import { ref as ref$1, defineComponent, openBlock, createElementBlock, normalizeClass, useSlots, createBlock, resolveDynamicComponent, withCtx, renderSlot, createCommentVNode, createElementVNode, createStaticVNode, normalizeStyle, provide, createVNode, normalizeProps, guardReactiveProps, mergeProps, toDisplayString, unref, computed, h as h$1, inject, watch, nextTick as nextTick$3, onUnmounted, onMounted, Fragment, renderList, createTextVNode, toRef, watchEffect, mergeModels, useModel, shallowRef, getCurrentScope, onScopeDispose, shallowReadonly, onBeforeUnmount, withDirectives, vModelText, vModelDynamic, getCurrentInstance, Transition, createSlots, resolveComponent, vShow, withModifiers, TransitionGroup, createApp, reactive, onUpdated, onBeforeUpdate, toRaw } from "vue";
class Node$1 {
  value;
  next;
  constructor(c) {
    this.value = c;
  }
}
class Queue {
  #e;
  #t;
  #r;
  constructor() {
    this.clear();
  }
  enqueue(c) {
    const ie = new Node$1(c);
    this.#e ? (this.#t.next = ie, this.#t = ie) : (this.#e = ie, this.#t = ie), this.#r++;
  }
  dequeue() {
    const c = this.#e;
    if (!!c)
      return this.#e = this.#e.next, this.#r--, c.value;
  }
  peek() {
    if (!!this.#e)
      return this.#e.value;
  }
  clear() {
    this.#e = void 0, this.#t = void 0, this.#r = 0;
  }
  get size() {
    return this.#r;
  }
  *[Symbol.iterator]() {
    let c = this.#e;
    for (; c; )
      yield c.value, c = c.next;
  }
}
function pLimit(m) {
  if (!((Number.isInteger(m) || m === Number.POSITIVE_INFINITY) && m > 0))
    throw new TypeError("Expected `concurrency` to be a number from 1 and up");
  const c = new Queue();
  let ie = 0;
  const we = () => {
    ie--, c.size > 0 && c.dequeue()();
  }, $e = async (ne, rr, gr) => {
    ie++;
    const or = (async () => ne(...gr))();
    rr(or);
    try {
      await or;
    } catch {
    }
    we();
  }, Me = (ne, rr, gr) => {
    c.enqueue($e.bind(void 0, ne, rr, gr)), (async () => (await Promise.resolve(), ie < m && c.size > 0 && c.dequeue()()))();
  }, Ze = (ne, ...rr) => new Promise((gr) => {
    Me(ne, gr, rr);
  });
  return Object.defineProperties(Ze, {
    activeCount: {
      get: () => ie
    },
    pendingCount: {
      get: () => c.size
    },
    clearQueue: {
      value: () => {
        c.clear();
      }
    }
  }), Ze;
}
/*!
 * Compressor.js v1.2.1
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-02-28T14:09:41.732Z
 */
function ownKeys$1(m, c) {
  var ie = Object.keys(m);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(m);
    c && (we = we.filter(function($e) {
      return Object.getOwnPropertyDescriptor(m, $e).enumerable;
    })), ie.push.apply(ie, we);
  }
  return ie;
}
function _objectSpread2$1(m) {
  for (var c = 1; c < arguments.length; c++) {
    var ie = arguments[c] != null ? arguments[c] : {};
    c % 2 ? ownKeys$1(Object(ie), !0).forEach(function(we) {
      _defineProperty$1(m, we, ie[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(m, Object.getOwnPropertyDescriptors(ie)) : ownKeys$1(Object(ie)).forEach(function(we) {
      Object.defineProperty(m, we, Object.getOwnPropertyDescriptor(ie, we));
    });
  }
  return m;
}
function _classCallCheck(m, c) {
  if (!(m instanceof c))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(m, c) {
  for (var ie = 0; ie < c.length; ie++) {
    var we = c[ie];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(m, _toPropertyKey(we.key), we);
  }
}
function _createClass(m, c, ie) {
  return c && _defineProperties(m.prototype, c), ie && _defineProperties(m, ie), Object.defineProperty(m, "prototype", {
    writable: !1
  }), m;
}
function _defineProperty$1(m, c, ie) {
  return c = _toPropertyKey(c), c in m ? Object.defineProperty(m, c, {
    value: ie,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : m[c] = ie, m;
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(m) {
    for (var c = 1; c < arguments.length; c++) {
      var ie = arguments[c];
      for (var we in ie)
        Object.prototype.hasOwnProperty.call(ie, we) && (m[we] = ie[we]);
    }
    return m;
  }, _extends$1.apply(this, arguments);
}
function _toPrimitive(m, c) {
  if (typeof m != "object" || m === null)
    return m;
  var ie = m[Symbol.toPrimitive];
  if (ie !== void 0) {
    var we = ie.call(m, c || "default");
    if (typeof we != "object")
      return we;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (c === "string" ? String : Number)(m);
}
function _toPropertyKey(m) {
  var c = _toPrimitive(m, "string");
  return typeof c == "symbol" ? c : String(c);
}
var canvasToBlob = { exports: {} };
(function(m) {
  typeof window > "u" || function(c) {
    var ie = c.HTMLCanvasElement && c.HTMLCanvasElement.prototype, we = c.Blob && function() {
      try {
        return Boolean(new Blob());
      } catch {
        return !1;
      }
    }(), $e = we && c.Uint8Array && function() {
      try {
        return new Blob([new Uint8Array(100)]).size === 100;
      } catch {
        return !1;
      }
    }(), Me = c.BlobBuilder || c.WebKitBlobBuilder || c.MozBlobBuilder || c.MSBlobBuilder, Ze = /^data:((.*?)(;charset=.*?)?)(;base64)?,/, ne = (we || Me) && c.atob && c.ArrayBuffer && c.Uint8Array && function(rr) {
      var gr, or, _r, Lr, Ir, Ar, Rr, Nr, Yr;
      if (gr = rr.match(Ze), !gr)
        throw new Error("invalid data URI");
      for (or = gr[2] ? gr[1] : "text/plain" + (gr[3] || ";charset=US-ASCII"), _r = !!gr[4], Lr = rr.slice(gr[0].length), _r ? Ir = atob(Lr) : Ir = decodeURIComponent(Lr), Ar = new ArrayBuffer(Ir.length), Rr = new Uint8Array(Ar), Nr = 0; Nr < Ir.length; Nr += 1)
        Rr[Nr] = Ir.charCodeAt(Nr);
      return we ? new Blob([$e ? Rr : Ar], {
        type: or
      }) : (Yr = new Me(), Yr.append(Ar), Yr.getBlob(or));
    };
    c.HTMLCanvasElement && !ie.toBlob && (ie.mozGetAsFile ? ie.toBlob = function(rr, gr, or) {
      var _r = this;
      setTimeout(function() {
        or && ie.toDataURL && ne ? rr(ne(_r.toDataURL(gr, or))) : rr(_r.mozGetAsFile("blob", gr));
      });
    } : ie.toDataURL && ne && (ie.msToBlob ? ie.toBlob = function(rr, gr, or) {
      var _r = this;
      setTimeout(function() {
        (gr && gr !== "image/png" || or) && ie.toDataURL && ne ? rr(ne(_r.toDataURL(gr, or))) : rr(_r.msToBlob(gr));
      });
    } : ie.toBlob = function(rr, gr, or) {
      var _r = this;
      setTimeout(function() {
        rr(ne(_r.toDataURL(gr, or)));
      });
    })), m.exports ? m.exports = ne : c.dataURLtoBlob = ne;
  }(window);
})(canvasToBlob);
var toBlob = canvasToBlob.exports, isBlob = function(c) {
  return typeof Blob > "u" ? !1 : c instanceof Blob || Object.prototype.toString.call(c) === "[object Blob]";
}, DEFAULTS = {
  strict: !0,
  checkOrientation: !0,
  retainExif: !1,
  maxWidth: 1 / 0,
  maxHeight: 1 / 0,
  minWidth: 0,
  minHeight: 0,
  width: void 0,
  height: void 0,
  resize: "none",
  quality: 0.8,
  mimeType: "auto",
  convertTypes: ["image/png"],
  convertSize: 5e6,
  beforeDraw: null,
  drew: null,
  success: null,
  error: null
}, IS_BROWSER = typeof window < "u" && typeof window.document < "u", WINDOW = IS_BROWSER ? window : {}, isPositiveNumber = function(c) {
  return c > 0 && c < 1 / 0;
}, slice = Array.prototype.slice;
function toArray$2(m) {
  return Array.from ? Array.from(m) : slice.call(m);
}
var REGEXP_IMAGE_TYPE = /^image\/.+$/;
function isImageType(m) {
  return REGEXP_IMAGE_TYPE.test(m);
}
function imageTypeToExtension(m) {
  var c = isImageType(m) ? m.substr(6) : "";
  return c === "jpeg" && (c = "jpg"), ".".concat(c);
}
var fromCharCode = String.fromCharCode;
function getStringFromCharCode(m, c, ie) {
  var we = "", $e;
  for (ie += c, $e = c; $e < ie; $e += 1)
    we += fromCharCode(m.getUint8($e));
  return we;
}
var btoa$2 = WINDOW.btoa;
function arrayBufferToDataURL(m, c) {
  for (var ie = [], we = 8192, $e = new Uint8Array(m); $e.length > 0; )
    ie.push(fromCharCode.apply(null, toArray$2($e.subarray(0, we)))), $e = $e.subarray(we);
  return "data:".concat(c, ";base64,").concat(btoa$2(ie.join("")));
}
function resetAndGetOrientation(m) {
  var c = new DataView(m), ie;
  try {
    var we, $e, Me;
    if (c.getUint8(0) === 255 && c.getUint8(1) === 216)
      for (var Ze = c.byteLength, ne = 2; ne + 1 < Ze; ) {
        if (c.getUint8(ne) === 255 && c.getUint8(ne + 1) === 225) {
          $e = ne;
          break;
        }
        ne += 1;
      }
    if ($e) {
      var rr = $e + 4, gr = $e + 10;
      if (getStringFromCharCode(c, rr, 4) === "Exif") {
        var or = c.getUint16(gr);
        if (we = or === 18761, (we || or === 19789) && c.getUint16(gr + 2, we) === 42) {
          var _r = c.getUint32(gr + 4, we);
          _r >= 8 && (Me = gr + _r);
        }
      }
    }
    if (Me) {
      var Lr = c.getUint16(Me, we), Ir, Ar;
      for (Ar = 0; Ar < Lr; Ar += 1)
        if (Ir = Me + Ar * 12 + 2, c.getUint16(Ir, we) === 274) {
          Ir += 8, ie = c.getUint16(Ir, we), c.setUint16(Ir, 1, we);
          break;
        }
    }
  } catch {
    ie = 1;
  }
  return ie;
}
function parseOrientation(m) {
  var c = 0, ie = 1, we = 1;
  switch (m) {
    case 2:
      ie = -1;
      break;
    case 3:
      c = -180;
      break;
    case 4:
      we = -1;
      break;
    case 5:
      c = 90, we = -1;
      break;
    case 6:
      c = 90;
      break;
    case 7:
      c = 90, ie = -1;
      break;
    case 8:
      c = -90;
      break;
  }
  return {
    rotate: c,
    scaleX: ie,
    scaleY: we
  };
}
var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
function normalizeDecimalNumber(m) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return REGEXP_DECIMALS.test(m) ? Math.round(m * c) / c : m;
}
function getAdjustedSizes(m) {
  var c = m.aspectRatio, ie = m.height, we = m.width, $e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none", Me = isPositiveNumber(we), Ze = isPositiveNumber(ie);
  if (Me && Ze) {
    var ne = ie * c;
    ($e === "contain" || $e === "none") && ne > we || $e === "cover" && ne < we ? ie = we / c : we = ie * c;
  } else
    Me ? ie = we / c : Ze && (we = ie * c);
  return {
    width: we,
    height: ie
  };
}
function getExif(m) {
  for (var c = toArray$2(new Uint8Array(m)), ie = c.length, we = [], $e = 0; $e + 3 < ie; ) {
    var Me = c[$e], Ze = c[$e + 1];
    if (Me === 255 && Ze === 218)
      break;
    if (Me === 255 && Ze === 216)
      $e += 2;
    else {
      var ne = c[$e + 2] * 256 + c[$e + 3], rr = $e + ne + 2, gr = c.slice($e, rr);
      we.push(gr), $e = rr;
    }
  }
  return we.reduce(function(or, _r) {
    return _r[0] === 255 && _r[1] === 225 ? or.concat(_r) : or;
  }, []);
}
function insertExif(m, c) {
  var ie = toArray$2(new Uint8Array(m));
  if (ie[2] !== 255 || ie[3] !== 224)
    return m;
  var we = ie[4] * 256 + ie[5], $e = [255, 216].concat(c, ie.slice(4 + we));
  return new Uint8Array($e);
}
var ArrayBuffer$1 = WINDOW.ArrayBuffer, FileReader$1 = WINDOW.FileReader, URL$2 = WINDOW.URL || WINDOW.webkitURL, REGEXP_EXTENSION = /\.\w+$/, AnotherCompressor = WINDOW.Compressor, Compressor = /* @__PURE__ */ function() {
  function m(c, ie) {
    _classCallCheck(this, m), this.file = c, this.exif = [], this.image = new Image(), this.options = _objectSpread2$1(_objectSpread2$1({}, DEFAULTS), ie), this.aborted = !1, this.result = null, this.init();
  }
  return _createClass(m, [{
    key: "init",
    value: function() {
      var ie = this, we = this.file, $e = this.options;
      if (!isBlob(we)) {
        this.fail(new Error("The first argument must be a File or Blob object."));
        return;
      }
      var Me = we.type;
      if (!isImageType(Me)) {
        this.fail(new Error("The first argument must be an image File or Blob object."));
        return;
      }
      if (!URL$2 || !FileReader$1) {
        this.fail(new Error("The current browser does not support image compression."));
        return;
      }
      ArrayBuffer$1 || ($e.checkOrientation = !1, $e.retainExif = !1);
      var Ze = Me === "image/jpeg", ne = Ze && $e.checkOrientation, rr = Ze && $e.retainExif;
      if (URL$2 && !ne && !rr)
        this.load({
          url: URL$2.createObjectURL(we)
        });
      else {
        var gr = new FileReader$1();
        this.reader = gr, gr.onload = function(or) {
          var _r = or.target, Lr = _r.result, Ir = {}, Ar = 1;
          ne && (Ar = resetAndGetOrientation(Lr), Ar > 1 && _extends$1(Ir, parseOrientation(Ar))), rr && (ie.exif = getExif(Lr)), ne || rr ? !URL$2 || Ar > 1 ? Ir.url = arrayBufferToDataURL(Lr, Me) : Ir.url = URL$2.createObjectURL(we) : Ir.url = Lr, ie.load(Ir);
        }, gr.onabort = function() {
          ie.fail(new Error("Aborted to read the image with FileReader."));
        }, gr.onerror = function() {
          ie.fail(new Error("Failed to read the image with FileReader."));
        }, gr.onloadend = function() {
          ie.reader = null;
        }, ne || rr ? gr.readAsArrayBuffer(we) : gr.readAsDataURL(we);
      }
    }
  }, {
    key: "load",
    value: function(ie) {
      var we = this, $e = this.file, Me = this.image;
      Me.onload = function() {
        we.draw(_objectSpread2$1(_objectSpread2$1({}, ie), {}, {
          naturalWidth: Me.naturalWidth,
          naturalHeight: Me.naturalHeight
        }));
      }, Me.onabort = function() {
        we.fail(new Error("Aborted to load the image."));
      }, Me.onerror = function() {
        we.fail(new Error("Failed to load the image."));
      }, WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent) && (Me.crossOrigin = "anonymous"), Me.alt = $e.name, Me.src = ie.url;
    }
  }, {
    key: "draw",
    value: function(ie) {
      var we = this, $e = ie.naturalWidth, Me = ie.naturalHeight, Ze = ie.rotate, ne = Ze === void 0 ? 0 : Ze, rr = ie.scaleX, gr = rr === void 0 ? 1 : rr, or = ie.scaleY, _r = or === void 0 ? 1 : or, Lr = this.file, Ir = this.image, Ar = this.options, Rr = document.createElement("canvas"), Nr = Rr.getContext("2d"), Yr = Math.abs(ne) % 180 === 90, Vr = (Ar.resize === "contain" || Ar.resize === "cover") && isPositiveNumber(Ar.width) && isPositiveNumber(Ar.height), Xr = Math.max(Ar.maxWidth, 0) || 1 / 0, Wr = Math.max(Ar.maxHeight, 0) || 1 / 0, si = Math.max(Ar.minWidth, 0) || 0, li = Math.max(Ar.minHeight, 0) || 0, xi = $e / Me, di = Ar.width, oi = Ar.height;
      if (Yr) {
        var ci = [Wr, Xr];
        Xr = ci[0], Wr = ci[1];
        var vr = [li, si];
        si = vr[0], li = vr[1];
        var Ae = [oi, di];
        di = Ae[0], oi = Ae[1];
      }
      Vr && (xi = di / oi);
      var ze = getAdjustedSizes({
        aspectRatio: xi,
        width: Xr,
        height: Wr
      }, "contain");
      Xr = ze.width, Wr = ze.height;
      var Ue = getAdjustedSizes({
        aspectRatio: xi,
        width: si,
        height: li
      }, "cover");
      if (si = Ue.width, li = Ue.height, Vr) {
        var tr = getAdjustedSizes({
          aspectRatio: xi,
          width: di,
          height: oi
        }, Ar.resize);
        di = tr.width, oi = tr.height;
      } else {
        var lr = getAdjustedSizes({
          aspectRatio: xi,
          width: di,
          height: oi
        }), pr = lr.width;
        di = pr === void 0 ? $e : pr;
        var br = lr.height;
        oi = br === void 0 ? Me : br;
      }
      di = Math.floor(normalizeDecimalNumber(Math.min(Math.max(di, si), Xr))), oi = Math.floor(normalizeDecimalNumber(Math.min(Math.max(oi, li), Wr)));
      var nr = -di / 2, Pe = -oi / 2, ur = di, Pr = oi, Hr = [];
      if (Vr) {
        var vi = 0, Ti = 0, wi = $e, ii = Me, mi = getAdjustedSizes({
          aspectRatio: xi,
          width: $e,
          height: Me
        }, {
          contain: "cover",
          cover: "contain"
        }[Ar.resize]);
        wi = mi.width, ii = mi.height, vi = ($e - wi) / 2, Ti = (Me - ii) / 2, Hr.push(vi, Ti, wi, ii);
      }
      if (Hr.push(nr, Pe, ur, Pr), Yr) {
        var ei = [oi, di];
        di = ei[0], oi = ei[1];
      }
      Rr.width = di, Rr.height = oi, isImageType(Ar.mimeType) || (Ar.mimeType = Lr.type);
      var Zr = "transparent";
      Lr.size > Ar.convertSize && Ar.convertTypes.indexOf(Ar.mimeType) >= 0 && (Ar.mimeType = "image/jpeg");
      var pi = Ar.mimeType === "image/jpeg";
      if (pi && (Zr = "#fff"), Nr.fillStyle = Zr, Nr.fillRect(0, 0, di, oi), Ar.beforeDraw && Ar.beforeDraw.call(this, Nr, Rr), !this.aborted && (Nr.save(), Nr.translate(di / 2, oi / 2), Nr.rotate(ne * Math.PI / 180), Nr.scale(gr, _r), Nr.drawImage.apply(Nr, [Ir].concat(Hr)), Nr.restore(), Ar.drew && Ar.drew.call(this, Nr, Rr), !this.aborted)) {
        var hi = function(qi) {
          if (!we.aborted) {
            var yn = function(ji) {
              return we.done({
                naturalWidth: $e,
                naturalHeight: Me,
                result: ji
              });
            };
            if (qi && pi && Ar.retainExif && we.exif && we.exif.length > 0) {
              var sn = function(ji) {
                return yn(toBlob(arrayBufferToDataURL(insertExif(ji, we.exif), Ar.mimeType)));
              };
              if (qi.arrayBuffer)
                qi.arrayBuffer().then(sn).catch(function() {
                  we.fail(new Error("Failed to read the compressed image with Blob.arrayBuffer()."));
                });
              else {
                var $n = new FileReader$1();
                we.reader = $n, $n.onload = function(rn) {
                  var ji = rn.target;
                  sn(ji.result);
                }, $n.onabort = function() {
                  we.fail(new Error("Aborted to read the compressed image with FileReader."));
                }, $n.onerror = function() {
                  we.fail(new Error("Failed to read the compressed image with FileReader."));
                }, $n.onloadend = function() {
                  we.reader = null;
                }, $n.readAsArrayBuffer(qi);
              }
            } else
              yn(qi);
          }
        };
        Rr.toBlob ? Rr.toBlob(hi, Ar.mimeType, Ar.quality) : hi(toBlob(Rr.toDataURL(Ar.mimeType, Ar.quality)));
      }
    }
  }, {
    key: "done",
    value: function(ie) {
      var we = ie.naturalWidth, $e = ie.naturalHeight, Me = ie.result, Ze = this.file, ne = this.image, rr = this.options;
      if (URL$2 && ne.src.indexOf("blob:") === 0 && URL$2.revokeObjectURL(ne.src), Me)
        if (rr.strict && !rr.retainExif && Me.size > Ze.size && rr.mimeType === Ze.type && !(rr.width > we || rr.height > $e || rr.minWidth > we || rr.minHeight > $e || rr.maxWidth < we || rr.maxHeight < $e))
          Me = Ze;
        else {
          var gr = new Date();
          Me.lastModified = gr.getTime(), Me.lastModifiedDate = gr, Me.name = Ze.name, Me.name && Me.type !== Ze.type && (Me.name = Me.name.replace(REGEXP_EXTENSION, imageTypeToExtension(Me.type)));
        }
      else
        Me = Ze;
      this.result = Me, rr.success && rr.success.call(this, Me);
    }
  }, {
    key: "fail",
    value: function(ie) {
      var we = this.options;
      if (we.error)
        we.error.call(this, ie);
      else
        throw ie;
    }
  }, {
    key: "abort",
    value: function() {
      this.aborted || (this.aborted = !0, this.reader ? this.reader.abort() : this.image.complete ? this.fail(new Error("The compression process has been aborted.")) : (this.image.onload = null, this.image.onabort()));
    }
  }], [{
    key: "noConflict",
    value: function() {
      return window.Compressor = AnotherCompressor, m;
    }
  }, {
    key: "setDefaults",
    value: function(ie) {
      _extends$1(DEFAULTS, ie);
    }
  }]), m;
}();
function round$3(m, c) {
  const ie = Math.pow(10, c || 0);
  return Math.round(m * ie) / ie;
}
const limiter = pLimit(1);
function useUpload(m, c, ie, we, $e, Me) {
  const Ze = ref$1(!1), ne = ref$1([]);
  async function rr(or) {
    return new Promise((_r, Lr) => {
      new Compressor(or, {
        quality: we.value,
        minWidth: m.value,
        minHeight: c.value,
        mimeType: ie.value,
        success(Ir) {
          _r(Ir);
        },
        error(Ir) {
          Lr(Ir);
        }
      });
    });
  }
  async function gr(or) {
    Ze.value = !0, ne.value = new Array(or.length).fill(0);
    const _r = await Promise.all(
      or.map((Lr, Ir) => limiter(() => rr(Lr)).then((Ar) => $e({
        blob: Ar,
        width: m.value ?? 1 / 0,
        height: c.value ?? 1 / 0,
        key: Lr.name,
        name: Lr.name,
        onProgress(Rr) {
          Ir in ne.value && (ne.value[Ir] = round$3(Rr, 5));
        },
        context: {
          field: Me.value
        }
      })))
    );
    return Ze.value = !1, ne.value = [], _r;
  }
  return {
    uploading: Ze,
    uploadProgresses: ne,
    uploadFiles: gr
  };
}
function openFiles(m) {
  return new Promise(function(c, ie) {
    const we = Object.assign(document.createElement("input"), {
      type: "file",
      accept: m.types.join(","),
      multiple: m.multiple ? "multiple" : !1,
      style: `
        position: fixed;
        left: -100%;
        top: -100%;
        visibility: hidden;
      `
    });
    we.addEventListener("change", () => {
      we.files && c(Array.from(we.files).filter(($e) => $e.size <= m.maxSize));
    }), document.body.append(we), we.click();
  });
}
const _sfc_main$1e = /* @__PURE__ */ defineComponent({
  __name: "BxSpin",
  props: {
    size: { default: "medium" }
  },
  setup(m) {
    return (c, ie) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-spin", { [`size-${c.size}`]: !0 }])
    }, null, 2));
  }
}), BxSpin_vue_vue_type_style_index_0_scoped_d53f8f21_lang = "", _export_sfc = (m, c) => {
  const ie = m.__vccOpts || m;
  for (const [we, $e] of c)
    ie[we] = $e;
  return ie;
}, BxSpin = /* @__PURE__ */ _export_sfc(_sfc_main$1e, [["__scopeId", "data-v-d53f8f21"]]), _hoisted_1$1G = {
  key: 0,
  class: "icon-wrapper"
}, _hoisted_2$1s = {
  key: 1,
  class: "label"
}, _sfc_main$1d = /* @__PURE__ */ defineComponent({
  __name: "BxButton",
  props: {
    size: { default: "medium" },
    round: { type: Boolean, default: !1 },
    circle: { type: Boolean, default: !1 },
    secondary: { type: Boolean, default: !1 },
    primary: { type: Boolean, default: !1 },
    tertiary: { type: Boolean },
    quarternary: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    state: { default: "default" },
    centered: { type: Boolean },
    tag: { default: "button" },
    loading: { type: Boolean, default: !1 }
  },
  setup(m) {
    const c = useSlots();
    return (ie, we) => (openBlock(), createBlock(resolveDynamicComponent(ie.tag), {
      class: normalizeClass(["bx-button", {
        "has-icon": !!c.icon,
        circle: ie.circle,
        round: ie.round,
        "has-label": !!c.default,
        secondary: ie.secondary,
        primary: ie.primary,
        tertiary: ie.tertiary,
        quarternary: ie.quarternary,
        disabled: ie.disabled,
        ["state-" + ie.state]: !0,
        ["size-" + ie.size]: !0,
        centered: ie.centered
      }])
    }, {
      default: withCtx(() => [
        c.icon || ie.loading ? (openBlock(), createElementBlock("div", _hoisted_1$1G, [
          ie.loading ? (openBlock(), createBlock(BxSpin, {
            key: 0,
            size: "small"
          })) : renderSlot(ie.$slots, "icon", { key: 1 }, void 0, !0)
        ])) : createCommentVNode("", !0),
        c.default ? (openBlock(), createElementBlock("span", _hoisted_2$1s, [
          renderSlot(ie.$slots, "default", {}, void 0, !0)
        ])) : createCommentVNode("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), BxButton_vue_vue_type_style_index_0_scoped_a63e3b71_lang = "", BxButton = /* @__PURE__ */ _export_sfc(_sfc_main$1d, [["__scopeId", "data-v-a63e3b71"]]), urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let nanoid = (m = 21) => {
  let c = "", ie = crypto.getRandomValues(new Uint8Array(m |= 0));
  for (; m--; )
    c += urlAlphabet[ie[m] & 63];
  return c;
};
const _hoisted_1$1F = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1r = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M256 112v288"
  },
  null,
  -1
), _hoisted_3$16 = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M400 256H112"
  },
  null,
  -1
), _hoisted_4$O = [_hoisted_2$1r, _hoisted_3$16], AddOutline = defineComponent({
  name: "AddOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1F, _hoisted_4$O);
  }
}), _hoisted_1$1E = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1q = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M256 80c-8.66 0-16.58 7.36-16 16l8 216a8 8 0 0 0 8 8h0a8 8 0 0 0 8-8l8-216c.58-8.64-7.34-16-16-16z",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$15 = /* @__PURE__ */ createElementVNode(
  "circle",
  {
    cx: "256",
    cy: "416",
    r: "16",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_4$N = [_hoisted_2$1q, _hoisted_3$15], AlertOutline = defineComponent({
  name: "AlertOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1E, _hoisted_4$N);
  }
}), _hoisted_1$1D = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1p = /* @__PURE__ */ createStaticVNode('<rect x="64" y="64" width="80" height="80" rx="40" ry="40" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></rect><rect x="216" y="64" width="80" height="80" rx="40" ry="40" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></rect><rect x="368" y="64" width="80" height="80" rx="40" ry="40" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></rect><rect x="64" y="216" width="80" height="80" rx="40" ry="40" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></rect><rect x="216" y="216" width="80" height="80" rx="40" ry="40" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></rect><rect x="368" y="216" width="80" height="80" rx="40" ry="40" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></rect><rect x="64" y="368" width="80" height="80" rx="40" ry="40" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></rect><rect x="216" y="368" width="80" height="80" rx="40" ry="40" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></rect><rect x="368" y="368" width="80" height="80" rx="40" ry="40" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></rect>', 9), _hoisted_11$6 = [_hoisted_2$1p], AppsOutline = defineComponent({
  name: "AppsOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1D, _hoisted_11$6);
  }
}), _hoisted_1$1C = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1o = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M80 152v256a40.12 40.12 0 0 0 40 40h272a40.12 40.12 0 0 0 40-40V152",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$14 = /* @__PURE__ */ createElementVNode(
  "rect",
  {
    x: "48",
    y: "64",
    width: "416",
    height: "80",
    rx: "28",
    ry: "28",
    fill: "none",
    stroke: "currentColor",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_4$M = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M320 304l-64 64l-64-64"
  },
  null,
  -1
), _hoisted_5$t = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M256 345.89V224"
  },
  null,
  -1
), _hoisted_6$f = [_hoisted_2$1o, _hoisted_3$14, _hoisted_4$M, _hoisted_5$t], ArchiveOutline = defineComponent({
  name: "ArchiveOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1C, _hoisted_6$f);
  }
}), _hoisted_1$1B = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1n = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "48",
    d: "M244 400L100 256l144-144"
  },
  null,
  -1
), _hoisted_3$13 = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "48",
    d: "M120 256h292"
  },
  null,
  -1
), _hoisted_4$L = [_hoisted_2$1n, _hoisted_3$13], ArrowBackOutline = defineComponent({
  name: "ArrowBackOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1B, _hoisted_4$L);
  }
}), _hoisted_1$1A = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1m = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "48",
    d: "M268 112l144 144l-144 144"
  },
  null,
  -1
), _hoisted_3$12 = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "48",
    d: "M392 256H100"
  },
  null,
  -1
), _hoisted_4$K = [_hoisted_2$1m, _hoisted_3$12], ArrowForwardOutline = defineComponent({
  name: "ArrowForwardOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1A, _hoisted_4$K);
  }
}), _hoisted_1$1z = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1l = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M448 256L272 88v96C103.57 184 64 304.77 64 424c48.61-62.24 91.6-96 208-96v96z",
    fill: "none",
    stroke: "currentColor",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$11 = [_hoisted_2$1l], ArrowRedoOutline = defineComponent({
  name: "ArrowRedoOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1z, _hoisted_3$11);
  }
}), _hoisted_1$1y = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1k = /* @__PURE__ */ createStaticVNode('<rect x="-24.43" y="167.88" width="560.87" height="176.25" rx="88.12" ry="88.12" transform="rotate(-45 256 256.002)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></rect><rect x="169.41" y="156.59" width="176" height="196" rx="32" ry="32" transform="rotate(45 257.409 254.582)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></rect><circle cx="256" cy="208" r="16" fill="currentColor"></circle><circle cx="304" cy="256" r="16" fill="currentColor"></circle><circle cx="208" cy="256" r="16" fill="currentColor"></circle><circle cx="256" cy="304" r="16" fill="currentColor"></circle>', 6), _hoisted_8$9 = [_hoisted_2$1k], BandageOutline = defineComponent({
  name: "BandageOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1y, _hoisted_8$9);
  }
}), _hoisted_1$1x = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1j = /* @__PURE__ */ createStaticVNode('<path d="M304 384v-24c0-29 31.54-56.43 52-76c28.84-27.57 44-64.61 44-108c0-80-63.73-144-144-144a143.6 143.6 0 0 0-144 144c0 41.84 15.81 81.39 44 108c20.35 19.21 52 46.7 52 76v24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M224 480h64"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M208 432h96"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M256 384V256"></path><path d="M294 240s-21.51 16-38 16s-38-16-38-16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></path>', 5), _hoisted_7$7 = [_hoisted_2$1j], BulbOutline = defineComponent({
  name: "BulbOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1x, _hoisted_7$7);
  }
}), _hoisted_1$1w = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1i = /* @__PURE__ */ createElementVNode(
  "rect",
  {
    x: "48",
    y: "96",
    width: "416",
    height: "320",
    rx: "56",
    ry: "56",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$10 = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linejoin": "round",
    "stroke-width": "60",
    d: "M48 192h416"
  },
  null,
  -1
), _hoisted_4$J = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linejoin": "round",
    "stroke-width": "60",
    d: "M128 300h48v20h-48z"
  },
  null,
  -1
), _hoisted_5$s = [_hoisted_2$1i, _hoisted_3$10, _hoisted_4$J], CardOutline = defineComponent({
  name: "CardOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1w, _hoisted_5$s);
  }
}), _hoisted_1$1v = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1h = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208s208-93.31 208-208S370.69 48 256 48zm108.25 138.29l-134.4 160a16 16 0 0 1-12 5.71h-.27a16 16 0 0 1-11.89-5.3l-57.6-64a16 16 0 1 1 23.78-21.4l45.29 50.32l122.59-145.91a16 16 0 0 1 24.5 20.58z",
    fill: "currentColor"
  },
  null,
  -1
), _hoisted_3$$ = [_hoisted_2$1h], CheckmarkCircle = defineComponent({
  name: "CheckmarkCircle",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1v, _hoisted_3$$);
  }
}), _hoisted_1$1u = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1g = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192s192-86 192-192z",
    fill: "none",
    stroke: "currentColor",
    "stroke-miterlimit": "10",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$_ = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M352 176L217.6 336L160 272"
  },
  null,
  -1
), _hoisted_4$I = [_hoisted_2$1g, _hoisted_3$_], CheckmarkCircleOutline = defineComponent({
  name: "CheckmarkCircleOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1u, _hoisted_4$I);
  }
}), _hoisted_1$1t = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1f = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M416 128L192 384l-96-96"
  },
  null,
  -1
), _hoisted_3$Z = [_hoisted_2$1f], CheckmarkOutline = defineComponent({
  name: "CheckmarkOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1t, _hoisted_3$Z);
  }
}), _hoisted_1$1s = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1e = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "48",
    d: "M328 112L184 256l144 144"
  },
  null,
  -1
), _hoisted_3$Y = [_hoisted_2$1e], ChevronBackOutline = defineComponent({
  name: "ChevronBackOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1s, _hoisted_3$Y);
  }
}), _hoisted_1$1r = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1d = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "48",
    d: "M112 184l144 144l144-144"
  },
  null,
  -1
), _hoisted_3$X = [_hoisted_2$1d], ChevronDownOutline = defineComponent({
  name: "ChevronDownOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1r, _hoisted_3$X);
  }
}), _hoisted_1$1q = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1c = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "48",
    d: "M184 112l144 144l-144 144"
  },
  null,
  -1
), _hoisted_3$W = [_hoisted_2$1c], ChevronForwardOutline = defineComponent({
  name: "ChevronForwardOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1q, _hoisted_3$W);
  }
}), _hoisted_1$1p = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1b = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "48",
    d: "M112 328l144-144l144 144"
  },
  null,
  -1
), _hoisted_3$V = [_hoisted_2$1b], ChevronUpOutline = defineComponent({
  name: "ChevronUpOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1p, _hoisted_3$V);
  }
}), _hoisted_1$1o = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$1a = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M336 64h32a48 48 0 0 1 48 48v320a48 48 0 0 1-48 48H144a48 48 0 0 1-48-48V112a48 48 0 0 1 48-48h32",
    fill: "none",
    stroke: "currentColor",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$U = /* @__PURE__ */ createElementVNode(
  "rect",
  {
    x: "176",
    y: "32",
    width: "160",
    height: "64",
    rx: "26.13",
    ry: "26.13",
    fill: "none",
    stroke: "currentColor",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_4$H = [_hoisted_2$1a, _hoisted_3$U], ClipboardOutline = defineComponent({
  name: "ClipboardOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1o, _hoisted_4$H);
  }
}), _hoisted_1$1n = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$19 = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M368 368L144 144"
  },
  null,
  -1
), _hoisted_3$T = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M368 144L144 368"
  },
  null,
  -1
), _hoisted_4$G = [_hoisted_2$19, _hoisted_3$T], CloseOutline = defineComponent({
  name: "CloseOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1n, _hoisted_4$G);
  }
}), _hoisted_1$1m = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$18 = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2c-60 5.7-112 35.88-112 98.4S70 336 136 336h56",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$S = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M192 400.1l64 63.9l64-63.9"
  },
  null,
  -1
), _hoisted_4$F = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M256 224v224.03"
  },
  null,
  -1
), _hoisted_5$r = [_hoisted_2$18, _hoisted_3$S, _hoisted_4$F], CloudDownloadOutline = defineComponent({
  name: "CloudDownloadOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1m, _hoisted_5$r);
  }
}), _hoisted_1$1l = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$17 = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8c-69 0-113.44 45.79-128 91.2c-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$R = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M320 255.79l-64-64l-64 64"
  },
  null,
  -1
), _hoisted_4$E = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M256 448.21V207.79"
  },
  null,
  -1
), _hoisted_5$q = [_hoisted_2$17, _hoisted_3$R, _hoisted_4$E], CloudUploadOutline = defineComponent({
  name: "CloudUploadOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1l, _hoisted_5$q);
  }
}), _hoisted_1$1k = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$16 = /* @__PURE__ */ createStaticVNode('<path d="M430.11 347.9c-6.6-6.1-16.3-7.6-24.6-9c-11.5-1.9-15.9-4-22.6-10c-14.3-12.7-14.3-31.1 0-43.8l30.3-26.9c46.4-41 46.4-108.2 0-149.2c-34.2-30.1-80.1-45-127.8-45c-55.7 0-113.9 20.3-158.8 60.1c-83.5 73.8-83.5 194.7 0 268.5c41.5 36.7 97.5 55 152.9 55.4h1.7c55.4 0 110-17.9 148.8-52.4c14.4-12.7 11.99-36.6.1-47.7z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></path><circle cx="144" cy="208" r="32" fill="currentColor"></circle><circle cx="152" cy="311" r="32" fill="currentColor"></circle><circle cx="224" cy="144" r="32" fill="currentColor"></circle><circle cx="256" cy="367" r="48" fill="currentColor"></circle><circle cx="328" cy="144" r="32" fill="currentColor"></circle>', 6), _hoisted_8$8 = [_hoisted_2$16], ColorPaletteOutline = defineComponent({
  name: "ColorPaletteOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1k, _hoisted_8$8);
  }
}), _hoisted_1$1j = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$15 = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M384 224v184a40 40 0 0 1-40 40H104a40 40 0 0 1-40-40V168a40 40 0 0 1 40-40h167.48",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$Q = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M459.94 53.25a16.06 16.06 0 0 0-23.22-.56L424.35 65a8 8 0 0 0 0 11.31l11.34 11.32a8 8 0 0 0 11.34 0l12.06-12c6.1-6.09 6.67-16.01.85-22.38z",
    fill: "currentColor"
  },
  null,
  -1
), _hoisted_4$D = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M399.34 90L218.82 270.2a9 9 0 0 0-2.31 3.93L208.16 299a3.91 3.91 0 0 0 4.86 4.86l24.85-8.35a9 9 0 0 0 3.93-2.31L422 112.66a9 9 0 0 0 0-12.66l-9.95-10a9 9 0 0 0-12.71 0z",
    fill: "currentColor"
  },
  null,
  -1
), _hoisted_5$p = [_hoisted_2$15, _hoisted_3$Q, _hoisted_4$D], CreateOutline = defineComponent({
  name: "CreateOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1j, _hoisted_5$p);
  }
}), _hoisted_1$1i = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$14 = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M144 48v272a48 48 0 0 0 48 48h272",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$P = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M368 304V192a48 48 0 0 0-48-48H208",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_4$C = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M368 368v96"
  },
  null,
  -1
), _hoisted_5$o = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M144 144H48"
  },
  null,
  -1
), _hoisted_6$e = [_hoisted_2$14, _hoisted_3$P, _hoisted_4$C, _hoisted_5$o], CropOutline = defineComponent({
  name: "CropOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1i, _hoisted_6$e);
  }
}), _hoisted_1$1h = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$13 = /* @__PURE__ */ createElementVNode(
  "circle",
  {
    cx: "256",
    cy: "256",
    r: "32",
    fill: "none",
    stroke: "currentColor",
    "stroke-miterlimit": "10",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$O = /* @__PURE__ */ createElementVNode(
  "circle",
  {
    cx: "256",
    cy: "416",
    r: "32",
    fill: "none",
    stroke: "currentColor",
    "stroke-miterlimit": "10",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_4$B = /* @__PURE__ */ createElementVNode(
  "circle",
  {
    cx: "256",
    cy: "96",
    r: "32",
    fill: "none",
    stroke: "currentColor",
    "stroke-miterlimit": "10",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_5$n = [_hoisted_2$13, _hoisted_3$O, _hoisted_4$B], EllipsisVerticalOutline = defineComponent({
  name: "EllipsisVerticalOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1h, _hoisted_5$n);
  }
}), _hoisted_1$1g = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$12 = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M320 176v-40a40 40 0 0 0-40-40H88a40 40 0 0 0-40 40v240a40 40 0 0 0 40 40h192a40 40 0 0 0 40-40v-40",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$N = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M384 176l80 80l-80 80"
  },
  null,
  -1
), _hoisted_4$A = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M191 256h273"
  },
  null,
  -1
), _hoisted_5$m = [_hoisted_2$12, _hoisted_3$N, _hoisted_4$A], ExitOutline = defineComponent({
  name: "ExitOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1g, _hoisted_5$m);
  }
}), _hoisted_1$1f = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$11 = /* @__PURE__ */ createStaticVNode('<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M432 320v112H320"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M421.8 421.77L304 304"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M80 192V80h112"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M90.2 90.23L208 208"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M320 80h112v112"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M421.77 90.2L304 208"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M192 432H80V320"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M90.23 421.8L208 304"></path>', 8), _hoisted_10$5 = [_hoisted_2$11], ExpandOutline = defineComponent({
  name: "ExpandOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1f, _hoisted_10$5);
  }
}), _hoisted_1$1e = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$10 = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 0 0-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 0 0 0-17.47C428.89 172.28 347.8 112 255.66 112z",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$M = /* @__PURE__ */ createElementVNode(
  "circle",
  {
    cx: "256",
    cy: "256",
    r: "80",
    fill: "none",
    stroke: "currentColor",
    "stroke-miterlimit": "10",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_4$z = [_hoisted_2$10, _hoisted_3$M], EyeOutline = defineComponent({
  name: "EyeOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1e, _hoisted_4$z);
  }
}), _hoisted_1$1d = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$$ = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M262.51 204.22L70 396.69C57.56 409.15 48 464 48 464s54.38-9.09 67.31-22L307.8 249.51",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$L = /* @__PURE__ */ createElementVNode(
  "rect",
  {
    x: "211.72",
    y: "172.19",
    width: "192.15",
    height: "64.05",
    rx: "32.03",
    ry: "32.03",
    transform: "rotate(45 307.788 204.2)",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_4$y = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M289.91 141s20.57 8.57 37.22-8.08l54.67-70.63c18.5-19.41 49.26-18.69 67.94 0h0c18.68 18.68 19.34 48.81 0 67.93l-70.68 54.67c-15.65 15.65-8.08 37.22-8.08 37.22",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_5$l = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M115.31 442s-26.48 17.34-44.56-.73s-.75-44.58-.75-44.58",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_6$d = [_hoisted_2$$, _hoisted_3$L, _hoisted_4$y, _hoisted_5$l], EyedropOutline = defineComponent({
  name: "EyedropOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1d, _hoisted_6$d);
  }
}), _hoisted_1$1c = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$_ = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M440 432H72a40 40 0 0 1-40-40V120a40 40 0 0 1 40-40h75.89a40 40 0 0 1 22.19 6.72l27.84 18.56a40 40 0 0 0 22.19 6.72H440a40 40 0 0 1 40 40v240a40 40 0 0 1-40 40z",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$K = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M32 192h448"
  },
  null,
  -1
), _hoisted_4$x = [_hoisted_2$_, _hoisted_3$K], FolderOutline = defineComponent({
  name: "FolderOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1c, _hoisted_4$x);
  }
}), _hoisted_1$1b = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$Z = /* @__PURE__ */ createStaticVNode('<path d="M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208s208-93.13 208-208S370.87 48 256 48z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></path><path d="M256 48c-58.07 0-112.67 93.13-112.67 208S197.93 464 256 464s112.67-93.13 112.67-208S314.07 48 256 48z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></path><path d="M117.33 117.33c38.24 27.15 86.38 43.34 138.67 43.34s100.43-16.19 138.67-43.34" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></path><path d="M394.67 394.67c-38.24-27.15-86.38-43.34-138.67-43.34s-100.43 16.19-138.67 43.34" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></path><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M256 48v416"></path><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M464 256H48"></path>', 6), _hoisted_8$7 = [_hoisted_2$Z], GlobeOutline = defineComponent({
  name: "GlobeOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1b, _hoisted_8$7);
  }
}), _hoisted_1$1a = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$Y = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-miterlimit": "10",
    "stroke-width": "40"
  },
  null,
  -1
), _hoisted_3$J = /* @__PURE__ */ createElementVNode(
  "circle",
  {
    cx: "248",
    cy: "399.99",
    r: "32",
    fill: "currentColor"
  },
  null,
  -1
), _hoisted_4$w = [_hoisted_2$Y, _hoisted_3$J], HelpOutline = defineComponent({
  name: "HelpOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$1a, _hoisted_4$w);
  }
}), _hoisted_1$19 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$X = /* @__PURE__ */ createElementVNode(
  "rect",
  {
    x: "48",
    y: "80",
    width: "416",
    height: "352",
    rx: "48",
    ry: "48",
    fill: "none",
    stroke: "currentColor",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$I = /* @__PURE__ */ createElementVNode(
  "circle",
  {
    cx: "336",
    cy: "176",
    r: "32",
    fill: "none",
    stroke: "currentColor",
    "stroke-miterlimit": "10",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_4$v = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M304 335.79l-90.66-90.49a32 32 0 0 0-43.87-1.3L48 352",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_5$k = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M224 432l123.34-123.34a32 32 0 0 1 43.11-2L464 368",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_6$c = [_hoisted_2$X, _hoisted_3$I, _hoisted_4$v, _hoisted_5$k], ImageOutline = defineComponent({
  name: "ImageOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$19, _hoisted_6$c);
  }
}), _hoisted_1$18 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$W = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184s184-82.39 184-184S349.61 64 248 64z",
    fill: "none",
    stroke: "currentColor",
    "stroke-miterlimit": "10",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$H = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M220 220h32v116"
  },
  null,
  -1
), _hoisted_4$u = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-miterlimit": "10",
    "stroke-width": "32",
    d: "M208 340h88"
  },
  null,
  -1
), _hoisted_5$j = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M248 130a26 26 0 1 0 26 26a26 26 0 0 0-26-26z",
    fill: "currentColor"
  },
  null,
  -1
), _hoisted_6$b = [_hoisted_2$W, _hoisted_3$H, _hoisted_4$u, _hoisted_5$j], InformationCircleOutline = defineComponent({
  name: "InformationCircleOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$18, _hoisted_6$b);
  }
}), _hoisted_1$17 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$V = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "40",
    d: "M196 220h64v172"
  },
  null,
  -1
), _hoisted_3$G = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-miterlimit": "10",
    "stroke-width": "40",
    d: "M187 396h138"
  },
  null,
  -1
), _hoisted_4$t = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M256 160a32 32 0 1 1 32-32a32 32 0 0 1-32 32z",
    fill: "currentColor"
  },
  null,
  -1
), _hoisted_5$i = [_hoisted_2$V, _hoisted_3$G, _hoisted_4$t], InformationOutline = defineComponent({
  name: "InformationOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$17, _hoisted_5$i);
  }
}), _hoisted_1$16 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$U = /* @__PURE__ */ createStaticVNode('<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M160 144h288"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M160 256h288"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M160 368h288"></path><circle cx="80" cy="144" r="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></circle><circle cx="80" cy="256" r="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></circle><circle cx="80" cy="368" r="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></circle>', 6), _hoisted_8$6 = [_hoisted_2$U], ListOutline = defineComponent({
  name: "ListOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$16, _hoisted_8$6);
  }
}), _hoisted_1$15 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$T = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M313.27 124.64L198.73 51.36a32 32 0 0 0-29.28.35L56.51 127.49A16 16 0 0 0 48 141.63v295.8a16 16 0 0 0 23.49 14.14l97.82-63.79a32 32 0 0 1 29.5-.24l111.86 73a32 32 0 0 0 29.27-.11l115.43-75.94a16 16 0 0 0 8.63-14.2V74.57a16 16 0 0 0-23.49-14.14l-98 63.86a32 32 0 0 1-29.24.35z",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$F = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M328 128v336"
  },
  null,
  -1
), _hoisted_4$s = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M184 48v336"
  },
  null,
  -1
), _hoisted_5$h = [_hoisted_2$T, _hoisted_3$F, _hoisted_4$s], MapOutline = defineComponent({
  name: "MapOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$15, _hoisted_5$h);
  }
}), _hoisted_1$14 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$S = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-miterlimit": "10",
    "stroke-width": "32",
    d: "M80 160h352"
  },
  null,
  -1
), _hoisted_3$E = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-miterlimit": "10",
    "stroke-width": "32",
    d: "M80 256h352"
  },
  null,
  -1
), _hoisted_4$r = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-miterlimit": "10",
    "stroke-width": "32",
    d: "M80 352h352"
  },
  null,
  -1
), _hoisted_5$g = [_hoisted_2$S, _hoisted_3$E, _hoisted_4$r], MenuOutline = defineComponent({
  name: "MenuOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$14, _hoisted_5$g);
  }
}), _hoisted_1$13 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$R = /* @__PURE__ */ createStaticVNode('<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M368 128h80"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M64 128h240"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M368 384h80"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M64 384h240"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M208 256h240"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M64 256h80"></path><circle cx="336" cy="128" r="32" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></circle><circle cx="176" cy="256" r="32" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></circle><circle cx="336" cy="384" r="32" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></circle>', 9), _hoisted_11$5 = [_hoisted_2$R], OptionsOutline = defineComponent({
  name: "OptionsOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$13, _hoisted_11$5);
  }
}), _hoisted_1$12 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$Q = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M208 432h-48a16 16 0 0 1-16-16V96a16 16 0 0 1 16-16h48a16 16 0 0 1 16 16v320a16 16 0 0 1-16 16z",
    fill: "currentColor"
  },
  null,
  -1
), _hoisted_3$D = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M352 432h-48a16 16 0 0 1-16-16V96a16 16 0 0 1 16-16h48a16 16 0 0 1 16 16v320a16 16 0 0 1-16 16z",
    fill: "currentColor"
  },
  null,
  -1
), _hoisted_4$q = [_hoisted_2$Q, _hoisted_3$D], Pause = defineComponent({
  name: "Pause",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$12, _hoisted_4$q);
  }
}), _hoisted_1$11 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$P = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M133 440a35.37 35.37 0 0 1-17.5-4.67c-12-6.8-19.46-20-19.46-34.33V111c0-14.37 7.46-27.53 19.46-34.33a35.13 35.13 0 0 1 35.77.45l247.85 148.36a36 36 0 0 1 0 61l-247.89 148.4A35.5 35.5 0 0 1 133 440z",
    fill: "currentColor"
  },
  null,
  -1
), _hoisted_3$C = [_hoisted_2$P], Play = defineComponent({
  name: "Play",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$11, _hoisted_3$C);
  }
}), _hoisted_1$10 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$O = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M30.71 229.47l188.87-113a30.54 30.54 0 0 1 31.09-.39a33.74 33.74 0 0 1 16.76 29.47v79.05l180.72-108.16a30.54 30.54 0 0 1 31.09-.39A33.74 33.74 0 0 1 496 145.52v221A33.73 33.73 0 0 1 479.24 396a30.54 30.54 0 0 1-31.09-.39L267.43 287.4v79.08A33.73 33.73 0 0 1 250.67 396a30.54 30.54 0 0 1-31.09-.39l-188.87-113a31.27 31.27 0 0 1 0-53z",
    fill: "currentColor"
  },
  null,
  -1
), _hoisted_3$B = [_hoisted_2$O], PlayBack = defineComponent({
  name: "PlayBack",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$10, _hoisted_3$B);
  }
}), _hoisted_1$$ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$N = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M481.29 229.47l-188.87-113a30.54 30.54 0 0 0-31.09-.39a33.74 33.74 0 0 0-16.76 29.47v79.05L63.85 116.44a30.54 30.54 0 0 0-31.09-.39A33.74 33.74 0 0 0 16 145.52v221A33.74 33.74 0 0 0 32.76 396a30.54 30.54 0 0 0 31.09-.39L244.57 287.4v79.08A33.74 33.74 0 0 0 261.33 396a30.54 30.54 0 0 0 31.09-.39l188.87-113a31.27 31.27 0 0 0 0-53z",
    fill: "currentColor"
  },
  null,
  -1
), _hoisted_3$A = [_hoisted_2$N], PlayForward = defineComponent({
  name: "PlayForward",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$$, _hoisted_3$A);
  }
}), _hoisted_1$_ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$M = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M320 146s24.36-12-64-12a160 160 0 1 0 160 160",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-miterlimit": "10",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$z = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M256 58l80 80l-80 80"
  },
  null,
  -1
), _hoisted_4$p = [_hoisted_2$M, _hoisted_3$z], RefreshOutline = defineComponent({
  name: "RefreshOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$_, _hoisted_4$p);
  }
}), _hoisted_1$Z = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$L = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M221.09 64a157.09 157.09 0 1 0 157.09 157.09A157.1 157.1 0 0 0 221.09 64z",
    fill: "none",
    stroke: "currentColor",
    "stroke-miterlimit": "10",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$y = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-miterlimit": "10",
    "stroke-width": "32",
    d: "M338.29 338.29L448 448"
  },
  null,
  -1
), _hoisted_4$o = [_hoisted_2$L, _hoisted_3$y], SearchOutline = defineComponent({
  name: "SearchOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$Z, _hoisted_4$o);
  }
}), _hoisted_1$Y = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$K = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M434.67 285.59v-29.8c0-98.73-80.24-178.79-179.2-178.79a179 179 0 0 0-140.14 67.36m-38.53 82v29.8C76.8 355 157 435 256 435a180.45 180.45 0 0 0 140-66.92",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_3$x = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M32 256l44-44l46 44"
  },
  null,
  -1
), _hoisted_4$n = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M480 256l-44 44l-46-44"
  },
  null,
  -1
), _hoisted_5$f = [_hoisted_2$K, _hoisted_3$x, _hoisted_4$n], SyncOutline = defineComponent({
  name: "SyncOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$Y, _hoisted_5$f);
  }
}), _hoisted_1$X = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, _hoisted_2$J = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M32 415.5l120-320l120 320"
  },
  null,
  -1
), _hoisted_3$w = /* @__PURE__ */ createElementVNode(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M230 303.5H74"
  },
  null,
  -1
), _hoisted_4$m = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M326 239.5c12.19-28.69 41-48 74-48h0c46 0 80 32 80 80v144",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_5$e = /* @__PURE__ */ createElementVNode(
  "path",
  {
    d: "M320 358.5c0 36 26.86 58 60 58c54 0 100-27 100-106v-15c-20 0-58 1-92 5c-32.77 3.86-68 19-68 58z",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32"
  },
  null,
  -1
), _hoisted_6$a = [_hoisted_2$J, _hoisted_3$w, _hoisted_4$m, _hoisted_5$e], TextOutline = defineComponent({
  name: "TextOutline",
  render: function(c, ie) {
    return openBlock(), createElementBlock("svg", _hoisted_1$X, _hoisted_6$a);
  }
}), _sfc_main$1c = /* @__PURE__ */ defineComponent({
  __name: "BxIcon",
  props: {
    size: {}
  },
  setup(m) {
    return (c, ie) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-icon", { ...typeof c.size == "string" ? { ["size-" + c.size]: !0 } : {} }]),
      style: normalizeStyle({ ...typeof c.size == "number" ? { "--icon-size": `${c.size}px` } : {} })
    }, [
      renderSlot(c.$slots, "default", {}, void 0, !0)
    ], 6));
  }
}), BxIcon_vue_vue_type_style_index_0_scoped_74c5df5a_lang = "", BxIcon = /* @__PURE__ */ _export_sfc(_sfc_main$1c, [["__scopeId", "data-v-74c5df5a"]]), _hoisted_1$W = {
  key: 0,
  class: "icon-wrapper"
}, _hoisted_2$I = { class: "title-wrapper" }, _hoisted_3$v = { key: 1 }, _hoisted_4$l = {
  key: 1,
  class: "actions-wrapper"
}, _sfc_main$1b = /* @__PURE__ */ defineComponent({
  __name: "PopupElement",
  props: {
    type: {},
    title: {},
    fullscreen: { type: Boolean },
    closeable: { type: Boolean },
    transculent: { type: Boolean },
    customClasses: {},
    fullLayer: { type: Boolean },
    injections: {}
  },
  emits: ["close"],
  setup(m, { emit: c }) {
    const ie = m;
    for (const Ze in ie.injections)
      provide(Ze, ie.injections[Ze]);
    const we = c, $e = useSlots();
    function Me() {
      we("close");
    }
    return (Ze, ne) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["popup-element", {
        ["type-" + Ze.type]: !0,
        ...Object.fromEntries(Ze.customClasses.map((rr) => [rr, !0])),
        "full-layer": Ze.fullLayer
      }])
    }, [
      createElementVNode("div", {
        class: normalizeClass(["popup-content", { fullscreen: Ze.fullscreen, transculent: Ze.transculent }])
      }, [
        createElementVNode("header", {
          class: normalizeClass({ "has-title": !!$e.title || Ze.title, "has-icon": !!$e.icon })
        }, [
          $e.icon !== void 0 ? (openBlock(), createElementBlock("div", _hoisted_1$W, [
            createVNode(BxIcon, null, {
              default: withCtx(() => [
                renderSlot(Ze.$slots, "icon", normalizeProps(guardReactiveProps({ close: Me })), void 0, !0)
              ]),
              _: 3
            })
          ])) : createCommentVNode("", !0),
          createElementVNode("div", _hoisted_2$I, [
            $e.title !== void 0 ? renderSlot(Ze.$slots, "title", normalizeProps(mergeProps({ key: 0 }, { close: Me })), void 0, !0) : Ze.title ? (openBlock(), createElementBlock("h3", _hoisted_3$v, toDisplayString(Ze.title), 1)) : createCommentVNode("", !0)
          ]),
          $e["header-actions"] !== void 0 || Ze.closeable ? (openBlock(), createElementBlock("div", _hoisted_4$l, [
            $e["header-actions"] !== void 0 ? renderSlot(Ze.$slots, "header-actions", normalizeProps(mergeProps({ key: 0 }, { close: Me })), void 0, !0) : createCommentVNode("", !0),
            $e["close-btn"] ? renderSlot(Ze.$slots, "close-btn", normalizeProps(mergeProps({ key: 1 }, { close: Me })), void 0, !0) : Ze.closeable ? (openBlock(), createBlock(BxButton, {
              key: 2,
              tertiary: "",
              circle: "",
              onClick: Me,
              class: "popup-close-btn",
              style: { padding: "8px" }
            }, {
              icon: withCtx(() => [
                createVNode(BxIcon, { size: 18 }, {
                  default: withCtx(() => [
                    createVNode(unref(CloseOutline))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : createCommentVNode("", !0)
          ])) : createCommentVNode("", !0)
        ], 2),
        createElementVNode("main", null, [
          renderSlot(Ze.$slots, "default", normalizeProps(guardReactiveProps({ close: Me })), void 0, !0)
        ])
      ], 2)
    ], 2));
  }
}), PopupElement_vue_vue_type_style_index_0_scoped_bf52fd18_lang = "", PopupElement = /* @__PURE__ */ _export_sfc(_sfc_main$1b, [["__scopeId", "data-v-bf52fd18"]]), _hoisted_1$V = { class: "symbol-wrapper" }, _hoisted_2$H = { class: "message-content" }, _hoisted_3$u = {
  key: 0,
  class: "title-wrapper"
}, _hoisted_4$k = { key: 1 }, _hoisted_5$d = { class: "message-wrapper" }, _hoisted_6$9 = { key: 1 }, _sfc_main$1a = /* @__PURE__ */ defineComponent({
  __name: "MessageElement",
  props: {
    type: {},
    title: {},
    message: {},
    closeable: { type: Boolean },
    customClasses: {},
    maxWidth: {},
    injections: {},
    placement: {}
  },
  setup(m) {
    const c = useSlots();
    return (ie, we) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["message-element", { [`placement-${ie.placement}`]: !0 }])
    }, [
      createElementVNode("div", {
        class: "message-body",
        style: normalizeStyle({ maxWidth: ie.maxWidth })
      }, [
        createElementVNode("div", _hoisted_1$V, [
          createVNode(BxIcon, null, {
            default: withCtx(() => [
              c.icon ? renderSlot(ie.$slots, "icon", { key: 0 }, void 0, !0) : ie.type === "success" ? (openBlock(), createBlock(unref(CheckmarkCircle), { key: 1 })) : createCommentVNode("", !0)
            ]),
            _: 3
          })
        ]),
        createElementVNode("div", _hoisted_2$H, [
          c.title || ie.title ? (openBlock(), createElementBlock("div", _hoisted_3$u, [
            c.title ? renderSlot(ie.$slots, "title", { key: 0 }, void 0, !0) : ie.title ? (openBlock(), createElementBlock("span", _hoisted_4$k, toDisplayString(ie.title), 1)) : createCommentVNode("", !0)
          ])) : createCommentVNode("", !0),
          createElementVNode("div", _hoisted_5$d, [
            c.message ? renderSlot(ie.$slots, "message", { key: 0 }, void 0, !0) : ie.message ? (openBlock(), createElementBlock("span", _hoisted_6$9, toDisplayString(ie.message), 1)) : createCommentVNode("", !0)
          ])
        ])
      ], 4)
    ], 2));
  }
}), MessageElement_vue_vue_type_style_index_0_scoped_c2341d4e_lang = "", MessageElement = /* @__PURE__ */ _export_sfc(_sfc_main$1a, [["__scopeId", "data-v-c2341d4e"]]);
window.addEventListener("load", () => {
  const m = document.querySelector(GLOBAL_APP_WRAPPER_SELECTOR);
  !m || (m.classList.add("bluepic-popup-app-wrapper"), m.parentElement?.classList.add("bluepic-popup-body"));
});
function createMessage(m) {
  const c = window.bluepicPopupProvider, ie = nanoid(), we = computed({
    get() {
      return c.popoverProviderRef.isVisible(ie);
    },
    set($e) {
      $e ? c.popoverProviderRef.push(
        ie,
        () => h$1(
          MessageElement,
          {
            placement: "top-right",
            type: m.type,
            title: typeof m.title == "string" ? m.title : void 0,
            message: typeof m.message == "string" ? m.message : void 0,
            closeable: m.closeable ?? !0,
            customClasses: m.customClasses ?? [],
            injections: Object.fromEntries((m.passInjections ?? []).map((Me) => [Me, inject(Me)])),
            maxWidth: m.maxWidth
          },
          {
            title: typeof m.title == "function" ? m.title : void 0,
            message: typeof m.message == "function" ? m.message : void 0,
            icon: m.icon
          }
        ),
        {
          darkenBackground: m.darkenBackground ?? !1,
          handleClickOutside() {
            we.value = !1;
          }
        }
      ) : c.popoverProviderRef.pull(ie);
    }
  });
  return we.value = !0, m.closeAfter && setTimeout(() => {
    we.value = !1;
  }, m.closeAfter), {
    show: we
  };
}
function createPopup(m) {
  const c = window.bluepicPopupProvider, ie = nanoid(), we = computed({
    get() {
      return c.popupProviderRef.isVisible(ie);
    },
    set(Me) {
      Me ? c.popupProviderRef.push(
        ie,
        () => h$1(
          PopupElement,
          {
            type: m.type ?? "frame",
            title: typeof m.title == "string" ? m.title : void 0,
            fullscreen: !1,
            closeable: m.closeable ?? !0,
            transculent: m.transculent ?? !1,
            customClasses: m.customClasses ?? [],
            fullLayer: m.fullLayer ?? !1,
            injections: Object.fromEntries((m.passInjections ?? []).map((Ze) => [Ze, inject(Ze)]))
          },
          {
            default: () => h$1("div", {}, [
              typeof m.content == "string" ? m.content : m.content(),
              ...m.actions ? typeof m.actions == "function" ? m.actions() : [
                h$1(
                  "div",
                  {},
                  m.actions.map((Ze) => h$1(
                    BxButton,
                    {
                      ...Ze.props
                    },
                    {
                      icon: Ze.icon,
                      default: () => Ze.label
                    }
                  ))
                )
              ] : []
            ]),
            title: typeof m.title == "function" ? m.title : void 0,
            header: m.header,
            icon: m.icon,
            "close-btn": m.closeBtn
          }
        ),
        {
          type: m.type ?? "frame",
          close() {
            we.value = !1;
          },
          disableBackgroundEffect: m.disableBackgroundEffect ?? !1,
          wrapperCustomClasses: m.wrapperCustomClasses ?? [],
          handleClickOutside() {
            we.value = !1;
          }
        }
      ) : c.popupProviderRef.pull(ie);
    }
  });
  function $e() {
    we.value = !1;
  }
  return we.value = !0, {
    close: $e
  };
}
const _hoisted_1$U = {
  key: 0,
  class: "bx-progress__circle"
}, _hoisted_2$G = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100"
}, _hoisted_3$t = ["d"], _hoisted_4$j = { class: "bx-progress__bar-inner" }, _sfc_main$19 = /* @__PURE__ */ defineComponent({
  __name: "BxProgress",
  props: {
    value: {},
    circle: { type: Boolean, default: !1 },
    transition: { type: Boolean, default: !0 }
  },
  setup(m) {
    const c = m;
    function ie($e, Me, Ze = 0, ne = 0) {
      $e = Math.max(0, Math.min(100, $e));
      const rr = $e / 100 * 360, gr = (rr - 90) * (Math.PI / 180), or = Ze + Me * Math.cos(gr), _r = ne + Me * Math.sin(gr), Lr = rr > 180 ? 1 : 0;
      return [
        `M ${Ze} ${ne - Me}`,
        `A ${Me} ${Me} 0 ${Lr} 1 ${or} ${_r}`
      ].join(" ");
    }
    const we = computed(() => c.value !== void 0 ? ie(c.value * 100, 45, 50, 50) : "");
    return ($e, Me) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-progress", { circle: $e.circle }])
    }, [
      $e.circle ? (openBlock(), createElementBlock("div", _hoisted_1$U, [
        (openBlock(), createElementBlock("svg", _hoisted_2$G, [
          createElementVNode("path", {
            d: we.value,
            class: "circle-progress-path"
          }, null, 8, _hoisted_3$t)
        ]))
      ])) : (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass(["bx-progress__bar", { circle: $e.circle }]),
        style: normalizeStyle({ "--progress": $e.value })
      }, [
        createElementVNode("div", _hoisted_4$j, [
          createElementVNode("div", {
            class: normalizeClass(["bx-progress__bar-fill", { transition: $e.transition }])
          }, null, 2)
        ])
      ], 6))
    ], 2));
  }
}), BxProgress_vue_vue_type_style_index_0_scoped_ce3eb72c_lang = "", BxProgress = /* @__PURE__ */ _export_sfc(_sfc_main$19, [["__scopeId", "data-v-ce3eb72c"]]);
function useSlotVNodes(m) {
  let c = [];
  const ie = ref$1([]), we = computed(() => m()), $e = (Me) => (Ze) => {
    const ne = (() => {
      if (Ze instanceof HTMLElement)
        return Ze;
      if (Ze instanceof Node)
        return Ze.nextSibling;
      if (Ze?.$el instanceof HTMLElement)
        return Ze.$el;
    })();
    !ne || c.push(ne);
  };
  return watch(
    we,
    () => {
      c = [], nextTick$3(() => {
        ie.value = c;
      });
    },
    { immediate: !0 }
  ), {
    setSlotRef: $e,
    slotElements: ie,
    vNodes: we
  };
}
const _sfc_main$18 = /* @__PURE__ */ defineComponent({
  __name: "Popup",
  props: {
    trigger: { default: "click" },
    type: { default: "layer" },
    title: {},
    fullscreen: { type: Boolean, default: !1 },
    show: { type: Boolean, default: !1 },
    closeable: { type: Boolean, default: !0 },
    transculent: { type: Boolean, default: !1 },
    customClasses: { default: () => [] },
    wrapperCustomClasses: { default: () => [] },
    fullLayer: { type: Boolean, default: !1 },
    disableBackgroundEffect: { type: Boolean, default: !1 },
    passInjections: { default: () => [] },
    debug: { type: Boolean, default: !1 }
  },
  emits: ["update:show"],
  setup(m, { emit: c }) {
    const ie = m, we = c, $e = nanoid(), Me = useSlots(), { setSlotRef: Ze, slotElements: ne, vNodes: rr } = useSlotVNodes(Me.trigger), gr = Object.fromEntries(ie.passInjections.map((Ir) => [Ir, inject(Ir)])), or = computed({
      get() {
        return Lr.popupProviderRef.isVisible($e);
      },
      set(Ir) {
        console.log("SET", $e, Ir), Ir ? Lr.popupProviderRef.push(
          $e,
          () => h$1(
            PopupElement,
            {
              type: ie.type,
              title: ie.title,
              fullscreen: ie.fullscreen,
              transculent: ie.transculent,
              customClasses: ie.customClasses,
              closeable: ie.closeable,
              fullLayer: ie.fullLayer,
              injections: gr
            },
            {
              default: Me.content,
              title: Me.title,
              ["header-actions"]: Me["header-actions"],
              ["close-btn"]: Me["close-btn"]
            }
          ),
          {
            type: ie.type,
            close() {
              or.value = !1;
            },
            disableBackgroundEffect: ie.disableBackgroundEffect,
            wrapperCustomClasses: ie.wrapperCustomClasses,
            handleClickOutside: () => {
              or.value = !1;
            }
          }
        ) : Lr.popupProviderRef.pull($e), ie.show !== Ir && we("update:show", Ir);
      }
    });
    onUnmounted(() => {
      console.log("UNMOUNT BXPOPUP", $e), Lr.popupProviderRef.pull($e);
    }), watch(
      () => ie.show,
      () => {
        console.log("POPUP", $e), console.log("show", ie.show), ie.show !== or.value && (or.value = ie.show);
      }
    );
    function _r() {
      or.value = !or.value;
    }
    watch(ne, () => {
      for (const Ir of ne.value)
        Ir.addEventListener("click", _r);
    }), onUnmounted(() => {
      for (const Ir of ne.value)
        Ir.removeEventListener("click", _r);
    });
    const Lr = window.bluepicPopupProvider;
    return onMounted(() => {
      const Ir = document.querySelector(GLOBAL_APP_WRAPPER_SELECTOR);
      !Ir || (Ir.classList.add("bluepic-popup-app-wrapper"), Ir.parentElement?.classList.add("bluepic-popup-body"));
    }), (Ir, Ar) => (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(rr), (Rr, Nr) => (openBlock(), createBlock(resolveDynamicComponent(Rr), {
      ref_for: !0,
      ref: unref(Ze)(Nr)
    }, null, 512))), 256));
  }
}), _hoisted_1$T = {
  key: 0,
  class: "bx-card__header"
}, _hoisted_2$F = { class: "bx-card__header-inner" }, _hoisted_3$s = {
  key: 1,
  class: "bx-card__title-wrapper"
}, _hoisted_4$i = { key: 1 }, _hoisted_5$c = {
  key: 0,
  class: "bx-card__header-extra"
}, _hoisted_6$8 = {
  key: 1,
  class: "bx-card__cover"
}, _hoisted_7$6 = ["src"], _hoisted_8$5 = {
  key: 2,
  class: "bx-card__content"
}, _hoisted_9$5 = {
  key: 3,
  class: "bx-card__footer"
}, _sfc_main$17 = /* @__PURE__ */ defineComponent({
  __name: "BxCard",
  props: {
    title: {},
    description: {},
    cover: {},
    size: { default: "medium" },
    bordered: { type: Boolean, default: !0 },
    transculent: { type: Boolean, default: !1 },
    coverWidth: {},
    hoverable: { type: Boolean, default: !1 },
    dividers: { type: Boolean, default: !0 }
  },
  setup(m) {
    const c = useSlots();
    return (ie, we) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-card", { bordered: ie.bordered, transculent: ie.transculent, ["size-" + ie.size]: !0, hoverable: ie.hoverable, dividers: ie.dividers }])
    }, [
      c.header || c.title || ie.title ? (openBlock(), createElementBlock("div", _hoisted_1$T, [
        createElementVNode("div", _hoisted_2$F, [
          c.header ? renderSlot(ie.$slots, "header", { key: 0 }, void 0, !0) : (openBlock(), createElementBlock("div", _hoisted_3$s, [
            c.title ? renderSlot(ie.$slots, "title", { key: 0 }, void 0, !0) : ie.title ? (openBlock(), createElementBlock("h3", _hoisted_4$i, toDisplayString(ie.title), 1)) : createCommentVNode("", !0)
          ]))
        ]),
        c["header-extra"] ? (openBlock(), createElementBlock("div", _hoisted_5$c, [
          renderSlot(ie.$slots, "header-extra", {}, void 0, !0)
        ])) : createCommentVNode("", !0)
      ])) : createCommentVNode("", !0),
      c.cover || ie.cover ? (openBlock(), createElementBlock("div", _hoisted_6$8, [
        c.cover ? renderSlot(ie.$slots, "cover", { key: 0 }, void 0, !0) : (openBlock(), createElementBlock("img", {
          key: 1,
          src: ie.cover,
          alt: "cover",
          style: normalizeStyle({ "--cover-width": ie.coverWidth })
        }, null, 12, _hoisted_7$6))
      ])) : createCommentVNode("", !0),
      c.default ? (openBlock(), createElementBlock("div", _hoisted_8$5, [
        renderSlot(ie.$slots, "default", {}, void 0, !0)
      ])) : createCommentVNode("", !0),
      c.footer ? (openBlock(), createElementBlock("div", _hoisted_9$5, [
        renderSlot(ie.$slots, "footer", {}, void 0, !0)
      ])) : createCommentVNode("", !0)
    ], 2));
  }
}), BxCard_vue_vue_type_style_index_0_scoped_29953d03_lang = "", BxCard = /* @__PURE__ */ _export_sfc(_sfc_main$17, [["__scopeId", "data-v-29953d03"]]), _hoisted_1$S = { class: "bx-upload" }, _hoisted_2$E = { class: "bx-upload__icon-wrapper" }, _hoisted_3$r = { class: "bx-upload__title" }, _hoisted_4$h = { class: "bx-upload__description" }, _sfc_main$16 = /* @__PURE__ */ defineComponent({
  __name: "BxUpload",
  props: {
    type: {},
    accept: { default: () => ["image/*"] },
    title: { default: "Upload" },
    description: { default: "Drag and drop files here or click to upload" },
    uploadProgress: {},
    maxSize: { default: 1 / 0 }
  },
  emits: ["select"],
  setup(m, { emit: c }) {
    const ie = m, we = c, $e = useSlots(), Me = ref$1(!1);
    function Ze(Lr) {
      Lr.preventDefault(), Lr.stopPropagation();
    }
    function ne(Lr) {
      Lr.preventDefault(), Lr.stopPropagation(), Me.value = !0;
    }
    function rr(Lr) {
      Lr.preventDefault(), Lr.stopPropagation();
    }
    function gr(Lr) {
      Lr.preventDefault(), Lr.stopPropagation(), Me.value = !1;
    }
    async function or(Lr) {
      Lr.preventDefault(), Lr.stopPropagation(), Me.value = !1;
      const Ir = Array.from(Lr.dataTransfer.files).filter((Ar) => {
        const [Rr, Nr] = Ar.type.split("/");
        return ie.accept.some((Yr) => {
          const [Vr, Xr] = Yr.split("/");
          return (Vr === "*" || Vr === Rr) && (Xr === "*" || Xr === Nr);
        });
      });
      we("select", Ir);
    }
    async function _r() {
      const Lr = await openFiles({
        types: ie.accept,
        maxSize: ie.maxSize,
        multiple: !0
      });
      we("select", Lr);
    }
    return (Lr, Ir) => (openBlock(), createElementBlock("div", _hoisted_1$S, [
      Lr.type === "area" ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["bx-upload__area", { dragging: Me.value }]),
        onDragstart: Ze,
        onDragenter: ne,
        onDragover: rr,
        onDragleave: gr,
        onDrop: or,
        onClick: _r
      }, [
        createElementVNode("div", _hoisted_2$E, [
          Lr.uploadProgress !== void 0 ? (openBlock(), createBlock(BxProgress, {
            key: 0,
            value: Lr.uploadProgress,
            circle: "",
            size: "medium"
          }, null, 8, ["value"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            $e.icon ? renderSlot(Lr.$slots, "icon", { key: 0 }, void 0, !0) : (openBlock(), createBlock(unref(ArchiveOutline), { key: 1 }))
          ], 64))
        ]),
        createElementVNode("div", _hoisted_3$r, [
          Lr.uploadProgress !== void 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(" Uploading ")
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            $e.title ? renderSlot(Lr.$slots, "title", { key: 0 }, void 0, !0) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(Lr.title), 1)
            ], 64))
          ], 64))
        ]),
        createElementVNode("div", _hoisted_4$h, [
          Lr.uploadProgress !== void 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(unref(round$3)(Lr.uploadProgress * 100, 5)) + "% ", 1)
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            $e.description ? renderSlot(Lr.$slots, "description", { key: 0 }, void 0, !0) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(Lr.description), 1)
            ], 64))
          ], 64))
        ])
      ], 34)) : Lr.type === "button" ? (openBlock(), createBlock(BxButton, {
        key: 1,
        accept: Lr.accept
      }, {
        icon: withCtx(() => [
          $e.icon ? renderSlot(Lr.$slots, "icon", { key: 0 }, void 0, !0) : (openBlock(), createBlock(unref(ArchiveOutline), { key: 1 }))
        ]),
        default: withCtx(() => [
          Ir[0] || (Ir[0] = createTextVNode(" Upload "))
        ]),
        _: 3
      }, 8, ["accept"])) : createCommentVNode("", !0)
    ]));
  }
}), BxUpload_vue_vue_type_style_index_0_scoped_88ad31a3_lang = "", BxUpload = /* @__PURE__ */ _export_sfc(_sfc_main$16, [["__scopeId", "data-v-88ad31a3"]]), _hoisted_1$R = { class: "image-library-upload" }, _hoisted_2$D = { class: "upload-progress-wrapper" }, _sfc_main$15 = /* @__PURE__ */ defineComponent({
  __name: "Upload",
  props: {
    width: {},
    height: {},
    quality: {},
    convertTo: {},
    field: {},
    handleUpload: { type: Function }
  },
  emits: ["upload"],
  setup(m, { emit: c }) {
    const ie = m, we = c, { uploadFiles: $e, uploadProgresses: Me, uploading: Ze } = useUpload(
      toRef(ie, "width"),
      toRef(ie, "height"),
      toRef(ie, "convertTo"),
      toRef(ie, "quality"),
      ie.handleUpload,
      toRef(ie, "field")
    ), ne = computed(() => {
      const gr = round$3(Me.value.reduce((or, _r) => or + _r, 0) / Me.value.length, 5);
      if (!isNaN(gr))
        return gr;
    });
    async function rr(gr) {
      const or = await $e(gr);
      we("upload", or);
    }
    return (gr, or) => (openBlock(), createElementBlock("div", _hoisted_1$R, [
      createVNode(BxUpload, {
        type: "area",
        onSelect: rr,
        "upload-progress": ne.value
      }, null, 8, ["upload-progress"]),
      createElementVNode("div", _hoisted_2$D, [
        unref(Ze) ? (openBlock(), createBlock(BxProgress, {
          key: 0,
          value: ne.value
        }, null, 8, ["value"])) : createCommentVNode("", !0)
      ])
    ]));
  }
}), Upload_vue_vue_type_style_index_0_scoped_73dc9b99_lang = "", UploadLibraryComponent = /* @__PURE__ */ _export_sfc(_sfc_main$15, [["__scopeId", "data-v-73dc9b99"]]), getPrototypeOf$1 = Object.getPrototypeOf, getOwnProperties = Object.getOwnPropertySymbols ? function(m) {
  return Object.keys(m).concat(Object.getOwnPropertySymbols(m));
} : Object.keys;
function checkEquality(m, c, ie) {
  var we, $e, Me, Ze = Object.prototype.toString.call(m), ne = Object.prototype.toString.call(c);
  if (m === c)
    return !0;
  if (m == null || c == null)
    return !1;
  if (ie.indexOf(m) > -1 && ie.indexOf(c) > -1)
    return !0;
  if (ie.push(m, c), Ze != ne || (we = getOwnProperties(m), $e = getOwnProperties(c), we.length != $e.length || we.some(function(rr) {
    return !checkEquality(m[rr], c[rr], ie);
  })))
    return !1;
  switch (Ze.slice(8, -1)) {
    case "Symbol":
      return m.valueOf() == c.valueOf();
    case "Date":
    case "Number":
      return +m == +c || +m != +m && +c != +c;
    case "RegExp":
    case "Function":
    case "String":
    case "Boolean":
      return "" + m == "" + c;
    case "Set":
    case "Map": {
      we = m.entries(), $e = c.entries();
      do
        if (Me = we.next(), !checkEquality(Me.value, $e.next().value, ie))
          return !1;
      while (!Me.done);
      return !0;
    }
    case "ArrayBuffer":
      m = new Uint8Array(m), c = new Uint8Array(c);
    case "DataView":
      m = new Uint8Array(m.buffer), c = new Uint8Array(c.buffer);
    case "Float32Array":
    case "Float64Array":
    case "Int8Array":
    case "Int16Array":
    case "Int32Array":
    case "Uint8Array":
    case "Uint16Array":
    case "Uint32Array":
    case "Uint8ClampedArray":
    case "Arguments":
    case "Array":
      if (m.length != c.length)
        return !1;
      for (Me = 0; Me < m.length; Me++)
        if (!(!(Me in m) && !(Me in c)) && (Me in m != Me in c || !checkEquality(m[Me], c[Me], ie)))
          return !1;
      return !0;
    case "Object":
      return checkEquality(getPrototypeOf$1(m), getPrototypeOf$1(c), ie);
    default:
      return !1;
  }
}
function isEqual(m, c) {
  return checkEquality(m, c, []);
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs$1(m) {
  return m && m.__esModule && Object.prototype.hasOwnProperty.call(m, "default") ? m.default : m;
}
function getAugmentedNamespace(m) {
  var c = m.default;
  if (typeof c == "function") {
    var ie = function() {
      return c.apply(this, arguments);
    };
    ie.prototype = c.prototype;
  } else
    ie = {};
  return Object.defineProperty(ie, "__esModule", { value: !0 }), Object.keys(m).forEach(function(we) {
    var $e = Object.getOwnPropertyDescriptor(m, we);
    Object.defineProperty(ie, we, $e.get ? $e : {
      enumerable: !0,
      get: function() {
        return m[we];
      }
    });
  }), ie;
}
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(m, c) {
  (function() {
    var ie, we = "4.17.21", $e = 200, Me = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", Ze = "Expected a function", ne = "Invalid `variable` option passed into `_.template`", rr = "__lodash_hash_undefined__", gr = 500, or = "__lodash_placeholder__", _r = 1, Lr = 2, Ir = 4, Ar = 1, Rr = 2, Nr = 1, Yr = 2, Vr = 4, Xr = 8, Wr = 16, si = 32, li = 64, xi = 128, di = 256, oi = 512, ci = 30, vr = "...", Ae = 800, ze = 16, Ue = 1, tr = 2, lr = 3, pr = 1 / 0, br = 9007199254740991, nr = 17976931348623157e292, Pe = 0 / 0, ur = 4294967295, Pr = ur - 1, Hr = ur >>> 1, vi = [
      ["ary", xi],
      ["bind", Nr],
      ["bindKey", Yr],
      ["curry", Xr],
      ["curryRight", Wr],
      ["flip", oi],
      ["partial", si],
      ["partialRight", li],
      ["rearg", di]
    ], Ti = "[object Arguments]", wi = "[object Array]", ii = "[object AsyncFunction]", mi = "[object Boolean]", ei = "[object Date]", Zr = "[object DOMException]", pi = "[object Error]", hi = "[object Function]", Oi = "[object GeneratorFunction]", qi = "[object Map]", yn = "[object Number]", sn = "[object Null]", $n = "[object Object]", rn = "[object Promise]", ji = "[object Proxy]", Kn = "[object RegExp]", In = "[object Set]", Fn = "[object String]", Po = "[object Symbol]", vn = "[object Undefined]", Vn = "[object WeakMap]", Xo = "[object WeakSet]", Xn = "[object ArrayBuffer]", Yn = "[object DataView]", Wo = "[object Float32Array]", Ci = "[object Float64Array]", ri = "[object Int8Array]", yi = "[object Int16Array]", Li = "[object Int32Array]", Yi = "[object Uint8Array]", zn = "[object Uint8ClampedArray]", un = "[object Uint16Array]", Gn = "[object Uint32Array]", Mn = /\b__p \+= '';/g, pn = /\b(__p \+=) '' \+/g, Rn = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Io = /&(?:amp|lt|gt|quot|#39);/g, to = /[&<>"']/g, no = RegExp(Io.source), ma = RegExp(to.source), Qn = /<%-([\s\S]+?)%>/g, co = /<%([\s\S]+?)%>/g, kn = /<%=([\s\S]+?)%>/g, ai = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, _i = /^\w*$/, Pi = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ai = /[\\^$.*+?()[\]{}|]/g, ki = RegExp(Ai.source), an = /^\s+/, Ui = /\s/, Vi = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Sn = /\{\n\/\* \[wrapped with (.+)\] \*/, Hi = /,? & /, en = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, qn = /[()=,{}\[\]\/\s]/, _n = /\\(\\)?/g, Tn = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, xo = /\w*$/, Co = /^[-+]0x[0-9a-f]+$/i, $o = /^0b[01]+$/i, Bo = /^\[object .+?Constructor\]$/, Qo = /^0o[0-7]+$/i, Go = /^(?:0|[1-9]\d*)$/, No = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Zo = /($^)/, ea = /['\n\r\u2028\u2029\\]/g, da = "\\ud800-\\udfff", Ra = "\\u0300-\\u036f", ba = "\\ufe20-\\ufe2f", Ea = "\\u20d0-\\u20ff", Ha = Ra + ba + Ea, Fa = "\\u2700-\\u27bf", ls = "a-z\\xdf-\\xf6\\xf8-\\xff", us = "\\xac\\xb1\\xd7\\xf7", Xa = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", hs = "\\u2000-\\u206f", Fc = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Pl = "A-Z\\xc0-\\xd6\\xd8-\\xde", wu = "\\ufe0e\\ufe0f", yf = us + Xa + hs + Fc, bf = "['\u2019]", xf = "[" + da + "]", Lh = "[" + yf + "]", ju = "[" + Ha + "]", wf = "\\d+", Hl = "[" + Fa + "]", uc = "[" + ls + "]", Wl = "[^" + da + yf + wf + Fa + ls + Pl + "]", Zl = "\\ud83c[\\udffb-\\udfff]", ru = "(?:" + ju + "|" + Zl + ")", _d = "[^" + da + "]", qu = "(?:\\ud83c[\\udde6-\\uddff]){2}", Nc = "[\\ud800-\\udbff][\\udc00-\\udfff]", Xl = "[" + Pl + "]", yd = "\\u200d", Mf = "(?:" + uc + "|" + Wl + ")", Ih = "(?:" + Xl + "|" + Wl + ")", Kl = "(?:" + bf + "(?:d|ll|m|re|s|t|ve))?", bd = "(?:" + bf + "(?:D|LL|M|RE|S|T|VE))?", xd = ru + "?", Ca = "[" + wu + "]?", O0 = "(?:" + yd + "(?:" + [_d, qu, Nc].join("|") + ")" + Ca + xd + ")*", Ho = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Sp = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", xa = Ca + xd + O0, Sf = "(?:" + [Hl, qu, Nc].join("|") + ")" + xa, hc = "(?:" + [_d + ju + "?", ju, qu, Nc, xf].join("|") + ")", Ep = RegExp(bf, "g"), Bh = RegExp(ju, "g"), To = RegExp(Zl + "(?=" + Zl + ")|" + hc + xa, "g"), Pa = RegExp([
      Xl + "?" + uc + "+" + Kl + "(?=" + [Lh, Xl, "$"].join("|") + ")",
      Ih + "+" + bd + "(?=" + [Lh, Xl + Mf, "$"].join("|") + ")",
      Xl + "?" + Mf + "+" + Kl,
      Xl + "+" + bd,
      Sp,
      Ho,
      wf,
      Sf
    ].join("|"), "g"), Ta = RegExp("[" + yd + da + Ha + wu + "]"), Dl = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Gu = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], ga = -1, vs = {};
    vs[Wo] = vs[Ci] = vs[ri] = vs[yi] = vs[Li] = vs[Yi] = vs[zn] = vs[un] = vs[Gn] = !0, vs[Ti] = vs[wi] = vs[Xn] = vs[mi] = vs[Yn] = vs[ei] = vs[pi] = vs[hi] = vs[qi] = vs[yn] = vs[$n] = vs[Kn] = vs[In] = vs[Fn] = vs[Vn] = !1;
    var es = {};
    es[Ti] = es[wi] = es[Xn] = es[Yn] = es[mi] = es[ei] = es[Wo] = es[Ci] = es[ri] = es[yi] = es[Li] = es[qi] = es[yn] = es[$n] = es[Kn] = es[In] = es[Fn] = es[Po] = es[Yi] = es[zn] = es[un] = es[Gn] = !0, es[pi] = es[hi] = es[Vn] = !1;
    var Hu = {
      \u00C0: "A",
      \u00C1: "A",
      \u00C2: "A",
      \u00C3: "A",
      \u00C4: "A",
      \u00C5: "A",
      \u00E0: "a",
      \u00E1: "a",
      \u00E2: "a",
      \u00E3: "a",
      \u00E4: "a",
      \u00E5: "a",
      \u00C7: "C",
      \u00E7: "c",
      \u00D0: "D",
      \u00F0: "d",
      \u00C8: "E",
      \u00C9: "E",
      \u00CA: "E",
      \u00CB: "E",
      \u00E8: "e",
      \u00E9: "e",
      \u00EA: "e",
      \u00EB: "e",
      \u00CC: "I",
      \u00CD: "I",
      \u00CE: "I",
      \u00CF: "I",
      \u00EC: "i",
      \u00ED: "i",
      \u00EE: "i",
      \u00EF: "i",
      \u00D1: "N",
      \u00F1: "n",
      \u00D2: "O",
      \u00D3: "O",
      \u00D4: "O",
      \u00D5: "O",
      \u00D6: "O",
      \u00D8: "O",
      \u00F2: "o",
      \u00F3: "o",
      \u00F4: "o",
      \u00F5: "o",
      \u00F6: "o",
      \u00F8: "o",
      \u00D9: "U",
      \u00DA: "U",
      \u00DB: "U",
      \u00DC: "U",
      \u00F9: "u",
      \u00FA: "u",
      \u00FB: "u",
      \u00FC: "u",
      \u00DD: "Y",
      \u00FD: "y",
      \u00FF: "y",
      \u00C6: "Ae",
      \u00E6: "ae",
      \u00DE: "Th",
      \u00FE: "th",
      \u00DF: "ss",
      \u0100: "A",
      \u0102: "A",
      \u0104: "A",
      \u0101: "a",
      \u0103: "a",
      \u0105: "a",
      \u0106: "C",
      \u0108: "C",
      \u010A: "C",
      \u010C: "C",
      \u0107: "c",
      \u0109: "c",
      \u010B: "c",
      \u010D: "c",
      \u010E: "D",
      \u0110: "D",
      \u010F: "d",
      \u0111: "d",
      \u0112: "E",
      \u0114: "E",
      \u0116: "E",
      \u0118: "E",
      \u011A: "E",
      \u0113: "e",
      \u0115: "e",
      \u0117: "e",
      \u0119: "e",
      \u011B: "e",
      \u011C: "G",
      \u011E: "G",
      \u0120: "G",
      \u0122: "G",
      \u011D: "g",
      \u011F: "g",
      \u0121: "g",
      \u0123: "g",
      \u0124: "H",
      \u0126: "H",
      \u0125: "h",
      \u0127: "h",
      \u0128: "I",
      \u012A: "I",
      \u012C: "I",
      \u012E: "I",
      \u0130: "I",
      \u0129: "i",
      \u012B: "i",
      \u012D: "i",
      \u012F: "i",
      \u0131: "i",
      \u0134: "J",
      \u0135: "j",
      \u0136: "K",
      \u0137: "k",
      \u0138: "k",
      \u0139: "L",
      \u013B: "L",
      \u013D: "L",
      \u013F: "L",
      \u0141: "L",
      \u013A: "l",
      \u013C: "l",
      \u013E: "l",
      \u0140: "l",
      \u0142: "l",
      \u0143: "N",
      \u0145: "N",
      \u0147: "N",
      \u014A: "N",
      \u0144: "n",
      \u0146: "n",
      \u0148: "n",
      \u014B: "n",
      \u014C: "O",
      \u014E: "O",
      \u0150: "O",
      \u014D: "o",
      \u014F: "o",
      \u0151: "o",
      \u0154: "R",
      \u0156: "R",
      \u0158: "R",
      \u0155: "r",
      \u0157: "r",
      \u0159: "r",
      \u015A: "S",
      \u015C: "S",
      \u015E: "S",
      \u0160: "S",
      \u015B: "s",
      \u015D: "s",
      \u015F: "s",
      \u0161: "s",
      \u0162: "T",
      \u0164: "T",
      \u0166: "T",
      \u0163: "t",
      \u0165: "t",
      \u0167: "t",
      \u0168: "U",
      \u016A: "U",
      \u016C: "U",
      \u016E: "U",
      \u0170: "U",
      \u0172: "U",
      \u0169: "u",
      \u016B: "u",
      \u016D: "u",
      \u016F: "u",
      \u0171: "u",
      \u0173: "u",
      \u0174: "W",
      \u0175: "w",
      \u0176: "Y",
      \u0177: "y",
      \u0178: "Y",
      \u0179: "Z",
      \u017B: "Z",
      \u017D: "Z",
      \u017A: "z",
      \u017C: "z",
      \u017E: "z",
      \u0132: "IJ",
      \u0133: "ij",
      \u0152: "Oe",
      \u0153: "oe",
      \u0149: "'n",
      \u017F: "s"
    }, dl = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, ts = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Bm = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, wd = parseFloat, Ef = parseInt, Wu = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, Cf = typeof self == "object" && self && self.Object === Object && self, Rs = Wu || Cf || Function("return this")(), Ys = c && !c.nodeType && c, yl = Ys && !0 && m && !m.nodeType && m, Ps = yl && yl.exports === Ys, iu = Ps && Wu.process, ol = function() {
      try {
        var jn = yl && yl.require && yl.require("util").types;
        return jn || iu && iu.binding && iu.binding("util");
      } catch {
      }
    }(), ds = ol && ol.isArrayBuffer, dc = ol && ol.isDate, Yl = ol && ol.isMap, Ts = ol && ol.isRegExp, $h = ol && ol.isSet, Jl = ol && ol.isTypedArray;
    function Ds(jn, go, so) {
      switch (so.length) {
        case 0:
          return jn.call(go);
        case 1:
          return jn.call(go, so[0]);
        case 2:
          return jn.call(go, so[0], so[1]);
        case 3:
          return jn.call(go, so[0], so[1], so[2]);
      }
      return jn.apply(go, so);
    }
    function Rh(jn, go, so, Yo) {
      for (var ka = -1, za = jn == null ? 0 : jn.length; ++ka < za; ) {
        var Ls = jn[ka];
        go(Yo, Ls, so(Ls), jn);
      }
      return Yo;
    }
    function al(jn, go) {
      for (var so = -1, Yo = jn == null ? 0 : jn.length; ++so < Yo && go(jn[so], so, jn) !== !1; )
        ;
      return jn;
    }
    function z0(jn, go) {
      for (var so = jn == null ? 0 : jn.length; so-- && go(jn[so], so, jn) !== !1; )
        ;
      return jn;
    }
    function Vc(jn, go) {
      for (var so = -1, Yo = jn == null ? 0 : jn.length; ++so < Yo; )
        if (!go(jn[so], so, jn))
          return !1;
      return !0;
    }
    function nu(jn, go) {
      for (var so = -1, Yo = jn == null ? 0 : jn.length, ka = 0, za = []; ++so < Yo; ) {
        var Ls = jn[so];
        go(Ls, so, jn) && (za[ka++] = Ls);
      }
      return za;
    }
    function Zu(jn, go) {
      var so = jn == null ? 0 : jn.length;
      return !!so && Xu(jn, go, 0) > -1;
    }
    function bl(jn, go, so) {
      for (var Yo = -1, ka = jn == null ? 0 : jn.length; ++Yo < ka; )
        if (so(go, jn[Yo]))
          return !0;
      return !1;
    }
    function Ms(jn, go) {
      for (var so = -1, Yo = jn == null ? 0 : jn.length, ka = Array(Yo); ++so < Yo; )
        ka[so] = go(jn[so], so, jn);
      return ka;
    }
    function Sc(jn, go) {
      for (var so = -1, Yo = go.length, ka = jn.length; ++so < Yo; )
        jn[ka + so] = go[so];
      return jn;
    }
    function Tf(jn, go, so, Yo) {
      var ka = -1, za = jn == null ? 0 : jn.length;
      for (Yo && za && (so = jn[++ka]); ++ka < za; )
        so = go(so, jn[ka], ka, jn);
      return so;
    }
    function Md(jn, go, so, Yo) {
      var ka = jn == null ? 0 : jn.length;
      for (Yo && ka && (so = jn[--ka]); ka--; )
        so = go(so, jn[ka], ka, jn);
      return so;
    }
    function Cp(jn, go) {
      for (var so = -1, Yo = jn == null ? 0 : jn.length; ++so < Yo; )
        if (go(jn[so], so, jn))
          return !0;
      return !1;
    }
    var F0 = Ap("length");
    function Sd(jn) {
      return jn.split("");
    }
    function Ed(jn) {
      return jn.match(en) || [];
    }
    function Tp(jn, go, so) {
      var Yo;
      return so(jn, function(ka, za, Ls) {
        if (go(ka, za, Ls))
          return Yo = za, !1;
      }), Yo;
    }
    function Ol(jn, go, so, Yo) {
      for (var ka = jn.length, za = so + (Yo ? 1 : -1); Yo ? za-- : ++za < ka; )
        if (go(jn[za], za, jn))
          return za;
      return -1;
    }
    function Xu(jn, go, so) {
      return go === go ? zh(jn, go, so) : Ol(jn, Ec, so);
    }
    function Af(jn, go, so, Yo) {
      for (var ka = so - 1, za = jn.length; ++ka < za; )
        if (Yo(jn[ka], go))
          return ka;
      return -1;
    }
    function Ec(jn) {
      return jn !== jn;
    }
    function $m(jn, go) {
      var so = jn == null ? 0 : jn.length;
      return so ? aa(jn, go) / so : Pe;
    }
    function Ap(jn) {
      return function(go) {
        return go == null ? ie : go[jn];
      };
    }
    function kp(jn) {
      return function(go) {
        return jn == null ? ie : jn[go];
      };
    }
    function Lp(jn, go, so, Yo, ka) {
      return ka(jn, function(za, Ls, _s) {
        so = Yo ? (Yo = !1, za) : go(so, za, Ls, _s);
      }), so;
    }
    function Ph(jn, go) {
      var so = jn.length;
      for (jn.sort(go); so--; )
        jn[so] = jn[so].value;
      return jn;
    }
    function aa(jn, go) {
      for (var so, Yo = -1, ka = jn.length; ++Yo < ka; ) {
        var za = go(jn[Yo]);
        za !== ie && (so = so === ie ? za : so + za);
      }
      return so;
    }
    function Oo(jn, go) {
      for (var so = -1, Yo = Array(jn); ++so < jn; )
        Yo[so] = go(so);
      return Yo;
    }
    function kf(jn, go) {
      return Ms(go, function(so) {
        return [so, jn[so]];
      });
    }
    function ta(jn) {
      return jn && jn.slice(0, Rm(jn) + 1).replace(an, "");
    }
    function xl(jn) {
      return function(go) {
        return jn(go);
      };
    }
    function Cc(jn, go) {
      return Ms(go, function(so) {
        return jn[so];
      });
    }
    function Uo(jn, go) {
      return jn.has(go);
    }
    function Lf(jn, go) {
      for (var so = -1, Yo = jn.length; ++so < Yo && Xu(go, jn[so], 0) > -1; )
        ;
      return so;
    }
    function Cd(jn, go) {
      for (var so = jn.length; so-- && Xu(go, jn[so], 0) > -1; )
        ;
      return so;
    }
    function Dh(jn, go) {
      for (var so = jn.length, Yo = 0; so--; )
        jn[so] === go && ++Yo;
      return Yo;
    }
    var Oh = kp(Hu), Td = kp(dl);
    function ll(jn) {
      return "\\" + Bm[jn];
    }
    function Fl(jn, go) {
      return jn == null ? ie : jn[go];
    }
    function ou(jn) {
      return Ta.test(jn);
    }
    function vo(jn) {
      return Dl.test(jn);
    }
    function If(jn) {
      for (var go, so = []; !(go = jn.next()).done; )
        so.push(go.value);
      return so;
    }
    function Tc(jn) {
      var go = -1, so = Array(jn.size);
      return jn.forEach(function(Yo, ka) {
        so[++go] = [ka, Yo];
      }), so;
    }
    function Js(jn, go) {
      return function(so) {
        return jn(go(so));
      };
    }
    function au(jn, go) {
      for (var so = -1, Yo = jn.length, ka = 0, za = []; ++so < Yo; ) {
        var Ls = jn[so];
        (Ls === go || Ls === or) && (jn[so] = or, za[ka++] = so);
      }
      return za;
    }
    function Ku(jn) {
      var go = -1, so = Array(jn.size);
      return jn.forEach(function(Yo) {
        so[++go] = Yo;
      }), so;
    }
    function su(jn) {
      var go = -1, so = Array(jn.size);
      return jn.forEach(function(Yo) {
        so[++go] = [Yo, Yo];
      }), so;
    }
    function zh(jn, go, so) {
      for (var Yo = so - 1, ka = jn.length; ++Yo < ka; )
        if (jn[Yo] === go)
          return Yo;
      return -1;
    }
    function Mu(jn, go, so) {
      for (var Yo = so + 1; Yo--; )
        if (jn[Yo] === go)
          return Yo;
      return Yo;
    }
    function Ac(jn) {
      return ou(jn) ? Ip(jn) : F0(jn);
    }
    function wl(jn) {
      return ou(jn) ? Pm(jn) : Sd(jn);
    }
    function Rm(jn) {
      for (var go = jn.length; go-- && Ui.test(jn.charAt(go)); )
        ;
      return go;
    }
    var N0 = kp(ts);
    function Ip(jn) {
      for (var go = To.lastIndex = 0; To.test(jn); )
        ++go;
      return go;
    }
    function Pm(jn) {
      return jn.match(To) || [];
    }
    function Dm(jn) {
      return jn.match(Pa) || [];
    }
    var Om = function jn(go) {
      go = go == null ? Rs : Nl.defaults(Rs.Object(), go, Nl.pick(Rs, Gu));
      var so = go.Array, Yo = go.Date, ka = go.Error, za = go.Function, Ls = go.Math, _s = go.Object, Ad = go.RegExp, Bf = go.String, Ml = go.TypeError, Yu = so.prototype, Su = za.prototype, lu = _s.prototype, Fh = go["__core-js_shared__"], Uc = Su.toString, rs = lu.hasOwnProperty, Ju = 0, Eu = function() {
        var dr = /[^.]+$/.exec(Fh && Fh.keys && Fh.keys.IE_PROTO || "");
        return dr ? "Symbol(src)_1." + dr : "";
      }(), fc = lu.toString, kd = Uc.call(_s), $f = Rs._, Bp = Ad(
        "^" + Uc.call(rs).replace(Ai, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), kc = Ps ? go.Buffer : ie, ca = go.Symbol, Cu = go.Uint8Array, $p = kc ? kc.allocUnsafe : ie, Ld = Js(_s.getPrototypeOf, _s), Rf = _s.create, Qu = lu.propertyIsEnumerable, Wa = Yu.splice, zm = ca ? ca.isConcatSpreadable : ie, Id = ca ? ca.iterator : ie, eh = ca ? ca.toStringTag : ie, Nh = function() {
        try {
          var dr = cl(_s, "defineProperty");
          return dr({}, "", {}), dr;
        } catch {
        }
      }(), Rp = go.clearTimeout !== Rs.clearTimeout && go.clearTimeout, Pp = Yo && Yo.now !== Rs.Date.now && Yo.now, Dp = go.setTimeout !== Rs.setTimeout && go.setTimeout, Bd = Ls.ceil, $d = Ls.floor, Op = _s.getOwnPropertySymbols, Rd = kc ? kc.isBuffer : ie, Vh = go.isFinite, Fm = Yu.join, Vl = Js(_s.keys, _s), Os = Ls.max, Qs = Ls.min, Pf = Yo.now, zp = go.parseInt, Df = Ls.random, Of = Yu.reverse, Pd = cl(go, "DataView"), th = cl(go, "Map"), Uh = cl(go, "Promise"), ih = cl(go, "Set"), jh = cl(go, "WeakMap"), jc = cl(_s, "create"), zf = jh && new jh(), qh = {}, V0 = Ki(Pd), U0 = Ki(th), j0 = Ki(Uh), Fp = Ki(ih), Np = Ki(jh), nh = ca ? ca.prototype : ie, Gh = nh ? nh.valueOf : ie, oh = nh ? nh.toString : ie;
      function Zi(dr) {
        if (js(dr) && !$a(dr) && !(dr instanceof Da)) {
          if (dr instanceof el)
            return dr;
          if (rs.call(dr, "__wrapped__"))
            return Xi(dr);
        }
        return new el(dr);
      }
      var Tu = function() {
        function dr() {
        }
        return function(Cr) {
          if (!$s(Cr))
            return {};
          if (Rf)
            return Rf(Cr);
          dr.prototype = Cr;
          var Ur = new dr();
          return dr.prototype = ie, Ur;
        };
      }();
      function Hh() {
      }
      function el(dr, Cr) {
        this.__wrapped__ = dr, this.__actions__ = [], this.__chain__ = !!Cr, this.__index__ = 0, this.__values__ = ie;
      }
      Zi.templateSettings = {
        escape: Qn,
        evaluate: co,
        interpolate: kn,
        variable: "",
        imports: {
          _: Zi
        }
      }, Zi.prototype = Hh.prototype, Zi.prototype.constructor = Zi, el.prototype = Tu(Hh.prototype), el.prototype.constructor = el;
      function Da(dr) {
        this.__wrapped__ = dr, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ur, this.__views__ = [];
      }
      function Vp() {
        var dr = new Da(this.__wrapped__);
        return dr.__actions__ = $l(this.__actions__), dr.__dir__ = this.__dir__, dr.__filtered__ = this.__filtered__, dr.__iteratees__ = $l(this.__iteratees__), dr.__takeCount__ = this.__takeCount__, dr.__views__ = $l(this.__views__), dr;
      }
      function Au() {
        if (this.__filtered__) {
          var dr = new Da(this);
          dr.__dir__ = -1, dr.__filtered__ = !0;
        } else
          dr = this.clone(), dr.__dir__ *= -1;
        return dr;
      }
      function Dd() {
        var dr = this.__wrapped__.value(), Cr = this.__dir__, Ur = $a(dr), ui = Cr < 0, $i = Ur ? dr.length : 0, Qi = Qp(0, $i, this.__views__), En = Qi.start, Dn = Qi.end, Zn = Dn - En, wo = ui ? Dn : En - 1, So = this.__iteratees__, ko = So.length, Vo = 0, na = Qs(Zn, this.__takeCount__);
        if (!Ur || !ui && $i == Zn && na == Zn)
          return tp(dr, this.__actions__);
        var Sa = [];
        e:
          for (; Zn-- && Vo < na; ) {
            wo += Cr;
            for (var Ua = -1, ya = dr[wo]; ++Ua < ko; ) {
              var Qa = So[Ua], ns = Qa.iteratee, Dc = Qa.type, Gl = ns(ya);
              if (Dc == tr)
                ya = Gl;
              else if (!Gl) {
                if (Dc == Ue)
                  continue e;
                break e;
              }
            }
            Sa[Vo++] = ya;
          }
        return Sa;
      }
      Da.prototype = Tu(Hh.prototype), Da.prototype.constructor = Da;
      function pc(dr) {
        var Cr = -1, Ur = dr == null ? 0 : dr.length;
        for (this.clear(); ++Cr < Ur; ) {
          var ui = dr[Cr];
          this.set(ui[0], ui[1]);
        }
      }
      function Nm() {
        this.__data__ = jc ? jc(null) : {}, this.size = 0;
      }
      function Vm(dr) {
        var Cr = this.has(dr) && delete this.__data__[dr];
        return this.size -= Cr ? 1 : 0, Cr;
      }
      function Ff(dr) {
        var Cr = this.__data__;
        if (jc) {
          var Ur = Cr[dr];
          return Ur === rr ? ie : Ur;
        }
        return rs.call(Cr, dr) ? Cr[dr] : ie;
      }
      function Nf(dr) {
        var Cr = this.__data__;
        return jc ? Cr[dr] !== ie : rs.call(Cr, dr);
      }
      function q0(dr, Cr) {
        var Ur = this.__data__;
        return this.size += this.has(dr) ? 0 : 1, Ur[dr] = jc && Cr === ie ? rr : Cr, this;
      }
      pc.prototype.clear = Nm, pc.prototype.delete = Vm, pc.prototype.get = Ff, pc.prototype.has = Nf, pc.prototype.set = q0;
      function qc(dr) {
        var Cr = -1, Ur = dr == null ? 0 : dr.length;
        for (this.clear(); ++Cr < Ur; ) {
          var ui = dr[Cr];
          this.set(ui[0], ui[1]);
        }
      }
      function Od() {
        this.__data__ = [], this.size = 0;
      }
      function Um(dr) {
        var Cr = this.__data__, Ur = Vd(Cr, dr);
        if (Ur < 0)
          return !1;
        var ui = Cr.length - 1;
        return Ur == ui ? Cr.pop() : Wa.call(Cr, Ur, 1), --this.size, !0;
      }
      function jm(dr) {
        var Cr = this.__data__, Ur = Vd(Cr, dr);
        return Ur < 0 ? ie : Cr[Ur][1];
      }
      function zd(dr) {
        return Vd(this.__data__, dr) > -1;
      }
      function G0(dr, Cr) {
        var Ur = this.__data__, ui = Vd(Ur, dr);
        return ui < 0 ? (++this.size, Ur.push([dr, Cr])) : Ur[ui][1] = Cr, this;
      }
      qc.prototype.clear = Od, qc.prototype.delete = Um, qc.prototype.get = jm, qc.prototype.has = zd, qc.prototype.set = G0;
      function mc(dr) {
        var Cr = -1, Ur = dr == null ? 0 : dr.length;
        for (this.clear(); ++Cr < Ur; ) {
          var ui = dr[Cr];
          this.set(ui[0], ui[1]);
        }
      }
      function Up() {
        this.size = 0, this.__data__ = {
          hash: new pc(),
          map: new (th || qc)(),
          string: new pc()
        };
      }
      function Fd(dr) {
        var Cr = Yc(this, dr).delete(dr);
        return this.size -= Cr ? 1 : 0, Cr;
      }
      function Vf(dr) {
        return Yc(this, dr).get(dr);
      }
      function Wh(dr) {
        return Yc(this, dr).has(dr);
      }
      function qm(dr, Cr) {
        var Ur = Yc(this, dr), ui = Ur.size;
        return Ur.set(dr, Cr), this.size += Ur.size == ui ? 0 : 1, this;
      }
      mc.prototype.clear = Up, mc.prototype.delete = Fd, mc.prototype.get = Vf, mc.prototype.has = Wh, mc.prototype.set = qm;
      function Gc(dr) {
        var Cr = -1, Ur = dr == null ? 0 : dr.length;
        for (this.__data__ = new mc(); ++Cr < Ur; )
          this.add(dr[Cr]);
      }
      function Uf(dr) {
        return this.__data__.set(dr, rr), this;
      }
      function jf(dr) {
        return this.__data__.has(dr);
      }
      Gc.prototype.add = Gc.prototype.push = Uf, Gc.prototype.has = jf;
      function gc(dr) {
        var Cr = this.__data__ = new qc(dr);
        this.size = Cr.size;
      }
      function H0() {
        this.__data__ = new qc(), this.size = 0;
      }
      function ah(dr) {
        var Cr = this.__data__, Ur = Cr.delete(dr);
        return this.size = Cr.size, Ur;
      }
      function Nd(dr) {
        return this.__data__.get(dr);
      }
      function Ao(dr) {
        return this.__data__.has(dr);
      }
      function Gm(dr, Cr) {
        var Ur = this.__data__;
        if (Ur instanceof qc) {
          var ui = Ur.__data__;
          if (!th || ui.length < $e - 1)
            return ui.push([dr, Cr]), this.size = ++Ur.size, this;
          Ur = this.__data__ = new mc(ui);
        }
        return Ur.set(dr, Cr), this.size = Ur.size, this;
      }
      gc.prototype.clear = H0, gc.prototype.delete = ah, gc.prototype.get = Nd, gc.prototype.has = Ao, gc.prototype.set = Gm;
      function ku(dr, Cr) {
        var Ur = $a(dr), ui = !Ur && dd(dr), $i = !Ur && !ui && wh(dr), Qi = !Ur && !ui && !$i && mf(dr), En = Ur || ui || $i || Qi, Dn = En ? Oo(dr.length, Bf) : [], Zn = Dn.length;
        for (var wo in dr)
          (Cr || rs.call(dr, wo)) && !(En && (wo == "length" || $i && (wo == "offset" || wo == "parent") || Qi && (wo == "buffer" || wo == "byteLength" || wo == "byteOffset") || As(wo, Zn))) && Dn.push(wo);
        return Dn;
      }
      function Lu(dr) {
        var Cr = dr.length;
        return Cr ? dr[Xd(0, Cr - 1)] : ie;
      }
      function lh(dr, Cr) {
        return Ii($l(dr), Sl(Cr, 0, dr.length));
      }
      function Do(dr) {
        return Ii($l(dr));
      }
      function Zh(dr, Cr, Ur) {
        (Ur !== ie && !bc(dr[Cr], Ur) || Ur === ie && !(Cr in dr)) && Hc(dr, Cr, Ur);
      }
      function Xh(dr, Cr, Ur) {
        var ui = dr[Cr];
        (!(rs.call(dr, Cr) && bc(ui, Ur)) || Ur === ie && !(Cr in dr)) && Hc(dr, Cr, Ur);
      }
      function Vd(dr, Cr) {
        for (var Ur = dr.length; Ur--; )
          if (bc(dr[Ur][0], Cr))
            return Ur;
        return -1;
      }
      function qf(dr, Cr, Ur, ui) {
        return Wc(dr, function($i, Qi, En) {
          Cr(ui, $i, Ur($i), En);
        }), ui;
      }
      function Ud(dr, Cr) {
        return dr && Bc(Cr, vl(Cr), dr);
      }
      function Gf(dr, Cr) {
        return dr && Bc(Cr, sc(Cr), dr);
      }
      function Hc(dr, Cr, Ur) {
        Cr == "__proto__" && Nh ? Nh(dr, Cr, {
          configurable: !0,
          enumerable: !0,
          value: Ur,
          writable: !0
        }) : dr[Cr] = Ur;
      }
      function jp(dr, Cr) {
        for (var Ur = -1, ui = Cr.length, $i = so(ui), Qi = dr == null; ++Ur < ui; )
          $i[Ur] = Qi ? ie : h1(dr, Cr[Ur]);
        return $i;
      }
      function Sl(dr, Cr, Ur) {
        return dr === dr && (Ur !== ie && (dr = dr <= Ur ? dr : Ur), Cr !== ie && (dr = dr >= Cr ? dr : Cr)), dr;
      }
      function Ul(dr, Cr, Ur, ui, $i, Qi) {
        var En, Dn = Cr & _r, Zn = Cr & Lr, wo = Cr & Ir;
        if (Ur && (En = $i ? Ur(dr, ui, $i, Qi) : Ur(dr)), En !== ie)
          return En;
        if (!$s(dr))
          return dr;
        var So = $a(dr);
        if (So) {
          if (En = r0(dr), !Dn)
            return $l(dr, En);
        } else {
          var ko = zs(dr), Vo = ko == hi || ko == Oi;
          if (wh(dr))
            return Xp(dr, Dn);
          if (ko == $n || ko == Ti || Vo && !$i) {
            if (En = Zn || Vo ? {} : up(dr), !Dn)
              return Zn ? Z0(dr, Gf(En, dr)) : Jp(dr, Ud(En, dr));
          } else {
            if (!es[ko])
              return $i ? dr : {};
            En = uf(dr, ko, Dn);
          }
        }
        Qi || (Qi = new gc());
        var na = Qi.get(dr);
        if (na)
          return na;
        Qi.set(dr, En), pm(dr) ? dr.forEach(function(ya) {
          En.add(Ul(ya, Cr, Ur, ya, dr, Qi));
        }) : f0(dr) && dr.forEach(function(ya, Qa) {
          En.set(Qa, Ul(ya, Cr, Ur, Qa, dr, Qi));
        });
        var Sa = wo ? Zn ? cp : cd : Zn ? sc : vl, Ua = So ? ie : Sa(dr);
        return al(Ua || dr, function(ya, Qa) {
          Ua && (Qa = ya, ya = dr[Qa]), Xh(En, Qa, Ul(ya, Cr, Ur, Qa, dr, Qi));
        }), En;
      }
      function qp(dr) {
        var Cr = vl(dr);
        return function(Ur) {
          return jd(Ur, dr, Cr);
        };
      }
      function jd(dr, Cr, Ur) {
        var ui = Ur.length;
        if (dr == null)
          return !ui;
        for (dr = _s(dr); ui--; ) {
          var $i = Ur[ui], Qi = Cr[$i], En = dr[$i];
          if (En === ie && !($i in dr) || !Qi(En))
            return !1;
        }
        return !0;
      }
      function kl(dr, Cr, Ur) {
        if (typeof dr != "function")
          throw new Ml(Ze);
        return bi(function() {
          dr.apply(ie, Ur);
        }, Cr);
      }
      function Ll(dr, Cr, Ur, ui) {
        var $i = -1, Qi = Zu, En = !0, Dn = dr.length, Zn = [], wo = Cr.length;
        if (!Dn)
          return Zn;
        Ur && (Cr = Ms(Cr, xl(Ur))), ui ? (Qi = bl, En = !1) : Cr.length >= $e && (Qi = Uo, En = !1, Cr = new Gc(Cr));
        e:
          for (; ++$i < Dn; ) {
            var So = dr[$i], ko = Ur == null ? So : Ur(So);
            if (So = ui || So !== 0 ? So : 0, En && ko === ko) {
              for (var Vo = wo; Vo--; )
                if (Cr[Vo] === ko)
                  continue e;
              Zn.push(So);
            } else
              Qi(Cr, ko, ui) || Zn.push(So);
          }
        return Zn;
      }
      var Wc = e0(El), uh = e0(Wf, !0);
      function Hf(dr, Cr) {
        var Ur = !0;
        return Wc(dr, function(ui, $i, Qi) {
          return Ur = !!Cr(ui, $i, Qi), Ur;
        }), Ur;
      }
      function Yh(dr, Cr, Ur) {
        for (var ui = -1, $i = dr.length; ++ui < $i; ) {
          var Qi = dr[ui], En = Cr(Qi);
          if (En != null && (Dn === ie ? En === En && !xc(En) : Ur(En, Dn)))
            var Dn = En, Zn = Qi;
        }
        return Zn;
      }
      function Hm(dr, Cr, Ur, ui) {
        var $i = dr.length;
        for (Ur = Va(Ur), Ur < 0 && (Ur = -Ur > $i ? 0 : $i + Ur), ui = ui === ie || ui > $i ? $i : Va(ui), ui < 0 && (ui += $i), ui = Ur > ui ? 0 : l1(ui); Ur < ui; )
          dr[Ur++] = Cr;
        return dr;
      }
      function Il(dr, Cr) {
        var Ur = [];
        return Wc(dr, function(ui, $i, Qi) {
          Cr(ui, $i, Qi) && Ur.push(ui);
        }), Ur;
      }
      function wa(dr, Cr, Ur, ui, $i) {
        var Qi = -1, En = dr.length;
        for (Ur || (Ur = gu), $i || ($i = []); ++Qi < En; ) {
          var Dn = dr[Qi];
          Cr > 0 && Ur(Dn) ? Cr > 1 ? wa(Dn, Cr - 1, Ur, ui, $i) : Sc($i, Dn) : ui || ($i[$i.length] = Dn);
        }
        return $i;
      }
      var hh = np(), fh = np(!0);
      function El(dr, Cr) {
        return dr && hh(dr, Cr, vl);
      }
      function Wf(dr, Cr) {
        return dr && fh(dr, Cr, vl);
      }
      function qd(dr, Cr) {
        return nu(Cr, function(Ur) {
          return Mh(dr[Ur]);
        });
      }
      function ph(dr, Cr) {
        Cr = Ic(Cr, dr);
        for (var Ur = 0, ui = Cr.length; dr != null && Ur < ui; )
          dr = dr[zi(Cr[Ur++])];
        return Ur && Ur == ui ? dr : ie;
      }
      function mh(dr, Cr, Ur) {
        var ui = Cr(dr);
        return $a(dr) ? ui : Sc(ui, Ur(dr));
      }
      function Zs(dr) {
        return dr == null ? dr === ie ? vn : sn : eh && eh in _s(dr) ? _c(dr) : $r(dr);
      }
      function lo(dr, Cr) {
        return dr > Cr;
      }
      function Mo(dr, Cr) {
        return dr != null && rs.call(dr, Cr);
      }
      function Jh(dr, Cr) {
        return dr != null && Cr in _s(dr);
      }
      function ys(dr, Cr, Ur) {
        return dr >= Qs(Cr, Ur) && dr < Os(Cr, Ur);
      }
      function Bn(dr, Cr, Ur) {
        for (var ui = Ur ? bl : Zu, $i = dr[0].length, Qi = dr.length, En = Qi, Dn = so(Qi), Zn = 1 / 0, wo = []; En--; ) {
          var So = dr[En];
          En && Cr && (So = Ms(So, xl(Cr))), Zn = Qs(So.length, Zn), Dn[En] = !Ur && (Cr || $i >= 120 && So.length >= 120) ? new Gc(En && So) : ie;
        }
        So = dr[0];
        var ko = -1, Vo = Dn[0];
        e:
          for (; ++ko < $i && wo.length < Zn; ) {
            var na = So[ko], Sa = Cr ? Cr(na) : na;
            if (na = Ur || na !== 0 ? na : 0, !(Vo ? Uo(Vo, Sa) : ui(wo, Sa, Ur))) {
              for (En = Qi; --En; ) {
                var Ua = Dn[En];
                if (!(Ua ? Uo(Ua, Sa) : ui(dr[En], Sa, Ur)))
                  continue e;
              }
              Vo && Vo.push(Sa), wo.push(na);
            }
          }
        return wo;
      }
      function Wm(dr, Cr, Ur, ui) {
        return El(dr, function($i, Qi, En) {
          Cr(ui, Ur($i), Qi, En);
        }), ui;
      }
      function Iu(dr, Cr, Ur) {
        Cr = Ic(Cr, dr), dr = Or(dr, Cr);
        var ui = dr == null ? dr : dr[zi(ia(Cr))];
        return ui == null ? ie : Ds(ui, dr, Ur);
      }
      function Zf(dr) {
        return js(dr) && Zs(dr) == Ti;
      }
      function Zm(dr) {
        return js(dr) && Zs(dr) == Xn;
      }
      function Xm(dr) {
        return js(dr) && Zs(dr) == ei;
      }
      function Qh(dr, Cr, Ur, ui, $i) {
        return dr === Cr ? !0 : dr == null || Cr == null || !js(dr) && !js(Cr) ? dr !== dr && Cr !== Cr : ed(dr, Cr, Ur, ui, Qh, $i);
      }
      function ed(dr, Cr, Ur, ui, $i, Qi) {
        var En = $a(dr), Dn = $a(Cr), Zn = En ? wi : zs(dr), wo = Dn ? wi : zs(Cr);
        Zn = Zn == Ti ? $n : Zn, wo = wo == Ti ? $n : wo;
        var So = Zn == $n, ko = wo == $n, Vo = Zn == wo;
        if (Vo && wh(dr)) {
          if (!wh(Cr))
            return !1;
          En = !0, So = !1;
        }
        if (Vo && !So)
          return Qi || (Qi = new gc()), En || mf(dr) ? du(dr, Cr, Ur, ui, $i, Qi) : lp(dr, Cr, Zn, Ur, ui, $i, Qi);
        if (!(Ur & Ar)) {
          var na = So && rs.call(dr, "__wrapped__"), Sa = ko && rs.call(Cr, "__wrapped__");
          if (na || Sa) {
            var Ua = na ? dr.value() : dr, ya = Sa ? Cr.value() : Cr;
            return Qi || (Qi = new gc()), $i(Ua, ya, Ur, ui, Qi);
          }
        }
        return Vo ? (Qi || (Qi = new gc()), X0(dr, Cr, Ur, ui, $i, Qi)) : !1;
      }
      function W0(dr) {
        return js(dr) && zs(dr) == qi;
      }
      function Bu(dr, Cr, Ur, ui) {
        var $i = Ur.length, Qi = $i, En = !ui;
        if (dr == null)
          return !Qi;
        for (dr = _s(dr); $i--; ) {
          var Dn = Ur[$i];
          if (En && Dn[2] ? Dn[1] !== dr[Dn[0]] : !(Dn[0] in dr))
            return !1;
        }
        for (; ++$i < Qi; ) {
          Dn = Ur[$i];
          var Zn = Dn[0], wo = dr[Zn], So = Dn[1];
          if (En && Dn[2]) {
            if (wo === ie && !(Zn in dr))
              return !1;
          } else {
            var ko = new gc();
            if (ui)
              var Vo = ui(wo, So, Zn, dr, Cr, ko);
            if (!(Vo === ie ? Qh(So, wo, Ar | Rr, ui, ko) : Vo))
              return !1;
          }
        }
        return !0;
      }
      function Xf(dr) {
        if (!$s(dr) || qe(dr))
          return !1;
        var Cr = Mh(dr) ? Bp : Bo;
        return Cr.test(Ki(dr));
      }
      function Gd(dr) {
        return js(dr) && Zs(dr) == Kn;
      }
      function td(dr) {
        return js(dr) && zs(dr) == In;
      }
      function Km(dr) {
        return js(dr) && dm(dr.length) && !!vs[Zs(dr)];
      }
      function Gp(dr) {
        return typeof dr == "function" ? dr : dr == null ? lc : typeof dr == "object" ? $a(dr) ? Cl(dr[0], dr[1]) : Ym(dr) : eu(dr);
      }
      function Ql(dr) {
        if (!ke(dr))
          return Vl(dr);
        var Cr = [];
        for (var Ur in _s(dr))
          rs.call(dr, Ur) && Ur != "constructor" && Cr.push(Ur);
        return Cr;
      }
      function Hd(dr) {
        if (!$s(dr))
          return Tr(dr);
        var Cr = ke(dr), Ur = [];
        for (var ui in dr)
          ui == "constructor" && (Cr || !rs.call(dr, ui)) || Ur.push(ui);
        return Ur;
      }
      function fl(dr, Cr) {
        return dr < Cr;
      }
      function Hp(dr, Cr) {
        var Ur = -1, ui = ac(dr) ? so(dr.length) : [];
        return Wc(dr, function($i, Qi, En) {
          ui[++Ur] = Cr($i, Qi, En);
        }), ui;
      }
      function Ym(dr) {
        var Cr = cf(dr);
        return Cr.length == 1 && Cr[0][2] ? ir(Cr[0][0], Cr[0][1]) : function(Ur) {
          return Ur === dr || Bu(Ur, dr, Cr);
        };
      }
      function Cl(dr, Cr) {
        return Fs(dr) && He(Cr) ? ir(zi(dr), Cr) : function(Ur) {
          var ui = h1(Ur, dr);
          return ui === ie && ui === Cr ? d1(Ur, dr) : Qh(Cr, ui, Ar | Rr);
        };
      }
      function Kf(dr, Cr, Ur, ui, $i) {
        dr !== Cr && hh(Cr, function(Qi, En) {
          if ($i || ($i = new gc()), $s(Qi))
            Wd(dr, Cr, En, Ur, Kf, ui, $i);
          else {
            var Dn = ui ? ui(qr(dr, En), Qi, En + "", dr, Cr, $i) : ie;
            Dn === ie && (Dn = Qi), Zh(dr, En, Dn);
          }
        }, sc);
      }
      function Wd(dr, Cr, Ur, ui, $i, Qi, En) {
        var Dn = qr(dr, Ur), Zn = qr(Cr, Ur), wo = En.get(Zn);
        if (wo) {
          Zh(dr, Ur, wo);
          return;
        }
        var So = Qi ? Qi(Dn, Zn, Ur + "", dr, Cr, En) : ie, ko = So === ie;
        if (ko) {
          var Vo = $a(Zn), na = !Vo && wh(Zn), Sa = !Vo && !na && mf(Zn);
          So = Zn, Vo || na || Sa ? $a(Dn) ? So = Dn : Bs(Dn) ? So = $l(Dn) : na ? (ko = !1, So = Xp(Zn, !0)) : Sa ? (ko = !1, So = ad(Zn, !0)) : So = [] : Qc(Zn) || dd(Zn) ? (So = Dn, dd(Dn) ? So = c1(Dn) : (!$s(Dn) || Mh(Dn)) && (So = up(Zn))) : ko = !1;
        }
        ko && (En.set(Zn, So), $i(So, Zn, ui, Qi, En), En.delete(Zn)), Zh(dr, Ur, So);
      }
      function Ka(dr, Cr) {
        var Ur = dr.length;
        if (!!Ur)
          return Cr += Cr < 0 ? Ur : 0, As(Cr, Ur) ? dr[Cr] : ie;
      }
      function La(dr, Cr, Ur) {
        Cr.length ? Cr = Ms(Cr, function(Qi) {
          return $a(Qi) ? function(En) {
            return ph(En, Qi.length === 1 ? Qi[0] : Qi);
          } : Qi;
        }) : Cr = [lc];
        var ui = -1;
        Cr = Ms(Cr, xl(pa()));
        var $i = Hp(dr, function(Qi, En, Dn) {
          var Zn = Ms(Cr, function(wo) {
            return wo(Qi);
          });
          return { criteria: Zn, index: ++ui, value: Qi };
        });
        return Ph($i, function(Qi, En) {
          return rf(Qi, En, Ur);
        });
      }
      function Zd(dr, Cr) {
        return Zc(dr, Cr, function(Ur, ui) {
          return d1(dr, ui);
        });
      }
      function Zc(dr, Cr, Ur) {
        for (var ui = -1, $i = Cr.length, Qi = {}; ++ui < $i; ) {
          var En = Cr[ui], Dn = ph(dr, En);
          Ur(Dn, En) && gh(Qi, Ic(En, dr), Dn);
        }
        return Qi;
      }
      function rd(dr) {
        return function(Cr) {
          return ph(Cr, dr);
        };
      }
      function $u(dr, Cr, Ur, ui) {
        var $i = ui ? Af : Xu, Qi = -1, En = Cr.length, Dn = dr;
        for (dr === Cr && (Cr = $l(Cr)), Ur && (Dn = Ms(dr, xl(Ur))); ++Qi < En; )
          for (var Zn = 0, wo = Cr[Qi], So = Ur ? Ur(wo) : wo; (Zn = $i(Dn, So, Zn, ui)) > -1; )
            Dn !== dr && Wa.call(Dn, Zn, 1), Wa.call(dr, Zn, 1);
        return dr;
      }
      function tc(dr, Cr) {
        for (var Ur = dr ? Cr.length : 0, ui = Ur - 1; Ur--; ) {
          var $i = Cr[Ur];
          if (Ur == ui || $i !== Qi) {
            var Qi = $i;
            As($i) ? Wa.call(dr, $i, 1) : Kc(dr, $i);
          }
        }
        return dr;
      }
      function Xd(dr, Cr) {
        return dr + $d(Df() * (Cr - dr + 1));
      }
      function cu(dr, Cr, Ur, ui) {
        for (var $i = -1, Qi = Os(Bd((Cr - dr) / (Ur || 1)), 0), En = so(Qi); Qi--; )
          En[ui ? Qi : ++$i] = dr, dr += Ur;
        return En;
      }
      function Xc(dr, Cr) {
        var Ur = "";
        if (!dr || Cr < 1 || Cr > br)
          return Ur;
        do
          Cr % 2 && (Ur += dr), Cr = $d(Cr / 2), Cr && (dr += dr);
        while (Cr);
        return Ur;
      }
      function Ia(dr, Cr) {
        return fi(Dr(dr, Cr, lc), dr + "");
      }
      function Yf(dr) {
        return Lu(gf(dr));
      }
      function Jf(dr, Cr) {
        var Ur = gf(dr);
        return Ii(Ur, Sl(Cr, 0, Ur.length));
      }
      function gh(dr, Cr, Ur, ui) {
        if (!$s(dr))
          return dr;
        Cr = Ic(Cr, dr);
        for (var $i = -1, Qi = Cr.length, En = Qi - 1, Dn = dr; Dn != null && ++$i < Qi; ) {
          var Zn = zi(Cr[$i]), wo = Ur;
          if (Zn === "__proto__" || Zn === "constructor" || Zn === "prototype")
            return dr;
          if ($i != En) {
            var So = Dn[Zn];
            wo = ui ? ui(So, Zn, Dn) : ie, wo === ie && (wo = $s(So) ? So : As(Cr[$i + 1]) ? [] : {});
          }
          Xh(Dn, Zn, wo), Dn = Dn[Zn];
        }
        return dr;
      }
      var Qf = zf ? function(dr, Cr) {
        return zf.set(dr, Cr), dr;
      } : lc, Wp = Nh ? function(dr, Cr) {
        return Nh(dr, "toString", {
          configurable: !0,
          enumerable: !1,
          value: _0(Cr),
          writable: !0
        });
      } : lc;
      function Ru(dr) {
        return Ii(gf(dr));
      }
      function jl(dr, Cr, Ur) {
        var ui = -1, $i = dr.length;
        Cr < 0 && (Cr = -Cr > $i ? 0 : $i + Cr), Ur = Ur > $i ? $i : Ur, Ur < 0 && (Ur += $i), $i = Cr > Ur ? 0 : Ur - Cr >>> 0, Cr >>>= 0;
        for (var Qi = so($i); ++ui < $i; )
          Qi[ui] = dr[ui + Cr];
        return Qi;
      }
      function Kd(dr, Cr) {
        var Ur;
        return Wc(dr, function(ui, $i, Qi) {
          return Ur = Cr(ui, $i, Qi), !Ur;
        }), !!Ur;
      }
      function id(dr, Cr, Ur) {
        var ui = 0, $i = dr == null ? ui : dr.length;
        if (typeof Cr == "number" && Cr === Cr && $i <= Hr) {
          for (; ui < $i; ) {
            var Qi = ui + $i >>> 1, En = dr[Qi];
            En !== null && !xc(En) && (Ur ? En <= Cr : En < Cr) ? ui = Qi + 1 : $i = Qi;
          }
          return $i;
        }
        return Yd(dr, Cr, lc, Ur);
      }
      function Yd(dr, Cr, Ur, ui) {
        var $i = 0, Qi = dr == null ? 0 : dr.length;
        if (Qi === 0)
          return 0;
        Cr = Ur(Cr);
        for (var En = Cr !== Cr, Dn = Cr === null, Zn = xc(Cr), wo = Cr === ie; $i < Qi; ) {
          var So = $d(($i + Qi) / 2), ko = Ur(dr[So]), Vo = ko !== ie, na = ko === null, Sa = ko === ko, Ua = xc(ko);
          if (En)
            var ya = ui || Sa;
          else
            wo ? ya = Sa && (ui || Vo) : Dn ? ya = Sa && Vo && (ui || !na) : Zn ? ya = Sa && Vo && !na && (ui || !Ua) : na || Ua ? ya = !1 : ya = ui ? ko <= Cr : ko < Cr;
          ya ? $i = So + 1 : Qi = So;
        }
        return Qs(Qi, Pr);
      }
      function tl(dr, Cr) {
        for (var Ur = -1, ui = dr.length, $i = 0, Qi = []; ++Ur < ui; ) {
          var En = dr[Ur], Dn = Cr ? Cr(En) : En;
          if (!Ur || !bc(Dn, Zn)) {
            var Zn = Dn;
            Qi[$i++] = En === 0 ? 0 : En;
          }
        }
        return Qi;
      }
      function Jd(dr) {
        return typeof dr == "number" ? dr : xc(dr) ? Pe : +dr;
      }
      function Tl(dr) {
        if (typeof dr == "string")
          return dr;
        if ($a(dr))
          return Ms(dr, Tl) + "";
        if (xc(dr))
          return oh ? oh.call(dr) : "";
        var Cr = dr + "";
        return Cr == "0" && 1 / dr == -pr ? "-0" : Cr;
      }
      function rl(dr, Cr, Ur) {
        var ui = -1, $i = Zu, Qi = dr.length, En = !0, Dn = [], Zn = Dn;
        if (Ur)
          En = !1, $i = bl;
        else if (Qi >= $e) {
          var wo = Cr ? null : ld(dr);
          if (wo)
            return Ku(wo);
          En = !1, $i = Uo, Zn = new Gc();
        } else
          Zn = Cr ? [] : Dn;
        e:
          for (; ++ui < Qi; ) {
            var So = dr[ui], ko = Cr ? Cr(So) : So;
            if (So = Ur || So !== 0 ? So : 0, En && ko === ko) {
              for (var Vo = Zn.length; Vo--; )
                if (Zn[Vo] === ko)
                  continue e;
              Cr && Zn.push(ko), Dn.push(So);
            } else
              $i(Zn, ko, Ur) || (Zn !== Dn && Zn.push(ko), Dn.push(So));
          }
        return Dn;
      }
      function Kc(dr, Cr) {
        return Cr = Ic(Cr, dr), dr = Or(dr, Cr), dr == null || delete dr[zi(ia(Cr))];
      }
      function ep(dr, Cr, Ur, ui) {
        return gh(dr, Cr, Ur(ph(dr, Cr)), ui);
      }
      function nd(dr, Cr, Ur, ui) {
        for (var $i = dr.length, Qi = ui ? $i : -1; (ui ? Qi-- : ++Qi < $i) && Cr(dr[Qi], Qi, dr); )
          ;
        return Ur ? jl(dr, ui ? 0 : Qi, ui ? Qi + 1 : $i) : jl(dr, ui ? Qi + 1 : 0, ui ? $i : Qi);
      }
      function tp(dr, Cr) {
        var Ur = dr;
        return Ur instanceof Da && (Ur = Ur.value()), Tf(Cr, function(ui, $i) {
          return $i.func.apply($i.thisArg, Sc([ui], $i.args));
        }, Ur);
      }
      function Lc(dr, Cr, Ur) {
        var ui = dr.length;
        if (ui < 2)
          return ui ? rl(dr[0]) : [];
        for (var $i = -1, Qi = so(ui); ++$i < ui; )
          for (var En = dr[$i], Dn = -1; ++Dn < ui; )
            Dn != $i && (Qi[$i] = Ll(Qi[$i] || En, dr[Dn], Cr, Ur));
        return rl(wa(Qi, 1), Cr, Ur);
      }
      function Qd(dr, Cr, Ur) {
        for (var ui = -1, $i = dr.length, Qi = Cr.length, En = {}; ++ui < $i; ) {
          var Dn = ui < Qi ? Cr[ui] : ie;
          Ur(En, dr[ui], Dn);
        }
        return En;
      }
      function ef(dr) {
        return Bs(dr) ? dr : [];
      }
      function od(dr) {
        return typeof dr == "function" ? dr : lc;
      }
      function Ic(dr, Cr) {
        return $a(dr) ? dr : Fs(dr, Cr) ? [dr] : Ni(ms(dr));
      }
      var rp = Ia;
      function rc(dr, Cr, Ur) {
        var ui = dr.length;
        return Ur = Ur === ie ? ui : Ur, !Cr && Ur >= ui ? dr : jl(dr, Cr, Ur);
      }
      var Zp = Rp || function(dr) {
        return Rs.clearTimeout(dr);
      };
      function Xp(dr, Cr) {
        if (Cr)
          return dr.slice();
        var Ur = dr.length, ui = $p ? $p(Ur) : new dr.constructor(Ur);
        return dr.copy(ui), ui;
      }
      function ip(dr) {
        var Cr = new dr.constructor(dr.byteLength);
        return new Cu(Cr).set(new Cu(dr)), Cr;
      }
      function Jm(dr, Cr) {
        var Ur = Cr ? ip(dr.buffer) : dr.buffer;
        return new dr.constructor(Ur, dr.byteOffset, dr.byteLength);
      }
      function Qm(dr) {
        var Cr = new dr.constructor(dr.source, xo.exec(dr));
        return Cr.lastIndex = dr.lastIndex, Cr;
      }
      function tf(dr) {
        return Gh ? _s(Gh.call(dr)) : {};
      }
      function ad(dr, Cr) {
        var Ur = Cr ? ip(dr.buffer) : dr.buffer;
        return new dr.constructor(Ur, dr.byteOffset, dr.length);
      }
      function Bl(dr, Cr) {
        if (dr !== Cr) {
          var Ur = dr !== ie, ui = dr === null, $i = dr === dr, Qi = xc(dr), En = Cr !== ie, Dn = Cr === null, Zn = Cr === Cr, wo = xc(Cr);
          if (!Dn && !wo && !Qi && dr > Cr || Qi && En && Zn && !Dn && !wo || ui && En && Zn || !Ur && Zn || !$i)
            return 1;
          if (!ui && !Qi && !wo && dr < Cr || wo && Ur && $i && !ui && !Qi || Dn && Ur && $i || !En && $i || !Zn)
            return -1;
        }
        return 0;
      }
      function rf(dr, Cr, Ur) {
        for (var ui = -1, $i = dr.criteria, Qi = Cr.criteria, En = $i.length, Dn = Ur.length; ++ui < En; ) {
          var Zn = Bl($i[ui], Qi[ui]);
          if (Zn) {
            if (ui >= Dn)
              return Zn;
            var wo = Ur[ui];
            return Zn * (wo == "desc" ? -1 : 1);
          }
        }
        return dr.index - Cr.index;
      }
      function Kp(dr, Cr, Ur, ui) {
        for (var $i = -1, Qi = dr.length, En = Ur.length, Dn = -1, Zn = Cr.length, wo = Os(Qi - En, 0), So = so(Zn + wo), ko = !ui; ++Dn < Zn; )
          So[Dn] = Cr[Dn];
        for (; ++$i < En; )
          (ko || $i < Qi) && (So[Ur[$i]] = dr[$i]);
        for (; wo--; )
          So[Dn++] = dr[$i++];
        return So;
      }
      function Yp(dr, Cr, Ur, ui) {
        for (var $i = -1, Qi = dr.length, En = -1, Dn = Ur.length, Zn = -1, wo = Cr.length, So = Os(Qi - Dn, 0), ko = so(So + wo), Vo = !ui; ++$i < So; )
          ko[$i] = dr[$i];
        for (var na = $i; ++Zn < wo; )
          ko[na + Zn] = Cr[Zn];
        for (; ++En < Dn; )
          (Vo || $i < Qi) && (ko[na + Ur[En]] = dr[$i++]);
        return ko;
      }
      function $l(dr, Cr) {
        var Ur = -1, ui = dr.length;
        for (Cr || (Cr = so(ui)); ++Ur < ui; )
          Cr[Ur] = dr[Ur];
        return Cr;
      }
      function Bc(dr, Cr, Ur, ui) {
        var $i = !Ur;
        Ur || (Ur = {});
        for (var Qi = -1, En = Cr.length; ++Qi < En; ) {
          var Dn = Cr[Qi], Zn = ui ? ui(Ur[Dn], dr[Dn], Dn, Ur, dr) : ie;
          Zn === ie && (Zn = dr[Dn]), $i ? Hc(Ur, Dn, Zn) : Xh(Ur, Dn, Zn);
        }
        return Ur;
      }
      function Jp(dr, Cr) {
        return Bc(dr, pu(dr), Cr);
      }
      function Z0(dr, Cr) {
        return Bc(dr, zu(dr), Cr);
      }
      function fs(dr, Cr) {
        return function(Ur, ui) {
          var $i = $a(Ur) ? Rh : qf, Qi = Cr ? Cr() : {};
          return $i(Ur, dr, pa(ui, 2), Qi);
        };
      }
      function vh(dr) {
        return Ia(function(Cr, Ur) {
          var ui = -1, $i = Ur.length, Qi = $i > 1 ? Ur[$i - 1] : ie, En = $i > 2 ? Ur[2] : ie;
          for (Qi = dr.length > 3 && typeof Qi == "function" ? ($i--, Qi) : ie, En && bs(Ur[0], Ur[1], En) && (Qi = $i < 3 ? ie : Qi, $i = 1), Cr = _s(Cr); ++ui < $i; ) {
            var Dn = Ur[ui];
            Dn && dr(Cr, Dn, ui, Qi);
          }
          return Cr;
        });
      }
      function e0(dr, Cr) {
        return function(Ur, ui) {
          if (Ur == null)
            return Ur;
          if (!ac(Ur))
            return dr(Ur, ui);
          for (var $i = Ur.length, Qi = Cr ? $i : -1, En = _s(Ur); (Cr ? Qi-- : ++Qi < $i) && ui(En[Qi], Qi, En) !== !1; )
            ;
          return Ur;
        };
      }
      function np(dr) {
        return function(Cr, Ur, ui) {
          for (var $i = -1, Qi = _s(Cr), En = ui(Cr), Dn = En.length; Dn--; ) {
            var Zn = En[dr ? Dn : ++$i];
            if (Ur(Qi[Zn], Zn, Qi) === !1)
              break;
          }
          return Cr;
        };
      }
      function nf(dr, Cr, Ur) {
        var ui = Cr & Nr, $i = Pu(dr);
        function Qi() {
          var En = this && this !== Rs && this instanceof Qi ? $i : dr;
          return En.apply(ui ? Ur : this, arguments);
        }
        return Qi;
      }
      function op(dr) {
        return function(Cr) {
          Cr = ms(Cr);
          var Ur = ou(Cr) ? wl(Cr) : ie, ui = Ur ? Ur[0] : Cr.charAt(0), $i = Ur ? rc(Ur, 1).join("") : Cr.slice(1);
          return ui[dr]() + $i;
        };
      }
      function uu(dr) {
        return function(Cr) {
          return Tf(S1(vf(Cr).replace(Ep, "")), dr, "");
        };
      }
      function Pu(dr) {
        return function() {
          var Cr = arguments;
          switch (Cr.length) {
            case 0:
              return new dr();
            case 1:
              return new dr(Cr[0]);
            case 2:
              return new dr(Cr[0], Cr[1]);
            case 3:
              return new dr(Cr[0], Cr[1], Cr[2]);
            case 4:
              return new dr(Cr[0], Cr[1], Cr[2], Cr[3]);
            case 5:
              return new dr(Cr[0], Cr[1], Cr[2], Cr[3], Cr[4]);
            case 6:
              return new dr(Cr[0], Cr[1], Cr[2], Cr[3], Cr[4], Cr[5]);
            case 7:
              return new dr(Cr[0], Cr[1], Cr[2], Cr[3], Cr[4], Cr[5], Cr[6]);
          }
          var Ur = Tu(dr.prototype), ui = dr.apply(Ur, Cr);
          return $s(ui) ? ui : Ur;
        };
      }
      function $c(dr, Cr, Ur) {
        var ui = Pu(dr);
        function $i() {
          for (var Qi = arguments.length, En = so(Qi), Dn = Qi, Zn = Ou($i); Dn--; )
            En[Dn] = arguments[Dn];
          var wo = Qi < 3 && En[0] !== Zn && En[Qi - 1] !== Zn ? [] : au(En, Zn);
          if (Qi -= wo.length, Qi < Ur)
            return sf(
              dr,
              Cr,
              ic,
              $i.placeholder,
              ie,
              En,
              wo,
              ie,
              ie,
              Ur - Qi
            );
          var So = this && this !== Rs && this instanceof $i ? ui : dr;
          return Ds(So, this, En);
        }
        return $i;
      }
      function Du(dr) {
        return function(Cr, Ur, ui) {
          var $i = _s(Cr);
          if (!ac(Cr)) {
            var Qi = pa(Ur, 3);
            Cr = vl(Cr), Ur = function(Dn) {
              return Qi($i[Dn], Dn, $i);
            };
          }
          var En = dr(Cr, Ur, ui);
          return En > -1 ? $i[Qi ? Cr[En] : En] : ie;
        };
      }
      function Ss(dr) {
        return fu(function(Cr) {
          var Ur = Cr.length, ui = Ur, $i = el.prototype.thru;
          for (dr && Cr.reverse(); ui--; ) {
            var Qi = Cr[ui];
            if (typeof Qi != "function")
              throw new Ml(Ze);
            if ($i && !En && ud(Qi) == "wrapper")
              var En = new el([], !0);
          }
          for (ui = En ? ui : Ur; ++ui < Ur; ) {
            Qi = Cr[ui];
            var Dn = ud(Qi), Zn = Dn == "wrapper" ? il(Qi) : ie;
            Zn && Es(Zn[0]) && Zn[1] == (xi | Xr | si | di) && !Zn[4].length && Zn[9] == 1 ? En = En[ud(Zn[0])].apply(En, Zn[3]) : En = Qi.length == 1 && Es(Qi) ? En[Dn]() : En.thru(Qi);
          }
          return function() {
            var wo = arguments, So = wo[0];
            if (En && wo.length == 1 && $a(So))
              return En.plant(So).value();
            for (var ko = 0, Vo = Ur ? Cr[ko].apply(this, wo) : So; ++ko < Ur; )
              Vo = Cr[ko].call(this, Vo);
            return Vo;
          };
        });
      }
      function ic(dr, Cr, Ur, ui, $i, Qi, En, Dn, Zn, wo) {
        var So = Cr & xi, ko = Cr & Nr, Vo = Cr & Yr, na = Cr & (Xr | Wr), Sa = Cr & oi, Ua = Vo ? ie : Pu(dr);
        function ya() {
          for (var Qa = arguments.length, ns = so(Qa), Dc = Qa; Dc--; )
            ns[Dc] = arguments[Dc];
          if (na)
            var Gl = Ou(ya), Oc = Dh(ns, Gl);
          if (ui && (ns = Kp(ns, ui, $i, na)), Qi && (ns = Yp(ns, Qi, En, na)), Qa -= Oc, na && Qa < wo) {
            var Ks = au(ns, Gl);
            return sf(
              dr,
              Cr,
              ic,
              ya.placeholder,
              Ur,
              ns,
              Ks,
              Dn,
              Zn,
              wo - Qa
            );
          }
          var yu = ko ? Ur : this, Eh = Vo ? yu[dr] : dr;
          return Qa = ns.length, Dn ? ns = Gr(ns, Dn) : Sa && Qa > 1 && ns.reverse(), So && Zn < Qa && (ns.length = Zn), this && this !== Rs && this instanceof ya && (Eh = Ua || Pu(Eh)), Eh.apply(yu, ns);
        }
        return ya;
      }
      function of(dr, Cr) {
        return function(Ur, ui) {
          return Wm(Ur, dr, Cr(ui), {});
        };
      }
      function _h(dr, Cr) {
        return function(Ur, ui) {
          var $i;
          if (Ur === ie && ui === ie)
            return Cr;
          if (Ur !== ie && ($i = Ur), ui !== ie) {
            if ($i === ie)
              return ui;
            typeof Ur == "string" || typeof ui == "string" ? (Ur = Tl(Ur), ui = Tl(ui)) : (Ur = Jd(Ur), ui = Jd(ui)), $i = dr(Ur, ui);
          }
          return $i;
        };
      }
      function sd(dr) {
        return fu(function(Cr) {
          return Cr = Ms(Cr, xl(pa())), Ia(function(Ur) {
            var ui = this;
            return dr(Cr, function($i) {
              return Ds($i, ui, Ur);
            });
          });
        });
      }
      function ap(dr, Cr) {
        Cr = Cr === ie ? " " : Tl(Cr);
        var Ur = Cr.length;
        if (Ur < 2)
          return Ur ? Xc(Cr, dr) : Cr;
        var ui = Xc(Cr, Bd(dr / Ac(Cr)));
        return ou(Cr) ? rc(wl(ui), 0, dr).join("") : ui.slice(0, dr);
      }
      function af(dr, Cr, Ur, ui) {
        var $i = Cr & Nr, Qi = Pu(dr);
        function En() {
          for (var Dn = -1, Zn = arguments.length, wo = -1, So = ui.length, ko = so(So + Zn), Vo = this && this !== Rs && this instanceof En ? Qi : dr; ++wo < So; )
            ko[wo] = ui[wo];
          for (; Zn--; )
            ko[wo++] = arguments[++Dn];
          return Ds(Vo, $i ? Ur : this, ko);
        }
        return En;
      }
      function t0(dr) {
        return function(Cr, Ur, ui) {
          return ui && typeof ui != "number" && bs(Cr, Ur, ui) && (Ur = ui = ie), Cr = Vu(Cr), Ur === ie ? (Ur = Cr, Cr = 0) : Ur = Vu(Ur), ui = ui === ie ? Cr < Ur ? 1 : -1 : Vu(ui), cu(Cr, Ur, ui, dr);
        };
      }
      function sp(dr) {
        return function(Cr, Ur) {
          return typeof Cr == "string" && typeof Ur == "string" || (Cr = wc(Cr), Ur = wc(Ur)), dr(Cr, Ur);
        };
      }
      function sf(dr, Cr, Ur, ui, $i, Qi, En, Dn, Zn, wo) {
        var So = Cr & Xr, ko = So ? En : ie, Vo = So ? ie : En, na = So ? Qi : ie, Sa = So ? ie : Qi;
        Cr |= So ? si : li, Cr &= ~(So ? li : si), Cr & Vr || (Cr &= ~(Nr | Yr));
        var Ua = [
          dr,
          Cr,
          $i,
          na,
          ko,
          Sa,
          Vo,
          Dn,
          Zn,
          wo
        ], ya = Ur.apply(ie, Ua);
        return Es(dr) && Jr(ya, Ua), ya.placeholder = ui, Mi(ya, dr, Cr);
      }
      function lf(dr) {
        var Cr = Ls[dr];
        return function(Ur, ui) {
          if (Ur = wc(Ur), ui = ui == null ? 0 : Qs(Va(ui), 292), ui && Vh(Ur)) {
            var $i = (ms(Ur) + "e").split("e"), Qi = Cr($i[0] + "e" + (+$i[1] + ui));
            return $i = (ms(Qi) + "e").split("e"), +($i[0] + "e" + (+$i[1] - ui));
          }
          return Cr(Ur);
        };
      }
      var ld = ih && 1 / Ku(new ih([, -0]))[1] == pr ? function(dr) {
        return new ih(dr);
      } : wm;
      function yh(dr) {
        return function(Cr) {
          var Ur = zs(Cr);
          return Ur == qi ? Tc(Cr) : Ur == In ? su(Cr) : kf(Cr, dr(Cr));
        };
      }
      function pl(dr, Cr, Ur, ui, $i, Qi, En, Dn) {
        var Zn = Cr & Yr;
        if (!Zn && typeof dr != "function")
          throw new Ml(Ze);
        var wo = ui ? ui.length : 0;
        if (wo || (Cr &= ~(si | li), ui = $i = ie), En = En === ie ? En : Os(Va(En), 0), Dn = Dn === ie ? Dn : Va(Dn), wo -= $i ? $i.length : 0, Cr & li) {
          var So = ui, ko = $i;
          ui = $i = ie;
        }
        var Vo = Zn ? ie : il(dr), na = [
          dr,
          Cr,
          Ur,
          ui,
          $i,
          So,
          ko,
          Qi,
          En,
          Dn
        ];
        if (Vo && yr(na, Vo), dr = na[0], Cr = na[1], Ur = na[2], ui = na[3], $i = na[4], Dn = na[9] = na[9] === ie ? Zn ? 0 : dr.length : Os(na[9] - wo, 0), !Dn && Cr & (Xr | Wr) && (Cr &= ~(Xr | Wr)), !Cr || Cr == Nr)
          var Sa = nf(dr, Cr, Ur);
        else
          Cr == Xr || Cr == Wr ? Sa = $c(dr, Cr, Dn) : (Cr == si || Cr == (Nr | si)) && !$i.length ? Sa = af(dr, Cr, Ur, ui) : Sa = ic.apply(ie, na);
        var Ua = Vo ? Qf : Jr;
        return Mi(Ua(Sa, na), dr, Cr);
      }
      function vc(dr, Cr, Ur, ui) {
        return dr === ie || bc(dr, lu[Ur]) && !rs.call(ui, Ur) ? Cr : dr;
      }
      function hu(dr, Cr, Ur, ui, $i, Qi) {
        return $s(dr) && $s(Cr) && (Qi.set(Cr, dr), Kf(dr, Cr, ie, hu, Qi), Qi.delete(Cr)), dr;
      }
      function bh(dr) {
        return Qc(dr) ? ie : dr;
      }
      function du(dr, Cr, Ur, ui, $i, Qi) {
        var En = Ur & Ar, Dn = dr.length, Zn = Cr.length;
        if (Dn != Zn && !(En && Zn > Dn))
          return !1;
        var wo = Qi.get(dr), So = Qi.get(Cr);
        if (wo && So)
          return wo == Cr && So == dr;
        var ko = -1, Vo = !0, na = Ur & Rr ? new Gc() : ie;
        for (Qi.set(dr, Cr), Qi.set(Cr, dr); ++ko < Dn; ) {
          var Sa = dr[ko], Ua = Cr[ko];
          if (ui)
            var ya = En ? ui(Ua, Sa, ko, Cr, dr, Qi) : ui(Sa, Ua, ko, dr, Cr, Qi);
          if (ya !== ie) {
            if (ya)
              continue;
            Vo = !1;
            break;
          }
          if (na) {
            if (!Cp(Cr, function(Qa, ns) {
              if (!Uo(na, ns) && (Sa === Qa || $i(Sa, Qa, Ur, ui, Qi)))
                return na.push(ns);
            })) {
              Vo = !1;
              break;
            }
          } else if (!(Sa === Ua || $i(Sa, Ua, Ur, ui, Qi))) {
            Vo = !1;
            break;
          }
        }
        return Qi.delete(dr), Qi.delete(Cr), Vo;
      }
      function lp(dr, Cr, Ur, ui, $i, Qi, En) {
        switch (Ur) {
          case Yn:
            if (dr.byteLength != Cr.byteLength || dr.byteOffset != Cr.byteOffset)
              return !1;
            dr = dr.buffer, Cr = Cr.buffer;
          case Xn:
            return !(dr.byteLength != Cr.byteLength || !Qi(new Cu(dr), new Cu(Cr)));
          case mi:
          case ei:
          case yn:
            return bc(+dr, +Cr);
          case pi:
            return dr.name == Cr.name && dr.message == Cr.message;
          case Kn:
          case Fn:
            return dr == Cr + "";
          case qi:
            var Dn = Tc;
          case In:
            var Zn = ui & Ar;
            if (Dn || (Dn = Ku), dr.size != Cr.size && !Zn)
              return !1;
            var wo = En.get(dr);
            if (wo)
              return wo == Cr;
            ui |= Rr, En.set(dr, Cr);
            var So = du(Dn(dr), Dn(Cr), ui, $i, Qi, En);
            return En.delete(dr), So;
          case Po:
            if (Gh)
              return Gh.call(dr) == Gh.call(Cr);
        }
        return !1;
      }
      function X0(dr, Cr, Ur, ui, $i, Qi) {
        var En = Ur & Ar, Dn = cd(dr), Zn = Dn.length, wo = cd(Cr), So = wo.length;
        if (Zn != So && !En)
          return !1;
        for (var ko = Zn; ko--; ) {
          var Vo = Dn[ko];
          if (!(En ? Vo in Cr : rs.call(Cr, Vo)))
            return !1;
        }
        var na = Qi.get(dr), Sa = Qi.get(Cr);
        if (na && Sa)
          return na == Cr && Sa == dr;
        var Ua = !0;
        Qi.set(dr, Cr), Qi.set(Cr, dr);
        for (var ya = En; ++ko < Zn; ) {
          Vo = Dn[ko];
          var Qa = dr[Vo], ns = Cr[Vo];
          if (ui)
            var Dc = En ? ui(ns, Qa, Vo, Cr, dr, Qi) : ui(Qa, ns, Vo, dr, Cr, Qi);
          if (!(Dc === ie ? Qa === ns || $i(Qa, ns, Ur, ui, Qi) : Dc)) {
            Ua = !1;
            break;
          }
          ya || (ya = Vo == "constructor");
        }
        if (Ua && !ya) {
          var Gl = dr.constructor, Oc = Cr.constructor;
          Gl != Oc && "constructor" in dr && "constructor" in Cr && !(typeof Gl == "function" && Gl instanceof Gl && typeof Oc == "function" && Oc instanceof Oc) && (Ua = !1);
        }
        return Qi.delete(dr), Qi.delete(Cr), Ua;
      }
      function fu(dr) {
        return fi(Dr(dr, ie, ao), dr + "");
      }
      function cd(dr) {
        return mh(dr, vl, pu);
      }
      function cp(dr) {
        return mh(dr, sc, zu);
      }
      var il = zf ? function(dr) {
        return zf.get(dr);
      } : wm;
      function ud(dr) {
        for (var Cr = dr.name + "", Ur = qh[Cr], ui = rs.call(qh, Cr) ? Ur.length : 0; ui--; ) {
          var $i = Ur[ui], Qi = $i.func;
          if (Qi == null || Qi == dr)
            return $i.name;
        }
        return Cr;
      }
      function Ou(dr) {
        var Cr = rs.call(Zi, "placeholder") ? Zi : dr;
        return Cr.placeholder;
      }
      function pa() {
        var dr = Zi.iteratee || y0;
        return dr = dr === y0 ? Gp : dr, arguments.length ? dr(arguments[0], arguments[1]) : dr;
      }
      function Yc(dr, Cr) {
        var Ur = dr.__data__;
        return em(Cr) ? Ur[typeof Cr == "string" ? "string" : "hash"] : Ur.map;
      }
      function cf(dr) {
        for (var Cr = vl(dr), Ur = Cr.length; Ur--; ) {
          var ui = Cr[Ur], $i = dr[ui];
          Cr[Ur] = [ui, $i, He($i)];
        }
        return Cr;
      }
      function cl(dr, Cr) {
        var Ur = Fl(dr, Cr);
        return Xf(Ur) ? Ur : ie;
      }
      function _c(dr) {
        var Cr = rs.call(dr, eh), Ur = dr[eh];
        try {
          dr[eh] = ie;
          var ui = !0;
        } catch {
        }
        var $i = fc.call(dr);
        return ui && (Cr ? dr[eh] = Ur : delete dr[eh]), $i;
      }
      var pu = Op ? function(dr) {
        return dr == null ? [] : (dr = _s(dr), nu(Op(dr), function(Cr) {
          return Qu.call(dr, Cr);
        }));
      } : x0, zu = Op ? function(dr) {
        for (var Cr = []; dr; )
          Sc(Cr, pu(dr)), dr = Ld(dr);
        return Cr;
      } : x0, zs = Zs;
      (Pd && zs(new Pd(new ArrayBuffer(1))) != Yn || th && zs(new th()) != qi || Uh && zs(Uh.resolve()) != rn || ih && zs(new ih()) != In || jh && zs(new jh()) != Vn) && (zs = function(dr) {
        var Cr = Zs(dr), Ur = Cr == $n ? dr.constructor : ie, ui = Ur ? Ki(Ur) : "";
        if (ui)
          switch (ui) {
            case V0:
              return Yn;
            case U0:
              return qi;
            case j0:
              return rn;
            case Fp:
              return In;
            case Np:
              return Vn;
          }
        return Cr;
      });
      function Qp(dr, Cr, Ur) {
        for (var ui = -1, $i = Ur.length; ++ui < $i; ) {
          var Qi = Ur[ui], En = Qi.size;
          switch (Qi.type) {
            case "drop":
              dr += En;
              break;
            case "dropRight":
              Cr -= En;
              break;
            case "take":
              Cr = Qs(Cr, dr + En);
              break;
            case "takeRight":
              dr = Os(dr, Cr - En);
              break;
          }
        }
        return { start: dr, end: Cr };
      }
      function Ba(dr) {
        var Cr = dr.match(Sn);
        return Cr ? Cr[1].split(Hi) : [];
      }
      function mu(dr, Cr, Ur) {
        Cr = Ic(Cr, dr);
        for (var ui = -1, $i = Cr.length, Qi = !1; ++ui < $i; ) {
          var En = zi(Cr[ui]);
          if (!(Qi = dr != null && Ur(dr, En)))
            break;
          dr = dr[En];
        }
        return Qi || ++ui != $i ? Qi : ($i = dr == null ? 0 : dr.length, !!$i && dm($i) && As(En, $i) && ($a(dr) || dd(dr)));
      }
      function r0(dr) {
        var Cr = dr.length, Ur = new dr.constructor(Cr);
        return Cr && typeof dr[0] == "string" && rs.call(dr, "index") && (Ur.index = dr.index, Ur.input = dr.input), Ur;
      }
      function up(dr) {
        return typeof dr.constructor == "function" && !ke(dr) ? Tu(Ld(dr)) : {};
      }
      function uf(dr, Cr, Ur) {
        var ui = dr.constructor;
        switch (Cr) {
          case Xn:
            return ip(dr);
          case mi:
          case ei:
            return new ui(+dr);
          case Yn:
            return Jm(dr, Ur);
          case Wo:
          case Ci:
          case ri:
          case yi:
          case Li:
          case Yi:
          case zn:
          case un:
          case Gn:
            return ad(dr, Ur);
          case qi:
            return new ui();
          case yn:
          case Fn:
            return new ui(dr);
          case Kn:
            return Qm(dr);
          case In:
            return new ui();
          case Po:
            return tf(dr);
        }
      }
      function Fu(dr, Cr) {
        var Ur = Cr.length;
        if (!Ur)
          return dr;
        var ui = Ur - 1;
        return Cr[ui] = (Ur > 1 ? "& " : "") + Cr[ui], Cr = Cr.join(Ur > 2 ? ", " : " "), dr.replace(Vi, `{
/* [wrapped with ` + Cr + `] */
`);
      }
      function gu(dr) {
        return $a(dr) || dd(dr) || !!(zm && dr && dr[zm]);
      }
      function As(dr, Cr) {
        var Ur = typeof dr;
        return Cr = Cr ?? br, !!Cr && (Ur == "number" || Ur != "symbol" && Go.test(dr)) && dr > -1 && dr % 1 == 0 && dr < Cr;
      }
      function bs(dr, Cr, Ur) {
        if (!$s(Ur))
          return !1;
        var ui = typeof Cr;
        return (ui == "number" ? ac(Ur) && As(Cr, Ur.length) : ui == "string" && Cr in Ur) ? bc(Ur[Cr], dr) : !1;
      }
      function Fs(dr, Cr) {
        if ($a(dr))
          return !1;
        var Ur = typeof dr;
        return Ur == "number" || Ur == "symbol" || Ur == "boolean" || dr == null || xc(dr) ? !0 : _i.test(dr) || !ai.test(dr) || Cr != null && dr in _s(Cr);
      }
      function em(dr) {
        var Cr = typeof dr;
        return Cr == "string" || Cr == "number" || Cr == "symbol" || Cr == "boolean" ? dr !== "__proto__" : dr === null;
      }
      function Es(dr) {
        var Cr = ud(dr), Ur = Zi[Cr];
        if (typeof Ur != "function" || !(Cr in Da.prototype))
          return !1;
        if (dr === Ur)
          return !0;
        var ui = il(Ur);
        return !!ui && dr === ui[0];
      }
      function qe(dr) {
        return !!Eu && Eu in dr;
      }
      var xe = Fh ? Mh : w0;
      function ke(dr) {
        var Cr = dr && dr.constructor, Ur = typeof Cr == "function" && Cr.prototype || lu;
        return dr === Ur;
      }
      function He(dr) {
        return dr === dr && !$s(dr);
      }
      function ir(dr, Cr) {
        return function(Ur) {
          return Ur == null ? !1 : Ur[dr] === Cr && (Cr !== ie || dr in _s(Ur));
        };
      }
      function ar(dr) {
        var Cr = um(dr, function(ui) {
          return Ur.size === gr && Ur.clear(), ui;
        }), Ur = Cr.cache;
        return Cr;
      }
      function yr(dr, Cr) {
        var Ur = dr[1], ui = Cr[1], $i = Ur | ui, Qi = $i < (Nr | Yr | xi), En = ui == xi && Ur == Xr || ui == xi && Ur == di && dr[7].length <= Cr[8] || ui == (xi | di) && Cr[7].length <= Cr[8] && Ur == Xr;
        if (!(Qi || En))
          return dr;
        ui & Nr && (dr[2] = Cr[2], $i |= Ur & Nr ? 0 : Vr);
        var Dn = Cr[3];
        if (Dn) {
          var Zn = dr[3];
          dr[3] = Zn ? Kp(Zn, Dn, Cr[4]) : Dn, dr[4] = Zn ? au(dr[3], or) : Cr[4];
        }
        return Dn = Cr[5], Dn && (Zn = dr[5], dr[5] = Zn ? Yp(Zn, Dn, Cr[6]) : Dn, dr[6] = Zn ? au(dr[5], or) : Cr[6]), Dn = Cr[7], Dn && (dr[7] = Dn), ui & xi && (dr[8] = dr[8] == null ? Cr[8] : Qs(dr[8], Cr[8])), dr[9] == null && (dr[9] = Cr[9]), dr[0] = Cr[0], dr[1] = $i, dr;
      }
      function Tr(dr) {
        var Cr = [];
        if (dr != null)
          for (var Ur in _s(dr))
            Cr.push(Ur);
        return Cr;
      }
      function $r(dr) {
        return fc.call(dr);
      }
      function Dr(dr, Cr, Ur) {
        return Cr = Os(Cr === ie ? dr.length - 1 : Cr, 0), function() {
          for (var ui = arguments, $i = -1, Qi = Os(ui.length - Cr, 0), En = so(Qi); ++$i < Qi; )
            En[$i] = ui[Cr + $i];
          $i = -1;
          for (var Dn = so(Cr + 1); ++$i < Cr; )
            Dn[$i] = ui[$i];
          return Dn[Cr] = Ur(En), Ds(dr, this, Dn);
        };
      }
      function Or(dr, Cr) {
        return Cr.length < 2 ? dr : ph(dr, jl(Cr, 0, -1));
      }
      function Gr(dr, Cr) {
        for (var Ur = dr.length, ui = Qs(Cr.length, Ur), $i = $l(dr); ui--; ) {
          var Qi = Cr[ui];
          dr[ui] = As(Qi, Ur) ? $i[Qi] : ie;
        }
        return dr;
      }
      function qr(dr, Cr) {
        if (!(Cr === "constructor" && typeof dr[Cr] == "function") && Cr != "__proto__")
          return dr[Cr];
      }
      var Jr = Ei(Qf), bi = Dp || function(dr, Cr) {
        return Rs.setTimeout(dr, Cr);
      }, fi = Ei(Wp);
      function Mi(dr, Cr, Ur) {
        var ui = Cr + "";
        return fi(dr, Fu(ui, Wi(Ba(ui), Ur)));
      }
      function Ei(dr) {
        var Cr = 0, Ur = 0;
        return function() {
          var ui = Pf(), $i = ze - (ui - Ur);
          if (Ur = ui, $i > 0) {
            if (++Cr >= Ae)
              return arguments[0];
          } else
            Cr = 0;
          return dr.apply(ie, arguments);
        };
      }
      function Ii(dr, Cr) {
        var Ur = -1, ui = dr.length, $i = ui - 1;
        for (Cr = Cr === ie ? ui : Cr; ++Ur < Cr; ) {
          var Qi = Xd(Ur, $i), En = dr[Qi];
          dr[Qi] = dr[Ur], dr[Ur] = En;
        }
        return dr.length = Cr, dr;
      }
      var Ni = ar(function(dr) {
        var Cr = [];
        return dr.charCodeAt(0) === 46 && Cr.push(""), dr.replace(Pi, function(Ur, ui, $i, Qi) {
          Cr.push($i ? Qi.replace(_n, "$1") : ui || Ur);
        }), Cr;
      });
      function zi(dr) {
        if (typeof dr == "string" || xc(dr))
          return dr;
        var Cr = dr + "";
        return Cr == "0" && 1 / dr == -pr ? "-0" : Cr;
      }
      function Ki(dr) {
        if (dr != null) {
          try {
            return Uc.call(dr);
          } catch {
          }
          try {
            return dr + "";
          } catch {
          }
        }
        return "";
      }
      function Wi(dr, Cr) {
        return al(vi, function(Ur) {
          var ui = "_." + Ur[0];
          Cr & Ur[1] && !Zu(dr, ui) && dr.push(ui);
        }), dr.sort();
      }
      function Xi(dr) {
        if (dr instanceof Da)
          return dr.clone();
        var Cr = new el(dr.__wrapped__, dr.__chain__);
        return Cr.__actions__ = $l(dr.__actions__), Cr.__index__ = dr.__index__, Cr.__values__ = dr.__values__, Cr;
      }
      function Gi(dr, Cr, Ur) {
        (Ur ? bs(dr, Cr, Ur) : Cr === ie) ? Cr = 1 : Cr = Os(Va(Cr), 0);
        var ui = dr == null ? 0 : dr.length;
        if (!ui || Cr < 1)
          return [];
        for (var $i = 0, Qi = 0, En = so(Bd(ui / Cr)); $i < ui; )
          En[Qi++] = jl(dr, $i, $i += Cr);
        return En;
      }
      function nn(dr) {
        for (var Cr = -1, Ur = dr == null ? 0 : dr.length, ui = 0, $i = []; ++Cr < Ur; ) {
          var Qi = dr[Cr];
          Qi && ($i[ui++] = Qi);
        }
        return $i;
      }
      function dn() {
        var dr = arguments.length;
        if (!dr)
          return [];
        for (var Cr = so(dr - 1), Ur = arguments[0], ui = dr; ui--; )
          Cr[ui - 1] = arguments[ui];
        return Sc($a(Ur) ? $l(Ur) : [Ur], wa(Cr, 1));
      }
      var Pn = Ia(function(dr, Cr) {
        return Bs(dr) ? Ll(dr, wa(Cr, 1, Bs, !0)) : [];
      }), Ln = Ia(function(dr, Cr) {
        var Ur = ia(Cr);
        return Bs(Ur) && (Ur = ie), Bs(dr) ? Ll(dr, wa(Cr, 1, Bs, !0), pa(Ur, 2)) : [];
      }), hn = Ia(function(dr, Cr) {
        var Ur = ia(Cr);
        return Bs(Ur) && (Ur = ie), Bs(dr) ? Ll(dr, wa(Cr, 1, Bs, !0), ie, Ur) : [];
      });
      function xn(dr, Cr, Ur) {
        var ui = dr == null ? 0 : dr.length;
        return ui ? (Cr = Ur || Cr === ie ? 1 : Va(Cr), jl(dr, Cr < 0 ? 0 : Cr, ui)) : [];
      }
      function Hn(dr, Cr, Ur) {
        var ui = dr == null ? 0 : dr.length;
        return ui ? (Cr = Ur || Cr === ie ? 1 : Va(Cr), Cr = ui - Cr, jl(dr, 0, Cr < 0 ? 0 : Cr)) : [];
      }
      function io(dr, Cr) {
        return dr && dr.length ? nd(dr, pa(Cr, 3), !0, !0) : [];
      }
      function uo(dr, Cr) {
        return dr && dr.length ? nd(dr, pa(Cr, 3), !0) : [];
      }
      function An(dr, Cr, Ur, ui) {
        var $i = dr == null ? 0 : dr.length;
        return $i ? (Ur && typeof Ur != "number" && bs(dr, Cr, Ur) && (Ur = 0, ui = $i), Hm(dr, Cr, Ur, ui)) : [];
      }
      function eo(dr, Cr, Ur) {
        var ui = dr == null ? 0 : dr.length;
        if (!ui)
          return -1;
        var $i = Ur == null ? 0 : Va(Ur);
        return $i < 0 && ($i = Os(ui + $i, 0)), Ol(dr, pa(Cr, 3), $i);
      }
      function On(dr, Cr, Ur) {
        var ui = dr == null ? 0 : dr.length;
        if (!ui)
          return -1;
        var $i = ui - 1;
        return Ur !== ie && ($i = Va(Ur), $i = Ur < 0 ? Os(ui + $i, 0) : Qs($i, ui - 1)), Ol(dr, pa(Cr, 3), $i, !0);
      }
      function ao(dr) {
        var Cr = dr == null ? 0 : dr.length;
        return Cr ? wa(dr, 1) : [];
      }
      function ro(dr) {
        var Cr = dr == null ? 0 : dr.length;
        return Cr ? wa(dr, pr) : [];
      }
      function Wn(dr, Cr) {
        var Ur = dr == null ? 0 : dr.length;
        return Ur ? (Cr = Cr === ie ? 1 : Va(Cr), wa(dr, Cr)) : [];
      }
      function _o(dr) {
        for (var Cr = -1, Ur = dr == null ? 0 : dr.length, ui = {}; ++Cr < Ur; ) {
          var $i = dr[Cr];
          ui[$i[0]] = $i[1];
        }
        return ui;
      }
      function yo(dr) {
        return dr && dr.length ? dr[0] : ie;
      }
      function mo(dr, Cr, Ur) {
        var ui = dr == null ? 0 : dr.length;
        if (!ui)
          return -1;
        var $i = Ur == null ? 0 : Va(Ur);
        return $i < 0 && ($i = Os(ui + $i, 0)), Xu(dr, Cr, $i);
      }
      function Eo(dr) {
        var Cr = dr == null ? 0 : dr.length;
        return Cr ? jl(dr, 0, -1) : [];
      }
      var Ko = Ia(function(dr) {
        var Cr = Ms(dr, ef);
        return Cr.length && Cr[0] === dr[0] ? Bn(Cr) : [];
      }), Fo = Ia(function(dr) {
        var Cr = ia(dr), Ur = Ms(dr, ef);
        return Cr === ia(Ur) ? Cr = ie : Ur.pop(), Ur.length && Ur[0] === dr[0] ? Bn(Ur, pa(Cr, 2)) : [];
      }), zo = Ia(function(dr) {
        var Cr = ia(dr), Ur = Ms(dr, ef);
        return Cr = typeof Cr == "function" ? Cr : ie, Cr && Ur.pop(), Ur.length && Ur[0] === dr[0] ? Bn(Ur, ie, Cr) : [];
      });
      function Jo(dr, Cr) {
        return dr == null ? "" : Fm.call(dr, Cr);
      }
      function ia(dr) {
        var Cr = dr == null ? 0 : dr.length;
        return Cr ? dr[Cr - 1] : ie;
      }
      function sa(dr, Cr, Ur) {
        var ui = dr == null ? 0 : dr.length;
        if (!ui)
          return -1;
        var $i = ui;
        return Ur !== ie && ($i = Va(Ur), $i = $i < 0 ? Os(ui + $i, 0) : Qs($i, ui - 1)), Cr === Cr ? Mu(dr, Cr, $i) : Ol(dr, Ec, $i, !0);
      }
      function ss(dr, Cr) {
        return dr && dr.length ? Ka(dr, Va(Cr)) : ie;
      }
      var Ya = Ia(Oa);
      function Oa(dr, Cr) {
        return dr && dr.length && Cr && Cr.length ? $u(dr, Cr) : dr;
      }
      function Na(dr, Cr, Ur) {
        return dr && dr.length && Cr && Cr.length ? $u(dr, Cr, pa(Ur, 2)) : dr;
      }
      function la(dr, Cr, Ur) {
        return dr && dr.length && Cr && Cr.length ? $u(dr, Cr, ie, Ur) : dr;
      }
      var _a = fu(function(dr, Cr) {
        var Ur = dr == null ? 0 : dr.length, ui = jp(dr, Cr);
        return tc(dr, Ms(Cr, function($i) {
          return As($i, Ur) ? +$i : $i;
        }).sort(Bl)), ui;
      });
      function qo(dr, Cr) {
        var Ur = [];
        if (!(dr && dr.length))
          return Ur;
        var ui = -1, $i = [], Qi = dr.length;
        for (Cr = pa(Cr, 3); ++ui < Qi; ) {
          var En = dr[ui];
          Cr(En, ui, dr) && (Ur.push(En), $i.push(ui));
        }
        return tc(dr, $i), Ur;
      }
      function Aa(dr) {
        return dr == null ? dr : Of.call(dr);
      }
      function ps(dr, Cr, Ur) {
        var ui = dr == null ? 0 : dr.length;
        return ui ? (Ur && typeof Ur != "number" && bs(dr, Cr, Ur) ? (Cr = 0, Ur = ui) : (Cr = Cr == null ? 0 : Va(Cr), Ur = Ur === ie ? ui : Va(Ur)), jl(dr, Cr, Ur)) : [];
      }
      function Xs(dr, Cr) {
        return id(dr, Cr);
      }
      function ql(dr, Cr, Ur) {
        return Yd(dr, Cr, pa(Ur, 2));
      }
      function ml(dr, Cr) {
        var Ur = dr == null ? 0 : dr.length;
        if (Ur) {
          var ui = id(dr, Cr);
          if (ui < Ur && bc(dr[ui], Cr))
            return ui;
        }
        return -1;
      }
      function Ns(dr, Cr) {
        return id(dr, Cr, !0);
      }
      function ks(dr, Cr, Ur) {
        return Yd(dr, Cr, pa(Ur, 2), !0);
      }
      function Cs(dr, Cr) {
        var Ur = dr == null ? 0 : dr.length;
        if (Ur) {
          var ui = id(dr, Cr, !0) - 1;
          if (bc(dr[ui], Cr))
            return ui;
        }
        return -1;
      }
      function is(dr) {
        return dr && dr.length ? tl(dr) : [];
      }
      function Za(dr, Cr) {
        return dr && dr.length ? tl(dr, pa(Cr, 2)) : [];
      }
      function Ma(dr) {
        var Cr = dr == null ? 0 : dr.length;
        return Cr ? jl(dr, 1, Cr) : [];
      }
      function xs(dr, Cr, Ur) {
        return dr && dr.length ? (Cr = Ur || Cr === ie ? 1 : Va(Cr), jl(dr, 0, Cr < 0 ? 0 : Cr)) : [];
      }
      function Vs(dr, Cr, Ur) {
        var ui = dr == null ? 0 : dr.length;
        return ui ? (Cr = Ur || Cr === ie ? 1 : Va(Cr), Cr = ui - Cr, jl(dr, Cr < 0 ? 0 : Cr, ui)) : [];
      }
      function Ja(dr, Cr) {
        return dr && dr.length ? nd(dr, pa(Cr, 3), !1, !0) : [];
      }
      function ul(dr, Cr) {
        return dr && dr.length ? nd(dr, pa(Cr, 3)) : [];
      }
      var nc = Ia(function(dr) {
        return rl(wa(dr, 1, Bs, !0));
      }), Rl = Ia(function(dr) {
        var Cr = ia(dr);
        return Bs(Cr) && (Cr = ie), rl(wa(dr, 1, Bs, !0), pa(Cr, 2));
      }), vu = Ia(function(dr) {
        var Cr = ia(dr);
        return Cr = typeof Cr == "function" ? Cr : ie, rl(wa(dr, 1, Bs, !0), ie, Cr);
      });
      function Jc(dr) {
        return dr && dr.length ? rl(dr) : [];
      }
      function gl(dr, Cr) {
        return dr && dr.length ? rl(dr, pa(Cr, 2)) : [];
      }
      function oc(dr, Cr) {
        return Cr = typeof Cr == "function" ? Cr : ie, dr && dr.length ? rl(dr, ie, Cr) : [];
      }
      function Rc(dr) {
        if (!(dr && dr.length))
          return [];
        var Cr = 0;
        return dr = nu(dr, function(Ur) {
          if (Bs(Ur))
            return Cr = Os(Ur.length, Cr), !0;
        }), Oo(Cr, function(Ur) {
          return Ms(dr, Ap(Ur));
        });
      }
      function yc(dr, Cr) {
        if (!(dr && dr.length))
          return [];
        var Ur = Rc(dr);
        return Cr == null ? Ur : Ms(Ur, function(ui) {
          return Ds(Cr, ie, ui);
        });
      }
      var xh = Ia(function(dr, Cr) {
        return Bs(dr) ? Ll(dr, Cr) : [];
      }), hf = Ia(function(dr) {
        return Lc(nu(dr, Bs));
      }), tm = Ia(function(dr) {
        var Cr = ia(dr);
        return Bs(Cr) && (Cr = ie), Lc(nu(dr, Bs), pa(Cr, 2));
      }), hp = Ia(function(dr) {
        var Cr = ia(dr);
        return Cr = typeof Cr == "function" ? Cr : ie, Lc(nu(dr, Bs), ie, Cr);
      }), j1 = Ia(Rc);
      function Av(dr, Cr) {
        return Qd(dr || [], Cr || [], Xh);
      }
      function q1(dr, Cr) {
        return Qd(dr || [], Cr || [], gh);
      }
      var kv = Ia(function(dr) {
        var Cr = dr.length, Ur = Cr > 1 ? dr[Cr - 1] : ie;
        return Ur = typeof Ur == "function" ? (dr.pop(), Ur) : ie, yc(dr, Ur);
      });
      function G1(dr) {
        var Cr = Zi(dr);
        return Cr.__chain__ = !0, Cr;
      }
      function H1(dr, Cr) {
        return Cr(dr), dr;
      }
      function rm(dr, Cr) {
        return Cr(dr);
      }
      var W1 = fu(function(dr) {
        var Cr = dr.length, Ur = Cr ? dr[0] : 0, ui = this.__wrapped__, $i = function(Qi) {
          return jp(Qi, dr);
        };
        return Cr > 1 || this.__actions__.length || !(ui instanceof Da) || !As(Ur) ? this.thru($i) : (ui = ui.slice(Ur, +Ur + (Cr ? 1 : 0)), ui.__actions__.push({
          func: rm,
          args: [$i],
          thisArg: ie
        }), new el(ui, this.__chain__).thru(function(Qi) {
          return Cr && !Qi.length && Qi.push(ie), Qi;
        }));
      });
      function Z1() {
        return G1(this);
      }
      function X1() {
        return new el(this.value(), this.__chain__);
      }
      function K1() {
        this.__values__ === ie && (this.__values__ = mm(this.value()));
        var dr = this.__index__ >= this.__values__.length, Cr = dr ? ie : this.__values__[this.__index__++];
        return { done: dr, value: Cr };
      }
      function Y1() {
        return this;
      }
      function K0(dr) {
        for (var Cr, Ur = this; Ur instanceof Hh; ) {
          var ui = Xi(Ur);
          ui.__index__ = 0, ui.__values__ = ie, Cr ? $i.__wrapped__ = ui : Cr = ui;
          var $i = ui;
          Ur = Ur.__wrapped__;
        }
        return $i.__wrapped__ = dr, Cr;
      }
      function hd() {
        var dr = this.__wrapped__;
        if (dr instanceof Da) {
          var Cr = dr;
          return this.__actions__.length && (Cr = new Da(this)), Cr = Cr.reverse(), Cr.__actions__.push({
            func: rm,
            args: [Aa],
            thisArg: ie
          }), new el(Cr, this.__chain__);
        }
        return this.thru(Aa);
      }
      function Al() {
        return tp(this.__wrapped__, this.__actions__);
      }
      var J1 = fs(function(dr, Cr, Ur) {
        rs.call(dr, Ur) ? ++dr[Ur] : Hc(dr, Ur, 1);
      });
      function im(dr, Cr, Ur) {
        var ui = $a(dr) ? Vc : Hf;
        return Ur && bs(dr, Cr, Ur) && (Cr = ie), ui(dr, pa(Cr, 3));
      }
      function Lv(dr, Cr) {
        var Ur = $a(dr) ? nu : Il;
        return Ur(dr, pa(Cr, 3));
      }
      var Iv = Du(eo), nm = Du(On);
      function Q1(dr, Cr) {
        return wa(i0(dr, Cr), 1);
      }
      function df(dr, Cr) {
        return wa(i0(dr, Cr), pr);
      }
      function om(dr, Cr, Ur) {
        return Ur = Ur === ie ? 1 : Va(Ur), wa(i0(dr, Cr), Ur);
      }
      function eg(dr, Cr) {
        var Ur = $a(dr) ? al : Wc;
        return Ur(dr, pa(Cr, 3));
      }
      function tg(dr, Cr) {
        var Ur = $a(dr) ? z0 : uh;
        return Ur(dr, pa(Cr, 3));
      }
      var Bv = fs(function(dr, Cr, Ur) {
        rs.call(dr, Ur) ? dr[Ur].push(Cr) : Hc(dr, Ur, [Cr]);
      });
      function $v(dr, Cr, Ur, ui) {
        dr = ac(dr) ? dr : gf(dr), Ur = Ur && !ui ? Va(Ur) : 0;
        var $i = dr.length;
        return Ur < 0 && (Ur = Os($i + Ur, 0)), fd(dr) ? Ur <= $i && dr.indexOf(Cr, Ur) > -1 : !!$i && Xu(dr, Cr, Ur) > -1;
      }
      var Rv = Ia(function(dr, Cr, Ur) {
        var ui = -1, $i = typeof Cr == "function", Qi = ac(dr) ? so(dr.length) : [];
        return Wc(dr, function(En) {
          Qi[++ui] = $i ? Ds(Cr, En, Ur) : Iu(En, Cr, Ur);
        }), Qi;
      }), Pv = fs(function(dr, Cr, Ur) {
        Hc(dr, Ur, Cr);
      });
      function i0(dr, Cr) {
        var Ur = $a(dr) ? Ms : Hp;
        return Ur(dr, pa(Cr, 3));
      }
      function Y0(dr, Cr, Ur, ui) {
        return dr == null ? [] : ($a(Cr) || (Cr = Cr == null ? [] : [Cr]), Ur = ui ? ie : Ur, $a(Ur) || (Ur = Ur == null ? [] : [Ur]), La(dr, Cr, Ur));
      }
      var Dv = fs(function(dr, Cr, Ur) {
        dr[Ur ? 0 : 1].push(Cr);
      }, function() {
        return [[], []];
      });
      function dp(dr, Cr, Ur) {
        var ui = $a(dr) ? Tf : Lp, $i = arguments.length < 3;
        return ui(dr, pa(Cr, 4), Ur, $i, Wc);
      }
      function Ov(dr, Cr, Ur) {
        var ui = $a(dr) ? Md : Lp, $i = arguments.length < 3;
        return ui(dr, pa(Cr, 4), Ur, $i, uh);
      }
      function Us(dr, Cr) {
        var Ur = $a(dr) ? nu : Il;
        return Ur(dr, fp(pa(Cr, 3)));
      }
      function n0(dr) {
        var Cr = $a(dr) ? Lu : Yf;
        return Cr(dr);
      }
      function rg(dr, Cr, Ur) {
        (Ur ? bs(dr, Cr, Ur) : Cr === ie) ? Cr = 1 : Cr = Va(Cr);
        var ui = $a(dr) ? lh : Jf;
        return ui(dr, Cr);
      }
      function o0(dr) {
        var Cr = $a(dr) ? Do : Ru;
        return Cr(dr);
      }
      function a0(dr) {
        if (dr == null)
          return 0;
        if (ac(dr))
          return fd(dr) ? Ac(dr) : dr.length;
        var Cr = zs(dr);
        return Cr == qi || Cr == In ? dr.size : Ql(dr).length;
      }
      function am(dr, Cr, Ur) {
        var ui = $a(dr) ? Cp : Kd;
        return Ur && bs(dr, Cr, Ur) && (Cr = ie), ui(dr, pa(Cr, 3));
      }
      var ig = Ia(function(dr, Cr) {
        if (dr == null)
          return [];
        var Ur = Cr.length;
        return Ur > 1 && bs(dr, Cr[0], Cr[1]) ? Cr = [] : Ur > 2 && bs(Cr[0], Cr[1], Cr[2]) && (Cr = [Cr[0]]), La(dr, wa(Cr, 1), []);
      }), sm = Pp || function() {
        return Rs.Date.now();
      };
      function lm(dr, Cr) {
        if (typeof Cr != "function")
          throw new Ml(Ze);
        return dr = Va(dr), function() {
          if (--dr < 1)
            return Cr.apply(this, arguments);
        };
      }
      function s0(dr, Cr, Ur) {
        return Cr = Ur ? ie : Cr, Cr = dr && Cr == null ? dr.length : Cr, pl(dr, xi, ie, ie, ie, ie, Cr);
      }
      function cm(dr, Cr) {
        var Ur;
        if (typeof Cr != "function")
          throw new Ml(Ze);
        return dr = Va(dr), function() {
          return --dr > 0 && (Ur = Cr.apply(this, arguments)), dr <= 1 && (Cr = ie), Ur;
        };
      }
      var J0 = Ia(function(dr, Cr, Ur) {
        var ui = Nr;
        if (Ur.length) {
          var $i = au(Ur, Ou(J0));
          ui |= si;
        }
        return pl(dr, ui, Cr, Ur, $i);
      }), Q0 = Ia(function(dr, Cr, Ur) {
        var ui = Nr | Yr;
        if (Ur.length) {
          var $i = au(Ur, Ou(Q0));
          ui |= si;
        }
        return pl(Cr, ui, dr, Ur, $i);
      });
      function l0(dr, Cr, Ur) {
        Cr = Ur ? ie : Cr;
        var ui = pl(dr, Xr, ie, ie, ie, ie, ie, Cr);
        return ui.placeholder = l0.placeholder, ui;
      }
      function c0(dr, Cr, Ur) {
        Cr = Ur ? ie : Cr;
        var ui = pl(dr, Wr, ie, ie, ie, ie, ie, Cr);
        return ui.placeholder = c0.placeholder, ui;
      }
      function u0(dr, Cr, Ur) {
        var ui, $i, Qi, En, Dn, Zn, wo = 0, So = !1, ko = !1, Vo = !0;
        if (typeof dr != "function")
          throw new Ml(Ze);
        Cr = wc(Cr) || 0, $s(Ur) && (So = !!Ur.leading, ko = "maxWait" in Ur, Qi = ko ? Os(wc(Ur.maxWait) || 0, Cr) : Qi, Vo = "trailing" in Ur ? !!Ur.trailing : Vo);
        function na(Ks) {
          var yu = ui, Eh = $i;
          return ui = $i = ie, wo = Ks, En = dr.apply(Eh, yu), En;
        }
        function Sa(Ks) {
          return wo = Ks, Dn = bi(Qa, Cr), So ? na(Ks) : En;
        }
        function Ua(Ks) {
          var yu = Ks - Zn, Eh = Ks - wo, Em = Cr - yu;
          return ko ? Qs(Em, Qi - Eh) : Em;
        }
        function ya(Ks) {
          var yu = Ks - Zn, Eh = Ks - wo;
          return Zn === ie || yu >= Cr || yu < 0 || ko && Eh >= Qi;
        }
        function Qa() {
          var Ks = sm();
          if (ya(Ks))
            return ns(Ks);
          Dn = bi(Qa, Ua(Ks));
        }
        function ns(Ks) {
          return Dn = ie, Vo && ui ? na(Ks) : (ui = $i = ie, En);
        }
        function Dc() {
          Dn !== ie && Zp(Dn), wo = 0, ui = Zn = $i = Dn = ie;
        }
        function Gl() {
          return Dn === ie ? En : ns(sm());
        }
        function Oc() {
          var Ks = sm(), yu = ya(Ks);
          if (ui = arguments, $i = this, Zn = Ks, yu) {
            if (Dn === ie)
              return Sa(Zn);
            if (ko)
              return Zp(Dn), Dn = bi(Qa, Cr), na(Zn);
          }
          return Dn === ie && (Dn = bi(Qa, Cr)), En;
        }
        return Oc.cancel = Dc, Oc.flush = Gl, Oc;
      }
      var ng = Ia(function(dr, Cr) {
        return kl(dr, 1, Cr);
      }), og = Ia(function(dr, Cr, Ur) {
        return kl(dr, wc(Cr) || 0, Ur);
      });
      function ag(dr) {
        return pl(dr, oi);
      }
      function um(dr, Cr) {
        if (typeof dr != "function" || Cr != null && typeof Cr != "function")
          throw new Ml(Ze);
        var Ur = function() {
          var ui = arguments, $i = Cr ? Cr.apply(this, ui) : ui[0], Qi = Ur.cache;
          if (Qi.has($i))
            return Qi.get($i);
          var En = dr.apply(this, ui);
          return Ur.cache = Qi.set($i, En) || Qi, En;
        };
        return Ur.cache = new (um.Cache || mc)(), Ur;
      }
      um.Cache = mc;
      function fp(dr) {
        if (typeof dr != "function")
          throw new Ml(Ze);
        return function() {
          var Cr = arguments;
          switch (Cr.length) {
            case 0:
              return !dr.call(this);
            case 1:
              return !dr.call(this, Cr[0]);
            case 2:
              return !dr.call(this, Cr[0], Cr[1]);
            case 3:
              return !dr.call(this, Cr[0], Cr[1], Cr[2]);
          }
          return !dr.apply(this, Cr);
        };
      }
      function Nu(dr) {
        return cm(2, dr);
      }
      var sg = rp(function(dr, Cr) {
        Cr = Cr.length == 1 && $a(Cr[0]) ? Ms(Cr[0], xl(pa())) : Ms(wa(Cr, 1), xl(pa()));
        var Ur = Cr.length;
        return Ia(function(ui) {
          for (var $i = -1, Qi = Qs(ui.length, Ur); ++$i < Qi; )
            ui[$i] = Cr[$i].call(this, ui[$i]);
          return Ds(dr, this, ui);
        });
      }), e1 = Ia(function(dr, Cr) {
        var Ur = au(Cr, Ou(e1));
        return pl(dr, si, ie, Cr, Ur);
      }), lg = Ia(function(dr, Cr) {
        var Ur = au(Cr, Ou(lg));
        return pl(dr, li, ie, Cr, Ur);
      }), zv = fu(function(dr, Cr) {
        return pl(dr, di, ie, ie, ie, Cr);
      });
      function Fv(dr, Cr) {
        if (typeof dr != "function")
          throw new Ml(Ze);
        return Cr = Cr === ie ? Cr : Va(Cr), Ia(dr, Cr);
      }
      function Nv(dr, Cr) {
        if (typeof dr != "function")
          throw new Ml(Ze);
        return Cr = Cr == null ? 0 : Os(Va(Cr), 0), Ia(function(Ur) {
          var ui = Ur[Cr], $i = rc(Ur, 0, Cr);
          return ui && Sc($i, ui), Ds(dr, this, $i);
        });
      }
      function Vv(dr, Cr, Ur) {
        var ui = !0, $i = !0;
        if (typeof dr != "function")
          throw new Ml(Ze);
        return $s(Ur) && (ui = "leading" in Ur ? !!Ur.leading : ui, $i = "trailing" in Ur ? !!Ur.trailing : $i), u0(dr, Cr, {
          leading: ui,
          maxWait: Cr,
          trailing: $i
        });
      }
      function Uv(dr) {
        return s0(dr, 1);
      }
      function t1(dr, Cr) {
        return e1(od(Cr), dr);
      }
      function cg() {
        if (!arguments.length)
          return [];
        var dr = arguments[0];
        return $a(dr) ? dr : [dr];
      }
      function r1(dr) {
        return Ul(dr, Ir);
      }
      function ug(dr, Cr) {
        return Cr = typeof Cr == "function" ? Cr : ie, Ul(dr, Ir, Cr);
      }
      function i1(dr) {
        return Ul(dr, _r | Ir);
      }
      function hg(dr, Cr) {
        return Cr = typeof Cr == "function" ? Cr : ie, Ul(dr, _r | Ir, Cr);
      }
      function dg(dr, Cr) {
        return Cr == null || jd(dr, Cr, vl(Cr));
      }
      function bc(dr, Cr) {
        return dr === Cr || dr !== dr && Cr !== Cr;
      }
      var fg = sp(lo), pg = sp(function(dr, Cr) {
        return dr >= Cr;
      }), dd = Zf(function() {
        return arguments;
      }()) ? Zf : function(dr) {
        return js(dr) && rs.call(dr, "callee") && !Qu.call(dr, "callee");
      }, $a = so.isArray, ff = ds ? xl(ds) : Zm;
      function ac(dr) {
        return dr != null && dm(dr.length) && !Mh(dr);
      }
      function Bs(dr) {
        return js(dr) && ac(dr);
      }
      function mg(dr) {
        return dr === !0 || dr === !1 || js(dr) && Zs(dr) == mi;
      }
      var wh = Rd || w0, h0 = dc ? xl(dc) : Xm;
      function gg(dr) {
        return js(dr) && dr.nodeType === 1 && !Qc(dr);
      }
      function d0(dr) {
        if (dr == null)
          return !0;
        if (ac(dr) && ($a(dr) || typeof dr == "string" || typeof dr.splice == "function" || wh(dr) || mf(dr) || dd(dr)))
          return !dr.length;
        var Cr = zs(dr);
        if (Cr == qi || Cr == In)
          return !dr.size;
        if (ke(dr))
          return !Ql(dr).length;
        for (var Ur in dr)
          if (rs.call(dr, Ur))
            return !1;
        return !0;
      }
      function vg(dr, Cr) {
        return Qh(dr, Cr);
      }
      function n1(dr, Cr, Ur) {
        Ur = typeof Ur == "function" ? Ur : ie;
        var ui = Ur ? Ur(dr, Cr) : ie;
        return ui === ie ? Qh(dr, Cr, ie, Ur) : !!ui;
      }
      function hm(dr) {
        if (!js(dr))
          return !1;
        var Cr = Zs(dr);
        return Cr == pi || Cr == Zr || typeof dr.message == "string" && typeof dr.name == "string" && !Qc(dr);
      }
      function _g(dr) {
        return typeof dr == "number" && Vh(dr);
      }
      function Mh(dr) {
        if (!$s(dr))
          return !1;
        var Cr = Zs(dr);
        return Cr == hi || Cr == Oi || Cr == ii || Cr == ji;
      }
      function o1(dr) {
        return typeof dr == "number" && dr == Va(dr);
      }
      function dm(dr) {
        return typeof dr == "number" && dr > -1 && dr % 1 == 0 && dr <= br;
      }
      function $s(dr) {
        var Cr = typeof dr;
        return dr != null && (Cr == "object" || Cr == "function");
      }
      function js(dr) {
        return dr != null && typeof dr == "object";
      }
      var f0 = Yl ? xl(Yl) : W0;
      function yg(dr, Cr) {
        return dr === Cr || Bu(dr, Cr, cf(Cr));
      }
      function a1(dr, Cr, Ur) {
        return Ur = typeof Ur == "function" ? Ur : ie, Bu(dr, Cr, cf(Cr), Ur);
      }
      function jv(dr) {
        return s1(dr) && dr != +dr;
      }
      function qv(dr) {
        if (xe(dr))
          throw new ka(Me);
        return Xf(dr);
      }
      function Gv(dr) {
        return dr === null;
      }
      function Hv(dr) {
        return dr == null;
      }
      function s1(dr) {
        return typeof dr == "number" || js(dr) && Zs(dr) == yn;
      }
      function Qc(dr) {
        if (!js(dr) || Zs(dr) != $n)
          return !1;
        var Cr = Ld(dr);
        if (Cr === null)
          return !0;
        var Ur = rs.call(Cr, "constructor") && Cr.constructor;
        return typeof Ur == "function" && Ur instanceof Ur && Uc.call(Ur) == kd;
      }
      var pf = Ts ? xl(Ts) : Gd;
      function fm(dr) {
        return o1(dr) && dr >= -br && dr <= br;
      }
      var pm = $h ? xl($h) : td;
      function fd(dr) {
        return typeof dr == "string" || !$a(dr) && js(dr) && Zs(dr) == Fn;
      }
      function xc(dr) {
        return typeof dr == "symbol" || js(dr) && Zs(dr) == Po;
      }
      var mf = Jl ? xl(Jl) : Km;
      function bg(dr) {
        return dr === ie;
      }
      function xg(dr) {
        return js(dr) && zs(dr) == Vn;
      }
      function Wv(dr) {
        return js(dr) && Zs(dr) == Xo;
      }
      var Zv = sp(fl), wg = sp(function(dr, Cr) {
        return dr <= Cr;
      });
      function mm(dr) {
        if (!dr)
          return [];
        if (ac(dr))
          return fd(dr) ? wl(dr) : $l(dr);
        if (Id && dr[Id])
          return If(dr[Id]());
        var Cr = zs(dr), Ur = Cr == qi ? Tc : Cr == In ? Ku : gf;
        return Ur(dr);
      }
      function Vu(dr) {
        if (!dr)
          return dr === 0 ? dr : 0;
        if (dr = wc(dr), dr === pr || dr === -pr) {
          var Cr = dr < 0 ? -1 : 1;
          return Cr * nr;
        }
        return dr === dr ? dr : 0;
      }
      function Va(dr) {
        var Cr = Vu(dr), Ur = Cr % 1;
        return Cr === Cr ? Ur ? Cr - Ur : Cr : 0;
      }
      function l1(dr) {
        return dr ? Sl(Va(dr), 0, ur) : 0;
      }
      function wc(dr) {
        if (typeof dr == "number")
          return dr;
        if (xc(dr))
          return Pe;
        if ($s(dr)) {
          var Cr = typeof dr.valueOf == "function" ? dr.valueOf() : dr;
          dr = $s(Cr) ? Cr + "" : Cr;
        }
        if (typeof dr != "string")
          return dr === 0 ? dr : +dr;
        dr = ta(dr);
        var Ur = $o.test(dr);
        return Ur || Qo.test(dr) ? Ef(dr.slice(2), Ur ? 2 : 8) : Co.test(dr) ? Pe : +dr;
      }
      function c1(dr) {
        return Bc(dr, sc(dr));
      }
      function Mg(dr) {
        return dr ? Sl(Va(dr), -br, br) : dr === 0 ? dr : 0;
      }
      function ms(dr) {
        return dr == null ? "" : Tl(dr);
      }
      var Sg = vh(function(dr, Cr) {
        if (ke(Cr) || ac(Cr)) {
          Bc(Cr, vl(Cr), dr);
          return;
        }
        for (var Ur in Cr)
          rs.call(Cr, Ur) && Xh(dr, Ur, Cr[Ur]);
      }), u1 = vh(function(dr, Cr) {
        Bc(Cr, sc(Cr), dr);
      }), p0 = vh(function(dr, Cr, Ur, ui) {
        Bc(Cr, sc(Cr), dr, ui);
      }), Eg = vh(function(dr, Cr, Ur, ui) {
        Bc(Cr, vl(Cr), dr, ui);
      }), Cg = fu(jp);
      function gm(dr, Cr) {
        var Ur = Tu(dr);
        return Cr == null ? Ur : Ud(Ur, Cr);
      }
      var Tg = Ia(function(dr, Cr) {
        dr = _s(dr);
        var Ur = -1, ui = Cr.length, $i = ui > 2 ? Cr[2] : ie;
        for ($i && bs(Cr[0], Cr[1], $i) && (ui = 1); ++Ur < ui; )
          for (var Qi = Cr[Ur], En = sc(Qi), Dn = -1, Zn = En.length; ++Dn < Zn; ) {
            var wo = En[Dn], So = dr[wo];
            (So === ie || bc(So, lu[wo]) && !rs.call(dr, wo)) && (dr[wo] = Qi[wo]);
          }
        return dr;
      }), Ag = Ia(function(dr) {
        return dr.push(ie, hu), Ds(m1, ie, dr);
      });
      function Xv(dr, Cr) {
        return Tp(dr, pa(Cr, 3), El);
      }
      function Kv(dr, Cr) {
        return Tp(dr, pa(Cr, 3), Wf);
      }
      function Yv(dr, Cr) {
        return dr == null ? dr : hh(dr, pa(Cr, 3), sc);
      }
      function Jv(dr, Cr) {
        return dr == null ? dr : fh(dr, pa(Cr, 3), sc);
      }
      function Qv(dr, Cr) {
        return dr && El(dr, pa(Cr, 3));
      }
      function e_(dr, Cr) {
        return dr && Wf(dr, pa(Cr, 3));
      }
      function t_(dr) {
        return dr == null ? [] : qd(dr, vl(dr));
      }
      function kg(dr) {
        return dr == null ? [] : qd(dr, sc(dr));
      }
      function h1(dr, Cr, Ur) {
        var ui = dr == null ? ie : ph(dr, Cr);
        return ui === ie ? Ur : ui;
      }
      function r_(dr, Cr) {
        return dr != null && mu(dr, Cr, Mo);
      }
      function d1(dr, Cr) {
        return dr != null && mu(dr, Cr, Jh);
      }
      var f1 = of(function(dr, Cr, Ur) {
        Cr != null && typeof Cr.toString != "function" && (Cr = fc.call(Cr)), dr[Cr] = Ur;
      }, _0(lc)), p1 = of(function(dr, Cr, Ur) {
        Cr != null && typeof Cr.toString != "function" && (Cr = fc.call(Cr)), rs.call(dr, Cr) ? dr[Cr].push(Ur) : dr[Cr] = [Ur];
      }, pa), Lg = Ia(Iu);
      function vl(dr) {
        return ac(dr) ? ku(dr) : Ql(dr);
      }
      function sc(dr) {
        return ac(dr) ? ku(dr, !0) : Hd(dr);
      }
      function Ig(dr, Cr) {
        var Ur = {};
        return Cr = pa(Cr, 3), El(dr, function(ui, $i, Qi) {
          Hc(Ur, Cr(ui, $i, Qi), ui);
        }), Ur;
      }
      function Bg(dr, Cr) {
        var Ur = {};
        return Cr = pa(Cr, 3), El(dr, function(ui, $i, Qi) {
          Hc(Ur, $i, Cr(ui, $i, Qi));
        }), Ur;
      }
      var $g = vh(function(dr, Cr, Ur) {
        Kf(dr, Cr, Ur);
      }), m1 = vh(function(dr, Cr, Ur, ui) {
        Kf(dr, Cr, Ur, ui);
      }), Rg = fu(function(dr, Cr) {
        var Ur = {};
        if (dr == null)
          return Ur;
        var ui = !1;
        Cr = Ms(Cr, function(Qi) {
          return Qi = Ic(Qi, dr), ui || (ui = Qi.length > 1), Qi;
        }), Bc(dr, cp(dr), Ur), ui && (Ur = Ul(Ur, _r | Lr | Ir, bh));
        for (var $i = Cr.length; $i--; )
          Kc(Ur, Cr[$i]);
        return Ur;
      });
      function g1(dr, Cr) {
        return Dg(dr, fp(pa(Cr)));
      }
      var Pg = fu(function(dr, Cr) {
        return dr == null ? {} : Zd(dr, Cr);
      });
      function Dg(dr, Cr) {
        if (dr == null)
          return {};
        var Ur = Ms(cp(dr), function(ui) {
          return [ui];
        });
        return Cr = pa(Cr), Zc(dr, Ur, function(ui, $i) {
          return Cr(ui, $i[0]);
        });
      }
      function vm(dr, Cr, Ur) {
        Cr = Ic(Cr, dr);
        var ui = -1, $i = Cr.length;
        for ($i || ($i = 1, dr = ie); ++ui < $i; ) {
          var Qi = dr == null ? ie : dr[zi(Cr[ui])];
          Qi === ie && (ui = $i, Qi = Ur), dr = Mh(Qi) ? Qi.call(dr) : Qi;
        }
        return dr;
      }
      function Og(dr, Cr, Ur) {
        return dr == null ? dr : gh(dr, Cr, Ur);
      }
      function i_(dr, Cr, Ur, ui) {
        return ui = typeof ui == "function" ? ui : ie, dr == null ? dr : gh(dr, Cr, Ur, ui);
      }
      var zg = yh(vl), Fg = yh(sc);
      function n_(dr, Cr, Ur) {
        var ui = $a(dr), $i = ui || wh(dr) || mf(dr);
        if (Cr = pa(Cr, 4), Ur == null) {
          var Qi = dr && dr.constructor;
          $i ? Ur = ui ? new Qi() : [] : $s(dr) ? Ur = Mh(Qi) ? Tu(Ld(dr)) : {} : Ur = {};
        }
        return ($i ? al : El)(dr, function(En, Dn, Zn) {
          return Cr(Ur, En, Dn, Zn);
        }), Ur;
      }
      function o_(dr, Cr) {
        return dr == null ? !0 : Kc(dr, Cr);
      }
      function a_(dr, Cr, Ur) {
        return dr == null ? dr : ep(dr, Cr, od(Ur));
      }
      function s_(dr, Cr, Ur, ui) {
        return ui = typeof ui == "function" ? ui : ie, dr == null ? dr : ep(dr, Cr, od(Ur), ui);
      }
      function gf(dr) {
        return dr == null ? [] : Cc(dr, vl(dr));
      }
      function l_(dr) {
        return dr == null ? [] : Cc(dr, sc(dr));
      }
      function _l(dr, Cr, Ur) {
        return Ur === ie && (Ur = Cr, Cr = ie), Ur !== ie && (Ur = wc(Ur), Ur = Ur === Ur ? Ur : 0), Cr !== ie && (Cr = wc(Cr), Cr = Cr === Cr ? Cr : 0), Sl(wc(dr), Cr, Ur);
      }
      function _u(dr, Cr, Ur) {
        return Cr = Vu(Cr), Ur === ie ? (Ur = Cr, Cr = 0) : Ur = Vu(Ur), dr = wc(dr), ys(dr, Cr, Ur);
      }
      function m0(dr, Cr, Ur) {
        if (Ur && typeof Ur != "boolean" && bs(dr, Cr, Ur) && (Cr = Ur = ie), Ur === ie && (typeof Cr == "boolean" ? (Ur = Cr, Cr = ie) : typeof dr == "boolean" && (Ur = dr, dr = ie)), dr === ie && Cr === ie ? (dr = 0, Cr = 1) : (dr = Vu(dr), Cr === ie ? (Cr = dr, dr = 0) : Cr = Vu(Cr)), dr > Cr) {
          var ui = dr;
          dr = Cr, Cr = ui;
        }
        if (Ur || dr % 1 || Cr % 1) {
          var $i = Df();
          return Qs(dr + $i * (Cr - dr + wd("1e-" + (($i + "").length - 1))), Cr);
        }
        return Xd(dr, Cr);
      }
      var v1 = uu(function(dr, Cr, Ur) {
        return Cr = Cr.toLowerCase(), dr + (Ur ? _m(Cr) : Cr);
      });
      function _m(dr) {
        return M1(ms(dr).toLowerCase());
      }
      function vf(dr) {
        return dr = ms(dr), dr && dr.replace(No, Oh).replace(Bh, "");
      }
      function c_(dr, Cr, Ur) {
        dr = ms(dr), Cr = Tl(Cr);
        var ui = dr.length;
        Ur = Ur === ie ? ui : Sl(Va(Ur), 0, ui);
        var $i = Ur;
        return Ur -= Cr.length, Ur >= 0 && dr.slice(Ur, $i) == Cr;
      }
      function u_(dr) {
        return dr = ms(dr), dr && ma.test(dr) ? dr.replace(to, Td) : dr;
      }
      function ym(dr) {
        return dr = ms(dr), dr && ki.test(dr) ? dr.replace(Ai, "\\$&") : dr;
      }
      var h_ = uu(function(dr, Cr, Ur) {
        return dr + (Ur ? "-" : "") + Cr.toLowerCase();
      }), d_ = uu(function(dr, Cr, Ur) {
        return dr + (Ur ? " " : "") + Cr.toLowerCase();
      }), Ng = op("toLowerCase");
      function y1(dr, Cr, Ur) {
        dr = ms(dr), Cr = Va(Cr);
        var ui = Cr ? Ac(dr) : 0;
        if (!Cr || ui >= Cr)
          return dr;
        var $i = (Cr - ui) / 2;
        return ap($d($i), Ur) + dr + ap(Bd($i), Ur);
      }
      function Vg(dr, Cr, Ur) {
        dr = ms(dr), Cr = Va(Cr);
        var ui = Cr ? Ac(dr) : 0;
        return Cr && ui < Cr ? dr + ap(Cr - ui, Ur) : dr;
      }
      function b1(dr, Cr, Ur) {
        dr = ms(dr), Cr = Va(Cr);
        var ui = Cr ? Ac(dr) : 0;
        return Cr && ui < Cr ? ap(Cr - ui, Ur) + dr : dr;
      }
      function f_(dr, Cr, Ur) {
        return Ur || Cr == null ? Cr = 0 : Cr && (Cr = +Cr), zp(ms(dr).replace(an, ""), Cr || 0);
      }
      function Ug(dr, Cr, Ur) {
        return (Ur ? bs(dr, Cr, Ur) : Cr === ie) ? Cr = 1 : Cr = Va(Cr), Xc(ms(dr), Cr);
      }
      function g0() {
        var dr = arguments, Cr = ms(dr[0]);
        return dr.length < 3 ? Cr : Cr.replace(dr[1], dr[2]);
      }
      var x1 = uu(function(dr, Cr, Ur) {
        return dr + (Ur ? "_" : "") + Cr.toLowerCase();
      });
      function p_(dr, Cr, Ur) {
        return Ur && typeof Ur != "number" && bs(dr, Cr, Ur) && (Cr = Ur = ie), Ur = Ur === ie ? ur : Ur >>> 0, Ur ? (dr = ms(dr), dr && (typeof Cr == "string" || Cr != null && !pf(Cr)) && (Cr = Tl(Cr), !Cr && ou(dr)) ? rc(wl(dr), 0, Ur) : dr.split(Cr, Ur)) : [];
      }
      var m_ = uu(function(dr, Cr, Ur) {
        return dr + (Ur ? " " : "") + M1(Cr);
      });
      function g_(dr, Cr, Ur) {
        return dr = ms(dr), Ur = Ur == null ? 0 : Sl(Va(Ur), 0, dr.length), Cr = Tl(Cr), dr.slice(Ur, Ur + Cr.length) == Cr;
      }
      function jg(dr, Cr, Ur) {
        var ui = Zi.templateSettings;
        Ur && bs(dr, Cr, Ur) && (Cr = ie), dr = ms(dr), Cr = p0({}, Cr, ui, vc);
        var $i = p0({}, Cr.imports, ui.imports, vc), Qi = vl($i), En = Cc($i, Qi), Dn, Zn, wo = 0, So = Cr.interpolate || Zo, ko = "__p += '", Vo = Ad(
          (Cr.escape || Zo).source + "|" + So.source + "|" + (So === kn ? Tn : Zo).source + "|" + (Cr.evaluate || Zo).source + "|$",
          "g"
        ), na = "//# sourceURL=" + (rs.call(Cr, "sourceURL") ? (Cr.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ga + "]") + `
`;
        dr.replace(Vo, function(ya, Qa, ns, Dc, Gl, Oc) {
          return ns || (ns = Dc), ko += dr.slice(wo, Oc).replace(ea, ll), Qa && (Dn = !0, ko += `' +
__e(` + Qa + `) +
'`), Gl && (Zn = !0, ko += `';
` + Gl + `;
__p += '`), ns && (ko += `' +
((__t = (` + ns + `)) == null ? '' : __t) +
'`), wo = Oc + ya.length, ya;
        }), ko += `';
`;
        var Sa = rs.call(Cr, "variable") && Cr.variable;
        if (!Sa)
          ko = `with (obj) {
` + ko + `
}
`;
        else if (qn.test(Sa))
          throw new ka(ne);
        ko = (Zn ? ko.replace(Mn, "") : ko).replace(pn, "$1").replace(Rn, "$1;"), ko = "function(" + (Sa || "obj") + `) {
` + (Sa ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Dn ? ", __e = _.escape" : "") + (Zn ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ko + `return __p
}`;
        var Ua = E1(function() {
          return za(Qi, na + "return " + ko).apply(ie, En);
        });
        if (Ua.source = ko, hm(Ua))
          throw Ua;
        return Ua;
      }
      function Pc(dr) {
        return ms(dr).toLowerCase();
      }
      function bm(dr) {
        return ms(dr).toUpperCase();
      }
      function pp(dr, Cr, Ur) {
        if (dr = ms(dr), dr && (Ur || Cr === ie))
          return ta(dr);
        if (!dr || !(Cr = Tl(Cr)))
          return dr;
        var ui = wl(dr), $i = wl(Cr), Qi = Lf(ui, $i), En = Cd(ui, $i) + 1;
        return rc(ui, Qi, En).join("");
      }
      function w1(dr, Cr, Ur) {
        if (dr = ms(dr), dr && (Ur || Cr === ie))
          return dr.slice(0, Rm(dr) + 1);
        if (!dr || !(Cr = Tl(Cr)))
          return dr;
        var ui = wl(dr), $i = Cd(ui, wl(Cr)) + 1;
        return rc(ui, 0, $i).join("");
      }
      function v0(dr, Cr, Ur) {
        if (dr = ms(dr), dr && (Ur || Cr === ie))
          return dr.replace(an, "");
        if (!dr || !(Cr = Tl(Cr)))
          return dr;
        var ui = wl(dr), $i = Lf(ui, wl(Cr));
        return rc(ui, $i).join("");
      }
      function v_(dr, Cr) {
        var Ur = ci, ui = vr;
        if ($s(Cr)) {
          var $i = "separator" in Cr ? Cr.separator : $i;
          Ur = "length" in Cr ? Va(Cr.length) : Ur, ui = "omission" in Cr ? Tl(Cr.omission) : ui;
        }
        dr = ms(dr);
        var Qi = dr.length;
        if (ou(dr)) {
          var En = wl(dr);
          Qi = En.length;
        }
        if (Ur >= Qi)
          return dr;
        var Dn = Ur - Ac(ui);
        if (Dn < 1)
          return ui;
        var Zn = En ? rc(En, 0, Dn).join("") : dr.slice(0, Dn);
        if ($i === ie)
          return Zn + ui;
        if (En && (Dn += Zn.length - Dn), pf($i)) {
          if (dr.slice(Dn).search($i)) {
            var wo, So = Zn;
            for ($i.global || ($i = Ad($i.source, ms(xo.exec($i)) + "g")), $i.lastIndex = 0; wo = $i.exec(So); )
              var ko = wo.index;
            Zn = Zn.slice(0, ko === ie ? Dn : ko);
          }
        } else if (dr.indexOf(Tl($i), Dn) != Dn) {
          var Vo = Zn.lastIndexOf($i);
          Vo > -1 && (Zn = Zn.slice(0, Vo));
        }
        return Zn + ui;
      }
      function qg(dr) {
        return dr = ms(dr), dr && no.test(dr) ? dr.replace(Io, N0) : dr;
      }
      var Gg = uu(function(dr, Cr, Ur) {
        return dr + (Ur ? " " : "") + Cr.toUpperCase();
      }), M1 = op("toUpperCase");
      function S1(dr, Cr, Ur) {
        return dr = ms(dr), Cr = Ur ? ie : Cr, Cr === ie ? vo(dr) ? Dm(dr) : Ed(dr) : dr.match(Cr) || [];
      }
      var E1 = Ia(function(dr, Cr) {
        try {
          return Ds(dr, ie, Cr);
        } catch (Ur) {
          return hm(Ur) ? Ur : new ka(Ur);
        }
      }), C1 = fu(function(dr, Cr) {
        return al(Cr, function(Ur) {
          Ur = zi(Ur), Hc(dr, Ur, J0(dr[Ur], dr));
        }), dr;
      });
      function Hg(dr) {
        var Cr = dr == null ? 0 : dr.length, Ur = pa();
        return dr = Cr ? Ms(dr, function(ui) {
          if (typeof ui[1] != "function")
            throw new Ml(Ze);
          return [Ur(ui[0]), ui[1]];
        }) : [], Ia(function(ui) {
          for (var $i = -1; ++$i < Cr; ) {
            var Qi = dr[$i];
            if (Ds(Qi[0], this, ui))
              return Ds(Qi[1], this, ui);
          }
        });
      }
      function __(dr) {
        return qp(Ul(dr, _r));
      }
      function _0(dr) {
        return function() {
          return dr;
        };
      }
      function Sh(dr, Cr) {
        return dr == null || dr !== dr ? Cr : dr;
      }
      var Wg = Ss(), Zg = Ss(!0);
      function lc(dr) {
        return dr;
      }
      function y0(dr) {
        return Gp(typeof dr == "function" ? dr : Ul(dr, _r));
      }
      function y_(dr) {
        return Ym(Ul(dr, _r));
      }
      function b_(dr, Cr) {
        return Cl(dr, Ul(Cr, _r));
      }
      var Xg = Ia(function(dr, Cr) {
        return function(Ur) {
          return Iu(Ur, dr, Cr);
        };
      }), Kg = Ia(function(dr, Cr) {
        return function(Ur) {
          return Iu(dr, Ur, Cr);
        };
      });
      function b0(dr, Cr, Ur) {
        var ui = vl(Cr), $i = qd(Cr, ui);
        Ur == null && !($s(Cr) && ($i.length || !ui.length)) && (Ur = Cr, Cr = dr, dr = this, $i = qd(Cr, vl(Cr)));
        var Qi = !($s(Ur) && "chain" in Ur) || !!Ur.chain, En = Mh(dr);
        return al($i, function(Dn) {
          var Zn = Cr[Dn];
          dr[Dn] = Zn, En && (dr.prototype[Dn] = function() {
            var wo = this.__chain__;
            if (Qi || wo) {
              var So = dr(this.__wrapped__), ko = So.__actions__ = $l(this.__actions__);
              return ko.push({ func: Zn, args: arguments, thisArg: dr }), So.__chain__ = wo, So;
            }
            return Zn.apply(dr, Sc([this.value()], arguments));
          });
        }), dr;
      }
      function xm() {
        return Rs._ === this && (Rs._ = $f), this;
      }
      function wm() {
      }
      function Yg(dr) {
        return dr = Va(dr), Ia(function(Cr) {
          return Ka(Cr, dr);
        });
      }
      var Mm = sd(Ms), Jg = sd(Vc), Qg = sd(Cp);
      function eu(dr) {
        return Fs(dr) ? Ap(zi(dr)) : rd(dr);
      }
      function T1(dr) {
        return function(Cr) {
          return dr == null ? ie : ph(dr, Cr);
        };
      }
      var mp = t0(), pd = t0(!0);
      function x0() {
        return [];
      }
      function w0() {
        return !1;
      }
      function M0() {
        return {};
      }
      function ev() {
        return "";
      }
      function S0() {
        return !0;
      }
      function E0(dr, Cr) {
        if (dr = Va(dr), dr < 1 || dr > br)
          return [];
        var Ur = ur, ui = Qs(dr, ur);
        Cr = pa(Cr), dr -= ur;
        for (var $i = Oo(ui, Cr); ++Ur < dr; )
          Cr(Ur);
        return $i;
      }
      function x_(dr) {
        return $a(dr) ? Ms(dr, zi) : xc(dr) ? [dr] : $l(Ni(ms(dr)));
      }
      function w_(dr) {
        var Cr = ++Ju;
        return ms(dr) + Cr;
      }
      var M_ = _h(function(dr, Cr) {
        return dr + Cr;
      }, 0), gp = lf("ceil"), A1 = _h(function(dr, Cr) {
        return dr / Cr;
      }, 1), S_ = lf("floor");
      function tv(dr) {
        return dr && dr.length ? Yh(dr, lc, lo) : ie;
      }
      function k1(dr, Cr) {
        return dr && dr.length ? Yh(dr, pa(Cr, 2), lo) : ie;
      }
      function E_(dr) {
        return $m(dr, lc);
      }
      function Sm(dr, Cr) {
        return $m(dr, pa(Cr, 2));
      }
      function md(dr) {
        return dr && dr.length ? Yh(dr, lc, fl) : ie;
      }
      function rv(dr, Cr) {
        return dr && dr.length ? Yh(dr, pa(Cr, 2), fl) : ie;
      }
      var iv = _h(function(dr, Cr) {
        return dr * Cr;
      }, 1), C0 = lf("round"), L1 = _h(function(dr, Cr) {
        return dr - Cr;
      }, 0);
      function C_(dr) {
        return dr && dr.length ? aa(dr, lc) : 0;
      }
      function nv(dr, Cr) {
        return dr && dr.length ? aa(dr, pa(Cr, 2)) : 0;
      }
      return Zi.after = lm, Zi.ary = s0, Zi.assign = Sg, Zi.assignIn = u1, Zi.assignInWith = p0, Zi.assignWith = Eg, Zi.at = Cg, Zi.before = cm, Zi.bind = J0, Zi.bindAll = C1, Zi.bindKey = Q0, Zi.castArray = cg, Zi.chain = G1, Zi.chunk = Gi, Zi.compact = nn, Zi.concat = dn, Zi.cond = Hg, Zi.conforms = __, Zi.constant = _0, Zi.countBy = J1, Zi.create = gm, Zi.curry = l0, Zi.curryRight = c0, Zi.debounce = u0, Zi.defaults = Tg, Zi.defaultsDeep = Ag, Zi.defer = ng, Zi.delay = og, Zi.difference = Pn, Zi.differenceBy = Ln, Zi.differenceWith = hn, Zi.drop = xn, Zi.dropRight = Hn, Zi.dropRightWhile = io, Zi.dropWhile = uo, Zi.fill = An, Zi.filter = Lv, Zi.flatMap = Q1, Zi.flatMapDeep = df, Zi.flatMapDepth = om, Zi.flatten = ao, Zi.flattenDeep = ro, Zi.flattenDepth = Wn, Zi.flip = ag, Zi.flow = Wg, Zi.flowRight = Zg, Zi.fromPairs = _o, Zi.functions = t_, Zi.functionsIn = kg, Zi.groupBy = Bv, Zi.initial = Eo, Zi.intersection = Ko, Zi.intersectionBy = Fo, Zi.intersectionWith = zo, Zi.invert = f1, Zi.invertBy = p1, Zi.invokeMap = Rv, Zi.iteratee = y0, Zi.keyBy = Pv, Zi.keys = vl, Zi.keysIn = sc, Zi.map = i0, Zi.mapKeys = Ig, Zi.mapValues = Bg, Zi.matches = y_, Zi.matchesProperty = b_, Zi.memoize = um, Zi.merge = $g, Zi.mergeWith = m1, Zi.method = Xg, Zi.methodOf = Kg, Zi.mixin = b0, Zi.negate = fp, Zi.nthArg = Yg, Zi.omit = Rg, Zi.omitBy = g1, Zi.once = Nu, Zi.orderBy = Y0, Zi.over = Mm, Zi.overArgs = sg, Zi.overEvery = Jg, Zi.overSome = Qg, Zi.partial = e1, Zi.partialRight = lg, Zi.partition = Dv, Zi.pick = Pg, Zi.pickBy = Dg, Zi.property = eu, Zi.propertyOf = T1, Zi.pull = Ya, Zi.pullAll = Oa, Zi.pullAllBy = Na, Zi.pullAllWith = la, Zi.pullAt = _a, Zi.range = mp, Zi.rangeRight = pd, Zi.rearg = zv, Zi.reject = Us, Zi.remove = qo, Zi.rest = Fv, Zi.reverse = Aa, Zi.sampleSize = rg, Zi.set = Og, Zi.setWith = i_, Zi.shuffle = o0, Zi.slice = ps, Zi.sortBy = ig, Zi.sortedUniq = is, Zi.sortedUniqBy = Za, Zi.split = p_, Zi.spread = Nv, Zi.tail = Ma, Zi.take = xs, Zi.takeRight = Vs, Zi.takeRightWhile = Ja, Zi.takeWhile = ul, Zi.tap = H1, Zi.throttle = Vv, Zi.thru = rm, Zi.toArray = mm, Zi.toPairs = zg, Zi.toPairsIn = Fg, Zi.toPath = x_, Zi.toPlainObject = c1, Zi.transform = n_, Zi.unary = Uv, Zi.union = nc, Zi.unionBy = Rl, Zi.unionWith = vu, Zi.uniq = Jc, Zi.uniqBy = gl, Zi.uniqWith = oc, Zi.unset = o_, Zi.unzip = Rc, Zi.unzipWith = yc, Zi.update = a_, Zi.updateWith = s_, Zi.values = gf, Zi.valuesIn = l_, Zi.without = xh, Zi.words = S1, Zi.wrap = t1, Zi.xor = hf, Zi.xorBy = tm, Zi.xorWith = hp, Zi.zip = j1, Zi.zipObject = Av, Zi.zipObjectDeep = q1, Zi.zipWith = kv, Zi.entries = zg, Zi.entriesIn = Fg, Zi.extend = u1, Zi.extendWith = p0, b0(Zi, Zi), Zi.add = M_, Zi.attempt = E1, Zi.camelCase = v1, Zi.capitalize = _m, Zi.ceil = gp, Zi.clamp = _l, Zi.clone = r1, Zi.cloneDeep = i1, Zi.cloneDeepWith = hg, Zi.cloneWith = ug, Zi.conformsTo = dg, Zi.deburr = vf, Zi.defaultTo = Sh, Zi.divide = A1, Zi.endsWith = c_, Zi.eq = bc, Zi.escape = u_, Zi.escapeRegExp = ym, Zi.every = im, Zi.find = Iv, Zi.findIndex = eo, Zi.findKey = Xv, Zi.findLast = nm, Zi.findLastIndex = On, Zi.findLastKey = Kv, Zi.floor = S_, Zi.forEach = eg, Zi.forEachRight = tg, Zi.forIn = Yv, Zi.forInRight = Jv, Zi.forOwn = Qv, Zi.forOwnRight = e_, Zi.get = h1, Zi.gt = fg, Zi.gte = pg, Zi.has = r_, Zi.hasIn = d1, Zi.head = yo, Zi.identity = lc, Zi.includes = $v, Zi.indexOf = mo, Zi.inRange = _u, Zi.invoke = Lg, Zi.isArguments = dd, Zi.isArray = $a, Zi.isArrayBuffer = ff, Zi.isArrayLike = ac, Zi.isArrayLikeObject = Bs, Zi.isBoolean = mg, Zi.isBuffer = wh, Zi.isDate = h0, Zi.isElement = gg, Zi.isEmpty = d0, Zi.isEqual = vg, Zi.isEqualWith = n1, Zi.isError = hm, Zi.isFinite = _g, Zi.isFunction = Mh, Zi.isInteger = o1, Zi.isLength = dm, Zi.isMap = f0, Zi.isMatch = yg, Zi.isMatchWith = a1, Zi.isNaN = jv, Zi.isNative = qv, Zi.isNil = Hv, Zi.isNull = Gv, Zi.isNumber = s1, Zi.isObject = $s, Zi.isObjectLike = js, Zi.isPlainObject = Qc, Zi.isRegExp = pf, Zi.isSafeInteger = fm, Zi.isSet = pm, Zi.isString = fd, Zi.isSymbol = xc, Zi.isTypedArray = mf, Zi.isUndefined = bg, Zi.isWeakMap = xg, Zi.isWeakSet = Wv, Zi.join = Jo, Zi.kebabCase = h_, Zi.last = ia, Zi.lastIndexOf = sa, Zi.lowerCase = d_, Zi.lowerFirst = Ng, Zi.lt = Zv, Zi.lte = wg, Zi.max = tv, Zi.maxBy = k1, Zi.mean = E_, Zi.meanBy = Sm, Zi.min = md, Zi.minBy = rv, Zi.stubArray = x0, Zi.stubFalse = w0, Zi.stubObject = M0, Zi.stubString = ev, Zi.stubTrue = S0, Zi.multiply = iv, Zi.nth = ss, Zi.noConflict = xm, Zi.noop = wm, Zi.now = sm, Zi.pad = y1, Zi.padEnd = Vg, Zi.padStart = b1, Zi.parseInt = f_, Zi.random = m0, Zi.reduce = dp, Zi.reduceRight = Ov, Zi.repeat = Ug, Zi.replace = g0, Zi.result = vm, Zi.round = C0, Zi.runInContext = jn, Zi.sample = n0, Zi.size = a0, Zi.snakeCase = x1, Zi.some = am, Zi.sortedIndex = Xs, Zi.sortedIndexBy = ql, Zi.sortedIndexOf = ml, Zi.sortedLastIndex = Ns, Zi.sortedLastIndexBy = ks, Zi.sortedLastIndexOf = Cs, Zi.startCase = m_, Zi.startsWith = g_, Zi.subtract = L1, Zi.sum = C_, Zi.sumBy = nv, Zi.template = jg, Zi.times = E0, Zi.toFinite = Vu, Zi.toInteger = Va, Zi.toLength = l1, Zi.toLower = Pc, Zi.toNumber = wc, Zi.toSafeInteger = Mg, Zi.toString = ms, Zi.toUpper = bm, Zi.trim = pp, Zi.trimEnd = w1, Zi.trimStart = v0, Zi.truncate = v_, Zi.unescape = qg, Zi.uniqueId = w_, Zi.upperCase = Gg, Zi.upperFirst = M1, Zi.each = eg, Zi.eachRight = tg, Zi.first = yo, b0(Zi, function() {
        var dr = {};
        return El(Zi, function(Cr, Ur) {
          rs.call(Zi.prototype, Ur) || (dr[Ur] = Cr);
        }), dr;
      }(), { chain: !1 }), Zi.VERSION = we, al(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(dr) {
        Zi[dr].placeholder = Zi;
      }), al(["drop", "take"], function(dr, Cr) {
        Da.prototype[dr] = function(Ur) {
          Ur = Ur === ie ? 1 : Os(Va(Ur), 0);
          var ui = this.__filtered__ && !Cr ? new Da(this) : this.clone();
          return ui.__filtered__ ? ui.__takeCount__ = Qs(Ur, ui.__takeCount__) : ui.__views__.push({
            size: Qs(Ur, ur),
            type: dr + (ui.__dir__ < 0 ? "Right" : "")
          }), ui;
        }, Da.prototype[dr + "Right"] = function(Ur) {
          return this.reverse()[dr](Ur).reverse();
        };
      }), al(["filter", "map", "takeWhile"], function(dr, Cr) {
        var Ur = Cr + 1, ui = Ur == Ue || Ur == lr;
        Da.prototype[dr] = function($i) {
          var Qi = this.clone();
          return Qi.__iteratees__.push({
            iteratee: pa($i, 3),
            type: Ur
          }), Qi.__filtered__ = Qi.__filtered__ || ui, Qi;
        };
      }), al(["head", "last"], function(dr, Cr) {
        var Ur = "take" + (Cr ? "Right" : "");
        Da.prototype[dr] = function() {
          return this[Ur](1).value()[0];
        };
      }), al(["initial", "tail"], function(dr, Cr) {
        var Ur = "drop" + (Cr ? "" : "Right");
        Da.prototype[dr] = function() {
          return this.__filtered__ ? new Da(this) : this[Ur](1);
        };
      }), Da.prototype.compact = function() {
        return this.filter(lc);
      }, Da.prototype.find = function(dr) {
        return this.filter(dr).head();
      }, Da.prototype.findLast = function(dr) {
        return this.reverse().find(dr);
      }, Da.prototype.invokeMap = Ia(function(dr, Cr) {
        return typeof dr == "function" ? new Da(this) : this.map(function(Ur) {
          return Iu(Ur, dr, Cr);
        });
      }), Da.prototype.reject = function(dr) {
        return this.filter(fp(pa(dr)));
      }, Da.prototype.slice = function(dr, Cr) {
        dr = Va(dr);
        var Ur = this;
        return Ur.__filtered__ && (dr > 0 || Cr < 0) ? new Da(Ur) : (dr < 0 ? Ur = Ur.takeRight(-dr) : dr && (Ur = Ur.drop(dr)), Cr !== ie && (Cr = Va(Cr), Ur = Cr < 0 ? Ur.dropRight(-Cr) : Ur.take(Cr - dr)), Ur);
      }, Da.prototype.takeRightWhile = function(dr) {
        return this.reverse().takeWhile(dr).reverse();
      }, Da.prototype.toArray = function() {
        return this.take(ur);
      }, El(Da.prototype, function(dr, Cr) {
        var Ur = /^(?:filter|find|map|reject)|While$/.test(Cr), ui = /^(?:head|last)$/.test(Cr), $i = Zi[ui ? "take" + (Cr == "last" ? "Right" : "") : Cr], Qi = ui || /^find/.test(Cr);
        !$i || (Zi.prototype[Cr] = function() {
          var En = this.__wrapped__, Dn = ui ? [1] : arguments, Zn = En instanceof Da, wo = Dn[0], So = Zn || $a(En), ko = function(Qa) {
            var ns = $i.apply(Zi, Sc([Qa], Dn));
            return ui && Vo ? ns[0] : ns;
          };
          So && Ur && typeof wo == "function" && wo.length != 1 && (Zn = So = !1);
          var Vo = this.__chain__, na = !!this.__actions__.length, Sa = Qi && !Vo, Ua = Zn && !na;
          if (!Qi && So) {
            En = Ua ? En : new Da(this);
            var ya = dr.apply(En, Dn);
            return ya.__actions__.push({ func: rm, args: [ko], thisArg: ie }), new el(ya, Vo);
          }
          return Sa && Ua ? dr.apply(this, Dn) : (ya = this.thru(ko), Sa ? ui ? ya.value()[0] : ya.value() : ya);
        });
      }), al(["pop", "push", "shift", "sort", "splice", "unshift"], function(dr) {
        var Cr = Yu[dr], Ur = /^(?:push|sort|unshift)$/.test(dr) ? "tap" : "thru", ui = /^(?:pop|shift)$/.test(dr);
        Zi.prototype[dr] = function() {
          var $i = arguments;
          if (ui && !this.__chain__) {
            var Qi = this.value();
            return Cr.apply($a(Qi) ? Qi : [], $i);
          }
          return this[Ur](function(En) {
            return Cr.apply($a(En) ? En : [], $i);
          });
        };
      }), El(Da.prototype, function(dr, Cr) {
        var Ur = Zi[Cr];
        if (Ur) {
          var ui = Ur.name + "";
          rs.call(qh, ui) || (qh[ui] = []), qh[ui].push({ name: Cr, func: Ur });
        }
      }), qh[ic(ie, Yr).name] = [{
        name: "wrapper",
        func: ie
      }], Da.prototype.clone = Vp, Da.prototype.reverse = Au, Da.prototype.value = Dd, Zi.prototype.at = W1, Zi.prototype.chain = Z1, Zi.prototype.commit = X1, Zi.prototype.next = K1, Zi.prototype.plant = K0, Zi.prototype.reverse = hd, Zi.prototype.toJSON = Zi.prototype.valueOf = Zi.prototype.value = Al, Zi.prototype.first = Zi.prototype.head, Id && (Zi.prototype[Id] = Y1), Zi;
    }, Nl = Om();
    yl ? ((yl.exports = Nl)._ = Nl, Ys._ = Nl) : Rs._ = Nl;
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
const _$1 = lodash.exports;
function sliceFeature$1({ text: m, format: c }, ...ie) {
  return {
    text: m.slice(...ie),
    format: c
  };
}
function groupFeatureByLinebreaks$1(m) {
  const c = [[]];
  let ie = 0;
  for (; ie in m; ) {
    const we = c.length - 1, $e = m[ie], Me = $e.text.search(`
`);
    if (Me > -1) {
      const Ze = sliceFeature$1($e, 0, Me), ne = sliceFeature$1($e, Me + 1);
      c[we].push(Ze);
      const rr = groupFeatureByLinebreaks$1([ne]);
      for (const gr of rr)
        c.push(gr);
    } else
      c[we].push(m[ie]);
    ie++;
  }
  return c.map((we) => we.filter(($e, Me) => {
    Me === 0 && we.length;
    const Ze = Me === we.length - 1 && we.slice(0, Me).every((ne) => ne.text === "");
    return $e.text !== "" || Ze;
  }));
}
function ungroupFeaturesDividedByLinebreaks(m) {
  const c = [];
  let ie = 0;
  for (const $e of lodash.exports.cloneDeep(m)) {
    for (const Me of $e)
      c.push(Me);
    ie < m.length - 1 && c[c.length - 1] && (c[c.length - 1].text += `
`), ie++;
  }
  const we = [];
  {
    let $e = 0;
    for (; $e < c.length; ) {
      const Me = {
        text: "",
        format: lodash.exports.cloneDeep(c[$e].format)
      };
      for (; isEqual(c[$e]?.format, Me.format); )
        Me.text += c[$e].text, $e++;
      we.push(Me);
    }
  }
  return we;
}
function sliceRichText$1(m, c, ie) {
  return m.map(({ text: we, format: $e }, Me) => {
    const Ze = m.slice(0, Me).reduce((rr, { text: gr }) => rr + gr.length, 0), ne = Ze + we.length;
    return {
      text: c < ne && Ze < ie ? we.slice(Math.max(c - Ze, 0), ie - Ze) : "",
      format: $e
    };
  }).filter(({ text: we }) => we.length > 0);
}
function getRawText(m) {
  return (m[0] instanceof Array ? ungroupFeaturesDividedByLinebreaks(m) : m).reduce((ie, we) => ie + we.text, "");
}
function getSelection(m) {
  const c = window.getSelection();
  if (!c)
    throw new Error("No selection descriptor");
  if (!c.anchorNode)
    throw new Error("No anchor node");
  if (!c.focusNode)
    throw new Error("No focus node");
  if (c.anchorNode.textContent === null)
    throw new Error("Anchor node's text content: null");
  if (c.focusNode.textContent === null)
    throw new Error("Focus node's text content: null");
  const ie = collectContentEditableText(m, (ne) => ne === c.anchorNode), we = collectContentEditableText(m, (ne) => ne === c.focusNode), $e = ie.length + c.anchorOffset, Me = we.length + c.focusOffset;
  return { start: $e, length: Me - $e };
}
function useSelection(m) {
  const c = ref$1(null);
  function ie() {
    const we = document.getSelection();
    if (m.value && we && we.rangeCount > 0) {
      const $e = we.getRangeAt(0);
      if (m.value.contains($e.commonAncestorContainer))
        try {
          c.value = getSelection(m.value);
        } catch (Me) {
          console.error("Failed to get selection", Me), c.value = null;
        }
    }
  }
  return document.addEventListener("selectionchange", ie), onUnmounted(() => {
    document.removeEventListener("selectionchange", ie);
  }), c;
}
function sliceFeature({ text: m, format: c }, ...ie) {
  return {
    text: m.slice(...ie),
    format: c
  };
}
function collectContentEditableText(m, c) {
  const ie = document.createTreeWalker(m);
  let we = ie.nextNode(), $e = "";
  for (; we; ) {
    if (c(we))
      return $e;
    const Me = ie.nextNode();
    if (we.nodeType === Node.TEXT_NODE)
      $e += we.textContent ?? "";
    else if (we.nodeType === Node.ELEMENT_NODE) {
      const Ze = we;
      (Ze.tagName === "BR" || Ze.tagName === "DIV" && !$e.endsWith(`
`) && $e !== "") && ($e += `
`);
    }
    we = Me;
  }
  return $e.endsWith(`
`) && ($e = $e.slice(0, -1)), $e;
}
window.collectContentEditableText = collectContentEditableText;
function getTextBeforeElement(m, c) {
  let ie = "";
  function we($e) {
    if (!$e)
      return "";
    let Me = "", Ze = $e.previousSibling;
    for (; Ze; ) {
      if (Ze.nodeType === Node.TEXT_NODE)
        Me = Ze.textContent + Me;
      else if (Ze.nodeType === Node.ELEMENT_NODE) {
        const ne = Ze;
        ne.tagName === "BR" ? Me = `
` + Me : Me = ne.innerText + Me;
      }
      Ze = Ze.previousSibling;
    }
    return $e.parentNode && c($e.parentNode) && (Me = we($e.parentNode) + Me), Me;
  }
  return ie = we(m), ie;
}
function groupFeatureByLinebreaks(m) {
  const c = [[]];
  let ie = 0;
  for (; ie in m; ) {
    const we = c.length - 1, $e = m[ie].text.search(`
`);
    if ($e > -1) {
      const Me = sliceFeature(m[ie], 0, $e), Ze = sliceFeature(m[ie], $e + 1);
      c[we].push(Me);
      const ne = groupFeatureByLinebreaks([Ze]);
      for (const rr of ne)
        c.push(rr);
    } else
      c[we].push(m[ie]);
    ie++;
  }
  return c;
}
function resolveSubtreeParagraphs(m, c, ie = !1) {
  const we = [[]], $e = Array.from(m.childNodes).filter((Me) => Me.nodeType === Node.TEXT_NODE ? (Me.textContent?.length ?? 0) > 0 : Me.nodeType !== Node.COMMENT_NODE);
  for (const Me of $e)
    if (Me.nodeType === Node.TEXT_NODE && Me.textContent)
      we[we.length - 1].push({
        text: Me.textContent,
        format: c
      });
    else if (Me.nodeType === Node.ELEMENT_NODE && Me.tagName.toLowerCase() === "br")
      getTextBeforeElement(Me, (ne) => ne?.tagName !== "DIV").length === 0 ? ie && we[we.length - 1].push({
        text: "",
        format: c
      }) : we.push([]);
    else if (Me.nodeType === Node.ELEMENT_NODE) {
      const Ze = (() => {
        if (Me.tagName.toLowerCase() === "b" || Me.tagName.toLowerCase() === "strong")
          return { fontWeight: 700 };
        if (Me.tagName.toLowerCase() === "i")
          return { fontStyle: "italic" };
        if (Me.tagName.toLowerCase() === "u")
          return { textDecoration: "underline" };
      })(), ne = {
        ...c,
        ...Ze,
        ...JSON.parse(Me.getAttribute("data-feature-format") ?? "{}") ?? {}
      };
      Me.tagName.toLowerCase() === "div" && we.push([]);
      const rr = resolveSubtreeParagraphs(Me, ne, ie);
      rr.slice(0, 1);
      for (const gr of rr.slice(0, 1))
        for (const or of gr)
          or.text === `
` ? we.push([]) : we[we.length - 1].push(or);
      for (const gr of rr.slice(1))
        we.push(gr);
    }
  return we.filter((Me) => Me.length > 0);
}
function sliceRichText(m, c, ie) {
  return m.map(({ text: we, format: $e }, Me) => {
    const Ze = m.slice(0, Me).reduce((rr, { text: gr }) => rr + gr.length, 0), ne = Ze + we.length;
    return {
      text: c < ne && Ze < ie ? we.slice(Math.max(c - Ze, 0), ie - Ze) : "",
      format: $e
    };
  }).filter(({ text: we }) => we.length > 0);
}
function getParagraphLength(m) {
  return m.reduce((c, { text: ie }) => c + ie.length, 0);
}
function useContentEditable(m, c, ie, we) {
  const $e = ref$1(c.value), Me = ref$1(c.value);
  watch(c, () => {
    isEqual($e.value, c.value) || ($e.value = c.value, Ze.value = nanoid());
  });
  const Ze = ref$1(nanoid()), ne = useSelection(m), rr = !0, gr = (Ar) => {
    if (m.value) {
      const Rr = resolveSubtreeParagraphs(m.value, {}, rr), Yr = Rr.reduce((xi, di) => {
        const oi = groupFeatureByLinebreaks(di);
        return [...xi, ...oi];
      }, []).filter((xi, di) => [].concat(...Rr.slice(di)).length > 0), Vr = ie.maxLengthPerLine ?? 1 / 0, Xr = ie.maxLength ?? 1 / 0, Wr = ie.maxLines ?? 1 / 0;
      let si = 0;
      Me.value = Yr.map((xi, di) => {
        if (xi.length === 1 && xi[0].text === "")
          return xi;
        const oi = sliceRichText(xi, 0, Vr), ci = getParagraphLength(oi);
        si += ci;
        const vr = si + di, Ae = di >= Wr ? 0 : Math.min(ci - Math.max(vr - Xr, 0), Vr);
        return [
          ...sliceRichText(xi, 0, Ae),
          ...sliceRichText(xi, Ae, 1 / 0).map((ze) => ({
            text: ze.text,
            format: {
              ...ze.format,
              lineOverflow: !0
            }
          }))
        ];
      });
      const li = Me.value.map((xi) => xi.filter((di) => !di.format.lineOverflow));
      $e.value = li;
    }
  };
  function or(Ar, Rr) {
    return {
      start: Ar + Math.min(0, Rr),
      length: Math.abs(Rr)
    };
  }
  const _r = (Ar, Rr, Nr, Yr) => {
    const Vr = Rr + Nr;
    return lodash.exports.cloneDeep(
      Ar.map((Xr, Wr) => {
        const si = Wr + Ar.slice(0, Wr).map(getParagraphLength).reduce((di, oi) => di + oi, 0), li = getParagraphLength(Xr), xi = sliceRichText(Xr, Rr - si, Vr - si).map(({ text: di }) => di).join("");
        return si + li >= Rr && si < Vr ? [
          ...sliceRichText(Xr, 0, Rr - si),
          { text: xi, format: Yr },
          ...sliceRichText(Xr, Vr - si, 1 / 0)
        ] : Xr;
      })
    ).map((Xr) => {
      const Wr = [];
      for (let si = 0; si < Xr.length; si++) {
        const li = Xr[si], xi = Xr[si - 1];
        xi && isEqual(li.format, xi.format) ? Wr[Wr.length - 1].text += li.text : Wr.push(li);
      }
      return Wr;
    });
  };
  return {
    selection: ne,
    paragraphs: $e,
    visibleParagraphs: Me,
    manipulationState: Ze,
    handleInputEvent: gr,
    applyFormat: (Ar, Rr, Nr, Yr = !0) => {
      const { start: Vr, length: Xr } = or(Ar, Rr);
      $e.value = _r($e.value, Vr, Xr, Nr), Me.value = _r(Me.value, Vr, Xr, Nr), Ze.value = nanoid(), nextTick$3(() => {
        m.value && Yr && selectContentEditable(m.value, Vr, Xr);
      });
    },
    resolveFeatures: (Ar, Rr) => {
      const Nr = Ar + Rr;
      return $e.value.map((Yr, Vr) => {
        const Xr = Vr + $e.value.slice(0, Vr).map(getParagraphLength).reduce((Wr, si) => Wr + si, 0);
        return sliceRichText(Yr, Ar - Xr, Nr - Xr);
      });
    }
  };
}
function getNodeStartIndex(m, c) {
  const ie = document.createTreeWalker(c);
  let we = ie.nextNode(), $e = 0;
  for (; we; ) {
    if (we === m)
      return $e;
    we.nodeType === Node.TEXT_NODE ? $e += we.textContent?.length ?? 0 : we.nodeType === Node.ELEMENT_NODE && we.tagName.toLowerCase() === "br" && ($e += 1), we = ie.nextNode();
  }
  return null;
}
function selectContentEditable(m, c, ie) {
  const we = c + ie, $e = document.createTreeWalker(m, NodeFilter.SHOW_TEXT, null);
  let Me = [], Ze = $e.nextNode();
  for (; Ze; ) {
    const gr = Ze.textContent?.length ?? 0;
    if (gr > 0) {
      const or = getNodeStartIndex(Ze, m);
      if (or !== null && or < we && or + gr > c) {
        const _r = Math.max(0, c - or), Lr = Math.min(Math.max(0, we - or), or + gr);
        Me.push({ node: Ze, start: _r, end: Lr });
      }
    }
    Ze = $e.nextNode();
  }
  const ne = document.createRange();
  for (let gr = 0; gr < Me.length; gr++) {
    const { node: or, start: _r, end: Lr } = Me[gr];
    gr === 0 && ne.setStart(or, _r), gr === Me.length - 1 && ne.setEnd(or, Lr);
  }
  const rr = window.getSelection();
  rr && (rr.removeAllRanges(), rr.addRange(ne), m.focus());
}
var cryptoBrowserify = {};
function getDefaultExportFromCjs(m) {
  return m && m.__esModule && Object.prototype.hasOwnProperty.call(m, "default") ? m.default : m;
}
var browser$d = { exports: {} }, process = browser$d.exports = {}, cachedSetTimeout, cachedClearTimeout;
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? cachedSetTimeout = setTimeout : cachedSetTimeout = defaultSetTimout;
  } catch {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    typeof clearTimeout == "function" ? cachedClearTimeout = clearTimeout : cachedClearTimeout = defaultClearTimeout;
  } catch {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(m) {
  if (cachedSetTimeout === setTimeout)
    return setTimeout(m, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout)
    return cachedSetTimeout = setTimeout, setTimeout(m, 0);
  try {
    return cachedSetTimeout(m, 0);
  } catch {
    try {
      return cachedSetTimeout.call(null, m, 0);
    } catch {
      return cachedSetTimeout.call(this, m, 0);
    }
  }
}
function runClearTimeout(m) {
  if (cachedClearTimeout === clearTimeout)
    return clearTimeout(m);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout)
    return cachedClearTimeout = clearTimeout, clearTimeout(m);
  try {
    return cachedClearTimeout(m);
  } catch {
    try {
      return cachedClearTimeout.call(null, m);
    } catch {
      return cachedClearTimeout.call(this, m);
    }
  }
}
var queue = [], draining = !1, currentQueue, queueIndex = -1;
function cleanUpNextTick() {
  !draining || !currentQueue || (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}
function drainQueue() {
  if (!draining) {
    var m = runTimeout(cleanUpNextTick);
    draining = !0;
    for (var c = queue.length; c; ) {
      for (currentQueue = queue, queue = []; ++queueIndex < c; )
        currentQueue && currentQueue[queueIndex].run();
      queueIndex = -1, c = queue.length;
    }
    currentQueue = null, draining = !1, runClearTimeout(m);
  }
}
process.nextTick = function(m) {
  var c = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var ie = 1; ie < arguments.length; ie++)
      c[ie - 1] = arguments[ie];
  queue.push(new Item(m, c)), queue.length === 1 && !draining && runTimeout(drainQueue);
};
function Item(m, c) {
  this.fun = m, this.array = c;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = !0;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop$1() {
}
process.on = noop$1;
process.addListener = noop$1;
process.once = noop$1;
process.off = noop$1;
process.removeListener = noop$1;
process.removeAllListeners = noop$1;
process.emit = noop$1;
process.prependListener = noop$1;
process.prependOnceListener = noop$1;
process.listeners = function(m) {
  return [];
};
process.binding = function(m) {
  throw new Error("process.binding is not supported");
};
process.cwd = function() {
  return "/";
};
process.chdir = function(m) {
  throw new Error("process.chdir is not supported");
};
process.umask = function() {
  return 0;
};
var browserExports = browser$d.exports;
const process$1 = /* @__PURE__ */ getDefaultExportFromCjs(browserExports);
var browser$c = { exports: {} }, safeBuffer$2 = { exports: {} }, buffer$1 = {}, base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$1 = 0, len = code.length; i$1 < len; ++i$1)
  lookup[i$1] = code[i$1], revLookup[code.charCodeAt(i$1)] = i$1;
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(m) {
  var c = m.length;
  if (c % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var ie = m.indexOf("=");
  ie === -1 && (ie = c);
  var we = ie === c ? 0 : 4 - ie % 4;
  return [ie, we];
}
function byteLength(m) {
  var c = getLens(m), ie = c[0], we = c[1];
  return (ie + we) * 3 / 4 - we;
}
function _byteLength(m, c, ie) {
  return (c + ie) * 3 / 4 - ie;
}
function toByteArray(m) {
  var c, ie = getLens(m), we = ie[0], $e = ie[1], Me = new Arr(_byteLength(m, we, $e)), Ze = 0, ne = $e > 0 ? we - 4 : we, rr;
  for (rr = 0; rr < ne; rr += 4)
    c = revLookup[m.charCodeAt(rr)] << 18 | revLookup[m.charCodeAt(rr + 1)] << 12 | revLookup[m.charCodeAt(rr + 2)] << 6 | revLookup[m.charCodeAt(rr + 3)], Me[Ze++] = c >> 16 & 255, Me[Ze++] = c >> 8 & 255, Me[Ze++] = c & 255;
  return $e === 2 && (c = revLookup[m.charCodeAt(rr)] << 2 | revLookup[m.charCodeAt(rr + 1)] >> 4, Me[Ze++] = c & 255), $e === 1 && (c = revLookup[m.charCodeAt(rr)] << 10 | revLookup[m.charCodeAt(rr + 1)] << 4 | revLookup[m.charCodeAt(rr + 2)] >> 2, Me[Ze++] = c >> 8 & 255, Me[Ze++] = c & 255), Me;
}
function tripletToBase64(m) {
  return lookup[m >> 18 & 63] + lookup[m >> 12 & 63] + lookup[m >> 6 & 63] + lookup[m & 63];
}
function encodeChunk(m, c, ie) {
  for (var we, $e = [], Me = c; Me < ie; Me += 3)
    we = (m[Me] << 16 & 16711680) + (m[Me + 1] << 8 & 65280) + (m[Me + 2] & 255), $e.push(tripletToBase64(we));
  return $e.join("");
}
function fromByteArray(m) {
  for (var c, ie = m.length, we = ie % 3, $e = [], Me = 16383, Ze = 0, ne = ie - we; Ze < ne; Ze += Me)
    $e.push(encodeChunk(m, Ze, Ze + Me > ne ? ne : Ze + Me));
  return we === 1 ? (c = m[ie - 1], $e.push(
    lookup[c >> 2] + lookup[c << 4 & 63] + "=="
  )) : we === 2 && (c = (m[ie - 2] << 8) + m[ie - 1], $e.push(
    lookup[c >> 10] + lookup[c >> 4 & 63] + lookup[c << 2 & 63] + "="
  )), $e.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(m, c, ie, we, $e) {
  var Me, Ze, ne = $e * 8 - we - 1, rr = (1 << ne) - 1, gr = rr >> 1, or = -7, _r = ie ? $e - 1 : 0, Lr = ie ? -1 : 1, Ir = m[c + _r];
  for (_r += Lr, Me = Ir & (1 << -or) - 1, Ir >>= -or, or += ne; or > 0; Me = Me * 256 + m[c + _r], _r += Lr, or -= 8)
    ;
  for (Ze = Me & (1 << -or) - 1, Me >>= -or, or += we; or > 0; Ze = Ze * 256 + m[c + _r], _r += Lr, or -= 8)
    ;
  if (Me === 0)
    Me = 1 - gr;
  else {
    if (Me === rr)
      return Ze ? NaN : (Ir ? -1 : 1) * (1 / 0);
    Ze = Ze + Math.pow(2, we), Me = Me - gr;
  }
  return (Ir ? -1 : 1) * Ze * Math.pow(2, Me - we);
};
ieee754.write = function(m, c, ie, we, $e, Me) {
  var Ze, ne, rr, gr = Me * 8 - $e - 1, or = (1 << gr) - 1, _r = or >> 1, Lr = $e === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, Ir = we ? 0 : Me - 1, Ar = we ? 1 : -1, Rr = c < 0 || c === 0 && 1 / c < 0 ? 1 : 0;
  for (c = Math.abs(c), isNaN(c) || c === 1 / 0 ? (ne = isNaN(c) ? 1 : 0, Ze = or) : (Ze = Math.floor(Math.log(c) / Math.LN2), c * (rr = Math.pow(2, -Ze)) < 1 && (Ze--, rr *= 2), Ze + _r >= 1 ? c += Lr / rr : c += Lr * Math.pow(2, 1 - _r), c * rr >= 2 && (Ze++, rr /= 2), Ze + _r >= or ? (ne = 0, Ze = or) : Ze + _r >= 1 ? (ne = (c * rr - 1) * Math.pow(2, $e), Ze = Ze + _r) : (ne = c * Math.pow(2, _r - 1) * Math.pow(2, $e), Ze = 0)); $e >= 8; m[ie + Ir] = ne & 255, Ir += Ar, ne /= 256, $e -= 8)
    ;
  for (Ze = Ze << $e | ne, gr += $e; gr > 0; m[ie + Ir] = Ze & 255, Ir += Ar, Ze /= 256, gr -= 8)
    ;
  m[ie + Ir - Ar] |= Rr * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(m) {
  const c = base64Js, ie = ieee754, we = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  m.Buffer = or, m.SlowBuffer = si, m.INSPECT_MAX_BYTES = 50;
  const $e = 2147483647;
  m.kMaxLength = $e;
  const { Uint8Array: Me, ArrayBuffer: Ze, SharedArrayBuffer: ne } = globalThis;
  or.TYPED_ARRAY_SUPPORT = rr(), !or.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function rr() {
    try {
      const Ci = new Me(1), ri = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(ri, Me.prototype), Object.setPrototypeOf(Ci, ri), Ci.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(or.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (!!or.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(or.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (!!or.isBuffer(this))
        return this.byteOffset;
    }
  });
  function gr(Ci) {
    if (Ci > $e)
      throw new RangeError('The value "' + Ci + '" is invalid for option "size"');
    const ri = new Me(Ci);
    return Object.setPrototypeOf(ri, or.prototype), ri;
  }
  function or(Ci, ri, yi) {
    if (typeof Ci == "number") {
      if (typeof ri == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return Ar(Ci);
    }
    return _r(Ci, ri, yi);
  }
  or.poolSize = 8192;
  function _r(Ci, ri, yi) {
    if (typeof Ci == "string")
      return Rr(Ci, ri);
    if (Ze.isView(Ci))
      return Yr(Ci);
    if (Ci == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Ci
      );
    if (Vn(Ci, Ze) || Ci && Vn(Ci.buffer, Ze) || typeof ne < "u" && (Vn(Ci, ne) || Ci && Vn(Ci.buffer, ne)))
      return Vr(Ci, ri, yi);
    if (typeof Ci == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const Li = Ci.valueOf && Ci.valueOf();
    if (Li != null && Li !== Ci)
      return or.from(Li, ri, yi);
    const Yi = Xr(Ci);
    if (Yi)
      return Yi;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Ci[Symbol.toPrimitive] == "function")
      return or.from(Ci[Symbol.toPrimitive]("string"), ri, yi);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Ci
    );
  }
  or.from = function(Ci, ri, yi) {
    return _r(Ci, ri, yi);
  }, Object.setPrototypeOf(or.prototype, Me.prototype), Object.setPrototypeOf(or, Me);
  function Lr(Ci) {
    if (typeof Ci != "number")
      throw new TypeError('"size" argument must be of type number');
    if (Ci < 0)
      throw new RangeError('The value "' + Ci + '" is invalid for option "size"');
  }
  function Ir(Ci, ri, yi) {
    return Lr(Ci), Ci <= 0 ? gr(Ci) : ri !== void 0 ? typeof yi == "string" ? gr(Ci).fill(ri, yi) : gr(Ci).fill(ri) : gr(Ci);
  }
  or.alloc = function(Ci, ri, yi) {
    return Ir(Ci, ri, yi);
  };
  function Ar(Ci) {
    return Lr(Ci), gr(Ci < 0 ? 0 : Wr(Ci) | 0);
  }
  or.allocUnsafe = function(Ci) {
    return Ar(Ci);
  }, or.allocUnsafeSlow = function(Ci) {
    return Ar(Ci);
  };
  function Rr(Ci, ri) {
    if ((typeof ri != "string" || ri === "") && (ri = "utf8"), !or.isEncoding(ri))
      throw new TypeError("Unknown encoding: " + ri);
    const yi = li(Ci, ri) | 0;
    let Li = gr(yi);
    const Yi = Li.write(Ci, ri);
    return Yi !== yi && (Li = Li.slice(0, Yi)), Li;
  }
  function Nr(Ci) {
    const ri = Ci.length < 0 ? 0 : Wr(Ci.length) | 0, yi = gr(ri);
    for (let Li = 0; Li < ri; Li += 1)
      yi[Li] = Ci[Li] & 255;
    return yi;
  }
  function Yr(Ci) {
    if (Vn(Ci, Me)) {
      const ri = new Me(Ci);
      return Vr(ri.buffer, ri.byteOffset, ri.byteLength);
    }
    return Nr(Ci);
  }
  function Vr(Ci, ri, yi) {
    if (ri < 0 || Ci.byteLength < ri)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (Ci.byteLength < ri + (yi || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let Li;
    return ri === void 0 && yi === void 0 ? Li = new Me(Ci) : yi === void 0 ? Li = new Me(Ci, ri) : Li = new Me(Ci, ri, yi), Object.setPrototypeOf(Li, or.prototype), Li;
  }
  function Xr(Ci) {
    if (or.isBuffer(Ci)) {
      const ri = Wr(Ci.length) | 0, yi = gr(ri);
      return yi.length === 0 || Ci.copy(yi, 0, 0, ri), yi;
    }
    if (Ci.length !== void 0)
      return typeof Ci.length != "number" || Xo(Ci.length) ? gr(0) : Nr(Ci);
    if (Ci.type === "Buffer" && Array.isArray(Ci.data))
      return Nr(Ci.data);
  }
  function Wr(Ci) {
    if (Ci >= $e)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e.toString(16) + " bytes");
    return Ci | 0;
  }
  function si(Ci) {
    return +Ci != Ci && (Ci = 0), or.alloc(+Ci);
  }
  or.isBuffer = function(ri) {
    return ri != null && ri._isBuffer === !0 && ri !== or.prototype;
  }, or.compare = function(ri, yi) {
    if (Vn(ri, Me) && (ri = or.from(ri, ri.offset, ri.byteLength)), Vn(yi, Me) && (yi = or.from(yi, yi.offset, yi.byteLength)), !or.isBuffer(ri) || !or.isBuffer(yi))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (ri === yi)
      return 0;
    let Li = ri.length, Yi = yi.length;
    for (let zn = 0, un = Math.min(Li, Yi); zn < un; ++zn)
      if (ri[zn] !== yi[zn]) {
        Li = ri[zn], Yi = yi[zn];
        break;
      }
    return Li < Yi ? -1 : Yi < Li ? 1 : 0;
  }, or.isEncoding = function(ri) {
    switch (String(ri).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, or.concat = function(ri, yi) {
    if (!Array.isArray(ri))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (ri.length === 0)
      return or.alloc(0);
    let Li;
    if (yi === void 0)
      for (yi = 0, Li = 0; Li < ri.length; ++Li)
        yi += ri[Li].length;
    const Yi = or.allocUnsafe(yi);
    let zn = 0;
    for (Li = 0; Li < ri.length; ++Li) {
      let un = ri[Li];
      if (Vn(un, Me))
        zn + un.length > Yi.length ? (or.isBuffer(un) || (un = or.from(un)), un.copy(Yi, zn)) : Me.prototype.set.call(
          Yi,
          un,
          zn
        );
      else if (or.isBuffer(un))
        un.copy(Yi, zn);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      zn += un.length;
    }
    return Yi;
  };
  function li(Ci, ri) {
    if (or.isBuffer(Ci))
      return Ci.length;
    if (Ze.isView(Ci) || Vn(Ci, Ze))
      return Ci.byteLength;
    if (typeof Ci != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Ci
      );
    const yi = Ci.length, Li = arguments.length > 2 && arguments[2] === !0;
    if (!Li && yi === 0)
      return 0;
    let Yi = !1;
    for (; ; )
      switch (ri) {
        case "ascii":
        case "latin1":
        case "binary":
          return yi;
        case "utf8":
        case "utf-8":
          return Kn(Ci).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return yi * 2;
        case "hex":
          return yi >>> 1;
        case "base64":
          return Po(Ci).length;
        default:
          if (Yi)
            return Li ? -1 : Kn(Ci).length;
          ri = ("" + ri).toLowerCase(), Yi = !0;
      }
  }
  or.byteLength = li;
  function xi(Ci, ri, yi) {
    let Li = !1;
    if ((ri === void 0 || ri < 0) && (ri = 0), ri > this.length || ((yi === void 0 || yi > this.length) && (yi = this.length), yi <= 0) || (yi >>>= 0, ri >>>= 0, yi <= ri))
      return "";
    for (Ci || (Ci = "utf8"); ; )
      switch (Ci) {
        case "hex":
          return Pr(this, ri, yi);
        case "utf8":
        case "utf-8":
          return pr(this, ri, yi);
        case "ascii":
          return Pe(this, ri, yi);
        case "latin1":
        case "binary":
          return ur(this, ri, yi);
        case "base64":
          return lr(this, ri, yi);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Hr(this, ri, yi);
        default:
          if (Li)
            throw new TypeError("Unknown encoding: " + Ci);
          Ci = (Ci + "").toLowerCase(), Li = !0;
      }
  }
  or.prototype._isBuffer = !0;
  function di(Ci, ri, yi) {
    const Li = Ci[ri];
    Ci[ri] = Ci[yi], Ci[yi] = Li;
  }
  or.prototype.swap16 = function() {
    const ri = this.length;
    if (ri % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let yi = 0; yi < ri; yi += 2)
      di(this, yi, yi + 1);
    return this;
  }, or.prototype.swap32 = function() {
    const ri = this.length;
    if (ri % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let yi = 0; yi < ri; yi += 4)
      di(this, yi, yi + 3), di(this, yi + 1, yi + 2);
    return this;
  }, or.prototype.swap64 = function() {
    const ri = this.length;
    if (ri % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let yi = 0; yi < ri; yi += 8)
      di(this, yi, yi + 7), di(this, yi + 1, yi + 6), di(this, yi + 2, yi + 5), di(this, yi + 3, yi + 4);
    return this;
  }, or.prototype.toString = function() {
    const ri = this.length;
    return ri === 0 ? "" : arguments.length === 0 ? pr(this, 0, ri) : xi.apply(this, arguments);
  }, or.prototype.toLocaleString = or.prototype.toString, or.prototype.equals = function(ri) {
    if (!or.isBuffer(ri))
      throw new TypeError("Argument must be a Buffer");
    return this === ri ? !0 : or.compare(this, ri) === 0;
  }, or.prototype.inspect = function() {
    let ri = "";
    const yi = m.INSPECT_MAX_BYTES;
    return ri = this.toString("hex", 0, yi).replace(/(.{2})/g, "$1 ").trim(), this.length > yi && (ri += " ... "), "<Buffer " + ri + ">";
  }, we && (or.prototype[we] = or.prototype.inspect), or.prototype.compare = function(ri, yi, Li, Yi, zn) {
    if (Vn(ri, Me) && (ri = or.from(ri, ri.offset, ri.byteLength)), !or.isBuffer(ri))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof ri
      );
    if (yi === void 0 && (yi = 0), Li === void 0 && (Li = ri ? ri.length : 0), Yi === void 0 && (Yi = 0), zn === void 0 && (zn = this.length), yi < 0 || Li > ri.length || Yi < 0 || zn > this.length)
      throw new RangeError("out of range index");
    if (Yi >= zn && yi >= Li)
      return 0;
    if (Yi >= zn)
      return -1;
    if (yi >= Li)
      return 1;
    if (yi >>>= 0, Li >>>= 0, Yi >>>= 0, zn >>>= 0, this === ri)
      return 0;
    let un = zn - Yi, Gn = Li - yi;
    const Mn = Math.min(un, Gn), pn = this.slice(Yi, zn), Rn = ri.slice(yi, Li);
    for (let Io = 0; Io < Mn; ++Io)
      if (pn[Io] !== Rn[Io]) {
        un = pn[Io], Gn = Rn[Io];
        break;
      }
    return un < Gn ? -1 : Gn < un ? 1 : 0;
  };
  function oi(Ci, ri, yi, Li, Yi) {
    if (Ci.length === 0)
      return -1;
    if (typeof yi == "string" ? (Li = yi, yi = 0) : yi > 2147483647 ? yi = 2147483647 : yi < -2147483648 && (yi = -2147483648), yi = +yi, Xo(yi) && (yi = Yi ? 0 : Ci.length - 1), yi < 0 && (yi = Ci.length + yi), yi >= Ci.length) {
      if (Yi)
        return -1;
      yi = Ci.length - 1;
    } else if (yi < 0)
      if (Yi)
        yi = 0;
      else
        return -1;
    if (typeof ri == "string" && (ri = or.from(ri, Li)), or.isBuffer(ri))
      return ri.length === 0 ? -1 : ci(Ci, ri, yi, Li, Yi);
    if (typeof ri == "number")
      return ri = ri & 255, typeof Me.prototype.indexOf == "function" ? Yi ? Me.prototype.indexOf.call(Ci, ri, yi) : Me.prototype.lastIndexOf.call(Ci, ri, yi) : ci(Ci, [ri], yi, Li, Yi);
    throw new TypeError("val must be string, number or Buffer");
  }
  function ci(Ci, ri, yi, Li, Yi) {
    let zn = 1, un = Ci.length, Gn = ri.length;
    if (Li !== void 0 && (Li = String(Li).toLowerCase(), Li === "ucs2" || Li === "ucs-2" || Li === "utf16le" || Li === "utf-16le")) {
      if (Ci.length < 2 || ri.length < 2)
        return -1;
      zn = 2, un /= 2, Gn /= 2, yi /= 2;
    }
    function Mn(Rn, Io) {
      return zn === 1 ? Rn[Io] : Rn.readUInt16BE(Io * zn);
    }
    let pn;
    if (Yi) {
      let Rn = -1;
      for (pn = yi; pn < un; pn++)
        if (Mn(Ci, pn) === Mn(ri, Rn === -1 ? 0 : pn - Rn)) {
          if (Rn === -1 && (Rn = pn), pn - Rn + 1 === Gn)
            return Rn * zn;
        } else
          Rn !== -1 && (pn -= pn - Rn), Rn = -1;
    } else
      for (yi + Gn > un && (yi = un - Gn), pn = yi; pn >= 0; pn--) {
        let Rn = !0;
        for (let Io = 0; Io < Gn; Io++)
          if (Mn(Ci, pn + Io) !== Mn(ri, Io)) {
            Rn = !1;
            break;
          }
        if (Rn)
          return pn;
      }
    return -1;
  }
  or.prototype.includes = function(ri, yi, Li) {
    return this.indexOf(ri, yi, Li) !== -1;
  }, or.prototype.indexOf = function(ri, yi, Li) {
    return oi(this, ri, yi, Li, !0);
  }, or.prototype.lastIndexOf = function(ri, yi, Li) {
    return oi(this, ri, yi, Li, !1);
  };
  function vr(Ci, ri, yi, Li) {
    yi = Number(yi) || 0;
    const Yi = Ci.length - yi;
    Li ? (Li = Number(Li), Li > Yi && (Li = Yi)) : Li = Yi;
    const zn = ri.length;
    Li > zn / 2 && (Li = zn / 2);
    let un;
    for (un = 0; un < Li; ++un) {
      const Gn = parseInt(ri.substr(un * 2, 2), 16);
      if (Xo(Gn))
        return un;
      Ci[yi + un] = Gn;
    }
    return un;
  }
  function Ae(Ci, ri, yi, Li) {
    return vn(Kn(ri, Ci.length - yi), Ci, yi, Li);
  }
  function ze(Ci, ri, yi, Li) {
    return vn(In(ri), Ci, yi, Li);
  }
  function Ue(Ci, ri, yi, Li) {
    return vn(Po(ri), Ci, yi, Li);
  }
  function tr(Ci, ri, yi, Li) {
    return vn(Fn(ri, Ci.length - yi), Ci, yi, Li);
  }
  or.prototype.write = function(ri, yi, Li, Yi) {
    if (yi === void 0)
      Yi = "utf8", Li = this.length, yi = 0;
    else if (Li === void 0 && typeof yi == "string")
      Yi = yi, Li = this.length, yi = 0;
    else if (isFinite(yi))
      yi = yi >>> 0, isFinite(Li) ? (Li = Li >>> 0, Yi === void 0 && (Yi = "utf8")) : (Yi = Li, Li = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const zn = this.length - yi;
    if ((Li === void 0 || Li > zn) && (Li = zn), ri.length > 0 && (Li < 0 || yi < 0) || yi > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    Yi || (Yi = "utf8");
    let un = !1;
    for (; ; )
      switch (Yi) {
        case "hex":
          return vr(this, ri, yi, Li);
        case "utf8":
        case "utf-8":
          return Ae(this, ri, yi, Li);
        case "ascii":
        case "latin1":
        case "binary":
          return ze(this, ri, yi, Li);
        case "base64":
          return Ue(this, ri, yi, Li);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return tr(this, ri, yi, Li);
        default:
          if (un)
            throw new TypeError("Unknown encoding: " + Yi);
          Yi = ("" + Yi).toLowerCase(), un = !0;
      }
  }, or.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function lr(Ci, ri, yi) {
    return ri === 0 && yi === Ci.length ? c.fromByteArray(Ci) : c.fromByteArray(Ci.slice(ri, yi));
  }
  function pr(Ci, ri, yi) {
    yi = Math.min(Ci.length, yi);
    const Li = [];
    let Yi = ri;
    for (; Yi < yi; ) {
      const zn = Ci[Yi];
      let un = null, Gn = zn > 239 ? 4 : zn > 223 ? 3 : zn > 191 ? 2 : 1;
      if (Yi + Gn <= yi) {
        let Mn, pn, Rn, Io;
        switch (Gn) {
          case 1:
            zn < 128 && (un = zn);
            break;
          case 2:
            Mn = Ci[Yi + 1], (Mn & 192) === 128 && (Io = (zn & 31) << 6 | Mn & 63, Io > 127 && (un = Io));
            break;
          case 3:
            Mn = Ci[Yi + 1], pn = Ci[Yi + 2], (Mn & 192) === 128 && (pn & 192) === 128 && (Io = (zn & 15) << 12 | (Mn & 63) << 6 | pn & 63, Io > 2047 && (Io < 55296 || Io > 57343) && (un = Io));
            break;
          case 4:
            Mn = Ci[Yi + 1], pn = Ci[Yi + 2], Rn = Ci[Yi + 3], (Mn & 192) === 128 && (pn & 192) === 128 && (Rn & 192) === 128 && (Io = (zn & 15) << 18 | (Mn & 63) << 12 | (pn & 63) << 6 | Rn & 63, Io > 65535 && Io < 1114112 && (un = Io));
        }
      }
      un === null ? (un = 65533, Gn = 1) : un > 65535 && (un -= 65536, Li.push(un >>> 10 & 1023 | 55296), un = 56320 | un & 1023), Li.push(un), Yi += Gn;
    }
    return nr(Li);
  }
  const br = 4096;
  function nr(Ci) {
    const ri = Ci.length;
    if (ri <= br)
      return String.fromCharCode.apply(String, Ci);
    let yi = "", Li = 0;
    for (; Li < ri; )
      yi += String.fromCharCode.apply(
        String,
        Ci.slice(Li, Li += br)
      );
    return yi;
  }
  function Pe(Ci, ri, yi) {
    let Li = "";
    yi = Math.min(Ci.length, yi);
    for (let Yi = ri; Yi < yi; ++Yi)
      Li += String.fromCharCode(Ci[Yi] & 127);
    return Li;
  }
  function ur(Ci, ri, yi) {
    let Li = "";
    yi = Math.min(Ci.length, yi);
    for (let Yi = ri; Yi < yi; ++Yi)
      Li += String.fromCharCode(Ci[Yi]);
    return Li;
  }
  function Pr(Ci, ri, yi) {
    const Li = Ci.length;
    (!ri || ri < 0) && (ri = 0), (!yi || yi < 0 || yi > Li) && (yi = Li);
    let Yi = "";
    for (let zn = ri; zn < yi; ++zn)
      Yi += Xn[Ci[zn]];
    return Yi;
  }
  function Hr(Ci, ri, yi) {
    const Li = Ci.slice(ri, yi);
    let Yi = "";
    for (let zn = 0; zn < Li.length - 1; zn += 2)
      Yi += String.fromCharCode(Li[zn] + Li[zn + 1] * 256);
    return Yi;
  }
  or.prototype.slice = function(ri, yi) {
    const Li = this.length;
    ri = ~~ri, yi = yi === void 0 ? Li : ~~yi, ri < 0 ? (ri += Li, ri < 0 && (ri = 0)) : ri > Li && (ri = Li), yi < 0 ? (yi += Li, yi < 0 && (yi = 0)) : yi > Li && (yi = Li), yi < ri && (yi = ri);
    const Yi = this.subarray(ri, yi);
    return Object.setPrototypeOf(Yi, or.prototype), Yi;
  };
  function vi(Ci, ri, yi) {
    if (Ci % 1 !== 0 || Ci < 0)
      throw new RangeError("offset is not uint");
    if (Ci + ri > yi)
      throw new RangeError("Trying to access beyond buffer length");
  }
  or.prototype.readUintLE = or.prototype.readUIntLE = function(ri, yi, Li) {
    ri = ri >>> 0, yi = yi >>> 0, Li || vi(ri, yi, this.length);
    let Yi = this[ri], zn = 1, un = 0;
    for (; ++un < yi && (zn *= 256); )
      Yi += this[ri + un] * zn;
    return Yi;
  }, or.prototype.readUintBE = or.prototype.readUIntBE = function(ri, yi, Li) {
    ri = ri >>> 0, yi = yi >>> 0, Li || vi(ri, yi, this.length);
    let Yi = this[ri + --yi], zn = 1;
    for (; yi > 0 && (zn *= 256); )
      Yi += this[ri + --yi] * zn;
    return Yi;
  }, or.prototype.readUint8 = or.prototype.readUInt8 = function(ri, yi) {
    return ri = ri >>> 0, yi || vi(ri, 1, this.length), this[ri];
  }, or.prototype.readUint16LE = or.prototype.readUInt16LE = function(ri, yi) {
    return ri = ri >>> 0, yi || vi(ri, 2, this.length), this[ri] | this[ri + 1] << 8;
  }, or.prototype.readUint16BE = or.prototype.readUInt16BE = function(ri, yi) {
    return ri = ri >>> 0, yi || vi(ri, 2, this.length), this[ri] << 8 | this[ri + 1];
  }, or.prototype.readUint32LE = or.prototype.readUInt32LE = function(ri, yi) {
    return ri = ri >>> 0, yi || vi(ri, 4, this.length), (this[ri] | this[ri + 1] << 8 | this[ri + 2] << 16) + this[ri + 3] * 16777216;
  }, or.prototype.readUint32BE = or.prototype.readUInt32BE = function(ri, yi) {
    return ri = ri >>> 0, yi || vi(ri, 4, this.length), this[ri] * 16777216 + (this[ri + 1] << 16 | this[ri + 2] << 8 | this[ri + 3]);
  }, or.prototype.readBigUInt64LE = Yn(function(ri) {
    ri = ri >>> 0, sn(ri, "offset");
    const yi = this[ri], Li = this[ri + 7];
    (yi === void 0 || Li === void 0) && $n(ri, this.length - 8);
    const Yi = yi + this[++ri] * 2 ** 8 + this[++ri] * 2 ** 16 + this[++ri] * 2 ** 24, zn = this[++ri] + this[++ri] * 2 ** 8 + this[++ri] * 2 ** 16 + Li * 2 ** 24;
    return BigInt(Yi) + (BigInt(zn) << BigInt(32));
  }), or.prototype.readBigUInt64BE = Yn(function(ri) {
    ri = ri >>> 0, sn(ri, "offset");
    const yi = this[ri], Li = this[ri + 7];
    (yi === void 0 || Li === void 0) && $n(ri, this.length - 8);
    const Yi = yi * 2 ** 24 + this[++ri] * 2 ** 16 + this[++ri] * 2 ** 8 + this[++ri], zn = this[++ri] * 2 ** 24 + this[++ri] * 2 ** 16 + this[++ri] * 2 ** 8 + Li;
    return (BigInt(Yi) << BigInt(32)) + BigInt(zn);
  }), or.prototype.readIntLE = function(ri, yi, Li) {
    ri = ri >>> 0, yi = yi >>> 0, Li || vi(ri, yi, this.length);
    let Yi = this[ri], zn = 1, un = 0;
    for (; ++un < yi && (zn *= 256); )
      Yi += this[ri + un] * zn;
    return zn *= 128, Yi >= zn && (Yi -= Math.pow(2, 8 * yi)), Yi;
  }, or.prototype.readIntBE = function(ri, yi, Li) {
    ri = ri >>> 0, yi = yi >>> 0, Li || vi(ri, yi, this.length);
    let Yi = yi, zn = 1, un = this[ri + --Yi];
    for (; Yi > 0 && (zn *= 256); )
      un += this[ri + --Yi] * zn;
    return zn *= 128, un >= zn && (un -= Math.pow(2, 8 * yi)), un;
  }, or.prototype.readInt8 = function(ri, yi) {
    return ri = ri >>> 0, yi || vi(ri, 1, this.length), this[ri] & 128 ? (255 - this[ri] + 1) * -1 : this[ri];
  }, or.prototype.readInt16LE = function(ri, yi) {
    ri = ri >>> 0, yi || vi(ri, 2, this.length);
    const Li = this[ri] | this[ri + 1] << 8;
    return Li & 32768 ? Li | 4294901760 : Li;
  }, or.prototype.readInt16BE = function(ri, yi) {
    ri = ri >>> 0, yi || vi(ri, 2, this.length);
    const Li = this[ri + 1] | this[ri] << 8;
    return Li & 32768 ? Li | 4294901760 : Li;
  }, or.prototype.readInt32LE = function(ri, yi) {
    return ri = ri >>> 0, yi || vi(ri, 4, this.length), this[ri] | this[ri + 1] << 8 | this[ri + 2] << 16 | this[ri + 3] << 24;
  }, or.prototype.readInt32BE = function(ri, yi) {
    return ri = ri >>> 0, yi || vi(ri, 4, this.length), this[ri] << 24 | this[ri + 1] << 16 | this[ri + 2] << 8 | this[ri + 3];
  }, or.prototype.readBigInt64LE = Yn(function(ri) {
    ri = ri >>> 0, sn(ri, "offset");
    const yi = this[ri], Li = this[ri + 7];
    (yi === void 0 || Li === void 0) && $n(ri, this.length - 8);
    const Yi = this[ri + 4] + this[ri + 5] * 2 ** 8 + this[ri + 6] * 2 ** 16 + (Li << 24);
    return (BigInt(Yi) << BigInt(32)) + BigInt(yi + this[++ri] * 2 ** 8 + this[++ri] * 2 ** 16 + this[++ri] * 2 ** 24);
  }), or.prototype.readBigInt64BE = Yn(function(ri) {
    ri = ri >>> 0, sn(ri, "offset");
    const yi = this[ri], Li = this[ri + 7];
    (yi === void 0 || Li === void 0) && $n(ri, this.length - 8);
    const Yi = (yi << 24) + this[++ri] * 2 ** 16 + this[++ri] * 2 ** 8 + this[++ri];
    return (BigInt(Yi) << BigInt(32)) + BigInt(this[++ri] * 2 ** 24 + this[++ri] * 2 ** 16 + this[++ri] * 2 ** 8 + Li);
  }), or.prototype.readFloatLE = function(ri, yi) {
    return ri = ri >>> 0, yi || vi(ri, 4, this.length), ie.read(this, ri, !0, 23, 4);
  }, or.prototype.readFloatBE = function(ri, yi) {
    return ri = ri >>> 0, yi || vi(ri, 4, this.length), ie.read(this, ri, !1, 23, 4);
  }, or.prototype.readDoubleLE = function(ri, yi) {
    return ri = ri >>> 0, yi || vi(ri, 8, this.length), ie.read(this, ri, !0, 52, 8);
  }, or.prototype.readDoubleBE = function(ri, yi) {
    return ri = ri >>> 0, yi || vi(ri, 8, this.length), ie.read(this, ri, !1, 52, 8);
  };
  function Ti(Ci, ri, yi, Li, Yi, zn) {
    if (!or.isBuffer(Ci))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (ri > Yi || ri < zn)
      throw new RangeError('"value" argument is out of bounds');
    if (yi + Li > Ci.length)
      throw new RangeError("Index out of range");
  }
  or.prototype.writeUintLE = or.prototype.writeUIntLE = function(ri, yi, Li, Yi) {
    if (ri = +ri, yi = yi >>> 0, Li = Li >>> 0, !Yi) {
      const Gn = Math.pow(2, 8 * Li) - 1;
      Ti(this, ri, yi, Li, Gn, 0);
    }
    let zn = 1, un = 0;
    for (this[yi] = ri & 255; ++un < Li && (zn *= 256); )
      this[yi + un] = ri / zn & 255;
    return yi + Li;
  }, or.prototype.writeUintBE = or.prototype.writeUIntBE = function(ri, yi, Li, Yi) {
    if (ri = +ri, yi = yi >>> 0, Li = Li >>> 0, !Yi) {
      const Gn = Math.pow(2, 8 * Li) - 1;
      Ti(this, ri, yi, Li, Gn, 0);
    }
    let zn = Li - 1, un = 1;
    for (this[yi + zn] = ri & 255; --zn >= 0 && (un *= 256); )
      this[yi + zn] = ri / un & 255;
    return yi + Li;
  }, or.prototype.writeUint8 = or.prototype.writeUInt8 = function(ri, yi, Li) {
    return ri = +ri, yi = yi >>> 0, Li || Ti(this, ri, yi, 1, 255, 0), this[yi] = ri & 255, yi + 1;
  }, or.prototype.writeUint16LE = or.prototype.writeUInt16LE = function(ri, yi, Li) {
    return ri = +ri, yi = yi >>> 0, Li || Ti(this, ri, yi, 2, 65535, 0), this[yi] = ri & 255, this[yi + 1] = ri >>> 8, yi + 2;
  }, or.prototype.writeUint16BE = or.prototype.writeUInt16BE = function(ri, yi, Li) {
    return ri = +ri, yi = yi >>> 0, Li || Ti(this, ri, yi, 2, 65535, 0), this[yi] = ri >>> 8, this[yi + 1] = ri & 255, yi + 2;
  }, or.prototype.writeUint32LE = or.prototype.writeUInt32LE = function(ri, yi, Li) {
    return ri = +ri, yi = yi >>> 0, Li || Ti(this, ri, yi, 4, 4294967295, 0), this[yi + 3] = ri >>> 24, this[yi + 2] = ri >>> 16, this[yi + 1] = ri >>> 8, this[yi] = ri & 255, yi + 4;
  }, or.prototype.writeUint32BE = or.prototype.writeUInt32BE = function(ri, yi, Li) {
    return ri = +ri, yi = yi >>> 0, Li || Ti(this, ri, yi, 4, 4294967295, 0), this[yi] = ri >>> 24, this[yi + 1] = ri >>> 16, this[yi + 2] = ri >>> 8, this[yi + 3] = ri & 255, yi + 4;
  };
  function wi(Ci, ri, yi, Li, Yi) {
    yn(ri, Li, Yi, Ci, yi, 7);
    let zn = Number(ri & BigInt(4294967295));
    Ci[yi++] = zn, zn = zn >> 8, Ci[yi++] = zn, zn = zn >> 8, Ci[yi++] = zn, zn = zn >> 8, Ci[yi++] = zn;
    let un = Number(ri >> BigInt(32) & BigInt(4294967295));
    return Ci[yi++] = un, un = un >> 8, Ci[yi++] = un, un = un >> 8, Ci[yi++] = un, un = un >> 8, Ci[yi++] = un, yi;
  }
  function ii(Ci, ri, yi, Li, Yi) {
    yn(ri, Li, Yi, Ci, yi, 7);
    let zn = Number(ri & BigInt(4294967295));
    Ci[yi + 7] = zn, zn = zn >> 8, Ci[yi + 6] = zn, zn = zn >> 8, Ci[yi + 5] = zn, zn = zn >> 8, Ci[yi + 4] = zn;
    let un = Number(ri >> BigInt(32) & BigInt(4294967295));
    return Ci[yi + 3] = un, un = un >> 8, Ci[yi + 2] = un, un = un >> 8, Ci[yi + 1] = un, un = un >> 8, Ci[yi] = un, yi + 8;
  }
  or.prototype.writeBigUInt64LE = Yn(function(ri, yi = 0) {
    return wi(this, ri, yi, BigInt(0), BigInt("0xffffffffffffffff"));
  }), or.prototype.writeBigUInt64BE = Yn(function(ri, yi = 0) {
    return ii(this, ri, yi, BigInt(0), BigInt("0xffffffffffffffff"));
  }), or.prototype.writeIntLE = function(ri, yi, Li, Yi) {
    if (ri = +ri, yi = yi >>> 0, !Yi) {
      const Mn = Math.pow(2, 8 * Li - 1);
      Ti(this, ri, yi, Li, Mn - 1, -Mn);
    }
    let zn = 0, un = 1, Gn = 0;
    for (this[yi] = ri & 255; ++zn < Li && (un *= 256); )
      ri < 0 && Gn === 0 && this[yi + zn - 1] !== 0 && (Gn = 1), this[yi + zn] = (ri / un >> 0) - Gn & 255;
    return yi + Li;
  }, or.prototype.writeIntBE = function(ri, yi, Li, Yi) {
    if (ri = +ri, yi = yi >>> 0, !Yi) {
      const Mn = Math.pow(2, 8 * Li - 1);
      Ti(this, ri, yi, Li, Mn - 1, -Mn);
    }
    let zn = Li - 1, un = 1, Gn = 0;
    for (this[yi + zn] = ri & 255; --zn >= 0 && (un *= 256); )
      ri < 0 && Gn === 0 && this[yi + zn + 1] !== 0 && (Gn = 1), this[yi + zn] = (ri / un >> 0) - Gn & 255;
    return yi + Li;
  }, or.prototype.writeInt8 = function(ri, yi, Li) {
    return ri = +ri, yi = yi >>> 0, Li || Ti(this, ri, yi, 1, 127, -128), ri < 0 && (ri = 255 + ri + 1), this[yi] = ri & 255, yi + 1;
  }, or.prototype.writeInt16LE = function(ri, yi, Li) {
    return ri = +ri, yi = yi >>> 0, Li || Ti(this, ri, yi, 2, 32767, -32768), this[yi] = ri & 255, this[yi + 1] = ri >>> 8, yi + 2;
  }, or.prototype.writeInt16BE = function(ri, yi, Li) {
    return ri = +ri, yi = yi >>> 0, Li || Ti(this, ri, yi, 2, 32767, -32768), this[yi] = ri >>> 8, this[yi + 1] = ri & 255, yi + 2;
  }, or.prototype.writeInt32LE = function(ri, yi, Li) {
    return ri = +ri, yi = yi >>> 0, Li || Ti(this, ri, yi, 4, 2147483647, -2147483648), this[yi] = ri & 255, this[yi + 1] = ri >>> 8, this[yi + 2] = ri >>> 16, this[yi + 3] = ri >>> 24, yi + 4;
  }, or.prototype.writeInt32BE = function(ri, yi, Li) {
    return ri = +ri, yi = yi >>> 0, Li || Ti(this, ri, yi, 4, 2147483647, -2147483648), ri < 0 && (ri = 4294967295 + ri + 1), this[yi] = ri >>> 24, this[yi + 1] = ri >>> 16, this[yi + 2] = ri >>> 8, this[yi + 3] = ri & 255, yi + 4;
  }, or.prototype.writeBigInt64LE = Yn(function(ri, yi = 0) {
    return wi(this, ri, yi, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), or.prototype.writeBigInt64BE = Yn(function(ri, yi = 0) {
    return ii(this, ri, yi, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function mi(Ci, ri, yi, Li, Yi, zn) {
    if (yi + Li > Ci.length)
      throw new RangeError("Index out of range");
    if (yi < 0)
      throw new RangeError("Index out of range");
  }
  function ei(Ci, ri, yi, Li, Yi) {
    return ri = +ri, yi = yi >>> 0, Yi || mi(Ci, ri, yi, 4), ie.write(Ci, ri, yi, Li, 23, 4), yi + 4;
  }
  or.prototype.writeFloatLE = function(ri, yi, Li) {
    return ei(this, ri, yi, !0, Li);
  }, or.prototype.writeFloatBE = function(ri, yi, Li) {
    return ei(this, ri, yi, !1, Li);
  };
  function Zr(Ci, ri, yi, Li, Yi) {
    return ri = +ri, yi = yi >>> 0, Yi || mi(Ci, ri, yi, 8), ie.write(Ci, ri, yi, Li, 52, 8), yi + 8;
  }
  or.prototype.writeDoubleLE = function(ri, yi, Li) {
    return Zr(this, ri, yi, !0, Li);
  }, or.prototype.writeDoubleBE = function(ri, yi, Li) {
    return Zr(this, ri, yi, !1, Li);
  }, or.prototype.copy = function(ri, yi, Li, Yi) {
    if (!or.isBuffer(ri))
      throw new TypeError("argument should be a Buffer");
    if (Li || (Li = 0), !Yi && Yi !== 0 && (Yi = this.length), yi >= ri.length && (yi = ri.length), yi || (yi = 0), Yi > 0 && Yi < Li && (Yi = Li), Yi === Li || ri.length === 0 || this.length === 0)
      return 0;
    if (yi < 0)
      throw new RangeError("targetStart out of bounds");
    if (Li < 0 || Li >= this.length)
      throw new RangeError("Index out of range");
    if (Yi < 0)
      throw new RangeError("sourceEnd out of bounds");
    Yi > this.length && (Yi = this.length), ri.length - yi < Yi - Li && (Yi = ri.length - yi + Li);
    const zn = Yi - Li;
    return this === ri && typeof Me.prototype.copyWithin == "function" ? this.copyWithin(yi, Li, Yi) : Me.prototype.set.call(
      ri,
      this.subarray(Li, Yi),
      yi
    ), zn;
  }, or.prototype.fill = function(ri, yi, Li, Yi) {
    if (typeof ri == "string") {
      if (typeof yi == "string" ? (Yi = yi, yi = 0, Li = this.length) : typeof Li == "string" && (Yi = Li, Li = this.length), Yi !== void 0 && typeof Yi != "string")
        throw new TypeError("encoding must be a string");
      if (typeof Yi == "string" && !or.isEncoding(Yi))
        throw new TypeError("Unknown encoding: " + Yi);
      if (ri.length === 1) {
        const un = ri.charCodeAt(0);
        (Yi === "utf8" && un < 128 || Yi === "latin1") && (ri = un);
      }
    } else
      typeof ri == "number" ? ri = ri & 255 : typeof ri == "boolean" && (ri = Number(ri));
    if (yi < 0 || this.length < yi || this.length < Li)
      throw new RangeError("Out of range index");
    if (Li <= yi)
      return this;
    yi = yi >>> 0, Li = Li === void 0 ? this.length : Li >>> 0, ri || (ri = 0);
    let zn;
    if (typeof ri == "number")
      for (zn = yi; zn < Li; ++zn)
        this[zn] = ri;
    else {
      const un = or.isBuffer(ri) ? ri : or.from(ri, Yi), Gn = un.length;
      if (Gn === 0)
        throw new TypeError('The value "' + ri + '" is invalid for argument "value"');
      for (zn = 0; zn < Li - yi; ++zn)
        this[zn + yi] = un[zn % Gn];
    }
    return this;
  };
  const pi = {};
  function hi(Ci, ri, yi) {
    pi[Ci] = class extends yi {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: ri.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${Ci}]`, this.stack, delete this.name;
      }
      get code() {
        return Ci;
      }
      set code(Yi) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: Yi,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${Ci}]: ${this.message}`;
      }
    };
  }
  hi(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(Ci) {
      return Ci ? `${Ci} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), hi(
    "ERR_INVALID_ARG_TYPE",
    function(Ci, ri) {
      return `The "${Ci}" argument must be of type number. Received type ${typeof ri}`;
    },
    TypeError
  ), hi(
    "ERR_OUT_OF_RANGE",
    function(Ci, ri, yi) {
      let Li = `The value of "${Ci}" is out of range.`, Yi = yi;
      return Number.isInteger(yi) && Math.abs(yi) > 2 ** 32 ? Yi = Oi(String(yi)) : typeof yi == "bigint" && (Yi = String(yi), (yi > BigInt(2) ** BigInt(32) || yi < -(BigInt(2) ** BigInt(32))) && (Yi = Oi(Yi)), Yi += "n"), Li += ` It must be ${ri}. Received ${Yi}`, Li;
    },
    RangeError
  );
  function Oi(Ci) {
    let ri = "", yi = Ci.length;
    const Li = Ci[0] === "-" ? 1 : 0;
    for (; yi >= Li + 4; yi -= 3)
      ri = `_${Ci.slice(yi - 3, yi)}${ri}`;
    return `${Ci.slice(0, yi)}${ri}`;
  }
  function qi(Ci, ri, yi) {
    sn(ri, "offset"), (Ci[ri] === void 0 || Ci[ri + yi] === void 0) && $n(ri, Ci.length - (yi + 1));
  }
  function yn(Ci, ri, yi, Li, Yi, zn) {
    if (Ci > yi || Ci < ri) {
      const un = typeof ri == "bigint" ? "n" : "";
      let Gn;
      throw zn > 3 ? ri === 0 || ri === BigInt(0) ? Gn = `>= 0${un} and < 2${un} ** ${(zn + 1) * 8}${un}` : Gn = `>= -(2${un} ** ${(zn + 1) * 8 - 1}${un}) and < 2 ** ${(zn + 1) * 8 - 1}${un}` : Gn = `>= ${ri}${un} and <= ${yi}${un}`, new pi.ERR_OUT_OF_RANGE("value", Gn, Ci);
    }
    qi(Li, Yi, zn);
  }
  function sn(Ci, ri) {
    if (typeof Ci != "number")
      throw new pi.ERR_INVALID_ARG_TYPE(ri, "number", Ci);
  }
  function $n(Ci, ri, yi) {
    throw Math.floor(Ci) !== Ci ? (sn(Ci, yi), new pi.ERR_OUT_OF_RANGE(yi || "offset", "an integer", Ci)) : ri < 0 ? new pi.ERR_BUFFER_OUT_OF_BOUNDS() : new pi.ERR_OUT_OF_RANGE(
      yi || "offset",
      `>= ${yi ? 1 : 0} and <= ${ri}`,
      Ci
    );
  }
  const rn = /[^+/0-9A-Za-z-_]/g;
  function ji(Ci) {
    if (Ci = Ci.split("=")[0], Ci = Ci.trim().replace(rn, ""), Ci.length < 2)
      return "";
    for (; Ci.length % 4 !== 0; )
      Ci = Ci + "=";
    return Ci;
  }
  function Kn(Ci, ri) {
    ri = ri || 1 / 0;
    let yi;
    const Li = Ci.length;
    let Yi = null;
    const zn = [];
    for (let un = 0; un < Li; ++un) {
      if (yi = Ci.charCodeAt(un), yi > 55295 && yi < 57344) {
        if (!Yi) {
          if (yi > 56319) {
            (ri -= 3) > -1 && zn.push(239, 191, 189);
            continue;
          } else if (un + 1 === Li) {
            (ri -= 3) > -1 && zn.push(239, 191, 189);
            continue;
          }
          Yi = yi;
          continue;
        }
        if (yi < 56320) {
          (ri -= 3) > -1 && zn.push(239, 191, 189), Yi = yi;
          continue;
        }
        yi = (Yi - 55296 << 10 | yi - 56320) + 65536;
      } else
        Yi && (ri -= 3) > -1 && zn.push(239, 191, 189);
      if (Yi = null, yi < 128) {
        if ((ri -= 1) < 0)
          break;
        zn.push(yi);
      } else if (yi < 2048) {
        if ((ri -= 2) < 0)
          break;
        zn.push(
          yi >> 6 | 192,
          yi & 63 | 128
        );
      } else if (yi < 65536) {
        if ((ri -= 3) < 0)
          break;
        zn.push(
          yi >> 12 | 224,
          yi >> 6 & 63 | 128,
          yi & 63 | 128
        );
      } else if (yi < 1114112) {
        if ((ri -= 4) < 0)
          break;
        zn.push(
          yi >> 18 | 240,
          yi >> 12 & 63 | 128,
          yi >> 6 & 63 | 128,
          yi & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return zn;
  }
  function In(Ci) {
    const ri = [];
    for (let yi = 0; yi < Ci.length; ++yi)
      ri.push(Ci.charCodeAt(yi) & 255);
    return ri;
  }
  function Fn(Ci, ri) {
    let yi, Li, Yi;
    const zn = [];
    for (let un = 0; un < Ci.length && !((ri -= 2) < 0); ++un)
      yi = Ci.charCodeAt(un), Li = yi >> 8, Yi = yi % 256, zn.push(Yi), zn.push(Li);
    return zn;
  }
  function Po(Ci) {
    return c.toByteArray(ji(Ci));
  }
  function vn(Ci, ri, yi, Li) {
    let Yi;
    for (Yi = 0; Yi < Li && !(Yi + yi >= ri.length || Yi >= Ci.length); ++Yi)
      ri[Yi + yi] = Ci[Yi];
    return Yi;
  }
  function Vn(Ci, ri) {
    return Ci instanceof ri || Ci != null && Ci.constructor != null && Ci.constructor.name != null && Ci.constructor.name === ri.name;
  }
  function Xo(Ci) {
    return Ci !== Ci;
  }
  const Xn = function() {
    const Ci = "0123456789abcdef", ri = new Array(256);
    for (let yi = 0; yi < 16; ++yi) {
      const Li = yi * 16;
      for (let Yi = 0; Yi < 16; ++Yi)
        ri[Li + Yi] = Ci[yi] + Ci[Yi];
    }
    return ri;
  }();
  function Yn(Ci) {
    return typeof BigInt > "u" ? Wo : Ci;
  }
  function Wo() {
    throw new Error("BigInt not supported");
  }
})(buffer$1);
const Buffer$C = buffer$1.Buffer, Blob$1 = buffer$1.Blob, BlobOptions = buffer$1.BlobOptions, Buffer$1$1 = buffer$1.Buffer, File$1 = buffer$1.File, FileOptions = buffer$1.FileOptions, INSPECT_MAX_BYTES = buffer$1.INSPECT_MAX_BYTES, SlowBuffer = buffer$1.SlowBuffer, TranscodeEncoding = buffer$1.TranscodeEncoding, atob$1 = buffer$1.atob, btoa$1 = buffer$1.btoa, constants$3 = buffer$1.constants, isAscii = buffer$1.isAscii, isUtf8 = buffer$1.isUtf8, kMaxLength = buffer$1.kMaxLength, kStringMaxLength = buffer$1.kStringMaxLength, resolveObjectURL = buffer$1.resolveObjectURL, transcode = buffer$1.transcode, dist = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Blob: Blob$1,
  BlobOptions,
  Buffer: Buffer$1$1,
  File: File$1,
  FileOptions,
  INSPECT_MAX_BYTES,
  SlowBuffer,
  TranscodeEncoding,
  atob: atob$1,
  btoa: btoa$1,
  constants: constants$3,
  default: Buffer$C,
  isAscii,
  isUtf8,
  kMaxLength,
  kStringMaxLength,
  resolveObjectURL,
  transcode
}, Symbol.toStringTag, { value: "Module" })), require$$0$4 = /* @__PURE__ */ getAugmentedNamespace(dist);
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(m, c) {
  var ie = require$$0$4, we = ie.Buffer;
  function $e(Ze, ne) {
    for (var rr in Ze)
      ne[rr] = Ze[rr];
  }
  we.from && we.alloc && we.allocUnsafe && we.allocUnsafeSlow ? m.exports = ie : ($e(ie, c), c.Buffer = Me);
  function Me(Ze, ne, rr) {
    return we(Ze, ne, rr);
  }
  Me.prototype = Object.create(we.prototype), $e(we, Me), Me.from = function(Ze, ne, rr) {
    if (typeof Ze == "number")
      throw new TypeError("Argument must not be a number");
    return we(Ze, ne, rr);
  }, Me.alloc = function(Ze, ne, rr) {
    if (typeof Ze != "number")
      throw new TypeError("Argument must be a number");
    var gr = we(Ze);
    return ne !== void 0 ? typeof rr == "string" ? gr.fill(ne, rr) : gr.fill(ne) : gr.fill(0), gr;
  }, Me.allocUnsafe = function(Ze) {
    if (typeof Ze != "number")
      throw new TypeError("Argument must be a number");
    return we(Ze);
  }, Me.allocUnsafeSlow = function(Ze) {
    if (typeof Ze != "number")
      throw new TypeError("Argument must be a number");
    return ie.SlowBuffer(Ze);
  };
})(safeBuffer$2, safeBuffer$2.exports);
var MAX_BYTES = 65536, MAX_UINT32 = 4294967295;
function oldBrowser$1() {
  throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
}
var Buffer$B = safeBuffer$2.exports.Buffer, crypto$2 = commonjsGlobal.crypto || commonjsGlobal.msCrypto;
crypto$2 && crypto$2.getRandomValues ? browser$c.exports = randomBytes$2 : browser$c.exports = oldBrowser$1;
function randomBytes$2(m, c) {
  if (m > MAX_UINT32)
    throw new RangeError("requested too many random bytes");
  var ie = Buffer$B.allocUnsafe(m);
  if (m > 0)
    if (m > MAX_BYTES)
      for (var we = 0; we < m; we += MAX_BYTES)
        crypto$2.getRandomValues(ie.slice(we, we + MAX_BYTES));
    else
      crypto$2.getRandomValues(ie);
  return typeof c == "function" ? process$1.nextTick(function() {
    c(null, ie);
  }) : ie;
}
var inherits_browser = { exports: {} };
typeof Object.create == "function" ? inherits_browser.exports = function(c, ie) {
  ie && (c.super_ = ie, c.prototype = Object.create(ie.prototype, {
    constructor: {
      value: c,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : inherits_browser.exports = function(c, ie) {
  if (ie) {
    c.super_ = ie;
    var we = function() {
    };
    we.prototype = ie.prototype, c.prototype = new we(), c.prototype.constructor = c;
  }
};
var events$2 = { exports: {} }, R$1 = typeof Reflect == "object" ? Reflect : null, ReflectApply = R$1 && typeof R$1.apply == "function" ? R$1.apply : function(c, ie, we) {
  return Function.prototype.apply.call(c, ie, we);
}, ReflectOwnKeys;
R$1 && typeof R$1.ownKeys == "function" ? ReflectOwnKeys = R$1.ownKeys : Object.getOwnPropertySymbols ? ReflectOwnKeys = function(c) {
  return Object.getOwnPropertyNames(c).concat(Object.getOwnPropertySymbols(c));
} : ReflectOwnKeys = function(c) {
  return Object.getOwnPropertyNames(c);
};
function ProcessEmitWarning(m) {
  console && console.warn && console.warn(m);
}
var NumberIsNaN = Number.isNaN || function(c) {
  return c !== c;
};
function EventEmitter() {
  EventEmitter.init.call(this);
}
events$2.exports = EventEmitter;
events$2.exports.once = once;
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = void 0;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(m) {
  if (typeof m != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof m);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(m) {
    if (typeof m != "number" || m < 0 || NumberIsNaN(m))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + m + ".");
    defaultMaxListeners = m;
  }
});
EventEmitter.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
EventEmitter.prototype.setMaxListeners = function(c) {
  if (typeof c != "number" || c < 0 || NumberIsNaN(c))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + c + ".");
  return this._maxListeners = c, this;
};
function _getMaxListeners(m) {
  return m._maxListeners === void 0 ? EventEmitter.defaultMaxListeners : m._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function() {
  return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function(c) {
  for (var ie = [], we = 1; we < arguments.length; we++)
    ie.push(arguments[we]);
  var $e = c === "error", Me = this._events;
  if (Me !== void 0)
    $e = $e && Me.error === void 0;
  else if (!$e)
    return !1;
  if ($e) {
    var Ze;
    if (ie.length > 0 && (Ze = ie[0]), Ze instanceof Error)
      throw Ze;
    var ne = new Error("Unhandled error." + (Ze ? " (" + Ze.message + ")" : ""));
    throw ne.context = Ze, ne;
  }
  var rr = Me[c];
  if (rr === void 0)
    return !1;
  if (typeof rr == "function")
    ReflectApply(rr, this, ie);
  else
    for (var gr = rr.length, or = arrayClone(rr, gr), we = 0; we < gr; ++we)
      ReflectApply(or[we], this, ie);
  return !0;
};
function _addListener(m, c, ie, we) {
  var $e, Me, Ze;
  if (checkListener(ie), Me = m._events, Me === void 0 ? (Me = m._events = /* @__PURE__ */ Object.create(null), m._eventsCount = 0) : (Me.newListener !== void 0 && (m.emit(
    "newListener",
    c,
    ie.listener ? ie.listener : ie
  ), Me = m._events), Ze = Me[c]), Ze === void 0)
    Ze = Me[c] = ie, ++m._eventsCount;
  else if (typeof Ze == "function" ? Ze = Me[c] = we ? [ie, Ze] : [Ze, ie] : we ? Ze.unshift(ie) : Ze.push(ie), $e = _getMaxListeners(m), $e > 0 && Ze.length > $e && !Ze.warned) {
    Ze.warned = !0;
    var ne = new Error("Possible EventEmitter memory leak detected. " + Ze.length + " " + String(c) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    ne.name = "MaxListenersExceededWarning", ne.emitter = m, ne.type = c, ne.count = Ze.length, ProcessEmitWarning(ne);
  }
  return m;
}
EventEmitter.prototype.addListener = function(c, ie) {
  return _addListener(this, c, ie, !1);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function(c, ie) {
  return _addListener(this, c, ie, !0);
};
function onceWrapper() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function _onceWrap(m, c, ie) {
  var we = { fired: !1, wrapFn: void 0, target: m, type: c, listener: ie }, $e = onceWrapper.bind(we);
  return $e.listener = ie, we.wrapFn = $e, $e;
}
EventEmitter.prototype.once = function(c, ie) {
  return checkListener(ie), this.on(c, _onceWrap(this, c, ie)), this;
};
EventEmitter.prototype.prependOnceListener = function(c, ie) {
  return checkListener(ie), this.prependListener(c, _onceWrap(this, c, ie)), this;
};
EventEmitter.prototype.removeListener = function(c, ie) {
  var we, $e, Me, Ze, ne;
  if (checkListener(ie), $e = this._events, $e === void 0)
    return this;
  if (we = $e[c], we === void 0)
    return this;
  if (we === ie || we.listener === ie)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete $e[c], $e.removeListener && this.emit("removeListener", c, we.listener || ie));
  else if (typeof we != "function") {
    for (Me = -1, Ze = we.length - 1; Ze >= 0; Ze--)
      if (we[Ze] === ie || we[Ze].listener === ie) {
        ne = we[Ze].listener, Me = Ze;
        break;
      }
    if (Me < 0)
      return this;
    Me === 0 ? we.shift() : spliceOne(we, Me), we.length === 1 && ($e[c] = we[0]), $e.removeListener !== void 0 && this.emit("removeListener", c, ne || ie);
  }
  return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function(c) {
  var ie, we, $e;
  if (we = this._events, we === void 0)
    return this;
  if (we.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : we[c] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete we[c]), this;
  if (arguments.length === 0) {
    var Me = Object.keys(we), Ze;
    for ($e = 0; $e < Me.length; ++$e)
      Ze = Me[$e], Ze !== "removeListener" && this.removeAllListeners(Ze);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (ie = we[c], typeof ie == "function")
    this.removeListener(c, ie);
  else if (ie !== void 0)
    for ($e = ie.length - 1; $e >= 0; $e--)
      this.removeListener(c, ie[$e]);
  return this;
};
function _listeners(m, c, ie) {
  var we = m._events;
  if (we === void 0)
    return [];
  var $e = we[c];
  return $e === void 0 ? [] : typeof $e == "function" ? ie ? [$e.listener || $e] : [$e] : ie ? unwrapListeners($e) : arrayClone($e, $e.length);
}
EventEmitter.prototype.listeners = function(c) {
  return _listeners(this, c, !0);
};
EventEmitter.prototype.rawListeners = function(c) {
  return _listeners(this, c, !1);
};
EventEmitter.listenerCount = function(m, c) {
  return typeof m.listenerCount == "function" ? m.listenerCount(c) : listenerCount.call(m, c);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(m) {
  var c = this._events;
  if (c !== void 0) {
    var ie = c[m];
    if (typeof ie == "function")
      return 1;
    if (ie !== void 0)
      return ie.length;
  }
  return 0;
}
EventEmitter.prototype.eventNames = function() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(m, c) {
  for (var ie = new Array(c), we = 0; we < c; ++we)
    ie[we] = m[we];
  return ie;
}
function spliceOne(m, c) {
  for (; c + 1 < m.length; c++)
    m[c] = m[c + 1];
  m.pop();
}
function unwrapListeners(m) {
  for (var c = new Array(m.length), ie = 0; ie < c.length; ++ie)
    c[ie] = m[ie].listener || m[ie];
  return c;
}
function once(m, c) {
  return new Promise(function(ie, we) {
    function $e(Ze) {
      m.removeListener(c, Me), we(Ze);
    }
    function Me() {
      typeof m.removeListener == "function" && m.removeListener("error", $e), ie([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(m, c, Me, { once: !0 }), c !== "error" && addErrorHandlerIfEventEmitter(m, $e, { once: !0 });
  });
}
function addErrorHandlerIfEventEmitter(m, c, ie) {
  typeof m.on == "function" && eventTargetAgnosticAddListener(m, "error", c, ie);
}
function eventTargetAgnosticAddListener(m, c, ie, we) {
  if (typeof m.on == "function")
    we.once ? m.once(c, ie) : m.on(c, ie);
  else if (typeof m.addEventListener == "function")
    m.addEventListener(c, function $e(Me) {
      we.once && m.removeEventListener(c, $e), ie(Me);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof m);
}
var streamBrowser$1, hasRequiredStreamBrowser;
function requireStreamBrowser() {
  return hasRequiredStreamBrowser || (hasRequiredStreamBrowser = 1, streamBrowser$1 = events$2.exports.EventEmitter), streamBrowser$1;
}
var util$4 = {}, types$2 = {}, shams$1 = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var c = {}, ie = Symbol("test"), we = Object(ie);
  if (typeof ie == "string" || Object.prototype.toString.call(ie) !== "[object Symbol]" || Object.prototype.toString.call(we) !== "[object Symbol]")
    return !1;
  var $e = 42;
  c[ie] = $e;
  for (var Me in c)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(c).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(c).length !== 0)
    return !1;
  var Ze = Object.getOwnPropertySymbols(c);
  if (Ze.length !== 1 || Ze[0] !== ie || !Object.prototype.propertyIsEnumerable.call(c, ie))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var ne = Object.getOwnPropertyDescriptor(c, ie);
    if (ne.value !== $e || ne.enumerable !== !0)
      return !1;
  }
  return !0;
}, hasSymbols$2 = shams$1, shams = function() {
  return hasSymbols$2() && !!Symbol.toStringTag;
}, esObjectAtoms = Object, esErrors = Error, _eval = EvalError, range$1 = RangeError, ref = ReferenceError, syntax = SyntaxError, type = TypeError, uri = URIError, abs$1 = Math.abs, floor$1 = Math.floor, max$3 = Math.max, min$2 = Math.min, pow$1 = Math.pow, round$2 = Math.round, _isNaN = Number.isNaN || function(c) {
  return c !== c;
}, $isNaN = _isNaN, sign$2 = function(c) {
  return $isNaN(c) || c === 0 ? c : c < 0 ? -1 : 1;
}, gOPD$3 = Object.getOwnPropertyDescriptor, $gOPD$1 = gOPD$3;
if ($gOPD$1)
  try {
    $gOPD$1([], "length");
  } catch {
    $gOPD$1 = null;
  }
var gopd$1 = $gOPD$1, $defineProperty$3 = Object.defineProperty || !1;
if ($defineProperty$3)
  try {
    $defineProperty$3({}, "a", { value: 1 });
  } catch {
    $defineProperty$3 = !1;
  }
var esDefineProperty = $defineProperty$3, hasSymbols$1, hasRequiredHasSymbols;
function requireHasSymbols() {
  if (hasRequiredHasSymbols)
    return hasSymbols$1;
  hasRequiredHasSymbols = 1;
  var m = typeof Symbol < "u" && Symbol, c = shams$1;
  return hasSymbols$1 = function() {
    return typeof m != "function" || typeof Symbol != "function" || typeof m("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : c();
  }, hasSymbols$1;
}
var Reflect_getPrototypeOf, hasRequiredReflect_getPrototypeOf;
function requireReflect_getPrototypeOf() {
  return hasRequiredReflect_getPrototypeOf || (hasRequiredReflect_getPrototypeOf = 1, Reflect_getPrototypeOf = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Reflect_getPrototypeOf;
}
var Object_getPrototypeOf, hasRequiredObject_getPrototypeOf;
function requireObject_getPrototypeOf() {
  if (hasRequiredObject_getPrototypeOf)
    return Object_getPrototypeOf;
  hasRequiredObject_getPrototypeOf = 1;
  var m = esObjectAtoms;
  return Object_getPrototypeOf = m.getPrototypeOf || null, Object_getPrototypeOf;
}
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ", toStr$4 = Object.prototype.toString, max$2 = Math.max, funcType = "[object Function]", concatty = function(c, ie) {
  for (var we = [], $e = 0; $e < c.length; $e += 1)
    we[$e] = c[$e];
  for (var Me = 0; Me < ie.length; Me += 1)
    we[Me + c.length] = ie[Me];
  return we;
}, slicy = function(c, ie) {
  for (var we = [], $e = ie || 0, Me = 0; $e < c.length; $e += 1, Me += 1)
    we[Me] = c[$e];
  return we;
}, joiny = function(m, c) {
  for (var ie = "", we = 0; we < m.length; we += 1)
    ie += m[we], we + 1 < m.length && (ie += c);
  return ie;
}, implementation$1 = function(c) {
  var ie = this;
  if (typeof ie != "function" || toStr$4.apply(ie) !== funcType)
    throw new TypeError(ERROR_MESSAGE + ie);
  for (var we = slicy(arguments, 1), $e, Me = function() {
    if (this instanceof $e) {
      var or = ie.apply(
        this,
        concatty(we, arguments)
      );
      return Object(or) === or ? or : this;
    }
    return ie.apply(
      c,
      concatty(we, arguments)
    );
  }, Ze = max$2(0, ie.length - we.length), ne = [], rr = 0; rr < Ze; rr++)
    ne[rr] = "$" + rr;
  if ($e = Function("binder", "return function (" + joiny(ne, ",") + "){ return binder.apply(this,arguments); }")(Me), ie.prototype) {
    var gr = function() {
    };
    gr.prototype = ie.prototype, $e.prototype = new gr(), gr.prototype = null;
  }
  return $e;
}, implementation = implementation$1, functionBind = Function.prototype.bind || implementation, functionCall = Function.prototype.call, functionApply, hasRequiredFunctionApply;
function requireFunctionApply() {
  return hasRequiredFunctionApply || (hasRequiredFunctionApply = 1, functionApply = Function.prototype.apply), functionApply;
}
var reflectApply$1 = typeof Reflect < "u" && Reflect && Reflect.apply, bind$3 = functionBind, $apply$2 = requireFunctionApply(), $call$2 = functionCall, $reflectApply = reflectApply$1, actualApply$1 = $reflectApply || bind$3.call($call$2, $apply$2), bind$2 = functionBind, $TypeError$8 = type, $call$1 = functionCall, $actualApply = actualApply$1, callBindApplyHelpers = function(c) {
  if (c.length < 1 || typeof c[0] != "function")
    throw new $TypeError$8("a function is required");
  return $actualApply(bind$2, $call$1, c);
}, get, hasRequiredGet;
function requireGet() {
  if (hasRequiredGet)
    return get;
  hasRequiredGet = 1;
  var m = callBindApplyHelpers, c = gopd$1, ie;
  try {
    ie = [].__proto__ === Array.prototype;
  } catch (Ze) {
    if (!Ze || typeof Ze != "object" || !("code" in Ze) || Ze.code !== "ERR_PROTO_ACCESS")
      throw Ze;
  }
  var we = !!ie && c && c(Object.prototype, "__proto__"), $e = Object, Me = $e.getPrototypeOf;
  return get = we && typeof we.get == "function" ? m([we.get]) : typeof Me == "function" ? function(ne) {
    return Me(ne == null ? ne : $e(ne));
  } : !1, get;
}
var getProto$2, hasRequiredGetProto;
function requireGetProto() {
  if (hasRequiredGetProto)
    return getProto$2;
  hasRequiredGetProto = 1;
  var m = requireReflect_getPrototypeOf(), c = requireObject_getPrototypeOf(), ie = requireGet();
  return getProto$2 = m ? function($e) {
    return m($e);
  } : c ? function($e) {
    if (!$e || typeof $e != "object" && typeof $e != "function")
      throw new TypeError("getProto: not an object");
    return c($e);
  } : ie ? function($e) {
    return ie($e);
  } : null, getProto$2;
}
var hasown, hasRequiredHasown;
function requireHasown() {
  if (hasRequiredHasown)
    return hasown;
  hasRequiredHasown = 1;
  var m = Function.prototype.call, c = Object.prototype.hasOwnProperty, ie = functionBind;
  return hasown = ie.call(m, c), hasown;
}
var undefined$1, $Object = esObjectAtoms, $Error = esErrors, $EvalError = _eval, $RangeError = range$1, $ReferenceError = ref, $SyntaxError$1 = syntax, $TypeError$7 = type, $URIError = uri, abs = abs$1, floor = floor$1, max$1 = max$3, min$1 = min$2, pow = pow$1, round$1 = round$2, sign$1 = sign$2, $Function = Function, getEvalledConstructor = function(m) {
  try {
    return $Function('"use strict"; return (' + m + ").constructor;")();
  } catch {
  }
}, $gOPD = gopd$1, $defineProperty$2 = esDefineProperty, throwTypeError = function() {
  throw new $TypeError$7();
}, ThrowTypeError = $gOPD ? function() {
  try {
    return arguments.callee, throwTypeError;
  } catch {
    try {
      return $gOPD(arguments, "callee").get;
    } catch {
      return throwTypeError;
    }
  }
}() : throwTypeError, hasSymbols = requireHasSymbols()(), getProto$1 = requireGetProto(), $ObjectGPO = requireObject_getPrototypeOf(), $ReflectGPO = requireReflect_getPrototypeOf(), $apply$1 = requireFunctionApply(), $call = functionCall, needsEval = {}, TypedArray = typeof Uint8Array > "u" || !getProto$1 ? undefined$1 : getProto$1(Uint8Array), INTRINSICS = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols && getProto$1 ? getProto$1([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics > "u" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt > "u" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": $Error,
  "%eval%": eval,
  "%EvalError%": $EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array > "u" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols && getProto$1 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON == "object" ? JSON : undefined$1,
  "%Map%": typeof Map > "u" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !hasSymbols || !getProto$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": $Object,
  "%Object.getOwnPropertyDescriptor%": $gOPD,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy > "u" ? undefined$1 : Proxy,
  "%RangeError%": $RangeError,
  "%ReferenceError%": $ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !hasSymbols || !getProto$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols && getProto$1 ? getProto$1(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError$1,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$7,
  "%Uint8Array%": typeof Uint8Array > "u" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? undefined$1 : Uint32Array,
  "%URIError%": $URIError,
  "%WeakMap%": typeof WeakMap > "u" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? undefined$1 : WeakSet,
  "%Function.prototype.call%": $call,
  "%Function.prototype.apply%": $apply$1,
  "%Object.defineProperty%": $defineProperty$2,
  "%Object.getPrototypeOf%": $ObjectGPO,
  "%Math.abs%": abs,
  "%Math.floor%": floor,
  "%Math.max%": max$1,
  "%Math.min%": min$1,
  "%Math.pow%": pow,
  "%Math.round%": round$1,
  "%Math.sign%": sign$1,
  "%Reflect.getPrototypeOf%": $ReflectGPO
};
if (getProto$1)
  try {
    null.error;
  } catch (m) {
    var errorProto = getProto$1(getProto$1(m));
    INTRINSICS["%Error.prototype%"] = errorProto;
  }
var doEval = function m(c) {
  var ie;
  if (c === "%AsyncFunction%")
    ie = getEvalledConstructor("async function () {}");
  else if (c === "%GeneratorFunction%")
    ie = getEvalledConstructor("function* () {}");
  else if (c === "%AsyncGeneratorFunction%")
    ie = getEvalledConstructor("async function* () {}");
  else if (c === "%AsyncGenerator%") {
    var we = m("%AsyncGeneratorFunction%");
    we && (ie = we.prototype);
  } else if (c === "%AsyncIteratorPrototype%") {
    var $e = m("%AsyncGenerator%");
    $e && getProto$1 && (ie = getProto$1($e.prototype));
  }
  return INTRINSICS[c] = ie, ie;
}, LEGACY_ALIASES = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, bind$1 = functionBind, hasOwn$2 = requireHasown(), $concat$1 = bind$1.call($call, Array.prototype.concat), $spliceApply = bind$1.call($apply$1, Array.prototype.splice), $replace$1 = bind$1.call($call, String.prototype.replace), $strSlice = bind$1.call($call, String.prototype.slice), $exec$2 = bind$1.call($call, RegExp.prototype.exec), rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = function(c) {
  var ie = $strSlice(c, 0, 1), we = $strSlice(c, -1);
  if (ie === "%" && we !== "%")
    throw new $SyntaxError$1("invalid intrinsic syntax, expected closing `%`");
  if (we === "%" && ie !== "%")
    throw new $SyntaxError$1("invalid intrinsic syntax, expected opening `%`");
  var $e = [];
  return $replace$1(c, rePropName, function(Me, Ze, ne, rr) {
    $e[$e.length] = ne ? $replace$1(rr, reEscapeChar, "$1") : Ze || Me;
  }), $e;
}, getBaseIntrinsic = function(c, ie) {
  var we = c, $e;
  if (hasOwn$2(LEGACY_ALIASES, we) && ($e = LEGACY_ALIASES[we], we = "%" + $e[0] + "%"), hasOwn$2(INTRINSICS, we)) {
    var Me = INTRINSICS[we];
    if (Me === needsEval && (Me = doEval(we)), typeof Me > "u" && !ie)
      throw new $TypeError$7("intrinsic " + c + " exists, but is not available. Please file an issue!");
    return {
      alias: $e,
      name: we,
      value: Me
    };
  }
  throw new $SyntaxError$1("intrinsic " + c + " does not exist!");
}, getIntrinsic = function(c, ie) {
  if (typeof c != "string" || c.length === 0)
    throw new $TypeError$7("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof ie != "boolean")
    throw new $TypeError$7('"allowMissing" argument must be a boolean');
  if ($exec$2(/^%?[^%]*%?$/, c) === null)
    throw new $SyntaxError$1("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var we = stringToPath(c), $e = we.length > 0 ? we[0] : "", Me = getBaseIntrinsic("%" + $e + "%", ie), Ze = Me.name, ne = Me.value, rr = !1, gr = Me.alias;
  gr && ($e = gr[0], $spliceApply(we, $concat$1([0, 1], gr)));
  for (var or = 1, _r = !0; or < we.length; or += 1) {
    var Lr = we[or], Ir = $strSlice(Lr, 0, 1), Ar = $strSlice(Lr, -1);
    if ((Ir === '"' || Ir === "'" || Ir === "`" || Ar === '"' || Ar === "'" || Ar === "`") && Ir !== Ar)
      throw new $SyntaxError$1("property names with quotes must have matching quotes");
    if ((Lr === "constructor" || !_r) && (rr = !0), $e += "." + Lr, Ze = "%" + $e + "%", hasOwn$2(INTRINSICS, Ze))
      ne = INTRINSICS[Ze];
    else if (ne != null) {
      if (!(Lr in ne)) {
        if (!ie)
          throw new $TypeError$7("base intrinsic for " + c + " exists, but the property is not available.");
        return;
      }
      if ($gOPD && or + 1 >= we.length) {
        var Rr = $gOPD(ne, Lr);
        _r = !!Rr, _r && "get" in Rr && !("originalValue" in Rr.get) ? ne = Rr.get : ne = ne[Lr];
      } else
        _r = hasOwn$2(ne, Lr), ne = ne[Lr];
      _r && !rr && (INTRINSICS[Ze] = ne);
    }
  }
  return ne;
}, GetIntrinsic$3 = getIntrinsic, callBindBasic = callBindApplyHelpers, $indexOf$1 = callBindBasic([GetIntrinsic$3("%String.prototype.indexOf%")]), callBound$7 = function(c, ie) {
  var we = GetIntrinsic$3(c, !!ie);
  return typeof we == "function" && $indexOf$1(c, ".prototype.") > -1 ? callBindBasic([we]) : we;
}, hasToStringTag$4 = shams(), callBound$6 = callBound$7, $toString$2 = callBound$6("Object.prototype.toString"), isStandardArguments = function(c) {
  return hasToStringTag$4 && c && typeof c == "object" && Symbol.toStringTag in c ? !1 : $toString$2(c) === "[object Arguments]";
}, isLegacyArguments = function(c) {
  return isStandardArguments(c) ? !0 : c !== null && typeof c == "object" && "length" in c && typeof c.length == "number" && c.length >= 0 && $toString$2(c) !== "[object Array]" && "callee" in c && $toString$2(c.callee) === "[object Function]";
}, supportsStandardArguments = function() {
  return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments;
var isArguments = supportsStandardArguments ? isStandardArguments : isLegacyArguments, callBound$5 = callBound$7, hasToStringTag$3 = shams(), hasOwn$1 = requireHasown(), gOPD$2 = gopd$1, fn;
if (hasToStringTag$3) {
  var $exec$1 = callBound$5("RegExp.prototype.exec"), isRegexMarker = {}, throwRegexMarker = function() {
    throw isRegexMarker;
  }, badStringifier = {
    toString: throwRegexMarker,
    valueOf: throwRegexMarker
  };
  typeof Symbol.toPrimitive == "symbol" && (badStringifier[Symbol.toPrimitive] = throwRegexMarker), fn = function(c) {
    if (!c || typeof c != "object")
      return !1;
    var ie = gOPD$2(c, "lastIndex"), we = ie && hasOwn$1(ie, "value");
    if (!we)
      return !1;
    try {
      $exec$1(c, badStringifier);
    } catch ($e) {
      return $e === isRegexMarker;
    }
  };
} else {
  var $toString$1 = callBound$5("Object.prototype.toString"), regexClass = "[object RegExp]";
  fn = function(c) {
    return !c || typeof c != "object" && typeof c != "function" ? !1 : $toString$1(c) === regexClass;
  };
}
var isRegex$1 = fn, callBound$4 = callBound$7, isRegex = isRegex$1, $exec = callBound$4("RegExp.prototype.exec"), $TypeError$6 = type, safeRegexTest$1 = function(c) {
  if (!isRegex(c))
    throw new $TypeError$6("`regex` must be a RegExp");
  return function(we) {
    return $exec(c, we) !== null;
  };
}, callBound$3 = callBound$7, safeRegexTest = safeRegexTest$1, isFnRegex = safeRegexTest(/^\s*(?:function)?\*/), hasToStringTag$2 = shams(), getProto = requireGetProto(), toStr$3 = callBound$3("Object.prototype.toString"), fnToStr$1 = callBound$3("Function.prototype.toString"), getGeneratorFunc = function() {
  if (!hasToStringTag$2)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, GeneratorFunction, isGeneratorFunction = function(c) {
  if (typeof c != "function")
    return !1;
  if (isFnRegex(fnToStr$1(c)))
    return !0;
  if (!hasToStringTag$2) {
    var ie = toStr$3(c);
    return ie === "[object GeneratorFunction]";
  }
  if (!getProto)
    return !1;
  if (typeof GeneratorFunction > "u") {
    var we = getGeneratorFunc();
    GeneratorFunction = we ? getProto(we) : !1;
  }
  return getProto(c) === GeneratorFunction;
}, fnToStr = Function.prototype.toString, reflectApply = typeof Reflect == "object" && Reflect !== null && Reflect.apply, badArrayLike, isCallableMarker;
if (typeof reflectApply == "function" && typeof Object.defineProperty == "function")
  try {
    badArrayLike = Object.defineProperty({}, "length", {
      get: function() {
        throw isCallableMarker;
      }
    }), isCallableMarker = {}, reflectApply(function() {
      throw 42;
    }, null, badArrayLike);
  } catch (m) {
    m !== isCallableMarker && (reflectApply = null);
  }
else
  reflectApply = null;
var constructorRegex = /^\s*class\b/, isES6ClassFn = function(c) {
  try {
    var ie = fnToStr.call(c);
    return constructorRegex.test(ie);
  } catch {
    return !1;
  }
}, tryFunctionObject = function(c) {
  try {
    return isES6ClassFn(c) ? !1 : (fnToStr.call(c), !0);
  } catch {
    return !1;
  }
}, toStr$2 = Object.prototype.toString, objectClass = "[object Object]", fnClass = "[object Function]", genClass = "[object GeneratorFunction]", ddaClass = "[object HTMLAllCollection]", ddaClass2 = "[object HTML document.all class]", ddaClass3 = "[object HTMLCollection]", hasToStringTag$1 = typeof Symbol == "function" && !!Symbol.toStringTag, isIE68 = !(0 in [,]), isDDA = function() {
  return !1;
};
if (typeof document == "object") {
  var all = document.all;
  toStr$2.call(all) === toStr$2.call(document.all) && (isDDA = function(c) {
    if ((isIE68 || !c) && (typeof c > "u" || typeof c == "object"))
      try {
        var ie = toStr$2.call(c);
        return (ie === ddaClass || ie === ddaClass2 || ie === ddaClass3 || ie === objectClass) && c("") == null;
      } catch {
      }
    return !1;
  });
}
var isCallable$1 = reflectApply ? function(c) {
  if (isDDA(c))
    return !0;
  if (!c || typeof c != "function" && typeof c != "object")
    return !1;
  try {
    reflectApply(c, null, badArrayLike);
  } catch (ie) {
    if (ie !== isCallableMarker)
      return !1;
  }
  return !isES6ClassFn(c) && tryFunctionObject(c);
} : function(c) {
  if (isDDA(c))
    return !0;
  if (!c || typeof c != "function" && typeof c != "object")
    return !1;
  if (hasToStringTag$1)
    return tryFunctionObject(c);
  if (isES6ClassFn(c))
    return !1;
  var ie = toStr$2.call(c);
  return ie !== fnClass && ie !== genClass && !/^\[object HTML/.test(ie) ? !1 : tryFunctionObject(c);
}, isCallable = isCallable$1, toStr$1 = Object.prototype.toString, hasOwnProperty = Object.prototype.hasOwnProperty, forEachArray = function(c, ie, we) {
  for (var $e = 0, Me = c.length; $e < Me; $e++)
    hasOwnProperty.call(c, $e) && (we == null ? ie(c[$e], $e, c) : ie.call(we, c[$e], $e, c));
}, forEachString = function(c, ie, we) {
  for (var $e = 0, Me = c.length; $e < Me; $e++)
    we == null ? ie(c.charAt($e), $e, c) : ie.call(we, c.charAt($e), $e, c);
}, forEachObject = function(c, ie, we) {
  for (var $e in c)
    hasOwnProperty.call(c, $e) && (we == null ? ie(c[$e], $e, c) : ie.call(we, c[$e], $e, c));
}, forEach$1 = function(c, ie, we) {
  if (!isCallable(ie))
    throw new TypeError("iterator must be a function");
  var $e;
  arguments.length >= 3 && ($e = we), toStr$1.call(c) === "[object Array]" ? forEachArray(c, ie, $e) : typeof c == "string" ? forEachString(c, ie, $e) : forEachObject(c, ie, $e);
}, forEach_1 = forEach$1, possibleTypedArrayNames = [
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Int16Array",
  "Int32Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array"
], possibleNames = possibleTypedArrayNames, g$3 = typeof globalThis > "u" ? commonjsGlobal : globalThis, availableTypedArrays$1 = function() {
  for (var c = [], ie = 0; ie < possibleNames.length; ie++)
    typeof g$3[possibleNames[ie]] == "function" && (c[c.length] = possibleNames[ie]);
  return c;
}, callBind$1 = { exports: {} }, $defineProperty$1 = esDefineProperty, $SyntaxError = syntax, $TypeError$5 = type, gopd = gopd$1, defineDataProperty = function(c, ie, we) {
  if (!c || typeof c != "object" && typeof c != "function")
    throw new $TypeError$5("`obj` must be an object or a function`");
  if (typeof ie != "string" && typeof ie != "symbol")
    throw new $TypeError$5("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new $TypeError$5("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new $TypeError$5("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new $TypeError$5("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new $TypeError$5("`loose`, if provided, must be a boolean");
  var $e = arguments.length > 3 ? arguments[3] : null, Me = arguments.length > 4 ? arguments[4] : null, Ze = arguments.length > 5 ? arguments[5] : null, ne = arguments.length > 6 ? arguments[6] : !1, rr = !!gopd && gopd(c, ie);
  if ($defineProperty$1)
    $defineProperty$1(c, ie, {
      configurable: Ze === null && rr ? rr.configurable : !Ze,
      enumerable: $e === null && rr ? rr.enumerable : !$e,
      value: we,
      writable: Me === null && rr ? rr.writable : !Me
    });
  else if (ne || !$e && !Me && !Ze)
    c[ie] = we;
  else
    throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, $defineProperty = esDefineProperty, hasPropertyDescriptors = function() {
  return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function() {
  if (!$defineProperty)
    return null;
  try {
    return $defineProperty([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors, GetIntrinsic$2 = getIntrinsic, define = defineDataProperty, hasDescriptors = hasPropertyDescriptors_1(), gOPD$1 = gopd$1, $TypeError$4 = type, $floor$1 = GetIntrinsic$2("%Math.floor%"), setFunctionLength = function(c, ie) {
  if (typeof c != "function")
    throw new $TypeError$4("`fn` is not a function");
  if (typeof ie != "number" || ie < 0 || ie > 4294967295 || $floor$1(ie) !== ie)
    throw new $TypeError$4("`length` must be a positive 32-bit integer");
  var we = arguments.length > 2 && !!arguments[2], $e = !0, Me = !0;
  if ("length" in c && gOPD$1) {
    var Ze = gOPD$1(c, "length");
    Ze && !Ze.configurable && ($e = !1), Ze && !Ze.writable && (Me = !1);
  }
  return ($e || Me || !we) && (hasDescriptors ? define(c, "length", ie, !0, !0) : define(c, "length", ie)), c;
}, bind = functionBind, $apply = requireFunctionApply(), actualApply = actualApply$1, applyBind = function() {
  return actualApply(bind, $apply, arguments);
};
(function(m) {
  var c = setFunctionLength, ie = esDefineProperty, we = callBindApplyHelpers, $e = applyBind;
  m.exports = function(Ze) {
    var ne = we(arguments), rr = Ze.length - (arguments.length - 1);
    return c(
      ne,
      1 + (rr > 0 ? rr : 0),
      !0
    );
  }, ie ? ie(m.exports, "apply", { value: $e }) : m.exports.apply = $e;
})(callBind$1);
var forEach = forEach_1, availableTypedArrays = availableTypedArrays$1, callBind = callBind$1.exports, callBound$2 = callBound$7, gOPD = gopd$1, $toString = callBound$2("Object.prototype.toString"), hasToStringTag = shams(), g$2 = typeof globalThis > "u" ? commonjsGlobal : globalThis, typedArrays = availableTypedArrays(), $slice$1 = callBound$2("String.prototype.slice"), getPrototypeOf = Object.getPrototypeOf, $indexOf = callBound$2("Array.prototype.indexOf", !0) || function(c, ie) {
  for (var we = 0; we < c.length; we += 1)
    if (c[we] === ie)
      return we;
  return -1;
}, cache = { __proto__: null };
hasToStringTag && gOPD && getPrototypeOf ? forEach(typedArrays, function(m) {
  var c = new g$2[m]();
  if (Symbol.toStringTag in c) {
    var ie = getPrototypeOf(c), we = gOPD(ie, Symbol.toStringTag);
    if (!we) {
      var $e = getPrototypeOf(ie);
      we = gOPD($e, Symbol.toStringTag);
    }
    cache["$" + m] = callBind(we.get);
  }
}) : forEach(typedArrays, function(m) {
  var c = new g$2[m](), ie = c.slice || c.set;
  ie && (cache["$" + m] = callBind(ie));
});
var tryTypedArrays = function(c) {
  var ie = !1;
  return forEach(
    cache,
    function(we, $e) {
      if (!ie)
        try {
          "$" + we(c) === $e && (ie = $slice$1($e, 1));
        } catch {
        }
    }
  ), ie;
}, trySlices = function(c) {
  var ie = !1;
  return forEach(
    cache,
    function(we, $e) {
      if (!ie)
        try {
          we(c), ie = $slice$1($e, 1);
        } catch {
        }
    }
  ), ie;
}, whichTypedArray$1 = function(c) {
  if (!c || typeof c != "object")
    return !1;
  if (!hasToStringTag) {
    var ie = $slice$1($toString(c), 8, -1);
    return $indexOf(typedArrays, ie) > -1 ? ie : ie !== "Object" ? !1 : trySlices(c);
  }
  return gOPD ? tryTypedArrays(c) : null;
}, whichTypedArray = whichTypedArray$1, isTypedArray = function(c) {
  return !!whichTypedArray(c);
};
(function(m) {
  var c = isArguments, ie = isGeneratorFunction, we = whichTypedArray$1, $e = isTypedArray;
  function Me(ji) {
    return ji.call.bind(ji);
  }
  var Ze = typeof BigInt < "u", ne = typeof Symbol < "u", rr = Me(Object.prototype.toString), gr = Me(Number.prototype.valueOf), or = Me(String.prototype.valueOf), _r = Me(Boolean.prototype.valueOf);
  if (Ze)
    var Lr = Me(BigInt.prototype.valueOf);
  if (ne)
    var Ir = Me(Symbol.prototype.valueOf);
  function Ar(ji, Kn) {
    if (typeof ji != "object")
      return !1;
    try {
      return Kn(ji), !0;
    } catch {
      return !1;
    }
  }
  m.isArgumentsObject = c, m.isGeneratorFunction = ie, m.isTypedArray = $e;
  function Rr(ji) {
    return typeof Promise < "u" && ji instanceof Promise || ji !== null && typeof ji == "object" && typeof ji.then == "function" && typeof ji.catch == "function";
  }
  m.isPromise = Rr;
  function Nr(ji) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(ji) : $e(ji) || Hr(ji);
  }
  m.isArrayBufferView = Nr;
  function Yr(ji) {
    return we(ji) === "Uint8Array";
  }
  m.isUint8Array = Yr;
  function Vr(ji) {
    return we(ji) === "Uint8ClampedArray";
  }
  m.isUint8ClampedArray = Vr;
  function Xr(ji) {
    return we(ji) === "Uint16Array";
  }
  m.isUint16Array = Xr;
  function Wr(ji) {
    return we(ji) === "Uint32Array";
  }
  m.isUint32Array = Wr;
  function si(ji) {
    return we(ji) === "Int8Array";
  }
  m.isInt8Array = si;
  function li(ji) {
    return we(ji) === "Int16Array";
  }
  m.isInt16Array = li;
  function xi(ji) {
    return we(ji) === "Int32Array";
  }
  m.isInt32Array = xi;
  function di(ji) {
    return we(ji) === "Float32Array";
  }
  m.isFloat32Array = di;
  function oi(ji) {
    return we(ji) === "Float64Array";
  }
  m.isFloat64Array = oi;
  function ci(ji) {
    return we(ji) === "BigInt64Array";
  }
  m.isBigInt64Array = ci;
  function vr(ji) {
    return we(ji) === "BigUint64Array";
  }
  m.isBigUint64Array = vr;
  function Ae(ji) {
    return rr(ji) === "[object Map]";
  }
  Ae.working = typeof Map < "u" && Ae(/* @__PURE__ */ new Map());
  function ze(ji) {
    return typeof Map > "u" ? !1 : Ae.working ? Ae(ji) : ji instanceof Map;
  }
  m.isMap = ze;
  function Ue(ji) {
    return rr(ji) === "[object Set]";
  }
  Ue.working = typeof Set < "u" && Ue(/* @__PURE__ */ new Set());
  function tr(ji) {
    return typeof Set > "u" ? !1 : Ue.working ? Ue(ji) : ji instanceof Set;
  }
  m.isSet = tr;
  function lr(ji) {
    return rr(ji) === "[object WeakMap]";
  }
  lr.working = typeof WeakMap < "u" && lr(/* @__PURE__ */ new WeakMap());
  function pr(ji) {
    return typeof WeakMap > "u" ? !1 : lr.working ? lr(ji) : ji instanceof WeakMap;
  }
  m.isWeakMap = pr;
  function br(ji) {
    return rr(ji) === "[object WeakSet]";
  }
  br.working = typeof WeakSet < "u" && br(/* @__PURE__ */ new WeakSet());
  function nr(ji) {
    return br(ji);
  }
  m.isWeakSet = nr;
  function Pe(ji) {
    return rr(ji) === "[object ArrayBuffer]";
  }
  Pe.working = typeof ArrayBuffer < "u" && Pe(new ArrayBuffer());
  function ur(ji) {
    return typeof ArrayBuffer > "u" ? !1 : Pe.working ? Pe(ji) : ji instanceof ArrayBuffer;
  }
  m.isArrayBuffer = ur;
  function Pr(ji) {
    return rr(ji) === "[object DataView]";
  }
  Pr.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && Pr(new DataView(new ArrayBuffer(1), 0, 1));
  function Hr(ji) {
    return typeof DataView > "u" ? !1 : Pr.working ? Pr(ji) : ji instanceof DataView;
  }
  m.isDataView = Hr;
  var vi = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function Ti(ji) {
    return rr(ji) === "[object SharedArrayBuffer]";
  }
  function wi(ji) {
    return typeof vi > "u" ? !1 : (typeof Ti.working > "u" && (Ti.working = Ti(new vi())), Ti.working ? Ti(ji) : ji instanceof vi);
  }
  m.isSharedArrayBuffer = wi;
  function ii(ji) {
    return rr(ji) === "[object AsyncFunction]";
  }
  m.isAsyncFunction = ii;
  function mi(ji) {
    return rr(ji) === "[object Map Iterator]";
  }
  m.isMapIterator = mi;
  function ei(ji) {
    return rr(ji) === "[object Set Iterator]";
  }
  m.isSetIterator = ei;
  function Zr(ji) {
    return rr(ji) === "[object Generator]";
  }
  m.isGeneratorObject = Zr;
  function pi(ji) {
    return rr(ji) === "[object WebAssembly.Module]";
  }
  m.isWebAssemblyCompiledModule = pi;
  function hi(ji) {
    return Ar(ji, gr);
  }
  m.isNumberObject = hi;
  function Oi(ji) {
    return Ar(ji, or);
  }
  m.isStringObject = Oi;
  function qi(ji) {
    return Ar(ji, _r);
  }
  m.isBooleanObject = qi;
  function yn(ji) {
    return Ze && Ar(ji, Lr);
  }
  m.isBigIntObject = yn;
  function sn(ji) {
    return ne && Ar(ji, Ir);
  }
  m.isSymbolObject = sn;
  function $n(ji) {
    return hi(ji) || Oi(ji) || qi(ji) || yn(ji) || sn(ji);
  }
  m.isBoxedPrimitive = $n;
  function rn(ji) {
    return typeof Uint8Array < "u" && (ur(ji) || wi(ji));
  }
  m.isAnyArrayBuffer = rn, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(ji) {
    Object.defineProperty(m, ji, {
      enumerable: !1,
      value: function() {
        throw new Error(ji + " is not supported in userland");
      }
    });
  });
})(types$2);
var isBufferBrowser = function(c) {
  return c && typeof c == "object" && typeof c.copy == "function" && typeof c.fill == "function" && typeof c.readUInt8 == "function";
};
(function(m) {
  var c = Object.getOwnPropertyDescriptors || function(Hr) {
    for (var vi = Object.keys(Hr), Ti = {}, wi = 0; wi < vi.length; wi++)
      Ti[vi[wi]] = Object.getOwnPropertyDescriptor(Hr, vi[wi]);
    return Ti;
  }, ie = /%[sdj%]/g;
  m.format = function(Pr) {
    if (!si(Pr)) {
      for (var Hr = [], vi = 0; vi < arguments.length; vi++)
        Hr.push(Ze(arguments[vi]));
      return Hr.join(" ");
    }
    for (var vi = 1, Ti = arguments, wi = Ti.length, ii = String(Pr).replace(ie, function(ei) {
      if (ei === "%%")
        return "%";
      if (vi >= wi)
        return ei;
      switch (ei) {
        case "%s":
          return String(Ti[vi++]);
        case "%d":
          return Number(Ti[vi++]);
        case "%j":
          try {
            return JSON.stringify(Ti[vi++]);
          } catch {
            return "[Circular]";
          }
        default:
          return ei;
      }
    }), mi = Ti[vi]; vi < wi; mi = Ti[++vi])
      Vr(mi) || !oi(mi) ? ii += " " + mi : ii += " " + Ze(mi);
    return ii;
  }, m.deprecate = function(Pr, Hr) {
    if (typeof process$1 < "u" && process$1.noDeprecation === !0)
      return Pr;
    if (typeof process$1 > "u")
      return function() {
        return m.deprecate(Pr, Hr).apply(this, arguments);
      };
    var vi = !1;
    function Ti() {
      if (!vi) {
        if (process$1.throwDeprecation)
          throw new Error(Hr);
        process$1.traceDeprecation ? console.trace(Hr) : console.error(Hr), vi = !0;
      }
      return Pr.apply(this, arguments);
    }
    return Ti;
  };
  var we = {}, $e = /^$/;
  if (process$1.env.NODE_DEBUG) {
    var Me = process$1.env.NODE_DEBUG;
    Me = Me.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), $e = new RegExp("^" + Me + "$", "i");
  }
  m.debuglog = function(Pr) {
    if (Pr = Pr.toUpperCase(), !we[Pr])
      if ($e.test(Pr)) {
        var Hr = process$1.pid;
        we[Pr] = function() {
          var vi = m.format.apply(m, arguments);
          console.error("%s %d: %s", Pr, Hr, vi);
        };
      } else
        we[Pr] = function() {
        };
    return we[Pr];
  };
  function Ze(Pr, Hr) {
    var vi = {
      seen: [],
      stylize: rr
    };
    return arguments.length >= 3 && (vi.depth = arguments[2]), arguments.length >= 4 && (vi.colors = arguments[3]), Yr(Hr) ? vi.showHidden = Hr : Hr && m._extend(vi, Hr), xi(vi.showHidden) && (vi.showHidden = !1), xi(vi.depth) && (vi.depth = 2), xi(vi.colors) && (vi.colors = !1), xi(vi.customInspect) && (vi.customInspect = !0), vi.colors && (vi.stylize = ne), or(vi, Pr, vi.depth);
  }
  m.inspect = Ze, Ze.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, Ze.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    regexp: "red"
  };
  function ne(Pr, Hr) {
    var vi = Ze.styles[Hr];
    return vi ? "\x1B[" + Ze.colors[vi][0] + "m" + Pr + "\x1B[" + Ze.colors[vi][1] + "m" : Pr;
  }
  function rr(Pr, Hr) {
    return Pr;
  }
  function gr(Pr) {
    var Hr = {};
    return Pr.forEach(function(vi, Ti) {
      Hr[vi] = !0;
    }), Hr;
  }
  function or(Pr, Hr, vi) {
    if (Pr.customInspect && Hr && Ae(Hr.inspect) && Hr.inspect !== m.inspect && !(Hr.constructor && Hr.constructor.prototype === Hr)) {
      var Ti = Hr.inspect(vi, Pr);
      return si(Ti) || (Ti = or(Pr, Ti, vi)), Ti;
    }
    var wi = _r(Pr, Hr);
    if (wi)
      return wi;
    var ii = Object.keys(Hr), mi = gr(ii);
    if (Pr.showHidden && (ii = Object.getOwnPropertyNames(Hr)), vr(Hr) && (ii.indexOf("message") >= 0 || ii.indexOf("description") >= 0))
      return Lr(Hr);
    if (ii.length === 0) {
      if (Ae(Hr)) {
        var ei = Hr.name ? ": " + Hr.name : "";
        return Pr.stylize("[Function" + ei + "]", "special");
      }
      if (di(Hr))
        return Pr.stylize(RegExp.prototype.toString.call(Hr), "regexp");
      if (ci(Hr))
        return Pr.stylize(Date.prototype.toString.call(Hr), "date");
      if (vr(Hr))
        return Lr(Hr);
    }
    var Zr = "", pi = !1, hi = ["{", "}"];
    if (Nr(Hr) && (pi = !0, hi = ["[", "]"]), Ae(Hr)) {
      var Oi = Hr.name ? ": " + Hr.name : "";
      Zr = " [Function" + Oi + "]";
    }
    if (di(Hr) && (Zr = " " + RegExp.prototype.toString.call(Hr)), ci(Hr) && (Zr = " " + Date.prototype.toUTCString.call(Hr)), vr(Hr) && (Zr = " " + Lr(Hr)), ii.length === 0 && (!pi || Hr.length == 0))
      return hi[0] + Zr + hi[1];
    if (vi < 0)
      return di(Hr) ? Pr.stylize(RegExp.prototype.toString.call(Hr), "regexp") : Pr.stylize("[Object]", "special");
    Pr.seen.push(Hr);
    var qi;
    return pi ? qi = Ir(Pr, Hr, vi, mi, ii) : qi = ii.map(function(yn) {
      return Ar(Pr, Hr, vi, mi, yn, pi);
    }), Pr.seen.pop(), Rr(qi, Zr, hi);
  }
  function _r(Pr, Hr) {
    if (xi(Hr))
      return Pr.stylize("undefined", "undefined");
    if (si(Hr)) {
      var vi = "'" + JSON.stringify(Hr).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return Pr.stylize(vi, "string");
    }
    if (Wr(Hr))
      return Pr.stylize("" + Hr, "number");
    if (Yr(Hr))
      return Pr.stylize("" + Hr, "boolean");
    if (Vr(Hr))
      return Pr.stylize("null", "null");
  }
  function Lr(Pr) {
    return "[" + Error.prototype.toString.call(Pr) + "]";
  }
  function Ir(Pr, Hr, vi, Ti, wi) {
    for (var ii = [], mi = 0, ei = Hr.length; mi < ei; ++mi)
      br(Hr, String(mi)) ? ii.push(Ar(
        Pr,
        Hr,
        vi,
        Ti,
        String(mi),
        !0
      )) : ii.push("");
    return wi.forEach(function(Zr) {
      Zr.match(/^\d+$/) || ii.push(Ar(
        Pr,
        Hr,
        vi,
        Ti,
        Zr,
        !0
      ));
    }), ii;
  }
  function Ar(Pr, Hr, vi, Ti, wi, ii) {
    var mi, ei, Zr;
    if (Zr = Object.getOwnPropertyDescriptor(Hr, wi) || { value: Hr[wi] }, Zr.get ? Zr.set ? ei = Pr.stylize("[Getter/Setter]", "special") : ei = Pr.stylize("[Getter]", "special") : Zr.set && (ei = Pr.stylize("[Setter]", "special")), br(Ti, wi) || (mi = "[" + wi + "]"), ei || (Pr.seen.indexOf(Zr.value) < 0 ? (Vr(vi) ? ei = or(Pr, Zr.value, null) : ei = or(Pr, Zr.value, vi - 1), ei.indexOf(`
`) > -1 && (ii ? ei = ei.split(`
`).map(function(pi) {
      return "  " + pi;
    }).join(`
`).slice(2) : ei = `
` + ei.split(`
`).map(function(pi) {
      return "   " + pi;
    }).join(`
`))) : ei = Pr.stylize("[Circular]", "special")), xi(mi)) {
      if (ii && wi.match(/^\d+$/))
        return ei;
      mi = JSON.stringify("" + wi), mi.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (mi = mi.slice(1, -1), mi = Pr.stylize(mi, "name")) : (mi = mi.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), mi = Pr.stylize(mi, "string"));
    }
    return mi + ": " + ei;
  }
  function Rr(Pr, Hr, vi) {
    var Ti = Pr.reduce(function(wi, ii) {
      return ii.indexOf(`
`) >= 0, wi + ii.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return Ti > 60 ? vi[0] + (Hr === "" ? "" : Hr + `
 `) + " " + Pr.join(`,
  `) + " " + vi[1] : vi[0] + Hr + " " + Pr.join(", ") + " " + vi[1];
  }
  m.types = types$2;
  function Nr(Pr) {
    return Array.isArray(Pr);
  }
  m.isArray = Nr;
  function Yr(Pr) {
    return typeof Pr == "boolean";
  }
  m.isBoolean = Yr;
  function Vr(Pr) {
    return Pr === null;
  }
  m.isNull = Vr;
  function Xr(Pr) {
    return Pr == null;
  }
  m.isNullOrUndefined = Xr;
  function Wr(Pr) {
    return typeof Pr == "number";
  }
  m.isNumber = Wr;
  function si(Pr) {
    return typeof Pr == "string";
  }
  m.isString = si;
  function li(Pr) {
    return typeof Pr == "symbol";
  }
  m.isSymbol = li;
  function xi(Pr) {
    return Pr === void 0;
  }
  m.isUndefined = xi;
  function di(Pr) {
    return oi(Pr) && Ue(Pr) === "[object RegExp]";
  }
  m.isRegExp = di, m.types.isRegExp = di;
  function oi(Pr) {
    return typeof Pr == "object" && Pr !== null;
  }
  m.isObject = oi;
  function ci(Pr) {
    return oi(Pr) && Ue(Pr) === "[object Date]";
  }
  m.isDate = ci, m.types.isDate = ci;
  function vr(Pr) {
    return oi(Pr) && (Ue(Pr) === "[object Error]" || Pr instanceof Error);
  }
  m.isError = vr, m.types.isNativeError = vr;
  function Ae(Pr) {
    return typeof Pr == "function";
  }
  m.isFunction = Ae;
  function ze(Pr) {
    return Pr === null || typeof Pr == "boolean" || typeof Pr == "number" || typeof Pr == "string" || typeof Pr == "symbol" || typeof Pr > "u";
  }
  m.isPrimitive = ze, m.isBuffer = isBufferBrowser;
  function Ue(Pr) {
    return Object.prototype.toString.call(Pr);
  }
  function tr(Pr) {
    return Pr < 10 ? "0" + Pr.toString(10) : Pr.toString(10);
  }
  var lr = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function pr() {
    var Pr = new Date(), Hr = [
      tr(Pr.getHours()),
      tr(Pr.getMinutes()),
      tr(Pr.getSeconds())
    ].join(":");
    return [Pr.getDate(), lr[Pr.getMonth()], Hr].join(" ");
  }
  m.log = function() {
    console.log("%s - %s", pr(), m.format.apply(m, arguments));
  }, m.inherits = inherits_browser.exports, m._extend = function(Pr, Hr) {
    if (!Hr || !oi(Hr))
      return Pr;
    for (var vi = Object.keys(Hr), Ti = vi.length; Ti--; )
      Pr[vi[Ti]] = Hr[vi[Ti]];
    return Pr;
  };
  function br(Pr, Hr) {
    return Object.prototype.hasOwnProperty.call(Pr, Hr);
  }
  var nr = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  m.promisify = function(Hr) {
    if (typeof Hr != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (nr && Hr[nr]) {
      var vi = Hr[nr];
      if (typeof vi != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(vi, nr, {
        value: vi,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), vi;
    }
    function vi() {
      for (var Ti, wi, ii = new Promise(function(Zr, pi) {
        Ti = Zr, wi = pi;
      }), mi = [], ei = 0; ei < arguments.length; ei++)
        mi.push(arguments[ei]);
      mi.push(function(Zr, pi) {
        Zr ? wi(Zr) : Ti(pi);
      });
      try {
        Hr.apply(this, mi);
      } catch (Zr) {
        wi(Zr);
      }
      return ii;
    }
    return Object.setPrototypeOf(vi, Object.getPrototypeOf(Hr)), nr && Object.defineProperty(vi, nr, {
      value: vi,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      vi,
      c(Hr)
    );
  }, m.promisify.custom = nr;
  function Pe(Pr, Hr) {
    if (!Pr) {
      var vi = new Error("Promise was rejected with a falsy value");
      vi.reason = Pr, Pr = vi;
    }
    return Hr(Pr);
  }
  function ur(Pr) {
    if (typeof Pr != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function Hr() {
      for (var vi = [], Ti = 0; Ti < arguments.length; Ti++)
        vi.push(arguments[Ti]);
      var wi = vi.pop();
      if (typeof wi != "function")
        throw new TypeError("The last argument must be of type Function");
      var ii = this, mi = function() {
        return wi.apply(ii, arguments);
      };
      Pr.apply(this, vi).then(
        function(ei) {
          process$1.nextTick(mi.bind(null, null, ei));
        },
        function(ei) {
          process$1.nextTick(Pe.bind(null, ei, mi));
        }
      );
    }
    return Object.setPrototypeOf(Hr, Object.getPrototypeOf(Pr)), Object.defineProperties(
      Hr,
      c(Pr)
    ), Hr;
  }
  m.callbackify = ur;
})(util$4);
var buffer_list, hasRequiredBuffer_list;
function requireBuffer_list() {
  if (hasRequiredBuffer_list)
    return buffer_list;
  hasRequiredBuffer_list = 1;
  function m(Ar, Rr) {
    var Nr = Object.keys(Ar);
    if (Object.getOwnPropertySymbols) {
      var Yr = Object.getOwnPropertySymbols(Ar);
      Rr && (Yr = Yr.filter(function(Vr) {
        return Object.getOwnPropertyDescriptor(Ar, Vr).enumerable;
      })), Nr.push.apply(Nr, Yr);
    }
    return Nr;
  }
  function c(Ar) {
    for (var Rr = 1; Rr < arguments.length; Rr++) {
      var Nr = arguments[Rr] != null ? arguments[Rr] : {};
      Rr % 2 ? m(Object(Nr), !0).forEach(function(Yr) {
        ie(Ar, Yr, Nr[Yr]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Ar, Object.getOwnPropertyDescriptors(Nr)) : m(Object(Nr)).forEach(function(Yr) {
        Object.defineProperty(Ar, Yr, Object.getOwnPropertyDescriptor(Nr, Yr));
      });
    }
    return Ar;
  }
  function ie(Ar, Rr, Nr) {
    return Rr = Ze(Rr), Rr in Ar ? Object.defineProperty(Ar, Rr, { value: Nr, enumerable: !0, configurable: !0, writable: !0 }) : Ar[Rr] = Nr, Ar;
  }
  function we(Ar, Rr) {
    if (!(Ar instanceof Rr))
      throw new TypeError("Cannot call a class as a function");
  }
  function $e(Ar, Rr) {
    for (var Nr = 0; Nr < Rr.length; Nr++) {
      var Yr = Rr[Nr];
      Yr.enumerable = Yr.enumerable || !1, Yr.configurable = !0, "value" in Yr && (Yr.writable = !0), Object.defineProperty(Ar, Ze(Yr.key), Yr);
    }
  }
  function Me(Ar, Rr, Nr) {
    return Rr && $e(Ar.prototype, Rr), Nr && $e(Ar, Nr), Object.defineProperty(Ar, "prototype", { writable: !1 }), Ar;
  }
  function Ze(Ar) {
    var Rr = ne(Ar, "string");
    return typeof Rr == "symbol" ? Rr : String(Rr);
  }
  function ne(Ar, Rr) {
    if (typeof Ar != "object" || Ar === null)
      return Ar;
    var Nr = Ar[Symbol.toPrimitive];
    if (Nr !== void 0) {
      var Yr = Nr.call(Ar, Rr || "default");
      if (typeof Yr != "object")
        return Yr;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Rr === "string" ? String : Number)(Ar);
  }
  var rr = require$$0$4, gr = rr.Buffer, or = util$4, _r = or.inspect, Lr = _r && _r.custom || "inspect";
  function Ir(Ar, Rr, Nr) {
    gr.prototype.copy.call(Ar, Rr, Nr);
  }
  return buffer_list = /* @__PURE__ */ function() {
    function Ar() {
      we(this, Ar), this.head = null, this.tail = null, this.length = 0;
    }
    return Me(Ar, [{
      key: "push",
      value: function(Nr) {
        var Yr = {
          data: Nr,
          next: null
        };
        this.length > 0 ? this.tail.next = Yr : this.head = Yr, this.tail = Yr, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(Nr) {
        var Yr = {
          data: Nr,
          next: this.head
        };
        this.length === 0 && (this.tail = Yr), this.head = Yr, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var Nr = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, Nr;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(Nr) {
        if (this.length === 0)
          return "";
        for (var Yr = this.head, Vr = "" + Yr.data; Yr = Yr.next; )
          Vr += Nr + Yr.data;
        return Vr;
      }
    }, {
      key: "concat",
      value: function(Nr) {
        if (this.length === 0)
          return gr.alloc(0);
        for (var Yr = gr.allocUnsafe(Nr >>> 0), Vr = this.head, Xr = 0; Vr; )
          Ir(Vr.data, Yr, Xr), Xr += Vr.data.length, Vr = Vr.next;
        return Yr;
      }
    }, {
      key: "consume",
      value: function(Nr, Yr) {
        var Vr;
        return Nr < this.head.data.length ? (Vr = this.head.data.slice(0, Nr), this.head.data = this.head.data.slice(Nr)) : Nr === this.head.data.length ? Vr = this.shift() : Vr = Yr ? this._getString(Nr) : this._getBuffer(Nr), Vr;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
    }, {
      key: "_getString",
      value: function(Nr) {
        var Yr = this.head, Vr = 1, Xr = Yr.data;
        for (Nr -= Xr.length; Yr = Yr.next; ) {
          var Wr = Yr.data, si = Nr > Wr.length ? Wr.length : Nr;
          if (si === Wr.length ? Xr += Wr : Xr += Wr.slice(0, Nr), Nr -= si, Nr === 0) {
            si === Wr.length ? (++Vr, Yr.next ? this.head = Yr.next : this.head = this.tail = null) : (this.head = Yr, Yr.data = Wr.slice(si));
            break;
          }
          ++Vr;
        }
        return this.length -= Vr, Xr;
      }
    }, {
      key: "_getBuffer",
      value: function(Nr) {
        var Yr = gr.allocUnsafe(Nr), Vr = this.head, Xr = 1;
        for (Vr.data.copy(Yr), Nr -= Vr.data.length; Vr = Vr.next; ) {
          var Wr = Vr.data, si = Nr > Wr.length ? Wr.length : Nr;
          if (Wr.copy(Yr, Yr.length - Nr, 0, si), Nr -= si, Nr === 0) {
            si === Wr.length ? (++Xr, Vr.next ? this.head = Vr.next : this.head = this.tail = null) : (this.head = Vr, Vr.data = Wr.slice(si));
            break;
          }
          ++Xr;
        }
        return this.length -= Xr, Yr;
      }
    }, {
      key: Lr,
      value: function(Nr, Yr) {
        return _r(this, c(c({}, Yr), {}, {
          depth: 0,
          customInspect: !1
        }));
      }
    }]), Ar;
  }(), buffer_list;
}
var destroy_1$1, hasRequiredDestroy;
function requireDestroy() {
  if (hasRequiredDestroy)
    return destroy_1$1;
  hasRequiredDestroy = 1;
  function m(Ze, ne) {
    var rr = this, gr = this._readableState && this._readableState.destroyed, or = this._writableState && this._writableState.destroyed;
    return gr || or ? (ne ? ne(Ze) : Ze && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process$1.nextTick($e, this, Ze)) : process$1.nextTick($e, this, Ze)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(Ze || null, function(_r) {
      !ne && _r ? rr._writableState ? rr._writableState.errorEmitted ? process$1.nextTick(ie, rr) : (rr._writableState.errorEmitted = !0, process$1.nextTick(c, rr, _r)) : process$1.nextTick(c, rr, _r) : ne ? (process$1.nextTick(ie, rr), ne(_r)) : process$1.nextTick(ie, rr);
    }), this);
  }
  function c(Ze, ne) {
    $e(Ze, ne), ie(Ze);
  }
  function ie(Ze) {
    Ze._writableState && !Ze._writableState.emitClose || Ze._readableState && !Ze._readableState.emitClose || Ze.emit("close");
  }
  function we() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function $e(Ze, ne) {
    Ze.emit("error", ne);
  }
  function Me(Ze, ne) {
    var rr = Ze._readableState, gr = Ze._writableState;
    rr && rr.autoDestroy || gr && gr.autoDestroy ? Ze.destroy(ne) : Ze.emit("error", ne);
  }
  return destroy_1$1 = {
    destroy: m,
    undestroy: we,
    errorOrDestroy: Me
  }, destroy_1$1;
}
var errorsBrowser = {}, hasRequiredErrorsBrowser;
function requireErrorsBrowser() {
  if (hasRequiredErrorsBrowser)
    return errorsBrowser;
  hasRequiredErrorsBrowser = 1;
  function m(ne, rr) {
    ne.prototype = Object.create(rr.prototype), ne.prototype.constructor = ne, ne.__proto__ = rr;
  }
  var c = {};
  function ie(ne, rr, gr) {
    gr || (gr = Error);
    function or(Lr, Ir, Ar) {
      return typeof rr == "string" ? rr : rr(Lr, Ir, Ar);
    }
    var _r = /* @__PURE__ */ function(Lr) {
      m(Ir, Lr);
      function Ir(Ar, Rr, Nr) {
        return Lr.call(this, or(Ar, Rr, Nr)) || this;
      }
      return Ir;
    }(gr);
    _r.prototype.name = gr.name, _r.prototype.code = ne, c[ne] = _r;
  }
  function we(ne, rr) {
    if (Array.isArray(ne)) {
      var gr = ne.length;
      return ne = ne.map(function(or) {
        return String(or);
      }), gr > 2 ? "one of ".concat(rr, " ").concat(ne.slice(0, gr - 1).join(", "), ", or ") + ne[gr - 1] : gr === 2 ? "one of ".concat(rr, " ").concat(ne[0], " or ").concat(ne[1]) : "of ".concat(rr, " ").concat(ne[0]);
    } else
      return "of ".concat(rr, " ").concat(String(ne));
  }
  function $e(ne, rr, gr) {
    return ne.substr(!gr || gr < 0 ? 0 : +gr, rr.length) === rr;
  }
  function Me(ne, rr, gr) {
    return (gr === void 0 || gr > ne.length) && (gr = ne.length), ne.substring(gr - rr.length, gr) === rr;
  }
  function Ze(ne, rr, gr) {
    return typeof gr != "number" && (gr = 0), gr + rr.length > ne.length ? !1 : ne.indexOf(rr, gr) !== -1;
  }
  return ie("ERR_INVALID_OPT_VALUE", function(ne, rr) {
    return 'The value "' + rr + '" is invalid for option "' + ne + '"';
  }, TypeError), ie("ERR_INVALID_ARG_TYPE", function(ne, rr, gr) {
    var or;
    typeof rr == "string" && $e(rr, "not ") ? (or = "must not be", rr = rr.replace(/^not /, "")) : or = "must be";
    var _r;
    if (Me(ne, " argument"))
      _r = "The ".concat(ne, " ").concat(or, " ").concat(we(rr, "type"));
    else {
      var Lr = Ze(ne, ".") ? "property" : "argument";
      _r = 'The "'.concat(ne, '" ').concat(Lr, " ").concat(or, " ").concat(we(rr, "type"));
    }
    return _r += ". Received type ".concat(typeof gr), _r;
  }, TypeError), ie("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), ie("ERR_METHOD_NOT_IMPLEMENTED", function(ne) {
    return "The " + ne + " method is not implemented";
  }), ie("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), ie("ERR_STREAM_DESTROYED", function(ne) {
    return "Cannot call " + ne + " after a stream was destroyed";
  }), ie("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), ie("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), ie("ERR_STREAM_WRITE_AFTER_END", "write after end"), ie("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), ie("ERR_UNKNOWN_ENCODING", function(ne) {
    return "Unknown encoding: " + ne;
  }, TypeError), ie("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), errorsBrowser.codes = c, errorsBrowser;
}
var state, hasRequiredState;
function requireState() {
  if (hasRequiredState)
    return state;
  hasRequiredState = 1;
  var m = requireErrorsBrowser().codes.ERR_INVALID_OPT_VALUE;
  function c(we, $e, Me) {
    return we.highWaterMark != null ? we.highWaterMark : $e ? we[Me] : null;
  }
  function ie(we, $e, Me, Ze) {
    var ne = c($e, Ze, Me);
    if (ne != null) {
      if (!(isFinite(ne) && Math.floor(ne) === ne) || ne < 0) {
        var rr = Ze ? Me : "highWaterMark";
        throw new m(rr, ne);
      }
      return Math.floor(ne);
    }
    return we.objectMode ? 16 : 16 * 1024;
  }
  return state = {
    getHighWaterMark: ie
  }, state;
}
var browser$b = deprecate;
function deprecate(m, c) {
  if (config("noDeprecation"))
    return m;
  var ie = !1;
  function we() {
    if (!ie) {
      if (config("throwDeprecation"))
        throw new Error(c);
      config("traceDeprecation") ? console.trace(c) : console.warn(c), ie = !0;
    }
    return m.apply(this, arguments);
  }
  return we;
}
function config(m) {
  try {
    if (!commonjsGlobal.localStorage)
      return !1;
  } catch {
    return !1;
  }
  var c = commonjsGlobal.localStorage[m];
  return c == null ? !1 : String(c).toLowerCase() === "true";
}
var _stream_writable$1, hasRequired_stream_writable$1;
function require_stream_writable$1() {
  if (hasRequired_stream_writable$1)
    return _stream_writable$1;
  hasRequired_stream_writable$1 = 1, _stream_writable$1 = di;
  function m(wi) {
    var ii = this;
    this.next = null, this.entry = null, this.finish = function() {
      Ti(ii, wi);
    };
  }
  var c;
  di.WritableState = li;
  var ie = {
    deprecate: browser$b
  }, we = requireStreamBrowser(), $e = require$$0$4.Buffer, Me = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function Ze(wi) {
    return $e.from(wi);
  }
  function ne(wi) {
    return $e.isBuffer(wi) || wi instanceof Me;
  }
  var rr = requireDestroy(), gr = requireState(), or = gr.getHighWaterMark, _r = requireErrorsBrowser().codes, Lr = _r.ERR_INVALID_ARG_TYPE, Ir = _r.ERR_METHOD_NOT_IMPLEMENTED, Ar = _r.ERR_MULTIPLE_CALLBACK, Rr = _r.ERR_STREAM_CANNOT_PIPE, Nr = _r.ERR_STREAM_DESTROYED, Yr = _r.ERR_STREAM_NULL_VALUES, Vr = _r.ERR_STREAM_WRITE_AFTER_END, Xr = _r.ERR_UNKNOWN_ENCODING, Wr = rr.errorOrDestroy;
  inherits_browser.exports(di, we);
  function si() {
  }
  function li(wi, ii, mi) {
    c = c || require_stream_duplex$1(), wi = wi || {}, typeof mi != "boolean" && (mi = ii instanceof c), this.objectMode = !!wi.objectMode, mi && (this.objectMode = this.objectMode || !!wi.writableObjectMode), this.highWaterMark = or(this, wi, "writableHighWaterMark", mi), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var ei = wi.decodeStrings === !1;
    this.decodeStrings = !ei, this.defaultEncoding = wi.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Zr) {
      lr(ii, Zr);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = wi.emitClose !== !1, this.autoDestroy = !!wi.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new m(this);
  }
  li.prototype.getBuffer = function() {
    for (var ii = this.bufferedRequest, mi = []; ii; )
      mi.push(ii), ii = ii.next;
    return mi;
  }, function() {
    try {
      Object.defineProperty(li.prototype, "buffer", {
        get: ie.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var xi;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (xi = Function.prototype[Symbol.hasInstance], Object.defineProperty(di, Symbol.hasInstance, {
    value: function(ii) {
      return xi.call(this, ii) ? !0 : this !== di ? !1 : ii && ii._writableState instanceof li;
    }
  })) : xi = function(ii) {
    return ii instanceof this;
  };
  function di(wi) {
    c = c || require_stream_duplex$1();
    var ii = this instanceof c;
    if (!ii && !xi.call(di, this))
      return new di(wi);
    this._writableState = new li(wi, this, ii), this.writable = !0, wi && (typeof wi.write == "function" && (this._write = wi.write), typeof wi.writev == "function" && (this._writev = wi.writev), typeof wi.destroy == "function" && (this._destroy = wi.destroy), typeof wi.final == "function" && (this._final = wi.final)), we.call(this);
  }
  di.prototype.pipe = function() {
    Wr(this, new Rr());
  };
  function oi(wi, ii) {
    var mi = new Vr();
    Wr(wi, mi), process$1.nextTick(ii, mi);
  }
  function ci(wi, ii, mi, ei) {
    var Zr;
    return mi === null ? Zr = new Yr() : typeof mi != "string" && !ii.objectMode && (Zr = new Lr("chunk", ["string", "Buffer"], mi)), Zr ? (Wr(wi, Zr), process$1.nextTick(ei, Zr), !1) : !0;
  }
  di.prototype.write = function(wi, ii, mi) {
    var ei = this._writableState, Zr = !1, pi = !ei.objectMode && ne(wi);
    return pi && !$e.isBuffer(wi) && (wi = Ze(wi)), typeof ii == "function" && (mi = ii, ii = null), pi ? ii = "buffer" : ii || (ii = ei.defaultEncoding), typeof mi != "function" && (mi = si), ei.ending ? oi(this, mi) : (pi || ci(this, ei, wi, mi)) && (ei.pendingcb++, Zr = Ae(this, ei, pi, wi, ii, mi)), Zr;
  }, di.prototype.cork = function() {
    this._writableState.corked++;
  }, di.prototype.uncork = function() {
    var wi = this._writableState;
    wi.corked && (wi.corked--, !wi.writing && !wi.corked && !wi.bufferProcessing && wi.bufferedRequest && nr(this, wi));
  }, di.prototype.setDefaultEncoding = function(ii) {
    if (typeof ii == "string" && (ii = ii.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((ii + "").toLowerCase()) > -1))
      throw new Xr(ii);
    return this._writableState.defaultEncoding = ii, this;
  }, Object.defineProperty(di.prototype, "writableBuffer", {
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function vr(wi, ii, mi) {
    return !wi.objectMode && wi.decodeStrings !== !1 && typeof ii == "string" && (ii = $e.from(ii, mi)), ii;
  }
  Object.defineProperty(di.prototype, "writableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Ae(wi, ii, mi, ei, Zr, pi) {
    if (!mi) {
      var hi = vr(ii, ei, Zr);
      ei !== hi && (mi = !0, Zr = "buffer", ei = hi);
    }
    var Oi = ii.objectMode ? 1 : ei.length;
    ii.length += Oi;
    var qi = ii.length < ii.highWaterMark;
    if (qi || (ii.needDrain = !0), ii.writing || ii.corked) {
      var yn = ii.lastBufferedRequest;
      ii.lastBufferedRequest = {
        chunk: ei,
        encoding: Zr,
        isBuf: mi,
        callback: pi,
        next: null
      }, yn ? yn.next = ii.lastBufferedRequest : ii.bufferedRequest = ii.lastBufferedRequest, ii.bufferedRequestCount += 1;
    } else
      ze(wi, ii, !1, Oi, ei, Zr, pi);
    return qi;
  }
  function ze(wi, ii, mi, ei, Zr, pi, hi) {
    ii.writelen = ei, ii.writecb = hi, ii.writing = !0, ii.sync = !0, ii.destroyed ? ii.onwrite(new Nr("write")) : mi ? wi._writev(Zr, ii.onwrite) : wi._write(Zr, pi, ii.onwrite), ii.sync = !1;
  }
  function Ue(wi, ii, mi, ei, Zr) {
    --ii.pendingcb, mi ? (process$1.nextTick(Zr, ei), process$1.nextTick(Hr, wi, ii), wi._writableState.errorEmitted = !0, Wr(wi, ei)) : (Zr(ei), wi._writableState.errorEmitted = !0, Wr(wi, ei), Hr(wi, ii));
  }
  function tr(wi) {
    wi.writing = !1, wi.writecb = null, wi.length -= wi.writelen, wi.writelen = 0;
  }
  function lr(wi, ii) {
    var mi = wi._writableState, ei = mi.sync, Zr = mi.writecb;
    if (typeof Zr != "function")
      throw new Ar();
    if (tr(mi), ii)
      Ue(wi, mi, ei, ii, Zr);
    else {
      var pi = Pe(mi) || wi.destroyed;
      !pi && !mi.corked && !mi.bufferProcessing && mi.bufferedRequest && nr(wi, mi), ei ? process$1.nextTick(pr, wi, mi, pi, Zr) : pr(wi, mi, pi, Zr);
    }
  }
  function pr(wi, ii, mi, ei) {
    mi || br(wi, ii), ii.pendingcb--, ei(), Hr(wi, ii);
  }
  function br(wi, ii) {
    ii.length === 0 && ii.needDrain && (ii.needDrain = !1, wi.emit("drain"));
  }
  function nr(wi, ii) {
    ii.bufferProcessing = !0;
    var mi = ii.bufferedRequest;
    if (wi._writev && mi && mi.next) {
      var ei = ii.bufferedRequestCount, Zr = new Array(ei), pi = ii.corkedRequestsFree;
      pi.entry = mi;
      for (var hi = 0, Oi = !0; mi; )
        Zr[hi] = mi, mi.isBuf || (Oi = !1), mi = mi.next, hi += 1;
      Zr.allBuffers = Oi, ze(wi, ii, !0, ii.length, Zr, "", pi.finish), ii.pendingcb++, ii.lastBufferedRequest = null, pi.next ? (ii.corkedRequestsFree = pi.next, pi.next = null) : ii.corkedRequestsFree = new m(ii), ii.bufferedRequestCount = 0;
    } else {
      for (; mi; ) {
        var qi = mi.chunk, yn = mi.encoding, sn = mi.callback, $n = ii.objectMode ? 1 : qi.length;
        if (ze(wi, ii, !1, $n, qi, yn, sn), mi = mi.next, ii.bufferedRequestCount--, ii.writing)
          break;
      }
      mi === null && (ii.lastBufferedRequest = null);
    }
    ii.bufferedRequest = mi, ii.bufferProcessing = !1;
  }
  di.prototype._write = function(wi, ii, mi) {
    mi(new Ir("_write()"));
  }, di.prototype._writev = null, di.prototype.end = function(wi, ii, mi) {
    var ei = this._writableState;
    return typeof wi == "function" ? (mi = wi, wi = null, ii = null) : typeof ii == "function" && (mi = ii, ii = null), wi != null && this.write(wi, ii), ei.corked && (ei.corked = 1, this.uncork()), ei.ending || vi(this, ei, mi), this;
  }, Object.defineProperty(di.prototype, "writableLength", {
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function Pe(wi) {
    return wi.ending && wi.length === 0 && wi.bufferedRequest === null && !wi.finished && !wi.writing;
  }
  function ur(wi, ii) {
    wi._final(function(mi) {
      ii.pendingcb--, mi && Wr(wi, mi), ii.prefinished = !0, wi.emit("prefinish"), Hr(wi, ii);
    });
  }
  function Pr(wi, ii) {
    !ii.prefinished && !ii.finalCalled && (typeof wi._final == "function" && !ii.destroyed ? (ii.pendingcb++, ii.finalCalled = !0, process$1.nextTick(ur, wi, ii)) : (ii.prefinished = !0, wi.emit("prefinish")));
  }
  function Hr(wi, ii) {
    var mi = Pe(ii);
    if (mi && (Pr(wi, ii), ii.pendingcb === 0 && (ii.finished = !0, wi.emit("finish"), ii.autoDestroy))) {
      var ei = wi._readableState;
      (!ei || ei.autoDestroy && ei.endEmitted) && wi.destroy();
    }
    return mi;
  }
  function vi(wi, ii, mi) {
    ii.ending = !0, Hr(wi, ii), mi && (ii.finished ? process$1.nextTick(mi) : wi.once("finish", mi)), ii.ended = !0, wi.writable = !1;
  }
  function Ti(wi, ii, mi) {
    var ei = wi.entry;
    for (wi.entry = null; ei; ) {
      var Zr = ei.callback;
      ii.pendingcb--, Zr(mi), ei = ei.next;
    }
    ii.corkedRequestsFree.next = wi;
  }
  return Object.defineProperty(di.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(ii) {
      !this._writableState || (this._writableState.destroyed = ii);
    }
  }), di.prototype.destroy = rr.destroy, di.prototype._undestroy = rr.undestroy, di.prototype._destroy = function(wi, ii) {
    ii(wi);
  }, _stream_writable$1;
}
var _stream_duplex$1, hasRequired_stream_duplex$1;
function require_stream_duplex$1() {
  if (hasRequired_stream_duplex$1)
    return _stream_duplex$1;
  hasRequired_stream_duplex$1 = 1;
  var m = Object.keys || function(gr) {
    var or = [];
    for (var _r in gr)
      or.push(_r);
    return or;
  };
  _stream_duplex$1 = Ze;
  var c = require_stream_readable$1(), ie = require_stream_writable$1();
  inherits_browser.exports(Ze, c);
  for (var we = m(ie.prototype), $e = 0; $e < we.length; $e++) {
    var Me = we[$e];
    Ze.prototype[Me] || (Ze.prototype[Me] = ie.prototype[Me]);
  }
  function Ze(gr) {
    if (!(this instanceof Ze))
      return new Ze(gr);
    c.call(this, gr), ie.call(this, gr), this.allowHalfOpen = !0, gr && (gr.readable === !1 && (this.readable = !1), gr.writable === !1 && (this.writable = !1), gr.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", ne)));
  }
  Object.defineProperty(Ze.prototype, "writableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(Ze.prototype, "writableBuffer", {
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(Ze.prototype, "writableLength", {
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function ne() {
    this._writableState.ended || process$1.nextTick(rr, this);
  }
  function rr(gr) {
    gr.end();
  }
  return Object.defineProperty(Ze.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(or) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = or, this._writableState.destroyed = or);
    }
  }), _stream_duplex$1;
}
var string_decoder = {}, Buffer$A = safeBuffer$2.exports.Buffer, isEncoding = Buffer$A.isEncoding || function(m) {
  switch (m = "" + m, m && m.toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
    case "raw":
      return !0;
    default:
      return !1;
  }
};
function _normalizeEncoding(m) {
  if (!m)
    return "utf8";
  for (var c; ; )
    switch (m) {
      case "utf8":
      case "utf-8":
        return "utf8";
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return "utf16le";
      case "latin1":
      case "binary":
        return "latin1";
      case "base64":
      case "ascii":
      case "hex":
        return m;
      default:
        if (c)
          return;
        m = ("" + m).toLowerCase(), c = !0;
    }
}
function normalizeEncoding(m) {
  var c = _normalizeEncoding(m);
  if (typeof c != "string" && (Buffer$A.isEncoding === isEncoding || !isEncoding(m)))
    throw new Error("Unknown encoding: " + m);
  return c || m;
}
string_decoder.StringDecoder = StringDecoder$1;
function StringDecoder$1(m) {
  this.encoding = normalizeEncoding(m);
  var c;
  switch (this.encoding) {
    case "utf16le":
      this.text = utf16Text, this.end = utf16End, c = 4;
      break;
    case "utf8":
      this.fillLast = utf8FillLast, c = 4;
      break;
    case "base64":
      this.text = base64Text, this.end = base64End, c = 3;
      break;
    default:
      this.write = simpleWrite, this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0, this.lastTotal = 0, this.lastChar = Buffer$A.allocUnsafe(c);
}
StringDecoder$1.prototype.write = function(m) {
  if (m.length === 0)
    return "";
  var c, ie;
  if (this.lastNeed) {
    if (c = this.fillLast(m), c === void 0)
      return "";
    ie = this.lastNeed, this.lastNeed = 0;
  } else
    ie = 0;
  return ie < m.length ? c ? c + this.text(m, ie) : this.text(m, ie) : c || "";
};
StringDecoder$1.prototype.end = utf8End;
StringDecoder$1.prototype.text = utf8Text;
StringDecoder$1.prototype.fillLast = function(m) {
  if (this.lastNeed <= m.length)
    return m.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  m.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, m.length), this.lastNeed -= m.length;
};
function utf8CheckByte(m) {
  return m <= 127 ? 0 : m >> 5 === 6 ? 2 : m >> 4 === 14 ? 3 : m >> 3 === 30 ? 4 : m >> 6 === 2 ? -1 : -2;
}
function utf8CheckIncomplete(m, c, ie) {
  var we = c.length - 1;
  if (we < ie)
    return 0;
  var $e = utf8CheckByte(c[we]);
  return $e >= 0 ? ($e > 0 && (m.lastNeed = $e - 1), $e) : --we < ie || $e === -2 ? 0 : ($e = utf8CheckByte(c[we]), $e >= 0 ? ($e > 0 && (m.lastNeed = $e - 2), $e) : --we < ie || $e === -2 ? 0 : ($e = utf8CheckByte(c[we]), $e >= 0 ? ($e > 0 && ($e === 2 ? $e = 0 : m.lastNeed = $e - 3), $e) : 0));
}
function utf8CheckExtraBytes(m, c, ie) {
  if ((c[0] & 192) !== 128)
    return m.lastNeed = 0, "\uFFFD";
  if (m.lastNeed > 1 && c.length > 1) {
    if ((c[1] & 192) !== 128)
      return m.lastNeed = 1, "\uFFFD";
    if (m.lastNeed > 2 && c.length > 2 && (c[2] & 192) !== 128)
      return m.lastNeed = 2, "\uFFFD";
  }
}
function utf8FillLast(m) {
  var c = this.lastTotal - this.lastNeed, ie = utf8CheckExtraBytes(this, m);
  if (ie !== void 0)
    return ie;
  if (this.lastNeed <= m.length)
    return m.copy(this.lastChar, c, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  m.copy(this.lastChar, c, 0, m.length), this.lastNeed -= m.length;
}
function utf8Text(m, c) {
  var ie = utf8CheckIncomplete(this, m, c);
  if (!this.lastNeed)
    return m.toString("utf8", c);
  this.lastTotal = ie;
  var we = m.length - (ie - this.lastNeed);
  return m.copy(this.lastChar, 0, we), m.toString("utf8", c, we);
}
function utf8End(m) {
  var c = m && m.length ? this.write(m) : "";
  return this.lastNeed ? c + "\uFFFD" : c;
}
function utf16Text(m, c) {
  if ((m.length - c) % 2 === 0) {
    var ie = m.toString("utf16le", c);
    if (ie) {
      var we = ie.charCodeAt(ie.length - 1);
      if (we >= 55296 && we <= 56319)
        return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = m[m.length - 2], this.lastChar[1] = m[m.length - 1], ie.slice(0, -1);
    }
    return ie;
  }
  return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = m[m.length - 1], m.toString("utf16le", c, m.length - 1);
}
function utf16End(m) {
  var c = m && m.length ? this.write(m) : "";
  if (this.lastNeed) {
    var ie = this.lastTotal - this.lastNeed;
    return c + this.lastChar.toString("utf16le", 0, ie);
  }
  return c;
}
function base64Text(m, c) {
  var ie = (m.length - c) % 3;
  return ie === 0 ? m.toString("base64", c) : (this.lastNeed = 3 - ie, this.lastTotal = 3, ie === 1 ? this.lastChar[0] = m[m.length - 1] : (this.lastChar[0] = m[m.length - 2], this.lastChar[1] = m[m.length - 1]), m.toString("base64", c, m.length - ie));
}
function base64End(m) {
  var c = m && m.length ? this.write(m) : "";
  return this.lastNeed ? c + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : c;
}
function simpleWrite(m) {
  return m.toString(this.encoding);
}
function simpleEnd(m) {
  return m && m.length ? this.write(m) : "";
}
var endOfStream, hasRequiredEndOfStream;
function requireEndOfStream() {
  if (hasRequiredEndOfStream)
    return endOfStream;
  hasRequiredEndOfStream = 1;
  var m = requireErrorsBrowser().codes.ERR_STREAM_PREMATURE_CLOSE;
  function c(Me) {
    var Ze = !1;
    return function() {
      if (!Ze) {
        Ze = !0;
        for (var ne = arguments.length, rr = new Array(ne), gr = 0; gr < ne; gr++)
          rr[gr] = arguments[gr];
        Me.apply(this, rr);
      }
    };
  }
  function ie() {
  }
  function we(Me) {
    return Me.setHeader && typeof Me.abort == "function";
  }
  function $e(Me, Ze, ne) {
    if (typeof Ze == "function")
      return $e(Me, null, Ze);
    Ze || (Ze = {}), ne = c(ne || ie);
    var rr = Ze.readable || Ze.readable !== !1 && Me.readable, gr = Ze.writable || Ze.writable !== !1 && Me.writable, or = function() {
      Me.writable || Lr();
    }, _r = Me._writableState && Me._writableState.finished, Lr = function() {
      gr = !1, _r = !0, rr || ne.call(Me);
    }, Ir = Me._readableState && Me._readableState.endEmitted, Ar = function() {
      rr = !1, Ir = !0, gr || ne.call(Me);
    }, Rr = function(Xr) {
      ne.call(Me, Xr);
    }, Nr = function() {
      var Xr;
      if (rr && !Ir)
        return (!Me._readableState || !Me._readableState.ended) && (Xr = new m()), ne.call(Me, Xr);
      if (gr && !_r)
        return (!Me._writableState || !Me._writableState.ended) && (Xr = new m()), ne.call(Me, Xr);
    }, Yr = function() {
      Me.req.on("finish", Lr);
    };
    return we(Me) ? (Me.on("complete", Lr), Me.on("abort", Nr), Me.req ? Yr() : Me.on("request", Yr)) : gr && !Me._writableState && (Me.on("end", or), Me.on("close", or)), Me.on("end", Ar), Me.on("finish", Lr), Ze.error !== !1 && Me.on("error", Rr), Me.on("close", Nr), function() {
      Me.removeListener("complete", Lr), Me.removeListener("abort", Nr), Me.removeListener("request", Yr), Me.req && Me.req.removeListener("finish", Lr), Me.removeListener("end", or), Me.removeListener("close", or), Me.removeListener("finish", Lr), Me.removeListener("end", Ar), Me.removeListener("error", Rr), Me.removeListener("close", Nr);
    };
  }
  return endOfStream = $e, endOfStream;
}
var async_iterator, hasRequiredAsync_iterator;
function requireAsync_iterator() {
  if (hasRequiredAsync_iterator)
    return async_iterator;
  hasRequiredAsync_iterator = 1;
  var m;
  function c(Xr, Wr, si) {
    return Wr = ie(Wr), Wr in Xr ? Object.defineProperty(Xr, Wr, { value: si, enumerable: !0, configurable: !0, writable: !0 }) : Xr[Wr] = si, Xr;
  }
  function ie(Xr) {
    var Wr = we(Xr, "string");
    return typeof Wr == "symbol" ? Wr : String(Wr);
  }
  function we(Xr, Wr) {
    if (typeof Xr != "object" || Xr === null)
      return Xr;
    var si = Xr[Symbol.toPrimitive];
    if (si !== void 0) {
      var li = si.call(Xr, Wr || "default");
      if (typeof li != "object")
        return li;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Wr === "string" ? String : Number)(Xr);
  }
  var $e = requireEndOfStream(), Me = Symbol("lastResolve"), Ze = Symbol("lastReject"), ne = Symbol("error"), rr = Symbol("ended"), gr = Symbol("lastPromise"), or = Symbol("handlePromise"), _r = Symbol("stream");
  function Lr(Xr, Wr) {
    return {
      value: Xr,
      done: Wr
    };
  }
  function Ir(Xr) {
    var Wr = Xr[Me];
    if (Wr !== null) {
      var si = Xr[_r].read();
      si !== null && (Xr[gr] = null, Xr[Me] = null, Xr[Ze] = null, Wr(Lr(si, !1)));
    }
  }
  function Ar(Xr) {
    process$1.nextTick(Ir, Xr);
  }
  function Rr(Xr, Wr) {
    return function(si, li) {
      Xr.then(function() {
        if (Wr[rr]) {
          si(Lr(void 0, !0));
          return;
        }
        Wr[or](si, li);
      }, li);
    };
  }
  var Nr = Object.getPrototypeOf(function() {
  }), Yr = Object.setPrototypeOf((m = {
    get stream() {
      return this[_r];
    },
    next: function() {
      var Wr = this, si = this[ne];
      if (si !== null)
        return Promise.reject(si);
      if (this[rr])
        return Promise.resolve(Lr(void 0, !0));
      if (this[_r].destroyed)
        return new Promise(function(oi, ci) {
          process$1.nextTick(function() {
            Wr[ne] ? ci(Wr[ne]) : oi(Lr(void 0, !0));
          });
        });
      var li = this[gr], xi;
      if (li)
        xi = new Promise(Rr(li, this));
      else {
        var di = this[_r].read();
        if (di !== null)
          return Promise.resolve(Lr(di, !1));
        xi = new Promise(this[or]);
      }
      return this[gr] = xi, xi;
    }
  }, c(m, Symbol.asyncIterator, function() {
    return this;
  }), c(m, "return", function() {
    var Wr = this;
    return new Promise(function(si, li) {
      Wr[_r].destroy(null, function(xi) {
        if (xi) {
          li(xi);
          return;
        }
        si(Lr(void 0, !0));
      });
    });
  }), m), Nr), Vr = function(Wr) {
    var si, li = Object.create(Yr, (si = {}, c(si, _r, {
      value: Wr,
      writable: !0
    }), c(si, Me, {
      value: null,
      writable: !0
    }), c(si, Ze, {
      value: null,
      writable: !0
    }), c(si, ne, {
      value: null,
      writable: !0
    }), c(si, rr, {
      value: Wr._readableState.endEmitted,
      writable: !0
    }), c(si, or, {
      value: function(di, oi) {
        var ci = li[_r].read();
        ci ? (li[gr] = null, li[Me] = null, li[Ze] = null, di(Lr(ci, !1))) : (li[Me] = di, li[Ze] = oi);
      },
      writable: !0
    }), si));
    return li[gr] = null, $e(Wr, function(xi) {
      if (xi && xi.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var di = li[Ze];
        di !== null && (li[gr] = null, li[Me] = null, li[Ze] = null, di(xi)), li[ne] = xi;
        return;
      }
      var oi = li[Me];
      oi !== null && (li[gr] = null, li[Me] = null, li[Ze] = null, oi(Lr(void 0, !0))), li[rr] = !0;
    }), Wr.on("readable", Ar.bind(null, li)), li;
  };
  return async_iterator = Vr, async_iterator;
}
var fromBrowser, hasRequiredFromBrowser;
function requireFromBrowser() {
  return hasRequiredFromBrowser || (hasRequiredFromBrowser = 1, fromBrowser = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fromBrowser;
}
var _stream_readable$1, hasRequired_stream_readable$1;
function require_stream_readable$1() {
  if (hasRequired_stream_readable$1)
    return _stream_readable$1;
  hasRequired_stream_readable$1 = 1, _stream_readable$1 = oi;
  var m;
  oi.ReadableState = di, events$2.exports.EventEmitter;
  var c = function(hi, Oi) {
    return hi.listeners(Oi).length;
  }, ie = requireStreamBrowser(), we = require$$0$4.Buffer, $e = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function Me(pi) {
    return we.from(pi);
  }
  function Ze(pi) {
    return we.isBuffer(pi) || pi instanceof $e;
  }
  var ne = util$4, rr;
  ne && ne.debuglog ? rr = ne.debuglog("stream") : rr = function() {
  };
  var gr = requireBuffer_list(), or = requireDestroy(), _r = requireState(), Lr = _r.getHighWaterMark, Ir = requireErrorsBrowser().codes, Ar = Ir.ERR_INVALID_ARG_TYPE, Rr = Ir.ERR_STREAM_PUSH_AFTER_EOF, Nr = Ir.ERR_METHOD_NOT_IMPLEMENTED, Yr = Ir.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, Vr, Xr, Wr;
  inherits_browser.exports(oi, ie);
  var si = or.errorOrDestroy, li = ["error", "close", "destroy", "pause", "resume"];
  function xi(pi, hi, Oi) {
    if (typeof pi.prependListener == "function")
      return pi.prependListener(hi, Oi);
    !pi._events || !pi._events[hi] ? pi.on(hi, Oi) : Array.isArray(pi._events[hi]) ? pi._events[hi].unshift(Oi) : pi._events[hi] = [Oi, pi._events[hi]];
  }
  function di(pi, hi, Oi) {
    m = m || require_stream_duplex$1(), pi = pi || {}, typeof Oi != "boolean" && (Oi = hi instanceof m), this.objectMode = !!pi.objectMode, Oi && (this.objectMode = this.objectMode || !!pi.readableObjectMode), this.highWaterMark = Lr(this, pi, "readableHighWaterMark", Oi), this.buffer = new gr(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = pi.emitClose !== !1, this.autoDestroy = !!pi.autoDestroy, this.destroyed = !1, this.defaultEncoding = pi.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, pi.encoding && (Vr || (Vr = string_decoder.StringDecoder), this.decoder = new Vr(pi.encoding), this.encoding = pi.encoding);
  }
  function oi(pi) {
    if (m = m || require_stream_duplex$1(), !(this instanceof oi))
      return new oi(pi);
    var hi = this instanceof m;
    this._readableState = new di(pi, this, hi), this.readable = !0, pi && (typeof pi.read == "function" && (this._read = pi.read), typeof pi.destroy == "function" && (this._destroy = pi.destroy)), ie.call(this);
  }
  Object.defineProperty(oi.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(hi) {
      !this._readableState || (this._readableState.destroyed = hi);
    }
  }), oi.prototype.destroy = or.destroy, oi.prototype._undestroy = or.undestroy, oi.prototype._destroy = function(pi, hi) {
    hi(pi);
  }, oi.prototype.push = function(pi, hi) {
    var Oi = this._readableState, qi;
    return Oi.objectMode ? qi = !0 : typeof pi == "string" && (hi = hi || Oi.defaultEncoding, hi !== Oi.encoding && (pi = we.from(pi, hi), hi = ""), qi = !0), ci(this, pi, hi, !1, qi);
  }, oi.prototype.unshift = function(pi) {
    return ci(this, pi, null, !0, !1);
  };
  function ci(pi, hi, Oi, qi, yn) {
    rr("readableAddChunk", hi);
    var sn = pi._readableState;
    if (hi === null)
      sn.reading = !1, lr(pi, sn);
    else {
      var $n;
      if (yn || ($n = Ae(sn, hi)), $n)
        si(pi, $n);
      else if (sn.objectMode || hi && hi.length > 0)
        if (typeof hi != "string" && !sn.objectMode && Object.getPrototypeOf(hi) !== we.prototype && (hi = Me(hi)), qi)
          sn.endEmitted ? si(pi, new Yr()) : vr(pi, sn, hi, !0);
        else if (sn.ended)
          si(pi, new Rr());
        else {
          if (sn.destroyed)
            return !1;
          sn.reading = !1, sn.decoder && !Oi ? (hi = sn.decoder.write(hi), sn.objectMode || hi.length !== 0 ? vr(pi, sn, hi, !1) : nr(pi, sn)) : vr(pi, sn, hi, !1);
        }
      else
        qi || (sn.reading = !1, nr(pi, sn));
    }
    return !sn.ended && (sn.length < sn.highWaterMark || sn.length === 0);
  }
  function vr(pi, hi, Oi, qi) {
    hi.flowing && hi.length === 0 && !hi.sync ? (hi.awaitDrain = 0, pi.emit("data", Oi)) : (hi.length += hi.objectMode ? 1 : Oi.length, qi ? hi.buffer.unshift(Oi) : hi.buffer.push(Oi), hi.needReadable && pr(pi)), nr(pi, hi);
  }
  function Ae(pi, hi) {
    var Oi;
    return !Ze(hi) && typeof hi != "string" && hi !== void 0 && !pi.objectMode && (Oi = new Ar("chunk", ["string", "Buffer", "Uint8Array"], hi)), Oi;
  }
  oi.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, oi.prototype.setEncoding = function(pi) {
    Vr || (Vr = string_decoder.StringDecoder);
    var hi = new Vr(pi);
    this._readableState.decoder = hi, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var Oi = this._readableState.buffer.head, qi = ""; Oi !== null; )
      qi += hi.write(Oi.data), Oi = Oi.next;
    return this._readableState.buffer.clear(), qi !== "" && this._readableState.buffer.push(qi), this._readableState.length = qi.length, this;
  };
  var ze = 1073741824;
  function Ue(pi) {
    return pi >= ze ? pi = ze : (pi--, pi |= pi >>> 1, pi |= pi >>> 2, pi |= pi >>> 4, pi |= pi >>> 8, pi |= pi >>> 16, pi++), pi;
  }
  function tr(pi, hi) {
    return pi <= 0 || hi.length === 0 && hi.ended ? 0 : hi.objectMode ? 1 : pi !== pi ? hi.flowing && hi.length ? hi.buffer.head.data.length : hi.length : (pi > hi.highWaterMark && (hi.highWaterMark = Ue(pi)), pi <= hi.length ? pi : hi.ended ? hi.length : (hi.needReadable = !0, 0));
  }
  oi.prototype.read = function(pi) {
    rr("read", pi), pi = parseInt(pi, 10);
    var hi = this._readableState, Oi = pi;
    if (pi !== 0 && (hi.emittedReadable = !1), pi === 0 && hi.needReadable && ((hi.highWaterMark !== 0 ? hi.length >= hi.highWaterMark : hi.length > 0) || hi.ended))
      return rr("read: emitReadable", hi.length, hi.ended), hi.length === 0 && hi.ended ? mi(this) : pr(this), null;
    if (pi = tr(pi, hi), pi === 0 && hi.ended)
      return hi.length === 0 && mi(this), null;
    var qi = hi.needReadable;
    rr("need readable", qi), (hi.length === 0 || hi.length - pi < hi.highWaterMark) && (qi = !0, rr("length less than watermark", qi)), hi.ended || hi.reading ? (qi = !1, rr("reading or ended", qi)) : qi && (rr("do read"), hi.reading = !0, hi.sync = !0, hi.length === 0 && (hi.needReadable = !0), this._read(hi.highWaterMark), hi.sync = !1, hi.reading || (pi = tr(Oi, hi)));
    var yn;
    return pi > 0 ? yn = ii(pi, hi) : yn = null, yn === null ? (hi.needReadable = hi.length <= hi.highWaterMark, pi = 0) : (hi.length -= pi, hi.awaitDrain = 0), hi.length === 0 && (hi.ended || (hi.needReadable = !0), Oi !== pi && hi.ended && mi(this)), yn !== null && this.emit("data", yn), yn;
  };
  function lr(pi, hi) {
    if (rr("onEofChunk"), !hi.ended) {
      if (hi.decoder) {
        var Oi = hi.decoder.end();
        Oi && Oi.length && (hi.buffer.push(Oi), hi.length += hi.objectMode ? 1 : Oi.length);
      }
      hi.ended = !0, hi.sync ? pr(pi) : (hi.needReadable = !1, hi.emittedReadable || (hi.emittedReadable = !0, br(pi)));
    }
  }
  function pr(pi) {
    var hi = pi._readableState;
    rr("emitReadable", hi.needReadable, hi.emittedReadable), hi.needReadable = !1, hi.emittedReadable || (rr("emitReadable", hi.flowing), hi.emittedReadable = !0, process$1.nextTick(br, pi));
  }
  function br(pi) {
    var hi = pi._readableState;
    rr("emitReadable_", hi.destroyed, hi.length, hi.ended), !hi.destroyed && (hi.length || hi.ended) && (pi.emit("readable"), hi.emittedReadable = !1), hi.needReadable = !hi.flowing && !hi.ended && hi.length <= hi.highWaterMark, wi(pi);
  }
  function nr(pi, hi) {
    hi.readingMore || (hi.readingMore = !0, process$1.nextTick(Pe, pi, hi));
  }
  function Pe(pi, hi) {
    for (; !hi.reading && !hi.ended && (hi.length < hi.highWaterMark || hi.flowing && hi.length === 0); ) {
      var Oi = hi.length;
      if (rr("maybeReadMore read 0"), pi.read(0), Oi === hi.length)
        break;
    }
    hi.readingMore = !1;
  }
  oi.prototype._read = function(pi) {
    si(this, new Nr("_read()"));
  }, oi.prototype.pipe = function(pi, hi) {
    var Oi = this, qi = this._readableState;
    switch (qi.pipesCount) {
      case 0:
        qi.pipes = pi;
        break;
      case 1:
        qi.pipes = [qi.pipes, pi];
        break;
      default:
        qi.pipes.push(pi);
        break;
    }
    qi.pipesCount += 1, rr("pipe count=%d opts=%j", qi.pipesCount, hi);
    var yn = (!hi || hi.end !== !1) && pi !== process$1.stdout && pi !== process$1.stderr, sn = yn ? rn : Xo;
    qi.endEmitted ? process$1.nextTick(sn) : Oi.once("end", sn), pi.on("unpipe", $n);
    function $n(Xn, Yn) {
      rr("onunpipe"), Xn === Oi && Yn && Yn.hasUnpiped === !1 && (Yn.hasUnpiped = !0, In());
    }
    function rn() {
      rr("onend"), pi.end();
    }
    var ji = ur(Oi);
    pi.on("drain", ji);
    var Kn = !1;
    function In() {
      rr("cleanup"), pi.removeListener("close", vn), pi.removeListener("finish", Vn), pi.removeListener("drain", ji), pi.removeListener("error", Po), pi.removeListener("unpipe", $n), Oi.removeListener("end", rn), Oi.removeListener("end", Xo), Oi.removeListener("data", Fn), Kn = !0, qi.awaitDrain && (!pi._writableState || pi._writableState.needDrain) && ji();
    }
    Oi.on("data", Fn);
    function Fn(Xn) {
      rr("ondata");
      var Yn = pi.write(Xn);
      rr("dest.write", Yn), Yn === !1 && ((qi.pipesCount === 1 && qi.pipes === pi || qi.pipesCount > 1 && Zr(qi.pipes, pi) !== -1) && !Kn && (rr("false write response, pause", qi.awaitDrain), qi.awaitDrain++), Oi.pause());
    }
    function Po(Xn) {
      rr("onerror", Xn), Xo(), pi.removeListener("error", Po), c(pi, "error") === 0 && si(pi, Xn);
    }
    xi(pi, "error", Po);
    function vn() {
      pi.removeListener("finish", Vn), Xo();
    }
    pi.once("close", vn);
    function Vn() {
      rr("onfinish"), pi.removeListener("close", vn), Xo();
    }
    pi.once("finish", Vn);
    function Xo() {
      rr("unpipe"), Oi.unpipe(pi);
    }
    return pi.emit("pipe", Oi), qi.flowing || (rr("pipe resume"), Oi.resume()), pi;
  };
  function ur(pi) {
    return function() {
      var Oi = pi._readableState;
      rr("pipeOnDrain", Oi.awaitDrain), Oi.awaitDrain && Oi.awaitDrain--, Oi.awaitDrain === 0 && c(pi, "data") && (Oi.flowing = !0, wi(pi));
    };
  }
  oi.prototype.unpipe = function(pi) {
    var hi = this._readableState, Oi = {
      hasUnpiped: !1
    };
    if (hi.pipesCount === 0)
      return this;
    if (hi.pipesCount === 1)
      return pi && pi !== hi.pipes ? this : (pi || (pi = hi.pipes), hi.pipes = null, hi.pipesCount = 0, hi.flowing = !1, pi && pi.emit("unpipe", this, Oi), this);
    if (!pi) {
      var qi = hi.pipes, yn = hi.pipesCount;
      hi.pipes = null, hi.pipesCount = 0, hi.flowing = !1;
      for (var sn = 0; sn < yn; sn++)
        qi[sn].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var $n = Zr(hi.pipes, pi);
    return $n === -1 ? this : (hi.pipes.splice($n, 1), hi.pipesCount -= 1, hi.pipesCount === 1 && (hi.pipes = hi.pipes[0]), pi.emit("unpipe", this, Oi), this);
  }, oi.prototype.on = function(pi, hi) {
    var Oi = ie.prototype.on.call(this, pi, hi), qi = this._readableState;
    return pi === "data" ? (qi.readableListening = this.listenerCount("readable") > 0, qi.flowing !== !1 && this.resume()) : pi === "readable" && !qi.endEmitted && !qi.readableListening && (qi.readableListening = qi.needReadable = !0, qi.flowing = !1, qi.emittedReadable = !1, rr("on readable", qi.length, qi.reading), qi.length ? pr(this) : qi.reading || process$1.nextTick(Hr, this)), Oi;
  }, oi.prototype.addListener = oi.prototype.on, oi.prototype.removeListener = function(pi, hi) {
    var Oi = ie.prototype.removeListener.call(this, pi, hi);
    return pi === "readable" && process$1.nextTick(Pr, this), Oi;
  }, oi.prototype.removeAllListeners = function(pi) {
    var hi = ie.prototype.removeAllListeners.apply(this, arguments);
    return (pi === "readable" || pi === void 0) && process$1.nextTick(Pr, this), hi;
  };
  function Pr(pi) {
    var hi = pi._readableState;
    hi.readableListening = pi.listenerCount("readable") > 0, hi.resumeScheduled && !hi.paused ? hi.flowing = !0 : pi.listenerCount("data") > 0 && pi.resume();
  }
  function Hr(pi) {
    rr("readable nexttick read 0"), pi.read(0);
  }
  oi.prototype.resume = function() {
    var pi = this._readableState;
    return pi.flowing || (rr("resume"), pi.flowing = !pi.readableListening, vi(this, pi)), pi.paused = !1, this;
  };
  function vi(pi, hi) {
    hi.resumeScheduled || (hi.resumeScheduled = !0, process$1.nextTick(Ti, pi, hi));
  }
  function Ti(pi, hi) {
    rr("resume", hi.reading), hi.reading || pi.read(0), hi.resumeScheduled = !1, pi.emit("resume"), wi(pi), hi.flowing && !hi.reading && pi.read(0);
  }
  oi.prototype.pause = function() {
    return rr("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (rr("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function wi(pi) {
    var hi = pi._readableState;
    for (rr("flow", hi.flowing); hi.flowing && pi.read() !== null; )
      ;
  }
  oi.prototype.wrap = function(pi) {
    var hi = this, Oi = this._readableState, qi = !1;
    pi.on("end", function() {
      if (rr("wrapped end"), Oi.decoder && !Oi.ended) {
        var $n = Oi.decoder.end();
        $n && $n.length && hi.push($n);
      }
      hi.push(null);
    }), pi.on("data", function($n) {
      if (rr("wrapped data"), Oi.decoder && ($n = Oi.decoder.write($n)), !(Oi.objectMode && $n == null) && !(!Oi.objectMode && (!$n || !$n.length))) {
        var rn = hi.push($n);
        rn || (qi = !0, pi.pause());
      }
    });
    for (var yn in pi)
      this[yn] === void 0 && typeof pi[yn] == "function" && (this[yn] = function(rn) {
        return function() {
          return pi[rn].apply(pi, arguments);
        };
      }(yn));
    for (var sn = 0; sn < li.length; sn++)
      pi.on(li[sn], this.emit.bind(this, li[sn]));
    return this._read = function($n) {
      rr("wrapped _read", $n), qi && (qi = !1, pi.resume());
    }, this;
  }, typeof Symbol == "function" && (oi.prototype[Symbol.asyncIterator] = function() {
    return Xr === void 0 && (Xr = requireAsync_iterator()), Xr(this);
  }), Object.defineProperty(oi.prototype, "readableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(oi.prototype, "readableBuffer", {
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(oi.prototype, "readableFlowing", {
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(hi) {
      this._readableState && (this._readableState.flowing = hi);
    }
  }), oi._fromList = ii, Object.defineProperty(oi.prototype, "readableLength", {
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function ii(pi, hi) {
    if (hi.length === 0)
      return null;
    var Oi;
    return hi.objectMode ? Oi = hi.buffer.shift() : !pi || pi >= hi.length ? (hi.decoder ? Oi = hi.buffer.join("") : hi.buffer.length === 1 ? Oi = hi.buffer.first() : Oi = hi.buffer.concat(hi.length), hi.buffer.clear()) : Oi = hi.buffer.consume(pi, hi.decoder), Oi;
  }
  function mi(pi) {
    var hi = pi._readableState;
    rr("endReadable", hi.endEmitted), hi.endEmitted || (hi.ended = !0, process$1.nextTick(ei, hi, pi));
  }
  function ei(pi, hi) {
    if (rr("endReadableNT", pi.endEmitted, pi.length), !pi.endEmitted && pi.length === 0 && (pi.endEmitted = !0, hi.readable = !1, hi.emit("end"), pi.autoDestroy)) {
      var Oi = hi._writableState;
      (!Oi || Oi.autoDestroy && Oi.finished) && hi.destroy();
    }
  }
  typeof Symbol == "function" && (oi.from = function(pi, hi) {
    return Wr === void 0 && (Wr = requireFromBrowser()), Wr(oi, pi, hi);
  });
  function Zr(pi, hi) {
    for (var Oi = 0, qi = pi.length; Oi < qi; Oi++)
      if (pi[Oi] === hi)
        return Oi;
    return -1;
  }
  return _stream_readable$1;
}
var _stream_transform$1, hasRequired_stream_transform;
function require_stream_transform() {
  if (hasRequired_stream_transform)
    return _stream_transform$1;
  hasRequired_stream_transform = 1, _stream_transform$1 = ne;
  var m = requireErrorsBrowser().codes, c = m.ERR_METHOD_NOT_IMPLEMENTED, ie = m.ERR_MULTIPLE_CALLBACK, we = m.ERR_TRANSFORM_ALREADY_TRANSFORMING, $e = m.ERR_TRANSFORM_WITH_LENGTH_0, Me = require_stream_duplex$1();
  inherits_browser.exports(ne, Me);
  function Ze(or, _r) {
    var Lr = this._transformState;
    Lr.transforming = !1;
    var Ir = Lr.writecb;
    if (Ir === null)
      return this.emit("error", new ie());
    Lr.writechunk = null, Lr.writecb = null, _r != null && this.push(_r), Ir(or);
    var Ar = this._readableState;
    Ar.reading = !1, (Ar.needReadable || Ar.length < Ar.highWaterMark) && this._read(Ar.highWaterMark);
  }
  function ne(or) {
    if (!(this instanceof ne))
      return new ne(or);
    Me.call(this, or), this._transformState = {
      afterTransform: Ze.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, or && (typeof or.transform == "function" && (this._transform = or.transform), typeof or.flush == "function" && (this._flush = or.flush)), this.on("prefinish", rr);
  }
  function rr() {
    var or = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(_r, Lr) {
      gr(or, _r, Lr);
    }) : gr(this, null, null);
  }
  ne.prototype.push = function(or, _r) {
    return this._transformState.needTransform = !1, Me.prototype.push.call(this, or, _r);
  }, ne.prototype._transform = function(or, _r, Lr) {
    Lr(new c("_transform()"));
  }, ne.prototype._write = function(or, _r, Lr) {
    var Ir = this._transformState;
    if (Ir.writecb = Lr, Ir.writechunk = or, Ir.writeencoding = _r, !Ir.transforming) {
      var Ar = this._readableState;
      (Ir.needTransform || Ar.needReadable || Ar.length < Ar.highWaterMark) && this._read(Ar.highWaterMark);
    }
  }, ne.prototype._read = function(or) {
    var _r = this._transformState;
    _r.writechunk !== null && !_r.transforming ? (_r.transforming = !0, this._transform(_r.writechunk, _r.writeencoding, _r.afterTransform)) : _r.needTransform = !0;
  }, ne.prototype._destroy = function(or, _r) {
    Me.prototype._destroy.call(this, or, function(Lr) {
      _r(Lr);
    });
  };
  function gr(or, _r, Lr) {
    if (_r)
      return or.emit("error", _r);
    if (Lr != null && or.push(Lr), or._writableState.length)
      throw new $e();
    if (or._transformState.transforming)
      throw new we();
    return or.push(null);
  }
  return _stream_transform$1;
}
var _stream_passthrough$1, hasRequired_stream_passthrough;
function require_stream_passthrough() {
  if (hasRequired_stream_passthrough)
    return _stream_passthrough$1;
  hasRequired_stream_passthrough = 1, _stream_passthrough$1 = c;
  var m = require_stream_transform();
  inherits_browser.exports(c, m);
  function c(ie) {
    if (!(this instanceof c))
      return new c(ie);
    m.call(this, ie);
  }
  return c.prototype._transform = function(ie, we, $e) {
    $e(null, ie);
  }, _stream_passthrough$1;
}
var pipeline_1, hasRequiredPipeline;
function requirePipeline() {
  if (hasRequiredPipeline)
    return pipeline_1;
  hasRequiredPipeline = 1;
  var m;
  function c(Lr) {
    var Ir = !1;
    return function() {
      Ir || (Ir = !0, Lr.apply(void 0, arguments));
    };
  }
  var ie = requireErrorsBrowser().codes, we = ie.ERR_MISSING_ARGS, $e = ie.ERR_STREAM_DESTROYED;
  function Me(Lr) {
    if (Lr)
      throw Lr;
  }
  function Ze(Lr) {
    return Lr.setHeader && typeof Lr.abort == "function";
  }
  function ne(Lr, Ir, Ar, Rr) {
    Rr = c(Rr);
    var Nr = !1;
    Lr.on("close", function() {
      Nr = !0;
    }), m === void 0 && (m = requireEndOfStream()), m(Lr, {
      readable: Ir,
      writable: Ar
    }, function(Vr) {
      if (Vr)
        return Rr(Vr);
      Nr = !0, Rr();
    });
    var Yr = !1;
    return function(Vr) {
      if (!Nr && !Yr) {
        if (Yr = !0, Ze(Lr))
          return Lr.abort();
        if (typeof Lr.destroy == "function")
          return Lr.destroy();
        Rr(Vr || new $e("pipe"));
      }
    };
  }
  function rr(Lr) {
    Lr();
  }
  function gr(Lr, Ir) {
    return Lr.pipe(Ir);
  }
  function or(Lr) {
    return !Lr.length || typeof Lr[Lr.length - 1] != "function" ? Me : Lr.pop();
  }
  function _r() {
    for (var Lr = arguments.length, Ir = new Array(Lr), Ar = 0; Ar < Lr; Ar++)
      Ir[Ar] = arguments[Ar];
    var Rr = or(Ir);
    if (Array.isArray(Ir[0]) && (Ir = Ir[0]), Ir.length < 2)
      throw new we("streams");
    var Nr, Yr = Ir.map(function(Vr, Xr) {
      var Wr = Xr < Ir.length - 1, si = Xr > 0;
      return ne(Vr, Wr, si, function(li) {
        Nr || (Nr = li), li && Yr.forEach(rr), !Wr && (Yr.forEach(rr), Rr(Nr));
      });
    });
    return Ir.reduce(gr);
  }
  return pipeline_1 = _r, pipeline_1;
}
var streamBrowserify = Stream, EE = events$2.exports.EventEmitter, inherits$s = inherits_browser.exports;
inherits$s(Stream, EE);
Stream.Readable = require_stream_readable$1();
Stream.Writable = require_stream_writable$1();
Stream.Duplex = require_stream_duplex$1();
Stream.Transform = require_stream_transform();
Stream.PassThrough = require_stream_passthrough();
Stream.finished = requireEndOfStream();
Stream.pipeline = requirePipeline();
Stream.Stream = Stream;
function Stream() {
  EE.call(this);
}
Stream.prototype.pipe = function(m, c) {
  var ie = this;
  function we(or) {
    m.writable && m.write(or) === !1 && ie.pause && ie.pause();
  }
  ie.on("data", we);
  function $e() {
    ie.readable && ie.resume && ie.resume();
  }
  m.on("drain", $e), !m._isStdio && (!c || c.end !== !1) && (ie.on("end", Ze), ie.on("close", ne));
  var Me = !1;
  function Ze() {
    Me || (Me = !0, m.end());
  }
  function ne() {
    Me || (Me = !0, typeof m.destroy == "function" && m.destroy());
  }
  function rr(or) {
    if (gr(), EE.listenerCount(this, "error") === 0)
      throw or;
  }
  ie.on("error", rr), m.on("error", rr);
  function gr() {
    ie.removeListener("data", we), m.removeListener("drain", $e), ie.removeListener("end", Ze), ie.removeListener("close", ne), ie.removeListener("error", rr), m.removeListener("error", rr), ie.removeListener("end", gr), ie.removeListener("close", gr), m.removeListener("close", gr);
  }
  return ie.on("end", gr), ie.on("close", gr), m.on("close", gr), m.emit("pipe", ie), m;
};
var Buffer$z = safeBuffer$2.exports.Buffer, Transform$7 = streamBrowserify.Transform, inherits$r = inherits_browser.exports;
function HashBase$2(m) {
  Transform$7.call(this), this._block = Buffer$z.allocUnsafe(m), this._blockSize = m, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
}
inherits$r(HashBase$2, Transform$7);
HashBase$2.prototype._transform = function(m, c, ie) {
  var we = null;
  try {
    this.update(m, c);
  } catch ($e) {
    we = $e;
  }
  ie(we);
};
HashBase$2.prototype._flush = function(m) {
  var c = null;
  try {
    this.push(this.digest());
  } catch (ie) {
    c = ie;
  }
  m(c);
};
var useUint8Array$1 = typeof Uint8Array < "u", useArrayBuffer$1 = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (Buffer$z.prototype instanceof Uint8Array || Buffer$z.TYPED_ARRAY_SUPPORT);
function toBuffer$4(m, c) {
  if (m instanceof Buffer$z)
    return m;
  if (typeof m == "string")
    return Buffer$z.from(m, c);
  if (useArrayBuffer$1 && ArrayBuffer.isView(m)) {
    if (m.byteLength === 0)
      return Buffer$z.alloc(0);
    var ie = Buffer$z.from(m.buffer, m.byteOffset, m.byteLength);
    if (ie.byteLength === m.byteLength)
      return ie;
  }
  if (useUint8Array$1 && m instanceof Uint8Array || Buffer$z.isBuffer(m) && m.constructor && typeof m.constructor.isBuffer == "function" && m.constructor.isBuffer(m))
    return Buffer$z.from(m);
  throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
HashBase$2.prototype.update = function(m, c) {
  if (this._finalized)
    throw new Error("Digest already called");
  m = toBuffer$4(m, c);
  for (var ie = this._block, we = 0; this._blockOffset + m.length - we >= this._blockSize; ) {
    for (var $e = this._blockOffset; $e < this._blockSize; )
      ie[$e++] = m[we++];
    this._update(), this._blockOffset = 0;
  }
  for (; we < m.length; )
    ie[this._blockOffset++] = m[we++];
  for (var Me = 0, Ze = m.length * 8; Ze > 0; ++Me)
    this._length[Me] += Ze, Ze = this._length[Me] / 4294967296 | 0, Ze > 0 && (this._length[Me] -= 4294967296 * Ze);
  return this;
};
HashBase$2.prototype._update = function() {
  throw new Error("_update is not implemented");
};
HashBase$2.prototype.digest = function(m) {
  if (this._finalized)
    throw new Error("Digest already called");
  this._finalized = !0;
  var c = this._digest();
  m !== void 0 && (c = c.toString(m)), this._block.fill(0), this._blockOffset = 0;
  for (var ie = 0; ie < 4; ++ie)
    this._length[ie] = 0;
  return c;
};
HashBase$2.prototype._digest = function() {
  throw new Error("_digest is not implemented");
};
var hashBase = HashBase$2, inherits$q = inherits_browser.exports, HashBase$1 = hashBase, Buffer$y = safeBuffer$2.exports.Buffer, ARRAY16$1 = new Array(16);
function MD5$3() {
  HashBase$1.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
}
inherits$q(MD5$3, HashBase$1);
MD5$3.prototype._update = function() {
  for (var m = ARRAY16$1, c = 0; c < 16; ++c)
    m[c] = this._block.readInt32LE(c * 4);
  var ie = this._a, we = this._b, $e = this._c, Me = this._d;
  ie = fnF(ie, we, $e, Me, m[0], 3614090360, 7), Me = fnF(Me, ie, we, $e, m[1], 3905402710, 12), $e = fnF($e, Me, ie, we, m[2], 606105819, 17), we = fnF(we, $e, Me, ie, m[3], 3250441966, 22), ie = fnF(ie, we, $e, Me, m[4], 4118548399, 7), Me = fnF(Me, ie, we, $e, m[5], 1200080426, 12), $e = fnF($e, Me, ie, we, m[6], 2821735955, 17), we = fnF(we, $e, Me, ie, m[7], 4249261313, 22), ie = fnF(ie, we, $e, Me, m[8], 1770035416, 7), Me = fnF(Me, ie, we, $e, m[9], 2336552879, 12), $e = fnF($e, Me, ie, we, m[10], 4294925233, 17), we = fnF(we, $e, Me, ie, m[11], 2304563134, 22), ie = fnF(ie, we, $e, Me, m[12], 1804603682, 7), Me = fnF(Me, ie, we, $e, m[13], 4254626195, 12), $e = fnF($e, Me, ie, we, m[14], 2792965006, 17), we = fnF(we, $e, Me, ie, m[15], 1236535329, 22), ie = fnG(ie, we, $e, Me, m[1], 4129170786, 5), Me = fnG(Me, ie, we, $e, m[6], 3225465664, 9), $e = fnG($e, Me, ie, we, m[11], 643717713, 14), we = fnG(we, $e, Me, ie, m[0], 3921069994, 20), ie = fnG(ie, we, $e, Me, m[5], 3593408605, 5), Me = fnG(Me, ie, we, $e, m[10], 38016083, 9), $e = fnG($e, Me, ie, we, m[15], 3634488961, 14), we = fnG(we, $e, Me, ie, m[4], 3889429448, 20), ie = fnG(ie, we, $e, Me, m[9], 568446438, 5), Me = fnG(Me, ie, we, $e, m[14], 3275163606, 9), $e = fnG($e, Me, ie, we, m[3], 4107603335, 14), we = fnG(we, $e, Me, ie, m[8], 1163531501, 20), ie = fnG(ie, we, $e, Me, m[13], 2850285829, 5), Me = fnG(Me, ie, we, $e, m[2], 4243563512, 9), $e = fnG($e, Me, ie, we, m[7], 1735328473, 14), we = fnG(we, $e, Me, ie, m[12], 2368359562, 20), ie = fnH(ie, we, $e, Me, m[5], 4294588738, 4), Me = fnH(Me, ie, we, $e, m[8], 2272392833, 11), $e = fnH($e, Me, ie, we, m[11], 1839030562, 16), we = fnH(we, $e, Me, ie, m[14], 4259657740, 23), ie = fnH(ie, we, $e, Me, m[1], 2763975236, 4), Me = fnH(Me, ie, we, $e, m[4], 1272893353, 11), $e = fnH($e, Me, ie, we, m[7], 4139469664, 16), we = fnH(we, $e, Me, ie, m[10], 3200236656, 23), ie = fnH(ie, we, $e, Me, m[13], 681279174, 4), Me = fnH(Me, ie, we, $e, m[0], 3936430074, 11), $e = fnH($e, Me, ie, we, m[3], 3572445317, 16), we = fnH(we, $e, Me, ie, m[6], 76029189, 23), ie = fnH(ie, we, $e, Me, m[9], 3654602809, 4), Me = fnH(Me, ie, we, $e, m[12], 3873151461, 11), $e = fnH($e, Me, ie, we, m[15], 530742520, 16), we = fnH(we, $e, Me, ie, m[2], 3299628645, 23), ie = fnI(ie, we, $e, Me, m[0], 4096336452, 6), Me = fnI(Me, ie, we, $e, m[7], 1126891415, 10), $e = fnI($e, Me, ie, we, m[14], 2878612391, 15), we = fnI(we, $e, Me, ie, m[5], 4237533241, 21), ie = fnI(ie, we, $e, Me, m[12], 1700485571, 6), Me = fnI(Me, ie, we, $e, m[3], 2399980690, 10), $e = fnI($e, Me, ie, we, m[10], 4293915773, 15), we = fnI(we, $e, Me, ie, m[1], 2240044497, 21), ie = fnI(ie, we, $e, Me, m[8], 1873313359, 6), Me = fnI(Me, ie, we, $e, m[15], 4264355552, 10), $e = fnI($e, Me, ie, we, m[6], 2734768916, 15), we = fnI(we, $e, Me, ie, m[13], 1309151649, 21), ie = fnI(ie, we, $e, Me, m[4], 4149444226, 6), Me = fnI(Me, ie, we, $e, m[11], 3174756917, 10), $e = fnI($e, Me, ie, we, m[2], 718787259, 15), we = fnI(we, $e, Me, ie, m[9], 3951481745, 21), this._a = this._a + ie | 0, this._b = this._b + we | 0, this._c = this._c + $e | 0, this._d = this._d + Me | 0;
};
MD5$3.prototype._digest = function() {
  this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
  var m = Buffer$y.allocUnsafe(16);
  return m.writeInt32LE(this._a, 0), m.writeInt32LE(this._b, 4), m.writeInt32LE(this._c, 8), m.writeInt32LE(this._d, 12), m;
};
function rotl$1(m, c) {
  return m << c | m >>> 32 - c;
}
function fnF(m, c, ie, we, $e, Me, Ze) {
  return rotl$1(m + (c & ie | ~c & we) + $e + Me | 0, Ze) + c | 0;
}
function fnG(m, c, ie, we, $e, Me, Ze) {
  return rotl$1(m + (c & we | ie & ~we) + $e + Me | 0, Ze) + c | 0;
}
function fnH(m, c, ie, we, $e, Me, Ze) {
  return rotl$1(m + (c ^ ie ^ we) + $e + Me | 0, Ze) + c | 0;
}
function fnI(m, c, ie, we, $e, Me, Ze) {
  return rotl$1(m + (ie ^ (c | ~we)) + $e + Me | 0, Ze) + c | 0;
}
var md5_js = MD5$3, Buffer$x = require$$0$4.Buffer, inherits$p = inherits_browser.exports, HashBase = hashBase, ARRAY16 = new Array(16), zl = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], zr = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], sl = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], sr = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], hl = [0, 1518500249, 1859775393, 2400959708, 2840853838], hr = [1352829926, 1548603684, 1836072691, 2053994217, 0];
function RIPEMD160$4() {
  HashBase.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
}
inherits$p(RIPEMD160$4, HashBase);
RIPEMD160$4.prototype._update = function() {
  for (var m = ARRAY16, c = 0; c < 16; ++c)
    m[c] = this._block.readInt32LE(c * 4);
  for (var ie = this._a | 0, we = this._b | 0, $e = this._c | 0, Me = this._d | 0, Ze = this._e | 0, ne = this._a | 0, rr = this._b | 0, gr = this._c | 0, or = this._d | 0, _r = this._e | 0, Lr = 0; Lr < 80; Lr += 1) {
    var Ir, Ar;
    Lr < 16 ? (Ir = fn1(ie, we, $e, Me, Ze, m[zl[Lr]], hl[0], sl[Lr]), Ar = fn5(ne, rr, gr, or, _r, m[zr[Lr]], hr[0], sr[Lr])) : Lr < 32 ? (Ir = fn2(ie, we, $e, Me, Ze, m[zl[Lr]], hl[1], sl[Lr]), Ar = fn4(ne, rr, gr, or, _r, m[zr[Lr]], hr[1], sr[Lr])) : Lr < 48 ? (Ir = fn3(ie, we, $e, Me, Ze, m[zl[Lr]], hl[2], sl[Lr]), Ar = fn3(ne, rr, gr, or, _r, m[zr[Lr]], hr[2], sr[Lr])) : Lr < 64 ? (Ir = fn4(ie, we, $e, Me, Ze, m[zl[Lr]], hl[3], sl[Lr]), Ar = fn2(ne, rr, gr, or, _r, m[zr[Lr]], hr[3], sr[Lr])) : (Ir = fn5(ie, we, $e, Me, Ze, m[zl[Lr]], hl[4], sl[Lr]), Ar = fn1(ne, rr, gr, or, _r, m[zr[Lr]], hr[4], sr[Lr])), ie = Ze, Ze = Me, Me = rotl($e, 10), $e = we, we = Ir, ne = _r, _r = or, or = rotl(gr, 10), gr = rr, rr = Ar;
  }
  var Rr = this._b + $e + or | 0;
  this._b = this._c + Me + _r | 0, this._c = this._d + Ze + ne | 0, this._d = this._e + ie + rr | 0, this._e = this._a + we + gr | 0, this._a = Rr;
};
RIPEMD160$4.prototype._digest = function() {
  this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
  var m = Buffer$x.alloc ? Buffer$x.alloc(20) : new Buffer$x(20);
  return m.writeInt32LE(this._a, 0), m.writeInt32LE(this._b, 4), m.writeInt32LE(this._c, 8), m.writeInt32LE(this._d, 12), m.writeInt32LE(this._e, 16), m;
};
function rotl(m, c) {
  return m << c | m >>> 32 - c;
}
function fn1(m, c, ie, we, $e, Me, Ze, ne) {
  return rotl(m + (c ^ ie ^ we) + Me + Ze | 0, ne) + $e | 0;
}
function fn2(m, c, ie, we, $e, Me, Ze, ne) {
  return rotl(m + (c & ie | ~c & we) + Me + Ze | 0, ne) + $e | 0;
}
function fn3(m, c, ie, we, $e, Me, Ze, ne) {
  return rotl(m + ((c | ~ie) ^ we) + Me + Ze | 0, ne) + $e | 0;
}
function fn4(m, c, ie, we, $e, Me, Ze, ne) {
  return rotl(m + (c & we | ie & ~we) + Me + Ze | 0, ne) + $e | 0;
}
function fn5(m, c, ie, we, $e, Me, Ze, ne) {
  return rotl(m + (c ^ (ie | ~we)) + Me + Ze | 0, ne) + $e | 0;
}
var ripemd160 = RIPEMD160$4, sha_js = { exports: {} }, Buffer$w = safeBuffer$2.exports.Buffer;
function Hash$7(m, c) {
  this._block = Buffer$w.alloc(m), this._finalSize = c, this._blockSize = m, this._len = 0;
}
Hash$7.prototype.update = function(m, c) {
  typeof m == "string" && (c = c || "utf8", m = Buffer$w.from(m, c));
  for (var ie = this._block, we = this._blockSize, $e = m.length, Me = this._len, Ze = 0; Ze < $e; ) {
    for (var ne = Me % we, rr = Math.min($e - Ze, we - ne), gr = 0; gr < rr; gr++)
      ie[ne + gr] = m[Ze + gr];
    Me += rr, Ze += rr, Me % we === 0 && this._update(ie);
  }
  return this._len += $e, this;
};
Hash$7.prototype.digest = function(m) {
  var c = this._len % this._blockSize;
  this._block[c] = 128, this._block.fill(0, c + 1), c >= this._finalSize && (this._update(this._block), this._block.fill(0));
  var ie = this._len * 8;
  if (ie <= 4294967295)
    this._block.writeUInt32BE(ie, this._blockSize - 4);
  else {
    var we = (ie & 4294967295) >>> 0, $e = (ie - we) / 4294967296;
    this._block.writeUInt32BE($e, this._blockSize - 8), this._block.writeUInt32BE(we, this._blockSize - 4);
  }
  this._update(this._block);
  var Me = this._hash();
  return m ? Me.toString(m) : Me;
};
Hash$7.prototype._update = function() {
  throw new Error("_update must be implemented by subclass");
};
var hash$5 = Hash$7, inherits$o = inherits_browser.exports, Hash$6 = hash$5, Buffer$v = safeBuffer$2.exports.Buffer, K$5 = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], W$6 = new Array(80);
function Sha() {
  this.init(), this._w = W$6, Hash$6.call(this, 64, 56);
}
inherits$o(Sha, Hash$6);
Sha.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function rotl5$1(m) {
  return m << 5 | m >>> 27;
}
function rotl30$1(m) {
  return m << 30 | m >>> 2;
}
function ft$3(m, c, ie, we) {
  return m === 0 ? c & ie | ~c & we : m === 2 ? c & ie | c & we | ie & we : c ^ ie ^ we;
}
Sha.prototype._update = function(m) {
  for (var c = this._w, ie = this._a | 0, we = this._b | 0, $e = this._c | 0, Me = this._d | 0, Ze = this._e | 0, ne = 0; ne < 16; ++ne)
    c[ne] = m.readInt32BE(ne * 4);
  for (; ne < 80; ++ne)
    c[ne] = c[ne - 3] ^ c[ne - 8] ^ c[ne - 14] ^ c[ne - 16];
  for (var rr = 0; rr < 80; ++rr) {
    var gr = ~~(rr / 20), or = rotl5$1(ie) + ft$3(gr, we, $e, Me) + Ze + c[rr] + K$5[gr] | 0;
    Ze = Me, Me = $e, $e = rotl30$1(we), we = ie, ie = or;
  }
  this._a = ie + this._a | 0, this._b = we + this._b | 0, this._c = $e + this._c | 0, this._d = Me + this._d | 0, this._e = Ze + this._e | 0;
};
Sha.prototype._hash = function() {
  var m = Buffer$v.allocUnsafe(20);
  return m.writeInt32BE(this._a | 0, 0), m.writeInt32BE(this._b | 0, 4), m.writeInt32BE(this._c | 0, 8), m.writeInt32BE(this._d | 0, 12), m.writeInt32BE(this._e | 0, 16), m;
};
var sha$4 = Sha, inherits$n = inherits_browser.exports, Hash$5 = hash$5, Buffer$u = safeBuffer$2.exports.Buffer, K$4 = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], W$5 = new Array(80);
function Sha1() {
  this.init(), this._w = W$5, Hash$5.call(this, 64, 56);
}
inherits$n(Sha1, Hash$5);
Sha1.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function rotl1(m) {
  return m << 1 | m >>> 31;
}
function rotl5(m) {
  return m << 5 | m >>> 27;
}
function rotl30(m) {
  return m << 30 | m >>> 2;
}
function ft$2(m, c, ie, we) {
  return m === 0 ? c & ie | ~c & we : m === 2 ? c & ie | c & we | ie & we : c ^ ie ^ we;
}
Sha1.prototype._update = function(m) {
  for (var c = this._w, ie = this._a | 0, we = this._b | 0, $e = this._c | 0, Me = this._d | 0, Ze = this._e | 0, ne = 0; ne < 16; ++ne)
    c[ne] = m.readInt32BE(ne * 4);
  for (; ne < 80; ++ne)
    c[ne] = rotl1(c[ne - 3] ^ c[ne - 8] ^ c[ne - 14] ^ c[ne - 16]);
  for (var rr = 0; rr < 80; ++rr) {
    var gr = ~~(rr / 20), or = rotl5(ie) + ft$2(gr, we, $e, Me) + Ze + c[rr] + K$4[gr] | 0;
    Ze = Me, Me = $e, $e = rotl30(we), we = ie, ie = or;
  }
  this._a = ie + this._a | 0, this._b = we + this._b | 0, this._c = $e + this._c | 0, this._d = Me + this._d | 0, this._e = Ze + this._e | 0;
};
Sha1.prototype._hash = function() {
  var m = Buffer$u.allocUnsafe(20);
  return m.writeInt32BE(this._a | 0, 0), m.writeInt32BE(this._b | 0, 4), m.writeInt32BE(this._c | 0, 8), m.writeInt32BE(this._d | 0, 12), m.writeInt32BE(this._e | 0, 16), m;
};
var sha1 = Sha1, inherits$m = inherits_browser.exports, Hash$4 = hash$5, Buffer$t = safeBuffer$2.exports.Buffer, K$3 = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
], W$4 = new Array(64);
function Sha256$1() {
  this.init(), this._w = W$4, Hash$4.call(this, 64, 56);
}
inherits$m(Sha256$1, Hash$4);
Sha256$1.prototype.init = function() {
  return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
};
function ch(m, c, ie) {
  return ie ^ m & (c ^ ie);
}
function maj$1(m, c, ie) {
  return m & c | ie & (m | c);
}
function sigma0$1(m) {
  return (m >>> 2 | m << 30) ^ (m >>> 13 | m << 19) ^ (m >>> 22 | m << 10);
}
function sigma1$1(m) {
  return (m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7);
}
function gamma0(m) {
  return (m >>> 7 | m << 25) ^ (m >>> 18 | m << 14) ^ m >>> 3;
}
function gamma1(m) {
  return (m >>> 17 | m << 15) ^ (m >>> 19 | m << 13) ^ m >>> 10;
}
Sha256$1.prototype._update = function(m) {
  for (var c = this._w, ie = this._a | 0, we = this._b | 0, $e = this._c | 0, Me = this._d | 0, Ze = this._e | 0, ne = this._f | 0, rr = this._g | 0, gr = this._h | 0, or = 0; or < 16; ++or)
    c[or] = m.readInt32BE(or * 4);
  for (; or < 64; ++or)
    c[or] = gamma1(c[or - 2]) + c[or - 7] + gamma0(c[or - 15]) + c[or - 16] | 0;
  for (var _r = 0; _r < 64; ++_r) {
    var Lr = gr + sigma1$1(Ze) + ch(Ze, ne, rr) + K$3[_r] + c[_r] | 0, Ir = sigma0$1(ie) + maj$1(ie, we, $e) | 0;
    gr = rr, rr = ne, ne = Ze, Ze = Me + Lr | 0, Me = $e, $e = we, we = ie, ie = Lr + Ir | 0;
  }
  this._a = ie + this._a | 0, this._b = we + this._b | 0, this._c = $e + this._c | 0, this._d = Me + this._d | 0, this._e = Ze + this._e | 0, this._f = ne + this._f | 0, this._g = rr + this._g | 0, this._h = gr + this._h | 0;
};
Sha256$1.prototype._hash = function() {
  var m = Buffer$t.allocUnsafe(32);
  return m.writeInt32BE(this._a, 0), m.writeInt32BE(this._b, 4), m.writeInt32BE(this._c, 8), m.writeInt32BE(this._d, 12), m.writeInt32BE(this._e, 16), m.writeInt32BE(this._f, 20), m.writeInt32BE(this._g, 24), m.writeInt32BE(this._h, 28), m;
};
var sha256$1 = Sha256$1, inherits$l = inherits_browser.exports, Sha256 = sha256$1, Hash$3 = hash$5, Buffer$s = safeBuffer$2.exports.Buffer, W$3 = new Array(64);
function Sha224() {
  this.init(), this._w = W$3, Hash$3.call(this, 64, 56);
}
inherits$l(Sha224, Sha256);
Sha224.prototype.init = function() {
  return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
};
Sha224.prototype._hash = function() {
  var m = Buffer$s.allocUnsafe(28);
  return m.writeInt32BE(this._a, 0), m.writeInt32BE(this._b, 4), m.writeInt32BE(this._c, 8), m.writeInt32BE(this._d, 12), m.writeInt32BE(this._e, 16), m.writeInt32BE(this._f, 20), m.writeInt32BE(this._g, 24), m;
};
var sha224$1 = Sha224, inherits$k = inherits_browser.exports, Hash$2 = hash$5, Buffer$r = safeBuffer$2.exports.Buffer, K$2 = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
], W$2 = new Array(160);
function Sha512() {
  this.init(), this._w = W$2, Hash$2.call(this, 128, 112);
}
inherits$k(Sha512, Hash$2);
Sha512.prototype.init = function() {
  return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
};
function Ch(m, c, ie) {
  return ie ^ m & (c ^ ie);
}
function maj(m, c, ie) {
  return m & c | ie & (m | c);
}
function sigma0(m, c) {
  return (m >>> 28 | c << 4) ^ (c >>> 2 | m << 30) ^ (c >>> 7 | m << 25);
}
function sigma1(m, c) {
  return (m >>> 14 | c << 18) ^ (m >>> 18 | c << 14) ^ (c >>> 9 | m << 23);
}
function Gamma0(m, c) {
  return (m >>> 1 | c << 31) ^ (m >>> 8 | c << 24) ^ m >>> 7;
}
function Gamma0l(m, c) {
  return (m >>> 1 | c << 31) ^ (m >>> 8 | c << 24) ^ (m >>> 7 | c << 25);
}
function Gamma1(m, c) {
  return (m >>> 19 | c << 13) ^ (c >>> 29 | m << 3) ^ m >>> 6;
}
function Gamma1l(m, c) {
  return (m >>> 19 | c << 13) ^ (c >>> 29 | m << 3) ^ (m >>> 6 | c << 26);
}
function getCarry(m, c) {
  return m >>> 0 < c >>> 0 ? 1 : 0;
}
Sha512.prototype._update = function(m) {
  for (var c = this._w, ie = this._ah | 0, we = this._bh | 0, $e = this._ch | 0, Me = this._dh | 0, Ze = this._eh | 0, ne = this._fh | 0, rr = this._gh | 0, gr = this._hh | 0, or = this._al | 0, _r = this._bl | 0, Lr = this._cl | 0, Ir = this._dl | 0, Ar = this._el | 0, Rr = this._fl | 0, Nr = this._gl | 0, Yr = this._hl | 0, Vr = 0; Vr < 32; Vr += 2)
    c[Vr] = m.readInt32BE(Vr * 4), c[Vr + 1] = m.readInt32BE(Vr * 4 + 4);
  for (; Vr < 160; Vr += 2) {
    var Xr = c[Vr - 30], Wr = c[Vr - 15 * 2 + 1], si = Gamma0(Xr, Wr), li = Gamma0l(Wr, Xr);
    Xr = c[Vr - 2 * 2], Wr = c[Vr - 2 * 2 + 1];
    var xi = Gamma1(Xr, Wr), di = Gamma1l(Wr, Xr), oi = c[Vr - 7 * 2], ci = c[Vr - 7 * 2 + 1], vr = c[Vr - 16 * 2], Ae = c[Vr - 16 * 2 + 1], ze = li + ci | 0, Ue = si + oi + getCarry(ze, li) | 0;
    ze = ze + di | 0, Ue = Ue + xi + getCarry(ze, di) | 0, ze = ze + Ae | 0, Ue = Ue + vr + getCarry(ze, Ae) | 0, c[Vr] = Ue, c[Vr + 1] = ze;
  }
  for (var tr = 0; tr < 160; tr += 2) {
    Ue = c[tr], ze = c[tr + 1];
    var lr = maj(ie, we, $e), pr = maj(or, _r, Lr), br = sigma0(ie, or), nr = sigma0(or, ie), Pe = sigma1(Ze, Ar), ur = sigma1(Ar, Ze), Pr = K$2[tr], Hr = K$2[tr + 1], vi = Ch(Ze, ne, rr), Ti = Ch(Ar, Rr, Nr), wi = Yr + ur | 0, ii = gr + Pe + getCarry(wi, Yr) | 0;
    wi = wi + Ti | 0, ii = ii + vi + getCarry(wi, Ti) | 0, wi = wi + Hr | 0, ii = ii + Pr + getCarry(wi, Hr) | 0, wi = wi + ze | 0, ii = ii + Ue + getCarry(wi, ze) | 0;
    var mi = nr + pr | 0, ei = br + lr + getCarry(mi, nr) | 0;
    gr = rr, Yr = Nr, rr = ne, Nr = Rr, ne = Ze, Rr = Ar, Ar = Ir + wi | 0, Ze = Me + ii + getCarry(Ar, Ir) | 0, Me = $e, Ir = Lr, $e = we, Lr = _r, we = ie, _r = or, or = wi + mi | 0, ie = ii + ei + getCarry(or, wi) | 0;
  }
  this._al = this._al + or | 0, this._bl = this._bl + _r | 0, this._cl = this._cl + Lr | 0, this._dl = this._dl + Ir | 0, this._el = this._el + Ar | 0, this._fl = this._fl + Rr | 0, this._gl = this._gl + Nr | 0, this._hl = this._hl + Yr | 0, this._ah = this._ah + ie + getCarry(this._al, or) | 0, this._bh = this._bh + we + getCarry(this._bl, _r) | 0, this._ch = this._ch + $e + getCarry(this._cl, Lr) | 0, this._dh = this._dh + Me + getCarry(this._dl, Ir) | 0, this._eh = this._eh + Ze + getCarry(this._el, Ar) | 0, this._fh = this._fh + ne + getCarry(this._fl, Rr) | 0, this._gh = this._gh + rr + getCarry(this._gl, Nr) | 0, this._hh = this._hh + gr + getCarry(this._hl, Yr) | 0;
};
Sha512.prototype._hash = function() {
  var m = Buffer$r.allocUnsafe(64);
  function c(ie, we, $e) {
    m.writeInt32BE(ie, $e), m.writeInt32BE(we, $e + 4);
  }
  return c(this._ah, this._al, 0), c(this._bh, this._bl, 8), c(this._ch, this._cl, 16), c(this._dh, this._dl, 24), c(this._eh, this._el, 32), c(this._fh, this._fl, 40), c(this._gh, this._gl, 48), c(this._hh, this._hl, 56), m;
};
var sha512$1 = Sha512, inherits$j = inherits_browser.exports, SHA512$2 = sha512$1, Hash$1 = hash$5, Buffer$q = safeBuffer$2.exports.Buffer, W$1 = new Array(160);
function Sha384() {
  this.init(), this._w = W$1, Hash$1.call(this, 128, 112);
}
inherits$j(Sha384, SHA512$2);
Sha384.prototype.init = function() {
  return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
};
Sha384.prototype._hash = function() {
  var m = Buffer$q.allocUnsafe(48);
  function c(ie, we, $e) {
    m.writeInt32BE(ie, $e), m.writeInt32BE(we, $e + 4);
  }
  return c(this._ah, this._al, 0), c(this._bh, this._bl, 8), c(this._ch, this._cl, 16), c(this._dh, this._dl, 24), c(this._eh, this._el, 32), c(this._fh, this._fl, 40), m;
};
var sha384$1 = Sha384, exports = sha_js.exports = function(c) {
  c = c.toLowerCase();
  var ie = exports[c];
  if (!ie)
    throw new Error(c + " is not supported (we accept pull requests)");
  return new ie();
};
exports.sha = sha$4;
exports.sha1 = sha1;
exports.sha224 = sha224$1;
exports.sha256 = sha256$1;
exports.sha384 = sha384$1;
exports.sha512 = sha512$1;
var Buffer$p = safeBuffer$2.exports.Buffer, Transform$6 = streamBrowserify.Transform, StringDecoder = string_decoder.StringDecoder, inherits$i = inherits_browser.exports;
function CipherBase$1(m) {
  Transform$6.call(this), this.hashMode = typeof m == "string", this.hashMode ? this[m] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
}
inherits$i(CipherBase$1, Transform$6);
var useUint8Array = typeof Uint8Array < "u", useArrayBuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (Buffer$p.prototype instanceof Uint8Array || Buffer$p.TYPED_ARRAY_SUPPORT);
function toBuffer$3(m, c) {
  if (m instanceof Buffer$p)
    return m;
  if (typeof m == "string")
    return Buffer$p.from(m, c);
  if (useArrayBuffer && ArrayBuffer.isView(m)) {
    if (m.byteLength === 0)
      return Buffer$p.alloc(0);
    var ie = Buffer$p.from(m.buffer, m.byteOffset, m.byteLength);
    if (ie.byteLength === m.byteLength)
      return ie;
  }
  if (useUint8Array && m instanceof Uint8Array || Buffer$p.isBuffer(m) && m.constructor && typeof m.constructor.isBuffer == "function" && m.constructor.isBuffer(m))
    return Buffer$p.from(m);
  throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
CipherBase$1.prototype.update = function(m, c, ie) {
  var we = toBuffer$3(m, c), $e = this._update(we);
  return this.hashMode ? this : (ie && ($e = this._toString($e, ie)), $e);
};
CipherBase$1.prototype.setAutoPadding = function() {
};
CipherBase$1.prototype.getAuthTag = function() {
  throw new Error("trying to get auth tag in unsupported state");
};
CipherBase$1.prototype.setAuthTag = function() {
  throw new Error("trying to set auth tag in unsupported state");
};
CipherBase$1.prototype.setAAD = function() {
  throw new Error("trying to set aad in unsupported state");
};
CipherBase$1.prototype._transform = function(m, c, ie) {
  var we;
  try {
    this.hashMode ? this._update(m) : this.push(this._update(m));
  } catch ($e) {
    we = $e;
  } finally {
    ie(we);
  }
};
CipherBase$1.prototype._flush = function(m) {
  var c;
  try {
    this.push(this.__final());
  } catch (ie) {
    c = ie;
  }
  m(c);
};
CipherBase$1.prototype._finalOrDigest = function(m) {
  var c = this.__final() || Buffer$p.alloc(0);
  return m && (c = this._toString(c, m, !0)), c;
};
CipherBase$1.prototype._toString = function(m, c, ie) {
  if (this._decoder || (this._decoder = new StringDecoder(c), this._encoding = c), this._encoding !== c)
    throw new Error("can\u2019t switch encodings");
  var we = this._decoder.write(m);
  return ie && (we += this._decoder.end()), we;
};
var cipherBase = CipherBase$1, inherits$h = inherits_browser.exports, MD5$2 = md5_js, RIPEMD160$3 = ripemd160, sha$3 = sha_js.exports, Base$7 = cipherBase;
function Hash(m) {
  Base$7.call(this, "digest"), this._hash = m;
}
inherits$h(Hash, Base$7);
Hash.prototype._update = function(m) {
  this._hash.update(m);
};
Hash.prototype._final = function() {
  return this._hash.digest();
};
var browser$a = function(c) {
  return c = c.toLowerCase(), c === "md5" ? new MD5$2() : c === "rmd160" || c === "ripemd160" ? new RIPEMD160$3() : new Hash(sha$3(c));
}, inherits$g = inherits_browser.exports, Buffer$o = safeBuffer$2.exports.Buffer, Base$6 = cipherBase, ZEROS$2 = Buffer$o.alloc(128), blocksize = 64;
function Hmac$3(m, c) {
  Base$6.call(this, "digest"), typeof c == "string" && (c = Buffer$o.from(c)), this._alg = m, this._key = c, c.length > blocksize ? c = m(c) : c.length < blocksize && (c = Buffer$o.concat([c, ZEROS$2], blocksize));
  for (var ie = this._ipad = Buffer$o.allocUnsafe(blocksize), we = this._opad = Buffer$o.allocUnsafe(blocksize), $e = 0; $e < blocksize; $e++)
    ie[$e] = c[$e] ^ 54, we[$e] = c[$e] ^ 92;
  this._hash = [ie];
}
inherits$g(Hmac$3, Base$6);
Hmac$3.prototype._update = function(m) {
  this._hash.push(m);
};
Hmac$3.prototype._final = function() {
  var m = this._alg(Buffer$o.concat(this._hash));
  return this._alg(Buffer$o.concat([this._opad, m]));
};
var legacy = Hmac$3, MD5$1 = md5_js, md5$2 = function(m) {
  return new MD5$1().update(m).digest();
}, inherits$f = inherits_browser.exports, Legacy = legacy, Base$5 = cipherBase, Buffer$n = safeBuffer$2.exports.Buffer, md5$1 = md5$2, RIPEMD160$2 = ripemd160, sha$2 = sha_js.exports, ZEROS$1 = Buffer$n.alloc(128);
function Hmac$2(m, c) {
  Base$5.call(this, "digest"), typeof c == "string" && (c = Buffer$n.from(c));
  var ie = m === "sha512" || m === "sha384" ? 128 : 64;
  if (this._alg = m, this._key = c, c.length > ie) {
    var we = m === "rmd160" ? new RIPEMD160$2() : sha$2(m);
    c = we.update(c).digest();
  } else
    c.length < ie && (c = Buffer$n.concat([c, ZEROS$1], ie));
  for (var $e = this._ipad = Buffer$n.allocUnsafe(ie), Me = this._opad = Buffer$n.allocUnsafe(ie), Ze = 0; Ze < ie; Ze++)
    $e[Ze] = c[Ze] ^ 54, Me[Ze] = c[Ze] ^ 92;
  this._hash = m === "rmd160" ? new RIPEMD160$2() : sha$2(m), this._hash.update($e);
}
inherits$f(Hmac$2, Base$5);
Hmac$2.prototype._update = function(m) {
  this._hash.update(m);
};
Hmac$2.prototype._final = function() {
  var m = this._hash.digest(), c = this._alg === "rmd160" ? new RIPEMD160$2() : sha$2(this._alg);
  return c.update(this._opad).update(m).digest();
};
var browser$9 = function(c, ie) {
  return c = c.toLowerCase(), c === "rmd160" || c === "ripemd160" ? new Hmac$2("rmd160", ie) : c === "md5" ? new Legacy(md5$1, ie) : new Hmac$2(c, ie);
}, algos = { exports: {} };
const sha224WithRSAEncryption = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, sha256WithRSAEncryption = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, sha384WithRSAEncryption = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, sha512WithRSAEncryption = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, sha256 = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, sha224 = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, sha384 = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, sha512 = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, DSA = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, ripemd160WithRSA = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, md5WithRSAEncryption = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, require$$6 = {
  sha224WithRSAEncryption,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256,
  sha224,
  sha384,
  sha512,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
(function(m) {
  m.exports = require$$6;
})(algos);
var browser$8 = {}, MAX_ALLOC = Math.pow(2, 30) - 1, precondition = function(m, c) {
  if (typeof m != "number")
    throw new TypeError("Iterations not a number");
  if (m < 0)
    throw new TypeError("Bad iterations");
  if (typeof c != "number")
    throw new TypeError("Key length not a number");
  if (c < 0 || c > MAX_ALLOC || c !== c)
    throw new TypeError("Bad key length");
}, defaultEncoding$2;
if (commonjsGlobal.process && commonjsGlobal.process.browser)
  defaultEncoding$2 = "utf-8";
else if (commonjsGlobal.process && commonjsGlobal.process.version) {
  var pVersionMajor = parseInt(process$1.version.split(".")[0].slice(1), 10);
  defaultEncoding$2 = pVersionMajor >= 6 ? "utf-8" : "binary";
} else
  defaultEncoding$2 = "utf-8";
var defaultEncoding_1 = defaultEncoding$2, Buffer$m = safeBuffer$2.exports.Buffer, toBuffer$2 = function(m, c, ie) {
  if (Buffer$m.isBuffer(m))
    return m;
  if (typeof m == "string")
    return Buffer$m.from(m, c);
  if (ArrayBuffer.isView(m))
    return Buffer$m.from(m.buffer);
  throw new TypeError(ie + " must be a string, a Buffer, a typed array or a DataView");
}, md5 = md5$2, RIPEMD160$1 = ripemd160, sha$1 = sha_js.exports, Buffer$l = safeBuffer$2.exports.Buffer, checkParameters$1 = precondition, defaultEncoding$1 = defaultEncoding_1, toBuffer$1 = toBuffer$2, ZEROS = Buffer$l.alloc(128), sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
};
function Hmac$1(m, c, ie) {
  var we = getDigest(m), $e = m === "sha512" || m === "sha384" ? 128 : 64;
  c.length > $e ? c = we(c) : c.length < $e && (c = Buffer$l.concat([c, ZEROS], $e));
  for (var Me = Buffer$l.allocUnsafe($e + sizes[m]), Ze = Buffer$l.allocUnsafe($e + sizes[m]), ne = 0; ne < $e; ne++)
    Me[ne] = c[ne] ^ 54, Ze[ne] = c[ne] ^ 92;
  var rr = Buffer$l.allocUnsafe($e + ie + 4);
  Me.copy(rr, 0, 0, $e), this.ipad1 = rr, this.ipad2 = Me, this.opad = Ze, this.alg = m, this.blocksize = $e, this.hash = we, this.size = sizes[m];
}
Hmac$1.prototype.run = function(m, c) {
  m.copy(c, this.blocksize);
  var ie = this.hash(c);
  return ie.copy(this.opad, this.blocksize), this.hash(this.opad);
};
function getDigest(m) {
  function c(we) {
    return sha$1(m).update(we).digest();
  }
  function ie(we) {
    return new RIPEMD160$1().update(we).digest();
  }
  return m === "rmd160" || m === "ripemd160" ? ie : m === "md5" ? md5 : c;
}
function pbkdf2(m, c, ie, we, $e) {
  checkParameters$1(ie, we), m = toBuffer$1(m, defaultEncoding$1, "Password"), c = toBuffer$1(c, defaultEncoding$1, "Salt"), $e = $e || "sha1";
  var Me = new Hmac$1($e, m, c.length), Ze = Buffer$l.allocUnsafe(we), ne = Buffer$l.allocUnsafe(c.length + 4);
  c.copy(ne, 0, 0, c.length);
  for (var rr = 0, gr = sizes[$e], or = Math.ceil(we / gr), _r = 1; _r <= or; _r++) {
    ne.writeUInt32BE(_r, c.length);
    for (var Lr = Me.run(ne, Me.ipad1), Ir = Lr, Ar = 1; Ar < ie; Ar++) {
      Ir = Me.run(Ir, Me.ipad2);
      for (var Rr = 0; Rr < gr; Rr++)
        Lr[Rr] ^= Ir[Rr];
    }
    Lr.copy(Ze, rr), rr += gr;
  }
  return Ze;
}
var syncBrowser = pbkdf2, Buffer$k = safeBuffer$2.exports.Buffer, checkParameters = precondition, defaultEncoding = defaultEncoding_1, sync = syncBrowser, toBuffer = toBuffer$2, ZERO_BUF, subtle = commonjsGlobal.crypto && commonjsGlobal.crypto.subtle, toBrowser = {
  sha: "SHA-1",
  "sha-1": "SHA-1",
  sha1: "SHA-1",
  sha256: "SHA-256",
  "sha-256": "SHA-256",
  sha384: "SHA-384",
  "sha-384": "SHA-384",
  "sha-512": "SHA-512",
  sha512: "SHA-512"
}, checks = [];
function checkNative(m) {
  if (commonjsGlobal.process && !commonjsGlobal.process.browser || !subtle || !subtle.importKey || !subtle.deriveBits)
    return Promise.resolve(!1);
  if (checks[m] !== void 0)
    return checks[m];
  ZERO_BUF = ZERO_BUF || Buffer$k.alloc(8);
  var c = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, m).then(function() {
    return !0;
  }).catch(function() {
    return !1;
  });
  return checks[m] = c, c;
}
var nextTick$2;
function getNextTick() {
  return nextTick$2 || (commonjsGlobal.process && commonjsGlobal.process.nextTick ? nextTick$2 = commonjsGlobal.process.nextTick : commonjsGlobal.queueMicrotask ? nextTick$2 = commonjsGlobal.queueMicrotask : commonjsGlobal.setImmediate ? nextTick$2 = commonjsGlobal.setImmediate : nextTick$2 = commonjsGlobal.setTimeout, nextTick$2);
}
function browserPbkdf2(m, c, ie, we, $e) {
  return subtle.importKey(
    "raw",
    m,
    { name: "PBKDF2" },
    !1,
    ["deriveBits"]
  ).then(function(Me) {
    return subtle.deriveBits({
      name: "PBKDF2",
      salt: c,
      iterations: ie,
      hash: {
        name: $e
      }
    }, Me, we << 3);
  }).then(function(Me) {
    return Buffer$k.from(Me);
  });
}
function resolvePromise(m, c) {
  m.then(function(ie) {
    getNextTick()(function() {
      c(null, ie);
    });
  }, function(ie) {
    getNextTick()(function() {
      c(ie);
    });
  });
}
var async = function(m, c, ie, we, $e, Me) {
  typeof $e == "function" && (Me = $e, $e = void 0), $e = $e || "sha1";
  var Ze = toBrowser[$e.toLowerCase()];
  if (!Ze || typeof commonjsGlobal.Promise != "function") {
    getNextTick()(function() {
      var ne;
      try {
        ne = sync(m, c, ie, we, $e);
      } catch (rr) {
        return Me(rr);
      }
      Me(null, ne);
    });
    return;
  }
  if (checkParameters(ie, we), m = toBuffer(m, defaultEncoding, "Password"), c = toBuffer(c, defaultEncoding, "Salt"), typeof Me != "function")
    throw new Error("No callback provided to pbkdf2");
  resolvePromise(checkNative(Ze).then(function(ne) {
    return ne ? browserPbkdf2(m, c, ie, we, Ze) : sync(m, c, ie, we, $e);
  }), Me);
};
browser$8.pbkdf2 = async;
browser$8.pbkdf2Sync = syncBrowser;
var browser$7 = {}, des$2 = {}, utils$q = {};
utils$q.readUInt32BE = function(c, ie) {
  var we = c[0 + ie] << 24 | c[1 + ie] << 16 | c[2 + ie] << 8 | c[3 + ie];
  return we >>> 0;
};
utils$q.writeUInt32BE = function(c, ie, we) {
  c[0 + we] = ie >>> 24, c[1 + we] = ie >>> 16 & 255, c[2 + we] = ie >>> 8 & 255, c[3 + we] = ie & 255;
};
utils$q.ip = function(c, ie, we, $e) {
  for (var Me = 0, Ze = 0, ne = 6; ne >= 0; ne -= 2) {
    for (var rr = 0; rr <= 24; rr += 8)
      Me <<= 1, Me |= ie >>> rr + ne & 1;
    for (var rr = 0; rr <= 24; rr += 8)
      Me <<= 1, Me |= c >>> rr + ne & 1;
  }
  for (var ne = 6; ne >= 0; ne -= 2) {
    for (var rr = 1; rr <= 25; rr += 8)
      Ze <<= 1, Ze |= ie >>> rr + ne & 1;
    for (var rr = 1; rr <= 25; rr += 8)
      Ze <<= 1, Ze |= c >>> rr + ne & 1;
  }
  we[$e + 0] = Me >>> 0, we[$e + 1] = Ze >>> 0;
};
utils$q.rip = function(c, ie, we, $e) {
  for (var Me = 0, Ze = 0, ne = 0; ne < 4; ne++)
    for (var rr = 24; rr >= 0; rr -= 8)
      Me <<= 1, Me |= ie >>> rr + ne & 1, Me <<= 1, Me |= c >>> rr + ne & 1;
  for (var ne = 4; ne < 8; ne++)
    for (var rr = 24; rr >= 0; rr -= 8)
      Ze <<= 1, Ze |= ie >>> rr + ne & 1, Ze <<= 1, Ze |= c >>> rr + ne & 1;
  we[$e + 0] = Me >>> 0, we[$e + 1] = Ze >>> 0;
};
utils$q.pc1 = function(c, ie, we, $e) {
  for (var Me = 0, Ze = 0, ne = 7; ne >= 5; ne--) {
    for (var rr = 0; rr <= 24; rr += 8)
      Me <<= 1, Me |= ie >> rr + ne & 1;
    for (var rr = 0; rr <= 24; rr += 8)
      Me <<= 1, Me |= c >> rr + ne & 1;
  }
  for (var rr = 0; rr <= 24; rr += 8)
    Me <<= 1, Me |= ie >> rr + ne & 1;
  for (var ne = 1; ne <= 3; ne++) {
    for (var rr = 0; rr <= 24; rr += 8)
      Ze <<= 1, Ze |= ie >> rr + ne & 1;
    for (var rr = 0; rr <= 24; rr += 8)
      Ze <<= 1, Ze |= c >> rr + ne & 1;
  }
  for (var rr = 0; rr <= 24; rr += 8)
    Ze <<= 1, Ze |= c >> rr + ne & 1;
  we[$e + 0] = Me >>> 0, we[$e + 1] = Ze >>> 0;
};
utils$q.r28shl = function(c, ie) {
  return c << ie & 268435455 | c >>> 28 - ie;
};
var pc2table = [
  14,
  11,
  17,
  4,
  27,
  23,
  25,
  0,
  13,
  22,
  7,
  18,
  5,
  9,
  16,
  24,
  2,
  20,
  12,
  21,
  1,
  8,
  15,
  26,
  15,
  4,
  25,
  19,
  9,
  1,
  26,
  16,
  5,
  11,
  23,
  8,
  12,
  7,
  17,
  0,
  22,
  3,
  10,
  14,
  6,
  20,
  27,
  24
];
utils$q.pc2 = function(c, ie, we, $e) {
  for (var Me = 0, Ze = 0, ne = pc2table.length >>> 1, rr = 0; rr < ne; rr++)
    Me <<= 1, Me |= c >>> pc2table[rr] & 1;
  for (var rr = ne; rr < pc2table.length; rr++)
    Ze <<= 1, Ze |= ie >>> pc2table[rr] & 1;
  we[$e + 0] = Me >>> 0, we[$e + 1] = Ze >>> 0;
};
utils$q.expand = function(c, ie, we) {
  var $e = 0, Me = 0;
  $e = (c & 1) << 5 | c >>> 27;
  for (var Ze = 23; Ze >= 15; Ze -= 4)
    $e <<= 6, $e |= c >>> Ze & 63;
  for (var Ze = 11; Ze >= 3; Ze -= 4)
    Me |= c >>> Ze & 63, Me <<= 6;
  Me |= (c & 31) << 1 | c >>> 31, ie[we + 0] = $e >>> 0, ie[we + 1] = Me >>> 0;
};
var sTable = [
  14,
  0,
  4,
  15,
  13,
  7,
  1,
  4,
  2,
  14,
  15,
  2,
  11,
  13,
  8,
  1,
  3,
  10,
  10,
  6,
  6,
  12,
  12,
  11,
  5,
  9,
  9,
  5,
  0,
  3,
  7,
  8,
  4,
  15,
  1,
  12,
  14,
  8,
  8,
  2,
  13,
  4,
  6,
  9,
  2,
  1,
  11,
  7,
  15,
  5,
  12,
  11,
  9,
  3,
  7,
  14,
  3,
  10,
  10,
  0,
  5,
  6,
  0,
  13,
  15,
  3,
  1,
  13,
  8,
  4,
  14,
  7,
  6,
  15,
  11,
  2,
  3,
  8,
  4,
  14,
  9,
  12,
  7,
  0,
  2,
  1,
  13,
  10,
  12,
  6,
  0,
  9,
  5,
  11,
  10,
  5,
  0,
  13,
  14,
  8,
  7,
  10,
  11,
  1,
  10,
  3,
  4,
  15,
  13,
  4,
  1,
  2,
  5,
  11,
  8,
  6,
  12,
  7,
  6,
  12,
  9,
  0,
  3,
  5,
  2,
  14,
  15,
  9,
  10,
  13,
  0,
  7,
  9,
  0,
  14,
  9,
  6,
  3,
  3,
  4,
  15,
  6,
  5,
  10,
  1,
  2,
  13,
  8,
  12,
  5,
  7,
  14,
  11,
  12,
  4,
  11,
  2,
  15,
  8,
  1,
  13,
  1,
  6,
  10,
  4,
  13,
  9,
  0,
  8,
  6,
  15,
  9,
  3,
  8,
  0,
  7,
  11,
  4,
  1,
  15,
  2,
  14,
  12,
  3,
  5,
  11,
  10,
  5,
  14,
  2,
  7,
  12,
  7,
  13,
  13,
  8,
  14,
  11,
  3,
  5,
  0,
  6,
  6,
  15,
  9,
  0,
  10,
  3,
  1,
  4,
  2,
  7,
  8,
  2,
  5,
  12,
  11,
  1,
  12,
  10,
  4,
  14,
  15,
  9,
  10,
  3,
  6,
  15,
  9,
  0,
  0,
  6,
  12,
  10,
  11,
  1,
  7,
  13,
  13,
  8,
  15,
  9,
  1,
  4,
  3,
  5,
  14,
  11,
  5,
  12,
  2,
  7,
  8,
  2,
  4,
  14,
  2,
  14,
  12,
  11,
  4,
  2,
  1,
  12,
  7,
  4,
  10,
  7,
  11,
  13,
  6,
  1,
  8,
  5,
  5,
  0,
  3,
  15,
  15,
  10,
  13,
  3,
  0,
  9,
  14,
  8,
  9,
  6,
  4,
  11,
  2,
  8,
  1,
  12,
  11,
  7,
  10,
  1,
  13,
  14,
  7,
  2,
  8,
  13,
  15,
  6,
  9,
  15,
  12,
  0,
  5,
  9,
  6,
  10,
  3,
  4,
  0,
  5,
  14,
  3,
  12,
  10,
  1,
  15,
  10,
  4,
  15,
  2,
  9,
  7,
  2,
  12,
  6,
  9,
  8,
  5,
  0,
  6,
  13,
  1,
  3,
  13,
  4,
  14,
  14,
  0,
  7,
  11,
  5,
  3,
  11,
  8,
  9,
  4,
  14,
  3,
  15,
  2,
  5,
  12,
  2,
  9,
  8,
  5,
  12,
  15,
  3,
  10,
  7,
  11,
  0,
  14,
  4,
  1,
  10,
  7,
  1,
  6,
  13,
  0,
  11,
  8,
  6,
  13,
  4,
  13,
  11,
  0,
  2,
  11,
  14,
  7,
  15,
  4,
  0,
  9,
  8,
  1,
  13,
  10,
  3,
  14,
  12,
  3,
  9,
  5,
  7,
  12,
  5,
  2,
  10,
  15,
  6,
  8,
  1,
  6,
  1,
  6,
  4,
  11,
  11,
  13,
  13,
  8,
  12,
  1,
  3,
  4,
  7,
  10,
  14,
  7,
  10,
  9,
  15,
  5,
  6,
  0,
  8,
  15,
  0,
  14,
  5,
  2,
  9,
  3,
  2,
  12,
  13,
  1,
  2,
  15,
  8,
  13,
  4,
  8,
  6,
  10,
  15,
  3,
  11,
  7,
  1,
  4,
  10,
  12,
  9,
  5,
  3,
  6,
  14,
  11,
  5,
  0,
  0,
  14,
  12,
  9,
  7,
  2,
  7,
  2,
  11,
  1,
  4,
  14,
  1,
  7,
  9,
  4,
  12,
  10,
  14,
  8,
  2,
  13,
  0,
  15,
  6,
  12,
  10,
  9,
  13,
  0,
  15,
  3,
  3,
  5,
  5,
  6,
  8,
  11
];
utils$q.substitute = function(c, ie) {
  for (var we = 0, $e = 0; $e < 4; $e++) {
    var Me = c >>> 18 - $e * 6 & 63, Ze = sTable[$e * 64 + Me];
    we <<= 4, we |= Ze;
  }
  for (var $e = 0; $e < 4; $e++) {
    var Me = ie >>> 18 - $e * 6 & 63, Ze = sTable[4 * 64 + $e * 64 + Me];
    we <<= 4, we |= Ze;
  }
  return we >>> 0;
};
var permuteTable = [
  16,
  25,
  12,
  11,
  3,
  20,
  4,
  15,
  31,
  17,
  9,
  6,
  27,
  14,
  1,
  22,
  30,
  24,
  8,
  18,
  0,
  5,
  29,
  23,
  13,
  19,
  2,
  26,
  10,
  21,
  28,
  7
];
utils$q.permute = function(c) {
  for (var ie = 0, we = 0; we < permuteTable.length; we++)
    ie <<= 1, ie |= c >>> permuteTable[we] & 1;
  return ie >>> 0;
};
utils$q.padSplit = function(c, ie, we) {
  for (var $e = c.toString(2); $e.length < ie; )
    $e = "0" + $e;
  for (var Me = [], Ze = 0; Ze < ie; Ze += we)
    Me.push($e.slice(Ze, Ze + we));
  return Me.join(" ");
};
var minimalisticAssert = assert$i;
function assert$i(m, c) {
  if (!m)
    throw new Error(c || "Assertion failed");
}
assert$i.equal = function(c, ie, we) {
  if (c != ie)
    throw new Error(we || "Assertion failed: " + c + " != " + ie);
};
var assert$h = minimalisticAssert;
function Cipher$3(m) {
  this.options = m, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = m.padding !== !1;
}
var cipher = Cipher$3;
Cipher$3.prototype._init = function() {
};
Cipher$3.prototype.update = function(c) {
  return c.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(c) : this._updateEncrypt(c);
};
Cipher$3.prototype._buffer = function(c, ie) {
  for (var we = Math.min(this.buffer.length - this.bufferOff, c.length - ie), $e = 0; $e < we; $e++)
    this.buffer[this.bufferOff + $e] = c[ie + $e];
  return this.bufferOff += we, we;
};
Cipher$3.prototype._flushBuffer = function(c, ie) {
  return this._update(this.buffer, 0, c, ie), this.bufferOff = 0, this.blockSize;
};
Cipher$3.prototype._updateEncrypt = function(c) {
  var ie = 0, we = 0, $e = (this.bufferOff + c.length) / this.blockSize | 0, Me = new Array($e * this.blockSize);
  this.bufferOff !== 0 && (ie += this._buffer(c, ie), this.bufferOff === this.buffer.length && (we += this._flushBuffer(Me, we)));
  for (var Ze = c.length - (c.length - ie) % this.blockSize; ie < Ze; ie += this.blockSize)
    this._update(c, ie, Me, we), we += this.blockSize;
  for (; ie < c.length; ie++, this.bufferOff++)
    this.buffer[this.bufferOff] = c[ie];
  return Me;
};
Cipher$3.prototype._updateDecrypt = function(c) {
  for (var ie = 0, we = 0, $e = Math.ceil((this.bufferOff + c.length) / this.blockSize) - 1, Me = new Array($e * this.blockSize); $e > 0; $e--)
    ie += this._buffer(c, ie), we += this._flushBuffer(Me, we);
  return ie += this._buffer(c, ie), Me;
};
Cipher$3.prototype.final = function(c) {
  var ie;
  c && (ie = this.update(c));
  var we;
  return this.type === "encrypt" ? we = this._finalEncrypt() : we = this._finalDecrypt(), ie ? ie.concat(we) : we;
};
Cipher$3.prototype._pad = function(c, ie) {
  if (ie === 0)
    return !1;
  for (; ie < c.length; )
    c[ie++] = 0;
  return !0;
};
Cipher$3.prototype._finalEncrypt = function() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];
  var c = new Array(this.blockSize);
  return this._update(this.buffer, 0, c, 0), c;
};
Cipher$3.prototype._unpad = function(c) {
  return c;
};
Cipher$3.prototype._finalDecrypt = function() {
  assert$h.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
  var c = new Array(this.blockSize);
  return this._flushBuffer(c, 0), this._unpad(c);
};
var assert$g = minimalisticAssert, inherits$e = inherits_browser.exports, utils$p = utils$q, Cipher$2 = cipher;
function DESState() {
  this.tmp = new Array(2), this.keys = null;
}
function DES$3(m) {
  Cipher$2.call(this, m);
  var c = new DESState();
  this._desState = c, this.deriveKeys(c, m.key);
}
inherits$e(DES$3, Cipher$2);
var des$1 = DES$3;
DES$3.create = function(c) {
  return new DES$3(c);
};
var shiftTable = [
  1,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  1
];
DES$3.prototype.deriveKeys = function(c, ie) {
  c.keys = new Array(16 * 2), assert$g.equal(ie.length, this.blockSize, "Invalid key length");
  var we = utils$p.readUInt32BE(ie, 0), $e = utils$p.readUInt32BE(ie, 4);
  utils$p.pc1(we, $e, c.tmp, 0), we = c.tmp[0], $e = c.tmp[1];
  for (var Me = 0; Me < c.keys.length; Me += 2) {
    var Ze = shiftTable[Me >>> 1];
    we = utils$p.r28shl(we, Ze), $e = utils$p.r28shl($e, Ze), utils$p.pc2(we, $e, c.keys, Me);
  }
};
DES$3.prototype._update = function(c, ie, we, $e) {
  var Me = this._desState, Ze = utils$p.readUInt32BE(c, ie), ne = utils$p.readUInt32BE(c, ie + 4);
  utils$p.ip(Ze, ne, Me.tmp, 0), Ze = Me.tmp[0], ne = Me.tmp[1], this.type === "encrypt" ? this._encrypt(Me, Ze, ne, Me.tmp, 0) : this._decrypt(Me, Ze, ne, Me.tmp, 0), Ze = Me.tmp[0], ne = Me.tmp[1], utils$p.writeUInt32BE(we, Ze, $e), utils$p.writeUInt32BE(we, ne, $e + 4);
};
DES$3.prototype._pad = function(c, ie) {
  if (this.padding === !1)
    return !1;
  for (var we = c.length - ie, $e = ie; $e < c.length; $e++)
    c[$e] = we;
  return !0;
};
DES$3.prototype._unpad = function(c) {
  if (this.padding === !1)
    return c;
  for (var ie = c[c.length - 1], we = c.length - ie; we < c.length; we++)
    assert$g.equal(c[we], ie);
  return c.slice(0, c.length - ie);
};
DES$3.prototype._encrypt = function(c, ie, we, $e, Me) {
  for (var Ze = ie, ne = we, rr = 0; rr < c.keys.length; rr += 2) {
    var gr = c.keys[rr], or = c.keys[rr + 1];
    utils$p.expand(ne, c.tmp, 0), gr ^= c.tmp[0], or ^= c.tmp[1];
    var _r = utils$p.substitute(gr, or), Lr = utils$p.permute(_r), Ir = ne;
    ne = (Ze ^ Lr) >>> 0, Ze = Ir;
  }
  utils$p.rip(ne, Ze, $e, Me);
};
DES$3.prototype._decrypt = function(c, ie, we, $e, Me) {
  for (var Ze = we, ne = ie, rr = c.keys.length - 2; rr >= 0; rr -= 2) {
    var gr = c.keys[rr], or = c.keys[rr + 1];
    utils$p.expand(Ze, c.tmp, 0), gr ^= c.tmp[0], or ^= c.tmp[1];
    var _r = utils$p.substitute(gr, or), Lr = utils$p.permute(_r), Ir = Ze;
    Ze = (ne ^ Lr) >>> 0, ne = Ir;
  }
  utils$p.rip(Ze, ne, $e, Me);
};
var cbc$1 = {}, assert$f = minimalisticAssert, inherits$d = inherits_browser.exports, proto = {};
function CBCState(m) {
  assert$f.equal(m.length, 8, "Invalid IV length"), this.iv = new Array(8);
  for (var c = 0; c < this.iv.length; c++)
    this.iv[c] = m[c];
}
function instantiate(m) {
  function c(Me) {
    m.call(this, Me), this._cbcInit();
  }
  inherits$d(c, m);
  for (var ie = Object.keys(proto), we = 0; we < ie.length; we++) {
    var $e = ie[we];
    c.prototype[$e] = proto[$e];
  }
  return c.create = function(Ze) {
    return new c(Ze);
  }, c;
}
cbc$1.instantiate = instantiate;
proto._cbcInit = function() {
  var c = new CBCState(this.options.iv);
  this._cbcState = c;
};
proto._update = function(c, ie, we, $e) {
  var Me = this._cbcState, Ze = this.constructor.super_.prototype, ne = Me.iv;
  if (this.type === "encrypt") {
    for (var rr = 0; rr < this.blockSize; rr++)
      ne[rr] ^= c[ie + rr];
    Ze._update.call(this, ne, 0, we, $e);
    for (var rr = 0; rr < this.blockSize; rr++)
      ne[rr] = we[$e + rr];
  } else {
    Ze._update.call(this, c, ie, we, $e);
    for (var rr = 0; rr < this.blockSize; rr++)
      we[$e + rr] ^= ne[rr];
    for (var rr = 0; rr < this.blockSize; rr++)
      ne[rr] = c[ie + rr];
  }
};
var assert$e = minimalisticAssert, inherits$c = inherits_browser.exports, Cipher$1 = cipher, DES$2 = des$1;
function EDEState(m, c) {
  assert$e.equal(c.length, 24, "Invalid key length");
  var ie = c.slice(0, 8), we = c.slice(8, 16), $e = c.slice(16, 24);
  m === "encrypt" ? this.ciphers = [
    DES$2.create({ type: "encrypt", key: ie }),
    DES$2.create({ type: "decrypt", key: we }),
    DES$2.create({ type: "encrypt", key: $e })
  ] : this.ciphers = [
    DES$2.create({ type: "decrypt", key: $e }),
    DES$2.create({ type: "encrypt", key: we }),
    DES$2.create({ type: "decrypt", key: ie })
  ];
}
function EDE(m) {
  Cipher$1.call(this, m);
  var c = new EDEState(this.type, this.options.key);
  this._edeState = c;
}
inherits$c(EDE, Cipher$1);
var ede = EDE;
EDE.create = function(c) {
  return new EDE(c);
};
EDE.prototype._update = function(c, ie, we, $e) {
  var Me = this._edeState;
  Me.ciphers[0]._update(c, ie, we, $e), Me.ciphers[1]._update(we, $e, we, $e), Me.ciphers[2]._update(we, $e, we, $e);
};
EDE.prototype._pad = DES$2.prototype._pad;
EDE.prototype._unpad = DES$2.prototype._unpad;
des$2.utils = utils$q;
des$2.Cipher = cipher;
des$2.DES = des$1;
des$2.CBC = cbc$1;
des$2.EDE = ede;
var CipherBase = cipherBase, des = des$2, inherits$b = inherits_browser.exports, Buffer$j = safeBuffer$2.exports.Buffer, modes$3 = {
  "des-ede3-cbc": des.CBC.instantiate(des.EDE),
  "des-ede3": des.EDE,
  "des-ede-cbc": des.CBC.instantiate(des.EDE),
  "des-ede": des.EDE,
  "des-cbc": des.CBC.instantiate(des.DES),
  "des-ecb": des.DES
};
modes$3.des = modes$3["des-cbc"];
modes$3.des3 = modes$3["des-ede3-cbc"];
var browserifyDes = DES$1;
inherits$b(DES$1, CipherBase);
function DES$1(m) {
  CipherBase.call(this);
  var c = m.mode.toLowerCase(), ie = modes$3[c], we;
  m.decrypt ? we = "decrypt" : we = "encrypt";
  var $e = m.key;
  Buffer$j.isBuffer($e) || ($e = Buffer$j.from($e)), (c === "des-ede" || c === "des-ede-cbc") && ($e = Buffer$j.concat([$e, $e.slice(0, 8)]));
  var Me = m.iv;
  Buffer$j.isBuffer(Me) || (Me = Buffer$j.from(Me)), this._des = ie.create({
    key: $e,
    iv: Me,
    type: we
  });
}
DES$1.prototype._update = function(m) {
  return Buffer$j.from(this._des.update(m));
};
DES$1.prototype._final = function() {
  return Buffer$j.from(this._des.final());
};
var browser$6 = {}, encrypter = {}, ecb = {};
ecb.encrypt = function(m, c) {
  return m._cipher.encryptBlock(c);
};
ecb.decrypt = function(m, c) {
  return m._cipher.decryptBlock(c);
};
var cbc = {}, bufferXor = function(c, ie) {
  for (var we = Math.min(c.length, ie.length), $e = new Buffer$C(we), Me = 0; Me < we; ++Me)
    $e[Me] = c[Me] ^ ie[Me];
  return $e;
}, xor$7 = bufferXor;
cbc.encrypt = function(m, c) {
  var ie = xor$7(c, m._prev);
  return m._prev = m._cipher.encryptBlock(ie), m._prev;
};
cbc.decrypt = function(m, c) {
  var ie = m._prev;
  m._prev = c;
  var we = m._cipher.decryptBlock(c);
  return xor$7(we, ie);
};
var cfb = {}, Buffer$i = safeBuffer$2.exports.Buffer, xor$6 = bufferXor;
function encryptStart(m, c, ie) {
  var we = c.length, $e = xor$6(c, m._cache);
  return m._cache = m._cache.slice(we), m._prev = Buffer$i.concat([m._prev, ie ? c : $e]), $e;
}
cfb.encrypt = function(m, c, ie) {
  for (var we = Buffer$i.allocUnsafe(0), $e; c.length; )
    if (m._cache.length === 0 && (m._cache = m._cipher.encryptBlock(m._prev), m._prev = Buffer$i.allocUnsafe(0)), m._cache.length <= c.length)
      $e = m._cache.length, we = Buffer$i.concat([we, encryptStart(m, c.slice(0, $e), ie)]), c = c.slice($e);
    else {
      we = Buffer$i.concat([we, encryptStart(m, c, ie)]);
      break;
    }
  return we;
};
var cfb8 = {}, Buffer$h = safeBuffer$2.exports.Buffer;
function encryptByte$1(m, c, ie) {
  var we = m._cipher.encryptBlock(m._prev), $e = we[0] ^ c;
  return m._prev = Buffer$h.concat([
    m._prev.slice(1),
    Buffer$h.from([ie ? c : $e])
  ]), $e;
}
cfb8.encrypt = function(m, c, ie) {
  for (var we = c.length, $e = Buffer$h.allocUnsafe(we), Me = -1; ++Me < we; )
    $e[Me] = encryptByte$1(m, c[Me], ie);
  return $e;
};
var cfb1 = {}, Buffer$g = safeBuffer$2.exports.Buffer;
function encryptByte(m, c, ie) {
  for (var we, $e = -1, Me = 8, Ze = 0, ne, rr; ++$e < Me; )
    we = m._cipher.encryptBlock(m._prev), ne = c & 1 << 7 - $e ? 128 : 0, rr = we[0] ^ ne, Ze += (rr & 128) >> $e % 8, m._prev = shiftIn(m._prev, ie ? ne : rr);
  return Ze;
}
function shiftIn(m, c) {
  var ie = m.length, we = -1, $e = Buffer$g.allocUnsafe(m.length);
  for (m = Buffer$g.concat([m, Buffer$g.from([c])]); ++we < ie; )
    $e[we] = m[we] << 1 | m[we + 1] >> 7;
  return $e;
}
cfb1.encrypt = function(m, c, ie) {
  for (var we = c.length, $e = Buffer$g.allocUnsafe(we), Me = -1; ++Me < we; )
    $e[Me] = encryptByte(m, c[Me], ie);
  return $e;
};
var ofb = {}, xor$5 = bufferXor;
function getBlock$1(m) {
  return m._prev = m._cipher.encryptBlock(m._prev), m._prev;
}
ofb.encrypt = function(m, c) {
  for (; m._cache.length < c.length; )
    m._cache = Buffer$C.concat([m._cache, getBlock$1(m)]);
  var ie = m._cache.slice(0, c.length);
  return m._cache = m._cache.slice(c.length), xor$5(c, ie);
};
var ctr = {};
function incr32$2(m) {
  for (var c = m.length, ie; c--; )
    if (ie = m.readUInt8(c), ie === 255)
      m.writeUInt8(0, c);
    else {
      ie++, m.writeUInt8(ie, c);
      break;
    }
}
var incr32_1 = incr32$2, xor$4 = bufferXor, Buffer$f = safeBuffer$2.exports.Buffer, incr32$1 = incr32_1;
function getBlock(m) {
  var c = m._cipher.encryptBlockRaw(m._prev);
  return incr32$1(m._prev), c;
}
var blockSize = 16;
ctr.encrypt = function(m, c) {
  var ie = Math.ceil(c.length / blockSize), we = m._cache.length;
  m._cache = Buffer$f.concat([
    m._cache,
    Buffer$f.allocUnsafe(ie * blockSize)
  ]);
  for (var $e = 0; $e < ie; $e++) {
    var Me = getBlock(m), Ze = we + $e * blockSize;
    m._cache.writeUInt32BE(Me[0], Ze + 0), m._cache.writeUInt32BE(Me[1], Ze + 4), m._cache.writeUInt32BE(Me[2], Ze + 8), m._cache.writeUInt32BE(Me[3], Ze + 12);
  }
  var ne = m._cache.slice(0, c.length);
  return m._cache = m._cache.slice(c.length), xor$4(c, ne);
};
const aes128 = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes192 = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes256 = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, require$$2$1 = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128,
  aes192,
  aes256,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var modeModules = {
  ECB: ecb,
  CBC: cbc,
  CFB: cfb,
  CFB8: cfb8,
  CFB1: cfb1,
  OFB: ofb,
  CTR: ctr,
  GCM: ctr
}, modes$2 = require$$2$1;
for (var key$2 in modes$2)
  modes$2[key$2].module = modeModules[modes$2[key$2].mode];
var modes_1 = modes$2, aes$5 = {}, Buffer$e = safeBuffer$2.exports.Buffer;
function asUInt32Array(m) {
  Buffer$e.isBuffer(m) || (m = Buffer$e.from(m));
  for (var c = m.length / 4 | 0, ie = new Array(c), we = 0; we < c; we++)
    ie[we] = m.readUInt32BE(we * 4);
  return ie;
}
function scrubVec(m) {
  for (var c = 0; c < m.length; m++)
    m[c] = 0;
}
function cryptBlock(m, c, ie, we, $e) {
  for (var Me = ie[0], Ze = ie[1], ne = ie[2], rr = ie[3], gr = m[0] ^ c[0], or = m[1] ^ c[1], _r = m[2] ^ c[2], Lr = m[3] ^ c[3], Ir, Ar, Rr, Nr, Yr = 4, Vr = 1; Vr < $e; Vr++)
    Ir = Me[gr >>> 24] ^ Ze[or >>> 16 & 255] ^ ne[_r >>> 8 & 255] ^ rr[Lr & 255] ^ c[Yr++], Ar = Me[or >>> 24] ^ Ze[_r >>> 16 & 255] ^ ne[Lr >>> 8 & 255] ^ rr[gr & 255] ^ c[Yr++], Rr = Me[_r >>> 24] ^ Ze[Lr >>> 16 & 255] ^ ne[gr >>> 8 & 255] ^ rr[or & 255] ^ c[Yr++], Nr = Me[Lr >>> 24] ^ Ze[gr >>> 16 & 255] ^ ne[or >>> 8 & 255] ^ rr[_r & 255] ^ c[Yr++], gr = Ir, or = Ar, _r = Rr, Lr = Nr;
  return Ir = (we[gr >>> 24] << 24 | we[or >>> 16 & 255] << 16 | we[_r >>> 8 & 255] << 8 | we[Lr & 255]) ^ c[Yr++], Ar = (we[or >>> 24] << 24 | we[_r >>> 16 & 255] << 16 | we[Lr >>> 8 & 255] << 8 | we[gr & 255]) ^ c[Yr++], Rr = (we[_r >>> 24] << 24 | we[Lr >>> 16 & 255] << 16 | we[gr >>> 8 & 255] << 8 | we[or & 255]) ^ c[Yr++], Nr = (we[Lr >>> 24] << 24 | we[gr >>> 16 & 255] << 16 | we[or >>> 8 & 255] << 8 | we[_r & 255]) ^ c[Yr++], Ir = Ir >>> 0, Ar = Ar >>> 0, Rr = Rr >>> 0, Nr = Nr >>> 0, [Ir, Ar, Rr, Nr];
}
var RCON = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], G$1 = function() {
  for (var m = new Array(256), c = 0; c < 256; c++)
    c < 128 ? m[c] = c << 1 : m[c] = c << 1 ^ 283;
  for (var ie = [], we = [], $e = [[], [], [], []], Me = [[], [], [], []], Ze = 0, ne = 0, rr = 0; rr < 256; ++rr) {
    var gr = ne ^ ne << 1 ^ ne << 2 ^ ne << 3 ^ ne << 4;
    gr = gr >>> 8 ^ gr & 255 ^ 99, ie[Ze] = gr, we[gr] = Ze;
    var or = m[Ze], _r = m[or], Lr = m[_r], Ir = m[gr] * 257 ^ gr * 16843008;
    $e[0][Ze] = Ir << 24 | Ir >>> 8, $e[1][Ze] = Ir << 16 | Ir >>> 16, $e[2][Ze] = Ir << 8 | Ir >>> 24, $e[3][Ze] = Ir, Ir = Lr * 16843009 ^ _r * 65537 ^ or * 257 ^ Ze * 16843008, Me[0][gr] = Ir << 24 | Ir >>> 8, Me[1][gr] = Ir << 16 | Ir >>> 16, Me[2][gr] = Ir << 8 | Ir >>> 24, Me[3][gr] = Ir, Ze === 0 ? Ze = ne = 1 : (Ze = or ^ m[m[m[Lr ^ or]]], ne ^= m[m[ne]]);
  }
  return {
    SBOX: ie,
    INV_SBOX: we,
    SUB_MIX: $e,
    INV_SUB_MIX: Me
  };
}();
function AES(m) {
  this._key = asUInt32Array(m), this._reset();
}
AES.blockSize = 4 * 4;
AES.keySize = 256 / 8;
AES.prototype.blockSize = AES.blockSize;
AES.prototype.keySize = AES.keySize;
AES.prototype._reset = function() {
  for (var m = this._key, c = m.length, ie = c + 6, we = (ie + 1) * 4, $e = [], Me = 0; Me < c; Me++)
    $e[Me] = m[Me];
  for (Me = c; Me < we; Me++) {
    var Ze = $e[Me - 1];
    Me % c === 0 ? (Ze = Ze << 8 | Ze >>> 24, Ze = G$1.SBOX[Ze >>> 24] << 24 | G$1.SBOX[Ze >>> 16 & 255] << 16 | G$1.SBOX[Ze >>> 8 & 255] << 8 | G$1.SBOX[Ze & 255], Ze ^= RCON[Me / c | 0] << 24) : c > 6 && Me % c === 4 && (Ze = G$1.SBOX[Ze >>> 24] << 24 | G$1.SBOX[Ze >>> 16 & 255] << 16 | G$1.SBOX[Ze >>> 8 & 255] << 8 | G$1.SBOX[Ze & 255]), $e[Me] = $e[Me - c] ^ Ze;
  }
  for (var ne = [], rr = 0; rr < we; rr++) {
    var gr = we - rr, or = $e[gr - (rr % 4 ? 0 : 4)];
    rr < 4 || gr <= 4 ? ne[rr] = or : ne[rr] = G$1.INV_SUB_MIX[0][G$1.SBOX[or >>> 24]] ^ G$1.INV_SUB_MIX[1][G$1.SBOX[or >>> 16 & 255]] ^ G$1.INV_SUB_MIX[2][G$1.SBOX[or >>> 8 & 255]] ^ G$1.INV_SUB_MIX[3][G$1.SBOX[or & 255]];
  }
  this._nRounds = ie, this._keySchedule = $e, this._invKeySchedule = ne;
};
AES.prototype.encryptBlockRaw = function(m) {
  return m = asUInt32Array(m), cryptBlock(m, this._keySchedule, G$1.SUB_MIX, G$1.SBOX, this._nRounds);
};
AES.prototype.encryptBlock = function(m) {
  var c = this.encryptBlockRaw(m), ie = Buffer$e.allocUnsafe(16);
  return ie.writeUInt32BE(c[0], 0), ie.writeUInt32BE(c[1], 4), ie.writeUInt32BE(c[2], 8), ie.writeUInt32BE(c[3], 12), ie;
};
AES.prototype.decryptBlock = function(m) {
  m = asUInt32Array(m);
  var c = m[1];
  m[1] = m[3], m[3] = c;
  var ie = cryptBlock(m, this._invKeySchedule, G$1.INV_SUB_MIX, G$1.INV_SBOX, this._nRounds), we = Buffer$e.allocUnsafe(16);
  return we.writeUInt32BE(ie[0], 0), we.writeUInt32BE(ie[3], 4), we.writeUInt32BE(ie[2], 8), we.writeUInt32BE(ie[1], 12), we;
};
AES.prototype.scrub = function() {
  scrubVec(this._keySchedule), scrubVec(this._invKeySchedule), scrubVec(this._key);
};
aes$5.AES = AES;
var Buffer$d = safeBuffer$2.exports.Buffer, ZEROES = Buffer$d.alloc(16, 0);
function toArray$1(m) {
  return [
    m.readUInt32BE(0),
    m.readUInt32BE(4),
    m.readUInt32BE(8),
    m.readUInt32BE(12)
  ];
}
function fromArray(m) {
  var c = Buffer$d.allocUnsafe(16);
  return c.writeUInt32BE(m[0] >>> 0, 0), c.writeUInt32BE(m[1] >>> 0, 4), c.writeUInt32BE(m[2] >>> 0, 8), c.writeUInt32BE(m[3] >>> 0, 12), c;
}
function GHASH$1(m) {
  this.h = m, this.state = Buffer$d.alloc(16, 0), this.cache = Buffer$d.allocUnsafe(0);
}
GHASH$1.prototype.ghash = function(m) {
  for (var c = -1; ++c < m.length; )
    this.state[c] ^= m[c];
  this._multiply();
};
GHASH$1.prototype._multiply = function() {
  for (var m = toArray$1(this.h), c = [0, 0, 0, 0], ie, we, $e, Me = -1; ++Me < 128; ) {
    for (we = (this.state[~~(Me / 8)] & 1 << 7 - Me % 8) !== 0, we && (c[0] ^= m[0], c[1] ^= m[1], c[2] ^= m[2], c[3] ^= m[3]), $e = (m[3] & 1) !== 0, ie = 3; ie > 0; ie--)
      m[ie] = m[ie] >>> 1 | (m[ie - 1] & 1) << 31;
    m[0] = m[0] >>> 1, $e && (m[0] = m[0] ^ 225 << 24);
  }
  this.state = fromArray(c);
};
GHASH$1.prototype.update = function(m) {
  this.cache = Buffer$d.concat([this.cache, m]);
  for (var c; this.cache.length >= 16; )
    c = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(c);
};
GHASH$1.prototype.final = function(m, c) {
  return this.cache.length && this.ghash(Buffer$d.concat([this.cache, ZEROES], 16)), this.ghash(fromArray([0, m, 0, c])), this.state;
};
var ghash = GHASH$1, aes$4 = aes$5, Buffer$c = safeBuffer$2.exports.Buffer, Transform$5 = cipherBase, inherits$a = inherits_browser.exports, GHASH = ghash, xor$3 = bufferXor, incr32 = incr32_1;
function xorTest(m, c) {
  var ie = 0;
  m.length !== c.length && ie++;
  for (var we = Math.min(m.length, c.length), $e = 0; $e < we; ++$e)
    ie += m[$e] ^ c[$e];
  return ie;
}
function calcIv(m, c, ie) {
  if (c.length === 12)
    return m._finID = Buffer$c.concat([c, Buffer$c.from([0, 0, 0, 1])]), Buffer$c.concat([c, Buffer$c.from([0, 0, 0, 2])]);
  var we = new GHASH(ie), $e = c.length, Me = $e % 16;
  we.update(c), Me && (Me = 16 - Me, we.update(Buffer$c.alloc(Me, 0))), we.update(Buffer$c.alloc(8, 0));
  var Ze = $e * 8, ne = Buffer$c.alloc(8);
  ne.writeUIntBE(Ze, 0, 8), we.update(ne), m._finID = we.state;
  var rr = Buffer$c.from(m._finID);
  return incr32(rr), rr;
}
function StreamCipher$3(m, c, ie, we) {
  Transform$5.call(this);
  var $e = Buffer$c.alloc(4, 0);
  this._cipher = new aes$4.AES(c);
  var Me = this._cipher.encryptBlock($e);
  this._ghash = new GHASH(Me), ie = calcIv(this, ie, Me), this._prev = Buffer$c.from(ie), this._cache = Buffer$c.allocUnsafe(0), this._secCache = Buffer$c.allocUnsafe(0), this._decrypt = we, this._alen = 0, this._len = 0, this._mode = m, this._authTag = null, this._called = !1;
}
inherits$a(StreamCipher$3, Transform$5);
StreamCipher$3.prototype._update = function(m) {
  if (!this._called && this._alen) {
    var c = 16 - this._alen % 16;
    c < 16 && (c = Buffer$c.alloc(c, 0), this._ghash.update(c));
  }
  this._called = !0;
  var ie = this._mode.encrypt(this, m);
  return this._decrypt ? this._ghash.update(m) : this._ghash.update(ie), this._len += m.length, ie;
};
StreamCipher$3.prototype._final = function() {
  if (this._decrypt && !this._authTag)
    throw new Error("Unsupported state or unable to authenticate data");
  var m = xor$3(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
  if (this._decrypt && xorTest(m, this._authTag))
    throw new Error("Unsupported state or unable to authenticate data");
  this._authTag = m, this._cipher.scrub();
};
StreamCipher$3.prototype.getAuthTag = function() {
  if (this._decrypt || !Buffer$c.isBuffer(this._authTag))
    throw new Error("Attempting to get auth tag in unsupported state");
  return this._authTag;
};
StreamCipher$3.prototype.setAuthTag = function(c) {
  if (!this._decrypt)
    throw new Error("Attempting to set auth tag in unsupported state");
  this._authTag = c;
};
StreamCipher$3.prototype.setAAD = function(c) {
  if (this._called)
    throw new Error("Attempting to set AAD in unsupported state");
  this._ghash.update(c), this._alen += c.length;
};
var authCipher = StreamCipher$3, aes$3 = aes$5, Buffer$b = safeBuffer$2.exports.Buffer, Transform$4 = cipherBase, inherits$9 = inherits_browser.exports;
function StreamCipher$2(m, c, ie, we) {
  Transform$4.call(this), this._cipher = new aes$3.AES(c), this._prev = Buffer$b.from(ie), this._cache = Buffer$b.allocUnsafe(0), this._secCache = Buffer$b.allocUnsafe(0), this._decrypt = we, this._mode = m;
}
inherits$9(StreamCipher$2, Transform$4);
StreamCipher$2.prototype._update = function(m) {
  return this._mode.encrypt(this, m, this._decrypt);
};
StreamCipher$2.prototype._final = function() {
  this._cipher.scrub();
};
var streamCipher = StreamCipher$2, Buffer$a = safeBuffer$2.exports.Buffer, MD5 = md5_js;
function EVP_BytesToKey(m, c, ie, we) {
  if (Buffer$a.isBuffer(m) || (m = Buffer$a.from(m, "binary")), c && (Buffer$a.isBuffer(c) || (c = Buffer$a.from(c, "binary")), c.length !== 8))
    throw new RangeError("salt should be Buffer with 8 byte length");
  for (var $e = ie / 8, Me = Buffer$a.alloc($e), Ze = Buffer$a.alloc(we || 0), ne = Buffer$a.alloc(0); $e > 0 || we > 0; ) {
    var rr = new MD5();
    rr.update(ne), rr.update(m), c && rr.update(c), ne = rr.digest();
    var gr = 0;
    if ($e > 0) {
      var or = Me.length - $e;
      gr = Math.min($e, ne.length), ne.copy(Me, or, 0, gr), $e -= gr;
    }
    if (gr < ne.length && we > 0) {
      var _r = Ze.length - we, Lr = Math.min(we, ne.length - gr);
      ne.copy(Ze, _r, gr, gr + Lr), we -= Lr;
    }
  }
  return ne.fill(0), { key: Me, iv: Ze };
}
var evp_bytestokey = EVP_BytesToKey, MODES$1 = modes_1, AuthCipher$1 = authCipher, Buffer$9 = safeBuffer$2.exports.Buffer, StreamCipher$1 = streamCipher, Transform$3 = cipherBase, aes$2 = aes$5, ebtk$2 = evp_bytestokey, inherits$8 = inherits_browser.exports;
function Cipher(m, c, ie) {
  Transform$3.call(this), this._cache = new Splitter$1(), this._cipher = new aes$2.AES(c), this._prev = Buffer$9.from(ie), this._mode = m, this._autopadding = !0;
}
inherits$8(Cipher, Transform$3);
Cipher.prototype._update = function(m) {
  this._cache.add(m);
  for (var c, ie, we = []; c = this._cache.get(); )
    ie = this._mode.encrypt(this, c), we.push(ie);
  return Buffer$9.concat(we);
};
var PADDING = Buffer$9.alloc(16, 16);
Cipher.prototype._final = function() {
  var m = this._cache.flush();
  if (this._autopadding)
    return m = this._mode.encrypt(this, m), this._cipher.scrub(), m;
  if (!m.equals(PADDING))
    throw this._cipher.scrub(), new Error("data not multiple of block length");
};
Cipher.prototype.setAutoPadding = function(m) {
  return this._autopadding = !!m, this;
};
function Splitter$1() {
  this.cache = Buffer$9.allocUnsafe(0);
}
Splitter$1.prototype.add = function(m) {
  this.cache = Buffer$9.concat([this.cache, m]);
};
Splitter$1.prototype.get = function() {
  if (this.cache.length > 15) {
    var m = this.cache.slice(0, 16);
    return this.cache = this.cache.slice(16), m;
  }
  return null;
};
Splitter$1.prototype.flush = function() {
  for (var m = 16 - this.cache.length, c = Buffer$9.allocUnsafe(m), ie = -1; ++ie < m; )
    c.writeUInt8(m, ie);
  return Buffer$9.concat([this.cache, c]);
};
function createCipheriv$1(m, c, ie) {
  var we = MODES$1[m.toLowerCase()];
  if (!we)
    throw new TypeError("invalid suite type");
  if (typeof c == "string" && (c = Buffer$9.from(c)), c.length !== we.key / 8)
    throw new TypeError("invalid key length " + c.length);
  if (typeof ie == "string" && (ie = Buffer$9.from(ie)), we.mode !== "GCM" && ie.length !== we.iv)
    throw new TypeError("invalid iv length " + ie.length);
  return we.type === "stream" ? new StreamCipher$1(we.module, c, ie) : we.type === "auth" ? new AuthCipher$1(we.module, c, ie) : new Cipher(we.module, c, ie);
}
function createCipher$1(m, c) {
  var ie = MODES$1[m.toLowerCase()];
  if (!ie)
    throw new TypeError("invalid suite type");
  var we = ebtk$2(c, !1, ie.key, ie.iv);
  return createCipheriv$1(m, we.key, we.iv);
}
encrypter.createCipheriv = createCipheriv$1;
encrypter.createCipher = createCipher$1;
var decrypter = {}, AuthCipher = authCipher, Buffer$8 = safeBuffer$2.exports.Buffer, MODES = modes_1, StreamCipher = streamCipher, Transform$2 = cipherBase, aes$1 = aes$5, ebtk$1 = evp_bytestokey, inherits$7 = inherits_browser.exports;
function Decipher(m, c, ie) {
  Transform$2.call(this), this._cache = new Splitter(), this._last = void 0, this._cipher = new aes$1.AES(c), this._prev = Buffer$8.from(ie), this._mode = m, this._autopadding = !0;
}
inherits$7(Decipher, Transform$2);
Decipher.prototype._update = function(m) {
  this._cache.add(m);
  for (var c, ie, we = []; c = this._cache.get(this._autopadding); )
    ie = this._mode.decrypt(this, c), we.push(ie);
  return Buffer$8.concat(we);
};
Decipher.prototype._final = function() {
  var m = this._cache.flush();
  if (this._autopadding)
    return unpad(this._mode.decrypt(this, m));
  if (m)
    throw new Error("data not multiple of block length");
};
Decipher.prototype.setAutoPadding = function(m) {
  return this._autopadding = !!m, this;
};
function Splitter() {
  this.cache = Buffer$8.allocUnsafe(0);
}
Splitter.prototype.add = function(m) {
  this.cache = Buffer$8.concat([this.cache, m]);
};
Splitter.prototype.get = function(m) {
  var c;
  if (m) {
    if (this.cache.length > 16)
      return c = this.cache.slice(0, 16), this.cache = this.cache.slice(16), c;
  } else if (this.cache.length >= 16)
    return c = this.cache.slice(0, 16), this.cache = this.cache.slice(16), c;
  return null;
};
Splitter.prototype.flush = function() {
  if (this.cache.length)
    return this.cache;
};
function unpad(m) {
  var c = m[15];
  if (c < 1 || c > 16)
    throw new Error("unable to decrypt data");
  for (var ie = -1; ++ie < c; )
    if (m[ie + (16 - c)] !== c)
      throw new Error("unable to decrypt data");
  if (c !== 16)
    return m.slice(0, 16 - c);
}
function createDecipheriv$1(m, c, ie) {
  var we = MODES[m.toLowerCase()];
  if (!we)
    throw new TypeError("invalid suite type");
  if (typeof ie == "string" && (ie = Buffer$8.from(ie)), we.mode !== "GCM" && ie.length !== we.iv)
    throw new TypeError("invalid iv length " + ie.length);
  if (typeof c == "string" && (c = Buffer$8.from(c)), c.length !== we.key / 8)
    throw new TypeError("invalid key length " + c.length);
  return we.type === "stream" ? new StreamCipher(we.module, c, ie, !0) : we.type === "auth" ? new AuthCipher(we.module, c, ie, !0) : new Decipher(we.module, c, ie);
}
function createDecipher$1(m, c) {
  var ie = MODES[m.toLowerCase()];
  if (!ie)
    throw new TypeError("invalid suite type");
  var we = ebtk$1(c, !1, ie.key, ie.iv);
  return createDecipheriv$1(m, we.key, we.iv);
}
decrypter.createDecipher = createDecipher$1;
decrypter.createDecipheriv = createDecipheriv$1;
var ciphers$2 = encrypter, deciphers = decrypter, modes$1 = require$$2$1;
function getCiphers$1() {
  return Object.keys(modes$1);
}
browser$6.createCipher = browser$6.Cipher = ciphers$2.createCipher;
browser$6.createCipheriv = browser$6.Cipheriv = ciphers$2.createCipheriv;
browser$6.createDecipher = browser$6.Decipher = deciphers.createDecipher;
browser$6.createDecipheriv = browser$6.Decipheriv = deciphers.createDecipheriv;
browser$6.listCiphers = browser$6.getCiphers = getCiphers$1;
var modes = {};
(function(m) {
  m["des-ecb"] = {
    key: 8,
    iv: 0
  }, m["des-cbc"] = m.des = {
    key: 8,
    iv: 8
  }, m["des-ede3-cbc"] = m.des3 = {
    key: 24,
    iv: 8
  }, m["des-ede3"] = {
    key: 24,
    iv: 0
  }, m["des-ede-cbc"] = {
    key: 16,
    iv: 8
  }, m["des-ede"] = {
    key: 16,
    iv: 0
  };
})(modes);
var DES = browserifyDes, aes = browser$6, aesModes = modes_1, desModes = modes, ebtk = evp_bytestokey;
function createCipher(m, c) {
  m = m.toLowerCase();
  var ie, we;
  if (aesModes[m])
    ie = aesModes[m].key, we = aesModes[m].iv;
  else if (desModes[m])
    ie = desModes[m].key * 8, we = desModes[m].iv;
  else
    throw new TypeError("invalid suite type");
  var $e = ebtk(c, !1, ie, we);
  return createCipheriv(m, $e.key, $e.iv);
}
function createDecipher(m, c) {
  m = m.toLowerCase();
  var ie, we;
  if (aesModes[m])
    ie = aesModes[m].key, we = aesModes[m].iv;
  else if (desModes[m])
    ie = desModes[m].key * 8, we = desModes[m].iv;
  else
    throw new TypeError("invalid suite type");
  var $e = ebtk(c, !1, ie, we);
  return createDecipheriv(m, $e.key, $e.iv);
}
function createCipheriv(m, c, ie) {
  if (m = m.toLowerCase(), aesModes[m])
    return aes.createCipheriv(m, c, ie);
  if (desModes[m])
    return new DES({ key: c, iv: ie, mode: m });
  throw new TypeError("invalid suite type");
}
function createDecipheriv(m, c, ie) {
  if (m = m.toLowerCase(), aesModes[m])
    return aes.createDecipheriv(m, c, ie);
  if (desModes[m])
    return new DES({ key: c, iv: ie, mode: m, decrypt: !0 });
  throw new TypeError("invalid suite type");
}
function getCiphers() {
  return Object.keys(desModes).concat(aes.getCiphers());
}
browser$7.createCipher = browser$7.Cipher = createCipher;
browser$7.createCipheriv = browser$7.Cipheriv = createCipheriv;
browser$7.createDecipher = browser$7.Decipher = createDecipher;
browser$7.createDecipheriv = browser$7.Decipheriv = createDecipheriv;
browser$7.listCiphers = browser$7.getCiphers = getCiphers;
var browser$5 = {}, bn$6 = { exports: {} };
(function(m) {
  (function(c, ie) {
    function we(vr, Ae) {
      if (!vr)
        throw new Error(Ae || "Assertion failed");
    }
    function $e(vr, Ae) {
      vr.super_ = Ae;
      var ze = function() {
      };
      ze.prototype = Ae.prototype, vr.prototype = new ze(), vr.prototype.constructor = vr;
    }
    function Me(vr, Ae, ze) {
      if (Me.isBN(vr))
        return vr;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, vr !== null && ((Ae === "le" || Ae === "be") && (ze = Ae, Ae = 10), this._init(vr || 0, Ae || 10, ze || "be"));
    }
    typeof c == "object" ? c.exports = Me : ie.BN = Me, Me.BN = Me, Me.wordSize = 26;
    var Ze;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? Ze = window.Buffer : Ze = require$$0$4.Buffer;
    } catch {
    }
    Me.isBN = function(Ae) {
      return Ae instanceof Me ? !0 : Ae !== null && typeof Ae == "object" && Ae.constructor.wordSize === Me.wordSize && Array.isArray(Ae.words);
    }, Me.max = function(Ae, ze) {
      return Ae.cmp(ze) > 0 ? Ae : ze;
    }, Me.min = function(Ae, ze) {
      return Ae.cmp(ze) < 0 ? Ae : ze;
    }, Me.prototype._init = function(Ae, ze, Ue) {
      if (typeof Ae == "number")
        return this._initNumber(Ae, ze, Ue);
      if (typeof Ae == "object")
        return this._initArray(Ae, ze, Ue);
      ze === "hex" && (ze = 16), we(ze === (ze | 0) && ze >= 2 && ze <= 36), Ae = Ae.toString().replace(/\s+/g, "");
      var tr = 0;
      Ae[0] === "-" && (tr++, this.negative = 1), tr < Ae.length && (ze === 16 ? this._parseHex(Ae, tr, Ue) : (this._parseBase(Ae, ze, tr), Ue === "le" && this._initArray(this.toArray(), ze, Ue)));
    }, Me.prototype._initNumber = function(Ae, ze, Ue) {
      Ae < 0 && (this.negative = 1, Ae = -Ae), Ae < 67108864 ? (this.words = [Ae & 67108863], this.length = 1) : Ae < 4503599627370496 ? (this.words = [
        Ae & 67108863,
        Ae / 67108864 & 67108863
      ], this.length = 2) : (we(Ae < 9007199254740992), this.words = [
        Ae & 67108863,
        Ae / 67108864 & 67108863,
        1
      ], this.length = 3), Ue === "le" && this._initArray(this.toArray(), ze, Ue);
    }, Me.prototype._initArray = function(Ae, ze, Ue) {
      if (we(typeof Ae.length == "number"), Ae.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(Ae.length / 3), this.words = new Array(this.length);
      for (var tr = 0; tr < this.length; tr++)
        this.words[tr] = 0;
      var lr, pr, br = 0;
      if (Ue === "be")
        for (tr = Ae.length - 1, lr = 0; tr >= 0; tr -= 3)
          pr = Ae[tr] | Ae[tr - 1] << 8 | Ae[tr - 2] << 16, this.words[lr] |= pr << br & 67108863, this.words[lr + 1] = pr >>> 26 - br & 67108863, br += 24, br >= 26 && (br -= 26, lr++);
      else if (Ue === "le")
        for (tr = 0, lr = 0; tr < Ae.length; tr += 3)
          pr = Ae[tr] | Ae[tr + 1] << 8 | Ae[tr + 2] << 16, this.words[lr] |= pr << br & 67108863, this.words[lr + 1] = pr >>> 26 - br & 67108863, br += 24, br >= 26 && (br -= 26, lr++);
      return this.strip();
    };
    function ne(vr, Ae) {
      var ze = vr.charCodeAt(Ae);
      return ze >= 65 && ze <= 70 ? ze - 55 : ze >= 97 && ze <= 102 ? ze - 87 : ze - 48 & 15;
    }
    function rr(vr, Ae, ze) {
      var Ue = ne(vr, ze);
      return ze - 1 >= Ae && (Ue |= ne(vr, ze - 1) << 4), Ue;
    }
    Me.prototype._parseHex = function(Ae, ze, Ue) {
      this.length = Math.ceil((Ae.length - ze) / 6), this.words = new Array(this.length);
      for (var tr = 0; tr < this.length; tr++)
        this.words[tr] = 0;
      var lr = 0, pr = 0, br;
      if (Ue === "be")
        for (tr = Ae.length - 1; tr >= ze; tr -= 2)
          br = rr(Ae, ze, tr) << lr, this.words[pr] |= br & 67108863, lr >= 18 ? (lr -= 18, pr += 1, this.words[pr] |= br >>> 26) : lr += 8;
      else {
        var nr = Ae.length - ze;
        for (tr = nr % 2 === 0 ? ze + 1 : ze; tr < Ae.length; tr += 2)
          br = rr(Ae, ze, tr) << lr, this.words[pr] |= br & 67108863, lr >= 18 ? (lr -= 18, pr += 1, this.words[pr] |= br >>> 26) : lr += 8;
      }
      this.strip();
    };
    function gr(vr, Ae, ze, Ue) {
      for (var tr = 0, lr = Math.min(vr.length, ze), pr = Ae; pr < lr; pr++) {
        var br = vr.charCodeAt(pr) - 48;
        tr *= Ue, br >= 49 ? tr += br - 49 + 10 : br >= 17 ? tr += br - 17 + 10 : tr += br;
      }
      return tr;
    }
    Me.prototype._parseBase = function(Ae, ze, Ue) {
      this.words = [0], this.length = 1;
      for (var tr = 0, lr = 1; lr <= 67108863; lr *= ze)
        tr++;
      tr--, lr = lr / ze | 0;
      for (var pr = Ae.length - Ue, br = pr % tr, nr = Math.min(pr, pr - br) + Ue, Pe = 0, ur = Ue; ur < nr; ur += tr)
        Pe = gr(Ae, ur, ur + tr, ze), this.imuln(lr), this.words[0] + Pe < 67108864 ? this.words[0] += Pe : this._iaddn(Pe);
      if (br !== 0) {
        var Pr = 1;
        for (Pe = gr(Ae, ur, Ae.length, ze), ur = 0; ur < br; ur++)
          Pr *= ze;
        this.imuln(Pr), this.words[0] + Pe < 67108864 ? this.words[0] += Pe : this._iaddn(Pe);
      }
      this.strip();
    }, Me.prototype.copy = function(Ae) {
      Ae.words = new Array(this.length);
      for (var ze = 0; ze < this.length; ze++)
        Ae.words[ze] = this.words[ze];
      Ae.length = this.length, Ae.negative = this.negative, Ae.red = this.red;
    }, Me.prototype.clone = function() {
      var Ae = new Me(null);
      return this.copy(Ae), Ae;
    }, Me.prototype._expand = function(Ae) {
      for (; this.length < Ae; )
        this.words[this.length++] = 0;
      return this;
    }, Me.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, Me.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, Me.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var or = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], _r = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Lr = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    Me.prototype.toString = function(Ae, ze) {
      Ae = Ae || 10, ze = ze | 0 || 1;
      var Ue;
      if (Ae === 16 || Ae === "hex") {
        Ue = "";
        for (var tr = 0, lr = 0, pr = 0; pr < this.length; pr++) {
          var br = this.words[pr], nr = ((br << tr | lr) & 16777215).toString(16);
          lr = br >>> 24 - tr & 16777215, tr += 2, tr >= 26 && (tr -= 26, pr--), lr !== 0 || pr !== this.length - 1 ? Ue = or[6 - nr.length] + nr + Ue : Ue = nr + Ue;
        }
        for (lr !== 0 && (Ue = lr.toString(16) + Ue); Ue.length % ze !== 0; )
          Ue = "0" + Ue;
        return this.negative !== 0 && (Ue = "-" + Ue), Ue;
      }
      if (Ae === (Ae | 0) && Ae >= 2 && Ae <= 36) {
        var Pe = _r[Ae], ur = Lr[Ae];
        Ue = "";
        var Pr = this.clone();
        for (Pr.negative = 0; !Pr.isZero(); ) {
          var Hr = Pr.modn(ur).toString(Ae);
          Pr = Pr.idivn(ur), Pr.isZero() ? Ue = Hr + Ue : Ue = or[Pe - Hr.length] + Hr + Ue;
        }
        for (this.isZero() && (Ue = "0" + Ue); Ue.length % ze !== 0; )
          Ue = "0" + Ue;
        return this.negative !== 0 && (Ue = "-" + Ue), Ue;
      }
      we(!1, "Base should be between 2 and 36");
    }, Me.prototype.toNumber = function() {
      var Ae = this.words[0];
      return this.length === 2 ? Ae += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ae += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && we(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ae : Ae;
    }, Me.prototype.toJSON = function() {
      return this.toString(16);
    }, Me.prototype.toBuffer = function(Ae, ze) {
      return we(typeof Ze < "u"), this.toArrayLike(Ze, Ae, ze);
    }, Me.prototype.toArray = function(Ae, ze) {
      return this.toArrayLike(Array, Ae, ze);
    }, Me.prototype.toArrayLike = function(Ae, ze, Ue) {
      var tr = this.byteLength(), lr = Ue || Math.max(1, tr);
      we(tr <= lr, "byte array longer than desired length"), we(lr > 0, "Requested array length <= 0"), this.strip();
      var pr = ze === "le", br = new Ae(lr), nr, Pe, ur = this.clone();
      if (pr) {
        for (Pe = 0; !ur.isZero(); Pe++)
          nr = ur.andln(255), ur.iushrn(8), br[Pe] = nr;
        for (; Pe < lr; Pe++)
          br[Pe] = 0;
      } else {
        for (Pe = 0; Pe < lr - tr; Pe++)
          br[Pe] = 0;
        for (Pe = 0; !ur.isZero(); Pe++)
          nr = ur.andln(255), ur.iushrn(8), br[lr - Pe - 1] = nr;
      }
      return br;
    }, Math.clz32 ? Me.prototype._countBits = function(Ae) {
      return 32 - Math.clz32(Ae);
    } : Me.prototype._countBits = function(Ae) {
      var ze = Ae, Ue = 0;
      return ze >= 4096 && (Ue += 13, ze >>>= 13), ze >= 64 && (Ue += 7, ze >>>= 7), ze >= 8 && (Ue += 4, ze >>>= 4), ze >= 2 && (Ue += 2, ze >>>= 2), Ue + ze;
    }, Me.prototype._zeroBits = function(Ae) {
      if (Ae === 0)
        return 26;
      var ze = Ae, Ue = 0;
      return (ze & 8191) === 0 && (Ue += 13, ze >>>= 13), (ze & 127) === 0 && (Ue += 7, ze >>>= 7), (ze & 15) === 0 && (Ue += 4, ze >>>= 4), (ze & 3) === 0 && (Ue += 2, ze >>>= 2), (ze & 1) === 0 && Ue++, Ue;
    }, Me.prototype.bitLength = function() {
      var Ae = this.words[this.length - 1], ze = this._countBits(Ae);
      return (this.length - 1) * 26 + ze;
    };
    function Ir(vr) {
      for (var Ae = new Array(vr.bitLength()), ze = 0; ze < Ae.length; ze++) {
        var Ue = ze / 26 | 0, tr = ze % 26;
        Ae[ze] = (vr.words[Ue] & 1 << tr) >>> tr;
      }
      return Ae;
    }
    Me.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var Ae = 0, ze = 0; ze < this.length; ze++) {
        var Ue = this._zeroBits(this.words[ze]);
        if (Ae += Ue, Ue !== 26)
          break;
      }
      return Ae;
    }, Me.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, Me.prototype.toTwos = function(Ae) {
      return this.negative !== 0 ? this.abs().inotn(Ae).iaddn(1) : this.clone();
    }, Me.prototype.fromTwos = function(Ae) {
      return this.testn(Ae - 1) ? this.notn(Ae).iaddn(1).ineg() : this.clone();
    }, Me.prototype.isNeg = function() {
      return this.negative !== 0;
    }, Me.prototype.neg = function() {
      return this.clone().ineg();
    }, Me.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, Me.prototype.iuor = function(Ae) {
      for (; this.length < Ae.length; )
        this.words[this.length++] = 0;
      for (var ze = 0; ze < Ae.length; ze++)
        this.words[ze] = this.words[ze] | Ae.words[ze];
      return this.strip();
    }, Me.prototype.ior = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuor(Ae);
    }, Me.prototype.or = function(Ae) {
      return this.length > Ae.length ? this.clone().ior(Ae) : Ae.clone().ior(this);
    }, Me.prototype.uor = function(Ae) {
      return this.length > Ae.length ? this.clone().iuor(Ae) : Ae.clone().iuor(this);
    }, Me.prototype.iuand = function(Ae) {
      var ze;
      this.length > Ae.length ? ze = Ae : ze = this;
      for (var Ue = 0; Ue < ze.length; Ue++)
        this.words[Ue] = this.words[Ue] & Ae.words[Ue];
      return this.length = ze.length, this.strip();
    }, Me.prototype.iand = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuand(Ae);
    }, Me.prototype.and = function(Ae) {
      return this.length > Ae.length ? this.clone().iand(Ae) : Ae.clone().iand(this);
    }, Me.prototype.uand = function(Ae) {
      return this.length > Ae.length ? this.clone().iuand(Ae) : Ae.clone().iuand(this);
    }, Me.prototype.iuxor = function(Ae) {
      var ze, Ue;
      this.length > Ae.length ? (ze = this, Ue = Ae) : (ze = Ae, Ue = this);
      for (var tr = 0; tr < Ue.length; tr++)
        this.words[tr] = ze.words[tr] ^ Ue.words[tr];
      if (this !== ze)
        for (; tr < ze.length; tr++)
          this.words[tr] = ze.words[tr];
      return this.length = ze.length, this.strip();
    }, Me.prototype.ixor = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuxor(Ae);
    }, Me.prototype.xor = function(Ae) {
      return this.length > Ae.length ? this.clone().ixor(Ae) : Ae.clone().ixor(this);
    }, Me.prototype.uxor = function(Ae) {
      return this.length > Ae.length ? this.clone().iuxor(Ae) : Ae.clone().iuxor(this);
    }, Me.prototype.inotn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Math.ceil(Ae / 26) | 0, Ue = Ae % 26;
      this._expand(ze), Ue > 0 && ze--;
      for (var tr = 0; tr < ze; tr++)
        this.words[tr] = ~this.words[tr] & 67108863;
      return Ue > 0 && (this.words[tr] = ~this.words[tr] & 67108863 >> 26 - Ue), this.strip();
    }, Me.prototype.notn = function(Ae) {
      return this.clone().inotn(Ae);
    }, Me.prototype.setn = function(Ae, ze) {
      we(typeof Ae == "number" && Ae >= 0);
      var Ue = Ae / 26 | 0, tr = Ae % 26;
      return this._expand(Ue + 1), ze ? this.words[Ue] = this.words[Ue] | 1 << tr : this.words[Ue] = this.words[Ue] & ~(1 << tr), this.strip();
    }, Me.prototype.iadd = function(Ae) {
      var ze;
      if (this.negative !== 0 && Ae.negative === 0)
        return this.negative = 0, ze = this.isub(Ae), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && Ae.negative !== 0)
        return Ae.negative = 0, ze = this.isub(Ae), Ae.negative = 1, ze._normSign();
      var Ue, tr;
      this.length > Ae.length ? (Ue = this, tr = Ae) : (Ue = Ae, tr = this);
      for (var lr = 0, pr = 0; pr < tr.length; pr++)
        ze = (Ue.words[pr] | 0) + (tr.words[pr] | 0) + lr, this.words[pr] = ze & 67108863, lr = ze >>> 26;
      for (; lr !== 0 && pr < Ue.length; pr++)
        ze = (Ue.words[pr] | 0) + lr, this.words[pr] = ze & 67108863, lr = ze >>> 26;
      if (this.length = Ue.length, lr !== 0)
        this.words[this.length] = lr, this.length++;
      else if (Ue !== this)
        for (; pr < Ue.length; pr++)
          this.words[pr] = Ue.words[pr];
      return this;
    }, Me.prototype.add = function(Ae) {
      var ze;
      return Ae.negative !== 0 && this.negative === 0 ? (Ae.negative = 0, ze = this.sub(Ae), Ae.negative ^= 1, ze) : Ae.negative === 0 && this.negative !== 0 ? (this.negative = 0, ze = Ae.sub(this), this.negative = 1, ze) : this.length > Ae.length ? this.clone().iadd(Ae) : Ae.clone().iadd(this);
    }, Me.prototype.isub = function(Ae) {
      if (Ae.negative !== 0) {
        Ae.negative = 0;
        var ze = this.iadd(Ae);
        return Ae.negative = 1, ze._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(Ae), this.negative = 1, this._normSign();
      var Ue = this.cmp(Ae);
      if (Ue === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var tr, lr;
      Ue > 0 ? (tr = this, lr = Ae) : (tr = Ae, lr = this);
      for (var pr = 0, br = 0; br < lr.length; br++)
        ze = (tr.words[br] | 0) - (lr.words[br] | 0) + pr, pr = ze >> 26, this.words[br] = ze & 67108863;
      for (; pr !== 0 && br < tr.length; br++)
        ze = (tr.words[br] | 0) + pr, pr = ze >> 26, this.words[br] = ze & 67108863;
      if (pr === 0 && br < tr.length && tr !== this)
        for (; br < tr.length; br++)
          this.words[br] = tr.words[br];
      return this.length = Math.max(this.length, br), tr !== this && (this.negative = 1), this.strip();
    }, Me.prototype.sub = function(Ae) {
      return this.clone().isub(Ae);
    };
    function Ar(vr, Ae, ze) {
      ze.negative = Ae.negative ^ vr.negative;
      var Ue = vr.length + Ae.length | 0;
      ze.length = Ue, Ue = Ue - 1 | 0;
      var tr = vr.words[0] | 0, lr = Ae.words[0] | 0, pr = tr * lr, br = pr & 67108863, nr = pr / 67108864 | 0;
      ze.words[0] = br;
      for (var Pe = 1; Pe < Ue; Pe++) {
        for (var ur = nr >>> 26, Pr = nr & 67108863, Hr = Math.min(Pe, Ae.length - 1), vi = Math.max(0, Pe - vr.length + 1); vi <= Hr; vi++) {
          var Ti = Pe - vi | 0;
          tr = vr.words[Ti] | 0, lr = Ae.words[vi] | 0, pr = tr * lr + Pr, ur += pr / 67108864 | 0, Pr = pr & 67108863;
        }
        ze.words[Pe] = Pr | 0, nr = ur | 0;
      }
      return nr !== 0 ? ze.words[Pe] = nr | 0 : ze.length--, ze.strip();
    }
    var Rr = function(Ae, ze, Ue) {
      var tr = Ae.words, lr = ze.words, pr = Ue.words, br = 0, nr, Pe, ur, Pr = tr[0] | 0, Hr = Pr & 8191, vi = Pr >>> 13, Ti = tr[1] | 0, wi = Ti & 8191, ii = Ti >>> 13, mi = tr[2] | 0, ei = mi & 8191, Zr = mi >>> 13, pi = tr[3] | 0, hi = pi & 8191, Oi = pi >>> 13, qi = tr[4] | 0, yn = qi & 8191, sn = qi >>> 13, $n = tr[5] | 0, rn = $n & 8191, ji = $n >>> 13, Kn = tr[6] | 0, In = Kn & 8191, Fn = Kn >>> 13, Po = tr[7] | 0, vn = Po & 8191, Vn = Po >>> 13, Xo = tr[8] | 0, Xn = Xo & 8191, Yn = Xo >>> 13, Wo = tr[9] | 0, Ci = Wo & 8191, ri = Wo >>> 13, yi = lr[0] | 0, Li = yi & 8191, Yi = yi >>> 13, zn = lr[1] | 0, un = zn & 8191, Gn = zn >>> 13, Mn = lr[2] | 0, pn = Mn & 8191, Rn = Mn >>> 13, Io = lr[3] | 0, to = Io & 8191, no = Io >>> 13, ma = lr[4] | 0, Qn = ma & 8191, co = ma >>> 13, kn = lr[5] | 0, ai = kn & 8191, _i = kn >>> 13, Pi = lr[6] | 0, Ai = Pi & 8191, ki = Pi >>> 13, an = lr[7] | 0, Ui = an & 8191, Vi = an >>> 13, Sn = lr[8] | 0, Hi = Sn & 8191, en = Sn >>> 13, qn = lr[9] | 0, _n = qn & 8191, Tn = qn >>> 13;
      Ue.negative = Ae.negative ^ ze.negative, Ue.length = 19, nr = Math.imul(Hr, Li), Pe = Math.imul(Hr, Yi), Pe = Pe + Math.imul(vi, Li) | 0, ur = Math.imul(vi, Yi);
      var xo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (xo >>> 26) | 0, xo &= 67108863, nr = Math.imul(wi, Li), Pe = Math.imul(wi, Yi), Pe = Pe + Math.imul(ii, Li) | 0, ur = Math.imul(ii, Yi), nr = nr + Math.imul(Hr, un) | 0, Pe = Pe + Math.imul(Hr, Gn) | 0, Pe = Pe + Math.imul(vi, un) | 0, ur = ur + Math.imul(vi, Gn) | 0;
      var Co = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Co >>> 26) | 0, Co &= 67108863, nr = Math.imul(ei, Li), Pe = Math.imul(ei, Yi), Pe = Pe + Math.imul(Zr, Li) | 0, ur = Math.imul(Zr, Yi), nr = nr + Math.imul(wi, un) | 0, Pe = Pe + Math.imul(wi, Gn) | 0, Pe = Pe + Math.imul(ii, un) | 0, ur = ur + Math.imul(ii, Gn) | 0, nr = nr + Math.imul(Hr, pn) | 0, Pe = Pe + Math.imul(Hr, Rn) | 0, Pe = Pe + Math.imul(vi, pn) | 0, ur = ur + Math.imul(vi, Rn) | 0;
      var $o = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + ($o >>> 26) | 0, $o &= 67108863, nr = Math.imul(hi, Li), Pe = Math.imul(hi, Yi), Pe = Pe + Math.imul(Oi, Li) | 0, ur = Math.imul(Oi, Yi), nr = nr + Math.imul(ei, un) | 0, Pe = Pe + Math.imul(ei, Gn) | 0, Pe = Pe + Math.imul(Zr, un) | 0, ur = ur + Math.imul(Zr, Gn) | 0, nr = nr + Math.imul(wi, pn) | 0, Pe = Pe + Math.imul(wi, Rn) | 0, Pe = Pe + Math.imul(ii, pn) | 0, ur = ur + Math.imul(ii, Rn) | 0, nr = nr + Math.imul(Hr, to) | 0, Pe = Pe + Math.imul(Hr, no) | 0, Pe = Pe + Math.imul(vi, to) | 0, ur = ur + Math.imul(vi, no) | 0;
      var Bo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Bo >>> 26) | 0, Bo &= 67108863, nr = Math.imul(yn, Li), Pe = Math.imul(yn, Yi), Pe = Pe + Math.imul(sn, Li) | 0, ur = Math.imul(sn, Yi), nr = nr + Math.imul(hi, un) | 0, Pe = Pe + Math.imul(hi, Gn) | 0, Pe = Pe + Math.imul(Oi, un) | 0, ur = ur + Math.imul(Oi, Gn) | 0, nr = nr + Math.imul(ei, pn) | 0, Pe = Pe + Math.imul(ei, Rn) | 0, Pe = Pe + Math.imul(Zr, pn) | 0, ur = ur + Math.imul(Zr, Rn) | 0, nr = nr + Math.imul(wi, to) | 0, Pe = Pe + Math.imul(wi, no) | 0, Pe = Pe + Math.imul(ii, to) | 0, ur = ur + Math.imul(ii, no) | 0, nr = nr + Math.imul(Hr, Qn) | 0, Pe = Pe + Math.imul(Hr, co) | 0, Pe = Pe + Math.imul(vi, Qn) | 0, ur = ur + Math.imul(vi, co) | 0;
      var Qo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Qo >>> 26) | 0, Qo &= 67108863, nr = Math.imul(rn, Li), Pe = Math.imul(rn, Yi), Pe = Pe + Math.imul(ji, Li) | 0, ur = Math.imul(ji, Yi), nr = nr + Math.imul(yn, un) | 0, Pe = Pe + Math.imul(yn, Gn) | 0, Pe = Pe + Math.imul(sn, un) | 0, ur = ur + Math.imul(sn, Gn) | 0, nr = nr + Math.imul(hi, pn) | 0, Pe = Pe + Math.imul(hi, Rn) | 0, Pe = Pe + Math.imul(Oi, pn) | 0, ur = ur + Math.imul(Oi, Rn) | 0, nr = nr + Math.imul(ei, to) | 0, Pe = Pe + Math.imul(ei, no) | 0, Pe = Pe + Math.imul(Zr, to) | 0, ur = ur + Math.imul(Zr, no) | 0, nr = nr + Math.imul(wi, Qn) | 0, Pe = Pe + Math.imul(wi, co) | 0, Pe = Pe + Math.imul(ii, Qn) | 0, ur = ur + Math.imul(ii, co) | 0, nr = nr + Math.imul(Hr, ai) | 0, Pe = Pe + Math.imul(Hr, _i) | 0, Pe = Pe + Math.imul(vi, ai) | 0, ur = ur + Math.imul(vi, _i) | 0;
      var Go = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Go >>> 26) | 0, Go &= 67108863, nr = Math.imul(In, Li), Pe = Math.imul(In, Yi), Pe = Pe + Math.imul(Fn, Li) | 0, ur = Math.imul(Fn, Yi), nr = nr + Math.imul(rn, un) | 0, Pe = Pe + Math.imul(rn, Gn) | 0, Pe = Pe + Math.imul(ji, un) | 0, ur = ur + Math.imul(ji, Gn) | 0, nr = nr + Math.imul(yn, pn) | 0, Pe = Pe + Math.imul(yn, Rn) | 0, Pe = Pe + Math.imul(sn, pn) | 0, ur = ur + Math.imul(sn, Rn) | 0, nr = nr + Math.imul(hi, to) | 0, Pe = Pe + Math.imul(hi, no) | 0, Pe = Pe + Math.imul(Oi, to) | 0, ur = ur + Math.imul(Oi, no) | 0, nr = nr + Math.imul(ei, Qn) | 0, Pe = Pe + Math.imul(ei, co) | 0, Pe = Pe + Math.imul(Zr, Qn) | 0, ur = ur + Math.imul(Zr, co) | 0, nr = nr + Math.imul(wi, ai) | 0, Pe = Pe + Math.imul(wi, _i) | 0, Pe = Pe + Math.imul(ii, ai) | 0, ur = ur + Math.imul(ii, _i) | 0, nr = nr + Math.imul(Hr, Ai) | 0, Pe = Pe + Math.imul(Hr, ki) | 0, Pe = Pe + Math.imul(vi, Ai) | 0, ur = ur + Math.imul(vi, ki) | 0;
      var No = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, nr = Math.imul(vn, Li), Pe = Math.imul(vn, Yi), Pe = Pe + Math.imul(Vn, Li) | 0, ur = Math.imul(Vn, Yi), nr = nr + Math.imul(In, un) | 0, Pe = Pe + Math.imul(In, Gn) | 0, Pe = Pe + Math.imul(Fn, un) | 0, ur = ur + Math.imul(Fn, Gn) | 0, nr = nr + Math.imul(rn, pn) | 0, Pe = Pe + Math.imul(rn, Rn) | 0, Pe = Pe + Math.imul(ji, pn) | 0, ur = ur + Math.imul(ji, Rn) | 0, nr = nr + Math.imul(yn, to) | 0, Pe = Pe + Math.imul(yn, no) | 0, Pe = Pe + Math.imul(sn, to) | 0, ur = ur + Math.imul(sn, no) | 0, nr = nr + Math.imul(hi, Qn) | 0, Pe = Pe + Math.imul(hi, co) | 0, Pe = Pe + Math.imul(Oi, Qn) | 0, ur = ur + Math.imul(Oi, co) | 0, nr = nr + Math.imul(ei, ai) | 0, Pe = Pe + Math.imul(ei, _i) | 0, Pe = Pe + Math.imul(Zr, ai) | 0, ur = ur + Math.imul(Zr, _i) | 0, nr = nr + Math.imul(wi, Ai) | 0, Pe = Pe + Math.imul(wi, ki) | 0, Pe = Pe + Math.imul(ii, Ai) | 0, ur = ur + Math.imul(ii, ki) | 0, nr = nr + Math.imul(Hr, Ui) | 0, Pe = Pe + Math.imul(Hr, Vi) | 0, Pe = Pe + Math.imul(vi, Ui) | 0, ur = ur + Math.imul(vi, Vi) | 0;
      var Zo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Zo >>> 26) | 0, Zo &= 67108863, nr = Math.imul(Xn, Li), Pe = Math.imul(Xn, Yi), Pe = Pe + Math.imul(Yn, Li) | 0, ur = Math.imul(Yn, Yi), nr = nr + Math.imul(vn, un) | 0, Pe = Pe + Math.imul(vn, Gn) | 0, Pe = Pe + Math.imul(Vn, un) | 0, ur = ur + Math.imul(Vn, Gn) | 0, nr = nr + Math.imul(In, pn) | 0, Pe = Pe + Math.imul(In, Rn) | 0, Pe = Pe + Math.imul(Fn, pn) | 0, ur = ur + Math.imul(Fn, Rn) | 0, nr = nr + Math.imul(rn, to) | 0, Pe = Pe + Math.imul(rn, no) | 0, Pe = Pe + Math.imul(ji, to) | 0, ur = ur + Math.imul(ji, no) | 0, nr = nr + Math.imul(yn, Qn) | 0, Pe = Pe + Math.imul(yn, co) | 0, Pe = Pe + Math.imul(sn, Qn) | 0, ur = ur + Math.imul(sn, co) | 0, nr = nr + Math.imul(hi, ai) | 0, Pe = Pe + Math.imul(hi, _i) | 0, Pe = Pe + Math.imul(Oi, ai) | 0, ur = ur + Math.imul(Oi, _i) | 0, nr = nr + Math.imul(ei, Ai) | 0, Pe = Pe + Math.imul(ei, ki) | 0, Pe = Pe + Math.imul(Zr, Ai) | 0, ur = ur + Math.imul(Zr, ki) | 0, nr = nr + Math.imul(wi, Ui) | 0, Pe = Pe + Math.imul(wi, Vi) | 0, Pe = Pe + Math.imul(ii, Ui) | 0, ur = ur + Math.imul(ii, Vi) | 0, nr = nr + Math.imul(Hr, Hi) | 0, Pe = Pe + Math.imul(Hr, en) | 0, Pe = Pe + Math.imul(vi, Hi) | 0, ur = ur + Math.imul(vi, en) | 0;
      var ea = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ea >>> 26) | 0, ea &= 67108863, nr = Math.imul(Ci, Li), Pe = Math.imul(Ci, Yi), Pe = Pe + Math.imul(ri, Li) | 0, ur = Math.imul(ri, Yi), nr = nr + Math.imul(Xn, un) | 0, Pe = Pe + Math.imul(Xn, Gn) | 0, Pe = Pe + Math.imul(Yn, un) | 0, ur = ur + Math.imul(Yn, Gn) | 0, nr = nr + Math.imul(vn, pn) | 0, Pe = Pe + Math.imul(vn, Rn) | 0, Pe = Pe + Math.imul(Vn, pn) | 0, ur = ur + Math.imul(Vn, Rn) | 0, nr = nr + Math.imul(In, to) | 0, Pe = Pe + Math.imul(In, no) | 0, Pe = Pe + Math.imul(Fn, to) | 0, ur = ur + Math.imul(Fn, no) | 0, nr = nr + Math.imul(rn, Qn) | 0, Pe = Pe + Math.imul(rn, co) | 0, Pe = Pe + Math.imul(ji, Qn) | 0, ur = ur + Math.imul(ji, co) | 0, nr = nr + Math.imul(yn, ai) | 0, Pe = Pe + Math.imul(yn, _i) | 0, Pe = Pe + Math.imul(sn, ai) | 0, ur = ur + Math.imul(sn, _i) | 0, nr = nr + Math.imul(hi, Ai) | 0, Pe = Pe + Math.imul(hi, ki) | 0, Pe = Pe + Math.imul(Oi, Ai) | 0, ur = ur + Math.imul(Oi, ki) | 0, nr = nr + Math.imul(ei, Ui) | 0, Pe = Pe + Math.imul(ei, Vi) | 0, Pe = Pe + Math.imul(Zr, Ui) | 0, ur = ur + Math.imul(Zr, Vi) | 0, nr = nr + Math.imul(wi, Hi) | 0, Pe = Pe + Math.imul(wi, en) | 0, Pe = Pe + Math.imul(ii, Hi) | 0, ur = ur + Math.imul(ii, en) | 0, nr = nr + Math.imul(Hr, _n) | 0, Pe = Pe + Math.imul(Hr, Tn) | 0, Pe = Pe + Math.imul(vi, _n) | 0, ur = ur + Math.imul(vi, Tn) | 0;
      var da = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (da >>> 26) | 0, da &= 67108863, nr = Math.imul(Ci, un), Pe = Math.imul(Ci, Gn), Pe = Pe + Math.imul(ri, un) | 0, ur = Math.imul(ri, Gn), nr = nr + Math.imul(Xn, pn) | 0, Pe = Pe + Math.imul(Xn, Rn) | 0, Pe = Pe + Math.imul(Yn, pn) | 0, ur = ur + Math.imul(Yn, Rn) | 0, nr = nr + Math.imul(vn, to) | 0, Pe = Pe + Math.imul(vn, no) | 0, Pe = Pe + Math.imul(Vn, to) | 0, ur = ur + Math.imul(Vn, no) | 0, nr = nr + Math.imul(In, Qn) | 0, Pe = Pe + Math.imul(In, co) | 0, Pe = Pe + Math.imul(Fn, Qn) | 0, ur = ur + Math.imul(Fn, co) | 0, nr = nr + Math.imul(rn, ai) | 0, Pe = Pe + Math.imul(rn, _i) | 0, Pe = Pe + Math.imul(ji, ai) | 0, ur = ur + Math.imul(ji, _i) | 0, nr = nr + Math.imul(yn, Ai) | 0, Pe = Pe + Math.imul(yn, ki) | 0, Pe = Pe + Math.imul(sn, Ai) | 0, ur = ur + Math.imul(sn, ki) | 0, nr = nr + Math.imul(hi, Ui) | 0, Pe = Pe + Math.imul(hi, Vi) | 0, Pe = Pe + Math.imul(Oi, Ui) | 0, ur = ur + Math.imul(Oi, Vi) | 0, nr = nr + Math.imul(ei, Hi) | 0, Pe = Pe + Math.imul(ei, en) | 0, Pe = Pe + Math.imul(Zr, Hi) | 0, ur = ur + Math.imul(Zr, en) | 0, nr = nr + Math.imul(wi, _n) | 0, Pe = Pe + Math.imul(wi, Tn) | 0, Pe = Pe + Math.imul(ii, _n) | 0, ur = ur + Math.imul(ii, Tn) | 0;
      var Ra = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ra >>> 26) | 0, Ra &= 67108863, nr = Math.imul(Ci, pn), Pe = Math.imul(Ci, Rn), Pe = Pe + Math.imul(ri, pn) | 0, ur = Math.imul(ri, Rn), nr = nr + Math.imul(Xn, to) | 0, Pe = Pe + Math.imul(Xn, no) | 0, Pe = Pe + Math.imul(Yn, to) | 0, ur = ur + Math.imul(Yn, no) | 0, nr = nr + Math.imul(vn, Qn) | 0, Pe = Pe + Math.imul(vn, co) | 0, Pe = Pe + Math.imul(Vn, Qn) | 0, ur = ur + Math.imul(Vn, co) | 0, nr = nr + Math.imul(In, ai) | 0, Pe = Pe + Math.imul(In, _i) | 0, Pe = Pe + Math.imul(Fn, ai) | 0, ur = ur + Math.imul(Fn, _i) | 0, nr = nr + Math.imul(rn, Ai) | 0, Pe = Pe + Math.imul(rn, ki) | 0, Pe = Pe + Math.imul(ji, Ai) | 0, ur = ur + Math.imul(ji, ki) | 0, nr = nr + Math.imul(yn, Ui) | 0, Pe = Pe + Math.imul(yn, Vi) | 0, Pe = Pe + Math.imul(sn, Ui) | 0, ur = ur + Math.imul(sn, Vi) | 0, nr = nr + Math.imul(hi, Hi) | 0, Pe = Pe + Math.imul(hi, en) | 0, Pe = Pe + Math.imul(Oi, Hi) | 0, ur = ur + Math.imul(Oi, en) | 0, nr = nr + Math.imul(ei, _n) | 0, Pe = Pe + Math.imul(ei, Tn) | 0, Pe = Pe + Math.imul(Zr, _n) | 0, ur = ur + Math.imul(Zr, Tn) | 0;
      var ba = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ba >>> 26) | 0, ba &= 67108863, nr = Math.imul(Ci, to), Pe = Math.imul(Ci, no), Pe = Pe + Math.imul(ri, to) | 0, ur = Math.imul(ri, no), nr = nr + Math.imul(Xn, Qn) | 0, Pe = Pe + Math.imul(Xn, co) | 0, Pe = Pe + Math.imul(Yn, Qn) | 0, ur = ur + Math.imul(Yn, co) | 0, nr = nr + Math.imul(vn, ai) | 0, Pe = Pe + Math.imul(vn, _i) | 0, Pe = Pe + Math.imul(Vn, ai) | 0, ur = ur + Math.imul(Vn, _i) | 0, nr = nr + Math.imul(In, Ai) | 0, Pe = Pe + Math.imul(In, ki) | 0, Pe = Pe + Math.imul(Fn, Ai) | 0, ur = ur + Math.imul(Fn, ki) | 0, nr = nr + Math.imul(rn, Ui) | 0, Pe = Pe + Math.imul(rn, Vi) | 0, Pe = Pe + Math.imul(ji, Ui) | 0, ur = ur + Math.imul(ji, Vi) | 0, nr = nr + Math.imul(yn, Hi) | 0, Pe = Pe + Math.imul(yn, en) | 0, Pe = Pe + Math.imul(sn, Hi) | 0, ur = ur + Math.imul(sn, en) | 0, nr = nr + Math.imul(hi, _n) | 0, Pe = Pe + Math.imul(hi, Tn) | 0, Pe = Pe + Math.imul(Oi, _n) | 0, ur = ur + Math.imul(Oi, Tn) | 0;
      var Ea = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ea >>> 26) | 0, Ea &= 67108863, nr = Math.imul(Ci, Qn), Pe = Math.imul(Ci, co), Pe = Pe + Math.imul(ri, Qn) | 0, ur = Math.imul(ri, co), nr = nr + Math.imul(Xn, ai) | 0, Pe = Pe + Math.imul(Xn, _i) | 0, Pe = Pe + Math.imul(Yn, ai) | 0, ur = ur + Math.imul(Yn, _i) | 0, nr = nr + Math.imul(vn, Ai) | 0, Pe = Pe + Math.imul(vn, ki) | 0, Pe = Pe + Math.imul(Vn, Ai) | 0, ur = ur + Math.imul(Vn, ki) | 0, nr = nr + Math.imul(In, Ui) | 0, Pe = Pe + Math.imul(In, Vi) | 0, Pe = Pe + Math.imul(Fn, Ui) | 0, ur = ur + Math.imul(Fn, Vi) | 0, nr = nr + Math.imul(rn, Hi) | 0, Pe = Pe + Math.imul(rn, en) | 0, Pe = Pe + Math.imul(ji, Hi) | 0, ur = ur + Math.imul(ji, en) | 0, nr = nr + Math.imul(yn, _n) | 0, Pe = Pe + Math.imul(yn, Tn) | 0, Pe = Pe + Math.imul(sn, _n) | 0, ur = ur + Math.imul(sn, Tn) | 0;
      var Ha = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ha >>> 26) | 0, Ha &= 67108863, nr = Math.imul(Ci, ai), Pe = Math.imul(Ci, _i), Pe = Pe + Math.imul(ri, ai) | 0, ur = Math.imul(ri, _i), nr = nr + Math.imul(Xn, Ai) | 0, Pe = Pe + Math.imul(Xn, ki) | 0, Pe = Pe + Math.imul(Yn, Ai) | 0, ur = ur + Math.imul(Yn, ki) | 0, nr = nr + Math.imul(vn, Ui) | 0, Pe = Pe + Math.imul(vn, Vi) | 0, Pe = Pe + Math.imul(Vn, Ui) | 0, ur = ur + Math.imul(Vn, Vi) | 0, nr = nr + Math.imul(In, Hi) | 0, Pe = Pe + Math.imul(In, en) | 0, Pe = Pe + Math.imul(Fn, Hi) | 0, ur = ur + Math.imul(Fn, en) | 0, nr = nr + Math.imul(rn, _n) | 0, Pe = Pe + Math.imul(rn, Tn) | 0, Pe = Pe + Math.imul(ji, _n) | 0, ur = ur + Math.imul(ji, Tn) | 0;
      var Fa = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Fa >>> 26) | 0, Fa &= 67108863, nr = Math.imul(Ci, Ai), Pe = Math.imul(Ci, ki), Pe = Pe + Math.imul(ri, Ai) | 0, ur = Math.imul(ri, ki), nr = nr + Math.imul(Xn, Ui) | 0, Pe = Pe + Math.imul(Xn, Vi) | 0, Pe = Pe + Math.imul(Yn, Ui) | 0, ur = ur + Math.imul(Yn, Vi) | 0, nr = nr + Math.imul(vn, Hi) | 0, Pe = Pe + Math.imul(vn, en) | 0, Pe = Pe + Math.imul(Vn, Hi) | 0, ur = ur + Math.imul(Vn, en) | 0, nr = nr + Math.imul(In, _n) | 0, Pe = Pe + Math.imul(In, Tn) | 0, Pe = Pe + Math.imul(Fn, _n) | 0, ur = ur + Math.imul(Fn, Tn) | 0;
      var ls = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ls >>> 26) | 0, ls &= 67108863, nr = Math.imul(Ci, Ui), Pe = Math.imul(Ci, Vi), Pe = Pe + Math.imul(ri, Ui) | 0, ur = Math.imul(ri, Vi), nr = nr + Math.imul(Xn, Hi) | 0, Pe = Pe + Math.imul(Xn, en) | 0, Pe = Pe + Math.imul(Yn, Hi) | 0, ur = ur + Math.imul(Yn, en) | 0, nr = nr + Math.imul(vn, _n) | 0, Pe = Pe + Math.imul(vn, Tn) | 0, Pe = Pe + Math.imul(Vn, _n) | 0, ur = ur + Math.imul(Vn, Tn) | 0;
      var us = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (us >>> 26) | 0, us &= 67108863, nr = Math.imul(Ci, Hi), Pe = Math.imul(Ci, en), Pe = Pe + Math.imul(ri, Hi) | 0, ur = Math.imul(ri, en), nr = nr + Math.imul(Xn, _n) | 0, Pe = Pe + Math.imul(Xn, Tn) | 0, Pe = Pe + Math.imul(Yn, _n) | 0, ur = ur + Math.imul(Yn, Tn) | 0;
      var Xa = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Xa >>> 26) | 0, Xa &= 67108863, nr = Math.imul(Ci, _n), Pe = Math.imul(Ci, Tn), Pe = Pe + Math.imul(ri, _n) | 0, ur = Math.imul(ri, Tn);
      var hs = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      return br = (ur + (Pe >>> 13) | 0) + (hs >>> 26) | 0, hs &= 67108863, pr[0] = xo, pr[1] = Co, pr[2] = $o, pr[3] = Bo, pr[4] = Qo, pr[5] = Go, pr[6] = No, pr[7] = Zo, pr[8] = ea, pr[9] = da, pr[10] = Ra, pr[11] = ba, pr[12] = Ea, pr[13] = Ha, pr[14] = Fa, pr[15] = ls, pr[16] = us, pr[17] = Xa, pr[18] = hs, br !== 0 && (pr[19] = br, Ue.length++), Ue;
    };
    Math.imul || (Rr = Ar);
    function Nr(vr, Ae, ze) {
      ze.negative = Ae.negative ^ vr.negative, ze.length = vr.length + Ae.length;
      for (var Ue = 0, tr = 0, lr = 0; lr < ze.length - 1; lr++) {
        var pr = tr;
        tr = 0;
        for (var br = Ue & 67108863, nr = Math.min(lr, Ae.length - 1), Pe = Math.max(0, lr - vr.length + 1); Pe <= nr; Pe++) {
          var ur = lr - Pe, Pr = vr.words[ur] | 0, Hr = Ae.words[Pe] | 0, vi = Pr * Hr, Ti = vi & 67108863;
          pr = pr + (vi / 67108864 | 0) | 0, Ti = Ti + br | 0, br = Ti & 67108863, pr = pr + (Ti >>> 26) | 0, tr += pr >>> 26, pr &= 67108863;
        }
        ze.words[lr] = br, Ue = pr, pr = tr;
      }
      return Ue !== 0 ? ze.words[lr] = Ue : ze.length--, ze.strip();
    }
    function Yr(vr, Ae, ze) {
      var Ue = new Vr();
      return Ue.mulp(vr, Ae, ze);
    }
    Me.prototype.mulTo = function(Ae, ze) {
      var Ue, tr = this.length + Ae.length;
      return this.length === 10 && Ae.length === 10 ? Ue = Rr(this, Ae, ze) : tr < 63 ? Ue = Ar(this, Ae, ze) : tr < 1024 ? Ue = Nr(this, Ae, ze) : Ue = Yr(this, Ae, ze), Ue;
    };
    function Vr(vr, Ae) {
      this.x = vr, this.y = Ae;
    }
    Vr.prototype.makeRBT = function(Ae) {
      for (var ze = new Array(Ae), Ue = Me.prototype._countBits(Ae) - 1, tr = 0; tr < Ae; tr++)
        ze[tr] = this.revBin(tr, Ue, Ae);
      return ze;
    }, Vr.prototype.revBin = function(Ae, ze, Ue) {
      if (Ae === 0 || Ae === Ue - 1)
        return Ae;
      for (var tr = 0, lr = 0; lr < ze; lr++)
        tr |= (Ae & 1) << ze - lr - 1, Ae >>= 1;
      return tr;
    }, Vr.prototype.permute = function(Ae, ze, Ue, tr, lr, pr) {
      for (var br = 0; br < pr; br++)
        tr[br] = ze[Ae[br]], lr[br] = Ue[Ae[br]];
    }, Vr.prototype.transform = function(Ae, ze, Ue, tr, lr, pr) {
      this.permute(pr, Ae, ze, Ue, tr, lr);
      for (var br = 1; br < lr; br <<= 1)
        for (var nr = br << 1, Pe = Math.cos(2 * Math.PI / nr), ur = Math.sin(2 * Math.PI / nr), Pr = 0; Pr < lr; Pr += nr)
          for (var Hr = Pe, vi = ur, Ti = 0; Ti < br; Ti++) {
            var wi = Ue[Pr + Ti], ii = tr[Pr + Ti], mi = Ue[Pr + Ti + br], ei = tr[Pr + Ti + br], Zr = Hr * mi - vi * ei;
            ei = Hr * ei + vi * mi, mi = Zr, Ue[Pr + Ti] = wi + mi, tr[Pr + Ti] = ii + ei, Ue[Pr + Ti + br] = wi - mi, tr[Pr + Ti + br] = ii - ei, Ti !== nr && (Zr = Pe * Hr - ur * vi, vi = Pe * vi + ur * Hr, Hr = Zr);
          }
    }, Vr.prototype.guessLen13b = function(Ae, ze) {
      var Ue = Math.max(ze, Ae) | 1, tr = Ue & 1, lr = 0;
      for (Ue = Ue / 2 | 0; Ue; Ue = Ue >>> 1)
        lr++;
      return 1 << lr + 1 + tr;
    }, Vr.prototype.conjugate = function(Ae, ze, Ue) {
      if (!(Ue <= 1))
        for (var tr = 0; tr < Ue / 2; tr++) {
          var lr = Ae[tr];
          Ae[tr] = Ae[Ue - tr - 1], Ae[Ue - tr - 1] = lr, lr = ze[tr], ze[tr] = -ze[Ue - tr - 1], ze[Ue - tr - 1] = -lr;
        }
    }, Vr.prototype.normalize13b = function(Ae, ze) {
      for (var Ue = 0, tr = 0; tr < ze / 2; tr++) {
        var lr = Math.round(Ae[2 * tr + 1] / ze) * 8192 + Math.round(Ae[2 * tr] / ze) + Ue;
        Ae[tr] = lr & 67108863, lr < 67108864 ? Ue = 0 : Ue = lr / 67108864 | 0;
      }
      return Ae;
    }, Vr.prototype.convert13b = function(Ae, ze, Ue, tr) {
      for (var lr = 0, pr = 0; pr < ze; pr++)
        lr = lr + (Ae[pr] | 0), Ue[2 * pr] = lr & 8191, lr = lr >>> 13, Ue[2 * pr + 1] = lr & 8191, lr = lr >>> 13;
      for (pr = 2 * ze; pr < tr; ++pr)
        Ue[pr] = 0;
      we(lr === 0), we((lr & -8192) === 0);
    }, Vr.prototype.stub = function(Ae) {
      for (var ze = new Array(Ae), Ue = 0; Ue < Ae; Ue++)
        ze[Ue] = 0;
      return ze;
    }, Vr.prototype.mulp = function(Ae, ze, Ue) {
      var tr = 2 * this.guessLen13b(Ae.length, ze.length), lr = this.makeRBT(tr), pr = this.stub(tr), br = new Array(tr), nr = new Array(tr), Pe = new Array(tr), ur = new Array(tr), Pr = new Array(tr), Hr = new Array(tr), vi = Ue.words;
      vi.length = tr, this.convert13b(Ae.words, Ae.length, br, tr), this.convert13b(ze.words, ze.length, ur, tr), this.transform(br, pr, nr, Pe, tr, lr), this.transform(ur, pr, Pr, Hr, tr, lr);
      for (var Ti = 0; Ti < tr; Ti++) {
        var wi = nr[Ti] * Pr[Ti] - Pe[Ti] * Hr[Ti];
        Pe[Ti] = nr[Ti] * Hr[Ti] + Pe[Ti] * Pr[Ti], nr[Ti] = wi;
      }
      return this.conjugate(nr, Pe, tr), this.transform(nr, Pe, vi, pr, tr, lr), this.conjugate(vi, pr, tr), this.normalize13b(vi, tr), Ue.negative = Ae.negative ^ ze.negative, Ue.length = Ae.length + ze.length, Ue.strip();
    }, Me.prototype.mul = function(Ae) {
      var ze = new Me(null);
      return ze.words = new Array(this.length + Ae.length), this.mulTo(Ae, ze);
    }, Me.prototype.mulf = function(Ae) {
      var ze = new Me(null);
      return ze.words = new Array(this.length + Ae.length), Yr(this, Ae, ze);
    }, Me.prototype.imul = function(Ae) {
      return this.clone().mulTo(Ae, this);
    }, Me.prototype.imuln = function(Ae) {
      we(typeof Ae == "number"), we(Ae < 67108864);
      for (var ze = 0, Ue = 0; Ue < this.length; Ue++) {
        var tr = (this.words[Ue] | 0) * Ae, lr = (tr & 67108863) + (ze & 67108863);
        ze >>= 26, ze += tr / 67108864 | 0, ze += lr >>> 26, this.words[Ue] = lr & 67108863;
      }
      return ze !== 0 && (this.words[Ue] = ze, this.length++), this;
    }, Me.prototype.muln = function(Ae) {
      return this.clone().imuln(Ae);
    }, Me.prototype.sqr = function() {
      return this.mul(this);
    }, Me.prototype.isqr = function() {
      return this.imul(this.clone());
    }, Me.prototype.pow = function(Ae) {
      var ze = Ir(Ae);
      if (ze.length === 0)
        return new Me(1);
      for (var Ue = this, tr = 0; tr < ze.length && ze[tr] === 0; tr++, Ue = Ue.sqr())
        ;
      if (++tr < ze.length)
        for (var lr = Ue.sqr(); tr < ze.length; tr++, lr = lr.sqr())
          ze[tr] !== 0 && (Ue = Ue.mul(lr));
      return Ue;
    }, Me.prototype.iushln = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 67108863 >>> 26 - ze << 26 - ze, lr;
      if (ze !== 0) {
        var pr = 0;
        for (lr = 0; lr < this.length; lr++) {
          var br = this.words[lr] & tr, nr = (this.words[lr] | 0) - br << ze;
          this.words[lr] = nr | pr, pr = br >>> 26 - ze;
        }
        pr && (this.words[lr] = pr, this.length++);
      }
      if (Ue !== 0) {
        for (lr = this.length - 1; lr >= 0; lr--)
          this.words[lr + Ue] = this.words[lr];
        for (lr = 0; lr < Ue; lr++)
          this.words[lr] = 0;
        this.length += Ue;
      }
      return this.strip();
    }, Me.prototype.ishln = function(Ae) {
      return we(this.negative === 0), this.iushln(Ae);
    }, Me.prototype.iushrn = function(Ae, ze, Ue) {
      we(typeof Ae == "number" && Ae >= 0);
      var tr;
      ze ? tr = (ze - ze % 26) / 26 : tr = 0;
      var lr = Ae % 26, pr = Math.min((Ae - lr) / 26, this.length), br = 67108863 ^ 67108863 >>> lr << lr, nr = Ue;
      if (tr -= pr, tr = Math.max(0, tr), nr) {
        for (var Pe = 0; Pe < pr; Pe++)
          nr.words[Pe] = this.words[Pe];
        nr.length = pr;
      }
      if (pr !== 0)
        if (this.length > pr)
          for (this.length -= pr, Pe = 0; Pe < this.length; Pe++)
            this.words[Pe] = this.words[Pe + pr];
        else
          this.words[0] = 0, this.length = 1;
      var ur = 0;
      for (Pe = this.length - 1; Pe >= 0 && (ur !== 0 || Pe >= tr); Pe--) {
        var Pr = this.words[Pe] | 0;
        this.words[Pe] = ur << 26 - lr | Pr >>> lr, ur = Pr & br;
      }
      return nr && ur !== 0 && (nr.words[nr.length++] = ur), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, Me.prototype.ishrn = function(Ae, ze, Ue) {
      return we(this.negative === 0), this.iushrn(Ae, ze, Ue);
    }, Me.prototype.shln = function(Ae) {
      return this.clone().ishln(Ae);
    }, Me.prototype.ushln = function(Ae) {
      return this.clone().iushln(Ae);
    }, Me.prototype.shrn = function(Ae) {
      return this.clone().ishrn(Ae);
    }, Me.prototype.ushrn = function(Ae) {
      return this.clone().iushrn(Ae);
    }, Me.prototype.testn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 1 << ze;
      if (this.length <= Ue)
        return !1;
      var lr = this.words[Ue];
      return !!(lr & tr);
    }, Me.prototype.imaskn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26;
      if (we(this.negative === 0, "imaskn works only with positive numbers"), this.length <= Ue)
        return this;
      if (ze !== 0 && Ue++, this.length = Math.min(Ue, this.length), ze !== 0) {
        var tr = 67108863 ^ 67108863 >>> ze << ze;
        this.words[this.length - 1] &= tr;
      }
      return this.strip();
    }, Me.prototype.maskn = function(Ae) {
      return this.clone().imaskn(Ae);
    }, Me.prototype.iaddn = function(Ae) {
      return we(typeof Ae == "number"), we(Ae < 67108864), Ae < 0 ? this.isubn(-Ae) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Ae ? (this.words[0] = Ae - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ae), this.negative = 1, this) : this._iaddn(Ae);
    }, Me.prototype._iaddn = function(Ae) {
      this.words[0] += Ae;
      for (var ze = 0; ze < this.length && this.words[ze] >= 67108864; ze++)
        this.words[ze] -= 67108864, ze === this.length - 1 ? this.words[ze + 1] = 1 : this.words[ze + 1]++;
      return this.length = Math.max(this.length, ze + 1), this;
    }, Me.prototype.isubn = function(Ae) {
      if (we(typeof Ae == "number"), we(Ae < 67108864), Ae < 0)
        return this.iaddn(-Ae);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(Ae), this.negative = 1, this;
      if (this.words[0] -= Ae, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var ze = 0; ze < this.length && this.words[ze] < 0; ze++)
          this.words[ze] += 67108864, this.words[ze + 1] -= 1;
      return this.strip();
    }, Me.prototype.addn = function(Ae) {
      return this.clone().iaddn(Ae);
    }, Me.prototype.subn = function(Ae) {
      return this.clone().isubn(Ae);
    }, Me.prototype.iabs = function() {
      return this.negative = 0, this;
    }, Me.prototype.abs = function() {
      return this.clone().iabs();
    }, Me.prototype._ishlnsubmul = function(Ae, ze, Ue) {
      var tr = Ae.length + Ue, lr;
      this._expand(tr);
      var pr, br = 0;
      for (lr = 0; lr < Ae.length; lr++) {
        pr = (this.words[lr + Ue] | 0) + br;
        var nr = (Ae.words[lr] | 0) * ze;
        pr -= nr & 67108863, br = (pr >> 26) - (nr / 67108864 | 0), this.words[lr + Ue] = pr & 67108863;
      }
      for (; lr < this.length - Ue; lr++)
        pr = (this.words[lr + Ue] | 0) + br, br = pr >> 26, this.words[lr + Ue] = pr & 67108863;
      if (br === 0)
        return this.strip();
      for (we(br === -1), br = 0, lr = 0; lr < this.length; lr++)
        pr = -(this.words[lr] | 0) + br, br = pr >> 26, this.words[lr] = pr & 67108863;
      return this.negative = 1, this.strip();
    }, Me.prototype._wordDiv = function(Ae, ze) {
      var Ue = this.length - Ae.length, tr = this.clone(), lr = Ae, pr = lr.words[lr.length - 1] | 0, br = this._countBits(pr);
      Ue = 26 - br, Ue !== 0 && (lr = lr.ushln(Ue), tr.iushln(Ue), pr = lr.words[lr.length - 1] | 0);
      var nr = tr.length - lr.length, Pe;
      if (ze !== "mod") {
        Pe = new Me(null), Pe.length = nr + 1, Pe.words = new Array(Pe.length);
        for (var ur = 0; ur < Pe.length; ur++)
          Pe.words[ur] = 0;
      }
      var Pr = tr.clone()._ishlnsubmul(lr, 1, nr);
      Pr.negative === 0 && (tr = Pr, Pe && (Pe.words[nr] = 1));
      for (var Hr = nr - 1; Hr >= 0; Hr--) {
        var vi = (tr.words[lr.length + Hr] | 0) * 67108864 + (tr.words[lr.length + Hr - 1] | 0);
        for (vi = Math.min(vi / pr | 0, 67108863), tr._ishlnsubmul(lr, vi, Hr); tr.negative !== 0; )
          vi--, tr.negative = 0, tr._ishlnsubmul(lr, 1, Hr), tr.isZero() || (tr.negative ^= 1);
        Pe && (Pe.words[Hr] = vi);
      }
      return Pe && Pe.strip(), tr.strip(), ze !== "div" && Ue !== 0 && tr.iushrn(Ue), {
        div: Pe || null,
        mod: tr
      };
    }, Me.prototype.divmod = function(Ae, ze, Ue) {
      if (we(!Ae.isZero()), this.isZero())
        return {
          div: new Me(0),
          mod: new Me(0)
        };
      var tr, lr, pr;
      return this.negative !== 0 && Ae.negative === 0 ? (pr = this.neg().divmod(Ae, ze), ze !== "mod" && (tr = pr.div.neg()), ze !== "div" && (lr = pr.mod.neg(), Ue && lr.negative !== 0 && lr.iadd(Ae)), {
        div: tr,
        mod: lr
      }) : this.negative === 0 && Ae.negative !== 0 ? (pr = this.divmod(Ae.neg(), ze), ze !== "mod" && (tr = pr.div.neg()), {
        div: tr,
        mod: pr.mod
      }) : (this.negative & Ae.negative) !== 0 ? (pr = this.neg().divmod(Ae.neg(), ze), ze !== "div" && (lr = pr.mod.neg(), Ue && lr.negative !== 0 && lr.isub(Ae)), {
        div: pr.div,
        mod: lr
      }) : Ae.length > this.length || this.cmp(Ae) < 0 ? {
        div: new Me(0),
        mod: this
      } : Ae.length === 1 ? ze === "div" ? {
        div: this.divn(Ae.words[0]),
        mod: null
      } : ze === "mod" ? {
        div: null,
        mod: new Me(this.modn(Ae.words[0]))
      } : {
        div: this.divn(Ae.words[0]),
        mod: new Me(this.modn(Ae.words[0]))
      } : this._wordDiv(Ae, ze);
    }, Me.prototype.div = function(Ae) {
      return this.divmod(Ae, "div", !1).div;
    }, Me.prototype.mod = function(Ae) {
      return this.divmod(Ae, "mod", !1).mod;
    }, Me.prototype.umod = function(Ae) {
      return this.divmod(Ae, "mod", !0).mod;
    }, Me.prototype.divRound = function(Ae) {
      var ze = this.divmod(Ae);
      if (ze.mod.isZero())
        return ze.div;
      var Ue = ze.div.negative !== 0 ? ze.mod.isub(Ae) : ze.mod, tr = Ae.ushrn(1), lr = Ae.andln(1), pr = Ue.cmp(tr);
      return pr < 0 || lr === 1 && pr === 0 ? ze.div : ze.div.negative !== 0 ? ze.div.isubn(1) : ze.div.iaddn(1);
    }, Me.prototype.modn = function(Ae) {
      we(Ae <= 67108863);
      for (var ze = (1 << 26) % Ae, Ue = 0, tr = this.length - 1; tr >= 0; tr--)
        Ue = (ze * Ue + (this.words[tr] | 0)) % Ae;
      return Ue;
    }, Me.prototype.idivn = function(Ae) {
      we(Ae <= 67108863);
      for (var ze = 0, Ue = this.length - 1; Ue >= 0; Ue--) {
        var tr = (this.words[Ue] | 0) + ze * 67108864;
        this.words[Ue] = tr / Ae | 0, ze = tr % Ae;
      }
      return this.strip();
    }, Me.prototype.divn = function(Ae) {
      return this.clone().idivn(Ae);
    }, Me.prototype.egcd = function(Ae) {
      we(Ae.negative === 0), we(!Ae.isZero());
      var ze = this, Ue = Ae.clone();
      ze.negative !== 0 ? ze = ze.umod(Ae) : ze = ze.clone();
      for (var tr = new Me(1), lr = new Me(0), pr = new Me(0), br = new Me(1), nr = 0; ze.isEven() && Ue.isEven(); )
        ze.iushrn(1), Ue.iushrn(1), ++nr;
      for (var Pe = Ue.clone(), ur = ze.clone(); !ze.isZero(); ) {
        for (var Pr = 0, Hr = 1; (ze.words[0] & Hr) === 0 && Pr < 26; ++Pr, Hr <<= 1)
          ;
        if (Pr > 0)
          for (ze.iushrn(Pr); Pr-- > 0; )
            (tr.isOdd() || lr.isOdd()) && (tr.iadd(Pe), lr.isub(ur)), tr.iushrn(1), lr.iushrn(1);
        for (var vi = 0, Ti = 1; (Ue.words[0] & Ti) === 0 && vi < 26; ++vi, Ti <<= 1)
          ;
        if (vi > 0)
          for (Ue.iushrn(vi); vi-- > 0; )
            (pr.isOdd() || br.isOdd()) && (pr.iadd(Pe), br.isub(ur)), pr.iushrn(1), br.iushrn(1);
        ze.cmp(Ue) >= 0 ? (ze.isub(Ue), tr.isub(pr), lr.isub(br)) : (Ue.isub(ze), pr.isub(tr), br.isub(lr));
      }
      return {
        a: pr,
        b: br,
        gcd: Ue.iushln(nr)
      };
    }, Me.prototype._invmp = function(Ae) {
      we(Ae.negative === 0), we(!Ae.isZero());
      var ze = this, Ue = Ae.clone();
      ze.negative !== 0 ? ze = ze.umod(Ae) : ze = ze.clone();
      for (var tr = new Me(1), lr = new Me(0), pr = Ue.clone(); ze.cmpn(1) > 0 && Ue.cmpn(1) > 0; ) {
        for (var br = 0, nr = 1; (ze.words[0] & nr) === 0 && br < 26; ++br, nr <<= 1)
          ;
        if (br > 0)
          for (ze.iushrn(br); br-- > 0; )
            tr.isOdd() && tr.iadd(pr), tr.iushrn(1);
        for (var Pe = 0, ur = 1; (Ue.words[0] & ur) === 0 && Pe < 26; ++Pe, ur <<= 1)
          ;
        if (Pe > 0)
          for (Ue.iushrn(Pe); Pe-- > 0; )
            lr.isOdd() && lr.iadd(pr), lr.iushrn(1);
        ze.cmp(Ue) >= 0 ? (ze.isub(Ue), tr.isub(lr)) : (Ue.isub(ze), lr.isub(tr));
      }
      var Pr;
      return ze.cmpn(1) === 0 ? Pr = tr : Pr = lr, Pr.cmpn(0) < 0 && Pr.iadd(Ae), Pr;
    }, Me.prototype.gcd = function(Ae) {
      if (this.isZero())
        return Ae.abs();
      if (Ae.isZero())
        return this.abs();
      var ze = this.clone(), Ue = Ae.clone();
      ze.negative = 0, Ue.negative = 0;
      for (var tr = 0; ze.isEven() && Ue.isEven(); tr++)
        ze.iushrn(1), Ue.iushrn(1);
      do {
        for (; ze.isEven(); )
          ze.iushrn(1);
        for (; Ue.isEven(); )
          Ue.iushrn(1);
        var lr = ze.cmp(Ue);
        if (lr < 0) {
          var pr = ze;
          ze = Ue, Ue = pr;
        } else if (lr === 0 || Ue.cmpn(1) === 0)
          break;
        ze.isub(Ue);
      } while (!0);
      return Ue.iushln(tr);
    }, Me.prototype.invm = function(Ae) {
      return this.egcd(Ae).a.umod(Ae);
    }, Me.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, Me.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, Me.prototype.andln = function(Ae) {
      return this.words[0] & Ae;
    }, Me.prototype.bincn = function(Ae) {
      we(typeof Ae == "number");
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 1 << ze;
      if (this.length <= Ue)
        return this._expand(Ue + 1), this.words[Ue] |= tr, this;
      for (var lr = tr, pr = Ue; lr !== 0 && pr < this.length; pr++) {
        var br = this.words[pr] | 0;
        br += lr, lr = br >>> 26, br &= 67108863, this.words[pr] = br;
      }
      return lr !== 0 && (this.words[pr] = lr, this.length++), this;
    }, Me.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, Me.prototype.cmpn = function(Ae) {
      var ze = Ae < 0;
      if (this.negative !== 0 && !ze)
        return -1;
      if (this.negative === 0 && ze)
        return 1;
      this.strip();
      var Ue;
      if (this.length > 1)
        Ue = 1;
      else {
        ze && (Ae = -Ae), we(Ae <= 67108863, "Number is too big");
        var tr = this.words[0] | 0;
        Ue = tr === Ae ? 0 : tr < Ae ? -1 : 1;
      }
      return this.negative !== 0 ? -Ue | 0 : Ue;
    }, Me.prototype.cmp = function(Ae) {
      if (this.negative !== 0 && Ae.negative === 0)
        return -1;
      if (this.negative === 0 && Ae.negative !== 0)
        return 1;
      var ze = this.ucmp(Ae);
      return this.negative !== 0 ? -ze | 0 : ze;
    }, Me.prototype.ucmp = function(Ae) {
      if (this.length > Ae.length)
        return 1;
      if (this.length < Ae.length)
        return -1;
      for (var ze = 0, Ue = this.length - 1; Ue >= 0; Ue--) {
        var tr = this.words[Ue] | 0, lr = Ae.words[Ue] | 0;
        if (tr !== lr) {
          tr < lr ? ze = -1 : tr > lr && (ze = 1);
          break;
        }
      }
      return ze;
    }, Me.prototype.gtn = function(Ae) {
      return this.cmpn(Ae) === 1;
    }, Me.prototype.gt = function(Ae) {
      return this.cmp(Ae) === 1;
    }, Me.prototype.gten = function(Ae) {
      return this.cmpn(Ae) >= 0;
    }, Me.prototype.gte = function(Ae) {
      return this.cmp(Ae) >= 0;
    }, Me.prototype.ltn = function(Ae) {
      return this.cmpn(Ae) === -1;
    }, Me.prototype.lt = function(Ae) {
      return this.cmp(Ae) === -1;
    }, Me.prototype.lten = function(Ae) {
      return this.cmpn(Ae) <= 0;
    }, Me.prototype.lte = function(Ae) {
      return this.cmp(Ae) <= 0;
    }, Me.prototype.eqn = function(Ae) {
      return this.cmpn(Ae) === 0;
    }, Me.prototype.eq = function(Ae) {
      return this.cmp(Ae) === 0;
    }, Me.red = function(Ae) {
      return new oi(Ae);
    }, Me.prototype.toRed = function(Ae) {
      return we(!this.red, "Already a number in reduction context"), we(this.negative === 0, "red works only with positives"), Ae.convertTo(this)._forceRed(Ae);
    }, Me.prototype.fromRed = function() {
      return we(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, Me.prototype._forceRed = function(Ae) {
      return this.red = Ae, this;
    }, Me.prototype.forceRed = function(Ae) {
      return we(!this.red, "Already a number in reduction context"), this._forceRed(Ae);
    }, Me.prototype.redAdd = function(Ae) {
      return we(this.red, "redAdd works only with red numbers"), this.red.add(this, Ae);
    }, Me.prototype.redIAdd = function(Ae) {
      return we(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ae);
    }, Me.prototype.redSub = function(Ae) {
      return we(this.red, "redSub works only with red numbers"), this.red.sub(this, Ae);
    }, Me.prototype.redISub = function(Ae) {
      return we(this.red, "redISub works only with red numbers"), this.red.isub(this, Ae);
    }, Me.prototype.redShl = function(Ae) {
      return we(this.red, "redShl works only with red numbers"), this.red.shl(this, Ae);
    }, Me.prototype.redMul = function(Ae) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ae), this.red.mul(this, Ae);
    }, Me.prototype.redIMul = function(Ae) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ae), this.red.imul(this, Ae);
    }, Me.prototype.redSqr = function() {
      return we(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, Me.prototype.redISqr = function() {
      return we(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, Me.prototype.redSqrt = function() {
      return we(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, Me.prototype.redInvm = function() {
      return we(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, Me.prototype.redNeg = function() {
      return we(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, Me.prototype.redPow = function(Ae) {
      return we(this.red && !Ae.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ae);
    };
    var Xr = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Wr(vr, Ae) {
      this.name = vr, this.p = new Me(Ae, 16), this.n = this.p.bitLength(), this.k = new Me(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Wr.prototype._tmp = function() {
      var Ae = new Me(null);
      return Ae.words = new Array(Math.ceil(this.n / 13)), Ae;
    }, Wr.prototype.ireduce = function(Ae) {
      var ze = Ae, Ue;
      do
        this.split(ze, this.tmp), ze = this.imulK(ze), ze = ze.iadd(this.tmp), Ue = ze.bitLength();
      while (Ue > this.n);
      var tr = Ue < this.n ? -1 : ze.ucmp(this.p);
      return tr === 0 ? (ze.words[0] = 0, ze.length = 1) : tr > 0 ? ze.isub(this.p) : ze.strip !== void 0 ? ze.strip() : ze._strip(), ze;
    }, Wr.prototype.split = function(Ae, ze) {
      Ae.iushrn(this.n, 0, ze);
    }, Wr.prototype.imulK = function(Ae) {
      return Ae.imul(this.k);
    };
    function si() {
      Wr.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    $e(si, Wr), si.prototype.split = function(Ae, ze) {
      for (var Ue = 4194303, tr = Math.min(Ae.length, 9), lr = 0; lr < tr; lr++)
        ze.words[lr] = Ae.words[lr];
      if (ze.length = tr, Ae.length <= 9) {
        Ae.words[0] = 0, Ae.length = 1;
        return;
      }
      var pr = Ae.words[9];
      for (ze.words[ze.length++] = pr & Ue, lr = 10; lr < Ae.length; lr++) {
        var br = Ae.words[lr] | 0;
        Ae.words[lr - 10] = (br & Ue) << 4 | pr >>> 22, pr = br;
      }
      pr >>>= 22, Ae.words[lr - 10] = pr, pr === 0 && Ae.length > 10 ? Ae.length -= 10 : Ae.length -= 9;
    }, si.prototype.imulK = function(Ae) {
      Ae.words[Ae.length] = 0, Ae.words[Ae.length + 1] = 0, Ae.length += 2;
      for (var ze = 0, Ue = 0; Ue < Ae.length; Ue++) {
        var tr = Ae.words[Ue] | 0;
        ze += tr * 977, Ae.words[Ue] = ze & 67108863, ze = tr * 64 + (ze / 67108864 | 0);
      }
      return Ae.words[Ae.length - 1] === 0 && (Ae.length--, Ae.words[Ae.length - 1] === 0 && Ae.length--), Ae;
    };
    function li() {
      Wr.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    $e(li, Wr);
    function xi() {
      Wr.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    $e(xi, Wr);
    function di() {
      Wr.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    $e(di, Wr), di.prototype.imulK = function(Ae) {
      for (var ze = 0, Ue = 0; Ue < Ae.length; Ue++) {
        var tr = (Ae.words[Ue] | 0) * 19 + ze, lr = tr & 67108863;
        tr >>>= 26, Ae.words[Ue] = lr, ze = tr;
      }
      return ze !== 0 && (Ae.words[Ae.length++] = ze), Ae;
    }, Me._prime = function(Ae) {
      if (Xr[Ae])
        return Xr[Ae];
      var ze;
      if (Ae === "k256")
        ze = new si();
      else if (Ae === "p224")
        ze = new li();
      else if (Ae === "p192")
        ze = new xi();
      else if (Ae === "p25519")
        ze = new di();
      else
        throw new Error("Unknown prime " + Ae);
      return Xr[Ae] = ze, ze;
    };
    function oi(vr) {
      if (typeof vr == "string") {
        var Ae = Me._prime(vr);
        this.m = Ae.p, this.prime = Ae;
      } else
        we(vr.gtn(1), "modulus must be greater than 1"), this.m = vr, this.prime = null;
    }
    oi.prototype._verify1 = function(Ae) {
      we(Ae.negative === 0, "red works only with positives"), we(Ae.red, "red works only with red numbers");
    }, oi.prototype._verify2 = function(Ae, ze) {
      we((Ae.negative | ze.negative) === 0, "red works only with positives"), we(
        Ae.red && Ae.red === ze.red,
        "red works only with red numbers"
      );
    }, oi.prototype.imod = function(Ae) {
      return this.prime ? this.prime.ireduce(Ae)._forceRed(this) : Ae.umod(this.m)._forceRed(this);
    }, oi.prototype.neg = function(Ae) {
      return Ae.isZero() ? Ae.clone() : this.m.sub(Ae)._forceRed(this);
    }, oi.prototype.add = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.add(ze);
      return Ue.cmp(this.m) >= 0 && Ue.isub(this.m), Ue._forceRed(this);
    }, oi.prototype.iadd = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.iadd(ze);
      return Ue.cmp(this.m) >= 0 && Ue.isub(this.m), Ue;
    }, oi.prototype.sub = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.sub(ze);
      return Ue.cmpn(0) < 0 && Ue.iadd(this.m), Ue._forceRed(this);
    }, oi.prototype.isub = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.isub(ze);
      return Ue.cmpn(0) < 0 && Ue.iadd(this.m), Ue;
    }, oi.prototype.shl = function(Ae, ze) {
      return this._verify1(Ae), this.imod(Ae.ushln(ze));
    }, oi.prototype.imul = function(Ae, ze) {
      return this._verify2(Ae, ze), this.imod(Ae.imul(ze));
    }, oi.prototype.mul = function(Ae, ze) {
      return this._verify2(Ae, ze), this.imod(Ae.mul(ze));
    }, oi.prototype.isqr = function(Ae) {
      return this.imul(Ae, Ae.clone());
    }, oi.prototype.sqr = function(Ae) {
      return this.mul(Ae, Ae);
    }, oi.prototype.sqrt = function(Ae) {
      if (Ae.isZero())
        return Ae.clone();
      var ze = this.m.andln(3);
      if (we(ze % 2 === 1), ze === 3) {
        var Ue = this.m.add(new Me(1)).iushrn(2);
        return this.pow(Ae, Ue);
      }
      for (var tr = this.m.subn(1), lr = 0; !tr.isZero() && tr.andln(1) === 0; )
        lr++, tr.iushrn(1);
      we(!tr.isZero());
      var pr = new Me(1).toRed(this), br = pr.redNeg(), nr = this.m.subn(1).iushrn(1), Pe = this.m.bitLength();
      for (Pe = new Me(2 * Pe * Pe).toRed(this); this.pow(Pe, nr).cmp(br) !== 0; )
        Pe.redIAdd(br);
      for (var ur = this.pow(Pe, tr), Pr = this.pow(Ae, tr.addn(1).iushrn(1)), Hr = this.pow(Ae, tr), vi = lr; Hr.cmp(pr) !== 0; ) {
        for (var Ti = Hr, wi = 0; Ti.cmp(pr) !== 0; wi++)
          Ti = Ti.redSqr();
        we(wi < vi);
        var ii = this.pow(ur, new Me(1).iushln(vi - wi - 1));
        Pr = Pr.redMul(ii), ur = ii.redSqr(), Hr = Hr.redMul(ur), vi = wi;
      }
      return Pr;
    }, oi.prototype.invm = function(Ae) {
      var ze = Ae._invmp(this.m);
      return ze.negative !== 0 ? (ze.negative = 0, this.imod(ze).redNeg()) : this.imod(ze);
    }, oi.prototype.pow = function(Ae, ze) {
      if (ze.isZero())
        return new Me(1).toRed(this);
      if (ze.cmpn(1) === 0)
        return Ae.clone();
      var Ue = 4, tr = new Array(1 << Ue);
      tr[0] = new Me(1).toRed(this), tr[1] = Ae;
      for (var lr = 2; lr < tr.length; lr++)
        tr[lr] = this.mul(tr[lr - 1], Ae);
      var pr = tr[0], br = 0, nr = 0, Pe = ze.bitLength() % 26;
      for (Pe === 0 && (Pe = 26), lr = ze.length - 1; lr >= 0; lr--) {
        for (var ur = ze.words[lr], Pr = Pe - 1; Pr >= 0; Pr--) {
          var Hr = ur >> Pr & 1;
          if (pr !== tr[0] && (pr = this.sqr(pr)), Hr === 0 && br === 0) {
            nr = 0;
            continue;
          }
          br <<= 1, br |= Hr, nr++, !(nr !== Ue && (lr !== 0 || Pr !== 0)) && (pr = this.mul(pr, tr[br]), nr = 0, br = 0);
        }
        Pe = 26;
      }
      return pr;
    }, oi.prototype.convertTo = function(Ae) {
      var ze = Ae.umod(this.m);
      return ze === Ae ? ze.clone() : ze;
    }, oi.prototype.convertFrom = function(Ae) {
      var ze = Ae.clone();
      return ze.red = null, ze;
    }, Me.mont = function(Ae) {
      return new ci(Ae);
    };
    function ci(vr) {
      oi.call(this, vr), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new Me(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    $e(ci, oi), ci.prototype.convertTo = function(Ae) {
      return this.imod(Ae.ushln(this.shift));
    }, ci.prototype.convertFrom = function(Ae) {
      var ze = this.imod(Ae.mul(this.rinv));
      return ze.red = null, ze;
    }, ci.prototype.imul = function(Ae, ze) {
      if (Ae.isZero() || ze.isZero())
        return Ae.words[0] = 0, Ae.length = 1, Ae;
      var Ue = Ae.imul(ze), tr = Ue.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), lr = Ue.isub(tr).iushrn(this.shift), pr = lr;
      return lr.cmp(this.m) >= 0 ? pr = lr.isub(this.m) : lr.cmpn(0) < 0 && (pr = lr.iadd(this.m)), pr._forceRed(this);
    }, ci.prototype.mul = function(Ae, ze) {
      if (Ae.isZero() || ze.isZero())
        return new Me(0)._forceRed(this);
      var Ue = Ae.mul(ze), tr = Ue.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), lr = Ue.isub(tr).iushrn(this.shift), pr = lr;
      return lr.cmp(this.m) >= 0 ? pr = lr.isub(this.m) : lr.cmpn(0) < 0 && (pr = lr.iadd(this.m)), pr._forceRed(this);
    }, ci.prototype.invm = function(Ae) {
      var ze = this.imod(Ae._invmp(this.m).mul(this.r2));
      return ze._forceRed(this);
    };
  })(m, commonjsGlobal);
})(bn$6);
var bn$5 = { exports: {} };
(function(m) {
  (function(c, ie) {
    function we(vr, Ae) {
      if (!vr)
        throw new Error(Ae || "Assertion failed");
    }
    function $e(vr, Ae) {
      vr.super_ = Ae;
      var ze = function() {
      };
      ze.prototype = Ae.prototype, vr.prototype = new ze(), vr.prototype.constructor = vr;
    }
    function Me(vr, Ae, ze) {
      if (Me.isBN(vr))
        return vr;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, vr !== null && ((Ae === "le" || Ae === "be") && (ze = Ae, Ae = 10), this._init(vr || 0, Ae || 10, ze || "be"));
    }
    typeof c == "object" ? c.exports = Me : ie.BN = Me, Me.BN = Me, Me.wordSize = 26;
    var Ze;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? Ze = window.Buffer : Ze = require$$0$4.Buffer;
    } catch {
    }
    Me.isBN = function(Ae) {
      return Ae instanceof Me ? !0 : Ae !== null && typeof Ae == "object" && Ae.constructor.wordSize === Me.wordSize && Array.isArray(Ae.words);
    }, Me.max = function(Ae, ze) {
      return Ae.cmp(ze) > 0 ? Ae : ze;
    }, Me.min = function(Ae, ze) {
      return Ae.cmp(ze) < 0 ? Ae : ze;
    }, Me.prototype._init = function(Ae, ze, Ue) {
      if (typeof Ae == "number")
        return this._initNumber(Ae, ze, Ue);
      if (typeof Ae == "object")
        return this._initArray(Ae, ze, Ue);
      ze === "hex" && (ze = 16), we(ze === (ze | 0) && ze >= 2 && ze <= 36), Ae = Ae.toString().replace(/\s+/g, "");
      var tr = 0;
      Ae[0] === "-" && (tr++, this.negative = 1), tr < Ae.length && (ze === 16 ? this._parseHex(Ae, tr, Ue) : (this._parseBase(Ae, ze, tr), Ue === "le" && this._initArray(this.toArray(), ze, Ue)));
    }, Me.prototype._initNumber = function(Ae, ze, Ue) {
      Ae < 0 && (this.negative = 1, Ae = -Ae), Ae < 67108864 ? (this.words = [Ae & 67108863], this.length = 1) : Ae < 4503599627370496 ? (this.words = [
        Ae & 67108863,
        Ae / 67108864 & 67108863
      ], this.length = 2) : (we(Ae < 9007199254740992), this.words = [
        Ae & 67108863,
        Ae / 67108864 & 67108863,
        1
      ], this.length = 3), Ue === "le" && this._initArray(this.toArray(), ze, Ue);
    }, Me.prototype._initArray = function(Ae, ze, Ue) {
      if (we(typeof Ae.length == "number"), Ae.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(Ae.length / 3), this.words = new Array(this.length);
      for (var tr = 0; tr < this.length; tr++)
        this.words[tr] = 0;
      var lr, pr, br = 0;
      if (Ue === "be")
        for (tr = Ae.length - 1, lr = 0; tr >= 0; tr -= 3)
          pr = Ae[tr] | Ae[tr - 1] << 8 | Ae[tr - 2] << 16, this.words[lr] |= pr << br & 67108863, this.words[lr + 1] = pr >>> 26 - br & 67108863, br += 24, br >= 26 && (br -= 26, lr++);
      else if (Ue === "le")
        for (tr = 0, lr = 0; tr < Ae.length; tr += 3)
          pr = Ae[tr] | Ae[tr + 1] << 8 | Ae[tr + 2] << 16, this.words[lr] |= pr << br & 67108863, this.words[lr + 1] = pr >>> 26 - br & 67108863, br += 24, br >= 26 && (br -= 26, lr++);
      return this.strip();
    };
    function ne(vr, Ae) {
      var ze = vr.charCodeAt(Ae);
      return ze >= 65 && ze <= 70 ? ze - 55 : ze >= 97 && ze <= 102 ? ze - 87 : ze - 48 & 15;
    }
    function rr(vr, Ae, ze) {
      var Ue = ne(vr, ze);
      return ze - 1 >= Ae && (Ue |= ne(vr, ze - 1) << 4), Ue;
    }
    Me.prototype._parseHex = function(Ae, ze, Ue) {
      this.length = Math.ceil((Ae.length - ze) / 6), this.words = new Array(this.length);
      for (var tr = 0; tr < this.length; tr++)
        this.words[tr] = 0;
      var lr = 0, pr = 0, br;
      if (Ue === "be")
        for (tr = Ae.length - 1; tr >= ze; tr -= 2)
          br = rr(Ae, ze, tr) << lr, this.words[pr] |= br & 67108863, lr >= 18 ? (lr -= 18, pr += 1, this.words[pr] |= br >>> 26) : lr += 8;
      else {
        var nr = Ae.length - ze;
        for (tr = nr % 2 === 0 ? ze + 1 : ze; tr < Ae.length; tr += 2)
          br = rr(Ae, ze, tr) << lr, this.words[pr] |= br & 67108863, lr >= 18 ? (lr -= 18, pr += 1, this.words[pr] |= br >>> 26) : lr += 8;
      }
      this.strip();
    };
    function gr(vr, Ae, ze, Ue) {
      for (var tr = 0, lr = Math.min(vr.length, ze), pr = Ae; pr < lr; pr++) {
        var br = vr.charCodeAt(pr) - 48;
        tr *= Ue, br >= 49 ? tr += br - 49 + 10 : br >= 17 ? tr += br - 17 + 10 : tr += br;
      }
      return tr;
    }
    Me.prototype._parseBase = function(Ae, ze, Ue) {
      this.words = [0], this.length = 1;
      for (var tr = 0, lr = 1; lr <= 67108863; lr *= ze)
        tr++;
      tr--, lr = lr / ze | 0;
      for (var pr = Ae.length - Ue, br = pr % tr, nr = Math.min(pr, pr - br) + Ue, Pe = 0, ur = Ue; ur < nr; ur += tr)
        Pe = gr(Ae, ur, ur + tr, ze), this.imuln(lr), this.words[0] + Pe < 67108864 ? this.words[0] += Pe : this._iaddn(Pe);
      if (br !== 0) {
        var Pr = 1;
        for (Pe = gr(Ae, ur, Ae.length, ze), ur = 0; ur < br; ur++)
          Pr *= ze;
        this.imuln(Pr), this.words[0] + Pe < 67108864 ? this.words[0] += Pe : this._iaddn(Pe);
      }
      this.strip();
    }, Me.prototype.copy = function(Ae) {
      Ae.words = new Array(this.length);
      for (var ze = 0; ze < this.length; ze++)
        Ae.words[ze] = this.words[ze];
      Ae.length = this.length, Ae.negative = this.negative, Ae.red = this.red;
    }, Me.prototype.clone = function() {
      var Ae = new Me(null);
      return this.copy(Ae), Ae;
    }, Me.prototype._expand = function(Ae) {
      for (; this.length < Ae; )
        this.words[this.length++] = 0;
      return this;
    }, Me.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, Me.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, Me.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var or = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], _r = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Lr = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    Me.prototype.toString = function(Ae, ze) {
      Ae = Ae || 10, ze = ze | 0 || 1;
      var Ue;
      if (Ae === 16 || Ae === "hex") {
        Ue = "";
        for (var tr = 0, lr = 0, pr = 0; pr < this.length; pr++) {
          var br = this.words[pr], nr = ((br << tr | lr) & 16777215).toString(16);
          lr = br >>> 24 - tr & 16777215, tr += 2, tr >= 26 && (tr -= 26, pr--), lr !== 0 || pr !== this.length - 1 ? Ue = or[6 - nr.length] + nr + Ue : Ue = nr + Ue;
        }
        for (lr !== 0 && (Ue = lr.toString(16) + Ue); Ue.length % ze !== 0; )
          Ue = "0" + Ue;
        return this.negative !== 0 && (Ue = "-" + Ue), Ue;
      }
      if (Ae === (Ae | 0) && Ae >= 2 && Ae <= 36) {
        var Pe = _r[Ae], ur = Lr[Ae];
        Ue = "";
        var Pr = this.clone();
        for (Pr.negative = 0; !Pr.isZero(); ) {
          var Hr = Pr.modn(ur).toString(Ae);
          Pr = Pr.idivn(ur), Pr.isZero() ? Ue = Hr + Ue : Ue = or[Pe - Hr.length] + Hr + Ue;
        }
        for (this.isZero() && (Ue = "0" + Ue); Ue.length % ze !== 0; )
          Ue = "0" + Ue;
        return this.negative !== 0 && (Ue = "-" + Ue), Ue;
      }
      we(!1, "Base should be between 2 and 36");
    }, Me.prototype.toNumber = function() {
      var Ae = this.words[0];
      return this.length === 2 ? Ae += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ae += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && we(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ae : Ae;
    }, Me.prototype.toJSON = function() {
      return this.toString(16);
    }, Me.prototype.toBuffer = function(Ae, ze) {
      return we(typeof Ze < "u"), this.toArrayLike(Ze, Ae, ze);
    }, Me.prototype.toArray = function(Ae, ze) {
      return this.toArrayLike(Array, Ae, ze);
    }, Me.prototype.toArrayLike = function(Ae, ze, Ue) {
      var tr = this.byteLength(), lr = Ue || Math.max(1, tr);
      we(tr <= lr, "byte array longer than desired length"), we(lr > 0, "Requested array length <= 0"), this.strip();
      var pr = ze === "le", br = new Ae(lr), nr, Pe, ur = this.clone();
      if (pr) {
        for (Pe = 0; !ur.isZero(); Pe++)
          nr = ur.andln(255), ur.iushrn(8), br[Pe] = nr;
        for (; Pe < lr; Pe++)
          br[Pe] = 0;
      } else {
        for (Pe = 0; Pe < lr - tr; Pe++)
          br[Pe] = 0;
        for (Pe = 0; !ur.isZero(); Pe++)
          nr = ur.andln(255), ur.iushrn(8), br[lr - Pe - 1] = nr;
      }
      return br;
    }, Math.clz32 ? Me.prototype._countBits = function(Ae) {
      return 32 - Math.clz32(Ae);
    } : Me.prototype._countBits = function(Ae) {
      var ze = Ae, Ue = 0;
      return ze >= 4096 && (Ue += 13, ze >>>= 13), ze >= 64 && (Ue += 7, ze >>>= 7), ze >= 8 && (Ue += 4, ze >>>= 4), ze >= 2 && (Ue += 2, ze >>>= 2), Ue + ze;
    }, Me.prototype._zeroBits = function(Ae) {
      if (Ae === 0)
        return 26;
      var ze = Ae, Ue = 0;
      return (ze & 8191) === 0 && (Ue += 13, ze >>>= 13), (ze & 127) === 0 && (Ue += 7, ze >>>= 7), (ze & 15) === 0 && (Ue += 4, ze >>>= 4), (ze & 3) === 0 && (Ue += 2, ze >>>= 2), (ze & 1) === 0 && Ue++, Ue;
    }, Me.prototype.bitLength = function() {
      var Ae = this.words[this.length - 1], ze = this._countBits(Ae);
      return (this.length - 1) * 26 + ze;
    };
    function Ir(vr) {
      for (var Ae = new Array(vr.bitLength()), ze = 0; ze < Ae.length; ze++) {
        var Ue = ze / 26 | 0, tr = ze % 26;
        Ae[ze] = (vr.words[Ue] & 1 << tr) >>> tr;
      }
      return Ae;
    }
    Me.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var Ae = 0, ze = 0; ze < this.length; ze++) {
        var Ue = this._zeroBits(this.words[ze]);
        if (Ae += Ue, Ue !== 26)
          break;
      }
      return Ae;
    }, Me.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, Me.prototype.toTwos = function(Ae) {
      return this.negative !== 0 ? this.abs().inotn(Ae).iaddn(1) : this.clone();
    }, Me.prototype.fromTwos = function(Ae) {
      return this.testn(Ae - 1) ? this.notn(Ae).iaddn(1).ineg() : this.clone();
    }, Me.prototype.isNeg = function() {
      return this.negative !== 0;
    }, Me.prototype.neg = function() {
      return this.clone().ineg();
    }, Me.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, Me.prototype.iuor = function(Ae) {
      for (; this.length < Ae.length; )
        this.words[this.length++] = 0;
      for (var ze = 0; ze < Ae.length; ze++)
        this.words[ze] = this.words[ze] | Ae.words[ze];
      return this.strip();
    }, Me.prototype.ior = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuor(Ae);
    }, Me.prototype.or = function(Ae) {
      return this.length > Ae.length ? this.clone().ior(Ae) : Ae.clone().ior(this);
    }, Me.prototype.uor = function(Ae) {
      return this.length > Ae.length ? this.clone().iuor(Ae) : Ae.clone().iuor(this);
    }, Me.prototype.iuand = function(Ae) {
      var ze;
      this.length > Ae.length ? ze = Ae : ze = this;
      for (var Ue = 0; Ue < ze.length; Ue++)
        this.words[Ue] = this.words[Ue] & Ae.words[Ue];
      return this.length = ze.length, this.strip();
    }, Me.prototype.iand = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuand(Ae);
    }, Me.prototype.and = function(Ae) {
      return this.length > Ae.length ? this.clone().iand(Ae) : Ae.clone().iand(this);
    }, Me.prototype.uand = function(Ae) {
      return this.length > Ae.length ? this.clone().iuand(Ae) : Ae.clone().iuand(this);
    }, Me.prototype.iuxor = function(Ae) {
      var ze, Ue;
      this.length > Ae.length ? (ze = this, Ue = Ae) : (ze = Ae, Ue = this);
      for (var tr = 0; tr < Ue.length; tr++)
        this.words[tr] = ze.words[tr] ^ Ue.words[tr];
      if (this !== ze)
        for (; tr < ze.length; tr++)
          this.words[tr] = ze.words[tr];
      return this.length = ze.length, this.strip();
    }, Me.prototype.ixor = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuxor(Ae);
    }, Me.prototype.xor = function(Ae) {
      return this.length > Ae.length ? this.clone().ixor(Ae) : Ae.clone().ixor(this);
    }, Me.prototype.uxor = function(Ae) {
      return this.length > Ae.length ? this.clone().iuxor(Ae) : Ae.clone().iuxor(this);
    }, Me.prototype.inotn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Math.ceil(Ae / 26) | 0, Ue = Ae % 26;
      this._expand(ze), Ue > 0 && ze--;
      for (var tr = 0; tr < ze; tr++)
        this.words[tr] = ~this.words[tr] & 67108863;
      return Ue > 0 && (this.words[tr] = ~this.words[tr] & 67108863 >> 26 - Ue), this.strip();
    }, Me.prototype.notn = function(Ae) {
      return this.clone().inotn(Ae);
    }, Me.prototype.setn = function(Ae, ze) {
      we(typeof Ae == "number" && Ae >= 0);
      var Ue = Ae / 26 | 0, tr = Ae % 26;
      return this._expand(Ue + 1), ze ? this.words[Ue] = this.words[Ue] | 1 << tr : this.words[Ue] = this.words[Ue] & ~(1 << tr), this.strip();
    }, Me.prototype.iadd = function(Ae) {
      var ze;
      if (this.negative !== 0 && Ae.negative === 0)
        return this.negative = 0, ze = this.isub(Ae), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && Ae.negative !== 0)
        return Ae.negative = 0, ze = this.isub(Ae), Ae.negative = 1, ze._normSign();
      var Ue, tr;
      this.length > Ae.length ? (Ue = this, tr = Ae) : (Ue = Ae, tr = this);
      for (var lr = 0, pr = 0; pr < tr.length; pr++)
        ze = (Ue.words[pr] | 0) + (tr.words[pr] | 0) + lr, this.words[pr] = ze & 67108863, lr = ze >>> 26;
      for (; lr !== 0 && pr < Ue.length; pr++)
        ze = (Ue.words[pr] | 0) + lr, this.words[pr] = ze & 67108863, lr = ze >>> 26;
      if (this.length = Ue.length, lr !== 0)
        this.words[this.length] = lr, this.length++;
      else if (Ue !== this)
        for (; pr < Ue.length; pr++)
          this.words[pr] = Ue.words[pr];
      return this;
    }, Me.prototype.add = function(Ae) {
      var ze;
      return Ae.negative !== 0 && this.negative === 0 ? (Ae.negative = 0, ze = this.sub(Ae), Ae.negative ^= 1, ze) : Ae.negative === 0 && this.negative !== 0 ? (this.negative = 0, ze = Ae.sub(this), this.negative = 1, ze) : this.length > Ae.length ? this.clone().iadd(Ae) : Ae.clone().iadd(this);
    }, Me.prototype.isub = function(Ae) {
      if (Ae.negative !== 0) {
        Ae.negative = 0;
        var ze = this.iadd(Ae);
        return Ae.negative = 1, ze._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(Ae), this.negative = 1, this._normSign();
      var Ue = this.cmp(Ae);
      if (Ue === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var tr, lr;
      Ue > 0 ? (tr = this, lr = Ae) : (tr = Ae, lr = this);
      for (var pr = 0, br = 0; br < lr.length; br++)
        ze = (tr.words[br] | 0) - (lr.words[br] | 0) + pr, pr = ze >> 26, this.words[br] = ze & 67108863;
      for (; pr !== 0 && br < tr.length; br++)
        ze = (tr.words[br] | 0) + pr, pr = ze >> 26, this.words[br] = ze & 67108863;
      if (pr === 0 && br < tr.length && tr !== this)
        for (; br < tr.length; br++)
          this.words[br] = tr.words[br];
      return this.length = Math.max(this.length, br), tr !== this && (this.negative = 1), this.strip();
    }, Me.prototype.sub = function(Ae) {
      return this.clone().isub(Ae);
    };
    function Ar(vr, Ae, ze) {
      ze.negative = Ae.negative ^ vr.negative;
      var Ue = vr.length + Ae.length | 0;
      ze.length = Ue, Ue = Ue - 1 | 0;
      var tr = vr.words[0] | 0, lr = Ae.words[0] | 0, pr = tr * lr, br = pr & 67108863, nr = pr / 67108864 | 0;
      ze.words[0] = br;
      for (var Pe = 1; Pe < Ue; Pe++) {
        for (var ur = nr >>> 26, Pr = nr & 67108863, Hr = Math.min(Pe, Ae.length - 1), vi = Math.max(0, Pe - vr.length + 1); vi <= Hr; vi++) {
          var Ti = Pe - vi | 0;
          tr = vr.words[Ti] | 0, lr = Ae.words[vi] | 0, pr = tr * lr + Pr, ur += pr / 67108864 | 0, Pr = pr & 67108863;
        }
        ze.words[Pe] = Pr | 0, nr = ur | 0;
      }
      return nr !== 0 ? ze.words[Pe] = nr | 0 : ze.length--, ze.strip();
    }
    var Rr = function(Ae, ze, Ue) {
      var tr = Ae.words, lr = ze.words, pr = Ue.words, br = 0, nr, Pe, ur, Pr = tr[0] | 0, Hr = Pr & 8191, vi = Pr >>> 13, Ti = tr[1] | 0, wi = Ti & 8191, ii = Ti >>> 13, mi = tr[2] | 0, ei = mi & 8191, Zr = mi >>> 13, pi = tr[3] | 0, hi = pi & 8191, Oi = pi >>> 13, qi = tr[4] | 0, yn = qi & 8191, sn = qi >>> 13, $n = tr[5] | 0, rn = $n & 8191, ji = $n >>> 13, Kn = tr[6] | 0, In = Kn & 8191, Fn = Kn >>> 13, Po = tr[7] | 0, vn = Po & 8191, Vn = Po >>> 13, Xo = tr[8] | 0, Xn = Xo & 8191, Yn = Xo >>> 13, Wo = tr[9] | 0, Ci = Wo & 8191, ri = Wo >>> 13, yi = lr[0] | 0, Li = yi & 8191, Yi = yi >>> 13, zn = lr[1] | 0, un = zn & 8191, Gn = zn >>> 13, Mn = lr[2] | 0, pn = Mn & 8191, Rn = Mn >>> 13, Io = lr[3] | 0, to = Io & 8191, no = Io >>> 13, ma = lr[4] | 0, Qn = ma & 8191, co = ma >>> 13, kn = lr[5] | 0, ai = kn & 8191, _i = kn >>> 13, Pi = lr[6] | 0, Ai = Pi & 8191, ki = Pi >>> 13, an = lr[7] | 0, Ui = an & 8191, Vi = an >>> 13, Sn = lr[8] | 0, Hi = Sn & 8191, en = Sn >>> 13, qn = lr[9] | 0, _n = qn & 8191, Tn = qn >>> 13;
      Ue.negative = Ae.negative ^ ze.negative, Ue.length = 19, nr = Math.imul(Hr, Li), Pe = Math.imul(Hr, Yi), Pe = Pe + Math.imul(vi, Li) | 0, ur = Math.imul(vi, Yi);
      var xo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (xo >>> 26) | 0, xo &= 67108863, nr = Math.imul(wi, Li), Pe = Math.imul(wi, Yi), Pe = Pe + Math.imul(ii, Li) | 0, ur = Math.imul(ii, Yi), nr = nr + Math.imul(Hr, un) | 0, Pe = Pe + Math.imul(Hr, Gn) | 0, Pe = Pe + Math.imul(vi, un) | 0, ur = ur + Math.imul(vi, Gn) | 0;
      var Co = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Co >>> 26) | 0, Co &= 67108863, nr = Math.imul(ei, Li), Pe = Math.imul(ei, Yi), Pe = Pe + Math.imul(Zr, Li) | 0, ur = Math.imul(Zr, Yi), nr = nr + Math.imul(wi, un) | 0, Pe = Pe + Math.imul(wi, Gn) | 0, Pe = Pe + Math.imul(ii, un) | 0, ur = ur + Math.imul(ii, Gn) | 0, nr = nr + Math.imul(Hr, pn) | 0, Pe = Pe + Math.imul(Hr, Rn) | 0, Pe = Pe + Math.imul(vi, pn) | 0, ur = ur + Math.imul(vi, Rn) | 0;
      var $o = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + ($o >>> 26) | 0, $o &= 67108863, nr = Math.imul(hi, Li), Pe = Math.imul(hi, Yi), Pe = Pe + Math.imul(Oi, Li) | 0, ur = Math.imul(Oi, Yi), nr = nr + Math.imul(ei, un) | 0, Pe = Pe + Math.imul(ei, Gn) | 0, Pe = Pe + Math.imul(Zr, un) | 0, ur = ur + Math.imul(Zr, Gn) | 0, nr = nr + Math.imul(wi, pn) | 0, Pe = Pe + Math.imul(wi, Rn) | 0, Pe = Pe + Math.imul(ii, pn) | 0, ur = ur + Math.imul(ii, Rn) | 0, nr = nr + Math.imul(Hr, to) | 0, Pe = Pe + Math.imul(Hr, no) | 0, Pe = Pe + Math.imul(vi, to) | 0, ur = ur + Math.imul(vi, no) | 0;
      var Bo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Bo >>> 26) | 0, Bo &= 67108863, nr = Math.imul(yn, Li), Pe = Math.imul(yn, Yi), Pe = Pe + Math.imul(sn, Li) | 0, ur = Math.imul(sn, Yi), nr = nr + Math.imul(hi, un) | 0, Pe = Pe + Math.imul(hi, Gn) | 0, Pe = Pe + Math.imul(Oi, un) | 0, ur = ur + Math.imul(Oi, Gn) | 0, nr = nr + Math.imul(ei, pn) | 0, Pe = Pe + Math.imul(ei, Rn) | 0, Pe = Pe + Math.imul(Zr, pn) | 0, ur = ur + Math.imul(Zr, Rn) | 0, nr = nr + Math.imul(wi, to) | 0, Pe = Pe + Math.imul(wi, no) | 0, Pe = Pe + Math.imul(ii, to) | 0, ur = ur + Math.imul(ii, no) | 0, nr = nr + Math.imul(Hr, Qn) | 0, Pe = Pe + Math.imul(Hr, co) | 0, Pe = Pe + Math.imul(vi, Qn) | 0, ur = ur + Math.imul(vi, co) | 0;
      var Qo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Qo >>> 26) | 0, Qo &= 67108863, nr = Math.imul(rn, Li), Pe = Math.imul(rn, Yi), Pe = Pe + Math.imul(ji, Li) | 0, ur = Math.imul(ji, Yi), nr = nr + Math.imul(yn, un) | 0, Pe = Pe + Math.imul(yn, Gn) | 0, Pe = Pe + Math.imul(sn, un) | 0, ur = ur + Math.imul(sn, Gn) | 0, nr = nr + Math.imul(hi, pn) | 0, Pe = Pe + Math.imul(hi, Rn) | 0, Pe = Pe + Math.imul(Oi, pn) | 0, ur = ur + Math.imul(Oi, Rn) | 0, nr = nr + Math.imul(ei, to) | 0, Pe = Pe + Math.imul(ei, no) | 0, Pe = Pe + Math.imul(Zr, to) | 0, ur = ur + Math.imul(Zr, no) | 0, nr = nr + Math.imul(wi, Qn) | 0, Pe = Pe + Math.imul(wi, co) | 0, Pe = Pe + Math.imul(ii, Qn) | 0, ur = ur + Math.imul(ii, co) | 0, nr = nr + Math.imul(Hr, ai) | 0, Pe = Pe + Math.imul(Hr, _i) | 0, Pe = Pe + Math.imul(vi, ai) | 0, ur = ur + Math.imul(vi, _i) | 0;
      var Go = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Go >>> 26) | 0, Go &= 67108863, nr = Math.imul(In, Li), Pe = Math.imul(In, Yi), Pe = Pe + Math.imul(Fn, Li) | 0, ur = Math.imul(Fn, Yi), nr = nr + Math.imul(rn, un) | 0, Pe = Pe + Math.imul(rn, Gn) | 0, Pe = Pe + Math.imul(ji, un) | 0, ur = ur + Math.imul(ji, Gn) | 0, nr = nr + Math.imul(yn, pn) | 0, Pe = Pe + Math.imul(yn, Rn) | 0, Pe = Pe + Math.imul(sn, pn) | 0, ur = ur + Math.imul(sn, Rn) | 0, nr = nr + Math.imul(hi, to) | 0, Pe = Pe + Math.imul(hi, no) | 0, Pe = Pe + Math.imul(Oi, to) | 0, ur = ur + Math.imul(Oi, no) | 0, nr = nr + Math.imul(ei, Qn) | 0, Pe = Pe + Math.imul(ei, co) | 0, Pe = Pe + Math.imul(Zr, Qn) | 0, ur = ur + Math.imul(Zr, co) | 0, nr = nr + Math.imul(wi, ai) | 0, Pe = Pe + Math.imul(wi, _i) | 0, Pe = Pe + Math.imul(ii, ai) | 0, ur = ur + Math.imul(ii, _i) | 0, nr = nr + Math.imul(Hr, Ai) | 0, Pe = Pe + Math.imul(Hr, ki) | 0, Pe = Pe + Math.imul(vi, Ai) | 0, ur = ur + Math.imul(vi, ki) | 0;
      var No = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, nr = Math.imul(vn, Li), Pe = Math.imul(vn, Yi), Pe = Pe + Math.imul(Vn, Li) | 0, ur = Math.imul(Vn, Yi), nr = nr + Math.imul(In, un) | 0, Pe = Pe + Math.imul(In, Gn) | 0, Pe = Pe + Math.imul(Fn, un) | 0, ur = ur + Math.imul(Fn, Gn) | 0, nr = nr + Math.imul(rn, pn) | 0, Pe = Pe + Math.imul(rn, Rn) | 0, Pe = Pe + Math.imul(ji, pn) | 0, ur = ur + Math.imul(ji, Rn) | 0, nr = nr + Math.imul(yn, to) | 0, Pe = Pe + Math.imul(yn, no) | 0, Pe = Pe + Math.imul(sn, to) | 0, ur = ur + Math.imul(sn, no) | 0, nr = nr + Math.imul(hi, Qn) | 0, Pe = Pe + Math.imul(hi, co) | 0, Pe = Pe + Math.imul(Oi, Qn) | 0, ur = ur + Math.imul(Oi, co) | 0, nr = nr + Math.imul(ei, ai) | 0, Pe = Pe + Math.imul(ei, _i) | 0, Pe = Pe + Math.imul(Zr, ai) | 0, ur = ur + Math.imul(Zr, _i) | 0, nr = nr + Math.imul(wi, Ai) | 0, Pe = Pe + Math.imul(wi, ki) | 0, Pe = Pe + Math.imul(ii, Ai) | 0, ur = ur + Math.imul(ii, ki) | 0, nr = nr + Math.imul(Hr, Ui) | 0, Pe = Pe + Math.imul(Hr, Vi) | 0, Pe = Pe + Math.imul(vi, Ui) | 0, ur = ur + Math.imul(vi, Vi) | 0;
      var Zo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Zo >>> 26) | 0, Zo &= 67108863, nr = Math.imul(Xn, Li), Pe = Math.imul(Xn, Yi), Pe = Pe + Math.imul(Yn, Li) | 0, ur = Math.imul(Yn, Yi), nr = nr + Math.imul(vn, un) | 0, Pe = Pe + Math.imul(vn, Gn) | 0, Pe = Pe + Math.imul(Vn, un) | 0, ur = ur + Math.imul(Vn, Gn) | 0, nr = nr + Math.imul(In, pn) | 0, Pe = Pe + Math.imul(In, Rn) | 0, Pe = Pe + Math.imul(Fn, pn) | 0, ur = ur + Math.imul(Fn, Rn) | 0, nr = nr + Math.imul(rn, to) | 0, Pe = Pe + Math.imul(rn, no) | 0, Pe = Pe + Math.imul(ji, to) | 0, ur = ur + Math.imul(ji, no) | 0, nr = nr + Math.imul(yn, Qn) | 0, Pe = Pe + Math.imul(yn, co) | 0, Pe = Pe + Math.imul(sn, Qn) | 0, ur = ur + Math.imul(sn, co) | 0, nr = nr + Math.imul(hi, ai) | 0, Pe = Pe + Math.imul(hi, _i) | 0, Pe = Pe + Math.imul(Oi, ai) | 0, ur = ur + Math.imul(Oi, _i) | 0, nr = nr + Math.imul(ei, Ai) | 0, Pe = Pe + Math.imul(ei, ki) | 0, Pe = Pe + Math.imul(Zr, Ai) | 0, ur = ur + Math.imul(Zr, ki) | 0, nr = nr + Math.imul(wi, Ui) | 0, Pe = Pe + Math.imul(wi, Vi) | 0, Pe = Pe + Math.imul(ii, Ui) | 0, ur = ur + Math.imul(ii, Vi) | 0, nr = nr + Math.imul(Hr, Hi) | 0, Pe = Pe + Math.imul(Hr, en) | 0, Pe = Pe + Math.imul(vi, Hi) | 0, ur = ur + Math.imul(vi, en) | 0;
      var ea = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ea >>> 26) | 0, ea &= 67108863, nr = Math.imul(Ci, Li), Pe = Math.imul(Ci, Yi), Pe = Pe + Math.imul(ri, Li) | 0, ur = Math.imul(ri, Yi), nr = nr + Math.imul(Xn, un) | 0, Pe = Pe + Math.imul(Xn, Gn) | 0, Pe = Pe + Math.imul(Yn, un) | 0, ur = ur + Math.imul(Yn, Gn) | 0, nr = nr + Math.imul(vn, pn) | 0, Pe = Pe + Math.imul(vn, Rn) | 0, Pe = Pe + Math.imul(Vn, pn) | 0, ur = ur + Math.imul(Vn, Rn) | 0, nr = nr + Math.imul(In, to) | 0, Pe = Pe + Math.imul(In, no) | 0, Pe = Pe + Math.imul(Fn, to) | 0, ur = ur + Math.imul(Fn, no) | 0, nr = nr + Math.imul(rn, Qn) | 0, Pe = Pe + Math.imul(rn, co) | 0, Pe = Pe + Math.imul(ji, Qn) | 0, ur = ur + Math.imul(ji, co) | 0, nr = nr + Math.imul(yn, ai) | 0, Pe = Pe + Math.imul(yn, _i) | 0, Pe = Pe + Math.imul(sn, ai) | 0, ur = ur + Math.imul(sn, _i) | 0, nr = nr + Math.imul(hi, Ai) | 0, Pe = Pe + Math.imul(hi, ki) | 0, Pe = Pe + Math.imul(Oi, Ai) | 0, ur = ur + Math.imul(Oi, ki) | 0, nr = nr + Math.imul(ei, Ui) | 0, Pe = Pe + Math.imul(ei, Vi) | 0, Pe = Pe + Math.imul(Zr, Ui) | 0, ur = ur + Math.imul(Zr, Vi) | 0, nr = nr + Math.imul(wi, Hi) | 0, Pe = Pe + Math.imul(wi, en) | 0, Pe = Pe + Math.imul(ii, Hi) | 0, ur = ur + Math.imul(ii, en) | 0, nr = nr + Math.imul(Hr, _n) | 0, Pe = Pe + Math.imul(Hr, Tn) | 0, Pe = Pe + Math.imul(vi, _n) | 0, ur = ur + Math.imul(vi, Tn) | 0;
      var da = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (da >>> 26) | 0, da &= 67108863, nr = Math.imul(Ci, un), Pe = Math.imul(Ci, Gn), Pe = Pe + Math.imul(ri, un) | 0, ur = Math.imul(ri, Gn), nr = nr + Math.imul(Xn, pn) | 0, Pe = Pe + Math.imul(Xn, Rn) | 0, Pe = Pe + Math.imul(Yn, pn) | 0, ur = ur + Math.imul(Yn, Rn) | 0, nr = nr + Math.imul(vn, to) | 0, Pe = Pe + Math.imul(vn, no) | 0, Pe = Pe + Math.imul(Vn, to) | 0, ur = ur + Math.imul(Vn, no) | 0, nr = nr + Math.imul(In, Qn) | 0, Pe = Pe + Math.imul(In, co) | 0, Pe = Pe + Math.imul(Fn, Qn) | 0, ur = ur + Math.imul(Fn, co) | 0, nr = nr + Math.imul(rn, ai) | 0, Pe = Pe + Math.imul(rn, _i) | 0, Pe = Pe + Math.imul(ji, ai) | 0, ur = ur + Math.imul(ji, _i) | 0, nr = nr + Math.imul(yn, Ai) | 0, Pe = Pe + Math.imul(yn, ki) | 0, Pe = Pe + Math.imul(sn, Ai) | 0, ur = ur + Math.imul(sn, ki) | 0, nr = nr + Math.imul(hi, Ui) | 0, Pe = Pe + Math.imul(hi, Vi) | 0, Pe = Pe + Math.imul(Oi, Ui) | 0, ur = ur + Math.imul(Oi, Vi) | 0, nr = nr + Math.imul(ei, Hi) | 0, Pe = Pe + Math.imul(ei, en) | 0, Pe = Pe + Math.imul(Zr, Hi) | 0, ur = ur + Math.imul(Zr, en) | 0, nr = nr + Math.imul(wi, _n) | 0, Pe = Pe + Math.imul(wi, Tn) | 0, Pe = Pe + Math.imul(ii, _n) | 0, ur = ur + Math.imul(ii, Tn) | 0;
      var Ra = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ra >>> 26) | 0, Ra &= 67108863, nr = Math.imul(Ci, pn), Pe = Math.imul(Ci, Rn), Pe = Pe + Math.imul(ri, pn) | 0, ur = Math.imul(ri, Rn), nr = nr + Math.imul(Xn, to) | 0, Pe = Pe + Math.imul(Xn, no) | 0, Pe = Pe + Math.imul(Yn, to) | 0, ur = ur + Math.imul(Yn, no) | 0, nr = nr + Math.imul(vn, Qn) | 0, Pe = Pe + Math.imul(vn, co) | 0, Pe = Pe + Math.imul(Vn, Qn) | 0, ur = ur + Math.imul(Vn, co) | 0, nr = nr + Math.imul(In, ai) | 0, Pe = Pe + Math.imul(In, _i) | 0, Pe = Pe + Math.imul(Fn, ai) | 0, ur = ur + Math.imul(Fn, _i) | 0, nr = nr + Math.imul(rn, Ai) | 0, Pe = Pe + Math.imul(rn, ki) | 0, Pe = Pe + Math.imul(ji, Ai) | 0, ur = ur + Math.imul(ji, ki) | 0, nr = nr + Math.imul(yn, Ui) | 0, Pe = Pe + Math.imul(yn, Vi) | 0, Pe = Pe + Math.imul(sn, Ui) | 0, ur = ur + Math.imul(sn, Vi) | 0, nr = nr + Math.imul(hi, Hi) | 0, Pe = Pe + Math.imul(hi, en) | 0, Pe = Pe + Math.imul(Oi, Hi) | 0, ur = ur + Math.imul(Oi, en) | 0, nr = nr + Math.imul(ei, _n) | 0, Pe = Pe + Math.imul(ei, Tn) | 0, Pe = Pe + Math.imul(Zr, _n) | 0, ur = ur + Math.imul(Zr, Tn) | 0;
      var ba = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ba >>> 26) | 0, ba &= 67108863, nr = Math.imul(Ci, to), Pe = Math.imul(Ci, no), Pe = Pe + Math.imul(ri, to) | 0, ur = Math.imul(ri, no), nr = nr + Math.imul(Xn, Qn) | 0, Pe = Pe + Math.imul(Xn, co) | 0, Pe = Pe + Math.imul(Yn, Qn) | 0, ur = ur + Math.imul(Yn, co) | 0, nr = nr + Math.imul(vn, ai) | 0, Pe = Pe + Math.imul(vn, _i) | 0, Pe = Pe + Math.imul(Vn, ai) | 0, ur = ur + Math.imul(Vn, _i) | 0, nr = nr + Math.imul(In, Ai) | 0, Pe = Pe + Math.imul(In, ki) | 0, Pe = Pe + Math.imul(Fn, Ai) | 0, ur = ur + Math.imul(Fn, ki) | 0, nr = nr + Math.imul(rn, Ui) | 0, Pe = Pe + Math.imul(rn, Vi) | 0, Pe = Pe + Math.imul(ji, Ui) | 0, ur = ur + Math.imul(ji, Vi) | 0, nr = nr + Math.imul(yn, Hi) | 0, Pe = Pe + Math.imul(yn, en) | 0, Pe = Pe + Math.imul(sn, Hi) | 0, ur = ur + Math.imul(sn, en) | 0, nr = nr + Math.imul(hi, _n) | 0, Pe = Pe + Math.imul(hi, Tn) | 0, Pe = Pe + Math.imul(Oi, _n) | 0, ur = ur + Math.imul(Oi, Tn) | 0;
      var Ea = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ea >>> 26) | 0, Ea &= 67108863, nr = Math.imul(Ci, Qn), Pe = Math.imul(Ci, co), Pe = Pe + Math.imul(ri, Qn) | 0, ur = Math.imul(ri, co), nr = nr + Math.imul(Xn, ai) | 0, Pe = Pe + Math.imul(Xn, _i) | 0, Pe = Pe + Math.imul(Yn, ai) | 0, ur = ur + Math.imul(Yn, _i) | 0, nr = nr + Math.imul(vn, Ai) | 0, Pe = Pe + Math.imul(vn, ki) | 0, Pe = Pe + Math.imul(Vn, Ai) | 0, ur = ur + Math.imul(Vn, ki) | 0, nr = nr + Math.imul(In, Ui) | 0, Pe = Pe + Math.imul(In, Vi) | 0, Pe = Pe + Math.imul(Fn, Ui) | 0, ur = ur + Math.imul(Fn, Vi) | 0, nr = nr + Math.imul(rn, Hi) | 0, Pe = Pe + Math.imul(rn, en) | 0, Pe = Pe + Math.imul(ji, Hi) | 0, ur = ur + Math.imul(ji, en) | 0, nr = nr + Math.imul(yn, _n) | 0, Pe = Pe + Math.imul(yn, Tn) | 0, Pe = Pe + Math.imul(sn, _n) | 0, ur = ur + Math.imul(sn, Tn) | 0;
      var Ha = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ha >>> 26) | 0, Ha &= 67108863, nr = Math.imul(Ci, ai), Pe = Math.imul(Ci, _i), Pe = Pe + Math.imul(ri, ai) | 0, ur = Math.imul(ri, _i), nr = nr + Math.imul(Xn, Ai) | 0, Pe = Pe + Math.imul(Xn, ki) | 0, Pe = Pe + Math.imul(Yn, Ai) | 0, ur = ur + Math.imul(Yn, ki) | 0, nr = nr + Math.imul(vn, Ui) | 0, Pe = Pe + Math.imul(vn, Vi) | 0, Pe = Pe + Math.imul(Vn, Ui) | 0, ur = ur + Math.imul(Vn, Vi) | 0, nr = nr + Math.imul(In, Hi) | 0, Pe = Pe + Math.imul(In, en) | 0, Pe = Pe + Math.imul(Fn, Hi) | 0, ur = ur + Math.imul(Fn, en) | 0, nr = nr + Math.imul(rn, _n) | 0, Pe = Pe + Math.imul(rn, Tn) | 0, Pe = Pe + Math.imul(ji, _n) | 0, ur = ur + Math.imul(ji, Tn) | 0;
      var Fa = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Fa >>> 26) | 0, Fa &= 67108863, nr = Math.imul(Ci, Ai), Pe = Math.imul(Ci, ki), Pe = Pe + Math.imul(ri, Ai) | 0, ur = Math.imul(ri, ki), nr = nr + Math.imul(Xn, Ui) | 0, Pe = Pe + Math.imul(Xn, Vi) | 0, Pe = Pe + Math.imul(Yn, Ui) | 0, ur = ur + Math.imul(Yn, Vi) | 0, nr = nr + Math.imul(vn, Hi) | 0, Pe = Pe + Math.imul(vn, en) | 0, Pe = Pe + Math.imul(Vn, Hi) | 0, ur = ur + Math.imul(Vn, en) | 0, nr = nr + Math.imul(In, _n) | 0, Pe = Pe + Math.imul(In, Tn) | 0, Pe = Pe + Math.imul(Fn, _n) | 0, ur = ur + Math.imul(Fn, Tn) | 0;
      var ls = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ls >>> 26) | 0, ls &= 67108863, nr = Math.imul(Ci, Ui), Pe = Math.imul(Ci, Vi), Pe = Pe + Math.imul(ri, Ui) | 0, ur = Math.imul(ri, Vi), nr = nr + Math.imul(Xn, Hi) | 0, Pe = Pe + Math.imul(Xn, en) | 0, Pe = Pe + Math.imul(Yn, Hi) | 0, ur = ur + Math.imul(Yn, en) | 0, nr = nr + Math.imul(vn, _n) | 0, Pe = Pe + Math.imul(vn, Tn) | 0, Pe = Pe + Math.imul(Vn, _n) | 0, ur = ur + Math.imul(Vn, Tn) | 0;
      var us = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (us >>> 26) | 0, us &= 67108863, nr = Math.imul(Ci, Hi), Pe = Math.imul(Ci, en), Pe = Pe + Math.imul(ri, Hi) | 0, ur = Math.imul(ri, en), nr = nr + Math.imul(Xn, _n) | 0, Pe = Pe + Math.imul(Xn, Tn) | 0, Pe = Pe + Math.imul(Yn, _n) | 0, ur = ur + Math.imul(Yn, Tn) | 0;
      var Xa = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Xa >>> 26) | 0, Xa &= 67108863, nr = Math.imul(Ci, _n), Pe = Math.imul(Ci, Tn), Pe = Pe + Math.imul(ri, _n) | 0, ur = Math.imul(ri, Tn);
      var hs = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      return br = (ur + (Pe >>> 13) | 0) + (hs >>> 26) | 0, hs &= 67108863, pr[0] = xo, pr[1] = Co, pr[2] = $o, pr[3] = Bo, pr[4] = Qo, pr[5] = Go, pr[6] = No, pr[7] = Zo, pr[8] = ea, pr[9] = da, pr[10] = Ra, pr[11] = ba, pr[12] = Ea, pr[13] = Ha, pr[14] = Fa, pr[15] = ls, pr[16] = us, pr[17] = Xa, pr[18] = hs, br !== 0 && (pr[19] = br, Ue.length++), Ue;
    };
    Math.imul || (Rr = Ar);
    function Nr(vr, Ae, ze) {
      ze.negative = Ae.negative ^ vr.negative, ze.length = vr.length + Ae.length;
      for (var Ue = 0, tr = 0, lr = 0; lr < ze.length - 1; lr++) {
        var pr = tr;
        tr = 0;
        for (var br = Ue & 67108863, nr = Math.min(lr, Ae.length - 1), Pe = Math.max(0, lr - vr.length + 1); Pe <= nr; Pe++) {
          var ur = lr - Pe, Pr = vr.words[ur] | 0, Hr = Ae.words[Pe] | 0, vi = Pr * Hr, Ti = vi & 67108863;
          pr = pr + (vi / 67108864 | 0) | 0, Ti = Ti + br | 0, br = Ti & 67108863, pr = pr + (Ti >>> 26) | 0, tr += pr >>> 26, pr &= 67108863;
        }
        ze.words[lr] = br, Ue = pr, pr = tr;
      }
      return Ue !== 0 ? ze.words[lr] = Ue : ze.length--, ze.strip();
    }
    function Yr(vr, Ae, ze) {
      var Ue = new Vr();
      return Ue.mulp(vr, Ae, ze);
    }
    Me.prototype.mulTo = function(Ae, ze) {
      var Ue, tr = this.length + Ae.length;
      return this.length === 10 && Ae.length === 10 ? Ue = Rr(this, Ae, ze) : tr < 63 ? Ue = Ar(this, Ae, ze) : tr < 1024 ? Ue = Nr(this, Ae, ze) : Ue = Yr(this, Ae, ze), Ue;
    };
    function Vr(vr, Ae) {
      this.x = vr, this.y = Ae;
    }
    Vr.prototype.makeRBT = function(Ae) {
      for (var ze = new Array(Ae), Ue = Me.prototype._countBits(Ae) - 1, tr = 0; tr < Ae; tr++)
        ze[tr] = this.revBin(tr, Ue, Ae);
      return ze;
    }, Vr.prototype.revBin = function(Ae, ze, Ue) {
      if (Ae === 0 || Ae === Ue - 1)
        return Ae;
      for (var tr = 0, lr = 0; lr < ze; lr++)
        tr |= (Ae & 1) << ze - lr - 1, Ae >>= 1;
      return tr;
    }, Vr.prototype.permute = function(Ae, ze, Ue, tr, lr, pr) {
      for (var br = 0; br < pr; br++)
        tr[br] = ze[Ae[br]], lr[br] = Ue[Ae[br]];
    }, Vr.prototype.transform = function(Ae, ze, Ue, tr, lr, pr) {
      this.permute(pr, Ae, ze, Ue, tr, lr);
      for (var br = 1; br < lr; br <<= 1)
        for (var nr = br << 1, Pe = Math.cos(2 * Math.PI / nr), ur = Math.sin(2 * Math.PI / nr), Pr = 0; Pr < lr; Pr += nr)
          for (var Hr = Pe, vi = ur, Ti = 0; Ti < br; Ti++) {
            var wi = Ue[Pr + Ti], ii = tr[Pr + Ti], mi = Ue[Pr + Ti + br], ei = tr[Pr + Ti + br], Zr = Hr * mi - vi * ei;
            ei = Hr * ei + vi * mi, mi = Zr, Ue[Pr + Ti] = wi + mi, tr[Pr + Ti] = ii + ei, Ue[Pr + Ti + br] = wi - mi, tr[Pr + Ti + br] = ii - ei, Ti !== nr && (Zr = Pe * Hr - ur * vi, vi = Pe * vi + ur * Hr, Hr = Zr);
          }
    }, Vr.prototype.guessLen13b = function(Ae, ze) {
      var Ue = Math.max(ze, Ae) | 1, tr = Ue & 1, lr = 0;
      for (Ue = Ue / 2 | 0; Ue; Ue = Ue >>> 1)
        lr++;
      return 1 << lr + 1 + tr;
    }, Vr.prototype.conjugate = function(Ae, ze, Ue) {
      if (!(Ue <= 1))
        for (var tr = 0; tr < Ue / 2; tr++) {
          var lr = Ae[tr];
          Ae[tr] = Ae[Ue - tr - 1], Ae[Ue - tr - 1] = lr, lr = ze[tr], ze[tr] = -ze[Ue - tr - 1], ze[Ue - tr - 1] = -lr;
        }
    }, Vr.prototype.normalize13b = function(Ae, ze) {
      for (var Ue = 0, tr = 0; tr < ze / 2; tr++) {
        var lr = Math.round(Ae[2 * tr + 1] / ze) * 8192 + Math.round(Ae[2 * tr] / ze) + Ue;
        Ae[tr] = lr & 67108863, lr < 67108864 ? Ue = 0 : Ue = lr / 67108864 | 0;
      }
      return Ae;
    }, Vr.prototype.convert13b = function(Ae, ze, Ue, tr) {
      for (var lr = 0, pr = 0; pr < ze; pr++)
        lr = lr + (Ae[pr] | 0), Ue[2 * pr] = lr & 8191, lr = lr >>> 13, Ue[2 * pr + 1] = lr & 8191, lr = lr >>> 13;
      for (pr = 2 * ze; pr < tr; ++pr)
        Ue[pr] = 0;
      we(lr === 0), we((lr & -8192) === 0);
    }, Vr.prototype.stub = function(Ae) {
      for (var ze = new Array(Ae), Ue = 0; Ue < Ae; Ue++)
        ze[Ue] = 0;
      return ze;
    }, Vr.prototype.mulp = function(Ae, ze, Ue) {
      var tr = 2 * this.guessLen13b(Ae.length, ze.length), lr = this.makeRBT(tr), pr = this.stub(tr), br = new Array(tr), nr = new Array(tr), Pe = new Array(tr), ur = new Array(tr), Pr = new Array(tr), Hr = new Array(tr), vi = Ue.words;
      vi.length = tr, this.convert13b(Ae.words, Ae.length, br, tr), this.convert13b(ze.words, ze.length, ur, tr), this.transform(br, pr, nr, Pe, tr, lr), this.transform(ur, pr, Pr, Hr, tr, lr);
      for (var Ti = 0; Ti < tr; Ti++) {
        var wi = nr[Ti] * Pr[Ti] - Pe[Ti] * Hr[Ti];
        Pe[Ti] = nr[Ti] * Hr[Ti] + Pe[Ti] * Pr[Ti], nr[Ti] = wi;
      }
      return this.conjugate(nr, Pe, tr), this.transform(nr, Pe, vi, pr, tr, lr), this.conjugate(vi, pr, tr), this.normalize13b(vi, tr), Ue.negative = Ae.negative ^ ze.negative, Ue.length = Ae.length + ze.length, Ue.strip();
    }, Me.prototype.mul = function(Ae) {
      var ze = new Me(null);
      return ze.words = new Array(this.length + Ae.length), this.mulTo(Ae, ze);
    }, Me.prototype.mulf = function(Ae) {
      var ze = new Me(null);
      return ze.words = new Array(this.length + Ae.length), Yr(this, Ae, ze);
    }, Me.prototype.imul = function(Ae) {
      return this.clone().mulTo(Ae, this);
    }, Me.prototype.imuln = function(Ae) {
      we(typeof Ae == "number"), we(Ae < 67108864);
      for (var ze = 0, Ue = 0; Ue < this.length; Ue++) {
        var tr = (this.words[Ue] | 0) * Ae, lr = (tr & 67108863) + (ze & 67108863);
        ze >>= 26, ze += tr / 67108864 | 0, ze += lr >>> 26, this.words[Ue] = lr & 67108863;
      }
      return ze !== 0 && (this.words[Ue] = ze, this.length++), this;
    }, Me.prototype.muln = function(Ae) {
      return this.clone().imuln(Ae);
    }, Me.prototype.sqr = function() {
      return this.mul(this);
    }, Me.prototype.isqr = function() {
      return this.imul(this.clone());
    }, Me.prototype.pow = function(Ae) {
      var ze = Ir(Ae);
      if (ze.length === 0)
        return new Me(1);
      for (var Ue = this, tr = 0; tr < ze.length && ze[tr] === 0; tr++, Ue = Ue.sqr())
        ;
      if (++tr < ze.length)
        for (var lr = Ue.sqr(); tr < ze.length; tr++, lr = lr.sqr())
          ze[tr] !== 0 && (Ue = Ue.mul(lr));
      return Ue;
    }, Me.prototype.iushln = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 67108863 >>> 26 - ze << 26 - ze, lr;
      if (ze !== 0) {
        var pr = 0;
        for (lr = 0; lr < this.length; lr++) {
          var br = this.words[lr] & tr, nr = (this.words[lr] | 0) - br << ze;
          this.words[lr] = nr | pr, pr = br >>> 26 - ze;
        }
        pr && (this.words[lr] = pr, this.length++);
      }
      if (Ue !== 0) {
        for (lr = this.length - 1; lr >= 0; lr--)
          this.words[lr + Ue] = this.words[lr];
        for (lr = 0; lr < Ue; lr++)
          this.words[lr] = 0;
        this.length += Ue;
      }
      return this.strip();
    }, Me.prototype.ishln = function(Ae) {
      return we(this.negative === 0), this.iushln(Ae);
    }, Me.prototype.iushrn = function(Ae, ze, Ue) {
      we(typeof Ae == "number" && Ae >= 0);
      var tr;
      ze ? tr = (ze - ze % 26) / 26 : tr = 0;
      var lr = Ae % 26, pr = Math.min((Ae - lr) / 26, this.length), br = 67108863 ^ 67108863 >>> lr << lr, nr = Ue;
      if (tr -= pr, tr = Math.max(0, tr), nr) {
        for (var Pe = 0; Pe < pr; Pe++)
          nr.words[Pe] = this.words[Pe];
        nr.length = pr;
      }
      if (pr !== 0)
        if (this.length > pr)
          for (this.length -= pr, Pe = 0; Pe < this.length; Pe++)
            this.words[Pe] = this.words[Pe + pr];
        else
          this.words[0] = 0, this.length = 1;
      var ur = 0;
      for (Pe = this.length - 1; Pe >= 0 && (ur !== 0 || Pe >= tr); Pe--) {
        var Pr = this.words[Pe] | 0;
        this.words[Pe] = ur << 26 - lr | Pr >>> lr, ur = Pr & br;
      }
      return nr && ur !== 0 && (nr.words[nr.length++] = ur), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, Me.prototype.ishrn = function(Ae, ze, Ue) {
      return we(this.negative === 0), this.iushrn(Ae, ze, Ue);
    }, Me.prototype.shln = function(Ae) {
      return this.clone().ishln(Ae);
    }, Me.prototype.ushln = function(Ae) {
      return this.clone().iushln(Ae);
    }, Me.prototype.shrn = function(Ae) {
      return this.clone().ishrn(Ae);
    }, Me.prototype.ushrn = function(Ae) {
      return this.clone().iushrn(Ae);
    }, Me.prototype.testn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 1 << ze;
      if (this.length <= Ue)
        return !1;
      var lr = this.words[Ue];
      return !!(lr & tr);
    }, Me.prototype.imaskn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26;
      if (we(this.negative === 0, "imaskn works only with positive numbers"), this.length <= Ue)
        return this;
      if (ze !== 0 && Ue++, this.length = Math.min(Ue, this.length), ze !== 0) {
        var tr = 67108863 ^ 67108863 >>> ze << ze;
        this.words[this.length - 1] &= tr;
      }
      return this.strip();
    }, Me.prototype.maskn = function(Ae) {
      return this.clone().imaskn(Ae);
    }, Me.prototype.iaddn = function(Ae) {
      return we(typeof Ae == "number"), we(Ae < 67108864), Ae < 0 ? this.isubn(-Ae) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Ae ? (this.words[0] = Ae - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ae), this.negative = 1, this) : this._iaddn(Ae);
    }, Me.prototype._iaddn = function(Ae) {
      this.words[0] += Ae;
      for (var ze = 0; ze < this.length && this.words[ze] >= 67108864; ze++)
        this.words[ze] -= 67108864, ze === this.length - 1 ? this.words[ze + 1] = 1 : this.words[ze + 1]++;
      return this.length = Math.max(this.length, ze + 1), this;
    }, Me.prototype.isubn = function(Ae) {
      if (we(typeof Ae == "number"), we(Ae < 67108864), Ae < 0)
        return this.iaddn(-Ae);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(Ae), this.negative = 1, this;
      if (this.words[0] -= Ae, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var ze = 0; ze < this.length && this.words[ze] < 0; ze++)
          this.words[ze] += 67108864, this.words[ze + 1] -= 1;
      return this.strip();
    }, Me.prototype.addn = function(Ae) {
      return this.clone().iaddn(Ae);
    }, Me.prototype.subn = function(Ae) {
      return this.clone().isubn(Ae);
    }, Me.prototype.iabs = function() {
      return this.negative = 0, this;
    }, Me.prototype.abs = function() {
      return this.clone().iabs();
    }, Me.prototype._ishlnsubmul = function(Ae, ze, Ue) {
      var tr = Ae.length + Ue, lr;
      this._expand(tr);
      var pr, br = 0;
      for (lr = 0; lr < Ae.length; lr++) {
        pr = (this.words[lr + Ue] | 0) + br;
        var nr = (Ae.words[lr] | 0) * ze;
        pr -= nr & 67108863, br = (pr >> 26) - (nr / 67108864 | 0), this.words[lr + Ue] = pr & 67108863;
      }
      for (; lr < this.length - Ue; lr++)
        pr = (this.words[lr + Ue] | 0) + br, br = pr >> 26, this.words[lr + Ue] = pr & 67108863;
      if (br === 0)
        return this.strip();
      for (we(br === -1), br = 0, lr = 0; lr < this.length; lr++)
        pr = -(this.words[lr] | 0) + br, br = pr >> 26, this.words[lr] = pr & 67108863;
      return this.negative = 1, this.strip();
    }, Me.prototype._wordDiv = function(Ae, ze) {
      var Ue = this.length - Ae.length, tr = this.clone(), lr = Ae, pr = lr.words[lr.length - 1] | 0, br = this._countBits(pr);
      Ue = 26 - br, Ue !== 0 && (lr = lr.ushln(Ue), tr.iushln(Ue), pr = lr.words[lr.length - 1] | 0);
      var nr = tr.length - lr.length, Pe;
      if (ze !== "mod") {
        Pe = new Me(null), Pe.length = nr + 1, Pe.words = new Array(Pe.length);
        for (var ur = 0; ur < Pe.length; ur++)
          Pe.words[ur] = 0;
      }
      var Pr = tr.clone()._ishlnsubmul(lr, 1, nr);
      Pr.negative === 0 && (tr = Pr, Pe && (Pe.words[nr] = 1));
      for (var Hr = nr - 1; Hr >= 0; Hr--) {
        var vi = (tr.words[lr.length + Hr] | 0) * 67108864 + (tr.words[lr.length + Hr - 1] | 0);
        for (vi = Math.min(vi / pr | 0, 67108863), tr._ishlnsubmul(lr, vi, Hr); tr.negative !== 0; )
          vi--, tr.negative = 0, tr._ishlnsubmul(lr, 1, Hr), tr.isZero() || (tr.negative ^= 1);
        Pe && (Pe.words[Hr] = vi);
      }
      return Pe && Pe.strip(), tr.strip(), ze !== "div" && Ue !== 0 && tr.iushrn(Ue), {
        div: Pe || null,
        mod: tr
      };
    }, Me.prototype.divmod = function(Ae, ze, Ue) {
      if (we(!Ae.isZero()), this.isZero())
        return {
          div: new Me(0),
          mod: new Me(0)
        };
      var tr, lr, pr;
      return this.negative !== 0 && Ae.negative === 0 ? (pr = this.neg().divmod(Ae, ze), ze !== "mod" && (tr = pr.div.neg()), ze !== "div" && (lr = pr.mod.neg(), Ue && lr.negative !== 0 && lr.iadd(Ae)), {
        div: tr,
        mod: lr
      }) : this.negative === 0 && Ae.negative !== 0 ? (pr = this.divmod(Ae.neg(), ze), ze !== "mod" && (tr = pr.div.neg()), {
        div: tr,
        mod: pr.mod
      }) : (this.negative & Ae.negative) !== 0 ? (pr = this.neg().divmod(Ae.neg(), ze), ze !== "div" && (lr = pr.mod.neg(), Ue && lr.negative !== 0 && lr.isub(Ae)), {
        div: pr.div,
        mod: lr
      }) : Ae.length > this.length || this.cmp(Ae) < 0 ? {
        div: new Me(0),
        mod: this
      } : Ae.length === 1 ? ze === "div" ? {
        div: this.divn(Ae.words[0]),
        mod: null
      } : ze === "mod" ? {
        div: null,
        mod: new Me(this.modn(Ae.words[0]))
      } : {
        div: this.divn(Ae.words[0]),
        mod: new Me(this.modn(Ae.words[0]))
      } : this._wordDiv(Ae, ze);
    }, Me.prototype.div = function(Ae) {
      return this.divmod(Ae, "div", !1).div;
    }, Me.prototype.mod = function(Ae) {
      return this.divmod(Ae, "mod", !1).mod;
    }, Me.prototype.umod = function(Ae) {
      return this.divmod(Ae, "mod", !0).mod;
    }, Me.prototype.divRound = function(Ae) {
      var ze = this.divmod(Ae);
      if (ze.mod.isZero())
        return ze.div;
      var Ue = ze.div.negative !== 0 ? ze.mod.isub(Ae) : ze.mod, tr = Ae.ushrn(1), lr = Ae.andln(1), pr = Ue.cmp(tr);
      return pr < 0 || lr === 1 && pr === 0 ? ze.div : ze.div.negative !== 0 ? ze.div.isubn(1) : ze.div.iaddn(1);
    }, Me.prototype.modn = function(Ae) {
      we(Ae <= 67108863);
      for (var ze = (1 << 26) % Ae, Ue = 0, tr = this.length - 1; tr >= 0; tr--)
        Ue = (ze * Ue + (this.words[tr] | 0)) % Ae;
      return Ue;
    }, Me.prototype.idivn = function(Ae) {
      we(Ae <= 67108863);
      for (var ze = 0, Ue = this.length - 1; Ue >= 0; Ue--) {
        var tr = (this.words[Ue] | 0) + ze * 67108864;
        this.words[Ue] = tr / Ae | 0, ze = tr % Ae;
      }
      return this.strip();
    }, Me.prototype.divn = function(Ae) {
      return this.clone().idivn(Ae);
    }, Me.prototype.egcd = function(Ae) {
      we(Ae.negative === 0), we(!Ae.isZero());
      var ze = this, Ue = Ae.clone();
      ze.negative !== 0 ? ze = ze.umod(Ae) : ze = ze.clone();
      for (var tr = new Me(1), lr = new Me(0), pr = new Me(0), br = new Me(1), nr = 0; ze.isEven() && Ue.isEven(); )
        ze.iushrn(1), Ue.iushrn(1), ++nr;
      for (var Pe = Ue.clone(), ur = ze.clone(); !ze.isZero(); ) {
        for (var Pr = 0, Hr = 1; (ze.words[0] & Hr) === 0 && Pr < 26; ++Pr, Hr <<= 1)
          ;
        if (Pr > 0)
          for (ze.iushrn(Pr); Pr-- > 0; )
            (tr.isOdd() || lr.isOdd()) && (tr.iadd(Pe), lr.isub(ur)), tr.iushrn(1), lr.iushrn(1);
        for (var vi = 0, Ti = 1; (Ue.words[0] & Ti) === 0 && vi < 26; ++vi, Ti <<= 1)
          ;
        if (vi > 0)
          for (Ue.iushrn(vi); vi-- > 0; )
            (pr.isOdd() || br.isOdd()) && (pr.iadd(Pe), br.isub(ur)), pr.iushrn(1), br.iushrn(1);
        ze.cmp(Ue) >= 0 ? (ze.isub(Ue), tr.isub(pr), lr.isub(br)) : (Ue.isub(ze), pr.isub(tr), br.isub(lr));
      }
      return {
        a: pr,
        b: br,
        gcd: Ue.iushln(nr)
      };
    }, Me.prototype._invmp = function(Ae) {
      we(Ae.negative === 0), we(!Ae.isZero());
      var ze = this, Ue = Ae.clone();
      ze.negative !== 0 ? ze = ze.umod(Ae) : ze = ze.clone();
      for (var tr = new Me(1), lr = new Me(0), pr = Ue.clone(); ze.cmpn(1) > 0 && Ue.cmpn(1) > 0; ) {
        for (var br = 0, nr = 1; (ze.words[0] & nr) === 0 && br < 26; ++br, nr <<= 1)
          ;
        if (br > 0)
          for (ze.iushrn(br); br-- > 0; )
            tr.isOdd() && tr.iadd(pr), tr.iushrn(1);
        for (var Pe = 0, ur = 1; (Ue.words[0] & ur) === 0 && Pe < 26; ++Pe, ur <<= 1)
          ;
        if (Pe > 0)
          for (Ue.iushrn(Pe); Pe-- > 0; )
            lr.isOdd() && lr.iadd(pr), lr.iushrn(1);
        ze.cmp(Ue) >= 0 ? (ze.isub(Ue), tr.isub(lr)) : (Ue.isub(ze), lr.isub(tr));
      }
      var Pr;
      return ze.cmpn(1) === 0 ? Pr = tr : Pr = lr, Pr.cmpn(0) < 0 && Pr.iadd(Ae), Pr;
    }, Me.prototype.gcd = function(Ae) {
      if (this.isZero())
        return Ae.abs();
      if (Ae.isZero())
        return this.abs();
      var ze = this.clone(), Ue = Ae.clone();
      ze.negative = 0, Ue.negative = 0;
      for (var tr = 0; ze.isEven() && Ue.isEven(); tr++)
        ze.iushrn(1), Ue.iushrn(1);
      do {
        for (; ze.isEven(); )
          ze.iushrn(1);
        for (; Ue.isEven(); )
          Ue.iushrn(1);
        var lr = ze.cmp(Ue);
        if (lr < 0) {
          var pr = ze;
          ze = Ue, Ue = pr;
        } else if (lr === 0 || Ue.cmpn(1) === 0)
          break;
        ze.isub(Ue);
      } while (!0);
      return Ue.iushln(tr);
    }, Me.prototype.invm = function(Ae) {
      return this.egcd(Ae).a.umod(Ae);
    }, Me.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, Me.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, Me.prototype.andln = function(Ae) {
      return this.words[0] & Ae;
    }, Me.prototype.bincn = function(Ae) {
      we(typeof Ae == "number");
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 1 << ze;
      if (this.length <= Ue)
        return this._expand(Ue + 1), this.words[Ue] |= tr, this;
      for (var lr = tr, pr = Ue; lr !== 0 && pr < this.length; pr++) {
        var br = this.words[pr] | 0;
        br += lr, lr = br >>> 26, br &= 67108863, this.words[pr] = br;
      }
      return lr !== 0 && (this.words[pr] = lr, this.length++), this;
    }, Me.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, Me.prototype.cmpn = function(Ae) {
      var ze = Ae < 0;
      if (this.negative !== 0 && !ze)
        return -1;
      if (this.negative === 0 && ze)
        return 1;
      this.strip();
      var Ue;
      if (this.length > 1)
        Ue = 1;
      else {
        ze && (Ae = -Ae), we(Ae <= 67108863, "Number is too big");
        var tr = this.words[0] | 0;
        Ue = tr === Ae ? 0 : tr < Ae ? -1 : 1;
      }
      return this.negative !== 0 ? -Ue | 0 : Ue;
    }, Me.prototype.cmp = function(Ae) {
      if (this.negative !== 0 && Ae.negative === 0)
        return -1;
      if (this.negative === 0 && Ae.negative !== 0)
        return 1;
      var ze = this.ucmp(Ae);
      return this.negative !== 0 ? -ze | 0 : ze;
    }, Me.prototype.ucmp = function(Ae) {
      if (this.length > Ae.length)
        return 1;
      if (this.length < Ae.length)
        return -1;
      for (var ze = 0, Ue = this.length - 1; Ue >= 0; Ue--) {
        var tr = this.words[Ue] | 0, lr = Ae.words[Ue] | 0;
        if (tr !== lr) {
          tr < lr ? ze = -1 : tr > lr && (ze = 1);
          break;
        }
      }
      return ze;
    }, Me.prototype.gtn = function(Ae) {
      return this.cmpn(Ae) === 1;
    }, Me.prototype.gt = function(Ae) {
      return this.cmp(Ae) === 1;
    }, Me.prototype.gten = function(Ae) {
      return this.cmpn(Ae) >= 0;
    }, Me.prototype.gte = function(Ae) {
      return this.cmp(Ae) >= 0;
    }, Me.prototype.ltn = function(Ae) {
      return this.cmpn(Ae) === -1;
    }, Me.prototype.lt = function(Ae) {
      return this.cmp(Ae) === -1;
    }, Me.prototype.lten = function(Ae) {
      return this.cmpn(Ae) <= 0;
    }, Me.prototype.lte = function(Ae) {
      return this.cmp(Ae) <= 0;
    }, Me.prototype.eqn = function(Ae) {
      return this.cmpn(Ae) === 0;
    }, Me.prototype.eq = function(Ae) {
      return this.cmp(Ae) === 0;
    }, Me.red = function(Ae) {
      return new oi(Ae);
    }, Me.prototype.toRed = function(Ae) {
      return we(!this.red, "Already a number in reduction context"), we(this.negative === 0, "red works only with positives"), Ae.convertTo(this)._forceRed(Ae);
    }, Me.prototype.fromRed = function() {
      return we(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, Me.prototype._forceRed = function(Ae) {
      return this.red = Ae, this;
    }, Me.prototype.forceRed = function(Ae) {
      return we(!this.red, "Already a number in reduction context"), this._forceRed(Ae);
    }, Me.prototype.redAdd = function(Ae) {
      return we(this.red, "redAdd works only with red numbers"), this.red.add(this, Ae);
    }, Me.prototype.redIAdd = function(Ae) {
      return we(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ae);
    }, Me.prototype.redSub = function(Ae) {
      return we(this.red, "redSub works only with red numbers"), this.red.sub(this, Ae);
    }, Me.prototype.redISub = function(Ae) {
      return we(this.red, "redISub works only with red numbers"), this.red.isub(this, Ae);
    }, Me.prototype.redShl = function(Ae) {
      return we(this.red, "redShl works only with red numbers"), this.red.shl(this, Ae);
    }, Me.prototype.redMul = function(Ae) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ae), this.red.mul(this, Ae);
    }, Me.prototype.redIMul = function(Ae) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ae), this.red.imul(this, Ae);
    }, Me.prototype.redSqr = function() {
      return we(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, Me.prototype.redISqr = function() {
      return we(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, Me.prototype.redSqrt = function() {
      return we(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, Me.prototype.redInvm = function() {
      return we(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, Me.prototype.redNeg = function() {
      return we(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, Me.prototype.redPow = function(Ae) {
      return we(this.red && !Ae.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ae);
    };
    var Xr = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Wr(vr, Ae) {
      this.name = vr, this.p = new Me(Ae, 16), this.n = this.p.bitLength(), this.k = new Me(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Wr.prototype._tmp = function() {
      var Ae = new Me(null);
      return Ae.words = new Array(Math.ceil(this.n / 13)), Ae;
    }, Wr.prototype.ireduce = function(Ae) {
      var ze = Ae, Ue;
      do
        this.split(ze, this.tmp), ze = this.imulK(ze), ze = ze.iadd(this.tmp), Ue = ze.bitLength();
      while (Ue > this.n);
      var tr = Ue < this.n ? -1 : ze.ucmp(this.p);
      return tr === 0 ? (ze.words[0] = 0, ze.length = 1) : tr > 0 ? ze.isub(this.p) : ze.strip !== void 0 ? ze.strip() : ze._strip(), ze;
    }, Wr.prototype.split = function(Ae, ze) {
      Ae.iushrn(this.n, 0, ze);
    }, Wr.prototype.imulK = function(Ae) {
      return Ae.imul(this.k);
    };
    function si() {
      Wr.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    $e(si, Wr), si.prototype.split = function(Ae, ze) {
      for (var Ue = 4194303, tr = Math.min(Ae.length, 9), lr = 0; lr < tr; lr++)
        ze.words[lr] = Ae.words[lr];
      if (ze.length = tr, Ae.length <= 9) {
        Ae.words[0] = 0, Ae.length = 1;
        return;
      }
      var pr = Ae.words[9];
      for (ze.words[ze.length++] = pr & Ue, lr = 10; lr < Ae.length; lr++) {
        var br = Ae.words[lr] | 0;
        Ae.words[lr - 10] = (br & Ue) << 4 | pr >>> 22, pr = br;
      }
      pr >>>= 22, Ae.words[lr - 10] = pr, pr === 0 && Ae.length > 10 ? Ae.length -= 10 : Ae.length -= 9;
    }, si.prototype.imulK = function(Ae) {
      Ae.words[Ae.length] = 0, Ae.words[Ae.length + 1] = 0, Ae.length += 2;
      for (var ze = 0, Ue = 0; Ue < Ae.length; Ue++) {
        var tr = Ae.words[Ue] | 0;
        ze += tr * 977, Ae.words[Ue] = ze & 67108863, ze = tr * 64 + (ze / 67108864 | 0);
      }
      return Ae.words[Ae.length - 1] === 0 && (Ae.length--, Ae.words[Ae.length - 1] === 0 && Ae.length--), Ae;
    };
    function li() {
      Wr.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    $e(li, Wr);
    function xi() {
      Wr.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    $e(xi, Wr);
    function di() {
      Wr.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    $e(di, Wr), di.prototype.imulK = function(Ae) {
      for (var ze = 0, Ue = 0; Ue < Ae.length; Ue++) {
        var tr = (Ae.words[Ue] | 0) * 19 + ze, lr = tr & 67108863;
        tr >>>= 26, Ae.words[Ue] = lr, ze = tr;
      }
      return ze !== 0 && (Ae.words[Ae.length++] = ze), Ae;
    }, Me._prime = function(Ae) {
      if (Xr[Ae])
        return Xr[Ae];
      var ze;
      if (Ae === "k256")
        ze = new si();
      else if (Ae === "p224")
        ze = new li();
      else if (Ae === "p192")
        ze = new xi();
      else if (Ae === "p25519")
        ze = new di();
      else
        throw new Error("Unknown prime " + Ae);
      return Xr[Ae] = ze, ze;
    };
    function oi(vr) {
      if (typeof vr == "string") {
        var Ae = Me._prime(vr);
        this.m = Ae.p, this.prime = Ae;
      } else
        we(vr.gtn(1), "modulus must be greater than 1"), this.m = vr, this.prime = null;
    }
    oi.prototype._verify1 = function(Ae) {
      we(Ae.negative === 0, "red works only with positives"), we(Ae.red, "red works only with red numbers");
    }, oi.prototype._verify2 = function(Ae, ze) {
      we((Ae.negative | ze.negative) === 0, "red works only with positives"), we(
        Ae.red && Ae.red === ze.red,
        "red works only with red numbers"
      );
    }, oi.prototype.imod = function(Ae) {
      return this.prime ? this.prime.ireduce(Ae)._forceRed(this) : Ae.umod(this.m)._forceRed(this);
    }, oi.prototype.neg = function(Ae) {
      return Ae.isZero() ? Ae.clone() : this.m.sub(Ae)._forceRed(this);
    }, oi.prototype.add = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.add(ze);
      return Ue.cmp(this.m) >= 0 && Ue.isub(this.m), Ue._forceRed(this);
    }, oi.prototype.iadd = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.iadd(ze);
      return Ue.cmp(this.m) >= 0 && Ue.isub(this.m), Ue;
    }, oi.prototype.sub = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.sub(ze);
      return Ue.cmpn(0) < 0 && Ue.iadd(this.m), Ue._forceRed(this);
    }, oi.prototype.isub = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.isub(ze);
      return Ue.cmpn(0) < 0 && Ue.iadd(this.m), Ue;
    }, oi.prototype.shl = function(Ae, ze) {
      return this._verify1(Ae), this.imod(Ae.ushln(ze));
    }, oi.prototype.imul = function(Ae, ze) {
      return this._verify2(Ae, ze), this.imod(Ae.imul(ze));
    }, oi.prototype.mul = function(Ae, ze) {
      return this._verify2(Ae, ze), this.imod(Ae.mul(ze));
    }, oi.prototype.isqr = function(Ae) {
      return this.imul(Ae, Ae.clone());
    }, oi.prototype.sqr = function(Ae) {
      return this.mul(Ae, Ae);
    }, oi.prototype.sqrt = function(Ae) {
      if (Ae.isZero())
        return Ae.clone();
      var ze = this.m.andln(3);
      if (we(ze % 2 === 1), ze === 3) {
        var Ue = this.m.add(new Me(1)).iushrn(2);
        return this.pow(Ae, Ue);
      }
      for (var tr = this.m.subn(1), lr = 0; !tr.isZero() && tr.andln(1) === 0; )
        lr++, tr.iushrn(1);
      we(!tr.isZero());
      var pr = new Me(1).toRed(this), br = pr.redNeg(), nr = this.m.subn(1).iushrn(1), Pe = this.m.bitLength();
      for (Pe = new Me(2 * Pe * Pe).toRed(this); this.pow(Pe, nr).cmp(br) !== 0; )
        Pe.redIAdd(br);
      for (var ur = this.pow(Pe, tr), Pr = this.pow(Ae, tr.addn(1).iushrn(1)), Hr = this.pow(Ae, tr), vi = lr; Hr.cmp(pr) !== 0; ) {
        for (var Ti = Hr, wi = 0; Ti.cmp(pr) !== 0; wi++)
          Ti = Ti.redSqr();
        we(wi < vi);
        var ii = this.pow(ur, new Me(1).iushln(vi - wi - 1));
        Pr = Pr.redMul(ii), ur = ii.redSqr(), Hr = Hr.redMul(ur), vi = wi;
      }
      return Pr;
    }, oi.prototype.invm = function(Ae) {
      var ze = Ae._invmp(this.m);
      return ze.negative !== 0 ? (ze.negative = 0, this.imod(ze).redNeg()) : this.imod(ze);
    }, oi.prototype.pow = function(Ae, ze) {
      if (ze.isZero())
        return new Me(1).toRed(this);
      if (ze.cmpn(1) === 0)
        return Ae.clone();
      var Ue = 4, tr = new Array(1 << Ue);
      tr[0] = new Me(1).toRed(this), tr[1] = Ae;
      for (var lr = 2; lr < tr.length; lr++)
        tr[lr] = this.mul(tr[lr - 1], Ae);
      var pr = tr[0], br = 0, nr = 0, Pe = ze.bitLength() % 26;
      for (Pe === 0 && (Pe = 26), lr = ze.length - 1; lr >= 0; lr--) {
        for (var ur = ze.words[lr], Pr = Pe - 1; Pr >= 0; Pr--) {
          var Hr = ur >> Pr & 1;
          if (pr !== tr[0] && (pr = this.sqr(pr)), Hr === 0 && br === 0) {
            nr = 0;
            continue;
          }
          br <<= 1, br |= Hr, nr++, !(nr !== Ue && (lr !== 0 || Pr !== 0)) && (pr = this.mul(pr, tr[br]), nr = 0, br = 0);
        }
        Pe = 26;
      }
      return pr;
    }, oi.prototype.convertTo = function(Ae) {
      var ze = Ae.umod(this.m);
      return ze === Ae ? ze.clone() : ze;
    }, oi.prototype.convertFrom = function(Ae) {
      var ze = Ae.clone();
      return ze.red = null, ze;
    }, Me.mont = function(Ae) {
      return new ci(Ae);
    };
    function ci(vr) {
      oi.call(this, vr), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new Me(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    $e(ci, oi), ci.prototype.convertTo = function(Ae) {
      return this.imod(Ae.ushln(this.shift));
    }, ci.prototype.convertFrom = function(Ae) {
      var ze = this.imod(Ae.mul(this.rinv));
      return ze.red = null, ze;
    }, ci.prototype.imul = function(Ae, ze) {
      if (Ae.isZero() || ze.isZero())
        return Ae.words[0] = 0, Ae.length = 1, Ae;
      var Ue = Ae.imul(ze), tr = Ue.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), lr = Ue.isub(tr).iushrn(this.shift), pr = lr;
      return lr.cmp(this.m) >= 0 ? pr = lr.isub(this.m) : lr.cmpn(0) < 0 && (pr = lr.iadd(this.m)), pr._forceRed(this);
    }, ci.prototype.mul = function(Ae, ze) {
      if (Ae.isZero() || ze.isZero())
        return new Me(0)._forceRed(this);
      var Ue = Ae.mul(ze), tr = Ue.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), lr = Ue.isub(tr).iushrn(this.shift), pr = lr;
      return lr.cmp(this.m) >= 0 ? pr = lr.isub(this.m) : lr.cmpn(0) < 0 && (pr = lr.iadd(this.m)), pr._forceRed(this);
    }, ci.prototype.invm = function(Ae) {
      var ze = this.imod(Ae._invmp(this.m).mul(this.r2));
      return ze._forceRed(this);
    };
  })(m, commonjsGlobal);
})(bn$5);
var brorand = { exports: {} }, hasRequiredBrorand;
function requireBrorand() {
  if (hasRequiredBrorand)
    return brorand.exports;
  hasRequiredBrorand = 1;
  var m;
  brorand.exports = function($e) {
    return m || (m = new c(null)), m.generate($e);
  };
  function c(we) {
    this.rand = we;
  }
  if (brorand.exports.Rand = c, c.prototype.generate = function($e) {
    return this._rand($e);
  }, c.prototype._rand = function($e) {
    if (this.rand.getBytes)
      return this.rand.getBytes($e);
    for (var Me = new Uint8Array($e), Ze = 0; Ze < Me.length; Ze++)
      Me[Ze] = this.rand.getByte();
    return Me;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? c.prototype._rand = function($e) {
      var Me = new Uint8Array($e);
      return self.crypto.getRandomValues(Me), Me;
    } : self.msCrypto && self.msCrypto.getRandomValues ? c.prototype._rand = function($e) {
      var Me = new Uint8Array($e);
      return self.msCrypto.getRandomValues(Me), Me;
    } : typeof window == "object" && (c.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var ie = requireCryptoBrowserify();
      if (typeof ie.randomBytes != "function")
        throw new Error("Not supported");
      c.prototype._rand = function($e) {
        return ie.randomBytes($e);
      };
    } catch {
    }
  return brorand.exports;
}
var mr, hasRequiredMr;
function requireMr() {
  if (hasRequiredMr)
    return mr;
  hasRequiredMr = 1;
  var m = bn$5.exports, c = requireBrorand();
  function ie(we) {
    this.rand = we || new c.Rand();
  }
  return mr = ie, ie.create = function($e) {
    return new ie($e);
  }, ie.prototype._randbelow = function($e) {
    var Me = $e.bitLength(), Ze = Math.ceil(Me / 8);
    do
      var ne = new m(this.rand.generate(Ze));
    while (ne.cmp($e) >= 0);
    return ne;
  }, ie.prototype._randrange = function($e, Me) {
    var Ze = Me.sub($e);
    return $e.add(this._randbelow(Ze));
  }, ie.prototype.test = function($e, Me, Ze) {
    var ne = $e.bitLength(), rr = m.mont($e), gr = new m(1).toRed(rr);
    Me || (Me = Math.max(1, ne / 48 | 0));
    for (var or = $e.subn(1), _r = 0; !or.testn(_r); _r++)
      ;
    for (var Lr = $e.shrn(_r), Ir = or.toRed(rr), Ar = !0; Me > 0; Me--) {
      var Rr = this._randrange(new m(2), or);
      Ze && Ze(Rr);
      var Nr = Rr.toRed(rr).redPow(Lr);
      if (!(Nr.cmp(gr) === 0 || Nr.cmp(Ir) === 0)) {
        for (var Yr = 1; Yr < _r; Yr++) {
          if (Nr = Nr.redSqr(), Nr.cmp(gr) === 0)
            return !1;
          if (Nr.cmp(Ir) === 0)
            break;
        }
        if (Yr === _r)
          return !1;
      }
    }
    return Ar;
  }, ie.prototype.getDivisor = function($e, Me) {
    var Ze = $e.bitLength(), ne = m.mont($e), rr = new m(1).toRed(ne);
    Me || (Me = Math.max(1, Ze / 48 | 0));
    for (var gr = $e.subn(1), or = 0; !gr.testn(or); or++)
      ;
    for (var _r = $e.shrn(or), Lr = gr.toRed(ne); Me > 0; Me--) {
      var Ir = this._randrange(new m(2), gr), Ar = $e.gcd(Ir);
      if (Ar.cmpn(1) !== 0)
        return Ar;
      var Rr = Ir.toRed(ne).redPow(_r);
      if (!(Rr.cmp(rr) === 0 || Rr.cmp(Lr) === 0)) {
        for (var Nr = 1; Nr < or; Nr++) {
          if (Rr = Rr.redSqr(), Rr.cmp(rr) === 0)
            return Rr.fromRed().subn(1).gcd($e);
          if (Rr.cmp(Lr) === 0)
            break;
        }
        if (Nr === or)
          return Rr = Rr.redSqr(), Rr.fromRed().subn(1).gcd($e);
      }
    }
    return !1;
  }, mr;
}
var generatePrime, hasRequiredGeneratePrime;
function requireGeneratePrime() {
  if (hasRequiredGeneratePrime)
    return generatePrime;
  hasRequiredGeneratePrime = 1;
  var m = browser$c.exports;
  generatePrime = Nr, Nr.simpleSieve = Ar, Nr.fermatTest = Rr;
  var c = bn$6.exports, ie = new c(24), we = requireMr(), $e = new we(), Me = new c(1), Ze = new c(2), ne = new c(5);
  new c(16), new c(8);
  var rr = new c(10), gr = new c(3);
  new c(7);
  var or = new c(11), _r = new c(4);
  new c(12);
  var Lr = null;
  function Ir() {
    if (Lr !== null)
      return Lr;
    var Yr = 1048576, Vr = [];
    Vr[0] = 2;
    for (var Xr = 1, Wr = 3; Wr < Yr; Wr += 2) {
      for (var si = Math.ceil(Math.sqrt(Wr)), li = 0; li < Xr && Vr[li] <= si && Wr % Vr[li] !== 0; li++)
        ;
      Xr !== li && Vr[li] <= si || (Vr[Xr++] = Wr);
    }
    return Lr = Vr, Vr;
  }
  function Ar(Yr) {
    for (var Vr = Ir(), Xr = 0; Xr < Vr.length; Xr++)
      if (Yr.modn(Vr[Xr]) === 0)
        return Yr.cmpn(Vr[Xr]) === 0;
    return !0;
  }
  function Rr(Yr) {
    var Vr = c.mont(Yr);
    return Ze.toRed(Vr).redPow(Yr.subn(1)).fromRed().cmpn(1) === 0;
  }
  function Nr(Yr, Vr) {
    if (Yr < 16)
      return Vr === 2 || Vr === 5 ? new c([140, 123]) : new c([140, 39]);
    Vr = new c(Vr);
    for (var Xr, Wr; ; ) {
      for (Xr = new c(m(Math.ceil(Yr / 8))); Xr.bitLength() > Yr; )
        Xr.ishrn(1);
      if (Xr.isEven() && Xr.iadd(Me), Xr.testn(1) || Xr.iadd(Ze), Vr.cmp(Ze)) {
        if (!Vr.cmp(ne))
          for (; Xr.mod(rr).cmp(gr); )
            Xr.iadd(_r);
      } else
        for (; Xr.mod(ie).cmp(or); )
          Xr.iadd(_r);
      if (Wr = Xr.shrn(1), Ar(Wr) && Ar(Xr) && Rr(Wr) && Rr(Xr) && $e.test(Wr) && $e.test(Xr))
        return Xr;
    }
  }
  return generatePrime;
}
const modp1 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, modp2 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, modp5 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, modp14 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, modp15 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, modp16 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, modp17 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, modp18 = {
  gen: "02",
  prime: "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"
}, require$$1$3 = {
  modp1,
  modp2,
  modp5,
  modp14,
  modp15,
  modp16,
  modp17,
  modp18
};
var dh, hasRequiredDh;
function requireDh() {
  if (hasRequiredDh)
    return dh;
  hasRequiredDh = 1;
  var m = bn$6.exports, c = requireMr(), ie = new c(), we = new m(24), $e = new m(11), Me = new m(10), Ze = new m(3), ne = new m(7), rr = requireGeneratePrime(), gr = browser$c.exports;
  dh = Ar;
  function or(Nr, Yr) {
    return Yr = Yr || "utf8", Buffer$C.isBuffer(Nr) || (Nr = new Buffer$C(Nr, Yr)), this._pub = new m(Nr), this;
  }
  function _r(Nr, Yr) {
    return Yr = Yr || "utf8", Buffer$C.isBuffer(Nr) || (Nr = new Buffer$C(Nr, Yr)), this._priv = new m(Nr), this;
  }
  var Lr = {};
  function Ir(Nr, Yr) {
    var Vr = Yr.toString("hex"), Xr = [Vr, Nr.toString(16)].join("_");
    if (Xr in Lr)
      return Lr[Xr];
    var Wr = 0;
    if (Nr.isEven() || !rr.simpleSieve || !rr.fermatTest(Nr) || !ie.test(Nr))
      return Wr += 1, Vr === "02" || Vr === "05" ? Wr += 8 : Wr += 4, Lr[Xr] = Wr, Wr;
    ie.test(Nr.shrn(1)) || (Wr += 2);
    var si;
    switch (Vr) {
      case "02":
        Nr.mod(we).cmp($e) && (Wr += 8);
        break;
      case "05":
        si = Nr.mod(Me), si.cmp(Ze) && si.cmp(ne) && (Wr += 8);
        break;
      default:
        Wr += 4;
    }
    return Lr[Xr] = Wr, Wr;
  }
  function Ar(Nr, Yr, Vr) {
    this.setGenerator(Yr), this.__prime = new m(Nr), this._prime = m.mont(this.__prime), this._primeLen = Nr.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, Vr ? (this.setPublicKey = or, this.setPrivateKey = _r) : this._primeCode = 8;
  }
  Object.defineProperty(Ar.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = Ir(this.__prime, this.__gen)), this._primeCode;
    }
  }), Ar.prototype.generateKeys = function() {
    return this._priv || (this._priv = new m(gr(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, Ar.prototype.computeSecret = function(Nr) {
    Nr = new m(Nr), Nr = Nr.toRed(this._prime);
    var Yr = Nr.redPow(this._priv).fromRed(), Vr = new Buffer$C(Yr.toArray()), Xr = this.getPrime();
    if (Vr.length < Xr.length) {
      var Wr = new Buffer$C(Xr.length - Vr.length);
      Wr.fill(0), Vr = Buffer$C.concat([Wr, Vr]);
    }
    return Vr;
  }, Ar.prototype.getPublicKey = function(Yr) {
    return Rr(this._pub, Yr);
  }, Ar.prototype.getPrivateKey = function(Yr) {
    return Rr(this._priv, Yr);
  }, Ar.prototype.getPrime = function(Nr) {
    return Rr(this.__prime, Nr);
  }, Ar.prototype.getGenerator = function(Nr) {
    return Rr(this._gen, Nr);
  }, Ar.prototype.setGenerator = function(Nr, Yr) {
    return Yr = Yr || "utf8", Buffer$C.isBuffer(Nr) || (Nr = new Buffer$C(Nr, Yr)), this.__gen = Nr, this._gen = new m(Nr), this;
  };
  function Rr(Nr, Yr) {
    var Vr = new Buffer$C(Nr.toArray());
    return Yr ? Vr.toString(Yr) : Vr;
  }
  return dh;
}
var hasRequiredBrowser$2;
function requireBrowser$2() {
  if (hasRequiredBrowser$2)
    return browser$5;
  hasRequiredBrowser$2 = 1;
  var m = requireGeneratePrime(), c = require$$1$3, ie = requireDh();
  function we(Ze) {
    var ne = new Buffer$C(c[Ze].prime, "hex"), rr = new Buffer$C(c[Ze].gen, "hex");
    return new ie(ne, rr);
  }
  var $e = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function Me(Ze, ne, rr, gr) {
    return Buffer$C.isBuffer(ne) || $e[ne] === void 0 ? Me(Ze, "binary", ne, rr) : (ne = ne || "binary", gr = gr || "binary", rr = rr || new Buffer$C([2]), Buffer$C.isBuffer(rr) || (rr = new Buffer$C(rr, gr)), typeof Ze == "number" ? new ie(m(Ze, rr), rr, !0) : (Buffer$C.isBuffer(Ze) || (Ze = new Buffer$C(Ze, ne)), new ie(Ze, rr, !0)));
  }
  return browser$5.DiffieHellmanGroup = browser$5.createDiffieHellmanGroup = browser$5.getDiffieHellman = we, browser$5.createDiffieHellman = browser$5.DiffieHellman = Me, browser$5;
}
var readableBrowser = { exports: {} }, processNextickArgs = { exports: {} };
typeof process$1 > "u" || !process$1.version || process$1.version.indexOf("v0.") === 0 || process$1.version.indexOf("v1.") === 0 && process$1.version.indexOf("v1.8.") !== 0 ? processNextickArgs.exports = { nextTick: nextTick$1 } : processNextickArgs.exports = process$1;
function nextTick$1(m, c, ie, we) {
  if (typeof m != "function")
    throw new TypeError('"callback" argument must be a function');
  var $e = arguments.length, Me, Ze;
  switch ($e) {
    case 0:
    case 1:
      return process$1.nextTick(m);
    case 2:
      return process$1.nextTick(function() {
        m.call(null, c);
      });
    case 3:
      return process$1.nextTick(function() {
        m.call(null, c, ie);
      });
    case 4:
      return process$1.nextTick(function() {
        m.call(null, c, ie, we);
      });
    default:
      for (Me = new Array($e - 1), Ze = 0; Ze < Me.length; )
        Me[Ze++] = arguments[Ze];
      return process$1.nextTick(function() {
        m.apply(null, Me);
      });
  }
}
var toString$2 = {}.toString, isarray = Array.isArray || function(m) {
  return toString$2.call(m) == "[object Array]";
}, streamBrowser = events$2.exports.EventEmitter, safeBuffer$1 = { exports: {} };
(function(m, c) {
  var ie = require$$0$4, we = ie.Buffer;
  function $e(Ze, ne) {
    for (var rr in Ze)
      ne[rr] = Ze[rr];
  }
  we.from && we.alloc && we.allocUnsafe && we.allocUnsafeSlow ? m.exports = ie : ($e(ie, c), c.Buffer = Me);
  function Me(Ze, ne, rr) {
    return we(Ze, ne, rr);
  }
  $e(we, Me), Me.from = function(Ze, ne, rr) {
    if (typeof Ze == "number")
      throw new TypeError("Argument must not be a number");
    return we(Ze, ne, rr);
  }, Me.alloc = function(Ze, ne, rr) {
    if (typeof Ze != "number")
      throw new TypeError("Argument must be a number");
    var gr = we(Ze);
    return ne !== void 0 ? typeof rr == "string" ? gr.fill(ne, rr) : gr.fill(ne) : gr.fill(0), gr;
  }, Me.allocUnsafe = function(Ze) {
    if (typeof Ze != "number")
      throw new TypeError("Argument must be a number");
    return we(Ze);
  }, Me.allocUnsafeSlow = function(Ze) {
    if (typeof Ze != "number")
      throw new TypeError("Argument must be a number");
    return ie.SlowBuffer(Ze);
  };
})(safeBuffer$1, safeBuffer$1.exports);
var util$3 = {};
function isArray$4(m) {
  return Array.isArray ? Array.isArray(m) : objectToString$1(m) === "[object Array]";
}
util$3.isArray = isArray$4;
function isBoolean$1(m) {
  return typeof m == "boolean";
}
util$3.isBoolean = isBoolean$1;
function isNull(m) {
  return m === null;
}
util$3.isNull = isNull;
function isNullOrUndefined(m) {
  return m == null;
}
util$3.isNullOrUndefined = isNullOrUndefined;
function isNumber$1(m) {
  return typeof m == "number";
}
util$3.isNumber = isNumber$1;
function isString$1(m) {
  return typeof m == "string";
}
util$3.isString = isString$1;
function isSymbol$1(m) {
  return typeof m == "symbol";
}
util$3.isSymbol = isSymbol$1;
function isUndefined(m) {
  return m === void 0;
}
util$3.isUndefined = isUndefined;
function isRegExp$2(m) {
  return objectToString$1(m) === "[object RegExp]";
}
util$3.isRegExp = isRegExp$2;
function isObject$4(m) {
  return typeof m == "object" && m !== null;
}
util$3.isObject = isObject$4;
function isDate$1(m) {
  return objectToString$1(m) === "[object Date]";
}
util$3.isDate = isDate$1;
function isError$1(m) {
  return objectToString$1(m) === "[object Error]" || m instanceof Error;
}
util$3.isError = isError$1;
function isFunction(m) {
  return typeof m == "function";
}
util$3.isFunction = isFunction;
function isPrimitive(m) {
  return m === null || typeof m == "boolean" || typeof m == "number" || typeof m == "string" || typeof m == "symbol" || typeof m > "u";
}
util$3.isPrimitive = isPrimitive;
util$3.isBuffer = require$$0$4.Buffer.isBuffer;
function objectToString$1(m) {
  return Object.prototype.toString.call(m);
}
var BufferList = { exports: {} }, hasRequiredBufferList;
function requireBufferList() {
  return hasRequiredBufferList || (hasRequiredBufferList = 1, function(m) {
    function c(Me, Ze) {
      if (!(Me instanceof Ze))
        throw new TypeError("Cannot call a class as a function");
    }
    var ie = safeBuffer$1.exports.Buffer, we = util$4;
    function $e(Me, Ze, ne) {
      Me.copy(Ze, ne);
    }
    m.exports = function() {
      function Me() {
        c(this, Me), this.head = null, this.tail = null, this.length = 0;
      }
      return Me.prototype.push = function(ne) {
        var rr = { data: ne, next: null };
        this.length > 0 ? this.tail.next = rr : this.head = rr, this.tail = rr, ++this.length;
      }, Me.prototype.unshift = function(ne) {
        var rr = { data: ne, next: this.head };
        this.length === 0 && (this.tail = rr), this.head = rr, ++this.length;
      }, Me.prototype.shift = function() {
        if (this.length !== 0) {
          var ne = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, ne;
        }
      }, Me.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, Me.prototype.join = function(ne) {
        if (this.length === 0)
          return "";
        for (var rr = this.head, gr = "" + rr.data; rr = rr.next; )
          gr += ne + rr.data;
        return gr;
      }, Me.prototype.concat = function(ne) {
        if (this.length === 0)
          return ie.alloc(0);
        for (var rr = ie.allocUnsafe(ne >>> 0), gr = this.head, or = 0; gr; )
          $e(gr.data, rr, or), or += gr.data.length, gr = gr.next;
        return rr;
      }, Me;
    }(), we && we.inspect && we.inspect.custom && (m.exports.prototype[we.inspect.custom] = function() {
      var Me = we.inspect({ length: this.length });
      return this.constructor.name + " " + Me;
    });
  }(BufferList)), BufferList.exports;
}
var pna = processNextickArgs.exports;
function destroy(m, c) {
  var ie = this, we = this._readableState && this._readableState.destroyed, $e = this._writableState && this._writableState.destroyed;
  return we || $e ? (c ? c(m) : m && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, pna.nextTick(emitErrorNT, this, m)) : pna.nextTick(emitErrorNT, this, m)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(m || null, function(Me) {
    !c && Me ? ie._writableState ? ie._writableState.errorEmitted || (ie._writableState.errorEmitted = !0, pna.nextTick(emitErrorNT, ie, Me)) : pna.nextTick(emitErrorNT, ie, Me) : c && c(Me);
  }), this);
}
function undestroy() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function emitErrorNT(m, c) {
  m.emit("error", c);
}
var destroy_1 = {
  destroy,
  undestroy
}, _stream_writable, hasRequired_stream_writable;
function require_stream_writable() {
  if (hasRequired_stream_writable)
    return _stream_writable;
  hasRequired_stream_writable = 1;
  var m = processNextickArgs.exports;
  _stream_writable = Rr;
  function c(pr) {
    var br = this;
    this.next = null, this.entry = null, this.finish = function() {
      lr(br, pr);
    };
  }
  var ie = !process$1.browser && ["v0.10", "v0.9."].indexOf(process$1.version.slice(0, 5)) > -1 ? setImmediate : m.nextTick, we;
  Rr.WritableState = Ir;
  var $e = Object.create(util$3);
  $e.inherits = inherits_browser.exports;
  var Me = {
    deprecate: browser$b
  }, Ze = streamBrowser, ne = safeBuffer$1.exports.Buffer, rr = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function gr(pr) {
    return ne.from(pr);
  }
  function or(pr) {
    return ne.isBuffer(pr) || pr instanceof rr;
  }
  var _r = destroy_1;
  $e.inherits(Rr, Ze);
  function Lr() {
  }
  function Ir(pr, br) {
    we = we || require_stream_duplex(), pr = pr || {};
    var nr = br instanceof we;
    this.objectMode = !!pr.objectMode, nr && (this.objectMode = this.objectMode || !!pr.writableObjectMode);
    var Pe = pr.highWaterMark, ur = pr.writableHighWaterMark, Pr = this.objectMode ? 16 : 16 * 1024;
    Pe || Pe === 0 ? this.highWaterMark = Pe : nr && (ur || ur === 0) ? this.highWaterMark = ur : this.highWaterMark = Pr, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Hr = pr.decodeStrings === !1;
    this.decodeStrings = !Hr, this.defaultEncoding = pr.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(vi) {
      xi(br, vi);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new c(this);
  }
  Ir.prototype.getBuffer = function() {
    for (var br = this.bufferedRequest, nr = []; br; )
      nr.push(br), br = br.next;
    return nr;
  }, function() {
    try {
      Object.defineProperty(Ir.prototype, "buffer", {
        get: Me.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Ar;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Ar = Function.prototype[Symbol.hasInstance], Object.defineProperty(Rr, Symbol.hasInstance, {
    value: function(pr) {
      return Ar.call(this, pr) ? !0 : this !== Rr ? !1 : pr && pr._writableState instanceof Ir;
    }
  })) : Ar = function(pr) {
    return pr instanceof this;
  };
  function Rr(pr) {
    if (we = we || require_stream_duplex(), !Ar.call(Rr, this) && !(this instanceof we))
      return new Rr(pr);
    this._writableState = new Ir(pr, this), this.writable = !0, pr && (typeof pr.write == "function" && (this._write = pr.write), typeof pr.writev == "function" && (this._writev = pr.writev), typeof pr.destroy == "function" && (this._destroy = pr.destroy), typeof pr.final == "function" && (this._final = pr.final)), Ze.call(this);
  }
  Rr.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function Nr(pr, br) {
    var nr = new Error("write after end");
    pr.emit("error", nr), m.nextTick(br, nr);
  }
  function Yr(pr, br, nr, Pe) {
    var ur = !0, Pr = !1;
    return nr === null ? Pr = new TypeError("May not write null values to stream") : typeof nr != "string" && nr !== void 0 && !br.objectMode && (Pr = new TypeError("Invalid non-string/buffer chunk")), Pr && (pr.emit("error", Pr), m.nextTick(Pe, Pr), ur = !1), ur;
  }
  Rr.prototype.write = function(pr, br, nr) {
    var Pe = this._writableState, ur = !1, Pr = !Pe.objectMode && or(pr);
    return Pr && !ne.isBuffer(pr) && (pr = gr(pr)), typeof br == "function" && (nr = br, br = null), Pr ? br = "buffer" : br || (br = Pe.defaultEncoding), typeof nr != "function" && (nr = Lr), Pe.ended ? Nr(this, nr) : (Pr || Yr(this, Pe, pr, nr)) && (Pe.pendingcb++, ur = Xr(this, Pe, Pr, pr, br, nr)), ur;
  }, Rr.prototype.cork = function() {
    var pr = this._writableState;
    pr.corked++;
  }, Rr.prototype.uncork = function() {
    var pr = this._writableState;
    pr.corked && (pr.corked--, !pr.writing && !pr.corked && !pr.bufferProcessing && pr.bufferedRequest && ci(this, pr));
  }, Rr.prototype.setDefaultEncoding = function(br) {
    if (typeof br == "string" && (br = br.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((br + "").toLowerCase()) > -1))
      throw new TypeError("Unknown encoding: " + br);
    return this._writableState.defaultEncoding = br, this;
  };
  function Vr(pr, br, nr) {
    return !pr.objectMode && pr.decodeStrings !== !1 && typeof br == "string" && (br = ne.from(br, nr)), br;
  }
  Object.defineProperty(Rr.prototype, "writableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Xr(pr, br, nr, Pe, ur, Pr) {
    if (!nr) {
      var Hr = Vr(br, Pe, ur);
      Pe !== Hr && (nr = !0, ur = "buffer", Pe = Hr);
    }
    var vi = br.objectMode ? 1 : Pe.length;
    br.length += vi;
    var Ti = br.length < br.highWaterMark;
    if (Ti || (br.needDrain = !0), br.writing || br.corked) {
      var wi = br.lastBufferedRequest;
      br.lastBufferedRequest = {
        chunk: Pe,
        encoding: ur,
        isBuf: nr,
        callback: Pr,
        next: null
      }, wi ? wi.next = br.lastBufferedRequest : br.bufferedRequest = br.lastBufferedRequest, br.bufferedRequestCount += 1;
    } else
      Wr(pr, br, !1, vi, Pe, ur, Pr);
    return Ti;
  }
  function Wr(pr, br, nr, Pe, ur, Pr, Hr) {
    br.writelen = Pe, br.writecb = Hr, br.writing = !0, br.sync = !0, nr ? pr._writev(ur, br.onwrite) : pr._write(ur, Pr, br.onwrite), br.sync = !1;
  }
  function si(pr, br, nr, Pe, ur) {
    --br.pendingcb, nr ? (m.nextTick(ur, Pe), m.nextTick(Ue, pr, br), pr._writableState.errorEmitted = !0, pr.emit("error", Pe)) : (ur(Pe), pr._writableState.errorEmitted = !0, pr.emit("error", Pe), Ue(pr, br));
  }
  function li(pr) {
    pr.writing = !1, pr.writecb = null, pr.length -= pr.writelen, pr.writelen = 0;
  }
  function xi(pr, br) {
    var nr = pr._writableState, Pe = nr.sync, ur = nr.writecb;
    if (li(nr), br)
      si(pr, nr, Pe, br, ur);
    else {
      var Pr = vr(nr);
      !Pr && !nr.corked && !nr.bufferProcessing && nr.bufferedRequest && ci(pr, nr), Pe ? ie(di, pr, nr, Pr, ur) : di(pr, nr, Pr, ur);
    }
  }
  function di(pr, br, nr, Pe) {
    nr || oi(pr, br), br.pendingcb--, Pe(), Ue(pr, br);
  }
  function oi(pr, br) {
    br.length === 0 && br.needDrain && (br.needDrain = !1, pr.emit("drain"));
  }
  function ci(pr, br) {
    br.bufferProcessing = !0;
    var nr = br.bufferedRequest;
    if (pr._writev && nr && nr.next) {
      var Pe = br.bufferedRequestCount, ur = new Array(Pe), Pr = br.corkedRequestsFree;
      Pr.entry = nr;
      for (var Hr = 0, vi = !0; nr; )
        ur[Hr] = nr, nr.isBuf || (vi = !1), nr = nr.next, Hr += 1;
      ur.allBuffers = vi, Wr(pr, br, !0, br.length, ur, "", Pr.finish), br.pendingcb++, br.lastBufferedRequest = null, Pr.next ? (br.corkedRequestsFree = Pr.next, Pr.next = null) : br.corkedRequestsFree = new c(br), br.bufferedRequestCount = 0;
    } else {
      for (; nr; ) {
        var Ti = nr.chunk, wi = nr.encoding, ii = nr.callback, mi = br.objectMode ? 1 : Ti.length;
        if (Wr(pr, br, !1, mi, Ti, wi, ii), nr = nr.next, br.bufferedRequestCount--, br.writing)
          break;
      }
      nr === null && (br.lastBufferedRequest = null);
    }
    br.bufferedRequest = nr, br.bufferProcessing = !1;
  }
  Rr.prototype._write = function(pr, br, nr) {
    nr(new Error("_write() is not implemented"));
  }, Rr.prototype._writev = null, Rr.prototype.end = function(pr, br, nr) {
    var Pe = this._writableState;
    typeof pr == "function" ? (nr = pr, pr = null, br = null) : typeof br == "function" && (nr = br, br = null), pr != null && this.write(pr, br), Pe.corked && (Pe.corked = 1, this.uncork()), Pe.ending || tr(this, Pe, nr);
  };
  function vr(pr) {
    return pr.ending && pr.length === 0 && pr.bufferedRequest === null && !pr.finished && !pr.writing;
  }
  function Ae(pr, br) {
    pr._final(function(nr) {
      br.pendingcb--, nr && pr.emit("error", nr), br.prefinished = !0, pr.emit("prefinish"), Ue(pr, br);
    });
  }
  function ze(pr, br) {
    !br.prefinished && !br.finalCalled && (typeof pr._final == "function" ? (br.pendingcb++, br.finalCalled = !0, m.nextTick(Ae, pr, br)) : (br.prefinished = !0, pr.emit("prefinish")));
  }
  function Ue(pr, br) {
    var nr = vr(br);
    return nr && (ze(pr, br), br.pendingcb === 0 && (br.finished = !0, pr.emit("finish"))), nr;
  }
  function tr(pr, br, nr) {
    br.ending = !0, Ue(pr, br), nr && (br.finished ? m.nextTick(nr) : pr.once("finish", nr)), br.ended = !0, pr.writable = !1;
  }
  function lr(pr, br, nr) {
    var Pe = pr.entry;
    for (pr.entry = null; Pe; ) {
      var ur = Pe.callback;
      br.pendingcb--, ur(nr), Pe = Pe.next;
    }
    br.corkedRequestsFree.next = pr;
  }
  return Object.defineProperty(Rr.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(pr) {
      !this._writableState || (this._writableState.destroyed = pr);
    }
  }), Rr.prototype.destroy = _r.destroy, Rr.prototype._undestroy = _r.undestroy, Rr.prototype._destroy = function(pr, br) {
    this.end(), br(pr);
  }, _stream_writable;
}
var _stream_duplex, hasRequired_stream_duplex;
function require_stream_duplex() {
  if (hasRequired_stream_duplex)
    return _stream_duplex;
  hasRequired_stream_duplex = 1;
  var m = processNextickArgs.exports, c = Object.keys || function(_r) {
    var Lr = [];
    for (var Ir in _r)
      Lr.push(Ir);
    return Lr;
  };
  _stream_duplex = rr;
  var ie = Object.create(util$3);
  ie.inherits = inherits_browser.exports;
  var we = require_stream_readable(), $e = require_stream_writable();
  ie.inherits(rr, we);
  for (var Me = c($e.prototype), Ze = 0; Ze < Me.length; Ze++) {
    var ne = Me[Ze];
    rr.prototype[ne] || (rr.prototype[ne] = $e.prototype[ne]);
  }
  function rr(_r) {
    if (!(this instanceof rr))
      return new rr(_r);
    we.call(this, _r), $e.call(this, _r), _r && _r.readable === !1 && (this.readable = !1), _r && _r.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, _r && _r.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", gr);
  }
  Object.defineProperty(rr.prototype, "writableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function gr() {
    this.allowHalfOpen || this._writableState.ended || m.nextTick(or, this);
  }
  function or(_r) {
    _r.end();
  }
  return Object.defineProperty(rr.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(_r) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = _r, this._writableState.destroyed = _r);
    }
  }), rr.prototype._destroy = function(_r, Lr) {
    this.push(null), this.end(), m.nextTick(Lr, _r);
  }, _stream_duplex;
}
var _stream_readable, hasRequired_stream_readable;
function require_stream_readable() {
  if (hasRequired_stream_readable)
    return _stream_readable;
  hasRequired_stream_readable = 1;
  var m = processNextickArgs.exports;
  _stream_readable = Vr;
  var c = isarray, ie;
  Vr.ReadableState = Yr, events$2.exports.EventEmitter;
  var we = function(ii, mi) {
    return ii.listeners(mi).length;
  }, $e = streamBrowser, Me = safeBuffer$1.exports.Buffer, Ze = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function ne(ii) {
    return Me.from(ii);
  }
  function rr(ii) {
    return Me.isBuffer(ii) || ii instanceof Ze;
  }
  var gr = Object.create(util$3);
  gr.inherits = inherits_browser.exports;
  var or = util$4, _r = void 0;
  or && or.debuglog ? _r = or.debuglog("stream") : _r = function() {
  };
  var Lr = requireBufferList(), Ir = destroy_1, Ar;
  gr.inherits(Vr, $e);
  var Rr = ["error", "close", "destroy", "pause", "resume"];
  function Nr(ii, mi, ei) {
    if (typeof ii.prependListener == "function")
      return ii.prependListener(mi, ei);
    !ii._events || !ii._events[mi] ? ii.on(mi, ei) : c(ii._events[mi]) ? ii._events[mi].unshift(ei) : ii._events[mi] = [ei, ii._events[mi]];
  }
  function Yr(ii, mi) {
    ie = ie || require_stream_duplex(), ii = ii || {};
    var ei = mi instanceof ie;
    this.objectMode = !!ii.objectMode, ei && (this.objectMode = this.objectMode || !!ii.readableObjectMode);
    var Zr = ii.highWaterMark, pi = ii.readableHighWaterMark, hi = this.objectMode ? 16 : 16 * 1024;
    Zr || Zr === 0 ? this.highWaterMark = Zr : ei && (pi || pi === 0) ? this.highWaterMark = pi : this.highWaterMark = hi, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new Lr(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = ii.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, ii.encoding && (Ar || (Ar = string_decoder.StringDecoder), this.decoder = new Ar(ii.encoding), this.encoding = ii.encoding);
  }
  function Vr(ii) {
    if (ie = ie || require_stream_duplex(), !(this instanceof Vr))
      return new Vr(ii);
    this._readableState = new Yr(ii, this), this.readable = !0, ii && (typeof ii.read == "function" && (this._read = ii.read), typeof ii.destroy == "function" && (this._destroy = ii.destroy)), $e.call(this);
  }
  Object.defineProperty(Vr.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(ii) {
      !this._readableState || (this._readableState.destroyed = ii);
    }
  }), Vr.prototype.destroy = Ir.destroy, Vr.prototype._undestroy = Ir.undestroy, Vr.prototype._destroy = function(ii, mi) {
    this.push(null), mi(ii);
  }, Vr.prototype.push = function(ii, mi) {
    var ei = this._readableState, Zr;
    return ei.objectMode ? Zr = !0 : typeof ii == "string" && (mi = mi || ei.defaultEncoding, mi !== ei.encoding && (ii = Me.from(ii, mi), mi = ""), Zr = !0), Xr(this, ii, mi, !1, Zr);
  }, Vr.prototype.unshift = function(ii) {
    return Xr(this, ii, null, !0, !1);
  };
  function Xr(ii, mi, ei, Zr, pi) {
    var hi = ii._readableState;
    if (mi === null)
      hi.reading = !1, ci(ii, hi);
    else {
      var Oi;
      pi || (Oi = si(hi, mi)), Oi ? ii.emit("error", Oi) : hi.objectMode || mi && mi.length > 0 ? (typeof mi != "string" && !hi.objectMode && Object.getPrototypeOf(mi) !== Me.prototype && (mi = ne(mi)), Zr ? hi.endEmitted ? ii.emit("error", new Error("stream.unshift() after end event")) : Wr(ii, hi, mi, !0) : hi.ended ? ii.emit("error", new Error("stream.push() after EOF")) : (hi.reading = !1, hi.decoder && !ei ? (mi = hi.decoder.write(mi), hi.objectMode || mi.length !== 0 ? Wr(ii, hi, mi, !1) : ze(ii, hi)) : Wr(ii, hi, mi, !1))) : Zr || (hi.reading = !1);
    }
    return li(hi);
  }
  function Wr(ii, mi, ei, Zr) {
    mi.flowing && mi.length === 0 && !mi.sync ? (ii.emit("data", ei), ii.read(0)) : (mi.length += mi.objectMode ? 1 : ei.length, Zr ? mi.buffer.unshift(ei) : mi.buffer.push(ei), mi.needReadable && vr(ii)), ze(ii, mi);
  }
  function si(ii, mi) {
    var ei;
    return !rr(mi) && typeof mi != "string" && mi !== void 0 && !ii.objectMode && (ei = new TypeError("Invalid non-string/buffer chunk")), ei;
  }
  function li(ii) {
    return !ii.ended && (ii.needReadable || ii.length < ii.highWaterMark || ii.length === 0);
  }
  Vr.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, Vr.prototype.setEncoding = function(ii) {
    return Ar || (Ar = string_decoder.StringDecoder), this._readableState.decoder = new Ar(ii), this._readableState.encoding = ii, this;
  };
  var xi = 8388608;
  function di(ii) {
    return ii >= xi ? ii = xi : (ii--, ii |= ii >>> 1, ii |= ii >>> 2, ii |= ii >>> 4, ii |= ii >>> 8, ii |= ii >>> 16, ii++), ii;
  }
  function oi(ii, mi) {
    return ii <= 0 || mi.length === 0 && mi.ended ? 0 : mi.objectMode ? 1 : ii !== ii ? mi.flowing && mi.length ? mi.buffer.head.data.length : mi.length : (ii > mi.highWaterMark && (mi.highWaterMark = di(ii)), ii <= mi.length ? ii : mi.ended ? mi.length : (mi.needReadable = !0, 0));
  }
  Vr.prototype.read = function(ii) {
    _r("read", ii), ii = parseInt(ii, 10);
    var mi = this._readableState, ei = ii;
    if (ii !== 0 && (mi.emittedReadable = !1), ii === 0 && mi.needReadable && (mi.length >= mi.highWaterMark || mi.ended))
      return _r("read: emitReadable", mi.length, mi.ended), mi.length === 0 && mi.ended ? vi(this) : vr(this), null;
    if (ii = oi(ii, mi), ii === 0 && mi.ended)
      return mi.length === 0 && vi(this), null;
    var Zr = mi.needReadable;
    _r("need readable", Zr), (mi.length === 0 || mi.length - ii < mi.highWaterMark) && (Zr = !0, _r("length less than watermark", Zr)), mi.ended || mi.reading ? (Zr = !1, _r("reading or ended", Zr)) : Zr && (_r("do read"), mi.reading = !0, mi.sync = !0, mi.length === 0 && (mi.needReadable = !0), this._read(mi.highWaterMark), mi.sync = !1, mi.reading || (ii = oi(ei, mi)));
    var pi;
    return ii > 0 ? pi = Pe(ii, mi) : pi = null, pi === null ? (mi.needReadable = !0, ii = 0) : mi.length -= ii, mi.length === 0 && (mi.ended || (mi.needReadable = !0), ei !== ii && mi.ended && vi(this)), pi !== null && this.emit("data", pi), pi;
  };
  function ci(ii, mi) {
    if (!mi.ended) {
      if (mi.decoder) {
        var ei = mi.decoder.end();
        ei && ei.length && (mi.buffer.push(ei), mi.length += mi.objectMode ? 1 : ei.length);
      }
      mi.ended = !0, vr(ii);
    }
  }
  function vr(ii) {
    var mi = ii._readableState;
    mi.needReadable = !1, mi.emittedReadable || (_r("emitReadable", mi.flowing), mi.emittedReadable = !0, mi.sync ? m.nextTick(Ae, ii) : Ae(ii));
  }
  function Ae(ii) {
    _r("emit readable"), ii.emit("readable"), nr(ii);
  }
  function ze(ii, mi) {
    mi.readingMore || (mi.readingMore = !0, m.nextTick(Ue, ii, mi));
  }
  function Ue(ii, mi) {
    for (var ei = mi.length; !mi.reading && !mi.flowing && !mi.ended && mi.length < mi.highWaterMark && (_r("maybeReadMore read 0"), ii.read(0), ei !== mi.length); )
      ei = mi.length;
    mi.readingMore = !1;
  }
  Vr.prototype._read = function(ii) {
    this.emit("error", new Error("_read() is not implemented"));
  }, Vr.prototype.pipe = function(ii, mi) {
    var ei = this, Zr = this._readableState;
    switch (Zr.pipesCount) {
      case 0:
        Zr.pipes = ii;
        break;
      case 1:
        Zr.pipes = [Zr.pipes, ii];
        break;
      default:
        Zr.pipes.push(ii);
        break;
    }
    Zr.pipesCount += 1, _r("pipe count=%d opts=%j", Zr.pipesCount, mi);
    var pi = (!mi || mi.end !== !1) && ii !== process$1.stdout && ii !== process$1.stderr, hi = pi ? qi : Po;
    Zr.endEmitted ? m.nextTick(hi) : ei.once("end", hi), ii.on("unpipe", Oi);
    function Oi(vn, Vn) {
      _r("onunpipe"), vn === ei && Vn && Vn.hasUnpiped === !1 && (Vn.hasUnpiped = !0, $n());
    }
    function qi() {
      _r("onend"), ii.end();
    }
    var yn = tr(ei);
    ii.on("drain", yn);
    var sn = !1;
    function $n() {
      _r("cleanup"), ii.removeListener("close", In), ii.removeListener("finish", Fn), ii.removeListener("drain", yn), ii.removeListener("error", Kn), ii.removeListener("unpipe", Oi), ei.removeListener("end", qi), ei.removeListener("end", Po), ei.removeListener("data", ji), sn = !0, Zr.awaitDrain && (!ii._writableState || ii._writableState.needDrain) && yn();
    }
    var rn = !1;
    ei.on("data", ji);
    function ji(vn) {
      _r("ondata"), rn = !1;
      var Vn = ii.write(vn);
      Vn === !1 && !rn && ((Zr.pipesCount === 1 && Zr.pipes === ii || Zr.pipesCount > 1 && wi(Zr.pipes, ii) !== -1) && !sn && (_r("false write response, pause", Zr.awaitDrain), Zr.awaitDrain++, rn = !0), ei.pause());
    }
    function Kn(vn) {
      _r("onerror", vn), Po(), ii.removeListener("error", Kn), we(ii, "error") === 0 && ii.emit("error", vn);
    }
    Nr(ii, "error", Kn);
    function In() {
      ii.removeListener("finish", Fn), Po();
    }
    ii.once("close", In);
    function Fn() {
      _r("onfinish"), ii.removeListener("close", In), Po();
    }
    ii.once("finish", Fn);
    function Po() {
      _r("unpipe"), ei.unpipe(ii);
    }
    return ii.emit("pipe", ei), Zr.flowing || (_r("pipe resume"), ei.resume()), ii;
  };
  function tr(ii) {
    return function() {
      var mi = ii._readableState;
      _r("pipeOnDrain", mi.awaitDrain), mi.awaitDrain && mi.awaitDrain--, mi.awaitDrain === 0 && we(ii, "data") && (mi.flowing = !0, nr(ii));
    };
  }
  Vr.prototype.unpipe = function(ii) {
    var mi = this._readableState, ei = { hasUnpiped: !1 };
    if (mi.pipesCount === 0)
      return this;
    if (mi.pipesCount === 1)
      return ii && ii !== mi.pipes ? this : (ii || (ii = mi.pipes), mi.pipes = null, mi.pipesCount = 0, mi.flowing = !1, ii && ii.emit("unpipe", this, ei), this);
    if (!ii) {
      var Zr = mi.pipes, pi = mi.pipesCount;
      mi.pipes = null, mi.pipesCount = 0, mi.flowing = !1;
      for (var hi = 0; hi < pi; hi++)
        Zr[hi].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var Oi = wi(mi.pipes, ii);
    return Oi === -1 ? this : (mi.pipes.splice(Oi, 1), mi.pipesCount -= 1, mi.pipesCount === 1 && (mi.pipes = mi.pipes[0]), ii.emit("unpipe", this, ei), this);
  }, Vr.prototype.on = function(ii, mi) {
    var ei = $e.prototype.on.call(this, ii, mi);
    if (ii === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (ii === "readable") {
      var Zr = this._readableState;
      !Zr.endEmitted && !Zr.readableListening && (Zr.readableListening = Zr.needReadable = !0, Zr.emittedReadable = !1, Zr.reading ? Zr.length && vr(this) : m.nextTick(lr, this));
    }
    return ei;
  }, Vr.prototype.addListener = Vr.prototype.on;
  function lr(ii) {
    _r("readable nexttick read 0"), ii.read(0);
  }
  Vr.prototype.resume = function() {
    var ii = this._readableState;
    return ii.flowing || (_r("resume"), ii.flowing = !0, pr(this, ii)), this;
  };
  function pr(ii, mi) {
    mi.resumeScheduled || (mi.resumeScheduled = !0, m.nextTick(br, ii, mi));
  }
  function br(ii, mi) {
    mi.reading || (_r("resume read 0"), ii.read(0)), mi.resumeScheduled = !1, mi.awaitDrain = 0, ii.emit("resume"), nr(ii), mi.flowing && !mi.reading && ii.read(0);
  }
  Vr.prototype.pause = function() {
    return _r("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (_r("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function nr(ii) {
    var mi = ii._readableState;
    for (_r("flow", mi.flowing); mi.flowing && ii.read() !== null; )
      ;
  }
  Vr.prototype.wrap = function(ii) {
    var mi = this, ei = this._readableState, Zr = !1;
    ii.on("end", function() {
      if (_r("wrapped end"), ei.decoder && !ei.ended) {
        var Oi = ei.decoder.end();
        Oi && Oi.length && mi.push(Oi);
      }
      mi.push(null);
    }), ii.on("data", function(Oi) {
      if (_r("wrapped data"), ei.decoder && (Oi = ei.decoder.write(Oi)), !(ei.objectMode && Oi == null) && !(!ei.objectMode && (!Oi || !Oi.length))) {
        var qi = mi.push(Oi);
        qi || (Zr = !0, ii.pause());
      }
    });
    for (var pi in ii)
      this[pi] === void 0 && typeof ii[pi] == "function" && (this[pi] = function(Oi) {
        return function() {
          return ii[Oi].apply(ii, arguments);
        };
      }(pi));
    for (var hi = 0; hi < Rr.length; hi++)
      ii.on(Rr[hi], this.emit.bind(this, Rr[hi]));
    return this._read = function(Oi) {
      _r("wrapped _read", Oi), Zr && (Zr = !1, ii.resume());
    }, this;
  }, Object.defineProperty(Vr.prototype, "readableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Vr._fromList = Pe;
  function Pe(ii, mi) {
    if (mi.length === 0)
      return null;
    var ei;
    return mi.objectMode ? ei = mi.buffer.shift() : !ii || ii >= mi.length ? (mi.decoder ? ei = mi.buffer.join("") : mi.buffer.length === 1 ? ei = mi.buffer.head.data : ei = mi.buffer.concat(mi.length), mi.buffer.clear()) : ei = ur(ii, mi.buffer, mi.decoder), ei;
  }
  function ur(ii, mi, ei) {
    var Zr;
    return ii < mi.head.data.length ? (Zr = mi.head.data.slice(0, ii), mi.head.data = mi.head.data.slice(ii)) : ii === mi.head.data.length ? Zr = mi.shift() : Zr = ei ? Pr(ii, mi) : Hr(ii, mi), Zr;
  }
  function Pr(ii, mi) {
    var ei = mi.head, Zr = 1, pi = ei.data;
    for (ii -= pi.length; ei = ei.next; ) {
      var hi = ei.data, Oi = ii > hi.length ? hi.length : ii;
      if (Oi === hi.length ? pi += hi : pi += hi.slice(0, ii), ii -= Oi, ii === 0) {
        Oi === hi.length ? (++Zr, ei.next ? mi.head = ei.next : mi.head = mi.tail = null) : (mi.head = ei, ei.data = hi.slice(Oi));
        break;
      }
      ++Zr;
    }
    return mi.length -= Zr, pi;
  }
  function Hr(ii, mi) {
    var ei = Me.allocUnsafe(ii), Zr = mi.head, pi = 1;
    for (Zr.data.copy(ei), ii -= Zr.data.length; Zr = Zr.next; ) {
      var hi = Zr.data, Oi = ii > hi.length ? hi.length : ii;
      if (hi.copy(ei, ei.length - ii, 0, Oi), ii -= Oi, ii === 0) {
        Oi === hi.length ? (++pi, Zr.next ? mi.head = Zr.next : mi.head = mi.tail = null) : (mi.head = Zr, Zr.data = hi.slice(Oi));
        break;
      }
      ++pi;
    }
    return mi.length -= pi, ei;
  }
  function vi(ii) {
    var mi = ii._readableState;
    if (mi.length > 0)
      throw new Error('"endReadable()" called on non-empty stream');
    mi.endEmitted || (mi.ended = !0, m.nextTick(Ti, mi, ii));
  }
  function Ti(ii, mi) {
    !ii.endEmitted && ii.length === 0 && (ii.endEmitted = !0, mi.readable = !1, mi.emit("end"));
  }
  function wi(ii, mi) {
    for (var ei = 0, Zr = ii.length; ei < Zr; ei++)
      if (ii[ei] === mi)
        return ei;
    return -1;
  }
  return _stream_readable;
}
var _stream_transform = Transform$1, Duplex = require_stream_duplex(), util$2 = Object.create(util$3);
util$2.inherits = inherits_browser.exports;
util$2.inherits(Transform$1, Duplex);
function afterTransform(m, c) {
  var ie = this._transformState;
  ie.transforming = !1;
  var we = ie.writecb;
  if (!we)
    return this.emit("error", new Error("write callback called multiple times"));
  ie.writechunk = null, ie.writecb = null, c != null && this.push(c), we(m);
  var $e = this._readableState;
  $e.reading = !1, ($e.needReadable || $e.length < $e.highWaterMark) && this._read($e.highWaterMark);
}
function Transform$1(m) {
  if (!(this instanceof Transform$1))
    return new Transform$1(m);
  Duplex.call(this, m), this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, m && (typeof m.transform == "function" && (this._transform = m.transform), typeof m.flush == "function" && (this._flush = m.flush)), this.on("prefinish", prefinish);
}
function prefinish() {
  var m = this;
  typeof this._flush == "function" ? this._flush(function(c, ie) {
    done(m, c, ie);
  }) : done(this, null, null);
}
Transform$1.prototype.push = function(m, c) {
  return this._transformState.needTransform = !1, Duplex.prototype.push.call(this, m, c);
};
Transform$1.prototype._transform = function(m, c, ie) {
  throw new Error("_transform() is not implemented");
};
Transform$1.prototype._write = function(m, c, ie) {
  var we = this._transformState;
  if (we.writecb = ie, we.writechunk = m, we.writeencoding = c, !we.transforming) {
    var $e = this._readableState;
    (we.needTransform || $e.needReadable || $e.length < $e.highWaterMark) && this._read($e.highWaterMark);
  }
};
Transform$1.prototype._read = function(m) {
  var c = this._transformState;
  c.writechunk !== null && c.writecb && !c.transforming ? (c.transforming = !0, this._transform(c.writechunk, c.writeencoding, c.afterTransform)) : c.needTransform = !0;
};
Transform$1.prototype._destroy = function(m, c) {
  var ie = this;
  Duplex.prototype._destroy.call(this, m, function(we) {
    c(we), ie.emit("close");
  });
};
function done(m, c, ie) {
  if (c)
    return m.emit("error", c);
  if (ie != null && m.push(ie), m._writableState.length)
    throw new Error("Calling transform done when ws.length != 0");
  if (m._transformState.transforming)
    throw new Error("Calling transform done when still transforming");
  return m.push(null);
}
var _stream_passthrough = PassThrough, Transform = _stream_transform, util$1 = Object.create(util$3);
util$1.inherits = inherits_browser.exports;
util$1.inherits(PassThrough, Transform);
function PassThrough(m) {
  if (!(this instanceof PassThrough))
    return new PassThrough(m);
  Transform.call(this, m);
}
PassThrough.prototype._transform = function(m, c, ie) {
  ie(null, m);
};
(function(m, c) {
  c = m.exports = require_stream_readable(), c.Stream = c, c.Readable = c, c.Writable = require_stream_writable(), c.Duplex = require_stream_duplex(), c.Transform = _stream_transform, c.PassThrough = _stream_passthrough;
})(readableBrowser, readableBrowser.exports);
var sign = { exports: {} }, bn$4 = { exports: {} };
(function(m) {
  (function(c, ie) {
    function we(ze, Ue) {
      if (!ze)
        throw new Error(Ue || "Assertion failed");
    }
    function $e(ze, Ue) {
      ze.super_ = Ue;
      var tr = function() {
      };
      tr.prototype = Ue.prototype, ze.prototype = new tr(), ze.prototype.constructor = ze;
    }
    function Me(ze, Ue, tr) {
      if (Me.isBN(ze))
        return ze;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, ze !== null && ((Ue === "le" || Ue === "be") && (tr = Ue, Ue = 10), this._init(ze || 0, Ue || 10, tr || "be"));
    }
    typeof c == "object" ? c.exports = Me : ie.BN = Me, Me.BN = Me, Me.wordSize = 26;
    var Ze;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? Ze = window.Buffer : Ze = require$$0$4.Buffer;
    } catch {
    }
    Me.isBN = function(Ue) {
      return Ue instanceof Me ? !0 : Ue !== null && typeof Ue == "object" && Ue.constructor.wordSize === Me.wordSize && Array.isArray(Ue.words);
    }, Me.max = function(Ue, tr) {
      return Ue.cmp(tr) > 0 ? Ue : tr;
    }, Me.min = function(Ue, tr) {
      return Ue.cmp(tr) < 0 ? Ue : tr;
    }, Me.prototype._init = function(Ue, tr, lr) {
      if (typeof Ue == "number")
        return this._initNumber(Ue, tr, lr);
      if (typeof Ue == "object")
        return this._initArray(Ue, tr, lr);
      tr === "hex" && (tr = 16), we(tr === (tr | 0) && tr >= 2 && tr <= 36), Ue = Ue.toString().replace(/\s+/g, "");
      var pr = 0;
      Ue[0] === "-" && (pr++, this.negative = 1), pr < Ue.length && (tr === 16 ? this._parseHex(Ue, pr, lr) : (this._parseBase(Ue, tr, pr), lr === "le" && this._initArray(this.toArray(), tr, lr)));
    }, Me.prototype._initNumber = function(Ue, tr, lr) {
      Ue < 0 && (this.negative = 1, Ue = -Ue), Ue < 67108864 ? (this.words = [Ue & 67108863], this.length = 1) : Ue < 4503599627370496 ? (this.words = [
        Ue & 67108863,
        Ue / 67108864 & 67108863
      ], this.length = 2) : (we(Ue < 9007199254740992), this.words = [
        Ue & 67108863,
        Ue / 67108864 & 67108863,
        1
      ], this.length = 3), lr === "le" && this._initArray(this.toArray(), tr, lr);
    }, Me.prototype._initArray = function(Ue, tr, lr) {
      if (we(typeof Ue.length == "number"), Ue.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(Ue.length / 3), this.words = new Array(this.length);
      for (var pr = 0; pr < this.length; pr++)
        this.words[pr] = 0;
      var br, nr, Pe = 0;
      if (lr === "be")
        for (pr = Ue.length - 1, br = 0; pr >= 0; pr -= 3)
          nr = Ue[pr] | Ue[pr - 1] << 8 | Ue[pr - 2] << 16, this.words[br] |= nr << Pe & 67108863, this.words[br + 1] = nr >>> 26 - Pe & 67108863, Pe += 24, Pe >= 26 && (Pe -= 26, br++);
      else if (lr === "le")
        for (pr = 0, br = 0; pr < Ue.length; pr += 3)
          nr = Ue[pr] | Ue[pr + 1] << 8 | Ue[pr + 2] << 16, this.words[br] |= nr << Pe & 67108863, this.words[br + 1] = nr >>> 26 - Pe & 67108863, Pe += 24, Pe >= 26 && (Pe -= 26, br++);
      return this._strip();
    };
    function ne(ze, Ue) {
      var tr = ze.charCodeAt(Ue);
      if (tr >= 48 && tr <= 57)
        return tr - 48;
      if (tr >= 65 && tr <= 70)
        return tr - 55;
      if (tr >= 97 && tr <= 102)
        return tr - 87;
      we(!1, "Invalid character in " + ze);
    }
    function rr(ze, Ue, tr) {
      var lr = ne(ze, tr);
      return tr - 1 >= Ue && (lr |= ne(ze, tr - 1) << 4), lr;
    }
    Me.prototype._parseHex = function(Ue, tr, lr) {
      this.length = Math.ceil((Ue.length - tr) / 6), this.words = new Array(this.length);
      for (var pr = 0; pr < this.length; pr++)
        this.words[pr] = 0;
      var br = 0, nr = 0, Pe;
      if (lr === "be")
        for (pr = Ue.length - 1; pr >= tr; pr -= 2)
          Pe = rr(Ue, tr, pr) << br, this.words[nr] |= Pe & 67108863, br >= 18 ? (br -= 18, nr += 1, this.words[nr] |= Pe >>> 26) : br += 8;
      else {
        var ur = Ue.length - tr;
        for (pr = ur % 2 === 0 ? tr + 1 : tr; pr < Ue.length; pr += 2)
          Pe = rr(Ue, tr, pr) << br, this.words[nr] |= Pe & 67108863, br >= 18 ? (br -= 18, nr += 1, this.words[nr] |= Pe >>> 26) : br += 8;
      }
      this._strip();
    };
    function gr(ze, Ue, tr, lr) {
      for (var pr = 0, br = 0, nr = Math.min(ze.length, tr), Pe = Ue; Pe < nr; Pe++) {
        var ur = ze.charCodeAt(Pe) - 48;
        pr *= lr, ur >= 49 ? br = ur - 49 + 10 : ur >= 17 ? br = ur - 17 + 10 : br = ur, we(ur >= 0 && br < lr, "Invalid character"), pr += br;
      }
      return pr;
    }
    Me.prototype._parseBase = function(Ue, tr, lr) {
      this.words = [0], this.length = 1;
      for (var pr = 0, br = 1; br <= 67108863; br *= tr)
        pr++;
      pr--, br = br / tr | 0;
      for (var nr = Ue.length - lr, Pe = nr % pr, ur = Math.min(nr, nr - Pe) + lr, Pr = 0, Hr = lr; Hr < ur; Hr += pr)
        Pr = gr(Ue, Hr, Hr + pr, tr), this.imuln(br), this.words[0] + Pr < 67108864 ? this.words[0] += Pr : this._iaddn(Pr);
      if (Pe !== 0) {
        var vi = 1;
        for (Pr = gr(Ue, Hr, Ue.length, tr), Hr = 0; Hr < Pe; Hr++)
          vi *= tr;
        this.imuln(vi), this.words[0] + Pr < 67108864 ? this.words[0] += Pr : this._iaddn(Pr);
      }
      this._strip();
    }, Me.prototype.copy = function(Ue) {
      Ue.words = new Array(this.length);
      for (var tr = 0; tr < this.length; tr++)
        Ue.words[tr] = this.words[tr];
      Ue.length = this.length, Ue.negative = this.negative, Ue.red = this.red;
    };
    function or(ze, Ue) {
      ze.words = Ue.words, ze.length = Ue.length, ze.negative = Ue.negative, ze.red = Ue.red;
    }
    if (Me.prototype._move = function(Ue) {
      or(Ue, this);
    }, Me.prototype.clone = function() {
      var Ue = new Me(null);
      return this.copy(Ue), Ue;
    }, Me.prototype._expand = function(Ue) {
      for (; this.length < Ue; )
        this.words[this.length++] = 0;
      return this;
    }, Me.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, Me.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        Me.prototype[Symbol.for("nodejs.util.inspect.custom")] = _r;
      } catch {
        Me.prototype.inspect = _r;
      }
    else
      Me.prototype.inspect = _r;
    function _r() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var Lr = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], Ir = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Ar = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    Me.prototype.toString = function(Ue, tr) {
      Ue = Ue || 10, tr = tr | 0 || 1;
      var lr;
      if (Ue === 16 || Ue === "hex") {
        lr = "";
        for (var pr = 0, br = 0, nr = 0; nr < this.length; nr++) {
          var Pe = this.words[nr], ur = ((Pe << pr | br) & 16777215).toString(16);
          br = Pe >>> 24 - pr & 16777215, pr += 2, pr >= 26 && (pr -= 26, nr--), br !== 0 || nr !== this.length - 1 ? lr = Lr[6 - ur.length] + ur + lr : lr = ur + lr;
        }
        for (br !== 0 && (lr = br.toString(16) + lr); lr.length % tr !== 0; )
          lr = "0" + lr;
        return this.negative !== 0 && (lr = "-" + lr), lr;
      }
      if (Ue === (Ue | 0) && Ue >= 2 && Ue <= 36) {
        var Pr = Ir[Ue], Hr = Ar[Ue];
        lr = "";
        var vi = this.clone();
        for (vi.negative = 0; !vi.isZero(); ) {
          var Ti = vi.modrn(Hr).toString(Ue);
          vi = vi.idivn(Hr), vi.isZero() ? lr = Ti + lr : lr = Lr[Pr - Ti.length] + Ti + lr;
        }
        for (this.isZero() && (lr = "0" + lr); lr.length % tr !== 0; )
          lr = "0" + lr;
        return this.negative !== 0 && (lr = "-" + lr), lr;
      }
      we(!1, "Base should be between 2 and 36");
    }, Me.prototype.toNumber = function() {
      var Ue = this.words[0];
      return this.length === 2 ? Ue += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ue += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && we(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ue : Ue;
    }, Me.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, Ze && (Me.prototype.toBuffer = function(Ue, tr) {
      return this.toArrayLike(Ze, Ue, tr);
    }), Me.prototype.toArray = function(Ue, tr) {
      return this.toArrayLike(Array, Ue, tr);
    };
    var Rr = function(Ue, tr) {
      return Ue.allocUnsafe ? Ue.allocUnsafe(tr) : new Ue(tr);
    };
    Me.prototype.toArrayLike = function(Ue, tr, lr) {
      this._strip();
      var pr = this.byteLength(), br = lr || Math.max(1, pr);
      we(pr <= br, "byte array longer than desired length"), we(br > 0, "Requested array length <= 0");
      var nr = Rr(Ue, br), Pe = tr === "le" ? "LE" : "BE";
      return this["_toArrayLike" + Pe](nr, pr), nr;
    }, Me.prototype._toArrayLikeLE = function(Ue, tr) {
      for (var lr = 0, pr = 0, br = 0, nr = 0; br < this.length; br++) {
        var Pe = this.words[br] << nr | pr;
        Ue[lr++] = Pe & 255, lr < Ue.length && (Ue[lr++] = Pe >> 8 & 255), lr < Ue.length && (Ue[lr++] = Pe >> 16 & 255), nr === 6 ? (lr < Ue.length && (Ue[lr++] = Pe >> 24 & 255), pr = 0, nr = 0) : (pr = Pe >>> 24, nr += 2);
      }
      if (lr < Ue.length)
        for (Ue[lr++] = pr; lr < Ue.length; )
          Ue[lr++] = 0;
    }, Me.prototype._toArrayLikeBE = function(Ue, tr) {
      for (var lr = Ue.length - 1, pr = 0, br = 0, nr = 0; br < this.length; br++) {
        var Pe = this.words[br] << nr | pr;
        Ue[lr--] = Pe & 255, lr >= 0 && (Ue[lr--] = Pe >> 8 & 255), lr >= 0 && (Ue[lr--] = Pe >> 16 & 255), nr === 6 ? (lr >= 0 && (Ue[lr--] = Pe >> 24 & 255), pr = 0, nr = 0) : (pr = Pe >>> 24, nr += 2);
      }
      if (lr >= 0)
        for (Ue[lr--] = pr; lr >= 0; )
          Ue[lr--] = 0;
    }, Math.clz32 ? Me.prototype._countBits = function(Ue) {
      return 32 - Math.clz32(Ue);
    } : Me.prototype._countBits = function(Ue) {
      var tr = Ue, lr = 0;
      return tr >= 4096 && (lr += 13, tr >>>= 13), tr >= 64 && (lr += 7, tr >>>= 7), tr >= 8 && (lr += 4, tr >>>= 4), tr >= 2 && (lr += 2, tr >>>= 2), lr + tr;
    }, Me.prototype._zeroBits = function(Ue) {
      if (Ue === 0)
        return 26;
      var tr = Ue, lr = 0;
      return (tr & 8191) === 0 && (lr += 13, tr >>>= 13), (tr & 127) === 0 && (lr += 7, tr >>>= 7), (tr & 15) === 0 && (lr += 4, tr >>>= 4), (tr & 3) === 0 && (lr += 2, tr >>>= 2), (tr & 1) === 0 && lr++, lr;
    }, Me.prototype.bitLength = function() {
      var Ue = this.words[this.length - 1], tr = this._countBits(Ue);
      return (this.length - 1) * 26 + tr;
    };
    function Nr(ze) {
      for (var Ue = new Array(ze.bitLength()), tr = 0; tr < Ue.length; tr++) {
        var lr = tr / 26 | 0, pr = tr % 26;
        Ue[tr] = ze.words[lr] >>> pr & 1;
      }
      return Ue;
    }
    Me.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var Ue = 0, tr = 0; tr < this.length; tr++) {
        var lr = this._zeroBits(this.words[tr]);
        if (Ue += lr, lr !== 26)
          break;
      }
      return Ue;
    }, Me.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, Me.prototype.toTwos = function(Ue) {
      return this.negative !== 0 ? this.abs().inotn(Ue).iaddn(1) : this.clone();
    }, Me.prototype.fromTwos = function(Ue) {
      return this.testn(Ue - 1) ? this.notn(Ue).iaddn(1).ineg() : this.clone();
    }, Me.prototype.isNeg = function() {
      return this.negative !== 0;
    }, Me.prototype.neg = function() {
      return this.clone().ineg();
    }, Me.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, Me.prototype.iuor = function(Ue) {
      for (; this.length < Ue.length; )
        this.words[this.length++] = 0;
      for (var tr = 0; tr < Ue.length; tr++)
        this.words[tr] = this.words[tr] | Ue.words[tr];
      return this._strip();
    }, Me.prototype.ior = function(Ue) {
      return we((this.negative | Ue.negative) === 0), this.iuor(Ue);
    }, Me.prototype.or = function(Ue) {
      return this.length > Ue.length ? this.clone().ior(Ue) : Ue.clone().ior(this);
    }, Me.prototype.uor = function(Ue) {
      return this.length > Ue.length ? this.clone().iuor(Ue) : Ue.clone().iuor(this);
    }, Me.prototype.iuand = function(Ue) {
      var tr;
      this.length > Ue.length ? tr = Ue : tr = this;
      for (var lr = 0; lr < tr.length; lr++)
        this.words[lr] = this.words[lr] & Ue.words[lr];
      return this.length = tr.length, this._strip();
    }, Me.prototype.iand = function(Ue) {
      return we((this.negative | Ue.negative) === 0), this.iuand(Ue);
    }, Me.prototype.and = function(Ue) {
      return this.length > Ue.length ? this.clone().iand(Ue) : Ue.clone().iand(this);
    }, Me.prototype.uand = function(Ue) {
      return this.length > Ue.length ? this.clone().iuand(Ue) : Ue.clone().iuand(this);
    }, Me.prototype.iuxor = function(Ue) {
      var tr, lr;
      this.length > Ue.length ? (tr = this, lr = Ue) : (tr = Ue, lr = this);
      for (var pr = 0; pr < lr.length; pr++)
        this.words[pr] = tr.words[pr] ^ lr.words[pr];
      if (this !== tr)
        for (; pr < tr.length; pr++)
          this.words[pr] = tr.words[pr];
      return this.length = tr.length, this._strip();
    }, Me.prototype.ixor = function(Ue) {
      return we((this.negative | Ue.negative) === 0), this.iuxor(Ue);
    }, Me.prototype.xor = function(Ue) {
      return this.length > Ue.length ? this.clone().ixor(Ue) : Ue.clone().ixor(this);
    }, Me.prototype.uxor = function(Ue) {
      return this.length > Ue.length ? this.clone().iuxor(Ue) : Ue.clone().iuxor(this);
    }, Me.prototype.inotn = function(Ue) {
      we(typeof Ue == "number" && Ue >= 0);
      var tr = Math.ceil(Ue / 26) | 0, lr = Ue % 26;
      this._expand(tr), lr > 0 && tr--;
      for (var pr = 0; pr < tr; pr++)
        this.words[pr] = ~this.words[pr] & 67108863;
      return lr > 0 && (this.words[pr] = ~this.words[pr] & 67108863 >> 26 - lr), this._strip();
    }, Me.prototype.notn = function(Ue) {
      return this.clone().inotn(Ue);
    }, Me.prototype.setn = function(Ue, tr) {
      we(typeof Ue == "number" && Ue >= 0);
      var lr = Ue / 26 | 0, pr = Ue % 26;
      return this._expand(lr + 1), tr ? this.words[lr] = this.words[lr] | 1 << pr : this.words[lr] = this.words[lr] & ~(1 << pr), this._strip();
    }, Me.prototype.iadd = function(Ue) {
      var tr;
      if (this.negative !== 0 && Ue.negative === 0)
        return this.negative = 0, tr = this.isub(Ue), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && Ue.negative !== 0)
        return Ue.negative = 0, tr = this.isub(Ue), Ue.negative = 1, tr._normSign();
      var lr, pr;
      this.length > Ue.length ? (lr = this, pr = Ue) : (lr = Ue, pr = this);
      for (var br = 0, nr = 0; nr < pr.length; nr++)
        tr = (lr.words[nr] | 0) + (pr.words[nr] | 0) + br, this.words[nr] = tr & 67108863, br = tr >>> 26;
      for (; br !== 0 && nr < lr.length; nr++)
        tr = (lr.words[nr] | 0) + br, this.words[nr] = tr & 67108863, br = tr >>> 26;
      if (this.length = lr.length, br !== 0)
        this.words[this.length] = br, this.length++;
      else if (lr !== this)
        for (; nr < lr.length; nr++)
          this.words[nr] = lr.words[nr];
      return this;
    }, Me.prototype.add = function(Ue) {
      var tr;
      return Ue.negative !== 0 && this.negative === 0 ? (Ue.negative = 0, tr = this.sub(Ue), Ue.negative ^= 1, tr) : Ue.negative === 0 && this.negative !== 0 ? (this.negative = 0, tr = Ue.sub(this), this.negative = 1, tr) : this.length > Ue.length ? this.clone().iadd(Ue) : Ue.clone().iadd(this);
    }, Me.prototype.isub = function(Ue) {
      if (Ue.negative !== 0) {
        Ue.negative = 0;
        var tr = this.iadd(Ue);
        return Ue.negative = 1, tr._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(Ue), this.negative = 1, this._normSign();
      var lr = this.cmp(Ue);
      if (lr === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var pr, br;
      lr > 0 ? (pr = this, br = Ue) : (pr = Ue, br = this);
      for (var nr = 0, Pe = 0; Pe < br.length; Pe++)
        tr = (pr.words[Pe] | 0) - (br.words[Pe] | 0) + nr, nr = tr >> 26, this.words[Pe] = tr & 67108863;
      for (; nr !== 0 && Pe < pr.length; Pe++)
        tr = (pr.words[Pe] | 0) + nr, nr = tr >> 26, this.words[Pe] = tr & 67108863;
      if (nr === 0 && Pe < pr.length && pr !== this)
        for (; Pe < pr.length; Pe++)
          this.words[Pe] = pr.words[Pe];
      return this.length = Math.max(this.length, Pe), pr !== this && (this.negative = 1), this._strip();
    }, Me.prototype.sub = function(Ue) {
      return this.clone().isub(Ue);
    };
    function Yr(ze, Ue, tr) {
      tr.negative = Ue.negative ^ ze.negative;
      var lr = ze.length + Ue.length | 0;
      tr.length = lr, lr = lr - 1 | 0;
      var pr = ze.words[0] | 0, br = Ue.words[0] | 0, nr = pr * br, Pe = nr & 67108863, ur = nr / 67108864 | 0;
      tr.words[0] = Pe;
      for (var Pr = 1; Pr < lr; Pr++) {
        for (var Hr = ur >>> 26, vi = ur & 67108863, Ti = Math.min(Pr, Ue.length - 1), wi = Math.max(0, Pr - ze.length + 1); wi <= Ti; wi++) {
          var ii = Pr - wi | 0;
          pr = ze.words[ii] | 0, br = Ue.words[wi] | 0, nr = pr * br + vi, Hr += nr / 67108864 | 0, vi = nr & 67108863;
        }
        tr.words[Pr] = vi | 0, ur = Hr | 0;
      }
      return ur !== 0 ? tr.words[Pr] = ur | 0 : tr.length--, tr._strip();
    }
    var Vr = function(Ue, tr, lr) {
      var pr = Ue.words, br = tr.words, nr = lr.words, Pe = 0, ur, Pr, Hr, vi = pr[0] | 0, Ti = vi & 8191, wi = vi >>> 13, ii = pr[1] | 0, mi = ii & 8191, ei = ii >>> 13, Zr = pr[2] | 0, pi = Zr & 8191, hi = Zr >>> 13, Oi = pr[3] | 0, qi = Oi & 8191, yn = Oi >>> 13, sn = pr[4] | 0, $n = sn & 8191, rn = sn >>> 13, ji = pr[5] | 0, Kn = ji & 8191, In = ji >>> 13, Fn = pr[6] | 0, Po = Fn & 8191, vn = Fn >>> 13, Vn = pr[7] | 0, Xo = Vn & 8191, Xn = Vn >>> 13, Yn = pr[8] | 0, Wo = Yn & 8191, Ci = Yn >>> 13, ri = pr[9] | 0, yi = ri & 8191, Li = ri >>> 13, Yi = br[0] | 0, zn = Yi & 8191, un = Yi >>> 13, Gn = br[1] | 0, Mn = Gn & 8191, pn = Gn >>> 13, Rn = br[2] | 0, Io = Rn & 8191, to = Rn >>> 13, no = br[3] | 0, ma = no & 8191, Qn = no >>> 13, co = br[4] | 0, kn = co & 8191, ai = co >>> 13, _i = br[5] | 0, Pi = _i & 8191, Ai = _i >>> 13, ki = br[6] | 0, an = ki & 8191, Ui = ki >>> 13, Vi = br[7] | 0, Sn = Vi & 8191, Hi = Vi >>> 13, en = br[8] | 0, qn = en & 8191, _n = en >>> 13, Tn = br[9] | 0, xo = Tn & 8191, Co = Tn >>> 13;
      lr.negative = Ue.negative ^ tr.negative, lr.length = 19, ur = Math.imul(Ti, zn), Pr = Math.imul(Ti, un), Pr = Pr + Math.imul(wi, zn) | 0, Hr = Math.imul(wi, un);
      var $o = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + ($o >>> 26) | 0, $o &= 67108863, ur = Math.imul(mi, zn), Pr = Math.imul(mi, un), Pr = Pr + Math.imul(ei, zn) | 0, Hr = Math.imul(ei, un), ur = ur + Math.imul(Ti, Mn) | 0, Pr = Pr + Math.imul(Ti, pn) | 0, Pr = Pr + Math.imul(wi, Mn) | 0, Hr = Hr + Math.imul(wi, pn) | 0;
      var Bo = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (Bo >>> 26) | 0, Bo &= 67108863, ur = Math.imul(pi, zn), Pr = Math.imul(pi, un), Pr = Pr + Math.imul(hi, zn) | 0, Hr = Math.imul(hi, un), ur = ur + Math.imul(mi, Mn) | 0, Pr = Pr + Math.imul(mi, pn) | 0, Pr = Pr + Math.imul(ei, Mn) | 0, Hr = Hr + Math.imul(ei, pn) | 0, ur = ur + Math.imul(Ti, Io) | 0, Pr = Pr + Math.imul(Ti, to) | 0, Pr = Pr + Math.imul(wi, Io) | 0, Hr = Hr + Math.imul(wi, to) | 0;
      var Qo = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (Qo >>> 26) | 0, Qo &= 67108863, ur = Math.imul(qi, zn), Pr = Math.imul(qi, un), Pr = Pr + Math.imul(yn, zn) | 0, Hr = Math.imul(yn, un), ur = ur + Math.imul(pi, Mn) | 0, Pr = Pr + Math.imul(pi, pn) | 0, Pr = Pr + Math.imul(hi, Mn) | 0, Hr = Hr + Math.imul(hi, pn) | 0, ur = ur + Math.imul(mi, Io) | 0, Pr = Pr + Math.imul(mi, to) | 0, Pr = Pr + Math.imul(ei, Io) | 0, Hr = Hr + Math.imul(ei, to) | 0, ur = ur + Math.imul(Ti, ma) | 0, Pr = Pr + Math.imul(Ti, Qn) | 0, Pr = Pr + Math.imul(wi, ma) | 0, Hr = Hr + Math.imul(wi, Qn) | 0;
      var Go = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (Go >>> 26) | 0, Go &= 67108863, ur = Math.imul($n, zn), Pr = Math.imul($n, un), Pr = Pr + Math.imul(rn, zn) | 0, Hr = Math.imul(rn, un), ur = ur + Math.imul(qi, Mn) | 0, Pr = Pr + Math.imul(qi, pn) | 0, Pr = Pr + Math.imul(yn, Mn) | 0, Hr = Hr + Math.imul(yn, pn) | 0, ur = ur + Math.imul(pi, Io) | 0, Pr = Pr + Math.imul(pi, to) | 0, Pr = Pr + Math.imul(hi, Io) | 0, Hr = Hr + Math.imul(hi, to) | 0, ur = ur + Math.imul(mi, ma) | 0, Pr = Pr + Math.imul(mi, Qn) | 0, Pr = Pr + Math.imul(ei, ma) | 0, Hr = Hr + Math.imul(ei, Qn) | 0, ur = ur + Math.imul(Ti, kn) | 0, Pr = Pr + Math.imul(Ti, ai) | 0, Pr = Pr + Math.imul(wi, kn) | 0, Hr = Hr + Math.imul(wi, ai) | 0;
      var No = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, ur = Math.imul(Kn, zn), Pr = Math.imul(Kn, un), Pr = Pr + Math.imul(In, zn) | 0, Hr = Math.imul(In, un), ur = ur + Math.imul($n, Mn) | 0, Pr = Pr + Math.imul($n, pn) | 0, Pr = Pr + Math.imul(rn, Mn) | 0, Hr = Hr + Math.imul(rn, pn) | 0, ur = ur + Math.imul(qi, Io) | 0, Pr = Pr + Math.imul(qi, to) | 0, Pr = Pr + Math.imul(yn, Io) | 0, Hr = Hr + Math.imul(yn, to) | 0, ur = ur + Math.imul(pi, ma) | 0, Pr = Pr + Math.imul(pi, Qn) | 0, Pr = Pr + Math.imul(hi, ma) | 0, Hr = Hr + Math.imul(hi, Qn) | 0, ur = ur + Math.imul(mi, kn) | 0, Pr = Pr + Math.imul(mi, ai) | 0, Pr = Pr + Math.imul(ei, kn) | 0, Hr = Hr + Math.imul(ei, ai) | 0, ur = ur + Math.imul(Ti, Pi) | 0, Pr = Pr + Math.imul(Ti, Ai) | 0, Pr = Pr + Math.imul(wi, Pi) | 0, Hr = Hr + Math.imul(wi, Ai) | 0;
      var Zo = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (Zo >>> 26) | 0, Zo &= 67108863, ur = Math.imul(Po, zn), Pr = Math.imul(Po, un), Pr = Pr + Math.imul(vn, zn) | 0, Hr = Math.imul(vn, un), ur = ur + Math.imul(Kn, Mn) | 0, Pr = Pr + Math.imul(Kn, pn) | 0, Pr = Pr + Math.imul(In, Mn) | 0, Hr = Hr + Math.imul(In, pn) | 0, ur = ur + Math.imul($n, Io) | 0, Pr = Pr + Math.imul($n, to) | 0, Pr = Pr + Math.imul(rn, Io) | 0, Hr = Hr + Math.imul(rn, to) | 0, ur = ur + Math.imul(qi, ma) | 0, Pr = Pr + Math.imul(qi, Qn) | 0, Pr = Pr + Math.imul(yn, ma) | 0, Hr = Hr + Math.imul(yn, Qn) | 0, ur = ur + Math.imul(pi, kn) | 0, Pr = Pr + Math.imul(pi, ai) | 0, Pr = Pr + Math.imul(hi, kn) | 0, Hr = Hr + Math.imul(hi, ai) | 0, ur = ur + Math.imul(mi, Pi) | 0, Pr = Pr + Math.imul(mi, Ai) | 0, Pr = Pr + Math.imul(ei, Pi) | 0, Hr = Hr + Math.imul(ei, Ai) | 0, ur = ur + Math.imul(Ti, an) | 0, Pr = Pr + Math.imul(Ti, Ui) | 0, Pr = Pr + Math.imul(wi, an) | 0, Hr = Hr + Math.imul(wi, Ui) | 0;
      var ea = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (ea >>> 26) | 0, ea &= 67108863, ur = Math.imul(Xo, zn), Pr = Math.imul(Xo, un), Pr = Pr + Math.imul(Xn, zn) | 0, Hr = Math.imul(Xn, un), ur = ur + Math.imul(Po, Mn) | 0, Pr = Pr + Math.imul(Po, pn) | 0, Pr = Pr + Math.imul(vn, Mn) | 0, Hr = Hr + Math.imul(vn, pn) | 0, ur = ur + Math.imul(Kn, Io) | 0, Pr = Pr + Math.imul(Kn, to) | 0, Pr = Pr + Math.imul(In, Io) | 0, Hr = Hr + Math.imul(In, to) | 0, ur = ur + Math.imul($n, ma) | 0, Pr = Pr + Math.imul($n, Qn) | 0, Pr = Pr + Math.imul(rn, ma) | 0, Hr = Hr + Math.imul(rn, Qn) | 0, ur = ur + Math.imul(qi, kn) | 0, Pr = Pr + Math.imul(qi, ai) | 0, Pr = Pr + Math.imul(yn, kn) | 0, Hr = Hr + Math.imul(yn, ai) | 0, ur = ur + Math.imul(pi, Pi) | 0, Pr = Pr + Math.imul(pi, Ai) | 0, Pr = Pr + Math.imul(hi, Pi) | 0, Hr = Hr + Math.imul(hi, Ai) | 0, ur = ur + Math.imul(mi, an) | 0, Pr = Pr + Math.imul(mi, Ui) | 0, Pr = Pr + Math.imul(ei, an) | 0, Hr = Hr + Math.imul(ei, Ui) | 0, ur = ur + Math.imul(Ti, Sn) | 0, Pr = Pr + Math.imul(Ti, Hi) | 0, Pr = Pr + Math.imul(wi, Sn) | 0, Hr = Hr + Math.imul(wi, Hi) | 0;
      var da = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (da >>> 26) | 0, da &= 67108863, ur = Math.imul(Wo, zn), Pr = Math.imul(Wo, un), Pr = Pr + Math.imul(Ci, zn) | 0, Hr = Math.imul(Ci, un), ur = ur + Math.imul(Xo, Mn) | 0, Pr = Pr + Math.imul(Xo, pn) | 0, Pr = Pr + Math.imul(Xn, Mn) | 0, Hr = Hr + Math.imul(Xn, pn) | 0, ur = ur + Math.imul(Po, Io) | 0, Pr = Pr + Math.imul(Po, to) | 0, Pr = Pr + Math.imul(vn, Io) | 0, Hr = Hr + Math.imul(vn, to) | 0, ur = ur + Math.imul(Kn, ma) | 0, Pr = Pr + Math.imul(Kn, Qn) | 0, Pr = Pr + Math.imul(In, ma) | 0, Hr = Hr + Math.imul(In, Qn) | 0, ur = ur + Math.imul($n, kn) | 0, Pr = Pr + Math.imul($n, ai) | 0, Pr = Pr + Math.imul(rn, kn) | 0, Hr = Hr + Math.imul(rn, ai) | 0, ur = ur + Math.imul(qi, Pi) | 0, Pr = Pr + Math.imul(qi, Ai) | 0, Pr = Pr + Math.imul(yn, Pi) | 0, Hr = Hr + Math.imul(yn, Ai) | 0, ur = ur + Math.imul(pi, an) | 0, Pr = Pr + Math.imul(pi, Ui) | 0, Pr = Pr + Math.imul(hi, an) | 0, Hr = Hr + Math.imul(hi, Ui) | 0, ur = ur + Math.imul(mi, Sn) | 0, Pr = Pr + Math.imul(mi, Hi) | 0, Pr = Pr + Math.imul(ei, Sn) | 0, Hr = Hr + Math.imul(ei, Hi) | 0, ur = ur + Math.imul(Ti, qn) | 0, Pr = Pr + Math.imul(Ti, _n) | 0, Pr = Pr + Math.imul(wi, qn) | 0, Hr = Hr + Math.imul(wi, _n) | 0;
      var Ra = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (Ra >>> 26) | 0, Ra &= 67108863, ur = Math.imul(yi, zn), Pr = Math.imul(yi, un), Pr = Pr + Math.imul(Li, zn) | 0, Hr = Math.imul(Li, un), ur = ur + Math.imul(Wo, Mn) | 0, Pr = Pr + Math.imul(Wo, pn) | 0, Pr = Pr + Math.imul(Ci, Mn) | 0, Hr = Hr + Math.imul(Ci, pn) | 0, ur = ur + Math.imul(Xo, Io) | 0, Pr = Pr + Math.imul(Xo, to) | 0, Pr = Pr + Math.imul(Xn, Io) | 0, Hr = Hr + Math.imul(Xn, to) | 0, ur = ur + Math.imul(Po, ma) | 0, Pr = Pr + Math.imul(Po, Qn) | 0, Pr = Pr + Math.imul(vn, ma) | 0, Hr = Hr + Math.imul(vn, Qn) | 0, ur = ur + Math.imul(Kn, kn) | 0, Pr = Pr + Math.imul(Kn, ai) | 0, Pr = Pr + Math.imul(In, kn) | 0, Hr = Hr + Math.imul(In, ai) | 0, ur = ur + Math.imul($n, Pi) | 0, Pr = Pr + Math.imul($n, Ai) | 0, Pr = Pr + Math.imul(rn, Pi) | 0, Hr = Hr + Math.imul(rn, Ai) | 0, ur = ur + Math.imul(qi, an) | 0, Pr = Pr + Math.imul(qi, Ui) | 0, Pr = Pr + Math.imul(yn, an) | 0, Hr = Hr + Math.imul(yn, Ui) | 0, ur = ur + Math.imul(pi, Sn) | 0, Pr = Pr + Math.imul(pi, Hi) | 0, Pr = Pr + Math.imul(hi, Sn) | 0, Hr = Hr + Math.imul(hi, Hi) | 0, ur = ur + Math.imul(mi, qn) | 0, Pr = Pr + Math.imul(mi, _n) | 0, Pr = Pr + Math.imul(ei, qn) | 0, Hr = Hr + Math.imul(ei, _n) | 0, ur = ur + Math.imul(Ti, xo) | 0, Pr = Pr + Math.imul(Ti, Co) | 0, Pr = Pr + Math.imul(wi, xo) | 0, Hr = Hr + Math.imul(wi, Co) | 0;
      var ba = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (ba >>> 26) | 0, ba &= 67108863, ur = Math.imul(yi, Mn), Pr = Math.imul(yi, pn), Pr = Pr + Math.imul(Li, Mn) | 0, Hr = Math.imul(Li, pn), ur = ur + Math.imul(Wo, Io) | 0, Pr = Pr + Math.imul(Wo, to) | 0, Pr = Pr + Math.imul(Ci, Io) | 0, Hr = Hr + Math.imul(Ci, to) | 0, ur = ur + Math.imul(Xo, ma) | 0, Pr = Pr + Math.imul(Xo, Qn) | 0, Pr = Pr + Math.imul(Xn, ma) | 0, Hr = Hr + Math.imul(Xn, Qn) | 0, ur = ur + Math.imul(Po, kn) | 0, Pr = Pr + Math.imul(Po, ai) | 0, Pr = Pr + Math.imul(vn, kn) | 0, Hr = Hr + Math.imul(vn, ai) | 0, ur = ur + Math.imul(Kn, Pi) | 0, Pr = Pr + Math.imul(Kn, Ai) | 0, Pr = Pr + Math.imul(In, Pi) | 0, Hr = Hr + Math.imul(In, Ai) | 0, ur = ur + Math.imul($n, an) | 0, Pr = Pr + Math.imul($n, Ui) | 0, Pr = Pr + Math.imul(rn, an) | 0, Hr = Hr + Math.imul(rn, Ui) | 0, ur = ur + Math.imul(qi, Sn) | 0, Pr = Pr + Math.imul(qi, Hi) | 0, Pr = Pr + Math.imul(yn, Sn) | 0, Hr = Hr + Math.imul(yn, Hi) | 0, ur = ur + Math.imul(pi, qn) | 0, Pr = Pr + Math.imul(pi, _n) | 0, Pr = Pr + Math.imul(hi, qn) | 0, Hr = Hr + Math.imul(hi, _n) | 0, ur = ur + Math.imul(mi, xo) | 0, Pr = Pr + Math.imul(mi, Co) | 0, Pr = Pr + Math.imul(ei, xo) | 0, Hr = Hr + Math.imul(ei, Co) | 0;
      var Ea = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (Ea >>> 26) | 0, Ea &= 67108863, ur = Math.imul(yi, Io), Pr = Math.imul(yi, to), Pr = Pr + Math.imul(Li, Io) | 0, Hr = Math.imul(Li, to), ur = ur + Math.imul(Wo, ma) | 0, Pr = Pr + Math.imul(Wo, Qn) | 0, Pr = Pr + Math.imul(Ci, ma) | 0, Hr = Hr + Math.imul(Ci, Qn) | 0, ur = ur + Math.imul(Xo, kn) | 0, Pr = Pr + Math.imul(Xo, ai) | 0, Pr = Pr + Math.imul(Xn, kn) | 0, Hr = Hr + Math.imul(Xn, ai) | 0, ur = ur + Math.imul(Po, Pi) | 0, Pr = Pr + Math.imul(Po, Ai) | 0, Pr = Pr + Math.imul(vn, Pi) | 0, Hr = Hr + Math.imul(vn, Ai) | 0, ur = ur + Math.imul(Kn, an) | 0, Pr = Pr + Math.imul(Kn, Ui) | 0, Pr = Pr + Math.imul(In, an) | 0, Hr = Hr + Math.imul(In, Ui) | 0, ur = ur + Math.imul($n, Sn) | 0, Pr = Pr + Math.imul($n, Hi) | 0, Pr = Pr + Math.imul(rn, Sn) | 0, Hr = Hr + Math.imul(rn, Hi) | 0, ur = ur + Math.imul(qi, qn) | 0, Pr = Pr + Math.imul(qi, _n) | 0, Pr = Pr + Math.imul(yn, qn) | 0, Hr = Hr + Math.imul(yn, _n) | 0, ur = ur + Math.imul(pi, xo) | 0, Pr = Pr + Math.imul(pi, Co) | 0, Pr = Pr + Math.imul(hi, xo) | 0, Hr = Hr + Math.imul(hi, Co) | 0;
      var Ha = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (Ha >>> 26) | 0, Ha &= 67108863, ur = Math.imul(yi, ma), Pr = Math.imul(yi, Qn), Pr = Pr + Math.imul(Li, ma) | 0, Hr = Math.imul(Li, Qn), ur = ur + Math.imul(Wo, kn) | 0, Pr = Pr + Math.imul(Wo, ai) | 0, Pr = Pr + Math.imul(Ci, kn) | 0, Hr = Hr + Math.imul(Ci, ai) | 0, ur = ur + Math.imul(Xo, Pi) | 0, Pr = Pr + Math.imul(Xo, Ai) | 0, Pr = Pr + Math.imul(Xn, Pi) | 0, Hr = Hr + Math.imul(Xn, Ai) | 0, ur = ur + Math.imul(Po, an) | 0, Pr = Pr + Math.imul(Po, Ui) | 0, Pr = Pr + Math.imul(vn, an) | 0, Hr = Hr + Math.imul(vn, Ui) | 0, ur = ur + Math.imul(Kn, Sn) | 0, Pr = Pr + Math.imul(Kn, Hi) | 0, Pr = Pr + Math.imul(In, Sn) | 0, Hr = Hr + Math.imul(In, Hi) | 0, ur = ur + Math.imul($n, qn) | 0, Pr = Pr + Math.imul($n, _n) | 0, Pr = Pr + Math.imul(rn, qn) | 0, Hr = Hr + Math.imul(rn, _n) | 0, ur = ur + Math.imul(qi, xo) | 0, Pr = Pr + Math.imul(qi, Co) | 0, Pr = Pr + Math.imul(yn, xo) | 0, Hr = Hr + Math.imul(yn, Co) | 0;
      var Fa = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (Fa >>> 26) | 0, Fa &= 67108863, ur = Math.imul(yi, kn), Pr = Math.imul(yi, ai), Pr = Pr + Math.imul(Li, kn) | 0, Hr = Math.imul(Li, ai), ur = ur + Math.imul(Wo, Pi) | 0, Pr = Pr + Math.imul(Wo, Ai) | 0, Pr = Pr + Math.imul(Ci, Pi) | 0, Hr = Hr + Math.imul(Ci, Ai) | 0, ur = ur + Math.imul(Xo, an) | 0, Pr = Pr + Math.imul(Xo, Ui) | 0, Pr = Pr + Math.imul(Xn, an) | 0, Hr = Hr + Math.imul(Xn, Ui) | 0, ur = ur + Math.imul(Po, Sn) | 0, Pr = Pr + Math.imul(Po, Hi) | 0, Pr = Pr + Math.imul(vn, Sn) | 0, Hr = Hr + Math.imul(vn, Hi) | 0, ur = ur + Math.imul(Kn, qn) | 0, Pr = Pr + Math.imul(Kn, _n) | 0, Pr = Pr + Math.imul(In, qn) | 0, Hr = Hr + Math.imul(In, _n) | 0, ur = ur + Math.imul($n, xo) | 0, Pr = Pr + Math.imul($n, Co) | 0, Pr = Pr + Math.imul(rn, xo) | 0, Hr = Hr + Math.imul(rn, Co) | 0;
      var ls = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (ls >>> 26) | 0, ls &= 67108863, ur = Math.imul(yi, Pi), Pr = Math.imul(yi, Ai), Pr = Pr + Math.imul(Li, Pi) | 0, Hr = Math.imul(Li, Ai), ur = ur + Math.imul(Wo, an) | 0, Pr = Pr + Math.imul(Wo, Ui) | 0, Pr = Pr + Math.imul(Ci, an) | 0, Hr = Hr + Math.imul(Ci, Ui) | 0, ur = ur + Math.imul(Xo, Sn) | 0, Pr = Pr + Math.imul(Xo, Hi) | 0, Pr = Pr + Math.imul(Xn, Sn) | 0, Hr = Hr + Math.imul(Xn, Hi) | 0, ur = ur + Math.imul(Po, qn) | 0, Pr = Pr + Math.imul(Po, _n) | 0, Pr = Pr + Math.imul(vn, qn) | 0, Hr = Hr + Math.imul(vn, _n) | 0, ur = ur + Math.imul(Kn, xo) | 0, Pr = Pr + Math.imul(Kn, Co) | 0, Pr = Pr + Math.imul(In, xo) | 0, Hr = Hr + Math.imul(In, Co) | 0;
      var us = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (us >>> 26) | 0, us &= 67108863, ur = Math.imul(yi, an), Pr = Math.imul(yi, Ui), Pr = Pr + Math.imul(Li, an) | 0, Hr = Math.imul(Li, Ui), ur = ur + Math.imul(Wo, Sn) | 0, Pr = Pr + Math.imul(Wo, Hi) | 0, Pr = Pr + Math.imul(Ci, Sn) | 0, Hr = Hr + Math.imul(Ci, Hi) | 0, ur = ur + Math.imul(Xo, qn) | 0, Pr = Pr + Math.imul(Xo, _n) | 0, Pr = Pr + Math.imul(Xn, qn) | 0, Hr = Hr + Math.imul(Xn, _n) | 0, ur = ur + Math.imul(Po, xo) | 0, Pr = Pr + Math.imul(Po, Co) | 0, Pr = Pr + Math.imul(vn, xo) | 0, Hr = Hr + Math.imul(vn, Co) | 0;
      var Xa = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (Xa >>> 26) | 0, Xa &= 67108863, ur = Math.imul(yi, Sn), Pr = Math.imul(yi, Hi), Pr = Pr + Math.imul(Li, Sn) | 0, Hr = Math.imul(Li, Hi), ur = ur + Math.imul(Wo, qn) | 0, Pr = Pr + Math.imul(Wo, _n) | 0, Pr = Pr + Math.imul(Ci, qn) | 0, Hr = Hr + Math.imul(Ci, _n) | 0, ur = ur + Math.imul(Xo, xo) | 0, Pr = Pr + Math.imul(Xo, Co) | 0, Pr = Pr + Math.imul(Xn, xo) | 0, Hr = Hr + Math.imul(Xn, Co) | 0;
      var hs = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (hs >>> 26) | 0, hs &= 67108863, ur = Math.imul(yi, qn), Pr = Math.imul(yi, _n), Pr = Pr + Math.imul(Li, qn) | 0, Hr = Math.imul(Li, _n), ur = ur + Math.imul(Wo, xo) | 0, Pr = Pr + Math.imul(Wo, Co) | 0, Pr = Pr + Math.imul(Ci, xo) | 0, Hr = Hr + Math.imul(Ci, Co) | 0;
      var Fc = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      Pe = (Hr + (Pr >>> 13) | 0) + (Fc >>> 26) | 0, Fc &= 67108863, ur = Math.imul(yi, xo), Pr = Math.imul(yi, Co), Pr = Pr + Math.imul(Li, xo) | 0, Hr = Math.imul(Li, Co);
      var Pl = (Pe + ur | 0) + ((Pr & 8191) << 13) | 0;
      return Pe = (Hr + (Pr >>> 13) | 0) + (Pl >>> 26) | 0, Pl &= 67108863, nr[0] = $o, nr[1] = Bo, nr[2] = Qo, nr[3] = Go, nr[4] = No, nr[5] = Zo, nr[6] = ea, nr[7] = da, nr[8] = Ra, nr[9] = ba, nr[10] = Ea, nr[11] = Ha, nr[12] = Fa, nr[13] = ls, nr[14] = us, nr[15] = Xa, nr[16] = hs, nr[17] = Fc, nr[18] = Pl, Pe !== 0 && (nr[19] = Pe, lr.length++), lr;
    };
    Math.imul || (Vr = Yr);
    function Xr(ze, Ue, tr) {
      tr.negative = Ue.negative ^ ze.negative, tr.length = ze.length + Ue.length;
      for (var lr = 0, pr = 0, br = 0; br < tr.length - 1; br++) {
        var nr = pr;
        pr = 0;
        for (var Pe = lr & 67108863, ur = Math.min(br, Ue.length - 1), Pr = Math.max(0, br - ze.length + 1); Pr <= ur; Pr++) {
          var Hr = br - Pr, vi = ze.words[Hr] | 0, Ti = Ue.words[Pr] | 0, wi = vi * Ti, ii = wi & 67108863;
          nr = nr + (wi / 67108864 | 0) | 0, ii = ii + Pe | 0, Pe = ii & 67108863, nr = nr + (ii >>> 26) | 0, pr += nr >>> 26, nr &= 67108863;
        }
        tr.words[br] = Pe, lr = nr, nr = pr;
      }
      return lr !== 0 ? tr.words[br] = lr : tr.length--, tr._strip();
    }
    function Wr(ze, Ue, tr) {
      return Xr(ze, Ue, tr);
    }
    Me.prototype.mulTo = function(Ue, tr) {
      var lr, pr = this.length + Ue.length;
      return this.length === 10 && Ue.length === 10 ? lr = Vr(this, Ue, tr) : pr < 63 ? lr = Yr(this, Ue, tr) : pr < 1024 ? lr = Xr(this, Ue, tr) : lr = Wr(this, Ue, tr), lr;
    }, Me.prototype.mul = function(Ue) {
      var tr = new Me(null);
      return tr.words = new Array(this.length + Ue.length), this.mulTo(Ue, tr);
    }, Me.prototype.mulf = function(Ue) {
      var tr = new Me(null);
      return tr.words = new Array(this.length + Ue.length), Wr(this, Ue, tr);
    }, Me.prototype.imul = function(Ue) {
      return this.clone().mulTo(Ue, this);
    }, Me.prototype.imuln = function(Ue) {
      var tr = Ue < 0;
      tr && (Ue = -Ue), we(typeof Ue == "number"), we(Ue < 67108864);
      for (var lr = 0, pr = 0; pr < this.length; pr++) {
        var br = (this.words[pr] | 0) * Ue, nr = (br & 67108863) + (lr & 67108863);
        lr >>= 26, lr += br / 67108864 | 0, lr += nr >>> 26, this.words[pr] = nr & 67108863;
      }
      return lr !== 0 && (this.words[pr] = lr, this.length++), tr ? this.ineg() : this;
    }, Me.prototype.muln = function(Ue) {
      return this.clone().imuln(Ue);
    }, Me.prototype.sqr = function() {
      return this.mul(this);
    }, Me.prototype.isqr = function() {
      return this.imul(this.clone());
    }, Me.prototype.pow = function(Ue) {
      var tr = Nr(Ue);
      if (tr.length === 0)
        return new Me(1);
      for (var lr = this, pr = 0; pr < tr.length && tr[pr] === 0; pr++, lr = lr.sqr())
        ;
      if (++pr < tr.length)
        for (var br = lr.sqr(); pr < tr.length; pr++, br = br.sqr())
          tr[pr] !== 0 && (lr = lr.mul(br));
      return lr;
    }, Me.prototype.iushln = function(Ue) {
      we(typeof Ue == "number" && Ue >= 0);
      var tr = Ue % 26, lr = (Ue - tr) / 26, pr = 67108863 >>> 26 - tr << 26 - tr, br;
      if (tr !== 0) {
        var nr = 0;
        for (br = 0; br < this.length; br++) {
          var Pe = this.words[br] & pr, ur = (this.words[br] | 0) - Pe << tr;
          this.words[br] = ur | nr, nr = Pe >>> 26 - tr;
        }
        nr && (this.words[br] = nr, this.length++);
      }
      if (lr !== 0) {
        for (br = this.length - 1; br >= 0; br--)
          this.words[br + lr] = this.words[br];
        for (br = 0; br < lr; br++)
          this.words[br] = 0;
        this.length += lr;
      }
      return this._strip();
    }, Me.prototype.ishln = function(Ue) {
      return we(this.negative === 0), this.iushln(Ue);
    }, Me.prototype.iushrn = function(Ue, tr, lr) {
      we(typeof Ue == "number" && Ue >= 0);
      var pr;
      tr ? pr = (tr - tr % 26) / 26 : pr = 0;
      var br = Ue % 26, nr = Math.min((Ue - br) / 26, this.length), Pe = 67108863 ^ 67108863 >>> br << br, ur = lr;
      if (pr -= nr, pr = Math.max(0, pr), ur) {
        for (var Pr = 0; Pr < nr; Pr++)
          ur.words[Pr] = this.words[Pr];
        ur.length = nr;
      }
      if (nr !== 0)
        if (this.length > nr)
          for (this.length -= nr, Pr = 0; Pr < this.length; Pr++)
            this.words[Pr] = this.words[Pr + nr];
        else
          this.words[0] = 0, this.length = 1;
      var Hr = 0;
      for (Pr = this.length - 1; Pr >= 0 && (Hr !== 0 || Pr >= pr); Pr--) {
        var vi = this.words[Pr] | 0;
        this.words[Pr] = Hr << 26 - br | vi >>> br, Hr = vi & Pe;
      }
      return ur && Hr !== 0 && (ur.words[ur.length++] = Hr), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, Me.prototype.ishrn = function(Ue, tr, lr) {
      return we(this.negative === 0), this.iushrn(Ue, tr, lr);
    }, Me.prototype.shln = function(Ue) {
      return this.clone().ishln(Ue);
    }, Me.prototype.ushln = function(Ue) {
      return this.clone().iushln(Ue);
    }, Me.prototype.shrn = function(Ue) {
      return this.clone().ishrn(Ue);
    }, Me.prototype.ushrn = function(Ue) {
      return this.clone().iushrn(Ue);
    }, Me.prototype.testn = function(Ue) {
      we(typeof Ue == "number" && Ue >= 0);
      var tr = Ue % 26, lr = (Ue - tr) / 26, pr = 1 << tr;
      if (this.length <= lr)
        return !1;
      var br = this.words[lr];
      return !!(br & pr);
    }, Me.prototype.imaskn = function(Ue) {
      we(typeof Ue == "number" && Ue >= 0);
      var tr = Ue % 26, lr = (Ue - tr) / 26;
      if (we(this.negative === 0, "imaskn works only with positive numbers"), this.length <= lr)
        return this;
      if (tr !== 0 && lr++, this.length = Math.min(lr, this.length), tr !== 0) {
        var pr = 67108863 ^ 67108863 >>> tr << tr;
        this.words[this.length - 1] &= pr;
      }
      return this._strip();
    }, Me.prototype.maskn = function(Ue) {
      return this.clone().imaskn(Ue);
    }, Me.prototype.iaddn = function(Ue) {
      return we(typeof Ue == "number"), we(Ue < 67108864), Ue < 0 ? this.isubn(-Ue) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= Ue ? (this.words[0] = Ue - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ue), this.negative = 1, this) : this._iaddn(Ue);
    }, Me.prototype._iaddn = function(Ue) {
      this.words[0] += Ue;
      for (var tr = 0; tr < this.length && this.words[tr] >= 67108864; tr++)
        this.words[tr] -= 67108864, tr === this.length - 1 ? this.words[tr + 1] = 1 : this.words[tr + 1]++;
      return this.length = Math.max(this.length, tr + 1), this;
    }, Me.prototype.isubn = function(Ue) {
      if (we(typeof Ue == "number"), we(Ue < 67108864), Ue < 0)
        return this.iaddn(-Ue);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(Ue), this.negative = 1, this;
      if (this.words[0] -= Ue, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var tr = 0; tr < this.length && this.words[tr] < 0; tr++)
          this.words[tr] += 67108864, this.words[tr + 1] -= 1;
      return this._strip();
    }, Me.prototype.addn = function(Ue) {
      return this.clone().iaddn(Ue);
    }, Me.prototype.subn = function(Ue) {
      return this.clone().isubn(Ue);
    }, Me.prototype.iabs = function() {
      return this.negative = 0, this;
    }, Me.prototype.abs = function() {
      return this.clone().iabs();
    }, Me.prototype._ishlnsubmul = function(Ue, tr, lr) {
      var pr = Ue.length + lr, br;
      this._expand(pr);
      var nr, Pe = 0;
      for (br = 0; br < Ue.length; br++) {
        nr = (this.words[br + lr] | 0) + Pe;
        var ur = (Ue.words[br] | 0) * tr;
        nr -= ur & 67108863, Pe = (nr >> 26) - (ur / 67108864 | 0), this.words[br + lr] = nr & 67108863;
      }
      for (; br < this.length - lr; br++)
        nr = (this.words[br + lr] | 0) + Pe, Pe = nr >> 26, this.words[br + lr] = nr & 67108863;
      if (Pe === 0)
        return this._strip();
      for (we(Pe === -1), Pe = 0, br = 0; br < this.length; br++)
        nr = -(this.words[br] | 0) + Pe, Pe = nr >> 26, this.words[br] = nr & 67108863;
      return this.negative = 1, this._strip();
    }, Me.prototype._wordDiv = function(Ue, tr) {
      var lr = this.length - Ue.length, pr = this.clone(), br = Ue, nr = br.words[br.length - 1] | 0, Pe = this._countBits(nr);
      lr = 26 - Pe, lr !== 0 && (br = br.ushln(lr), pr.iushln(lr), nr = br.words[br.length - 1] | 0);
      var ur = pr.length - br.length, Pr;
      if (tr !== "mod") {
        Pr = new Me(null), Pr.length = ur + 1, Pr.words = new Array(Pr.length);
        for (var Hr = 0; Hr < Pr.length; Hr++)
          Pr.words[Hr] = 0;
      }
      var vi = pr.clone()._ishlnsubmul(br, 1, ur);
      vi.negative === 0 && (pr = vi, Pr && (Pr.words[ur] = 1));
      for (var Ti = ur - 1; Ti >= 0; Ti--) {
        var wi = (pr.words[br.length + Ti] | 0) * 67108864 + (pr.words[br.length + Ti - 1] | 0);
        for (wi = Math.min(wi / nr | 0, 67108863), pr._ishlnsubmul(br, wi, Ti); pr.negative !== 0; )
          wi--, pr.negative = 0, pr._ishlnsubmul(br, 1, Ti), pr.isZero() || (pr.negative ^= 1);
        Pr && (Pr.words[Ti] = wi);
      }
      return Pr && Pr._strip(), pr._strip(), tr !== "div" && lr !== 0 && pr.iushrn(lr), {
        div: Pr || null,
        mod: pr
      };
    }, Me.prototype.divmod = function(Ue, tr, lr) {
      if (we(!Ue.isZero()), this.isZero())
        return {
          div: new Me(0),
          mod: new Me(0)
        };
      var pr, br, nr;
      return this.negative !== 0 && Ue.negative === 0 ? (nr = this.neg().divmod(Ue, tr), tr !== "mod" && (pr = nr.div.neg()), tr !== "div" && (br = nr.mod.neg(), lr && br.negative !== 0 && br.iadd(Ue)), {
        div: pr,
        mod: br
      }) : this.negative === 0 && Ue.negative !== 0 ? (nr = this.divmod(Ue.neg(), tr), tr !== "mod" && (pr = nr.div.neg()), {
        div: pr,
        mod: nr.mod
      }) : (this.negative & Ue.negative) !== 0 ? (nr = this.neg().divmod(Ue.neg(), tr), tr !== "div" && (br = nr.mod.neg(), lr && br.negative !== 0 && br.isub(Ue)), {
        div: nr.div,
        mod: br
      }) : Ue.length > this.length || this.cmp(Ue) < 0 ? {
        div: new Me(0),
        mod: this
      } : Ue.length === 1 ? tr === "div" ? {
        div: this.divn(Ue.words[0]),
        mod: null
      } : tr === "mod" ? {
        div: null,
        mod: new Me(this.modrn(Ue.words[0]))
      } : {
        div: this.divn(Ue.words[0]),
        mod: new Me(this.modrn(Ue.words[0]))
      } : this._wordDiv(Ue, tr);
    }, Me.prototype.div = function(Ue) {
      return this.divmod(Ue, "div", !1).div;
    }, Me.prototype.mod = function(Ue) {
      return this.divmod(Ue, "mod", !1).mod;
    }, Me.prototype.umod = function(Ue) {
      return this.divmod(Ue, "mod", !0).mod;
    }, Me.prototype.divRound = function(Ue) {
      var tr = this.divmod(Ue);
      if (tr.mod.isZero())
        return tr.div;
      var lr = tr.div.negative !== 0 ? tr.mod.isub(Ue) : tr.mod, pr = Ue.ushrn(1), br = Ue.andln(1), nr = lr.cmp(pr);
      return nr < 0 || br === 1 && nr === 0 ? tr.div : tr.div.negative !== 0 ? tr.div.isubn(1) : tr.div.iaddn(1);
    }, Me.prototype.modrn = function(Ue) {
      var tr = Ue < 0;
      tr && (Ue = -Ue), we(Ue <= 67108863);
      for (var lr = (1 << 26) % Ue, pr = 0, br = this.length - 1; br >= 0; br--)
        pr = (lr * pr + (this.words[br] | 0)) % Ue;
      return tr ? -pr : pr;
    }, Me.prototype.modn = function(Ue) {
      return this.modrn(Ue);
    }, Me.prototype.idivn = function(Ue) {
      var tr = Ue < 0;
      tr && (Ue = -Ue), we(Ue <= 67108863);
      for (var lr = 0, pr = this.length - 1; pr >= 0; pr--) {
        var br = (this.words[pr] | 0) + lr * 67108864;
        this.words[pr] = br / Ue | 0, lr = br % Ue;
      }
      return this._strip(), tr ? this.ineg() : this;
    }, Me.prototype.divn = function(Ue) {
      return this.clone().idivn(Ue);
    }, Me.prototype.egcd = function(Ue) {
      we(Ue.negative === 0), we(!Ue.isZero());
      var tr = this, lr = Ue.clone();
      tr.negative !== 0 ? tr = tr.umod(Ue) : tr = tr.clone();
      for (var pr = new Me(1), br = new Me(0), nr = new Me(0), Pe = new Me(1), ur = 0; tr.isEven() && lr.isEven(); )
        tr.iushrn(1), lr.iushrn(1), ++ur;
      for (var Pr = lr.clone(), Hr = tr.clone(); !tr.isZero(); ) {
        for (var vi = 0, Ti = 1; (tr.words[0] & Ti) === 0 && vi < 26; ++vi, Ti <<= 1)
          ;
        if (vi > 0)
          for (tr.iushrn(vi); vi-- > 0; )
            (pr.isOdd() || br.isOdd()) && (pr.iadd(Pr), br.isub(Hr)), pr.iushrn(1), br.iushrn(1);
        for (var wi = 0, ii = 1; (lr.words[0] & ii) === 0 && wi < 26; ++wi, ii <<= 1)
          ;
        if (wi > 0)
          for (lr.iushrn(wi); wi-- > 0; )
            (nr.isOdd() || Pe.isOdd()) && (nr.iadd(Pr), Pe.isub(Hr)), nr.iushrn(1), Pe.iushrn(1);
        tr.cmp(lr) >= 0 ? (tr.isub(lr), pr.isub(nr), br.isub(Pe)) : (lr.isub(tr), nr.isub(pr), Pe.isub(br));
      }
      return {
        a: nr,
        b: Pe,
        gcd: lr.iushln(ur)
      };
    }, Me.prototype._invmp = function(Ue) {
      we(Ue.negative === 0), we(!Ue.isZero());
      var tr = this, lr = Ue.clone();
      tr.negative !== 0 ? tr = tr.umod(Ue) : tr = tr.clone();
      for (var pr = new Me(1), br = new Me(0), nr = lr.clone(); tr.cmpn(1) > 0 && lr.cmpn(1) > 0; ) {
        for (var Pe = 0, ur = 1; (tr.words[0] & ur) === 0 && Pe < 26; ++Pe, ur <<= 1)
          ;
        if (Pe > 0)
          for (tr.iushrn(Pe); Pe-- > 0; )
            pr.isOdd() && pr.iadd(nr), pr.iushrn(1);
        for (var Pr = 0, Hr = 1; (lr.words[0] & Hr) === 0 && Pr < 26; ++Pr, Hr <<= 1)
          ;
        if (Pr > 0)
          for (lr.iushrn(Pr); Pr-- > 0; )
            br.isOdd() && br.iadd(nr), br.iushrn(1);
        tr.cmp(lr) >= 0 ? (tr.isub(lr), pr.isub(br)) : (lr.isub(tr), br.isub(pr));
      }
      var vi;
      return tr.cmpn(1) === 0 ? vi = pr : vi = br, vi.cmpn(0) < 0 && vi.iadd(Ue), vi;
    }, Me.prototype.gcd = function(Ue) {
      if (this.isZero())
        return Ue.abs();
      if (Ue.isZero())
        return this.abs();
      var tr = this.clone(), lr = Ue.clone();
      tr.negative = 0, lr.negative = 0;
      for (var pr = 0; tr.isEven() && lr.isEven(); pr++)
        tr.iushrn(1), lr.iushrn(1);
      do {
        for (; tr.isEven(); )
          tr.iushrn(1);
        for (; lr.isEven(); )
          lr.iushrn(1);
        var br = tr.cmp(lr);
        if (br < 0) {
          var nr = tr;
          tr = lr, lr = nr;
        } else if (br === 0 || lr.cmpn(1) === 0)
          break;
        tr.isub(lr);
      } while (!0);
      return lr.iushln(pr);
    }, Me.prototype.invm = function(Ue) {
      return this.egcd(Ue).a.umod(Ue);
    }, Me.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, Me.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, Me.prototype.andln = function(Ue) {
      return this.words[0] & Ue;
    }, Me.prototype.bincn = function(Ue) {
      we(typeof Ue == "number");
      var tr = Ue % 26, lr = (Ue - tr) / 26, pr = 1 << tr;
      if (this.length <= lr)
        return this._expand(lr + 1), this.words[lr] |= pr, this;
      for (var br = pr, nr = lr; br !== 0 && nr < this.length; nr++) {
        var Pe = this.words[nr] | 0;
        Pe += br, br = Pe >>> 26, Pe &= 67108863, this.words[nr] = Pe;
      }
      return br !== 0 && (this.words[nr] = br, this.length++), this;
    }, Me.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, Me.prototype.cmpn = function(Ue) {
      var tr = Ue < 0;
      if (this.negative !== 0 && !tr)
        return -1;
      if (this.negative === 0 && tr)
        return 1;
      this._strip();
      var lr;
      if (this.length > 1)
        lr = 1;
      else {
        tr && (Ue = -Ue), we(Ue <= 67108863, "Number is too big");
        var pr = this.words[0] | 0;
        lr = pr === Ue ? 0 : pr < Ue ? -1 : 1;
      }
      return this.negative !== 0 ? -lr | 0 : lr;
    }, Me.prototype.cmp = function(Ue) {
      if (this.negative !== 0 && Ue.negative === 0)
        return -1;
      if (this.negative === 0 && Ue.negative !== 0)
        return 1;
      var tr = this.ucmp(Ue);
      return this.negative !== 0 ? -tr | 0 : tr;
    }, Me.prototype.ucmp = function(Ue) {
      if (this.length > Ue.length)
        return 1;
      if (this.length < Ue.length)
        return -1;
      for (var tr = 0, lr = this.length - 1; lr >= 0; lr--) {
        var pr = this.words[lr] | 0, br = Ue.words[lr] | 0;
        if (pr !== br) {
          pr < br ? tr = -1 : pr > br && (tr = 1);
          break;
        }
      }
      return tr;
    }, Me.prototype.gtn = function(Ue) {
      return this.cmpn(Ue) === 1;
    }, Me.prototype.gt = function(Ue) {
      return this.cmp(Ue) === 1;
    }, Me.prototype.gten = function(Ue) {
      return this.cmpn(Ue) >= 0;
    }, Me.prototype.gte = function(Ue) {
      return this.cmp(Ue) >= 0;
    }, Me.prototype.ltn = function(Ue) {
      return this.cmpn(Ue) === -1;
    }, Me.prototype.lt = function(Ue) {
      return this.cmp(Ue) === -1;
    }, Me.prototype.lten = function(Ue) {
      return this.cmpn(Ue) <= 0;
    }, Me.prototype.lte = function(Ue) {
      return this.cmp(Ue) <= 0;
    }, Me.prototype.eqn = function(Ue) {
      return this.cmpn(Ue) === 0;
    }, Me.prototype.eq = function(Ue) {
      return this.cmp(Ue) === 0;
    }, Me.red = function(Ue) {
      return new vr(Ue);
    }, Me.prototype.toRed = function(Ue) {
      return we(!this.red, "Already a number in reduction context"), we(this.negative === 0, "red works only with positives"), Ue.convertTo(this)._forceRed(Ue);
    }, Me.prototype.fromRed = function() {
      return we(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, Me.prototype._forceRed = function(Ue) {
      return this.red = Ue, this;
    }, Me.prototype.forceRed = function(Ue) {
      return we(!this.red, "Already a number in reduction context"), this._forceRed(Ue);
    }, Me.prototype.redAdd = function(Ue) {
      return we(this.red, "redAdd works only with red numbers"), this.red.add(this, Ue);
    }, Me.prototype.redIAdd = function(Ue) {
      return we(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ue);
    }, Me.prototype.redSub = function(Ue) {
      return we(this.red, "redSub works only with red numbers"), this.red.sub(this, Ue);
    }, Me.prototype.redISub = function(Ue) {
      return we(this.red, "redISub works only with red numbers"), this.red.isub(this, Ue);
    }, Me.prototype.redShl = function(Ue) {
      return we(this.red, "redShl works only with red numbers"), this.red.shl(this, Ue);
    }, Me.prototype.redMul = function(Ue) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ue), this.red.mul(this, Ue);
    }, Me.prototype.redIMul = function(Ue) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ue), this.red.imul(this, Ue);
    }, Me.prototype.redSqr = function() {
      return we(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, Me.prototype.redISqr = function() {
      return we(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, Me.prototype.redSqrt = function() {
      return we(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, Me.prototype.redInvm = function() {
      return we(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, Me.prototype.redNeg = function() {
      return we(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, Me.prototype.redPow = function(Ue) {
      return we(this.red && !Ue.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ue);
    };
    var si = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function li(ze, Ue) {
      this.name = ze, this.p = new Me(Ue, 16), this.n = this.p.bitLength(), this.k = new Me(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    li.prototype._tmp = function() {
      var Ue = new Me(null);
      return Ue.words = new Array(Math.ceil(this.n / 13)), Ue;
    }, li.prototype.ireduce = function(Ue) {
      var tr = Ue, lr;
      do
        this.split(tr, this.tmp), tr = this.imulK(tr), tr = tr.iadd(this.tmp), lr = tr.bitLength();
      while (lr > this.n);
      var pr = lr < this.n ? -1 : tr.ucmp(this.p);
      return pr === 0 ? (tr.words[0] = 0, tr.length = 1) : pr > 0 ? tr.isub(this.p) : tr.strip !== void 0 ? tr.strip() : tr._strip(), tr;
    }, li.prototype.split = function(Ue, tr) {
      Ue.iushrn(this.n, 0, tr);
    }, li.prototype.imulK = function(Ue) {
      return Ue.imul(this.k);
    };
    function xi() {
      li.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    $e(xi, li), xi.prototype.split = function(Ue, tr) {
      for (var lr = 4194303, pr = Math.min(Ue.length, 9), br = 0; br < pr; br++)
        tr.words[br] = Ue.words[br];
      if (tr.length = pr, Ue.length <= 9) {
        Ue.words[0] = 0, Ue.length = 1;
        return;
      }
      var nr = Ue.words[9];
      for (tr.words[tr.length++] = nr & lr, br = 10; br < Ue.length; br++) {
        var Pe = Ue.words[br] | 0;
        Ue.words[br - 10] = (Pe & lr) << 4 | nr >>> 22, nr = Pe;
      }
      nr >>>= 22, Ue.words[br - 10] = nr, nr === 0 && Ue.length > 10 ? Ue.length -= 10 : Ue.length -= 9;
    }, xi.prototype.imulK = function(Ue) {
      Ue.words[Ue.length] = 0, Ue.words[Ue.length + 1] = 0, Ue.length += 2;
      for (var tr = 0, lr = 0; lr < Ue.length; lr++) {
        var pr = Ue.words[lr] | 0;
        tr += pr * 977, Ue.words[lr] = tr & 67108863, tr = pr * 64 + (tr / 67108864 | 0);
      }
      return Ue.words[Ue.length - 1] === 0 && (Ue.length--, Ue.words[Ue.length - 1] === 0 && Ue.length--), Ue;
    };
    function di() {
      li.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    $e(di, li);
    function oi() {
      li.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    $e(oi, li);
    function ci() {
      li.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    $e(ci, li), ci.prototype.imulK = function(Ue) {
      for (var tr = 0, lr = 0; lr < Ue.length; lr++) {
        var pr = (Ue.words[lr] | 0) * 19 + tr, br = pr & 67108863;
        pr >>>= 26, Ue.words[lr] = br, tr = pr;
      }
      return tr !== 0 && (Ue.words[Ue.length++] = tr), Ue;
    }, Me._prime = function(Ue) {
      if (si[Ue])
        return si[Ue];
      var tr;
      if (Ue === "k256")
        tr = new xi();
      else if (Ue === "p224")
        tr = new di();
      else if (Ue === "p192")
        tr = new oi();
      else if (Ue === "p25519")
        tr = new ci();
      else
        throw new Error("Unknown prime " + Ue);
      return si[Ue] = tr, tr;
    };
    function vr(ze) {
      if (typeof ze == "string") {
        var Ue = Me._prime(ze);
        this.m = Ue.p, this.prime = Ue;
      } else
        we(ze.gtn(1), "modulus must be greater than 1"), this.m = ze, this.prime = null;
    }
    vr.prototype._verify1 = function(Ue) {
      we(Ue.negative === 0, "red works only with positives"), we(Ue.red, "red works only with red numbers");
    }, vr.prototype._verify2 = function(Ue, tr) {
      we((Ue.negative | tr.negative) === 0, "red works only with positives"), we(
        Ue.red && Ue.red === tr.red,
        "red works only with red numbers"
      );
    }, vr.prototype.imod = function(Ue) {
      return this.prime ? this.prime.ireduce(Ue)._forceRed(this) : (or(Ue, Ue.umod(this.m)._forceRed(this)), Ue);
    }, vr.prototype.neg = function(Ue) {
      return Ue.isZero() ? Ue.clone() : this.m.sub(Ue)._forceRed(this);
    }, vr.prototype.add = function(Ue, tr) {
      this._verify2(Ue, tr);
      var lr = Ue.add(tr);
      return lr.cmp(this.m) >= 0 && lr.isub(this.m), lr._forceRed(this);
    }, vr.prototype.iadd = function(Ue, tr) {
      this._verify2(Ue, tr);
      var lr = Ue.iadd(tr);
      return lr.cmp(this.m) >= 0 && lr.isub(this.m), lr;
    }, vr.prototype.sub = function(Ue, tr) {
      this._verify2(Ue, tr);
      var lr = Ue.sub(tr);
      return lr.cmpn(0) < 0 && lr.iadd(this.m), lr._forceRed(this);
    }, vr.prototype.isub = function(Ue, tr) {
      this._verify2(Ue, tr);
      var lr = Ue.isub(tr);
      return lr.cmpn(0) < 0 && lr.iadd(this.m), lr;
    }, vr.prototype.shl = function(Ue, tr) {
      return this._verify1(Ue), this.imod(Ue.ushln(tr));
    }, vr.prototype.imul = function(Ue, tr) {
      return this._verify2(Ue, tr), this.imod(Ue.imul(tr));
    }, vr.prototype.mul = function(Ue, tr) {
      return this._verify2(Ue, tr), this.imod(Ue.mul(tr));
    }, vr.prototype.isqr = function(Ue) {
      return this.imul(Ue, Ue.clone());
    }, vr.prototype.sqr = function(Ue) {
      return this.mul(Ue, Ue);
    }, vr.prototype.sqrt = function(Ue) {
      if (Ue.isZero())
        return Ue.clone();
      var tr = this.m.andln(3);
      if (we(tr % 2 === 1), tr === 3) {
        var lr = this.m.add(new Me(1)).iushrn(2);
        return this.pow(Ue, lr);
      }
      for (var pr = this.m.subn(1), br = 0; !pr.isZero() && pr.andln(1) === 0; )
        br++, pr.iushrn(1);
      we(!pr.isZero());
      var nr = new Me(1).toRed(this), Pe = nr.redNeg(), ur = this.m.subn(1).iushrn(1), Pr = this.m.bitLength();
      for (Pr = new Me(2 * Pr * Pr).toRed(this); this.pow(Pr, ur).cmp(Pe) !== 0; )
        Pr.redIAdd(Pe);
      for (var Hr = this.pow(Pr, pr), vi = this.pow(Ue, pr.addn(1).iushrn(1)), Ti = this.pow(Ue, pr), wi = br; Ti.cmp(nr) !== 0; ) {
        for (var ii = Ti, mi = 0; ii.cmp(nr) !== 0; mi++)
          ii = ii.redSqr();
        we(mi < wi);
        var ei = this.pow(Hr, new Me(1).iushln(wi - mi - 1));
        vi = vi.redMul(ei), Hr = ei.redSqr(), Ti = Ti.redMul(Hr), wi = mi;
      }
      return vi;
    }, vr.prototype.invm = function(Ue) {
      var tr = Ue._invmp(this.m);
      return tr.negative !== 0 ? (tr.negative = 0, this.imod(tr).redNeg()) : this.imod(tr);
    }, vr.prototype.pow = function(Ue, tr) {
      if (tr.isZero())
        return new Me(1).toRed(this);
      if (tr.cmpn(1) === 0)
        return Ue.clone();
      var lr = 4, pr = new Array(1 << lr);
      pr[0] = new Me(1).toRed(this), pr[1] = Ue;
      for (var br = 2; br < pr.length; br++)
        pr[br] = this.mul(pr[br - 1], Ue);
      var nr = pr[0], Pe = 0, ur = 0, Pr = tr.bitLength() % 26;
      for (Pr === 0 && (Pr = 26), br = tr.length - 1; br >= 0; br--) {
        for (var Hr = tr.words[br], vi = Pr - 1; vi >= 0; vi--) {
          var Ti = Hr >> vi & 1;
          if (nr !== pr[0] && (nr = this.sqr(nr)), Ti === 0 && Pe === 0) {
            ur = 0;
            continue;
          }
          Pe <<= 1, Pe |= Ti, ur++, !(ur !== lr && (br !== 0 || vi !== 0)) && (nr = this.mul(nr, pr[Pe]), ur = 0, Pe = 0);
        }
        Pr = 26;
      }
      return nr;
    }, vr.prototype.convertTo = function(Ue) {
      var tr = Ue.umod(this.m);
      return tr === Ue ? tr.clone() : tr;
    }, vr.prototype.convertFrom = function(Ue) {
      var tr = Ue.clone();
      return tr.red = null, tr;
    }, Me.mont = function(Ue) {
      return new Ae(Ue);
    };
    function Ae(ze) {
      vr.call(this, ze), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new Me(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    $e(Ae, vr), Ae.prototype.convertTo = function(Ue) {
      return this.imod(Ue.ushln(this.shift));
    }, Ae.prototype.convertFrom = function(Ue) {
      var tr = this.imod(Ue.mul(this.rinv));
      return tr.red = null, tr;
    }, Ae.prototype.imul = function(Ue, tr) {
      if (Ue.isZero() || tr.isZero())
        return Ue.words[0] = 0, Ue.length = 1, Ue;
      var lr = Ue.imul(tr), pr = lr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), br = lr.isub(pr).iushrn(this.shift), nr = br;
      return br.cmp(this.m) >= 0 ? nr = br.isub(this.m) : br.cmpn(0) < 0 && (nr = br.iadd(this.m)), nr._forceRed(this);
    }, Ae.prototype.mul = function(Ue, tr) {
      if (Ue.isZero() || tr.isZero())
        return new Me(0)._forceRed(this);
      var lr = Ue.mul(tr), pr = lr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), br = lr.isub(pr).iushrn(this.shift), nr = br;
      return br.cmp(this.m) >= 0 ? nr = br.isub(this.m) : br.cmpn(0) < 0 && (nr = br.iadd(this.m)), nr._forceRed(this);
    }, Ae.prototype.invm = function(Ue) {
      var tr = this.imod(Ue._invmp(this.m).mul(this.r2));
      return tr._forceRed(this);
    };
  })(m, commonjsGlobal);
})(bn$4);
var BN$a = bn$4.exports, randomBytes$1 = browser$c.exports, Buffer$7 = safeBuffer$2.exports.Buffer;
function getr(m) {
  var c = m.modulus.byteLength(), ie;
  do
    ie = new BN$a(randomBytes$1(c));
  while (ie.cmp(m.modulus) >= 0 || !ie.umod(m.prime1) || !ie.umod(m.prime2));
  return ie;
}
function blind(m) {
  var c = getr(m), ie = c.toRed(BN$a.mont(m.modulus)).redPow(new BN$a(m.publicExponent)).fromRed();
  return { blinder: ie, unblinder: c.invm(m.modulus) };
}
function crt$2(m, c) {
  var ie = blind(c), we = c.modulus.byteLength(), $e = new BN$a(m).mul(ie.blinder).umod(c.modulus), Me = $e.toRed(BN$a.mont(c.prime1)), Ze = $e.toRed(BN$a.mont(c.prime2)), ne = c.coefficient, rr = c.prime1, gr = c.prime2, or = Me.redPow(c.exponent1).fromRed(), _r = Ze.redPow(c.exponent2).fromRed(), Lr = or.isub(_r).imul(ne).umod(rr).imul(gr);
  return _r.iadd(Lr).imul(ie.unblinder).umod(c.modulus).toArrayLike(Buffer$7, "be", we);
}
crt$2.getr = getr;
var browserifyRsa = crt$2, elliptic = {};
const name = "elliptic", version$1 = "6.6.1", description = "EC cryptography", main = "lib/elliptic.js", files = [
  "lib"
], scripts = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, repository = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, keywords = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], author = "Fedor Indutny <fedor@indutny.com>", license = "MIT", bugs = {
  url: "https://github.com/indutny/elliptic/issues"
}, homepage = "https://github.com/indutny/elliptic", devDependencies = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, dependencies = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, require$$0$3 = {
  name,
  version: version$1,
  description,
  main,
  files,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  dependencies
};
var utils$o = {}, bn$3 = { exports: {} };
(function(m) {
  (function(c, ie) {
    function we(vr, Ae) {
      if (!vr)
        throw new Error(Ae || "Assertion failed");
    }
    function $e(vr, Ae) {
      vr.super_ = Ae;
      var ze = function() {
      };
      ze.prototype = Ae.prototype, vr.prototype = new ze(), vr.prototype.constructor = vr;
    }
    function Me(vr, Ae, ze) {
      if (Me.isBN(vr))
        return vr;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, vr !== null && ((Ae === "le" || Ae === "be") && (ze = Ae, Ae = 10), this._init(vr || 0, Ae || 10, ze || "be"));
    }
    typeof c == "object" ? c.exports = Me : ie.BN = Me, Me.BN = Me, Me.wordSize = 26;
    var Ze;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? Ze = window.Buffer : Ze = require$$0$4.Buffer;
    } catch {
    }
    Me.isBN = function(Ae) {
      return Ae instanceof Me ? !0 : Ae !== null && typeof Ae == "object" && Ae.constructor.wordSize === Me.wordSize && Array.isArray(Ae.words);
    }, Me.max = function(Ae, ze) {
      return Ae.cmp(ze) > 0 ? Ae : ze;
    }, Me.min = function(Ae, ze) {
      return Ae.cmp(ze) < 0 ? Ae : ze;
    }, Me.prototype._init = function(Ae, ze, Ue) {
      if (typeof Ae == "number")
        return this._initNumber(Ae, ze, Ue);
      if (typeof Ae == "object")
        return this._initArray(Ae, ze, Ue);
      ze === "hex" && (ze = 16), we(ze === (ze | 0) && ze >= 2 && ze <= 36), Ae = Ae.toString().replace(/\s+/g, "");
      var tr = 0;
      Ae[0] === "-" && (tr++, this.negative = 1), tr < Ae.length && (ze === 16 ? this._parseHex(Ae, tr, Ue) : (this._parseBase(Ae, ze, tr), Ue === "le" && this._initArray(this.toArray(), ze, Ue)));
    }, Me.prototype._initNumber = function(Ae, ze, Ue) {
      Ae < 0 && (this.negative = 1, Ae = -Ae), Ae < 67108864 ? (this.words = [Ae & 67108863], this.length = 1) : Ae < 4503599627370496 ? (this.words = [
        Ae & 67108863,
        Ae / 67108864 & 67108863
      ], this.length = 2) : (we(Ae < 9007199254740992), this.words = [
        Ae & 67108863,
        Ae / 67108864 & 67108863,
        1
      ], this.length = 3), Ue === "le" && this._initArray(this.toArray(), ze, Ue);
    }, Me.prototype._initArray = function(Ae, ze, Ue) {
      if (we(typeof Ae.length == "number"), Ae.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(Ae.length / 3), this.words = new Array(this.length);
      for (var tr = 0; tr < this.length; tr++)
        this.words[tr] = 0;
      var lr, pr, br = 0;
      if (Ue === "be")
        for (tr = Ae.length - 1, lr = 0; tr >= 0; tr -= 3)
          pr = Ae[tr] | Ae[tr - 1] << 8 | Ae[tr - 2] << 16, this.words[lr] |= pr << br & 67108863, this.words[lr + 1] = pr >>> 26 - br & 67108863, br += 24, br >= 26 && (br -= 26, lr++);
      else if (Ue === "le")
        for (tr = 0, lr = 0; tr < Ae.length; tr += 3)
          pr = Ae[tr] | Ae[tr + 1] << 8 | Ae[tr + 2] << 16, this.words[lr] |= pr << br & 67108863, this.words[lr + 1] = pr >>> 26 - br & 67108863, br += 24, br >= 26 && (br -= 26, lr++);
      return this.strip();
    };
    function ne(vr, Ae) {
      var ze = vr.charCodeAt(Ae);
      return ze >= 65 && ze <= 70 ? ze - 55 : ze >= 97 && ze <= 102 ? ze - 87 : ze - 48 & 15;
    }
    function rr(vr, Ae, ze) {
      var Ue = ne(vr, ze);
      return ze - 1 >= Ae && (Ue |= ne(vr, ze - 1) << 4), Ue;
    }
    Me.prototype._parseHex = function(Ae, ze, Ue) {
      this.length = Math.ceil((Ae.length - ze) / 6), this.words = new Array(this.length);
      for (var tr = 0; tr < this.length; tr++)
        this.words[tr] = 0;
      var lr = 0, pr = 0, br;
      if (Ue === "be")
        for (tr = Ae.length - 1; tr >= ze; tr -= 2)
          br = rr(Ae, ze, tr) << lr, this.words[pr] |= br & 67108863, lr >= 18 ? (lr -= 18, pr += 1, this.words[pr] |= br >>> 26) : lr += 8;
      else {
        var nr = Ae.length - ze;
        for (tr = nr % 2 === 0 ? ze + 1 : ze; tr < Ae.length; tr += 2)
          br = rr(Ae, ze, tr) << lr, this.words[pr] |= br & 67108863, lr >= 18 ? (lr -= 18, pr += 1, this.words[pr] |= br >>> 26) : lr += 8;
      }
      this.strip();
    };
    function gr(vr, Ae, ze, Ue) {
      for (var tr = 0, lr = Math.min(vr.length, ze), pr = Ae; pr < lr; pr++) {
        var br = vr.charCodeAt(pr) - 48;
        tr *= Ue, br >= 49 ? tr += br - 49 + 10 : br >= 17 ? tr += br - 17 + 10 : tr += br;
      }
      return tr;
    }
    Me.prototype._parseBase = function(Ae, ze, Ue) {
      this.words = [0], this.length = 1;
      for (var tr = 0, lr = 1; lr <= 67108863; lr *= ze)
        tr++;
      tr--, lr = lr / ze | 0;
      for (var pr = Ae.length - Ue, br = pr % tr, nr = Math.min(pr, pr - br) + Ue, Pe = 0, ur = Ue; ur < nr; ur += tr)
        Pe = gr(Ae, ur, ur + tr, ze), this.imuln(lr), this.words[0] + Pe < 67108864 ? this.words[0] += Pe : this._iaddn(Pe);
      if (br !== 0) {
        var Pr = 1;
        for (Pe = gr(Ae, ur, Ae.length, ze), ur = 0; ur < br; ur++)
          Pr *= ze;
        this.imuln(Pr), this.words[0] + Pe < 67108864 ? this.words[0] += Pe : this._iaddn(Pe);
      }
      this.strip();
    }, Me.prototype.copy = function(Ae) {
      Ae.words = new Array(this.length);
      for (var ze = 0; ze < this.length; ze++)
        Ae.words[ze] = this.words[ze];
      Ae.length = this.length, Ae.negative = this.negative, Ae.red = this.red;
    }, Me.prototype.clone = function() {
      var Ae = new Me(null);
      return this.copy(Ae), Ae;
    }, Me.prototype._expand = function(Ae) {
      for (; this.length < Ae; )
        this.words[this.length++] = 0;
      return this;
    }, Me.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, Me.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, Me.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var or = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], _r = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Lr = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    Me.prototype.toString = function(Ae, ze) {
      Ae = Ae || 10, ze = ze | 0 || 1;
      var Ue;
      if (Ae === 16 || Ae === "hex") {
        Ue = "";
        for (var tr = 0, lr = 0, pr = 0; pr < this.length; pr++) {
          var br = this.words[pr], nr = ((br << tr | lr) & 16777215).toString(16);
          lr = br >>> 24 - tr & 16777215, tr += 2, tr >= 26 && (tr -= 26, pr--), lr !== 0 || pr !== this.length - 1 ? Ue = or[6 - nr.length] + nr + Ue : Ue = nr + Ue;
        }
        for (lr !== 0 && (Ue = lr.toString(16) + Ue); Ue.length % ze !== 0; )
          Ue = "0" + Ue;
        return this.negative !== 0 && (Ue = "-" + Ue), Ue;
      }
      if (Ae === (Ae | 0) && Ae >= 2 && Ae <= 36) {
        var Pe = _r[Ae], ur = Lr[Ae];
        Ue = "";
        var Pr = this.clone();
        for (Pr.negative = 0; !Pr.isZero(); ) {
          var Hr = Pr.modn(ur).toString(Ae);
          Pr = Pr.idivn(ur), Pr.isZero() ? Ue = Hr + Ue : Ue = or[Pe - Hr.length] + Hr + Ue;
        }
        for (this.isZero() && (Ue = "0" + Ue); Ue.length % ze !== 0; )
          Ue = "0" + Ue;
        return this.negative !== 0 && (Ue = "-" + Ue), Ue;
      }
      we(!1, "Base should be between 2 and 36");
    }, Me.prototype.toNumber = function() {
      var Ae = this.words[0];
      return this.length === 2 ? Ae += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ae += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && we(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ae : Ae;
    }, Me.prototype.toJSON = function() {
      return this.toString(16);
    }, Me.prototype.toBuffer = function(Ae, ze) {
      return we(typeof Ze < "u"), this.toArrayLike(Ze, Ae, ze);
    }, Me.prototype.toArray = function(Ae, ze) {
      return this.toArrayLike(Array, Ae, ze);
    }, Me.prototype.toArrayLike = function(Ae, ze, Ue) {
      var tr = this.byteLength(), lr = Ue || Math.max(1, tr);
      we(tr <= lr, "byte array longer than desired length"), we(lr > 0, "Requested array length <= 0"), this.strip();
      var pr = ze === "le", br = new Ae(lr), nr, Pe, ur = this.clone();
      if (pr) {
        for (Pe = 0; !ur.isZero(); Pe++)
          nr = ur.andln(255), ur.iushrn(8), br[Pe] = nr;
        for (; Pe < lr; Pe++)
          br[Pe] = 0;
      } else {
        for (Pe = 0; Pe < lr - tr; Pe++)
          br[Pe] = 0;
        for (Pe = 0; !ur.isZero(); Pe++)
          nr = ur.andln(255), ur.iushrn(8), br[lr - Pe - 1] = nr;
      }
      return br;
    }, Math.clz32 ? Me.prototype._countBits = function(Ae) {
      return 32 - Math.clz32(Ae);
    } : Me.prototype._countBits = function(Ae) {
      var ze = Ae, Ue = 0;
      return ze >= 4096 && (Ue += 13, ze >>>= 13), ze >= 64 && (Ue += 7, ze >>>= 7), ze >= 8 && (Ue += 4, ze >>>= 4), ze >= 2 && (Ue += 2, ze >>>= 2), Ue + ze;
    }, Me.prototype._zeroBits = function(Ae) {
      if (Ae === 0)
        return 26;
      var ze = Ae, Ue = 0;
      return (ze & 8191) === 0 && (Ue += 13, ze >>>= 13), (ze & 127) === 0 && (Ue += 7, ze >>>= 7), (ze & 15) === 0 && (Ue += 4, ze >>>= 4), (ze & 3) === 0 && (Ue += 2, ze >>>= 2), (ze & 1) === 0 && Ue++, Ue;
    }, Me.prototype.bitLength = function() {
      var Ae = this.words[this.length - 1], ze = this._countBits(Ae);
      return (this.length - 1) * 26 + ze;
    };
    function Ir(vr) {
      for (var Ae = new Array(vr.bitLength()), ze = 0; ze < Ae.length; ze++) {
        var Ue = ze / 26 | 0, tr = ze % 26;
        Ae[ze] = (vr.words[Ue] & 1 << tr) >>> tr;
      }
      return Ae;
    }
    Me.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var Ae = 0, ze = 0; ze < this.length; ze++) {
        var Ue = this._zeroBits(this.words[ze]);
        if (Ae += Ue, Ue !== 26)
          break;
      }
      return Ae;
    }, Me.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, Me.prototype.toTwos = function(Ae) {
      return this.negative !== 0 ? this.abs().inotn(Ae).iaddn(1) : this.clone();
    }, Me.prototype.fromTwos = function(Ae) {
      return this.testn(Ae - 1) ? this.notn(Ae).iaddn(1).ineg() : this.clone();
    }, Me.prototype.isNeg = function() {
      return this.negative !== 0;
    }, Me.prototype.neg = function() {
      return this.clone().ineg();
    }, Me.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, Me.prototype.iuor = function(Ae) {
      for (; this.length < Ae.length; )
        this.words[this.length++] = 0;
      for (var ze = 0; ze < Ae.length; ze++)
        this.words[ze] = this.words[ze] | Ae.words[ze];
      return this.strip();
    }, Me.prototype.ior = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuor(Ae);
    }, Me.prototype.or = function(Ae) {
      return this.length > Ae.length ? this.clone().ior(Ae) : Ae.clone().ior(this);
    }, Me.prototype.uor = function(Ae) {
      return this.length > Ae.length ? this.clone().iuor(Ae) : Ae.clone().iuor(this);
    }, Me.prototype.iuand = function(Ae) {
      var ze;
      this.length > Ae.length ? ze = Ae : ze = this;
      for (var Ue = 0; Ue < ze.length; Ue++)
        this.words[Ue] = this.words[Ue] & Ae.words[Ue];
      return this.length = ze.length, this.strip();
    }, Me.prototype.iand = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuand(Ae);
    }, Me.prototype.and = function(Ae) {
      return this.length > Ae.length ? this.clone().iand(Ae) : Ae.clone().iand(this);
    }, Me.prototype.uand = function(Ae) {
      return this.length > Ae.length ? this.clone().iuand(Ae) : Ae.clone().iuand(this);
    }, Me.prototype.iuxor = function(Ae) {
      var ze, Ue;
      this.length > Ae.length ? (ze = this, Ue = Ae) : (ze = Ae, Ue = this);
      for (var tr = 0; tr < Ue.length; tr++)
        this.words[tr] = ze.words[tr] ^ Ue.words[tr];
      if (this !== ze)
        for (; tr < ze.length; tr++)
          this.words[tr] = ze.words[tr];
      return this.length = ze.length, this.strip();
    }, Me.prototype.ixor = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuxor(Ae);
    }, Me.prototype.xor = function(Ae) {
      return this.length > Ae.length ? this.clone().ixor(Ae) : Ae.clone().ixor(this);
    }, Me.prototype.uxor = function(Ae) {
      return this.length > Ae.length ? this.clone().iuxor(Ae) : Ae.clone().iuxor(this);
    }, Me.prototype.inotn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Math.ceil(Ae / 26) | 0, Ue = Ae % 26;
      this._expand(ze), Ue > 0 && ze--;
      for (var tr = 0; tr < ze; tr++)
        this.words[tr] = ~this.words[tr] & 67108863;
      return Ue > 0 && (this.words[tr] = ~this.words[tr] & 67108863 >> 26 - Ue), this.strip();
    }, Me.prototype.notn = function(Ae) {
      return this.clone().inotn(Ae);
    }, Me.prototype.setn = function(Ae, ze) {
      we(typeof Ae == "number" && Ae >= 0);
      var Ue = Ae / 26 | 0, tr = Ae % 26;
      return this._expand(Ue + 1), ze ? this.words[Ue] = this.words[Ue] | 1 << tr : this.words[Ue] = this.words[Ue] & ~(1 << tr), this.strip();
    }, Me.prototype.iadd = function(Ae) {
      var ze;
      if (this.negative !== 0 && Ae.negative === 0)
        return this.negative = 0, ze = this.isub(Ae), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && Ae.negative !== 0)
        return Ae.negative = 0, ze = this.isub(Ae), Ae.negative = 1, ze._normSign();
      var Ue, tr;
      this.length > Ae.length ? (Ue = this, tr = Ae) : (Ue = Ae, tr = this);
      for (var lr = 0, pr = 0; pr < tr.length; pr++)
        ze = (Ue.words[pr] | 0) + (tr.words[pr] | 0) + lr, this.words[pr] = ze & 67108863, lr = ze >>> 26;
      for (; lr !== 0 && pr < Ue.length; pr++)
        ze = (Ue.words[pr] | 0) + lr, this.words[pr] = ze & 67108863, lr = ze >>> 26;
      if (this.length = Ue.length, lr !== 0)
        this.words[this.length] = lr, this.length++;
      else if (Ue !== this)
        for (; pr < Ue.length; pr++)
          this.words[pr] = Ue.words[pr];
      return this;
    }, Me.prototype.add = function(Ae) {
      var ze;
      return Ae.negative !== 0 && this.negative === 0 ? (Ae.negative = 0, ze = this.sub(Ae), Ae.negative ^= 1, ze) : Ae.negative === 0 && this.negative !== 0 ? (this.negative = 0, ze = Ae.sub(this), this.negative = 1, ze) : this.length > Ae.length ? this.clone().iadd(Ae) : Ae.clone().iadd(this);
    }, Me.prototype.isub = function(Ae) {
      if (Ae.negative !== 0) {
        Ae.negative = 0;
        var ze = this.iadd(Ae);
        return Ae.negative = 1, ze._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(Ae), this.negative = 1, this._normSign();
      var Ue = this.cmp(Ae);
      if (Ue === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var tr, lr;
      Ue > 0 ? (tr = this, lr = Ae) : (tr = Ae, lr = this);
      for (var pr = 0, br = 0; br < lr.length; br++)
        ze = (tr.words[br] | 0) - (lr.words[br] | 0) + pr, pr = ze >> 26, this.words[br] = ze & 67108863;
      for (; pr !== 0 && br < tr.length; br++)
        ze = (tr.words[br] | 0) + pr, pr = ze >> 26, this.words[br] = ze & 67108863;
      if (pr === 0 && br < tr.length && tr !== this)
        for (; br < tr.length; br++)
          this.words[br] = tr.words[br];
      return this.length = Math.max(this.length, br), tr !== this && (this.negative = 1), this.strip();
    }, Me.prototype.sub = function(Ae) {
      return this.clone().isub(Ae);
    };
    function Ar(vr, Ae, ze) {
      ze.negative = Ae.negative ^ vr.negative;
      var Ue = vr.length + Ae.length | 0;
      ze.length = Ue, Ue = Ue - 1 | 0;
      var tr = vr.words[0] | 0, lr = Ae.words[0] | 0, pr = tr * lr, br = pr & 67108863, nr = pr / 67108864 | 0;
      ze.words[0] = br;
      for (var Pe = 1; Pe < Ue; Pe++) {
        for (var ur = nr >>> 26, Pr = nr & 67108863, Hr = Math.min(Pe, Ae.length - 1), vi = Math.max(0, Pe - vr.length + 1); vi <= Hr; vi++) {
          var Ti = Pe - vi | 0;
          tr = vr.words[Ti] | 0, lr = Ae.words[vi] | 0, pr = tr * lr + Pr, ur += pr / 67108864 | 0, Pr = pr & 67108863;
        }
        ze.words[Pe] = Pr | 0, nr = ur | 0;
      }
      return nr !== 0 ? ze.words[Pe] = nr | 0 : ze.length--, ze.strip();
    }
    var Rr = function(Ae, ze, Ue) {
      var tr = Ae.words, lr = ze.words, pr = Ue.words, br = 0, nr, Pe, ur, Pr = tr[0] | 0, Hr = Pr & 8191, vi = Pr >>> 13, Ti = tr[1] | 0, wi = Ti & 8191, ii = Ti >>> 13, mi = tr[2] | 0, ei = mi & 8191, Zr = mi >>> 13, pi = tr[3] | 0, hi = pi & 8191, Oi = pi >>> 13, qi = tr[4] | 0, yn = qi & 8191, sn = qi >>> 13, $n = tr[5] | 0, rn = $n & 8191, ji = $n >>> 13, Kn = tr[6] | 0, In = Kn & 8191, Fn = Kn >>> 13, Po = tr[7] | 0, vn = Po & 8191, Vn = Po >>> 13, Xo = tr[8] | 0, Xn = Xo & 8191, Yn = Xo >>> 13, Wo = tr[9] | 0, Ci = Wo & 8191, ri = Wo >>> 13, yi = lr[0] | 0, Li = yi & 8191, Yi = yi >>> 13, zn = lr[1] | 0, un = zn & 8191, Gn = zn >>> 13, Mn = lr[2] | 0, pn = Mn & 8191, Rn = Mn >>> 13, Io = lr[3] | 0, to = Io & 8191, no = Io >>> 13, ma = lr[4] | 0, Qn = ma & 8191, co = ma >>> 13, kn = lr[5] | 0, ai = kn & 8191, _i = kn >>> 13, Pi = lr[6] | 0, Ai = Pi & 8191, ki = Pi >>> 13, an = lr[7] | 0, Ui = an & 8191, Vi = an >>> 13, Sn = lr[8] | 0, Hi = Sn & 8191, en = Sn >>> 13, qn = lr[9] | 0, _n = qn & 8191, Tn = qn >>> 13;
      Ue.negative = Ae.negative ^ ze.negative, Ue.length = 19, nr = Math.imul(Hr, Li), Pe = Math.imul(Hr, Yi), Pe = Pe + Math.imul(vi, Li) | 0, ur = Math.imul(vi, Yi);
      var xo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (xo >>> 26) | 0, xo &= 67108863, nr = Math.imul(wi, Li), Pe = Math.imul(wi, Yi), Pe = Pe + Math.imul(ii, Li) | 0, ur = Math.imul(ii, Yi), nr = nr + Math.imul(Hr, un) | 0, Pe = Pe + Math.imul(Hr, Gn) | 0, Pe = Pe + Math.imul(vi, un) | 0, ur = ur + Math.imul(vi, Gn) | 0;
      var Co = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Co >>> 26) | 0, Co &= 67108863, nr = Math.imul(ei, Li), Pe = Math.imul(ei, Yi), Pe = Pe + Math.imul(Zr, Li) | 0, ur = Math.imul(Zr, Yi), nr = nr + Math.imul(wi, un) | 0, Pe = Pe + Math.imul(wi, Gn) | 0, Pe = Pe + Math.imul(ii, un) | 0, ur = ur + Math.imul(ii, Gn) | 0, nr = nr + Math.imul(Hr, pn) | 0, Pe = Pe + Math.imul(Hr, Rn) | 0, Pe = Pe + Math.imul(vi, pn) | 0, ur = ur + Math.imul(vi, Rn) | 0;
      var $o = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + ($o >>> 26) | 0, $o &= 67108863, nr = Math.imul(hi, Li), Pe = Math.imul(hi, Yi), Pe = Pe + Math.imul(Oi, Li) | 0, ur = Math.imul(Oi, Yi), nr = nr + Math.imul(ei, un) | 0, Pe = Pe + Math.imul(ei, Gn) | 0, Pe = Pe + Math.imul(Zr, un) | 0, ur = ur + Math.imul(Zr, Gn) | 0, nr = nr + Math.imul(wi, pn) | 0, Pe = Pe + Math.imul(wi, Rn) | 0, Pe = Pe + Math.imul(ii, pn) | 0, ur = ur + Math.imul(ii, Rn) | 0, nr = nr + Math.imul(Hr, to) | 0, Pe = Pe + Math.imul(Hr, no) | 0, Pe = Pe + Math.imul(vi, to) | 0, ur = ur + Math.imul(vi, no) | 0;
      var Bo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Bo >>> 26) | 0, Bo &= 67108863, nr = Math.imul(yn, Li), Pe = Math.imul(yn, Yi), Pe = Pe + Math.imul(sn, Li) | 0, ur = Math.imul(sn, Yi), nr = nr + Math.imul(hi, un) | 0, Pe = Pe + Math.imul(hi, Gn) | 0, Pe = Pe + Math.imul(Oi, un) | 0, ur = ur + Math.imul(Oi, Gn) | 0, nr = nr + Math.imul(ei, pn) | 0, Pe = Pe + Math.imul(ei, Rn) | 0, Pe = Pe + Math.imul(Zr, pn) | 0, ur = ur + Math.imul(Zr, Rn) | 0, nr = nr + Math.imul(wi, to) | 0, Pe = Pe + Math.imul(wi, no) | 0, Pe = Pe + Math.imul(ii, to) | 0, ur = ur + Math.imul(ii, no) | 0, nr = nr + Math.imul(Hr, Qn) | 0, Pe = Pe + Math.imul(Hr, co) | 0, Pe = Pe + Math.imul(vi, Qn) | 0, ur = ur + Math.imul(vi, co) | 0;
      var Qo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Qo >>> 26) | 0, Qo &= 67108863, nr = Math.imul(rn, Li), Pe = Math.imul(rn, Yi), Pe = Pe + Math.imul(ji, Li) | 0, ur = Math.imul(ji, Yi), nr = nr + Math.imul(yn, un) | 0, Pe = Pe + Math.imul(yn, Gn) | 0, Pe = Pe + Math.imul(sn, un) | 0, ur = ur + Math.imul(sn, Gn) | 0, nr = nr + Math.imul(hi, pn) | 0, Pe = Pe + Math.imul(hi, Rn) | 0, Pe = Pe + Math.imul(Oi, pn) | 0, ur = ur + Math.imul(Oi, Rn) | 0, nr = nr + Math.imul(ei, to) | 0, Pe = Pe + Math.imul(ei, no) | 0, Pe = Pe + Math.imul(Zr, to) | 0, ur = ur + Math.imul(Zr, no) | 0, nr = nr + Math.imul(wi, Qn) | 0, Pe = Pe + Math.imul(wi, co) | 0, Pe = Pe + Math.imul(ii, Qn) | 0, ur = ur + Math.imul(ii, co) | 0, nr = nr + Math.imul(Hr, ai) | 0, Pe = Pe + Math.imul(Hr, _i) | 0, Pe = Pe + Math.imul(vi, ai) | 0, ur = ur + Math.imul(vi, _i) | 0;
      var Go = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Go >>> 26) | 0, Go &= 67108863, nr = Math.imul(In, Li), Pe = Math.imul(In, Yi), Pe = Pe + Math.imul(Fn, Li) | 0, ur = Math.imul(Fn, Yi), nr = nr + Math.imul(rn, un) | 0, Pe = Pe + Math.imul(rn, Gn) | 0, Pe = Pe + Math.imul(ji, un) | 0, ur = ur + Math.imul(ji, Gn) | 0, nr = nr + Math.imul(yn, pn) | 0, Pe = Pe + Math.imul(yn, Rn) | 0, Pe = Pe + Math.imul(sn, pn) | 0, ur = ur + Math.imul(sn, Rn) | 0, nr = nr + Math.imul(hi, to) | 0, Pe = Pe + Math.imul(hi, no) | 0, Pe = Pe + Math.imul(Oi, to) | 0, ur = ur + Math.imul(Oi, no) | 0, nr = nr + Math.imul(ei, Qn) | 0, Pe = Pe + Math.imul(ei, co) | 0, Pe = Pe + Math.imul(Zr, Qn) | 0, ur = ur + Math.imul(Zr, co) | 0, nr = nr + Math.imul(wi, ai) | 0, Pe = Pe + Math.imul(wi, _i) | 0, Pe = Pe + Math.imul(ii, ai) | 0, ur = ur + Math.imul(ii, _i) | 0, nr = nr + Math.imul(Hr, Ai) | 0, Pe = Pe + Math.imul(Hr, ki) | 0, Pe = Pe + Math.imul(vi, Ai) | 0, ur = ur + Math.imul(vi, ki) | 0;
      var No = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, nr = Math.imul(vn, Li), Pe = Math.imul(vn, Yi), Pe = Pe + Math.imul(Vn, Li) | 0, ur = Math.imul(Vn, Yi), nr = nr + Math.imul(In, un) | 0, Pe = Pe + Math.imul(In, Gn) | 0, Pe = Pe + Math.imul(Fn, un) | 0, ur = ur + Math.imul(Fn, Gn) | 0, nr = nr + Math.imul(rn, pn) | 0, Pe = Pe + Math.imul(rn, Rn) | 0, Pe = Pe + Math.imul(ji, pn) | 0, ur = ur + Math.imul(ji, Rn) | 0, nr = nr + Math.imul(yn, to) | 0, Pe = Pe + Math.imul(yn, no) | 0, Pe = Pe + Math.imul(sn, to) | 0, ur = ur + Math.imul(sn, no) | 0, nr = nr + Math.imul(hi, Qn) | 0, Pe = Pe + Math.imul(hi, co) | 0, Pe = Pe + Math.imul(Oi, Qn) | 0, ur = ur + Math.imul(Oi, co) | 0, nr = nr + Math.imul(ei, ai) | 0, Pe = Pe + Math.imul(ei, _i) | 0, Pe = Pe + Math.imul(Zr, ai) | 0, ur = ur + Math.imul(Zr, _i) | 0, nr = nr + Math.imul(wi, Ai) | 0, Pe = Pe + Math.imul(wi, ki) | 0, Pe = Pe + Math.imul(ii, Ai) | 0, ur = ur + Math.imul(ii, ki) | 0, nr = nr + Math.imul(Hr, Ui) | 0, Pe = Pe + Math.imul(Hr, Vi) | 0, Pe = Pe + Math.imul(vi, Ui) | 0, ur = ur + Math.imul(vi, Vi) | 0;
      var Zo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Zo >>> 26) | 0, Zo &= 67108863, nr = Math.imul(Xn, Li), Pe = Math.imul(Xn, Yi), Pe = Pe + Math.imul(Yn, Li) | 0, ur = Math.imul(Yn, Yi), nr = nr + Math.imul(vn, un) | 0, Pe = Pe + Math.imul(vn, Gn) | 0, Pe = Pe + Math.imul(Vn, un) | 0, ur = ur + Math.imul(Vn, Gn) | 0, nr = nr + Math.imul(In, pn) | 0, Pe = Pe + Math.imul(In, Rn) | 0, Pe = Pe + Math.imul(Fn, pn) | 0, ur = ur + Math.imul(Fn, Rn) | 0, nr = nr + Math.imul(rn, to) | 0, Pe = Pe + Math.imul(rn, no) | 0, Pe = Pe + Math.imul(ji, to) | 0, ur = ur + Math.imul(ji, no) | 0, nr = nr + Math.imul(yn, Qn) | 0, Pe = Pe + Math.imul(yn, co) | 0, Pe = Pe + Math.imul(sn, Qn) | 0, ur = ur + Math.imul(sn, co) | 0, nr = nr + Math.imul(hi, ai) | 0, Pe = Pe + Math.imul(hi, _i) | 0, Pe = Pe + Math.imul(Oi, ai) | 0, ur = ur + Math.imul(Oi, _i) | 0, nr = nr + Math.imul(ei, Ai) | 0, Pe = Pe + Math.imul(ei, ki) | 0, Pe = Pe + Math.imul(Zr, Ai) | 0, ur = ur + Math.imul(Zr, ki) | 0, nr = nr + Math.imul(wi, Ui) | 0, Pe = Pe + Math.imul(wi, Vi) | 0, Pe = Pe + Math.imul(ii, Ui) | 0, ur = ur + Math.imul(ii, Vi) | 0, nr = nr + Math.imul(Hr, Hi) | 0, Pe = Pe + Math.imul(Hr, en) | 0, Pe = Pe + Math.imul(vi, Hi) | 0, ur = ur + Math.imul(vi, en) | 0;
      var ea = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ea >>> 26) | 0, ea &= 67108863, nr = Math.imul(Ci, Li), Pe = Math.imul(Ci, Yi), Pe = Pe + Math.imul(ri, Li) | 0, ur = Math.imul(ri, Yi), nr = nr + Math.imul(Xn, un) | 0, Pe = Pe + Math.imul(Xn, Gn) | 0, Pe = Pe + Math.imul(Yn, un) | 0, ur = ur + Math.imul(Yn, Gn) | 0, nr = nr + Math.imul(vn, pn) | 0, Pe = Pe + Math.imul(vn, Rn) | 0, Pe = Pe + Math.imul(Vn, pn) | 0, ur = ur + Math.imul(Vn, Rn) | 0, nr = nr + Math.imul(In, to) | 0, Pe = Pe + Math.imul(In, no) | 0, Pe = Pe + Math.imul(Fn, to) | 0, ur = ur + Math.imul(Fn, no) | 0, nr = nr + Math.imul(rn, Qn) | 0, Pe = Pe + Math.imul(rn, co) | 0, Pe = Pe + Math.imul(ji, Qn) | 0, ur = ur + Math.imul(ji, co) | 0, nr = nr + Math.imul(yn, ai) | 0, Pe = Pe + Math.imul(yn, _i) | 0, Pe = Pe + Math.imul(sn, ai) | 0, ur = ur + Math.imul(sn, _i) | 0, nr = nr + Math.imul(hi, Ai) | 0, Pe = Pe + Math.imul(hi, ki) | 0, Pe = Pe + Math.imul(Oi, Ai) | 0, ur = ur + Math.imul(Oi, ki) | 0, nr = nr + Math.imul(ei, Ui) | 0, Pe = Pe + Math.imul(ei, Vi) | 0, Pe = Pe + Math.imul(Zr, Ui) | 0, ur = ur + Math.imul(Zr, Vi) | 0, nr = nr + Math.imul(wi, Hi) | 0, Pe = Pe + Math.imul(wi, en) | 0, Pe = Pe + Math.imul(ii, Hi) | 0, ur = ur + Math.imul(ii, en) | 0, nr = nr + Math.imul(Hr, _n) | 0, Pe = Pe + Math.imul(Hr, Tn) | 0, Pe = Pe + Math.imul(vi, _n) | 0, ur = ur + Math.imul(vi, Tn) | 0;
      var da = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (da >>> 26) | 0, da &= 67108863, nr = Math.imul(Ci, un), Pe = Math.imul(Ci, Gn), Pe = Pe + Math.imul(ri, un) | 0, ur = Math.imul(ri, Gn), nr = nr + Math.imul(Xn, pn) | 0, Pe = Pe + Math.imul(Xn, Rn) | 0, Pe = Pe + Math.imul(Yn, pn) | 0, ur = ur + Math.imul(Yn, Rn) | 0, nr = nr + Math.imul(vn, to) | 0, Pe = Pe + Math.imul(vn, no) | 0, Pe = Pe + Math.imul(Vn, to) | 0, ur = ur + Math.imul(Vn, no) | 0, nr = nr + Math.imul(In, Qn) | 0, Pe = Pe + Math.imul(In, co) | 0, Pe = Pe + Math.imul(Fn, Qn) | 0, ur = ur + Math.imul(Fn, co) | 0, nr = nr + Math.imul(rn, ai) | 0, Pe = Pe + Math.imul(rn, _i) | 0, Pe = Pe + Math.imul(ji, ai) | 0, ur = ur + Math.imul(ji, _i) | 0, nr = nr + Math.imul(yn, Ai) | 0, Pe = Pe + Math.imul(yn, ki) | 0, Pe = Pe + Math.imul(sn, Ai) | 0, ur = ur + Math.imul(sn, ki) | 0, nr = nr + Math.imul(hi, Ui) | 0, Pe = Pe + Math.imul(hi, Vi) | 0, Pe = Pe + Math.imul(Oi, Ui) | 0, ur = ur + Math.imul(Oi, Vi) | 0, nr = nr + Math.imul(ei, Hi) | 0, Pe = Pe + Math.imul(ei, en) | 0, Pe = Pe + Math.imul(Zr, Hi) | 0, ur = ur + Math.imul(Zr, en) | 0, nr = nr + Math.imul(wi, _n) | 0, Pe = Pe + Math.imul(wi, Tn) | 0, Pe = Pe + Math.imul(ii, _n) | 0, ur = ur + Math.imul(ii, Tn) | 0;
      var Ra = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ra >>> 26) | 0, Ra &= 67108863, nr = Math.imul(Ci, pn), Pe = Math.imul(Ci, Rn), Pe = Pe + Math.imul(ri, pn) | 0, ur = Math.imul(ri, Rn), nr = nr + Math.imul(Xn, to) | 0, Pe = Pe + Math.imul(Xn, no) | 0, Pe = Pe + Math.imul(Yn, to) | 0, ur = ur + Math.imul(Yn, no) | 0, nr = nr + Math.imul(vn, Qn) | 0, Pe = Pe + Math.imul(vn, co) | 0, Pe = Pe + Math.imul(Vn, Qn) | 0, ur = ur + Math.imul(Vn, co) | 0, nr = nr + Math.imul(In, ai) | 0, Pe = Pe + Math.imul(In, _i) | 0, Pe = Pe + Math.imul(Fn, ai) | 0, ur = ur + Math.imul(Fn, _i) | 0, nr = nr + Math.imul(rn, Ai) | 0, Pe = Pe + Math.imul(rn, ki) | 0, Pe = Pe + Math.imul(ji, Ai) | 0, ur = ur + Math.imul(ji, ki) | 0, nr = nr + Math.imul(yn, Ui) | 0, Pe = Pe + Math.imul(yn, Vi) | 0, Pe = Pe + Math.imul(sn, Ui) | 0, ur = ur + Math.imul(sn, Vi) | 0, nr = nr + Math.imul(hi, Hi) | 0, Pe = Pe + Math.imul(hi, en) | 0, Pe = Pe + Math.imul(Oi, Hi) | 0, ur = ur + Math.imul(Oi, en) | 0, nr = nr + Math.imul(ei, _n) | 0, Pe = Pe + Math.imul(ei, Tn) | 0, Pe = Pe + Math.imul(Zr, _n) | 0, ur = ur + Math.imul(Zr, Tn) | 0;
      var ba = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ba >>> 26) | 0, ba &= 67108863, nr = Math.imul(Ci, to), Pe = Math.imul(Ci, no), Pe = Pe + Math.imul(ri, to) | 0, ur = Math.imul(ri, no), nr = nr + Math.imul(Xn, Qn) | 0, Pe = Pe + Math.imul(Xn, co) | 0, Pe = Pe + Math.imul(Yn, Qn) | 0, ur = ur + Math.imul(Yn, co) | 0, nr = nr + Math.imul(vn, ai) | 0, Pe = Pe + Math.imul(vn, _i) | 0, Pe = Pe + Math.imul(Vn, ai) | 0, ur = ur + Math.imul(Vn, _i) | 0, nr = nr + Math.imul(In, Ai) | 0, Pe = Pe + Math.imul(In, ki) | 0, Pe = Pe + Math.imul(Fn, Ai) | 0, ur = ur + Math.imul(Fn, ki) | 0, nr = nr + Math.imul(rn, Ui) | 0, Pe = Pe + Math.imul(rn, Vi) | 0, Pe = Pe + Math.imul(ji, Ui) | 0, ur = ur + Math.imul(ji, Vi) | 0, nr = nr + Math.imul(yn, Hi) | 0, Pe = Pe + Math.imul(yn, en) | 0, Pe = Pe + Math.imul(sn, Hi) | 0, ur = ur + Math.imul(sn, en) | 0, nr = nr + Math.imul(hi, _n) | 0, Pe = Pe + Math.imul(hi, Tn) | 0, Pe = Pe + Math.imul(Oi, _n) | 0, ur = ur + Math.imul(Oi, Tn) | 0;
      var Ea = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ea >>> 26) | 0, Ea &= 67108863, nr = Math.imul(Ci, Qn), Pe = Math.imul(Ci, co), Pe = Pe + Math.imul(ri, Qn) | 0, ur = Math.imul(ri, co), nr = nr + Math.imul(Xn, ai) | 0, Pe = Pe + Math.imul(Xn, _i) | 0, Pe = Pe + Math.imul(Yn, ai) | 0, ur = ur + Math.imul(Yn, _i) | 0, nr = nr + Math.imul(vn, Ai) | 0, Pe = Pe + Math.imul(vn, ki) | 0, Pe = Pe + Math.imul(Vn, Ai) | 0, ur = ur + Math.imul(Vn, ki) | 0, nr = nr + Math.imul(In, Ui) | 0, Pe = Pe + Math.imul(In, Vi) | 0, Pe = Pe + Math.imul(Fn, Ui) | 0, ur = ur + Math.imul(Fn, Vi) | 0, nr = nr + Math.imul(rn, Hi) | 0, Pe = Pe + Math.imul(rn, en) | 0, Pe = Pe + Math.imul(ji, Hi) | 0, ur = ur + Math.imul(ji, en) | 0, nr = nr + Math.imul(yn, _n) | 0, Pe = Pe + Math.imul(yn, Tn) | 0, Pe = Pe + Math.imul(sn, _n) | 0, ur = ur + Math.imul(sn, Tn) | 0;
      var Ha = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ha >>> 26) | 0, Ha &= 67108863, nr = Math.imul(Ci, ai), Pe = Math.imul(Ci, _i), Pe = Pe + Math.imul(ri, ai) | 0, ur = Math.imul(ri, _i), nr = nr + Math.imul(Xn, Ai) | 0, Pe = Pe + Math.imul(Xn, ki) | 0, Pe = Pe + Math.imul(Yn, Ai) | 0, ur = ur + Math.imul(Yn, ki) | 0, nr = nr + Math.imul(vn, Ui) | 0, Pe = Pe + Math.imul(vn, Vi) | 0, Pe = Pe + Math.imul(Vn, Ui) | 0, ur = ur + Math.imul(Vn, Vi) | 0, nr = nr + Math.imul(In, Hi) | 0, Pe = Pe + Math.imul(In, en) | 0, Pe = Pe + Math.imul(Fn, Hi) | 0, ur = ur + Math.imul(Fn, en) | 0, nr = nr + Math.imul(rn, _n) | 0, Pe = Pe + Math.imul(rn, Tn) | 0, Pe = Pe + Math.imul(ji, _n) | 0, ur = ur + Math.imul(ji, Tn) | 0;
      var Fa = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Fa >>> 26) | 0, Fa &= 67108863, nr = Math.imul(Ci, Ai), Pe = Math.imul(Ci, ki), Pe = Pe + Math.imul(ri, Ai) | 0, ur = Math.imul(ri, ki), nr = nr + Math.imul(Xn, Ui) | 0, Pe = Pe + Math.imul(Xn, Vi) | 0, Pe = Pe + Math.imul(Yn, Ui) | 0, ur = ur + Math.imul(Yn, Vi) | 0, nr = nr + Math.imul(vn, Hi) | 0, Pe = Pe + Math.imul(vn, en) | 0, Pe = Pe + Math.imul(Vn, Hi) | 0, ur = ur + Math.imul(Vn, en) | 0, nr = nr + Math.imul(In, _n) | 0, Pe = Pe + Math.imul(In, Tn) | 0, Pe = Pe + Math.imul(Fn, _n) | 0, ur = ur + Math.imul(Fn, Tn) | 0;
      var ls = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ls >>> 26) | 0, ls &= 67108863, nr = Math.imul(Ci, Ui), Pe = Math.imul(Ci, Vi), Pe = Pe + Math.imul(ri, Ui) | 0, ur = Math.imul(ri, Vi), nr = nr + Math.imul(Xn, Hi) | 0, Pe = Pe + Math.imul(Xn, en) | 0, Pe = Pe + Math.imul(Yn, Hi) | 0, ur = ur + Math.imul(Yn, en) | 0, nr = nr + Math.imul(vn, _n) | 0, Pe = Pe + Math.imul(vn, Tn) | 0, Pe = Pe + Math.imul(Vn, _n) | 0, ur = ur + Math.imul(Vn, Tn) | 0;
      var us = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (us >>> 26) | 0, us &= 67108863, nr = Math.imul(Ci, Hi), Pe = Math.imul(Ci, en), Pe = Pe + Math.imul(ri, Hi) | 0, ur = Math.imul(ri, en), nr = nr + Math.imul(Xn, _n) | 0, Pe = Pe + Math.imul(Xn, Tn) | 0, Pe = Pe + Math.imul(Yn, _n) | 0, ur = ur + Math.imul(Yn, Tn) | 0;
      var Xa = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Xa >>> 26) | 0, Xa &= 67108863, nr = Math.imul(Ci, _n), Pe = Math.imul(Ci, Tn), Pe = Pe + Math.imul(ri, _n) | 0, ur = Math.imul(ri, Tn);
      var hs = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      return br = (ur + (Pe >>> 13) | 0) + (hs >>> 26) | 0, hs &= 67108863, pr[0] = xo, pr[1] = Co, pr[2] = $o, pr[3] = Bo, pr[4] = Qo, pr[5] = Go, pr[6] = No, pr[7] = Zo, pr[8] = ea, pr[9] = da, pr[10] = Ra, pr[11] = ba, pr[12] = Ea, pr[13] = Ha, pr[14] = Fa, pr[15] = ls, pr[16] = us, pr[17] = Xa, pr[18] = hs, br !== 0 && (pr[19] = br, Ue.length++), Ue;
    };
    Math.imul || (Rr = Ar);
    function Nr(vr, Ae, ze) {
      ze.negative = Ae.negative ^ vr.negative, ze.length = vr.length + Ae.length;
      for (var Ue = 0, tr = 0, lr = 0; lr < ze.length - 1; lr++) {
        var pr = tr;
        tr = 0;
        for (var br = Ue & 67108863, nr = Math.min(lr, Ae.length - 1), Pe = Math.max(0, lr - vr.length + 1); Pe <= nr; Pe++) {
          var ur = lr - Pe, Pr = vr.words[ur] | 0, Hr = Ae.words[Pe] | 0, vi = Pr * Hr, Ti = vi & 67108863;
          pr = pr + (vi / 67108864 | 0) | 0, Ti = Ti + br | 0, br = Ti & 67108863, pr = pr + (Ti >>> 26) | 0, tr += pr >>> 26, pr &= 67108863;
        }
        ze.words[lr] = br, Ue = pr, pr = tr;
      }
      return Ue !== 0 ? ze.words[lr] = Ue : ze.length--, ze.strip();
    }
    function Yr(vr, Ae, ze) {
      var Ue = new Vr();
      return Ue.mulp(vr, Ae, ze);
    }
    Me.prototype.mulTo = function(Ae, ze) {
      var Ue, tr = this.length + Ae.length;
      return this.length === 10 && Ae.length === 10 ? Ue = Rr(this, Ae, ze) : tr < 63 ? Ue = Ar(this, Ae, ze) : tr < 1024 ? Ue = Nr(this, Ae, ze) : Ue = Yr(this, Ae, ze), Ue;
    };
    function Vr(vr, Ae) {
      this.x = vr, this.y = Ae;
    }
    Vr.prototype.makeRBT = function(Ae) {
      for (var ze = new Array(Ae), Ue = Me.prototype._countBits(Ae) - 1, tr = 0; tr < Ae; tr++)
        ze[tr] = this.revBin(tr, Ue, Ae);
      return ze;
    }, Vr.prototype.revBin = function(Ae, ze, Ue) {
      if (Ae === 0 || Ae === Ue - 1)
        return Ae;
      for (var tr = 0, lr = 0; lr < ze; lr++)
        tr |= (Ae & 1) << ze - lr - 1, Ae >>= 1;
      return tr;
    }, Vr.prototype.permute = function(Ae, ze, Ue, tr, lr, pr) {
      for (var br = 0; br < pr; br++)
        tr[br] = ze[Ae[br]], lr[br] = Ue[Ae[br]];
    }, Vr.prototype.transform = function(Ae, ze, Ue, tr, lr, pr) {
      this.permute(pr, Ae, ze, Ue, tr, lr);
      for (var br = 1; br < lr; br <<= 1)
        for (var nr = br << 1, Pe = Math.cos(2 * Math.PI / nr), ur = Math.sin(2 * Math.PI / nr), Pr = 0; Pr < lr; Pr += nr)
          for (var Hr = Pe, vi = ur, Ti = 0; Ti < br; Ti++) {
            var wi = Ue[Pr + Ti], ii = tr[Pr + Ti], mi = Ue[Pr + Ti + br], ei = tr[Pr + Ti + br], Zr = Hr * mi - vi * ei;
            ei = Hr * ei + vi * mi, mi = Zr, Ue[Pr + Ti] = wi + mi, tr[Pr + Ti] = ii + ei, Ue[Pr + Ti + br] = wi - mi, tr[Pr + Ti + br] = ii - ei, Ti !== nr && (Zr = Pe * Hr - ur * vi, vi = Pe * vi + ur * Hr, Hr = Zr);
          }
    }, Vr.prototype.guessLen13b = function(Ae, ze) {
      var Ue = Math.max(ze, Ae) | 1, tr = Ue & 1, lr = 0;
      for (Ue = Ue / 2 | 0; Ue; Ue = Ue >>> 1)
        lr++;
      return 1 << lr + 1 + tr;
    }, Vr.prototype.conjugate = function(Ae, ze, Ue) {
      if (!(Ue <= 1))
        for (var tr = 0; tr < Ue / 2; tr++) {
          var lr = Ae[tr];
          Ae[tr] = Ae[Ue - tr - 1], Ae[Ue - tr - 1] = lr, lr = ze[tr], ze[tr] = -ze[Ue - tr - 1], ze[Ue - tr - 1] = -lr;
        }
    }, Vr.prototype.normalize13b = function(Ae, ze) {
      for (var Ue = 0, tr = 0; tr < ze / 2; tr++) {
        var lr = Math.round(Ae[2 * tr + 1] / ze) * 8192 + Math.round(Ae[2 * tr] / ze) + Ue;
        Ae[tr] = lr & 67108863, lr < 67108864 ? Ue = 0 : Ue = lr / 67108864 | 0;
      }
      return Ae;
    }, Vr.prototype.convert13b = function(Ae, ze, Ue, tr) {
      for (var lr = 0, pr = 0; pr < ze; pr++)
        lr = lr + (Ae[pr] | 0), Ue[2 * pr] = lr & 8191, lr = lr >>> 13, Ue[2 * pr + 1] = lr & 8191, lr = lr >>> 13;
      for (pr = 2 * ze; pr < tr; ++pr)
        Ue[pr] = 0;
      we(lr === 0), we((lr & -8192) === 0);
    }, Vr.prototype.stub = function(Ae) {
      for (var ze = new Array(Ae), Ue = 0; Ue < Ae; Ue++)
        ze[Ue] = 0;
      return ze;
    }, Vr.prototype.mulp = function(Ae, ze, Ue) {
      var tr = 2 * this.guessLen13b(Ae.length, ze.length), lr = this.makeRBT(tr), pr = this.stub(tr), br = new Array(tr), nr = new Array(tr), Pe = new Array(tr), ur = new Array(tr), Pr = new Array(tr), Hr = new Array(tr), vi = Ue.words;
      vi.length = tr, this.convert13b(Ae.words, Ae.length, br, tr), this.convert13b(ze.words, ze.length, ur, tr), this.transform(br, pr, nr, Pe, tr, lr), this.transform(ur, pr, Pr, Hr, tr, lr);
      for (var Ti = 0; Ti < tr; Ti++) {
        var wi = nr[Ti] * Pr[Ti] - Pe[Ti] * Hr[Ti];
        Pe[Ti] = nr[Ti] * Hr[Ti] + Pe[Ti] * Pr[Ti], nr[Ti] = wi;
      }
      return this.conjugate(nr, Pe, tr), this.transform(nr, Pe, vi, pr, tr, lr), this.conjugate(vi, pr, tr), this.normalize13b(vi, tr), Ue.negative = Ae.negative ^ ze.negative, Ue.length = Ae.length + ze.length, Ue.strip();
    }, Me.prototype.mul = function(Ae) {
      var ze = new Me(null);
      return ze.words = new Array(this.length + Ae.length), this.mulTo(Ae, ze);
    }, Me.prototype.mulf = function(Ae) {
      var ze = new Me(null);
      return ze.words = new Array(this.length + Ae.length), Yr(this, Ae, ze);
    }, Me.prototype.imul = function(Ae) {
      return this.clone().mulTo(Ae, this);
    }, Me.prototype.imuln = function(Ae) {
      we(typeof Ae == "number"), we(Ae < 67108864);
      for (var ze = 0, Ue = 0; Ue < this.length; Ue++) {
        var tr = (this.words[Ue] | 0) * Ae, lr = (tr & 67108863) + (ze & 67108863);
        ze >>= 26, ze += tr / 67108864 | 0, ze += lr >>> 26, this.words[Ue] = lr & 67108863;
      }
      return ze !== 0 && (this.words[Ue] = ze, this.length++), this;
    }, Me.prototype.muln = function(Ae) {
      return this.clone().imuln(Ae);
    }, Me.prototype.sqr = function() {
      return this.mul(this);
    }, Me.prototype.isqr = function() {
      return this.imul(this.clone());
    }, Me.prototype.pow = function(Ae) {
      var ze = Ir(Ae);
      if (ze.length === 0)
        return new Me(1);
      for (var Ue = this, tr = 0; tr < ze.length && ze[tr] === 0; tr++, Ue = Ue.sqr())
        ;
      if (++tr < ze.length)
        for (var lr = Ue.sqr(); tr < ze.length; tr++, lr = lr.sqr())
          ze[tr] !== 0 && (Ue = Ue.mul(lr));
      return Ue;
    }, Me.prototype.iushln = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 67108863 >>> 26 - ze << 26 - ze, lr;
      if (ze !== 0) {
        var pr = 0;
        for (lr = 0; lr < this.length; lr++) {
          var br = this.words[lr] & tr, nr = (this.words[lr] | 0) - br << ze;
          this.words[lr] = nr | pr, pr = br >>> 26 - ze;
        }
        pr && (this.words[lr] = pr, this.length++);
      }
      if (Ue !== 0) {
        for (lr = this.length - 1; lr >= 0; lr--)
          this.words[lr + Ue] = this.words[lr];
        for (lr = 0; lr < Ue; lr++)
          this.words[lr] = 0;
        this.length += Ue;
      }
      return this.strip();
    }, Me.prototype.ishln = function(Ae) {
      return we(this.negative === 0), this.iushln(Ae);
    }, Me.prototype.iushrn = function(Ae, ze, Ue) {
      we(typeof Ae == "number" && Ae >= 0);
      var tr;
      ze ? tr = (ze - ze % 26) / 26 : tr = 0;
      var lr = Ae % 26, pr = Math.min((Ae - lr) / 26, this.length), br = 67108863 ^ 67108863 >>> lr << lr, nr = Ue;
      if (tr -= pr, tr = Math.max(0, tr), nr) {
        for (var Pe = 0; Pe < pr; Pe++)
          nr.words[Pe] = this.words[Pe];
        nr.length = pr;
      }
      if (pr !== 0)
        if (this.length > pr)
          for (this.length -= pr, Pe = 0; Pe < this.length; Pe++)
            this.words[Pe] = this.words[Pe + pr];
        else
          this.words[0] = 0, this.length = 1;
      var ur = 0;
      for (Pe = this.length - 1; Pe >= 0 && (ur !== 0 || Pe >= tr); Pe--) {
        var Pr = this.words[Pe] | 0;
        this.words[Pe] = ur << 26 - lr | Pr >>> lr, ur = Pr & br;
      }
      return nr && ur !== 0 && (nr.words[nr.length++] = ur), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, Me.prototype.ishrn = function(Ae, ze, Ue) {
      return we(this.negative === 0), this.iushrn(Ae, ze, Ue);
    }, Me.prototype.shln = function(Ae) {
      return this.clone().ishln(Ae);
    }, Me.prototype.ushln = function(Ae) {
      return this.clone().iushln(Ae);
    }, Me.prototype.shrn = function(Ae) {
      return this.clone().ishrn(Ae);
    }, Me.prototype.ushrn = function(Ae) {
      return this.clone().iushrn(Ae);
    }, Me.prototype.testn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 1 << ze;
      if (this.length <= Ue)
        return !1;
      var lr = this.words[Ue];
      return !!(lr & tr);
    }, Me.prototype.imaskn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26;
      if (we(this.negative === 0, "imaskn works only with positive numbers"), this.length <= Ue)
        return this;
      if (ze !== 0 && Ue++, this.length = Math.min(Ue, this.length), ze !== 0) {
        var tr = 67108863 ^ 67108863 >>> ze << ze;
        this.words[this.length - 1] &= tr;
      }
      return this.strip();
    }, Me.prototype.maskn = function(Ae) {
      return this.clone().imaskn(Ae);
    }, Me.prototype.iaddn = function(Ae) {
      return we(typeof Ae == "number"), we(Ae < 67108864), Ae < 0 ? this.isubn(-Ae) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Ae ? (this.words[0] = Ae - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ae), this.negative = 1, this) : this._iaddn(Ae);
    }, Me.prototype._iaddn = function(Ae) {
      this.words[0] += Ae;
      for (var ze = 0; ze < this.length && this.words[ze] >= 67108864; ze++)
        this.words[ze] -= 67108864, ze === this.length - 1 ? this.words[ze + 1] = 1 : this.words[ze + 1]++;
      return this.length = Math.max(this.length, ze + 1), this;
    }, Me.prototype.isubn = function(Ae) {
      if (we(typeof Ae == "number"), we(Ae < 67108864), Ae < 0)
        return this.iaddn(-Ae);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(Ae), this.negative = 1, this;
      if (this.words[0] -= Ae, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var ze = 0; ze < this.length && this.words[ze] < 0; ze++)
          this.words[ze] += 67108864, this.words[ze + 1] -= 1;
      return this.strip();
    }, Me.prototype.addn = function(Ae) {
      return this.clone().iaddn(Ae);
    }, Me.prototype.subn = function(Ae) {
      return this.clone().isubn(Ae);
    }, Me.prototype.iabs = function() {
      return this.negative = 0, this;
    }, Me.prototype.abs = function() {
      return this.clone().iabs();
    }, Me.prototype._ishlnsubmul = function(Ae, ze, Ue) {
      var tr = Ae.length + Ue, lr;
      this._expand(tr);
      var pr, br = 0;
      for (lr = 0; lr < Ae.length; lr++) {
        pr = (this.words[lr + Ue] | 0) + br;
        var nr = (Ae.words[lr] | 0) * ze;
        pr -= nr & 67108863, br = (pr >> 26) - (nr / 67108864 | 0), this.words[lr + Ue] = pr & 67108863;
      }
      for (; lr < this.length - Ue; lr++)
        pr = (this.words[lr + Ue] | 0) + br, br = pr >> 26, this.words[lr + Ue] = pr & 67108863;
      if (br === 0)
        return this.strip();
      for (we(br === -1), br = 0, lr = 0; lr < this.length; lr++)
        pr = -(this.words[lr] | 0) + br, br = pr >> 26, this.words[lr] = pr & 67108863;
      return this.negative = 1, this.strip();
    }, Me.prototype._wordDiv = function(Ae, ze) {
      var Ue = this.length - Ae.length, tr = this.clone(), lr = Ae, pr = lr.words[lr.length - 1] | 0, br = this._countBits(pr);
      Ue = 26 - br, Ue !== 0 && (lr = lr.ushln(Ue), tr.iushln(Ue), pr = lr.words[lr.length - 1] | 0);
      var nr = tr.length - lr.length, Pe;
      if (ze !== "mod") {
        Pe = new Me(null), Pe.length = nr + 1, Pe.words = new Array(Pe.length);
        for (var ur = 0; ur < Pe.length; ur++)
          Pe.words[ur] = 0;
      }
      var Pr = tr.clone()._ishlnsubmul(lr, 1, nr);
      Pr.negative === 0 && (tr = Pr, Pe && (Pe.words[nr] = 1));
      for (var Hr = nr - 1; Hr >= 0; Hr--) {
        var vi = (tr.words[lr.length + Hr] | 0) * 67108864 + (tr.words[lr.length + Hr - 1] | 0);
        for (vi = Math.min(vi / pr | 0, 67108863), tr._ishlnsubmul(lr, vi, Hr); tr.negative !== 0; )
          vi--, tr.negative = 0, tr._ishlnsubmul(lr, 1, Hr), tr.isZero() || (tr.negative ^= 1);
        Pe && (Pe.words[Hr] = vi);
      }
      return Pe && Pe.strip(), tr.strip(), ze !== "div" && Ue !== 0 && tr.iushrn(Ue), {
        div: Pe || null,
        mod: tr
      };
    }, Me.prototype.divmod = function(Ae, ze, Ue) {
      if (we(!Ae.isZero()), this.isZero())
        return {
          div: new Me(0),
          mod: new Me(0)
        };
      var tr, lr, pr;
      return this.negative !== 0 && Ae.negative === 0 ? (pr = this.neg().divmod(Ae, ze), ze !== "mod" && (tr = pr.div.neg()), ze !== "div" && (lr = pr.mod.neg(), Ue && lr.negative !== 0 && lr.iadd(Ae)), {
        div: tr,
        mod: lr
      }) : this.negative === 0 && Ae.negative !== 0 ? (pr = this.divmod(Ae.neg(), ze), ze !== "mod" && (tr = pr.div.neg()), {
        div: tr,
        mod: pr.mod
      }) : (this.negative & Ae.negative) !== 0 ? (pr = this.neg().divmod(Ae.neg(), ze), ze !== "div" && (lr = pr.mod.neg(), Ue && lr.negative !== 0 && lr.isub(Ae)), {
        div: pr.div,
        mod: lr
      }) : Ae.length > this.length || this.cmp(Ae) < 0 ? {
        div: new Me(0),
        mod: this
      } : Ae.length === 1 ? ze === "div" ? {
        div: this.divn(Ae.words[0]),
        mod: null
      } : ze === "mod" ? {
        div: null,
        mod: new Me(this.modn(Ae.words[0]))
      } : {
        div: this.divn(Ae.words[0]),
        mod: new Me(this.modn(Ae.words[0]))
      } : this._wordDiv(Ae, ze);
    }, Me.prototype.div = function(Ae) {
      return this.divmod(Ae, "div", !1).div;
    }, Me.prototype.mod = function(Ae) {
      return this.divmod(Ae, "mod", !1).mod;
    }, Me.prototype.umod = function(Ae) {
      return this.divmod(Ae, "mod", !0).mod;
    }, Me.prototype.divRound = function(Ae) {
      var ze = this.divmod(Ae);
      if (ze.mod.isZero())
        return ze.div;
      var Ue = ze.div.negative !== 0 ? ze.mod.isub(Ae) : ze.mod, tr = Ae.ushrn(1), lr = Ae.andln(1), pr = Ue.cmp(tr);
      return pr < 0 || lr === 1 && pr === 0 ? ze.div : ze.div.negative !== 0 ? ze.div.isubn(1) : ze.div.iaddn(1);
    }, Me.prototype.modn = function(Ae) {
      we(Ae <= 67108863);
      for (var ze = (1 << 26) % Ae, Ue = 0, tr = this.length - 1; tr >= 0; tr--)
        Ue = (ze * Ue + (this.words[tr] | 0)) % Ae;
      return Ue;
    }, Me.prototype.idivn = function(Ae) {
      we(Ae <= 67108863);
      for (var ze = 0, Ue = this.length - 1; Ue >= 0; Ue--) {
        var tr = (this.words[Ue] | 0) + ze * 67108864;
        this.words[Ue] = tr / Ae | 0, ze = tr % Ae;
      }
      return this.strip();
    }, Me.prototype.divn = function(Ae) {
      return this.clone().idivn(Ae);
    }, Me.prototype.egcd = function(Ae) {
      we(Ae.negative === 0), we(!Ae.isZero());
      var ze = this, Ue = Ae.clone();
      ze.negative !== 0 ? ze = ze.umod(Ae) : ze = ze.clone();
      for (var tr = new Me(1), lr = new Me(0), pr = new Me(0), br = new Me(1), nr = 0; ze.isEven() && Ue.isEven(); )
        ze.iushrn(1), Ue.iushrn(1), ++nr;
      for (var Pe = Ue.clone(), ur = ze.clone(); !ze.isZero(); ) {
        for (var Pr = 0, Hr = 1; (ze.words[0] & Hr) === 0 && Pr < 26; ++Pr, Hr <<= 1)
          ;
        if (Pr > 0)
          for (ze.iushrn(Pr); Pr-- > 0; )
            (tr.isOdd() || lr.isOdd()) && (tr.iadd(Pe), lr.isub(ur)), tr.iushrn(1), lr.iushrn(1);
        for (var vi = 0, Ti = 1; (Ue.words[0] & Ti) === 0 && vi < 26; ++vi, Ti <<= 1)
          ;
        if (vi > 0)
          for (Ue.iushrn(vi); vi-- > 0; )
            (pr.isOdd() || br.isOdd()) && (pr.iadd(Pe), br.isub(ur)), pr.iushrn(1), br.iushrn(1);
        ze.cmp(Ue) >= 0 ? (ze.isub(Ue), tr.isub(pr), lr.isub(br)) : (Ue.isub(ze), pr.isub(tr), br.isub(lr));
      }
      return {
        a: pr,
        b: br,
        gcd: Ue.iushln(nr)
      };
    }, Me.prototype._invmp = function(Ae) {
      we(Ae.negative === 0), we(!Ae.isZero());
      var ze = this, Ue = Ae.clone();
      ze.negative !== 0 ? ze = ze.umod(Ae) : ze = ze.clone();
      for (var tr = new Me(1), lr = new Me(0), pr = Ue.clone(); ze.cmpn(1) > 0 && Ue.cmpn(1) > 0; ) {
        for (var br = 0, nr = 1; (ze.words[0] & nr) === 0 && br < 26; ++br, nr <<= 1)
          ;
        if (br > 0)
          for (ze.iushrn(br); br-- > 0; )
            tr.isOdd() && tr.iadd(pr), tr.iushrn(1);
        for (var Pe = 0, ur = 1; (Ue.words[0] & ur) === 0 && Pe < 26; ++Pe, ur <<= 1)
          ;
        if (Pe > 0)
          for (Ue.iushrn(Pe); Pe-- > 0; )
            lr.isOdd() && lr.iadd(pr), lr.iushrn(1);
        ze.cmp(Ue) >= 0 ? (ze.isub(Ue), tr.isub(lr)) : (Ue.isub(ze), lr.isub(tr));
      }
      var Pr;
      return ze.cmpn(1) === 0 ? Pr = tr : Pr = lr, Pr.cmpn(0) < 0 && Pr.iadd(Ae), Pr;
    }, Me.prototype.gcd = function(Ae) {
      if (this.isZero())
        return Ae.abs();
      if (Ae.isZero())
        return this.abs();
      var ze = this.clone(), Ue = Ae.clone();
      ze.negative = 0, Ue.negative = 0;
      for (var tr = 0; ze.isEven() && Ue.isEven(); tr++)
        ze.iushrn(1), Ue.iushrn(1);
      do {
        for (; ze.isEven(); )
          ze.iushrn(1);
        for (; Ue.isEven(); )
          Ue.iushrn(1);
        var lr = ze.cmp(Ue);
        if (lr < 0) {
          var pr = ze;
          ze = Ue, Ue = pr;
        } else if (lr === 0 || Ue.cmpn(1) === 0)
          break;
        ze.isub(Ue);
      } while (!0);
      return Ue.iushln(tr);
    }, Me.prototype.invm = function(Ae) {
      return this.egcd(Ae).a.umod(Ae);
    }, Me.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, Me.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, Me.prototype.andln = function(Ae) {
      return this.words[0] & Ae;
    }, Me.prototype.bincn = function(Ae) {
      we(typeof Ae == "number");
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 1 << ze;
      if (this.length <= Ue)
        return this._expand(Ue + 1), this.words[Ue] |= tr, this;
      for (var lr = tr, pr = Ue; lr !== 0 && pr < this.length; pr++) {
        var br = this.words[pr] | 0;
        br += lr, lr = br >>> 26, br &= 67108863, this.words[pr] = br;
      }
      return lr !== 0 && (this.words[pr] = lr, this.length++), this;
    }, Me.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, Me.prototype.cmpn = function(Ae) {
      var ze = Ae < 0;
      if (this.negative !== 0 && !ze)
        return -1;
      if (this.negative === 0 && ze)
        return 1;
      this.strip();
      var Ue;
      if (this.length > 1)
        Ue = 1;
      else {
        ze && (Ae = -Ae), we(Ae <= 67108863, "Number is too big");
        var tr = this.words[0] | 0;
        Ue = tr === Ae ? 0 : tr < Ae ? -1 : 1;
      }
      return this.negative !== 0 ? -Ue | 0 : Ue;
    }, Me.prototype.cmp = function(Ae) {
      if (this.negative !== 0 && Ae.negative === 0)
        return -1;
      if (this.negative === 0 && Ae.negative !== 0)
        return 1;
      var ze = this.ucmp(Ae);
      return this.negative !== 0 ? -ze | 0 : ze;
    }, Me.prototype.ucmp = function(Ae) {
      if (this.length > Ae.length)
        return 1;
      if (this.length < Ae.length)
        return -1;
      for (var ze = 0, Ue = this.length - 1; Ue >= 0; Ue--) {
        var tr = this.words[Ue] | 0, lr = Ae.words[Ue] | 0;
        if (tr !== lr) {
          tr < lr ? ze = -1 : tr > lr && (ze = 1);
          break;
        }
      }
      return ze;
    }, Me.prototype.gtn = function(Ae) {
      return this.cmpn(Ae) === 1;
    }, Me.prototype.gt = function(Ae) {
      return this.cmp(Ae) === 1;
    }, Me.prototype.gten = function(Ae) {
      return this.cmpn(Ae) >= 0;
    }, Me.prototype.gte = function(Ae) {
      return this.cmp(Ae) >= 0;
    }, Me.prototype.ltn = function(Ae) {
      return this.cmpn(Ae) === -1;
    }, Me.prototype.lt = function(Ae) {
      return this.cmp(Ae) === -1;
    }, Me.prototype.lten = function(Ae) {
      return this.cmpn(Ae) <= 0;
    }, Me.prototype.lte = function(Ae) {
      return this.cmp(Ae) <= 0;
    }, Me.prototype.eqn = function(Ae) {
      return this.cmpn(Ae) === 0;
    }, Me.prototype.eq = function(Ae) {
      return this.cmp(Ae) === 0;
    }, Me.red = function(Ae) {
      return new oi(Ae);
    }, Me.prototype.toRed = function(Ae) {
      return we(!this.red, "Already a number in reduction context"), we(this.negative === 0, "red works only with positives"), Ae.convertTo(this)._forceRed(Ae);
    }, Me.prototype.fromRed = function() {
      return we(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, Me.prototype._forceRed = function(Ae) {
      return this.red = Ae, this;
    }, Me.prototype.forceRed = function(Ae) {
      return we(!this.red, "Already a number in reduction context"), this._forceRed(Ae);
    }, Me.prototype.redAdd = function(Ae) {
      return we(this.red, "redAdd works only with red numbers"), this.red.add(this, Ae);
    }, Me.prototype.redIAdd = function(Ae) {
      return we(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ae);
    }, Me.prototype.redSub = function(Ae) {
      return we(this.red, "redSub works only with red numbers"), this.red.sub(this, Ae);
    }, Me.prototype.redISub = function(Ae) {
      return we(this.red, "redISub works only with red numbers"), this.red.isub(this, Ae);
    }, Me.prototype.redShl = function(Ae) {
      return we(this.red, "redShl works only with red numbers"), this.red.shl(this, Ae);
    }, Me.prototype.redMul = function(Ae) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ae), this.red.mul(this, Ae);
    }, Me.prototype.redIMul = function(Ae) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ae), this.red.imul(this, Ae);
    }, Me.prototype.redSqr = function() {
      return we(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, Me.prototype.redISqr = function() {
      return we(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, Me.prototype.redSqrt = function() {
      return we(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, Me.prototype.redInvm = function() {
      return we(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, Me.prototype.redNeg = function() {
      return we(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, Me.prototype.redPow = function(Ae) {
      return we(this.red && !Ae.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ae);
    };
    var Xr = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Wr(vr, Ae) {
      this.name = vr, this.p = new Me(Ae, 16), this.n = this.p.bitLength(), this.k = new Me(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Wr.prototype._tmp = function() {
      var Ae = new Me(null);
      return Ae.words = new Array(Math.ceil(this.n / 13)), Ae;
    }, Wr.prototype.ireduce = function(Ae) {
      var ze = Ae, Ue;
      do
        this.split(ze, this.tmp), ze = this.imulK(ze), ze = ze.iadd(this.tmp), Ue = ze.bitLength();
      while (Ue > this.n);
      var tr = Ue < this.n ? -1 : ze.ucmp(this.p);
      return tr === 0 ? (ze.words[0] = 0, ze.length = 1) : tr > 0 ? ze.isub(this.p) : ze.strip !== void 0 ? ze.strip() : ze._strip(), ze;
    }, Wr.prototype.split = function(Ae, ze) {
      Ae.iushrn(this.n, 0, ze);
    }, Wr.prototype.imulK = function(Ae) {
      return Ae.imul(this.k);
    };
    function si() {
      Wr.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    $e(si, Wr), si.prototype.split = function(Ae, ze) {
      for (var Ue = 4194303, tr = Math.min(Ae.length, 9), lr = 0; lr < tr; lr++)
        ze.words[lr] = Ae.words[lr];
      if (ze.length = tr, Ae.length <= 9) {
        Ae.words[0] = 0, Ae.length = 1;
        return;
      }
      var pr = Ae.words[9];
      for (ze.words[ze.length++] = pr & Ue, lr = 10; lr < Ae.length; lr++) {
        var br = Ae.words[lr] | 0;
        Ae.words[lr - 10] = (br & Ue) << 4 | pr >>> 22, pr = br;
      }
      pr >>>= 22, Ae.words[lr - 10] = pr, pr === 0 && Ae.length > 10 ? Ae.length -= 10 : Ae.length -= 9;
    }, si.prototype.imulK = function(Ae) {
      Ae.words[Ae.length] = 0, Ae.words[Ae.length + 1] = 0, Ae.length += 2;
      for (var ze = 0, Ue = 0; Ue < Ae.length; Ue++) {
        var tr = Ae.words[Ue] | 0;
        ze += tr * 977, Ae.words[Ue] = ze & 67108863, ze = tr * 64 + (ze / 67108864 | 0);
      }
      return Ae.words[Ae.length - 1] === 0 && (Ae.length--, Ae.words[Ae.length - 1] === 0 && Ae.length--), Ae;
    };
    function li() {
      Wr.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    $e(li, Wr);
    function xi() {
      Wr.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    $e(xi, Wr);
    function di() {
      Wr.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    $e(di, Wr), di.prototype.imulK = function(Ae) {
      for (var ze = 0, Ue = 0; Ue < Ae.length; Ue++) {
        var tr = (Ae.words[Ue] | 0) * 19 + ze, lr = tr & 67108863;
        tr >>>= 26, Ae.words[Ue] = lr, ze = tr;
      }
      return ze !== 0 && (Ae.words[Ae.length++] = ze), Ae;
    }, Me._prime = function(Ae) {
      if (Xr[Ae])
        return Xr[Ae];
      var ze;
      if (Ae === "k256")
        ze = new si();
      else if (Ae === "p224")
        ze = new li();
      else if (Ae === "p192")
        ze = new xi();
      else if (Ae === "p25519")
        ze = new di();
      else
        throw new Error("Unknown prime " + Ae);
      return Xr[Ae] = ze, ze;
    };
    function oi(vr) {
      if (typeof vr == "string") {
        var Ae = Me._prime(vr);
        this.m = Ae.p, this.prime = Ae;
      } else
        we(vr.gtn(1), "modulus must be greater than 1"), this.m = vr, this.prime = null;
    }
    oi.prototype._verify1 = function(Ae) {
      we(Ae.negative === 0, "red works only with positives"), we(Ae.red, "red works only with red numbers");
    }, oi.prototype._verify2 = function(Ae, ze) {
      we((Ae.negative | ze.negative) === 0, "red works only with positives"), we(
        Ae.red && Ae.red === ze.red,
        "red works only with red numbers"
      );
    }, oi.prototype.imod = function(Ae) {
      return this.prime ? this.prime.ireduce(Ae)._forceRed(this) : Ae.umod(this.m)._forceRed(this);
    }, oi.prototype.neg = function(Ae) {
      return Ae.isZero() ? Ae.clone() : this.m.sub(Ae)._forceRed(this);
    }, oi.prototype.add = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.add(ze);
      return Ue.cmp(this.m) >= 0 && Ue.isub(this.m), Ue._forceRed(this);
    }, oi.prototype.iadd = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.iadd(ze);
      return Ue.cmp(this.m) >= 0 && Ue.isub(this.m), Ue;
    }, oi.prototype.sub = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.sub(ze);
      return Ue.cmpn(0) < 0 && Ue.iadd(this.m), Ue._forceRed(this);
    }, oi.prototype.isub = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.isub(ze);
      return Ue.cmpn(0) < 0 && Ue.iadd(this.m), Ue;
    }, oi.prototype.shl = function(Ae, ze) {
      return this._verify1(Ae), this.imod(Ae.ushln(ze));
    }, oi.prototype.imul = function(Ae, ze) {
      return this._verify2(Ae, ze), this.imod(Ae.imul(ze));
    }, oi.prototype.mul = function(Ae, ze) {
      return this._verify2(Ae, ze), this.imod(Ae.mul(ze));
    }, oi.prototype.isqr = function(Ae) {
      return this.imul(Ae, Ae.clone());
    }, oi.prototype.sqr = function(Ae) {
      return this.mul(Ae, Ae);
    }, oi.prototype.sqrt = function(Ae) {
      if (Ae.isZero())
        return Ae.clone();
      var ze = this.m.andln(3);
      if (we(ze % 2 === 1), ze === 3) {
        var Ue = this.m.add(new Me(1)).iushrn(2);
        return this.pow(Ae, Ue);
      }
      for (var tr = this.m.subn(1), lr = 0; !tr.isZero() && tr.andln(1) === 0; )
        lr++, tr.iushrn(1);
      we(!tr.isZero());
      var pr = new Me(1).toRed(this), br = pr.redNeg(), nr = this.m.subn(1).iushrn(1), Pe = this.m.bitLength();
      for (Pe = new Me(2 * Pe * Pe).toRed(this); this.pow(Pe, nr).cmp(br) !== 0; )
        Pe.redIAdd(br);
      for (var ur = this.pow(Pe, tr), Pr = this.pow(Ae, tr.addn(1).iushrn(1)), Hr = this.pow(Ae, tr), vi = lr; Hr.cmp(pr) !== 0; ) {
        for (var Ti = Hr, wi = 0; Ti.cmp(pr) !== 0; wi++)
          Ti = Ti.redSqr();
        we(wi < vi);
        var ii = this.pow(ur, new Me(1).iushln(vi - wi - 1));
        Pr = Pr.redMul(ii), ur = ii.redSqr(), Hr = Hr.redMul(ur), vi = wi;
      }
      return Pr;
    }, oi.prototype.invm = function(Ae) {
      var ze = Ae._invmp(this.m);
      return ze.negative !== 0 ? (ze.negative = 0, this.imod(ze).redNeg()) : this.imod(ze);
    }, oi.prototype.pow = function(Ae, ze) {
      if (ze.isZero())
        return new Me(1).toRed(this);
      if (ze.cmpn(1) === 0)
        return Ae.clone();
      var Ue = 4, tr = new Array(1 << Ue);
      tr[0] = new Me(1).toRed(this), tr[1] = Ae;
      for (var lr = 2; lr < tr.length; lr++)
        tr[lr] = this.mul(tr[lr - 1], Ae);
      var pr = tr[0], br = 0, nr = 0, Pe = ze.bitLength() % 26;
      for (Pe === 0 && (Pe = 26), lr = ze.length - 1; lr >= 0; lr--) {
        for (var ur = ze.words[lr], Pr = Pe - 1; Pr >= 0; Pr--) {
          var Hr = ur >> Pr & 1;
          if (pr !== tr[0] && (pr = this.sqr(pr)), Hr === 0 && br === 0) {
            nr = 0;
            continue;
          }
          br <<= 1, br |= Hr, nr++, !(nr !== Ue && (lr !== 0 || Pr !== 0)) && (pr = this.mul(pr, tr[br]), nr = 0, br = 0);
        }
        Pe = 26;
      }
      return pr;
    }, oi.prototype.convertTo = function(Ae) {
      var ze = Ae.umod(this.m);
      return ze === Ae ? ze.clone() : ze;
    }, oi.prototype.convertFrom = function(Ae) {
      var ze = Ae.clone();
      return ze.red = null, ze;
    }, Me.mont = function(Ae) {
      return new ci(Ae);
    };
    function ci(vr) {
      oi.call(this, vr), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new Me(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    $e(ci, oi), ci.prototype.convertTo = function(Ae) {
      return this.imod(Ae.ushln(this.shift));
    }, ci.prototype.convertFrom = function(Ae) {
      var ze = this.imod(Ae.mul(this.rinv));
      return ze.red = null, ze;
    }, ci.prototype.imul = function(Ae, ze) {
      if (Ae.isZero() || ze.isZero())
        return Ae.words[0] = 0, Ae.length = 1, Ae;
      var Ue = Ae.imul(ze), tr = Ue.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), lr = Ue.isub(tr).iushrn(this.shift), pr = lr;
      return lr.cmp(this.m) >= 0 ? pr = lr.isub(this.m) : lr.cmpn(0) < 0 && (pr = lr.iadd(this.m)), pr._forceRed(this);
    }, ci.prototype.mul = function(Ae, ze) {
      if (Ae.isZero() || ze.isZero())
        return new Me(0)._forceRed(this);
      var Ue = Ae.mul(ze), tr = Ue.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), lr = Ue.isub(tr).iushrn(this.shift), pr = lr;
      return lr.cmp(this.m) >= 0 ? pr = lr.isub(this.m) : lr.cmpn(0) < 0 && (pr = lr.iadd(this.m)), pr._forceRed(this);
    }, ci.prototype.invm = function(Ae) {
      var ze = this.imod(Ae._invmp(this.m).mul(this.r2));
      return ze._forceRed(this);
    };
  })(m, commonjsGlobal);
})(bn$3);
var utils$n = {};
(function(m) {
  var c = m;
  function ie(Me, Ze) {
    if (Array.isArray(Me))
      return Me.slice();
    if (!Me)
      return [];
    var ne = [];
    if (typeof Me != "string") {
      for (var rr = 0; rr < Me.length; rr++)
        ne[rr] = Me[rr] | 0;
      return ne;
    }
    if (Ze === "hex") {
      Me = Me.replace(/[^a-z0-9]+/ig, ""), Me.length % 2 !== 0 && (Me = "0" + Me);
      for (var rr = 0; rr < Me.length; rr += 2)
        ne.push(parseInt(Me[rr] + Me[rr + 1], 16));
    } else
      for (var rr = 0; rr < Me.length; rr++) {
        var gr = Me.charCodeAt(rr), or = gr >> 8, _r = gr & 255;
        or ? ne.push(or, _r) : ne.push(_r);
      }
    return ne;
  }
  c.toArray = ie;
  function we(Me) {
    return Me.length === 1 ? "0" + Me : Me;
  }
  c.zero2 = we;
  function $e(Me) {
    for (var Ze = "", ne = 0; ne < Me.length; ne++)
      Ze += we(Me[ne].toString(16));
    return Ze;
  }
  c.toHex = $e, c.encode = function(Ze, ne) {
    return ne === "hex" ? $e(Ze) : Ze;
  };
})(utils$n);
(function(m) {
  var c = m, ie = bn$3.exports, we = minimalisticAssert, $e = utils$n;
  c.assert = we, c.toArray = $e.toArray, c.zero2 = $e.zero2, c.toHex = $e.toHex, c.encode = $e.encode;
  function Me(or, _r, Lr) {
    var Ir = new Array(Math.max(or.bitLength(), Lr) + 1), Ar;
    for (Ar = 0; Ar < Ir.length; Ar += 1)
      Ir[Ar] = 0;
    var Rr = 1 << _r + 1, Nr = or.clone();
    for (Ar = 0; Ar < Ir.length; Ar++) {
      var Yr, Vr = Nr.andln(Rr - 1);
      Nr.isOdd() ? (Vr > (Rr >> 1) - 1 ? Yr = (Rr >> 1) - Vr : Yr = Vr, Nr.isubn(Yr)) : Yr = 0, Ir[Ar] = Yr, Nr.iushrn(1);
    }
    return Ir;
  }
  c.getNAF = Me;
  function Ze(or, _r) {
    var Lr = [
      [],
      []
    ];
    or = or.clone(), _r = _r.clone();
    for (var Ir = 0, Ar = 0, Rr; or.cmpn(-Ir) > 0 || _r.cmpn(-Ar) > 0; ) {
      var Nr = or.andln(3) + Ir & 3, Yr = _r.andln(3) + Ar & 3;
      Nr === 3 && (Nr = -1), Yr === 3 && (Yr = -1);
      var Vr;
      (Nr & 1) === 0 ? Vr = 0 : (Rr = or.andln(7) + Ir & 7, (Rr === 3 || Rr === 5) && Yr === 2 ? Vr = -Nr : Vr = Nr), Lr[0].push(Vr);
      var Xr;
      (Yr & 1) === 0 ? Xr = 0 : (Rr = _r.andln(7) + Ar & 7, (Rr === 3 || Rr === 5) && Nr === 2 ? Xr = -Yr : Xr = Yr), Lr[1].push(Xr), 2 * Ir === Vr + 1 && (Ir = 1 - Ir), 2 * Ar === Xr + 1 && (Ar = 1 - Ar), or.iushrn(1), _r.iushrn(1);
    }
    return Lr;
  }
  c.getJSF = Ze;
  function ne(or, _r, Lr) {
    var Ir = "_" + _r;
    or.prototype[_r] = function() {
      return this[Ir] !== void 0 ? this[Ir] : this[Ir] = Lr.call(this);
    };
  }
  c.cachedProperty = ne;
  function rr(or) {
    return typeof or == "string" ? c.toArray(or, "hex") : or;
  }
  c.parseBytes = rr;
  function gr(or) {
    return new ie(or, "hex", "le");
  }
  c.intFromLE = gr;
})(utils$o);
var curve = {}, BN$9 = bn$3.exports, utils$m = utils$o, getNAF = utils$m.getNAF, getJSF = utils$m.getJSF, assert$d = utils$m.assert;
function BaseCurve(m, c) {
  this.type = m, this.p = new BN$9(c.p, 16), this.red = c.prime ? BN$9.red(c.prime) : BN$9.mont(this.p), this.zero = new BN$9(0).toRed(this.red), this.one = new BN$9(1).toRed(this.red), this.two = new BN$9(2).toRed(this.red), this.n = c.n && new BN$9(c.n, 16), this.g = c.g && this.pointFromJSON(c.g, c.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var ie = this.n && this.p.div(this.n);
  !ie || ie.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var base$1 = BaseCurve;
BaseCurve.prototype.point = function() {
  throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function() {
  throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function(c, ie) {
  assert$d(c.precomputed);
  var we = c._getDoubles(), $e = getNAF(ie, 1, this._bitLength), Me = (1 << we.step + 1) - (we.step % 2 === 0 ? 2 : 1);
  Me /= 3;
  var Ze = [], ne, rr;
  for (ne = 0; ne < $e.length; ne += we.step) {
    rr = 0;
    for (var gr = ne + we.step - 1; gr >= ne; gr--)
      rr = (rr << 1) + $e[gr];
    Ze.push(rr);
  }
  for (var or = this.jpoint(null, null, null), _r = this.jpoint(null, null, null), Lr = Me; Lr > 0; Lr--) {
    for (ne = 0; ne < Ze.length; ne++)
      rr = Ze[ne], rr === Lr ? _r = _r.mixedAdd(we.points[ne]) : rr === -Lr && (_r = _r.mixedAdd(we.points[ne].neg()));
    or = or.add(_r);
  }
  return or.toP();
};
BaseCurve.prototype._wnafMul = function(c, ie) {
  var we = 4, $e = c._getNAFPoints(we);
  we = $e.wnd;
  for (var Me = $e.points, Ze = getNAF(ie, we, this._bitLength), ne = this.jpoint(null, null, null), rr = Ze.length - 1; rr >= 0; rr--) {
    for (var gr = 0; rr >= 0 && Ze[rr] === 0; rr--)
      gr++;
    if (rr >= 0 && gr++, ne = ne.dblp(gr), rr < 0)
      break;
    var or = Ze[rr];
    assert$d(or !== 0), c.type === "affine" ? or > 0 ? ne = ne.mixedAdd(Me[or - 1 >> 1]) : ne = ne.mixedAdd(Me[-or - 1 >> 1].neg()) : or > 0 ? ne = ne.add(Me[or - 1 >> 1]) : ne = ne.add(Me[-or - 1 >> 1].neg());
  }
  return c.type === "affine" ? ne.toP() : ne;
};
BaseCurve.prototype._wnafMulAdd = function(c, ie, we, $e, Me) {
  var Ze = this._wnafT1, ne = this._wnafT2, rr = this._wnafT3, gr = 0, or, _r, Lr;
  for (or = 0; or < $e; or++) {
    Lr = ie[or];
    var Ir = Lr._getNAFPoints(c);
    Ze[or] = Ir.wnd, ne[or] = Ir.points;
  }
  for (or = $e - 1; or >= 1; or -= 2) {
    var Ar = or - 1, Rr = or;
    if (Ze[Ar] !== 1 || Ze[Rr] !== 1) {
      rr[Ar] = getNAF(we[Ar], Ze[Ar], this._bitLength), rr[Rr] = getNAF(we[Rr], Ze[Rr], this._bitLength), gr = Math.max(rr[Ar].length, gr), gr = Math.max(rr[Rr].length, gr);
      continue;
    }
    var Nr = [
      ie[Ar],
      null,
      null,
      ie[Rr]
    ];
    ie[Ar].y.cmp(ie[Rr].y) === 0 ? (Nr[1] = ie[Ar].add(ie[Rr]), Nr[2] = ie[Ar].toJ().mixedAdd(ie[Rr].neg())) : ie[Ar].y.cmp(ie[Rr].y.redNeg()) === 0 ? (Nr[1] = ie[Ar].toJ().mixedAdd(ie[Rr]), Nr[2] = ie[Ar].add(ie[Rr].neg())) : (Nr[1] = ie[Ar].toJ().mixedAdd(ie[Rr]), Nr[2] = ie[Ar].toJ().mixedAdd(ie[Rr].neg()));
    var Yr = [
      -3,
      -1,
      -5,
      -7,
      0,
      7,
      5,
      1,
      3
    ], Vr = getJSF(we[Ar], we[Rr]);
    for (gr = Math.max(Vr[0].length, gr), rr[Ar] = new Array(gr), rr[Rr] = new Array(gr), _r = 0; _r < gr; _r++) {
      var Xr = Vr[0][_r] | 0, Wr = Vr[1][_r] | 0;
      rr[Ar][_r] = Yr[(Xr + 1) * 3 + (Wr + 1)], rr[Rr][_r] = 0, ne[Ar] = Nr;
    }
  }
  var si = this.jpoint(null, null, null), li = this._wnafT4;
  for (or = gr; or >= 0; or--) {
    for (var xi = 0; or >= 0; ) {
      var di = !0;
      for (_r = 0; _r < $e; _r++)
        li[_r] = rr[_r][or] | 0, li[_r] !== 0 && (di = !1);
      if (!di)
        break;
      xi++, or--;
    }
    if (or >= 0 && xi++, si = si.dblp(xi), or < 0)
      break;
    for (_r = 0; _r < $e; _r++) {
      var oi = li[_r];
      oi !== 0 && (oi > 0 ? Lr = ne[_r][oi - 1 >> 1] : oi < 0 && (Lr = ne[_r][-oi - 1 >> 1].neg()), Lr.type === "affine" ? si = si.mixedAdd(Lr) : si = si.add(Lr));
    }
  }
  for (or = 0; or < $e; or++)
    ne[or] = null;
  return Me ? si : si.toP();
};
function BasePoint(m, c) {
  this.curve = m, this.type = c, this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function() {
  throw new Error("Not implemented");
};
BasePoint.prototype.validate = function() {
  return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function(c, ie) {
  c = utils$m.toArray(c, ie);
  var we = this.p.byteLength();
  if ((c[0] === 4 || c[0] === 6 || c[0] === 7) && c.length - 1 === 2 * we) {
    c[0] === 6 ? assert$d(c[c.length - 1] % 2 === 0) : c[0] === 7 && assert$d(c[c.length - 1] % 2 === 1);
    var $e = this.point(
      c.slice(1, 1 + we),
      c.slice(1 + we, 1 + 2 * we)
    );
    return $e;
  } else if ((c[0] === 2 || c[0] === 3) && c.length - 1 === we)
    return this.pointFromX(c.slice(1, 1 + we), c[0] === 3);
  throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function(c) {
  return this.encode(c, !0);
};
BasePoint.prototype._encode = function(c) {
  var ie = this.curve.p.byteLength(), we = this.getX().toArray("be", ie);
  return c ? [this.getY().isEven() ? 2 : 3].concat(we) : [4].concat(we, this.getY().toArray("be", ie));
};
BasePoint.prototype.encode = function(c, ie) {
  return utils$m.encode(this._encode(ie), c);
};
BasePoint.prototype.precompute = function(c) {
  if (this.precomputed)
    return this;
  var ie = {
    doubles: null,
    naf: null,
    beta: null
  };
  return ie.naf = this._getNAFPoints(8), ie.doubles = this._getDoubles(4, c), ie.beta = this._getBeta(), this.precomputed = ie, this;
};
BasePoint.prototype._hasDoubles = function(c) {
  if (!this.precomputed)
    return !1;
  var ie = this.precomputed.doubles;
  return ie ? ie.points.length >= Math.ceil((c.bitLength() + 1) / ie.step) : !1;
};
BasePoint.prototype._getDoubles = function(c, ie) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var we = [this], $e = this, Me = 0; Me < ie; Me += c) {
    for (var Ze = 0; Ze < c; Ze++)
      $e = $e.dbl();
    we.push($e);
  }
  return {
    step: c,
    points: we
  };
};
BasePoint.prototype._getNAFPoints = function(c) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var ie = [this], we = (1 << c) - 1, $e = we === 1 ? null : this.dbl(), Me = 1; Me < we; Me++)
    ie[Me] = ie[Me - 1].add($e);
  return {
    wnd: c,
    points: ie
  };
};
BasePoint.prototype._getBeta = function() {
  return null;
};
BasePoint.prototype.dblp = function(c) {
  for (var ie = this, we = 0; we < c; we++)
    ie = ie.dbl();
  return ie;
};
var utils$l = utils$o, BN$8 = bn$3.exports, inherits$6 = inherits_browser.exports, Base$4 = base$1, assert$c = utils$l.assert;
function ShortCurve(m) {
  Base$4.call(this, "short", m), this.a = new BN$8(m.a, 16).toRed(this.red), this.b = new BN$8(m.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(m), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
inherits$6(ShortCurve, Base$4);
var short = ShortCurve;
ShortCurve.prototype._getEndomorphism = function(c) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var ie, we;
    if (c.beta)
      ie = new BN$8(c.beta, 16).toRed(this.red);
    else {
      var $e = this._getEndoRoots(this.p);
      ie = $e[0].cmp($e[1]) < 0 ? $e[0] : $e[1], ie = ie.toRed(this.red);
    }
    if (c.lambda)
      we = new BN$8(c.lambda, 16);
    else {
      var Me = this._getEndoRoots(this.n);
      this.g.mul(Me[0]).x.cmp(this.g.x.redMul(ie)) === 0 ? we = Me[0] : (we = Me[1], assert$c(this.g.mul(we).x.cmp(this.g.x.redMul(ie)) === 0));
    }
    var Ze;
    return c.basis ? Ze = c.basis.map(function(ne) {
      return {
        a: new BN$8(ne.a, 16),
        b: new BN$8(ne.b, 16)
      };
    }) : Ze = this._getEndoBasis(we), {
      beta: ie,
      lambda: we,
      basis: Ze
    };
  }
};
ShortCurve.prototype._getEndoRoots = function(c) {
  var ie = c === this.p ? this.red : BN$8.mont(c), we = new BN$8(2).toRed(ie).redInvm(), $e = we.redNeg(), Me = new BN$8(3).toRed(ie).redNeg().redSqrt().redMul(we), Ze = $e.redAdd(Me).fromRed(), ne = $e.redSub(Me).fromRed();
  return [Ze, ne];
};
ShortCurve.prototype._getEndoBasis = function(c) {
  for (var ie = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), we = c, $e = this.n.clone(), Me = new BN$8(1), Ze = new BN$8(0), ne = new BN$8(0), rr = new BN$8(1), gr, or, _r, Lr, Ir, Ar, Rr, Nr = 0, Yr, Vr; we.cmpn(0) !== 0; ) {
    var Xr = $e.div(we);
    Yr = $e.sub(Xr.mul(we)), Vr = ne.sub(Xr.mul(Me));
    var Wr = rr.sub(Xr.mul(Ze));
    if (!_r && Yr.cmp(ie) < 0)
      gr = Rr.neg(), or = Me, _r = Yr.neg(), Lr = Vr;
    else if (_r && ++Nr === 2)
      break;
    Rr = Yr, $e = we, we = Yr, ne = Me, Me = Vr, rr = Ze, Ze = Wr;
  }
  Ir = Yr.neg(), Ar = Vr;
  var si = _r.sqr().add(Lr.sqr()), li = Ir.sqr().add(Ar.sqr());
  return li.cmp(si) >= 0 && (Ir = gr, Ar = or), _r.negative && (_r = _r.neg(), Lr = Lr.neg()), Ir.negative && (Ir = Ir.neg(), Ar = Ar.neg()), [
    { a: _r, b: Lr },
    { a: Ir, b: Ar }
  ];
};
ShortCurve.prototype._endoSplit = function(c) {
  var ie = this.endo.basis, we = ie[0], $e = ie[1], Me = $e.b.mul(c).divRound(this.n), Ze = we.b.neg().mul(c).divRound(this.n), ne = Me.mul(we.a), rr = Ze.mul($e.a), gr = Me.mul(we.b), or = Ze.mul($e.b), _r = c.sub(ne).sub(rr), Lr = gr.add(or).neg();
  return { k1: _r, k2: Lr };
};
ShortCurve.prototype.pointFromX = function(c, ie) {
  c = new BN$8(c, 16), c.red || (c = c.toRed(this.red));
  var we = c.redSqr().redMul(c).redIAdd(c.redMul(this.a)).redIAdd(this.b), $e = we.redSqrt();
  if ($e.redSqr().redSub(we).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var Me = $e.fromRed().isOdd();
  return (ie && !Me || !ie && Me) && ($e = $e.redNeg()), this.point(c, $e);
};
ShortCurve.prototype.validate = function(c) {
  if (c.inf)
    return !0;
  var ie = c.x, we = c.y, $e = this.a.redMul(ie), Me = ie.redSqr().redMul(ie).redIAdd($e).redIAdd(this.b);
  return we.redSqr().redISub(Me).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function(c, ie, we) {
  for (var $e = this._endoWnafT1, Me = this._endoWnafT2, Ze = 0; Ze < c.length; Ze++) {
    var ne = this._endoSplit(ie[Ze]), rr = c[Ze], gr = rr._getBeta();
    ne.k1.negative && (ne.k1.ineg(), rr = rr.neg(!0)), ne.k2.negative && (ne.k2.ineg(), gr = gr.neg(!0)), $e[Ze * 2] = rr, $e[Ze * 2 + 1] = gr, Me[Ze * 2] = ne.k1, Me[Ze * 2 + 1] = ne.k2;
  }
  for (var or = this._wnafMulAdd(1, $e, Me, Ze * 2, we), _r = 0; _r < Ze * 2; _r++)
    $e[_r] = null, Me[_r] = null;
  return or;
};
function Point$2(m, c, ie, we) {
  Base$4.BasePoint.call(this, m, "affine"), c === null && ie === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new BN$8(c, 16), this.y = new BN$8(ie, 16), we && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
inherits$6(Point$2, Base$4.BasePoint);
ShortCurve.prototype.point = function(c, ie, we) {
  return new Point$2(this, c, ie, we);
};
ShortCurve.prototype.pointFromJSON = function(c, ie) {
  return Point$2.fromJSON(this, c, ie);
};
Point$2.prototype._getBeta = function() {
  if (!!this.curve.endo) {
    var c = this.precomputed;
    if (c && c.beta)
      return c.beta;
    var ie = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (c) {
      var we = this.curve, $e = function(Me) {
        return we.point(Me.x.redMul(we.endo.beta), Me.y);
      };
      c.beta = ie, ie.precomputed = {
        beta: null,
        naf: c.naf && {
          wnd: c.naf.wnd,
          points: c.naf.points.map($e)
        },
        doubles: c.doubles && {
          step: c.doubles.step,
          points: c.doubles.points.map($e)
        }
      };
    }
    return ie;
  }
};
Point$2.prototype.toJSON = function() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Point$2.fromJSON = function(c, ie, we) {
  typeof ie == "string" && (ie = JSON.parse(ie));
  var $e = c.point(ie[0], ie[1], we);
  if (!ie[2])
    return $e;
  function Me(ne) {
    return c.point(ne[0], ne[1], we);
  }
  var Ze = ie[2];
  return $e.precomputed = {
    beta: null,
    doubles: Ze.doubles && {
      step: Ze.doubles.step,
      points: [$e].concat(Ze.doubles.points.map(Me))
    },
    naf: Ze.naf && {
      wnd: Ze.naf.wnd,
      points: [$e].concat(Ze.naf.points.map(Me))
    }
  }, $e;
};
Point$2.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point$2.prototype.isInfinity = function() {
  return this.inf;
};
Point$2.prototype.add = function(c) {
  if (this.inf)
    return c;
  if (c.inf)
    return this;
  if (this.eq(c))
    return this.dbl();
  if (this.neg().eq(c))
    return this.curve.point(null, null);
  if (this.x.cmp(c.x) === 0)
    return this.curve.point(null, null);
  var ie = this.y.redSub(c.y);
  ie.cmpn(0) !== 0 && (ie = ie.redMul(this.x.redSub(c.x).redInvm()));
  var we = ie.redSqr().redISub(this.x).redISub(c.x), $e = ie.redMul(this.x.redSub(we)).redISub(this.y);
  return this.curve.point(we, $e);
};
Point$2.prototype.dbl = function() {
  if (this.inf)
    return this;
  var c = this.y.redAdd(this.y);
  if (c.cmpn(0) === 0)
    return this.curve.point(null, null);
  var ie = this.curve.a, we = this.x.redSqr(), $e = c.redInvm(), Me = we.redAdd(we).redIAdd(we).redIAdd(ie).redMul($e), Ze = Me.redSqr().redISub(this.x.redAdd(this.x)), ne = Me.redMul(this.x.redSub(Ze)).redISub(this.y);
  return this.curve.point(Ze, ne);
};
Point$2.prototype.getX = function() {
  return this.x.fromRed();
};
Point$2.prototype.getY = function() {
  return this.y.fromRed();
};
Point$2.prototype.mul = function(c) {
  return c = new BN$8(c, 16), this.isInfinity() ? this : this._hasDoubles(c) ? this.curve._fixedNafMul(this, c) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [c]) : this.curve._wnafMul(this, c);
};
Point$2.prototype.mulAdd = function(c, ie, we) {
  var $e = [this, ie], Me = [c, we];
  return this.curve.endo ? this.curve._endoWnafMulAdd($e, Me) : this.curve._wnafMulAdd(1, $e, Me, 2);
};
Point$2.prototype.jmulAdd = function(c, ie, we) {
  var $e = [this, ie], Me = [c, we];
  return this.curve.endo ? this.curve._endoWnafMulAdd($e, Me, !0) : this.curve._wnafMulAdd(1, $e, Me, 2, !0);
};
Point$2.prototype.eq = function(c) {
  return this === c || this.inf === c.inf && (this.inf || this.x.cmp(c.x) === 0 && this.y.cmp(c.y) === 0);
};
Point$2.prototype.neg = function(c) {
  if (this.inf)
    return this;
  var ie = this.curve.point(this.x, this.y.redNeg());
  if (c && this.precomputed) {
    var we = this.precomputed, $e = function(Me) {
      return Me.neg();
    };
    ie.precomputed = {
      naf: we.naf && {
        wnd: we.naf.wnd,
        points: we.naf.points.map($e)
      },
      doubles: we.doubles && {
        step: we.doubles.step,
        points: we.doubles.points.map($e)
      }
    };
  }
  return ie;
};
Point$2.prototype.toJ = function() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var c = this.curve.jpoint(this.x, this.y, this.curve.one);
  return c;
};
function JPoint(m, c, ie, we) {
  Base$4.BasePoint.call(this, m, "jacobian"), c === null && ie === null && we === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$8(0)) : (this.x = new BN$8(c, 16), this.y = new BN$8(ie, 16), this.z = new BN$8(we, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
inherits$6(JPoint, Base$4.BasePoint);
ShortCurve.prototype.jpoint = function(c, ie, we) {
  return new JPoint(this, c, ie, we);
};
JPoint.prototype.toP = function() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var c = this.z.redInvm(), ie = c.redSqr(), we = this.x.redMul(ie), $e = this.y.redMul(ie).redMul(c);
  return this.curve.point(we, $e);
};
JPoint.prototype.neg = function() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function(c) {
  if (this.isInfinity())
    return c;
  if (c.isInfinity())
    return this;
  var ie = c.z.redSqr(), we = this.z.redSqr(), $e = this.x.redMul(ie), Me = c.x.redMul(we), Ze = this.y.redMul(ie.redMul(c.z)), ne = c.y.redMul(we.redMul(this.z)), rr = $e.redSub(Me), gr = Ze.redSub(ne);
  if (rr.cmpn(0) === 0)
    return gr.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var or = rr.redSqr(), _r = or.redMul(rr), Lr = $e.redMul(or), Ir = gr.redSqr().redIAdd(_r).redISub(Lr).redISub(Lr), Ar = gr.redMul(Lr.redISub(Ir)).redISub(Ze.redMul(_r)), Rr = this.z.redMul(c.z).redMul(rr);
  return this.curve.jpoint(Ir, Ar, Rr);
};
JPoint.prototype.mixedAdd = function(c) {
  if (this.isInfinity())
    return c.toJ();
  if (c.isInfinity())
    return this;
  var ie = this.z.redSqr(), we = this.x, $e = c.x.redMul(ie), Me = this.y, Ze = c.y.redMul(ie).redMul(this.z), ne = we.redSub($e), rr = Me.redSub(Ze);
  if (ne.cmpn(0) === 0)
    return rr.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var gr = ne.redSqr(), or = gr.redMul(ne), _r = we.redMul(gr), Lr = rr.redSqr().redIAdd(or).redISub(_r).redISub(_r), Ir = rr.redMul(_r.redISub(Lr)).redISub(Me.redMul(or)), Ar = this.z.redMul(ne);
  return this.curve.jpoint(Lr, Ir, Ar);
};
JPoint.prototype.dblp = function(c) {
  if (c === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!c)
    return this.dbl();
  var ie;
  if (this.curve.zeroA || this.curve.threeA) {
    var we = this;
    for (ie = 0; ie < c; ie++)
      we = we.dbl();
    return we;
  }
  var $e = this.curve.a, Me = this.curve.tinv, Ze = this.x, ne = this.y, rr = this.z, gr = rr.redSqr().redSqr(), or = ne.redAdd(ne);
  for (ie = 0; ie < c; ie++) {
    var _r = Ze.redSqr(), Lr = or.redSqr(), Ir = Lr.redSqr(), Ar = _r.redAdd(_r).redIAdd(_r).redIAdd($e.redMul(gr)), Rr = Ze.redMul(Lr), Nr = Ar.redSqr().redISub(Rr.redAdd(Rr)), Yr = Rr.redISub(Nr), Vr = Ar.redMul(Yr);
    Vr = Vr.redIAdd(Vr).redISub(Ir);
    var Xr = or.redMul(rr);
    ie + 1 < c && (gr = gr.redMul(Ir)), Ze = Nr, rr = Xr, or = Vr;
  }
  return this.curve.jpoint(Ze, or.redMul(Me), rr);
};
JPoint.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
JPoint.prototype._zeroDbl = function() {
  var c, ie, we;
  if (this.zOne) {
    var $e = this.x.redSqr(), Me = this.y.redSqr(), Ze = Me.redSqr(), ne = this.x.redAdd(Me).redSqr().redISub($e).redISub(Ze);
    ne = ne.redIAdd(ne);
    var rr = $e.redAdd($e).redIAdd($e), gr = rr.redSqr().redISub(ne).redISub(ne), or = Ze.redIAdd(Ze);
    or = or.redIAdd(or), or = or.redIAdd(or), c = gr, ie = rr.redMul(ne.redISub(gr)).redISub(or), we = this.y.redAdd(this.y);
  } else {
    var _r = this.x.redSqr(), Lr = this.y.redSqr(), Ir = Lr.redSqr(), Ar = this.x.redAdd(Lr).redSqr().redISub(_r).redISub(Ir);
    Ar = Ar.redIAdd(Ar);
    var Rr = _r.redAdd(_r).redIAdd(_r), Nr = Rr.redSqr(), Yr = Ir.redIAdd(Ir);
    Yr = Yr.redIAdd(Yr), Yr = Yr.redIAdd(Yr), c = Nr.redISub(Ar).redISub(Ar), ie = Rr.redMul(Ar.redISub(c)).redISub(Yr), we = this.y.redMul(this.z), we = we.redIAdd(we);
  }
  return this.curve.jpoint(c, ie, we);
};
JPoint.prototype._threeDbl = function() {
  var c, ie, we;
  if (this.zOne) {
    var $e = this.x.redSqr(), Me = this.y.redSqr(), Ze = Me.redSqr(), ne = this.x.redAdd(Me).redSqr().redISub($e).redISub(Ze);
    ne = ne.redIAdd(ne);
    var rr = $e.redAdd($e).redIAdd($e).redIAdd(this.curve.a), gr = rr.redSqr().redISub(ne).redISub(ne);
    c = gr;
    var or = Ze.redIAdd(Ze);
    or = or.redIAdd(or), or = or.redIAdd(or), ie = rr.redMul(ne.redISub(gr)).redISub(or), we = this.y.redAdd(this.y);
  } else {
    var _r = this.z.redSqr(), Lr = this.y.redSqr(), Ir = this.x.redMul(Lr), Ar = this.x.redSub(_r).redMul(this.x.redAdd(_r));
    Ar = Ar.redAdd(Ar).redIAdd(Ar);
    var Rr = Ir.redIAdd(Ir);
    Rr = Rr.redIAdd(Rr);
    var Nr = Rr.redAdd(Rr);
    c = Ar.redSqr().redISub(Nr), we = this.y.redAdd(this.z).redSqr().redISub(Lr).redISub(_r);
    var Yr = Lr.redSqr();
    Yr = Yr.redIAdd(Yr), Yr = Yr.redIAdd(Yr), Yr = Yr.redIAdd(Yr), ie = Ar.redMul(Rr.redISub(c)).redISub(Yr);
  }
  return this.curve.jpoint(c, ie, we);
};
JPoint.prototype._dbl = function() {
  var c = this.curve.a, ie = this.x, we = this.y, $e = this.z, Me = $e.redSqr().redSqr(), Ze = ie.redSqr(), ne = we.redSqr(), rr = Ze.redAdd(Ze).redIAdd(Ze).redIAdd(c.redMul(Me)), gr = ie.redAdd(ie);
  gr = gr.redIAdd(gr);
  var or = gr.redMul(ne), _r = rr.redSqr().redISub(or.redAdd(or)), Lr = or.redISub(_r), Ir = ne.redSqr();
  Ir = Ir.redIAdd(Ir), Ir = Ir.redIAdd(Ir), Ir = Ir.redIAdd(Ir);
  var Ar = rr.redMul(Lr).redISub(Ir), Rr = we.redAdd(we).redMul($e);
  return this.curve.jpoint(_r, Ar, Rr);
};
JPoint.prototype.trpl = function() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var c = this.x.redSqr(), ie = this.y.redSqr(), we = this.z.redSqr(), $e = ie.redSqr(), Me = c.redAdd(c).redIAdd(c), Ze = Me.redSqr(), ne = this.x.redAdd(ie).redSqr().redISub(c).redISub($e);
  ne = ne.redIAdd(ne), ne = ne.redAdd(ne).redIAdd(ne), ne = ne.redISub(Ze);
  var rr = ne.redSqr(), gr = $e.redIAdd($e);
  gr = gr.redIAdd(gr), gr = gr.redIAdd(gr), gr = gr.redIAdd(gr);
  var or = Me.redIAdd(ne).redSqr().redISub(Ze).redISub(rr).redISub(gr), _r = ie.redMul(or);
  _r = _r.redIAdd(_r), _r = _r.redIAdd(_r);
  var Lr = this.x.redMul(rr).redISub(_r);
  Lr = Lr.redIAdd(Lr), Lr = Lr.redIAdd(Lr);
  var Ir = this.y.redMul(or.redMul(gr.redISub(or)).redISub(ne.redMul(rr)));
  Ir = Ir.redIAdd(Ir), Ir = Ir.redIAdd(Ir), Ir = Ir.redIAdd(Ir);
  var Ar = this.z.redAdd(ne).redSqr().redISub(we).redISub(rr);
  return this.curve.jpoint(Lr, Ir, Ar);
};
JPoint.prototype.mul = function(c, ie) {
  return c = new BN$8(c, ie), this.curve._wnafMul(this, c);
};
JPoint.prototype.eq = function(c) {
  if (c.type === "affine")
    return this.eq(c.toJ());
  if (this === c)
    return !0;
  var ie = this.z.redSqr(), we = c.z.redSqr();
  if (this.x.redMul(we).redISub(c.x.redMul(ie)).cmpn(0) !== 0)
    return !1;
  var $e = ie.redMul(this.z), Me = we.redMul(c.z);
  return this.y.redMul(Me).redISub(c.y.redMul($e)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function(c) {
  var ie = this.z.redSqr(), we = c.toRed(this.curve.red).redMul(ie);
  if (this.x.cmp(we) === 0)
    return !0;
  for (var $e = c.clone(), Me = this.curve.redN.redMul(ie); ; ) {
    if ($e.iadd(this.curve.n), $e.cmp(this.curve.p) >= 0)
      return !1;
    if (we.redIAdd(Me), this.x.cmp(we) === 0)
      return !0;
  }
};
JPoint.prototype.inspect = function() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
var BN$7 = bn$3.exports, inherits$5 = inherits_browser.exports, Base$3 = base$1, utils$k = utils$o;
function MontCurve(m) {
  Base$3.call(this, "mont", m), this.a = new BN$7(m.a, 16).toRed(this.red), this.b = new BN$7(m.b, 16).toRed(this.red), this.i4 = new BN$7(4).toRed(this.red).redInvm(), this.two = new BN$7(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits$5(MontCurve, Base$3);
var mont = MontCurve;
MontCurve.prototype.validate = function(c) {
  var ie = c.normalize().x, we = ie.redSqr(), $e = we.redMul(ie).redAdd(we.redMul(this.a)).redAdd(ie), Me = $e.redSqrt();
  return Me.redSqr().cmp($e) === 0;
};
function Point$1(m, c, ie) {
  Base$3.BasePoint.call(this, m, "projective"), c === null && ie === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new BN$7(c, 16), this.z = new BN$7(ie, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
}
inherits$5(Point$1, Base$3.BasePoint);
MontCurve.prototype.decodePoint = function(c, ie) {
  return this.point(utils$k.toArray(c, ie), 1);
};
MontCurve.prototype.point = function(c, ie) {
  return new Point$1(this, c, ie);
};
MontCurve.prototype.pointFromJSON = function(c) {
  return Point$1.fromJSON(this, c);
};
Point$1.prototype.precompute = function() {
};
Point$1.prototype._encode = function() {
  return this.getX().toArray("be", this.curve.p.byteLength());
};
Point$1.fromJSON = function(c, ie) {
  return new Point$1(c, ie[0], ie[1] || c.one);
};
Point$1.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point$1.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
Point$1.prototype.dbl = function() {
  var c = this.x.redAdd(this.z), ie = c.redSqr(), we = this.x.redSub(this.z), $e = we.redSqr(), Me = ie.redSub($e), Ze = ie.redMul($e), ne = Me.redMul($e.redAdd(this.curve.a24.redMul(Me)));
  return this.curve.point(Ze, ne);
};
Point$1.prototype.add = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.diffAdd = function(c, ie) {
  var we = this.x.redAdd(this.z), $e = this.x.redSub(this.z), Me = c.x.redAdd(c.z), Ze = c.x.redSub(c.z), ne = Ze.redMul(we), rr = Me.redMul($e), gr = ie.z.redMul(ne.redAdd(rr).redSqr()), or = ie.x.redMul(ne.redISub(rr).redSqr());
  return this.curve.point(gr, or);
};
Point$1.prototype.mul = function(c) {
  for (var ie = c.clone(), we = this, $e = this.curve.point(null, null), Me = this, Ze = []; ie.cmpn(0) !== 0; ie.iushrn(1))
    Ze.push(ie.andln(1));
  for (var ne = Ze.length - 1; ne >= 0; ne--)
    Ze[ne] === 0 ? (we = we.diffAdd($e, Me), $e = $e.dbl()) : ($e = we.diffAdd($e, Me), we = we.dbl());
  return $e;
};
Point$1.prototype.mulAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.jumlAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.eq = function(c) {
  return this.getX().cmp(c.getX()) === 0;
};
Point$1.prototype.normalize = function() {
  return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
};
Point$1.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
var utils$j = utils$o, BN$6 = bn$3.exports, inherits$4 = inherits_browser.exports, Base$2 = base$1, assert$b = utils$j.assert;
function EdwardsCurve(m) {
  this.twisted = (m.a | 0) !== 1, this.mOneA = this.twisted && (m.a | 0) === -1, this.extended = this.mOneA, Base$2.call(this, "edwards", m), this.a = new BN$6(m.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new BN$6(m.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new BN$6(m.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), assert$b(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (m.c | 0) === 1;
}
inherits$4(EdwardsCurve, Base$2);
var edwards = EdwardsCurve;
EdwardsCurve.prototype._mulA = function(c) {
  return this.mOneA ? c.redNeg() : this.a.redMul(c);
};
EdwardsCurve.prototype._mulC = function(c) {
  return this.oneC ? c : this.c.redMul(c);
};
EdwardsCurve.prototype.jpoint = function(c, ie, we, $e) {
  return this.point(c, ie, we, $e);
};
EdwardsCurve.prototype.pointFromX = function(c, ie) {
  c = new BN$6(c, 16), c.red || (c = c.toRed(this.red));
  var we = c.redSqr(), $e = this.c2.redSub(this.a.redMul(we)), Me = this.one.redSub(this.c2.redMul(this.d).redMul(we)), Ze = $e.redMul(Me.redInvm()), ne = Ze.redSqrt();
  if (ne.redSqr().redSub(Ze).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var rr = ne.fromRed().isOdd();
  return (ie && !rr || !ie && rr) && (ne = ne.redNeg()), this.point(c, ne);
};
EdwardsCurve.prototype.pointFromY = function(c, ie) {
  c = new BN$6(c, 16), c.red || (c = c.toRed(this.red));
  var we = c.redSqr(), $e = we.redSub(this.c2), Me = we.redMul(this.d).redMul(this.c2).redSub(this.a), Ze = $e.redMul(Me.redInvm());
  if (Ze.cmp(this.zero) === 0) {
    if (ie)
      throw new Error("invalid point");
    return this.point(this.zero, c);
  }
  var ne = Ze.redSqrt();
  if (ne.redSqr().redSub(Ze).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  return ne.fromRed().isOdd() !== ie && (ne = ne.redNeg()), this.point(ne, c);
};
EdwardsCurve.prototype.validate = function(c) {
  if (c.isInfinity())
    return !0;
  c.normalize();
  var ie = c.x.redSqr(), we = c.y.redSqr(), $e = ie.redMul(this.a).redAdd(we), Me = this.c2.redMul(this.one.redAdd(this.d.redMul(ie).redMul(we)));
  return $e.cmp(Me) === 0;
};
function Point(m, c, ie, we, $e) {
  Base$2.BasePoint.call(this, m, "projective"), c === null && ie === null && we === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new BN$6(c, 16), this.y = new BN$6(ie, 16), this.z = we ? new BN$6(we, 16) : this.curve.one, this.t = $e && new BN$6($e, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
}
inherits$4(Point, Base$2.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function(c) {
  return Point.fromJSON(this, c);
};
EdwardsCurve.prototype.point = function(c, ie, we, $e) {
  return new Point(this, c, ie, we, $e);
};
Point.fromJSON = function(c, ie) {
  return new Point(c, ie[0], ie[1], ie[2]);
};
Point.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function() {
  return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function() {
  var c = this.x.redSqr(), ie = this.y.redSqr(), we = this.z.redSqr();
  we = we.redIAdd(we);
  var $e = this.curve._mulA(c), Me = this.x.redAdd(this.y).redSqr().redISub(c).redISub(ie), Ze = $e.redAdd(ie), ne = Ze.redSub(we), rr = $e.redSub(ie), gr = Me.redMul(ne), or = Ze.redMul(rr), _r = Me.redMul(rr), Lr = ne.redMul(Ze);
  return this.curve.point(gr, or, Lr, _r);
};
Point.prototype._projDbl = function() {
  var c = this.x.redAdd(this.y).redSqr(), ie = this.x.redSqr(), we = this.y.redSqr(), $e, Me, Ze, ne, rr, gr;
  if (this.curve.twisted) {
    ne = this.curve._mulA(ie);
    var or = ne.redAdd(we);
    this.zOne ? ($e = c.redSub(ie).redSub(we).redMul(or.redSub(this.curve.two)), Me = or.redMul(ne.redSub(we)), Ze = or.redSqr().redSub(or).redSub(or)) : (rr = this.z.redSqr(), gr = or.redSub(rr).redISub(rr), $e = c.redSub(ie).redISub(we).redMul(gr), Me = or.redMul(ne.redSub(we)), Ze = or.redMul(gr));
  } else
    ne = ie.redAdd(we), rr = this.curve._mulC(this.z).redSqr(), gr = ne.redSub(rr).redSub(rr), $e = this.curve._mulC(c.redISub(ne)).redMul(gr), Me = this.curve._mulC(ne).redMul(ie.redISub(we)), Ze = ne.redMul(gr);
  return this.curve.point($e, Me, Ze);
};
Point.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
};
Point.prototype._extAdd = function(c) {
  var ie = this.y.redSub(this.x).redMul(c.y.redSub(c.x)), we = this.y.redAdd(this.x).redMul(c.y.redAdd(c.x)), $e = this.t.redMul(this.curve.dd).redMul(c.t), Me = this.z.redMul(c.z.redAdd(c.z)), Ze = we.redSub(ie), ne = Me.redSub($e), rr = Me.redAdd($e), gr = we.redAdd(ie), or = Ze.redMul(ne), _r = rr.redMul(gr), Lr = Ze.redMul(gr), Ir = ne.redMul(rr);
  return this.curve.point(or, _r, Ir, Lr);
};
Point.prototype._projAdd = function(c) {
  var ie = this.z.redMul(c.z), we = ie.redSqr(), $e = this.x.redMul(c.x), Me = this.y.redMul(c.y), Ze = this.curve.d.redMul($e).redMul(Me), ne = we.redSub(Ze), rr = we.redAdd(Ze), gr = this.x.redAdd(this.y).redMul(c.x.redAdd(c.y)).redISub($e).redISub(Me), or = ie.redMul(ne).redMul(gr), _r, Lr;
  return this.curve.twisted ? (_r = ie.redMul(rr).redMul(Me.redSub(this.curve._mulA($e))), Lr = ne.redMul(rr)) : (_r = ie.redMul(rr).redMul(Me.redSub($e)), Lr = this.curve._mulC(ne).redMul(rr)), this.curve.point(or, _r, Lr);
};
Point.prototype.add = function(c) {
  return this.isInfinity() ? c : c.isInfinity() ? this : this.curve.extended ? this._extAdd(c) : this._projAdd(c);
};
Point.prototype.mul = function(c) {
  return this._hasDoubles(c) ? this.curve._fixedNafMul(this, c) : this.curve._wnafMul(this, c);
};
Point.prototype.mulAdd = function(c, ie, we) {
  return this.curve._wnafMulAdd(1, [this, ie], [c, we], 2, !1);
};
Point.prototype.jmulAdd = function(c, ie, we) {
  return this.curve._wnafMulAdd(1, [this, ie], [c, we], 2, !0);
};
Point.prototype.normalize = function() {
  if (this.zOne)
    return this;
  var c = this.z.redInvm();
  return this.x = this.x.redMul(c), this.y = this.y.redMul(c), this.t && (this.t = this.t.redMul(c)), this.z = this.curve.one, this.zOne = !0, this;
};
Point.prototype.neg = function() {
  return this.curve.point(
    this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg()
  );
};
Point.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
Point.prototype.getY = function() {
  return this.normalize(), this.y.fromRed();
};
Point.prototype.eq = function(c) {
  return this === c || this.getX().cmp(c.getX()) === 0 && this.getY().cmp(c.getY()) === 0;
};
Point.prototype.eqXToP = function(c) {
  var ie = c.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(ie) === 0)
    return !0;
  for (var we = c.clone(), $e = this.curve.redN.redMul(this.z); ; ) {
    if (we.iadd(this.curve.n), we.cmp(this.curve.p) >= 0)
      return !1;
    if (ie.redIAdd($e), this.x.cmp(ie) === 0)
      return !0;
  }
};
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;
(function(m) {
  var c = m;
  c.base = base$1, c.short = short, c.mont = mont, c.edwards = edwards;
})(curve);
var curves$1 = {}, hash$4 = {}, utils$i = {}, assert$a = minimalisticAssert, inherits$3 = inherits_browser.exports;
utils$i.inherits = inherits$3;
function isSurrogatePair(m, c) {
  return (m.charCodeAt(c) & 64512) !== 55296 || c < 0 || c + 1 >= m.length ? !1 : (m.charCodeAt(c + 1) & 64512) === 56320;
}
function toArray(m, c) {
  if (Array.isArray(m))
    return m.slice();
  if (!m)
    return [];
  var ie = [];
  if (typeof m == "string")
    if (c) {
      if (c === "hex")
        for (m = m.replace(/[^a-z0-9]+/ig, ""), m.length % 2 !== 0 && (m = "0" + m), $e = 0; $e < m.length; $e += 2)
          ie.push(parseInt(m[$e] + m[$e + 1], 16));
    } else
      for (var we = 0, $e = 0; $e < m.length; $e++) {
        var Me = m.charCodeAt($e);
        Me < 128 ? ie[we++] = Me : Me < 2048 ? (ie[we++] = Me >> 6 | 192, ie[we++] = Me & 63 | 128) : isSurrogatePair(m, $e) ? (Me = 65536 + ((Me & 1023) << 10) + (m.charCodeAt(++$e) & 1023), ie[we++] = Me >> 18 | 240, ie[we++] = Me >> 12 & 63 | 128, ie[we++] = Me >> 6 & 63 | 128, ie[we++] = Me & 63 | 128) : (ie[we++] = Me >> 12 | 224, ie[we++] = Me >> 6 & 63 | 128, ie[we++] = Me & 63 | 128);
      }
  else
    for ($e = 0; $e < m.length; $e++)
      ie[$e] = m[$e] | 0;
  return ie;
}
utils$i.toArray = toArray;
function toHex(m) {
  for (var c = "", ie = 0; ie < m.length; ie++)
    c += zero2(m[ie].toString(16));
  return c;
}
utils$i.toHex = toHex;
function htonl(m) {
  var c = m >>> 24 | m >>> 8 & 65280 | m << 8 & 16711680 | (m & 255) << 24;
  return c >>> 0;
}
utils$i.htonl = htonl;
function toHex32(m, c) {
  for (var ie = "", we = 0; we < m.length; we++) {
    var $e = m[we];
    c === "little" && ($e = htonl($e)), ie += zero8($e.toString(16));
  }
  return ie;
}
utils$i.toHex32 = toHex32;
function zero2(m) {
  return m.length === 1 ? "0" + m : m;
}
utils$i.zero2 = zero2;
function zero8(m) {
  return m.length === 7 ? "0" + m : m.length === 6 ? "00" + m : m.length === 5 ? "000" + m : m.length === 4 ? "0000" + m : m.length === 3 ? "00000" + m : m.length === 2 ? "000000" + m : m.length === 1 ? "0000000" + m : m;
}
utils$i.zero8 = zero8;
function join32(m, c, ie, we) {
  var $e = ie - c;
  assert$a($e % 4 === 0);
  for (var Me = new Array($e / 4), Ze = 0, ne = c; Ze < Me.length; Ze++, ne += 4) {
    var rr;
    we === "big" ? rr = m[ne] << 24 | m[ne + 1] << 16 | m[ne + 2] << 8 | m[ne + 3] : rr = m[ne + 3] << 24 | m[ne + 2] << 16 | m[ne + 1] << 8 | m[ne], Me[Ze] = rr >>> 0;
  }
  return Me;
}
utils$i.join32 = join32;
function split32(m, c) {
  for (var ie = new Array(m.length * 4), we = 0, $e = 0; we < m.length; we++, $e += 4) {
    var Me = m[we];
    c === "big" ? (ie[$e] = Me >>> 24, ie[$e + 1] = Me >>> 16 & 255, ie[$e + 2] = Me >>> 8 & 255, ie[$e + 3] = Me & 255) : (ie[$e + 3] = Me >>> 24, ie[$e + 2] = Me >>> 16 & 255, ie[$e + 1] = Me >>> 8 & 255, ie[$e] = Me & 255);
  }
  return ie;
}
utils$i.split32 = split32;
function rotr32$1(m, c) {
  return m >>> c | m << 32 - c;
}
utils$i.rotr32 = rotr32$1;
function rotl32$2(m, c) {
  return m << c | m >>> 32 - c;
}
utils$i.rotl32 = rotl32$2;
function sum32$3(m, c) {
  return m + c >>> 0;
}
utils$i.sum32 = sum32$3;
function sum32_3$1(m, c, ie) {
  return m + c + ie >>> 0;
}
utils$i.sum32_3 = sum32_3$1;
function sum32_4$2(m, c, ie, we) {
  return m + c + ie + we >>> 0;
}
utils$i.sum32_4 = sum32_4$2;
function sum32_5$2(m, c, ie, we, $e) {
  return m + c + ie + we + $e >>> 0;
}
utils$i.sum32_5 = sum32_5$2;
function sum64$1(m, c, ie, we) {
  var $e = m[c], Me = m[c + 1], Ze = we + Me >>> 0, ne = (Ze < we ? 1 : 0) + ie + $e;
  m[c] = ne >>> 0, m[c + 1] = Ze;
}
utils$i.sum64 = sum64$1;
function sum64_hi$1(m, c, ie, we) {
  var $e = c + we >>> 0, Me = ($e < c ? 1 : 0) + m + ie;
  return Me >>> 0;
}
utils$i.sum64_hi = sum64_hi$1;
function sum64_lo$1(m, c, ie, we) {
  var $e = c + we;
  return $e >>> 0;
}
utils$i.sum64_lo = sum64_lo$1;
function sum64_4_hi$1(m, c, ie, we, $e, Me, Ze, ne) {
  var rr = 0, gr = c;
  gr = gr + we >>> 0, rr += gr < c ? 1 : 0, gr = gr + Me >>> 0, rr += gr < Me ? 1 : 0, gr = gr + ne >>> 0, rr += gr < ne ? 1 : 0;
  var or = m + ie + $e + Ze + rr;
  return or >>> 0;
}
utils$i.sum64_4_hi = sum64_4_hi$1;
function sum64_4_lo$1(m, c, ie, we, $e, Me, Ze, ne) {
  var rr = c + we + Me + ne;
  return rr >>> 0;
}
utils$i.sum64_4_lo = sum64_4_lo$1;
function sum64_5_hi$1(m, c, ie, we, $e, Me, Ze, ne, rr, gr) {
  var or = 0, _r = c;
  _r = _r + we >>> 0, or += _r < c ? 1 : 0, _r = _r + Me >>> 0, or += _r < Me ? 1 : 0, _r = _r + ne >>> 0, or += _r < ne ? 1 : 0, _r = _r + gr >>> 0, or += _r < gr ? 1 : 0;
  var Lr = m + ie + $e + Ze + rr + or;
  return Lr >>> 0;
}
utils$i.sum64_5_hi = sum64_5_hi$1;
function sum64_5_lo$1(m, c, ie, we, $e, Me, Ze, ne, rr, gr) {
  var or = c + we + Me + ne + gr;
  return or >>> 0;
}
utils$i.sum64_5_lo = sum64_5_lo$1;
function rotr64_hi$1(m, c, ie) {
  var we = c << 32 - ie | m >>> ie;
  return we >>> 0;
}
utils$i.rotr64_hi = rotr64_hi$1;
function rotr64_lo$1(m, c, ie) {
  var we = m << 32 - ie | c >>> ie;
  return we >>> 0;
}
utils$i.rotr64_lo = rotr64_lo$1;
function shr64_hi$1(m, c, ie) {
  return m >>> ie;
}
utils$i.shr64_hi = shr64_hi$1;
function shr64_lo$1(m, c, ie) {
  var we = m << 32 - ie | c >>> ie;
  return we >>> 0;
}
utils$i.shr64_lo = shr64_lo$1;
var common$5 = {}, utils$h = utils$i, assert$9 = minimalisticAssert;
function BlockHash$4() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
common$5.BlockHash = BlockHash$4;
BlockHash$4.prototype.update = function(c, ie) {
  if (c = utils$h.toArray(c, ie), this.pending ? this.pending = this.pending.concat(c) : this.pending = c, this.pendingTotal += c.length, this.pending.length >= this._delta8) {
    c = this.pending;
    var we = c.length % this._delta8;
    this.pending = c.slice(c.length - we, c.length), this.pending.length === 0 && (this.pending = null), c = utils$h.join32(c, 0, c.length - we, this.endian);
    for (var $e = 0; $e < c.length; $e += this._delta32)
      this._update(c, $e, $e + this._delta32);
  }
  return this;
};
BlockHash$4.prototype.digest = function(c) {
  return this.update(this._pad()), assert$9(this.pending === null), this._digest(c);
};
BlockHash$4.prototype._pad = function() {
  var c = this.pendingTotal, ie = this._delta8, we = ie - (c + this.padLength) % ie, $e = new Array(we + this.padLength);
  $e[0] = 128;
  for (var Me = 1; Me < we; Me++)
    $e[Me] = 0;
  if (c <<= 3, this.endian === "big") {
    for (var Ze = 8; Ze < this.padLength; Ze++)
      $e[Me++] = 0;
    $e[Me++] = 0, $e[Me++] = 0, $e[Me++] = 0, $e[Me++] = 0, $e[Me++] = c >>> 24 & 255, $e[Me++] = c >>> 16 & 255, $e[Me++] = c >>> 8 & 255, $e[Me++] = c & 255;
  } else
    for ($e[Me++] = c & 255, $e[Me++] = c >>> 8 & 255, $e[Me++] = c >>> 16 & 255, $e[Me++] = c >>> 24 & 255, $e[Me++] = 0, $e[Me++] = 0, $e[Me++] = 0, $e[Me++] = 0, Ze = 8; Ze < this.padLength; Ze++)
      $e[Me++] = 0;
  return $e;
};
var sha = {}, common$4 = {}, utils$g = utils$i, rotr32 = utils$g.rotr32;
function ft_1$1(m, c, ie, we) {
  if (m === 0)
    return ch32$1(c, ie, we);
  if (m === 1 || m === 3)
    return p32(c, ie, we);
  if (m === 2)
    return maj32$1(c, ie, we);
}
common$4.ft_1 = ft_1$1;
function ch32$1(m, c, ie) {
  return m & c ^ ~m & ie;
}
common$4.ch32 = ch32$1;
function maj32$1(m, c, ie) {
  return m & c ^ m & ie ^ c & ie;
}
common$4.maj32 = maj32$1;
function p32(m, c, ie) {
  return m ^ c ^ ie;
}
common$4.p32 = p32;
function s0_256$1(m) {
  return rotr32(m, 2) ^ rotr32(m, 13) ^ rotr32(m, 22);
}
common$4.s0_256 = s0_256$1;
function s1_256$1(m) {
  return rotr32(m, 6) ^ rotr32(m, 11) ^ rotr32(m, 25);
}
common$4.s1_256 = s1_256$1;
function g0_256$1(m) {
  return rotr32(m, 7) ^ rotr32(m, 18) ^ m >>> 3;
}
common$4.g0_256 = g0_256$1;
function g1_256$1(m) {
  return rotr32(m, 17) ^ rotr32(m, 19) ^ m >>> 10;
}
common$4.g1_256 = g1_256$1;
var utils$f = utils$i, common$3 = common$5, shaCommon$1 = common$4, rotl32$1 = utils$f.rotl32, sum32$2 = utils$f.sum32, sum32_5$1 = utils$f.sum32_5, ft_1 = shaCommon$1.ft_1, BlockHash$3 = common$3.BlockHash, sha1_K = [
  1518500249,
  1859775393,
  2400959708,
  3395469782
];
function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();
  BlockHash$3.call(this), this.h = [
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ], this.W = new Array(80);
}
utils$f.inherits(SHA1, BlockHash$3);
var _1 = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function(c, ie) {
  for (var we = this.W, $e = 0; $e < 16; $e++)
    we[$e] = c[ie + $e];
  for (; $e < we.length; $e++)
    we[$e] = rotl32$1(we[$e - 3] ^ we[$e - 8] ^ we[$e - 14] ^ we[$e - 16], 1);
  var Me = this.h[0], Ze = this.h[1], ne = this.h[2], rr = this.h[3], gr = this.h[4];
  for ($e = 0; $e < we.length; $e++) {
    var or = ~~($e / 20), _r = sum32_5$1(rotl32$1(Me, 5), ft_1(or, Ze, ne, rr), gr, we[$e], sha1_K[or]);
    gr = rr, rr = ne, ne = rotl32$1(Ze, 30), Ze = Me, Me = _r;
  }
  this.h[0] = sum32$2(this.h[0], Me), this.h[1] = sum32$2(this.h[1], Ze), this.h[2] = sum32$2(this.h[2], ne), this.h[3] = sum32$2(this.h[3], rr), this.h[4] = sum32$2(this.h[4], gr);
};
SHA1.prototype._digest = function(c) {
  return c === "hex" ? utils$f.toHex32(this.h, "big") : utils$f.split32(this.h, "big");
};
var utils$e = utils$i, common$2 = common$5, shaCommon = common$4, assert$8 = minimalisticAssert, sum32$1 = utils$e.sum32, sum32_4$1 = utils$e.sum32_4, sum32_5 = utils$e.sum32_5, ch32 = shaCommon.ch32, maj32 = shaCommon.maj32, s0_256 = shaCommon.s0_256, s1_256 = shaCommon.s1_256, g0_256 = shaCommon.g0_256, g1_256 = shaCommon.g1_256, BlockHash$2 = common$2.BlockHash, sha256_K = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
];
function SHA256$1() {
  if (!(this instanceof SHA256$1))
    return new SHA256$1();
  BlockHash$2.call(this), this.h = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ], this.k = sha256_K, this.W = new Array(64);
}
utils$e.inherits(SHA256$1, BlockHash$2);
var _256 = SHA256$1;
SHA256$1.blockSize = 512;
SHA256$1.outSize = 256;
SHA256$1.hmacStrength = 192;
SHA256$1.padLength = 64;
SHA256$1.prototype._update = function(c, ie) {
  for (var we = this.W, $e = 0; $e < 16; $e++)
    we[$e] = c[ie + $e];
  for (; $e < we.length; $e++)
    we[$e] = sum32_4$1(g1_256(we[$e - 2]), we[$e - 7], g0_256(we[$e - 15]), we[$e - 16]);
  var Me = this.h[0], Ze = this.h[1], ne = this.h[2], rr = this.h[3], gr = this.h[4], or = this.h[5], _r = this.h[6], Lr = this.h[7];
  for (assert$8(this.k.length === we.length), $e = 0; $e < we.length; $e++) {
    var Ir = sum32_5(Lr, s1_256(gr), ch32(gr, or, _r), this.k[$e], we[$e]), Ar = sum32$1(s0_256(Me), maj32(Me, Ze, ne));
    Lr = _r, _r = or, or = gr, gr = sum32$1(rr, Ir), rr = ne, ne = Ze, Ze = Me, Me = sum32$1(Ir, Ar);
  }
  this.h[0] = sum32$1(this.h[0], Me), this.h[1] = sum32$1(this.h[1], Ze), this.h[2] = sum32$1(this.h[2], ne), this.h[3] = sum32$1(this.h[3], rr), this.h[4] = sum32$1(this.h[4], gr), this.h[5] = sum32$1(this.h[5], or), this.h[6] = sum32$1(this.h[6], _r), this.h[7] = sum32$1(this.h[7], Lr);
};
SHA256$1.prototype._digest = function(c) {
  return c === "hex" ? utils$e.toHex32(this.h, "big") : utils$e.split32(this.h, "big");
};
var utils$d = utils$i, SHA256 = _256;
function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();
  SHA256.call(this), this.h = [
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ];
}
utils$d.inherits(SHA224, SHA256);
var _224 = SHA224;
SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;
SHA224.prototype._digest = function(c) {
  return c === "hex" ? utils$d.toHex32(this.h.slice(0, 7), "big") : utils$d.split32(this.h.slice(0, 7), "big");
};
var utils$c = utils$i, common$1 = common$5, assert$7 = minimalisticAssert, rotr64_hi = utils$c.rotr64_hi, rotr64_lo = utils$c.rotr64_lo, shr64_hi = utils$c.shr64_hi, shr64_lo = utils$c.shr64_lo, sum64 = utils$c.sum64, sum64_hi = utils$c.sum64_hi, sum64_lo = utils$c.sum64_lo, sum64_4_hi = utils$c.sum64_4_hi, sum64_4_lo = utils$c.sum64_4_lo, sum64_5_hi = utils$c.sum64_5_hi, sum64_5_lo = utils$c.sum64_5_lo, BlockHash$1 = common$1.BlockHash, sha512_K = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
];
function SHA512$1() {
  if (!(this instanceof SHA512$1))
    return new SHA512$1();
  BlockHash$1.call(this), this.h = [
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ], this.k = sha512_K, this.W = new Array(160);
}
utils$c.inherits(SHA512$1, BlockHash$1);
var _512 = SHA512$1;
SHA512$1.blockSize = 1024;
SHA512$1.outSize = 512;
SHA512$1.hmacStrength = 192;
SHA512$1.padLength = 128;
SHA512$1.prototype._prepareBlock = function(c, ie) {
  for (var we = this.W, $e = 0; $e < 32; $e++)
    we[$e] = c[ie + $e];
  for (; $e < we.length; $e += 2) {
    var Me = g1_512_hi(we[$e - 4], we[$e - 3]), Ze = g1_512_lo(we[$e - 4], we[$e - 3]), ne = we[$e - 14], rr = we[$e - 13], gr = g0_512_hi(we[$e - 30], we[$e - 29]), or = g0_512_lo(we[$e - 30], we[$e - 29]), _r = we[$e - 32], Lr = we[$e - 31];
    we[$e] = sum64_4_hi(
      Me,
      Ze,
      ne,
      rr,
      gr,
      or,
      _r,
      Lr
    ), we[$e + 1] = sum64_4_lo(
      Me,
      Ze,
      ne,
      rr,
      gr,
      or,
      _r,
      Lr
    );
  }
};
SHA512$1.prototype._update = function(c, ie) {
  this._prepareBlock(c, ie);
  var we = this.W, $e = this.h[0], Me = this.h[1], Ze = this.h[2], ne = this.h[3], rr = this.h[4], gr = this.h[5], or = this.h[6], _r = this.h[7], Lr = this.h[8], Ir = this.h[9], Ar = this.h[10], Rr = this.h[11], Nr = this.h[12], Yr = this.h[13], Vr = this.h[14], Xr = this.h[15];
  assert$7(this.k.length === we.length);
  for (var Wr = 0; Wr < we.length; Wr += 2) {
    var si = Vr, li = Xr, xi = s1_512_hi(Lr, Ir), di = s1_512_lo(Lr, Ir), oi = ch64_hi(Lr, Ir, Ar, Rr, Nr), ci = ch64_lo(Lr, Ir, Ar, Rr, Nr, Yr), vr = this.k[Wr], Ae = this.k[Wr + 1], ze = we[Wr], Ue = we[Wr + 1], tr = sum64_5_hi(
      si,
      li,
      xi,
      di,
      oi,
      ci,
      vr,
      Ae,
      ze,
      Ue
    ), lr = sum64_5_lo(
      si,
      li,
      xi,
      di,
      oi,
      ci,
      vr,
      Ae,
      ze,
      Ue
    );
    si = s0_512_hi($e, Me), li = s0_512_lo($e, Me), xi = maj64_hi($e, Me, Ze, ne, rr), di = maj64_lo($e, Me, Ze, ne, rr, gr);
    var pr = sum64_hi(si, li, xi, di), br = sum64_lo(si, li, xi, di);
    Vr = Nr, Xr = Yr, Nr = Ar, Yr = Rr, Ar = Lr, Rr = Ir, Lr = sum64_hi(or, _r, tr, lr), Ir = sum64_lo(_r, _r, tr, lr), or = rr, _r = gr, rr = Ze, gr = ne, Ze = $e, ne = Me, $e = sum64_hi(tr, lr, pr, br), Me = sum64_lo(tr, lr, pr, br);
  }
  sum64(this.h, 0, $e, Me), sum64(this.h, 2, Ze, ne), sum64(this.h, 4, rr, gr), sum64(this.h, 6, or, _r), sum64(this.h, 8, Lr, Ir), sum64(this.h, 10, Ar, Rr), sum64(this.h, 12, Nr, Yr), sum64(this.h, 14, Vr, Xr);
};
SHA512$1.prototype._digest = function(c) {
  return c === "hex" ? utils$c.toHex32(this.h, "big") : utils$c.split32(this.h, "big");
};
function ch64_hi(m, c, ie, we, $e) {
  var Me = m & ie ^ ~m & $e;
  return Me < 0 && (Me += 4294967296), Me;
}
function ch64_lo(m, c, ie, we, $e, Me) {
  var Ze = c & we ^ ~c & Me;
  return Ze < 0 && (Ze += 4294967296), Ze;
}
function maj64_hi(m, c, ie, we, $e) {
  var Me = m & ie ^ m & $e ^ ie & $e;
  return Me < 0 && (Me += 4294967296), Me;
}
function maj64_lo(m, c, ie, we, $e, Me) {
  var Ze = c & we ^ c & Me ^ we & Me;
  return Ze < 0 && (Ze += 4294967296), Ze;
}
function s0_512_hi(m, c) {
  var ie = rotr64_hi(m, c, 28), we = rotr64_hi(c, m, 2), $e = rotr64_hi(c, m, 7), Me = ie ^ we ^ $e;
  return Me < 0 && (Me += 4294967296), Me;
}
function s0_512_lo(m, c) {
  var ie = rotr64_lo(m, c, 28), we = rotr64_lo(c, m, 2), $e = rotr64_lo(c, m, 7), Me = ie ^ we ^ $e;
  return Me < 0 && (Me += 4294967296), Me;
}
function s1_512_hi(m, c) {
  var ie = rotr64_hi(m, c, 14), we = rotr64_hi(m, c, 18), $e = rotr64_hi(c, m, 9), Me = ie ^ we ^ $e;
  return Me < 0 && (Me += 4294967296), Me;
}
function s1_512_lo(m, c) {
  var ie = rotr64_lo(m, c, 14), we = rotr64_lo(m, c, 18), $e = rotr64_lo(c, m, 9), Me = ie ^ we ^ $e;
  return Me < 0 && (Me += 4294967296), Me;
}
function g0_512_hi(m, c) {
  var ie = rotr64_hi(m, c, 1), we = rotr64_hi(m, c, 8), $e = shr64_hi(m, c, 7), Me = ie ^ we ^ $e;
  return Me < 0 && (Me += 4294967296), Me;
}
function g0_512_lo(m, c) {
  var ie = rotr64_lo(m, c, 1), we = rotr64_lo(m, c, 8), $e = shr64_lo(m, c, 7), Me = ie ^ we ^ $e;
  return Me < 0 && (Me += 4294967296), Me;
}
function g1_512_hi(m, c) {
  var ie = rotr64_hi(m, c, 19), we = rotr64_hi(c, m, 29), $e = shr64_hi(m, c, 6), Me = ie ^ we ^ $e;
  return Me < 0 && (Me += 4294967296), Me;
}
function g1_512_lo(m, c) {
  var ie = rotr64_lo(m, c, 19), we = rotr64_lo(c, m, 29), $e = shr64_lo(m, c, 6), Me = ie ^ we ^ $e;
  return Me < 0 && (Me += 4294967296), Me;
}
var utils$b = utils$i, SHA512 = _512;
function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();
  SHA512.call(this), this.h = [
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ];
}
utils$b.inherits(SHA384, SHA512);
var _384 = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function(c) {
  return c === "hex" ? utils$b.toHex32(this.h.slice(0, 12), "big") : utils$b.split32(this.h.slice(0, 12), "big");
};
sha.sha1 = _1;
sha.sha224 = _224;
sha.sha256 = _256;
sha.sha384 = _384;
sha.sha512 = _512;
var ripemd = {}, utils$a = utils$i, common = common$5, rotl32 = utils$a.rotl32, sum32 = utils$a.sum32, sum32_3 = utils$a.sum32_3, sum32_4 = utils$a.sum32_4, BlockHash = common.BlockHash;
function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();
  BlockHash.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
utils$a.inherits(RIPEMD160, BlockHash);
ripemd.ripemd160 = RIPEMD160;
RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;
RIPEMD160.prototype._update = function(c, ie) {
  for (var we = this.h[0], $e = this.h[1], Me = this.h[2], Ze = this.h[3], ne = this.h[4], rr = we, gr = $e, or = Me, _r = Ze, Lr = ne, Ir = 0; Ir < 80; Ir++) {
    var Ar = sum32(
      rotl32(
        sum32_4(we, f$2(Ir, $e, Me, Ze), c[r$1[Ir] + ie], K$1(Ir)),
        s$1[Ir]
      ),
      ne
    );
    we = ne, ne = Ze, Ze = rotl32(Me, 10), Me = $e, $e = Ar, Ar = sum32(
      rotl32(
        sum32_4(rr, f$2(79 - Ir, gr, or, _r), c[rh[Ir] + ie], Kh(Ir)),
        sh[Ir]
      ),
      Lr
    ), rr = Lr, Lr = _r, _r = rotl32(or, 10), or = gr, gr = Ar;
  }
  Ar = sum32_3(this.h[1], Me, _r), this.h[1] = sum32_3(this.h[2], Ze, Lr), this.h[2] = sum32_3(this.h[3], ne, rr), this.h[3] = sum32_3(this.h[4], we, gr), this.h[4] = sum32_3(this.h[0], $e, or), this.h[0] = Ar;
};
RIPEMD160.prototype._digest = function(c) {
  return c === "hex" ? utils$a.toHex32(this.h, "little") : utils$a.split32(this.h, "little");
};
function f$2(m, c, ie, we) {
  return m <= 15 ? c ^ ie ^ we : m <= 31 ? c & ie | ~c & we : m <= 47 ? (c | ~ie) ^ we : m <= 63 ? c & we | ie & ~we : c ^ (ie | ~we);
}
function K$1(m) {
  return m <= 15 ? 0 : m <= 31 ? 1518500249 : m <= 47 ? 1859775393 : m <= 63 ? 2400959708 : 2840853838;
}
function Kh(m) {
  return m <= 15 ? 1352829926 : m <= 31 ? 1548603684 : m <= 47 ? 1836072691 : m <= 63 ? 2053994217 : 0;
}
var r$1 = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], rh = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], s$1 = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], sh = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], utils$9 = utils$i, assert$6 = minimalisticAssert;
function Hmac(m, c, ie) {
  if (!(this instanceof Hmac))
    return new Hmac(m, c, ie);
  this.Hash = m, this.blockSize = m.blockSize / 8, this.outSize = m.outSize / 8, this.inner = null, this.outer = null, this._init(utils$9.toArray(c, ie));
}
var hmac = Hmac;
Hmac.prototype._init = function(c) {
  c.length > this.blockSize && (c = new this.Hash().update(c).digest()), assert$6(c.length <= this.blockSize);
  for (var ie = c.length; ie < this.blockSize; ie++)
    c.push(0);
  for (ie = 0; ie < c.length; ie++)
    c[ie] ^= 54;
  for (this.inner = new this.Hash().update(c), ie = 0; ie < c.length; ie++)
    c[ie] ^= 106;
  this.outer = new this.Hash().update(c);
};
Hmac.prototype.update = function(c, ie) {
  return this.inner.update(c, ie), this;
};
Hmac.prototype.digest = function(c) {
  return this.outer.update(this.inner.digest()), this.outer.digest(c);
};
(function(m) {
  var c = m;
  c.utils = utils$i, c.common = common$5, c.sha = sha, c.ripemd = ripemd, c.hmac = hmac, c.sha1 = c.sha.sha1, c.sha256 = c.sha.sha256, c.sha224 = c.sha.sha224, c.sha384 = c.sha.sha384, c.sha512 = c.sha.sha512, c.ripemd160 = c.ripemd.ripemd160;
})(hash$4);
var secp256k1, hasRequiredSecp256k1;
function requireSecp256k1() {
  return hasRequiredSecp256k1 || (hasRequiredSecp256k1 = 1, secp256k1 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1;
}
(function(m) {
  var c = m, ie = hash$4, we = curve, $e = utils$o, Me = $e.assert;
  function Ze(gr) {
    gr.type === "short" ? this.curve = new we.short(gr) : gr.type === "edwards" ? this.curve = new we.edwards(gr) : this.curve = new we.mont(gr), this.g = this.curve.g, this.n = this.curve.n, this.hash = gr.hash, Me(this.g.validate(), "Invalid curve"), Me(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  c.PresetCurve = Ze;
  function ne(gr, or) {
    Object.defineProperty(c, gr, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var _r = new Ze(or);
        return Object.defineProperty(c, gr, {
          configurable: !0,
          enumerable: !0,
          value: _r
        }), _r;
      }
    });
  }
  ne("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: ie.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), ne("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: ie.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), ne("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: ie.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), ne("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: ie.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), ne("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: ie.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), ne("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: ie.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), ne("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: ie.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var rr;
  try {
    rr = requireSecp256k1();
  } catch {
    rr = void 0;
  }
  ne("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: ie.sha256,
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      rr
    ]
  });
})(curves$1);
var hash$3 = hash$4, utils$8 = utils$n, assert$5 = minimalisticAssert;
function HmacDRBG(m) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(m);
  this.hash = m.hash, this.predResist = !!m.predResist, this.outLen = this.hash.outSize, this.minEntropy = m.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var c = utils$8.toArray(m.entropy, m.entropyEnc || "hex"), ie = utils$8.toArray(m.nonce, m.nonceEnc || "hex"), we = utils$8.toArray(m.pers, m.persEnc || "hex");
  assert$5(
    c.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(c, ie, we);
}
var hmacDrbg = HmacDRBG;
HmacDRBG.prototype._init = function(c, ie, we) {
  var $e = c.concat(ie).concat(we);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var Me = 0; Me < this.V.length; Me++)
    this.K[Me] = 0, this.V[Me] = 1;
  this._update($e), this._reseed = 1, this.reseedInterval = 281474976710656;
};
HmacDRBG.prototype._hmac = function() {
  return new hash$3.hmac(this.hash, this.K);
};
HmacDRBG.prototype._update = function(c) {
  var ie = this._hmac().update(this.V).update([0]);
  c && (ie = ie.update(c)), this.K = ie.digest(), this.V = this._hmac().update(this.V).digest(), c && (this.K = this._hmac().update(this.V).update([1]).update(c).digest(), this.V = this._hmac().update(this.V).digest());
};
HmacDRBG.prototype.reseed = function(c, ie, we, $e) {
  typeof ie != "string" && ($e = we, we = ie, ie = null), c = utils$8.toArray(c, ie), we = utils$8.toArray(we, $e), assert$5(
    c.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(c.concat(we || [])), this._reseed = 1;
};
HmacDRBG.prototype.generate = function(c, ie, we, $e) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof ie != "string" && ($e = we, we = ie, ie = null), we && (we = utils$8.toArray(we, $e || "hex"), this._update(we));
  for (var Me = []; Me.length < c; )
    this.V = this._hmac().update(this.V).digest(), Me = Me.concat(this.V);
  var Ze = Me.slice(0, c);
  return this._update(we), this._reseed++, utils$8.encode(Ze, ie);
};
var BN$5 = bn$3.exports, utils$7 = utils$o, assert$4 = utils$7.assert;
function KeyPair$2(m, c) {
  this.ec = m, this.priv = null, this.pub = null, c.priv && this._importPrivate(c.priv, c.privEnc), c.pub && this._importPublic(c.pub, c.pubEnc);
}
var key$1 = KeyPair$2;
KeyPair$2.fromPublic = function(c, ie, we) {
  return ie instanceof KeyPair$2 ? ie : new KeyPair$2(c, {
    pub: ie,
    pubEnc: we
  });
};
KeyPair$2.fromPrivate = function(c, ie, we) {
  return ie instanceof KeyPair$2 ? ie : new KeyPair$2(c, {
    priv: ie,
    privEnc: we
  });
};
KeyPair$2.prototype.validate = function() {
  var c = this.getPublic();
  return c.isInfinity() ? { result: !1, reason: "Invalid public key" } : c.validate() ? c.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
KeyPair$2.prototype.getPublic = function(c, ie) {
  return typeof c == "string" && (ie = c, c = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), ie ? this.pub.encode(ie, c) : this.pub;
};
KeyPair$2.prototype.getPrivate = function(c) {
  return c === "hex" ? this.priv.toString(16, 2) : this.priv;
};
KeyPair$2.prototype._importPrivate = function(c, ie) {
  this.priv = new BN$5(c, ie || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair$2.prototype._importPublic = function(c, ie) {
  if (c.x || c.y) {
    this.ec.curve.type === "mont" ? assert$4(c.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && assert$4(c.x && c.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(c.x, c.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(c, ie);
};
KeyPair$2.prototype.derive = function(c) {
  return c.validate() || assert$4(c.validate(), "public point not validated"), c.mul(this.priv).getX();
};
KeyPair$2.prototype.sign = function(c, ie, we) {
  return this.ec.sign(c, this, ie, we);
};
KeyPair$2.prototype.verify = function(c, ie, we) {
  return this.ec.verify(c, ie, this, void 0, we);
};
KeyPair$2.prototype.inspect = function() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var BN$4 = bn$3.exports, utils$6 = utils$o, assert$3 = utils$6.assert;
function Signature$2(m, c) {
  if (m instanceof Signature$2)
    return m;
  this._importDER(m, c) || (assert$3(m.r && m.s, "Signature without r or s"), this.r = new BN$4(m.r, 16), this.s = new BN$4(m.s, 16), m.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = m.recoveryParam);
}
var signature$1 = Signature$2;
function Position() {
  this.place = 0;
}
function getLength(m, c) {
  var ie = m[c.place++];
  if (!(ie & 128))
    return ie;
  var we = ie & 15;
  if (we === 0 || we > 4 || m[c.place] === 0)
    return !1;
  for (var $e = 0, Me = 0, Ze = c.place; Me < we; Me++, Ze++)
    $e <<= 8, $e |= m[Ze], $e >>>= 0;
  return $e <= 127 ? !1 : (c.place = Ze, $e);
}
function rmPadding(m) {
  for (var c = 0, ie = m.length - 1; !m[c] && !(m[c + 1] & 128) && c < ie; )
    c++;
  return c === 0 ? m : m.slice(c);
}
Signature$2.prototype._importDER = function(c, ie) {
  c = utils$6.toArray(c, ie);
  var we = new Position();
  if (c[we.place++] !== 48)
    return !1;
  var $e = getLength(c, we);
  if ($e === !1 || $e + we.place !== c.length || c[we.place++] !== 2)
    return !1;
  var Me = getLength(c, we);
  if (Me === !1 || (c[we.place] & 128) !== 0)
    return !1;
  var Ze = c.slice(we.place, Me + we.place);
  if (we.place += Me, c[we.place++] !== 2)
    return !1;
  var ne = getLength(c, we);
  if (ne === !1 || c.length !== ne + we.place || (c[we.place] & 128) !== 0)
    return !1;
  var rr = c.slice(we.place, ne + we.place);
  if (Ze[0] === 0)
    if (Ze[1] & 128)
      Ze = Ze.slice(1);
    else
      return !1;
  if (rr[0] === 0)
    if (rr[1] & 128)
      rr = rr.slice(1);
    else
      return !1;
  return this.r = new BN$4(Ze), this.s = new BN$4(rr), this.recoveryParam = null, !0;
};
function constructLength(m, c) {
  if (c < 128) {
    m.push(c);
    return;
  }
  var ie = 1 + (Math.log(c) / Math.LN2 >>> 3);
  for (m.push(ie | 128); --ie; )
    m.push(c >>> (ie << 3) & 255);
  m.push(c);
}
Signature$2.prototype.toDER = function(c) {
  var ie = this.r.toArray(), we = this.s.toArray();
  for (ie[0] & 128 && (ie = [0].concat(ie)), we[0] & 128 && (we = [0].concat(we)), ie = rmPadding(ie), we = rmPadding(we); !we[0] && !(we[1] & 128); )
    we = we.slice(1);
  var $e = [2];
  constructLength($e, ie.length), $e = $e.concat(ie), $e.push(2), constructLength($e, we.length);
  var Me = $e.concat(we), Ze = [48];
  return constructLength(Ze, Me.length), Ze = Ze.concat(Me), utils$6.encode(Ze, c);
};
var ec, hasRequiredEc;
function requireEc() {
  if (hasRequiredEc)
    return ec;
  hasRequiredEc = 1;
  var m = bn$3.exports, c = hmacDrbg, ie = utils$o, we = curves$1, $e = requireBrorand(), Me = ie.assert, Ze = key$1, ne = signature$1;
  function rr(gr) {
    if (!(this instanceof rr))
      return new rr(gr);
    typeof gr == "string" && (Me(
      Object.prototype.hasOwnProperty.call(we, gr),
      "Unknown curve " + gr
    ), gr = we[gr]), gr instanceof we.PresetCurve && (gr = { curve: gr }), this.curve = gr.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = gr.curve.g, this.g.precompute(gr.curve.n.bitLength() + 1), this.hash = gr.hash || gr.curve.hash;
  }
  return ec = rr, rr.prototype.keyPair = function(or) {
    return new Ze(this, or);
  }, rr.prototype.keyFromPrivate = function(or, _r) {
    return Ze.fromPrivate(this, or, _r);
  }, rr.prototype.keyFromPublic = function(or, _r) {
    return Ze.fromPublic(this, or, _r);
  }, rr.prototype.genKeyPair = function(or) {
    or || (or = {});
    for (var _r = new c({
      hash: this.hash,
      pers: or.pers,
      persEnc: or.persEnc || "utf8",
      entropy: or.entropy || $e(this.hash.hmacStrength),
      entropyEnc: or.entropy && or.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), Lr = this.n.byteLength(), Ir = this.n.sub(new m(2)); ; ) {
      var Ar = new m(_r.generate(Lr));
      if (!(Ar.cmp(Ir) > 0))
        return Ar.iaddn(1), this.keyFromPrivate(Ar);
    }
  }, rr.prototype._truncateToN = function(or, _r, Lr) {
    var Ir;
    if (m.isBN(or) || typeof or == "number")
      or = new m(or, 16), Ir = or.byteLength();
    else if (typeof or == "object")
      Ir = or.length, or = new m(or, 16);
    else {
      var Ar = or.toString();
      Ir = Ar.length + 1 >>> 1, or = new m(Ar, 16);
    }
    typeof Lr != "number" && (Lr = Ir * 8);
    var Rr = Lr - this.n.bitLength();
    return Rr > 0 && (or = or.ushrn(Rr)), !_r && or.cmp(this.n) >= 0 ? or.sub(this.n) : or;
  }, rr.prototype.sign = function(or, _r, Lr, Ir) {
    if (typeof Lr == "object" && (Ir = Lr, Lr = null), Ir || (Ir = {}), typeof or != "string" && typeof or != "number" && !m.isBN(or)) {
      Me(
        typeof or == "object" && or && typeof or.length == "number",
        "Expected message to be an array-like, a hex string, or a BN instance"
      ), Me(or.length >>> 0 === or.length);
      for (var Ar = 0; Ar < or.length; Ar++)
        Me((or[Ar] & 255) === or[Ar]);
    }
    _r = this.keyFromPrivate(_r, Lr), or = this._truncateToN(or, !1, Ir.msgBitLength), Me(!or.isNeg(), "Can not sign a negative message");
    var Rr = this.n.byteLength(), Nr = _r.getPrivate().toArray("be", Rr), Yr = or.toArray("be", Rr);
    Me(new m(Yr).eq(or), "Can not sign message");
    for (var Vr = new c({
      hash: this.hash,
      entropy: Nr,
      nonce: Yr,
      pers: Ir.pers,
      persEnc: Ir.persEnc || "utf8"
    }), Xr = this.n.sub(new m(1)), Wr = 0; ; Wr++) {
      var si = Ir.k ? Ir.k(Wr) : new m(Vr.generate(this.n.byteLength()));
      if (si = this._truncateToN(si, !0), !(si.cmpn(1) <= 0 || si.cmp(Xr) >= 0)) {
        var li = this.g.mul(si);
        if (!li.isInfinity()) {
          var xi = li.getX(), di = xi.umod(this.n);
          if (di.cmpn(0) !== 0) {
            var oi = si.invm(this.n).mul(di.mul(_r.getPrivate()).iadd(or));
            if (oi = oi.umod(this.n), oi.cmpn(0) !== 0) {
              var ci = (li.getY().isOdd() ? 1 : 0) | (xi.cmp(di) !== 0 ? 2 : 0);
              return Ir.canonical && oi.cmp(this.nh) > 0 && (oi = this.n.sub(oi), ci ^= 1), new ne({ r: di, s: oi, recoveryParam: ci });
            }
          }
        }
      }
    }
  }, rr.prototype.verify = function(or, _r, Lr, Ir, Ar) {
    Ar || (Ar = {}), or = this._truncateToN(or, !1, Ar.msgBitLength), Lr = this.keyFromPublic(Lr, Ir), _r = new ne(_r, "hex");
    var Rr = _r.r, Nr = _r.s;
    if (Rr.cmpn(1) < 0 || Rr.cmp(this.n) >= 0 || Nr.cmpn(1) < 0 || Nr.cmp(this.n) >= 0)
      return !1;
    var Yr = Nr.invm(this.n), Vr = Yr.mul(or).umod(this.n), Xr = Yr.mul(Rr).umod(this.n), Wr;
    return this.curve._maxwellTrick ? (Wr = this.g.jmulAdd(Vr, Lr.getPublic(), Xr), Wr.isInfinity() ? !1 : Wr.eqXToP(Rr)) : (Wr = this.g.mulAdd(Vr, Lr.getPublic(), Xr), Wr.isInfinity() ? !1 : Wr.getX().umod(this.n).cmp(Rr) === 0);
  }, rr.prototype.recoverPubKey = function(gr, or, _r, Lr) {
    Me((3 & _r) === _r, "The recovery param is more than two bits"), or = new ne(or, Lr);
    var Ir = this.n, Ar = new m(gr), Rr = or.r, Nr = or.s, Yr = _r & 1, Vr = _r >> 1;
    if (Rr.cmp(this.curve.p.umod(this.curve.n)) >= 0 && Vr)
      throw new Error("Unable to find sencond key candinate");
    Vr ? Rr = this.curve.pointFromX(Rr.add(this.curve.n), Yr) : Rr = this.curve.pointFromX(Rr, Yr);
    var Xr = or.r.invm(Ir), Wr = Ir.sub(Ar).mul(Xr).umod(Ir), si = Nr.mul(Xr).umod(Ir);
    return this.g.mulAdd(Wr, Rr, si);
  }, rr.prototype.getKeyRecoveryParam = function(gr, or, _r, Lr) {
    if (or = new ne(or, Lr), or.recoveryParam !== null)
      return or.recoveryParam;
    for (var Ir = 0; Ir < 4; Ir++) {
      var Ar;
      try {
        Ar = this.recoverPubKey(gr, or, Ir);
      } catch {
        continue;
      }
      if (Ar.eq(_r))
        return Ir;
    }
    throw new Error("Unable to find valid recovery factor");
  }, ec;
}
var utils$5 = utils$o, assert$2 = utils$5.assert, parseBytes$2 = utils$5.parseBytes, cachedProperty$1 = utils$5.cachedProperty;
function KeyPair$1(m, c) {
  this.eddsa = m, this._secret = parseBytes$2(c.secret), m.isPoint(c.pub) ? this._pub = c.pub : this._pubBytes = parseBytes$2(c.pub);
}
KeyPair$1.fromPublic = function(c, ie) {
  return ie instanceof KeyPair$1 ? ie : new KeyPair$1(c, { pub: ie });
};
KeyPair$1.fromSecret = function(c, ie) {
  return ie instanceof KeyPair$1 ? ie : new KeyPair$1(c, { secret: ie });
};
KeyPair$1.prototype.secret = function() {
  return this._secret;
};
cachedProperty$1(KeyPair$1, "pubBytes", function() {
  return this.eddsa.encodePoint(this.pub());
});
cachedProperty$1(KeyPair$1, "pub", function() {
  return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
});
cachedProperty$1(KeyPair$1, "privBytes", function() {
  var c = this.eddsa, ie = this.hash(), we = c.encodingLength - 1, $e = ie.slice(0, c.encodingLength);
  return $e[0] &= 248, $e[we] &= 127, $e[we] |= 64, $e;
});
cachedProperty$1(KeyPair$1, "priv", function() {
  return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty$1(KeyPair$1, "hash", function() {
  return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty$1(KeyPair$1, "messagePrefix", function() {
  return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair$1.prototype.sign = function(c) {
  return assert$2(this._secret, "KeyPair can only verify"), this.eddsa.sign(c, this);
};
KeyPair$1.prototype.verify = function(c, ie) {
  return this.eddsa.verify(c, ie, this);
};
KeyPair$1.prototype.getSecret = function(c) {
  return assert$2(this._secret, "KeyPair is public only"), utils$5.encode(this.secret(), c);
};
KeyPair$1.prototype.getPublic = function(c) {
  return utils$5.encode(this.pubBytes(), c);
};
var key = KeyPair$1, BN$3 = bn$3.exports, utils$4 = utils$o, assert$1 = utils$4.assert, cachedProperty = utils$4.cachedProperty, parseBytes$1 = utils$4.parseBytes;
function Signature$1(m, c) {
  this.eddsa = m, typeof c != "object" && (c = parseBytes$1(c)), Array.isArray(c) && (assert$1(c.length === m.encodingLength * 2, "Signature has invalid size"), c = {
    R: c.slice(0, m.encodingLength),
    S: c.slice(m.encodingLength)
  }), assert$1(c.R && c.S, "Signature without R or S"), m.isPoint(c.R) && (this._R = c.R), c.S instanceof BN$3 && (this._S = c.S), this._Rencoded = Array.isArray(c.R) ? c.R : c.Rencoded, this._Sencoded = Array.isArray(c.S) ? c.S : c.Sencoded;
}
cachedProperty(Signature$1, "S", function() {
  return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature$1, "R", function() {
  return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature$1, "Rencoded", function() {
  return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature$1, "Sencoded", function() {
  return this.eddsa.encodeInt(this.S());
});
Signature$1.prototype.toBytes = function() {
  return this.Rencoded().concat(this.Sencoded());
};
Signature$1.prototype.toHex = function() {
  return utils$4.encode(this.toBytes(), "hex").toUpperCase();
};
var signature = Signature$1, hash$2 = hash$4, curves = curves$1, utils$3 = utils$o, assert = utils$3.assert, parseBytes = utils$3.parseBytes, KeyPair = key, Signature = signature;
function EDDSA(m) {
  if (assert(m === "ed25519", "only tested with ed25519 so far"), !(this instanceof EDDSA))
    return new EDDSA(m);
  m = curves[m].curve, this.curve = m, this.g = m.g, this.g.precompute(m.n.bitLength() + 1), this.pointClass = m.point().constructor, this.encodingLength = Math.ceil(m.n.bitLength() / 8), this.hash = hash$2.sha512;
}
var eddsa = EDDSA;
EDDSA.prototype.sign = function(c, ie) {
  c = parseBytes(c);
  var we = this.keyFromSecret(ie), $e = this.hashInt(we.messagePrefix(), c), Me = this.g.mul($e), Ze = this.encodePoint(Me), ne = this.hashInt(Ze, we.pubBytes(), c).mul(we.priv()), rr = $e.add(ne).umod(this.curve.n);
  return this.makeSignature({ R: Me, S: rr, Rencoded: Ze });
};
EDDSA.prototype.verify = function(c, ie, we) {
  if (c = parseBytes(c), ie = this.makeSignature(ie), ie.S().gte(ie.eddsa.curve.n) || ie.S().isNeg())
    return !1;
  var $e = this.keyFromPublic(we), Me = this.hashInt(ie.Rencoded(), $e.pubBytes(), c), Ze = this.g.mul(ie.S()), ne = ie.R().add($e.pub().mul(Me));
  return ne.eq(Ze);
};
EDDSA.prototype.hashInt = function() {
  for (var c = this.hash(), ie = 0; ie < arguments.length; ie++)
    c.update(arguments[ie]);
  return utils$3.intFromLE(c.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function(c) {
  return KeyPair.fromPublic(this, c);
};
EDDSA.prototype.keyFromSecret = function(c) {
  return KeyPair.fromSecret(this, c);
};
EDDSA.prototype.makeSignature = function(c) {
  return c instanceof Signature ? c : new Signature(this, c);
};
EDDSA.prototype.encodePoint = function(c) {
  var ie = c.getY().toArray("le", this.encodingLength);
  return ie[this.encodingLength - 1] |= c.getX().isOdd() ? 128 : 0, ie;
};
EDDSA.prototype.decodePoint = function(c) {
  c = utils$3.parseBytes(c);
  var ie = c.length - 1, we = c.slice(0, ie).concat(c[ie] & -129), $e = (c[ie] & 128) !== 0, Me = utils$3.intFromLE(we);
  return this.curve.pointFromY(Me, $e);
};
EDDSA.prototype.encodeInt = function(c) {
  return c.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function(c) {
  return utils$3.intFromLE(c);
};
EDDSA.prototype.isPoint = function(c) {
  return c instanceof this.pointClass;
};
var hasRequiredElliptic;
function requireElliptic() {
  return hasRequiredElliptic || (hasRequiredElliptic = 1, function(m) {
    var c = m;
    c.version = require$$0$3.version, c.utils = utils$o, c.rand = requireBrorand(), c.curve = curve, c.curves = curves$1, c.ec = requireEc(), c.eddsa = eddsa;
  }(elliptic)), elliptic;
}
var asn1$3 = {}, asn1$2 = {}, bn$2 = { exports: {} };
(function(m) {
  (function(c, ie) {
    function we(vr, Ae) {
      if (!vr)
        throw new Error(Ae || "Assertion failed");
    }
    function $e(vr, Ae) {
      vr.super_ = Ae;
      var ze = function() {
      };
      ze.prototype = Ae.prototype, vr.prototype = new ze(), vr.prototype.constructor = vr;
    }
    function Me(vr, Ae, ze) {
      if (Me.isBN(vr))
        return vr;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, vr !== null && ((Ae === "le" || Ae === "be") && (ze = Ae, Ae = 10), this._init(vr || 0, Ae || 10, ze || "be"));
    }
    typeof c == "object" ? c.exports = Me : ie.BN = Me, Me.BN = Me, Me.wordSize = 26;
    var Ze;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? Ze = window.Buffer : Ze = require$$0$4.Buffer;
    } catch {
    }
    Me.isBN = function(Ae) {
      return Ae instanceof Me ? !0 : Ae !== null && typeof Ae == "object" && Ae.constructor.wordSize === Me.wordSize && Array.isArray(Ae.words);
    }, Me.max = function(Ae, ze) {
      return Ae.cmp(ze) > 0 ? Ae : ze;
    }, Me.min = function(Ae, ze) {
      return Ae.cmp(ze) < 0 ? Ae : ze;
    }, Me.prototype._init = function(Ae, ze, Ue) {
      if (typeof Ae == "number")
        return this._initNumber(Ae, ze, Ue);
      if (typeof Ae == "object")
        return this._initArray(Ae, ze, Ue);
      ze === "hex" && (ze = 16), we(ze === (ze | 0) && ze >= 2 && ze <= 36), Ae = Ae.toString().replace(/\s+/g, "");
      var tr = 0;
      Ae[0] === "-" && (tr++, this.negative = 1), tr < Ae.length && (ze === 16 ? this._parseHex(Ae, tr, Ue) : (this._parseBase(Ae, ze, tr), Ue === "le" && this._initArray(this.toArray(), ze, Ue)));
    }, Me.prototype._initNumber = function(Ae, ze, Ue) {
      Ae < 0 && (this.negative = 1, Ae = -Ae), Ae < 67108864 ? (this.words = [Ae & 67108863], this.length = 1) : Ae < 4503599627370496 ? (this.words = [
        Ae & 67108863,
        Ae / 67108864 & 67108863
      ], this.length = 2) : (we(Ae < 9007199254740992), this.words = [
        Ae & 67108863,
        Ae / 67108864 & 67108863,
        1
      ], this.length = 3), Ue === "le" && this._initArray(this.toArray(), ze, Ue);
    }, Me.prototype._initArray = function(Ae, ze, Ue) {
      if (we(typeof Ae.length == "number"), Ae.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(Ae.length / 3), this.words = new Array(this.length);
      for (var tr = 0; tr < this.length; tr++)
        this.words[tr] = 0;
      var lr, pr, br = 0;
      if (Ue === "be")
        for (tr = Ae.length - 1, lr = 0; tr >= 0; tr -= 3)
          pr = Ae[tr] | Ae[tr - 1] << 8 | Ae[tr - 2] << 16, this.words[lr] |= pr << br & 67108863, this.words[lr + 1] = pr >>> 26 - br & 67108863, br += 24, br >= 26 && (br -= 26, lr++);
      else if (Ue === "le")
        for (tr = 0, lr = 0; tr < Ae.length; tr += 3)
          pr = Ae[tr] | Ae[tr + 1] << 8 | Ae[tr + 2] << 16, this.words[lr] |= pr << br & 67108863, this.words[lr + 1] = pr >>> 26 - br & 67108863, br += 24, br >= 26 && (br -= 26, lr++);
      return this.strip();
    };
    function ne(vr, Ae) {
      var ze = vr.charCodeAt(Ae);
      return ze >= 65 && ze <= 70 ? ze - 55 : ze >= 97 && ze <= 102 ? ze - 87 : ze - 48 & 15;
    }
    function rr(vr, Ae, ze) {
      var Ue = ne(vr, ze);
      return ze - 1 >= Ae && (Ue |= ne(vr, ze - 1) << 4), Ue;
    }
    Me.prototype._parseHex = function(Ae, ze, Ue) {
      this.length = Math.ceil((Ae.length - ze) / 6), this.words = new Array(this.length);
      for (var tr = 0; tr < this.length; tr++)
        this.words[tr] = 0;
      var lr = 0, pr = 0, br;
      if (Ue === "be")
        for (tr = Ae.length - 1; tr >= ze; tr -= 2)
          br = rr(Ae, ze, tr) << lr, this.words[pr] |= br & 67108863, lr >= 18 ? (lr -= 18, pr += 1, this.words[pr] |= br >>> 26) : lr += 8;
      else {
        var nr = Ae.length - ze;
        for (tr = nr % 2 === 0 ? ze + 1 : ze; tr < Ae.length; tr += 2)
          br = rr(Ae, ze, tr) << lr, this.words[pr] |= br & 67108863, lr >= 18 ? (lr -= 18, pr += 1, this.words[pr] |= br >>> 26) : lr += 8;
      }
      this.strip();
    };
    function gr(vr, Ae, ze, Ue) {
      for (var tr = 0, lr = Math.min(vr.length, ze), pr = Ae; pr < lr; pr++) {
        var br = vr.charCodeAt(pr) - 48;
        tr *= Ue, br >= 49 ? tr += br - 49 + 10 : br >= 17 ? tr += br - 17 + 10 : tr += br;
      }
      return tr;
    }
    Me.prototype._parseBase = function(Ae, ze, Ue) {
      this.words = [0], this.length = 1;
      for (var tr = 0, lr = 1; lr <= 67108863; lr *= ze)
        tr++;
      tr--, lr = lr / ze | 0;
      for (var pr = Ae.length - Ue, br = pr % tr, nr = Math.min(pr, pr - br) + Ue, Pe = 0, ur = Ue; ur < nr; ur += tr)
        Pe = gr(Ae, ur, ur + tr, ze), this.imuln(lr), this.words[0] + Pe < 67108864 ? this.words[0] += Pe : this._iaddn(Pe);
      if (br !== 0) {
        var Pr = 1;
        for (Pe = gr(Ae, ur, Ae.length, ze), ur = 0; ur < br; ur++)
          Pr *= ze;
        this.imuln(Pr), this.words[0] + Pe < 67108864 ? this.words[0] += Pe : this._iaddn(Pe);
      }
      this.strip();
    }, Me.prototype.copy = function(Ae) {
      Ae.words = new Array(this.length);
      for (var ze = 0; ze < this.length; ze++)
        Ae.words[ze] = this.words[ze];
      Ae.length = this.length, Ae.negative = this.negative, Ae.red = this.red;
    }, Me.prototype.clone = function() {
      var Ae = new Me(null);
      return this.copy(Ae), Ae;
    }, Me.prototype._expand = function(Ae) {
      for (; this.length < Ae; )
        this.words[this.length++] = 0;
      return this;
    }, Me.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, Me.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, Me.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var or = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], _r = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Lr = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    Me.prototype.toString = function(Ae, ze) {
      Ae = Ae || 10, ze = ze | 0 || 1;
      var Ue;
      if (Ae === 16 || Ae === "hex") {
        Ue = "";
        for (var tr = 0, lr = 0, pr = 0; pr < this.length; pr++) {
          var br = this.words[pr], nr = ((br << tr | lr) & 16777215).toString(16);
          lr = br >>> 24 - tr & 16777215, tr += 2, tr >= 26 && (tr -= 26, pr--), lr !== 0 || pr !== this.length - 1 ? Ue = or[6 - nr.length] + nr + Ue : Ue = nr + Ue;
        }
        for (lr !== 0 && (Ue = lr.toString(16) + Ue); Ue.length % ze !== 0; )
          Ue = "0" + Ue;
        return this.negative !== 0 && (Ue = "-" + Ue), Ue;
      }
      if (Ae === (Ae | 0) && Ae >= 2 && Ae <= 36) {
        var Pe = _r[Ae], ur = Lr[Ae];
        Ue = "";
        var Pr = this.clone();
        for (Pr.negative = 0; !Pr.isZero(); ) {
          var Hr = Pr.modn(ur).toString(Ae);
          Pr = Pr.idivn(ur), Pr.isZero() ? Ue = Hr + Ue : Ue = or[Pe - Hr.length] + Hr + Ue;
        }
        for (this.isZero() && (Ue = "0" + Ue); Ue.length % ze !== 0; )
          Ue = "0" + Ue;
        return this.negative !== 0 && (Ue = "-" + Ue), Ue;
      }
      we(!1, "Base should be between 2 and 36");
    }, Me.prototype.toNumber = function() {
      var Ae = this.words[0];
      return this.length === 2 ? Ae += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ae += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && we(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ae : Ae;
    }, Me.prototype.toJSON = function() {
      return this.toString(16);
    }, Me.prototype.toBuffer = function(Ae, ze) {
      return we(typeof Ze < "u"), this.toArrayLike(Ze, Ae, ze);
    }, Me.prototype.toArray = function(Ae, ze) {
      return this.toArrayLike(Array, Ae, ze);
    }, Me.prototype.toArrayLike = function(Ae, ze, Ue) {
      var tr = this.byteLength(), lr = Ue || Math.max(1, tr);
      we(tr <= lr, "byte array longer than desired length"), we(lr > 0, "Requested array length <= 0"), this.strip();
      var pr = ze === "le", br = new Ae(lr), nr, Pe, ur = this.clone();
      if (pr) {
        for (Pe = 0; !ur.isZero(); Pe++)
          nr = ur.andln(255), ur.iushrn(8), br[Pe] = nr;
        for (; Pe < lr; Pe++)
          br[Pe] = 0;
      } else {
        for (Pe = 0; Pe < lr - tr; Pe++)
          br[Pe] = 0;
        for (Pe = 0; !ur.isZero(); Pe++)
          nr = ur.andln(255), ur.iushrn(8), br[lr - Pe - 1] = nr;
      }
      return br;
    }, Math.clz32 ? Me.prototype._countBits = function(Ae) {
      return 32 - Math.clz32(Ae);
    } : Me.prototype._countBits = function(Ae) {
      var ze = Ae, Ue = 0;
      return ze >= 4096 && (Ue += 13, ze >>>= 13), ze >= 64 && (Ue += 7, ze >>>= 7), ze >= 8 && (Ue += 4, ze >>>= 4), ze >= 2 && (Ue += 2, ze >>>= 2), Ue + ze;
    }, Me.prototype._zeroBits = function(Ae) {
      if (Ae === 0)
        return 26;
      var ze = Ae, Ue = 0;
      return (ze & 8191) === 0 && (Ue += 13, ze >>>= 13), (ze & 127) === 0 && (Ue += 7, ze >>>= 7), (ze & 15) === 0 && (Ue += 4, ze >>>= 4), (ze & 3) === 0 && (Ue += 2, ze >>>= 2), (ze & 1) === 0 && Ue++, Ue;
    }, Me.prototype.bitLength = function() {
      var Ae = this.words[this.length - 1], ze = this._countBits(Ae);
      return (this.length - 1) * 26 + ze;
    };
    function Ir(vr) {
      for (var Ae = new Array(vr.bitLength()), ze = 0; ze < Ae.length; ze++) {
        var Ue = ze / 26 | 0, tr = ze % 26;
        Ae[ze] = (vr.words[Ue] & 1 << tr) >>> tr;
      }
      return Ae;
    }
    Me.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var Ae = 0, ze = 0; ze < this.length; ze++) {
        var Ue = this._zeroBits(this.words[ze]);
        if (Ae += Ue, Ue !== 26)
          break;
      }
      return Ae;
    }, Me.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, Me.prototype.toTwos = function(Ae) {
      return this.negative !== 0 ? this.abs().inotn(Ae).iaddn(1) : this.clone();
    }, Me.prototype.fromTwos = function(Ae) {
      return this.testn(Ae - 1) ? this.notn(Ae).iaddn(1).ineg() : this.clone();
    }, Me.prototype.isNeg = function() {
      return this.negative !== 0;
    }, Me.prototype.neg = function() {
      return this.clone().ineg();
    }, Me.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, Me.prototype.iuor = function(Ae) {
      for (; this.length < Ae.length; )
        this.words[this.length++] = 0;
      for (var ze = 0; ze < Ae.length; ze++)
        this.words[ze] = this.words[ze] | Ae.words[ze];
      return this.strip();
    }, Me.prototype.ior = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuor(Ae);
    }, Me.prototype.or = function(Ae) {
      return this.length > Ae.length ? this.clone().ior(Ae) : Ae.clone().ior(this);
    }, Me.prototype.uor = function(Ae) {
      return this.length > Ae.length ? this.clone().iuor(Ae) : Ae.clone().iuor(this);
    }, Me.prototype.iuand = function(Ae) {
      var ze;
      this.length > Ae.length ? ze = Ae : ze = this;
      for (var Ue = 0; Ue < ze.length; Ue++)
        this.words[Ue] = this.words[Ue] & Ae.words[Ue];
      return this.length = ze.length, this.strip();
    }, Me.prototype.iand = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuand(Ae);
    }, Me.prototype.and = function(Ae) {
      return this.length > Ae.length ? this.clone().iand(Ae) : Ae.clone().iand(this);
    }, Me.prototype.uand = function(Ae) {
      return this.length > Ae.length ? this.clone().iuand(Ae) : Ae.clone().iuand(this);
    }, Me.prototype.iuxor = function(Ae) {
      var ze, Ue;
      this.length > Ae.length ? (ze = this, Ue = Ae) : (ze = Ae, Ue = this);
      for (var tr = 0; tr < Ue.length; tr++)
        this.words[tr] = ze.words[tr] ^ Ue.words[tr];
      if (this !== ze)
        for (; tr < ze.length; tr++)
          this.words[tr] = ze.words[tr];
      return this.length = ze.length, this.strip();
    }, Me.prototype.ixor = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuxor(Ae);
    }, Me.prototype.xor = function(Ae) {
      return this.length > Ae.length ? this.clone().ixor(Ae) : Ae.clone().ixor(this);
    }, Me.prototype.uxor = function(Ae) {
      return this.length > Ae.length ? this.clone().iuxor(Ae) : Ae.clone().iuxor(this);
    }, Me.prototype.inotn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Math.ceil(Ae / 26) | 0, Ue = Ae % 26;
      this._expand(ze), Ue > 0 && ze--;
      for (var tr = 0; tr < ze; tr++)
        this.words[tr] = ~this.words[tr] & 67108863;
      return Ue > 0 && (this.words[tr] = ~this.words[tr] & 67108863 >> 26 - Ue), this.strip();
    }, Me.prototype.notn = function(Ae) {
      return this.clone().inotn(Ae);
    }, Me.prototype.setn = function(Ae, ze) {
      we(typeof Ae == "number" && Ae >= 0);
      var Ue = Ae / 26 | 0, tr = Ae % 26;
      return this._expand(Ue + 1), ze ? this.words[Ue] = this.words[Ue] | 1 << tr : this.words[Ue] = this.words[Ue] & ~(1 << tr), this.strip();
    }, Me.prototype.iadd = function(Ae) {
      var ze;
      if (this.negative !== 0 && Ae.negative === 0)
        return this.negative = 0, ze = this.isub(Ae), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && Ae.negative !== 0)
        return Ae.negative = 0, ze = this.isub(Ae), Ae.negative = 1, ze._normSign();
      var Ue, tr;
      this.length > Ae.length ? (Ue = this, tr = Ae) : (Ue = Ae, tr = this);
      for (var lr = 0, pr = 0; pr < tr.length; pr++)
        ze = (Ue.words[pr] | 0) + (tr.words[pr] | 0) + lr, this.words[pr] = ze & 67108863, lr = ze >>> 26;
      for (; lr !== 0 && pr < Ue.length; pr++)
        ze = (Ue.words[pr] | 0) + lr, this.words[pr] = ze & 67108863, lr = ze >>> 26;
      if (this.length = Ue.length, lr !== 0)
        this.words[this.length] = lr, this.length++;
      else if (Ue !== this)
        for (; pr < Ue.length; pr++)
          this.words[pr] = Ue.words[pr];
      return this;
    }, Me.prototype.add = function(Ae) {
      var ze;
      return Ae.negative !== 0 && this.negative === 0 ? (Ae.negative = 0, ze = this.sub(Ae), Ae.negative ^= 1, ze) : Ae.negative === 0 && this.negative !== 0 ? (this.negative = 0, ze = Ae.sub(this), this.negative = 1, ze) : this.length > Ae.length ? this.clone().iadd(Ae) : Ae.clone().iadd(this);
    }, Me.prototype.isub = function(Ae) {
      if (Ae.negative !== 0) {
        Ae.negative = 0;
        var ze = this.iadd(Ae);
        return Ae.negative = 1, ze._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(Ae), this.negative = 1, this._normSign();
      var Ue = this.cmp(Ae);
      if (Ue === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var tr, lr;
      Ue > 0 ? (tr = this, lr = Ae) : (tr = Ae, lr = this);
      for (var pr = 0, br = 0; br < lr.length; br++)
        ze = (tr.words[br] | 0) - (lr.words[br] | 0) + pr, pr = ze >> 26, this.words[br] = ze & 67108863;
      for (; pr !== 0 && br < tr.length; br++)
        ze = (tr.words[br] | 0) + pr, pr = ze >> 26, this.words[br] = ze & 67108863;
      if (pr === 0 && br < tr.length && tr !== this)
        for (; br < tr.length; br++)
          this.words[br] = tr.words[br];
      return this.length = Math.max(this.length, br), tr !== this && (this.negative = 1), this.strip();
    }, Me.prototype.sub = function(Ae) {
      return this.clone().isub(Ae);
    };
    function Ar(vr, Ae, ze) {
      ze.negative = Ae.negative ^ vr.negative;
      var Ue = vr.length + Ae.length | 0;
      ze.length = Ue, Ue = Ue - 1 | 0;
      var tr = vr.words[0] | 0, lr = Ae.words[0] | 0, pr = tr * lr, br = pr & 67108863, nr = pr / 67108864 | 0;
      ze.words[0] = br;
      for (var Pe = 1; Pe < Ue; Pe++) {
        for (var ur = nr >>> 26, Pr = nr & 67108863, Hr = Math.min(Pe, Ae.length - 1), vi = Math.max(0, Pe - vr.length + 1); vi <= Hr; vi++) {
          var Ti = Pe - vi | 0;
          tr = vr.words[Ti] | 0, lr = Ae.words[vi] | 0, pr = tr * lr + Pr, ur += pr / 67108864 | 0, Pr = pr & 67108863;
        }
        ze.words[Pe] = Pr | 0, nr = ur | 0;
      }
      return nr !== 0 ? ze.words[Pe] = nr | 0 : ze.length--, ze.strip();
    }
    var Rr = function(Ae, ze, Ue) {
      var tr = Ae.words, lr = ze.words, pr = Ue.words, br = 0, nr, Pe, ur, Pr = tr[0] | 0, Hr = Pr & 8191, vi = Pr >>> 13, Ti = tr[1] | 0, wi = Ti & 8191, ii = Ti >>> 13, mi = tr[2] | 0, ei = mi & 8191, Zr = mi >>> 13, pi = tr[3] | 0, hi = pi & 8191, Oi = pi >>> 13, qi = tr[4] | 0, yn = qi & 8191, sn = qi >>> 13, $n = tr[5] | 0, rn = $n & 8191, ji = $n >>> 13, Kn = tr[6] | 0, In = Kn & 8191, Fn = Kn >>> 13, Po = tr[7] | 0, vn = Po & 8191, Vn = Po >>> 13, Xo = tr[8] | 0, Xn = Xo & 8191, Yn = Xo >>> 13, Wo = tr[9] | 0, Ci = Wo & 8191, ri = Wo >>> 13, yi = lr[0] | 0, Li = yi & 8191, Yi = yi >>> 13, zn = lr[1] | 0, un = zn & 8191, Gn = zn >>> 13, Mn = lr[2] | 0, pn = Mn & 8191, Rn = Mn >>> 13, Io = lr[3] | 0, to = Io & 8191, no = Io >>> 13, ma = lr[4] | 0, Qn = ma & 8191, co = ma >>> 13, kn = lr[5] | 0, ai = kn & 8191, _i = kn >>> 13, Pi = lr[6] | 0, Ai = Pi & 8191, ki = Pi >>> 13, an = lr[7] | 0, Ui = an & 8191, Vi = an >>> 13, Sn = lr[8] | 0, Hi = Sn & 8191, en = Sn >>> 13, qn = lr[9] | 0, _n = qn & 8191, Tn = qn >>> 13;
      Ue.negative = Ae.negative ^ ze.negative, Ue.length = 19, nr = Math.imul(Hr, Li), Pe = Math.imul(Hr, Yi), Pe = Pe + Math.imul(vi, Li) | 0, ur = Math.imul(vi, Yi);
      var xo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (xo >>> 26) | 0, xo &= 67108863, nr = Math.imul(wi, Li), Pe = Math.imul(wi, Yi), Pe = Pe + Math.imul(ii, Li) | 0, ur = Math.imul(ii, Yi), nr = nr + Math.imul(Hr, un) | 0, Pe = Pe + Math.imul(Hr, Gn) | 0, Pe = Pe + Math.imul(vi, un) | 0, ur = ur + Math.imul(vi, Gn) | 0;
      var Co = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Co >>> 26) | 0, Co &= 67108863, nr = Math.imul(ei, Li), Pe = Math.imul(ei, Yi), Pe = Pe + Math.imul(Zr, Li) | 0, ur = Math.imul(Zr, Yi), nr = nr + Math.imul(wi, un) | 0, Pe = Pe + Math.imul(wi, Gn) | 0, Pe = Pe + Math.imul(ii, un) | 0, ur = ur + Math.imul(ii, Gn) | 0, nr = nr + Math.imul(Hr, pn) | 0, Pe = Pe + Math.imul(Hr, Rn) | 0, Pe = Pe + Math.imul(vi, pn) | 0, ur = ur + Math.imul(vi, Rn) | 0;
      var $o = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + ($o >>> 26) | 0, $o &= 67108863, nr = Math.imul(hi, Li), Pe = Math.imul(hi, Yi), Pe = Pe + Math.imul(Oi, Li) | 0, ur = Math.imul(Oi, Yi), nr = nr + Math.imul(ei, un) | 0, Pe = Pe + Math.imul(ei, Gn) | 0, Pe = Pe + Math.imul(Zr, un) | 0, ur = ur + Math.imul(Zr, Gn) | 0, nr = nr + Math.imul(wi, pn) | 0, Pe = Pe + Math.imul(wi, Rn) | 0, Pe = Pe + Math.imul(ii, pn) | 0, ur = ur + Math.imul(ii, Rn) | 0, nr = nr + Math.imul(Hr, to) | 0, Pe = Pe + Math.imul(Hr, no) | 0, Pe = Pe + Math.imul(vi, to) | 0, ur = ur + Math.imul(vi, no) | 0;
      var Bo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Bo >>> 26) | 0, Bo &= 67108863, nr = Math.imul(yn, Li), Pe = Math.imul(yn, Yi), Pe = Pe + Math.imul(sn, Li) | 0, ur = Math.imul(sn, Yi), nr = nr + Math.imul(hi, un) | 0, Pe = Pe + Math.imul(hi, Gn) | 0, Pe = Pe + Math.imul(Oi, un) | 0, ur = ur + Math.imul(Oi, Gn) | 0, nr = nr + Math.imul(ei, pn) | 0, Pe = Pe + Math.imul(ei, Rn) | 0, Pe = Pe + Math.imul(Zr, pn) | 0, ur = ur + Math.imul(Zr, Rn) | 0, nr = nr + Math.imul(wi, to) | 0, Pe = Pe + Math.imul(wi, no) | 0, Pe = Pe + Math.imul(ii, to) | 0, ur = ur + Math.imul(ii, no) | 0, nr = nr + Math.imul(Hr, Qn) | 0, Pe = Pe + Math.imul(Hr, co) | 0, Pe = Pe + Math.imul(vi, Qn) | 0, ur = ur + Math.imul(vi, co) | 0;
      var Qo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Qo >>> 26) | 0, Qo &= 67108863, nr = Math.imul(rn, Li), Pe = Math.imul(rn, Yi), Pe = Pe + Math.imul(ji, Li) | 0, ur = Math.imul(ji, Yi), nr = nr + Math.imul(yn, un) | 0, Pe = Pe + Math.imul(yn, Gn) | 0, Pe = Pe + Math.imul(sn, un) | 0, ur = ur + Math.imul(sn, Gn) | 0, nr = nr + Math.imul(hi, pn) | 0, Pe = Pe + Math.imul(hi, Rn) | 0, Pe = Pe + Math.imul(Oi, pn) | 0, ur = ur + Math.imul(Oi, Rn) | 0, nr = nr + Math.imul(ei, to) | 0, Pe = Pe + Math.imul(ei, no) | 0, Pe = Pe + Math.imul(Zr, to) | 0, ur = ur + Math.imul(Zr, no) | 0, nr = nr + Math.imul(wi, Qn) | 0, Pe = Pe + Math.imul(wi, co) | 0, Pe = Pe + Math.imul(ii, Qn) | 0, ur = ur + Math.imul(ii, co) | 0, nr = nr + Math.imul(Hr, ai) | 0, Pe = Pe + Math.imul(Hr, _i) | 0, Pe = Pe + Math.imul(vi, ai) | 0, ur = ur + Math.imul(vi, _i) | 0;
      var Go = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Go >>> 26) | 0, Go &= 67108863, nr = Math.imul(In, Li), Pe = Math.imul(In, Yi), Pe = Pe + Math.imul(Fn, Li) | 0, ur = Math.imul(Fn, Yi), nr = nr + Math.imul(rn, un) | 0, Pe = Pe + Math.imul(rn, Gn) | 0, Pe = Pe + Math.imul(ji, un) | 0, ur = ur + Math.imul(ji, Gn) | 0, nr = nr + Math.imul(yn, pn) | 0, Pe = Pe + Math.imul(yn, Rn) | 0, Pe = Pe + Math.imul(sn, pn) | 0, ur = ur + Math.imul(sn, Rn) | 0, nr = nr + Math.imul(hi, to) | 0, Pe = Pe + Math.imul(hi, no) | 0, Pe = Pe + Math.imul(Oi, to) | 0, ur = ur + Math.imul(Oi, no) | 0, nr = nr + Math.imul(ei, Qn) | 0, Pe = Pe + Math.imul(ei, co) | 0, Pe = Pe + Math.imul(Zr, Qn) | 0, ur = ur + Math.imul(Zr, co) | 0, nr = nr + Math.imul(wi, ai) | 0, Pe = Pe + Math.imul(wi, _i) | 0, Pe = Pe + Math.imul(ii, ai) | 0, ur = ur + Math.imul(ii, _i) | 0, nr = nr + Math.imul(Hr, Ai) | 0, Pe = Pe + Math.imul(Hr, ki) | 0, Pe = Pe + Math.imul(vi, Ai) | 0, ur = ur + Math.imul(vi, ki) | 0;
      var No = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, nr = Math.imul(vn, Li), Pe = Math.imul(vn, Yi), Pe = Pe + Math.imul(Vn, Li) | 0, ur = Math.imul(Vn, Yi), nr = nr + Math.imul(In, un) | 0, Pe = Pe + Math.imul(In, Gn) | 0, Pe = Pe + Math.imul(Fn, un) | 0, ur = ur + Math.imul(Fn, Gn) | 0, nr = nr + Math.imul(rn, pn) | 0, Pe = Pe + Math.imul(rn, Rn) | 0, Pe = Pe + Math.imul(ji, pn) | 0, ur = ur + Math.imul(ji, Rn) | 0, nr = nr + Math.imul(yn, to) | 0, Pe = Pe + Math.imul(yn, no) | 0, Pe = Pe + Math.imul(sn, to) | 0, ur = ur + Math.imul(sn, no) | 0, nr = nr + Math.imul(hi, Qn) | 0, Pe = Pe + Math.imul(hi, co) | 0, Pe = Pe + Math.imul(Oi, Qn) | 0, ur = ur + Math.imul(Oi, co) | 0, nr = nr + Math.imul(ei, ai) | 0, Pe = Pe + Math.imul(ei, _i) | 0, Pe = Pe + Math.imul(Zr, ai) | 0, ur = ur + Math.imul(Zr, _i) | 0, nr = nr + Math.imul(wi, Ai) | 0, Pe = Pe + Math.imul(wi, ki) | 0, Pe = Pe + Math.imul(ii, Ai) | 0, ur = ur + Math.imul(ii, ki) | 0, nr = nr + Math.imul(Hr, Ui) | 0, Pe = Pe + Math.imul(Hr, Vi) | 0, Pe = Pe + Math.imul(vi, Ui) | 0, ur = ur + Math.imul(vi, Vi) | 0;
      var Zo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Zo >>> 26) | 0, Zo &= 67108863, nr = Math.imul(Xn, Li), Pe = Math.imul(Xn, Yi), Pe = Pe + Math.imul(Yn, Li) | 0, ur = Math.imul(Yn, Yi), nr = nr + Math.imul(vn, un) | 0, Pe = Pe + Math.imul(vn, Gn) | 0, Pe = Pe + Math.imul(Vn, un) | 0, ur = ur + Math.imul(Vn, Gn) | 0, nr = nr + Math.imul(In, pn) | 0, Pe = Pe + Math.imul(In, Rn) | 0, Pe = Pe + Math.imul(Fn, pn) | 0, ur = ur + Math.imul(Fn, Rn) | 0, nr = nr + Math.imul(rn, to) | 0, Pe = Pe + Math.imul(rn, no) | 0, Pe = Pe + Math.imul(ji, to) | 0, ur = ur + Math.imul(ji, no) | 0, nr = nr + Math.imul(yn, Qn) | 0, Pe = Pe + Math.imul(yn, co) | 0, Pe = Pe + Math.imul(sn, Qn) | 0, ur = ur + Math.imul(sn, co) | 0, nr = nr + Math.imul(hi, ai) | 0, Pe = Pe + Math.imul(hi, _i) | 0, Pe = Pe + Math.imul(Oi, ai) | 0, ur = ur + Math.imul(Oi, _i) | 0, nr = nr + Math.imul(ei, Ai) | 0, Pe = Pe + Math.imul(ei, ki) | 0, Pe = Pe + Math.imul(Zr, Ai) | 0, ur = ur + Math.imul(Zr, ki) | 0, nr = nr + Math.imul(wi, Ui) | 0, Pe = Pe + Math.imul(wi, Vi) | 0, Pe = Pe + Math.imul(ii, Ui) | 0, ur = ur + Math.imul(ii, Vi) | 0, nr = nr + Math.imul(Hr, Hi) | 0, Pe = Pe + Math.imul(Hr, en) | 0, Pe = Pe + Math.imul(vi, Hi) | 0, ur = ur + Math.imul(vi, en) | 0;
      var ea = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ea >>> 26) | 0, ea &= 67108863, nr = Math.imul(Ci, Li), Pe = Math.imul(Ci, Yi), Pe = Pe + Math.imul(ri, Li) | 0, ur = Math.imul(ri, Yi), nr = nr + Math.imul(Xn, un) | 0, Pe = Pe + Math.imul(Xn, Gn) | 0, Pe = Pe + Math.imul(Yn, un) | 0, ur = ur + Math.imul(Yn, Gn) | 0, nr = nr + Math.imul(vn, pn) | 0, Pe = Pe + Math.imul(vn, Rn) | 0, Pe = Pe + Math.imul(Vn, pn) | 0, ur = ur + Math.imul(Vn, Rn) | 0, nr = nr + Math.imul(In, to) | 0, Pe = Pe + Math.imul(In, no) | 0, Pe = Pe + Math.imul(Fn, to) | 0, ur = ur + Math.imul(Fn, no) | 0, nr = nr + Math.imul(rn, Qn) | 0, Pe = Pe + Math.imul(rn, co) | 0, Pe = Pe + Math.imul(ji, Qn) | 0, ur = ur + Math.imul(ji, co) | 0, nr = nr + Math.imul(yn, ai) | 0, Pe = Pe + Math.imul(yn, _i) | 0, Pe = Pe + Math.imul(sn, ai) | 0, ur = ur + Math.imul(sn, _i) | 0, nr = nr + Math.imul(hi, Ai) | 0, Pe = Pe + Math.imul(hi, ki) | 0, Pe = Pe + Math.imul(Oi, Ai) | 0, ur = ur + Math.imul(Oi, ki) | 0, nr = nr + Math.imul(ei, Ui) | 0, Pe = Pe + Math.imul(ei, Vi) | 0, Pe = Pe + Math.imul(Zr, Ui) | 0, ur = ur + Math.imul(Zr, Vi) | 0, nr = nr + Math.imul(wi, Hi) | 0, Pe = Pe + Math.imul(wi, en) | 0, Pe = Pe + Math.imul(ii, Hi) | 0, ur = ur + Math.imul(ii, en) | 0, nr = nr + Math.imul(Hr, _n) | 0, Pe = Pe + Math.imul(Hr, Tn) | 0, Pe = Pe + Math.imul(vi, _n) | 0, ur = ur + Math.imul(vi, Tn) | 0;
      var da = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (da >>> 26) | 0, da &= 67108863, nr = Math.imul(Ci, un), Pe = Math.imul(Ci, Gn), Pe = Pe + Math.imul(ri, un) | 0, ur = Math.imul(ri, Gn), nr = nr + Math.imul(Xn, pn) | 0, Pe = Pe + Math.imul(Xn, Rn) | 0, Pe = Pe + Math.imul(Yn, pn) | 0, ur = ur + Math.imul(Yn, Rn) | 0, nr = nr + Math.imul(vn, to) | 0, Pe = Pe + Math.imul(vn, no) | 0, Pe = Pe + Math.imul(Vn, to) | 0, ur = ur + Math.imul(Vn, no) | 0, nr = nr + Math.imul(In, Qn) | 0, Pe = Pe + Math.imul(In, co) | 0, Pe = Pe + Math.imul(Fn, Qn) | 0, ur = ur + Math.imul(Fn, co) | 0, nr = nr + Math.imul(rn, ai) | 0, Pe = Pe + Math.imul(rn, _i) | 0, Pe = Pe + Math.imul(ji, ai) | 0, ur = ur + Math.imul(ji, _i) | 0, nr = nr + Math.imul(yn, Ai) | 0, Pe = Pe + Math.imul(yn, ki) | 0, Pe = Pe + Math.imul(sn, Ai) | 0, ur = ur + Math.imul(sn, ki) | 0, nr = nr + Math.imul(hi, Ui) | 0, Pe = Pe + Math.imul(hi, Vi) | 0, Pe = Pe + Math.imul(Oi, Ui) | 0, ur = ur + Math.imul(Oi, Vi) | 0, nr = nr + Math.imul(ei, Hi) | 0, Pe = Pe + Math.imul(ei, en) | 0, Pe = Pe + Math.imul(Zr, Hi) | 0, ur = ur + Math.imul(Zr, en) | 0, nr = nr + Math.imul(wi, _n) | 0, Pe = Pe + Math.imul(wi, Tn) | 0, Pe = Pe + Math.imul(ii, _n) | 0, ur = ur + Math.imul(ii, Tn) | 0;
      var Ra = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ra >>> 26) | 0, Ra &= 67108863, nr = Math.imul(Ci, pn), Pe = Math.imul(Ci, Rn), Pe = Pe + Math.imul(ri, pn) | 0, ur = Math.imul(ri, Rn), nr = nr + Math.imul(Xn, to) | 0, Pe = Pe + Math.imul(Xn, no) | 0, Pe = Pe + Math.imul(Yn, to) | 0, ur = ur + Math.imul(Yn, no) | 0, nr = nr + Math.imul(vn, Qn) | 0, Pe = Pe + Math.imul(vn, co) | 0, Pe = Pe + Math.imul(Vn, Qn) | 0, ur = ur + Math.imul(Vn, co) | 0, nr = nr + Math.imul(In, ai) | 0, Pe = Pe + Math.imul(In, _i) | 0, Pe = Pe + Math.imul(Fn, ai) | 0, ur = ur + Math.imul(Fn, _i) | 0, nr = nr + Math.imul(rn, Ai) | 0, Pe = Pe + Math.imul(rn, ki) | 0, Pe = Pe + Math.imul(ji, Ai) | 0, ur = ur + Math.imul(ji, ki) | 0, nr = nr + Math.imul(yn, Ui) | 0, Pe = Pe + Math.imul(yn, Vi) | 0, Pe = Pe + Math.imul(sn, Ui) | 0, ur = ur + Math.imul(sn, Vi) | 0, nr = nr + Math.imul(hi, Hi) | 0, Pe = Pe + Math.imul(hi, en) | 0, Pe = Pe + Math.imul(Oi, Hi) | 0, ur = ur + Math.imul(Oi, en) | 0, nr = nr + Math.imul(ei, _n) | 0, Pe = Pe + Math.imul(ei, Tn) | 0, Pe = Pe + Math.imul(Zr, _n) | 0, ur = ur + Math.imul(Zr, Tn) | 0;
      var ba = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ba >>> 26) | 0, ba &= 67108863, nr = Math.imul(Ci, to), Pe = Math.imul(Ci, no), Pe = Pe + Math.imul(ri, to) | 0, ur = Math.imul(ri, no), nr = nr + Math.imul(Xn, Qn) | 0, Pe = Pe + Math.imul(Xn, co) | 0, Pe = Pe + Math.imul(Yn, Qn) | 0, ur = ur + Math.imul(Yn, co) | 0, nr = nr + Math.imul(vn, ai) | 0, Pe = Pe + Math.imul(vn, _i) | 0, Pe = Pe + Math.imul(Vn, ai) | 0, ur = ur + Math.imul(Vn, _i) | 0, nr = nr + Math.imul(In, Ai) | 0, Pe = Pe + Math.imul(In, ki) | 0, Pe = Pe + Math.imul(Fn, Ai) | 0, ur = ur + Math.imul(Fn, ki) | 0, nr = nr + Math.imul(rn, Ui) | 0, Pe = Pe + Math.imul(rn, Vi) | 0, Pe = Pe + Math.imul(ji, Ui) | 0, ur = ur + Math.imul(ji, Vi) | 0, nr = nr + Math.imul(yn, Hi) | 0, Pe = Pe + Math.imul(yn, en) | 0, Pe = Pe + Math.imul(sn, Hi) | 0, ur = ur + Math.imul(sn, en) | 0, nr = nr + Math.imul(hi, _n) | 0, Pe = Pe + Math.imul(hi, Tn) | 0, Pe = Pe + Math.imul(Oi, _n) | 0, ur = ur + Math.imul(Oi, Tn) | 0;
      var Ea = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ea >>> 26) | 0, Ea &= 67108863, nr = Math.imul(Ci, Qn), Pe = Math.imul(Ci, co), Pe = Pe + Math.imul(ri, Qn) | 0, ur = Math.imul(ri, co), nr = nr + Math.imul(Xn, ai) | 0, Pe = Pe + Math.imul(Xn, _i) | 0, Pe = Pe + Math.imul(Yn, ai) | 0, ur = ur + Math.imul(Yn, _i) | 0, nr = nr + Math.imul(vn, Ai) | 0, Pe = Pe + Math.imul(vn, ki) | 0, Pe = Pe + Math.imul(Vn, Ai) | 0, ur = ur + Math.imul(Vn, ki) | 0, nr = nr + Math.imul(In, Ui) | 0, Pe = Pe + Math.imul(In, Vi) | 0, Pe = Pe + Math.imul(Fn, Ui) | 0, ur = ur + Math.imul(Fn, Vi) | 0, nr = nr + Math.imul(rn, Hi) | 0, Pe = Pe + Math.imul(rn, en) | 0, Pe = Pe + Math.imul(ji, Hi) | 0, ur = ur + Math.imul(ji, en) | 0, nr = nr + Math.imul(yn, _n) | 0, Pe = Pe + Math.imul(yn, Tn) | 0, Pe = Pe + Math.imul(sn, _n) | 0, ur = ur + Math.imul(sn, Tn) | 0;
      var Ha = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ha >>> 26) | 0, Ha &= 67108863, nr = Math.imul(Ci, ai), Pe = Math.imul(Ci, _i), Pe = Pe + Math.imul(ri, ai) | 0, ur = Math.imul(ri, _i), nr = nr + Math.imul(Xn, Ai) | 0, Pe = Pe + Math.imul(Xn, ki) | 0, Pe = Pe + Math.imul(Yn, Ai) | 0, ur = ur + Math.imul(Yn, ki) | 0, nr = nr + Math.imul(vn, Ui) | 0, Pe = Pe + Math.imul(vn, Vi) | 0, Pe = Pe + Math.imul(Vn, Ui) | 0, ur = ur + Math.imul(Vn, Vi) | 0, nr = nr + Math.imul(In, Hi) | 0, Pe = Pe + Math.imul(In, en) | 0, Pe = Pe + Math.imul(Fn, Hi) | 0, ur = ur + Math.imul(Fn, en) | 0, nr = nr + Math.imul(rn, _n) | 0, Pe = Pe + Math.imul(rn, Tn) | 0, Pe = Pe + Math.imul(ji, _n) | 0, ur = ur + Math.imul(ji, Tn) | 0;
      var Fa = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Fa >>> 26) | 0, Fa &= 67108863, nr = Math.imul(Ci, Ai), Pe = Math.imul(Ci, ki), Pe = Pe + Math.imul(ri, Ai) | 0, ur = Math.imul(ri, ki), nr = nr + Math.imul(Xn, Ui) | 0, Pe = Pe + Math.imul(Xn, Vi) | 0, Pe = Pe + Math.imul(Yn, Ui) | 0, ur = ur + Math.imul(Yn, Vi) | 0, nr = nr + Math.imul(vn, Hi) | 0, Pe = Pe + Math.imul(vn, en) | 0, Pe = Pe + Math.imul(Vn, Hi) | 0, ur = ur + Math.imul(Vn, en) | 0, nr = nr + Math.imul(In, _n) | 0, Pe = Pe + Math.imul(In, Tn) | 0, Pe = Pe + Math.imul(Fn, _n) | 0, ur = ur + Math.imul(Fn, Tn) | 0;
      var ls = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ls >>> 26) | 0, ls &= 67108863, nr = Math.imul(Ci, Ui), Pe = Math.imul(Ci, Vi), Pe = Pe + Math.imul(ri, Ui) | 0, ur = Math.imul(ri, Vi), nr = nr + Math.imul(Xn, Hi) | 0, Pe = Pe + Math.imul(Xn, en) | 0, Pe = Pe + Math.imul(Yn, Hi) | 0, ur = ur + Math.imul(Yn, en) | 0, nr = nr + Math.imul(vn, _n) | 0, Pe = Pe + Math.imul(vn, Tn) | 0, Pe = Pe + Math.imul(Vn, _n) | 0, ur = ur + Math.imul(Vn, Tn) | 0;
      var us = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (us >>> 26) | 0, us &= 67108863, nr = Math.imul(Ci, Hi), Pe = Math.imul(Ci, en), Pe = Pe + Math.imul(ri, Hi) | 0, ur = Math.imul(ri, en), nr = nr + Math.imul(Xn, _n) | 0, Pe = Pe + Math.imul(Xn, Tn) | 0, Pe = Pe + Math.imul(Yn, _n) | 0, ur = ur + Math.imul(Yn, Tn) | 0;
      var Xa = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Xa >>> 26) | 0, Xa &= 67108863, nr = Math.imul(Ci, _n), Pe = Math.imul(Ci, Tn), Pe = Pe + Math.imul(ri, _n) | 0, ur = Math.imul(ri, Tn);
      var hs = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      return br = (ur + (Pe >>> 13) | 0) + (hs >>> 26) | 0, hs &= 67108863, pr[0] = xo, pr[1] = Co, pr[2] = $o, pr[3] = Bo, pr[4] = Qo, pr[5] = Go, pr[6] = No, pr[7] = Zo, pr[8] = ea, pr[9] = da, pr[10] = Ra, pr[11] = ba, pr[12] = Ea, pr[13] = Ha, pr[14] = Fa, pr[15] = ls, pr[16] = us, pr[17] = Xa, pr[18] = hs, br !== 0 && (pr[19] = br, Ue.length++), Ue;
    };
    Math.imul || (Rr = Ar);
    function Nr(vr, Ae, ze) {
      ze.negative = Ae.negative ^ vr.negative, ze.length = vr.length + Ae.length;
      for (var Ue = 0, tr = 0, lr = 0; lr < ze.length - 1; lr++) {
        var pr = tr;
        tr = 0;
        for (var br = Ue & 67108863, nr = Math.min(lr, Ae.length - 1), Pe = Math.max(0, lr - vr.length + 1); Pe <= nr; Pe++) {
          var ur = lr - Pe, Pr = vr.words[ur] | 0, Hr = Ae.words[Pe] | 0, vi = Pr * Hr, Ti = vi & 67108863;
          pr = pr + (vi / 67108864 | 0) | 0, Ti = Ti + br | 0, br = Ti & 67108863, pr = pr + (Ti >>> 26) | 0, tr += pr >>> 26, pr &= 67108863;
        }
        ze.words[lr] = br, Ue = pr, pr = tr;
      }
      return Ue !== 0 ? ze.words[lr] = Ue : ze.length--, ze.strip();
    }
    function Yr(vr, Ae, ze) {
      var Ue = new Vr();
      return Ue.mulp(vr, Ae, ze);
    }
    Me.prototype.mulTo = function(Ae, ze) {
      var Ue, tr = this.length + Ae.length;
      return this.length === 10 && Ae.length === 10 ? Ue = Rr(this, Ae, ze) : tr < 63 ? Ue = Ar(this, Ae, ze) : tr < 1024 ? Ue = Nr(this, Ae, ze) : Ue = Yr(this, Ae, ze), Ue;
    };
    function Vr(vr, Ae) {
      this.x = vr, this.y = Ae;
    }
    Vr.prototype.makeRBT = function(Ae) {
      for (var ze = new Array(Ae), Ue = Me.prototype._countBits(Ae) - 1, tr = 0; tr < Ae; tr++)
        ze[tr] = this.revBin(tr, Ue, Ae);
      return ze;
    }, Vr.prototype.revBin = function(Ae, ze, Ue) {
      if (Ae === 0 || Ae === Ue - 1)
        return Ae;
      for (var tr = 0, lr = 0; lr < ze; lr++)
        tr |= (Ae & 1) << ze - lr - 1, Ae >>= 1;
      return tr;
    }, Vr.prototype.permute = function(Ae, ze, Ue, tr, lr, pr) {
      for (var br = 0; br < pr; br++)
        tr[br] = ze[Ae[br]], lr[br] = Ue[Ae[br]];
    }, Vr.prototype.transform = function(Ae, ze, Ue, tr, lr, pr) {
      this.permute(pr, Ae, ze, Ue, tr, lr);
      for (var br = 1; br < lr; br <<= 1)
        for (var nr = br << 1, Pe = Math.cos(2 * Math.PI / nr), ur = Math.sin(2 * Math.PI / nr), Pr = 0; Pr < lr; Pr += nr)
          for (var Hr = Pe, vi = ur, Ti = 0; Ti < br; Ti++) {
            var wi = Ue[Pr + Ti], ii = tr[Pr + Ti], mi = Ue[Pr + Ti + br], ei = tr[Pr + Ti + br], Zr = Hr * mi - vi * ei;
            ei = Hr * ei + vi * mi, mi = Zr, Ue[Pr + Ti] = wi + mi, tr[Pr + Ti] = ii + ei, Ue[Pr + Ti + br] = wi - mi, tr[Pr + Ti + br] = ii - ei, Ti !== nr && (Zr = Pe * Hr - ur * vi, vi = Pe * vi + ur * Hr, Hr = Zr);
          }
    }, Vr.prototype.guessLen13b = function(Ae, ze) {
      var Ue = Math.max(ze, Ae) | 1, tr = Ue & 1, lr = 0;
      for (Ue = Ue / 2 | 0; Ue; Ue = Ue >>> 1)
        lr++;
      return 1 << lr + 1 + tr;
    }, Vr.prototype.conjugate = function(Ae, ze, Ue) {
      if (!(Ue <= 1))
        for (var tr = 0; tr < Ue / 2; tr++) {
          var lr = Ae[tr];
          Ae[tr] = Ae[Ue - tr - 1], Ae[Ue - tr - 1] = lr, lr = ze[tr], ze[tr] = -ze[Ue - tr - 1], ze[Ue - tr - 1] = -lr;
        }
    }, Vr.prototype.normalize13b = function(Ae, ze) {
      for (var Ue = 0, tr = 0; tr < ze / 2; tr++) {
        var lr = Math.round(Ae[2 * tr + 1] / ze) * 8192 + Math.round(Ae[2 * tr] / ze) + Ue;
        Ae[tr] = lr & 67108863, lr < 67108864 ? Ue = 0 : Ue = lr / 67108864 | 0;
      }
      return Ae;
    }, Vr.prototype.convert13b = function(Ae, ze, Ue, tr) {
      for (var lr = 0, pr = 0; pr < ze; pr++)
        lr = lr + (Ae[pr] | 0), Ue[2 * pr] = lr & 8191, lr = lr >>> 13, Ue[2 * pr + 1] = lr & 8191, lr = lr >>> 13;
      for (pr = 2 * ze; pr < tr; ++pr)
        Ue[pr] = 0;
      we(lr === 0), we((lr & -8192) === 0);
    }, Vr.prototype.stub = function(Ae) {
      for (var ze = new Array(Ae), Ue = 0; Ue < Ae; Ue++)
        ze[Ue] = 0;
      return ze;
    }, Vr.prototype.mulp = function(Ae, ze, Ue) {
      var tr = 2 * this.guessLen13b(Ae.length, ze.length), lr = this.makeRBT(tr), pr = this.stub(tr), br = new Array(tr), nr = new Array(tr), Pe = new Array(tr), ur = new Array(tr), Pr = new Array(tr), Hr = new Array(tr), vi = Ue.words;
      vi.length = tr, this.convert13b(Ae.words, Ae.length, br, tr), this.convert13b(ze.words, ze.length, ur, tr), this.transform(br, pr, nr, Pe, tr, lr), this.transform(ur, pr, Pr, Hr, tr, lr);
      for (var Ti = 0; Ti < tr; Ti++) {
        var wi = nr[Ti] * Pr[Ti] - Pe[Ti] * Hr[Ti];
        Pe[Ti] = nr[Ti] * Hr[Ti] + Pe[Ti] * Pr[Ti], nr[Ti] = wi;
      }
      return this.conjugate(nr, Pe, tr), this.transform(nr, Pe, vi, pr, tr, lr), this.conjugate(vi, pr, tr), this.normalize13b(vi, tr), Ue.negative = Ae.negative ^ ze.negative, Ue.length = Ae.length + ze.length, Ue.strip();
    }, Me.prototype.mul = function(Ae) {
      var ze = new Me(null);
      return ze.words = new Array(this.length + Ae.length), this.mulTo(Ae, ze);
    }, Me.prototype.mulf = function(Ae) {
      var ze = new Me(null);
      return ze.words = new Array(this.length + Ae.length), Yr(this, Ae, ze);
    }, Me.prototype.imul = function(Ae) {
      return this.clone().mulTo(Ae, this);
    }, Me.prototype.imuln = function(Ae) {
      we(typeof Ae == "number"), we(Ae < 67108864);
      for (var ze = 0, Ue = 0; Ue < this.length; Ue++) {
        var tr = (this.words[Ue] | 0) * Ae, lr = (tr & 67108863) + (ze & 67108863);
        ze >>= 26, ze += tr / 67108864 | 0, ze += lr >>> 26, this.words[Ue] = lr & 67108863;
      }
      return ze !== 0 && (this.words[Ue] = ze, this.length++), this;
    }, Me.prototype.muln = function(Ae) {
      return this.clone().imuln(Ae);
    }, Me.prototype.sqr = function() {
      return this.mul(this);
    }, Me.prototype.isqr = function() {
      return this.imul(this.clone());
    }, Me.prototype.pow = function(Ae) {
      var ze = Ir(Ae);
      if (ze.length === 0)
        return new Me(1);
      for (var Ue = this, tr = 0; tr < ze.length && ze[tr] === 0; tr++, Ue = Ue.sqr())
        ;
      if (++tr < ze.length)
        for (var lr = Ue.sqr(); tr < ze.length; tr++, lr = lr.sqr())
          ze[tr] !== 0 && (Ue = Ue.mul(lr));
      return Ue;
    }, Me.prototype.iushln = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 67108863 >>> 26 - ze << 26 - ze, lr;
      if (ze !== 0) {
        var pr = 0;
        for (lr = 0; lr < this.length; lr++) {
          var br = this.words[lr] & tr, nr = (this.words[lr] | 0) - br << ze;
          this.words[lr] = nr | pr, pr = br >>> 26 - ze;
        }
        pr && (this.words[lr] = pr, this.length++);
      }
      if (Ue !== 0) {
        for (lr = this.length - 1; lr >= 0; lr--)
          this.words[lr + Ue] = this.words[lr];
        for (lr = 0; lr < Ue; lr++)
          this.words[lr] = 0;
        this.length += Ue;
      }
      return this.strip();
    }, Me.prototype.ishln = function(Ae) {
      return we(this.negative === 0), this.iushln(Ae);
    }, Me.prototype.iushrn = function(Ae, ze, Ue) {
      we(typeof Ae == "number" && Ae >= 0);
      var tr;
      ze ? tr = (ze - ze % 26) / 26 : tr = 0;
      var lr = Ae % 26, pr = Math.min((Ae - lr) / 26, this.length), br = 67108863 ^ 67108863 >>> lr << lr, nr = Ue;
      if (tr -= pr, tr = Math.max(0, tr), nr) {
        for (var Pe = 0; Pe < pr; Pe++)
          nr.words[Pe] = this.words[Pe];
        nr.length = pr;
      }
      if (pr !== 0)
        if (this.length > pr)
          for (this.length -= pr, Pe = 0; Pe < this.length; Pe++)
            this.words[Pe] = this.words[Pe + pr];
        else
          this.words[0] = 0, this.length = 1;
      var ur = 0;
      for (Pe = this.length - 1; Pe >= 0 && (ur !== 0 || Pe >= tr); Pe--) {
        var Pr = this.words[Pe] | 0;
        this.words[Pe] = ur << 26 - lr | Pr >>> lr, ur = Pr & br;
      }
      return nr && ur !== 0 && (nr.words[nr.length++] = ur), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, Me.prototype.ishrn = function(Ae, ze, Ue) {
      return we(this.negative === 0), this.iushrn(Ae, ze, Ue);
    }, Me.prototype.shln = function(Ae) {
      return this.clone().ishln(Ae);
    }, Me.prototype.ushln = function(Ae) {
      return this.clone().iushln(Ae);
    }, Me.prototype.shrn = function(Ae) {
      return this.clone().ishrn(Ae);
    }, Me.prototype.ushrn = function(Ae) {
      return this.clone().iushrn(Ae);
    }, Me.prototype.testn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 1 << ze;
      if (this.length <= Ue)
        return !1;
      var lr = this.words[Ue];
      return !!(lr & tr);
    }, Me.prototype.imaskn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26;
      if (we(this.negative === 0, "imaskn works only with positive numbers"), this.length <= Ue)
        return this;
      if (ze !== 0 && Ue++, this.length = Math.min(Ue, this.length), ze !== 0) {
        var tr = 67108863 ^ 67108863 >>> ze << ze;
        this.words[this.length - 1] &= tr;
      }
      return this.strip();
    }, Me.prototype.maskn = function(Ae) {
      return this.clone().imaskn(Ae);
    }, Me.prototype.iaddn = function(Ae) {
      return we(typeof Ae == "number"), we(Ae < 67108864), Ae < 0 ? this.isubn(-Ae) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Ae ? (this.words[0] = Ae - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ae), this.negative = 1, this) : this._iaddn(Ae);
    }, Me.prototype._iaddn = function(Ae) {
      this.words[0] += Ae;
      for (var ze = 0; ze < this.length && this.words[ze] >= 67108864; ze++)
        this.words[ze] -= 67108864, ze === this.length - 1 ? this.words[ze + 1] = 1 : this.words[ze + 1]++;
      return this.length = Math.max(this.length, ze + 1), this;
    }, Me.prototype.isubn = function(Ae) {
      if (we(typeof Ae == "number"), we(Ae < 67108864), Ae < 0)
        return this.iaddn(-Ae);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(Ae), this.negative = 1, this;
      if (this.words[0] -= Ae, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var ze = 0; ze < this.length && this.words[ze] < 0; ze++)
          this.words[ze] += 67108864, this.words[ze + 1] -= 1;
      return this.strip();
    }, Me.prototype.addn = function(Ae) {
      return this.clone().iaddn(Ae);
    }, Me.prototype.subn = function(Ae) {
      return this.clone().isubn(Ae);
    }, Me.prototype.iabs = function() {
      return this.negative = 0, this;
    }, Me.prototype.abs = function() {
      return this.clone().iabs();
    }, Me.prototype._ishlnsubmul = function(Ae, ze, Ue) {
      var tr = Ae.length + Ue, lr;
      this._expand(tr);
      var pr, br = 0;
      for (lr = 0; lr < Ae.length; lr++) {
        pr = (this.words[lr + Ue] | 0) + br;
        var nr = (Ae.words[lr] | 0) * ze;
        pr -= nr & 67108863, br = (pr >> 26) - (nr / 67108864 | 0), this.words[lr + Ue] = pr & 67108863;
      }
      for (; lr < this.length - Ue; lr++)
        pr = (this.words[lr + Ue] | 0) + br, br = pr >> 26, this.words[lr + Ue] = pr & 67108863;
      if (br === 0)
        return this.strip();
      for (we(br === -1), br = 0, lr = 0; lr < this.length; lr++)
        pr = -(this.words[lr] | 0) + br, br = pr >> 26, this.words[lr] = pr & 67108863;
      return this.negative = 1, this.strip();
    }, Me.prototype._wordDiv = function(Ae, ze) {
      var Ue = this.length - Ae.length, tr = this.clone(), lr = Ae, pr = lr.words[lr.length - 1] | 0, br = this._countBits(pr);
      Ue = 26 - br, Ue !== 0 && (lr = lr.ushln(Ue), tr.iushln(Ue), pr = lr.words[lr.length - 1] | 0);
      var nr = tr.length - lr.length, Pe;
      if (ze !== "mod") {
        Pe = new Me(null), Pe.length = nr + 1, Pe.words = new Array(Pe.length);
        for (var ur = 0; ur < Pe.length; ur++)
          Pe.words[ur] = 0;
      }
      var Pr = tr.clone()._ishlnsubmul(lr, 1, nr);
      Pr.negative === 0 && (tr = Pr, Pe && (Pe.words[nr] = 1));
      for (var Hr = nr - 1; Hr >= 0; Hr--) {
        var vi = (tr.words[lr.length + Hr] | 0) * 67108864 + (tr.words[lr.length + Hr - 1] | 0);
        for (vi = Math.min(vi / pr | 0, 67108863), tr._ishlnsubmul(lr, vi, Hr); tr.negative !== 0; )
          vi--, tr.negative = 0, tr._ishlnsubmul(lr, 1, Hr), tr.isZero() || (tr.negative ^= 1);
        Pe && (Pe.words[Hr] = vi);
      }
      return Pe && Pe.strip(), tr.strip(), ze !== "div" && Ue !== 0 && tr.iushrn(Ue), {
        div: Pe || null,
        mod: tr
      };
    }, Me.prototype.divmod = function(Ae, ze, Ue) {
      if (we(!Ae.isZero()), this.isZero())
        return {
          div: new Me(0),
          mod: new Me(0)
        };
      var tr, lr, pr;
      return this.negative !== 0 && Ae.negative === 0 ? (pr = this.neg().divmod(Ae, ze), ze !== "mod" && (tr = pr.div.neg()), ze !== "div" && (lr = pr.mod.neg(), Ue && lr.negative !== 0 && lr.iadd(Ae)), {
        div: tr,
        mod: lr
      }) : this.negative === 0 && Ae.negative !== 0 ? (pr = this.divmod(Ae.neg(), ze), ze !== "mod" && (tr = pr.div.neg()), {
        div: tr,
        mod: pr.mod
      }) : (this.negative & Ae.negative) !== 0 ? (pr = this.neg().divmod(Ae.neg(), ze), ze !== "div" && (lr = pr.mod.neg(), Ue && lr.negative !== 0 && lr.isub(Ae)), {
        div: pr.div,
        mod: lr
      }) : Ae.length > this.length || this.cmp(Ae) < 0 ? {
        div: new Me(0),
        mod: this
      } : Ae.length === 1 ? ze === "div" ? {
        div: this.divn(Ae.words[0]),
        mod: null
      } : ze === "mod" ? {
        div: null,
        mod: new Me(this.modn(Ae.words[0]))
      } : {
        div: this.divn(Ae.words[0]),
        mod: new Me(this.modn(Ae.words[0]))
      } : this._wordDiv(Ae, ze);
    }, Me.prototype.div = function(Ae) {
      return this.divmod(Ae, "div", !1).div;
    }, Me.prototype.mod = function(Ae) {
      return this.divmod(Ae, "mod", !1).mod;
    }, Me.prototype.umod = function(Ae) {
      return this.divmod(Ae, "mod", !0).mod;
    }, Me.prototype.divRound = function(Ae) {
      var ze = this.divmod(Ae);
      if (ze.mod.isZero())
        return ze.div;
      var Ue = ze.div.negative !== 0 ? ze.mod.isub(Ae) : ze.mod, tr = Ae.ushrn(1), lr = Ae.andln(1), pr = Ue.cmp(tr);
      return pr < 0 || lr === 1 && pr === 0 ? ze.div : ze.div.negative !== 0 ? ze.div.isubn(1) : ze.div.iaddn(1);
    }, Me.prototype.modn = function(Ae) {
      we(Ae <= 67108863);
      for (var ze = (1 << 26) % Ae, Ue = 0, tr = this.length - 1; tr >= 0; tr--)
        Ue = (ze * Ue + (this.words[tr] | 0)) % Ae;
      return Ue;
    }, Me.prototype.idivn = function(Ae) {
      we(Ae <= 67108863);
      for (var ze = 0, Ue = this.length - 1; Ue >= 0; Ue--) {
        var tr = (this.words[Ue] | 0) + ze * 67108864;
        this.words[Ue] = tr / Ae | 0, ze = tr % Ae;
      }
      return this.strip();
    }, Me.prototype.divn = function(Ae) {
      return this.clone().idivn(Ae);
    }, Me.prototype.egcd = function(Ae) {
      we(Ae.negative === 0), we(!Ae.isZero());
      var ze = this, Ue = Ae.clone();
      ze.negative !== 0 ? ze = ze.umod(Ae) : ze = ze.clone();
      for (var tr = new Me(1), lr = new Me(0), pr = new Me(0), br = new Me(1), nr = 0; ze.isEven() && Ue.isEven(); )
        ze.iushrn(1), Ue.iushrn(1), ++nr;
      for (var Pe = Ue.clone(), ur = ze.clone(); !ze.isZero(); ) {
        for (var Pr = 0, Hr = 1; (ze.words[0] & Hr) === 0 && Pr < 26; ++Pr, Hr <<= 1)
          ;
        if (Pr > 0)
          for (ze.iushrn(Pr); Pr-- > 0; )
            (tr.isOdd() || lr.isOdd()) && (tr.iadd(Pe), lr.isub(ur)), tr.iushrn(1), lr.iushrn(1);
        for (var vi = 0, Ti = 1; (Ue.words[0] & Ti) === 0 && vi < 26; ++vi, Ti <<= 1)
          ;
        if (vi > 0)
          for (Ue.iushrn(vi); vi-- > 0; )
            (pr.isOdd() || br.isOdd()) && (pr.iadd(Pe), br.isub(ur)), pr.iushrn(1), br.iushrn(1);
        ze.cmp(Ue) >= 0 ? (ze.isub(Ue), tr.isub(pr), lr.isub(br)) : (Ue.isub(ze), pr.isub(tr), br.isub(lr));
      }
      return {
        a: pr,
        b: br,
        gcd: Ue.iushln(nr)
      };
    }, Me.prototype._invmp = function(Ae) {
      we(Ae.negative === 0), we(!Ae.isZero());
      var ze = this, Ue = Ae.clone();
      ze.negative !== 0 ? ze = ze.umod(Ae) : ze = ze.clone();
      for (var tr = new Me(1), lr = new Me(0), pr = Ue.clone(); ze.cmpn(1) > 0 && Ue.cmpn(1) > 0; ) {
        for (var br = 0, nr = 1; (ze.words[0] & nr) === 0 && br < 26; ++br, nr <<= 1)
          ;
        if (br > 0)
          for (ze.iushrn(br); br-- > 0; )
            tr.isOdd() && tr.iadd(pr), tr.iushrn(1);
        for (var Pe = 0, ur = 1; (Ue.words[0] & ur) === 0 && Pe < 26; ++Pe, ur <<= 1)
          ;
        if (Pe > 0)
          for (Ue.iushrn(Pe); Pe-- > 0; )
            lr.isOdd() && lr.iadd(pr), lr.iushrn(1);
        ze.cmp(Ue) >= 0 ? (ze.isub(Ue), tr.isub(lr)) : (Ue.isub(ze), lr.isub(tr));
      }
      var Pr;
      return ze.cmpn(1) === 0 ? Pr = tr : Pr = lr, Pr.cmpn(0) < 0 && Pr.iadd(Ae), Pr;
    }, Me.prototype.gcd = function(Ae) {
      if (this.isZero())
        return Ae.abs();
      if (Ae.isZero())
        return this.abs();
      var ze = this.clone(), Ue = Ae.clone();
      ze.negative = 0, Ue.negative = 0;
      for (var tr = 0; ze.isEven() && Ue.isEven(); tr++)
        ze.iushrn(1), Ue.iushrn(1);
      do {
        for (; ze.isEven(); )
          ze.iushrn(1);
        for (; Ue.isEven(); )
          Ue.iushrn(1);
        var lr = ze.cmp(Ue);
        if (lr < 0) {
          var pr = ze;
          ze = Ue, Ue = pr;
        } else if (lr === 0 || Ue.cmpn(1) === 0)
          break;
        ze.isub(Ue);
      } while (!0);
      return Ue.iushln(tr);
    }, Me.prototype.invm = function(Ae) {
      return this.egcd(Ae).a.umod(Ae);
    }, Me.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, Me.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, Me.prototype.andln = function(Ae) {
      return this.words[0] & Ae;
    }, Me.prototype.bincn = function(Ae) {
      we(typeof Ae == "number");
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 1 << ze;
      if (this.length <= Ue)
        return this._expand(Ue + 1), this.words[Ue] |= tr, this;
      for (var lr = tr, pr = Ue; lr !== 0 && pr < this.length; pr++) {
        var br = this.words[pr] | 0;
        br += lr, lr = br >>> 26, br &= 67108863, this.words[pr] = br;
      }
      return lr !== 0 && (this.words[pr] = lr, this.length++), this;
    }, Me.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, Me.prototype.cmpn = function(Ae) {
      var ze = Ae < 0;
      if (this.negative !== 0 && !ze)
        return -1;
      if (this.negative === 0 && ze)
        return 1;
      this.strip();
      var Ue;
      if (this.length > 1)
        Ue = 1;
      else {
        ze && (Ae = -Ae), we(Ae <= 67108863, "Number is too big");
        var tr = this.words[0] | 0;
        Ue = tr === Ae ? 0 : tr < Ae ? -1 : 1;
      }
      return this.negative !== 0 ? -Ue | 0 : Ue;
    }, Me.prototype.cmp = function(Ae) {
      if (this.negative !== 0 && Ae.negative === 0)
        return -1;
      if (this.negative === 0 && Ae.negative !== 0)
        return 1;
      var ze = this.ucmp(Ae);
      return this.negative !== 0 ? -ze | 0 : ze;
    }, Me.prototype.ucmp = function(Ae) {
      if (this.length > Ae.length)
        return 1;
      if (this.length < Ae.length)
        return -1;
      for (var ze = 0, Ue = this.length - 1; Ue >= 0; Ue--) {
        var tr = this.words[Ue] | 0, lr = Ae.words[Ue] | 0;
        if (tr !== lr) {
          tr < lr ? ze = -1 : tr > lr && (ze = 1);
          break;
        }
      }
      return ze;
    }, Me.prototype.gtn = function(Ae) {
      return this.cmpn(Ae) === 1;
    }, Me.prototype.gt = function(Ae) {
      return this.cmp(Ae) === 1;
    }, Me.prototype.gten = function(Ae) {
      return this.cmpn(Ae) >= 0;
    }, Me.prototype.gte = function(Ae) {
      return this.cmp(Ae) >= 0;
    }, Me.prototype.ltn = function(Ae) {
      return this.cmpn(Ae) === -1;
    }, Me.prototype.lt = function(Ae) {
      return this.cmp(Ae) === -1;
    }, Me.prototype.lten = function(Ae) {
      return this.cmpn(Ae) <= 0;
    }, Me.prototype.lte = function(Ae) {
      return this.cmp(Ae) <= 0;
    }, Me.prototype.eqn = function(Ae) {
      return this.cmpn(Ae) === 0;
    }, Me.prototype.eq = function(Ae) {
      return this.cmp(Ae) === 0;
    }, Me.red = function(Ae) {
      return new oi(Ae);
    }, Me.prototype.toRed = function(Ae) {
      return we(!this.red, "Already a number in reduction context"), we(this.negative === 0, "red works only with positives"), Ae.convertTo(this)._forceRed(Ae);
    }, Me.prototype.fromRed = function() {
      return we(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, Me.prototype._forceRed = function(Ae) {
      return this.red = Ae, this;
    }, Me.prototype.forceRed = function(Ae) {
      return we(!this.red, "Already a number in reduction context"), this._forceRed(Ae);
    }, Me.prototype.redAdd = function(Ae) {
      return we(this.red, "redAdd works only with red numbers"), this.red.add(this, Ae);
    }, Me.prototype.redIAdd = function(Ae) {
      return we(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ae);
    }, Me.prototype.redSub = function(Ae) {
      return we(this.red, "redSub works only with red numbers"), this.red.sub(this, Ae);
    }, Me.prototype.redISub = function(Ae) {
      return we(this.red, "redISub works only with red numbers"), this.red.isub(this, Ae);
    }, Me.prototype.redShl = function(Ae) {
      return we(this.red, "redShl works only with red numbers"), this.red.shl(this, Ae);
    }, Me.prototype.redMul = function(Ae) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ae), this.red.mul(this, Ae);
    }, Me.prototype.redIMul = function(Ae) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ae), this.red.imul(this, Ae);
    }, Me.prototype.redSqr = function() {
      return we(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, Me.prototype.redISqr = function() {
      return we(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, Me.prototype.redSqrt = function() {
      return we(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, Me.prototype.redInvm = function() {
      return we(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, Me.prototype.redNeg = function() {
      return we(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, Me.prototype.redPow = function(Ae) {
      return we(this.red && !Ae.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ae);
    };
    var Xr = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Wr(vr, Ae) {
      this.name = vr, this.p = new Me(Ae, 16), this.n = this.p.bitLength(), this.k = new Me(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Wr.prototype._tmp = function() {
      var Ae = new Me(null);
      return Ae.words = new Array(Math.ceil(this.n / 13)), Ae;
    }, Wr.prototype.ireduce = function(Ae) {
      var ze = Ae, Ue;
      do
        this.split(ze, this.tmp), ze = this.imulK(ze), ze = ze.iadd(this.tmp), Ue = ze.bitLength();
      while (Ue > this.n);
      var tr = Ue < this.n ? -1 : ze.ucmp(this.p);
      return tr === 0 ? (ze.words[0] = 0, ze.length = 1) : tr > 0 ? ze.isub(this.p) : ze.strip !== void 0 ? ze.strip() : ze._strip(), ze;
    }, Wr.prototype.split = function(Ae, ze) {
      Ae.iushrn(this.n, 0, ze);
    }, Wr.prototype.imulK = function(Ae) {
      return Ae.imul(this.k);
    };
    function si() {
      Wr.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    $e(si, Wr), si.prototype.split = function(Ae, ze) {
      for (var Ue = 4194303, tr = Math.min(Ae.length, 9), lr = 0; lr < tr; lr++)
        ze.words[lr] = Ae.words[lr];
      if (ze.length = tr, Ae.length <= 9) {
        Ae.words[0] = 0, Ae.length = 1;
        return;
      }
      var pr = Ae.words[9];
      for (ze.words[ze.length++] = pr & Ue, lr = 10; lr < Ae.length; lr++) {
        var br = Ae.words[lr] | 0;
        Ae.words[lr - 10] = (br & Ue) << 4 | pr >>> 22, pr = br;
      }
      pr >>>= 22, Ae.words[lr - 10] = pr, pr === 0 && Ae.length > 10 ? Ae.length -= 10 : Ae.length -= 9;
    }, si.prototype.imulK = function(Ae) {
      Ae.words[Ae.length] = 0, Ae.words[Ae.length + 1] = 0, Ae.length += 2;
      for (var ze = 0, Ue = 0; Ue < Ae.length; Ue++) {
        var tr = Ae.words[Ue] | 0;
        ze += tr * 977, Ae.words[Ue] = ze & 67108863, ze = tr * 64 + (ze / 67108864 | 0);
      }
      return Ae.words[Ae.length - 1] === 0 && (Ae.length--, Ae.words[Ae.length - 1] === 0 && Ae.length--), Ae;
    };
    function li() {
      Wr.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    $e(li, Wr);
    function xi() {
      Wr.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    $e(xi, Wr);
    function di() {
      Wr.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    $e(di, Wr), di.prototype.imulK = function(Ae) {
      for (var ze = 0, Ue = 0; Ue < Ae.length; Ue++) {
        var tr = (Ae.words[Ue] | 0) * 19 + ze, lr = tr & 67108863;
        tr >>>= 26, Ae.words[Ue] = lr, ze = tr;
      }
      return ze !== 0 && (Ae.words[Ae.length++] = ze), Ae;
    }, Me._prime = function(Ae) {
      if (Xr[Ae])
        return Xr[Ae];
      var ze;
      if (Ae === "k256")
        ze = new si();
      else if (Ae === "p224")
        ze = new li();
      else if (Ae === "p192")
        ze = new xi();
      else if (Ae === "p25519")
        ze = new di();
      else
        throw new Error("Unknown prime " + Ae);
      return Xr[Ae] = ze, ze;
    };
    function oi(vr) {
      if (typeof vr == "string") {
        var Ae = Me._prime(vr);
        this.m = Ae.p, this.prime = Ae;
      } else
        we(vr.gtn(1), "modulus must be greater than 1"), this.m = vr, this.prime = null;
    }
    oi.prototype._verify1 = function(Ae) {
      we(Ae.negative === 0, "red works only with positives"), we(Ae.red, "red works only with red numbers");
    }, oi.prototype._verify2 = function(Ae, ze) {
      we((Ae.negative | ze.negative) === 0, "red works only with positives"), we(
        Ae.red && Ae.red === ze.red,
        "red works only with red numbers"
      );
    }, oi.prototype.imod = function(Ae) {
      return this.prime ? this.prime.ireduce(Ae)._forceRed(this) : Ae.umod(this.m)._forceRed(this);
    }, oi.prototype.neg = function(Ae) {
      return Ae.isZero() ? Ae.clone() : this.m.sub(Ae)._forceRed(this);
    }, oi.prototype.add = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.add(ze);
      return Ue.cmp(this.m) >= 0 && Ue.isub(this.m), Ue._forceRed(this);
    }, oi.prototype.iadd = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.iadd(ze);
      return Ue.cmp(this.m) >= 0 && Ue.isub(this.m), Ue;
    }, oi.prototype.sub = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.sub(ze);
      return Ue.cmpn(0) < 0 && Ue.iadd(this.m), Ue._forceRed(this);
    }, oi.prototype.isub = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.isub(ze);
      return Ue.cmpn(0) < 0 && Ue.iadd(this.m), Ue;
    }, oi.prototype.shl = function(Ae, ze) {
      return this._verify1(Ae), this.imod(Ae.ushln(ze));
    }, oi.prototype.imul = function(Ae, ze) {
      return this._verify2(Ae, ze), this.imod(Ae.imul(ze));
    }, oi.prototype.mul = function(Ae, ze) {
      return this._verify2(Ae, ze), this.imod(Ae.mul(ze));
    }, oi.prototype.isqr = function(Ae) {
      return this.imul(Ae, Ae.clone());
    }, oi.prototype.sqr = function(Ae) {
      return this.mul(Ae, Ae);
    }, oi.prototype.sqrt = function(Ae) {
      if (Ae.isZero())
        return Ae.clone();
      var ze = this.m.andln(3);
      if (we(ze % 2 === 1), ze === 3) {
        var Ue = this.m.add(new Me(1)).iushrn(2);
        return this.pow(Ae, Ue);
      }
      for (var tr = this.m.subn(1), lr = 0; !tr.isZero() && tr.andln(1) === 0; )
        lr++, tr.iushrn(1);
      we(!tr.isZero());
      var pr = new Me(1).toRed(this), br = pr.redNeg(), nr = this.m.subn(1).iushrn(1), Pe = this.m.bitLength();
      for (Pe = new Me(2 * Pe * Pe).toRed(this); this.pow(Pe, nr).cmp(br) !== 0; )
        Pe.redIAdd(br);
      for (var ur = this.pow(Pe, tr), Pr = this.pow(Ae, tr.addn(1).iushrn(1)), Hr = this.pow(Ae, tr), vi = lr; Hr.cmp(pr) !== 0; ) {
        for (var Ti = Hr, wi = 0; Ti.cmp(pr) !== 0; wi++)
          Ti = Ti.redSqr();
        we(wi < vi);
        var ii = this.pow(ur, new Me(1).iushln(vi - wi - 1));
        Pr = Pr.redMul(ii), ur = ii.redSqr(), Hr = Hr.redMul(ur), vi = wi;
      }
      return Pr;
    }, oi.prototype.invm = function(Ae) {
      var ze = Ae._invmp(this.m);
      return ze.negative !== 0 ? (ze.negative = 0, this.imod(ze).redNeg()) : this.imod(ze);
    }, oi.prototype.pow = function(Ae, ze) {
      if (ze.isZero())
        return new Me(1).toRed(this);
      if (ze.cmpn(1) === 0)
        return Ae.clone();
      var Ue = 4, tr = new Array(1 << Ue);
      tr[0] = new Me(1).toRed(this), tr[1] = Ae;
      for (var lr = 2; lr < tr.length; lr++)
        tr[lr] = this.mul(tr[lr - 1], Ae);
      var pr = tr[0], br = 0, nr = 0, Pe = ze.bitLength() % 26;
      for (Pe === 0 && (Pe = 26), lr = ze.length - 1; lr >= 0; lr--) {
        for (var ur = ze.words[lr], Pr = Pe - 1; Pr >= 0; Pr--) {
          var Hr = ur >> Pr & 1;
          if (pr !== tr[0] && (pr = this.sqr(pr)), Hr === 0 && br === 0) {
            nr = 0;
            continue;
          }
          br <<= 1, br |= Hr, nr++, !(nr !== Ue && (lr !== 0 || Pr !== 0)) && (pr = this.mul(pr, tr[br]), nr = 0, br = 0);
        }
        Pe = 26;
      }
      return pr;
    }, oi.prototype.convertTo = function(Ae) {
      var ze = Ae.umod(this.m);
      return ze === Ae ? ze.clone() : ze;
    }, oi.prototype.convertFrom = function(Ae) {
      var ze = Ae.clone();
      return ze.red = null, ze;
    }, Me.mont = function(Ae) {
      return new ci(Ae);
    };
    function ci(vr) {
      oi.call(this, vr), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new Me(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    $e(ci, oi), ci.prototype.convertTo = function(Ae) {
      return this.imod(Ae.ushln(this.shift));
    }, ci.prototype.convertFrom = function(Ae) {
      var ze = this.imod(Ae.mul(this.rinv));
      return ze.red = null, ze;
    }, ci.prototype.imul = function(Ae, ze) {
      if (Ae.isZero() || ze.isZero())
        return Ae.words[0] = 0, Ae.length = 1, Ae;
      var Ue = Ae.imul(ze), tr = Ue.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), lr = Ue.isub(tr).iushrn(this.shift), pr = lr;
      return lr.cmp(this.m) >= 0 ? pr = lr.isub(this.m) : lr.cmpn(0) < 0 && (pr = lr.iadd(this.m)), pr._forceRed(this);
    }, ci.prototype.mul = function(Ae, ze) {
      if (Ae.isZero() || ze.isZero())
        return new Me(0)._forceRed(this);
      var Ue = Ae.mul(ze), tr = Ue.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), lr = Ue.isub(tr).iushrn(this.shift), pr = lr;
      return lr.cmp(this.m) >= 0 ? pr = lr.isub(this.m) : lr.cmpn(0) < 0 && (pr = lr.iadd(this.m)), pr._forceRed(this);
    }, ci.prototype.invm = function(Ae) {
      var ze = this.imod(Ae._invmp(this.m).mul(this.r2));
      return ze._forceRed(this);
    };
  })(m, commonjsGlobal);
})(bn$2);
var api$1 = {}, vmBrowserify = {}, hasRequiredVmBrowserify;
function requireVmBrowserify() {
  return hasRequiredVmBrowserify || (hasRequiredVmBrowserify = 1, function(exports) {
    var indexOf = function(m, c) {
      if (m.indexOf)
        return m.indexOf(c);
      for (var ie = 0; ie < m.length; ie++)
        if (m[ie] === c)
          return ie;
      return -1;
    }, Object_keys = function(m) {
      if (Object.keys)
        return Object.keys(m);
      var c = [];
      for (var ie in m)
        c.push(ie);
      return c;
    }, forEach = function(m, c) {
      if (m.forEach)
        return m.forEach(c);
      for (var ie = 0; ie < m.length; ie++)
        c(m[ie], ie, m);
    }, defineProp = function() {
      try {
        return Object.defineProperty({}, "_", {}), function(m, c, ie) {
          Object.defineProperty(m, c, {
            writable: !0,
            enumerable: !1,
            configurable: !0,
            value: ie
          });
        };
      } catch {
        return function(c, ie, we) {
          c[ie] = we;
        };
      }
    }(), globals = [
      "Array",
      "Boolean",
      "Date",
      "Error",
      "EvalError",
      "Function",
      "Infinity",
      "JSON",
      "Math",
      "NaN",
      "Number",
      "Object",
      "RangeError",
      "ReferenceError",
      "RegExp",
      "String",
      "SyntaxError",
      "TypeError",
      "URIError",
      "decodeURI",
      "decodeURIComponent",
      "encodeURI",
      "encodeURIComponent",
      "escape",
      "eval",
      "isFinite",
      "isNaN",
      "parseFloat",
      "parseInt",
      "undefined",
      "unescape"
    ];
    function Context() {
    }
    Context.prototype = {};
    var Script = exports.Script = function(c) {
      if (!(this instanceof Script))
        return new Script(c);
      this.code = c;
    };
    Script.prototype.runInContext = function(m) {
      if (!(m instanceof Context))
        throw new TypeError("needs a 'context' argument.");
      var c = document.createElement("iframe");
      c.style || (c.style = {}), c.style.display = "none", document.body.appendChild(c);
      var ie = c.contentWindow, we = ie.eval, $e = ie.execScript;
      !we && $e && ($e.call(ie, "null"), we = ie.eval), forEach(Object_keys(m), function(ne) {
        ie[ne] = m[ne];
      }), forEach(globals, function(ne) {
        m[ne] && (ie[ne] = m[ne]);
      });
      var Me = Object_keys(ie), Ze = we.call(ie, this.code);
      return forEach(Object_keys(ie), function(ne) {
        (ne in m || indexOf(Me, ne) === -1) && (m[ne] = ie[ne]);
      }), forEach(globals, function(ne) {
        ne in m || defineProp(m, ne, ie[ne]);
      }), document.body.removeChild(c), Ze;
    }, Script.prototype.runInThisContext = function() {
      return eval(this.code);
    }, Script.prototype.runInNewContext = function(m) {
      var c = Script.createContext(m), ie = this.runInContext(c);
      return m && forEach(Object_keys(c), function(we) {
        m[we] = c[we];
      }), ie;
    }, forEach(Object_keys(Script.prototype), function(m) {
      exports[m] = Script[m] = function(c) {
        var ie = Script(c);
        return ie[m].apply(ie, [].slice.call(arguments, 1));
      };
    }), exports.isContext = function(m) {
      return m instanceof Context;
    }, exports.createScript = function(m) {
      return exports.Script(m);
    }, exports.createContext = Script.createContext = function(m) {
      var c = new Context();
      return typeof m == "object" && forEach(Object_keys(m), function(ie) {
        c[ie] = m[ie];
      }), c;
    };
  }(vmBrowserify)), vmBrowserify;
}
var hasRequiredApi;
function requireApi() {
  return hasRequiredApi || (hasRequiredApi = 1, function(m) {
    var c = requireAsn1(), ie = inherits_browser.exports, we = m;
    we.define = function(Ze, ne) {
      return new $e(Ze, ne);
    };
    function $e(Me, Ze) {
      this.name = Me, this.body = Ze, this.decoders = {}, this.encoders = {};
    }
    $e.prototype._createNamed = function(Ze) {
      var ne;
      try {
        ne = requireVmBrowserify().runInThisContext(
          "(function " + this.name + `(entity) {
  this._initNamed(entity);
})`
        );
      } catch {
        ne = function(gr) {
          this._initNamed(gr);
        };
      }
      return ie(ne, Ze), ne.prototype._initNamed = function(gr) {
        Ze.call(this, gr);
      }, new ne(this);
    }, $e.prototype._getDecoder = function(Ze) {
      return Ze = Ze || "der", this.decoders.hasOwnProperty(Ze) || (this.decoders[Ze] = this._createNamed(c.decoders[Ze])), this.decoders[Ze];
    }, $e.prototype.decode = function(Ze, ne, rr) {
      return this._getDecoder(ne).decode(Ze, rr);
    }, $e.prototype._getEncoder = function(Ze) {
      return Ze = Ze || "der", this.encoders.hasOwnProperty(Ze) || (this.encoders[Ze] = this._createNamed(c.encoders[Ze])), this.encoders[Ze];
    }, $e.prototype.encode = function(Ze, ne, rr) {
      return this._getEncoder(ne).encode(Ze, rr);
    };
  }(api$1)), api$1;
}
var base = {}, reporter = {}, inherits$2 = inherits_browser.exports;
function Reporter(m) {
  this._reporterState = {
    obj: null,
    path: [],
    options: m || {},
    errors: []
  };
}
reporter.Reporter = Reporter;
Reporter.prototype.isError = function m(c) {
  return c instanceof ReporterError;
};
Reporter.prototype.save = function m() {
  var c = this._reporterState;
  return { obj: c.obj, pathLen: c.path.length };
};
Reporter.prototype.restore = function m(c) {
  var ie = this._reporterState;
  ie.obj = c.obj, ie.path = ie.path.slice(0, c.pathLen);
};
Reporter.prototype.enterKey = function m(c) {
  return this._reporterState.path.push(c);
};
Reporter.prototype.exitKey = function m(c) {
  var ie = this._reporterState;
  ie.path = ie.path.slice(0, c - 1);
};
Reporter.prototype.leaveKey = function m(c, ie, we) {
  var $e = this._reporterState;
  this.exitKey(c), $e.obj !== null && ($e.obj[ie] = we);
};
Reporter.prototype.path = function m() {
  return this._reporterState.path.join("/");
};
Reporter.prototype.enterObject = function m() {
  var c = this._reporterState, ie = c.obj;
  return c.obj = {}, ie;
};
Reporter.prototype.leaveObject = function m(c) {
  var ie = this._reporterState, we = ie.obj;
  return ie.obj = c, we;
};
Reporter.prototype.error = function m(c) {
  var ie, we = this._reporterState, $e = c instanceof ReporterError;
  if ($e ? ie = c : ie = new ReporterError(we.path.map(function(Me) {
    return "[" + JSON.stringify(Me) + "]";
  }).join(""), c.message || c, c.stack), !we.options.partial)
    throw ie;
  return $e || we.errors.push(ie), ie;
};
Reporter.prototype.wrapResult = function m(c) {
  var ie = this._reporterState;
  return ie.options.partial ? {
    result: this.isError(c) ? null : c,
    errors: ie.errors
  } : c;
};
function ReporterError(m, c) {
  this.path = m, this.rethrow(c);
}
inherits$2(ReporterError, Error);
ReporterError.prototype.rethrow = function m(c) {
  if (this.message = c + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, ReporterError), !this.stack)
    try {
      throw new Error(this.message);
    } catch (ie) {
      this.stack = ie.stack;
    }
  return this;
};
var buffer = {}, hasRequiredBuffer;
function requireBuffer() {
  if (hasRequiredBuffer)
    return buffer;
  hasRequiredBuffer = 1;
  var m = inherits_browser.exports, c = requireBase().Reporter, ie = require$$0$4.Buffer;
  function we(Me, Ze) {
    if (c.call(this, Ze), !ie.isBuffer(Me)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = Me, this.offset = 0, this.length = Me.length;
  }
  m(we, c), buffer.DecoderBuffer = we, we.prototype.save = function() {
    return { offset: this.offset, reporter: c.prototype.save.call(this) };
  }, we.prototype.restore = function(Ze) {
    var ne = new we(this.base);
    return ne.offset = Ze.offset, ne.length = this.offset, this.offset = Ze.offset, c.prototype.restore.call(this, Ze.reporter), ne;
  }, we.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, we.prototype.readUInt8 = function(Ze) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(Ze || "DecoderBuffer overrun");
  }, we.prototype.skip = function(Ze, ne) {
    if (!(this.offset + Ze <= this.length))
      return this.error(ne || "DecoderBuffer overrun");
    var rr = new we(this.base);
    return rr._reporterState = this._reporterState, rr.offset = this.offset, rr.length = this.offset + Ze, this.offset += Ze, rr;
  }, we.prototype.raw = function(Ze) {
    return this.base.slice(Ze ? Ze.offset : this.offset, this.length);
  };
  function $e(Me, Ze) {
    if (Array.isArray(Me))
      this.length = 0, this.value = Me.map(function(ne) {
        return ne instanceof $e || (ne = new $e(ne, Ze)), this.length += ne.length, ne;
      }, this);
    else if (typeof Me == "number") {
      if (!(0 <= Me && Me <= 255))
        return Ze.error("non-byte EncoderBuffer value");
      this.value = Me, this.length = 1;
    } else if (typeof Me == "string")
      this.value = Me, this.length = ie.byteLength(Me);
    else if (ie.isBuffer(Me))
      this.value = Me, this.length = Me.length;
    else
      return Ze.error("Unsupported type: " + typeof Me);
  }
  return buffer.EncoderBuffer = $e, $e.prototype.join = function(Ze, ne) {
    return Ze || (Ze = new ie(this.length)), ne || (ne = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(rr) {
      rr.join(Ze, ne), ne += rr.length;
    }) : (typeof this.value == "number" ? Ze[ne] = this.value : typeof this.value == "string" ? Ze.write(this.value, ne) : ie.isBuffer(this.value) && this.value.copy(Ze, ne), ne += this.length)), Ze;
  }, buffer;
}
var node, hasRequiredNode;
function requireNode() {
  if (hasRequiredNode)
    return node;
  hasRequiredNode = 1;
  var m = requireBase().Reporter, c = requireBase().EncoderBuffer, ie = requireBase().DecoderBuffer, we = minimalisticAssert, $e = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], Me = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat($e), Ze = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function ne(gr, or) {
    var _r = {};
    this._baseState = _r, _r.enc = gr, _r.parent = or || null, _r.children = null, _r.tag = null, _r.args = null, _r.reverseArgs = null, _r.choice = null, _r.optional = !1, _r.any = !1, _r.obj = !1, _r.use = null, _r.useDecoder = null, _r.key = null, _r.default = null, _r.explicit = null, _r.implicit = null, _r.contains = null, _r.parent || (_r.children = [], this._wrap());
  }
  node = ne;
  var rr = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return ne.prototype.clone = function() {
    var or = this._baseState, _r = {};
    rr.forEach(function(Ir) {
      _r[Ir] = or[Ir];
    });
    var Lr = new this.constructor(_r.parent);
    return Lr._baseState = _r, Lr;
  }, ne.prototype._wrap = function() {
    var or = this._baseState;
    Me.forEach(function(_r) {
      this[_r] = function() {
        var Ir = new this.constructor(this);
        return or.children.push(Ir), Ir[_r].apply(Ir, arguments);
      };
    }, this);
  }, ne.prototype._init = function(or) {
    var _r = this._baseState;
    we(_r.parent === null), or.call(this), _r.children = _r.children.filter(function(Lr) {
      return Lr._baseState.parent === this;
    }, this), we.equal(_r.children.length, 1, "Root node can have only one child");
  }, ne.prototype._useArgs = function(or) {
    var _r = this._baseState, Lr = or.filter(function(Ir) {
      return Ir instanceof this.constructor;
    }, this);
    or = or.filter(function(Ir) {
      return !(Ir instanceof this.constructor);
    }, this), Lr.length !== 0 && (we(_r.children === null), _r.children = Lr, Lr.forEach(function(Ir) {
      Ir._baseState.parent = this;
    }, this)), or.length !== 0 && (we(_r.args === null), _r.args = or, _r.reverseArgs = or.map(function(Ir) {
      if (typeof Ir != "object" || Ir.constructor !== Object)
        return Ir;
      var Ar = {};
      return Object.keys(Ir).forEach(function(Rr) {
        Rr == (Rr | 0) && (Rr |= 0);
        var Nr = Ir[Rr];
        Ar[Nr] = Rr;
      }), Ar;
    }));
  }, Ze.forEach(function(gr) {
    ne.prototype[gr] = function() {
      var _r = this._baseState;
      throw new Error(gr + " not implemented for encoding: " + _r.enc);
    };
  }), $e.forEach(function(gr) {
    ne.prototype[gr] = function() {
      var _r = this._baseState, Lr = Array.prototype.slice.call(arguments);
      return we(_r.tag === null), _r.tag = gr, this._useArgs(Lr), this;
    };
  }), ne.prototype.use = function(or) {
    we(or);
    var _r = this._baseState;
    return we(_r.use === null), _r.use = or, this;
  }, ne.prototype.optional = function() {
    var or = this._baseState;
    return or.optional = !0, this;
  }, ne.prototype.def = function(or) {
    var _r = this._baseState;
    return we(_r.default === null), _r.default = or, _r.optional = !0, this;
  }, ne.prototype.explicit = function(or) {
    var _r = this._baseState;
    return we(_r.explicit === null && _r.implicit === null), _r.explicit = or, this;
  }, ne.prototype.implicit = function(or) {
    var _r = this._baseState;
    return we(_r.explicit === null && _r.implicit === null), _r.implicit = or, this;
  }, ne.prototype.obj = function() {
    var or = this._baseState, _r = Array.prototype.slice.call(arguments);
    return or.obj = !0, _r.length !== 0 && this._useArgs(_r), this;
  }, ne.prototype.key = function(or) {
    var _r = this._baseState;
    return we(_r.key === null), _r.key = or, this;
  }, ne.prototype.any = function() {
    var or = this._baseState;
    return or.any = !0, this;
  }, ne.prototype.choice = function(or) {
    var _r = this._baseState;
    return we(_r.choice === null), _r.choice = or, this._useArgs(Object.keys(or).map(function(Lr) {
      return or[Lr];
    })), this;
  }, ne.prototype.contains = function(or) {
    var _r = this._baseState;
    return we(_r.use === null), _r.contains = or, this;
  }, ne.prototype._decode = function(or, _r) {
    var Lr = this._baseState;
    if (Lr.parent === null)
      return or.wrapResult(Lr.children[0]._decode(or, _r));
    var Ir = Lr.default, Ar = !0, Rr = null;
    if (Lr.key !== null && (Rr = or.enterKey(Lr.key)), Lr.optional) {
      var Nr = null;
      if (Lr.explicit !== null ? Nr = Lr.explicit : Lr.implicit !== null ? Nr = Lr.implicit : Lr.tag !== null && (Nr = Lr.tag), Nr === null && !Lr.any) {
        var Yr = or.save();
        try {
          Lr.choice === null ? this._decodeGeneric(Lr.tag, or, _r) : this._decodeChoice(or, _r), Ar = !0;
        } catch {
          Ar = !1;
        }
        or.restore(Yr);
      } else if (Ar = this._peekTag(or, Nr, Lr.any), or.isError(Ar))
        return Ar;
    }
    var Vr;
    if (Lr.obj && Ar && (Vr = or.enterObject()), Ar) {
      if (Lr.explicit !== null) {
        var Xr = this._decodeTag(or, Lr.explicit);
        if (or.isError(Xr))
          return Xr;
        or = Xr;
      }
      var Wr = or.offset;
      if (Lr.use === null && Lr.choice === null) {
        if (Lr.any)
          var Yr = or.save();
        var si = this._decodeTag(
          or,
          Lr.implicit !== null ? Lr.implicit : Lr.tag,
          Lr.any
        );
        if (or.isError(si))
          return si;
        Lr.any ? Ir = or.raw(Yr) : or = si;
      }
      if (_r && _r.track && Lr.tag !== null && _r.track(or.path(), Wr, or.length, "tagged"), _r && _r.track && Lr.tag !== null && _r.track(or.path(), or.offset, or.length, "content"), Lr.any ? Ir = Ir : Lr.choice === null ? Ir = this._decodeGeneric(Lr.tag, or, _r) : Ir = this._decodeChoice(or, _r), or.isError(Ir))
        return Ir;
      if (!Lr.any && Lr.choice === null && Lr.children !== null && Lr.children.forEach(function(di) {
        di._decode(or, _r);
      }), Lr.contains && (Lr.tag === "octstr" || Lr.tag === "bitstr")) {
        var li = new ie(Ir);
        Ir = this._getUse(Lr.contains, or._reporterState.obj)._decode(li, _r);
      }
    }
    return Lr.obj && Ar && (Ir = or.leaveObject(Vr)), Lr.key !== null && (Ir !== null || Ar === !0) ? or.leaveKey(Rr, Lr.key, Ir) : Rr !== null && or.exitKey(Rr), Ir;
  }, ne.prototype._decodeGeneric = function(or, _r, Lr) {
    var Ir = this._baseState;
    return or === "seq" || or === "set" ? null : or === "seqof" || or === "setof" ? this._decodeList(_r, or, Ir.args[0], Lr) : /str$/.test(or) ? this._decodeStr(_r, or, Lr) : or === "objid" && Ir.args ? this._decodeObjid(_r, Ir.args[0], Ir.args[1], Lr) : or === "objid" ? this._decodeObjid(_r, null, null, Lr) : or === "gentime" || or === "utctime" ? this._decodeTime(_r, or, Lr) : or === "null_" ? this._decodeNull(_r, Lr) : or === "bool" ? this._decodeBool(_r, Lr) : or === "objDesc" ? this._decodeStr(_r, or, Lr) : or === "int" || or === "enum" ? this._decodeInt(_r, Ir.args && Ir.args[0], Lr) : Ir.use !== null ? this._getUse(Ir.use, _r._reporterState.obj)._decode(_r, Lr) : _r.error("unknown tag: " + or);
  }, ne.prototype._getUse = function(or, _r) {
    var Lr = this._baseState;
    return Lr.useDecoder = this._use(or, _r), we(Lr.useDecoder._baseState.parent === null), Lr.useDecoder = Lr.useDecoder._baseState.children[0], Lr.implicit !== Lr.useDecoder._baseState.implicit && (Lr.useDecoder = Lr.useDecoder.clone(), Lr.useDecoder._baseState.implicit = Lr.implicit), Lr.useDecoder;
  }, ne.prototype._decodeChoice = function(or, _r) {
    var Lr = this._baseState, Ir = null, Ar = !1;
    return Object.keys(Lr.choice).some(function(Rr) {
      var Nr = or.save(), Yr = Lr.choice[Rr];
      try {
        var Vr = Yr._decode(or, _r);
        if (or.isError(Vr))
          return !1;
        Ir = { type: Rr, value: Vr }, Ar = !0;
      } catch {
        return or.restore(Nr), !1;
      }
      return !0;
    }, this), Ar ? Ir : or.error("Choice not matched");
  }, ne.prototype._createEncoderBuffer = function(or) {
    return new c(or, this.reporter);
  }, ne.prototype._encode = function(or, _r, Lr) {
    var Ir = this._baseState;
    if (!(Ir.default !== null && Ir.default === or)) {
      var Ar = this._encodeValue(or, _r, Lr);
      if (Ar !== void 0 && !this._skipDefault(Ar, _r, Lr))
        return Ar;
    }
  }, ne.prototype._encodeValue = function(or, _r, Lr) {
    var Ir = this._baseState;
    if (Ir.parent === null)
      return Ir.children[0]._encode(or, _r || new m());
    var Yr = null;
    if (this.reporter = _r, Ir.optional && or === void 0)
      if (Ir.default !== null)
        or = Ir.default;
      else
        return;
    var Ar = null, Rr = !1;
    if (Ir.any)
      Yr = this._createEncoderBuffer(or);
    else if (Ir.choice)
      Yr = this._encodeChoice(or, _r);
    else if (Ir.contains)
      Ar = this._getUse(Ir.contains, Lr)._encode(or, _r), Rr = !0;
    else if (Ir.children)
      Ar = Ir.children.map(function(Wr) {
        if (Wr._baseState.tag === "null_")
          return Wr._encode(null, _r, or);
        if (Wr._baseState.key === null)
          return _r.error("Child should have a key");
        var si = _r.enterKey(Wr._baseState.key);
        if (typeof or != "object")
          return _r.error("Child expected, but input is not object");
        var li = Wr._encode(or[Wr._baseState.key], _r, or);
        return _r.leaveKey(si), li;
      }, this).filter(function(Wr) {
        return Wr;
      }), Ar = this._createEncoderBuffer(Ar);
    else if (Ir.tag === "seqof" || Ir.tag === "setof") {
      if (!(Ir.args && Ir.args.length === 1))
        return _r.error("Too many args for : " + Ir.tag);
      if (!Array.isArray(or))
        return _r.error("seqof/setof, but data is not Array");
      var Nr = this.clone();
      Nr._baseState.implicit = null, Ar = this._createEncoderBuffer(or.map(function(Wr) {
        var si = this._baseState;
        return this._getUse(si.args[0], or)._encode(Wr, _r);
      }, Nr));
    } else
      Ir.use !== null ? Yr = this._getUse(Ir.use, Lr)._encode(or, _r) : (Ar = this._encodePrimitive(Ir.tag, or), Rr = !0);
    var Yr;
    if (!Ir.any && Ir.choice === null) {
      var Vr = Ir.implicit !== null ? Ir.implicit : Ir.tag, Xr = Ir.implicit === null ? "universal" : "context";
      Vr === null ? Ir.use === null && _r.error("Tag could be omitted only for .use()") : Ir.use === null && (Yr = this._encodeComposite(Vr, Rr, Xr, Ar));
    }
    return Ir.explicit !== null && (Yr = this._encodeComposite(Ir.explicit, !1, "context", Yr)), Yr;
  }, ne.prototype._encodeChoice = function(or, _r) {
    var Lr = this._baseState, Ir = Lr.choice[or.type];
    return Ir || we(
      !1,
      or.type + " not found in " + JSON.stringify(Object.keys(Lr.choice))
    ), Ir._encode(or.value, _r);
  }, ne.prototype._encodePrimitive = function(or, _r) {
    var Lr = this._baseState;
    if (/str$/.test(or))
      return this._encodeStr(_r, or);
    if (or === "objid" && Lr.args)
      return this._encodeObjid(_r, Lr.reverseArgs[0], Lr.args[1]);
    if (or === "objid")
      return this._encodeObjid(_r, null, null);
    if (or === "gentime" || or === "utctime")
      return this._encodeTime(_r, or);
    if (or === "null_")
      return this._encodeNull();
    if (or === "int" || or === "enum")
      return this._encodeInt(_r, Lr.args && Lr.reverseArgs[0]);
    if (or === "bool")
      return this._encodeBool(_r);
    if (or === "objDesc")
      return this._encodeStr(_r, or);
    throw new Error("Unsupported tag: " + or);
  }, ne.prototype._isNumstr = function(or) {
    return /^[0-9 ]*$/.test(or);
  }, ne.prototype._isPrintstr = function(or) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(or);
  }, node;
}
var hasRequiredBase;
function requireBase() {
  return hasRequiredBase || (hasRequiredBase = 1, function(m) {
    var c = m;
    c.Reporter = reporter.Reporter, c.DecoderBuffer = requireBuffer().DecoderBuffer, c.EncoderBuffer = requireBuffer().EncoderBuffer, c.Node = requireNode();
  }(base)), base;
}
var constants$2 = {}, der = {}, hasRequiredDer$2;
function requireDer$2() {
  return hasRequiredDer$2 || (hasRequiredDer$2 = 1, function(m) {
    var c = requireConstants();
    m.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, m.tagClassByName = c._reverse(m.tagClass), m.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, m.tagByName = c._reverse(m.tag);
  }(der)), der;
}
var hasRequiredConstants;
function requireConstants() {
  return hasRequiredConstants || (hasRequiredConstants = 1, function(m) {
    var c = m;
    c._reverse = function(we) {
      var $e = {};
      return Object.keys(we).forEach(function(Me) {
        (Me | 0) == Me && (Me = Me | 0);
        var Ze = we[Me];
        $e[Ze] = Me;
      }), $e;
    }, c.der = requireDer$2();
  }(constants$2)), constants$2;
}
var decoders = {}, der_1$1, hasRequiredDer$1;
function requireDer$1() {
  if (hasRequiredDer$1)
    return der_1$1;
  hasRequiredDer$1 = 1;
  var m = inherits_browser.exports, c = requireAsn1(), ie = c.base, we = c.bignum, $e = c.constants.der;
  function Me(gr) {
    this.enc = "der", this.name = gr.name, this.entity = gr, this.tree = new Ze(), this.tree._init(gr.body);
  }
  der_1$1 = Me, Me.prototype.decode = function(or, _r) {
    return or instanceof ie.DecoderBuffer || (or = new ie.DecoderBuffer(or, _r)), this.tree._decode(or, _r);
  };
  function Ze(gr) {
    ie.Node.call(this, "der", gr);
  }
  m(Ze, ie.Node), Ze.prototype._peekTag = function(or, _r, Lr) {
    if (or.isEmpty())
      return !1;
    var Ir = or.save(), Ar = ne(or, 'Failed to peek tag: "' + _r + '"');
    return or.isError(Ar) ? Ar : (or.restore(Ir), Ar.tag === _r || Ar.tagStr === _r || Ar.tagStr + "of" === _r || Lr);
  }, Ze.prototype._decodeTag = function(or, _r, Lr) {
    var Ir = ne(
      or,
      'Failed to decode tag of "' + _r + '"'
    );
    if (or.isError(Ir))
      return Ir;
    var Ar = rr(
      or,
      Ir.primitive,
      'Failed to get length of "' + _r + '"'
    );
    if (or.isError(Ar))
      return Ar;
    if (!Lr && Ir.tag !== _r && Ir.tagStr !== _r && Ir.tagStr + "of" !== _r)
      return or.error('Failed to match tag: "' + _r + '"');
    if (Ir.primitive || Ar !== null)
      return or.skip(Ar, 'Failed to match body of: "' + _r + '"');
    var Rr = or.save(), Nr = this._skipUntilEnd(
      or,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return or.isError(Nr) ? Nr : (Ar = or.offset - Rr.offset, or.restore(Rr), or.skip(Ar, 'Failed to match body of: "' + _r + '"'));
  }, Ze.prototype._skipUntilEnd = function(or, _r) {
    for (; ; ) {
      var Lr = ne(or, _r);
      if (or.isError(Lr))
        return Lr;
      var Ir = rr(or, Lr.primitive, _r);
      if (or.isError(Ir))
        return Ir;
      var Ar;
      if (Lr.primitive || Ir !== null ? Ar = or.skip(Ir) : Ar = this._skipUntilEnd(or, _r), or.isError(Ar))
        return Ar;
      if (Lr.tagStr === "end")
        break;
    }
  }, Ze.prototype._decodeList = function(or, _r, Lr, Ir) {
    for (var Ar = []; !or.isEmpty(); ) {
      var Rr = this._peekTag(or, "end");
      if (or.isError(Rr))
        return Rr;
      var Nr = Lr.decode(or, "der", Ir);
      if (or.isError(Nr) && Rr)
        break;
      Ar.push(Nr);
    }
    return Ar;
  }, Ze.prototype._decodeStr = function(or, _r) {
    if (_r === "bitstr") {
      var Lr = or.readUInt8();
      return or.isError(Lr) ? Lr : { unused: Lr, data: or.raw() };
    } else if (_r === "bmpstr") {
      var Ir = or.raw();
      if (Ir.length % 2 === 1)
        return or.error("Decoding of string type: bmpstr length mismatch");
      for (var Ar = "", Rr = 0; Rr < Ir.length / 2; Rr++)
        Ar += String.fromCharCode(Ir.readUInt16BE(Rr * 2));
      return Ar;
    } else if (_r === "numstr") {
      var Nr = or.raw().toString("ascii");
      return this._isNumstr(Nr) ? Nr : or.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (_r === "octstr")
        return or.raw();
      if (_r === "objDesc")
        return or.raw();
      if (_r === "printstr") {
        var Yr = or.raw().toString("ascii");
        return this._isPrintstr(Yr) ? Yr : or.error("Decoding of string type: printstr unsupported characters");
      } else
        return /str$/.test(_r) ? or.raw().toString() : or.error("Decoding of string type: " + _r + " unsupported");
    }
  }, Ze.prototype._decodeObjid = function(or, _r, Lr) {
    for (var Ir, Ar = [], Rr = 0; !or.isEmpty(); ) {
      var Nr = or.readUInt8();
      Rr <<= 7, Rr |= Nr & 127, (Nr & 128) === 0 && (Ar.push(Rr), Rr = 0);
    }
    Nr & 128 && Ar.push(Rr);
    var Yr = Ar[0] / 40 | 0, Vr = Ar[0] % 40;
    if (Lr ? Ir = Ar : Ir = [Yr, Vr].concat(Ar.slice(1)), _r) {
      var Xr = _r[Ir.join(" ")];
      Xr === void 0 && (Xr = _r[Ir.join(".")]), Xr !== void 0 && (Ir = Xr);
    }
    return Ir;
  }, Ze.prototype._decodeTime = function(or, _r) {
    var Lr = or.raw().toString();
    if (_r === "gentime")
      var Ir = Lr.slice(0, 4) | 0, Ar = Lr.slice(4, 6) | 0, Rr = Lr.slice(6, 8) | 0, Nr = Lr.slice(8, 10) | 0, Yr = Lr.slice(10, 12) | 0, Vr = Lr.slice(12, 14) | 0;
    else if (_r === "utctime") {
      var Ir = Lr.slice(0, 2) | 0, Ar = Lr.slice(2, 4) | 0, Rr = Lr.slice(4, 6) | 0, Nr = Lr.slice(6, 8) | 0, Yr = Lr.slice(8, 10) | 0, Vr = Lr.slice(10, 12) | 0;
      Ir < 70 ? Ir = 2e3 + Ir : Ir = 1900 + Ir;
    } else
      return or.error("Decoding " + _r + " time is not supported yet");
    return Date.UTC(Ir, Ar - 1, Rr, Nr, Yr, Vr, 0);
  }, Ze.prototype._decodeNull = function(or) {
    return null;
  }, Ze.prototype._decodeBool = function(or) {
    var _r = or.readUInt8();
    return or.isError(_r) ? _r : _r !== 0;
  }, Ze.prototype._decodeInt = function(or, _r) {
    var Lr = or.raw(), Ir = new we(Lr);
    return _r && (Ir = _r[Ir.toString(10)] || Ir), Ir;
  }, Ze.prototype._use = function(or, _r) {
    return typeof or == "function" && (or = or(_r)), or._getDecoder("der").tree;
  };
  function ne(gr, or) {
    var _r = gr.readUInt8(or);
    if (gr.isError(_r))
      return _r;
    var Lr = $e.tagClass[_r >> 6], Ir = (_r & 32) === 0;
    if ((_r & 31) === 31) {
      var Ar = _r;
      for (_r = 0; (Ar & 128) === 128; ) {
        if (Ar = gr.readUInt8(or), gr.isError(Ar))
          return Ar;
        _r <<= 7, _r |= Ar & 127;
      }
    } else
      _r &= 31;
    var Rr = $e.tag[_r];
    return {
      cls: Lr,
      primitive: Ir,
      tag: _r,
      tagStr: Rr
    };
  }
  function rr(gr, or, _r) {
    var Lr = gr.readUInt8(_r);
    if (gr.isError(Lr))
      return Lr;
    if (!or && Lr === 128)
      return null;
    if ((Lr & 128) === 0)
      return Lr;
    var Ir = Lr & 127;
    if (Ir > 4)
      return gr.error("length octect is too long");
    Lr = 0;
    for (var Ar = 0; Ar < Ir; Ar++) {
      Lr <<= 8;
      var Rr = gr.readUInt8(_r);
      if (gr.isError(Rr))
        return Rr;
      Lr |= Rr;
    }
    return Lr;
  }
  return der_1$1;
}
var pem$1, hasRequiredPem$1;
function requirePem$1() {
  if (hasRequiredPem$1)
    return pem$1;
  hasRequiredPem$1 = 1;
  var m = inherits_browser.exports, c = require$$0$4.Buffer, ie = requireDer$1();
  function we($e) {
    ie.call(this, $e), this.enc = "pem";
  }
  return m(we, ie), pem$1 = we, we.prototype.decode = function(Me, Ze) {
    for (var ne = Me.toString().split(/[\r\n]+/g), rr = Ze.label.toUpperCase(), gr = /^-----(BEGIN|END) ([^-]+)-----$/, or = -1, _r = -1, Lr = 0; Lr < ne.length; Lr++) {
      var Ir = ne[Lr].match(gr);
      if (Ir !== null && Ir[2] === rr)
        if (or === -1) {
          if (Ir[1] !== "BEGIN")
            break;
          or = Lr;
        } else {
          if (Ir[1] !== "END")
            break;
          _r = Lr;
          break;
        }
    }
    if (or === -1 || _r === -1)
      throw new Error("PEM section not found for: " + rr);
    var Ar = ne.slice(or + 1, _r).join("");
    Ar.replace(/[^a-z0-9\+\/=]+/gi, "");
    var Rr = new c(Ar, "base64");
    return ie.prototype.decode.call(this, Rr, Ze);
  }, pem$1;
}
var hasRequiredDecoders;
function requireDecoders() {
  return hasRequiredDecoders || (hasRequiredDecoders = 1, function(m) {
    var c = m;
    c.der = requireDer$1(), c.pem = requirePem$1();
  }(decoders)), decoders;
}
var encoders = {}, der_1, hasRequiredDer;
function requireDer() {
  if (hasRequiredDer)
    return der_1;
  hasRequiredDer = 1;
  var m = inherits_browser.exports, c = require$$0$4.Buffer, ie = requireAsn1(), we = ie.base, $e = ie.constants.der;
  function Me(gr) {
    this.enc = "der", this.name = gr.name, this.entity = gr, this.tree = new Ze(), this.tree._init(gr.body);
  }
  der_1 = Me, Me.prototype.encode = function(or, _r) {
    return this.tree._encode(or, _r).join();
  };
  function Ze(gr) {
    we.Node.call(this, "der", gr);
  }
  m(Ze, we.Node), Ze.prototype._encodeComposite = function(or, _r, Lr, Ir) {
    var Ar = rr(or, _r, Lr, this.reporter);
    if (Ir.length < 128) {
      var Yr = new c(2);
      return Yr[0] = Ar, Yr[1] = Ir.length, this._createEncoderBuffer([Yr, Ir]);
    }
    for (var Rr = 1, Nr = Ir.length; Nr >= 256; Nr >>= 8)
      Rr++;
    var Yr = new c(1 + 1 + Rr);
    Yr[0] = Ar, Yr[1] = 128 | Rr;
    for (var Nr = 1 + Rr, Vr = Ir.length; Vr > 0; Nr--, Vr >>= 8)
      Yr[Nr] = Vr & 255;
    return this._createEncoderBuffer([Yr, Ir]);
  }, Ze.prototype._encodeStr = function(or, _r) {
    if (_r === "bitstr")
      return this._createEncoderBuffer([or.unused | 0, or.data]);
    if (_r === "bmpstr") {
      for (var Lr = new c(or.length * 2), Ir = 0; Ir < or.length; Ir++)
        Lr.writeUInt16BE(or.charCodeAt(Ir), Ir * 2);
      return this._createEncoderBuffer(Lr);
    } else
      return _r === "numstr" ? this._isNumstr(or) ? this._createEncoderBuffer(or) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : _r === "printstr" ? this._isPrintstr(or) ? this._createEncoderBuffer(or) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(_r) ? this._createEncoderBuffer(or) : _r === "objDesc" ? this._createEncoderBuffer(or) : this.reporter.error("Encoding of string type: " + _r + " unsupported");
  }, Ze.prototype._encodeObjid = function(or, _r, Lr) {
    if (typeof or == "string") {
      if (!_r)
        return this.reporter.error("string objid given, but no values map found");
      if (!_r.hasOwnProperty(or))
        return this.reporter.error("objid not found in values map");
      or = _r[or].split(/[\s\.]+/g);
      for (var Ir = 0; Ir < or.length; Ir++)
        or[Ir] |= 0;
    } else if (Array.isArray(or)) {
      or = or.slice();
      for (var Ir = 0; Ir < or.length; Ir++)
        or[Ir] |= 0;
    }
    if (!Array.isArray(or))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(or));
    if (!Lr) {
      if (or[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      or.splice(0, 2, or[0] * 40 + or[1]);
    }
    for (var Ar = 0, Ir = 0; Ir < or.length; Ir++) {
      var Rr = or[Ir];
      for (Ar++; Rr >= 128; Rr >>= 7)
        Ar++;
    }
    for (var Nr = new c(Ar), Yr = Nr.length - 1, Ir = or.length - 1; Ir >= 0; Ir--) {
      var Rr = or[Ir];
      for (Nr[Yr--] = Rr & 127; (Rr >>= 7) > 0; )
        Nr[Yr--] = 128 | Rr & 127;
    }
    return this._createEncoderBuffer(Nr);
  };
  function ne(gr) {
    return gr < 10 ? "0" + gr : gr;
  }
  Ze.prototype._encodeTime = function(or, _r) {
    var Lr, Ir = new Date(or);
    return _r === "gentime" ? Lr = [
      ne(Ir.getFullYear()),
      ne(Ir.getUTCMonth() + 1),
      ne(Ir.getUTCDate()),
      ne(Ir.getUTCHours()),
      ne(Ir.getUTCMinutes()),
      ne(Ir.getUTCSeconds()),
      "Z"
    ].join("") : _r === "utctime" ? Lr = [
      ne(Ir.getFullYear() % 100),
      ne(Ir.getUTCMonth() + 1),
      ne(Ir.getUTCDate()),
      ne(Ir.getUTCHours()),
      ne(Ir.getUTCMinutes()),
      ne(Ir.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + _r + " time is not supported yet"), this._encodeStr(Lr, "octstr");
  }, Ze.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, Ze.prototype._encodeInt = function(or, _r) {
    if (typeof or == "string") {
      if (!_r)
        return this.reporter.error("String int or enum given, but no values map");
      if (!_r.hasOwnProperty(or))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(or));
      or = _r[or];
    }
    if (typeof or != "number" && !c.isBuffer(or)) {
      var Lr = or.toArray();
      !or.sign && Lr[0] & 128 && Lr.unshift(0), or = new c(Lr);
    }
    if (c.isBuffer(or)) {
      var Ir = or.length;
      or.length === 0 && Ir++;
      var Rr = new c(Ir);
      return or.copy(Rr), or.length === 0 && (Rr[0] = 0), this._createEncoderBuffer(Rr);
    }
    if (or < 128)
      return this._createEncoderBuffer(or);
    if (or < 256)
      return this._createEncoderBuffer([0, or]);
    for (var Ir = 1, Ar = or; Ar >= 256; Ar >>= 8)
      Ir++;
    for (var Rr = new Array(Ir), Ar = Rr.length - 1; Ar >= 0; Ar--)
      Rr[Ar] = or & 255, or >>= 8;
    return Rr[0] & 128 && Rr.unshift(0), this._createEncoderBuffer(new c(Rr));
  }, Ze.prototype._encodeBool = function(or) {
    return this._createEncoderBuffer(or ? 255 : 0);
  }, Ze.prototype._use = function(or, _r) {
    return typeof or == "function" && (or = or(_r)), or._getEncoder("der").tree;
  }, Ze.prototype._skipDefault = function(or, _r, Lr) {
    var Ir = this._baseState, Ar;
    if (Ir.default === null)
      return !1;
    var Rr = or.join();
    if (Ir.defaultBuffer === void 0 && (Ir.defaultBuffer = this._encodeValue(Ir.default, _r, Lr).join()), Rr.length !== Ir.defaultBuffer.length)
      return !1;
    for (Ar = 0; Ar < Rr.length; Ar++)
      if (Rr[Ar] !== Ir.defaultBuffer[Ar])
        return !1;
    return !0;
  };
  function rr(gr, or, _r, Lr) {
    var Ir;
    if (gr === "seqof" ? gr = "seq" : gr === "setof" && (gr = "set"), $e.tagByName.hasOwnProperty(gr))
      Ir = $e.tagByName[gr];
    else if (typeof gr == "number" && (gr | 0) === gr)
      Ir = gr;
    else
      return Lr.error("Unknown tag: " + gr);
    return Ir >= 31 ? Lr.error("Multi-octet tag encoding unsupported") : (or || (Ir |= 32), Ir |= $e.tagClassByName[_r || "universal"] << 6, Ir);
  }
  return der_1;
}
var pem, hasRequiredPem;
function requirePem() {
  if (hasRequiredPem)
    return pem;
  hasRequiredPem = 1;
  var m = inherits_browser.exports, c = requireDer();
  function ie(we) {
    c.call(this, we), this.enc = "pem";
  }
  return m(ie, c), pem = ie, ie.prototype.encode = function($e, Me) {
    for (var Ze = c.prototype.encode.call(this, $e), ne = Ze.toString("base64"), rr = ["-----BEGIN " + Me.label + "-----"], gr = 0; gr < ne.length; gr += 64)
      rr.push(ne.slice(gr, gr + 64));
    return rr.push("-----END " + Me.label + "-----"), rr.join(`
`);
  }, pem;
}
var hasRequiredEncoders;
function requireEncoders() {
  return hasRequiredEncoders || (hasRequiredEncoders = 1, function(m) {
    var c = m;
    c.der = requireDer(), c.pem = requirePem();
  }(encoders)), encoders;
}
var hasRequiredAsn1;
function requireAsn1() {
  return hasRequiredAsn1 || (hasRequiredAsn1 = 1, function(m) {
    var c = m;
    c.bignum = bn$2.exports, c.define = requireApi().define, c.base = requireBase(), c.constants = requireConstants(), c.decoders = requireDecoders(), c.encoders = requireEncoders();
  }(asn1$2)), asn1$2;
}
var asn = requireAsn1(), Time = asn.define("Time", function() {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  });
}), AttributeTypeValue = asn.define("AttributeTypeValue", function() {
  this.seq().obj(
    this.key("type").objid(),
    this.key("value").any()
  );
}), AlgorithmIdentifier$1 = asn.define("AlgorithmIdentifier", function() {
  this.seq().obj(
    this.key("algorithm").objid(),
    this.key("parameters").optional(),
    this.key("curve").objid().optional()
  );
}), SubjectPublicKeyInfo = asn.define("SubjectPublicKeyInfo", function() {
  this.seq().obj(
    this.key("algorithm").use(AlgorithmIdentifier$1),
    this.key("subjectPublicKey").bitstr()
  );
}), RelativeDistinguishedName = asn.define("RelativeDistinguishedName", function() {
  this.setof(AttributeTypeValue);
}), RDNSequence = asn.define("RDNSequence", function() {
  this.seqof(RelativeDistinguishedName);
}), Name = asn.define("Name", function() {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  });
}), Validity = asn.define("Validity", function() {
  this.seq().obj(
    this.key("notBefore").use(Time),
    this.key("notAfter").use(Time)
  );
}), Extension = asn.define("Extension", function() {
  this.seq().obj(
    this.key("extnID").objid(),
    this.key("critical").bool().def(!1),
    this.key("extnValue").octstr()
  );
}), TBSCertificate = asn.define("TBSCertificate", function() {
  this.seq().obj(
    this.key("version").explicit(0).int().optional(),
    this.key("serialNumber").int(),
    this.key("signature").use(AlgorithmIdentifier$1),
    this.key("issuer").use(Name),
    this.key("validity").use(Validity),
    this.key("subject").use(Name),
    this.key("subjectPublicKeyInfo").use(SubjectPublicKeyInfo),
    this.key("issuerUniqueID").implicit(1).bitstr().optional(),
    this.key("subjectUniqueID").implicit(2).bitstr().optional(),
    this.key("extensions").explicit(3).seqof(Extension).optional()
  );
}), X509Certificate = asn.define("X509Certificate", function() {
  this.seq().obj(
    this.key("tbsCertificate").use(TBSCertificate),
    this.key("signatureAlgorithm").use(AlgorithmIdentifier$1),
    this.key("signatureValue").bitstr()
  );
}), certificate = X509Certificate, asn1$1 = requireAsn1();
asn1$3.certificate = certificate;
var RSAPrivateKey = asn1$1.define("RSAPrivateKey", function() {
  this.seq().obj(
    this.key("version").int(),
    this.key("modulus").int(),
    this.key("publicExponent").int(),
    this.key("privateExponent").int(),
    this.key("prime1").int(),
    this.key("prime2").int(),
    this.key("exponent1").int(),
    this.key("exponent2").int(),
    this.key("coefficient").int()
  );
});
asn1$3.RSAPrivateKey = RSAPrivateKey;
var RSAPublicKey = asn1$1.define("RSAPublicKey", function() {
  this.seq().obj(
    this.key("modulus").int(),
    this.key("publicExponent").int()
  );
});
asn1$3.RSAPublicKey = RSAPublicKey;
var AlgorithmIdentifier = asn1$1.define("AlgorithmIdentifier", function() {
  this.seq().obj(
    this.key("algorithm").objid(),
    this.key("none").null_().optional(),
    this.key("curve").objid().optional(),
    this.key("params").seq().obj(
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int()
    ).optional()
  );
}), PublicKey = asn1$1.define("SubjectPublicKeyInfo", function() {
  this.seq().obj(
    this.key("algorithm").use(AlgorithmIdentifier),
    this.key("subjectPublicKey").bitstr()
  );
});
asn1$3.PublicKey = PublicKey;
var PrivateKeyInfo = asn1$1.define("PrivateKeyInfo", function() {
  this.seq().obj(
    this.key("version").int(),
    this.key("algorithm").use(AlgorithmIdentifier),
    this.key("subjectPrivateKey").octstr()
  );
});
asn1$3.PrivateKey = PrivateKeyInfo;
var EncryptedPrivateKeyInfo = asn1$1.define("EncryptedPrivateKeyInfo", function() {
  this.seq().obj(
    this.key("algorithm").seq().obj(
      this.key("id").objid(),
      this.key("decrypt").seq().obj(
        this.key("kde").seq().obj(
          this.key("id").objid(),
          this.key("kdeparams").seq().obj(
            this.key("salt").octstr(),
            this.key("iters").int()
          )
        ),
        this.key("cipher").seq().obj(
          this.key("algo").objid(),
          this.key("iv").octstr()
        )
      )
    ),
    this.key("subjectPrivateKey").octstr()
  );
});
asn1$3.EncryptedPrivateKey = EncryptedPrivateKeyInfo;
var DSAPrivateKey = asn1$1.define("DSAPrivateKey", function() {
  this.seq().obj(
    this.key("version").int(),
    this.key("p").int(),
    this.key("q").int(),
    this.key("g").int(),
    this.key("pub_key").int(),
    this.key("priv_key").int()
  );
});
asn1$3.DSAPrivateKey = DSAPrivateKey;
asn1$3.DSAparam = asn1$1.define("DSAparam", function() {
  this.int();
});
var ECParameters = asn1$1.define("ECParameters", function() {
  this.choice({
    namedCurve: this.objid()
  });
}), ECPrivateKey = asn1$1.define("ECPrivateKey", function() {
  this.seq().obj(
    this.key("version").int(),
    this.key("privateKey").octstr(),
    this.key("parameters").optional().explicit(0).use(ECParameters),
    this.key("publicKey").optional().explicit(1).bitstr()
  );
});
asn1$3.ECPrivateKey = ECPrivateKey;
asn1$3.signature = asn1$1.define("signature", function() {
  this.seq().obj(
    this.key("r").int(),
    this.key("s").int()
  );
});
const require$$1$2 = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, evp = evp_bytestokey, ciphers$1 = browser$6, Buffer$6 = safeBuffer$2.exports.Buffer, fixProc$1 = function(m, c) {
  var ie = m.toString(), we = ie.match(findProc), $e;
  if (we) {
    var Ze = "aes" + we[1], ne = Buffer$6.from(we[2], "hex"), rr = Buffer$6.from(we[3].replace(/[\r\n]/g, ""), "base64"), gr = evp(c, ne.slice(0, 8), parseInt(we[1], 10)).key, or = [], _r = ciphers$1.createDecipheriv(Ze, gr, ne);
    or.push(_r.update(rr)), or.push(_r.final()), $e = Buffer$6.concat(or);
  } else {
    var Me = ie.match(fullRegex);
    $e = Buffer$6.from(Me[2].replace(/[\r\n]/g, ""), "base64");
  }
  var Lr = ie.match(startRegex)[1];
  return {
    tag: Lr,
    data: $e
  };
}, asn1 = asn1$3, aesid = require$$1$2, fixProc = fixProc$1, ciphers = browser$6, compat = browser$8, Buffer$5 = safeBuffer$2.exports.Buffer;
function decrypt(m, c) {
  var ie = m.algorithm.decrypt.kde.kdeparams.salt, we = parseInt(m.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), $e = aesid[m.algorithm.decrypt.cipher.algo.join(".")], Me = m.algorithm.decrypt.cipher.iv, Ze = m.subjectPrivateKey, ne = parseInt($e.split("-")[1], 10) / 8, rr = compat.pbkdf2Sync(c, ie, we, ne, "sha1"), gr = ciphers.createDecipheriv($e, rr, Me), or = [];
  return or.push(gr.update(Ze)), or.push(gr.final()), Buffer$5.concat(or);
}
function parseKeys$3(m) {
  var c;
  typeof m == "object" && !Buffer$5.isBuffer(m) && (c = m.passphrase, m = m.key), typeof m == "string" && (m = Buffer$5.from(m));
  var ie = fixProc(m, c), we = ie.tag, $e = ie.data, Me, Ze;
  switch (we) {
    case "CERTIFICATE":
      Ze = asn1.certificate.decode($e, "der").tbsCertificate.subjectPublicKeyInfo;
    case "PUBLIC KEY":
      switch (Ze || (Ze = asn1.PublicKey.decode($e, "der")), Me = Ze.algorithm.algorithm.join("."), Me) {
        case "1.2.840.113549.1.1.1":
          return asn1.RSAPublicKey.decode(Ze.subjectPublicKey.data, "der");
        case "1.2.840.10045.2.1":
          return Ze.subjectPrivateKey = Ze.subjectPublicKey, {
            type: "ec",
            data: Ze
          };
        case "1.2.840.10040.4.1":
          return Ze.algorithm.params.pub_key = asn1.DSAparam.decode(Ze.subjectPublicKey.data, "der"), {
            type: "dsa",
            data: Ze.algorithm.params
          };
        default:
          throw new Error("unknown key id " + Me);
      }
    case "ENCRYPTED PRIVATE KEY":
      $e = asn1.EncryptedPrivateKey.decode($e, "der"), $e = decrypt($e, c);
    case "PRIVATE KEY":
      switch (Ze = asn1.PrivateKey.decode($e, "der"), Me = Ze.algorithm.algorithm.join("."), Me) {
        case "1.2.840.113549.1.1.1":
          return asn1.RSAPrivateKey.decode(Ze.subjectPrivateKey, "der");
        case "1.2.840.10045.2.1":
          return {
            curve: Ze.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(Ze.subjectPrivateKey, "der").privateKey
          };
        case "1.2.840.10040.4.1":
          return Ze.algorithm.params.priv_key = asn1.DSAparam.decode(Ze.subjectPrivateKey, "der"), {
            type: "dsa",
            params: Ze.algorithm.params
          };
        default:
          throw new Error("unknown key id " + Me);
      }
    case "RSA PUBLIC KEY":
      return asn1.RSAPublicKey.decode($e, "der");
    case "RSA PRIVATE KEY":
      return asn1.RSAPrivateKey.decode($e, "der");
    case "DSA PRIVATE KEY":
      return {
        type: "dsa",
        params: asn1.DSAPrivateKey.decode($e, "der")
      };
    case "EC PRIVATE KEY":
      return $e = asn1.ECPrivateKey.decode($e, "der"), {
        curve: $e.parameters.value,
        privateKey: $e.privateKey
      };
    default:
      throw new Error("unknown key type " + we);
  }
}
parseKeys$3.signature = asn1.signature;
var parseAsn1 = parseKeys$3;
const require$$4 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign)
    return sign.exports;
  hasRequiredSign = 1;
  var m = safeBuffer$2.exports.Buffer, c = browser$9, ie = browserifyRsa, we = requireElliptic().ec, $e = bn$4.exports, Me = parseAsn1, Ze = require$$4, ne = 1;
  function rr(Yr, Vr, Xr, Wr, si) {
    var li = Me(Vr);
    if (li.curve) {
      if (Wr !== "ecdsa" && Wr !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return gr(Yr, li);
    } else if (li.type === "dsa") {
      if (Wr !== "dsa")
        throw new Error("wrong private key type");
      return or(Yr, li, Xr);
    }
    if (Wr !== "rsa" && Wr !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (Vr.padding !== void 0 && Vr.padding !== ne)
      throw new Error("illegal or unsupported padding mode");
    Yr = m.concat([si, Yr]);
    for (var xi = li.modulus.byteLength(), di = [0, 1]; Yr.length + di.length + 1 < xi; )
      di.push(255);
    di.push(0);
    for (var oi = -1; ++oi < Yr.length; )
      di.push(Yr[oi]);
    var ci = ie(di, li);
    return ci;
  }
  function gr(Yr, Vr) {
    var Xr = Ze[Vr.curve.join(".")];
    if (!Xr)
      throw new Error("unknown curve " + Vr.curve.join("."));
    var Wr = new we(Xr), si = Wr.keyFromPrivate(Vr.privateKey), li = si.sign(Yr);
    return m.from(li.toDER());
  }
  function or(Yr, Vr, Xr) {
    for (var Wr = Vr.params.priv_key, si = Vr.params.p, li = Vr.params.q, xi = Vr.params.g, di = new $e(0), oi, ci = Ir(Yr, li).mod(li), vr = !1, Ae = Lr(Wr, li, Yr, Xr); vr === !1; )
      oi = Rr(li, Ae, Xr), di = Nr(xi, oi, si, li), vr = oi.invm(li).imul(ci.add(Wr.mul(di))).mod(li), vr.cmpn(0) === 0 && (vr = !1, di = new $e(0));
    return _r(di, vr);
  }
  function _r(Yr, Vr) {
    Yr = Yr.toArray(), Vr = Vr.toArray(), Yr[0] & 128 && (Yr = [0].concat(Yr)), Vr[0] & 128 && (Vr = [0].concat(Vr));
    var Xr = Yr.length + Vr.length + 4, Wr = [
      48,
      Xr,
      2,
      Yr.length
    ];
    return Wr = Wr.concat(Yr, [2, Vr.length], Vr), m.from(Wr);
  }
  function Lr(Yr, Vr, Xr, Wr) {
    if (Yr = m.from(Yr.toArray()), Yr.length < Vr.byteLength()) {
      var si = m.alloc(Vr.byteLength() - Yr.length);
      Yr = m.concat([si, Yr]);
    }
    var li = Xr.length, xi = Ar(Xr, Vr), di = m.alloc(li);
    di.fill(1);
    var oi = m.alloc(li);
    return oi = c(Wr, oi).update(di).update(m.from([0])).update(Yr).update(xi).digest(), di = c(Wr, oi).update(di).digest(), oi = c(Wr, oi).update(di).update(m.from([1])).update(Yr).update(xi).digest(), di = c(Wr, oi).update(di).digest(), { k: oi, v: di };
  }
  function Ir(Yr, Vr) {
    var Xr = new $e(Yr), Wr = (Yr.length << 3) - Vr.bitLength();
    return Wr > 0 && Xr.ishrn(Wr), Xr;
  }
  function Ar(Yr, Vr) {
    Yr = Ir(Yr, Vr), Yr = Yr.mod(Vr);
    var Xr = m.from(Yr.toArray());
    if (Xr.length < Vr.byteLength()) {
      var Wr = m.alloc(Vr.byteLength() - Xr.length);
      Xr = m.concat([Wr, Xr]);
    }
    return Xr;
  }
  function Rr(Yr, Vr, Xr) {
    var Wr, si;
    do {
      for (Wr = m.alloc(0); Wr.length * 8 < Yr.bitLength(); )
        Vr.v = c(Xr, Vr.k).update(Vr.v).digest(), Wr = m.concat([Wr, Vr.v]);
      si = Ir(Wr, Yr), Vr.k = c(Xr, Vr.k).update(Vr.v).update(m.from([0])).digest(), Vr.v = c(Xr, Vr.k).update(Vr.v).digest();
    } while (si.cmp(Yr) !== -1);
    return si;
  }
  function Nr(Yr, Vr, Xr, Wr) {
    return Yr.toRed($e.mont(Xr)).redPow(Vr).fromRed().mod(Wr);
  }
  return sign.exports = rr, sign.exports.getKey = Lr, sign.exports.makeKey = Rr, sign.exports;
}
var verify_1, hasRequiredVerify;
function requireVerify() {
  if (hasRequiredVerify)
    return verify_1;
  hasRequiredVerify = 1;
  var m = safeBuffer$2.exports.Buffer, c = bn$4.exports, ie = requireElliptic().ec, we = parseAsn1, $e = require$$4;
  function Me(gr, or, _r, Lr, Ir) {
    var Ar = we(_r);
    if (Ar.type === "ec") {
      if (Lr !== "ecdsa" && Lr !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return Ze(gr, or, Ar);
    } else if (Ar.type === "dsa") {
      if (Lr !== "dsa")
        throw new Error("wrong public key type");
      return ne(gr, or, Ar);
    }
    if (Lr !== "rsa" && Lr !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    or = m.concat([Ir, or]);
    for (var Rr = Ar.modulus.byteLength(), Nr = [1], Yr = 0; or.length + Nr.length + 2 < Rr; )
      Nr.push(255), Yr += 1;
    Nr.push(0);
    for (var Vr = -1; ++Vr < or.length; )
      Nr.push(or[Vr]);
    Nr = m.from(Nr);
    var Xr = c.mont(Ar.modulus);
    gr = new c(gr).toRed(Xr), gr = gr.redPow(new c(Ar.publicExponent)), gr = m.from(gr.fromRed().toArray());
    var Wr = Yr < 8 ? 1 : 0;
    for (Rr = Math.min(gr.length, Nr.length), gr.length !== Nr.length && (Wr = 1), Vr = -1; ++Vr < Rr; )
      Wr |= gr[Vr] ^ Nr[Vr];
    return Wr === 0;
  }
  function Ze(gr, or, _r) {
    var Lr = $e[_r.data.algorithm.curve.join(".")];
    if (!Lr)
      throw new Error("unknown curve " + _r.data.algorithm.curve.join("."));
    var Ir = new ie(Lr), Ar = _r.data.subjectPrivateKey.data;
    return Ir.verify(or, gr, Ar);
  }
  function ne(gr, or, _r) {
    var Lr = _r.data.p, Ir = _r.data.q, Ar = _r.data.g, Rr = _r.data.pub_key, Nr = we.signature.decode(gr, "der"), Yr = Nr.s, Vr = Nr.r;
    rr(Yr, Ir), rr(Vr, Ir);
    var Xr = c.mont(Lr), Wr = Yr.invm(Ir), si = Ar.toRed(Xr).redPow(new c(or).mul(Wr).mod(Ir)).fromRed().mul(Rr.toRed(Xr).redPow(Vr.mul(Wr).mod(Ir)).fromRed()).mod(Lr).mod(Ir);
    return si.cmp(Vr) === 0;
  }
  function rr(gr, or) {
    if (gr.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (gr.cmp(or) >= 0)
      throw new Error("invalid sig");
  }
  return verify_1 = Me, verify_1;
}
var browser$4, hasRequiredBrowser$1;
function requireBrowser$1() {
  if (hasRequiredBrowser$1)
    return browser$4;
  hasRequiredBrowser$1 = 1;
  var m = safeBuffer$2.exports.Buffer, c = browser$a, ie = readableBrowser.exports, we = inherits_browser.exports, $e = requireSign(), Me = requireVerify(), Ze = require$$6;
  Object.keys(Ze).forEach(function(_r) {
    Ze[_r].id = m.from(Ze[_r].id, "hex"), Ze[_r.toLowerCase()] = Ze[_r];
  });
  function ne(_r) {
    ie.Writable.call(this);
    var Lr = Ze[_r];
    if (!Lr)
      throw new Error("Unknown message digest");
    this._hashType = Lr.hash, this._hash = c(Lr.hash), this._tag = Lr.id, this._signType = Lr.sign;
  }
  we(ne, ie.Writable), ne.prototype._write = function(Lr, Ir, Ar) {
    this._hash.update(Lr), Ar();
  }, ne.prototype.update = function(Lr, Ir) {
    return this._hash.update(typeof Lr == "string" ? m.from(Lr, Ir) : Lr), this;
  }, ne.prototype.sign = function(Lr, Ir) {
    this.end();
    var Ar = this._hash.digest(), Rr = $e(Ar, Lr, this._hashType, this._signType, this._tag);
    return Ir ? Rr.toString(Ir) : Rr;
  };
  function rr(_r) {
    ie.Writable.call(this);
    var Lr = Ze[_r];
    if (!Lr)
      throw new Error("Unknown message digest");
    this._hash = c(Lr.hash), this._tag = Lr.id, this._signType = Lr.sign;
  }
  we(rr, ie.Writable), rr.prototype._write = function(Lr, Ir, Ar) {
    this._hash.update(Lr), Ar();
  }, rr.prototype.update = function(Lr, Ir) {
    return this._hash.update(typeof Lr == "string" ? m.from(Lr, Ir) : Lr), this;
  }, rr.prototype.verify = function(Lr, Ir, Ar) {
    var Rr = typeof Ir == "string" ? m.from(Ir, Ar) : Ir;
    this.end();
    var Nr = this._hash.digest();
    return Me(Rr, Nr, Lr, this._signType, this._tag);
  };
  function gr(_r) {
    return new ne(_r);
  }
  function or(_r) {
    return new rr(_r);
  }
  return browser$4 = {
    Sign: gr,
    Verify: or,
    createSign: gr,
    createVerify: or
  }, browser$4;
}
var bn$1 = { exports: {} };
(function(m) {
  (function(c, ie) {
    function we(vr, Ae) {
      if (!vr)
        throw new Error(Ae || "Assertion failed");
    }
    function $e(vr, Ae) {
      vr.super_ = Ae;
      var ze = function() {
      };
      ze.prototype = Ae.prototype, vr.prototype = new ze(), vr.prototype.constructor = vr;
    }
    function Me(vr, Ae, ze) {
      if (Me.isBN(vr))
        return vr;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, vr !== null && ((Ae === "le" || Ae === "be") && (ze = Ae, Ae = 10), this._init(vr || 0, Ae || 10, ze || "be"));
    }
    typeof c == "object" ? c.exports = Me : ie.BN = Me, Me.BN = Me, Me.wordSize = 26;
    var Ze;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? Ze = window.Buffer : Ze = require$$0$4.Buffer;
    } catch {
    }
    Me.isBN = function(Ae) {
      return Ae instanceof Me ? !0 : Ae !== null && typeof Ae == "object" && Ae.constructor.wordSize === Me.wordSize && Array.isArray(Ae.words);
    }, Me.max = function(Ae, ze) {
      return Ae.cmp(ze) > 0 ? Ae : ze;
    }, Me.min = function(Ae, ze) {
      return Ae.cmp(ze) < 0 ? Ae : ze;
    }, Me.prototype._init = function(Ae, ze, Ue) {
      if (typeof Ae == "number")
        return this._initNumber(Ae, ze, Ue);
      if (typeof Ae == "object")
        return this._initArray(Ae, ze, Ue);
      ze === "hex" && (ze = 16), we(ze === (ze | 0) && ze >= 2 && ze <= 36), Ae = Ae.toString().replace(/\s+/g, "");
      var tr = 0;
      Ae[0] === "-" && (tr++, this.negative = 1), tr < Ae.length && (ze === 16 ? this._parseHex(Ae, tr, Ue) : (this._parseBase(Ae, ze, tr), Ue === "le" && this._initArray(this.toArray(), ze, Ue)));
    }, Me.prototype._initNumber = function(Ae, ze, Ue) {
      Ae < 0 && (this.negative = 1, Ae = -Ae), Ae < 67108864 ? (this.words = [Ae & 67108863], this.length = 1) : Ae < 4503599627370496 ? (this.words = [
        Ae & 67108863,
        Ae / 67108864 & 67108863
      ], this.length = 2) : (we(Ae < 9007199254740992), this.words = [
        Ae & 67108863,
        Ae / 67108864 & 67108863,
        1
      ], this.length = 3), Ue === "le" && this._initArray(this.toArray(), ze, Ue);
    }, Me.prototype._initArray = function(Ae, ze, Ue) {
      if (we(typeof Ae.length == "number"), Ae.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(Ae.length / 3), this.words = new Array(this.length);
      for (var tr = 0; tr < this.length; tr++)
        this.words[tr] = 0;
      var lr, pr, br = 0;
      if (Ue === "be")
        for (tr = Ae.length - 1, lr = 0; tr >= 0; tr -= 3)
          pr = Ae[tr] | Ae[tr - 1] << 8 | Ae[tr - 2] << 16, this.words[lr] |= pr << br & 67108863, this.words[lr + 1] = pr >>> 26 - br & 67108863, br += 24, br >= 26 && (br -= 26, lr++);
      else if (Ue === "le")
        for (tr = 0, lr = 0; tr < Ae.length; tr += 3)
          pr = Ae[tr] | Ae[tr + 1] << 8 | Ae[tr + 2] << 16, this.words[lr] |= pr << br & 67108863, this.words[lr + 1] = pr >>> 26 - br & 67108863, br += 24, br >= 26 && (br -= 26, lr++);
      return this.strip();
    };
    function ne(vr, Ae) {
      var ze = vr.charCodeAt(Ae);
      return ze >= 65 && ze <= 70 ? ze - 55 : ze >= 97 && ze <= 102 ? ze - 87 : ze - 48 & 15;
    }
    function rr(vr, Ae, ze) {
      var Ue = ne(vr, ze);
      return ze - 1 >= Ae && (Ue |= ne(vr, ze - 1) << 4), Ue;
    }
    Me.prototype._parseHex = function(Ae, ze, Ue) {
      this.length = Math.ceil((Ae.length - ze) / 6), this.words = new Array(this.length);
      for (var tr = 0; tr < this.length; tr++)
        this.words[tr] = 0;
      var lr = 0, pr = 0, br;
      if (Ue === "be")
        for (tr = Ae.length - 1; tr >= ze; tr -= 2)
          br = rr(Ae, ze, tr) << lr, this.words[pr] |= br & 67108863, lr >= 18 ? (lr -= 18, pr += 1, this.words[pr] |= br >>> 26) : lr += 8;
      else {
        var nr = Ae.length - ze;
        for (tr = nr % 2 === 0 ? ze + 1 : ze; tr < Ae.length; tr += 2)
          br = rr(Ae, ze, tr) << lr, this.words[pr] |= br & 67108863, lr >= 18 ? (lr -= 18, pr += 1, this.words[pr] |= br >>> 26) : lr += 8;
      }
      this.strip();
    };
    function gr(vr, Ae, ze, Ue) {
      for (var tr = 0, lr = Math.min(vr.length, ze), pr = Ae; pr < lr; pr++) {
        var br = vr.charCodeAt(pr) - 48;
        tr *= Ue, br >= 49 ? tr += br - 49 + 10 : br >= 17 ? tr += br - 17 + 10 : tr += br;
      }
      return tr;
    }
    Me.prototype._parseBase = function(Ae, ze, Ue) {
      this.words = [0], this.length = 1;
      for (var tr = 0, lr = 1; lr <= 67108863; lr *= ze)
        tr++;
      tr--, lr = lr / ze | 0;
      for (var pr = Ae.length - Ue, br = pr % tr, nr = Math.min(pr, pr - br) + Ue, Pe = 0, ur = Ue; ur < nr; ur += tr)
        Pe = gr(Ae, ur, ur + tr, ze), this.imuln(lr), this.words[0] + Pe < 67108864 ? this.words[0] += Pe : this._iaddn(Pe);
      if (br !== 0) {
        var Pr = 1;
        for (Pe = gr(Ae, ur, Ae.length, ze), ur = 0; ur < br; ur++)
          Pr *= ze;
        this.imuln(Pr), this.words[0] + Pe < 67108864 ? this.words[0] += Pe : this._iaddn(Pe);
      }
      this.strip();
    }, Me.prototype.copy = function(Ae) {
      Ae.words = new Array(this.length);
      for (var ze = 0; ze < this.length; ze++)
        Ae.words[ze] = this.words[ze];
      Ae.length = this.length, Ae.negative = this.negative, Ae.red = this.red;
    }, Me.prototype.clone = function() {
      var Ae = new Me(null);
      return this.copy(Ae), Ae;
    }, Me.prototype._expand = function(Ae) {
      for (; this.length < Ae; )
        this.words[this.length++] = 0;
      return this;
    }, Me.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, Me.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, Me.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var or = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], _r = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Lr = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    Me.prototype.toString = function(Ae, ze) {
      Ae = Ae || 10, ze = ze | 0 || 1;
      var Ue;
      if (Ae === 16 || Ae === "hex") {
        Ue = "";
        for (var tr = 0, lr = 0, pr = 0; pr < this.length; pr++) {
          var br = this.words[pr], nr = ((br << tr | lr) & 16777215).toString(16);
          lr = br >>> 24 - tr & 16777215, tr += 2, tr >= 26 && (tr -= 26, pr--), lr !== 0 || pr !== this.length - 1 ? Ue = or[6 - nr.length] + nr + Ue : Ue = nr + Ue;
        }
        for (lr !== 0 && (Ue = lr.toString(16) + Ue); Ue.length % ze !== 0; )
          Ue = "0" + Ue;
        return this.negative !== 0 && (Ue = "-" + Ue), Ue;
      }
      if (Ae === (Ae | 0) && Ae >= 2 && Ae <= 36) {
        var Pe = _r[Ae], ur = Lr[Ae];
        Ue = "";
        var Pr = this.clone();
        for (Pr.negative = 0; !Pr.isZero(); ) {
          var Hr = Pr.modn(ur).toString(Ae);
          Pr = Pr.idivn(ur), Pr.isZero() ? Ue = Hr + Ue : Ue = or[Pe - Hr.length] + Hr + Ue;
        }
        for (this.isZero() && (Ue = "0" + Ue); Ue.length % ze !== 0; )
          Ue = "0" + Ue;
        return this.negative !== 0 && (Ue = "-" + Ue), Ue;
      }
      we(!1, "Base should be between 2 and 36");
    }, Me.prototype.toNumber = function() {
      var Ae = this.words[0];
      return this.length === 2 ? Ae += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ae += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && we(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ae : Ae;
    }, Me.prototype.toJSON = function() {
      return this.toString(16);
    }, Me.prototype.toBuffer = function(Ae, ze) {
      return we(typeof Ze < "u"), this.toArrayLike(Ze, Ae, ze);
    }, Me.prototype.toArray = function(Ae, ze) {
      return this.toArrayLike(Array, Ae, ze);
    }, Me.prototype.toArrayLike = function(Ae, ze, Ue) {
      var tr = this.byteLength(), lr = Ue || Math.max(1, tr);
      we(tr <= lr, "byte array longer than desired length"), we(lr > 0, "Requested array length <= 0"), this.strip();
      var pr = ze === "le", br = new Ae(lr), nr, Pe, ur = this.clone();
      if (pr) {
        for (Pe = 0; !ur.isZero(); Pe++)
          nr = ur.andln(255), ur.iushrn(8), br[Pe] = nr;
        for (; Pe < lr; Pe++)
          br[Pe] = 0;
      } else {
        for (Pe = 0; Pe < lr - tr; Pe++)
          br[Pe] = 0;
        for (Pe = 0; !ur.isZero(); Pe++)
          nr = ur.andln(255), ur.iushrn(8), br[lr - Pe - 1] = nr;
      }
      return br;
    }, Math.clz32 ? Me.prototype._countBits = function(Ae) {
      return 32 - Math.clz32(Ae);
    } : Me.prototype._countBits = function(Ae) {
      var ze = Ae, Ue = 0;
      return ze >= 4096 && (Ue += 13, ze >>>= 13), ze >= 64 && (Ue += 7, ze >>>= 7), ze >= 8 && (Ue += 4, ze >>>= 4), ze >= 2 && (Ue += 2, ze >>>= 2), Ue + ze;
    }, Me.prototype._zeroBits = function(Ae) {
      if (Ae === 0)
        return 26;
      var ze = Ae, Ue = 0;
      return (ze & 8191) === 0 && (Ue += 13, ze >>>= 13), (ze & 127) === 0 && (Ue += 7, ze >>>= 7), (ze & 15) === 0 && (Ue += 4, ze >>>= 4), (ze & 3) === 0 && (Ue += 2, ze >>>= 2), (ze & 1) === 0 && Ue++, Ue;
    }, Me.prototype.bitLength = function() {
      var Ae = this.words[this.length - 1], ze = this._countBits(Ae);
      return (this.length - 1) * 26 + ze;
    };
    function Ir(vr) {
      for (var Ae = new Array(vr.bitLength()), ze = 0; ze < Ae.length; ze++) {
        var Ue = ze / 26 | 0, tr = ze % 26;
        Ae[ze] = (vr.words[Ue] & 1 << tr) >>> tr;
      }
      return Ae;
    }
    Me.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var Ae = 0, ze = 0; ze < this.length; ze++) {
        var Ue = this._zeroBits(this.words[ze]);
        if (Ae += Ue, Ue !== 26)
          break;
      }
      return Ae;
    }, Me.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, Me.prototype.toTwos = function(Ae) {
      return this.negative !== 0 ? this.abs().inotn(Ae).iaddn(1) : this.clone();
    }, Me.prototype.fromTwos = function(Ae) {
      return this.testn(Ae - 1) ? this.notn(Ae).iaddn(1).ineg() : this.clone();
    }, Me.prototype.isNeg = function() {
      return this.negative !== 0;
    }, Me.prototype.neg = function() {
      return this.clone().ineg();
    }, Me.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, Me.prototype.iuor = function(Ae) {
      for (; this.length < Ae.length; )
        this.words[this.length++] = 0;
      for (var ze = 0; ze < Ae.length; ze++)
        this.words[ze] = this.words[ze] | Ae.words[ze];
      return this.strip();
    }, Me.prototype.ior = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuor(Ae);
    }, Me.prototype.or = function(Ae) {
      return this.length > Ae.length ? this.clone().ior(Ae) : Ae.clone().ior(this);
    }, Me.prototype.uor = function(Ae) {
      return this.length > Ae.length ? this.clone().iuor(Ae) : Ae.clone().iuor(this);
    }, Me.prototype.iuand = function(Ae) {
      var ze;
      this.length > Ae.length ? ze = Ae : ze = this;
      for (var Ue = 0; Ue < ze.length; Ue++)
        this.words[Ue] = this.words[Ue] & Ae.words[Ue];
      return this.length = ze.length, this.strip();
    }, Me.prototype.iand = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuand(Ae);
    }, Me.prototype.and = function(Ae) {
      return this.length > Ae.length ? this.clone().iand(Ae) : Ae.clone().iand(this);
    }, Me.prototype.uand = function(Ae) {
      return this.length > Ae.length ? this.clone().iuand(Ae) : Ae.clone().iuand(this);
    }, Me.prototype.iuxor = function(Ae) {
      var ze, Ue;
      this.length > Ae.length ? (ze = this, Ue = Ae) : (ze = Ae, Ue = this);
      for (var tr = 0; tr < Ue.length; tr++)
        this.words[tr] = ze.words[tr] ^ Ue.words[tr];
      if (this !== ze)
        for (; tr < ze.length; tr++)
          this.words[tr] = ze.words[tr];
      return this.length = ze.length, this.strip();
    }, Me.prototype.ixor = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuxor(Ae);
    }, Me.prototype.xor = function(Ae) {
      return this.length > Ae.length ? this.clone().ixor(Ae) : Ae.clone().ixor(this);
    }, Me.prototype.uxor = function(Ae) {
      return this.length > Ae.length ? this.clone().iuxor(Ae) : Ae.clone().iuxor(this);
    }, Me.prototype.inotn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Math.ceil(Ae / 26) | 0, Ue = Ae % 26;
      this._expand(ze), Ue > 0 && ze--;
      for (var tr = 0; tr < ze; tr++)
        this.words[tr] = ~this.words[tr] & 67108863;
      return Ue > 0 && (this.words[tr] = ~this.words[tr] & 67108863 >> 26 - Ue), this.strip();
    }, Me.prototype.notn = function(Ae) {
      return this.clone().inotn(Ae);
    }, Me.prototype.setn = function(Ae, ze) {
      we(typeof Ae == "number" && Ae >= 0);
      var Ue = Ae / 26 | 0, tr = Ae % 26;
      return this._expand(Ue + 1), ze ? this.words[Ue] = this.words[Ue] | 1 << tr : this.words[Ue] = this.words[Ue] & ~(1 << tr), this.strip();
    }, Me.prototype.iadd = function(Ae) {
      var ze;
      if (this.negative !== 0 && Ae.negative === 0)
        return this.negative = 0, ze = this.isub(Ae), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && Ae.negative !== 0)
        return Ae.negative = 0, ze = this.isub(Ae), Ae.negative = 1, ze._normSign();
      var Ue, tr;
      this.length > Ae.length ? (Ue = this, tr = Ae) : (Ue = Ae, tr = this);
      for (var lr = 0, pr = 0; pr < tr.length; pr++)
        ze = (Ue.words[pr] | 0) + (tr.words[pr] | 0) + lr, this.words[pr] = ze & 67108863, lr = ze >>> 26;
      for (; lr !== 0 && pr < Ue.length; pr++)
        ze = (Ue.words[pr] | 0) + lr, this.words[pr] = ze & 67108863, lr = ze >>> 26;
      if (this.length = Ue.length, lr !== 0)
        this.words[this.length] = lr, this.length++;
      else if (Ue !== this)
        for (; pr < Ue.length; pr++)
          this.words[pr] = Ue.words[pr];
      return this;
    }, Me.prototype.add = function(Ae) {
      var ze;
      return Ae.negative !== 0 && this.negative === 0 ? (Ae.negative = 0, ze = this.sub(Ae), Ae.negative ^= 1, ze) : Ae.negative === 0 && this.negative !== 0 ? (this.negative = 0, ze = Ae.sub(this), this.negative = 1, ze) : this.length > Ae.length ? this.clone().iadd(Ae) : Ae.clone().iadd(this);
    }, Me.prototype.isub = function(Ae) {
      if (Ae.negative !== 0) {
        Ae.negative = 0;
        var ze = this.iadd(Ae);
        return Ae.negative = 1, ze._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(Ae), this.negative = 1, this._normSign();
      var Ue = this.cmp(Ae);
      if (Ue === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var tr, lr;
      Ue > 0 ? (tr = this, lr = Ae) : (tr = Ae, lr = this);
      for (var pr = 0, br = 0; br < lr.length; br++)
        ze = (tr.words[br] | 0) - (lr.words[br] | 0) + pr, pr = ze >> 26, this.words[br] = ze & 67108863;
      for (; pr !== 0 && br < tr.length; br++)
        ze = (tr.words[br] | 0) + pr, pr = ze >> 26, this.words[br] = ze & 67108863;
      if (pr === 0 && br < tr.length && tr !== this)
        for (; br < tr.length; br++)
          this.words[br] = tr.words[br];
      return this.length = Math.max(this.length, br), tr !== this && (this.negative = 1), this.strip();
    }, Me.prototype.sub = function(Ae) {
      return this.clone().isub(Ae);
    };
    function Ar(vr, Ae, ze) {
      ze.negative = Ae.negative ^ vr.negative;
      var Ue = vr.length + Ae.length | 0;
      ze.length = Ue, Ue = Ue - 1 | 0;
      var tr = vr.words[0] | 0, lr = Ae.words[0] | 0, pr = tr * lr, br = pr & 67108863, nr = pr / 67108864 | 0;
      ze.words[0] = br;
      for (var Pe = 1; Pe < Ue; Pe++) {
        for (var ur = nr >>> 26, Pr = nr & 67108863, Hr = Math.min(Pe, Ae.length - 1), vi = Math.max(0, Pe - vr.length + 1); vi <= Hr; vi++) {
          var Ti = Pe - vi | 0;
          tr = vr.words[Ti] | 0, lr = Ae.words[vi] | 0, pr = tr * lr + Pr, ur += pr / 67108864 | 0, Pr = pr & 67108863;
        }
        ze.words[Pe] = Pr | 0, nr = ur | 0;
      }
      return nr !== 0 ? ze.words[Pe] = nr | 0 : ze.length--, ze.strip();
    }
    var Rr = function(Ae, ze, Ue) {
      var tr = Ae.words, lr = ze.words, pr = Ue.words, br = 0, nr, Pe, ur, Pr = tr[0] | 0, Hr = Pr & 8191, vi = Pr >>> 13, Ti = tr[1] | 0, wi = Ti & 8191, ii = Ti >>> 13, mi = tr[2] | 0, ei = mi & 8191, Zr = mi >>> 13, pi = tr[3] | 0, hi = pi & 8191, Oi = pi >>> 13, qi = tr[4] | 0, yn = qi & 8191, sn = qi >>> 13, $n = tr[5] | 0, rn = $n & 8191, ji = $n >>> 13, Kn = tr[6] | 0, In = Kn & 8191, Fn = Kn >>> 13, Po = tr[7] | 0, vn = Po & 8191, Vn = Po >>> 13, Xo = tr[8] | 0, Xn = Xo & 8191, Yn = Xo >>> 13, Wo = tr[9] | 0, Ci = Wo & 8191, ri = Wo >>> 13, yi = lr[0] | 0, Li = yi & 8191, Yi = yi >>> 13, zn = lr[1] | 0, un = zn & 8191, Gn = zn >>> 13, Mn = lr[2] | 0, pn = Mn & 8191, Rn = Mn >>> 13, Io = lr[3] | 0, to = Io & 8191, no = Io >>> 13, ma = lr[4] | 0, Qn = ma & 8191, co = ma >>> 13, kn = lr[5] | 0, ai = kn & 8191, _i = kn >>> 13, Pi = lr[6] | 0, Ai = Pi & 8191, ki = Pi >>> 13, an = lr[7] | 0, Ui = an & 8191, Vi = an >>> 13, Sn = lr[8] | 0, Hi = Sn & 8191, en = Sn >>> 13, qn = lr[9] | 0, _n = qn & 8191, Tn = qn >>> 13;
      Ue.negative = Ae.negative ^ ze.negative, Ue.length = 19, nr = Math.imul(Hr, Li), Pe = Math.imul(Hr, Yi), Pe = Pe + Math.imul(vi, Li) | 0, ur = Math.imul(vi, Yi);
      var xo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (xo >>> 26) | 0, xo &= 67108863, nr = Math.imul(wi, Li), Pe = Math.imul(wi, Yi), Pe = Pe + Math.imul(ii, Li) | 0, ur = Math.imul(ii, Yi), nr = nr + Math.imul(Hr, un) | 0, Pe = Pe + Math.imul(Hr, Gn) | 0, Pe = Pe + Math.imul(vi, un) | 0, ur = ur + Math.imul(vi, Gn) | 0;
      var Co = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Co >>> 26) | 0, Co &= 67108863, nr = Math.imul(ei, Li), Pe = Math.imul(ei, Yi), Pe = Pe + Math.imul(Zr, Li) | 0, ur = Math.imul(Zr, Yi), nr = nr + Math.imul(wi, un) | 0, Pe = Pe + Math.imul(wi, Gn) | 0, Pe = Pe + Math.imul(ii, un) | 0, ur = ur + Math.imul(ii, Gn) | 0, nr = nr + Math.imul(Hr, pn) | 0, Pe = Pe + Math.imul(Hr, Rn) | 0, Pe = Pe + Math.imul(vi, pn) | 0, ur = ur + Math.imul(vi, Rn) | 0;
      var $o = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + ($o >>> 26) | 0, $o &= 67108863, nr = Math.imul(hi, Li), Pe = Math.imul(hi, Yi), Pe = Pe + Math.imul(Oi, Li) | 0, ur = Math.imul(Oi, Yi), nr = nr + Math.imul(ei, un) | 0, Pe = Pe + Math.imul(ei, Gn) | 0, Pe = Pe + Math.imul(Zr, un) | 0, ur = ur + Math.imul(Zr, Gn) | 0, nr = nr + Math.imul(wi, pn) | 0, Pe = Pe + Math.imul(wi, Rn) | 0, Pe = Pe + Math.imul(ii, pn) | 0, ur = ur + Math.imul(ii, Rn) | 0, nr = nr + Math.imul(Hr, to) | 0, Pe = Pe + Math.imul(Hr, no) | 0, Pe = Pe + Math.imul(vi, to) | 0, ur = ur + Math.imul(vi, no) | 0;
      var Bo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Bo >>> 26) | 0, Bo &= 67108863, nr = Math.imul(yn, Li), Pe = Math.imul(yn, Yi), Pe = Pe + Math.imul(sn, Li) | 0, ur = Math.imul(sn, Yi), nr = nr + Math.imul(hi, un) | 0, Pe = Pe + Math.imul(hi, Gn) | 0, Pe = Pe + Math.imul(Oi, un) | 0, ur = ur + Math.imul(Oi, Gn) | 0, nr = nr + Math.imul(ei, pn) | 0, Pe = Pe + Math.imul(ei, Rn) | 0, Pe = Pe + Math.imul(Zr, pn) | 0, ur = ur + Math.imul(Zr, Rn) | 0, nr = nr + Math.imul(wi, to) | 0, Pe = Pe + Math.imul(wi, no) | 0, Pe = Pe + Math.imul(ii, to) | 0, ur = ur + Math.imul(ii, no) | 0, nr = nr + Math.imul(Hr, Qn) | 0, Pe = Pe + Math.imul(Hr, co) | 0, Pe = Pe + Math.imul(vi, Qn) | 0, ur = ur + Math.imul(vi, co) | 0;
      var Qo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Qo >>> 26) | 0, Qo &= 67108863, nr = Math.imul(rn, Li), Pe = Math.imul(rn, Yi), Pe = Pe + Math.imul(ji, Li) | 0, ur = Math.imul(ji, Yi), nr = nr + Math.imul(yn, un) | 0, Pe = Pe + Math.imul(yn, Gn) | 0, Pe = Pe + Math.imul(sn, un) | 0, ur = ur + Math.imul(sn, Gn) | 0, nr = nr + Math.imul(hi, pn) | 0, Pe = Pe + Math.imul(hi, Rn) | 0, Pe = Pe + Math.imul(Oi, pn) | 0, ur = ur + Math.imul(Oi, Rn) | 0, nr = nr + Math.imul(ei, to) | 0, Pe = Pe + Math.imul(ei, no) | 0, Pe = Pe + Math.imul(Zr, to) | 0, ur = ur + Math.imul(Zr, no) | 0, nr = nr + Math.imul(wi, Qn) | 0, Pe = Pe + Math.imul(wi, co) | 0, Pe = Pe + Math.imul(ii, Qn) | 0, ur = ur + Math.imul(ii, co) | 0, nr = nr + Math.imul(Hr, ai) | 0, Pe = Pe + Math.imul(Hr, _i) | 0, Pe = Pe + Math.imul(vi, ai) | 0, ur = ur + Math.imul(vi, _i) | 0;
      var Go = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Go >>> 26) | 0, Go &= 67108863, nr = Math.imul(In, Li), Pe = Math.imul(In, Yi), Pe = Pe + Math.imul(Fn, Li) | 0, ur = Math.imul(Fn, Yi), nr = nr + Math.imul(rn, un) | 0, Pe = Pe + Math.imul(rn, Gn) | 0, Pe = Pe + Math.imul(ji, un) | 0, ur = ur + Math.imul(ji, Gn) | 0, nr = nr + Math.imul(yn, pn) | 0, Pe = Pe + Math.imul(yn, Rn) | 0, Pe = Pe + Math.imul(sn, pn) | 0, ur = ur + Math.imul(sn, Rn) | 0, nr = nr + Math.imul(hi, to) | 0, Pe = Pe + Math.imul(hi, no) | 0, Pe = Pe + Math.imul(Oi, to) | 0, ur = ur + Math.imul(Oi, no) | 0, nr = nr + Math.imul(ei, Qn) | 0, Pe = Pe + Math.imul(ei, co) | 0, Pe = Pe + Math.imul(Zr, Qn) | 0, ur = ur + Math.imul(Zr, co) | 0, nr = nr + Math.imul(wi, ai) | 0, Pe = Pe + Math.imul(wi, _i) | 0, Pe = Pe + Math.imul(ii, ai) | 0, ur = ur + Math.imul(ii, _i) | 0, nr = nr + Math.imul(Hr, Ai) | 0, Pe = Pe + Math.imul(Hr, ki) | 0, Pe = Pe + Math.imul(vi, Ai) | 0, ur = ur + Math.imul(vi, ki) | 0;
      var No = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, nr = Math.imul(vn, Li), Pe = Math.imul(vn, Yi), Pe = Pe + Math.imul(Vn, Li) | 0, ur = Math.imul(Vn, Yi), nr = nr + Math.imul(In, un) | 0, Pe = Pe + Math.imul(In, Gn) | 0, Pe = Pe + Math.imul(Fn, un) | 0, ur = ur + Math.imul(Fn, Gn) | 0, nr = nr + Math.imul(rn, pn) | 0, Pe = Pe + Math.imul(rn, Rn) | 0, Pe = Pe + Math.imul(ji, pn) | 0, ur = ur + Math.imul(ji, Rn) | 0, nr = nr + Math.imul(yn, to) | 0, Pe = Pe + Math.imul(yn, no) | 0, Pe = Pe + Math.imul(sn, to) | 0, ur = ur + Math.imul(sn, no) | 0, nr = nr + Math.imul(hi, Qn) | 0, Pe = Pe + Math.imul(hi, co) | 0, Pe = Pe + Math.imul(Oi, Qn) | 0, ur = ur + Math.imul(Oi, co) | 0, nr = nr + Math.imul(ei, ai) | 0, Pe = Pe + Math.imul(ei, _i) | 0, Pe = Pe + Math.imul(Zr, ai) | 0, ur = ur + Math.imul(Zr, _i) | 0, nr = nr + Math.imul(wi, Ai) | 0, Pe = Pe + Math.imul(wi, ki) | 0, Pe = Pe + Math.imul(ii, Ai) | 0, ur = ur + Math.imul(ii, ki) | 0, nr = nr + Math.imul(Hr, Ui) | 0, Pe = Pe + Math.imul(Hr, Vi) | 0, Pe = Pe + Math.imul(vi, Ui) | 0, ur = ur + Math.imul(vi, Vi) | 0;
      var Zo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Zo >>> 26) | 0, Zo &= 67108863, nr = Math.imul(Xn, Li), Pe = Math.imul(Xn, Yi), Pe = Pe + Math.imul(Yn, Li) | 0, ur = Math.imul(Yn, Yi), nr = nr + Math.imul(vn, un) | 0, Pe = Pe + Math.imul(vn, Gn) | 0, Pe = Pe + Math.imul(Vn, un) | 0, ur = ur + Math.imul(Vn, Gn) | 0, nr = nr + Math.imul(In, pn) | 0, Pe = Pe + Math.imul(In, Rn) | 0, Pe = Pe + Math.imul(Fn, pn) | 0, ur = ur + Math.imul(Fn, Rn) | 0, nr = nr + Math.imul(rn, to) | 0, Pe = Pe + Math.imul(rn, no) | 0, Pe = Pe + Math.imul(ji, to) | 0, ur = ur + Math.imul(ji, no) | 0, nr = nr + Math.imul(yn, Qn) | 0, Pe = Pe + Math.imul(yn, co) | 0, Pe = Pe + Math.imul(sn, Qn) | 0, ur = ur + Math.imul(sn, co) | 0, nr = nr + Math.imul(hi, ai) | 0, Pe = Pe + Math.imul(hi, _i) | 0, Pe = Pe + Math.imul(Oi, ai) | 0, ur = ur + Math.imul(Oi, _i) | 0, nr = nr + Math.imul(ei, Ai) | 0, Pe = Pe + Math.imul(ei, ki) | 0, Pe = Pe + Math.imul(Zr, Ai) | 0, ur = ur + Math.imul(Zr, ki) | 0, nr = nr + Math.imul(wi, Ui) | 0, Pe = Pe + Math.imul(wi, Vi) | 0, Pe = Pe + Math.imul(ii, Ui) | 0, ur = ur + Math.imul(ii, Vi) | 0, nr = nr + Math.imul(Hr, Hi) | 0, Pe = Pe + Math.imul(Hr, en) | 0, Pe = Pe + Math.imul(vi, Hi) | 0, ur = ur + Math.imul(vi, en) | 0;
      var ea = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ea >>> 26) | 0, ea &= 67108863, nr = Math.imul(Ci, Li), Pe = Math.imul(Ci, Yi), Pe = Pe + Math.imul(ri, Li) | 0, ur = Math.imul(ri, Yi), nr = nr + Math.imul(Xn, un) | 0, Pe = Pe + Math.imul(Xn, Gn) | 0, Pe = Pe + Math.imul(Yn, un) | 0, ur = ur + Math.imul(Yn, Gn) | 0, nr = nr + Math.imul(vn, pn) | 0, Pe = Pe + Math.imul(vn, Rn) | 0, Pe = Pe + Math.imul(Vn, pn) | 0, ur = ur + Math.imul(Vn, Rn) | 0, nr = nr + Math.imul(In, to) | 0, Pe = Pe + Math.imul(In, no) | 0, Pe = Pe + Math.imul(Fn, to) | 0, ur = ur + Math.imul(Fn, no) | 0, nr = nr + Math.imul(rn, Qn) | 0, Pe = Pe + Math.imul(rn, co) | 0, Pe = Pe + Math.imul(ji, Qn) | 0, ur = ur + Math.imul(ji, co) | 0, nr = nr + Math.imul(yn, ai) | 0, Pe = Pe + Math.imul(yn, _i) | 0, Pe = Pe + Math.imul(sn, ai) | 0, ur = ur + Math.imul(sn, _i) | 0, nr = nr + Math.imul(hi, Ai) | 0, Pe = Pe + Math.imul(hi, ki) | 0, Pe = Pe + Math.imul(Oi, Ai) | 0, ur = ur + Math.imul(Oi, ki) | 0, nr = nr + Math.imul(ei, Ui) | 0, Pe = Pe + Math.imul(ei, Vi) | 0, Pe = Pe + Math.imul(Zr, Ui) | 0, ur = ur + Math.imul(Zr, Vi) | 0, nr = nr + Math.imul(wi, Hi) | 0, Pe = Pe + Math.imul(wi, en) | 0, Pe = Pe + Math.imul(ii, Hi) | 0, ur = ur + Math.imul(ii, en) | 0, nr = nr + Math.imul(Hr, _n) | 0, Pe = Pe + Math.imul(Hr, Tn) | 0, Pe = Pe + Math.imul(vi, _n) | 0, ur = ur + Math.imul(vi, Tn) | 0;
      var da = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (da >>> 26) | 0, da &= 67108863, nr = Math.imul(Ci, un), Pe = Math.imul(Ci, Gn), Pe = Pe + Math.imul(ri, un) | 0, ur = Math.imul(ri, Gn), nr = nr + Math.imul(Xn, pn) | 0, Pe = Pe + Math.imul(Xn, Rn) | 0, Pe = Pe + Math.imul(Yn, pn) | 0, ur = ur + Math.imul(Yn, Rn) | 0, nr = nr + Math.imul(vn, to) | 0, Pe = Pe + Math.imul(vn, no) | 0, Pe = Pe + Math.imul(Vn, to) | 0, ur = ur + Math.imul(Vn, no) | 0, nr = nr + Math.imul(In, Qn) | 0, Pe = Pe + Math.imul(In, co) | 0, Pe = Pe + Math.imul(Fn, Qn) | 0, ur = ur + Math.imul(Fn, co) | 0, nr = nr + Math.imul(rn, ai) | 0, Pe = Pe + Math.imul(rn, _i) | 0, Pe = Pe + Math.imul(ji, ai) | 0, ur = ur + Math.imul(ji, _i) | 0, nr = nr + Math.imul(yn, Ai) | 0, Pe = Pe + Math.imul(yn, ki) | 0, Pe = Pe + Math.imul(sn, Ai) | 0, ur = ur + Math.imul(sn, ki) | 0, nr = nr + Math.imul(hi, Ui) | 0, Pe = Pe + Math.imul(hi, Vi) | 0, Pe = Pe + Math.imul(Oi, Ui) | 0, ur = ur + Math.imul(Oi, Vi) | 0, nr = nr + Math.imul(ei, Hi) | 0, Pe = Pe + Math.imul(ei, en) | 0, Pe = Pe + Math.imul(Zr, Hi) | 0, ur = ur + Math.imul(Zr, en) | 0, nr = nr + Math.imul(wi, _n) | 0, Pe = Pe + Math.imul(wi, Tn) | 0, Pe = Pe + Math.imul(ii, _n) | 0, ur = ur + Math.imul(ii, Tn) | 0;
      var Ra = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ra >>> 26) | 0, Ra &= 67108863, nr = Math.imul(Ci, pn), Pe = Math.imul(Ci, Rn), Pe = Pe + Math.imul(ri, pn) | 0, ur = Math.imul(ri, Rn), nr = nr + Math.imul(Xn, to) | 0, Pe = Pe + Math.imul(Xn, no) | 0, Pe = Pe + Math.imul(Yn, to) | 0, ur = ur + Math.imul(Yn, no) | 0, nr = nr + Math.imul(vn, Qn) | 0, Pe = Pe + Math.imul(vn, co) | 0, Pe = Pe + Math.imul(Vn, Qn) | 0, ur = ur + Math.imul(Vn, co) | 0, nr = nr + Math.imul(In, ai) | 0, Pe = Pe + Math.imul(In, _i) | 0, Pe = Pe + Math.imul(Fn, ai) | 0, ur = ur + Math.imul(Fn, _i) | 0, nr = nr + Math.imul(rn, Ai) | 0, Pe = Pe + Math.imul(rn, ki) | 0, Pe = Pe + Math.imul(ji, Ai) | 0, ur = ur + Math.imul(ji, ki) | 0, nr = nr + Math.imul(yn, Ui) | 0, Pe = Pe + Math.imul(yn, Vi) | 0, Pe = Pe + Math.imul(sn, Ui) | 0, ur = ur + Math.imul(sn, Vi) | 0, nr = nr + Math.imul(hi, Hi) | 0, Pe = Pe + Math.imul(hi, en) | 0, Pe = Pe + Math.imul(Oi, Hi) | 0, ur = ur + Math.imul(Oi, en) | 0, nr = nr + Math.imul(ei, _n) | 0, Pe = Pe + Math.imul(ei, Tn) | 0, Pe = Pe + Math.imul(Zr, _n) | 0, ur = ur + Math.imul(Zr, Tn) | 0;
      var ba = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ba >>> 26) | 0, ba &= 67108863, nr = Math.imul(Ci, to), Pe = Math.imul(Ci, no), Pe = Pe + Math.imul(ri, to) | 0, ur = Math.imul(ri, no), nr = nr + Math.imul(Xn, Qn) | 0, Pe = Pe + Math.imul(Xn, co) | 0, Pe = Pe + Math.imul(Yn, Qn) | 0, ur = ur + Math.imul(Yn, co) | 0, nr = nr + Math.imul(vn, ai) | 0, Pe = Pe + Math.imul(vn, _i) | 0, Pe = Pe + Math.imul(Vn, ai) | 0, ur = ur + Math.imul(Vn, _i) | 0, nr = nr + Math.imul(In, Ai) | 0, Pe = Pe + Math.imul(In, ki) | 0, Pe = Pe + Math.imul(Fn, Ai) | 0, ur = ur + Math.imul(Fn, ki) | 0, nr = nr + Math.imul(rn, Ui) | 0, Pe = Pe + Math.imul(rn, Vi) | 0, Pe = Pe + Math.imul(ji, Ui) | 0, ur = ur + Math.imul(ji, Vi) | 0, nr = nr + Math.imul(yn, Hi) | 0, Pe = Pe + Math.imul(yn, en) | 0, Pe = Pe + Math.imul(sn, Hi) | 0, ur = ur + Math.imul(sn, en) | 0, nr = nr + Math.imul(hi, _n) | 0, Pe = Pe + Math.imul(hi, Tn) | 0, Pe = Pe + Math.imul(Oi, _n) | 0, ur = ur + Math.imul(Oi, Tn) | 0;
      var Ea = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ea >>> 26) | 0, Ea &= 67108863, nr = Math.imul(Ci, Qn), Pe = Math.imul(Ci, co), Pe = Pe + Math.imul(ri, Qn) | 0, ur = Math.imul(ri, co), nr = nr + Math.imul(Xn, ai) | 0, Pe = Pe + Math.imul(Xn, _i) | 0, Pe = Pe + Math.imul(Yn, ai) | 0, ur = ur + Math.imul(Yn, _i) | 0, nr = nr + Math.imul(vn, Ai) | 0, Pe = Pe + Math.imul(vn, ki) | 0, Pe = Pe + Math.imul(Vn, Ai) | 0, ur = ur + Math.imul(Vn, ki) | 0, nr = nr + Math.imul(In, Ui) | 0, Pe = Pe + Math.imul(In, Vi) | 0, Pe = Pe + Math.imul(Fn, Ui) | 0, ur = ur + Math.imul(Fn, Vi) | 0, nr = nr + Math.imul(rn, Hi) | 0, Pe = Pe + Math.imul(rn, en) | 0, Pe = Pe + Math.imul(ji, Hi) | 0, ur = ur + Math.imul(ji, en) | 0, nr = nr + Math.imul(yn, _n) | 0, Pe = Pe + Math.imul(yn, Tn) | 0, Pe = Pe + Math.imul(sn, _n) | 0, ur = ur + Math.imul(sn, Tn) | 0;
      var Ha = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ha >>> 26) | 0, Ha &= 67108863, nr = Math.imul(Ci, ai), Pe = Math.imul(Ci, _i), Pe = Pe + Math.imul(ri, ai) | 0, ur = Math.imul(ri, _i), nr = nr + Math.imul(Xn, Ai) | 0, Pe = Pe + Math.imul(Xn, ki) | 0, Pe = Pe + Math.imul(Yn, Ai) | 0, ur = ur + Math.imul(Yn, ki) | 0, nr = nr + Math.imul(vn, Ui) | 0, Pe = Pe + Math.imul(vn, Vi) | 0, Pe = Pe + Math.imul(Vn, Ui) | 0, ur = ur + Math.imul(Vn, Vi) | 0, nr = nr + Math.imul(In, Hi) | 0, Pe = Pe + Math.imul(In, en) | 0, Pe = Pe + Math.imul(Fn, Hi) | 0, ur = ur + Math.imul(Fn, en) | 0, nr = nr + Math.imul(rn, _n) | 0, Pe = Pe + Math.imul(rn, Tn) | 0, Pe = Pe + Math.imul(ji, _n) | 0, ur = ur + Math.imul(ji, Tn) | 0;
      var Fa = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Fa >>> 26) | 0, Fa &= 67108863, nr = Math.imul(Ci, Ai), Pe = Math.imul(Ci, ki), Pe = Pe + Math.imul(ri, Ai) | 0, ur = Math.imul(ri, ki), nr = nr + Math.imul(Xn, Ui) | 0, Pe = Pe + Math.imul(Xn, Vi) | 0, Pe = Pe + Math.imul(Yn, Ui) | 0, ur = ur + Math.imul(Yn, Vi) | 0, nr = nr + Math.imul(vn, Hi) | 0, Pe = Pe + Math.imul(vn, en) | 0, Pe = Pe + Math.imul(Vn, Hi) | 0, ur = ur + Math.imul(Vn, en) | 0, nr = nr + Math.imul(In, _n) | 0, Pe = Pe + Math.imul(In, Tn) | 0, Pe = Pe + Math.imul(Fn, _n) | 0, ur = ur + Math.imul(Fn, Tn) | 0;
      var ls = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ls >>> 26) | 0, ls &= 67108863, nr = Math.imul(Ci, Ui), Pe = Math.imul(Ci, Vi), Pe = Pe + Math.imul(ri, Ui) | 0, ur = Math.imul(ri, Vi), nr = nr + Math.imul(Xn, Hi) | 0, Pe = Pe + Math.imul(Xn, en) | 0, Pe = Pe + Math.imul(Yn, Hi) | 0, ur = ur + Math.imul(Yn, en) | 0, nr = nr + Math.imul(vn, _n) | 0, Pe = Pe + Math.imul(vn, Tn) | 0, Pe = Pe + Math.imul(Vn, _n) | 0, ur = ur + Math.imul(Vn, Tn) | 0;
      var us = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (us >>> 26) | 0, us &= 67108863, nr = Math.imul(Ci, Hi), Pe = Math.imul(Ci, en), Pe = Pe + Math.imul(ri, Hi) | 0, ur = Math.imul(ri, en), nr = nr + Math.imul(Xn, _n) | 0, Pe = Pe + Math.imul(Xn, Tn) | 0, Pe = Pe + Math.imul(Yn, _n) | 0, ur = ur + Math.imul(Yn, Tn) | 0;
      var Xa = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Xa >>> 26) | 0, Xa &= 67108863, nr = Math.imul(Ci, _n), Pe = Math.imul(Ci, Tn), Pe = Pe + Math.imul(ri, _n) | 0, ur = Math.imul(ri, Tn);
      var hs = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      return br = (ur + (Pe >>> 13) | 0) + (hs >>> 26) | 0, hs &= 67108863, pr[0] = xo, pr[1] = Co, pr[2] = $o, pr[3] = Bo, pr[4] = Qo, pr[5] = Go, pr[6] = No, pr[7] = Zo, pr[8] = ea, pr[9] = da, pr[10] = Ra, pr[11] = ba, pr[12] = Ea, pr[13] = Ha, pr[14] = Fa, pr[15] = ls, pr[16] = us, pr[17] = Xa, pr[18] = hs, br !== 0 && (pr[19] = br, Ue.length++), Ue;
    };
    Math.imul || (Rr = Ar);
    function Nr(vr, Ae, ze) {
      ze.negative = Ae.negative ^ vr.negative, ze.length = vr.length + Ae.length;
      for (var Ue = 0, tr = 0, lr = 0; lr < ze.length - 1; lr++) {
        var pr = tr;
        tr = 0;
        for (var br = Ue & 67108863, nr = Math.min(lr, Ae.length - 1), Pe = Math.max(0, lr - vr.length + 1); Pe <= nr; Pe++) {
          var ur = lr - Pe, Pr = vr.words[ur] | 0, Hr = Ae.words[Pe] | 0, vi = Pr * Hr, Ti = vi & 67108863;
          pr = pr + (vi / 67108864 | 0) | 0, Ti = Ti + br | 0, br = Ti & 67108863, pr = pr + (Ti >>> 26) | 0, tr += pr >>> 26, pr &= 67108863;
        }
        ze.words[lr] = br, Ue = pr, pr = tr;
      }
      return Ue !== 0 ? ze.words[lr] = Ue : ze.length--, ze.strip();
    }
    function Yr(vr, Ae, ze) {
      var Ue = new Vr();
      return Ue.mulp(vr, Ae, ze);
    }
    Me.prototype.mulTo = function(Ae, ze) {
      var Ue, tr = this.length + Ae.length;
      return this.length === 10 && Ae.length === 10 ? Ue = Rr(this, Ae, ze) : tr < 63 ? Ue = Ar(this, Ae, ze) : tr < 1024 ? Ue = Nr(this, Ae, ze) : Ue = Yr(this, Ae, ze), Ue;
    };
    function Vr(vr, Ae) {
      this.x = vr, this.y = Ae;
    }
    Vr.prototype.makeRBT = function(Ae) {
      for (var ze = new Array(Ae), Ue = Me.prototype._countBits(Ae) - 1, tr = 0; tr < Ae; tr++)
        ze[tr] = this.revBin(tr, Ue, Ae);
      return ze;
    }, Vr.prototype.revBin = function(Ae, ze, Ue) {
      if (Ae === 0 || Ae === Ue - 1)
        return Ae;
      for (var tr = 0, lr = 0; lr < ze; lr++)
        tr |= (Ae & 1) << ze - lr - 1, Ae >>= 1;
      return tr;
    }, Vr.prototype.permute = function(Ae, ze, Ue, tr, lr, pr) {
      for (var br = 0; br < pr; br++)
        tr[br] = ze[Ae[br]], lr[br] = Ue[Ae[br]];
    }, Vr.prototype.transform = function(Ae, ze, Ue, tr, lr, pr) {
      this.permute(pr, Ae, ze, Ue, tr, lr);
      for (var br = 1; br < lr; br <<= 1)
        for (var nr = br << 1, Pe = Math.cos(2 * Math.PI / nr), ur = Math.sin(2 * Math.PI / nr), Pr = 0; Pr < lr; Pr += nr)
          for (var Hr = Pe, vi = ur, Ti = 0; Ti < br; Ti++) {
            var wi = Ue[Pr + Ti], ii = tr[Pr + Ti], mi = Ue[Pr + Ti + br], ei = tr[Pr + Ti + br], Zr = Hr * mi - vi * ei;
            ei = Hr * ei + vi * mi, mi = Zr, Ue[Pr + Ti] = wi + mi, tr[Pr + Ti] = ii + ei, Ue[Pr + Ti + br] = wi - mi, tr[Pr + Ti + br] = ii - ei, Ti !== nr && (Zr = Pe * Hr - ur * vi, vi = Pe * vi + ur * Hr, Hr = Zr);
          }
    }, Vr.prototype.guessLen13b = function(Ae, ze) {
      var Ue = Math.max(ze, Ae) | 1, tr = Ue & 1, lr = 0;
      for (Ue = Ue / 2 | 0; Ue; Ue = Ue >>> 1)
        lr++;
      return 1 << lr + 1 + tr;
    }, Vr.prototype.conjugate = function(Ae, ze, Ue) {
      if (!(Ue <= 1))
        for (var tr = 0; tr < Ue / 2; tr++) {
          var lr = Ae[tr];
          Ae[tr] = Ae[Ue - tr - 1], Ae[Ue - tr - 1] = lr, lr = ze[tr], ze[tr] = -ze[Ue - tr - 1], ze[Ue - tr - 1] = -lr;
        }
    }, Vr.prototype.normalize13b = function(Ae, ze) {
      for (var Ue = 0, tr = 0; tr < ze / 2; tr++) {
        var lr = Math.round(Ae[2 * tr + 1] / ze) * 8192 + Math.round(Ae[2 * tr] / ze) + Ue;
        Ae[tr] = lr & 67108863, lr < 67108864 ? Ue = 0 : Ue = lr / 67108864 | 0;
      }
      return Ae;
    }, Vr.prototype.convert13b = function(Ae, ze, Ue, tr) {
      for (var lr = 0, pr = 0; pr < ze; pr++)
        lr = lr + (Ae[pr] | 0), Ue[2 * pr] = lr & 8191, lr = lr >>> 13, Ue[2 * pr + 1] = lr & 8191, lr = lr >>> 13;
      for (pr = 2 * ze; pr < tr; ++pr)
        Ue[pr] = 0;
      we(lr === 0), we((lr & -8192) === 0);
    }, Vr.prototype.stub = function(Ae) {
      for (var ze = new Array(Ae), Ue = 0; Ue < Ae; Ue++)
        ze[Ue] = 0;
      return ze;
    }, Vr.prototype.mulp = function(Ae, ze, Ue) {
      var tr = 2 * this.guessLen13b(Ae.length, ze.length), lr = this.makeRBT(tr), pr = this.stub(tr), br = new Array(tr), nr = new Array(tr), Pe = new Array(tr), ur = new Array(tr), Pr = new Array(tr), Hr = new Array(tr), vi = Ue.words;
      vi.length = tr, this.convert13b(Ae.words, Ae.length, br, tr), this.convert13b(ze.words, ze.length, ur, tr), this.transform(br, pr, nr, Pe, tr, lr), this.transform(ur, pr, Pr, Hr, tr, lr);
      for (var Ti = 0; Ti < tr; Ti++) {
        var wi = nr[Ti] * Pr[Ti] - Pe[Ti] * Hr[Ti];
        Pe[Ti] = nr[Ti] * Hr[Ti] + Pe[Ti] * Pr[Ti], nr[Ti] = wi;
      }
      return this.conjugate(nr, Pe, tr), this.transform(nr, Pe, vi, pr, tr, lr), this.conjugate(vi, pr, tr), this.normalize13b(vi, tr), Ue.negative = Ae.negative ^ ze.negative, Ue.length = Ae.length + ze.length, Ue.strip();
    }, Me.prototype.mul = function(Ae) {
      var ze = new Me(null);
      return ze.words = new Array(this.length + Ae.length), this.mulTo(Ae, ze);
    }, Me.prototype.mulf = function(Ae) {
      var ze = new Me(null);
      return ze.words = new Array(this.length + Ae.length), Yr(this, Ae, ze);
    }, Me.prototype.imul = function(Ae) {
      return this.clone().mulTo(Ae, this);
    }, Me.prototype.imuln = function(Ae) {
      we(typeof Ae == "number"), we(Ae < 67108864);
      for (var ze = 0, Ue = 0; Ue < this.length; Ue++) {
        var tr = (this.words[Ue] | 0) * Ae, lr = (tr & 67108863) + (ze & 67108863);
        ze >>= 26, ze += tr / 67108864 | 0, ze += lr >>> 26, this.words[Ue] = lr & 67108863;
      }
      return ze !== 0 && (this.words[Ue] = ze, this.length++), this;
    }, Me.prototype.muln = function(Ae) {
      return this.clone().imuln(Ae);
    }, Me.prototype.sqr = function() {
      return this.mul(this);
    }, Me.prototype.isqr = function() {
      return this.imul(this.clone());
    }, Me.prototype.pow = function(Ae) {
      var ze = Ir(Ae);
      if (ze.length === 0)
        return new Me(1);
      for (var Ue = this, tr = 0; tr < ze.length && ze[tr] === 0; tr++, Ue = Ue.sqr())
        ;
      if (++tr < ze.length)
        for (var lr = Ue.sqr(); tr < ze.length; tr++, lr = lr.sqr())
          ze[tr] !== 0 && (Ue = Ue.mul(lr));
      return Ue;
    }, Me.prototype.iushln = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 67108863 >>> 26 - ze << 26 - ze, lr;
      if (ze !== 0) {
        var pr = 0;
        for (lr = 0; lr < this.length; lr++) {
          var br = this.words[lr] & tr, nr = (this.words[lr] | 0) - br << ze;
          this.words[lr] = nr | pr, pr = br >>> 26 - ze;
        }
        pr && (this.words[lr] = pr, this.length++);
      }
      if (Ue !== 0) {
        for (lr = this.length - 1; lr >= 0; lr--)
          this.words[lr + Ue] = this.words[lr];
        for (lr = 0; lr < Ue; lr++)
          this.words[lr] = 0;
        this.length += Ue;
      }
      return this.strip();
    }, Me.prototype.ishln = function(Ae) {
      return we(this.negative === 0), this.iushln(Ae);
    }, Me.prototype.iushrn = function(Ae, ze, Ue) {
      we(typeof Ae == "number" && Ae >= 0);
      var tr;
      ze ? tr = (ze - ze % 26) / 26 : tr = 0;
      var lr = Ae % 26, pr = Math.min((Ae - lr) / 26, this.length), br = 67108863 ^ 67108863 >>> lr << lr, nr = Ue;
      if (tr -= pr, tr = Math.max(0, tr), nr) {
        for (var Pe = 0; Pe < pr; Pe++)
          nr.words[Pe] = this.words[Pe];
        nr.length = pr;
      }
      if (pr !== 0)
        if (this.length > pr)
          for (this.length -= pr, Pe = 0; Pe < this.length; Pe++)
            this.words[Pe] = this.words[Pe + pr];
        else
          this.words[0] = 0, this.length = 1;
      var ur = 0;
      for (Pe = this.length - 1; Pe >= 0 && (ur !== 0 || Pe >= tr); Pe--) {
        var Pr = this.words[Pe] | 0;
        this.words[Pe] = ur << 26 - lr | Pr >>> lr, ur = Pr & br;
      }
      return nr && ur !== 0 && (nr.words[nr.length++] = ur), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, Me.prototype.ishrn = function(Ae, ze, Ue) {
      return we(this.negative === 0), this.iushrn(Ae, ze, Ue);
    }, Me.prototype.shln = function(Ae) {
      return this.clone().ishln(Ae);
    }, Me.prototype.ushln = function(Ae) {
      return this.clone().iushln(Ae);
    }, Me.prototype.shrn = function(Ae) {
      return this.clone().ishrn(Ae);
    }, Me.prototype.ushrn = function(Ae) {
      return this.clone().iushrn(Ae);
    }, Me.prototype.testn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 1 << ze;
      if (this.length <= Ue)
        return !1;
      var lr = this.words[Ue];
      return !!(lr & tr);
    }, Me.prototype.imaskn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26;
      if (we(this.negative === 0, "imaskn works only with positive numbers"), this.length <= Ue)
        return this;
      if (ze !== 0 && Ue++, this.length = Math.min(Ue, this.length), ze !== 0) {
        var tr = 67108863 ^ 67108863 >>> ze << ze;
        this.words[this.length - 1] &= tr;
      }
      return this.strip();
    }, Me.prototype.maskn = function(Ae) {
      return this.clone().imaskn(Ae);
    }, Me.prototype.iaddn = function(Ae) {
      return we(typeof Ae == "number"), we(Ae < 67108864), Ae < 0 ? this.isubn(-Ae) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Ae ? (this.words[0] = Ae - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ae), this.negative = 1, this) : this._iaddn(Ae);
    }, Me.prototype._iaddn = function(Ae) {
      this.words[0] += Ae;
      for (var ze = 0; ze < this.length && this.words[ze] >= 67108864; ze++)
        this.words[ze] -= 67108864, ze === this.length - 1 ? this.words[ze + 1] = 1 : this.words[ze + 1]++;
      return this.length = Math.max(this.length, ze + 1), this;
    }, Me.prototype.isubn = function(Ae) {
      if (we(typeof Ae == "number"), we(Ae < 67108864), Ae < 0)
        return this.iaddn(-Ae);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(Ae), this.negative = 1, this;
      if (this.words[0] -= Ae, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var ze = 0; ze < this.length && this.words[ze] < 0; ze++)
          this.words[ze] += 67108864, this.words[ze + 1] -= 1;
      return this.strip();
    }, Me.prototype.addn = function(Ae) {
      return this.clone().iaddn(Ae);
    }, Me.prototype.subn = function(Ae) {
      return this.clone().isubn(Ae);
    }, Me.prototype.iabs = function() {
      return this.negative = 0, this;
    }, Me.prototype.abs = function() {
      return this.clone().iabs();
    }, Me.prototype._ishlnsubmul = function(Ae, ze, Ue) {
      var tr = Ae.length + Ue, lr;
      this._expand(tr);
      var pr, br = 0;
      for (lr = 0; lr < Ae.length; lr++) {
        pr = (this.words[lr + Ue] | 0) + br;
        var nr = (Ae.words[lr] | 0) * ze;
        pr -= nr & 67108863, br = (pr >> 26) - (nr / 67108864 | 0), this.words[lr + Ue] = pr & 67108863;
      }
      for (; lr < this.length - Ue; lr++)
        pr = (this.words[lr + Ue] | 0) + br, br = pr >> 26, this.words[lr + Ue] = pr & 67108863;
      if (br === 0)
        return this.strip();
      for (we(br === -1), br = 0, lr = 0; lr < this.length; lr++)
        pr = -(this.words[lr] | 0) + br, br = pr >> 26, this.words[lr] = pr & 67108863;
      return this.negative = 1, this.strip();
    }, Me.prototype._wordDiv = function(Ae, ze) {
      var Ue = this.length - Ae.length, tr = this.clone(), lr = Ae, pr = lr.words[lr.length - 1] | 0, br = this._countBits(pr);
      Ue = 26 - br, Ue !== 0 && (lr = lr.ushln(Ue), tr.iushln(Ue), pr = lr.words[lr.length - 1] | 0);
      var nr = tr.length - lr.length, Pe;
      if (ze !== "mod") {
        Pe = new Me(null), Pe.length = nr + 1, Pe.words = new Array(Pe.length);
        for (var ur = 0; ur < Pe.length; ur++)
          Pe.words[ur] = 0;
      }
      var Pr = tr.clone()._ishlnsubmul(lr, 1, nr);
      Pr.negative === 0 && (tr = Pr, Pe && (Pe.words[nr] = 1));
      for (var Hr = nr - 1; Hr >= 0; Hr--) {
        var vi = (tr.words[lr.length + Hr] | 0) * 67108864 + (tr.words[lr.length + Hr - 1] | 0);
        for (vi = Math.min(vi / pr | 0, 67108863), tr._ishlnsubmul(lr, vi, Hr); tr.negative !== 0; )
          vi--, tr.negative = 0, tr._ishlnsubmul(lr, 1, Hr), tr.isZero() || (tr.negative ^= 1);
        Pe && (Pe.words[Hr] = vi);
      }
      return Pe && Pe.strip(), tr.strip(), ze !== "div" && Ue !== 0 && tr.iushrn(Ue), {
        div: Pe || null,
        mod: tr
      };
    }, Me.prototype.divmod = function(Ae, ze, Ue) {
      if (we(!Ae.isZero()), this.isZero())
        return {
          div: new Me(0),
          mod: new Me(0)
        };
      var tr, lr, pr;
      return this.negative !== 0 && Ae.negative === 0 ? (pr = this.neg().divmod(Ae, ze), ze !== "mod" && (tr = pr.div.neg()), ze !== "div" && (lr = pr.mod.neg(), Ue && lr.negative !== 0 && lr.iadd(Ae)), {
        div: tr,
        mod: lr
      }) : this.negative === 0 && Ae.negative !== 0 ? (pr = this.divmod(Ae.neg(), ze), ze !== "mod" && (tr = pr.div.neg()), {
        div: tr,
        mod: pr.mod
      }) : (this.negative & Ae.negative) !== 0 ? (pr = this.neg().divmod(Ae.neg(), ze), ze !== "div" && (lr = pr.mod.neg(), Ue && lr.negative !== 0 && lr.isub(Ae)), {
        div: pr.div,
        mod: lr
      }) : Ae.length > this.length || this.cmp(Ae) < 0 ? {
        div: new Me(0),
        mod: this
      } : Ae.length === 1 ? ze === "div" ? {
        div: this.divn(Ae.words[0]),
        mod: null
      } : ze === "mod" ? {
        div: null,
        mod: new Me(this.modn(Ae.words[0]))
      } : {
        div: this.divn(Ae.words[0]),
        mod: new Me(this.modn(Ae.words[0]))
      } : this._wordDiv(Ae, ze);
    }, Me.prototype.div = function(Ae) {
      return this.divmod(Ae, "div", !1).div;
    }, Me.prototype.mod = function(Ae) {
      return this.divmod(Ae, "mod", !1).mod;
    }, Me.prototype.umod = function(Ae) {
      return this.divmod(Ae, "mod", !0).mod;
    }, Me.prototype.divRound = function(Ae) {
      var ze = this.divmod(Ae);
      if (ze.mod.isZero())
        return ze.div;
      var Ue = ze.div.negative !== 0 ? ze.mod.isub(Ae) : ze.mod, tr = Ae.ushrn(1), lr = Ae.andln(1), pr = Ue.cmp(tr);
      return pr < 0 || lr === 1 && pr === 0 ? ze.div : ze.div.negative !== 0 ? ze.div.isubn(1) : ze.div.iaddn(1);
    }, Me.prototype.modn = function(Ae) {
      we(Ae <= 67108863);
      for (var ze = (1 << 26) % Ae, Ue = 0, tr = this.length - 1; tr >= 0; tr--)
        Ue = (ze * Ue + (this.words[tr] | 0)) % Ae;
      return Ue;
    }, Me.prototype.idivn = function(Ae) {
      we(Ae <= 67108863);
      for (var ze = 0, Ue = this.length - 1; Ue >= 0; Ue--) {
        var tr = (this.words[Ue] | 0) + ze * 67108864;
        this.words[Ue] = tr / Ae | 0, ze = tr % Ae;
      }
      return this.strip();
    }, Me.prototype.divn = function(Ae) {
      return this.clone().idivn(Ae);
    }, Me.prototype.egcd = function(Ae) {
      we(Ae.negative === 0), we(!Ae.isZero());
      var ze = this, Ue = Ae.clone();
      ze.negative !== 0 ? ze = ze.umod(Ae) : ze = ze.clone();
      for (var tr = new Me(1), lr = new Me(0), pr = new Me(0), br = new Me(1), nr = 0; ze.isEven() && Ue.isEven(); )
        ze.iushrn(1), Ue.iushrn(1), ++nr;
      for (var Pe = Ue.clone(), ur = ze.clone(); !ze.isZero(); ) {
        for (var Pr = 0, Hr = 1; (ze.words[0] & Hr) === 0 && Pr < 26; ++Pr, Hr <<= 1)
          ;
        if (Pr > 0)
          for (ze.iushrn(Pr); Pr-- > 0; )
            (tr.isOdd() || lr.isOdd()) && (tr.iadd(Pe), lr.isub(ur)), tr.iushrn(1), lr.iushrn(1);
        for (var vi = 0, Ti = 1; (Ue.words[0] & Ti) === 0 && vi < 26; ++vi, Ti <<= 1)
          ;
        if (vi > 0)
          for (Ue.iushrn(vi); vi-- > 0; )
            (pr.isOdd() || br.isOdd()) && (pr.iadd(Pe), br.isub(ur)), pr.iushrn(1), br.iushrn(1);
        ze.cmp(Ue) >= 0 ? (ze.isub(Ue), tr.isub(pr), lr.isub(br)) : (Ue.isub(ze), pr.isub(tr), br.isub(lr));
      }
      return {
        a: pr,
        b: br,
        gcd: Ue.iushln(nr)
      };
    }, Me.prototype._invmp = function(Ae) {
      we(Ae.negative === 0), we(!Ae.isZero());
      var ze = this, Ue = Ae.clone();
      ze.negative !== 0 ? ze = ze.umod(Ae) : ze = ze.clone();
      for (var tr = new Me(1), lr = new Me(0), pr = Ue.clone(); ze.cmpn(1) > 0 && Ue.cmpn(1) > 0; ) {
        for (var br = 0, nr = 1; (ze.words[0] & nr) === 0 && br < 26; ++br, nr <<= 1)
          ;
        if (br > 0)
          for (ze.iushrn(br); br-- > 0; )
            tr.isOdd() && tr.iadd(pr), tr.iushrn(1);
        for (var Pe = 0, ur = 1; (Ue.words[0] & ur) === 0 && Pe < 26; ++Pe, ur <<= 1)
          ;
        if (Pe > 0)
          for (Ue.iushrn(Pe); Pe-- > 0; )
            lr.isOdd() && lr.iadd(pr), lr.iushrn(1);
        ze.cmp(Ue) >= 0 ? (ze.isub(Ue), tr.isub(lr)) : (Ue.isub(ze), lr.isub(tr));
      }
      var Pr;
      return ze.cmpn(1) === 0 ? Pr = tr : Pr = lr, Pr.cmpn(0) < 0 && Pr.iadd(Ae), Pr;
    }, Me.prototype.gcd = function(Ae) {
      if (this.isZero())
        return Ae.abs();
      if (Ae.isZero())
        return this.abs();
      var ze = this.clone(), Ue = Ae.clone();
      ze.negative = 0, Ue.negative = 0;
      for (var tr = 0; ze.isEven() && Ue.isEven(); tr++)
        ze.iushrn(1), Ue.iushrn(1);
      do {
        for (; ze.isEven(); )
          ze.iushrn(1);
        for (; Ue.isEven(); )
          Ue.iushrn(1);
        var lr = ze.cmp(Ue);
        if (lr < 0) {
          var pr = ze;
          ze = Ue, Ue = pr;
        } else if (lr === 0 || Ue.cmpn(1) === 0)
          break;
        ze.isub(Ue);
      } while (!0);
      return Ue.iushln(tr);
    }, Me.prototype.invm = function(Ae) {
      return this.egcd(Ae).a.umod(Ae);
    }, Me.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, Me.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, Me.prototype.andln = function(Ae) {
      return this.words[0] & Ae;
    }, Me.prototype.bincn = function(Ae) {
      we(typeof Ae == "number");
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 1 << ze;
      if (this.length <= Ue)
        return this._expand(Ue + 1), this.words[Ue] |= tr, this;
      for (var lr = tr, pr = Ue; lr !== 0 && pr < this.length; pr++) {
        var br = this.words[pr] | 0;
        br += lr, lr = br >>> 26, br &= 67108863, this.words[pr] = br;
      }
      return lr !== 0 && (this.words[pr] = lr, this.length++), this;
    }, Me.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, Me.prototype.cmpn = function(Ae) {
      var ze = Ae < 0;
      if (this.negative !== 0 && !ze)
        return -1;
      if (this.negative === 0 && ze)
        return 1;
      this.strip();
      var Ue;
      if (this.length > 1)
        Ue = 1;
      else {
        ze && (Ae = -Ae), we(Ae <= 67108863, "Number is too big");
        var tr = this.words[0] | 0;
        Ue = tr === Ae ? 0 : tr < Ae ? -1 : 1;
      }
      return this.negative !== 0 ? -Ue | 0 : Ue;
    }, Me.prototype.cmp = function(Ae) {
      if (this.negative !== 0 && Ae.negative === 0)
        return -1;
      if (this.negative === 0 && Ae.negative !== 0)
        return 1;
      var ze = this.ucmp(Ae);
      return this.negative !== 0 ? -ze | 0 : ze;
    }, Me.prototype.ucmp = function(Ae) {
      if (this.length > Ae.length)
        return 1;
      if (this.length < Ae.length)
        return -1;
      for (var ze = 0, Ue = this.length - 1; Ue >= 0; Ue--) {
        var tr = this.words[Ue] | 0, lr = Ae.words[Ue] | 0;
        if (tr !== lr) {
          tr < lr ? ze = -1 : tr > lr && (ze = 1);
          break;
        }
      }
      return ze;
    }, Me.prototype.gtn = function(Ae) {
      return this.cmpn(Ae) === 1;
    }, Me.prototype.gt = function(Ae) {
      return this.cmp(Ae) === 1;
    }, Me.prototype.gten = function(Ae) {
      return this.cmpn(Ae) >= 0;
    }, Me.prototype.gte = function(Ae) {
      return this.cmp(Ae) >= 0;
    }, Me.prototype.ltn = function(Ae) {
      return this.cmpn(Ae) === -1;
    }, Me.prototype.lt = function(Ae) {
      return this.cmp(Ae) === -1;
    }, Me.prototype.lten = function(Ae) {
      return this.cmpn(Ae) <= 0;
    }, Me.prototype.lte = function(Ae) {
      return this.cmp(Ae) <= 0;
    }, Me.prototype.eqn = function(Ae) {
      return this.cmpn(Ae) === 0;
    }, Me.prototype.eq = function(Ae) {
      return this.cmp(Ae) === 0;
    }, Me.red = function(Ae) {
      return new oi(Ae);
    }, Me.prototype.toRed = function(Ae) {
      return we(!this.red, "Already a number in reduction context"), we(this.negative === 0, "red works only with positives"), Ae.convertTo(this)._forceRed(Ae);
    }, Me.prototype.fromRed = function() {
      return we(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, Me.prototype._forceRed = function(Ae) {
      return this.red = Ae, this;
    }, Me.prototype.forceRed = function(Ae) {
      return we(!this.red, "Already a number in reduction context"), this._forceRed(Ae);
    }, Me.prototype.redAdd = function(Ae) {
      return we(this.red, "redAdd works only with red numbers"), this.red.add(this, Ae);
    }, Me.prototype.redIAdd = function(Ae) {
      return we(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ae);
    }, Me.prototype.redSub = function(Ae) {
      return we(this.red, "redSub works only with red numbers"), this.red.sub(this, Ae);
    }, Me.prototype.redISub = function(Ae) {
      return we(this.red, "redISub works only with red numbers"), this.red.isub(this, Ae);
    }, Me.prototype.redShl = function(Ae) {
      return we(this.red, "redShl works only with red numbers"), this.red.shl(this, Ae);
    }, Me.prototype.redMul = function(Ae) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ae), this.red.mul(this, Ae);
    }, Me.prototype.redIMul = function(Ae) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ae), this.red.imul(this, Ae);
    }, Me.prototype.redSqr = function() {
      return we(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, Me.prototype.redISqr = function() {
      return we(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, Me.prototype.redSqrt = function() {
      return we(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, Me.prototype.redInvm = function() {
      return we(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, Me.prototype.redNeg = function() {
      return we(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, Me.prototype.redPow = function(Ae) {
      return we(this.red && !Ae.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ae);
    };
    var Xr = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Wr(vr, Ae) {
      this.name = vr, this.p = new Me(Ae, 16), this.n = this.p.bitLength(), this.k = new Me(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Wr.prototype._tmp = function() {
      var Ae = new Me(null);
      return Ae.words = new Array(Math.ceil(this.n / 13)), Ae;
    }, Wr.prototype.ireduce = function(Ae) {
      var ze = Ae, Ue;
      do
        this.split(ze, this.tmp), ze = this.imulK(ze), ze = ze.iadd(this.tmp), Ue = ze.bitLength();
      while (Ue > this.n);
      var tr = Ue < this.n ? -1 : ze.ucmp(this.p);
      return tr === 0 ? (ze.words[0] = 0, ze.length = 1) : tr > 0 ? ze.isub(this.p) : ze.strip !== void 0 ? ze.strip() : ze._strip(), ze;
    }, Wr.prototype.split = function(Ae, ze) {
      Ae.iushrn(this.n, 0, ze);
    }, Wr.prototype.imulK = function(Ae) {
      return Ae.imul(this.k);
    };
    function si() {
      Wr.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    $e(si, Wr), si.prototype.split = function(Ae, ze) {
      for (var Ue = 4194303, tr = Math.min(Ae.length, 9), lr = 0; lr < tr; lr++)
        ze.words[lr] = Ae.words[lr];
      if (ze.length = tr, Ae.length <= 9) {
        Ae.words[0] = 0, Ae.length = 1;
        return;
      }
      var pr = Ae.words[9];
      for (ze.words[ze.length++] = pr & Ue, lr = 10; lr < Ae.length; lr++) {
        var br = Ae.words[lr] | 0;
        Ae.words[lr - 10] = (br & Ue) << 4 | pr >>> 22, pr = br;
      }
      pr >>>= 22, Ae.words[lr - 10] = pr, pr === 0 && Ae.length > 10 ? Ae.length -= 10 : Ae.length -= 9;
    }, si.prototype.imulK = function(Ae) {
      Ae.words[Ae.length] = 0, Ae.words[Ae.length + 1] = 0, Ae.length += 2;
      for (var ze = 0, Ue = 0; Ue < Ae.length; Ue++) {
        var tr = Ae.words[Ue] | 0;
        ze += tr * 977, Ae.words[Ue] = ze & 67108863, ze = tr * 64 + (ze / 67108864 | 0);
      }
      return Ae.words[Ae.length - 1] === 0 && (Ae.length--, Ae.words[Ae.length - 1] === 0 && Ae.length--), Ae;
    };
    function li() {
      Wr.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    $e(li, Wr);
    function xi() {
      Wr.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    $e(xi, Wr);
    function di() {
      Wr.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    $e(di, Wr), di.prototype.imulK = function(Ae) {
      for (var ze = 0, Ue = 0; Ue < Ae.length; Ue++) {
        var tr = (Ae.words[Ue] | 0) * 19 + ze, lr = tr & 67108863;
        tr >>>= 26, Ae.words[Ue] = lr, ze = tr;
      }
      return ze !== 0 && (Ae.words[Ae.length++] = ze), Ae;
    }, Me._prime = function(Ae) {
      if (Xr[Ae])
        return Xr[Ae];
      var ze;
      if (Ae === "k256")
        ze = new si();
      else if (Ae === "p224")
        ze = new li();
      else if (Ae === "p192")
        ze = new xi();
      else if (Ae === "p25519")
        ze = new di();
      else
        throw new Error("Unknown prime " + Ae);
      return Xr[Ae] = ze, ze;
    };
    function oi(vr) {
      if (typeof vr == "string") {
        var Ae = Me._prime(vr);
        this.m = Ae.p, this.prime = Ae;
      } else
        we(vr.gtn(1), "modulus must be greater than 1"), this.m = vr, this.prime = null;
    }
    oi.prototype._verify1 = function(Ae) {
      we(Ae.negative === 0, "red works only with positives"), we(Ae.red, "red works only with red numbers");
    }, oi.prototype._verify2 = function(Ae, ze) {
      we((Ae.negative | ze.negative) === 0, "red works only with positives"), we(
        Ae.red && Ae.red === ze.red,
        "red works only with red numbers"
      );
    }, oi.prototype.imod = function(Ae) {
      return this.prime ? this.prime.ireduce(Ae)._forceRed(this) : Ae.umod(this.m)._forceRed(this);
    }, oi.prototype.neg = function(Ae) {
      return Ae.isZero() ? Ae.clone() : this.m.sub(Ae)._forceRed(this);
    }, oi.prototype.add = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.add(ze);
      return Ue.cmp(this.m) >= 0 && Ue.isub(this.m), Ue._forceRed(this);
    }, oi.prototype.iadd = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.iadd(ze);
      return Ue.cmp(this.m) >= 0 && Ue.isub(this.m), Ue;
    }, oi.prototype.sub = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.sub(ze);
      return Ue.cmpn(0) < 0 && Ue.iadd(this.m), Ue._forceRed(this);
    }, oi.prototype.isub = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.isub(ze);
      return Ue.cmpn(0) < 0 && Ue.iadd(this.m), Ue;
    }, oi.prototype.shl = function(Ae, ze) {
      return this._verify1(Ae), this.imod(Ae.ushln(ze));
    }, oi.prototype.imul = function(Ae, ze) {
      return this._verify2(Ae, ze), this.imod(Ae.imul(ze));
    }, oi.prototype.mul = function(Ae, ze) {
      return this._verify2(Ae, ze), this.imod(Ae.mul(ze));
    }, oi.prototype.isqr = function(Ae) {
      return this.imul(Ae, Ae.clone());
    }, oi.prototype.sqr = function(Ae) {
      return this.mul(Ae, Ae);
    }, oi.prototype.sqrt = function(Ae) {
      if (Ae.isZero())
        return Ae.clone();
      var ze = this.m.andln(3);
      if (we(ze % 2 === 1), ze === 3) {
        var Ue = this.m.add(new Me(1)).iushrn(2);
        return this.pow(Ae, Ue);
      }
      for (var tr = this.m.subn(1), lr = 0; !tr.isZero() && tr.andln(1) === 0; )
        lr++, tr.iushrn(1);
      we(!tr.isZero());
      var pr = new Me(1).toRed(this), br = pr.redNeg(), nr = this.m.subn(1).iushrn(1), Pe = this.m.bitLength();
      for (Pe = new Me(2 * Pe * Pe).toRed(this); this.pow(Pe, nr).cmp(br) !== 0; )
        Pe.redIAdd(br);
      for (var ur = this.pow(Pe, tr), Pr = this.pow(Ae, tr.addn(1).iushrn(1)), Hr = this.pow(Ae, tr), vi = lr; Hr.cmp(pr) !== 0; ) {
        for (var Ti = Hr, wi = 0; Ti.cmp(pr) !== 0; wi++)
          Ti = Ti.redSqr();
        we(wi < vi);
        var ii = this.pow(ur, new Me(1).iushln(vi - wi - 1));
        Pr = Pr.redMul(ii), ur = ii.redSqr(), Hr = Hr.redMul(ur), vi = wi;
      }
      return Pr;
    }, oi.prototype.invm = function(Ae) {
      var ze = Ae._invmp(this.m);
      return ze.negative !== 0 ? (ze.negative = 0, this.imod(ze).redNeg()) : this.imod(ze);
    }, oi.prototype.pow = function(Ae, ze) {
      if (ze.isZero())
        return new Me(1).toRed(this);
      if (ze.cmpn(1) === 0)
        return Ae.clone();
      var Ue = 4, tr = new Array(1 << Ue);
      tr[0] = new Me(1).toRed(this), tr[1] = Ae;
      for (var lr = 2; lr < tr.length; lr++)
        tr[lr] = this.mul(tr[lr - 1], Ae);
      var pr = tr[0], br = 0, nr = 0, Pe = ze.bitLength() % 26;
      for (Pe === 0 && (Pe = 26), lr = ze.length - 1; lr >= 0; lr--) {
        for (var ur = ze.words[lr], Pr = Pe - 1; Pr >= 0; Pr--) {
          var Hr = ur >> Pr & 1;
          if (pr !== tr[0] && (pr = this.sqr(pr)), Hr === 0 && br === 0) {
            nr = 0;
            continue;
          }
          br <<= 1, br |= Hr, nr++, !(nr !== Ue && (lr !== 0 || Pr !== 0)) && (pr = this.mul(pr, tr[br]), nr = 0, br = 0);
        }
        Pe = 26;
      }
      return pr;
    }, oi.prototype.convertTo = function(Ae) {
      var ze = Ae.umod(this.m);
      return ze === Ae ? ze.clone() : ze;
    }, oi.prototype.convertFrom = function(Ae) {
      var ze = Ae.clone();
      return ze.red = null, ze;
    }, Me.mont = function(Ae) {
      return new ci(Ae);
    };
    function ci(vr) {
      oi.call(this, vr), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new Me(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    $e(ci, oi), ci.prototype.convertTo = function(Ae) {
      return this.imod(Ae.ushln(this.shift));
    }, ci.prototype.convertFrom = function(Ae) {
      var ze = this.imod(Ae.mul(this.rinv));
      return ze.red = null, ze;
    }, ci.prototype.imul = function(Ae, ze) {
      if (Ae.isZero() || ze.isZero())
        return Ae.words[0] = 0, Ae.length = 1, Ae;
      var Ue = Ae.imul(ze), tr = Ue.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), lr = Ue.isub(tr).iushrn(this.shift), pr = lr;
      return lr.cmp(this.m) >= 0 ? pr = lr.isub(this.m) : lr.cmpn(0) < 0 && (pr = lr.iadd(this.m)), pr._forceRed(this);
    }, ci.prototype.mul = function(Ae, ze) {
      if (Ae.isZero() || ze.isZero())
        return new Me(0)._forceRed(this);
      var Ue = Ae.mul(ze), tr = Ue.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), lr = Ue.isub(tr).iushrn(this.shift), pr = lr;
      return lr.cmp(this.m) >= 0 ? pr = lr.isub(this.m) : lr.cmpn(0) < 0 && (pr = lr.iadd(this.m)), pr._forceRed(this);
    }, ci.prototype.invm = function(Ae) {
      var ze = this.imod(Ae._invmp(this.m).mul(this.r2));
      return ze._forceRed(this);
    };
  })(m, commonjsGlobal);
})(bn$1);
var browser$3, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser)
    return browser$3;
  hasRequiredBrowser = 1;
  var m = requireElliptic(), c = bn$1.exports;
  browser$3 = function(Ze) {
    return new we(Ze);
  };
  var ie = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  ie.p224 = ie.secp224r1, ie.p256 = ie.secp256r1 = ie.prime256v1, ie.p192 = ie.secp192r1 = ie.prime192v1, ie.p384 = ie.secp384r1, ie.p521 = ie.secp521r1;
  function we(Me) {
    this.curveType = ie[Me], this.curveType || (this.curveType = {
      name: Me
    }), this.curve = new m.ec(this.curveType.name), this.keys = void 0;
  }
  we.prototype.generateKeys = function(Me, Ze) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(Me, Ze);
  }, we.prototype.computeSecret = function(Me, Ze, ne) {
    Ze = Ze || "utf8", Buffer$C.isBuffer(Me) || (Me = new Buffer$C(Me, Ze));
    var rr = this.curve.keyFromPublic(Me).getPublic(), gr = rr.mul(this.keys.getPrivate()).getX();
    return $e(gr, ne, this.curveType.byteLength);
  }, we.prototype.getPublicKey = function(Me, Ze) {
    var ne = this.keys.getPublic(Ze === "compressed", !0);
    return Ze === "hybrid" && (ne[ne.length - 1] % 2 ? ne[0] = 7 : ne[0] = 6), $e(ne, Me);
  }, we.prototype.getPrivateKey = function(Me) {
    return $e(this.keys.getPrivate(), Me);
  }, we.prototype.setPublicKey = function(Me, Ze) {
    return Ze = Ze || "utf8", Buffer$C.isBuffer(Me) || (Me = new Buffer$C(Me, Ze)), this.keys._importPublic(Me), this;
  }, we.prototype.setPrivateKey = function(Me, Ze) {
    Ze = Ze || "utf8", Buffer$C.isBuffer(Me) || (Me = new Buffer$C(Me, Ze));
    var ne = new c(Me);
    return ne = ne.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(ne), this;
  };
  function $e(Me, Ze, ne) {
    Array.isArray(Me) || (Me = Me.toArray());
    var rr = new Buffer$C(Me);
    if (ne && rr.length < ne) {
      var gr = new Buffer$C(ne - rr.length);
      gr.fill(0), rr = Buffer$C.concat([gr, rr]);
    }
    return Ze ? rr.toString(Ze) : rr;
  }
  return browser$3;
}
var browser$2 = {}, createHash$2 = browser$a, Buffer$4 = safeBuffer$2.exports.Buffer, mgf$2 = function(m, c) {
  for (var ie = Buffer$4.alloc(0), we = 0, $e; ie.length < c; )
    $e = i2ops(we++), ie = Buffer$4.concat([ie, createHash$2("sha1").update(m).update($e).digest()]);
  return ie.slice(0, c);
};
function i2ops(m) {
  var c = Buffer$4.allocUnsafe(4);
  return c.writeUInt32BE(m, 0), c;
}
var xor$2 = function m(c, ie) {
  for (var we = c.length, $e = -1; ++$e < we; )
    c[$e] ^= ie[$e];
  return c;
}, bn = { exports: {} };
(function(m) {
  (function(c, ie) {
    function we(vr, Ae) {
      if (!vr)
        throw new Error(Ae || "Assertion failed");
    }
    function $e(vr, Ae) {
      vr.super_ = Ae;
      var ze = function() {
      };
      ze.prototype = Ae.prototype, vr.prototype = new ze(), vr.prototype.constructor = vr;
    }
    function Me(vr, Ae, ze) {
      if (Me.isBN(vr))
        return vr;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, vr !== null && ((Ae === "le" || Ae === "be") && (ze = Ae, Ae = 10), this._init(vr || 0, Ae || 10, ze || "be"));
    }
    typeof c == "object" ? c.exports = Me : ie.BN = Me, Me.BN = Me, Me.wordSize = 26;
    var Ze;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? Ze = window.Buffer : Ze = require$$0$4.Buffer;
    } catch {
    }
    Me.isBN = function(Ae) {
      return Ae instanceof Me ? !0 : Ae !== null && typeof Ae == "object" && Ae.constructor.wordSize === Me.wordSize && Array.isArray(Ae.words);
    }, Me.max = function(Ae, ze) {
      return Ae.cmp(ze) > 0 ? Ae : ze;
    }, Me.min = function(Ae, ze) {
      return Ae.cmp(ze) < 0 ? Ae : ze;
    }, Me.prototype._init = function(Ae, ze, Ue) {
      if (typeof Ae == "number")
        return this._initNumber(Ae, ze, Ue);
      if (typeof Ae == "object")
        return this._initArray(Ae, ze, Ue);
      ze === "hex" && (ze = 16), we(ze === (ze | 0) && ze >= 2 && ze <= 36), Ae = Ae.toString().replace(/\s+/g, "");
      var tr = 0;
      Ae[0] === "-" && (tr++, this.negative = 1), tr < Ae.length && (ze === 16 ? this._parseHex(Ae, tr, Ue) : (this._parseBase(Ae, ze, tr), Ue === "le" && this._initArray(this.toArray(), ze, Ue)));
    }, Me.prototype._initNumber = function(Ae, ze, Ue) {
      Ae < 0 && (this.negative = 1, Ae = -Ae), Ae < 67108864 ? (this.words = [Ae & 67108863], this.length = 1) : Ae < 4503599627370496 ? (this.words = [
        Ae & 67108863,
        Ae / 67108864 & 67108863
      ], this.length = 2) : (we(Ae < 9007199254740992), this.words = [
        Ae & 67108863,
        Ae / 67108864 & 67108863,
        1
      ], this.length = 3), Ue === "le" && this._initArray(this.toArray(), ze, Ue);
    }, Me.prototype._initArray = function(Ae, ze, Ue) {
      if (we(typeof Ae.length == "number"), Ae.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(Ae.length / 3), this.words = new Array(this.length);
      for (var tr = 0; tr < this.length; tr++)
        this.words[tr] = 0;
      var lr, pr, br = 0;
      if (Ue === "be")
        for (tr = Ae.length - 1, lr = 0; tr >= 0; tr -= 3)
          pr = Ae[tr] | Ae[tr - 1] << 8 | Ae[tr - 2] << 16, this.words[lr] |= pr << br & 67108863, this.words[lr + 1] = pr >>> 26 - br & 67108863, br += 24, br >= 26 && (br -= 26, lr++);
      else if (Ue === "le")
        for (tr = 0, lr = 0; tr < Ae.length; tr += 3)
          pr = Ae[tr] | Ae[tr + 1] << 8 | Ae[tr + 2] << 16, this.words[lr] |= pr << br & 67108863, this.words[lr + 1] = pr >>> 26 - br & 67108863, br += 24, br >= 26 && (br -= 26, lr++);
      return this.strip();
    };
    function ne(vr, Ae) {
      var ze = vr.charCodeAt(Ae);
      return ze >= 65 && ze <= 70 ? ze - 55 : ze >= 97 && ze <= 102 ? ze - 87 : ze - 48 & 15;
    }
    function rr(vr, Ae, ze) {
      var Ue = ne(vr, ze);
      return ze - 1 >= Ae && (Ue |= ne(vr, ze - 1) << 4), Ue;
    }
    Me.prototype._parseHex = function(Ae, ze, Ue) {
      this.length = Math.ceil((Ae.length - ze) / 6), this.words = new Array(this.length);
      for (var tr = 0; tr < this.length; tr++)
        this.words[tr] = 0;
      var lr = 0, pr = 0, br;
      if (Ue === "be")
        for (tr = Ae.length - 1; tr >= ze; tr -= 2)
          br = rr(Ae, ze, tr) << lr, this.words[pr] |= br & 67108863, lr >= 18 ? (lr -= 18, pr += 1, this.words[pr] |= br >>> 26) : lr += 8;
      else {
        var nr = Ae.length - ze;
        for (tr = nr % 2 === 0 ? ze + 1 : ze; tr < Ae.length; tr += 2)
          br = rr(Ae, ze, tr) << lr, this.words[pr] |= br & 67108863, lr >= 18 ? (lr -= 18, pr += 1, this.words[pr] |= br >>> 26) : lr += 8;
      }
      this.strip();
    };
    function gr(vr, Ae, ze, Ue) {
      for (var tr = 0, lr = Math.min(vr.length, ze), pr = Ae; pr < lr; pr++) {
        var br = vr.charCodeAt(pr) - 48;
        tr *= Ue, br >= 49 ? tr += br - 49 + 10 : br >= 17 ? tr += br - 17 + 10 : tr += br;
      }
      return tr;
    }
    Me.prototype._parseBase = function(Ae, ze, Ue) {
      this.words = [0], this.length = 1;
      for (var tr = 0, lr = 1; lr <= 67108863; lr *= ze)
        tr++;
      tr--, lr = lr / ze | 0;
      for (var pr = Ae.length - Ue, br = pr % tr, nr = Math.min(pr, pr - br) + Ue, Pe = 0, ur = Ue; ur < nr; ur += tr)
        Pe = gr(Ae, ur, ur + tr, ze), this.imuln(lr), this.words[0] + Pe < 67108864 ? this.words[0] += Pe : this._iaddn(Pe);
      if (br !== 0) {
        var Pr = 1;
        for (Pe = gr(Ae, ur, Ae.length, ze), ur = 0; ur < br; ur++)
          Pr *= ze;
        this.imuln(Pr), this.words[0] + Pe < 67108864 ? this.words[0] += Pe : this._iaddn(Pe);
      }
      this.strip();
    }, Me.prototype.copy = function(Ae) {
      Ae.words = new Array(this.length);
      for (var ze = 0; ze < this.length; ze++)
        Ae.words[ze] = this.words[ze];
      Ae.length = this.length, Ae.negative = this.negative, Ae.red = this.red;
    }, Me.prototype.clone = function() {
      var Ae = new Me(null);
      return this.copy(Ae), Ae;
    }, Me.prototype._expand = function(Ae) {
      for (; this.length < Ae; )
        this.words[this.length++] = 0;
      return this;
    }, Me.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, Me.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, Me.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var or = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], _r = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Lr = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    Me.prototype.toString = function(Ae, ze) {
      Ae = Ae || 10, ze = ze | 0 || 1;
      var Ue;
      if (Ae === 16 || Ae === "hex") {
        Ue = "";
        for (var tr = 0, lr = 0, pr = 0; pr < this.length; pr++) {
          var br = this.words[pr], nr = ((br << tr | lr) & 16777215).toString(16);
          lr = br >>> 24 - tr & 16777215, tr += 2, tr >= 26 && (tr -= 26, pr--), lr !== 0 || pr !== this.length - 1 ? Ue = or[6 - nr.length] + nr + Ue : Ue = nr + Ue;
        }
        for (lr !== 0 && (Ue = lr.toString(16) + Ue); Ue.length % ze !== 0; )
          Ue = "0" + Ue;
        return this.negative !== 0 && (Ue = "-" + Ue), Ue;
      }
      if (Ae === (Ae | 0) && Ae >= 2 && Ae <= 36) {
        var Pe = _r[Ae], ur = Lr[Ae];
        Ue = "";
        var Pr = this.clone();
        for (Pr.negative = 0; !Pr.isZero(); ) {
          var Hr = Pr.modn(ur).toString(Ae);
          Pr = Pr.idivn(ur), Pr.isZero() ? Ue = Hr + Ue : Ue = or[Pe - Hr.length] + Hr + Ue;
        }
        for (this.isZero() && (Ue = "0" + Ue); Ue.length % ze !== 0; )
          Ue = "0" + Ue;
        return this.negative !== 0 && (Ue = "-" + Ue), Ue;
      }
      we(!1, "Base should be between 2 and 36");
    }, Me.prototype.toNumber = function() {
      var Ae = this.words[0];
      return this.length === 2 ? Ae += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ae += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && we(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ae : Ae;
    }, Me.prototype.toJSON = function() {
      return this.toString(16);
    }, Me.prototype.toBuffer = function(Ae, ze) {
      return we(typeof Ze < "u"), this.toArrayLike(Ze, Ae, ze);
    }, Me.prototype.toArray = function(Ae, ze) {
      return this.toArrayLike(Array, Ae, ze);
    }, Me.prototype.toArrayLike = function(Ae, ze, Ue) {
      var tr = this.byteLength(), lr = Ue || Math.max(1, tr);
      we(tr <= lr, "byte array longer than desired length"), we(lr > 0, "Requested array length <= 0"), this.strip();
      var pr = ze === "le", br = new Ae(lr), nr, Pe, ur = this.clone();
      if (pr) {
        for (Pe = 0; !ur.isZero(); Pe++)
          nr = ur.andln(255), ur.iushrn(8), br[Pe] = nr;
        for (; Pe < lr; Pe++)
          br[Pe] = 0;
      } else {
        for (Pe = 0; Pe < lr - tr; Pe++)
          br[Pe] = 0;
        for (Pe = 0; !ur.isZero(); Pe++)
          nr = ur.andln(255), ur.iushrn(8), br[lr - Pe - 1] = nr;
      }
      return br;
    }, Math.clz32 ? Me.prototype._countBits = function(Ae) {
      return 32 - Math.clz32(Ae);
    } : Me.prototype._countBits = function(Ae) {
      var ze = Ae, Ue = 0;
      return ze >= 4096 && (Ue += 13, ze >>>= 13), ze >= 64 && (Ue += 7, ze >>>= 7), ze >= 8 && (Ue += 4, ze >>>= 4), ze >= 2 && (Ue += 2, ze >>>= 2), Ue + ze;
    }, Me.prototype._zeroBits = function(Ae) {
      if (Ae === 0)
        return 26;
      var ze = Ae, Ue = 0;
      return (ze & 8191) === 0 && (Ue += 13, ze >>>= 13), (ze & 127) === 0 && (Ue += 7, ze >>>= 7), (ze & 15) === 0 && (Ue += 4, ze >>>= 4), (ze & 3) === 0 && (Ue += 2, ze >>>= 2), (ze & 1) === 0 && Ue++, Ue;
    }, Me.prototype.bitLength = function() {
      var Ae = this.words[this.length - 1], ze = this._countBits(Ae);
      return (this.length - 1) * 26 + ze;
    };
    function Ir(vr) {
      for (var Ae = new Array(vr.bitLength()), ze = 0; ze < Ae.length; ze++) {
        var Ue = ze / 26 | 0, tr = ze % 26;
        Ae[ze] = (vr.words[Ue] & 1 << tr) >>> tr;
      }
      return Ae;
    }
    Me.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var Ae = 0, ze = 0; ze < this.length; ze++) {
        var Ue = this._zeroBits(this.words[ze]);
        if (Ae += Ue, Ue !== 26)
          break;
      }
      return Ae;
    }, Me.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, Me.prototype.toTwos = function(Ae) {
      return this.negative !== 0 ? this.abs().inotn(Ae).iaddn(1) : this.clone();
    }, Me.prototype.fromTwos = function(Ae) {
      return this.testn(Ae - 1) ? this.notn(Ae).iaddn(1).ineg() : this.clone();
    }, Me.prototype.isNeg = function() {
      return this.negative !== 0;
    }, Me.prototype.neg = function() {
      return this.clone().ineg();
    }, Me.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, Me.prototype.iuor = function(Ae) {
      for (; this.length < Ae.length; )
        this.words[this.length++] = 0;
      for (var ze = 0; ze < Ae.length; ze++)
        this.words[ze] = this.words[ze] | Ae.words[ze];
      return this.strip();
    }, Me.prototype.ior = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuor(Ae);
    }, Me.prototype.or = function(Ae) {
      return this.length > Ae.length ? this.clone().ior(Ae) : Ae.clone().ior(this);
    }, Me.prototype.uor = function(Ae) {
      return this.length > Ae.length ? this.clone().iuor(Ae) : Ae.clone().iuor(this);
    }, Me.prototype.iuand = function(Ae) {
      var ze;
      this.length > Ae.length ? ze = Ae : ze = this;
      for (var Ue = 0; Ue < ze.length; Ue++)
        this.words[Ue] = this.words[Ue] & Ae.words[Ue];
      return this.length = ze.length, this.strip();
    }, Me.prototype.iand = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuand(Ae);
    }, Me.prototype.and = function(Ae) {
      return this.length > Ae.length ? this.clone().iand(Ae) : Ae.clone().iand(this);
    }, Me.prototype.uand = function(Ae) {
      return this.length > Ae.length ? this.clone().iuand(Ae) : Ae.clone().iuand(this);
    }, Me.prototype.iuxor = function(Ae) {
      var ze, Ue;
      this.length > Ae.length ? (ze = this, Ue = Ae) : (ze = Ae, Ue = this);
      for (var tr = 0; tr < Ue.length; tr++)
        this.words[tr] = ze.words[tr] ^ Ue.words[tr];
      if (this !== ze)
        for (; tr < ze.length; tr++)
          this.words[tr] = ze.words[tr];
      return this.length = ze.length, this.strip();
    }, Me.prototype.ixor = function(Ae) {
      return we((this.negative | Ae.negative) === 0), this.iuxor(Ae);
    }, Me.prototype.xor = function(Ae) {
      return this.length > Ae.length ? this.clone().ixor(Ae) : Ae.clone().ixor(this);
    }, Me.prototype.uxor = function(Ae) {
      return this.length > Ae.length ? this.clone().iuxor(Ae) : Ae.clone().iuxor(this);
    }, Me.prototype.inotn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Math.ceil(Ae / 26) | 0, Ue = Ae % 26;
      this._expand(ze), Ue > 0 && ze--;
      for (var tr = 0; tr < ze; tr++)
        this.words[tr] = ~this.words[tr] & 67108863;
      return Ue > 0 && (this.words[tr] = ~this.words[tr] & 67108863 >> 26 - Ue), this.strip();
    }, Me.prototype.notn = function(Ae) {
      return this.clone().inotn(Ae);
    }, Me.prototype.setn = function(Ae, ze) {
      we(typeof Ae == "number" && Ae >= 0);
      var Ue = Ae / 26 | 0, tr = Ae % 26;
      return this._expand(Ue + 1), ze ? this.words[Ue] = this.words[Ue] | 1 << tr : this.words[Ue] = this.words[Ue] & ~(1 << tr), this.strip();
    }, Me.prototype.iadd = function(Ae) {
      var ze;
      if (this.negative !== 0 && Ae.negative === 0)
        return this.negative = 0, ze = this.isub(Ae), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && Ae.negative !== 0)
        return Ae.negative = 0, ze = this.isub(Ae), Ae.negative = 1, ze._normSign();
      var Ue, tr;
      this.length > Ae.length ? (Ue = this, tr = Ae) : (Ue = Ae, tr = this);
      for (var lr = 0, pr = 0; pr < tr.length; pr++)
        ze = (Ue.words[pr] | 0) + (tr.words[pr] | 0) + lr, this.words[pr] = ze & 67108863, lr = ze >>> 26;
      for (; lr !== 0 && pr < Ue.length; pr++)
        ze = (Ue.words[pr] | 0) + lr, this.words[pr] = ze & 67108863, lr = ze >>> 26;
      if (this.length = Ue.length, lr !== 0)
        this.words[this.length] = lr, this.length++;
      else if (Ue !== this)
        for (; pr < Ue.length; pr++)
          this.words[pr] = Ue.words[pr];
      return this;
    }, Me.prototype.add = function(Ae) {
      var ze;
      return Ae.negative !== 0 && this.negative === 0 ? (Ae.negative = 0, ze = this.sub(Ae), Ae.negative ^= 1, ze) : Ae.negative === 0 && this.negative !== 0 ? (this.negative = 0, ze = Ae.sub(this), this.negative = 1, ze) : this.length > Ae.length ? this.clone().iadd(Ae) : Ae.clone().iadd(this);
    }, Me.prototype.isub = function(Ae) {
      if (Ae.negative !== 0) {
        Ae.negative = 0;
        var ze = this.iadd(Ae);
        return Ae.negative = 1, ze._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(Ae), this.negative = 1, this._normSign();
      var Ue = this.cmp(Ae);
      if (Ue === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var tr, lr;
      Ue > 0 ? (tr = this, lr = Ae) : (tr = Ae, lr = this);
      for (var pr = 0, br = 0; br < lr.length; br++)
        ze = (tr.words[br] | 0) - (lr.words[br] | 0) + pr, pr = ze >> 26, this.words[br] = ze & 67108863;
      for (; pr !== 0 && br < tr.length; br++)
        ze = (tr.words[br] | 0) + pr, pr = ze >> 26, this.words[br] = ze & 67108863;
      if (pr === 0 && br < tr.length && tr !== this)
        for (; br < tr.length; br++)
          this.words[br] = tr.words[br];
      return this.length = Math.max(this.length, br), tr !== this && (this.negative = 1), this.strip();
    }, Me.prototype.sub = function(Ae) {
      return this.clone().isub(Ae);
    };
    function Ar(vr, Ae, ze) {
      ze.negative = Ae.negative ^ vr.negative;
      var Ue = vr.length + Ae.length | 0;
      ze.length = Ue, Ue = Ue - 1 | 0;
      var tr = vr.words[0] | 0, lr = Ae.words[0] | 0, pr = tr * lr, br = pr & 67108863, nr = pr / 67108864 | 0;
      ze.words[0] = br;
      for (var Pe = 1; Pe < Ue; Pe++) {
        for (var ur = nr >>> 26, Pr = nr & 67108863, Hr = Math.min(Pe, Ae.length - 1), vi = Math.max(0, Pe - vr.length + 1); vi <= Hr; vi++) {
          var Ti = Pe - vi | 0;
          tr = vr.words[Ti] | 0, lr = Ae.words[vi] | 0, pr = tr * lr + Pr, ur += pr / 67108864 | 0, Pr = pr & 67108863;
        }
        ze.words[Pe] = Pr | 0, nr = ur | 0;
      }
      return nr !== 0 ? ze.words[Pe] = nr | 0 : ze.length--, ze.strip();
    }
    var Rr = function(Ae, ze, Ue) {
      var tr = Ae.words, lr = ze.words, pr = Ue.words, br = 0, nr, Pe, ur, Pr = tr[0] | 0, Hr = Pr & 8191, vi = Pr >>> 13, Ti = tr[1] | 0, wi = Ti & 8191, ii = Ti >>> 13, mi = tr[2] | 0, ei = mi & 8191, Zr = mi >>> 13, pi = tr[3] | 0, hi = pi & 8191, Oi = pi >>> 13, qi = tr[4] | 0, yn = qi & 8191, sn = qi >>> 13, $n = tr[5] | 0, rn = $n & 8191, ji = $n >>> 13, Kn = tr[6] | 0, In = Kn & 8191, Fn = Kn >>> 13, Po = tr[7] | 0, vn = Po & 8191, Vn = Po >>> 13, Xo = tr[8] | 0, Xn = Xo & 8191, Yn = Xo >>> 13, Wo = tr[9] | 0, Ci = Wo & 8191, ri = Wo >>> 13, yi = lr[0] | 0, Li = yi & 8191, Yi = yi >>> 13, zn = lr[1] | 0, un = zn & 8191, Gn = zn >>> 13, Mn = lr[2] | 0, pn = Mn & 8191, Rn = Mn >>> 13, Io = lr[3] | 0, to = Io & 8191, no = Io >>> 13, ma = lr[4] | 0, Qn = ma & 8191, co = ma >>> 13, kn = lr[5] | 0, ai = kn & 8191, _i = kn >>> 13, Pi = lr[6] | 0, Ai = Pi & 8191, ki = Pi >>> 13, an = lr[7] | 0, Ui = an & 8191, Vi = an >>> 13, Sn = lr[8] | 0, Hi = Sn & 8191, en = Sn >>> 13, qn = lr[9] | 0, _n = qn & 8191, Tn = qn >>> 13;
      Ue.negative = Ae.negative ^ ze.negative, Ue.length = 19, nr = Math.imul(Hr, Li), Pe = Math.imul(Hr, Yi), Pe = Pe + Math.imul(vi, Li) | 0, ur = Math.imul(vi, Yi);
      var xo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (xo >>> 26) | 0, xo &= 67108863, nr = Math.imul(wi, Li), Pe = Math.imul(wi, Yi), Pe = Pe + Math.imul(ii, Li) | 0, ur = Math.imul(ii, Yi), nr = nr + Math.imul(Hr, un) | 0, Pe = Pe + Math.imul(Hr, Gn) | 0, Pe = Pe + Math.imul(vi, un) | 0, ur = ur + Math.imul(vi, Gn) | 0;
      var Co = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Co >>> 26) | 0, Co &= 67108863, nr = Math.imul(ei, Li), Pe = Math.imul(ei, Yi), Pe = Pe + Math.imul(Zr, Li) | 0, ur = Math.imul(Zr, Yi), nr = nr + Math.imul(wi, un) | 0, Pe = Pe + Math.imul(wi, Gn) | 0, Pe = Pe + Math.imul(ii, un) | 0, ur = ur + Math.imul(ii, Gn) | 0, nr = nr + Math.imul(Hr, pn) | 0, Pe = Pe + Math.imul(Hr, Rn) | 0, Pe = Pe + Math.imul(vi, pn) | 0, ur = ur + Math.imul(vi, Rn) | 0;
      var $o = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + ($o >>> 26) | 0, $o &= 67108863, nr = Math.imul(hi, Li), Pe = Math.imul(hi, Yi), Pe = Pe + Math.imul(Oi, Li) | 0, ur = Math.imul(Oi, Yi), nr = nr + Math.imul(ei, un) | 0, Pe = Pe + Math.imul(ei, Gn) | 0, Pe = Pe + Math.imul(Zr, un) | 0, ur = ur + Math.imul(Zr, Gn) | 0, nr = nr + Math.imul(wi, pn) | 0, Pe = Pe + Math.imul(wi, Rn) | 0, Pe = Pe + Math.imul(ii, pn) | 0, ur = ur + Math.imul(ii, Rn) | 0, nr = nr + Math.imul(Hr, to) | 0, Pe = Pe + Math.imul(Hr, no) | 0, Pe = Pe + Math.imul(vi, to) | 0, ur = ur + Math.imul(vi, no) | 0;
      var Bo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Bo >>> 26) | 0, Bo &= 67108863, nr = Math.imul(yn, Li), Pe = Math.imul(yn, Yi), Pe = Pe + Math.imul(sn, Li) | 0, ur = Math.imul(sn, Yi), nr = nr + Math.imul(hi, un) | 0, Pe = Pe + Math.imul(hi, Gn) | 0, Pe = Pe + Math.imul(Oi, un) | 0, ur = ur + Math.imul(Oi, Gn) | 0, nr = nr + Math.imul(ei, pn) | 0, Pe = Pe + Math.imul(ei, Rn) | 0, Pe = Pe + Math.imul(Zr, pn) | 0, ur = ur + Math.imul(Zr, Rn) | 0, nr = nr + Math.imul(wi, to) | 0, Pe = Pe + Math.imul(wi, no) | 0, Pe = Pe + Math.imul(ii, to) | 0, ur = ur + Math.imul(ii, no) | 0, nr = nr + Math.imul(Hr, Qn) | 0, Pe = Pe + Math.imul(Hr, co) | 0, Pe = Pe + Math.imul(vi, Qn) | 0, ur = ur + Math.imul(vi, co) | 0;
      var Qo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Qo >>> 26) | 0, Qo &= 67108863, nr = Math.imul(rn, Li), Pe = Math.imul(rn, Yi), Pe = Pe + Math.imul(ji, Li) | 0, ur = Math.imul(ji, Yi), nr = nr + Math.imul(yn, un) | 0, Pe = Pe + Math.imul(yn, Gn) | 0, Pe = Pe + Math.imul(sn, un) | 0, ur = ur + Math.imul(sn, Gn) | 0, nr = nr + Math.imul(hi, pn) | 0, Pe = Pe + Math.imul(hi, Rn) | 0, Pe = Pe + Math.imul(Oi, pn) | 0, ur = ur + Math.imul(Oi, Rn) | 0, nr = nr + Math.imul(ei, to) | 0, Pe = Pe + Math.imul(ei, no) | 0, Pe = Pe + Math.imul(Zr, to) | 0, ur = ur + Math.imul(Zr, no) | 0, nr = nr + Math.imul(wi, Qn) | 0, Pe = Pe + Math.imul(wi, co) | 0, Pe = Pe + Math.imul(ii, Qn) | 0, ur = ur + Math.imul(ii, co) | 0, nr = nr + Math.imul(Hr, ai) | 0, Pe = Pe + Math.imul(Hr, _i) | 0, Pe = Pe + Math.imul(vi, ai) | 0, ur = ur + Math.imul(vi, _i) | 0;
      var Go = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Go >>> 26) | 0, Go &= 67108863, nr = Math.imul(In, Li), Pe = Math.imul(In, Yi), Pe = Pe + Math.imul(Fn, Li) | 0, ur = Math.imul(Fn, Yi), nr = nr + Math.imul(rn, un) | 0, Pe = Pe + Math.imul(rn, Gn) | 0, Pe = Pe + Math.imul(ji, un) | 0, ur = ur + Math.imul(ji, Gn) | 0, nr = nr + Math.imul(yn, pn) | 0, Pe = Pe + Math.imul(yn, Rn) | 0, Pe = Pe + Math.imul(sn, pn) | 0, ur = ur + Math.imul(sn, Rn) | 0, nr = nr + Math.imul(hi, to) | 0, Pe = Pe + Math.imul(hi, no) | 0, Pe = Pe + Math.imul(Oi, to) | 0, ur = ur + Math.imul(Oi, no) | 0, nr = nr + Math.imul(ei, Qn) | 0, Pe = Pe + Math.imul(ei, co) | 0, Pe = Pe + Math.imul(Zr, Qn) | 0, ur = ur + Math.imul(Zr, co) | 0, nr = nr + Math.imul(wi, ai) | 0, Pe = Pe + Math.imul(wi, _i) | 0, Pe = Pe + Math.imul(ii, ai) | 0, ur = ur + Math.imul(ii, _i) | 0, nr = nr + Math.imul(Hr, Ai) | 0, Pe = Pe + Math.imul(Hr, ki) | 0, Pe = Pe + Math.imul(vi, Ai) | 0, ur = ur + Math.imul(vi, ki) | 0;
      var No = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, nr = Math.imul(vn, Li), Pe = Math.imul(vn, Yi), Pe = Pe + Math.imul(Vn, Li) | 0, ur = Math.imul(Vn, Yi), nr = nr + Math.imul(In, un) | 0, Pe = Pe + Math.imul(In, Gn) | 0, Pe = Pe + Math.imul(Fn, un) | 0, ur = ur + Math.imul(Fn, Gn) | 0, nr = nr + Math.imul(rn, pn) | 0, Pe = Pe + Math.imul(rn, Rn) | 0, Pe = Pe + Math.imul(ji, pn) | 0, ur = ur + Math.imul(ji, Rn) | 0, nr = nr + Math.imul(yn, to) | 0, Pe = Pe + Math.imul(yn, no) | 0, Pe = Pe + Math.imul(sn, to) | 0, ur = ur + Math.imul(sn, no) | 0, nr = nr + Math.imul(hi, Qn) | 0, Pe = Pe + Math.imul(hi, co) | 0, Pe = Pe + Math.imul(Oi, Qn) | 0, ur = ur + Math.imul(Oi, co) | 0, nr = nr + Math.imul(ei, ai) | 0, Pe = Pe + Math.imul(ei, _i) | 0, Pe = Pe + Math.imul(Zr, ai) | 0, ur = ur + Math.imul(Zr, _i) | 0, nr = nr + Math.imul(wi, Ai) | 0, Pe = Pe + Math.imul(wi, ki) | 0, Pe = Pe + Math.imul(ii, Ai) | 0, ur = ur + Math.imul(ii, ki) | 0, nr = nr + Math.imul(Hr, Ui) | 0, Pe = Pe + Math.imul(Hr, Vi) | 0, Pe = Pe + Math.imul(vi, Ui) | 0, ur = ur + Math.imul(vi, Vi) | 0;
      var Zo = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Zo >>> 26) | 0, Zo &= 67108863, nr = Math.imul(Xn, Li), Pe = Math.imul(Xn, Yi), Pe = Pe + Math.imul(Yn, Li) | 0, ur = Math.imul(Yn, Yi), nr = nr + Math.imul(vn, un) | 0, Pe = Pe + Math.imul(vn, Gn) | 0, Pe = Pe + Math.imul(Vn, un) | 0, ur = ur + Math.imul(Vn, Gn) | 0, nr = nr + Math.imul(In, pn) | 0, Pe = Pe + Math.imul(In, Rn) | 0, Pe = Pe + Math.imul(Fn, pn) | 0, ur = ur + Math.imul(Fn, Rn) | 0, nr = nr + Math.imul(rn, to) | 0, Pe = Pe + Math.imul(rn, no) | 0, Pe = Pe + Math.imul(ji, to) | 0, ur = ur + Math.imul(ji, no) | 0, nr = nr + Math.imul(yn, Qn) | 0, Pe = Pe + Math.imul(yn, co) | 0, Pe = Pe + Math.imul(sn, Qn) | 0, ur = ur + Math.imul(sn, co) | 0, nr = nr + Math.imul(hi, ai) | 0, Pe = Pe + Math.imul(hi, _i) | 0, Pe = Pe + Math.imul(Oi, ai) | 0, ur = ur + Math.imul(Oi, _i) | 0, nr = nr + Math.imul(ei, Ai) | 0, Pe = Pe + Math.imul(ei, ki) | 0, Pe = Pe + Math.imul(Zr, Ai) | 0, ur = ur + Math.imul(Zr, ki) | 0, nr = nr + Math.imul(wi, Ui) | 0, Pe = Pe + Math.imul(wi, Vi) | 0, Pe = Pe + Math.imul(ii, Ui) | 0, ur = ur + Math.imul(ii, Vi) | 0, nr = nr + Math.imul(Hr, Hi) | 0, Pe = Pe + Math.imul(Hr, en) | 0, Pe = Pe + Math.imul(vi, Hi) | 0, ur = ur + Math.imul(vi, en) | 0;
      var ea = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ea >>> 26) | 0, ea &= 67108863, nr = Math.imul(Ci, Li), Pe = Math.imul(Ci, Yi), Pe = Pe + Math.imul(ri, Li) | 0, ur = Math.imul(ri, Yi), nr = nr + Math.imul(Xn, un) | 0, Pe = Pe + Math.imul(Xn, Gn) | 0, Pe = Pe + Math.imul(Yn, un) | 0, ur = ur + Math.imul(Yn, Gn) | 0, nr = nr + Math.imul(vn, pn) | 0, Pe = Pe + Math.imul(vn, Rn) | 0, Pe = Pe + Math.imul(Vn, pn) | 0, ur = ur + Math.imul(Vn, Rn) | 0, nr = nr + Math.imul(In, to) | 0, Pe = Pe + Math.imul(In, no) | 0, Pe = Pe + Math.imul(Fn, to) | 0, ur = ur + Math.imul(Fn, no) | 0, nr = nr + Math.imul(rn, Qn) | 0, Pe = Pe + Math.imul(rn, co) | 0, Pe = Pe + Math.imul(ji, Qn) | 0, ur = ur + Math.imul(ji, co) | 0, nr = nr + Math.imul(yn, ai) | 0, Pe = Pe + Math.imul(yn, _i) | 0, Pe = Pe + Math.imul(sn, ai) | 0, ur = ur + Math.imul(sn, _i) | 0, nr = nr + Math.imul(hi, Ai) | 0, Pe = Pe + Math.imul(hi, ki) | 0, Pe = Pe + Math.imul(Oi, Ai) | 0, ur = ur + Math.imul(Oi, ki) | 0, nr = nr + Math.imul(ei, Ui) | 0, Pe = Pe + Math.imul(ei, Vi) | 0, Pe = Pe + Math.imul(Zr, Ui) | 0, ur = ur + Math.imul(Zr, Vi) | 0, nr = nr + Math.imul(wi, Hi) | 0, Pe = Pe + Math.imul(wi, en) | 0, Pe = Pe + Math.imul(ii, Hi) | 0, ur = ur + Math.imul(ii, en) | 0, nr = nr + Math.imul(Hr, _n) | 0, Pe = Pe + Math.imul(Hr, Tn) | 0, Pe = Pe + Math.imul(vi, _n) | 0, ur = ur + Math.imul(vi, Tn) | 0;
      var da = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (da >>> 26) | 0, da &= 67108863, nr = Math.imul(Ci, un), Pe = Math.imul(Ci, Gn), Pe = Pe + Math.imul(ri, un) | 0, ur = Math.imul(ri, Gn), nr = nr + Math.imul(Xn, pn) | 0, Pe = Pe + Math.imul(Xn, Rn) | 0, Pe = Pe + Math.imul(Yn, pn) | 0, ur = ur + Math.imul(Yn, Rn) | 0, nr = nr + Math.imul(vn, to) | 0, Pe = Pe + Math.imul(vn, no) | 0, Pe = Pe + Math.imul(Vn, to) | 0, ur = ur + Math.imul(Vn, no) | 0, nr = nr + Math.imul(In, Qn) | 0, Pe = Pe + Math.imul(In, co) | 0, Pe = Pe + Math.imul(Fn, Qn) | 0, ur = ur + Math.imul(Fn, co) | 0, nr = nr + Math.imul(rn, ai) | 0, Pe = Pe + Math.imul(rn, _i) | 0, Pe = Pe + Math.imul(ji, ai) | 0, ur = ur + Math.imul(ji, _i) | 0, nr = nr + Math.imul(yn, Ai) | 0, Pe = Pe + Math.imul(yn, ki) | 0, Pe = Pe + Math.imul(sn, Ai) | 0, ur = ur + Math.imul(sn, ki) | 0, nr = nr + Math.imul(hi, Ui) | 0, Pe = Pe + Math.imul(hi, Vi) | 0, Pe = Pe + Math.imul(Oi, Ui) | 0, ur = ur + Math.imul(Oi, Vi) | 0, nr = nr + Math.imul(ei, Hi) | 0, Pe = Pe + Math.imul(ei, en) | 0, Pe = Pe + Math.imul(Zr, Hi) | 0, ur = ur + Math.imul(Zr, en) | 0, nr = nr + Math.imul(wi, _n) | 0, Pe = Pe + Math.imul(wi, Tn) | 0, Pe = Pe + Math.imul(ii, _n) | 0, ur = ur + Math.imul(ii, Tn) | 0;
      var Ra = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ra >>> 26) | 0, Ra &= 67108863, nr = Math.imul(Ci, pn), Pe = Math.imul(Ci, Rn), Pe = Pe + Math.imul(ri, pn) | 0, ur = Math.imul(ri, Rn), nr = nr + Math.imul(Xn, to) | 0, Pe = Pe + Math.imul(Xn, no) | 0, Pe = Pe + Math.imul(Yn, to) | 0, ur = ur + Math.imul(Yn, no) | 0, nr = nr + Math.imul(vn, Qn) | 0, Pe = Pe + Math.imul(vn, co) | 0, Pe = Pe + Math.imul(Vn, Qn) | 0, ur = ur + Math.imul(Vn, co) | 0, nr = nr + Math.imul(In, ai) | 0, Pe = Pe + Math.imul(In, _i) | 0, Pe = Pe + Math.imul(Fn, ai) | 0, ur = ur + Math.imul(Fn, _i) | 0, nr = nr + Math.imul(rn, Ai) | 0, Pe = Pe + Math.imul(rn, ki) | 0, Pe = Pe + Math.imul(ji, Ai) | 0, ur = ur + Math.imul(ji, ki) | 0, nr = nr + Math.imul(yn, Ui) | 0, Pe = Pe + Math.imul(yn, Vi) | 0, Pe = Pe + Math.imul(sn, Ui) | 0, ur = ur + Math.imul(sn, Vi) | 0, nr = nr + Math.imul(hi, Hi) | 0, Pe = Pe + Math.imul(hi, en) | 0, Pe = Pe + Math.imul(Oi, Hi) | 0, ur = ur + Math.imul(Oi, en) | 0, nr = nr + Math.imul(ei, _n) | 0, Pe = Pe + Math.imul(ei, Tn) | 0, Pe = Pe + Math.imul(Zr, _n) | 0, ur = ur + Math.imul(Zr, Tn) | 0;
      var ba = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ba >>> 26) | 0, ba &= 67108863, nr = Math.imul(Ci, to), Pe = Math.imul(Ci, no), Pe = Pe + Math.imul(ri, to) | 0, ur = Math.imul(ri, no), nr = nr + Math.imul(Xn, Qn) | 0, Pe = Pe + Math.imul(Xn, co) | 0, Pe = Pe + Math.imul(Yn, Qn) | 0, ur = ur + Math.imul(Yn, co) | 0, nr = nr + Math.imul(vn, ai) | 0, Pe = Pe + Math.imul(vn, _i) | 0, Pe = Pe + Math.imul(Vn, ai) | 0, ur = ur + Math.imul(Vn, _i) | 0, nr = nr + Math.imul(In, Ai) | 0, Pe = Pe + Math.imul(In, ki) | 0, Pe = Pe + Math.imul(Fn, Ai) | 0, ur = ur + Math.imul(Fn, ki) | 0, nr = nr + Math.imul(rn, Ui) | 0, Pe = Pe + Math.imul(rn, Vi) | 0, Pe = Pe + Math.imul(ji, Ui) | 0, ur = ur + Math.imul(ji, Vi) | 0, nr = nr + Math.imul(yn, Hi) | 0, Pe = Pe + Math.imul(yn, en) | 0, Pe = Pe + Math.imul(sn, Hi) | 0, ur = ur + Math.imul(sn, en) | 0, nr = nr + Math.imul(hi, _n) | 0, Pe = Pe + Math.imul(hi, Tn) | 0, Pe = Pe + Math.imul(Oi, _n) | 0, ur = ur + Math.imul(Oi, Tn) | 0;
      var Ea = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ea >>> 26) | 0, Ea &= 67108863, nr = Math.imul(Ci, Qn), Pe = Math.imul(Ci, co), Pe = Pe + Math.imul(ri, Qn) | 0, ur = Math.imul(ri, co), nr = nr + Math.imul(Xn, ai) | 0, Pe = Pe + Math.imul(Xn, _i) | 0, Pe = Pe + Math.imul(Yn, ai) | 0, ur = ur + Math.imul(Yn, _i) | 0, nr = nr + Math.imul(vn, Ai) | 0, Pe = Pe + Math.imul(vn, ki) | 0, Pe = Pe + Math.imul(Vn, Ai) | 0, ur = ur + Math.imul(Vn, ki) | 0, nr = nr + Math.imul(In, Ui) | 0, Pe = Pe + Math.imul(In, Vi) | 0, Pe = Pe + Math.imul(Fn, Ui) | 0, ur = ur + Math.imul(Fn, Vi) | 0, nr = nr + Math.imul(rn, Hi) | 0, Pe = Pe + Math.imul(rn, en) | 0, Pe = Pe + Math.imul(ji, Hi) | 0, ur = ur + Math.imul(ji, en) | 0, nr = nr + Math.imul(yn, _n) | 0, Pe = Pe + Math.imul(yn, Tn) | 0, Pe = Pe + Math.imul(sn, _n) | 0, ur = ur + Math.imul(sn, Tn) | 0;
      var Ha = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Ha >>> 26) | 0, Ha &= 67108863, nr = Math.imul(Ci, ai), Pe = Math.imul(Ci, _i), Pe = Pe + Math.imul(ri, ai) | 0, ur = Math.imul(ri, _i), nr = nr + Math.imul(Xn, Ai) | 0, Pe = Pe + Math.imul(Xn, ki) | 0, Pe = Pe + Math.imul(Yn, Ai) | 0, ur = ur + Math.imul(Yn, ki) | 0, nr = nr + Math.imul(vn, Ui) | 0, Pe = Pe + Math.imul(vn, Vi) | 0, Pe = Pe + Math.imul(Vn, Ui) | 0, ur = ur + Math.imul(Vn, Vi) | 0, nr = nr + Math.imul(In, Hi) | 0, Pe = Pe + Math.imul(In, en) | 0, Pe = Pe + Math.imul(Fn, Hi) | 0, ur = ur + Math.imul(Fn, en) | 0, nr = nr + Math.imul(rn, _n) | 0, Pe = Pe + Math.imul(rn, Tn) | 0, Pe = Pe + Math.imul(ji, _n) | 0, ur = ur + Math.imul(ji, Tn) | 0;
      var Fa = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Fa >>> 26) | 0, Fa &= 67108863, nr = Math.imul(Ci, Ai), Pe = Math.imul(Ci, ki), Pe = Pe + Math.imul(ri, Ai) | 0, ur = Math.imul(ri, ki), nr = nr + Math.imul(Xn, Ui) | 0, Pe = Pe + Math.imul(Xn, Vi) | 0, Pe = Pe + Math.imul(Yn, Ui) | 0, ur = ur + Math.imul(Yn, Vi) | 0, nr = nr + Math.imul(vn, Hi) | 0, Pe = Pe + Math.imul(vn, en) | 0, Pe = Pe + Math.imul(Vn, Hi) | 0, ur = ur + Math.imul(Vn, en) | 0, nr = nr + Math.imul(In, _n) | 0, Pe = Pe + Math.imul(In, Tn) | 0, Pe = Pe + Math.imul(Fn, _n) | 0, ur = ur + Math.imul(Fn, Tn) | 0;
      var ls = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (ls >>> 26) | 0, ls &= 67108863, nr = Math.imul(Ci, Ui), Pe = Math.imul(Ci, Vi), Pe = Pe + Math.imul(ri, Ui) | 0, ur = Math.imul(ri, Vi), nr = nr + Math.imul(Xn, Hi) | 0, Pe = Pe + Math.imul(Xn, en) | 0, Pe = Pe + Math.imul(Yn, Hi) | 0, ur = ur + Math.imul(Yn, en) | 0, nr = nr + Math.imul(vn, _n) | 0, Pe = Pe + Math.imul(vn, Tn) | 0, Pe = Pe + Math.imul(Vn, _n) | 0, ur = ur + Math.imul(Vn, Tn) | 0;
      var us = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (us >>> 26) | 0, us &= 67108863, nr = Math.imul(Ci, Hi), Pe = Math.imul(Ci, en), Pe = Pe + Math.imul(ri, Hi) | 0, ur = Math.imul(ri, en), nr = nr + Math.imul(Xn, _n) | 0, Pe = Pe + Math.imul(Xn, Tn) | 0, Pe = Pe + Math.imul(Yn, _n) | 0, ur = ur + Math.imul(Yn, Tn) | 0;
      var Xa = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      br = (ur + (Pe >>> 13) | 0) + (Xa >>> 26) | 0, Xa &= 67108863, nr = Math.imul(Ci, _n), Pe = Math.imul(Ci, Tn), Pe = Pe + Math.imul(ri, _n) | 0, ur = Math.imul(ri, Tn);
      var hs = (br + nr | 0) + ((Pe & 8191) << 13) | 0;
      return br = (ur + (Pe >>> 13) | 0) + (hs >>> 26) | 0, hs &= 67108863, pr[0] = xo, pr[1] = Co, pr[2] = $o, pr[3] = Bo, pr[4] = Qo, pr[5] = Go, pr[6] = No, pr[7] = Zo, pr[8] = ea, pr[9] = da, pr[10] = Ra, pr[11] = ba, pr[12] = Ea, pr[13] = Ha, pr[14] = Fa, pr[15] = ls, pr[16] = us, pr[17] = Xa, pr[18] = hs, br !== 0 && (pr[19] = br, Ue.length++), Ue;
    };
    Math.imul || (Rr = Ar);
    function Nr(vr, Ae, ze) {
      ze.negative = Ae.negative ^ vr.negative, ze.length = vr.length + Ae.length;
      for (var Ue = 0, tr = 0, lr = 0; lr < ze.length - 1; lr++) {
        var pr = tr;
        tr = 0;
        for (var br = Ue & 67108863, nr = Math.min(lr, Ae.length - 1), Pe = Math.max(0, lr - vr.length + 1); Pe <= nr; Pe++) {
          var ur = lr - Pe, Pr = vr.words[ur] | 0, Hr = Ae.words[Pe] | 0, vi = Pr * Hr, Ti = vi & 67108863;
          pr = pr + (vi / 67108864 | 0) | 0, Ti = Ti + br | 0, br = Ti & 67108863, pr = pr + (Ti >>> 26) | 0, tr += pr >>> 26, pr &= 67108863;
        }
        ze.words[lr] = br, Ue = pr, pr = tr;
      }
      return Ue !== 0 ? ze.words[lr] = Ue : ze.length--, ze.strip();
    }
    function Yr(vr, Ae, ze) {
      var Ue = new Vr();
      return Ue.mulp(vr, Ae, ze);
    }
    Me.prototype.mulTo = function(Ae, ze) {
      var Ue, tr = this.length + Ae.length;
      return this.length === 10 && Ae.length === 10 ? Ue = Rr(this, Ae, ze) : tr < 63 ? Ue = Ar(this, Ae, ze) : tr < 1024 ? Ue = Nr(this, Ae, ze) : Ue = Yr(this, Ae, ze), Ue;
    };
    function Vr(vr, Ae) {
      this.x = vr, this.y = Ae;
    }
    Vr.prototype.makeRBT = function(Ae) {
      for (var ze = new Array(Ae), Ue = Me.prototype._countBits(Ae) - 1, tr = 0; tr < Ae; tr++)
        ze[tr] = this.revBin(tr, Ue, Ae);
      return ze;
    }, Vr.prototype.revBin = function(Ae, ze, Ue) {
      if (Ae === 0 || Ae === Ue - 1)
        return Ae;
      for (var tr = 0, lr = 0; lr < ze; lr++)
        tr |= (Ae & 1) << ze - lr - 1, Ae >>= 1;
      return tr;
    }, Vr.prototype.permute = function(Ae, ze, Ue, tr, lr, pr) {
      for (var br = 0; br < pr; br++)
        tr[br] = ze[Ae[br]], lr[br] = Ue[Ae[br]];
    }, Vr.prototype.transform = function(Ae, ze, Ue, tr, lr, pr) {
      this.permute(pr, Ae, ze, Ue, tr, lr);
      for (var br = 1; br < lr; br <<= 1)
        for (var nr = br << 1, Pe = Math.cos(2 * Math.PI / nr), ur = Math.sin(2 * Math.PI / nr), Pr = 0; Pr < lr; Pr += nr)
          for (var Hr = Pe, vi = ur, Ti = 0; Ti < br; Ti++) {
            var wi = Ue[Pr + Ti], ii = tr[Pr + Ti], mi = Ue[Pr + Ti + br], ei = tr[Pr + Ti + br], Zr = Hr * mi - vi * ei;
            ei = Hr * ei + vi * mi, mi = Zr, Ue[Pr + Ti] = wi + mi, tr[Pr + Ti] = ii + ei, Ue[Pr + Ti + br] = wi - mi, tr[Pr + Ti + br] = ii - ei, Ti !== nr && (Zr = Pe * Hr - ur * vi, vi = Pe * vi + ur * Hr, Hr = Zr);
          }
    }, Vr.prototype.guessLen13b = function(Ae, ze) {
      var Ue = Math.max(ze, Ae) | 1, tr = Ue & 1, lr = 0;
      for (Ue = Ue / 2 | 0; Ue; Ue = Ue >>> 1)
        lr++;
      return 1 << lr + 1 + tr;
    }, Vr.prototype.conjugate = function(Ae, ze, Ue) {
      if (!(Ue <= 1))
        for (var tr = 0; tr < Ue / 2; tr++) {
          var lr = Ae[tr];
          Ae[tr] = Ae[Ue - tr - 1], Ae[Ue - tr - 1] = lr, lr = ze[tr], ze[tr] = -ze[Ue - tr - 1], ze[Ue - tr - 1] = -lr;
        }
    }, Vr.prototype.normalize13b = function(Ae, ze) {
      for (var Ue = 0, tr = 0; tr < ze / 2; tr++) {
        var lr = Math.round(Ae[2 * tr + 1] / ze) * 8192 + Math.round(Ae[2 * tr] / ze) + Ue;
        Ae[tr] = lr & 67108863, lr < 67108864 ? Ue = 0 : Ue = lr / 67108864 | 0;
      }
      return Ae;
    }, Vr.prototype.convert13b = function(Ae, ze, Ue, tr) {
      for (var lr = 0, pr = 0; pr < ze; pr++)
        lr = lr + (Ae[pr] | 0), Ue[2 * pr] = lr & 8191, lr = lr >>> 13, Ue[2 * pr + 1] = lr & 8191, lr = lr >>> 13;
      for (pr = 2 * ze; pr < tr; ++pr)
        Ue[pr] = 0;
      we(lr === 0), we((lr & -8192) === 0);
    }, Vr.prototype.stub = function(Ae) {
      for (var ze = new Array(Ae), Ue = 0; Ue < Ae; Ue++)
        ze[Ue] = 0;
      return ze;
    }, Vr.prototype.mulp = function(Ae, ze, Ue) {
      var tr = 2 * this.guessLen13b(Ae.length, ze.length), lr = this.makeRBT(tr), pr = this.stub(tr), br = new Array(tr), nr = new Array(tr), Pe = new Array(tr), ur = new Array(tr), Pr = new Array(tr), Hr = new Array(tr), vi = Ue.words;
      vi.length = tr, this.convert13b(Ae.words, Ae.length, br, tr), this.convert13b(ze.words, ze.length, ur, tr), this.transform(br, pr, nr, Pe, tr, lr), this.transform(ur, pr, Pr, Hr, tr, lr);
      for (var Ti = 0; Ti < tr; Ti++) {
        var wi = nr[Ti] * Pr[Ti] - Pe[Ti] * Hr[Ti];
        Pe[Ti] = nr[Ti] * Hr[Ti] + Pe[Ti] * Pr[Ti], nr[Ti] = wi;
      }
      return this.conjugate(nr, Pe, tr), this.transform(nr, Pe, vi, pr, tr, lr), this.conjugate(vi, pr, tr), this.normalize13b(vi, tr), Ue.negative = Ae.negative ^ ze.negative, Ue.length = Ae.length + ze.length, Ue.strip();
    }, Me.prototype.mul = function(Ae) {
      var ze = new Me(null);
      return ze.words = new Array(this.length + Ae.length), this.mulTo(Ae, ze);
    }, Me.prototype.mulf = function(Ae) {
      var ze = new Me(null);
      return ze.words = new Array(this.length + Ae.length), Yr(this, Ae, ze);
    }, Me.prototype.imul = function(Ae) {
      return this.clone().mulTo(Ae, this);
    }, Me.prototype.imuln = function(Ae) {
      we(typeof Ae == "number"), we(Ae < 67108864);
      for (var ze = 0, Ue = 0; Ue < this.length; Ue++) {
        var tr = (this.words[Ue] | 0) * Ae, lr = (tr & 67108863) + (ze & 67108863);
        ze >>= 26, ze += tr / 67108864 | 0, ze += lr >>> 26, this.words[Ue] = lr & 67108863;
      }
      return ze !== 0 && (this.words[Ue] = ze, this.length++), this;
    }, Me.prototype.muln = function(Ae) {
      return this.clone().imuln(Ae);
    }, Me.prototype.sqr = function() {
      return this.mul(this);
    }, Me.prototype.isqr = function() {
      return this.imul(this.clone());
    }, Me.prototype.pow = function(Ae) {
      var ze = Ir(Ae);
      if (ze.length === 0)
        return new Me(1);
      for (var Ue = this, tr = 0; tr < ze.length && ze[tr] === 0; tr++, Ue = Ue.sqr())
        ;
      if (++tr < ze.length)
        for (var lr = Ue.sqr(); tr < ze.length; tr++, lr = lr.sqr())
          ze[tr] !== 0 && (Ue = Ue.mul(lr));
      return Ue;
    }, Me.prototype.iushln = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 67108863 >>> 26 - ze << 26 - ze, lr;
      if (ze !== 0) {
        var pr = 0;
        for (lr = 0; lr < this.length; lr++) {
          var br = this.words[lr] & tr, nr = (this.words[lr] | 0) - br << ze;
          this.words[lr] = nr | pr, pr = br >>> 26 - ze;
        }
        pr && (this.words[lr] = pr, this.length++);
      }
      if (Ue !== 0) {
        for (lr = this.length - 1; lr >= 0; lr--)
          this.words[lr + Ue] = this.words[lr];
        for (lr = 0; lr < Ue; lr++)
          this.words[lr] = 0;
        this.length += Ue;
      }
      return this.strip();
    }, Me.prototype.ishln = function(Ae) {
      return we(this.negative === 0), this.iushln(Ae);
    }, Me.prototype.iushrn = function(Ae, ze, Ue) {
      we(typeof Ae == "number" && Ae >= 0);
      var tr;
      ze ? tr = (ze - ze % 26) / 26 : tr = 0;
      var lr = Ae % 26, pr = Math.min((Ae - lr) / 26, this.length), br = 67108863 ^ 67108863 >>> lr << lr, nr = Ue;
      if (tr -= pr, tr = Math.max(0, tr), nr) {
        for (var Pe = 0; Pe < pr; Pe++)
          nr.words[Pe] = this.words[Pe];
        nr.length = pr;
      }
      if (pr !== 0)
        if (this.length > pr)
          for (this.length -= pr, Pe = 0; Pe < this.length; Pe++)
            this.words[Pe] = this.words[Pe + pr];
        else
          this.words[0] = 0, this.length = 1;
      var ur = 0;
      for (Pe = this.length - 1; Pe >= 0 && (ur !== 0 || Pe >= tr); Pe--) {
        var Pr = this.words[Pe] | 0;
        this.words[Pe] = ur << 26 - lr | Pr >>> lr, ur = Pr & br;
      }
      return nr && ur !== 0 && (nr.words[nr.length++] = ur), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, Me.prototype.ishrn = function(Ae, ze, Ue) {
      return we(this.negative === 0), this.iushrn(Ae, ze, Ue);
    }, Me.prototype.shln = function(Ae) {
      return this.clone().ishln(Ae);
    }, Me.prototype.ushln = function(Ae) {
      return this.clone().iushln(Ae);
    }, Me.prototype.shrn = function(Ae) {
      return this.clone().ishrn(Ae);
    }, Me.prototype.ushrn = function(Ae) {
      return this.clone().iushrn(Ae);
    }, Me.prototype.testn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 1 << ze;
      if (this.length <= Ue)
        return !1;
      var lr = this.words[Ue];
      return !!(lr & tr);
    }, Me.prototype.imaskn = function(Ae) {
      we(typeof Ae == "number" && Ae >= 0);
      var ze = Ae % 26, Ue = (Ae - ze) / 26;
      if (we(this.negative === 0, "imaskn works only with positive numbers"), this.length <= Ue)
        return this;
      if (ze !== 0 && Ue++, this.length = Math.min(Ue, this.length), ze !== 0) {
        var tr = 67108863 ^ 67108863 >>> ze << ze;
        this.words[this.length - 1] &= tr;
      }
      return this.strip();
    }, Me.prototype.maskn = function(Ae) {
      return this.clone().imaskn(Ae);
    }, Me.prototype.iaddn = function(Ae) {
      return we(typeof Ae == "number"), we(Ae < 67108864), Ae < 0 ? this.isubn(-Ae) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Ae ? (this.words[0] = Ae - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ae), this.negative = 1, this) : this._iaddn(Ae);
    }, Me.prototype._iaddn = function(Ae) {
      this.words[0] += Ae;
      for (var ze = 0; ze < this.length && this.words[ze] >= 67108864; ze++)
        this.words[ze] -= 67108864, ze === this.length - 1 ? this.words[ze + 1] = 1 : this.words[ze + 1]++;
      return this.length = Math.max(this.length, ze + 1), this;
    }, Me.prototype.isubn = function(Ae) {
      if (we(typeof Ae == "number"), we(Ae < 67108864), Ae < 0)
        return this.iaddn(-Ae);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(Ae), this.negative = 1, this;
      if (this.words[0] -= Ae, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var ze = 0; ze < this.length && this.words[ze] < 0; ze++)
          this.words[ze] += 67108864, this.words[ze + 1] -= 1;
      return this.strip();
    }, Me.prototype.addn = function(Ae) {
      return this.clone().iaddn(Ae);
    }, Me.prototype.subn = function(Ae) {
      return this.clone().isubn(Ae);
    }, Me.prototype.iabs = function() {
      return this.negative = 0, this;
    }, Me.prototype.abs = function() {
      return this.clone().iabs();
    }, Me.prototype._ishlnsubmul = function(Ae, ze, Ue) {
      var tr = Ae.length + Ue, lr;
      this._expand(tr);
      var pr, br = 0;
      for (lr = 0; lr < Ae.length; lr++) {
        pr = (this.words[lr + Ue] | 0) + br;
        var nr = (Ae.words[lr] | 0) * ze;
        pr -= nr & 67108863, br = (pr >> 26) - (nr / 67108864 | 0), this.words[lr + Ue] = pr & 67108863;
      }
      for (; lr < this.length - Ue; lr++)
        pr = (this.words[lr + Ue] | 0) + br, br = pr >> 26, this.words[lr + Ue] = pr & 67108863;
      if (br === 0)
        return this.strip();
      for (we(br === -1), br = 0, lr = 0; lr < this.length; lr++)
        pr = -(this.words[lr] | 0) + br, br = pr >> 26, this.words[lr] = pr & 67108863;
      return this.negative = 1, this.strip();
    }, Me.prototype._wordDiv = function(Ae, ze) {
      var Ue = this.length - Ae.length, tr = this.clone(), lr = Ae, pr = lr.words[lr.length - 1] | 0, br = this._countBits(pr);
      Ue = 26 - br, Ue !== 0 && (lr = lr.ushln(Ue), tr.iushln(Ue), pr = lr.words[lr.length - 1] | 0);
      var nr = tr.length - lr.length, Pe;
      if (ze !== "mod") {
        Pe = new Me(null), Pe.length = nr + 1, Pe.words = new Array(Pe.length);
        for (var ur = 0; ur < Pe.length; ur++)
          Pe.words[ur] = 0;
      }
      var Pr = tr.clone()._ishlnsubmul(lr, 1, nr);
      Pr.negative === 0 && (tr = Pr, Pe && (Pe.words[nr] = 1));
      for (var Hr = nr - 1; Hr >= 0; Hr--) {
        var vi = (tr.words[lr.length + Hr] | 0) * 67108864 + (tr.words[lr.length + Hr - 1] | 0);
        for (vi = Math.min(vi / pr | 0, 67108863), tr._ishlnsubmul(lr, vi, Hr); tr.negative !== 0; )
          vi--, tr.negative = 0, tr._ishlnsubmul(lr, 1, Hr), tr.isZero() || (tr.negative ^= 1);
        Pe && (Pe.words[Hr] = vi);
      }
      return Pe && Pe.strip(), tr.strip(), ze !== "div" && Ue !== 0 && tr.iushrn(Ue), {
        div: Pe || null,
        mod: tr
      };
    }, Me.prototype.divmod = function(Ae, ze, Ue) {
      if (we(!Ae.isZero()), this.isZero())
        return {
          div: new Me(0),
          mod: new Me(0)
        };
      var tr, lr, pr;
      return this.negative !== 0 && Ae.negative === 0 ? (pr = this.neg().divmod(Ae, ze), ze !== "mod" && (tr = pr.div.neg()), ze !== "div" && (lr = pr.mod.neg(), Ue && lr.negative !== 0 && lr.iadd(Ae)), {
        div: tr,
        mod: lr
      }) : this.negative === 0 && Ae.negative !== 0 ? (pr = this.divmod(Ae.neg(), ze), ze !== "mod" && (tr = pr.div.neg()), {
        div: tr,
        mod: pr.mod
      }) : (this.negative & Ae.negative) !== 0 ? (pr = this.neg().divmod(Ae.neg(), ze), ze !== "div" && (lr = pr.mod.neg(), Ue && lr.negative !== 0 && lr.isub(Ae)), {
        div: pr.div,
        mod: lr
      }) : Ae.length > this.length || this.cmp(Ae) < 0 ? {
        div: new Me(0),
        mod: this
      } : Ae.length === 1 ? ze === "div" ? {
        div: this.divn(Ae.words[0]),
        mod: null
      } : ze === "mod" ? {
        div: null,
        mod: new Me(this.modn(Ae.words[0]))
      } : {
        div: this.divn(Ae.words[0]),
        mod: new Me(this.modn(Ae.words[0]))
      } : this._wordDiv(Ae, ze);
    }, Me.prototype.div = function(Ae) {
      return this.divmod(Ae, "div", !1).div;
    }, Me.prototype.mod = function(Ae) {
      return this.divmod(Ae, "mod", !1).mod;
    }, Me.prototype.umod = function(Ae) {
      return this.divmod(Ae, "mod", !0).mod;
    }, Me.prototype.divRound = function(Ae) {
      var ze = this.divmod(Ae);
      if (ze.mod.isZero())
        return ze.div;
      var Ue = ze.div.negative !== 0 ? ze.mod.isub(Ae) : ze.mod, tr = Ae.ushrn(1), lr = Ae.andln(1), pr = Ue.cmp(tr);
      return pr < 0 || lr === 1 && pr === 0 ? ze.div : ze.div.negative !== 0 ? ze.div.isubn(1) : ze.div.iaddn(1);
    }, Me.prototype.modn = function(Ae) {
      we(Ae <= 67108863);
      for (var ze = (1 << 26) % Ae, Ue = 0, tr = this.length - 1; tr >= 0; tr--)
        Ue = (ze * Ue + (this.words[tr] | 0)) % Ae;
      return Ue;
    }, Me.prototype.idivn = function(Ae) {
      we(Ae <= 67108863);
      for (var ze = 0, Ue = this.length - 1; Ue >= 0; Ue--) {
        var tr = (this.words[Ue] | 0) + ze * 67108864;
        this.words[Ue] = tr / Ae | 0, ze = tr % Ae;
      }
      return this.strip();
    }, Me.prototype.divn = function(Ae) {
      return this.clone().idivn(Ae);
    }, Me.prototype.egcd = function(Ae) {
      we(Ae.negative === 0), we(!Ae.isZero());
      var ze = this, Ue = Ae.clone();
      ze.negative !== 0 ? ze = ze.umod(Ae) : ze = ze.clone();
      for (var tr = new Me(1), lr = new Me(0), pr = new Me(0), br = new Me(1), nr = 0; ze.isEven() && Ue.isEven(); )
        ze.iushrn(1), Ue.iushrn(1), ++nr;
      for (var Pe = Ue.clone(), ur = ze.clone(); !ze.isZero(); ) {
        for (var Pr = 0, Hr = 1; (ze.words[0] & Hr) === 0 && Pr < 26; ++Pr, Hr <<= 1)
          ;
        if (Pr > 0)
          for (ze.iushrn(Pr); Pr-- > 0; )
            (tr.isOdd() || lr.isOdd()) && (tr.iadd(Pe), lr.isub(ur)), tr.iushrn(1), lr.iushrn(1);
        for (var vi = 0, Ti = 1; (Ue.words[0] & Ti) === 0 && vi < 26; ++vi, Ti <<= 1)
          ;
        if (vi > 0)
          for (Ue.iushrn(vi); vi-- > 0; )
            (pr.isOdd() || br.isOdd()) && (pr.iadd(Pe), br.isub(ur)), pr.iushrn(1), br.iushrn(1);
        ze.cmp(Ue) >= 0 ? (ze.isub(Ue), tr.isub(pr), lr.isub(br)) : (Ue.isub(ze), pr.isub(tr), br.isub(lr));
      }
      return {
        a: pr,
        b: br,
        gcd: Ue.iushln(nr)
      };
    }, Me.prototype._invmp = function(Ae) {
      we(Ae.negative === 0), we(!Ae.isZero());
      var ze = this, Ue = Ae.clone();
      ze.negative !== 0 ? ze = ze.umod(Ae) : ze = ze.clone();
      for (var tr = new Me(1), lr = new Me(0), pr = Ue.clone(); ze.cmpn(1) > 0 && Ue.cmpn(1) > 0; ) {
        for (var br = 0, nr = 1; (ze.words[0] & nr) === 0 && br < 26; ++br, nr <<= 1)
          ;
        if (br > 0)
          for (ze.iushrn(br); br-- > 0; )
            tr.isOdd() && tr.iadd(pr), tr.iushrn(1);
        for (var Pe = 0, ur = 1; (Ue.words[0] & ur) === 0 && Pe < 26; ++Pe, ur <<= 1)
          ;
        if (Pe > 0)
          for (Ue.iushrn(Pe); Pe-- > 0; )
            lr.isOdd() && lr.iadd(pr), lr.iushrn(1);
        ze.cmp(Ue) >= 0 ? (ze.isub(Ue), tr.isub(lr)) : (Ue.isub(ze), lr.isub(tr));
      }
      var Pr;
      return ze.cmpn(1) === 0 ? Pr = tr : Pr = lr, Pr.cmpn(0) < 0 && Pr.iadd(Ae), Pr;
    }, Me.prototype.gcd = function(Ae) {
      if (this.isZero())
        return Ae.abs();
      if (Ae.isZero())
        return this.abs();
      var ze = this.clone(), Ue = Ae.clone();
      ze.negative = 0, Ue.negative = 0;
      for (var tr = 0; ze.isEven() && Ue.isEven(); tr++)
        ze.iushrn(1), Ue.iushrn(1);
      do {
        for (; ze.isEven(); )
          ze.iushrn(1);
        for (; Ue.isEven(); )
          Ue.iushrn(1);
        var lr = ze.cmp(Ue);
        if (lr < 0) {
          var pr = ze;
          ze = Ue, Ue = pr;
        } else if (lr === 0 || Ue.cmpn(1) === 0)
          break;
        ze.isub(Ue);
      } while (!0);
      return Ue.iushln(tr);
    }, Me.prototype.invm = function(Ae) {
      return this.egcd(Ae).a.umod(Ae);
    }, Me.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, Me.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, Me.prototype.andln = function(Ae) {
      return this.words[0] & Ae;
    }, Me.prototype.bincn = function(Ae) {
      we(typeof Ae == "number");
      var ze = Ae % 26, Ue = (Ae - ze) / 26, tr = 1 << ze;
      if (this.length <= Ue)
        return this._expand(Ue + 1), this.words[Ue] |= tr, this;
      for (var lr = tr, pr = Ue; lr !== 0 && pr < this.length; pr++) {
        var br = this.words[pr] | 0;
        br += lr, lr = br >>> 26, br &= 67108863, this.words[pr] = br;
      }
      return lr !== 0 && (this.words[pr] = lr, this.length++), this;
    }, Me.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, Me.prototype.cmpn = function(Ae) {
      var ze = Ae < 0;
      if (this.negative !== 0 && !ze)
        return -1;
      if (this.negative === 0 && ze)
        return 1;
      this.strip();
      var Ue;
      if (this.length > 1)
        Ue = 1;
      else {
        ze && (Ae = -Ae), we(Ae <= 67108863, "Number is too big");
        var tr = this.words[0] | 0;
        Ue = tr === Ae ? 0 : tr < Ae ? -1 : 1;
      }
      return this.negative !== 0 ? -Ue | 0 : Ue;
    }, Me.prototype.cmp = function(Ae) {
      if (this.negative !== 0 && Ae.negative === 0)
        return -1;
      if (this.negative === 0 && Ae.negative !== 0)
        return 1;
      var ze = this.ucmp(Ae);
      return this.negative !== 0 ? -ze | 0 : ze;
    }, Me.prototype.ucmp = function(Ae) {
      if (this.length > Ae.length)
        return 1;
      if (this.length < Ae.length)
        return -1;
      for (var ze = 0, Ue = this.length - 1; Ue >= 0; Ue--) {
        var tr = this.words[Ue] | 0, lr = Ae.words[Ue] | 0;
        if (tr !== lr) {
          tr < lr ? ze = -1 : tr > lr && (ze = 1);
          break;
        }
      }
      return ze;
    }, Me.prototype.gtn = function(Ae) {
      return this.cmpn(Ae) === 1;
    }, Me.prototype.gt = function(Ae) {
      return this.cmp(Ae) === 1;
    }, Me.prototype.gten = function(Ae) {
      return this.cmpn(Ae) >= 0;
    }, Me.prototype.gte = function(Ae) {
      return this.cmp(Ae) >= 0;
    }, Me.prototype.ltn = function(Ae) {
      return this.cmpn(Ae) === -1;
    }, Me.prototype.lt = function(Ae) {
      return this.cmp(Ae) === -1;
    }, Me.prototype.lten = function(Ae) {
      return this.cmpn(Ae) <= 0;
    }, Me.prototype.lte = function(Ae) {
      return this.cmp(Ae) <= 0;
    }, Me.prototype.eqn = function(Ae) {
      return this.cmpn(Ae) === 0;
    }, Me.prototype.eq = function(Ae) {
      return this.cmp(Ae) === 0;
    }, Me.red = function(Ae) {
      return new oi(Ae);
    }, Me.prototype.toRed = function(Ae) {
      return we(!this.red, "Already a number in reduction context"), we(this.negative === 0, "red works only with positives"), Ae.convertTo(this)._forceRed(Ae);
    }, Me.prototype.fromRed = function() {
      return we(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, Me.prototype._forceRed = function(Ae) {
      return this.red = Ae, this;
    }, Me.prototype.forceRed = function(Ae) {
      return we(!this.red, "Already a number in reduction context"), this._forceRed(Ae);
    }, Me.prototype.redAdd = function(Ae) {
      return we(this.red, "redAdd works only with red numbers"), this.red.add(this, Ae);
    }, Me.prototype.redIAdd = function(Ae) {
      return we(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ae);
    }, Me.prototype.redSub = function(Ae) {
      return we(this.red, "redSub works only with red numbers"), this.red.sub(this, Ae);
    }, Me.prototype.redISub = function(Ae) {
      return we(this.red, "redISub works only with red numbers"), this.red.isub(this, Ae);
    }, Me.prototype.redShl = function(Ae) {
      return we(this.red, "redShl works only with red numbers"), this.red.shl(this, Ae);
    }, Me.prototype.redMul = function(Ae) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ae), this.red.mul(this, Ae);
    }, Me.prototype.redIMul = function(Ae) {
      return we(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ae), this.red.imul(this, Ae);
    }, Me.prototype.redSqr = function() {
      return we(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, Me.prototype.redISqr = function() {
      return we(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, Me.prototype.redSqrt = function() {
      return we(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, Me.prototype.redInvm = function() {
      return we(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, Me.prototype.redNeg = function() {
      return we(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, Me.prototype.redPow = function(Ae) {
      return we(this.red && !Ae.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ae);
    };
    var Xr = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Wr(vr, Ae) {
      this.name = vr, this.p = new Me(Ae, 16), this.n = this.p.bitLength(), this.k = new Me(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Wr.prototype._tmp = function() {
      var Ae = new Me(null);
      return Ae.words = new Array(Math.ceil(this.n / 13)), Ae;
    }, Wr.prototype.ireduce = function(Ae) {
      var ze = Ae, Ue;
      do
        this.split(ze, this.tmp), ze = this.imulK(ze), ze = ze.iadd(this.tmp), Ue = ze.bitLength();
      while (Ue > this.n);
      var tr = Ue < this.n ? -1 : ze.ucmp(this.p);
      return tr === 0 ? (ze.words[0] = 0, ze.length = 1) : tr > 0 ? ze.isub(this.p) : ze.strip !== void 0 ? ze.strip() : ze._strip(), ze;
    }, Wr.prototype.split = function(Ae, ze) {
      Ae.iushrn(this.n, 0, ze);
    }, Wr.prototype.imulK = function(Ae) {
      return Ae.imul(this.k);
    };
    function si() {
      Wr.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    $e(si, Wr), si.prototype.split = function(Ae, ze) {
      for (var Ue = 4194303, tr = Math.min(Ae.length, 9), lr = 0; lr < tr; lr++)
        ze.words[lr] = Ae.words[lr];
      if (ze.length = tr, Ae.length <= 9) {
        Ae.words[0] = 0, Ae.length = 1;
        return;
      }
      var pr = Ae.words[9];
      for (ze.words[ze.length++] = pr & Ue, lr = 10; lr < Ae.length; lr++) {
        var br = Ae.words[lr] | 0;
        Ae.words[lr - 10] = (br & Ue) << 4 | pr >>> 22, pr = br;
      }
      pr >>>= 22, Ae.words[lr - 10] = pr, pr === 0 && Ae.length > 10 ? Ae.length -= 10 : Ae.length -= 9;
    }, si.prototype.imulK = function(Ae) {
      Ae.words[Ae.length] = 0, Ae.words[Ae.length + 1] = 0, Ae.length += 2;
      for (var ze = 0, Ue = 0; Ue < Ae.length; Ue++) {
        var tr = Ae.words[Ue] | 0;
        ze += tr * 977, Ae.words[Ue] = ze & 67108863, ze = tr * 64 + (ze / 67108864 | 0);
      }
      return Ae.words[Ae.length - 1] === 0 && (Ae.length--, Ae.words[Ae.length - 1] === 0 && Ae.length--), Ae;
    };
    function li() {
      Wr.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    $e(li, Wr);
    function xi() {
      Wr.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    $e(xi, Wr);
    function di() {
      Wr.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    $e(di, Wr), di.prototype.imulK = function(Ae) {
      for (var ze = 0, Ue = 0; Ue < Ae.length; Ue++) {
        var tr = (Ae.words[Ue] | 0) * 19 + ze, lr = tr & 67108863;
        tr >>>= 26, Ae.words[Ue] = lr, ze = tr;
      }
      return ze !== 0 && (Ae.words[Ae.length++] = ze), Ae;
    }, Me._prime = function(Ae) {
      if (Xr[Ae])
        return Xr[Ae];
      var ze;
      if (Ae === "k256")
        ze = new si();
      else if (Ae === "p224")
        ze = new li();
      else if (Ae === "p192")
        ze = new xi();
      else if (Ae === "p25519")
        ze = new di();
      else
        throw new Error("Unknown prime " + Ae);
      return Xr[Ae] = ze, ze;
    };
    function oi(vr) {
      if (typeof vr == "string") {
        var Ae = Me._prime(vr);
        this.m = Ae.p, this.prime = Ae;
      } else
        we(vr.gtn(1), "modulus must be greater than 1"), this.m = vr, this.prime = null;
    }
    oi.prototype._verify1 = function(Ae) {
      we(Ae.negative === 0, "red works only with positives"), we(Ae.red, "red works only with red numbers");
    }, oi.prototype._verify2 = function(Ae, ze) {
      we((Ae.negative | ze.negative) === 0, "red works only with positives"), we(
        Ae.red && Ae.red === ze.red,
        "red works only with red numbers"
      );
    }, oi.prototype.imod = function(Ae) {
      return this.prime ? this.prime.ireduce(Ae)._forceRed(this) : Ae.umod(this.m)._forceRed(this);
    }, oi.prototype.neg = function(Ae) {
      return Ae.isZero() ? Ae.clone() : this.m.sub(Ae)._forceRed(this);
    }, oi.prototype.add = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.add(ze);
      return Ue.cmp(this.m) >= 0 && Ue.isub(this.m), Ue._forceRed(this);
    }, oi.prototype.iadd = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.iadd(ze);
      return Ue.cmp(this.m) >= 0 && Ue.isub(this.m), Ue;
    }, oi.prototype.sub = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.sub(ze);
      return Ue.cmpn(0) < 0 && Ue.iadd(this.m), Ue._forceRed(this);
    }, oi.prototype.isub = function(Ae, ze) {
      this._verify2(Ae, ze);
      var Ue = Ae.isub(ze);
      return Ue.cmpn(0) < 0 && Ue.iadd(this.m), Ue;
    }, oi.prototype.shl = function(Ae, ze) {
      return this._verify1(Ae), this.imod(Ae.ushln(ze));
    }, oi.prototype.imul = function(Ae, ze) {
      return this._verify2(Ae, ze), this.imod(Ae.imul(ze));
    }, oi.prototype.mul = function(Ae, ze) {
      return this._verify2(Ae, ze), this.imod(Ae.mul(ze));
    }, oi.prototype.isqr = function(Ae) {
      return this.imul(Ae, Ae.clone());
    }, oi.prototype.sqr = function(Ae) {
      return this.mul(Ae, Ae);
    }, oi.prototype.sqrt = function(Ae) {
      if (Ae.isZero())
        return Ae.clone();
      var ze = this.m.andln(3);
      if (we(ze % 2 === 1), ze === 3) {
        var Ue = this.m.add(new Me(1)).iushrn(2);
        return this.pow(Ae, Ue);
      }
      for (var tr = this.m.subn(1), lr = 0; !tr.isZero() && tr.andln(1) === 0; )
        lr++, tr.iushrn(1);
      we(!tr.isZero());
      var pr = new Me(1).toRed(this), br = pr.redNeg(), nr = this.m.subn(1).iushrn(1), Pe = this.m.bitLength();
      for (Pe = new Me(2 * Pe * Pe).toRed(this); this.pow(Pe, nr).cmp(br) !== 0; )
        Pe.redIAdd(br);
      for (var ur = this.pow(Pe, tr), Pr = this.pow(Ae, tr.addn(1).iushrn(1)), Hr = this.pow(Ae, tr), vi = lr; Hr.cmp(pr) !== 0; ) {
        for (var Ti = Hr, wi = 0; Ti.cmp(pr) !== 0; wi++)
          Ti = Ti.redSqr();
        we(wi < vi);
        var ii = this.pow(ur, new Me(1).iushln(vi - wi - 1));
        Pr = Pr.redMul(ii), ur = ii.redSqr(), Hr = Hr.redMul(ur), vi = wi;
      }
      return Pr;
    }, oi.prototype.invm = function(Ae) {
      var ze = Ae._invmp(this.m);
      return ze.negative !== 0 ? (ze.negative = 0, this.imod(ze).redNeg()) : this.imod(ze);
    }, oi.prototype.pow = function(Ae, ze) {
      if (ze.isZero())
        return new Me(1).toRed(this);
      if (ze.cmpn(1) === 0)
        return Ae.clone();
      var Ue = 4, tr = new Array(1 << Ue);
      tr[0] = new Me(1).toRed(this), tr[1] = Ae;
      for (var lr = 2; lr < tr.length; lr++)
        tr[lr] = this.mul(tr[lr - 1], Ae);
      var pr = tr[0], br = 0, nr = 0, Pe = ze.bitLength() % 26;
      for (Pe === 0 && (Pe = 26), lr = ze.length - 1; lr >= 0; lr--) {
        for (var ur = ze.words[lr], Pr = Pe - 1; Pr >= 0; Pr--) {
          var Hr = ur >> Pr & 1;
          if (pr !== tr[0] && (pr = this.sqr(pr)), Hr === 0 && br === 0) {
            nr = 0;
            continue;
          }
          br <<= 1, br |= Hr, nr++, !(nr !== Ue && (lr !== 0 || Pr !== 0)) && (pr = this.mul(pr, tr[br]), nr = 0, br = 0);
        }
        Pe = 26;
      }
      return pr;
    }, oi.prototype.convertTo = function(Ae) {
      var ze = Ae.umod(this.m);
      return ze === Ae ? ze.clone() : ze;
    }, oi.prototype.convertFrom = function(Ae) {
      var ze = Ae.clone();
      return ze.red = null, ze;
    }, Me.mont = function(Ae) {
      return new ci(Ae);
    };
    function ci(vr) {
      oi.call(this, vr), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new Me(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    $e(ci, oi), ci.prototype.convertTo = function(Ae) {
      return this.imod(Ae.ushln(this.shift));
    }, ci.prototype.convertFrom = function(Ae) {
      var ze = this.imod(Ae.mul(this.rinv));
      return ze.red = null, ze;
    }, ci.prototype.imul = function(Ae, ze) {
      if (Ae.isZero() || ze.isZero())
        return Ae.words[0] = 0, Ae.length = 1, Ae;
      var Ue = Ae.imul(ze), tr = Ue.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), lr = Ue.isub(tr).iushrn(this.shift), pr = lr;
      return lr.cmp(this.m) >= 0 ? pr = lr.isub(this.m) : lr.cmpn(0) < 0 && (pr = lr.iadd(this.m)), pr._forceRed(this);
    }, ci.prototype.mul = function(Ae, ze) {
      if (Ae.isZero() || ze.isZero())
        return new Me(0)._forceRed(this);
      var Ue = Ae.mul(ze), tr = Ue.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), lr = Ue.isub(tr).iushrn(this.shift), pr = lr;
      return lr.cmp(this.m) >= 0 ? pr = lr.isub(this.m) : lr.cmpn(0) < 0 && (pr = lr.iadd(this.m)), pr._forceRed(this);
    }, ci.prototype.invm = function(Ae) {
      var ze = this.imod(Ae._invmp(this.m).mul(this.r2));
      return ze._forceRed(this);
    };
  })(m, commonjsGlobal);
})(bn);
var BN$2 = bn.exports, Buffer$3 = safeBuffer$2.exports.Buffer;
function withPublic$2(m, c) {
  return Buffer$3.from(m.toRed(BN$2.mont(c.modulus)).redPow(new BN$2(c.publicExponent)).fromRed().toArray());
}
var withPublic_1 = withPublic$2, parseKeys$2 = parseAsn1, randomBytes = browser$c.exports, createHash$1 = browser$a, mgf$1 = mgf$2, xor$1 = xor$2, BN$1 = bn.exports, withPublic$1 = withPublic_1, crt$1 = browserifyRsa, Buffer$2 = safeBuffer$2.exports.Buffer, publicEncrypt = function m(c, ie, we) {
  var $e;
  c.padding ? $e = c.padding : we ? $e = 1 : $e = 4;
  var Me = parseKeys$2(c), Ze;
  if ($e === 4)
    Ze = oaep$1(Me, ie);
  else if ($e === 1)
    Ze = pkcs1$1(Me, ie, we);
  else if ($e === 3) {
    if (Ze = new BN$1(ie), Ze.cmp(Me.modulus) >= 0)
      throw new Error("data too long for modulus");
  } else
    throw new Error("unknown padding");
  return we ? crt$1(Ze, Me) : withPublic$1(Ze, Me);
};
function oaep$1(m, c) {
  var ie = m.modulus.byteLength(), we = c.length, $e = createHash$1("sha1").update(Buffer$2.alloc(0)).digest(), Me = $e.length, Ze = 2 * Me;
  if (we > ie - Ze - 2)
    throw new Error("message too long");
  var ne = Buffer$2.alloc(ie - we - Ze - 2), rr = ie - Me - 1, gr = randomBytes(Me), or = xor$1(Buffer$2.concat([$e, ne, Buffer$2.alloc(1, 1), c], rr), mgf$1(gr, rr)), _r = xor$1(gr, mgf$1(or, Me));
  return new BN$1(Buffer$2.concat([Buffer$2.alloc(1), _r, or], ie));
}
function pkcs1$1(m, c, ie) {
  var we = c.length, $e = m.modulus.byteLength();
  if (we > $e - 11)
    throw new Error("message too long");
  var Me;
  return ie ? Me = Buffer$2.alloc($e - we - 3, 255) : Me = nonZero($e - we - 3), new BN$1(Buffer$2.concat([Buffer$2.from([0, ie ? 1 : 2]), Me, Buffer$2.alloc(1), c], $e));
}
function nonZero(m) {
  for (var c = Buffer$2.allocUnsafe(m), ie = 0, we = randomBytes(m * 2), $e = 0, Me; ie < m; )
    $e === we.length && (we = randomBytes(m * 2), $e = 0), Me = we[$e++], Me && (c[ie++] = Me);
  return c;
}
var parseKeys$1 = parseAsn1, mgf = mgf$2, xor = xor$2, BN = bn.exports, crt = browserifyRsa, createHash = browser$a, withPublic = withPublic_1, Buffer$1 = safeBuffer$2.exports.Buffer, privateDecrypt = function m(c, ie, we) {
  var $e;
  c.padding ? $e = c.padding : we ? $e = 1 : $e = 4;
  var Me = parseKeys$1(c), Ze = Me.modulus.byteLength();
  if (ie.length > Ze || new BN(ie).cmp(Me.modulus) >= 0)
    throw new Error("decryption error");
  var ne;
  we ? ne = withPublic(new BN(ie), Me) : ne = crt(ie, Me);
  var rr = Buffer$1.alloc(Ze - ne.length);
  if (ne = Buffer$1.concat([rr, ne], Ze), $e === 4)
    return oaep(Me, ne);
  if ($e === 1)
    return pkcs1(Me, ne, we);
  if ($e === 3)
    return ne;
  throw new Error("unknown padding");
};
function oaep(m, c) {
  var ie = m.modulus.byteLength(), we = createHash("sha1").update(Buffer$1.alloc(0)).digest(), $e = we.length;
  if (c[0] !== 0)
    throw new Error("decryption error");
  var Me = c.slice(1, $e + 1), Ze = c.slice($e + 1), ne = xor(Me, mgf(Ze, $e)), rr = xor(Ze, mgf(ne, ie - $e - 1));
  if (compare$c(we, rr.slice(0, $e)))
    throw new Error("decryption error");
  for (var gr = $e; rr[gr] === 0; )
    gr++;
  if (rr[gr++] !== 1)
    throw new Error("decryption error");
  return rr.slice(gr);
}
function pkcs1(m, c, ie) {
  for (var we = c.slice(0, 2), $e = 2, Me = 0; c[$e++] !== 0; )
    if ($e >= c.length) {
      Me++;
      break;
    }
  var Ze = c.slice(2, $e - 1);
  if ((we.toString("hex") !== "0002" && !ie || we.toString("hex") !== "0001" && ie) && Me++, Ze.length < 8 && Me++, Me)
    throw new Error("decryption error");
  return c.slice($e);
}
function compare$c(m, c) {
  m = Buffer$1.from(m), c = Buffer$1.from(c);
  var ie = 0, we = m.length;
  m.length !== c.length && (ie++, we = Math.min(m.length, c.length));
  for (var $e = -1; ++$e < we; )
    ie += m[$e] ^ c[$e];
  return ie;
}
(function(m) {
  m.publicEncrypt = publicEncrypt, m.privateDecrypt = privateDecrypt, m.privateEncrypt = function(ie, we) {
    return m.publicEncrypt(ie, we, !0);
  }, m.publicDecrypt = function(ie, we) {
    return m.privateDecrypt(ie, we, !0);
  };
})(browser$2);
var browser$1 = {};
function oldBrowser() {
  throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
}
var safeBuffer = safeBuffer$2.exports, randombytes = browser$c.exports, Buffer = safeBuffer.Buffer, kBufferMaxLength = safeBuffer.kMaxLength, crypto$1 = commonjsGlobal.crypto || commonjsGlobal.msCrypto, kMaxUint32 = Math.pow(2, 32) - 1;
function assertOffset(m, c) {
  if (typeof m != "number" || m !== m)
    throw new TypeError("offset must be a number");
  if (m > kMaxUint32 || m < 0)
    throw new TypeError("offset must be a uint32");
  if (m > kBufferMaxLength || m > c)
    throw new RangeError("offset out of range");
}
function assertSize(m, c, ie) {
  if (typeof m != "number" || m !== m)
    throw new TypeError("size must be a number");
  if (m > kMaxUint32 || m < 0)
    throw new TypeError("size must be a uint32");
  if (m + c > ie || m > kBufferMaxLength)
    throw new RangeError("buffer too small");
}
crypto$1 && crypto$1.getRandomValues || !process$1.browser ? (browser$1.randomFill = randomFill, browser$1.randomFillSync = randomFillSync) : (browser$1.randomFill = oldBrowser, browser$1.randomFillSync = oldBrowser);
function randomFill(m, c, ie, we) {
  if (!Buffer.isBuffer(m) && !(m instanceof commonjsGlobal.Uint8Array))
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
  if (typeof c == "function")
    we = c, c = 0, ie = m.length;
  else if (typeof ie == "function")
    we = ie, ie = m.length - c;
  else if (typeof we != "function")
    throw new TypeError('"cb" argument must be a function');
  return assertOffset(c, m.length), assertSize(ie, c, m.length), actualFill(m, c, ie, we);
}
function actualFill(m, c, ie, we) {
  if (process$1.browser) {
    var $e = m.buffer, Me = new Uint8Array($e, c, ie);
    if (crypto$1.getRandomValues(Me), we) {
      process$1.nextTick(function() {
        we(null, m);
      });
      return;
    }
    return m;
  }
  if (we) {
    randombytes(ie, function(ne, rr) {
      if (ne)
        return we(ne);
      rr.copy(m, c), we(null, m);
    });
    return;
  }
  var Ze = randombytes(ie);
  return Ze.copy(m, c), m;
}
function randomFillSync(m, c, ie) {
  if (typeof c > "u" && (c = 0), !Buffer.isBuffer(m) && !(m instanceof commonjsGlobal.Uint8Array))
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
  return assertOffset(c, m.length), ie === void 0 && (ie = m.length - c), assertSize(ie, c, m.length), actualFill(m, c, ie);
}
var hasRequiredCryptoBrowserify;
function requireCryptoBrowserify() {
  if (hasRequiredCryptoBrowserify)
    return cryptoBrowserify;
  hasRequiredCryptoBrowserify = 1, cryptoBrowserify.randomBytes = cryptoBrowserify.rng = cryptoBrowserify.pseudoRandomBytes = cryptoBrowserify.prng = browser$c.exports, cryptoBrowserify.createHash = cryptoBrowserify.Hash = browser$a, cryptoBrowserify.createHmac = cryptoBrowserify.Hmac = browser$9;
  var m = algos.exports, c = Object.keys(m), ie = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
  ].concat(c);
  cryptoBrowserify.getHashes = function() {
    return ie;
  };
  var we = browser$8;
  cryptoBrowserify.pbkdf2 = we.pbkdf2, cryptoBrowserify.pbkdf2Sync = we.pbkdf2Sync;
  var $e = browser$7;
  cryptoBrowserify.Cipher = $e.Cipher, cryptoBrowserify.createCipher = $e.createCipher, cryptoBrowserify.Cipheriv = $e.Cipheriv, cryptoBrowserify.createCipheriv = $e.createCipheriv, cryptoBrowserify.Decipher = $e.Decipher, cryptoBrowserify.createDecipher = $e.createDecipher, cryptoBrowserify.Decipheriv = $e.Decipheriv, cryptoBrowserify.createDecipheriv = $e.createDecipheriv, cryptoBrowserify.getCiphers = $e.getCiphers, cryptoBrowserify.listCiphers = $e.listCiphers;
  var Me = requireBrowser$2();
  cryptoBrowserify.DiffieHellmanGroup = Me.DiffieHellmanGroup, cryptoBrowserify.createDiffieHellmanGroup = Me.createDiffieHellmanGroup, cryptoBrowserify.getDiffieHellman = Me.getDiffieHellman, cryptoBrowserify.createDiffieHellman = Me.createDiffieHellman, cryptoBrowserify.DiffieHellman = Me.DiffieHellman;
  var Ze = requireBrowser$1();
  cryptoBrowserify.createSign = Ze.createSign, cryptoBrowserify.Sign = Ze.Sign, cryptoBrowserify.createVerify = Ze.createVerify, cryptoBrowserify.Verify = Ze.Verify, cryptoBrowserify.createECDH = requireBrowser();
  var ne = browser$2;
  cryptoBrowserify.publicEncrypt = ne.publicEncrypt, cryptoBrowserify.privateEncrypt = ne.privateEncrypt, cryptoBrowserify.publicDecrypt = ne.publicDecrypt, cryptoBrowserify.privateDecrypt = ne.privateDecrypt;
  var rr = browser$1;
  return cryptoBrowserify.randomFill = rr.randomFill, cryptoBrowserify.randomFillSync = rr.randomFillSync, cryptoBrowserify.createCredentials = function() {
    throw new Error(`sorry, createCredentials is not implemented yet
we accept pull requests
https://github.com/browserify/crypto-browserify`);
  }, cryptoBrowserify.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, cryptoBrowserify;
}
var cryptoBrowserifyExports = requireCryptoBrowserify();
function simpleHash(m) {
  let c = 0;
  for (let ie = 0; ie < m.length; ie++) {
    const we = m.charCodeAt(ie);
    c = (c << 5) - c + we, c &= c;
  }
  return new Uint32Array([c])[0].toString(36);
}
function hashString(m, c = "sha256") {
  const ie = cryptoBrowserifyExports.createHash(c);
  return ie.update(m), ie.digest("hex");
}
function hashObject(m, c = "sha256") {
  return hashString(JSON.stringify(m), c);
}
function hash$1(m) {
  const c = typeof m == "string" ? m : JSON.stringify(m);
  return simpleHash(c);
}
const _hoisted_1$Q = ["contenteditable", "data-ghost"], _hoisted_2$C = ["data-paragraph"], _sfc_main$14 = /* @__PURE__ */ defineComponent({
  __name: "RichTextDisplay",
  props: {
    paragraphs: {},
    noLazy: { type: Boolean },
    ghost: { type: Boolean },
    debug: { type: Boolean }
  },
  emits: ["update", "focus", "blur"],
  setup(m, { expose: c, emit: ie }) {
    const we = m, $e = ie, Me = ref$1(), Ze = ref$1(we.paragraphs);
    watch(
      () => we.paragraphs,
      () => {
        we.noLazy && (Ze.value = we.paragraphs);
      },
      { deep: !0 }
    ), watchEffect(() => {
      we.debug && console.log("lazyParagraphs", Ze.value);
    });
    const ne = (_r) => {
      $e("update", _r);
    }, rr = (_r) => {
      $e("focus", _r);
    }, gr = (_r) => {
      $e("blur", _r);
    };
    nanoid();
    const or = (_r) => {
      const Lr = Object.fromEntries(Object.entries(_r).filter(([, Rr]) => Rr !== void 0)), Ir = `rich-text-${hashObject(Lr)}`;
      let Ar = document.querySelector(`[data-rich-text-global-style='${Ir}']`);
      return Ar || (Ar = document.createElement("style"), Ar.lang = "css", Ar.setAttribute("data-rich-text-global-style", Ir), document.head.appendChild(Ar)), Ar.innerHTML = `.${Ir} { ${Object.entries(Lr).map(([Rr, Nr]) => `${Rr}: ${Nr};`).join(" ")} }`, Ir;
    };
    return c({
      richTextEditorDivRef: Me
    }), (_r, Lr) => (openBlock(), createElementBlock("div", {
      ref_key: "richTextEditorDivRef",
      ref: Me,
      class: normalizeClass(["rich-text-editor", { ghost: _r.ghost }]),
      contenteditable: !_r.ghost,
      onInput: ne,
      onFocus: rr,
      onBlur: gr,
      "data-ghost": _r.ghost
    }, [
      (openBlock(!0), createElementBlock(Fragment, null, renderList(Ze.value, (Ir, Ar) => (openBlock(), createElementBlock(Fragment, { key: Ar }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(Ir, (Rr, Nr) => renderSlot(_r.$slots, "feature", {
          key: Nr,
          text: Rr.text,
          format: Rr.format,
          cssclass: or
        }, void 0, !0)), 128)),
        Ar < Ze.value.length - 1 ? (openBlock(), createElementBlock("br", {
          key: 0,
          "data-custom-br": "true",
          "data-paragraph": JSON.stringify(Ir)
        }, null, 8, _hoisted_2$C)) : createCommentVNode("", !0)
      ], 64))), 128))
    ], 42, _hoisted_1$Q));
  }
}), RichTextDisplay_vue_vue_type_style_index_0_scoped_a344d5e9_lang = "", RichTextDisplay = /* @__PURE__ */ _export_sfc(_sfc_main$14, [["__scopeId", "data-v-a344d5e9"]]), _hoisted_1$P = { class: "rich-text-wrapper" }, _hoisted_2$B = ["data-feature-format"], _hoisted_3$q = ["data-feature-format"], _sfc_main$13 = /* @__PURE__ */ defineComponent({
  __name: "RichText",
  props: {
    value: {},
    selection: {},
    userAgentRichText: { type: Boolean },
    renderFeatureInlineStyle: {},
    maxLength: {},
    maxLengthPerLine: {},
    maxLines: {},
    multiline: { type: Boolean, default: !0 }
  },
  emits: [
    "update:value",
    "update:visible-value",
    "update:selection",
    "update:warning-message",
    "update:focus"
  ],
  setup(m, { expose: c, emit: ie }) {
    const we = m, $e = ie;
    computed(() => !we.multiline);
    const Me = ref$1(), Ze = ref$1(), ne = computed(() => Me.value?.richTextEditorDivRef), { handleInputEvent: rr, paragraphs: gr, visibleParagraphs: or, manipulationState: _r, applyFormat: Lr, resolveFeatures: Ir, selection: Ar } = useContentEditable(
      ne,
      toRef(we, "value"),
      {
        maxLength: we.maxLength,
        maxLengthPerLine: we.maxLengthPerLine,
        maxLines: we.maxLines
      }
    ), Rr = (si) => {
      we.multiline || si.key === "Enter" && si.preventDefault();
    }, Nr = computed(() => isEqual(gr.value, or.value) ? void 0 : "Text is too long");
    watchEffect(() => {
      $e("update:warning-message", Nr.value);
    });
    const Yr = ref$1(!1);
    watch(
      Yr,
      () => {
        $e("update:focus", Yr.value);
      },
      { immediate: !0 }
    );
    const Vr = () => {
      Yr.value = !0;
    }, Xr = () => {
      Yr.value = !1;
    };
    watch(ne, (si, li) => {
      li && (li.removeEventListener("focus", Vr), li.removeEventListener("blur", Xr)), si && (si.addEventListener("focus", Vr), si.addEventListener("blur", Xr));
    }), watch(Ar, () => {
      isEqual(Ar.value, we.selection) || $e("update:selection", Ar.value ?? void 0);
    }), watch(gr, () => {
      isEqual(gr.value, we.value) || $e("update:value", gr.value);
    }), watch(or, () => {
      $e("update:visible-value", or.value);
    }), window.addEventListener("touchmove", (si) => {
      Ar.value && si.preventDefault();
    });
    let Wr;
    return onMounted(() => {
      if (!Ze.value?.richTextEditorDivRef)
        return;
      const si = (li, xi) => {
        Me.value?.richTextEditorDivRef, Ze.value?.richTextEditorDivRef;
        for (const di of li)
          ;
      };
      Wr = new MutationObserver(si), Wr.observe(Ze.value.richTextEditorDivRef, {
        attributes: !0,
        childList: !0,
        subtree: !0
      });
    }), onUnmounted(() => {
      Wr.disconnect();
    }), c({
      applyFormat: Lr,
      resolveFeatures: Ir
    }), (si, li) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["rich-text", { focus: Yr.value }])
    }, [
      createElementVNode("div", _hoisted_1$P, [
        createVNode(RichTextDisplay, {
          ref_key: "richTextDisplayGhostInstance",
          ref: Ze,
          paragraphs: unref(or),
          "no-lazy": "",
          ghost: "",
          debug: !1
        }, {
          feature: withCtx((xi) => [
            createElementVNode("span", {
              "data-feature-format": JSON.stringify(xi.format),
              class: normalizeClass(["feature-wrapper feature-wrapper-ghost", {
                [xi.cssclass(si.renderFeatureInlineStyle(xi.format))]: !0,
                "line-overflow": !!xi.format.lineOverflow,
                overflow: !!xi.format.overflow
              }])
            }, toDisplayString(xi.text), 11, _hoisted_2$B)
          ]),
          _: 1
        }, 8, ["paragraphs"]),
        (openBlock(), createBlock(RichTextDisplay, {
          ref_key: "richTextDisplayInstance",
          ref: Me,
          key: unref(_r),
          paragraphs: unref(gr),
          onUpdate: unref(rr),
          onKeydown: Rr,
          style: normalizeStyle({
            "-webkit-user-modify": si.userAgentRichText ? "read-write" : "read-write-plaintext-only"
          })
        }, {
          feature: withCtx((xi) => [
            createElementVNode("span", {
              "data-feature-format": JSON.stringify(xi.format),
              class: normalizeClass(["feature-wrapper", {
                [xi.cssclass(si.renderFeatureInlineStyle(xi.format))]: !0
              }])
            }, toDisplayString(xi.text), 11, _hoisted_3$q)
          ]),
          _: 1
        }, 8, ["paragraphs", "onUpdate", "style"]))
      ])
    ], 2));
  }
}), RichText_vue_vue_type_style_index_0_scoped_3bf042ff_lang = "", RichText = /* @__PURE__ */ _export_sfc(_sfc_main$13, [["__scopeId", "data-v-3bf042ff"]]), colorNames = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, reverseNames = /* @__PURE__ */ Object.create(null);
for (const m in colorNames)
  Object.hasOwn(colorNames, m) && (reverseNames[colorNames[m]] = m);
const cs = {
  to: {},
  get: {}
};
cs.get = function(m) {
  const c = m.slice(0, 3).toLowerCase();
  let ie, we;
  switch (c) {
    case "hsl": {
      ie = cs.get.hsl(m), we = "hsl";
      break;
    }
    case "hwb": {
      ie = cs.get.hwb(m), we = "hwb";
      break;
    }
    default: {
      ie = cs.get.rgb(m), we = "rgb";
      break;
    }
  }
  return ie ? { model: we, value: ie } : null;
};
cs.get.rgb = function(m) {
  if (!m)
    return null;
  const c = /^#([a-f\d]{3,4})$/i, ie = /^#([a-f\d]{6})([a-f\d]{2})?$/i, we = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|/]\s*([+-]?[\d.]+)(%?)\s*)?\)$/, $e = /^rgba?\(\s*([+-]?[\d.]+)%\s*,?\s*([+-]?[\d.]+)%\s*,?\s*([+-]?[\d.]+)%\s*(?:[,|/]\s*([+-]?[\d.]+)(%?)\s*)?\)$/, Me = /^(\w+)$/;
  let Ze = [0, 0, 0, 1], ne, rr, gr;
  if (ne = m.match(ie)) {
    for (gr = ne[2], ne = ne[1], rr = 0; rr < 3; rr++) {
      const or = rr * 2;
      Ze[rr] = Number.parseInt(ne.slice(or, or + 2), 16);
    }
    gr && (Ze[3] = Number.parseInt(gr, 16) / 255);
  } else if (ne = m.match(c)) {
    for (ne = ne[1], gr = ne[3], rr = 0; rr < 3; rr++)
      Ze[rr] = Number.parseInt(ne[rr] + ne[rr], 16);
    gr && (Ze[3] = Number.parseInt(gr + gr, 16) / 255);
  } else if (ne = m.match(we)) {
    for (rr = 0; rr < 3; rr++)
      Ze[rr] = Number.parseInt(ne[rr + 1], 10);
    ne[4] && (Ze[3] = ne[5] ? Number.parseFloat(ne[4]) * 0.01 : Number.parseFloat(ne[4]));
  } else if (ne = m.match($e)) {
    for (rr = 0; rr < 3; rr++)
      Ze[rr] = Math.round(Number.parseFloat(ne[rr + 1]) * 2.55);
    ne[4] && (Ze[3] = ne[5] ? Number.parseFloat(ne[4]) * 0.01 : Number.parseFloat(ne[4]));
  } else
    return (ne = m.match(Me)) ? ne[1] === "transparent" ? [0, 0, 0, 0] : Object.hasOwn(colorNames, ne[1]) ? (Ze = colorNames[ne[1]], Ze[3] = 1, Ze) : null : null;
  for (rr = 0; rr < 3; rr++)
    Ze[rr] = clamp$1(Ze[rr], 0, 255);
  return Ze[3] = clamp$1(Ze[3], 0, 1), Ze;
};
cs.get.hsl = function(m) {
  if (!m)
    return null;
  const c = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d.]+)%\s*,?\s*([+-]?[\d.]+)%\s*(?:[,|/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, ie = m.match(c);
  if (ie) {
    const we = Number.parseFloat(ie[4]), $e = (Number.parseFloat(ie[1]) % 360 + 360) % 360, Me = clamp$1(Number.parseFloat(ie[2]), 0, 100), Ze = clamp$1(Number.parseFloat(ie[3]), 0, 100), ne = clamp$1(Number.isNaN(we) ? 1 : we, 0, 1);
    return [$e, Me, Ze, ne];
  }
  return null;
};
cs.get.hwb = function(m) {
  if (!m)
    return null;
  const c = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d.]+)%\s*,\s*([+-]?[\d.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, ie = m.match(c);
  if (ie) {
    const we = Number.parseFloat(ie[4]), $e = (Number.parseFloat(ie[1]) % 360 + 360) % 360, Me = clamp$1(Number.parseFloat(ie[2]), 0, 100), Ze = clamp$1(Number.parseFloat(ie[3]), 0, 100), ne = clamp$1(Number.isNaN(we) ? 1 : we, 0, 1);
    return [$e, Me, Ze, ne];
  }
  return null;
};
cs.to.hex = function(...m) {
  return "#" + hexDouble(m[0]) + hexDouble(m[1]) + hexDouble(m[2]) + (m[3] < 1 ? hexDouble(Math.round(m[3] * 255)) : "");
};
cs.to.rgb = function(...m) {
  return m.length < 4 || m[3] === 1 ? "rgb(" + Math.round(m[0]) + ", " + Math.round(m[1]) + ", " + Math.round(m[2]) + ")" : "rgba(" + Math.round(m[0]) + ", " + Math.round(m[1]) + ", " + Math.round(m[2]) + ", " + m[3] + ")";
};
cs.to.rgb.percent = function(...m) {
  const c = Math.round(m[0] / 255 * 100), ie = Math.round(m[1] / 255 * 100), we = Math.round(m[2] / 255 * 100);
  return m.length < 4 || m[3] === 1 ? "rgb(" + c + "%, " + ie + "%, " + we + "%)" : "rgba(" + c + "%, " + ie + "%, " + we + "%, " + m[3] + ")";
};
cs.to.hsl = function(...m) {
  return m.length < 4 || m[3] === 1 ? "hsl(" + m[0] + ", " + m[1] + "%, " + m[2] + "%)" : "hsla(" + m[0] + ", " + m[1] + "%, " + m[2] + "%, " + m[3] + ")";
};
cs.to.hwb = function(...m) {
  let c = "";
  return m.length >= 4 && m[3] !== 1 && (c = ", " + m[3]), "hwb(" + m[0] + ", " + m[1] + "%, " + m[2] + "%" + c + ")";
};
cs.to.keyword = function(...m) {
  return reverseNames[m.slice(0, 3)];
};
function clamp$1(m, c, ie) {
  return Math.min(Math.max(c, m), ie);
}
function hexDouble(m) {
  const c = Math.round(m).toString(16).toUpperCase();
  return c.length < 2 ? "0" + c : c;
}
const cssKeywords = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, reverseKeywords = {};
for (const m of Object.keys(cssKeywords))
  reverseKeywords[cssKeywords[m]] = m;
const convert$1 = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
}, LAB_FT = (6 / 29) ** 3;
for (const m of Object.keys(convert$1)) {
  if (!("channels" in convert$1[m]))
    throw new Error("missing channels property: " + m);
  if (!("labels" in convert$1[m]))
    throw new Error("missing channel labels property: " + m);
  if (convert$1[m].labels.length !== convert$1[m].channels)
    throw new Error("channel and label counts mismatch: " + m);
  const { channels: c, labels: ie } = convert$1[m];
  delete convert$1[m].channels, delete convert$1[m].labels, Object.defineProperty(convert$1[m], "channels", { value: c }), Object.defineProperty(convert$1[m], "labels", { value: ie });
}
convert$1.rgb.hsl = function(m) {
  const c = m[0] / 255, ie = m[1] / 255, we = m[2] / 255, $e = Math.min(c, ie, we), Me = Math.max(c, ie, we), Ze = Me - $e;
  let ne, rr;
  switch (Me) {
    case $e: {
      ne = 0;
      break;
    }
    case c: {
      ne = (ie - we) / Ze;
      break;
    }
    case ie: {
      ne = 2 + (we - c) / Ze;
      break;
    }
    case we: {
      ne = 4 + (c - ie) / Ze;
      break;
    }
  }
  ne = Math.min(ne * 60, 360), ne < 0 && (ne += 360);
  const gr = ($e + Me) / 2;
  return Me === $e ? rr = 0 : gr <= 0.5 ? rr = Ze / (Me + $e) : rr = Ze / (2 - Me - $e), [ne, rr * 100, gr * 100];
};
convert$1.rgb.hsv = function(m) {
  let c, ie, we, $e, Me;
  const Ze = m[0] / 255, ne = m[1] / 255, rr = m[2] / 255, gr = Math.max(Ze, ne, rr), or = gr - Math.min(Ze, ne, rr), _r = function(Lr) {
    return (gr - Lr) / 6 / or + 1 / 2;
  };
  if (or === 0)
    $e = 0, Me = 0;
  else {
    switch (Me = or / gr, c = _r(Ze), ie = _r(ne), we = _r(rr), gr) {
      case Ze: {
        $e = we - ie;
        break;
      }
      case ne: {
        $e = 1 / 3 + c - we;
        break;
      }
      case rr: {
        $e = 2 / 3 + ie - c;
        break;
      }
    }
    $e < 0 ? $e += 1 : $e > 1 && ($e -= 1);
  }
  return [
    $e * 360,
    Me * 100,
    gr * 100
  ];
};
convert$1.rgb.hwb = function(m) {
  const c = m[0], ie = m[1];
  let we = m[2];
  const $e = convert$1.rgb.hsl(m)[0], Me = 1 / 255 * Math.min(c, Math.min(ie, we));
  return we = 1 - 1 / 255 * Math.max(c, Math.max(ie, we)), [$e, Me * 100, we * 100];
};
convert$1.rgb.cmyk = function(m) {
  const c = m[0] / 255, ie = m[1] / 255, we = m[2] / 255, $e = Math.min(1 - c, 1 - ie, 1 - we), Me = (1 - c - $e) / (1 - $e) || 0, Ze = (1 - ie - $e) / (1 - $e) || 0, ne = (1 - we - $e) / (1 - $e) || 0;
  return [Me * 100, Ze * 100, ne * 100, $e * 100];
};
function comparativeDistance(m, c) {
  return (m[0] - c[0]) ** 2 + (m[1] - c[1]) ** 2 + (m[2] - c[2]) ** 2;
}
convert$1.rgb.keyword = function(m) {
  const c = reverseKeywords[m];
  if (c)
    return c;
  let ie = Number.POSITIVE_INFINITY, we;
  for (const $e of Object.keys(cssKeywords)) {
    const Me = cssKeywords[$e], Ze = comparativeDistance(m, Me);
    Ze < ie && (ie = Ze, we = $e);
  }
  return we;
};
convert$1.keyword.rgb = function(m) {
  return cssKeywords[m];
};
convert$1.rgb.xyz = function(m) {
  let c = m[0] / 255, ie = m[1] / 255, we = m[2] / 255;
  c = c > 0.04045 ? ((c + 0.055) / 1.055) ** 2.4 : c / 12.92, ie = ie > 0.04045 ? ((ie + 0.055) / 1.055) ** 2.4 : ie / 12.92, we = we > 0.04045 ? ((we + 0.055) / 1.055) ** 2.4 : we / 12.92;
  const $e = c * 0.4124564 + ie * 0.3575761 + we * 0.1804375, Me = c * 0.2126729 + ie * 0.7151522 + we * 0.072175, Ze = c * 0.0193339 + ie * 0.119192 + we * 0.9503041;
  return [$e * 100, Me * 100, Ze * 100];
};
convert$1.rgb.lab = function(m) {
  const c = convert$1.rgb.xyz(m);
  let ie = c[0], we = c[1], $e = c[2];
  ie /= 95.047, we /= 100, $e /= 108.883, ie = ie > LAB_FT ? ie ** (1 / 3) : 7.787 * ie + 16 / 116, we = we > LAB_FT ? we ** (1 / 3) : 7.787 * we + 16 / 116, $e = $e > LAB_FT ? $e ** (1 / 3) : 7.787 * $e + 16 / 116;
  const Me = 116 * we - 16, Ze = 500 * (ie - we), ne = 200 * (we - $e);
  return [Me, Ze, ne];
};
convert$1.hsl.rgb = function(m) {
  const c = m[0] / 360, ie = m[1] / 100, we = m[2] / 100;
  let $e, Me;
  if (ie === 0)
    return Me = we * 255, [Me, Me, Me];
  const Ze = we < 0.5 ? we * (1 + ie) : we + ie - we * ie, ne = 2 * we - Ze, rr = [0, 0, 0];
  for (let gr = 0; gr < 3; gr++)
    $e = c + 1 / 3 * -(gr - 1), $e < 0 && $e++, $e > 1 && $e--, 6 * $e < 1 ? Me = ne + (Ze - ne) * 6 * $e : 2 * $e < 1 ? Me = Ze : 3 * $e < 2 ? Me = ne + (Ze - ne) * (2 / 3 - $e) * 6 : Me = ne, rr[gr] = Me * 255;
  return rr;
};
convert$1.hsl.hsv = function(m) {
  const c = m[0];
  let ie = m[1] / 100, we = m[2] / 100, $e = ie;
  const Me = Math.max(we, 0.01);
  we *= 2, ie *= we <= 1 ? we : 2 - we, $e *= Me <= 1 ? Me : 2 - Me;
  const Ze = (we + ie) / 2, ne = we === 0 ? 2 * $e / (Me + $e) : 2 * ie / (we + ie);
  return [c, ne * 100, Ze * 100];
};
convert$1.hsv.rgb = function(m) {
  const c = m[0] / 60, ie = m[1] / 100;
  let we = m[2] / 100;
  const $e = Math.floor(c) % 6, Me = c - Math.floor(c), Ze = 255 * we * (1 - ie), ne = 255 * we * (1 - ie * Me), rr = 255 * we * (1 - ie * (1 - Me));
  switch (we *= 255, $e) {
    case 0:
      return [we, rr, Ze];
    case 1:
      return [ne, we, Ze];
    case 2:
      return [Ze, we, rr];
    case 3:
      return [Ze, ne, we];
    case 4:
      return [rr, Ze, we];
    case 5:
      return [we, Ze, ne];
  }
};
convert$1.hsv.hsl = function(m) {
  const c = m[0], ie = m[1] / 100, we = m[2] / 100, $e = Math.max(we, 0.01);
  let Me, Ze;
  Ze = (2 - ie) * we;
  const ne = (2 - ie) * $e;
  return Me = ie * $e, Me /= ne <= 1 ? ne : 2 - ne, Me = Me || 0, Ze /= 2, [c, Me * 100, Ze * 100];
};
convert$1.hwb.rgb = function(m) {
  const c = m[0] / 360;
  let ie = m[1] / 100, we = m[2] / 100;
  const $e = ie + we;
  let Me;
  $e > 1 && (ie /= $e, we /= $e);
  const Ze = Math.floor(6 * c), ne = 1 - we;
  Me = 6 * c - Ze, (Ze & 1) !== 0 && (Me = 1 - Me);
  const rr = ie + Me * (ne - ie);
  let gr, or, _r;
  switch (Ze) {
    default:
    case 6:
    case 0: {
      gr = ne, or = rr, _r = ie;
      break;
    }
    case 1: {
      gr = rr, or = ne, _r = ie;
      break;
    }
    case 2: {
      gr = ie, or = ne, _r = rr;
      break;
    }
    case 3: {
      gr = ie, or = rr, _r = ne;
      break;
    }
    case 4: {
      gr = rr, or = ie, _r = ne;
      break;
    }
    case 5: {
      gr = ne, or = ie, _r = rr;
      break;
    }
  }
  return [gr * 255, or * 255, _r * 255];
};
convert$1.cmyk.rgb = function(m) {
  const c = m[0] / 100, ie = m[1] / 100, we = m[2] / 100, $e = m[3] / 100, Me = 1 - Math.min(1, c * (1 - $e) + $e), Ze = 1 - Math.min(1, ie * (1 - $e) + $e), ne = 1 - Math.min(1, we * (1 - $e) + $e);
  return [Me * 255, Ze * 255, ne * 255];
};
convert$1.xyz.rgb = function(m) {
  const c = m[0] / 100, ie = m[1] / 100, we = m[2] / 100;
  let $e, Me, Ze;
  return $e = c * 3.2404542 + ie * -1.5371385 + we * -0.4985314, Me = c * -0.969266 + ie * 1.8760108 + we * 0.041556, Ze = c * 0.0556434 + ie * -0.2040259 + we * 1.0572252, $e = $e > 31308e-7 ? 1.055 * $e ** (1 / 2.4) - 0.055 : $e * 12.92, Me = Me > 31308e-7 ? 1.055 * Me ** (1 / 2.4) - 0.055 : Me * 12.92, Ze = Ze > 31308e-7 ? 1.055 * Ze ** (1 / 2.4) - 0.055 : Ze * 12.92, $e = Math.min(Math.max(0, $e), 1), Me = Math.min(Math.max(0, Me), 1), Ze = Math.min(Math.max(0, Ze), 1), [$e * 255, Me * 255, Ze * 255];
};
convert$1.xyz.lab = function(m) {
  let c = m[0], ie = m[1], we = m[2];
  c /= 95.047, ie /= 100, we /= 108.883, c = c > LAB_FT ? c ** (1 / 3) : 7.787 * c + 16 / 116, ie = ie > LAB_FT ? ie ** (1 / 3) : 7.787 * ie + 16 / 116, we = we > LAB_FT ? we ** (1 / 3) : 7.787 * we + 16 / 116;
  const $e = 116 * ie - 16, Me = 500 * (c - ie), Ze = 200 * (ie - we);
  return [$e, Me, Ze];
};
convert$1.lab.xyz = function(m) {
  const c = m[0], ie = m[1], we = m[2];
  let $e, Me, Ze;
  Me = (c + 16) / 116, $e = ie / 500 + Me, Ze = Me - we / 200;
  const ne = Me ** 3, rr = $e ** 3, gr = Ze ** 3;
  return Me = ne > LAB_FT ? ne : (Me - 16 / 116) / 7.787, $e = rr > LAB_FT ? rr : ($e - 16 / 116) / 7.787, Ze = gr > LAB_FT ? gr : (Ze - 16 / 116) / 7.787, $e *= 95.047, Me *= 100, Ze *= 108.883, [$e, Me, Ze];
};
convert$1.lab.lch = function(m) {
  const c = m[0], ie = m[1], we = m[2];
  let $e;
  $e = Math.atan2(we, ie) * 360 / 2 / Math.PI, $e < 0 && ($e += 360);
  const Ze = Math.sqrt(ie * ie + we * we);
  return [c, Ze, $e];
};
convert$1.lch.lab = function(m) {
  const c = m[0], ie = m[1], $e = m[2] / 360 * 2 * Math.PI, Me = ie * Math.cos($e), Ze = ie * Math.sin($e);
  return [c, Me, Ze];
};
convert$1.rgb.ansi16 = function(m, c = null) {
  const [ie, we, $e] = m;
  let Me = c === null ? convert$1.rgb.hsv(m)[2] : c;
  if (Me = Math.round(Me / 50), Me === 0)
    return 30;
  let Ze = 30 + (Math.round($e / 255) << 2 | Math.round(we / 255) << 1 | Math.round(ie / 255));
  return Me === 2 && (Ze += 60), Ze;
};
convert$1.hsv.ansi16 = function(m) {
  return convert$1.rgb.ansi16(convert$1.hsv.rgb(m), m[2]);
};
convert$1.rgb.ansi256 = function(m) {
  const c = m[0], ie = m[1], we = m[2];
  return c >> 4 === ie >> 4 && ie >> 4 === we >> 4 ? c < 8 ? 16 : c > 248 ? 231 : Math.round((c - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(c / 255 * 5) + 6 * Math.round(ie / 255 * 5) + Math.round(we / 255 * 5);
};
convert$1.ansi16.rgb = function(m) {
  m = m[0];
  let c = m % 10;
  if (c === 0 || c === 7)
    return m > 50 && (c += 3.5), c = c / 10.5 * 255, [c, c, c];
  const ie = (Math.trunc(m > 50) + 1) * 0.5, we = (c & 1) * ie * 255, $e = (c >> 1 & 1) * ie * 255, Me = (c >> 2 & 1) * ie * 255;
  return [we, $e, Me];
};
convert$1.ansi256.rgb = function(m) {
  if (m = m[0], m >= 232) {
    const Me = (m - 232) * 10 + 8;
    return [Me, Me, Me];
  }
  m -= 16;
  let c;
  const ie = Math.floor(m / 36) / 5 * 255, we = Math.floor((c = m % 36) / 6) / 5 * 255, $e = c % 6 / 5 * 255;
  return [ie, we, $e];
};
convert$1.rgb.hex = function(m) {
  const ie = (((Math.round(m[0]) & 255) << 16) + ((Math.round(m[1]) & 255) << 8) + (Math.round(m[2]) & 255)).toString(16).toUpperCase();
  return "000000".slice(ie.length) + ie;
};
convert$1.hex.rgb = function(m) {
  const c = m.toString(16).match(/[a-f\d]{6}|[a-f\d]{3}/i);
  if (!c)
    return [0, 0, 0];
  let ie = c[0];
  c[0].length === 3 && (ie = [...ie].map((ne) => ne + ne).join(""));
  const we = Number.parseInt(ie, 16), $e = we >> 16 & 255, Me = we >> 8 & 255, Ze = we & 255;
  return [$e, Me, Ze];
};
convert$1.rgb.hcg = function(m) {
  const c = m[0] / 255, ie = m[1] / 255, we = m[2] / 255, $e = Math.max(Math.max(c, ie), we), Me = Math.min(Math.min(c, ie), we), Ze = $e - Me;
  let ne;
  const rr = Ze < 1 ? Me / (1 - Ze) : 0;
  return Ze <= 0 ? ne = 0 : $e === c ? ne = (ie - we) / Ze % 6 : $e === ie ? ne = 2 + (we - c) / Ze : ne = 4 + (c - ie) / Ze, ne /= 6, ne %= 1, [ne * 360, Ze * 100, rr * 100];
};
convert$1.hsl.hcg = function(m) {
  const c = m[1] / 100, ie = m[2] / 100, we = ie < 0.5 ? 2 * c * ie : 2 * c * (1 - ie);
  let $e = 0;
  return we < 1 && ($e = (ie - 0.5 * we) / (1 - we)), [m[0], we * 100, $e * 100];
};
convert$1.hsv.hcg = function(m) {
  const c = m[1] / 100, ie = m[2] / 100, we = c * ie;
  let $e = 0;
  return we < 1 && ($e = (ie - we) / (1 - we)), [m[0], we * 100, $e * 100];
};
convert$1.hcg.rgb = function(m) {
  const c = m[0] / 360, ie = m[1] / 100, we = m[2] / 100;
  if (ie === 0)
    return [we * 255, we * 255, we * 255];
  const $e = [0, 0, 0], Me = c % 1 * 6, Ze = Me % 1, ne = 1 - Ze;
  let rr = 0;
  switch (Math.floor(Me)) {
    case 0: {
      $e[0] = 1, $e[1] = Ze, $e[2] = 0;
      break;
    }
    case 1: {
      $e[0] = ne, $e[1] = 1, $e[2] = 0;
      break;
    }
    case 2: {
      $e[0] = 0, $e[1] = 1, $e[2] = Ze;
      break;
    }
    case 3: {
      $e[0] = 0, $e[1] = ne, $e[2] = 1;
      break;
    }
    case 4: {
      $e[0] = Ze, $e[1] = 0, $e[2] = 1;
      break;
    }
    default:
      $e[0] = 1, $e[1] = 0, $e[2] = ne;
  }
  return rr = (1 - ie) * we, [
    (ie * $e[0] + rr) * 255,
    (ie * $e[1] + rr) * 255,
    (ie * $e[2] + rr) * 255
  ];
};
convert$1.hcg.hsv = function(m) {
  const c = m[1] / 100, ie = m[2] / 100, we = c + ie * (1 - c);
  let $e = 0;
  return we > 0 && ($e = c / we), [m[0], $e * 100, we * 100];
};
convert$1.hcg.hsl = function(m) {
  const c = m[1] / 100, we = m[2] / 100 * (1 - c) + 0.5 * c;
  let $e = 0;
  return we > 0 && we < 0.5 ? $e = c / (2 * we) : we >= 0.5 && we < 1 && ($e = c / (2 * (1 - we))), [m[0], $e * 100, we * 100];
};
convert$1.hcg.hwb = function(m) {
  const c = m[1] / 100, ie = m[2] / 100, we = c + ie * (1 - c);
  return [m[0], (we - c) * 100, (1 - we) * 100];
};
convert$1.hwb.hcg = function(m) {
  const c = m[1] / 100, we = 1 - m[2] / 100, $e = we - c;
  let Me = 0;
  return $e < 1 && (Me = (we - $e) / (1 - $e)), [m[0], $e * 100, Me * 100];
};
convert$1.apple.rgb = function(m) {
  return [m[0] / 65535 * 255, m[1] / 65535 * 255, m[2] / 65535 * 255];
};
convert$1.rgb.apple = function(m) {
  return [m[0] / 255 * 65535, m[1] / 255 * 65535, m[2] / 255 * 65535];
};
convert$1.gray.rgb = function(m) {
  return [m[0] / 100 * 255, m[0] / 100 * 255, m[0] / 100 * 255];
};
convert$1.gray.hsl = function(m) {
  return [0, 0, m[0]];
};
convert$1.gray.hsv = convert$1.gray.hsl;
convert$1.gray.hwb = function(m) {
  return [0, 100, m[0]];
};
convert$1.gray.cmyk = function(m) {
  return [0, 0, 0, m[0]];
};
convert$1.gray.lab = function(m) {
  return [m[0], 0, 0];
};
convert$1.gray.hex = function(m) {
  const c = Math.round(m[0] / 100 * 255) & 255, we = ((c << 16) + (c << 8) + c).toString(16).toUpperCase();
  return "000000".slice(we.length) + we;
};
convert$1.rgb.gray = function(m) {
  return [(m[0] + m[1] + m[2]) / 3 / 255 * 100];
};
function buildGraph() {
  const m = {}, c = Object.keys(convert$1);
  for (let { length: ie } = c, we = 0; we < ie; we++)
    m[c[we]] = {
      distance: -1,
      parent: null
    };
  return m;
}
function deriveBFS(m) {
  const c = buildGraph(), ie = [m];
  for (c[m].distance = 0; ie.length > 0; ) {
    const we = ie.pop(), $e = Object.keys(convert$1[we]);
    for (let { length: Me } = $e, Ze = 0; Ze < Me; Ze++) {
      const ne = $e[Ze], rr = c[ne];
      rr.distance === -1 && (rr.distance = c[we].distance + 1, rr.parent = we, ie.unshift(ne));
    }
  }
  return c;
}
function link(m, c) {
  return function(ie) {
    return c(m(ie));
  };
}
function wrapConversion(m, c) {
  const ie = [c[m].parent, m];
  let we = convert$1[c[m].parent][m], $e = c[m].parent;
  for (; c[$e].parent; )
    ie.unshift(c[$e].parent), we = link(convert$1[c[$e].parent][$e], we), $e = c[$e].parent;
  return we.conversion = ie, we;
}
function route(m) {
  const c = deriveBFS(m), ie = {}, we = Object.keys(c);
  for (let { length: $e } = we, Me = 0; Me < $e; Me++) {
    const Ze = we[Me];
    c[Ze].parent !== null && (ie[Ze] = wrapConversion(Ze, c));
  }
  return ie;
}
const convert = {}, models = Object.keys(convert$1);
function wrapRaw(m) {
  const c = function(...ie) {
    const we = ie[0];
    return we == null ? we : (we.length > 1 && (ie = we), m(ie));
  };
  return "conversion" in m && (c.conversion = m.conversion), c;
}
function wrapRounded(m) {
  const c = function(...ie) {
    const we = ie[0];
    if (we == null)
      return we;
    we.length > 1 && (ie = we);
    const $e = m(ie);
    if (typeof $e == "object")
      for (let { length: Me } = $e, Ze = 0; Ze < Me; Ze++)
        $e[Ze] = Math.round($e[Ze]);
    return $e;
  };
  return "conversion" in m && (c.conversion = m.conversion), c;
}
for (const m of models) {
  convert[m] = {}, Object.defineProperty(convert[m], "channels", { value: convert$1[m].channels }), Object.defineProperty(convert[m], "labels", { value: convert$1[m].labels });
  const c = route(m), ie = Object.keys(c);
  for (const we of ie) {
    const $e = c[we];
    convert[m][we] = wrapRounded($e), convert[m][we].raw = wrapRaw($e);
  }
}
const skippedModels = [
  "keyword",
  "gray",
  "hex"
], hashedModelKeys = {};
for (const m of Object.keys(convert))
  hashedModelKeys[[...convert[m].labels].sort().join("")] = m;
const limiters = {};
function Color$1(m, c) {
  if (!(this instanceof Color$1))
    return new Color$1(m, c);
  if (c && c in skippedModels && (c = null), c && !(c in convert))
    throw new Error("Unknown model: " + c);
  let ie, we;
  if (m == null)
    this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;
  else if (m instanceof Color$1)
    this.model = m.model, this.color = [...m.color], this.valpha = m.valpha;
  else if (typeof m == "string") {
    const $e = cs.get(m);
    if ($e === null)
      throw new Error("Unable to parse color from string: " + m);
    this.model = $e.model, we = convert[this.model].channels, this.color = $e.value.slice(0, we), this.valpha = typeof $e.value[we] == "number" ? $e.value[we] : 1;
  } else if (m.length > 0) {
    this.model = c || "rgb", we = convert[this.model].channels;
    const $e = Array.prototype.slice.call(m, 0, we);
    this.color = zeroArray($e, we), this.valpha = typeof m[we] == "number" ? m[we] : 1;
  } else if (typeof m == "number")
    this.model = "rgb", this.color = [
      m >> 16 & 255,
      m >> 8 & 255,
      m & 255
    ], this.valpha = 1;
  else {
    this.valpha = 1;
    const $e = Object.keys(m);
    "alpha" in m && ($e.splice($e.indexOf("alpha"), 1), this.valpha = typeof m.alpha == "number" ? m.alpha : 0);
    const Me = $e.sort().join("");
    if (!(Me in hashedModelKeys))
      throw new Error("Unable to parse color from object: " + JSON.stringify(m));
    this.model = hashedModelKeys[Me];
    const { labels: Ze } = convert[this.model], ne = [];
    for (ie = 0; ie < Ze.length; ie++)
      ne.push(m[Ze[ie]]);
    this.color = zeroArray(ne);
  }
  if (limiters[this.model])
    for (we = convert[this.model].channels, ie = 0; ie < we; ie++) {
      const $e = limiters[this.model][ie];
      $e && (this.color[ie] = $e(this.color[ie]));
    }
  this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}
Color$1.prototype = {
  toString() {
    return this.string();
  },
  toJSON() {
    return this[this.model]();
  },
  string(m) {
    let c = this.model in cs.to ? this : this.rgb();
    c = c.round(typeof m == "number" ? m : 1);
    const ie = c.valpha === 1 ? c.color : [...c.color, this.valpha];
    return cs.to[c.model](...ie);
  },
  percentString(m) {
    const c = this.rgb().round(typeof m == "number" ? m : 1), ie = c.valpha === 1 ? c.color : [...c.color, this.valpha];
    return cs.to.rgb.percent(...ie);
  },
  array() {
    return this.valpha === 1 ? [...this.color] : [...this.color, this.valpha];
  },
  object() {
    const m = {}, { channels: c } = convert[this.model], { labels: ie } = convert[this.model];
    for (let we = 0; we < c; we++)
      m[ie[we]] = this.color[we];
    return this.valpha !== 1 && (m.alpha = this.valpha), m;
  },
  unitArray() {
    const m = this.rgb().color;
    return m[0] /= 255, m[1] /= 255, m[2] /= 255, this.valpha !== 1 && m.push(this.valpha), m;
  },
  unitObject() {
    const m = this.rgb().object();
    return m.r /= 255, m.g /= 255, m.b /= 255, this.valpha !== 1 && (m.alpha = this.valpha), m;
  },
  round(m) {
    return m = Math.max(m || 0, 0), new Color$1([...this.color.map(roundToPlace(m)), this.valpha], this.model);
  },
  alpha(m) {
    return m !== void 0 ? new Color$1([...this.color, Math.max(0, Math.min(1, m))], this.model) : this.valpha;
  },
  red: getset("rgb", 0, maxfn(255)),
  green: getset("rgb", 1, maxfn(255)),
  blue: getset("rgb", 2, maxfn(255)),
  hue: getset(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, (m) => (m % 360 + 360) % 360),
  saturationl: getset("hsl", 1, maxfn(100)),
  lightness: getset("hsl", 2, maxfn(100)),
  saturationv: getset("hsv", 1, maxfn(100)),
  value: getset("hsv", 2, maxfn(100)),
  chroma: getset("hcg", 1, maxfn(100)),
  gray: getset("hcg", 2, maxfn(100)),
  white: getset("hwb", 1, maxfn(100)),
  wblack: getset("hwb", 2, maxfn(100)),
  cyan: getset("cmyk", 0, maxfn(100)),
  magenta: getset("cmyk", 1, maxfn(100)),
  yellow: getset("cmyk", 2, maxfn(100)),
  black: getset("cmyk", 3, maxfn(100)),
  x: getset("xyz", 0, maxfn(95.047)),
  y: getset("xyz", 1, maxfn(100)),
  z: getset("xyz", 2, maxfn(108.833)),
  l: getset("lab", 0, maxfn(100)),
  a: getset("lab", 1),
  b: getset("lab", 2),
  keyword(m) {
    return m !== void 0 ? new Color$1(m) : convert[this.model].keyword(this.color);
  },
  hex(m) {
    return m !== void 0 ? new Color$1(m) : cs.to.hex(...this.rgb().round().color);
  },
  hexa(m) {
    if (m !== void 0)
      return new Color$1(m);
    const c = this.rgb().round().color;
    let ie = Math.round(this.valpha * 255).toString(16).toUpperCase();
    return ie.length === 1 && (ie = "0" + ie), cs.to.hex(...c) + ie;
  },
  rgbNumber() {
    const m = this.rgb().color;
    return (m[0] & 255) << 16 | (m[1] & 255) << 8 | m[2] & 255;
  },
  luminosity() {
    const m = this.rgb().color, c = [];
    for (const [ie, we] of m.entries()) {
      const $e = we / 255;
      c[ie] = $e <= 0.04045 ? $e / 12.92 : (($e + 0.055) / 1.055) ** 2.4;
    }
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  },
  contrast(m) {
    const c = this.luminosity(), ie = m.luminosity();
    return c > ie ? (c + 0.05) / (ie + 0.05) : (ie + 0.05) / (c + 0.05);
  },
  level(m) {
    const c = this.contrast(m);
    return c >= 7 ? "AAA" : c >= 4.5 ? "AA" : "";
  },
  isDark() {
    const m = this.rgb().color;
    return (m[0] * 2126 + m[1] * 7152 + m[2] * 722) / 1e4 < 128;
  },
  isLight() {
    return !this.isDark();
  },
  negate() {
    const m = this.rgb();
    for (let c = 0; c < 3; c++)
      m.color[c] = 255 - m.color[c];
    return m;
  },
  lighten(m) {
    const c = this.hsl();
    return c.color[2] += c.color[2] * m, c;
  },
  darken(m) {
    const c = this.hsl();
    return c.color[2] -= c.color[2] * m, c;
  },
  saturate(m) {
    const c = this.hsl();
    return c.color[1] += c.color[1] * m, c;
  },
  desaturate(m) {
    const c = this.hsl();
    return c.color[1] -= c.color[1] * m, c;
  },
  whiten(m) {
    const c = this.hwb();
    return c.color[1] += c.color[1] * m, c;
  },
  blacken(m) {
    const c = this.hwb();
    return c.color[2] += c.color[2] * m, c;
  },
  grayscale() {
    const m = this.rgb().color, c = m[0] * 0.3 + m[1] * 0.59 + m[2] * 0.11;
    return Color$1.rgb(c, c, c);
  },
  fade(m) {
    return this.alpha(this.valpha - this.valpha * m);
  },
  opaquer(m) {
    return this.alpha(this.valpha + this.valpha * m);
  },
  rotate(m) {
    const c = this.hsl();
    let ie = c.color[0];
    return ie = (ie + m) % 360, ie = ie < 0 ? 360 + ie : ie, c.color[0] = ie, c;
  },
  mix(m, c) {
    if (!m || !m.rgb)
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof m);
    const ie = m.rgb(), we = this.rgb(), $e = c === void 0 ? 0.5 : c, Me = 2 * $e - 1, Ze = ie.alpha() - we.alpha(), ne = ((Me * Ze === -1 ? Me : (Me + Ze) / (1 + Me * Ze)) + 1) / 2, rr = 1 - ne;
    return Color$1.rgb(
      ne * ie.red() + rr * we.red(),
      ne * ie.green() + rr * we.green(),
      ne * ie.blue() + rr * we.blue(),
      ie.alpha() * $e + we.alpha() * (1 - $e)
    );
  }
};
for (const m of Object.keys(convert)) {
  if (skippedModels.includes(m))
    continue;
  const { channels: c } = convert[m];
  Color$1.prototype[m] = function(...ie) {
    return this.model === m ? new Color$1(this) : ie.length > 0 ? new Color$1(ie, m) : new Color$1([...assertArray(convert[this.model][m].raw(this.color)), this.valpha], m);
  }, Color$1[m] = function(...ie) {
    let we = ie[0];
    return typeof we == "number" && (we = zeroArray(ie, c)), new Color$1(we, m);
  };
}
function roundTo(m, c) {
  return Number(m.toFixed(c));
}
function roundToPlace(m) {
  return function(c) {
    return roundTo(c, m);
  };
}
function getset(m, c, ie) {
  m = Array.isArray(m) ? m : [m];
  for (const we of m)
    (limiters[we] ||= [])[c] = ie;
  return m = m[0], function(we) {
    let $e;
    return we !== void 0 ? (ie && (we = ie(we)), $e = this[m](), $e.color[c] = we, $e) : ($e = this[m]().color[c], ie && ($e = ie($e)), $e);
  };
}
function maxfn(m) {
  return function(c) {
    return Math.max(0, Math.min(m, c));
  };
}
function assertArray(m) {
  return Array.isArray(m) ? m : [m];
}
function zeroArray(m, c) {
  for (let ie = 0; ie < c; ie++)
    typeof m[ie] != "number" && (m[ie] = 0);
  return m;
}
const _sfc_main$12 = /* @__PURE__ */ defineComponent({
  __name: "BxRichtextInput",
  props: /* @__PURE__ */ mergeModels({
    userAgentRichText: { type: Boolean, default: !0 },
    multiline: { type: Boolean, default: !0 },
    maxLength: { default: 1 / 0 },
    maxLengthPerLine: { default: 1 / 0 },
    maxLines: { default: 1 / 0 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {},
    selection: {
      required: !0
    },
    selectionModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["update:raw-text", "update:focus"], ["update:modelValue", "update:selection"]),
  setup(m, { expose: c, emit: ie }) {
    const we = useModel(m, "modelValue"), $e = ie, Me = useModel(m, "selection"), Ze = (Ar) => Ar.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), ne = (Ar) => {
      const Rr = (() => {
        if (Ar.customClass) {
          if (Ar.customClassUIRepresentation === "bold")
            return {
              "font-weight": 600
            };
          if (Ar.customClassUIRepresentation === "italic")
            return {
              "font-style": "italic"
            };
          if (Ar.customClassUIRepresentation === "textColor")
            return {
              color: Ar.customClassUIRepresentationColor ?? "#ff0000"
            };
          if (Ar.customClassUIRepresentation === "backgroundColor")
            return {
              "background-color": Ar.customClassUIRepresentationColor ?? "#ff0000",
              color: Color$1(Ar.customClassUIRepresentationColor ?? "#ff0000").isDark() ? "white" : "black"
            };
        } else
          return {};
      })();
      return {
        ...Object.fromEntries(
          Object.entries({
            ...Ar,
            ...(() => Ar.customClass === "list-item" ? {
              display: "block",
              marginLeft: "1em"
            } : {})()
          }).map(([Yr, Vr]) => {
            const Xr = Ze(Yr);
            return [
              Xr,
              (() => Xr === "font-size" && typeof Vr == "number" ? `${Vr}px` : Vr)()
            ];
          })
        ),
        ...Rr
      };
    }, rr = ref$1(
      groupFeatureByLinebreaks$1(typeof we.value == "string" ? [{ text: we.value, format: {} }] : we.value)
    );
    watch(rr, (Ar) => {
      const Rr = ungroupFeaturesDividedByLinebreaks(Ar);
      isEqual(Rr, we.value) || (we.value = Rr);
    }), watch(we, () => {
      const Ar = groupFeatureByLinebreaks$1(
        typeof we.value == "string" ? [{ text: we.value, format: {} }] : we.value
      );
      isEqual(Ar, we.value) || (rr.value = Ar);
    });
    const gr = ref$1(rr.value), or = computed(() => getRawText(gr.value));
    watch(
      or,
      () => {
        $e("update:raw-text", or.value);
      },
      { immediate: !0 }
    );
    const _r = ref$1(), Lr = ref$1(), Ir = ref$1(!1);
    return watch(
      Ir,
      () => {
        $e("update:focus", Ir.value);
      },
      { immediate: !0 }
    ), c({
      richTextInstance: Lr
    }), (Ar, Rr) => (openBlock(), createBlock(RichText, {
      ref_key: "richTextInstance",
      ref: Lr,
      selection: Me.value,
      "onUpdate:selection": Rr[0] || (Rr[0] = (Nr) => Me.value = Nr),
      value: rr.value,
      "onUpdate:value": Rr[1] || (Rr[1] = (Nr) => rr.value = Nr),
      "onUpdate:visibleValue": Rr[2] || (Rr[2] = (Nr) => gr.value = Nr),
      "render-feature-inline-style": ne,
      "user-agent-rich-text": Ar.userAgentRichText,
      "max-length": Ar.maxLength,
      "max-length-per-line": Ar.maxLengthPerLine,
      "max-lines": Ar.maxLines,
      multiline: Ar.multiline,
      "onUpdate:warningMessage": Rr[3] || (Rr[3] = (Nr) => _r.value = Nr),
      focus: Ir.value,
      "onUpdate:focus": Rr[4] || (Rr[4] = (Nr) => Ir.value = Nr),
      class: normalizeClass({ warning: !!_r.value })
    }, null, 8, ["selection", "value", "user-agent-rich-text", "max-length", "max-length-per-line", "max-lines", "multiline", "focus", "class"]));
  }
}), BxRichtextInput_vue_vue_type_style_index_0_scoped_5d2e9b73_lang = "", BxRichtextInput = /* @__PURE__ */ _export_sfc(_sfc_main$12, [["__scopeId", "data-v-5d2e9b73"]]), sides = ["top", "right", "bottom", "left"], alignments = ["start", "end"], placements = /* @__PURE__ */ sides.reduce((m, c) => m.concat(c, c + "-" + alignments[0], c + "-" + alignments[1]), []), min = Math.min, max = Math.max, round = Math.round, createCoords = (m) => ({
  x: m,
  y: m
}), oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(m, c, ie) {
  return max(m, min(c, ie));
}
function evaluate(m, c) {
  return typeof m == "function" ? m(c) : m;
}
function getSide(m) {
  return m.split("-")[0];
}
function getAlignment(m) {
  return m.split("-")[1];
}
function getOppositeAxis(m) {
  return m === "x" ? "y" : "x";
}
function getAxisLength(m) {
  return m === "y" ? "height" : "width";
}
function getSideAxis(m) {
  return ["top", "bottom"].includes(getSide(m)) ? "y" : "x";
}
function getAlignmentAxis(m) {
  return getOppositeAxis(getSideAxis(m));
}
function getAlignmentSides(m, c, ie) {
  ie === void 0 && (ie = !1);
  const we = getAlignment(m), $e = getAlignmentAxis(m), Me = getAxisLength($e);
  let Ze = $e === "x" ? we === (ie ? "end" : "start") ? "right" : "left" : we === "start" ? "bottom" : "top";
  return c.reference[Me] > c.floating[Me] && (Ze = getOppositePlacement(Ze)), [Ze, getOppositePlacement(Ze)];
}
function getExpandedPlacements(m) {
  const c = getOppositePlacement(m);
  return [getOppositeAlignmentPlacement(m), c, getOppositeAlignmentPlacement(c)];
}
function getOppositeAlignmentPlacement(m) {
  return m.replace(/start|end/g, (c) => oppositeAlignmentMap[c]);
}
function getSideList(m, c, ie) {
  const we = ["left", "right"], $e = ["right", "left"], Me = ["top", "bottom"], Ze = ["bottom", "top"];
  switch (m) {
    case "top":
    case "bottom":
      return ie ? c ? $e : we : c ? we : $e;
    case "left":
    case "right":
      return c ? Me : Ze;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(m, c, ie, we) {
  const $e = getAlignment(m);
  let Me = getSideList(getSide(m), ie === "start", we);
  return $e && (Me = Me.map((Ze) => Ze + "-" + $e), c && (Me = Me.concat(Me.map(getOppositeAlignmentPlacement)))), Me;
}
function getOppositePlacement(m) {
  return m.replace(/left|right|bottom|top/g, (c) => oppositeSideMap[c]);
}
function expandPaddingObject(m) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...m
  };
}
function getPaddingObject(m) {
  return typeof m != "number" ? expandPaddingObject(m) : {
    top: m,
    right: m,
    bottom: m,
    left: m
  };
}
function rectToClientRect(m) {
  const {
    x: c,
    y: ie,
    width: we,
    height: $e
  } = m;
  return {
    width: we,
    height: $e,
    top: ie,
    left: c,
    right: c + we,
    bottom: ie + $e,
    x: c,
    y: ie
  };
}
function computeCoordsFromPlacement(m, c, ie) {
  let {
    reference: we,
    floating: $e
  } = m;
  const Me = getSideAxis(c), Ze = getAlignmentAxis(c), ne = getAxisLength(Ze), rr = getSide(c), gr = Me === "y", or = we.x + we.width / 2 - $e.width / 2, _r = we.y + we.height / 2 - $e.height / 2, Lr = we[ne] / 2 - $e[ne] / 2;
  let Ir;
  switch (rr) {
    case "top":
      Ir = {
        x: or,
        y: we.y - $e.height
      };
      break;
    case "bottom":
      Ir = {
        x: or,
        y: we.y + we.height
      };
      break;
    case "right":
      Ir = {
        x: we.x + we.width,
        y: _r
      };
      break;
    case "left":
      Ir = {
        x: we.x - $e.width,
        y: _r
      };
      break;
    default:
      Ir = {
        x: we.x,
        y: we.y
      };
  }
  switch (getAlignment(c)) {
    case "start":
      Ir[Ze] -= Lr * (ie && gr ? -1 : 1);
      break;
    case "end":
      Ir[Ze] += Lr * (ie && gr ? -1 : 1);
      break;
  }
  return Ir;
}
const computePosition$1 = async (m, c, ie) => {
  const {
    placement: we = "bottom",
    strategy: $e = "absolute",
    middleware: Me = [],
    platform: Ze
  } = ie, ne = Me.filter(Boolean), rr = await (Ze.isRTL == null ? void 0 : Ze.isRTL(c));
  let gr = await Ze.getElementRects({
    reference: m,
    floating: c,
    strategy: $e
  }), {
    x: or,
    y: _r
  } = computeCoordsFromPlacement(gr, we, rr), Lr = we, Ir = {}, Ar = 0;
  for (let Rr = 0; Rr < ne.length; Rr++) {
    const {
      name: Nr,
      fn: Yr
    } = ne[Rr], {
      x: Vr,
      y: Xr,
      data: Wr,
      reset: si
    } = await Yr({
      x: or,
      y: _r,
      initialPlacement: we,
      placement: Lr,
      strategy: $e,
      middlewareData: Ir,
      rects: gr,
      platform: Ze,
      elements: {
        reference: m,
        floating: c
      }
    });
    or = Vr ?? or, _r = Xr ?? _r, Ir = {
      ...Ir,
      [Nr]: {
        ...Ir[Nr],
        ...Wr
      }
    }, si && Ar <= 50 && (Ar++, typeof si == "object" && (si.placement && (Lr = si.placement), si.rects && (gr = si.rects === !0 ? await Ze.getElementRects({
      reference: m,
      floating: c,
      strategy: $e
    }) : si.rects), {
      x: or,
      y: _r
    } = computeCoordsFromPlacement(gr, Lr, rr)), Rr = -1);
  }
  return {
    x: or,
    y: _r,
    placement: Lr,
    strategy: $e,
    middlewareData: Ir
  };
};
async function detectOverflow(m, c) {
  var ie;
  c === void 0 && (c = {});
  const {
    x: we,
    y: $e,
    platform: Me,
    rects: Ze,
    elements: ne,
    strategy: rr
  } = m, {
    boundary: gr = "clippingAncestors",
    rootBoundary: or = "viewport",
    elementContext: _r = "floating",
    altBoundary: Lr = !1,
    padding: Ir = 0
  } = evaluate(c, m), Ar = getPaddingObject(Ir), Nr = ne[Lr ? _r === "floating" ? "reference" : "floating" : _r], Yr = rectToClientRect(await Me.getClippingRect({
    element: (ie = await (Me.isElement == null ? void 0 : Me.isElement(Nr))) == null || ie ? Nr : Nr.contextElement || await (Me.getDocumentElement == null ? void 0 : Me.getDocumentElement(ne.floating)),
    boundary: gr,
    rootBoundary: or,
    strategy: rr
  })), Vr = _r === "floating" ? {
    x: we,
    y: $e,
    width: Ze.floating.width,
    height: Ze.floating.height
  } : Ze.reference, Xr = await (Me.getOffsetParent == null ? void 0 : Me.getOffsetParent(ne.floating)), Wr = await (Me.isElement == null ? void 0 : Me.isElement(Xr)) ? await (Me.getScale == null ? void 0 : Me.getScale(Xr)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, si = rectToClientRect(Me.convertOffsetParentRelativeRectToViewportRelativeRect ? await Me.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: ne,
    rect: Vr,
    offsetParent: Xr,
    strategy: rr
  }) : Vr);
  return {
    top: (Yr.top - si.top + Ar.top) / Wr.y,
    bottom: (si.bottom - Yr.bottom + Ar.bottom) / Wr.y,
    left: (Yr.left - si.left + Ar.left) / Wr.x,
    right: (si.right - Yr.right + Ar.right) / Wr.x
  };
}
const arrow = (m) => ({
  name: "arrow",
  options: m,
  async fn(c) {
    const {
      x: ie,
      y: we,
      placement: $e,
      rects: Me,
      platform: Ze,
      elements: ne,
      middlewareData: rr
    } = c, {
      element: gr,
      padding: or = 0
    } = evaluate(m, c) || {};
    if (gr == null)
      return {};
    const _r = getPaddingObject(or), Lr = {
      x: ie,
      y: we
    }, Ir = getAlignmentAxis($e), Ar = getAxisLength(Ir), Rr = await Ze.getDimensions(gr), Nr = Ir === "y", Yr = Nr ? "top" : "left", Vr = Nr ? "bottom" : "right", Xr = Nr ? "clientHeight" : "clientWidth", Wr = Me.reference[Ar] + Me.reference[Ir] - Lr[Ir] - Me.floating[Ar], si = Lr[Ir] - Me.reference[Ir], li = await (Ze.getOffsetParent == null ? void 0 : Ze.getOffsetParent(gr));
    let xi = li ? li[Xr] : 0;
    (!xi || !await (Ze.isElement == null ? void 0 : Ze.isElement(li))) && (xi = ne.floating[Xr] || Me.floating[Ar]);
    const di = Wr / 2 - si / 2, oi = xi / 2 - Rr[Ar] / 2 - 1, ci = min(_r[Yr], oi), vr = min(_r[Vr], oi), Ae = ci, ze = xi - Rr[Ar] - vr, Ue = xi / 2 - Rr[Ar] / 2 + di, tr = clamp(Ae, Ue, ze), lr = !rr.arrow && getAlignment($e) != null && Ue !== tr && Me.reference[Ar] / 2 - (Ue < Ae ? ci : vr) - Rr[Ar] / 2 < 0, pr = lr ? Ue < Ae ? Ue - Ae : Ue - ze : 0;
    return {
      [Ir]: Lr[Ir] + pr,
      data: {
        [Ir]: tr,
        centerOffset: Ue - tr - pr,
        ...lr && {
          alignmentOffset: pr
        }
      },
      reset: lr
    };
  }
});
function getPlacementList(m, c, ie) {
  return (m ? [...ie.filter(($e) => getAlignment($e) === m), ...ie.filter(($e) => getAlignment($e) !== m)] : ie.filter(($e) => getSide($e) === $e)).filter(($e) => m ? getAlignment($e) === m || (c ? getOppositeAlignmentPlacement($e) !== $e : !1) : !0);
}
const autoPlacement$1 = function(m) {
  return m === void 0 && (m = {}), {
    name: "autoPlacement",
    options: m,
    async fn(c) {
      var ie, we, $e;
      const {
        rects: Me,
        middlewareData: Ze,
        placement: ne,
        platform: rr,
        elements: gr
      } = c, {
        crossAxis: or = !1,
        alignment: _r,
        allowedPlacements: Lr = placements,
        autoAlignment: Ir = !0,
        ...Ar
      } = evaluate(m, c), Rr = _r !== void 0 || Lr === placements ? getPlacementList(_r || null, Ir, Lr) : Lr, Nr = await detectOverflow(c, Ar), Yr = ((ie = Ze.autoPlacement) == null ? void 0 : ie.index) || 0, Vr = Rr[Yr];
      if (Vr == null)
        return {};
      const Xr = getAlignmentSides(Vr, Me, await (rr.isRTL == null ? void 0 : rr.isRTL(gr.floating)));
      if (ne !== Vr)
        return {
          reset: {
            placement: Rr[0]
          }
        };
      const Wr = [Nr[getSide(Vr)], Nr[Xr[0]], Nr[Xr[1]]], si = [...((we = Ze.autoPlacement) == null ? void 0 : we.overflows) || [], {
        placement: Vr,
        overflows: Wr
      }], li = Rr[Yr + 1];
      if (li)
        return {
          data: {
            index: Yr + 1,
            overflows: si
          },
          reset: {
            placement: li
          }
        };
      const xi = si.map((ci) => {
        const vr = getAlignment(ci.placement);
        return [ci.placement, vr && or ? ci.overflows.slice(0, 2).reduce((Ae, ze) => Ae + ze, 0) : ci.overflows[0], ci.overflows];
      }).sort((ci, vr) => ci[1] - vr[1]), oi = (($e = xi.filter((ci) => ci[2].slice(
        0,
        getAlignment(ci[0]) ? 2 : 3
      ).every((vr) => vr <= 0))[0]) == null ? void 0 : $e[0]) || xi[0][0];
      return oi !== ne ? {
        data: {
          index: Yr + 1,
          overflows: si
        },
        reset: {
          placement: oi
        }
      } : {};
    }
  };
}, flip = function(m) {
  return m === void 0 && (m = {}), {
    name: "flip",
    options: m,
    async fn(c) {
      var ie, we;
      const {
        placement: $e,
        middlewareData: Me,
        rects: Ze,
        initialPlacement: ne,
        platform: rr,
        elements: gr
      } = c, {
        mainAxis: or = !0,
        crossAxis: _r = !0,
        fallbackPlacements: Lr,
        fallbackStrategy: Ir = "bestFit",
        fallbackAxisSideDirection: Ar = "none",
        flipAlignment: Rr = !0,
        ...Nr
      } = evaluate(m, c);
      if ((ie = Me.arrow) != null && ie.alignmentOffset)
        return {};
      const Yr = getSide($e), Vr = getSideAxis(ne), Xr = getSide(ne) === ne, Wr = await (rr.isRTL == null ? void 0 : rr.isRTL(gr.floating)), si = Lr || (Xr || !Rr ? [getOppositePlacement(ne)] : getExpandedPlacements(ne)), li = Ar !== "none";
      !Lr && li && si.push(...getOppositeAxisPlacements(ne, Rr, Ar, Wr));
      const xi = [ne, ...si], di = await detectOverflow(c, Nr), oi = [];
      let ci = ((we = Me.flip) == null ? void 0 : we.overflows) || [];
      if (or && oi.push(di[Yr]), _r) {
        const Ue = getAlignmentSides($e, Ze, Wr);
        oi.push(di[Ue[0]], di[Ue[1]]);
      }
      if (ci = [...ci, {
        placement: $e,
        overflows: oi
      }], !oi.every((Ue) => Ue <= 0)) {
        var vr, Ae;
        const Ue = (((vr = Me.flip) == null ? void 0 : vr.index) || 0) + 1, tr = xi[Ue];
        if (tr)
          return {
            data: {
              index: Ue,
              overflows: ci
            },
            reset: {
              placement: tr
            }
          };
        let lr = (Ae = ci.filter((pr) => pr.overflows[0] <= 0).sort((pr, br) => pr.overflows[1] - br.overflows[1])[0]) == null ? void 0 : Ae.placement;
        if (!lr)
          switch (Ir) {
            case "bestFit": {
              var ze;
              const pr = (ze = ci.filter((br) => {
                if (li) {
                  const nr = getSideAxis(br.placement);
                  return nr === Vr || nr === "y";
                }
                return !0;
              }).map((br) => [br.placement, br.overflows.filter((nr) => nr > 0).reduce((nr, Pe) => nr + Pe, 0)]).sort((br, nr) => br[1] - nr[1])[0]) == null ? void 0 : ze[0];
              pr && (lr = pr);
              break;
            }
            case "initialPlacement":
              lr = ne;
              break;
          }
        if ($e !== lr)
          return {
            reset: {
              placement: lr
            }
          };
      }
      return {};
    }
  };
};
function getSideOffsets(m, c) {
  return {
    top: m.top - c.height,
    right: m.right - c.width,
    bottom: m.bottom - c.height,
    left: m.left - c.width
  };
}
function isAnySideFullyClipped(m) {
  return sides.some((c) => m[c] >= 0);
}
const hide = function(m) {
  return m === void 0 && (m = {}), {
    name: "hide",
    options: m,
    async fn(c) {
      const {
        rects: ie
      } = c, {
        strategy: we = "referenceHidden",
        ...$e
      } = evaluate(m, c);
      switch (we) {
        case "referenceHidden": {
          const Me = await detectOverflow(c, {
            ...$e,
            elementContext: "reference"
          }), Ze = getSideOffsets(Me, ie.reference);
          return {
            data: {
              referenceHiddenOffsets: Ze,
              referenceHidden: isAnySideFullyClipped(Ze)
            }
          };
        }
        case "escaped": {
          const Me = await detectOverflow(c, {
            ...$e,
            altBoundary: !0
          }), Ze = getSideOffsets(Me, ie.floating);
          return {
            data: {
              escapedOffsets: Ze,
              escaped: isAnySideFullyClipped(Ze)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
function getBoundingRect(m) {
  const c = min(...m.map((Me) => Me.left)), ie = min(...m.map((Me) => Me.top)), we = max(...m.map((Me) => Me.right)), $e = max(...m.map((Me) => Me.bottom));
  return {
    x: c,
    y: ie,
    width: we - c,
    height: $e - ie
  };
}
function getRectsByLine(m) {
  const c = m.slice().sort(($e, Me) => $e.y - Me.y), ie = [];
  let we = null;
  for (let $e = 0; $e < c.length; $e++) {
    const Me = c[$e];
    !we || Me.y - we.y > we.height / 2 ? ie.push([Me]) : ie[ie.length - 1].push(Me), we = Me;
  }
  return ie.map(($e) => rectToClientRect(getBoundingRect($e)));
}
const inline = function(m) {
  return m === void 0 && (m = {}), {
    name: "inline",
    options: m,
    async fn(c) {
      const {
        placement: ie,
        elements: we,
        rects: $e,
        platform: Me,
        strategy: Ze
      } = c, {
        padding: ne = 2,
        x: rr,
        y: gr
      } = evaluate(m, c), or = Array.from(await (Me.getClientRects == null ? void 0 : Me.getClientRects(we.reference)) || []), _r = getRectsByLine(or), Lr = rectToClientRect(getBoundingRect(or)), Ir = getPaddingObject(ne);
      function Ar() {
        if (_r.length === 2 && _r[0].left > _r[1].right && rr != null && gr != null)
          return _r.find((Nr) => rr > Nr.left - Ir.left && rr < Nr.right + Ir.right && gr > Nr.top - Ir.top && gr < Nr.bottom + Ir.bottom) || Lr;
        if (_r.length >= 2) {
          if (getSideAxis(ie) === "y") {
            const ci = _r[0], vr = _r[_r.length - 1], Ae = getSide(ie) === "top", ze = ci.top, Ue = vr.bottom, tr = Ae ? ci.left : vr.left, lr = Ae ? ci.right : vr.right, pr = lr - tr, br = Ue - ze;
            return {
              top: ze,
              bottom: Ue,
              left: tr,
              right: lr,
              width: pr,
              height: br,
              x: tr,
              y: ze
            };
          }
          const Nr = getSide(ie) === "left", Yr = max(..._r.map((ci) => ci.right)), Vr = min(..._r.map((ci) => ci.left)), Xr = _r.filter((ci) => Nr ? ci.left === Vr : ci.right === Yr), Wr = Xr[0].top, si = Xr[Xr.length - 1].bottom, li = Vr, xi = Yr, di = xi - li, oi = si - Wr;
          return {
            top: Wr,
            bottom: si,
            left: li,
            right: xi,
            width: di,
            height: oi,
            x: li,
            y: Wr
          };
        }
        return Lr;
      }
      const Rr = await Me.getElementRects({
        reference: {
          getBoundingClientRect: Ar
        },
        floating: we.floating,
        strategy: Ze
      });
      return $e.reference.x !== Rr.reference.x || $e.reference.y !== Rr.reference.y || $e.reference.width !== Rr.reference.width || $e.reference.height !== Rr.reference.height ? {
        reset: {
          rects: Rr
        }
      } : {};
    }
  };
};
async function convertValueToCoords(m, c) {
  const {
    placement: ie,
    platform: we,
    elements: $e
  } = m, Me = await (we.isRTL == null ? void 0 : we.isRTL($e.floating)), Ze = getSide(ie), ne = getAlignment(ie), rr = getSideAxis(ie) === "y", gr = ["left", "top"].includes(Ze) ? -1 : 1, or = Me && rr ? -1 : 1, _r = evaluate(c, m);
  let {
    mainAxis: Lr,
    crossAxis: Ir,
    alignmentAxis: Ar
  } = typeof _r == "number" ? {
    mainAxis: _r,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: _r.mainAxis || 0,
    crossAxis: _r.crossAxis || 0,
    alignmentAxis: _r.alignmentAxis
  };
  return ne && typeof Ar == "number" && (Ir = ne === "end" ? Ar * -1 : Ar), rr ? {
    x: Ir * or,
    y: Lr * gr
  } : {
    x: Lr * gr,
    y: Ir * or
  };
}
const offset$1 = function(m) {
  return m === void 0 && (m = 0), {
    name: "offset",
    options: m,
    async fn(c) {
      var ie, we;
      const {
        x: $e,
        y: Me,
        placement: Ze,
        middlewareData: ne
      } = c, rr = await convertValueToCoords(c, m);
      return Ze === ((ie = ne.offset) == null ? void 0 : ie.placement) && (we = ne.arrow) != null && we.alignmentOffset ? {} : {
        x: $e + rr.x,
        y: Me + rr.y,
        data: {
          ...rr,
          placement: Ze
        }
      };
    }
  };
}, shift$1 = function(m) {
  return m === void 0 && (m = {}), {
    name: "shift",
    options: m,
    async fn(c) {
      const {
        x: ie,
        y: we,
        placement: $e
      } = c, {
        mainAxis: Me = !0,
        crossAxis: Ze = !1,
        limiter: ne = {
          fn: (Nr) => {
            let {
              x: Yr,
              y: Vr
            } = Nr;
            return {
              x: Yr,
              y: Vr
            };
          }
        },
        ...rr
      } = evaluate(m, c), gr = {
        x: ie,
        y: we
      }, or = await detectOverflow(c, rr), _r = getSideAxis(getSide($e)), Lr = getOppositeAxis(_r);
      let Ir = gr[Lr], Ar = gr[_r];
      if (Me) {
        const Nr = Lr === "y" ? "top" : "left", Yr = Lr === "y" ? "bottom" : "right", Vr = Ir + or[Nr], Xr = Ir - or[Yr];
        Ir = clamp(Vr, Ir, Xr);
      }
      if (Ze) {
        const Nr = _r === "y" ? "top" : "left", Yr = _r === "y" ? "bottom" : "right", Vr = Ar + or[Nr], Xr = Ar - or[Yr];
        Ar = clamp(Vr, Ar, Xr);
      }
      const Rr = ne.fn({
        ...c,
        [Lr]: Ir,
        [_r]: Ar
      });
      return {
        ...Rr,
        data: {
          x: Rr.x - ie,
          y: Rr.y - we,
          enabled: {
            [Lr]: Me,
            [_r]: Ze
          }
        }
      };
    }
  };
}, limitShift = function(m) {
  return m === void 0 && (m = {}), {
    options: m,
    fn(c) {
      const {
        x: ie,
        y: we,
        placement: $e,
        rects: Me,
        middlewareData: Ze
      } = c, {
        offset: ne = 0,
        mainAxis: rr = !0,
        crossAxis: gr = !0
      } = evaluate(m, c), or = {
        x: ie,
        y: we
      }, _r = getSideAxis($e), Lr = getOppositeAxis(_r);
      let Ir = or[Lr], Ar = or[_r];
      const Rr = evaluate(ne, c), Nr = typeof Rr == "number" ? {
        mainAxis: Rr,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...Rr
      };
      if (rr) {
        const Xr = Lr === "y" ? "height" : "width", Wr = Me.reference[Lr] - Me.floating[Xr] + Nr.mainAxis, si = Me.reference[Lr] + Me.reference[Xr] - Nr.mainAxis;
        Ir < Wr ? Ir = Wr : Ir > si && (Ir = si);
      }
      if (gr) {
        var Yr, Vr;
        const Xr = Lr === "y" ? "width" : "height", Wr = ["top", "left"].includes(getSide($e)), si = Me.reference[_r] - Me.floating[Xr] + (Wr && ((Yr = Ze.offset) == null ? void 0 : Yr[_r]) || 0) + (Wr ? 0 : Nr.crossAxis), li = Me.reference[_r] + Me.reference[Xr] + (Wr ? 0 : ((Vr = Ze.offset) == null ? void 0 : Vr[_r]) || 0) - (Wr ? Nr.crossAxis : 0);
        Ar < si ? Ar = si : Ar > li && (Ar = li);
      }
      return {
        [Lr]: Ir,
        [_r]: Ar
      };
    }
  };
}, size$1 = function(m) {
  return m === void 0 && (m = {}), {
    name: "size",
    options: m,
    async fn(c) {
      var ie, we;
      const {
        placement: $e,
        rects: Me,
        platform: Ze,
        elements: ne
      } = c, {
        apply: rr = () => {
        },
        ...gr
      } = evaluate(m, c), or = await detectOverflow(c, gr), _r = getSide($e), Lr = getAlignment($e), Ir = getSideAxis($e) === "y", {
        width: Ar,
        height: Rr
      } = Me.floating;
      let Nr, Yr;
      _r === "top" || _r === "bottom" ? (Nr = _r, Yr = Lr === (await (Ze.isRTL == null ? void 0 : Ze.isRTL(ne.floating)) ? "start" : "end") ? "left" : "right") : (Yr = _r, Nr = Lr === "end" ? "top" : "bottom");
      const Vr = Rr - or.top - or.bottom, Xr = Ar - or.left - or.right, Wr = min(Rr - or[Nr], Vr), si = min(Ar - or[Yr], Xr), li = !c.middlewareData.shift;
      let xi = Wr, di = si;
      if ((ie = c.middlewareData.shift) != null && ie.enabled.x && (di = Xr), (we = c.middlewareData.shift) != null && we.enabled.y && (xi = Vr), li && !Lr) {
        const ci = max(or.left, 0), vr = max(or.right, 0), Ae = max(or.top, 0), ze = max(or.bottom, 0);
        Ir ? di = Ar - 2 * (ci !== 0 || vr !== 0 ? ci + vr : max(or.left, or.right)) : xi = Rr - 2 * (Ae !== 0 || ze !== 0 ? Ae + ze : max(or.top, or.bottom));
      }
      await rr({
        ...c,
        availableWidth: di,
        availableHeight: xi
      });
      const oi = await Ze.getDimensions(ne.floating);
      return Ar !== oi.width || Rr !== oi.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function hasWindow() {
  return typeof window < "u";
}
function getNodeName(m) {
  return isNode$1(m) ? (m.nodeName || "").toLowerCase() : "#document";
}
function getWindow$1(m) {
  var c;
  return (m == null || (c = m.ownerDocument) == null ? void 0 : c.defaultView) || window;
}
function getDocumentElement(m) {
  var c;
  return (c = (isNode$1(m) ? m.ownerDocument : m.document) || window.document) == null ? void 0 : c.documentElement;
}
function isNode$1(m) {
  return hasWindow() ? m instanceof Node || m instanceof getWindow$1(m).Node : !1;
}
function isElement$1(m) {
  return hasWindow() ? m instanceof Element || m instanceof getWindow$1(m).Element : !1;
}
function isHTMLElement(m) {
  return hasWindow() ? m instanceof HTMLElement || m instanceof getWindow$1(m).HTMLElement : !1;
}
function isShadowRoot(m) {
  return !hasWindow() || typeof ShadowRoot > "u" ? !1 : m instanceof ShadowRoot || m instanceof getWindow$1(m).ShadowRoot;
}
function isOverflowElement(m) {
  const {
    overflow: c,
    overflowX: ie,
    overflowY: we,
    display: $e
  } = getComputedStyle$2(m);
  return /auto|scroll|overlay|hidden|clip/.test(c + we + ie) && !["inline", "contents"].includes($e);
}
function isTableElement(m) {
  return ["table", "td", "th"].includes(getNodeName(m));
}
function isTopLayer(m) {
  return [":popover-open", ":modal"].some((c) => {
    try {
      return m.matches(c);
    } catch {
      return !1;
    }
  });
}
function isContainingBlock(m) {
  const c = isWebKit(), ie = isElement$1(m) ? getComputedStyle$2(m) : m;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((we) => ie[we] ? ie[we] !== "none" : !1) || (ie.containerType ? ie.containerType !== "normal" : !1) || !c && (ie.backdropFilter ? ie.backdropFilter !== "none" : !1) || !c && (ie.filter ? ie.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((we) => (ie.willChange || "").includes(we)) || ["paint", "layout", "strict", "content"].some((we) => (ie.contain || "").includes(we));
}
function getContainingBlock(m) {
  let c = getParentNode(m);
  for (; isHTMLElement(c) && !isLastTraversableNode(c); ) {
    if (isContainingBlock(c))
      return c;
    if (isTopLayer(c))
      return null;
    c = getParentNode(c);
  }
  return null;
}
function isWebKit() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(m) {
  return ["html", "body", "#document"].includes(getNodeName(m));
}
function getComputedStyle$2(m) {
  return getWindow$1(m).getComputedStyle(m);
}
function getNodeScroll(m) {
  return isElement$1(m) ? {
    scrollLeft: m.scrollLeft,
    scrollTop: m.scrollTop
  } : {
    scrollLeft: m.scrollX,
    scrollTop: m.scrollY
  };
}
function getParentNode(m) {
  if (getNodeName(m) === "html")
    return m;
  const c = m.assignedSlot || m.parentNode || isShadowRoot(m) && m.host || getDocumentElement(m);
  return isShadowRoot(c) ? c.host : c;
}
function getNearestOverflowAncestor(m) {
  const c = getParentNode(m);
  return isLastTraversableNode(c) ? m.ownerDocument ? m.ownerDocument.body : m.body : isHTMLElement(c) && isOverflowElement(c) ? c : getNearestOverflowAncestor(c);
}
function getOverflowAncestors(m, c, ie) {
  var we;
  c === void 0 && (c = []), ie === void 0 && (ie = !0);
  const $e = getNearestOverflowAncestor(m), Me = $e === ((we = m.ownerDocument) == null ? void 0 : we.body), Ze = getWindow$1($e);
  if (Me) {
    const ne = getFrameElement(Ze);
    return c.concat(Ze, Ze.visualViewport || [], isOverflowElement($e) ? $e : [], ne && ie ? getOverflowAncestors(ne) : []);
  }
  return c.concat($e, getOverflowAncestors($e, [], ie));
}
function getFrameElement(m) {
  return m.parent && Object.getPrototypeOf(m.parent) ? m.frameElement : null;
}
function getCssDimensions(m) {
  const c = getComputedStyle$2(m);
  let ie = parseFloat(c.width) || 0, we = parseFloat(c.height) || 0;
  const $e = isHTMLElement(m), Me = $e ? m.offsetWidth : ie, Ze = $e ? m.offsetHeight : we, ne = round(ie) !== Me || round(we) !== Ze;
  return ne && (ie = Me, we = Ze), {
    width: ie,
    height: we,
    $: ne
  };
}
function unwrapElement$1(m) {
  return isElement$1(m) ? m : m.contextElement;
}
function getScale(m) {
  const c = unwrapElement$1(m);
  if (!isHTMLElement(c))
    return createCoords(1);
  const ie = c.getBoundingClientRect(), {
    width: we,
    height: $e,
    $: Me
  } = getCssDimensions(c);
  let Ze = (Me ? round(ie.width) : ie.width) / we, ne = (Me ? round(ie.height) : ie.height) / $e;
  return (!Ze || !Number.isFinite(Ze)) && (Ze = 1), (!ne || !Number.isFinite(ne)) && (ne = 1), {
    x: Ze,
    y: ne
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(m) {
  const c = getWindow$1(m);
  return !isWebKit() || !c.visualViewport ? noOffsets : {
    x: c.visualViewport.offsetLeft,
    y: c.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(m, c, ie) {
  return c === void 0 && (c = !1), !ie || c && ie !== getWindow$1(m) ? !1 : c;
}
function getBoundingClientRect(m, c, ie, we) {
  c === void 0 && (c = !1), ie === void 0 && (ie = !1);
  const $e = m.getBoundingClientRect(), Me = unwrapElement$1(m);
  let Ze = createCoords(1);
  c && (we ? isElement$1(we) && (Ze = getScale(we)) : Ze = getScale(m));
  const ne = shouldAddVisualOffsets(Me, ie, we) ? getVisualOffsets(Me) : createCoords(0);
  let rr = ($e.left + ne.x) / Ze.x, gr = ($e.top + ne.y) / Ze.y, or = $e.width / Ze.x, _r = $e.height / Ze.y;
  if (Me) {
    const Lr = getWindow$1(Me), Ir = we && isElement$1(we) ? getWindow$1(we) : we;
    let Ar = Lr, Rr = getFrameElement(Ar);
    for (; Rr && we && Ir !== Ar; ) {
      const Nr = getScale(Rr), Yr = Rr.getBoundingClientRect(), Vr = getComputedStyle$2(Rr), Xr = Yr.left + (Rr.clientLeft + parseFloat(Vr.paddingLeft)) * Nr.x, Wr = Yr.top + (Rr.clientTop + parseFloat(Vr.paddingTop)) * Nr.y;
      rr *= Nr.x, gr *= Nr.y, or *= Nr.x, _r *= Nr.y, rr += Xr, gr += Wr, Ar = getWindow$1(Rr), Rr = getFrameElement(Ar);
    }
  }
  return rectToClientRect({
    width: or,
    height: _r,
    x: rr,
    y: gr
  });
}
function getWindowScrollBarX(m, c) {
  const ie = getNodeScroll(m).scrollLeft;
  return c ? c.left + ie : getBoundingClientRect(getDocumentElement(m)).left + ie;
}
function getHTMLOffset(m, c, ie) {
  ie === void 0 && (ie = !1);
  const we = m.getBoundingClientRect(), $e = we.left + c.scrollLeft - (ie ? 0 : getWindowScrollBarX(m, we)), Me = we.top + c.scrollTop;
  return {
    x: $e,
    y: Me
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(m) {
  let {
    elements: c,
    rect: ie,
    offsetParent: we,
    strategy: $e
  } = m;
  const Me = $e === "fixed", Ze = getDocumentElement(we), ne = c ? isTopLayer(c.floating) : !1;
  if (we === Ze || ne && Me)
    return ie;
  let rr = {
    scrollLeft: 0,
    scrollTop: 0
  }, gr = createCoords(1);
  const or = createCoords(0), _r = isHTMLElement(we);
  if ((_r || !_r && !Me) && ((getNodeName(we) !== "body" || isOverflowElement(Ze)) && (rr = getNodeScroll(we)), isHTMLElement(we))) {
    const Ir = getBoundingClientRect(we);
    gr = getScale(we), or.x = Ir.x + we.clientLeft, or.y = Ir.y + we.clientTop;
  }
  const Lr = Ze && !_r && !Me ? getHTMLOffset(Ze, rr, !0) : createCoords(0);
  return {
    width: ie.width * gr.x,
    height: ie.height * gr.y,
    x: ie.x * gr.x - rr.scrollLeft * gr.x + or.x + Lr.x,
    y: ie.y * gr.y - rr.scrollTop * gr.y + or.y + Lr.y
  };
}
function getClientRects(m) {
  return Array.from(m.getClientRects());
}
function getDocumentRect(m) {
  const c = getDocumentElement(m), ie = getNodeScroll(m), we = m.ownerDocument.body, $e = max(c.scrollWidth, c.clientWidth, we.scrollWidth, we.clientWidth), Me = max(c.scrollHeight, c.clientHeight, we.scrollHeight, we.clientHeight);
  let Ze = -ie.scrollLeft + getWindowScrollBarX(m);
  const ne = -ie.scrollTop;
  return getComputedStyle$2(we).direction === "rtl" && (Ze += max(c.clientWidth, we.clientWidth) - $e), {
    width: $e,
    height: Me,
    x: Ze,
    y: ne
  };
}
function getViewportRect(m, c) {
  const ie = getWindow$1(m), we = getDocumentElement(m), $e = ie.visualViewport;
  let Me = we.clientWidth, Ze = we.clientHeight, ne = 0, rr = 0;
  if ($e) {
    Me = $e.width, Ze = $e.height;
    const gr = isWebKit();
    (!gr || gr && c === "fixed") && (ne = $e.offsetLeft, rr = $e.offsetTop);
  }
  return {
    width: Me,
    height: Ze,
    x: ne,
    y: rr
  };
}
function getInnerBoundingClientRect(m, c) {
  const ie = getBoundingClientRect(m, !0, c === "fixed"), we = ie.top + m.clientTop, $e = ie.left + m.clientLeft, Me = isHTMLElement(m) ? getScale(m) : createCoords(1), Ze = m.clientWidth * Me.x, ne = m.clientHeight * Me.y, rr = $e * Me.x, gr = we * Me.y;
  return {
    width: Ze,
    height: ne,
    x: rr,
    y: gr
  };
}
function getClientRectFromClippingAncestor(m, c, ie) {
  let we;
  if (c === "viewport")
    we = getViewportRect(m, ie);
  else if (c === "document")
    we = getDocumentRect(getDocumentElement(m));
  else if (isElement$1(c))
    we = getInnerBoundingClientRect(c, ie);
  else {
    const $e = getVisualOffsets(m);
    we = {
      x: c.x - $e.x,
      y: c.y - $e.y,
      width: c.width,
      height: c.height
    };
  }
  return rectToClientRect(we);
}
function hasFixedPositionAncestor(m, c) {
  const ie = getParentNode(m);
  return ie === c || !isElement$1(ie) || isLastTraversableNode(ie) ? !1 : getComputedStyle$2(ie).position === "fixed" || hasFixedPositionAncestor(ie, c);
}
function getClippingElementAncestors(m, c) {
  const ie = c.get(m);
  if (ie)
    return ie;
  let we = getOverflowAncestors(m, [], !1).filter((ne) => isElement$1(ne) && getNodeName(ne) !== "body"), $e = null;
  const Me = getComputedStyle$2(m).position === "fixed";
  let Ze = Me ? getParentNode(m) : m;
  for (; isElement$1(Ze) && !isLastTraversableNode(Ze); ) {
    const ne = getComputedStyle$2(Ze), rr = isContainingBlock(Ze);
    !rr && ne.position === "fixed" && ($e = null), (Me ? !rr && !$e : !rr && ne.position === "static" && !!$e && ["absolute", "fixed"].includes($e.position) || isOverflowElement(Ze) && !rr && hasFixedPositionAncestor(m, Ze)) ? we = we.filter((or) => or !== Ze) : $e = ne, Ze = getParentNode(Ze);
  }
  return c.set(m, we), we;
}
function getClippingRect(m) {
  let {
    element: c,
    boundary: ie,
    rootBoundary: we,
    strategy: $e
  } = m;
  const Ze = [...ie === "clippingAncestors" ? isTopLayer(c) ? [] : getClippingElementAncestors(c, this._c) : [].concat(ie), we], ne = Ze[0], rr = Ze.reduce((gr, or) => {
    const _r = getClientRectFromClippingAncestor(c, or, $e);
    return gr.top = max(_r.top, gr.top), gr.right = min(_r.right, gr.right), gr.bottom = min(_r.bottom, gr.bottom), gr.left = max(_r.left, gr.left), gr;
  }, getClientRectFromClippingAncestor(c, ne, $e));
  return {
    width: rr.right - rr.left,
    height: rr.bottom - rr.top,
    x: rr.left,
    y: rr.top
  };
}
function getDimensions(m) {
  const {
    width: c,
    height: ie
  } = getCssDimensions(m);
  return {
    width: c,
    height: ie
  };
}
function getRectRelativeToOffsetParent(m, c, ie) {
  const we = isHTMLElement(c), $e = getDocumentElement(c), Me = ie === "fixed", Ze = getBoundingClientRect(m, !0, Me, c);
  let ne = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const rr = createCoords(0);
  if (we || !we && !Me)
    if ((getNodeName(c) !== "body" || isOverflowElement($e)) && (ne = getNodeScroll(c)), we) {
      const Lr = getBoundingClientRect(c, !0, Me, c);
      rr.x = Lr.x + c.clientLeft, rr.y = Lr.y + c.clientTop;
    } else
      $e && (rr.x = getWindowScrollBarX($e));
  const gr = $e && !we && !Me ? getHTMLOffset($e, ne) : createCoords(0), or = Ze.left + ne.scrollLeft - rr.x - gr.x, _r = Ze.top + ne.scrollTop - rr.y - gr.y;
  return {
    x: or,
    y: _r,
    width: Ze.width,
    height: Ze.height
  };
}
function isStaticPositioned(m) {
  return getComputedStyle$2(m).position === "static";
}
function getTrueOffsetParent(m, c) {
  if (!isHTMLElement(m) || getComputedStyle$2(m).position === "fixed")
    return null;
  if (c)
    return c(m);
  let ie = m.offsetParent;
  return getDocumentElement(m) === ie && (ie = ie.ownerDocument.body), ie;
}
function getOffsetParent(m, c) {
  const ie = getWindow$1(m);
  if (isTopLayer(m))
    return ie;
  if (!isHTMLElement(m)) {
    let $e = getParentNode(m);
    for (; $e && !isLastTraversableNode($e); ) {
      if (isElement$1($e) && !isStaticPositioned($e))
        return $e;
      $e = getParentNode($e);
    }
    return ie;
  }
  let we = getTrueOffsetParent(m, c);
  for (; we && isTableElement(we) && isStaticPositioned(we); )
    we = getTrueOffsetParent(we, c);
  return we && isLastTraversableNode(we) && isStaticPositioned(we) && !isContainingBlock(we) ? ie : we || getContainingBlock(m) || ie;
}
const getElementRects = async function(m) {
  const c = this.getOffsetParent || getOffsetParent, ie = this.getDimensions, we = await ie(m.floating);
  return {
    reference: getRectRelativeToOffsetParent(m.reference, await c(m.floating), m.strategy),
    floating: {
      x: 0,
      y: 0,
      width: we.width,
      height: we.height
    }
  };
};
function isRTL(m) {
  return getComputedStyle$2(m).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement$1,
  isRTL
}, offset = offset$1, autoPlacement = autoPlacement$1, shift = shift$1, size = size$1, computePosition = (m, c, ie) => {
  const we = /* @__PURE__ */ new Map(), $e = {
    platform,
    ...ie
  }, Me = {
    ...$e.platform,
    _c: we
  };
  return computePosition$1(m, c, {
    ...$e,
    platform: Me
  });
};
function isComponentPublicInstance(m) {
  return m != null && typeof m == "object" && "$el" in m;
}
function unwrapElement(m) {
  if (isComponentPublicInstance(m)) {
    const c = m.$el;
    return isNode$1(c) && getNodeName(c) === "#comment" ? null : c;
  }
  return m;
}
function toValue$1(m) {
  return typeof m == "function" ? m() : unref(m);
}
function getDPR(m) {
  return typeof window > "u" ? 1 : (m.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function roundByDPR(m, c) {
  const ie = getDPR(m);
  return Math.round(c * ie) / ie;
}
function useFloating(m, c, ie) {
  ie === void 0 && (ie = {});
  const we = ie.whileElementsMounted, $e = computed(() => {
    var xi;
    return (xi = toValue$1(ie.open)) != null ? xi : !0;
  }), Me = computed(() => toValue$1(ie.middleware)), Ze = computed(() => {
    var xi;
    return (xi = toValue$1(ie.placement)) != null ? xi : "bottom";
  }), ne = computed(() => {
    var xi;
    return (xi = toValue$1(ie.strategy)) != null ? xi : "absolute";
  }), rr = computed(() => {
    var xi;
    return (xi = toValue$1(ie.transform)) != null ? xi : !0;
  }), gr = computed(() => unwrapElement(m.value)), or = computed(() => unwrapElement(c.value)), _r = ref$1(0), Lr = ref$1(0), Ir = ref$1(ne.value), Ar = ref$1(Ze.value), Rr = shallowRef({}), Nr = ref$1(!1), Yr = computed(() => {
    const xi = {
      position: Ir.value,
      left: "0",
      top: "0"
    };
    if (!or.value)
      return xi;
    const di = roundByDPR(or.value, _r.value), oi = roundByDPR(or.value, Lr.value);
    return rr.value ? {
      ...xi,
      transform: "translate(" + di + "px, " + oi + "px)",
      ...getDPR(or.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: Ir.value,
      left: di + "px",
      top: oi + "px"
    };
  });
  let Vr;
  function Xr() {
    if (gr.value == null || or.value == null)
      return;
    const xi = $e.value;
    computePosition(gr.value, or.value, {
      middleware: Me.value,
      placement: Ze.value,
      strategy: ne.value
    }).then((di) => {
      _r.value = di.x, Lr.value = di.y, Ir.value = di.strategy, Ar.value = di.placement, Rr.value = di.middlewareData, Nr.value = xi !== !1;
    });
  }
  function Wr() {
    typeof Vr == "function" && (Vr(), Vr = void 0);
  }
  function si() {
    if (Wr(), we === void 0) {
      Xr();
      return;
    }
    if (gr.value != null && or.value != null) {
      Vr = we(gr.value, or.value, Xr);
      return;
    }
  }
  function li() {
    $e.value || (Nr.value = !1);
  }
  return watch([Me, Ze, ne, $e], Xr, {
    flush: "sync"
  }), watch([gr, or], si, {
    flush: "sync"
  }), watch($e, li, {
    flush: "sync"
  }), getCurrentScope() && onScopeDispose(Wr), {
    x: shallowReadonly(_r),
    y: shallowReadonly(Lr),
    strategy: shallowReadonly(Ir),
    placement: shallowReadonly(Ar),
    middlewareData: shallowReadonly(Rr),
    isPositioned: shallowReadonly(Nr),
    floatingStyles: Yr,
    update: Xr
  };
}
const _hoisted_1$O = ["data-bx-popover-id"], _hoisted_2$A = ["data-origin", "data-placement"], _hoisted_3$p = { class: "popover-inner" }, _sfc_main$11 = /* @__PURE__ */ defineComponent({
  __name: "PopoverElement",
  props: {
    floatingElement: {},
    styles: {},
    customClasses: {},
    alignment: {},
    allowedPlacements: {},
    arrow: { type: Boolean },
    bxPopoverId: {},
    noPointerEvents: { type: Boolean, default: !1 },
    overflowVisible: { type: Boolean }
  },
  emits: ["close", "click-outside", "mouseenter", "mouseleave"],
  setup(m, { emit: c }) {
    const ie = m, we = c, $e = computed(() => ie.floatingElement), Me = ref$1(), { floatingStyles: Ze, placement: ne, middlewareData: rr } = useFloating($e, Me, {
      middleware: [
        autoPlacement({
          autoAlignment: !0,
          alignment: ie.alignment,
          allowedPlacements: ie.allowedPlacements
        }),
        shift({
          padding: 0
        }),
        size({
          apply({ availableWidth: Ar, availableHeight: Rr, elements: Nr }) {
            Nr.floating.style.setProperty("--min-width", `calc(${Ar}px - 70px)`), Nr.floating.style.setProperty("--min-height", `calc(${Rr}px - 70px)`);
          }
        })
      ]
    });
    function gr(Ar) {
      we("mouseenter", Ar);
    }
    function or(Ar) {
      we("mouseleave", Ar);
    }
    const _r = computed(() => {
      switch (ne.value) {
        case "right":
          return [0, 0.5];
        case "left":
          return [1, 0.5];
        case "top":
          return [0.5, 1];
        case "bottom":
          return [0.5, 0];
        case "bottom-end":
          return [1, 0];
        case "bottom-start":
          return [0, 0];
        case "top-end":
          return [1, 1];
        case "top-start":
          return [0, 1];
        case "right-end":
          return [0, 0];
        case "right-start":
          return [0, 1];
        case "left-end":
          return [1, 0];
        case "left-start":
          return [1, 1];
        default:
          return [0.5, 0.5];
      }
    }), Lr = (Ar) => {
      Ar.stopPropagation();
    }, Ir = () => {
      we("click-outside");
    };
    return (Ar, Rr) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["popover-wrapper", {
        ...Object.fromEntries(Ar.customClasses.map((Nr) => [Nr, !0])),
        "no-pointer-events": Ar.noPointerEvents
      }]),
      onClick: Ir,
      "data-bx-popover-id": Ar.bxPopoverId
    }, [
      createElementVNode("div", {
        ref_key: "popoverElementRef",
        ref: Me,
        class: "popover-element",
        style: normalizeStyle({ ...unref(Ze), ...Ar.styles }),
        onClick: Lr,
        onMouseenter: gr,
        onMouseleave: or
      }, [
        createElementVNode("div", {
          class: normalizeClass(["popover-frame-wrapper", { arrow: Ar.arrow, "overflow-visible": Ar.overflowVisible }]),
          "data-origin": _r.value,
          "data-placement": unref(ne),
          style: normalizeStyle({
            "--shift-left": "0px",
            "--shift-top": "0px",
            "transform-origin": `calc(${_r.value[0] * 100}% - var(--shift-left)) calc(${_r.value[1] * 100}% - var(--shift-top))`
          })
        }, [
          createElementVNode("div", {
            class: normalizeClass(["arrow-element", { ["placement-" + unref(ne)]: !0 }])
          }, Rr[0] || (Rr[0] = [
            createElementVNode("div", { class: "arrow-symbol" }, null, -1)
          ]), 2),
          createElementVNode("div", _hoisted_3$p, [
            renderSlot(Ar.$slots, "default", {}, void 0, !0)
          ])
        ], 14, _hoisted_2$A)
      ], 36)
    ], 10, _hoisted_1$O));
  }
}), PopoverElement_vue_vue_type_style_index_0_scoped_5f743c29_lang = "", PopoverElement = /* @__PURE__ */ _export_sfc(_sfc_main$11, [["__scopeId", "data-v-5f743c29"]]), _sfc_main$10 = /* @__PURE__ */ defineComponent({
  __name: "BxPopover",
  props: {
    show: { type: Boolean },
    trigger: {},
    customStyles: {},
    customClasses: {},
    darkenBackground: { type: Boolean, default: !0 },
    allowedPlacements: { default: () => [
      "top",
      "right",
      "bottom",
      "left",
      "top-start",
      "top-end",
      "right-start",
      "right-end",
      "bottom-start",
      "bottom-end",
      "left-start",
      "left-end"
    ] },
    arrow: { type: Boolean, default: !0 },
    leaveLazyness: { default: 200 },
    overflowVisible: { type: Boolean, default: !1 }
  },
  emits: ["update:show"],
  setup(m, { expose: c, emit: ie }) {
    const we = m, $e = ie, Me = useSlots(), Ze = nanoid(), { setSlotRef: ne, slotElements: rr, vNodes: gr } = useSlotVNodes(Me.trigger), or = ref$1(!1);
    watch(
      or,
      () => {
        or.value !== we.show && $e("update:show", or.value);
      },
      {
        immediate: !0
      }
    ), watch(
      () => we.show,
      () => {
        we.show !== or.value && (or.value = we.show);
      },
      { immediate: !0 }
    );
    const _r = computed(() => rr.value[0]), Lr = ref$1(!1), Ir = ref$1(!1);
    function Ar() {
      we.trigger === "click" && (or.value = !or.value);
    }
    function Rr() {
      Lr.value = !0;
    }
    function Nr() {
      Lr.value = !1;
    }
    watch(Lr, (Wr) => {
      we.trigger === "hover" && (Wr ? or.value = !0 : Yr());
    }), watch(Ir, (Wr) => {
      we.trigger === "hover" && (Wr || Yr());
    });
    function Yr() {
      setTimeout(() => {
        !Lr.value && !Ir.value && (or.value = !1);
      }, we.leaveLazyness);
    }
    let Vr = [];
    onUnmounted(() => {
      for (const Wr of Vr)
        Wr.removeEventListener("click", Ar), Wr.removeEventListener("mouseenter", Rr), Wr.removeEventListener("mouseleave", Nr);
    }), watch(rr, (Wr, si) => {
      if (si)
        for (const li of si)
          li.removeEventListener("click", Ar), li.removeEventListener("mouseenter", Rr), li.removeEventListener("mouseleave", Nr);
      for (const li of Wr)
        li.addEventListener("click", Ar), li.addEventListener("mouseenter", Rr), li.addEventListener("mouseleave", Nr), li.nodeType === Node.ELEMENT_NODE && (li.dataset.bxTargetPopoverId = Ze);
      Vr = Wr;
    });
    const Xr = window.bluepicPopupProvider;
    return onMounted(() => {
      const Wr = document.querySelector(GLOBAL_APP_WRAPPER_SELECTOR);
      !Wr || (Wr.classList.add("bluepic-popup-app-wrapper"), Wr.parentElement?.classList.add("bluepic-popup-body"));
    }), onUnmounted(() => {
      for (const Wr of rr.value)
        Wr.removeEventListener("click", Ar);
      console.log("BX POPOVER UNMOUNTED", Ze), Xr.popoverProviderRef.pull(Ze);
    }), watch(or, () => {
      or.value ? Xr.popoverProviderRef.push(
        Ze,
        () => h$1(
          PopoverElement,
          {
            floatingElement: _r.value,
            styles: {
              ...we.customStyles
            },
            customClasses: we.customClasses ?? [],
            onClose() {
              or.value = !1;
            },
            arrow: we.arrow,
            allowedPlacements: we.allowedPlacements,
            bxPopoverId: Ze,
            noPointerEvents: we.trigger === "hover" || we.trigger === "manual",
            overflowVisible: we.overflowVisible,
            onMouseenter() {
              Ir.value = !0;
            },
            onMouseleave() {
              Ir.value = !1;
            }
          },
          {
            default: () => Me.content()
          }
        ),
        {
          darkenBackground: we.darkenBackground,
          handleClickOutside() {
            we.trigger === "click" && (or.value = !1);
          }
        }
      ) : Xr.popoverProviderRef.pull(Ze);
    }), c({
      close() {
        or.value = !1;
      },
      show() {
        or.value = !0;
      },
      destroy() {
      }
    }), (Wr, si) => (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(gr), (li, xi) => (openBlock(), createBlock(resolveDynamicComponent(li), {
      ref_for: !0,
      ref: unref(ne)(xi)
    }, null, 512))), 256));
  }
}), BxPopover_vue_vue_type_style_index_0_scoped_6fc563ec_lang = "", BxPopover = /* @__PURE__ */ _export_sfc(_sfc_main$10, [["__scopeId", "data-v-6fc563ec"]]), _hoisted_1$N = ["onClick"], _hoisted_2$z = {
  key: 0,
  class: "icon-wrapper"
}, _hoisted_3$o = {
  key: 1,
  class: "icon-wrapper"
}, _hoisted_4$g = { key: 3 }, _hoisted_5$b = { class: "active-symbol" }, _sfc_main$$ = /* @__PURE__ */ defineComponent({
  __name: "BxMenu",
  props: {
    items: {},
    primary: { type: Boolean, default: !1 },
    secondary: { type: Boolean, default: !1 }
  },
  emits: ["action"],
  setup(m, { emit: c }) {
    const ie = c, we = useSlots();
    function $e(Me) {
      ie("action", Me);
    }
    return (Me, Ze) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-menu", { primary: Me.primary, secondary: Me.secondary }])
    }, [
      we["render-items"] ? renderSlot(Me.$slots, "render-items", {
        key: 0,
        items: Me.items
      }, void 0, !0) : (openBlock(!0), createElementBlock(Fragment, { key: 1 }, renderList(Me.items, (ne, rr) => (openBlock(), createElementBlock("div", {
        key: rr,
        onClick: (gr) => $e(ne),
        class: normalizeClass(["bx-menu__item", { active: ne.isActive === !0 }])
      }, [
        we["render-item-icon"] ? (openBlock(), createElementBlock("div", _hoisted_2$z, [
          renderSlot(Me.$slots, "render-item-icon", {
            item: ne,
            isActive: ne.isActive === !0
          }, void 0, !0)
        ])) : ne.icon ? (openBlock(), createElementBlock("div", _hoisted_3$o, [
          (openBlock(), createBlock(resolveDynamicComponent(ne.icon())))
        ])) : createCommentVNode("", !0),
        we["render-item-label"] ? renderSlot(Me.$slots, "render-item-label", {
          key: 2,
          item: ne,
          isActive: ne.isActive === !0
        }, void 0, !0) : (openBlock(), createElementBlock("span", _hoisted_4$g, toDisplayString(ne.label), 1)),
        createElementVNode("div", _hoisted_5$b, [
          we["render-item-active-symbol"] ? renderSlot(Me.$slots, "render-item-active-symbol", {
            key: 0,
            item: ne,
            isActive: ne.isActive === !0
          }, void 0, !0) : (openBlock(), createBlock(BxIcon, {
            key: 1,
            size: 14,
            style: normalizeStyle({ opacity: ne.isActive === !0 ? 1 : 0 })
          }, {
            default: withCtx(() => [
              createVNode(unref(CheckmarkOutline))
            ]),
            _: 2
          }, 1032, ["style"]))
        ])
      ], 10, _hoisted_1$N))), 128))
    ], 2));
  }
}), BxMenu_vue_vue_type_style_index_0_scoped_ca1b34cf_lang = "", BxMenu = /* @__PURE__ */ _export_sfc(_sfc_main$$, [["__scopeId", "data-v-ca1b34cf"]]);
function useElementBounding$1(m) {
  const c = ref$1(), ie = () => {
    m.value && (c.value = m.value.getBoundingClientRect());
  };
  onMounted(() => {
    ie(), window.addEventListener("resize", ie);
  });
  const we = new ResizeObserver(() => {
    ie();
  }), $e = new MutationObserver(() => {
    ie();
  }), Me = watch(m, (Ze, ne) => {
    Ze && !ne && (we.observe(Ze), $e.observe(Ze, {
      attributes: !0,
      childList: !0,
      subtree: !0
    }));
  });
  return onBeforeUnmount(() => {
    window.removeEventListener("resize", ie), Me(), we.disconnect(), $e.disconnect();
  }), {
    rect: c,
    width: computed(() => c.value?.width),
    height: computed(() => c.value?.height),
    x: computed(() => c.value?.x),
    y: computed(() => c.value?.y)
  };
}
const _hoisted_1$M = {
  key: 0,
  class: "prefix-wrapper"
}, _hoisted_2$y = {
  key: 1,
  class: "prefix-wrapper"
}, _hoisted_3$n = { class: "select-value" }, _hoisted_4$f = { class: "suffix-wrapper" }, iconSize = "24px", _sfc_main$_ = /* @__PURE__ */ defineComponent({
  __name: "BxSelect",
  props: /* @__PURE__ */ mergeModels({
    trigger: { default: "click" },
    options: {},
    disabled: { type: Boolean, default: !1 },
    placeholderActiveLabel: {}
  }, {
    modelValue: {
      required: !1
    },
    modelModifiers: {},
    show: { type: Boolean, required: !1, default: !1 },
    showModifiers: {}
  }),
  emits: ["update:modelValue", "update:show"],
  setup(m, { expose: c }) {
    const ie = m, we = useSlots(), $e = useModel(m, "modelValue"), Me = ref$1(), { width: Ze } = useElementBounding$1(Me);
    watchEffect(() => {
      console.log("bxSelectMainWidth", Ze.value);
    });
    const ne = ref$1(), rr = useModel(m, "show"), gr = computed(() => ie.options.find((Rr) => Rr.value === $e.value)?.label), or = computed(() => {
      const Ar = ie.options.find((Rr) => Rr.value === $e.value);
      if (!!Ar)
        return we["render-option-icon"] ? () => we["render-option-icon"]({ option: Ar, isActive: _r(Ar) }) : Ar.icon;
    });
    function _r(Ar) {
      return Ar.value === $e.value;
    }
    watch($e, () => {
      ne.value?.close();
    });
    const Lr = (Ar) => {
      const Rr = ie.options[Number(Ar.key)];
      Rr && ($e.value = Rr.value);
    };
    c({
      closePopover() {
        ne.value?.close();
      },
      showPopover() {
        ne.value?.show();
      }
    });
    const Ir = computed(() => ie.options.map((Ar, Rr) => ({
      label: Ar.label,
      key: Rr,
      icon: Ar.icon,
      isActive: _r(Ar)
    })));
    return (Ar, Rr) => (openBlock(), createElementBlock("div", {
      ref_key: "bxSelectMainRef",
      ref: Me,
      class: normalizeClass(["bx-select", { disabled: Ar.disabled }]),
      style: normalizeStyle({ "--icon-size": iconSize })
    }, [
      createVNode(BxPopover, {
        ref_key: "popoverRef",
        ref: ne,
        trigger: Ar.trigger,
        "allowed-placements": ["bottom", "top"],
        arrow: !1,
        "darken-background": !1,
        "custom-classes": ["bx-select-popover"],
        show: rr.value,
        "onUpdate:show": Rr[0] || (Rr[0] = (Nr) => rr.value = Nr)
      }, {
        trigger: withCtx(() => [
          we.trigger ? renderSlot(Ar.$slots, "trigger", { key: 0 }, void 0, !0) : (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(["select-trigger", { focus: rr.value }])
          }, [
            we.prefix ? (openBlock(), createElementBlock("div", _hoisted_1$M, [
              renderSlot(Ar.$slots, "prefix", {}, void 0, !0)
            ])) : or.value ? (openBlock(), createElementBlock("div", _hoisted_2$y, [
              (openBlock(), createBlock(resolveDynamicComponent(or.value)))
            ])) : createCommentVNode("", !0),
            createElementVNode("div", _hoisted_3$n, [
              createElementVNode("span", {
                class: normalizeClass({ placeholder: gr.value === void 0 })
              }, [
                we.label ? renderSlot(Ar.$slots, "label", {
                  key: 0,
                  label: gr.value ?? Ar.placeholderActiveLabel
                }, void 0, !0) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(gr.value ?? Ar.placeholderActiveLabel), 1)
                ], 64))
              ], 2)
            ]),
            createElementVNode("div", _hoisted_4$f, [
              we.suffix ? renderSlot(Ar.$slots, "suffix", { key: 0 }, void 0, !0) : (openBlock(), createBlock(BxIcon, {
                key: 1,
                size: 14
              }, {
                default: withCtx(() => [
                  createVNode(unref(ChevronDownOutline))
                ]),
                _: 1
              }))
            ])
          ], 2))
        ]),
        content: withCtx(() => [
          createVNode(BxMenu, {
            items: Ir.value,
            secondary: "",
            onAction: Lr,
            style: normalizeStyle({ width: `calc(${unref(Ze)}px - 8px)` })
          }, null, 8, ["items", "style"])
        ]),
        _: 3
      }, 8, ["trigger", "show"])
    ], 6));
  }
}), BxSelect_vue_vue_type_style_index_0_scoped_3f55a69c_lang = "", BxSelect_vue_vue_type_style_index_1_lang = "", BxSelect = /* @__PURE__ */ _export_sfc(_sfc_main$_, [["__scopeId", "data-v-3f55a69c"]]), _hoisted_1$L = { class: "tooltip-wrapper" }, _sfc_main$Z = /* @__PURE__ */ defineComponent({
  __name: "BxTooltip",
  props: /* @__PURE__ */ mergeModels({
    trigger: {},
    allowedPlacements: {},
    customPopoverClasses: {}
  }, {
    show: { type: Boolean, required: !1, default: !1 },
    showModifiers: {}
  }),
  emits: ["update:show"],
  setup(m) {
    const c = useModel(m, "show"), ie = m, we = useSlots(), $e = ref$1(), { setSlotRef: Me, slotElements: Ze, vNodes: ne } = useSlotVNodes(we.trigger);
    function rr(gr) {
    }
    return watch(Ze, () => {
      for (const gr of Ze.value)
        gr.addEventListener("click", rr);
    }), onUnmounted(() => {
      for (const gr of Ze.value)
        gr.removeEventListener("click", rr);
    }), (gr, or) => (openBlock(), createBlock(BxPopover, {
      ref_key: "popover",
      ref: $e,
      show: c.value,
      "onUpdate:show": or[0] || (or[0] = (_r) => c.value = _r),
      trigger: gr.trigger,
      "darken-background": !1,
      "allowed-placements": gr.allowedPlacements,
      "custom-classes": ["tooltip-popover", ...ie.customPopoverClasses ?? []],
      "overflow-visible": !0
    }, {
      trigger: withCtx(() => [
        renderSlot(gr.$slots, "trigger", {}, void 0, !0)
      ]),
      content: withCtx(() => [
        createElementVNode("div", _hoisted_1$L, [
          renderSlot(gr.$slots, "content", {}, void 0, !0)
        ])
      ]),
      _: 3
    }, 8, ["show", "trigger", "allowed-placements", "custom-classes"]));
  }
}), BxTooltip_vue_vue_type_style_index_0_scoped_0c1f2710_lang = "", BxTooltip_vue_vue_type_style_index_1_lang = "", BxTooltip = /* @__PURE__ */ _export_sfc(_sfc_main$Z, [["__scopeId", "data-v-0c1f2710"]]), _hoisted_1$K = {
  key: 0,
  class: "bx-input__prefix"
}, _hoisted_2$x = ["placeholder", "readonly"], _hoisted_3$m = ["readonly", "placeholder", "type"], _hoisted_4$e = {
  key: 1,
  class: "bx-input__suffix"
}, _hoisted_5$a = {
  key: 0,
  class: "bx-input__loading-wrapper"
}, _hoisted_6$7 = {
  key: 1,
  class: "bx-input__footer"
}, _hoisted_7$5 = {
  key: 0,
  class: "bx-input__clear"
}, _hoisted_8$4 = {
  key: 1,
  class: "bx-input__word-count"
}, _hoisted_9$4 = { class: "text-overflow-errors" }, _hoisted_10$4 = {
  key: 0,
  class: "text-err"
}, _hoisted_11$4 = { class: "overflow-label" }, _hoisted_12$3 = {
  key: 1,
  class: "text-err"
}, _hoisted_13$3 = { class: "overflow-label" }, _hoisted_14$3 = {
  key: 2,
  class: "text-err"
}, _hoisted_15$3 = { class: "index-label" }, _hoisted_16$3 = { class: "overflow-label" }, _sfc_main$Y = /* @__PURE__ */ defineComponent({
  __name: "BxInput",
  props: /* @__PURE__ */ mergeModels({
    size: { default: "medium" },
    loading: { type: Boolean, default: !1 },
    round: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    inputProps: { default: () => ({}) },
    placeholder: {},
    validator: {},
    maxLength: { default: 1 / 0 },
    maxLineLength: { default: 1 / 0 },
    maxLines: { default: 1 / 0 },
    showWordCount: { type: Boolean, default: !1 },
    type: { default: "text" },
    state: { default: "default" },
    clearable: { type: Boolean, default: !1 },
    resizeable: { type: Boolean, default: !0 },
    richtext: {},
    maxHeight: { default: "100px" },
    readonly: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: [String, Number, Boolean, Array], required: !1, default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["enter", "focus", "blur"], ["update:modelValue"]),
  setup(m, { expose: c, emit: ie }) {
    const we = m, $e = ie, Me = useSlots(), Ze = useModel(m, "modelValue"), ne = ref$1(Ze.value), rr = ref$1([]), gr = ref$1(0), or = ref$1(0), _r = computed(() => {
      if (rr.value.length > 0 || gr.value > 0 || or.value > 0)
        return {
          lineOverflows: rr.value.length > 0 ? rr.value : void 0,
          overlowingLines: gr.value > 0 ? gr.value : void 0,
          overflowingCharacters: or.value > 0 ? or.value : void 0
        };
    }), Lr = computed({
      get() {
        return _r.value !== void 0;
      },
      set(pr) {
      }
    }), Ir = computed(() => String(ne.value).split(`
`).slice(0, we.maxLines ?? 1 / 0).map((nr) => nr.slice(0, we.maxLineLength ?? 1 / 0)).join(`
`).slice(0, we.maxLength ?? 1 / 0));
    watch(Ze, (pr) => {
      pr !== Ir.value && (ne.value = pr);
    }), watch(ne, (pr) => {
      if (typeof pr == "object" && pr !== null)
        Ze.value = sliceRichText$1(pr, 0, we.maxLength);
      else {
        const nr = String(pr).split(`
`);
        Ze.value !== Ir.value && (Ze.value = Ir.value), we.maxLineLength !== 1 / 0 && we.maxLineLength !== null && (rr.value = nr.filter((Pe) => Pe.length > (we.maxLineLength ?? 1 / 0)).map((Pe) => ({ index: nr.indexOf(Pe), length: Pe.length }))), we.maxLines !== 1 / 0 && we.maxLines !== null && (gr.value = Math.max(0, String(pr).split(`
`).length - (we.maxLines ?? 1 / 0))), we.maxLength !== 1 / 0 && we.maxLength !== null && (or.value = String(pr).length - we.maxLength);
      }
    });
    const Ar = computed({
      get() {
        return getRawText(Rr.value);
      },
      set(pr) {
        we.richtext ? ne.value = [{ text: pr, format: {} }] : ne.value = pr;
      }
    }), Rr = computed({
      get() {
        return typeof ne.value == "string" ? [{ text: ne.value, format: {} }] : typeof ne.value == "boolean" ? [{ text: ne.value ? "true" : "false", format: {} }] : typeof ne.value == "number" ? [{ text: ne.value.toString(), format: {} }] : ne.value;
      },
      set(pr) {
        we.richtext ? ne.value = pr : ne.value = getRawText(pr);
      }
    }), Nr = ref$1(), Yr = ref$1(), Vr = ref$1(!1);
    watch(Vr, () => {
      Vr.value ? $e("focus") : $e("blur");
    });
    function Xr(pr) {
      Vr.value = !0;
    }
    function Wr(pr) {
      Vr.value = !1;
    }
    watch(Yr, (pr, br) => {
      pr && (br && (br.removeEventListener("focus", Xr), br.removeEventListener("blur", Wr)), pr.addEventListener("focus", Xr), pr.addEventListener("blur", Wr));
    });
    const si = () => {
      we.disabled || Yr.value?.focus();
    }, li = (pr) => {
      pr.key === "Enter" && $e("enter", pr);
    }, xi = ref$1(""), di = computed(() => {
      const pr = we.richtext ? xi.value : ne.value;
      return [...new Intl.Segmenter().segment(pr)].length;
    });
    function oi(pr) {
      return pr.en;
    }
    const ci = ref$1(), vr = ref$1({ start: 0, length: 0 }), Ae = computed({
      get() {
        const pr = Nr.value?.richTextInstance;
        if (!pr)
          return;
        const nr = pr.resolveFeatures(vr.value.start, vr.value.length).flat(), Pe = tr(nr);
        if (Pe !== void 0)
          return Pe === null ? "multiple" : ze.value.find((ur) => isEqual(ur.value, Pe))?.value;
      },
      set(pr) {
        const br = Nr.value?.richTextInstance;
        !br || pr !== "multiple" && (pr === void 0 ? br.applyFormat(vr.value.start, vr.value.length, {}) : (br.resolveFeatures(vr.value.start, vr.value.length), br.applyFormat(vr.value.start, vr.value.length, pr)), Ue.value.closePopover());
      }
    });
    watch(ci, () => {
      !ci.value || (vr.value = ci.value);
    });
    const ze = computed(() => we.richtext ? [
      {
        label: oi(we.richtext.noStyleLabel),
        value: void 0
      },
      ...we.richtext.options.map((pr, br) => ({
        label: pr.label,
        value: pr.style
      }))
    ] : []), Ue = ref$1();
    function tr(pr) {
      let br = !1, nr;
      for (const Pe of pr)
        if (!nr)
          nr = Pe.format;
        else if (!isEqual(nr, Pe.format)) {
          br = !0;
          break;
        }
      return br ? null : nr;
    }
    function lr() {
      we.richtext ? Rr.value = [{ text: "", format: {} }] : Ze.value = "";
    }
    return onUnmounted(() => {
      rr.value = [], gr.value = 0, or.value = 0;
    }), c({
      inputEelRef: Yr,
      setFocus(pr) {
        pr ? Yr.value?.focus() : Yr.value?.blur();
      }
    }), (pr, br) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-input", { readonly: pr.readonly }])
    }, [
      pr.richtext ? (openBlock(), createBlock(BxSelect, {
        key: 0,
        ref_key: "bxSelectRef",
        ref: Ue,
        class: "select-richtext",
        modelValue: Ae.value,
        "onUpdate:modelValue": br[0] || (br[0] = (nr) => Ae.value = nr),
        options: ze.value,
        disabled: !vr.value || vr.value.length === 0
      }, {
        label: withCtx(({ label: nr }) => [
          createTextVNode(toDisplayString(nr ?? "Multiple"), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "options", "disabled"])) : createCommentVNode("", !0),
      createElementVNode("div", {
        class: normalizeClass(["bx-input-wrapper", { focus: Vr.value, round: pr.round, ["size-" + pr.size]: pr.size, disabled: pr.disabled, "rich-text": pr.richtext, error: Lr.value }]),
        style: normalizeStyle({ "--max-height": pr.richtext ? `calc(${pr.maxHeight} - 48px)` : pr.maxHeight }),
        onClick: si
      }, [
        Me.prefix ? (openBlock(), createElementBlock("div", _hoisted_1$K, [
          renderSlot(pr.$slots, "prefix", {}, void 0, !0)
        ])) : createCommentVNode("", !0),
        createElementVNode("div", {
          class: normalizeClass(["bx-input__input", { "swiper-no-swiping": Vr.value }])
        }, [
          pr.richtext ? (openBlock(), createBlock(BxRichtextInput, {
            key: 0,
            ref_key: "bxRichTextInstance",
            ref: Nr,
            modelValue: Rr.value,
            "onUpdate:modelValue": br[1] || (br[1] = (nr) => Rr.value = nr),
            selection: ci.value,
            "onUpdate:selection": br[2] || (br[2] = (nr) => ci.value = nr),
            "raw-text": xi.value,
            "onUpdate:rawText": br[3] || (br[3] = (nr) => xi.value = nr),
            focus: Vr.value,
            "onUpdate:focus": br[4] || (br[4] = (nr) => Vr.value = nr)
          }, null, 8, ["modelValue", "selection", "raw-text", "focus"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            pr.type === "textarea" ? withDirectives((openBlock(), createElementBlock("textarea", {
              key: 0,
              ref_key: "inputEelRef",
              ref: Yr,
              class: normalizeClass({ resizeable: pr.resizeable }),
              "onUpdate:modelValue": br[5] || (br[5] = (nr) => Ar.value = nr),
              placeholder: pr.placeholder,
              onKeydown: li,
              style: normalizeStyle({ "--lines": Math.max(4, Ze.value.toString().split(`
`).length) }),
              readonly: pr.readonly
            }, null, 46, _hoisted_2$x)), [
              [vModelText, Ar.value]
            ]) : withDirectives((openBlock(), createElementBlock("input", {
              key: 1,
              ref_key: "inputEelRef",
              ref: Yr,
              "onUpdate:modelValue": br[6] || (br[6] = (nr) => Ze.value = nr),
              readonly: pr.readonly,
              placeholder: pr.placeholder,
              type: pr.type,
              onKeydown: li
            }, null, 40, _hoisted_3$m)), [
              [vModelDynamic, Ze.value]
            ])
          ], 64)),
          br[7] || (br[7] = createElementVNode("div", { class: "bx-input__actions" }, null, -1))
        ], 2),
        Me.suffix ? (openBlock(), createElementBlock("div", _hoisted_4$e, [
          Me.loading || pr.loading ? (openBlock(), createElementBlock("div", _hoisted_5$a, [
            Me.loading ? renderSlot(pr.$slots, "loading", { key: 0 }, void 0, !0) : (openBlock(), createBlock(BxSpin, { key: 1 }))
          ])) : createCommentVNode("", !0),
          renderSlot(pr.$slots, "suffix", {}, void 0, !0)
        ])) : createCommentVNode("", !0)
      ], 6),
      pr.clearable || pr.showWordCount || Lr.value ? (openBlock(), createElementBlock("div", _hoisted_6$7, [
        pr.clearable ? (openBlock(), createElementBlock("div", _hoisted_7$5, [
          createVNode(BxButton, {
            class: "clear-btn",
            size: "small",
            tertiary: "",
            onClick: lr
          }, {
            icon: withCtx(() => [
              createVNode(BxIcon, null, {
                default: withCtx(() => [
                  createVNode(unref(CloseOutline))
                ]),
                _: 1
              })
            ]),
            default: withCtx(() => [
              br[8] || (br[8] = createTextVNode(" Clear "))
            ]),
            _: 1
          })
        ])) : createCommentVNode("", !0),
        pr.showWordCount ? (openBlock(), createElementBlock("div", _hoisted_8$4, [
          pr.maxLength && pr.maxLength !== 1 / 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(di.value) + " / " + toDisplayString(pr.maxLength), 1)
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode(toDisplayString(di.value), 1)
          ], 64))
        ])) : createCommentVNode("", !0),
        Lr.value ? (openBlock(), createBlock(BxTooltip, {
          key: 2,
          trigger: "hover",
          "custom-popover-classes": ["text-overflow-tooltip"],
          "allowed-placements": ["bottom", "top", "right"]
        }, {
          trigger: withCtx(() => [
            createVNode(BxButton, {
              circle: "",
              size: "tiny",
              secondary: "",
              state: "error",
              class: "errors-button"
            }, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(AlertOutline))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          content: withCtx(() => [
            createElementVNode("div", _hoisted_9$4, [
              _r.value?.overflowingCharacters ? (openBlock(), createElementBlock("div", _hoisted_10$4, [
                createElementVNode("span", _hoisted_11$4, toDisplayString(pr.maxLength + or.value) + " / " + toDisplayString(pr.maxLength), 1),
                br[9] || (br[9] = createTextVNode(" characters "))
              ])) : createCommentVNode("", !0),
              _r.value?.overlowingLines ? (openBlock(), createElementBlock("div", _hoisted_12$3, [
                createElementVNode("span", _hoisted_13$3, toDisplayString(pr.maxLines + gr.value) + " / " + toDisplayString(pr.maxLines), 1),
                br[10] || (br[10] = createTextVNode(" lines "))
              ])) : createCommentVNode("", !0),
              _r.value?.lineOverflows ? (openBlock(), createElementBlock("div", _hoisted_14$3, [
                br[11] || (br[11] = createTextVNode(" Lines are too long: ")),
                createElementVNode("ul", null, [
                  (openBlock(!0), createElementBlock(Fragment, null, renderList(_r.value.lineOverflows, ({ index: nr, length: Pe }) => (openBlock(), createElementBlock("li", null, [
                    createElementVNode("span", _hoisted_15$3, "(" + toDisplayString(nr + 1) + ")", 1),
                    createElementVNode("span", _hoisted_16$3, toDisplayString(Pe) + " / " + toDisplayString(pr.maxLineLength), 1)
                  ]))), 256))
                ])
              ])) : createCommentVNode("", !0)
            ])
          ]),
          _: 1
        })) : createCommentVNode("", !0)
      ])) : createCommentVNode("", !0)
    ], 2));
  }
}), BxInput_vue_vue_type_style_index_0_scoped_3fe0edbf_lang = "", BxInput_vue_vue_type_style_index_1_lang = "", BxInput = /* @__PURE__ */ _export_sfc(_sfc_main$Y, [["__scopeId", "data-v-3fe0edbf"]]);
function getQuerystring(m) {
  return new URLSearchParams(Object.fromEntries(Object.entries(m).map(([c, ie]) => [c, String(ie)]))).toString();
}
function usePexels(m) {
  const c = ref$1([]), ie = ref$1(0);
  let we = 25;
  async function $e(Me, Ze) {
    Ze = Ze ?? c.value.length ?? 0;
    const rr = await (await fetch(
      `https://api.pexels.com/v1/search?${getQuerystring({
        page: Math.ceil(Ze / we),
        query: Me,
        per_page: we
      })}`,
      {
        headers: {
          Authorization: m
        }
      }
    )).json();
    if ("error" in rr)
      throw new Error(rr.error);
    ie.value = rr.total_results, c.value = [...c.value.slice(0, Ze), ...rr.photos];
  }
  return {
    photos: c,
    total: ie,
    searchPhotos: $e
  };
}
const global$1 = globalThis || void 0 || self;
function tryOnScopeDispose(m) {
  return getCurrentScope() ? (onScopeDispose(m), !0) : !1;
}
function toValue(m) {
  return typeof m == "function" ? m() : unref(m);
}
const isClient = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const notNullish = (m) => m != null, toString$1 = Object.prototype.toString, isObject$3 = (m) => toString$1.call(m) === "[object Object]", noop = () => {
};
function createFilterWrapper(m, c) {
  function ie(...we) {
    return new Promise(($e, Me) => {
      Promise.resolve(m(() => c.apply(this, we), { fn: c, thisArg: this, args: we })).then($e).catch(Me);
    });
  }
  return ie;
}
function debounceFilter(m, c = {}) {
  let ie, we, $e = noop;
  const Me = (ne) => {
    clearTimeout(ne), $e(), $e = noop;
  };
  return (ne) => {
    const rr = toValue(m), gr = toValue(c.maxWait);
    return ie && Me(ie), rr <= 0 || gr !== void 0 && gr <= 0 ? (we && (Me(we), we = null), Promise.resolve(ne())) : new Promise((or, _r) => {
      $e = c.rejectOnCancel ? _r : or, gr && !we && (we = setTimeout(() => {
        ie && Me(ie), we = null, or(ne());
      }, gr)), ie = setTimeout(() => {
        we && Me(we), we = null, or(ne());
      }, rr);
    });
  };
}
function getLifeCycleTarget(m) {
  return m || getCurrentInstance();
}
function useDebounceFn(m, c = 200, ie = {}) {
  return createFilterWrapper(
    debounceFilter(c, ie),
    m
  );
}
function tryOnMounted(m, c = !0, ie) {
  getLifeCycleTarget() ? onMounted(m, ie) : c ? m() : nextTick$3(m);
}
function unrefElement(m) {
  var c;
  const ie = toValue(m);
  return (c = ie?.$el) != null ? c : ie;
}
const defaultWindow = isClient ? window : void 0;
function useEventListener(...m) {
  let c, ie, we, $e;
  if (typeof m[0] == "string" || Array.isArray(m[0]) ? ([ie, we, $e] = m, c = defaultWindow) : [c, ie, we, $e] = m, !c)
    return noop;
  Array.isArray(ie) || (ie = [ie]), Array.isArray(we) || (we = [we]);
  const Me = [], Ze = () => {
    Me.forEach((or) => or()), Me.length = 0;
  }, ne = (or, _r, Lr, Ir) => (or.addEventListener(_r, Lr, Ir), () => or.removeEventListener(_r, Lr, Ir)), rr = watch(
    () => [unrefElement(c), toValue($e)],
    ([or, _r]) => {
      if (Ze(), !or)
        return;
      const Lr = isObject$3(_r) ? { ..._r } : _r;
      Me.push(
        ...ie.flatMap((Ir) => we.map((Ar) => ne(or, Ir, Ar, Lr)))
      );
    },
    { immediate: !0, flush: "post" }
  ), gr = () => {
    rr(), Ze();
  };
  return tryOnScopeDispose(gr), gr;
}
function useMounted() {
  const m = ref$1(!1), c = getCurrentInstance();
  return c && onMounted(() => {
    m.value = !0;
  }, c), m;
}
function useSupported(m) {
  const c = useMounted();
  return computed(() => (c.value, Boolean(m())));
}
function useMutationObserver(m, c, ie = {}) {
  const { window: we = defaultWindow, ...$e } = ie;
  let Me;
  const Ze = useSupported(() => we && "MutationObserver" in we), ne = () => {
    Me && (Me.disconnect(), Me = void 0);
  }, rr = computed(() => {
    const Lr = toValue(m), Ir = (Array.isArray(Lr) ? Lr : [Lr]).map(unrefElement).filter(notNullish);
    return new Set(Ir);
  }), gr = watch(
    () => rr.value,
    (Lr) => {
      ne(), Ze.value && Lr.size && (Me = new MutationObserver(c), Lr.forEach((Ir) => Me.observe(Ir, $e)));
    },
    { immediate: !0, flush: "post" }
  ), or = () => Me?.takeRecords(), _r = () => {
    ne(), gr();
  };
  return tryOnScopeDispose(_r), {
    isSupported: Ze,
    stop: _r,
    takeRecords: or
  };
}
function useMediaQuery(m, c = {}) {
  const { window: ie = defaultWindow } = c, we = useSupported(() => ie && "matchMedia" in ie && typeof ie.matchMedia == "function");
  let $e;
  const Me = ref$1(!1), Ze = (gr) => {
    Me.value = gr.matches;
  }, ne = () => {
    !$e || ("removeEventListener" in $e ? $e.removeEventListener("change", Ze) : $e.removeListener(Ze));
  }, rr = watchEffect(() => {
    !we.value || (ne(), $e = ie.matchMedia(toValue(m)), "addEventListener" in $e ? $e.addEventListener("change", Ze) : $e.addListener(Ze), Me.value = $e.matches);
  });
  return tryOnScopeDispose(() => {
    rr(), ne(), $e = void 0;
  }), Me;
}
function useResizeObserver(m, c, ie = {}) {
  const { window: we = defaultWindow, ...$e } = ie;
  let Me;
  const Ze = useSupported(() => we && "ResizeObserver" in we), ne = () => {
    Me && (Me.disconnect(), Me = void 0);
  }, rr = computed(() => Array.isArray(m) ? m.map((_r) => unrefElement(_r)) : [unrefElement(m)]), gr = watch(
    rr,
    (_r) => {
      if (ne(), Ze.value && we) {
        Me = new ResizeObserver(c);
        for (const Lr of _r)
          Lr && Me.observe(Lr, $e);
      }
    },
    { immediate: !0, flush: "post" }
  ), or = () => {
    ne(), gr();
  };
  return tryOnScopeDispose(or), {
    isSupported: Ze,
    stop: or
  };
}
function useElementBounding(m, c = {}) {
  const {
    reset: ie = !0,
    windowResize: we = !0,
    windowScroll: $e = !0,
    immediate: Me = !0
  } = c, Ze = ref$1(0), ne = ref$1(0), rr = ref$1(0), gr = ref$1(0), or = ref$1(0), _r = ref$1(0), Lr = ref$1(0), Ir = ref$1(0);
  function Ar() {
    const Rr = unrefElement(m);
    if (!Rr) {
      ie && (Ze.value = 0, ne.value = 0, rr.value = 0, gr.value = 0, or.value = 0, _r.value = 0, Lr.value = 0, Ir.value = 0);
      return;
    }
    const Nr = Rr.getBoundingClientRect();
    Ze.value = Nr.height, ne.value = Nr.bottom, rr.value = Nr.left, gr.value = Nr.right, or.value = Nr.top, _r.value = Nr.width, Lr.value = Nr.x, Ir.value = Nr.y;
  }
  return useResizeObserver(m, Ar), watch(() => unrefElement(m), (Rr) => !Rr && Ar()), useMutationObserver(m, Ar, {
    attributeFilter: ["style", "class"]
  }), $e && useEventListener("scroll", Ar, { capture: !0, passive: !0 }), we && useEventListener("resize", Ar, { passive: !0 }), tryOnMounted(() => {
    Me && Ar();
  }), {
    height: Ze,
    bottom: ne,
    left: rr,
    right: gr,
    top: or,
    width: _r,
    x: Lr,
    y: Ir,
    update: Ar
  };
}
function useIntersectionObserver(m, c, ie = {}) {
  const {
    root: we,
    rootMargin: $e = "0px",
    threshold: Me = 0.1,
    window: Ze = defaultWindow,
    immediate: ne = !0
  } = ie, rr = useSupported(() => Ze && "IntersectionObserver" in Ze), gr = computed(() => {
    const Ar = toValue(m);
    return (Array.isArray(Ar) ? Ar : [Ar]).map(unrefElement).filter(notNullish);
  });
  let or = noop;
  const _r = ref$1(ne), Lr = rr.value ? watch(
    () => [gr.value, unrefElement(we), _r.value],
    ([Ar, Rr]) => {
      if (or(), !_r.value || !Ar.length)
        return;
      const Nr = new IntersectionObserver(
        c,
        {
          root: unrefElement(Rr),
          rootMargin: $e,
          threshold: Me
        }
      );
      Ar.forEach((Yr) => Yr && Nr.observe(Yr)), or = () => {
        Nr.disconnect(), or = noop;
      };
    },
    { immediate: ne, flush: "post" }
  ) : noop, Ir = () => {
    or(), Lr(), _r.value = !1;
  };
  return tryOnScopeDispose(Ir), {
    isSupported: rr,
    isActive: _r,
    pause() {
      or(), _r.value = !1;
    },
    resume() {
      _r.value = !0;
    },
    stop: Ir
  };
}
function useElementVisibility(m, c = {}) {
  const { window: ie = defaultWindow, scrollTarget: we, threshold: $e = 0 } = c, Me = ref$1(!1);
  return useIntersectionObserver(
    m,
    (Ze) => {
      let ne = Me.value, rr = 0;
      for (const gr of Ze)
        gr.time >= rr && (rr = gr.time, ne = gr.isIntersecting);
      Me.value = ne;
    },
    {
      root: we,
      window: ie,
      threshold: $e
    }
  ), Me;
}
function useWindowSize(m = {}) {
  const {
    window: c = defaultWindow,
    initialWidth: ie = Number.POSITIVE_INFINITY,
    initialHeight: we = Number.POSITIVE_INFINITY,
    listenOrientation: $e = !0,
    includeScrollbar: Me = !0
  } = m, Ze = ref$1(ie), ne = ref$1(we), rr = () => {
    c && (Me ? (Ze.value = c.innerWidth, ne.value = c.innerHeight) : (Ze.value = c.document.documentElement.clientWidth, ne.value = c.document.documentElement.clientHeight));
  };
  if (rr(), tryOnMounted(rr), useEventListener("resize", rr, { passive: !0 }), $e) {
    const gr = useMediaQuery("(orientation: portrait)");
    watch(gr, () => rr());
  }
  return { width: Ze, height: ne };
}
const _sfc_main$X = /* @__PURE__ */ defineComponent({
  __name: "LazyLoadingItemWrapper",
  emits: ["update:visible"],
  setup(m, { emit: c }) {
    ref$1();
    const ie = c, we = ref$1(), $e = useElementVisibility(we);
    return ie("update:visible", $e.value), watch($e, (Me, Ze) => {
      !Ze && Me && ie("update:visible", $e.value);
    }), (Me, Ze) => (openBlock(), createElementBlock("div", {
      class: "item-wrapper",
      ref_key: "itemWrapperRef",
      ref: we
    }, [
      renderSlot(Me.$slots, "default")
    ], 512));
  }
}), _sfc_main$W = /* @__PURE__ */ defineComponent({
  __name: "LazyLoading",
  props: {
    items: {},
    total: {},
    fetch: { type: Function },
    visibleTriggerOffset: {}
  },
  setup(m) {
    ref$1();
    const c = m;
    c.fetch(0);
    const ie = (we, $e) => {
      $e && we >= c.items.length - c.visibleTriggerOffset - 1 && c.total > c.items.length && c.fetch();
    };
    return (we, $e) => (openBlock(!0), createElementBlock(Fragment, null, renderList(we.items, (Me, Ze) => (openBlock(), createBlock(_sfc_main$X, {
      key: Ze,
      class: "item-wrapper",
      item: Me,
      index: Ze,
      "onUpdate:visible": (ne) => ie(Ze, ne)
    }, {
      default: withCtx(() => [
        renderSlot(we.$slots, "item", {
          item: Me,
          index: Ze
        })
      ]),
      _: 2
    }, 1032, ["item", "index", "onUpdate:visible"]))), 128));
  }
}), _hoisted_1$J = { class: "bx-empty" }, _hoisted_2$w = {
  key: 0,
  class: "icon-wrapper"
}, _hoisted_3$l = {
  key: 1,
  class: "title"
}, _hoisted_4$d = {
  key: 2,
  class: "description"
}, _sfc_main$V = /* @__PURE__ */ defineComponent({
  __name: "BxEmpty",
  props: {
    title: {},
    description: {}
  },
  setup(m) {
    const c = useSlots();
    return (ie, we) => (openBlock(), createElementBlock("div", _hoisted_1$J, [
      c.icon ? (openBlock(), createElementBlock("div", _hoisted_2$w, [
        renderSlot(ie.$slots, "icon", {}, void 0, !0)
      ])) : createCommentVNode("", !0),
      ie.title || c.title ? (openBlock(), createElementBlock("div", _hoisted_3$l, [
        c.title ? renderSlot(ie.$slots, "title", { key: 0 }, void 0, !0) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString(ie.title), 1)
        ], 64))
      ])) : createCommentVNode("", !0),
      ie.description || c.description ? (openBlock(), createElementBlock("div", _hoisted_4$d, [
        c.description ? renderSlot(ie.$slots, "description", { key: 0 }, void 0, !0) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString(ie.description), 1)
        ], 64))
      ])) : createCommentVNode("", !0)
    ]));
  }
}), BxEmpty_vue_vue_type_style_index_0_scoped_2b4dcd9d_lang = "", BxEmpty = /* @__PURE__ */ _export_sfc(_sfc_main$V, [["__scopeId", "data-v-2b4dcd9d"]]), _hoisted_1$I = { class: "image-library-pexels" }, _hoisted_2$v = { class: "search-bar-wrapper" }, _hoisted_3$k = {
  key: 0,
  class: "photos"
}, _hoisted_4$c = ["onClick"], _hoisted_5$9 = { class: "preview" }, _hoisted_6$6 = ["src"], _hoisted_7$4 = {
  key: 1,
  class: "loading-wrapper"
}, _sfc_main$U = /* @__PURE__ */ defineComponent({
  __name: "Pexels",
  props: {
    apiKey: {},
    width: {},
    height: {}
  },
  emits: ["select"],
  setup(m, { emit: c }) {
    const ie = m, we = c, $e = ref$1("city");
    console.log("pexels api key", ie.apiKey);
    const { searchPhotos: Me, photos: Ze, total: ne } = usePexels(ie.apiKey), rr = ref$1(), gr = ref$1(!1);
    async function or() {
      $e.value.length > 0 && (gr.value = !0, ne.value = 25, Ze.value = [], await Me($e.value), rr.value = $e.value, gr.value = !1);
    }
    async function _r(Ir, Ar) {
      await Me($e.value, Ir);
    }
    function Lr(Ir) {
      const Ar = (Ir.width ?? 1) / (Ir.height ?? 1), Rr = ie.width / ie.height, Nr = Ar >= Rr ? "height" : "width", Yr = `https://really.blue/cdn-cgi/image/${Nr}=${Nr === "width" ? ie.width : ie.height},quality=75/${Ir.src.original}`;
      we("select", Yr);
    }
    return (Ir, Ar) => (openBlock(), createElementBlock("div", _hoisted_1$I, [
      createElementVNode("header", null, [
        createElementVNode("div", _hoisted_2$v, [
          createVNode(BxInput, {
            modelValue: $e.value,
            "onUpdate:modelValue": Ar[0] || (Ar[0] = (Rr) => $e.value = Rr),
            round: "",
            placeholder: "Search...",
            size: "large",
            onEnter: or
          }, null, 8, ["modelValue"]),
          createVNode(BxButton, {
            primary: "",
            round: "",
            onClick: or
          }, {
            default: withCtx(() => Ar[1] || (Ar[1] = [
              createTextVNode("Search")
            ])),
            _: 1
          })
        ])
      ]),
      createElementVNode("main", null, [
        rr.value ? (openBlock(), createElementBlock("div", _hoisted_3$k, [
          createVNode(_sfc_main$W, {
            items: unref(Ze),
            total: unref(ne),
            fetch: _r,
            "visible-trigger-offset": 0
          }, {
            item: withCtx(({ item: Rr }) => [
              (openBlock(), createElementBlock("div", {
                key: Rr.id,
                class: "photo-wrapper",
                onClick: (Nr) => Lr(Rr)
              }, [
                createElementVNode("div", _hoisted_5$9, [
                  createElementVNode("img", {
                    src: Rr.src.tiny
                  }, null, 8, _hoisted_6$6)
                ])
              ], 8, _hoisted_4$c))
            ]),
            _: 1
          }, 8, ["items", "total"])
        ])) : gr.value ? (openBlock(), createElementBlock("div", _hoisted_7$4, [
          createVNode(BxSpin)
        ])) : (openBlock(), createBlock(BxEmpty, {
          key: 2,
          title: "Pexels",
          description: "Search for images on Pexels"
        }, {
          icon: withCtx(() => [
            createVNode(unref(SearchOutline))
          ]),
          _: 1
        }))
      ])
    ]));
  }
}), Pexels_vue_vue_type_style_index_0_scopd_true_lang = "";
function normalizeOnedrive(m, c, ie) {
  return m.map((we) => {
    const $e = `https://really.blue/cdn-cgi/image/width=250,quality=75/${we["@microsoft.graph.downloadUrl"]}`, Me = we.image.width / we.image.height, Ze = c / ie, ne = Me >= Ze ? "height" : "width";
    return {
      src: `https://really.blue/cdn-cgi/image/${ne}=${ne === "width" ? c : ie},quality=75/${we["@microsoft.graph.downloadUrl"]}`,
      key: we.id,
      width: we.image.width,
      height: we.image.height,
      previews: {
        small: {
          src: $e,
          width: we.image.width,
          height: we.image.height
        },
        medium: {
          src: $e,
          width: we.image.width,
          height: we.image.height
        }
      }
    };
  });
}
function normalizeGoogledrive(m, c, ie) {
  return m.map(({ thumbnailLink: we, webContentLink: $e, sha256Checksum: Me, imageMediaMetadata: Ze }) => {
    const ne = `https://really.blue/cdn-cgi/image/width=250,quality=75/${$e}`, rr = (Ze?.width ?? 1) / (Ze?.height ?? 1), gr = c / ie, or = rr >= gr ? "height" : "width";
    return {
      src: `https://really.blue/cdn-cgi/image/${or}=${or === "width" ? c : ie},quality=75/${$e}`,
      key: Me,
      width: Ze?.width ?? 0,
      height: Ze?.height ?? 0,
      previews: {
        small: {
          src: ne,
          width: Ze?.width ?? 0,
          height: Ze?.height ?? 0
        },
        medium: {
          src: ne,
          width: Ze?.width ?? 0,
          height: Ze?.height ?? 0
        }
      }
    };
  });
}
function useSharedDrive(m, c, ie, we) {
  const $e = ref$1();
  return {
    sharedItems: $e,
    fetchSharedDrive: async () => {
      if (m === "onedrive") {
        const Ze = `https://europe-central2-bluepic.cloudfunctions.net/shared-drive/onedrive/?${getQuerystring({
          sharing: c
        })}`, rr = await (await fetch(Ze)).json();
        $e.value = normalizeOnedrive(rr.children, ie, we);
      } else if (m === "googledrive") {
        const Ze = `https://europe-central2-bluepic.cloudfunctions.net/shared-drive/googledrive/?${getQuerystring({
          sharing: c
        })}`, rr = await (await fetch(Ze)).json();
        $e.value = normalizeGoogledrive(rr.files, ie, we);
      }
    }
  };
}
const _hoisted_1$H = { class: "image-library-shared-drive" }, _hoisted_2$u = {
  key: 0,
  class: "photos"
}, _hoisted_3$j = ["onClick"], _hoisted_4$b = { class: "preview" }, _hoisted_5$8 = ["src"], _hoisted_6$5 = {
  key: 1,
  class: "loading-wrapper"
}, _sfc_main$T = /* @__PURE__ */ defineComponent({
  __name: "SharedDrive",
  props: {
    service: {},
    sharedUrl: {},
    width: {},
    height: {}
  },
  emits: ["select"],
  setup(m, { emit: c }) {
    const ie = m, we = c, { fetchSharedDrive: $e, sharedItems: Me } = useSharedDrive(ie.service, ie.sharedUrl, ie.width, ie.height);
    $e();
    function Ze(ne) {
      we("select", ne.src);
    }
    return (ne, rr) => (openBlock(), createElementBlock("div", _hoisted_1$H, [
      unref(Me) ? (openBlock(), createElementBlock("div", _hoisted_2$u, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(Me), (gr) => (openBlock(), createElementBlock("div", {
          class: "photo-wrapper",
          onClick: (or) => Ze(gr)
        }, [
          createElementVNode("div", _hoisted_4$b, [
            createElementVNode("img", {
              src: gr.previews.small.src
            }, null, 8, _hoisted_5$8)
          ])
        ], 8, _hoisted_3$j))), 256))
      ])) : (openBlock(), createElementBlock("div", _hoisted_6$5, [
        createVNode(BxSpin)
      ]))
    ]));
  }
}), SharedDrive_vue_vue_type_style_index_0_scoped_7d6cf073_lang = "", SharedDriveLibraryComponent = /* @__PURE__ */ _export_sfc(_sfc_main$T, [["__scopeId", "data-v-7d6cf073"]]), _hoisted_1$G = { class: "image-library-custom" }, _sfc_main$S = /* @__PURE__ */ defineComponent({
  __name: "Custom",
  props: {
    controller: {},
    label: {},
    name: {},
    props: {}
  },
  setup(m) {
    const c = m, ie = import(c.controller), we = ref$1();
    return ie.then(($e) => {
      we.value = new $e.default(c.props);
    }), ($e, Me) => (openBlock(), createElementBlock("div", _hoisted_1$G, "JAJAJA"));
  }
}), _hoisted_1$F = { class: "image-library-wrapper" }, _hoisted_2$t = {
  key: 0,
  class: "nav-view-wrapper"
}, _hoisted_3$i = { class: "icon-wrapper" }, _hoisted_4$a = { class: "label" }, _hoisted_5$7 = {
  key: 1,
  class: "library-view-wrapper"
}, _sfc_main$R = /* @__PURE__ */ defineComponent({
  __name: "ImageLibraryWrapper",
  props: {
    options: {},
    activeKey: {},
    imageLibraries: {},
    convertTo: {},
    quality: {},
    width: {},
    height: {},
    bridge: {},
    field: {}
  },
  emits: ["select", "update:active-key"],
  setup(m, { emit: c }) {
    const ie = m, we = c, $e = ref$1(ie.activeKey);
    watch($e, () => {
      ie.activeKey !== $e.value && we("update:active-key", $e.value);
    }), watch(
      () => ie.activeKey,
      () => {
        ie.activeKey !== $e.value && ($e.value = ie.activeKey);
      }
    );
    function Me(Ar) {
      $e.value = Ar;
    }
    const Ze = computed(() => ie.imageLibraries.find((Ar) => Ar.type === "pexels")?.apiKey), ne = computed(() => ie.imageLibraries.find((Ar) => Ar.type === "sharedDrive" && Ar.service === $e.value).sharedUrl), rr = computed(() => ie.imageLibraries.find((Ar) => Ar.type === $e.value)?.label), gr = computed(() => ie.imageLibraries.find((Ar) => Ar.type === $e.value)?.name), or = computed(() => ie.imageLibraries.find((Ar) => Ar.type === $e.value)?.controller), _r = computed(() => ie.imageLibraries.find((Ar) => Ar.type === $e.value)?.props);
    function Lr(Ar) {
      const Rr = Ar[0];
      Rr && Ir(Rr.src);
    }
    function Ir(Ar) {
      we("select", Ar);
    }
    return (Ar, Rr) => (openBlock(), createElementBlock("div", _hoisted_1$F, [
      createVNode(Transition, { name: "slide-library" }, {
        default: withCtx(() => [
          $e.value === void 0 ? (openBlock(), createElementBlock("div", _hoisted_2$t, [
            createElementVNode("div", {
              class: "image-library-source-navigation",
              style: normalizeStyle({ "--options-length": Ar.options.length })
            }, [
              (openBlock(!0), createElementBlock(Fragment, null, renderList(ie.options, (Nr) => (openBlock(), createBlock(BxCard, {
                key: Nr.key,
                hoverable: "",
                bordered: !0,
                onClick: (Yr) => Me(Nr.key)
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_3$i, [
                    (openBlock(), createBlock(resolveDynamicComponent(Nr.icon)))
                  ]),
                  createElementVNode("div", _hoisted_4$a, toDisplayString(Nr.label), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))), 128))
            ], 4)
          ])) : (openBlock(), createElementBlock("div", _hoisted_5$7, [
            $e.value === "upload" ? (openBlock(), createBlock(UploadLibraryComponent, {
              key: 0,
              width: Ar.width,
              height: Ar.height,
              "convert-to": Ar.convertTo,
              quality: Ar.quality,
              field: Ar.field,
              "handle-upload": Ar.bridge.handleUpload,
              onUpload: Lr
            }, null, 8, ["width", "height", "convert-to", "quality", "field", "handle-upload"])) : $e.value === "pexels" ? (openBlock(), createBlock(_sfc_main$U, {
              key: 1,
              "api-key": Ze.value,
              onSelect: Ir,
              width: Ar.width,
              height: Ar.height
            }, null, 8, ["api-key", "width", "height"])) : $e.value === "googledrive" || $e.value === "onedrive" || $e.value === "icloud" || $e.value === "dropbox" ? (openBlock(), createBlock(SharedDriveLibraryComponent, {
              key: 2,
              service: $e.value,
              "shared-url": ne.value,
              width: Ar.width,
              height: Ar.height,
              onSelect: Ir
            }, null, 8, ["service", "shared-url", "width", "height"])) : $e.value === "custom" ? (openBlock(), createBlock(_sfc_main$S, {
              key: 3,
              label: rr.value,
              name: gr.value,
              controller: or.value,
              props: _r.value
            }, null, 8, ["label", "name", "controller", "props"])) : createCommentVNode("", !0)
          ]))
        ]),
        _: 1
      })
    ]));
  }
}), ImageLibraryWrapper_vue_vue_type_style_index_0_scoped_562275c6_lang = "", ImageLibraryWrapper = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["__scopeId", "data-v-562275c6"]]), _sfc_main$Q = /* @__PURE__ */ defineComponent({
  __name: "BxList",
  props: {
    divider: { type: Boolean, default: !0 }
  },
  setup(m) {
    return useSlots(), (c, ie) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-list", { "has-divider": c.divider }])
    }, [
      renderSlot(c.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), BxList_vue_vue_type_style_index_0_scoped_50dcc63b_lang = "", BxList = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["__scopeId", "data-v-50dcc63b"]]), _hoisted_1$E = { class: "bx-list-item__inner" }, _hoisted_2$s = {
  key: 0,
  class: "bx-list-item__prefix"
}, _hoisted_3$h = { class: "bx-list-item__content" }, _hoisted_4$9 = {
  key: 1,
  class: "bx-list-item__suffix"
}, _sfc_main$P = /* @__PURE__ */ defineComponent({
  __name: "BxListItem",
  setup(m) {
    const c = useSlots(), ie = computed(() => !!c.prefix), we = computed(() => !!c.suffix);
    return ($e, Me) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-list-item", { "has-prefix": ie.value, "has-suffix": we.value }])
    }, [
      createElementVNode("div", _hoisted_1$E, [
        c.prefix ? (openBlock(), createElementBlock("div", _hoisted_2$s, [
          renderSlot($e.$slots, "prefix", {}, void 0, !0)
        ])) : createCommentVNode("", !0),
        createElementVNode("div", _hoisted_3$h, [
          renderSlot($e.$slots, "default", {}, void 0, !0)
        ]),
        c.suffix ? (openBlock(), createElementBlock("div", _hoisted_4$9, [
          renderSlot($e.$slots, "suffix", {}, void 0, !0)
        ])) : createCommentVNode("", !0)
      ])
    ], 2));
  }
}), BxListItem_vue_vue_type_style_index_0_scoped_be754519_lang = "", BxListItem = /* @__PURE__ */ _export_sfc(_sfc_main$P, [["__scopeId", "data-v-be754519"]]), _hoisted_1$D = { class: "pullup-menu" }, _hoisted_2$r = ["onClick"], _hoisted_3$g = { class: "icon" }, _hoisted_4$8 = { class: "label" }, _hoisted_5$6 = { class: "pullup-menu" }, _hoisted_6$4 = { class: "icon" }, _sfc_main$O = /* @__PURE__ */ defineComponent({
  __name: "BxDropdown",
  props: /* @__PURE__ */ mergeModels({
    options: {},
    allowedPlacements: {},
    mobileLayout: { type: Boolean, default: !1 }
  }, {
    show: { type: Boolean, required: !1, default: !1 },
    showModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["select"], ["update:show"]),
  setup(m, { emit: c }) {
    const ie = c, we = useModel(m, "show");
    function $e(Ze) {
      we.value = !1, ie("select", Ze.value);
    }
    const Me = useSlots();
    return (Ze, ne) => Ze.mobileLayout ? (openBlock(), createBlock(_sfc_main$18, {
      key: 0,
      show: we.value,
      "onUpdate:show": ne[1] || (ne[1] = (rr) => we.value = rr),
      "disable-background-effect": "",
      "custom-classes": ["bx-dropdown-mobile-layout-popup"],
      closeable: !1
    }, {
      trigger: withCtx(() => [
        renderSlot(Ze.$slots, "trigger", {}, void 0, !0)
      ]),
      content: withCtx(() => [
        createElementVNode("div", {
          class: normalizeClass(["pullup-menu-wrapper", {}])
        }, [
          createElementVNode("div", _hoisted_1$D, [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(Ze.options, (rr) => (openBlock(), createElementBlock("button", {
              class: "select-button",
              onClick: (gr) => $e(rr)
            }, [
              createElementVNode("div", _hoisted_3$g, [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    (openBlock(), createBlock(resolveDynamicComponent(rr.icon)))
                  ]),
                  _: 2
                }, 1024)
              ]),
              createElementVNode("div", _hoisted_4$8, [
                Me.optionLabel ? renderSlot(Ze.$slots, "optionLabel", {
                  key: 0,
                  option: rr
                }, void 0, !0) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(rr.label), 1)
                ], 64))
              ])
            ], 8, _hoisted_2$r))), 256))
          ]),
          createElementVNode("div", _hoisted_5$6, [
            createElementVNode("button", {
              class: "select-button",
              onClick: ne[0] || (ne[0] = (rr) => we.value = !1)
            }, [
              createElementVNode("div", _hoisted_6$4, [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(CloseOutline))
                  ]),
                  _: 1
                })
              ]),
              ne[3] || (ne[3] = createElementVNode("div", { class: "label" }, "Close", -1))
            ])
          ])
        ])
      ]),
      _: 3
    }, 8, ["show"])) : (openBlock(), createBlock(BxPopover, {
      key: 1,
      show: we.value,
      "onUpdate:show": ne[2] || (ne[2] = (rr) => we.value = rr),
      trigger: "click",
      "allowed-placements": Ze.allowedPlacements ?? ["bottom", "top"],
      arrow: !0,
      "custom-styles": {},
      "custom-classes": ["dropdown-popover"]
    }, {
      trigger: withCtx(() => [
        renderSlot(Ze.$slots, "trigger", {}, void 0, !0)
      ]),
      content: withCtx(() => [
        createVNode(BxList, null, {
          default: withCtx(() => [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(Ze.options, (rr) => (openBlock(), createBlock(BxListItem, {
              key: rr.value,
              onClick: (gr) => $e(rr)
            }, createSlots({
              default: withCtx(() => [
                Me.optionLabel ? renderSlot(Ze.$slots, "optionLabel", {
                  key: 0,
                  option: rr
                }, void 0, !0) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(rr.label), 1)
                ], 64))
              ]),
              _: 2
            }, [
              rr.icon ? {
                name: "prefix",
                fn: withCtx(() => [
                  createVNode(BxIcon, null, {
                    default: withCtx(() => [
                      (openBlock(), createBlock(resolveDynamicComponent(rr.icon)))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["onClick"]))), 128))
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show", "allowed-placements"]));
  }
}), BxDropdown_vue_vue_type_style_index_0_scoped_8f2540c6_lang = "", BxDropdown_vue_vue_type_style_index_1_lang = "", BxDropdown = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["__scopeId", "data-v-8f2540c6"]]);
function p$1(m, c) {
  var ie = Object.keys(m);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(m);
    c && (we = we.filter(function($e) {
      return Object.getOwnPropertyDescriptor(m, $e).enumerable;
    })), ie.push.apply(ie, we);
  }
  return ie;
}
function g$1(m) {
  for (var c = 1; c < arguments.length; c++) {
    var ie = arguments[c] != null ? arguments[c] : {};
    c % 2 ? p$1(Object(ie), !0).forEach(function(we) {
      f$1(m, we, ie[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(m, Object.getOwnPropertyDescriptors(ie)) : p$1(Object(ie)).forEach(function(we) {
      Object.defineProperty(m, we, Object.getOwnPropertyDescriptor(ie, we));
    });
  }
  return m;
}
function f$1(m, c, ie) {
  return c in m ? Object.defineProperty(m, c, { value: ie, enumerable: !0, configurable: !0, writable: !0 }) : m[c] = ie, m;
}
function v$1(m, c) {
  if (m == null)
    return {};
  var ie, we, $e = function(Ze, ne) {
    if (Ze == null)
      return {};
    var rr, gr, or = {}, _r = Object.keys(Ze);
    for (gr = 0; gr < _r.length; gr++)
      rr = _r[gr], ne.indexOf(rr) >= 0 || (or[rr] = Ze[rr]);
    return or;
  }(m, c);
  if (Object.getOwnPropertySymbols) {
    var Me = Object.getOwnPropertySymbols(m);
    for (we = 0; we < Me.length; we++)
      ie = Me[we], c.indexOf(ie) >= 0 || Object.prototype.propertyIsEnumerable.call(m, ie) && ($e[ie] = m[ie]);
  }
  return $e;
}
function b$1(m) {
  return function(c) {
    if (Array.isArray(c))
      return w$1(c);
  }(m) || function(c) {
    if (typeof Symbol < "u" && c[Symbol.iterator] != null || c["@@iterator"] != null)
      return Array.from(c);
  }(m) || function(c, ie) {
    if (!!c) {
      if (typeof c == "string")
        return w$1(c, ie);
      var we = Object.prototype.toString.call(c).slice(8, -1);
      if (we === "Object" && c.constructor && (we = c.constructor.name), we === "Map" || we === "Set")
        return Array.from(c);
      if (we === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(we))
        return w$1(c, ie);
    }
  }(m) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function w$1(m, c) {
  (c == null || c > m.length) && (c = m.length);
  for (var ie = 0, we = new Array(c); ie < c; ie++)
    we[ie] = m[ie];
  return we;
}
var y$1, z, R, A$1 = (y$1 = function(m) {
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  (function() {
    var c = {}.hasOwnProperty;
    function ie() {
      for (var we = [], $e = 0; $e < arguments.length; $e++) {
        var Me = arguments[$e];
        if (Me) {
          var Ze = typeof Me;
          if (Ze === "string" || Ze === "number")
            we.push(Me);
          else if (Array.isArray(Me)) {
            if (Me.length) {
              var ne = ie.apply(null, Me);
              ne && we.push(ne);
            }
          } else if (Ze === "object")
            if (Me.toString === Object.prototype.toString)
              for (var rr in Me)
                c.call(Me, rr) && Me[rr] && we.push(rr);
            else
              we.push(Me.toString());
        }
      }
      return we.join(" ");
    }
    m.exports ? (ie.default = ie, m.exports = ie) : window.classNames = ie;
  })();
}, y$1(R = { path: z, exports: {}, require: function(m, c) {
  return function() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }(c == null && R.path);
} }, R.exports), R.exports), M = function(m) {
  return function(c, ie) {
    if (!c)
      return m;
    var we;
    typeof c == "string" ? we = c : ie = c;
    var $e = m;
    return we && ($e += "__" + we), $e + (ie ? Object.keys(ie).reduce(function(Me, Ze) {
      var ne = ie[Ze];
      return ne && (Me += " " + (typeof ne == "boolean" ? $e + "--" + Ze : $e + "--" + Ze + "_" + ne)), Me;
    }, "") : "");
  };
};
function S$1(m, c, ie) {
  var we, $e, Me, Ze, ne;
  function rr() {
    var or = Date.now() - Ze;
    or < c && or >= 0 ? we = setTimeout(rr, c - or) : (we = null, ie || (ne = m.apply(Me, $e), Me = $e = null));
  }
  c == null && (c = 100);
  var gr = function() {
    Me = this, $e = arguments, Ze = Date.now();
    var or = ie && !we;
    return we || (we = setTimeout(rr, c)), or && (ne = m.apply(Me, $e), Me = $e = null), ne;
  };
  return gr.clear = function() {
    we && (clearTimeout(we), we = null);
  }, gr.flush = function() {
    we && (ne = m.apply(Me, $e), Me = $e = null, clearTimeout(we), we = null);
  }, gr;
}
S$1.debounce = S$1;
var x = S$1, C = function() {
  return C = Object.assign || function(m) {
    for (var c, ie = 1, we = arguments.length; ie < we; ie++)
      for (var $e in c = arguments[ie])
        Object.prototype.hasOwnProperty.call(c, $e) && (m[$e] = c[$e]);
    return m;
  }, C.apply(this, arguments);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function E(m, c) {
  var ie, we;
  return m && c ? (ie = "" + m + c[0].toUpperCase() + c.slice(1), we = m + "-" + c) : (ie = m || c, we = m || c), { name: ie, classname: we };
}
function W(m) {
  return /^blob:/.test(m);
}
function T(m) {
  return W(m) || function(c) {
    return /^data:/.test(c);
  }(m);
}
function O(m) {
  return !!(m && m.constructor && m.call && m.apply);
}
function D$1(m) {
  return m === void 0;
}
function H(m) {
  return typeof m == "object" && m !== null;
}
function j(m, c, ie) {
  var we = {};
  return H(m) ? (Object.keys(c).forEach(function($e) {
    D$1(m[$e]) ? we[$e] = c[$e] : H(c[$e]) ? H(m[$e]) ? we[$e] = j(m[$e], c[$e], ie[$e]) : we[$e] = m[$e] ? c[$e] : ie[$e] : c[$e] === !0 || c[$e] === !1 ? we[$e] = Boolean(m[$e]) : we[$e] = m[$e];
  }), we) : m ? c : ie;
}
function L(m) {
  var c = Number(m);
  return Number.isNaN(c) ? m : c;
}
function P(m) {
  return typeof (m == "number" || function(c) {
    return typeof c == "object" && c !== null;
  }(m) && toString.call(m) == "[object Number]") && !$(m);
}
function $(m) {
  return m != m;
}
function I$1(m, c) {
  return Math.sqrt(Math.pow(m.x - c.x, 2) + Math.pow(m.y - c.y, 2));
}
var B$1 = function(m, c) {
  m === void 0 && (m = {}), c === void 0 && (c = {}), this.type = "manipulateImage", this.move = m, this.scale = c;
}, X = function(m, c) {
  c === void 0 && (c = {}), this.type = "resize", this.directions = m, this.params = c;
}, Y = function(m) {
  this.type = "move", this.directions = m;
}, k = function() {
  function m(c, ie, we, $e, Me) {
    this.type = "drag", this.nativeEvent = c, this.position = we, this.previousPosition = $e, this.element = ie, this.anchor = Me;
  }
  return m.prototype.shift = function() {
    var c = this, ie = c.element, we = c.anchor, $e = c.position;
    if (ie) {
      var Me = ie.getBoundingClientRect(), Ze = Me.left, ne = Me.top;
      return { left: $e.left - Ze - we.left, top: $e.top - ne - we.top };
    }
    return { left: 0, top: 0 };
  }, m;
}(), F = { name: "DraggableElement", props: { classname: { type: String } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  if (!this.$refs.draggable)
    throw new Error('You should add ref "draggable" to your root element to use draggable mixin');
  this.touches = [], this.hovered = !1;
}, methods: { onMouseOver: function() {
  this.hovered || (this.hovered = !0, this.$emit("enter"));
}, onMouseLeave: function() {
  this.hovered && !this.touches.length && (this.hovered = !1, this.$emit("leave"));
}, onTouchStart: function(m) {
  m.cancelable && !this.disabled && m.touches.length === 1 && (this.touches = b$1(m.touches), this.hovered || (this.$emit("enter"), this.hovered = !0), m.touches.length && this.initAnchor(this.touches.reduce(function(c, ie) {
    return { clientX: c.clientX + ie.clientX / m.touches.length, clientY: c.clientY + ie.clientY / m.touches.length };
  }, { clientX: 0, clientY: 0 })), m.preventDefault && m.preventDefault(), m.stopPropagation());
}, onTouchEnd: function() {
  this.processEnd();
}, onTouchMove: function(m) {
  this.touches.length && (this.processMove(m, m.touches), m.preventDefault && m.preventDefault(), m.stopPropagation && m.stopPropagation());
}, onMouseDown: function(m) {
  if (!this.disabled) {
    var c = { fake: !0, clientX: m.clientX, clientY: m.clientY };
    this.touches = [c], this.initAnchor(c), m.stopPropagation();
  }
}, onMouseMove: function(m) {
  this.touches.length && (this.processMove(m, [{ fake: !0, clientX: m.clientX, clientY: m.clientY }]), m.preventDefault && m.preventDefault());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(m) {
  var c = this.$refs.draggable.getBoundingClientRect(), ie = c.left, we = c.right, $e = c.bottom, Me = c.top;
  this.anchor = { left: m.clientX - ie, top: m.clientY - Me, bottom: $e - m.clientY, right: we - m.clientX };
}, processMove: function(m, c) {
  var ie = b$1(c);
  if (this.touches.length) {
    if (this.touches.length === 1 && ie.length === 1) {
      var we = this.$refs.draggable;
      this.$emit("drag", new k(m, we, { left: ie[0].clientX, top: ie[0].clientY }, { left: this.touches[0].clientX, top: this.touches[0].clientY }, this.anchor));
    }
    this.touches = ie;
  }
}, processEnd: function() {
  this.touches.length && this.$emit("drag-end"), this.hovered && (this.$emit("leave"), this.hovered = !1), this.touches = [];
} }, emits: ["drag", "drag-end", "leave", "enter"] };
F.render = function(m, c, ie, we, $e, Me) {
  return openBlock(), createBlock("div", { ref: "draggable", class: ie.classname, onTouchstart: c[1] || (c[1] = function() {
    return Me.onTouchStart && Me.onTouchStart.apply(Me, arguments);
  }), onMousedown: c[2] || (c[2] = function() {
    return Me.onMouseDown && Me.onMouseDown.apply(Me, arguments);
  }), onMouseover: c[3] || (c[3] = function() {
    return Me.onMouseOver && Me.onMouseOver.apply(Me, arguments);
  }), onMouseleave: c[4] || (c[4] = function() {
    return Me.onMouseLeave && Me.onMouseLeave.apply(Me, arguments);
  }) }, [renderSlot(m.$slots, "default")], 34);
};
var U = M("vue-handler-wrapper"), N$1 = { name: "HandlerWrapper", components: { DraggableElement: F }, props: { horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, computed: { classes: function() {
  var m;
  if (this.horizontalPosition || this.verticalPosition) {
    var c, ie = E(this.horizontalPosition, this.verticalPosition);
    m = U((f$1(c = {}, ie.classname, !0), f$1(c, "disabled", this.disabled), c));
  } else
    m = U({ disabled: this.disabled });
  return { root: m, draggable: U("draggable") };
} }, emits: ["leave", "enter", "drag", "drag-end"] };
N$1.render = function(m, c, ie, we, $e, Me) {
  var Ze = resolveComponent("DraggableElement");
  return openBlock(), createBlock("div", { class: Me.classes.root }, [createVNode(Ze, { class: Me.classes.draggable, onDrag: c[1] || (c[1] = function(ne) {
    return m.$emit("drag", ne);
  }), onDragEnd: c[2] || (c[2] = function(ne) {
    return m.$emit("drag-end");
  }), onLeave: c[3] || (c[3] = function(ne) {
    return m.$emit("leave");
  }), onEnter: c[4] || (c[4] = function(ne) {
    return m.$emit("enter");
  }) }, { default: withCtx(function() {
    return [renderSlot(m.$slots, "default")];
  }), _: 3 }, 8, ["class"])], 2);
};
var Z = M("vue-line-wrapper"), q = { name: "LineWrapper", components: { DraggableElement: F }, props: { position: { type: String, required: !0 }, disabled: { type: Boolean, default: !1 } }, computed: { classname: function() {
  var m;
  return Z((f$1(m = {}, this.position, !0), f$1(m, "disabled", this.disabled), m));
} }, emits: ["leave", "enter", "drag", "drag-end"] };
q.render = function(m, c, ie, we, $e, Me) {
  var Ze = resolveComponent("DraggableElement");
  return openBlock(), createBlock(Ze, { class: Me.classname, onDrag: c[1] || (c[1] = function(ne) {
    return m.$emit("drag", ne);
  }), onDragEnd: c[2] || (c[2] = function(ne) {
    return m.$emit("drag-end");
  }), onLeave: c[3] || (c[3] = function(ne) {
    return m.$emit("leave");
  }), onEnter: c[4] || (c[4] = function(ne) {
    return m.$emit("enter");
  }) }, { default: withCtx(function() {
    return [renderSlot(m.$slots, "default")];
  }), _: 3 }, 8, ["class"]);
};
var V = ["left", "right", "top", "bottom"], _ = ["left", "right"], G = ["top", "bottom"], Q = ["left", "top"], K = ["fill-area", "fit-area", "stencil", "none"], J = { left: 0, top: 0, width: 0, height: 0 };
function tt$1(m, c, ie) {
  return !(ie = ie || ["width", "height", "left", "top"]).some(function(we) {
    return m[we] !== c[we];
  });
}
function et$1(m) {
  return { left: m.left, top: m.top, right: m.left + m.width, bottom: m.top + m.height };
}
function it$1(m, c) {
  return { left: m.left - c.left, top: m.top - c.top };
}
function nt$1(m) {
  return { left: m.left + m.width / 2, top: m.top + m.height / 2 };
}
function st$1(m, c) {
  var ie = { left: 0, top: 0, right: 0, bottom: 0 };
  return V.forEach(function(we) {
    var $e = c[we], Me = et$1(m)[we];
    ie[we] = $e !== void 0 && Me !== void 0 ? we === "left" || we === "top" ? Math.max(0, $e - Me) : Math.max(0, Me - $e) : 0;
  }), ie;
}
function ot$1(m, c) {
  return { left: m.left - c.left, top: m.top - c.top, width: m.width + c.left + c.right, height: m.height + c.top + c.bottom };
}
function rt$1(m) {
  return { left: -m.left, top: -m.top };
}
function at$1(m, c) {
  return C(C({}, m), { left: m.left + c.left, top: m.top + c.top });
}
function ht$1(m, c, ie, we) {
  if (c !== 1) {
    if (ie) {
      var $e = nt$1(m);
      return { width: m.width * c, height: m.height * c, left: m.left + m.width * (1 - c) / 2 + (ie.left - $e.left) * (we || 1 - c), top: m.top + m.height * (1 - c) / 2 + (ie.top - $e.top) * (we || 1 - c) };
    }
    return { width: m.width * c, height: m.height * c, left: m.left + m.width * (1 - c) / 2, top: m.top + m.height * (1 - c) / 2 };
  }
  return m;
}
function ct$1(m) {
  return m.width / m.height;
}
function lt$5(m, c) {
  return Math.min(c.right !== void 0 && c.left !== void 0 ? (c.right - c.left) / m.width : 1 / 0, c.bottom !== void 0 && c.top !== void 0 ? (c.bottom - c.top) / m.height : 1 / 0);
}
function ut$1(m, c) {
  var ie = { left: 0, top: 0 }, we = st$1(m, c);
  return we.left && we.left > 0 ? ie.left = we.left : we.right && we.right > 0 && (ie.left = -we.right), we.top && we.top > 0 ? ie.top = we.top : we.bottom && we.bottom > 0 && (ie.top = -we.bottom), ie;
}
function dt$1(m, c) {
  var ie;
  return c.minimum && m < c.minimum ? ie = c.minimum : c.maximum && m > c.maximum && (ie = c.maximum), ie;
}
function mt$1(m, c) {
  var ie = ct$1(m), we = ct$1(c);
  return c.width < 1 / 0 && c.height < 1 / 0 ? ie > we ? { width: c.width, height: c.width / ie } : { width: c.height * ie, height: c.height } : c.width < 1 / 0 ? { width: c.width, height: c.width / ie } : c.height < 1 / 0 ? { width: c.height * ie, height: c.height } : m;
}
function pt$1(m, c) {
  var ie = c * Math.PI / 180;
  return { width: Math.abs(m.width * Math.cos(ie)) + Math.abs(m.height * Math.sin(ie)), height: Math.abs(m.width * Math.sin(ie)) + Math.abs(m.height * Math.cos(ie)) };
}
function gt$6(m, c) {
  var ie = c * Math.PI / 180;
  return { left: m.left * Math.cos(ie) - m.top * Math.sin(ie), top: m.left * Math.sin(ie) + m.top * Math.cos(ie) };
}
function ft$1(m, c) {
  var ie = st$1(vt$1(m, c), c);
  return ie.left + ie.right + ie.top + ie.bottom ? ie.left + ie.right > ie.top + ie.bottom ? Math.min((m.width + ie.left + ie.right) / m.width, lt$5(m, c)) : Math.min((m.height + ie.top + ie.bottom) / m.height, lt$5(m, c)) : 1;
}
function vt$1(m, c, ie) {
  ie === void 0 && (ie = !1);
  var we = ut$1(m, c);
  return at$1(m, ie ? rt$1(we) : we);
}
function bt$1(m) {
  return { width: m.right !== void 0 && m.left !== void 0 ? m.right - m.left : 1 / 0, height: m.bottom !== void 0 && m.top !== void 0 ? m.bottom - m.top : 1 / 0 };
}
function wt$1(m, c) {
  return C(C({}, m), { minWidth: Math.min(c.width, m.minWidth), minHeight: Math.min(c.height, m.minHeight), maxWidth: Math.min(c.width, m.maxWidth), maxHeight: Math.min(c.height, m.maxHeight) });
}
function yt$1(m, c, ie) {
  ie === void 0 && (ie = !0);
  var we = {};
  return V.forEach(function($e) {
    var Me = m[$e], Ze = c[$e];
    Me !== void 0 && Ze !== void 0 ? we[$e] = $e === "left" || $e === "top" ? ie ? Math.max(Me, Ze) : Math.min(Me, Ze) : ie ? Math.min(Me, Ze) : Math.max(Me, Ze) : Ze !== void 0 ? we[$e] = Ze : Me !== void 0 && (we[$e] = Me);
  }), we;
}
function zt(m, c) {
  return yt$1(m, c, !0);
}
function Rt$1(m) {
  var c = m.size, ie = m.aspectRatio, we = m.ignoreMinimum, $e = m.sizeRestrictions;
  return Boolean((c.correctRatio || ct$1(c) >= ie.minimum && ct$1(c) <= ie.maximum) && c.height <= $e.maxHeight && c.width <= $e.maxWidth && c.width && c.height && (we || c.height >= $e.minHeight && c.width >= $e.minWidth));
}
function At$1(m, c) {
  return Math.pow(m.width - c.width, 2) + Math.pow(m.height - c.height, 2);
}
function Mt$1(m) {
  var c = m.width, ie = m.height, we = m.sizeRestrictions, $e = { minimum: m.aspectRatio && m.aspectRatio.minimum || 0, maximum: m.aspectRatio && m.aspectRatio.maximum || 1 / 0 }, Me = { width: Math.max(we.minWidth, Math.min(we.maxWidth, c)), height: Math.max(we.minHeight, Math.min(we.maxHeight, ie)) };
  function Ze(gr, or) {
    return or === void 0 && (or = !1), gr.reduce(function(_r, Lr) {
      return Rt$1({ size: Lr, aspectRatio: $e, sizeRestrictions: we, ignoreMinimum: or }) && (!_r || At$1(Lr, { width: c, height: ie }) < At$1(_r, { width: c, height: ie })) ? Lr : _r;
    }, null);
  }
  var ne = [];
  $e && [$e.minimum, $e.maximum].forEach(function(gr) {
    gr && ne.push({ width: Me.width, height: Me.width / gr, correctRatio: !0 }, { width: Me.height * gr, height: Me.height, correctRatio: !0 });
  }), Rt$1({ size: Me, aspectRatio: $e, sizeRestrictions: we }) && ne.push(Me);
  var rr = Ze(ne) || Ze(ne, !0);
  return rr && { width: rr.width, height: rr.height };
}
function St$1(m) {
  var c = m.event, ie = m.coordinates, we = m.positionRestrictions, $e = we === void 0 ? {} : we, Me = at$1(ie, c.directions);
  return at$1(Me, ut$1(Me, $e));
}
function xt$1(m) {
  var c = m.coordinates, ie = m.transform, we = m.imageSize, $e = m.sizeRestrictions, Me = m.positionRestrictions, Ze = m.aspectRatio, ne = m.visibleArea, rr = function(or, _r) {
    return St$1({ coordinates: or, positionRestrictions: Me, event: new Y({ left: _r.left - or.left, top: _r.top - or.top }) });
  }, gr = C({}, c);
  return (Array.isArray(ie) ? ie : [ie]).forEach(function(or) {
    var _r = {};
    D$1((_r = typeof or == "function" ? or({ coordinates: gr, imageSize: we, visibleArea: ne }) : or).width) && D$1(_r.height) || (gr = function(Lr, Ir) {
      var Ar = C(C(C({}, Lr), Mt$1({ width: Ir.width, height: Ir.height, sizeRestrictions: $e, aspectRatio: Ze })), { left: 0, top: 0 });
      return rr(Ar, { left: Lr.left, top: Lr.top });
    }(gr, C(C({}, gr), _r))), D$1(_r.left) && D$1(_r.top) || (gr = rr(gr, C(C({}, gr), _r)));
  }), gr;
}
function Ct$1(m) {
  m.event;
  var c = m.getAreaRestrictions, ie = m.boundaries, we = m.coordinates, $e = m.visibleArea;
  m.aspectRatio;
  var Me = m.stencilSize, Ze = m.sizeRestrictions, ne = m.positionRestrictions;
  m.stencilReference;
  var rr, gr, or, _r = C({}, we), Lr = C({}, $e), Ir = C({}, Me);
  rr = ct$1(Ir), gr = ct$1(_r), or === void 0 && (or = 1e-3), (rr === 0 || gr === 0 ? Math.abs(gr - rr) < or : Math.abs(gr / rr) < 1 + or && Math.abs(gr / rr) > 1 - or) || (_r = C(C({}, _r), Mt$1({ sizeRestrictions: Ze, width: _r.width, height: _r.height, aspectRatio: { minimum: ct$1(Ir), maximum: ct$1(Ir) } })));
  var Ar = ft$1(Lr = ht$1(Lr, _r.width * ie.width / (Lr.width * Ir.width)), c({ visibleArea: Lr, type: "resize" }));
  return Ar !== 1 && (Lr = ht$1(Lr, Ar), _r = ht$1(_r, Ar)), Lr = vt$1(Lr = at$1(Lr, it$1(nt$1(_r), nt$1(Lr))), c({ visibleArea: Lr, type: "move" })), { coordinates: _r = vt$1(_r, zt(et$1(Lr), ne)), visibleArea: Lr };
}
function Et$1(m) {
  var c = m.event, ie = m.getAreaRestrictions, we = m.boundaries, $e = m.coordinates, Me = m.visibleArea;
  m.aspectRatio, m.stencilSize, m.sizeRestrictions;
  var Ze = m.positionRestrictions;
  m.stencilReference;
  var ne = C({}, $e), rr = C({}, Me);
  if ($e && Me && c.type !== "manipulateImage") {
    var gr = { width: 0, height: 0 };
    rr.width, we.width, ct$1(we) > ct$1(ne) ? (gr.height = 0.8 * we.height, gr.width = gr.height * ct$1(ne)) : (gr.width = 0.8 * we.width, gr.height = gr.width * ct$1(ne));
    var or = ft$1(rr = ht$1(rr, ne.width * we.width / (rr.width * gr.width)), ie({ visibleArea: rr, type: "resize" }));
    rr = ht$1(rr, or), or !== 1 && (gr.height /= or, gr.width /= or), rr = vt$1(rr = at$1(rr, it$1(nt$1(ne), nt$1(rr))), ie({ visibleArea: rr, type: "move" })), ne = vt$1(ne, zt(et$1(rr), Ze));
  }
  return { coordinates: ne, visibleArea: rr };
}
function Wt$1(m) {
  var c = m.event, ie = m.coordinates, we = m.visibleArea, $e = m.getAreaRestrictions, Me = C({}, we), Ze = C({}, ie);
  if (c.type === "setCoordinates") {
    var ne = Math.max(0, Ze.width - Me.width), rr = Math.max(0, Ze.height - Me.height);
    ne > rr ? Me = ht$1(Me, Math.min(Ze.width / Me.width, lt$5(Me, $e({ visibleArea: Me, type: "resize" })))) : rr > ne && (Me = ht$1(Me, Math.min(Ze.height / Me.height, lt$5(Me, $e({ visibleArea: Me, type: "resize" }))))), Me = vt$1(Me = at$1(Me, rt$1(ut$1(Ze, et$1(Me)))), $e({ visibleArea: Me, type: "move" }));
  }
  return { visibleArea: Me, coordinates: Ze };
}
function Tt$1(m) {
  var c = m.imageSize, ie = m.visibleArea, we = m.coordinates, $e = ie || c;
  return { left: (ie ? ie.left : 0) + $e.width / 2 - we.width / 2, top: (ie ? ie.top : 0) + $e.height / 2 - we.height / 2 };
}
function Ot$1(m) {
  var c = m.imageSize, ie = m.visibleArea, we = m.aspectRatio, $e = m.sizeRestrictions, Me = ie || c, Ze = Math.min(we.maximum || 1 / 0, Math.max(we.minimum || 0, ct$1(Me))), ne = Me.width < Me.height ? { width: 0.8 * Me.width, height: 0.8 * Me.width / Ze } : { height: 0.8 * Me.height, width: 0.8 * Me.height * Ze };
  return Mt$1(C(C({}, ne), { aspectRatio: we, sizeRestrictions: $e }));
}
function Dt$1(m) {
  var c, ie, we = m.imageSize, $e = m.visibleArea, Me = m.boundaries, Ze = m.aspectRatio, ne = m.sizeRestrictions, rr = m.stencilSize, gr = $e || we;
  return ct$1(gr) > ct$1(Me) ? ie = (c = rr.height * gr.height / Me.height) * ct$1(rr) : c = (ie = rr.width * gr.width / Me.width) / ct$1(rr), Mt$1({ width: ie, height: c, aspectRatio: Ze, sizeRestrictions: ne });
}
function Ht(m) {
  var c = m.getAreaRestrictions, ie = m.coordinates, we = m.imageSize, $e = ct$1(m.boundaries);
  if (ie) {
    var Me = { height: Math.max(ie.height, we.height), width: Math.max(ie.width, we.width) }, Ze = mt$1({ width: ct$1(Me) > $e ? Me.width : Me.height * $e, height: ct$1(Me) > $e ? Me.width / $e : Me.height }, bt$1(c())), ne = { left: ie.left + ie.width / 2 - Ze.width / 2, top: ie.top + ie.height / 2 - Ze.height / 2, width: Ze.width, height: Ze.height }, rr = st$1(ie, et$1(C({ left: 0, top: 0 }, we))), gr = {};
    return !rr.left && !rr.right && ne.width <= we.width && (gr.left = 0, gr.right = we.width), !rr.top && !rr.bottom && ne.height <= we.height && (gr.top = 0, gr.bottom = we.height), vt$1(ne, gr);
  }
  var or = ct$1(we);
  return Ze = { height: or > $e ? we.height : we.width / $e, width: or > $e ? we.height * $e : we.width }, { left: we.width / 2 - Ze.width / 2, top: we.height / 2 - Ze.height / 2, width: Ze.width, height: Ze.height };
}
function jt(m, c) {
  return yt$1(m, et$1(c));
}
function Lt(m) {
  var c = m.event, ie = m.coordinates, we = m.visibleArea, $e = m.sizeRestrictions, Me = m.getAreaRestrictions, Ze = m.positionRestrictions, ne = m.adjustStencil, rr = c.scale, gr = c.move, or = C({}, we), _r = C({}, ie), Lr = 1, Ir = 1, Ar = rr.factor && Math.abs(rr.factor - 1) > 1e-3;
  or = at$1(or, { left: gr.left || 0, top: gr.top || 0 });
  var Rr = { stencil: { minimum: Math.max($e.minWidth ? $e.minWidth / _r.width : 0, $e.minHeight ? $e.minHeight / _r.height : 0), maximum: Math.min($e.maxWidth ? $e.maxWidth / _r.width : 1 / 0, $e.maxHeight ? $e.maxHeight / _r.height : 1 / 0, lt$5(_r, Ze)) }, area: { maximum: lt$5(or, Me({ visibleArea: or, type: "resize" })) } };
  rr.factor && Ar && (rr.factor < 1 ? (Ir = Math.max(rr.factor, Rr.stencil.minimum)) > 1 && (Ir = 1) : rr.factor > 1 && (Ir = Math.min(rr.factor, Math.min(Rr.area.maximum, Rr.stencil.maximum))) < 1 && (Ir = 1)), Ir && (or = ht$1(or, Ir, rr.center));
  var Nr = ie.left - we.left, Yr = we.width + we.left - (ie.width + ie.left), Vr = ie.top - we.top, Xr = we.height + we.top - (ie.height + ie.top);
  return or = vt$1(or = at$1(or, ut$1(or, { left: Ze.left !== void 0 ? Ze.left - Nr * Ir : void 0, top: Ze.top !== void 0 ? Ze.top - Vr * Ir : void 0, bottom: Ze.bottom !== void 0 ? Ze.bottom + Xr * Ir : void 0, right: Ze.right !== void 0 ? Ze.right + Yr * Ir : void 0 })), Me({ visibleArea: or, type: "move" })), _r.width = _r.width * Ir, _r.height = _r.height * Ir, _r.left = or.left + Nr * Ir, _r.top = or.top + Vr * Ir, _r = vt$1(_r, zt(et$1(or), Ze)), rr.factor && Ar && ne && (rr.factor > 1 ? Lr = Math.min(Rr.area.maximum, rr.factor) / Ir : rr.factor < 1 && (Lr = Math.max(_r.height / or.height, _r.width / or.width, rr.factor / Ir)), Lr !== 1 && (or = at$1(or = vt$1(or = ht$1(or, Lr, rr.factor > 1 ? rr.center : nt$1(_r)), Me({ visibleArea: or, type: "move" })), rt$1(ut$1(_r, et$1(or)))))), { coordinates: _r, visibleArea: or };
}
function Pt$1(m) {
  var c = m.aspectRatio, ie = m.getAreaRestrictions, we = m.coordinates, $e = m.visibleArea, Me = m.sizeRestrictions, Ze = m.positionRestrictions, ne = m.imageSize, rr = m.previousImageSize, gr = m.angle, or = C({}, we), _r = C({}, $e), Lr = gt$6(nt$1(C({ left: 0, top: 0 }, rr)), gr);
  return (or = C(C({}, Mt$1({ sizeRestrictions: Me, aspectRatio: c, width: or.width, height: or.height })), gt$6(nt$1(or), gr))).left -= Lr.left - ne.width / 2 + or.width / 2, or.top -= Lr.top - ne.height / 2 + or.height / 2, _r = ht$1(_r, ft$1(_r, ie({ visibleArea: _r, type: "resize" }))), { coordinates: or = vt$1(or, Ze), visibleArea: _r = vt$1(_r = at$1(_r, it$1(nt$1(or), nt$1(we))), ie({ visibleArea: _r, type: "move" })) };
}
function $t(m) {
  var c = m.flip, ie = m.previousFlip, we = m.rotate;
  m.aspectRatio;
  var $e = m.getAreaRestrictions, Me = m.coordinates, Ze = m.visibleArea, ne = m.imageSize, rr = C({}, Me), gr = C({}, Ze), or = ie.horizontal !== c.horizontal, _r = ie.vertical !== c.vertical;
  if (or || _r) {
    var Lr = gt$6({ left: ne.width / 2, top: ne.height / 2 }, -we), Ir = gt$6(nt$1(rr), -we), Ar = gt$6({ left: or ? Lr.left - (Ir.left - Lr.left) : Ir.left, top: _r ? Lr.top - (Ir.top - Lr.top) : Ir.top }, we);
    rr = at$1(rr, it$1(Ar, nt$1(rr))), Ir = gt$6(nt$1(gr), -we), gr = vt$1(gr = at$1(gr, it$1(Ar = gt$6({ left: or ? Lr.left - (Ir.left - Lr.left) : Ir.left, top: _r ? Lr.top - (Ir.top - Lr.top) : Ir.top }, we), nt$1(gr))), $e({ visibleArea: gr, type: "move" }));
  }
  return { coordinates: rr, visibleArea: gr };
}
function It(m) {
  var c = m.directions, ie = m.coordinates, we = m.positionRestrictions, $e = we === void 0 ? {} : we, Me = m.sizeRestrictions, Ze = m.preserveRatio, ne = m.compensate, rr = C({}, c), gr = ot$1(ie, rr).width, or = ot$1(ie, rr).height;
  gr < 0 && (rr.left < 0 && rr.right < 0 ? (rr.left = -(ie.width - Me.minWidth) / (rr.left / rr.right), rr.right = -(ie.width - Me.minWidth) / (rr.right / rr.left)) : rr.left < 0 ? rr.left = -(ie.width - Me.minWidth) : rr.right < 0 && (rr.right = -(ie.width - Me.minWidth))), or < 0 && (rr.top < 0 && rr.bottom < 0 ? (rr.top = -(ie.height - Me.minHeight) / (rr.top / rr.bottom), rr.bottom = -(ie.height - Me.minHeight) / (rr.bottom / rr.top)) : rr.top < 0 ? rr.top = -(ie.height - Me.minHeight) : rr.bottom < 0 && (rr.bottom = -(ie.height - Me.minHeight)));
  var _r = st$1(ot$1(ie, rr), $e);
  ne && (_r.left && _r.left > 0 && _r.right === 0 ? (rr.right += _r.left, rr.left -= _r.left) : _r.right && _r.right > 0 && _r.left === 0 && (rr.left += _r.right, rr.right -= _r.right), _r.top && _r.top > 0 && _r.bottom === 0 ? (rr.bottom += _r.top, rr.top -= _r.top) : _r.bottom && _r.bottom > 0 && _r.top === 0 && (rr.top += _r.bottom, rr.bottom -= _r.bottom), _r = st$1(ot$1(ie, rr), $e));
  var Lr = { width: 1 / 0, height: 1 / 0, left: 1 / 0, right: 1 / 0, top: 1 / 0, bottom: 1 / 0 };
  if (V.forEach(function(Rr) {
    var Nr = _r[Rr];
    Nr && rr[Rr] && (Lr[Rr] = Math.max(0, 1 - Nr / rr[Rr]));
  }), Ze) {
    var Ir = Math.min.apply(null, V.map(function(Rr) {
      return Lr[Rr];
    }));
    Ir !== 1 / 0 && V.forEach(function(Rr) {
      rr[Rr] *= Ir;
    });
  } else
    V.forEach(function(Rr) {
      Lr[Rr] !== 1 / 0 && (rr[Rr] *= Lr[Rr]);
    });
  if (gr = ot$1(ie, rr).width, or = ot$1(ie, rr).height, rr.right + rr.left && (gr > Me.maxWidth ? Lr.width = (Me.maxWidth - ie.width) / (rr.right + rr.left) : gr < Me.minWidth && (Lr.width = (Me.minWidth - ie.width) / (rr.right + rr.left))), rr.bottom + rr.top && (or > Me.maxHeight ? Lr.height = (Me.maxHeight - ie.height) / (rr.bottom + rr.top) : or < Me.minHeight && (Lr.height = (Me.minHeight - ie.height) / (rr.bottom + rr.top))), Ze) {
    var Ar = Math.min(Lr.width, Lr.height);
    Ar !== 1 / 0 && V.forEach(function(Rr) {
      rr[Rr] *= Ar;
    });
  } else
    Lr.width !== 1 / 0 && _.forEach(function(Rr) {
      rr[Rr] *= Lr.width;
    }), Lr.height !== 1 / 0 && G.forEach(function(Rr) {
      rr[Rr] *= Lr.height;
    });
  return rr;
}
function Bt(m, c, ie) {
  return c == 0 && ie == 0 ? m / 2 : c == 0 ? 0 : ie == 0 ? m : m * Math.abs(c / (c + ie));
}
var Xt$1 = M("vue-simple-handler"), Yt$1 = M("vue-simple-handler-wrapper"), kt = { name: "SimpleHandler", components: { HandlerWrapper: N$1 }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  var m, c = (f$1(m = {}, this.horizontalPosition, Boolean(this.horizontalPosition)), f$1(m, this.verticalPosition, Boolean(this.verticalPosition)), f$1(m, "".concat(this.horizontalPosition, "-").concat(this.verticalPosition), Boolean(this.verticalPosition && this.horizontalPosition)), f$1(m, "hover", this.hover), m);
  return { default: A$1(Xt$1(c), this.defaultClass, this.hover && this.hoverClass), wrapper: A$1(Yt$1(c), this.wrapperClass) };
} }, methods: { onDrag: function(m) {
  this.$emit("drag", m);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
kt.render = function(m, c, ie, we, $e, Me) {
  var Ze = resolveComponent("HandlerWrapper");
  return openBlock(), createBlock(Ze, { class: Me.classes.wrapper, "vertical-position": ie.verticalPosition, "horizontal-position": ie.horizontalPosition, disabled: ie.disabled, onDrag: Me.onDrag, onDragEnd: Me.onDragEnd, onEnter: Me.onEnter, onLeave: Me.onLeave }, { default: withCtx(function() {
    return [createVNode("div", { class: Me.classes.default }, null, 2)];
  }), _: 1 }, 8, ["class", "vertical-position", "horizontal-position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var Ft = M("vue-simple-line"), Ut = M("vue-simple-line-wrapper"), Nt = { name: "SimpleLine", components: { LineWrapper: q }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, position: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  return { root: A$1(Ft(f$1({}, this.position, !0)), this.defaultClass, this.hover && this.hoverClass), wrapper: A$1(Ut(f$1({}, this.position, !0)), this.wrapperClass) };
} }, methods: { onDrag: function(m) {
  this.$emit("drag", m);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
Nt.render = function(m, c, ie, we, $e, Me) {
  var Ze = resolveComponent("LineWrapper");
  return openBlock(), createBlock(Ze, { class: Me.classes.wrapper, position: ie.position, disabled: ie.disabled, onDrag: Me.onDrag, onDragEnd: Me.onDragEnd, onEnter: Me.onEnter, onLeave: Me.onLeave }, { default: withCtx(function() {
    return [createVNode("div", { class: Me.classes.root }, null, 2)];
  }), _: 1 }, 8, ["class", "position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var Zt = M("vue-bounding-box"), qt = ["east", "west", null], Vt = ["south", "north", null], _t$1 = { name: "BoundingBox", props: { width: { type: Number }, height: { type: Number }, transitions: { type: Object }, handlers: { type: Object, default: function() {
  return { eastNorth: !0, north: !0, westNorth: !0, west: !0, westSouth: !0, south: !0, eastSouth: !0, east: !0 };
} }, handlersComponent: { type: [Object, String], default: function() {
  return kt;
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} }, lines: { type: Object, default: function() {
  return { west: !0, north: !0, east: !0, south: !0 };
} }, linesComponent: { type: [Object, String], default: function() {
  return Nt;
} }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, resizable: { type: Boolean, default: !0 } }, data: function() {
  var m = [];
  return qt.forEach(function(c) {
    Vt.forEach(function(ie) {
      if (c !== ie) {
        var we = E(c, ie), $e = we.name, Me = we.classname;
        m.push({ name: $e, classname: Me, verticalDirection: ie, horizontalDirection: c });
      }
    });
  }), { points: m };
}, computed: { style: function() {
  var m = {};
  return this.width && this.height && (m.width = "".concat(this.width, "px"), m.height = "".concat(this.height, "px"), this.transitions && this.transitions.enabled && (m.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction))), m;
}, classes: function() {
  var m = this.handlersClasses, c = this.handlersWrappersClasses, ie = this.linesClasses, we = this.linesWrappersClasses;
  return { root: Zt(), handlers: m, handlersWrappers: c, lines: ie, linesWrappers: we };
}, lineNodes: function() {
  var m = this, c = [];
  return this.points.forEach(function(ie) {
    ie.horizontalDirection && ie.verticalDirection || !m.lines[ie.name] || c.push({ name: ie.name, component: m.linesComponent, class: A$1(m.classes.lines.default, m.classes.lines[ie.name], !m.resizable && m.classes.lines.disabled), wrapperClass: A$1(m.classes.linesWrappers.default, m.classes.linesWrappers[ie.name], !m.resizable && m.classes.linesWrappers.disabled), hoverClass: m.classes.lines.hover, verticalDirection: ie.verticalDirection, horizontalDirection: ie.horizontalDirection, disabled: !m.resizable });
  }), c;
}, handlerNodes: function() {
  var m = this, c = [], ie = this.width, we = this.height;
  return this.points.forEach(function($e) {
    if (m.handlers[$e.name]) {
      var Me = { name: $e.name, component: m.handlersComponent, class: A$1(m.classes.handlers.default, m.classes.handlers[$e.name]), wrapperClass: A$1(m.classes.handlersWrappers.default, m.classes.handlersWrappers[$e.name]), hoverClass: m.classes.handlers.hover, verticalDirection: $e.verticalDirection, horizontalDirection: $e.horizontalDirection, disabled: !m.resizable };
      if (ie && we) {
        var Ze = $e.horizontalDirection, ne = $e.verticalDirection, rr = Ze === "east" ? ie : Ze === "west" ? 0 : ie / 2, gr = ne === "south" ? we : ne === "north" ? 0 : we / 2;
        Me.wrapperClass = Zt("handler"), Me.wrapperStyle = { transform: "translate(".concat(rr, "px, ").concat(gr, "px)") }, m.transitions && m.transitions.enabled && (Me.wrapperStyle.transition = "".concat(m.transitions.time, "ms ").concat(m.transitions.timingFunction));
      } else
        Me.wrapperClass = Zt("handler", f$1({}, $e.classname, !0));
      c.push(Me);
    }
  }), c;
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [];
}, methods: { onEnd: function() {
  this.$emit("resize-end");
}, onHandlerDrag: function(m, c, ie) {
  var we, $e = m.shift(), Me = $e.left, Ze = $e.top, ne = { left: 0, right: 0, top: 0, bottom: 0 };
  c === "west" ? ne.left -= Me : c === "east" && (ne.right += Me), ie === "north" ? ne.top -= Ze : ie === "south" && (ne.bottom += Ze), !ie && c ? we = "width" : ie && !c && (we = "height"), this.resizable && this.$emit("resize", new X(ne, { allowedDirections: { left: c === "west" || !c, right: c === "east" || !c, bottom: ie === "south" || !ie, top: ie === "north" || !ie }, preserveAspectRatio: m.nativeEvent && m.nativeEvent.shiftKey, respectDirection: we }));
} }, emits: ["resize", "resize-end"] };
_t$1.render = function(m, c, ie, we, $e, Me) {
  return openBlock(), createBlock("div", { ref: "box", class: Me.classes.root, style: Me.style }, [renderSlot(m.$slots, "default"), createVNode("div", null, [(openBlock(!0), createBlock(Fragment, null, renderList(Me.lineNodes, function(Ze) {
    return openBlock(), createBlock(resolveDynamicComponent(Ze.component), { key: Ze.name, "default-class": Ze.class, "hover-class": Ze.hoverClass, "wrapper-class": Ze.wrapperClass, position: Ze.name, disabled: Ze.disabled, onDrag: function(ne) {
      return Me.onHandlerDrag(ne, Ze.horizontalDirection, Ze.verticalDirection);
    }, onDragEnd: c[1] || (c[1] = function(ne) {
      return Me.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "position", "disabled", "onDrag"]);
  }), 128))]), (openBlock(!0), createBlock(Fragment, null, renderList(Me.handlerNodes, function(Ze) {
    return openBlock(), createBlock("div", { key: Ze.name, style: Ze.wrapperStyle, class: Ze.wrapperClass }, [(openBlock(), createBlock(resolveDynamicComponent(Ze.component), { "default-class": Ze.class, "hover-class": Ze.hoverClass, "wrapper-class": Ze.wrapperClass, "horizontal-position": Ze.horizontalDirection, "vertical-position": Ze.verticalDirection, disabled: Ze.disabled, onDrag: function(ne) {
      return Me.onHandlerDrag(ne, Ze.horizontalDirection, Ze.verticalDirection);
    }, onDragEnd: c[2] || (c[2] = function(ne) {
      return Me.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "horizontal-position", "vertical-position", "disabled", "onDrag"]))], 6);
  }), 128))], 6);
};
var Gt = M("vue-draggable-area"), Qt = { name: "DraggableArea", props: { movable: { type: Boolean, default: !0 }, activationDistance: { type: Number, default: 20 } }, computed: { classnames: function() {
  return { default: Gt() };
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [], this.touchStarted = !1;
}, methods: { onTouchStart: function(m) {
  if (m.cancelable) {
    var c = this.movable && m.touches.length === 1;
    c && (this.touches = b$1(m.touches)), (this.touchStarted || c) && (m.preventDefault(), m.stopPropagation());
  }
}, onTouchEnd: function() {
  this.touchStarted = !1, this.processEnd();
}, onTouchMove: function(m) {
  this.touches.length >= 1 && (this.touchStarted ? (this.processMove(m, m.touches), m.preventDefault(), m.stopPropagation()) : I$1({ x: this.touches[0].clientX, y: this.touches[0].clientY }, { x: m.touches[0].clientX, y: m.touches[0].clientY }) > this.activationDistance && (this.initAnchor({ clientX: m.touches[0].clientX, clientY: m.touches[0].clientY }), this.touchStarted = !0));
}, onMouseDown: function(m) {
  if (this.movable && m.button === 0) {
    var c = { fake: !0, clientX: m.clientX, clientY: m.clientY };
    this.touches = [c], this.initAnchor(c), m.stopPropagation();
  }
}, onMouseMove: function(m) {
  this.touches.length && (this.processMove(m, [{ fake: !0, clientX: m.clientX, clientY: m.clientY }]), m.preventDefault && m.cancelable && m.preventDefault(), m.stopPropagation());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(m) {
  var c = this.$refs.container.getBoundingClientRect(), ie = c.left, we = c.top;
  this.anchor = { x: m.clientX - ie, y: m.clientY - we };
}, processMove: function(m, c) {
  var ie = b$1(c);
  if (this.touches.length) {
    var we = this.$refs.container.getBoundingClientRect(), $e = we.left, Me = we.top;
    this.touches.length === 1 && ie.length === 1 && this.$emit("move", new Y({ left: ie[0].clientX - ($e + this.anchor.x), top: ie[0].clientY - (Me + this.anchor.y) }));
  }
}, processEnd: function() {
  this.touches.length && this.$emit("move-end"), this.touches = [];
} }, emits: ["move", "move-end"] };
Qt.render = function(m, c, ie, we, $e, Me) {
  return openBlock(), createBlock("div", { ref: "container", onTouchstart: c[1] || (c[1] = function() {
    return Me.onTouchStart && Me.onTouchStart.apply(Me, arguments);
  }), onMousedown: c[2] || (c[2] = function() {
    return Me.onMouseDown && Me.onMouseDown.apply(Me, arguments);
  }) }, [renderSlot(m.$slots, "default")], 544);
};
function Kt(m) {
  var c, ie;
  return { rotate: m.rotate || 0, flip: { horizontal: ((c = m?.flip) === null || c === void 0 ? void 0 : c.horizontal) || !1, vertical: ((ie = m?.flip) === null || ie === void 0 ? void 0 : ie.vertical) || !1 } };
}
function Jt(m) {
  return new Promise(function(c, ie) {
    try {
      if (m)
        if (/^data:/i.test(m))
          c(function(rr) {
            rr = rr.replace(/^data:([^;]+);base64,/gim, "");
            for (var gr = atob(rr), or = gr.length, _r = new ArrayBuffer(or), Lr = new Uint8Array(_r), Ir = 0; Ir < or; Ir++)
              Lr[Ir] = gr.charCodeAt(Ir);
            return _r;
          }(m));
        else if (/^blob:/i.test(m)) {
          var we = new FileReader();
          we.onload = function(rr) {
            c(rr.target.result);
          }, Me = m, Ze = function(rr) {
            we.readAsArrayBuffer(rr);
          }, (ne = new XMLHttpRequest()).open("GET", Me, !0), ne.responseType = "blob", ne.onload = function() {
            this.status != 200 && this.status !== 0 || Ze(this.response);
          }, ne.send();
        } else {
          var $e = new XMLHttpRequest();
          $e.onreadystatechange = function() {
            $e.readyState === 4 && ($e.status === 200 || $e.status === 0 ? c($e.response) : ie("Warning: could not load an image to parse its orientation"), $e = null);
          }, $e.onprogress = function() {
            $e.getResponseHeader("content-type") !== "image/jpeg" && $e.abort();
          }, $e.withCredentials = !1, $e.open("GET", m, !0), $e.responseType = "arraybuffer", $e.send(null);
        }
      else
        ie("Error: the image is empty");
    } catch (rr) {
      ie(rr);
    }
    var Me, Ze, ne;
  });
}
function te(m) {
  var c = m.rotate, ie = m.flip, we = m.scaleX, $e = m.scaleY, Me = "";
  return Me += " rotate(" + c + "deg) ", Me += " scaleX(" + we * (ie.horizontal ? -1 : 1) + ") ", Me += " scaleY(" + $e * (ie.vertical ? -1 : 1) + ") ";
}
function ee(m) {
  try {
    var c, ie = new DataView(m), we = void 0, $e = void 0, Me = void 0, Ze = void 0;
    if (ie.getUint8(0) === 255 && ie.getUint8(1) === 216)
      for (var ne = ie.byteLength, rr = 2; rr + 1 < ne; ) {
        if (ie.getUint8(rr) === 255 && ie.getUint8(rr + 1) === 225) {
          Me = rr;
          break;
        }
        rr++;
      }
    if (Me && (we = Me + 10, function(Ir, Ar, Rr) {
      var Nr, Yr = "";
      for (Nr = Ar, Rr += Ar; Nr < Rr; Nr++)
        Yr += String.fromCharCode(Ir.getUint8(Nr));
      return Yr;
    }(ie, Me + 4, 4) === "Exif")) {
      var gr = ie.getUint16(we);
      if ((($e = gr === 18761) || gr === 19789) && ie.getUint16(we + 2, $e) === 42) {
        var or = ie.getUint32(we + 4, $e);
        or >= 8 && (Ze = we + or);
      }
    }
    if (Ze) {
      for (var _r = ie.getUint16(Ze, $e), Lr = 0; Lr < _r; Lr++)
        if (rr = Ze + 12 * Lr + 2, ie.getUint16(rr, $e) === 274) {
          rr += 8, c = ie.getUint16(rr, $e), ie.setUint16(rr, 1, $e);
          break;
        }
    }
    return c;
  } catch {
    return null;
  }
}
function se(m, c) {
  var ie = c.getBoundingClientRect(), we = ie.left, $e = ie.top, Me = { left: 0, top: 0 }, Ze = 0;
  return m.forEach(function(ne) {
    Me.left += (ne.clientX - we) / m.length, Me.top += (ne.clientY - $e) / m.length;
  }), m.forEach(function(ne) {
    Ze += I$1({ x: Me.left, y: Me.top }, { x: ne.clientX - we, y: ne.clientY - $e });
  }), { centerMass: Me, spread: Ze, count: m.length };
}
var oe = { props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 }, eventsFilter: { type: Function, required: !1 } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, created: function() {
  this.transforming = !1, this.debouncedProcessEnd = x(this.processEnd), this.touches = [];
}, methods: { processMove: function(m, c) {
  if (this.touches.length) {
    if (this.touches.length === 1 && c.length === 1)
      this.$emit("move", new B$1({ left: this.touches[0].clientX - c[0].clientX, top: this.touches[0].clientY - c[0].clientY }));
    else if (this.touches.length > 1 && this.touchResize) {
      var ie = se(c, this.$refs.container), we = this.oldGeometricProperties;
      we.count === ie.count && we.count > 1 && this.$emit("resize", new B$1({ left: we.centerMass.left - ie.centerMass.left, top: we.centerMass.top - ie.centerMass.top }, { factor: we.spread / ie.spread, center: ie.centerMass })), this.oldGeometricProperties = ie;
    }
    this.touches = c;
  }
}, processEnd: function() {
  this.transforming && (this.transforming = !1, this.$emit("transform-end"));
}, processStart: function() {
  this.transforming = !0, this.debouncedProcessEnd.clear();
}, processEvent: function(m) {
  return this.eventsFilter ? this.eventsFilter(m, this.transforming) !== !1 : (m.preventDefault(), m.stopPropagation(), !0);
}, onTouchStart: function(m) {
  if (m.cancelable && (this.touchMove || this.touchResize && m.touches.length > 1) && this.processEvent(m)) {
    var c = this.$refs.container, ie = c.getBoundingClientRect(), we = ie.left, $e = ie.top, Me = ie.bottom, Ze = ie.right;
    this.touches = b$1(m.touches).filter(function(ne) {
      return ne.clientX > we && ne.clientX < Ze && ne.clientY > $e && ne.clientY < Me;
    }), this.oldGeometricProperties = se(this.touches, c);
  }
}, onTouchEnd: function(m) {
  m.touches.length === 0 && (this.touches = [], this.processEnd());
}, onTouchMove: function(m) {
  var c = this;
  if (this.touches.length) {
    var ie = b$1(m.touches).filter(function(we) {
      return !we.identifier || c.touches.find(function($e) {
        return $e.identifier === we.identifier;
      });
    });
    this.processEvent(m) && (this.processMove(m, ie), this.processStart());
  }
}, onMouseDown: function(m) {
  if (this.mouseMove && "buttons" in m && m.buttons === 1 && this.processEvent(m)) {
    var c = { fake: !0, clientX: m.clientX, clientY: m.clientY };
    this.touches = [c], this.processStart();
  }
}, onMouseMove: function(m) {
  this.touches.length && this.processEvent(m) && this.processMove(m, [{ clientX: m.clientX, clientY: m.clientY }]);
}, onMouseUp: function() {
  this.touches = [], this.processEnd();
}, onWheel: function(m) {
  if (this.wheelResize && this.processEvent(m)) {
    var c = this.$refs.container.getBoundingClientRect(), ie = c.left, we = c.top, $e = 1 + this.wheelResize.ratio * (Ze = m.deltaY || m.detail || m.wheelDelta, (ne = +Ze) == 0 || $(ne) ? ne : ne > 0 ? 1 : -1), Me = { left: m.clientX - ie, top: m.clientY - we };
    this.$emit("resize", new B$1({}, { factor: $e, center: Me })), this.touches.length || this.debouncedProcessEnd();
  }
  var Ze, ne;
} }, emits: ["resize", "move", "transform-end"] };
oe.render = function(m, c, ie, we, $e, Me) {
  return openBlock(), createBlock("div", { ref: "container", onTouchstart: c[1] || (c[1] = function() {
    return Me.onTouchStart && Me.onTouchStart.apply(Me, arguments);
  }), onMousedown: c[2] || (c[2] = function() {
    return Me.onMouseDown && Me.onMouseDown.apply(Me, arguments);
  }), onWheel: c[3] || (c[3] = function() {
    return Me.onWheel && Me.onWheel.apply(Me, arguments);
  }) }, [renderSlot(m.$slots, "default")], 544);
};
var re$4 = { components: { TransformableImage: oe }, props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 } }, emits: ["resize", "move"] };
re$4.render = function(m, c, ie, we, $e, Me) {
  var Ze = resolveComponent("transformable-image");
  return openBlock(), createBlock(Ze, { "touch-move": ie.touchMove, "touch-resize": ie.touchResize, "mouse-move": ie.mouseMove, "wheel-resize": ie.wheelResize, onMove: c[1] || (c[1] = function(ne) {
    return m.$emit("move", ne);
  }), onResize: c[2] || (c[2] = function(ne) {
    return m.$emit("resize", ne);
  }) }, { default: withCtx(function() {
    return [renderSlot(m.$slots, "default")];
  }), _: 3 }, 8, ["touch-move", "touch-resize", "mouse-move", "wheel-resize"]);
};
var ae$1 = M("vue-preview"), he$1 = { props: { coordinates: { type: Object }, transitions: { type: Object }, image: { type: Object, default: function() {
  return {};
} }, imageClass: { type: String }, width: { type: Number }, height: { type: Number }, fill: { type: Boolean } }, data: function() {
  return { calculatedImageSize: { width: 0, height: 0 }, calculatedSize: { width: 0, height: 0 } };
}, computed: { classes: function() {
  return { root: ae$1({ fill: this.fill }), wrapper: ae$1("wrapper"), imageWrapper: ae$1("image-wrapper"), image: A$1(ae$1("image"), this.imageClass) };
}, style: function() {
  if (this.fill)
    return {};
  var m = {};
  return this.width && (m.width = "".concat(this.size.width, "px")), this.height && (m.height = "".concat(this.size.height, "px")), this.transitions && this.transitions.enabled && (m.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), m;
}, wrapperStyle: function() {
  var m = { width: "".concat(this.size.width, "px"), height: "".concat(this.size.height, "px"), left: "calc(50% - ".concat(this.size.width / 2, "px)"), top: "calc(50% - ".concat(this.size.height / 2, "px)") };
  return this.transitions && this.transitions.enabled && (m.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), m;
}, imageStyle: function() {
  if (this.coordinates && this.image) {
    var m = this.coordinates.width / this.size.width, c = g$1(g$1({ rotate: 0, flip: { horizontal: !1, vertical: !1 } }, this.image.transforms), {}, { scaleX: 1 / m, scaleY: 1 / m }), ie = this.imageSize.width, we = this.imageSize.height, $e = pt$1({ width: ie, height: we }, c.rotate), Me = { width: "".concat(ie, "px"), height: "".concat(we, "px"), left: "0px", top: "0px" }, Ze = { rotate: { left: (ie - $e.width) * c.scaleX / 2, top: (we - $e.height) * c.scaleY / 2 }, scale: { left: (1 - c.scaleX) * ie / 2, top: (1 - c.scaleY) * we / 2 } };
    return Me.transform = `translate(
				`.concat(-this.coordinates.left / m - Ze.rotate.left - Ze.scale.left, "px,").concat(-this.coordinates.top / m - Ze.rotate.top - Ze.scale.top, "px) ") + te(c), this.transitions && this.transitions.enabled && (Me.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), Me;
  }
  return {};
}, size: function() {
  return { width: this.width || this.calculatedSize.width, height: this.height || this.calculatedSize.height };
}, imageSize: function() {
  return { width: this.image.width || this.calculatedImageSize.width, height: this.image.height || this.calculatedImageSize.height };
} }, watch: { image: function(m) {
  (m.width || m.height) && this.onChangeImage();
} }, mounted: function() {
  var m = this;
  this.onChangeImage(), this.$refs.image.addEventListener("load", function() {
    m.refreshImage();
  }), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh);
}, methods: { refreshImage: function() {
  var m = this.$refs.image;
  this.calculatedImageSize.height = m.naturalHeight, this.calculatedImageSize.width = m.naturalWidth;
}, refresh: function() {
  var m = this.$refs.root;
  this.width || (this.calculatedSize.width = m.clientWidth), this.height || (this.calculatedSize.height = m.clientHeight);
}, onChangeImage: function() {
  var m = this.$refs.image;
  m && m.complete && this.refreshImage(), this.refresh();
} } };
he$1.render = function(m, c, ie, we, $e, Me) {
  return openBlock(), createBlock("div", { ref: "root", class: Me.classes.root, style: Me.style }, [createVNode("div", { ref: "wrapper", class: Me.classes.wrapper, style: Me.wrapperStyle }, [withDirectives(createVNode("img", { ref: "image", src: ie.image && ie.image.src, class: Me.classes.image, style: Me.imageStyle }, null, 14, ["src"]), [[vShow, ie.image && ie.image.src]])], 6)], 6);
};
var ce$1 = { components: { Preview: he$1 }, inheritAttrs: !1 };
ce$1.render = function(m, c, ie, we, $e, Me) {
  var Ze = resolveComponent("preview");
  return openBlock(), createBlock(Ze, mergeProps(m.$attrs, { fill: !0 }), null, 16);
};
var le = M("vue-rectangle-stencil"), ue = { name: "RectangleStencil", components: { StencilPreview: ce$1, BoundingBox: _t$1, DraggableArea: Qt }, props: { image: { type: Object }, coordinates: { type: Object }, stencilCoordinates: { type: Object }, handlers: { type: Object }, handlersComponent: { type: [Object, String], default: function() {
  return kt;
} }, lines: { type: Object }, linesComponent: { type: [Object, String], default: function() {
  return Nt;
} }, aspectRatio: { type: [Number, String] }, minAspectRatio: { type: [Number, String] }, maxAspectRatio: { type: [Number, String] }, movable: { type: Boolean, default: !0 }, resizable: { type: Boolean, default: !0 }, transitions: { type: Object }, movingClass: { type: String }, resizingClass: { type: String }, previewClass: { type: String }, boundingBoxClass: { type: String }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} } }, data: function() {
  return { moving: !1, resizing: !1 };
}, computed: { classes: function() {
  return { stencil: A$1(le({ movable: this.movable, moving: this.moving, resizing: this.resizing }), this.moving && this.movingClass, this.resizing && this.resizingClass), preview: A$1(le("preview"), this.previewClass), boundingBox: A$1(le("bounding-box"), this.boundingBoxClass) };
}, style: function() {
  var m = this.stencilCoordinates, c = m.height, ie = m.width, we = m.left, $e = m.top, Me = { width: "".concat(ie, "px"), height: "".concat(c, "px"), transform: "translate(".concat(we, "px, ").concat($e, "px)") };
  return this.transitions && this.transitions.enabled && (Me.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), Me;
} }, methods: { onMove: function(m) {
  this.$emit("move", m), this.moving = !0;
}, onMoveEnd: function() {
  this.$emit("move-end"), this.moving = !1;
}, onResize: function(m) {
  this.$emit("resize", m), this.resizing = !0;
}, onResizeEnd: function() {
  this.$emit("resize-end"), this.resizing = !1;
}, aspectRatios: function() {
  return { minimum: this.aspectRatio || this.minAspectRatio, maximum: this.aspectRatio || this.maxAspectRatio };
} }, emits: ["resize", "resize-end", "move", "move-end"] };
ue.render = function(m, c, ie, we, $e, Me) {
  var Ze = resolveComponent("stencil-preview"), ne = resolveComponent("draggable-area"), rr = resolveComponent("bounding-box");
  return openBlock(), createBlock("div", { class: Me.classes.stencil, style: Me.style }, [createVNode(rr, { width: ie.stencilCoordinates.width, height: ie.stencilCoordinates.height, transitions: ie.transitions, class: Me.classes.boundingBox, handlers: ie.handlers, "handlers-component": ie.handlersComponent, "handlers-classes": ie.handlersClasses, "handlers-wrappers-classes": ie.handlersWrappersClasses, lines: ie.lines, "lines-component": ie.linesComponent, "lines-classes": ie.linesClasses, "lines-wrappers-classes": ie.linesWrappersClasses, resizable: ie.resizable, onResize: Me.onResize, onResizeEnd: Me.onResizeEnd }, { default: withCtx(function() {
    return [createVNode(ne, { movable: ie.movable, onMove: Me.onMove, onMoveEnd: Me.onMoveEnd }, { default: withCtx(function() {
      return [createVNode(Ze, { image: ie.image, coordinates: ie.coordinates, width: ie.stencilCoordinates.width, height: ie.stencilCoordinates.height, class: Me.classes.preview, transitions: ie.transitions }, null, 8, ["image", "coordinates", "width", "height", "class", "transitions"])];
    }), _: 1 }, 8, ["movable", "onMove", "onMoveEnd"])];
  }), _: 1 }, 8, ["width", "height", "transitions", "class", "handlers", "handlers-component", "handlers-classes", "handlers-wrappers-classes", "lines", "lines-component", "lines-classes", "lines-wrappers-classes", "resizable", "onResize", "onResizeEnd"])], 6);
};
var pe$1 = ["transitions"], ge = M("vue-advanced-cropper"), fe = { name: "Cropper", components: { BackgroundWrapper: re$4 }, props: { src: { type: String, default: null }, stencilComponent: { type: [Object, String], default: function() {
  return ue;
} }, backgroundWrapperComponent: { type: [Object, String], default: function() {
  return re$4;
} }, stencilProps: { type: Object, default: function() {
  return {};
} }, autoZoom: { type: Boolean, default: !1 }, imageClass: { type: String }, boundariesClass: { type: String }, backgroundClass: { type: String }, foregroundClass: { type: String }, minWidth: { type: [Number, String] }, minHeight: { type: [Number, String] }, maxWidth: { type: [Number, String] }, maxHeight: { type: [Number, String] }, debounce: { type: [Boolean, Number], default: 500 }, transitions: { type: Boolean, default: !0 }, checkOrientation: { type: Boolean, default: !0 }, canvas: { type: [Object, Boolean], default: !0 }, crossOrigin: { type: [Boolean, String], default: void 0 }, transitionTime: { type: Number, default: 300 }, imageRestriction: { type: String, default: "fit-area", validator: function(m) {
  return K.indexOf(m) !== -1;
} }, roundResult: { type: Boolean, default: !0 }, defaultSize: { type: [Function, Object] }, defaultPosition: { type: [Function, Object] }, defaultVisibleArea: { type: [Function, Object] }, defaultTransforms: { type: [Function, Object] }, defaultBoundaries: { type: [Function, String], validator: function(m) {
  return !(typeof m == "string" && m !== "fill" && m !== "fit");
} }, priority: { type: String, default: "coordinates" }, stencilSize: { type: [Object, Function] }, resizeImage: { type: [Boolean, Object], default: !0 }, moveImage: { type: [Boolean, Object], default: !0 }, autoZoomAlgorithm: { type: Function }, resizeAlgorithm: { type: Function, default: function(m) {
  var c = m.event, ie = m.coordinates, we = m.aspectRatio, $e = m.positionRestrictions, Me = m.sizeRestrictions, Ze = C(C({}, ie), { right: ie.left + ie.width, bottom: ie.top + ie.height }), ne = c.params || {}, rr = C({}, c.directions), gr = ne.allowedDirections || { left: !0, right: !0, bottom: !0, top: !0 };
  Me.widthFrozen && (rr.left = 0, rr.right = 0), Me.heightFrozen && (rr.top = 0, rr.bottom = 0), V.forEach(function(Wr) {
    gr[Wr] || (rr[Wr] = 0);
  });
  var or = ot$1(Ze, rr = It({ coordinates: Ze, directions: rr, sizeRestrictions: Me, positionRestrictions: $e })).width, _r = ot$1(Ze, rr).height, Lr = ne.preserveRatio ? ct$1(Ze) : dt$1(or / _r, we);
  if (Lr) {
    var Ir = ne.respectDirection;
    if (Ir || (Ir = Ze.width >= Ze.height || Lr === 1 ? "width" : "height"), Ir === "width") {
      var Ar = or / Lr - Ze.height;
      if (gr.top && gr.bottom) {
        var Rr = rr.top, Nr = rr.bottom;
        rr.bottom = Bt(Ar, Nr, Rr), rr.top = Bt(Ar, Rr, Nr);
      } else
        gr.bottom ? rr.bottom = Ar : gr.top ? rr.top = Ar : gr.right ? rr.right = 0 : gr.left && (rr.left = 0);
    } else if (Ir === "height") {
      var Yr = Ze.width - _r * Lr;
      if (gr.left && gr.right) {
        var Vr = rr.left, Xr = rr.right;
        rr.left = -Bt(Yr, Vr, Xr), rr.right = -Bt(Yr, Xr, Vr);
      } else
        gr.left ? rr.left = -Yr : gr.right ? rr.right = -Yr : gr.top ? rr.top = 0 : gr.bottom && (rr.bottom = 0);
    }
    rr = It({ directions: rr, coordinates: Ze, sizeRestrictions: Me, positionRestrictions: $e, preserveRatio: !0, compensate: ne.compensate });
  }
  return or = ot$1(Ze, rr).width, _r = ot$1(Ze, rr).height, (Lr = ne.preserveRatio ? ct$1(Ze) : dt$1(or / _r, we)) && Math.abs(Lr - or / _r) > 1e-3 && V.forEach(function(Wr) {
    gr[Wr] || (rr[Wr] = 0);
  }), St$1({ event: new Y({ left: -rr.left, top: -rr.top }), coordinates: { width: ie.width + rr.right + rr.left, height: ie.height + rr.top + rr.bottom, left: ie.left, top: ie.top }, positionRestrictions: $e });
} }, moveAlgorithm: { type: Function, default: St$1 }, initStretcher: { type: Function, default: function(m) {
  var c = m.stretcher, ie = m.imageSize, we = ct$1(ie);
  c.style.width = ie.width + "px", c.style.height = c.clientWidth / we + "px", c.style.width = c.clientWidth + "px";
} }, fitCoordinates: { type: Function, default: function(m) {
  var c = m.visibleArea, ie = m.coordinates, we = m.aspectRatio, $e = m.sizeRestrictions, Me = m.positionRestrictions, Ze = C(C({}, ie), Mt$1({ width: ie.width, height: ie.height, aspectRatio: we, sizeRestrictions: { maxWidth: c.width, maxHeight: c.height, minHeight: Math.min(c.height, $e.minHeight), minWidth: Math.min(c.width, $e.minWidth) } }));
  return Ze = vt$1(Ze = at$1(Ze, it$1(nt$1(ie), nt$1(Ze))), zt(et$1(c), Me));
} }, fitVisibleArea: { type: Function, default: function(m) {
  var c = m.visibleArea, ie = m.boundaries, we = m.getAreaRestrictions, $e = m.coordinates, Me = C({}, c);
  Me.height = Me.width / ct$1(ie), Me.top += (c.height - Me.height) / 2, ($e.height - Me.height > 0 || $e.width - Me.width > 0) && (Me = ht$1(Me, Math.max($e.height / Me.height, $e.width / Me.width)));
  var Ze = rt$1(ut$1($e, et$1(Me = ht$1(Me, ft$1(Me, we({ visibleArea: Me, type: "resize" }))))));
  return Me.width < $e.width && (Ze.left = 0), Me.height < $e.height && (Ze.top = 0), Me = vt$1(Me = at$1(Me, Ze), we({ visibleArea: Me, type: "move" }));
} }, areaRestrictionsAlgorithm: { type: Function, default: function(m) {
  var c = m.visibleArea, ie = m.boundaries, we = m.imageSize, $e = m.imageRestriction, Me = m.type, Ze = {};
  return $e === "fill-area" ? Ze = { left: 0, top: 0, right: we.width, bottom: we.height } : $e === "fit-area" && (ct$1(ie) > ct$1(we) ? (Ze = { top: 0, bottom: we.height }, c && Me === "move" && (c.width > we.width ? (Ze.left = -(c.width - we.width) / 2, Ze.right = we.width - Ze.left) : (Ze.left = 0, Ze.right = we.width))) : (Ze = { left: 0, right: we.width }, c && Me === "move" && (c.height > we.height ? (Ze.top = -(c.height - we.height) / 2, Ze.bottom = we.height - Ze.top) : (Ze.top = 0, Ze.bottom = we.height)))), Ze;
} }, sizeRestrictionsAlgorithm: { type: Function, default: function(m) {
  return { minWidth: m.minWidth, minHeight: m.minHeight, maxWidth: m.maxWidth, maxHeight: m.maxHeight };
} }, positionRestrictionsAlgorithm: { type: Function, default: function(m) {
  var c = m.imageSize, ie = {};
  return m.imageRestriction !== "none" && (ie = { left: 0, top: 0, right: c.width, bottom: c.height }), ie;
} } }, data: function() {
  return { transitionsActive: !1, imageLoaded: !1, imageAttributes: { width: null, height: null, crossOrigin: null, src: null }, defaultImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, appliedImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, boundaries: { width: 0, height: 0 }, visibleArea: null, coordinates: g$1({}, J) };
}, computed: { image: function() {
  return { src: this.imageAttributes.src, width: this.imageAttributes.width, height: this.imageAttributes.height, transforms: this.imageTransforms };
}, imageTransforms: function() {
  return { rotate: this.appliedImageTransforms.rotate, flip: { horizontal: this.appliedImageTransforms.flip.horizontal, vertical: this.appliedImageTransforms.flip.vertical }, translateX: this.visibleArea ? this.visibleArea.left / this.coefficient : 0, translateY: this.visibleArea ? this.visibleArea.top / this.coefficient : 0, scaleX: 1 / this.coefficient, scaleY: 1 / this.coefficient };
}, imageSize: function() {
  var m = function(c) {
    return c * Math.PI / 180;
  }(this.imageTransforms.rotate);
  return { width: Math.abs(this.imageAttributes.width * Math.cos(m)) + Math.abs(this.imageAttributes.height * Math.sin(m)), height: Math.abs(this.imageAttributes.width * Math.sin(m)) + Math.abs(this.imageAttributes.height * Math.cos(m)) };
}, initialized: function() {
  return Boolean(this.visibleArea && this.imageLoaded);
}, settings: function() {
  var m = j(this.resizeImage, { touch: !0, wheel: { ratio: 0.1 }, adjustStencil: !0 }, { touch: !1, wheel: !1, adjustStencil: !1 });
  return { moveImage: j(this.moveImage, { touch: !0, mouse: !0 }, { touch: !1, mouse: !1 }), resizeImage: m };
}, coefficient: function() {
  return this.visibleArea ? this.visibleArea.width / this.boundaries.width : 0;
}, areaRestrictions: function() {
  return this.imageLoaded ? this.areaRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction, boundaries: this.boundaries }) : {};
}, transitionsOptions: function() {
  return { enabled: this.transitionsActive, timingFunction: "ease-in-out", time: 350 };
}, sizeRestrictions: function() {
  if (this.boundaries.width && this.boundaries.height && this.imageSize.width && this.imageSize.height) {
    var m = this.sizeRestrictionsAlgorithm({ imageSize: this.imageSize, minWidth: D$1(this.minWidth) ? 0 : L(this.minWidth), minHeight: D$1(this.minHeight) ? 0 : L(this.minHeight), maxWidth: D$1(this.maxWidth) ? 1 / 0 : L(this.maxWidth), maxHeight: D$1(this.maxHeight) ? 1 / 0 : L(this.maxHeight) });
    if (m = function(we) {
      var $e = we.areaRestrictions, Me = we.sizeRestrictions;
      we.imageSize;
      var Ze = we.boundaries, ne = we.positionRestrictions;
      we.imageRestriction;
      var rr = C(C({}, Me), { minWidth: Me.minWidth !== void 0 ? Me.minWidth : 0, minHeight: Me.minHeight !== void 0 ? Me.minHeight : 0, maxWidth: Me.maxWidth !== void 0 ? Me.maxWidth : 1 / 0, maxHeight: Me.maxHeight !== void 0 ? Me.maxHeight : 1 / 0 });
      ne.left !== void 0 && ne.right !== void 0 && (rr.maxWidth = Math.min(rr.maxWidth, ne.right - ne.left)), ne.bottom !== void 0 && ne.top !== void 0 && (rr.maxHeight = Math.min(rr.maxHeight, ne.bottom - ne.top));
      var gr = bt$1($e), or = mt$1(Ze, gr);
      return gr.width < 1 / 0 && (!rr.maxWidth || rr.maxWidth > or.width) && (rr.maxWidth = Math.min(rr.maxWidth, or.width)), gr.height < 1 / 0 && (!rr.maxHeight || rr.maxHeight > or.height) && (rr.maxHeight = Math.min(rr.maxHeight, or.height)), rr.minWidth > rr.maxWidth && (rr.minWidth = rr.maxWidth, rr.widthFrozen = !0), rr.minHeight > rr.maxHeight && (rr.minHeight = rr.maxHeight, rr.heightFrozen = !0), rr;
    }({ sizeRestrictions: m, areaRestrictions: this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }), imageSize: this.imageSize, boundaries: this.boundaries, positionRestrictions: this.positionRestrictions, imageRestriction: this.imageRestriction, visibleArea: this.visibleArea, stencilSize: this.getStencilSize() }), this.visibleArea && this.stencilSize) {
      var c = this.getStencilSize(), ie = bt$1(this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }));
      m.maxWidth = Math.min(m.maxWidth, ie.width * c.width / this.boundaries.width), m.maxHeight = Math.min(m.maxHeight, ie.height * c.height / this.boundaries.height), m.maxWidth < m.minWidth && (m.minWidth = m.maxWidth), m.maxHeight < m.minHeight && (m.minHeight = m.maxHeight);
    }
    return m;
  }
  return { minWidth: 0, minHeight: 0, maxWidth: 0, maxHeight: 0 };
}, positionRestrictions: function() {
  return this.positionRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction });
}, classes: function() {
  return { cropper: ge(), image: A$1(ge("image"), this.imageClass), stencil: ge("stencil"), boundaries: A$1(ge("boundaries"), this.boundariesClass), stretcher: A$1(ge("stretcher")), background: A$1(ge("background"), this.backgroundClass), foreground: A$1(ge("foreground"), this.foregroundClass), imageWrapper: A$1(ge("image-wrapper")), cropperWrapper: A$1(ge("cropper-wrapper")) };
}, stencilCoordinates: function() {
  if (this.initialized) {
    var m = this.coordinates, c = m.width, ie = m.height, we = m.left, $e = m.top;
    return { width: c / this.coefficient, height: ie / this.coefficient, left: (we - this.visibleArea.left) / this.coefficient, top: ($e - this.visibleArea.top) / this.coefficient };
  }
  return this.defaultCoordinates();
}, boundariesStyle: function() {
  var m = { width: this.boundaries.width ? "".concat(Math.round(this.boundaries.width), "px") : "auto", height: this.boundaries.height ? "".concat(Math.round(this.boundaries.height), "px") : "auto", transition: "opacity ".concat(this.transitionTime, "ms"), pointerEvents: this.imageLoaded ? "all" : "none" };
  return this.imageLoaded || (m.opacity = "0"), m;
}, imageStyle: function() {
  var m = this.imageAttributes.width > this.imageAttributes.height ? { width: Math.min(1024, this.imageAttributes.width), height: Math.min(1024, this.imageAttributes.width) / (this.imageAttributes.width / this.imageAttributes.height) } : { height: Math.min(1024, this.imageAttributes.height), width: Math.min(1024, this.imageAttributes.height) * (this.imageAttributes.width / this.imageAttributes.height) }, c = { left: (m.width - this.imageSize.width) / (2 * this.coefficient), top: (m.height - this.imageSize.height) / (2 * this.coefficient) }, ie = { left: (1 - 1 / this.coefficient) * m.width / 2, top: (1 - 1 / this.coefficient) * m.height / 2 }, we = g$1(g$1({}, this.imageTransforms), {}, { scaleX: this.imageTransforms.scaleX * (this.imageAttributes.width / m.width), scaleY: this.imageTransforms.scaleY * (this.imageAttributes.height / m.height) }), $e = { width: "".concat(m.width, "px"), height: "".concat(m.height, "px"), left: "0px", top: "0px", transform: "translate(".concat(-c.left - ie.left - this.imageTransforms.translateX, "px, ").concat(-c.top - ie.top - this.imageTransforms.translateY, "px)") + te(we) };
  return this.transitionsOptions.enabled && ($e.transition = "".concat(this.transitionsOptions.time, "ms ").concat(this.transitionsOptions.timingFunction)), $e;
} }, watch: { src: function() {
  this.onChangeImage();
}, stencilComponent: function() {
  var m = this;
  this.$nextTick(function() {
    m.resetCoordinates(), m.runAutoZoom("setCoordinates"), m.onChange();
  });
}, minWidth: function() {
  this.onPropsChange();
}, maxWidth: function() {
  this.onPropsChange();
}, minHeight: function() {
  this.onPropsChange();
}, maxHeight: function() {
  this.onPropsChange();
}, imageRestriction: function() {
  this.reset();
}, stencilProps: function(m, c) {
  ["aspectRatio", "minAspectRatio", "maxAspectRatio"].find(function(ie) {
    return m[ie] !== c[ie];
  }) && this.$nextTick(this.onPropsChange);
} }, created: function() {
  this.debouncedUpdate = x(this.update, this.debounce), this.debouncedDisableTransitions = x(this.disableTransitions, this.transitionsOptions.time), this.awaiting = !1;
}, mounted: function() {
  this.$refs.image.addEventListener("load", this.onSuccessLoadImage), this.$refs.image.addEventListener("error", this.onFailLoadImage), this.onChangeImage(), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh), this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.debouncedUpdate.clear(), this.debouncedDisableTransitions.clear();
}, methods: { getResult: function() {
  var m = this.initialized ? this.prepareResult(g$1({}, this.coordinates)) : this.defaultCoordinates(), c = { rotate: this.imageTransforms.rotate % 360, flip: g$1({}, this.imageTransforms.flip) };
  if (this.src && this.imageLoaded) {
    var ie = this;
    return { image: this.image, coordinates: m, visibleArea: this.visibleArea ? g$1({}, this.visibleArea) : null, imageTransforms: c, get canvas() {
      return ie.canvas ? ie.getCanvas() : void 0;
    } };
  }
  return { image: this.image, coordinates: m, visibleArea: this.visibleArea ? g$1({}, this.visibleArea) : null, canvas: void 0, imageTransforms: c };
}, zoom: function(m, c) {
  var ie = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, we = ie.transitions, $e = we === void 0 || we;
  this.onManipulateImage(new B$1({}, { factor: 1 / m, center: c }), { normalize: !1, transitions: $e });
}, move: function(m, c) {
  var ie = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, we = ie.transitions, $e = we === void 0 || we;
  this.onManipulateImage(new B$1({ left: m || 0, top: c || 0 }), { normalize: !1, transitions: $e });
}, setCoordinates: function(m) {
  var c = this, ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, we = ie.autoZoom, $e = we === void 0 || we, Me = ie.transitions, Ze = Me === void 0 || Me;
  this.$nextTick(function() {
    c.imageLoaded ? (c.transitionsActive || (Ze && c.enableTransitions(), c.coordinates = c.applyTransform(m), $e && c.runAutoZoom("setCoordinates"), Ze && c.debouncedDisableTransitions()), c.onChange()) : c.delayedTransforms = m;
  });
}, refresh: function() {
  var m = this, c = this.$refs.image;
  if (this.src && c)
    return this.initialized ? this.updateVisibleArea().then(function() {
      m.onChange();
    }) : this.resetVisibleArea().then(function() {
      m.onChange();
    });
}, reset: function() {
  var m = this;
  return this.resetVisibleArea().then(function() {
    m.onChange(!1);
  });
}, awaitRender: function(m) {
  var c = this;
  this.awaiting || (this.awaiting = !0, this.$nextTick(function() {
    m(), c.awaiting = !1;
  }));
}, prepareResult: function(m) {
  return this.roundResult ? function(c) {
    var ie = c.coordinates, we = c.sizeRestrictions, $e = c.positionRestrictions, Me = { width: Math.round(ie.width), height: Math.round(ie.height), left: Math.round(ie.left), top: Math.round(ie.top) };
    return Me.width > we.maxWidth ? Me.width = Math.floor(ie.width) : Me.width < we.minWidth && (Me.width = Math.ceil(ie.width)), Me.height > we.maxHeight ? Me.height = Math.floor(ie.height) : Me.height < we.minHeight && (Me.height = Math.ceil(ie.height)), vt$1(Me, $e);
  }(g$1(g$1({}, this.getPublicProperties()), {}, { positionRestrictions: jt(this.positionRestrictions, this.visibleArea), coordinates: m })) : m;
}, processAutoZoom: function(m, c, ie, we) {
  var $e = this.autoZoomAlgorithm;
  $e || ($e = this.stencilSize ? Ct$1 : this.autoZoom ? Et$1 : Wt$1);
  var Me = $e({ event: { type: m, params: we }, visibleArea: c, coordinates: ie, boundaries: this.boundaries, aspectRatio: this.getAspectRatio(), positionRestrictions: this.positionRestrictions, getAreaRestrictions: this.getAreaRestrictions, sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize() });
  return g$1(g$1({}, Me), {}, { changed: !tt$1(Me.visibleArea, c) || !tt$1(Me.coordinates, ie) });
}, runAutoZoom: function(m) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ie = c.transitions, we = ie !== void 0 && ie, $e = v$1(c, pe$1), Me = this.processAutoZoom(m, this.visibleArea, this.coordinates, $e), Ze = Me.visibleArea, ne = Me.coordinates, rr = Me.changed;
  we && rr && this.enableTransitions(), this.visibleArea = Ze, this.coordinates = ne, we && rr && this.debouncedDisableTransitions();
}, normalizeEvent: function(m) {
  return function(c) {
    var ie = c.event, we = c.visibleArea, $e = c.coefficient;
    if (ie.type === "manipulateImage")
      return C(C({}, ie), { move: { left: ie.move && ie.move.left ? $e * ie.move.left : 0, top: ie.move && ie.move.top ? $e * ie.move.top : 0 }, scale: { factor: ie.scale && ie.scale.factor ? ie.scale.factor : 1, center: ie.scale && ie.scale.center ? { left: ie.scale.center.left * $e + we.left, top: ie.scale.center.top * $e + we.top } : null } });
    if (ie.type === "resize") {
      var Me = C(C({}, ie), { directions: C({}, ie.directions) });
      return V.forEach(function(ne) {
        Me.directions[ne] *= $e;
      }), Me;
    }
    if (ie.type === "move") {
      var Ze = C(C({}, ie), { directions: C({}, ie.directions) });
      return Q.forEach(function(ne) {
        Ze.directions[ne] *= $e;
      }), Ze;
    }
    return ie;
  }(g$1(g$1({}, this.getPublicProperties()), {}, { event: m }));
}, getCanvas: function() {
  if (this.$refs.canvas) {
    var m = this.$refs.canvas, c = this.$refs.image, ie = this.imageTransforms.rotate !== 0 || this.imageTransforms.flip.horizontal || this.imageTransforms.flip.vertical ? function(ne, rr, gr) {
      var or = gr.rotate, _r = gr.flip, Lr = { width: rr.naturalWidth, height: rr.naturalHeight }, Ir = pt$1(Lr, or), Ar = ne.getContext("2d");
      ne.height = Ir.height, ne.width = Ir.width, Ar.save();
      var Rr = gt$6(nt$1(C({ left: 0, top: 0 }, Lr)), or);
      return Ar.translate(-(Rr.left - Ir.width / 2), -(Rr.top - Ir.height / 2)), Ar.rotate(or * Math.PI / 180), Ar.translate(_r.horizontal ? Lr.width : 0, _r.vertical ? Lr.height : 0), Ar.scale(_r.horizontal ? -1 : 1, _r.vertical ? -1 : 1), Ar.drawImage(rr, 0, 0, Lr.width, Lr.height), Ar.restore(), ne;
    }(this.$refs.sourceCanvas, c, this.imageTransforms) : c, we = g$1({ minWidth: 0, minHeight: 0, maxWidth: 1 / 0, maxHeight: 1 / 0, maxArea: this.maxCanvasSize, imageSmoothingEnabled: !0, imageSmoothingQuality: "high", fillColor: "transparent" }, this.canvas), $e = function(ne) {
      return ne.find(function(rr) {
        return gr = rr, !Number.isNaN(parseFloat(gr)) && isFinite(gr);
        var gr;
      });
    }, Me = Mt$1({ sizeRestrictions: { minWidth: $e([we.width, we.minWidth]) || 0, minHeight: $e([we.height, we.minHeight]) || 0, maxWidth: $e([we.width, we.maxWidth]) || 1 / 0, maxHeight: $e([we.height, we.maxHeight]) || 1 / 0 }, width: this.coordinates.width, height: this.coordinates.height, aspectRatio: { minimum: this.coordinates.width / this.coordinates.height, maximum: this.coordinates.width / this.coordinates.height } });
    if (we.maxArea && Me.width * Me.height > we.maxArea) {
      var Ze = Math.sqrt(we.maxArea / (Me.width * Me.height));
      Me = { width: Math.round(Ze * Me.width), height: Math.round(Ze * Me.height) };
    }
    return function(ne, rr, gr, or, _r) {
      ne.width = or ? or.width : gr.width, ne.height = or ? or.height : gr.height;
      var Lr = ne.getContext("2d");
      Lr.clearRect(0, 0, ne.width, ne.height), _r && (_r.imageSmoothingEnabled && (Lr.imageSmoothingEnabled = _r.imageSmoothingEnabled), _r.imageSmoothingQuality && (Lr.imageSmoothingQuality = _r.imageSmoothingQuality), _r.fillColor && (Lr.fillStyle = _r.fillColor, Lr.fillRect(0, 0, ne.width, ne.height), Lr.save()));
      var Ir = gr.left < 0 ? -gr.left : 0, Ar = gr.top < 0 ? -gr.top : 0;
      Lr.drawImage(rr, gr.left + Ir, gr.top + Ar, gr.width, gr.height, Ir * (ne.width / gr.width), Ar * (ne.height / gr.height), ne.width, ne.height);
    }(m, ie, this.coordinates, Me, we), m;
  }
}, update: function() {
  this.$emit("change", this.getResult());
}, applyTransform: function(m) {
  var c = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], ie = this.visibleArea && c ? wt$1(this.sizeRestrictions, this.visibleArea) : this.sizeRestrictions, we = this.visibleArea && c ? jt(this.positionRestrictions, this.visibleArea) : this.positionRestrictions;
  return xt$1({ transform: m, coordinates: this.coordinates, imageSize: this.imageSize, sizeRestrictions: ie, positionRestrictions: we, aspectRatio: this.getAspectRatio(), visibleArea: this.visibleArea });
}, resetCoordinates: function() {
  var m = this;
  if (this.$refs.image) {
    this.$refs.cropper, this.$refs.image;
    var c = this.defaultSize;
    c || (c = this.stencilSize ? Dt$1 : Ot$1);
    var ie = this.sizeRestrictions;
    ie.minWidth, ie.minHeight, ie.maxWidth, ie.maxHeight;
    var we = O(c) ? c({ boundaries: this.boundaries, imageSize: this.imageSize, aspectRatio: this.getAspectRatio(), sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize(), visibleArea: this.visibleArea }) : c, $e = this.defaultPosition || Tt$1, Me = [we, function(Ze) {
      var ne = Ze.coordinates;
      return g$1({}, O($e) ? $e({ coordinates: ne, imageSize: m.imageSize, visibleArea: m.visibleArea }) : m.defaultPosition);
    }];
    this.delayedTransforms && Me.push.apply(Me, b$1(Array.isArray(this.delayedTransforms) ? this.delayedTransforms : [this.delayedTransforms])), this.coordinates = this.applyTransform(Me, !0), this.delayedTransforms = null;
  }
}, clearImage: function() {
  var m = this;
  this.imageLoaded = !1, setTimeout(function() {
    var c = m.$refs.stretcher;
    c && (c.style.height = "auto", c.style.width = "auto"), m.coordinates = m.defaultCoordinates(), m.boundaries = { width: 0, height: 0 };
  }, this.transitionTime);
}, enableTransitions: function() {
  this.transitions && (this.transitionsActive = !0);
}, disableTransitions: function() {
  this.transitionsActive = !1;
}, updateBoundaries: function() {
  var m = this, c = this.$refs.stretcher, ie = this.$refs.cropper;
  return this.initStretcher({ cropper: ie, stretcher: c, imageSize: this.imageSize }), this.$nextTick().then(function() {
    var we = { cropper: ie, imageSize: m.imageSize };
    if (O(m.defaultBoundaries) ? m.boundaries = m.defaultBoundaries(we) : m.defaultBoundaries === "fit" ? m.boundaries = function($e) {
      var Me = $e.cropper, Ze = $e.imageSize, ne = Me.clientHeight, rr = Me.clientWidth, gr = ne, or = Ze.width * ne / Ze.height;
      return or > rr && (or = rr, gr = Ze.height * rr / Ze.width), { width: or, height: gr };
    }(we) : m.boundaries = function($e) {
      var Me = $e.cropper;
      return { width: Me.clientWidth, height: Me.clientHeight };
    }(we), !m.boundaries.width || !m.boundaries.height)
      throw new Error("It's impossible to fit the cropper in the current container");
  });
}, resetVisibleArea: function() {
  var m = this;
  return this.appliedImageTransforms = g$1(g$1({}, this.defaultImageTransforms), {}, { flip: g$1({}, this.defaultImageTransforms.flip) }), this.updateBoundaries().then(function() {
    m.priority !== "visible-area" && (m.visibleArea = null, m.resetCoordinates());
    var c, ie, we, $e, Me, Ze, ne = m.defaultVisibleArea || Ht;
    m.visibleArea = O(ne) ? ne({ imageSize: m.imageSize, boundaries: m.boundaries, coordinates: m.priority !== "visible-area" ? m.coordinates : null, getAreaRestrictions: m.getAreaRestrictions, stencilSize: m.getStencilSize() }) : m.defaultVisibleArea, m.visibleArea = (c = { visibleArea: m.visibleArea, boundaries: m.boundaries, getAreaRestrictions: m.getAreaRestrictions }, ie = c.visibleArea, we = c.boundaries, $e = c.getAreaRestrictions, Me = C({}, ie), Ze = ct$1(we), Me.width / Me.height !== Ze && (Me.height = Me.width / Ze), vt$1(Me, $e({ visibleArea: Me, type: "move" }))), m.priority === "visible-area" ? m.resetCoordinates() : m.coordinates = m.fitCoordinates({ visibleArea: m.visibleArea, coordinates: m.coordinates, aspectRatio: m.getAspectRatio(), positionRestrictions: m.positionRestrictions, sizeRestrictions: m.sizeRestrictions }), m.runAutoZoom("resetVisibleArea");
  }).catch(function() {
    m.visibleArea = null;
  });
}, updateVisibleArea: function() {
  var m = this;
  return this.updateBoundaries().then(function() {
    m.visibleArea = m.fitVisibleArea({ imageSize: m.imageSize, boundaries: m.boundaries, visibleArea: m.visibleArea, coordinates: m.coordinates, getAreaRestrictions: m.getAreaRestrictions }), m.coordinates = m.fitCoordinates({ visibleArea: m.visibleArea, coordinates: m.coordinates, aspectRatio: m.getAspectRatio(), positionRestrictions: m.positionRestrictions, sizeRestrictions: m.sizeRestrictions }), m.runAutoZoom("updateVisibleArea");
  }).catch(function() {
    m.visibleArea = null;
  });
}, onChange: function() {
  var m = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
  m && this.debounce ? this.debouncedUpdate() : this.update();
}, onChangeImage: function() {
  var m, c = this;
  if (this.imageLoaded = !1, this.delayedTransforms = null, this.src) {
    if (function($e) {
      if (T($e))
        return !1;
      var Me = window.location, Ze = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/.exec($e) || [], ne = { protocol: Ze[1] || "", host: Ze[2] || "", port: Ze[3] || "" }, rr = function(gr) {
        return gr.port || ((gr.protocol || Me.protocol) === "http" ? 80 : 433);
      };
      return !(!ne.protocol && !ne.host && !ne.port || Boolean(ne.protocol && ne.protocol == Me.protocol && ne.host && ne.host == Me.host && ne.host && rr(ne) == rr(Me)));
    }(this.src)) {
      var ie = D$1(this.crossOrigin) ? this.canvas : this.crossOrigin;
      ie === !0 && (ie = "anonymous"), this.imageAttributes.crossOrigin = ie || null;
    }
    if (this.checkOrientation) {
      var we = (m = this.src, new Promise(function($e) {
        Jt(m).then(function(Me) {
          var Ze = ee(Me);
          $e(Me ? { source: m, arrayBuffer: Me, orientation: Ze } : { source: m, arrayBuffer: null, orientation: null });
        }).catch(function(Me) {
          console.warn(Me), $e({ source: m, arrayBuffer: null, orientation: null });
        });
      }));
      setTimeout(function() {
        we.then(c.onParseImage);
      }, this.transitionTime);
    } else
      setTimeout(function() {
        c.onParseImage({ source: c.src });
      }, this.transitionTime);
  } else
    this.clearImage();
}, onFailLoadImage: function() {
  this.imageAttributes.src && (this.clearImage(), this.$emit("error"));
}, onSuccessLoadImage: function() {
  var m = this, c = this.$refs.image;
  c && !this.imageLoaded && (this.imageAttributes.height = c.naturalHeight, this.imageAttributes.width = c.naturalWidth, this.imageLoaded = !0, this.resetVisibleArea().then(function() {
    m.$emit("ready"), m.onChange(!1);
  }));
}, onParseImage: function(m) {
  var c = this, ie = m.source, we = m.arrayBuffer, $e = m.orientation;
  this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.imageAttributes.revoke = !1, we && $e && $e > 1 ? W(ie) || !T(ie) ? (this.imageAttributes.src = URL.createObjectURL(new Blob([we])), this.imageAttributes.revoke = !0) : this.imageAttributes.src = function(Me) {
    for (var Ze = [], ne = new Uint8Array(Me); ne.length > 0; ) {
      var rr = ne.subarray(0, 8192);
      Ze.push(String.fromCharCode.apply(null, Array.from ? Array.from(rr) : rr.slice())), ne = ne.subarray(8192);
    }
    return "data:image/jpeg;base64," + btoa(Ze.join(""));
  }(we) : this.imageAttributes.src = ie, O(this.defaultTransforms) ? this.appliedImageTransforms = Kt(this.defaultTransforms()) : H(this.defaultTransforms) ? this.appliedImageTransforms = Kt(this.defaultTransforms) : this.appliedImageTransforms = function(Me) {
    var Ze = Kt({});
    if (Me)
      switch (Me) {
        case 2:
          Ze.flip.horizontal = !0;
          break;
        case 3:
          Ze.rotate = -180;
          break;
        case 4:
          Ze.flip.vertical = !0;
          break;
        case 5:
          Ze.rotate = 90, Ze.flip.vertical = !0;
          break;
        case 6:
          Ze.rotate = 90;
          break;
        case 7:
          Ze.rotate = 90, Ze.flip.horizontal = !0;
          break;
        case 8:
          Ze.rotate = -90;
      }
    return Ze;
  }($e), this.defaultImageTransforms = g$1(g$1({}, this.appliedImageTransforms), {}, { flip: g$1({}, this.appliedImageTransforms.flip) }), this.$nextTick(function() {
    var Me = c.$refs.image;
    Me && Me.complete && (function(Ze) {
      return Boolean(Ze.naturalWidth);
    }(Me) ? c.onSuccessLoadImage() : c.onFailLoadImage());
  });
}, onResizeEnd: function() {
  this.runAutoZoom("resize", { transitions: !0 });
}, onMoveEnd: function() {
  this.runAutoZoom("move", { transitions: !0 });
}, onMove: function(m) {
  var c = this;
  this.transitionsOptions.enabled || this.awaitRender(function() {
    c.coordinates = c.moveAlgorithm(g$1(g$1({}, c.getPublicProperties()), {}, { positionRestrictions: jt(c.positionRestrictions, c.visibleArea), coordinates: c.coordinates, event: c.normalizeEvent(m) })), c.onChange();
  });
}, onResize: function(m) {
  var c = this;
  this.transitionsOptions.enabled || this.stencilSize && !this.autoZoom || this.awaitRender(function() {
    var ie = c.sizeRestrictions, we = Math.min(c.coordinates.width, c.coordinates.height, 20 * c.coefficient);
    c.coordinates = c.resizeAlgorithm(g$1(g$1({}, c.getPublicProperties()), {}, { positionRestrictions: jt(c.positionRestrictions, c.visibleArea), sizeRestrictions: { maxWidth: Math.min(ie.maxWidth, c.visibleArea.width), maxHeight: Math.min(ie.maxHeight, c.visibleArea.height), minWidth: Math.max(ie.minWidth, we), minHeight: Math.max(ie.minHeight, we) }, event: c.normalizeEvent(m) })), c.onChange(), c.ticking = !1;
  });
}, onManipulateImage: function(m) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!this.transitionsOptions.enabled) {
    var ie = c.transitions, we = ie !== void 0 && ie, $e = c.normalize, Me = $e === void 0 || $e;
    we && this.enableTransitions();
    var Ze = Lt(g$1(g$1({}, this.getPublicProperties()), {}, { event: Me ? this.normalizeEvent(m) : m, getAreaRestrictions: this.getAreaRestrictions, imageRestriction: this.imageRestriction, adjustStencil: !this.stencilSize && this.settings.resizeImage.adjustStencil })), ne = Ze.visibleArea, rr = Ze.coordinates;
    this.visibleArea = ne, this.coordinates = rr, this.runAutoZoom("manipulateImage"), this.onChange(), we && this.debouncedDisableTransitions();
  }
}, onPropsChange: function() {
  this.coordinates = this.applyTransform(this.coordinates, !0), this.onChange(!1);
}, getAreaRestrictions: function() {
  var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = m.visibleArea, ie = m.type, we = ie === void 0 ? "move" : ie;
  return this.areaRestrictionsAlgorithm({ boundaries: this.boundaries, imageSize: this.imageSize, imageRestriction: this.imageRestriction, visibleArea: c, type: we });
}, getAspectRatio: function(m) {
  var c, ie, we = this.stencilProps, $e = we.aspectRatio, Me = we.minAspectRatio, Ze = we.maxAspectRatio;
  if (this.$refs.stencil && this.$refs.stencil.aspectRatios) {
    var ne = this.$refs.stencil.aspectRatios();
    c = ne.minimum, ie = ne.maximum;
  }
  if (D$1(c) && (c = D$1($e) ? Me : $e), D$1(ie) && (ie = D$1($e) ? Ze : $e), !m && (D$1(c) || D$1(ie))) {
    var rr = this.getStencilSize(), gr = rr ? ct$1(rr) : null;
    D$1(c) && (c = P(gr) ? gr : void 0), D$1(ie) && (ie = P(gr) ? gr : void 0);
  }
  return { minimum: c, maximum: ie };
}, getStencilSize: function() {
  if (this.stencilSize)
    return m = { currentStencilSize: { width: this.stencilCoordinates.width, height: this.stencilCoordinates.height }, stencilSize: this.stencilSize, boundaries: this.boundaries, coefficient: this.coefficient, coordinates: this.coordinates, aspectRatio: this.getAspectRatio(!0) }, c = m.boundaries, ie = m.stencilSize, we = m.aspectRatio, dt$1(ct$1($e = O(ie) ? ie({ boundaries: c, aspectRatio: we }) : ie), we) && ($e = Mt$1({ sizeRestrictions: { maxWidth: c.width, maxHeight: c.height, minWidth: 0, minHeight: 0 }, width: $e.width, height: $e.height, aspectRatio: { minimum: we.minimum, maximum: we.maximum } })), ($e.width > c.width || $e.height > c.height) && ($e = Mt$1({ sizeRestrictions: { maxWidth: c.width, maxHeight: c.height, minWidth: 0, minHeight: 0 }, width: $e.width, height: $e.height, aspectRatio: { minimum: ct$1($e), maximum: ct$1($e) } })), $e;
  var m, c, ie, we, $e;
}, getPublicProperties: function() {
  return { coefficient: this.coefficient, visibleArea: this.visibleArea, coordinates: this.coordinates, boundaries: this.boundaries, sizeRestrictions: this.sizeRestrictions, positionRestrictions: this.positionRestrictions, aspectRatio: this.getAspectRatio(), imageRestriction: this.imageRestriction };
}, defaultCoordinates: function() {
  return g$1({}, J);
}, flip: function(m, c) {
  var ie = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, we = ie.transitions, $e = we === void 0 || we;
  if (!this.transitionsActive) {
    $e && this.enableTransitions();
    var Me = g$1({}, this.imageTransforms.flip), Ze = $t({ flip: { horizontal: m ? !Me.horizontal : Me.horizontal, vertical: c ? !Me.vertical : Me.vertical }, previousFlip: Me, rotate: this.imageTransforms.rotate, visibleArea: this.visibleArea, coordinates: this.coordinates, imageSize: this.imageSize, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), ne = Ze.visibleArea, rr = Ze.coordinates;
    m && (this.appliedImageTransforms.flip.horizontal = !this.appliedImageTransforms.flip.horizontal), c && (this.appliedImageTransforms.flip.vertical = !this.appliedImageTransforms.flip.vertical), this.visibleArea = ne, this.coordinates = rr, this.onChange(), $e && this.debouncedDisableTransitions();
  }
}, rotate: function(m) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ie = c.transitions, we = ie === void 0 || ie;
  if (!this.transitionsActive) {
    we && this.enableTransitions();
    var $e = g$1({}, this.imageSize);
    this.appliedImageTransforms.rotate += m;
    var Me = Pt$1({ visibleArea: this.visibleArea, coordinates: this.coordinates, previousImageSize: $e, imageSize: this.imageSize, angle: m, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), Ze = Me.visibleArea, ne = Me.coordinates, rr = this.processAutoZoom("rotateImage", Ze, ne);
    Ze = rr.visibleArea, ne = rr.coordinates, this.visibleArea = Ze, this.coordinates = ne, this.onChange(), we && this.debouncedDisableTransitions();
  }
} }, emits: ["change", "error", "ready"] }, ve = { key: 0, ref: "canvas", style: { display: "none" } }, be$1 = { key: 1, ref: "sourceCanvas", style: { display: "none" } };
fe.render = function(m, c, ie, we, $e, Me) {
  return openBlock(), createBlock("div", { ref: "cropper", class: Me.classes.cropper }, [createVNode("div", { ref: "stretcher", class: Me.classes.stretcher }, null, 2), createVNode("div", { class: Me.classes.boundaries, style: Me.boundariesStyle }, [(openBlock(), createBlock(resolveDynamicComponent(ie.backgroundWrapperComponent), { class: Me.classes.cropperWrapper, "wheel-resize": Me.settings.resizeImage.wheel, "touch-resize": Me.settings.resizeImage.touch, "touch-move": Me.settings.moveImage.touch, "mouse-move": Me.settings.moveImage.mouse, onMove: Me.onManipulateImage, onResize: Me.onManipulateImage }, { default: withCtx(function() {
    return [createVNode("div", { class: Me.classes.background, style: Me.boundariesStyle }, null, 6), createVNode("div", { class: Me.classes.imageWrapper }, [createVNode("img", { ref: "image", crossorigin: $e.imageAttributes.crossOrigin, src: $e.imageAttributes.src, class: Me.classes.image, style: Me.imageStyle, onMousedown: c[1] || (c[1] = withModifiers(function() {
    }, ["prevent"])) }, null, 46, ["crossorigin", "src"])], 2), createVNode("div", { class: Me.classes.foreground, style: Me.boundariesStyle }, null, 6), withDirectives((openBlock(), createBlock(resolveDynamicComponent(ie.stencilComponent), mergeProps({ ref: "stencil", image: Me.image, coordinates: $e.coordinates, "stencil-coordinates": Me.stencilCoordinates, transitions: Me.transitionsOptions }, ie.stencilProps, { onResize: Me.onResize, onResizeEnd: Me.onResizeEnd, onMove: Me.onMove, onMoveEnd: Me.onMoveEnd }), null, 16, ["image", "coordinates", "stencil-coordinates", "transitions", "onResize", "onResizeEnd", "onMove", "onMoveEnd"])), [[vShow, $e.imageLoaded]]), ie.canvas ? (openBlock(), createBlock("canvas", ve, null, 512)) : createCommentVNode("", !0), ie.canvas ? (openBlock(), createBlock("canvas", be$1, null, 512)) : createCommentVNode("", !0)];
  }), _: 1 }, 8, ["class", "wheel-resize", "touch-resize", "touch-move", "mouse-move", "onMove", "onResize"]))], 6)], 2);
};
const style$1 = "", theme_bubble = "", BluepicSpinner_vue_vue_type_style_index_0_scoped_abe3e1ac_lang = "", _sfc_main$N = {}, _hoisted_1$C = { class: "bluepic-spinner" };
function _sfc_render$3(m, c) {
  return openBlock(), createElementBlock("div", _hoisted_1$C, c[0] || (c[0] = [
    createStaticVNode('<svg width="344" height="350" viewBox="0 0 344 350" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-abe3e1ac><ellipse cx="220.755" cy="202.159" rx="49.9896" ry="39.3918" fill="white" data-v-abe3e1ac></ellipse><circle cx="172.765" cy="177.564" r="137.571" fill="#09275E" data-v-abe3e1ac></circle><path d="M289.161 117.691L290.189 119.025L290.264 118.986C290.267 118.995 290.269 119.005 290.271 119.014C290.292 119.111 290.315 119.215 290.34 119.326L290.342 119.337C290.487 119.99 290.731 121.089 291.275 121.912C291.58 122.375 292.096 122.935 292.913 123.191C293.415 123.348 293.903 123.35 294.35 123.263L295.779 123.684C301.037 125.446 304.551 126.122 307.811 126.749C308.154 126.815 308.493 126.88 308.832 126.946C312.104 127.583 315.343 128.293 320.317 130.209C320.307 130.996 320.033 131.826 319.597 132.943C319.558 133.042 319.517 133.144 319.475 133.25C318.931 134.621 318.158 136.569 318.569 138.743L319.03 141.184L321.316 140.213C322.688 139.63 326.238 138.076 329.797 136.444C333.29 134.843 336.992 133.075 338.526 132.093L339.723 131.327L339.394 129.946C338.672 126.916 337.967 123.872 337.258 120.815C335.248 112.147 333.214 103.376 330.737 94.5409L330.308 93.0091L328.719 93.0832C321.431 93.4233 314.301 94.1966 307.29 94.9568C303.561 95.3612 299.866 95.7619 296.2 96.0918L295.311 96.1717L294.777 96.886C294.246 97.5964 293.707 98.3078 293.165 99.0223C290.635 102.358 288.052 105.763 286.025 109.468L285.631 110.188L285.857 110.977C286.583 113.52 287.614 115.684 289.161 117.691ZM289.933 117.746C289.934 117.745 289.938 117.753 289.947 117.771C289.937 117.756 289.933 117.747 289.933 117.746Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M93.1862 189.025L93.1862 189.025C92.3418 188.723 91.58 188.994 91.2708 189.119C90.8714 189.28 90.4932 189.512 90.169 189.738C89.5089 190.198 88.7881 190.834 88.1038 191.51C86.7464 192.85 85.2731 194.605 84.4485 196.015L84.4467 196.018C76.1322 210.301 75.0953 225.446 78.6265 241.168C81.8267 255.475 89.6272 267.326 97.2042 278.836L97.5148 279.308L97.5213 279.318C99.8514 282.814 102.915 285.581 106.291 287.871L106.293 287.872C107.63 288.777 109.408 289.807 111.751 289.538C115.478 289.131 119.188 287.275 122.147 284.723C125.106 282.171 127.493 278.77 128.373 275.08C129.463 270.553 128.601 266.205 127.362 262.489L127.241 262.126L126.995 261.833C125.807 260.423 124.367 259.601 123.334 259.011C123.1 258.878 122.887 258.756 122.702 258.642C115.356 254.059 109.017 248.779 104.649 241.416L104.646 241.412C96.802 228.252 93.2533 214.222 94.7986 198.973C94.8225 198.747 94.8517 198.49 94.8837 198.208C95.0138 197.06 95.1886 195.518 95.2329 194.155C95.2603 193.311 95.2447 192.396 95.0956 191.61C95.0214 191.219 94.8947 190.75 94.6514 190.309C94.4038 189.861 93.9521 189.299 93.1862 189.025Z" fill="#FFBB34" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M290.005 121.129L289.656 121.988L290.085 122.809C292.75 127.905 294.192 132.59 293.907 136.956C293.627 141.238 291.665 145.483 286.961 149.719L284.446 151.984L287.643 153.094C293.842 155.247 299.66 157.273 305.479 159.3C307.974 160.168 310.469 161.037 312.995 161.916L314.796 162.543L315.508 160.774C317.768 155.15 319.921 149.776 322.065 144.425C324.217 139.052 326.36 133.704 328.592 128.152L329.356 126.251L327.438 125.533C322.371 123.638 317.397 121.775 312.491 119.939C307.134 117.933 301.858 115.958 296.635 114.004L295.405 113.544L294.494 114.49C292.435 116.629 291.012 118.653 290.005 121.129Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M162.722 197.574H162.695L162.668 197.575C158.965 197.676 156.646 200.15 155.153 202.449C151.761 207.638 150.294 213.427 150.531 219.592C150.634 222.464 152.176 224.391 153.955 225.873L153.963 225.88L153.972 225.887C158.318 229.429 163.337 231.194 168.536 232.158C169.167 232.282 169.957 232.298 170.744 231.972C171.586 231.623 172.225 230.962 172.6 230.102L172.707 229.854L172.745 229.587C172.745 229.587 172.747 229.579 172.75 229.557C172.754 229.538 172.757 229.52 172.762 229.495C172.764 229.485 172.766 229.474 172.768 229.462C172.782 229.388 172.806 229.258 172.824 229.117C172.841 228.98 172.861 228.764 172.844 228.515C172.827 228.277 172.766 227.874 172.518 227.46L172.518 227.46L172.513 227.453C168.063 220.106 166.241 212.24 167.157 203.718C167.321 202.2 166.665 200.739 166.017 199.78C165.672 199.268 165.252 198.783 164.786 198.401C164.396 198.082 163.661 197.574 162.722 197.574Z" fill="#FFBB34" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M180.399 40.1741C181.974 40.3116 183.454 40.4408 184.909 40.6792C184.228 45.2675 183.241 49.756 182.237 54.3138L182.214 54.4178C181.085 59.5414 179.935 64.7558 179.241 70.1416L179.016 71.8853L180.717 72.3314C185.308 73.5358 189.672 74.411 193.947 74.8692C196.831 75.1782 199.928 75.7588 202.811 76.2992C203.941 76.511 205.038 76.7166 206.076 76.8973C207.852 77.2063 209.528 77.4544 210.793 77.4711C211.397 77.4791 212.131 77.4419 212.783 77.2014C213.128 77.0746 213.569 76.8483 213.937 76.4293C214.337 75.9731 214.545 75.407 214.556 74.8219L214.556 74.8168C214.6 72.0297 213.488 69.3888 212.568 67.2043C212.54 67.1397 212.513 67.0755 212.486 67.0117C211.477 64.6117 210.713 62.7036 210.757 60.8354C210.764 60.5351 210.756 60.1602 210.749 59.8186C210.746 59.6678 210.743 59.5234 210.741 59.3948C210.736 58.9128 210.744 58.4628 210.791 58.0449C210.847 57.5513 210.945 57.2092 211.066 56.9696C212.585 56.8593 213.855 56.3467 214.708 55.2183C215.492 54.1819 215.665 52.8597 215.762 52.1245C215.771 52.0554 215.779 51.9915 215.787 51.9335C215.918 51.001 216.027 50.6767 216.19 50.4815C216.269 50.3865 216.628 49.9996 218.159 49.93L220.201 49.8372L220.063 47.7982C219.845 44.5492 220.16 41.3975 220.492 38.0783C220.533 37.6678 220.574 37.2547 220.614 36.8385C220.977 33.124 221.274 29.2037 220.597 25.1391L220.347 23.6407L218.836 23.4795C209.196 22.4508 199.693 21.4527 190.202 20.4559C184.985 19.908 179.771 19.3604 174.54 18.8083L172.779 18.6226L172.381 20.3473C171.008 26.298 170.555 31.6249 170.367 36.7755L170.311 38.3068L171.775 38.7589C174.514 39.6048 177.162 39.8863 179.615 40.1051C179.879 40.1287 180.14 40.1515 180.399 40.1741Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M134.234 79.9717L134.458 81.5862L136.085 81.6917C139.271 81.8981 142.447 82.132 145.618 82.3656C155.449 83.0898 165.234 83.8105 175.12 83.6975L176.711 83.6793L177.051 82.1246C178.105 77.2955 179.195 72.5212 180.279 67.7721C182.531 57.9086 184.758 48.154 186.59 38.244L186.918 36.4649L185.181 35.9604C179.24 34.2354 171.076 33.8622 165.486 33.6068L165.258 33.5963L163.101 33.4976L163.168 35.6559C163.268 38.8806 163.968 41.9624 164.79 44.889C165.136 46.118 165.488 47.2779 165.834 48.413C166.158 49.4805 166.476 50.5261 166.775 51.5867C159.115 53.946 151.592 56.2745 144.101 58.5932C140.914 59.5797 137.733 60.5644 134.549 61.549L133.317 61.9301L133.156 63.2098C132.517 68.2858 133.206 72.9608 133.893 77.6183C134.009 78.4026 134.125 79.1865 134.234 79.9717Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M235.987 77.2978L237.597 75.9449L236.164 74.4049C234.927 73.0743 233.511 72.8335 232.527 72.7119C232.424 72.6991 232.327 72.6874 232.236 72.6764C231.957 72.6427 231.729 72.6152 231.533 72.5831C231.441 69.4098 231.536 66.2292 231.633 62.9588C231.654 62.2493 231.676 61.5355 231.695 60.8167C231.816 56.3655 231.867 51.7646 231.35 47.0422L231.155 45.2528L229.355 45.2599C225.882 45.2737 222.492 44.9896 219.022 44.6988C217.931 44.6073 216.832 44.5152 215.719 44.4315C211.131 44.086 206.409 43.8946 201.565 44.6144L199.731 44.887L199.865 46.7367C200.233 51.8147 200.432 56.8294 200.631 61.8463C200.691 63.3646 200.751 64.8832 200.816 66.4037C201.095 72.9254 201.459 79.4532 202.285 85.9895L202.486 87.5836L204.087 87.73C206.257 87.9285 208.273 88.3083 210.351 88.6997C211.078 88.8366 211.812 88.9749 212.562 89.1073C215.396 89.6071 218.362 89.9982 221.547 89.694L222.312 89.6208L222.831 89.0534C226.01 85.5803 229.634 82.5749 233.426 79.4307C234.272 78.7289 235.127 78.0202 235.987 77.2978Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M238.43 76.8741L238.524 76.883H238.619H238.656H239.416L239.984 76.3784C240.606 75.8255 241.206 75.2772 241.793 74.7413C244.015 72.7114 246.04 70.8607 248.334 69.623C251.027 68.1703 253.99 67.6423 257.9 69.2771L259.41 69.9081L260.327 68.5536C263.376 64.052 266.319 59.7631 268.842 56.1056C269.214 55.8165 269.59 55.7012 270.152 55.5731C270.2 55.5622 270.256 55.5505 270.318 55.5375C270.918 55.4115 272.136 55.156 273.036 54.187L273.432 53.7603L273.537 53.1876C274.04 50.4526 273.895 47.6874 273.127 44.9153L272.797 43.7231L271.582 43.4867C263.347 41.8831 255 40.2479 246.437 38.5701C241.936 37.6882 237.375 36.7945 232.738 35.8876L230.648 35.4788L230.372 37.5901C229.226 46.3333 229.305 54.9129 229.382 63.2284C229.413 66.6176 229.444 69.9628 229.391 73.2575L229.369 74.6691L230.692 75.1628C233.369 76.1618 235.547 76.6013 238.43 76.8741Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M113.263 17.2528L111.592 17.7788L111.894 19.5045C112.563 23.3331 113.21 27.1511 113.856 30.9674C115.742 42.1 117.626 53.2183 120.063 64.5472L120.527 66.7031L122.627 66.0311C137.343 61.3231 151.356 56.837 165.739 52.2025L167.448 51.652L167.084 49.8942C166.341 46.3024 165.618 42.7407 164.899 39.1967C162.612 27.9303 160.361 16.8421 157.618 5.52881L157.112 3.44522L155.069 4.09424C145.819 7.03208 136.764 9.87348 127.677 12.7249C122.892 14.2262 118.098 15.7303 113.263 17.2528Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M262.342 65.8041L260.526 68.8324H263.185C272.563 79.6925 278.667 92.1168 284.494 105.834L285.903 109.152L287.972 106.2C289.795 103.598 291.611 101.061 293.405 98.5547C297.793 92.425 302.05 86.4771 305.97 80.1993L306.956 78.6203L305.452 77.5241C301.19 74.4193 296.984 71.3585 292.795 68.3103C285.976 63.3488 279.204 58.421 272.316 53.3923L270.548 52.1018L269.422 53.9786C268.143 56.1116 266.956 58.096 265.797 60.0328L265.719 60.1647C264.588 62.0558 263.483 63.9035 262.342 65.8041Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M328.052 237.274L328.894 236.501L328.655 235.383C328.524 234.766 328.393 234.15 328.261 233.533C326.622 225.832 324.984 218.135 322.767 210.307L322.338 208.792L320.764 208.854C316.093 209.038 311.535 209.802 307.19 210.53C307.035 210.556 306.879 210.582 306.724 210.608C302.583 211.301 298.643 211.941 294.779 212.087C294.32 211.174 294.184 210.152 294.067 208.823C294.058 208.717 294.048 208.609 294.039 208.498C293.905 206.915 293.726 204.792 292.391 202.858L291.489 201.552L290.012 202.133C289.048 202.513 288.07 202.885 287.083 203.26C283.205 204.735 279.196 206.259 275.417 208.502L274.451 209.076L274.438 210.199C274.402 213.408 274.138 216.128 272.948 218.512C271.647 221.054 271.503 223.443 272.081 225.711C272.635 227.88 273.834 229.865 275.028 231.674L276.226 233.49L277.934 232.144C280.24 230.329 282.202 228.249 284.059 226.282C284.211 226.121 284.361 225.962 284.511 225.803C286.164 224.056 287.767 222.4 289.577 220.93C293.737 224.62 297.869 228.288 302.002 231.957C306.542 235.989 311.083 240.021 315.662 244.08L316.757 245.052L318.014 244.3C318.127 244.233 318.239 244.166 318.351 244.099C321.621 242.146 324.837 240.224 328.052 237.274Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><mask id="path-14-outside-1_503_366" maskUnits="userSpaceOnUse" x="25" y="63" width="271" height="287" fill="black" data-v-abe3e1ac><rect fill="white" x="25" y="63" width="271" height="287" data-v-abe3e1ac></rect><path fill-rule="evenodd" clip-rule="evenodd" d="M177.294 229.437C176.864 227.937 176.002 226.893 175.17 225.884C175.007 225.686 174.844 225.489 174.686 225.29C170.498 220.137 169.015 213.946 167.977 207.644C166.827 200.707 169.684 194.677 172.528 188.674C172.617 188.485 172.707 188.297 172.796 188.108C178.096 176.839 186.066 167.46 194.368 158.377L194.69 158.028C197.991 154.438 201.278 150.864 205.155 147.812C206.415 146.811 207.601 145.662 208.343 143.809C207.687 142.861 207.043 141.883 206.392 140.896C204.982 138.756 203.542 136.57 201.893 134.541C196.333 127.646 196.481 120.899 201.596 113.893C202.11 113.19 202.619 112.484 203.128 111.779C205.999 107.799 208.862 103.832 212.42 100.399L213.332 99.5236C222.33 90.882 231.31 82.2574 240.776 74.1532C243.852 71.5211 247.225 69.4823 250.932 67.8882C254.602 66.2942 257.789 66.8503 260.755 69.5193C266.352 74.5609 270.169 80.9 273.765 87.3873C280.066 98.6939 284.848 110.631 288.999 122.827C290.519 127.312 291.853 131.835 291.705 136.691C291.557 141.473 289.778 145.18 285.923 148.109C282.216 150.926 278.213 153.039 274.061 155.041C273.717 155.209 273.366 155.366 273.017 155.523C271.903 156.022 270.812 156.512 270.021 157.302C269.227 158.529 269.382 159.721 269.527 160.844L269.539 160.935C269.88 163.671 270.21 166.41 270.54 169.149C271.431 176.544 272.322 183.949 273.431 191.333C275.396 204.456 273.95 217.097 268.168 228.997C265.054 235.41 260.384 240.896 253.712 244.159C252.251 244.879 250.808 245.627 249.37 246.372C245.849 248.198 242.359 250.008 238.7 251.35C238.632 253.023 239.281 254.296 239.965 255.639C240.404 256.499 240.857 257.389 241.146 258.431C238.441 262.782 235.715 267.171 232.964 271.601C227.534 280.342 222.007 289.24 216.349 298.319C224.689 304.176 232.658 309.773 240.553 315.334C242.149 319.235 240.081 322.186 238.179 324.9C238.093 325.024 238.007 325.147 237.922 325.269C230.063 336.576 218.758 342.062 205.377 343.73C205.133 343.755 204.888 343.771 204.645 343.787C204.151 343.82 203.662 343.853 203.19 343.953C184.954 348.104 171.313 340.32 159.637 327.271C158.981 326.533 158.365 325.774 157.745 325.01C157.524 324.739 157.303 324.466 157.08 324.194C156.756 323.763 156.453 323.312 156.097 322.785C155.964 322.587 155.823 322.378 155.671 322.155C151.683 322.98 147.796 323.152 143.951 323.323C142.615 323.382 141.284 323.441 139.955 323.527C137.362 323.702 134.772 323.941 132.183 324.18C125.481 324.799 118.781 325.417 112.044 324.935C105.817 324.49 99.6635 323.378 93.844 321.154C86.2454 318.263 78.9062 314.667 71.8636 310.515C63.746 305.733 57.0741 299.208 51.1434 291.943C39.6157 277.893 32.499 261.804 29.6448 243.899C28.5671 237.073 29.0562 230.211 29.5598 223.147C29.5758 222.922 29.5918 222.697 29.6078 222.472C34.1855 219.729 38.7261 217.014 43.2667 214.298C47.8074 211.583 52.3481 208.867 56.9258 206.124C55.058 200.68 53.2461 195.375 51.4645 190.159C50.3469 186.887 49.2412 183.65 48.141 180.434C57.1111 168.349 69.0095 160.861 82.5388 155.745C87.8022 153.744 93.1398 152.001 98.5144 150.333C108.263 147.256 115.528 140.991 121.31 132.799C123.201 130.13 124.342 128.784 126.092 129.092C128.761 129.561 129.205 133.837 128.761 136.914C127.945 142.734 124.72 147.367 120.903 151.556C117.789 154.967 114.156 157.784 110.153 160.12C108.715 160.961 107.281 161.806 105.847 162.652C100.516 165.795 95.1918 168.934 89.7297 171.797C70.6033 181.769 61.5591 198.451 57.8525 218.802C54.9613 234.78 58.6679 249.608 66.8226 263.102C76.7193 279.45 91.9166 288.087 110.969 289.978C122.274 291.127 132.616 277.114 131.244 267.661C130.503 262.434 128.724 257.652 126.129 253.093C124.043 249.467 121.708 246.025 119.369 242.576C118.216 240.876 117.061 239.174 115.936 237.449C110.265 228.774 106.15 219.433 105.742 208.942C104.964 188.256 112.674 171.834 130.132 160.157C133.247 158.075 136.493 156.205 139.741 154.334C144.185 151.774 148.631 149.213 152.743 146.107C156.301 143.438 159.637 140.509 162.936 137.507C172.981 128.387 168.644 106.701 152.446 102.067C147.183 100.547 142.179 102.216 137.508 104.81C135.655 105.848 132.341 106.989 131.763 105.774C131.141 103.989 132.467 101.771 134.098 100.51C142.068 94.4307 151.149 92.4289 160.934 93.9859C164.135 94.4929 167.254 95.7044 170.338 96.9022C170.862 97.1056 171.384 97.3085 171.906 97.5076C174.871 98.6197 177.207 100.696 179.171 103.179C179.486 103.578 179.764 104 180.041 104.418C180.254 104.74 180.465 105.06 180.691 105.367C192.775 120.64 189.661 137.247 180.728 150.741C175.205 159.082 167.903 165.866 160.082 172.019C154.374 176.505 148.814 181.176 144.662 187.255C140.437 193.446 137.879 200.045 139.176 207.718C140.511 215.54 145.07 221.36 151.371 225.549C156.82 229.182 163.047 231.258 169.793 231.184C172.331 231.184 174.723 230.819 177.294 229.437ZM175.835 317.966C172.277 318.856 168.681 319.597 164.011 319.338C165.729 318.563 167.323 317.826 168.846 317.123C171.331 315.974 173.625 314.914 175.946 313.925C177.726 313.147 179.764 313.184 181.618 313.629C186.214 314.704 190.588 316.409 195.555 318.819C193.071 319.894 191.329 319.634 189.661 318.782C185.139 316.446 180.506 316.78 175.835 317.966Z" data-v-abe3e1ac></path></mask><path fill-rule="evenodd" clip-rule="evenodd" d="M177.294 229.437C176.864 227.937 176.002 226.893 175.17 225.884C175.007 225.686 174.844 225.489 174.686 225.29C170.498 220.137 169.015 213.946 167.977 207.644C166.827 200.707 169.684 194.677 172.528 188.674C172.617 188.485 172.707 188.297 172.796 188.108C178.096 176.839 186.066 167.46 194.368 158.377L194.69 158.028C197.991 154.438 201.278 150.864 205.155 147.812C206.415 146.811 207.601 145.662 208.343 143.809C207.687 142.861 207.043 141.883 206.392 140.896C204.982 138.756 203.542 136.57 201.893 134.541C196.333 127.646 196.481 120.899 201.596 113.893C202.11 113.19 202.619 112.484 203.128 111.779C205.999 107.799 208.862 103.832 212.42 100.399L213.332 99.5236C222.33 90.882 231.31 82.2574 240.776 74.1532C243.852 71.5211 247.225 69.4823 250.932 67.8882C254.602 66.2942 257.789 66.8503 260.755 69.5193C266.352 74.5609 270.169 80.9 273.765 87.3873C280.066 98.6939 284.848 110.631 288.999 122.827C290.519 127.312 291.853 131.835 291.705 136.691C291.557 141.473 289.778 145.18 285.923 148.109C282.216 150.926 278.213 153.039 274.061 155.041C273.717 155.209 273.366 155.366 273.017 155.523C271.903 156.022 270.812 156.512 270.021 157.302C269.227 158.529 269.382 159.721 269.527 160.844L269.539 160.935C269.88 163.671 270.21 166.41 270.54 169.149C271.431 176.544 272.322 183.949 273.431 191.333C275.396 204.456 273.95 217.097 268.168 228.997C265.054 235.41 260.384 240.896 253.712 244.159C252.251 244.879 250.808 245.627 249.37 246.372C245.849 248.198 242.359 250.008 238.7 251.35C238.632 253.023 239.281 254.296 239.965 255.639C240.404 256.499 240.857 257.389 241.146 258.431C238.441 262.782 235.715 267.171 232.964 271.601C227.534 280.342 222.007 289.24 216.349 298.319C224.689 304.176 232.658 309.773 240.553 315.334C242.149 319.235 240.081 322.186 238.179 324.9C238.093 325.024 238.007 325.147 237.922 325.269C230.063 336.576 218.758 342.062 205.377 343.73C205.133 343.755 204.888 343.771 204.645 343.787C204.151 343.82 203.662 343.853 203.19 343.953C184.954 348.104 171.313 340.32 159.637 327.271C158.981 326.533 158.365 325.774 157.745 325.01C157.524 324.739 157.303 324.466 157.08 324.194C156.756 323.763 156.453 323.312 156.097 322.785C155.964 322.587 155.823 322.378 155.671 322.155C151.683 322.98 147.796 323.152 143.951 323.323C142.615 323.382 141.284 323.441 139.955 323.527C137.362 323.702 134.772 323.941 132.183 324.18C125.481 324.799 118.781 325.417 112.044 324.935C105.817 324.49 99.6635 323.378 93.844 321.154C86.2454 318.263 78.9062 314.667 71.8636 310.515C63.746 305.733 57.0741 299.208 51.1434 291.943C39.6157 277.893 32.499 261.804 29.6448 243.899C28.5671 237.073 29.0562 230.211 29.5598 223.147C29.5758 222.922 29.5918 222.697 29.6078 222.472C34.1855 219.729 38.7261 217.014 43.2667 214.298C47.8074 211.583 52.3481 208.867 56.9258 206.124C55.058 200.68 53.2461 195.375 51.4645 190.159C50.3469 186.887 49.2412 183.65 48.141 180.434C57.1111 168.349 69.0095 160.861 82.5388 155.745C87.8022 153.744 93.1398 152.001 98.5144 150.333C108.263 147.256 115.528 140.991 121.31 132.799C123.201 130.13 124.342 128.784 126.092 129.092C128.761 129.561 129.205 133.837 128.761 136.914C127.945 142.734 124.72 147.367 120.903 151.556C117.789 154.967 114.156 157.784 110.153 160.12C108.715 160.961 107.281 161.806 105.847 162.652C100.516 165.795 95.1918 168.934 89.7297 171.797C70.6033 181.769 61.5591 198.451 57.8525 218.802C54.9613 234.78 58.6679 249.608 66.8226 263.102C76.7193 279.45 91.9166 288.087 110.969 289.978C122.274 291.127 132.616 277.114 131.244 267.661C130.503 262.434 128.724 257.652 126.129 253.093C124.043 249.467 121.708 246.025 119.369 242.576C118.216 240.876 117.061 239.174 115.936 237.449C110.265 228.774 106.15 219.433 105.742 208.942C104.964 188.256 112.674 171.834 130.132 160.157C133.247 158.075 136.493 156.205 139.741 154.334C144.185 151.774 148.631 149.213 152.743 146.107C156.301 143.438 159.637 140.509 162.936 137.507C172.981 128.387 168.644 106.701 152.446 102.067C147.183 100.547 142.179 102.216 137.508 104.81C135.655 105.848 132.341 106.989 131.763 105.774C131.141 103.989 132.467 101.771 134.098 100.51C142.068 94.4307 151.149 92.4289 160.934 93.9859C164.135 94.4929 167.254 95.7044 170.338 96.9022C170.862 97.1056 171.384 97.3085 171.906 97.5076C174.871 98.6197 177.207 100.696 179.171 103.179C179.486 103.578 179.764 104 180.041 104.418C180.254 104.74 180.465 105.06 180.691 105.367C192.775 120.64 189.661 137.247 180.728 150.741C175.205 159.082 167.903 165.866 160.082 172.019C154.374 176.505 148.814 181.176 144.662 187.255C140.437 193.446 137.879 200.045 139.176 207.718C140.511 215.54 145.07 221.36 151.371 225.549C156.82 229.182 163.047 231.258 169.793 231.184C172.331 231.184 174.723 230.819 177.294 229.437ZM175.835 317.966C172.277 318.856 168.681 319.597 164.011 319.338C165.729 318.563 167.323 317.826 168.846 317.123C171.331 315.974 173.625 314.914 175.946 313.925C177.726 313.147 179.764 313.184 181.618 313.629C186.214 314.704 190.588 316.409 195.555 318.819C193.071 319.894 191.329 319.634 189.661 318.782C185.139 316.446 180.506 316.78 175.835 317.966Z" fill="#FFBB34" data-v-abe3e1ac></path><path d="M214.718 207.496L212.718 207.489V207.496H214.718ZM234.511 227.106H236.511V225.093L234.498 225.107L234.511 227.106ZM174.167 194.521L176.167 194.549L176.167 194.544L174.167 194.521ZM192.182 212.871L192.174 210.872L192.167 210.872L192.182 212.871ZM234.599 185.923C222.452 185.842 212.759 195.441 212.718 207.489L216.718 207.503C216.751 197.679 224.628 189.855 234.572 189.922L234.599 185.923ZM212.718 207.496C212.718 219.58 222.371 229.187 234.525 229.106L234.498 225.107C224.56 225.173 216.718 217.357 216.718 207.496H212.718ZM232.512 227.106V227.143H236.511V227.106H232.512ZM192.123 174.913C181.272 174.831 172.291 183.648 172.168 194.498L176.167 194.544C176.265 185.895 183.446 178.846 192.092 178.912L192.123 174.913ZM172.168 194.493C172.004 206.083 180.674 214.953 192.196 214.871L192.167 210.872C182.932 210.938 176.034 203.942 176.167 194.549L172.168 194.493ZM192.189 214.871C203.259 214.83 211.858 206.229 211.899 195.159L207.9 195.144C207.867 204.018 201.046 210.839 192.174 210.872L192.189 214.871ZM177.294 229.437L179.187 232.96L182.028 231.434L181.138 228.334L177.294 229.437ZM175.17 225.884L178.255 223.339L178.255 223.339L175.17 225.884ZM174.686 225.29L177.818 222.803L177.804 222.785L177.789 222.767L174.686 225.29ZM167.977 207.644L171.923 206.994L171.922 206.99L167.977 207.644ZM172.528 188.674L176.142 190.386L176.142 190.386L172.528 188.674ZM172.796 188.108L176.411 189.818L176.415 189.81L172.796 188.108ZM194.368 158.377L191.425 155.67L191.417 155.679L194.368 158.377ZM194.69 158.028L197.634 160.735L197.634 160.735L194.69 158.028ZM205.155 147.812L207.628 150.955L207.635 150.949L207.642 150.944L205.155 147.812ZM208.343 143.809L212.056 145.294L212.853 143.301L211.632 141.535L208.343 143.809ZM206.392 140.896L203.053 143.097L203.053 143.097L206.392 140.896ZM201.893 134.541L198.78 137.051L198.784 137.057L198.789 137.063L201.893 134.541ZM201.596 113.893L198.366 111.535L198.366 111.535L201.596 113.893ZM203.128 111.779L199.884 109.439V109.439L203.128 111.779ZM212.42 100.399L209.65 97.5147L209.643 97.5209L212.42 100.399ZM213.332 99.5236L216.102 102.408L216.102 102.408L213.332 99.5236ZM240.776 74.1532L238.176 71.1143L238.175 71.1153L240.776 74.1532ZM250.932 67.8882L252.512 71.5621L252.519 71.5592L252.525 71.5563L250.932 67.8882ZM260.755 69.5193L263.431 66.5479L263.43 66.5469L260.755 69.5193ZM273.765 87.3873L270.267 89.326L270.272 89.3342L273.765 87.3873ZM288.999 122.827L292.787 121.543L292.785 121.538L288.999 122.827ZM291.705 136.691L295.702 136.815L295.702 136.813L291.705 136.691ZM285.923 148.109L283.503 144.924L283.503 144.925L285.923 148.109ZM274.061 155.041L272.324 151.439L272.317 151.442L272.31 151.446L274.061 155.041ZM273.017 155.523L271.381 151.874L271.381 151.874L273.017 155.523ZM270.021 157.302L267.193 154.475L266.894 154.774L266.663 155.13L270.021 157.302ZM269.527 160.844L273.494 160.33L273.493 160.329L269.527 160.844ZM269.539 160.935L273.508 160.441L273.507 160.432L273.505 160.422L269.539 160.935ZM270.54 169.149L274.51 168.671V168.671L270.54 169.149ZM273.431 191.333L277.386 190.741L277.386 190.739L273.431 191.333ZM268.168 228.997L264.571 227.249L264.57 227.25L268.168 228.997ZM253.712 244.159L251.955 240.566L251.944 240.571L253.712 244.159ZM249.37 246.372L251.211 249.922L251.211 249.922L249.37 246.372ZM238.7 251.35L237.322 247.596L234.812 248.517L234.704 251.188L238.7 251.35ZM239.965 255.639L236.402 257.455L236.402 257.455L239.965 255.639ZM241.146 258.431L244.543 260.542L245.469 259.052L245 257.361L241.146 258.431ZM232.964 271.601L236.361 273.711V273.711L232.964 271.601ZM216.349 298.319L212.955 296.203L210.953 299.416L214.05 301.591L216.349 298.319ZM240.553 315.334L244.255 313.82L243.812 312.738L242.856 312.064L240.553 315.334ZM238.179 324.9L241.454 327.195L241.455 327.195L238.179 324.9ZM237.922 325.269L234.641 322.982L234.638 322.987L237.922 325.269ZM205.377 343.73L205.775 347.709L205.824 347.705L205.872 347.699L205.377 343.73ZM204.645 343.787L204.913 347.777L204.913 347.777L204.645 343.787ZM203.19 343.953L202.366 340.039L202.334 340.046L202.303 340.053L203.19 343.953ZM159.637 327.271L156.648 329.928L156.657 329.938L159.637 327.271ZM157.745 325.01L160.85 322.49L160.85 322.489L157.745 325.01ZM157.08 324.194L153.88 326.593L153.933 326.664L153.989 326.732L157.08 324.194ZM156.097 322.785L152.781 325.02L152.781 325.02L156.097 322.785ZM155.671 322.155L158.975 319.902L157.473 317.698L154.861 318.239L155.671 322.155ZM143.951 323.323L143.774 319.327L143.951 323.323ZM139.955 323.527L139.696 319.536L139.685 319.537L139.955 323.527ZM132.183 324.18L132.55 328.162H132.55L132.183 324.18ZM112.044 324.935L111.759 328.924L112.044 324.935ZM93.844 321.154L95.2718 317.419L95.2663 317.416L93.844 321.154ZM71.8636 310.515L73.8946 307.07L73.8935 307.069L71.8636 310.515ZM51.1434 291.943L54.2416 289.414L54.2351 289.406L51.1434 291.943ZM29.6448 243.899L25.6946 244.523L25.6955 244.529L29.6448 243.899ZM29.5598 223.147L25.5707 222.862H25.5707L29.5598 223.147ZM29.6078 222.472L27.5521 219.042L25.7662 220.112L25.6187 222.189L29.6078 222.472ZM43.2667 214.298L41.2141 210.866H41.2141L43.2667 214.298ZM56.9258 206.124L58.9815 209.555L61.7595 207.89L60.7086 204.827L56.9258 206.124ZM51.4645 190.159L47.68 191.451V191.451L51.4645 190.159ZM48.141 180.434L44.9298 178.051L43.6764 179.739L44.3573 181.729L48.141 180.434ZM82.5388 155.745L83.9532 159.486L83.9604 159.483L82.5388 155.745ZM98.5144 150.333L99.6999 154.153L99.709 154.15L99.7181 154.147L98.5144 150.333ZM121.31 132.799L118.047 130.487L118.043 130.493L121.31 132.799ZM126.092 129.092L126.785 125.153H126.785L126.092 129.092ZM128.761 136.914L124.803 136.341L124.801 136.35L124.8 136.359L128.761 136.914ZM120.903 151.556L123.856 154.253L123.858 154.25L120.903 151.556ZM110.153 160.12L108.138 156.665L108.135 156.667L110.153 160.12ZM105.847 162.652L103.816 159.207H103.816L105.847 162.652ZM89.7297 171.797L91.5785 175.343L91.5862 175.339L89.7297 171.797ZM57.8525 218.802L53.918 218.086L53.9172 218.09L57.8525 218.802ZM66.8226 263.102L63.3999 265.17L63.4014 265.173L66.8226 263.102ZM110.969 289.978L111.373 285.999L111.364 285.998L110.969 289.978ZM131.244 267.661L127.285 268.223L127.286 268.236L131.244 267.661ZM126.129 253.093L129.605 251.115L129.6 251.107L129.595 251.098L126.129 253.093ZM119.369 242.576L116.059 244.821L119.369 242.576ZM115.936 237.449L119.285 235.264L119.283 235.26L115.936 237.449ZM105.742 208.942L101.746 209.092L101.746 209.097L105.742 208.942ZM130.132 160.157L127.91 156.832L127.909 156.833L130.132 160.157ZM139.741 154.334L137.745 150.869V150.869L139.741 154.334ZM152.743 146.107L150.343 142.908L150.332 142.916L152.743 146.107ZM162.936 137.507L160.248 134.546L160.244 134.549L162.936 137.507ZM152.446 102.067L151.337 105.909L151.346 105.912L152.446 102.067ZM137.508 104.81L135.566 101.315L135.554 101.321L137.508 104.81ZM131.763 105.774L127.987 107.09L128.058 107.296L128.152 107.492L131.763 105.774ZM134.098 100.51L131.673 97.3307L131.663 97.3383L131.653 97.346L134.098 100.51ZM160.934 93.9859L160.306 97.9354L160.309 97.9358L160.934 93.9859ZM170.338 96.9022L171.786 93.1743L171.786 93.1743L170.338 96.9022ZM171.906 97.5076L170.481 101.244L170.491 101.248L170.502 101.252L171.906 97.5076ZM179.171 103.179L182.31 100.701L182.308 100.698L179.171 103.179ZM180.041 104.418L176.705 106.623V106.623L180.041 104.418ZM180.691 105.367L177.471 107.739L177.512 107.794L177.555 107.848L180.691 105.367ZM180.728 150.741L184.062 152.949L184.063 152.948L180.728 150.741ZM160.082 172.019L162.553 175.164L162.555 175.162L160.082 172.019ZM144.662 187.255L141.36 185L141.359 185.001L144.662 187.255ZM139.176 207.718L135.233 208.385L135.234 208.391L139.176 207.718ZM151.371 225.549L153.59 222.222L153.585 222.219L151.371 225.549ZM169.793 231.184V227.185H169.771L169.749 227.185L169.793 231.184ZM164.011 319.338L162.367 315.692L163.789 323.331L164.011 319.338ZM175.835 317.966L176.805 321.846L176.812 321.844L176.82 321.842L175.835 317.966ZM168.846 317.123L170.524 320.753L170.524 320.753L168.846 317.123ZM175.946 313.925L177.513 317.605L177.531 317.597L177.549 317.589L175.946 313.925ZM181.618 313.629L180.684 317.518L180.695 317.52L180.707 317.523L181.618 313.629ZM195.555 318.819L197.143 322.489L205.143 319.026L197.3 315.221L195.555 318.819ZM189.661 318.782L187.826 322.335L187.833 322.339L187.841 322.343L189.661 318.782ZM181.138 228.334C180.449 225.934 179.051 224.304 178.255 223.339L172.085 228.429C172.953 229.481 173.278 229.94 173.45 230.54L181.138 228.334ZM178.255 223.339C178.087 223.136 177.949 222.968 177.818 222.803L171.554 227.777C171.739 228.01 171.926 228.235 172.085 228.429L178.255 223.339ZM177.789 222.767C174.304 218.479 172.944 213.195 171.923 206.994L164.031 208.294C165.086 214.697 166.691 221.794 171.583 227.812L177.789 222.767ZM171.922 206.99C171.009 201.481 173.207 196.581 176.142 190.386L168.914 186.962C166.161 192.773 162.645 199.934 164.032 208.298L171.922 206.99ZM176.142 190.386C176.231 190.198 176.321 190.008 176.411 189.818L169.181 186.398C169.092 186.585 169.003 186.773 168.914 186.962L176.142 190.386ZM176.415 189.81C181.438 179.13 189.043 170.13 197.32 161.076L191.417 155.679C183.088 164.79 174.754 174.548 169.177 186.406L176.415 189.81ZM197.312 161.085L197.634 160.735L191.747 155.321L191.425 155.67L197.312 161.085ZM197.634 160.735C200.97 157.107 204.045 153.775 207.628 150.955L202.681 144.67C198.51 147.953 195.013 151.768 191.746 155.321L197.634 160.735ZM207.642 150.944C209.139 149.755 210.941 148.081 212.056 145.294L204.629 142.324C204.261 143.244 203.691 143.868 202.668 144.681L207.642 150.944ZM211.632 141.535C211.006 140.629 210.387 139.689 209.732 138.695L203.053 143.097C203.699 144.077 204.368 145.092 205.053 146.083L211.632 141.535ZM209.732 138.695C208.339 136.583 206.792 134.229 204.997 132.019L198.789 137.063C200.291 138.912 201.625 140.93 203.053 143.097L209.732 138.695ZM205.006 132.031C202.644 129.102 201.753 126.541 201.741 124.237C201.728 121.907 202.611 119.285 204.826 116.251L198.366 111.535C195.467 115.506 193.718 119.762 193.742 124.28C193.767 128.825 195.582 133.085 198.78 137.051L205.006 132.031ZM204.826 116.251C205.347 115.537 205.863 114.823 206.371 114.119L199.884 109.439C199.375 110.146 198.872 110.842 198.366 111.535L204.826 116.251ZM206.371 114.119C209.276 110.092 211.938 106.421 215.196 103.277L209.643 97.5209C205.786 101.243 202.722 105.506 199.884 109.439L206.371 114.119ZM215.19 103.284L216.102 102.408L210.561 96.6391L209.65 97.5147L215.19 103.284ZM216.102 102.408C225.113 93.7532 234.012 85.2086 243.377 77.191L238.175 71.1153C228.608 79.3063 219.546 88.0108 210.561 96.6392L216.102 102.408ZM243.376 77.192C246.12 74.8439 249.143 73.011 252.512 71.5621L249.352 64.2144C245.308 65.9535 241.584 68.1984 238.176 71.1143L243.376 77.192ZM252.525 71.5563C253.803 71.0012 254.73 70.9289 255.444 71.0489C256.164 71.1699 257.03 71.5471 258.079 72.4918L263.43 66.5469C261.514 64.8225 259.304 63.5871 256.77 63.1613C254.232 62.7346 251.73 63.1813 249.339 64.2202L252.525 71.5563ZM258.078 72.4908C263.137 77.0481 266.685 82.8635 270.267 89.3259L277.263 85.4487C273.654 78.9365 269.566 72.0738 263.431 66.5479L258.078 72.4908ZM270.272 89.3342C276.412 100.353 281.104 112.043 285.213 124.115L292.785 121.538C288.591 109.218 283.72 97.0349 277.258 85.4405L270.272 89.3342ZM285.212 124.11C286.719 128.559 287.832 132.489 287.708 136.569L295.702 136.813C295.874 131.18 294.319 126.065 292.787 121.543L285.212 124.11ZM287.708 136.567C287.595 140.218 286.34 142.77 283.503 144.924L288.342 151.293C293.215 147.591 295.519 142.729 295.702 136.815L287.708 136.567ZM283.503 144.925C280.122 147.494 276.41 149.469 272.324 151.439L275.798 158.643C280.016 156.61 284.31 154.358 288.343 151.293L283.503 144.925ZM272.31 151.446C272.032 151.581 271.739 151.713 271.381 151.874L274.654 159.172C274.993 159.02 275.402 158.837 275.813 158.636L272.31 151.446ZM271.381 151.874C270.427 152.302 268.6 153.067 267.193 154.475L272.849 160.13C273.023 159.956 273.38 159.743 274.654 159.172L271.381 151.874ZM266.663 155.13C264.987 157.722 265.427 160.319 265.561 161.358L273.493 160.329C273.455 160.033 273.432 159.848 273.419 159.678C273.406 159.519 273.408 159.437 273.411 159.398C273.413 159.366 273.415 159.378 273.404 159.415C273.391 159.454 273.377 159.477 273.379 159.475L266.663 155.13ZM265.561 161.357L265.573 161.448L273.505 160.422L273.494 160.33L265.561 161.357ZM265.571 161.429C265.91 164.156 266.239 166.886 266.569 169.628L274.51 168.671C274.18 165.933 273.85 163.186 273.508 160.441L265.571 161.429ZM266.569 169.628C267.459 177.013 268.357 184.475 269.477 191.927L277.386 190.739C276.287 183.422 275.402 176.076 274.51 168.671L266.569 169.628ZM269.476 191.925C271.338 204.36 269.955 216.169 264.571 227.249L271.765 230.745C277.946 218.025 279.454 204.553 277.386 190.741L269.476 191.925ZM264.57 227.25C261.751 233.057 257.648 237.783 251.955 240.566L255.469 247.751C263.12 244.01 268.357 237.763 271.765 230.743L264.57 227.25ZM251.944 240.571C250.44 241.312 248.961 242.08 247.53 242.822L251.211 249.922C252.655 249.174 254.061 248.445 255.479 247.746L251.944 240.571ZM247.53 242.822C243.968 244.668 240.703 246.356 237.322 247.596L240.078 255.105C244.015 253.66 247.73 251.727 251.211 249.922L247.53 242.822ZM234.704 251.188C234.588 254.042 235.76 256.195 236.402 257.455L243.529 253.823C242.801 252.396 242.676 252.003 242.696 251.512L234.704 251.188ZM236.402 257.455C236.859 258.352 237.127 258.902 237.293 259.501L245 257.361C244.587 255.876 243.948 254.647 243.529 253.823L236.402 257.455ZM237.75 256.319C235.044 260.671 232.318 265.061 229.566 269.491L236.361 273.711C239.112 269.281 241.838 264.893 244.543 260.542L237.75 256.319ZM229.566 269.491C224.137 278.232 218.611 287.128 212.955 296.203L219.743 300.434C225.403 291.353 230.932 282.451 236.361 273.711L229.566 269.491ZM214.05 301.591C222.391 307.449 230.358 313.045 238.251 318.604L242.856 312.064C234.958 306.502 226.987 300.903 218.647 295.046L214.05 301.591ZM236.852 316.848C237.23 317.772 237.18 318.461 236.909 319.225C236.567 320.188 235.916 321.161 234.904 322.606L241.455 327.195C243.177 324.737 246.778 319.989 244.255 313.82L236.852 316.848ZM234.904 322.605C234.818 322.729 234.729 322.855 234.641 322.982L241.202 327.556C241.284 327.438 241.368 327.319 241.454 327.195L234.904 322.605ZM234.638 322.987C227.567 333.161 217.403 338.201 204.882 339.762L205.872 347.699C220.113 345.923 232.56 339.99 241.206 327.551L234.638 322.987ZM204.979 339.751C204.811 339.768 204.632 339.78 204.378 339.797L204.913 347.777C205.145 347.762 205.455 347.741 205.775 347.709L204.979 339.751ZM204.378 339.797C203.935 339.827 203.161 339.872 202.366 340.039L204.014 347.866C204.163 347.834 204.367 347.814 204.913 347.777L204.378 339.797ZM202.303 340.053C186.013 343.762 173.75 337.046 162.617 324.604L156.657 329.938C168.876 343.593 183.894 352.447 204.078 347.852L202.303 340.053ZM162.626 324.614C162.039 323.953 161.479 323.264 160.85 322.49L154.64 327.531C155.251 328.284 155.923 329.112 156.648 329.928L162.626 324.614ZM160.85 322.489C160.63 322.219 160.402 321.938 160.17 321.656L153.989 326.732C154.205 326.994 154.419 327.258 154.64 327.531L160.85 322.489ZM160.279 321.795C160.027 321.459 159.781 321.095 159.414 320.55L152.781 325.02C153.124 325.529 153.485 326.067 153.88 326.593L160.279 321.795ZM159.414 320.55C159.281 320.353 159.134 320.135 158.975 319.902L152.367 324.408C152.512 324.62 152.647 324.821 152.781 325.02L159.414 320.55ZM154.861 318.239C151.234 318.989 147.662 319.155 143.774 319.327L144.128 327.318C147.931 327.149 152.131 326.971 156.481 326.071L154.861 318.239ZM143.774 319.327C142.445 319.386 141.073 319.447 139.696 319.536L140.213 327.517C141.495 327.434 142.785 327.377 144.128 327.318L143.774 319.327ZM139.685 319.537C137.035 319.716 134.397 319.96 131.815 320.198L132.55 328.162C135.148 327.923 137.689 327.688 140.225 327.517L139.685 319.537ZM131.815 320.198C125.059 320.821 118.686 321.4 112.329 320.946L111.759 328.924C118.877 329.433 125.902 328.776 132.55 328.162L131.815 320.198ZM112.329 320.946C106.379 320.521 100.631 319.467 95.2718 317.419L92.4163 324.89C98.6956 327.29 105.254 328.46 111.759 328.924L112.329 320.946ZM95.2663 317.416C87.8973 314.612 80.7611 311.118 73.8946 307.07L69.8326 313.96C77.0514 318.216 84.5935 321.913 92.4218 324.892L95.2663 317.416ZM73.8935 307.069C66.3209 302.608 59.9941 296.461 54.2416 289.414L48.0453 294.471C54.154 301.955 61.1712 308.857 69.8337 313.961L73.8935 307.069ZM54.2351 289.406C43.1675 275.917 36.3391 260.49 33.5941 243.27L25.6955 244.529C28.6588 263.118 36.064 279.869 48.0517 294.479L54.2351 289.406ZM33.5951 243.275C32.6007 236.977 33.0395 230.576 33.5488 223.431L25.5707 222.862C25.0729 229.846 24.5335 237.168 25.6946 244.523L33.5951 243.275ZM33.5488 223.431C33.5648 223.206 33.5809 222.981 33.5969 222.756L25.6187 222.189C25.6027 222.413 25.5867 222.638 25.5707 222.862L33.5488 223.431ZM31.6634 225.903C36.2393 223.161 40.7784 220.446 45.3193 217.731L41.2141 210.866C36.6738 213.581 32.1316 216.298 27.5521 219.042L31.6634 225.903ZM45.3193 217.731C49.8597 215.015 54.4019 212.299 58.9815 209.555L54.8701 202.694C50.2942 205.436 45.7551 208.151 41.2141 210.866L45.3193 217.731ZM60.7086 204.827C58.8417 199.385 57.0308 194.083 55.249 188.866L47.68 191.451C49.4615 196.667 51.2742 201.974 53.143 207.422L60.7086 204.827ZM55.249 188.866C54.1315 185.594 53.0254 182.356 51.9248 179.14L44.3573 181.729C45.457 184.943 46.5624 188.179 47.68 191.451L55.249 188.866ZM51.3523 182.818C59.7438 171.512 70.9214 164.414 83.9532 159.486L81.1243 152.005C67.0976 157.309 54.4785 165.186 44.9298 178.051L51.3523 182.818ZM83.9604 159.483C89.11 157.525 94.3568 155.811 99.6999 154.153L97.329 146.514C91.9228 148.192 86.4944 149.962 81.1171 152.007L83.9604 159.483ZM99.7181 154.147C110.497 150.745 118.424 143.824 124.578 135.105L118.043 130.493C112.632 138.159 106.029 143.768 97.3107 146.519L99.7181 154.147ZM124.574 135.11C125.038 134.455 125.404 133.955 125.723 133.559C126.046 133.159 126.244 132.961 126.349 132.871C126.443 132.791 126.359 132.888 126.111 132.968C125.828 133.061 125.561 133.059 125.399 133.03L126.785 125.153C124.467 124.745 122.577 125.577 121.159 126.786C119.975 127.796 118.943 129.223 118.047 130.487L124.574 135.11ZM125.399 133.03C124.967 132.954 124.673 132.702 124.569 132.57C124.515 132.503 124.613 132.602 124.721 133.022C124.941 133.878 124.974 135.157 124.803 136.341L132.719 137.486C132.992 135.594 133.025 133.196 132.467 131.028C131.954 129.035 130.498 125.806 126.785 125.153L125.399 133.03ZM124.8 136.359C124.152 140.986 121.574 144.883 117.947 148.863L123.858 154.25C127.867 149.852 131.739 144.482 132.721 137.468L124.8 136.359ZM117.949 148.86C115.144 151.933 111.84 154.505 108.138 156.665L112.169 163.574C116.473 161.063 120.434 158.001 123.856 154.253L117.949 148.86ZM108.135 156.667C106.689 157.513 105.249 158.362 103.816 159.207L107.878 166.097C109.313 165.251 110.741 164.409 112.172 163.572L108.135 156.667ZM103.816 159.207C98.4701 162.359 93.2319 165.446 87.8732 168.255L91.5862 175.339C97.1517 172.422 102.562 169.231 107.878 166.097L103.816 159.207ZM87.8808 168.251C67.3449 178.958 57.7733 196.918 53.918 218.086L61.7869 219.519C65.3449 199.983 73.8618 184.58 91.5785 175.343L87.8808 168.251ZM53.9172 218.09C50.8244 235.182 54.83 250.989 63.3999 265.17L70.2453 261.033C62.5059 248.227 59.0982 234.378 61.7877 219.514L53.9172 218.09ZM63.4014 265.173C74.0208 282.714 90.4108 291.957 110.574 293.957L111.364 285.998C93.4224 284.218 79.4178 276.185 70.2437 261.031L63.4014 265.173ZM110.564 293.956C118.019 294.714 124.613 290.481 128.918 285.373C133.197 280.296 136.106 273.319 135.202 267.087L127.286 268.236C127.754 271.457 126.178 276.213 122.802 280.218C119.454 284.192 115.224 286.391 111.373 285.999L110.564 293.956ZM135.204 267.1C134.382 261.306 132.412 256.048 129.605 251.115L122.653 255.071C125.035 259.257 126.624 263.563 127.285 268.223L135.204 267.1ZM129.595 251.098C127.424 247.323 125.004 243.76 122.678 240.331L116.059 244.821C118.412 248.29 120.663 251.611 122.663 255.087L129.595 251.098ZM122.678 240.331C121.522 238.626 120.388 236.954 119.285 235.264L112.586 239.634C113.735 241.395 114.909 243.126 116.059 244.821L122.678 240.331ZM119.283 235.26C113.834 226.926 110.108 218.291 109.739 208.786L101.746 209.097C102.192 220.574 106.695 230.622 112.588 239.637L119.283 235.26ZM109.739 208.791C109.009 189.404 116.123 174.338 132.356 163.481L127.909 156.833C109.224 169.33 100.919 187.108 101.746 209.092L109.739 208.791ZM132.355 163.482C135.34 161.486 138.47 159.681 141.737 157.799L137.745 150.869C134.516 152.728 131.153 154.664 127.91 156.832L132.355 163.482ZM141.737 157.799C146.146 155.26 150.81 152.579 155.153 149.298L150.332 142.916C146.452 145.847 142.224 148.288 137.745 150.869L141.737 157.799ZM155.142 149.306C158.855 146.521 162.303 143.491 165.628 140.464L160.244 134.549C156.971 137.528 153.747 140.355 150.343 142.908L155.142 149.306ZM165.624 140.468C172.056 134.628 173.512 125.226 171.403 117.1C169.264 108.858 163.254 100.999 153.546 98.2223L151.346 105.912C157.837 107.769 162.094 113.071 163.661 119.11C165.259 125.266 163.861 131.266 160.248 134.546L165.624 140.468ZM153.556 98.2251C146.763 96.2635 140.573 98.5327 135.566 101.315L139.451 108.306C143.785 105.898 147.603 104.831 151.337 105.909L153.556 98.2251ZM135.554 101.321C134.889 101.694 133.949 102.08 133.253 102.241C132.876 102.329 132.86 102.282 133.094 102.308C133.23 102.324 133.596 102.381 134.041 102.627C134.534 102.901 135.049 103.372 135.374 104.056L128.152 107.492C129.155 109.601 131.153 110.138 132.194 110.256C133.27 110.377 134.307 110.208 135.062 110.032C136.63 109.668 138.274 108.965 139.463 108.3L135.554 101.321ZM135.54 104.458C135.701 104.922 135.498 105.071 135.678 104.703C135.752 104.553 135.869 104.368 136.031 104.172C136.193 103.978 136.372 103.807 136.544 103.675L131.653 97.346C130.398 98.3155 129.245 99.6521 128.494 101.188C127.758 102.691 127.203 104.842 127.987 107.09L135.54 104.458ZM136.524 103.69C143.56 98.3219 151.52 96.5375 160.306 97.9354L161.563 90.0364C150.778 88.3204 140.575 90.5395 131.673 97.3307L136.524 103.69ZM160.309 97.9358C163.013 98.3642 165.729 99.4023 168.89 100.63L171.786 93.1743C168.779 92.0064 165.257 90.6217 161.56 90.036L160.309 97.9358ZM168.89 100.63C169.412 100.833 169.946 101.04 170.481 101.244L173.332 93.7711C172.823 93.577 172.311 93.3784 171.786 93.1743L168.89 100.63ZM170.502 101.252C172.555 102.022 174.339 103.517 176.035 105.66L182.308 100.698C180.074 97.8741 177.188 95.2174 173.31 93.7631L170.502 101.252ZM176.032 105.657C176.225 105.901 176.413 106.181 176.705 106.623L183.378 102.214C183.116 101.818 182.746 101.254 182.31 100.701L176.032 105.657ZM176.705 106.623C176.908 106.93 177.175 107.336 177.471 107.739L183.911 102.994C183.756 102.784 183.6 102.55 183.378 102.214L176.705 106.623ZM177.555 107.848C183.007 114.739 184.932 121.761 184.596 128.523C184.257 135.37 181.579 142.211 177.393 148.533L184.063 152.948C188.81 145.777 192.156 137.567 192.585 128.919C193.018 120.185 190.459 111.267 183.827 102.885L177.555 107.848ZM177.394 148.533C172.208 156.364 165.28 162.841 157.609 168.876L162.555 175.162C170.526 168.89 178.202 161.799 184.062 152.949L177.394 148.533ZM157.611 168.875C151.884 173.375 145.888 178.369 141.36 185L147.965 189.511C151.74 183.982 156.864 179.635 162.553 175.164L157.611 168.875ZM141.359 185.001C136.809 191.667 133.7 199.315 135.233 208.385L143.12 207.052C142.058 200.775 144.064 195.225 147.965 189.51L141.359 185.001ZM135.234 208.391C136.791 217.516 142.14 224.214 149.157 228.88L153.585 222.219C148 218.506 144.231 213.564 143.119 207.046L135.234 208.391ZM149.153 228.877C155.201 232.91 162.207 235.267 169.837 235.183L169.749 227.185C163.888 227.249 158.439 225.455 153.59 222.222L149.153 228.877ZM169.793 235.183C172.778 235.183 175.871 234.742 179.187 232.96L175.401 225.915C173.574 226.896 171.884 227.185 169.793 227.185V235.183ZM163.789 323.331C169.053 323.623 173.104 322.771 176.805 321.846L174.865 314.086C171.45 314.94 168.31 315.571 164.233 315.345L163.789 323.331ZM167.168 313.492C165.644 314.197 164.065 314.926 162.367 315.692L165.655 322.983C167.392 322.2 169.003 321.456 170.524 320.753L167.168 313.492ZM174.38 310.246C171.992 311.262 169.643 312.348 167.168 313.492L170.524 320.753C173.02 319.599 175.257 318.565 177.513 317.605L174.38 310.246ZM182.551 309.74C180.174 309.17 177.18 309.02 174.343 310.262L177.549 317.589C178.271 317.273 179.354 317.198 180.684 317.518L182.551 309.74ZM197.3 315.221C192.169 312.731 187.506 310.899 182.528 309.735L180.707 317.523C184.922 318.509 189.007 320.087 193.809 322.417L197.3 315.221ZM187.841 322.343C189.046 322.958 190.468 323.454 192.147 323.519C193.818 323.584 195.473 323.212 197.143 322.489L193.966 315.149C193.153 315.5 192.695 315.536 192.457 315.527C192.227 315.518 191.944 315.458 191.481 315.221L187.841 322.343ZM176.82 321.842C181.084 320.759 184.566 320.651 187.826 322.335L191.496 315.228C185.712 312.241 179.927 312.801 174.851 314.09L176.82 321.842Z" fill="#09275E" mask="url(#path-14-outside-1_503_366)" data-v-abe3e1ac></path><path d="M89.8915 57.0404L88.8306 56.4518L87.8186 57.121C83.1444 60.2119 78.8785 63.8126 74.7973 67.2575C72.8793 68.8764 71.0021 70.4608 69.1426 71.9418L68.5392 72.4223L68.4148 73.1836C67.5559 78.4416 67.2125 83.6401 66.8775 88.7105C66.7295 90.952 66.583 93.1685 66.3945 95.3539L66.2979 96.4726L67.2029 97.1374C73.7731 101.964 80.2245 106.589 87.0594 110.997L88.5282 111.944L89.6634 110.615C99.2102 99.4404 108.42 88.6371 117.806 77.6265L119.17 76.0265L120.755 74.1671L118.619 72.9811C109.997 68.1945 101.84 63.6689 93.2746 58.9173C92.1545 58.2959 91.0275 57.6706 89.8915 57.0404Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M234.144 227.534C245.264 227.497 253.864 218.785 253.752 207.738C253.641 196.876 245.116 188.387 234.218 188.313C223.173 188.239 214.388 196.95 214.351 207.886C214.351 218.859 223.098 227.571 234.144 227.497V227.534ZM209.495 195.542C209.569 185.421 201.711 177.377 191.74 177.303C181.992 177.229 173.911 185.162 173.8 194.912C173.652 205.402 181.436 213.336 191.814 213.261C201.785 213.224 209.495 205.514 209.532 195.542H209.495Z" fill="white" data-v-abe3e1ac></path><path d="M326.03 255.941L327.06 254.494L325.746 253.3C314.068 242.697 302.688 232.39 290.938 221.751L289.436 220.391L288.096 221.911C283.602 227.006 279.159 232.049 274.717 237.092C269.007 243.574 263.297 250.056 257.48 256.645L256.053 258.262L257.773 259.563C263.62 263.986 269.634 267.923 275.55 271.755C276.01 272.053 276.47 272.351 276.929 272.648C281.952 275.898 286.886 279.092 291.64 282.498C291.145 283.634 290.505 284.695 289.809 285.85C289.759 285.934 289.708 286.018 289.657 286.103C288.682 287.723 287.577 289.599 287.15 291.848L286.96 292.846L287.654 293.588C289.462 295.519 291.386 296.901 293.747 298.2L295.305 299.056L296.338 297.61C303.314 287.843 310.216 278.15 317.28 268.227C320.164 264.177 323.075 260.088 326.03 255.941Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M338.304 204.327L340.616 203.887L339.809 201.677C337.196 194.522 334.629 187.488 332.062 180.454L332.06 180.448C329.493 173.416 326.927 166.384 324.315 159.231L323.572 157.196L321.603 158.099C312.602 162.228 303.999 166.201 295.438 170.155C292.927 171.315 290.419 172.474 287.905 173.634L286.432 174.314L286.794 175.895C287.483 178.907 288.165 181.885 288.842 184.842C290.824 193.497 292.764 201.972 294.726 210.591L295.153 212.471L297.048 212.112C303.286 210.93 309.385 209.783 315.447 208.643C323.058 207.212 330.611 205.792 338.304 204.327Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M37.3088 70.9943L35.2298 70.8135L35.1379 72.8983C34.8368 79.7309 35.1199 86.2832 35.4538 92.655C35.4925 93.3945 35.5319 94.1312 35.5712 94.8654C35.8716 100.484 36.1646 105.96 36.0998 111.479L36.0783 113.317L37.9082 113.493C49.9545 114.649 61.3173 115.099 73.3255 114.575L74.9709 114.504L75.2157 112.875C76.5829 103.776 77.4526 94.7227 78.3254 85.6351C78.6885 81.8548 79.0522 78.0687 79.4525 74.271L79.676 72.1506L77.5456 72.0635C72.0999 71.8409 66.7299 71.813 61.4159 71.7853C60.05 71.7782 58.6877 71.7711 57.3289 71.7607C50.6626 71.7098 44.0466 71.5803 37.3088 70.9943Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M293.135 284.096L294.283 282.389L292.544 281.29C285.636 276.922 278.849 272.64 272.089 268.375C264.438 263.547 256.821 258.742 249.103 253.858L247.365 252.759L246.315 254.526C242.757 260.514 239.237 266.431 235.729 272.329C230.832 280.561 225.958 288.754 221.035 297.047L220.055 298.697L221.664 299.744C226.371 302.807 231.013 305.901 235.644 308.988C244.5 314.891 253.318 320.77 262.487 326.355L264.121 327.35L265.187 325.762C269.467 319.393 273.673 313.115 277.875 306.842C282.927 299.301 287.973 291.769 293.135 284.096Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M4.6069 136.87L3.32656 138.114L4.41714 139.527C5.45766 140.875 6.49509 142.219 7.53067 143.56C13.6143 151.443 19.6343 159.242 25.8437 167.258L26.9528 168.69L28.4871 167.727C34.6363 163.87 40.6597 160.096 46.7543 156.277C50.6154 153.858 54.505 151.421 58.4733 148.933L60.4036 147.723L58.9534 145.966C49.8109 134.89 40.7098 124.525 31.3269 113.991L29.9405 112.435L28.4429 113.884C24.7686 117.442 21.1619 120.91 17.5712 124.363C13.2568 128.511 8.96536 132.638 4.6069 136.87Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M24.1438 220.764L24.7235 223.219L26.9813 222.095C35.2305 217.986 42.7267 213.623 50.2998 209.214C51.4696 208.534 52.6413 207.852 53.8179 207.169L55.3098 206.304L54.6731 204.701C53.3352 201.333 52.2061 197.943 51.0558 194.489C50.8421 193.847 50.6276 193.203 50.411 192.557C49.0368 188.457 47.5826 184.287 45.7024 180.146L44.9085 178.398L43.1293 179.12C41.6769 179.71 40.2302 180.291 38.7892 180.87C31.8672 183.65 25.0751 186.377 18.3958 189.795L17.0028 190.508L17.3598 192.031C18.8458 198.372 20.3156 204.583 21.8347 211.001C22.5895 214.19 23.3566 217.431 24.1438 220.764Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916" data-v-abe3e1ac></path><path d="M223.136 212.372C225.063 210.629 227.658 211.037 228.733 208.553C228.918 204.179 224.841 205.959 222.765 204.921C221.876 199.99 224.1 195.468 228.066 193.985C231.735 192.576 236.369 194.244 238.741 198.211C241.669 203.141 241.558 208.405 239.297 213.521C238.111 216.227 235.664 217.895 232.551 217.747C228.659 217.525 224.952 216.82 223.136 212.409V212.372Z" fill="#09275E" data-v-abe3e1ac></path><path d="M190.814 197.247C188.923 196.024 186.996 196.802 185.365 196.098C183.919 191.538 186.625 185.57 190.999 183.716C194.891 182.085 199.784 184.198 201.971 188.721C204.046 193.021 204.195 197.655 202.638 202.066C200.303 208.739 193.445 209.406 187.811 203.512C188.404 201.992 190.517 202.363 190.851 201.362C191.926 199.62 191.815 198.433 190.851 197.21L190.814 197.247Z" fill="#09275E" data-v-abe3e1ac></path><path d="M258.547 165.167C259.667 168.526 263.813 172.965 265.746 174.765C266.945 172.765 265.182 164.595 264.946 163.767C264.346 159.768 264.546 158.768 264.946 155.369C265.346 151.97 273.544 151.17 281.342 146.771C289.141 142.372 287.541 134.373 286.341 130.374C285.307 126.927 283.142 122.976 281.742 119.776C280.342 116.577 271.944 101.98 269.945 98.3807C267.945 94.7815 266.145 93.5817 265.746 93.5817C265.346 93.5817 264.346 93.5817 265.346 98.3807C265.876 100.926 267.345 108.779 267.745 110.378C268.145 111.978 268.945 124.175 268.345 129.174C267.865 133.173 266.145 137.639 265.346 139.372C265.012 137.906 264.106 134.533 263.146 132.774C261.946 130.574 260.147 126.775 258.547 125.175C256.948 123.575 255.748 122.176 253.748 121.776C251.748 121.376 255.548 127.775 257.147 132.774C258.747 137.773 256.948 142.372 257.147 147.97C257.347 153.569 257.147 160.968 258.547 165.167Z" fill="#FFA220" data-v-abe3e1ac></path><path d="M232.123 270.553C232.123 267.25 229.599 264.176 227.693 261.583C226.593 260.086 225.628 258.278 224.349 256.998" stroke="#FFBB34" stroke-width="1.19975" stroke-linecap="round" data-v-abe3e1ac></path><path d="M232.521 269.158C232.057 267.59 231.444 266.408 230.373 265.104C228.229 262.495 226.282 259.735 224.216 257.065C222.613 254.994 220.993 252.315 220.163 249.822" stroke="#FFBB34" stroke-width="1.19975" stroke-linecap="round" data-v-abe3e1ac></path><path d="M229.953 263.546C231.553 266.266 232.753 269.611 233.153 270.945L238.352 262.746L234.752 255.348C233.553 253.548 233.553 251.349 233.553 249.549C233.553 247.749 237.552 247.35 238.752 246.55C239.951 245.75 240.751 245.75 242.751 244.15C244.75 242.551 247.95 240.351 248.349 238.751C248.749 237.152 241.151 240.151 239.151 240.751C237.152 241.351 233.953 242.55 232.353 243.35C230.753 244.15 226.354 245.35 223.155 246.55C219.955 247.749 220.155 250.549 220.355 251.949C220.555 253.348 223.955 255.948 224.554 256.348C225.154 256.748 227.954 260.147 229.953 263.546Z" fill="#FFA220" data-v-abe3e1ac></path></svg>', 1)
  ]));
}
const BluepicSpinner = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["render", _sfc_render$3], ["__scopeId", "data-v-abe3e1ac"]]);
async function waitUntil(m, c) {
  for (; !await m(); )
    await new Promise(
      (ie) => typeof c == "number" ? setTimeout(ie, c) : requestAnimationFrame(ie)
    );
}
function imageInfo(m) {
  return new Promise(function(c, ie) {
    const we = new Image();
    we.addEventListener("load", ($e) => {
      c({
        width: we.width,
        height: we.height,
        ratio: we.height / we.width
      });
    }), we.addEventListener("error", () => ie({ err: "image corrupted" })), we.src = typeof m == "string" ? m : URL.createObjectURL(m);
  });
}
function normalizeCrop({ height: m, left: c, top: ie, width: we }, $e, Me) {
  const Ze = 1 / Math.max((we ?? 0) / $e, (m ?? 0) / Me), ne = [
    Math.min(1, round$3(Math.max(1e-6, c ?? 0) / ($e - (we ?? 0)), 6)),
    Math.min(1, round$3(Math.max(1e-6, ie ?? 0) / (Me - (m ?? 0)), 6))
  ], rr = [Math.max(-1, Math.min(1, (ne[0] - 0.5) * 2)), Math.max(-1, Math.min(1, (ne[1] - 0.5) * 2))];
  return { scale: Ze, innerPos: rr };
}
function normalizeAdjust(m, c, ie, we) {
  const $e = m.innerPos[0] / 2 + 0.5, Me = m.innerPos[1] / 2 + 0.5, Ze = c / ie > we ? ie * we : c, ne = c / ie > we ? ie : c / we, rr = Ze / m.scale, gr = ne / m.scale, or = c - rr, _r = ie - gr, Lr = or * $e, Ir = _r * Me;
  return { left: Lr, top: Ir, width: rr, height: gr };
}
const _hoisted_1$B = {
  class: "adjust-image swiper-no-swiping",
  ref: "adjustImageRef"
}, _hoisted_2$q = {
  key: 0,
  class: "cropper-wrapper"
}, _hoisted_3$f = {
  key: 1,
  class: "spinner-wrapper"
}, _sfc_main$M = /* @__PURE__ */ defineComponent({
  __name: "AdjustImage",
  props: {
    src: {},
    width: {},
    height: {},
    ratio: {},
    adjust: {},
    inline: { type: Boolean },
    minScale: {},
    maxScale: {}
  },
  emits: ["update:adjust"],
  setup(m, { emit: c }) {
    const ie = m, we = c;
    console.log("adjust", ie.adjust);
    const $e = ref$1();
    watch(
      () => ie.src,
      async () => {
        const { width: gr, height: or } = await imageInfo(ie.src);
        $e.value = { width: gr, height: or };
      },
      { immediate: !0 }
    );
    const Me = ref$1(), Ze = ref$1({
      width: 0,
      height: 0,
      left: 0,
      top: 0
    });
    function ne({ coordinates: gr }) {
      Ze.value = gr;
    }
    let rr = !1;
    return watch(
      [() => ie.adjust, Me],
      async ([gr, or]) => {
        if (!or || rr)
          return;
        const _r = normalizeAdjust(gr, ie.width, ie.height, ie.ratio);
        Ze.value = _r, await waitUntil(() => or.getResult().canvas !== void 0, "animationFrame"), or.setCoordinates(_r, { transitions: !1 }), rr = !0;
      },
      { immediate: !0 }
    ), watch(Ze, (gr) => {
      !rr || we("update:adjust", normalizeCrop(gr, ie.width, ie.height));
    }), (gr, or) => (openBlock(), createElementBlock("div", _hoisted_1$B, [
      $e.value ? (openBlock(), createElementBlock("div", _hoisted_2$q, [
        createVNode(unref(fe), {
          ref_key: "cropperRef",
          ref: Me,
          src: gr.src,
          "stencil-props": { aspectRatio: gr.ratio },
          onChange: ne
        }, null, 8, ["src", "stencil-props"])
      ])) : (openBlock(), createElementBlock("div", _hoisted_3$f, [
        createVNode(BluepicSpinner)
      ]))
    ], 512));
  }
}), AdjustImage_vue_vue_type_style_index_0_scoped_71a25023_lang = "", AdjustImage_vue_vue_type_style_index_1_lang = "", AdjustImage = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["__scopeId", "data-v-71a25023"]]), _hoisted_1$A = ["src"], _hoisted_2$p = { class: "actions" }, _sfc_main$L = /* @__PURE__ */ defineComponent({
  __name: "ImageEdit",
  props: /* @__PURE__ */ mergeModels({
    allowUploadFromDevice: { type: Boolean },
    width: {},
    height: {},
    allowedTypes: {},
    convertTo: {},
    quality: {},
    imageLibraries: {},
    removeBackground: { type: Boolean },
    uploadLabel: { default: "Select image" },
    actionsLabel: { default: "More" },
    maxSize: { default: 1 / 0 },
    bridge: {},
    mobile: { type: Boolean, default: !1 },
    field: {},
    allowCropImage: { type: Boolean },
    aspectRatio: {},
    resetCropOnChange: { type: Boolean, default: !0 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue"), ie = computed({
      get: () => c.value?.src,
      set: (si) => {
        !c.value || typeof c.value != "object" ? c.value = {
          src: si,
          scale: 1,
          innerPos: [0, 0],
          innerRotate: 0
        } : c.value.src = si;
      }
    }), we = computed({
      get: () => ({
        scale: c.value.scale,
        innerPos: c.value.innerPos,
        innerRotate: c.value.innerRotate
      }),
      set: (si) => {
        c.value = {
          src: c.value.src,
          scale: si.scale,
          innerPos: si.innerPos,
          innerRotate: si.innerRotate
        };
      }
    });
    watch(ie, () => {
      $e.resetCropOnChange && (we.value = {
        scale: 1,
        innerPos: [0, 0],
        innerRotate: 0
      });
    });
    const $e = m, Me = ref$1(!1), Ze = ref$1(!1), ne = computed(() => $e.allowCropImage ? 1 : 2), { uploadFiles: rr, uploadProgresses: gr, uploading: or } = useUpload(
      toRef($e, "width"),
      toRef($e, "height"),
      toRef($e, "convertTo"),
      toRef($e, "quality"),
      $e.bridge.handleUpload,
      toRef($e, "field")
    );
    async function _r() {
      const si = await openFiles({
        types: $e.allowedTypes,
        maxSize: $e.maxSize,
        multiple: !0
      }), li = createPopup({
        title: "Uploading images",
        content: () => [
          h$1(BxProgress, { value: gr.value.reduce((oi, ci) => oi + ci, 0) / gr.value.length })
        ],
        closeable: !1,
        icon: () => h$1(CloudUploadOutline),
        disableBackgroundEffect: !0
      }), xi = await rr(si);
      li.close();
      const di = xi[0];
      di && Nr(di.src);
    }
    const Lr = computed(() => [
      ...$e.allowUploadFromDevice ? [
        {
          label: $e.uploadLabel,
          action: _r,
          icon: () => h$1(ImageOutline),
          key: "upload"
        }
      ] : [],
      ...$e.imageLibraries.map((li) => ({
        label: li.label,
        icon: () => {
          if (li.type === "sharedDrive")
            switch (li.service) {
              case "googledrive":
                return h$1("img", {
                  src: "https://upload.wikimedia.org/wikipedia/commons/1/12/Google_Drive_icon_%282020%29.svg"
                });
              case "onedrive":
                return h$1("img", {
                  src: "https://upload.wikimedia.org/wikipedia/commons/3/3c/Microsoft_Office_OneDrive_%282019\u2013present%29.svg"
                });
              default:
                return h$1(ImageOutline);
            }
          else
            return li.type === "pexels" ? h$1("img", { src: "https://www.drupal.org/files/project-images/pexels_logo_0.png" }) : h$1(ImageOutline);
        },
        key: (() => li.type === "sharedDrive" ? li.service : li.type === "custom" ? "custom" : li.type)(),
        lib: li
      }))
    ]), Ir = ref$1(), Ar = computed(() => Lr.value.slice(ne.value === 1 ? ne.value : ne.value - 1).map((si) => ({
      label: si.label,
      value: si.key,
      icon: $e.mobile ? si.icon : () => h$1(BxIcon, {}, si.icon)
    })));
    function Rr(si) {
      console.log("handleSelectRemainingAction", si), si === "upload" ? Lr.value.length > 1 ? (Ir.value = void 0, Me.value = !0) : _r() : (Ir.value = si, Me.value = !0);
    }
    function Nr(si) {
      ie.value = si, Me.value = !1;
    }
    function Yr(si) {
      $e.imageLibraries.length === 0 && $e.allowUploadFromDevice && (_r(), si.stopImmediatePropagation(), si.stopPropagation(), nextTick$3(() => {
        Me.value = !1;
      }));
    }
    const Vr = ref$1();
    watchEffect(async () => {
      ie.value && (Vr.value = await imageInfo(ie.value));
    });
    const Xr = ref$1(!1);
    function Wr(si) {
      Rr(si), Xr.value = !1;
    }
    return (si, li) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["image-edit-field", { "has-single-action": Ar.value.length === 0 }])
    }, [
      createVNode(_sfc_main$18, {
        closeable: !1,
        show: Me.value,
        "onUpdate:show": li[3] || (li[3] = (xi) => Me.value = xi),
        type: "layer",
        trigger: "click",
        fullscreen: ""
      }, {
        title: withCtx(() => [
          Ir.value ? (openBlock(), createBlock(BxButton, {
            key: 0,
            circle: "",
            onClick: li[0] || (li[0] = (xi) => Ir.value = void 0)
          }, {
            icon: withCtx(() => [
              createVNode(BxIcon, null, {
                default: withCtx(() => [
                  createVNode(unref(ArrowBackOutline))
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : createCommentVNode("", !0)
        ]),
        "header-actions": withCtx(() => [
          createVNode(BxButton, {
            circle: "",
            onClick: li[1] || (li[1] = (xi) => Me.value = !1)
          }, {
            icon: withCtx(() => [
              createVNode(BxIcon, null, {
                default: withCtx(() => [
                  createVNode(unref(CloseOutline))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        trigger: withCtx(() => [
          createElementVNode("div", {
            class: "image-preview",
            onClick: Yr
          }, [
            createElementVNode("img", {
              src: ie.value,
              alt: "image"
            }, null, 8, _hoisted_1$A)
          ])
        ]),
        content: withCtx(() => [
          createVNode(ImageLibraryWrapper, {
            "active-key": Ir.value,
            "onUpdate:activeKey": li[2] || (li[2] = (xi) => Ir.value = xi),
            options: Lr.value,
            "image-libraries": si.imageLibraries,
            width: si.width,
            height: si.height,
            quality: si.quality,
            "convert-to": si.convertTo,
            bridge: si.bridge,
            field: si.field,
            onSelect: Nr
          }, null, 8, ["active-key", "options", "image-libraries", "width", "height", "quality", "convert-to", "bridge", "field"])
        ]),
        _: 1
      }, 8, ["show"]),
      createElementVNode("div", _hoisted_2$p, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(Lr.value.slice(0, Lr.value.length > ne.value ? ne.value - 1 : ne.value), (xi, di) => (openBlock(), createBlock(BxButton, {
          secondary: di === 0,
          onClick: (oi) => Rr(xi.key)
        }, {
          icon: withCtx(() => [
            createVNode(BxIcon, null, {
              default: withCtx(() => [
                (openBlock(), createBlock(resolveDynamicComponent(xi.icon)))
              ]),
              _: 2
            }, 1024)
          ]),
          default: withCtx(() => [
            createTextVNode(" " + toDisplayString(xi.label), 1)
          ]),
          _: 2
        }, 1032, ["secondary", "onClick"]))), 256)),
        Ar.value.length > 0 && Lr.value.length > ne.value ? (openBlock(), createBlock(resolveDynamicComponent(si.mobile ? BxDropdown : BxSelect), {
          key: 0,
          trigger: "manual",
          options: Ar.value,
          onSelect: Rr,
          "model-value": void 0,
          "onUpdate:modelValue": Wr,
          "mobile-layout": si.mobile,
          show: Xr.value,
          "onUpdate:show": li[5] || (li[5] = (xi) => Xr.value = xi)
        }, {
          trigger: withCtx(() => [
            ne.value === 1 ? (openBlock(), createBlock(BxButton, {
              key: 0,
              secondary: "",
              onClick: li[4] || (li[4] = (xi) => Rr(Lr.value[0].key))
            }, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    (openBlock(), createBlock(resolveDynamicComponent(Lr.value[0].icon)))
                  ]),
                  _: 1
                })
              ]),
              default: withCtx(() => [
                createTextVNode(" " + toDisplayString(Lr.value[0].label), 1)
              ]),
              _: 1
            })) : (openBlock(), createBlock(BxButton, { key: 1 }, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(EllipsisVerticalOutline))
                  ]),
                  _: 1
                })
              ]),
              default: withCtx(() => [
                createTextVNode(" " + toDisplayString(si.actionsLabel), 1)
              ]),
              _: 1
            }))
          ]),
          _: 1
        }, 40, ["options", "mobile-layout", "show"])) : createCommentVNode("", !0),
        $e.allowCropImage ? (openBlock(), createBlock(_sfc_main$18, {
          key: 1,
          show: Ze.value,
          "onUpdate:show": li[8] || (li[8] = (xi) => Ze.value = xi),
          type: "layer",
          transculent: "",
          "full-layer": "",
          "custom-classes": ["image-adjust-popup"],
          "wrapper-custom-classes": ["image-adjust-popup-wrapper"],
          "disable-background-effect": ""
        }, {
          trigger: withCtx(() => [
            createVNode(BxButton, null, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(CropOutline))
                  ]),
                  _: 1
                })
              ]),
              default: withCtx(() => [
                li[9] || (li[9] = createTextVNode(" Crop "))
              ]),
              _: 1
            })
          ]),
          "close-btn": withCtx(() => [
            createVNode(BxButton, {
              class: "btn-done",
              primary: "",
              round: "",
              onClick: li[6] || (li[6] = (xi) => Ze.value = !1)
            }, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(CheckmarkOutline))
                  ]),
                  _: 1
                })
              ]),
              default: withCtx(() => [
                li[10] || (li[10] = createTextVNode(" Done "))
              ]),
              _: 1
            })
          ]),
          content: withCtx(() => [
            Vr.value ? (openBlock(), createBlock(AdjustImage, {
              key: 0,
              src: ie.value,
              adjust: we.value,
              "onUpdate:adjust": li[7] || (li[7] = (xi) => we.value = xi),
              width: Vr.value.width,
              height: Vr.value.height,
              ratio: si.aspectRatio
            }, null, 8, ["src", "adjust", "width", "height", "ratio"])) : createCommentVNode("", !0)
          ]),
          _: 1
        }, 8, ["show"])) : createCommentVNode("", !0)
      ])
    ], 2));
  }
}), ImageEdit_vue_vue_type_style_index_0_scoped_59560f7f_lang = "", ImageEdit_vue_vue_type_style_index_1_lang = "", ImageEdit = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["__scopeId", "data-v-59560f7f"]]), _hoisted_1$z = ["src"], _hoisted_2$o = {
  key: 0,
  class: "actions"
}, maxActions = 2, _sfc_main$K = /* @__PURE__ */ defineComponent({
  __name: "Image",
  props: /* @__PURE__ */ mergeModels({
    layout: {},
    allowUploadFromDevice: { type: Boolean },
    width: {},
    height: {},
    allowedTypes: {},
    convertTo: {},
    quality: {},
    imageLibraries: {},
    removeBackground: { type: Boolean },
    uploadLabel: { default: "Select image" },
    actionsLabel: { default: "More" },
    maxSize: { default: 1 / 0 },
    bridge: {},
    mobile: { type: Boolean, default: !1 },
    field: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue"), ie = m, we = ref$1(!1), { uploadFiles: $e, uploadProgresses: Me, uploading: Ze } = useUpload(
      toRef(ie, "width"),
      toRef(ie, "height"),
      toRef(ie, "convertTo"),
      toRef(ie, "quality"),
      ie.bridge.handleUpload,
      toRef(ie, "field")
    );
    async function ne() {
      const Ar = await openFiles({
        types: ie.allowedTypes,
        maxSize: ie.maxSize,
        multiple: !0
      }), Rr = createPopup({
        title: "Uploading images",
        content: () => [
          h$1(BxProgress, { value: Me.value.reduce((Vr, Xr) => Vr + Xr, 0) / Me.value.length })
        ],
        closeable: !1,
        icon: () => h$1(CloudUploadOutline),
        disableBackgroundEffect: !0
      }), Nr = await $e(Ar);
      Rr.close();
      const Yr = Nr[0];
      Yr && Lr(Yr.src);
    }
    const rr = computed(() => [
      ...ie.allowUploadFromDevice ? [
        {
          label: ie.uploadLabel,
          action: ne,
          icon: () => h$1(ImageOutline),
          key: "upload"
        }
      ] : [],
      ...ie.imageLibraries.map((Rr) => ({
        label: Rr.label,
        icon: () => {
          if (Rr.type === "sharedDrive")
            switch (Rr.service) {
              case "googledrive":
                return h$1("img", {
                  src: "https://upload.wikimedia.org/wikipedia/commons/1/12/Google_Drive_icon_%282020%29.svg"
                });
              case "onedrive":
                return h$1("img", {
                  src: "https://upload.wikimedia.org/wikipedia/commons/3/3c/Microsoft_Office_OneDrive_%282019\u2013present%29.svg"
                });
              default:
                return h$1(ImageOutline);
            }
          else
            return Rr.type === "pexels" ? h$1("img", { src: "https://www.drupal.org/files/project-images/pexels_logo_0.png" }) : h$1(ImageOutline);
        },
        key: (() => Rr.type === "sharedDrive" ? Rr.service : Rr.type === "custom" ? "custom" : Rr.type)(),
        lib: Rr
      }))
    ]), gr = ref$1(), or = computed(() => rr.value.slice(maxActions - 1).map((Ar) => ({
      label: Ar.label,
      value: Ar.key,
      icon: Ar.icon
    })));
    function _r(Ar) {
      Ar === "upload" ? ne() : (gr.value = Ar, we.value = !0);
    }
    function Lr(Ar) {
      c.value = Ar, we.value = !1;
    }
    function Ir(Ar) {
      ie.imageLibraries.length === 0 && ie.allowUploadFromDevice && (ne(), Ar.stopImmediatePropagation(), Ar.stopPropagation(), nextTick$3(() => {
        we.value = !1;
      }));
    }
    return (Ar, Rr) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["image-field", { ["layout-" + Ar.layout]: !0 }])
    }, [
      createVNode(_sfc_main$18, {
        show: we.value,
        "onUpdate:show": Rr[2] || (Rr[2] = (Nr) => we.value = Nr),
        type: "layer",
        trigger: "click",
        fullscreen: ""
      }, {
        title: withCtx(() => [
          gr.value ? (openBlock(), createBlock(BxButton, {
            key: 0,
            circle: "",
            tertiary: "",
            onClick: Rr[0] || (Rr[0] = (Nr) => gr.value = void 0)
          }, {
            icon: withCtx(() => [
              createVNode(BxIcon, { size: "small" }, {
                default: withCtx(() => [
                  createVNode(unref(ArrowBackOutline))
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : createCommentVNode("", !0),
          Rr[3] || (Rr[3] = createElementVNode("h3", null, "Select image", -1))
        ]),
        trigger: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(["image-preview", { "single-button-height": rr.value.length <= 1 }]),
            onClick: Ir
          }, [
            createElementVNode("img", { src: c.value }, null, 8, _hoisted_1$z)
          ], 2)
        ]),
        content: withCtx(() => [
          createVNode(ImageLibraryWrapper, {
            "active-key": gr.value,
            "onUpdate:activeKey": Rr[1] || (Rr[1] = (Nr) => gr.value = Nr),
            options: rr.value,
            "image-libraries": Ar.imageLibraries,
            width: Ar.width,
            height: Ar.height,
            quality: Ar.quality,
            "convert-to": Ar.convertTo,
            bridge: Ar.bridge,
            field: Ar.field,
            onSelect: Lr
          }, null, 8, ["active-key", "options", "image-libraries", "width", "height", "quality", "convert-to", "bridge", "field"])
        ]),
        _: 1
      }, 8, ["show"]),
      Ar.layout !== "compact" ? (openBlock(), createElementBlock("div", _hoisted_2$o, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(rr.value.slice(0, rr.value.length > maxActions ? maxActions - 1 : maxActions), (Nr) => (openBlock(), createElementBlock(Fragment, null, [
          createVNode(BxButton, {
            onClick: (Yr) => _r(Nr.key)
          }, {
            icon: withCtx(() => [
              createVNode(BxIcon, null, {
                default: withCtx(() => [
                  (openBlock(), createBlock(resolveDynamicComponent(Nr.icon)))
                ]),
                _: 2
              }, 1024)
            ]),
            default: withCtx(() => [
              createTextVNode(" " + toDisplayString(Nr.label), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]),
          createVNode(BxDropdown, {
            trigger: "click",
            options: or.value,
            onSelect: _r,
            "mobile-layout": Ar.mobile
          }, {
            trigger: withCtx(() => [
              rr.value.length > maxActions ? (openBlock(), createBlock(BxButton, { key: 0 }, {
                icon: withCtx(() => [
                  createVNode(BxIcon, { size: "small" }, {
                    default: withCtx(() => [
                      createVNode(unref(EllipsisVerticalOutline))
                    ]),
                    _: 1
                  })
                ]),
                default: withCtx(() => [
                  createTextVNode(" " + toDisplayString(Ar.actionsLabel), 1)
                ]),
                _: 1
              })) : createCommentVNode("", !0)
            ]),
            _: 1
          }, 8, ["options", "mobile-layout"])
        ], 64))), 256))
      ])) : createCommentVNode("", !0)
    ], 2));
  }
}), Image_vue_vue_type_style_index_0_scoped_2b55ce8f_lang = "", Image$1 = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["__scopeId", "data-v-2b55ce8f"]]), _hoisted_1$y = {
  key: 0,
  class: "title-wrapper"
}, _hoisted_2$n = {
  key: 0,
  class: "root-index"
}, _hoisted_3$e = {
  key: 1,
  class: "title"
}, _sfc_main$J = /* @__PURE__ */ defineComponent({
  __name: "Group",
  props: {
    layout: {},
    isRoot: { type: Boolean, default: !1 },
    index: { default: 0 },
    fields: {},
    card: { type: Boolean },
    description: {},
    detailedDescription: {},
    bridge: {}
  },
  setup(m) {
    return (c, ie) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["group-field", {}])
    }, [
      createVNode(BxCard, {
        transculent: !c.card,
        class: normalizeClass({ "no-card": c.card === !1 }),
        dividers: !1
      }, {
        default: withCtx(() => [
          c.description || c.detailedDescription ? (openBlock(), createElementBlock("div", _hoisted_1$y, [
            c.isRoot ? (openBlock(), createElementBlock("div", _hoisted_2$n, toDisplayString(c.index), 1)) : createCommentVNode("", !0),
            c.description ? (openBlock(), createElementBlock("h4", _hoisted_3$e, toDisplayString(c.description), 1)) : createCommentVNode("", !0),
            c.detailedDescription ? (openBlock(), createBlock(BxTooltip, {
              key: 2,
              trigger: "hover"
            }, {
              trigger: withCtx(() => [
                createVNode(BxIcon, {
                  size: 16,
                  style: { cursor: "pointer", "border-radius": "50%", padding: "4px", "background-color": "rgba(var(--primary-color-light), 1)" }
                }, {
                  default: withCtx(() => [
                    createVNode(unref(HelpOutline))
                  ]),
                  _: 1
                })
              ]),
              content: withCtx(() => [
                createTextVNode(toDisplayString(c.detailedDescription), 1)
              ]),
              _: 1
            })) : createCommentVNode("", !0)
          ])) : createCommentVNode("", !0),
          createVNode(FieldsList, {
            fields: c.fields,
            bridge: c.bridge,
            layout: c.layout,
            "is-root": !1
          }, null, 8, ["fields", "bridge", "layout"])
        ]),
        _: 1
      }, 8, ["transculent", "class"])
    ]));
  }
}), Group_vue_vue_type_style_index_0_scoped_0f7ba23c_lang = "", Group = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["__scopeId", "data-v-0f7ba23c"]]), _hoisted_1$x = { class: "text-field" }, _sfc_main$I = /* @__PURE__ */ defineComponent({
  __name: "Text",
  props: /* @__PURE__ */ mergeModels({
    maxLength: {},
    maxLines: {},
    maxLineLength: {},
    showWordCount: { type: Boolean },
    clearable: { type: Boolean },
    multiline: { type: Boolean },
    uppercase: { type: Boolean },
    placeholder: {},
    richtext: {},
    bridge: {},
    maxHeight: {},
    minWidth: {},
    maxWidth: {}
  }, {
    modelValue: { type: [String, Number, Boolean, Array], required: !1, default: "Hello world" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue");
    return (ie, we) => (openBlock(), createElementBlock("div", _hoisted_1$x, [
      createVNode(BxInput, {
        type: ie.multiline ? "textarea" : "text",
        modelValue: c.value,
        "onUpdate:modelValue": we[0] || (we[0] = ($e) => c.value = $e),
        "show-word-count": ie.showWordCount,
        clearable: ie.clearable,
        "max-length": ie.maxLength,
        "max-line-length": ie.maxLineLength,
        "max-lines": ie.maxLines,
        placeholder: ie.placeholder,
        resizeable: !1,
        richtext: ie.richtext.enabled ? ie.richtext : void 0,
        "max-height": ie.maxHeight ?? void 0
      }, null, 8, ["type", "modelValue", "show-word-count", "clearable", "max-length", "max-line-length", "max-lines", "placeholder", "richtext", "max-height"])
    ]));
  }
}), Text_vue_vue_type_style_index_0_scoped_651f35bc_lang = "", Text = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["__scopeId", "data-v-651f35bc"]]), _hoisted_1$w = { class: "field-image-adjust" }, _sfc_main$H = /* @__PURE__ */ defineComponent({
  __name: "ImageAdjust",
  props: /* @__PURE__ */ mergeModels({
    minX: {},
    maxX: {},
    minY: {},
    maxY: {},
    minScale: {},
    maxScale: {},
    type: {},
    aspectRatio: {},
    bridge: {}
  }, {
    image: {
      required: !0
    },
    imageModifiers: {},
    adjust: {
      required: !0
    },
    adjustModifiers: {}
  }),
  emits: ["update:image", "update:adjust"],
  setup(m) {
    const c = useModel(m, "image"), ie = useModel(m, "adjust"), we = ref$1();
    watchEffect(async () => {
      c.value && (we.value = await imageInfo(c.value));
    });
    const $e = ref$1(!1);
    return (Me, Ze) => (openBlock(), createElementBlock("div", _hoisted_1$w, [
      createVNode(_sfc_main$18, {
        show: $e.value,
        "onUpdate:show": Ze[2] || (Ze[2] = (ne) => $e.value = ne),
        type: "layer",
        transculent: "",
        "full-layer": "",
        "custom-classes": ["image-adjust-popup"],
        "wrapper-custom-classes": ["image-adjust-popup-wrapper"],
        "disable-background-effect": ""
      }, {
        trigger: withCtx(() => [
          createVNode(BxButton, null, {
            icon: withCtx(() => [
              createVNode(BxIcon, null, {
                default: withCtx(() => [
                  createVNode(unref(CropOutline))
                ]),
                _: 1
              })
            ]),
            default: withCtx(() => [
              Ze[3] || (Ze[3] = createTextVNode(" Crop "))
            ]),
            _: 1
          })
        ]),
        "close-btn": withCtx(() => [
          createVNode(BxButton, {
            class: "btn-done",
            primary: "",
            round: "",
            onClick: Ze[0] || (Ze[0] = (ne) => $e.value = !1)
          }, {
            icon: withCtx(() => [
              createVNode(BxIcon, null, {
                default: withCtx(() => [
                  createVNode(unref(CheckmarkOutline))
                ]),
                _: 1
              })
            ]),
            default: withCtx(() => [
              Ze[4] || (Ze[4] = createTextVNode(" Done "))
            ]),
            _: 1
          })
        ]),
        content: withCtx(() => [
          we.value ? (openBlock(), createBlock(AdjustImage, {
            key: 0,
            src: c.value,
            adjust: ie.value,
            "onUpdate:adjust": Ze[1] || (Ze[1] = (ne) => ie.value = ne),
            width: we.value.width,
            height: we.value.height,
            ratio: Me.aspectRatio,
            "min-scale": Me.minScale,
            "max-scale": Me.maxScale,
            inline: Me.type === "inline"
          }, null, 8, ["src", "adjust", "width", "height", "ratio", "min-scale", "max-scale", "inline"])) : createCommentVNode("", !0)
        ]),
        _: 1
      }, 8, ["show"])
    ]));
  }
}), ImageAdjust_vue_vue_type_style_index_0_scoped_a309fa2e_lang = "", ImageAdjust_vue_vue_type_style_index_1_lang = "", ImageAdjust = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["__scopeId", "data-v-a309fa2e"]]), _hoisted_1$v = ["onClick"], _hoisted_2$m = { class: "image-card" }, _hoisted_3$d = { class: "label-image-proxy" }, _hoisted_4$7 = ["src"], _hoisted_5$5 = {
  key: 0,
  class: "label"
}, _sfc_main$G = /* @__PURE__ */ defineComponent({
  __name: "Select",
  props: /* @__PURE__ */ mergeModels({
    options: {},
    layout: {},
    cardSize: {},
    showLabels: { type: Boolean }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = m, ie = useModel(m, "modelValue"), we = computed(() => c.layout === "grid" || c.layout === "cards");
    function $e(Ze) {
      ie.value = Ze.value;
    }
    const Me = computed(
      () => c.options.map((Ze) => ({
        label: Ze.label,
        value: Ze.value,
        icon: Ze.image ? () => h$1(BxIcon, {}, () => h$1("img", { src: Ze.image, style: { "object-fit": "cover", width: "24px", height: "24px" } })) : void 0
      }))
    );
    return (Ze, ne) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["select-field", { "grid-layout": we.value, "horizontal-scroll": Ze.layout === "cards" }])
    }, [
      we.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["select-grid", { ["size-" + Ze.cardSize]: !0, "horizontal-scroll": Ze.layout === "cards" }])
      }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(Ze.options, (rr) => (openBlock(), createElementBlock("div", {
          class: normalizeClass(["option-item", { active: rr.value === ie.value }]),
          onClick: (gr) => $e(rr)
        }, [
          createElementVNode("div", _hoisted_2$m, [
            createElementVNode("div", _hoisted_3$d, [
              createElementVNode("span", null, toDisplayString(rr.label), 1)
            ]),
            rr.image ? (openBlock(), createElementBlock("img", {
              key: 0,
              src: rr.image
            }, null, 8, _hoisted_4$7)) : createCommentVNode("", !0)
          ]),
          Ze.showLabels ? (openBlock(), createElementBlock("div", _hoisted_5$5, toDisplayString(rr.label), 1)) : createCommentVNode("", !0)
        ], 10, _hoisted_1$v))), 256))
      ], 2)) : (openBlock(), createBlock(BxSelect, {
        key: 1,
        modelValue: ie.value,
        "onUpdate:modelValue": ne[0] || (ne[0] = (rr) => ie.value = rr),
        options: Me.value
      }, null, 8, ["modelValue", "options"]))
    ], 2));
  }
}), Select_vue_vue_type_style_index_0_scoped_1154c121_lang = "", Select = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["__scopeId", "data-v-1154c121"]]), _sfc_main$F = /* @__PURE__ */ defineComponent({
  __name: "BxCheckbox",
  props: /* @__PURE__ */ mergeModels({
    label: {},
    size: { default: "medium" },
    disabled: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean, required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = m, ie = useModel(m, "modelValue"), we = () => {
      c.disabled || (ie.value = !ie.value);
    };
    return ($e, Me) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-checkbox", { checked: ie.value, disabled: $e.disabled }]),
      onClick: we
    }, Me[0] || (Me[0] = [
      createElementVNode("div", { class: "checkbox-box" }, [
        createElementVNode("div", { class: "checkbox-symbol" }, [
          createElementVNode("svg", {
            viewBox: "0 0 64 64",
            class: "check-icon"
          }, [
            createElementVNode("path", { d: "M50.42,16.76L22.34,39.45l-8.1-11.46c-1.12-1.58-3.3-1.96-4.88-0.84c-1.58,1.12-1.95,3.3-0.84,4.88l10.26,14.51  c0.56,0.79,1.42,1.31,2.38,1.45c0.16,0.02,0.32,0.03,0.48,0.03c0.8,0,1.57-0.27,2.2-0.78l30.99-25.03c1.5-1.21,1.74-3.42,0.52-4.92  C54.13,15.78,51.93,15.55,50.42,16.76z" })
          ])
        ])
      ], -1)
    ]), 2));
  }
}), BxCheckbox_vue_vue_type_style_index_0_scoped_d2bb9ea5_lang = "", BxCheckbox = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["__scopeId", "data-v-d2bb9ea5"]]), _hoisted_1$u = {
  key: 0,
  class: "checkbox-label"
}, _hoisted_2$l = { class: "label" }, _sfc_main$E = /* @__PURE__ */ defineComponent({
  __name: "Checkbox",
  props: /* @__PURE__ */ mergeModels({
    description: {},
    detailedDescription: {},
    label: {},
    mobile: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean, required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue");
    return (ie, we) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["checkbox-field", { mobile: ie.mobile }])
    }, [
      createVNode(BxCheckbox, {
        modelValue: c.value,
        "onUpdate:modelValue": we[0] || (we[0] = ($e) => c.value = $e),
        size: "medium"
      }, null, 8, ["modelValue"]),
      ie.label ? (openBlock(), createElementBlock("div", _hoisted_1$u, [
        createElementVNode("div", _hoisted_2$l, [
          createElementVNode("span", null, toDisplayString(ie.label), 1)
        ])
      ])) : createCommentVNode("", !0)
    ], 2));
  }
}), Checkbox_vue_vue_type_style_index_0_scoped_03947a47_lang = "", Checkbox = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["__scopeId", "data-v-03947a47"]]), _sfc_main$D = /* @__PURE__ */ defineComponent({
  __name: "CollectionEntryFields",
  props: {
    bridge: {},
    fields: {},
    layout: {},
    data: {}
  },
  emits: ["update:data"],
  setup(m, { emit: c }) {
    const ie = m, we = c, $e = ref$1(ie.data);
    return provide("data", $e), watch(
      $e,
      () => {
        we("update:data", $e.value);
      },
      { deep: !0 }
    ), (Me, Ze) => (openBlock(), createBlock(Group, {
      bridge: Me.bridge,
      fields: Me.fields,
      card: !1,
      layout: Me.layout
    }, null, 8, ["bridge", "fields", "layout"]));
  }
});
/**!
 * Sortable 1.15.6
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function ownKeys(m, c) {
  var ie = Object.keys(m);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(m);
    c && (we = we.filter(function($e) {
      return Object.getOwnPropertyDescriptor(m, $e).enumerable;
    })), ie.push.apply(ie, we);
  }
  return ie;
}
function _objectSpread2(m) {
  for (var c = 1; c < arguments.length; c++) {
    var ie = arguments[c] != null ? arguments[c] : {};
    c % 2 ? ownKeys(Object(ie), !0).forEach(function(we) {
      _defineProperty(m, we, ie[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(m, Object.getOwnPropertyDescriptors(ie)) : ownKeys(Object(ie)).forEach(function(we) {
      Object.defineProperty(m, we, Object.getOwnPropertyDescriptor(ie, we));
    });
  }
  return m;
}
function _typeof(m) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(c) {
    return typeof c;
  } : _typeof = function(c) {
    return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
  }, _typeof(m);
}
function _defineProperty(m, c, ie) {
  return c in m ? Object.defineProperty(m, c, {
    value: ie,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : m[c] = ie, m;
}
function _extends() {
  return _extends = Object.assign || function(m) {
    for (var c = 1; c < arguments.length; c++) {
      var ie = arguments[c];
      for (var we in ie)
        Object.prototype.hasOwnProperty.call(ie, we) && (m[we] = ie[we]);
    }
    return m;
  }, _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(m, c) {
  if (m == null)
    return {};
  var ie = {}, we = Object.keys(m), $e, Me;
  for (Me = 0; Me < we.length; Me++)
    $e = we[Me], !(c.indexOf($e) >= 0) && (ie[$e] = m[$e]);
  return ie;
}
function _objectWithoutProperties(m, c) {
  if (m == null)
    return {};
  var ie = _objectWithoutPropertiesLoose(m, c), we, $e;
  if (Object.getOwnPropertySymbols) {
    var Me = Object.getOwnPropertySymbols(m);
    for ($e = 0; $e < Me.length; $e++)
      we = Me[$e], !(c.indexOf(we) >= 0) && (!Object.prototype.propertyIsEnumerable.call(m, we) || (ie[we] = m[we]));
  }
  return ie;
}
function _toConsumableArray(m) {
  return _arrayWithoutHoles(m) || _iterableToArray(m) || _unsupportedIterableToArray(m) || _nonIterableSpread();
}
function _arrayWithoutHoles(m) {
  if (Array.isArray(m))
    return _arrayLikeToArray(m);
}
function _iterableToArray(m) {
  if (typeof Symbol < "u" && m[Symbol.iterator] != null || m["@@iterator"] != null)
    return Array.from(m);
}
function _unsupportedIterableToArray(m, c) {
  if (!!m) {
    if (typeof m == "string")
      return _arrayLikeToArray(m, c);
    var ie = Object.prototype.toString.call(m).slice(8, -1);
    if (ie === "Object" && m.constructor && (ie = m.constructor.name), ie === "Map" || ie === "Set")
      return Array.from(m);
    if (ie === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ie))
      return _arrayLikeToArray(m, c);
  }
}
function _arrayLikeToArray(m, c) {
  (c == null || c > m.length) && (c = m.length);
  for (var ie = 0, we = new Array(c); ie < c; ie++)
    we[ie] = m[ie];
  return we;
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var version = "1.15.6";
function userAgent(m) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(m);
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), Edge = userAgent(/Edge/i), FireFox = userAgent(/firefox/i), Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i), IOS = userAgent(/iP(ad|od|hone)/i), ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i), captureMode = {
  capture: !1,
  passive: !1
};
function on(m, c, ie) {
  m.addEventListener(c, ie, !IE11OrLess && captureMode);
}
function off(m, c, ie) {
  m.removeEventListener(c, ie, !IE11OrLess && captureMode);
}
function matches(m, c) {
  if (!!c) {
    if (c[0] === ">" && (c = c.substring(1)), m)
      try {
        if (m.matches)
          return m.matches(c);
        if (m.msMatchesSelector)
          return m.msMatchesSelector(c);
        if (m.webkitMatchesSelector)
          return m.webkitMatchesSelector(c);
      } catch {
        return !1;
      }
    return !1;
  }
}
function getParentOrHost(m) {
  return m.host && m !== document && m.host.nodeType ? m.host : m.parentNode;
}
function closest(m, c, ie, we) {
  if (m) {
    ie = ie || document;
    do {
      if (c != null && (c[0] === ">" ? m.parentNode === ie && matches(m, c) : matches(m, c)) || we && m === ie)
        return m;
      if (m === ie)
        break;
    } while (m = getParentOrHost(m));
  }
  return null;
}
var R_SPACE = /\s+/g;
function toggleClass(m, c, ie) {
  if (m && c)
    if (m.classList)
      m.classList[ie ? "add" : "remove"](c);
    else {
      var we = (" " + m.className + " ").replace(R_SPACE, " ").replace(" " + c + " ", " ");
      m.className = (we + (ie ? " " + c : "")).replace(R_SPACE, " ");
    }
}
function css$1(m, c, ie) {
  var we = m && m.style;
  if (we) {
    if (ie === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? ie = document.defaultView.getComputedStyle(m, "") : m.currentStyle && (ie = m.currentStyle), c === void 0 ? ie : ie[c];
    !(c in we) && c.indexOf("webkit") === -1 && (c = "-webkit-" + c), we[c] = ie + (typeof ie == "string" ? "" : "px");
  }
}
function matrix(m, c) {
  var ie = "";
  if (typeof m == "string")
    ie = m;
  else
    do {
      var we = css$1(m, "transform");
      we && we !== "none" && (ie = we + " " + ie);
    } while (!c && (m = m.parentNode));
  var $e = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return $e && new $e(ie);
}
function find(m, c, ie) {
  if (m) {
    var we = m.getElementsByTagName(c), $e = 0, Me = we.length;
    if (ie)
      for (; $e < Me; $e++)
        ie(we[$e], $e);
    return we;
  }
  return [];
}
function getWindowScrollingElement() {
  var m = document.scrollingElement;
  return m || document.documentElement;
}
function getRect(m, c, ie, we, $e) {
  if (!(!m.getBoundingClientRect && m !== window)) {
    var Me, Ze, ne, rr, gr, or, _r;
    if (m !== window && m.parentNode && m !== getWindowScrollingElement() ? (Me = m.getBoundingClientRect(), Ze = Me.top, ne = Me.left, rr = Me.bottom, gr = Me.right, or = Me.height, _r = Me.width) : (Ze = 0, ne = 0, rr = window.innerHeight, gr = window.innerWidth, or = window.innerHeight, _r = window.innerWidth), (c || ie) && m !== window && ($e = $e || m.parentNode, !IE11OrLess))
      do
        if ($e && $e.getBoundingClientRect && (css$1($e, "transform") !== "none" || ie && css$1($e, "position") !== "static")) {
          var Lr = $e.getBoundingClientRect();
          Ze -= Lr.top + parseInt(css$1($e, "border-top-width")), ne -= Lr.left + parseInt(css$1($e, "border-left-width")), rr = Ze + Me.height, gr = ne + Me.width;
          break;
        }
      while ($e = $e.parentNode);
    if (we && m !== window) {
      var Ir = matrix($e || m), Ar = Ir && Ir.a, Rr = Ir && Ir.d;
      Ir && (Ze /= Rr, ne /= Ar, _r /= Ar, or /= Rr, rr = Ze + or, gr = ne + _r);
    }
    return {
      top: Ze,
      left: ne,
      bottom: rr,
      right: gr,
      width: _r,
      height: or
    };
  }
}
function isScrolledPast(m, c, ie) {
  for (var we = getParentAutoScrollElement(m, !0), $e = getRect(m)[c]; we; ) {
    var Me = getRect(we)[ie], Ze = void 0;
    if (ie === "top" || ie === "left" ? Ze = $e >= Me : Ze = $e <= Me, !Ze)
      return we;
    if (we === getWindowScrollingElement())
      break;
    we = getParentAutoScrollElement(we, !1);
  }
  return !1;
}
function getChild(m, c, ie, we) {
  for (var $e = 0, Me = 0, Ze = m.children; Me < Ze.length; ) {
    if (Ze[Me].style.display !== "none" && Ze[Me] !== Sortable.ghost && (we || Ze[Me] !== Sortable.dragged) && closest(Ze[Me], ie.draggable, m, !1)) {
      if ($e === c)
        return Ze[Me];
      $e++;
    }
    Me++;
  }
  return null;
}
function lastChild(m, c) {
  for (var ie = m.lastElementChild; ie && (ie === Sortable.ghost || css$1(ie, "display") === "none" || c && !matches(ie, c)); )
    ie = ie.previousElementSibling;
  return ie || null;
}
function index(m, c) {
  var ie = 0;
  if (!m || !m.parentNode)
    return -1;
  for (; m = m.previousElementSibling; )
    m.nodeName.toUpperCase() !== "TEMPLATE" && m !== Sortable.clone && (!c || matches(m, c)) && ie++;
  return ie;
}
function getRelativeScrollOffset(m) {
  var c = 0, ie = 0, we = getWindowScrollingElement();
  if (m)
    do {
      var $e = matrix(m), Me = $e.a, Ze = $e.d;
      c += m.scrollLeft * Me, ie += m.scrollTop * Ze;
    } while (m !== we && (m = m.parentNode));
  return [c, ie];
}
function indexOfObject(m, c) {
  for (var ie in m)
    if (!!m.hasOwnProperty(ie)) {
      for (var we in c)
        if (c.hasOwnProperty(we) && c[we] === m[ie][we])
          return Number(ie);
    }
  return -1;
}
function getParentAutoScrollElement(m, c) {
  if (!m || !m.getBoundingClientRect)
    return getWindowScrollingElement();
  var ie = m, we = !1;
  do
    if (ie.clientWidth < ie.scrollWidth || ie.clientHeight < ie.scrollHeight) {
      var $e = css$1(ie);
      if (ie.clientWidth < ie.scrollWidth && ($e.overflowX == "auto" || $e.overflowX == "scroll") || ie.clientHeight < ie.scrollHeight && ($e.overflowY == "auto" || $e.overflowY == "scroll")) {
        if (!ie.getBoundingClientRect || ie === document.body)
          return getWindowScrollingElement();
        if (we || c)
          return ie;
        we = !0;
      }
    }
  while (ie = ie.parentNode);
  return getWindowScrollingElement();
}
function extend$3(m, c) {
  if (m && c)
    for (var ie in c)
      c.hasOwnProperty(ie) && (m[ie] = c[ie]);
  return m;
}
function isRectEqual(m, c) {
  return Math.round(m.top) === Math.round(c.top) && Math.round(m.left) === Math.round(c.left) && Math.round(m.height) === Math.round(c.height) && Math.round(m.width) === Math.round(c.width);
}
var _throttleTimeout;
function throttle(m, c) {
  return function() {
    if (!_throttleTimeout) {
      var ie = arguments, we = this;
      ie.length === 1 ? m.call(we, ie[0]) : m.apply(we, ie), _throttleTimeout = setTimeout(function() {
        _throttleTimeout = void 0;
      }, c);
    }
  };
}
function cancelThrottle() {
  clearTimeout(_throttleTimeout), _throttleTimeout = void 0;
}
function scrollBy(m, c, ie) {
  m.scrollLeft += c, m.scrollTop += ie;
}
function clone(m) {
  var c = window.Polymer, ie = window.jQuery || window.Zepto;
  return c && c.dom ? c.dom(m).cloneNode(!0) : ie ? ie(m).clone(!0)[0] : m.cloneNode(!0);
}
function setRect(m, c) {
  css$1(m, "position", "absolute"), css$1(m, "top", c.top), css$1(m, "left", c.left), css$1(m, "width", c.width), css$1(m, "height", c.height);
}
function unsetRect(m) {
  css$1(m, "position", ""), css$1(m, "top", ""), css$1(m, "left", ""), css$1(m, "width", ""), css$1(m, "height", "");
}
function getChildContainingRectFromElement(m, c, ie) {
  var we = {};
  return Array.from(m.children).forEach(function($e) {
    var Me, Ze, ne, rr;
    if (!(!closest($e, c.draggable, m, !1) || $e.animated || $e === ie)) {
      var gr = getRect($e);
      we.left = Math.min((Me = we.left) !== null && Me !== void 0 ? Me : 1 / 0, gr.left), we.top = Math.min((Ze = we.top) !== null && Ze !== void 0 ? Ze : 1 / 0, gr.top), we.right = Math.max((ne = we.right) !== null && ne !== void 0 ? ne : -1 / 0, gr.right), we.bottom = Math.max((rr = we.bottom) !== null && rr !== void 0 ? rr : -1 / 0, gr.bottom);
    }
  }), we.width = we.right - we.left, we.height = we.bottom - we.top, we.x = we.left, we.y = we.top, we;
}
var expando = "Sortable" + new Date().getTime();
function AnimationStateManager() {
  var m = [], c;
  return {
    captureAnimationState: function() {
      if (m = [], !!this.options.animation) {
        var we = [].slice.call(this.el.children);
        we.forEach(function($e) {
          if (!(css$1($e, "display") === "none" || $e === Sortable.ghost)) {
            m.push({
              target: $e,
              rect: getRect($e)
            });
            var Me = _objectSpread2({}, m[m.length - 1].rect);
            if ($e.thisAnimationDuration) {
              var Ze = matrix($e, !0);
              Ze && (Me.top -= Ze.f, Me.left -= Ze.e);
            }
            $e.fromRect = Me;
          }
        });
      }
    },
    addAnimationState: function(we) {
      m.push(we);
    },
    removeAnimationState: function(we) {
      m.splice(indexOfObject(m, {
        target: we
      }), 1);
    },
    animateAll: function(we) {
      var $e = this;
      if (!this.options.animation) {
        clearTimeout(c), typeof we == "function" && we();
        return;
      }
      var Me = !1, Ze = 0;
      m.forEach(function(ne) {
        var rr = 0, gr = ne.target, or = gr.fromRect, _r = getRect(gr), Lr = gr.prevFromRect, Ir = gr.prevToRect, Ar = ne.rect, Rr = matrix(gr, !0);
        Rr && (_r.top -= Rr.f, _r.left -= Rr.e), gr.toRect = _r, gr.thisAnimationDuration && isRectEqual(Lr, _r) && !isRectEqual(or, _r) && (Ar.top - _r.top) / (Ar.left - _r.left) === (or.top - _r.top) / (or.left - _r.left) && (rr = calculateRealTime(Ar, Lr, Ir, $e.options)), isRectEqual(_r, or) || (gr.prevFromRect = or, gr.prevToRect = _r, rr || (rr = $e.options.animation), $e.animate(gr, Ar, _r, rr)), rr && (Me = !0, Ze = Math.max(Ze, rr), clearTimeout(gr.animationResetTimer), gr.animationResetTimer = setTimeout(function() {
          gr.animationTime = 0, gr.prevFromRect = null, gr.fromRect = null, gr.prevToRect = null, gr.thisAnimationDuration = null;
        }, rr), gr.thisAnimationDuration = rr);
      }), clearTimeout(c), Me ? c = setTimeout(function() {
        typeof we == "function" && we();
      }, Ze) : typeof we == "function" && we(), m = [];
    },
    animate: function(we, $e, Me, Ze) {
      if (Ze) {
        css$1(we, "transition", ""), css$1(we, "transform", "");
        var ne = matrix(this.el), rr = ne && ne.a, gr = ne && ne.d, or = ($e.left - Me.left) / (rr || 1), _r = ($e.top - Me.top) / (gr || 1);
        we.animatingX = !!or, we.animatingY = !!_r, css$1(we, "transform", "translate3d(" + or + "px," + _r + "px,0)"), this.forRepaintDummy = repaint(we), css$1(we, "transition", "transform " + Ze + "ms" + (this.options.easing ? " " + this.options.easing : "")), css$1(we, "transform", "translate3d(0,0,0)"), typeof we.animated == "number" && clearTimeout(we.animated), we.animated = setTimeout(function() {
          css$1(we, "transition", ""), css$1(we, "transform", ""), we.animated = !1, we.animatingX = !1, we.animatingY = !1;
        }, Ze);
      }
    }
  };
}
function repaint(m) {
  return m.offsetWidth;
}
function calculateRealTime(m, c, ie, we) {
  return Math.sqrt(Math.pow(c.top - m.top, 2) + Math.pow(c.left - m.left, 2)) / Math.sqrt(Math.pow(c.top - ie.top, 2) + Math.pow(c.left - ie.left, 2)) * we.animation;
}
var plugins = [], defaults$3 = {
  initializeByDefault: !0
}, PluginManager = {
  mount: function m(c) {
    for (var ie in defaults$3)
      defaults$3.hasOwnProperty(ie) && !(ie in c) && (c[ie] = defaults$3[ie]);
    plugins.forEach(function(we) {
      if (we.pluginName === c.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(c.pluginName, " more than once");
    }), plugins.push(c);
  },
  pluginEvent: function m(c, ie, we) {
    var $e = this;
    this.eventCanceled = !1, we.cancel = function() {
      $e.eventCanceled = !0;
    };
    var Me = c + "Global";
    plugins.forEach(function(Ze) {
      !ie[Ze.pluginName] || (ie[Ze.pluginName][Me] && ie[Ze.pluginName][Me](_objectSpread2({
        sortable: ie
      }, we)), ie.options[Ze.pluginName] && ie[Ze.pluginName][c] && ie[Ze.pluginName][c](_objectSpread2({
        sortable: ie
      }, we)));
    });
  },
  initializePlugins: function m(c, ie, we, $e) {
    plugins.forEach(function(ne) {
      var rr = ne.pluginName;
      if (!(!c.options[rr] && !ne.initializeByDefault)) {
        var gr = new ne(c, ie, c.options);
        gr.sortable = c, gr.options = c.options, c[rr] = gr, _extends(we, gr.defaults);
      }
    });
    for (var Me in c.options)
      if (!!c.options.hasOwnProperty(Me)) {
        var Ze = this.modifyOption(c, Me, c.options[Me]);
        typeof Ze < "u" && (c.options[Me] = Ze);
      }
  },
  getEventProperties: function m(c, ie) {
    var we = {};
    return plugins.forEach(function($e) {
      typeof $e.eventProperties == "function" && _extends(we, $e.eventProperties.call(ie[$e.pluginName], c));
    }), we;
  },
  modifyOption: function m(c, ie, we) {
    var $e;
    return plugins.forEach(function(Me) {
      !c[Me.pluginName] || Me.optionListeners && typeof Me.optionListeners[ie] == "function" && ($e = Me.optionListeners[ie].call(c[Me.pluginName], we));
    }), $e;
  }
};
function dispatchEvent(m) {
  var c = m.sortable, ie = m.rootEl, we = m.name, $e = m.targetEl, Me = m.cloneEl, Ze = m.toEl, ne = m.fromEl, rr = m.oldIndex, gr = m.newIndex, or = m.oldDraggableIndex, _r = m.newDraggableIndex, Lr = m.originalEvent, Ir = m.putSortable, Ar = m.extraEventProperties;
  if (c = c || ie && ie[expando], !!c) {
    var Rr, Nr = c.options, Yr = "on" + we.charAt(0).toUpperCase() + we.substr(1);
    window.CustomEvent && !IE11OrLess && !Edge ? Rr = new CustomEvent(we, {
      bubbles: !0,
      cancelable: !0
    }) : (Rr = document.createEvent("Event"), Rr.initEvent(we, !0, !0)), Rr.to = Ze || ie, Rr.from = ne || ie, Rr.item = $e || ie, Rr.clone = Me, Rr.oldIndex = rr, Rr.newIndex = gr, Rr.oldDraggableIndex = or, Rr.newDraggableIndex = _r, Rr.originalEvent = Lr, Rr.pullMode = Ir ? Ir.lastPutMode : void 0;
    var Vr = _objectSpread2(_objectSpread2({}, Ar), PluginManager.getEventProperties(we, c));
    for (var Xr in Vr)
      Rr[Xr] = Vr[Xr];
    ie && ie.dispatchEvent(Rr), Nr[Yr] && Nr[Yr].call(c, Rr);
  }
}
var _excluded = ["evt"], pluginEvent = function m(c, ie) {
  var we = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, $e = we.evt, Me = _objectWithoutProperties(we, _excluded);
  PluginManager.pluginEvent.bind(Sortable)(c, ie, _objectSpread2({
    dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    dragStarted: moved,
    putSortable,
    activeSortable: Sortable.active,
    originalEvent: $e,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function() {
      cloneHidden = !0;
    },
    cloneNowShown: function() {
      cloneHidden = !1;
    },
    dispatchSortableEvent: function(ne) {
      _dispatchEvent({
        sortable: ie,
        name: ne,
        originalEvent: $e
      });
    }
  }, Me));
};
function _dispatchEvent(m) {
  dispatchEvent(_objectSpread2({
    putSortable,
    cloneEl,
    targetEl: dragEl,
    rootEl,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex
  }, m));
}
var dragEl, parentEl, ghostEl, rootEl, nextEl, lastDownEl, cloneEl, cloneHidden, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, activeGroup, putSortable, awaitingDragStarted = !1, ignoreNextClick = !1, sortables = [], tapEvt, touchEvt, lastDx, lastDy, tapDistanceLeft, tapDistanceTop, moved, lastTarget, lastDirection, pastFirstInvertThresh = !1, isCircumstantialInvert = !1, targetMoveDistance, ghostRelativeParent, ghostRelativeParentInitialScroll = [], _silent = !1, savedInputChecked = [], documentExists = typeof document < "u", PositionGhostAbsolutely = IOS, CSSFloatProperty = Edge || IE11OrLess ? "cssFloat" : "float", supportDraggable = documentExists && !ChromeForAndroid && !IOS && "draggable" in document.createElement("div"), supportCssPointerEvents = function() {
  if (!!documentExists) {
    if (IE11OrLess)
      return !1;
    var m = document.createElement("x");
    return m.style.cssText = "pointer-events:auto", m.style.pointerEvents === "auto";
  }
}(), _detectDirection = function m(c, ie) {
  var we = css$1(c), $e = parseInt(we.width) - parseInt(we.paddingLeft) - parseInt(we.paddingRight) - parseInt(we.borderLeftWidth) - parseInt(we.borderRightWidth), Me = getChild(c, 0, ie), Ze = getChild(c, 1, ie), ne = Me && css$1(Me), rr = Ze && css$1(Ze), gr = ne && parseInt(ne.marginLeft) + parseInt(ne.marginRight) + getRect(Me).width, or = rr && parseInt(rr.marginLeft) + parseInt(rr.marginRight) + getRect(Ze).width;
  if (we.display === "flex")
    return we.flexDirection === "column" || we.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (we.display === "grid")
    return we.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (Me && ne.float && ne.float !== "none") {
    var _r = ne.float === "left" ? "left" : "right";
    return Ze && (rr.clear === "both" || rr.clear === _r) ? "vertical" : "horizontal";
  }
  return Me && (ne.display === "block" || ne.display === "flex" || ne.display === "table" || ne.display === "grid" || gr >= $e && we[CSSFloatProperty] === "none" || Ze && we[CSSFloatProperty] === "none" && gr + or > $e) ? "vertical" : "horizontal";
}, _dragElInRowColumn = function m(c, ie, we) {
  var $e = we ? c.left : c.top, Me = we ? c.right : c.bottom, Ze = we ? c.width : c.height, ne = we ? ie.left : ie.top, rr = we ? ie.right : ie.bottom, gr = we ? ie.width : ie.height;
  return $e === ne || Me === rr || $e + Ze / 2 === ne + gr / 2;
}, _detectNearestEmptySortable = function m(c, ie) {
  var we;
  return sortables.some(function($e) {
    var Me = $e[expando].options.emptyInsertThreshold;
    if (!(!Me || lastChild($e))) {
      var Ze = getRect($e), ne = c >= Ze.left - Me && c <= Ze.right + Me, rr = ie >= Ze.top - Me && ie <= Ze.bottom + Me;
      if (ne && rr)
        return we = $e;
    }
  }), we;
}, _prepareGroup = function m(c) {
  function ie(Me, Ze) {
    return function(ne, rr, gr, or) {
      var _r = ne.options.group.name && rr.options.group.name && ne.options.group.name === rr.options.group.name;
      if (Me == null && (Ze || _r))
        return !0;
      if (Me == null || Me === !1)
        return !1;
      if (Ze && Me === "clone")
        return Me;
      if (typeof Me == "function")
        return ie(Me(ne, rr, gr, or), Ze)(ne, rr, gr, or);
      var Lr = (Ze ? ne : rr).options.group.name;
      return Me === !0 || typeof Me == "string" && Me === Lr || Me.join && Me.indexOf(Lr) > -1;
    };
  }
  var we = {}, $e = c.group;
  (!$e || _typeof($e) != "object") && ($e = {
    name: $e
  }), we.name = $e.name, we.checkPull = ie($e.pull, !0), we.checkPut = ie($e.put), we.revertClone = $e.revertClone, c.group = we;
}, _hideGhostForTarget = function m() {
  !supportCssPointerEvents && ghostEl && css$1(ghostEl, "display", "none");
}, _unhideGhostForTarget = function m() {
  !supportCssPointerEvents && ghostEl && css$1(ghostEl, "display", "");
};
documentExists && !ChromeForAndroid && document.addEventListener("click", function(m) {
  if (ignoreNextClick)
    return m.preventDefault(), m.stopPropagation && m.stopPropagation(), m.stopImmediatePropagation && m.stopImmediatePropagation(), ignoreNextClick = !1, !1;
}, !0);
var nearestEmptyInsertDetectEvent = function m(c) {
  if (dragEl) {
    c = c.touches ? c.touches[0] : c;
    var ie = _detectNearestEmptySortable(c.clientX, c.clientY);
    if (ie) {
      var we = {};
      for (var $e in c)
        c.hasOwnProperty($e) && (we[$e] = c[$e]);
      we.target = we.rootEl = ie, we.preventDefault = void 0, we.stopPropagation = void 0, ie[expando]._onDragOver(we);
    }
  }
}, _checkOutsideTargetEl = function m(c) {
  dragEl && dragEl.parentNode[expando]._isOutsideThisEl(c.target);
};
function Sortable(m, c) {
  if (!(m && m.nodeType && m.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(m));
  this.el = m, this.options = c = _extends({}, c), m[expando] = this;
  var ie = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(m.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    invertSwap: !1,
    invertedSwapThreshold: null,
    removeCloneOnHide: !0,
    direction: function() {
      return _detectDirection(m, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(Ze, ne) {
      Ze.setData("Text", ne.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== !1 && "PointerEvent" in window && (!Safari || IOS),
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, m, ie);
  for (var we in ie)
    !(we in c) && (c[we] = ie[we]);
  _prepareGroup(c);
  for (var $e in this)
    $e.charAt(0) === "_" && typeof this[$e] == "function" && (this[$e] = this[$e].bind(this));
  this.nativeDraggable = c.forceFallback ? !1 : supportDraggable, this.nativeDraggable && (this.options.touchStartThreshold = 1), c.supportPointer ? on(m, "pointerdown", this._onTapStart) : (on(m, "mousedown", this._onTapStart), on(m, "touchstart", this._onTapStart)), this.nativeDraggable && (on(m, "dragover", this), on(m, "dragenter", this)), sortables.push(this.el), c.store && c.store.get && this.sort(c.store.get(this) || []), _extends(this, AnimationStateManager());
}
Sortable.prototype = {
  constructor: Sortable,
  _isOutsideThisEl: function m(c) {
    !this.el.contains(c) && c !== this.el && (lastTarget = null);
  },
  _getDirection: function m(c, ie) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, c, ie, dragEl) : this.options.direction;
  },
  _onTapStart: function m(c) {
    if (!!c.cancelable) {
      var ie = this, we = this.el, $e = this.options, Me = $e.preventOnFilter, Ze = c.type, ne = c.touches && c.touches[0] || c.pointerType && c.pointerType === "touch" && c, rr = (ne || c).target, gr = c.target.shadowRoot && (c.path && c.path[0] || c.composedPath && c.composedPath()[0]) || rr, or = $e.filter;
      if (_saveInputCheckedState(we), !dragEl && !(/mousedown|pointerdown/.test(Ze) && c.button !== 0 || $e.disabled) && !gr.isContentEditable && !(!this.nativeDraggable && Safari && rr && rr.tagName.toUpperCase() === "SELECT") && (rr = closest(rr, $e.draggable, we, !1), !(rr && rr.animated) && lastDownEl !== rr)) {
        if (oldIndex = index(rr), oldDraggableIndex = index(rr, $e.draggable), typeof or == "function") {
          if (or.call(this, c, rr, this)) {
            _dispatchEvent({
              sortable: ie,
              rootEl: gr,
              name: "filter",
              targetEl: rr,
              toEl: we,
              fromEl: we
            }), pluginEvent("filter", ie, {
              evt: c
            }), Me && c.preventDefault();
            return;
          }
        } else if (or && (or = or.split(",").some(function(_r) {
          if (_r = closest(gr, _r.trim(), we, !1), _r)
            return _dispatchEvent({
              sortable: ie,
              rootEl: _r,
              name: "filter",
              targetEl: rr,
              fromEl: we,
              toEl: we
            }), pluginEvent("filter", ie, {
              evt: c
            }), !0;
        }), or)) {
          Me && c.preventDefault();
          return;
        }
        $e.handle && !closest(gr, $e.handle, we, !1) || this._prepareDragStart(c, ne, rr);
      }
    }
  },
  _prepareDragStart: function m(c, ie, we) {
    var $e = this, Me = $e.el, Ze = $e.options, ne = Me.ownerDocument, rr;
    if (we && !dragEl && we.parentNode === Me) {
      var gr = getRect(we);
      if (rootEl = Me, dragEl = we, parentEl = dragEl.parentNode, nextEl = dragEl.nextSibling, lastDownEl = we, activeGroup = Ze.group, Sortable.dragged = dragEl, tapEvt = {
        target: dragEl,
        clientX: (ie || c).clientX,
        clientY: (ie || c).clientY
      }, tapDistanceLeft = tapEvt.clientX - gr.left, tapDistanceTop = tapEvt.clientY - gr.top, this._lastX = (ie || c).clientX, this._lastY = (ie || c).clientY, dragEl.style["will-change"] = "all", rr = function() {
        if (pluginEvent("delayEnded", $e, {
          evt: c
        }), Sortable.eventCanceled) {
          $e._onDrop();
          return;
        }
        $e._disableDelayedDragEvents(), !FireFox && $e.nativeDraggable && (dragEl.draggable = !0), $e._triggerDragStart(c, ie), _dispatchEvent({
          sortable: $e,
          name: "choose",
          originalEvent: c
        }), toggleClass(dragEl, Ze.chosenClass, !0);
      }, Ze.ignore.split(",").forEach(function(or) {
        find(dragEl, or.trim(), _disableDraggable);
      }), on(ne, "dragover", nearestEmptyInsertDetectEvent), on(ne, "mousemove", nearestEmptyInsertDetectEvent), on(ne, "touchmove", nearestEmptyInsertDetectEvent), Ze.supportPointer ? (on(ne, "pointerup", $e._onDrop), !this.nativeDraggable && on(ne, "pointercancel", $e._onDrop)) : (on(ne, "mouseup", $e._onDrop), on(ne, "touchend", $e._onDrop), on(ne, "touchcancel", $e._onDrop)), FireFox && this.nativeDraggable && (this.options.touchStartThreshold = 4, dragEl.draggable = !0), pluginEvent("delayStart", this, {
        evt: c
      }), Ze.delay && (!Ze.delayOnTouchOnly || ie) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();
          return;
        }
        Ze.supportPointer ? (on(ne, "pointerup", $e._disableDelayedDrag), on(ne, "pointercancel", $e._disableDelayedDrag)) : (on(ne, "mouseup", $e._disableDelayedDrag), on(ne, "touchend", $e._disableDelayedDrag), on(ne, "touchcancel", $e._disableDelayedDrag)), on(ne, "mousemove", $e._delayedDragTouchMoveHandler), on(ne, "touchmove", $e._delayedDragTouchMoveHandler), Ze.supportPointer && on(ne, "pointermove", $e._delayedDragTouchMoveHandler), $e._dragStartTimer = setTimeout(rr, Ze.delay);
      } else
        rr();
    }
  },
  _delayedDragTouchMoveHandler: function m(c) {
    var ie = c.touches ? c.touches[0] : c;
    Math.max(Math.abs(ie.clientX - this._lastX), Math.abs(ie.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function m() {
    dragEl && _disableDraggable(dragEl), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function m() {
    var c = this.el.ownerDocument;
    off(c, "mouseup", this._disableDelayedDrag), off(c, "touchend", this._disableDelayedDrag), off(c, "touchcancel", this._disableDelayedDrag), off(c, "pointerup", this._disableDelayedDrag), off(c, "pointercancel", this._disableDelayedDrag), off(c, "mousemove", this._delayedDragTouchMoveHandler), off(c, "touchmove", this._delayedDragTouchMoveHandler), off(c, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function m(c, ie) {
    ie = ie || c.pointerType == "touch" && c, !this.nativeDraggable || ie ? this.options.supportPointer ? on(document, "pointermove", this._onTouchMove) : ie ? on(document, "touchmove", this._onTouchMove) : on(document, "mousemove", this._onTouchMove) : (on(dragEl, "dragend", this), on(rootEl, "dragstart", this._onDragStart));
    try {
      document.selection ? _nextTick(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function m(c, ie) {
    if (awaitingDragStarted = !1, rootEl && dragEl) {
      pluginEvent("dragStarted", this, {
        evt: ie
      }), this.nativeDraggable && on(document, "dragover", _checkOutsideTargetEl);
      var we = this.options;
      !c && toggleClass(dragEl, we.dragClass, !1), toggleClass(dragEl, we.ghostClass, !0), Sortable.active = this, c && this._appendGhost(), _dispatchEvent({
        sortable: this,
        name: "start",
        originalEvent: ie
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function m() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX, this._lastY = touchEvt.clientY, _hideGhostForTarget();
      for (var c = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY), ie = c; c && c.shadowRoot && (c = c.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY), c !== ie); )
        ie = c;
      if (dragEl.parentNode[expando]._isOutsideThisEl(c), ie)
        do {
          if (ie[expando]) {
            var we = void 0;
            if (we = ie[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: c,
              rootEl: ie
            }), we && !this.options.dragoverBubble)
              break;
          }
          c = ie;
        } while (ie = getParentOrHost(ie));
      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function m(c) {
    if (tapEvt) {
      var ie = this.options, we = ie.fallbackTolerance, $e = ie.fallbackOffset, Me = c.touches ? c.touches[0] : c, Ze = ghostEl && matrix(ghostEl, !0), ne = ghostEl && Ze && Ze.a, rr = ghostEl && Ze && Ze.d, gr = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent), or = (Me.clientX - tapEvt.clientX + $e.x) / (ne || 1) + (gr ? gr[0] - ghostRelativeParentInitialScroll[0] : 0) / (ne || 1), _r = (Me.clientY - tapEvt.clientY + $e.y) / (rr || 1) + (gr ? gr[1] - ghostRelativeParentInitialScroll[1] : 0) / (rr || 1);
      if (!Sortable.active && !awaitingDragStarted) {
        if (we && Math.max(Math.abs(Me.clientX - this._lastX), Math.abs(Me.clientY - this._lastY)) < we)
          return;
        this._onDragStart(c, !0);
      }
      if (ghostEl) {
        Ze ? (Ze.e += or - (lastDx || 0), Ze.f += _r - (lastDy || 0)) : Ze = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: or,
          f: _r
        };
        var Lr = "matrix(".concat(Ze.a, ",").concat(Ze.b, ",").concat(Ze.c, ",").concat(Ze.d, ",").concat(Ze.e, ",").concat(Ze.f, ")");
        css$1(ghostEl, "webkitTransform", Lr), css$1(ghostEl, "mozTransform", Lr), css$1(ghostEl, "msTransform", Lr), css$1(ghostEl, "transform", Lr), lastDx = or, lastDy = _r, touchEvt = Me;
      }
      c.cancelable && c.preventDefault();
    }
  },
  _appendGhost: function m() {
    if (!ghostEl) {
      var c = this.options.fallbackOnBody ? document.body : rootEl, ie = getRect(dragEl, !0, PositionGhostAbsolutely, !0, c), we = this.options;
      if (PositionGhostAbsolutely) {
        for (ghostRelativeParent = c; css$1(ghostRelativeParent, "position") === "static" && css$1(ghostRelativeParent, "transform") === "none" && ghostRelativeParent !== document; )
          ghostRelativeParent = ghostRelativeParent.parentNode;
        ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement ? (ghostRelativeParent === document && (ghostRelativeParent = getWindowScrollingElement()), ie.top += ghostRelativeParent.scrollTop, ie.left += ghostRelativeParent.scrollLeft) : ghostRelativeParent = getWindowScrollingElement(), ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }
      ghostEl = dragEl.cloneNode(!0), toggleClass(ghostEl, we.ghostClass, !1), toggleClass(ghostEl, we.fallbackClass, !0), toggleClass(ghostEl, we.dragClass, !0), css$1(ghostEl, "transition", ""), css$1(ghostEl, "transform", ""), css$1(ghostEl, "box-sizing", "border-box"), css$1(ghostEl, "margin", 0), css$1(ghostEl, "top", ie.top), css$1(ghostEl, "left", ie.left), css$1(ghostEl, "width", ie.width), css$1(ghostEl, "height", ie.height), css$1(ghostEl, "opacity", "0.8"), css$1(ghostEl, "position", PositionGhostAbsolutely ? "absolute" : "fixed"), css$1(ghostEl, "zIndex", "100000"), css$1(ghostEl, "pointerEvents", "none"), Sortable.ghost = ghostEl, c.appendChild(ghostEl), css$1(ghostEl, "transform-origin", tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + "% " + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + "%");
    }
  },
  _onDragStart: function m(c, ie) {
    var we = this, $e = c.dataTransfer, Me = we.options;
    if (pluginEvent("dragStart", this, {
      evt: c
    }), Sortable.eventCanceled) {
      this._onDrop();
      return;
    }
    pluginEvent("setupClone", this), Sortable.eventCanceled || (cloneEl = clone(dragEl), cloneEl.removeAttribute("id"), cloneEl.draggable = !1, cloneEl.style["will-change"] = "", this._hideClone(), toggleClass(cloneEl, this.options.chosenClass, !1), Sortable.clone = cloneEl), we.cloneId = _nextTick(function() {
      pluginEvent("clone", we), !Sortable.eventCanceled && (we.options.removeCloneOnHide || rootEl.insertBefore(cloneEl, dragEl), we._hideClone(), _dispatchEvent({
        sortable: we,
        name: "clone"
      }));
    }), !ie && toggleClass(dragEl, Me.dragClass, !0), ie ? (ignoreNextClick = !0, we._loopId = setInterval(we._emulateDragOver, 50)) : (off(document, "mouseup", we._onDrop), off(document, "touchend", we._onDrop), off(document, "touchcancel", we._onDrop), $e && ($e.effectAllowed = "move", Me.setData && Me.setData.call(we, $e, dragEl)), on(document, "drop", we), css$1(dragEl, "transform", "translateZ(0)")), awaitingDragStarted = !0, we._dragStartId = _nextTick(we._dragStarted.bind(we, ie, c)), on(document, "selectstart", we), moved = !0, window.getSelection().removeAllRanges(), Safari && css$1(document.body, "user-select", "none");
  },
  _onDragOver: function m(c) {
    var ie = this.el, we = c.target, $e, Me, Ze, ne = this.options, rr = ne.group, gr = Sortable.active, or = activeGroup === rr, _r = ne.sort, Lr = putSortable || gr, Ir, Ar = this, Rr = !1;
    if (_silent)
      return;
    function Nr(br, nr) {
      pluginEvent(br, Ar, _objectSpread2({
        evt: c,
        isOwner: or,
        axis: Ir ? "vertical" : "horizontal",
        revert: Ze,
        dragRect: $e,
        targetRect: Me,
        canSort: _r,
        fromSortable: Lr,
        target: we,
        completed: Vr,
        onMove: function(ur, Pr) {
          return _onMove(rootEl, ie, dragEl, $e, ur, getRect(ur), c, Pr);
        },
        changed: Xr
      }, nr));
    }
    function Yr() {
      Nr("dragOverAnimationCapture"), Ar.captureAnimationState(), Ar !== Lr && Lr.captureAnimationState();
    }
    function Vr(br) {
      return Nr("dragOverCompleted", {
        insertion: br
      }), br && (or ? gr._hideClone() : gr._showClone(Ar), Ar !== Lr && (toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : gr.options.ghostClass, !1), toggleClass(dragEl, ne.ghostClass, !0)), putSortable !== Ar && Ar !== Sortable.active ? putSortable = Ar : Ar === Sortable.active && putSortable && (putSortable = null), Lr === Ar && (Ar._ignoreWhileAnimating = we), Ar.animateAll(function() {
        Nr("dragOverAnimationComplete"), Ar._ignoreWhileAnimating = null;
      }), Ar !== Lr && (Lr.animateAll(), Lr._ignoreWhileAnimating = null)), (we === dragEl && !dragEl.animated || we === ie && !we.animated) && (lastTarget = null), !ne.dragoverBubble && !c.rootEl && we !== document && (dragEl.parentNode[expando]._isOutsideThisEl(c.target), !br && nearestEmptyInsertDetectEvent(c)), !ne.dragoverBubble && c.stopPropagation && c.stopPropagation(), Rr = !0;
    }
    function Xr() {
      newIndex = index(dragEl), newDraggableIndex = index(dragEl, ne.draggable), _dispatchEvent({
        sortable: Ar,
        name: "change",
        toEl: ie,
        newIndex,
        newDraggableIndex,
        originalEvent: c
      });
    }
    if (c.preventDefault !== void 0 && c.cancelable && c.preventDefault(), we = closest(we, ne.draggable, ie, !0), Nr("dragOver"), Sortable.eventCanceled)
      return Rr;
    if (dragEl.contains(c.target) || we.animated && we.animatingX && we.animatingY || Ar._ignoreWhileAnimating === we)
      return Vr(!1);
    if (ignoreNextClick = !1, gr && !ne.disabled && (or ? _r || (Ze = parentEl !== rootEl) : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, gr, dragEl, c)) && rr.checkPut(this, gr, dragEl, c))) {
      if (Ir = this._getDirection(c, we) === "vertical", $e = getRect(dragEl), Nr("dragOverValid"), Sortable.eventCanceled)
        return Rr;
      if (Ze)
        return parentEl = rootEl, Yr(), this._hideClone(), Nr("revert"), Sortable.eventCanceled || (nextEl ? rootEl.insertBefore(dragEl, nextEl) : rootEl.appendChild(dragEl)), Vr(!0);
      var Wr = lastChild(ie, ne.draggable);
      if (!Wr || _ghostIsLast(c, Ir, this) && !Wr.animated) {
        if (Wr === dragEl)
          return Vr(!1);
        if (Wr && ie === c.target && (we = Wr), we && (Me = getRect(we)), _onMove(rootEl, ie, dragEl, $e, we, Me, c, !!we) !== !1)
          return Yr(), Wr && Wr.nextSibling ? ie.insertBefore(dragEl, Wr.nextSibling) : ie.appendChild(dragEl), parentEl = ie, Xr(), Vr(!0);
      } else if (Wr && _ghostIsFirst(c, Ir, this)) {
        var si = getChild(ie, 0, ne, !0);
        if (si === dragEl)
          return Vr(!1);
        if (we = si, Me = getRect(we), _onMove(rootEl, ie, dragEl, $e, we, Me, c, !1) !== !1)
          return Yr(), ie.insertBefore(dragEl, si), parentEl = ie, Xr(), Vr(!0);
      } else if (we.parentNode === ie) {
        Me = getRect(we);
        var li = 0, xi, di = dragEl.parentNode !== ie, oi = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || $e, we.animated && we.toRect || Me, Ir), ci = Ir ? "top" : "left", vr = isScrolledPast(we, "top", "top") || isScrolledPast(dragEl, "top", "top"), Ae = vr ? vr.scrollTop : void 0;
        lastTarget !== we && (xi = Me[ci], pastFirstInvertThresh = !1, isCircumstantialInvert = !oi && ne.invertSwap || di), li = _getSwapDirection(c, we, Me, Ir, oi ? 1 : ne.swapThreshold, ne.invertedSwapThreshold == null ? ne.swapThreshold : ne.invertedSwapThreshold, isCircumstantialInvert, lastTarget === we);
        var ze;
        if (li !== 0) {
          var Ue = index(dragEl);
          do
            Ue -= li, ze = parentEl.children[Ue];
          while (ze && (css$1(ze, "display") === "none" || ze === ghostEl));
        }
        if (li === 0 || ze === we)
          return Vr(!1);
        lastTarget = we, lastDirection = li;
        var tr = we.nextElementSibling, lr = !1;
        lr = li === 1;
        var pr = _onMove(rootEl, ie, dragEl, $e, we, Me, c, lr);
        if (pr !== !1)
          return (pr === 1 || pr === -1) && (lr = pr === 1), _silent = !0, setTimeout(_unsilent, 30), Yr(), lr && !tr ? ie.appendChild(dragEl) : we.parentNode.insertBefore(dragEl, lr ? tr : we), vr && scrollBy(vr, 0, Ae - vr.scrollTop), parentEl = dragEl.parentNode, xi !== void 0 && !isCircumstantialInvert && (targetMoveDistance = Math.abs(xi - getRect(we)[ci])), Xr(), Vr(!0);
      }
      if (ie.contains(dragEl))
        return Vr(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function m() {
    off(document, "mousemove", this._onTouchMove), off(document, "touchmove", this._onTouchMove), off(document, "pointermove", this._onTouchMove), off(document, "dragover", nearestEmptyInsertDetectEvent), off(document, "mousemove", nearestEmptyInsertDetectEvent), off(document, "touchmove", nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function m() {
    var c = this.el.ownerDocument;
    off(c, "mouseup", this._onDrop), off(c, "touchend", this._onDrop), off(c, "pointerup", this._onDrop), off(c, "pointercancel", this._onDrop), off(c, "touchcancel", this._onDrop), off(document, "selectstart", this);
  },
  _onDrop: function m(c) {
    var ie = this.el, we = this.options;
    if (newIndex = index(dragEl), newDraggableIndex = index(dragEl, we.draggable), pluginEvent("drop", this, {
      evt: c
    }), parentEl = dragEl && dragEl.parentNode, newIndex = index(dragEl), newDraggableIndex = index(dragEl, we.draggable), Sortable.eventCanceled) {
      this._nulling();
      return;
    }
    awaitingDragStarted = !1, isCircumstantialInvert = !1, pastFirstInvertThresh = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), _cancelNextTick(this.cloneId), _cancelNextTick(this._dragStartId), this.nativeDraggable && (off(document, "drop", this), off(ie, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), Safari && css$1(document.body, "user-select", ""), css$1(dragEl, "transform", ""), c && (moved && (c.cancelable && c.preventDefault(), !we.dropBubble && c.stopPropagation()), ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl), (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") && cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl), dragEl && (this.nativeDraggable && off(dragEl, "dragend", this), _disableDraggable(dragEl), dragEl.style["will-change"] = "", moved && !awaitingDragStarted && toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, !1), toggleClass(dragEl, this.options.chosenClass, !1), _dispatchEvent({
      sortable: this,
      name: "unchoose",
      toEl: parentEl,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: c
    }), rootEl !== parentEl ? (newIndex >= 0 && (_dispatchEvent({
      rootEl: parentEl,
      name: "add",
      toEl: parentEl,
      fromEl: rootEl,
      originalEvent: c
    }), _dispatchEvent({
      sortable: this,
      name: "remove",
      toEl: parentEl,
      originalEvent: c
    }), _dispatchEvent({
      rootEl: parentEl,
      name: "sort",
      toEl: parentEl,
      fromEl: rootEl,
      originalEvent: c
    }), _dispatchEvent({
      sortable: this,
      name: "sort",
      toEl: parentEl,
      originalEvent: c
    })), putSortable && putSortable.save()) : newIndex !== oldIndex && newIndex >= 0 && (_dispatchEvent({
      sortable: this,
      name: "update",
      toEl: parentEl,
      originalEvent: c
    }), _dispatchEvent({
      sortable: this,
      name: "sort",
      toEl: parentEl,
      originalEvent: c
    })), Sortable.active && ((newIndex == null || newIndex === -1) && (newIndex = oldIndex, newDraggableIndex = oldDraggableIndex), _dispatchEvent({
      sortable: this,
      name: "end",
      toEl: parentEl,
      originalEvent: c
    }), this.save()))), this._nulling();
  },
  _nulling: function m() {
    pluginEvent("nulling", this), rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null, savedInputChecked.forEach(function(c) {
      c.checked = !0;
    }), savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function m(c) {
    switch (c.type) {
      case "drop":
      case "dragend":
        this._onDrop(c);
        break;
      case "dragenter":
      case "dragover":
        dragEl && (this._onDragOver(c), _globalDragOver(c));
        break;
      case "selectstart":
        c.preventDefault();
        break;
    }
  },
  toArray: function m() {
    for (var c = [], ie, we = this.el.children, $e = 0, Me = we.length, Ze = this.options; $e < Me; $e++)
      ie = we[$e], closest(ie, Ze.draggable, this.el, !1) && c.push(ie.getAttribute(Ze.dataIdAttr) || _generateId(ie));
    return c;
  },
  sort: function m(c, ie) {
    var we = {}, $e = this.el;
    this.toArray().forEach(function(Me, Ze) {
      var ne = $e.children[Ze];
      closest(ne, this.options.draggable, $e, !1) && (we[Me] = ne);
    }, this), ie && this.captureAnimationState(), c.forEach(function(Me) {
      we[Me] && ($e.removeChild(we[Me]), $e.appendChild(we[Me]));
    }), ie && this.animateAll();
  },
  save: function m() {
    var c = this.options.store;
    c && c.set && c.set(this);
  },
  closest: function m(c, ie) {
    return closest(c, ie || this.options.draggable, this.el, !1);
  },
  option: function m(c, ie) {
    var we = this.options;
    if (ie === void 0)
      return we[c];
    var $e = PluginManager.modifyOption(this, c, ie);
    typeof $e < "u" ? we[c] = $e : we[c] = ie, c === "group" && _prepareGroup(we);
  },
  destroy: function m() {
    pluginEvent("destroy", this);
    var c = this.el;
    c[expando] = null, off(c, "mousedown", this._onTapStart), off(c, "touchstart", this._onTapStart), off(c, "pointerdown", this._onTapStart), this.nativeDraggable && (off(c, "dragover", this), off(c, "dragenter", this)), Array.prototype.forEach.call(c.querySelectorAll("[draggable]"), function(ie) {
      ie.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), sortables.splice(sortables.indexOf(this.el), 1), this.el = c = null;
  },
  _hideClone: function m() {
    if (!cloneHidden) {
      if (pluginEvent("hideClone", this), Sortable.eventCanceled)
        return;
      css$1(cloneEl, "display", "none"), this.options.removeCloneOnHide && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl), cloneHidden = !0;
    }
  },
  _showClone: function m(c) {
    if (c.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (cloneHidden) {
      if (pluginEvent("showClone", this), Sortable.eventCanceled)
        return;
      dragEl.parentNode == rootEl && !this.options.group.revertClone ? rootEl.insertBefore(cloneEl, dragEl) : nextEl ? rootEl.insertBefore(cloneEl, nextEl) : rootEl.appendChild(cloneEl), this.options.group.revertClone && this.animate(dragEl, cloneEl), css$1(cloneEl, "display", ""), cloneHidden = !1;
    }
  }
};
function _globalDragOver(m) {
  m.dataTransfer && (m.dataTransfer.dropEffect = "move"), m.cancelable && m.preventDefault();
}
function _onMove(m, c, ie, we, $e, Me, Ze, ne) {
  var rr, gr = m[expando], or = gr.options.onMove, _r;
  return window.CustomEvent && !IE11OrLess && !Edge ? rr = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (rr = document.createEvent("Event"), rr.initEvent("move", !0, !0)), rr.to = c, rr.from = m, rr.dragged = ie, rr.draggedRect = we, rr.related = $e || c, rr.relatedRect = Me || getRect(c), rr.willInsertAfter = ne, rr.originalEvent = Ze, m.dispatchEvent(rr), or && (_r = or.call(gr, rr, Ze)), _r;
}
function _disableDraggable(m) {
  m.draggable = !1;
}
function _unsilent() {
  _silent = !1;
}
function _ghostIsFirst(m, c, ie) {
  var we = getRect(getChild(ie.el, 0, ie.options, !0)), $e = getChildContainingRectFromElement(ie.el, ie.options, ghostEl), Me = 10;
  return c ? m.clientX < $e.left - Me || m.clientY < we.top && m.clientX < we.right : m.clientY < $e.top - Me || m.clientY < we.bottom && m.clientX < we.left;
}
function _ghostIsLast(m, c, ie) {
  var we = getRect(lastChild(ie.el, ie.options.draggable)), $e = getChildContainingRectFromElement(ie.el, ie.options, ghostEl), Me = 10;
  return c ? m.clientX > $e.right + Me || m.clientY > we.bottom && m.clientX > we.left : m.clientY > $e.bottom + Me || m.clientX > we.right && m.clientY > we.top;
}
function _getSwapDirection(m, c, ie, we, $e, Me, Ze, ne) {
  var rr = we ? m.clientY : m.clientX, gr = we ? ie.height : ie.width, or = we ? ie.top : ie.left, _r = we ? ie.bottom : ie.right, Lr = !1;
  if (!Ze) {
    if (ne && targetMoveDistance < gr * $e) {
      if (!pastFirstInvertThresh && (lastDirection === 1 ? rr > or + gr * Me / 2 : rr < _r - gr * Me / 2) && (pastFirstInvertThresh = !0), pastFirstInvertThresh)
        Lr = !0;
      else if (lastDirection === 1 ? rr < or + targetMoveDistance : rr > _r - targetMoveDistance)
        return -lastDirection;
    } else if (rr > or + gr * (1 - $e) / 2 && rr < _r - gr * (1 - $e) / 2)
      return _getInsertDirection(c);
  }
  return Lr = Lr || Ze, Lr && (rr < or + gr * Me / 2 || rr > _r - gr * Me / 2) ? rr > or + gr / 2 ? 1 : -1 : 0;
}
function _getInsertDirection(m) {
  return index(dragEl) < index(m) ? 1 : -1;
}
function _generateId(m) {
  for (var c = m.tagName + m.className + m.src + m.href + m.textContent, ie = c.length, we = 0; ie--; )
    we += c.charCodeAt(ie);
  return we.toString(36);
}
function _saveInputCheckedState(m) {
  savedInputChecked.length = 0;
  for (var c = m.getElementsByTagName("input"), ie = c.length; ie--; ) {
    var we = c[ie];
    we.checked && savedInputChecked.push(we);
  }
}
function _nextTick(m) {
  return setTimeout(m, 0);
}
function _cancelNextTick(m) {
  return clearTimeout(m);
}
documentExists && on(document, "touchmove", function(m) {
  (Sortable.active || awaitingDragStarted) && m.cancelable && m.preventDefault();
});
Sortable.utils = {
  on,
  off,
  css: css$1,
  find,
  is: function m(c, ie) {
    return !!closest(c, ie, c, !1);
  },
  extend: extend$3,
  throttle,
  closest,
  toggleClass,
  clone,
  index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild,
  expando
};
Sortable.get = function(m) {
  return m[expando];
};
Sortable.mount = function() {
  for (var m = arguments.length, c = new Array(m), ie = 0; ie < m; ie++)
    c[ie] = arguments[ie];
  c[0].constructor === Array && (c = c[0]), c.forEach(function(we) {
    if (!we.prototype || !we.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(we));
    we.utils && (Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), we.utils)), PluginManager.mount(we);
  });
};
Sortable.create = function(m, c) {
  return new Sortable(m, c);
};
Sortable.version = version;
var autoScrolls = [], scrollEl, scrollRootEl, scrolling = !1, lastAutoScrollX, lastAutoScrollY, touchEvt$1, pointerElemChangedInterval;
function AutoScrollPlugin() {
  function m() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var c in this)
      c.charAt(0) === "_" && typeof this[c] == "function" && (this[c] = this[c].bind(this));
  }
  return m.prototype = {
    dragStarted: function(ie) {
      var we = ie.originalEvent;
      this.sortable.nativeDraggable ? on(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? on(document, "pointermove", this._handleFallbackAutoScroll) : we.touches ? on(document, "touchmove", this._handleFallbackAutoScroll) : on(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(ie) {
      var we = ie.originalEvent;
      !this.options.dragOverBubble && !we.rootEl && this._handleAutoScroll(we);
    },
    drop: function() {
      this.sortable.nativeDraggable ? off(document, "dragover", this._handleAutoScroll) : (off(document, "pointermove", this._handleFallbackAutoScroll), off(document, "touchmove", this._handleFallbackAutoScroll), off(document, "mousemove", this._handleFallbackAutoScroll)), clearPointerElemChangedInterval(), clearAutoScrolls(), cancelThrottle();
    },
    nulling: function() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null, autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function(ie) {
      this._handleAutoScroll(ie, !0);
    },
    _handleAutoScroll: function(ie, we) {
      var $e = this, Me = (ie.touches ? ie.touches[0] : ie).clientX, Ze = (ie.touches ? ie.touches[0] : ie).clientY, ne = document.elementFromPoint(Me, Ze);
      if (touchEvt$1 = ie, we || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
        autoScroll(ie, this.options, ne, we);
        var rr = getParentAutoScrollElement(ne, !0);
        scrolling && (!pointerElemChangedInterval || Me !== lastAutoScrollX || Ze !== lastAutoScrollY) && (pointerElemChangedInterval && clearPointerElemChangedInterval(), pointerElemChangedInterval = setInterval(function() {
          var gr = getParentAutoScrollElement(document.elementFromPoint(Me, Ze), !0);
          gr !== rr && (rr = gr, clearAutoScrolls()), autoScroll(ie, $e.options, gr, we);
        }, 10), lastAutoScrollX = Me, lastAutoScrollY = Ze);
      } else {
        if (!this.options.bubbleScroll || getParentAutoScrollElement(ne, !0) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }
        autoScroll(ie, this.options, getParentAutoScrollElement(ne, !1), !1);
      }
    }
  }, _extends(m, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function clearAutoScrolls() {
  autoScrolls.forEach(function(m) {
    clearInterval(m.pid);
  }), autoScrolls = [];
}
function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}
var autoScroll = throttle(function(m, c, ie, we) {
  if (!!c.scroll) {
    var $e = (m.touches ? m.touches[0] : m).clientX, Me = (m.touches ? m.touches[0] : m).clientY, Ze = c.scrollSensitivity, ne = c.scrollSpeed, rr = getWindowScrollingElement(), gr = !1, or;
    scrollRootEl !== ie && (scrollRootEl = ie, clearAutoScrolls(), scrollEl = c.scroll, or = c.scrollFn, scrollEl === !0 && (scrollEl = getParentAutoScrollElement(ie, !0)));
    var _r = 0, Lr = scrollEl;
    do {
      var Ir = Lr, Ar = getRect(Ir), Rr = Ar.top, Nr = Ar.bottom, Yr = Ar.left, Vr = Ar.right, Xr = Ar.width, Wr = Ar.height, si = void 0, li = void 0, xi = Ir.scrollWidth, di = Ir.scrollHeight, oi = css$1(Ir), ci = Ir.scrollLeft, vr = Ir.scrollTop;
      Ir === rr ? (si = Xr < xi && (oi.overflowX === "auto" || oi.overflowX === "scroll" || oi.overflowX === "visible"), li = Wr < di && (oi.overflowY === "auto" || oi.overflowY === "scroll" || oi.overflowY === "visible")) : (si = Xr < xi && (oi.overflowX === "auto" || oi.overflowX === "scroll"), li = Wr < di && (oi.overflowY === "auto" || oi.overflowY === "scroll"));
      var Ae = si && (Math.abs(Vr - $e) <= Ze && ci + Xr < xi) - (Math.abs(Yr - $e) <= Ze && !!ci), ze = li && (Math.abs(Nr - Me) <= Ze && vr + Wr < di) - (Math.abs(Rr - Me) <= Ze && !!vr);
      if (!autoScrolls[_r])
        for (var Ue = 0; Ue <= _r; Ue++)
          autoScrolls[Ue] || (autoScrolls[Ue] = {});
      (autoScrolls[_r].vx != Ae || autoScrolls[_r].vy != ze || autoScrolls[_r].el !== Ir) && (autoScrolls[_r].el = Ir, autoScrolls[_r].vx = Ae, autoScrolls[_r].vy = ze, clearInterval(autoScrolls[_r].pid), (Ae != 0 || ze != 0) && (gr = !0, autoScrolls[_r].pid = setInterval(function() {
        we && this.layer === 0 && Sortable.active._onTouchMove(touchEvt$1);
        var tr = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * ne : 0, lr = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * ne : 0;
        typeof or == "function" && or.call(Sortable.dragged.parentNode[expando], lr, tr, m, touchEvt$1, autoScrolls[this.layer].el) !== "continue" || scrollBy(autoScrolls[this.layer].el, lr, tr);
      }.bind({
        layer: _r
      }), 24))), _r++;
    } while (c.bubbleScroll && Lr !== rr && (Lr = getParentAutoScrollElement(Lr, !1)));
    scrolling = gr;
  }
}, 30), drop = function m(c) {
  var ie = c.originalEvent, we = c.putSortable, $e = c.dragEl, Me = c.activeSortable, Ze = c.dispatchSortableEvent, ne = c.hideGhostForTarget, rr = c.unhideGhostForTarget;
  if (!!ie) {
    var gr = we || Me;
    ne();
    var or = ie.changedTouches && ie.changedTouches.length ? ie.changedTouches[0] : ie, _r = document.elementFromPoint(or.clientX, or.clientY);
    rr(), gr && !gr.el.contains(_r) && (Ze("spill"), this.onSpill({
      dragEl: $e,
      putSortable: we
    }));
  }
};
function Revert() {
}
Revert.prototype = {
  startIndex: null,
  dragStart: function m(c) {
    var ie = c.oldDraggableIndex;
    this.startIndex = ie;
  },
  onSpill: function m(c) {
    var ie = c.dragEl, we = c.putSortable;
    this.sortable.captureAnimationState(), we && we.captureAnimationState();
    var $e = getChild(this.sortable.el, this.startIndex, this.options);
    $e ? this.sortable.el.insertBefore(ie, $e) : this.sortable.el.appendChild(ie), this.sortable.animateAll(), we && we.animateAll();
  },
  drop
};
_extends(Revert, {
  pluginName: "revertOnSpill"
});
function Remove() {
}
Remove.prototype = {
  onSpill: function m(c) {
    var ie = c.dragEl, we = c.putSortable, $e = we || this.sortable;
    $e.captureAnimationState(), ie.parentNode && ie.parentNode.removeChild(ie), $e.animateAll();
  },
  drop
};
_extends(Remove, {
  pluginName: "removeOnSpill"
});
var lastSwapEl;
function SwapPlugin() {
  function m() {
    this.defaults = {
      swapClass: "sortable-swap-highlight"
    };
  }
  return m.prototype = {
    dragStart: function(ie) {
      var we = ie.dragEl;
      lastSwapEl = we;
    },
    dragOverValid: function(ie) {
      var we = ie.completed, $e = ie.target, Me = ie.onMove, Ze = ie.activeSortable, ne = ie.changed, rr = ie.cancel;
      if (!!Ze.options.swap) {
        var gr = this.sortable.el, or = this.options;
        if ($e && $e !== gr) {
          var _r = lastSwapEl;
          Me($e) !== !1 ? (toggleClass($e, or.swapClass, !0), lastSwapEl = $e) : lastSwapEl = null, _r && _r !== lastSwapEl && toggleClass(_r, or.swapClass, !1);
        }
        ne(), we(!0), rr();
      }
    },
    drop: function(ie) {
      var we = ie.activeSortable, $e = ie.putSortable, Me = ie.dragEl, Ze = $e || this.sortable, ne = this.options;
      lastSwapEl && toggleClass(lastSwapEl, ne.swapClass, !1), lastSwapEl && (ne.swap || $e && $e.options.swap) && Me !== lastSwapEl && (Ze.captureAnimationState(), Ze !== we && we.captureAnimationState(), swapNodes(Me, lastSwapEl), Ze.animateAll(), Ze !== we && we.animateAll());
    },
    nulling: function() {
      lastSwapEl = null;
    }
  }, _extends(m, {
    pluginName: "swap",
    eventProperties: function() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}
function swapNodes(m, c) {
  var ie = m.parentNode, we = c.parentNode, $e, Me;
  !ie || !we || ie.isEqualNode(c) || we.isEqualNode(m) || ($e = index(m), Me = index(c), ie.isEqualNode(we) && $e < Me && Me++, ie.insertBefore(c, ie.children[$e]), we.insertBefore(m, we.children[Me]));
}
var multiDragElements = [], multiDragClones = [], lastMultiDragSelect, multiDragSortable, initialFolding = !1, folding = !1, dragStarted = !1, dragEl$1, clonesFromRect, clonesHidden;
function MultiDragPlugin() {
  function m(c) {
    for (var ie in this)
      ie.charAt(0) === "_" && typeof this[ie] == "function" && (this[ie] = this[ie].bind(this));
    c.options.avoidImplicitDeselect || (c.options.supportPointer ? on(document, "pointerup", this._deselectMultiDrag) : (on(document, "mouseup", this._deselectMultiDrag), on(document, "touchend", this._deselectMultiDrag))), on(document, "keydown", this._checkKeyDown), on(document, "keyup", this._checkKeyUp), this.defaults = {
      selectedClass: "sortable-selected",
      multiDragKey: null,
      avoidImplicitDeselect: !1,
      setData: function($e, Me) {
        var Ze = "";
        multiDragElements.length && multiDragSortable === c ? multiDragElements.forEach(function(ne, rr) {
          Ze += (rr ? ", " : "") + ne.textContent;
        }) : Ze = Me.textContent, $e.setData("Text", Ze);
      }
    };
  }
  return m.prototype = {
    multiDragKeyDown: !1,
    isMultiDrag: !1,
    delayStartGlobal: function(ie) {
      var we = ie.dragEl;
      dragEl$1 = we;
    },
    delayEnded: function() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function(ie) {
      var we = ie.sortable, $e = ie.cancel;
      if (!!this.isMultiDrag) {
        for (var Me = 0; Me < multiDragElements.length; Me++)
          multiDragClones.push(clone(multiDragElements[Me])), multiDragClones[Me].sortableIndex = multiDragElements[Me].sortableIndex, multiDragClones[Me].draggable = !1, multiDragClones[Me].style["will-change"] = "", toggleClass(multiDragClones[Me], this.options.selectedClass, !1), multiDragElements[Me] === dragEl$1 && toggleClass(multiDragClones[Me], this.options.chosenClass, !1);
        we._hideClone(), $e();
      }
    },
    clone: function(ie) {
      var we = ie.sortable, $e = ie.rootEl, Me = ie.dispatchSortableEvent, Ze = ie.cancel;
      !this.isMultiDrag || this.options.removeCloneOnHide || multiDragElements.length && multiDragSortable === we && (insertMultiDragClones(!0, $e), Me("clone"), Ze());
    },
    showClone: function(ie) {
      var we = ie.cloneNowShown, $e = ie.rootEl, Me = ie.cancel;
      !this.isMultiDrag || (insertMultiDragClones(!1, $e), multiDragClones.forEach(function(Ze) {
        css$1(Ze, "display", "");
      }), we(), clonesHidden = !1, Me());
    },
    hideClone: function(ie) {
      var we = this;
      ie.sortable;
      var $e = ie.cloneNowHidden, Me = ie.cancel;
      !this.isMultiDrag || (multiDragClones.forEach(function(Ze) {
        css$1(Ze, "display", "none"), we.options.removeCloneOnHide && Ze.parentNode && Ze.parentNode.removeChild(Ze);
      }), $e(), clonesHidden = !0, Me());
    },
    dragStartGlobal: function(ie) {
      ie.sortable, !this.isMultiDrag && multiDragSortable && multiDragSortable.multiDrag._deselectMultiDrag(), multiDragElements.forEach(function(we) {
        we.sortableIndex = index(we);
      }), multiDragElements = multiDragElements.sort(function(we, $e) {
        return we.sortableIndex - $e.sortableIndex;
      }), dragStarted = !0;
    },
    dragStarted: function(ie) {
      var we = this, $e = ie.sortable;
      if (!!this.isMultiDrag) {
        if (this.options.sort && ($e.captureAnimationState(), this.options.animation)) {
          multiDragElements.forEach(function(Ze) {
            Ze !== dragEl$1 && css$1(Ze, "position", "absolute");
          });
          var Me = getRect(dragEl$1, !1, !0, !0);
          multiDragElements.forEach(function(Ze) {
            Ze !== dragEl$1 && setRect(Ze, Me);
          }), folding = !0, initialFolding = !0;
        }
        $e.animateAll(function() {
          folding = !1, initialFolding = !1, we.options.animation && multiDragElements.forEach(function(Ze) {
            unsetRect(Ze);
          }), we.options.sort && removeMultiDragElements();
        });
      }
    },
    dragOver: function(ie) {
      var we = ie.target, $e = ie.completed, Me = ie.cancel;
      folding && ~multiDragElements.indexOf(we) && ($e(!1), Me());
    },
    revert: function(ie) {
      var we = ie.fromSortable, $e = ie.rootEl, Me = ie.sortable, Ze = ie.dragRect;
      multiDragElements.length > 1 && (multiDragElements.forEach(function(ne) {
        Me.addAnimationState({
          target: ne,
          rect: folding ? getRect(ne) : Ze
        }), unsetRect(ne), ne.fromRect = Ze, we.removeAnimationState(ne);
      }), folding = !1, insertMultiDragElements(!this.options.removeCloneOnHide, $e));
    },
    dragOverCompleted: function(ie) {
      var we = ie.sortable, $e = ie.isOwner, Me = ie.insertion, Ze = ie.activeSortable, ne = ie.parentEl, rr = ie.putSortable, gr = this.options;
      if (Me) {
        if ($e && Ze._hideClone(), initialFolding = !1, gr.animation && multiDragElements.length > 1 && (folding || !$e && !Ze.options.sort && !rr)) {
          var or = getRect(dragEl$1, !1, !0, !0);
          multiDragElements.forEach(function(Lr) {
            Lr !== dragEl$1 && (setRect(Lr, or), ne.appendChild(Lr));
          }), folding = !0;
        }
        if (!$e)
          if (folding || removeMultiDragElements(), multiDragElements.length > 1) {
            var _r = clonesHidden;
            Ze._showClone(we), Ze.options.animation && !clonesHidden && _r && multiDragClones.forEach(function(Lr) {
              Ze.addAnimationState({
                target: Lr,
                rect: clonesFromRect
              }), Lr.fromRect = clonesFromRect, Lr.thisAnimationDuration = null;
            });
          } else
            Ze._showClone(we);
      }
    },
    dragOverAnimationCapture: function(ie) {
      var we = ie.dragRect, $e = ie.isOwner, Me = ie.activeSortable;
      if (multiDragElements.forEach(function(ne) {
        ne.thisAnimationDuration = null;
      }), Me.options.animation && !$e && Me.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, we);
        var Ze = matrix(dragEl$1, !0);
        clonesFromRect.top -= Ze.f, clonesFromRect.left -= Ze.e;
      }
    },
    dragOverAnimationComplete: function() {
      folding && (folding = !1, removeMultiDragElements());
    },
    drop: function(ie) {
      var we = ie.originalEvent, $e = ie.rootEl, Me = ie.parentEl, Ze = ie.sortable, ne = ie.dispatchSortableEvent, rr = ie.oldIndex, gr = ie.putSortable, or = gr || this.sortable;
      if (!!we) {
        var _r = this.options, Lr = Me.children;
        if (!dragStarted)
          if (_r.multiDragKey && !this.multiDragKeyDown && this._deselectMultiDrag(), toggleClass(dragEl$1, _r.selectedClass, !~multiDragElements.indexOf(dragEl$1)), ~multiDragElements.indexOf(dragEl$1))
            multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1), lastMultiDragSelect = null, dispatchEvent({
              sortable: Ze,
              rootEl: $e,
              name: "deselect",
              targetEl: dragEl$1,
              originalEvent: we
            });
          else {
            if (multiDragElements.push(dragEl$1), dispatchEvent({
              sortable: Ze,
              rootEl: $e,
              name: "select",
              targetEl: dragEl$1,
              originalEvent: we
            }), we.shiftKey && lastMultiDragSelect && Ze.el.contains(lastMultiDragSelect)) {
              var Ir = index(lastMultiDragSelect), Ar = index(dragEl$1);
              ~Ir && ~Ar && Ir !== Ar && function() {
                var Vr, Xr;
                Ar > Ir ? (Xr = Ir, Vr = Ar) : (Xr = Ar, Vr = Ir + 1);
                for (var Wr = _r.filter; Xr < Vr; Xr++)
                  if (!~multiDragElements.indexOf(Lr[Xr]) && !!closest(Lr[Xr], _r.draggable, Me, !1)) {
                    var si = Wr && (typeof Wr == "function" ? Wr.call(Ze, we, Lr[Xr], Ze) : Wr.split(",").some(function(li) {
                      return closest(Lr[Xr], li.trim(), Me, !1);
                    }));
                    si || (toggleClass(Lr[Xr], _r.selectedClass, !0), multiDragElements.push(Lr[Xr]), dispatchEvent({
                      sortable: Ze,
                      rootEl: $e,
                      name: "select",
                      targetEl: Lr[Xr],
                      originalEvent: we
                    }));
                  }
              }();
            } else
              lastMultiDragSelect = dragEl$1;
            multiDragSortable = or;
          }
        if (dragStarted && this.isMultiDrag) {
          if (folding = !1, (Me[expando].options.sort || Me !== $e) && multiDragElements.length > 1) {
            var Rr = getRect(dragEl$1), Nr = index(dragEl$1, ":not(." + this.options.selectedClass + ")");
            if (!initialFolding && _r.animation && (dragEl$1.thisAnimationDuration = null), or.captureAnimationState(), !initialFolding && (_r.animation && (dragEl$1.fromRect = Rr, multiDragElements.forEach(function(Vr) {
              if (Vr.thisAnimationDuration = null, Vr !== dragEl$1) {
                var Xr = folding ? getRect(Vr) : Rr;
                Vr.fromRect = Xr, or.addAnimationState({
                  target: Vr,
                  rect: Xr
                });
              }
            })), removeMultiDragElements(), multiDragElements.forEach(function(Vr) {
              Lr[Nr] ? Me.insertBefore(Vr, Lr[Nr]) : Me.appendChild(Vr), Nr++;
            }), rr === index(dragEl$1))) {
              var Yr = !1;
              multiDragElements.forEach(function(Vr) {
                if (Vr.sortableIndex !== index(Vr)) {
                  Yr = !0;
                  return;
                }
              }), Yr && (ne("update"), ne("sort"));
            }
            multiDragElements.forEach(function(Vr) {
              unsetRect(Vr);
            }), or.animateAll();
          }
          multiDragSortable = or;
        }
        ($e === Me || gr && gr.lastPutMode !== "clone") && multiDragClones.forEach(function(Vr) {
          Vr.parentNode && Vr.parentNode.removeChild(Vr);
        });
      }
    },
    nullingGlobal: function() {
      this.isMultiDrag = dragStarted = !1, multiDragClones.length = 0;
    },
    destroyGlobal: function() {
      this._deselectMultiDrag(), off(document, "pointerup", this._deselectMultiDrag), off(document, "mouseup", this._deselectMultiDrag), off(document, "touchend", this._deselectMultiDrag), off(document, "keydown", this._checkKeyDown), off(document, "keyup", this._checkKeyUp);
    },
    _deselectMultiDrag: function(ie) {
      if (!(typeof dragStarted < "u" && dragStarted) && multiDragSortable === this.sortable && !(ie && closest(ie.target, this.options.draggable, this.sortable.el, !1)) && !(ie && ie.button !== 0))
        for (; multiDragElements.length; ) {
          var we = multiDragElements[0];
          toggleClass(we, this.options.selectedClass, !1), multiDragElements.shift(), dispatchEvent({
            sortable: this.sortable,
            rootEl: this.sortable.el,
            name: "deselect",
            targetEl: we,
            originalEvent: ie
          });
        }
    },
    _checkKeyDown: function(ie) {
      ie.key === this.options.multiDragKey && (this.multiDragKeyDown = !0);
    },
    _checkKeyUp: function(ie) {
      ie.key === this.options.multiDragKey && (this.multiDragKeyDown = !1);
    }
  }, _extends(m, {
    pluginName: "multiDrag",
    utils: {
      select: function(ie) {
        var we = ie.parentNode[expando];
        !we || !we.options.multiDrag || ~multiDragElements.indexOf(ie) || (multiDragSortable && multiDragSortable !== we && (multiDragSortable.multiDrag._deselectMultiDrag(), multiDragSortable = we), toggleClass(ie, we.options.selectedClass, !0), multiDragElements.push(ie));
      },
      deselect: function(ie) {
        var we = ie.parentNode[expando], $e = multiDragElements.indexOf(ie);
        !we || !we.options.multiDrag || !~$e || (toggleClass(ie, we.options.selectedClass, !1), multiDragElements.splice($e, 1));
      }
    },
    eventProperties: function() {
      var ie = this, we = [], $e = [];
      return multiDragElements.forEach(function(Me) {
        we.push({
          multiDragElement: Me,
          index: Me.sortableIndex
        });
        var Ze;
        folding && Me !== dragEl$1 ? Ze = -1 : folding ? Ze = index(Me, ":not(." + ie.options.selectedClass + ")") : Ze = index(Me), $e.push({
          multiDragElement: Me,
          index: Ze
        });
      }), {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: we,
        newIndicies: $e
      };
    },
    optionListeners: {
      multiDragKey: function(ie) {
        return ie = ie.toLowerCase(), ie === "ctrl" ? ie = "Control" : ie.length > 1 && (ie = ie.charAt(0).toUpperCase() + ie.substr(1)), ie;
      }
    }
  });
}
function insertMultiDragElements(m, c) {
  multiDragElements.forEach(function(ie, we) {
    var $e = c.children[ie.sortableIndex + (m ? Number(we) : 0)];
    $e ? c.insertBefore(ie, $e) : c.appendChild(ie);
  });
}
function insertMultiDragClones(m, c) {
  multiDragClones.forEach(function(ie, we) {
    var $e = c.children[ie.sortableIndex + (m ? Number(we) : 0)];
    $e ? c.insertBefore(ie, $e) : c.appendChild(ie);
  });
}
function removeMultiDragElements() {
  multiDragElements.forEach(function(m) {
    m !== dragEl$1 && m.parentNode && m.parentNode.removeChild(m);
  });
}
Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);
Sortable.mount(new SwapPlugin());
Sortable.mount(new MultiDragPlugin());
const fieldWeights = {
  Image: 1,
  Checkbox: 0.2,
  Text: 1,
  HighlightedText: 1,
  Select: 1,
  Group: 1,
  ImageAdjust: 1,
  Color: 1,
  Number: 1,
  Map: 1,
  Collection: 1,
  ImageEdit: 1,
  SelectColor: 1,
  SelectImage: 1,
  SelectText: 1,
  Instruction: 1
};
function flattenFields(m) {
  const c = [];
  function ie(we, $e) {
    let Me = 1;
    for (const Ze of we)
      if (Ze.type === "Group")
        ie(Ze.props.fields, Ze);
      else {
        const ne = fieldWeights[Ze.type] ?? 1;
        ne + Me <= 1 ? (c[c.length - 1].fields.push(Ze), Me += ne) : (c.push({
          fields: [Ze],
          originalField: $e
        }), Me = ne);
      }
  }
  return ie(m), c;
}
function flattenFieldTable(m) {
  const c = [];
  function ie(we, $e) {
    for (const Me of we)
      Me.type === "Group" ? ie(Me.props.fields) : c.push(Me);
  }
  return ie(m), c;
}
function useMobileFields(m) {
  return {
    mobileFields: computed(() => (console.log("fields.value", m.value), flattenFields(m.value).map((ie) => ({
      originalField: ie.originalField,
      fields: ie.fields
    }))))
  };
}
function useFields(m) {
  const c = inject("data"), ie = inject("bridge");
  ie || console.error("bridge is not provided");
  const we = inject("computedPropEvaluator");
  we || console.error("computedPropEvaluator is not provided");
  const $e = (Ze) => ({
    ...Object.fromEntries(
      Object.entries(Ze).map(([rr, gr]) => [rr, c.value ? c.value[gr] : void 0])
    ),
    ...Object.fromEntries(
      Object.entries(Ze).map(([rr]) => [
        `onUpdate:${rr}`,
        (gr) => {
          if (!c.value) {
            console.error("data is not provided");
            return;
          }
          c.value[Ze[rr]] = gr;
        }
      ])
    )
  });
  function Me(Ze) {
    return Object.fromEntries(
      Object.entries(Ze).map(([ne, rr]) => typeof rr == "function" ? [ne, we(rr)] : [ne, rr])
    );
  }
  return {
    fields: m,
    data: c,
    bridge: ie,
    modelField: $e,
    wrapFieldProps: Me
  };
}
function getFieldDescription(m) {
  if (m.description)
    return m.description;
  switch (m.type) {
    case "ImageAdjust":
      return m.model.image;
    case "Group":
      return getFieldsDescription(m.props.fields);
    case "Instruction":
      return typeof m.props.instruction == "function" ? m.props.instruction() : m.props.instruction;
    case "ImageEdit":
      return m.model.modelValue;
    default:
      return m.model.modelValue;
  }
}
function getFieldsDescription(m) {
  return m.map(getFieldDescription).join(", ");
}
function renderFieldIcon(m, c, ie = {}) {
  return h$1(
    BxIcon,
    {
      style: {
        color: c ? "rgba(var(--primary-color-base), 1)" : "inherit",
        ...ie
      }
    },
    () => h$1(
      (() => {
        switch (m) {
          case "Text":
            return TextOutline;
          case "HighlightedText":
            return TextOutline;
          case "Image":
            return ImageOutline;
          case "Checkbox":
            return CheckmarkCircleOutline;
          case "ImageAdjust":
            return CropOutline;
          case "Select":
            return ListOutline;
          case "Number":
            return OptionsOutline;
          case "Color":
            return EyedropOutline;
          case "Group":
            return FolderOutline;
          case "Map":
            return MapOutline;
          case "Collection":
            return ListOutline;
          case "ImageEdit":
            return ImageOutline;
          case "SelectColor":
            return ColorPaletteOutline;
          case "SelectImage":
            return ImageOutline;
          case "SelectText":
            return TextOutline;
          case "Instruction":
            return InformationCircleOutline;
          default:
            return AppsOutline;
        }
      })()
    )
  );
}
function getDefaultValueForFieldModel(m, c) {
  return m.type === "Text" ? m.props.richtext.enabled ? [{ text: "hello world", format: {} }] : "hello world" : m.type === "HighlightedText" ? [{ text: "hello world", format: {} }] : m.type === "Checkbox" ? !1 : m.type === "Image" ? "https://imagedelivery.net/mudX-CmAqIANL8bxoNCToA/0ef44222-cec4-41a9-fa4b-deb327addf00/draftThumb" : m.type === "ImageEdit" ? {
    src: "https://imagedelivery.net/mudX-CmAqIANL8bxoNCToA/0ef44222-cec4-41a9-fa4b-deb327addf00/draftThumb",
    innerPos: [0, 0],
    scale: 1,
    innerRotate: 0
  } : m.type === "Group" ? {} : m.type === "Collection" ? [] : m.type === "ImageAdjust" ? c === "image" ? "https://imagedelivery.net/mudX-CmAqIANL8bxoNCToA/0ef44222-cec4-41a9-fa4b-deb327addf00/draftThumb" : {
    scale: 1,
    innerPos: [0, 0]
  } : m.type === "Select" ? m.props.options[0].value : m.type === "SelectImage" ? {
    src: "https://imagedelivery.net/mudX-CmAqIANL8bxoNCToA/0ef44222-cec4-41a9-fa4b-deb327addf00/draftThumb",
    innerPos: [0, 0],
    scale: 1,
    innerRotate: 0
  } : m.type === "SelectColor" ? "#ff0000" : m.type === "SelectText" ? "hello world" : null;
}
function realizeField(m) {
  return {
    ...m,
    props: Object.fromEntries(
      Object.entries(m.props).map(([c, ie]) => {
        if (ie?.__type__ === "function") {
          const [we] = ie.__value__.match(/function anonymous\(\s*\) {\s*return /) ?? [];
          let $e = ie.__value__.slice(we.length, -1);
          for (; $e.lastIndexOf(`
`) > -1; )
            $e.lastIndexOf(`
`) === $e.length - 1 && ($e = $e.slice(0, -1));
          return [c, new Function(`return ${$e}`)];
        } else
          return [c, ie];
      })
    )
  };
}
function stringifyField(m) {
  return {
    ...m,
    props: Object.fromEntries(
      Object.entries(m.props).map(([c, ie]) => typeof ie == "function" ? [
        c,
        {
          __type__: "function",
          __value__: ie.toString()
        }
      ] : [c, ie])
    )
  };
}
const _hoisted_1$t = { class: "label" }, _hoisted_2$k = { class: "actions-right" }, _hoisted_3$c = { class: "actions" }, _sfc_main$C = /* @__PURE__ */ defineComponent({
  __name: "Collection",
  props: /* @__PURE__ */ mergeModels({
    layout: {},
    fields: {},
    description: {},
    detailedDescription: {},
    bridge: {},
    defaultValue: {},
    mobile: { type: Boolean, default: !1 },
    min: { default: 0 },
    max: { default: 1 / 0 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = m, ie = ref$1(nanoid()), we = useModel(m, "modelValue"), $e = ref$1();
    onMounted(() => {
      !$e.value || Sortable.create($e.value, {
        animation: 500,
        handle: ".drag-btn",
        preventOnFilter: !0,
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        onUpdate: function(Ar) {
          gr(Ar.oldIndex, Ar.newIndex);
        }
      });
    });
    const Me = ref$1((we.value ?? []).map(() => !1));
    Me.value[0] = !0, (we.value === void 0 || we.value === null) && (we.value = []);
    function Ze() {
      if (Lr.value)
        return;
      const Ar = Object.fromEntries(
        c.fields.map((Rr) => Object.entries(Rr.model).map(([Nr, Yr]) => c.defaultValue && Yr in c.defaultValue ? [Yr, c.defaultValue[Yr]] : [Yr, getDefaultValueForFieldModel(Rr, Nr)])).flat()
      );
      we.value = [...we.value ?? [], _$1.cloneDeep(we.value[0] ?? Ar)], Me.value = [...Me.value.map(() => !1), !0];
    }
    function ne(Ar, Rr) {
      we.value[Ar] = Rr;
    }
    function rr(Ar) {
      Ir.value || (we.value = we.value.filter((Rr, Nr) => Nr !== Ar), Me.value.splice(Ar, 1));
    }
    function gr(Ar, Rr) {
      const Nr = we.value[Ar];
      we.value.splice(Ar, 1), we.value.splice(Rr, 0, Nr);
      const Yr = Me.value[Ar];
      Me.value.splice(Ar, 1), Me.value.splice(Rr, 0, Yr), ie.value = nanoid();
    }
    function or(Ar) {
      if (Me.value[Ar] = !Me.value[Ar], Me.value[Ar])
        for (let Rr = 0; Rr < Me.value.length; Rr++)
          Rr !== Ar && (Me.value[Rr] = !1);
    }
    function _r(Ar) {
      const Rr = we.value.indexOf(Ar), Nr = c.fields.find((Yr) => Yr.type === "Text");
      return Nr ? Ar[Nr.model.modelValue] ?? `Entry ${Rr + 1}` : `Entry ${Rr + 1}`;
    }
    const Lr = computed(() => we.value instanceof Array ? we.value.length >= c.max : !1), Ir = computed(() => we.value instanceof Array ? we.value.length <= c.min : !1);
    return (Ar, Rr) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["collection-field", { mobile: Ar.mobile }])
    }, [
      createElementVNode("div", {
        ref_key: "entriesListRef",
        ref: $e,
        class: "entries-list"
      }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(we.value, (Nr, Yr) => (openBlock(), createBlock(BxCard, {
          key: Yr + ie.value
        }, createSlots({
          header: withCtx(() => [
            createVNode(BxIcon, { class: "drag-btn swiper-no-swiping" }, {
              default: withCtx(() => [
                createVNode(unref(MenuOutline))
              ]),
              _: 1
            }),
            createElementVNode("div", _hoisted_1$t, toDisplayString(_r(Nr)), 1),
            createElementVNode("div", _hoisted_2$k, [
              createVNode(BxButton, {
                circle: "",
                size: "small",
                tertiary: "",
                onClick: (Vr) => or(Yr)
              }, {
                icon: withCtx(() => [
                  createVNode(BxIcon, null, {
                    default: withCtx(() => [
                      Me.value[Yr] ? (openBlock(), createBlock(unref(ChevronDownOutline), { key: 0 })) : (openBlock(), createBlock(unref(ChevronUpOutline), { key: 1 }))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              createVNode(BxButton, {
                circle: "",
                size: "small",
                tertiary: "",
                disabled: Ir.value,
                onClick: (Vr) => rr(Yr)
              }, {
                icon: withCtx(() => [
                  createVNode(BxIcon, null, {
                    default: withCtx(() => [
                      createVNode(unref(CloseOutline))
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ])
          ]),
          _: 2
        }, [
          Me.value[Yr] ? {
            name: "default",
            fn: withCtx(() => [
              createElementVNode("main", null, [
                createVNode(_sfc_main$D, {
                  data: Nr,
                  "onUpdate:data": (Vr) => ne(Yr, Vr),
                  fields: Ar.fields,
                  bridge: Ar.bridge,
                  layout: Ar.layout
                }, null, 8, ["data", "onUpdate:data", "fields", "bridge", "layout"])
              ])
            ]),
            key: "0"
          } : void 0
        ]), 1024))), 128))
      ], 512),
      createElementVNode("div", _hoisted_3$c, [
        createVNode(BxButton, {
          disabled: Lr.value,
          centered: "",
          onClick: Ze
        }, {
          icon: withCtx(() => [
            createVNode(BxIcon, null, {
              default: withCtx(() => [
                createVNode(unref(AddOutline))
              ]),
              _: 1
            })
          ]),
          default: withCtx(() => [
            Rr[0] || (Rr[0] = createTextVNode(" Add entry "))
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 2));
  }
}), Collection_vue_vue_type_style_index_0_scoped_b308de50_lang = "", Collection = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["__scopeId", "data-v-b308de50"]]);
var mapboxGl = { exports: {} };
(function(m, c) {
  (function(ie, we) {
    m.exports = we();
  })(commonjsGlobal, function() {
    var ie, we, $e;
    function Me(ne, rr) {
      if (!ie)
        ie = rr;
      else if (!we)
        we = rr;
      else {
        var gr = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + ie + ")(sharedChunk); (" + we + ")(sharedChunk); self.onerror = null;", or = {};
        ie(or), $e = rr(or), typeof window < "u" && window && window.URL && window.URL.createObjectURL && ($e.workerUrl = window.URL.createObjectURL(new Blob([gr], { type: "text/javascript" })));
      }
    }
    Me(["exports"], function(ne) {
      function rr(Ie) {
        return Ie && Ie.__esModule && Object.prototype.hasOwnProperty.call(Ie, "default") ? Ie.default : Ie;
      }
      var gr, or = {}, _r = {};
      function Lr() {
        if (gr)
          return _r;
        gr = 1, Object.defineProperty(_r, "__esModule", { value: !0 }), _r.setMatrixArrayType = function(Ke) {
          _r.ARRAY_TYPE = de = Ke;
        }, _r.toRadian = function(Ke) {
          return Ke * De;
        }, _r.equals = function(Ke, Ve) {
          return Math.abs(Ke - Ve) <= Ie * Math.max(1, Math.abs(Ke), Math.abs(Ve));
        }, _r.RANDOM = _r.ARRAY_TYPE = _r.EPSILON = void 0;
        var Ie = 1e-6;
        _r.EPSILON = Ie;
        var de = typeof Float32Array < "u" ? Float32Array : Array;
        _r.ARRAY_TYPE = de;
        var Ce = Math.random;
        _r.RANDOM = Ce;
        var De = Math.PI / 180;
        return Math.hypot || (Math.hypot = function() {
          for (var Ke = 0, Ve = arguments.length; Ve--; )
            Ke += arguments[Ve] * arguments[Ve];
          return Math.sqrt(Ke);
        }), _r;
      }
      var Ir, Ar = {};
      function Rr() {
        if (Ir)
          return Ar;
        function Ie(Ve) {
          return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(er) {
            return typeof er;
          } : function(er) {
            return er && typeof Symbol == "function" && er.constructor === Symbol && er !== Symbol.prototype ? "symbol" : typeof er;
          }, Ie(Ve);
        }
        Ir = 1, Object.defineProperty(Ar, "__esModule", { value: !0 }), Ar.create = function() {
          var Ve = new de.ARRAY_TYPE(4);
          return de.ARRAY_TYPE != Float32Array && (Ve[1] = 0, Ve[2] = 0), Ve[0] = 1, Ve[3] = 1, Ve;
        }, Ar.clone = function(Ve) {
          var er = new de.ARRAY_TYPE(4);
          return er[0] = Ve[0], er[1] = Ve[1], er[2] = Ve[2], er[3] = Ve[3], er;
        }, Ar.copy = function(Ve, er) {
          return Ve[0] = er[0], Ve[1] = er[1], Ve[2] = er[2], Ve[3] = er[3], Ve;
        }, Ar.identity = function(Ve) {
          return Ve[0] = 1, Ve[1] = 0, Ve[2] = 0, Ve[3] = 1, Ve;
        }, Ar.fromValues = function(Ve, er, fr, wr) {
          var kr = new de.ARRAY_TYPE(4);
          return kr[0] = Ve, kr[1] = er, kr[2] = fr, kr[3] = wr, kr;
        }, Ar.set = function(Ve, er, fr, wr, kr) {
          return Ve[0] = er, Ve[1] = fr, Ve[2] = wr, Ve[3] = kr, Ve;
        }, Ar.transpose = function(Ve, er) {
          if (Ve === er) {
            var fr = er[1];
            Ve[1] = er[2], Ve[2] = fr;
          } else
            Ve[0] = er[0], Ve[1] = er[2], Ve[2] = er[1], Ve[3] = er[3];
          return Ve;
        }, Ar.invert = function(Ve, er) {
          var fr = er[0], wr = er[1], kr = er[2], cr = er[3], Mr = fr * cr - kr * wr;
          return Mr ? (Ve[0] = cr * (Mr = 1 / Mr), Ve[1] = -wr * Mr, Ve[2] = -kr * Mr, Ve[3] = fr * Mr, Ve) : null;
        }, Ar.adjoint = function(Ve, er) {
          var fr = er[0];
          return Ve[0] = er[3], Ve[1] = -er[1], Ve[2] = -er[2], Ve[3] = fr, Ve;
        }, Ar.determinant = function(Ve) {
          return Ve[0] * Ve[3] - Ve[2] * Ve[1];
        }, Ar.multiply = De, Ar.rotate = function(Ve, er, fr) {
          var wr = er[0], kr = er[1], cr = er[2], Mr = er[3], Er = Math.sin(fr), xr = Math.cos(fr);
          return Ve[0] = wr * xr + cr * Er, Ve[1] = kr * xr + Mr * Er, Ve[2] = wr * -Er + cr * xr, Ve[3] = kr * -Er + Mr * xr, Ve;
        }, Ar.scale = function(Ve, er, fr) {
          var wr = er[1], kr = er[2], cr = er[3], Mr = fr[0], Er = fr[1];
          return Ve[0] = er[0] * Mr, Ve[1] = wr * Mr, Ve[2] = kr * Er, Ve[3] = cr * Er, Ve;
        }, Ar.fromRotation = function(Ve, er) {
          var fr = Math.sin(er), wr = Math.cos(er);
          return Ve[0] = wr, Ve[1] = fr, Ve[2] = -fr, Ve[3] = wr, Ve;
        }, Ar.fromScaling = function(Ve, er) {
          return Ve[0] = er[0], Ve[1] = 0, Ve[2] = 0, Ve[3] = er[1], Ve;
        }, Ar.str = function(Ve) {
          return "mat2(" + Ve[0] + ", " + Ve[1] + ", " + Ve[2] + ", " + Ve[3] + ")";
        }, Ar.frob = function(Ve) {
          return Math.hypot(Ve[0], Ve[1], Ve[2], Ve[3]);
        }, Ar.LDU = function(Ve, er, fr, wr) {
          return Ve[2] = wr[2] / wr[0], fr[0] = wr[0], fr[1] = wr[1], fr[3] = wr[3] - Ve[2] * fr[1], [Ve, er, fr];
        }, Ar.add = function(Ve, er, fr) {
          return Ve[0] = er[0] + fr[0], Ve[1] = er[1] + fr[1], Ve[2] = er[2] + fr[2], Ve[3] = er[3] + fr[3], Ve;
        }, Ar.subtract = Ke, Ar.exactEquals = function(Ve, er) {
          return Ve[0] === er[0] && Ve[1] === er[1] && Ve[2] === er[2] && Ve[3] === er[3];
        }, Ar.equals = function(Ve, er) {
          var fr = Ve[0], wr = Ve[1], kr = Ve[2], cr = Ve[3], Mr = er[0], Er = er[1], xr = er[2], Sr = er[3];
          return Math.abs(fr - Mr) <= de.EPSILON * Math.max(1, Math.abs(fr), Math.abs(Mr)) && Math.abs(wr - Er) <= de.EPSILON * Math.max(1, Math.abs(wr), Math.abs(Er)) && Math.abs(kr - xr) <= de.EPSILON * Math.max(1, Math.abs(kr), Math.abs(xr)) && Math.abs(cr - Sr) <= de.EPSILON * Math.max(1, Math.abs(cr), Math.abs(Sr));
        }, Ar.multiplyScalar = function(Ve, er, fr) {
          return Ve[0] = er[0] * fr, Ve[1] = er[1] * fr, Ve[2] = er[2] * fr, Ve[3] = er[3] * fr, Ve;
        }, Ar.multiplyScalarAndAdd = function(Ve, er, fr, wr) {
          return Ve[0] = er[0] + fr[0] * wr, Ve[1] = er[1] + fr[1] * wr, Ve[2] = er[2] + fr[2] * wr, Ve[3] = er[3] + fr[3] * wr, Ve;
        }, Ar.sub = Ar.mul = void 0;
        var de = function(Ve, er) {
          if (Ve && Ve.__esModule)
            return Ve;
          if (Ve === null || Ie(Ve) !== "object" && typeof Ve != "function")
            return { default: Ve };
          var fr = Ce(void 0);
          if (fr && fr.has(Ve))
            return fr.get(Ve);
          var wr = {}, kr = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var cr in Ve)
            if (cr !== "default" && Object.prototype.hasOwnProperty.call(Ve, cr)) {
              var Mr = kr ? Object.getOwnPropertyDescriptor(Ve, cr) : null;
              Mr && (Mr.get || Mr.set) ? Object.defineProperty(wr, cr, Mr) : wr[cr] = Ve[cr];
            }
          return wr.default = Ve, fr && fr.set(Ve, wr), wr;
        }(Lr());
        function Ce(Ve) {
          if (typeof WeakMap != "function")
            return null;
          var er = /* @__PURE__ */ new WeakMap(), fr = /* @__PURE__ */ new WeakMap();
          return (Ce = function(wr) {
            return wr ? fr : er;
          })(Ve);
        }
        function De(Ve, er, fr) {
          var wr = er[0], kr = er[1], cr = er[2], Mr = er[3], Er = fr[0], xr = fr[1], Sr = fr[2], Br = fr[3];
          return Ve[0] = wr * Er + cr * xr, Ve[1] = kr * Er + Mr * xr, Ve[2] = wr * Sr + cr * Br, Ve[3] = kr * Sr + Mr * Br, Ve;
        }
        function Ke(Ve, er, fr) {
          return Ve[0] = er[0] - fr[0], Ve[1] = er[1] - fr[1], Ve[2] = er[2] - fr[2], Ve[3] = er[3] - fr[3], Ve;
        }
        return Ar.mul = De, Ar.sub = Ke, Ar;
      }
      var Nr, Yr = {};
      function Vr() {
        if (Nr)
          return Yr;
        function Ie(Ve) {
          return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(er) {
            return typeof er;
          } : function(er) {
            return er && typeof Symbol == "function" && er.constructor === Symbol && er !== Symbol.prototype ? "symbol" : typeof er;
          }, Ie(Ve);
        }
        Nr = 1, Object.defineProperty(Yr, "__esModule", { value: !0 }), Yr.create = function() {
          var Ve = new de.ARRAY_TYPE(6);
          return de.ARRAY_TYPE != Float32Array && (Ve[1] = 0, Ve[2] = 0, Ve[4] = 0, Ve[5] = 0), Ve[0] = 1, Ve[3] = 1, Ve;
        }, Yr.clone = function(Ve) {
          var er = new de.ARRAY_TYPE(6);
          return er[0] = Ve[0], er[1] = Ve[1], er[2] = Ve[2], er[3] = Ve[3], er[4] = Ve[4], er[5] = Ve[5], er;
        }, Yr.copy = function(Ve, er) {
          return Ve[0] = er[0], Ve[1] = er[1], Ve[2] = er[2], Ve[3] = er[3], Ve[4] = er[4], Ve[5] = er[5], Ve;
        }, Yr.identity = function(Ve) {
          return Ve[0] = 1, Ve[1] = 0, Ve[2] = 0, Ve[3] = 1, Ve[4] = 0, Ve[5] = 0, Ve;
        }, Yr.fromValues = function(Ve, er, fr, wr, kr, cr) {
          var Mr = new de.ARRAY_TYPE(6);
          return Mr[0] = Ve, Mr[1] = er, Mr[2] = fr, Mr[3] = wr, Mr[4] = kr, Mr[5] = cr, Mr;
        }, Yr.set = function(Ve, er, fr, wr, kr, cr, Mr) {
          return Ve[0] = er, Ve[1] = fr, Ve[2] = wr, Ve[3] = kr, Ve[4] = cr, Ve[5] = Mr, Ve;
        }, Yr.invert = function(Ve, er) {
          var fr = er[0], wr = er[1], kr = er[2], cr = er[3], Mr = er[4], Er = er[5], xr = fr * cr - wr * kr;
          return xr ? (Ve[0] = cr * (xr = 1 / xr), Ve[1] = -wr * xr, Ve[2] = -kr * xr, Ve[3] = fr * xr, Ve[4] = (kr * Er - cr * Mr) * xr, Ve[5] = (wr * Mr - fr * Er) * xr, Ve) : null;
        }, Yr.determinant = function(Ve) {
          return Ve[0] * Ve[3] - Ve[1] * Ve[2];
        }, Yr.multiply = De, Yr.rotate = function(Ve, er, fr) {
          var wr = er[0], kr = er[1], cr = er[2], Mr = er[3], Er = er[4], xr = er[5], Sr = Math.sin(fr), Br = Math.cos(fr);
          return Ve[0] = wr * Br + cr * Sr, Ve[1] = kr * Br + Mr * Sr, Ve[2] = wr * -Sr + cr * Br, Ve[3] = kr * -Sr + Mr * Br, Ve[4] = Er, Ve[5] = xr, Ve;
        }, Yr.scale = function(Ve, er, fr) {
          var wr = er[1], kr = er[2], cr = er[3], Mr = er[4], Er = er[5], xr = fr[0], Sr = fr[1];
          return Ve[0] = er[0] * xr, Ve[1] = wr * xr, Ve[2] = kr * Sr, Ve[3] = cr * Sr, Ve[4] = Mr, Ve[5] = Er, Ve;
        }, Yr.translate = function(Ve, er, fr) {
          var wr = er[0], kr = er[1], cr = er[2], Mr = er[3], Er = er[4], xr = er[5], Sr = fr[0], Br = fr[1];
          return Ve[0] = wr, Ve[1] = kr, Ve[2] = cr, Ve[3] = Mr, Ve[4] = wr * Sr + cr * Br + Er, Ve[5] = kr * Sr + Mr * Br + xr, Ve;
        }, Yr.fromRotation = function(Ve, er) {
          var fr = Math.sin(er), wr = Math.cos(er);
          return Ve[0] = wr, Ve[1] = fr, Ve[2] = -fr, Ve[3] = wr, Ve[4] = 0, Ve[5] = 0, Ve;
        }, Yr.fromScaling = function(Ve, er) {
          return Ve[0] = er[0], Ve[1] = 0, Ve[2] = 0, Ve[3] = er[1], Ve[4] = 0, Ve[5] = 0, Ve;
        }, Yr.fromTranslation = function(Ve, er) {
          return Ve[0] = 1, Ve[1] = 0, Ve[2] = 0, Ve[3] = 1, Ve[4] = er[0], Ve[5] = er[1], Ve;
        }, Yr.str = function(Ve) {
          return "mat2d(" + Ve[0] + ", " + Ve[1] + ", " + Ve[2] + ", " + Ve[3] + ", " + Ve[4] + ", " + Ve[5] + ")";
        }, Yr.frob = function(Ve) {
          return Math.hypot(Ve[0], Ve[1], Ve[2], Ve[3], Ve[4], Ve[5], 1);
        }, Yr.add = function(Ve, er, fr) {
          return Ve[0] = er[0] + fr[0], Ve[1] = er[1] + fr[1], Ve[2] = er[2] + fr[2], Ve[3] = er[3] + fr[3], Ve[4] = er[4] + fr[4], Ve[5] = er[5] + fr[5], Ve;
        }, Yr.subtract = Ke, Yr.multiplyScalar = function(Ve, er, fr) {
          return Ve[0] = er[0] * fr, Ve[1] = er[1] * fr, Ve[2] = er[2] * fr, Ve[3] = er[3] * fr, Ve[4] = er[4] * fr, Ve[5] = er[5] * fr, Ve;
        }, Yr.multiplyScalarAndAdd = function(Ve, er, fr, wr) {
          return Ve[0] = er[0] + fr[0] * wr, Ve[1] = er[1] + fr[1] * wr, Ve[2] = er[2] + fr[2] * wr, Ve[3] = er[3] + fr[3] * wr, Ve[4] = er[4] + fr[4] * wr, Ve[5] = er[5] + fr[5] * wr, Ve;
        }, Yr.exactEquals = function(Ve, er) {
          return Ve[0] === er[0] && Ve[1] === er[1] && Ve[2] === er[2] && Ve[3] === er[3] && Ve[4] === er[4] && Ve[5] === er[5];
        }, Yr.equals = function(Ve, er) {
          var fr = Ve[0], wr = Ve[1], kr = Ve[2], cr = Ve[3], Mr = Ve[4], Er = Ve[5], xr = er[0], Sr = er[1], Br = er[2], Fr = er[3], jr = er[4], Qr = er[5];
          return Math.abs(fr - xr) <= de.EPSILON * Math.max(1, Math.abs(fr), Math.abs(xr)) && Math.abs(wr - Sr) <= de.EPSILON * Math.max(1, Math.abs(wr), Math.abs(Sr)) && Math.abs(kr - Br) <= de.EPSILON * Math.max(1, Math.abs(kr), Math.abs(Br)) && Math.abs(cr - Fr) <= de.EPSILON * Math.max(1, Math.abs(cr), Math.abs(Fr)) && Math.abs(Mr - jr) <= de.EPSILON * Math.max(1, Math.abs(Mr), Math.abs(jr)) && Math.abs(Er - Qr) <= de.EPSILON * Math.max(1, Math.abs(Er), Math.abs(Qr));
        }, Yr.sub = Yr.mul = void 0;
        var de = function(Ve, er) {
          if (Ve && Ve.__esModule)
            return Ve;
          if (Ve === null || Ie(Ve) !== "object" && typeof Ve != "function")
            return { default: Ve };
          var fr = Ce(void 0);
          if (fr && fr.has(Ve))
            return fr.get(Ve);
          var wr = {}, kr = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var cr in Ve)
            if (cr !== "default" && Object.prototype.hasOwnProperty.call(Ve, cr)) {
              var Mr = kr ? Object.getOwnPropertyDescriptor(Ve, cr) : null;
              Mr && (Mr.get || Mr.set) ? Object.defineProperty(wr, cr, Mr) : wr[cr] = Ve[cr];
            }
          return wr.default = Ve, fr && fr.set(Ve, wr), wr;
        }(Lr());
        function Ce(Ve) {
          if (typeof WeakMap != "function")
            return null;
          var er = /* @__PURE__ */ new WeakMap(), fr = /* @__PURE__ */ new WeakMap();
          return (Ce = function(wr) {
            return wr ? fr : er;
          })(Ve);
        }
        function De(Ve, er, fr) {
          var wr = er[0], kr = er[1], cr = er[2], Mr = er[3], Er = er[4], xr = er[5], Sr = fr[0], Br = fr[1], Fr = fr[2], jr = fr[3], Qr = fr[4], ti = fr[5];
          return Ve[0] = wr * Sr + cr * Br, Ve[1] = kr * Sr + Mr * Br, Ve[2] = wr * Fr + cr * jr, Ve[3] = kr * Fr + Mr * jr, Ve[4] = wr * Qr + cr * ti + Er, Ve[5] = kr * Qr + Mr * ti + xr, Ve;
        }
        function Ke(Ve, er, fr) {
          return Ve[0] = er[0] - fr[0], Ve[1] = er[1] - fr[1], Ve[2] = er[2] - fr[2], Ve[3] = er[3] - fr[3], Ve[4] = er[4] - fr[4], Ve[5] = er[5] - fr[5], Ve;
        }
        return Yr.mul = De, Yr.sub = Ke, Yr;
      }
      var Xr, Wr = {};
      function si() {
        if (Xr)
          return Wr;
        function Ie(Ve) {
          return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(er) {
            return typeof er;
          } : function(er) {
            return er && typeof Symbol == "function" && er.constructor === Symbol && er !== Symbol.prototype ? "symbol" : typeof er;
          }, Ie(Ve);
        }
        Xr = 1, Object.defineProperty(Wr, "__esModule", { value: !0 }), Wr.create = function() {
          var Ve = new de.ARRAY_TYPE(9);
          return de.ARRAY_TYPE != Float32Array && (Ve[1] = 0, Ve[2] = 0, Ve[3] = 0, Ve[5] = 0, Ve[6] = 0, Ve[7] = 0), Ve[0] = 1, Ve[4] = 1, Ve[8] = 1, Ve;
        }, Wr.fromMat4 = function(Ve, er) {
          return Ve[0] = er[0], Ve[1] = er[1], Ve[2] = er[2], Ve[3] = er[4], Ve[4] = er[5], Ve[5] = er[6], Ve[6] = er[8], Ve[7] = er[9], Ve[8] = er[10], Ve;
        }, Wr.clone = function(Ve) {
          var er = new de.ARRAY_TYPE(9);
          return er[0] = Ve[0], er[1] = Ve[1], er[2] = Ve[2], er[3] = Ve[3], er[4] = Ve[4], er[5] = Ve[5], er[6] = Ve[6], er[7] = Ve[7], er[8] = Ve[8], er;
        }, Wr.copy = function(Ve, er) {
          return Ve[0] = er[0], Ve[1] = er[1], Ve[2] = er[2], Ve[3] = er[3], Ve[4] = er[4], Ve[5] = er[5], Ve[6] = er[6], Ve[7] = er[7], Ve[8] = er[8], Ve;
        }, Wr.fromValues = function(Ve, er, fr, wr, kr, cr, Mr, Er, xr) {
          var Sr = new de.ARRAY_TYPE(9);
          return Sr[0] = Ve, Sr[1] = er, Sr[2] = fr, Sr[3] = wr, Sr[4] = kr, Sr[5] = cr, Sr[6] = Mr, Sr[7] = Er, Sr[8] = xr, Sr;
        }, Wr.set = function(Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr) {
          return Ve[0] = er, Ve[1] = fr, Ve[2] = wr, Ve[3] = kr, Ve[4] = cr, Ve[5] = Mr, Ve[6] = Er, Ve[7] = xr, Ve[8] = Sr, Ve;
        }, Wr.identity = function(Ve) {
          return Ve[0] = 1, Ve[1] = 0, Ve[2] = 0, Ve[3] = 0, Ve[4] = 1, Ve[5] = 0, Ve[6] = 0, Ve[7] = 0, Ve[8] = 1, Ve;
        }, Wr.transpose = function(Ve, er) {
          if (Ve === er) {
            var fr = er[1], wr = er[2], kr = er[5];
            Ve[1] = er[3], Ve[2] = er[6], Ve[3] = fr, Ve[5] = er[7], Ve[6] = wr, Ve[7] = kr;
          } else
            Ve[0] = er[0], Ve[1] = er[3], Ve[2] = er[6], Ve[3] = er[1], Ve[4] = er[4], Ve[5] = er[7], Ve[6] = er[2], Ve[7] = er[5], Ve[8] = er[8];
          return Ve;
        }, Wr.invert = function(Ve, er) {
          var fr = er[0], wr = er[1], kr = er[2], cr = er[3], Mr = er[4], Er = er[5], xr = er[6], Sr = er[7], Br = er[8], Fr = Br * Mr - Er * Sr, jr = -Br * cr + Er * xr, Qr = Sr * cr - Mr * xr, ti = fr * Fr + wr * jr + kr * Qr;
          return ti ? (Ve[0] = Fr * (ti = 1 / ti), Ve[1] = (-Br * wr + kr * Sr) * ti, Ve[2] = (Er * wr - kr * Mr) * ti, Ve[3] = jr * ti, Ve[4] = (Br * fr - kr * xr) * ti, Ve[5] = (-Er * fr + kr * cr) * ti, Ve[6] = Qr * ti, Ve[7] = (-Sr * fr + wr * xr) * ti, Ve[8] = (Mr * fr - wr * cr) * ti, Ve) : null;
        }, Wr.adjoint = function(Ve, er) {
          var fr = er[0], wr = er[1], kr = er[2], cr = er[3], Mr = er[4], Er = er[5], xr = er[6], Sr = er[7], Br = er[8];
          return Ve[0] = Mr * Br - Er * Sr, Ve[1] = kr * Sr - wr * Br, Ve[2] = wr * Er - kr * Mr, Ve[3] = Er * xr - cr * Br, Ve[4] = fr * Br - kr * xr, Ve[5] = kr * cr - fr * Er, Ve[6] = cr * Sr - Mr * xr, Ve[7] = wr * xr - fr * Sr, Ve[8] = fr * Mr - wr * cr, Ve;
        }, Wr.determinant = function(Ve) {
          var er = Ve[3], fr = Ve[4], wr = Ve[5], kr = Ve[6], cr = Ve[7], Mr = Ve[8];
          return Ve[0] * (Mr * fr - wr * cr) + Ve[1] * (-Mr * er + wr * kr) + Ve[2] * (cr * er - fr * kr);
        }, Wr.multiply = De, Wr.translate = function(Ve, er, fr) {
          var wr = er[0], kr = er[1], cr = er[2], Mr = er[3], Er = er[4], xr = er[5], Sr = er[6], Br = er[7], Fr = er[8], jr = fr[0], Qr = fr[1];
          return Ve[0] = wr, Ve[1] = kr, Ve[2] = cr, Ve[3] = Mr, Ve[4] = Er, Ve[5] = xr, Ve[6] = jr * wr + Qr * Mr + Sr, Ve[7] = jr * kr + Qr * Er + Br, Ve[8] = jr * cr + Qr * xr + Fr, Ve;
        }, Wr.rotate = function(Ve, er, fr) {
          var wr = er[0], kr = er[1], cr = er[2], Mr = er[3], Er = er[4], xr = er[5], Sr = er[6], Br = er[7], Fr = er[8], jr = Math.sin(fr), Qr = Math.cos(fr);
          return Ve[0] = Qr * wr + jr * Mr, Ve[1] = Qr * kr + jr * Er, Ve[2] = Qr * cr + jr * xr, Ve[3] = Qr * Mr - jr * wr, Ve[4] = Qr * Er - jr * kr, Ve[5] = Qr * xr - jr * cr, Ve[6] = Sr, Ve[7] = Br, Ve[8] = Fr, Ve;
        }, Wr.scale = function(Ve, er, fr) {
          var wr = fr[0], kr = fr[1];
          return Ve[0] = wr * er[0], Ve[1] = wr * er[1], Ve[2] = wr * er[2], Ve[3] = kr * er[3], Ve[4] = kr * er[4], Ve[5] = kr * er[5], Ve[6] = er[6], Ve[7] = er[7], Ve[8] = er[8], Ve;
        }, Wr.fromTranslation = function(Ve, er) {
          return Ve[0] = 1, Ve[1] = 0, Ve[2] = 0, Ve[3] = 0, Ve[4] = 1, Ve[5] = 0, Ve[6] = er[0], Ve[7] = er[1], Ve[8] = 1, Ve;
        }, Wr.fromRotation = function(Ve, er) {
          var fr = Math.sin(er), wr = Math.cos(er);
          return Ve[0] = wr, Ve[1] = fr, Ve[2] = 0, Ve[3] = -fr, Ve[4] = wr, Ve[5] = 0, Ve[6] = 0, Ve[7] = 0, Ve[8] = 1, Ve;
        }, Wr.fromScaling = function(Ve, er) {
          return Ve[0] = er[0], Ve[1] = 0, Ve[2] = 0, Ve[3] = 0, Ve[4] = er[1], Ve[5] = 0, Ve[6] = 0, Ve[7] = 0, Ve[8] = 1, Ve;
        }, Wr.fromMat2d = function(Ve, er) {
          return Ve[0] = er[0], Ve[1] = er[1], Ve[2] = 0, Ve[3] = er[2], Ve[4] = er[3], Ve[5] = 0, Ve[6] = er[4], Ve[7] = er[5], Ve[8] = 1, Ve;
        }, Wr.fromQuat = function(Ve, er) {
          var fr = er[0], wr = er[1], kr = er[2], cr = er[3], Mr = fr + fr, Er = wr + wr, xr = kr + kr, Sr = fr * Mr, Br = wr * Mr, Fr = wr * Er, jr = kr * Mr, Qr = kr * Er, ti = kr * xr, Kr = cr * Mr, ni = cr * Er, gi = cr * xr;
          return Ve[0] = 1 - Fr - ti, Ve[3] = Br - gi, Ve[6] = jr + ni, Ve[1] = Br + gi, Ve[4] = 1 - Sr - ti, Ve[7] = Qr - Kr, Ve[2] = jr - ni, Ve[5] = Qr + Kr, Ve[8] = 1 - Sr - Fr, Ve;
        }, Wr.normalFromMat4 = function(Ve, er) {
          var fr = er[0], wr = er[1], kr = er[2], cr = er[3], Mr = er[4], Er = er[5], xr = er[6], Sr = er[7], Br = er[8], Fr = er[9], jr = er[10], Qr = er[11], ti = er[12], Kr = er[13], ni = er[14], gi = er[15], Si = fr * Er - wr * Mr, Di = fr * xr - kr * Mr, Ri = fr * Sr - cr * Mr, Bi = wr * xr - kr * Er, Ji = wr * Sr - cr * Er, Fi = kr * Sr - cr * xr, tn = Br * Kr - Fr * ti, cn = Br * ni - jr * ti, ln = Br * gi - Qr * ti, mn = Fr * ni - jr * Kr, wn = Fr * gi - Qr * Kr, Cn = jr * gi - Qr * ni, gn = Si * Cn - Di * wn + Ri * mn + Bi * ln - Ji * cn + Fi * tn;
          return gn ? (Ve[0] = (Er * Cn - xr * wn + Sr * mn) * (gn = 1 / gn), Ve[1] = (xr * ln - Mr * Cn - Sr * cn) * gn, Ve[2] = (Mr * wn - Er * ln + Sr * tn) * gn, Ve[3] = (kr * wn - wr * Cn - cr * mn) * gn, Ve[4] = (fr * Cn - kr * ln + cr * cn) * gn, Ve[5] = (wr * ln - fr * wn - cr * tn) * gn, Ve[6] = (Kr * Fi - ni * Ji + gi * Bi) * gn, Ve[7] = (ni * Ri - ti * Fi - gi * Di) * gn, Ve[8] = (ti * Ji - Kr * Ri + gi * Si) * gn, Ve) : null;
        }, Wr.projection = function(Ve, er, fr) {
          return Ve[0] = 2 / er, Ve[1] = 0, Ve[2] = 0, Ve[3] = 0, Ve[4] = -2 / fr, Ve[5] = 0, Ve[6] = -1, Ve[7] = 1, Ve[8] = 1, Ve;
        }, Wr.str = function(Ve) {
          return "mat3(" + Ve[0] + ", " + Ve[1] + ", " + Ve[2] + ", " + Ve[3] + ", " + Ve[4] + ", " + Ve[5] + ", " + Ve[6] + ", " + Ve[7] + ", " + Ve[8] + ")";
        }, Wr.frob = function(Ve) {
          return Math.hypot(Ve[0], Ve[1], Ve[2], Ve[3], Ve[4], Ve[5], Ve[6], Ve[7], Ve[8]);
        }, Wr.add = function(Ve, er, fr) {
          return Ve[0] = er[0] + fr[0], Ve[1] = er[1] + fr[1], Ve[2] = er[2] + fr[2], Ve[3] = er[3] + fr[3], Ve[4] = er[4] + fr[4], Ve[5] = er[5] + fr[5], Ve[6] = er[6] + fr[6], Ve[7] = er[7] + fr[7], Ve[8] = er[8] + fr[8], Ve;
        }, Wr.subtract = Ke, Wr.multiplyScalar = function(Ve, er, fr) {
          return Ve[0] = er[0] * fr, Ve[1] = er[1] * fr, Ve[2] = er[2] * fr, Ve[3] = er[3] * fr, Ve[4] = er[4] * fr, Ve[5] = er[5] * fr, Ve[6] = er[6] * fr, Ve[7] = er[7] * fr, Ve[8] = er[8] * fr, Ve;
        }, Wr.multiplyScalarAndAdd = function(Ve, er, fr, wr) {
          return Ve[0] = er[0] + fr[0] * wr, Ve[1] = er[1] + fr[1] * wr, Ve[2] = er[2] + fr[2] * wr, Ve[3] = er[3] + fr[3] * wr, Ve[4] = er[4] + fr[4] * wr, Ve[5] = er[5] + fr[5] * wr, Ve[6] = er[6] + fr[6] * wr, Ve[7] = er[7] + fr[7] * wr, Ve[8] = er[8] + fr[8] * wr, Ve;
        }, Wr.exactEquals = function(Ve, er) {
          return Ve[0] === er[0] && Ve[1] === er[1] && Ve[2] === er[2] && Ve[3] === er[3] && Ve[4] === er[4] && Ve[5] === er[5] && Ve[6] === er[6] && Ve[7] === er[7] && Ve[8] === er[8];
        }, Wr.equals = function(Ve, er) {
          var fr = Ve[0], wr = Ve[1], kr = Ve[2], cr = Ve[3], Mr = Ve[4], Er = Ve[5], xr = Ve[6], Sr = Ve[7], Br = Ve[8], Fr = er[0], jr = er[1], Qr = er[2], ti = er[3], Kr = er[4], ni = er[5], gi = er[6], Si = er[7], Di = er[8];
          return Math.abs(fr - Fr) <= de.EPSILON * Math.max(1, Math.abs(fr), Math.abs(Fr)) && Math.abs(wr - jr) <= de.EPSILON * Math.max(1, Math.abs(wr), Math.abs(jr)) && Math.abs(kr - Qr) <= de.EPSILON * Math.max(1, Math.abs(kr), Math.abs(Qr)) && Math.abs(cr - ti) <= de.EPSILON * Math.max(1, Math.abs(cr), Math.abs(ti)) && Math.abs(Mr - Kr) <= de.EPSILON * Math.max(1, Math.abs(Mr), Math.abs(Kr)) && Math.abs(Er - ni) <= de.EPSILON * Math.max(1, Math.abs(Er), Math.abs(ni)) && Math.abs(xr - gi) <= de.EPSILON * Math.max(1, Math.abs(xr), Math.abs(gi)) && Math.abs(Sr - Si) <= de.EPSILON * Math.max(1, Math.abs(Sr), Math.abs(Si)) && Math.abs(Br - Di) <= de.EPSILON * Math.max(1, Math.abs(Br), Math.abs(Di));
        }, Wr.sub = Wr.mul = void 0;
        var de = function(Ve, er) {
          if (Ve && Ve.__esModule)
            return Ve;
          if (Ve === null || Ie(Ve) !== "object" && typeof Ve != "function")
            return { default: Ve };
          var fr = Ce(void 0);
          if (fr && fr.has(Ve))
            return fr.get(Ve);
          var wr = {}, kr = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var cr in Ve)
            if (cr !== "default" && Object.prototype.hasOwnProperty.call(Ve, cr)) {
              var Mr = kr ? Object.getOwnPropertyDescriptor(Ve, cr) : null;
              Mr && (Mr.get || Mr.set) ? Object.defineProperty(wr, cr, Mr) : wr[cr] = Ve[cr];
            }
          return wr.default = Ve, fr && fr.set(Ve, wr), wr;
        }(Lr());
        function Ce(Ve) {
          if (typeof WeakMap != "function")
            return null;
          var er = /* @__PURE__ */ new WeakMap(), fr = /* @__PURE__ */ new WeakMap();
          return (Ce = function(wr) {
            return wr ? fr : er;
          })(Ve);
        }
        function De(Ve, er, fr) {
          var wr = er[0], kr = er[1], cr = er[2], Mr = er[3], Er = er[4], xr = er[5], Sr = er[6], Br = er[7], Fr = er[8], jr = fr[0], Qr = fr[1], ti = fr[2], Kr = fr[3], ni = fr[4], gi = fr[5], Si = fr[6], Di = fr[7], Ri = fr[8];
          return Ve[0] = jr * wr + Qr * Mr + ti * Sr, Ve[1] = jr * kr + Qr * Er + ti * Br, Ve[2] = jr * cr + Qr * xr + ti * Fr, Ve[3] = Kr * wr + ni * Mr + gi * Sr, Ve[4] = Kr * kr + ni * Er + gi * Br, Ve[5] = Kr * cr + ni * xr + gi * Fr, Ve[6] = Si * wr + Di * Mr + Ri * Sr, Ve[7] = Si * kr + Di * Er + Ri * Br, Ve[8] = Si * cr + Di * xr + Ri * Fr, Ve;
        }
        function Ke(Ve, er, fr) {
          return Ve[0] = er[0] - fr[0], Ve[1] = er[1] - fr[1], Ve[2] = er[2] - fr[2], Ve[3] = er[3] - fr[3], Ve[4] = er[4] - fr[4], Ve[5] = er[5] - fr[5], Ve[6] = er[6] - fr[6], Ve[7] = er[7] - fr[7], Ve[8] = er[8] - fr[8], Ve;
        }
        return Wr.mul = De, Wr.sub = Ke, Wr;
      }
      var li, xi = {};
      function di() {
        if (li)
          return xi;
        function Ie(cr) {
          return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Mr) {
            return typeof Mr;
          } : function(Mr) {
            return Mr && typeof Symbol == "function" && Mr.constructor === Symbol && Mr !== Symbol.prototype ? "symbol" : typeof Mr;
          }, Ie(cr);
        }
        li = 1, Object.defineProperty(xi, "__esModule", { value: !0 }), xi.create = function() {
          var cr = new de.ARRAY_TYPE(16);
          return de.ARRAY_TYPE != Float32Array && (cr[1] = 0, cr[2] = 0, cr[3] = 0, cr[4] = 0, cr[6] = 0, cr[7] = 0, cr[8] = 0, cr[9] = 0, cr[11] = 0, cr[12] = 0, cr[13] = 0, cr[14] = 0), cr[0] = 1, cr[5] = 1, cr[10] = 1, cr[15] = 1, cr;
        }, xi.clone = function(cr) {
          var Mr = new de.ARRAY_TYPE(16);
          return Mr[0] = cr[0], Mr[1] = cr[1], Mr[2] = cr[2], Mr[3] = cr[3], Mr[4] = cr[4], Mr[5] = cr[5], Mr[6] = cr[6], Mr[7] = cr[7], Mr[8] = cr[8], Mr[9] = cr[9], Mr[10] = cr[10], Mr[11] = cr[11], Mr[12] = cr[12], Mr[13] = cr[13], Mr[14] = cr[14], Mr[15] = cr[15], Mr;
        }, xi.copy = function(cr, Mr) {
          return cr[0] = Mr[0], cr[1] = Mr[1], cr[2] = Mr[2], cr[3] = Mr[3], cr[4] = Mr[4], cr[5] = Mr[5], cr[6] = Mr[6], cr[7] = Mr[7], cr[8] = Mr[8], cr[9] = Mr[9], cr[10] = Mr[10], cr[11] = Mr[11], cr[12] = Mr[12], cr[13] = Mr[13], cr[14] = Mr[14], cr[15] = Mr[15], cr;
        }, xi.fromValues = function(cr, Mr, Er, xr, Sr, Br, Fr, jr, Qr, ti, Kr, ni, gi, Si, Di, Ri) {
          var Bi = new de.ARRAY_TYPE(16);
          return Bi[0] = cr, Bi[1] = Mr, Bi[2] = Er, Bi[3] = xr, Bi[4] = Sr, Bi[5] = Br, Bi[6] = Fr, Bi[7] = jr, Bi[8] = Qr, Bi[9] = ti, Bi[10] = Kr, Bi[11] = ni, Bi[12] = gi, Bi[13] = Si, Bi[14] = Di, Bi[15] = Ri, Bi;
        }, xi.set = function(cr, Mr, Er, xr, Sr, Br, Fr, jr, Qr, ti, Kr, ni, gi, Si, Di, Ri, Bi) {
          return cr[0] = Mr, cr[1] = Er, cr[2] = xr, cr[3] = Sr, cr[4] = Br, cr[5] = Fr, cr[6] = jr, cr[7] = Qr, cr[8] = ti, cr[9] = Kr, cr[10] = ni, cr[11] = gi, cr[12] = Si, cr[13] = Di, cr[14] = Ri, cr[15] = Bi, cr;
        }, xi.identity = De, xi.transpose = function(cr, Mr) {
          if (cr === Mr) {
            var Er = Mr[1], xr = Mr[2], Sr = Mr[3], Br = Mr[6], Fr = Mr[7], jr = Mr[11];
            cr[1] = Mr[4], cr[2] = Mr[8], cr[3] = Mr[12], cr[4] = Er, cr[6] = Mr[9], cr[7] = Mr[13], cr[8] = xr, cr[9] = Br, cr[11] = Mr[14], cr[12] = Sr, cr[13] = Fr, cr[14] = jr;
          } else
            cr[0] = Mr[0], cr[1] = Mr[4], cr[2] = Mr[8], cr[3] = Mr[12], cr[4] = Mr[1], cr[5] = Mr[5], cr[6] = Mr[9], cr[7] = Mr[13], cr[8] = Mr[2], cr[9] = Mr[6], cr[10] = Mr[10], cr[11] = Mr[14], cr[12] = Mr[3], cr[13] = Mr[7], cr[14] = Mr[11], cr[15] = Mr[15];
          return cr;
        }, xi.invert = function(cr, Mr) {
          var Er = Mr[0], xr = Mr[1], Sr = Mr[2], Br = Mr[3], Fr = Mr[4], jr = Mr[5], Qr = Mr[6], ti = Mr[7], Kr = Mr[8], ni = Mr[9], gi = Mr[10], Si = Mr[11], Di = Mr[12], Ri = Mr[13], Bi = Mr[14], Ji = Mr[15], Fi = Er * jr - xr * Fr, tn = Er * Qr - Sr * Fr, cn = Er * ti - Br * Fr, ln = xr * Qr - Sr * jr, mn = xr * ti - Br * jr, wn = Sr * ti - Br * Qr, Cn = Kr * Ri - ni * Di, gn = Kr * Bi - gi * Di, Nn = Kr * Ji - Si * Di, oo = ni * Bi - gi * Ri, Un = ni * Ji - Si * Ri, fo = gi * Ji - Si * Bi, ho = Fi * fo - tn * Un + cn * oo + ln * Nn - mn * gn + wn * Cn;
          return ho ? (cr[0] = (jr * fo - Qr * Un + ti * oo) * (ho = 1 / ho), cr[1] = (Sr * Un - xr * fo - Br * oo) * ho, cr[2] = (Ri * wn - Bi * mn + Ji * ln) * ho, cr[3] = (gi * mn - ni * wn - Si * ln) * ho, cr[4] = (Qr * Nn - Fr * fo - ti * gn) * ho, cr[5] = (Er * fo - Sr * Nn + Br * gn) * ho, cr[6] = (Bi * cn - Di * wn - Ji * tn) * ho, cr[7] = (Kr * wn - gi * cn + Si * tn) * ho, cr[8] = (Fr * Un - jr * Nn + ti * Cn) * ho, cr[9] = (xr * Nn - Er * Un - Br * Cn) * ho, cr[10] = (Di * mn - Ri * cn + Ji * Fi) * ho, cr[11] = (ni * cn - Kr * mn - Si * Fi) * ho, cr[12] = (jr * gn - Fr * oo - Qr * Cn) * ho, cr[13] = (Er * oo - xr * gn + Sr * Cn) * ho, cr[14] = (Ri * tn - Di * ln - Bi * Fi) * ho, cr[15] = (Kr * ln - ni * tn + gi * Fi) * ho, cr) : null;
        }, xi.adjoint = function(cr, Mr) {
          var Er = Mr[0], xr = Mr[1], Sr = Mr[2], Br = Mr[3], Fr = Mr[4], jr = Mr[5], Qr = Mr[6], ti = Mr[7], Kr = Mr[8], ni = Mr[9], gi = Mr[10], Si = Mr[11], Di = Mr[12], Ri = Mr[13], Bi = Mr[14], Ji = Mr[15];
          return cr[0] = jr * (gi * Ji - Si * Bi) - ni * (Qr * Ji - ti * Bi) + Ri * (Qr * Si - ti * gi), cr[1] = -(xr * (gi * Ji - Si * Bi) - ni * (Sr * Ji - Br * Bi) + Ri * (Sr * Si - Br * gi)), cr[2] = xr * (Qr * Ji - ti * Bi) - jr * (Sr * Ji - Br * Bi) + Ri * (Sr * ti - Br * Qr), cr[3] = -(xr * (Qr * Si - ti * gi) - jr * (Sr * Si - Br * gi) + ni * (Sr * ti - Br * Qr)), cr[4] = -(Fr * (gi * Ji - Si * Bi) - Kr * (Qr * Ji - ti * Bi) + Di * (Qr * Si - ti * gi)), cr[5] = Er * (gi * Ji - Si * Bi) - Kr * (Sr * Ji - Br * Bi) + Di * (Sr * Si - Br * gi), cr[6] = -(Er * (Qr * Ji - ti * Bi) - Fr * (Sr * Ji - Br * Bi) + Di * (Sr * ti - Br * Qr)), cr[7] = Er * (Qr * Si - ti * gi) - Fr * (Sr * Si - Br * gi) + Kr * (Sr * ti - Br * Qr), cr[8] = Fr * (ni * Ji - Si * Ri) - Kr * (jr * Ji - ti * Ri) + Di * (jr * Si - ti * ni), cr[9] = -(Er * (ni * Ji - Si * Ri) - Kr * (xr * Ji - Br * Ri) + Di * (xr * Si - Br * ni)), cr[10] = Er * (jr * Ji - ti * Ri) - Fr * (xr * Ji - Br * Ri) + Di * (xr * ti - Br * jr), cr[11] = -(Er * (jr * Si - ti * ni) - Fr * (xr * Si - Br * ni) + Kr * (xr * ti - Br * jr)), cr[12] = -(Fr * (ni * Bi - gi * Ri) - Kr * (jr * Bi - Qr * Ri) + Di * (jr * gi - Qr * ni)), cr[13] = Er * (ni * Bi - gi * Ri) - Kr * (xr * Bi - Sr * Ri) + Di * (xr * gi - Sr * ni), cr[14] = -(Er * (jr * Bi - Qr * Ri) - Fr * (xr * Bi - Sr * Ri) + Di * (xr * Qr - Sr * jr)), cr[15] = Er * (jr * gi - Qr * ni) - Fr * (xr * gi - Sr * ni) + Kr * (xr * Qr - Sr * jr), cr;
        }, xi.determinant = function(cr) {
          var Mr = cr[0], Er = cr[1], xr = cr[2], Sr = cr[3], Br = cr[4], Fr = cr[5], jr = cr[6], Qr = cr[7], ti = cr[8], Kr = cr[9], ni = cr[10], gi = cr[11], Si = cr[12], Di = cr[13], Ri = cr[14], Bi = cr[15];
          return (Mr * Fr - Er * Br) * (ni * Bi - gi * Ri) - (Mr * jr - xr * Br) * (Kr * Bi - gi * Di) + (Mr * Qr - Sr * Br) * (Kr * Ri - ni * Di) + (Er * jr - xr * Fr) * (ti * Bi - gi * Si) - (Er * Qr - Sr * Fr) * (ti * Ri - ni * Si) + (xr * Qr - Sr * jr) * (ti * Di - Kr * Si);
        }, xi.multiply = Ke, xi.translate = function(cr, Mr, Er) {
          var xr, Sr, Br, Fr, jr, Qr, ti, Kr, ni, gi, Si, Di, Ri = Er[0], Bi = Er[1], Ji = Er[2];
          return Mr === cr ? (cr[12] = Mr[0] * Ri + Mr[4] * Bi + Mr[8] * Ji + Mr[12], cr[13] = Mr[1] * Ri + Mr[5] * Bi + Mr[9] * Ji + Mr[13], cr[14] = Mr[2] * Ri + Mr[6] * Bi + Mr[10] * Ji + Mr[14], cr[15] = Mr[3] * Ri + Mr[7] * Bi + Mr[11] * Ji + Mr[15]) : (Sr = Mr[1], Br = Mr[2], Fr = Mr[3], jr = Mr[4], Qr = Mr[5], ti = Mr[6], Kr = Mr[7], ni = Mr[8], gi = Mr[9], Si = Mr[10], Di = Mr[11], cr[0] = xr = Mr[0], cr[1] = Sr, cr[2] = Br, cr[3] = Fr, cr[4] = jr, cr[5] = Qr, cr[6] = ti, cr[7] = Kr, cr[8] = ni, cr[9] = gi, cr[10] = Si, cr[11] = Di, cr[12] = xr * Ri + jr * Bi + ni * Ji + Mr[12], cr[13] = Sr * Ri + Qr * Bi + gi * Ji + Mr[13], cr[14] = Br * Ri + ti * Bi + Si * Ji + Mr[14], cr[15] = Fr * Ri + Kr * Bi + Di * Ji + Mr[15]), cr;
        }, xi.scale = function(cr, Mr, Er) {
          var xr = Er[0], Sr = Er[1], Br = Er[2];
          return cr[0] = Mr[0] * xr, cr[1] = Mr[1] * xr, cr[2] = Mr[2] * xr, cr[3] = Mr[3] * xr, cr[4] = Mr[4] * Sr, cr[5] = Mr[5] * Sr, cr[6] = Mr[6] * Sr, cr[7] = Mr[7] * Sr, cr[8] = Mr[8] * Br, cr[9] = Mr[9] * Br, cr[10] = Mr[10] * Br, cr[11] = Mr[11] * Br, cr[12] = Mr[12], cr[13] = Mr[13], cr[14] = Mr[14], cr[15] = Mr[15], cr;
        }, xi.rotate = function(cr, Mr, Er, xr) {
          var Sr, Br, Fr, jr, Qr, ti, Kr, ni, gi, Si, Di, Ri, Bi, Ji, Fi, tn, cn, ln, mn, wn, Cn, gn, Nn, oo, Un = xr[0], fo = xr[1], ho = xr[2], bo = Math.hypot(Un, fo, ho);
          return bo < de.EPSILON ? null : (Un *= bo = 1 / bo, fo *= bo, ho *= bo, Sr = Math.sin(Er), Br = Math.cos(Er), Qr = Mr[1], ti = Mr[2], Kr = Mr[3], gi = Mr[5], Si = Mr[6], Di = Mr[7], Bi = Mr[9], Ji = Mr[10], Fi = Mr[11], tn = Un * Un * (Fr = 1 - Br) + Br, mn = Un * fo * Fr - ho * Sr, wn = fo * fo * Fr + Br, Cn = ho * fo * Fr + Un * Sr, gn = Un * ho * Fr + fo * Sr, Nn = fo * ho * Fr - Un * Sr, oo = ho * ho * Fr + Br, cr[0] = (jr = Mr[0]) * tn + (ni = Mr[4]) * (cn = fo * Un * Fr + ho * Sr) + (Ri = Mr[8]) * (ln = ho * Un * Fr - fo * Sr), cr[1] = Qr * tn + gi * cn + Bi * ln, cr[2] = ti * tn + Si * cn + Ji * ln, cr[3] = Kr * tn + Di * cn + Fi * ln, cr[4] = jr * mn + ni * wn + Ri * Cn, cr[5] = Qr * mn + gi * wn + Bi * Cn, cr[6] = ti * mn + Si * wn + Ji * Cn, cr[7] = Kr * mn + Di * wn + Fi * Cn, cr[8] = jr * gn + ni * Nn + Ri * oo, cr[9] = Qr * gn + gi * Nn + Bi * oo, cr[10] = ti * gn + Si * Nn + Ji * oo, cr[11] = Kr * gn + Di * Nn + Fi * oo, Mr !== cr && (cr[12] = Mr[12], cr[13] = Mr[13], cr[14] = Mr[14], cr[15] = Mr[15]), cr);
        }, xi.rotateX = function(cr, Mr, Er) {
          var xr = Math.sin(Er), Sr = Math.cos(Er), Br = Mr[4], Fr = Mr[5], jr = Mr[6], Qr = Mr[7], ti = Mr[8], Kr = Mr[9], ni = Mr[10], gi = Mr[11];
          return Mr !== cr && (cr[0] = Mr[0], cr[1] = Mr[1], cr[2] = Mr[2], cr[3] = Mr[3], cr[12] = Mr[12], cr[13] = Mr[13], cr[14] = Mr[14], cr[15] = Mr[15]), cr[4] = Br * Sr + ti * xr, cr[5] = Fr * Sr + Kr * xr, cr[6] = jr * Sr + ni * xr, cr[7] = Qr * Sr + gi * xr, cr[8] = ti * Sr - Br * xr, cr[9] = Kr * Sr - Fr * xr, cr[10] = ni * Sr - jr * xr, cr[11] = gi * Sr - Qr * xr, cr;
        }, xi.rotateY = function(cr, Mr, Er) {
          var xr = Math.sin(Er), Sr = Math.cos(Er), Br = Mr[0], Fr = Mr[1], jr = Mr[2], Qr = Mr[3], ti = Mr[8], Kr = Mr[9], ni = Mr[10], gi = Mr[11];
          return Mr !== cr && (cr[4] = Mr[4], cr[5] = Mr[5], cr[6] = Mr[6], cr[7] = Mr[7], cr[12] = Mr[12], cr[13] = Mr[13], cr[14] = Mr[14], cr[15] = Mr[15]), cr[0] = Br * Sr - ti * xr, cr[1] = Fr * Sr - Kr * xr, cr[2] = jr * Sr - ni * xr, cr[3] = Qr * Sr - gi * xr, cr[8] = Br * xr + ti * Sr, cr[9] = Fr * xr + Kr * Sr, cr[10] = jr * xr + ni * Sr, cr[11] = Qr * xr + gi * Sr, cr;
        }, xi.rotateZ = function(cr, Mr, Er) {
          var xr = Math.sin(Er), Sr = Math.cos(Er), Br = Mr[0], Fr = Mr[1], jr = Mr[2], Qr = Mr[3], ti = Mr[4], Kr = Mr[5], ni = Mr[6], gi = Mr[7];
          return Mr !== cr && (cr[8] = Mr[8], cr[9] = Mr[9], cr[10] = Mr[10], cr[11] = Mr[11], cr[12] = Mr[12], cr[13] = Mr[13], cr[14] = Mr[14], cr[15] = Mr[15]), cr[0] = Br * Sr + ti * xr, cr[1] = Fr * Sr + Kr * xr, cr[2] = jr * Sr + ni * xr, cr[3] = Qr * Sr + gi * xr, cr[4] = ti * Sr - Br * xr, cr[5] = Kr * Sr - Fr * xr, cr[6] = ni * Sr - jr * xr, cr[7] = gi * Sr - Qr * xr, cr;
        }, xi.fromTranslation = function(cr, Mr) {
          return cr[0] = 1, cr[1] = 0, cr[2] = 0, cr[3] = 0, cr[4] = 0, cr[5] = 1, cr[6] = 0, cr[7] = 0, cr[8] = 0, cr[9] = 0, cr[10] = 1, cr[11] = 0, cr[12] = Mr[0], cr[13] = Mr[1], cr[14] = Mr[2], cr[15] = 1, cr;
        }, xi.fromScaling = function(cr, Mr) {
          return cr[0] = Mr[0], cr[1] = 0, cr[2] = 0, cr[3] = 0, cr[4] = 0, cr[5] = Mr[1], cr[6] = 0, cr[7] = 0, cr[8] = 0, cr[9] = 0, cr[10] = Mr[2], cr[11] = 0, cr[12] = 0, cr[13] = 0, cr[14] = 0, cr[15] = 1, cr;
        }, xi.fromRotation = function(cr, Mr, Er) {
          var xr, Sr, Br, Fr = Er[0], jr = Er[1], Qr = Er[2], ti = Math.hypot(Fr, jr, Qr);
          return ti < de.EPSILON ? null : (Fr *= ti = 1 / ti, jr *= ti, Qr *= ti, xr = Math.sin(Mr), Sr = Math.cos(Mr), cr[0] = Fr * Fr * (Br = 1 - Sr) + Sr, cr[1] = jr * Fr * Br + Qr * xr, cr[2] = Qr * Fr * Br - jr * xr, cr[3] = 0, cr[4] = Fr * jr * Br - Qr * xr, cr[5] = jr * jr * Br + Sr, cr[6] = Qr * jr * Br + Fr * xr, cr[7] = 0, cr[8] = Fr * Qr * Br + jr * xr, cr[9] = jr * Qr * Br - Fr * xr, cr[10] = Qr * Qr * Br + Sr, cr[11] = 0, cr[12] = 0, cr[13] = 0, cr[14] = 0, cr[15] = 1, cr);
        }, xi.fromXRotation = function(cr, Mr) {
          var Er = Math.sin(Mr), xr = Math.cos(Mr);
          return cr[0] = 1, cr[1] = 0, cr[2] = 0, cr[3] = 0, cr[4] = 0, cr[5] = xr, cr[6] = Er, cr[7] = 0, cr[8] = 0, cr[9] = -Er, cr[10] = xr, cr[11] = 0, cr[12] = 0, cr[13] = 0, cr[14] = 0, cr[15] = 1, cr;
        }, xi.fromYRotation = function(cr, Mr) {
          var Er = Math.sin(Mr), xr = Math.cos(Mr);
          return cr[0] = xr, cr[1] = 0, cr[2] = -Er, cr[3] = 0, cr[4] = 0, cr[5] = 1, cr[6] = 0, cr[7] = 0, cr[8] = Er, cr[9] = 0, cr[10] = xr, cr[11] = 0, cr[12] = 0, cr[13] = 0, cr[14] = 0, cr[15] = 1, cr;
        }, xi.fromZRotation = function(cr, Mr) {
          var Er = Math.sin(Mr), xr = Math.cos(Mr);
          return cr[0] = xr, cr[1] = Er, cr[2] = 0, cr[3] = 0, cr[4] = -Er, cr[5] = xr, cr[6] = 0, cr[7] = 0, cr[8] = 0, cr[9] = 0, cr[10] = 1, cr[11] = 0, cr[12] = 0, cr[13] = 0, cr[14] = 0, cr[15] = 1, cr;
        }, xi.fromRotationTranslation = Ve, xi.fromQuat2 = function(cr, Mr) {
          var Er = new de.ARRAY_TYPE(3), xr = -Mr[0], Sr = -Mr[1], Br = -Mr[2], Fr = Mr[3], jr = Mr[4], Qr = Mr[5], ti = Mr[6], Kr = Mr[7], ni = xr * xr + Sr * Sr + Br * Br + Fr * Fr;
          return ni > 0 ? (Er[0] = 2 * (jr * Fr + Kr * xr + Qr * Br - ti * Sr) / ni, Er[1] = 2 * (Qr * Fr + Kr * Sr + ti * xr - jr * Br) / ni, Er[2] = 2 * (ti * Fr + Kr * Br + jr * Sr - Qr * xr) / ni) : (Er[0] = 2 * (jr * Fr + Kr * xr + Qr * Br - ti * Sr), Er[1] = 2 * (Qr * Fr + Kr * Sr + ti * xr - jr * Br), Er[2] = 2 * (ti * Fr + Kr * Br + jr * Sr - Qr * xr)), Ve(cr, Mr, Er), cr;
        }, xi.getTranslation = function(cr, Mr) {
          return cr[0] = Mr[12], cr[1] = Mr[13], cr[2] = Mr[14], cr;
        }, xi.getScaling = er, xi.getRotation = function(cr, Mr) {
          var Er = new de.ARRAY_TYPE(3);
          er(Er, Mr);
          var xr = 1 / Er[0], Sr = 1 / Er[1], Br = 1 / Er[2], Fr = Mr[0] * xr, jr = Mr[1] * Sr, Qr = Mr[2] * Br, ti = Mr[4] * xr, Kr = Mr[5] * Sr, ni = Mr[6] * Br, gi = Mr[8] * xr, Si = Mr[9] * Sr, Di = Mr[10] * Br, Ri = Fr + Kr + Di, Bi = 0;
          return Ri > 0 ? (Bi = 2 * Math.sqrt(Ri + 1), cr[3] = 0.25 * Bi, cr[0] = (ni - Si) / Bi, cr[1] = (gi - Qr) / Bi, cr[2] = (jr - ti) / Bi) : Fr > Kr && Fr > Di ? (Bi = 2 * Math.sqrt(1 + Fr - Kr - Di), cr[3] = (ni - Si) / Bi, cr[0] = 0.25 * Bi, cr[1] = (jr + ti) / Bi, cr[2] = (gi + Qr) / Bi) : Kr > Di ? (Bi = 2 * Math.sqrt(1 + Kr - Fr - Di), cr[3] = (gi - Qr) / Bi, cr[0] = (jr + ti) / Bi, cr[1] = 0.25 * Bi, cr[2] = (ni + Si) / Bi) : (Bi = 2 * Math.sqrt(1 + Di - Fr - Kr), cr[3] = (jr - ti) / Bi, cr[0] = (gi + Qr) / Bi, cr[1] = (ni + Si) / Bi, cr[2] = 0.25 * Bi), cr;
        }, xi.fromRotationTranslationScale = function(cr, Mr, Er, xr) {
          var Sr = Mr[0], Br = Mr[1], Fr = Mr[2], jr = Mr[3], Qr = Sr + Sr, ti = Br + Br, Kr = Fr + Fr, ni = Sr * Qr, gi = Sr * ti, Si = Sr * Kr, Di = Br * ti, Ri = Br * Kr, Bi = Fr * Kr, Ji = jr * Qr, Fi = jr * ti, tn = jr * Kr, cn = xr[0], ln = xr[1], mn = xr[2];
          return cr[0] = (1 - (Di + Bi)) * cn, cr[1] = (gi + tn) * cn, cr[2] = (Si - Fi) * cn, cr[3] = 0, cr[4] = (gi - tn) * ln, cr[5] = (1 - (ni + Bi)) * ln, cr[6] = (Ri + Ji) * ln, cr[7] = 0, cr[8] = (Si + Fi) * mn, cr[9] = (Ri - Ji) * mn, cr[10] = (1 - (ni + Di)) * mn, cr[11] = 0, cr[12] = Er[0], cr[13] = Er[1], cr[14] = Er[2], cr[15] = 1, cr;
        }, xi.fromRotationTranslationScaleOrigin = function(cr, Mr, Er, xr, Sr) {
          var Br = Mr[0], Fr = Mr[1], jr = Mr[2], Qr = Mr[3], ti = Br + Br, Kr = Fr + Fr, ni = jr + jr, gi = Br * ti, Si = Br * Kr, Di = Br * ni, Ri = Fr * Kr, Bi = Fr * ni, Ji = jr * ni, Fi = Qr * ti, tn = Qr * Kr, cn = Qr * ni, ln = xr[0], mn = xr[1], wn = xr[2], Cn = Sr[0], gn = Sr[1], Nn = Sr[2], oo = (1 - (Ri + Ji)) * ln, Un = (Si + cn) * ln, fo = (Di - tn) * ln, ho = (Si - cn) * mn, bo = (1 - (gi + Ji)) * mn, Jn = (Bi + Fi) * mn, Ro = (Di + tn) * wn, po = (Bi - Fi) * wn, Lo = (1 - (gi + Ri)) * wn;
          return cr[0] = oo, cr[1] = Un, cr[2] = fo, cr[3] = 0, cr[4] = ho, cr[5] = bo, cr[6] = Jn, cr[7] = 0, cr[8] = Ro, cr[9] = po, cr[10] = Lo, cr[11] = 0, cr[12] = Er[0] + Cn - (oo * Cn + ho * gn + Ro * Nn), cr[13] = Er[1] + gn - (Un * Cn + bo * gn + po * Nn), cr[14] = Er[2] + Nn - (fo * Cn + Jn * gn + Lo * Nn), cr[15] = 1, cr;
        }, xi.fromQuat = function(cr, Mr) {
          var Er = Mr[0], xr = Mr[1], Sr = Mr[2], Br = Mr[3], Fr = Er + Er, jr = xr + xr, Qr = Sr + Sr, ti = Er * Fr, Kr = xr * Fr, ni = xr * jr, gi = Sr * Fr, Si = Sr * jr, Di = Sr * Qr, Ri = Br * Fr, Bi = Br * jr, Ji = Br * Qr;
          return cr[0] = 1 - ni - Di, cr[1] = Kr + Ji, cr[2] = gi - Bi, cr[3] = 0, cr[4] = Kr - Ji, cr[5] = 1 - ti - Di, cr[6] = Si + Ri, cr[7] = 0, cr[8] = gi + Bi, cr[9] = Si - Ri, cr[10] = 1 - ti - ni, cr[11] = 0, cr[12] = 0, cr[13] = 0, cr[14] = 0, cr[15] = 1, cr;
        }, xi.frustum = function(cr, Mr, Er, xr, Sr, Br, Fr) {
          var jr = 1 / (Er - Mr), Qr = 1 / (Sr - xr), ti = 1 / (Br - Fr);
          return cr[0] = 2 * Br * jr, cr[1] = 0, cr[2] = 0, cr[3] = 0, cr[4] = 0, cr[5] = 2 * Br * Qr, cr[6] = 0, cr[7] = 0, cr[8] = (Er + Mr) * jr, cr[9] = (Sr + xr) * Qr, cr[10] = (Fr + Br) * ti, cr[11] = -1, cr[12] = 0, cr[13] = 0, cr[14] = Fr * Br * 2 * ti, cr[15] = 0, cr;
        }, xi.perspectiveNO = fr, xi.perspectiveZO = function(cr, Mr, Er, xr, Sr) {
          var Br, Fr = 1 / Math.tan(Mr / 2);
          return cr[0] = Fr / Er, cr[1] = 0, cr[2] = 0, cr[3] = 0, cr[4] = 0, cr[5] = Fr, cr[6] = 0, cr[7] = 0, cr[8] = 0, cr[9] = 0, cr[11] = -1, cr[12] = 0, cr[13] = 0, cr[15] = 0, Sr != null && Sr !== 1 / 0 ? (cr[10] = Sr * (Br = 1 / (xr - Sr)), cr[14] = Sr * xr * Br) : (cr[10] = -1, cr[14] = -xr), cr;
        }, xi.perspectiveFromFieldOfView = function(cr, Mr, Er, xr) {
          var Sr = Math.tan(Mr.upDegrees * Math.PI / 180), Br = Math.tan(Mr.downDegrees * Math.PI / 180), Fr = Math.tan(Mr.leftDegrees * Math.PI / 180), jr = Math.tan(Mr.rightDegrees * Math.PI / 180), Qr = 2 / (Fr + jr), ti = 2 / (Sr + Br);
          return cr[0] = Qr, cr[1] = 0, cr[2] = 0, cr[3] = 0, cr[4] = 0, cr[5] = ti, cr[6] = 0, cr[7] = 0, cr[8] = -(Fr - jr) * Qr * 0.5, cr[9] = (Sr - Br) * ti * 0.5, cr[10] = xr / (Er - xr), cr[11] = -1, cr[12] = 0, cr[13] = 0, cr[14] = xr * Er / (Er - xr), cr[15] = 0, cr;
        }, xi.orthoNO = wr, xi.orthoZO = function(cr, Mr, Er, xr, Sr, Br, Fr) {
          var jr = 1 / (Mr - Er), Qr = 1 / (xr - Sr), ti = 1 / (Br - Fr);
          return cr[0] = -2 * jr, cr[1] = 0, cr[2] = 0, cr[3] = 0, cr[4] = 0, cr[5] = -2 * Qr, cr[6] = 0, cr[7] = 0, cr[8] = 0, cr[9] = 0, cr[10] = ti, cr[11] = 0, cr[12] = (Mr + Er) * jr, cr[13] = (Sr + xr) * Qr, cr[14] = Br * ti, cr[15] = 1, cr;
        }, xi.lookAt = function(cr, Mr, Er, xr) {
          var Sr, Br, Fr, jr, Qr, ti, Kr, ni, gi, Si, Di = Mr[0], Ri = Mr[1], Bi = Mr[2], Ji = xr[0], Fi = xr[1], tn = xr[2], cn = Er[0], ln = Er[1], mn = Er[2];
          return Math.abs(Di - cn) < de.EPSILON && Math.abs(Ri - ln) < de.EPSILON && Math.abs(Bi - mn) < de.EPSILON ? De(cr) : (Kr = Di - cn, ni = Ri - ln, gi = Bi - mn, Sr = Fi * (gi *= Si = 1 / Math.hypot(Kr, ni, gi)) - tn * (ni *= Si), Br = tn * (Kr *= Si) - Ji * gi, Fr = Ji * ni - Fi * Kr, (Si = Math.hypot(Sr, Br, Fr)) ? (Sr *= Si = 1 / Si, Br *= Si, Fr *= Si) : (Sr = 0, Br = 0, Fr = 0), jr = ni * Fr - gi * Br, Qr = gi * Sr - Kr * Fr, ti = Kr * Br - ni * Sr, (Si = Math.hypot(jr, Qr, ti)) ? (jr *= Si = 1 / Si, Qr *= Si, ti *= Si) : (jr = 0, Qr = 0, ti = 0), cr[0] = Sr, cr[1] = jr, cr[2] = Kr, cr[3] = 0, cr[4] = Br, cr[5] = Qr, cr[6] = ni, cr[7] = 0, cr[8] = Fr, cr[9] = ti, cr[10] = gi, cr[11] = 0, cr[12] = -(Sr * Di + Br * Ri + Fr * Bi), cr[13] = -(jr * Di + Qr * Ri + ti * Bi), cr[14] = -(Kr * Di + ni * Ri + gi * Bi), cr[15] = 1, cr);
        }, xi.targetTo = function(cr, Mr, Er, xr) {
          var Sr = Mr[0], Br = Mr[1], Fr = Mr[2], jr = xr[0], Qr = xr[1], ti = xr[2], Kr = Sr - Er[0], ni = Br - Er[1], gi = Fr - Er[2], Si = Kr * Kr + ni * ni + gi * gi;
          Si > 0 && (Kr *= Si = 1 / Math.sqrt(Si), ni *= Si, gi *= Si);
          var Di = Qr * gi - ti * ni, Ri = ti * Kr - jr * gi, Bi = jr * ni - Qr * Kr;
          return (Si = Di * Di + Ri * Ri + Bi * Bi) > 0 && (Di *= Si = 1 / Math.sqrt(Si), Ri *= Si, Bi *= Si), cr[0] = Di, cr[1] = Ri, cr[2] = Bi, cr[3] = 0, cr[4] = ni * Bi - gi * Ri, cr[5] = gi * Di - Kr * Bi, cr[6] = Kr * Ri - ni * Di, cr[7] = 0, cr[8] = Kr, cr[9] = ni, cr[10] = gi, cr[11] = 0, cr[12] = Sr, cr[13] = Br, cr[14] = Fr, cr[15] = 1, cr;
        }, xi.str = function(cr) {
          return "mat4(" + cr[0] + ", " + cr[1] + ", " + cr[2] + ", " + cr[3] + ", " + cr[4] + ", " + cr[5] + ", " + cr[6] + ", " + cr[7] + ", " + cr[8] + ", " + cr[9] + ", " + cr[10] + ", " + cr[11] + ", " + cr[12] + ", " + cr[13] + ", " + cr[14] + ", " + cr[15] + ")";
        }, xi.frob = function(cr) {
          return Math.hypot(cr[0], cr[1], cr[2], cr[3], cr[4], cr[5], cr[6], cr[7], cr[8], cr[9], cr[10], cr[11], cr[12], cr[13], cr[14], cr[15]);
        }, xi.add = function(cr, Mr, Er) {
          return cr[0] = Mr[0] + Er[0], cr[1] = Mr[1] + Er[1], cr[2] = Mr[2] + Er[2], cr[3] = Mr[3] + Er[3], cr[4] = Mr[4] + Er[4], cr[5] = Mr[5] + Er[5], cr[6] = Mr[6] + Er[6], cr[7] = Mr[7] + Er[7], cr[8] = Mr[8] + Er[8], cr[9] = Mr[9] + Er[9], cr[10] = Mr[10] + Er[10], cr[11] = Mr[11] + Er[11], cr[12] = Mr[12] + Er[12], cr[13] = Mr[13] + Er[13], cr[14] = Mr[14] + Er[14], cr[15] = Mr[15] + Er[15], cr;
        }, xi.subtract = kr, xi.multiplyScalar = function(cr, Mr, Er) {
          return cr[0] = Mr[0] * Er, cr[1] = Mr[1] * Er, cr[2] = Mr[2] * Er, cr[3] = Mr[3] * Er, cr[4] = Mr[4] * Er, cr[5] = Mr[5] * Er, cr[6] = Mr[6] * Er, cr[7] = Mr[7] * Er, cr[8] = Mr[8] * Er, cr[9] = Mr[9] * Er, cr[10] = Mr[10] * Er, cr[11] = Mr[11] * Er, cr[12] = Mr[12] * Er, cr[13] = Mr[13] * Er, cr[14] = Mr[14] * Er, cr[15] = Mr[15] * Er, cr;
        }, xi.multiplyScalarAndAdd = function(cr, Mr, Er, xr) {
          return cr[0] = Mr[0] + Er[0] * xr, cr[1] = Mr[1] + Er[1] * xr, cr[2] = Mr[2] + Er[2] * xr, cr[3] = Mr[3] + Er[3] * xr, cr[4] = Mr[4] + Er[4] * xr, cr[5] = Mr[5] + Er[5] * xr, cr[6] = Mr[6] + Er[6] * xr, cr[7] = Mr[7] + Er[7] * xr, cr[8] = Mr[8] + Er[8] * xr, cr[9] = Mr[9] + Er[9] * xr, cr[10] = Mr[10] + Er[10] * xr, cr[11] = Mr[11] + Er[11] * xr, cr[12] = Mr[12] + Er[12] * xr, cr[13] = Mr[13] + Er[13] * xr, cr[14] = Mr[14] + Er[14] * xr, cr[15] = Mr[15] + Er[15] * xr, cr;
        }, xi.exactEquals = function(cr, Mr) {
          return cr[0] === Mr[0] && cr[1] === Mr[1] && cr[2] === Mr[2] && cr[3] === Mr[3] && cr[4] === Mr[4] && cr[5] === Mr[5] && cr[6] === Mr[6] && cr[7] === Mr[7] && cr[8] === Mr[8] && cr[9] === Mr[9] && cr[10] === Mr[10] && cr[11] === Mr[11] && cr[12] === Mr[12] && cr[13] === Mr[13] && cr[14] === Mr[14] && cr[15] === Mr[15];
        }, xi.equals = function(cr, Mr) {
          var Er = cr[0], xr = cr[1], Sr = cr[2], Br = cr[3], Fr = cr[4], jr = cr[5], Qr = cr[6], ti = cr[7], Kr = cr[8], ni = cr[9], gi = cr[10], Si = cr[11], Di = cr[12], Ri = cr[13], Bi = cr[14], Ji = cr[15], Fi = Mr[0], tn = Mr[1], cn = Mr[2], ln = Mr[3], mn = Mr[4], wn = Mr[5], Cn = Mr[6], gn = Mr[7], Nn = Mr[8], oo = Mr[9], Un = Mr[10], fo = Mr[11], ho = Mr[12], bo = Mr[13], Jn = Mr[14], Ro = Mr[15];
          return Math.abs(Er - Fi) <= de.EPSILON * Math.max(1, Math.abs(Er), Math.abs(Fi)) && Math.abs(xr - tn) <= de.EPSILON * Math.max(1, Math.abs(xr), Math.abs(tn)) && Math.abs(Sr - cn) <= de.EPSILON * Math.max(1, Math.abs(Sr), Math.abs(cn)) && Math.abs(Br - ln) <= de.EPSILON * Math.max(1, Math.abs(Br), Math.abs(ln)) && Math.abs(Fr - mn) <= de.EPSILON * Math.max(1, Math.abs(Fr), Math.abs(mn)) && Math.abs(jr - wn) <= de.EPSILON * Math.max(1, Math.abs(jr), Math.abs(wn)) && Math.abs(Qr - Cn) <= de.EPSILON * Math.max(1, Math.abs(Qr), Math.abs(Cn)) && Math.abs(ti - gn) <= de.EPSILON * Math.max(1, Math.abs(ti), Math.abs(gn)) && Math.abs(Kr - Nn) <= de.EPSILON * Math.max(1, Math.abs(Kr), Math.abs(Nn)) && Math.abs(ni - oo) <= de.EPSILON * Math.max(1, Math.abs(ni), Math.abs(oo)) && Math.abs(gi - Un) <= de.EPSILON * Math.max(1, Math.abs(gi), Math.abs(Un)) && Math.abs(Si - fo) <= de.EPSILON * Math.max(1, Math.abs(Si), Math.abs(fo)) && Math.abs(Di - ho) <= de.EPSILON * Math.max(1, Math.abs(Di), Math.abs(ho)) && Math.abs(Ri - bo) <= de.EPSILON * Math.max(1, Math.abs(Ri), Math.abs(bo)) && Math.abs(Bi - Jn) <= de.EPSILON * Math.max(1, Math.abs(Bi), Math.abs(Jn)) && Math.abs(Ji - Ro) <= de.EPSILON * Math.max(1, Math.abs(Ji), Math.abs(Ro));
        }, xi.sub = xi.mul = xi.ortho = xi.perspective = void 0;
        var de = function(cr, Mr) {
          if (cr && cr.__esModule)
            return cr;
          if (cr === null || Ie(cr) !== "object" && typeof cr != "function")
            return { default: cr };
          var Er = Ce(void 0);
          if (Er && Er.has(cr))
            return Er.get(cr);
          var xr = {}, Sr = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var Br in cr)
            if (Br !== "default" && Object.prototype.hasOwnProperty.call(cr, Br)) {
              var Fr = Sr ? Object.getOwnPropertyDescriptor(cr, Br) : null;
              Fr && (Fr.get || Fr.set) ? Object.defineProperty(xr, Br, Fr) : xr[Br] = cr[Br];
            }
          return xr.default = cr, Er && Er.set(cr, xr), xr;
        }(Lr());
        function Ce(cr) {
          if (typeof WeakMap != "function")
            return null;
          var Mr = /* @__PURE__ */ new WeakMap(), Er = /* @__PURE__ */ new WeakMap();
          return (Ce = function(xr) {
            return xr ? Er : Mr;
          })(cr);
        }
        function De(cr) {
          return cr[0] = 1, cr[1] = 0, cr[2] = 0, cr[3] = 0, cr[4] = 0, cr[5] = 1, cr[6] = 0, cr[7] = 0, cr[8] = 0, cr[9] = 0, cr[10] = 1, cr[11] = 0, cr[12] = 0, cr[13] = 0, cr[14] = 0, cr[15] = 1, cr;
        }
        function Ke(cr, Mr, Er) {
          var xr = Mr[0], Sr = Mr[1], Br = Mr[2], Fr = Mr[3], jr = Mr[4], Qr = Mr[5], ti = Mr[6], Kr = Mr[7], ni = Mr[8], gi = Mr[9], Si = Mr[10], Di = Mr[11], Ri = Mr[12], Bi = Mr[13], Ji = Mr[14], Fi = Mr[15], tn = Er[0], cn = Er[1], ln = Er[2], mn = Er[3];
          return cr[0] = tn * xr + cn * jr + ln * ni + mn * Ri, cr[1] = tn * Sr + cn * Qr + ln * gi + mn * Bi, cr[2] = tn * Br + cn * ti + ln * Si + mn * Ji, cr[3] = tn * Fr + cn * Kr + ln * Di + mn * Fi, cr[4] = (tn = Er[4]) * xr + (cn = Er[5]) * jr + (ln = Er[6]) * ni + (mn = Er[7]) * Ri, cr[5] = tn * Sr + cn * Qr + ln * gi + mn * Bi, cr[6] = tn * Br + cn * ti + ln * Si + mn * Ji, cr[7] = tn * Fr + cn * Kr + ln * Di + mn * Fi, cr[8] = (tn = Er[8]) * xr + (cn = Er[9]) * jr + (ln = Er[10]) * ni + (mn = Er[11]) * Ri, cr[9] = tn * Sr + cn * Qr + ln * gi + mn * Bi, cr[10] = tn * Br + cn * ti + ln * Si + mn * Ji, cr[11] = tn * Fr + cn * Kr + ln * Di + mn * Fi, cr[12] = (tn = Er[12]) * xr + (cn = Er[13]) * jr + (ln = Er[14]) * ni + (mn = Er[15]) * Ri, cr[13] = tn * Sr + cn * Qr + ln * gi + mn * Bi, cr[14] = tn * Br + cn * ti + ln * Si + mn * Ji, cr[15] = tn * Fr + cn * Kr + ln * Di + mn * Fi, cr;
        }
        function Ve(cr, Mr, Er) {
          var xr = Mr[0], Sr = Mr[1], Br = Mr[2], Fr = Mr[3], jr = xr + xr, Qr = Sr + Sr, ti = Br + Br, Kr = xr * jr, ni = xr * Qr, gi = xr * ti, Si = Sr * Qr, Di = Sr * ti, Ri = Br * ti, Bi = Fr * jr, Ji = Fr * Qr, Fi = Fr * ti;
          return cr[0] = 1 - (Si + Ri), cr[1] = ni + Fi, cr[2] = gi - Ji, cr[3] = 0, cr[4] = ni - Fi, cr[5] = 1 - (Kr + Ri), cr[6] = Di + Bi, cr[7] = 0, cr[8] = gi + Ji, cr[9] = Di - Bi, cr[10] = 1 - (Kr + Si), cr[11] = 0, cr[12] = Er[0], cr[13] = Er[1], cr[14] = Er[2], cr[15] = 1, cr;
        }
        function er(cr, Mr) {
          var Er = Mr[4], xr = Mr[5], Sr = Mr[6], Br = Mr[8], Fr = Mr[9], jr = Mr[10];
          return cr[0] = Math.hypot(Mr[0], Mr[1], Mr[2]), cr[1] = Math.hypot(Er, xr, Sr), cr[2] = Math.hypot(Br, Fr, jr), cr;
        }
        function fr(cr, Mr, Er, xr, Sr) {
          var Br, Fr = 1 / Math.tan(Mr / 2);
          return cr[0] = Fr / Er, cr[1] = 0, cr[2] = 0, cr[3] = 0, cr[4] = 0, cr[5] = Fr, cr[6] = 0, cr[7] = 0, cr[8] = 0, cr[9] = 0, cr[11] = -1, cr[12] = 0, cr[13] = 0, cr[15] = 0, Sr != null && Sr !== 1 / 0 ? (cr[10] = (Sr + xr) * (Br = 1 / (xr - Sr)), cr[14] = 2 * Sr * xr * Br) : (cr[10] = -1, cr[14] = -2 * xr), cr;
        }
        function wr(cr, Mr, Er, xr, Sr, Br, Fr) {
          var jr = 1 / (Mr - Er), Qr = 1 / (xr - Sr), ti = 1 / (Br - Fr);
          return cr[0] = -2 * jr, cr[1] = 0, cr[2] = 0, cr[3] = 0, cr[4] = 0, cr[5] = -2 * Qr, cr[6] = 0, cr[7] = 0, cr[8] = 0, cr[9] = 0, cr[10] = 2 * ti, cr[11] = 0, cr[12] = (Mr + Er) * jr, cr[13] = (Sr + xr) * Qr, cr[14] = (Fr + Br) * ti, cr[15] = 1, cr;
        }
        function kr(cr, Mr, Er) {
          return cr[0] = Mr[0] - Er[0], cr[1] = Mr[1] - Er[1], cr[2] = Mr[2] - Er[2], cr[3] = Mr[3] - Er[3], cr[4] = Mr[4] - Er[4], cr[5] = Mr[5] - Er[5], cr[6] = Mr[6] - Er[6], cr[7] = Mr[7] - Er[7], cr[8] = Mr[8] - Er[8], cr[9] = Mr[9] - Er[9], cr[10] = Mr[10] - Er[10], cr[11] = Mr[11] - Er[11], cr[12] = Mr[12] - Er[12], cr[13] = Mr[13] - Er[13], cr[14] = Mr[14] - Er[14], cr[15] = Mr[15] - Er[15], cr;
        }
        return xi.perspective = fr, xi.ortho = wr, xi.mul = Ke, xi.sub = kr, xi;
      }
      var oi, ci = {}, vr = {};
      function Ae() {
        if (oi)
          return vr;
        function Ie(Sr) {
          return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Br) {
            return typeof Br;
          } : function(Br) {
            return Br && typeof Symbol == "function" && Br.constructor === Symbol && Br !== Symbol.prototype ? "symbol" : typeof Br;
          }, Ie(Sr);
        }
        oi = 1, Object.defineProperty(vr, "__esModule", { value: !0 }), vr.create = De, vr.clone = function(Sr) {
          var Br = new de.ARRAY_TYPE(3);
          return Br[0] = Sr[0], Br[1] = Sr[1], Br[2] = Sr[2], Br;
        }, vr.length = Ke, vr.fromValues = function(Sr, Br, Fr) {
          var jr = new de.ARRAY_TYPE(3);
          return jr[0] = Sr, jr[1] = Br, jr[2] = Fr, jr;
        }, vr.copy = function(Sr, Br) {
          return Sr[0] = Br[0], Sr[1] = Br[1], Sr[2] = Br[2], Sr;
        }, vr.set = function(Sr, Br, Fr, jr) {
          return Sr[0] = Br, Sr[1] = Fr, Sr[2] = jr, Sr;
        }, vr.add = function(Sr, Br, Fr) {
          return Sr[0] = Br[0] + Fr[0], Sr[1] = Br[1] + Fr[1], Sr[2] = Br[2] + Fr[2], Sr;
        }, vr.subtract = Ve, vr.multiply = er, vr.divide = fr, vr.ceil = function(Sr, Br) {
          return Sr[0] = Math.ceil(Br[0]), Sr[1] = Math.ceil(Br[1]), Sr[2] = Math.ceil(Br[2]), Sr;
        }, vr.floor = function(Sr, Br) {
          return Sr[0] = Math.floor(Br[0]), Sr[1] = Math.floor(Br[1]), Sr[2] = Math.floor(Br[2]), Sr;
        }, vr.min = function(Sr, Br, Fr) {
          return Sr[0] = Math.min(Br[0], Fr[0]), Sr[1] = Math.min(Br[1], Fr[1]), Sr[2] = Math.min(Br[2], Fr[2]), Sr;
        }, vr.max = function(Sr, Br, Fr) {
          return Sr[0] = Math.max(Br[0], Fr[0]), Sr[1] = Math.max(Br[1], Fr[1]), Sr[2] = Math.max(Br[2], Fr[2]), Sr;
        }, vr.round = function(Sr, Br) {
          return Sr[0] = Math.round(Br[0]), Sr[1] = Math.round(Br[1]), Sr[2] = Math.round(Br[2]), Sr;
        }, vr.scale = function(Sr, Br, Fr) {
          return Sr[0] = Br[0] * Fr, Sr[1] = Br[1] * Fr, Sr[2] = Br[2] * Fr, Sr;
        }, vr.scaleAndAdd = function(Sr, Br, Fr, jr) {
          return Sr[0] = Br[0] + Fr[0] * jr, Sr[1] = Br[1] + Fr[1] * jr, Sr[2] = Br[2] + Fr[2] * jr, Sr;
        }, vr.distance = wr, vr.squaredDistance = kr, vr.squaredLength = cr, vr.negate = function(Sr, Br) {
          return Sr[0] = -Br[0], Sr[1] = -Br[1], Sr[2] = -Br[2], Sr;
        }, vr.inverse = function(Sr, Br) {
          return Sr[0] = 1 / Br[0], Sr[1] = 1 / Br[1], Sr[2] = 1 / Br[2], Sr;
        }, vr.normalize = function(Sr, Br) {
          var Fr = Br[0], jr = Br[1], Qr = Br[2], ti = Fr * Fr + jr * jr + Qr * Qr;
          return ti > 0 && (ti = 1 / Math.sqrt(ti)), Sr[0] = Br[0] * ti, Sr[1] = Br[1] * ti, Sr[2] = Br[2] * ti, Sr;
        }, vr.dot = Mr, vr.cross = function(Sr, Br, Fr) {
          var jr = Br[0], Qr = Br[1], ti = Br[2], Kr = Fr[0], ni = Fr[1], gi = Fr[2];
          return Sr[0] = Qr * gi - ti * ni, Sr[1] = ti * Kr - jr * gi, Sr[2] = jr * ni - Qr * Kr, Sr;
        }, vr.lerp = function(Sr, Br, Fr, jr) {
          var Qr = Br[0], ti = Br[1], Kr = Br[2];
          return Sr[0] = Qr + jr * (Fr[0] - Qr), Sr[1] = ti + jr * (Fr[1] - ti), Sr[2] = Kr + jr * (Fr[2] - Kr), Sr;
        }, vr.hermite = function(Sr, Br, Fr, jr, Qr, ti) {
          var Kr = ti * ti, ni = Kr * (2 * ti - 3) + 1, gi = Kr * (ti - 2) + ti, Si = Kr * (ti - 1), Di = Kr * (3 - 2 * ti);
          return Sr[0] = Br[0] * ni + Fr[0] * gi + jr[0] * Si + Qr[0] * Di, Sr[1] = Br[1] * ni + Fr[1] * gi + jr[1] * Si + Qr[1] * Di, Sr[2] = Br[2] * ni + Fr[2] * gi + jr[2] * Si + Qr[2] * Di, Sr;
        }, vr.bezier = function(Sr, Br, Fr, jr, Qr, ti) {
          var Kr = 1 - ti, ni = Kr * Kr, gi = ti * ti, Si = ni * Kr, Di = 3 * ti * ni, Ri = 3 * gi * Kr, Bi = gi * ti;
          return Sr[0] = Br[0] * Si + Fr[0] * Di + jr[0] * Ri + Qr[0] * Bi, Sr[1] = Br[1] * Si + Fr[1] * Di + jr[1] * Ri + Qr[1] * Bi, Sr[2] = Br[2] * Si + Fr[2] * Di + jr[2] * Ri + Qr[2] * Bi, Sr;
        }, vr.random = function(Sr, Br) {
          Br = Br || 1;
          var Fr = 2 * de.RANDOM() * Math.PI, jr = 2 * de.RANDOM() - 1, Qr = Math.sqrt(1 - jr * jr) * Br;
          return Sr[0] = Math.cos(Fr) * Qr, Sr[1] = Math.sin(Fr) * Qr, Sr[2] = jr * Br, Sr;
        }, vr.transformMat4 = function(Sr, Br, Fr) {
          var jr = Br[0], Qr = Br[1], ti = Br[2], Kr = Fr[3] * jr + Fr[7] * Qr + Fr[11] * ti + Fr[15];
          return Sr[0] = (Fr[0] * jr + Fr[4] * Qr + Fr[8] * ti + Fr[12]) / (Kr = Kr || 1), Sr[1] = (Fr[1] * jr + Fr[5] * Qr + Fr[9] * ti + Fr[13]) / Kr, Sr[2] = (Fr[2] * jr + Fr[6] * Qr + Fr[10] * ti + Fr[14]) / Kr, Sr;
        }, vr.transformMat3 = function(Sr, Br, Fr) {
          var jr = Br[0], Qr = Br[1], ti = Br[2];
          return Sr[0] = jr * Fr[0] + Qr * Fr[3] + ti * Fr[6], Sr[1] = jr * Fr[1] + Qr * Fr[4] + ti * Fr[7], Sr[2] = jr * Fr[2] + Qr * Fr[5] + ti * Fr[8], Sr;
        }, vr.transformQuat = function(Sr, Br, Fr) {
          var jr = Fr[0], Qr = Fr[1], ti = Fr[2], Kr = Br[0], ni = Br[1], gi = Br[2], Si = Qr * gi - ti * ni, Di = ti * Kr - jr * gi, Ri = jr * ni - Qr * Kr, Bi = Qr * Ri - ti * Di, Ji = ti * Si - jr * Ri, Fi = jr * Di - Qr * Si, tn = 2 * Fr[3];
          return Di *= tn, Ri *= tn, Ji *= 2, Fi *= 2, Sr[0] = Kr + (Si *= tn) + (Bi *= 2), Sr[1] = ni + Di + Ji, Sr[2] = gi + Ri + Fi, Sr;
        }, vr.rotateX = function(Sr, Br, Fr, jr) {
          var Qr = [], ti = [];
          return Qr[0] = Br[0] - Fr[0], Qr[1] = Br[1] - Fr[1], Qr[2] = Br[2] - Fr[2], ti[0] = Qr[0], ti[1] = Qr[1] * Math.cos(jr) - Qr[2] * Math.sin(jr), ti[2] = Qr[1] * Math.sin(jr) + Qr[2] * Math.cos(jr), Sr[0] = ti[0] + Fr[0], Sr[1] = ti[1] + Fr[1], Sr[2] = ti[2] + Fr[2], Sr;
        }, vr.rotateY = function(Sr, Br, Fr, jr) {
          var Qr = [], ti = [];
          return Qr[0] = Br[0] - Fr[0], Qr[1] = Br[1] - Fr[1], Qr[2] = Br[2] - Fr[2], ti[0] = Qr[2] * Math.sin(jr) + Qr[0] * Math.cos(jr), ti[1] = Qr[1], ti[2] = Qr[2] * Math.cos(jr) - Qr[0] * Math.sin(jr), Sr[0] = ti[0] + Fr[0], Sr[1] = ti[1] + Fr[1], Sr[2] = ti[2] + Fr[2], Sr;
        }, vr.rotateZ = function(Sr, Br, Fr, jr) {
          var Qr = [], ti = [];
          return Qr[0] = Br[0] - Fr[0], Qr[1] = Br[1] - Fr[1], Qr[2] = Br[2] - Fr[2], ti[0] = Qr[0] * Math.cos(jr) - Qr[1] * Math.sin(jr), ti[1] = Qr[0] * Math.sin(jr) + Qr[1] * Math.cos(jr), ti[2] = Qr[2], Sr[0] = ti[0] + Fr[0], Sr[1] = ti[1] + Fr[1], Sr[2] = ti[2] + Fr[2], Sr;
        }, vr.angle = function(Sr, Br) {
          var Fr = Sr[0], jr = Sr[1], Qr = Sr[2], ti = Br[0], Kr = Br[1], ni = Br[2], gi = Math.sqrt(Fr * Fr + jr * jr + Qr * Qr) * Math.sqrt(ti * ti + Kr * Kr + ni * ni), Si = gi && Mr(Sr, Br) / gi;
          return Math.acos(Math.min(Math.max(Si, -1), 1));
        }, vr.zero = function(Sr) {
          return Sr[0] = 0, Sr[1] = 0, Sr[2] = 0, Sr;
        }, vr.str = function(Sr) {
          return "vec3(" + Sr[0] + ", " + Sr[1] + ", " + Sr[2] + ")";
        }, vr.exactEquals = function(Sr, Br) {
          return Sr[0] === Br[0] && Sr[1] === Br[1] && Sr[2] === Br[2];
        }, vr.equals = function(Sr, Br) {
          var Fr = Sr[0], jr = Sr[1], Qr = Sr[2], ti = Br[0], Kr = Br[1], ni = Br[2];
          return Math.abs(Fr - ti) <= de.EPSILON * Math.max(1, Math.abs(Fr), Math.abs(ti)) && Math.abs(jr - Kr) <= de.EPSILON * Math.max(1, Math.abs(jr), Math.abs(Kr)) && Math.abs(Qr - ni) <= de.EPSILON * Math.max(1, Math.abs(Qr), Math.abs(ni));
        }, vr.forEach = vr.sqrLen = vr.len = vr.sqrDist = vr.dist = vr.div = vr.mul = vr.sub = void 0;
        var de = function(Sr, Br) {
          if (Sr && Sr.__esModule)
            return Sr;
          if (Sr === null || Ie(Sr) !== "object" && typeof Sr != "function")
            return { default: Sr };
          var Fr = Ce(void 0);
          if (Fr && Fr.has(Sr))
            return Fr.get(Sr);
          var jr = {}, Qr = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var ti in Sr)
            if (ti !== "default" && Object.prototype.hasOwnProperty.call(Sr, ti)) {
              var Kr = Qr ? Object.getOwnPropertyDescriptor(Sr, ti) : null;
              Kr && (Kr.get || Kr.set) ? Object.defineProperty(jr, ti, Kr) : jr[ti] = Sr[ti];
            }
          return jr.default = Sr, Fr && Fr.set(Sr, jr), jr;
        }(Lr());
        function Ce(Sr) {
          if (typeof WeakMap != "function")
            return null;
          var Br = /* @__PURE__ */ new WeakMap(), Fr = /* @__PURE__ */ new WeakMap();
          return (Ce = function(jr) {
            return jr ? Fr : Br;
          })(Sr);
        }
        function De() {
          var Sr = new de.ARRAY_TYPE(3);
          return de.ARRAY_TYPE != Float32Array && (Sr[0] = 0, Sr[1] = 0, Sr[2] = 0), Sr;
        }
        function Ke(Sr) {
          return Math.hypot(Sr[0], Sr[1], Sr[2]);
        }
        function Ve(Sr, Br, Fr) {
          return Sr[0] = Br[0] - Fr[0], Sr[1] = Br[1] - Fr[1], Sr[2] = Br[2] - Fr[2], Sr;
        }
        function er(Sr, Br, Fr) {
          return Sr[0] = Br[0] * Fr[0], Sr[1] = Br[1] * Fr[1], Sr[2] = Br[2] * Fr[2], Sr;
        }
        function fr(Sr, Br, Fr) {
          return Sr[0] = Br[0] / Fr[0], Sr[1] = Br[1] / Fr[1], Sr[2] = Br[2] / Fr[2], Sr;
        }
        function wr(Sr, Br) {
          return Math.hypot(Br[0] - Sr[0], Br[1] - Sr[1], Br[2] - Sr[2]);
        }
        function kr(Sr, Br) {
          var Fr = Br[0] - Sr[0], jr = Br[1] - Sr[1], Qr = Br[2] - Sr[2];
          return Fr * Fr + jr * jr + Qr * Qr;
        }
        function cr(Sr) {
          var Br = Sr[0], Fr = Sr[1], jr = Sr[2];
          return Br * Br + Fr * Fr + jr * jr;
        }
        function Mr(Sr, Br) {
          return Sr[0] * Br[0] + Sr[1] * Br[1] + Sr[2] * Br[2];
        }
        vr.sub = Ve, vr.mul = er, vr.div = fr, vr.dist = wr, vr.sqrDist = kr, vr.len = Ke, vr.sqrLen = cr;
        var Er, xr = (Er = De(), function(Sr, Br, Fr, jr, Qr, ti) {
          var Kr, ni;
          for (Br || (Br = 3), Fr || (Fr = 0), ni = jr ? Math.min(jr * Br + Fr, Sr.length) : Sr.length, Kr = Fr; Kr < ni; Kr += Br)
            Er[0] = Sr[Kr], Er[1] = Sr[Kr + 1], Er[2] = Sr[Kr + 2], Qr(Er, Er, ti), Sr[Kr] = Er[0], Sr[Kr + 1] = Er[1], Sr[Kr + 2] = Er[2];
          return Sr;
        });
        return vr.forEach = xr, vr;
      }
      var ze, Ue, tr = {};
      function lr() {
        if (ze)
          return tr;
        function Ie(xr) {
          return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Sr) {
            return typeof Sr;
          } : function(Sr) {
            return Sr && typeof Symbol == "function" && Sr.constructor === Symbol && Sr !== Symbol.prototype ? "symbol" : typeof Sr;
          }, Ie(xr);
        }
        ze = 1, Object.defineProperty(tr, "__esModule", { value: !0 }), tr.create = De, tr.clone = function(xr) {
          var Sr = new de.ARRAY_TYPE(4);
          return Sr[0] = xr[0], Sr[1] = xr[1], Sr[2] = xr[2], Sr[3] = xr[3], Sr;
        }, tr.fromValues = function(xr, Sr, Br, Fr) {
          var jr = new de.ARRAY_TYPE(4);
          return jr[0] = xr, jr[1] = Sr, jr[2] = Br, jr[3] = Fr, jr;
        }, tr.copy = function(xr, Sr) {
          return xr[0] = Sr[0], xr[1] = Sr[1], xr[2] = Sr[2], xr[3] = Sr[3], xr;
        }, tr.set = function(xr, Sr, Br, Fr, jr) {
          return xr[0] = Sr, xr[1] = Br, xr[2] = Fr, xr[3] = jr, xr;
        }, tr.add = function(xr, Sr, Br) {
          return xr[0] = Sr[0] + Br[0], xr[1] = Sr[1] + Br[1], xr[2] = Sr[2] + Br[2], xr[3] = Sr[3] + Br[3], xr;
        }, tr.subtract = Ke, tr.multiply = Ve, tr.divide = er, tr.ceil = function(xr, Sr) {
          return xr[0] = Math.ceil(Sr[0]), xr[1] = Math.ceil(Sr[1]), xr[2] = Math.ceil(Sr[2]), xr[3] = Math.ceil(Sr[3]), xr;
        }, tr.floor = function(xr, Sr) {
          return xr[0] = Math.floor(Sr[0]), xr[1] = Math.floor(Sr[1]), xr[2] = Math.floor(Sr[2]), xr[3] = Math.floor(Sr[3]), xr;
        }, tr.min = function(xr, Sr, Br) {
          return xr[0] = Math.min(Sr[0], Br[0]), xr[1] = Math.min(Sr[1], Br[1]), xr[2] = Math.min(Sr[2], Br[2]), xr[3] = Math.min(Sr[3], Br[3]), xr;
        }, tr.max = function(xr, Sr, Br) {
          return xr[0] = Math.max(Sr[0], Br[0]), xr[1] = Math.max(Sr[1], Br[1]), xr[2] = Math.max(Sr[2], Br[2]), xr[3] = Math.max(Sr[3], Br[3]), xr;
        }, tr.round = function(xr, Sr) {
          return xr[0] = Math.round(Sr[0]), xr[1] = Math.round(Sr[1]), xr[2] = Math.round(Sr[2]), xr[3] = Math.round(Sr[3]), xr;
        }, tr.scale = function(xr, Sr, Br) {
          return xr[0] = Sr[0] * Br, xr[1] = Sr[1] * Br, xr[2] = Sr[2] * Br, xr[3] = Sr[3] * Br, xr;
        }, tr.scaleAndAdd = function(xr, Sr, Br, Fr) {
          return xr[0] = Sr[0] + Br[0] * Fr, xr[1] = Sr[1] + Br[1] * Fr, xr[2] = Sr[2] + Br[2] * Fr, xr[3] = Sr[3] + Br[3] * Fr, xr;
        }, tr.distance = fr, tr.squaredDistance = wr, tr.length = kr, tr.squaredLength = cr, tr.negate = function(xr, Sr) {
          return xr[0] = -Sr[0], xr[1] = -Sr[1], xr[2] = -Sr[2], xr[3] = -Sr[3], xr;
        }, tr.inverse = function(xr, Sr) {
          return xr[0] = 1 / Sr[0], xr[1] = 1 / Sr[1], xr[2] = 1 / Sr[2], xr[3] = 1 / Sr[3], xr;
        }, tr.normalize = function(xr, Sr) {
          var Br = Sr[0], Fr = Sr[1], jr = Sr[2], Qr = Sr[3], ti = Br * Br + Fr * Fr + jr * jr + Qr * Qr;
          return ti > 0 && (ti = 1 / Math.sqrt(ti)), xr[0] = Br * ti, xr[1] = Fr * ti, xr[2] = jr * ti, xr[3] = Qr * ti, xr;
        }, tr.dot = function(xr, Sr) {
          return xr[0] * Sr[0] + xr[1] * Sr[1] + xr[2] * Sr[2] + xr[3] * Sr[3];
        }, tr.cross = function(xr, Sr, Br, Fr) {
          var jr = Br[0] * Fr[1] - Br[1] * Fr[0], Qr = Br[0] * Fr[2] - Br[2] * Fr[0], ti = Br[0] * Fr[3] - Br[3] * Fr[0], Kr = Br[1] * Fr[2] - Br[2] * Fr[1], ni = Br[1] * Fr[3] - Br[3] * Fr[1], gi = Br[2] * Fr[3] - Br[3] * Fr[2], Si = Sr[0], Di = Sr[1], Ri = Sr[2], Bi = Sr[3];
          return xr[0] = Di * gi - Ri * ni + Bi * Kr, xr[1] = -Si * gi + Ri * ti - Bi * Qr, xr[2] = Si * ni - Di * ti + Bi * jr, xr[3] = -Si * Kr + Di * Qr - Ri * jr, xr;
        }, tr.lerp = function(xr, Sr, Br, Fr) {
          var jr = Sr[0], Qr = Sr[1], ti = Sr[2], Kr = Sr[3];
          return xr[0] = jr + Fr * (Br[0] - jr), xr[1] = Qr + Fr * (Br[1] - Qr), xr[2] = ti + Fr * (Br[2] - ti), xr[3] = Kr + Fr * (Br[3] - Kr), xr;
        }, tr.random = function(xr, Sr) {
          var Br, Fr, jr, Qr, ti, Kr;
          Sr = Sr || 1;
          do
            ti = (Br = 2 * de.RANDOM() - 1) * Br + (Fr = 2 * de.RANDOM() - 1) * Fr;
          while (ti >= 1);
          do
            Kr = (jr = 2 * de.RANDOM() - 1) * jr + (Qr = 2 * de.RANDOM() - 1) * Qr;
          while (Kr >= 1);
          var ni = Math.sqrt((1 - ti) / Kr);
          return xr[0] = Sr * Br, xr[1] = Sr * Fr, xr[2] = Sr * jr * ni, xr[3] = Sr * Qr * ni, xr;
        }, tr.transformMat4 = function(xr, Sr, Br) {
          var Fr = Sr[0], jr = Sr[1], Qr = Sr[2], ti = Sr[3];
          return xr[0] = Br[0] * Fr + Br[4] * jr + Br[8] * Qr + Br[12] * ti, xr[1] = Br[1] * Fr + Br[5] * jr + Br[9] * Qr + Br[13] * ti, xr[2] = Br[2] * Fr + Br[6] * jr + Br[10] * Qr + Br[14] * ti, xr[3] = Br[3] * Fr + Br[7] * jr + Br[11] * Qr + Br[15] * ti, xr;
        }, tr.transformQuat = function(xr, Sr, Br) {
          var Fr = Sr[0], jr = Sr[1], Qr = Sr[2], ti = Br[0], Kr = Br[1], ni = Br[2], gi = Br[3], Si = gi * Fr + Kr * Qr - ni * jr, Di = gi * jr + ni * Fr - ti * Qr, Ri = gi * Qr + ti * jr - Kr * Fr, Bi = -ti * Fr - Kr * jr - ni * Qr;
          return xr[0] = Si * gi + Bi * -ti + Di * -ni - Ri * -Kr, xr[1] = Di * gi + Bi * -Kr + Ri * -ti - Si * -ni, xr[2] = Ri * gi + Bi * -ni + Si * -Kr - Di * -ti, xr[3] = Sr[3], xr;
        }, tr.zero = function(xr) {
          return xr[0] = 0, xr[1] = 0, xr[2] = 0, xr[3] = 0, xr;
        }, tr.str = function(xr) {
          return "vec4(" + xr[0] + ", " + xr[1] + ", " + xr[2] + ", " + xr[3] + ")";
        }, tr.exactEquals = function(xr, Sr) {
          return xr[0] === Sr[0] && xr[1] === Sr[1] && xr[2] === Sr[2] && xr[3] === Sr[3];
        }, tr.equals = function(xr, Sr) {
          var Br = xr[0], Fr = xr[1], jr = xr[2], Qr = xr[3], ti = Sr[0], Kr = Sr[1], ni = Sr[2], gi = Sr[3];
          return Math.abs(Br - ti) <= de.EPSILON * Math.max(1, Math.abs(Br), Math.abs(ti)) && Math.abs(Fr - Kr) <= de.EPSILON * Math.max(1, Math.abs(Fr), Math.abs(Kr)) && Math.abs(jr - ni) <= de.EPSILON * Math.max(1, Math.abs(jr), Math.abs(ni)) && Math.abs(Qr - gi) <= de.EPSILON * Math.max(1, Math.abs(Qr), Math.abs(gi));
        }, tr.forEach = tr.sqrLen = tr.len = tr.sqrDist = tr.dist = tr.div = tr.mul = tr.sub = void 0;
        var de = function(xr, Sr) {
          if (xr && xr.__esModule)
            return xr;
          if (xr === null || Ie(xr) !== "object" && typeof xr != "function")
            return { default: xr };
          var Br = Ce(void 0);
          if (Br && Br.has(xr))
            return Br.get(xr);
          var Fr = {}, jr = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var Qr in xr)
            if (Qr !== "default" && Object.prototype.hasOwnProperty.call(xr, Qr)) {
              var ti = jr ? Object.getOwnPropertyDescriptor(xr, Qr) : null;
              ti && (ti.get || ti.set) ? Object.defineProperty(Fr, Qr, ti) : Fr[Qr] = xr[Qr];
            }
          return Fr.default = xr, Br && Br.set(xr, Fr), Fr;
        }(Lr());
        function Ce(xr) {
          if (typeof WeakMap != "function")
            return null;
          var Sr = /* @__PURE__ */ new WeakMap(), Br = /* @__PURE__ */ new WeakMap();
          return (Ce = function(Fr) {
            return Fr ? Br : Sr;
          })(xr);
        }
        function De() {
          var xr = new de.ARRAY_TYPE(4);
          return de.ARRAY_TYPE != Float32Array && (xr[0] = 0, xr[1] = 0, xr[2] = 0, xr[3] = 0), xr;
        }
        function Ke(xr, Sr, Br) {
          return xr[0] = Sr[0] - Br[0], xr[1] = Sr[1] - Br[1], xr[2] = Sr[2] - Br[2], xr[3] = Sr[3] - Br[3], xr;
        }
        function Ve(xr, Sr, Br) {
          return xr[0] = Sr[0] * Br[0], xr[1] = Sr[1] * Br[1], xr[2] = Sr[2] * Br[2], xr[3] = Sr[3] * Br[3], xr;
        }
        function er(xr, Sr, Br) {
          return xr[0] = Sr[0] / Br[0], xr[1] = Sr[1] / Br[1], xr[2] = Sr[2] / Br[2], xr[3] = Sr[3] / Br[3], xr;
        }
        function fr(xr, Sr) {
          return Math.hypot(Sr[0] - xr[0], Sr[1] - xr[1], Sr[2] - xr[2], Sr[3] - xr[3]);
        }
        function wr(xr, Sr) {
          var Br = Sr[0] - xr[0], Fr = Sr[1] - xr[1], jr = Sr[2] - xr[2], Qr = Sr[3] - xr[3];
          return Br * Br + Fr * Fr + jr * jr + Qr * Qr;
        }
        function kr(xr) {
          return Math.hypot(xr[0], xr[1], xr[2], xr[3]);
        }
        function cr(xr) {
          var Sr = xr[0], Br = xr[1], Fr = xr[2], jr = xr[3];
          return Sr * Sr + Br * Br + Fr * Fr + jr * jr;
        }
        tr.sub = Ke, tr.mul = Ve, tr.div = er, tr.dist = fr, tr.sqrDist = wr, tr.len = kr, tr.sqrLen = cr;
        var Mr, Er = (Mr = De(), function(xr, Sr, Br, Fr, jr, Qr) {
          var ti, Kr;
          for (Sr || (Sr = 4), Br || (Br = 0), Kr = Fr ? Math.min(Fr * Sr + Br, xr.length) : xr.length, ti = Br; ti < Kr; ti += Sr)
            Mr[0] = xr[ti], Mr[1] = xr[ti + 1], Mr[2] = xr[ti + 2], Mr[3] = xr[ti + 3], jr(Mr, Mr, Qr), xr[ti] = Mr[0], xr[ti + 1] = Mr[1], xr[ti + 2] = Mr[2], xr[ti + 3] = Mr[3];
          return xr;
        });
        return tr.forEach = Er, tr;
      }
      function pr() {
        if (Ue)
          return ci;
        function Ie(Fi) {
          return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(tn) {
            return typeof tn;
          } : function(tn) {
            return tn && typeof Symbol == "function" && tn.constructor === Symbol && tn !== Symbol.prototype ? "symbol" : typeof tn;
          }, Ie(Fi);
        }
        Ue = 1, Object.defineProperty(ci, "__esModule", { value: !0 }), ci.create = fr, ci.identity = function(Fi) {
          return Fi[0] = 0, Fi[1] = 0, Fi[2] = 0, Fi[3] = 1, Fi;
        }, ci.setAxisAngle = wr, ci.getAxisAngle = function(Fi, tn) {
          var cn = 2 * Math.acos(tn[3]), ln = Math.sin(cn / 2);
          return ln > de.EPSILON ? (Fi[0] = tn[0] / ln, Fi[1] = tn[1] / ln, Fi[2] = tn[2] / ln) : (Fi[0] = 1, Fi[1] = 0, Fi[2] = 0), cn;
        }, ci.getAngle = function(Fi, tn) {
          var cn = Br(Fi, tn);
          return Math.acos(2 * cn * cn - 1);
        }, ci.multiply = kr, ci.rotateX = function(Fi, tn, cn) {
          cn *= 0.5;
          var ln = tn[0], mn = tn[1], wn = tn[2], Cn = tn[3], gn = Math.sin(cn), Nn = Math.cos(cn);
          return Fi[0] = ln * Nn + Cn * gn, Fi[1] = mn * Nn + wn * gn, Fi[2] = wn * Nn - mn * gn, Fi[3] = Cn * Nn - ln * gn, Fi;
        }, ci.rotateY = function(Fi, tn, cn) {
          cn *= 0.5;
          var ln = tn[0], mn = tn[1], wn = tn[2], Cn = tn[3], gn = Math.sin(cn), Nn = Math.cos(cn);
          return Fi[0] = ln * Nn - wn * gn, Fi[1] = mn * Nn + Cn * gn, Fi[2] = wn * Nn + ln * gn, Fi[3] = Cn * Nn - mn * gn, Fi;
        }, ci.rotateZ = function(Fi, tn, cn) {
          cn *= 0.5;
          var ln = tn[0], mn = tn[1], wn = tn[2], Cn = tn[3], gn = Math.sin(cn), Nn = Math.cos(cn);
          return Fi[0] = ln * Nn + mn * gn, Fi[1] = mn * Nn - ln * gn, Fi[2] = wn * Nn + Cn * gn, Fi[3] = Cn * Nn - wn * gn, Fi;
        }, ci.calculateW = function(Fi, tn) {
          var cn = tn[0], ln = tn[1], mn = tn[2];
          return Fi[0] = cn, Fi[1] = ln, Fi[2] = mn, Fi[3] = Math.sqrt(Math.abs(1 - cn * cn - ln * ln - mn * mn)), Fi;
        }, ci.exp = cr, ci.ln = Mr, ci.pow = function(Fi, tn, cn) {
          return Mr(Fi, tn), Sr(Fi, Fi, cn), cr(Fi, Fi), Fi;
        }, ci.slerp = Er, ci.random = function(Fi) {
          var tn = de.RANDOM(), cn = de.RANDOM(), ln = de.RANDOM(), mn = Math.sqrt(1 - tn), wn = Math.sqrt(tn);
          return Fi[0] = mn * Math.sin(2 * Math.PI * cn), Fi[1] = mn * Math.cos(2 * Math.PI * cn), Fi[2] = wn * Math.sin(2 * Math.PI * ln), Fi[3] = wn * Math.cos(2 * Math.PI * ln), Fi;
        }, ci.invert = function(Fi, tn) {
          var cn = tn[0], ln = tn[1], mn = tn[2], wn = tn[3], Cn = cn * cn + ln * ln + mn * mn + wn * wn, gn = Cn ? 1 / Cn : 0;
          return Fi[0] = -cn * gn, Fi[1] = -ln * gn, Fi[2] = -mn * gn, Fi[3] = wn * gn, Fi;
        }, ci.conjugate = function(Fi, tn) {
          return Fi[0] = -tn[0], Fi[1] = -tn[1], Fi[2] = -tn[2], Fi[3] = tn[3], Fi;
        }, ci.fromMat3 = xr, ci.fromEuler = function(Fi, tn, cn, ln) {
          var mn = 0.5 * Math.PI / 180;
          tn *= mn, cn *= mn, ln *= mn;
          var wn = Math.sin(tn), Cn = Math.cos(tn), gn = Math.sin(cn), Nn = Math.cos(cn), oo = Math.sin(ln), Un = Math.cos(ln);
          return Fi[0] = wn * Nn * Un - Cn * gn * oo, Fi[1] = Cn * gn * Un + wn * Nn * oo, Fi[2] = Cn * Nn * oo - wn * gn * Un, Fi[3] = Cn * Nn * Un + wn * gn * oo, Fi;
        }, ci.str = function(Fi) {
          return "quat(" + Fi[0] + ", " + Fi[1] + ", " + Fi[2] + ", " + Fi[3] + ")";
        }, ci.setAxes = ci.sqlerp = ci.rotationTo = ci.equals = ci.exactEquals = ci.normalize = ci.sqrLen = ci.squaredLength = ci.len = ci.length = ci.lerp = ci.dot = ci.scale = ci.mul = ci.add = ci.set = ci.copy = ci.fromValues = ci.clone = void 0;
        var de = er(Lr()), Ce = er(si()), De = er(Ae()), Ke = er(lr());
        function Ve(Fi) {
          if (typeof WeakMap != "function")
            return null;
          var tn = /* @__PURE__ */ new WeakMap(), cn = /* @__PURE__ */ new WeakMap();
          return (Ve = function(ln) {
            return ln ? cn : tn;
          })(Fi);
        }
        function er(Fi, tn) {
          if (Fi && Fi.__esModule)
            return Fi;
          if (Fi === null || Ie(Fi) !== "object" && typeof Fi != "function")
            return { default: Fi };
          var cn = Ve(tn);
          if (cn && cn.has(Fi))
            return cn.get(Fi);
          var ln = {}, mn = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var wn in Fi)
            if (wn !== "default" && Object.prototype.hasOwnProperty.call(Fi, wn)) {
              var Cn = mn ? Object.getOwnPropertyDescriptor(Fi, wn) : null;
              Cn && (Cn.get || Cn.set) ? Object.defineProperty(ln, wn, Cn) : ln[wn] = Fi[wn];
            }
          return ln.default = Fi, cn && cn.set(Fi, ln), ln;
        }
        function fr() {
          var Fi = new de.ARRAY_TYPE(4);
          return de.ARRAY_TYPE != Float32Array && (Fi[0] = 0, Fi[1] = 0, Fi[2] = 0), Fi[3] = 1, Fi;
        }
        function wr(Fi, tn, cn) {
          cn *= 0.5;
          var ln = Math.sin(cn);
          return Fi[0] = ln * tn[0], Fi[1] = ln * tn[1], Fi[2] = ln * tn[2], Fi[3] = Math.cos(cn), Fi;
        }
        function kr(Fi, tn, cn) {
          var ln = tn[0], mn = tn[1], wn = tn[2], Cn = tn[3], gn = cn[0], Nn = cn[1], oo = cn[2], Un = cn[3];
          return Fi[0] = ln * Un + Cn * gn + mn * oo - wn * Nn, Fi[1] = mn * Un + Cn * Nn + wn * gn - ln * oo, Fi[2] = wn * Un + Cn * oo + ln * Nn - mn * gn, Fi[3] = Cn * Un - ln * gn - mn * Nn - wn * oo, Fi;
        }
        function cr(Fi, tn) {
          var cn = tn[0], ln = tn[1], mn = tn[2], wn = tn[3], Cn = Math.sqrt(cn * cn + ln * ln + mn * mn), gn = Math.exp(wn), Nn = Cn > 0 ? gn * Math.sin(Cn) / Cn : 0;
          return Fi[0] = cn * Nn, Fi[1] = ln * Nn, Fi[2] = mn * Nn, Fi[3] = gn * Math.cos(Cn), Fi;
        }
        function Mr(Fi, tn) {
          var cn = tn[0], ln = tn[1], mn = tn[2], wn = tn[3], Cn = Math.sqrt(cn * cn + ln * ln + mn * mn), gn = Cn > 0 ? Math.atan2(Cn, wn) / Cn : 0;
          return Fi[0] = cn * gn, Fi[1] = ln * gn, Fi[2] = mn * gn, Fi[3] = 0.5 * Math.log(cn * cn + ln * ln + mn * mn + wn * wn), Fi;
        }
        function Er(Fi, tn, cn, ln) {
          var mn, wn, Cn, gn, Nn, oo = tn[0], Un = tn[1], fo = tn[2], ho = tn[3], bo = cn[0], Jn = cn[1], Ro = cn[2], po = cn[3];
          return (wn = oo * bo + Un * Jn + fo * Ro + ho * po) < 0 && (wn = -wn, bo = -bo, Jn = -Jn, Ro = -Ro, po = -po), 1 - wn > de.EPSILON ? (mn = Math.acos(wn), Cn = Math.sin(mn), gn = Math.sin((1 - ln) * mn) / Cn, Nn = Math.sin(ln * mn) / Cn) : (gn = 1 - ln, Nn = ln), Fi[0] = gn * oo + Nn * bo, Fi[1] = gn * Un + Nn * Jn, Fi[2] = gn * fo + Nn * Ro, Fi[3] = gn * ho + Nn * po, Fi;
        }
        function xr(Fi, tn) {
          var cn, ln = tn[0] + tn[4] + tn[8];
          if (ln > 0)
            cn = Math.sqrt(ln + 1), Fi[3] = 0.5 * cn, Fi[0] = (tn[5] - tn[7]) * (cn = 0.5 / cn), Fi[1] = (tn[6] - tn[2]) * cn, Fi[2] = (tn[1] - tn[3]) * cn;
          else {
            var mn = 0;
            tn[4] > tn[0] && (mn = 1), tn[8] > tn[3 * mn + mn] && (mn = 2);
            var wn = (mn + 1) % 3, Cn = (mn + 2) % 3;
            cn = Math.sqrt(tn[3 * mn + mn] - tn[3 * wn + wn] - tn[3 * Cn + Cn] + 1), Fi[mn] = 0.5 * cn, Fi[3] = (tn[3 * wn + Cn] - tn[3 * Cn + wn]) * (cn = 0.5 / cn), Fi[wn] = (tn[3 * wn + mn] + tn[3 * mn + wn]) * cn, Fi[Cn] = (tn[3 * Cn + mn] + tn[3 * mn + Cn]) * cn;
          }
          return Fi;
        }
        ci.clone = Ke.clone, ci.fromValues = Ke.fromValues, ci.copy = Ke.copy, ci.set = Ke.set, ci.add = Ke.add, ci.mul = kr;
        var Sr = Ke.scale;
        ci.scale = Sr;
        var Br = Ke.dot;
        ci.dot = Br, ci.lerp = Ke.lerp;
        var Fr = Ke.length;
        ci.length = Fr, ci.len = Fr;
        var jr = Ke.squaredLength;
        ci.squaredLength = jr, ci.sqrLen = jr;
        var Qr = Ke.normalize;
        ci.normalize = Qr, ci.exactEquals = Ke.exactEquals, ci.equals = Ke.equals;
        var ti, Kr, ni, gi = (ti = De.create(), Kr = De.fromValues(1, 0, 0), ni = De.fromValues(0, 1, 0), function(Fi, tn, cn) {
          var ln = De.dot(tn, cn);
          return ln < -0.999999 ? (De.cross(ti, Kr, tn), De.len(ti) < 1e-6 && De.cross(ti, ni, tn), De.normalize(ti, ti), wr(Fi, ti, Math.PI), Fi) : ln > 0.999999 ? (Fi[0] = 0, Fi[1] = 0, Fi[2] = 0, Fi[3] = 1, Fi) : (De.cross(ti, tn, cn), Fi[0] = ti[0], Fi[1] = ti[1], Fi[2] = ti[2], Fi[3] = 1 + ln, Qr(Fi, Fi));
        });
        ci.rotationTo = gi;
        var Si, Di, Ri = (Si = fr(), Di = fr(), function(Fi, tn, cn, ln, mn, wn) {
          return Er(Si, tn, mn, wn), Er(Di, cn, ln, wn), Er(Fi, Si, Di, 2 * wn * (1 - wn)), Fi;
        });
        ci.sqlerp = Ri;
        var Bi, Ji = (Bi = Ce.create(), function(Fi, tn, cn, ln) {
          return Bi[0] = cn[0], Bi[3] = cn[1], Bi[6] = cn[2], Bi[1] = ln[0], Bi[4] = ln[1], Bi[7] = ln[2], Bi[2] = -tn[0], Bi[5] = -tn[1], Bi[8] = -tn[2], Qr(Fi, xr(Fi, Bi));
        });
        return ci.setAxes = Ji, ci;
      }
      var br, nr = {};
      function Pe() {
        if (br)
          return nr;
        function Ie(Er) {
          return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(xr) {
            return typeof xr;
          } : function(xr) {
            return xr && typeof Symbol == "function" && xr.constructor === Symbol && xr !== Symbol.prototype ? "symbol" : typeof xr;
          }, Ie(Er);
        }
        br = 1, Object.defineProperty(nr, "__esModule", { value: !0 }), nr.create = function() {
          var Er = new de.ARRAY_TYPE(8);
          return de.ARRAY_TYPE != Float32Array && (Er[0] = 0, Er[1] = 0, Er[2] = 0, Er[4] = 0, Er[5] = 0, Er[6] = 0, Er[7] = 0), Er[3] = 1, Er;
        }, nr.clone = function(Er) {
          var xr = new de.ARRAY_TYPE(8);
          return xr[0] = Er[0], xr[1] = Er[1], xr[2] = Er[2], xr[3] = Er[3], xr[4] = Er[4], xr[5] = Er[5], xr[6] = Er[6], xr[7] = Er[7], xr;
        }, nr.fromValues = function(Er, xr, Sr, Br, Fr, jr, Qr, ti) {
          var Kr = new de.ARRAY_TYPE(8);
          return Kr[0] = Er, Kr[1] = xr, Kr[2] = Sr, Kr[3] = Br, Kr[4] = Fr, Kr[5] = jr, Kr[6] = Qr, Kr[7] = ti, Kr;
        }, nr.fromRotationTranslationValues = function(Er, xr, Sr, Br, Fr, jr, Qr) {
          var ti = new de.ARRAY_TYPE(8);
          ti[0] = Er, ti[1] = xr, ti[2] = Sr, ti[3] = Br;
          var Kr = 0.5 * Fr, ni = 0.5 * jr, gi = 0.5 * Qr;
          return ti[4] = Kr * Br + ni * Sr - gi * xr, ti[5] = ni * Br + gi * Er - Kr * Sr, ti[6] = gi * Br + Kr * xr - ni * Er, ti[7] = -Kr * Er - ni * xr - gi * Sr, ti;
        }, nr.fromRotationTranslation = er, nr.fromTranslation = function(Er, xr) {
          return Er[0] = 0, Er[1] = 0, Er[2] = 0, Er[3] = 1, Er[4] = 0.5 * xr[0], Er[5] = 0.5 * xr[1], Er[6] = 0.5 * xr[2], Er[7] = 0, Er;
        }, nr.fromRotation = function(Er, xr) {
          return Er[0] = xr[0], Er[1] = xr[1], Er[2] = xr[2], Er[3] = xr[3], Er[4] = 0, Er[5] = 0, Er[6] = 0, Er[7] = 0, Er;
        }, nr.fromMat4 = function(Er, xr) {
          var Sr = Ce.create();
          De.getRotation(Sr, xr);
          var Br = new de.ARRAY_TYPE(3);
          return De.getTranslation(Br, xr), er(Er, Sr, Br), Er;
        }, nr.copy = fr, nr.identity = function(Er) {
          return Er[0] = 0, Er[1] = 0, Er[2] = 0, Er[3] = 1, Er[4] = 0, Er[5] = 0, Er[6] = 0, Er[7] = 0, Er;
        }, nr.set = function(Er, xr, Sr, Br, Fr, jr, Qr, ti, Kr) {
          return Er[0] = xr, Er[1] = Sr, Er[2] = Br, Er[3] = Fr, Er[4] = jr, Er[5] = Qr, Er[6] = ti, Er[7] = Kr, Er;
        }, nr.getDual = function(Er, xr) {
          return Er[0] = xr[4], Er[1] = xr[5], Er[2] = xr[6], Er[3] = xr[7], Er;
        }, nr.setDual = function(Er, xr) {
          return Er[4] = xr[0], Er[5] = xr[1], Er[6] = xr[2], Er[7] = xr[3], Er;
        }, nr.getTranslation = function(Er, xr) {
          var Sr = xr[4], Br = xr[5], Fr = xr[6], jr = xr[7], Qr = -xr[0], ti = -xr[1], Kr = -xr[2], ni = xr[3];
          return Er[0] = 2 * (Sr * ni + jr * Qr + Br * Kr - Fr * ti), Er[1] = 2 * (Br * ni + jr * ti + Fr * Qr - Sr * Kr), Er[2] = 2 * (Fr * ni + jr * Kr + Sr * ti - Br * Qr), Er;
        }, nr.translate = function(Er, xr, Sr) {
          var Br = xr[0], Fr = xr[1], jr = xr[2], Qr = xr[3], ti = 0.5 * Sr[0], Kr = 0.5 * Sr[1], ni = 0.5 * Sr[2], gi = xr[4], Si = xr[5], Di = xr[6], Ri = xr[7];
          return Er[0] = Br, Er[1] = Fr, Er[2] = jr, Er[3] = Qr, Er[4] = Qr * ti + Fr * ni - jr * Kr + gi, Er[5] = Qr * Kr + jr * ti - Br * ni + Si, Er[6] = Qr * ni + Br * Kr - Fr * ti + Di, Er[7] = -Br * ti - Fr * Kr - jr * ni + Ri, Er;
        }, nr.rotateX = function(Er, xr, Sr) {
          var Br = -xr[0], Fr = -xr[1], jr = -xr[2], Qr = xr[3], ti = xr[4], Kr = xr[5], ni = xr[6], gi = xr[7], Si = ti * Qr + gi * Br + Kr * jr - ni * Fr, Di = Kr * Qr + gi * Fr + ni * Br - ti * jr, Ri = ni * Qr + gi * jr + ti * Fr - Kr * Br, Bi = gi * Qr - ti * Br - Kr * Fr - ni * jr;
          return Ce.rotateX(Er, xr, Sr), Er[4] = Si * (Qr = Er[3]) + Bi * (Br = Er[0]) + Di * (jr = Er[2]) - Ri * (Fr = Er[1]), Er[5] = Di * Qr + Bi * Fr + Ri * Br - Si * jr, Er[6] = Ri * Qr + Bi * jr + Si * Fr - Di * Br, Er[7] = Bi * Qr - Si * Br - Di * Fr - Ri * jr, Er;
        }, nr.rotateY = function(Er, xr, Sr) {
          var Br = -xr[0], Fr = -xr[1], jr = -xr[2], Qr = xr[3], ti = xr[4], Kr = xr[5], ni = xr[6], gi = xr[7], Si = ti * Qr + gi * Br + Kr * jr - ni * Fr, Di = Kr * Qr + gi * Fr + ni * Br - ti * jr, Ri = ni * Qr + gi * jr + ti * Fr - Kr * Br, Bi = gi * Qr - ti * Br - Kr * Fr - ni * jr;
          return Ce.rotateY(Er, xr, Sr), Er[4] = Si * (Qr = Er[3]) + Bi * (Br = Er[0]) + Di * (jr = Er[2]) - Ri * (Fr = Er[1]), Er[5] = Di * Qr + Bi * Fr + Ri * Br - Si * jr, Er[6] = Ri * Qr + Bi * jr + Si * Fr - Di * Br, Er[7] = Bi * Qr - Si * Br - Di * Fr - Ri * jr, Er;
        }, nr.rotateZ = function(Er, xr, Sr) {
          var Br = -xr[0], Fr = -xr[1], jr = -xr[2], Qr = xr[3], ti = xr[4], Kr = xr[5], ni = xr[6], gi = xr[7], Si = ti * Qr + gi * Br + Kr * jr - ni * Fr, Di = Kr * Qr + gi * Fr + ni * Br - ti * jr, Ri = ni * Qr + gi * jr + ti * Fr - Kr * Br, Bi = gi * Qr - ti * Br - Kr * Fr - ni * jr;
          return Ce.rotateZ(Er, xr, Sr), Er[4] = Si * (Qr = Er[3]) + Bi * (Br = Er[0]) + Di * (jr = Er[2]) - Ri * (Fr = Er[1]), Er[5] = Di * Qr + Bi * Fr + Ri * Br - Si * jr, Er[6] = Ri * Qr + Bi * jr + Si * Fr - Di * Br, Er[7] = Bi * Qr - Si * Br - Di * Fr - Ri * jr, Er;
        }, nr.rotateByQuatAppend = function(Er, xr, Sr) {
          var Br = Sr[0], Fr = Sr[1], jr = Sr[2], Qr = Sr[3], ti = xr[0], Kr = xr[1], ni = xr[2], gi = xr[3];
          return Er[0] = ti * Qr + gi * Br + Kr * jr - ni * Fr, Er[1] = Kr * Qr + gi * Fr + ni * Br - ti * jr, Er[2] = ni * Qr + gi * jr + ti * Fr - Kr * Br, Er[3] = gi * Qr - ti * Br - Kr * Fr - ni * jr, Er[4] = (ti = xr[4]) * Qr + (gi = xr[7]) * Br + (Kr = xr[5]) * jr - (ni = xr[6]) * Fr, Er[5] = Kr * Qr + gi * Fr + ni * Br - ti * jr, Er[6] = ni * Qr + gi * jr + ti * Fr - Kr * Br, Er[7] = gi * Qr - ti * Br - Kr * Fr - ni * jr, Er;
        }, nr.rotateByQuatPrepend = function(Er, xr, Sr) {
          var Br = xr[0], Fr = xr[1], jr = xr[2], Qr = xr[3], ti = Sr[0], Kr = Sr[1], ni = Sr[2], gi = Sr[3];
          return Er[0] = Br * gi + Qr * ti + Fr * ni - jr * Kr, Er[1] = Fr * gi + Qr * Kr + jr * ti - Br * ni, Er[2] = jr * gi + Qr * ni + Br * Kr - Fr * ti, Er[3] = Qr * gi - Br * ti - Fr * Kr - jr * ni, Er[4] = Br * (gi = Sr[7]) + Qr * (ti = Sr[4]) + Fr * (ni = Sr[6]) - jr * (Kr = Sr[5]), Er[5] = Fr * gi + Qr * Kr + jr * ti - Br * ni, Er[6] = jr * gi + Qr * ni + Br * Kr - Fr * ti, Er[7] = Qr * gi - Br * ti - Fr * Kr - jr * ni, Er;
        }, nr.rotateAroundAxis = function(Er, xr, Sr, Br) {
          if (Math.abs(Br) < de.EPSILON)
            return fr(Er, xr);
          var Fr = Math.hypot(Sr[0], Sr[1], Sr[2]);
          Br *= 0.5;
          var jr = Math.sin(Br), Qr = jr * Sr[0] / Fr, ti = jr * Sr[1] / Fr, Kr = jr * Sr[2] / Fr, ni = Math.cos(Br), gi = xr[0], Si = xr[1], Di = xr[2], Ri = xr[3];
          Er[0] = gi * ni + Ri * Qr + Si * Kr - Di * ti, Er[1] = Si * ni + Ri * ti + Di * Qr - gi * Kr, Er[2] = Di * ni + Ri * Kr + gi * ti - Si * Qr, Er[3] = Ri * ni - gi * Qr - Si * ti - Di * Kr;
          var Bi = xr[4], Ji = xr[5], Fi = xr[6], tn = xr[7];
          return Er[4] = Bi * ni + tn * Qr + Ji * Kr - Fi * ti, Er[5] = Ji * ni + tn * ti + Fi * Qr - Bi * Kr, Er[6] = Fi * ni + tn * Kr + Bi * ti - Ji * Qr, Er[7] = tn * ni - Bi * Qr - Ji * ti - Fi * Kr, Er;
        }, nr.add = function(Er, xr, Sr) {
          return Er[0] = xr[0] + Sr[0], Er[1] = xr[1] + Sr[1], Er[2] = xr[2] + Sr[2], Er[3] = xr[3] + Sr[3], Er[4] = xr[4] + Sr[4], Er[5] = xr[5] + Sr[5], Er[6] = xr[6] + Sr[6], Er[7] = xr[7] + Sr[7], Er;
        }, nr.multiply = wr, nr.scale = function(Er, xr, Sr) {
          return Er[0] = xr[0] * Sr, Er[1] = xr[1] * Sr, Er[2] = xr[2] * Sr, Er[3] = xr[3] * Sr, Er[4] = xr[4] * Sr, Er[5] = xr[5] * Sr, Er[6] = xr[6] * Sr, Er[7] = xr[7] * Sr, Er;
        }, nr.lerp = function(Er, xr, Sr, Br) {
          var Fr = 1 - Br;
          return kr(xr, Sr) < 0 && (Br = -Br), Er[0] = xr[0] * Fr + Sr[0] * Br, Er[1] = xr[1] * Fr + Sr[1] * Br, Er[2] = xr[2] * Fr + Sr[2] * Br, Er[3] = xr[3] * Fr + Sr[3] * Br, Er[4] = xr[4] * Fr + Sr[4] * Br, Er[5] = xr[5] * Fr + Sr[5] * Br, Er[6] = xr[6] * Fr + Sr[6] * Br, Er[7] = xr[7] * Fr + Sr[7] * Br, Er;
        }, nr.invert = function(Er, xr) {
          var Sr = Mr(xr);
          return Er[0] = -xr[0] / Sr, Er[1] = -xr[1] / Sr, Er[2] = -xr[2] / Sr, Er[3] = xr[3] / Sr, Er[4] = -xr[4] / Sr, Er[5] = -xr[5] / Sr, Er[6] = -xr[6] / Sr, Er[7] = xr[7] / Sr, Er;
        }, nr.conjugate = function(Er, xr) {
          return Er[0] = -xr[0], Er[1] = -xr[1], Er[2] = -xr[2], Er[3] = xr[3], Er[4] = -xr[4], Er[5] = -xr[5], Er[6] = -xr[6], Er[7] = xr[7], Er;
        }, nr.normalize = function(Er, xr) {
          var Sr = Mr(xr);
          if (Sr > 0) {
            Sr = Math.sqrt(Sr);
            var Br = xr[0] / Sr, Fr = xr[1] / Sr, jr = xr[2] / Sr, Qr = xr[3] / Sr, ti = xr[4], Kr = xr[5], ni = xr[6], gi = xr[7], Si = Br * ti + Fr * Kr + jr * ni + Qr * gi;
            Er[0] = Br, Er[1] = Fr, Er[2] = jr, Er[3] = Qr, Er[4] = (ti - Br * Si) / Sr, Er[5] = (Kr - Fr * Si) / Sr, Er[6] = (ni - jr * Si) / Sr, Er[7] = (gi - Qr * Si) / Sr;
          }
          return Er;
        }, nr.str = function(Er) {
          return "quat2(" + Er[0] + ", " + Er[1] + ", " + Er[2] + ", " + Er[3] + ", " + Er[4] + ", " + Er[5] + ", " + Er[6] + ", " + Er[7] + ")";
        }, nr.exactEquals = function(Er, xr) {
          return Er[0] === xr[0] && Er[1] === xr[1] && Er[2] === xr[2] && Er[3] === xr[3] && Er[4] === xr[4] && Er[5] === xr[5] && Er[6] === xr[6] && Er[7] === xr[7];
        }, nr.equals = function(Er, xr) {
          var Sr = Er[0], Br = Er[1], Fr = Er[2], jr = Er[3], Qr = Er[4], ti = Er[5], Kr = Er[6], ni = Er[7], gi = xr[0], Si = xr[1], Di = xr[2], Ri = xr[3], Bi = xr[4], Ji = xr[5], Fi = xr[6], tn = xr[7];
          return Math.abs(Sr - gi) <= de.EPSILON * Math.max(1, Math.abs(Sr), Math.abs(gi)) && Math.abs(Br - Si) <= de.EPSILON * Math.max(1, Math.abs(Br), Math.abs(Si)) && Math.abs(Fr - Di) <= de.EPSILON * Math.max(1, Math.abs(Fr), Math.abs(Di)) && Math.abs(jr - Ri) <= de.EPSILON * Math.max(1, Math.abs(jr), Math.abs(Ri)) && Math.abs(Qr - Bi) <= de.EPSILON * Math.max(1, Math.abs(Qr), Math.abs(Bi)) && Math.abs(ti - Ji) <= de.EPSILON * Math.max(1, Math.abs(ti), Math.abs(Ji)) && Math.abs(Kr - Fi) <= de.EPSILON * Math.max(1, Math.abs(Kr), Math.abs(Fi)) && Math.abs(ni - tn) <= de.EPSILON * Math.max(1, Math.abs(ni), Math.abs(tn));
        }, nr.sqrLen = nr.squaredLength = nr.len = nr.length = nr.dot = nr.mul = nr.setReal = nr.getReal = void 0;
        var de = Ve(Lr()), Ce = Ve(pr()), De = Ve(di());
        function Ke(Er) {
          if (typeof WeakMap != "function")
            return null;
          var xr = /* @__PURE__ */ new WeakMap(), Sr = /* @__PURE__ */ new WeakMap();
          return (Ke = function(Br) {
            return Br ? Sr : xr;
          })(Er);
        }
        function Ve(Er, xr) {
          if (Er && Er.__esModule)
            return Er;
          if (Er === null || Ie(Er) !== "object" && typeof Er != "function")
            return { default: Er };
          var Sr = Ke(xr);
          if (Sr && Sr.has(Er))
            return Sr.get(Er);
          var Br = {}, Fr = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var jr in Er)
            if (jr !== "default" && Object.prototype.hasOwnProperty.call(Er, jr)) {
              var Qr = Fr ? Object.getOwnPropertyDescriptor(Er, jr) : null;
              Qr && (Qr.get || Qr.set) ? Object.defineProperty(Br, jr, Qr) : Br[jr] = Er[jr];
            }
          return Br.default = Er, Sr && Sr.set(Er, Br), Br;
        }
        function er(Er, xr, Sr) {
          var Br = 0.5 * Sr[0], Fr = 0.5 * Sr[1], jr = 0.5 * Sr[2], Qr = xr[0], ti = xr[1], Kr = xr[2], ni = xr[3];
          return Er[0] = Qr, Er[1] = ti, Er[2] = Kr, Er[3] = ni, Er[4] = Br * ni + Fr * Kr - jr * ti, Er[5] = Fr * ni + jr * Qr - Br * Kr, Er[6] = jr * ni + Br * ti - Fr * Qr, Er[7] = -Br * Qr - Fr * ti - jr * Kr, Er;
        }
        function fr(Er, xr) {
          return Er[0] = xr[0], Er[1] = xr[1], Er[2] = xr[2], Er[3] = xr[3], Er[4] = xr[4], Er[5] = xr[5], Er[6] = xr[6], Er[7] = xr[7], Er;
        }
        function wr(Er, xr, Sr) {
          var Br = xr[0], Fr = xr[1], jr = xr[2], Qr = xr[3], ti = Sr[4], Kr = Sr[5], ni = Sr[6], gi = Sr[7], Si = xr[4], Di = xr[5], Ri = xr[6], Bi = xr[7], Ji = Sr[0], Fi = Sr[1], tn = Sr[2], cn = Sr[3];
          return Er[0] = Br * cn + Qr * Ji + Fr * tn - jr * Fi, Er[1] = Fr * cn + Qr * Fi + jr * Ji - Br * tn, Er[2] = jr * cn + Qr * tn + Br * Fi - Fr * Ji, Er[3] = Qr * cn - Br * Ji - Fr * Fi - jr * tn, Er[4] = Br * gi + Qr * ti + Fr * ni - jr * Kr + Si * cn + Bi * Ji + Di * tn - Ri * Fi, Er[5] = Fr * gi + Qr * Kr + jr * ti - Br * ni + Di * cn + Bi * Fi + Ri * Ji - Si * tn, Er[6] = jr * gi + Qr * ni + Br * Kr - Fr * ti + Ri * cn + Bi * tn + Si * Fi - Di * Ji, Er[7] = Qr * gi - Br * ti - Fr * Kr - jr * ni + Bi * cn - Si * Ji - Di * Fi - Ri * tn, Er;
        }
        nr.getReal = Ce.copy, nr.setReal = Ce.copy, nr.mul = wr;
        var kr = Ce.dot;
        nr.dot = kr;
        var cr = Ce.length;
        nr.length = cr, nr.len = cr;
        var Mr = Ce.squaredLength;
        return nr.squaredLength = Mr, nr.sqrLen = Mr, nr;
      }
      var ur, Pr, Hr = {};
      function vi() {
        if (ur)
          return Hr;
        function Ie(xr) {
          return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Sr) {
            return typeof Sr;
          } : function(Sr) {
            return Sr && typeof Symbol == "function" && Sr.constructor === Symbol && Sr !== Symbol.prototype ? "symbol" : typeof Sr;
          }, Ie(xr);
        }
        ur = 1, Object.defineProperty(Hr, "__esModule", { value: !0 }), Hr.create = De, Hr.clone = function(xr) {
          var Sr = new de.ARRAY_TYPE(2);
          return Sr[0] = xr[0], Sr[1] = xr[1], Sr;
        }, Hr.fromValues = function(xr, Sr) {
          var Br = new de.ARRAY_TYPE(2);
          return Br[0] = xr, Br[1] = Sr, Br;
        }, Hr.copy = function(xr, Sr) {
          return xr[0] = Sr[0], xr[1] = Sr[1], xr;
        }, Hr.set = function(xr, Sr, Br) {
          return xr[0] = Sr, xr[1] = Br, xr;
        }, Hr.add = function(xr, Sr, Br) {
          return xr[0] = Sr[0] + Br[0], xr[1] = Sr[1] + Br[1], xr;
        }, Hr.subtract = Ke, Hr.multiply = Ve, Hr.divide = er, Hr.ceil = function(xr, Sr) {
          return xr[0] = Math.ceil(Sr[0]), xr[1] = Math.ceil(Sr[1]), xr;
        }, Hr.floor = function(xr, Sr) {
          return xr[0] = Math.floor(Sr[0]), xr[1] = Math.floor(Sr[1]), xr;
        }, Hr.min = function(xr, Sr, Br) {
          return xr[0] = Math.min(Sr[0], Br[0]), xr[1] = Math.min(Sr[1], Br[1]), xr;
        }, Hr.max = function(xr, Sr, Br) {
          return xr[0] = Math.max(Sr[0], Br[0]), xr[1] = Math.max(Sr[1], Br[1]), xr;
        }, Hr.round = function(xr, Sr) {
          return xr[0] = Math.round(Sr[0]), xr[1] = Math.round(Sr[1]), xr;
        }, Hr.scale = function(xr, Sr, Br) {
          return xr[0] = Sr[0] * Br, xr[1] = Sr[1] * Br, xr;
        }, Hr.scaleAndAdd = function(xr, Sr, Br, Fr) {
          return xr[0] = Sr[0] + Br[0] * Fr, xr[1] = Sr[1] + Br[1] * Fr, xr;
        }, Hr.distance = fr, Hr.squaredDistance = wr, Hr.length = kr, Hr.squaredLength = cr, Hr.negate = function(xr, Sr) {
          return xr[0] = -Sr[0], xr[1] = -Sr[1], xr;
        }, Hr.inverse = function(xr, Sr) {
          return xr[0] = 1 / Sr[0], xr[1] = 1 / Sr[1], xr;
        }, Hr.normalize = function(xr, Sr) {
          var Br = Sr[0], Fr = Sr[1], jr = Br * Br + Fr * Fr;
          return jr > 0 && (jr = 1 / Math.sqrt(jr)), xr[0] = Sr[0] * jr, xr[1] = Sr[1] * jr, xr;
        }, Hr.dot = function(xr, Sr) {
          return xr[0] * Sr[0] + xr[1] * Sr[1];
        }, Hr.cross = function(xr, Sr, Br) {
          var Fr = Sr[0] * Br[1] - Sr[1] * Br[0];
          return xr[0] = xr[1] = 0, xr[2] = Fr, xr;
        }, Hr.lerp = function(xr, Sr, Br, Fr) {
          var jr = Sr[0], Qr = Sr[1];
          return xr[0] = jr + Fr * (Br[0] - jr), xr[1] = Qr + Fr * (Br[1] - Qr), xr;
        }, Hr.random = function(xr, Sr) {
          Sr = Sr || 1;
          var Br = 2 * de.RANDOM() * Math.PI;
          return xr[0] = Math.cos(Br) * Sr, xr[1] = Math.sin(Br) * Sr, xr;
        }, Hr.transformMat2 = function(xr, Sr, Br) {
          var Fr = Sr[0], jr = Sr[1];
          return xr[0] = Br[0] * Fr + Br[2] * jr, xr[1] = Br[1] * Fr + Br[3] * jr, xr;
        }, Hr.transformMat2d = function(xr, Sr, Br) {
          var Fr = Sr[0], jr = Sr[1];
          return xr[0] = Br[0] * Fr + Br[2] * jr + Br[4], xr[1] = Br[1] * Fr + Br[3] * jr + Br[5], xr;
        }, Hr.transformMat3 = function(xr, Sr, Br) {
          var Fr = Sr[0], jr = Sr[1];
          return xr[0] = Br[0] * Fr + Br[3] * jr + Br[6], xr[1] = Br[1] * Fr + Br[4] * jr + Br[7], xr;
        }, Hr.transformMat4 = function(xr, Sr, Br) {
          var Fr = Sr[0], jr = Sr[1];
          return xr[0] = Br[0] * Fr + Br[4] * jr + Br[12], xr[1] = Br[1] * Fr + Br[5] * jr + Br[13], xr;
        }, Hr.rotate = function(xr, Sr, Br, Fr) {
          var jr = Sr[0] - Br[0], Qr = Sr[1] - Br[1], ti = Math.sin(Fr), Kr = Math.cos(Fr);
          return xr[0] = jr * Kr - Qr * ti + Br[0], xr[1] = jr * ti + Qr * Kr + Br[1], xr;
        }, Hr.angle = function(xr, Sr) {
          var Br = xr[0], Fr = xr[1], jr = Sr[0], Qr = Sr[1], ti = Math.sqrt(Br * Br + Fr * Fr) * Math.sqrt(jr * jr + Qr * Qr);
          return Math.acos(Math.min(Math.max(ti && (Br * jr + Fr * Qr) / ti, -1), 1));
        }, Hr.zero = function(xr) {
          return xr[0] = 0, xr[1] = 0, xr;
        }, Hr.str = function(xr) {
          return "vec2(" + xr[0] + ", " + xr[1] + ")";
        }, Hr.exactEquals = function(xr, Sr) {
          return xr[0] === Sr[0] && xr[1] === Sr[1];
        }, Hr.equals = function(xr, Sr) {
          var Br = xr[0], Fr = xr[1], jr = Sr[0], Qr = Sr[1];
          return Math.abs(Br - jr) <= de.EPSILON * Math.max(1, Math.abs(Br), Math.abs(jr)) && Math.abs(Fr - Qr) <= de.EPSILON * Math.max(1, Math.abs(Fr), Math.abs(Qr));
        }, Hr.forEach = Hr.sqrLen = Hr.sqrDist = Hr.dist = Hr.div = Hr.mul = Hr.sub = Hr.len = void 0;
        var de = function(xr, Sr) {
          if (xr && xr.__esModule)
            return xr;
          if (xr === null || Ie(xr) !== "object" && typeof xr != "function")
            return { default: xr };
          var Br = Ce(void 0);
          if (Br && Br.has(xr))
            return Br.get(xr);
          var Fr = {}, jr = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var Qr in xr)
            if (Qr !== "default" && Object.prototype.hasOwnProperty.call(xr, Qr)) {
              var ti = jr ? Object.getOwnPropertyDescriptor(xr, Qr) : null;
              ti && (ti.get || ti.set) ? Object.defineProperty(Fr, Qr, ti) : Fr[Qr] = xr[Qr];
            }
          return Fr.default = xr, Br && Br.set(xr, Fr), Fr;
        }(Lr());
        function Ce(xr) {
          if (typeof WeakMap != "function")
            return null;
          var Sr = /* @__PURE__ */ new WeakMap(), Br = /* @__PURE__ */ new WeakMap();
          return (Ce = function(Fr) {
            return Fr ? Br : Sr;
          })(xr);
        }
        function De() {
          var xr = new de.ARRAY_TYPE(2);
          return de.ARRAY_TYPE != Float32Array && (xr[0] = 0, xr[1] = 0), xr;
        }
        function Ke(xr, Sr, Br) {
          return xr[0] = Sr[0] - Br[0], xr[1] = Sr[1] - Br[1], xr;
        }
        function Ve(xr, Sr, Br) {
          return xr[0] = Sr[0] * Br[0], xr[1] = Sr[1] * Br[1], xr;
        }
        function er(xr, Sr, Br) {
          return xr[0] = Sr[0] / Br[0], xr[1] = Sr[1] / Br[1], xr;
        }
        function fr(xr, Sr) {
          return Math.hypot(Sr[0] - xr[0], Sr[1] - xr[1]);
        }
        function wr(xr, Sr) {
          var Br = Sr[0] - xr[0], Fr = Sr[1] - xr[1];
          return Br * Br + Fr * Fr;
        }
        function kr(xr) {
          return Math.hypot(xr[0], xr[1]);
        }
        function cr(xr) {
          var Sr = xr[0], Br = xr[1];
          return Sr * Sr + Br * Br;
        }
        Hr.len = kr, Hr.sub = Ke, Hr.mul = Ve, Hr.div = er, Hr.dist = fr, Hr.sqrDist = wr, Hr.sqrLen = cr;
        var Mr, Er = (Mr = De(), function(xr, Sr, Br, Fr, jr, Qr) {
          var ti, Kr;
          for (Sr || (Sr = 2), Br || (Br = 0), Kr = Fr ? Math.min(Fr * Sr + Br, xr.length) : xr.length, ti = Br; ti < Kr; ti += Sr)
            Mr[0] = xr[ti], Mr[1] = xr[ti + 1], jr(Mr, Mr, Qr), xr[ti] = Mr[0], xr[ti + 1] = Mr[1];
          return xr;
        });
        return Hr.forEach = Er, Hr;
      }
      function Ti() {
        if (Pr)
          return or;
        function Ie(xr) {
          return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Sr) {
            return typeof Sr;
          } : function(Sr) {
            return Sr && typeof Symbol == "function" && Sr.constructor === Symbol && Sr !== Symbol.prototype ? "symbol" : typeof Sr;
          }, Ie(xr);
        }
        Pr = 1, Object.defineProperty(or, "__esModule", { value: !0 }), or.vec4 = or.vec3 = or.vec2 = or.quat2 = or.quat = or.mat4 = or.mat3 = or.mat2d = or.mat2 = or.glMatrix = void 0;
        var de = Er(Lr());
        or.glMatrix = de;
        var Ce = Er(Rr());
        or.mat2 = Ce;
        var De = Er(Vr());
        or.mat2d = De;
        var Ke = Er(si());
        or.mat3 = Ke;
        var Ve = Er(di());
        or.mat4 = Ve;
        var er = Er(pr());
        or.quat = er;
        var fr = Er(Pe());
        or.quat2 = fr;
        var wr = Er(vi());
        or.vec2 = wr;
        var kr = Er(Ae());
        or.vec3 = kr;
        var cr = Er(lr());
        function Mr(xr) {
          if (typeof WeakMap != "function")
            return null;
          var Sr = /* @__PURE__ */ new WeakMap(), Br = /* @__PURE__ */ new WeakMap();
          return (Mr = function(Fr) {
            return Fr ? Br : Sr;
          })(xr);
        }
        function Er(xr, Sr) {
          if (xr && xr.__esModule)
            return xr;
          if (xr === null || Ie(xr) !== "object" && typeof xr != "function")
            return { default: xr };
          var Br = Mr(Sr);
          if (Br && Br.has(xr))
            return Br.get(xr);
          var Fr = {}, jr = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var Qr in xr)
            if (Qr !== "default" && Object.prototype.hasOwnProperty.call(xr, Qr)) {
              var ti = jr ? Object.getOwnPropertyDescriptor(xr, Qr) : null;
              ti && (ti.get || ti.set) ? Object.defineProperty(Fr, Qr, ti) : Fr[Qr] = xr[Qr];
            }
          return Fr.default = xr, Br && Br.set(xr, Fr), Fr;
        }
        return or.vec4 = cr, or;
      }
      var wi, ii, mi, ei, Zr = Ti(), pi = function() {
        if (ii)
          return wi;
        function Ie(de, Ce, De, Ke) {
          this.cx = 3 * de, this.bx = 3 * (De - de) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * Ce, this.by = 3 * (Ke - Ce) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = de, this.p1y = Ce, this.p2x = De, this.p2y = Ke;
        }
        return ii = 1, wi = Ie, Ie.prototype = { sampleCurveX: function(de) {
          return ((this.ax * de + this.bx) * de + this.cx) * de;
        }, sampleCurveY: function(de) {
          return ((this.ay * de + this.by) * de + this.cy) * de;
        }, sampleCurveDerivativeX: function(de) {
          return (3 * this.ax * de + 2 * this.bx) * de + this.cx;
        }, solveCurveX: function(de, Ce) {
          if (Ce === void 0 && (Ce = 1e-6), de < 0)
            return 0;
          if (de > 1)
            return 1;
          for (var De = de, Ke = 0; Ke < 8; Ke++) {
            var Ve = this.sampleCurveX(De) - de;
            if (Math.abs(Ve) < Ce)
              return De;
            var er = this.sampleCurveDerivativeX(De);
            if (Math.abs(er) < 1e-6)
              break;
            De -= Ve / er;
          }
          var fr = 0, wr = 1;
          for (De = de, Ke = 0; Ke < 20 && (Ve = this.sampleCurveX(De), !(Math.abs(Ve - de) < Ce)); Ke++)
            de > Ve ? fr = De : wr = De, De = 0.5 * (wr - fr) + fr;
          return De;
        }, solve: function(de, Ce) {
          return this.sampleCurveY(this.solveCurveX(de, Ce));
        } }, wi;
      }(), hi = rr(pi);
      function Oi() {
        if (ei)
          return mi;
        function Ie(de, Ce) {
          this.x = de, this.y = Ce;
        }
        return ei = 1, mi = Ie, Ie.prototype = { clone: function() {
          return new Ie(this.x, this.y);
        }, add: function(de) {
          return this.clone()._add(de);
        }, sub: function(de) {
          return this.clone()._sub(de);
        }, multByPoint: function(de) {
          return this.clone()._multByPoint(de);
        }, divByPoint: function(de) {
          return this.clone()._divByPoint(de);
        }, mult: function(de) {
          return this.clone()._mult(de);
        }, div: function(de) {
          return this.clone()._div(de);
        }, rotate: function(de) {
          return this.clone()._rotate(de);
        }, rotateAround: function(de, Ce) {
          return this.clone()._rotateAround(de, Ce);
        }, matMult: function(de) {
          return this.clone()._matMult(de);
        }, unit: function() {
          return this.clone()._unit();
        }, perp: function() {
          return this.clone()._perp();
        }, round: function() {
          return this.clone()._round();
        }, mag: function() {
          return Math.sqrt(this.x * this.x + this.y * this.y);
        }, equals: function(de) {
          return this.x === de.x && this.y === de.y;
        }, dist: function(de) {
          return Math.sqrt(this.distSqr(de));
        }, distSqr: function(de) {
          var Ce = de.x - this.x, De = de.y - this.y;
          return Ce * Ce + De * De;
        }, angle: function() {
          return Math.atan2(this.y, this.x);
        }, angleTo: function(de) {
          return Math.atan2(this.y - de.y, this.x - de.x);
        }, angleWith: function(de) {
          return this.angleWithSep(de.x, de.y);
        }, angleWithSep: function(de, Ce) {
          return Math.atan2(this.x * Ce - this.y * de, this.x * de + this.y * Ce);
        }, _matMult: function(de) {
          var Ce = de[2] * this.x + de[3] * this.y;
          return this.x = de[0] * this.x + de[1] * this.y, this.y = Ce, this;
        }, _add: function(de) {
          return this.x += de.x, this.y += de.y, this;
        }, _sub: function(de) {
          return this.x -= de.x, this.y -= de.y, this;
        }, _mult: function(de) {
          return this.x *= de, this.y *= de, this;
        }, _div: function(de) {
          return this.x /= de, this.y /= de, this;
        }, _multByPoint: function(de) {
          return this.x *= de.x, this.y *= de.y, this;
        }, _divByPoint: function(de) {
          return this.x /= de.x, this.y /= de.y, this;
        }, _unit: function() {
          return this._div(this.mag()), this;
        }, _perp: function() {
          var de = this.y;
          return this.y = this.x, this.x = -de, this;
        }, _rotate: function(de) {
          var Ce = Math.cos(de), De = Math.sin(de), Ke = De * this.x + Ce * this.y;
          return this.x = Ce * this.x - De * this.y, this.y = Ke, this;
        }, _rotateAround: function(de, Ce) {
          var De = Math.cos(de), Ke = Math.sin(de), Ve = Ce.y + Ke * (this.x - Ce.x) + De * (this.y - Ce.y);
          return this.x = Ce.x + De * (this.x - Ce.x) - Ke * (this.y - Ce.y), this.y = Ve, this;
        }, _round: function() {
          return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
        } }, Ie.convert = function(de) {
          return de instanceof Ie ? de : Array.isArray(de) ? new Ie(de[0], de[1]) : de;
        }, mi;
      }
      var qi = rr(Oi());
      function yn(Ie, de) {
        if (Array.isArray(Ie)) {
          if (!Array.isArray(de) || Ie.length !== de.length)
            return !1;
          for (let Ce = 0; Ce < Ie.length; Ce++)
            if (!yn(Ie[Ce], de[Ce]))
              return !1;
          return !0;
        }
        if (typeof Ie == "object" && Ie !== null && de !== null) {
          if (typeof de != "object" || Object.keys(Ie).length !== Object.keys(de).length)
            return !1;
          for (const Ce in Ie)
            if (!yn(Ie[Ce], de[Ce]))
              return !1;
          return !0;
        }
        return Ie === de;
      }
      const sn = Math.PI / 180, $n = 180 / Math.PI;
      function rn(Ie) {
        return Ie * sn;
      }
      function ji(Ie) {
        return Ie * $n;
      }
      const Kn = [[0, 0], [1, 0], [1, 1], [0, 1]];
      function In(Ie) {
        if (Ie <= 0)
          return 0;
        if (Ie >= 1)
          return 1;
        const de = Ie * Ie, Ce = de * Ie;
        return 4 * (Ie < 0.5 ? Ce : 3 * (Ie - de) + Ce - 0.75);
      }
      function Fn(Ie, de, Ce, De) {
        const Ke = new hi(Ie, de, Ce, De);
        return function(Ve) {
          return Ke.solve(Ve);
        };
      }
      const Po = Fn(0.25, 0.1, 0.25, 1);
      function vn(Ie, de, Ce) {
        return Math.min(Ce, Math.max(de, Ie));
      }
      function Vn(Ie, de, Ce) {
        return (Ce = vn((Ce - Ie) / (de - Ie), 0, 1)) * Ce * (3 - 2 * Ce);
      }
      function Xo(Ie, de, Ce) {
        const De = Ce - de, Ke = ((Ie - de) % De + De) % De + de;
        return Ke === de ? Ce : Ke;
      }
      function Xn(Ie, de, Ce) {
        if (!Ie.length)
          return Ce(null, []);
        let De = Ie.length;
        const Ke = new Array(Ie.length);
        let Ve = null;
        Ie.forEach((er, fr) => {
          de(er, (wr, kr) => {
            wr && (Ve = wr), Ke[fr] = kr, --De == 0 && Ce(Ve, Ke);
          });
        });
      }
      function Yn(Ie, ...de) {
        for (const Ce of de)
          for (const De in Ce)
            Ie[De] = Ce[De];
        return Ie;
      }
      let Wo = 1;
      function Ci() {
        return Wo++;
      }
      function ri(Ie) {
        return Ie <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(Ie) / Math.LN2));
      }
      function yi(Ie, de) {
        Ie.forEach((Ce) => {
          de[Ce] && (de[Ce] = de[Ce].bind(de));
        });
      }
      function Li(Ie, de) {
        return Ie.indexOf(de, Ie.length - de.length) !== -1;
      }
      function Yi(Ie, de, Ce) {
        const De = {};
        for (const Ke in Ie)
          De[Ke] = de.call(this, Ie[Ke], Ke, Ie);
        return De;
      }
      function zn(Ie, de, Ce) {
        const De = {};
        for (const Ke in Ie)
          de.call(this, Ie[Ke], Ke, Ie) && (De[Ke] = Ie[Ke]);
        return De;
      }
      function un(Ie) {
        return Array.isArray(Ie) ? Ie.map(un) : typeof Ie == "object" && Ie ? Yi(Ie, un) : Ie;
      }
      const Gn = {};
      function Mn(Ie) {
        Gn[Ie] || (typeof console < "u" && console.warn(Ie), Gn[Ie] = !0);
      }
      function pn(Ie, de, Ce) {
        return (Ce.y - Ie.y) * (de.x - Ie.x) > (de.y - Ie.y) * (Ce.x - Ie.x);
      }
      function Rn(Ie) {
        let de = 0;
        for (let Ce, De, Ke = 0, Ve = Ie.length, er = Ve - 1; Ke < Ve; er = Ke++)
          Ce = Ie[Ke], De = Ie[er], de += (De.x - Ce.x) * (Ce.y + De.y);
        return de;
      }
      function Io([Ie, de, Ce]) {
        const De = rn(de + 90), Ke = rn(Ce);
        return { x: Ie * Math.cos(De) * Math.sin(Ke), y: Ie * Math.sin(De) * Math.sin(Ke), z: Ie * Math.cos(Ke), azimuthal: de, polar: Ce };
      }
      function to() {
        return typeof WorkerGlobalScope < "u" && typeof self < "u" && self instanceof WorkerGlobalScope;
      }
      function no(Ie) {
        const de = {};
        if (Ie.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (Ce, De, Ke, Ve) => {
          const er = Ke || Ve;
          return de[De] = !er || er.toLowerCase(), "";
        }), de["max-age"]) {
          const Ce = parseInt(de["max-age"], 10);
          isNaN(Ce) ? delete de["max-age"] : de["max-age"] = Ce;
        }
        return de;
      }
      let ma = null;
      function Qn(Ie, de) {
        return [Ie[4 * de], Ie[4 * de + 1], Ie[4 * de + 2], Ie[4 * de + 3]];
      }
      function co(Ie, de, Ce, De) {
        for (; de < Ce; ) {
          const Ke = de + Ce >> 1;
          Ie[Ke] < De ? de = Ke + 1 : Ce = Ke;
        }
        return de;
      }
      function kn(Ie, de, Ce, De) {
        for (; de < Ce; ) {
          const Ke = de + Ce >> 1;
          Ie[Ke] <= De ? de = Ke + 1 : Ce = Ke;
        }
        return de;
      }
      function ai(Ie) {
        return Ie > 0 ? 1 / (1.001 - Ie) : 1 + Ie;
      }
      function _i(Ie) {
        return Ie > 0 ? 1 - 1 / (1.001 - Ie) : -Ie;
      }
      const Pi = { API_URL: "https://api.mapbox.com", get API_URL_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
      }, get API_TILEJSON_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i;
      }, get API_SPRITE_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i;
      }, get API_FONTS_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i;
      }, get API_STYLE_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i;
      }, get API_CDN_URL_REGEX() {
        return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i;
      }, get EVENTS_URL() {
        if (!Pi.API_URL)
          return null;
        try {
          const Ie = new URL(Pi.API_URL);
          return Ie.hostname === "api.mapbox.cn" ? "https://events.mapbox.cn/events/v2" : Ie.hostname === "api.mapbox.com" ? "https://events.mapbox.com/events/v2" : null;
        } catch {
          return null;
        }
      }, SESSION_PATH: "/map-sessions/v1", FEEDBACK_URL: "https://apps.mapbox.com/feedback", TILE_URL_VERSION: "v4", RASTER_URL_PREFIX: "raster/v1", RASTERARRAYS_URL_PREFIX: "rasterarrays/v1", REQUIRE_ACCESS_TOKEN: !0, ACCESS_TOKEN: null, DEFAULT_STYLE: "mapbox://styles/mapbox/standard", MAX_PARALLEL_IMAGE_REQUESTS: 16, DRACO_URL: "https://api.mapbox.com/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm", MESHOPT_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_base_v0.20.wasm", MESHOPT_SIMD_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_simd_v0.20.wasm", GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf", TILES3D_URL_PREFIX: "3dtiles/v1" };
      function Ai(Ie) {
        return Pi.API_URL_REGEX.test(Ie);
      }
      function ki(Ie) {
        return Pi.API_SPRITE_REGEX.test(Ie);
      }
      let an, Ui, Vi, Sn, Hi, en;
      function qn() {
        return an == null && (an = self.OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && typeof self.createImageBitmap == "function"), an;
      }
      const _n = { now: () => Sn !== void 0 ? Sn : performance.now(), setNow(Ie) {
        Sn = Ie;
      }, restoreNow() {
        Sn = void 0;
      }, frame(Ie) {
        const de = requestAnimationFrame(Ie);
        return { cancel: () => cancelAnimationFrame(de) };
      }, getImageData(Ie, de = 0) {
        const { width: Ce, height: De } = Ie;
        Hi || (Hi = document.createElement("canvas"));
        const Ke = Hi.getContext("2d", { willReadFrequently: !0 });
        if (!Ke)
          throw new Error("failed to create canvas 2d context");
        return (Ce > Hi.width || De > Hi.height) && (Hi.width = Ce, Hi.height = De), Ke.clearRect(-de, -de, Ce + 2 * de, De + 2 * de), Ke.drawImage(Ie, 0, 0, Ce, De), Ke.getImageData(-de, -de, Ce + 2 * de, De + 2 * de);
      }, resolveURL: (Ie) => (Ui || (Ui = document.createElement("a")), Ui.href = Ie, Ui.href), get devicePixelRatio() {
        return window.devicePixelRatio;
      }, get prefersReducedMotion() {
        return !!window.matchMedia && (Vi == null && (Vi = window.matchMedia("(prefers-reduced-motion: reduce)")), Vi.matches);
      }, hasCanvasFingerprintNoise() {
        if (en !== void 0)
          return en;
        if (!qn())
          return en = !1, !1;
        const Ie = new OffscreenCanvas(85, 1), de = Ie.getContext("2d", { willReadFrequently: !0 });
        let Ce = 0;
        for (let Ke = 0; Ke < Ie.width; ++Ke)
          de.fillStyle = `rgba(${Ce++},${Ce++},${Ce++}, 255)`, de.fillRect(Ke, 0, 1, 1);
        const De = de.getImageData(0, 0, Ie.width, Ie.height);
        Ce = 0;
        for (let Ke = 0; Ke < De.data.length; ++Ke)
          if (Ke % 4 != 3 && Ce++ !== De.data[Ke])
            return en = !0, !0;
        return en = !1, !1;
      } };
      function Tn(Ie, de) {
        const Ce = Ie.indexOf("?");
        if (Ce < 0)
          return `${Ie}?${new URLSearchParams(de).toString()}`;
        const De = new URLSearchParams(Ie.slice(Ce));
        for (const Ke in de)
          De.set(Ke, de[Ke]);
        return `${Ie.slice(0, Ce)}?${De.toString()}`;
      }
      function xo(Ie, de = { persistentParams: [] }) {
        const Ce = Ie.indexOf("?");
        if (Ce < 0)
          return Ie;
        const De = new URLSearchParams(), Ke = new URLSearchParams(Ie.slice(Ce));
        for (const er of de.persistentParams) {
          const fr = Ke.get(er);
          fr && De.set(er, fr);
        }
        const Ve = De.toString();
        return `${Ie.slice(0, Ce)}${Ve.length > 0 ? `?${Ve}` : ""}`;
      }
      const Co = "mapbox-tiles";
      let $o = 500, Bo = 50;
      const Qo = ["language", "worldview", "jobid"];
      let Go, No;
      function Zo() {
        try {
          return caches;
        } catch {
        }
      }
      function ea() {
        const Ie = Zo();
        Ie && Go == null && (Go = Ie.open(Co));
      }
      let da = 1 / 0;
      const Ra = { supported: !1, testSupport: function(Ie) {
        !Ha && Ea && (Fa ? us(Ie) : ba = Ie);
      } };
      let ba, Ea, Ha = !1, Fa = !1;
      const ls = typeof self < "u" ? self : {};
      function us(Ie) {
        const de = Ie.createTexture();
        Ie.bindTexture(Ie.TEXTURE_2D, de);
        try {
          if (Ie.texImage2D(Ie.TEXTURE_2D, 0, Ie.RGBA, Ie.RGBA, Ie.UNSIGNED_BYTE, Ea), Ie.isContextLost())
            return;
          Ra.supported = !0;
        } catch {
        }
        Ie.deleteTexture(de), Ha = !0;
      }
      ls.document && (Ea = ls.document.createElement("img"), Ea.onload = function() {
        ba && us(ba), ba = null, Fa = !0;
      }, Ea.onerror = function() {
        Ha = !0, ba = null;
      }, Ea.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
      const Xa = { Unknown: "Unknown", Style: "Style", Source: "Source", Tile: "Tile", Glyphs: "Glyphs", SpriteImage: "SpriteImage", SpriteJSON: "SpriteJSON", Iconset: "Iconset", Image: "Image", Model: "Model" };
      typeof Object.freeze == "function" && Object.freeze(Xa);
      class hs extends Error {
        constructor(de, Ce, De) {
          Ce === 401 && Ai(De) && (de += ": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"), super(de), this.status = Ce, this.url = De;
        }
        toString() {
          return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
        }
      }
      const Fc = to() ? () => self.worker && self.worker.referrer : () => (location.protocol === "blob:" ? parent : self).location.href, Pl = function(Ie, de) {
        if (!(/^file:/.test(Ce = Ie.url) || /^file:/.test(Fc()) && !/^\w+:/.test(Ce))) {
          if (self.fetch && self.Request && self.AbortController && Request.prototype.hasOwnProperty("signal"))
            return function(De, Ke) {
              const Ve = new AbortController(), er = new Request(De.url, { method: De.method || "GET", body: De.body, credentials: De.credentials, headers: De.headers, referrer: Fc(), referrerPolicy: De.referrerPolicy, signal: Ve.signal });
              let fr = !1, wr = !1;
              const kr = (cr = er.url).indexOf("sku=") > 0 && Ai(cr);
              var cr;
              De.type === "json" && er.headers.set("Accept", "application/json");
              const Mr = (xr, Sr, Br) => {
                if (wr)
                  return;
                if (xr && xr.message !== "SecurityError" && Mn(xr.toString()), Sr && Br)
                  return Er(Sr);
                const Fr = Date.now();
                fetch(er).then((jr) => {
                  if (jr.ok) {
                    const Qr = kr ? jr.clone() : null;
                    return Er(jr, Qr, Fr);
                  }
                  return Ke(new hs(jr.statusText, jr.status, De.url));
                }).catch((jr) => {
                  jr.name !== "AbortError" && Ke(new Error(`${jr.message} ${De.url}`));
                });
              }, Er = (xr, Sr, Br) => {
                (De.type === "arrayBuffer" ? xr.arrayBuffer() : De.type === "json" ? xr.json() : xr.text()).then((Fr) => {
                  wr || (Sr && Br && function(jr, Qr, ti) {
                    if (ea(), Go == null)
                      return;
                    const Kr = no(Qr.headers.get("Cache-Control") || "");
                    if (Kr["no-store"])
                      return;
                    const ni = { status: Qr.status, statusText: Qr.statusText, headers: new Headers() };
                    Qr.headers.forEach((Di, Ri) => ni.headers.set(Ri, Di)), Kr["max-age"] && ni.headers.set("Expires", new Date(ti + 1e3 * Kr["max-age"]).toUTCString());
                    const gi = ni.headers.get("Expires");
                    if (!gi || new Date(gi).getTime() - ti < 42e4)
                      return;
                    let Si = xo(jr.url, { persistentParams: Qo });
                    if (Qr.status === 206) {
                      const Di = jr.headers.get("Range");
                      if (!Di)
                        return;
                      ni.status = 200, Si = Tn(Si, { range: Di });
                    }
                    (function(Di, Ri) {
                      if (No === void 0)
                        try {
                          new Response(new ReadableStream()), No = !0;
                        } catch {
                          No = !1;
                        }
                      No ? Ri(Di.body) : Di.blob().then(Ri);
                    })(Qr, (Di) => {
                      const Ri = new Response((Bi = Qr.status) !== 200 && Bi !== 404 && [101, 103, 204, 205, 304].includes(Bi) ? null : Di, ni);
                      var Bi;
                      ea(), Go?.then((Ji) => Ji.put(Si, Ri)).catch((Ji) => Mn(Ji.message));
                    });
                  }(er, Sr, Br), fr = !0, Ke(null, Fr, xr.headers.get("Cache-Control"), xr.headers.get("Expires")));
                }).catch((Fr) => {
                  wr || Ke(new Error(Fr.message));
                });
              };
              return kr ? function(xr, Sr) {
                if (ea(), Go == null)
                  return Sr(null);
                Go.then((Br) => {
                  let Fr = xo(xr.url, { persistentParams: Qo });
                  const jr = xr.headers.get("Range");
                  jr && (Fr = Tn(Fr, { range: jr })), Br.match(Fr).then((Qr) => {
                    const ti = function(Kr) {
                      if (!Kr)
                        return !1;
                      const ni = new Date(Kr.headers.get("Expires") || 0), gi = no(Kr.headers.get("Cache-Control") || "");
                      return ni > Date.now() && !gi["no-cache"];
                    }(Qr);
                    Br.delete(Fr), ti && Br.put(Fr, Qr.clone()), Sr(null, Qr, ti);
                  }).catch(Sr);
                }).catch(Sr);
              }(er, Mr) : Mr(null, null), { cancel: () => {
                wr = !0, fr || Ve.abort();
              } };
            }(Ie, de);
          if (to() && self.worker && self.worker.actor)
            return self.worker.actor.send("getResource", Ie, de, void 0, !0);
        }
        var Ce;
        return function(De, Ke) {
          const Ve = new XMLHttpRequest();
          Ve.open(De.method || "GET", De.url, !0), De.type === "arrayBuffer" && (Ve.responseType = "arraybuffer");
          for (const er in De.headers)
            Ve.setRequestHeader(er, De.headers[er]);
          return De.type === "json" && (Ve.responseType = "text", Ve.setRequestHeader("Accept", "application/json")), Ve.withCredentials = De.credentials === "include", Ve.onerror = () => {
            Ke(new Error(Ve.statusText));
          }, Ve.onload = () => {
            if ((Ve.status >= 200 && Ve.status < 300 || Ve.status === 0) && Ve.response !== null) {
              let er = Ve.response;
              if (De.type === "json")
                try {
                  er = JSON.parse(Ve.response);
                } catch (fr) {
                  return Ke(fr);
                }
              Ke(null, er, Ve.getResponseHeader("Cache-Control"), Ve.getResponseHeader("Expires"));
            } else
              Ke(new hs(Ve.statusText, Ve.status, De.url));
          }, Ve.send(De.body), { cancel: () => Ve.abort() };
        }(Ie, de);
      }, wu = function(Ie, de) {
        return Pl(Yn(Ie, { type: "arrayBuffer" }), de);
      };
      function yf(Ie) {
        const de = document.createElement("a");
        return de.href = Ie, de.protocol === location.protocol && de.host === location.host;
      }
      const bf = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
      let xf, Lh;
      xf = [], Lh = 0;
      const ju = function(Ie, de) {
        if (Ra.supported && (Ie.headers || (Ie.headers = {}), Ie.headers.accept = "image/webp,*/*"), Lh >= Pi.MAX_PARALLEL_IMAGE_REQUESTS) {
          const Ve = { requestParameters: Ie, callback: de, cancelled: !1, cancel() {
            this.cancelled = !0;
          } };
          return xf.push(Ve), Ve;
        }
        Lh++;
        let Ce = !1;
        const De = () => {
          if (!Ce)
            for (Ce = !0, Lh--; xf.length && Lh < Pi.MAX_PARALLEL_IMAGE_REQUESTS; ) {
              const Ve = xf.shift(), { requestParameters: er, callback: fr, cancelled: wr } = Ve;
              wr || (Ve.cancel = ju(er, fr).cancel);
            }
        }, Ke = wu(Ie, (Ve, er, fr, wr) => {
          De(), Ve ? de(Ve) : er && (self.createImageBitmap ? function(kr, cr) {
            const Mr = new Blob([new Uint8Array(kr)], { type: "image/png" });
            createImageBitmap(Mr).then((Er) => {
              cr(null, Er);
            }).catch((Er) => {
              cr(new Error(`Could not load image because of ${Er.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
            });
          }(er, (kr, cr) => de(kr, cr, fr, wr)) : function(kr, cr) {
            const Mr = new Image();
            Mr.onload = () => {
              cr(null, Mr), URL.revokeObjectURL(Mr.src), Mr.onload = null, requestAnimationFrame(() => {
                Mr.src = bf;
              });
            }, Mr.onerror = () => cr(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
            const Er = new Blob([new Uint8Array(kr)], { type: "image/png" });
            Mr.src = kr.byteLength ? URL.createObjectURL(Er) : bf;
          }(er, (kr, cr) => de(kr, cr, fr, wr)));
        });
        return { cancel: () => {
          Ke.cancel(), De();
        } };
      };
      var wf, Hl, uc, Wl = { exports: {} }, Zl = { exports: {} }, ru = { exports: {} }, _d = function() {
        if (uc)
          return Wl.exports;
        uc = 1;
        var Ie = (wf || (wf = 1, Zl.exports = function(Ce, De) {
          var Ke, Ve, er, fr, wr, kr, cr, Mr;
          for (Ve = Ce.length - (Ke = 3 & Ce.length), er = De, wr = 3432918353, kr = 461845907, Mr = 0; Mr < Ve; )
            cr = 255 & Ce.charCodeAt(Mr) | (255 & Ce.charCodeAt(++Mr)) << 8 | (255 & Ce.charCodeAt(++Mr)) << 16 | (255 & Ce.charCodeAt(++Mr)) << 24, ++Mr, er = 27492 + (65535 & (fr = 5 * (65535 & (er = (er ^= cr = (65535 & (cr = (cr = (65535 & cr) * wr + (((cr >>> 16) * wr & 65535) << 16) & 4294967295) << 15 | cr >>> 17)) * kr + (((cr >>> 16) * kr & 65535) << 16) & 4294967295) << 13 | er >>> 19)) + ((5 * (er >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (fr >>> 16) & 65535) << 16);
          switch (cr = 0, Ke) {
            case 3:
              cr ^= (255 & Ce.charCodeAt(Mr + 2)) << 16;
            case 2:
              cr ^= (255 & Ce.charCodeAt(Mr + 1)) << 8;
            case 1:
              er ^= cr = (65535 & (cr = (cr = (65535 & (cr ^= 255 & Ce.charCodeAt(Mr))) * wr + (((cr >>> 16) * wr & 65535) << 16) & 4294967295) << 15 | cr >>> 17)) * kr + (((cr >>> 16) * kr & 65535) << 16) & 4294967295;
          }
          return er ^= Ce.length, er = 2246822507 * (65535 & (er ^= er >>> 16)) + ((2246822507 * (er >>> 16) & 65535) << 16) & 4294967295, er = 3266489909 * (65535 & (er ^= er >>> 13)) + ((3266489909 * (er >>> 16) & 65535) << 16) & 4294967295, (er ^= er >>> 16) >>> 0;
        }), Zl.exports), de = (Hl || (Hl = 1, ru.exports = function(Ce, De) {
          for (var Ke, Ve = Ce.length, er = De ^ Ve, fr = 0; Ve >= 4; )
            Ke = 1540483477 * (65535 & (Ke = 255 & Ce.charCodeAt(fr) | (255 & Ce.charCodeAt(++fr)) << 8 | (255 & Ce.charCodeAt(++fr)) << 16 | (255 & Ce.charCodeAt(++fr)) << 24)) + ((1540483477 * (Ke >>> 16) & 65535) << 16), er = 1540483477 * (65535 & er) + ((1540483477 * (er >>> 16) & 65535) << 16) ^ (Ke = 1540483477 * (65535 & (Ke ^= Ke >>> 24)) + ((1540483477 * (Ke >>> 16) & 65535) << 16)), Ve -= 4, ++fr;
          switch (Ve) {
            case 3:
              er ^= (255 & Ce.charCodeAt(fr + 2)) << 16;
            case 2:
              er ^= (255 & Ce.charCodeAt(fr + 1)) << 8;
            case 1:
              er = 1540483477 * (65535 & (er ^= 255 & Ce.charCodeAt(fr))) + ((1540483477 * (er >>> 16) & 65535) << 16);
          }
          return er = 1540483477 * (65535 & (er ^= er >>> 13)) + ((1540483477 * (er >>> 16) & 65535) << 16), (er ^= er >>> 15) >>> 0;
        }), ru.exports);
        return Wl.exports = Ie, Wl.exports.murmur3 = Ie, Wl.exports.murmur2 = de, Wl.exports;
      }(), qu = rr(_d);
      class Nc {
        constructor(de, ...Ce) {
          Yn(this, Ce[0] || {}), this.type = de;
        }
      }
      class Xl extends Nc {
        constructor(de, Ce = {}) {
          super("error", Yn({ error: de }, Ce));
        }
      }
      function yd(Ie, de, Ce) {
        Ce[Ie] && Ce[Ie].indexOf(de) !== -1 || (Ce[Ie] = Ce[Ie] || [], Ce[Ie].push(de));
      }
      function Mf(Ie, de, Ce) {
        if (Ce && Ce[Ie]) {
          const De = Ce[Ie].indexOf(de);
          De !== -1 && Ce[Ie].splice(De, 1);
        }
      }
      class Ih {
        on(de, Ce) {
          return this._listeners = this._listeners || {}, yd(de, Ce, this._listeners), this;
        }
        off(de, Ce) {
          return Mf(de, Ce, this._listeners), Mf(de, Ce, this._oneTimeListeners), this;
        }
        once(de, Ce) {
          return Ce ? (this._oneTimeListeners = this._oneTimeListeners || {}, yd(de, Ce, this._oneTimeListeners), this) : new Promise((De) => this.once(de, De));
        }
        fire(de, Ce) {
          const De = typeof de == "string" ? new Nc(de, Ce) : de, Ke = De.type;
          if (this.listens(Ke)) {
            De.target = this;
            const Ve = this._listeners && this._listeners[Ke] ? this._listeners[Ke].slice() : [];
            for (const wr of Ve)
              wr.call(this, De);
            const er = this._oneTimeListeners && this._oneTimeListeners[Ke] ? this._oneTimeListeners[Ke].slice() : [];
            for (const wr of er)
              Mf(Ke, wr, this._oneTimeListeners), wr.call(this, De);
            const fr = this._eventedParent;
            fr && (Yn(De, typeof this._eventedParentData == "function" ? this._eventedParentData() : this._eventedParentData), fr.fire(De));
          } else
            De instanceof Xl && console.error(De.error);
          return this;
        }
        listens(de) {
          return !!(this._listeners && this._listeners[de] && this._listeners[de].length > 0 || this._oneTimeListeners && this._oneTimeListeners[de] && this._oneTimeListeners[de].length > 0 || this._eventedParent && this._eventedParent.listens(de));
        }
        setEventedParent(de, Ce) {
          return this._eventedParent = de, this._eventedParentData = Ce, this;
        }
      }
      var Kl, bd = {}, xd = function() {
        if (Kl)
          return bd;
        Kl = 1;
        var Ie = { transparent: [0, 0, 0, 0], aliceblue: [240, 248, 255, 1], antiquewhite: [250, 235, 215, 1], aqua: [0, 255, 255, 1], aquamarine: [127, 255, 212, 1], azure: [240, 255, 255, 1], beige: [245, 245, 220, 1], bisque: [255, 228, 196, 1], black: [0, 0, 0, 1], blanchedalmond: [255, 235, 205, 1], blue: [0, 0, 255, 1], blueviolet: [138, 43, 226, 1], brown: [165, 42, 42, 1], burlywood: [222, 184, 135, 1], cadetblue: [95, 158, 160, 1], chartreuse: [127, 255, 0, 1], chocolate: [210, 105, 30, 1], coral: [255, 127, 80, 1], cornflowerblue: [100, 149, 237, 1], cornsilk: [255, 248, 220, 1], crimson: [220, 20, 60, 1], cyan: [0, 255, 255, 1], darkblue: [0, 0, 139, 1], darkcyan: [0, 139, 139, 1], darkgoldenrod: [184, 134, 11, 1], darkgray: [169, 169, 169, 1], darkgreen: [0, 100, 0, 1], darkgrey: [169, 169, 169, 1], darkkhaki: [189, 183, 107, 1], darkmagenta: [139, 0, 139, 1], darkolivegreen: [85, 107, 47, 1], darkorange: [255, 140, 0, 1], darkorchid: [153, 50, 204, 1], darkred: [139, 0, 0, 1], darksalmon: [233, 150, 122, 1], darkseagreen: [143, 188, 143, 1], darkslateblue: [72, 61, 139, 1], darkslategray: [47, 79, 79, 1], darkslategrey: [47, 79, 79, 1], darkturquoise: [0, 206, 209, 1], darkviolet: [148, 0, 211, 1], deeppink: [255, 20, 147, 1], deepskyblue: [0, 191, 255, 1], dimgray: [105, 105, 105, 1], dimgrey: [105, 105, 105, 1], dodgerblue: [30, 144, 255, 1], firebrick: [178, 34, 34, 1], floralwhite: [255, 250, 240, 1], forestgreen: [34, 139, 34, 1], fuchsia: [255, 0, 255, 1], gainsboro: [220, 220, 220, 1], ghostwhite: [248, 248, 255, 1], gold: [255, 215, 0, 1], goldenrod: [218, 165, 32, 1], gray: [128, 128, 128, 1], green: [0, 128, 0, 1], greenyellow: [173, 255, 47, 1], grey: [128, 128, 128, 1], honeydew: [240, 255, 240, 1], hotpink: [255, 105, 180, 1], indianred: [205, 92, 92, 1], indigo: [75, 0, 130, 1], ivory: [255, 255, 240, 1], khaki: [240, 230, 140, 1], lavender: [230, 230, 250, 1], lavenderblush: [255, 240, 245, 1], lawngreen: [124, 252, 0, 1], lemonchiffon: [255, 250, 205, 1], lightblue: [173, 216, 230, 1], lightcoral: [240, 128, 128, 1], lightcyan: [224, 255, 255, 1], lightgoldenrodyellow: [250, 250, 210, 1], lightgray: [211, 211, 211, 1], lightgreen: [144, 238, 144, 1], lightgrey: [211, 211, 211, 1], lightpink: [255, 182, 193, 1], lightsalmon: [255, 160, 122, 1], lightseagreen: [32, 178, 170, 1], lightskyblue: [135, 206, 250, 1], lightslategray: [119, 136, 153, 1], lightslategrey: [119, 136, 153, 1], lightsteelblue: [176, 196, 222, 1], lightyellow: [255, 255, 224, 1], lime: [0, 255, 0, 1], limegreen: [50, 205, 50, 1], linen: [250, 240, 230, 1], magenta: [255, 0, 255, 1], maroon: [128, 0, 0, 1], mediumaquamarine: [102, 205, 170, 1], mediumblue: [0, 0, 205, 1], mediumorchid: [186, 85, 211, 1], mediumpurple: [147, 112, 219, 1], mediumseagreen: [60, 179, 113, 1], mediumslateblue: [123, 104, 238, 1], mediumspringgreen: [0, 250, 154, 1], mediumturquoise: [72, 209, 204, 1], mediumvioletred: [199, 21, 133, 1], midnightblue: [25, 25, 112, 1], mintcream: [245, 255, 250, 1], mistyrose: [255, 228, 225, 1], moccasin: [255, 228, 181, 1], navajowhite: [255, 222, 173, 1], navy: [0, 0, 128, 1], oldlace: [253, 245, 230, 1], olive: [128, 128, 0, 1], olivedrab: [107, 142, 35, 1], orange: [255, 165, 0, 1], orangered: [255, 69, 0, 1], orchid: [218, 112, 214, 1], palegoldenrod: [238, 232, 170, 1], palegreen: [152, 251, 152, 1], paleturquoise: [175, 238, 238, 1], palevioletred: [219, 112, 147, 1], papayawhip: [255, 239, 213, 1], peachpuff: [255, 218, 185, 1], peru: [205, 133, 63, 1], pink: [255, 192, 203, 1], plum: [221, 160, 221, 1], powderblue: [176, 224, 230, 1], purple: [128, 0, 128, 1], rebeccapurple: [102, 51, 153, 1], red: [255, 0, 0, 1], rosybrown: [188, 143, 143, 1], royalblue: [65, 105, 225, 1], saddlebrown: [139, 69, 19, 1], salmon: [250, 128, 114, 1], sandybrown: [244, 164, 96, 1], seagreen: [46, 139, 87, 1], seashell: [255, 245, 238, 1], sienna: [160, 82, 45, 1], silver: [192, 192, 192, 1], skyblue: [135, 206, 235, 1], slateblue: [106, 90, 205, 1], slategray: [112, 128, 144, 1], slategrey: [112, 128, 144, 1], snow: [255, 250, 250, 1], springgreen: [0, 255, 127, 1], steelblue: [70, 130, 180, 1], tan: [210, 180, 140, 1], teal: [0, 128, 128, 1], thistle: [216, 191, 216, 1], tomato: [255, 99, 71, 1], turquoise: [64, 224, 208, 1], violet: [238, 130, 238, 1], wheat: [245, 222, 179, 1], white: [255, 255, 255, 1], whitesmoke: [245, 245, 245, 1], yellow: [255, 255, 0, 1], yellowgreen: [154, 205, 50, 1] };
        function de(Ve) {
          return (Ve = Math.round(Ve)) < 0 ? 0 : Ve > 255 ? 255 : Ve;
        }
        function Ce(Ve) {
          return de(Ve[Ve.length - 1] === "%" ? parseFloat(Ve) / 100 * 255 : parseInt(Ve));
        }
        function De(Ve) {
          return (er = Ve[Ve.length - 1] === "%" ? parseFloat(Ve) / 100 : parseFloat(Ve)) < 0 ? 0 : er > 1 ? 1 : er;
          var er;
        }
        function Ke(Ve, er, fr) {
          return fr < 0 ? fr += 1 : fr > 1 && (fr -= 1), 6 * fr < 1 ? Ve + (er - Ve) * fr * 6 : 2 * fr < 1 ? er : 3 * fr < 2 ? Ve + (er - Ve) * (2 / 3 - fr) * 6 : Ve;
        }
        try {
          bd.parseCSSColor = function(Ve) {
            var er, fr = Ve.replace(/ /g, "").toLowerCase();
            if (fr in Ie)
              return Ie[fr].slice();
            if (fr[0] === "#")
              return fr.length === 4 ? (er = parseInt(fr.substr(1), 16)) >= 0 && er <= 4095 ? [(3840 & er) >> 4 | (3840 & er) >> 8, 240 & er | (240 & er) >> 4, 15 & er | (15 & er) << 4, 1] : null : fr.length === 7 && (er = parseInt(fr.substr(1), 16)) >= 0 && er <= 16777215 ? [(16711680 & er) >> 16, (65280 & er) >> 8, 255 & er, 1] : null;
            var wr = fr.indexOf("("), kr = fr.indexOf(")");
            if (wr !== -1 && kr + 1 === fr.length) {
              var cr = fr.substr(0, wr), Mr = fr.substr(wr + 1, kr - (wr + 1)).split(","), Er = 1;
              switch (cr) {
                case "rgba":
                  if (Mr.length !== 4)
                    return null;
                  Er = De(Mr.pop());
                case "rgb":
                  return Mr.length !== 3 ? null : [Ce(Mr[0]), Ce(Mr[1]), Ce(Mr[2]), Er];
                case "hsla":
                  if (Mr.length !== 4)
                    return null;
                  Er = De(Mr.pop());
                case "hsl":
                  if (Mr.length !== 3)
                    return null;
                  var xr = (parseFloat(Mr[0]) % 360 + 360) % 360 / 360, Sr = De(Mr[1]), Br = De(Mr[2]), Fr = Br <= 0.5 ? Br * (Sr + 1) : Br + Sr - Br * Sr, jr = 2 * Br - Fr;
                  return [de(255 * Ke(jr, Fr, xr + 1 / 3)), de(255 * Ke(jr, Fr, xr)), de(255 * Ke(jr, Fr, xr - 1 / 3)), Er];
                default:
                  return null;
              }
            }
            return null;
          };
        } catch {
        }
        return bd;
      }();
      class Ca {
        constructor(de, Ce, De, Ke = 1) {
          this.r = de, this.g = Ce, this.b = De, this.a = Ke;
        }
        static parse(de) {
          if (!de)
            return;
          if (de instanceof Ca)
            return de;
          if (typeof de != "string")
            return;
          const Ce = xd.parseCSSColor(de);
          return Ce ? new Ca(Ce[0] / 255 * Ce[3], Ce[1] / 255 * Ce[3], Ce[2] / 255 * Ce[3], Ce[3]) : void 0;
        }
        toStringPremultipliedAlpha() {
          const [de, Ce, De, Ke] = this.a === 0 ? [0, 0, 0, 0] : [255 * this.r / this.a, 255 * this.g / this.a, 255 * this.b / this.a, this.a];
          return `rgba(${Math.round(de)},${Math.round(Ce)},${Math.round(De)},${Ke})`;
        }
        toString() {
          const [de, Ce, De, Ke] = [this.r, this.g, this.b, this.a];
          return `rgba(${Math.round(255 * de)},${Math.round(255 * Ce)},${Math.round(255 * De)},${Ke})`;
        }
        toRenderColor(de) {
          const { r: Ce, g: De, b: Ke, a: Ve } = this;
          return new O0(de, Ce, De, Ke, Ve);
        }
        clone() {
          return new Ca(this.r, this.g, this.b, this.a);
        }
      }
      class O0 {
        constructor(de, Ce, De, Ke, Ve) {
          if (de) {
            const er = de.image.height, fr = er * er;
            Ce = Ve === 0 ? 0 : Ce / Ve * (er - 1), De = Ve === 0 ? 0 : De / Ve * (er - 1), Ke = Ve === 0 ? 0 : Ke / Ve * (er - 1);
            const wr = Math.floor(Ce), kr = Math.floor(De), cr = Math.floor(Ke), Mr = Math.ceil(Ce), Er = Math.ceil(De), xr = Math.ceil(Ke), Sr = Ce - wr, Br = De - kr, Fr = Ke - cr, jr = de.image.data, Qr = 4 * (wr + kr * fr + cr * er), ti = 4 * (wr + kr * fr + xr * er), Kr = 4 * (wr + Er * fr + cr * er), ni = 4 * (wr + Er * fr + xr * er), gi = 4 * (Mr + kr * fr + cr * er), Si = 4 * (Mr + kr * fr + xr * er), Di = 4 * (Mr + Er * fr + cr * er), Ri = 4 * (Mr + Er * fr + xr * er);
            if (Qr < 0 || Ri >= jr.length)
              throw new Error("out of range");
            this.r = Ho(Ho(Ho(jr[Qr], jr[ti], Fr), Ho(jr[Kr], jr[ni], Fr), Br), Ho(Ho(jr[gi], jr[Si], Fr), Ho(jr[Di], jr[Ri], Fr), Br), Sr) / 255 * Ve, this.g = Ho(Ho(Ho(jr[Qr + 1], jr[ti + 1], Fr), Ho(jr[Kr + 1], jr[ni + 1], Fr), Br), Ho(Ho(jr[gi + 1], jr[Si + 1], Fr), Ho(jr[Di + 1], jr[Ri + 1], Fr), Br), Sr) / 255 * Ve, this.b = Ho(Ho(Ho(jr[Qr + 2], jr[ti + 2], Fr), Ho(jr[Kr + 2], jr[ni + 2], Fr), Br), Ho(Ho(jr[gi + 2], jr[Si + 2], Fr), Ho(jr[Di + 2], jr[Ri + 2], Fr), Br), Sr) / 255 * Ve, this.a = Ve;
          } else
            this.r = Ce, this.g = De, this.b = Ke, this.a = Ve;
        }
        toArray() {
          const { r: de, g: Ce, b: De, a: Ke } = this;
          return Ke === 0 ? [0, 0, 0, 0] : [255 * de / Ke, 255 * Ce / Ke, 255 * De / Ke, Ke];
        }
        toHslaArray() {
          if (this.a === 0)
            return [0, 0, 0, 0];
          const { r: de, g: Ce, b: De, a: Ke } = this, Ve = Math.min(Math.max(de / Ke, 0), 1), er = Math.min(Math.max(Ce / Ke, 0), 1), fr = Math.min(Math.max(De / Ke, 0), 1), wr = Math.min(Ve, er, fr), kr = Math.max(Ve, er, fr), cr = (wr + kr) / 2;
          if (wr === kr)
            return [0, 0, 100 * cr, Ke];
          const Mr = kr - wr, Er = cr > 0.5 ? Mr / (2 - kr - wr) : Mr / (kr + wr);
          let xr = 0;
          return kr === Ve ? xr = (er - fr) / Mr + (er < fr ? 6 : 0) : kr === er ? xr = (fr - Ve) / Mr + 2 : kr === fr && (xr = (Ve - er) / Mr + 4), xr *= 60, [Math.min(Math.max(xr, 0), 360), Math.min(Math.max(100 * Er, 0), 100), Math.min(Math.max(100 * cr, 0), 100), Ke];
        }
        toArray01() {
          const { r: de, g: Ce, b: De, a: Ke } = this;
          return Ke === 0 ? [0, 0, 0, 0] : [de / Ke, Ce / Ke, De / Ke, Ke];
        }
        toArray01Scaled(de) {
          const { r: Ce, g: De, b: Ke, a: Ve } = this;
          return Ve === 0 ? [0, 0, 0] : [Ce / Ve * de, De / Ve * de, Ke / Ve * de];
        }
        toArray01PremultipliedAlpha() {
          const { r: de, g: Ce, b: De, a: Ke } = this;
          return [de, Ce, De, Ke];
        }
        toArray01Linear() {
          const { r: de, g: Ce, b: De, a: Ke } = this;
          return Ke === 0 ? [0, 0, 0, 0] : [Math.pow(de / Ke, 2.2), Math.pow(Ce / Ke, 2.2), Math.pow(De / Ke, 2.2), Ke];
        }
      }
      function Ho(Ie, de, Ce) {
        return Ie * (1 - Ce) + de * Ce;
      }
      function Sp(Ie, de, Ce) {
        return Ie.map((De, Ke) => Ho(De, de[Ke], Ce));
      }
      Ca.black = new Ca(0, 0, 0, 1), Ca.white = new Ca(1, 1, 1, 1), Ca.transparent = new Ca(0, 0, 0, 0), Ca.red = new Ca(1, 0, 0, 1), Ca.blue = new Ca(0, 0, 1, 1);
      var xa = Object.freeze({ __proto__: null, array: Sp, color: function(Ie, de, Ce) {
        return new Ca(Ho(Ie.r, de.r, Ce), Ho(Ie.g, de.g, Ce), Ho(Ie.b, de.b, Ce), Ho(Ie.a, de.a, Ce));
      }, number: Ho });
      function Sf(Ie, ...de) {
        for (const Ce of de)
          for (const De in Ce)
            Ie[De] = Ce[De];
        return Ie;
      }
      class hc extends Error {
        constructor(de, Ce) {
          super(Ce), this.message = Ce, this.key = de;
        }
      }
      class Ep {
        constructor(de, Ce = []) {
          this.parent = de, this.bindings = {};
          for (const [De, Ke] of Ce)
            this.bindings[De] = Ke;
        }
        concat(de) {
          return new Ep(this, de);
        }
        get(de) {
          if (this.bindings[de])
            return this.bindings[de];
          if (this.parent)
            return this.parent.get(de);
          throw new Error(`${de} not found in scope.`);
        }
        has(de) {
          return !!this.bindings[de] || !!this.parent && this.parent.has(de);
        }
      }
      const Bh = { kind: "null" }, To = { kind: "number" }, Pa = { kind: "string" }, Ta = { kind: "boolean" }, Dl = { kind: "color" }, Gu = { kind: "object" }, ga = { kind: "value" }, vs = { kind: "collator" }, es = { kind: "formatted" }, Hu = { kind: "resolvedImage" };
      function dl(Ie, de) {
        return { kind: "array", itemType: Ie, N: de };
      }
      function ts(Ie) {
        if (Ie.kind === "array") {
          const de = ts(Ie.itemType);
          return typeof Ie.N == "number" ? `array<${de}, ${Ie.N}>` : Ie.itemType.kind === "value" ? "array" : `array<${de}>`;
        }
        return Ie.kind;
      }
      const Bm = [Bh, To, Pa, Ta, Dl, es, Gu, dl(ga), Hu];
      function wd(Ie, de) {
        if (de.kind === "error")
          return null;
        if (Ie.kind === "array") {
          if (de.kind === "array" && (de.N === 0 && de.itemType.kind === "value" || !wd(Ie.itemType, de.itemType)) && (typeof Ie.N != "number" || Ie.N === de.N))
            return null;
        } else {
          if (Ie.kind === de.kind)
            return null;
          if (Ie.kind === "value") {
            for (const Ce of Bm)
              if (!wd(Ce, de))
                return null;
          }
        }
        return `Expected ${ts(Ie)} but found ${ts(de)} instead.`;
      }
      function Ef(Ie, de) {
        return de.some((Ce) => Ce.kind === Ie.kind);
      }
      function Wu(Ie, de) {
        return de.some((Ce) => Ce === "null" ? Ie === null : Ce === "array" ? Array.isArray(Ie) : Ce === "object" ? Ie && !Array.isArray(Ie) && typeof Ie == "object" : Ce === typeof Ie);
      }
      class Cf {
        constructor(de, Ce, De) {
          this.sensitivity = de ? Ce ? "variant" : "case" : Ce ? "accent" : "base", this.locale = De, this.collator = new Intl.Collator(this.locale ? this.locale : [], { sensitivity: this.sensitivity, usage: "search" });
        }
        compare(de, Ce) {
          return this.collator.compare(de, Ce);
        }
        resolvedLocale() {
          return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
        }
      }
      class Rs {
        constructor(de, Ce, De, Ke, Ve) {
          this.text = de.normalize ? de.normalize() : de, this.image = Ce, this.scale = De, this.fontStack = Ke, this.textColor = Ve;
        }
      }
      class Ys {
        constructor(de) {
          this.sections = de;
        }
        static fromString(de) {
          return new Ys([new Rs(de, null, null, null, null)]);
        }
        isEmpty() {
          return this.sections.length === 0 || !this.sections.some((de) => de.text.length !== 0 || de.image && de.image.namePrimary);
        }
        static factory(de) {
          return de instanceof Ys ? de : Ys.fromString(de);
        }
        toString() {
          return this.sections.length === 0 ? "" : this.sections.map((de) => de.text).join("");
        }
        serialize() {
          const de = ["format"];
          for (const Ce of this.sections) {
            if (Ce.image) {
              de.push(["image", Ce.image.namePrimary]);
              continue;
            }
            de.push(Ce.text);
            const De = {};
            Ce.fontStack && (De["text-font"] = ["literal", Ce.fontStack.split(",")]), Ce.scale && (De["font-scale"] = Ce.scale), Ce.textColor && (De["text-color"] = ["rgba"].concat(Ce.textColor.toRenderColor(null).toArray())), de.push(De);
          }
          return de;
        }
      }
      class yl {
        constructor(de, Ce) {
          if (this.id = de, this.options = Ce || { params: {} }, this.options.transform) {
            const { a: De, b: Ke, c: Ve, d: er, e: fr, f: wr } = this.options.transform;
            this.options.transform = new DOMMatrix([De, Ke, Ve, er, fr, wr]);
          } else
            this.options.transform = new DOMMatrix([1, 0, 0, 1, 0, 0]);
        }
        static deserializeId(de) {
          return JSON.parse(de).id;
        }
        static deserializeFromString(de) {
          const Ce = JSON.parse(de), { a: De, b: Ke, c: Ve, d: er, e: fr, f: wr } = Ce.options.transform;
          return new DOMMatrix([De, Ke, Ve, er, fr, wr]), new yl(Ce.id, Ce.options);
        }
        scaleSelf(de) {
          return this.options.transform = this.options.transform.scale(de), this;
        }
        serialize() {
          const de = { id: this.id };
          this.options && (de.options = this.options);
          const { a: Ce, b: De, c: Ke, d: Ve, e: er, f: fr } = this.options.transform;
          return de.options.transform = { a: Ce, b: De, c: Ke, d: Ve, e: er, f: fr }, JSON.stringify(de);
        }
      }
      class Ps {
        constructor(de) {
          this.namePrimary = de.namePrimary, de.nameSecondary && (this.nameSecondary = de.nameSecondary), de.optionsPrimary && (this.optionsPrimary = de.optionsPrimary), de.optionsSecondary && (this.optionsSecondary = de.optionsSecondary), this.available = de.available;
        }
        toString() {
          return this.namePrimary && this.nameSecondary ? `[${this.namePrimary},${this.nameSecondary}]` : this.namePrimary;
        }
        getPrimary() {
          return new yl(this.namePrimary, { params: this.optionsPrimary && this.optionsPrimary.params || {} });
        }
        getSerializedPrimary() {
          return this.getPrimary().serialize();
        }
        getSecondary() {
          return this.nameSecondary ? new yl(this.nameSecondary, { params: this.optionsSecondary && this.optionsSecondary.params || {} }) : null;
        }
        static from(de) {
          return typeof de == "string" ? Ps.build(de) : de;
        }
        static build(de, Ce, De, Ke) {
          return de ? new Ps({ namePrimary: de, nameSecondary: Ce, optionsPrimary: De, optionsSecondary: Ke, available: !1 }) : null;
        }
      }
      function iu(Ie, de, Ce, De) {
        return typeof Ie == "number" && Ie >= 0 && Ie <= 255 && typeof de == "number" && de >= 0 && de <= 255 && typeof Ce == "number" && Ce >= 0 && Ce <= 255 ? De === void 0 || typeof De == "number" && De >= 0 && De <= 1 ? null : `Invalid rgba value [${[Ie, de, Ce, De].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${(typeof De == "number" ? [Ie, de, Ce, De] : [Ie, de, Ce]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
      }
      function ol(Ie) {
        if (Ie === null || typeof Ie == "string" || typeof Ie == "boolean" || typeof Ie == "number" || Ie instanceof Ca || Ie instanceof Cf || Ie instanceof Ys || Ie instanceof Ps)
          return !0;
        if (Array.isArray(Ie)) {
          for (const de of Ie)
            if (!ol(de))
              return !1;
          return !0;
        }
        if (typeof Ie == "object") {
          for (const de in Ie)
            if (!ol(Ie[de]))
              return !1;
          return !0;
        }
        return !1;
      }
      function ds(Ie) {
        if (Ie === null)
          return Bh;
        if (typeof Ie == "string")
          return Pa;
        if (typeof Ie == "boolean")
          return Ta;
        if (typeof Ie == "number")
          return To;
        if (Ie instanceof Ca)
          return Dl;
        if (Ie instanceof Cf)
          return vs;
        if (Ie instanceof Ys)
          return es;
        if (Ie instanceof Ps)
          return Hu;
        if (Array.isArray(Ie)) {
          const de = Ie.length;
          let Ce;
          for (const De of Ie) {
            const Ke = ds(De);
            if (Ce) {
              if (Ce === Ke)
                continue;
              Ce = ga;
              break;
            }
            Ce = Ke;
          }
          return dl(Ce || ga, de);
        }
        return Gu;
      }
      function dc(Ie) {
        const de = typeof Ie;
        return Ie === null ? "" : de === "string" || de === "number" || de === "boolean" ? String(Ie) : Ie instanceof Ca ? Ie.toStringPremultipliedAlpha() : Ie instanceof Ys || Ie instanceof Ps ? Ie.toString() : JSON.stringify(Ie);
      }
      class Yl {
        constructor(de, Ce) {
          this.type = de, this.value = Ce;
        }
        static parse(de, Ce) {
          if (de.length !== 2)
            return Ce.error(`'literal' expression requires exactly one argument, but found ${de.length - 1} instead.`);
          if (!ol(de[1]))
            return Ce.error("invalid value");
          const De = de[1];
          let Ke = ds(De);
          const Ve = Ce.expectedType;
          return Ke.kind !== "array" || Ke.N !== 0 || !Ve || Ve.kind !== "array" || typeof Ve.N == "number" && Ve.N !== 0 || (Ke = Ve), new Yl(Ke, De);
        }
        evaluate() {
          return this.value;
        }
        eachChild() {
        }
        outputDefined() {
          return !0;
        }
        serialize() {
          return this.type.kind === "array" || this.type.kind === "object" ? ["literal", this.value] : this.value instanceof Ca ? ["rgba"].concat(this.value.toRenderColor(null).toArray()) : this.value instanceof Ys ? this.value.serialize() : this.value;
        }
      }
      class Ts {
        constructor(de) {
          this.name = "ExpressionEvaluationError", this.message = de;
        }
        toJSON() {
          return this.message;
        }
      }
      const $h = { string: Pa, number: To, boolean: Ta, object: Gu };
      class Jl {
        constructor(de, Ce) {
          this.type = de, this.args = Ce;
        }
        static parse(de, Ce) {
          if (de.length < 2)
            return Ce.error("Expected at least one argument.");
          let De, Ke = 1;
          const Ve = de[0];
          if (Ve === "array") {
            let fr, wr;
            if (de.length > 2) {
              const kr = de[1];
              if (typeof kr != "string" || !(kr in $h) || kr === "object")
                return Ce.error('The item type argument of "array" must be one of string, number, boolean', 1);
              fr = $h[kr], Ke++;
            } else
              fr = ga;
            if (de.length > 3) {
              if (de[2] !== null && (typeof de[2] != "number" || de[2] < 0 || de[2] !== Math.floor(de[2])))
                return Ce.error('The length argument to "array" must be a positive integer literal', 2);
              wr = de[2], Ke++;
            }
            De = dl(fr, wr);
          } else
            De = $h[Ve];
          const er = [];
          for (; Ke < de.length; Ke++) {
            const fr = Ce.parse(de[Ke], Ke, ga);
            if (!fr)
              return null;
            er.push(fr);
          }
          return new Jl(De, er);
        }
        evaluate(de) {
          for (let Ce = 0; Ce < this.args.length; Ce++) {
            const De = this.args[Ce].evaluate(de);
            if (!wd(this.type, ds(De)))
              return De;
            if (Ce === this.args.length - 1)
              throw new Ts(`The expression ${JSON.stringify(this.args[Ce].serialize())} evaluated to ${ts(ds(De))} but was expected to be of type ${ts(this.type)}.`);
          }
          return null;
        }
        eachChild(de) {
          this.args.forEach(de);
        }
        outputDefined() {
          return this.args.every((de) => de.outputDefined());
        }
        serialize() {
          const de = this.type, Ce = [de.kind];
          if (de.kind === "array") {
            const De = de.itemType;
            if (De.kind === "string" || De.kind === "number" || De.kind === "boolean") {
              Ce.push(De.kind);
              const Ke = de.N;
              (typeof Ke == "number" || this.args.length > 1) && Ce.push(Ke);
            }
          }
          return Ce.concat(this.args.map((De) => De.serialize()));
        }
      }
      class Ds {
        constructor(de) {
          this.type = es, this.sections = de;
        }
        static parse(de, Ce) {
          if (de.length < 2)
            return Ce.error("Expected at least one argument.");
          const De = de[1];
          if (!Array.isArray(De) && typeof De == "object")
            return Ce.error("First argument must be an image or text section.");
          const Ke = [];
          let Ve = !1;
          for (let er = 1; er <= de.length - 1; ++er) {
            const fr = de[er];
            if (Ve && typeof fr == "object" && !Array.isArray(fr)) {
              Ve = !1;
              let wr = null;
              if (fr["font-scale"] && (wr = Ce.parseObjectValue(fr["font-scale"], er, "font-scale", To), !wr))
                return null;
              let kr = null;
              if (fr["text-font"] && (kr = Ce.parseObjectValue(fr["text-font"], er, "text-font", dl(Pa)), !kr))
                return null;
              let cr = null;
              if (fr["text-color"] && (cr = Ce.parseObjectValue(fr["text-color"], er, "text-color", Dl), !cr))
                return null;
              const Mr = Ke[Ke.length - 1];
              Mr.scale = wr, Mr.font = kr, Mr.textColor = cr;
            } else {
              const wr = Ce.parse(de[er], er, ga);
              if (!wr)
                return null;
              const kr = wr.type.kind;
              if (kr !== "string" && kr !== "value" && kr !== "null" && kr !== "resolvedImage")
                return Ce.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
              Ve = !0, Ke.push({ content: wr, scale: null, font: null, textColor: null });
            }
          }
          return new Ds(Ke);
        }
        evaluate(de) {
          return new Ys(this.sections.map((Ce) => {
            const De = Ce.content.evaluate(de);
            return ds(De) === Hu ? new Rs("", De, null, null, null) : new Rs(dc(De), null, Ce.scale ? Ce.scale.evaluate(de) : null, Ce.font ? Ce.font.evaluate(de).join(",") : null, Ce.textColor ? Ce.textColor.evaluate(de) : null);
          }));
        }
        eachChild(de) {
          for (const Ce of this.sections)
            de(Ce.content), Ce.scale && de(Ce.scale), Ce.font && de(Ce.font), Ce.textColor && de(Ce.textColor);
        }
        outputDefined() {
          return !1;
        }
        serialize() {
          const de = ["format"];
          for (const Ce of this.sections) {
            de.push(Ce.content.serialize());
            const De = {};
            Ce.scale && (De["font-scale"] = Ce.scale.serialize()), Ce.font && (De["text-font"] = Ce.font.serialize()), Ce.textColor && (De["text-color"] = Ce.textColor.serialize()), de.push(De);
          }
          return de;
        }
      }
      class Rh {
        constructor(de, Ce, De, Ke) {
          this._imageWarnHistory = {}, this.type = Hu, this.inputPrimary = de, this.inputSecondary = Ce, this.inputPrimaryParams = De, this.inputSecondaryParams = Ke;
        }
        static parse(de, Ce) {
          if (de.length < 2)
            return Ce.error("Expected two or more arguments.");
          let De = 1;
          const Ke = [];
          function Ve() {
            if (De < de.length) {
              const fr = Ce.parse(de[De], De++, Pa);
              return fr ? (Ke.push({ image: fr, options: void 0 }), !0) : (Ce.error(Ke.length ? "Secondary image variant is not a string." : "No image name provided."), !1);
            }
            return !0;
          }
          function er() {
            if (De < de.length) {
              if ((fr = de[De]) === null || typeof fr != "object" || Array.isArray(fr))
                return !0;
              const wr = de[De].params, kr = Ce.concat(De);
              if (!wr)
                return De++, !0;
              if (typeof wr != "object" || wr.constructor !== Object)
                return kr.error('Image options "params" should be an object'), !1;
              const cr = {}, Mr = kr.concat(void 0, "params");
              for (const Er in wr) {
                if (!Er)
                  return Mr.error("Image parameter name should be non-empty"), !1;
                const xr = Mr.concat(void 0, Er).parse(wr[Er], void 0, Dl, void 0, { typeAnnotation: "coerce" });
                if (!xr)
                  return !1;
                cr[Er] = xr;
              }
              return Ke[Ke.length - 1].options = cr, De++, !0;
            }
            var fr;
            return !0;
          }
          for (let fr = 0; fr < 2; fr++)
            if (!Ve() || !er())
              return;
          return new Rh(Ke[0].image, Ke[1] ? Ke[1].image : void 0, Ke[0].options, Ke[1] ? Ke[1].options : void 0);
        }
        evaluateParams(de, Ce) {
          const De = {};
          if (Ce) {
            for (const Ke in Ce)
              if (Ce[Ke])
                try {
                  const Ve = Ce[Ke].evaluate(de), er = `Ignoring image parameter "${Ke}" with semi-transparent color ${Ve.toString()}`;
                  if (Ve.a !== 1) {
                    this._imageWarnHistory[er] || (console.warn(er), this._imageWarnHistory[er] = !0);
                    continue;
                  }
                  De[Ke] = Ve;
                } catch {
                  continue;
                }
            if (Object.keys(De).length !== 0)
              return { params: De };
          }
        }
        evaluate(de) {
          const Ce = Ps.build(this.inputPrimary.evaluate(de), this.inputSecondary ? this.inputSecondary.evaluate(de) : void 0, this.inputPrimaryParams ? this.evaluateParams(de, this.inputPrimaryParams) : void 0, this.inputSecondaryParams ? this.evaluateParams(de, this.inputSecondaryParams) : void 0);
          return Ce && de.availableImages && (Ce.available = de.availableImages.indexOf(Ce.namePrimary) > -1, Ce.nameSecondary && Ce.available && de.availableImages && (Ce.available = de.availableImages.indexOf(Ce.nameSecondary) > -1)), Ce;
        }
        eachChild(de) {
          if (de(this.inputPrimary), this.inputPrimaryParams)
            for (const Ce in this.inputPrimaryParams)
              this.inputPrimaryParams[Ce] && de(this.inputPrimaryParams[Ce]);
          if (this.inputSecondary && (de(this.inputSecondary), this.inputSecondaryParams))
            for (const Ce in this.inputSecondaryParams)
              this.inputSecondaryParams[Ce] && de(this.inputSecondaryParams[Ce]);
        }
        outputDefined() {
          return !1;
        }
        serializeParams(de) {
          const Ce = {};
          if (de) {
            for (const De in de)
              de[De] && (Ce[De] = de[De].serialize());
            return { params: Ce };
          }
        }
        serialize() {
          const de = ["image", this.inputPrimary.serialize()];
          return this.inputPrimaryParams && de.push(this.serializeParams(this.inputPrimaryParams)), this.inputSecondary && (de.push(this.inputSecondary.serialize()), this.inputSecondaryParams && de.push(this.serializeParams(this.inputSecondaryParams))), de;
        }
      }
      function al(Ie) {
        return Ie instanceof Number ? "number" : Ie instanceof String ? "string" : Ie instanceof Boolean ? "boolean" : Array.isArray(Ie) ? "array" : Ie === null ? "null" : typeof Ie;
      }
      const z0 = { "to-boolean": Ta, "to-color": Dl, "to-number": To, "to-string": Pa };
      class Vc {
        constructor(de, Ce) {
          this.type = de, this.args = Ce;
        }
        static parse(de, Ce) {
          if (de.length < 2)
            return Ce.error("Expected at least one argument.");
          const De = de[0], Ke = [];
          let Ve = Bh;
          if (De === "to-array") {
            if (!Array.isArray(de[1]))
              return null;
            const er = de[1].length;
            if (Ce.expectedType) {
              if (Ce.expectedType.kind !== "array")
                return Ce.error(`Expected ${Ce.expectedType.kind} but found array.`);
              Ve = dl(Ce.expectedType.itemType, er);
            } else {
              if (!(er > 0 && ol(de[1][0])))
                return null;
              Ve = dl(ds(de[1][0]), er);
            }
            for (let fr = 0; fr < er; fr++) {
              const wr = de[1][fr];
              let kr;
              if (al(wr) === "array")
                kr = Ce.parse(wr, void 0, Ve.itemType);
              else {
                const cr = al(wr);
                if (cr !== Ve.itemType.kind)
                  return Ce.error(`Expected ${Ve.itemType.kind} but found ${cr}.`);
                kr = Ce.registry.literal.parse(["literal", wr === void 0 ? null : wr], Ce);
              }
              if (!kr)
                return null;
              Ke.push(kr);
            }
          } else {
            if ((De === "to-boolean" || De === "to-string") && de.length !== 2)
              return Ce.error("Expected one argument.");
            Ve = z0[De];
            for (let er = 1; er < de.length; er++) {
              const fr = Ce.parse(de[er], er, ga);
              if (!fr)
                return null;
              Ke.push(fr);
            }
          }
          return new Vc(Ve, Ke);
        }
        evaluate(de) {
          if (this.type.kind === "boolean")
            return Boolean(this.args[0].evaluate(de));
          if (this.type.kind === "color") {
            let Ce, De;
            for (const Ke of this.args) {
              if (Ce = Ke.evaluate(de), De = null, Ce instanceof Ca)
                return Ce;
              if (typeof Ce == "string") {
                const Ve = de.parseColor(Ce);
                if (Ve)
                  return Ve;
              } else if (Array.isArray(Ce) && (De = Ce.length < 3 || Ce.length > 4 ? `Invalid rbga value ${JSON.stringify(Ce)}: expected an array containing either three or four numeric values.` : iu(Ce[0], Ce[1], Ce[2], Ce[3]), !De))
                return new Ca(Ce[0] / 255, Ce[1] / 255, Ce[2] / 255, Ce[3]);
            }
            throw new Ts(De || `Could not parse color from value '${typeof Ce == "string" ? Ce : String(JSON.stringify(Ce))}'`);
          }
          if (this.type.kind === "number") {
            let Ce = null;
            for (const De of this.args) {
              if (Ce = De.evaluate(de), Ce === null)
                return 0;
              const Ke = Number(Ce);
              if (!isNaN(Ke))
                return Ke;
            }
            throw new Ts(`Could not convert ${JSON.stringify(Ce)} to number.`);
          }
          return this.type.kind === "formatted" ? Ys.fromString(dc(this.args[0].evaluate(de))) : this.type.kind === "resolvedImage" ? Ps.build(dc(this.args[0].evaluate(de))) : this.type.kind === "array" ? this.args.map((Ce) => Ce.evaluate(de)) : dc(this.args[0].evaluate(de));
        }
        eachChild(de) {
          this.args.forEach(de);
        }
        outputDefined() {
          return this.args.every((de) => de.outputDefined());
        }
        serialize() {
          if (this.type.kind === "formatted")
            return new Ds([{ content: this.args[0], scale: null, font: null, textColor: null }]).serialize();
          if (this.type.kind === "resolvedImage")
            return new Rh(this.args[0]).serialize();
          const de = this.type.kind === "array" ? [] : [`to-${this.type.kind}`];
          return this.eachChild((Ce) => {
            de.push(Ce.serialize());
          }), de;
        }
      }
      const nu = ["Unknown", "Point", "LineString", "Polygon"];
      class Zu {
        constructor(de, Ce) {
          this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.scope = de, this.options = Ce;
        }
        id() {
          return this.feature && this.feature.id !== void 0 ? this.feature.id : null;
        }
        geometryType() {
          return this.feature ? typeof this.feature.type == "number" ? nu[this.feature.type] : this.feature.type : null;
        }
        geometry() {
          return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
        }
        canonicalID() {
          return this.canonical;
        }
        properties() {
          return this.feature && this.feature.properties || {};
        }
        measureLight(de) {
          return this.globals.brightness || 0;
        }
        distanceFromCenter() {
          if (this.featureTileCoord && this.featureDistanceData) {
            const de = this.featureDistanceData.center, Ce = this.featureDistanceData.scale, { x: De, y: Ke } = this.featureTileCoord;
            return this.featureDistanceData.bearing[0] * (De * Ce - de[0]) + this.featureDistanceData.bearing[1] * (Ke * Ce - de[1]);
          }
          return 0;
        }
        parseColor(de) {
          let Ce = this._parseColorCache[de];
          return Ce || (Ce = this._parseColorCache[de] = Ca.parse(de)), Ce;
        }
        getConfig(de) {
          return this.options ? this.options.get(de) : null;
        }
      }
      class bl {
        constructor(de, Ce, De, Ke, Ve) {
          this.name = de, this.type = Ce, this._evaluate = De, this.args = Ke, this._overloadIndex = Ve;
        }
        evaluate(de) {
          if (!this._evaluate) {
            const Ce = bl.definitions[this.name];
            this._evaluate = Array.isArray(Ce) ? Ce[2] : Ce.overloads[this._overloadIndex][1];
          }
          return this._evaluate(de, this.args);
        }
        eachChild(de) {
          this.args.forEach(de);
        }
        outputDefined() {
          return !1;
        }
        serialize() {
          return [this.name].concat(this.args.map((de) => de.serialize()));
        }
        static parse(de, Ce) {
          const De = de[0], Ke = bl.definitions[De];
          if (!Ke)
            return Ce.error(`Unknown expression "${De}". If you wanted a literal array, use ["literal", [...]].`, 0);
          const Ve = Array.isArray(Ke) ? Ke[0] : Ke.type, er = Array.isArray(Ke) ? [[Ke[1], Ke[2]]] : Ke.overloads, fr = [];
          let wr = null, kr = -1;
          for (const [cr, Mr] of er) {
            if (Array.isArray(cr) && cr.length !== de.length - 1)
              continue;
            fr.push(cr), kr++, wr = new Bp(Ce.registry, Ce.path, null, Ce.scope, void 0, Ce._scope, Ce.options);
            const Er = [];
            let xr = !1;
            for (let Sr = 1; Sr < de.length; Sr++) {
              const Br = de[Sr], Fr = Array.isArray(cr) ? cr[Sr - 1] : cr.type, jr = wr.parse(Br, 1 + Er.length, Fr);
              if (!jr) {
                xr = !0;
                break;
              }
              Er.push(jr);
            }
            if (!xr)
              if (Array.isArray(cr) && cr.length !== Er.length)
                wr.error(`Expected ${cr.length} arguments, but found ${Er.length} instead.`);
              else {
                for (let Sr = 0; Sr < Er.length; Sr++) {
                  const Br = Array.isArray(cr) ? cr[Sr] : cr.type, Fr = Er[Sr];
                  wr.concat(Sr + 1).checkSubtype(Br, Fr.type);
                }
                if (wr.errors.length === 0)
                  return new bl(De, Ve, Mr, Er, kr);
              }
          }
          if (fr.length === 1)
            Ce.errors.push(...wr.errors);
          else {
            const cr = (fr.length ? fr : er.map(([Er]) => Er)).map(Ms).join(" | "), Mr = [];
            for (let Er = 1; Er < de.length; Er++) {
              const xr = Ce.parse(de[Er], 1 + Mr.length);
              if (!xr)
                return null;
              Mr.push(ts(xr.type));
            }
            Ce.error(`Expected arguments of type ${cr}, but found (${Mr.join(", ")}) instead.`);
          }
          return null;
        }
        static register(de, Ce) {
          bl.definitions = Ce;
          for (const De in Ce)
            de[De] = bl;
        }
      }
      function Ms(Ie) {
        return Array.isArray(Ie) ? `(${Ie.map(ts).join(", ")})` : `(${ts(Ie.type)}...)`;
      }
      class Sc {
        constructor(de, Ce, De) {
          this.type = vs, this.locale = De, this.caseSensitive = de, this.diacriticSensitive = Ce;
        }
        static parse(de, Ce) {
          if (de.length !== 2)
            return Ce.error("Expected one argument.");
          const De = de[1];
          if (typeof De != "object" || Array.isArray(De))
            return Ce.error("Collator options argument must be an object.");
          const Ke = De["case-sensitive"] === void 0 ? Ce.parse(!1, 1, Ta) : Ce.parseObjectValue(De["case-sensitive"], 1, "case-sensitive", Ta);
          if (!Ke)
            return null;
          const Ve = De["diacritic-sensitive"] === void 0 ? Ce.parse(!1, 1, Ta) : Ce.parseObjectValue(De["diacritic-sensitive"], 1, "diacritic-sensitive", Ta);
          if (!Ve)
            return null;
          let er = null;
          return De.locale && (er = Ce.parseObjectValue(De.locale, 1, "locale", Pa), !er) ? null : new Sc(Ke, Ve, er);
        }
        evaluate(de) {
          return new Cf(this.caseSensitive.evaluate(de), this.diacriticSensitive.evaluate(de), this.locale ? this.locale.evaluate(de) : null);
        }
        eachChild(de) {
          de(this.caseSensitive), de(this.diacriticSensitive), this.locale && de(this.locale);
        }
        outputDefined() {
          return !1;
        }
        serialize() {
          const de = {};
          return de["case-sensitive"] = this.caseSensitive.serialize(), de["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (de.locale = this.locale.serialize()), ["collator", de];
        }
      }
      function Tf(Ie, de, Ce = 0, De = Ie.length - 1, Ke = Cp) {
        for (; De > Ce; ) {
          if (De - Ce > 600) {
            const wr = De - Ce + 1, kr = de - Ce + 1, cr = Math.log(wr), Mr = 0.5 * Math.exp(2 * cr / 3), Er = 0.5 * Math.sqrt(cr * Mr * (wr - Mr) / wr) * (kr - wr / 2 < 0 ? -1 : 1);
            Tf(Ie, de, Math.max(Ce, Math.floor(de - kr * Mr / wr + Er)), Math.min(De, Math.floor(de + (wr - kr) * Mr / wr + Er)), Ke);
          }
          const Ve = Ie[de];
          let er = Ce, fr = De;
          for (Md(Ie, Ce, de), Ke(Ie[De], Ve) > 0 && Md(Ie, Ce, De); er < fr; ) {
            for (Md(Ie, er, fr), er++, fr--; Ke(Ie[er], Ve) < 0; )
              er++;
            for (; Ke(Ie[fr], Ve) > 0; )
              fr--;
          }
          Ke(Ie[Ce], Ve) === 0 ? Md(Ie, Ce, fr) : (fr++, Md(Ie, fr, De)), fr <= de && (Ce = fr + 1), de <= fr && (De = fr - 1);
        }
      }
      function Md(Ie, de, Ce) {
        const De = Ie[de];
        Ie[de] = Ie[Ce], Ie[Ce] = De;
      }
      function Cp(Ie, de) {
        return Ie < de ? -1 : Ie > de ? 1 : 0;
      }
      function F0(Ie) {
        let de = 0;
        for (let Ce, De, Ke = 0, Ve = Ie.length, er = Ve - 1; Ke < Ve; er = Ke++)
          Ce = Ie[Ke], De = Ie[er], de += (De.x - Ce.x) * (Ce.y + De.y);
        return de;
      }
      function Sd(Ie, de) {
        Ie[0] = Math.min(Ie[0], de[0]), Ie[1] = Math.min(Ie[1], de[1]), Ie[2] = Math.max(Ie[2], de[0]), Ie[3] = Math.max(Ie[3], de[1]);
      }
      function Ed(Ie, de) {
        return !(Ie[0] <= de[0] || Ie[2] >= de[2] || Ie[1] <= de[1] || Ie[3] >= de[3]);
      }
      function Tp(Ie, de, Ce) {
        const De = Ie[0] - de[0], Ke = Ie[1] - de[1], Ve = Ie[0] - Ce[0], er = Ie[1] - Ce[1];
        return De * er - Ve * Ke == 0 && De * Ve <= 0 && Ke * er <= 0;
      }
      function Ol(Ie, de, Ce = !1) {
        let De = !1;
        for (let fr = 0, wr = de.length; fr < wr; fr++) {
          const kr = de[fr];
          for (let cr = 0, Mr = kr.length, Er = Mr - 1; cr < Mr; Er = cr++) {
            const xr = kr[Er], Sr = kr[cr];
            if (Tp(Ie, xr, Sr))
              return Ce;
            (Ve = xr)[1] > (Ke = Ie)[1] != (er = Sr)[1] > Ke[1] && Ke[0] < (er[0] - Ve[0]) * (Ke[1] - Ve[1]) / (er[1] - Ve[1]) + Ve[0] && (De = !De);
          }
        }
        var Ke, Ve, er;
        return De;
      }
      function Xu(Ie, de, Ce, De) {
        const Ke = De[0] - Ce[0], Ve = De[1] - Ce[1], er = (Ie[0] - Ce[0]) * Ve - Ke * (Ie[1] - Ce[1]), fr = (de[0] - Ce[0]) * Ve - Ke * (de[1] - Ce[1]);
        return er > 0 && fr < 0 || er < 0 && fr > 0;
      }
      function Af(Ie, de, Ce, De) {
        return (Ke = [De[0] - Ce[0], De[1] - Ce[1]])[0] * (Ve = [de[0] - Ie[0], de[1] - Ie[1]])[1] - Ke[1] * Ve[0] != 0 && !(!Xu(Ie, de, Ce, De) || !Xu(Ce, De, Ie, de));
        var Ke, Ve;
      }
      const Ec = 8192;
      function $m(Ie, de) {
        const Ce = (180 + Ie[0]) / 360, De = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + Ie[1] * Math.PI / 360))) / 360, Ke = Math.pow(2, de.z);
        return [Math.round(Ce * Ke * Ec), Math.round(De * Ke * Ec)];
      }
      function Ap(Ie, de) {
        for (let Ce = 0; Ce < de.length; Ce++)
          if (Ol(Ie, de[Ce]))
            return !0;
        return !1;
      }
      function kp(Ie, de, Ce) {
        for (const De of Ce)
          for (let Ke = 0, Ve = De.length, er = Ve - 1; Ke < Ve; er = Ke++)
            if (Af(Ie, de, De[er], De[Ke]))
              return !0;
        return !1;
      }
      function Lp(Ie, de) {
        for (let Ce = 0; Ce < Ie.length; ++Ce)
          if (!Ol(Ie[Ce], de))
            return !1;
        for (let Ce = 0; Ce < Ie.length - 1; ++Ce)
          if (kp(Ie[Ce], Ie[Ce + 1], de))
            return !1;
        return !0;
      }
      function Ph(Ie, de) {
        for (let Ce = 0; Ce < de.length; Ce++)
          if (Lp(Ie, de[Ce]))
            return !0;
        return !1;
      }
      function aa(Ie, de, Ce) {
        const De = [];
        for (let Ke = 0; Ke < Ie.length; Ke++) {
          const Ve = [];
          for (let er = 0; er < Ie[Ke].length; er++) {
            const fr = $m(Ie[Ke][er], Ce);
            Sd(de, fr), Ve.push(fr);
          }
          De.push(Ve);
        }
        return De;
      }
      function Oo(Ie, de, Ce) {
        const De = [];
        for (let Ke = 0; Ke < Ie.length; Ke++) {
          const Ve = aa(Ie[Ke], de, Ce);
          De.push(Ve);
        }
        return De;
      }
      function kf(Ie, de, Ce, De) {
        if (Ie[0] < Ce[0] || Ie[0] > Ce[2]) {
          const Ke = 0.5 * De;
          let Ve = Ie[0] - Ce[0] > Ke ? -De : Ce[0] - Ie[0] > Ke ? De : 0;
          Ve === 0 && (Ve = Ie[0] - Ce[2] > Ke ? -De : Ce[2] - Ie[0] > Ke ? De : 0), Ie[0] += Ve;
        }
        Sd(de, Ie);
      }
      function ta(Ie, de, Ce, De) {
        const Ke = Math.pow(2, De.z) * Ec, Ve = [De.x * Ec, De.y * Ec], er = [];
        if (!Ie)
          return er;
        for (const fr of Ie)
          for (const wr of fr) {
            const kr = [wr.x + Ve[0], wr.y + Ve[1]];
            kf(kr, de, Ce, Ke), er.push(kr);
          }
        return er;
      }
      function xl(Ie, de, Ce, De) {
        const Ke = Math.pow(2, De.z) * Ec, Ve = [De.x * Ec, De.y * Ec], er = [];
        if (!Ie)
          return er;
        for (const wr of Ie) {
          const kr = [];
          for (const cr of wr) {
            const Mr = [cr.x + Ve[0], cr.y + Ve[1]];
            Sd(de, Mr), kr.push(Mr);
          }
          er.push(kr);
        }
        if (de[2] - de[0] <= Ke / 2) {
          (fr = de)[0] = fr[1] = 1 / 0, fr[2] = fr[3] = -1 / 0;
          for (const wr of er)
            for (const kr of wr)
              kf(kr, de, Ce, Ke);
        }
        var fr;
        return er;
      }
      class Cc {
        constructor(de, Ce) {
          this.type = Ta, this.geojson = de, this.geometries = Ce;
        }
        static parse(de, Ce) {
          if (de.length !== 2)
            return Ce.error(`'within' expression requires exactly one argument, but found ${de.length - 1} instead.`);
          if (ol(de[1])) {
            const De = de[1];
            if (De.type === "FeatureCollection")
              for (let Ke = 0; Ke < De.features.length; ++Ke) {
                const Ve = De.features[Ke].geometry.type;
                if (Ve === "Polygon" || Ve === "MultiPolygon")
                  return new Cc(De, De.features[Ke].geometry);
              }
            else if (De.type === "Feature") {
              const Ke = De.geometry.type;
              if (Ke === "Polygon" || Ke === "MultiPolygon")
                return new Cc(De, De.geometry);
            } else if (De.type === "Polygon" || De.type === "MultiPolygon")
              return new Cc(De, De);
          }
          return Ce.error("'within' expression requires valid geojson object that contains polygon geometry type.");
        }
        evaluate(de) {
          if (de.geometry() != null && de.canonicalID() != null) {
            if (de.geometryType() === "Point")
              return function(Ce, De) {
                const Ke = [1 / 0, 1 / 0, -1 / 0, -1 / 0], Ve = [1 / 0, 1 / 0, -1 / 0, -1 / 0], er = Ce.canonicalID();
                if (!er)
                  return !1;
                if (De.type === "Polygon") {
                  const fr = aa(De.coordinates, Ve, er), wr = ta(Ce.geometry(), Ke, Ve, er);
                  if (!Ed(Ke, Ve))
                    return !1;
                  for (const kr of wr)
                    if (!Ol(kr, fr))
                      return !1;
                }
                if (De.type === "MultiPolygon") {
                  const fr = Oo(De.coordinates, Ve, er), wr = ta(Ce.geometry(), Ke, Ve, er);
                  if (!Ed(Ke, Ve))
                    return !1;
                  for (const kr of wr)
                    if (!Ap(kr, fr))
                      return !1;
                }
                return !0;
              }(de, this.geometries);
            if (de.geometryType() === "LineString")
              return function(Ce, De) {
                const Ke = [1 / 0, 1 / 0, -1 / 0, -1 / 0], Ve = [1 / 0, 1 / 0, -1 / 0, -1 / 0], er = Ce.canonicalID();
                if (!er)
                  return !1;
                if (De.type === "Polygon") {
                  const fr = aa(De.coordinates, Ve, er), wr = xl(Ce.geometry(), Ke, Ve, er);
                  if (!Ed(Ke, Ve))
                    return !1;
                  for (const kr of wr)
                    if (!Lp(kr, fr))
                      return !1;
                }
                if (De.type === "MultiPolygon") {
                  const fr = Oo(De.coordinates, Ve, er), wr = xl(Ce.geometry(), Ke, Ve, er);
                  if (!Ed(Ke, Ve))
                    return !1;
                  for (const kr of wr)
                    if (!Ph(kr, fr))
                      return !1;
                }
                return !0;
              }(de, this.geometries);
          }
          return !1;
        }
        eachChild() {
        }
        outputDefined() {
          return !0;
        }
        serialize() {
          return ["within", this.geojson];
        }
      }
      const Uo = { kilometers: 1, miles: 1e3 / 1609.344, nauticalmiles: 1e3 / 1852, meters: 1e3, metres: 1e3, yards: 1e3 / 0.9144, feet: 1e3 / 0.3048, inches: 1e3 / 0.0254 }, Lf = 1 / 298.257223563, Cd = Lf * (2 - Lf), Dh = Math.PI / 180;
      class Oh {
        static fromTile(de, Ce, De) {
          const Ke = Math.PI * (1 - 2 * (de + 0.5) / Math.pow(2, Ce)), Ve = Math.atan(0.5 * (Math.exp(Ke) - Math.exp(-Ke))) / Dh;
          return new Oh(Ve, De);
        }
        static get units() {
          return Uo;
        }
        constructor(de, Ce) {
          if (de === void 0)
            throw new Error("No latitude given.");
          if (Ce && !Uo[Ce])
            throw new Error(`Unknown unit ${Ce}. Use one of: ${Object.keys(Uo).join(", ")}`);
          const De = 6378.137 * Dh * (Ce ? Uo[Ce] : 1), Ke = Math.cos(de * Dh), Ve = 1 / (1 - Cd * (1 - Ke * Ke)), er = Math.sqrt(Ve);
          this.kx = De * er * Ke, this.ky = De * er * Ve * (1 - Cd);
        }
        distance(de, Ce) {
          const De = Fl(de[0] - Ce[0]) * this.kx, Ke = (de[1] - Ce[1]) * this.ky;
          return Math.sqrt(De * De + Ke * Ke);
        }
        bearing(de, Ce) {
          const De = Fl(Ce[0] - de[0]) * this.kx;
          return Math.atan2(De, (Ce[1] - de[1]) * this.ky) / Dh;
        }
        destination(de, Ce, De) {
          const Ke = De * Dh;
          return this.offset(de, Math.sin(Ke) * Ce, Math.cos(Ke) * Ce);
        }
        offset(de, Ce, De) {
          return [de[0] + Ce / this.kx, de[1] + De / this.ky];
        }
        lineDistance(de) {
          let Ce = 0;
          for (let De = 0; De < de.length - 1; De++)
            Ce += this.distance(de[De], de[De + 1]);
          return Ce;
        }
        area(de) {
          let Ce = 0;
          for (let De = 0; De < de.length; De++) {
            const Ke = de[De];
            for (let Ve = 0, er = Ke.length, fr = er - 1; Ve < er; fr = Ve++)
              Ce += Fl(Ke[Ve][0] - Ke[fr][0]) * (Ke[Ve][1] + Ke[fr][1]) * (De ? -1 : 1);
          }
          return Math.abs(Ce) / 2 * this.kx * this.ky;
        }
        along(de, Ce) {
          let De = 0;
          if (Ce <= 0)
            return de[0];
          for (let Ke = 0; Ke < de.length - 1; Ke++) {
            const Ve = de[Ke], er = de[Ke + 1], fr = this.distance(Ve, er);
            if (De += fr, De > Ce)
              return ll(Ve, er, (Ce - (De - fr)) / fr);
          }
          return de[de.length - 1];
        }
        pointToSegmentDistance(de, Ce, De) {
          let [Ke, Ve] = Ce, er = Fl(De[0] - Ke) * this.kx, fr = (De[1] - Ve) * this.ky;
          if (er !== 0 || fr !== 0) {
            const wr = (Fl(de[0] - Ke) * this.kx * er + (de[1] - Ve) * this.ky * fr) / (er * er + fr * fr);
            wr > 1 ? (Ke = De[0], Ve = De[1]) : wr > 0 && (Ke += er / this.kx * wr, Ve += fr / this.ky * wr);
          }
          return er = Fl(de[0] - Ke) * this.kx, fr = (de[1] - Ve) * this.ky, Math.sqrt(er * er + fr * fr);
        }
        pointOnLine(de, Ce) {
          let De = 1 / 0, Ke = de[0][0], Ve = de[0][1], er = 0, fr = 0;
          for (let wr = 0; wr < de.length - 1; wr++) {
            let kr = de[wr][0], cr = de[wr][1], Mr = Fl(de[wr + 1][0] - kr) * this.kx, Er = (de[wr + 1][1] - cr) * this.ky, xr = 0;
            Mr === 0 && Er === 0 || (xr = (Fl(Ce[0] - kr) * this.kx * Mr + (Ce[1] - cr) * this.ky * Er) / (Mr * Mr + Er * Er), xr > 1 ? (kr = de[wr + 1][0], cr = de[wr + 1][1]) : xr > 0 && (kr += Mr / this.kx * xr, cr += Er / this.ky * xr)), Mr = Fl(Ce[0] - kr) * this.kx, Er = (Ce[1] - cr) * this.ky;
            const Sr = Mr * Mr + Er * Er;
            Sr < De && (De = Sr, Ke = kr, Ve = cr, er = wr, fr = xr);
          }
          return { point: [Ke, Ve], index: er, t: Math.max(0, Math.min(1, fr)) };
        }
        lineSlice(de, Ce, De) {
          let Ke = this.pointOnLine(De, de), Ve = this.pointOnLine(De, Ce);
          if (Ke.index > Ve.index || Ke.index === Ve.index && Ke.t > Ve.t) {
            const kr = Ke;
            Ke = Ve, Ve = kr;
          }
          const er = [Ke.point], fr = Ke.index + 1, wr = Ve.index;
          !Td(De[fr], er[0]) && fr <= wr && er.push(De[fr]);
          for (let kr = fr + 1; kr <= wr; kr++)
            er.push(De[kr]);
          return Td(De[wr], Ve.point) || er.push(Ve.point), er;
        }
        lineSliceAlong(de, Ce, De) {
          let Ke = 0;
          const Ve = [];
          for (let er = 0; er < De.length - 1; er++) {
            const fr = De[er], wr = De[er + 1], kr = this.distance(fr, wr);
            if (Ke += kr, Ke > de && Ve.length === 0 && Ve.push(ll(fr, wr, (de - (Ke - kr)) / kr)), Ke >= Ce)
              return Ve.push(ll(fr, wr, (Ce - (Ke - kr)) / kr)), Ve;
            Ke > de && Ve.push(wr);
          }
          return Ve;
        }
        bufferPoint(de, Ce) {
          const De = Ce / this.ky, Ke = Ce / this.kx;
          return [de[0] - Ke, de[1] - De, de[0] + Ke, de[1] + De];
        }
        bufferBBox(de, Ce) {
          const De = Ce / this.ky, Ke = Ce / this.kx;
          return [de[0] - Ke, de[1] - De, de[2] + Ke, de[3] + De];
        }
        insideBBox(de, Ce) {
          return Fl(de[0] - Ce[0]) >= 0 && Fl(de[0] - Ce[2]) <= 0 && de[1] >= Ce[1] && de[1] <= Ce[3];
        }
      }
      function Td(Ie, de) {
        return Ie[0] === de[0] && Ie[1] === de[1];
      }
      function ll(Ie, de, Ce) {
        const De = Fl(de[0] - Ie[0]);
        return [Ie[0] + De * Ce, Ie[1] + (de[1] - Ie[1]) * Ce];
      }
      function Fl(Ie) {
        for (; Ie < -180; )
          Ie += 360;
        for (; Ie > 180; )
          Ie -= 360;
        return Ie;
      }
      class ou {
        constructor(de = [], Ce = (De, Ke) => De < Ke ? -1 : De > Ke ? 1 : 0) {
          if (this.data = de, this.length = this.data.length, this.compare = Ce, this.length > 0)
            for (let De = (this.length >> 1) - 1; De >= 0; De--)
              this._down(De);
        }
        push(de) {
          this.data.push(de), this._up(this.length++);
        }
        pop() {
          if (this.length === 0)
            return;
          const de = this.data[0], Ce = this.data.pop();
          return --this.length > 0 && (this.data[0] = Ce, this._down(0)), de;
        }
        peek() {
          return this.data[0];
        }
        _up(de) {
          const { data: Ce, compare: De } = this, Ke = Ce[de];
          for (; de > 0; ) {
            const Ve = de - 1 >> 1, er = Ce[Ve];
            if (De(Ke, er) >= 0)
              break;
            Ce[de] = er, de = Ve;
          }
          Ce[de] = Ke;
        }
        _down(de) {
          const { data: Ce, compare: De } = this, Ke = this.length >> 1, Ve = Ce[de];
          for (; de < Ke; ) {
            let er = 1 + (de << 1);
            const fr = er + 1;
            if (fr < this.length && De(Ce[fr], Ce[er]) < 0 && (er = fr), De(Ce[er], Ve) >= 0)
              break;
            Ce[de] = Ce[er], de = er;
          }
          Ce[de] = Ve;
        }
      }
      var vo = 8192;
      function If(Ie, de) {
        return de.dist - Ie.dist;
      }
      const Tc = 100, Js = 50;
      function au(Ie) {
        const de = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
        if (de.length !== Ie.length)
          return !1;
        for (let Ce = 0; Ce < de.length; Ce++)
          if (de[Ce] !== Ie[Ce])
            return !1;
        return !0;
      }
      function Ku(Ie) {
        return Ie[1] - Ie[0] + 1;
      }
      function su(Ie, de) {
        const Ce = Ie[1] >= Ie[0] && Ie[1] < de;
        return Ce || console.warn("Distance Expression: Index is out of range"), Ce;
      }
      function zh(Ie, de) {
        if (Ie[0] > Ie[1])
          return [null, null];
        const Ce = Ku(Ie);
        if (de) {
          if (Ce === 2)
            return [Ie, null];
          const De = Math.floor(Ce / 2);
          return [[Ie[0], Ie[0] + De], [Ie[0] + De, Ie[1]]];
        }
        {
          if (Ce === 1)
            return [Ie, null];
          const De = Math.floor(Ce / 2) - 1;
          return [[Ie[0], Ie[0] + De], [Ie[0] + De + 1, Ie[1]]];
        }
      }
      function Mu(Ie, de) {
        const Ce = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
        if (!su(de, Ie.length))
          return Ce;
        for (let De = de[0]; De <= de[1]; ++De)
          Sd(Ce, Ie[De]);
        return Ce;
      }
      function Ac(Ie) {
        const de = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
        for (let Ce = 0; Ce < Ie.length; ++Ce)
          for (let De = 0; De < Ie[Ce].length; ++De)
            Sd(de, Ie[Ce][De]);
        return de;
      }
      function wl(Ie, de, Ce) {
        if (au(Ie) || au(de))
          return NaN;
        let De = 0, Ke = 0;
        return Ie[2] < de[0] && (De = de[0] - Ie[2]), Ie[0] > de[2] && (De = Ie[0] - de[2]), Ie[1] > de[3] && (Ke = Ie[1] - de[3]), Ie[3] < de[1] && (Ke = de[1] - Ie[3]), Ce.distance([0, 0], [De, Ke]);
      }
      function Rm(Ie) {
        return 360 * Ie - 180;
      }
      function N0(Ie) {
        return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * Ie) * Math.PI / 180)) - 90;
      }
      function Ip(Ie, de) {
        const Ce = Math.pow(2, de.z), De = (Ie.y / vo + de.y) / Ce;
        return [Rm((Ie.x / vo + de.x) / Ce), N0(De)];
      }
      function Pm(Ie, de) {
        const Ce = [];
        for (let De = 0; De < Ie.length; ++De)
          Ce.push(Ip(Ie[De], de));
        return Ce;
      }
      function Dm(Ie, de, Ce) {
        const De = Ce.pointOnLine(de, Ie).point;
        return Ce.distance(Ie, De);
      }
      function Om(Ie, de, Ce, De, Ke) {
        const Ve = Ce.slice(De[0], De[1] + 1);
        let er = 1 / 0;
        for (let fr = de[0]; fr <= de[1]; ++fr)
          if ((er = Math.min(er, Dm(Ie[fr], Ve, Ke))) === 0)
            return 0;
        return er;
      }
      function Nl(Ie, de, Ce, De, Ke) {
        const Ve = Math.min(Ke.pointToSegmentDistance(Ie, Ce, De), Ke.pointToSegmentDistance(de, Ce, De)), er = Math.min(Ke.pointToSegmentDistance(Ce, Ie, de), Ke.pointToSegmentDistance(De, Ie, de));
        return Math.min(Ve, er);
      }
      function jn(Ie, de, Ce, De, Ke) {
        if (!su(de, Ie.length) || !su(De, Ce.length))
          return NaN;
        let Ve = 1 / 0;
        for (let er = de[0]; er < de[1]; ++er)
          for (let fr = De[0]; fr < De[1]; ++fr) {
            if (Af(Ie[er], Ie[er + 1], Ce[fr], Ce[fr + 1]))
              return 0;
            Ve = Math.min(Ve, Nl(Ie[er], Ie[er + 1], Ce[fr], Ce[fr + 1], Ke));
          }
        return Ve;
      }
      function go(Ie, de, Ce, De, Ke) {
        if (!su(de, Ie.length) || !su(De, Ce.length))
          return NaN;
        let Ve = 1 / 0;
        for (let er = de[0]; er <= de[1]; ++er)
          for (let fr = De[0]; fr <= De[1]; ++fr)
            if ((Ve = Math.min(Ve, Ke.distance(Ie[er], Ce[fr]))) === 0)
              return Ve;
        return Ve;
      }
      function so(Ie, de, Ce) {
        if (Ol(Ie, de, !0))
          return 0;
        let De = 1 / 0;
        for (const Ke of de) {
          const Ve = Ke.length;
          if (Ve < 2)
            return console.warn("Distance Expression: Invalid polygon!"), NaN;
          if (Ke[0] !== Ke[Ve - 1] && (De = Math.min(De, Ce.pointToSegmentDistance(Ie, Ke[Ve - 1], Ke[0]))) === 0 || (De = Math.min(De, Dm(Ie, Ke, Ce))) === 0)
            return De;
        }
        return De;
      }
      function Yo(Ie, de, Ce, De) {
        if (!su(de, Ie.length))
          return NaN;
        for (let Ve = de[0]; Ve <= de[1]; ++Ve)
          if (Ol(Ie[Ve], Ce, !0))
            return 0;
        let Ke = 1 / 0;
        for (let Ve = de[0]; Ve < de[1]; ++Ve)
          for (const er of Ce)
            for (let fr = 0, wr = er.length, kr = wr - 1; fr < wr; kr = fr++) {
              if (Af(Ie[Ve], Ie[Ve + 1], er[kr], er[fr]))
                return 0;
              Ke = Math.min(Ke, Nl(Ie[Ve], Ie[Ve + 1], er[kr], er[fr], De));
            }
        return Ke;
      }
      function ka(Ie, de) {
        for (const Ce of Ie)
          for (let De = 0; De <= Ce.length - 1; ++De)
            if (Ol(Ce[De], de, !0))
              return !0;
        return !1;
      }
      function za(Ie, de, Ce, De = 1 / 0) {
        const Ke = Ac(Ie), Ve = Ac(de);
        if (De !== 1 / 0 && wl(Ke, Ve, Ce) >= De)
          return De;
        if (Ed(Ke, Ve)) {
          if (ka(Ie, de))
            return 0;
        } else if (ka(de, Ie))
          return 0;
        let er = De;
        for (const fr of Ie)
          for (let wr = 0, kr = fr.length, cr = kr - 1; wr < kr; cr = wr++)
            for (const Mr of de)
              for (let Er = 0, xr = Mr.length, Sr = xr - 1; Er < xr; Sr = Er++) {
                if (Af(fr[cr], fr[wr], Mr[Sr], Mr[Er]))
                  return 0;
                er = Math.min(er, Nl(fr[cr], fr[wr], Mr[Sr], Mr[Er], Ce));
              }
        return er;
      }
      function Ls(Ie, de, Ce, De, Ke, Ve, er) {
        if (Ve === null || er === null)
          return;
        const fr = wl(Mu(De, Ve), Mu(Ke, er), Ce);
        fr < de && Ie.push({ dist: fr, range1: Ve, range2: er });
      }
      function _s(Ie, de, Ce, De, Ke = 1 / 0) {
        let Ve = Math.min(De.distance(Ie[0], Ce[0][0]), Ke);
        if (Ve === 0)
          return Ve;
        const er = new ou([{ dist: 0, range1: [0, Ie.length - 1], range2: [0, 0] }], If), fr = de ? Js : Tc, wr = Ac(Ce);
        for (; er.length; ) {
          const kr = er.pop();
          if (kr.dist >= Ve)
            continue;
          const cr = kr.range1;
          if (Ku(cr) <= fr) {
            if (!su(cr, Ie.length))
              return NaN;
            if (de) {
              const Mr = Yo(Ie, cr, Ce, De);
              if ((Ve = Math.min(Ve, Mr)) === 0)
                return Ve;
            } else
              for (let Mr = cr[0]; Mr <= cr[1]; ++Mr) {
                const Er = so(Ie[Mr], Ce, De);
                if ((Ve = Math.min(Ve, Er)) === 0)
                  return Ve;
              }
          } else {
            const Mr = zh(cr, de);
            if (Mr[0] !== null) {
              const Er = wl(Mu(Ie, Mr[0]), wr, De);
              Er < Ve && er.push({ dist: Er, range1: Mr[0], range2: [0, 0] });
            }
            if (Mr[1] !== null) {
              const Er = wl(Mu(Ie, Mr[1]), wr, De);
              Er < Ve && er.push({ dist: Er, range1: Mr[1], range2: [0, 0] });
            }
          }
        }
        return Ve;
      }
      function Ad(Ie, de, Ce, De, Ke, Ve = 1 / 0) {
        let er = Math.min(Ve, Ke.distance(Ie[0], Ce[0]));
        if (er === 0)
          return er;
        const fr = new ou([{ dist: 0, range1: [0, Ie.length - 1], range2: [0, Ce.length - 1] }], If), wr = de ? Js : Tc, kr = De ? Js : Tc;
        for (; fr.length; ) {
          const cr = fr.pop();
          if (cr.dist >= er)
            continue;
          const Mr = cr.range1, Er = cr.range2;
          if (Ku(Mr) <= wr && Ku(Er) <= kr) {
            if (!su(Mr, Ie.length) || !su(Er, Ce.length))
              return NaN;
            if (de && De ? er = Math.min(er, jn(Ie, Mr, Ce, Er, Ke)) : de || De ? de && !De ? er = Math.min(er, Om(Ce, Er, Ie, Mr, Ke)) : !de && De && (er = Math.min(er, Om(Ie, Mr, Ce, Er, Ke))) : er = Math.min(er, go(Ie, Mr, Ce, Er, Ke)), er === 0)
              return er;
          } else {
            const xr = zh(Mr, de), Sr = zh(Er, De);
            Ls(fr, er, Ke, Ie, Ce, xr[0], Sr[0]), Ls(fr, er, Ke, Ie, Ce, xr[0], Sr[1]), Ls(fr, er, Ke, Ie, Ce, xr[1], Sr[0]), Ls(fr, er, Ke, Ie, Ce, xr[1], Sr[1]);
          }
        }
        return er;
      }
      function Bf(Ie, de, Ce, De, Ke = 1 / 0) {
        let Ve = Ke;
        const er = Mu(Ie, [0, Ie.length - 1]);
        for (const fr of Ce)
          if (!(Ve !== 1 / 0 && wl(er, Mu(fr, [0, fr.length - 1]), De) >= Ve) && (Ve = Math.min(Ve, Ad(Ie, de, fr, !0, De, Ve)), Ve === 0))
            return Ve;
        return Ve;
      }
      function Ml(Ie, de, Ce, De, Ke = 1 / 0) {
        let Ve = Ke;
        const er = Mu(Ie, [0, Ie.length - 1]);
        for (const fr of Ce) {
          if (Ve !== 1 / 0 && wl(er, Ac(fr), De) >= Ve)
            continue;
          const wr = _s(Ie, de, fr, De, Ve);
          if (isNaN(wr))
            return wr;
          if ((Ve = Math.min(Ve, wr)) === 0)
            return Ve;
        }
        return Ve;
      }
      function Yu(Ie) {
        return Ie === "Point" || Ie === "MultiPoint" || Ie === "LineString" || Ie === "MultiLineString" || Ie === "Polygon" || Ie === "MultiPolygon";
      }
      class Su {
        constructor(de, Ce) {
          this.type = To, this.geojson = de, this.geometries = Ce;
        }
        static parse(de, Ce) {
          if (de.length !== 2)
            return Ce.error(`'distance' expression requires either one argument, but found ' ${de.length - 1} instead.`);
          if (ol(de[1])) {
            const De = de[1];
            if (De.type === "FeatureCollection") {
              for (let Ke = 0; Ke < De.features.length; ++Ke)
                if (Yu(De.features[Ke].geometry.type))
                  return new Su(De, De.features[Ke].geometry);
            } else if (De.type === "Feature") {
              if (Yu(De.geometry.type))
                return new Su(De, De.geometry);
            } else if (Yu(De.type))
              return new Su(De, De);
          }
          return Ce.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].");
        }
        evaluate(de) {
          const Ce = de.geometry(), De = de.canonicalID();
          if (Ce != null && De != null) {
            if (de.geometryType() === "Point")
              return function(Ke, Ve, er) {
                const fr = [];
                for (const kr of Ke)
                  for (const cr of kr)
                    fr.push(Ip(cr, Ve));
                const wr = new Oh(fr[0][1], "meters");
                return er.type === "Point" || er.type === "MultiPoint" || er.type === "LineString" ? Ad(fr, !1, er.type === "Point" ? [er.coordinates] : er.coordinates, er.type === "LineString", wr) : er.type === "MultiLineString" ? Bf(fr, !1, er.coordinates, wr) : er.type === "Polygon" || er.type === "MultiPolygon" ? Ml(fr, !1, er.type === "Polygon" ? [er.coordinates] : er.coordinates, wr) : null;
              }(Ce, De, this.geometries);
            if (de.geometryType() === "LineString")
              return function(Ke, Ve, er) {
                const fr = [];
                for (const kr of Ke) {
                  const cr = [];
                  for (const Mr of kr)
                    cr.push(Ip(Mr, Ve));
                  fr.push(cr);
                }
                const wr = new Oh(fr[0][0][1], "meters");
                if (er.type === "Point" || er.type === "MultiPoint" || er.type === "LineString")
                  return Bf(er.type === "Point" ? [er.coordinates] : er.coordinates, er.type === "LineString", fr, wr);
                if (er.type === "MultiLineString") {
                  let kr = 1 / 0;
                  for (let cr = 0; cr < er.coordinates.length; cr++) {
                    const Mr = Bf(er.coordinates[cr], !0, fr, wr, kr);
                    if (isNaN(Mr))
                      return Mr;
                    if ((kr = Math.min(kr, Mr)) === 0)
                      return kr;
                  }
                  return kr;
                }
                if (er.type === "Polygon" || er.type === "MultiPolygon") {
                  let kr = 1 / 0;
                  for (let cr = 0; cr < fr.length; cr++) {
                    const Mr = Ml(fr[cr], !0, er.type === "Polygon" ? [er.coordinates] : er.coordinates, wr, kr);
                    if (isNaN(Mr))
                      return Mr;
                    if ((kr = Math.min(kr, Mr)) === 0)
                      return kr;
                  }
                  return kr;
                }
                return null;
              }(Ce, De, this.geometries);
            if (de.geometryType() === "Polygon")
              return function(Ke, Ve, er) {
                const fr = [];
                for (const kr of function(cr, Mr) {
                  const Er = cr.length;
                  if (Er <= 1)
                    return [cr];
                  const xr = [];
                  let Sr, Br;
                  for (let Fr = 0; Fr < Er; Fr++) {
                    const jr = F0(cr[Fr]);
                    jr !== 0 && (cr[Fr].area = Math.abs(jr), Br === void 0 && (Br = jr < 0), Br === jr < 0 ? (Sr && xr.push(Sr), Sr = [cr[Fr]]) : Sr.push(cr[Fr]));
                  }
                  return Sr && xr.push(Sr), xr;
                }(Ke)) {
                  const cr = [];
                  for (let Mr = 0; Mr < kr.length; ++Mr)
                    cr.push(Pm(kr[Mr], Ve));
                  fr.push(cr);
                }
                const wr = new Oh(fr[0][0][0][1], "meters");
                if (er.type === "Point" || er.type === "MultiPoint" || er.type === "LineString")
                  return Ml(er.type === "Point" ? [er.coordinates] : er.coordinates, er.type === "LineString", fr, wr);
                if (er.type === "MultiLineString") {
                  let kr = 1 / 0;
                  for (let cr = 0; cr < er.coordinates.length; cr++) {
                    const Mr = Ml(er.coordinates[cr], !0, fr, wr, kr);
                    if (isNaN(Mr))
                      return Mr;
                    if ((kr = Math.min(kr, Mr)) === 0)
                      return kr;
                  }
                  return kr;
                }
                return er.type === "Polygon" || er.type === "MultiPolygon" ? function(kr, cr, Mr) {
                  let Er = 1 / 0;
                  for (const xr of kr)
                    for (const Sr of cr) {
                      const Br = za(xr, Sr, Mr, Er);
                      if (isNaN(Br))
                        return Br;
                      if ((Er = Math.min(Er, Br)) === 0)
                        return Er;
                    }
                  return Er;
                }(er.type === "Polygon" ? [er.coordinates] : er.coordinates, fr, wr) : null;
              }(Ce, De, this.geometries);
            console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries.");
          } else
            console.warn("Distance Expression: requirs valid feature and canonical information.");
          return null;
        }
        eachChild() {
        }
        outputDefined() {
          return !0;
        }
        serialize() {
          return ["distance", this.geojson];
        }
      }
      function lu(Ie, de) {
        switch (Ie) {
          case "string":
            return dc(de);
          case "number":
            return +de;
          case "boolean":
            return !!de;
          case "color":
            return Ca.parse(de);
          case "formatted":
            return Ys.fromString(dc(de));
          case "resolvedImage":
            return Ps.build(dc(de));
        }
        return de;
      }
      function Fh(Ie, de, Ce, De) {
        return De !== void 0 && (Ie = De * Math.round(Ie / De)), de !== void 0 && Ie < de && (Ie = de), Ce !== void 0 && Ie > Ce && (Ie = Ce), Ie;
      }
      class Uc {
        constructor(de, Ce, De) {
          this.type = de, this.key = Ce, this.scope = De;
        }
        static parse(de, Ce) {
          let De = Ce.expectedType;
          if (De == null && (De = ga), de.length < 2 || de.length > 3)
            return Ce.error("Invalid number of arguments for 'config' expression.");
          const Ke = Ce.parse(de[1], 1);
          if (!(Ke instanceof Yl))
            return Ce.error("Key name of 'config' expression must be a string literal.");
          if (de.length >= 3) {
            const Ve = Ce.parse(de[2], 2);
            return Ve instanceof Yl ? new Uc(De, dc(Ke.value), dc(Ve.value)) : Ce.error("Scope of 'config' expression must be a string literal.");
          }
          return new Uc(De, dc(Ke.value));
        }
        evaluate(de) {
          const Ce = [this.key, this.scope, de.scope].filter(Boolean).join(""), De = de.getConfig(Ce);
          if (!De)
            return null;
          const { type: Ke, value: Ve, values: er, minValue: fr, maxValue: wr, stepValue: kr } = De, cr = De.default.evaluate(de);
          let Mr = cr;
          if (Ve) {
            const Er = de.scope;
            de.scope = (Er || "").split("").slice(1).join(""), Mr = Ve.evaluate(de), de.scope = Er;
          }
          return Ke && (Mr = lu(Ke, Mr)), Mr === void 0 || fr === void 0 && wr === void 0 && kr === void 0 || (typeof Mr == "number" ? Mr = Fh(Mr, fr, wr, kr) : Array.isArray(Mr) && (Mr = Mr.map((Er) => typeof Er == "number" ? Fh(Er, fr, wr, kr) : Er))), Ve !== void 0 && Mr !== void 0 && er && !er.includes(Mr) && (Mr = cr, Ke && (Mr = lu(Ke, Mr))), (Ke && Ke !== this.type || Mr !== void 0 && ds(Mr) !== this.type) && (Mr = lu(this.type.kind, Mr)), Mr;
        }
        eachChild() {
        }
        outputDefined() {
          return !1;
        }
        serialize() {
          const de = ["config", this.key];
          return this.scope && de.concat(this.key), de;
        }
      }
      function rs(Ie) {
        if (Ie instanceof bl && (Ie.name === "get" && Ie.args.length === 1 || Ie.name === "feature-state" || Ie.name === "has" && Ie.args.length === 1 || Ie.name === "properties" || Ie.name === "geometry-type" || Ie.name === "id" || /^filter-/.test(Ie.name)) || Ie instanceof Cc || Ie instanceof Su)
          return !1;
        let de = !0;
        return Ie.eachChild((Ce) => {
          de && !rs(Ce) && (de = !1);
        }), de;
      }
      function Ju(Ie) {
        if (Ie instanceof bl && Ie.name === "feature-state")
          return !1;
        let de = !0;
        return Ie.eachChild((Ce) => {
          de && !Ju(Ce) && (de = !1);
        }), de;
      }
      function Eu(Ie) {
        if (Ie instanceof Uc)
          return /* @__PURE__ */ new Set([Ie.key]);
        let de = /* @__PURE__ */ new Set();
        return Ie.eachChild((Ce) => {
          de = /* @__PURE__ */ new Set([...de, ...Eu(Ce)]);
        }), de;
      }
      function fc(Ie, de) {
        if (Ie instanceof bl && de.indexOf(Ie.name) >= 0)
          return !1;
        let Ce = !0;
        return Ie.eachChild((De) => {
          Ce && !fc(De, de) && (Ce = !1);
        }), Ce;
      }
      class kd {
        constructor(de, Ce) {
          this.type = Ce.type, this.name = de, this.boundExpression = Ce;
        }
        static parse(de, Ce) {
          if (de.length !== 2 || typeof de[1] != "string")
            return Ce.error("'var' expression requires exactly one string literal argument.");
          const De = de[1];
          return Ce.scope.has(De) ? new kd(De, Ce.scope.get(De)) : Ce.error(`Unknown variable "${De}". Make sure "${De}" has been bound in an enclosing "let" expression before using it.`, 1);
        }
        evaluate(de) {
          return this.boundExpression.evaluate(de);
        }
        eachChild() {
        }
        outputDefined() {
          return !1;
        }
        serialize() {
          return ["var", this.name];
        }
      }
      class $f {
        constructor(de, Ce = [], De, Ke = new Ep(), Ve = [], er, fr) {
          this.registry = de, this.path = Ce, this.key = Ce.map((wr) => typeof wr == "string" ? `['${wr}']` : `[${wr}]`).join(""), this.scope = Ke, this.errors = Ve, this.expectedType = De, this._scope = er, this.options = fr;
        }
        parse(de, Ce, De, Ke, Ve = {}) {
          return Ce || De ? this.concat(Ce, null, De, Ke)._parse(de, Ve) : this._parse(de, Ve);
        }
        parseObjectValue(de, Ce, De, Ke, Ve, er = {}) {
          return this.concat(Ce, De, Ke, Ve)._parse(de, er);
        }
        _parse(de, Ce) {
          function De(Ke, Ve, er) {
            return er === "assert" ? new Jl(Ve, [Ke]) : er === "coerce" ? new Vc(Ve, [Ke]) : Ke;
          }
          if (de !== null && typeof de != "string" && typeof de != "boolean" && typeof de != "number" || (de = ["literal", de]), Array.isArray(de)) {
            if (de.length === 0)
              return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
            const Ke = typeof de[0] == "string" ? this.registry[de[0]] : void 0;
            if (Ke) {
              let Ve = Ke.parse(de, this);
              if (!Ve)
                return null;
              if (this.expectedType) {
                const er = this.expectedType, fr = Ve.type;
                if (er.kind !== "string" && er.kind !== "number" && er.kind !== "boolean" && er.kind !== "object" && er.kind !== "array" || fr.kind !== "value")
                  if (er.kind !== "color" && er.kind !== "formatted" && er.kind !== "resolvedImage" || fr.kind !== "value" && fr.kind !== "string") {
                    if (this.checkSubtype(er, fr))
                      return null;
                  } else
                    Ve = De(Ve, er, Ce.typeAnnotation || "coerce");
                else
                  Ve = De(Ve, er, Ce.typeAnnotation || "assert");
              }
              if (!(Ve instanceof Yl) && Ve.type.kind !== "resolvedImage" && kc(Ve)) {
                const er = new Zu(this._scope, this.options);
                try {
                  Ve = new Yl(Ve.type, Ve.evaluate(er));
                } catch (fr) {
                  return this.error(fr.message), null;
                }
              }
              return Ve;
            }
            return Vc.parse(["to-array", de], this);
          }
          return this.error(de === void 0 ? "'undefined' value invalid. Use null instead." : typeof de == "object" ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof de} instead.`);
        }
        concat(de, Ce, De, Ke) {
          let Ve = typeof de == "number" ? this.path.concat(de) : this.path;
          Ve = typeof Ce == "string" ? Ve.concat(Ce) : Ve;
          const er = Ke ? this.scope.concat(Ke) : this.scope;
          return new $f(this.registry, Ve, De || null, er, this.errors, this._scope, this.options);
        }
        error(de, ...Ce) {
          const De = `${this.key}${Ce.map((Ke) => `[${Ke}]`).join("")}`;
          this.errors.push(new hc(De, de));
        }
        checkSubtype(de, Ce) {
          const De = wd(de, Ce);
          return De && this.error(De), De;
        }
      }
      var Bp = $f;
      function kc(Ie) {
        if (Ie instanceof kd)
          return kc(Ie.boundExpression);
        if (Ie instanceof bl && Ie.name === "error" || Ie instanceof Sc || Ie instanceof Cc || Ie instanceof Su || Ie instanceof Uc)
          return !1;
        const de = Ie instanceof Vc || Ie instanceof Jl;
        let Ce = !0;
        return Ie.eachChild((De) => {
          Ce = de ? Ce && kc(De) : Ce && De instanceof Yl;
        }), !!Ce && rs(Ie) && fc(Ie, ["zoom", "heatmap-density", "line-progress", "raster-value", "sky-radial-progress", "accumulated", "is-supported-script", "pitch", "distance-from-center", "measure-light", "raster-particle-speed"]);
      }
      function ca(Ie, de) {
        const Ce = Ie.length - 1;
        let De, Ke, Ve = 0, er = Ce, fr = 0;
        for (; Ve <= er; )
          if (fr = Math.floor((Ve + er) / 2), De = Ie[fr], Ke = Ie[fr + 1], De <= de) {
            if (fr === Ce || de < Ke)
              return fr;
            Ve = fr + 1;
          } else {
            if (!(De > de))
              throw new Ts("Input is not a number.");
            er = fr - 1;
          }
        return 0;
      }
      class Cu {
        constructor(de, Ce, De) {
          this.type = de, this.input = Ce, this.labels = [], this.outputs = [];
          for (const [Ke, Ve] of De)
            this.labels.push(Ke), this.outputs.push(Ve);
        }
        static parse(de, Ce) {
          if (de.length - 1 < 4)
            return Ce.error(`Expected at least 4 arguments, but found only ${de.length - 1}.`);
          if ((de.length - 1) % 2 != 0)
            return Ce.error("Expected an even number of arguments.");
          const De = Ce.parse(de[1], 1, To);
          if (!De)
            return null;
          const Ke = [];
          let Ve = null;
          Ce.expectedType && Ce.expectedType.kind !== "value" && (Ve = Ce.expectedType);
          for (let er = 1; er < de.length; er += 2) {
            const fr = er === 1 ? -1 / 0 : de[er], wr = de[er + 1], kr = er, cr = er + 1;
            if (typeof fr != "number")
              return Ce.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', kr);
            if (Ke.length && Ke[Ke.length - 1][0] >= fr)
              return Ce.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', kr);
            const Mr = Ce.parse(wr, cr, Ve);
            if (!Mr)
              return null;
            Ve = Ve || Mr.type, Ke.push([fr, Mr]);
          }
          return new Cu(Ve, De, Ke);
        }
        evaluate(de) {
          const Ce = this.labels, De = this.outputs;
          if (Ce.length === 1)
            return De[0].evaluate(de);
          const Ke = this.input.evaluate(de);
          if (Ke <= Ce[0])
            return De[0].evaluate(de);
          const Ve = Ce.length;
          return Ke >= Ce[Ve - 1] ? De[Ve - 1].evaluate(de) : De[ca(Ce, Ke)].evaluate(de);
        }
        eachChild(de) {
          de(this.input);
          for (const Ce of this.outputs)
            de(Ce);
        }
        outputDefined() {
          return this.outputs.every((de) => de.outputDefined());
        }
        serialize() {
          const de = ["step", this.input.serialize()];
          for (let Ce = 0; Ce < this.labels.length; Ce++)
            Ce > 0 && de.push(this.labels[Ce]), de.push(this.outputs[Ce].serialize());
          return de;
        }
      }
      const $p = 0.95047, Ld = 1.08883, Rf = 4 / 29, Qu = 6 / 29, Wa = 3 * Qu * Qu, zm = Qu * Qu * Qu, Id = Math.PI / 180, eh = 180 / Math.PI;
      function Nh(Ie) {
        return Ie > zm ? Math.pow(Ie, 1 / 3) : Ie / Wa + Rf;
      }
      function Rp(Ie) {
        return Ie > Qu ? Ie * Ie * Ie : Wa * (Ie - Rf);
      }
      function Pp(Ie) {
        return 255 * (Ie <= 31308e-7 ? 12.92 * Ie : 1.055 * Math.pow(Ie, 1 / 2.4) - 0.055);
      }
      function Dp(Ie) {
        return (Ie /= 255) <= 0.04045 ? Ie / 12.92 : Math.pow((Ie + 0.055) / 1.055, 2.4);
      }
      function Bd(Ie) {
        const de = Dp(Ie.r), Ce = Dp(Ie.g), De = Dp(Ie.b), Ke = Nh((0.4124564 * de + 0.3575761 * Ce + 0.1804375 * De) / $p), Ve = Nh((0.2126729 * de + 0.7151522 * Ce + 0.072175 * De) / 1);
        return { l: 116 * Ve - 16, a: 500 * (Ke - Ve), b: 200 * (Ve - Nh((0.0193339 * de + 0.119192 * Ce + 0.9503041 * De) / Ld)), alpha: Ie.a };
      }
      function $d(Ie) {
        let de = (Ie.l + 16) / 116, Ce = isNaN(Ie.a) ? de : de + Ie.a / 500, De = isNaN(Ie.b) ? de : de - Ie.b / 200;
        return de = 1 * Rp(de), Ce = $p * Rp(Ce), De = Ld * Rp(De), new Ca(Pp(3.2404542 * Ce - 1.5371385 * de - 0.4985314 * De), Pp(-0.969266 * Ce + 1.8760108 * de + 0.041556 * De), Pp(0.0556434 * Ce - 0.2040259 * de + 1.0572252 * De), Ie.alpha);
      }
      function Op(Ie, de, Ce) {
        const De = de - Ie;
        return Ie + Ce * (De > 180 || De < -180 ? De - 360 * Math.round(De / 360) : De);
      }
      const Rd = { forward: Bd, reverse: $d, interpolate: function(Ie, de, Ce) {
        return { l: Ho(Ie.l, de.l, Ce), a: Ho(Ie.a, de.a, Ce), b: Ho(Ie.b, de.b, Ce), alpha: Ho(Ie.alpha, de.alpha, Ce) };
      } }, Vh = { forward: function(Ie) {
        const { l: de, a: Ce, b: De } = Bd(Ie), Ke = Math.atan2(De, Ce) * eh;
        return { h: Ke < 0 ? Ke + 360 : Ke, c: Math.sqrt(Ce * Ce + De * De), l: de, alpha: Ie.a };
      }, reverse: function(Ie) {
        const de = Ie.h * Id, Ce = Ie.c;
        return $d({ l: Ie.l, a: Math.cos(de) * Ce, b: Math.sin(de) * Ce, alpha: Ie.alpha });
      }, interpolate: function(Ie, de, Ce) {
        return { h: Op(Ie.h, de.h, Ce), c: Ho(Ie.c, de.c, Ce), l: Ho(Ie.l, de.l, Ce), alpha: Ho(Ie.alpha, de.alpha, Ce) };
      } };
      var Fm = Object.freeze({ __proto__: null, hcl: Vh, lab: Rd });
      class Vl {
        constructor(de, Ce, De, Ke, Ve, er) {
          this.type = de, this.operator = Ce, this.interpolation = De, this.input = Ke, this.dynamicStops = Ve, this.labels = [], this.outputs = [];
          for (const [fr, wr] of er)
            this.labels.push(fr), this.outputs.push(wr);
        }
        static interpolationFactor(de, Ce, De, Ke) {
          let Ve = 0;
          if (de.name === "exponential")
            Ve = Os(Ce, de.base, De, Ke);
          else if (de.name === "linear")
            Ve = Os(Ce, 1, De, Ke);
          else if (de.name === "cubic-bezier") {
            const er = de.controlPoints;
            Ve = new hi(er[0], er[1], er[2], er[3]).solve(Os(Ce, 1, De, Ke));
          }
          return Ve;
        }
        static parse(de, Ce) {
          let [De, Ke, Ve, ...er] = de;
          if (!Array.isArray(Ke) || Ke.length === 0)
            return Ce.error("Expected an interpolation type expression.", 1);
          if (Ke[0] === "linear")
            Ke = { name: "linear" };
          else if (Ke[0] === "exponential") {
            const kr = Ke[1];
            if (typeof kr != "number")
              return Ce.error("Exponential interpolation requires a numeric base.", 1, 1);
            Ke = { name: "exponential", base: kr };
          } else {
            if (Ke[0] !== "cubic-bezier")
              return Ce.error(`Unknown interpolation type ${String(Ke[0])}`, 1, 0);
            {
              const kr = Ke.slice(1);
              if (kr.length !== 4 || kr.some((cr) => typeof cr != "number" || cr < 0 || cr > 1))
                return Ce.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
              Ke = { name: "cubic-bezier", controlPoints: kr };
            }
          }
          if (de.length - 1 < 3)
            return Ce.error(`Expected at least 3 arguments, but found only ${de.length - 1}.`);
          if (de.length - 1 > 3 && (de.length - 1) % 2 != 0)
            return Ce.error("Expected an even number of arguments.");
          if (Ve = Ce.parse(Ve, 2, To), !Ve)
            return null;
          const fr = [];
          let wr = null;
          if (De === "interpolate-hcl" || De === "interpolate-lab" ? wr = Dl : Ce.expectedType && Ce.expectedType.kind !== "value" && (wr = Ce.expectedType), de.length - 1 == 3) {
            const kr = Ce.parse(er[0], 3, ga);
            return kr ? new Vl(wr, De, Ke, Ve, kr, fr) : null;
          }
          for (let kr = 0; kr < er.length; kr += 2) {
            const cr = er[kr], Mr = er[kr + 1], Er = kr + 3, xr = kr + 4;
            if (typeof cr != "number")
              return Ce.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', Er);
            if (fr.length && fr[fr.length - 1][0] >= cr)
              return Ce.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', Er);
            const Sr = Ce.parse(Mr, xr, wr);
            if (!Sr)
              return null;
            wr = wr || Sr.type, fr.push([cr, Sr]);
          }
          return wr.kind === "number" || wr.kind === "color" || wr.kind === "array" && wr.itemType.kind === "number" && typeof wr.N == "number" ? new Vl(wr, De, Ke, Ve, null, fr) : Ce.error(`Type ${ts(wr)} is not interpolatable.`);
        }
        evaluate(de) {
          let Ce = this.labels, De = this.outputs;
          if (this.dynamicStops) {
            const cr = this.dynamicStops.evaluate(de);
            if (cr.length % 2 != 0)
              throw new Ts("Expected an even number of arguments.");
            Ce = [], De = [];
            for (let Mr = 0; Mr < cr.length; Mr += 2) {
              const Er = cr[Mr], xr = new Yl(To, cr[Mr + 1]);
              if (typeof Er != "number")
                throw new Ts('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.');
              if (Ce.length && Ce[Ce.length - 1] >= Er)
                throw new Ts('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.');
              Ce.push(Er), De.push(xr);
            }
            if (Ce.length === 0)
              throw new Ts("Expected at least one input/output pair.");
          }
          if (Ce.length === 1)
            return De[0].evaluate(de);
          const Ke = this.input.evaluate(de);
          if (Ke <= Ce[0])
            return De[0].evaluate(de);
          const Ve = Ce.length;
          if (Ke >= Ce[Ve - 1])
            return De[Ve - 1].evaluate(de);
          const er = ca(Ce, Ke), fr = Vl.interpolationFactor(this.interpolation, Ke, Ce[er], Ce[er + 1]), wr = De[er].evaluate(de), kr = De[er + 1].evaluate(de);
          return this.operator === "interpolate" ? xa[this.type.kind.toLowerCase()](wr, kr, fr) : this.operator === "interpolate-hcl" ? Vh.reverse(Vh.interpolate(Vh.forward(wr), Vh.forward(kr), fr)) : Rd.reverse(Rd.interpolate(Rd.forward(wr), Rd.forward(kr), fr));
        }
        eachChild(de) {
          de(this.input);
          for (const Ce of this.outputs)
            de(Ce);
        }
        outputDefined() {
          return this.outputs.every((de) => de.outputDefined());
        }
        serialize() {
          let de;
          de = this.interpolation.name === "linear" ? ["linear"] : this.interpolation.name === "exponential" ? this.interpolation.base === 1 ? ["linear"] : ["exponential", this.interpolation.base] : ["cubic-bezier"].concat(this.interpolation.controlPoints);
          const Ce = [this.operator, de, this.input.serialize()];
          if (this.dynamicStops)
            Ce.push(this.dynamicStops.serialize());
          else
            for (let De = 0; De < this.labels.length; De++)
              Ce.push(this.labels[De], this.outputs[De].serialize());
          return Ce;
        }
      }
      function Os(Ie, de, Ce, De) {
        const Ke = De - Ce, Ve = Ie - Ce;
        return Ke === 0 ? 0 : de === 1 ? Ve / Ke : (Math.pow(de, Ve) - 1) / (Math.pow(de, Ke) - 1);
      }
      class Qs {
        constructor(de, Ce) {
          this.type = de, this.args = Ce;
        }
        static parse(de, Ce) {
          if (de.length < 2)
            return Ce.error("Expectected at least one argument.");
          let De = null;
          const Ke = Ce.expectedType;
          Ke && Ke.kind !== "value" && (De = Ke);
          const Ve = [];
          for (const fr of de.slice(1)) {
            const wr = Ce.parse(fr, 1 + Ve.length, De, void 0, { typeAnnotation: "omit" });
            if (!wr)
              return null;
            De = De || wr.type, Ve.push(wr);
          }
          const er = Ke && Ve.some((fr) => wd(Ke, fr.type));
          return new Qs(er ? ga : De, Ve);
        }
        evaluate(de) {
          let Ce, De = null, Ke = 0;
          for (const Ve of this.args) {
            if (Ke++, De = Ve.evaluate(de), De && De instanceof Ps && !De.available && (Ce || (Ce = De), De = null, Ke === this.args.length))
              return Ce;
            if (De !== null)
              break;
          }
          return De;
        }
        eachChild(de) {
          this.args.forEach(de);
        }
        outputDefined() {
          return this.args.every((de) => de.outputDefined());
        }
        serialize() {
          const de = ["coalesce"];
          return this.eachChild((Ce) => {
            de.push(Ce.serialize());
          }), de;
        }
      }
      class Pf {
        constructor(de, Ce) {
          this.type = Ce.type, this.bindings = [].concat(de), this.result = Ce;
        }
        evaluate(de) {
          return this.result.evaluate(de);
        }
        eachChild(de) {
          for (const Ce of this.bindings)
            de(Ce[1]);
          de(this.result);
        }
        static parse(de, Ce) {
          if (de.length < 4)
            return Ce.error(`Expected at least 3 arguments, but found ${de.length - 1} instead.`);
          const De = [];
          for (let Ve = 1; Ve < de.length - 1; Ve += 2) {
            const er = de[Ve];
            if (typeof er != "string")
              return Ce.error(`Expected string, but found ${typeof er} instead.`, Ve);
            if (/[^a-zA-Z0-9_]/.test(er))
              return Ce.error("Variable names must contain only alphanumeric characters or '_'.", Ve);
            const fr = Ce.parse(de[Ve + 1], Ve + 1);
            if (!fr)
              return null;
            De.push([er, fr]);
          }
          const Ke = Ce.parse(de[de.length - 1], de.length - 1, Ce.expectedType, De);
          return Ke ? new Pf(De, Ke) : null;
        }
        outputDefined() {
          return this.result.outputDefined();
        }
        serialize() {
          const de = ["let"];
          for (const [Ce, De] of this.bindings)
            de.push(Ce, De.serialize());
          return de.push(this.result.serialize()), de;
        }
      }
      class zp {
        constructor(de, Ce, De) {
          this.type = de, this.index = Ce, this.input = De;
        }
        static parse(de, Ce) {
          if (de.length !== 3)
            return Ce.error(`Expected 2 arguments, but found ${de.length - 1} instead.`);
          const De = Ce.parse(de[1], 1, To), Ke = Ce.parse(de[2], 2, dl(Ce.expectedType || ga));
          return De && Ke ? new zp(Ke.type.itemType, De, Ke) : null;
        }
        evaluate(de) {
          const Ce = this.index.evaluate(de), De = this.input.evaluate(de);
          if (Ce < 0)
            throw new Ts(`Array index out of bounds: ${Ce} < 0.`);
          if (Ce > De.length - 1)
            throw new Ts(`Array index out of bounds: ${Ce} > ${De.length - 1}.`);
          if (Ce === Math.floor(Ce))
            return De[Ce];
          const Ke = Math.floor(Ce), Ve = Math.ceil(Ce), er = De[Ke], fr = De[Ve];
          if (typeof er != "number" || typeof fr != "number")
            throw new Ts(`Cannot interpolate between non-number values at index ${Ce}.`);
          const wr = Ce - Ke;
          return er * (1 - wr) + fr * wr;
        }
        eachChild(de) {
          de(this.index), de(this.input);
        }
        outputDefined() {
          return !1;
        }
        serialize() {
          return ["at", this.index.serialize(), this.input.serialize()];
        }
      }
      class Df {
        constructor(de, Ce) {
          this.type = Ta, this.needle = de, this.haystack = Ce;
        }
        static parse(de, Ce) {
          if (de.length !== 3)
            return Ce.error(`Expected 2 arguments, but found ${de.length - 1} instead.`);
          const De = Ce.parse(de[1], 1, ga), Ke = Ce.parse(de[2], 2, ga);
          return De && Ke ? Ef(De.type, [Ta, Pa, To, Bh, ga]) ? new Df(De, Ke) : Ce.error(`Expected first argument to be of type boolean, string, number or null, but found ${ts(De.type)} instead`) : null;
        }
        evaluate(de) {
          const Ce = this.needle.evaluate(de), De = this.haystack.evaluate(de);
          if (De == null)
            return !1;
          if (!Wu(Ce, ["boolean", "string", "number", "null"]))
            throw new Ts(`Expected first argument to be of type boolean, string, number or null, but found ${ts(ds(Ce))} instead.`);
          if (!Wu(De, ["string", "array"]))
            throw new Ts(`Expected second argument to be of type array or string, but found ${ts(ds(De))} instead.`);
          return De.indexOf(Ce) >= 0;
        }
        eachChild(de) {
          de(this.needle), de(this.haystack);
        }
        outputDefined() {
          return !0;
        }
        serialize() {
          return ["in", this.needle.serialize(), this.haystack.serialize()];
        }
      }
      class Of {
        constructor(de, Ce, De) {
          this.type = To, this.needle = de, this.haystack = Ce, this.fromIndex = De;
        }
        static parse(de, Ce) {
          if (de.length <= 2 || de.length >= 5)
            return Ce.error(`Expected 3 or 4 arguments, but found ${de.length - 1} instead.`);
          const De = Ce.parse(de[1], 1, ga), Ke = Ce.parse(de[2], 2, ga);
          if (!De || !Ke)
            return null;
          if (!Ef(De.type, [Ta, Pa, To, Bh, ga]))
            return Ce.error(`Expected first argument to be of type boolean, string, number or null, but found ${ts(De.type)} instead`);
          if (de.length === 4) {
            const Ve = Ce.parse(de[3], 3, To);
            return Ve ? new Of(De, Ke, Ve) : null;
          }
          return new Of(De, Ke);
        }
        evaluate(de) {
          const Ce = this.needle.evaluate(de), De = this.haystack.evaluate(de);
          if (!Wu(Ce, ["boolean", "string", "number", "null"]))
            throw new Ts(`Expected first argument to be of type boolean, string, number or null, but found ${ts(ds(Ce))} instead.`);
          if (!Wu(De, ["string", "array"]))
            throw new Ts(`Expected second argument to be of type array or string, but found ${ts(ds(De))} instead.`);
          if (this.fromIndex) {
            const Ke = this.fromIndex.evaluate(de);
            return De.indexOf(Ce, Ke);
          }
          return De.indexOf(Ce);
        }
        eachChild(de) {
          de(this.needle), de(this.haystack), this.fromIndex && de(this.fromIndex);
        }
        outputDefined() {
          return !1;
        }
        serialize() {
          if (this.fromIndex != null && this.fromIndex !== void 0) {
            const de = this.fromIndex.serialize();
            return ["index-of", this.needle.serialize(), this.haystack.serialize(), de];
          }
          return ["index-of", this.needle.serialize(), this.haystack.serialize()];
        }
      }
      class Pd {
        constructor(de, Ce, De, Ke, Ve, er) {
          this.inputType = de, this.type = Ce, this.input = De, this.cases = Ke, this.outputs = Ve, this.otherwise = er;
        }
        static parse(de, Ce) {
          if (de.length < 5)
            return Ce.error(`Expected at least 4 arguments, but found only ${de.length - 1}.`);
          if (de.length % 2 != 1)
            return Ce.error("Expected an even number of arguments.");
          let De, Ke;
          Ce.expectedType && Ce.expectedType.kind !== "value" && (Ke = Ce.expectedType);
          const Ve = {}, er = [];
          for (let kr = 2; kr < de.length - 1; kr += 2) {
            let cr = de[kr];
            const Mr = de[kr + 1];
            Array.isArray(cr) || (cr = [cr]);
            const Er = Ce.concat(kr);
            if (cr.length === 0)
              return Er.error("Expected at least one branch label.");
            for (const Sr of cr) {
              if (typeof Sr != "number" && typeof Sr != "string")
                return Er.error("Branch labels must be numbers or strings.");
              if (typeof Sr == "number" && Math.abs(Sr) > Number.MAX_SAFE_INTEGER)
                return Er.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
              if (typeof Sr == "number" && Math.floor(Sr) !== Sr)
                return Er.error("Numeric branch labels must be integer values.");
              if (De) {
                if (Er.checkSubtype(De, ds(Sr)))
                  return null;
              } else
                De = ds(Sr);
              if (Ve[String(Sr)] !== void 0)
                return Er.error("Branch labels must be unique.");
              Ve[String(Sr)] = er.length;
            }
            const xr = Ce.parse(Mr, kr, Ke);
            if (!xr)
              return null;
            Ke = Ke || xr.type, er.push(xr);
          }
          const fr = Ce.parse(de[1], 1, ga);
          if (!fr)
            return null;
          const wr = Ce.parse(de[de.length - 1], de.length - 1, Ke);
          return wr ? fr.type.kind !== "value" && Ce.concat(1).checkSubtype(De, fr.type) ? null : new Pd(De, Ke, fr, Ve, er, wr) : null;
        }
        evaluate(de) {
          const Ce = this.input.evaluate(de);
          return (ds(Ce) === this.inputType && this.outputs[this.cases[Ce]] || this.otherwise).evaluate(de);
        }
        eachChild(de) {
          de(this.input), this.outputs.forEach(de), de(this.otherwise);
        }
        outputDefined() {
          return this.outputs.every((de) => de.outputDefined()) && this.otherwise.outputDefined();
        }
        serialize() {
          const de = ["match", this.input.serialize()], Ce = Object.keys(this.cases).sort(), De = [], Ke = {};
          for (const er of Ce) {
            const fr = Ke[this.cases[er]];
            fr === void 0 ? (Ke[this.cases[er]] = De.length, De.push([this.cases[er], [er]])) : De[fr][1].push(er);
          }
          const Ve = (er) => this.inputType.kind === "number" ? Number(er) : er;
          for (const [er, fr] of De)
            de.push(fr.length === 1 ? Ve(fr[0]) : fr.map(Ve)), de.push(this.outputs[er].serialize());
          return de.push(this.otherwise.serialize()), de;
        }
      }
      class th {
        constructor(de, Ce, De) {
          this.type = de, this.branches = Ce, this.otherwise = De;
        }
        static parse(de, Ce) {
          if (de.length < 4)
            return Ce.error(`Expected at least 3 arguments, but found only ${de.length - 1}.`);
          if (de.length % 2 != 0)
            return Ce.error("Expected an odd number of arguments.");
          let De;
          Ce.expectedType && Ce.expectedType.kind !== "value" && (De = Ce.expectedType);
          const Ke = [];
          for (let er = 1; er < de.length - 1; er += 2) {
            const fr = Ce.parse(de[er], er, Ta);
            if (!fr)
              return null;
            const wr = Ce.parse(de[er + 1], er + 1, De);
            if (!wr)
              return null;
            Ke.push([fr, wr]), De = De || wr.type;
          }
          const Ve = Ce.parse(de[de.length - 1], de.length - 1, De);
          return Ve ? new th(De, Ke, Ve) : null;
        }
        evaluate(de) {
          for (const [Ce, De] of this.branches)
            if (Ce.evaluate(de))
              return De.evaluate(de);
          return this.otherwise.evaluate(de);
        }
        eachChild(de) {
          for (const [Ce, De] of this.branches)
            de(Ce), de(De);
          de(this.otherwise);
        }
        outputDefined() {
          return this.branches.every(([de, Ce]) => Ce.outputDefined()) && this.otherwise.outputDefined();
        }
        serialize() {
          const de = ["case"];
          return this.eachChild((Ce) => {
            de.push(Ce.serialize());
          }), de;
        }
      }
      class Uh {
        constructor(de, Ce, De, Ke) {
          this.type = de, this.input = Ce, this.beginIndex = De, this.endIndex = Ke;
        }
        static parse(de, Ce) {
          if (de.length <= 2 || de.length >= 5)
            return Ce.error(`Expected 3 or 4 arguments, but found ${de.length - 1} instead.`);
          const De = Ce.parse(de[1], 1, ga), Ke = Ce.parse(de[2], 2, To);
          if (!De || !Ke)
            return null;
          if (!Ef(De.type, [dl(ga), Pa, ga]))
            return Ce.error(`Expected first argument to be of type array or string, but found ${ts(De.type)} instead`);
          if (de.length === 4) {
            const Ve = Ce.parse(de[3], 3, To);
            return Ve ? new Uh(De.type, De, Ke, Ve) : null;
          }
          return new Uh(De.type, De, Ke);
        }
        evaluate(de) {
          const Ce = this.input.evaluate(de), De = this.beginIndex.evaluate(de);
          if (!Wu(Ce, ["string", "array"]))
            throw new Ts(`Expected first argument to be of type array or string, but found ${ts(ds(Ce))} instead.`);
          if (this.endIndex) {
            const Ke = this.endIndex.evaluate(de);
            return Ce.slice(De, Ke);
          }
          return Ce.slice(De);
        }
        eachChild(de) {
          de(this.input), de(this.beginIndex), this.endIndex && de(this.endIndex);
        }
        outputDefined() {
          return !1;
        }
        serialize() {
          if (this.endIndex != null && this.endIndex !== void 0) {
            const de = this.endIndex.serialize();
            return ["slice", this.input.serialize(), this.beginIndex.serialize(), de];
          }
          return ["slice", this.input.serialize(), this.beginIndex.serialize()];
        }
      }
      function ih(Ie, de) {
        return Ie === "==" || Ie === "!=" ? de.kind === "boolean" || de.kind === "string" || de.kind === "number" || de.kind === "null" || de.kind === "value" : de.kind === "string" || de.kind === "number" || de.kind === "value";
      }
      function jh(Ie, de, Ce, De) {
        return De.compare(de, Ce) === 0;
      }
      function jc(Ie, de, Ce) {
        const De = Ie !== "==" && Ie !== "!=";
        return class Hy {
          constructor(Ve, er, fr) {
            this.type = Ta, this.lhs = Ve, this.rhs = er, this.collator = fr, this.hasUntypedArgument = Ve.type.kind === "value" || er.type.kind === "value";
          }
          static parse(Ve, er) {
            if (Ve.length !== 3 && Ve.length !== 4)
              return er.error("Expected two or three arguments.");
            const fr = Ve[0];
            let wr = er.parse(Ve[1], 1, ga);
            if (!wr)
              return null;
            if (!ih(fr, wr.type))
              return er.concat(1).error(`"${fr}" comparisons are not supported for type '${ts(wr.type)}'.`);
            let kr = er.parse(Ve[2], 2, ga);
            if (!kr)
              return null;
            if (!ih(fr, kr.type))
              return er.concat(2).error(`"${fr}" comparisons are not supported for type '${ts(kr.type)}'.`);
            if (wr.type.kind !== kr.type.kind && wr.type.kind !== "value" && kr.type.kind !== "value")
              return er.error(`Cannot compare types '${ts(wr.type)}' and '${ts(kr.type)}'.`);
            De && (wr.type.kind === "value" && kr.type.kind !== "value" ? wr = new Jl(kr.type, [wr]) : wr.type.kind !== "value" && kr.type.kind === "value" && (kr = new Jl(wr.type, [kr])));
            let cr = null;
            if (Ve.length === 4) {
              if (wr.type.kind !== "string" && kr.type.kind !== "string" && wr.type.kind !== "value" && kr.type.kind !== "value")
                return er.error("Cannot use collator to compare non-string types.");
              if (cr = er.parse(Ve[3], 3, vs), !cr)
                return null;
            }
            return new Hy(wr, kr, cr);
          }
          evaluate(Ve) {
            const er = this.lhs.evaluate(Ve), fr = this.rhs.evaluate(Ve);
            if (De && this.hasUntypedArgument) {
              const wr = ds(er), kr = ds(fr);
              if (wr.kind !== kr.kind || wr.kind !== "string" && wr.kind !== "number")
                throw new Ts(`Expected arguments for "${Ie}" to be (string, string) or (number, number), but found (${wr.kind}, ${kr.kind}) instead.`);
            }
            if (this.collator && !De && this.hasUntypedArgument) {
              const wr = ds(er), kr = ds(fr);
              if (wr.kind !== "string" || kr.kind !== "string")
                return de(Ve, er, fr);
            }
            return this.collator ? Ce(Ve, er, fr, this.collator.evaluate(Ve)) : de(Ve, er, fr);
          }
          eachChild(Ve) {
            Ve(this.lhs), Ve(this.rhs), this.collator && Ve(this.collator);
          }
          outputDefined() {
            return !0;
          }
          serialize() {
            const Ve = [Ie];
            return this.eachChild((er) => {
              Ve.push(er.serialize());
            }), Ve;
          }
        };
      }
      const zf = jc("==", function(Ie, de, Ce) {
        return de === Ce;
      }, jh), qh = jc("!=", function(Ie, de, Ce) {
        return de !== Ce;
      }, function(Ie, de, Ce, De) {
        return !jh(0, de, Ce, De);
      }), V0 = jc("<", function(Ie, de, Ce) {
        return de < Ce;
      }, function(Ie, de, Ce, De) {
        return De.compare(de, Ce) < 0;
      }), U0 = jc(">", function(Ie, de, Ce) {
        return de > Ce;
      }, function(Ie, de, Ce, De) {
        return De.compare(de, Ce) > 0;
      }), j0 = jc("<=", function(Ie, de, Ce) {
        return de <= Ce;
      }, function(Ie, de, Ce, De) {
        return De.compare(de, Ce) <= 0;
      }), Fp = jc(">=", function(Ie, de, Ce) {
        return de >= Ce;
      }, function(Ie, de, Ce, De) {
        return De.compare(de, Ce) >= 0;
      });
      class Np {
        constructor(de, Ce, De, Ke, Ve, er) {
          this.type = Pa, this.number = de, this.locale = Ce, this.currency = De, this.unit = Ke, this.minFractionDigits = Ve, this.maxFractionDigits = er;
        }
        static parse(de, Ce) {
          if (de.length !== 3)
            return Ce.error("Expected two arguments.");
          const De = Ce.parse(de[1], 1, To);
          if (!De)
            return null;
          const Ke = de[2];
          if (typeof Ke != "object" || Array.isArray(Ke))
            return Ce.error("NumberFormat options argument must be an object.");
          let Ve = null;
          if (Ke.locale && (Ve = Ce.parseObjectValue(Ke.locale, 2, "locale", Pa), !Ve))
            return null;
          let er = null;
          if (Ke.currency && (er = Ce.parseObjectValue(Ke.currency, 2, "currency", Pa), !er))
            return null;
          let fr = null;
          if (Ke.unit && (fr = Ce.parseObjectValue(Ke.unit, 2, "unit", Pa), !fr))
            return null;
          let wr = null;
          if (Ke["min-fraction-digits"] && (wr = Ce.parseObjectValue(Ke["min-fraction-digits"], 2, "min-fraction-digits", To), !wr))
            return null;
          let kr = null;
          return Ke["max-fraction-digits"] && (kr = Ce.parseObjectValue(Ke["max-fraction-digits"], 2, "max-fraction-digits", To), !kr) ? null : new Np(De, Ve, er, fr, wr, kr);
        }
        evaluate(de) {
          return new Intl.NumberFormat(this.locale ? this.locale.evaluate(de) : [], { style: (this.currency ? "currency" : this.unit && "unit") || "decimal", currency: this.currency ? this.currency.evaluate(de) : void 0, unit: this.unit ? this.unit.evaluate(de) : void 0, minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(de) : void 0, maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(de) : void 0 }).format(this.number.evaluate(de));
        }
        eachChild(de) {
          de(this.number), this.locale && de(this.locale), this.currency && de(this.currency), this.unit && de(this.unit), this.minFractionDigits && de(this.minFractionDigits), this.maxFractionDigits && de(this.maxFractionDigits);
        }
        outputDefined() {
          return !1;
        }
        serialize() {
          const de = {};
          return this.locale && (de.locale = this.locale.serialize()), this.currency && (de.currency = this.currency.serialize()), this.unit && (de.unit = this.unit.serialize()), this.minFractionDigits && (de["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (de["max-fraction-digits"] = this.maxFractionDigits.serialize()), ["number-format", this.number.serialize(), de];
        }
      }
      class nh {
        constructor(de) {
          this.type = To, this.input = de;
        }
        static parse(de, Ce) {
          if (de.length !== 2)
            return Ce.error(`Expected 1 argument, but found ${de.length - 1} instead.`);
          const De = Ce.parse(de[1], 1);
          return De ? De.type.kind !== "array" && De.type.kind !== "string" && De.type.kind !== "value" ? Ce.error(`Expected argument of type string or array, but found ${ts(De.type)} instead.`) : new nh(De) : null;
        }
        evaluate(de) {
          const Ce = this.input.evaluate(de);
          if (typeof Ce == "string" || Array.isArray(Ce))
            return Ce.length;
          throw new Ts(`Expected value to be of type string or array, but found ${ts(ds(Ce))} instead.`);
        }
        eachChild(de) {
          de(this.input);
        }
        outputDefined() {
          return !1;
        }
        serialize() {
          const de = ["length"];
          return this.eachChild((Ce) => {
            de.push(Ce.serialize());
          }), de;
        }
      }
      function Gh(Ie) {
        return function() {
          Ie = 1831565813 + (Ie |= 0) | 0;
          let de = Math.imul(Ie ^ Ie >>> 15, 1 | Ie);
          return de = de + Math.imul(de ^ de >>> 7, 61 | de) ^ de, ((de ^ de >>> 14) >>> 0) / 4294967296;
        };
      }
      const oh = { "==": zf, "!=": qh, ">": U0, "<": V0, ">=": Fp, "<=": j0, array: Jl, at: zp, boolean: Jl, case: th, coalesce: Qs, collator: Sc, format: Ds, image: Rh, in: Df, "index-of": Of, interpolate: Vl, "interpolate-hcl": Vl, "interpolate-lab": Vl, length: nh, let: Pf, literal: Yl, match: Pd, number: Jl, "number-format": Np, object: Jl, slice: Uh, step: Cu, string: Jl, "to-boolean": Vc, "to-color": Vc, "to-number": Vc, "to-string": Vc, var: kd, within: Cc, distance: Su, config: Uc };
      function Zi(Ie, [de, Ce, De, Ke]) {
        de = de.evaluate(Ie), Ce = Ce.evaluate(Ie), De = De.evaluate(Ie);
        const Ve = Ke ? Ke.evaluate(Ie) : 1, er = iu(de, Ce, De, Ve);
        if (er)
          throw new Ts(er);
        return new Ca(de / 255 * Ve, Ce / 255 * Ve, De / 255 * Ve, Ve);
      }
      function Tu(Ie, [de, Ce, De, Ke]) {
        de = de.evaluate(Ie), Ce = Ce.evaluate(Ie), De = De.evaluate(Ie);
        const Ve = Ke ? Ke.evaluate(Ie) : 1, er = function(kr, cr, Mr, Er) {
          return typeof kr == "number" && kr >= 0 && kr <= 360 ? typeof cr == "number" && cr >= 0 && cr <= 100 && typeof Mr == "number" && Mr >= 0 && Mr <= 100 ? Er === void 0 || typeof Er == "number" && Er >= 0 && Er <= 1 ? null : `Invalid hsla value [${[kr, cr, Mr, Er].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid hsla value [${(typeof Er == "number" ? [kr, cr, Mr, Er] : [kr, cr, Mr]).join(", ")}]: 's', and 'l' must be between 0 and 100.` : `Invalid hsla value [${(typeof Er == "number" ? [kr, cr, Mr, Er] : [kr, cr, Mr]).join(", ")}]: 'h' must be between 0 and 360.`;
        }(de, Ce, De, Ve);
        if (er)
          throw new Ts(er);
        const fr = `hsla(${de}, ${Ce}%, ${De}%, ${Ve})`, wr = Ca.parse(fr);
        if (!wr)
          throw new Ts(`Failed to parse HSLA color: ${fr}`);
        return wr;
      }
      function Hh(Ie, de) {
        return Ie in de;
      }
      function el(Ie, de) {
        const Ce = de[Ie];
        return Ce === void 0 ? null : Ce;
      }
      function Da(Ie) {
        return { type: Ie };
      }
      function Vp(Ie) {
        return { result: "success", value: Ie };
      }
      function Au(Ie) {
        return { result: "error", value: Ie };
      }
      function Dd(Ie, de) {
        return !!Ie && !!Ie.parameters && Ie.parameters.indexOf(de) > -1;
      }
      function pc(Ie) {
        return Ie["property-type"] === "data-driven";
      }
      function Nm(Ie) {
        return Dd(Ie.expression, "measure-light");
      }
      function Vm(Ie) {
        return Dd(Ie.expression, "zoom");
      }
      function Ff(Ie) {
        return !!Ie.expression && Ie.expression.interpolated;
      }
      function Nf(Ie) {
        return typeof Ie == "object" && Ie !== null && !Array.isArray(Ie);
      }
      function q0(Ie) {
        return Ie;
      }
      function qc(Ie, de) {
        const Ce = de.type === "color", De = Ie.stops && typeof Ie.stops[0][0] == "object", Ke = De || !(De || Ie.property !== void 0), Ve = Ie.type || (Ff(de) ? "exponential" : "interval");
        if (Ce && ((Ie = Sf({}, Ie)).stops && (Ie.stops = Ie.stops.map((kr) => [kr[0], Ca.parse(kr[1])])), Ie.default = Ca.parse(Ie.default ? Ie.default : de.default)), Ie.colorSpace && Ie.colorSpace !== "rgb" && !Fm[Ie.colorSpace])
          throw new Error(`Unknown color space: ${Ie.colorSpace}`);
        let er, fr, wr;
        if (Ve === "exponential")
          er = zd;
        else if (Ve === "interval")
          er = jm;
        else if (Ve === "categorical") {
          er = Um, fr = /* @__PURE__ */ Object.create(null);
          for (const kr of Ie.stops)
            fr[kr[0]] = kr[1];
          wr = typeof Ie.stops[0][0];
        } else {
          if (Ve !== "identity")
            throw new Error(`Unknown function type "${Ve}"`);
          er = G0;
        }
        if (De) {
          const kr = {}, cr = [];
          for (let xr = 0; xr < Ie.stops.length; xr++) {
            const Sr = Ie.stops[xr], Br = Sr[0].zoom;
            kr[Br] === void 0 && (kr[Br] = { zoom: Br, type: Ie.type, property: Ie.property, default: Ie.default, stops: [] }, cr.push(Br)), kr[Br].stops.push([Sr[0].value, Sr[1]]);
          }
          const Mr = [];
          for (const xr of cr)
            Mr.push([kr[xr].zoom, qc(kr[xr], de)]);
          const Er = { name: "linear" };
          return { kind: "composite", interpolationType: Er, interpolationFactor: Vl.interpolationFactor.bind(void 0, Er), zoomStops: Mr.map((xr) => xr[0]), evaluate: ({ zoom: xr }, Sr) => zd({ stops: Mr, base: Ie.base }, de, xr).evaluate(xr, Sr) };
        }
        if (Ke) {
          const kr = Ve === "exponential" ? { name: "exponential", base: Ie.base !== void 0 ? Ie.base : 1 } : null;
          return { kind: "camera", interpolationType: kr, interpolationFactor: Vl.interpolationFactor.bind(void 0, kr), zoomStops: Ie.stops.map((cr) => cr[0]), evaluate: ({ zoom: cr }) => er(Ie, de, cr, fr, wr) };
        }
        return { kind: "source", evaluate(kr, cr) {
          const Mr = cr && cr.properties ? cr.properties[Ie.property] : void 0;
          return Mr === void 0 ? Od(Ie.default, de.default) : er(Ie, de, Mr, fr, wr);
        } };
      }
      function Od(Ie, de, Ce) {
        return Ie !== void 0 ? Ie : de !== void 0 ? de : Ce !== void 0 ? Ce : void 0;
      }
      function Um(Ie, de, Ce, De, Ke) {
        return Od(typeof Ce === Ke ? De[Ce] : void 0, Ie.default, de.default);
      }
      function jm(Ie, de, Ce) {
        if (al(Ce) !== "number")
          return Od(Ie.default, de.default);
        const De = Ie.stops.length;
        if (De === 1 || Ce <= Ie.stops[0][0])
          return Ie.stops[0][1];
        if (Ce >= Ie.stops[De - 1][0])
          return Ie.stops[De - 1][1];
        const Ke = ca(Ie.stops.map((Ve) => Ve[0]), Ce);
        return Ie.stops[Ke][1];
      }
      function zd(Ie, de, Ce) {
        const De = Ie.base !== void 0 ? Ie.base : 1;
        if (al(Ce) !== "number")
          return Od(Ie.default, de.default);
        const Ke = Ie.stops.length;
        if (Ke === 1 || Ce <= Ie.stops[0][0])
          return Ie.stops[0][1];
        if (Ce >= Ie.stops[Ke - 1][0])
          return Ie.stops[Ke - 1][1];
        const Ve = ca(Ie.stops.map((cr) => cr[0]), Ce), er = function(cr, Mr, Er, xr) {
          const Sr = xr - Er, Br = cr - Er;
          return Sr === 0 ? 0 : Mr === 1 ? Br / Sr : (Math.pow(Mr, Br) - 1) / (Math.pow(Mr, Sr) - 1);
        }(Ce, De, Ie.stops[Ve][0], Ie.stops[Ve + 1][0]), fr = Ie.stops[Ve][1], wr = Ie.stops[Ve + 1][1];
        let kr = xa[de.type] || q0;
        if (Ie.colorSpace && Ie.colorSpace !== "rgb") {
          const cr = Fm[Ie.colorSpace];
          kr = (Mr, Er) => cr.reverse(cr.interpolate(cr.forward(Mr), cr.forward(Er), er));
        }
        return typeof fr.evaluate == "function" ? { evaluate(...cr) {
          const Mr = fr.evaluate.apply(void 0, cr), Er = wr.evaluate.apply(void 0, cr);
          if (Mr !== void 0 && Er !== void 0)
            return kr(Mr, Er, er);
        } } : kr(fr, wr, er);
      }
      function G0(Ie, de, Ce) {
        return de.type === "color" ? Ce = Ca.parse(Ce) : de.type === "formatted" ? Ce = Ys.fromString(Ce.toString()) : de.type === "resolvedImage" ? Ce = Ps.build(Ce.toString()) : al(Ce) === de.type || de.type === "enum" && de.values[Ce] || (Ce = void 0), Od(Ce, Ie.default, de.default);
      }
      bl.register(oh, { error: [{ kind: "error" }, [Pa], (Ie, [de]) => {
        throw new Ts(de.evaluate(Ie));
      }], typeof: [Pa, [ga], (Ie, [de]) => ts(ds(de.evaluate(Ie)))], "to-rgba": [dl(To, 4), [Dl], (Ie, [de]) => de.evaluate(Ie).toRenderColor(null).toArray()], "to-hsla": [dl(To, 4), [Dl], (Ie, [de]) => de.evaluate(Ie).toRenderColor(null).toHslaArray()], rgb: [Dl, [To, To, To], Zi], rgba: [Dl, [To, To, To, To], Zi], hsl: [Dl, [To, To, To], Tu], hsla: [Dl, [To, To, To, To], Tu], has: { type: Ta, overloads: [[[Pa], (Ie, [de]) => Hh(de.evaluate(Ie), Ie.properties())], [[Pa, Gu], (Ie, [de, Ce]) => Hh(de.evaluate(Ie), Ce.evaluate(Ie))]] }, get: { type: ga, overloads: [[[Pa], (Ie, [de]) => el(de.evaluate(Ie), Ie.properties())], [[Pa, Gu], (Ie, [de, Ce]) => el(de.evaluate(Ie), Ce.evaluate(Ie))]] }, "feature-state": [ga, [Pa], (Ie, [de]) => el(de.evaluate(Ie), Ie.featureState || {})], properties: [Gu, [], (Ie) => Ie.properties()], "geometry-type": [Pa, [], (Ie) => Ie.geometryType()], id: [ga, [], (Ie) => Ie.id()], zoom: [To, [], (Ie) => Ie.globals.zoom], pitch: [To, [], (Ie) => Ie.globals.pitch || 0], "distance-from-center": [To, [], (Ie) => Ie.distanceFromCenter()], "measure-light": [To, [Pa], (Ie, [de]) => Ie.measureLight(de.evaluate(Ie))], "heatmap-density": [To, [], (Ie) => Ie.globals.heatmapDensity || 0], "line-progress": [To, [], (Ie) => Ie.globals.lineProgress || 0], "raster-value": [To, [], (Ie) => Ie.globals.rasterValue || 0], "raster-particle-speed": [To, [], (Ie) => Ie.globals.rasterParticleSpeed || 0], "sky-radial-progress": [To, [], (Ie) => Ie.globals.skyRadialProgress || 0], accumulated: [ga, [], (Ie) => Ie.globals.accumulated === void 0 ? null : Ie.globals.accumulated], "+": [To, Da(To), (Ie, de) => {
        let Ce = 0;
        for (const De of de)
          Ce += De.evaluate(Ie);
        return Ce;
      }], "*": [To, Da(To), (Ie, de) => {
        let Ce = 1;
        for (const De of de)
          Ce *= De.evaluate(Ie);
        return Ce;
      }], "-": { type: To, overloads: [[[To, To], (Ie, [de, Ce]) => de.evaluate(Ie) - Ce.evaluate(Ie)], [[To], (Ie, [de]) => -de.evaluate(Ie)]] }, "/": [To, [To, To], (Ie, [de, Ce]) => de.evaluate(Ie) / Ce.evaluate(Ie)], "%": [To, [To, To], (Ie, [de, Ce]) => de.evaluate(Ie) % Ce.evaluate(Ie)], ln2: [To, [], () => Math.LN2], pi: [To, [], () => Math.PI], e: [To, [], () => Math.E], "^": [To, [To, To], (Ie, [de, Ce]) => Math.pow(de.evaluate(Ie), Ce.evaluate(Ie))], sqrt: [To, [To], (Ie, [de]) => Math.sqrt(de.evaluate(Ie))], log10: [To, [To], (Ie, [de]) => Math.log(de.evaluate(Ie)) / Math.LN10], ln: [To, [To], (Ie, [de]) => Math.log(de.evaluate(Ie))], log2: [To, [To], (Ie, [de]) => Math.log(de.evaluate(Ie)) / Math.LN2], sin: [To, [To], (Ie, [de]) => Math.sin(de.evaluate(Ie))], cos: [To, [To], (Ie, [de]) => Math.cos(de.evaluate(Ie))], tan: [To, [To], (Ie, [de]) => Math.tan(de.evaluate(Ie))], asin: [To, [To], (Ie, [de]) => Math.asin(de.evaluate(Ie))], acos: [To, [To], (Ie, [de]) => Math.acos(de.evaluate(Ie))], atan: [To, [To], (Ie, [de]) => Math.atan(de.evaluate(Ie))], min: [To, Da(To), (Ie, de) => Math.min(...de.map((Ce) => Ce.evaluate(Ie)))], max: [To, Da(To), (Ie, de) => Math.max(...de.map((Ce) => Ce.evaluate(Ie)))], abs: [To, [To], (Ie, [de]) => Math.abs(de.evaluate(Ie))], round: [To, [To], (Ie, [de]) => {
        const Ce = de.evaluate(Ie);
        return Ce < 0 ? -Math.round(-Ce) : Math.round(Ce);
      }], floor: [To, [To], (Ie, [de]) => Math.floor(de.evaluate(Ie))], ceil: [To, [To], (Ie, [de]) => Math.ceil(de.evaluate(Ie))], "filter-==": [Ta, [Pa, ga], (Ie, [de, Ce]) => Ie.properties()[de.value] === Ce.value], "filter-id-==": [Ta, [ga], (Ie, [de]) => Ie.id() === de.value], "filter-type-==": [Ta, [Pa], (Ie, [de]) => Ie.geometryType() === de.value], "filter-<": [Ta, [Pa, ga], (Ie, [de, Ce]) => {
        const De = Ie.properties()[de.value], Ke = Ce.value;
        return typeof De == typeof Ke && De < Ke;
      }], "filter-id-<": [Ta, [ga], (Ie, [de]) => {
        const Ce = Ie.id(), De = de.value;
        return typeof Ce == typeof De && Ce < De;
      }], "filter->": [Ta, [Pa, ga], (Ie, [de, Ce]) => {
        const De = Ie.properties()[de.value], Ke = Ce.value;
        return typeof De == typeof Ke && De > Ke;
      }], "filter-id->": [Ta, [ga], (Ie, [de]) => {
        const Ce = Ie.id(), De = de.value;
        return typeof Ce == typeof De && Ce > De;
      }], "filter-<=": [Ta, [Pa, ga], (Ie, [de, Ce]) => {
        const De = Ie.properties()[de.value], Ke = Ce.value;
        return typeof De == typeof Ke && De <= Ke;
      }], "filter-id-<=": [Ta, [ga], (Ie, [de]) => {
        const Ce = Ie.id(), De = de.value;
        return typeof Ce == typeof De && Ce <= De;
      }], "filter->=": [Ta, [Pa, ga], (Ie, [de, Ce]) => {
        const De = Ie.properties()[de.value], Ke = Ce.value;
        return typeof De == typeof Ke && De >= Ke;
      }], "filter-id->=": [Ta, [ga], (Ie, [de]) => {
        const Ce = Ie.id(), De = de.value;
        return typeof Ce == typeof De && Ce >= De;
      }], "filter-has": [Ta, [ga], (Ie, [de]) => de.value in Ie.properties()], "filter-has-id": [Ta, [], (Ie) => Ie.id() !== null && Ie.id() !== void 0], "filter-type-in": [Ta, [dl(Pa)], (Ie, [de]) => de.value.indexOf(Ie.geometryType()) >= 0], "filter-id-in": [Ta, [dl(ga)], (Ie, [de]) => de.value.indexOf(Ie.id()) >= 0], "filter-in-small": [Ta, [Pa, dl(ga)], (Ie, [de, Ce]) => Ce.value.indexOf(Ie.properties()[de.value]) >= 0], "filter-in-large": [Ta, [Pa, dl(ga)], (Ie, [de, Ce]) => function(De, Ke, Ve, er) {
        for (; Ve <= er; ) {
          const fr = Ve + er >> 1;
          if (Ke[fr] === De)
            return !0;
          Ke[fr] > De ? er = fr - 1 : Ve = fr + 1;
        }
        return !1;
      }(Ie.properties()[de.value], Ce.value, 0, Ce.value.length - 1)], all: { type: Ta, overloads: [[[Ta, Ta], (Ie, [de, Ce]) => de.evaluate(Ie) && Ce.evaluate(Ie)], [Da(Ta), (Ie, de) => {
        for (const Ce of de)
          if (!Ce.evaluate(Ie))
            return !1;
        return !0;
      }]] }, any: { type: Ta, overloads: [[[Ta, Ta], (Ie, [de, Ce]) => de.evaluate(Ie) || Ce.evaluate(Ie)], [Da(Ta), (Ie, de) => {
        for (const Ce of de)
          if (Ce.evaluate(Ie))
            return !0;
        return !1;
      }]] }, "!": [Ta, [Ta], (Ie, [de]) => !de.evaluate(Ie)], "is-supported-script": [Ta, [Pa], (Ie, [de]) => {
        const Ce = Ie.globals && Ie.globals.isSupportedScript;
        return !Ce || Ce(de.evaluate(Ie));
      }], upcase: [Pa, [Pa], (Ie, [de]) => de.evaluate(Ie).toUpperCase()], downcase: [Pa, [Pa], (Ie, [de]) => de.evaluate(Ie).toLowerCase()], concat: [Pa, Da(ga), (Ie, de) => de.map((Ce) => dc(Ce.evaluate(Ie))).join("")], "resolved-locale": [Pa, [vs], (Ie, [de]) => de.evaluate(Ie).resolvedLocale()], random: [To, [To, To, ga], (Ie, de) => {
        const [Ce, De, Ke] = de.map((er) => er.evaluate(Ie));
        if (Ce > De || Ce === De)
          return Ce;
        let Ve;
        if (typeof Ke == "string")
          Ve = function(er) {
            let fr = 0;
            if (er.length === 0)
              return fr;
            for (let wr = 0; wr < er.length; wr++)
              fr = (fr << 5) - fr + er.charCodeAt(wr), fr |= 0;
            return fr;
          }(Ke);
        else {
          if (typeof Ke != "number")
            throw new Ts(`Invalid seed input: ${Ke}`);
          Ve = Ke;
        }
        return Ce + Gh(Ve)() * (De - Ce);
      }] });
      class mc {
        constructor(de, Ce, De, Ke) {
          this.expression = de, this._warningHistory = {}, this._evaluator = new Zu(De, Ke), this._defaultValue = Ce ? function(Ve) {
            return Ve.type === "color" && (Nf(Ve.default) || Array.isArray(Ve.default)) ? new Ca(0, 0, 0, 0) : Ve.type === "color" ? Ca.parse(Ve.default) || null : Ve.default === void 0 ? null : Ve.default;
          }(Ce) : null, this._enumValues = Ce && Ce.type === "enum" ? Ce.values : null, this.configDependencies = Eu(de);
        }
        evaluateWithoutErrorHandling(de, Ce, De, Ke, Ve, er, fr, wr) {
          return this._evaluator.globals = de, this._evaluator.feature = Ce, this._evaluator.featureState = De, this._evaluator.canonical = Ke || null, this._evaluator.availableImages = Ve || null, this._evaluator.formattedSection = er, this._evaluator.featureTileCoord = fr || null, this._evaluator.featureDistanceData = wr || null, this.expression.evaluate(this._evaluator);
        }
        evaluate(de, Ce, De, Ke, Ve, er, fr, wr) {
          this._evaluator.globals = de, this._evaluator.feature = Ce || null, this._evaluator.featureState = De || null, this._evaluator.canonical = Ke || null, this._evaluator.availableImages = Ve || null, this._evaluator.formattedSection = er || null, this._evaluator.featureTileCoord = fr || null, this._evaluator.featureDistanceData = wr || null;
          try {
            const kr = this.expression.evaluate(this._evaluator);
            if (kr == null || typeof kr == "number" && kr != kr)
              return this._defaultValue;
            if (this._enumValues && !(kr in this._enumValues))
              throw new Ts(`Expected value to be one of ${Object.keys(this._enumValues).map((cr) => JSON.stringify(cr)).join(", ")}, but found ${JSON.stringify(kr)} instead.`);
            return kr;
          } catch (kr) {
            return this._warningHistory[kr.message] || (this._warningHistory[kr.message] = !0, typeof console < "u" && console.warn(`Failed to evaluate expression "${JSON.stringify(this.expression.serialize())}". ${kr.message}`)), this._defaultValue;
          }
        }
      }
      function Up(Ie) {
        return Array.isArray(Ie) && Ie.length > 0 && typeof Ie[0] == "string" && Ie[0] in oh;
      }
      function Fd(Ie, de, Ce, De) {
        const Ke = new Bp(oh, [], de ? function(er) {
          const fr = { color: Dl, string: Pa, number: To, enum: Pa, boolean: Ta, formatted: es, resolvedImage: Hu };
          return er.type === "array" ? dl(fr[er.value] || ga, er.length) : fr[er.type];
        }(de) : void 0, void 0, void 0, Ce, De), Ve = Ke.parse(Ie, void 0, void 0, void 0, de && de.type === "string" ? { typeAnnotation: "coerce" } : void 0);
        return Ve ? Vp(new mc(Ve, de, Ce, De)) : Au(Ke.errors);
      }
      class Vf {
        constructor(de, Ce, De, Ke) {
          this.kind = de, this._styleExpression = Ce, this.isLightConstant = De, this.isLineProgressConstant = Ke, this.isStateDependent = de !== "constant" && !Ju(Ce.expression), this.configDependencies = Eu(Ce.expression);
        }
        evaluateWithoutErrorHandling(de, Ce, De, Ke, Ve, er) {
          return this._styleExpression.evaluateWithoutErrorHandling(de, Ce, De, Ke, Ve, er);
        }
        evaluate(de, Ce, De, Ke, Ve, er) {
          return this._styleExpression.evaluate(de, Ce, De, Ke, Ve, er);
        }
      }
      class Wh {
        constructor(de, Ce, De, Ke, Ve, er) {
          this.kind = de, this.zoomStops = De, this._styleExpression = Ce, this.isStateDependent = de !== "camera" && !Ju(Ce.expression), this.isLightConstant = Ve, this.isLineProgressConstant = er, this.configDependencies = Eu(Ce.expression), this.interpolationType = Ke;
        }
        evaluateWithoutErrorHandling(de, Ce, De, Ke, Ve, er) {
          return this._styleExpression.evaluateWithoutErrorHandling(de, Ce, De, Ke, Ve, er);
        }
        evaluate(de, Ce, De, Ke, Ve, er) {
          return this._styleExpression.evaluate(de, Ce, De, Ke, Ve, er);
        }
        interpolationFactor(de, Ce, De) {
          return this.interpolationType ? Vl.interpolationFactor(this.interpolationType, de, Ce, De) : 0;
        }
      }
      function qm(Ie, de, Ce, De) {
        if ((Ie = Fd(Ie, de, Ce, De)).result === "error")
          return Ie;
        const Ke = Ie.value.expression, Ve = rs(Ke);
        if (!Ve && !pc(de))
          return Au([new hc("", "data expressions not supported")]);
        const er = fc(Ke, ["zoom", "pitch", "distance-from-center"]);
        if (!er && !Vm(de))
          return Au([new hc("", "zoom expressions not supported")]);
        const fr = fc(Ke, ["measure-light"]);
        if (!fr && !Nm(de))
          return Au([new hc("", "measure-light expression not supported")]);
        const wr = fc(Ke, ["line-progress"]);
        if (!wr && !function(Mr) {
          return Dd(Mr.expression, "line-progress");
        }(de))
          return Au([new hc("", "line-progress expression not supported")]);
        const kr = de.expression && de.expression.relaxZoomRestriction, cr = Uf(Ke);
        return cr || er || kr ? cr instanceof hc ? Au([cr]) : cr instanceof Vl && !Ff(de) ? Au([new hc("", '"interpolate" expressions cannot be used with this property')]) : Vp(cr ? new Wh(Ve && wr ? "camera" : "composite", Ie.value, cr.labels, cr instanceof Vl ? cr.interpolation : void 0, fr, wr) : new Vf(Ve && wr ? "constant" : "source", Ie.value, fr, wr)) : Au([new hc("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')]);
      }
      class Gc {
        constructor(de, Ce) {
          this._parameters = de, this._specification = Ce, Sf(this, qc(this._parameters, this._specification));
        }
        static deserialize(de) {
          return new Gc(de._parameters, de._specification);
        }
        static serialize(de) {
          return { _parameters: de._parameters, _specification: de._specification };
        }
      }
      function Uf(Ie) {
        let de = null;
        if (Ie instanceof Pf)
          de = Uf(Ie.result);
        else if (Ie instanceof Qs) {
          for (const Ce of Ie.args)
            if (de = Uf(Ce), de)
              break;
        } else
          (Ie instanceof Cu || Ie instanceof Vl) && Ie.input instanceof bl && Ie.input.name === "zoom" && (de = Ie);
        return de instanceof hc || Ie.eachChild((Ce) => {
          const De = Uf(Ce);
          De instanceof hc ? de = De : de && De && de !== De && (de = new hc("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
        }), de;
      }
      var jf, gc, H0 = function() {
        if (gc)
          return jf;
        gc = 1, jf = de;
        var Ie = 3;
        function de(Ce, De, Ke) {
          var Ve = this.cells = [];
          if (Ce instanceof ArrayBuffer) {
            this.arrayBuffer = Ce;
            var er = new Int32Array(this.arrayBuffer);
            Ce = er[0], this.d = (De = er[1]) + 2 * (Ke = er[2]);
            for (var fr = 0; fr < this.d * this.d; fr++) {
              var wr = er[Ie + fr], kr = er[Ie + fr + 1];
              Ve.push(wr === kr ? null : er.subarray(wr, kr));
            }
            var cr = er[Ie + Ve.length + 1];
            this.keys = er.subarray(er[Ie + Ve.length], cr), this.bboxes = er.subarray(cr), this.insert = this._insertReadonly;
          } else {
            this.d = De + 2 * Ke;
            for (var Mr = 0; Mr < this.d * this.d; Mr++)
              Ve.push([]);
            this.keys = [], this.bboxes = [];
          }
          this.n = De, this.extent = Ce, this.padding = Ke, this.scale = De / Ce, this.uid = 0;
          var Er = Ke / De * Ce;
          this.min = -Er, this.max = Ce + Er;
        }
        return de.prototype.insert = function(Ce, De, Ke, Ve, er) {
          this._forEachCell(De, Ke, Ve, er, this._insertCell, this.uid++), this.keys.push(Ce), this.bboxes.push(De), this.bboxes.push(Ke), this.bboxes.push(Ve), this.bboxes.push(er);
        }, de.prototype._insertReadonly = function() {
          throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
        }, de.prototype._insertCell = function(Ce, De, Ke, Ve, er, fr) {
          this.cells[er].push(fr);
        }, de.prototype.query = function(Ce, De, Ke, Ve, er) {
          var fr = this.min, wr = this.max;
          if (Ce <= fr && De <= fr && wr <= Ke && wr <= Ve && !er)
            return Array.prototype.slice.call(this.keys);
          var kr = [];
          return this._forEachCell(Ce, De, Ke, Ve, this._queryCell, kr, {}, er), kr;
        }, de.prototype._queryCell = function(Ce, De, Ke, Ve, er, fr, wr, kr) {
          var cr = this.cells[er];
          if (cr !== null)
            for (var Mr = this.keys, Er = this.bboxes, xr = 0; xr < cr.length; xr++) {
              var Sr = cr[xr];
              if (wr[Sr] === void 0) {
                var Br = 4 * Sr;
                (kr ? kr(Er[Br + 0], Er[Br + 1], Er[Br + 2], Er[Br + 3]) : Ce <= Er[Br + 2] && De <= Er[Br + 3] && Ke >= Er[Br + 0] && Ve >= Er[Br + 1]) ? (wr[Sr] = !0, fr.push(Mr[Sr])) : wr[Sr] = !1;
              }
            }
        }, de.prototype._forEachCell = function(Ce, De, Ke, Ve, er, fr, wr, kr) {
          for (var cr = this._convertToCellCoord(Ce), Mr = this._convertToCellCoord(De), Er = this._convertToCellCoord(Ke), xr = this._convertToCellCoord(Ve), Sr = cr; Sr <= Er; Sr++)
            for (var Br = Mr; Br <= xr; Br++) {
              var Fr = this.d * Br + Sr;
              if ((!kr || kr(this._convertFromCellCoord(Sr), this._convertFromCellCoord(Br), this._convertFromCellCoord(Sr + 1), this._convertFromCellCoord(Br + 1))) && er.call(this, Ce, De, Ke, Ve, Fr, fr, wr, kr))
                return;
            }
        }, de.prototype._convertFromCellCoord = function(Ce) {
          return (Ce - this.padding) / this.scale;
        }, de.prototype._convertToCellCoord = function(Ce) {
          return Math.max(0, Math.min(this.d - 1, Math.floor(Ce * this.scale) + this.padding));
        }, de.prototype.toArrayBuffer = function() {
          if (this.arrayBuffer)
            return this.arrayBuffer;
          for (var Ce = this.cells, De = Ie + this.cells.length + 1 + 1, Ke = 0, Ve = 0; Ve < this.cells.length; Ve++)
            Ke += this.cells[Ve].length;
          var er = new Int32Array(De + Ke + this.keys.length + this.bboxes.length);
          er[0] = this.extent, er[1] = this.n, er[2] = this.padding;
          for (var fr = De, wr = 0; wr < Ce.length; wr++) {
            var kr = Ce[wr];
            er[Ie + wr] = fr, er.set(kr, fr), fr += kr.length;
          }
          return er[Ie + Ce.length] = fr, er.set(this.keys, fr), er[Ie + Ce.length + 1] = fr += this.keys.length, er.set(this.bboxes, fr), fr += this.bboxes.length, er.buffer;
        }, jf;
      }(), ah = rr(H0);
      const Nd = {};
      function Ao(Ie, de, Ce = {}) {
        Object.defineProperty(Ie, "_classRegistryKey", { value: de, writable: !1 }), Nd[de] = { klass: Ie, omit: Ce.omit || [] };
      }
      Ao(Object, "Object"), ah.serialize = function(Ie, de) {
        const Ce = Ie.toArrayBuffer();
        return de && de.add(Ce), { buffer: Ce };
      }, ah.deserialize = function(Ie) {
        return new ah(Ie.buffer);
      }, Object.defineProperty(ah, "name", { value: "Grid" }), Ao(ah, "Grid"), typeof DOMMatrix < "u" && Ao(DOMMatrix, "DOMMatrix"), Ao(Ca, "Color"), Ao(Error, "Error"), Ao(Ys, "Formatted"), Ao(Rs, "FormattedSection"), Ao(hs, "AJAXError"), Ao(Ps, "ResolvedImage"), Ao(Gc, "StylePropertyFunction"), Ao(mc, "StyleExpression", { omit: ["_evaluator"] }), Ao(yl, "ImageIdWithOptions"), Ao(Wh, "ZoomDependentExpression"), Ao(Vf, "ZoomConstantExpression"), Ao(bl, "CompoundExpression", { omit: ["_evaluate"] });
      for (const Ie in oh)
        Nd[oh[Ie]._classRegistryKey] || Ao(oh[Ie], `Expression${Ie}`);
      function Gm(Ie) {
        return Ie && typeof ArrayBuffer < "u" && (Ie instanceof ArrayBuffer || Ie.constructor && Ie.constructor.name === "ArrayBuffer");
      }
      function ku(Ie) {
        return self.ImageBitmap && Ie instanceof ImageBitmap;
      }
      function Lu(Ie, de) {
        if (Ie == null || typeof Ie == "boolean" || typeof Ie == "number" || typeof Ie == "string" || Ie instanceof Boolean || Ie instanceof Number || Ie instanceof String || Ie instanceof Date || Ie instanceof RegExp)
          return Ie;
        if (Gm(Ie) || ku(Ie))
          return de && de.add(Ie), Ie;
        if (ArrayBuffer.isView(Ie))
          return de && de.add(Ie.buffer), Ie;
        if (Ie instanceof ImageData)
          return de && de.add(Ie.data.buffer), Ie;
        if (Array.isArray(Ie)) {
          const Ce = [];
          for (const De of Ie)
            Ce.push(Lu(De, de));
          return Ce;
        }
        if (Ie instanceof Map) {
          const Ce = { $name: "Map" };
          for (const [De, Ke] of Ie.entries())
            Ce[De] = Lu(Ke);
          return Ce;
        }
        if (Ie instanceof Set) {
          const Ce = { $name: "Set" };
          let De = 0;
          for (const Ke of Ie.values())
            Ce[++De] = Lu(Ke);
          return Ce;
        }
        if (typeof Ie == "object") {
          const Ce = Ie.constructor, De = Ce._classRegistryKey;
          if (!De)
            throw new Error(`Can't serialize object of unregistered class "${De}".`);
          const Ke = Ce.serialize ? Ce.serialize(Ie, de) : {};
          if (!Ce.serialize) {
            for (const Ve in Ie)
              Ie.hasOwnProperty(Ve) && (Nd[De].omit.indexOf(Ve) >= 0 || (Ke[Ve] = Lu(Ie[Ve], de)));
            Ie instanceof Error && (Ke.message = Ie.message);
          }
          if (Ke.$name)
            throw new Error("$name property is reserved for worker serialization logic.");
          return De !== "Object" && (Ke.$name = De), Ke;
        }
        throw new Error("can't serialize object of type " + typeof Ie);
      }
      function lh(Ie) {
        if (Ie == null || typeof Ie == "boolean" || typeof Ie == "number" || typeof Ie == "string" || Ie instanceof Boolean || Ie instanceof Number || Ie instanceof String || Ie instanceof Date || Ie instanceof RegExp || Gm(Ie) || ku(Ie) || ArrayBuffer.isView(Ie) || Ie instanceof ImageData)
          return Ie;
        if (Array.isArray(Ie))
          return Ie.map(lh);
        if (typeof Ie == "object") {
          const de = Ie.$name || "Object";
          if (de === "Map") {
            const Ke = /* @__PURE__ */ new Map();
            for (const Ve of Object.keys(Ie))
              Ve !== "$name" && Ke.set(Ve, lh(Ie[Ve]));
            return Ke;
          }
          if (de === "Set") {
            const Ke = /* @__PURE__ */ new Set();
            for (const Ve of Object.keys(Ie))
              Ve !== "$name" && Ke.add(lh(Ie[Ve]));
            return Ke;
          }
          const { klass: Ce } = Nd[de];
          if (!Ce)
            throw new Error(`Can't deserialize unregistered class "${de}".`);
          if (Ce.deserialize)
            return Ce.deserialize(Ie);
          const De = Object.create(Ce.prototype);
          for (const Ke of Object.keys(Ie))
            Ke !== "$name" && (De[Ke] = lh(Ie[Ke]));
          return De;
        }
        throw new Error("can't deserialize object of type " + typeof Ie);
      }
      const Do = { "Latin-1 Supplement": (Ie) => Ie >= 128 && Ie <= 255, Arabic: (Ie) => Ie >= 1536 && Ie <= 1791, "Arabic Supplement": (Ie) => Ie >= 1872 && Ie <= 1919, "Arabic Extended-A": (Ie) => Ie >= 2208 && Ie <= 2303, "Hangul Jamo": (Ie) => Ie >= 4352 && Ie <= 4607, "Unified Canadian Aboriginal Syllabics": (Ie) => Ie >= 5120 && Ie <= 5759, Khmer: (Ie) => Ie >= 6016 && Ie <= 6143, "Unified Canadian Aboriginal Syllabics Extended": (Ie) => Ie >= 6320 && Ie <= 6399, "General Punctuation": (Ie) => Ie >= 8192 && Ie <= 8303, "Letterlike Symbols": (Ie) => Ie >= 8448 && Ie <= 8527, "Number Forms": (Ie) => Ie >= 8528 && Ie <= 8591, "Miscellaneous Technical": (Ie) => Ie >= 8960 && Ie <= 9215, "Control Pictures": (Ie) => Ie >= 9216 && Ie <= 9279, "Optical Character Recognition": (Ie) => Ie >= 9280 && Ie <= 9311, "Enclosed Alphanumerics": (Ie) => Ie >= 9312 && Ie <= 9471, "Geometric Shapes": (Ie) => Ie >= 9632 && Ie <= 9727, "Miscellaneous Symbols": (Ie) => Ie >= 9728 && Ie <= 9983, "Miscellaneous Symbols and Arrows": (Ie) => Ie >= 11008 && Ie <= 11263, "CJK Radicals Supplement": (Ie) => Ie >= 11904 && Ie <= 12031, "Kangxi Radicals": (Ie) => Ie >= 12032 && Ie <= 12255, "Ideographic Description Characters": (Ie) => Ie >= 12272 && Ie <= 12287, "CJK Symbols and Punctuation": (Ie) => Ie >= 12288 && Ie <= 12351, Hiragana: (Ie) => Ie >= 12352 && Ie <= 12447, Katakana: (Ie) => Ie >= 12448 && Ie <= 12543, Bopomofo: (Ie) => Ie >= 12544 && Ie <= 12591, "Hangul Compatibility Jamo": (Ie) => Ie >= 12592 && Ie <= 12687, Kanbun: (Ie) => Ie >= 12688 && Ie <= 12703, "Bopomofo Extended": (Ie) => Ie >= 12704 && Ie <= 12735, "CJK Strokes": (Ie) => Ie >= 12736 && Ie <= 12783, "Katakana Phonetic Extensions": (Ie) => Ie >= 12784 && Ie <= 12799, "Enclosed CJK Letters and Months": (Ie) => Ie >= 12800 && Ie <= 13055, "CJK Compatibility": (Ie) => Ie >= 13056 && Ie <= 13311, "CJK Unified Ideographs Extension A": (Ie) => Ie >= 13312 && Ie <= 19903, "Yijing Hexagram Symbols": (Ie) => Ie >= 19904 && Ie <= 19967, "CJK Unified Ideographs": (Ie) => Ie >= 19968 && Ie <= 40959, "Yi Syllables": (Ie) => Ie >= 40960 && Ie <= 42127, "Yi Radicals": (Ie) => Ie >= 42128 && Ie <= 42191, "Hangul Jamo Extended-A": (Ie) => Ie >= 43360 && Ie <= 43391, "Hangul Syllables": (Ie) => Ie >= 44032 && Ie <= 55215, "Hangul Jamo Extended-B": (Ie) => Ie >= 55216 && Ie <= 55295, "Private Use Area": (Ie) => Ie >= 57344 && Ie <= 63743, "CJK Compatibility Ideographs": (Ie) => Ie >= 63744 && Ie <= 64255, "Arabic Presentation Forms-A": (Ie) => Ie >= 64336 && Ie <= 65023, "Vertical Forms": (Ie) => Ie >= 65040 && Ie <= 65055, "CJK Compatibility Forms": (Ie) => Ie >= 65072 && Ie <= 65103, "Small Form Variants": (Ie) => Ie >= 65104 && Ie <= 65135, "Arabic Presentation Forms-B": (Ie) => Ie >= 65136 && Ie <= 65279, "Halfwidth and Fullwidth Forms": (Ie) => Ie >= 65280 && Ie <= 65519, Osage: (Ie) => Ie >= 66736 && Ie <= 66815, "CJK Unified Ideographs Extension B": (Ie) => Ie >= 131072 && Ie <= 173791 };
      function Zh(Ie) {
        for (const de of Ie)
          if (qf(de.charCodeAt(0)))
            return !0;
        return !1;
      }
      function Xh(Ie) {
        for (const de of Ie)
          if (!Vd(de.charCodeAt(0)))
            return !1;
        return !0;
      }
      function Vd(Ie) {
        return !(Do.Arabic(Ie) || Do["Arabic Supplement"](Ie) || Do["Arabic Extended-A"](Ie) || Do["Arabic Presentation Forms-A"](Ie) || Do["Arabic Presentation Forms-B"](Ie));
      }
      function qf(Ie) {
        return !(Ie !== 746 && Ie !== 747 && (Ie < 4352 || !(Do["Bopomofo Extended"](Ie) || Do.Bopomofo(Ie) || Do["CJK Compatibility Forms"](Ie) && !(Ie >= 65097 && Ie <= 65103) || Do["CJK Compatibility Ideographs"](Ie) || Do["CJK Compatibility"](Ie) || Do["CJK Radicals Supplement"](Ie) || Do["CJK Strokes"](Ie) || !(!Do["CJK Symbols and Punctuation"](Ie) || Ie >= 12296 && Ie <= 12305 || Ie >= 12308 && Ie <= 12319 || Ie === 12336) || Do["CJK Unified Ideographs Extension A"](Ie) || Do["CJK Unified Ideographs"](Ie) || Do["Enclosed CJK Letters and Months"](Ie) || Do["Hangul Compatibility Jamo"](Ie) || Do["Hangul Jamo Extended-A"](Ie) || Do["Hangul Jamo Extended-B"](Ie) || Do["Hangul Jamo"](Ie) || Do["Hangul Syllables"](Ie) || Do.Hiragana(Ie) || Do["Ideographic Description Characters"](Ie) || Do.Kanbun(Ie) || Do["Kangxi Radicals"](Ie) || Do["Katakana Phonetic Extensions"](Ie) || Do.Katakana(Ie) && Ie !== 12540 || !(!Do["Halfwidth and Fullwidth Forms"](Ie) || Ie === 65288 || Ie === 65289 || Ie === 65293 || Ie >= 65306 && Ie <= 65310 || Ie === 65339 || Ie === 65341 || Ie === 65343 || Ie >= 65371 && Ie <= 65503 || Ie === 65507 || Ie >= 65512 && Ie <= 65519) || !(!Do["Small Form Variants"](Ie) || Ie >= 65112 && Ie <= 65118 || Ie >= 65123 && Ie <= 65126) || Do["Unified Canadian Aboriginal Syllabics"](Ie) || Do["Unified Canadian Aboriginal Syllabics Extended"](Ie) || Do["Vertical Forms"](Ie) || Do["Yijing Hexagram Symbols"](Ie) || Do["Yi Syllables"](Ie) || Do["Yi Radicals"](Ie))));
      }
      function Ud(Ie) {
        return !(qf(Ie) || function(de) {
          return !!(Do["Latin-1 Supplement"](de) && (de === 167 || de === 169 || de === 174 || de === 177 || de === 188 || de === 189 || de === 190 || de === 215 || de === 247) || Do["General Punctuation"](de) && (de === 8214 || de === 8224 || de === 8225 || de === 8240 || de === 8241 || de === 8251 || de === 8252 || de === 8258 || de === 8263 || de === 8264 || de === 8265 || de === 8273) || Do["Letterlike Symbols"](de) || Do["Number Forms"](de) || Do["Miscellaneous Technical"](de) && (de >= 8960 && de <= 8967 || de >= 8972 && de <= 8991 || de >= 8996 && de <= 9e3 || de === 9003 || de >= 9085 && de <= 9114 || de >= 9150 && de <= 9165 || de === 9167 || de >= 9169 && de <= 9179 || de >= 9186 && de <= 9215) || Do["Control Pictures"](de) && de !== 9251 || Do["Optical Character Recognition"](de) || Do["Enclosed Alphanumerics"](de) || Do["Geometric Shapes"](de) || Do["Miscellaneous Symbols"](de) && !(de >= 9754 && de <= 9759) || Do["Miscellaneous Symbols and Arrows"](de) && (de >= 11026 && de <= 11055 || de >= 11088 && de <= 11097 || de >= 11192 && de <= 11243) || Do["CJK Symbols and Punctuation"](de) || Do.Katakana(de) || Do["Private Use Area"](de) || Do["CJK Compatibility Forms"](de) || Do["Small Form Variants"](de) || Do["Halfwidth and Fullwidth Forms"](de) || de === 8734 || de === 8756 || de === 8757 || de >= 9984 && de <= 10087 || de >= 10102 && de <= 10131 || de === 65532 || de === 65533);
        }(Ie));
      }
      function Gf(Ie) {
        return Ie >= 1424 && Ie <= 2303 || Do["Arabic Presentation Forms-A"](Ie) || Do["Arabic Presentation Forms-B"](Ie);
      }
      function Hc(Ie, de) {
        return !(!de && Gf(Ie) || Ie >= 2304 && Ie <= 3583 || Ie >= 3840 && Ie <= 4255 || Do.Khmer(Ie));
      }
      function jp(Ie) {
        for (const de of Ie)
          if (Gf(de.charCodeAt(0)))
            return !0;
        return !1;
      }
      const Sl = "deferred", Ul = "loading", qp = "loaded";
      let jd = null, kl = "unavailable", Ll = null;
      const Wc = function(Ie) {
        Ie && typeof Ie == "string" && Ie.indexOf("NetworkError") > -1 && (kl = "error"), jd && jd(Ie);
      };
      function uh() {
        Hf.fire(new Nc("pluginStateChange", { pluginStatus: kl, pluginURL: Ll }));
      }
      const Hf = new Ih(), Yh = function() {
        return kl;
      }, Hm = function() {
        if (kl !== Sl || !Ll)
          throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
        kl = Ul, uh(), Ll && wu({ url: Ll }, (Ie) => {
          Ie ? Wc(Ie) : (kl = qp, uh());
        });
      }, Il = { applyArabicShaping: null, processBidirectionalText: null, processStyledBidirectionalText: null, isLoaded: () => kl === qp || Il.applyArabicShaping != null, isLoading: () => kl === Ul, setState(Ie) {
        kl = Ie.pluginStatus, Ll = Ie.pluginURL;
      }, isParsed: () => Il.applyArabicShaping != null && Il.processBidirectionalText != null && Il.processStyledBidirectionalText != null, getPluginURL: () => Ll };
      class wa {
        constructor(de, Ce) {
          this.zoom = de, Ce ? (this.now = Ce.now, this.fadeDuration = Ce.fadeDuration, this.transition = Ce.transition, this.pitch = Ce.pitch, this.brightness = Ce.brightness) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
        }
        isSupportedScript(de) {
          return function(Ce, De) {
            for (const Ke of Ce)
              if (!Hc(Ke.charCodeAt(0), De))
                return !1;
            return !0;
          }(de, Il.isLoaded());
        }
      }
      class hh {
        constructor(de, Ce, De, Ke) {
          this.property = de, this.value = Ce, this.expression = function(Ve, er, fr, wr) {
            if (Nf(Ve))
              return new Gc(Ve, er);
            if (Up(Ve) || Array.isArray(Ve) && Ve.length > 0) {
              const kr = qm(Ve, er, fr, wr);
              if (kr.result === "error")
                throw new Error(kr.value.map((cr) => `${cr.key}: ${cr.message}`).join(", "));
              return kr.value;
            }
            {
              let kr = Ve;
              return typeof Ve == "string" && er.type === "color" && (kr = Ca.parse(Ve)), { kind: "constant", configDependencies: /* @__PURE__ */ new Set(), evaluate: () => kr };
            }
          }(Ce === void 0 ? de.specification.default : Ce, de.specification, De, Ke);
        }
        isDataDriven() {
          return this.expression.kind === "source" || this.expression.kind === "composite";
        }
        possiblyEvaluate(de, Ce, De) {
          return this.property.possiblyEvaluate(this, de, Ce, De);
        }
      }
      class fh {
        constructor(de, Ce, De) {
          this.property = de, this.value = new hh(de, void 0, Ce, De);
        }
        transitioned(de, Ce) {
          return new Wf(this.property, this.value, Ce, Yn({}, de.transition, this.transition), de.now);
        }
        untransitioned() {
          return new Wf(this.property, this.value, null, {}, 0);
        }
      }
      class El {
        constructor(de, Ce, De) {
          this._properties = de, this._values = Object.create(de.defaultTransitionablePropertyValues), this._scope = Ce, this._options = De, this.configDependencies = /* @__PURE__ */ new Set();
        }
        getValue(de) {
          return un(this._values[de].value.value);
        }
        setValue(de, Ce) {
          this._values.hasOwnProperty(de) || (this._values[de] = new fh(this._values[de].property, this._scope, this._options)), this._values[de].value = new hh(this._values[de].property, Ce === null ? void 0 : un(Ce), this._scope, this._options), this._values[de].value.expression.configDependencies && (this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._values[de].value.expression.configDependencies]));
        }
        setTransitionOrValue(de, Ce) {
          Ce && (this._options = Ce);
          const De = this._properties.properties;
          if (de)
            for (const Ke in de) {
              const Ve = de[Ke];
              if (Li(Ke, "-transition")) {
                const er = Ke.slice(0, -11);
                De[er] && this.setTransition(er, Ve);
              } else
                De.hasOwnProperty(Ke) && this.setValue(Ke, Ve);
            }
        }
        getTransition(de) {
          return un(this._values[de].transition);
        }
        setTransition(de, Ce) {
          this._values.hasOwnProperty(de) || (this._values[de] = new fh(this._values[de].property)), this._values[de].transition = un(Ce) || void 0;
        }
        serialize() {
          const de = {};
          for (const Ce of Object.keys(this._values)) {
            const De = this.getValue(Ce);
            De !== void 0 && (de[Ce] = De);
            const Ke = this.getTransition(Ce);
            Ke !== void 0 && (de[`${Ce}-transition`] = Ke);
          }
          return de;
        }
        transitioned(de, Ce) {
          const De = new qd(this._properties);
          for (const Ke of Object.keys(this._values))
            De._values[Ke] = this._values[Ke].transitioned(de, Ce._values[Ke]);
          return De;
        }
        untransitioned() {
          const de = new qd(this._properties);
          for (const Ce of Object.keys(this._values))
            de._values[Ce] = this._values[Ce].untransitioned();
          return de;
        }
      }
      class Wf {
        constructor(de, Ce, De, Ke, Ve) {
          const er = Ke.delay || 0, fr = Ke.duration || 0;
          Ve = Ve || 0, this.property = de, this.value = Ce, this.begin = Ve + er, this.end = this.begin + fr, de.specification.transition && (Ke.delay || Ke.duration) && (this.prior = De);
        }
        possiblyEvaluate(de, Ce, De) {
          const Ke = de.now || 0, Ve = this.value.possiblyEvaluate(de, Ce, De), er = this.prior;
          if (er) {
            if (Ke > this.end)
              return this.prior = null, Ve;
            if (this.value.isDataDriven())
              return this.prior = null, Ve;
            if (Ke < this.begin)
              return er.possiblyEvaluate(de, Ce, De);
            {
              const fr = (Ke - this.begin) / (this.end - this.begin);
              return this.property.interpolate(er.possiblyEvaluate(de, Ce, De), Ve, In(fr));
            }
          }
          return Ve;
        }
      }
      class qd {
        constructor(de) {
          this._properties = de, this._values = Object.create(de.defaultTransitioningPropertyValues);
        }
        possiblyEvaluate(de, Ce, De) {
          const Ke = new Zs(this._properties);
          for (const Ve of Object.keys(this._values))
            Ke._values[Ve] = this._values[Ve].possiblyEvaluate(de, Ce, De);
          return Ke;
        }
        hasTransition() {
          for (const de of Object.keys(this._values))
            if (this._values[de].prior)
              return !0;
          return !1;
        }
      }
      class ph {
        constructor(de, Ce, De) {
          this._properties = de, this._values = Object.create(de.defaultPropertyValues), this._scope = Ce, this._options = De, this.configDependencies = /* @__PURE__ */ new Set();
        }
        getValue(de) {
          return un(this._values[de].value);
        }
        setValue(de, Ce) {
          this._values[de] = new hh(this._values[de].property, Ce === null ? void 0 : un(Ce), this._scope, this._options), this._values[de].expression.configDependencies && (this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._values[de].expression.configDependencies]));
        }
        serialize() {
          const de = {};
          for (const Ce of Object.keys(this._values)) {
            const De = this.getValue(Ce);
            De !== void 0 && (de[Ce] = De);
          }
          return de;
        }
        possiblyEvaluate(de, Ce, De) {
          const Ke = new Zs(this._properties);
          for (const Ve of Object.keys(this._values))
            Ke._values[Ve] = this._values[Ve].possiblyEvaluate(de, Ce, De);
          return Ke;
        }
      }
      class mh {
        constructor(de, Ce, De) {
          this.property = de, this.value = Ce, this.parameters = De;
        }
        isConstant() {
          return this.value.kind === "constant";
        }
        constantOr(de) {
          return this.value.kind === "constant" ? this.value.value : de;
        }
        evaluate(de, Ce, De, Ke) {
          return this.property.evaluate(this.value, this.parameters, de, Ce, De, Ke);
        }
      }
      class Zs {
        constructor(de) {
          this._properties = de, this._values = Object.create(de.defaultPossiblyEvaluatedValues);
        }
        get(de) {
          return this._values[de];
        }
      }
      class lo {
        constructor(de) {
          this.specification = de;
        }
        possiblyEvaluate(de, Ce) {
          return de.expression.evaluate(Ce);
        }
        interpolate(de, Ce, De) {
          const Ke = xa[this.specification.type];
          return Ke ? Ke(de, Ce, De) : de;
        }
      }
      class Mo {
        constructor(de, Ce) {
          this.specification = de, this.overrides = Ce;
        }
        possiblyEvaluate(de, Ce, De, Ke) {
          return new mh(this, de.expression.kind === "constant" || de.expression.kind === "camera" ? { kind: "constant", value: de.expression.evaluate(Ce, null, {}, De, Ke) } : de.expression, Ce);
        }
        interpolate(de, Ce, De) {
          if (de.value.kind !== "constant" || Ce.value.kind !== "constant")
            return de;
          if (de.value.value === void 0 || Ce.value.value === void 0)
            return new mh(this, { kind: "constant", value: void 0 }, de.parameters);
          const Ke = xa[this.specification.type];
          return Ke ? new mh(this, { kind: "constant", value: Ke(de.value.value, Ce.value.value, De) }, de.parameters) : de;
        }
        evaluate(de, Ce, De, Ke, Ve, er) {
          return de.kind === "constant" ? de.value : de.evaluate(Ce, De, Ke, Ve, er);
        }
      }
      class Jh {
        constructor(de) {
          this.specification = de;
        }
        possiblyEvaluate(de, Ce, De, Ke) {
          return !!de.expression.evaluate(Ce, null, {}, De, Ke);
        }
        interpolate() {
          return !1;
        }
      }
      class ys {
        constructor(de) {
          this.properties = de, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
          const Ce = new wa(0, {});
          for (const De in de) {
            const Ke = de[De];
            Ke.specification.overridable && this.overridableProperties.push(De);
            const Ve = this.defaultPropertyValues[De] = new hh(Ke, void 0), er = this.defaultTransitionablePropertyValues[De] = new fh(Ke);
            this.defaultTransitioningPropertyValues[De] = er.untransitioned(), this.defaultPossiblyEvaluatedValues[De] = Ve.possiblyEvaluate(Ce);
          }
        }
      }
      Ao(Mo, "DataDrivenProperty"), Ao(lo, "DataConstantProperty"), Ao(Jh, "ColorRampProperty");
      var Bn = JSON.parse('{"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"required":false,"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"snow":{"type":"snow","experimental":true},"rain":{"type":"rain","experimental":true},"camera":{"type":"camera"},"color-theme":{"type":"colorTheme"},"indoor":{"type":"indoor","experimental":true},"imports":{"type":"array","value":"import"},"schema":{"type":"schema"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"required":true,"type":"array","value":"layer"},"models":{"type":"models"},"featuresets":{"experimental":true,"type":"featuresets"}},"featuresets":{"experimental":true,"*":{"type":"featureset"}},"featureset":{"experimental":true,"metadata":{"type":"*"},"selectors":{"type":"array","value":"selector"}},"selector":{"experimental":true,"layer":{"type":"string","required":true},"properties":{"type":"selectorProperty","required":false},"featureNamespace":{"type":"string","required":false}},"selectorProperty":{"experimental":true,"*":{"type":"*"}},"model":{"type":"string","required":true},"import":{"id":{"type":"string","required":true},"url":{"type":"string","required":true},"config":{"type":"config"},"data":{"type":"$root"},"color-theme":{"type":"colorTheme","optional":true}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"default":{"type":"*","property-type":"data-constant","expression":{},"required":true},"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1}},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"values":{"type":"array","value":"*"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"id":{"type":"string","required":true},"properties":{"type":"properties"},"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"cast-shadows":{"type":"boolean","default":false,"property-type":"data-constant"},"shadow-quality":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"expression":{"parameters":["zoom"]},"experimental":true},"shadow-intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_ambient":{"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":1,"mapbox":1},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"experimental":true,"type":{"required":true,"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"},"dynamic":{"type":"boolean","default":false}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":1}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":1}},"url":{"required":false,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_model":{"type":{"required":true,"type":"enum","values":{"model":1,"batched-model":1}},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"raster-particle":{"experimental":true},"hillshade":{},"model":{"experimental":true},"background":{},"sky":{},"slot":{},"clip":{}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_clip","layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_raster-particle","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_model":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"model-id":{"type":"string","default":"","property-type":"data-driven","expression":{"parameters":["zoom","feature"]}}},"layout_clip":{"clip-layer-types":{"type":"array","value":"enum","values":{"model":1,"symbol":1},"default":[],"expression":{},"property-type":"data-constant"},"clip-layer-scope":{"type":"array","value":"string","default":[],"expression":{},"property-type":"data-constant"}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"fill-elevation-reference":{"type":"enum","values":{"none":1,"hd-road-base":1,"hd-road-markup":1},"default":"none","experimental":true,"private":true,"expression":{},"property-type":"data-constant"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"fill-extrusion-edge-radius":{"type":"number","experimental":true,"default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"constant"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":1,"round":1,"square":1},"default":"butt","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":1,"round":1,"miter":1,"none":1},"default":"miter","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-z-offset":{"type":"number","experimental":true,"default":0,"expression":{"parameters":["zoom","feature","line-progress"]},"property-type":"data-driven"},"line-elevation-reference":{"type":"enum","values":{"none":1,"sea":1,"ground":1,"hd-road-markup":1},"default":"none","experimental":true,"expression":{},"property-type":"data-constant"},"line-cross-slope":{"type":"number","experimental":true,"expression":{},"property-type":"constant"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"line-width-unit":{"type":"enum","values":{"pixels":1,"meters":1},"default":"pixels","experimental":true,"private":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":1,"line":1,"line-center":1},"default":"point","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":1,"viewport-y":1,"source":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-elevation-reference":{"type":"enum","values":{"sea":1,"ground":1,"hd-road-markup":1},"default":"ground","experimental":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-size":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":0.1,"maximum":10,"experimental":true,"private":true,"expression":{},"property-type":"data-constant"},"icon-text-fit":{"type":"enum","values":{"none":1,"width":1,"height":1,"both":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":0.1,"maximum":10,"experimental":true,"private":true,"expression":{},"property-type":"data-constant"},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":1,"left":1,"center":1,"right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-transform":{"type":"enum","values":{"none":1,"uppercase":1,"lowercase":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster-particle":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_hillshade":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster-particle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_clip":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_model":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":1,"exponential":1,"interval":1,"categorical":1},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":1,"lab":1,"hcl":1},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"high-color":{"type":"color","property-type":"data-constant","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"space-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"horizon-blend":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"star-intensity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"snow":{"density":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],11,0,13,0.85],"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"opacity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],11,0,13,0.3],"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette-color":{"type":"color","property-type":"data-constant","default":"#ffffff","experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"center-thinning":{"type":"number","property-type":"data-constant","default":0.4,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,50],"minimum":0,"maximum":360,"length":2,"value":"number","property-type":"data-constant","transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"flake-size":{"type":"number","property-type":"data-constant","default":0.71,"minimum":0,"maximum":5,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true}},"rain":{"density":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],11,0,13,0.5],"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["measure-light","brightness"],0,"#03113d",0.3,"#a8adbc"],"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"opacity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["measure-light","brightness"],0,0.88,1,0.7],"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],11,0,13,1],"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["measure-light","brightness"],0,"#001736",0.3,"#464646"],"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"center-thinning":{"type":"number","property-type":"data-constant","default":0.57,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,80],"minimum":0,"maximum":360,"length":2,"value":"number","property-type":"data-constant","transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"droplet-size":{"type":"array","default":[2.6,18.2],"minimum":0,"maximum":50,"length":2,"value":"number","property-type":"data-constant","transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"distortion-strength":{"type":"number","property-type":"data-constant","default":0.7,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true}},"camera":{"camera-projection":{"type":"enum","values":{"perspective":1,"orthographic":1},"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"default":"perspective","property-type":"data-constant"}},"colorTheme":{"data":{"type":"string","property-type":"data-constant","expression":{}}},"indoor":{"floorplanFeaturesetId":{"type":"string","experimental":true,"property-type":"data-constant","expression":{}},"buildingFeaturesetId":{"type":"string","experimental":true,"property-type":"data-constant","expression":{}}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1},"default":"mercator","required":true},"center":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-180,-90],"maximum":[180,90]},"parallels":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-90,-90],"maximum":[90,90]}},"terrain":{"source":{"type":"string","required":true},"exaggeration":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_raster-particle","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"fill-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-height-alignment":{"type":"enum","experimental":true,"values":{"terrain":1,"flat":1},"default":"flat","property-type":"data-constant"},"fill-extrusion-base-alignment":{"type":"enum","experimental":true,"values":{"terrain":1,"flat":1},"default":"terrain","property-type":"data-constant"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-ambient-occlusion-intensity":{"property-type":"data-constant","type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"property-type":"data-constant","type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-wall-radius":{"property-type":"data-constant","type":"number","experimental":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-radius":{"property-type":"data-constant","type":"number","experimental":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-attenuation":{"property-type":"data-constant","type":"number","experimental":true,"default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-flood-light-color":{"property-type":"data-constant","type":"color","experimental":true,"default":"#ffffff","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-intensity":{"property-type":"data-constant","type":"number","experimental":true,"default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-wall-radius":{"property-type":"data-driven","type":"number","experimental":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-radius":{"property-type":"data-driven","type":"number","experimental":true,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-attenuation":{"property-type":"data-constant","type":"number","experimental":true,"default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-vertical-scale":{"property-type":"data-constant","type":"number","experimental":true,"default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-rounded-roof":{"property-type":"data-constant","type":"boolean","default":true,"experimental":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"fill-extrusion-line-width":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-cast-shadows":{"type":"boolean","default":true,"property-type":"data-constant"}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light","line-progress"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-gradient":{"type":"color","expression":{"interpolated":true,"parameters":["line-progress"]},"property-type":"color-ramp"},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"property-type":"constant"},"line-trim-fade-range":{"type":"array","value":"number","experimental":true,"length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-trim-color":{"type":"color","experimental":true,"default":"transparent","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-border-width":{"type":"number","private":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-border-color":{"type":"color","private":true,"default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true,"property-type":"data-constant"}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"expression":{"interpolated":true,"parameters":["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-image-cross-fade":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"transition":true},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","transition":true,"overridable":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-color-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"symbol-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-value"]},"property-type":"color-ramp"},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color-range":{"type":"array","length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-resampling":{"type":"enum","values":{"linear":1,"nearest":1},"default":"linear","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"raster-array-band":{"type":"string","required":false,"experimental":true,"property-type":"data-constant"},"raster-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_raster-particle":{"raster-particle-array-band":{"type":"string","required":false,"property-type":"data-constant"},"raster-particle-count":{"type":"number","default":512,"minimum":1,"property-type":"data-constant"},"raster-particle-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-particle-speed"]},"property-type":"color-ramp"},"raster-particle-max-speed":{"type":"number","default":1,"minimum":1,"property-type":"data-constant"},"raster-particle-speed-factor":{"type":"number","default":0.2,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-particle-fade-opacity-factor":{"type":"number","default":0.98,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-particle-reset-rate-factor":{"type":"number","default":0.8,"minimum":0,"maximum":1,"property-type":"data-constant"},"raster-particle-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-accent-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_background":{"background-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":[]},"experimental":true,"property-type":"data-constant"},"background-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":1,"atmosphere":1},"default":"atmosphere","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100,"property-type":"data-constant"},"sky-gradient-center":{"type":"array","value":"number","default":[0,0],"length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"expression":{"interpolated":true,"parameters":["sky-radial-progress"]},"property-type":"color-ramp"},"sky-atmosphere-halo-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-atmosphere-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"property-type":"data-driven"},"model-rotation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-scale":{"type":"array","value":"number","length":3,"default":[1,1,1],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-translation":{"type":"array","value":"number","length":3,"default":[0,0,0],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-color":{"type":"color","default":"#ffffff","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":true},"model-color-mix-intensity":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-type":{"type":"enum","values":{"common-3d":1,"location-indicator":1},"default":"common-3d","property-type":"data-constant"},"model-cast-shadows":{"type":"boolean","default":true,"property-type":"data-constant"},"model-receive-shadows":{"type":"boolean","default":true,"property-type":"data-constant"},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant","transition":true},"model-emissive-strength":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state"]},"transition":true},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"model-front-cutoff":{"type":"array","private":true,"value":"number","property-type":"data-constant","expression":{"interpolated":true,"parameters":["zoom"]},"length":3,"default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1]}},"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"property-type":{"data-driven":{"type":"property-type"},"color-ramp":{"type":"property-type"},"data-constant":{"type":"property-type"},"constant":{"type":"property-type"}},"promoteId":{"*":{"type":"string"}}}');
      function Wm(Ie) {
        return Ie instanceof Number || Ie instanceof String || Ie instanceof Boolean ? Ie.valueOf() : Ie;
      }
      function Iu(Ie) {
        if (Array.isArray(Ie))
          return Ie.map(Iu);
        if (Ie instanceof Object && !(Ie instanceof Number || Ie instanceof String || Ie instanceof Boolean)) {
          const de = {};
          for (const Ce in Ie)
            de[Ce] = Iu(Ie[Ce]);
          return de;
        }
        return Wm(Ie);
      }
      function Zf(Ie) {
        if (Ie === !0 || Ie === !1)
          return !0;
        if (!Array.isArray(Ie) || Ie.length === 0)
          return !1;
        switch (Ie[0]) {
          case "has":
            return Ie.length >= 2 && Ie[1] !== "$id" && Ie[1] !== "$type";
          case "in":
            return Ie.length >= 3 && (typeof Ie[1] != "string" || Array.isArray(Ie[2]));
          case "!in":
          case "!has":
          case "none":
            return !1;
          case "==":
          case "!=":
          case ">":
          case ">=":
          case "<":
          case "<=":
            return Ie.length !== 3 || Array.isArray(Ie[1]) || Array.isArray(Ie[2]);
          case "any":
          case "all":
            for (const de of Ie.slice(1))
              if (!Zf(de) && typeof de != "boolean")
                return !1;
            return !0;
          default:
            return !0;
        }
      }
      function Zm(Ie, de = "", Ce = null, De = "fill") {
        if (Ie == null)
          return { filter: () => !0, needGeometry: !1, needFeature: !1 };
        Zf(Ie) || (Ie = Gd(Ie));
        const Ke = Ie;
        let Ve = !0;
        try {
          Ve = function(cr) {
            if (!ed(cr))
              return cr;
            let Mr = Iu(cr);
            return Qh(Mr), Mr = Xm(Mr), Mr;
          }(Ke);
        } catch {
          console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.
This is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md
and paste the contents of this message in the report.
Thank you!
Filter Expression:
${JSON.stringify(Ke, null, 2)}
        `);
        }
        let er = null, fr = null;
        if (De !== "background" && De !== "sky" && De !== "slot") {
          fr = Bn[`filter_${De}`];
          const cr = Fd(Ve, fr, de, Ce);
          if (cr.result === "error")
            throw new Error(cr.value.map((Mr) => `${Mr.key}: ${Mr.message}`).join(", "));
          er = (Mr, Er, xr) => cr.value.evaluate(Mr, Er, {}, xr);
        }
        let wr = null, kr = null;
        if (Ve !== Ke) {
          const cr = Fd(Ke, fr, de, Ce);
          if (cr.result === "error")
            throw new Error(cr.value.map((Mr) => `${Mr.key}: ${Mr.message}`).join(", "));
          wr = (Mr, Er, xr, Sr, Br) => cr.value.evaluate(Mr, Er, {}, xr, void 0, void 0, Sr, Br), kr = !rs(cr.value.expression);
        }
        return { filter: er, dynamicFilter: wr || void 0, needGeometry: Xf(Ve), needFeature: !!kr };
      }
      function Xm(Ie) {
        if (!Array.isArray(Ie))
          return Ie;
        const de = function(Ce) {
          if (W0.has(Ce[0])) {
            for (let De = 1; De < Ce.length; De++)
              if (ed(Ce[De]))
                return !0;
          }
          return Ce;
        }(Ie);
        return de === !0 ? de : de.map((Ce) => Xm(Ce));
      }
      function Qh(Ie) {
        let de = !1;
        const Ce = [];
        if (Ie[0] === "case") {
          for (let De = 1; De < Ie.length - 1; De += 2)
            de = de || ed(Ie[De]), Ce.push(Ie[De + 1]);
          Ce.push(Ie[Ie.length - 1]);
        } else if (Ie[0] === "match") {
          de = de || ed(Ie[1]);
          for (let De = 2; De < Ie.length - 1; De += 2)
            Ce.push(Ie[De + 1]);
          Ce.push(Ie[Ie.length - 1]);
        } else if (Ie[0] === "step") {
          de = de || ed(Ie[1]);
          for (let De = 1; De < Ie.length - 1; De += 2)
            Ce.push(Ie[De + 1]);
        }
        de && (Ie.length = 0, Ie.push("any", ...Ce));
        for (let De = 1; De < Ie.length; De++)
          Qh(Ie[De]);
      }
      function ed(Ie) {
        if (!Array.isArray(Ie))
          return !1;
        if ((de = Ie[0]) === "pitch" || de === "distance-from-center")
          return !0;
        var de;
        for (let Ce = 1; Ce < Ie.length; Ce++)
          if (ed(Ie[Ce]))
            return !0;
        return !1;
      }
      const W0 = /* @__PURE__ */ new Set(["in", "==", "!=", ">", ">=", "<", "<=", "to-boolean"]);
      function Bu(Ie, de) {
        return Ie < de ? -1 : Ie > de ? 1 : 0;
      }
      function Xf(Ie) {
        if (!Array.isArray(Ie))
          return !1;
        if (Ie[0] === "within" || Ie[0] === "distance")
          return !0;
        for (let de = 1; de < Ie.length; de++)
          if (Xf(Ie[de]))
            return !0;
        return !1;
      }
      function Gd(Ie) {
        if (!Ie)
          return !0;
        const de = Ie[0];
        return Ie.length <= 1 ? de !== "any" : de === "==" ? td(Ie[1], Ie[2], "==") : de === "!=" ? Ql(td(Ie[1], Ie[2], "==")) : de === "<" || de === ">" || de === "<=" || de === ">=" ? td(Ie[1], Ie[2], de) : de === "any" ? (Ce = Ie.slice(1), ["any"].concat(Ce.map(Gd))) : de === "all" ? ["all"].concat(Ie.slice(1).map(Gd)) : de === "none" ? ["all"].concat(Ie.slice(1).map(Gd).map(Ql)) : de === "in" ? Km(Ie[1], Ie.slice(2)) : de === "!in" ? Ql(Km(Ie[1], Ie.slice(2))) : de === "has" ? Gp(Ie[1]) : de !== "!has" || Ql(Gp(Ie[1]));
        var Ce;
      }
      function td(Ie, de, Ce) {
        switch (Ie) {
          case "$type":
            return [`filter-type-${Ce}`, de];
          case "$id":
            return [`filter-id-${Ce}`, de];
          default:
            return [`filter-${Ce}`, Ie, de];
        }
      }
      function Km(Ie, de) {
        if (de.length === 0)
          return !1;
        switch (Ie) {
          case "$type":
            return ["filter-type-in", ["literal", de]];
          case "$id":
            return ["filter-id-in", ["literal", de]];
          default:
            return de.length > 200 && !de.some((Ce) => typeof Ce != typeof de[0]) ? ["filter-in-large", Ie, ["literal", de.sort(Bu)]] : ["filter-in-small", Ie, ["literal", de]];
        }
      }
      function Gp(Ie) {
        switch (Ie) {
          case "$type":
            return !0;
          case "$id":
            return ["filter-has-id"];
          default:
            return ["filter-has", Ie];
        }
      }
      function Ql(Ie) {
        return ["!", Ie];
      }
      const Hd = "";
      function fl(Ie, de) {
        return de ? `${Ie}${Hd}${de}` : Ie;
      }
      const Hp = "-transition", Ym = /* @__PURE__ */ new Set(["fill", "line", "background", "hillshade", "raster"]);
      class Cl extends Ih {
        constructor(de, Ce, De, Ke, Ve) {
          if (super(), this.id = de.id, this.fqid = fl(this.id, De), this.type = de.type, this.scope = De, this.lut = Ke, this.options = Ve, this._featureFilter = { filter: () => !0, needGeometry: !1, needFeature: !1 }, this._filterCompiled = !1, this.configDependencies = /* @__PURE__ */ new Set(), de.type !== "custom") {
            if (this.metadata = de.metadata, this.minzoom = de.minzoom, this.maxzoom = de.maxzoom, de.type && de.type !== "background" && de.type !== "sky" && de.type !== "slot") {
              this.source = de.source, this.sourceLayer = de["source-layer"], this.filter = de.filter;
              const er = Fd(this.filter, Bn[`filter_${de.type}`]);
              er.result !== "error" && (this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...er.value.configDependencies]));
            }
            if (de.slot && (this.slot = de.slot), Ce.layout && (this._unevaluatedLayout = new ph(Ce.layout, this.scope, Ve), this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._unevaluatedLayout.configDependencies])), Ce.paint) {
              this._transitionablePaint = new El(Ce.paint, this.scope, Ve);
              for (const er in de.paint)
                this.setPaintProperty(er, de.paint[er]);
              for (const er in de.layout)
                this.setLayoutProperty(er, de.layout[er]);
              this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._transitionablePaint.configDependencies]), this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Zs(Ce.paint);
            }
          }
        }
        onAdd(de) {
        }
        onRemove(de) {
        }
        isDraped(de) {
          return !this.is3D() && Ym.has(this.type);
        }
        getLayoutProperty(de) {
          return de === "visibility" ? this.visibility : this._unevaluatedLayout.getValue(de);
        }
        setLayoutProperty(de, Ce) {
          if (this.type === "custom" && de === "visibility")
            return void (this.visibility = Ce);
          const De = this._unevaluatedLayout;
          De._properties.properties[de] && (De.setValue(de, Ce), this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...De.configDependencies]), de === "visibility" && this.possiblyEvaluateVisibility());
        }
        possiblyEvaluateVisibility() {
          this._unevaluatedLayout._values.visibility && (this.visibility = this._unevaluatedLayout._values.visibility.possiblyEvaluate({ zoom: 0 }));
        }
        getPaintProperty(de) {
          return Li(de, Hp) ? this._transitionablePaint.getTransition(de.slice(0, -11)) : this._transitionablePaint.getValue(de);
        }
        setPaintProperty(de, Ce) {
          const De = this._transitionablePaint, Ke = De._properties.properties;
          if (Li(de, Hp)) {
            const Mr = de.slice(0, -11);
            return Ke[Mr] && De.setTransition(Mr, Ce || void 0), !1;
          }
          if (!Ke[de])
            return !1;
          const Ve = De._values[de], er = Ve.value.isDataDriven(), fr = Ve.value;
          De.setValue(de, Ce), this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...De.configDependencies]), this._handleSpecialPaintPropertyUpdate(de);
          const wr = De._values[de].value, kr = wr.isDataDriven(), cr = Li(de, "pattern") || de === "line-dasharray";
          return kr || er || cr || this._handleOverridablePaintPropertyUpdate(de, fr, wr);
        }
        _handleSpecialPaintPropertyUpdate(de) {
        }
        getProgramIds() {
          return null;
        }
        getDefaultProgramParams(de, Ce, De) {
          return null;
        }
        _handleOverridablePaintPropertyUpdate(de, Ce, De) {
          return !1;
        }
        isHidden(de) {
          return !!(this.minzoom && de < this.minzoom) || !!(this.maxzoom && de >= this.maxzoom) || this.visibility === "none";
        }
        updateTransitions(de) {
          this._transitioningPaint = this._transitionablePaint.transitioned(de, this._transitioningPaint);
        }
        hasTransition() {
          return this._transitioningPaint.hasTransition();
        }
        recalculate(de, Ce) {
          this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(de, void 0, Ce)), this.paint = this._transitioningPaint.possiblyEvaluate(de, void 0, Ce);
        }
        serialize() {
          return zn({ id: this.id, type: this.type, slot: this.slot, source: this.source, "source-layer": this.sourceLayer, metadata: this.metadata, minzoom: this.minzoom, maxzoom: this.maxzoom, filter: this.filter, layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(), paint: this._transitionablePaint && this._transitionablePaint.serialize() }, (de, Ce) => !(de === void 0 || Ce === "layout" && !Object.keys(de).length || Ce === "paint" && !Object.keys(de).length));
        }
        is3D() {
          return !1;
        }
        isSky() {
          return !1;
        }
        isTileClipped() {
          return !1;
        }
        hasOffscreenPass() {
          return !1;
        }
        hasShadowPass() {
          return !1;
        }
        canCastShadows() {
          return !1;
        }
        hasLightBeamPass() {
          return !1;
        }
        cutoffRange() {
          return 0;
        }
        tileCoverLift() {
          return 0;
        }
        resize() {
        }
        isStateDependent() {
          for (const de in this.paint._values) {
            const Ce = this.paint.get(de);
            if (Ce instanceof mh && pc(Ce.property.specification) && (Ce.value.kind === "source" || Ce.value.kind === "composite") && Ce.value.isStateDependent)
              return !0;
          }
          return !1;
        }
        compileFilter(de) {
          this._filterCompiled || (this._featureFilter = Zm(this.filter, this.scope, de), this._filterCompiled = !0);
        }
        invalidateCompiledFilter() {
          this._filterCompiled = !1;
        }
        dynamicFilter() {
          return this._featureFilter.dynamicFilter;
        }
        dynamicFilterNeedsFeature() {
          return this._featureFilter.needFeature;
        }
        getLayerRenderingStats() {
          return this._stats;
        }
        resetLayerRenderingStats(de) {
          this._stats && (de.renderPass === "shadow" ? this._stats.numRenderedVerticesInShadowPass = 0 : this._stats.numRenderedVerticesInTransparentPass = 0);
        }
        queryRadius(de) {
        }
        queryIntersectsFeature(de, Ce, De, Ke, Ve, er, fr, wr, kr) {
        }
      }
      const Kf = { Int8: Int8Array, Uint8: Uint8Array, Int16: Int16Array, Uint16: Uint16Array, Int32: Int32Array, Uint32: Uint32Array, Float32: Float32Array };
      class Wd {
        constructor(de, Ce) {
          this._structArray = de, this._pos1 = Ce * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
        }
      }
      class Ka {
        constructor() {
          this.isTransferred = !1, this.capacity = -1, this.resize(0);
        }
        static serialize(de, Ce) {
          return de._trim(), Ce && (de.isTransferred = !0, Ce.add(de.arrayBuffer)), { length: de.length, arrayBuffer: de.arrayBuffer };
        }
        static deserialize(de) {
          const Ce = Object.create(this.prototype);
          return Ce.arrayBuffer = de.arrayBuffer, Ce.length = de.length, Ce.capacity = de.arrayBuffer.byteLength / Ce.bytesPerElement, Ce._refreshViews(), Ce;
        }
        _trim() {
          this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
        }
        clear() {
          this.length = 0;
        }
        resize(de) {
          this.reserve(de), this.length = de;
        }
        reserve(de) {
          if (de > this.capacity) {
            this.capacity = Math.max(de, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
            const Ce = this.uint8;
            this._refreshViews(), Ce && this.uint8.set(Ce);
          }
        }
        _refreshViews() {
          throw new Error("StructArray#_refreshViews() must be implemented by each concrete StructArray layout");
        }
        emplace(...de) {
          throw new Error("StructArray#emplace() must be implemented by each concrete StructArray layout");
        }
        emplaceBack(...de) {
          throw new Error("StructArray#emplaceBack() must be implemented by each concrete StructArray layout");
        }
        destroy() {
          this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
        }
      }
      function La(Ie, de = 1) {
        let Ce = 0, De = 0;
        return { members: Ie.map((Ke) => {
          const Ve = Kf[Ke.type].BYTES_PER_ELEMENT, er = Ce = Zd(Ce, Math.max(de, Ve)), fr = Ke.components || 1;
          return De = Math.max(De, Ve), Ce += Ve * fr, { name: Ke.name, type: Ke.type, components: fr, offset: er };
        }), size: Zd(Ce, Math.max(De, de)), alignment: de };
      }
      function Zd(Ie, de) {
        return Math.ceil(Ie / de) * de;
      }
      class Zc extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce) {
          const De = this.length;
          return this.resize(De + 1), this.emplace(De, de, Ce);
        }
        emplace(de, Ce, De) {
          const Ke = 2 * de;
          return this.int16[Ke + 0] = Ce, this.int16[Ke + 1] = De, de;
        }
      }
      Zc.prototype.bytesPerElement = 4, Ao(Zc, "StructArrayLayout2i4");
      class rd extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De) {
          const Ke = this.length;
          return this.resize(Ke + 1), this.emplace(Ke, de, Ce, De);
        }
        emplace(de, Ce, De, Ke) {
          const Ve = 3 * de;
          return this.int16[Ve + 0] = Ce, this.int16[Ve + 1] = De, this.int16[Ve + 2] = Ke, de;
        }
      }
      rd.prototype.bytesPerElement = 6, Ao(rd, "StructArrayLayout3i6");
      class $u extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke) {
          const Ve = this.length;
          return this.resize(Ve + 1), this.emplace(Ve, de, Ce, De, Ke);
        }
        emplace(de, Ce, De, Ke, Ve) {
          const er = 4 * de;
          return this.int16[er + 0] = Ce, this.int16[er + 1] = De, this.int16[er + 2] = Ke, this.int16[er + 3] = Ve, de;
        }
      }
      $u.prototype.bytesPerElement = 8, Ao($u, "StructArrayLayout4i8");
      class tc extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve) {
          const er = this.length;
          return this.resize(er + 1), this.emplace(er, de, Ce, De, Ke, Ve);
        }
        emplace(de, Ce, De, Ke, Ve, er) {
          const fr = 5 * de;
          return this.int16[fr + 0] = Ce, this.int16[fr + 1] = De, this.int16[fr + 2] = Ke, this.int16[fr + 3] = Ve, this.int16[fr + 4] = er, de;
        }
      }
      tc.prototype.bytesPerElement = 10, Ao(tc, "StructArrayLayout5i10");
      class Xd extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er, fr) {
          const wr = this.length;
          return this.resize(wr + 1), this.emplace(wr, de, Ce, De, Ke, Ve, er, fr);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr, wr) {
          const kr = 6 * de, cr = 12 * de, Mr = 3 * de;
          return this.int16[kr + 0] = Ce, this.int16[kr + 1] = De, this.uint8[cr + 4] = Ke, this.uint8[cr + 5] = Ve, this.uint8[cr + 6] = er, this.uint8[cr + 7] = fr, this.float32[Mr + 2] = wr, de;
        }
      }
      Xd.prototype.bytesPerElement = 12, Ao(Xd, "StructArrayLayout2i4ub1f12");
      class cu extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke) {
          const Ve = this.length;
          return this.resize(Ve + 1), this.emplace(Ve, de, Ce, De, Ke);
        }
        emplace(de, Ce, De, Ke, Ve) {
          const er = 4 * de;
          return this.float32[er + 0] = Ce, this.float32[er + 1] = De, this.float32[er + 2] = Ke, this.float32[er + 3] = Ve, de;
        }
      }
      cu.prototype.bytesPerElement = 16, Ao(cu, "StructArrayLayout4f16");
      class Xc extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De) {
          const Ke = this.length;
          return this.resize(Ke + 1), this.emplace(Ke, de, Ce, De);
        }
        emplace(de, Ce, De, Ke) {
          const Ve = 3 * de;
          return this.float32[Ve + 0] = Ce, this.float32[Ve + 1] = De, this.float32[Ve + 2] = Ke, de;
        }
      }
      Xc.prototype.bytesPerElement = 12, Ao(Xc, "StructArrayLayout3f12");
      class Ia extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve) {
          const er = this.length;
          return this.resize(er + 1), this.emplace(er, de, Ce, De, Ke, Ve);
        }
        emplace(de, Ce, De, Ke, Ve, er) {
          const fr = 6 * de, wr = 3 * de;
          return this.uint16[fr + 0] = Ce, this.uint16[fr + 1] = De, this.uint16[fr + 2] = Ke, this.uint16[fr + 3] = Ve, this.float32[wr + 2] = er, de;
        }
      }
      Ia.prototype.bytesPerElement = 12, Ao(Ia, "StructArrayLayout4ui1f12");
      class Yf extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke) {
          const Ve = this.length;
          return this.resize(Ve + 1), this.emplace(Ve, de, Ce, De, Ke);
        }
        emplace(de, Ce, De, Ke, Ve) {
          const er = 4 * de;
          return this.uint16[er + 0] = Ce, this.uint16[er + 1] = De, this.uint16[er + 2] = Ke, this.uint16[er + 3] = Ve, de;
        }
      }
      Yf.prototype.bytesPerElement = 8, Ao(Yf, "StructArrayLayout4ui8");
      class Jf extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er) {
          const fr = this.length;
          return this.resize(fr + 1), this.emplace(fr, de, Ce, De, Ke, Ve, er);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr) {
          const wr = 6 * de;
          return this.int16[wr + 0] = Ce, this.int16[wr + 1] = De, this.int16[wr + 2] = Ke, this.int16[wr + 3] = Ve, this.int16[wr + 4] = er, this.int16[wr + 5] = fr, de;
        }
      }
      Jf.prototype.bytesPerElement = 12, Ao(Jf, "StructArrayLayout6i12");
      class gh extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er) {
          const xr = this.length;
          return this.resize(xr + 1), this.emplace(xr, de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr) {
          const Sr = 12 * de;
          return this.int16[Sr + 0] = Ce, this.int16[Sr + 1] = De, this.int16[Sr + 2] = Ke, this.int16[Sr + 3] = Ve, this.uint16[Sr + 4] = er, this.uint16[Sr + 5] = fr, this.uint16[Sr + 6] = wr, this.uint16[Sr + 7] = kr, this.int16[Sr + 8] = cr, this.int16[Sr + 9] = Mr, this.int16[Sr + 10] = Er, this.int16[Sr + 11] = xr, de;
        }
      }
      gh.prototype.bytesPerElement = 24, Ao(gh, "StructArrayLayout4i4ui4i24");
      class Qf extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er) {
          const fr = this.length;
          return this.resize(fr + 1), this.emplace(fr, de, Ce, De, Ke, Ve, er);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr) {
          const wr = 10 * de, kr = 5 * de;
          return this.int16[wr + 0] = Ce, this.int16[wr + 1] = De, this.int16[wr + 2] = Ke, this.float32[kr + 2] = Ve, this.float32[kr + 3] = er, this.float32[kr + 4] = fr, de;
        }
      }
      Qf.prototype.bytesPerElement = 20, Ao(Qf, "StructArrayLayout3i3f20");
      class Wp extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
        }
        emplaceBack(de) {
          const Ce = this.length;
          return this.resize(Ce + 1), this.emplace(Ce, de);
        }
        emplace(de, Ce) {
          return this.uint32[1 * de + 0] = Ce, de;
        }
      }
      Wp.prototype.bytesPerElement = 4, Ao(Wp, "StructArrayLayout1ul4");
      class Ru extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce) {
          const De = this.length;
          return this.resize(De + 1), this.emplace(De, de, Ce);
        }
        emplace(de, Ce, De) {
          const Ke = 2 * de;
          return this.uint16[Ke + 0] = Ce, this.uint16[Ke + 1] = De, de;
        }
      }
      Ru.prototype.bytesPerElement = 4, Ao(Ru, "StructArrayLayout2ui4");
      class jl extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr) {
          const Sr = this.length;
          return this.resize(Sr + 1), this.emplace(Sr, de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr) {
          const Br = 20 * de, Fr = 10 * de;
          return this.int16[Br + 0] = Ce, this.int16[Br + 1] = De, this.int16[Br + 2] = Ke, this.int16[Br + 3] = Ve, this.int16[Br + 4] = er, this.float32[Fr + 3] = fr, this.float32[Fr + 4] = wr, this.float32[Fr + 5] = kr, this.float32[Fr + 6] = cr, this.int16[Br + 14] = Mr, this.uint32[Fr + 8] = Er, this.uint16[Br + 18] = xr, this.uint16[Br + 19] = Sr, de;
        }
      }
      jl.prototype.bytesPerElement = 40, Ao(jl, "StructArrayLayout5i4f1i1ul2ui40");
      class Kd extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er, fr) {
          const wr = this.length;
          return this.resize(wr + 1), this.emplace(wr, de, Ce, De, Ke, Ve, er, fr);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr, wr) {
          const kr = 8 * de;
          return this.int16[kr + 0] = Ce, this.int16[kr + 1] = De, this.int16[kr + 2] = Ke, this.int16[kr + 4] = Ve, this.int16[kr + 5] = er, this.int16[kr + 6] = fr, this.int16[kr + 7] = wr, de;
        }
      }
      Kd.prototype.bytesPerElement = 16, Ao(Kd, "StructArrayLayout3i2i2i16");
      class id extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve) {
          const er = this.length;
          return this.resize(er + 1), this.emplace(er, de, Ce, De, Ke, Ve);
        }
        emplace(de, Ce, De, Ke, Ve, er) {
          const fr = 4 * de, wr = 8 * de;
          return this.float32[fr + 0] = Ce, this.float32[fr + 1] = De, this.float32[fr + 2] = Ke, this.int16[wr + 6] = Ve, this.int16[wr + 7] = er, de;
        }
      }
      id.prototype.bytesPerElement = 16, Ao(id, "StructArrayLayout2f1f2i16");
      class Yd extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er) {
          const fr = this.length;
          return this.resize(fr + 1), this.emplace(fr, de, Ce, De, Ke, Ve, er);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr) {
          const wr = 20 * de, kr = 5 * de;
          return this.uint8[wr + 0] = Ce, this.uint8[wr + 1] = De, this.float32[kr + 1] = Ke, this.float32[kr + 2] = Ve, this.float32[kr + 3] = er, this.float32[kr + 4] = fr, de;
        }
      }
      Yd.prototype.bytesPerElement = 20, Ao(Yd, "StructArrayLayout2ub4f20");
      class tl extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De) {
          const Ke = this.length;
          return this.resize(Ke + 1), this.emplace(Ke, de, Ce, De);
        }
        emplace(de, Ce, De, Ke) {
          const Ve = 3 * de;
          return this.uint16[Ve + 0] = Ce, this.uint16[Ve + 1] = De, this.uint16[Ve + 2] = Ke, de;
        }
      }
      tl.prototype.bytesPerElement = 6, Ao(tl, "StructArrayLayout3ui6");
      class Jd extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr, Br, Fr, jr, Qr, ti, Kr, ni) {
          const gi = this.length;
          return this.resize(gi + 1), this.emplace(gi, de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr, Br, Fr, jr, Qr, ti, Kr, ni);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr, Br, Fr, jr, Qr, ti, Kr, ni, gi) {
          const Si = 30 * de, Di = 15 * de, Ri = 60 * de;
          return this.int16[Si + 0] = Ce, this.int16[Si + 1] = De, this.int16[Si + 2] = Ke, this.float32[Di + 2] = Ve, this.float32[Di + 3] = er, this.uint16[Si + 8] = fr, this.uint16[Si + 9] = wr, this.uint32[Di + 5] = kr, this.uint32[Di + 6] = cr, this.uint32[Di + 7] = Mr, this.uint16[Si + 16] = Er, this.uint16[Si + 17] = xr, this.uint16[Si + 18] = Sr, this.float32[Di + 10] = Br, this.float32[Di + 11] = Fr, this.uint8[Ri + 48] = jr, this.uint8[Ri + 49] = Qr, this.uint8[Ri + 50] = ti, this.uint32[Di + 13] = Kr, this.int16[Si + 28] = ni, this.uint8[Ri + 58] = gi, de;
        }
      }
      Jd.prototype.bytesPerElement = 60, Ao(Jd, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
      class Tl extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr, Br, Fr, jr, Qr, ti, Kr, ni, gi, Si, Di, Ri, Bi, Ji, Fi, tn, cn, ln, mn) {
          const wn = this.length;
          return this.resize(wn + 1), this.emplace(wn, de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr, Br, Fr, jr, Qr, ti, Kr, ni, gi, Si, Di, Ri, Bi, Ji, Fi, tn, cn, ln, mn);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr, Br, Fr, jr, Qr, ti, Kr, ni, gi, Si, Di, Ri, Bi, Ji, Fi, tn, cn, ln, mn, wn) {
          const Cn = 20 * de, gn = 40 * de, Nn = 80 * de;
          return this.float32[Cn + 0] = Ce, this.float32[Cn + 1] = De, this.int16[gn + 4] = Ke, this.int16[gn + 5] = Ve, this.int16[gn + 6] = er, this.int16[gn + 7] = fr, this.int16[gn + 8] = wr, this.int16[gn + 9] = kr, this.int16[gn + 10] = cr, this.int16[gn + 11] = Mr, this.int16[gn + 12] = Er, this.uint16[gn + 13] = xr, this.uint16[gn + 14] = Sr, this.uint16[gn + 15] = Br, this.uint16[gn + 16] = Fr, this.uint16[gn + 17] = jr, this.uint16[gn + 18] = Qr, this.uint16[gn + 19] = ti, this.uint16[gn + 20] = Kr, this.uint16[gn + 21] = ni, this.uint16[gn + 22] = gi, this.uint16[gn + 23] = Si, this.uint16[gn + 24] = Di, this.uint16[gn + 25] = Ri, this.uint16[gn + 26] = Bi, this.uint16[gn + 27] = Ji, this.uint32[Cn + 14] = Fi, this.float32[Cn + 15] = tn, this.float32[Cn + 16] = cn, this.float32[Cn + 17] = ln, this.float32[Cn + 18] = mn, this.uint8[Nn + 76] = wn, de;
        }
      }
      Tl.prototype.bytesPerElement = 80, Ao(Tl, "StructArrayLayout2f9i15ui1ul4f1ub80");
      class rl extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de) {
          const Ce = this.length;
          return this.resize(Ce + 1), this.emplace(Ce, de);
        }
        emplace(de, Ce) {
          return this.float32[1 * de + 0] = Ce, de;
        }
      }
      rl.prototype.bytesPerElement = 4, Ao(rl, "StructArrayLayout1f4");
      class Kc extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve) {
          const er = this.length;
          return this.resize(er + 1), this.emplace(er, de, Ce, De, Ke, Ve);
        }
        emplace(de, Ce, De, Ke, Ve, er) {
          const fr = 5 * de;
          return this.float32[fr + 0] = Ce, this.float32[fr + 1] = De, this.float32[fr + 2] = Ke, this.float32[fr + 3] = Ve, this.float32[fr + 4] = er, de;
        }
      }
      Kc.prototype.bytesPerElement = 20, Ao(Kc, "StructArrayLayout5f20");
      class ep extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er, fr) {
          const wr = this.length;
          return this.resize(wr + 1), this.emplace(wr, de, Ce, De, Ke, Ve, er, fr);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr, wr) {
          const kr = 7 * de;
          return this.float32[kr + 0] = Ce, this.float32[kr + 1] = De, this.float32[kr + 2] = Ke, this.float32[kr + 3] = Ve, this.float32[kr + 4] = er, this.float32[kr + 5] = fr, this.float32[kr + 6] = wr, de;
        }
      }
      ep.prototype.bytesPerElement = 28, Ao(ep, "StructArrayLayout7f28");
      class nd extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr) {
          const Er = this.length;
          return this.resize(Er + 1), this.emplace(Er, de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er) {
          const xr = 11 * de;
          return this.float32[xr + 0] = Ce, this.float32[xr + 1] = De, this.float32[xr + 2] = Ke, this.float32[xr + 3] = Ve, this.float32[xr + 4] = er, this.float32[xr + 5] = fr, this.float32[xr + 6] = wr, this.float32[xr + 7] = kr, this.float32[xr + 8] = cr, this.float32[xr + 9] = Mr, this.float32[xr + 10] = Er, de;
        }
      }
      nd.prototype.bytesPerElement = 44, Ao(nd, "StructArrayLayout11f44");
      class tp extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er, fr, wr, kr) {
          const cr = this.length;
          return this.resize(cr + 1), this.emplace(cr, de, Ce, De, Ke, Ve, er, fr, wr, kr);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr) {
          const Mr = 9 * de;
          return this.float32[Mr + 0] = Ce, this.float32[Mr + 1] = De, this.float32[Mr + 2] = Ke, this.float32[Mr + 3] = Ve, this.float32[Mr + 4] = er, this.float32[Mr + 5] = fr, this.float32[Mr + 6] = wr, this.float32[Mr + 7] = kr, this.float32[Mr + 8] = cr, de;
        }
      }
      tp.prototype.bytesPerElement = 36, Ao(tp, "StructArrayLayout9f36");
      class Lc extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce) {
          const De = this.length;
          return this.resize(De + 1), this.emplace(De, de, Ce);
        }
        emplace(de, Ce, De) {
          const Ke = 2 * de;
          return this.float32[Ke + 0] = Ce, this.float32[Ke + 1] = De, de;
        }
      }
      Lc.prototype.bytesPerElement = 8, Ao(Lc, "StructArrayLayout2f8");
      class Qd extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke) {
          const Ve = this.length;
          return this.resize(Ve + 1), this.emplace(Ve, de, Ce, De, Ke);
        }
        emplace(de, Ce, De, Ke, Ve) {
          const er = 6 * de;
          return this.uint32[3 * de + 0] = Ce, this.uint16[er + 2] = De, this.uint16[er + 3] = Ke, this.uint16[er + 4] = Ve, de;
        }
      }
      Qd.prototype.bytesPerElement = 12, Ao(Qd, "StructArrayLayout1ul3ui12");
      class ef extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(de) {
          const Ce = this.length;
          return this.resize(Ce + 1), this.emplace(Ce, de);
        }
        emplace(de, Ce) {
          return this.uint16[1 * de + 0] = Ce, de;
        }
      }
      ef.prototype.bytesPerElement = 2, Ao(ef, "StructArrayLayout1ui2");
      class od extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr, Br, Fr) {
          const jr = this.length;
          return this.resize(jr + 1), this.emplace(jr, de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr, Br, Fr);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr, Br, Fr, jr) {
          const Qr = 16 * de;
          return this.float32[Qr + 0] = Ce, this.float32[Qr + 1] = De, this.float32[Qr + 2] = Ke, this.float32[Qr + 3] = Ve, this.float32[Qr + 4] = er, this.float32[Qr + 5] = fr, this.float32[Qr + 6] = wr, this.float32[Qr + 7] = kr, this.float32[Qr + 8] = cr, this.float32[Qr + 9] = Mr, this.float32[Qr + 10] = Er, this.float32[Qr + 11] = xr, this.float32[Qr + 12] = Sr, this.float32[Qr + 13] = Br, this.float32[Qr + 14] = Fr, this.float32[Qr + 15] = jr, de;
        }
      }
      od.prototype.bytesPerElement = 64, Ao(od, "StructArrayLayout16f64");
      class Ic extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(de, Ce, De, Ke, Ve, er, fr) {
          const wr = this.length;
          return this.resize(wr + 1), this.emplace(wr, de, Ce, De, Ke, Ve, er, fr);
        }
        emplace(de, Ce, De, Ke, Ve, er, fr, wr) {
          const kr = 10 * de, cr = 5 * de;
          return this.uint16[kr + 0] = Ce, this.uint16[kr + 1] = De, this.uint16[kr + 2] = Ke, this.uint16[kr + 3] = Ve, this.float32[cr + 2] = er, this.float32[cr + 3] = fr, this.float32[cr + 4] = wr, de;
        }
      }
      Ic.prototype.bytesPerElement = 20, Ao(Ic, "StructArrayLayout4ui3f20");
      class rp extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(de) {
          const Ce = this.length;
          return this.resize(Ce + 1), this.emplace(Ce, de);
        }
        emplace(de, Ce) {
          return this.int16[1 * de + 0] = Ce, de;
        }
      }
      rp.prototype.bytesPerElement = 2, Ao(rp, "StructArrayLayout1i2");
      class rc extends Ka {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer);
        }
        emplaceBack(de) {
          const Ce = this.length;
          return this.resize(Ce + 1), this.emplace(Ce, de);
        }
        emplace(de, Ce) {
          return this.uint8[1 * de + 0] = Ce, de;
        }
      }
      rc.prototype.bytesPerElement = 1, Ao(rc, "StructArrayLayout1ub1");
      class Zp extends Wd {
        get projectedAnchorX() {
          return this._structArray.int16[this._pos2 + 0];
        }
        get projectedAnchorY() {
          return this._structArray.int16[this._pos2 + 1];
        }
        get projectedAnchorZ() {
          return this._structArray.int16[this._pos2 + 2];
        }
        get tileAnchorX() {
          return this._structArray.int16[this._pos2 + 3];
        }
        get tileAnchorY() {
          return this._structArray.int16[this._pos2 + 4];
        }
        get x1() {
          return this._structArray.float32[this._pos4 + 3];
        }
        get y1() {
          return this._structArray.float32[this._pos4 + 4];
        }
        get x2() {
          return this._structArray.float32[this._pos4 + 5];
        }
        get y2() {
          return this._structArray.float32[this._pos4 + 6];
        }
        get padding() {
          return this._structArray.int16[this._pos2 + 14];
        }
        get featureIndex() {
          return this._structArray.uint32[this._pos4 + 8];
        }
        get sourceLayerIndex() {
          return this._structArray.uint16[this._pos2 + 18];
        }
        get bucketIndex() {
          return this._structArray.uint16[this._pos2 + 19];
        }
      }
      Zp.prototype.size = 40;
      class Xp extends jl {
        get(de) {
          return new Zp(this, de);
        }
      }
      Ao(Xp, "CollisionBoxArray");
      class ip extends Wd {
        get projectedAnchorX() {
          return this._structArray.int16[this._pos2 + 0];
        }
        get projectedAnchorY() {
          return this._structArray.int16[this._pos2 + 1];
        }
        get projectedAnchorZ() {
          return this._structArray.int16[this._pos2 + 2];
        }
        get tileAnchorX() {
          return this._structArray.float32[this._pos4 + 2];
        }
        get tileAnchorY() {
          return this._structArray.float32[this._pos4 + 3];
        }
        get glyphStartIndex() {
          return this._structArray.uint16[this._pos2 + 8];
        }
        get numGlyphs() {
          return this._structArray.uint16[this._pos2 + 9];
        }
        get vertexStartIndex() {
          return this._structArray.uint32[this._pos4 + 5];
        }
        get lineStartIndex() {
          return this._structArray.uint32[this._pos4 + 6];
        }
        get lineLength() {
          return this._structArray.uint32[this._pos4 + 7];
        }
        get segment() {
          return this._structArray.uint16[this._pos2 + 16];
        }
        get lowerSize() {
          return this._structArray.uint16[this._pos2 + 17];
        }
        get upperSize() {
          return this._structArray.uint16[this._pos2 + 18];
        }
        get lineOffsetX() {
          return this._structArray.float32[this._pos4 + 10];
        }
        get lineOffsetY() {
          return this._structArray.float32[this._pos4 + 11];
        }
        get writingMode() {
          return this._structArray.uint8[this._pos1 + 48];
        }
        get placedOrientation() {
          return this._structArray.uint8[this._pos1 + 49];
        }
        set placedOrientation(de) {
          this._structArray.uint8[this._pos1 + 49] = de;
        }
        get hidden() {
          return this._structArray.uint8[this._pos1 + 50];
        }
        set hidden(de) {
          this._structArray.uint8[this._pos1 + 50] = de;
        }
        get crossTileID() {
          return this._structArray.uint32[this._pos4 + 13];
        }
        set crossTileID(de) {
          this._structArray.uint32[this._pos4 + 13] = de;
        }
        get associatedIconIndex() {
          return this._structArray.int16[this._pos2 + 28];
        }
        get flipState() {
          return this._structArray.uint8[this._pos1 + 58];
        }
        set flipState(de) {
          this._structArray.uint8[this._pos1 + 58] = de;
        }
      }
      ip.prototype.size = 60;
      class Jm extends Jd {
        get(de) {
          return new ip(this, de);
        }
      }
      Ao(Jm, "PlacedSymbolArray");
      class Qm extends Wd {
        get tileAnchorX() {
          return this._structArray.float32[this._pos4 + 0];
        }
        get tileAnchorY() {
          return this._structArray.float32[this._pos4 + 1];
        }
        get projectedAnchorX() {
          return this._structArray.int16[this._pos2 + 4];
        }
        get projectedAnchorY() {
          return this._structArray.int16[this._pos2 + 5];
        }
        get projectedAnchorZ() {
          return this._structArray.int16[this._pos2 + 6];
        }
        get rightJustifiedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 7];
        }
        get centerJustifiedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 8];
        }
        get leftJustifiedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 9];
        }
        get verticalPlacedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 10];
        }
        get placedIconSymbolIndex() {
          return this._structArray.int16[this._pos2 + 11];
        }
        get verticalPlacedIconSymbolIndex() {
          return this._structArray.int16[this._pos2 + 12];
        }
        get key() {
          return this._structArray.uint16[this._pos2 + 13];
        }
        get textBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 14];
        }
        get textBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 15];
        }
        get verticalTextBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 16];
        }
        get verticalTextBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 17];
        }
        get iconBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 18];
        }
        get iconBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 19];
        }
        get verticalIconBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 20];
        }
        get verticalIconBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 21];
        }
        get featureIndex() {
          return this._structArray.uint16[this._pos2 + 22];
        }
        get numHorizontalGlyphVertices() {
          return this._structArray.uint16[this._pos2 + 23];
        }
        get numVerticalGlyphVertices() {
          return this._structArray.uint16[this._pos2 + 24];
        }
        get numIconVertices() {
          return this._structArray.uint16[this._pos2 + 25];
        }
        get numVerticalIconVertices() {
          return this._structArray.uint16[this._pos2 + 26];
        }
        get useRuntimeCollisionCircles() {
          return this._structArray.uint16[this._pos2 + 27];
        }
        get crossTileID() {
          return this._structArray.uint32[this._pos4 + 14];
        }
        set crossTileID(de) {
          this._structArray.uint32[this._pos4 + 14] = de;
        }
        get textOffset0() {
          return this._structArray.float32[this._pos4 + 15];
        }
        get textOffset1() {
          return this._structArray.float32[this._pos4 + 16];
        }
        get collisionCircleDiameter() {
          return this._structArray.float32[this._pos4 + 17];
        }
        get zOffset() {
          return this._structArray.float32[this._pos4 + 18];
        }
        set zOffset(de) {
          this._structArray.float32[this._pos4 + 18] = de;
        }
        get hasIconTextFit() {
          return this._structArray.uint8[this._pos1 + 76];
        }
      }
      Qm.prototype.size = 80;
      class tf extends Tl {
        get(de) {
          return new Qm(this, de);
        }
      }
      Ao(tf, "SymbolInstanceArray");
      class ad extends rl {
        getoffsetX(de) {
          return this.float32[1 * de + 0];
        }
      }
      Ao(ad, "GlyphOffsetArray");
      class Bl extends Zc {
        getx(de) {
          return this.int16[2 * de + 0];
        }
        gety(de) {
          return this.int16[2 * de + 1];
        }
      }
      Ao(Bl, "SymbolLineVertexArray");
      class rf extends Wd {
        get featureIndex() {
          return this._structArray.uint32[this._pos4 + 0];
        }
        get sourceLayerIndex() {
          return this._structArray.uint16[this._pos2 + 2];
        }
        get bucketIndex() {
          return this._structArray.uint16[this._pos2 + 3];
        }
        get layoutVertexArrayOffset() {
          return this._structArray.uint16[this._pos2 + 4];
        }
      }
      rf.prototype.size = 12;
      class Kp extends Qd {
        get(de) {
          return new rf(this, de);
        }
      }
      Ao(Kp, "FeatureIndexArray");
      class Yp extends Ru {
        geta_centroid_pos0(de) {
          return this.uint16[2 * de + 0];
        }
        geta_centroid_pos1(de) {
          return this.uint16[2 * de + 1];
        }
      }
      Ao(Yp, "FillExtrusionCentroidArray");
      class $l extends Wd {
        get a_join_normal_inside0() {
          return this._structArray.int16[this._pos2 + 0];
        }
        get a_join_normal_inside1() {
          return this._structArray.int16[this._pos2 + 1];
        }
        get a_join_normal_inside2() {
          return this._structArray.int16[this._pos2 + 2];
        }
      }
      $l.prototype.size = 6;
      class Bc extends rd {
        get(de) {
          return new $l(this, de);
        }
      }
      Ao(Bc, "FillExtrusionWallArray");
      const Jp = La([{ name: "a_pos", components: 2, type: "Int16" }], 4), Z0 = La([{ name: "a_pos_3", components: 3, type: "Int16" }, { name: "a_pos_normal_3", components: 3, type: "Int16" }]);
      class fs {
        constructor(de = []) {
          this.segments = de;
        }
        _prepareSegment(de, Ce, De, Ke) {
          let Ve = this.segments[this.segments.length - 1];
          return de > fs.MAX_VERTEX_ARRAY_LENGTH && Mn(`Max vertices per segment is ${fs.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${de}`), (!Ve || Ve.vertexLength + de > fs.MAX_VERTEX_ARRAY_LENGTH || Ve.sortKey !== Ke) && (Ve = { vertexOffset: Ce, primitiveOffset: De, vertexLength: 0, primitiveLength: 0 }, Ke !== void 0 && (Ve.sortKey = Ke), this.segments.push(Ve)), Ve;
        }
        prepareSegment(de, Ce, De, Ke) {
          return this._prepareSegment(de, Ce.length, De.length, Ke);
        }
        get() {
          return this.segments;
        }
        destroy() {
          for (const de of this.segments)
            for (const Ce in de.vaos)
              de.vaos[Ce].destroy();
        }
        static simpleSegment(de, Ce, De, Ke) {
          return new fs([{ vertexOffset: de, primitiveOffset: Ce, vertexLength: De, primitiveLength: Ke, vaos: {}, sortKey: 0 }]);
        }
      }
      function vh(Ie, de) {
        return 256 * (Ie = vn(Math.floor(Ie), 0, 255)) + vn(Math.floor(de), 0, 255);
      }
      fs.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Ao(fs, "SegmentVector");
      const e0 = La([{ name: "a_pattern", components: 4, type: "Uint16" }, { name: "a_pixel_ratio", components: 1, type: "Float32" }]), np = La([{ name: "a_dash", components: 4, type: "Uint16" }]);
      class nf {
        constructor() {
          this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = !1;
        }
        add(de, Ce, De, Ke) {
          this.ids.push(op(de)), this.positions.push(Ce, De, Ke);
        }
        eachPosition(de, Ce) {
          const De = op(de);
          let Ke = 0, Ve = this.ids.length - 1;
          for (; Ke < Ve; ) {
            const er = Ke + Ve >> 1;
            this.ids[er] >= De ? Ve = er : Ke = er + 1;
          }
          for (; this.ids[Ke] === De; )
            Ce(this.positions[3 * Ke], this.positions[3 * Ke + 1], this.positions[3 * Ke + 2]), Ke++;
        }
        static serialize(de, Ce) {
          const De = new Float64Array(de.ids), Ke = new Uint32Array(de.positions);
          return uu(De, Ke, 0, De.length - 1), Ce && (Ce.add(De.buffer), Ce.add(Ke.buffer)), { ids: De, positions: Ke };
        }
        static deserialize(de) {
          const Ce = new nf();
          let De;
          Ce.ids = de.ids, Ce.positions = de.positions;
          for (const Ke of Ce.ids)
            Ke !== De && Ce.uniqueIds.push(Ke), De = Ke;
          return Ce.indexed = !0, Ce;
        }
      }
      function op(Ie) {
        const de = +Ie;
        return !isNaN(de) && Number.MIN_SAFE_INTEGER <= de && de <= Number.MAX_SAFE_INTEGER ? de : qu(String(Ie));
      }
      function uu(Ie, de, Ce, De) {
        for (; Ce < De; ) {
          const Ke = Ie[Ce + De >> 1];
          let Ve = Ce - 1, er = De + 1;
          for (; ; ) {
            do
              Ve++;
            while (Ie[Ve] < Ke);
            do
              er--;
            while (Ie[er] > Ke);
            if (Ve >= er)
              break;
            Pu(Ie, Ve, er), Pu(de, 3 * Ve, 3 * er), Pu(de, 3 * Ve + 1, 3 * er + 1), Pu(de, 3 * Ve + 2, 3 * er + 2);
          }
          er - Ce < De - er ? (uu(Ie, de, Ce, er), Ce = er + 1) : (uu(Ie, de, er + 1, De), De = er);
        }
      }
      function Pu(Ie, de, Ce) {
        const De = Ie[de];
        Ie[de] = Ie[Ce], Ie[Ce] = De;
      }
      Ao(nf, "FeaturePositionMap");
      class $c {
        constructor(de) {
          this.gl = de.gl, this.initialized = !1;
        }
        fetchUniformLocation(de, Ce) {
          return this.location || this.initialized || (this.location = this.gl.getUniformLocation(de, Ce), this.initialized = !0), !!this.location;
        }
        set(de, Ce, De) {
          throw new Error("Uniform#set() must be implemented by each concrete Uniform");
        }
      }
      class Du extends $c {
        constructor(de) {
          super(de), this.current = 0;
        }
        set(de, Ce, De) {
          this.fetchUniformLocation(de, Ce) && this.current !== De && (this.current = De, this.gl.uniform1i(this.location, De));
        }
      }
      class Ss extends $c {
        constructor(de) {
          super(de), this.current = 0;
        }
        set(de, Ce, De) {
          this.fetchUniformLocation(de, Ce) && this.current !== De && (this.current = De, this.gl.uniform1f(this.location, De));
        }
      }
      class ic extends $c {
        constructor(de) {
          super(de), this.current = [0, 0];
        }
        set(de, Ce, De) {
          this.fetchUniformLocation(de, Ce) && (De[0] === this.current[0] && De[1] === this.current[1] || (this.current = De, this.gl.uniform2f(this.location, De[0], De[1])));
        }
      }
      class of extends $c {
        constructor(de) {
          super(de), this.current = [0, 0, 0];
        }
        set(de, Ce, De) {
          this.fetchUniformLocation(de, Ce) && (De[0] === this.current[0] && De[1] === this.current[1] && De[2] === this.current[2] || (this.current = De, this.gl.uniform3f(this.location, De[0], De[1], De[2])));
        }
      }
      class _h extends $c {
        constructor(de) {
          super(de), this.current = [0, 0, 0, 0];
        }
        set(de, Ce, De) {
          this.fetchUniformLocation(de, Ce) && (De[0] === this.current[0] && De[1] === this.current[1] && De[2] === this.current[2] && De[3] === this.current[3] || (this.current = De, this.gl.uniform4f(this.location, De[0], De[1], De[2], De[3])));
        }
      }
      class sd extends $c {
        constructor(de) {
          super(de), this.current = Ca.transparent.toRenderColor(null);
        }
        set(de, Ce, De) {
          this.fetchUniformLocation(de, Ce) && (De.r === this.current.r && De.g === this.current.g && De.b === this.current.b && De.a === this.current.a || (this.current = De, this.gl.uniform4f(this.location, De.r, De.g, De.b, De.a)));
        }
      }
      const ap = new Float32Array(16);
      class af extends $c {
        constructor(de) {
          super(de), this.current = ap;
        }
        set(de, Ce, De) {
          if (this.fetchUniformLocation(de, Ce)) {
            if (De[12] !== this.current[12] || De[0] !== this.current[0])
              return this.current = De, void this.gl.uniformMatrix4fv(this.location, !1, De);
            for (let Ke = 1; Ke < 16; Ke++)
              if (De[Ke] !== this.current[Ke]) {
                this.current = De, this.gl.uniformMatrix4fv(this.location, !1, De);
                break;
              }
          }
        }
      }
      const t0 = new Float32Array(9), sp = new Float32Array(4);
      class sf extends $c {
        constructor(de) {
          super(de), this.current = sp;
        }
        set(de, Ce, De) {
          if (this.fetchUniformLocation(de, Ce)) {
            for (let Ke = 0; Ke < 4; Ke++)
              if (De[Ke] !== this.current[Ke]) {
                this.current = De, this.gl.uniformMatrix2fv(this.location, !1, De);
                break;
              }
          }
        }
      }
      function lf(Ie) {
        return [vh(255 * Ie.r, 255 * Ie.g), vh(255 * Ie.b, 255 * Ie.a)];
      }
      class ld {
        constructor(de, Ce, De, Ke) {
          this.value = de, this.uniformNames = Ce.map((Ve) => `u_${Ve}`), this.type = De, this.context = Ke;
        }
        setUniform(de, Ce, De, Ke, Ve) {
          const er = Ke.constantOr(this.value);
          Ce.set(de, Ve, er instanceof Ca ? er.toRenderColor(this.ignoreLut ? null : this.context.lut) : er);
        }
        getBinding(de, Ce) {
          return this.type === "color" ? new sd(de) : new Ss(de);
        }
      }
      class yh {
        constructor(de, Ce) {
          this.uniformNames = Ce.map((De) => `u_${De}`), this.pattern = null, this.pixelRatio = 1;
        }
        setConstantPatternPositions(de) {
          this.pixelRatio = de.pixelRatio || 1, this.pattern = de.tl.concat(de.br);
        }
        setUniform(de, Ce, De, Ke, Ve) {
          const er = Ve === "u_pattern" || Ve === "u_dash" ? this.pattern : Ve === "u_pixel_ratio" ? this.pixelRatio : null;
          er && Ce.set(de, Ve, er);
        }
        getBinding(de, Ce) {
          return Ce === "u_pattern" || Ce === "u_dash" ? new _h(de) : new Ss(de);
        }
      }
      class pl {
        constructor(de, Ce, De, Ke) {
          this.expression = de, this.type = De, this.maxValue = 0, this.paintVertexAttributes = Ce.map((Ve) => ({ name: `a_${Ve}`, type: "Float32", components: De === "color" ? 2 : 1, offset: 0 })), this.paintVertexArray = new Ke();
        }
        populatePaintArray(de, Ce, De, Ke, Ve, er, fr) {
          const wr = this.paintVertexArray.length, kr = this.expression.evaluate(new wa(0, { brightness: er }), Ce, {}, Ve, Ke, fr);
          this.paintVertexArray.resize(de), this._setPaintValue(wr, de, kr, this.context);
        }
        updatePaintArray(de, Ce, De, Ke, Ve, er, fr) {
          const wr = this.expression.evaluate({ zoom: 0, brightness: fr }, De, Ke, void 0, Ve);
          this._setPaintValue(de, Ce, wr, this.context);
        }
        _setPaintValue(de, Ce, De, Ke) {
          if (this.type === "color") {
            const Ve = lf(De.toRenderColor(this.ignoreLut ? null : Ke.lut));
            for (let er = de; er < Ce; er++)
              this.paintVertexArray.emplace(er, Ve[0], Ve[1]);
          } else {
            for (let Ve = de; Ve < Ce; Ve++)
              this.paintVertexArray.emplace(Ve, De);
            this.maxValue = Math.max(this.maxValue, Math.abs(De));
          }
        }
        upload(de) {
          this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = de.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
        }
        destroy() {
          this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }
      }
      class vc {
        constructor(de, Ce, De, Ke, Ve, er) {
          this.expression = de, this.uniformNames = Ce.map((fr) => `u_${fr}_t`), this.type = De, this.useIntegerZoom = Ke, this.context = Ve, this.maxValue = 0, this.paintVertexAttributes = Ce.map((fr) => ({ name: `a_${fr}`, type: "Float32", components: De === "color" ? 4 : 2, offset: 0 })), this.paintVertexArray = new er();
        }
        populatePaintArray(de, Ce, De, Ke, Ve, er, fr) {
          const wr = this.expression.evaluate(new wa(this.context.zoom, { brightness: er }), Ce, {}, Ve, Ke, fr), kr = this.expression.evaluate(new wa(this.context.zoom + 1, { brightness: er }), Ce, {}, Ve, Ke, fr), cr = this.paintVertexArray.length;
          this.paintVertexArray.resize(de), this._setPaintValue(cr, de, wr, kr, this.context);
        }
        updatePaintArray(de, Ce, De, Ke, Ve, er, fr) {
          const wr = this.expression.evaluate({ zoom: this.context.zoom, brightness: fr }, De, Ke, void 0, Ve), kr = this.expression.evaluate({ zoom: this.context.zoom + 1, brightness: fr }, De, Ke, void 0, Ve);
          this._setPaintValue(de, Ce, wr, kr, this.context);
        }
        _setPaintValue(de, Ce, De, Ke, Ve) {
          if (this.type === "color") {
            const er = lf(De.toRenderColor(this.ignoreLut ? null : Ve.lut)), fr = lf(De.toRenderColor(this.ignoreLut ? null : Ve.lut));
            for (let wr = de; wr < Ce; wr++)
              this.paintVertexArray.emplace(wr, er[0], er[1], fr[0], fr[1]);
          } else {
            for (let er = de; er < Ce; er++)
              this.paintVertexArray.emplace(er, De, Ke);
            this.maxValue = Math.max(this.maxValue, Math.abs(De), Math.abs(Ke));
          }
        }
        upload(de) {
          this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = de.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
        }
        destroy() {
          this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }
        setUniform(de, Ce, De, Ke, Ve) {
          const er = this.useIntegerZoom ? Math.floor(De.zoom) : De.zoom, fr = vn(this.expression.interpolationFactor(er, this.context.zoom, this.context.zoom + 1), 0, 1);
          Ce.set(de, Ve, fr);
        }
        getBinding(de, Ce) {
          return new Ss(de);
        }
      }
      class hu {
        constructor(de, Ce, De, Ke, Ve) {
          this.expression = de, this.layerId = Ve, this.paintVertexAttributes = (De === "array" ? np : e0).members;
          for (let er = 0; er < Ce.length; ++er)
            ;
          this.paintVertexArray = new Ke();
        }
        populatePaintArray(de, Ce, De, Ke) {
          const Ve = this.paintVertexArray.length;
          this.paintVertexArray.resize(de), this._setPaintValues(Ve, de, Ce.patterns && Ce.patterns[this.layerId], De);
        }
        updatePaintArray(de, Ce, De, Ke, Ve, er, fr) {
          this._setPaintValues(de, Ce, De.patterns && De.patterns[this.layerId], er);
        }
        _setPaintValues(de, Ce, De, Ke) {
          if (!Ke || !De)
            return;
          const Ve = Ke[De];
          if (!Ve)
            return;
          const { tl: er, br: fr, pixelRatio: wr } = Ve;
          for (let kr = de; kr < Ce; kr++)
            this.paintVertexArray.emplace(kr, er[0], er[1], fr[0], fr[1], wr);
        }
        upload(de) {
          this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = de.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
        }
        destroy() {
          this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }
      }
      class bh {
        constructor(de, Ce, De = () => !0) {
          this.binders = {}, this._buffers = [], this.context = Ce;
          const Ke = [];
          for (const Ve in de.paint._values) {
            const er = de.paint.get(Ve), fr = de.paint.get(`${Ve}-use-theme`);
            if (Ve.endsWith("-use-theme") || !De(Ve) || !(er instanceof mh && pc(er.property.specification)))
              continue;
            const wr = X0(Ve, de.type), kr = er.value, cr = er.property.specification.type, Mr = !!er.property.useIntegerZoom, Er = Ve === "line-dasharray" || Ve.endsWith("pattern"), xr = Ve === "line-dasharray" && de.layout.get("line-cap").value.kind !== "constant";
            if (kr.kind !== "constant" || xr)
              if (kr.kind === "source" || xr || Er) {
                const Sr = cp(Ve, cr, "source");
                this.binders[Ve] = Er ? new hu(kr, wr, cr, Sr, de.id) : new pl(kr, wr, cr, Sr), Ke.push(`/a_${Ve}`);
              } else {
                const Sr = cp(Ve, cr, "composite");
                this.binders[Ve] = new vc(kr, wr, cr, Mr, Ce, Sr), Ke.push(`/z_${Ve}`);
              }
            else
              this.binders[Ve] = Er ? new yh(kr.value, wr) : new ld(kr.value, wr, cr, Ce), Ke.push(`/u_${Ve}`);
            fr && (this.binders[Ve].ignoreLut = fr.constantOr("default") === "none", this.binders[Ve].checkUseTheme = !0);
          }
          this.cacheKey = Ke.sort().join("");
        }
        getMaxValue(de) {
          const Ce = this.binders[de];
          return Ce instanceof pl || Ce instanceof vc ? Ce.maxValue : 0;
        }
        populatePaintArrays(de, Ce, De, Ke, Ve, er, fr) {
          for (const wr in this.binders) {
            const kr = this.binders[wr];
            kr.context = this.context, (kr instanceof pl || kr instanceof vc || kr instanceof hu) && kr.populatePaintArray(de, Ce, De, Ke, Ve, er, fr);
          }
        }
        setConstantPatternPositions(de) {
          for (const Ce in this.binders) {
            const De = this.binders[Ce];
            De instanceof yh && De.setConstantPatternPositions(de);
          }
        }
        updatePaintArrays(de, Ce, De, Ke, Ve, er, fr, wr, kr) {
          let cr = !1;
          const Mr = Object.keys(de), Er = Mr.length !== 0 && !wr, xr = Er ? Mr : Ce.uniqueIds;
          this.context.lut = Ve.lut;
          for (const Sr in this.binders) {
            const Br = this.binders[Sr];
            if (Br.context = this.context, (Br instanceof pl || Br instanceof vc || Br instanceof hu) && (Br.expression.isStateDependent === !0 || Br.expression.isLightConstant === !1)) {
              const Fr = Ve.paint.get(Sr);
              Br.expression = Fr.value;
              for (const jr of xr) {
                const Qr = de[jr.toString()];
                Ce.eachPosition(jr, (ti, Kr, ni) => {
                  const gi = Ke.feature(ti);
                  Br.updatePaintArray(Kr, ni, gi, Qr, er, fr, kr);
                });
              }
              if (!Er)
                for (const jr of De.uniqueIds) {
                  const Qr = de[jr.toString()];
                  De.eachPosition(jr, (ti, Kr, ni) => {
                    const gi = Ke.feature(ti);
                    Br.updatePaintArray(Kr, ni, gi, Qr, er, fr, kr);
                  });
                }
              cr = !0;
            }
          }
          return cr;
        }
        defines() {
          const de = [];
          for (const Ce in this.binders) {
            const De = this.binders[Ce];
            (De instanceof ld || De instanceof yh) && de.push(...De.uniformNames.map((Ke) => `#define HAS_UNIFORM_${Ke}`));
          }
          return de;
        }
        getBinderAttributes() {
          const de = [];
          for (const Ce in this.binders) {
            const De = this.binders[Ce];
            if (De instanceof pl || De instanceof vc || De instanceof hu)
              for (let Ke = 0; Ke < De.paintVertexAttributes.length; Ke++)
                de.push(De.paintVertexAttributes[Ke].name);
          }
          return de;
        }
        getBinderUniforms() {
          const de = [];
          for (const Ce in this.binders) {
            const De = this.binders[Ce];
            if (De instanceof ld || De instanceof yh || De instanceof vc)
              for (const Ke of De.uniformNames)
                de.push(Ke);
          }
          return de;
        }
        getPaintVertexBuffers() {
          return this._buffers;
        }
        getUniforms(de) {
          const Ce = [];
          for (const De in this.binders) {
            const Ke = this.binders[De];
            if (Ke instanceof ld || Ke instanceof yh || Ke instanceof vc)
              for (const Ve of Ke.uniformNames)
                Ce.push({ name: Ve, property: De, binding: Ke.getBinding(de, Ve) });
          }
          return Ce;
        }
        setUniforms(de, Ce, De, Ke, Ve) {
          for (const { name: er, property: fr, binding: wr } of De) {
            if (this.binders[fr].checkUseTheme && this.binders[fr] instanceof ld) {
              const kr = Ke.get(`${fr}-use-theme`);
              kr.isConstant() && (this.binders[fr].ignoreLut = kr.constantOr("default") === "none");
            }
            this.binders[fr].setUniform(de, wr, Ve, Ke.get(fr), er);
          }
        }
        updatePaintBuffers() {
          this._buffers = [];
          for (const de in this.binders) {
            const Ce = this.binders[de];
            (Ce instanceof pl || Ce instanceof vc || Ce instanceof hu) && Ce.paintVertexBuffer && this._buffers.push(Ce.paintVertexBuffer);
          }
        }
        upload(de) {
          for (const Ce in this.binders) {
            const De = this.binders[Ce];
            (De instanceof pl || De instanceof vc || De instanceof hu) && De.upload(de);
          }
          this.updatePaintBuffers();
        }
        destroy() {
          for (const de in this.binders) {
            const Ce = this.binders[de];
            (Ce instanceof pl || Ce instanceof vc || Ce instanceof hu) && Ce.destroy();
          }
        }
      }
      class du {
        constructor(de, Ce, De = () => !0) {
          this.programConfigurations = {};
          for (const Ke of de)
            this.programConfigurations[Ke.id] = new bh(Ke, Ce, De);
          this.needsUpload = !1, this._featureMap = new nf(), this._featureMapWithoutIds = new nf(), this._bufferOffset = 0, this._idlessCounter = 0;
        }
        populatePaintArrays(de, Ce, De, Ke, Ve, er, fr, wr) {
          for (const kr in this.programConfigurations)
            this.programConfigurations[kr].populatePaintArrays(de, Ce, Ke, Ve, er, fr, wr);
          Ce.id !== void 0 ? this._featureMap.add(Ce.id, De, this._bufferOffset, de) : (this._featureMapWithoutIds.add(this._idlessCounter, De, this._bufferOffset, de), this._idlessCounter += 1), this._bufferOffset = de, this.needsUpload = !0;
        }
        updatePaintArrays(de, Ce, De, Ke, Ve, er, fr) {
          for (const wr of De)
            this.needsUpload = this.programConfigurations[wr.id].updatePaintArrays(de, this._featureMap, this._featureMapWithoutIds, Ce, wr, Ke, Ve, er, fr || 0) || this.needsUpload;
        }
        get(de) {
          return this.programConfigurations[de];
        }
        upload(de) {
          if (this.needsUpload) {
            for (const Ce in this.programConfigurations)
              this.programConfigurations[Ce].upload(de);
            this.needsUpload = !1;
          }
        }
        destroy() {
          for (const de in this.programConfigurations)
            this.programConfigurations[de].destroy();
        }
      }
      const lp = { "text-opacity": ["opacity"], "icon-opacity": ["opacity"], "text-occlusion-opacity": ["occlusion_opacity"], "icon-occlusion-opacity": ["occlusion_opacity"], "text-color": ["fill_color"], "icon-color": ["fill_color"], "text-emissive-strength": ["emissive_strength"], "icon-emissive-strength": ["emissive_strength"], "text-halo-color": ["halo_color"], "icon-halo-color": ["halo_color"], "text-halo-blur": ["halo_blur"], "icon-halo-blur": ["halo_blur"], "text-halo-width": ["halo_width"], "icon-halo-width": ["halo_width"], "symbol-z-offset": ["z_offset"], "line-gap-width": ["gapwidth"], "line-pattern": ["pattern", "pixel_ratio"], "fill-pattern": ["pattern", "pixel_ratio"], "fill-extrusion-pattern": ["pattern", "pixel_ratio"], "line-dasharray": ["dash"] };
      function X0(Ie, de) {
        return lp[Ie] || [Ie.replace(`${de}-`, "").replace(/-/g, "_")];
      }
      const fu = { "line-pattern": { source: Ia, composite: Ia }, "fill-pattern": { source: Ia, composite: Ia }, "fill-extrusion-pattern": { source: Ia, composite: Ia }, "line-dasharray": { source: Yf, composite: Yf } }, cd = { color: { source: Lc, composite: cu }, number: { source: rl, composite: Lc } };
      function cp(Ie, de, Ce) {
        const De = fu[Ie];
        return De && De[Ce] || cd[de][Ce];
      }
      Ao(ld, "ConstantBinder"), Ao(yh, "PatternConstantBinder"), Ao(pl, "SourceExpressionBinder"), Ao(hu, "PatternCompositeBinder"), Ao(vc, "CompositeExpressionBinder"), Ao(bh, "ProgramConfiguration", { omit: ["_buffers"] }), Ao(du, "ProgramConfigurationSet");
      const il = vo / Math.PI / 2, ud = 5, Ou = 6, pa = 16383, Yc = 64, cf = [Yc, 32, 16], cl = -il, _c = il;
      function pu(Ie, de, Ce, De = il) {
        return Ce = rn(Ce), [Ie * Math.sin(Ce) * De, -de * De, Ie * Math.cos(Ce) * De];
      }
      function zu(Ie, de, Ce) {
        return pu(Math.cos(rn(Ie)), Math.sin(rn(Ie)), de, Ce);
      }
      const zs = 63710088e-1, Qp = 2 * Math.PI * zs;
      class Ba {
        constructor(de, Ce) {
          if (isNaN(de) || isNaN(Ce))
            throw new Error(`Invalid LngLat object: (${de}, ${Ce})`);
          if (this.lng = +de, this.lat = +Ce, this.lat > 90 || this.lat < -90)
            throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
        }
        wrap() {
          return new Ba(Xo(this.lng, -180, 180), this.lat);
        }
        toArray() {
          return [this.lng, this.lat];
        }
        toString() {
          return `LngLat(${this.lng}, ${this.lat})`;
        }
        distanceTo(de) {
          const Ce = Math.PI / 180, De = this.lat * Ce, Ke = de.lat * Ce, Ve = Math.sin(De) * Math.sin(Ke) + Math.cos(De) * Math.cos(Ke) * Math.cos((de.lng - this.lng) * Ce);
          return zs * Math.acos(Math.min(Ve, 1));
        }
        toBounds(de = 0) {
          const Ce = 360 * de / 40075017, De = Ce / Math.cos(Math.PI / 180 * this.lat);
          return new mu({ lng: this.lng - De, lat: this.lat - Ce }, { lng: this.lng + De, lat: this.lat + Ce });
        }
        toEcef(de) {
          return zu(this.lat, this.lng, il + de * il / zs);
        }
        static convert(de) {
          if (de instanceof Ba)
            return de;
          if (Array.isArray(de) && (de.length === 2 || de.length === 3))
            return new Ba(Number(de[0]), Number(de[1]));
          if (!Array.isArray(de) && typeof de == "object" && de !== null)
            return new Ba(Number("lng" in de ? de.lng : de.lon), Number(de.lat));
          throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
        }
      }
      class mu {
        constructor(de, Ce) {
          if (de)
            if (Ce)
              this.setSouthWest(de).setNorthEast(Ce);
            else if (de.length === 4) {
              const De = de;
              this.setSouthWest([De[0], De[1]]).setNorthEast([De[2], De[3]]);
            } else {
              const De = de;
              this.setSouthWest(De[0]).setNorthEast(De[1]);
            }
        }
        setNorthEast(de) {
          return this._ne = de instanceof Ba ? new Ba(de.lng, de.lat) : Ba.convert(de), this;
        }
        setSouthWest(de) {
          return this._sw = de instanceof Ba ? new Ba(de.lng, de.lat) : Ba.convert(de), this;
        }
        extend(de) {
          const Ce = this._sw, De = this._ne;
          let Ke, Ve;
          if (de instanceof Ba)
            Ke = de, Ve = de;
          else {
            if (!(de instanceof mu))
              return Array.isArray(de) ? de.length === 4 || de.every(Array.isArray) ? this.extend(mu.convert(de)) : this.extend(Ba.convert(de)) : typeof de == "object" && de !== null && de.hasOwnProperty("lat") && (de.hasOwnProperty("lon") || de.hasOwnProperty("lng")) ? this.extend(Ba.convert(de)) : this;
            if (Ke = de._sw, Ve = de._ne, !Ke || !Ve)
              return this;
          }
          return Ce || De ? (Ce.lng = Math.min(Ke.lng, Ce.lng), Ce.lat = Math.min(Ke.lat, Ce.lat), De.lng = Math.max(Ve.lng, De.lng), De.lat = Math.max(Ve.lat, De.lat)) : (this._sw = new Ba(Ke.lng, Ke.lat), this._ne = new Ba(Ve.lng, Ve.lat)), this;
        }
        getCenter() {
          return new Ba((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
        }
        getSouthWest() {
          return this._sw;
        }
        getNorthEast() {
          return this._ne;
        }
        getNorthWest() {
          return new Ba(this.getWest(), this.getNorth());
        }
        getSouthEast() {
          return new Ba(this.getEast(), this.getSouth());
        }
        getWest() {
          return this._sw.lng;
        }
        getSouth() {
          return this._sw.lat;
        }
        getEast() {
          return this._ne.lng;
        }
        getNorth() {
          return this._ne.lat;
        }
        toArray() {
          return [this._sw.toArray(), this._ne.toArray()];
        }
        toString() {
          return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
        }
        isEmpty() {
          return !(this._sw && this._ne);
        }
        contains(de) {
          const { lng: Ce, lat: De } = Ba.convert(de);
          let Ke = this._sw.lng <= Ce && Ce <= this._ne.lng;
          return this._sw.lng > this._ne.lng && (Ke = this._sw.lng >= Ce && Ce >= this._ne.lng), this._sw.lat <= De && De <= this._ne.lat && Ke;
        }
        static convert(de) {
          if (de)
            return de instanceof mu ? de : new mu(de);
        }
      }
      const r0 = 0, up = 25.5;
      function uf(Ie) {
        return Qp * Math.cos(Ie * Math.PI / 180);
      }
      function Fu(Ie) {
        return (180 + Ie) / 360;
      }
      function gu(Ie) {
        return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + Ie * Math.PI / 360))) / 360;
      }
      function As(Ie, de) {
        return Ie / uf(de);
      }
      function bs(Ie) {
        return 360 * Ie - 180;
      }
      function Fs(Ie) {
        return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * Ie) * Math.PI / 180)) - 90;
      }
      function em(Ie, de) {
        return Ie * uf(Fs(de));
      }
      const Es = 85.051129;
      function qe(Ie) {
        return Math.cos(rn(vn(Ie, -Es, Es)));
      }
      function xe(Ie, de) {
        const Ce = vn(de, r0, up), De = Math.pow(2, Ce);
        return qe(Ie) * Qp / (512 * De);
      }
      function ke(Ie) {
        return 1 / Math.cos(Ie * Math.PI / 180);
      }
      function He(Ie, de = 0) {
        const Ce = Math.exp(Math.PI * (1 - (Ie.y + de / vo) / (1 << Ie.z) * 2));
        return 80150034 * Ce / (Ce * Ce + 1) / vo / (1 << Ie.z);
      }
      class ir {
        constructor(de, Ce, De = 0) {
          this.x = +de, this.y = +Ce, this.z = +De;
        }
        static fromLngLat(de, Ce = 0) {
          const De = Ba.convert(de);
          return new ir(Fu(De.lng), gu(De.lat), As(Ce, De.lat));
        }
        toLngLat() {
          return new Ba(bs(this.x), Fs(this.y));
        }
        toAltitude() {
          return em(this.z, this.y);
        }
        meterInMercatorCoordinateUnits() {
          return 1 / Qp * ke(Fs(this.y));
        }
      }
      function ar(Ie, de, Ce, De, Ke, Ve, er, fr, wr) {
        const kr = (de + De) / 2, cr = (Ce + Ke) / 2, Mr = new qi(kr, cr);
        fr(Mr), function(Er, xr, Sr, Br, Fr, jr) {
          const Qr = Sr - Fr, ti = Br - jr;
          return Math.abs((Br - xr) * Qr - (Sr - Er) * ti) / Math.hypot(Qr, ti);
        }(Mr.x, Mr.y, Ve.x, Ve.y, er.x, er.y) >= wr ? (ar(Ie, de, Ce, kr, cr, Ve, Mr, fr, wr), ar(Ie, kr, cr, De, Ke, Mr, er, fr, wr)) : Ie.push(er);
      }
      function yr(Ie, de, Ce) {
        let De = Ie[0], Ke = De.x, Ve = De.y;
        de(De);
        const er = [De];
        for (let fr = 1; fr < Ie.length; fr++) {
          const wr = Ie[fr], { x: kr, y: cr } = wr;
          de(wr), ar(er, Ke, Ve, kr, cr, De, wr, de, Ce), Ke = kr, Ve = cr, De = wr;
        }
        return er;
      }
      function Tr(Ie, de, Ce, De) {
        if (De(de, Ce)) {
          const Ke = de.add(Ce)._mult(0.5);
          Tr(Ie, de, Ke, De), Tr(Ie, Ke, Ce, De);
        } else
          Ie.push(Ce);
      }
      function $r(Ie, de) {
        let Ce = Ie[0];
        const De = [Ce];
        for (let Ke = 1; Ke < Ie.length; Ke++) {
          const Ve = Ie[Ke];
          Tr(De, Ce, Ve, de), Ce = Ve;
        }
        return De;
      }
      const Dr = Math.pow(2, 14) - 1, Or = -Dr - 1;
      function Gr(Ie, de) {
        const Ce = Math.round(Ie.x * de), De = Math.round(Ie.y * de);
        return Ie.x = vn(Ce, Or, Dr), Ie.y = vn(De, Or, Dr), (Ce < Ie.x || Ce > Ie.x + 1 || De < Ie.y || De > Ie.y + 1) && Mn("Geometry exceeds allowed extent, reduce your vector tile buffer size"), Ie;
      }
      function qr(Ie, de, Ce) {
        const De = Ie.loadGeometry(), Ke = Ie.extent, Ve = vo / Ke;
        if (de && Ce && Ce.projection.isReprojectedInTileSpace) {
          const er = 1 << de.z, { scale: fr, x: wr, y: kr, projection: cr } = Ce, Mr = (Er) => {
            const xr = bs((de.x + Er.x / Ke) / er), Sr = Fs((de.y + Er.y / Ke) / er), Br = cr.project(xr, Sr);
            Er.x = (Br.x * fr - wr) * Ke, Er.y = (Br.y * fr - kr) * Ke;
          };
          for (let Er = 0; Er < De.length; Er++)
            if (Ie.type !== 1)
              De[Er] = yr(De[Er], Mr, 1);
            else {
              const xr = [];
              for (const Sr of De[Er])
                Sr.x < 0 || Sr.x >= Ke || Sr.y < 0 || Sr.y >= Ke || (Mr(Sr), xr.push(Sr));
              De[Er] = xr;
            }
        }
        for (const er of De)
          for (const fr of er)
            Gr(fr, Ve);
        return De;
      }
      function Jr(Ie, de) {
        return { type: Ie.type, id: Ie.id, properties: Ie.properties, geometry: de ? qr(Ie) : [] };
      }
      function bi(Ie, de, Ce, De, Ke) {
        Ie.emplaceBack(2 * de + (De + 1) / 2, 2 * Ce + (Ke + 1) / 2);
      }
      function fi(Ie, de, Ce) {
        Ie.emplaceBack(de.x, de.y, de.z, Ce[0] * 16384, Ce[1] * 16384, Ce[2] * 16384);
      }
      class Mi {
        constructor(de) {
          this.zoom = de.zoom, this.overscaling = de.overscaling, this.layers = de.layers, this.layerIds = this.layers.map((Ce) => Ce.fqid), this.index = de.index, this.hasPattern = !1, this.projection = de.projection, this.layoutVertexArray = new Zc(), this.indexArray = new tl(), this.segments = new fs(), this.programConfigurations = new du(de.layers, { zoom: de.zoom, lut: de.lut }), this.stateDependentLayerIds = this.layers.filter((Ce) => Ce.isStateDependent()).map((Ce) => Ce.id);
        }
        updateFootprints(de, Ce) {
        }
        populate(de, Ce, De, Ke) {
          const Ve = this.layers[0], er = [];
          let fr = null;
          Ve.type === "circle" && (fr = Ve.layout.get("circle-sort-key"));
          for (const { feature: kr, id: cr, index: Mr, sourceLayerIndex: Er } of de) {
            const xr = this.layers[0]._featureFilter.needGeometry, Sr = Jr(kr, xr);
            if (!this.layers[0]._featureFilter.filter(new wa(this.zoom), Sr, De))
              continue;
            const Br = fr ? fr.evaluate(Sr, {}, De) : void 0, Fr = { id: cr, properties: kr.properties, type: kr.type, sourceLayerIndex: Er, index: Mr, geometry: xr ? Sr.geometry : qr(kr, De, Ke), patterns: {}, sortKey: Br };
            er.push(Fr);
          }
          fr && er.sort((kr, cr) => kr.sortKey - cr.sortKey);
          let wr = null;
          Ke.projection.name === "globe" && (this.globeExtVertexArray = new Jf(), wr = Ke.projection);
          for (const kr of er) {
            const { geometry: cr, index: Mr, sourceLayerIndex: Er } = kr, xr = de[Mr].feature;
            this.addFeature(kr, cr, Mr, Ce.availableImages, De, wr, Ce.brightness), Ce.featureIndex.insert(xr, cr, Mr, Er, this.index);
          }
        }
        update(de, Ce, De, Ke, Ve, er, fr) {
          this.programConfigurations.updatePaintArrays(de, Ce, Ve, De, Ke, er, fr);
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(de) {
          this.uploaded || (this.layoutVertexBuffer = de.createVertexBuffer(this.layoutVertexArray, Jp.members), this.indexBuffer = de.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = de.createVertexBuffer(this.globeExtVertexArray, Z0.members))), this.programConfigurations.upload(de), this.uploaded = !0;
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy());
        }
        addFeature(de, Ce, De, Ke, Ve, er, fr) {
          for (const wr of Ce)
            for (const kr of wr) {
              const cr = kr.x, Mr = kr.y;
              if (cr < 0 || cr >= vo || Mr < 0 || Mr >= vo)
                continue;
              if (er) {
                const Sr = er.projectTilePoint(cr, Mr, Ve), Br = er.upVector(Ve, cr, Mr), Fr = this.globeExtVertexArray;
                fi(Fr, Sr, Br), fi(Fr, Sr, Br), fi(Fr, Sr, Br), fi(Fr, Sr, Br);
              }
              const Er = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, de.sortKey), xr = Er.vertexLength;
              bi(this.layoutVertexArray, cr, Mr, -1, -1), bi(this.layoutVertexArray, cr, Mr, 1, -1), bi(this.layoutVertexArray, cr, Mr, 1, 1), bi(this.layoutVertexArray, cr, Mr, -1, 1), this.indexArray.emplaceBack(xr, xr + 1, xr + 2), this.indexArray.emplaceBack(xr, xr + 2, xr + 3), Er.vertexLength += 4, Er.primitiveLength += 2;
            }
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, de, De, {}, Ke, Ve, fr);
        }
      }
      function Ei(Ie, de) {
        for (let Ce = 0; Ce < Ie.length; Ce++)
          if (dn(de, Ie[Ce]))
            return !0;
        for (let Ce = 0; Ce < de.length; Ce++)
          if (dn(Ie, de[Ce]))
            return !0;
        return !!Ki(Ie, de);
      }
      function Ii(Ie, de, Ce) {
        return !!dn(Ie, de) || !!Xi(de, Ie, Ce);
      }
      function Ni(Ie, de) {
        if (Ie.length === 1)
          return nn(de, Ie[0]);
        for (let Ce = 0; Ce < de.length; Ce++) {
          const De = de[Ce];
          for (let Ke = 0; Ke < De.length; Ke++)
            if (dn(Ie, De[Ke]))
              return !0;
        }
        for (let Ce = 0; Ce < Ie.length; Ce++)
          if (nn(de, Ie[Ce]))
            return !0;
        for (let Ce = 0; Ce < de.length; Ce++)
          if (Ki(Ie, de[Ce]))
            return !0;
        return !1;
      }
      function zi(Ie, de, Ce) {
        if (Ie.length > 1) {
          if (Ki(Ie, de))
            return !0;
          for (let De = 0; De < de.length; De++)
            if (Xi(de[De], Ie, Ce))
              return !0;
        }
        for (let De = 0; De < Ie.length; De++)
          if (Xi(Ie[De], de, Ce))
            return !0;
        return !1;
      }
      function Ki(Ie, de) {
        if (Ie.length === 0 || de.length === 0)
          return !1;
        for (let Ce = 0; Ce < Ie.length - 1; Ce++) {
          const De = Ie[Ce], Ke = Ie[Ce + 1];
          for (let Ve = 0; Ve < de.length - 1; Ve++)
            if (Wi(De, Ke, de[Ve], de[Ve + 1]))
              return !0;
        }
        return !1;
      }
      function Wi(Ie, de, Ce, De) {
        return pn(Ie, Ce, De) !== pn(de, Ce, De) && pn(Ie, de, Ce) !== pn(Ie, de, De);
      }
      function Xi(Ie, de, Ce) {
        const De = Ce * Ce;
        if (de.length === 1)
          return Ie.distSqr(de[0]) < De;
        for (let Ke = 1; Ke < de.length; Ke++)
          if (Gi(Ie, de[Ke - 1], de[Ke]) < De)
            return !0;
        return !1;
      }
      function Gi(Ie, de, Ce) {
        const De = de.distSqr(Ce);
        if (De === 0)
          return Ie.distSqr(de);
        const Ke = ((Ie.x - de.x) * (Ce.x - de.x) + (Ie.y - de.y) * (Ce.y - de.y)) / De;
        return Ie.distSqr(Ke < 0 ? de : Ke > 1 ? Ce : Ce.sub(de)._mult(Ke)._add(de));
      }
      function nn(Ie, de) {
        let Ce, De, Ke, Ve = !1;
        for (let er = 0; er < Ie.length; er++) {
          Ce = Ie[er];
          for (let fr = 0, wr = Ce.length - 1; fr < Ce.length; wr = fr++)
            De = Ce[fr], Ke = Ce[wr], De.y > de.y != Ke.y > de.y && de.x < (Ke.x - De.x) * (de.y - De.y) / (Ke.y - De.y) + De.x && (Ve = !Ve);
        }
        return Ve;
      }
      function dn(Ie, de) {
        let Ce = !1;
        for (let De = 0, Ke = Ie.length - 1; De < Ie.length; Ke = De++) {
          const Ve = Ie[De], er = Ie[Ke];
          Ve.y > de.y != er.y > de.y && de.x < (er.x - Ve.x) * (de.y - Ve.y) / (er.y - Ve.y) + Ve.x && (Ce = !Ce);
        }
        return Ce;
      }
      function Pn(Ie, de, Ce, De, Ke) {
        for (const er of Ie)
          if (de <= er.x && Ce <= er.y && De >= er.x && Ke >= er.y)
            return !0;
        const Ve = [new qi(de, Ce), new qi(de, Ke), new qi(De, Ke), new qi(De, Ce)];
        if (Ie.length > 2) {
          for (const er of Ve)
            if (dn(Ie, er))
              return !0;
        }
        for (let er = 0; er < Ie.length - 1; er++)
          if (Ln(Ie[er], Ie[er + 1], Ve))
            return !0;
        return !1;
      }
      function Ln(Ie, de, Ce) {
        const De = Ce[0], Ke = Ce[2];
        if (Ie.x < De.x && de.x < De.x || Ie.x > Ke.x && de.x > Ke.x || Ie.y < De.y && de.y < De.y || Ie.y > Ke.y && de.y > Ke.y)
          return !1;
        const Ve = pn(Ie, de, Ce[0]);
        return Ve !== pn(Ie, de, Ce[1]) || Ve !== pn(Ie, de, Ce[2]) || Ve !== pn(Ie, de, Ce[3]);
      }
      function hn(Ie, de, Ce, De, Ke, Ve) {
        let er = de.y - Ie.y, fr = Ie.x - de.x;
        if (Ve = Ve || 0) {
          const wr = er * er + fr * fr;
          if (wr === 0)
            return !0;
          const kr = Math.sqrt(wr);
          er /= kr, fr /= kr;
        }
        return !((Ce.x - Ie.x) * er + (Ce.y - Ie.y) * fr - Ve < 0 || (De.x - Ie.x) * er + (De.y - Ie.y) * fr - Ve < 0 || (Ke.x - Ie.x) * er + (Ke.y - Ie.y) * fr - Ve < 0);
      }
      function xn(Ie, de, Ce, De, Ke, Ve, er) {
        return !(hn(Ie, de, De, Ke, Ve, er) || hn(de, Ce, De, Ke, Ve, er) || hn(Ce, Ie, De, Ke, Ve, er) || hn(De, Ke, Ie, de, Ce, er) || hn(Ke, Ve, Ie, de, Ce, er) || hn(Ve, De, Ie, de, Ce, er));
      }
      function Hn(Ie, de, Ce) {
        const De = de.paint.get(Ie).value;
        return De.kind === "constant" ? De.value : Ce.programConfigurations.get(de.id).getMaxValue(Ie);
      }
      function io(Ie) {
        return Math.sqrt(Ie[0] * Ie[0] + Ie[1] * Ie[1]);
      }
      function uo(Ie, de, Ce, De, Ke) {
        if (!de[0] && !de[1])
          return Ie;
        const Ve = qi.convert(de)._mult(Ke);
        Ce === "viewport" && Ve._rotate(-De);
        const er = [];
        for (let fr = 0; fr < Ie.length; fr++)
          er.push(Ie[fr].sub(Ve));
        return er;
      }
      function An(Ie, de, Ce, De) {
        const Ke = qi.convert(Ie)._mult(De);
        return de === "viewport" && Ke._rotate(-Ce), Ke;
      }
      let eo, On;
      Ao(Mi, "CircleBucket", { omit: ["layers"] });
      var ao, ro = { exports: {} }, Wn = (ao || (ao = 1, function(Ie, de) {
        (function(Ce) {
          function De(Ve, er, fr) {
            var wr = Ke(256 * Ve, 256 * (er = Math.pow(2, fr) - er - 1), fr), kr = Ke(256 * (Ve + 1), 256 * (er + 1), fr);
            return wr[0] + "," + wr[1] + "," + kr[0] + "," + kr[1];
          }
          function Ke(Ve, er, fr) {
            var wr = 2 * Math.PI * 6378137 / 256 / Math.pow(2, fr);
            return [Ve * wr - 2 * Math.PI * 6378137 / 2, er * wr - 2 * Math.PI * 6378137 / 2];
          }
          Ce.getURL = function(Ve, er, fr, wr, kr, cr) {
            return cr = cr || {}, Ve + "?" + ["bbox=" + De(fr, wr, kr), "format=" + (cr.format || "image/png"), "service=" + (cr.service || "WMS"), "version=" + (cr.version || "1.1.1"), "request=" + (cr.request || "GetMap"), "srs=" + (cr.srs || "EPSG:3857"), "width=" + (cr.width || 256), "height=" + (cr.height || 256), "layers=" + er].join("&");
          }, Ce.getTileBBox = De, Ce.getMercCoords = Ke, Object.defineProperty(Ce, "__esModule", { value: !0 });
        })(de);
      }(0, ro.exports)), ro.exports);
      class _o {
        constructor(de, Ce, De) {
          this.z = de, this.x = Ce, this.y = De, this.key = Eo(0, de, de, Ce, De);
        }
        equals(de) {
          return this.z === de.z && this.x === de.x && this.y === de.y;
        }
        url(de, Ce) {
          const De = Wn.getTileBBox(this.x, this.y, this.z), Ke = function(Ve, er, fr) {
            let wr, kr = "";
            for (let cr = Ve; cr > 0; cr--)
              wr = 1 << cr - 1, kr += (er & wr ? 1 : 0) + (fr & wr ? 2 : 0);
            return kr;
          }(this.z, this.x, this.y);
          return de[(this.x + this.y) % de.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String(Ce === "tms" ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", Ke).replace("{bbox-epsg-3857}", De);
        }
        toString() {
          return `${this.z}/${this.x}/${this.y}`;
        }
      }
      class yo {
        constructor(de, Ce) {
          this.wrap = de, this.canonical = Ce, this.key = Eo(de, Ce.z, Ce.z, Ce.x, Ce.y);
        }
      }
      class mo {
        constructor(de, Ce, De, Ke, Ve) {
          this.overscaledZ = de, this.wrap = Ce, this.canonical = new _o(De, +Ke, +Ve), this.key = Ce === 0 && de === De ? this.canonical.key : Eo(Ce, de, De, Ke, Ve);
        }
        equals(de) {
          return this.overscaledZ === de.overscaledZ && this.wrap === de.wrap && this.canonical.equals(de.canonical);
        }
        scaledTo(de) {
          const Ce = this.canonical.z - de;
          return de > this.canonical.z ? new mo(de, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new mo(de, this.wrap, de, this.canonical.x >> Ce, this.canonical.y >> Ce);
        }
        calculateScaledKey(de, Ce = !0) {
          if (this.overscaledZ === de && Ce)
            return this.key;
          if (de > this.canonical.z)
            return Eo(this.wrap * +Ce, de, this.canonical.z, this.canonical.x, this.canonical.y);
          {
            const De = this.canonical.z - de;
            return Eo(this.wrap * +Ce, de, de, this.canonical.x >> De, this.canonical.y >> De);
          }
        }
        isChildOf(de) {
          if (de.wrap !== this.wrap)
            return !1;
          const Ce = this.canonical.z - de.canonical.z;
          return de.overscaledZ === 0 || de.overscaledZ < this.overscaledZ && de.canonical.z < this.canonical.z && de.canonical.x === this.canonical.x >> Ce && de.canonical.y === this.canonical.y >> Ce;
        }
        children(de) {
          if (this.overscaledZ >= de)
            return [new mo(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)];
          const Ce = this.canonical.z + 1, De = 2 * this.canonical.x, Ke = 2 * this.canonical.y;
          return [new mo(Ce, this.wrap, Ce, De, Ke), new mo(Ce, this.wrap, Ce, De + 1, Ke), new mo(Ce, this.wrap, Ce, De, Ke + 1), new mo(Ce, this.wrap, Ce, De + 1, Ke + 1)];
        }
        isLessThan(de) {
          return this.wrap < de.wrap || !(this.wrap > de.wrap) && (this.overscaledZ < de.overscaledZ || !(this.overscaledZ > de.overscaledZ) && (this.canonical.x < de.canonical.x || !(this.canonical.x > de.canonical.x) && this.canonical.y < de.canonical.y));
        }
        wrapped() {
          return new mo(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
        }
        unwrapTo(de) {
          return new mo(this.overscaledZ, de, this.canonical.z, this.canonical.x, this.canonical.y);
        }
        overscaleFactor() {
          return Math.pow(2, this.overscaledZ - this.canonical.z);
        }
        toUnwrapped() {
          return new yo(this.wrap, this.canonical);
        }
        toString() {
          return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
        }
      }
      function Eo(Ie, de, Ce, De, Ke) {
        const Ve = 1 << Math.min(Ce, 22);
        let er = Ve * (Ke % Ve) + De % Ve;
        return Ie && Ce < 22 && (er += Ve * Ve * ((Ie < 0 ? -2 * Ie - 1 : 2 * Ie) % (1 << 2 * (22 - Ce)))), 16 * (32 * er + Ce) + (de - Ce);
      }
      const Ko = [(Ie) => {
        let de = Ie.canonical.x - 1, Ce = Ie.wrap;
        return de < 0 && (de = (1 << Ie.canonical.z) - 1, Ce--), new mo(Ie.overscaledZ, Ce, Ie.canonical.z, de, Ie.canonical.y);
      }, (Ie) => {
        let de = Ie.canonical.x + 1, Ce = Ie.wrap;
        return de === 1 << Ie.canonical.z && (de = 0, Ce++), new mo(Ie.overscaledZ, Ce, Ie.canonical.z, de, Ie.canonical.y);
      }, (Ie) => new mo(Ie.overscaledZ, Ie.wrap, Ie.canonical.z, Ie.canonical.x, (Ie.canonical.y === 0 ? 1 << Ie.canonical.z : Ie.canonical.y) - 1), (Ie) => new mo(Ie.overscaledZ, Ie.wrap, Ie.canonical.z, Ie.canonical.x, Ie.canonical.y === (1 << Ie.canonical.z) - 1 ? 0 : Ie.canonical.y + 1)];
      Ao(_o, "CanonicalTileID"), Ao(mo, "OverscaledTileID", { omit: ["projMatrix", "expandedProjMatrix"] });
      const Fo = La([{ type: "Float32", name: "a_globe_pos", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }]), { members: zo } = Fo, Jo = La([{ name: "a_pos_3", components: 3, type: "Int16" }]);
      var ia = La([{ name: "a_pos", type: "Int16", components: 2 }]);
      class sa {
        constructor(de, Ce) {
          this.pos = de, this.dir = Ce;
        }
        intersectsPlane(de, Ce, De) {
          const Ke = Zr.vec3.dot(Ce, this.dir);
          if (Math.abs(Ke) < 1e-6)
            return !1;
          const Ve = ((de[0] - this.pos[0]) * Ce[0] + (de[1] - this.pos[1]) * Ce[1] + (de[2] - this.pos[2]) * Ce[2]) / Ke;
          return De[0] = this.pos[0] + this.dir[0] * Ve, De[1] = this.pos[1] + this.dir[1] * Ve, De[2] = this.pos[2] + this.dir[2] * Ve, !0;
        }
        closestPointOnSphere(de, Ce, De) {
          if (Zr.vec3.equals(this.pos, de) || Ce === 0)
            return De[0] = De[1] = De[2] = 0, !1;
          const [Ke, Ve, er] = this.dir, fr = this.pos[0] - de[0], wr = this.pos[1] - de[1], kr = this.pos[2] - de[2], cr = Ke * Ke + Ve * Ve + er * er, Mr = 2 * (fr * Ke + wr * Ve + kr * er), Er = Mr * Mr - 4 * cr * (fr * fr + wr * wr + kr * kr - Ce * Ce);
          if (Er < 0) {
            const xr = Math.max(-Mr / 2, 0), Sr = fr + Ke * xr, Br = wr + Ve * xr, Fr = kr + er * xr, jr = Math.hypot(Sr, Br, Fr);
            return De[0] = Sr * Ce / jr, De[1] = Br * Ce / jr, De[2] = Fr * Ce / jr, !1;
          }
          {
            const xr = (-Mr - Math.sqrt(Er)) / (2 * cr);
            if (xr < 0) {
              const Sr = Math.hypot(fr, wr, kr);
              return De[0] = fr * Ce / Sr, De[1] = wr * Ce / Sr, De[2] = kr * Ce / Sr, !1;
            }
            return De[0] = fr + Ke * xr, De[1] = wr + Ve * xr, De[2] = kr + er * xr, !0;
          }
        }
      }
      class ss {
        constructor(de, Ce, De, Ke, Ve) {
          this.TL = de, this.TR = Ce, this.BR = De, this.BL = Ke, this.horizon = Ve;
        }
        static fromInvProjectionMatrix(de, Ce, De) {
          const Ke = [-1, 1, 1], Ve = [1, 1, 1], er = [1, -1, 1], fr = [-1, -1, 1], wr = Zr.vec3.transformMat4(Ke, Ke, de), kr = Zr.vec3.transformMat4(Ve, Ve, de), cr = Zr.vec3.transformMat4(er, er, de), Mr = Zr.vec3.transformMat4(fr, fr, de);
          return new ss(wr, kr, cr, Mr, Ce / De);
        }
      }
      function Ya(Ie, de, Ce) {
        let De = 1 / 0, Ke = -1 / 0;
        const Ve = [];
        for (const er of Ie) {
          Zr.vec3.sub(Ve, er, de);
          const fr = Zr.vec3.dot(Ve, Ce);
          De = Math.min(De, fr), Ke = Math.max(Ke, fr);
        }
        return [De, Ke];
      }
      function Oa(Ie, de) {
        let Ce = !0;
        for (let De = 0; De < Ie.planes.length; De++) {
          const Ke = Ie.planes[De];
          let Ve = 0;
          for (let er = 0; er < de.length; er++)
            Ve += Zr.vec3.dot(Ke, de[er]) + Ke[3] >= 0;
          if (Ve === 0)
            return 0;
          Ve !== de.length && (Ce = !1);
        }
        return Ce ? 2 : 1;
      }
      function Na(Ie, de) {
        for (const Ce of Ie.projections) {
          const De = Ya(de, Ie.points[0], Ce.axis);
          if (Ce.projection[1] < De[0] || Ce.projection[0] > De[1])
            return 0;
        }
        return 1;
      }
      function la(Ie, de) {
        let Ce = 0;
        const De = [0, 0, 0, 0];
        for (let Ke = 0; Ke < Ie.length; Ke++)
          De[0] = Ie[Ke][0], De[1] = Ie[Ke][1], De[2] = Ie[Ke][2], De[3] = 1, Zr.vec4.dot(De, de) >= 0 && Ce++;
        return Ce;
      }
      class _a {
        constructor(de, Ce) {
          this.points = de || new Array(8).fill([0, 0, 0]), this.planes = Ce || new Array(6).fill([0, 0, 0, 0]), this.bounds = qo.fromPoints(this.points), this.projections = [], this.frustumEdges = [Zr.vec3.sub([], this.points[2], this.points[3]), Zr.vec3.sub([], this.points[0], this.points[3]), Zr.vec3.sub([], this.points[4], this.points[0]), Zr.vec3.sub([], this.points[5], this.points[1]), Zr.vec3.sub([], this.points[6], this.points[2]), Zr.vec3.sub([], this.points[7], this.points[3])];
          for (const De of this.frustumEdges) {
            const Ke = [0, -De[2], De[1]], Ve = [De[2], 0, -De[0]];
            this.projections.push({ axis: Ke, projection: Ya(this.points, this.points[0], Ke) }), this.projections.push({ axis: Ve, projection: Ya(this.points, this.points[0], Ve) });
          }
        }
        static fromInvProjectionMatrix(de, Ce, De, Ke) {
          const Ve = Math.pow(2, De), er = [[-1, 1, -1, 1], [1, 1, -1, 1], [1, -1, -1, 1], [-1, -1, -1, 1], [-1, 1, 1, 1], [1, 1, 1, 1], [1, -1, 1, 1], [-1, -1, 1, 1]].map((kr) => {
            const cr = Zr.vec4.transformMat4([], kr, de), Mr = 1 / cr[3] / Ce * Ve;
            return Zr.vec4.mul(cr, cr, [Mr, Mr, Ke ? 1 / cr[3] : Mr, Mr]);
          }), fr = [[0, 1, 2], [6, 5, 4], [0, 3, 7], [2, 1, 5], [3, 2, 6], [0, 4, 5]].map((kr) => {
            const cr = Zr.vec3.sub([], er[kr[0]], er[kr[1]]), Mr = Zr.vec3.sub([], er[kr[2]], er[kr[1]]), Er = Zr.vec3.normalize([], Zr.vec3.cross([], cr, Mr)), xr = -Zr.vec3.dot(Er, er[kr[1]]);
            return Er.concat(xr);
          }), wr = [];
          for (let kr = 0; kr < er.length; kr++)
            wr.push([er[kr][0], er[kr][1], er[kr][2]]);
          return new _a(wr, fr);
        }
        intersectsPrecise(de, Ce, De) {
          for (let Ke = 0; Ke < Ce.length; Ke++)
            if (!la(de, Ce[Ke]))
              return 0;
          for (let Ke = 0; Ke < this.planes.length; Ke++)
            if (!la(de, this.planes[Ke]))
              return 0;
          for (const Ke of De)
            for (const Ve of this.frustumEdges) {
              const er = Zr.vec3.cross([], Ke, Ve), fr = Zr.vec3.length(er);
              if (fr === 0)
                continue;
              Zr.vec3.scale(er, er, 1 / fr);
              const wr = Ya(this.points, this.points[0], er), kr = Ya(de, this.points[0], er);
              if (wr[0] > kr[1] || kr[0] > wr[1])
                return 0;
            }
          return 1;
        }
        containsPoint(de) {
          for (const Ce of this.planes) {
            const De = Ce[3];
            if (Zr.vec3.dot([Ce[0], Ce[1], Ce[2]], de) + De < 0)
              return !1;
          }
          return !0;
        }
      }
      class qo {
        static fromPoints(de) {
          const Ce = [1 / 0, 1 / 0, 1 / 0], De = [-1 / 0, -1 / 0, -1 / 0];
          for (const Ke of de)
            Zr.vec3.min(Ce, Ce, Ke), Zr.vec3.max(De, De, Ke);
          return new qo(Ce, De);
        }
        static fromTileIdAndHeight(de, Ce, De) {
          const Ke = 1 << de.canonical.z, Ve = de.canonical.x, er = de.canonical.y;
          return new qo([Ve / Ke, er / Ke, Ce], [(Ve + 1) / Ke, (er + 1) / Ke, De]);
        }
        static applyTransform(de, Ce) {
          const De = de.getCorners();
          for (let Ke = 0; Ke < De.length; ++Ke)
            Zr.vec3.transformMat4(De[Ke], De[Ke], Ce);
          return qo.fromPoints(De);
        }
        static applyTransformFast(de, Ce) {
          const De = [Ce[12], Ce[13], Ce[14]], Ke = [...De];
          for (let Ve = 0; Ve < 3; Ve++)
            for (let er = 0; er < 3; er++) {
              const fr = Ce[4 * er + Ve], wr = fr * de.min[er], kr = fr * de.max[er];
              De[Ve] += Math.min(wr, kr), Ke[Ve] += Math.max(wr, kr);
            }
          return new qo(De, Ke);
        }
        static projectAabbCorners(de, Ce) {
          const De = de.getCorners();
          for (let Ke = 0; Ke < De.length; ++Ke)
            Zr.vec3.transformMat4(De[Ke], De[Ke], Ce);
          return De;
        }
        constructor(de, Ce) {
          this.min = de, this.max = Ce, this.center = Zr.vec3.scale([], Zr.vec3.add([], this.min, this.max), 0.5);
        }
        quadrant(de) {
          const Ce = [de % 2 == 0, de < 2], De = Zr.vec3.clone(this.min), Ke = Zr.vec3.clone(this.max);
          for (let Ve = 0; Ve < Ce.length; Ve++)
            De[Ve] = Ce[Ve] ? this.min[Ve] : this.center[Ve], Ke[Ve] = Ce[Ve] ? this.center[Ve] : this.max[Ve];
          return Ke[2] = this.max[2], new qo(De, Ke);
        }
        distanceX(de) {
          return Math.max(Math.min(this.max[0], de[0]), this.min[0]) - de[0];
        }
        distanceY(de) {
          return Math.max(Math.min(this.max[1], de[1]), this.min[1]) - de[1];
        }
        distanceZ(de) {
          return Math.max(Math.min(this.max[2], de[2]), this.min[2]) - de[2];
        }
        getCorners() {
          const de = this.min, Ce = this.max;
          return [[de[0], de[1], de[2]], [Ce[0], de[1], de[2]], [Ce[0], Ce[1], de[2]], [de[0], Ce[1], de[2]], [de[0], de[1], Ce[2]], [Ce[0], de[1], Ce[2]], [Ce[0], Ce[1], Ce[2]], [de[0], Ce[1], Ce[2]]];
        }
        intersects(de) {
          return this.intersectsAabb(de.bounds) ? Oa(de, this.getCorners()) : 0;
        }
        intersectsFlat(de) {
          return this.intersectsAabb(de.bounds) ? Oa(de, [[this.min[0], this.min[1], 0], [this.max[0], this.min[1], 0], [this.max[0], this.max[1], 0], [this.min[0], this.max[1], 0]]) : 0;
        }
        intersectsPrecise(de, Ce) {
          return Ce || this.intersects(de) ? Na(de, this.getCorners()) : 0;
        }
        intersectsPreciseFlat(de, Ce) {
          return Ce || this.intersectsFlat(de) ? Na(de, [[this.min[0], this.min[1], 0], [this.max[0], this.min[1], 0], [this.max[0], this.max[1], 0], [this.min[0], this.max[1], 0]]) : 0;
        }
        intersectsAabb(de) {
          for (let Ce = 0; Ce < 3; ++Ce)
            if (this.min[Ce] > de.max[Ce] || de.min[Ce] > this.max[Ce])
              return !1;
          return !0;
        }
        intersectsAabbXY(de) {
          return !(this.min[0] > de.max[0] || de.min[0] > this.max[0] || this.min[1] > de.max[1] || de.min[1] > this.max[1]);
        }
        encapsulate(de) {
          for (let Ce = 0; Ce < 3; Ce++)
            this.min[Ce] = Math.min(this.min[Ce], de.min[Ce]), this.max[Ce] = Math.max(this.max[Ce], de.max[Ce]);
        }
        encapsulatePoint(de) {
          for (let Ce = 0; Ce < 3; Ce++)
            this.min[Ce] = Math.min(this.min[Ce], de[Ce]), this.max[Ce] = Math.max(this.max[Ce], de[Ce]);
        }
        closestPoint(de) {
          return [Math.max(Math.min(this.max[0], de[0]), this.min[0]), Math.max(Math.min(this.max[1], de[1]), this.min[1]), Math.max(Math.min(this.max[2], de[2]), this.min[2])];
        }
      }
      function Aa(Ie) {
        return Ie * il / zs;
      }
      Ao(qo, "Aabb");
      const ps = [new qo([cl, cl, cl], [_c, _c, _c]), new qo([cl, cl, cl], [0, 0, _c]), new qo([0, cl, cl], [_c, 0, _c]), new qo([cl, 0, cl], [0, _c, _c]), new qo([0, 0, cl], [_c, _c, _c])];
      function Xs(Ie, de, Ce, De = !0) {
        const Ke = Zr.vec3.scale([], Ie._camera.position, Ie.worldSize), Ve = [de, Ce, 1, 1];
        Zr.vec4.transformMat4(Ve, Ve, Ie.pixelMatrixInverse), Zr.vec4.scale(Ve, Ve, 1 / Ve[3]);
        const er = Zr.vec3.sub([], Ve, Ke), fr = Zr.vec3.normalize([], er), wr = Ie.globeMatrix, kr = [wr[12], wr[13], wr[14]], cr = Zr.vec3.sub([], kr, Ke), Mr = Zr.vec3.length(cr), Er = Zr.vec3.normalize([], cr), xr = Ie.worldSize / (2 * Math.PI), Sr = Zr.vec3.dot(Er, fr), Br = Math.asin(xr / Mr);
        if (Br < Math.acos(Sr)) {
          if (!De)
            return null;
          const Ji = [], Fi = [];
          Zr.vec3.scale(Ji, fr, Mr / Sr), Zr.vec3.normalize(Fi, Zr.vec3.sub(Fi, Ji, cr)), Zr.vec3.normalize(fr, Zr.vec3.add(fr, cr, Zr.vec3.scale(fr, Fi, Math.tan(Br) * Mr)));
        }
        const Fr = [];
        new sa(Ke, fr).closestPointOnSphere(kr, xr, Fr);
        const jr = Zr.vec3.normalize([], Qn(wr, 0)), Qr = Zr.vec3.normalize([], Qn(wr, 1)), ti = Zr.vec3.normalize([], Qn(wr, 2)), Kr = Zr.vec3.dot(jr, Fr), ni = Zr.vec3.dot(Qr, Fr), gi = Zr.vec3.dot(ti, Fr), Si = ji(Math.asin(-ni / xr));
        let Di = ji(Math.atan2(Kr, gi));
        Di = Ie.center.lng + function(Ji, Fi) {
          const tn = (Fi - Ji + 180) % 360 - 180;
          return tn < -180 ? tn + 360 : tn;
        }(Ie.center.lng, Di);
        const Ri = Fu(Di), Bi = vn(gu(Si), 0, 1);
        return new ir(Ri, Bi);
      }
      class ql {
        constructor(de, Ce, De) {
          this.a = Zr.vec3.sub([], de, De), this.b = Zr.vec3.sub([], Ce, De), this.center = De;
          const Ke = Zr.vec3.normalize([], this.a), Ve = Zr.vec3.normalize([], this.b);
          this.angle = Math.acos(Zr.vec3.dot(Ke, Ve));
        }
      }
      function ml(Ie, de) {
        if (Ie.angle === 0)
          return null;
        let Ce;
        return Ce = Ie.a[de] === 0 ? 1 / Ie.angle * 0.5 * Math.PI : 1 / Ie.angle * Math.atan(Ie.b[de] / Ie.a[de] / Math.sin(Ie.angle) - 1 / Math.tan(Ie.angle)), Ce < 0 || Ce > 1 ? null : function(De, Ke, Ve, er) {
          const fr = Math.sin(Ve);
          return De * (Math.sin((1 - er) * Ve) / fr) + Ke * (Math.sin(er * Ve) / fr);
        }(Ie.a[de], Ie.b[de], Ie.angle, vn(Ce, 0, 1)) + Ie.center[de];
      }
      function Ns(Ie) {
        if (Ie.z <= 1)
          return ps[Ie.z + 2 * Ie.y + Ie.x];
        const de = Ma(Za(Ie));
        return qo.fromPoints(de);
      }
      function ks(Ie, de, Ce) {
        return Zr.vec3.scale(Ie, Ie, 1 - Ce), Zr.vec3.scaleAndAdd(Ie, Ie, de, Ce);
      }
      function Cs(Ie, de, Ce) {
        for (const De of Ie)
          Zr.vec3.transformMat4(De, De, de), Zr.vec3.scale(De, De, Ce);
      }
      function is(Ie, de, Ce, De) {
        const Ke = de / Ie.worldSize, Ve = Ie.globeMatrix;
        if (Ce.z <= 1) {
          const Ri = Ns(Ce).getCorners();
          return Cs(Ri, Ve, Ke), qo.fromPoints(Ri);
        }
        const er = Za(Ce, De), fr = Ma(er, il + Aa(Ie._tileCoverLift));
        Cs(fr, Ve, Ke);
        const wr = Number.MAX_VALUE, kr = [-wr, -wr, -wr], cr = [wr, wr, wr];
        if (er.contains(Ie.center)) {
          for (const Ji of fr)
            Zr.vec3.min(cr, cr, Ji), Zr.vec3.max(kr, kr, Ji);
          kr[2] = 0;
          const Ri = Ie.point, Bi = [Ri.x * Ke, Ri.y * Ke, 0];
          return Zr.vec3.min(cr, cr, Bi), Zr.vec3.max(kr, kr, Bi), new qo(cr, kr);
        }
        if (Ie._tileCoverLift > 0) {
          for (const Ri of fr)
            Zr.vec3.min(cr, cr, Ri), Zr.vec3.max(kr, kr, Ri);
          return new qo(cr, kr);
        }
        const Mr = [Ve[12] * Ke, Ve[13] * Ke, Ve[14] * Ke], Er = er.getCenter(), xr = vn(Ie.center.lat, -Es, Es), Sr = vn(Er.lat, -Es, Es), Br = Fu(Ie.center.lng), Fr = gu(xr);
        let jr = Br - Fu(Er.lng);
        const Qr = Fr - gu(Sr);
        jr > 0.5 ? jr -= 1 : jr < -0.5 && (jr += 1);
        let ti = 0;
        if (Math.abs(jr) > Math.abs(Qr))
          ti = jr >= 0 ? 1 : 3;
        else {
          ti = Qr >= 0 ? 0 : 2;
          const Ri = [Ve[4] * Ke, Ve[5] * Ke, Ve[6] * Ke], Bi = -Math.sin(rn(Qr >= 0 ? er.getSouth() : er.getNorth())) * il;
          Zr.vec3.scaleAndAdd(Mr, Mr, Ri, Bi);
        }
        const Kr = fr[ti], ni = fr[(ti + 1) % 4], gi = new ql(Kr, ni, Mr), Si = [ml(gi, 0) || Kr[0], ml(gi, 1) || Kr[1], ml(gi, 2) || Kr[2]], Di = gl(Ie.zoom);
        if (Di > 0) {
          const Ri = function({ x: Ji, y: Fi, z: tn }, cn, ln, mn, wn) {
            const Cn = 1 / (1 << tn);
            let gn = Ji * Cn, Nn = gn + Cn, oo = Fi * Cn, Un = oo + Cn, fo = 0;
            const ho = (gn + Nn) / 2 - mn;
            return ho > 0.5 ? fo = -1 : ho < -0.5 && (fo = 1), gn = ((gn + fo) * cn - (mn *= cn)) * ln + mn, Nn = ((Nn + fo) * cn - mn) * ln + mn, oo = (oo * cn - (wn *= cn)) * ln + wn, Un = (Un * cn - wn) * ln + wn, [[gn, Un, 0], [Nn, Un, 0], [Nn, oo, 0], [gn, oo, 0]];
          }(Ce, de, Ie._pixelsPerMercatorPixel, Br, Fr);
          for (let Ji = 0; Ji < fr.length; Ji++)
            ks(fr[Ji], Ri[Ji], Di);
          const Bi = Zr.vec3.add([], Ri[ti], Ri[(ti + 1) % 4]);
          Zr.vec3.scale(Bi, Bi, 0.5), ks(Si, Bi, Di);
        }
        for (const Ri of fr)
          Zr.vec3.min(cr, cr, Ri), Zr.vec3.max(kr, kr, Ri);
        return cr[2] = Math.min(Kr[2], ni[2]), Zr.vec3.min(cr, cr, Si), Zr.vec3.max(kr, kr, Si), new qo(cr, kr);
      }
      function Za({ x: Ie, y: de, z: Ce }, De = !1) {
        const Ke = 1 / (1 << Ce), Ve = new Ba(bs(Ie * Ke), de === (1 << Ce) - 1 && De ? -90 : Fs((de + 1) * Ke)), er = new Ba(bs((Ie + 1) * Ke), de === 0 && De ? 90 : Fs(de * Ke));
        return new mu(Ve, er);
      }
      function Ma(Ie, de = il) {
        const Ce = rn(Ie.getNorth()), De = rn(Ie.getSouth()), Ke = Math.cos(Ce), Ve = Math.cos(De), er = Math.sin(Ce), fr = Math.sin(De), wr = Ie.getWest(), kr = Ie.getEast();
        return [pu(Ve, fr, wr, de), pu(Ve, fr, kr, de), pu(Ke, er, kr, de), pu(Ke, er, wr, de)];
      }
      function xs(Ie, de, Ce, De) {
        const Ke = 1 << Ce.z, Ve = (Ie / vo + Ce.x) / Ke;
        return zu(Fs((de / vo + Ce.y) / Ke), bs(Ve), De);
      }
      function Vs({ min: Ie, max: de }) {
        return pa / Math.max(de[0] - Ie[0], de[1] - Ie[1], de[2] - Ie[2]);
      }
      const Ja = new Float64Array(16);
      function ul(Ie) {
        const de = Vs(Ie), Ce = Zr.mat4.fromScaling(Ja, [de, de, de]);
        return Zr.mat4.translate(Ce, Ce, Zr.vec3.negate([], Ie.min));
      }
      function nc(Ie) {
        const de = Zr.mat4.fromTranslation(Ja, Ie.min), Ce = 1 / Vs(Ie);
        return Zr.mat4.scale(de, de, [Ce, Ce, Ce]);
      }
      function Rl(Ie) {
        const de = vo / (2 * Math.PI);
        return Ie / (2 * Math.PI) / de;
      }
      function vu(Ie, de) {
        return vo / (512 * Math.pow(2, Ie)) * Vs(Ns(de));
      }
      function Jc(Ie, de, Ce, De, Ke) {
        const Ve = Rl(Ce), er = [Ie, de, -Ce / (2 * Math.PI)], fr = Zr.mat4.identity(new Float64Array(16));
        return Zr.mat4.translate(fr, fr, er), Zr.mat4.scale(fr, fr, [Ve, Ve, Ve]), Zr.mat4.rotateX(fr, fr, rn(-Ke)), Zr.mat4.rotateY(fr, fr, rn(-De)), fr;
      }
      function gl(Ie) {
        return Vn(ud, Ou, Ie);
      }
      function oc(Ie, de) {
        const Ce = zu(de.lat, de.lng), De = function(Ve) {
          const er = zu(Ve._center.lat, Ve._center.lng), fr = Zr.vec3.fromValues(0, 1, 0);
          let wr = Zr.vec3.cross([], fr, er);
          const kr = Zr.mat4.fromRotation([], -Ve.angle, er);
          wr = Zr.vec3.transformMat4(wr, wr, kr), Zr.mat4.fromRotation(kr, -Ve._pitch, wr);
          const cr = Zr.vec3.normalize([], er);
          return Zr.vec3.scale(cr, cr, Aa(Ve.cameraToCenterDistance / Ve.pixelsPerMeter)), Zr.vec3.transformMat4(cr, cr, kr), Zr.vec3.add([], er, cr);
        }(Ie), Ke = Zr.vec3.subtract([], De, Ce);
        return Zr.vec3.angle(Ke, Ce);
      }
      function Rc(Ie, de) {
        return oc(Ie, de) > Math.PI / 2 * 1.01;
      }
      const yc = rn(85), xh = Math.cos(yc), hf = Math.sin(yc), tm = Zr.mat4.create(), hp = (Ie) => {
        const de = [];
        return Ie.paint.get("circle-pitch-alignment") === "map" && de.push("PITCH_WITH_MAP"), Ie.paint.get("circle-pitch-scale") === "map" && de.push("SCALE_WITH_MAP"), de;
      };
      function j1(Ie, de, Ce, De, Ke, Ve, er, fr, wr) {
        if (Ve && Ie.queryGeometry.isAboveHorizon)
          return !1;
        Ve && (wr *= Ie.pixelToTileUnitsFactor);
        const kr = Ie.tileID.canonical, cr = Ce.projection.upVectorScale(kr, Ce.center.lat, Ce.worldSize).metersToTile;
        for (const Mr of de)
          for (const Er of Mr) {
            const xr = Er.add(fr), Sr = Ke && Ce.elevation ? Ce.elevation.exaggeration() * Ke.getElevationAt(xr.x, xr.y, !0) : 0, Br = Ce.projection.projectTilePoint(xr.x, xr.y, kr);
            if (Sr > 0) {
              const ti = Ce.projection.upVector(kr, xr.x, xr.y);
              Br.x += ti[0] * cr * Sr, Br.y += ti[1] * cr * Sr, Br.z += ti[2] * cr * Sr;
            }
            const Fr = Ve ? xr : Av(Br.x, Br.y, Br.z, De), jr = Ve ? Ie.tilespaceRays.map((ti) => G1(ti, Sr)) : Ie.queryGeometry.screenGeometry, Qr = Zr.vec4.transformMat4([], [Br.x, Br.y, Br.z, 1], De);
            if (!er && Ve ? wr *= Qr[3] / Ce.cameraToCenterDistance : er && !Ve && (wr *= Ce.cameraToCenterDistance / Qr[3]), Ve) {
              const ti = Fs((Er.y / vo + kr.y) / (1 << kr.z));
              wr /= Ce.projection.pixelsPerMeter(ti, 1) / As(1, ti);
            }
            if (Ii(jr, Fr, wr))
              return !0;
          }
        return !1;
      }
      function Av(Ie, de, Ce, De) {
        const Ke = Zr.vec4.transformMat4([], [Ie, de, Ce, 1], De);
        return new qi(Ke[0] / Ke[3], Ke[1] / Ke[3]);
      }
      const q1 = Zr.vec3.fromValues(0, 0, 0), kv = Zr.vec3.fromValues(0, 0, 1);
      function G1(Ie, de) {
        const Ce = Zr.vec3.create();
        return q1[2] = de, Ie.intersectsPlane(q1, kv, Ce), new qi(Ce[0], Ce[1]);
      }
      class H1 extends Mi {
      }
      let rm, W1, Z1, X1;
      function K1(Ie, { width: de, height: Ce }, De, Ke) {
        if (Ke) {
          if (Ke instanceof Uint8ClampedArray)
            Ke = new Uint8Array(Ke.buffer);
          else if (Ke.length !== de * Ce * De)
            throw new RangeError("mismatched image size");
        } else
          Ke = new Uint8Array(de * Ce * De);
        return Ie.width = de, Ie.height = Ce, Ie.data = Ke, Ie;
      }
      function Y1(Ie, de, Ce) {
        const { width: De, height: Ke } = de;
        De === Ie.width && Ke === Ie.height || (K0(Ie, de, { x: 0, y: 0 }, { x: 0, y: 0 }, { width: Math.min(Ie.width, De), height: Math.min(Ie.height, Ke) }, Ce, null), Ie.width = De, Ie.height = Ke, Ie.data = de.data);
      }
      function K0(Ie, de, Ce, De, Ke, Ve, er, fr) {
        if (Ke.width === 0 || Ke.height === 0)
          return de;
        if (Ke.width > Ie.width || Ke.height > Ie.height || Ce.x > Ie.width - Ke.width || Ce.y > Ie.height - Ke.height)
          throw new RangeError("out of range source coordinates for image copy");
        if (Ke.width > de.width || Ke.height > de.height || De.x > de.width - Ke.width || De.y > de.height - Ke.height)
          throw new RangeError("out of range destination coordinates for image copy");
        const wr = Ie.data, kr = de.data, cr = Ve === 4 && fr;
        for (let Mr = 0; Mr < Ke.height; Mr++) {
          const Er = ((Ce.y + Mr) * Ie.width + Ce.x) * Ve, xr = ((De.y + Mr) * de.width + De.x) * Ve;
          if (cr)
            for (let Sr = 0; Sr < Ke.width; Sr++) {
              const Br = Er + Sr * Ve + 3, Fr = xr + Sr * Ve;
              kr[Fr + 0] = 255, kr[Fr + 1] = 255, kr[Fr + 2] = 255, kr[Fr + 3] = wr[Br];
            }
          else if (er)
            for (let Sr = 0; Sr < Ke.width; Sr++) {
              const Br = Er + Sr * Ve, Fr = xr + Sr * Ve, jr = wr[Br + 3], Qr = new Ca(wr[Br + 0] / 255 * jr, wr[Br + 1] / 255 * jr, wr[Br + 2] / 255 * jr, jr).toRenderColor(er).toArray();
              kr[Fr + 0] = Qr[0], kr[Fr + 1] = Qr[1], kr[Fr + 2] = Qr[2], kr[Fr + 3] = Qr[3];
            }
          else
            for (let Sr = 0; Sr < Ke.width * Ve; Sr++)
              kr[xr + Sr] = wr[Er + Sr];
        }
        return de;
      }
      Ao(H1, "HeatmapBucket", { omit: ["layers"] });
      class hd {
        constructor(de, Ce) {
          K1(this, de, 1, Ce);
        }
        resize(de) {
          Y1(this, new hd(de), 1);
        }
        clone() {
          return new hd({ width: this.width, height: this.height }, new Uint8Array(this.data));
        }
        static copy(de, Ce, De, Ke, Ve) {
          K0(de, Ce, De, Ke, Ve, 1, null);
        }
      }
      class Al {
        constructor(de, Ce) {
          K1(this, de, 4, Ce);
        }
        resize(de) {
          Y1(this, new Al(de), 4);
        }
        replace(de, Ce) {
          Ce ? this.data.set(de) : this.data = de instanceof Uint8ClampedArray ? new Uint8Array(de.buffer) : de;
        }
        clone() {
          return new Al({ width: this.width, height: this.height }, new Uint8Array(this.data));
        }
        static copy(de, Ce, De, Ke, Ve, er, fr) {
          K0(de, Ce, De, Ke, Ve, 4, er, fr);
        }
      }
      class J1 {
        constructor(de, Ce) {
          this.width = de.width, this.height = de.height, this.data = Ce instanceof Uint8Array ? new Float32Array(Ce.buffer) : Ce;
        }
      }
      function im(Ie) {
        const de = {}, Ce = Ie.resolution || 256, De = Ie.clips ? Ie.clips.length : 1, Ke = Ie.image || new Al({ width: Ce, height: De }), Ve = (er, fr, wr) => {
          de[Ie.evaluationKey] = wr;
          const kr = Ie.expression.evaluate(de);
          kr && (Ke.data[er + fr + 0] = Math.floor(255 * kr.r / kr.a), Ke.data[er + fr + 1] = Math.floor(255 * kr.g / kr.a), Ke.data[er + fr + 2] = Math.floor(255 * kr.b / kr.a), Ke.data[er + fr + 3] = Math.floor(255 * kr.a));
        };
        if (Ie.clips)
          for (let er = 0, fr = 0; er < De; ++er, fr += 4 * Ce)
            for (let wr = 0, kr = 0; wr < Ce; wr++, kr += 4) {
              const cr = wr / (Ce - 1), { start: Mr, end: Er } = Ie.clips[er];
              Ve(fr, kr, Mr * (1 - cr) + Er * cr);
            }
        else
          for (let er = 0, fr = 0; er < Ce; er++, fr += 4)
            Ve(0, fr, er / (Ce - 1));
        return Ke;
      }
      Ao(hd, "AlphaImage"), Ao(Al, "RGBAImage");
      const Lv = La([{ name: "a_pos", components: 2, type: "Int16" }], 4), { members: Iv } = Lv;
      function nm(Ie, de, Ce = 2) {
        const De = de && de.length, Ke = De ? de[0] * Ce : Ie.length;
        let Ve = Q1(Ie, 0, Ke, Ce, !0);
        const er = [];
        if (!Ve || Ve.next === Ve.prev)
          return er;
        let fr, wr, kr;
        if (De && (Ve = function(cr, Mr, Er, xr) {
          const Sr = [];
          for (let Br = 0, Fr = Mr.length; Br < Fr; Br++) {
            const jr = Q1(cr, Mr[Br] * xr, Br < Fr - 1 ? Mr[Br + 1] * xr : cr.length, xr, !1);
            jr === jr.next && (jr.steiner = !0), Sr.push(Dv(jr));
          }
          Sr.sort(Rv);
          for (let Br = 0; Br < Sr.length; Br++)
            Er = Pv(Sr[Br], Er);
          return Er;
        }(Ie, de, Ve, Ce)), Ie.length > 80 * Ce) {
          fr = 1 / 0, wr = 1 / 0;
          let cr = -1 / 0, Mr = -1 / 0;
          for (let Er = Ce; Er < Ke; Er += Ce) {
            const xr = Ie[Er], Sr = Ie[Er + 1];
            xr < fr && (fr = xr), Sr < wr && (wr = Sr), xr > cr && (cr = xr), Sr > Mr && (Mr = Sr);
          }
          kr = Math.max(cr - fr, Mr - wr), kr = kr !== 0 ? 32767 / kr : 0;
        }
        return om(Ve, er, Ce, fr, wr, kr, 0), er;
      }
      function Q1(Ie, de, Ce, De, Ke) {
        let Ve;
        if (Ke === function(er, fr, wr, kr) {
          let cr = 0;
          for (let Mr = fr, Er = wr - kr; Mr < wr; Mr += kr)
            cr += (er[Er] - er[Mr]) * (er[Mr + 1] + er[Er + 1]), Er = Mr;
          return cr;
        }(Ie, de, Ce, De) > 0)
          for (let er = de; er < Ce; er += De)
            Ve = sm(er / De | 0, Ie[er], Ie[er + 1], Ve);
        else
          for (let er = Ce - De; er >= de; er -= De)
            Ve = sm(er / De | 0, Ie[er], Ie[er + 1], Ve);
        return Ve && n0(Ve, Ve.next) && (lm(Ve), Ve = Ve.next), Ve;
      }
      function df(Ie, de) {
        if (!Ie)
          return Ie;
        de || (de = Ie);
        let Ce, De = Ie;
        do
          if (Ce = !1, De.steiner || !n0(De, De.next) && Us(De.prev, De, De.next) !== 0)
            De = De.next;
          else {
            if (lm(De), De = de = De.prev, De === De.next)
              break;
            Ce = !0;
          }
        while (Ce || De !== de);
        return de;
      }
      function om(Ie, de, Ce, De, Ke, Ve, er) {
        if (!Ie)
          return;
        !er && Ve && function(wr, kr, cr, Mr) {
          let Er = wr;
          do
            Er.z === 0 && (Er.z = Y0(Er.x, Er.y, kr, cr, Mr)), Er.prevZ = Er.prev, Er.nextZ = Er.next, Er = Er.next;
          while (Er !== wr);
          Er.prevZ.nextZ = null, Er.prevZ = null, function(xr) {
            let Sr, Br = 1;
            do {
              let Fr, jr = xr;
              xr = null;
              let Qr = null;
              for (Sr = 0; jr; ) {
                Sr++;
                let ti = jr, Kr = 0;
                for (let gi = 0; gi < Br && (Kr++, ti = ti.nextZ, ti); gi++)
                  ;
                let ni = Br;
                for (; Kr > 0 || ni > 0 && ti; )
                  Kr !== 0 && (ni === 0 || !ti || jr.z <= ti.z) ? (Fr = jr, jr = jr.nextZ, Kr--) : (Fr = ti, ti = ti.nextZ, ni--), Qr ? Qr.nextZ = Fr : xr = Fr, Fr.prevZ = Qr, Qr = Fr;
                jr = ti;
              }
              Qr.nextZ = null, Br *= 2;
            } while (Sr > 1);
          }(Er);
        }(Ie, De, Ke, Ve);
        let fr = Ie;
        for (; Ie.prev !== Ie.next; ) {
          const wr = Ie.prev, kr = Ie.next;
          if (Ve ? tg(Ie, De, Ke, Ve) : eg(Ie))
            de.push(wr.i, Ie.i, kr.i), lm(Ie), Ie = kr.next, fr = kr.next;
          else if ((Ie = kr) === fr) {
            er ? er === 1 ? om(Ie = Bv(df(Ie), de), de, Ce, De, Ke, Ve, 2) : er === 2 && $v(Ie, de, Ce, De, Ke, Ve) : om(df(Ie), de, Ce, De, Ke, Ve, 1);
            break;
          }
        }
      }
      function eg(Ie) {
        const de = Ie.prev, Ce = Ie, De = Ie.next;
        if (Us(de, Ce, De) >= 0)
          return !1;
        const Ke = de.x, Ve = Ce.x, er = De.x, fr = de.y, wr = Ce.y, kr = De.y, cr = Ke < Ve ? Ke < er ? Ke : er : Ve < er ? Ve : er, Mr = fr < wr ? fr < kr ? fr : kr : wr < kr ? wr : kr, Er = Ke > Ve ? Ke > er ? Ke : er : Ve > er ? Ve : er, xr = fr > wr ? fr > kr ? fr : kr : wr > kr ? wr : kr;
        let Sr = De.next;
        for (; Sr !== de; ) {
          if (Sr.x >= cr && Sr.x <= Er && Sr.y >= Mr && Sr.y <= xr && dp(Ke, fr, Ve, wr, er, kr, Sr.x, Sr.y) && Us(Sr.prev, Sr, Sr.next) >= 0)
            return !1;
          Sr = Sr.next;
        }
        return !0;
      }
      function tg(Ie, de, Ce, De) {
        const Ke = Ie.prev, Ve = Ie, er = Ie.next;
        if (Us(Ke, Ve, er) >= 0)
          return !1;
        const fr = Ke.x, wr = Ve.x, kr = er.x, cr = Ke.y, Mr = Ve.y, Er = er.y, xr = fr < wr ? fr < kr ? fr : kr : wr < kr ? wr : kr, Sr = cr < Mr ? cr < Er ? cr : Er : Mr < Er ? Mr : Er, Br = fr > wr ? fr > kr ? fr : kr : wr > kr ? wr : kr, Fr = cr > Mr ? cr > Er ? cr : Er : Mr > Er ? Mr : Er, jr = Y0(xr, Sr, de, Ce, De), Qr = Y0(Br, Fr, de, Ce, De);
        let ti = Ie.prevZ, Kr = Ie.nextZ;
        for (; ti && ti.z >= jr && Kr && Kr.z <= Qr; ) {
          if (ti.x >= xr && ti.x <= Br && ti.y >= Sr && ti.y <= Fr && ti !== Ke && ti !== er && dp(fr, cr, wr, Mr, kr, Er, ti.x, ti.y) && Us(ti.prev, ti, ti.next) >= 0 || (ti = ti.prevZ, Kr.x >= xr && Kr.x <= Br && Kr.y >= Sr && Kr.y <= Fr && Kr !== Ke && Kr !== er && dp(fr, cr, wr, Mr, kr, Er, Kr.x, Kr.y) && Us(Kr.prev, Kr, Kr.next) >= 0))
            return !1;
          Kr = Kr.nextZ;
        }
        for (; ti && ti.z >= jr; ) {
          if (ti.x >= xr && ti.x <= Br && ti.y >= Sr && ti.y <= Fr && ti !== Ke && ti !== er && dp(fr, cr, wr, Mr, kr, Er, ti.x, ti.y) && Us(ti.prev, ti, ti.next) >= 0)
            return !1;
          ti = ti.prevZ;
        }
        for (; Kr && Kr.z <= Qr; ) {
          if (Kr.x >= xr && Kr.x <= Br && Kr.y >= Sr && Kr.y <= Fr && Kr !== Ke && Kr !== er && dp(fr, cr, wr, Mr, kr, Er, Kr.x, Kr.y) && Us(Kr.prev, Kr, Kr.next) >= 0)
            return !1;
          Kr = Kr.nextZ;
        }
        return !0;
      }
      function Bv(Ie, de) {
        let Ce = Ie;
        do {
          const De = Ce.prev, Ke = Ce.next.next;
          !n0(De, Ke) && rg(De, Ce, Ce.next, Ke) && am(De, Ke) && am(Ke, De) && (de.push(De.i, Ce.i, Ke.i), lm(Ce), lm(Ce.next), Ce = Ie = Ke), Ce = Ce.next;
        } while (Ce !== Ie);
        return df(Ce);
      }
      function $v(Ie, de, Ce, De, Ke, Ve) {
        let er = Ie;
        do {
          let fr = er.next.next;
          for (; fr !== er.prev; ) {
            if (er.i !== fr.i && Ov(er, fr)) {
              let wr = ig(er, fr);
              return er = df(er, er.next), wr = df(wr, wr.next), om(er, de, Ce, De, Ke, Ve, 0), void om(wr, de, Ce, De, Ke, Ve, 0);
            }
            fr = fr.next;
          }
          er = er.next;
        } while (er !== Ie);
      }
      function Rv(Ie, de) {
        return Ie.x - de.x;
      }
      function Pv(Ie, de) {
        const Ce = function(Ke, Ve) {
          let er = Ve;
          const fr = Ke.x, wr = Ke.y;
          let kr, cr = -1 / 0;
          do {
            if (wr <= er.y && wr >= er.next.y && er.next.y !== er.y) {
              const Br = er.x + (wr - er.y) * (er.next.x - er.x) / (er.next.y - er.y);
              if (Br <= fr && Br > cr && (cr = Br, kr = er.x < er.next.x ? er : er.next, Br === fr))
                return kr;
            }
            er = er.next;
          } while (er !== Ve);
          if (!kr)
            return null;
          const Mr = kr, Er = kr.x, xr = kr.y;
          let Sr = 1 / 0;
          er = kr;
          do {
            if (fr >= er.x && er.x >= Er && fr !== er.x && dp(wr < xr ? fr : cr, wr, Er, xr, wr < xr ? cr : fr, wr, er.x, er.y)) {
              const Br = Math.abs(wr - er.y) / (fr - er.x);
              am(er, Ke) && (Br < Sr || Br === Sr && (er.x > kr.x || er.x === kr.x && i0(kr, er))) && (kr = er, Sr = Br);
            }
            er = er.next;
          } while (er !== Mr);
          return kr;
        }(Ie, de);
        if (!Ce)
          return de;
        const De = ig(Ce, Ie);
        return df(De, De.next), df(Ce, Ce.next);
      }
      function i0(Ie, de) {
        return Us(Ie.prev, Ie, de.prev) < 0 && Us(de.next, Ie, Ie.next) < 0;
      }
      function Y0(Ie, de, Ce, De, Ke) {
        return (Ie = 1431655765 & ((Ie = 858993459 & ((Ie = 252645135 & ((Ie = 16711935 & ((Ie = (Ie - Ce) * Ke | 0) | Ie << 8)) | Ie << 4)) | Ie << 2)) | Ie << 1)) | (de = 1431655765 & ((de = 858993459 & ((de = 252645135 & ((de = 16711935 & ((de = (de - De) * Ke | 0) | de << 8)) | de << 4)) | de << 2)) | de << 1)) << 1;
      }
      function Dv(Ie) {
        let de = Ie, Ce = Ie;
        do
          (de.x < Ce.x || de.x === Ce.x && de.y < Ce.y) && (Ce = de), de = de.next;
        while (de !== Ie);
        return Ce;
      }
      function dp(Ie, de, Ce, De, Ke, Ve, er, fr) {
        return (Ke - er) * (de - fr) >= (Ie - er) * (Ve - fr) && (Ie - er) * (De - fr) >= (Ce - er) * (de - fr) && (Ce - er) * (Ve - fr) >= (Ke - er) * (De - fr);
      }
      function Ov(Ie, de) {
        return Ie.next.i !== de.i && Ie.prev.i !== de.i && !function(Ce, De) {
          let Ke = Ce;
          do {
            if (Ke.i !== Ce.i && Ke.next.i !== Ce.i && Ke.i !== De.i && Ke.next.i !== De.i && rg(Ke, Ke.next, Ce, De))
              return !0;
            Ke = Ke.next;
          } while (Ke !== Ce);
          return !1;
        }(Ie, de) && (am(Ie, de) && am(de, Ie) && function(Ce, De) {
          let Ke = Ce, Ve = !1;
          const er = (Ce.x + De.x) / 2, fr = (Ce.y + De.y) / 2;
          do
            Ke.y > fr != Ke.next.y > fr && Ke.next.y !== Ke.y && er < (Ke.next.x - Ke.x) * (fr - Ke.y) / (Ke.next.y - Ke.y) + Ke.x && (Ve = !Ve), Ke = Ke.next;
          while (Ke !== Ce);
          return Ve;
        }(Ie, de) && (Us(Ie.prev, Ie, de.prev) || Us(Ie, de.prev, de)) || n0(Ie, de) && Us(Ie.prev, Ie, Ie.next) > 0 && Us(de.prev, de, de.next) > 0);
      }
      function Us(Ie, de, Ce) {
        return (de.y - Ie.y) * (Ce.x - de.x) - (de.x - Ie.x) * (Ce.y - de.y);
      }
      function n0(Ie, de) {
        return Ie.x === de.x && Ie.y === de.y;
      }
      function rg(Ie, de, Ce, De) {
        const Ke = a0(Us(Ie, de, Ce)), Ve = a0(Us(Ie, de, De)), er = a0(Us(Ce, De, Ie)), fr = a0(Us(Ce, De, de));
        return Ke !== Ve && er !== fr || !(Ke !== 0 || !o0(Ie, Ce, de)) || !(Ve !== 0 || !o0(Ie, De, de)) || !(er !== 0 || !o0(Ce, Ie, De)) || !(fr !== 0 || !o0(Ce, de, De));
      }
      function o0(Ie, de, Ce) {
        return de.x <= Math.max(Ie.x, Ce.x) && de.x >= Math.min(Ie.x, Ce.x) && de.y <= Math.max(Ie.y, Ce.y) && de.y >= Math.min(Ie.y, Ce.y);
      }
      function a0(Ie) {
        return Ie > 0 ? 1 : Ie < 0 ? -1 : 0;
      }
      function am(Ie, de) {
        return Us(Ie.prev, Ie, Ie.next) < 0 ? Us(Ie, de, Ie.next) >= 0 && Us(Ie, Ie.prev, de) >= 0 : Us(Ie, de, Ie.prev) < 0 || Us(Ie, Ie.next, de) < 0;
      }
      function ig(Ie, de) {
        const Ce = s0(Ie.i, Ie.x, Ie.y), De = s0(de.i, de.x, de.y), Ke = Ie.next, Ve = de.prev;
        return Ie.next = de, de.prev = Ie, Ce.next = Ke, Ke.prev = Ce, De.next = Ce, Ce.prev = De, Ve.next = De, De.prev = Ve, De;
      }
      function sm(Ie, de, Ce, De) {
        const Ke = s0(Ie, de, Ce);
        return De ? (Ke.next = De.next, Ke.prev = De, De.next.prev = Ke, De.next = Ke) : (Ke.prev = Ke, Ke.next = Ke), Ke;
      }
      function lm(Ie) {
        Ie.next.prev = Ie.prev, Ie.prev.next = Ie.next, Ie.prevZ && (Ie.prevZ.nextZ = Ie.nextZ), Ie.nextZ && (Ie.nextZ.prevZ = Ie.prevZ);
      }
      function s0(Ie, de, Ce) {
        return { i: Ie, x: de, y: Ce, prev: null, next: null, z: 0, prevZ: null, nextZ: null, steiner: !1 };
      }
      function cm(Ie, de) {
        const Ce = Ie.length;
        if (Ce <= 1)
          return [Ie];
        const De = [];
        let Ke, Ve;
        for (let er = 0; er < Ce; er++) {
          const fr = Rn(Ie[er]);
          fr !== 0 && (Ie[er].area = Math.abs(fr), Ve === void 0 && (Ve = fr < 0), Ve === fr < 0 ? (Ke && De.push(Ke), Ke = [Ie[er]]) : Ke.push(Ie[er]));
        }
        if (Ke && De.push(Ke), de > 1)
          for (let er = 0; er < De.length; er++)
            De[er].length <= de || (Tf(De[er], de, 1, De[er].length - 1, J0), De[er] = De[er].slice(0, de));
        return De;
      }
      function J0(Ie, de) {
        return de.area - Ie.area;
      }
      function Q0(Ie, de) {
        if (!Ie)
          return null;
        const Ce = typeof Ie == "string" ? Ie : Ie.getPrimary().id;
        de[Ce] || (de[Ce] = []);
        const De = Ps.from(Ie).getPrimary();
        return de[Ce].push(De), De.serialize();
      }
      function l0(Ie, de, Ce) {
        const De = Ce.patternDependencies;
        let Ke = !1;
        for (const Ve of de) {
          const er = Ve.paint.get(`${Ie}-pattern`);
          er.isConstant() || (Ke = !0), Q0(er.constantOr(null), De) && (Ke = !0);
        }
        return Ke;
      }
      function c0(Ie, de, Ce, De, Ke) {
        const Ve = Ke.patternDependencies;
        for (const er of de) {
          const fr = er.paint.get(`${Ie}-pattern`).value;
          if (fr.kind !== "constant") {
            let wr = fr.evaluate({ zoom: De }, Ce, {}, Ke.availableImages);
            wr = wr && wr.name ? wr.name : wr;
            const kr = Q0(wr, Ve);
            kr && (Ce.patterns[er.id] = kr);
          }
        }
        return Ce;
      }
      class u0 {
        constructor(de) {
          this.zoom = de.zoom, this.overscaling = de.overscaling, this.layers = de.layers, this.layerIds = this.layers.map((Ce) => Ce.fqid), this.index = de.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new Zc(), this.indexArray = new tl(), this.indexArray2 = new Ru(), this.programConfigurations = new du(de.layers, { zoom: de.zoom, lut: de.lut }), this.segments = new fs(), this.segments2 = new fs(), this.stateDependentLayerIds = this.layers.filter((Ce) => Ce.isStateDependent()).map((Ce) => Ce.id), this.projection = de.projection;
        }
        updateFootprints(de, Ce) {
        }
        populate(de, Ce, De, Ke) {
          this.hasPattern = l0("fill", this.layers, Ce);
          const Ve = this.layers[0].layout.get("fill-sort-key"), er = [];
          for (const { feature: fr, id: wr, index: kr, sourceLayerIndex: cr } of de) {
            const Mr = this.layers[0]._featureFilter.needGeometry, Er = Jr(fr, Mr);
            if (!this.layers[0]._featureFilter.filter(new wa(this.zoom), Er, De))
              continue;
            const xr = Ve ? Ve.evaluate(Er, {}, De, Ce.availableImages) : void 0, Sr = { id: wr, properties: fr.properties, type: fr.type, sourceLayerIndex: cr, index: kr, geometry: Mr ? Er.geometry : qr(fr, De, Ke), patterns: {}, sortKey: xr };
            er.push(Sr);
          }
          Ve && er.sort((fr, wr) => fr.sortKey - wr.sortKey);
          for (const fr of er) {
            const { geometry: wr, index: kr, sourceLayerIndex: cr } = fr;
            if (this.hasPattern) {
              const Mr = c0("fill", this.layers, fr, this.zoom, Ce);
              this.patternFeatures.push(Mr);
            } else
              this.addFeature(fr, wr, kr, De, {}, Ce.availableImages, Ce.brightness);
            Ce.featureIndex.insert(de[kr].feature, wr, kr, cr, this.index);
          }
        }
        update(de, Ce, De, Ke, Ve, er, fr) {
          this.programConfigurations.updatePaintArrays(de, Ce, Ve, De, Ke, er, fr);
        }
        addFeatures(de, Ce, De, Ke, Ve, er) {
          for (const fr of this.patternFeatures)
            this.addFeature(fr, fr.geometry, fr.index, Ce, De, Ke, er);
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(de) {
          this.uploaded || (this.layoutVertexBuffer = de.createVertexBuffer(this.layoutVertexArray, Iv), this.indexBuffer = de.createIndexBuffer(this.indexArray), this.indexBuffer2 = de.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(de), this.uploaded = !0;
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
        }
        addFeature(de, Ce, De, Ke, Ve, er = [], fr) {
          for (const wr of cm(Ce, 500)) {
            let kr = 0;
            for (const Br of wr)
              kr += Br.length;
            const cr = this.segments.prepareSegment(kr, this.layoutVertexArray, this.indexArray), Mr = cr.vertexLength, Er = [], xr = [];
            for (const Br of wr) {
              if (Br.length === 0)
                continue;
              Br !== wr[0] && xr.push(Er.length / 2);
              const Fr = this.segments2.prepareSegment(Br.length, this.layoutVertexArray, this.indexArray2), jr = Fr.vertexLength;
              this.layoutVertexArray.emplaceBack(Br[0].x, Br[0].y), this.indexArray2.emplaceBack(jr + Br.length - 1, jr), Er.push(Br[0].x), Er.push(Br[0].y);
              for (let Qr = 1; Qr < Br.length; Qr++)
                this.layoutVertexArray.emplaceBack(Br[Qr].x, Br[Qr].y), this.indexArray2.emplaceBack(jr + Qr - 1, jr + Qr), Er.push(Br[Qr].x), Er.push(Br[Qr].y);
              Fr.vertexLength += Br.length, Fr.primitiveLength += Br.length;
            }
            const Sr = nm(Er, xr);
            for (let Br = 0; Br < Sr.length; Br += 3)
              this.indexArray.emplaceBack(Mr + Sr[Br], Mr + Sr[Br + 1], Mr + Sr[Br + 2]);
            cr.vertexLength += kr, cr.primitiveLength += Sr.length / 3;
          }
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, de, De, Ve, er, Ke, fr);
        }
      }
      let ng, og, ag, um;
      Ao(u0, "FillBucket", { omit: ["layers", "patternFeatures"] });
      class fp {
        constructor(de, Ce, De, Ke) {
          if (this.triangleCount = Ce.length / 3, this.min = new qi(0, 0), this.max = new qi(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cells = [], this.payload = [], this.triangleCount === 0 || de.length === 0)
            return;
          const [Ve, er] = [de[0].clone(), de[0].clone()];
          for (let Mr = 1; Mr < de.length; ++Mr) {
            const Er = de[Mr];
            Ve.x = Math.min(Ve.x, Er.x), Ve.y = Math.min(Ve.y, Er.y), er.x = Math.max(er.x, Er.x), er.y = Math.max(er.y, Er.y);
          }
          if (Ke) {
            const Mr = Math.ceil(Math.max(er.x - Ve.x, er.y - Ve.y) / Ke);
            De = Math.max(De, Mr);
          }
          if (De === 0)
            return;
          this.min = Ve, this.max = er;
          const fr = this.max.sub(this.min);
          fr.x = Math.max(fr.x, 1), fr.y = Math.max(fr.y, 1);
          const wr = Math.max(fr.x, fr.y) / De;
          this.cellsX = Math.max(1, Math.ceil(fr.x / wr)), this.cellsY = Math.max(1, Math.ceil(fr.y / wr)), this.xScale = 1 / wr, this.yScale = 1 / wr;
          const kr = [];
          for (let Mr = 0; Mr < this.triangleCount; Mr++) {
            const Er = de[Ce[3 * Mr + 0]].sub(this.min), xr = de[Ce[3 * Mr + 1]].sub(this.min), Sr = de[Ce[3 * Mr + 2]].sub(this.min), Br = Nu(Math.floor(Math.min(Er.x, xr.x, Sr.x)), this.xScale, this.cellsX), Fr = Nu(Math.floor(Math.max(Er.x, xr.x, Sr.x)), this.xScale, this.cellsX), jr = Nu(Math.floor(Math.min(Er.y, xr.y, Sr.y)), this.yScale, this.cellsY), Qr = Nu(Math.floor(Math.max(Er.y, xr.y, Sr.y)), this.yScale, this.cellsY), ti = new qi(0, 0), Kr = new qi(0, 0), ni = new qi(0, 0), gi = new qi(0, 0);
            for (let Si = jr; Si <= Qr; ++Si) {
              ti.y = Kr.y = Si * wr, ni.y = gi.y = (Si + 1) * wr;
              for (let Di = Br; Di <= Fr; ++Di)
                ti.x = ni.x = Di * wr, Kr.x = gi.x = (Di + 1) * wr, (xn(Er, xr, Sr, ti, Kr, gi) || xn(Er, xr, Sr, ti, gi, ni)) && kr.push({ cellIdx: Si * this.cellsX + Di, triIdx: Mr });
            }
          }
          if (kr.length === 0)
            return;
          kr.sort((Mr, Er) => Mr.cellIdx - Er.cellIdx || Mr.triIdx - Er.triIdx);
          let cr = 0;
          for (; cr < kr.length; ) {
            const Mr = kr[cr].cellIdx, Er = { start: this.payload.length, len: 0 };
            for (; cr < kr.length && kr[cr].cellIdx === Mr; )
              ++Er.len, this.payload.push(kr[cr++].triIdx);
            this.cells[Mr] = Er;
          }
        }
        _lazyInitLookup() {
          this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8))), this.lookup.fill(0);
        }
        queryPoint(de, Ce) {
          if (this.triangleCount === 0 || this.cells.length === 0 || de.x > this.max.x || this.min.x > de.x || de.y > this.max.y || this.min.y > de.y)
            return;
          const De = Nu(de.x - this.min.x, this.xScale, this.cellsX), Ke = Nu(de.y - this.min.y, this.yScale, this.cellsY), Ve = this.cells[Ke * this.cellsX + De];
          if (Ve) {
            this._lazyInitLookup();
            for (let er = 0; er < Ve.len; er++) {
              const fr = this.payload[Ve.start + er], wr = Math.floor(fr / 8), kr = 1 << fr % 8;
              if (!(this.lookup[wr] & kr) && (this.lookup[wr] |= kr, Ce.push(fr), Ce.length === this.triangleCount))
                return;
            }
          }
        }
        query(de, Ce, De) {
          if (this.triangleCount === 0 || this.cells.length === 0 || de.x > this.max.x || this.min.x > Ce.x || de.y > this.max.y || this.min.y > Ce.y)
            return;
          this._lazyInitLookup();
          const Ke = Nu(de.x - this.min.x, this.xScale, this.cellsX), Ve = Nu(Ce.x - this.min.x, this.xScale, this.cellsX), er = Nu(de.y - this.min.y, this.yScale, this.cellsY), fr = Nu(Ce.y - this.min.y, this.yScale, this.cellsY);
          for (let wr = er; wr <= fr; wr++)
            for (let kr = Ke; kr <= Ve; kr++) {
              const cr = this.cells[wr * this.cellsX + kr];
              if (cr)
                for (let Mr = 0; Mr < cr.len; Mr++) {
                  const Er = this.payload[cr.start + Mr], xr = Math.floor(Er / 8), Sr = 1 << Er % 8;
                  if (!(this.lookup[xr] & Sr) && (this.lookup[xr] |= Sr, De.push(Er), De.length === this.triangleCount))
                    return;
                }
            }
        }
      }
      function Nu(Ie, de, Ce) {
        return Math.max(0, Math.min(Ce - 1, Math.floor(Ie * de)));
      }
      Ao(fp, "TriangleGridIndex");
      class sg {
        constructor(de) {
          this.zoom = de.zoom, this.layers = de.layers, this.layerIds = this.layers.map((Ce) => Ce.fqid), this.index = de.index, this.hasPattern = !1, this.stateDependentLayerIds = this.layers.filter((Ce) => Ce.isStateDependent()).map((Ce) => Ce.id), this.footprints = [];
        }
        updateFootprints(de, Ce) {
          for (const De of this.footprints)
            Ce.push({ footprint: De, id: de });
        }
        populate(de, Ce, De, Ke) {
          const Ve = [];
          for (const { feature: er, id: fr, index: wr, sourceLayerIndex: kr } of de) {
            const cr = this.layers[0]._featureFilter.needGeometry, Mr = Jr(er, cr);
            if (!this.layers[0]._featureFilter.filter(new wa(this.zoom), Mr, De))
              continue;
            const Er = { id: fr, properties: er.properties, type: er.type, sourceLayerIndex: kr, index: wr, geometry: cr ? Mr.geometry : qr(er, De, Ke), patterns: {} };
            Ve.push(Er);
          }
          for (const er of Ve) {
            const { geometry: fr, index: wr, sourceLayerIndex: kr } = er;
            this.addFeature(er, fr, wr, De, {}, Ce.availableImages, Ce.brightness), Ce.featureIndex.insert(de[wr].feature, fr, wr, kr, this.index);
          }
        }
        isEmpty() {
          return this.footprints.length === 0;
        }
        uploadPending() {
          return !1;
        }
        upload(de) {
        }
        update(de, Ce, De, Ke, Ve, er, fr) {
        }
        destroy() {
        }
        addFeature(de, Ce, De, Ke, Ve, er = [], fr) {
          for (const wr of cm(Ce, 2)) {
            const kr = [], cr = [], Mr = [], Er = new qi(1 / 0, 1 / 0), xr = new qi(-1 / 0, -1 / 0);
            for (const Fr of wr)
              if (Fr.length !== 0) {
                Fr !== wr[0] && Mr.push(cr.length / 2);
                for (let jr = 0; jr < Fr.length; jr++)
                  cr.push(Fr[jr].x), cr.push(Fr[jr].y), kr.push(Fr[jr]), Er.x = Math.min(Er.x, Fr[jr].x), Er.y = Math.min(Er.y, Fr[jr].y), xr.x = Math.max(xr.x, Fr[jr].x), xr.y = Math.max(xr.y, Fr[jr].y);
              }
            const Sr = nm(cr, Mr), Br = new fp(kr, Sr, 8, 256);
            this.footprints.push({ vertices: kr, indices: Sr, grid: Br, min: Er, max: xr });
          }
        }
      }
      Ao(sg, "ClipBucket", { omit: ["layers"] });
      const e1 = La([{ name: "a_pos_normal_ed", components: 4, type: "Int16" }]), lg = La([{ name: "a_pos_end", components: 4, type: "Int16" }, { name: "a_angular_offset_factor", components: 1, type: "Int16" }]), zv = La([{ name: "a_centroid_pos", components: 2, type: "Uint16" }]), Fv = La([{ name: "a_join_normal_inside", components: 3, type: "Int16" }]), Nv = La([{ name: "a_hidden_by_landmark", components: 1, type: "Uint8" }]), Vv = La([{ name: "a_pos_3", components: 3, type: "Int16" }, { name: "a_pos_normal_3", components: 3, type: "Int16" }]), { members: Uv } = e1;
      var t1, cg, r1, ug, i1, hg, dg, bc = {};
      function fg() {
        if (cg)
          return t1;
        cg = 1;
        var Ie = Oi();
        function de(Ke, Ve, er, fr, wr) {
          this.properties = {}, this.extent = er, this.type = 0, this._pbf = Ke, this._geometry = -1, this._keys = fr, this._values = wr, Ke.readFields(Ce, this, Ve);
        }
        function Ce(Ke, Ve, er) {
          Ke == 1 ? Ve.id = er.readVarint() : Ke == 2 ? function(fr, wr) {
            for (var kr = fr.readVarint() + fr.pos; fr.pos < kr; ) {
              var cr = wr._keys[fr.readVarint()], Mr = wr._values[fr.readVarint()];
              wr.properties[cr] = Mr;
            }
          }(er, Ve) : Ke == 3 ? Ve.type = er.readVarint() : Ke == 4 && (Ve._geometry = er.pos);
        }
        function De(Ke) {
          for (var Ve, er, fr = 0, wr = 0, kr = Ke.length, cr = kr - 1; wr < kr; cr = wr++)
            fr += ((er = Ke[cr]).x - (Ve = Ke[wr]).x) * (Ve.y + er.y);
          return fr;
        }
        return t1 = de, de.types = ["Unknown", "Point", "LineString", "Polygon"], de.prototype.loadGeometry = function() {
          var Ke = this._pbf;
          Ke.pos = this._geometry;
          for (var Ve, er = Ke.readVarint() + Ke.pos, fr = 1, wr = 0, kr = 0, cr = 0, Mr = []; Ke.pos < er; ) {
            if (wr <= 0) {
              var Er = Ke.readVarint();
              fr = 7 & Er, wr = Er >> 3;
            }
            if (wr--, fr === 1 || fr === 2)
              kr += Ke.readSVarint(), cr += Ke.readSVarint(), fr === 1 && (Ve && Mr.push(Ve), Ve = []), Ve.push(new Ie(kr, cr));
            else {
              if (fr !== 7)
                throw new Error("unknown command " + fr);
              Ve && Ve.push(Ve[0].clone());
            }
          }
          return Ve && Mr.push(Ve), Mr;
        }, de.prototype.bbox = function() {
          var Ke = this._pbf;
          Ke.pos = this._geometry;
          for (var Ve = Ke.readVarint() + Ke.pos, er = 1, fr = 0, wr = 0, kr = 0, cr = 1 / 0, Mr = -1 / 0, Er = 1 / 0, xr = -1 / 0; Ke.pos < Ve; ) {
            if (fr <= 0) {
              var Sr = Ke.readVarint();
              er = 7 & Sr, fr = Sr >> 3;
            }
            if (fr--, er === 1 || er === 2)
              (wr += Ke.readSVarint()) < cr && (cr = wr), wr > Mr && (Mr = wr), (kr += Ke.readSVarint()) < Er && (Er = kr), kr > xr && (xr = kr);
            else if (er !== 7)
              throw new Error("unknown command " + er);
          }
          return [cr, Er, Mr, xr];
        }, de.prototype.toGeoJSON = function(Ke, Ve, er) {
          var fr, wr, kr = this.extent * Math.pow(2, er), cr = this.extent * Ke, Mr = this.extent * Ve, Er = this.loadGeometry(), xr = de.types[this.type];
          function Sr(jr) {
            for (var Qr = 0; Qr < jr.length; Qr++) {
              var ti = jr[Qr];
              jr[Qr] = [360 * (ti.x + cr) / kr - 180, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * (ti.y + Mr) / kr) * Math.PI / 180)) - 90];
            }
          }
          switch (this.type) {
            case 1:
              var Br = [];
              for (fr = 0; fr < Er.length; fr++)
                Br[fr] = Er[fr][0];
              Sr(Er = Br);
              break;
            case 2:
              for (fr = 0; fr < Er.length; fr++)
                Sr(Er[fr]);
              break;
            case 3:
              for (Er = function(jr) {
                var Qr = jr.length;
                if (Qr <= 1)
                  return [jr];
                for (var ti, Kr, ni = [], gi = 0; gi < Qr; gi++) {
                  var Si = De(jr[gi]);
                  Si !== 0 && (Kr === void 0 && (Kr = Si < 0), Kr === Si < 0 ? (ti && ni.push(ti), ti = [jr[gi]]) : ti.push(jr[gi]));
                }
                return ti && ni.push(ti), ni;
              }(Er), fr = 0; fr < Er.length; fr++)
                for (wr = 0; wr < Er[fr].length; wr++)
                  Sr(Er[fr][wr]);
          }
          Er.length === 1 ? Er = Er[0] : xr = "Multi" + xr;
          var Fr = { type: "Feature", geometry: { type: xr, coordinates: Er }, properties: this.properties };
          return "id" in this && (Fr.id = this.id), Fr;
        }, t1;
      }
      function pg() {
        if (ug)
          return r1;
        ug = 1;
        var Ie = fg();
        function de(De, Ke) {
          this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = De, this._keys = [], this._values = [], this._features = [], De.readFields(Ce, this, Ke), this.length = this._features.length;
        }
        function Ce(De, Ke, Ve) {
          De === 15 ? Ke.version = Ve.readVarint() : De === 1 ? Ke.name = Ve.readString() : De === 5 ? Ke.extent = Ve.readVarint() : De === 2 ? Ke._features.push(Ve.pos) : De === 3 ? Ke._keys.push(Ve.readString()) : De === 4 && Ke._values.push(function(er) {
            for (var fr = null, wr = er.readVarint() + er.pos; er.pos < wr; ) {
              var kr = er.readVarint() >> 3;
              fr = kr === 1 ? er.readString() : kr === 2 ? er.readFloat() : kr === 3 ? er.readDouble() : kr === 4 ? er.readVarint64() : kr === 5 ? er.readVarint() : kr === 6 ? er.readSVarint() : kr === 7 ? er.readBoolean() : null;
            }
            return fr;
          }(Ve));
        }
        return r1 = de, de.prototype.feature = function(De) {
          if (De < 0 || De >= this._features.length)
            throw new Error("feature index out of bounds");
          this._pbf.pos = this._features[De];
          var Ke = this._pbf.readVarint() + this._pbf.pos;
          return new Ie(this._pbf, Ke, this.extent, this._keys, this._values);
        }, r1;
      }
      function dd() {
        return dg || (dg = 1, bc.VectorTile = function() {
          if (hg)
            return i1;
          hg = 1;
          var Ie = pg();
          function de(Ce, De, Ke) {
            if (Ce === 3) {
              var Ve = new Ie(Ke, Ke.readVarint() + Ke.pos);
              Ve.length && (De[Ve.name] = Ve);
            }
          }
          return i1 = function(Ce, De) {
            this.layers = Ce.readFields(de, {}, De);
          }, i1;
        }(), bc.VectorTileFeature = fg(), bc.VectorTileLayer = pg()), bc;
      }
      var $a = dd();
      class ff extends qi {
        constructor(de, Ce, De) {
          super(de, Ce), this.z = De;
        }
      }
      class ac extends ff {
        constructor(de, Ce, De, Ke) {
          super(de, Ce, De), this.w = Ke;
        }
      }
      function Bs(Ie, de, Ce, De) {
        const Ke = [], Ve = De === 0 ? (er, fr, wr, kr, cr, Mr) => {
          er.push(new qi(Mr, wr + (Mr - fr) / (kr - fr) * (cr - wr)));
        } : (er, fr, wr, kr, cr, Mr) => {
          er.push(new qi(fr + (Mr - wr) / (cr - wr) * (kr - fr), Mr));
        };
        for (const er of Ie) {
          const fr = [];
          for (const wr of er) {
            if (wr.length <= 2)
              continue;
            const kr = [];
            for (let Er = 0; Er < wr.length - 1; Er++) {
              const xr = wr[Er].x, Sr = wr[Er].y, Br = wr[Er + 1].x, Fr = wr[Er + 1].y, jr = De === 0 ? xr : Sr, Qr = De === 0 ? Br : Fr;
              jr < de ? Qr > de && Ve(kr, xr, Sr, Br, Fr, de) : jr > Ce ? Qr < Ce && Ve(kr, xr, Sr, Br, Fr, Ce) : kr.push(wr[Er]), Qr < de && jr >= de && Ve(kr, xr, Sr, Br, Fr, de), Qr > Ce && jr <= Ce && Ve(kr, xr, Sr, Br, Fr, Ce);
            }
            let cr = wr[wr.length - 1];
            const Mr = De === 0 ? cr.x : cr.y;
            Mr >= de && Mr <= Ce && kr.push(cr), kr.length && (cr = kr[kr.length - 1], kr[0].x === cr.x && kr[0].y === cr.y || kr.push(kr[0]), fr.push(kr));
          }
          fr.length && Ke.push(fr);
        }
        return Ke;
      }
      function mg(Ie, de, Ce, De) {
        const Ke = Ce === "x" ? "y" : "x", Ve = (De - Ie[Ce]) / (de[Ce] - Ie[Ce]);
        Ie[Ke] = Ie[Ke] + (de[Ke] - Ie[Ke]) * Ve, Ie[Ce] = De, Ie.hasOwnProperty("z") && (Ie.z = Ho(Ie.z, de.z, Ve)), Ie.hasOwnProperty("w") && (Ie.w = Ho(Ie.w, de.w, Ve));
      }
      function wh(Ie, de, Ce, De) {
        const Ke = Ce, Ve = De;
        for (const er of ["x", "y"]) {
          let fr = Ie, wr = de;
          fr[er] >= wr[er] && (fr = de, wr = Ie), fr[er] < Ke && wr[er] > Ke && mg(fr, wr, er, Ke), fr[er] < Ve && wr[er] > Ve && mg(wr, fr, er, Ve);
        }
      }
      const h0 = Number.MAX_SAFE_INTEGER;
      function gg(Ie, de, Ce, De) {
        return Ie.order < de || Ie.order === h0 || !(Ie.clipMask & Ce) || function(Ke, Ve) {
          return Ve.length !== 0 && Ve.find((er) => er === Ke) === void 0;
        }(De, Ie.clipScope);
      }
      function d0(Ie, de) {
        return Ie.x - de.x || Ie.y - de.y;
      }
      function vg(Ie, de) {
        return d0(Ie.min, de.min) === 0 && d0(Ie.max, de.max) === 0;
      }
      function n1(Ie, de) {
        return !(Ie.min.x > de.max.x || Ie.max.x < de.min.x || Ie.min.y > de.max.y || Ie.max.y < de.min.y);
      }
      function hm(Ie, de) {
        if (Ie.length !== de.length)
          return !1;
        for (let Ce = 0; Ce < Ie.length; Ce++)
          if (Ie[Ce].sourceId !== de[Ce].sourceId || !vg(Ie[Ce], de[Ce]) || Ie[Ce].order !== de[Ce].order || Ie[Ce].clipMask !== de[Ce].clipMask || !yn(Ie[Ce].clipScope, de[Ce].clipScope))
            return !1;
        return !0;
      }
      function _g(Ie, de, Ce) {
        const De = 1 / vo, Ke = 1 / (1 << Ce.canonical.z), Ve = (de.x * De + Ce.canonical.x) * Ke + Ce.wrap, er = (de.y * De + Ce.canonical.y) * Ke;
        return { min: new qi((Ie.x * De + Ce.canonical.x) * Ke + Ce.wrap, (Ie.y * De + Ce.canonical.y) * Ke), max: new qi(Ve, er) };
      }
      function Mh(Ie, de, Ce) {
        const De = 1 << Ce.canonical.z, Ke = ((de.x - Ce.wrap) * De - Ce.canonical.x) * vo, Ve = (de.y * De - Ce.canonical.y) * vo;
        return { min: new qi(((Ie.x - Ce.wrap) * De - Ce.canonical.x) * vo, (Ie.y * De - Ce.canonical.y) * vo), max: new qi(Ke, Ve) };
      }
      function o1(Ie, de, Ce, De, Ke, Ve, er) {
        const fr = Ie.indices, wr = Ie.vertices, kr = [];
        for (let cr = De; cr < De + Ke; cr += 3) {
          const Mr = de[Ce[cr + 0] + Ve], Er = de[Ce[cr + 1] + Ve], xr = de[Ce[cr + 2] + Ve], Sr = Math.min(Mr.x, Er.x, xr.x), Br = Math.max(Mr.x, Er.x, xr.x), Fr = Math.min(Mr.y, Er.y, xr.y), jr = Math.max(Mr.y, Er.y, xr.y);
          kr.length = 0, Ie.grid.query(new qi(Sr, Fr), new qi(Br, jr), kr);
          for (let Qr = 0; Qr < kr.length; Qr++) {
            const ti = kr[Qr];
            if (xn(wr[fr[3 * ti + 0]], wr[fr[3 * ti + 1]], wr[fr[3 * ti + 2]], Mr, Er, xr, er))
              return !0;
          }
        }
        return !1;
      }
      function dm(Ie, de, Ce, De) {
        if (!Ie || !Ce)
          return !1;
        let Ke = Ie.vertices;
        if (!de.canonical.equals(De.canonical) || de.wrap !== De.wrap) {
          if (Ce.vertices.length < Ie.vertices.length)
            return dm(Ce, De, Ie, de);
          const Ve = de.canonical, er = De.canonical, fr = Math.pow(2, er.z - Ve.z);
          Ke = Ie.vertices.map((wr) => new qi((wr.x + Ve.x * vo) * fr - er.x * vo, (wr.y + Ve.y * vo) * fr - er.y * vo));
        }
        return o1(Ce, Ke, Ie.indices, 0, Ie.indices.length, 0, 0);
      }
      function $s(Ie, de, Ce, De) {
        const Ke = Math.pow(2, De.z - Ce.z);
        return new qi((Ie + Ce.x * vo) * Ke - De.x * vo, (de + Ce.y * vo) * Ke - De.y * vo);
      }
      function js(Ie, de) {
        const Ce = [];
        de.grid.queryPoint(Ie, Ce);
        const De = de.indices, Ke = de.vertices;
        for (let Ve = 0; Ve < Ce.length; Ve++) {
          const er = Ce[Ve];
          if (dn([Ke[De[3 * er + 0]], Ke[De[3 * er + 1]], Ke[De[3 * er + 2]]], Ie))
            return !0;
        }
        return !1;
      }
      const f0 = [new qi(0, 0), new qi(vo, 0), new qi(vo, vo), new qi(0, vo)];
      function yg(Ie, de) {
        const Ce = [];
        let De = [];
        if (!de || Ie.length < 2)
          return [Ie];
        if (Ie.length === 2)
          return Ln(Ie[0], Ie[1], f0) ? [Ie] : [];
        for (let Ke = 0; Ke < Ie.length + 2; Ke++) {
          const Ve = Ie[Ke % Ie.length], er = Ie[(Ke + 1) % Ie.length], fr = Ln(Ke === 0 ? Ie[Ie.length - 1] : Ie[(Ke - 1) % Ie.length], Ve, f0), wr = Ln(Ve, er, f0), kr = fr || wr;
          kr && De.push(Ve), kr && wr || De.length > 0 && (De.length > 1 && Ce.push(De), De = []);
        }
        return De.length > 1 && Ce.push(De), Ce;
      }
      const a1 = $a.VectorTileFeature.types, jv = ["fill-extrusion-base", "fill-extrusion-height", "fill-extrusion-color", "fill-extrusion-pattern", "fill-extrusion-flood-light-wall-radius", "fill-extrusion-line-width", "fill-extrusion-emissive-strength"], qv = ["fill-extrusion-flood-light-ground-radius"], Gv = Math.pow(2, 13), Hv = Math.pow(2, 15) - 1, s1 = new qi(0, 1), Qc = 2147483648;
      function pf(Ie, de, Ce, De, Ke, Ve, er, fr) {
        Ie.emplaceBack((de << 1) + er, (Ce << 1) + Ve, (Math.floor(De * Gv) << 1) + Ke, Math.round(fr));
      }
      function fm(Ie, de, Ce) {
        Ie.emplaceBack(de.x * vo, de.y * vo, Ce ? 1 : 0);
      }
      function pm(Ie, de, Ce, De, Ke, Ve) {
        Ie.emplaceBack(de.x, de.y, (Ce.x << 1) + De, (Ce.y << 1) + Ke, Ve);
      }
      function fd(Ie, de, Ce) {
        Ie.emplaceBack(de.x, de.y, de.z, Ce[0] * 16384, Ce[1] * 16384, Ce[2] * 16384);
      }
      class xc {
        constructor() {
          this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
        }
      }
      class mf {
        constructor() {
          this.centroidXY = new qi(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new qi(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new qi(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0;
        }
        span() {
          return new qi(this.max.x - this.min.x, this.max.y - this.min.y);
        }
      }
      class bg {
        constructor() {
          this.acc = new qi(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
        }
        startRing(de, Ce) {
          de.min.x === Number.MAX_VALUE && (de.min.x = de.max.x = Ce.x, de.min.y = de.max.y = Ce.y);
        }
        appendEdge(de, Ce, De) {
          this.accCount++, this.acc._add(Ce);
          let Ke = !!this.borders;
          Ce.x < de.min.x ? (de.min.x = Ce.x, Ke = !0) : Ce.x > de.max.x && (de.max.x = Ce.x, Ke = !0), Ce.y < de.min.y ? (de.min.y = Ce.y, Ke = !0) : Ce.y > de.max.y && (de.max.y = Ce.y, Ke = !0), ((Ce.x === 0 || Ce.x === vo) && Ce.x === De.x) != ((Ce.y === 0 || Ce.y === vo) && Ce.y === De.y) && this.processBorderOverlap(Ce, De), Ke && this.checkBorderIntersection(Ce, De);
        }
        checkBorderIntersection(de, Ce) {
          Ce.x < 0 != de.x < 0 && this.addBorderIntersection(0, Ho(Ce.y, de.y, (0 - Ce.x) / (de.x - Ce.x))), Ce.x > vo != de.x > vo && this.addBorderIntersection(1, Ho(Ce.y, de.y, (vo - Ce.x) / (de.x - Ce.x))), Ce.y < 0 != de.y < 0 && this.addBorderIntersection(2, Ho(Ce.x, de.x, (0 - Ce.y) / (de.y - Ce.y))), Ce.y > vo != de.y > vo && this.addBorderIntersection(3, Ho(Ce.x, de.x, (vo - Ce.y) / (de.y - Ce.y)));
        }
        addBorderIntersection(de, Ce) {
          this.borders || (this.borders = [[Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE]]);
          const De = this.borders[de];
          Ce < De[0] && (De[0] = Ce), Ce > De[1] && (De[1] = Ce);
        }
        processBorderOverlap(de, Ce) {
          if (de.x === Ce.x) {
            if (de.y === Ce.y)
              return;
            const De = de.x === 0 ? 0 : 1;
            this.addBorderIntersection(De, Ce.y), this.addBorderIntersection(De, de.y);
          } else {
            const De = de.y === 0 ? 2 : 3;
            this.addBorderIntersection(De, Ce.x), this.addBorderIntersection(De, de.x);
          }
        }
        centroid() {
          return this.accCount === 0 ? new qi(0, 0) : new qi(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
        }
        intersectsCount() {
          return this.borders ? this.borders.reduce((de, Ce) => de + +(Ce[0] !== Number.MAX_VALUE), 0) : 0;
        }
      }
      function xg(Ie, de) {
        const Ce = Ie.add(de)._unit(), De = vn(Ie.x * Ce.x + Ie.y * Ce.y, -1, 1);
        var Ke, Ve, er;
        return er = Math.acos(De), Math.min(4, Math.max(-4, Math.tan(er))) / 4 * Hv * ((Ke = Ie).x * (Ve = de).y - Ke.y * Ve.x < 0 ? -1 : 1);
      }
      const Wv = [(Ie) => Ie.x < 0, (Ie) => Ie.x > vo, (Ie) => Ie.y < 0, (Ie) => Ie.y > vo];
      function Zv(Ie, de, Ce, De) {
        const Ke = [4];
        if (De === 0)
          return Ke;
        Ce._mult(De);
        const Ve = Ie.sub(Ce), er = de.sub(Ce), fr = [Ie, de, Ve, er];
        for (let wr = 0; wr < 4; wr++)
          for (const kr of fr)
            if (Wv[wr](kr)) {
              Ke.push(wr);
              break;
            }
        return Ke;
      }
      class wg {
        constructor(de) {
          this.vertexArray = new tc(), this.indexArray = new tl(), this.programConfigurations = new du(de.layers, { zoom: de.zoom, lut: de.lut }, (Ce) => qv.includes(Ce)), this._segments = new fs(), this.hiddenByLandmarkVertexArray = new rc(), this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [0, 0, 0, 0, 0], this.regionSegments = {}, this.regionSegments[4] = new fs();
        }
        getDefaultSegment() {
          return this.regionSegments[4];
        }
        hasData() {
          return this.vertexArray.length !== 0;
        }
        addData(de, Ce, De, Ke = !1) {
          const Ve = de.length;
          if (Ve > 2) {
            let er = Math.max(0, this._segments.get().length - 1);
            const fr = this._segments._prepareSegment(4 * Ve, this.vertexArray.length, 2 * this._segmentToGroundQuads[er].length);
            let wr;
            er !== this._segments.get().length - 1 && (er++, this._segmentToGroundQuads[er] = [], this._segmentToRegionTriCounts[er] = [0, 0, 0, 0, 0]);
            {
              const kr = de[0], cr = de[1];
              wr = xg(kr.sub(de[Ve - 1])._perp()._unit(), cr.sub(kr)._perp()._unit());
            }
            for (let kr = 0; kr < Ve; kr++) {
              const cr = kr === Ve - 1 ? 0 : kr + 1, Mr = de[kr], Er = de[cr], xr = de[cr === Ve - 1 ? 0 : cr + 1], Sr = Er.sub(Mr)._perp()._unit(), Br = xg(Sr, xr.sub(Er)._perp()._unit()), Fr = wr, jr = Br;
              if (wc(Mr, Er, Ce) || Ke && c1(Mr, Ce) && c1(Er, Ce)) {
                wr = Br;
                continue;
              }
              const Qr = fr.vertexLength;
              pm(this.vertexArray, Mr, Er, 1, 1, Fr), pm(this.vertexArray, Mr, Er, 1, 0, Fr), pm(this.vertexArray, Mr, Er, 0, 1, jr), pm(this.vertexArray, Mr, Er, 0, 0, jr), fr.vertexLength += 4;
              const ti = Zv(Mr, Er, Sr, De);
              for (const Kr of ti)
                this._segmentToGroundQuads[er].push({ id: Qr, region: Kr }), this._segmentToRegionTriCounts[er][Kr] += 2, fr.primitiveLength += 2;
              wr = Br;
            }
          }
        }
        prepareBorderSegments() {
          if (!this.hasData())
            return;
          const de = this._segments.get(), Ce = de.length;
          for (let De = 0; De < Ce; De++)
            this._segmentToGroundQuads[De].sort((Ke, Ve) => Ke.region - Ve.region);
          for (let De = 0; De < Ce; De++) {
            const Ke = this._segmentToGroundQuads[De], Ve = de[De], er = this._segmentToRegionTriCounts[De];
            er.reduce((wr, kr) => wr + kr, 0);
            let fr = 0;
            for (let wr = 0; wr <= 4; wr++) {
              const kr = er[wr];
              if (kr !== 0) {
                let cr = this.regionSegments[wr];
                cr || (cr = this.regionSegments[wr] = new fs());
                const Mr = { vertexOffset: Ve.vertexOffset, primitiveOffset: Ve.primitiveOffset + fr, vertexLength: Ve.vertexLength, primitiveLength: kr };
                cr.get().push(Mr);
              }
              fr += kr;
            }
            for (let wr = 0; wr < Ke.length; wr++) {
              const kr = Ke[wr].id;
              this.indexArray.emplaceBack(kr, kr + 1, kr + 3), this.indexArray.emplaceBack(kr, kr + 3, kr + 2);
            }
          }
          this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
        }
        addPaintPropertiesData(de, Ce, De, Ke, Ve, er) {
          this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, de, Ce, De, Ke, Ve, er);
        }
        upload(de) {
          this.hasData() && (this.vertexBuffer = de.createVertexBuffer(this.vertexArray, lg.members), this.indexBuffer = de.createIndexBuffer(this.indexArray));
        }
        uploadPaintProperties(de) {
          this.hasData() && this.programConfigurations.upload(de);
        }
        update(de, Ce, De, Ke, Ve, er, fr) {
          this.hasData() && this.programConfigurations.updatePaintArrays(de, Ce, De, Ke, Ve, er, fr);
        }
        updateHiddenByLandmark(de) {
          if (!this.hasData())
            return;
          const Ce = de.groundVertexCount + de.groundVertexArrayOffset;
          if (de.groundVertexCount === 0)
            return;
          const De = de.flags & Qc ? 1 : 0;
          for (let Ke = de.groundVertexArrayOffset; Ke < Ce; ++Ke)
            this.hiddenByLandmarkVertexArray.emplace(Ke, De);
          this._needsHiddenByLandmarkUpdate = !0;
        }
        uploadHiddenByLandmark(de) {
          this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = de.createVertexBuffer(this.hiddenByLandmarkVertexArray, Nv.members, !0) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = !1);
        }
        destroy() {
          if (this.vertexBuffer) {
            this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
            for (let de = 0; de <= 4; de++) {
              const Ce = this.regionSegments[de];
              Ce && Ce.destroy();
            }
          }
        }
      }
      class mm {
        constructor(de) {
          this.zoom = de.zoom, this.canonical = de.canonical, this.overscaling = de.overscaling, this.layers = de.layers, this.layerIds = this.layers.map((Ce) => Ce.fqid), this.index = de.index, this.hasPattern = !1, this.edgeRadius = 0, this.projection = de.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = [], this.footprintIndices = new tl(), this.footprintVertices = new Zc(), this.footprintSegments = [], this.layoutVertexArray = new $u(), this.centroidVertexArray = new Yp(), this.wallVertexArray = new Bc(), this.indexArray = new tl(), this.programConfigurations = new du(de.layers, { zoom: de.zoom, lut: de.lut }, (Ce) => jv.includes(Ce)), this.segments = new fs(), this.stateDependentLayerIds = this.layers.filter((Ce) => Ce.isStateDependent()).map((Ce) => Ce.id), this.groundEffect = new wg(de), this.maxHeight = 0, this.partLookup = {}, this.triangleSubSegments = [], this.polygonSegments = [];
        }
        updateFootprints(de, Ce) {
        }
        populate(de, Ce, De, Ke) {
          this.features = [], this.hasPattern = l0("fill-extrusion", this.layers, Ce), this.featuresOnBorder = [], this.borderFeatureIndices = [[], [], [], []], this.borderDoneWithNeighborZ = [-1, -1, -1, -1], this.selfDEMTileTimestamp = Number.MAX_VALUE, this.borderDEMTileTimestamp = [Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE], this.tileToMeter = He(De), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter, this.wallMode = this.layers[0].paint.get("fill-extrusion-line-width").constantOr(1) !== 0;
          for (const { feature: Ve, id: er, index: fr, sourceLayerIndex: wr } of de) {
            const kr = this.layers[0]._featureFilter.needGeometry, cr = Jr(Ve, kr);
            if (!this.layers[0]._featureFilter.filter(new wa(this.zoom), cr, De))
              continue;
            const Mr = { id: er, sourceLayerIndex: wr, index: fr, geometry: kr ? cr.geometry : qr(Ve, De, Ke), properties: Ve.properties, type: Ve.type, patterns: {} }, Er = this.layoutVertexArray.length, xr = a1[Mr.type] === "Polygon";
            if (this.hasPattern)
              this.features.push(c0("fill-extrusion", this.layers, Mr, this.zoom, Ce));
            else if (this.wallMode)
              for (const Sr of Mr.geometry)
                for (const Br of yg(Sr, xr))
                  this.addFeature(Mr, [Br], fr, De, {}, Ce.availableImages, Ke, Ce.brightness);
            else
              this.addFeature(Mr, Mr.geometry, fr, De, {}, Ce.availableImages, Ke, Ce.brightness);
            Ce.featureIndex.insert(Ve, Mr.geometry, fr, wr, this.index, Er);
          }
          this.sortBorders(), this.projection.name === "mercator" && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
        }
        addFeatures(de, Ce, De, Ke, Ve, er) {
          for (const fr of this.features) {
            const wr = a1[fr.type] === "Polygon", { geometry: kr } = fr;
            if (this.wallMode)
              for (const cr of kr)
                for (const Mr of yg(cr, wr))
                  this.addFeature(fr, [Mr], fr.index, Ce, De, Ke, Ve, er);
            else
              this.addFeature(fr, kr, fr.index, Ce, De, Ke, Ve, er);
          }
          this.sortBorders(), this.projection.name === "mercator" && this.splitToSubtiles();
        }
        update(de, Ce, De, Ke, Ve, er, fr) {
          this.programConfigurations.updatePaintArrays(de, Ce, Ve, De, Ke, er, fr), this.groundEffect.update(de, Ce, Ve, De, Ke, er, fr);
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
        }
        upload(de) {
          this.uploaded || (this.layoutVertexBuffer = de.createVertexBuffer(this.layoutVertexArray, Uv), this.indexBuffer = de.createIndexBuffer(this.indexArray), this.wallVertexBuffer = de.createVertexBuffer(this.wallVertexArray, Fv.members), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = de.createVertexBuffer(this.layoutVertexExtArray, Vv.members, !0)), this.groundEffect.upload(de)), this.groundEffect.uploadPaintProperties(de), this.programConfigurations.upload(de), this.uploaded = !0;
        }
        uploadCentroid(de) {
          this.groundEffect.uploadHiddenByLandmark(de), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = de.createVertexBuffer(this.centroidVertexArray, zv.members, !0) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = !1);
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }
        addFeature(de, Ce, De, Ke, Ve, er, fr, wr) {
          const kr = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(de, {}) / this.tileToMeter, cr = [new qi(0, 0), new qi(vo, vo)], Mr = fr.projection, Er = Mr.name === "globe", xr = this.wallMode || a1[de.type] === "Polygon", Sr = new bg();
          Sr.centroidDataIndex = this.centroidData.length;
          const Br = new mf(), Fr = this.layers[0].paint.get("fill-extrusion-base").evaluate(de, {}, Ke) <= 0, jr = this.layers[0].paint.get("fill-extrusion-height").evaluate(de, {}, Ke);
          let Qr;
          if (Br.height = jr, Br.vertexArrayOffset = this.layoutVertexArray.length, Br.groundVertexArrayOffset = this.groundEffect.vertexArray.length, Er && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new Jf()), this.wallMode) {
            if (Er)
              return void Mn("Non zero fill-extrusion-line-width is not yet supported on globe.");
            if (Ce.length !== 1)
              return;
            Qr = function(Bi) {
              const Ji = Bi[0].x === Bi[Bi.length - 1].x && Bi[0].y === Bi[Bi.length - 1].y;
              (function(bo) {
                let Jn = 0;
                const Ro = bo.length;
                for (let po = 0; po < Ro; po++)
                  Jn += (bo[(po + 1) % Ro].x - bo[po].x) * (bo[(po + 1) % Ro].y + bo[po].y);
                return Jn >= 0;
              })(Bi) || (Bi = Bi.reverse());
              const tn = { geometry: [], joinNormals: [], indices: [] }, cn = [], ln = [], mn = [];
              let wn = Bi.length;
              for (; wn >= 2 && Bi[wn - 1].equals(Bi[wn - 2]); )
                wn--;
              if (wn < (Ji ? 3 : 2))
                return tn;
              let Cn, gn, Nn, oo, Un, fo = 0;
              for (; fo < wn - 1 && Bi[fo].equals(Bi[fo + 1]); )
                fo++;
              Ji && (Cn = Bi[wn - 2], Un = Bi[fo].sub(Cn)._unit()._perp());
              for (let bo = fo; bo < wn; bo++) {
                if (Nn = bo === wn - 1 ? Ji ? Bi[fo + 1] : void 0 : Bi[bo + 1], Nn && Bi[bo].equals(Nn))
                  continue;
                Un && (oo = Un), Cn && (gn = Cn), Cn = Bi[bo], Un = Nn ? Nn.sub(Cn)._unit()._perp() : oo, oo = oo || Un;
                let Jn = oo.add(Un);
                Jn.x === 0 && Jn.y === 0 || Jn._unit();
                const Ro = Jn.x * Un.x + Jn.y * Un.y, po = Ro !== 0 ? 1 / Ro : 1 / 0, Lo = oo.x * Un.y - oo.y * Un.x > 0;
                let jo = "miter";
                const oa = 2;
                jo === "miter" && po > oa && (jo = "bevel"), jo === "bevel" && (po > 100 && (jo = "flipbevel"), po < oa && (jo = "miter"));
                const ua = (fa, ha, va, os) => {
                  const qa = new qi(fa.x, fa.y), ra = new qi(fa.x, fa.y);
                  qa.x += ha.x * os, qa.y += ha.y * os, ra.x -= ha.x * Math.max(va, 1), ra.y -= ha.y * Math.max(va, 1), mn.push(ha), cn.push(qa), ln.push(ra);
                };
                if (jo === "miter")
                  Jn._mult(po), ua(Cn, Jn, 0, 0);
                else if (jo === "flipbevel")
                  Jn = Un.mult(-1), ua(Cn, Jn, 0, 0), ua(Cn, Jn.mult(-1), 0, 0);
                else {
                  const fa = -Math.sqrt(po * po - 1), ha = Lo ? fa : 0, va = Lo ? 0 : fa;
                  gn && ua(Cn, oo, ha, va), Nn && ua(Cn, Un, ha, va);
                }
              }
              tn.geometry = [...cn, ...ln.reverse(), cn[0]], tn.joinNormals = [...mn, ...mn.reverse(), mn[mn.length - 1]];
              const ho = tn.geometry.length - 1;
              for (let bo = 0; bo < ho / 2; bo++)
                if (bo + 1 < ho / 2) {
                  let Jn = bo, Ro = bo + 1, po = ho - 1 - bo, Lo = ho - 2 - bo;
                  Jn = Jn === 0 ? ho - 1 : Jn - 1, Ro = Ro === 0 ? ho - 1 : Ro - 1, po = po === 0 ? ho - 1 : po - 1, Lo = Lo === 0 ? ho - 1 : Lo - 1, tn.indices.push(po), tn.indices.push(Ro), tn.indices.push(Jn), tn.indices.push(po), tn.indices.push(Lo), tn.indices.push(Ro);
                }
              return tn;
            }(Ce[0]), Ce = [Qr.geometry];
          }
          const ti = (Bi, Ji) => Bi < (Ji.length - 1) / 2 || Bi === Ji.length - 1, Kr = this.wallMode ? [Ce] : cm(Ce, 500);
          for (let Bi = Kr.length - 1; Bi >= 0; Bi--) {
            const Ji = Kr[Bi];
            (Ji.length === 0 || (ni = Ji[0]).every((Fi) => Fi.x <= 0) || ni.every((Fi) => Fi.x >= vo) || ni.every((Fi) => Fi.y <= 0) || ni.every((Fi) => Fi.y >= vo)) && Kr.splice(Bi, 1);
          }
          var ni;
          let gi;
          if (Er)
            gi = u1(Kr, cr, Ke);
          else {
            gi = [];
            for (const Bi of Kr)
              gi.push({ polygon: Bi, bounds: cr });
          }
          const Si = xr ? this.edgeRadius : 0, Di = Si > 0 && this.zoom < 17, Ri = (Bi, Ji) => {
            if (Bi.length === 0)
              return !1;
            const Fi = Bi[Bi.length - 1];
            return Ji.x === Fi.x && Ji.y === Fi.y;
          };
          for (const { polygon: Bi, bounds: Ji } of gi) {
            let Fi = 0, tn = 0;
            for (const wn of Bi)
              xr && !wn[0].equals(wn[wn.length - 1]) && wn.push(wn[0]), tn += xr ? wn.length - 1 : wn.length;
            const cn = this.segments.prepareSegment((xr ? 5 : 4) * tn, this.layoutVertexArray, this.indexArray);
            Br.footprintSegIdx < 0 && (Br.footprintSegIdx = this.footprintSegments.length), Br.polygonSegIdx < 0 && (Br.polygonSegIdx = this.polygonSegments.length);
            const ln = { triangleArrayOffset: this.indexArray.length, triangleCount: 0, triangleSegIdx: this.segments.segments.length - 1 }, mn = new xc();
            if (mn.vertexOffset = this.footprintVertices.length, mn.indexOffset = 3 * this.footprintIndices.length, mn.ringIndices = [], xr) {
              const wn = [], Cn = [];
              Fi = cn.vertexLength;
              for (let Nn = 0; Nn < Bi.length; Nn++) {
                const oo = Bi[Nn];
                oo.length && Nn !== 0 && Cn.push(wn.length / 2);
                const Un = [];
                let fo, ho;
                fo = oo[1].sub(oo[0])._perp()._unit(), mn.ringIndices.push(oo.length - 1);
                for (let bo = 1; bo < oo.length; bo++) {
                  const Jn = oo[bo], Ro = oo[bo === oo.length - 1 ? 1 : bo + 1], po = Jn.clone();
                  if (Si) {
                    ho = Ro.sub(Jn)._perp()._unit();
                    const Lo = fo.add(ho)._unit(), jo = Si * Math.min(4, 1 / (fo.x * Lo.x + fo.y * Lo.y));
                    po.x += jo * Lo.x, po.y += jo * Lo.y, po.x = Math.round(po.x), po.y = Math.round(po.y), fo = ho;
                  }
                  if (!Fr || Si !== 0 && !Di || Ri(Un, po) || Un.push(po), pf(this.layoutVertexArray, po.x, po.y, 0, 0, 1, 1, 0), this.wallMode) {
                    const Lo = ti(bo, oo);
                    fm(this.wallVertexArray, Qr.joinNormals[bo], !Lo);
                  }
                  cn.vertexLength++, this.footprintVertices.emplaceBack(Jn.x, Jn.y), wn.push(Jn.x, Jn.y), Er && fd(this.layoutVertexExtArray, Mr.projectTilePoint(po.x, po.y, Ke), Mr.upVector(Ke, po.x, po.y));
                }
                Fr && (Si === 0 || Di) && (Un.length !== 0 && Ri(Un, Un[0]) && Un.pop(), this.groundEffect.addData(Un, Ji, kr));
              }
              const gn = this.wallMode ? Qr.indices : nm(wn, Cn);
              for (let Nn = 0; Nn < gn.length; Nn += 3)
                this.footprintIndices.emplaceBack(mn.vertexOffset + gn[Nn + 0], mn.vertexOffset + gn[Nn + 1], mn.vertexOffset + gn[Nn + 2]), this.indexArray.emplaceBack(Fi + gn[Nn], Fi + gn[Nn + 2], Fi + gn[Nn + 1]), cn.primitiveLength++;
              mn.indexCount += gn.length, mn.vertexCount += this.footprintVertices.length - mn.vertexOffset;
            }
            for (let wn = 0; wn < Bi.length; wn++) {
              const Cn = Bi[wn];
              Sr.startRing(Br, Cn[0]);
              let gn = Cn.length > 4 && Mg(Cn[Cn.length - 2], Cn[0], Cn[1]), Nn = Si ? Va(Cn[Cn.length - 2], Cn[0], Cn[1], Si) : 0;
              const oo = [];
              let Un, fo, ho;
              fo = Cn[1].sub(Cn[0])._perp()._unit();
              let bo = !0;
              for (let Jn = 1, Ro = 0; Jn < Cn.length; Jn++) {
                let po = Cn[Jn - 1], Lo = Cn[Jn];
                const jo = Cn[Jn === Cn.length - 1 ? 1 : Jn + 1];
                if (Sr.appendEdge(Br, Lo, po), wc(Lo, po, Ji)) {
                  Si && (fo = jo.sub(Lo)._perp()._unit(), bo = !bo);
                  continue;
                }
                const oa = Lo.sub(po)._perp(), ua = oa.x / (Math.abs(oa.x) + Math.abs(oa.y)), fa = oa.y > 0 ? 1 : 0, ha = po.dist(Lo);
                if (Ro + ha > 32768 && (Ro = 0), Si) {
                  ho = jo.sub(Lo)._perp()._unit();
                  let ra = l1(po, Lo, jo, Vu(fo, ho), Si);
                  isNaN(ra) && (ra = 0);
                  const Ga = Lo.sub(po)._unit();
                  po = po.add(Ga.mult(Nn))._round(), Lo = Lo.add(Ga.mult(-ra))._round(), Nn = ra, fo = ho, Fr && this.zoom >= 17 && (Ri(oo, po) || oo.push(po), Ri(oo, Lo) || oo.push(Lo));
                }
                const va = cn.vertexLength, os = Cn.length > 4 && Mg(po, Lo, jo);
                let qa = ms(Ro, gn, bo);
                if (pf(this.layoutVertexArray, po.x, po.y, ua, fa, 0, 0, qa), pf(this.layoutVertexArray, po.x, po.y, ua, fa, 0, 1, qa), this.wallMode) {
                  const ra = ti(Jn - 1, Cn), Ga = Qr.joinNormals[Jn - 1];
                  fm(this.wallVertexArray, Ga, ra), fm(this.wallVertexArray, Ga, ra);
                }
                if (Ro += ha, qa = ms(Ro, os, !bo), gn = os, pf(this.layoutVertexArray, Lo.x, Lo.y, ua, fa, 0, 0, qa), pf(this.layoutVertexArray, Lo.x, Lo.y, ua, fa, 0, 1, qa), this.wallMode) {
                  const ra = ti(Jn, Cn), Ga = Qr.joinNormals[Jn];
                  fm(this.wallVertexArray, Ga, ra), fm(this.wallVertexArray, Ga, ra);
                }
                if (cn.vertexLength += 4, this.indexArray.emplaceBack(va + 0, va + 1, va + 2), this.indexArray.emplaceBack(va + 1, va + 3, va + 2), cn.primitiveLength += 2, Si) {
                  const ra = Fi + (Jn === 1 ? Cn.length - 2 : Jn - 2), Ga = Jn === 1 ? Fi : ra + 1;
                  if (this.indexArray.emplaceBack(va + 1, ra, va + 3), this.indexArray.emplaceBack(ra, Ga, va + 3), cn.primitiveLength += 2, Un === void 0 && (Un = va), !wc(jo, Cn[Jn], Ji)) {
                    const ja = Jn === Cn.length - 1 ? Un : cn.vertexLength;
                    this.indexArray.emplaceBack(va + 2, va + 3, ja), this.indexArray.emplaceBack(va + 3, ja + 1, ja), this.indexArray.emplaceBack(va + 3, Ga, ja + 1), cn.primitiveLength += 3;
                  }
                  bo = !bo;
                }
                if (Er) {
                  const ra = this.layoutVertexExtArray, Ga = Mr.projectTilePoint(po.x, po.y, Ke), ja = Mr.projectTilePoint(Lo.x, Lo.y, Ke), as = Mr.upVector(Ke, po.x, po.y), Gs = Mr.upVector(Ke, Lo.x, Lo.y);
                  fd(ra, Ga, as), fd(ra, Ga, as), fd(ra, ja, Gs), fd(ra, ja, Gs);
                }
              }
              xr && (Fi += Cn.length - 1), Fr && Si && this.zoom >= 17 && (oo.length !== 0 && Ri(oo, oo[0]) && oo.pop(), this.groundEffect.addData(oo, Ji, kr, Si > 0));
            }
            this.footprintSegments.push(mn), ln.triangleCount = this.indexArray.length - ln.triangleArrayOffset, this.polygonSegments.push(ln), ++Br.footprintSegLen, ++Br.polygonSegLen;
          }
          if (Br.vertexCount = this.layoutVertexArray.length - Br.vertexArrayOffset, Br.groundVertexCount = this.groundEffect.vertexArray.length - Br.groundVertexArrayOffset, Br.vertexCount !== 0) {
            if (Br.centroidXY = Sr.borders ? s1 : this.encodeCentroid(Sr, Br), this.centroidData.push(Br), Sr.borders) {
              this.featuresOnBorder.push(Sr);
              const Bi = this.featuresOnBorder.length - 1;
              for (let Ji = 0; Ji < Sr.borders.length; Ji++)
                Sr.borders[Ji][0] !== Number.MAX_VALUE && this.borderFeatureIndices[Ji].push(Bi);
            }
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, de, De, Ve, er, Ke, wr), this.groundEffect.addPaintPropertiesData(de, De, Ve, er, Ke, wr), this.maxHeight = Math.max(this.maxHeight, jr);
          }
        }
        sortBorders() {
          for (let de = 0; de < this.borderFeatureIndices.length; de++)
            this.borderFeatureIndices[de].sort((Ce, De) => this.featuresOnBorder[Ce].borders[de][0] - this.featuresOnBorder[De].borders[de][0]);
        }
        splitToSubtiles() {
          const de = [];
          for (let fr = 0; fr < this.centroidData.length; fr++) {
            const wr = this.centroidData[fr], kr = +(wr.min.y + wr.max.y > vo), cr = 2 * kr + (+(wr.min.x + wr.max.x > vo) ^ kr);
            for (let Mr = 0; Mr < wr.polygonSegLen; Mr++) {
              const Er = wr.polygonSegIdx + Mr;
              de.push({ centroidIdx: fr, subtile: cr, polygonSegmentIdx: Er, triangleSegmentIdx: this.polygonSegments[Er].triangleSegIdx });
            }
          }
          const Ce = new tl();
          de.sort((fr, wr) => fr.triangleSegmentIdx === wr.triangleSegmentIdx ? fr.subtile - wr.subtile : fr.triangleSegmentIdx - wr.triangleSegmentIdx);
          let De = 0, Ke = 0, Ve = 0;
          for (const fr of de) {
            if (fr.triangleSegmentIdx !== De)
              break;
            Ve++;
          }
          const er = de.length;
          for (; Ke !== de.length; ) {
            De = de[Ke].triangleSegmentIdx;
            let fr = 0, wr = Ke, kr = Ke;
            for (let cr = wr; cr < Ve && de[cr].subtile === fr; cr++)
              kr++;
            for (; wr !== Ve; ) {
              const cr = de[wr];
              fr = cr.subtile;
              const Mr = this.centroidData[cr.centroidIdx].min.clone(), Er = this.centroidData[cr.centroidIdx].max.clone(), xr = { vertexOffset: this.segments.segments[De].vertexOffset, primitiveOffset: Ce.length, vertexLength: this.segments.segments[De].vertexLength, primitiveLength: 0, sortKey: void 0, vaos: {} };
              for (let Sr = wr; Sr < kr; Sr++) {
                const Br = de[Sr], Fr = this.polygonSegments[Br.polygonSegmentIdx], jr = this.centroidData[Br.centroidIdx].min, Qr = this.centroidData[Br.centroidIdx].max, ti = this.indexArray.uint16;
                for (let Kr = Fr.triangleArrayOffset; Kr < Fr.triangleArrayOffset + Fr.triangleCount; Kr++)
                  Ce.emplaceBack(ti[3 * Kr], ti[3 * Kr + 1], ti[3 * Kr + 2]);
                xr.primitiveLength += Fr.triangleCount, Mr.x = Math.min(Mr.x, jr.x), Mr.y = Math.min(Mr.y, jr.y), Er.x = Math.max(Er.x, Qr.x), Er.y = Math.max(Er.y, Qr.y);
              }
              xr.primitiveLength > 0 && this.triangleSubSegments.push({ segment: xr, min: Mr, max: Er }), wr = kr;
              for (let Sr = wr; Sr < Ve && de[Sr].subtile === de[wr].subtile; Sr++)
                kr++;
            }
            Ke = Ve;
            for (let cr = Ke; cr < er && de[cr].triangleSegmentIdx === de[Ke].triangleSegmentIdx; cr++)
              Ve++;
          }
          Ce._trim(), this.indexArray = Ce;
        }
        getVisibleSegments(de, Ce, De) {
          const Ke = new fs();
          if (this.wallMode) {
            for (const Br of this.triangleSubSegments)
              Ke.segments.push(Br.segment);
            return Ke;
          }
          let Ve = 0, er = 0;
          const fr = 1 << de.canonical.z;
          if (Ce) {
            const Br = Ce.getMinMaxForTile(de);
            Br && (Ve = Br.min, er = Br.max);
          }
          er += this.maxHeight;
          const wr = de.toUnwrapped();
          let kr;
          const cr = [wr.canonical.x / fr + wr.wrap, wr.canonical.y / fr], Mr = [(wr.canonical.x + 1) / fr + wr.wrap, (wr.canonical.y + 1) / fr], Er = (Br, Fr, jr) => [Br[0] * (1 - jr[0]) + Fr[0] * jr[0], Br[1] * (1 - jr[1]) + Fr[1] * jr[1]], xr = [], Sr = [];
          for (const Br of this.triangleSubSegments) {
            xr[0] = Br.min.x / vo, xr[1] = Br.min.y / vo, Sr[0] = Br.max.x / vo, Sr[1] = Br.max.y / vo;
            const Fr = Er(cr, Mr, xr), jr = Er(cr, Mr, Sr);
            if (new qo([Fr[0], Fr[1], Ve], [jr[0], jr[1], er]).intersectsPrecise(De) === 0) {
              kr && (Ke.segments.push(kr), kr = void 0);
              continue;
            }
            const Qr = Br.segment;
            kr && kr.vertexOffset !== Qr.vertexOffset && (Ke.segments.push(kr), kr = void 0), kr ? (kr.vertexLength += Qr.vertexLength, kr.primitiveLength += Qr.primitiveLength) : kr = { vertexOffset: Qr.vertexOffset, primitiveLength: Qr.primitiveLength, vertexLength: Qr.vertexLength, primitiveOffset: Qr.primitiveOffset, sortKey: void 0, vaos: {} };
          }
          return kr && Ke.segments.push(kr), Ke;
        }
        encodeCentroid(de, Ce) {
          const De = de.centroid(), Ke = Ce.span(), Ve = Math.min(7, Math.round(Ke.x * this.tileToMeter / 10)), er = Math.min(7, Math.round(Ke.y * this.tileToMeter / 10));
          return new qi(vn(De.x, 1, vo - 1) << 3 | Ve, vn(De.y, 1, vo - 1) << 3 | er);
        }
        encodeBorderCentroid(de) {
          if (!de.borders)
            return new qi(0, 0);
          const Ce = de.borders, De = Number.MAX_VALUE;
          if (Ce[0][0] !== De || Ce[1][0] !== De) {
            const Ke = Ce[0][0] !== De ? 0 : 1;
            return new qi(6 | (Ce[0][0] !== De ? 0 : 65528), (Ce[Ke][0] + Ce[Ke][1]) / 2 << 3 | 6);
          }
          {
            const Ke = Ce[2][0] !== De ? 2 : 3;
            return new qi((Ce[Ke][0] + Ce[Ke][1]) / 2 << 3 | 6, 6 | (Ce[2][0] !== De ? 0 : 65528));
          }
        }
        showCentroid(de) {
          const Ce = this.centroidData[de.centroidDataIndex];
          Ce.flags &= Qc, Ce.centroidXY.x = 0, Ce.centroidXY.y = 0, this.writeCentroidToBuffer(Ce);
        }
        writeCentroidToBuffer(de) {
          this.groundEffect.updateHiddenByLandmark(de);
          const Ce = de.vertexArrayOffset, De = de.vertexCount + de.vertexArrayOffset, Ke = de.flags & Qc ? s1 : de.centroidXY, Ve = this.centroidVertexArray.geta_centroid_pos0(Ce);
          if (this.centroidVertexArray.geta_centroid_pos1(Ce) !== Ke.y || Ve !== Ke.x) {
            for (let er = Ce; er < De; ++er)
              this.centroidVertexArray.emplace(er, Ke.x, Ke.y);
            this.needsCentroidUpdate = !0;
          }
        }
        createCentroidsBuffer() {
          this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
          for (const de of this.centroidData)
            this.writeCentroidToBuffer(de);
        }
        updateReplacement(de, Ce, De) {
          if (Ce.updateTime === this.replacementUpdateTime)
            return;
          this.replacementUpdateTime = Ce.updateTime;
          const Ke = Ce.getReplacementRegionsForTile(de.toUnwrapped());
          if (hm(this.activeReplacements, Ke))
            return;
          if (this.activeReplacements = Ke, this.centroidVertexArray.length === 0)
            this.createCentroidsBuffer();
          else
            for (const er of this.centroidData)
              er.flags &= 2147483647;
          const Ve = [];
          for (const er of this.activeReplacements) {
            if (er.order < De)
              continue;
            const fr = Math.max(1, Math.pow(2, er.footprintTileId.canonical.z - de.canonical.z));
            for (const wr of this.centroidData)
              if (!(wr.flags & Qc || er.min.x > wr.max.x || wr.min.x > er.max.x || er.min.y > wr.max.y || wr.min.y > er.max.y))
                for (let kr = 0; kr < wr.footprintSegLen; kr++) {
                  const cr = this.footprintSegments[wr.footprintSegIdx + kr];
                  if (Ve.length = 0, p0(this.footprintVertices, cr.vertexOffset, cr.vertexCount, er.footprintTileId.canonical, de.canonical, Ve), o1(er.footprint, Ve, this.footprintIndices.uint16, cr.indexOffset, cr.indexCount, -cr.vertexOffset, -fr)) {
                    wr.flags |= Qc;
                    break;
                  }
                }
          }
          for (const er of this.centroidData)
            this.writeCentroidToBuffer(er);
          this.borderDoneWithNeighborZ = [-1, -1, -1, -1];
        }
        footprintContainsPoint(de, Ce, De) {
          let Ke = !1;
          for (let Ve = 0; Ve < De.footprintSegLen; Ve++) {
            const er = this.footprintSegments[De.footprintSegIdx + Ve];
            let fr = 0;
            for (const wr of er.ringIndices) {
              for (let kr = fr, cr = wr + fr - 1; kr < wr + fr; cr = kr++) {
                const Mr = this.footprintVertices.int16[2 * (kr + er.vertexOffset) + 0], Er = this.footprintVertices.int16[2 * (kr + er.vertexOffset) + 1], xr = this.footprintVertices.int16[2 * (cr + er.vertexOffset) + 1];
                Er > Ce != xr > Ce && de < (this.footprintVertices.int16[2 * (cr + er.vertexOffset) + 0] - Mr) * (Ce - Er) / (xr - Er) + Mr && (Ke = !Ke);
              }
              fr = wr;
            }
          }
          return Ke;
        }
        getHeightAtTileCoord(de, Ce) {
          let De = Number.NEGATIVE_INFINITY, Ke = !0;
          const Ve = 4 * (de + vo) * vo + (Ce + vo);
          if (this.partLookup.hasOwnProperty(Ve)) {
            const er = this.partLookup[Ve];
            return er ? { height: er.height, hidden: !!(er.flags & Qc) } : void 0;
          }
          for (const er of this.centroidData)
            de > er.max.x || er.min.x > de || Ce > er.max.y || er.min.y > Ce || this.footprintContainsPoint(de, Ce, er) && er && er.height > De && (De = er.height, this.partLookup[Ve] = er, Ke = !!(er.flags & Qc));
          if (De !== Number.NEGATIVE_INFINITY)
            return { height: De, hidden: Ke };
          this.partLookup[Ve] = void 0;
        }
      }
      function Vu(Ie, de) {
        const Ce = Ie.add(de)._unit();
        return Ie.x * Ce.x + Ie.y * Ce.y;
      }
      function Va(Ie, de, Ce, De) {
        const Ke = de.sub(Ie)._perp()._unit(), Ve = Ce.sub(de)._perp()._unit();
        return l1(Ie, de, Ce, Vu(Ke, Ve), De);
      }
      function l1(Ie, de, Ce, De, Ke) {
        const Ve = Math.sqrt(1 - De * De);
        return Math.min(Ie.dist(de) / 3, de.dist(Ce) / 3, Ke * Ve / De);
      }
      function wc(Ie, de, Ce) {
        return Ie.x < Ce[0].x && de.x < Ce[0].x || Ie.x > Ce[1].x && de.x > Ce[1].x || Ie.y < Ce[0].y && de.y < Ce[0].y || Ie.y > Ce[1].y && de.y > Ce[1].y;
      }
      function c1(Ie, de) {
        return Ie.x < de[0].x || Ie.x > de[1].x || Ie.y < de[0].y || Ie.y > de[1].y;
      }
      function Mg(Ie, de, Ce) {
        if (Ie.x < 0 || Ie.x >= vo || de.x < 0 || de.x >= vo || Ce.x < 0 || Ce.x >= vo)
          return !1;
        const De = Ce.sub(de), Ke = De.perp(), Ve = Ie.sub(de);
        return (De.x * Ve.x + De.y * Ve.y) / Math.sqrt((De.x * De.x + De.y * De.y) * (Ve.x * Ve.x + Ve.y * Ve.y)) > -0.866 && Ke.x * Ve.x + Ke.y * Ve.y < 0;
      }
      function ms(Ie, de, Ce) {
        const De = de ? 2 | Ie : -3 & Ie;
        return Ce ? 1 | De : -2 & De;
      }
      function Sg() {
        const Ie = Math.PI / 32, de = Math.tan(Ie), Ce = zs;
        return Ce * Math.sqrt(1 + 2 * de * de) - Ce;
      }
      function u1(Ie, de, Ce) {
        const De = 1 << Ce.z, Ke = bs(Ce.x / De), Ve = bs((Ce.x + 1) / De), er = Fs(Ce.y / De), fr = Fs((Ce.y + 1) / De);
        return function(wr, kr, cr, Mr, Er = 0, xr) {
          const Sr = [];
          if (!wr.length || !cr || !Mr)
            return Sr;
          const Br = (gi, Si) => {
            for (const Di of gi)
              Sr.push({ polygon: Di, bounds: Si });
          }, Fr = Math.ceil(Math.log2(cr)), jr = Math.ceil(Math.log2(Mr)), Qr = Fr - jr, ti = [];
          for (let gi = 0; gi < Math.abs(Qr); gi++)
            ti.push(Qr > 0 ? 0 : 1);
          for (let gi = 0; gi < Math.min(Fr, jr); gi++)
            ti.push(0), ti.push(1);
          let Kr = wr;
          if (Kr = Bs(Kr, kr[0].y - Er, kr[1].y + Er, 1), Kr = Bs(Kr, kr[0].x - Er, kr[1].x + Er, 0), !Kr.length)
            return Sr;
          const ni = [];
          for (ti.length ? ni.push({ polygons: Kr, bounds: kr, depth: 0 }) : Br(Kr, kr); ni.length; ) {
            const gi = ni.pop(), Si = gi.depth, Di = ti[Si], Ri = gi.bounds[0], Bi = gi.bounds[1], Ji = Di === 0 ? Ri.x : Ri.y, Fi = Di === 0 ? Bi.x : Bi.y, tn = xr ? xr(Di, Ji, Fi) : 0.5 * (Ji + Fi), cn = Bs(gi.polygons, Ji - Er, tn + Er, Di), ln = Bs(gi.polygons, tn - Er, Fi + Er, Di);
            if (cn.length) {
              const mn = [Ri, new qi(Di === 0 ? tn : Bi.x, Di === 1 ? tn : Bi.y)];
              ti.length > Si + 1 ? ni.push({ polygons: cn, bounds: mn, depth: Si + 1 }) : Br(cn, mn);
            }
            if (ln.length) {
              const mn = [new qi(Di === 0 ? tn : Ri.x, Di === 1 ? tn : Ri.y), Bi];
              ti.length > Si + 1 ? ni.push({ polygons: ln, bounds: mn, depth: Si + 1 }) : Br(ln, mn);
            }
          }
          return Sr;
        }(Ie, de, Math.ceil((Ve - Ke) / 11.25), Math.ceil((er - fr) / 11.25), 1, (wr, kr, cr) => {
          if (wr === 0)
            return 0.5 * (kr + cr);
          {
            const Mr = Fs((Ce.y + kr / vo) / De);
            return (gu(0.5 * (Fs((Ce.y + cr / vo) / De) + Mr)) * De - Ce.y) * vo;
          }
        });
      }
      function p0(Ie, de, Ce, De, Ke, Ve) {
        const er = Math.pow(2, De.z - Ke.z);
        for (let fr = 0; fr < Ce; fr++) {
          let wr = Ie.int16[2 * (fr + de) + 0], kr = Ie.int16[2 * (fr + de) + 1];
          wr = (wr + Ke.x * vo) * er - De.x * vo, kr = (kr + Ke.y * vo) * er - De.y * vo, Ve.push(new qi(wr, kr));
        }
      }
      let Eg, Cg;
      function gm(Ie, de) {
        return Ie.x * de.x + Ie.y * de.y;
      }
      function Tg(Ie, de) {
        if (Ie.length === 1) {
          let Ce = 0;
          const De = de[Ce++];
          let Ke;
          for (; !Ke || De.equals(Ke); )
            if (Ke = de[Ce++], !Ke)
              return 1 / 0;
          for (; Ce < de.length; Ce++) {
            const Ve = de[Ce], er = Ie[0], fr = Ke.sub(De), wr = Ve.sub(De), kr = er.sub(De), cr = gm(fr, fr), Mr = gm(fr, wr), Er = gm(wr, wr), xr = gm(kr, fr), Sr = gm(kr, wr), Br = cr * Er - Mr * Mr, Fr = (Er * xr - Mr * Sr) / Br, jr = (cr * Sr - Mr * xr) / Br, Qr = De.z * (1 - Fr - jr) + Ke.z * Fr + Ve.z * jr;
            if (isFinite(Qr))
              return Qr;
          }
          return 1 / 0;
        }
        {
          let Ce = 1 / 0;
          for (const De of de)
            Ce = Math.min(Ce, De.z);
          return Ce;
        }
      }
      function Ag(Ie, de, Ce, De, Ke, Ve, er, fr) {
        const wr = er * Ke.getElevationAt(Ie, de, !0, !0), kr = Ve[0] !== 0, cr = kr ? Ve[1] === 0 ? er * (Ve[0] / 7 - 450) : er * function(Mr, Er, xr) {
          const Sr = Math.floor(Er[0] / 8), Br = Math.floor(Er[1] / 8), Fr = 10 * (Er[0] - 8 * Sr), jr = 10 * (Er[1] - 8 * Br), Qr = Mr.getElevationAt(Sr, Br, !0, !0), ti = Mr.getMeterToDEM(xr), Kr = Math.floor(0.5 * (Fr * ti - 1)), ni = Math.floor(0.5 * (jr * ti - 1)), gi = Mr.tileCoordToPixel(Sr, Br), Si = 2 * Kr + 1, Di = 2 * ni + 1, Ri = function(ln, mn, wn, Cn, gn) {
            return [ln.getElevationAtPixel(mn, wn, !0), ln.getElevationAtPixel(mn + gn, wn, !0), ln.getElevationAtPixel(mn, wn + gn, !0), ln.getElevationAtPixel(mn + Cn, wn + gn, !0)];
          }(Mr, gi.x - Kr, gi.y - ni, Si, Di), Bi = Math.abs(Ri[0] - Ri[1]), Ji = Math.abs(Ri[2] - Ri[3]), Fi = Math.abs(Ri[0] - Ri[2]) + Math.abs(Ri[1] - Ri[3]), tn = Math.min(0.25, 0.5 * ti * (Bi + Ji) / Si), cn = Math.min(0.25, 0.5 * ti * Fi / Di);
          return Qr + Math.max(tn * Fr, cn * jr);
        }(Ke, Ve, fr) : wr;
        return { base: wr + (Ce === 0 ? -1 : Ce), top: kr ? Math.max(cr + De, wr + Ce + 2) : wr + De };
      }
      Ao(mm, "FillExtrusionBucket", { omit: ["layers", "features"] }), Ao(mf, "PartData"), Ao(xc, "FootprintSegment"), Ao(bg, "BorderCentroidData"), Ao(wg, "GroundEffect");
      const Xv = La([{ name: "a_pos_normal", components: 2, type: "Int16" }, { name: "a_data", components: 4, type: "Uint8" }, { name: "a_linesofar", components: 1, type: "Float32" }], 4), Kv = La([{ name: "a_z_offset_width", components: 2, type: "Float32" }], 4), { members: Yv } = Xv, Jv = La([{ name: "a_packed", components: 4, type: "Float32" }]), { members: Qv } = Jv, e_ = La([{ name: "a_pattern_data", components: 3, type: "Float32" }]), { members: t_ } = e_;
      class kg {
        constructor(de, Ce) {
          this.width = de, this.height = Ce, this.nextRow = 0, this.image = new hd({ width: de, height: Ce }), this.positions = {}, this.uploaded = !1;
        }
        getDash(de, Ce) {
          const De = this.getKey(de, Ce);
          return this.positions[De];
        }
        trim() {
          const de = this.width, Ce = this.height = ri(this.nextRow);
          this.image.resize({ width: de, height: Ce });
        }
        getKey(de, Ce) {
          return de.join(",") + Ce;
        }
        getDashRanges(de, Ce, De) {
          const Ke = [];
          let Ve = de.length % 2 == 1 ? -de[de.length - 1] * De : 0, er = de[0] * De, fr = !0;
          Ke.push({ left: Ve, right: er, isDash: fr, zeroLength: de[0] === 0 });
          let wr = de[0];
          for (let kr = 1; kr < de.length; kr++) {
            fr = !fr;
            const cr = de[kr];
            Ve = wr * De, wr += cr, er = wr * De, Ke.push({ left: Ve, right: er, isDash: fr, zeroLength: cr === 0 });
          }
          return Ke;
        }
        addRoundDash(de, Ce, De) {
          const Ke = Ce / 2;
          for (let Ve = -De; Ve <= De; Ve++) {
            const er = this.width * (this.nextRow + De + Ve);
            let fr = 0, wr = de[fr];
            for (let kr = 0; kr < this.width; kr++) {
              kr / wr.right > 1 && (wr = de[++fr]);
              const cr = Math.abs(kr - wr.left), Mr = Math.abs(kr - wr.right), Er = Math.min(cr, Mr);
              let xr;
              const Sr = Ve / De * (Ke + 1);
              if (wr.isDash) {
                const Br = Ke - Math.abs(Sr);
                xr = Math.sqrt(Er * Er + Br * Br);
              } else
                xr = Ke - Math.sqrt(Er * Er + Sr * Sr);
              this.image.data[er + kr] = Math.max(0, Math.min(255, xr + 128));
            }
          }
        }
        addRegularDash(de, Ce) {
          for (let wr = de.length - 1; wr >= 0; --wr) {
            const kr = de[wr], cr = de[wr + 1];
            kr.zeroLength ? de.splice(wr, 1) : cr && cr.isDash === kr.isDash && (cr.left = kr.left, de.splice(wr, 1));
          }
          const De = de[0], Ke = de[de.length - 1];
          De.isDash === Ke.isDash && (De.left = Ke.left - this.width, Ke.right = De.right + this.width);
          const Ve = this.width * this.nextRow;
          let er = 0, fr = de[er];
          for (let wr = 0; wr < this.width; wr++) {
            wr / fr.right > 1 && (fr = de[++er]);
            const kr = Math.abs(wr - fr.left), cr = Math.abs(wr - fr.right), Mr = Math.min(kr, cr);
            this.image.data[Ve + wr] = Math.max(0, Math.min(255, (fr.isDash ? Mr : -Mr) + Ce + 128));
          }
        }
        addDash(de, Ce) {
          const De = this.getKey(de, Ce);
          if (this.positions[De])
            return this.positions[De];
          const Ke = Ce === "round", Ve = Ke ? 7 : 0, er = 2 * Ve + 1;
          if (this.nextRow + er > this.height)
            return Mn("LineAtlas out of space"), null;
          de.length === 0 && de.push(1);
          let fr = 0;
          for (let cr = 0; cr < de.length; cr++)
            de[cr] < 0 && (Mn("Negative value is found in line dasharray, replacing values with 0"), de[cr] = 0), fr += de[cr];
          if (fr !== 0) {
            const cr = this.width / fr, Mr = this.getDashRanges(de, this.width, cr);
            Ke ? this.addRoundDash(Mr, cr, Ve) : this.addRegularDash(Mr, Ce === "square" ? 0.5 * cr : 0);
          }
          const wr = this.nextRow + Ve;
          this.nextRow += er;
          const kr = { tl: [wr, Ve], br: [fr, 0] };
          return this.positions[De] = kr, kr;
        }
      }
      Ao(kg, "LineAtlas");
      const h1 = $a.VectorTileFeature.types, r_ = Math.cos(Math.PI / 180 * 37.5), d1 = Math.cos(Math.PI / 180 * 5);
      class f1 {
        constructor(de) {
          this.evaluationGlobals = { zoom: 0, lineProgress: void 0 }, this.zoom = de.zoom, this.evaluationGlobals.zoom = this.zoom, this.overscaling = de.overscaling, this.layers = de.layers, this.layerIds = this.layers.map((Ce) => Ce.fqid), this.index = de.index, this.projection = de.projection, this.hasPattern = !1, this.hasZOffset = !1, this.hasCrossSlope = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((Ce) => {
            this.gradients[Ce.id] = {};
          }), this.layoutVertexArray = new Xd(), this.layoutVertexArray2 = new cu(), this.patternVertexArray = new Xc(), this.indexArray = new tl(), this.programConfigurations = new du(de.layers, { zoom: de.zoom, lut: de.lut }), this.segments = new fs(), this.maxLineLength = 0, this.zOffsetVertexArray = new Lc(), this.stateDependentLayerIds = this.layers.filter((Ce) => Ce.isStateDependent()).map((Ce) => Ce.id), this.tessellationStep = de.tessellationStep ? de.tessellationStep : vo / 64;
        }
        updateFootprints(de, Ce) {
        }
        populate(de, Ce, De, Ke) {
          this.hasPattern = l0("line", this.layers, Ce);
          const Ve = this.layers[0].layout.get("line-sort-key");
          this.tileToMeter = He(De), this.hasZOffset = !this.layers[0].isDraped();
          const er = this.layers[0].layout.get("line-elevation-reference");
          this.hasZOffset && er === "none" && Mn(`line-elevation-reference: ground is used for the layer ${this.layerIds[0]} because non-zero line-z-offset value was found.`);
          const fr = this.layers[0].layout.get("line-cross-slope");
          this.hasCrossSlope = this.hasZOffset && fr !== void 0;
          const wr = [];
          for (const { feature: Er, id: xr, index: Sr, sourceLayerIndex: Br } of de) {
            const Fr = this.layers[0]._featureFilter.needGeometry, jr = Jr(Er, Fr);
            if (!this.layers[0]._featureFilter.filter(new wa(this.zoom), jr, De))
              continue;
            const Qr = Ve ? Ve.evaluate(jr, {}, De) : void 0, ti = { id: xr, properties: Er.properties, type: Er.type, sourceLayerIndex: Br, index: Sr, geometry: Fr ? jr.geometry : qr(Er, De, Ke), patterns: {}, sortKey: Qr };
            wr.push(ti);
          }
          Ve && wr.sort((Er, xr) => Er.sortKey - xr.sortKey);
          const { lineAtlas: kr, featureIndex: cr } = Ce, Mr = this.addConstantDashes(kr);
          for (const Er of wr) {
            const { geometry: xr, index: Sr, sourceLayerIndex: Br } = Er;
            if (Mr && this.addFeatureDashes(Er, kr), this.hasPattern) {
              const Fr = c0("line", this.layers, Er, this.zoom, Ce);
              this.patternFeatures.push(Fr);
            } else
              this.addFeature(Er, xr, Sr, De, kr.positions, Ce.availableImages, Ce.brightness);
            cr.insert(de[Sr].feature, xr, Sr, Br, this.index);
          }
        }
        addConstantDashes(de) {
          let Ce = !1;
          for (const De of this.layers) {
            const Ke = De.paint.get("line-dasharray").value, Ve = De.layout.get("line-cap").value;
            if (Ke.kind !== "constant" || Ve.kind !== "constant")
              Ce = !0;
            else {
              const er = Ve.value, fr = Ke.value;
              if (!fr)
                continue;
              de.addDash(fr, er);
            }
          }
          return Ce;
        }
        addFeatureDashes(de, Ce) {
          const De = this.zoom;
          for (const Ke of this.layers) {
            const Ve = Ke.paint.get("line-dasharray").value, er = Ke.layout.get("line-cap").value;
            if (Ve.kind === "constant" && er.kind === "constant")
              continue;
            let fr, wr;
            if (Ve.kind === "constant") {
              if (fr = Ve.value, !fr)
                continue;
            } else
              fr = Ve.evaluate({ zoom: De }, de);
            wr = er.kind === "constant" ? er.value : er.evaluate({ zoom: De }, de), Ce.addDash(fr, wr), de.patterns[Ke.id] = Ce.getKey(fr, wr);
          }
        }
        update(de, Ce, De, Ke, Ve, er, fr) {
          this.programConfigurations.updatePaintArrays(de, Ce, Ve, De, Ke, er, fr);
        }
        addFeatures(de, Ce, De, Ke, Ve, er) {
          for (const fr of this.patternFeatures)
            this.addFeature(fr, fr.geometry, fr.index, Ce, De, Ke, er);
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(de) {
          this.uploaded || (this.layoutVertexArray2.length !== 0 && (this.layoutVertexBuffer2 = de.createVertexBuffer(this.layoutVertexArray2, Qv)), this.patternVertexArray.length !== 0 && (this.patternVertexBuffer = de.createVertexBuffer(this.patternVertexArray, t_)), !this.zOffsetVertexBuffer && this.zOffsetVertexArray.length > 0 && (this.zOffsetVertexBuffer = de.createVertexBuffer(this.zOffsetVertexArray, Kv.members, !0)), this.layoutVertexBuffer = de.createVertexBuffer(this.layoutVertexArray, Yv), this.indexBuffer = de.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(de), this.uploaded = !0;
        }
        destroy() {
          this.layoutVertexBuffer && (this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }
        lineFeatureClips(de) {
          if (de.properties && de.properties.hasOwnProperty("mapbox_clip_start") && de.properties.hasOwnProperty("mapbox_clip_end"))
            return { start: +de.properties.mapbox_clip_start, end: +de.properties.mapbox_clip_end };
        }
        addFeature(de, Ce, De, Ke, Ve, er, fr) {
          const wr = this.layers[0].layout, kr = wr.get("line-join").evaluate(de, {}), cr = wr.get("line-cap").evaluate(de, {}), Mr = wr.get("line-miter-limit"), Er = wr.get("line-round-limit");
          this.lineClips = this.lineFeatureClips(de), this.lineFeature = de, this.zOffsetValue = wr.get("line-z-offset").value;
          const xr = this.layers[0].paint.get("line-width").value;
          xr.kind !== "constant" && xr.isLineProgressConstant === !1 && (this.variableWidthValue = xr);
          for (const Sr of Ce)
            this.addLine(Sr, de, Ke, kr, cr, Mr, Er);
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, de, De, Ve, er, Ke, fr);
        }
        addLine(de, Ce, De, Ke, Ve, er, fr) {
          this.distance = 0, this.prevDistance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.totalFeatureLength = 0, this.lineSoFar = 0, this.currentVertex = void 0;
          const wr = Ke === "none";
          if (this.patternJoinNone = this.hasPattern && wr, this.segmentStart = 0, this.segmentStartf32 = 0, this.segmentPoints = [], this.lineClips) {
            this.lineClipsArray.push(this.lineClips);
            for (let ti = 0; ti < de.length - 1; ti++)
              this.totalDistance += de[ti].dist(de[ti + 1]);
            this.totalFeatureLength = this.totalDistance / (this.lineClips.end - this.lineClips.start), this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
          }
          const kr = h1[Ce.type] === "Polygon";
          let cr = de.length;
          for (; cr >= 2 && de[cr - 1].equals(de[cr - 2]); )
            cr--;
          let Mr = 0;
          for (; Mr < cr - 1 && de[Mr].equals(de[Mr + 1]); )
            Mr++;
          if (cr < (kr ? 3 : 2))
            return;
          Ke === "bevel" && (er = 1.05);
          const Er = this.segments.prepareSegment(10 * cr, this.layoutVertexArray, this.indexArray);
          let xr, Sr, Br, Fr, jr, Qr;
          this.e1 = this.e2 = -1, kr && (xr = de[cr - 2], jr = de[Mr].sub(xr)._unit()._perp());
          for (let ti = Mr; ti < cr; ti++) {
            if (Br = ti === cr - 1 ? kr ? de[Mr + 1] : void 0 : de[ti + 1], Br && de[ti].equals(Br))
              continue;
            jr && (Fr = jr), xr && (Sr = xr), xr = de[ti], Qr = this.evaluateLineProgressFeatures(Sr ? Sr.dist(xr) : 0), jr = Br ? Br.sub(xr)._unit()._perp() : Fr, Fr = Fr || jr;
            const Kr = Sr && Br;
            let ni = Kr ? Ke : kr || wr ? "butt" : Ve;
            const gi = Fr.x * jr.x + Fr.y * jr.y;
            if (wr) {
              const cn = function(ln) {
                if (ln.patternJoinNone) {
                  const mn = ln.segmentPoints.length / 2, wn = ln.lineSoFar - ln.segmentStart;
                  for (let Cn = 0; Cn < mn; ++Cn) {
                    const gn = ln.segmentPoints[2 * Cn + 1], Nn = Math.round(ln.segmentPoints[2 * Cn]) + 0.5 + 0.25 * gn;
                    ln.patternVertexArray.emplaceBack(Nn, wn, ln.segmentStart), ln.patternVertexArray.emplaceBack(Nn, wn, ln.segmentStart);
                  }
                  ln.segmentPoints.length = 0;
                }
                ln.e1 = ln.e2 = -1;
              };
              if (Kr && gi < d1) {
                this.updateDistance(Sr, xr), this.addCurrentVertex(xr, Fr, 1, 1, Er, Qr), cn(this), this.addCurrentVertex(xr, jr, -1, -1, Er, Qr);
                continue;
              }
              if (Sr) {
                if (!Br) {
                  this.updateDistance(Sr, xr), this.addCurrentVertex(xr, Fr, 1, 1, Er, Qr), cn(this);
                  continue;
                }
                ni = "miter";
              }
            }
            let Si = Fr.add(jr);
            Si.x === 0 && Si.y === 0 || Si._unit();
            const Di = Si.x * jr.x + Si.y * jr.y, Ri = Di !== 0 ? 1 / Di : 1 / 0, Bi = 2 * Math.sqrt(2 - 2 * Di), Ji = Di < r_ && Sr && Br, Fi = Fr.x * jr.y - Fr.y * jr.x > 0, tn = this.overscaling <= 16 ? 15 * vo / (512 * this.overscaling) : 0;
            if (Kr && ni === "round") {
              if (Ri < fr)
                ni = "miter";
              else if (Ri <= 2) {
                const cn = p1(xr, -10, vo + 10);
                ni = this.hasZOffset && (cn || this.hasCrossSlope) ? "miter" : "fakeround";
              }
            }
            if (ni === "miter" && Ri > er && (ni = "bevel"), ni === "bevel" && (Ri > 2 && (ni = "flipbevel"), Ri < er && (ni = "miter")), Sr && !(ni === "miter" && Ji) && this.updateDistance(Sr, xr), ni === "miter")
              if (Ji) {
                const cn = xr.dist(Sr);
                if (cn > 2 * tn) {
                  const mn = xr.sub(xr.sub(Sr)._mult(tn / cn)._round());
                  this.updateDistance(Sr, mn), this.addCurrentVertex(mn, Fr, 0, 0, Er, Qr), Sr = mn;
                }
                this.updateDistance(Sr, xr), Si._mult(Ri), this.addCurrentVertex(xr, Si, 0, 0, Er, Qr);
                const ln = xr.dist(Br);
                if (ln > 2 * tn) {
                  const mn = xr.add(Br.sub(xr)._mult(tn / ln)._round());
                  this.updateDistance(xr, mn), this.addCurrentVertex(mn, jr, 0, 0, Er, Qr), xr = mn;
                }
              } else
                Si._mult(Ri), this.addCurrentVertex(xr, Si, 0, 0, Er, Qr);
            else if (ni === "flipbevel") {
              if (Ri > 100)
                Si = jr.mult(-1);
              else {
                const cn = Ri * Fr.add(jr).mag() / Fr.sub(jr).mag();
                Si._perp()._mult(cn * (Fi ? -1 : 1));
              }
              this.addCurrentVertex(xr, Si, 0, 0, Er, Qr), this.addCurrentVertex(xr, Si.mult(-1), 0, 0, Er, Qr);
            } else if (ni === "bevel" || ni === "fakeround") {
              Qr != null && Sr && this.addCurrentVertex(xr, Fr, -1, -1, Er, Qr);
              const cn = xr.dist(Sr) <= 2 * tn && ni !== "bevel", ln = Si.mult(Fi ? 1 : -1);
              ln._mult(Ri);
              const mn = jr.mult(Fi ? -1 : 1), wn = Fr.mult(Fi ? -1 : 1), Cn = this.evaluateLineProgressFeatures(this.distance);
              if (Qr == null && (this.addHalfVertex(xr, ln.x, ln.y, !1, !Fi, 0, Er, Cn), cn || this.addHalfVertex(xr, ln.x + 2 * wn.x, ln.y + 2 * wn.y, !1, Fi, 0, Er, Cn)), ni === "fakeround") {
                const gn = Math.round(180 * Bi / Math.PI / 20);
                this.addHalfVertex(xr, wn.x, wn.y, !1, Fi, 0, Er, Cn);
                for (let Nn = 0; Nn < gn; Nn++) {
                  let oo = Nn / gn;
                  if (oo !== 0.5) {
                    const fo = oo - 0.5;
                    oo += oo * fo * (oo - 1) * ((1.0904 + gi * (gi * (3.55645 - 1.43519 * gi) - 3.2452)) * fo * fo + (0.848013 + gi * (0.215638 * gi - 1.06021)));
                  }
                  const Un = mn.sub(wn)._mult(oo)._add(wn)._unit();
                  this.addHalfVertex(xr, Un.x, Un.y, !1, Fi, 0, Er, Cn);
                }
                this.addHalfVertex(xr, mn.x, mn.y, !1, Fi, 0, Er, Cn);
              }
              cn || Qr != null || this.addHalfVertex(xr, ln.x + 2 * mn.x, ln.y + 2 * mn.y, !1, Fi, 0, Er, Cn), Qr != null && Br && this.addCurrentVertex(xr, jr, 1, 1, Er, Qr);
            } else
              ni === "butt" ? this.addCurrentVertex(xr, Si, 0, 0, Er, Qr) : ni === "square" ? (Sr || this.addCurrentVertex(xr, Si, -1, -1, Er, Qr), this.addCurrentVertex(xr, Si, 0, 0, Er, Qr), Sr && this.addCurrentVertex(xr, Si, 1, 1, Er, Qr)) : ni === "round" && (Sr && (this.addCurrentVertex(xr, Fr, 0, 0, Er, Qr), this.addCurrentVertex(xr, Fr, 1, 1, Er, Qr, !0)), Br && (this.addCurrentVertex(xr, jr, -1, -1, Er, Qr, !0), this.addCurrentVertex(xr, jr, 0, 0, Er, Qr)));
          }
        }
        addVerticesTo(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr) {
          const Mr = (Ce.w - de.w) / this.tessellationStep | 0;
          let Er = 0;
          const xr = this.scaledDistance;
          if (Mr > 1) {
            this.lineSoFar = de.w;
            const Br = (Ce.x - de.x) / Mr, Fr = (Ce.y - de.y) / Mr, jr = (Ce.z - de.z) / Mr, Qr = (Ce.w - de.w) / Mr;
            for (let ti = 1; ti < Mr; ++ti) {
              de.x += Br, de.y += Fr, de.z += jr, this.lineSoFar += Qr, Er += Qr;
              const Kr = this.evaluateLineProgressFeatures(this.prevDistance + Er);
              this.scaledDistance = (this.prevDistance + Er) / this.totalDistance, this.addHalfVertex(de, De, Ke, cr, !1, fr, kr, Kr), this.addHalfVertex(de, Ve, er, cr, !0, -wr, kr, Kr);
            }
          }
          this.lineSoFar = Ce.w, this.scaledDistance = xr;
          const Sr = this.evaluateLineProgressFeatures(this.distance);
          this.addHalfVertex(Ce, De, Ke, cr, !1, fr, kr, Sr), this.addHalfVertex(Ce, Ve, er, cr, !0, -wr, kr, Sr);
        }
        evaluateLineProgressFeatures(de) {
          if (!this.variableWidthValue && !this.hasZOffset)
            return null;
          this.evaluationGlobals.lineProgress = 0, this.lineClips ? this.evaluationGlobals.lineProgress = Math.min(1, (this.totalFeatureLength * this.lineClips.start + de) / this.totalFeatureLength) : Mn(`line-progress evaluation for ${this.layerIds[0]} requires enabling 'lineMetrics' for the source.`);
          let Ce = 0;
          return this.variableWidthValue && this.variableWidthValue.kind !== "constant" && (Ce = this.variableWidthValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0), this.hasZOffset ? this.zOffsetValue.kind === "constant" ? { zOffset: this.zOffsetValue.value, variableWidth: Ce } : { zOffset: this.zOffsetValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0, variableWidth: Ce } : { zOffset: 0, variableWidth: Ce };
        }
        addCurrentVertex(de, Ce, De, Ke, Ve, er, fr = !1) {
          const wr = Ce.x + Ce.y * De, kr = Ce.y - Ce.x * De, cr = Ce.y * Ke - Ce.x, Mr = -Ce.y - Ce.x * Ke;
          if (er != null) {
            const Er = this.hasZOffset, xr = -10, Sr = vo + 10, Br = er.zOffset, Fr = new ac(de.x, de.y, Br, this.lineSoFar), jr = !!Er && p1(de, xr, Sr), Qr = this.lineSoFar, ti = this.distance;
            if (this.currentVertex)
              if (jr) {
                const Kr = this.currentVertexIsOutside, ni = this.currentVertex, gi = new ac(de.x, de.y, Br, this.lineSoFar);
                if (wh(ni, gi, xr, Sr), !p1(gi, xr, Sr)) {
                  if (Kr) {
                    this.e1 = this.e2 = -1, this.distance -= ni.dist(Fr), this.lineSoFar = ni.w;
                    const Si = this.evaluateLineProgressFeatures(ni.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                    this.addHalfVertex(ni, wr, kr, fr, !1, De, Ve, Si), this.addHalfVertex(ni, cr, Mr, fr, !0, -Ke, Ve, Si), this.prevDistance = this.distance;
                  }
                  this.distance = this.prevDistance + ni.dist(gi), this.scaledDistance = this.distance / this.totalDistance, this.addVerticesTo(ni, gi, wr, kr, cr, Mr, De, Ke, Ve, fr), this.distance = ti, this.scaledDistance = this.distance / this.totalDistance;
                }
              } else {
                const Kr = this.currentVertex;
                if (this.currentVertexIsOutside) {
                  wh(Kr, Fr, xr, Sr), this.e1 = this.e2 = -1, this.distance -= Kr.dist(Fr), this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = Kr.w;
                  const ni = this.evaluateLineProgressFeatures(Kr.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                  this.addHalfVertex(Kr, wr, kr, fr, !1, De, Ve, ni), this.addHalfVertex(Kr, cr, Mr, fr, !0, -Ke, Ve, ni), this.prevDistance = this.distance, this.distance = ti, this.scaledDistance = this.distance / this.totalDistance;
                }
                this.addVerticesTo(Kr, Fr, wr, kr, cr, Mr, De, Ke, Ve, fr);
              }
            else
              jr || (this.addHalfVertex(de, wr, kr, fr, !1, De, Ve, er), this.addHalfVertex(de, cr, Mr, fr, !0, -Ke, Ve, er));
            this.currentVertex = Fr, this.currentVertexIsOutside = jr, this.lineSoFar = Qr;
          } else
            this.addHalfVertex(de, wr, kr, fr, !1, De, Ve, er), this.addHalfVertex(de, cr, Mr, fr, !0, -Ke, Ve, er);
        }
        addHalfVertex({ x: de, y: Ce }, De, Ke, Ve, er, fr, wr, kr) {
          this.patternJoinNone && (this.segmentPoints.length === 0 && (this.segmentStart = this.lineSoFar, this.segmentStartf32 = Math.fround(this.lineSoFar)), er || this.segmentPoints.push(this.lineSoFar - this.segmentStart, fr)), this.layoutVertexArray.emplaceBack((de << 1) + (Ve ? 1 : 0), (Ce << 1) + (er ? 1 : 0), Math.round(63 * De) + 128, Math.round(63 * Ke) + 128, 1 + (fr === 0 ? 0 : fr < 0 ? -1 : 1), 0, this.lineSoFar - this.segmentStartf32), this.lineClips && this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, this.lineClips.start, this.lineClips.end);
          const cr = wr.vertexLength++;
          this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, cr), wr.primitiveLength++), er ? this.e2 = cr : this.e1 = cr, kr != null && this.zOffsetVertexArray.emplaceBack(kr.zOffset, kr.variableWidth);
        }
        updateScaledDistance() {
          this.lineClips ? (this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = this.totalFeatureLength * this.lineClips.start + this.distance) : this.lineSoFar = this.distance;
        }
        updateDistance(de, Ce) {
          this.prevDistance = this.distance, this.distance += de.dist(Ce), this.updateScaledDistance();
        }
      }
      function p1(Ie, de, Ce) {
        return Ie.x < de || Ie.x > Ce || Ie.y < de || Ie.y > Ce;
      }
      let Lg, vl;
      function sc(Ie, de, Ce) {
        return de * (vo / (Ie.tileSize * Math.pow(2, Ce - Ie.tileID.overscaledZ)));
      }
      Ao(f1, "LineBucket", { omit: ["layers", "patternFeatures", "currentVertex", "currentVertexIsOutside"] });
      const Ig = (Ie, de, Ce) => (1 - Ce) * Ie + Ce * de;
      function Bg(Ie, de) {
        return 1 / sc(Ie, 1, de.tileZoom);
      }
      function $g(Ie, de, Ce, De) {
        return Ie.translatePosMatrix(De || de.tileID.projMatrix, de, Ce.paint.get("line-translate"), Ce.paint.get("line-translate-anchor"));
      }
      const m1 = (Ie) => {
        const de = [];
        Rg(Ie) && de.push("RENDER_LINE_DASH"), Ie.paint.get("line-gradient") && de.push("RENDER_LINE_GRADIENT");
        const Ce = Ie.paint.get("line-trim-offset");
        Ce[0] === 0 && Ce[1] === 0 || de.push("RENDER_LINE_TRIM_OFFSET"), Ie.paint.get("line-border-width").constantOr(1) !== 0 && de.push("RENDER_LINE_BORDER");
        const De = Ie.layout.get("line-join").constantOr("miter") === "none", Ke = !!Ie.paint.get("line-pattern").constantOr(1);
        return De && Ke && de.push("LINE_JOIN_NONE"), de;
      };
      function Rg(Ie) {
        const de = Ie.paint.get("line-dasharray").value;
        return de.value || de.kind !== "constant";
      }
      let g1;
      const Pg = () => g1 || (g1 = { layout: Lg || (Lg = new ys({ "line-cap": new Mo(Bn.layout_line["line-cap"]), "line-join": new Mo(Bn.layout_line["line-join"]), "line-miter-limit": new lo(Bn.layout_line["line-miter-limit"]), "line-round-limit": new lo(Bn.layout_line["line-round-limit"]), "line-sort-key": new Mo(Bn.layout_line["line-sort-key"]), "line-z-offset": new Mo(Bn.layout_line["line-z-offset"]), "line-elevation-reference": new lo(Bn.layout_line["line-elevation-reference"]), "line-cross-slope": new lo(Bn.layout_line["line-cross-slope"]), visibility: new lo(Bn.layout_line.visibility), "line-width-unit": new lo(Bn.layout_line["line-width-unit"]) })), paint: vl || (vl = new ys({ "line-opacity": new Mo(Bn.paint_line["line-opacity"]), "line-color": new Mo(Bn.paint_line["line-color"]), "line-translate": new lo(Bn.paint_line["line-translate"]), "line-translate-anchor": new lo(Bn.paint_line["line-translate-anchor"]), "line-width": new Mo(Bn.paint_line["line-width"]), "line-gap-width": new Mo(Bn.paint_line["line-gap-width"]), "line-offset": new Mo(Bn.paint_line["line-offset"]), "line-blur": new Mo(Bn.paint_line["line-blur"]), "line-dasharray": new Mo(Bn.paint_line["line-dasharray"]), "line-pattern": new Mo(Bn.paint_line["line-pattern"]), "line-gradient": new Jh(Bn.paint_line["line-gradient"]), "line-trim-offset": new lo(Bn.paint_line["line-trim-offset"]), "line-trim-fade-range": new lo(Bn.paint_line["line-trim-fade-range"]), "line-trim-color": new lo(Bn.paint_line["line-trim-color"]), "line-emissive-strength": new lo(Bn.paint_line["line-emissive-strength"]), "line-border-width": new Mo(Bn.paint_line["line-border-width"]), "line-border-color": new Mo(Bn.paint_line["line-border-color"]), "line-occlusion-opacity": new lo(Bn.paint_line["line-occlusion-opacity"]), "line-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }), "line-gradient-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }), "line-trim-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }), "line-border-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, g1);
      class Dg extends Mo {
        possiblyEvaluate(de, Ce) {
          return Ce = new wa(Math.floor(Ce.zoom), { now: Ce.now, fadeDuration: Ce.fadeDuration, transition: Ce.transition }), super.possiblyEvaluate(de, Ce);
        }
        evaluate(de, Ce, De, Ke) {
          return Ce = Yn({}, Ce, { zoom: Math.floor(Ce.zoom) }), super.evaluate(de, Ce, De, Ke);
        }
      }
      let vm;
      function Og(Ie, de) {
        return de > 0 ? de + 2 * Ie : Ie;
      }
      const i_ = La([{ name: "a_pos_offset", components: 4, type: "Int16" }, { name: "a_tex_size", components: 4, type: "Uint16" }, { name: "a_pixeloffset", components: 4, type: "Int16" }], 4), zg = La([{ name: "a_globe_anchor", components: 3, type: "Int16" }, { name: "a_globe_normal", components: 3, type: "Float32" }], 4), Fg = La([{ name: "a_projected_pos", components: 4, type: "Float32" }], 4);
      La([{ name: "a_fade_opacity", components: 1, type: "Uint32" }], 4);
      const n_ = La([{ name: "a_auto_z_offset", components: 1, type: "Float32" }], 4), o_ = La([{ name: "a_texb", components: 2, type: "Uint16" }]), a_ = La([{ name: "a_placed", components: 2, type: "Uint8" }, { name: "a_shift", components: 2, type: "Float32" }, { name: "a_elevation_from_sea", components: 2, type: "Float32" }]), s_ = La([{ name: "a_size_scale", components: 1, type: "Float32" }, { name: "a_padding", components: 2, type: "Float32" }, { name: "a_auto_z_offset", components: 1, type: "Float32" }]);
      La([{ type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Int16", name: "tileAnchorX" }, { type: "Int16", name: "tileAnchorY" }, { type: "Float32", name: "x1" }, { type: "Float32", name: "y1" }, { type: "Float32", name: "x2" }, { type: "Float32", name: "y2" }, { type: "Int16", name: "padding" }, { type: "Uint32", name: "featureIndex" }, { type: "Uint16", name: "sourceLayerIndex" }, { type: "Uint16", name: "bucketIndex" }]);
      const gf = La([{ name: "a_pos", components: 3, type: "Int16" }, { name: "a_anchor_pos", components: 2, type: "Int16" }, { name: "a_extrude", components: 2, type: "Int16" }], 4), l_ = La([{ name: "a_pos_2f", components: 2, type: "Float32" }, { name: "a_radius", components: 1, type: "Float32" }, { name: "a_flags", components: 2, type: "Int16" }], 4);
      La([{ name: "triangle", components: 3, type: "Uint16" }]), La([{ type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Float32", name: "tileAnchorX" }, { type: "Float32", name: "tileAnchorY" }, { type: "Uint16", name: "glyphStartIndex" }, { type: "Uint16", name: "numGlyphs" }, { type: "Uint32", name: "vertexStartIndex" }, { type: "Uint32", name: "lineStartIndex" }, { type: "Uint32", name: "lineLength" }, { type: "Uint16", name: "segment" }, { type: "Uint16", name: "lowerSize" }, { type: "Uint16", name: "upperSize" }, { type: "Float32", name: "lineOffsetX" }, { type: "Float32", name: "lineOffsetY" }, { type: "Uint8", name: "writingMode" }, { type: "Uint8", name: "placedOrientation" }, { type: "Uint8", name: "hidden" }, { type: "Uint32", name: "crossTileID" }, { type: "Int16", name: "associatedIconIndex" }, { type: "Uint8", name: "flipState" }]), La([{ type: "Float32", name: "tileAnchorX" }, { type: "Float32", name: "tileAnchorY" }, { type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Int16", name: "rightJustifiedTextSymbolIndex" }, { type: "Int16", name: "centerJustifiedTextSymbolIndex" }, { type: "Int16", name: "leftJustifiedTextSymbolIndex" }, { type: "Int16", name: "verticalPlacedTextSymbolIndex" }, { type: "Int16", name: "placedIconSymbolIndex" }, { type: "Int16", name: "verticalPlacedIconSymbolIndex" }, { type: "Uint16", name: "key" }, { type: "Uint16", name: "textBoxStartIndex" }, { type: "Uint16", name: "textBoxEndIndex" }, { type: "Uint16", name: "verticalTextBoxStartIndex" }, { type: "Uint16", name: "verticalTextBoxEndIndex" }, { type: "Uint16", name: "iconBoxStartIndex" }, { type: "Uint16", name: "iconBoxEndIndex" }, { type: "Uint16", name: "verticalIconBoxStartIndex" }, { type: "Uint16", name: "verticalIconBoxEndIndex" }, { type: "Uint16", name: "featureIndex" }, { type: "Uint16", name: "numHorizontalGlyphVertices" }, { type: "Uint16", name: "numVerticalGlyphVertices" }, { type: "Uint16", name: "numIconVertices" }, { type: "Uint16", name: "numVerticalIconVertices" }, { type: "Uint16", name: "useRuntimeCollisionCircles" }, { type: "Uint32", name: "crossTileID" }, { type: "Float32", components: 2, name: "textOffset" }, { type: "Float32", name: "collisionCircleDiameter" }, { type: "Float32", name: "zOffset" }, { type: "Uint8", name: "hasIconTextFit" }]), La([{ type: "Float32", name: "offsetX" }]), La([{ type: "Int16", name: "x" }, { type: "Int16", name: "y" }]);
      var _l = 24;
      const _u = 128;
      function m0(Ie, de, Ce, De, Ke) {
        if (Ie.kind === "camera")
          return Ie.maxSize;
        if (Ie.kind === "composite") {
          const Ve = de.possiblyEvaluate(new wa(Ie.maxZoom), Ce).evaluate(Ke, {}, Ce), er = de.possiblyEvaluate(new wa(Ie.minZoom), Ce).evaluate(Ke, {}, Ce);
          return Math.max(Ve, er);
        }
        return de.possiblyEvaluate(new wa(De)).evaluate(Ke, {}, Ce);
      }
      function v1(Ie, de) {
        const { expression: Ce } = de;
        if (Ce.kind === "constant")
          return { kind: "constant", layoutSize: Ce.evaluate(new wa(Ie + 1)) };
        if (Ce.kind === "source")
          return { kind: "source" };
        {
          const { zoomStops: De, interpolationType: Ke } = Ce;
          let Ve = 0;
          for (; Ve < De.length && De[Ve] <= Ie; )
            Ve++;
          Ve = Math.max(0, Ve - 1);
          let er = Ve;
          for (; er < De.length && De[er] < Ie + 1; )
            er++;
          er = Math.min(De.length - 1, er);
          const fr = De[Ve], wr = De[er];
          return Ce.kind === "composite" ? { kind: "composite", minZoom: fr, maxZoom: wr, interpolationType: Ke } : { kind: "camera", minZoom: fr, maxZoom: wr, minSize: Ce.evaluate(new wa(fr)), maxSize: Ce.evaluate(new wa(wr)), interpolationType: Ke };
        }
      }
      function _m(Ie, { uSize: de, uSizeT: Ce }, { lowerSize: De, upperSize: Ke }) {
        return Ie.kind === "source" ? De / _u : Ie.kind === "composite" ? Ho(De / _u, Ke / _u, Ce) : de;
      }
      function vf(Ie, de, Ce = 1) {
        let De = 0, Ke = 0;
        if (Ie.kind === "constant")
          Ke = Ie.layoutSize * Ce;
        else if (Ie.kind !== "source") {
          const { interpolationType: Ve, minZoom: er, maxZoom: fr } = Ie, wr = Ve ? vn(Vl.interpolationFactor(Ve, de, er, fr), 0, 1) : 0;
          Ie.kind === "camera" ? Ke = Ho(Ie.minSize, Ie.maxSize, wr) * Ce : De = wr * Ce;
        }
        return { uSizeT: De, uSize: Ke };
      }
      var c_ = Object.freeze({ __proto__: null, SIZE_PACK_FACTOR: _u, evaluateSizeForFeature: _m, evaluateSizeForZoom: vf, getRasterizedIconSize: m0, getSizeData: v1 });
      function u_(Ie, de, Ce) {
        return Ie.sections.forEach((De) => {
          De.text = function(Ke, Ve, er) {
            const fr = Ve.layout.get("text-transform").evaluate(er, {});
            return fr === "uppercase" ? Ke = Ke.toLocaleUpperCase() : fr === "lowercase" && (Ke = Ke.toLocaleLowerCase()), Il.applyArabicShaping && (Ke = Il.applyArabicShaping(Ke)), Ke;
          }(De.text, de, Ce);
        }), Ie;
      }
      const ym = { "!": "\uFE15", "#": "\uFF03", $: "\uFF04", "%": "\uFF05", "&": "\uFF06", "(": "\uFE35", ")": "\uFE36", "*": "\uFF0A", "+": "\uFF0B", ",": "\uFE10", "-": "\uFE32", ".": "\u30FB", "/": "\uFF0F", ":": "\uFE13", ";": "\uFE14", "<": "\uFE3F", "=": "\uFF1D", ">": "\uFE40", "?": "\uFE16", "@": "\uFF20", "[": "\uFE47", "\\": "\uFF3C", "]": "\uFE48", "^": "\uFF3E", _: "\uFE33", "`": "\uFF40", "{": "\uFE37", "|": "\u2015", "}": "\uFE38", "~": "\uFF5E", "\xA2": "\uFFE0", "\xA3": "\uFFE1", "\xA5": "\uFFE5", "\xA6": "\uFFE4", "\xAC": "\uFFE2", "\xAF": "\uFFE3", "\u2013": "\uFE32", "\u2014": "\uFE31", "\u2018": "\uFE43", "\u2019": "\uFE44", "\u201C": "\uFE41", "\u201D": "\uFE42", "\u2026": "\uFE19", "\u2027": "\u30FB", "\u20A9": "\uFFE6", "\u3001": "\uFE11", "\u3002": "\uFE12", "\u3008": "\uFE3F", "\u3009": "\uFE40", "\u300A": "\uFE3D", "\u300B": "\uFE3E", "\u300C": "\uFE41", "\u300D": "\uFE42", "\u300E": "\uFE43", "\u300F": "\uFE44", "\u3010": "\uFE3B", "\u3011": "\uFE3C", "\u3014": "\uFE39", "\u3015": "\uFE3A", "\u3016": "\uFE17", "\u3017": "\uFE18", "\uFF01": "\uFE15", "\uFF08": "\uFE35", "\uFF09": "\uFE36", "\uFF0C": "\uFE10", "\uFF0D": "\uFE32", "\uFF0E": "\u30FB", "\uFF1A": "\uFE13", "\uFF1B": "\uFE14", "\uFF1C": "\uFE3F", "\uFF1E": "\uFE40", "\uFF1F": "\uFE16", "\uFF3B": "\uFE47", "\uFF3D": "\uFE48", "\uFF3F": "\uFE33", "\uFF5B": "\uFE37", "\uFF5C": "\u2015", "\uFF5D": "\uFE38", "\uFF5F": "\uFE35", "\uFF60": "\uFE36", "\uFF61": "\uFE12", "\uFF62": "\uFE41", "\uFF63": "\uFE42", "\u2190": "\u2191", "\u2192": "\u2193" };
      function h_(Ie) {
        return Ie === "\uFE36" || Ie === "\uFE48" || Ie === "\uFE38" || Ie === "\uFE44" || Ie === "\uFE42" || Ie === "\uFE3E" || Ie === "\uFE3C" || Ie === "\uFE3A" || Ie === "\uFE18" || Ie === "\uFE40" || Ie === "\uFE10" || Ie === "\uFE13" || Ie === "\uFE14" || Ie === "\uFF40" || Ie === "\uFFE3" || Ie === "\uFE11" || Ie === "\uFE12";
      }
      function d_(Ie) {
        return Ie === "\uFE35" || Ie === "\uFE47" || Ie === "\uFE37" || Ie === "\uFE43" || Ie === "\uFE41" || Ie === "\uFE3D" || Ie === "\uFE3B" || Ie === "\uFE39" || Ie === "\uFE17" || Ie === "\uFE3F";
      }
      var Ng, y1, Vg, b1 = {};
      /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
      function f_() {
        return Ng || (Ng = 1, b1.read = function(Ie, de, Ce, De, Ke) {
          var Ve, er, fr = 8 * Ke - De - 1, wr = (1 << fr) - 1, kr = wr >> 1, cr = -7, Mr = Ce ? Ke - 1 : 0, Er = Ce ? -1 : 1, xr = Ie[de + Mr];
          for (Mr += Er, Ve = xr & (1 << -cr) - 1, xr >>= -cr, cr += fr; cr > 0; Ve = 256 * Ve + Ie[de + Mr], Mr += Er, cr -= 8)
            ;
          for (er = Ve & (1 << -cr) - 1, Ve >>= -cr, cr += De; cr > 0; er = 256 * er + Ie[de + Mr], Mr += Er, cr -= 8)
            ;
          if (Ve === 0)
            Ve = 1 - kr;
          else {
            if (Ve === wr)
              return er ? NaN : 1 / 0 * (xr ? -1 : 1);
            er += Math.pow(2, De), Ve -= kr;
          }
          return (xr ? -1 : 1) * er * Math.pow(2, Ve - De);
        }, b1.write = function(Ie, de, Ce, De, Ke, Ve) {
          var er, fr, wr, kr = 8 * Ve - Ke - 1, cr = (1 << kr) - 1, Mr = cr >> 1, Er = Ke === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, xr = De ? 0 : Ve - 1, Sr = De ? 1 : -1, Br = de < 0 || de === 0 && 1 / de < 0 ? 1 : 0;
          for (de = Math.abs(de), isNaN(de) || de === 1 / 0 ? (fr = isNaN(de) ? 1 : 0, er = cr) : (er = Math.floor(Math.log(de) / Math.LN2), de * (wr = Math.pow(2, -er)) < 1 && (er--, wr *= 2), (de += er + Mr >= 1 ? Er / wr : Er * Math.pow(2, 1 - Mr)) * wr >= 2 && (er++, wr /= 2), er + Mr >= cr ? (fr = 0, er = cr) : er + Mr >= 1 ? (fr = (de * wr - 1) * Math.pow(2, Ke), er += Mr) : (fr = de * Math.pow(2, Mr - 1) * Math.pow(2, Ke), er = 0)); Ke >= 8; Ie[Ce + xr] = 255 & fr, xr += Sr, fr /= 256, Ke -= 8)
            ;
          for (er = er << Ke | fr, kr += Ke; kr > 0; Ie[Ce + xr] = 255 & er, xr += Sr, er /= 256, kr -= 8)
            ;
          Ie[Ce + xr - Sr] |= 128 * Br;
        }), b1;
      }
      function Ug() {
        if (Vg)
          return y1;
        Vg = 1, y1 = de;
        var Ie = f_();
        function de(Kr) {
          this.buf = ArrayBuffer.isView && ArrayBuffer.isView(Kr) ? Kr : new Uint8Array(Kr || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        de.Varint = 0, de.Fixed64 = 1, de.Bytes = 2, de.Fixed32 = 5;
        var Ce = 4294967296, De = 1 / Ce, Ke = typeof TextDecoder > "u" ? null : new TextDecoder("utf8");
        function Ve(Kr) {
          return Kr.type === de.Bytes ? Kr.readVarint() + Kr.pos : Kr.pos + 1;
        }
        function er(Kr, ni, gi) {
          return gi ? 4294967296 * ni + (Kr >>> 0) : 4294967296 * (ni >>> 0) + (Kr >>> 0);
        }
        function fr(Kr, ni, gi) {
          var Si = ni <= 16383 ? 1 : ni <= 2097151 ? 2 : ni <= 268435455 ? 3 : Math.floor(Math.log(ni) / (7 * Math.LN2));
          gi.realloc(Si);
          for (var Di = gi.pos - 1; Di >= Kr; Di--)
            gi.buf[Di + Si] = gi.buf[Di];
        }
        function wr(Kr, ni) {
          for (var gi = 0; gi < Kr.length; gi++)
            ni.writeVarint(Kr[gi]);
        }
        function kr(Kr, ni) {
          for (var gi = 0; gi < Kr.length; gi++)
            ni.writeSVarint(Kr[gi]);
        }
        function cr(Kr, ni) {
          for (var gi = 0; gi < Kr.length; gi++)
            ni.writeFloat(Kr[gi]);
        }
        function Mr(Kr, ni) {
          for (var gi = 0; gi < Kr.length; gi++)
            ni.writeDouble(Kr[gi]);
        }
        function Er(Kr, ni) {
          for (var gi = 0; gi < Kr.length; gi++)
            ni.writeBoolean(Kr[gi]);
        }
        function xr(Kr, ni) {
          for (var gi = 0; gi < Kr.length; gi++)
            ni.writeFixed32(Kr[gi]);
        }
        function Sr(Kr, ni) {
          for (var gi = 0; gi < Kr.length; gi++)
            ni.writeSFixed32(Kr[gi]);
        }
        function Br(Kr, ni) {
          for (var gi = 0; gi < Kr.length; gi++)
            ni.writeFixed64(Kr[gi]);
        }
        function Fr(Kr, ni) {
          for (var gi = 0; gi < Kr.length; gi++)
            ni.writeSFixed64(Kr[gi]);
        }
        function jr(Kr, ni) {
          return (Kr[ni] | Kr[ni + 1] << 8 | Kr[ni + 2] << 16) + 16777216 * Kr[ni + 3];
        }
        function Qr(Kr, ni, gi) {
          Kr[gi] = ni, Kr[gi + 1] = ni >>> 8, Kr[gi + 2] = ni >>> 16, Kr[gi + 3] = ni >>> 24;
        }
        function ti(Kr, ni) {
          return (Kr[ni] | Kr[ni + 1] << 8 | Kr[ni + 2] << 16) + (Kr[ni + 3] << 24);
        }
        return de.prototype = { destroy: function() {
          this.buf = null;
        }, readFields: function(Kr, ni, gi) {
          for (gi = gi || this.length; this.pos < gi; ) {
            var Si = this.readVarint(), Di = Si >> 3, Ri = this.pos;
            this.type = 7 & Si, Kr(Di, ni, this), this.pos === Ri && this.skip(Si);
          }
          return ni;
        }, readMessage: function(Kr, ni) {
          return this.readFields(Kr, ni, this.readVarint() + this.pos);
        }, readFixed32: function() {
          var Kr = jr(this.buf, this.pos);
          return this.pos += 4, Kr;
        }, readSFixed32: function() {
          var Kr = ti(this.buf, this.pos);
          return this.pos += 4, Kr;
        }, readFixed64: function() {
          var Kr = jr(this.buf, this.pos) + jr(this.buf, this.pos + 4) * Ce;
          return this.pos += 8, Kr;
        }, readSFixed64: function() {
          var Kr = jr(this.buf, this.pos) + ti(this.buf, this.pos + 4) * Ce;
          return this.pos += 8, Kr;
        }, readFloat: function() {
          var Kr = Ie.read(this.buf, this.pos, !0, 23, 4);
          return this.pos += 4, Kr;
        }, readDouble: function() {
          var Kr = Ie.read(this.buf, this.pos, !0, 52, 8);
          return this.pos += 8, Kr;
        }, readVarint: function(Kr) {
          var ni, gi, Si = this.buf;
          return ni = 127 & (gi = Si[this.pos++]), gi < 128 ? ni : (ni |= (127 & (gi = Si[this.pos++])) << 7, gi < 128 ? ni : (ni |= (127 & (gi = Si[this.pos++])) << 14, gi < 128 ? ni : (ni |= (127 & (gi = Si[this.pos++])) << 21, gi < 128 ? ni : function(Di, Ri, Bi) {
            var Ji, Fi, tn = Bi.buf;
            if (Ji = (112 & (Fi = tn[Bi.pos++])) >> 4, Fi < 128 || (Ji |= (127 & (Fi = tn[Bi.pos++])) << 3, Fi < 128) || (Ji |= (127 & (Fi = tn[Bi.pos++])) << 10, Fi < 128) || (Ji |= (127 & (Fi = tn[Bi.pos++])) << 17, Fi < 128) || (Ji |= (127 & (Fi = tn[Bi.pos++])) << 24, Fi < 128) || (Ji |= (1 & (Fi = tn[Bi.pos++])) << 31, Fi < 128))
              return er(Di, Ji, Ri);
            throw new Error("Expected varint not more than 10 bytes");
          }(ni |= (15 & (gi = Si[this.pos])) << 28, Kr, this))));
        }, readVarint64: function() {
          return this.readVarint(!0);
        }, readSVarint: function() {
          var Kr = this.readVarint();
          return Kr % 2 == 1 ? (Kr + 1) / -2 : Kr / 2;
        }, readBoolean: function() {
          return Boolean(this.readVarint());
        }, readString: function() {
          var Kr = this.readVarint() + this.pos, ni = this.pos;
          return this.pos = Kr, Kr - ni >= 12 && Ke ? function(gi, Si, Di) {
            return Ke.decode(gi.subarray(Si, Di));
          }(this.buf, ni, Kr) : function(gi, Si, Di) {
            for (var Ri = "", Bi = Si; Bi < Di; ) {
              var Ji, Fi, tn, cn = gi[Bi], ln = null, mn = cn > 239 ? 4 : cn > 223 ? 3 : cn > 191 ? 2 : 1;
              if (Bi + mn > Di)
                break;
              mn === 1 ? cn < 128 && (ln = cn) : mn === 2 ? (192 & (Ji = gi[Bi + 1])) == 128 && (ln = (31 & cn) << 6 | 63 & Ji) <= 127 && (ln = null) : mn === 3 ? (Fi = gi[Bi + 2], (192 & (Ji = gi[Bi + 1])) == 128 && (192 & Fi) == 128 && ((ln = (15 & cn) << 12 | (63 & Ji) << 6 | 63 & Fi) <= 2047 || ln >= 55296 && ln <= 57343) && (ln = null)) : mn === 4 && (Fi = gi[Bi + 2], tn = gi[Bi + 3], (192 & (Ji = gi[Bi + 1])) == 128 && (192 & Fi) == 128 && (192 & tn) == 128 && ((ln = (15 & cn) << 18 | (63 & Ji) << 12 | (63 & Fi) << 6 | 63 & tn) <= 65535 || ln >= 1114112) && (ln = null)), ln === null ? (ln = 65533, mn = 1) : ln > 65535 && (ln -= 65536, Ri += String.fromCharCode(ln >>> 10 & 1023 | 55296), ln = 56320 | 1023 & ln), Ri += String.fromCharCode(ln), Bi += mn;
            }
            return Ri;
          }(this.buf, ni, Kr);
        }, readBytes: function() {
          var Kr = this.readVarint() + this.pos, ni = this.buf.subarray(this.pos, Kr);
          return this.pos = Kr, ni;
        }, readPackedVarint: function(Kr, ni) {
          if (this.type !== de.Bytes)
            return Kr.push(this.readVarint(ni));
          var gi = Ve(this);
          for (Kr = Kr || []; this.pos < gi; )
            Kr.push(this.readVarint(ni));
          return Kr;
        }, readPackedSVarint: function(Kr) {
          if (this.type !== de.Bytes)
            return Kr.push(this.readSVarint());
          var ni = Ve(this);
          for (Kr = Kr || []; this.pos < ni; )
            Kr.push(this.readSVarint());
          return Kr;
        }, readPackedBoolean: function(Kr) {
          if (this.type !== de.Bytes)
            return Kr.push(this.readBoolean());
          var ni = Ve(this);
          for (Kr = Kr || []; this.pos < ni; )
            Kr.push(this.readBoolean());
          return Kr;
        }, readPackedFloat: function(Kr) {
          if (this.type !== de.Bytes)
            return Kr.push(this.readFloat());
          var ni = Ve(this);
          for (Kr = Kr || []; this.pos < ni; )
            Kr.push(this.readFloat());
          return Kr;
        }, readPackedDouble: function(Kr) {
          if (this.type !== de.Bytes)
            return Kr.push(this.readDouble());
          var ni = Ve(this);
          for (Kr = Kr || []; this.pos < ni; )
            Kr.push(this.readDouble());
          return Kr;
        }, readPackedFixed32: function(Kr) {
          if (this.type !== de.Bytes)
            return Kr.push(this.readFixed32());
          var ni = Ve(this);
          for (Kr = Kr || []; this.pos < ni; )
            Kr.push(this.readFixed32());
          return Kr;
        }, readPackedSFixed32: function(Kr) {
          if (this.type !== de.Bytes)
            return Kr.push(this.readSFixed32());
          var ni = Ve(this);
          for (Kr = Kr || []; this.pos < ni; )
            Kr.push(this.readSFixed32());
          return Kr;
        }, readPackedFixed64: function(Kr) {
          if (this.type !== de.Bytes)
            return Kr.push(this.readFixed64());
          var ni = Ve(this);
          for (Kr = Kr || []; this.pos < ni; )
            Kr.push(this.readFixed64());
          return Kr;
        }, readPackedSFixed64: function(Kr) {
          if (this.type !== de.Bytes)
            return Kr.push(this.readSFixed64());
          var ni = Ve(this);
          for (Kr = Kr || []; this.pos < ni; )
            Kr.push(this.readSFixed64());
          return Kr;
        }, skip: function(Kr) {
          var ni = 7 & Kr;
          if (ni === de.Varint)
            for (; this.buf[this.pos++] > 127; )
              ;
          else if (ni === de.Bytes)
            this.pos = this.readVarint() + this.pos;
          else if (ni === de.Fixed32)
            this.pos += 4;
          else {
            if (ni !== de.Fixed64)
              throw new Error("Unimplemented type: " + ni);
            this.pos += 8;
          }
        }, writeTag: function(Kr, ni) {
          this.writeVarint(Kr << 3 | ni);
        }, realloc: function(Kr) {
          for (var ni = this.length || 16; ni < this.pos + Kr; )
            ni *= 2;
          if (ni !== this.length) {
            var gi = new Uint8Array(ni);
            gi.set(this.buf), this.buf = gi, this.length = ni;
          }
        }, finish: function() {
          return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
        }, writeFixed32: function(Kr) {
          this.realloc(4), Qr(this.buf, Kr, this.pos), this.pos += 4;
        }, writeSFixed32: function(Kr) {
          this.realloc(4), Qr(this.buf, Kr, this.pos), this.pos += 4;
        }, writeFixed64: function(Kr) {
          this.realloc(8), Qr(this.buf, -1 & Kr, this.pos), Qr(this.buf, Math.floor(Kr * De), this.pos + 4), this.pos += 8;
        }, writeSFixed64: function(Kr) {
          this.realloc(8), Qr(this.buf, -1 & Kr, this.pos), Qr(this.buf, Math.floor(Kr * De), this.pos + 4), this.pos += 8;
        }, writeVarint: function(Kr) {
          (Kr = +Kr || 0) > 268435455 || Kr < 0 ? function(ni, gi) {
            var Si, Di;
            if (ni >= 0 ? (Si = ni % 4294967296 | 0, Di = ni / 4294967296 | 0) : (Di = ~(-ni / 4294967296), 4294967295 ^ (Si = ~(-ni % 4294967296)) ? Si = Si + 1 | 0 : (Si = 0, Di = Di + 1 | 0)), ni >= 18446744073709552e3 || ni < -18446744073709552e3)
              throw new Error("Given varint doesn't fit into 10 bytes");
            gi.realloc(10), function(Ri, Bi, Ji) {
              Ji.buf[Ji.pos++] = 127 & Ri | 128, Ri >>>= 7, Ji.buf[Ji.pos++] = 127 & Ri | 128, Ri >>>= 7, Ji.buf[Ji.pos++] = 127 & Ri | 128, Ri >>>= 7, Ji.buf[Ji.pos++] = 127 & Ri | 128, Ji.buf[Ji.pos] = 127 & (Ri >>>= 7);
            }(Si, 0, gi), function(Ri, Bi) {
              var Ji = (7 & Ri) << 4;
              Bi.buf[Bi.pos++] |= Ji | ((Ri >>>= 3) ? 128 : 0), Ri && (Bi.buf[Bi.pos++] = 127 & Ri | ((Ri >>>= 7) ? 128 : 0), Ri && (Bi.buf[Bi.pos++] = 127 & Ri | ((Ri >>>= 7) ? 128 : 0), Ri && (Bi.buf[Bi.pos++] = 127 & Ri | ((Ri >>>= 7) ? 128 : 0), Ri && (Bi.buf[Bi.pos++] = 127 & Ri | ((Ri >>>= 7) ? 128 : 0), Ri && (Bi.buf[Bi.pos++] = 127 & Ri)))));
            }(Di, gi);
          }(Kr, this) : (this.realloc(4), this.buf[this.pos++] = 127 & Kr | (Kr > 127 ? 128 : 0), Kr <= 127 || (this.buf[this.pos++] = 127 & (Kr >>>= 7) | (Kr > 127 ? 128 : 0), Kr <= 127 || (this.buf[this.pos++] = 127 & (Kr >>>= 7) | (Kr > 127 ? 128 : 0), Kr <= 127 || (this.buf[this.pos++] = Kr >>> 7 & 127))));
        }, writeSVarint: function(Kr) {
          this.writeVarint(Kr < 0 ? 2 * -Kr - 1 : 2 * Kr);
        }, writeBoolean: function(Kr) {
          this.writeVarint(Boolean(Kr));
        }, writeString: function(Kr) {
          Kr = String(Kr), this.realloc(4 * Kr.length), this.pos++;
          var ni = this.pos;
          this.pos = function(Si, Di, Ri) {
            for (var Bi, Ji, Fi = 0; Fi < Di.length; Fi++) {
              if ((Bi = Di.charCodeAt(Fi)) > 55295 && Bi < 57344) {
                if (!Ji) {
                  Bi > 56319 || Fi + 1 === Di.length ? (Si[Ri++] = 239, Si[Ri++] = 191, Si[Ri++] = 189) : Ji = Bi;
                  continue;
                }
                if (Bi < 56320) {
                  Si[Ri++] = 239, Si[Ri++] = 191, Si[Ri++] = 189, Ji = Bi;
                  continue;
                }
                Bi = Ji - 55296 << 10 | Bi - 56320 | 65536, Ji = null;
              } else
                Ji && (Si[Ri++] = 239, Si[Ri++] = 191, Si[Ri++] = 189, Ji = null);
              Bi < 128 ? Si[Ri++] = Bi : (Bi < 2048 ? Si[Ri++] = Bi >> 6 | 192 : (Bi < 65536 ? Si[Ri++] = Bi >> 12 | 224 : (Si[Ri++] = Bi >> 18 | 240, Si[Ri++] = Bi >> 12 & 63 | 128), Si[Ri++] = Bi >> 6 & 63 | 128), Si[Ri++] = 63 & Bi | 128);
            }
            return Ri;
          }(this.buf, Kr, this.pos);
          var gi = this.pos - ni;
          gi >= 128 && fr(ni, gi, this), this.pos = ni - 1, this.writeVarint(gi), this.pos += gi;
        }, writeFloat: function(Kr) {
          this.realloc(4), Ie.write(this.buf, Kr, this.pos, !0, 23, 4), this.pos += 4;
        }, writeDouble: function(Kr) {
          this.realloc(8), Ie.write(this.buf, Kr, this.pos, !0, 52, 8), this.pos += 8;
        }, writeBytes: function(Kr) {
          var ni = Kr.length;
          this.writeVarint(ni), this.realloc(ni);
          for (var gi = 0; gi < ni; gi++)
            this.buf[this.pos++] = Kr[gi];
        }, writeRawMessage: function(Kr, ni) {
          this.pos++;
          var gi = this.pos;
          Kr(ni, this);
          var Si = this.pos - gi;
          Si >= 128 && fr(gi, Si, this), this.pos = gi - 1, this.writeVarint(Si), this.pos += Si;
        }, writeMessage: function(Kr, ni, gi) {
          this.writeTag(Kr, de.Bytes), this.writeRawMessage(ni, gi);
        }, writePackedVarint: function(Kr, ni) {
          ni.length && this.writeMessage(Kr, wr, ni);
        }, writePackedSVarint: function(Kr, ni) {
          ni.length && this.writeMessage(Kr, kr, ni);
        }, writePackedBoolean: function(Kr, ni) {
          ni.length && this.writeMessage(Kr, Er, ni);
        }, writePackedFloat: function(Kr, ni) {
          ni.length && this.writeMessage(Kr, cr, ni);
        }, writePackedDouble: function(Kr, ni) {
          ni.length && this.writeMessage(Kr, Mr, ni);
        }, writePackedFixed32: function(Kr, ni) {
          ni.length && this.writeMessage(Kr, xr, ni);
        }, writePackedSFixed32: function(Kr, ni) {
          ni.length && this.writeMessage(Kr, Sr, ni);
        }, writePackedFixed64: function(Kr, ni) {
          ni.length && this.writeMessage(Kr, Br, ni);
        }, writePackedSFixed64: function(Kr, ni) {
          ni.length && this.writeMessage(Kr, Fr, ni);
        }, writeBytesField: function(Kr, ni) {
          this.writeTag(Kr, de.Bytes), this.writeBytes(ni);
        }, writeFixed32Field: function(Kr, ni) {
          this.writeTag(Kr, de.Fixed32), this.writeFixed32(ni);
        }, writeSFixed32Field: function(Kr, ni) {
          this.writeTag(Kr, de.Fixed32), this.writeSFixed32(ni);
        }, writeFixed64Field: function(Kr, ni) {
          this.writeTag(Kr, de.Fixed64), this.writeFixed64(ni);
        }, writeSFixed64Field: function(Kr, ni) {
          this.writeTag(Kr, de.Fixed64), this.writeSFixed64(ni);
        }, writeVarintField: function(Kr, ni) {
          this.writeTag(Kr, de.Varint), this.writeVarint(ni);
        }, writeSVarintField: function(Kr, ni) {
          this.writeTag(Kr, de.Varint), this.writeSVarint(ni);
        }, writeStringField: function(Kr, ni) {
          this.writeTag(Kr, de.Bytes), this.writeString(ni);
        }, writeFloatField: function(Kr, ni) {
          this.writeTag(Kr, de.Fixed32), this.writeFloat(ni);
        }, writeDoubleField: function(Kr, ni) {
          this.writeTag(Kr, de.Fixed64), this.writeDouble(ni);
        }, writeBooleanField: function(Kr, ni) {
          this.writeVarintField(Kr, Boolean(ni));
        } }, y1;
      }
      var g0 = rr(Ug());
      const x1 = 3;
      function p_(Ie, de, Ce) {
        de.glyphs = [], Ie === 1 && Ce.readMessage(m_, de);
      }
      function m_(Ie, de, Ce) {
        if (Ie === 3) {
          const { id: De, bitmap: Ke, width: Ve, height: er, left: fr, top: wr, advance: kr } = Ce.readMessage(g_, {});
          de.glyphs.push({ id: De, bitmap: new hd({ width: Ve + 2 * x1, height: er + 2 * x1 }, Ke), metrics: { width: Ve, height: er, left: fr, top: wr, advance: kr } });
        } else
          Ie === 4 ? de.ascender = Ce.readSVarint() : Ie === 5 && (de.descender = Ce.readSVarint());
      }
      function g_(Ie, de, Ce) {
        Ie === 1 ? de.id = Ce.readVarint() : Ie === 2 ? de.bitmap = Ce.readBytes() : Ie === 3 ? de.width = Ce.readVarint() : Ie === 4 ? de.height = Ce.readVarint() : Ie === 5 ? de.left = Ce.readSVarint() : Ie === 6 ? de.top = Ce.readSVarint() : Ie === 7 && (de.advance = Ce.readVarint());
      }
      const jg = x1, Pc = { horizontal: 1, vertical: 2, horizontalOnly: 3 };
      class bm {
        constructor() {
          this.scale = 1, this.fontStack = "", this.image = null;
        }
        static forText(de, Ce) {
          const De = new bm();
          return De.scale = de || 1, De.fontStack = Ce, De;
        }
        static forImage(de) {
          const Ce = new bm();
          return Ce.image = de, Ce;
        }
      }
      class pp {
        constructor() {
          this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
        }
        static fromFeature(de, Ce) {
          const De = new pp();
          for (let Ke = 0; Ke < de.sections.length; Ke++) {
            const Ve = de.sections[Ke];
            Ve.image ? De.addImageSection(Ve) : De.addTextSection(Ve, Ce);
          }
          return De;
        }
        length() {
          return this.text.length;
        }
        getSection(de) {
          return this.sections[this.sectionIndex[de]];
        }
        getSections() {
          return this.sections;
        }
        getSectionIndex(de) {
          return this.sectionIndex[de];
        }
        getCodePoint(de) {
          return this.text.codePointAt(de);
        }
        verticalizePunctuation(de) {
          this.text = function(Ce, De) {
            let Ke = "";
            for (let Ve = 0; Ve < Ce.length; Ve++) {
              const er = Ce.charCodeAt(Ve + 1) || null, fr = Ce.charCodeAt(Ve - 1) || null;
              Ke += !De && (er && Ud(er) && !ym[Ce[Ve + 1]] || fr && Ud(fr) && !ym[Ce[Ve - 1]]) || !ym[Ce[Ve]] ? Ce[Ve] : ym[Ce[Ve]];
            }
            return Ke;
          }(this.text, de);
        }
        trim() {
          let de = 0;
          for (let De = 0; De < this.text.length && v0[this.text.charCodeAt(De)]; De++)
            de++;
          let Ce = this.text.length;
          for (let De = this.text.length - 1; De >= 0 && De >= de && v0[this.text.charCodeAt(De)]; De--)
            Ce--;
          this.text = this.text.substring(de, Ce), this.sectionIndex = this.sectionIndex.slice(de, Ce);
        }
        substring(de, Ce) {
          const De = new pp();
          return De.text = this.text.substring(de, Ce), De.sectionIndex = this.sectionIndex.slice(de, Ce), De.sections = this.sections, De;
        }
        toString() {
          return this.text;
        }
        getMaxScale() {
          return this.sectionIndex.reduce((de, Ce) => Math.max(de, this.sections[Ce].scale), 0);
        }
        addTextSection(de, Ce) {
          this.text += de.text, this.sections.push(bm.forText(de.scale, de.fontStack || Ce));
          const De = this.sections.length - 1;
          for (let Ke = 0; Ke < de.text.length; ++Ke)
            this.sectionIndex.push(De);
        }
        addImageSection(de) {
          const Ce = de.image && de.image.namePrimary ? de.image.getPrimary() : null;
          if (!Ce)
            return void Mn("Can't add FormattedSection with an empty image.");
          const De = this.getNextImageSectionCharCode();
          De ? (this.text += String.fromCodePoint(De), this.sections.push(bm.forImage(Ce)), this.sectionIndex.push(this.sections.length - 1)) : Mn("Reached maximum number of images 6401");
        }
        getNextImageSectionCharCode() {
          return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
        }
      }
      function w1(Ie, de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr) {
        const Br = pp.fromFeature(Ie, Ke);
        Mr === Pc.vertical && Br.verticalizePunctuation(Er);
        let Fr = [];
        const jr = function(gi, Si, Di, Ri, Bi, Ji) {
          if (!gi)
            return [];
          const Fi = [], tn = function(wn, Cn, gn, Nn, oo, Un) {
            let fo = 0;
            for (let ho = 0; ho < wn.length(); ho++) {
              const bo = wn.getSection(ho);
              fo += qg(wn.getCodePoint(ho), bo, Nn, oo, Cn, Un);
            }
            return fo / Math.max(1, Math.ceil(fo / gn));
          }(gi, Si, Di, Ri, Bi, Ji), cn = gi.text.indexOf("\u200B") >= 0;
          let ln = 0;
          for (let wn = 0; wn < gi.length(); wn++) {
            const Cn = gi.getSection(wn), gn = gi.getCodePoint(wn);
            if (v0[gn] || (ln += qg(gn, Cn, Ri, Bi, Si, Ji)), wn < gi.length() - 1) {
              const Nn = !((mn = gn) < 11904 || !(Do["Bopomofo Extended"](mn) || Do.Bopomofo(mn) || Do["CJK Compatibility Forms"](mn) || Do["CJK Compatibility Ideographs"](mn) || Do["CJK Compatibility"](mn) || Do["CJK Radicals Supplement"](mn) || Do["CJK Strokes"](mn) || Do["CJK Symbols and Punctuation"](mn) || Do["CJK Unified Ideographs Extension A"](mn) || Do["CJK Unified Ideographs"](mn) || Do["Enclosed CJK Letters and Months"](mn) || Do["Halfwidth and Fullwidth Forms"](mn) || Do.Hiragana(mn) || Do["Ideographic Description Characters"](mn) || Do["Kangxi Radicals"](mn) || Do["Katakana Phonetic Extensions"](mn) || Do.Katakana(mn) || Do["Vertical Forms"](mn) || Do["Yi Radicals"](mn) || Do["Yi Syllables"](mn)));
              (v_[gn] || Nn || Cn.image) && Fi.push(S1(wn + 1, ln, tn, Fi, M1(gn, gi.getCodePoint(wn + 1), Nn && cn), !1));
            }
          }
          var mn;
          return E1(S1(gi.length(), ln, tn, Fi, 0, !0));
        }(Br, kr, Ve, de, De, xr), { processBidirectionalText: Qr, processStyledBidirectionalText: ti } = Il;
        if (Qr && Br.sections.length === 1) {
          const gi = Qr(Br.toString(), jr);
          for (const Si of gi) {
            const Di = new pp();
            Di.text = Si, Di.sections = Br.sections;
            for (let Ri = 0; Ri < Si.length; Ri++)
              Di.sectionIndex.push(0);
            Fr.push(Di);
          }
        } else if (ti) {
          const gi = ti(Br.text, Br.sectionIndex, jr);
          for (const Si of gi) {
            const Di = new pp();
            Di.text = Si[0], Di.sectionIndex = Si[1], Di.sections = Br.sections, Fr.push(Di);
          }
        } else
          Fr = function(gi, Si) {
            const Di = [], Ri = gi.text;
            let Bi = 0;
            for (const Ji of Si)
              Di.push(gi.substring(Bi, Ji)), Bi = Ji;
            return Bi < Ri.length && Di.push(gi.substring(Bi, Ri.length)), Di;
          }(Br, jr);
        const Kr = [], ni = { positionedLines: Kr, text: Br.toString(), top: cr[1], bottom: cr[1], left: cr[0], right: cr[0], writingMode: Mr, iconsInText: !1, verticalizable: !1, hasBaseline: !1 };
        return function(gi, Si, Di, Ri, Bi, Ji, Fi, tn, cn, ln, mn, wn) {
          let Cn = 0, gn = 0, Nn = 0;
          const oo = tn === "right" ? 1 : tn === "left" ? 0 : 0.5;
          let Un = !1;
          for (const po of Bi) {
            const Lo = po.getSections();
            for (const jo of Lo) {
              if (jo.image)
                continue;
              const oa = Si[jo.fontStack];
              if (oa && (Un = oa.ascender !== void 0 && oa.descender !== void 0, !Un))
                break;
            }
            if (!Un)
              break;
          }
          let fo = 0;
          for (const po of Bi) {
            po.trim();
            const Lo = po.getMaxScale(), jo = (Lo - 1) * _l, oa = { positionedGlyphs: [], lineOffset: 0 };
            gi.positionedLines[fo] = oa;
            const ua = oa.positionedGlyphs;
            let fa = 0;
            if (!po.length()) {
              gn += Ji, ++fo;
              continue;
            }
            let ha = 0, va = 0;
            for (let qa = 0; qa < po.length(); qa++) {
              const ra = po.getSection(qa), Ga = po.getSectionIndex(qa), ja = po.getCodePoint(qa);
              let as = ra.scale, Gs = null, Hs = null, Is = null, Mc = _l, gs = 0;
              const ws = !(cn === Pc.horizontal || !mn && !qf(ja) || mn && (v0[ja] || (ho = ja, Do.Arabic(ho) || Do["Arabic Supplement"](ho) || Do["Arabic Extended-A"](ho) || Do["Arabic Presentation Forms-A"](ho) || Do["Arabic Presentation Forms-B"](ho))));
              if (ra.image) {
                const cc = Ri[ra.image.serialize()];
                if (!cc)
                  continue;
                Is = ra.image.id, gi.iconsInText = gi.iconsInText || !0, Hs = cc.paddedRect;
                const Ws = cc.displaySize;
                as = as * _l / wn, Gs = { width: Ws[0], height: Ws[1], left: 0, top: -jg, advance: ws ? Ws[1] : Ws[0], localGlyph: !1 }, gs = Un ? -Gs.height * as : Lo * _l - 17 - Ws[1] * as, Mc = Gs.advance;
                const zc = (ws ? Ws[0] : Ws[1]) * as - _l * Lo;
                zc > 0 && zc > fa && (fa = zc);
              } else {
                const cc = Di[ra.fontStack];
                if (!cc)
                  continue;
                cc[ja] && (Hs = cc[ja]);
                const Ws = Si[ra.fontStack];
                if (!Ws)
                  continue;
                const zc = Ws.glyphs[ja];
                if (!zc)
                  continue;
                if (Gs = zc.metrics, Mc = ja !== 8203 ? _l : 0, Un) {
                  const nl = Ws.ascender !== void 0 ? Math.abs(Ws.ascender) : 0, gd = Ws.descender !== void 0 ? Math.abs(Ws.descender) : 0, yp = (nl + gd) * as;
                  ha < yp && (ha = yp, va = (nl - gd) / 2 * as), gs = -nl * as;
                } else
                  gs = (Lo - as) * _l - 17;
              }
              ws ? (gi.verticalizable = !0, ua.push({ glyph: ja, imageName: Is, x: Cn, y: gn + gs, vertical: ws, scale: as, localGlyph: Gs.localGlyph, fontStack: ra.fontStack, sectionIndex: Ga, metrics: Gs, rect: Hs }), Cn += Mc * as + ln) : (ua.push({ glyph: ja, imageName: Is, x: Cn, y: gn + gs, vertical: ws, scale: as, localGlyph: Gs.localGlyph, fontStack: ra.fontStack, sectionIndex: Ga, metrics: Gs, rect: Hs }), Cn += Gs.advance * as + ln);
            }
            ua.length !== 0 && (Nn = Math.max(Cn - ln, Nn), Un ? Hg(ua, oo, fa, va, Ji * Lo / 2) : Hg(ua, oo, fa, 0, Ji / 2)), Cn = 0;
            const os = Ji * Lo + fa;
            oa.lineOffset = Math.max(fa, jo), gn += os, ++fo;
          }
          var ho;
          const bo = gn, { horizontalAlign: Jn, verticalAlign: Ro } = C1(Fi);
          (function(po, Lo, jo, oa, ua, fa) {
            const ha = (Lo - jo) * ua, va = -fa * oa;
            for (const os of po)
              for (const qa of os.positionedGlyphs)
                qa.x += ha, qa.y += va;
          })(gi.positionedLines, oo, Jn, Ro, Nn, bo), gi.top += -Ro * bo, gi.bottom = gi.top + bo, gi.left += -Jn * Nn, gi.right = gi.left + Nn, gi.hasBaseline = Un;
        }(ni, de, Ce, De, Fr, er, fr, wr, Mr, kr, Er, Sr), !function(gi) {
          for (const Si of gi)
            if (Si.positionedGlyphs.length !== 0)
              return !1;
          return !0;
        }(Kr) && ni;
      }
      const v0 = { 9: !0, 10: !0, 11: !0, 12: !0, 13: !0, 32: !0 }, v_ = { 10: !0, 32: !0, 38: !0, 40: !0, 41: !0, 43: !0, 45: !0, 47: !0, 173: !0, 183: !0, 8203: !0, 8208: !0, 8211: !0, 8231: !0 };
      function qg(Ie, de, Ce, De, Ke, Ve) {
        if (de.image) {
          const er = De[de.image.serialize()];
          return er ? er.displaySize[0] * de.scale * _l / Ve + Ke : 0;
        }
        {
          const er = Ce[de.fontStack], fr = er && er.glyphs[Ie];
          return fr ? fr.metrics.advance * de.scale + Ke : 0;
        }
      }
      function Gg(Ie, de, Ce, De) {
        const Ke = Math.pow(Ie - de, 2);
        return De ? Ie < de ? Ke / 2 : 2 * Ke : Ke + Math.abs(Ce) * Ce;
      }
      function M1(Ie, de, Ce) {
        let De = 0;
        return Ie === 10 && (De -= 1e4), Ce && (De += 150), Ie !== 40 && Ie !== 65288 || (De += 50), de !== 41 && de !== 65289 || (De += 50), De;
      }
      function S1(Ie, de, Ce, De, Ke, Ve) {
        let er = null, fr = Gg(de, Ce, Ke, Ve);
        for (const wr of De) {
          const kr = Gg(de - wr.x, Ce, Ke, Ve) + wr.badness;
          kr <= fr && (er = wr, fr = kr);
        }
        return { index: Ie, x: de, priorBreak: er, badness: fr };
      }
      function E1(Ie) {
        return Ie ? E1(Ie.priorBreak).concat(Ie.index) : [];
      }
      function C1(Ie) {
        let de = 0.5, Ce = 0.5;
        switch (Ie) {
          case "right":
          case "top-right":
          case "bottom-right":
            de = 1;
            break;
          case "left":
          case "top-left":
          case "bottom-left":
            de = 0;
        }
        switch (Ie) {
          case "bottom":
          case "bottom-right":
          case "bottom-left":
            Ce = 1;
            break;
          case "top":
          case "top-right":
          case "top-left":
            Ce = 0;
        }
        return { horizontalAlign: de, verticalAlign: Ce };
      }
      function Hg(Ie, de, Ce, De, Ke) {
        if (!(de || Ce || De || Ke))
          return;
        const Ve = Ie.length - 1, er = Ie[Ve], fr = (er.x + er.metrics.advance * er.scale) * de;
        for (let wr = 0; wr <= Ve; wr++)
          Ie[wr].x -= fr, Ie[wr].y += Ce + De + Ke;
      }
      function __(Ie, de, Ce, De) {
        const { horizontalAlign: Ke, verticalAlign: Ve } = C1(De), er = Ce[0] - Ie.displaySize[0] * Ke, fr = Ce[1] - Ie.displaySize[1] * Ve;
        return { imagePrimary: Ie, imageSecondary: de, top: fr, bottom: fr + Ie.displaySize[1], left: er, right: er + Ie.displaySize[0] };
      }
      function _0(Ie, de, Ce, De, Ke, Ve) {
        const er = Ie.imagePrimary;
        let fr;
        if (er.content) {
          const Fr = er.content, jr = er.pixelRatio || 1;
          fr = [Fr[0] / jr, Fr[1] / jr, er.displaySize[0] - Fr[2] / jr, er.displaySize[1] - Fr[3] / jr];
        }
        const wr = de.left * Ve, kr = de.right * Ve;
        let cr, Mr, Er, xr;
        Ce === "width" || Ce === "both" ? (xr = Ke[0] + wr - De[3], Mr = Ke[0] + kr + De[1]) : (xr = Ke[0] + (wr + kr - er.displaySize[0]) / 2, Mr = xr + er.displaySize[0]);
        const Sr = de.top * Ve, Br = de.bottom * Ve;
        return Ce === "height" || Ce === "both" ? (cr = Ke[1] + Sr - De[0], Er = Ke[1] + Br + De[2]) : (cr = Ke[1] + (Sr + Br - er.displaySize[1]) / 2, Er = cr + er.displaySize[1]), { imagePrimary: er, imageSecondary: void 0, top: cr, right: Mr, bottom: Er, left: xr, collisionPadding: fr };
      }
      class Sh extends qi {
        constructor(de, Ce, De, Ke, Ve) {
          super(de, Ce), this.angle = Ke, this.z = De, Ve !== void 0 && (this.segment = Ve);
        }
        clone() {
          return new Sh(this.x, this.y, this.z, this.angle, this.segment);
        }
      }
      function Wg(Ie, de, Ce, De, Ke) {
        if (de.segment === void 0)
          return !0;
        let Ve = de, er = de.segment + 1, fr = 0;
        for (; fr > -Ce / 2; ) {
          if (er--, er < 0)
            return !1;
          fr -= Ie[er].dist(Ve), Ve = Ie[er];
        }
        fr += Ie[er].dist(Ie[er + 1]), er++;
        const wr = [];
        let kr = 0;
        for (; fr < Ce / 2; ) {
          const cr = Ie[er], Mr = Ie[er + 1];
          if (!Mr)
            return !1;
          let Er = Ie[er - 1].angleTo(cr) - cr.angleTo(Mr);
          for (Er = Math.abs((Er + 3 * Math.PI) % (2 * Math.PI) - Math.PI), wr.push({ distance: fr, angleDelta: Er }), kr += Er; fr - wr[0].distance > De; )
            kr -= wr.shift().angleDelta;
          if (kr > Ke)
            return !1;
          er++, fr += cr.dist(Mr);
        }
        return !0;
      }
      function Zg(Ie) {
        let de = 0;
        for (let Ce = 0; Ce < Ie.length - 1; Ce++)
          de += Ie[Ce].dist(Ie[Ce + 1]);
        return de;
      }
      function lc(Ie, de, Ce) {
        return Ie ? 0.6 * de * Ce : 0;
      }
      function y0(Ie, de) {
        return Math.max(Ie ? Ie.right - Ie.left : 0, de ? de.right - de.left : 0);
      }
      function y_(Ie, de, Ce, De, Ke, Ve) {
        const er = lc(Ce, Ke, Ve), fr = y0(Ce, De) * Ve;
        let wr = 0;
        const kr = Zg(Ie) / 2;
        for (let cr = 0; cr < Ie.length - 1; cr++) {
          const Mr = Ie[cr], Er = Ie[cr + 1], xr = Mr.dist(Er);
          if (wr + xr > kr) {
            const Sr = (kr - wr) / xr, Br = Ho(Mr.x, Er.x, Sr), Fr = Ho(Mr.y, Er.y, Sr), jr = new Sh(Br, Fr, 0, Er.angleTo(Mr), cr);
            return !er || Wg(Ie, jr, fr, er, de) ? jr : void 0;
          }
          wr += xr;
        }
      }
      function b_(Ie, de, Ce, De, Ke, Ve, er, fr, wr) {
        const kr = lc(De, Ve, er), cr = y0(De, Ke), Mr = cr * er, Er = Ie[0].x === 0 || Ie[0].x === wr || Ie[0].y === 0 || Ie[0].y === wr;
        return de - Mr < de / 4 && (de = Mr + de / 4), Xg(Ie, Er ? de / 2 * fr % de : (cr / 2 + 2 * Ve) * er * fr % de, de, kr, Ce, Mr, Er, !1, wr);
      }
      function Xg(Ie, de, Ce, De, Ke, Ve, er, fr, wr) {
        const kr = Ve / 2, cr = Zg(Ie);
        let Mr = 0, Er = de - Ce, xr = [];
        for (let Sr = 0; Sr < Ie.length - 1; Sr++) {
          const Br = Ie[Sr], Fr = Ie[Sr + 1], jr = Br.dist(Fr), Qr = Fr.angleTo(Br);
          for (; Er + Ce < Mr + jr; ) {
            Er += Ce;
            const ti = (Er - Mr) / jr, Kr = Ho(Br.x, Fr.x, ti), ni = Ho(Br.y, Fr.y, ti);
            if (Kr >= 0 && Kr < wr && ni >= 0 && ni < wr && Er - kr >= 0 && Er + kr <= cr) {
              const gi = new Sh(Kr, ni, 0, Qr, Sr);
              De && !Wg(Ie, gi, Ve, De, Ke) || xr.push(gi);
            }
          }
          Mr += jr;
        }
        return fr || xr.length || er || (xr = Xg(Ie, Mr / 2, Ce, De, Ke, Ve, er, !0, wr)), xr;
      }
      function Kg(Ie, de, Ce, De, Ke) {
        const Ve = [];
        for (let er = 0; er < Ie.length; er++) {
          const fr = Ie[er];
          let wr;
          for (let kr = 0; kr < fr.length - 1; kr++) {
            let cr = fr[kr], Mr = fr[kr + 1];
            cr.x < de && Mr.x < de || (cr.x < de ? cr = new qi(de, cr.y + (de - cr.x) / (Mr.x - cr.x) * (Mr.y - cr.y))._round() : Mr.x < de && (Mr = new qi(de, cr.y + (de - cr.x) / (Mr.x - cr.x) * (Mr.y - cr.y))._round()), cr.y < Ce && Mr.y < Ce || (cr.y < Ce ? cr = new qi(cr.x + (Ce - cr.y) / (Mr.y - cr.y) * (Mr.x - cr.x), Ce)._round() : Mr.y < Ce && (Mr = new qi(cr.x + (Ce - cr.y) / (Mr.y - cr.y) * (Mr.x - cr.x), Ce)._round()), cr.x >= De && Mr.x >= De || (cr.x >= De ? cr = new qi(De, cr.y + (De - cr.x) / (Mr.x - cr.x) * (Mr.y - cr.y))._round() : Mr.x >= De && (Mr = new qi(De, cr.y + (De - cr.x) / (Mr.x - cr.x) * (Mr.y - cr.y))._round()), cr.y >= Ke && Mr.y >= Ke || (cr.y >= Ke ? cr = new qi(cr.x + (Ke - cr.y) / (Mr.y - cr.y) * (Mr.x - cr.x), Ke)._round() : Mr.y >= Ke && (Mr = new qi(cr.x + (Ke - cr.y) / (Mr.y - cr.y) * (Mr.x - cr.x), Ke)._round()), wr && cr.equals(wr[wr.length - 1]) || (wr = [cr], Ve.push(wr)), wr.push(Mr)))));
          }
        }
        return Ve;
      }
      function b0(Ie) {
        let de = 0, Ce = 0;
        for (const er of Ie)
          de += er.w * er.h, Ce = Math.max(Ce, er.w);
        Ie.sort((er, fr) => fr.h - er.h);
        const De = [{ x: 0, y: 0, w: Math.max(Math.ceil(Math.sqrt(de / 0.95)), Ce), h: 1 / 0 }];
        let Ke = 0, Ve = 0;
        for (const er of Ie)
          for (let fr = De.length - 1; fr >= 0; fr--) {
            const wr = De[fr];
            if (!(er.w > wr.w || er.h > wr.h)) {
              if (er.x = wr.x, er.y = wr.y, Ve = Math.max(Ve, er.y + er.h), Ke = Math.max(Ke, er.x + er.w), er.w === wr.w && er.h === wr.h) {
                const kr = De.pop();
                fr < De.length && (De[fr] = kr);
              } else
                er.h === wr.h ? (wr.x += er.w, wr.w -= er.w) : er.w === wr.w ? (wr.y += er.h, wr.h -= er.h) : (De.push({ x: wr.x + er.w, y: wr.y, w: wr.w - er.w, h: er.h }), wr.y += er.h, wr.h -= er.h);
              break;
            }
          }
        return { w: Ke, h: Ve, fill: de / (Ke * Ve) || 0 };
      }
      Ao(Sh, "Anchor");
      const xm = 1;
      class wm {
        constructor(de, { pixelRatio: Ce, version: De, stretchX: Ke, stretchY: Ve, content: er }, fr) {
          this.paddedRect = de, this.pixelRatio = Ce, this.stretchX = Ke, this.stretchY = Ve, this.content = er, this.version = De, this.padding = fr;
        }
        get tl() {
          return [this.paddedRect.x + this.padding, this.paddedRect.y + this.padding];
        }
        get br() {
          return [this.paddedRect.x + this.paddedRect.w - this.padding, this.paddedRect.y + this.paddedRect.h - this.padding];
        }
        get displaySize() {
          return [(this.paddedRect.w - 2 * this.padding) / this.pixelRatio, (this.paddedRect.h - 2 * this.padding) / this.pixelRatio];
        }
      }
      class Yg {
        constructor(de, Ce, De) {
          const Ke = {}, Ve = {};
          this.haveRenderCallbacks = [];
          const er = [];
          this.addImages(de, Ke, xm, er), this.addImages(Ce, Ve, 2, er);
          const { w: fr, h: wr } = b0(er), kr = new Al({ width: fr || 1, height: wr || 1 });
          for (const cr in de) {
            const Mr = de[cr], Er = Ke[cr].paddedRect;
            Al.copy(Mr.data, kr, { x: 0, y: 0 }, { x: Er.x + xm, y: Er.y + xm }, Mr.data, De, Mr.sdf);
          }
          for (const cr in Ce) {
            const Mr = Ce[cr], Er = Ve[cr].paddedRect;
            let xr = Ve[cr].padding;
            const Sr = Er.x + xr, Br = Er.y + xr, Fr = Mr.data.width, jr = Mr.data.height;
            xr = xr > 1 ? xr - 1 : xr, Al.copy(Mr.data, kr, { x: 0, y: 0 }, { x: Sr, y: Br }, Mr.data, De), Al.copy(Mr.data, kr, { x: 0, y: jr - xr }, { x: Sr, y: Br - xr }, { width: Fr, height: xr }, De), Al.copy(Mr.data, kr, { x: 0, y: 0 }, { x: Sr, y: Br + jr }, { width: Fr, height: xr }, De), Al.copy(Mr.data, kr, { x: Fr - xr, y: 0 }, { x: Sr - xr, y: Br }, { width: xr, height: jr }, De), Al.copy(Mr.data, kr, { x: 0, y: 0 }, { x: Sr + Fr, y: Br }, { width: xr, height: jr }, De), Al.copy(Mr.data, kr, { x: Fr - xr, y: jr - xr }, { x: Sr - xr, y: Br - xr }, { width: xr, height: xr }, De), Al.copy(Mr.data, kr, { x: 0, y: jr - xr }, { x: Sr + Fr, y: Br - xr }, { width: xr, height: xr }, De), Al.copy(Mr.data, kr, { x: 0, y: 0 }, { x: Sr + Fr, y: Br + jr }, { width: xr, height: xr }, De), Al.copy(Mr.data, kr, { x: Fr - xr, y: 0 }, { x: Sr - xr, y: Br + jr }, { width: xr, height: xr }, De);
          }
          this.image = kr, this.iconPositions = Ke, this.patternPositions = Ve;
        }
        addImages(de, Ce, De, Ke) {
          for (const Ve in de) {
            const er = de[Ve], fr = { x: 0, y: 0, w: er.data.width + 2 * De, h: er.data.height + 2 * De };
            Ke.push(fr), Ce[Ve] = new wm(fr, er, De), er.hasRenderCallback && this.haveRenderCallbacks.push(yl.deserializeId(Ve));
          }
        }
        patchUpdatedImages(de, Ce, De) {
          this.haveRenderCallbacks = this.haveRenderCallbacks.filter((Ke) => de.hasImage(Ke, De)), de.dispatchRenderCallbacks(this.haveRenderCallbacks, De);
          for (const Ke in de.getUpdatedImages(De)) {
            for (const Ve of Object.keys(this.iconPositions))
              yl.deserializeId(Ve) === Ke && this.patchUpdatedImage(this.iconPositions[Ve], de.getImage(Ke, De), Ce);
            for (const Ve of Object.keys(this.patternPositions))
              yl.deserializeId(Ve) === Ke && this.patchUpdatedImage(this.patternPositions[Ve], de.getImage(Ke, De), Ce);
          }
        }
        patchUpdatedImage(de, Ce, De) {
          if (!de || !Ce || de.version === Ce.version)
            return;
          de.version = Ce.version;
          const [Ke, Ve] = de.tl;
          De.update(Ce.data, { position: { x: Ke, y: Ve } });
        }
      }
      Ao(wm, "ImagePosition"), Ao(Yg, "ImageAtlas");
      const Mm = 1e20;
      function Jg(Ie, de, Ce, De, Ke, Ve, er, fr, wr) {
        for (let kr = de; kr < de + De; kr++)
          Qg(Ie, Ce * Ve + kr, Ve, Ke, er, fr, wr);
        for (let kr = Ce; kr < Ce + Ke; kr++)
          Qg(Ie, kr * Ve + de, 1, De, er, fr, wr);
      }
      function Qg(Ie, de, Ce, De, Ke, Ve, er) {
        Ve[0] = 0, er[0] = -Mm, er[1] = Mm, Ke[0] = Ie[de];
        for (let fr = 1, wr = 0, kr = 0; fr < De; fr++) {
          Ke[fr] = Ie[de + fr * Ce];
          const cr = fr * fr;
          do {
            const Mr = Ve[wr];
            kr = (Ke[fr] - Ke[Mr] + cr - Mr * Mr) / (fr - Mr) / 2;
          } while (kr <= er[wr] && --wr > -1);
          wr++, Ve[wr] = fr, er[wr] = kr, er[wr + 1] = Mm;
        }
        for (let fr = 0, wr = 0; fr < De; fr++) {
          for (; er[wr + 1] < fr; )
            wr++;
          const kr = Ve[wr], cr = fr - kr;
          Ie[de + fr * Ce] = Ke[kr] + cr * cr;
        }
      }
      const eu = 2, T1 = { none: 0, ideographs: 1, all: 2 };
      class mp {
        constructor(de, Ce, De) {
          this.requestManager = de, this.localGlyphMode = Ce, this.localFontFamily = De, this.urls = {}, this.entries = {}, this.localGlyphs = { 200: {}, 400: {}, 500: {}, 900: {} };
        }
        setURL(de, Ce) {
          this.urls[Ce] = de;
        }
        getGlyphs(de, Ce, De) {
          const Ke = [], Ve = this.urls[Ce] || Pi.GLYPHS_URL;
          for (const er in de)
            for (const fr of de[er])
              Ke.push({ stack: er, id: fr });
          Xn(Ke, ({ stack: er, id: fr }, wr) => {
            let kr = this.entries[er];
            kr || (kr = this.entries[er] = { glyphs: {}, requests: {}, ranges: {}, ascender: void 0, descender: void 0 });
            let cr = kr.glyphs[fr];
            if (cr !== void 0)
              return void wr(null, { stack: er, id: fr, glyph: cr });
            if (cr = this._tinySDF(kr, er, fr), cr)
              return kr.glyphs[fr] = cr, void wr(null, { stack: er, id: fr, glyph: cr });
            const Mr = Math.floor(fr / 256);
            if (256 * Mr > 65535)
              return Mn("glyphs > 65535 not supported"), void wr(null, { stack: er, id: fr, glyph: cr });
            if (kr.ranges[Mr])
              return void wr(null, { stack: er, id: fr, glyph: cr });
            let Er = kr.requests[Mr];
            Er || (Er = kr.requests[Mr] = [], mp.loadGlyphRange(er, Mr, Ve, this.requestManager, (xr, Sr) => {
              if (Sr) {
                kr.ascender = Sr.ascender, kr.descender = Sr.descender;
                for (const Br in Sr.glyphs)
                  this._doesCharSupportLocalGlyph(+Br) || (kr.glyphs[+Br] = Sr.glyphs[+Br]);
                kr.ranges[Mr] = !0;
              }
              for (const Br of Er)
                Br(xr, Sr);
              delete kr.requests[Mr];
            })), Er.push((xr, Sr) => {
              xr ? wr(xr) : Sr && wr(null, { stack: er, id: fr, glyph: Sr.glyphs[fr] || null });
            });
          }, (er, fr) => {
            if (er)
              De(er);
            else if (fr) {
              const wr = {};
              for (const { stack: kr, id: cr, glyph: Mr } of fr)
                wr[kr] === void 0 && (wr[kr] = {}), wr[kr].glyphs === void 0 && (wr[kr].glyphs = {}), wr[kr].glyphs[cr] = Mr && { id: Mr.id, bitmap: Mr.bitmap.clone(), metrics: Mr.metrics }, wr[kr].ascender = this.entries[kr].ascender, wr[kr].descender = this.entries[kr].descender;
              De(null, wr);
            }
          });
        }
        _doesCharSupportLocalGlyph(de) {
          return this.localGlyphMode !== T1.none && (this.localGlyphMode === T1.all ? !!this.localFontFamily : !!this.localFontFamily && (Do["CJK Unified Ideographs"](de) || Do["Hangul Syllables"](de) || Do.Hiragana(de) || Do.Katakana(de) || Do["CJK Symbols and Punctuation"](de) || Do["CJK Unified Ideographs Extension A"](de) || Do["CJK Unified Ideographs Extension B"](de) || Do.Osage(de)));
        }
        _tinySDF(de, Ce, De) {
          const Ke = this.localFontFamily;
          if (!Ke || !this._doesCharSupportLocalGlyph(De))
            return;
          let Ve = de.tinySDF;
          if (!Ve) {
            let Br = "400";
            /bold/i.test(Ce) ? Br = "900" : /medium/i.test(Ce) ? Br = "500" : /light/i.test(Ce) && (Br = "200"), Ve = de.tinySDF = new mp.TinySDF({ fontFamily: Ke, fontWeight: Br, fontSize: 24 * eu, buffer: 3 * eu, radius: 8 * eu }), Ve.fontWeight = Br;
          }
          if (this.localGlyphs[Ve.fontWeight][De])
            return this.localGlyphs[Ve.fontWeight][De];
          const er = String.fromCodePoint(De), { data: fr, width: wr, height: kr, glyphWidth: cr, glyphHeight: Mr, glyphLeft: Er, glyphTop: xr, glyphAdvance: Sr } = Ve.draw(er);
          return this.localGlyphs[Ve.fontWeight][De] = { id: De, bitmap: new hd({ width: wr, height: kr }, fr), metrics: { width: cr / eu, height: Mr / eu, left: Er / eu, top: xr / eu - 27, advance: Sr / eu, localGlyph: !0 } };
        }
      }
      mp.loadGlyphRange = function(Ie, de, Ce, De, Ke) {
        const Ve = 256 * de, er = Ve + 255, fr = De.transformRequest(De.normalizeGlyphsURL(Ce).replace("{fontstack}", Ie).replace("{range}", `${Ve}-${er}`), Xa.Glyphs);
        wu(fr, (wr, kr) => {
          if (wr)
            Ke(wr);
          else if (kr) {
            const cr = {}, Mr = function(Er) {
              return new g0(Er).readFields(p_, {});
            }(kr);
            for (const Er of Mr.glyphs)
              cr[Er.id] = Er;
            Ke(null, { glyphs: cr, ascender: Mr.ascender, descender: Mr.descender });
          }
        });
      }, mp.TinySDF = class {
        constructor({ fontSize: Ie = 24, buffer: de = 3, radius: Ce = 8, cutoff: De = 0.25, fontFamily: Ke = "sans-serif", fontWeight: Ve = "normal", fontStyle: er = "normal" } = {}) {
          this.buffer = de, this.cutoff = De, this.radius = Ce;
          const fr = this.size = Ie + 4 * de, wr = this._createCanvas(fr), kr = this.ctx = wr.getContext("2d", { willReadFrequently: !0 });
          kr.font = `${er} ${Ve} ${Ie}px ${Ke}`, kr.textBaseline = "alphabetic", kr.textAlign = "left", kr.fillStyle = "black", this.gridOuter = new Float64Array(fr * fr), this.gridInner = new Float64Array(fr * fr), this.f = new Float64Array(fr), this.z = new Float64Array(fr + 1), this.v = new Uint16Array(fr);
        }
        _createCanvas(Ie) {
          const de = document.createElement("canvas");
          return de.width = de.height = Ie, de;
        }
        draw(Ie) {
          const { width: de, actualBoundingBoxAscent: Ce, actualBoundingBoxDescent: De, actualBoundingBoxLeft: Ke, actualBoundingBoxRight: Ve } = this.ctx.measureText(Ie), er = Math.ceil(Ce), fr = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(Ve - Ke))), wr = Math.min(this.size - this.buffer, er + Math.ceil(De)), kr = fr + 2 * this.buffer, cr = wr + 2 * this.buffer, Mr = Math.max(kr * cr, 0), Er = new Uint8ClampedArray(Mr), xr = { data: Er, width: kr, height: cr, glyphWidth: fr, glyphHeight: wr, glyphTop: er, glyphLeft: 0, glyphAdvance: de };
          if (fr === 0 || wr === 0)
            return xr;
          const { ctx: Sr, buffer: Br, gridInner: Fr, gridOuter: jr } = this;
          Sr.clearRect(Br, Br, fr, wr), Sr.fillText(Ie, Br, Br + er);
          const Qr = Sr.getImageData(Br, Br, fr, wr);
          jr.fill(Mm, 0, Mr), Fr.fill(0, 0, Mr);
          for (let ti = 0; ti < wr; ti++)
            for (let Kr = 0; Kr < fr; Kr++) {
              const ni = Qr.data[4 * (ti * fr + Kr) + 3] / 255;
              if (ni === 0)
                continue;
              const gi = (ti + Br) * kr + Kr + Br;
              if (ni === 1)
                jr[gi] = 0, Fr[gi] = Mm;
              else {
                const Si = 0.5 - ni;
                jr[gi] = Si > 0 ? Si * Si : 0, Fr[gi] = Si < 0 ? Si * Si : 0;
              }
            }
          Jg(jr, 0, 0, kr, cr, kr, this.f, this.v, this.z), Jg(Fr, Br, Br, fr, wr, kr, this.f, this.v, this.z);
          for (let ti = 0; ti < Mr; ti++) {
            const Kr = Math.sqrt(jr[ti]) - Math.sqrt(Fr[ti]);
            Er[ti] = Math.round(255 - 255 * (Kr / this.radius + this.cutoff));
          }
          return xr;
        }
      };
      const pd = xm;
      function x0(Ie, de) {
        return Ie + de[1] - de[0];
      }
      function w0(Ie, de, Ce, De, Ke = 1) {
        const Ve = [], er = Ie.imagePrimary, fr = er.pixelRatio, wr = er.paddedRect.w - 2 * pd, kr = er.paddedRect.h - 2 * pd, cr = (Ie.right - Ie.left) * Ke, Mr = (Ie.bottom - Ie.top) * Ke, Er = er.stretchX || [[0, wr]], xr = er.stretchY || [[0, kr]], Sr = Er.reduce(x0, 0), Br = xr.reduce(x0, 0), Fr = wr - Sr, jr = kr - Br;
        let Qr = 0, ti = Sr, Kr = 0, ni = Br, gi = 0, Si = Fr, Di = 0, Ri = jr;
        if (er.content && De) {
          const Ji = er.content;
          Qr = M0(Er, 0, Ji[0]), Kr = M0(xr, 0, Ji[1]), ti = M0(Er, Ji[0], Ji[2]), ni = M0(xr, Ji[1], Ji[3]), gi = Ji[0] - Qr, Di = Ji[1] - Kr, Si = Ji[2] - Ji[0] - ti, Ri = Ji[3] - Ji[1] - ni;
        }
        const Bi = (Ji, Fi, tn, cn) => {
          const ln = S0(Ji.stretch - Qr, ti, cr, Ie.left * Ke), mn = E0(Ji.fixed - gi, Si, Ji.stretch, Sr), wn = S0(Fi.stretch - Kr, ni, Mr, Ie.top * Ke), Cn = E0(Fi.fixed - Di, Ri, Fi.stretch, Br), gn = S0(tn.stretch - Qr, ti, cr, Ie.left * Ke), Nn = E0(tn.fixed - gi, Si, tn.stretch, Sr), oo = S0(cn.stretch - Kr, ni, Mr, Ie.top * Ke), Un = E0(cn.fixed - Di, Ri, cn.stretch, Br), fo = new qi(ln, wn), ho = new qi(gn, wn), bo = new qi(gn, oo), Jn = new qi(ln, oo), Ro = new qi(mn / fr, Cn / fr), po = new qi(Nn / fr, Un / fr), Lo = de * Math.PI / 180;
          if (Lo) {
            const va = Math.sin(Lo), os = Math.cos(Lo), qa = [os, -va, va, os];
            fo._matMult(qa), ho._matMult(qa), Jn._matMult(qa), bo._matMult(qa);
          }
          const jo = Ji.stretch + Ji.fixed, oa = tn.stretch + tn.fixed, ua = Fi.stretch + Fi.fixed, fa = cn.stretch + cn.fixed, ha = Ie.imageSecondary;
          return { tl: fo, tr: ho, bl: Jn, br: bo, texPrimary: { x: er.paddedRect.x + pd + jo, y: er.paddedRect.y + pd + ua, w: oa - jo, h: fa - ua }, texSecondary: ha ? { x: ha.paddedRect.x + pd + jo, y: ha.paddedRect.y + pd + ua, w: oa - jo, h: fa - ua } : void 0, writingMode: void 0, glyphOffset: [0, 0], sectionIndex: 0, pixelOffsetTL: Ro, pixelOffsetBR: po, minFontScaleX: Si / fr / cr, minFontScaleY: Ri / fr / Mr, isSDF: Ce };
        };
        if (De && (er.stretchX || er.stretchY)) {
          const Ji = ev(Er, Fr, Sr), Fi = ev(xr, jr, Br);
          for (let tn = 0; tn < Ji.length - 1; tn++) {
            const cn = Ji[tn], ln = Ji[tn + 1];
            for (let mn = 0; mn < Fi.length - 1; mn++)
              Ve.push(Bi(cn, Fi[mn], ln, Fi[mn + 1]));
          }
        } else
          Ve.push(Bi({ fixed: 0, stretch: -1 }, { fixed: 0, stretch: -1 }, { fixed: 0, stretch: wr + 1 }, { fixed: 0, stretch: kr + 1 }));
        return Ve;
      }
      function M0(Ie, de, Ce) {
        let De = 0;
        for (const Ke of Ie)
          De += Math.max(de, Math.min(Ce, Ke[1])) - Math.max(de, Math.min(Ce, Ke[0]));
        return De;
      }
      function ev(Ie, de, Ce) {
        const De = [{ fixed: -pd, stretch: 0 }];
        for (const [Ke, Ve] of Ie) {
          const er = De[De.length - 1];
          De.push({ fixed: Ke - er.stretch, stretch: er.stretch }), De.push({ fixed: Ke - er.stretch, stretch: er.stretch + (Ve - Ke) });
        }
        return De.push({ fixed: de + pd, stretch: Ce }), De;
      }
      function S0(Ie, de, Ce, De) {
        return Ie / de * Ce + De;
      }
      function E0(Ie, de, Ce, De) {
        return Ie - de * Ce / De;
      }
      function x_(Ie, de, Ce, De) {
        const Ke = de + Ie.positionedLines[De].lineOffset;
        return De === 0 ? Ce + Ke / 2 : Ce + (Ke + (de + Ie.positionedLines[De - 1].lineOffset)) / 2;
      }
      function w_(Ie, de = 1, Ce = !1) {
        let De = 1 / 0, Ke = 1 / 0, Ve = -1 / 0, er = -1 / 0;
        const fr = Ie[0];
        for (let xr = 0; xr < fr.length; xr++) {
          const Sr = fr[xr];
          (!xr || Sr.x < De) && (De = Sr.x), (!xr || Sr.y < Ke) && (Ke = Sr.y), (!xr || Sr.x > Ve) && (Ve = Sr.x), (!xr || Sr.y > er) && (er = Sr.y);
        }
        const wr = Math.min(Ve - De, er - Ke);
        let kr = wr / 2;
        const cr = new ou([], M_);
        if (wr === 0)
          return new qi(De, Ke);
        for (let xr = De; xr < Ve; xr += wr)
          for (let Sr = Ke; Sr < er; Sr += wr)
            cr.push(new gp(xr + kr, Sr + kr, kr, Ie));
        let Mr = function(xr) {
          let Sr = 0, Br = 0, Fr = 0;
          const jr = xr[0];
          for (let Qr = 0, ti = jr.length, Kr = ti - 1; Qr < ti; Kr = Qr++) {
            const ni = jr[Qr], gi = jr[Kr], Si = ni.x * gi.y - gi.x * ni.y;
            Br += (ni.x + gi.x) * Si, Fr += (ni.y + gi.y) * Si, Sr += 3 * Si;
          }
          return new gp(Br / Sr, Fr / Sr, 0, xr);
        }(Ie), Er = cr.length;
        for (; cr.length; ) {
          const xr = cr.pop();
          (xr.d > Mr.d || !Mr.d) && (Mr = xr, Ce && console.log("found best %d after %d probes", Math.round(1e4 * xr.d) / 1e4, Er)), xr.max - Mr.d <= de || (kr = xr.h / 2, cr.push(new gp(xr.p.x - kr, xr.p.y - kr, kr, Ie)), cr.push(new gp(xr.p.x + kr, xr.p.y - kr, kr, Ie)), cr.push(new gp(xr.p.x - kr, xr.p.y + kr, kr, Ie)), cr.push(new gp(xr.p.x + kr, xr.p.y + kr, kr, Ie)), Er += 4);
        }
        return Ce && (console.log(`num probes: ${Er}`), console.log(`best distance: ${Mr.d}`)), Mr.p;
      }
      function M_(Ie, de) {
        return de.max - Ie.max;
      }
      class gp {
        constructor(de, Ce, De, Ke) {
          this.p = new qi(de, Ce), this.h = De, this.d = function(Ve, er) {
            let fr = !1, wr = 1 / 0;
            for (let kr = 0; kr < er.length; kr++) {
              const cr = er[kr];
              for (let Mr = 0, Er = cr.length, xr = Er - 1; Mr < Er; xr = Mr++) {
                const Sr = cr[Mr], Br = cr[xr];
                Sr.y > Ve.y != Br.y > Ve.y && Ve.x < (Br.x - Sr.x) * (Ve.y - Sr.y) / (Br.y - Sr.y) + Sr.x && (fr = !fr), wr = Math.min(wr, Gi(Ve, Sr, Br));
              }
            }
            return (fr ? 1 : -1) * Math.sqrt(wr);
          }(this.p, Ke), this.max = this.d + this.h * Math.SQRT2;
        }
      }
      const A1 = Number.POSITIVE_INFINITY, S_ = Math.sqrt(2);
      function tv(Ie, [de, Ce]) {
        let De = 0, Ke = 0;
        if (Ce === A1) {
          de < 0 && (de = 0);
          const Ve = de / S_;
          switch (Ie) {
            case "top-right":
            case "top-left":
              Ke = Ve - 7;
              break;
            case "bottom-right":
            case "bottom-left":
              Ke = 7 - Ve;
              break;
            case "bottom":
              Ke = 7 - de;
              break;
            case "top":
              Ke = de - 7;
          }
          switch (Ie) {
            case "top-right":
            case "bottom-right":
              De = -Ve;
              break;
            case "top-left":
            case "bottom-left":
              De = Ve;
              break;
            case "left":
              De = de;
              break;
            case "right":
              De = -de;
          }
        } else {
          switch (de = Math.abs(de), Ce = Math.abs(Ce), Ie) {
            case "top-right":
            case "top-left":
            case "top":
              Ke = Ce - 7;
              break;
            case "bottom-right":
            case "bottom-left":
            case "bottom":
              Ke = 7 - Ce;
          }
          switch (Ie) {
            case "top-right":
            case "bottom-right":
            case "right":
              De = -de;
              break;
            case "top-left":
            case "bottom-left":
            case "left":
              De = de;
          }
        }
        return [De, Ke];
      }
      function k1(Ie) {
        switch (Ie) {
          case "right":
          case "top-right":
          case "bottom-right":
            return "right";
          case "left":
          case "top-left":
          case "bottom-left":
            return "left";
        }
        return "center";
      }
      function E_(Ie, de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr, Br) {
        let Fr = Ve.textMaxSize.evaluate(de, {}, Er);
        Fr === void 0 ? Fr = er * Ve.textScaleFactor : Fr *= Ve.textScaleFactor;
        const jr = Ie.layers[0].layout, Qr = jr.get("icon-offset").evaluate(de, {}, Er), ti = iv(Ce.horizontal) || Ce.vertical, Kr = xr.name === "globe", ni = _l, gi = er * Ve.textScaleFactor / ni, Si = Ie.tilePixelRatio * Fr / ni, Di = (mn = Ie.overscaling, Ie.zoom > 18 && mn > 2 && (mn >>= 1), Math.max(vo / (512 * mn), 1) * jr.get("symbol-spacing")), Ri = jr.get("text-padding") * Ie.tilePixelRatio, Bi = jr.get("icon-padding") * Ie.tilePixelRatio, Ji = rn(jr.get("text-max-angle")), Fi = jr.get("text-rotation-alignment") === "map" && jr.get("symbol-placement") !== "point", tn = jr.get("icon-rotation-alignment") === "map" && jr.get("symbol-placement") !== "point", cn = jr.get("symbol-placement"), ln = Di / 2;
        var mn;
        const wn = jr.get("icon-text-fit").evaluate(de, {}, Er), Cn = jr.get("icon-text-fit-padding").evaluate(de, {}, Er), gn = wn !== "none";
        let Nn;
        Ie.hasAnyIconTextFit === !1 && gn && (Ie.hasAnyIconTextFit = !0), De && gn && (Ie.allowVerticalPlacement && Ce.vertical && (Nn = _0(De, Ce.vertical, wn, Cn, Qr, gi)), ti && (De = _0(De, ti, wn, Cn, Qr, gi)));
        const oo = (Un, fo, ho) => {
          if (fo.x < 0 || fo.x >= vo || fo.y < 0 || fo.y >= vo)
            return;
          let bo = null;
          if (Kr) {
            const { x: Jn, y: Ro, z: po } = xr.projectTilePoint(fo.x, fo.y, ho);
            bo = { anchor: new Sh(Jn, Ro, po, 0, void 0), up: xr.upVector(ho, fo.x, fo.y) };
          }
          (function(Jn, Ro, po, Lo, jo, oa, ua, fa, ha, va, os, qa, ra, Ga, ja, as, Gs, Hs, Is, Mc, gs, ws, cc, Ws, zc, nl, gd, yp) {
            const bp = Jn.addToLineVertexArray(Ro, Lo);
            let _f, xp, wp, Tv, Oy, zy, Fy, Ny = 0, Vy = 0, Uy = 0, jy = 0, a2 = -1, s2 = -1;
            const vd = {};
            let qy = qu("");
            const Lm = po ? po.anchor : Ro, l2 = ha.layout.get("icon-text-fit").evaluate(gs, {}, nl) !== "none";
            let c2 = 0, u2 = 0;
            if (ha._unevaluatedLayout.getValue("text-radial-offset") === void 0 ? [c2, u2] = ha.layout.get("text-offset").evaluate(gs, {}, nl).map((xu) => xu * _l) : (c2 = ha.layout.get("text-radial-offset").evaluate(gs, {}, nl) * _l, u2 = A1), Jn.allowVerticalPlacement && jo.vertical) {
              const xu = jo.vertical;
              if (ja)
                zy = L1(xu), fa && (Fy = L1(fa));
              else {
                const tu = ha.layout.get("text-rotate").evaluate(gs, {}, nl) + 90;
                wp = C0(va, Lm, Ro, os, qa, ra, xu, Ga, tu, as), fa && (Tv = C0(va, Lm, Ro, os, qa, ra, fa, Hs, tu));
              }
            }
            if (oa) {
              const xu = Jn.iconSizeData, tu = Ws ? m0(Jn.iconSizeData, Jn.layers[0]._unevaluatedLayout._values["icon-size"], nl, Jn.zoom, gs) : 1, D0 = ha.layout.get("icon-rotate").evaluate(gs, {}, nl), Gy = w0(oa, D0, cc, l2, Ws ? 1 / tu : ws.iconScaleFactor), d2 = fa ? w0(fa, D0, cc, l2, ws.iconScaleFactor) : void 0;
              xp = C0(va, Lm, Ro, os, qa, ra, oa, Hs, D0, null, Ws ? ws.iconScaleFactor * tu : 1), Ny = 4 * Gy.length;
              let Im = null;
              xu.kind === "source" ? (Im = [_u * ha.layout.get("icon-size").evaluate(gs, {}, nl) * ws.iconScaleFactor], Im[0] > md && Mn(`${Jn.layerIds[0]}: Value for "icon-size" is >= ${Sm}. Reduce your "icon-size".`)) : xu.kind === "composite" && (Im = [_u * ws.compositeIconSizes[0].evaluate(gs, {}, nl) * ws.iconScaleFactor, _u * ws.compositeIconSizes[1].evaluate(gs, {}, nl) * ws.iconScaleFactor], (Im[0] > md || Im[1] > md) && Mn(`${Jn.layerIds[0]}: Value for "icon-size" is >= ${Sm}. Reduce your "icon-size".`)), Jn.addSymbols(Jn.icon, Gy, Im, Mc, Is, gs, !1, po, Ro, bp.lineStartIndex, bp.lineLength, -1, zc, nl, gd, yp), a2 = Jn.icon.placedSymbolArray.length - 1, d2 && (Vy = 4 * d2.length, Jn.addSymbols(Jn.icon, d2, Im, Mc, Is, gs, Pc.vertical, po, Ro, bp.lineStartIndex, bp.lineLength, -1, zc, nl, gd, yp), s2 = Jn.icon.placedSymbolArray.length - 1);
            }
            for (const xu in jo.horizontal) {
              const tu = jo.horizontal[xu];
              _f || (qy = qu(tu.text), ja ? Oy = L1(tu) : _f = C0(va, Lm, Ro, os, qa, ra, tu, Ga, ha.layout.get("text-rotate").evaluate(gs, {}, nl), as));
              const D0 = tu.positionedLines.length === 1;
              if (Uy += rv(Jn, po, Ro, tu, ua, ha, ja, gs, as, bp, jo.vertical ? Pc.horizontal : Pc.horizontalOnly, D0 ? Object.keys(jo.horizontal) : [xu], vd, a2, ws, zc, nl, gd), D0)
                break;
            }
            jo.vertical && (jy += rv(Jn, po, Ro, jo.vertical, ua, ha, ja, gs, as, bp, Pc.vertical, ["vertical"], vd, s2, ws, zc, nl, gd));
            let Mp = -1;
            const h2 = (xu, tu) => xu ? Math.max(xu, tu) : tu;
            Mp = h2(Oy, Mp), Mp = h2(zy, Mp), Mp = h2(Fy, Mp);
            const px = Mp > -1 ? 1 : 0;
            Jn.glyphOffsetArray.length >= 65535 && Mn("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), gs.sortKey !== void 0 && Jn.addToSortKeyRanges(Jn.symbolInstances.length, gs.sortKey), Jn.symbolInstances.emplaceBack(Ro.x, Ro.y, Lm.x, Lm.y, Lm.z, vd.right >= 0 ? vd.right : -1, vd.center >= 0 ? vd.center : -1, vd.left >= 0 ? vd.left : -1, vd.vertical >= 0 ? vd.vertical : -1, a2, s2, qy, _f !== void 0 ? _f : Jn.collisionBoxArray.length, _f !== void 0 ? _f + 1 : Jn.collisionBoxArray.length, wp !== void 0 ? wp : Jn.collisionBoxArray.length, wp !== void 0 ? wp + 1 : Jn.collisionBoxArray.length, xp !== void 0 ? xp : Jn.collisionBoxArray.length, xp !== void 0 ? xp + 1 : Jn.collisionBoxArray.length, Tv || Jn.collisionBoxArray.length, Tv ? Tv + 1 : Jn.collisionBoxArray.length, os, Uy, jy, Ny, Vy, px, 0, c2, u2, Mp, 0, l2 ? 1 : 0);
          })(Ie, fo, bo, Un, Ce, De, Ke, Nn, Ie.layers[0], Ie.collisionBoxArray, de.index, de.sourceLayerIndex, Ie.index, Ri, Fi, wr, 0, Bi, tn, Qr, de, Ve, kr, cr, Mr, Er, Sr, Br);
        };
        if (cn === "line")
          for (const Un of Kg(de.geometry, 0, 0, vo, vo)) {
            const fo = b_(Un, Di, Ji, Ce.vertical || ti, De, ni, Si, Ie.overscaling, vo);
            for (const ho of fo)
              ti && C_(Ie, ti.text, ln, ho) || oo(Un, ho, Er);
          }
        else if (cn === "line-center") {
          for (const Un of de.geometry)
            if (Un.length > 1) {
              const fo = y_(Un, Ji, Ce.vertical || ti, De, ni, Si);
              fo && oo(Un, fo, Er);
            }
        } else if (de.type === "Polygon")
          for (const Un of cm(de.geometry, 0)) {
            const fo = w_(Un, 16);
            oo(Un[0], new Sh(fo.x, fo.y, 0, 0, void 0), Er);
          }
        else if (de.type === "LineString")
          for (const Un of de.geometry)
            oo(Un, new Sh(Un[0].x, Un[0].y, 0, 0, void 0), Er);
        else if (de.type === "Point")
          for (const Un of de.geometry)
            for (const fo of Un)
              oo([fo], new Sh(fo.x, fo.y, 0, 0, void 0), Er);
      }
      const Sm = 255, md = Sm * _u;
      function rv(Ie, de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr, Br, Fr, jr) {
        const Qr = function(ni, gi, Si, Di, Ri, Bi, Ji, Fi) {
          const tn = [];
          if (gi.positionedLines.length === 0)
            return tn;
          const cn = Di.layout.get("text-rotate").evaluate(Bi, {}) * Math.PI / 180, ln = function(Nn) {
            const oo = Nn[0], Un = Nn[1], fo = oo * Un;
            return fo > 0 ? [oo, -Un] : fo < 0 ? [-oo, Un] : oo === 0 ? [Un, oo] : [Un, -oo];
          }(Si);
          let mn = Math.abs(gi.top - gi.bottom);
          for (const Nn of gi.positionedLines)
            mn -= Nn.lineOffset;
          const wn = gi.positionedLines.length, Cn = mn / wn;
          let gn = gi.top - Si[1];
          for (let Nn = 0; Nn < wn; ++Nn) {
            const oo = gi.positionedLines[Nn];
            gn = x_(gi, Cn, gn, Nn);
            for (const Un of oo.positionedGlyphs) {
              if (!Un.rect)
                continue;
              const fo = Un.rect || {};
              let ho = jg + 1, bo = !0, Jn = 1, Ro = 0;
              if (Un.imageName) {
                const Is = Ji[Ps.build(Un.imageName).getSerializedPrimary()];
                if (!Is)
                  continue;
                if (Is.sdf) {
                  Mn("SDF images are not supported in formatted text and will be ignored.");
                  continue;
                }
                bo = !1, Jn = Is.pixelRatio, ho = xm / Jn;
              }
              const po = (Ri || Fi) && Un.vertical, Lo = Un.metrics.advance * Un.scale / 2, jo = Un.metrics, oa = Un.rect;
              if (oa === null)
                continue;
              Fi && gi.verticalizable && (Ro = Un.imageName ? Lo - Un.metrics.width * Un.scale / 2 : 0);
              const ua = Ri ? [Un.x + Lo, Un.y] : [0, 0];
              let fa = [0, 0], ha = [0, 0], va = !1;
              Ri || (po ? (ha = [Un.x + Lo + ln[0], Un.y + ln[1] - Ro], va = !0) : fa = [Un.x + Lo + Si[0], Un.y + Si[1] - Ro]);
              const os = oa.w * Un.scale / (Jn * (Un.localGlyph ? eu : 1)), qa = oa.h * Un.scale / (Jn * (Un.localGlyph ? eu : 1));
              let ra, Ga, ja, as;
              if (po) {
                const Is = Un.y - gn, Mc = new qi(-Lo, Lo - Is), gs = -Math.PI / 2, ws = new qi(...ha);
                ra = new qi(-Lo + fa[0], fa[1]), ra._rotateAround(gs, Mc)._add(ws), ra.x += -Is + Lo, ra.y -= (jo.left - ho) * Un.scale;
                const cc = Un.imageName ? jo.advance * Un.scale : _l * Un.scale, Ws = String.fromCodePoint(Un.glyph);
                h_(Ws) ? ra.x += (1 - ho) * Un.scale : d_(Ws) ? ra.x += cc - jo.height * Un.scale + (-ho - 1) * Un.scale : ra.x += Un.imageName || jo.width + 2 * ho === oa.w && jo.height + 2 * ho === oa.h ? (cc - qa) / 2 : (cc - (jo.height + 2 * ho) * Un.scale) / 2, Ga = new qi(ra.x, ra.y - os), ja = new qi(ra.x + qa, ra.y), as = new qi(ra.x + qa, ra.y - os);
              } else {
                const Is = (jo.left - ho) * Un.scale - Lo + fa[0], Mc = (-jo.top - ho) * Un.scale + fa[1], gs = Is + os, ws = Mc + qa;
                ra = new qi(Is, Mc), Ga = new qi(gs, Mc), ja = new qi(Is, ws), as = new qi(gs, ws);
              }
              if (cn) {
                let Is;
                Is = Ri ? new qi(0, 0) : va ? new qi(ln[0], ln[1]) : new qi(Si[0], Si[1]), ra._rotateAround(cn, Is), Ga._rotateAround(cn, Is), ja._rotateAround(cn, Is), as._rotateAround(cn, Is);
              }
              const Gs = new qi(0, 0), Hs = new qi(0, 0);
              tn.push({ tl: ra, tr: Ga, bl: ja, br: as, texPrimary: fo, texSecondary: void 0, writingMode: gi.writingMode, glyphOffset: ua, sectionIndex: Un.sectionIndex, isSDF: bo, pixelOffsetTL: Gs, pixelOffsetBR: Hs, minFontScaleX: 0, minFontScaleY: 0 });
            }
          }
          return tn;
        }(0, De, wr, Ve, er, fr, Ke, Ie.allowVerticalPlacement), ti = Ie.textSizeData;
        let Kr = null;
        ti.kind === "source" ? (Kr = [_u * Ve.layout.get("text-size").evaluate(fr, {}, Fr) * Sr.textScaleFactor], Kr[0] > md && Mn(`${Ie.layerIds[0]}: Value for "text-size" is >= ${Sm}. Reduce your "text-size".`)) : ti.kind === "composite" && (Kr = [_u * Sr.compositeTextSizes[0].evaluate(fr, {}, Fr) * Sr.textScaleFactor, _u * Sr.compositeTextSizes[1].evaluate(fr, {}, Fr) * Sr.textScaleFactor], (Kr[0] > md || Kr[1] > md) && Mn(`${Ie.layerIds[0]}: Value for "text-size" is >= ${Sm}. Reduce your "text-size".`)), Ie.addSymbols(Ie.text, Qr, Kr, wr, er, fr, cr, de, Ce, kr.lineStartIndex, kr.lineLength, xr, Br, Fr, jr, !1);
        for (const ni of Mr)
          Er[ni] = Ie.text.placedSymbolArray.length - 1;
        return 4 * Qr.length;
      }
      function iv(Ie) {
        for (const de in Ie)
          return Ie[de];
        return null;
      }
      function C0(Ie, de, Ce, De, Ke, Ve, er, fr, wr, kr, cr = 1) {
        let Mr = er.top / cr, Er = er.bottom / cr, xr = er.left / cr, Sr = er.right / cr;
        const Br = er.collisionPadding;
        if (Br && (xr -= Br[0], Mr -= Br[1], Sr += Br[2], Er += Br[3]), wr) {
          const Fr = new qi(xr, Mr), jr = new qi(Sr, Mr), Qr = new qi(xr, Er), ti = new qi(Sr, Er), Kr = rn(wr);
          let ni = new qi(0, 0);
          kr && (ni = new qi(kr[0], kr[1])), Fr._rotateAround(Kr, ni), jr._rotateAround(Kr, ni), Qr._rotateAround(Kr, ni), ti._rotateAround(Kr, ni), xr = Math.min(Fr.x, jr.x, Qr.x, ti.x), Sr = Math.max(Fr.x, jr.x, Qr.x, ti.x), Mr = Math.min(Fr.y, jr.y, Qr.y, ti.y), Er = Math.max(Fr.y, jr.y, Qr.y, ti.y);
        }
        return Ie.emplaceBack(de.x, de.y, de.z, Ce.x, Ce.y, xr, Mr, Sr, Er, fr, De, Ke, Ve), Ie.length - 1;
      }
      function L1(Ie) {
        Ie.collisionPadding && (Ie.top -= Ie.collisionPadding[1], Ie.bottom += Ie.collisionPadding[3]);
        const de = Ie.bottom - Ie.top;
        return de > 0 ? Math.max(10, de) : null;
      }
      function C_(Ie, de, Ce, De) {
        const Ke = Ie.compareText;
        if (de in Ke) {
          const Ve = Ke[de];
          for (let er = Ve.length - 1; er >= 0; er--)
            if (De.dist(Ve[er]) < Ce)
              return !0;
        } else
          Ke[de] = [];
        return Ke[de].push(De), !1;
      }
      function nv(Ie, de) {
        const Ce = Ie.fovAboveCenter, De = Ie.elevation ? Ie.elevation.getMinElevationBelowMSL() * de : 0, Ke = (Ie._camera.position[2] * Ie.worldSize - De) / Math.cos(Ie._pitch), Ve = Math.sin(Ce) * Ke / Math.sin(Math.max(Math.PI / 2 - Ie._pitch - Ce, 0.01));
        let er = Math.sin(Ie._pitch) * Ve + Ke;
        const fr = Ke * (1 / Ie._horizonShift);
        return Ie.elevation && Ie.elevation.exaggeration() !== 0 || (er *= 1 + Math.max(Ie.zoom - 17, 0)), Math.min(1.01 * er, fr);
      }
      function dr(Ie, de) {
        if (!de.isReprojectedInTileSpace)
          return { scale: 1 << Ie.z, x: Ie.x, y: Ie.y, x2: Ie.x + 1, y2: Ie.y + 1, projection: de };
        const Ce = Math.pow(2, -Ie.z), De = Ie.x * Ce, Ke = (Ie.x + 1) * Ce, Ve = Ie.y * Ce, er = (Ie.y + 1) * Ce, fr = bs(De), wr = bs(Ke), kr = Fs(Ve), cr = Fs(er), Mr = de.project(fr, kr), Er = de.project(wr, kr), xr = de.project(wr, cr), Sr = de.project(fr, cr);
        let Br = Math.min(Mr.x, Er.x, xr.x, Sr.x), Fr = Math.min(Mr.y, Er.y, xr.y, Sr.y), jr = Math.max(Mr.x, Er.x, xr.x, Sr.x), Qr = Math.max(Mr.y, Er.y, xr.y, Sr.y);
        const ti = Ce / 16;
        function Kr(gi, Si, Di, Ri, Bi, Ji) {
          const Fi = (Di + Bi) / 2, tn = (Ri + Ji) / 2, cn = de.project(bs(Fi), Fs(tn)), ln = Math.max(0, Br - cn.x, Fr - cn.y, cn.x - jr, cn.y - Qr);
          Br = Math.min(Br, cn.x), jr = Math.max(jr, cn.x), Fr = Math.min(Fr, cn.y), Qr = Math.max(Qr, cn.y), ln > ti && (Kr(gi, cn, Di, Ri, Fi, tn), Kr(cn, Si, Fi, tn, Bi, Ji));
        }
        Kr(Mr, Er, De, Ve, Ke, Ve), Kr(Er, xr, Ke, Ve, Ke, er), Kr(xr, Sr, Ke, er, De, er), Kr(Sr, Mr, De, er, De, Ve), Br -= ti, Fr -= ti, jr += ti, Qr += ti;
        const ni = 1 / Math.max(jr - Br, Qr - Fr);
        return { scale: ni, x: Br * ni, y: Fr * ni, x2: jr * ni, y2: Qr * ni, projection: de };
      }
      function Cr(Ie, { x: de, y: Ce }, De = 0) {
        return new qi(((de - De) * Ie.scale - Ie.x) * vo, (Ce * Ie.scale - Ie.y) * vo);
      }
      const Ur = Zr.mat4.identity(new Float32Array(16));
      class ui {
        constructor(de) {
          this.spec = de, this.name = de.name, this.wrap = !1, this.requiresDraping = !1, this.supportsWorldCopies = !1, this.supportsTerrain = !1, this.supportsFog = !1, this.supportsFreeCamera = !1, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = !0, this.unsupportedLayers = ["custom"], this.center = [0, 0], this.range = [3.5, 7];
        }
        project(de, Ce) {
          return { x: 0, y: 0, z: 0 };
        }
        unproject(de, Ce) {
          return new Ba(0, 0);
        }
        projectTilePoint(de, Ce, De) {
          return { x: de, y: Ce, z: 0 };
        }
        locationPoint(de, Ce, De = !0) {
          return de._coordinatePoint(de.locationCoordinate(Ce), De);
        }
        pixelsPerMeter(de, Ce) {
          return As(1, de) * Ce;
        }
        pixelSpaceConversion(de, Ce, De) {
          return 1;
        }
        farthestPixelDistance(de) {
          return nv(de, de.pixelsPerMeter);
        }
        pointCoordinate(de, Ce, De, Ke) {
          const Ve = de.horizonLineFromTop(!1), er = new qi(Ce, Math.max(Ve, De));
          return de.rayIntersectionCoordinate(de.pointRayIntersection(er, Ke));
        }
        pointCoordinate3D(de, Ce, De) {
          const Ke = new qi(Ce, De);
          if (de.elevation)
            return de.elevation.pointCoordinate(Ke);
          {
            const Ve = this.pointCoordinate(de, Ke.x, Ke.y, 0);
            return [Ve.x, Ve.y, Ve.z];
          }
        }
        isPointAboveHorizon(de, Ce) {
          if (de.elevation && de.elevation.visibleDemTiles.length)
            return !this.pointCoordinate3D(de, Ce.x, Ce.y);
          const De = de.horizonLineFromTop();
          return Ce.y < De;
        }
        createInversionMatrix(de, Ce) {
          return Ur;
        }
        createTileMatrix(de, Ce, De) {
          let Ke, Ve, er;
          const fr = De.canonical, wr = Zr.mat4.identity(new Float64Array(16));
          if (this.isReprojectedInTileSpace) {
            const kr = dr(fr, this);
            Ke = 1, Ve = kr.x + De.wrap * kr.scale, er = kr.y, Zr.mat4.scale(wr, wr, [Ke / kr.scale, Ke / kr.scale, de.pixelsPerMeter / Ce]);
          } else
            Ke = Ce / de.zoomScale(fr.z), Ve = (fr.x + Math.pow(2, fr.z) * De.wrap) * Ke, er = fr.y * Ke;
          return Zr.mat4.translate(wr, wr, [Ve, er, 0]), Zr.mat4.scale(wr, wr, [Ke / vo, Ke / vo, 1]), wr;
        }
        upVector(de, Ce, De) {
          return [0, 0, 1];
        }
        upVectorScale(de, Ce, De) {
          return { metersToTile: 1 };
        }
      }
      class $i extends ui {
        constructor(de) {
          super(de), this.range = [4, 7], this.center = de.center || [-96, 37.5];
          const [Ce, De] = this.parallels = de.parallels || [29.5, 45.5], Ke = Math.sin(rn(Ce));
          this.n = (Ke + Math.sin(rn(De))) / 2, this.c = 1 + Ke * (2 * this.n - Ke), this.r0 = Math.sqrt(this.c) / this.n;
        }
        project(de, Ce) {
          const { n: De, c: Ke, r0: Ve } = this, er = rn(de - this.center[0]), fr = rn(Ce), wr = Math.sqrt(Ke - 2 * De * Math.sin(fr)) / De;
          return { x: wr * Math.sin(er * De), y: wr * Math.cos(er * De) - Ve, z: 0 };
        }
        unproject(de, Ce) {
          const { n: De, c: Ke, r0: Ve } = this, er = Ve + Ce;
          let fr = Math.atan2(de, Math.abs(er)) * Math.sign(er);
          er * De < 0 && (fr -= Math.PI * Math.sign(de) * Math.sign(er));
          const wr = rn(this.center[0]) * De;
          fr = Xo(fr, -Math.PI - wr, Math.PI - wr);
          const kr = vn(ji(fr / De) + this.center[0], -180, 180), cr = Math.asin(vn((Ke - (de * de + er * er) * De * De) / (2 * De), -1, 1)), Mr = vn(ji(cr), -Es, Es);
          return new Ba(kr, Mr);
        }
      }
      const Qi = 1.340264, En = -0.081106, Dn = 893e-6, Zn = 3796e-6, wo = Math.sqrt(3) / 2;
      class So extends ui {
        project(de, Ce) {
          Ce = Ce / 180 * Math.PI, de = de / 180 * Math.PI;
          const De = Math.asin(wo * Math.sin(Ce)), Ke = De * De, Ve = Ke * Ke * Ke;
          return { x: 0.5 * (de * Math.cos(De) / (wo * (Qi + 3 * En * Ke + Ve * (7 * Dn + 9 * Zn * Ke))) / Math.PI + 0.5), y: 1 - 0.5 * (De * (Qi + En * Ke + Ve * (Dn + Zn * Ke)) / Math.PI + 1), z: 0 };
        }
        unproject(de, Ce) {
          de = (2 * de - 0.5) * Math.PI;
          let De = Ce = (2 * (1 - Ce) - 1) * Math.PI, Ke = De * De, Ve = Ke * Ke * Ke;
          for (let cr, Mr, Er, xr = 0; xr < 12 && (Mr = De * (Qi + En * Ke + Ve * (Dn + Zn * Ke)) - Ce, Er = Qi + 3 * En * Ke + Ve * (7 * Dn + 9 * Zn * Ke), cr = Mr / Er, De = vn(De - cr, -Math.PI / 3, Math.PI / 3), Ke = De * De, Ve = Ke * Ke * Ke, !(Math.abs(cr) < 1e-12)); ++xr)
            ;
          const er = wo * de * (Qi + 3 * En * Ke + Ve * (7 * Dn + 9 * Zn * Ke)) / Math.cos(De), fr = Math.asin(Math.sin(De) / wo), wr = vn(180 * er / Math.PI, -180, 180), kr = vn(180 * fr / Math.PI, -Es, Es);
          return new Ba(wr, kr);
        }
      }
      class ko extends ui {
        constructor(de) {
          super(de), this.wrap = !0, this.supportsWorldCopies = !0;
        }
        project(de, Ce) {
          return { x: 0.5 + de / 360, y: 0.5 - Ce / 360, z: 0 };
        }
        unproject(de, Ce) {
          const De = 360 * (de - 0.5), Ke = vn(360 * (0.5 - Ce), -Es, Es);
          return new Ba(De, Ke);
        }
      }
      const Vo = Math.PI / 2;
      function na(Ie) {
        return Math.tan((Vo + Ie) / 2);
      }
      class Sa extends ui {
        constructor(de) {
          super(de), this.center = de.center || [0, 30];
          const [Ce, De] = this.parallels = de.parallels || [30, 30];
          let Ke = rn(Ce), Ve = rn(De);
          this.southernCenter = Ke + Ve < 0, this.southernCenter && (Ke = -Ke, Ve = -Ve);
          const er = Math.cos(Ke), fr = na(Ke);
          this.n = Ke === Ve ? Math.sin(Ke) : Math.log(er / Math.cos(Ve)) / Math.log(na(Ve) / fr), this.f = er * Math.pow(na(Ke), this.n) / this.n;
        }
        project(de, Ce) {
          Ce = rn(Ce), this.southernCenter && (Ce = -Ce), de = rn(de - this.center[0]);
          const De = 1e-6, { n: Ke, f: Ve } = this;
          Ve > 0 ? Ce < -Vo + De && (Ce = -Vo + De) : Ce > Vo - De && (Ce = Vo - De);
          const er = Ve / Math.pow(na(Ce), Ke);
          let fr = er * Math.sin(Ke * de), wr = Ve - er * Math.cos(Ke * de);
          return fr = 0.5 * (fr / Math.PI + 0.5), wr = 0.5 * (wr / Math.PI + 0.5), { x: fr, y: this.southernCenter ? wr : 1 - wr, z: 0 };
        }
        unproject(de, Ce) {
          de = (2 * de - 0.5) * Math.PI, this.southernCenter && (Ce = 1 - Ce), Ce = (2 * (1 - Ce) - 0.5) * Math.PI;
          const { n: De, f: Ke } = this, Ve = Ke - Ce, er = Math.sign(Ve), fr = Math.sign(De) * Math.sqrt(de * de + Ve * Ve);
          let wr = Math.atan2(de, Math.abs(Ve)) * er;
          Ve * De < 0 && (wr -= Math.PI * Math.sign(de) * er);
          const kr = vn(ji(wr / De) + this.center[0], -180, 180), cr = vn(ji(2 * Math.atan(Math.pow(Ke / fr, 1 / De)) - Vo), -Es, Es);
          return new Ba(kr, this.southernCenter ? -cr : cr);
        }
      }
      class Ua extends ui {
        constructor(de) {
          super(de), this.wrap = !0, this.supportsWorldCopies = !0, this.supportsTerrain = !0, this.supportsFog = !0, this.supportsFreeCamera = !0, this.isReprojectedInTileSpace = !1, this.unsupportedLayers = [], this.range = null;
        }
        project(de, Ce) {
          return { x: Fu(de), y: gu(Ce), z: 0 };
        }
        unproject(de, Ce) {
          const De = bs(de), Ke = Fs(Ce);
          return new Ba(De, Ke);
        }
      }
      const ya = rn(Es);
      class Qa extends ui {
        project(de, Ce) {
          const De = (Ce = rn(Ce)) * Ce, Ke = De * De;
          return { x: 0.5 * ((de = rn(de)) * (0.8707 - 0.131979 * De + Ke * (Ke * (3971e-6 * De - 1529e-6 * Ke) - 0.013791)) / Math.PI + 0.5), y: 1 - 0.5 * (Ce * (1.007226 + De * (0.015085 + Ke * (0.028874 * De - 0.044475 - 5916e-6 * Ke))) / Math.PI + 1), z: 0 };
        }
        unproject(de, Ce) {
          de = (2 * de - 0.5) * Math.PI;
          let De = Ce = (2 * (1 - Ce) - 1) * Math.PI, Ke = 25, Ve = 0, er = De * De;
          do {
            er = De * De;
            const kr = er * er;
            Ve = (De * (1.007226 + er * (0.015085 + kr * (0.028874 * er - 0.044475 - 5916e-6 * kr))) - Ce) / (1.007226 + er * (0.045255 + kr * (0.259866 * er - 0.311325 - 5916e-6 * 11 * kr))), De = vn(De - Ve, -ya, ya);
          } while (Math.abs(Ve) > 1e-6 && --Ke > 0);
          er = De * De;
          const fr = vn(ji(de / (0.8707 + er * (er * (er * er * er * (3971e-6 - 1529e-6 * er) - 0.013791) - 0.131979))), -180, 180), wr = ji(De);
          return new Ba(fr, wr);
        }
      }
      const ns = rn(Es);
      class Dc extends ui {
        project(de, Ce) {
          Ce = rn(Ce), de = rn(de);
          const De = Math.cos(Ce), Ke = 2 / Math.PI, Ve = Math.acos(De * Math.cos(de / 2)), er = Math.sin(Ve) / Ve, fr = 0.5 * (de * Ke + 2 * De * Math.sin(de / 2) / er) || 0, wr = 0.5 * (Ce + Math.sin(Ce) / er) || 0;
          return { x: 0.5 * (fr / Math.PI + 0.5), y: 1 - 0.5 * (wr / Math.PI + 1), z: 0 };
        }
        unproject(de, Ce) {
          let De = de = (2 * de - 0.5) * Math.PI, Ke = Ce = (2 * (1 - Ce) - 1) * Math.PI, Ve = 25;
          const er = 1e-6;
          let fr = 0, wr = 0;
          do {
            const kr = Math.cos(Ke), cr = Math.sin(Ke), Mr = 2 * cr * kr, Er = cr * cr, xr = kr * kr, Sr = Math.cos(De / 2), Br = Math.sin(De / 2), Fr = 2 * Sr * Br, jr = Br * Br, Qr = 1 - xr * Sr * Sr, ti = Qr ? 1 / Qr : 0, Kr = Qr ? Math.acos(kr * Sr) * Math.sqrt(1 / Qr) : 0, ni = 0.5 * (2 * Kr * kr * Br + 2 * De / Math.PI) - de, gi = 0.5 * (Kr * cr + Ke) - Ce, Si = 0.5 * ti * (xr * jr + Kr * kr * Sr * Er) + 1 / Math.PI, Di = ti * (Fr * Mr / 4 - Kr * cr * Br), Ri = 0.125 * ti * (Mr * Br - Kr * cr * xr * Fr), Bi = 0.5 * ti * (Er * Sr + Kr * jr * kr) + 0.5, Ji = Di * Ri - Bi * Si;
            fr = (gi * Di - ni * Bi) / Ji, wr = (ni * Ri - gi * Si) / Ji, De = vn(De - fr, -Math.PI, Math.PI), Ke = vn(Ke - wr, -ns, ns);
          } while ((Math.abs(fr) > er || Math.abs(wr) > er) && --Ve > 0);
          return new Ba(ji(De), ji(Ke));
        }
      }
      class Gl extends ui {
        constructor(de) {
          super(de), this.center = de.center || [0, 0], this.parallels = de.parallels || [0, 0], this.cosPhi = Math.max(0.01, Math.cos(rn(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = !0, this.supportsWorldCopies = !0;
        }
        project(de, Ce) {
          const { scale: De, cosPhi: Ke } = this;
          return { x: rn(de) * Ke * De + 0.5, y: -Math.sin(rn(Ce)) / Ke * De + 0.5, z: 0 };
        }
        unproject(de, Ce) {
          const { scale: De, cosPhi: Ke } = this, Ve = -(Ce - 0.5) / De, er = vn(ji((de - 0.5) / De) / Ke, -180, 180), fr = Math.asin(vn(Ve * Ke, -1, 1)), wr = vn(ji(fr), -Es, Es);
          return new Ba(er, wr);
        }
      }
      class Oc extends Ua {
        constructor(de) {
          super(de), this.requiresDraping = !0, this.supportsWorldCopies = !1, this.supportsFog = !0, this.zAxisUnit = "pixels", this.unsupportedLayers = ["debug"], this.range = [3, 5];
        }
        projectTilePoint(de, Ce, De) {
          const Ke = xs(de, Ce, De), Ve = ul(Ns(De));
          return Zr.vec3.transformMat4(Ke, Ke, Ve), { x: Ke[0], y: Ke[1], z: Ke[2] };
        }
        locationPoint(de, Ce) {
          const De = zu(Ce.lat, Ce.lng), Ke = Zr.vec3.normalize([], De), Ve = de.elevation ? de.elevation.getAtPointOrZero(de.locationCoordinate(Ce), de._centerAltitude) : de._centerAltitude, er = As(1, 0) * vo * Ve;
          Zr.vec3.scaleAndAdd(De, De, Ke, er);
          const fr = Zr.mat4.identity(new Float64Array(16));
          return Zr.mat4.multiply(fr, de.pixelMatrix, de.globeMatrix), Zr.vec3.transformMat4(De, De, fr), new qi(De[0], De[1]);
        }
        pixelsPerMeter(de, Ce) {
          return As(1, 0) * Ce;
        }
        pixelSpaceConversion(de, Ce, De) {
          const Ke = As(1, de) * Ce, Ve = Ho(As(1, 45) * Ce, Ke, De);
          return this.pixelsPerMeter(de, Ce) / Ve;
        }
        createTileMatrix(de, Ce, De) {
          const Ke = nc(Ns(De.canonical));
          return Zr.mat4.multiply(new Float64Array(16), de.globeMatrix, Ke);
        }
        createInversionMatrix(de, Ce) {
          const { center: De } = de, Ke = ul(Ns(Ce));
          return Zr.mat4.rotateY(Ke, Ke, rn(De.lng)), Zr.mat4.rotateX(Ke, Ke, rn(De.lat)), Zr.mat4.scale(Ke, Ke, [de._pixelsPerMercatorPixel, de._pixelsPerMercatorPixel, 1]), Float32Array.from(Ke);
        }
        pointCoordinate(de, Ce, De, Ke) {
          return Xs(de, Ce, De, !0) || new ir(0, 0);
        }
        pointCoordinate3D(de, Ce, De) {
          const Ke = this.pointCoordinate(de, Ce, De, 0);
          return [Ke.x, Ke.y, Ke.z];
        }
        isPointAboveHorizon(de, Ce) {
          return !Xs(de, Ce.x, Ce.y, !1);
        }
        farthestPixelDistance(de) {
          const Ce = function(Ke, Ve) {
            const er = Ke.cameraToCenterDistance, fr = Ke._centerAltitude * Ve, wr = Ke._camera, kr = Ke._camera.forward(), cr = Zr.vec3.add([], Zr.vec3.scale([], kr, -er), [0, 0, fr]), Mr = Ke.worldSize / (2 * Math.PI), Er = [0, 0, -Mr], xr = Ke.width / Ke.height, Sr = Math.tan(Ke.fovAboveCenter), Br = Zr.vec3.scale([], wr.up(), Sr), Fr = Zr.vec3.scale([], wr.right(), Sr * xr), jr = Zr.vec3.normalize([], Zr.vec3.add([], Zr.vec3.add([], kr, Br), Fr)), Qr = [];
            let ti;
            if (new sa(cr, jr).closestPointOnSphere(Er, Mr, Qr)) {
              const Kr = Zr.vec3.add([], Qr, Er), ni = Zr.vec3.sub([], Kr, cr);
              ti = Math.cos(Ke.fovAboveCenter) * Zr.vec3.length(ni);
            } else {
              const Kr = Zr.vec3.sub([], cr, Er), ni = Zr.vec3.sub([], Er, cr);
              Zr.vec3.normalize(ni, ni);
              const gi = Zr.vec3.length(Kr) - Mr;
              ti = Math.sqrt(gi * (gi + 2 * Mr));
              const Si = Math.acos(ti / (Mr + gi)) - Math.acos(Zr.vec3.dot(kr, ni));
              ti *= Math.cos(Si);
            }
            return 1.01 * ti;
          }(de, this.pixelsPerMeter(de.center.lat, de.worldSize)), De = gl(de.zoom);
          if (De > 0) {
            const Ke = nv(de, As(1, de.center.lat) * de.worldSize), Ve = de.worldSize / (2 * Math.PI), er = Math.max(de.width, de.height) / de.worldSize * Math.PI;
            return Ho(Ce, Ke + Ve * (1 - Math.cos(er)), Math.pow(De, 10));
          }
          return Ce;
        }
        upVector(de, Ce, De) {
          return xs(Ce, De, de, 1);
        }
        upVectorScale(de) {
          return { metersToTile: Aa(Vs(Ns(de))) };
        }
      }
      function Ks(Ie) {
        const de = Ie.parallels, Ce = !!de && Math.abs(de[0] + de[1]) < 0.01;
        switch (Ie.name) {
          case "mercator":
            return new Ua(Ie);
          case "equirectangular":
            return new ko(Ie);
          case "naturalEarth":
            return new Qa(Ie);
          case "equalEarth":
            return new So(Ie);
          case "winkelTripel":
            return new Dc(Ie);
          case "albers":
            return Ce ? new Gl(Ie) : new $i(Ie);
          case "lambertConformalConic":
            return Ce ? new Gl(Ie) : new Sa(Ie);
          case "globe":
            return new Oc(Ie);
        }
        throw new Error(`Invalid projection name: ${Ie.name}`);
      }
      const yu = $a.VectorTileFeature.types, Eh = [{ name: "a_fade_opacity", components: 1, type: "Uint8", offset: 0 }];
      function Em(Ie, de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er) {
        const xr = fr ? Math.min(md, Math.round(fr[0])) : 0, Sr = fr ? Math.min(md, Math.round(fr[1])) : 0;
        Ie.emplaceBack(de, Ce, Math.round(32 * De), Math.round(32 * Ke), Ve, er, (xr << 1) + (wr ? 1 : 0), Sr, 16 * kr, 16 * cr, 256 * Mr, 256 * Er);
      }
      function ov(Ie, de, Ce) {
        Ie.emplaceBack(de, Ce);
      }
      function av(Ie, de, Ce, De, Ke, Ve, er) {
        Ie.emplaceBack(de, Ce, De, Ke, Ve, er);
      }
      function sv(Ie, de, Ce, De, Ke) {
        Ie.emplaceBack(de, Ce, De, Ke), Ie.emplaceBack(de, Ce, De, Ke), Ie.emplaceBack(de, Ce, De, Ke), Ie.emplaceBack(de, Ce, De, Ke);
      }
      function Wy(Ie) {
        for (const de of Ie.sections)
          if (jp(de.text))
            return !0;
        return !1;
      }
      class T_ {
        constructor(de) {
          this.layoutVertexArray = new gh(), this.indexArray = new tl(), this.programConfigurations = de, this.segments = new fs(), this.dynamicLayoutVertexArray = new cu(), this.opacityVertexArray = new Wp(), this.placedSymbolArray = new Jm(), this.iconTransitioningVertexArray = new Ru(), this.globeExtVertexArray = new Qf(), this.zOffsetVertexArray = new rl();
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0 && this.indexArray.length === 0 && this.dynamicLayoutVertexArray.length === 0 && this.opacityVertexArray.length === 0 && this.iconTransitioningVertexArray.length === 0;
        }
        upload(de, Ce, De, Ke, Ve) {
          this.isEmpty() || (De && (this.layoutVertexBuffer = de.createVertexBuffer(this.layoutVertexArray, i_.members), this.indexBuffer = de.createIndexBuffer(this.indexArray, Ce), this.dynamicLayoutVertexBuffer = de.createVertexBuffer(this.dynamicLayoutVertexArray, Fg.members, !0), this.opacityVertexBuffer = de.createVertexBuffer(this.opacityVertexArray, Eh, !0), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = de.createVertexBuffer(this.iconTransitioningVertexArray, o_.members, !0)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = de.createVertexBuffer(this.globeExtVertexArray, zg.members, !0)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || Ve) && (this.zOffsetVertexBuffer = de.createVertexBuffer(this.zOffsetVertexArray, n_.members, !0)), this.opacityVertexBuffer.itemSize = 1), (De || Ke) && this.programConfigurations.upload(de));
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy());
        }
      }
      Ao(T_, "SymbolBuffers");
      class A_ {
        constructor(de, Ce, De) {
          this.layoutVertexArray = new de(), this.layoutAttributes = Ce, this.indexArray = new De(), this.segments = new fs(), this.collisionVertexArray = new Yd(), this.collisionVertexArrayExt = new cu();
        }
        upload(de) {
          this.layoutVertexBuffer = de.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = de.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = de.createVertexBuffer(this.collisionVertexArray, a_.members, !0), this.collisionVertexBufferExt = de.createVertexBuffer(this.collisionVertexArrayExt, s_.members, !0);
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
        }
      }
      Ao(A_, "CollisionBuffers");
      class lv {
        constructor(de) {
          this.collisionBoxArray = de.collisionBoxArray, this.zoom = de.zoom, this.lut = de.lut, this.overscaling = de.overscaling, this.layers = de.layers, this.layerIds = this.layers.map((er) => er.fqid), this.index = de.index, this.pixelRatio = de.pixelRatio, this.sourceLayerIndex = de.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.fullyClipped = !1, this.hasAnyIconTextFit = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = Zr.mat4.identity([]), this.placementViewportMatrix = Zr.mat4.identity([]);
          const Ce = this.layers[0]._unevaluatedLayout._values;
          this.textSizeData = v1(this.zoom, Ce["text-size"]), this.iconSizeData = v1(this.zoom, Ce["icon-size"]);
          const De = this.layers[0].layout, Ke = De.get("symbol-sort-key"), Ve = De.get("symbol-z-order");
          this.canOverlap = De.get("text-allow-overlap") || De.get("icon-allow-overlap") || De.get("text-ignore-placement") || De.get("icon-ignore-placement"), this.sortFeaturesByKey = Ve !== "viewport-y" && Ke.constantOr(1) !== void 0, this.sortFeaturesByY = (Ve === "viewport-y" || Ve === "auto" && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = De.get("text-writing-mode").map((er) => Pc[er]), this.stateDependentLayerIds = this.layers.filter((er) => er.isStateDependent()).map((er) => er.id), this.sourceID = de.sourceID, this.projection = de.projection, this.hasAnyZOffset = !1, this.zOffsetSortDirty = !1, this.zOffsetBuffersNeedUpload = De.get("symbol-z-elevate"), this.activeReplacements = [], this.replacementUpdateTime = 0;
        }
        createArrays() {
          this.text = new T_(new du(this.layers, { zoom: this.zoom, lut: this.lut }, (de) => de.startsWith("text") || de.startsWith("symbol"))), this.icon = new T_(new du(this.layers, { zoom: this.zoom, lut: this.lut }, (de) => de.startsWith("icon") || de.startsWith("symbol"))), this.glyphOffsetArray = new ad(), this.lineVertexArray = new Bl(), this.symbolInstances = new tf();
        }
        calculateGlyphDependencies(de, Ce, De, Ke, Ve) {
          for (const er of de) {
            const fr = er.codePointAt(0);
            if (fr === void 0)
              break;
            if (Ce[fr] = !0, Ke && Ve && fr <= 65535) {
              const wr = ym[er];
              wr && (Ce[wr.charCodeAt(0)] = !0);
            }
          }
        }
        updateFootprints(de, Ce) {
        }
        updateReplacement(de, Ce) {
          if (Ce.updateTime === this.replacementUpdateTime)
            return !1;
          this.replacementUpdateTime = Ce.updateTime;
          const De = Ce.getReplacementRegionsForTile(de.toUnwrapped(), !0);
          return !hm(this.activeReplacements, De) && (this.activeReplacements = De, !0);
        }
        populate(de, Ce, De, Ke) {
          const Ve = this.layers[0], er = Ve.layout, fr = this.projection.name === "globe", wr = er.get("text-font"), kr = er.get("text-field"), cr = er.get("icon-image"), [Mr, Er] = er.get("icon-size-scale-range"), xr = vn(Ce.scaleFactor || 1, Mr, Er), Sr = (kr.value.kind !== "constant" || kr.value.value instanceof Ys && !kr.value.value.isEmpty() || kr.value.value.toString().length > 0) && (wr.value.kind !== "constant" || wr.value.value.length > 0), Br = cr.value.kind !== "constant" || !!cr.value.value || Object.keys(cr.parameters).length > 0, Fr = er.get("symbol-sort-key");
          if (this.features = [], !Sr && !Br)
            return;
          const jr = Ce.iconDependencies, Qr = Ce.glyphDependencies, ti = Ce.availableImages, Kr = new wa(this.zoom);
          for (const { feature: ni, id: gi, index: Si, sourceLayerIndex: Di } of de) {
            const Ri = Ve._featureFilter.needGeometry, Bi = Jr(ni, Ri);
            if (!Ve._featureFilter.filter(Kr, Bi, De))
              continue;
            if (Ri || (Bi.geometry = qr(ni, De, Ke)), fr && ni.type !== 1 && De.z <= 5) {
              const ln = Bi.geometry, mn = 0.98078528056, wn = (Cn, gn) => {
                const Nn = xs(Cn.x, Cn.y, De, 1), oo = xs(gn.x, gn.y, De, 1);
                return Zr.vec3.dot(Nn, oo) < mn;
              };
              for (let Cn = 0; Cn < ln.length; Cn++)
                ln[Cn] = $r(ln[Cn], wn);
            }
            let Ji, Fi;
            if (Sr) {
              const ln = Ve.getValueAndResolveTokens("text-field", Bi, De, ti), mn = Ys.factory(ln);
              Wy(mn) && (this.hasRTLText = !0), (!this.hasRTLText || Yh() === "unavailable" || this.hasRTLText && Il.isParsed()) && (Ji = u_(mn, Ve, Bi));
            }
            if (Br) {
              const ln = Ve.getValueAndResolveTokens("icon-image", Bi, De, ti);
              Fi = ln instanceof Ps ? ln : Ps.build(ln);
            }
            if (!Ji && !Fi)
              continue;
            const tn = this.sortFeaturesByKey ? Fr.evaluate(Bi, {}, De) : void 0, cn = { id: gi, text: Ji, icon: Fi, index: Si, sourceLayerIndex: Di, geometry: Bi.geometry, properties: ni.properties, type: yu[ni.type], sortKey: tn };
            if (this.features.push(cn), Fi) {
              const ln = m0(this.iconSizeData, this.layers[0]._unevaluatedLayout._values["icon-size"], De, this.zoom, cn) * xr * this.pixelRatio, mn = Fi.getPrimary().scaleSelf(ln);
              if (jr[mn.id] = jr[mn.id] || [], jr[mn.id].push(mn), Fi.nameSecondary) {
                const wn = Fi.getSecondary().scaleSelf(ln);
                jr[wn.id] = jr[wn.id] || [], jr[wn.id].push(wn);
              }
            }
            if (Ji) {
              const ln = wr.evaluate(Bi, {}, De).join(","), mn = er.get("text-rotation-alignment") === "map" && er.get("symbol-placement") !== "point";
              this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(Pc.vertical) >= 0;
              for (const wn of Ji.sections)
                if (wn.image) {
                  const Cn = wn.image.getPrimary().scaleSelf(this.pixelRatio);
                  jr[Cn.id] = jr[Cn.id] || [], jr[Cn.id].push(Cn);
                } else {
                  const Cn = Zh(Ji.toString()), gn = wn.fontStack || ln, Nn = Qr[gn] = Qr[gn] || {};
                  this.calculateGlyphDependencies(wn.text, Nn, mn, this.allowVerticalPlacement, Cn);
                }
            }
          }
          er.get("symbol-placement") === "line" && (this.features = function(ni) {
            const gi = {}, Si = {}, Di = [];
            let Ri = 0;
            function Bi(cn) {
              Di.push(ni[cn]), Ri++;
            }
            function Ji(cn, ln, mn) {
              const wn = Si[cn];
              return delete Si[cn], Si[ln] = wn, Di[wn].geometry[0].pop(), Di[wn].geometry[0] = Di[wn].geometry[0].concat(mn[0]), wn;
            }
            function Fi(cn, ln, mn) {
              const wn = gi[ln];
              return delete gi[ln], gi[cn] = wn, Di[wn].geometry[0].shift(), Di[wn].geometry[0] = mn[0].concat(Di[wn].geometry[0]), wn;
            }
            function tn(cn, ln, mn) {
              const wn = mn ? ln[0][ln[0].length - 1] : ln[0][0];
              return `${cn}:${wn.x}:${wn.y}`;
            }
            for (let cn = 0; cn < ni.length; cn++) {
              const ln = ni[cn], mn = ln.geometry, wn = ln.text ? ln.text.toString() : null;
              if (!wn) {
                Bi(cn);
                continue;
              }
              const Cn = tn(wn, mn), gn = tn(wn, mn, !0);
              if (Cn in Si && gn in gi && Si[Cn] !== gi[gn]) {
                const Nn = Fi(Cn, gn, mn), oo = Ji(Cn, gn, Di[Nn].geometry);
                delete gi[Cn], delete Si[gn], Si[tn(wn, Di[oo].geometry, !0)] = oo, Di[Nn].geometry = null;
              } else
                Cn in Si ? Ji(Cn, gn, mn) : gn in gi ? Fi(Cn, gn, mn) : (Bi(cn), gi[Cn] = Ri - 1, Si[gn] = Ri - 1);
            }
            return Di.filter((cn) => cn.geometry);
          }(this.features)), this.sortFeaturesByKey && this.features.sort((ni, gi) => ni.sortKey - gi.sortKey);
        }
        update(de, Ce, De, Ke, Ve, er, fr) {
          this.text.programConfigurations.updatePaintArrays(de, Ce, Ve, De, Ke, er, fr), this.icon.programConfigurations.updatePaintArrays(de, Ce, Ve, De, Ke, er, fr);
        }
        updateZOffset() {
          const de = (Ve, er, fr) => {
            De += er, De > Ve.length && Ve.resize(De);
            for (let wr = -er; wr < 0; wr++)
              Ve.emplace(wr + De, fr);
          }, Ce = (Ve, er, fr) => {
            Ke += er, Ke > Ve.length && Ve.resize(Ke);
            for (let wr = -er; wr < 0; wr++)
              Ve.emplace(wr + Ke, fr);
          };
          if (!this.zOffsetBuffersNeedUpload)
            return;
          this.zOffsetBuffersNeedUpload = !1;
          let De = 0, Ke = 0;
          for (let Ve = 0; Ve < this.symbolInstances.length; Ve++) {
            const er = this.symbolInstances.get(Ve), { numHorizontalGlyphVertices: fr, numVerticalGlyphVertices: wr, numIconVertices: kr } = er, cr = er.zOffset, Mr = kr > 0;
            if ((fr > 0 || wr > 0) && (de(this.text.zOffsetVertexArray, fr, cr), de(this.text.zOffsetVertexArray, wr, cr)), Mr) {
              const { placedIconSymbolIndex: Er, verticalPlacedIconSymbolIndex: xr } = er;
              Er >= 0 && Ce(this.icon.zOffsetVertexArray, kr, cr), xr >= 0 && Ce(this.icon.zOffsetVertexArray, er.numVerticalIconVertices, cr);
            }
          }
          this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(this.text.zOffsetVertexArray), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(this.icon.zOffsetVertexArray);
        }
        isEmpty() {
          return this.symbolInstances.length === 0 && !this.hasRTLText;
        }
        uploadPending() {
          return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
        }
        upload(de) {
          !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(de), this.iconCollisionBox.upload(de)), this.text.upload(de, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.icon.upload(de, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.uploaded = !0;
        }
        destroyDebugData() {
          this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
        }
        getProjection() {
          return this.projectionInstance || (this.projectionInstance = Ks(this.projection)), this.projectionInstance;
        }
        destroy() {
          this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
        }
        addToLineVertexArray(de, Ce) {
          const De = this.lineVertexArray.length;
          if (de.segment !== void 0)
            for (const { x: Ke, y: Ve } of Ce)
              this.lineVertexArray.emplaceBack(Ke, Ve);
          return { lineStartIndex: De, lineLength: this.lineVertexArray.length - De };
        }
        addSymbols(de, Ce, De, Ke, Ve, er, fr, wr, kr, cr, Mr, Er, xr, Sr, Br, Fr) {
          const jr = de.indexArray, Qr = de.layoutVertexArray, ti = de.globeExtVertexArray, Kr = de.segments.prepareSegment(4 * Ce.length, Qr, jr, this.canOverlap ? er.sortKey : void 0), ni = this.glyphOffsetArray.length, gi = Kr.vertexLength, Si = this.allowVerticalPlacement && fr === Pc.vertical ? Math.PI / 2 : 0, Di = er.text && er.text.sections;
          for (let Bi = 0; Bi < Ce.length; Bi++) {
            const { tl: Ji, tr: Fi, bl: tn, br: cn, texPrimary: ln, texSecondary: mn, pixelOffsetTL: wn, pixelOffsetBR: Cn, minFontScaleX: gn, minFontScaleY: Nn, glyphOffset: oo, isSDF: Un, sectionIndex: fo } = Ce[Bi], ho = Kr.vertexLength, bo = oo[1];
            if (Em(Qr, kr.x, kr.y, Ji.x, bo + Ji.y, ln.x, ln.y, De, Un, wn.x, wn.y, gn, Nn), Em(Qr, kr.x, kr.y, Fi.x, bo + Fi.y, ln.x + ln.w, ln.y, De, Un, Cn.x, wn.y, gn, Nn), Em(Qr, kr.x, kr.y, tn.x, bo + tn.y, ln.x, ln.y + ln.h, De, Un, wn.x, Cn.y, gn, Nn), Em(Qr, kr.x, kr.y, cn.x, bo + cn.y, ln.x + ln.w, ln.y + ln.h, De, Un, Cn.x, Cn.y, gn, Nn), wr) {
              const { x: Jn, y: Ro, z: po } = wr.anchor, [Lo, jo, oa] = wr.up;
              av(ti, Jn, Ro, po, Lo, jo, oa), av(ti, Jn, Ro, po, Lo, jo, oa), av(ti, Jn, Ro, po, Lo, jo, oa), av(ti, Jn, Ro, po, Lo, jo, oa), sv(de.dynamicLayoutVertexArray, Jn, Ro, po, Si);
            } else
              sv(de.dynamicLayoutVertexArray, kr.x, kr.y, kr.z, Si);
            if (Fr) {
              const Jn = mn || ln;
              ov(de.iconTransitioningVertexArray, Jn.x, Jn.y), ov(de.iconTransitioningVertexArray, Jn.x + Jn.w, Jn.y), ov(de.iconTransitioningVertexArray, Jn.x, Jn.y + Jn.h), ov(de.iconTransitioningVertexArray, Jn.x + Jn.w, Jn.y + Jn.h);
            }
            jr.emplaceBack(ho, ho + 1, ho + 2), jr.emplaceBack(ho + 1, ho + 2, ho + 3), Kr.vertexLength += 4, Kr.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(oo[0]), Bi !== Ce.length - 1 && fo === Ce[Bi + 1].sectionIndex || de.programConfigurations.populatePaintArrays(Qr.length, er, er.index, {}, xr, Sr, Br, Di && Di[fo]);
          }
          const Ri = wr ? wr.anchor : kr;
          de.placedSymbolArray.emplaceBack(Ri.x, Ri.y, Ri.z, kr.x, kr.y, ni, this.glyphOffsetArray.length - ni, gi, cr, Mr, kr.segment, De ? De[0] : 0, De ? De[1] : 0, Ke[0], Ke[1], fr, 0, !1, 0, Er, 0);
        }
        _commitLayoutVertex(de, Ce, De, Ke, Ve, er, fr) {
          de.emplaceBack(Ce, De, Ke, Ve, er, Math.round(fr.x), Math.round(fr.y));
        }
        _addCollisionDebugVertices(de, Ce, De, Ke, Ve, er, fr) {
          const wr = De.segments.prepareSegment(4, De.layoutVertexArray, De.indexArray), kr = wr.vertexLength, cr = fr.tileAnchorX, Mr = fr.tileAnchorY;
          for (let xr = 0; xr < 4; xr++)
            De.collisionVertexArray.emplaceBack(0, 0, 0, 0, 0, 0);
          this._commitDebugCollisionVertexUpdate(De.collisionVertexArrayExt, Ce, de.padding, fr.zOffset), this._commitLayoutVertex(De.layoutVertexArray, Ke, Ve, er, cr, Mr, new qi(de.x1, de.y1)), this._commitLayoutVertex(De.layoutVertexArray, Ke, Ve, er, cr, Mr, new qi(de.x2, de.y1)), this._commitLayoutVertex(De.layoutVertexArray, Ke, Ve, er, cr, Mr, new qi(de.x2, de.y2)), this._commitLayoutVertex(De.layoutVertexArray, Ke, Ve, er, cr, Mr, new qi(de.x1, de.y2)), wr.vertexLength += 4;
          const Er = De.indexArray;
          Er.emplaceBack(kr, kr + 1), Er.emplaceBack(kr + 1, kr + 2), Er.emplaceBack(kr + 2, kr + 3), Er.emplaceBack(kr + 3, kr), wr.primitiveLength += 4;
        }
        _addTextDebugCollisionBoxes(de, Ce, De, Ke, Ve, er) {
          for (let fr = Ke; fr < Ve; fr++) {
            const wr = De.get(fr), kr = this.getSymbolInstanceTextSize(de, er, Ce, fr);
            this._addCollisionDebugVertices(wr, kr, this.textCollisionBox, wr.projectedAnchorX, wr.projectedAnchorY, wr.projectedAnchorZ, er);
          }
        }
        _addIconDebugCollisionBoxes(de, Ce, De, Ke, Ve, er) {
          for (let fr = Ke; fr < Ve; fr++) {
            const wr = De.get(fr), kr = this.getSymbolInstanceIconSize(de, Ce, er.placedIconSymbolIndex);
            this._addCollisionDebugVertices(wr, kr, this.iconCollisionBox, wr.projectedAnchorX, wr.projectedAnchorY, wr.projectedAnchorZ, er);
          }
        }
        generateCollisionDebugBuffers(de, Ce, De) {
          this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new A_(Kd, gf.members, Ru), this.iconCollisionBox = new A_(Kd, gf.members, Ru);
          const Ke = vf(this.iconSizeData, de), Ve = vf(this.textSizeData, de, De);
          for (let er = 0; er < this.symbolInstances.length; er++) {
            const fr = this.symbolInstances.get(er);
            this._addTextDebugCollisionBoxes(Ve, de, Ce, fr.textBoxStartIndex, fr.textBoxEndIndex, fr), this._addTextDebugCollisionBoxes(Ve, de, Ce, fr.verticalTextBoxStartIndex, fr.verticalTextBoxEndIndex, fr), this._addIconDebugCollisionBoxes(Ke, de, Ce, fr.iconBoxStartIndex, fr.iconBoxEndIndex, fr), this._addIconDebugCollisionBoxes(Ke, de, Ce, fr.verticalIconBoxStartIndex, fr.verticalIconBoxEndIndex, fr);
          }
        }
        getSymbolInstanceTextSize(de, Ce, De, Ke) {
          const Ve = this.text.placedSymbolArray.get(Ce.rightJustifiedTextSymbolIndex >= 0 ? Ce.rightJustifiedTextSymbolIndex : Ce.centerJustifiedTextSymbolIndex >= 0 ? Ce.centerJustifiedTextSymbolIndex : Ce.leftJustifiedTextSymbolIndex >= 0 ? Ce.leftJustifiedTextSymbolIndex : Ce.verticalPlacedTextSymbolIndex >= 0 ? Ce.verticalPlacedTextSymbolIndex : Ke), er = _m(this.textSizeData, de, Ve) / _l;
          return this.tilePixelRatio * er;
        }
        getSymbolInstanceIconSize(de, Ce, De) {
          const Ke = this.icon.placedSymbolArray.get(De), Ve = _m(this.iconSizeData, de, Ke);
          return this.tilePixelRatio * Ve;
        }
        _commitDebugCollisionVertexUpdate(de, Ce, De, Ke) {
          de.emplaceBack(Ce, -De, -De, Ke), de.emplaceBack(Ce, De, -De, Ke), de.emplaceBack(Ce, De, De, Ke), de.emplaceBack(Ce, -De, De, Ke);
        }
        _updateTextDebugCollisionBoxes(de, Ce, De, Ke, Ve, er, fr) {
          for (let wr = Ke; wr < Ve; wr++) {
            const kr = De.get(wr), cr = this.getSymbolInstanceTextSize(de, er, Ce, wr);
            this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, cr, kr.padding, er.zOffset);
          }
        }
        _updateIconDebugCollisionBoxes(de, Ce, De, Ke, Ve, er, fr) {
          for (let wr = Ke; wr < Ve; wr++) {
            const kr = De.get(wr), cr = this.getSymbolInstanceIconSize(de, Ce, er.placedIconSymbolIndex);
            this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, cr, kr.padding, er.zOffset);
          }
        }
        updateCollisionDebugBuffers(de, Ce, De, Ke) {
          if (!this.hasDebugData())
            return;
          this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
          const Ve = vf(this.iconSizeData, de, Ke), er = vf(this.textSizeData, de, De);
          for (let fr = 0; fr < this.symbolInstances.length; fr++) {
            const wr = this.symbolInstances.get(fr);
            this._updateTextDebugCollisionBoxes(er, de, Ce, wr.textBoxStartIndex, wr.textBoxEndIndex, wr, De), this._updateTextDebugCollisionBoxes(er, de, Ce, wr.verticalTextBoxStartIndex, wr.verticalTextBoxEndIndex, wr, De), this._updateIconDebugCollisionBoxes(Ve, de, Ce, wr.iconBoxStartIndex, wr.iconBoxEndIndex, wr, Ke), this._updateIconDebugCollisionBoxes(Ve, de, Ce, wr.verticalIconBoxStartIndex, wr.verticalIconBoxEndIndex, wr, Ke);
          }
          this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
        }
        _deserializeCollisionBoxesForSymbol(de, Ce, De, Ke, Ve, er, fr, wr, kr) {
          const cr = {};
          if (Ce < De) {
            const { x1: Mr, y1: Er, x2: xr, y2: Sr, padding: Br, projectedAnchorX: Fr, projectedAnchorY: jr, projectedAnchorZ: Qr, tileAnchorX: ti, tileAnchorY: Kr, featureIndex: ni } = de.get(Ce);
            cr.textBox = { x1: Mr, y1: Er, x2: xr, y2: Sr, padding: Br, projectedAnchorX: Fr, projectedAnchorY: jr, projectedAnchorZ: Qr, tileAnchorX: ti, tileAnchorY: Kr }, cr.textFeatureIndex = ni;
          }
          if (Ke < Ve) {
            const { x1: Mr, y1: Er, x2: xr, y2: Sr, padding: Br, projectedAnchorX: Fr, projectedAnchorY: jr, projectedAnchorZ: Qr, tileAnchorX: ti, tileAnchorY: Kr, featureIndex: ni } = de.get(Ke);
            cr.verticalTextBox = { x1: Mr, y1: Er, x2: xr, y2: Sr, padding: Br, projectedAnchorX: Fr, projectedAnchorY: jr, projectedAnchorZ: Qr, tileAnchorX: ti, tileAnchorY: Kr }, cr.verticalTextFeatureIndex = ni;
          }
          if (er < fr) {
            const { x1: Mr, y1: Er, x2: xr, y2: Sr, padding: Br, projectedAnchorX: Fr, projectedAnchorY: jr, projectedAnchorZ: Qr, tileAnchorX: ti, tileAnchorY: Kr, featureIndex: ni } = de.get(er);
            cr.iconBox = { x1: Mr, y1: Er, x2: xr, y2: Sr, padding: Br, projectedAnchorX: Fr, projectedAnchorY: jr, projectedAnchorZ: Qr, tileAnchorX: ti, tileAnchorY: Kr }, cr.iconFeatureIndex = ni;
          }
          if (wr < kr) {
            const { x1: Mr, y1: Er, x2: xr, y2: Sr, padding: Br, projectedAnchorX: Fr, projectedAnchorY: jr, projectedAnchorZ: Qr, tileAnchorX: ti, tileAnchorY: Kr, featureIndex: ni } = de.get(wr);
            cr.verticalIconBox = { x1: Mr, y1: Er, x2: xr, y2: Sr, padding: Br, projectedAnchorX: Fr, projectedAnchorY: jr, projectedAnchorZ: Qr, tileAnchorX: ti, tileAnchorY: Kr }, cr.verticalIconFeatureIndex = ni;
          }
          return cr;
        }
        deserializeCollisionBoxes(de) {
          this.collisionArrays = [];
          for (let Ce = 0; Ce < this.symbolInstances.length; Ce++) {
            const De = this.symbolInstances.get(Ce);
            this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(de, De.textBoxStartIndex, De.textBoxEndIndex, De.verticalTextBoxStartIndex, De.verticalTextBoxEndIndex, De.iconBoxStartIndex, De.iconBoxEndIndex, De.verticalIconBoxStartIndex, De.verticalIconBoxEndIndex));
          }
        }
        hasTextData() {
          return this.text.segments.get().length > 0;
        }
        hasIconData() {
          return this.icon.segments.get().length > 0;
        }
        hasDebugData() {
          return this.textCollisionBox && this.iconCollisionBox;
        }
        hasTextCollisionBoxData() {
          return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
        }
        hasIconCollisionBoxData() {
          return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
        }
        hasIconTextFit() {
          return this.hasAnyIconTextFit;
        }
        addIndicesForPlacedSymbol(de, Ce) {
          const De = de.placedSymbolArray.get(Ce), Ke = De.vertexStartIndex + 4 * De.numGlyphs;
          for (let Ve = De.vertexStartIndex; Ve < Ke; Ve += 4)
            de.indexArray.emplaceBack(Ve, Ve + 1, Ve + 2), de.indexArray.emplaceBack(Ve + 1, Ve + 2, Ve + 3);
        }
        getSortedSymbolIndexes(de) {
          if (this.sortedAngle === de && this.symbolInstanceIndexes !== void 0)
            return this.symbolInstanceIndexes;
          const Ce = Math.sin(de), De = Math.cos(de), Ke = [], Ve = [], er = [];
          for (let fr = 0; fr < this.symbolInstances.length; ++fr) {
            er.push(fr);
            const wr = this.symbolInstances.get(fr);
            Ke.push(0 | Math.round(Ce * wr.tileAnchorX + De * wr.tileAnchorY)), Ve.push(wr.featureIndex);
          }
          return er.sort((fr, wr) => Ke[fr] - Ke[wr] || Ve[wr] - Ve[fr]), er;
        }
        getSortedIndexesByZOffset() {
          if (!this.zOffsetSortDirty)
            return this.symbolInstanceIndexesSortedZOffset;
          if (!this.symbolInstanceIndexesSortedZOffset) {
            this.symbolInstanceIndexesSortedZOffset = [];
            for (let de = 0; de < this.symbolInstances.length; ++de)
              this.symbolInstanceIndexesSortedZOffset.push(de);
          }
          return this.zOffsetSortDirty = !1, this.symbolInstanceIndexesSortedZOffset.sort((de, Ce) => this.symbolInstances.get(Ce).zOffset - this.symbolInstances.get(de).zOffset);
        }
        addToSortKeyRanges(de, Ce) {
          const De = this.sortKeyRanges[this.sortKeyRanges.length - 1];
          De && De.sortKey === Ce ? De.symbolInstanceEnd = de + 1 : this.sortKeyRanges.push({ sortKey: Ce, symbolInstanceStart: de, symbolInstanceEnd: de + 1 });
        }
        sortFeatures(de) {
          if (this.sortFeaturesByY && this.sortedAngle !== de && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
            this.symbolInstanceIndexes = this.getSortedSymbolIndexes(de), this.sortedAngle = de, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
            for (const Ce of this.symbolInstanceIndexes) {
              const De = this.symbolInstances.get(Ce);
              this.featureSortOrder.push(De.featureIndex);
              const { rightJustifiedTextSymbolIndex: Ke, centerJustifiedTextSymbolIndex: Ve, leftJustifiedTextSymbolIndex: er, verticalPlacedTextSymbolIndex: fr, placedIconSymbolIndex: wr, verticalPlacedIconSymbolIndex: kr } = De;
              Ke >= 0 && this.addIndicesForPlacedSymbol(this.text, Ke), Ve >= 0 && Ve !== Ke && this.addIndicesForPlacedSymbol(this.text, Ve), er >= 0 && er !== Ve && er !== Ke && this.addIndicesForPlacedSymbol(this.text, er), fr >= 0 && this.addIndicesForPlacedSymbol(this.text, fr), wr >= 0 && this.addIndicesForPlacedSymbol(this.icon, wr), kr >= 0 && this.addIndicesForPlacedSymbol(this.icon, kr);
            }
            this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
          }
        }
      }
      let f2, p2, k_;
      Ao(lv, "SymbolBucket", { omit: ["layers", "collisionBoxArray", "features", "compareText"] }), lv.addDynamicAttributes = sv;
      class m2 {
        constructor(de) {
          this.type = de.property.overrides ? de.property.overrides.runtimeType : Bh, this.defaultValue = de;
        }
        evaluate(de) {
          if (de.formattedSection) {
            const Ce = this.defaultValue.property.overrides;
            if (Ce && Ce.hasOverride(de.formattedSection))
              return Ce.getOverride(de.formattedSection);
          }
          return de.feature && de.featureState ? this.defaultValue.evaluate(de.feature, de.featureState) : this.defaultValue.property.specification.default;
        }
        eachChild(de) {
          this.defaultValue.isConstant() || de(this.defaultValue.value._styleExpression.expression);
        }
        outputDefined() {
          return !1;
        }
        serialize() {
          return null;
        }
      }
      Ao(m2, "FormatSectionOverride", { omit: ["defaultValue"] });
      const L_ = () => k_ || (k_ = { layout: f2 || (f2 = new ys({ "symbol-placement": new lo(Bn.layout_symbol["symbol-placement"]), "symbol-spacing": new lo(Bn.layout_symbol["symbol-spacing"]), "symbol-avoid-edges": new lo(Bn.layout_symbol["symbol-avoid-edges"]), "symbol-sort-key": new Mo(Bn.layout_symbol["symbol-sort-key"]), "symbol-z-order": new lo(Bn.layout_symbol["symbol-z-order"]), "symbol-z-elevate": new lo(Bn.layout_symbol["symbol-z-elevate"]), "symbol-elevation-reference": new lo(Bn.layout_symbol["symbol-elevation-reference"]), "icon-allow-overlap": new lo(Bn.layout_symbol["icon-allow-overlap"]), "icon-ignore-placement": new lo(Bn.layout_symbol["icon-ignore-placement"]), "icon-optional": new lo(Bn.layout_symbol["icon-optional"]), "icon-rotation-alignment": new lo(Bn.layout_symbol["icon-rotation-alignment"]), "icon-size": new Mo(Bn.layout_symbol["icon-size"]), "icon-size-scale-range": new lo(Bn.layout_symbol["icon-size-scale-range"]), "icon-text-fit": new Mo(Bn.layout_symbol["icon-text-fit"]), "icon-text-fit-padding": new Mo(Bn.layout_symbol["icon-text-fit-padding"]), "icon-image": new Mo(Bn.layout_symbol["icon-image"]), "icon-rotate": new Mo(Bn.layout_symbol["icon-rotate"]), "icon-padding": new lo(Bn.layout_symbol["icon-padding"]), "icon-keep-upright": new lo(Bn.layout_symbol["icon-keep-upright"]), "icon-offset": new Mo(Bn.layout_symbol["icon-offset"]), "icon-anchor": new Mo(Bn.layout_symbol["icon-anchor"]), "icon-pitch-alignment": new lo(Bn.layout_symbol["icon-pitch-alignment"]), "text-pitch-alignment": new lo(Bn.layout_symbol["text-pitch-alignment"]), "text-rotation-alignment": new lo(Bn.layout_symbol["text-rotation-alignment"]), "text-field": new Mo(Bn.layout_symbol["text-field"]), "text-font": new Mo(Bn.layout_symbol["text-font"]), "text-size": new Mo(Bn.layout_symbol["text-size"]), "text-size-scale-range": new lo(Bn.layout_symbol["text-size-scale-range"]), "text-max-width": new Mo(Bn.layout_symbol["text-max-width"]), "text-line-height": new Mo(Bn.layout_symbol["text-line-height"]), "text-letter-spacing": new Mo(Bn.layout_symbol["text-letter-spacing"]), "text-justify": new Mo(Bn.layout_symbol["text-justify"]), "text-radial-offset": new Mo(Bn.layout_symbol["text-radial-offset"]), "text-variable-anchor": new lo(Bn.layout_symbol["text-variable-anchor"]), "text-anchor": new Mo(Bn.layout_symbol["text-anchor"]), "text-max-angle": new lo(Bn.layout_symbol["text-max-angle"]), "text-writing-mode": new lo(Bn.layout_symbol["text-writing-mode"]), "text-rotate": new Mo(Bn.layout_symbol["text-rotate"]), "text-padding": new lo(Bn.layout_symbol["text-padding"]), "text-keep-upright": new lo(Bn.layout_symbol["text-keep-upright"]), "text-transform": new Mo(Bn.layout_symbol["text-transform"]), "text-offset": new Mo(Bn.layout_symbol["text-offset"]), "text-allow-overlap": new lo(Bn.layout_symbol["text-allow-overlap"]), "text-ignore-placement": new lo(Bn.layout_symbol["text-ignore-placement"]), "text-optional": new lo(Bn.layout_symbol["text-optional"]), visibility: new lo(Bn.layout_symbol.visibility) })), paint: p2 || (p2 = new ys({ "icon-opacity": new Mo(Bn.paint_symbol["icon-opacity"]), "icon-occlusion-opacity": new Mo(Bn.paint_symbol["icon-occlusion-opacity"]), "icon-emissive-strength": new Mo(Bn.paint_symbol["icon-emissive-strength"]), "text-emissive-strength": new Mo(Bn.paint_symbol["text-emissive-strength"]), "icon-color": new Mo(Bn.paint_symbol["icon-color"]), "icon-halo-color": new Mo(Bn.paint_symbol["icon-halo-color"]), "icon-halo-width": new Mo(Bn.paint_symbol["icon-halo-width"]), "icon-halo-blur": new Mo(Bn.paint_symbol["icon-halo-blur"]), "icon-translate": new lo(Bn.paint_symbol["icon-translate"]), "icon-translate-anchor": new lo(Bn.paint_symbol["icon-translate-anchor"]), "icon-image-cross-fade": new Mo(Bn.paint_symbol["icon-image-cross-fade"]), "text-opacity": new Mo(Bn.paint_symbol["text-opacity"]), "text-occlusion-opacity": new Mo(Bn.paint_symbol["text-occlusion-opacity"]), "text-color": new Mo(Bn.paint_symbol["text-color"], { runtimeType: Dl, getOverride: (Ie) => Ie.textColor, hasOverride: (Ie) => !!Ie.textColor }), "text-halo-color": new Mo(Bn.paint_symbol["text-halo-color"]), "text-halo-width": new Mo(Bn.paint_symbol["text-halo-width"]), "text-halo-blur": new Mo(Bn.paint_symbol["text-halo-blur"]), "text-translate": new lo(Bn.paint_symbol["text-translate"]), "text-translate-anchor": new lo(Bn.paint_symbol["text-translate-anchor"]), "icon-color-saturation": new lo(Bn.paint_symbol["icon-color-saturation"]), "icon-color-contrast": new lo(Bn.paint_symbol["icon-color-contrast"]), "icon-color-brightness-min": new lo(Bn.paint_symbol["icon-color-brightness-min"]), "icon-color-brightness-max": new lo(Bn.paint_symbol["icon-color-brightness-max"]), "symbol-z-offset": new Mo(Bn.paint_symbol["symbol-z-offset"]), "icon-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }), "icon-halo-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }), "text-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }), "text-halo-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, k_);
      class cv extends Cl {
        constructor(de, Ce, De, Ke) {
          super(de, L_(), Ce, De, Ke), this._colorAdjustmentMatrix = Zr.mat4.identity([]), this.hasInitialOcclusionOpacityProperties = de.paint !== void 0 && ("icon-occlusion-opacity" in de.paint || "text-occlusion-opacity" in de.paint);
        }
        recalculate(de, Ce) {
          super.recalculate(de, Ce), this.layout.get("icon-rotation-alignment") === "auto" && (this.layout._values["icon-rotation-alignment"] = this.layout.get("symbol-placement") !== "point" ? "map" : "viewport"), this.layout.get("text-rotation-alignment") === "auto" && (this.layout._values["text-rotation-alignment"] = this.layout.get("symbol-placement") !== "point" ? "map" : "viewport"), this.layout.get("text-pitch-alignment") === "auto" && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), this.layout.get("icon-pitch-alignment") === "auto" && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
          const De = this.layout.get("text-writing-mode");
          if (De) {
            const Ke = [];
            for (const Ve of De)
              Ke.indexOf(Ve) < 0 && Ke.push(Ve);
            this.layout._values["text-writing-mode"] = Ke;
          } else
            this.layout._values["text-writing-mode"] = this.layout.get("symbol-placement") === "point" ? ["horizontal"] : ["horizontal", "vertical"];
          this._setPaintOverrides();
        }
        getColorAdjustmentMatrix(de, Ce, De, Ke) {
          return this._saturation === de && this._contrast === Ce && this._brightnessMin === De && this._brightnessMax === Ke || (this._colorAdjustmentMatrix = function(Ve, er, fr, wr) {
            Ve = _i(Ve), er = ai(er);
            const kr = Zr.mat4.create(), cr = Ve / 3, Mr = 1 - 2 * cr, Er = [Mr, cr, cr, 0, cr, Mr, cr, 0, cr, cr, Mr, 0, 0, 0, 0, 1], xr = 0.5 - 0.5 * er, Sr = wr - fr;
            return Zr.mat4.multiply(kr, [Sr, 0, 0, 0, 0, Sr, 0, 0, 0, 0, Sr, 0, fr, fr, fr, 1], [er, 0, 0, 0, 0, er, 0, 0, 0, 0, er, 0, xr, xr, xr, 1]), Zr.mat4.multiply(kr, kr, Er), kr;
          }(de, Ce, De, Ke), this._saturation = de, this._contrast = Ce, this._brightnessMin = De, this._brightnessMax = Ke), this._colorAdjustmentMatrix;
        }
        getValueAndResolveTokens(de, Ce, De, Ke) {
          const Ve = this.layout.get(de).evaluate(Ce, {}, De, Ke), er = this._unevaluatedLayout._values[de];
          return er.isDataDriven() || Up(er.value) || !Ve ? Ve : function(fr, wr) {
            return wr.replace(/{([^{}]+)}/g, (kr, cr) => cr in fr ? String(fr[cr]) : "");
          }(Ce.properties, Ve);
        }
        createBucket(de) {
          return new lv(de);
        }
        queryRadius() {
          return 0;
        }
        queryIntersectsFeature() {
          return !1;
        }
        _setPaintOverrides() {
          for (const de of L_().paint.overridableProperties) {
            if (!cv.hasPaintOverride(this.layout, de))
              continue;
            const Ce = this.paint.get(de), De = new m2(Ce), Ke = new mc(De, Ce.property.specification, this.scope, this.options);
            let Ve = null;
            Ve = Ce.value.kind === "constant" || Ce.value.kind === "source" ? new Vf("source", Ke) : new Wh("composite", Ke, Ce.value.zoomStops, Ce.value._interpolationType), this.paint._values[de] = new mh(Ce.property, Ve, Ce.parameters);
          }
        }
        _handleOverridablePaintPropertyUpdate(de, Ce, De) {
          return !(!this.layout || Ce.isDataDriven() || De.isDataDriven()) && cv.hasPaintOverride(this.layout, de);
        }
        static hasPaintOverride(de, Ce) {
          const De = de.get("text-field"), Ke = L_().paint.properties[Ce];
          let Ve = !1;
          const er = (fr) => {
            for (const wr of fr)
              if (Ke.overrides && Ke.overrides.hasOverride(wr))
                return void (Ve = !0);
          };
          if (De.value.kind === "constant" && De.value.value instanceof Ys)
            er(De.value.value.sections);
          else if (De.value.kind === "source") {
            const fr = (kr) => {
              Ve || (kr instanceof Yl && ds(kr.value) === es ? er(kr.value.sections) : kr instanceof Ds ? er(kr.sections) : kr.eachChild(fr));
            }, wr = De.value;
            wr._styleExpression && fr(wr._styleExpression.expression);
          }
          return Ve;
        }
        getProgramIds() {
          return ["symbol"];
        }
        getDefaultProgramParams(de, Ce, De) {
          return { config: new bh(this, { zoom: Ce, lut: De }), overrideFog: !1 };
        }
      }
      let g2, v2, _2, y2;
      var I_ = La([{ name: "a_pos", type: "Int16", components: 2 }, { name: "a_texture_pos", type: "Int16", components: 2 }]);
      function B_(Ie) {
        switch (Ie) {
          case WebGL2RenderingContext.RGBA8:
            return WebGL2RenderingContext.RGBA;
          case WebGL2RenderingContext.DEPTH_COMPONENT16:
            return WebGL2RenderingContext.DEPTH_COMPONENT;
          case WebGL2RenderingContext.DEPTH24_STENCIL8:
            return WebGL2RenderingContext.DEPTH_STENCIL;
          case WebGL2RenderingContext.R8:
          case WebGL2RenderingContext.R32F:
            return WebGL2RenderingContext.RED;
        }
      }
      function $_(Ie) {
        switch (Ie) {
          case WebGL2RenderingContext.RGBA8:
            return WebGL2RenderingContext.UNSIGNED_BYTE;
          case WebGL2RenderingContext.DEPTH_COMPONENT16:
            return WebGL2RenderingContext.UNSIGNED_SHORT;
          case WebGL2RenderingContext.DEPTH24_STENCIL8:
            return WebGL2RenderingContext.UNSIGNED_INT_24_8;
          case WebGL2RenderingContext.R8:
            return WebGL2RenderingContext.UNSIGNED_BYTE;
          case WebGL2RenderingContext.R32F:
            return WebGL2RenderingContext.FLOAT;
        }
      }
      class R_ {
        constructor(de, Ce, De, Ke) {
          this.context = de, this.format = De, this.useMipmap = Ke && Ke.useMipmap, this.texture = de.gl.createTexture(), this.update(Ce, { premultiply: Ke && Ke.premultiply });
        }
        update(de, Ce) {
          const De = de && de instanceof HTMLVideoElement && de.width === 0 ? de.videoWidth : de.width, Ke = de && de instanceof HTMLVideoElement && de.height === 0 ? de.videoHeight : de.height, { context: Ve } = this, { gl: er } = Ve, { x: fr, y: wr } = Ce && Ce.position ? Ce.position : { x: 0, y: 0 }, kr = fr + De, cr = wr + Ke;
          !this.size || this.size[0] === kr && this.size[1] === cr || (er.bindTexture(er.TEXTURE_2D, null), er.deleteTexture(this.texture), this.texture = er.createTexture(), this.size = null), er.bindTexture(er.TEXTURE_2D, this.texture), Ve.pixelStoreUnpackFlipY.set(!1), Ve.pixelStoreUnpack.set(1), Ve.pixelStoreUnpackPremultiplyAlpha.set(this.format === er.RGBA8 && (!Ce || Ce.premultiply !== !1));
          const Mr = de instanceof HTMLImageElement || de instanceof HTMLCanvasElement || de instanceof HTMLVideoElement || de instanceof ImageData || ImageBitmap && de instanceof ImageBitmap;
          if (!this.size && kr > 0 && cr > 0) {
            const Er = this.useMipmap ? Math.floor(Math.log2(Math.max(kr, cr))) + 1 : 1;
            er.texStorage2D(er.TEXTURE_2D, Er, this.format, kr, cr), this.size = [kr, cr];
          }
          if (this.size)
            if (Mr)
              er.texSubImage2D(er.TEXTURE_2D, 0, fr, wr, B_(this.format), $_(this.format), de);
            else {
              const Er = de.data;
              Er && er.texSubImage2D(er.TEXTURE_2D, 0, fr, wr, De, Ke, B_(this.format), $_(this.format), Er);
            }
          this.useMipmap && er.generateMipmap(er.TEXTURE_2D);
        }
        bind(de, Ce, De = !1) {
          const { context: Ke } = this, { gl: Ve } = Ke;
          Ve.bindTexture(Ve.TEXTURE_2D, this.texture), de !== this.minFilter && (Ve.texParameteri(Ve.TEXTURE_2D, Ve.TEXTURE_MAG_FILTER, de), Ve.texParameteri(Ve.TEXTURE_2D, Ve.TEXTURE_MIN_FILTER, this.useMipmap && !De ? de === Ve.NEAREST ? Ve.NEAREST_MIPMAP_NEAREST : Ve.LINEAR_MIPMAP_LINEAR : de), this.minFilter = de), Ce !== this.wrapS && (Ve.texParameteri(Ve.TEXTURE_2D, Ve.TEXTURE_WRAP_S, Ce), Ve.texParameteri(Ve.TEXTURE_2D, Ve.TEXTURE_WRAP_T, Ce), this.wrapS = Ce);
        }
        bindExtraParam(de, Ce, De, Ke) {
          const { context: Ve } = this, { gl: er } = Ve;
          er.bindTexture(er.TEXTURE_2D, this.texture), Ce !== this.magFilter && (er.texParameteri(er.TEXTURE_2D, er.TEXTURE_MAG_FILTER, Ce), this.magFilter = Ce), de !== this.minFilter && (er.texParameteri(er.TEXTURE_2D, er.TEXTURE_MIN_FILTER, this.useMipmap ? de === er.NEAREST ? er.NEAREST_MIPMAP_NEAREST : er.LINEAR_MIPMAP_LINEAR : de), this.minFilter = de), De !== this.wrapS && (er.texParameteri(er.TEXTURE_2D, er.TEXTURE_WRAP_S, De), this.wrapS = De), Ke !== this.wrapT && (er.texParameteri(er.TEXTURE_2D, er.TEXTURE_WRAP_T, Ke), this.wrapT = Ke);
        }
        destroy() {
          const { gl: de } = this.context;
          de.deleteTexture(this.texture), this.texture = null;
        }
      }
      class uv {
        constructor(de, Ce) {
          this.context = de, this.texture = Ce;
        }
        bind(de, Ce) {
          const { context: De } = this, { gl: Ke } = De;
          Ke.bindTexture(Ke.TEXTURE_2D, this.texture), de !== this.minFilter && (Ke.texParameteri(Ke.TEXTURE_2D, Ke.TEXTURE_MAG_FILTER, de), Ke.texParameteri(Ke.TEXTURE_2D, Ke.TEXTURE_MIN_FILTER, de), this.minFilter = de), Ce !== this.wrapS && (Ke.texParameteri(Ke.TEXTURE_2D, Ke.TEXTURE_WRAP_S, Ce), Ke.texParameteri(Ke.TEXTURE_2D, Ke.TEXTURE_WRAP_T, Ce), this.wrapS = Ce);
        }
      }
      function hv(Ie, de, Ce, De, Ke, Ve, er, fr) {
        const wr = [Ie, de, 1, Ce, De, 1, Ke, Ve, 1], kr = [er, fr, 1], cr = Zr.mat3.adjoint([], wr), [Mr, Er, xr] = Zr.vec3.transformMat3(kr, kr, cr);
        return Zr.mat3.multiply(wr, wr, [Mr, 0, 0, 0, Er, 0, 0, 0, xr]);
      }
      function b2(Ie, de, Ce, De, Ke, Ve, er, fr) {
        const wr = function(kr, cr, Mr, Er, xr, Sr, Br, Fr) {
          const jr = hv(0, 0, 1, 0, 1, 1, 0, 1), Qr = hv(kr, cr, Mr, Er, xr, Sr, Br, Fr), ti = Zr.mat3.adjoint([], jr);
          return Zr.mat3.multiply(Qr, Qr, ti);
        }(Ie, de, Ce, De, Ke, Ve, er, fr);
        return [wr[2] / wr[8] / vo, wr[5] / wr[8] / vo];
      }
      function dv(Ie) {
        return [Ie[0], Math.min(Math.max(Ie[1], -Es), Es)];
      }
      class x2 extends Ih {
        constructor(de, Ce, De, Ke) {
          super(), this.id = de, this.dispatcher = De, this.coordinates = Ce.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.onNorthPole = !1, this.onSouthPole = !1, this.setEventedParent(Ke), this.options = Ce, this._dirty = !1;
        }
        load(de, Ce) {
          if (this._loaded = Ce || !1, this.fire(new Nc("dataloading", { dataType: "source" })), this.url = this.options.url, !this.url)
            return de && (this.coordinates = de), this._loaded = !0, void this._finishLoading();
          this._imageRequest = ju(this.map._requestManager.transformRequest(this.url, Xa.Image), (De, Ke) => {
            this._imageRequest = null, this._loaded = !0, De ? this.fire(new Xl(De)) : Ke && (this.image = Ke instanceof HTMLImageElement ? _n.getImageData(Ke) : Ke, this._dirty = !0, this.width = this.image.width, this.height = this.image.height, de && (this.coordinates = de), this._finishLoading());
          });
        }
        loaded() {
          return this._loaded;
        }
        updateImage(de) {
          return de.url ? (this._imageRequest && de.url !== this.options.url && (this._imageRequest.cancel(), this._imageRequest = null), this.options.url = de.url, this.load(de.coordinates, this._loaded), this) : this;
        }
        setTexture(de) {
          if (!(de.handle instanceof WebGLTexture))
            throw new Error("The provided handle is not a WebGLTexture instance");
          return this.texture = new uv(this.map.painter.context, de.handle), this.width = de.dimensions[0], this.height = de.dimensions[1], this._dirty = !1, this._loaded = !0, this._finishLoading(), this;
        }
        _finishLoading() {
          this.map && (this.setCoordinates(this.coordinates), this.fire(new Nc("data", { dataType: "source", sourceDataType: "metadata" })));
        }
        onAdd(de) {
          this.map = de, this.load();
        }
        onRemove(de) {
          this._imageRequest && (this._imageRequest.cancel(), this._imageRequest = null), !this.texture || this.texture instanceof uv || this.texture.destroy(), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy());
        }
        setCoordinates(de) {
          if (this.coordinates = de, this._boundsArray = void 0, this._unsupportedCoords = !1, !de.length)
            return this;
          this.onNorthPole = !1, this.onSouthPole = !1;
          let Ce = de[0][1], De = de[0][1];
          for (const Ve of de)
            Ve[1] > De && (De = Ve[1]), Ve[1] < Ce && (Ce = Ve[1]);
          const Ke = (De + Ce) / 2;
          if (Ke > Es ? this.onNorthPole = !0 : Ke < -Es && (this.onSouthPole = !0), !this.onNorthPole && !this.onSouthPole) {
            const Ve = de.map(ir.fromLngLat);
            this.tileID = function(er) {
              let fr = 1 / 0, wr = 1 / 0, kr = -1 / 0, cr = -1 / 0;
              for (const Br of er)
                fr = Math.min(fr, Br.x), wr = Math.min(wr, Br.y), kr = Math.max(kr, Br.x), cr = Math.max(cr, Br.y);
              const Mr = Math.max(kr - fr, cr - wr), Er = Math.max(0, Math.floor(-Math.log(Mr) / Math.LN2)), xr = Math.pow(2, Er);
              let Sr = Math.floor((fr + kr) / 2 * xr);
              return Sr > 1 && (Sr -= 1), new _o(Er, Sr, Math.floor((wr + cr) / 2 * xr));
            }(Ve), this.minzoom = this.maxzoom = this.tileID.z;
          }
          return this.fire(new Nc("data", { dataType: "source", sourceDataType: "content" })), this;
        }
        _clear() {
          this._boundsArray = void 0, this._unsupportedCoords = !1;
        }
        _prepareData(de) {
          for (const jr in this.tiles) {
            const Qr = this.tiles[jr];
            Qr.state !== "loaded" && (Qr.state = "loaded", Qr.texture = this.texture);
          }
          if (this._boundsArray || this.onNorthPole || this.onSouthPole || this._unsupportedCoords)
            return;
          const Ce = dr(new _o(0, 0, 0), this.map.transform.projection), De = [Ce.projection.project(this.coordinates[0][0], this.coordinates[0][1]), Ce.projection.project(this.coordinates[1][0], this.coordinates[1][1]), Ce.projection.project(this.coordinates[2][0], this.coordinates[2][1]), Ce.projection.project(this.coordinates[3][0], this.coordinates[3][1])];
          if (!function(jr) {
            const Qr = jr[1].x - jr[0].x, ti = jr[1].y - jr[0].y, Kr = jr[2].x - jr[1].x, ni = jr[2].y - jr[1].y, gi = jr[3].x - jr[2].x, Si = jr[3].y - jr[2].y, Di = jr[0].x - jr[3].x, Ri = jr[0].y - jr[3].y, Bi = Qr * ni - Kr * ti, Ji = Kr * Si - gi * ni, Fi = gi * Ri - Di * Si, tn = Di * ti - Qr * Ri;
            return Bi > 0 && Ji > 0 && Fi > 0 && tn > 0 || Bi < 0 && Ji < 0 && Fi < 0 && tn < 0;
          }(De))
            return console.warn("Image source coordinates are defining non-convex area in the Mercator projection"), void (this._unsupportedCoords = !0);
          const Ke = dr(this.tileID, this.map.transform.projection), [Ve, er, fr, wr] = this.coordinates.map((jr) => {
            const Qr = Ke.projection.project(jr[0], jr[1]);
            return Cr(Ke, Qr)._round();
          });
          this.perspectiveTransform = b2(Ve.x, Ve.y, er.x, er.y, fr.x, fr.y, wr.x, wr.y);
          const kr = this._boundsArray = new $u();
          kr.emplaceBack(Ve.x, Ve.y, 0, 0), kr.emplaceBack(er.x, er.y, vo, 0), kr.emplaceBack(wr.x, wr.y, 0, vo), kr.emplaceBack(fr.x, fr.y, vo, vo), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy()), this.boundsBuffer = de.createVertexBuffer(kr, I_.members), this.boundsSegments = fs.simpleSegment(0, 0, 4, 2);
          const cr = [], Mr = [dv((Er = this.coordinates)[0]), dv(Er[1]), dv(Er[2]), dv(Er[3])];
          var Er;
          const [xr, Sr, Br, Fr] = function(jr) {
            let Qr = jr[0][0], ti = Qr, Kr = jr[0][1], ni = Kr;
            for (let gi = 1; gi < jr.length; gi++)
              jr[gi][0] < Qr ? Qr = jr[gi][0] : jr[gi][0] > ti && (ti = jr[gi][0]), jr[gi][1] < Kr ? Kr = jr[gi][1] : jr[gi][1] > ni && (ni = jr[gi][1]);
            return [Qr, Kr, ti - Qr, ni - Kr];
          }(Mr);
          {
            const jr = new $u(), [Qr, ti, Kr, ni] = function(wn) {
              let Cn = wn[0].x, gn = Cn, Nn = wn[0].y, oo = Nn;
              for (let Un = 1; Un < wn.length; Un++)
                wn[Un].x < Cn ? Cn = wn[Un].x : wn[Un].x > gn && (gn = wn[Un].x), wn[Un].y < Nn ? Nn = wn[Un].y : wn[Un].y > oo && (oo = wn[Un].y);
              return [Cn, Nn, gn - Cn, oo - Nn];
            }(De), gi = (wn) => [(wn.x - Qr) / Kr, (wn.y - ti) / ni], [Si, Di, Ri, Bi] = De.map(gi), Ji = function(wn, Cn, gn, Nn, oo, Un, fo, ho) {
              const bo = hv(0, 0, 1, 0, 1, 1, 0, 1), Jn = hv(wn, Cn, gn, Nn, oo, Un, fo, ho), Ro = Zr.mat3.adjoint([], Jn);
              return Zr.mat3.multiply(bo, bo, Ro);
            }(Si[0], Si[1], Di[0], Di[1], Ri[0], Ri[1], Bi[0], Bi[1]);
            this.elevatedGlobePerspectiveTransform = b2(Si[0], Si[1], Di[0], Di[1], Ri[0], Ri[1], Bi[0], Bi[1]);
            const Fi = (wn, Cn) => {
              cr.push(wn.lng);
              const gn = Math.round((wn.lng - xr) / Br * vo), Nn = Math.round((wn.lat - Sr) / Fr * vo), oo = gi(Cn), Un = Zr.vec3.transformMat3([], [oo[0], oo[1], 1], Ji), fo = Math.round(Un[0] / Un[2] * vo), ho = Math.round(Un[1] / Un[2] * vo);
              jr.emplaceBack(gn, Nn, fo, ho);
            }, tn = De[3].x - De[0].x, cn = De[3].y - De[0].y, ln = De[2].x - De[1].x, mn = De[2].y - De[1].y;
            for (let wn = 0; wn < 65; wn++) {
              const Cn = wn / 64, gn = [De[0].x + Cn * tn, De[0].y + Cn * cn], Nn = [De[1].x + Cn * ln, De[1].y + Cn * mn], oo = Nn[0] - gn[0], Un = Nn[1] - gn[1];
              for (let fo = 0; fo < 65; fo++) {
                const ho = fo / 64, bo = { x: gn[0] + oo * ho, y: gn[1] + Un * ho, z: 0 };
                Fi(Ce.projection.unproject(bo.x, bo.y), bo);
              }
            }
            this.elevatedGlobeVertexBuffer = de.createVertexBuffer(jr, I_.members);
          }
          {
            this.maxLongitudeTriangleSize = 0;
            let jr = [], Qr = new tl();
            const ti = (Kr, ni, gi) => {
              Qr.emplaceBack(Kr, ni, gi);
              const Si = cr[Kr], Di = cr[ni], Ri = cr[gi], Bi = Math.min(Math.min(Si, Di), Ri), Ji = Math.max(Math.max(Si, Di), Ri) - Bi;
              Ji > this.maxLongitudeTriangleSize && (this.maxLongitudeTriangleSize = Ji), jr.push(Bi + Ji / 2);
            };
            for (let Kr = 0; Kr < 64; Kr++)
              for (let ni = 0; ni < 64; ni++) {
                const gi = 65 * Kr + ni, Si = gi + 1, Di = gi + 65, Ri = Di + 1;
                ti(gi, Di, Si), ti(Si, Di, Ri);
              }
            [jr, Qr] = function(Kr, ni) {
              const gi = Array.from({ length: Kr.length }, (Ri, Bi) => Bi);
              gi.sort((Ri, Bi) => Kr[Ri] - Kr[Bi]);
              const Si = [], Di = new tl();
              for (let Ri = 0; Ri < gi.length; Ri++) {
                const Bi = gi[Ri];
                Si.push(Kr[Bi]);
                const Ji = 3 * Bi, Fi = Ji + 1;
                Di.emplaceBack(ni.uint16[Ji], ni.uint16[Fi], ni.uint16[Fi + 1]);
              }
              return [Si, Di];
            }(jr, Qr), this.elevatedGlobeTrianglesCenterLongitudes = jr, this.elevatedGlobeIndexBuffer = de.createIndexBuffer(Qr);
          }
          this.elevatedGlobeSegments = fs.simpleSegment(0, 0, 4225, 8192), this.elevatedGlobeGridMatrix = new Float32Array([0, Br / vo, 0, Fr / vo, 0, 0, Sr, xr, 0]);
        }
        prepare() {
          const de = Object.keys(this.tiles).length !== 0;
          if (this.tileID && !de)
            return;
          const Ce = this.map.painter.context, De = Ce.gl;
          !this._dirty || this.texture instanceof uv || (this.texture ? this.texture.update(this.image) : (this.texture = new R_(Ce, this.image, De.RGBA8), this.texture.bind(De.LINEAR, De.CLAMP_TO_EDGE)), this._dirty = !1), de && this._prepareData(Ce);
        }
        loadTile(de, Ce) {
          this.tileID && this.tileID.equals(de.tileID.canonical) ? (this.tiles[String(de.tileID.wrap)] = de, de.buckets = {}, Ce(null)) : (de.state = "errored", Ce(null));
        }
        serialize() {
          return { type: "image", url: this.options.url, coordinates: this.coordinates };
        }
        hasTransition() {
          return !1;
        }
        getSegmentsForLongitude(de) {
          const Ce = this.elevatedGlobeSegments;
          if (!this.elevatedGlobeTrianglesCenterLongitudes || !Ce)
            return null;
          const De = this.elevatedGlobeTrianglesCenterLongitudes;
          let Ke = (Ve = de + 180) + 360 * Math.round((De[0] - Ve) / 360);
          var Ve;
          const er = new fs(), fr = (Mr, Er) => {
            er.segments.push({ vertexOffset: 0, primitiveOffset: Mr, vertexLength: Ce.segments[0].vertexLength, primitiveLength: Er, sortKey: void 0, vaos: {} });
          }, wr = 0.51 * this.maxLongitudeTriangleSize;
          if (Math.abs(De[0] - Ke) <= wr) {
            const Mr = kn(De, 0, De.length, Ke + wr);
            return Mr === De.length || fr(Mr, co(De, Mr + 1, De.length, Ke + 360 - wr) - Mr), er;
          }
          Ke < De[0] && (Ke += 360);
          const kr = co(De, 0, De.length, Ke - wr);
          if (kr === De.length)
            return fr(0, De.length), er;
          fr(0, kr - 0);
          const cr = kn(De, kr + 1, De.length, Ke + wr);
          return cr !== De.length && fr(cr, De.length - cr), er;
        }
      }
      const Zy = (Math.pow(256, 2) - 1) / 16907520;
      class w2 extends Cl {
        constructor(de, Ce, De, Ke) {
          super(de, { layout: _2 || (_2 = new ys({ visibility: new lo(Bn.layout_raster.visibility) })), paint: y2 || (y2 = new ys({ "raster-opacity": new lo(Bn.paint_raster["raster-opacity"]), "raster-color": new Jh(Bn.paint_raster["raster-color"]), "raster-color-mix": new lo(Bn.paint_raster["raster-color-mix"]), "raster-color-range": new lo(Bn.paint_raster["raster-color-range"]), "raster-hue-rotate": new lo(Bn.paint_raster["raster-hue-rotate"]), "raster-brightness-min": new lo(Bn.paint_raster["raster-brightness-min"]), "raster-brightness-max": new lo(Bn.paint_raster["raster-brightness-max"]), "raster-saturation": new lo(Bn.paint_raster["raster-saturation"]), "raster-contrast": new lo(Bn.paint_raster["raster-contrast"]), "raster-resampling": new lo(Bn.paint_raster["raster-resampling"]), "raster-fade-duration": new lo(Bn.paint_raster["raster-fade-duration"]), "raster-emissive-strength": new lo(Bn.paint_raster["raster-emissive-strength"]), "raster-array-band": new lo(Bn.paint_raster["raster-array-band"]), "raster-elevation": new lo(Bn.paint_raster["raster-elevation"]), "raster-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, Ce, De, Ke), this.updateColorRamp(), this._curRampRange = [NaN, NaN];
        }
        getProgramIds() {
          return ["raster"];
        }
        hasColorMap() {
          return !!this._transitionablePaint._values["raster-color"].value.value;
        }
        tileCoverLift() {
          return this.paint.get("raster-elevation");
        }
        isDraped(de) {
          return !(de && de._source instanceof x2 && (de._source.onNorthPole || de._source.onSouthPole)) && this.paint.get("raster-elevation") === 0;
        }
        _handleSpecialPaintPropertyUpdate(de) {
          de !== "raster-color" && de !== "raster-color-range" || (this._curRampRange = [NaN, NaN], this.updateColorRamp());
        }
        updateColorRamp(de) {
          if (!this.hasColorMap() || !this._curRampRange)
            return;
          const Ce = this._transitionablePaint._values["raster-color"].value.expression, [De, Ke] = de || this._transitionablePaint._values["raster-color-range"].value.expression.evaluate({ zoom: 0 }) || [NaN, NaN];
          isNaN(De) && isNaN(Ke) || De === this._curRampRange[0] && Ke === this._curRampRange[1] || (this.colorRamp = im({ expression: Ce, evaluationKey: "rasterValue", image: this.colorRamp, clips: [{ start: De, end: Ke }], resolution: 256 }), this.colorRampTexture = null, this._curRampRange = [De, Ke]);
        }
      }
      let M2, S2, E2, C2, T2;
      class A2 extends Cl {
        constructor(de, Ce, De, Ke) {
          super(de, { layout: M2 || (M2 = new ys({ visibility: new lo(Bn["layout_raster-particle"].visibility) })), paint: S2 || (S2 = new ys({ "raster-particle-array-band": new lo(Bn["paint_raster-particle"]["raster-particle-array-band"]), "raster-particle-count": new lo(Bn["paint_raster-particle"]["raster-particle-count"]), "raster-particle-color": new Jh(Bn["paint_raster-particle"]["raster-particle-color"]), "raster-particle-max-speed": new lo(Bn["paint_raster-particle"]["raster-particle-max-speed"]), "raster-particle-speed-factor": new lo(Bn["paint_raster-particle"]["raster-particle-speed-factor"]), "raster-particle-fade-opacity-factor": new lo(Bn["paint_raster-particle"]["raster-particle-fade-opacity-factor"]), "raster-particle-reset-rate-factor": new lo(Bn["paint_raster-particle"]["raster-particle-reset-rate-factor"]), "raster-particle-elevation": new lo(Bn["paint_raster-particle"]["raster-particle-elevation"]), "raster-particle-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, Ce, De, Ke), this._updateColorRamp(), this.lastInvalidatedAt = _n.now();
        }
        onRemove(de) {
          this.colorRampTexture && this.colorRampTexture.destroy(), this.tileFramebuffer && this.tileFramebuffer.destroy(), this.particleFramebuffer && this.particleFramebuffer.destroy();
        }
        hasColorMap() {
          return !!this._transitionablePaint._values["raster-particle-color"].value.value;
        }
        getProgramIds() {
          return ["rasterParticle"];
        }
        hasOffscreenPass() {
          return this.visibility !== "none";
        }
        isDraped(de) {
          return !1;
        }
        _handleSpecialPaintPropertyUpdate(de) {
          de !== "raster-particle-color" && de !== "raster-particle-max-speed" || (this._updateColorRamp(), this._invalidateAnimationState()), de === "raster-particle-count" && this._invalidateAnimationState();
        }
        _updateColorRamp() {
          if (!this.hasColorMap())
            return;
          const de = this._transitionablePaint._values["raster-particle-color"].value.expression, Ce = this._transitionablePaint._values["raster-particle-max-speed"].value.expression.evaluate({ zoom: 0 });
          this.colorRamp = im({ expression: de, evaluationKey: "rasterParticleSpeed", image: this.colorRamp, clips: [{ start: 0, end: Ce }], resolution: 256 }), this.colorRampTexture = null;
        }
        _invalidateAnimationState() {
          this.lastInvalidatedAt = _n.now();
        }
        tileCoverLift() {
          return this.paint.get("raster-particle-elevation");
        }
      }
      class Xy extends Cl {
        constructor(de, Ce) {
          super(de, {}, Ce, null), this.implementation = de, de.slot && (this.slot = de.slot);
        }
        is3D() {
          return this.implementation.renderingMode === "3d";
        }
        hasOffscreenPass() {
          return this.implementation.prerender !== void 0;
        }
        isDraped(de) {
          return this.implementation.renderToTile !== void 0;
        }
        shouldRedrape() {
          return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
        }
        recalculate() {
        }
        updateTransitions() {
        }
        hasTransition() {
          return !1;
        }
        serialize() {
        }
        onAdd(de) {
          this.implementation.onAdd && this.implementation.onAdd(de, de.painter.context.gl);
        }
        onRemove(de) {
          this.implementation.onRemove && this.implementation.onRemove(de, de.painter.context.gl);
        }
      }
      function P_(Ie, de, Ce) {
        const De = [0, 0, 1], Ke = Zr.quat.identity([]);
        return Zr.quat.rotateY(Ke, Ke, Ce ? -rn(Ie) + Math.PI : rn(Ie)), Zr.quat.rotateX(Ke, Ke, -rn(de)), Zr.vec3.transformQuat(De, De, Ke), Zr.vec3.normalize(De, De);
      }
      function k2(Ie, de) {
        const Ce = fv(Ie.projection, Ie.zoom, Ie.width, Ie.height), De = function(Ve, er, fr, wr, kr) {
          const cr = new Ba(fr.lng - 180 * vp, fr.lat), Mr = new Ba(fr.lng + 180 * vp, fr.lat), Er = Ve.project(cr.lng, cr.lat), xr = Ve.project(Mr.lng, Mr.lat), Sr = -Math.atan2(xr.y - Er.y, xr.x - Er.x), Br = ir.fromLngLat(fr);
          Br.y = vn(Br.y, -1 + vp, 1 - vp);
          const Fr = Br.toLngLat(), jr = Ve.project(Fr.lng, Fr.lat), Qr = ir.fromLngLat(Fr);
          Qr.x += vp;
          const ti = Qr.toLngLat(), Kr = Ve.project(ti.lng, ti.lat), ni = I2(Kr.x - jr.x, Kr.y - jr.y, Sr), gi = ir.fromLngLat(Fr);
          gi.y += vp;
          const Si = gi.toLngLat(), Di = Ve.project(Si.lng, Si.lat), Ri = I2(Di.x - jr.x, Di.y - jr.y, Sr), Bi = Math.abs(ni.x) / Math.abs(Ri.y), Ji = Zr.mat4.identity([]);
          Zr.mat4.rotateZ(Ji, Ji, -Sr * (1 - (kr ? 0 : wr)));
          const Fi = Zr.mat4.identity([]);
          return Zr.mat4.scale(Fi, Fi, [1, 1 - (1 - Bi) * wr, 1]), Fi[4] = -Ri.x / Ri.y * wr, Zr.mat4.rotateZ(Fi, Fi, Sr), Zr.mat4.multiply(Fi, Ji, Fi), Fi;
        }(Ie.projection, 0, Ie.center, Ce, de), Ke = L2(Ie);
        return Zr.mat4.scale(De, De, [Ke, Ke, 1]), De;
      }
      function L2(Ie) {
        const de = Ie.projection, Ce = fv(Ie.projection, Ie.zoom, Ie.width, Ie.height), De = D_(de, Ie.center), Ke = D_(de, Ba.convert(de.center));
        return Math.pow(2, De * Ce + (1 - Ce) * Ke);
      }
      function fv(Ie, de, Ce, De, Ke = 1 / 0) {
        const Ve = Ie.range;
        if (!Ve)
          return 0;
        const er = Math.min(Ke, Math.max(Ce, De)), fr = Math.log(er / 1024) / Math.LN2;
        return Vn(Ve[0] + fr, Ve[1] + fr, de);
      }
      const vp = 1 / 4e4;
      function D_(Ie, de) {
        const Ce = vn(de.lat, -Es, Es), De = new Ba(de.lng - 180 * vp, Ce), Ke = new Ba(de.lng + 180 * vp, Ce), Ve = Ie.project(De.lng, Ce), er = Ie.project(Ke.lng, Ce), fr = ir.fromLngLat(De), wr = ir.fromLngLat(Ke), kr = er.x - Ve.x, cr = er.y - Ve.y, Mr = wr.x - fr.x, Er = wr.y - fr.y, xr = Math.sqrt((Mr * Mr + Er * Er) / (kr * kr + cr * cr));
        return Math.log(xr) / Math.LN2;
      }
      function I2(Ie, de, Ce) {
        const De = Math.cos(Ce), Ke = Math.sin(Ce);
        return { x: Ie * De - de * Ke, y: Ie * Ke + de * De };
      }
      function B2(Ie, de, Ce) {
        Zr.mat4.identity(Ie), Zr.mat4.rotateZ(Ie, Ie, rn(de[2])), Zr.mat4.rotateX(Ie, Ie, rn(de[0])), Zr.mat4.rotateY(Ie, Ie, rn(de[1])), Zr.mat4.scale(Ie, Ie, Ce), Zr.mat4.multiply(Ie, Ie, [1, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
      }
      function pv(Ie, de, Ce, De, Ke, Ve, er, fr) {
        const wr = [Ce[0] - de[0], Ce[1] - de[1], 0], kr = [De[0] - de[0], De[1] - de[1], 0];
        if (Zr.vec3.length(wr) < 1e-12 || Zr.vec3.length(kr) < 1e-12)
          return Zr.quat.identity(Ie);
        const cr = Zr.vec3.cross([], wr, kr);
        Zr.vec3.normalize(cr, cr), Zr.vec3.subtract(kr, De, de), wr[2] = (Ve - Ke) * fr, kr[2] = (er - Ke) * fr;
        const Mr = wr;
        return Zr.vec3.cross(Mr, wr, kr), Zr.vec3.normalize(Mr, Mr), Zr.quat.rotationTo(Ie, cr, Mr);
      }
      function O_(Ie, de, Ce = !1) {
        const De = gl(de.zoom), Ke = function(Ve, er, fr) {
          const wr = er.worldSize, kr = [Ve[12], Ve[13], Ve[14]], cr = Fs(kr[1] / wr), Mr = bs(kr[0] / wr), Er = Zr.mat4.identity([]), xr = As(1, cr) * wr, Sr = As(1, 0) * wr * xe(cr, er.zoom), Br = 1 / Rl(wr);
          let Fr = Sr * Br;
          if (fr) {
            const Kr = fv(er.projection, er.zoom, er.width, er.height, 1024);
            Fr = Br * er.projection.pixelSpaceConversion(er.center.lat, wr, Kr);
          }
          const jr = zu(cr, Mr);
          Zr.vec3.add(jr, jr, Zr.vec3.scale([], Zr.vec3.normalize([], jr), xr * Fr * kr[2]));
          const Qr = function(Kr) {
            const ni = [Kr[0], Kr[1], Kr[2]];
            let gi = [0, 1, 0];
            const Si = Zr.vec3.cross([], gi, ni);
            return Zr.vec3.cross(gi, ni, Si), Zr.vec3.squaredLength(gi) === 0 && (gi = [0, 1, 0], Zr.vec3.cross(Si, ni, gi)), Zr.vec3.normalize(Si, Si), Zr.vec3.normalize(gi, gi), Zr.vec3.normalize(ni, ni), [Si[0], Si[1], Si[2], 0, gi[0], gi[1], gi[2], 0, ni[0], ni[1], ni[2], 0, Kr[0], Kr[1], Kr[2], 1];
          }(jr);
          Zr.mat4.scale(Er, Er, [Fr, Fr, Fr * xr]), Zr.mat4.translate(Er, Er, [-kr[0], -kr[1], -kr[2]]);
          const ti = Zr.mat4.multiply([], er.globeMatrix, Qr);
          return Zr.mat4.multiply(ti, ti, Er), Zr.mat4.multiply(ti, ti, Ve), ti;
        }(Ie, de, Ce);
        if (De > 0) {
          const Ve = function(er, fr) {
            const wr = fr.worldSize, kr = As(1, 0) * wr * xe(fr.center.lat, fr.zoom) / Rl(wr), cr = As(1, fr.center.lat) * wr, Mr = Zr.mat4.identity([]);
            return Zr.mat4.rotateY(Mr, Mr, rn(fr.center.lng)), Zr.mat4.rotateX(Mr, Mr, rn(fr.center.lat)), Zr.mat4.translate(Mr, Mr, [0, 0, il]), Zr.mat4.scale(Mr, Mr, [kr, kr, kr * cr]), Zr.mat4.translate(Mr, Mr, [fr.point.x - 0.5 * wr, fr.point.y - 0.5 * wr, 0]), Zr.mat4.multiply(Mr, Mr, er), Zr.mat4.multiply(Mr, fr.globeMatrix, Mr);
          }(Ie, de);
          return function(er, fr, wr) {
            const kr = (Sr, Br, Fr) => {
              const jr = Zr.vec3.length(Sr), Qr = Zr.vec3.length(Br), ti = ks(Sr, Br, Fr);
              return Zr.vec3.scale(ti, ti, 1 / Zr.vec3.length(ti) * Ho(jr, Qr, Fr));
            }, cr = kr([er[0], er[1], er[2]], [fr[0], fr[1], fr[2]], wr), Mr = kr([er[4], er[5], er[6]], [fr[4], fr[5], fr[6]], wr), Er = kr([er[8], er[9], er[10]], [fr[8], fr[9], fr[10]], wr), xr = ks([er[12], er[13], er[14]], [fr[12], fr[13], fr[14]], wr);
            return [cr[0], cr[1], cr[2], 0, Mr[0], Mr[1], Mr[2], 0, Er[0], Er[1], Er[2], 0, xr[0], xr[1], xr[2], 1];
          }(Ke, Ve, De);
        }
        return Ke;
      }
      function $2(Ie, de, Ce, De) {
        const Ke = qo.projectAabbCorners(De, Ce);
        let Ve = Number.MAX_VALUE, er = -1;
        for (let kr = 0; kr < Ke.length; ++kr) {
          const cr = Ke[kr];
          cr[0] = (0.5 * cr[0] + 0.5) * de.width, cr[1] = (0.5 - 0.5 * cr[1]) * de.height, cr[2] < Ve && (er = kr, Ve = cr[2]);
        }
        const fr = (kr) => new qi(Ke[kr][0], Ke[kr][1]);
        let wr;
        switch (er) {
          case 0:
          case 6:
            wr = [fr(1), fr(5), fr(4), fr(7), fr(3), fr(2), fr(1)];
            break;
          case 1:
          case 7:
            wr = [fr(0), fr(4), fr(5), fr(6), fr(2), fr(3), fr(0)];
            break;
          case 3:
          case 5:
            wr = [fr(1), fr(0), fr(4), fr(7), fr(6), fr(2), fr(1)];
            break;
          default:
            wr = [fr(1), fr(5), fr(6), fr(7), fr(3), fr(0), fr(1)];
        }
        if (Ei(Ie, wr))
          return Ve;
      }
      const Ky = La([{ name: "a_pos_3f", components: 3, type: "Float32" }]), Yy = La([{ name: "a_color_3f", components: 3, type: "Float32" }]), Jy = La([{ name: "a_color_4f", components: 4, type: "Float32" }]), Qy = La([{ name: "a_uv_2f", components: 2, type: "Float32" }]), eb = La([{ name: "a_normal_3f", components: 3, type: "Float32" }]), tb = La([{ name: "a_normal_matrix0", components: 4, type: "Float32" }, { name: "a_normal_matrix1", components: 4, type: "Float32" }, { name: "a_normal_matrix2", components: 4, type: "Float32" }, { name: "a_normal_matrix3", components: 4, type: "Float32" }]), rb = La([{ name: "a_pbr", components: 4, type: "Uint16" }, { name: "a_heightBasedEmissiveStrength", components: 3, type: "Float32" }]), R2 = { None: 0, Model: 1, Symbol: 2, FillExtrusion: 4, All: 7 };
      class mv {
        constructor(de, Ce, De, Ke) {
          this.message = (de ? `${de}: ` : "") + De, Ke && (this.identifier = Ke), Ce != null && Ce.__line__ && (this.line = Ce.__line__);
        }
      }
      function P2(Ie, de) {
        const Ce = Ie.indexOf("://") === -1;
        try {
          return new URL(Ie, Ce && de ? "http://example.com" : void 0), !0;
        } catch {
          return !1;
        }
      }
      class D2 {
        constructor(de, Ce) {
          this.feature = de, this.instancedDataOffset = Ce, this.instancedDataCount = 0, this.rotation = [0, 0, 0], this.scale = [1, 1, 1], this.translation = [0, 0, 0];
        }
      }
      class O2 {
        constructor() {
          this.instancedDataArray = new od(), this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
        }
      }
      class z_ {
        constructor(de) {
          this.zoom = de.zoom, this.canonical = de.canonical, this.layers = de.layers, this.layerIds = this.layers.map((Ce) => Ce.fqid), this.projection = de.projection, this.index = de.index, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter((Ce) => Ce.isStateDependent()).map((Ce) => Ce.id), this.hasPattern = !1, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = { id: null, timestamp: 0 }, this.modelUris = [], this.modelsRequested = !1, this.activeReplacements = [], this.replacementUpdateTime = 0;
        }
        updateFootprints(de, Ce) {
        }
        populate(de, Ce, De, Ke) {
          this.tileToMeter = He(De);
          const Ve = this.layers[0]._featureFilter.needGeometry;
          this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
          for (const { feature: er, id: fr, index: wr, sourceLayerIndex: kr } of de) {
            const cr = fr ?? (er.properties && er.properties.hasOwnProperty("id") ? er.properties.id : void 0), Mr = Jr(er, Ve);
            if (!this.layers[0]._featureFilter.filter(new wa(this.zoom), Mr, De))
              continue;
            const Er = { id: cr, sourceLayerIndex: kr, index: wr, geometry: Ve ? Mr.geometry : qr(er, De, Ke), properties: er.properties, type: er.type, patterns: {} }, xr = this.addFeature(Er, Er.geometry, Mr);
            xr && Ce.featureIndex.insert(er, Er.geometry, wr, kr, this.index, this.instancesPerModel[xr].instancedDataArray.length, vo / 32);
          }
          this.lookup = null;
        }
        update(de, Ce, De, Ke) {
          for (const Ve in this.instancesPerModel) {
            const er = this.instancesPerModel[Ve];
            for (const fr in de)
              er.idToFeaturesIndex.hasOwnProperty(fr) && (this.evaluate(er.features[er.idToFeaturesIndex[fr]], de[fr], er, !0), this.uploaded = !1);
          }
          this.maxHeight = 0;
        }
        updateZoomBasedPaintProperties() {
          if (!this.hasZoomDependentProperties)
            return !1;
          let de = !1;
          for (const Ce in this.instancesPerModel) {
            const De = this.instancesPerModel[Ce];
            for (const Ke of De.features) {
              const Ve = this.layers[0], er = Ke.feature, fr = this.canonical, wr = Ve.paint.get("model-rotation").evaluate(er, {}, fr), kr = Ve.paint.get("model-scale").evaluate(er, {}, fr), cr = Ve.paint.get("model-translation").evaluate(er, {}, fr);
              Zr.vec3.exactEquals(Ke.rotation, wr) && Zr.vec3.exactEquals(Ke.scale, kr) && Zr.vec3.exactEquals(Ke.translation, cr) || (this.evaluate(Ke, Ke.featureStates, De, !0), de = !0);
            }
          }
          return de;
        }
        updateReplacement(de, Ce, De, Ke) {
          if (Ce.updateTime === this.replacementUpdateTime)
            return !1;
          this.replacementUpdateTime = Ce.updateTime;
          const Ve = Ce.getReplacementRegionsForTile(de.toUnwrapped(), !0);
          if (hm(this.activeReplacements, Ve))
            return !1;
          this.activeReplacements = Ve;
          let er = !1;
          for (const fr in this.instancesPerModel) {
            const wr = this.instancesPerModel[fr], kr = wr.instancedDataArray;
            for (const cr of wr.features) {
              const Mr = cr.instancedDataOffset, Er = cr.instancedDataCount;
              for (let xr = 0; xr < Er; xr++) {
                const Sr = 16 * (xr + Mr);
                let Br = kr.float32[Sr + 0];
                const Fr = Br > vo;
                Br = Fr ? Br - vo : Br;
                const jr = Math.floor(Br), Qr = kr.float32[Sr + 1];
                let ti = !1;
                for (const Kr of this.activeReplacements)
                  if (!gg(Kr, De, R2.Model, Ke) && !(Kr.min.x > jr || jr > Kr.max.x || Kr.min.y > Qr || Qr > Kr.max.y) && (ti = js($s(jr, Qr, de.canonical, Kr.footprintTileId.canonical), Kr.footprint), ti))
                    break;
                kr.float32[Sr] = ti ? Br + vo : Br, er = er || ti !== Fr;
              }
            }
          }
          return er;
        }
        isEmpty() {
          for (const de in this.instancesPerModel)
            if (this.instancesPerModel[de].instancedDataArray.length !== 0)
              return !1;
          return !0;
        }
        uploadPending() {
          return !this.uploaded;
        }
        upload(de) {
          if (!this.uploaded)
            for (const Ce in this.instancesPerModel) {
              const De = this.instancesPerModel[Ce];
              De.instancedDataArray.length < 0 || De.instancedDataArray.length === 0 || (De.instancedDataBuffer ? De.instancedDataBuffer.updateData(De.instancedDataArray) : De.instancedDataBuffer = de.createVertexBuffer(De.instancedDataArray, tb.members, !0, void 0, this.instanceCount));
            }
          this.uploaded = !0;
        }
        destroy() {
          for (const Ce in this.instancesPerModel) {
            const De = this.instancesPerModel[Ce];
            De.instancedDataArray.length !== 0 && De.instancedDataBuffer && De.instancedDataBuffer.destroy();
          }
          const de = this.layers[0].modelManager;
          if (de && this.modelUris)
            for (const Ce of this.modelUris)
              de.removeModel(Ce, "");
        }
        addFeature(de, Ce, De) {
          const Ke = this.layers[0], Ve = Ke.layout.get("model-id").evaluate(De, {}, this.canonical);
          if (!Ve)
            return Mn(`modelId is not evaluated for layer ${Ke.id} and it is not going to get rendered.`), Ve;
          P2(Ve, !1) && (this.modelUris.includes(Ve) || this.modelUris.push(Ve)), this.instancesPerModel[Ve] || (this.instancesPerModel[Ve] = new O2());
          const er = this.instancesPerModel[Ve], fr = er.instancedDataArray, wr = new D2(De, fr.length);
          for (const kr of Ce)
            for (const cr of kr) {
              if (cr.x < 0 || cr.x >= vo || cr.y < 0 || cr.y >= vo)
                continue;
              const Mr = (this.lookupDim - 1) / vo, Er = this.lookupDim * (cr.y * Mr | 0) + cr.x * Mr | 0;
              if (this.lookup) {
                if (this.lookup[Er] !== 0)
                  continue;
                this.lookup[Er] = 1;
              }
              this.instanceCount++;
              const xr = fr.length;
              fr.resize(xr + 1), er.instancesEvaluatedElevation.push(0), fr.float32[16 * xr] = cr.x, fr.float32[16 * xr + 1] = cr.y;
            }
          return wr.instancedDataCount = er.instancedDataArray.length - wr.instancedDataOffset, wr.instancedDataCount > 0 && (de.id && (er.idToFeaturesIndex[de.id] = er.features.length), er.features.push(wr), this.evaluate(wr, {}, er, !1)), Ve;
        }
        getModelUris() {
          return this.modelUris;
        }
        evaluate(de, Ce, De, Ke) {
          const Ve = this.layers[0], er = de.feature, fr = this.canonical, wr = de.rotation = Ve.paint.get("model-rotation").evaluate(er, Ce, fr), kr = de.scale = Ve.paint.get("model-scale").evaluate(er, Ce, fr), cr = de.translation = Ve.paint.get("model-translation").evaluate(er, Ce, fr), Mr = Ve.paint.get("model-color").evaluate(er, Ce, fr);
          Mr.a = Ve.paint.get("model-color-mix-intensity").evaluate(er, Ce, fr);
          const Er = [];
          this.maxVerticalOffset < cr[2] && (this.maxVerticalOffset = cr[2]), this.maxScale = Math.max(Math.max(this.maxScale, kr[0]), Math.max(kr[1], kr[2])), B2(Er, wr, kr);
          const xr = Math.round(100 * Mr.a) + Mr.b / 1.05;
          for (let Sr = 0; Sr < de.instancedDataCount; ++Sr) {
            const Br = de.instancedDataOffset + Sr, Fr = 16 * Br, jr = De.instancedDataArray.float32;
            let Qr = 0;
            Ke && (Qr = jr[Fr + 6] - De.instancesEvaluatedElevation[Br]);
            const ti = 0 | jr[Fr + 1];
            jr[Fr] = (0 | jr[Fr]) + Mr.r / 1.05, jr[Fr + 1] = ti + Mr.g / 1.05, jr[Fr + 2] = xr, jr[Fr + 3] = 1 / (fr.z > 10 ? this.tileToMeter : He(fr, ti)), jr[Fr + 4] = cr[0], jr[Fr + 5] = cr[1], jr[Fr + 6] = cr[2] + Qr, jr[Fr + 7] = Er[0], jr[Fr + 8] = Er[1], jr[Fr + 9] = Er[2], jr[Fr + 10] = Er[4], jr[Fr + 11] = Er[5], jr[Fr + 12] = Er[6], jr[Fr + 13] = Er[8], jr[Fr + 14] = Er[9], jr[Fr + 15] = Er[10], De.instancesEvaluatedElevation[Br] = cr[2];
          }
        }
      }
      let z2, F2;
      Ao(z_, "ModelBucket", { omit: ["layers"] }), Ao(O2, "PerModelAttributes"), Ao(D2, "ModelFeature");
      const Cm = 64, T0 = { CoordinateSpaceTile: 1, CoordinateSpaceYUp: 2, HasMapboxMeshFeatures: 4, HasMeshoptCompression: 8 };
      function N2(Ie, de, Ce, De, Ke, Ve, er, fr, wr, kr = !1) {
        const cr = Ce.zoom, Mr = Ce.project(De), Er = xe(De.lat, cr), xr = 1 / Er;
        Zr.mat4.identity(Ie), Zr.mat4.translate(Ie, Ie, [Mr.x + er[0] * xr, Mr.y + er[1] * xr, er[2]]);
        let Sr = 1, Br = 1;
        const Fr = Ce.worldSize;
        if (kr) {
          if (Ce.projection.name === "mercator") {
            let Kr = 0;
            Ce.elevation && (Kr = Ce.elevation.getAtPointOrZero(new ir(Mr.x / Fr, Mr.y / Fr), 0));
            const ni = Zr.vec4.transformMat4([], [Mr.x, Mr.y, Kr, 1], Ce.projMatrix)[3] / Ce.cameraToCenterDistance;
            Sr = ni, Br = ni * xe(Ce.center.lat, cr);
          } else if (Ce.projection.name === "globe") {
            const Kr = O_(Ie, Ce), ni = Zr.mat4.multiply([], Ce.projMatrix, Kr), gi = [0, 0, 0, 1];
            Zr.vec4.transformMat4(gi, gi, ni);
            const Si = gi[3] / Ce.cameraToCenterDistance, Di = gl(cr), Ri = Ce.projection.pixelsPerMeter(De.lat, Fr) * xe(De.lat, cr), Bi = Ce.projection.pixelsPerMeter(Ce.center.lat, Fr) * xe(Ce.center.lat, cr);
            Sr = Si / Ho(Ri, qe(Ce.center.lat), Di), Br = Si * Er / Ri, Sr *= Bi, Br *= Bi;
          }
        } else
          Sr = xr;
        Zr.mat4.scale(Ie, Ie, [Sr, Sr, Br]);
        const jr = [...Ie], Qr = de.orientation, ti = [];
        if (B2(ti, [Qr[0] + Ke[0], Qr[1] + Ke[1], Qr[2] + Ke[2]], Ve), Zr.mat4.multiply(Ie, jr, ti), fr && Ce.elevation) {
          let Kr = 0;
          const ni = [];
          if (wr && Ce.elevation) {
            Kr = function(Di, Ri, Bi, Ji, Fi) {
              const tn = Ri.elevation;
              if (!tn)
                return 0;
              const cn = qo.projectAabbCorners(Bi, Ji), ln = As(1, Fi.lat) * Ri.worldSize, mn = function(Ro, po) {
                const Lo = [0, 0, 1], jo = [{ corners: [0, 1, 3, 2], dotProductWithUp: 0 }, { corners: [1, 5, 2, 6], dotProductWithUp: 0 }, { corners: [0, 4, 1, 5], dotProductWithUp: 0 }, { corners: [2, 6, 3, 7], dotProductWithUp: 0 }, { corners: [4, 7, 5, 6], dotProductWithUp: 0 }, { corners: [0, 3, 4, 7], dotProductWithUp: 0 }];
                for (const oa of jo) {
                  const ua = Ro[oa.corners[0]], fa = Ro[oa.corners[1]], ha = Ro[oa.corners[2]], va = [fa[0] - ua[0], fa[1] - ua[1], po * (fa[2] - ua[2])], os = Zr.vec3.cross(va, va, [ha[0] - ua[0], ha[1] - ua[1], po * (ha[2] - ua[2])]);
                  Zr.vec3.normalize(os, os), oa.dotProductWithUp = Zr.vec3.dot(os, Lo);
                }
                return jo.sort((oa, ua) => oa.dotProductWithUp - ua.dotProductWithUp), jo[0].corners;
              }(cn, ln), wn = cn[mn[0]], Cn = cn[mn[1]], gn = cn[mn[2]], Nn = cn[mn[3]], oo = tn.getAtPointOrZero(new ir(wn[0] / Ri.worldSize, wn[1] / Ri.worldSize), 0), Un = tn.getAtPointOrZero(new ir(Cn[0] / Ri.worldSize, Cn[1] / Ri.worldSize), 0), fo = tn.getAtPointOrZero(new ir(gn[0] / Ri.worldSize, gn[1] / Ri.worldSize), 0), ho = tn.getAtPointOrZero(new ir(Nn[0] / Ri.worldSize, Nn[1] / Ri.worldSize), 0), bo = (oo + ho) / 2, Jn = (Un + fo) / 2;
              return bo > Jn ? Un < fo ? pv(Di, Cn, Nn, wn, Un, ho, oo, ln) : pv(Di, gn, wn, Nn, fo, oo, ho, ln) : oo < ho ? pv(Di, wn, Cn, gn, oo, Un, fo, ln) : pv(Di, Nn, gn, Cn, ho, fo, Un, ln), Math.max(bo, Jn);
            }(ni, Ce, de.aabb, Ie, De);
            const gi = Zr.mat4.fromQuat([], ni), Si = Zr.mat4.multiply([], gi, ti);
            Zr.mat4.multiply(Ie, jr, Si);
          } else
            Kr = Ce.elevation.getAtPointOrZero(new ir(Mr.x / Fr, Mr.y / Fr), 0);
          Kr !== 0 && (Ie[14] += Kr);
        }
      }
      function I1(Ie, de, Ce = !1) {
        Ie.uploaded || (Ie.gfxTexture = new R_(de, Ie.image, Ce ? de.gl.R8 : de.gl.RGBA8, { useMipmap: Ie.sampler.minFilter >= de.gl.NEAREST_MIPMAP_NEAREST }), Ie.uploaded = !0, Ie.image = null);
      }
      function ib(Ie, de, Ce) {
        Ie.indexBuffer = de.createIndexBuffer(Ie.indexArray, !1, !0), Ie.vertexBuffer = de.createVertexBuffer(Ie.vertexArray, Ky.members, !1, !0), Ie.normalArray && (Ie.normalBuffer = de.createVertexBuffer(Ie.normalArray, eb.members, !1, !0)), Ie.texcoordArray && (Ie.texcoordBuffer = de.createVertexBuffer(Ie.texcoordArray, Qy.members, !1, !0)), Ie.colorArray && (Ie.colorBuffer = de.createVertexBuffer(Ie.colorArray, (Ie.colorArray.bytesPerElement === 12 ? Yy : Jy).members, !1, !0)), Ie.featureArray && (Ie.pbrBuffer = de.createVertexBuffer(Ie.featureArray, rb.members, !0)), Ie.segments = fs.simpleSegment(0, 0, Ie.vertexArray.length, Ie.indexArray.length);
        const De = Ie.material;
        De.pbrMetallicRoughness.baseColorTexture && I1(De.pbrMetallicRoughness.baseColorTexture, de), De.pbrMetallicRoughness.metallicRoughnessTexture && I1(De.pbrMetallicRoughness.metallicRoughnessTexture, de), De.normalTexture && I1(De.normalTexture, de), De.occlusionTexture && I1(De.occlusionTexture, de, Ce), De.emissionTexture && I1(De.emissionTexture, de);
      }
      function F_(Ie, de, Ce) {
        if (Ie.meshes)
          for (const De of Ie.meshes)
            ib(De, de, Ce);
        if (Ie.children)
          for (const De of Ie.children)
            F_(De, de, Ce);
      }
      function gv(Ie) {
        if (Ie.meshes)
          for (const de of Ie.meshes)
            de.indexArray.destroy(), de.vertexArray.destroy(), de.colorArray && de.colorArray.destroy(), de.normalArray && de.normalArray.destroy(), de.texcoordArray && de.texcoordArray.destroy(), de.featureArray && de.featureArray.destroy();
        if (Ie.children)
          for (const de of Ie.children)
            gv(de);
      }
      function N_(Ie) {
        if (Ie.meshes)
          for (const Ce of Ie.meshes)
            Ce.vertexBuffer && (Ce.vertexBuffer.destroy(), Ce.indexBuffer.destroy(), Ce.normalBuffer && Ce.normalBuffer.destroy(), Ce.texcoordBuffer && Ce.texcoordBuffer.destroy(), Ce.colorBuffer && Ce.colorBuffer.destroy(), Ce.pbrBuffer && Ce.pbrBuffer.destroy(), Ce.segments.destroy(), Ce.material && ((de = Ce.material).pbrMetallicRoughness.baseColorTexture && de.pbrMetallicRoughness.baseColorTexture.gfxTexture && de.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), de.pbrMetallicRoughness.metallicRoughnessTexture && de.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && de.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), de.normalTexture && de.normalTexture.gfxTexture && de.normalTexture.gfxTexture.destroy(), de.emissionTexture && de.emissionTexture.gfxTexture && de.emissionTexture.gfxTexture.destroy(), de.occlusionTexture && de.occlusionTexture.gfxTexture && de.occlusionTexture.gfxTexture.destroy()));
        var de;
        if (Ie.children)
          for (const Ce of Ie.children)
            N_(Ce);
      }
      class A0 {
        constructor(de, Ce, De) {
          this._demTile = de, this._dem = this._demTile.dem, this._scale = Ce, this._offset = De;
        }
        static create(de, Ce, De) {
          const Ke = De || de.findDEMTileFor(Ce);
          if (!Ke || !Ke.dem)
            return;
          const Ve = Ke.dem, er = Ke.tileID, fr = 1 << Ce.canonical.z - er.canonical.z;
          return new A0(Ke, Ve.dim / vo / fr, [(Ce.canonical.x / fr - er.canonical.x) * Ve.dim, (Ce.canonical.y / fr - er.canonical.y) * Ve.dim]);
        }
        tileCoordToPixel(de, Ce) {
          const De = Ce * this._scale + this._offset[1], Ke = Math.floor(de * this._scale + this._offset[0]), Ve = Math.floor(De);
          return new qi(Ke, Ve);
        }
        getElevationAt(de, Ce, De, Ke) {
          const Ve = de * this._scale + this._offset[0], er = Ce * this._scale + this._offset[1], fr = Math.floor(Ve), wr = Math.floor(er), kr = this._dem;
          return Ke = !!Ke, De ? Ho(Ho(kr.get(fr, wr, Ke), kr.get(fr, wr + 1, Ke), er - wr), Ho(kr.get(fr + 1, wr, Ke), kr.get(fr + 1, wr + 1, Ke), er - wr), Ve - fr) : kr.get(fr, wr, Ke);
        }
        getElevationAtPixel(de, Ce, De) {
          return this._dem.get(de, Ce, !!De);
        }
        getMeterToDEM(de) {
          return (1 << this._demTile.tileID.canonical.z) * As(1, de) * this._dem.stride;
        }
      }
      const V_ = new Float32Array(262144), Tm = new Uint8Array(262144);
      function V2(Ie) {
        let de = 0;
        if (Ie.meshes)
          for (const Ce of Ie.meshes)
            de = Math.max(de, Ce.aabb.max[2]);
        if (Ie.children)
          for (const Ce of Ie.children)
            de = Math.max(de, V2(Ce));
        return de;
      }
      function U2(Ie, de, Ce) {
        if (Ie.meshes)
          for (const De of Ie.meshes) {
            if (De.aabb.min[0] === 1 / 0)
              continue;
            const Ke = qo.applyTransform(De.aabb, Ie.matrix);
            Ce.insert(de, Ke.min[0], Ke.min[1], Ke.max[0], Ke.max[1]);
          }
        if (Ie.children)
          for (const De of Ie.children)
            U2(De, de, Ce);
      }
      const j2 = ["", "wall", "door", "roof", "window", "lamp", "logo"];
      class q2 {
        constructor(de) {
          this.node = de, this.evaluatedRMEA = [[1, 0, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1], [0.4, 1, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1]], this.hiddenByReplacement = !1, this.evaluatedScale = [1, 1, 1], this.evaluatedColor = [], this.emissionHeightBasedParams = [], this.cameraCollisionOpacity = 1, this.feature = { type: "Point", id: de.id, geometry: [], properties: { height: V2(de) } }, this.aabb = this._getLocalBounds(), this.state = null;
        }
        _getLocalBounds() {
          if (!this.node.meshes)
            return new qo([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]);
          if (!this.aabb) {
            let de = 0;
            const Ce = new qo([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]);
            for (const De of this.node.meshes)
              this.node.lightMeshIndex !== de && (De.transformedAabb = qo.applyTransformFast(De.aabb, this.node.matrix), Ce.encapsulate(De.transformedAabb)), de++;
            this.aabb = Ce;
          }
          return this.aabb;
        }
      }
      class vv {
        constructor(de, Ce, De, Ke, Ve, er, fr) {
          this.id = De, this.layers = de, this.layerIds = this.layers.map((wr) => wr.fqid), this.stateDependentLayerIds = this.layers.filter((wr) => wr.isStateDependent()).map((wr) => wr.id), this.modelTraits |= T0.CoordinateSpaceTile, this.uploaded = !1, this.hasPattern = !1, Ke && (this.modelTraits |= T0.HasMapboxMeshFeatures), Ve && (this.modelTraits |= T0.HasMeshoptCompression), this.zoom = -1, this.terrainExaggeration = 1, this.projection = { name: "mercator" }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = er, this.dirty = !0, this.needsUpload = !1, this.nodesInfo = [];
          for (const wr of Ce)
            this.nodesInfo.push(new q2(wr)), U2(wr, fr.featureIndexArray.length, fr.grid), fr.featureIndexArray.emplaceBack(this.nodesInfo.length - 1, 0, fr.bucketLayerIDs.length - 1, 0);
          this.states = {};
        }
        updateFootprints(de, Ce) {
          for (const De of this.getNodesInfo()) {
            const Ke = De.node;
            Ke.footprint && Ce.push({ footprint: Ke.footprint, id: de });
          }
        }
        update(de) {
          const Ce = Object.keys(de).length !== 0;
          if (Ce && !this.stateDependentLayers.length)
            return;
          const De = Ce ? this.stateDependentLayers : this.layers;
          if (!yn(de, this.states))
            for (const Ke of De)
              this.evaluate(Ke, de);
          this.states = structuredClone(de);
        }
        populate() {
          console.log("populate 3D model bucket");
        }
        uploadPending() {
          return !this.uploaded || this.needsUpload;
        }
        upload(de) {
          if (!this.needsUpload)
            return;
          const Ce = this.getNodesInfo();
          for (const De of Ce) {
            const Ke = De.node;
            this.uploaded ? this.updatePbrBuffer(Ke) : F_(Ke, de, !0);
          }
          for (const De of Ce)
            gv(De.node);
          this.uploaded = !0, this.needsUpload = !1;
        }
        updatePbrBuffer(de) {
          let Ce = !1;
          if (!de.meshes)
            return Ce;
          for (const De of de.meshes)
            De.pbrBuffer && (De.pbrBuffer.updateData(De.featureArray), Ce = !0);
          return Ce;
        }
        needsReEvaluation(de, Ce, De) {
          const Ke = de.transform.projectionOptions, Ve = de.style.getBrightness(), er = this.brightness !== Ve;
          if (!this.uploaded || this.dirty || Ke.name !== this.projection.name || B1(De.paint.get("model-color").value, er) || B1(De.paint.get("model-color-mix-intensity").value, er) || B1(De.paint.get("model-roughness").value, er) || B1(De.paint.get("model-emissive-strength").value, er) || B1(De.paint.get("model-height-based-emissive-strength-multiplier").value, er)) {
            this.projection = Ke, this.brightness = Ve;
            const fr = this.getNodesInfo();
            for (const wr of fr)
              wr.state = null;
            return !0;
          }
          return !1;
        }
        evaluateScale(de, Ce) {
          if (de.transform.zoom === this.zoom)
            return;
          this.zoom = de.transform.zoom;
          const De = this.getNodesInfo(), Ke = this.id.canonical;
          for (const Ve of De) {
            const er = Ve.feature;
            Ve.evaluatedScale = Ce.paint.get("model-scale").evaluate(er, {}, Ke);
          }
        }
        evaluate(de, Ce) {
          const De = this.getNodesInfo();
          for (const Ke of De) {
            if (!Ke.node.meshes)
              continue;
            const Ve = Ke.feature, er = Ce && Ce[Ve.id];
            if (yn(er, Ke.state))
              continue;
            Ke.state = structuredClone(er);
            const fr = Ke.node.meshes && Ke.node.meshes[0].featureData, wr = Ke.evaluatedColor[2], kr = Ke.evaluatedRMEA[2], cr = this.id.canonical;
            if (Ke.hasTranslucentParts = !1, fr) {
              for (let Mr = 0; Mr < j2.length; Mr++) {
                const Er = j2[Mr];
                Er.length && (Ve.properties.part = Er);
                const xr = de.paint.get("model-color").evaluate(Ve, er, cr).toRenderColor(null), Sr = de.paint.get("model-color-mix-intensity").evaluate(Ve, er, cr);
                Ke.evaluatedColor[Mr] = [xr.r, xr.g, xr.b, Sr], Ke.evaluatedRMEA[Mr][0] = de.paint.get("model-roughness").evaluate(Ve, er, cr), Ke.evaluatedRMEA[Mr][2] = de.paint.get("model-emissive-strength").evaluate(Ve, er, cr), Ke.evaluatedRMEA[Mr][3] = xr.a, Ke.emissionHeightBasedParams[Mr] = de.paint.get("model-height-based-emissive-strength-multiplier").evaluate(Ve, er, cr), !Ke.hasTranslucentParts && xr.a < 1 && (Ke.hasTranslucentParts = !0);
              }
              delete Ve.properties.part, ob(Ke, wr !== Ke.evaluatedColor[2] || kr !== Ke.evaluatedRMEA[2], this.modelTraits);
            } else
              Ke.evaluatedRMEA[0][2] = de.paint.get("model-emissive-strength").evaluate(Ve, er, cr);
            Ke.evaluatedScale = de.paint.get("model-scale").evaluate(Ve, er, cr), this.updatePbrBuffer(Ke.node) || (this.needsUpload = !0);
          }
          this.dirty = !1;
        }
        elevationUpdate(de, Ce, De, Ke) {
          const Ve = de.findDEMTileFor(De);
          if (Ve && (Ve.tileID.canonical !== this.terrainTile || Ce !== this.terrainExaggeration)) {
            if (Ve.dem && Ve.tileID.overscaledZ !== this.elevationReadFromZ) {
              this.elevationReadFromZ = Ve.tileID.overscaledZ;
              const er = A0.create(de, De, Ve);
              if (!er)
                return;
              this.modelTraits & T0.HasMapboxMeshFeatures && this.updateDEM(de, er, De, Ke);
              for (const fr of this.getNodesInfo()) {
                const wr = fr.node;
                if (!wr.footprint || !wr.footprint.vertices || !wr.footprint.vertices.length)
                  continue;
                const kr = wr.footprint.vertices;
                let cr = er.getElevationAt(kr[0].x, kr[0].y, !0, !0);
                for (let Mr = 1; Mr < kr.length; Mr++)
                  cr = Math.min(cr, er.getElevationAt(kr[Mr].x, kr[Mr].y, !0, !0));
                wr.elevation = cr;
              }
            }
            this.terrainTile = Ve.tileID.canonical, this.terrainExaggeration = Ce;
          }
        }
        updateDEM(de, Ce, De, Ke) {
          let Ve = Ce._dem._modifiedForSources[Ke];
          if (Ve === void 0 && (Ce._dem._modifiedForSources[Ke] = [], Ve = Ce._dem._modifiedForSources[Ke]), Ve.includes(De.canonical))
            return;
          const er = Ce._dem.dim;
          Ve.push(De.canonical);
          let fr = !1;
          for (const wr of this.getNodesInfo()) {
            const kr = wr.node;
            if (!kr.footprint || !kr.footprint.grid)
              continue;
            const cr = kr.footprint.grid, Mr = Ce.tileCoordToPixel(cr.min.x, cr.min.y), Er = Ce.tileCoordToPixel(cr.max.x, cr.max.y), xr = Math.min(Math.min(er - Er.y, Mr.x), Math.min(Mr.y, er - Er.x));
            if (xr < 0)
              continue;
            const Sr = vn(xr, 2, 5);
            let Br = Math.max(0, Mr.x - Sr), Fr = Math.max(0, Mr.y - Sr), jr = Math.min(Er.x + Sr, er - 1), Qr = Math.min(Er.y + Sr, er - 1);
            for (let gi = Fr; gi <= Qr; ++gi)
              for (let Si = Br; Si <= jr; ++Si)
                Tm[gi * er + Si] = 255;
            let ti = 0, Kr = 0;
            for (let gi = 0; gi < cr.cellsY; ++gi)
              for (let Si = 0; Si < cr.cellsX; ++Si) {
                if (!cr.cells[gi * cr.cellsX + Si])
                  continue;
                const Di = Ce.tileCoordToPixel(cr.min.x + Si / cr.xScale, cr.min.y + gi / cr.yScale), Ri = Ce.tileCoordToPixel(cr.min.x + (Si + 1) / cr.xScale, cr.min.y + (gi + 1) / cr.yScale);
                for (let Bi = Di.y; Bi <= Math.min(Ri.y + 1, er - 1); ++Bi)
                  for (let Ji = Di.x; Ji <= Math.min(Ri.x + 1, er - 1); ++Ji)
                    Tm[Bi * er + Ji] === 255 && (Tm[Bi * er + Ji] = 0, ti += Ce.getElevationAtPixel(Ji, Bi), Kr++);
              }
            const ni = ti / Kr;
            Br = Math.max(1, Mr.x - Sr), Fr = Math.max(1, Mr.y - Sr), jr = Math.min(Er.x + Sr, er - 2), Qr = Math.min(Er.y + Sr, er - 2), fr = !0;
            for (let gi = Fr; gi <= Qr; ++gi)
              for (let Si = Br; Si <= jr; ++Si)
                Tm[gi * er + Si] === 0 && (V_[gi * er + Si] = Ce._dem.set(Si, gi, ni));
            for (let gi = 1; gi < Sr; ++gi) {
              Br = Math.max(1, Mr.x - gi), Fr = Math.max(1, Mr.y - gi), jr = Math.min(Er.x + gi, er - 2), Qr = Math.min(Er.y + gi, er - 2);
              for (let Si = Fr; Si <= Qr; ++Si)
                for (let Di = Br; Di <= jr; ++Di) {
                  const Ri = Si * er + Di;
                  if (Tm[Ri] === 255) {
                    let Bi = 0, Ji = 0, Fi = -1, tn = -1;
                    for (let cn = -1; cn <= 1; ++cn)
                      for (let ln = -1; ln <= 1; ++ln) {
                        const mn = (Si + cn) * er + Di + ln;
                        if (Tm[mn] >= gi)
                          continue;
                        const wn = V_[mn], Cn = Math.abs(wn);
                        Cn > Ji && (Bi = wn, Ji = Cn, Fi = ln, tn = cn);
                      }
                    if (Ji > 0.1) {
                      const cn = 1 - (gi + 0.5 * Math.abs(Fi * tn)) / Sr;
                      let ln = Ce._dem.get(Di, Si) + Bi * cn;
                      const mn = Ce._dem.get(Di + Fi, Si + tn), wn = Ce._dem.get(Di - Fi, Si - tn, !0);
                      (ln - mn) * (ln - wn) > 0 && (ln = (mn + wn) / 2), V_[Ri] = Ce._dem.set(Di, Si, ln), Tm[Ri] = gi;
                    }
                  }
                }
            }
          }
          fr && (Ce._demTile.needsDEMTextureUpload = !0, Ce._dem._timestamp = _n.now());
        }
        getNodesInfo() {
          return this.nodesInfo;
        }
        destroy() {
          const de = this.getNodesInfo();
          for (const Ce of de)
            gv(Ce.node), N_(Ce.node);
        }
        isEmpty() {
          return !this.nodesInfo.length;
        }
        updateReplacement(de, Ce) {
          if (Ce.updateTime === this.replacementUpdateTime)
            return;
          this.replacementUpdateTime = Ce.updateTime;
          const De = Ce.getReplacementRegionsForTile(de.toUnwrapped()), Ke = this.getNodesInfo();
          for (let Ve = 0; Ve < this.nodesInfo.length; Ve++) {
            const er = Ke[Ve].node;
            Ke[Ve].hiddenByReplacement = !!er.footprint && !De.find((fr) => fr.footprint === er.footprint);
          }
        }
        getHeightAtTileCoord(de, Ce) {
          const De = this.getNodesInfo(), Ke = [], Ve = [0, 0, 0], er = Zr.mat4.identity([]);
          for (let fr = 0; fr < this.nodesInfo.length; fr++) {
            const wr = De[fr], kr = wr.node.meshes[0], cr = kr.transformedAabb;
            if (de < cr.min[0] || Ce < cr.min[1] || de > cr.max[0] || Ce > cr.max[1])
              continue;
            if (wr.node.hidden === !0)
              return { height: 1 / 0, maxHeight: wr.feature.properties.height, hidden: !1, verticalScale: wr.evaluatedScale[2] };
            Zr.mat4.invert(er, wr.node.matrix), Ve[0] = de, Ve[1] = Ce, Zr.vec3.transformMat4(Ve, Ve, er);
            const Mr = (Ve[0] - kr.aabb.min[0]) / (kr.aabb.max[0] - kr.aabb.min[0]) * Cm | 0, Er = Math.min(63, (Ve[1] - kr.aabb.min[1]) / (kr.aabb.max[1] - kr.aabb.min[1]) * Cm | 0) * Cm + Math.min(63, Mr), xr = kr.heightmap[Er];
            if (!(xr < 0 && wr.node.footprint))
              return wr.hiddenByReplacement ? void 0 : { height: xr, maxHeight: wr.feature.properties.height, hidden: !1, verticalScale: wr.evaluatedScale[2] };
            if (wr.node.footprint.grid.query(new qi(de, Ce), new qi(de, Ce), Ke), Ke.length > 0)
              return { height: void 0, maxHeight: wr.feature.properties.height, hidden: wr.hiddenByReplacement, verticalScale: wr.evaluatedScale[2] };
          }
        }
      }
      function B1(Ie, de) {
        return !Ie.isLightConstant && de;
      }
      function nb(Ie, de, Ce, De, Ke, Ve, er, fr) {
        let wr = (61440 & de | (61440 & de) >> 4) >> 8, kr = (3840 & de | (3840 & de) >> 4) >> 4, cr = 240 & de | (240 & de) >> 4;
        Ce[3] > 0 && (wr = Ho(wr, 255 * Ce[0], Ce[3]), kr = Ho(kr, 255 * Ce[1], Ce[3]), cr = Ho(cr, 255 * Ce[2], Ce[3]));
        const Mr = wr << 8 | kr, Er = cr << 8 | Math.floor(255 * De[3]), xr = function(gi) {
          const Si = vn(gi, 0, 2);
          return Math.min(Math.round(0.5 * Si * 255), 255);
        }(De[2]) << 8 | 15 * De[0] << 4 | 15 * De[1], Sr = vn(Ke[0], 0, 1), Br = vn(Ke[1], 0, 1), Fr = vn(Ke[2], 0, 1), jr = vn(Ke[3], 0, 1);
        let Qr, ti, Kr, ni;
        if (Sr !== Br && er !== Ve && Br !== Sr) {
          const gi = er - Ve;
          ti = 1 / (gi * (Br - Sr)), Kr = -(Ve + gi * Sr) / (gi * (Br - Sr));
          const Si = vn(Ke[4], -1, 1);
          ni = Math.pow(10, Si), Qr = 255 * Fr << 8 | 255 * jr;
        } else
          Qr = 65535, ti = 0, Kr = 1, ni = 1;
        if (Ie.emplaceBack(Mr, Er, xr, Qr, ti, Kr, ni), fr) {
          const gi = fr.length;
          fr.clear();
          for (let Si = 0; Si < gi; Si++)
            fr.emplaceBack(Mr, Er, xr, Qr, ti, Kr, ni);
        }
      }
      function ob(Ie, de, Ce) {
        const De = Ie.node;
        let Ke = 0;
        const Ve = Ce & T0.HasMeshoptCompression;
        for (const er of De.meshes) {
          if (De.lights && De.lightMeshIndex === Ke || !er.featureData)
            continue;
          er.featureArray = new Ic(), er.featureArray.reserve(er.featureData.length);
          let fr = de;
          for (const wr of er.featureData) {
            const kr = Ve ? 65535 & wr : wr >> 16 & 65535, cr = Ve ? wr >> 16 & 65535 : 65535 & wr, Mr = (15 & cr) < 8 ? 15 & cr : 0, Er = Ie.evaluatedRMEA[Mr], xr = Ie.evaluatedColor[Mr], Sr = Ie.emissionHeightBasedParams[Mr];
            let Br;
            if (fr && Mr === 2 && De.lights && (Br = new Ic(), Br.resize(10 * De.lights.length)), nb(er.featureArray, kr, xr, Er, Sr, er.aabb.min[2], er.aabb.max[2], Br), Br && fr) {
              fr = !1;
              const Fr = De.meshes[De.lightMeshIndex];
              Fr.featureArray = Br, Fr.featureArray._trim();
            }
          }
          er.featureArray._trim(), Ke++;
        }
      }
      function G2(Ie, de, Ce, De) {
        const Ke = 1 << Ie.z;
        de.lat = Fs((De / vo + Ie.y) / Ke), de.lng = bs((Ce / vo + Ie.x) / Ke);
      }
      Ao(vv, "Tiled3dModelBucket", { omit: ["layers"] }), Ao(q2, "Tiled3dModelFeature");
      const ab = { circle: class extends Cl {
        constructor(Ie, de, Ce, De) {
          super(Ie, { layout: eo || (eo = new ys({ "circle-sort-key": new Mo(Bn.layout_circle["circle-sort-key"]), visibility: new lo(Bn.layout_circle.visibility) })), paint: On || (On = new ys({ "circle-radius": new Mo(Bn.paint_circle["circle-radius"]), "circle-color": new Mo(Bn.paint_circle["circle-color"]), "circle-blur": new Mo(Bn.paint_circle["circle-blur"]), "circle-opacity": new Mo(Bn.paint_circle["circle-opacity"]), "circle-translate": new lo(Bn.paint_circle["circle-translate"]), "circle-translate-anchor": new lo(Bn.paint_circle["circle-translate-anchor"]), "circle-pitch-scale": new lo(Bn.paint_circle["circle-pitch-scale"]), "circle-pitch-alignment": new lo(Bn.paint_circle["circle-pitch-alignment"]), "circle-stroke-width": new Mo(Bn.paint_circle["circle-stroke-width"]), "circle-stroke-color": new Mo(Bn.paint_circle["circle-stroke-color"]), "circle-stroke-opacity": new Mo(Bn.paint_circle["circle-stroke-opacity"]), "circle-emissive-strength": new lo(Bn.paint_circle["circle-emissive-strength"]), "circle-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }), "circle-stroke-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, de, Ce, De);
        }
        createBucket(Ie) {
          return new Mi(Ie);
        }
        queryRadius(Ie) {
          const de = Ie;
          return Hn("circle-radius", this, de) + Hn("circle-stroke-width", this, de) + io(this.paint.get("circle-translate"));
        }
        queryIntersectsFeature(Ie, de, Ce, De, Ke, Ve, er, fr) {
          const wr = An(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), Ve.angle, Ie.pixelToTileUnitsFactor), kr = this.paint.get("circle-radius").evaluate(de, Ce) + this.paint.get("circle-stroke-width").evaluate(de, Ce);
          return j1(Ie, De, Ve, er, fr, this.paint.get("circle-pitch-alignment") === "map", this.paint.get("circle-pitch-scale") === "map", wr, kr);
        }
        getProgramIds() {
          return ["circle"];
        }
        getDefaultProgramParams(Ie, de, Ce) {
          const De = hp(this);
          return { config: new bh(this, { zoom: de, lut: Ce }), defines: De, overrideFog: !1 };
        }
      }, heatmap: class extends Cl {
        createBucket(Ie) {
          return new H1(Ie);
        }
        constructor(Ie, de, Ce, De) {
          super(Ie, { layout: rm || (rm = new ys({ visibility: new lo(Bn.layout_heatmap.visibility) })), paint: W1 || (W1 = new ys({ "heatmap-radius": new Mo(Bn.paint_heatmap["heatmap-radius"]), "heatmap-weight": new Mo(Bn.paint_heatmap["heatmap-weight"]), "heatmap-intensity": new lo(Bn.paint_heatmap["heatmap-intensity"]), "heatmap-color": new Jh(Bn.paint_heatmap["heatmap-color"]), "heatmap-opacity": new lo(Bn.paint_heatmap["heatmap-opacity"]), "heatmap-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, de, Ce, De), this._updateColorRamp();
        }
        _handleSpecialPaintPropertyUpdate(Ie) {
          Ie === "heatmap-color" && this._updateColorRamp();
        }
        _updateColorRamp() {
          this.colorRamp = im({ expression: this._transitionablePaint._values["heatmap-color"].value.expression, evaluationKey: "heatmapDensity", image: this.colorRamp }), this.colorRampTexture = null;
        }
        resize() {
          this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
        }
        queryRadius(Ie) {
          return Hn("heatmap-radius", this, Ie);
        }
        queryIntersectsFeature(Ie, de, Ce, De, Ke, Ve, er, fr) {
          const wr = this.paint.get("heatmap-radius").evaluate(de, Ce);
          return j1(Ie, De, Ve, er, fr, !0, !0, new qi(0, 0), wr);
        }
        hasOffscreenPass() {
          return this.paint.get("heatmap-opacity") !== 0 && this.visibility !== "none";
        }
        getProgramIds() {
          return ["heatmap", "heatmapTexture"];
        }
        getDefaultProgramParams(Ie, de, Ce) {
          return Ie === "heatmap" ? { config: new bh(this, { zoom: de, lut: Ce }), overrideFog: !1 } : {};
        }
      }, hillshade: class extends Cl {
        constructor(Ie, de, Ce, De) {
          super(Ie, { layout: Z1 || (Z1 = new ys({ visibility: new lo(Bn.layout_hillshade.visibility) })), paint: X1 || (X1 = new ys({ "hillshade-illumination-direction": new lo(Bn.paint_hillshade["hillshade-illumination-direction"]), "hillshade-illumination-anchor": new lo(Bn.paint_hillshade["hillshade-illumination-anchor"]), "hillshade-exaggeration": new lo(Bn.paint_hillshade["hillshade-exaggeration"]), "hillshade-shadow-color": new lo(Bn.paint_hillshade["hillshade-shadow-color"]), "hillshade-highlight-color": new lo(Bn.paint_hillshade["hillshade-highlight-color"]), "hillshade-accent-color": new lo(Bn.paint_hillshade["hillshade-accent-color"]), "hillshade-emissive-strength": new lo(Bn.paint_hillshade["hillshade-emissive-strength"]), "hillshade-shadow-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }), "hillshade-highlight-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }), "hillshade-accent-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, de, Ce, De);
        }
        shouldRedrape() {
          return this.hasOffscreenPass() && this.paint.get("hillshade-illumination-anchor") === "viewport";
        }
        hasOffscreenPass() {
          return this.paint.get("hillshade-exaggeration") !== 0 && this.visibility !== "none";
        }
        getProgramIds() {
          return ["hillshade", "hillshadePrepare"];
        }
        getDefaultProgramParams(Ie, de, Ce) {
          return { overrideFog: !1 };
        }
      }, fill: class extends Cl {
        constructor(Ie, de, Ce, De) {
          super(Ie, { layout: ng || (ng = new ys({ "fill-sort-key": new Mo(Bn.layout_fill["fill-sort-key"]), visibility: new lo(Bn.layout_fill.visibility), "fill-elevation-reference": new lo(Bn.layout_fill["fill-elevation-reference"]) })), paint: og || (og = new ys({ "fill-antialias": new lo(Bn.paint_fill["fill-antialias"]), "fill-opacity": new Mo(Bn.paint_fill["fill-opacity"]), "fill-color": new Mo(Bn.paint_fill["fill-color"]), "fill-outline-color": new Mo(Bn.paint_fill["fill-outline-color"]), "fill-translate": new lo(Bn.paint_fill["fill-translate"]), "fill-translate-anchor": new lo(Bn.paint_fill["fill-translate-anchor"]), "fill-pattern": new Mo(Bn.paint_fill["fill-pattern"]), "fill-emissive-strength": new lo(Bn.paint_fill["fill-emissive-strength"]), "fill-z-offset": new Mo(Bn.paint_fill["fill-z-offset"]), "fill-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }), "fill-outline-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, de, Ce, De);
        }
        getProgramIds() {
          const Ie = this.paint.get("fill-pattern"), de = Ie && Ie.constantOr(1), Ce = [de ? "fillPattern" : "fill"];
          return this.paint.get("fill-antialias") && Ce.push(de && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), Ce;
        }
        getDefaultProgramParams(Ie, de, Ce) {
          return { config: new bh(this, { zoom: de, lut: Ce }), overrideFog: !1 };
        }
        recalculate(Ie, de) {
          super.recalculate(Ie, de);
          const Ce = this.paint._values["fill-outline-color"];
          Ce.value.kind === "constant" && Ce.value.value === void 0 && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
        }
        createBucket(Ie) {
          return new u0(Ie);
        }
        queryRadius() {
          return io(this.paint.get("fill-translate"));
        }
        queryIntersectsFeature(Ie, de, Ce, De, Ke, Ve) {
          return !Ie.queryGeometry.isAboveHorizon && Ni(uo(Ie.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), Ve.angle, Ie.pixelToTileUnitsFactor), De);
        }
        isTileClipped() {
          return !0;
        }
        is3D() {
          return this.paint.get("fill-z-offset").constantOr(1) !== 0;
        }
      }, "fill-extrusion": class extends Cl {
        constructor(Ie, de, Ce, De) {
          super(Ie, { layout: Eg || (Eg = new ys({ visibility: new lo(Bn["layout_fill-extrusion"].visibility), "fill-extrusion-edge-radius": new lo(Bn["layout_fill-extrusion"]["fill-extrusion-edge-radius"]) })), paint: Cg || (Cg = new ys({ "fill-extrusion-opacity": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-opacity"]), "fill-extrusion-color": new Mo(Bn["paint_fill-extrusion"]["fill-extrusion-color"]), "fill-extrusion-translate": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-translate"]), "fill-extrusion-translate-anchor": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]), "fill-extrusion-pattern": new Mo(Bn["paint_fill-extrusion"]["fill-extrusion-pattern"]), "fill-extrusion-height": new Mo(Bn["paint_fill-extrusion"]["fill-extrusion-height"]), "fill-extrusion-base": new Mo(Bn["paint_fill-extrusion"]["fill-extrusion-base"]), "fill-extrusion-height-alignment": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-height-alignment"]), "fill-extrusion-base-alignment": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-base-alignment"]), "fill-extrusion-vertical-gradient": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]), "fill-extrusion-ambient-occlusion-intensity": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]), "fill-extrusion-ambient-occlusion-radius": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]), "fill-extrusion-ambient-occlusion-wall-radius": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]), "fill-extrusion-ambient-occlusion-ground-radius": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]), "fill-extrusion-ambient-occlusion-ground-attenuation": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]), "fill-extrusion-flood-light-color": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]), "fill-extrusion-flood-light-intensity": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]), "fill-extrusion-flood-light-wall-radius": new Mo(Bn["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]), "fill-extrusion-flood-light-ground-radius": new Mo(Bn["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]), "fill-extrusion-flood-light-ground-attenuation": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]), "fill-extrusion-vertical-scale": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]), "fill-extrusion-rounded-roof": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]), "fill-extrusion-cutoff-fade-range": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]), "fill-extrusion-emissive-strength": new Mo(Bn["paint_fill-extrusion"]["fill-extrusion-emissive-strength"]), "fill-extrusion-line-width": new Mo(Bn["paint_fill-extrusion"]["fill-extrusion-line-width"]), "fill-extrusion-cast-shadows": new lo(Bn["paint_fill-extrusion"]["fill-extrusion-cast-shadows"]), "fill-extrusion-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }), "fill-extrusion-flood-light-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, de, Ce, De), this._stats = { numRenderedVerticesInShadowPass: 0, numRenderedVerticesInTransparentPass: 0 };
        }
        createBucket(Ie) {
          return new mm(Ie);
        }
        queryRadius() {
          return io(this.paint.get("fill-extrusion-translate"));
        }
        is3D() {
          return !0;
        }
        hasShadowPass() {
          return this.paint.get("fill-extrusion-cast-shadows");
        }
        cutoffRange() {
          return this.paint.get("fill-extrusion-cutoff-fade-range");
        }
        canCastShadows() {
          return !0;
        }
        getProgramIds() {
          return [this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"];
        }
        queryIntersectsFeature(Ie, de, Ce, De, Ke, Ve, er, fr, wr) {
          const kr = An(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), Ve.angle, Ie.pixelToTileUnitsFactor), cr = this.paint.get("fill-extrusion-height").evaluate(de, Ce), Mr = this.paint.get("fill-extrusion-base").evaluate(de, Ce), Er = [0, 0], xr = fr && Ve.elevation, Sr = Ve.elevation ? Ve.elevation.exaggeration() : 1, Br = Ie.tile.getBucket(this);
          if (xr && Br instanceof mm) {
            const Kr = Br.centroidVertexArray, ni = wr + 1;
            ni < Kr.length && (Er[0] = Kr.geta_centroid_pos0(ni), Er[1] = Kr.geta_centroid_pos1(ni));
          }
          if (Er[0] === 0 && Er[1] === 1)
            return !1;
          Ve.projection.name === "globe" && (De = u1([De], [new qi(0, 0), new qi(vo, vo)], Ie.tileID.canonical).map((Kr) => Kr.polygon).flat());
          const Fr = xr ? fr : null, [jr, Qr] = function(Kr, ni, gi, Si, Di, Ri, Bi, Ji, Fi, tn, cn) {
            return Kr.projection.name === "globe" ? function(ln, mn, wn, Cn, gn, Nn, oo, Un, fo, ho, bo) {
              const Jn = [], Ro = [], po = ln.projection.upVectorScale(bo, ln.center.lat, ln.worldSize).metersToTile, Lo = [0, 0, 0, 1], jo = [0, 0, 0, 1], oa = (fa, ha, va, os) => {
                fa[0] = ha, fa[1] = va, fa[2] = os, fa[3] = 1;
              }, ua = Sg();
              wn > 0 && (wn += ua), Cn += ua;
              for (const fa of mn) {
                const ha = [], va = [];
                for (const os of fa) {
                  const qa = os.x + gn.x, ra = os.y + gn.y, Ga = ln.projection.projectTilePoint(qa, ra, bo), ja = ln.projection.upVector(bo, os.x, os.y);
                  let as = wn, Gs = Cn;
                  if (oo) {
                    const Hs = Ag(qa, ra, wn, Cn, oo, Un, fo, ho);
                    as += Hs.base, Gs += Hs.top;
                  }
                  wn !== 0 ? oa(Lo, Ga.x + ja[0] * po * as, Ga.y + ja[1] * po * as, Ga.z + ja[2] * po * as) : oa(Lo, Ga.x, Ga.y, Ga.z), oa(jo, Ga.x + ja[0] * po * Gs, Ga.y + ja[1] * po * Gs, Ga.z + ja[2] * po * Gs), Zr.vec3.transformMat4(Lo, Lo, Nn), Zr.vec3.transformMat4(jo, jo, Nn), ha.push(new ff(Lo[0], Lo[1], Lo[2])), va.push(new ff(jo[0], jo[1], jo[2]));
                }
                Jn.push(ha), Ro.push(va);
              }
              return [Jn, Ro];
            }(Kr, ni, gi, Si, Di, Ri, Bi, Ji, Fi, tn, cn) : Bi ? function(ln, mn, wn, Cn, gn, Nn, oo, Un, fo) {
              const ho = [], bo = [], Jn = [0, 0, 0, 1];
              for (const Ro of ln) {
                const po = [], Lo = [];
                for (const jo of Ro) {
                  const oa = jo.x + Cn.x, ua = jo.y + Cn.y, fa = Ag(oa, ua, mn, wn, Nn, oo, Un, fo);
                  Jn[0] = oa, Jn[1] = ua, Jn[2] = fa.base, Jn[3] = 1, Zr.vec4.transformMat4(Jn, Jn, gn), Jn[3] = Math.max(Jn[3], 1e-5);
                  const ha = new ff(Jn[0] / Jn[3], Jn[1] / Jn[3], Jn[2] / Jn[3]);
                  Jn[0] = oa, Jn[1] = ua, Jn[2] = fa.top, Jn[3] = 1, Zr.vec4.transformMat4(Jn, Jn, gn), Jn[3] = Math.max(Jn[3], 1e-5);
                  const va = new ff(Jn[0] / Jn[3], Jn[1] / Jn[3], Jn[2] / Jn[3]);
                  po.push(ha), Lo.push(va);
                }
                ho.push(po), bo.push(Lo);
              }
              return [ho, bo];
            }(ni, gi, Si, Di, Ri, Bi, Ji, Fi, tn) : function(ln, mn, wn, Cn, gn) {
              const Nn = [], oo = [], Un = gn[8] * mn, fo = gn[9] * mn, ho = gn[10] * mn, bo = gn[11] * mn, Jn = gn[8] * wn, Ro = gn[9] * wn, po = gn[10] * wn, Lo = gn[11] * wn;
              for (const jo of ln) {
                const oa = [], ua = [];
                for (const fa of jo) {
                  const ha = fa.x + Cn.x, va = fa.y + Cn.y, os = gn[0] * ha + gn[4] * va + gn[12], qa = gn[1] * ha + gn[5] * va + gn[13], ra = gn[2] * ha + gn[6] * va + gn[14], Ga = gn[3] * ha + gn[7] * va + gn[15], ja = os + Un, as = qa + fo, Gs = ra + ho, Hs = Math.max(Ga + bo, 1e-5), Is = os + Jn, Mc = qa + Ro, gs = ra + po, ws = Math.max(Ga + Lo, 1e-5);
                  oa.push(new ff(ja / Hs, as / Hs, Gs / Hs)), ua.push(new ff(Is / ws, Mc / ws, gs / ws));
                }
                Nn.push(oa), oo.push(ua);
              }
              return [Nn, oo];
            }(ni, gi, Si, Di, Ri);
          }(Ve, De, Mr, cr, kr, er, Fr, Er, Sr, Ve.center.lat, Ie.tileID.canonical), ti = Ie.queryGeometry;
          return function(Kr, ni, gi) {
            let Si = 1 / 0;
            Ni(gi, ni) && (Si = Tg(gi, ni[0]));
            for (let Di = 0; Di < ni.length; Di++) {
              const Ri = ni[Di], Bi = Kr[Di];
              for (let Ji = 0; Ji < Ri.length - 1; Ji++) {
                const Fi = Ri[Ji], tn = [Fi, Ri[Ji + 1], Bi[Ji + 1], Bi[Ji], Fi];
                Ei(gi, tn) && (Si = Math.min(Si, Tg(gi, tn)));
              }
            }
            return Si !== 1 / 0 && Si;
          }(jr, Qr, ti.isPointQuery() ? ti.screenBounds : ti.screenGeometry);
        }
      }, line: class extends Cl {
        constructor(Ie, de, Ce, De) {
          const Ke = Pg();
          super(Ie, Ke, de, Ce, De), Ke.layout && (this.layout = new Zs(Ke.layout)), this.gradientVersion = 0;
        }
        _handleSpecialPaintPropertyUpdate(Ie) {
          if (Ie === "line-gradient") {
            const de = this._transitionablePaint._values["line-gradient"].value.expression;
            this.stepInterpolant = de._styleExpression && de._styleExpression.expression instanceof Cu, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
          }
        }
        gradientExpression() {
          return this._transitionablePaint._values["line-gradient"].value.expression;
        }
        widthExpression() {
          return this._transitionablePaint._values["line-width"].value.expression;
        }
        recalculate(Ie, de) {
          super.recalculate(Ie, de), this.paint._values["line-floorwidth"] = (() => {
            if (vm)
              return vm;
            const Ce = Pg();
            return vm = new Dg(Ce.paint.properties["line-width"].specification), vm.useIntegerZoom = !0, vm;
          })().possiblyEvaluate(this._transitioningPaint._values["line-width"].value, Ie);
        }
        createBucket(Ie) {
          return new f1(Ie);
        }
        getProgramIds() {
          return [this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"];
        }
        getDefaultProgramParams(Ie, de, Ce) {
          const De = m1(this);
          return { config: new bh(this, { zoom: de, lut: Ce }), defines: De, overrideFog: !1 };
        }
        queryRadius(Ie) {
          const de = Ie, Ce = Og(Hn("line-width", this, de), Hn("line-gap-width", this, de)), De = Hn("line-offset", this, de);
          return Ce / 2 + Math.abs(De) + io(this.paint.get("line-translate"));
        }
        queryIntersectsFeature(Ie, de, Ce, De, Ke, Ve) {
          if (Ie.queryGeometry.isAboveHorizon)
            return !1;
          const er = uo(Ie.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), Ve.angle, Ie.pixelToTileUnitsFactor), fr = Ie.pixelToTileUnitsFactor / 2 * Og(this.paint.get("line-width").evaluate(de, Ce), this.paint.get("line-gap-width").evaluate(de, Ce)), wr = this.paint.get("line-offset").evaluate(de, Ce);
          return wr && (De = function(kr, cr) {
            const Mr = [], Er = new qi(0, 0);
            for (let xr = 0; xr < kr.length; xr++) {
              const Sr = kr[xr], Br = [];
              for (let Fr = 0; Fr < Sr.length; Fr++) {
                const jr = Sr[Fr], Qr = Sr[Fr + 1], ti = Fr === 0 ? Er : jr.sub(Sr[Fr - 1])._unit()._perp(), Kr = Fr === Sr.length - 1 ? Er : Qr.sub(jr)._unit()._perp(), ni = ti._add(Kr)._unit();
                ni._mult(1 / (ni.x * Kr.x + ni.y * Kr.y)), Br.push(ni._mult(cr)._add(jr));
              }
              Mr.push(Br);
            }
            return Mr;
          }(De, wr * Ie.pixelToTileUnitsFactor)), function(kr, cr, Mr) {
            for (let Er = 0; Er < cr.length; Er++) {
              const xr = cr[Er];
              if (kr.length >= 3) {
                for (let Sr = 0; Sr < xr.length; Sr++)
                  if (dn(kr, xr[Sr]))
                    return !0;
              }
              if (zi(kr, xr, Mr))
                return !0;
            }
            return !1;
          }(er, De, fr);
        }
        isTileClipped() {
          return !0;
        }
        isDraped(Ie) {
          const de = this.layout.get("line-z-offset"), Ce = de.isConstant() && !de.constantOr(0), De = this.layout.get("line-elevation-reference");
          return !(De === "sea" || De === "ground") && (Ce || De !== "none");
        }
      }, symbol: cv, background: class extends Cl {
        constructor(Ie, de, Ce, De) {
          super(Ie, { layout: g2 || (g2 = new ys({ visibility: new lo(Bn.layout_background.visibility) })), paint: v2 || (v2 = new ys({ "background-pitch-alignment": new lo(Bn.paint_background["background-pitch-alignment"]), "background-color": new lo(Bn.paint_background["background-color"]), "background-pattern": new lo(Bn.paint_background["background-pattern"]), "background-opacity": new lo(Bn.paint_background["background-opacity"]), "background-emissive-strength": new lo(Bn.paint_background["background-emissive-strength"]), "background-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, de, Ce, De);
        }
        getProgramIds() {
          return [this.paint.get("background-pattern") ? "backgroundPattern" : "background"];
        }
        getDefaultProgramParams(Ie, de, Ce) {
          return { overrideFog: !1 };
        }
        is3D() {
          return this.paint.get("background-pitch-alignment") === "viewport";
        }
      }, raster: w2, "raster-particle": A2, sky: class extends Cl {
        constructor(Ie, de, Ce, De) {
          super(Ie, { layout: E2 || (E2 = new ys({ visibility: new lo(Bn.layout_sky.visibility) })), paint: C2 || (C2 = new ys({ "sky-type": new lo(Bn.paint_sky["sky-type"]), "sky-atmosphere-sun": new lo(Bn.paint_sky["sky-atmosphere-sun"]), "sky-atmosphere-sun-intensity": new lo(Bn.paint_sky["sky-atmosphere-sun-intensity"]), "sky-gradient-center": new lo(Bn.paint_sky["sky-gradient-center"]), "sky-gradient-radius": new lo(Bn.paint_sky["sky-gradient-radius"]), "sky-gradient": new Jh(Bn.paint_sky["sky-gradient"]), "sky-atmosphere-halo-color": new lo(Bn.paint_sky["sky-atmosphere-halo-color"]), "sky-atmosphere-color": new lo(Bn.paint_sky["sky-atmosphere-color"]), "sky-opacity": new lo(Bn.paint_sky["sky-opacity"]), "sky-gradient-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }), "sky-atmosphere-halo-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }), "sky-atmosphere-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, de, Ce, De), this._updateColorRamp();
        }
        _handleSpecialPaintPropertyUpdate(Ie) {
          Ie === "sky-gradient" ? this._updateColorRamp() : Ie !== "sky-atmosphere-sun" && Ie !== "sky-atmosphere-halo-color" && Ie !== "sky-atmosphere-color" && Ie !== "sky-atmosphere-sun-intensity" || (this._skyboxInvalidated = !0);
        }
        _updateColorRamp() {
          this.colorRamp = im({ expression: this._transitionablePaint._values["sky-gradient"].value.expression, evaluationKey: "skyRadialProgress" }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
        }
        needsSkyboxCapture(Ie) {
          if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry)
            return !0;
          if (!this.paint.get("sky-atmosphere-sun")) {
            const de = Ie.style.light.properties.get("position");
            return this._lightPosition.azimuthal !== de.azimuthal || this._lightPosition.polar !== de.polar;
          }
          return !1;
        }
        getCenter(Ie, de) {
          if (this.paint.get("sky-type") === "atmosphere") {
            const De = this.paint.get("sky-atmosphere-sun"), Ke = !De, Ve = Ie.style.light, er = Ve.properties.get("position");
            return Ke && Ve.properties.get("anchor") === "viewport" && Mn("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), Ke ? P_(er.azimuthal, 90 - er.polar, de) : P_(De[0], 90 - De[1], de);
          }
          const Ce = this.paint.get("sky-gradient-center");
          return P_(Ce[0], 90 - Ce[1], de);
        }
        isSky() {
          return !0;
        }
        markSkyboxValid(Ie) {
          this._skyboxInvalidated = !1, this._lightPosition = Ie.style.light.properties.get("position");
        }
        hasOffscreenPass() {
          return !0;
        }
        getProgramIds() {
          const Ie = this.paint.get("sky-type");
          return Ie === "atmosphere" ? ["skyboxCapture", "skybox"] : Ie === "gradient" ? ["skyboxGradient"] : null;
        }
      }, slot: class extends Cl {
        constructor(Ie, de, Ce, De) {
          super(Ie, { paint: T2 || (T2 = new ys({})) }, de, null);
        }
      }, model: class extends Cl {
        constructor(Ie, de, Ce, De) {
          super(Ie, { layout: z2 || (z2 = new ys({ visibility: new lo(Bn.layout_model.visibility), "model-id": new Mo(Bn.layout_model["model-id"]) })), paint: F2 || (F2 = new ys({ "model-opacity": new Mo(Bn.paint_model["model-opacity"]), "model-rotation": new Mo(Bn.paint_model["model-rotation"]), "model-scale": new Mo(Bn.paint_model["model-scale"]), "model-translation": new Mo(Bn.paint_model["model-translation"]), "model-color": new Mo(Bn.paint_model["model-color"]), "model-color-mix-intensity": new Mo(Bn.paint_model["model-color-mix-intensity"]), "model-type": new lo(Bn.paint_model["model-type"]), "model-cast-shadows": new lo(Bn.paint_model["model-cast-shadows"]), "model-receive-shadows": new lo(Bn.paint_model["model-receive-shadows"]), "model-ambient-occlusion-intensity": new lo(Bn.paint_model["model-ambient-occlusion-intensity"]), "model-emissive-strength": new Mo(Bn.paint_model["model-emissive-strength"]), "model-roughness": new Mo(Bn.paint_model["model-roughness"]), "model-height-based-emissive-strength-multiplier": new Mo(Bn.paint_model["model-height-based-emissive-strength-multiplier"]), "model-cutoff-fade-range": new lo(Bn.paint_model["model-cutoff-fade-range"]), "model-front-cutoff": new lo(Bn.paint_model["model-front-cutoff"]), "model-color-use-theme": new Mo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, de, Ce, De), this._stats = { numRenderedVerticesInShadowPass: 0, numRenderedVerticesInTransparentPass: 0 };
        }
        createBucket(Ie) {
          return new z_(Ie);
        }
        getProgramIds() {
          return ["model"];
        }
        is3D() {
          return !0;
        }
        hasShadowPass() {
          return !0;
        }
        canCastShadows() {
          return !0;
        }
        hasLightBeamPass() {
          return !0;
        }
        cutoffRange() {
          return this.paint.get("model-cutoff-fade-range");
        }
        queryRadius(Ie) {
          return Ie instanceof vv ? vo - 1 : 0;
        }
        queryIntersectsFeature(Ie, de, Ce, De, Ke, Ve) {
          if (!this.modelManager)
            return !1;
          const er = this.modelManager, fr = Ie.tile.getBucket(this);
          if (!(fr && fr instanceof z_))
            return !1;
          for (const wr in fr.instancesPerModel) {
            const kr = fr.instancesPerModel[wr], cr = de.id !== void 0 ? de.id : de.properties && de.properties.hasOwnProperty("id") ? de.properties.id : void 0;
            if (kr.idToFeaturesIndex.hasOwnProperty(cr)) {
              const Mr = kr.features[kr.idToFeaturesIndex[cr]], Er = er.getModel(wr, this.scope);
              if (!Er)
                return !1;
              let xr = Zr.mat4.create();
              const Sr = new Ba(0, 0), Br = fr.canonical;
              let Fr = Number.MAX_VALUE;
              for (let jr = 0; jr < Mr.instancedDataCount; ++jr) {
                const Qr = 16 * (Mr.instancedDataOffset + jr), ti = kr.instancedDataArray.float32, Kr = [ti[Qr + 4], ti[Qr + 5], ti[Qr + 6]];
                G2(Br, Sr, ti[Qr], 0 | ti[Qr + 1]), N2(xr, Er, Ve, Sr, Mr.rotation, Mr.scale, Kr, !1, !1, !1), Ve.projection.name === "globe" && (xr = O_(xr, Ve));
                const ni = Zr.mat4.multiply([], Ve.projMatrix, xr), gi = Ie.queryGeometry, Si = $2(gi.isPointQuery() ? gi.screenBounds : gi.screenGeometry, Ve, ni, Er.aabb);
                Si != null && (Fr = Math.min(Si, Fr));
              }
              return Fr !== Number.MAX_VALUE && Fr;
            }
          }
          return !1;
        }
        _handleOverridablePaintPropertyUpdate(Ie, de, Ce) {
          return !(!this.layout || de.isDataDriven() || Ce.isDataDriven() || Ie !== "model-color" && Ie !== "model-color-mix-intensity" && Ie !== "model-rotation" && Ie !== "model-scale" && Ie !== "model-translation" && Ie !== "model-emissive-strength");
        }
        _isPropertyZoomDependent(Ie) {
          const de = this._transitionablePaint._values[Ie];
          return de != null && de.value != null && de.value.expression != null && de.value.expression instanceof Wh;
        }
        isZoomDependent() {
          return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
        }
      }, clip: class extends Cl {
        constructor(Ie, de, Ce, De) {
          super(Ie, { layout: ag || (ag = new ys({ "clip-layer-types": new lo(Bn.layout_clip["clip-layer-types"]), "clip-layer-scope": new lo(Bn.layout_clip["clip-layer-scope"]) })), paint: um || (um = new ys({})) }, de, Ce, De);
        }
        recalculate(Ie, de) {
          super.recalculate(Ie, de);
        }
        createBucket(Ie) {
          return new sg(Ie);
        }
        isTileClipped() {
          return !0;
        }
        is3D() {
          return !0;
        }
      } };
      class sb {
        constructor(de) {
          this._callback = de, this._triggered = !1, typeof MessageChannel < "u" && (this._channel = new MessageChannel(), this._channel.port2.onmessage = () => {
            this._triggered = !1, this._callback();
          });
        }
        trigger() {
          this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(() => {
            this._triggered = !1, this._callback();
          }, 0));
        }
        remove() {
          this._channel = void 0, this._callback = () => {
          };
        }
      }
      class lb {
        constructor() {
          this.tasks = {}, this.taskQueue = [], yi(["process"], this), this.invoker = new sb(this.process), this.nextId = 0;
        }
        add(de, Ce) {
          const De = this.nextId++, Ke = function({ type: Ve, isSymbolTile: er, zoom: fr }) {
            return fr = fr || 0, Ve === "message" ? 0 : Ve !== "maybePrepare" || er ? Ve !== "parseTile" || er ? Ve === "parseTile" && er ? 300 - fr : Ve === "maybePrepare" && er ? 400 - fr : 500 : 200 - fr : 100 - fr;
          }(Ce);
          if (Ke === 0) {
            try {
              de();
            } finally {
            }
            return null;
          }
          return this.tasks[De] = { fn: de, metadata: Ce, priority: Ke, id: De }, this.taskQueue.push(De), this.invoker.trigger(), { cancel: () => {
            delete this.tasks[De];
          } };
        }
        process() {
          try {
            if (this.taskQueue = this.taskQueue.filter((De) => !!this.tasks[De]), !this.taskQueue.length)
              return;
            const de = this.pick();
            if (de === null)
              return;
            const Ce = this.tasks[de];
            if (delete this.tasks[de], this.taskQueue.length && this.invoker.trigger(), !Ce)
              return;
            Ce.fn();
          } finally {
          }
        }
        pick() {
          let de = null, Ce = 1 / 0;
          for (let Ke = 0; Ke < this.taskQueue.length; Ke++) {
            const Ve = this.tasks[this.taskQueue[Ke]];
            Ve.priority < Ce && (Ce = Ve.priority, de = Ke);
          }
          if (de === null)
            return null;
          const De = this.taskQueue[de];
          return this.taskQueue.splice(de, 1), De;
        }
        remove() {
          this.invoker.remove();
        }
      }
      class H2 {
        constructor(de, Ce, De) {
          this.target = de, this.parent = Ce, this.mapId = De, this.callbacks = {}, this.cancelCallbacks = {}, yi(["receive"], this), this.target.addEventListener("message", this.receive, !1), this.scheduler = new lb();
        }
        send(de, Ce, De, Ke, Ve = !1, er) {
          const fr = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
          De && (De.metadata = er, this.callbacks[fr] = De);
          const wr = /* @__PURE__ */ new Set();
          return this.target.postMessage({ id: fr, type: de, hasCallback: !!De, targetMapId: Ke, mustQueue: Ve, sourceMapId: this.mapId, data: Lu(Ce, wr) }, wr), { cancel: () => {
            De && delete this.callbacks[fr], this.target.postMessage({ id: fr, type: "<cancel>", targetMapId: Ke, sourceMapId: this.mapId });
          } };
        }
        receive(de) {
          const Ce = de.data, De = Ce.id;
          if (De && (!Ce.targetMapId || this.mapId === Ce.targetMapId))
            if (Ce.type === "<cancel>") {
              const Ke = this.cancelCallbacks[De];
              delete this.cancelCallbacks[De], Ke && Ke.cancel();
            } else if (Ce.mustQueue || to()) {
              const Ke = this.callbacks[De], Ve = this.scheduler.add(() => this.processTask(De, Ce), Ke && Ke.metadata || { type: "message" });
              Ve && (this.cancelCallbacks[De] = Ve);
            } else
              this.processTask(De, Ce);
        }
        processTask(de, Ce) {
          if (delete this.cancelCallbacks[de], Ce.type === "<response>") {
            const De = this.callbacks[de];
            delete this.callbacks[de], De && (Ce.error ? De(lh(Ce.error)) : De(null, lh(Ce.data)));
          } else {
            const De = /* @__PURE__ */ new Set(), Ke = Ce.hasCallback ? (er, fr) => {
              this.target.postMessage({ id: de, type: "<response>", sourceMapId: this.mapId, error: er ? Lu(er) : null, data: Lu(fr, De) }, De);
            } : () => {
            }, Ve = lh(Ce.data);
            if (this.parent[Ce.type])
              this.parent[Ce.type](Ce.sourceMapId, Ve, Ke);
            else if (this.parent.getWorkerSource) {
              const er = Ce.type.split(".");
              this.parent.getWorkerSource(Ce.sourceMapId, er[0], Ve.source, Ve.scope)[er[1]](Ve, Ke);
            } else
              Ke(new Error(`Could not find function ${Ce.type}`));
          }
        }
        remove() {
          this.scheduler.remove(), this.target.removeEventListener("message", this.receive, !1);
        }
      }
      var $1 = { workerUrl: "", workerClass: null, workerParams: void 0 };
      const U_ = "mapboxgl_preloaded_worker_pool";
      class Am {
        constructor() {
          this.active = {};
        }
        acquire(de, Ce = Am.workerCount) {
          if (!this.workers)
            for (this.workers = []; this.workers.length < Ce; )
              this.workers.push($1.workerClass != null ? new $1.workerClass() : new self.Worker($1.workerUrl, $1.workerParams));
          return this.active[de] = !0, this.workers.slice();
        }
        release(de) {
          delete this.active[de], this.workers && this.numActive() === 0 && (this.workers.forEach((Ce) => {
            Ce.terminate();
          }), this.workers = null);
        }
        isPreloaded() {
          return !!this.active[U_];
        }
        numActive() {
          return Object.keys(this.active).length;
        }
      }
      Am.workerCount = 2;
      class k0 {
        constructor(de, Ce, De = "Worker", Ke = Am.workerCount) {
          this.workerPool = de, this.actors = [], this.currentActor = 0, this.id = Ci();
          const Ve = this.workerPool.acquire(this.id, Ke);
          for (let er = 0; er < Ve.length; er++) {
            const fr = new k0.Actor(Ve[er], Ce, this.id);
            fr.name = `${De} ${er}`, this.actors.push(fr);
          }
          this.ready = !1, this.broadcast("checkIfReady", null, () => {
            this.ready = !0;
          });
        }
        broadcast(de, Ce, De) {
          Xn(this.actors, (Ke, Ve) => {
            Ke.send(de, Ce, Ve);
          }, De = De || function() {
          });
        }
        getActor() {
          return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
        }
        remove() {
          this.actors.forEach((de) => {
            de.remove();
          }), this.actors = [], this.workerPool.release(this.id);
        }
      }
      let R1, j_;
      function _v() {
        return R1 || (R1 = new Am()), R1;
      }
      k0.Actor = H2;
      const q_ = new Ca(0, 0, 0);
      var yv = ((Ie) => (Ie[Ie.PATH_RULE_UNSPECIFIED = 0] = "PATH_RULE_UNSPECIFIED", Ie[Ie.PATH_RULE_NON_ZERO = 1] = "PATH_RULE_NON_ZERO", Ie[Ie.PATH_RULE_EVEN_ODD = 2] = "PATH_RULE_EVEN_ODD", Ie))(yv || {}), bv = ((Ie) => (Ie[Ie.LINE_CAP_UNSPECIFIED = 0] = "LINE_CAP_UNSPECIFIED", Ie[Ie.LINE_CAP_BUTT = 1] = "LINE_CAP_BUTT", Ie[Ie.LINE_CAP_ROUND = 2] = "LINE_CAP_ROUND", Ie[Ie.LINE_CAP_SQUARE = 3] = "LINE_CAP_SQUARE", Ie))(bv || {}), P1 = ((Ie) => (Ie[Ie.LINE_JOIN_UNSPECIFIED = 0] = "LINE_JOIN_UNSPECIFIED", Ie[Ie.LINE_JOIN_MITER = 1] = "LINE_JOIN_MITER", Ie[Ie.LINE_JOIN_MITER_CLIP = 2] = "LINE_JOIN_MITER_CLIP", Ie[Ie.LINE_JOIN_ROUND = 3] = "LINE_JOIN_ROUND", Ie[Ie.LINE_JOIN_BEVEL = 4] = "LINE_JOIN_BEVEL", Ie))(P1 || {}), W2 = ((Ie) => (Ie[Ie.PAINT_ORDER_UNSPECIFIED = 0] = "PAINT_ORDER_UNSPECIFIED", Ie[Ie.PAINT_ORDER_FILL_AND_STROKE = 1] = "PAINT_ORDER_FILL_AND_STROKE", Ie[Ie.PAINT_ORDER_STROKE_AND_FILL = 2] = "PAINT_ORDER_STROKE_AND_FILL", Ie))(W2 || {}), L0 = ((Ie) => (Ie[Ie.PATH_COMMAND_UNSPECIFIED = 0] = "PATH_COMMAND_UNSPECIFIED", Ie[Ie.PATH_COMMAND_MOVE = 1] = "PATH_COMMAND_MOVE", Ie[Ie.PATH_COMMAND_LINE = 2] = "PATH_COMMAND_LINE", Ie[Ie.PATH_COMMAND_QUAD = 3] = "PATH_COMMAND_QUAD", Ie[Ie.PATH_COMMAND_CUBIC = 4] = "PATH_COMMAND_CUBIC", Ie[Ie.PATH_COMMAND_CLOSE = 5] = "PATH_COMMAND_CLOSE", Ie))(L0 || {}), Z2 = ((Ie) => (Ie[Ie.MASK_TYPE_UNSPECIFIED = 0] = "MASK_TYPE_UNSPECIFIED", Ie[Ie.MASK_TYPE_LUMINANCE = 1] = "MASK_TYPE_LUMINANCE", Ie[Ie.MASK_TYPE_ALPHA = 2] = "MASK_TYPE_ALPHA", Ie))(Z2 || {});
      function cb(Ie, de, Ce) {
        Ie === 1 && de.icons.push(function(De, Ke) {
          return function(Ve) {
            if (Ve.usvg_tree.height || (Ve.usvg_tree.height = Ve.usvg_tree.width), !Ve.metadata)
              return Ve;
            const { metadata: er } = Ve;
            if (er.content_area) {
              const { content_area: fr } = er;
              fr.top == null && (fr.top = fr.left), fr.width == null && (fr.width = Ve.usvg_tree.width), fr.height == null && (fr.height = fr.width);
            }
            return er.stretch_x && er.stretch_x.length && X2(er, "x"), er.stretch_y && er.stretch_y.length && X2(er, "y"), Ve;
          }(De.readFields(ub, { name: void 0 }, Ke));
        }(Ce, Ce.readVarint() + Ce.pos));
      }
      function X2(Ie, de) {
        const Ce = [], De = Ie[`stretch_${de}`];
        let Ke = null;
        for (let Ve = 0; Ve < De.length; Ve++)
          Ke === null ? Ke = Ce.length === 0 ? De[0] : Ce[Ce.length - 1][1] + De[Ve] : (Ce.push([Ke, Ke + De[Ve]]), Ke = null);
        Ie[`stretch_${de}_areas`] = Ce;
      }
      function ub(Ie, de, Ce) {
        Ie === 1 ? de.name = Ce.readString() : Ie === 2 ? de.metadata = function(De, Ke) {
          return De.readFields(hb, { stretch_x: null, stretch_y: null, stretch_x_areas: null, stretch_y_areas: null, variables: [] }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos) : Ie === 3 && (de.usvg_tree = function(De, Ke) {
          return De.readFields(pb, { width: 20, children: [], linear_gradients: [], radial_gradients: [], clip_paths: [], masks: [] }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos), de.data = "usvg_tree");
      }
      function hb(Ie, de, Ce) {
        Ie === 1 ? de.stretch_x = Ce.readPackedVarint() : Ie === 2 ? de.stretch_y = Ce.readPackedVarint() : Ie === 3 ? de.content_area = function(De, Ke) {
          return De.readFields(db, { left: 0 }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos) : Ie === 4 && de.variables.push(function(De, Ke) {
          return De.readFields(fb, { name: void 0 }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos));
      }
      function db(Ie, de, Ce) {
        Ie === 1 ? de.left = Ce.readVarint() : Ie === 2 ? de.width = Ce.readVarint() : Ie === 3 ? de.top = Ce.readVarint() : Ie === 4 && (de.height = Ce.readVarint());
      }
      function fb(Ie, de, Ce) {
        Ie === 1 ? de.name = Ce.readString() : Ie === 2 && (de.rgb_color = Mv(Ce.readVarint()), de.value = "rgb_color");
      }
      function pb(Ie, de, Ce) {
        Ie === 1 ? de.width = de.height = Ce.readVarint() : Ie === 2 ? de.height = Ce.readVarint() : Ie === 3 ? de.children.push(xv(Ce, Ce.readVarint() + Ce.pos)) : Ie === 4 ? de.linear_gradients.push(function(De, Ke) {
          return De.readFields(xb, { spread_method: 1, stops: [], x1: 0, y1: 0, x2: 1, y2: 0 }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos)) : Ie === 5 ? de.radial_gradients.push(function(De, Ke) {
          return De.readFields(Mb, { spread_method: 1, stops: [], cx: 0.5, cy: 0.5, r: 0.5, fx: 0.5, fy: 0.5, fr: 0 }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos)) : Ie === 7 ? de.clip_paths.push(function(De, Ke) {
          return De.readFields(Sb, { children: [] }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos)) : Ie === 8 && de.masks.push(function(De, Ke) {
          const Ve = De.readFields(Eb, { left: 0, width: 20, mask_type: 1, children: [] }, Ke);
          return Ve.height == null && (Ve.height = Ve.width), Ve.top == null && (Ve.top = Ve.left), Ve;
        }(Ce, Ce.readVarint() + Ce.pos));
      }
      function xv(Ie, de) {
        return Ie.readFields(mb, {}, de);
      }
      function mb(Ie, de, Ce) {
        Ie === 1 ? (de.group = function(De, Ke) {
          return De.readFields(gb, { opacity: 255, children: [] }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos), de.node = "group") : Ie === 2 && (de.path = function(De, Ke) {
          return De.readFields(_b, { paint_order: 1, commands: [], step: 1, diffs: [], rule: 1 }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos), de.node = "path");
      }
      function gb(Ie, de, Ce) {
        Ie === 1 ? de.transform = wv(Ce, Ce.readVarint() + Ce.pos) : Ie === 2 ? de.opacity = Ce.readVarint() : Ie === 5 ? de.clip_path_idx = Ce.readVarint() : Ie === 6 ? de.mask_idx = Ce.readVarint() : Ie === 7 && de.children.push(xv(Ce, Ce.readVarint() + Ce.pos));
      }
      function wv(Ie, de) {
        return Ie.readFields(vb, { sx: 1, ky: 0, kx: 0, sy: 1, tx: 0, ty: 0 }, de);
      }
      function vb(Ie, de, Ce) {
        Ie === 1 ? de.sx = Ce.readFloat() : Ie === 2 ? de.ky = Ce.readFloat() : Ie === 3 ? de.kx = Ce.readFloat() : Ie === 4 ? de.sy = Ce.readFloat() : Ie === 5 ? de.tx = Ce.readFloat() : Ie === 6 && (de.ty = Ce.readFloat());
      }
      function _b(Ie, de, Ce) {
        Ie === 1 ? de.fill = function(De, Ke) {
          return De.readFields(yb, { rgb_color: q_, paint: "rgb_color", opacity: 255 }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos) : Ie === 2 ? de.stroke = function(De, Ke) {
          return De.readFields(bb, { rgb_color: q_, paint: "rgb_color", dasharray: [], dashoffset: 0, miterlimit: 4, opacity: 255, width: 1, linecap: 1, linejoin: 1 }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos) : Ie === 3 ? de.paint_order = Ce.readVarint() : Ie === 5 ? Ce.readPackedVarint(de.commands) : Ie === 6 ? de.step = Ce.readFloat() : Ie === 7 ? Ce.readPackedSVarint(de.diffs) : Ie === 8 && (de.rule = Ce.readVarint());
      }
      function yb(Ie, de, Ce) {
        Ie === 1 ? (de.rgb_color = Mv(Ce.readVarint()), de.paint = "rgb_color") : Ie === 2 ? (de.linear_gradient_idx = Ce.readVarint(), de.paint = "linear_gradient_idx") : Ie === 3 ? (de.radial_gradient_idx = Ce.readVarint(), de.paint = "radial_gradient_idx") : Ie === 5 && (de.opacity = Ce.readVarint());
      }
      function Mv(Ie) {
        return new Ca((Ie >> 16 & 255) / 255, (Ie >> 8 & 255) / 255, (255 & Ie) / 255, 1);
      }
      function bb(Ie, de, Ce) {
        Ie === 1 ? (de.rgb_color = Mv(Ce.readVarint()), de.paint = "rgb_color") : Ie === 2 ? (de.linear_gradient_idx = Ce.readVarint(), de.paint = "linear_gradient_idx") : Ie === 3 ? (de.radial_gradient_idx = Ce.readVarint(), de.paint = "radial_gradient_idx") : Ie === 5 ? Ce.readPackedFloat(de.dasharray) : Ie === 6 ? de.dashoffset = Ce.readFloat() : Ie === 7 ? de.miterlimit = Ce.readFloat() : Ie === 8 ? de.opacity = Ce.readVarint() : Ie === 9 ? de.width = Ce.readFloat() : Ie === 10 ? de.linecap = Ce.readVarint() : Ie === 11 && (de.linejoin = Ce.readVarint());
      }
      function xb(Ie, de, Ce) {
        Ie === 1 ? de.transform = wv(Ce, Ce.readVarint() + Ce.pos) : Ie === 2 ? de.spread_method = Ce.readVarint() : Ie === 3 ? de.stops.push(K2(Ce, Ce.readVarint() + Ce.pos)) : Ie === 4 ? de.x1 = Ce.readFloat() : Ie === 5 ? de.y1 = Ce.readFloat() : Ie === 6 ? de.x2 = Ce.readFloat() : Ie === 7 && (de.y2 = Ce.readFloat());
      }
      function K2(Ie, de) {
        return Ie.readFields(wb, { offset: 0, opacity: 255, rgb_color: q_ }, de);
      }
      function wb(Ie, de, Ce) {
        Ie === 1 ? de.offset = Ce.readFloat() : Ie === 2 ? de.opacity = Ce.readVarint() : Ie === 3 && (de.rgb_color = Mv(Ce.readVarint()));
      }
      function Mb(Ie, de, Ce) {
        Ie === 1 ? de.transform = wv(Ce, Ce.readVarint() + Ce.pos) : Ie === 2 ? de.spread_method = Ce.readVarint() : Ie === 3 ? de.stops.push(K2(Ce, Ce.readVarint() + Ce.pos)) : Ie === 4 ? de.cx = Ce.readFloat() : Ie === 5 ? de.cy = Ce.readFloat() : Ie === 6 ? de.r = Ce.readFloat() : Ie === 7 ? de.fx = Ce.readFloat() : Ie === 8 ? de.fy = Ce.readFloat() : Ie === 9 && (de.fr = Ce.readFloat());
      }
      function Sb(Ie, de, Ce) {
        Ie === 1 ? de.transform = wv(Ce, Ce.readVarint() + Ce.pos) : Ie === 2 ? de.clip_path_idx = Ce.readVarint() : Ie === 3 && de.children.push(xv(Ce, Ce.readVarint() + Ce.pos));
      }
      function Eb(Ie, de, Ce) {
        Ie === 1 ? de.left = de.top = Ce.readFloat() : Ie === 2 ? de.width = de.height = Ce.readFloat() : Ie === 3 ? de.top = Ce.readFloat() : Ie === 4 ? de.height = Ce.readFloat() : Ie === 5 ? de.mask_type = Ce.readVarint() : Ie === 6 ? de.mask_idx = Ce.readVarint() : Ie === 7 && de.children.push(xv(Ce, Ce.readVarint() + Ce.pos));
      }
      class Cb {
        static calculate(de, Ce) {
          const De = /* @__PURE__ */ new Map(), Ke = /* @__PURE__ */ new Map();
          if (Object.keys(de).length === 0)
            return De;
          Ce.forEach((Ve) => {
            Ke.set(Ve.name, Ve.rgb_color || new Ca(0, 0, 0));
          });
          for (const [Ve, er] of Object.entries(de))
            Ke.has(Ve) ? De.set(Ke.get(Ve).toStringPremultipliedAlpha(), er) : console.warn(`Ignoring unknown image variable "${Ve}"`);
          return De;
        }
      }
      function I0(Ie, de = 255, Ce) {
        const De = de / 255, Ke = Ie.toStringPremultipliedAlpha(), Ve = Ce.has(Ke) ? Ce.get(Ke).clone() : Ie.clone();
        return Ve.a = De, Ve.toString();
      }
      function G_(Ie, de) {
        if (!qn()) {
          const Ce = document.createElement("canvas");
          return Ce.width = Ie, Ce.height = de, Ce;
        }
        return new OffscreenCanvas(Ie, de);
      }
      function Tb(Ie, de) {
        const Ce = Cb.calculate(de.params, Ie.metadata ? Ie.metadata.variables : []), De = Ie.usvg_tree, Ke = De.width, Ve = De.height, er = de.transform ? de.transform : new DOMMatrix(), fr = Math.max(1, Math.round(Ke * er.a)), wr = Math.max(1, Math.round(Ve * er.d)), kr = new DOMMatrix([fr / Ke, 0, 0, wr / Ve, 0, 0]), cr = G_(fr, wr).getContext("2d");
        return H_(cr, kr, De, De, Ce), cr.getImageData(0, 0, fr, wr);
      }
      function H_(Ie, de, Ce, De, Ke) {
        for (const Ve of De.children)
          Y2(Ie, de, Ce, Ve, Ke);
      }
      function Y2(Ie, de, Ce, De, Ke) {
        De.group ? (Ie.save(), function(Ve, er, fr, wr, kr) {
          const cr = wr.mask_idx != null ? fr.masks[wr.mask_idx] : null, Mr = wr.clip_path_idx != null ? fr.clip_paths[wr.clip_path_idx] : null;
          if (wr.transform && (er = D1(wr.transform).preMultiplySelf(er)), !function(Sr, Br, Fr) {
            return Sr.opacity !== 255 || Br || Fr;
          }(wr, Mr != null, cr != null))
            return void H_(Ve, er, fr, wr, kr);
          const Er = G_(Ve.canvas.width, Ve.canvas.height), xr = Er.getContext("2d");
          Mr && ry(xr, er, fr, Mr), H_(xr, er, fr, wr, kr), cr && iy(xr, er, fr, cr, kr), Ve.globalAlpha = wr.opacity / 255, Ve.drawImage(Er, 0, 0);
        }(Ie, de, Ce, De.group, Ke), Ie.restore()) : De.path && (Ie.save(), function(Ve, er, fr, wr, kr) {
          const cr = ny(wr);
          Ve.setTransform(er), wr.paint_order === W2.PAINT_ORDER_FILL_AND_STROKE ? (J2(Ve, fr, wr, cr, kr), Q2(Ve, fr, wr, cr, kr)) : (Q2(Ve, fr, wr, cr, kr), J2(Ve, fr, wr, cr, kr));
        }(Ie, de, Ce, De.path, Ke), Ie.restore());
      }
      function J2(Ie, de, Ce, De, Ke) {
        const Ve = Ce.fill;
        if (!Ve)
          return;
        const er = Ve.opacity / 255;
        switch (Ve.paint) {
          case "rgb_color":
            Ie.fillStyle = I0(Ve.rgb_color, Ve.opacity, Ke);
            break;
          case "linear_gradient_idx":
            Ie.fillStyle = ey(Ie, de.linear_gradients[Ve.linear_gradient_idx], er, Ke);
            break;
          case "radial_gradient_idx":
            Ie.fillStyle = ty(Ie, de.radial_gradients[Ve.radial_gradient_idx], er, Ke);
        }
        let fr;
        switch (Ce.rule) {
          case yv.PATH_RULE_NON_ZERO:
            fr = "nonzero";
            break;
          case yv.PATH_RULE_EVEN_ODD:
            fr = "evenodd";
        }
        Ie.fill(De, fr);
      }
      function Q2(Ie, de, Ce, De, Ke) {
        const Ve = Ce.stroke;
        if (!Ve)
          return;
        Ie.lineWidth = Ve.width, Ie.miterLimit = Ve.miterlimit, Ie.setLineDash(Ve.dasharray), Ie.lineDashOffset = Ve.dashoffset;
        const er = Ve.opacity / 255;
        switch (Ve.paint) {
          case "rgb_color":
            Ie.strokeStyle = I0(Ve.rgb_color, Ve.opacity, Ke);
            break;
          case "linear_gradient_idx":
            Ie.strokeStyle = ey(Ie, de.linear_gradients[Ve.linear_gradient_idx], er, Ke);
            break;
          case "radial_gradient_idx":
            Ie.strokeStyle = ty(Ie, de.radial_gradients[Ve.radial_gradient_idx], er, Ke);
        }
        switch (Ve.linejoin) {
          case P1.LINE_JOIN_MITER_CLIP:
          case P1.LINE_JOIN_MITER:
            Ie.lineJoin = "miter";
            break;
          case P1.LINE_JOIN_ROUND:
            Ie.lineJoin = "round";
            break;
          case P1.LINE_JOIN_BEVEL:
            Ie.lineJoin = "bevel";
        }
        switch (Ve.linecap) {
          case bv.LINE_CAP_BUTT:
            Ie.lineCap = "butt";
            break;
          case bv.LINE_CAP_ROUND:
            Ie.lineCap = "round";
            break;
          case bv.LINE_CAP_SQUARE:
            Ie.lineCap = "square";
        }
        Ie.stroke(De);
      }
      function ey(Ie, de, Ce, De) {
        if (de.stops.length === 1) {
          const Er = de.stops[0];
          return I0(Er.rgb_color, Er.opacity * Ce, De);
        }
        const Ke = D1(de.transform), { x1: Ve, y1: er, x2: fr, y2: wr } = de, kr = Ke.transformPoint(new DOMPoint(Ve, er)), cr = Ke.transformPoint(new DOMPoint(fr, wr)), Mr = Ie.createLinearGradient(kr.x, kr.y, cr.x, cr.y);
        for (const Er of de.stops)
          Mr.addColorStop(Er.offset, I0(Er.rgb_color, Er.opacity * Ce, De));
        return Mr;
      }
      function ty(Ie, de, Ce, De) {
        if (de.stops.length === 1) {
          const Er = de.stops[0];
          return I0(Er.rgb_color, Er.opacity * Ce, De);
        }
        const Ke = D1(de.transform), { fx: Ve, fy: er, cx: fr, cy: wr } = de, kr = Ke.transformPoint(new DOMPoint(Ve, er)), cr = Ke.transformPoint(new DOMPoint(fr, wr)), Mr = Ie.createRadialGradient(kr.x, kr.y, 0, cr.x, cr.y, de.r * ((Ke.a + Ke.d) / 2));
        for (const Er of de.stops)
          Mr.addColorStop(Er.offset, I0(Er.rgb_color, Er.opacity * Ce, De));
        return Mr;
      }
      function ry(Ie, de, Ce, De) {
        const Ke = D1(De.transform).preMultiplySelf(de), Ve = De.clip_path_idx != null ? Ce.clip_paths[De.clip_path_idx] : null;
        Ve && ry(Ie, Ke, Ce, Ve);
        const er = new Path2D();
        let fr;
        function wr(kr, cr) {
          if (kr.path) {
            const Mr = kr.path;
            er.addPath(ny(Mr), cr), Mr.rule === yv.PATH_RULE_EVEN_ODD && (fr = "evenodd");
          } else if (kr.group) {
            const Mr = kr.group.transform ? D1(kr.group.transform).preMultiplySelf(cr) : cr;
            for (const Er of kr.group.children)
              wr(Er, Mr);
          }
        }
        for (const kr of De.children)
          wr(kr, Ke);
        Ie.clip(er, fr);
      }
      function iy(Ie, de, Ce, De, Ke) {
        if (De.children.length === 0)
          return;
        const Ve = De.mask_idx != null ? Ce.masks[De.mask_idx] : null;
        Ve && iy(Ie, de, Ce, Ve, Ke);
        const er = Ie.canvas.width, fr = Ie.canvas.height, wr = G_(er, fr), kr = wr.getContext("2d"), cr = De.width, Mr = De.height, Er = De.left, xr = De.top, Sr = new Path2D(), Br = new Path2D();
        Br.rect(Er, xr, cr, Mr), Sr.addPath(Br, de), kr.clip(Sr);
        for (const Qr of De.children)
          Y2(kr, de, Ce, Qr, Ke);
        const Fr = kr.getImageData(0, 0, er, fr), jr = Fr.data;
        if (De.mask_type === Z2.MASK_TYPE_LUMINANCE)
          for (let Qr = 0; Qr < jr.length; Qr += 4)
            jr[Qr + 3] = jr[Qr + 3] / 255 * (0.2126 * jr[Qr] + 0.7152 * jr[Qr + 1] + 0.0722 * jr[Qr + 2]);
        kr.putImageData(Fr, 0, 0), Ie.globalCompositeOperation = "destination-in", Ie.drawImage(wr, 0, 0);
      }
      function D1(Ie) {
        return Ie ? new DOMMatrix([Ie.sx, Ie.ky, Ie.kx, Ie.sy, Ie.tx, Ie.ty]) : new DOMMatrix();
      }
      function ny(Ie) {
        const de = new Path2D(), Ce = Ie.step;
        let De = Ie.diffs[0] * Ce, Ke = Ie.diffs[1] * Ce;
        de.moveTo(De, Ke);
        for (let Ve = 0, er = 2; Ve < Ie.commands.length; Ve++)
          switch (Ie.commands[Ve]) {
            case L0.PATH_COMMAND_MOVE:
              De += Ie.diffs[er++] * Ce, Ke += Ie.diffs[er++] * Ce, de.moveTo(De, Ke);
              break;
            case L0.PATH_COMMAND_LINE:
              De += Ie.diffs[er++] * Ce, Ke += Ie.diffs[er++] * Ce, de.lineTo(De, Ke);
              break;
            case L0.PATH_COMMAND_QUAD: {
              const fr = De + Ie.diffs[er++] * Ce, wr = Ke + Ie.diffs[er++] * Ce;
              De = fr + Ie.diffs[er++] * Ce, Ke = wr + Ie.diffs[er++] * Ce, de.quadraticCurveTo(fr, wr, De, Ke);
              break;
            }
            case L0.PATH_COMMAND_CUBIC: {
              const fr = De + Ie.diffs[er++] * Ce, wr = Ke + Ie.diffs[er++] * Ce, kr = fr + Ie.diffs[er++] * Ce, cr = wr + Ie.diffs[er++] * Ce;
              De = kr + Ie.diffs[er++] * Ce, Ke = cr + Ie.diffs[er++] * Ce, de.bezierCurveTo(fr, wr, kr, cr, De, Ke);
              break;
            }
            case L0.PATH_COMMAND_CLOSE:
              de.closePath();
          }
        return de;
      }
      class W_ {
        constructor(de) {
          this.capacity = de, this.cache = /* @__PURE__ */ new Map();
        }
        get(de) {
          if (!this.cache.has(de))
            return;
          const Ce = this.cache.get(de);
          return this.cache.delete(de), this.cache.set(de, Ce), Ce;
        }
        put(de, Ce) {
          this.cache.has(de) ? this.cache.delete(de) : this.cache.size === this.capacity && this.cache.delete(this.cache.keys().next().value), this.cache.set(de, Ce);
        }
        delete(de) {
          this.cache.delete(de);
        }
      }
      class Z_ {
        constructor() {
          this.cacheMap = /* @__PURE__ */ new Map(), this.cacheDependenciesMap = /* @__PURE__ */ new Map();
        }
        static _getImage(de) {
          return new Al(de, de.data);
        }
        getFromCache(de, Ce, De) {
          return this.cacheMap.has(De) || this.cacheMap.set(De, new W_(150)), this.cacheMap.get(De).get(fl(de.serialize(), Ce));
        }
        setInCache(de, Ce, De, Ke) {
          this.cacheDependenciesMap.has(Ke) || this.cacheDependenciesMap.set(Ke, /* @__PURE__ */ new Map()), this.cacheMap.has(Ke) || this.cacheMap.set(Ke, new W_(150));
          const Ve = this.cacheDependenciesMap.get(Ke);
          Ve.get(fl(de.id, De)) || Ve.set(fl(de.id, De), /* @__PURE__ */ new Set());
          const er = this.cacheMap.get(Ke), fr = de.serialize();
          Ve.get(fl(de.id, De)).add(fr), er.put(fl(de.serialize(), De), Ce);
        }
        removeImagesFromCacheByIds(de, Ce, De = "") {
          if (!this.cacheMap.has(De) || !this.cacheDependenciesMap.has(De))
            return;
          const Ke = this.cacheMap.get(De), Ve = this.cacheDependenciesMap.get(De);
          for (const er of de)
            if (Ve.has(fl(er, Ce))) {
              for (const fr of Ve.get(fl(er, Ce)))
                Ke.delete(fr);
              Ve.delete(fl(er, Ce));
            }
        }
        rasterize(de, Ce, De, Ke, Ve = Tb) {
          const er = this.getFromCache(de, De, Ke);
          if (er)
            return er.clone();
          const fr = Ve(Ce.icon, de.options), wr = Z_._getImage(fr);
          return this.setInCache(de, wr, De, Ke), wr.clone();
        }
      }
      class oy {
        constructor(de) {
          this.size = de, this.minimums = [], this.maximums = [], this.leaves = [];
        }
        getElevation(de, Ce) {
          const De = this.toIdx(de, Ce);
          return { min: this.minimums[De], max: this.maximums[De] };
        }
        isLeaf(de, Ce) {
          return this.leaves[this.toIdx(de, Ce)];
        }
        toIdx(de, Ce) {
          return Ce * this.size + de;
        }
      }
      function ay(Ie, de, Ce, De) {
        let Ke = 0, Ve = Number.MAX_VALUE;
        for (let er = 0; er < 3; er++)
          if (Math.abs(De[er]) < 1e-15) {
            if (Ce[er] < Ie[er] || Ce[er] > de[er])
              return null;
          } else {
            const fr = 1 / De[er];
            let wr = (Ie[er] - Ce[er]) * fr, kr = (de[er] - Ce[er]) * fr;
            if (wr > kr) {
              const cr = wr;
              wr = kr, kr = cr;
            }
            if (wr > Ke && (Ke = wr), kr < Ve && (Ve = kr), Ke > Ve)
              return null;
          }
        return Ke;
      }
      function sy(Ie, de, Ce, De, Ke, Ve, er, fr, wr, kr, cr) {
        const Mr = De - Ie, Er = Ke - de, xr = Ve - Ce, Sr = er - Ie, Br = fr - de, Fr = wr - Ce, jr = cr[1] * Fr - cr[2] * Br, Qr = cr[2] * Sr - cr[0] * Fr, ti = cr[0] * Br - cr[1] * Sr, Kr = Mr * jr + Er * Qr + xr * ti;
        if (Math.abs(Kr) < 1e-15)
          return null;
        const ni = 1 / Kr, gi = kr[0] - Ie, Si = kr[1] - de, Di = kr[2] - Ce, Ri = (gi * jr + Si * Qr + Di * ti) * ni;
        if (Ri < 0 || Ri > 1)
          return null;
        const Bi = Si * xr - Di * Er, Ji = Di * Mr - gi * xr, Fi = gi * Er - Si * Mr, tn = (cr[0] * Bi + cr[1] * Ji + cr[2] * Fi) * ni;
        return tn < 0 || Ri + tn > 1 ? null : (Sr * Bi + Br * Ji + Fr * Fi) * ni;
      }
      function ly(Ie, de, Ce) {
        return (Ie - de) / (Ce - de);
      }
      function cy(Ie, de, Ce, De, Ke, Ve, er, fr, wr) {
        const kr = 1 << Ce, cr = Ve - De, Mr = er - Ke, Er = (Ie + 1) / kr * cr + De, xr = (de + 0) / kr * Mr + Ke, Sr = (de + 1) / kr * Mr + Ke;
        fr[0] = (Ie + 0) / kr * cr + De, fr[1] = xr, wr[0] = Er, wr[1] = Sr;
      }
      class uy {
        constructor(de) {
          if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = de, this._siblingOffset = [[0, 0], [1, 0], [0, 1], [1, 1]], !this.dem)
            return;
          const Ce = function(Ve) {
            const er = Math.ceil(Math.log2(Ve.dim / 8)), fr = [];
            let wr = Math.ceil(Math.pow(2, er));
            const kr = 1 / wr, cr = (xr, Sr, Br, Fr, jr) => {
              const Qr = Fr ? 1 : 0, ti = (xr + 1) * Br - Qr, Kr = Sr * Br, ni = (Sr + 1) * Br - Qr;
              jr[0] = xr * Br, jr[1] = Kr, jr[2] = ti, jr[3] = ni;
            };
            let Mr = new oy(wr);
            const Er = [];
            for (let xr = 0; xr < wr * wr; xr++) {
              cr(xr % wr, Math.floor(xr / wr), kr, !1, Er);
              const Sr = _p(Er[0], Er[1], Ve), Br = _p(Er[2], Er[1], Ve), Fr = _p(Er[2], Er[3], Ve), jr = _p(Er[0], Er[3], Ve);
              Mr.minimums.push(Math.min(Sr, Br, Fr, jr)), Mr.maximums.push(Math.max(Sr, Br, Fr, jr)), Mr.leaves.push(1);
            }
            for (fr.push(Mr), wr /= 2; wr >= 1; wr /= 2) {
              const xr = fr[fr.length - 1];
              Mr = new oy(wr);
              for (let Sr = 0; Sr < wr * wr; Sr++) {
                cr(Sr % wr, Math.floor(Sr / wr), 2, !0, Er);
                const Br = xr.getElevation(Er[0], Er[1]), Fr = xr.getElevation(Er[2], Er[1]), jr = xr.getElevation(Er[2], Er[3]), Qr = xr.getElevation(Er[0], Er[3]), ti = xr.isLeaf(Er[0], Er[1]), Kr = xr.isLeaf(Er[2], Er[1]), ni = xr.isLeaf(Er[2], Er[3]), gi = xr.isLeaf(Er[0], Er[3]), Si = Math.min(Br.min, Fr.min, jr.min, Qr.min), Di = Math.max(Br.max, Fr.max, jr.max, Qr.max), Ri = ti && Kr && ni && gi;
                Mr.maximums.push(Di), Mr.minimums.push(Si), Mr.leaves.push(Di - Si <= 5 && Ri ? 1 : 0);
              }
              fr.push(Mr);
            }
            return fr;
          }(this.dem), De = Ce.length - 1, Ke = Ce[De];
          this._addNode(Ke.minimums[0], Ke.maximums[0], Ke.leaves[0]), this._construct(Ce, 0, 0, De, 0);
        }
        raycastRoot(de, Ce, De, Ke, Ve, er, fr = 1) {
          return ay([de, Ce, -100], [De, Ke, this.maximums[0] * fr], Ve, er);
        }
        raycast(de, Ce, De, Ke, Ve, er, fr = 1) {
          if (!this.nodeCount)
            return null;
          const wr = this.raycastRoot(de, Ce, De, Ke, Ve, er, fr);
          if (wr == null)
            return null;
          const kr = [], cr = [], Mr = [], Er = [], xr = [{ idx: 0, t: wr, nodex: 0, nodey: 0, depth: 0 }];
          for (; xr.length > 0; ) {
            const { idx: Sr, t: Br, nodex: Fr, nodey: jr, depth: Qr } = xr.pop();
            if (this.leaves[Sr]) {
              cy(Fr, jr, Qr, de, Ce, De, Ke, Mr, Er);
              const Kr = 1 << Qr, ni = (Fr + 0) / Kr, gi = (Fr + 1) / Kr, Si = (jr + 0) / Kr, Di = (jr + 1) / Kr, Ri = _p(ni, Si, this.dem) * fr, Bi = _p(gi, Si, this.dem) * fr, Ji = _p(gi, Di, this.dem) * fr, Fi = _p(ni, Di, this.dem) * fr, tn = sy(Mr[0], Mr[1], Ri, Er[0], Mr[1], Bi, Er[0], Er[1], Ji, Ve, er), cn = sy(Er[0], Er[1], Ji, Mr[0], Er[1], Fi, Mr[0], Mr[1], Ri, Ve, er), ln = Math.min(tn !== null ? tn : Number.MAX_VALUE, cn !== null ? cn : Number.MAX_VALUE);
              if (ln !== Number.MAX_VALUE)
                return ln;
              {
                const mn = Zr.vec3.scaleAndAdd([], Ve, er, Br);
                if (hy(Ri, Bi, Fi, Ji, ly(mn[0], Mr[0], Er[0]), ly(mn[1], Mr[1], Er[1])) >= mn[2])
                  return Br;
              }
              continue;
            }
            let ti = 0;
            for (let Kr = 0; Kr < this._siblingOffset.length; Kr++) {
              cy((Fr << 1) + this._siblingOffset[Kr][0], (jr << 1) + this._siblingOffset[Kr][1], Qr + 1, de, Ce, De, Ke, Mr, Er), Mr[2] = -100, Er[2] = this.maximums[this.childOffsets[Sr] + Kr] * fr;
              const ni = ay(Mr, Er, Ve, er);
              if (ni != null) {
                const gi = ni;
                kr[Kr] = gi;
                let Si = !1;
                for (let Di = 0; Di < ti && !Si; Di++)
                  gi >= kr[cr[Di]] && (cr.splice(Di, 0, Kr), Si = !0);
                Si || (cr[ti] = Kr), ti++;
              }
            }
            for (let Kr = 0; Kr < ti; Kr++) {
              const ni = cr[Kr];
              xr.push({ idx: this.childOffsets[Sr] + ni, t: kr[ni], nodex: (Fr << 1) + this._siblingOffset[ni][0], nodey: (jr << 1) + this._siblingOffset[ni][1], depth: Qr + 1 });
            }
          }
          return null;
        }
        _addNode(de, Ce, De) {
          return this.minimums.push(de), this.maximums.push(Ce), this.leaves.push(De), this.childOffsets.push(0), this.nodeCount++;
        }
        _construct(de, Ce, De, Ke, Ve) {
          if (de[Ke].isLeaf(Ce, De) === 1)
            return;
          this.childOffsets[Ve] || (this.childOffsets[Ve] = this.nodeCount);
          const er = Ke - 1, fr = de[er];
          let wr = 0, kr = 0;
          for (let cr = 0; cr < this._siblingOffset.length; cr++) {
            const Mr = 2 * Ce + this._siblingOffset[cr][0], Er = 2 * De + this._siblingOffset[cr][1], xr = fr.getElevation(Mr, Er), Sr = fr.isLeaf(Mr, Er), Br = this._addNode(xr.min, xr.max, Sr);
            Sr && (wr |= 1 << cr), kr || (kr = Br);
          }
          for (let cr = 0; cr < this._siblingOffset.length; cr++)
            wr & 1 << cr || this._construct(de, 2 * Ce + this._siblingOffset[cr][0], 2 * De + this._siblingOffset[cr][1], er, kr + cr);
        }
      }
      function hy(Ie, de, Ce, De, Ke, Ve) {
        return Ho(Ho(Ie, Ce, Ve), Ho(de, De, Ve), Ke);
      }
      function _p(Ie, de, Ce) {
        const De = Ce.dim, Ke = vn(Ie * De - 0.5, 0, De - 1), Ve = vn(de * De - 0.5, 0, De - 1), er = Math.floor(Ke), fr = Math.floor(Ve), wr = Math.min(er + 1, De - 1), kr = Math.min(fr + 1, De - 1);
        return hy(Ce.get(er, fr), Ce.get(wr, fr), Ce.get(er, kr), Ce.get(wr, kr), Ke - er, Ve - fr);
      }
      const Ab = { mapbox: [6553.6, 25.6, 0.1, 1e4], terrarium: [256, 1, 1 / 256, 32768] };
      function kb(Ie, de, Ce) {
        return (256 * Ie * 256 + 256 * de + Ce) / 10 - 1e4;
      }
      function Lb(Ie, de, Ce) {
        return 256 * Ie + de + Ce / 256 - 32768;
      }
      class Sv {
        get tree() {
          return this._tree || this._buildQuadTree(), this._tree;
        }
        constructor(de, Ce, De, Ke = !1) {
          if (this.uid = de, Ce.height !== Ce.width)
            throw new RangeError("DEM tiles must be square");
          if (De && De !== "mapbox" && De !== "terrarium")
            return void Mn(`"${De}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
          this.stride = Ce.height;
          const Ve = this.dim = Ce.height - 2, er = new Uint32Array(Ce.data.buffer);
          if (this.pixels = new Uint8Array(Ce.data.buffer), this.floatView = new Float32Array(Ce.data.buffer), this.borderReady = Ke, this._modifiedForSources = {}, !Ke) {
            for (let wr = 0; wr < Ve; wr++)
              er[this._idx(-1, wr)] = er[this._idx(0, wr)], er[this._idx(Ve, wr)] = er[this._idx(Ve - 1, wr)], er[this._idx(wr, -1)] = er[this._idx(wr, 0)], er[this._idx(wr, Ve)] = er[this._idx(wr, Ve - 1)];
            er[this._idx(-1, -1)] = er[this._idx(0, 0)], er[this._idx(Ve, -1)] = er[this._idx(Ve - 1, 0)], er[this._idx(-1, Ve)] = er[this._idx(0, Ve - 1)], er[this._idx(Ve, Ve)] = er[this._idx(Ve - 1, Ve - 1)];
          }
          const fr = De === "terrarium" ? Lb : kb;
          for (let wr = 0; wr < er.length; ++wr) {
            const kr = 4 * wr;
            this.floatView[wr] = fr(this.pixels[kr], this.pixels[kr + 1], this.pixels[kr + 2]);
          }
          this._timestamp = _n.now();
        }
        _buildQuadTree() {
          this._tree = new uy(this);
        }
        get(de, Ce, De = !1) {
          De && (de = vn(de, -1, this.dim), Ce = vn(Ce, -1, this.dim));
          const Ke = this._idx(de, Ce);
          return this.floatView[Ke];
        }
        set(de, Ce, De) {
          const Ke = this._idx(de, Ce), Ve = this.floatView[Ke];
          return this.floatView[Ke] = De, De - Ve;
        }
        static getUnpackVector(de) {
          return Ab[de];
        }
        _idx(de, Ce) {
          if (de < -1 || de >= this.dim + 1 || Ce < -1 || Ce >= this.dim + 1)
            throw new RangeError("out of range source coordinates for DEM data");
          return (Ce + 1) * this.stride + (de + 1);
        }
        static pack(de, Ce) {
          const De = [0, 0, 0, 0], Ke = Sv.getUnpackVector(Ce);
          let Ve = Math.floor((de + Ke[3]) / Ke[2]);
          return De[2] = Ve % 256, Ve = Math.floor(Ve / 256), De[1] = Ve % 256, Ve = Math.floor(Ve / 256), De[0] = Ve, De;
        }
        getPixels() {
          return new J1({ width: this.stride, height: this.stride }, this.pixels);
        }
        backfillBorder(de, Ce, De) {
          if (this.dim !== de.dim)
            throw new Error("dem dimension mismatch");
          let Ke = Ce * this.dim, Ve = Ce * this.dim + this.dim, er = De * this.dim, fr = De * this.dim + this.dim;
          switch (Ce) {
            case -1:
              Ke = Ve - 1;
              break;
            case 1:
              Ve = Ke + 1;
          }
          switch (De) {
            case -1:
              er = fr - 1;
              break;
            case 1:
              fr = er + 1;
          }
          const wr = -Ce * this.dim, kr = -De * this.dim;
          for (let cr = er; cr < fr; cr++)
            for (let Mr = Ke; Mr < Ve; Mr++) {
              const Er = 4 * this._idx(Mr, cr), xr = 4 * this._idx(Mr + wr, cr + kr);
              this.pixels[Er + 0] = de.pixels[xr + 0], this.pixels[Er + 1] = de.pixels[xr + 1], this.pixels[Er + 2] = de.pixels[xr + 2], this.pixels[Er + 3] = de.pixels[xr + 3];
            }
        }
        onDeserialize() {
          this._tree && (this._tree.dem = this);
        }
      }
      function Ib(Ie, de, Ce) {
        Ie === 1 ? de.headerLength = Ce.readFixed32() : Ie === 2 ? de.x = Ce.readVarint() : Ie === 3 ? de.y = Ce.readVarint() : Ie === 4 ? de.z = Ce.readVarint() : Ie === 5 && de.layers.push(function(De, Ke) {
          return De.readFields(Db, { version: 0, name: "", units: "", tileSize: 0, buffer: 0, pixelFormat: 0, dataIndex: [] }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos));
      }
      function Bb(Ie, de, Ce) {
        Ie === 1 ? (de.delta_filter = function(De, Ke) {
          return De.readFields($b, { blockSize: 0 }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos), de.filter = "delta_filter") : Ie === 2 ? (Ce.readVarint(), de.filter = "zigzag_filter") : Ie === 3 ? (Ce.readVarint(), de.filter = "bitshuffle_filter") : Ie === 4 && (Ce.readVarint(), de.filter = "byteshuffle_filter");
      }
      function $b(Ie, de, Ce) {
        Ie === 1 && (de.blockSize = Ce.readVarint());
      }
      function Rb(Ie, de, Ce) {
        Ie === 1 ? (Ce.readVarint(), de.codec = "gzip_data") : Ie === 2 ? (Ce.readVarint(), de.codec = "jpeg_image") : Ie === 3 ? (Ce.readVarint(), de.codec = "webp_image") : Ie === 4 && (Ce.readVarint(), de.codec = "png_image");
      }
      function Pb(Ie, de, Ce) {
        let De = 0, Ke = 0;
        Ie === 1 ? de.firstByte = Ce.readFixed64() : Ie === 2 ? de.lastByte = Ce.readFixed64() : Ie === 3 ? de.filters.push(function(Ve, er) {
          return Ve.readFields(Bb, {}, er);
        }(Ce, Ce.readVarint() + Ce.pos)) : Ie === 4 ? de.codec = function(Ve, er) {
          return Ve.readFields(Rb, {}, er);
        }(Ce, Ce.readVarint() + Ce.pos) : Ie === 5 ? Ke = Ce.readFloat() : Ie === 6 ? De = Ce.readFloat() : Ie === 7 ? de.bands.push(Ce.readString()) : Ie === 8 ? de.offset = Ce.readDouble() : Ie === 9 && (de.scale = Ce.readDouble()), de.offset === 0 && (de.offset = Ke), de.scale === 0 && (de.scale = De);
      }
      function Db(Ie, de, Ce) {
        Ie === 1 ? de.version = Ce.readVarint() : Ie === 2 ? de.name = Ce.readString() : Ie === 3 ? de.units = Ce.readString() : Ie === 4 ? de.tileSize = Ce.readVarint() : Ie === 5 ? de.buffer = Ce.readVarint() : Ie === 6 ? de.pixelFormat = Ce.readVarint() : Ie === 7 && de.dataIndex.push(function(De, Ke) {
          return De.readFields(Pb, { firstByte: 0, lastByte: 0, filters: [], codec: null, offset: 0, scale: 0, bands: [] }, Ke);
        }(Ce, Ce.readVarint() + Ce.pos));
      }
      function Ob(Ie, de, Ce) {
        if (Ie === 2)
          (function(De, Ke, Ve) {
            De.readFields(zb, Ve, Ke);
          })(Ce, Ce.readVarint() + Ce.pos, de);
        else if (Ie === 3)
          throw new Error("Not implemented");
      }
      function zb(Ie, de, Ce) {
        if (Ie === 1) {
          let De = 0;
          const Ke = Ce.readVarint() + Ce.pos;
          for (; Ce.pos < Ke; )
            de[De++] = Ce.readVarint();
        }
      }
      function Fb(Ie, de) {
        if (de.length !== 4)
          throw new Error(`Expected data of dimension 4 but got ${de.length}.`);
        let Ce = de[3];
        for (let De = 2; De >= 1; De--) {
          const Ke = De === 1 ? 1 : 0, Ve = De === 2 ? 1 : 0;
          for (let er = 0; er < de[0]; er++) {
            const fr = de[1] * er;
            for (let wr = Ke; wr < de[1]; wr++) {
              const kr = de[2] * (wr + fr);
              for (let cr = Ve; cr < de[2]; cr++) {
                const Mr = de[3] * (cr + kr);
                for (let Er = 0; Er < de[3]; Er++) {
                  const xr = Mr + Er;
                  Ie[xr] += Ie[xr - Ce];
                }
              }
            }
          }
          Ce *= de[De];
        }
        return Ie;
      }
      function Nb(Ie) {
        for (let de = 0, Ce = Ie.length; de < Ce; de++)
          Ie[de] = Ie[de] >>> 1 ^ -(1 & Ie[de]);
        return Ie;
      }
      function Vb(Ie, de) {
        switch (de) {
          case "uint32":
            return Ie;
          case "uint16":
            for (let Ce = 0; Ce < Ie.length; Ce += 2) {
              const De = Ie[Ce], Ke = Ie[Ce + 1];
              Ie[Ce] = (240 & De) >> 4 | (61440 & De) >> 8 | (240 & Ke) << 4 | 61440 & Ke, Ie[Ce + 1] = 15 & De | (3840 & De) >> 4 | (15 & Ke) << 8 | (3840 & Ke) << 4;
            }
            return Ie;
          case "uint8":
            for (let Ce = 0; Ce < Ie.length; Ce += 4) {
              const De = Ie[Ce], Ke = Ie[Ce + 1], Ve = Ie[Ce + 2], er = Ie[Ce + 3];
              Ie[Ce + 0] = (192 & De) >> 6 | (192 & Ke) >> 4 | (192 & Ve) >> 2 | 192 & er, Ie[Ce + 1] = (48 & De) >> 4 | (48 & Ke) >> 2 | 48 & Ve | (48 & er) << 2, Ie[Ce + 2] = (12 & De) >> 2 | 12 & Ke | (12 & Ve) << 2 | (12 & er) << 4, Ie[Ce + 3] = 3 & De | (3 & Ke) << 2 | (3 & Ve) << 4 | (3 & er) << 6;
            }
            return Ie;
          default:
            throw new Error(`Invalid pixel format, "${de}"`);
        }
      }
      Ao(Sv, "DEMData"), Ao(uy, "DemMinMaxQuadTree", { omit: ["dem"] });
      var bu = Uint8Array, O1 = Uint16Array, Ub = Int32Array, dy = new bu([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), fy = new bu([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), jb = new bu([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), py = function(Ie, de) {
        for (var Ce = new O1(31), De = 0; De < 31; ++De)
          Ce[De] = de += 1 << Ie[De - 1];
        var Ke = new Ub(Ce[30]);
        for (De = 1; De < 30; ++De)
          for (var Ve = Ce[De]; Ve < Ce[De + 1]; ++Ve)
            Ke[Ve] = Ve - Ce[De] << 5 | De;
        return { b: Ce, r: Ke };
      }, my = py(dy, 2), gy = my.b, qb = my.r;
      gy[28] = 258, qb[258] = 28;
      for (var Gb = py(fy, 0).b, vy = new O1(32768), qs = 0; qs < 32768; ++qs) {
        var B0 = (43690 & qs) >> 1 | (21845 & qs) << 1;
        vy[qs] = ((65280 & (B0 = (61680 & (B0 = (52428 & B0) >> 2 | (13107 & B0) << 2)) >> 4 | (3855 & B0) << 4)) >> 8 | (255 & B0) << 8) >> 1;
      }
      var z1 = function(Ie, de, Ce) {
        for (var De = Ie.length, Ke = 0, Ve = new O1(de); Ke < De; ++Ke)
          Ie[Ke] && ++Ve[Ie[Ke] - 1];
        var er, fr = new O1(de);
        for (Ke = 1; Ke < de; ++Ke)
          fr[Ke] = fr[Ke - 1] + Ve[Ke - 1] << 1;
        er = new O1(1 << de);
        var wr = 15 - de;
        for (Ke = 0; Ke < De; ++Ke)
          if (Ie[Ke])
            for (var kr = Ke << 4 | Ie[Ke], cr = de - Ie[Ke], Mr = fr[Ie[Ke] - 1]++ << cr, Er = Mr | (1 << cr) - 1; Mr <= Er; ++Mr)
              er[vy[Mr] >> wr] = kr;
        return er;
      }, F1 = new bu(288);
      for (qs = 0; qs < 144; ++qs)
        F1[qs] = 8;
      for (qs = 144; qs < 256; ++qs)
        F1[qs] = 9;
      for (qs = 256; qs < 280; ++qs)
        F1[qs] = 7;
      for (qs = 280; qs < 288; ++qs)
        F1[qs] = 8;
      var _y = new bu(32);
      for (qs = 0; qs < 32; ++qs)
        _y[qs] = 5;
      var Hb = z1(F1, 9), Wb = z1(_y, 5), X_ = function(Ie) {
        for (var de = Ie[0], Ce = 1; Ce < Ie.length; ++Ce)
          Ie[Ce] > de && (de = Ie[Ce]);
        return de;
      }, Th = function(Ie, de, Ce) {
        var De = de / 8 | 0;
        return (Ie[De] | Ie[De + 1] << 8) >> (7 & de) & Ce;
      }, K_ = function(Ie, de) {
        var Ce = de / 8 | 0;
        return (Ie[Ce] | Ie[Ce + 1] << 8 | Ie[Ce + 2] << 16) >> (7 & de);
      }, Zb = ["unexpected EOF", "invalid block type", "invalid length/literal", "invalid distance", "stream finished", "no stream handler", , "no callback", "invalid UTF-8 data", "extra field too long", "date not in range 1980-2099", "filename too long", "stream finishing", "invalid zip data"], Ah = function(Ie, de, Ce) {
        var De = new Error(de || Zb[Ie]);
        if (De.code = Ie, Error.captureStackTrace && Error.captureStackTrace(De, Ah), !Ce)
          throw De;
        return De;
      }, Xb = new bu(0), Kb = typeof TextDecoder < "u" && new TextDecoder();
      try {
        Kb.decode(Xb, { stream: !0 });
      } catch {
      }
      const Yb = { gzip_data: "gzip" };
      class Uu extends Error {
        constructor(de) {
          super(de), this.name = "MRTError";
        }
      }
      const Jb = { 0: "uint32", 1: "uint32", 2: "uint16", 3: "uint8" }, yy = { uint32: 1, uint16: 2, uint8: 4 }, Qb = { uint32: Uint32Array, uint16: Uint16Array, uint8: Uint8Array };
      let Y_;
      class J_ {
        constructor(de = 5) {
          this.x = NaN, this.y = NaN, this.z = NaN, this.layers = {}, this._cacheSize = de;
        }
        getLayer(de) {
          const Ce = this.layers[de];
          if (!Ce)
            throw new Uu(`Layer '${de}' not found`);
          return Ce;
        }
        getHeaderLength(de) {
          const Ce = new Uint8Array(de), De = new DataView(de);
          if (Ce[0] !== 13)
            throw new Uu("File is not a valid MRT.");
          return De.getUint32(1, !0);
        }
        parseHeader(de) {
          const Ce = new Uint8Array(de), De = this.getHeaderLength(de);
          if (Ce.length < De)
            throw new Uu(`Expected header with length >= ${De} but got buffer of length ${Ce.length}`);
          const Ke = function(Ve, er) {
            return Ve.readFields(Ib, { headerLength: 0, x: 0, y: 0, z: 0, layers: [] }, void 0);
          }(new Y_(Ce.subarray(0, De)));
          if (!isNaN(this.x) && (this.x !== Ke.x || this.y !== Ke.y || this.z !== Ke.z))
            throw new Uu(`Invalid attempt to parse header ${Ke.z}/${Ke.x}/${Ke.y} for tile ${this.z}/${this.x}/${this.y}`);
          this.x = Ke.x, this.y = Ke.y, this.z = Ke.z;
          for (const Ve of Ke.layers)
            this.layers[Ve.name] = new ex(Ve, { cacheSize: this._cacheSize });
          return this;
        }
        createDecodingTask(de) {
          const Ce = [], De = this.getLayer(de.layerName);
          for (let Ke of de.blockIndices) {
            const Ve = De.dataIndex[Ke], er = Ve.firstByte - de.firstByte, fr = Ve.lastByte - de.firstByte;
            if (De._blocksInProgress.has(Ke))
              continue;
            const wr = { layerName: De.name, firstByte: er, lastByte: fr, pixelFormat: De.pixelFormat, blockIndex: Ke, blockShape: [Ve.bands.length].concat(De.bandShape), buffer: De.buffer, codec: Ve.codec.codec, filters: Ve.filters.map((kr) => kr.filter) };
            De._blocksInProgress.add(Ke), Ce.push(wr);
          }
          return new by(Ce, () => {
            Ce.forEach((Ke) => De._blocksInProgress.delete(Ke.blockIndex));
          }, (Ke, Ve) => {
            if (Ce.forEach((er) => De._blocksInProgress.delete(er.blockIndex)), Ke)
              throw Ke;
            Ve.forEach((er) => {
              this.getLayer(er.layerName).processDecodedData(er);
            });
          });
        }
      }
      class ex {
        constructor({ version: de, name: Ce, units: De, tileSize: Ke, pixelFormat: Ve, buffer: er, dataIndex: fr }, wr) {
          if (this.version = de, this.version !== 1)
            throw new Uu(`Cannot parse raster layer encoded with MRT version ${de}`);
          this.name = Ce, this.units = De, this.tileSize = Ke, this.buffer = er, this.pixelFormat = Jb[Ve], this.dataIndex = fr, this.bandShape = [Ke + 2 * er, Ke + 2 * er, yy[this.pixelFormat]], this._decodedBlocks = new W_(wr ? wr.cacheSize : 5), this._blocksInProgress = /* @__PURE__ */ new Set();
        }
        get dimension() {
          return yy[this.pixelFormat];
        }
        get cacheSize() {
          return this._decodedBlocks.capacity;
        }
        getBandList() {
          return this.dataIndex.map(({ bands: de }) => de).flat();
        }
        processDecodedData(de) {
          const Ce = de.blockIndex.toString();
          this._decodedBlocks.get(Ce) || this._decodedBlocks.put(Ce, de.data);
        }
        getBlockForBand(de) {
          let Ce = 0;
          switch (typeof de) {
            case "string":
              for (const [De, Ke] of this.dataIndex.entries()) {
                for (const [Ve, er] of Ke.bands.entries())
                  if (er === de)
                    return { bandIndex: Ce + Ve, blockIndex: De, blockBandIndex: Ve };
                Ce += Ke.bands.length;
              }
              break;
            case "number":
              for (const [De, Ke] of this.dataIndex.entries()) {
                if (de >= Ce && de < Ce + Ke.bands.length)
                  return { bandIndex: de, blockIndex: De, blockBandIndex: de - Ce };
                Ce += Ke.bands.length;
              }
              break;
            default:
              throw new Uu(`Invalid band \`${JSON.stringify(de)}\`. Expected string or integer.`);
          }
          throw new Uu(`Band not found: ${JSON.stringify(de)}`);
        }
        getDataRange(de) {
          let Ce = 1 / 0, De = -1 / 0;
          const Ke = [], Ve = /* @__PURE__ */ new Set();
          for (const er of de) {
            const { blockIndex: fr } = this.getBlockForBand(er);
            if (fr < 0)
              throw new Uu(`Invalid band: ${JSON.stringify(er)}`);
            const wr = this.dataIndex[fr];
            Ke.includes(fr) || Ke.push(fr), Ve.add(fr), Ce = Math.min(Ce, wr.firstByte), De = Math.max(De, wr.lastByte);
          }
          if (Ve.size > this.cacheSize)
            throw new Uu(`Number of blocks to decode (${Ve.size}) exceeds cache size (${this.cacheSize}).`);
          return { layerName: this.name, firstByte: Ce, lastByte: De, blockIndices: Ke };
        }
        hasBand(de) {
          const { blockIndex: Ce } = this.getBlockForBand(de);
          return Ce >= 0;
        }
        hasDataForBand(de) {
          const { blockIndex: Ce } = this.getBlockForBand(de);
          return Ce >= 0 && !!this._decodedBlocks.get(Ce.toString());
        }
        getBandView(de) {
          const { blockIndex: Ce, blockBandIndex: De } = this.getBlockForBand(de), Ke = this._decodedBlocks.get(Ce.toString());
          if (!Ke)
            throw new Uu(`Data for band ${JSON.stringify(de)} of layer "${this.name}" not decoded.`);
          const Ve = this.dataIndex[Ce], er = this.bandShape.reduce((kr, cr) => kr * cr, 1), fr = De * er, wr = Ke.subarray(fr, fr + er);
          return { data: wr, bytes: new Uint8Array(wr.buffer).subarray(wr.byteOffset, wr.byteOffset + wr.byteLength), tileSize: this.tileSize, buffer: this.buffer, pixelFormat: this.pixelFormat, dimension: this.dimension, offset: Ve.offset, scale: Ve.scale };
        }
      }
      J_.setPbf = function(Ie) {
        Y_ = Ie;
      };
      class by {
        constructor(de, Ce, De) {
          this.tasks = de, this._onCancel = Ce, this._onComplete = De, this._finalized = !1;
        }
        cancel() {
          this._finalized || (this._onCancel(), this._finalized = !0);
        }
        complete(de, Ce) {
          this._finalized || (this._onComplete(de, Ce), this._finalized = !0);
        }
      }
      J_.performDecoding = function(Ie, de) {
        const Ce = new Uint8Array(Ie);
        return Promise.all(de.tasks.map((De) => {
          const { layerName: Ke, firstByte: Ve, lastByte: er, pixelFormat: fr, blockShape: wr, blockIndex: kr, filters: cr, codec: Mr } = De, Er = Ce.subarray(Ve, er + 1), xr = new Uint32Array(wr[0] * wr[1] * wr[2]);
          let Sr;
          if (Mr !== "gzip_data")
            throw new Uu(`Unhandled codec: ${Mr}`);
          return Sr = function(Br, Fr) {
            if (!globalThis.DecompressionStream && Fr === "gzip_data")
              return Promise.resolve(((Kr = function(Si) {
                Si[0] == 31 && Si[1] == 139 && Si[2] == 8 || Ah(6, "invalid gzip data");
                var Di = Si[3], Ri = 10;
                4 & Di && (Ri += 2 + (Si[10] | Si[11] << 8));
                for (var Bi = (Di >> 3 & 1) + (Di >> 4 & 1); Bi > 0; Bi -= !Si[Ri++])
                  ;
                return Ri + (2 & Di);
              }(ti = Br)) + 8 > ti.length && Ah(6, "invalid gzip data"), function(Si, Di, Ri, Bi) {
                var Ji = Si.length;
                if (!Ji || Di.f && !Di.l)
                  return Ri || new bu(0);
                var Fi = !Ri, tn = Fi || Di.i != 2, cn = Di.i;
                Fi && (Ri = new bu(3 * Ji));
                var ln, mn, wn = function(_f) {
                  var xp = Ri.length;
                  if (_f > xp) {
                    var wp = new bu(Math.max(2 * xp, _f));
                    wp.set(Ri), Ri = wp;
                  }
                }, Cn = Di.f || 0, gn = Di.p || 0, Nn = Di.b || 0, oo = Di.l, Un = Di.d, fo = Di.m, ho = Di.n, bo = 8 * Ji;
                do {
                  if (!oo) {
                    Cn = Th(Si, gn, 1);
                    var Jn = Th(Si, gn + 1, 3);
                    if (gn += 3, !Jn) {
                      var Ro = Si[(ra = 4 + ((gn + 7) / 8 | 0)) - 4] | Si[ra - 3] << 8, po = ra + Ro;
                      if (po > Ji) {
                        cn && Ah(0);
                        break;
                      }
                      tn && wn(Nn + Ro), Ri.set(Si.subarray(ra, po), Nn), Di.b = Nn += Ro, Di.p = gn = 8 * po, Di.f = Cn;
                      continue;
                    }
                    if (Jn == 1)
                      oo = Hb, Un = Wb, fo = 9, ho = 5;
                    else if (Jn == 2) {
                      var Lo = Th(Si, gn, 31) + 257, jo = Th(Si, gn + 10, 15) + 4, oa = Lo + Th(Si, gn + 5, 31) + 1;
                      gn += 14;
                      for (var ua = new bu(oa), fa = new bu(19), ha = 0; ha < jo; ++ha)
                        fa[jb[ha]] = Th(Si, gn + 3 * ha, 7);
                      gn += 3 * jo;
                      var va = X_(fa), os = (1 << va) - 1, qa = z1(fa, va);
                      for (ha = 0; ha < oa; ) {
                        var ra, Ga = qa[Th(Si, gn, os)];
                        if (gn += 15 & Ga, (ra = Ga >> 4) < 16)
                          ua[ha++] = ra;
                        else {
                          var ja = 0, as = 0;
                          for (ra == 16 ? (as = 3 + Th(Si, gn, 3), gn += 2, ja = ua[ha - 1]) : ra == 17 ? (as = 3 + Th(Si, gn, 7), gn += 3) : ra == 18 && (as = 11 + Th(Si, gn, 127), gn += 7); as--; )
                            ua[ha++] = ja;
                        }
                      }
                      var Gs = ua.subarray(0, Lo), Hs = ua.subarray(Lo);
                      fo = X_(Gs), ho = X_(Hs), oo = z1(Gs, fo), Un = z1(Hs, ho);
                    } else
                      Ah(1);
                    if (gn > bo) {
                      cn && Ah(0);
                      break;
                    }
                  }
                  tn && wn(Nn + 131072);
                  for (var Is = (1 << fo) - 1, Mc = (1 << ho) - 1, gs = gn; ; gs = gn) {
                    var ws = (ja = oo[K_(Si, gn) & Is]) >> 4;
                    if ((gn += 15 & ja) > bo) {
                      cn && Ah(0);
                      break;
                    }
                    if (ja || Ah(2), ws < 256)
                      Ri[Nn++] = ws;
                    else {
                      if (ws == 256) {
                        gs = gn, oo = null;
                        break;
                      }
                      var cc = ws - 254;
                      ws > 264 && (cc = Th(Si, gn, (1 << (nl = dy[ha = ws - 257])) - 1) + gy[ha], gn += nl);
                      var Ws = Un[K_(Si, gn) & Mc], zc = Ws >> 4;
                      if (Ws || Ah(3), gn += 15 & Ws, Hs = Gb[zc], zc > 3) {
                        var nl = fy[zc];
                        Hs += K_(Si, gn) & (1 << nl) - 1, gn += nl;
                      }
                      if (gn > bo) {
                        cn && Ah(0);
                        break;
                      }
                      tn && wn(Nn + 131072);
                      var gd = Nn + cc;
                      if (Nn < Hs) {
                        var yp = 0 - Hs, bp = Math.min(Hs, gd);
                        for (yp + Nn < 0 && Ah(3); Nn < bp; ++Nn)
                          Ri[Nn] = (void 0)[yp + Nn];
                      }
                      for (; Nn < gd; ++Nn)
                        Ri[Nn] = Ri[Nn - Hs];
                    }
                  }
                  Di.l = oo, Di.p = gs, Di.b = Nn, Di.f = Cn, oo && (Cn = 1, Di.m = fo, Di.d = Un, Di.n = ho);
                } while (!Cn);
                return Nn != Ri.length && Fi ? (ln = Ri, ((mn = Nn) == null || mn > ln.length) && (mn = ln.length), new bu(ln.subarray(0, mn))) : Ri.subarray(0, Nn);
              }(ti.subarray(Kr, -8), { i: 2 }, new bu(((jr = ti)[(Qr = jr.length) - 4] | jr[Qr - 3] << 8 | jr[Qr - 2] << 16 | jr[Qr - 1] << 24) >>> 0))));
            var jr, Qr, ti, Kr;
            const ni = Yb[Fr];
            if (!ni)
              throw new Error(`Unhandled codec: ${Fr}`);
            const gi = new globalThis.DecompressionStream(ni);
            return new Response(new Blob([Br]).stream().pipeThrough(gi)).arrayBuffer().then((Si) => new Uint8Array(Si));
          }(Er, Mr).then((Br) => (function(Fr, jr) {
            Fr.readFields(Ob, jr);
          }(new Y_(Br), xr), new Qb[fr](xr.buffer))), Sr.then((Br) => {
            for (let Fr = cr.length - 1; Fr >= 0; Fr--)
              switch (cr[Fr]) {
                case "delta_filter":
                  Fb(Br, wr);
                  break;
                case "zigzag_filter":
                  Nb(Br);
                  break;
                case "bitshuffle_filter":
                  Vb(Br, fr);
                  break;
                default:
                  throw new Uu(`Unhandled filter "${cr[Fr]}"`);
              }
            return { layerName: Ke, blockIndex: kr, data: Br };
          }).catch((Br) => {
            throw Br;
          });
        }));
      }, Ao(by, "MRTDecodingBatch", { omit: ["_onCancel", "_onComplete"] });
      let N1, Q_, kh, $0, e2, R0 = null;
      function xy() {
        return to() && self.worker && self.worker.dracoUrl ? self.worker.dracoUrl : Q_ || Pi.DRACO_URL;
      }
      function wy() {
        if (to() && self.worker && self.worker.meshoptUrl)
          return self.worker.meshoptUrl;
        if ($0)
          return $0;
        const Ie = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 3, 2, 0, 0, 5, 3, 1, 0, 1, 12, 1, 0, 10, 22, 2, 12, 0, 65, 0, 65, 0, 65, 0, 252, 10, 0, 0, 11, 7, 0, 65, 0, 253, 15, 26, 11]);
        if (typeof WebAssembly != "object")
          throw new Error("WebAssembly not supported, cannot instantiate meshoptimizer");
        return $0 = WebAssembly.validate(Ie) ? Pi.MESHOPT_SIMD_URL : Pi.MESHOPT_URL, $0;
      }
      const Ev = { 5120: Int8Array, 5121: Uint8Array, 5122: Int16Array, 5123: Uint16Array, 5125: Uint32Array, 5126: Float32Array }, tx = { 5120: "DT_INT8", 5121: "DT_UINT8", 5122: "DT_INT16", 5123: "DT_UINT16", 5125: "DT_UINT32", 5126: "DT_FLOAT32" }, V1 = { SCALAR: 1, VEC2: 2, VEC3: 3, VEC4: 4, MAT2: 4, MAT3: 9, MAT4: 16 };
      function My(Ie, de, Ce) {
        const De = Ce.json.bufferViews.length, Ke = Ce.buffers.length;
        de.bufferView = De, Ce.json.bufferViews[De] = { buffer: Ke, byteLength: Ie.byteLength }, Ce.buffers[Ke] = Ie;
      }
      const t2 = "KHR_draco_mesh_compression";
      function rx(Ie, de) {
        const Ce = Ie.extensions && Ie.extensions[t2];
        if (!Ce)
          return;
        const De = new kh.Decoder(), Ke = Ty(de, Ce.bufferView), Ve = new kh.Mesh();
        if (!De.DecodeArrayToMesh(Ke, Ke.byteLength, Ve))
          throw new Error("Failed to decode Draco mesh");
        const er = de.json.accessors[Ie.indices], fr = Ev[er.componentType], wr = er.count * fr.BYTES_PER_ELEMENT, kr = kh._malloc(wr);
        fr === Uint16Array ? De.GetTrianglesUInt16Array(Ve, wr, kr) : De.GetTrianglesUInt32Array(Ve, wr, kr), My(kh.memory.buffer.slice(kr, kr + wr), er, de), kh._free(kr);
        for (const cr of Object.keys(Ce.attributes)) {
          const Mr = De.GetAttributeByUniqueId(Ve, Ce.attributes[cr]), Er = de.json.accessors[Ie.attributes[cr]], xr = tx[Er.componentType], Sr = Er.count * V1[Er.type] * Ev[Er.componentType].BYTES_PER_ELEMENT, Br = kh._malloc(Sr);
          De.GetAttributeDataArrayForAllPoints(Ve, Mr, kh[xr], Sr, Br), My(kh.memory.buffer.slice(Br, Br + Sr), Er, de), kh._free(Br);
        }
        De.destroy(), Ve.destroy(), delete Ie.extensions[t2];
      }
      const Cv = "EXT_meshopt_compression";
      function ix(Ie, de) {
        if (!Ie.extensions || !Ie.extensions[Cv])
          return;
        const Ce = Ie.extensions[Cv], De = new Uint8Array(de.buffers[Ce.buffer], Ce.byteOffset || 0, Ce.byteLength || 0), Ke = new Uint8Array(Ce.count * Ce.byteStride);
        e2.decodeGltfBuffer(Ke, Ce.count, Ce.byteStride, De, Ce.mode, Ce.filter), Ie.buffer = de.buffers.length, Ie.byteOffset = 0, de.buffers[Ie.buffer] = Ke.buffer, delete Ie.extensions[Cv];
      }
      const Sy = 1179937895, Ey = new TextDecoder("utf8");
      function Cy(Ie, de) {
        return new URL(Ie, de).href;
      }
      function nx(Ie, de, Ce, De) {
        return fetch(Cy(Ie.uri, De)).then((Ke) => Ke.arrayBuffer()).then((Ke) => {
          de.buffers[Ce] = Ke;
        });
      }
      function Ty(Ie, de) {
        const Ce = Ie.json.bufferViews[de];
        return new Uint8Array(Ie.buffers[Ce.buffer], Ce.byteOffset || 0, Ce.byteLength);
      }
      function ox(Ie, de, Ce, De) {
        if (Ie.uri) {
          const Ke = Cy(Ie.uri, De);
          return fetch(Ke).then((Ve) => Ve.blob()).then((Ve) => createImageBitmap(Ve)).then((Ve) => {
            de.images[Ce] = Ve;
          });
        }
        if (Ie.bufferView !== void 0) {
          const Ke = Ty(de, Ie.bufferView), Ve = new Blob([Ke], { type: Ie.mimeType });
          return createImageBitmap(Ve).then((er) => {
            de.images[Ce] = er;
          });
        }
      }
      function Ay(Ie, de = 0, Ce) {
        const De = { json: null, images: [], buffers: [] };
        if (new Uint32Array(Ie, de, 1)[0] === Sy) {
          const cr = new Uint32Array(Ie, de);
          let Mr = 2;
          const Er = (cr[Mr++] >> 2) - 3, xr = cr[Mr++] >> 2;
          if (Mr++, De.json = JSON.parse(Ey.decode(cr.subarray(Mr, Mr + xr))), Mr += xr, Mr < Er) {
            const Sr = cr[Mr++];
            Mr++;
            const Br = de + (Mr << 2);
            De.buffers[0] = Ie.slice(Br, Br + Sr);
          }
        } else
          De.json = JSON.parse(Ey.decode(new Uint8Array(Ie, de)));
        const { buffers: Ke, images: Ve, meshes: er, extensionsUsed: fr, bufferViews: wr } = De.json;
        let kr = Promise.resolve();
        if (Ke) {
          const cr = [];
          for (let Mr = 0; Mr < Ke.length; Mr++) {
            const Er = Ke[Mr];
            Er.uri ? cr.push(nx(Er, De, Mr, Ce)) : De.buffers[Mr] || (De.buffers[Mr] = null);
          }
          kr = Promise.all(cr);
        }
        return kr.then(() => {
          const cr = [], Mr = fr && fr.includes(t2), Er = fr && fr.includes(Cv);
          if (Mr && cr.push(function() {
            if (!kh)
              return N1 ?? (N1 = function(xr) {
                let Sr, Br = null;
                function Fr() {
                  Sr = new Uint8Array(Br.buffer);
                }
                function jr() {
                  throw new Error("Unexpected Draco error.");
                }
                const Qr = { a: { a: jr, d: function(ti, Kr, ni) {
                  return Sr.copyWithin(ti, Kr, Kr + ni);
                }, c: function(ti) {
                  const Kr = Sr.length, ni = Math.max(ti >>> 0, Math.ceil(1.2 * Kr)), gi = Math.ceil((ni - Kr) / 65536);
                  try {
                    return Br.grow(gi), Fr(), !0;
                  } catch {
                    return !1;
                  }
                }, b: jr } };
                return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(xr, Qr) : xr.then((ti) => ti.arrayBuffer()).then((ti) => WebAssembly.instantiate(ti, Qr))).then((ti) => {
                  const { Rb: Kr, Qb: ni, P: gi, T: Si, X: Di, Ja: Ri, La: Bi, Qa: Ji, Va: Fi, Wa: tn, eb: cn, jb: ln, f: mn, e: wn, yb: Cn, zb: gn, Ab: Nn, Bb: oo, Db: Un, Gb: fo } = ti.instance.exports;
                  Br = wn;
                  const ho = (() => {
                    let bo = 0, Jn = 0, Ro = 0, po = 0;
                    return (Lo) => {
                      Ro && (Kr(po), Kr(bo), Jn += Ro, Ro = bo = 0), bo || (Jn += 128, bo = ni(Jn));
                      const jo = Lo.length + 7 & -8;
                      let oa = bo;
                      jo >= Jn && (Ro = jo, oa = po = ni(jo));
                      for (let ua = 0; ua < Lo.length; ua++)
                        Sr[oa + ua] = Lo[ua];
                      return oa;
                    };
                  })();
                  return Fr(), mn(), { memory: wn, _free: Kr, _malloc: ni, Mesh: class {
                    constructor() {
                      this.ptr = gi();
                    }
                    destroy() {
                      Si(this.ptr);
                    }
                  }, Decoder: class {
                    constructor() {
                      this.ptr = Ri();
                    }
                    destroy() {
                      ln(this.ptr);
                    }
                    DecodeArrayToMesh(bo, Jn, Ro) {
                      const po = ho(bo), Lo = Bi(this.ptr, po, Jn, Ro.ptr);
                      return !!Di(Lo);
                    }
                    GetAttributeByUniqueId(bo, Jn) {
                      return { ptr: Ji(this.ptr, bo.ptr, Jn) };
                    }
                    GetTrianglesUInt16Array(bo, Jn, Ro) {
                      Fi(this.ptr, bo.ptr, Jn, Ro);
                    }
                    GetTrianglesUInt32Array(bo, Jn, Ro) {
                      tn(this.ptr, bo.ptr, Jn, Ro);
                    }
                    GetAttributeDataArrayForAllPoints(bo, Jn, Ro, po, Lo) {
                      cn(this.ptr, bo.ptr, Jn.ptr, Ro, po, Lo);
                    }
                  }, DT_INT8: Cn(), DT_UINT8: gn(), DT_INT16: Nn(), DT_UINT16: oo(), DT_UINT32: Un(), DT_FLOAT32: fo() };
                });
              }(fetch(xy())), N1.then((xr) => {
                kh = xr, N1 = void 0;
              }));
          }()), Er && cr.push(function() {
            if (e2)
              return;
            const xr = function(Sr) {
              let Br;
              const Fr = WebAssembly.instantiateStreaming(Sr, {}).then((ti) => {
                Br = ti.instance, Br.exports.__wasm_call_ctors();
              }), jr = { NONE: "", OCTAHEDRAL: "meshopt_decodeFilterOct", QUATERNION: "meshopt_decodeFilterQuat", EXPONENTIAL: "meshopt_decodeFilterExp" }, Qr = { ATTRIBUTES: "meshopt_decodeVertexBuffer", TRIANGLES: "meshopt_decodeIndexBuffer", INDICES: "meshopt_decodeIndexSequence" };
              return { ready: Fr, supported: !0, decodeGltfBuffer(ti, Kr, ni, gi, Si, Di) {
                (function(Ri, Bi, Ji, Fi, tn, cn, ln) {
                  const mn = Ri.exports.sbrk, wn = Fi + 3 & -4, Cn = mn(wn * tn), gn = mn(cn.length), Nn = new Uint8Array(Ri.exports.memory.buffer);
                  Nn.set(cn, gn);
                  const oo = Bi(Cn, Fi, tn, gn, cn.length);
                  if (oo === 0 && ln && ln(Cn, wn, tn), Ji.set(Nn.subarray(Cn, Cn + Fi * tn)), mn(Cn - mn(0)), oo !== 0)
                    throw new Error(`Malformed buffer data: ${oo}`);
                })(Br, Br.exports[Qr[Si]], ti, Kr, ni, gi, Br.exports[jr[Di]]);
              } };
            }(fetch(wy()));
            return xr.ready.then(() => {
              e2 = xr;
            });
          }()), Ve)
            for (let xr = 0; xr < Ve.length; xr++)
              cr.push(ox(Ve[xr], De, xr, Ce));
          return (cr.length ? Promise.all(cr) : Promise.resolve()).then(() => {
            if (Mr && er)
              for (const { primitives: xr } of er)
                for (const Sr of xr)
                  rx(Sr, De);
            if (Er && er && wr)
              for (const xr of wr)
                ix(xr, De);
            return De;
          });
        });
      }
      function km(Ie, de) {
        const Ce = Ie.json.bufferViews[de.bufferView], De = Ev[de.componentType];
        return new De(Ie.buffers[Ce.buffer], (de.byteOffset || 0) + (Ce.byteOffset || 0), de.count * (Ce.byteStride && Ce.byteStride !== V1[de.type] * De.BYTES_PER_ELEMENT ? Ce.byteStride / De.BYTES_PER_ELEMENT : V1[de.type]));
      }
      function r2(Ie, de, Ce, De) {
        const Ke = Ev[de.componentType], Ve = function(cr) {
          switch (cr) {
            case Int8Array:
              return 1 / 127;
            case Uint8Array:
              return 1 / 255;
            case Int16Array:
              return 1 / 32767;
            case Uint16Array:
              return 1 / 65535;
            default:
              return 1;
          }
        }(Ke), er = Ie.json.bufferViews[de.bufferView], fr = er.byteStride ? er.byteStride / Ke.BYTES_PER_ELEMENT : V1[de.type], wr = Ce.float32, kr = wr.length / Ce.capacity;
        for (let cr = 0, Mr = 0; cr < de.count * fr; cr += fr, Mr += kr)
          for (let Er = 0; Er < kr; Er++)
            wr[Mr + Er] = De[cr + Er] * Ve;
        Ce._trim();
      }
      function ax(Ie, de, Ce) {
        const De = Ie.indices, Ke = Ie.attributes, Ve = {};
        Ve.indexArray = new tl();
        const er = de.json.accessors[De], fr = er.count / 3;
        Ve.indexArray.reserve(fr);
        const wr = km(de, er);
        for (let Er = 0; Er < fr; Er++)
          Ve.indexArray.emplaceBack(wr[3 * Er], wr[3 * Er + 1], wr[3 * Er + 2]);
        Ve.indexArray._trim(), Ve.vertexArray = new Xc();
        const kr = de.json.accessors[Ke.POSITION];
        Ve.vertexArray.reserve(kr.count);
        const cr = km(de, kr);
        for (let Er = 0; Er < kr.count; Er++)
          Ve.vertexArray.emplaceBack(cr[3 * Er], cr[3 * Er + 1], cr[3 * Er + 2]);
        if (Ve.vertexArray._trim(), Ve.aabb = new qo(kr.min, kr.max), Ve.centroid = function(Er, xr) {
          const Sr = [0, 0, 0], Br = Er.length;
          if (Br > 0) {
            for (let Fr = 0; Fr < Br; Fr++) {
              const jr = 3 * Er[Fr];
              Sr[0] += xr[jr], Sr[1] += xr[jr + 1], Sr[2] += xr[jr + 2];
            }
            Sr[0] /= Br, Sr[1] /= Br, Sr[2] /= Br;
          }
          return Sr;
        }(wr, cr), Ke.COLOR_0 !== void 0) {
          const Er = de.json.accessors[Ke.COLOR_0], xr = V1[Er.type], Sr = km(de, Er);
          Ve.colorArray = xr === 3 ? new Xc() : new cu(), Ve.colorArray.resize(Er.count), r2(de, Er, Ve.colorArray, Sr);
        }
        if (Ke.NORMAL !== void 0) {
          Ve.normalArray = new Xc();
          const Er = de.json.accessors[Ke.NORMAL];
          Ve.normalArray.resize(Er.count);
          const xr = km(de, Er);
          r2(de, Er, Ve.normalArray, xr);
        }
        if (Ke.TEXCOORD_0 !== void 0 && Ce.length > 0) {
          Ve.texcoordArray = new Lc();
          const Er = de.json.accessors[Ke.TEXCOORD_0];
          Ve.texcoordArray.resize(Er.count);
          const xr = km(de, Er);
          r2(de, Er, Ve.texcoordArray, xr);
        }
        if (Ke._FEATURE_ID_RGBA4444 !== void 0) {
          const Er = de.json.accessors[Ke._FEATURE_ID_RGBA4444];
          de.json.extensionsUsed && de.json.extensionsUsed.includes("EXT_meshopt_compression") && (Ve.featureData = km(de, Er));
        }
        Ke._FEATURE_RGBA4444 !== void 0 && (Ve.featureData = new Uint32Array(km(de, de.json.accessors[Ke._FEATURE_RGBA4444]).buffer));
        const Mr = Ie.material;
        return Ve.material = function(Er, xr) {
          const { emissiveFactor: Sr = [0, 0, 0], alphaMode: Br = "OPAQUE", alphaCutoff: Fr = 0.5, normalTexture: jr, occlusionTexture: Qr, emissiveTexture: ti, doubleSided: Kr } = Er, { baseColorFactor: ni = [1, 1, 1, 1], metallicFactor: gi = 1, roughnessFactor: Si = 1, baseColorTexture: Di, metallicRoughnessTexture: Ri } = Er.pbrMetallicRoughness || {}, Bi = Qr ? xr[Qr.index] : void 0;
          if (Qr && Qr.extensions && Qr.extensions.KHR_texture_transform && Bi) {
            const Ji = Qr.extensions.KHR_texture_transform;
            Bi.offsetScale = [Ji.offset[0], Ji.offset[1], Ji.scale[0], Ji.scale[1]];
          }
          return { pbrMetallicRoughness: { baseColorFactor: new Ca(...ni), metallicFactor: gi, roughnessFactor: Si, baseColorTexture: Di ? xr[Di.index] : void 0, metallicRoughnessTexture: Ri ? xr[Ri.index] : void 0 }, doubleSided: Kr, emissiveFactor: Sr, alphaMode: Br, alphaCutoff: Fr, normalTexture: jr ? xr[jr.index] : void 0, occlusionTexture: Bi, emissionTexture: ti ? xr[ti.index] : void 0, defined: Er.defined === void 0 };
        }(Mr !== void 0 ? de.json.materials[Mr] : { defined: !1 }, Ce), Ve;
      }
      function ky(Ie, de, Ce) {
        const { matrix: De, rotation: Ke, translation: Ve, scale: er, mesh: fr, extras: wr, children: kr } = Ie, cr = {};
        if (cr.matrix = De || Zr.mat4.fromRotationTranslationScale([], Ke || [0, 0, 0, 1], Ve || [0, 0, 0], er || [1, 1, 1]), fr !== void 0) {
          cr.meshes = Ce[fr];
          const Mr = cr.anchor = [0, 0];
          for (const Er of cr.meshes) {
            const { min: xr, max: Sr } = Er.aabb;
            Mr[0] += xr[0] + Sr[0], Mr[1] += xr[1] + Sr[1];
          }
          Mr[0] = Math.floor(Mr[0] / cr.meshes.length / 2), Mr[1] = Math.floor(Mr[1] / cr.meshes.length / 2);
        }
        if (wr && (wr.id && (cr.id = wr.id), wr.lights && (cr.lights = function(Mr) {
          if (!Mr.length)
            return [];
          const Er = function(jr) {
            const Qr = atob(jr), ti = new Uint8Array(Qr.length);
            for (let Kr = 0; Kr < Qr.length; Kr++)
              ti[Kr] = Qr.codePointAt(Kr);
            return ti;
          }(Mr), xr = [], Sr = Er.length / 24, Br = new Uint16Array(Er.buffer), Fr = new Float32Array(Er.buffer);
          for (let jr = 0; jr < Sr; jr++) {
            const Qr = Br[2 * jr * 6] / 30, ti = Br[2 * jr * 6 + 1] / 30, Kr = Br[2 * jr * 6 + 10] / 100, ni = Fr[6 * jr + 1], gi = Fr[6 * jr + 2], Si = Fr[6 * jr + 3], Di = Fr[6 * jr + 4], Ri = Si - ni, Bi = Di - gi, Ji = Math.hypot(Ri, Bi);
            xr.push({ pos: [ni + 0.5 * Ri, gi + 0.5 * Bi, ti], normal: [Bi / Ji, -Ri / Ji, 0], width: Ji, height: Qr, depth: Kr, points: [ni, gi, Si, Di] });
          }
          return xr;
        }(wr.lights))), kr) {
          const Mr = [];
          for (const Er of kr)
            Mr.push(ky(de.json.nodes[Er], de, Ce));
          cr.children = Mr;
        }
        return cr;
      }
      function sx(Ie) {
        if (Ie.vertices.length === 0 || Ie.indices.length === 0)
          return null;
        const de = new fp(Ie.vertices, Ie.indices, 8, 256), [Ce, De] = [de.min.clone(), de.max.clone()];
        return { vertices: Ie.vertices, indices: Ie.indices, grid: de, min: Ce, max: De };
      }
      function lx(Ie) {
        if (!Ie.extras || !Ie.extras.ground)
          return null;
        const de = Ie.extras.ground;
        if (!de || !Array.isArray(de) || de.length === 0)
          return null;
        const Ce = de[0];
        if (!Ce || !Array.isArray(Ce) || Ce.length === 0)
          return null;
        const De = [];
        for (const er of Ce) {
          if (!Array.isArray(er) || er.length !== 2)
            continue;
          const fr = er[0], wr = er[1];
          typeof fr == "number" && typeof wr == "number" && De.push(new qi(fr, wr));
        }
        if (De.length < 3)
          return null;
        De.length > 1 && De[De.length - 1].equals(De[0]) && De.pop();
        let Ke = 0;
        for (let er = 0; er < De.length; er++) {
          const fr = De[er], wr = De[(er + 1) % De.length], kr = De[(er + 2) % De.length];
          Ke += (fr.x - wr.x) * (kr.y - wr.y) - (kr.x - wr.x) * (fr.y - wr.y);
        }
        Ke > 0 && De.reverse();
        const Ve = nm(De.flatMap((er) => [er.x, er.y]), []);
        return Ve.length === 0 ? null : { vertices: De, indices: Ve };
      }
      function cx(Ie, de) {
        const Ce = [], De = [];
        let Ke = 0;
        const Ve = [];
        for (const er of Ie) {
          Ke = Ce.length;
          const fr = er.vertexArray.float32, wr = er.indexArray.uint16;
          for (let kr = 0; kr < er.vertexArray.length; kr++)
            Ve[0] = fr[3 * kr + 0], Ve[1] = fr[3 * kr + 1], Ve[2] = fr[3 * kr + 2], Zr.vec3.transformMat4(Ve, Ve, de), Ce.push(new qi(Ve[0], Ve[1]));
          for (let kr = 0; kr < 3 * er.indexArray.length; kr++)
            De.push(wr[kr] + Ke);
        }
        if (De.length % 3 != 0)
          return null;
        for (let er = 0; er < De.length; er += 3) {
          const fr = Ce[De[er + 0]], wr = Ce[De[er + 1]], kr = Ce[De[er + 2]];
          (fr.x - wr.x) * (kr.y - wr.y) - (kr.x - wr.x) * (fr.y - wr.y) > 0 && ([De[er + 1], De[er + 2]] = [De[er + 2], De[er + 1]]);
        }
        return { vertices: Ce, indices: De };
      }
      function Ly(Ie) {
        const de = function(wr, kr) {
          const cr = [], Mr = WebGL2RenderingContext;
          if (wr.json.textures)
            for (const Er of wr.json.textures) {
              const xr = { magFilter: Mr.LINEAR, minFilter: Mr.NEAREST, wrapS: Mr.REPEAT, wrapT: Mr.REPEAT };
              Er.sampler !== void 0 && Object.assign(xr, wr.json.samplers[Er.sampler]), cr.push({ image: kr[Er.source], sampler: xr, uploaded: !1 });
            }
          return cr;
        }(Ie, Ie.images), Ce = function(wr, kr) {
          const cr = [];
          for (const Mr of wr.json.meshes) {
            const Er = [];
            for (const xr of Mr.primitives)
              Er.push(ax(xr, wr, kr));
            cr.push(Er);
          }
          return cr;
        }(Ie, de), { scenes: De, scene: Ke, nodes: Ve } = Ie.json, er = De ? De[Ke || 0].nodes : Ve, fr = [];
        for (const wr of er)
          fr.push(ky(Ve[wr], Ie, Ce));
        return function(wr, kr, cr) {
          const Mr = {}, Er = /* @__PURE__ */ new Set();
          for (let xr = 0; xr < wr.length; xr++) {
            const Sr = cr[kr[xr]];
            if (!Sr.extras)
              continue;
            const Br = Sr.extras["mapbox:footprint:version"], Fr = Sr.extras["mapbox:footprint:id"];
            (Br || Fr) && Er.add(xr), Br === "1.0.0" && Fr && (Mr[Fr] = xr);
          }
          for (let xr = 0; xr < wr.length; xr++) {
            if (Er.has(xr))
              continue;
            const Sr = wr[xr], Br = cr[kr[xr]];
            if (!Br.extras)
              continue;
            let Fr = null;
            Sr.id in Mr && (Fr = cx(wr[Mr[Sr.id]].meshes, Sr.matrix)), Fr || (Fr = lx(Br)), Fr && (Sr.footprint = sx(Fr));
          }
          if (Er.size > 0) {
            const xr = Array.from(Er.values()).sort((Sr, Br) => Sr - Br);
            for (let Sr = xr.length - 1; Sr >= 0; Sr--)
              wr.splice(xr[Sr], 1);
          }
        }(fr, er, Ie.json.nodes), fr;
      }
      function ux(Ie) {
        Ie.heightmap = new Float32Array(4096), Ie.heightmap.fill(-1);
        const de = Ie.vertexArray.float32, Ce = Ie.aabb.min[0] - 1, De = Ie.aabb.min[1] - 1, Ke = Cm / (Ie.aabb.max[0] - Ce + 2), Ve = Cm / (Ie.aabb.max[1] - De + 2);
        for (let er = 0; er < de.length; er += 3) {
          const fr = de[er + 2], wr = (de[er + 0] - Ce) * Ke | 0, kr = (de[er + 1] - De) * Ve | 0;
          fr > Ie.heightmap[kr * Cm + wr] && (Ie.heightmap[kr * Cm + wr] = fr);
        }
      }
      function hx(Ie, de) {
        const Ce = {};
        Ce.indexArray = new tl(), Ce.indexArray.reserve(4 * Ie.length), Ce.vertexArray = new Xc(), Ce.vertexArray.reserve(10 * Ie.length), Ce.colorArray = new cu(), Ce.vertexArray.reserve(10 * Ie.length);
        let De = 0;
        for (const er of Ie) {
          const fr = Math.min(10, Math.max(4, 1.3 * er.height)) * de, wr = [-er.normal[1], er.normal[0], 0], kr = Math.min(0.29, 0.1 * er.width / er.depth), cr = er.width - 2 * er.depth * de * (kr + 0.01), Mr = Zr.vec3.scaleAndAdd([], er.pos, wr, cr / 2), Er = Zr.vec3.scaleAndAdd([], er.pos, wr, -cr / 2), xr = [Mr[0], Mr[1], Mr[2] + er.height], Sr = [Er[0], Er[1], Er[2] + er.height], Br = Zr.vec3.scaleAndAdd([], er.normal, wr, kr);
          Zr.vec3.scale(Br, Br, fr);
          const Fr = Zr.vec3.scaleAndAdd([], er.normal, wr, -kr);
          Zr.vec3.scale(Fr, Fr, fr), Zr.vec3.add(Br, Mr, Br), Zr.vec3.add(Fr, Er, Fr), Mr[2] += 0.1, Er[2] += 0.1, Ce.vertexArray.emplaceBack(Br[0], Br[1], Br[2]), Ce.vertexArray.emplaceBack(Fr[0], Fr[1], Fr[2]), Ce.vertexArray.emplaceBack(Mr[0], Mr[1], Mr[2]), Ce.vertexArray.emplaceBack(Er[0], Er[1], Er[2]), Ce.vertexArray.emplaceBack(xr[0], xr[1], xr[2]), Ce.vertexArray.emplaceBack(Sr[0], Sr[1], Sr[2]), Ce.vertexArray.emplaceBack(Mr[0], Mr[1], Mr[2]), Ce.vertexArray.emplaceBack(Er[0], Er[1], Er[2]), Ce.vertexArray.emplaceBack(Br[0], Br[1], Br[2]), Ce.vertexArray.emplaceBack(Fr[0], Fr[1], Fr[2]);
          const jr = cr / fr / 2;
          Ce.colorArray.emplaceBack(-jr - kr, -1, jr, 0.8), Ce.colorArray.emplaceBack(jr + kr, -1, jr, 0.8), Ce.colorArray.emplaceBack(-jr, 0, jr, 1.3), Ce.colorArray.emplaceBack(jr, 0, jr, 1.3), Ce.colorArray.emplaceBack(jr + kr, -0.8, jr, 0.7), Ce.colorArray.emplaceBack(jr + kr, -0.8, jr, 0.7), Ce.colorArray.emplaceBack(0, 0, jr, 1.3), Ce.colorArray.emplaceBack(0, 0, jr, 1.3), Ce.colorArray.emplaceBack(jr + kr, -1.2, jr, 0.8), Ce.colorArray.emplaceBack(jr + kr, -1.2, jr, 0.8), Ce.indexArray.emplaceBack(6 + De, 4 + De, 8 + De), Ce.indexArray.emplaceBack(7 + De, 9 + De, 5 + De), Ce.indexArray.emplaceBack(0 + De, 1 + De, 2 + De), Ce.indexArray.emplaceBack(1 + De, 3 + De, 2 + De), De += 10;
        }
        const Ke = { defined: !0, emissiveFactor: [0, 0, 0] }, Ve = {};
        return Ve.baseColorFactor = Ca.white, Ke.pbrMetallicRoughness = Ve, Ce.material = Ke, Ce.aabb = new qo([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), Ce;
      }
      class Iy {
        constructor(de) {
          this._stringToNumber = {}, this._numberToString = [];
          for (let Ce = 0; Ce < de.length; Ce++) {
            const De = de[Ce];
            this._stringToNumber[De] = Ce, this._numberToString[Ce] = De;
          }
        }
        encode(de) {
          return this._stringToNumber[de];
        }
        decode(de) {
          return this._numberToString[de];
        }
      }
      const dx = ["id", "tile", "layer", "source", "sourceLayer", "state"];
      class P0 {
        constructor(de, Ce, De, Ke, Ve) {
          this.type = "Feature", this._vectorTileFeature = de, this._z = Ce, this._x = De, this._y = Ke, this.properties = de.properties, this.id = Ve;
        }
        clone() {
          const de = new P0(this._vectorTileFeature, this._z, this._x, this._y, this.id);
          return this.state && (de.state = { ...this.state }), this.layer && (de.layer = { ...this.layer }), this.source && (de.source = this.source), this.sourceLayer && (de.sourceLayer = this.sourceLayer), de;
        }
        get geometry() {
          return this._geometry === void 0 && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
        }
        set geometry(de) {
          this._geometry = de;
        }
        toJSON() {
          const de = { type: "Feature", state: void 0, geometry: this.geometry, properties: this.properties };
          for (const Ce of dx)
            this[Ce] !== void 0 && (de[Ce] = this[Ce]);
          return de;
        }
      }
      class By {
        constructor(de, Ce) {
          this.tileID = de, this.x = de.canonical.x, this.y = de.canonical.y, this.z = de.canonical.z, this.grid = new ah(vo, 16, 0), this.featureIndexArray = new Kp(), this.promoteId = Ce, this.is3DTile = !1, this.serializedLayersCache = /* @__PURE__ */ new Map();
        }
        insert(de, Ce, De, Ke, Ve, er = 0, fr = 0) {
          const wr = this.featureIndexArray.length;
          this.featureIndexArray.emplaceBack(De, Ke, Ve, er);
          const kr = this.grid;
          for (let cr = 0; cr < Ce.length; cr++) {
            const Mr = Ce[cr], Er = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
            for (let xr = 0; xr < Mr.length; xr++) {
              const Sr = Mr[xr];
              Er[0] = Math.min(Er[0], Sr.x), Er[1] = Math.min(Er[1], Sr.y), Er[2] = Math.max(Er[2], Sr.x), Er[3] = Math.max(Er[3], Sr.y);
            }
            fr !== 0 && (Er[0] -= fr, Er[1] -= fr, Er[2] += fr, Er[3] += fr), Er[0] < vo && Er[1] < vo && Er[2] >= 0 && Er[3] >= 0 && kr.insert(wr, Er[0], Er[1], Er[2], Er[3]);
          }
        }
        loadVTLayers() {
          if (!this.vtLayers) {
            this.vtLayers = new $a.VectorTile(new g0(this.rawTileData)).layers, this.sourceLayerCoder = new Iy(this.vtLayers ? Object.keys(this.vtLayers).sort() : ["_geojsonTileLayer"]), this.vtFeatures = {};
            for (const de in this.vtLayers)
              this.vtFeatures[de] = [];
          }
          return this.vtLayers;
        }
        query(de, Ce) {
          const { tilespaceGeometry: De, transform: Ke, tileTransform: Ve, pixelPosMatrix: er, availableImages: fr } = Ce;
          this.loadVTLayers(), this.serializedLayersCache.clear();
          const wr = De.bufferedTilespaceBounds, kr = this.grid.query(wr.min.x, wr.min.y, wr.max.x, wr.max.y, (xr, Sr, Br, Fr) => Pn(De.bufferedTilespaceGeometry, xr, Sr, Br, Fr));
          kr.sort(fx);
          let cr = null;
          Ke.elevation && kr.length > 0 && (cr = A0.create(Ke.elevation, this.tileID));
          const Mr = {};
          let Er;
          for (let xr = 0; xr < kr.length; xr++) {
            const Sr = kr[xr];
            if (Sr === Er)
              continue;
            Er = Sr;
            const Br = this.featureIndexArray.get(Sr);
            let Fr = null;
            this.is3DTile ? this.loadMatchingModelFeature(Mr, Br, de, De, Ke) : this.loadMatchingFeature(Mr, Br, de, fr, (jr, Qr, ti, Kr = 0) => (Fr || (Fr = qr(jr, this.tileID.canonical, Ve)), Qr.queryIntersectsFeature(De, jr, ti, Fr, this.z, Ke, er, cr, Kr)));
          }
          return Mr;
        }
        loadMatchingFeature(de, Ce, De, Ke, Ve) {
          const { featureIndex: er, bucketIndex: fr, sourceLayerIndex: wr, layoutVertexArrayOffset: kr } = Ce, cr = this.bucketLayerIDs[fr], Mr = De.layers, Er = Object.keys(Mr);
          if (Er.length && !function(jr, Qr) {
            for (let ti = 0; ti < jr.length; ti++)
              if (Qr.indexOf(jr[ti]) >= 0)
                return !0;
            return !1;
          }(Er, cr))
            return;
          const xr = De.sourceCache, Sr = this.sourceLayerCoder.decode(wr), Br = this.vtLayers[Sr].feature(er), Fr = this.getId(Br, Sr);
          for (let jr = 0; jr < cr.length; jr++) {
            const Qr = cr[jr];
            if (!Mr[Qr])
              continue;
            const { styleLayer: ti, targets: Kr } = Mr[Qr];
            let ni = {};
            Fr !== void 0 && (ni = xr.getFeatureState(ti.sourceLayer, Fr));
            const gi = !Ve || Ve(Br, ti, ni, kr);
            if (!gi)
              continue;
            const Si = new P0(Br, this.z, this.x, this.y, Fr);
            Si.tile = this.tileID.canonical, Si.state = ni;
            let Di = this.serializedLayersCache.get(Qr);
            Di || (Di = ti.serialize(), Di.id = Qr, this.serializedLayersCache.set(Qr, Di)), Si.source = Di.source, Si.sourceLayer = Di["source-layer"], Si.layer = Yn({}, Di), Si.layer.paint = $y(Di.paint, ti.paint, Br, ni, Ke), Si.layer.layout = $y(Di.layout, ti.layout, Br, ni, Ke);
            let Ri = !1;
            for (const Bi of Kr) {
              this.updateFeatureProperties(Si, Bi);
              const { filter: Ji } = Bi;
              if (Ji) {
                if (Br.properties = Si.properties, Ji.needGeometry) {
                  const Fi = Jr(Br, !0);
                  if (!Ji.filter(new wa(this.tileID.overscaledZ), Fi, this.tileID.canonical))
                    continue;
                } else if (!Ji.filter(new wa(this.tileID.overscaledZ), Br))
                  continue;
              }
              Ri = !0, Bi.targetId && this.addFeatureVariant(Si, Bi);
            }
            Ri && this.appendToResult(de, Qr, er, Si, gi);
          }
        }
        loadMatchingModelFeature(de, Ce, De, Ke, Ve) {
          const er = this.bucketLayerIDs[0][0], fr = De.layers;
          if (!fr[er])
            return;
          const { styleLayer: wr, targets: kr } = fr[er];
          if (wr.type !== "model")
            return;
          const cr = Ke.tile, Mr = Ce.featureIndex, Er = cr.getBucket(wr);
          if (!(Er && Er instanceof vv))
            return;
          const xr = function(Di, Ri, Bi, Ji) {
            const Fi = Di.getNodesInfo()[Ri];
            if (Fi.hiddenByReplacement || !Fi.node.meshes)
              return;
            let tn = Number.MAX_VALUE;
            const cn = Fi.node, ln = Bi.tile, mn = Ji.calculatePosMatrix(ln.tileID.toUnwrapped(), Ji.worldSize), wn = Fi.evaluatedScale;
            let Cn = 0;
            Ji.elevation && cn.elevation && (Cn = cn.elevation * Ji.elevation.exaggeration()), Zr.mat4.translate(mn, mn, [(cn.anchor ? cn.anchor[0] : 0) * (wn[0] - 1), (cn.anchor ? cn.anchor[1] : 0) * (wn[1] - 1), Cn]), Zr.mat4.scale(mn, mn, wn);
            const gn = Bi.queryGeometry, Nn = gn.isPointQuery() ? gn.screenBounds : gn.screenGeometry, oo = function(fo) {
              const ho = Zr.mat4.multiply([], mn, fo.matrix);
              Zr.mat4.multiply(ho, Ji.expandedFarZProjMatrix, ho);
              for (let bo = 0; bo < fo.meshes.length; ++bo) {
                const Jn = fo.meshes[bo];
                if (bo === fo.lightMeshIndex)
                  continue;
                const Ro = $2(Nn, Ji, ho, Jn.aabb);
                Ro != null && (tn = Math.min(Ro, tn));
              }
              if (fo.children)
                for (const bo of fo.children)
                  oo(bo);
            };
            if (oo(cn), tn === Number.MAX_VALUE)
              return;
            const Un = new Ba(0, 0);
            return G2(ln.tileID.canonical, Un, Fi.node.anchor[0], Fi.node.anchor[1]), { intersectionZ: tn, position: Un, feature: Fi.feature };
          }(Er, Mr, Ke, Ve);
          if (!xr)
            return;
          const { z: Sr, x: Br, y: Fr } = cr.tileID.canonical, { feature: jr, intersectionZ: Qr, position: ti } = xr;
          let Kr = {};
          jr.id !== void 0 && (Kr = De.sourceCache.getFeatureState(wr.sourceLayer, jr.id));
          const ni = new P0({}, Sr, Br, Fr, jr.id);
          ni.tile = this.tileID.canonical, ni.state = Kr, ni.properties = jr.properties, ni.geometry = { type: "Point", coordinates: [ti.lng, ti.lat] };
          let gi = this.serializedLayersCache.get(er);
          gi || (gi = wr.serialize(), gi.id = er, this.serializedLayersCache.set(er, gi)), ni.source = gi.source, ni.sourceLayer = gi["source-layer"], ni.layer = Yn({}, gi);
          let Si = !1;
          for (const Di of kr) {
            this.updateFeatureProperties(ni, Di);
            const { filter: Ri } = Di;
            if (Ri) {
              if (jr.properties = ni.properties, Ri.needGeometry) {
                if (!Ri.filter(new wa(this.tileID.overscaledZ), jr, this.tileID.canonical))
                  continue;
              } else if (!Ri.filter(new wa(this.tileID.overscaledZ), jr))
                continue;
            }
            Si = !0, Di.targetId && this.addFeatureVariant(ni, Di);
          }
          Si && this.appendToResult(de, er, Mr, ni, Qr);
        }
        updateFeatureProperties(de, Ce, De) {
          if (Ce.properties) {
            const Ke = {};
            for (const Ve in Ce.properties) {
              const er = Ce.properties[Ve].evaluate({ zoom: this.z }, de._vectorTileFeature, de.state, de.tile, De);
              er != null && (Ke[Ve] = er);
            }
            de.properties = Ke;
          }
        }
        addFeatureVariant(de, Ce, De) {
          const Ke = { target: Ce.target, namespace: Ce.namespace };
          Ce.properties && (Ke.properties = de.properties), de.variants = de.variants || {}, de.variants[Ce.targetId] = de.variants[Ce.targetId] || [], de.variants[Ce.targetId].push(Ke);
        }
        appendToResult(de, Ce, De, Ke, Ve) {
          let er = de[Ce];
          er === void 0 && (er = de[Ce] = []), er.push({ featureIndex: De, feature: Ke, intersectionZ: Ve });
        }
        lookupSymbolFeatures(de, Ce, De, Ke, Ve) {
          const er = {};
          this.loadVTLayers();
          for (const fr of de)
            this.loadMatchingFeature(er, { bucketIndex: Ce, sourceLayerIndex: De, featureIndex: fr, layoutVertexArrayOffset: 0 }, Ke, Ve);
          return er;
        }
        loadFeature(de) {
          const { featureIndex: Ce, sourceLayerIndex: De } = de;
          this.loadVTLayers();
          const Ke = this.sourceLayerCoder.decode(De), Ve = this.vtFeatures[Ke];
          if (Ve[Ce])
            return Ve[Ce];
          const er = this.vtLayers[Ke].feature(Ce);
          return Ve[Ce] = er, er;
        }
        hasLayer(de) {
          for (const Ce of this.bucketLayerIDs)
            for (const De of Ce)
              if (de === De)
                return !0;
          return !1;
        }
        getId(de, Ce) {
          let De = de.id;
          if (this.promoteId) {
            const Ke = typeof this.promoteId == "string" ? this.promoteId : this.promoteId[Ce];
            Ke != null && (De = de.properties[Ke]), typeof De == "boolean" && (De = Number(De));
          }
          return De;
        }
      }
      function $y(Ie, de, Ce, De, Ke) {
        return Yi(Ie, (Ve, er) => {
          const fr = de instanceof Zs ? de.get(er) : null;
          return fr && fr.evaluate ? fr.evaluate(Ce, De, Ke) : fr;
        });
      }
      function fx(Ie, de) {
        return de - Ie;
      }
      Ao(By, "FeatureIndex", { omit: ["rawTileData", "sourceLayerCoder"] });
      const Ry = [Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
      class i2 {
        static from(de) {
          if (!(de instanceof ArrayBuffer))
            throw new Error("Data must be an instance of ArrayBuffer.");
          const [Ce, De] = new Uint8Array(de, 0, 2);
          if (Ce !== 219)
            throw new Error("Data does not appear to be in a KDBush format.");
          const Ke = De >> 4;
          if (Ke !== 1)
            throw new Error(`Got v${Ke} data when expected v1.`);
          const Ve = Ry[15 & De];
          if (!Ve)
            throw new Error("Unrecognized array type.");
          const [er] = new Uint16Array(de, 2, 1), [fr] = new Uint32Array(de, 4, 1);
          return new i2(fr, er, Ve, de);
        }
        constructor(de, Ce = 64, De = Float64Array, Ke) {
          if (isNaN(de) || de < 0)
            throw new Error(`Unpexpected numItems value: ${de}.`);
          this.numItems = +de, this.nodeSize = Math.min(Math.max(+Ce, 2), 65535), this.ArrayType = De, this.IndexArrayType = de < 65536 ? Uint16Array : Uint32Array;
          const Ve = Ry.indexOf(this.ArrayType), er = 2 * de * this.ArrayType.BYTES_PER_ELEMENT, fr = de * this.IndexArrayType.BYTES_PER_ELEMENT, wr = (8 - fr % 8) % 8;
          if (Ve < 0)
            throw new Error(`Unexpected typed array class: ${De}.`);
          Ke && Ke instanceof ArrayBuffer ? (this.data = Ke, this.ids = new this.IndexArrayType(this.data, 8, de), this.coords = new this.ArrayType(this.data, 8 + fr + wr, 2 * de), this._pos = 2 * de, this._finished = !0) : (this.data = new ArrayBuffer(8 + er + fr + wr), this.ids = new this.IndexArrayType(this.data, 8, de), this.coords = new this.ArrayType(this.data, 8 + fr + wr, 2 * de), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([219, 16 + Ve]), new Uint16Array(this.data, 2, 1)[0] = Ce, new Uint32Array(this.data, 4, 1)[0] = de);
        }
        add(de, Ce) {
          const De = this._pos >> 1;
          return this.ids[De] = De, this.coords[this._pos++] = de, this.coords[this._pos++] = Ce, De;
        }
        finish() {
          const de = this._pos >> 1;
          if (de !== this.numItems)
            throw new Error(`Added ${de} items when expected ${this.numItems}.`);
          return n2(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
        }
        range(de, Ce, De, Ke) {
          if (!this._finished)
            throw new Error("Data not yet indexed - call index.finish().");
          const { ids: Ve, coords: er, nodeSize: fr } = this, wr = [0, Ve.length - 1, 0], kr = [];
          for (; wr.length; ) {
            const cr = wr.pop() || 0, Mr = wr.pop() || 0, Er = wr.pop() || 0;
            if (Mr - Er <= fr) {
              for (let Fr = Er; Fr <= Mr; Fr++) {
                const jr = er[2 * Fr], Qr = er[2 * Fr + 1];
                jr >= de && jr <= De && Qr >= Ce && Qr <= Ke && kr.push(Ve[Fr]);
              }
              continue;
            }
            const xr = Er + Mr >> 1, Sr = er[2 * xr], Br = er[2 * xr + 1];
            Sr >= de && Sr <= De && Br >= Ce && Br <= Ke && kr.push(Ve[xr]), (cr === 0 ? de <= Sr : Ce <= Br) && (wr.push(Er), wr.push(xr - 1), wr.push(1 - cr)), (cr === 0 ? De >= Sr : Ke >= Br) && (wr.push(xr + 1), wr.push(Mr), wr.push(1 - cr));
          }
          return kr;
        }
        within(de, Ce, De) {
          if (!this._finished)
            throw new Error("Data not yet indexed - call index.finish().");
          const { ids: Ke, coords: Ve, nodeSize: er } = this, fr = [0, Ke.length - 1, 0], wr = [], kr = De * De;
          for (; fr.length; ) {
            const cr = fr.pop() || 0, Mr = fr.pop() || 0, Er = fr.pop() || 0;
            if (Mr - Er <= er) {
              for (let Fr = Er; Fr <= Mr; Fr++)
                Dy(Ve[2 * Fr], Ve[2 * Fr + 1], de, Ce) <= kr && wr.push(Ke[Fr]);
              continue;
            }
            const xr = Er + Mr >> 1, Sr = Ve[2 * xr], Br = Ve[2 * xr + 1];
            Dy(Sr, Br, de, Ce) <= kr && wr.push(Ke[xr]), (cr === 0 ? de - De <= Sr : Ce - De <= Br) && (fr.push(Er), fr.push(xr - 1), fr.push(1 - cr)), (cr === 0 ? de + De >= Sr : Ce + De >= Br) && (fr.push(xr + 1), fr.push(Mr), fr.push(1 - cr));
          }
          return wr;
        }
      }
      function n2(Ie, de, Ce, De, Ke, Ve) {
        if (Ke - De <= Ce)
          return;
        const er = De + Ke >> 1;
        Py(Ie, de, er, De, Ke, Ve), n2(Ie, de, Ce, De, er - 1, 1 - Ve), n2(Ie, de, Ce, er + 1, Ke, 1 - Ve);
      }
      function Py(Ie, de, Ce, De, Ke, Ve) {
        for (; Ke > De; ) {
          if (Ke - De > 600) {
            const kr = Ke - De + 1, cr = Ce - De + 1, Mr = Math.log(kr), Er = 0.5 * Math.exp(2 * Mr / 3), xr = 0.5 * Math.sqrt(Mr * Er * (kr - Er) / kr) * (cr - kr / 2 < 0 ? -1 : 1);
            Py(Ie, de, Ce, Math.max(De, Math.floor(Ce - cr * Er / kr + xr)), Math.min(Ke, Math.floor(Ce + (kr - cr) * Er / kr + xr)), Ve);
          }
          const er = de[2 * Ce + Ve];
          let fr = De, wr = Ke;
          for (U1(Ie, de, De, Ce), de[2 * Ke + Ve] > er && U1(Ie, de, De, Ke); fr < wr; ) {
            for (U1(Ie, de, fr, wr), fr++, wr--; de[2 * fr + Ve] < er; )
              fr++;
            for (; de[2 * wr + Ve] > er; )
              wr--;
          }
          de[2 * De + Ve] === er ? U1(Ie, de, De, wr) : (wr++, U1(Ie, de, wr, Ke)), wr <= Ce && (De = wr + 1), Ce <= wr && (Ke = wr - 1);
        }
      }
      function U1(Ie, de, Ce, De) {
        o2(Ie, Ce, De), o2(de, 2 * Ce, 2 * De), o2(de, 2 * Ce + 1, 2 * De + 1);
      }
      function o2(Ie, de, Ce) {
        const De = Ie[de];
        Ie[de] = Ie[Ce], Ie[Ce] = De;
      }
      function Dy(Ie, de, Ce, De) {
        const Ke = Ie - Ce, Ve = de - De;
        return Ke * Ke + Ve * Ve;
      }
      ne.$ = Zf, ne.A = Ps, ne.B = 2, ne.C = b0, ne.D = k0, ne.E = Ih, ne.F = wm, ne.G = class extends mv {
      }, ne.H = al, ne.I = Z_, ne.J = Sf, ne.K = Wm, ne.L = Ff, ne.M = pc, ne.N = Vm, ne.O = Up, ne.P = qi, ne.Q = Iu, ne.R = Xa, ne.S = qm, ne.T = R_, ne.U = Fd, ne.V = mv, ne.W = Ju, ne.X = fc, ne.Y = rs, ne.Z = bl, ne._ = xd, ne.a = function(Ie) {
        return Pi.API_CDN_URL_REGEX.test(Ie);
      }, ne.a$ = P0, ne.a0 = Nf, ne.a1 = Nm, ne.a2 = function(Ie) {
        const de = Ie.value;
        let Ce = [];
        if (!de)
          return Ce;
        const De = al(de);
        return De !== "string" ? (Ce = Ce.concat([new mv(Ie.key, de, `string expected, "${De}" found`)]), Ce) : (P2(de, !0) || (Ce = Ce.concat([new mv(Ie.key, de, `invalid url "${de}"`)])), Ce);
      }, ne.a3 = Bn, ne.a4 = El, ne.a5 = ys, ne.a6 = lo, ne.a7 = class {
        constructor(Ie) {
          this.specification = Ie;
        }
        possiblyEvaluate(Ie, de) {
          return Io(Ie.expression.evaluate(de));
        }
        interpolate(Ie, de, Ce) {
          return { x: Ho(Ie.x, de.x, Ce), y: Ho(Ie.y, de.y, Ce), z: Ho(Ie.z, de.z, Ce), azimuthal: Ho(Ie.azimuthal, de.azimuthal, Ce), polar: Ho(Ie.polar, de.polar, Ce) };
        }
      }, ne.a8 = wa, ne.a9 = Wh, ne.aA = gu, ne.aB = class {
        constructor(Ie) {
          this.entries = {}, this.scheduler = Ie;
        }
        request(Ie, de, Ce, De) {
          const Ke = this.entries[Ie] = this.entries[Ie] || { callbacks: [] };
          if (Ke.result) {
            const [Ve, er] = Ke.result;
            return this.scheduler ? this.scheduler.add(() => {
              De(Ve, er);
            }, de) : De(Ve, er), () => {
            };
          }
          return Ke.callbacks.push(De), Ke.cancel || (Ke.cancel = Ce((Ve, er) => {
            Ke.result = [Ve, er];
            for (const fr of Ke.callbacks)
              this.scheduler ? this.scheduler.add(() => {
                fr(Ve, er);
              }, de) : fr(Ve, er);
            setTimeout(() => delete this.entries[Ie], 3e3);
          })), () => {
            Ke.result || (Ke.callbacks = Ke.callbacks.filter((Ve) => Ve !== De), Ke.callbacks.length || (Ke.cancel(), delete this.entries[Ie]));
          };
        }
      }, ne.aC = fl, ne.aD = function(Ie, de, Ce) {
        const De = JSON.stringify(Ie.request);
        return Ie.data && (this.deduped.entries[De] = { result: [null, Ie.data] }), this.deduped.request(De, { type: "parseTile", isSymbolTile: Ie.isSymbolTile, zoom: Ie.tileZoom }, (Ke) => {
          const Ve = wu(Ie.request, (er, fr, wr, kr) => {
            er ? Ke(er) : fr && Ke(null, { vectorTile: Ce ? void 0 : new $a.VectorTile(new g0(fr)), rawData: fr, cacheControl: wr, expires: kr });
          });
          return () => {
            Ve.cancel(), Ke();
          };
        }, de);
      }, ne.aE = function(Ie) {
        da++, da > Bo && (Ie.getActor().send("enforceCacheSizeLimit", $o), da = 0);
      }, ne.aF = function(Ie) {
        return Ie <= 1 ? 1 : Math.pow(2, Math.floor(Math.log(Ie) / Math.LN2));
      }, ne.aG = mo, ne.aH = w2, ne.aI = A2, ne.aJ = x2, ne.aK = function(Ie, de) {
        const Ce = document.createElement("video");
        Ce.muted = !0, Ce.onloadstart = function() {
          de(null, Ce);
        };
        for (let De = 0; De < Ie.length; De++) {
          const Ke = document.createElement("source");
          yf(Ie[De]) || (Ce.crossOrigin = "Anonymous"), Ke.src = Ie[De], Ce.appendChild(Ke);
        }
        return { cancel: () => {
        } };
      }, ne.aL = uv, ne.aM = function(Ie) {
        return fetch(Ie).then((de) => de.arrayBuffer()).then((de) => Ay(de, 0, Ie));
      }, ne.aN = Ly, ne.aO = class {
        constructor(Ie, de, Ce, De) {
          this.id = Ie, this.position = de != null ? new Ba(de[0], de[1]) : new Ba(0, 0), this.orientation = Ce ?? [0, 0, 0], this.nodes = De, this.uploaded = !1, this.aabb = new qo([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), this.matrix = [];
        }
        _applyTransformations(Ie, de) {
          if (Zr.mat4.multiply(Ie.matrix, de, Ie.matrix), Ie.meshes)
            for (const Ce of Ie.meshes) {
              const De = qo.applyTransformFast(Ce.aabb, Ie.matrix);
              this.aabb.encapsulate(De);
            }
          if (Ie.children)
            for (const Ce of Ie.children)
              this._applyTransformations(Ce, Ie.matrix);
        }
        computeBoundsAndApplyParent() {
          const Ie = Zr.mat4.identity([]);
          for (const de of this.nodes)
            this._applyTransformations(de, Ie);
        }
        computeModelMatrix(Ie, de, Ce, De, Ke, Ve, er = !1) {
          N2(this.matrix, this, Ie.transform, this.position, de, Ce, De, Ke, Ve, er);
        }
        upload(Ie) {
          if (!this.uploaded) {
            for (const de of this.nodes)
              F_(de, Ie);
            for (const de of this.nodes)
              gv(de);
            this.uploaded = !0;
          }
        }
        destroy() {
          for (const Ie of this.nodes)
            N_(Ie);
        }
      }, ne.aP = yi, ne.aQ = dr, ne.aR = bs, ne.aS = Fs, ne.aT = $u, ne.aU = tl, ne.aV = Ci, ne.aW = Xp, ne.aX = lv, ne.aY = function() {
        Il.isLoading() || Il.isLoaded() || Yh() !== "deferred" || Hm();
      }, ne.aZ = Zm, ne.a_ = Jr, ne.aa = ir, ne.ab = Zr, ne.ac = Vn, ne.ad = Zs, ne.ae = gl, ne.af = Ho, ne.ag = vo, ne.ah = Sp, ne.ai = rn, ne.aj = Ca, ne.ak = class {
        constructor(Ie) {
          this.specification = Ie;
        }
        possiblyEvaluate(Ie, de) {
          return function([Ce, De]) {
            const Ke = Io([1, Ce, De]);
            return { x: Ke.x, y: Ke.y, z: Ke.z };
          }(Ie.expression.evaluate(de));
        }
        interpolate(Ie, de, Ce) {
          return { x: Ho(Ie.x, de.x, Ce), y: Ho(Ie.y, de.y, Ce), z: Ho(Ie.z, de.z, Ce) };
        }
      }, ne.al = function(Ie, de, Ce = 0, De = !0) {
        const Ke = new qi(Ce, Ce), Ve = Ie.sub(Ke), er = de.add(Ke), fr = [Ve, new qi(er.x, Ve.y), er, new qi(Ve.x, er.y)];
        return De && fr.push(Ve.clone()), fr;
      }, ne.am = function(Ie, de) {
        const Ce = [];
        for (let De = 0; De < Ie.length; De++) {
          const Ke = Xo(De - 1, -1, Ie.length - 1), Ve = Xo(De + 1, -1, Ie.length - 1), er = Ie[De], fr = Ie[Ve], wr = Ie[Ke].sub(er).unit(), kr = fr.sub(er).unit(), cr = kr.angleWithSep(wr.x, wr.y), Mr = wr.add(kr).unit().mult(-1 * de / Math.sin(cr / 2));
          Ce.push(er.add(Mr));
        }
        return Ce;
      }, ne.an = Cr, ne.ao = Pn, ne.ap = function(Ie, de, Ce = 0) {
        return Zr.vec3.fromValues(((de.x - Ce) * Ie.scale - Ie.x) * vo, (de.y * Ie.scale - Ie.y) * vo, em(de.z, de.y));
      }, ne.aq = sa, ne.ar = sc, ne.as = function(Ie) {
        let de = 1 / 0, Ce = 1 / 0, De = -1 / 0, Ke = -1 / 0;
        for (const Ve of Ie)
          de = Math.min(de, Ve.x), Ce = Math.min(Ce, Ve.y), De = Math.max(De, Ve.x), Ke = Math.max(Ke, Ve.y);
        return { min: new qi(de, Ce), max: new qi(De, Ke) };
      }, ne.at = Fu, ne.au = dn, ne.av = yr, ne.aw = vn, ne.ax = il, ne.ay = function(Ie, de) {
        const Ce = {};
        for (let De = 0; De < de.length; De++) {
          const Ke = de[De];
          Ke in Ie && (Ce[Ke] = Ie[Ke]);
        }
        return Ce;
      }, ne.az = mu, ne.b = function(Ie) {
        return Pi.API_FONTS_REGEX.test(Ie);
      }, ne.b$ = fv, ne.b0 = no, ne.b1 = f1, ne.b2 = u0, ne.b3 = qr, ne.b4 = Zc, ne.b5 = ef, ne.b6 = ia, ne.b7 = fs, ne.b8 = nm, ne.b9 = I_, ne.bA = js, ne.bB = k1, ne.bC = tv, ne.bD = C1, ne.bE = i2, ne.bF = Xo, ne.bG = Qn, ne.bH = As, ne.bI = function(Ie, de, Ce) {
        Ie[4 * de + 0] = Ce[0], Ie[4 * de + 1] = Ce[1], Ie[4 * de + 2] = Ce[2], Ie[4 * de + 3] = Ce[3];
      }, ne.bJ = af, ne.bK = ic, ne.bL = of, ne.bM = Ss, ne.bN = Du, ne.bO = Ba, ne.bP = Ks, ne.bQ = yo, ne.bR = _a, ne.bS = L2, ne.bT = _o, ne.bU = is, ne.bV = function(Ie, de, Ce, De, Ke, Ve, er, fr, wr) {
        if (wr.name === "globe")
          return is(Ie, de, new _o(Ce, De, Ke), !1);
        const kr = dr({ z: Ce, x: De, y: Ke }, wr);
        return new qo([(Ve + kr.x / kr.scale) * de, de * (kr.y / kr.scale), er], [(Ve + kr.x2 / kr.scale) * de, de * (kr.y2 / kr.scale), fr]);
      }, ne.bW = function(Ie, de, Ce) {
        let De = 0;
        for (let Ke = 0; Ke < 2; ++Ke)
          Ie[Ke] > 0 && (De += (Ie[Ke] - 0) * (Ie[Ke] - 0)), de[Ke] < 0 && (De += (0 - de[Ke]) * (0 - de[Ke]));
        return De;
      }, ne.bX = Es, ne.bY = Ou, ne.bZ = function(Ie) {
        const de = Zr.mat4.identity(new Float64Array(16));
        Zr.mat4.multiply(de, Ie.pixelMatrix, Ie.globeMatrix);
        const Ce = [0, cl, 0], De = [0, _c, 0];
        return Zr.vec3.transformMat4(Ce, Ce, de), Zr.vec3.transformMat4(De, De, de), [Ce[0] > 0 && Ce[0] <= Ie.width && Ce[1] > 0 && Ce[1] <= Ie.height && !Rc(Ie, new Ba(Ie.center.lat, 90)), De[0] > 0 && De[0] <= Ie.width && De[1] > 0 && De[1] <= Ie.height && !Rc(Ie, new Ba(Ie.center.lat, -90))];
      }, ne.b_ = function(Ie, de) {
        const { scale: Ce } = Ie.tileTransform, De = Ce * vo / (Ie.tileSize * Math.pow(2, de.zoom - Ie.tileID.overscaledZ + Ie.tileID.canonical.z));
        return Zr.mat2.scale(new Float32Array(4), de.inverseAdjustmentMatrix, [De, De]);
      }, ne.ba = function(Ie, de) {
        const Ce = gl(de.zoom);
        if (Ce === 0)
          return Ns(Ie);
        const De = Za(Ie), Ke = Ma(De), Ve = Fu(De.getWest()) * de.worldSize, er = Fu(De.getEast()) * de.worldSize, fr = gu(De.getNorth()) * de.worldSize, wr = gu(De.getSouth()) * de.worldSize, kr = [Ve, fr, 0], cr = [er, fr, 0], Mr = [Ve, wr, 0], Er = [er, wr, 0], xr = Zr.mat4.invert([], de.globeMatrix);
        return Zr.vec3.transformMat4(kr, kr, xr), Zr.vec3.transformMat4(cr, cr, xr), Zr.vec3.transformMat4(Mr, Mr, xr), Zr.vec3.transformMat4(Er, Er, xr), Ke[0] = ks(Ke[0], Mr, Ce), Ke[1] = ks(Ke[1], Er, Ce), Ke[2] = ks(Ke[2], cr, Ce), Ke[3] = ks(Ke[3], kr, Ce), qo.fromPoints(Ke);
      }, ne.bb = ul, ne.bc = xs, ne.bd = ks, ne.be = rd, ne.bf = Jo, ne.bg = J_, ne.bh = g0, ne.bi = wu, ne.bj = function(Ie) {
        const de = [];
        for (const Ce in Ie)
          de.push(Ie[Ce]);
        return de;
      }, ne.bk = function(Ie, de) {
        const Ce = [];
        for (const De in Ie)
          De in de || Ce.push(De);
        return Ce;
      }, ne.bl = Xn, ne.bm = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"], ne.bn = yn, ne.bo = function(Ie, de) {
        const { x: Ce, y: De } = Ie.point, Ke = Jc(Ce, De, Ie.worldSize / Ie._pixelsPerMercatorPixel, 0, 0);
        return Zr.mat4.multiply(Ke, Ke, nc(Ns(de)));
      }, ne.bp = vf, ne.bq = Pc, ne.br = _m, ne.bs = function(Ie, de, Ce, De, Ke) {
        const Ve = 5 * de + 2;
        Ie.float32[Ve + 0] = Ce, Ie.float32[Ve + 1] = De, Ie.float32[Ve + 2] = Ke;
      }, ne.bt = sv, ne.bu = Kg, ne.bv = Ei, ne.bw = _l, ne.bx = gg, ne.by = R2, ne.bz = $s, ne.c = ki, ne.c$ = (Ie, de, Ce, De, Ke, Ve, er, fr) => {
        const wr = Ie.transform, kr = wr.pitch < 15 ? Ig(0.07, 0.7, vn((14 - wr.zoom) / 5, 0, 1)) : 0.07, cr = Ce.paint.get("line-trim-color-use-theme").constantOr("default") === "none";
        return { u_matrix: $g(Ie, de, Ce, De), u_texsize: de.imageAtlasTexture ? de.imageAtlasTexture.size : [0, 0], u_pixels_to_tile_units: wr.calculatePixelsToTileUnitsMatrix(de), u_device_pixel_ratio: Ke, u_width_scale: Ve, u_floor_width_scale: er, u_image: 0, u_tile_units_to_pixels: Bg(de, wr), u_units_to_pixels: [1 / wr.pixelsToGLUnits[0], 1 / wr.pixelsToGLUnits[1]], u_alpha_discard_threshold: 0, u_trim_offset: fr, u_trim_fade_range: Ce.paint.get("line-trim-fade-range"), u_trim_color: Ce.paint.get("line-trim-color").toRenderColor(cr ? null : Ce.lut).toArray01(), u_emissive_strength: Ce.paint.get("line-emissive-strength"), u_zbias_factor: kr, u_tile_to_meter: He(de.tileID.canonical, 0) };
      }, ne.c0 = k2, ne.c1 = function(Ie) {
        const de = k2(Ie, !0);
        return Zr.mat2.invert([], [de[0], de[1], de[4], de[5]]);
      }, ne.c2 = ss, ne.c3 = function(Ie) {
        const { x: de, y: Ce } = Ie.point, { lng: De, lat: Ke } = Ie._center;
        return Jc(de, Ce, Ie.worldSize, De, Ke);
      }, ne.c4 = ji, ne.c5 = Eo, ne.c6 = ud, ne.c7 = function(Ie) {
        const de = Math.round((Ie + 45 + 360) % 360 / 90) % 4;
        return Kn[de];
      }, ne.c8 = 45, ne.c9 = uf, ne.cA = class extends $c {
        constructor(Ie) {
          super(Ie), this.current = t0;
        }
        set(Ie, de, Ce) {
          if (this.fetchUniformLocation(Ie, de)) {
            for (let De = 0; De < 9; De++)
              if (Ce[De] !== this.current[De]) {
                this.current = Ce, this.gl.uniformMatrix3fv(this.location, !1, Ce);
                break;
              }
          }
        }
      }, ne.cB = In, ne.cC = function(Ie, de, Ce) {
        const De = gl(Ce.zoom), Ke = Ie.style.map._antialias, Ve = de.options.extStandardDerivativesForceOff || Ie.terrain && Ie.terrain.exaggeration() > 0;
        return De === 0 && !Ke && !Ve;
      }, ne.cD = function(Ie) {
        const de = Ie.pixelsPerMeter, Ce = de / As(1, Ie.center.lat), De = Zr.mat4.identity(new Float64Array(16));
        return Zr.mat4.translate(De, De, [Ie.point.x, Ie.point.y, 0]), Zr.mat4.scale(De, De, [Ce, Ce, de]), Float32Array.from(De);
      }, ne.cE = Za, ne.cF = function(Ie) {
        const de = Es - 5;
        Ie = vn(Ie, -de, de) / de * 90;
        const Ce = Math.pow(Math.abs(Math.sin(rn(Ie))), 3);
        return Math.round(Ce * (cf.length - 1));
      }, ne.cG = function(Ie, de, Ce, De) {
        const Ke = de.getNorth(), Ve = de.getSouth(), er = de.getWest(), fr = de.getEast(), wr = 1 << Ie.z, kr = fr - er, cr = Ke - Ve, Mr = kr / Yc, Er = -cr / cf[Ce], xr = [0, Mr, 0, Er, 0, 0, Ke, er, 0];
        if (Ie.z > 0) {
          const Sr = 180 / De;
          Zr.mat3.multiply(xr, xr, [Sr / kr + 1, 0, 0, 0, Sr / cr + 1, 0, -0.5 * Sr / Mr, 0.5 * Sr / Er, 1]);
        }
        return xr[2] = wr, xr[5] = Ie.x, xr[8] = Ie.y, xr;
      }, ne.cH = Ns, ne.cI = function(Ie, de, Ce) {
        const De = Zr.mat4.identity(new Float64Array(16)), Ke = (de / (1 << Ie) - 0.5) * Math.PI * 2;
        return Zr.mat4.rotateY(De, Ce.globeMatrix, Ke), Float32Array.from(De);
      }, ne.cJ = class {
        isDataAvailableAtPoint(Ie) {
          const de = this._source();
          if (this.isUsingMockSource() || !de || Ie.y < 0 || Ie.y > 1)
            return !1;
          const Ce = de.getSource().maxzoom, De = 1 << Ce, Ke = Math.floor(Ie.x), Ve = Math.floor((Ie.x - Ke) * De), er = Math.floor(Ie.y * De), fr = this.findDEMTileFor(new mo(Ce, Ke, Ce, Ve, er));
          return !(!fr || !fr.dem);
        }
        getAtPointOrZero(Ie, de = 0) {
          return this.getAtPoint(Ie, de) || 0;
        }
        getAtPoint(Ie, de, Ce = !0) {
          if (this.isUsingMockSource())
            return null;
          de == null && (de = null);
          const De = this._source();
          if (!De || Ie.y < 0 || Ie.y > 1)
            return de;
          const Ke = De.getSource().maxzoom, Ve = 1 << Ke, er = Math.floor(Ie.x), fr = Ie.x - er, wr = new mo(Ke, er, Ke, Math.floor(fr * Ve), Math.floor(Ie.y * Ve)), kr = this.findDEMTileFor(wr);
          if (!kr || !kr.dem)
            return de;
          const cr = kr.dem, Mr = 1 << kr.tileID.canonical.z, Er = (fr * Mr - kr.tileID.canonical.x) * cr.dim, xr = (Ie.y * Mr - kr.tileID.canonical.y) * cr.dim, Sr = Math.floor(Er), Br = Math.floor(xr);
          return (Ce ? this.exaggeration() : 1) * Ho(Ho(cr.get(Sr, Br), cr.get(Sr, Br + 1), xr - Br), Ho(cr.get(Sr + 1, Br), cr.get(Sr + 1, Br + 1), xr - Br), Er - Sr);
        }
        getAtTileOffset(Ie, de, Ce) {
          const De = 1 << Ie.canonical.z;
          return this.getAtPointOrZero(new ir(Ie.wrap + (Ie.canonical.x + de / vo) / De, (Ie.canonical.y + Ce / vo) / De));
        }
        getAtTileOffsetFunc(Ie, de, Ce, De) {
          return (Ke) => {
            const Ve = this.getAtTileOffset(Ie, Ke.x, Ke.y), er = De.upVector(Ie.canonical, Ke.x, Ke.y), fr = De.upVectorScale(Ie.canonical, de, Ce).metersToTile;
            return Zr.vec3.scale(er, er, Ve * fr), er;
          };
        }
        getForTilePoints(Ie, de, Ce, De) {
          if (this.isUsingMockSource())
            return !1;
          const Ke = A0.create(this, Ie, De);
          return !!Ke && (de.forEach((Ve) => {
            Ve[2] = this.exaggeration() * Ke.getElevationAt(Ve[0], Ve[1], Ce);
          }), !0);
        }
        getMinMaxForTile(Ie) {
          if (this.isUsingMockSource())
            return null;
          const de = this.findDEMTileFor(Ie);
          if (!de || !de.dem)
            return null;
          const Ce = de.dem.tree, De = de.tileID, Ke = 1 << Ie.canonical.z - De.canonical.z;
          let Ve = Ie.canonical.x / Ke - De.canonical.x, er = Ie.canonical.y / Ke - De.canonical.y, fr = 0;
          for (let wr = 0; wr < Ie.canonical.z - De.canonical.z && !Ce.leaves[fr]; wr++) {
            Ve *= 2, er *= 2;
            const kr = 2 * Math.floor(er) + Math.floor(Ve);
            fr = Ce.childOffsets[fr] + kr, Ve %= 1, er %= 1;
          }
          return { min: this.exaggeration() * Ce.minimums[fr], max: this.exaggeration() * Ce.maximums[fr] };
        }
        getMinElevationBelowMSL() {
          throw new Error("Pure virtual method called.");
        }
        raycast(Ie, de, Ce) {
          throw new Error("Pure virtual method called.");
        }
        pointCoordinate(Ie) {
          throw new Error("Pure virtual method called.");
        }
        _source() {
          throw new Error("Pure virtual method called.");
        }
        isUsingMockSource() {
          throw new Error("Pure virtual method called.");
        }
        exaggeration() {
          throw new Error("Pure virtual method called.");
        }
        findDEMTileFor(Ie) {
          throw new Error("Pure virtual method called.");
        }
        get visibleDemTiles() {
          throw new Error("Getter must be implemented in subclass.");
        }
        getMinMaxForVisibleTiles() {
          const Ie = this.visibleDemTiles;
          if (Ie.length === 0)
            return null;
          let de = !1, Ce = Number.MAX_VALUE, De = Number.MIN_VALUE;
          for (const Ke of Ie) {
            const Ve = this.getMinMaxForTile(Ke.tileID);
            Ve && (Ce = Math.min(Ce, Ve.min), De = Math.max(De, Ve.max), de = !0);
          }
          return de ? { min: Ce, max: De } : null;
        }
      }, ne.cK = J1, ne.cL = Aa, ne.cM = function(Ie, de) {
        return [Math.pow(Ie[0], 2.2) * de, Math.pow(Ie[1], 2.2) * de, Math.pow(Ie[2], 2.2) * de];
      }, ne.cN = vu, ne.cO = _i, ne.cP = ai, ne.cQ = 256, ne.cR = function(Ie, de) {
        const Ce = [0, 0, 0], De = ul(Ns(de.canonical));
        return Zr.vec3.transformMat4(Ce, Ce, De), Zr.vec3.transformMat4(Ce, Ce, Ie), Ce;
      }, ne.cS = (Ie) => ({ u_camera_to_center_distance: new Ss(Ie), u_extrude_scale: new sf(Ie), u_device_pixel_ratio: new Ss(Ie), u_matrix: new af(Ie), u_inv_rot_matrix: new af(Ie), u_merc_center: new ic(Ie), u_tile_id: new of(Ie), u_zoom_transition: new Ss(Ie), u_up_dir: new of(Ie), u_emissive_strength: new Ss(Ie) }), ne.cT = (Ie) => ({ u_matrix: new af(Ie), u_pixels_to_tile_units: new sf(Ie), u_device_pixel_ratio: new Ss(Ie), u_width_scale: new Ss(Ie), u_floor_width_scale: new Ss(Ie), u_units_to_pixels: new ic(Ie), u_dash_image: new Du(Ie), u_gradient_image: new Du(Ie), u_image_height: new Ss(Ie), u_texsize: new ic(Ie), u_tile_units_to_pixels: new Ss(Ie), u_alpha_discard_threshold: new Ss(Ie), u_trim_offset: new ic(Ie), u_trim_fade_range: new ic(Ie), u_trim_color: new _h(Ie), u_emissive_strength: new Ss(Ie), u_zbias_factor: new Ss(Ie), u_tile_to_meter: new Ss(Ie) }), ne.cU = (Ie) => ({ u_matrix: new af(Ie), u_texsize: new ic(Ie), u_pixels_to_tile_units: new sf(Ie), u_device_pixel_ratio: new Ss(Ie), u_width_scale: new Ss(Ie), u_floor_width_scale: new Ss(Ie), u_image: new Du(Ie), u_units_to_pixels: new ic(Ie), u_tile_units_to_pixels: new Ss(Ie), u_alpha_discard_threshold: new Ss(Ie), u_trim_offset: new ic(Ie), u_trim_fade_range: new ic(Ie), u_trim_color: new _h(Ie), u_emissive_strength: new Ss(Ie), u_zbias_factor: new Ss(Ie), u_tile_to_meter: new Ss(Ie) }), ne.cV = id, ne.cW = l_, ne.cX = c_, ne.cY = hp, ne.cZ = (Ie, de, Ce, De, Ke, Ve) => {
        const er = Ie.transform, fr = er.projection.name === "globe";
        let wr;
        if (Ve.paint.get("circle-pitch-alignment") === "map")
          if (fr) {
            const cr = vu(er.zoom, de.canonical) * er._pixelsPerMercatorPixel;
            wr = Float32Array.from([cr, 0, 0, cr]);
          } else
            wr = er.calculatePixelsToTileUnitsMatrix(Ce);
        else
          wr = new Float32Array([er.pixelsToGLUnits[0], 0, 0, er.pixelsToGLUnits[1]]);
        const kr = { u_camera_to_center_distance: Ie.transform.getCameraToCenterDistance(er.projection), u_matrix: Ie.translatePosMatrix(de.projMatrix, Ce, Ve.paint.get("circle-translate"), Ve.paint.get("circle-translate-anchor")), u_device_pixel_ratio: _n.devicePixelRatio, u_extrude_scale: wr, u_inv_rot_matrix: tm, u_merc_center: [0, 0], u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_up_dir: [0, 0, 0], u_emissive_strength: Ve.paint.get("circle-emissive-strength") };
        if (fr) {
          kr.u_inv_rot_matrix = De, kr.u_merc_center = Ke, kr.u_tile_id = [de.canonical.x, de.canonical.y, 1 << de.canonical.z], kr.u_zoom_transition = gl(er.zoom);
          const cr = Ke[0] * vo, Mr = Ke[1] * vo;
          kr.u_up_dir = er.projection.upVector(new _o(0, 0, 0), cr, Mr);
        }
        return kr;
      }, ne.c_ = m1, ne.ca = _h, ne.cb = function(Ie, de, Ce) {
        const De = Math.sqrt(Ie * Ie + de * de + Ce * Ce), Ke = De > 0 ? Math.acos(Ce / De) * $n : 0;
        let Ve = Ie !== 0 || de !== 0 ? Math.atan2(-de, -Ie) * $n + 90 : 0;
        return Ve < 0 && (Ve += 360), [De, Ve, Ke];
      }, ne.cc = He, ne.cd = qo, ne.ce = Io, ne.cf = function(Ie) {
        return [Math.pow(Ie[0], 1 / 2.2), Math.pow(Ie[1], 1 / 2.2), Math.pow(Ie[2], 1 / 2.2)];
      }, ne.cg = function(Ie, de) {
        return Ie.readFields(cb, { icons: [] }, de);
      }, ne.ch = function(Ie) {
        return Ie({ pluginStatus: kl, pluginURL: Ll }), Hf.on("pluginStateChange", Ie), Ie;
      }, ne.ci = _v, ne.cj = mp, ne.ck = T1, ne.cl = Fc, ne.cm = Wc, ne.cn = xo, ne.co = qu, ne.cp = un, ne.cq = function(Ie) {
        const de = Ie.indexOf(Hd);
        return de >= 0 ? Ie.slice(0, de) : Ie;
      }, ne.cr = function(Ie) {
        return Ie.indexOf(Hd) >= 0;
      }, ne.cs = function(Ie) {
        const de = Ie.indexOf(Hd);
        return de >= 0 ? Ie.slice(de + 1) : "";
      }, ne.ct = function(Ie) {
        const de = [], Ce = Ie.id;
        return Ce === void 0 && de.push({ message: `layers.${Ce}: missing required property "id"` }), Ie.render === void 0 && de.push({ message: `layers.${Ce}: missing required method "render"` }), Ie.renderingMode && Ie.renderingMode !== "2d" && Ie.renderingMode !== "3d" && de.push({ message: `layers.${Ce}: property "renderingMode" must be either "2d" or "3d"` }), de;
      }, ne.cu = function(Ie, de, Ce, De) {
        return Ie.type === "custom" ? new Xy(Ie, de) : new ab[Ie.type](Ie, de, Ce, De);
      }, ne.cv = zn, ne.cw = class extends P0 {
        constructor(Ie, de) {
          super(Ie._vectorTileFeature, Ie._z, Ie._x, Ie._y, Ie.id), Ie.state && (this.state = { ...Ie.state }), this.target = de.target, this.namespace = de.namespace, de.properties && (this.properties = de.properties), this.target && ("featuresetId" in this.target && !this.target.importId || "layerId" in this.target) && (this.source = Ie.source, this.sourceLayer = Ie.sourceLayer, this.layer = Ie.layer);
        }
        toJSON() {
          const Ie = super.toJSON();
          return Ie.target = this.target, Ie.namespace = this.namespace, Ie;
        }
      }, ne.cx = Hf, ne.cy = Pl, ne.cz = sd, ne.d = function(Ie) {
        return Pi.API_TILEJSON_REGEX.test(Ie);
      }, ne.d$ = Yi, ne.d0 = (Ie, de, Ce, De, Ke, Ve, er, fr, wr) => {
        const kr = Ie.transform, cr = kr.calculatePixelsToTileUnitsMatrix(de), Mr = Ce.paint.get("line-trim-color-use-theme").constantOr("default") === "none", Er = kr.pitch < 15 ? Ig(0.07, 0.7, vn((14 - kr.zoom) / 5, 0, 1)) : 0.07;
        return { u_matrix: $g(Ie, de, Ce, De), u_pixels_to_tile_units: cr, u_device_pixel_ratio: Ve, u_width_scale: er, u_floor_width_scale: fr, u_units_to_pixels: [1 / kr.pixelsToGLUnits[0], 1 / kr.pixelsToGLUnits[1]], u_dash_image: 0, u_gradient_image: 1, u_image_height: Ke, u_texsize: Rg(Ce) && de.lineAtlasTexture ? de.lineAtlasTexture.size : [0, 0], u_tile_units_to_pixels: Bg(de, Ie.transform), u_alpha_discard_threshold: 0, u_trim_offset: wr, u_trim_fade_range: Ce.paint.get("line-trim-fade-range"), u_trim_color: Ce.paint.get("line-trim-color").toRenderColor(Mr ? null : Ce.lut).toArray01(), u_emissive_strength: Ce.paint.get("line-emissive-strength"), u_zbias_factor: Er, u_tile_to_meter: He(de.tileID.canonical, 0) };
      }, ne.d1 = ri, ne.d2 = im, ne.d3 = Sg, ne.d4 = Ko, ne.d5 = mm, ne.d6 = Qc, ne.d7 = 450, ne.d8 = 7, ne.d9 = Zy, ne.dA = Po, ne.dB = ke, ne.dC = zu, ne.dD = function([Ie, de, Ce]) {
        const De = Math.hypot(Ie, de, Ce), Ke = Math.atan2(Ie, Ce), Ve = 0.5 * Math.PI - Math.acos(-de / De);
        return new Ba(ji(Ke), ji(Ve));
      }, ne.dE = D_, ne.dF = function(Ie) {
        const de = Ie.navigator ? Ie.navigator.userAgent : null;
        return !!function(Ce) {
          if (ma == null) {
            const De = Ce.navigator ? Ce.navigator.userAgent : null;
            ma = !!Ce.safari || !(!De || !(/\b(iPad|iPhone|iPod)\b/.test(De) || De.match("Safari") && !De.match("Chrome")));
          }
          return ma;
        }(Ie) && de && (de.match("Version/15.4") || de.match("Version/15.5") || de.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/));
      }, ne.dG = function(Ie, de) {
        $o = Ie, Bo = de;
      }, ne.dH = Rc, ne.dI = oc, ne.dJ = function(Ie) {
        const de = [0, 0, 0], Ce = Zr.mat4.identity(new Float64Array(16));
        return Zr.mat4.multiply(Ce, Ie.pixelMatrix, Ie.globeMatrix), Zr.vec3.transformMat4(de, de, Ce), new qi(de[0], de[1]);
      }, ne.dK = function(Ie, de, Ce = !1) {
        if (kl === Sl || kl === Ul || kl === qp)
          throw new Error("setRTLTextPlugin cannot be called multiple times.");
        Ll = _n.resolveURL(Ie), kl = Sl, jd = de, uh(), Ce || Hm();
      }, ne.dL = Yh, ne.dM = function() {
        _v().acquire(U_);
      }, ne.dN = function() {
        const Ie = R1;
        Ie && (Ie.isPreloaded() && Ie.numActive() === 1 ? (Ie.release(U_), R1 = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
      }, ne.dO = Am, ne.dP = function(Ie) {
        const de = Zo();
        if (!de)
          return;
        const Ce = de.delete(Co);
        Ie && Ce.catch(Ie).then(() => Ie());
      }, ne.dQ = $1, ne.dR = xy, ne.dS = function(Ie) {
        Q_ = _n.resolveURL(Ie), R0 || (R0 = new k0(_v(), new Ih())), R0.broadcast("setDracoUrl", Q_);
      }, ne.dT = wy, ne.dU = function(Ie) {
        $0 = _n.resolveURL(Ie), R0 || (R0 = new k0(_v(), new Ih())), R0.broadcast("setMeshoptUrl", $0);
      }, ne.dV = Ao, ne.dW = hd, ne.dX = eu, ne.dY = Iy, ne.dZ = By, ne.d_ = kg, ne.da = La, ne.db = rp, ne.dc = 256, ne.dd = nc, ne.de = Xc, ne.df = Kc, ne.dg = ep, ne.dh = function(Ie, de, Ce, De, Ke) {
        return vn((Ie - de) / (Ce - de) * (Ke - De) + De, De, Ke);
      }, ne.di = Gh, ne.dj = xe, ne.dk = class {
        constructor(Ie, de, Ce, De) {
          this.context = Ie, this.format = De, this.size = Ce, this.texture = Ie.gl.createTexture();
          const [Ke, Ve, er] = this.size, { gl: fr } = Ie;
          fr.bindTexture(fr.TEXTURE_3D, this.texture), Ie.pixelStoreUnpackFlipY.set(!1), Ie.pixelStoreUnpack.set(1), Ie.pixelStoreUnpackPremultiplyAlpha.set(!1), fr.texImage3D(fr.TEXTURE_3D, 0, this.format, Ke, Ve, er, 0, B_(this.format), $_(this.format), de.data);
        }
        bind(Ie, de) {
          const { context: Ce } = this, { gl: De } = Ce;
          De.bindTexture(De.TEXTURE_3D, this.texture), Ie !== this.minFilter && (De.texParameteri(De.TEXTURE_3D, De.TEXTURE_MAG_FILTER, Ie), De.texParameteri(De.TEXTURE_3D, De.TEXTURE_MIN_FILTER, Ie), this.minFilter = Ie), de !== this.wrapS && (De.texParameteri(De.TEXTURE_3D, De.TEXTURE_WRAP_S, de), De.texParameteri(De.TEXTURE_3D, De.TEXTURE_WRAP_T, de), this.wrapS = de);
        }
        destroy() {
          const { gl: Ie } = this.context;
          Ie.deleteTexture(this.texture), this.texture = null;
        }
      }, ne.dl = O_, ne.dm = [1, 1, 1], ne.dn = A0, ne.dp = T0, ne.dq = Ru, ne.dr = Lc, ne.ds = zs, ne.dt = tp, ne.du = nd, ne.dv = class {
        constructor() {
          this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [], this._globalClipBounds = { min: new qi(1 / 0, 1 / 0), max: new qi(-1 / 0, -1 / 0) };
        }
        clear() {
          this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
        }
        get updateTime() {
          return this._updateTime;
        }
        getReplacementRegionsForTile(Ie, de = !1) {
          const Ce = _g(new qi(0, 0), new qi(vo, vo), Ie), De = [];
          if (de && !n1(Ce, this._globalClipBounds))
            return De;
          for (const Ke of this._activeRegions) {
            if (Ke.hiddenByOverlap || !n1(Ce, Ke))
              continue;
            const Ve = Mh(Ke.min, Ke.max, Ie);
            De.push({ min: Ve.min, max: Ve.max, sourceId: this._sourceIds[Ke.priority], footprint: Ke.footprint, footprintTileId: Ke.tileId, order: Ke.order, clipMask: Ke.clipMask, clipScope: Ke.clipScope });
          }
          return De;
        }
        setSources(Ie) {
          this._setSources(Ie.map((de) => ({ getSourceId: () => de.cache.id, getFootprints: () => {
            const Ce = [];
            for (const De of de.cache.getVisibleCoordinates()) {
              const Ke = de.cache.getTile(De).buckets[de.layer];
              Ke && Ke.updateFootprints(De.toUnwrapped(), Ce);
            }
            return Ce;
          }, getOrder: () => de.order, getClipMask: () => de.clipMask, getClipScope: () => de.clipScope })));
        }
        _addSource(Ie) {
          const de = Ie.getFootprints();
          if (de.length === 0)
            return;
          const Ce = Ie.getOrder(), De = Ie.getClipMask(), Ke = Ie.getClipScope();
          for (const Ve of de) {
            if (!Ve.footprint)
              continue;
            const er = _g(Ve.footprint.min, Ve.footprint.max, Ve.id);
            this._activeRegions.push({ min: er.min, max: er.max, hiddenByOverlap: !1, priority: this._sourceIds.length, tileId: Ve.id, footprint: Ve.footprint, order: Ce, clipMask: De, clipScope: Ke });
          }
          this._sourceIds.push(Ie.getSourceId());
        }
        _computeReplacement() {
          this._activeRegions.sort((de, Ce) => de.priority - Ce.priority || d0(de.min, Ce.min) || d0(de.max, Ce.max) || de.order - Ce.order || de.clipMask - Ce.clipMask || function(De, Ke) {
            const Ve = (er, fr) => er + fr;
            return De.length - Ke.length || De.reduce(Ve, "").localeCompare(Ke.reduce(Ve, ""));
          }(de.clipScope, Ce.clipScope));
          let Ie = this._activeRegions.length !== this._prevRegions.length;
          if (!Ie) {
            let de = 0;
            for (; !Ie && de !== this._activeRegions.length; ) {
              const Ce = this._activeRegions[de], De = this._prevRegions[de];
              Ie = Ce.priority !== De.priority || !vg(Ce, De) || Ce.order !== De.order || Ce.clipMask !== De.clipMask || !yn(Ce.clipScope, De.clipScope), ++de;
            }
          }
          if (Ie) {
            ++this._updateTime;
            for (const Ce of this._activeRegions)
              Ce.order !== h0 && (this._globalClipBounds.min.x = Math.min(this._globalClipBounds.min.x, Ce.min.x), this._globalClipBounds.min.y = Math.min(this._globalClipBounds.min.y, Ce.min.y), this._globalClipBounds.max.x = Math.max(this._globalClipBounds.max.x, Ce.max.x), this._globalClipBounds.max.y = Math.max(this._globalClipBounds.max.y, Ce.max.y));
            const de = (Ce) => {
              const De = this._activeRegions;
              if (Ce >= De.length)
                return Ce;
              const Ke = De[Ce].priority;
              for (; Ce < De.length && De[Ce].priority === Ke; )
                ++Ce;
              return Ce;
            };
            if (this._sourceIds.length > 1) {
              let Ce = 0, De = de(Ce);
              for (; Ce !== De; ) {
                let Ke = Ce;
                const Ve = Ce;
                for (; Ke !== De; ) {
                  const er = this._activeRegions[Ke];
                  er.hiddenByOverlap = !1;
                  for (let fr = 0; fr < Ve; fr++) {
                    const wr = this._activeRegions[fr];
                    if (!wr.hiddenByOverlap && er.order === h0 && n1(er, wr) && (er.hiddenByOverlap = dm(er.footprint, er.tileId, wr.footprint, wr.tileId), er.hiddenByOverlap))
                      break;
                  }
                  ++Ke;
                }
                Ce = De, De = de(Ce);
              }
            }
          }
        }
        _setSources(Ie) {
          [this._prevRegions, this._activeRegions] = [this._activeRegions, []], this._sourceIds = [];
          for (let de = Ie.length - 1; de >= 0; de--)
            this._addSource(Ie[de]);
          this._computeReplacement();
        }
      }, ne.dw = class {
        constructor(Ie) {
          this._createGrid(Ie), this._createPoles(Ie);
        }
        destroy() {
          this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
          for (const Ie of this._poleSegments)
            Ie.destroy();
          for (const Ie of this._gridSegments)
            Ie.withSkirts.destroy(), Ie.withoutSkirts.destroy();
        }
        _fillGridMeshWithLods(Ie, de) {
          const Ce = new Zc(), De = new tl(), Ke = [], Ve = Ie + 1 + 2, er = de[0] + 1, fr = de[0] + 1 + (1 + de.length), wr = (kr, cr, Mr) => {
            let Er = kr === Ve - 1 ? kr - 2 : kr === 0 ? kr : kr - 1;
            return Er += Mr ? 24575 : 0, [Er, cr];
          };
          for (let kr = 0; kr < Ve; ++kr)
            Ce.emplaceBack(...wr(kr, 0, !0));
          for (let kr = 0; kr < er; ++kr)
            for (let cr = 0; cr < Ve; ++cr)
              Ce.emplaceBack(...wr(cr, kr, (cr === 0 || cr === Ve - 1) && !0));
          for (let kr = 0; kr < de.length; ++kr) {
            const cr = de[kr];
            for (let Mr = 0; Mr < Ve; ++Mr)
              Ce.emplaceBack(...wr(Mr, cr, !0));
          }
          for (let kr = 0; kr < de.length; ++kr) {
            const cr = De.length, Mr = de[kr] + 1 + 2, Er = new tl();
            for (let Br = 0; Br < Mr - 1; Br++) {
              const Fr = Br === Mr - 2, jr = Fr ? Ve * (fr - de.length + kr - Br) : Ve;
              for (let Qr = 0; Qr < Ve - 1; Qr++) {
                const ti = Br * Ve + Qr;
                Br === 0 || Fr || Qr === 0 || Qr === Ve - 2 ? (Er.emplaceBack(ti + 1, ti, ti + jr), Er.emplaceBack(ti + jr, ti + jr + 1, ti + 1)) : (De.emplaceBack(ti + 1, ti, ti + jr), De.emplaceBack(ti + jr, ti + jr + 1, ti + 1));
              }
            }
            const xr = fs.simpleSegment(0, cr, Ce.length, De.length - cr);
            for (let Br = 0; Br < Er.uint16.length; Br += 3)
              De.emplaceBack(Er.uint16[Br], Er.uint16[Br + 1], Er.uint16[Br + 2]);
            const Sr = fs.simpleSegment(0, cr, Ce.length, De.length - cr);
            Ke.push({ withoutSkirts: xr, withSkirts: Sr });
          }
          return { vertices: Ce, indices: De, segments: Ke };
        }
        _createGrid(Ie) {
          const de = this._fillGridMeshWithLods(Yc, cf);
          this._gridSegments = de.segments, this._gridBuffer = Ie.createVertexBuffer(de.vertices, ia.members), this._gridIndexBuffer = Ie.createIndexBuffer(de.indices, !0);
        }
        _createPoles(Ie) {
          const de = new tl();
          for (let er = 0; er <= Yc; er++)
            de.emplaceBack(0, er + 1, er + 2);
          this._poleIndexBuffer = Ie.createIndexBuffer(de, !0);
          const Ce = new Kc(), De = new Kc(), Ke = new Kc(), Ve = new Kc();
          this._poleSegments = [];
          for (let er = 0, fr = 0; er < ud; er++) {
            const wr = 360 / (1 << er);
            Ce.emplaceBack(0, -il, 0, 0.5, 0), De.emplaceBack(0, -il, 0, 0.5, 1), Ke.emplaceBack(0, -il, 0, 0.5, 0.5), Ve.emplaceBack(0, -il, 0, 0.5, 0.5);
            for (let kr = 0; kr <= Yc; kr++) {
              let cr = kr / Yc, Mr = 0;
              const Er = Ho(0, wr, cr), [xr, Sr, Br] = pu(xh, hf, Er, il);
              Ce.emplaceBack(xr, Sr, Br, cr, Mr), De.emplaceBack(xr, Sr, Br, cr, 1 - Mr);
              const Fr = rn(Er);
              cr = 0.5 + 0.5 * Math.sin(Fr), Mr = 0.5 + 0.5 * Math.cos(Fr), Ke.emplaceBack(xr, Sr, Br, cr, Mr), Ve.emplaceBack(xr, Sr, Br, cr, 1 - Mr);
            }
            this._poleSegments.push(fs.simpleSegment(fr, 0, 66, 64)), fr += 66;
          }
          this._poleNorthVertexBuffer = Ie.createVertexBuffer(Ce, zo, !1), this._poleSouthVertexBuffer = Ie.createVertexBuffer(De, zo, !1), this._texturedPoleNorthVertexBuffer = Ie.createVertexBuffer(Ke, zo, !1), this._texturedPoleSouthVertexBuffer = Ie.createVertexBuffer(Ve, zo, !1);
        }
        getGridBuffers(Ie, de) {
          return [this._gridBuffer, this._gridIndexBuffer, de ? this._gridSegments[Ie].withSkirts : this._gridSegments[Ie].withoutSkirts];
        }
        getPoleBuffers(Ie, de) {
          return [de ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer, de ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer, this._poleIndexBuffer, this._poleSegments[Ie]];
        }
      }, ne.dx = h0, ne.dy = Fn, ne.dz = function() {
        return !!document.fullscreenElement || !!document.webkitFullscreenElement;
      }, ne.e = Pi, ne.e0 = yl, ne.e1 = Yg, ne.e2 = function(Ie, de, Ce, De, Ke, Ve, er, fr, wr, kr, cr = 1, Mr, Er) {
        Ie.createArrays(), Ie.tilePixelRatio = vo / (512 * Ie.overscaling), Ie.compareText = {}, Ie.iconsNeedLinear = !1;
        const xr = Ie.layers[0].layout, Sr = Ie.layers[0]._unevaluatedLayout._values, Br = {};
        Br.scaleFactor = cr, Br.textSizeScaleRange = xr.get("text-size-scale-range"), Br.iconSizeScaleRange = xr.get("icon-size-scale-range");
        const [Fr, jr] = Br.textSizeScaleRange, [Qr, ti] = Br.iconSizeScaleRange;
        if (Br.textScaleFactor = vn(Br.scaleFactor, Fr, jr), Br.iconScaleFactor = vn(Br.scaleFactor, Qr, ti), Ie.textSizeData.kind === "composite") {
          const { minZoom: Si, maxZoom: Di } = Ie.textSizeData;
          Br.compositeTextSizes = [Sr["text-size"].possiblyEvaluate(new wa(Si), fr), Sr["text-size"].possiblyEvaluate(new wa(Di), fr)];
        }
        if (Ie.iconSizeData.kind === "composite") {
          const { minZoom: Si, maxZoom: Di } = Ie.iconSizeData;
          Br.compositeIconSizes = [Sr["icon-size"].possiblyEvaluate(new wa(Si), fr), Sr["icon-size"].possiblyEvaluate(new wa(Di), fr)];
        }
        Br.layoutTextSize = Sr["text-size"].possiblyEvaluate(new wa(wr + 1), fr), Br.layoutIconSize = Sr["icon-size"].possiblyEvaluate(new wa(wr + 1), fr), Br.textMaxSize = Sr["text-size"].possiblyEvaluate(new wa(18), fr);
        const Kr = xr.get("text-rotation-alignment") === "map" && xr.get("symbol-placement") !== "point", ni = xr.get("text-size");
        let gi = !1;
        for (const Si of Ie.features)
          if (Si.icon && Si.icon.nameSecondary) {
            gi = !0;
            break;
          }
        for (const Si of Ie.features) {
          const Di = xr.get("text-font").evaluate(Si, {}, fr).join(","), Ri = ni.evaluate(Si, {}, fr) * Br.textScaleFactor, Bi = Br.layoutTextSize.evaluate(Si, {}, fr) * Br.textScaleFactor, Ji = (Br.layoutIconSize.evaluate(Si, {}, fr), { horizontal: {}, vertical: void 0 }), Fi = Si.text;
          let tn, cn = [0, 0];
          if (Fi) {
            const Cn = Fi.toString(), gn = xr.get("text-letter-spacing").evaluate(Si, {}, fr) * _l, Nn = xr.get("text-line-height").evaluate(Si, {}, fr) * _l, oo = Xh(Cn) ? gn : 0, Un = xr.get("text-anchor").evaluate(Si, {}, fr), fo = xr.get("text-variable-anchor");
            if (!fo) {
              const po = xr.get("text-radial-offset").evaluate(Si, {}, fr);
              cn = po ? tv(Un, [po * _l, A1]) : xr.get("text-offset").evaluate(Si, {}, fr).map((Lo) => Lo * _l);
            }
            let ho = Kr ? "center" : xr.get("text-justify").evaluate(Si, {}, fr);
            const bo = xr.get("symbol-placement") === "point", Jn = bo ? xr.get("text-max-width").evaluate(Si, {}, fr) * _l : 1 / 0, Ro = (po) => {
              Ie.allowVerticalPlacement && Zh(Cn) && (Ji.vertical = w1(Fi, de, Ce, Ke, Di, Jn, Nn, Un, po, oo, cn, Pc.vertical, !0, Bi, Ri));
            };
            if (!Kr && fo) {
              const po = ho === "auto" ? fo.map((jo) => k1(jo)) : [ho];
              let Lo = !1;
              for (let jo = 0; jo < po.length; jo++) {
                const oa = po[jo];
                if (!Ji.horizontal[oa])
                  if (Lo)
                    Ji.horizontal[oa] = Ji.horizontal[0];
                  else {
                    const ua = w1(Fi, de, Ce, Ke, Di, Jn, Nn, "center", oa, oo, cn, Pc.horizontal, !1, Bi, Ri);
                    ua && (Ji.horizontal[oa] = ua, Lo = ua.positionedLines.length === 1);
                  }
              }
              Ro("left");
            } else {
              if (ho === "auto" && (ho = k1(Un)), bo || xr.get("text-writing-mode").indexOf("horizontal") >= 0 || !Zh(Cn)) {
                const po = w1(Fi, de, Ce, Ke, Di, Jn, Nn, Un, ho, oo, cn, Pc.horizontal, !1, Bi, Ri);
                po && (Ji.horizontal[ho] = po);
              }
              Ro(bo ? "left" : ho);
            }
          }
          let ln = !1, mn = !1;
          if (Si.icon && Si.icon.namePrimary) {
            const Cn = m0(Ie.iconSizeData, Sr["icon-size"], fr, Ie.zoom, Si) * Br.iconScaleFactor * Mr, gn = Si.icon.getPrimary().scaleSelf(Cn).serialize(), Nn = De[gn];
            Nn && (tn = __(Ke[gn], Si.icon.nameSecondary ? Ke[Si.icon.getSecondary().scaleSelf(Cn).serialize()] : void 0, xr.get("icon-offset").evaluate(Si, {}, fr), xr.get("icon-anchor").evaluate(Si, {}, fr)), ln = Nn.sdf, mn = Nn.usvg, Ie.sdfIcons === void 0 ? Ie.sdfIcons = Nn.sdf : Ie.sdfIcons !== Nn.sdf && Mn("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (Nn.pixelRatio !== Ie.pixelRatio || xr.get("icon-rotate").constantOr(1) !== 0) && (Ie.iconsNeedLinear = !0));
          }
          const wn = iv(Ji.horizontal) || Ji.vertical;
          Ie.iconsInText || (Ie.iconsInText = !!wn && wn.iconsInText), (wn || tn) && E_(Ie, Si, Ji, tn, De, Br, Bi, 0, cn, ln, mn, er, fr, kr, Er, gi);
        }
        Ve && Ie.generateCollisionDebugBuffers(wr, Ie.collisionBoxArray, Br.textScaleFactor);
      }, ne.e3 = $a, ne.e4 = Sv, ne.e5 = Oi, ne.e6 = dd, ne.e7 = Ug, ne.e8 = rr, ne.e9 = function(Ie) {
        let de = 0;
        if (new Uint32Array(Ie, 0, 1)[0] !== Sy) {
          const Ce = new Uint32Array(Ie, 0, 7), [, , De, Ke, Ve, er] = Ce;
          de = Ce.byteLength + Ke + Ve + er + Ve, (De !== Ie.byteLength || de >= Ie.byteLength) && Mn("Invalid b3dm header information.");
        }
        return Ay(Ie, de);
      }, ne.ea = function(Ie, de) {
        const Ce = Ly(Ie);
        for (const De of Ce) {
          for (const Ke of De.meshes)
            ux(Ke);
          De.lights && (De.lightMeshIndex = De.meshes.length, De.meshes.push(hx(De.lights, de)));
        }
        return Ce;
      }, ne.eb = vv, ne.ec = H2, ne.ed = Il, ne.ee = function(Ie) {
        ea(), Go?.then((de) => {
          de.keys().then((Ce) => {
            for (let De = 0; De < Ce.length - Ie; De++)
              de.delete(Ce[De]);
          });
        });
      }, ne.f = function(Ie) {
        return Ie.indexOf("mapbox:") === 0;
      }, ne.g = function(Ie, de) {
        return Pl(Yn(Ie, { method: "GET" }), de);
      }, ne.h = Ai, ne.i = function(Ie) {
        return Pi.API_STYLE_REGEX.test(Ie) && !ki(Ie);
      }, ne.j = function(Ie) {
        return decodeURIComponent(atob(Ie).split("").map((de) => "%" + ("00" + de.charCodeAt(0).toString(16)).slice(-2)).join(""));
      }, ne.k = function(Ie) {
        return btoa(encodeURIComponent(Ie).replace(/%([0-9A-F]{2})/g, (de, Ce) => String.fromCharCode(Number("0x" + Ce))));
      }, ne.l = Yn, ne.m = Ra, ne.n = function(Ie, de) {
        return Pl(Yn(Ie, { type: "json" }), de);
      }, ne.o = ju, ne.p = function(Ie, de) {
        return Pl(Yn(Ie, { method: "POST" }), de);
      }, ne.q = _n, ne.r = Al, ne.s = function(Ie) {
        try {
          const de = self[Ie];
          return de.setItem("_mapbox_test_", 1), de.removeItem("_mapbox_test_"), !0;
        } catch {
          return !1;
        }
      }, ne.t = qn, ne.u = function() {
        return function Ie(de) {
          return de ? (de ^ Math.random() * (16 >> de / 4)).toString(16) : ([1e7] + -[1e3] + -4e3 + -8e3 + -1e11).replace(/[018]/g, Ie);
        }();
      }, ne.v = function(Ie) {
        return !!Ie && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(Ie);
      }, ne.w = Mn, ne.x = function() {
        return j_ || (j_ = new Am()), j_;
      }, ne.y = Xl, ne.z = Nc;
    }), Me(["./shared"], function(ne) {
      function rr(kn) {
        const ai = kn ? kn.url.toString() : void 0;
        return ai ? performance.getEntriesByName(ai) : [];
      }
      function gr(kn) {
        if (typeof kn == "number" || typeof kn == "boolean" || typeof kn == "string" || kn == null)
          return JSON.stringify(kn);
        if (Array.isArray(kn)) {
          let _i = "[";
          for (const Pi of kn)
            _i += `${gr(Pi)},`;
          return `${_i}]`;
        }
        let ai = "{";
        for (const _i of Object.keys(kn).sort())
          ai += `${_i}:${gr(kn[_i])},`;
        return `${ai}}`;
      }
      function or(kn) {
        let ai = "";
        for (const _i of ne.bm)
          ai += `/${gr(kn[_i])}`;
        return ai;
      }
      class _r {
        constructor(ai) {
          this.keyCache = {}, this._layers = {}, this._layerConfigs = {}, ai && this.replace(ai);
        }
        replace(ai, _i) {
          this._layerConfigs = {}, this._layers = {}, this.update(ai, [], _i);
        }
        update(ai, _i, Pi) {
          this._options = Pi;
          for (const ki of ai)
            this._layerConfigs[ki.id] = ki, (this._layers[ki.id] = ne.cu(ki, this.scope, null, this._options)).compileFilter(Pi), this.keyCache[ki.id] && delete this.keyCache[ki.id];
          for (const ki of _i)
            delete this.keyCache[ki], delete this._layerConfigs[ki], delete this._layers[ki];
          this.familiesBySource = {};
          const Ai = function(ki, an) {
            const Ui = {};
            for (let Sn = 0; Sn < ki.length; Sn++) {
              const Hi = ki[Sn];
              let en = an && an[Hi.id];
              !en && (en = or(Hi), Hi.type === "line" && Hi.paint) && function _n(Tn) {
                return typeof Tn == "string" && Tn === "line-progress" || (Array.isArray(Tn) ? Tn.some(_n) : !(!Tn || typeof Tn != "object") && Object.values(Tn).some(_n));
              }(Hi.paint["line-width"]) && (en += `/${gr(Hi.paint["line-width"])}`), an && (an[Hi.id] = en);
              let qn = Ui[en];
              qn || (qn = Ui[en] = []), qn.push(Hi);
            }
            const Vi = [];
            for (const Sn in Ui)
              Vi.push(Ui[Sn]);
            return Vi;
          }(ne.bj(this._layerConfigs), this.keyCache);
          for (const ki of Ai) {
            const an = ki.map((qn) => this._layers[qn.id]), Ui = an[0];
            if (Ui.visibility === "none")
              continue;
            const Vi = Ui.source || "";
            let Sn = this.familiesBySource[Vi];
            Sn || (Sn = this.familiesBySource[Vi] = {});
            const Hi = Ui.sourceLayer || "_geojsonTileLayer";
            let en = Sn[Hi];
            en || (en = Sn[Hi] = []), en.push(an);
          }
        }
      }
      const Lr = 1 * ne.dX;
      class Ir {
        constructor(ai) {
          const _i = {}, Pi = [];
          for (const Ui in ai) {
            const Vi = ai[Ui], Sn = _i[Ui] = {};
            for (const Hi in Vi.glyphs) {
              const en = Vi.glyphs[+Hi];
              if (!en || en.bitmap.width === 0 || en.bitmap.height === 0)
                continue;
              const qn = en.metrics.localGlyph ? Lr : 1, _n = { x: 0, y: 0, w: en.bitmap.width + 2 * qn, h: en.bitmap.height + 2 * qn };
              Pi.push(_n), Sn[Hi] = _n;
            }
          }
          const { w: Ai, h: ki } = ne.C(Pi), an = new ne.dW({ width: Ai || 1, height: ki || 1 });
          for (const Ui in ai) {
            const Vi = ai[Ui];
            for (const Sn in Vi.glyphs) {
              const Hi = Vi.glyphs[+Sn];
              if (!Hi || Hi.bitmap.width === 0 || Hi.bitmap.height === 0)
                continue;
              const en = _i[Ui][Sn], qn = Hi.metrics.localGlyph ? Lr : 1;
              ne.dW.copy(Hi.bitmap, an, { x: 0, y: 0 }, { x: en.x + qn, y: en.y + qn }, Hi.bitmap);
            }
          }
          this.image = an, this.positions = _i;
        }
      }
      ne.dV(Ir, "GlyphAtlas");
      class Ar {
        constructor(ai) {
          this.tileID = new ne.aG(ai.tileID.overscaledZ, ai.tileID.wrap, ai.tileID.canonical.z, ai.tileID.canonical.x, ai.tileID.canonical.y), this.tileZoom = ai.tileZoom, this.uid = ai.uid, this.zoom = ai.zoom, this.lut = ai.lut, this.canonical = ai.tileID.canonical, this.pixelRatio = ai.pixelRatio, this.tileSize = ai.tileSize, this.source = ai.source, this.scope = ai.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = ai.showCollisionBoxes, this.collectResourceTiming = !!ai.request && ai.request.collectResourceTiming, this.promoteId = ai.promoteId, this.isSymbolTile = ai.isSymbolTile, this.tileTransform = ne.aQ(ai.tileID.canonical, ai.projection), this.projection = ai.projection, this.worldview = ai.worldview, this.localizableLayerIds = ai.localizableLayerIds, this.brightness = ai.brightness, this.extraShadowCaster = !!ai.extraShadowCaster, this.tessellationStep = ai.tessellationStep, this.scaleFactor = ai.scaleFactor;
        }
        parse(ai, _i, Pi, Ai, ki) {
          this.status = "parsing", this.data = ai, this.collisionBoxArray = new ne.aW();
          const an = new ne.dY(Object.keys(ai.layers).sort()), Ui = new ne.dZ(this.tileID, this.promoteId);
          Ui.bucketLayerIDs = [];
          const Vi = {}, Sn = new ne.d_(256, 256), Hi = { featureIndex: Ui, iconDependencies: {}, patternDependencies: {}, glyphDependencies: {}, lineAtlas: Sn, availableImages: Pi, brightness: this.brightness, scaleFactor: this.scaleFactor }, en = _i.familiesBySource[this.source];
          for (const Bo in en) {
            const Qo = ai.layers[Bo];
            if (!Qo)
              continue;
            let Go = !1, No = !1, Zo = !1;
            for (const Ra of en[Bo])
              Ra[0].type === "symbol" ? Go = !0 : No = !0, Ra[0].is3D() && Ra[0].type !== "model" && (Zo = !0);
            if (this.extraShadowCaster && !Zo || this.isSymbolTile === !0 && !Go || this.isSymbolTile === !1 && !No)
              continue;
            Qo.version === 1 && ne.w(`Vector tile source "${this.source}" layer "${Bo}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
            const ea = an.encode(Bo), da = [];
            for (let Ra = 0, ba = 0; Ra < Qo.length; Ra++) {
              const Ea = Qo.feature(Ra), Ha = Ui.getId(Ea, Bo);
              if (this.localizableLayerIds && this.localizableLayerIds.has(Bo)) {
                const Fa = Ea.properties ? Ea.properties.worldview : null;
                if (this.worldview && typeof Fa == "string")
                  if (Fa === "all")
                    Ea.properties.$localized = !0;
                  else {
                    if (!Fa.split(",").includes(this.worldview))
                      continue;
                    Ea.properties.$localized = !0, Ea.properties.worldview = this.worldview;
                  }
              }
              da.push({ feature: Ea, id: Ha, index: ba, sourceLayerIndex: ea }), ba++;
            }
            for (const Ra of en[Bo]) {
              const ba = Ra[0];
              (!this.extraShadowCaster || ba.is3D() && ba.type !== "model") && (this.isSymbolTile !== void 0 && ba.type === "symbol" !== this.isSymbolTile || ba.minzoom && this.zoom < Math.floor(ba.minzoom) || ba.maxzoom && this.zoom >= ba.maxzoom || ba.visibility !== "none" && (Rr(Ra, this.zoom, Hi.brightness, Pi), (Vi[ba.id] = ba.createBucket({ index: Ui.bucketLayerIDs.length, layers: Ra, zoom: this.zoom, lut: this.lut, canonical: this.canonical, pixelRatio: this.pixelRatio, overscaling: this.overscaling, collisionBoxArray: this.collisionBoxArray, sourceLayerIndex: ea, sourceID: this.source, projection: this.projection.spec, tessellationStep: this.tessellationStep })).populate(da, Hi, this.tileID.canonical, this.tileTransform), Ui.bucketLayerIDs.push(Ra.map((Ea) => ne.aC(Ea.id, Ea.scope)))));
            }
          }
          let qn, _n, Tn, xo;
          Sn.trim();
          const Co = { type: "maybePrepare", isSymbolTile: this.isSymbolTile, zoom: this.zoom }, $o = () => {
            if (qn)
              return this.status = "done", ki(qn);
            if (this.extraShadowCaster)
              this.status = "done", ki(null, { buckets: ne.bj(Vi).filter((Bo) => !Bo.isEmpty()), featureIndex: Ui, collisionBoxArray: null, glyphAtlasImage: null, lineAtlas: null, imageAtlas: null, brightness: Hi.brightness, glyphMap: null, iconMap: null, glyphPositions: null });
            else if (_n && Tn && xo) {
              const Bo = new Ir(_n), Qo = new ne.e1(Tn, xo, this.lut);
              for (const Go in Vi) {
                const No = Vi[Go];
                No instanceof ne.aX ? (Rr(No.layers, this.zoom, Hi.brightness, Pi), ne.e2(No, _n, Bo.positions, Tn, Qo.iconPositions, this.showCollisionBoxes, Pi, this.tileID.canonical, this.tileZoom, this.projection, this.scaleFactor, this.pixelRatio, this.brightness)) : No.hasPattern && (No instanceof ne.b1 || No instanceof ne.b2 || No instanceof ne.d5) && (Rr(No.layers, this.zoom, Hi.brightness, Pi), No.addFeatures(Hi, this.tileID.canonical, Qo.patternPositions, Pi, this.tileTransform, this.brightness));
              }
              this.status = "done", ki(null, { buckets: ne.bj(Vi).filter((Go) => !Go.isEmpty()), featureIndex: Ui, collisionBoxArray: this.collisionBoxArray, glyphAtlasImage: Bo.image, lineAtlas: Sn, imageAtlas: Qo, brightness: Hi.brightness });
            }
          };
          if (!this.extraShadowCaster) {
            const Bo = ne.d$(Hi.glyphDependencies, (No) => Object.keys(No).map(Number));
            Object.keys(Bo).length ? Ai.send("getGlyphs", { uid: this.uid, stacks: Bo, scope: this.scope }, (No, Zo) => {
              qn || (qn = No, _n = Zo, $o());
            }, void 0, !1, Co) : _n = {};
            const Qo = Object.keys(Hi.iconDependencies);
            Qo.length ? Ai.send("getImages", { icons: Qo, source: this.source, scope: this.scope, tileID: this.tileID, type: "icons" }, (No, Zo) => {
              if (qn)
                return;
              qn = No;
              const ea = {};
              Object.values(Zo).some((da) => da.usvg) ? this.rasterize(Ai, ea, Zo, Hi.iconDependencies, () => {
                Tn = ea, $o();
              }) : (this.fillImageMap(ea, Hi.iconDependencies, Zo), Tn = ea, $o());
            }, void 0, !1, Co) : Tn = {};
            const Go = Object.keys(Hi.patternDependencies);
            Go.length ? Ai.send("getImages", { icons: Go, source: this.source, scope: this.scope, tileID: this.tileID, type: "patterns" }, (No, Zo) => {
              if (!qn) {
                qn = No;
                const ea = {};
                Object.values(Zo).some((da) => da.usvg) ? this.rasterize(Ai, ea, Zo, Hi.patternDependencies, () => {
                  xo = ea, $o();
                }) : (this.fillImageMap(ea, Hi.patternDependencies, Zo), xo = ea, $o());
              }
            }, void 0, !1, Co) : xo = {};
          }
          $o();
        }
        fillImageMap(ai, _i, Pi) {
          for (const Ai in Pi) {
            const ki = _i[Ai] || [];
            for (const an of ki)
              Pi[an.id].usvg || (ai[an.serialize()] = Pi[an.id]);
          }
        }
        getImageTaskQueue(ai, _i, Pi) {
          const Ai = {};
          for (const ki in _i) {
            const an = Pi[ki] || [];
            for (const Ui of an) {
              const Vi = Ui.serialize();
              _i[Ui.id].usvg ? Ai[Vi] || (Ai[Vi] = Ui) : ai[Vi] = _i[Ui.id];
            }
          }
          return Ai;
        }
        rasterize(ai, _i, Pi, Ai, ki) {
          const an = this.getImageTaskQueue(_i, Pi, Ai);
          this.rasterizeTask = ai.send("rasterizeImages", { scope: this.scope, imageTasks: an }, (Ui, Vi) => {
            if (!Ui)
              for (const Sn in Vi) {
                const { id: Hi } = ne.e0.deserializeFromString(Sn);
                _i[Sn] = Object.assign({}, Pi[Hi], { data: Vi[Sn] });
              }
            ki();
          });
        }
        cancelRasterize() {
          this.rasterizeTask && this.rasterizeTask.cancel();
        }
      }
      function Rr(kn, ai, _i, Pi) {
        const Ai = new ne.a8(ai, { brightness: _i });
        for (const ki of kn)
          ki.recalculate(Ai, Pi);
      }
      class Nr extends ne.E {
        constructor(ai, _i, Pi, Ai, ki, an) {
          super(), this.actor = ai, this.layerIndex = _i, this.availableImages = Pi, this.loadVectorData = ki || ne.aD, this.loading = {}, this.loaded = {}, this.deduped = new ne.aB(ai.scheduler), this.isSpriteLoaded = Ai, this.scheduler = ai.scheduler, this.brightness = an;
        }
        loadTile(ai, _i) {
          const Pi = ai.uid, Ai = ai && ai.request, ki = Ai && Ai.collectResourceTiming, an = this.loading[Pi] = new Ar(ai);
          an.abort = this.loadVectorData(ai, (Ui, Vi) => {
            const Sn = !this.loading[Pi];
            if (delete this.loading[Pi], an.cancelRasterize(), Sn || Ui || !Vi)
              return an.status = "done", Sn || (this.loaded[Pi] = an), _i(Ui);
            const Hi = Vi.rawData, en = {};
            Vi.expires && (en.expires = Vi.expires), Vi.cacheControl && (en.cacheControl = Vi.cacheControl), an.vectorTile = Vi.vectorTile || new ne.e3.VectorTile(new ne.bh(Hi));
            const qn = () => {
              an.parse(an.vectorTile, this.layerIndex, this.availableImages, this.actor, (_n, Tn) => {
                if (_n || !Tn)
                  return _i(_n);
                const xo = {};
                if (ki) {
                  const Co = rr(Ai);
                  Co.length > 0 && (xo.resourceTiming = JSON.parse(JSON.stringify(Co)));
                }
                _i(null, ne.l({ rawTileData: Hi.slice(0) }, Tn, en, xo));
              });
            };
            this.isSpriteLoaded ? qn() : this.once("isSpriteLoaded", () => {
              this.scheduler ? this.scheduler.add(qn, { type: "parseTile", isSymbolTile: ai.isSymbolTile, zoom: ai.tileZoom }) : qn();
            }), this.loaded = this.loaded || {}, this.loaded[Pi] = an;
          });
        }
        reloadTile(ai, _i) {
          const Pi = this.loaded, Ai = ai.uid;
          if (Pi && Pi[Ai]) {
            const ki = Pi[Ai];
            ki.scaleFactor = ai.scaleFactor, ki.showCollisionBoxes = ai.showCollisionBoxes, ki.projection = ai.projection, ki.brightness = ai.brightness, ki.tileTransform = ne.aQ(ai.tileID.canonical, ai.projection), ki.extraShadowCaster = ai.extraShadowCaster, ki.lut = ai.lut;
            const an = (Ui, Vi) => {
              const Sn = ki.reloadCallback;
              Sn && (delete ki.reloadCallback, ki.parse(ki.vectorTile, this.layerIndex, this.availableImages, this.actor, Sn)), _i(Ui, Vi);
            };
            ki.status === "parsing" ? ki.reloadCallback = an : ki.status === "done" && (ki.vectorTile ? ki.parse(ki.vectorTile, this.layerIndex, this.availableImages, this.actor, an) : an());
          } else
            _i(null, void 0);
        }
        abortTile(ai, _i) {
          const Pi = ai.uid, Ai = this.loading[Pi];
          Ai && (Ai.abort && Ai.abort(), delete this.loading[Pi]), _i();
        }
        removeTile(ai, _i) {
          const Pi = this.loaded, Ai = ai.uid;
          Pi && Pi[Ai] && delete Pi[Ai], _i();
        }
      }
      class Yr {
        loadTile(ai, _i) {
          const { uid: Pi, encoding: Ai, rawImageData: ki, padding: an } = ai, Ui = ImageBitmap && ki instanceof ImageBitmap ? this.getImageData(ki, an) : ki;
          _i(null, new ne.e4(Pi, Ui, Ai, an < 1));
        }
        getImageData(ai, _i) {
          this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(ai.width, ai.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", { willReadFrequently: !0 })), this.offscreenCanvas.width = ai.width, this.offscreenCanvas.height = ai.height, this.offscreenCanvasContext.drawImage(ai, 0, 0, ai.width, ai.height);
          const Pi = this.offscreenCanvasContext.getImageData(-_i, -_i, ai.width + 2 * _i, ai.height + 2 * _i);
          return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), Pi;
        }
      }
      ne.bg.setPbf(ne.bh);
      class Vr {
        decodeRasterArray({ task: ai, buffer: _i }, Pi) {
          ne.bg.performDecoding(_i, ai).then((Ai) => {
            Pi(null, Ai);
          }, (Ai) => {
            Pi(Ai);
          });
        }
      }
      const Xr = ne.e3.VectorTileFeature.prototype.toGeoJSON;
      class Wr {
        constructor(ai) {
          this._feature = ai, this.extent = ne.ag, this.type = ai.type, this.properties = ai.tags, "id" in ai && !isNaN(ai.id) && (this.id = parseInt(ai.id, 10));
        }
        loadGeometry() {
          if (this._feature.type === 1) {
            const ai = [];
            for (const _i of this._feature.geometry)
              ai.push([new ne.P(_i[0], _i[1])]);
            return ai;
          }
          {
            const ai = [];
            for (const _i of this._feature.geometry) {
              const Pi = [];
              for (const Ai of _i)
                Pi.push(new ne.P(Ai[0], Ai[1]));
              ai.push(Pi);
            }
            return ai;
          }
        }
        toGeoJSON(ai, _i, Pi) {
          return Xr.call(this, ai, _i, Pi);
        }
      }
      class si {
        constructor(ai) {
          this.layers = { _geojsonTileLayer: this }, this.name = "_geojsonTileLayer", this.extent = ne.ag, this.length = ai.length, this._features = ai;
        }
        feature(ai) {
          return new Wr(this._features[ai]);
        }
      }
      const li = 64 / 4096, xi = 128;
      class di {
        constructor() {
          this.features = /* @__PURE__ */ new Map();
        }
        clear() {
          this.features.clear();
        }
        load(ai = [], _i) {
          for (const Pi of ai) {
            const Ai = Pi.id;
            if (Ai == null)
              continue;
            let ki = this.features.get(Ai);
            ki && this.updateCache(ki, _i), Pi.geometry ? (ki = ci(Pi), this.updateCache(ki, _i), this.features.set(Ai, ki)) : this.features.delete(Ai), this.updateCache(ki, _i);
          }
        }
        updateCache(ai, _i) {
          for (const { canonical: Pi, uid: Ai } of Object.values(_i)) {
            const { z: ki, x: an, y: Ui } = Pi;
            oi(ai, Math.pow(2, ki), an, Ui) && delete _i[Ai];
          }
        }
        getTile(ai, _i, Pi) {
          const Ai = Math.pow(2, ai), ki = [];
          for (const an of this.features.values())
            oi(an, Ai, _i, Pi) && ki.push(Ue(an, Ai, _i, Pi));
          return { features: ki };
        }
        getFeatures() {
          return [...this.features.values()];
        }
      }
      function oi({ minX: kn, minY: ai, maxX: _i, maxY: Pi }, Ai, ki, an) {
        return kn < (ki + 1 + li) / Ai && ai < (an + 1 + li) / Ai && _i > (ki - li) / Ai && Pi > (an - li) / Ai;
      }
      function ci(kn) {
        const { id: ai, geometry: _i, properties: Pi } = kn;
        if (!_i)
          return;
        if (_i.type === "GeometryCollection")
          throw new Error("GeometryCollection not supported in dynamic mode.");
        const { type: Ai, coordinates: ki } = _i, an = { id: ai, type: 1, geometry: [], tags: Pi, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 }, Ui = an.geometry;
        if (Ai === "Point")
          vr(ki, Ui, an);
        else if (Ai === "MultiPoint")
          for (const Vi of ki)
            vr(Vi, Ui, an);
        else if (Ai === "LineString")
          an.type = 2, Ae(ki, Ui, an);
        else if (Ai === "MultiLineString")
          an.type = 2, ze(ki, Ui, an);
        else if (Ai === "Polygon")
          an.type = 3, ze(ki, Ui, an, !0);
        else {
          if (Ai !== "MultiPolygon")
            throw new Error("Input data is not a valid GeoJSON object.");
          an.type = 3;
          for (const Vi of ki)
            ze(Vi, Ui, an, !0);
        }
        return an;
      }
      function vr([kn, ai], _i, Pi) {
        const Ai = ne.at(kn);
        let ki = ne.aA(ai);
        ki = ki < 0 ? 0 : ki > 1 ? 1 : ki, _i.push(Ai, ki), Pi.minX = Math.min(Pi.minX, Ai), Pi.minY = Math.min(Pi.minY, ki), Pi.maxX = Math.max(Pi.maxX, Ai), Pi.maxY = Math.max(Pi.maxY, ki);
      }
      function Ae(kn, ai, _i, Pi = !1, Ai = !1) {
        const ki = [];
        for (const an of kn)
          vr(an, ki, _i);
        ai.push(ki), Pi && function(an, Ui) {
          let Vi = 0;
          for (let Sn = 0, Hi = an.length, en = Hi - 2; Sn < Hi; en = Sn, Sn += 2)
            Vi += (an[Sn] - an[en]) * (an[Sn + 1] + an[en + 1]);
          if (Vi > 0 === Ui)
            for (let Sn = 0, Hi = an.length; Sn < Hi / 2; Sn += 2) {
              const en = an[Sn], qn = an[Sn + 1];
              an[Sn] = an[Hi - 2 - Sn], an[Sn + 1] = an[Hi - 1 - Sn], an[Hi - 2 - Sn] = en, an[Hi - 1 - Sn] = qn;
            }
        }(ki, Ai);
      }
      function ze(kn, ai, _i, Pi = !1) {
        for (let Ai = 0; Ai < kn.length; Ai++)
          Ae(kn[Ai], ai, _i, Pi, Ai === 0);
      }
      function Ue(kn, ai, _i, Pi) {
        const { id: Ai, type: ki, geometry: an, tags: Ui } = kn, Vi = [];
        if (ki === 1)
          (function(Sn, Hi, en, qn, _n) {
            for (let Tn = 0; Tn < Sn.length; Tn += 2) {
              const xo = Math.round(ne.ag * (Sn[Tn + 0] * Hi - en)), Co = Math.round(ne.ag * (Sn[Tn + 1] * Hi - qn));
              _n.push([xo, Co]);
            }
          })(an, ai, _i, Pi, Vi);
        else
          for (const Sn of an)
            tr(Sn, ai, _i, Pi, Vi);
        return { id: Ai, type: ki, geometry: Vi, tags: Ui };
      }
      function tr(kn, ai, _i, Pi, Ai) {
        const ki = -xi, an = ne.ag + xi;
        let Ui;
        for (let Vi = 0; Vi < kn.length - 2; Vi += 2) {
          let Sn = Math.round(ne.ag * (kn[Vi + 0] * ai - _i)), Hi = Math.round(ne.ag * (kn[Vi + 1] * ai - Pi)), en = Math.round(ne.ag * (kn[Vi + 2] * ai - _i)), qn = Math.round(ne.ag * (kn[Vi + 3] * ai - Pi));
          const _n = en - Sn, Tn = qn - Hi;
          Sn < ki && en < ki || (Sn < ki ? (Hi += Math.round(Tn * ((ki - Sn) / _n)), Sn = ki) : en < ki && (qn = Hi + Math.round(Tn * ((ki - Sn) / _n)), en = ki), Hi < ki && qn < ki || (Hi < ki ? (Sn += Math.round(_n * ((ki - Hi) / Tn)), Hi = ki) : qn < ki && (en = Sn + Math.round(_n * ((ki - Hi) / Tn)), qn = ki), Sn >= an && en >= an || (Sn >= an ? (Hi += Math.round(Tn * ((an - Sn) / _n)), Sn = an) : en >= an && (qn = Hi + Math.round(Tn * ((an - Sn) / _n)), en = an), Hi >= an && qn >= an || (Hi >= an ? (Sn += Math.round(_n * ((an - Hi) / Tn)), Hi = an) : qn >= an && (en = Sn + Math.round(_n * ((an - Hi) / Tn)), qn = an), Ui && Sn === Ui[Ui.length - 1][0] && Hi === Ui[Ui.length - 1][1] || (Ui = [[Sn, Hi]], Ai.push(Ui)), Ui.push([en, qn])))));
        }
      }
      var lr, pr, br, nr = { exports: {} }, Pe = function() {
        if (br)
          return nr.exports;
        br = 1;
        var kn = ne.e7(), ai = function() {
          if (pr)
            return lr;
          pr = 1;
          var Hi = ne.e5(), en = ne.e6().VectorTileFeature;
          function qn(Tn, xo) {
            this.options = xo || {}, this.features = Tn, this.length = Tn.length;
          }
          function _n(Tn, xo) {
            this.id = typeof Tn.id == "number" ? Tn.id : void 0, this.type = Tn.type, this.rawGeometry = Tn.type === 1 ? [Tn.geometry] : Tn.geometry, this.properties = Tn.tags, this.extent = xo || 4096;
          }
          return lr = qn, qn.prototype.feature = function(Tn) {
            return new _n(this.features[Tn], this.options.extent);
          }, _n.prototype.loadGeometry = function() {
            var Tn = this.rawGeometry;
            this.geometry = [];
            for (var xo = 0; xo < Tn.length; xo++) {
              for (var Co = Tn[xo], $o = [], Bo = 0; Bo < Co.length; Bo++)
                $o.push(new Hi(Co[Bo][0], Co[Bo][1]));
              this.geometry.push($o);
            }
            return this.geometry;
          }, _n.prototype.bbox = function() {
            this.geometry || this.loadGeometry();
            for (var Tn = this.geometry, xo = 1 / 0, Co = -1 / 0, $o = 1 / 0, Bo = -1 / 0, Qo = 0; Qo < Tn.length; Qo++)
              for (var Go = Tn[Qo], No = 0; No < Go.length; No++) {
                var Zo = Go[No];
                xo = Math.min(xo, Zo.x), Co = Math.max(Co, Zo.x), $o = Math.min($o, Zo.y), Bo = Math.max(Bo, Zo.y);
              }
            return [xo, $o, Co, Bo];
          }, _n.prototype.toGeoJSON = en.prototype.toGeoJSON, lr;
        }();
        function _i(Hi) {
          var en = new kn();
          return function(qn, _n) {
            for (var Tn in qn.layers)
              _n.writeMessage(3, Pi, qn.layers[Tn]);
          }(Hi, en), en.finish();
        }
        function Pi(Hi, en) {
          var qn;
          en.writeVarintField(15, Hi.version || 1), en.writeStringField(1, Hi.name || ""), en.writeVarintField(5, Hi.extent || 4096);
          var _n = { keys: [], values: [], keycache: {}, valuecache: {} };
          for (qn = 0; qn < Hi.length; qn++)
            _n.feature = Hi.feature(qn), en.writeMessage(2, Ai, _n);
          var Tn = _n.keys;
          for (qn = 0; qn < Tn.length; qn++)
            en.writeStringField(3, Tn[qn]);
          var xo = _n.values;
          for (qn = 0; qn < xo.length; qn++)
            en.writeMessage(4, Sn, xo[qn]);
        }
        function Ai(Hi, en) {
          var qn = Hi.feature;
          qn.id !== void 0 && en.writeVarintField(1, qn.id), en.writeMessage(2, ki, Hi), en.writeVarintField(3, qn.type), en.writeMessage(4, Vi, qn);
        }
        function ki(Hi, en) {
          var qn = Hi.feature, _n = Hi.keys, Tn = Hi.values, xo = Hi.keycache, Co = Hi.valuecache;
          for (var $o in qn.properties) {
            var Bo = qn.properties[$o], Qo = xo[$o];
            if (Bo !== null) {
              Qo === void 0 && (_n.push($o), xo[$o] = Qo = _n.length - 1), en.writeVarint(Qo);
              var Go = typeof Bo;
              Go !== "string" && Go !== "boolean" && Go !== "number" && (Bo = JSON.stringify(Bo));
              var No = Go + ":" + Bo, Zo = Co[No];
              Zo === void 0 && (Tn.push(Bo), Co[No] = Zo = Tn.length - 1), en.writeVarint(Zo);
            }
          }
        }
        function an(Hi, en) {
          return (en << 3) + (7 & Hi);
        }
        function Ui(Hi) {
          return Hi << 1 ^ Hi >> 31;
        }
        function Vi(Hi, en) {
          for (var qn = Hi.loadGeometry(), _n = Hi.type, Tn = 0, xo = 0, Co = qn.length, $o = 0; $o < Co; $o++) {
            var Bo = qn[$o], Qo = 1;
            _n === 1 && (Qo = Bo.length), en.writeVarint(an(1, Qo));
            for (var Go = _n === 3 ? Bo.length - 1 : Bo.length, No = 0; No < Go; No++) {
              No === 1 && _n !== 1 && en.writeVarint(an(2, Go - 1));
              var Zo = Bo[No].x - Tn, ea = Bo[No].y - xo;
              en.writeVarint(Ui(Zo)), en.writeVarint(Ui(ea)), Tn += Zo, xo += ea;
            }
            _n === 3 && en.writeVarint(an(7, 1));
          }
        }
        function Sn(Hi, en) {
          var qn = typeof Hi;
          qn === "string" ? en.writeStringField(1, Hi) : qn === "boolean" ? en.writeBooleanField(7, Hi) : qn === "number" && (Hi % 1 != 0 ? en.writeDoubleField(3, Hi) : Hi < 0 ? en.writeSVarintField(6, Hi) : en.writeVarintField(5, Hi));
        }
        return nr.exports = _i, nr.exports.fromVectorTileJs = _i, nr.exports.fromGeojsonVt = function(Hi, en) {
          en = en || {};
          var qn = {};
          for (var _n in Hi)
            qn[_n] = new ai(Hi[_n].features, en), qn[_n].name = _n, qn[_n].version = en.version, qn[_n].extent = en.extent;
          return _i({ layers: qn });
        }, nr.exports.GeoJSONWrapper = ai, nr.exports;
      }(), ur = ne.e8(Pe);
      const Pr = { minZoom: 0, maxZoom: 16, minPoints: 2, radius: 40, extent: 512, nodeSize: 64, log: !1, generateId: !1, reduce: null, map: (kn) => kn }, Hr = Math.fround || (vi = new Float32Array(1), (kn) => (vi[0] = +kn, vi[0]));
      var vi;
      const Ti = 3, wi = 5, ii = 6;
      class mi {
        constructor(ai) {
          this.options = Object.assign(Object.create(Pr), ai), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
        }
        load(ai) {
          const { log: _i, minZoom: Pi, maxZoom: Ai } = this.options;
          _i && console.time("total time");
          const ki = `prepare ${ai.length} points`;
          _i && console.time(ki), this.points = ai;
          const an = [];
          for (let Vi = 0; Vi < ai.length; Vi++) {
            const Sn = ai[Vi];
            if (!Sn.geometry)
              continue;
            const [Hi, en] = Sn.geometry.coordinates, qn = Hr(pi(Hi)), _n = Hr(hi(en));
            an.push(qn, _n, 1 / 0, Vi, -1, 1), this.options.reduce && an.push(0);
          }
          let Ui = this.trees[Ai + 1] = this._createTree(an);
          _i && console.timeEnd(ki);
          for (let Vi = Ai; Vi >= Pi; Vi--) {
            const Sn = +Date.now();
            Ui = this.trees[Vi] = this._createTree(this._cluster(Ui, Vi)), _i && console.log("z%d: %d clusters in %dms", Vi, Ui.numItems, +Date.now() - Sn);
          }
          return _i && console.timeEnd("total time"), this;
        }
        getClusters(ai, _i) {
          let Pi = ((ai[0] + 180) % 360 + 360) % 360 - 180;
          const Ai = Math.max(-90, Math.min(90, ai[1]));
          let ki = ai[2] === 180 ? 180 : ((ai[2] + 180) % 360 + 360) % 360 - 180;
          const an = Math.max(-90, Math.min(90, ai[3]));
          if (ai[2] - ai[0] >= 360)
            Pi = -180, ki = 180;
          else if (Pi > ki) {
            const en = this.getClusters([Pi, Ai, 180, an], _i), qn = this.getClusters([-180, Ai, ki, an], _i);
            return en.concat(qn);
          }
          const Ui = this.trees[this._limitZoom(_i)], Vi = Ui.range(pi(Pi), hi(an), pi(ki), hi(Ai)), Sn = Ui.data, Hi = [];
          for (const en of Vi) {
            const qn = this.stride * en;
            Hi.push(Sn[qn + wi] > 1 ? ei(Sn, qn, this.clusterProps) : this.points[Sn[qn + Ti]]);
          }
          return Hi;
        }
        getChildren(ai) {
          const _i = this._getOriginId(ai), Pi = this._getOriginZoom(ai), Ai = "No cluster with the specified id.", ki = this.trees[Pi];
          if (!ki)
            throw new Error(Ai);
          const an = ki.data;
          if (_i * this.stride >= an.length)
            throw new Error(Ai);
          const Ui = this.options.radius / (this.options.extent * Math.pow(2, Pi - 1)), Vi = ki.within(an[_i * this.stride], an[_i * this.stride + 1], Ui), Sn = [];
          for (const Hi of Vi) {
            const en = Hi * this.stride;
            an[en + 4] === ai && Sn.push(an[en + wi] > 1 ? ei(an, en, this.clusterProps) : this.points[an[en + Ti]]);
          }
          if (Sn.length === 0)
            throw new Error(Ai);
          return Sn;
        }
        getLeaves(ai, _i, Pi) {
          const Ai = [];
          return this._appendLeaves(Ai, ai, _i = _i || 10, Pi = Pi || 0, 0), Ai;
        }
        getTile(ai, _i, Pi) {
          const Ai = this.trees[this._limitZoom(ai)], ki = Math.pow(2, ai), { extent: an, radius: Ui } = this.options, Vi = Ui / an, Sn = (Pi - Vi) / ki, Hi = (Pi + 1 + Vi) / ki, en = { features: [] };
          return this._addTileFeatures(Ai.range((_i - Vi) / ki, Sn, (_i + 1 + Vi) / ki, Hi), Ai.data, _i, Pi, ki, en), _i === 0 && this._addTileFeatures(Ai.range(1 - Vi / ki, Sn, 1, Hi), Ai.data, ki, Pi, ki, en), _i === ki - 1 && this._addTileFeatures(Ai.range(0, Sn, Vi / ki, Hi), Ai.data, -1, Pi, ki, en), en.features.length ? en : null;
        }
        getClusterExpansionZoom(ai) {
          let _i = this._getOriginZoom(ai) - 1;
          for (; _i <= this.options.maxZoom; ) {
            const Pi = this.getChildren(ai);
            if (_i++, Pi.length !== 1)
              break;
            ai = Pi[0].properties.cluster_id;
          }
          return _i;
        }
        _appendLeaves(ai, _i, Pi, Ai, ki) {
          const an = this.getChildren(_i);
          for (const Ui of an) {
            const Vi = Ui.properties;
            if (Vi && Vi.cluster ? ki + Vi.point_count <= Ai ? ki += Vi.point_count : ki = this._appendLeaves(ai, Vi.cluster_id, Pi, Ai, ki) : ki < Ai ? ki++ : ai.push(Ui), ai.length === Pi)
              break;
          }
          return ki;
        }
        _createTree(ai) {
          const _i = new ne.bE(ai.length / this.stride | 0, this.options.nodeSize, Float32Array);
          for (let Pi = 0; Pi < ai.length; Pi += this.stride)
            _i.add(ai[Pi], ai[Pi + 1]);
          return _i.finish(), _i.data = ai, _i;
        }
        _addTileFeatures(ai, _i, Pi, Ai, ki, an) {
          for (const Ui of ai) {
            const Vi = Ui * this.stride, Sn = _i[Vi + wi] > 1;
            let Hi, en, qn;
            if (Sn)
              Hi = Zr(_i, Vi, this.clusterProps), en = _i[Vi], qn = _i[Vi + 1];
            else {
              const xo = this.points[_i[Vi + Ti]];
              Hi = xo.properties;
              const [Co, $o] = xo.geometry.coordinates;
              en = pi(Co), qn = hi($o);
            }
            const _n = { type: 1, geometry: [[Math.round(this.options.extent * (en * ki - Pi)), Math.round(this.options.extent * (qn * ki - Ai))]], tags: Hi };
            let Tn;
            Tn = Sn || this.options.generateId ? _i[Vi + Ti] : this.points[_i[Vi + Ti]].id, Tn !== void 0 && (_n.id = Tn), an.features.push(_n);
          }
        }
        _limitZoom(ai) {
          return Math.max(this.options.minZoom, Math.min(Math.floor(+ai), this.options.maxZoom + 1));
        }
        _cluster(ai, _i) {
          const { radius: Pi, extent: Ai, reduce: ki, minPoints: an } = this.options, Ui = Pi / (Ai * Math.pow(2, _i)), Vi = ai.data, Sn = [], Hi = this.stride;
          for (let en = 0; en < Vi.length; en += Hi) {
            if (Vi[en + 2] <= _i)
              continue;
            Vi[en + 2] = _i;
            const qn = Vi[en], _n = Vi[en + 1], Tn = ai.within(Vi[en], Vi[en + 1], Ui), xo = Vi[en + wi];
            let Co = xo;
            for (const $o of Tn) {
              const Bo = $o * Hi;
              Vi[Bo + 2] > _i && (Co += Vi[Bo + wi]);
            }
            if (Co > xo && Co >= an) {
              let $o, Bo = qn * xo, Qo = _n * xo, Go = -1;
              const No = (en / Hi << 5) + (_i + 1) + this.points.length;
              for (const Zo of Tn) {
                const ea = Zo * Hi;
                if (Vi[ea + 2] <= _i)
                  continue;
                Vi[ea + 2] = _i;
                const da = Vi[ea + wi];
                Bo += Vi[ea] * da, Qo += Vi[ea + 1] * da, Vi[ea + 4] = No, ki && ($o || ($o = this._map(Vi, en, !0), Go = this.clusterProps.length, this.clusterProps.push($o)), ki($o, this._map(Vi, ea)));
              }
              Vi[en + 4] = No, Sn.push(Bo / Co, Qo / Co, 1 / 0, No, -1, Co), ki && Sn.push(Go);
            } else {
              for (let $o = 0; $o < Hi; $o++)
                Sn.push(Vi[en + $o]);
              if (Co > 1)
                for (const $o of Tn) {
                  const Bo = $o * Hi;
                  if (!(Vi[Bo + 2] <= _i)) {
                    Vi[Bo + 2] = _i;
                    for (let Qo = 0; Qo < Hi; Qo++)
                      Sn.push(Vi[Bo + Qo]);
                  }
                }
            }
          }
          return Sn;
        }
        _getOriginId(ai) {
          return ai - this.points.length >> 5;
        }
        _getOriginZoom(ai) {
          return (ai - this.points.length) % 32;
        }
        _map(ai, _i, Pi) {
          if (ai[_i + wi] > 1) {
            const an = this.clusterProps[ai[_i + ii]];
            return Pi ? Object.assign({}, an) : an;
          }
          const Ai = this.points[ai[_i + Ti]].properties, ki = this.options.map(Ai);
          return Pi && ki === Ai ? Object.assign({}, ki) : ki;
        }
      }
      function ei(kn, ai, _i) {
        return { type: "Feature", id: kn[ai + Ti], properties: Zr(kn, ai, _i), geometry: { type: "Point", coordinates: [(Pi = kn[ai], 360 * (Pi - 0.5)), Oi(kn[ai + 1])] } };
        var Pi;
      }
      function Zr(kn, ai, _i) {
        const Pi = kn[ai + wi], Ai = Pi >= 1e4 ? `${Math.round(Pi / 1e3)}k` : Pi >= 1e3 ? Math.round(Pi / 100) / 10 + "k" : Pi, ki = kn[ai + ii], an = ki === -1 ? {} : Object.assign({}, _i[ki]);
        return Object.assign(an, { cluster: !0, cluster_id: kn[ai + Ti], point_count: Pi, point_count_abbreviated: Ai });
      }
      function pi(kn) {
        return kn / 360 + 0.5;
      }
      function hi(kn) {
        const ai = Math.sin(kn * Math.PI / 180), _i = 0.5 - 0.25 * Math.log((1 + ai) / (1 - ai)) / Math.PI;
        return _i < 0 ? 0 : _i > 1 ? 1 : _i;
      }
      function Oi(kn) {
        const ai = (180 - 360 * kn) * Math.PI / 180;
        return 360 * Math.atan(Math.exp(ai)) / Math.PI - 90;
      }
      function qi(kn, ai, _i, Pi) {
        let Ai = Pi;
        const ki = ai + (_i - ai >> 1);
        let an, Ui = _i - ai;
        const Vi = kn[ai], Sn = kn[ai + 1], Hi = kn[_i], en = kn[_i + 1];
        for (let qn = ai + 3; qn < _i; qn += 3) {
          const _n = yn(kn[qn], kn[qn + 1], Vi, Sn, Hi, en);
          if (_n > Ai)
            an = qn, Ai = _n;
          else if (_n === Ai) {
            const Tn = Math.abs(qn - ki);
            Tn < Ui && (an = qn, Ui = Tn);
          }
        }
        Ai > Pi && (an - ai > 3 && qi(kn, ai, an, Pi), kn[an + 2] = Ai, _i - an > 3 && qi(kn, an, _i, Pi));
      }
      function yn(kn, ai, _i, Pi, Ai, ki) {
        let an = Ai - _i, Ui = ki - Pi;
        if (an !== 0 || Ui !== 0) {
          const Vi = ((kn - _i) * an + (ai - Pi) * Ui) / (an * an + Ui * Ui);
          Vi > 1 ? (_i = Ai, Pi = ki) : Vi > 0 && (_i += an * Vi, Pi += Ui * Vi);
        }
        return an = kn - _i, Ui = ai - Pi, an * an + Ui * Ui;
      }
      function sn(kn, ai, _i, Pi) {
        const Ai = { id: kn ?? null, type: ai, geometry: _i, tags: Pi, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 };
        if (ai === "Point" || ai === "MultiPoint" || ai === "LineString")
          $n(Ai, _i);
        else if (ai === "Polygon")
          $n(Ai, _i[0]);
        else if (ai === "MultiLineString")
          for (const ki of _i)
            $n(Ai, ki);
        else if (ai === "MultiPolygon")
          for (const ki of _i)
            $n(Ai, ki[0]);
        return Ai;
      }
      function $n(kn, ai) {
        for (let _i = 0; _i < ai.length; _i += 3)
          kn.minX = Math.min(kn.minX, ai[_i]), kn.minY = Math.min(kn.minY, ai[_i + 1]), kn.maxX = Math.max(kn.maxX, ai[_i]), kn.maxY = Math.max(kn.maxY, ai[_i + 1]);
      }
      function rn(kn, ai, _i, Pi) {
        if (!ai.geometry)
          return;
        const Ai = ai.geometry.coordinates;
        if (Ai && Ai.length === 0)
          return;
        const ki = ai.geometry.type, an = Math.pow(_i.tolerance / ((1 << _i.maxZoom) * _i.extent), 2);
        let Ui = [], Vi = ai.id;
        if (_i.promoteId ? Vi = ai.properties[_i.promoteId] : _i.generateId && (Vi = Pi || 0), ki === "Point")
          ji(Ai, Ui);
        else if (ki === "MultiPoint")
          for (const Sn of Ai)
            ji(Sn, Ui);
        else if (ki === "LineString")
          Kn(Ai, Ui, an, !1);
        else if (ki === "MultiLineString") {
          if (_i.lineMetrics) {
            for (const Sn of Ai)
              Ui = [], Kn(Sn, Ui, an, !1), kn.push(sn(Vi, "LineString", Ui, ai.properties));
            return;
          }
          In(Ai, Ui, an, !1);
        } else if (ki === "Polygon")
          In(Ai, Ui, an, !0);
        else {
          if (ki !== "MultiPolygon") {
            if (ki === "GeometryCollection") {
              for (const Sn of ai.geometry.geometries)
                rn(kn, { id: Vi, geometry: Sn, properties: ai.properties }, _i, Pi);
              return;
            }
            throw new Error("Input data is not a valid GeoJSON object.");
          }
          for (const Sn of Ai) {
            const Hi = [];
            In(Sn, Hi, an, !0), Ui.push(Hi);
          }
        }
        kn.push(sn(Vi, ki, Ui, ai.properties));
      }
      function ji(kn, ai) {
        ai.push(Fn(kn[0]), Po(kn[1]), 0);
      }
      function Kn(kn, ai, _i, Pi) {
        let Ai, ki, an = 0;
        for (let Vi = 0; Vi < kn.length; Vi++) {
          const Sn = Fn(kn[Vi][0]), Hi = Po(kn[Vi][1]);
          ai.push(Sn, Hi, 0), Vi > 0 && (an += Pi ? (Ai * Hi - Sn * ki) / 2 : Math.sqrt(Math.pow(Sn - Ai, 2) + Math.pow(Hi - ki, 2))), Ai = Sn, ki = Hi;
        }
        const Ui = ai.length - 3;
        ai[2] = 1, qi(ai, 0, Ui, _i), ai[Ui + 2] = 1, ai.size = Math.abs(an), ai.start = 0, ai.end = ai.size;
      }
      function In(kn, ai, _i, Pi) {
        for (let Ai = 0; Ai < kn.length; Ai++) {
          const ki = [];
          Kn(kn[Ai], ki, _i, Pi), ai.push(ki);
        }
      }
      function Fn(kn) {
        return kn / 360 + 0.5;
      }
      function Po(kn) {
        const ai = Math.sin(kn * Math.PI / 180), _i = 0.5 - 0.25 * Math.log((1 + ai) / (1 - ai)) / Math.PI;
        return _i < 0 ? 0 : _i > 1 ? 1 : _i;
      }
      function vn(kn, ai, _i, Pi, Ai, ki, an, Ui) {
        if (Pi /= ai, ki >= (_i /= ai) && an < Pi)
          return kn;
        if (an < _i || ki >= Pi)
          return null;
        const Vi = [];
        for (const Sn of kn) {
          const Hi = Sn.geometry;
          let en = Sn.type;
          const qn = Ai === 0 ? Sn.minX : Sn.minY, _n = Ai === 0 ? Sn.maxX : Sn.maxY;
          if (qn >= _i && _n < Pi) {
            Vi.push(Sn);
            continue;
          }
          if (_n < _i || qn >= Pi)
            continue;
          let Tn = [];
          if (en === "Point" || en === "MultiPoint")
            Vn(Hi, Tn, _i, Pi, Ai);
          else if (en === "LineString")
            Xo(Hi, Tn, _i, Pi, Ai, !1, Ui.lineMetrics);
          else if (en === "MultiLineString")
            Yn(Hi, Tn, _i, Pi, Ai, !1);
          else if (en === "Polygon")
            Yn(Hi, Tn, _i, Pi, Ai, !0);
          else if (en === "MultiPolygon")
            for (const xo of Hi) {
              const Co = [];
              Yn(xo, Co, _i, Pi, Ai, !0), Co.length && Tn.push(Co);
            }
          if (Tn.length) {
            if (Ui.lineMetrics && en === "LineString") {
              for (const xo of Tn)
                Vi.push(sn(Sn.id, en, xo, Sn.tags));
              continue;
            }
            en !== "LineString" && en !== "MultiLineString" || (Tn.length === 1 ? (en = "LineString", Tn = Tn[0]) : en = "MultiLineString"), en !== "Point" && en !== "MultiPoint" || (en = Tn.length === 3 ? "Point" : "MultiPoint"), Vi.push(sn(Sn.id, en, Tn, Sn.tags));
          }
        }
        return Vi.length ? Vi : null;
      }
      function Vn(kn, ai, _i, Pi, Ai) {
        for (let ki = 0; ki < kn.length; ki += 3) {
          const an = kn[ki + Ai];
          an >= _i && an <= Pi && Wo(ai, kn[ki], kn[ki + 1], kn[ki + 2]);
        }
      }
      function Xo(kn, ai, _i, Pi, Ai, ki, an) {
        let Ui = Xn(kn);
        const Vi = Ai === 0 ? Ci : ri;
        let Sn, Hi, en = kn.start;
        for (let Co = 0; Co < kn.length - 3; Co += 3) {
          const $o = kn[Co], Bo = kn[Co + 1], Qo = kn[Co + 2], Go = kn[Co + 3], No = kn[Co + 4], Zo = Ai === 0 ? $o : Bo, ea = Ai === 0 ? Go : No;
          let da = !1;
          an && (Sn = Math.sqrt(Math.pow($o - Go, 2) + Math.pow(Bo - No, 2))), Zo < _i ? ea > _i && (Hi = Vi(Ui, $o, Bo, Go, No, _i), an && (Ui.start = en + Sn * Hi)) : Zo > Pi ? ea < Pi && (Hi = Vi(Ui, $o, Bo, Go, No, Pi), an && (Ui.start = en + Sn * Hi)) : Wo(Ui, $o, Bo, Qo), ea < _i && Zo >= _i && (Hi = Vi(Ui, $o, Bo, Go, No, _i), da = !0), ea > Pi && Zo <= Pi && (Hi = Vi(Ui, $o, Bo, Go, No, Pi), da = !0), !ki && da && (an && (Ui.end = en + Sn * Hi), ai.push(Ui), Ui = Xn(kn)), an && (en += Sn);
        }
        let qn = kn.length - 3;
        const _n = kn[qn], Tn = kn[qn + 1], xo = Ai === 0 ? _n : Tn;
        xo >= _i && xo <= Pi && Wo(Ui, _n, Tn, kn[qn + 2]), qn = Ui.length - 3, ki && qn >= 3 && (Ui[qn] !== Ui[0] || Ui[qn + 1] !== Ui[1]) && Wo(Ui, Ui[0], Ui[1], Ui[2]), Ui.length && ai.push(Ui);
      }
      function Xn(kn) {
        const ai = [];
        return ai.size = kn.size, ai.start = kn.start, ai.end = kn.end, ai;
      }
      function Yn(kn, ai, _i, Pi, Ai, ki) {
        for (const an of kn)
          Xo(an, ai, _i, Pi, Ai, ki, !1);
      }
      function Wo(kn, ai, _i, Pi) {
        kn.push(ai, _i, Pi);
      }
      function Ci(kn, ai, _i, Pi, Ai, ki) {
        const an = (ki - ai) / (Pi - ai);
        return Wo(kn, ki, _i + (Ai - _i) * an, 1), an;
      }
      function ri(kn, ai, _i, Pi, Ai, ki) {
        const an = (ki - _i) / (Ai - _i);
        return Wo(kn, ai + (Pi - ai) * an, ki, 1), an;
      }
      function yi(kn, ai) {
        const _i = [];
        for (let Pi = 0; Pi < kn.length; Pi++) {
          const Ai = kn[Pi], ki = Ai.type;
          let an;
          if (ki === "Point" || ki === "MultiPoint" || ki === "LineString")
            an = Li(Ai.geometry, ai);
          else if (ki === "MultiLineString" || ki === "Polygon") {
            an = [];
            for (const Ui of Ai.geometry)
              an.push(Li(Ui, ai));
          } else if (ki === "MultiPolygon") {
            an = [];
            for (const Ui of Ai.geometry) {
              const Vi = [];
              for (const Sn of Ui)
                Vi.push(Li(Sn, ai));
              an.push(Vi);
            }
          }
          _i.push(sn(Ai.id, ki, an, Ai.tags));
        }
        return _i;
      }
      function Li(kn, ai) {
        const _i = [];
        _i.size = kn.size, kn.start !== void 0 && (_i.start = kn.start, _i.end = kn.end);
        for (let Pi = 0; Pi < kn.length; Pi += 3)
          _i.push(kn[Pi] + ai, kn[Pi + 1], kn[Pi + 2]);
        return _i;
      }
      function Yi(kn, ai) {
        if (kn.transformed)
          return kn;
        const _i = 1 << kn.z, Pi = kn.x, Ai = kn.y;
        for (const ki of kn.features) {
          const an = ki.geometry, Ui = ki.type;
          if (ki.geometry = [], Ui === 1)
            for (let Vi = 0; Vi < an.length; Vi += 2)
              ki.geometry.push(zn(an[Vi], an[Vi + 1], ai, _i, Pi, Ai));
          else
            for (let Vi = 0; Vi < an.length; Vi++) {
              const Sn = [];
              for (let Hi = 0; Hi < an[Vi].length; Hi += 2)
                Sn.push(zn(an[Vi][Hi], an[Vi][Hi + 1], ai, _i, Pi, Ai));
              ki.geometry.push(Sn);
            }
        }
        return kn.transformed = !0, kn;
      }
      function zn(kn, ai, _i, Pi, Ai, ki) {
        return [Math.round(_i * (kn * Pi - Ai)), Math.round(_i * (ai * Pi - ki))];
      }
      function un(kn, ai, _i, Pi, Ai) {
        const ki = ai === Ai.maxZoom ? 0 : Ai.tolerance / ((1 << ai) * Ai.extent), an = { features: [], numPoints: 0, numSimplified: 0, numFeatures: kn.length, source: null, x: _i, y: Pi, z: ai, transformed: !1, minX: 2, minY: 1, maxX: -1, maxY: 0 };
        for (const Ui of kn)
          Gn(an, Ui, ki, Ai);
        return an;
      }
      function Gn(kn, ai, _i, Pi) {
        const Ai = ai.geometry, ki = ai.type, an = [];
        if (kn.minX = Math.min(kn.minX, ai.minX), kn.minY = Math.min(kn.minY, ai.minY), kn.maxX = Math.max(kn.maxX, ai.maxX), kn.maxY = Math.max(kn.maxY, ai.maxY), ki === "Point" || ki === "MultiPoint")
          for (let Ui = 0; Ui < Ai.length; Ui += 3)
            an.push(Ai[Ui], Ai[Ui + 1]), kn.numPoints++, kn.numSimplified++;
        else if (ki === "LineString")
          Mn(an, Ai, kn, _i, !1, !1);
        else if (ki === "MultiLineString" || ki === "Polygon")
          for (let Ui = 0; Ui < Ai.length; Ui++)
            Mn(an, Ai[Ui], kn, _i, ki === "Polygon", Ui === 0);
        else if (ki === "MultiPolygon")
          for (let Ui = 0; Ui < Ai.length; Ui++) {
            const Vi = Ai[Ui];
            for (let Sn = 0; Sn < Vi.length; Sn++)
              Mn(an, Vi[Sn], kn, _i, !0, Sn === 0);
          }
        if (an.length) {
          let Ui = ai.tags || null;
          if (ki === "LineString" && Pi.lineMetrics) {
            Ui = {};
            for (const Sn in ai.tags)
              Ui[Sn] = ai.tags[Sn];
            Ui.mapbox_clip_start = Ai.start / Ai.size, Ui.mapbox_clip_end = Ai.end / Ai.size;
          }
          const Vi = { geometry: an, type: ki === "Polygon" || ki === "MultiPolygon" ? 3 : ki === "LineString" || ki === "MultiLineString" ? 2 : 1, tags: Ui };
          ai.id !== null && (Vi.id = ai.id), kn.features.push(Vi);
        }
      }
      function Mn(kn, ai, _i, Pi, Ai, ki) {
        const an = Pi * Pi;
        if (Pi > 0 && ai.size < (Ai ? an : Pi))
          return void (_i.numPoints += ai.length / 3);
        const Ui = [];
        for (let Vi = 0; Vi < ai.length; Vi += 3)
          (Pi === 0 || ai[Vi + 2] > an) && (_i.numSimplified++, Ui.push(ai[Vi], ai[Vi + 1])), _i.numPoints++;
        Ai && function(Vi, Sn) {
          let Hi = 0;
          for (let en = 0, qn = Vi.length, _n = qn - 2; en < qn; _n = en, en += 2)
            Hi += (Vi[en] - Vi[_n]) * (Vi[en + 1] + Vi[_n + 1]);
          if (Hi > 0 === Sn)
            for (let en = 0, qn = Vi.length; en < qn / 2; en += 2) {
              const _n = Vi[en], Tn = Vi[en + 1];
              Vi[en] = Vi[qn - 2 - en], Vi[en + 1] = Vi[qn - 1 - en], Vi[qn - 2 - en] = _n, Vi[qn - 1 - en] = Tn;
            }
        }(Ui, ki), kn.push(Ui);
      }
      const pn = { maxZoom: 14, indexMaxZoom: 5, indexMaxPoints: 1e5, tolerance: 3, extent: 4096, buffer: 64, lineMetrics: !1, promoteId: null, generateId: !1, debug: 0 };
      class Rn {
        constructor(ai, _i) {
          const Pi = (_i = this.options = function(ki, an) {
            for (const Ui in an)
              ki[Ui] = an[Ui];
            return ki;
          }(Object.create(pn), _i)).debug;
          if (Pi && console.time("preprocess data"), _i.maxZoom < 0 || _i.maxZoom > 24)
            throw new Error("maxZoom should be in the 0-24 range");
          if (_i.promoteId && _i.generateId)
            throw new Error("promoteId and generateId cannot be used together.");
          let Ai = function(ki, an) {
            const Ui = [];
            if (ki.type === "FeatureCollection")
              for (let Vi = 0; Vi < ki.features.length; Vi++)
                rn(Ui, ki.features[Vi], an, Vi);
            else
              rn(Ui, ki.type === "Feature" ? ki : { geometry: ki }, an);
            return Ui;
          }(ai, _i);
          this.tiles = {}, this.tileCoords = [], Pi && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", _i.indexMaxZoom, _i.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), Ai = function(ki, an) {
            const Ui = an.buffer / an.extent;
            let Vi = ki;
            const Sn = vn(ki, 1, -1 - Ui, Ui, 0, -1, 2, an), Hi = vn(ki, 1, 1 - Ui, 2 + Ui, 0, -1, 2, an);
            return (Sn || Hi) && (Vi = vn(ki, 1, -Ui, 1 + Ui, 0, -1, 2, an) || [], Sn && (Vi = yi(Sn, 1).concat(Vi)), Hi && (Vi = Vi.concat(yi(Hi, -1)))), Vi;
          }(Ai, _i), Ai.length && this.splitTile(Ai, 0, 0, 0), Pi && (Ai.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
        }
        splitTile(ai, _i, Pi, Ai, ki, an, Ui) {
          const Vi = [ai, _i, Pi, Ai], Sn = this.options, Hi = Sn.debug;
          for (; Vi.length; ) {
            Ai = Vi.pop(), Pi = Vi.pop(), _i = Vi.pop(), ai = Vi.pop();
            const en = 1 << _i, qn = Io(_i, Pi, Ai);
            let _n = this.tiles[qn];
            if (!_n && (Hi > 1 && console.time("creation"), _n = this.tiles[qn] = un(ai, _i, Pi, Ai, Sn), this.tileCoords.push({ z: _i, x: Pi, y: Ai }), Hi)) {
              Hi > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", _i, Pi, Ai, _n.numFeatures, _n.numPoints, _n.numSimplified), console.timeEnd("creation"));
              const da = `z${_i}`;
              this.stats[da] = (this.stats[da] || 0) + 1, this.total++;
            }
            if (_n.source = ai, ki == null) {
              if (_i === Sn.indexMaxZoom || _n.numPoints <= Sn.indexMaxPoints)
                continue;
            } else {
              if (_i === Sn.maxZoom || _i === ki)
                continue;
              if (ki != null) {
                const da = ki - _i;
                if (Pi !== an >> da || Ai !== Ui >> da)
                  continue;
              }
            }
            if (_n.source = null, ai.length === 0)
              continue;
            Hi > 1 && console.time("clipping");
            const Tn = 0.5 * Sn.buffer / Sn.extent, xo = 0.5 - Tn, Co = 0.5 + Tn, $o = 1 + Tn;
            let Bo = null, Qo = null, Go = null, No = null, Zo = vn(ai, en, Pi - Tn, Pi + Co, 0, _n.minX, _n.maxX, Sn), ea = vn(ai, en, Pi + xo, Pi + $o, 0, _n.minX, _n.maxX, Sn);
            ai = null, Zo && (Bo = vn(Zo, en, Ai - Tn, Ai + Co, 1, _n.minY, _n.maxY, Sn), Qo = vn(Zo, en, Ai + xo, Ai + $o, 1, _n.minY, _n.maxY, Sn), Zo = null), ea && (Go = vn(ea, en, Ai - Tn, Ai + Co, 1, _n.minY, _n.maxY, Sn), No = vn(ea, en, Ai + xo, Ai + $o, 1, _n.minY, _n.maxY, Sn), ea = null), Hi > 1 && console.timeEnd("clipping"), Vi.push(Bo || [], _i + 1, 2 * Pi, 2 * Ai), Vi.push(Qo || [], _i + 1, 2 * Pi, 2 * Ai + 1), Vi.push(Go || [], _i + 1, 2 * Pi + 1, 2 * Ai), Vi.push(No || [], _i + 1, 2 * Pi + 1, 2 * Ai + 1);
          }
        }
        getTile(ai, _i, Pi) {
          ai = +ai, _i = +_i, Pi = +Pi;
          const Ai = this.options, { extent: ki, debug: an } = Ai;
          if (ai < 0 || ai > 24)
            return null;
          const Ui = 1 << ai, Vi = Io(ai, _i = _i + Ui & Ui - 1, Pi);
          if (this.tiles[Vi])
            return Yi(this.tiles[Vi], ki);
          an > 1 && console.log("drilling down to z%d-%d-%d", ai, _i, Pi);
          let Sn, Hi = ai, en = _i, qn = Pi;
          for (; !Sn && Hi > 0; )
            Hi--, en >>= 1, qn >>= 1, Sn = this.tiles[Io(Hi, en, qn)];
          return Sn && Sn.source ? (an > 1 && (console.log("found parent tile z%d-%d-%d", Hi, en, qn), console.time("drilling down")), this.splitTile(Sn.source, Hi, en, qn, ai, _i, Pi), an > 1 && console.timeEnd("drilling down"), this.tiles[Vi] ? Yi(this.tiles[Vi], ki) : null) : null;
        }
      }
      function Io(kn, ai, _i) {
        return 32 * ((1 << kn) * _i + ai) + kn;
      }
      function to(kn, ai) {
        const _i = kn.tileID.canonical;
        if (!this._geoJSONIndex)
          return void ai(null, null);
        const Pi = this._geoJSONIndex.getTile(_i.z, _i.x, _i.y);
        if (!Pi)
          return void ai(null, null);
        const Ai = new si(Pi.features);
        let ki = ur(Ai);
        ki.byteOffset === 0 && ki.byteLength === ki.buffer.byteLength || (ki = new Uint8Array(ki)), ai(null, { vectorTile: Ai, rawData: ki.buffer });
      }
      class no extends Nr {
        constructor(ai, _i, Pi, Ai, ki, an) {
          super(ai, _i, Pi, Ai, to, an), ki && (this.loadGeoJSON = ki), this._dynamicIndex = new di();
        }
        loadData(ai, _i) {
          const Pi = ai && ai.request, Ai = Pi && Pi.collectResourceTiming;
          this.loadGeoJSON(ai, (ki, an) => {
            if (ki || !an)
              return _i(ki);
            if (typeof an != "object")
              return _i(new Error(`Input data given to '${ai.source}' is not a valid GeoJSON object.`));
            {
              try {
                if (ai.filter) {
                  const Vi = ne.U(ai.filter, { type: "boolean", "property-type": "data-driven", overridable: !1, transition: !1 });
                  if (Vi.result === "error")
                    throw new Error(Vi.value.map((Sn) => `${Sn.key}: ${Sn.message}`).join(", "));
                  an.features = an.features.filter((Sn) => Vi.value.evaluate({ zoom: 0 }, Sn));
                }
                ai.dynamic ? (an.type === "Feature" && (an = { type: "FeatureCollection", features: [an] }), ai.append || (this._dynamicIndex.clear(), this.loaded = {}), this._dynamicIndex.load(an.features, this.loaded), ai.cluster && (an.features = this._dynamicIndex.getFeatures())) : this.loaded = {}, this._geoJSONIndex = ai.cluster ? new mi(function({ superclusterOptions: Vi, clusterProperties: Sn }) {
                  if (!Sn || !Vi)
                    return Vi;
                  const Hi = {}, en = {}, qn = { accumulated: null, zoom: 0 }, _n = { properties: null }, Tn = Object.keys(Sn);
                  for (const xo of Tn) {
                    const [Co, $o] = Sn[xo], Bo = ne.U($o), Qo = ne.U(typeof Co == "string" ? [Co, ["accumulated"], ["get", xo]] : Co);
                    Hi[xo] = Bo.value, en[xo] = Qo.value;
                  }
                  return Vi.map = (xo) => {
                    _n.properties = xo;
                    const Co = {};
                    for (const $o of Tn)
                      Co[$o] = Hi[$o].evaluate(qn, _n);
                    return Co;
                  }, Vi.reduce = (xo, Co) => {
                    _n.properties = Co;
                    for (const $o of Tn)
                      qn.accumulated = xo[$o], xo[$o] = en[$o].evaluate(qn, _n);
                  }, Vi;
                }(ai)).load(an.features) : ai.dynamic ? this._dynamicIndex : function(Vi, Sn) {
                  return new Rn(Vi, Sn);
                }(an, ai.geojsonVtOptions);
              } catch (Vi) {
                return _i(Vi);
              }
              const Ui = {};
              if (Ai) {
                const Vi = rr(Pi);
                Vi && (Ui.resourceTiming = {}, Ui.resourceTiming[ai.source] = JSON.parse(JSON.stringify(Vi)));
              }
              _i(null, Ui);
            }
          });
        }
        reloadTile(ai, _i) {
          const Pi = this.loaded;
          return Pi && Pi[ai.uid] ? ai.partial ? _i(null, void 0) : super.reloadTile(ai, _i) : this.loadTile(ai, _i);
        }
        loadGeoJSON(ai, _i) {
          if (ai.request)
            ne.n(ai.request, _i);
          else {
            if (typeof ai.data != "string")
              return _i(new Error(`Input data given to '${ai.source}' is not a valid GeoJSON object.`));
            try {
              return _i(null, JSON.parse(ai.data));
            } catch {
              return _i(new Error(`Input data given to '${ai.source}' is not a valid GeoJSON object.`));
            }
          }
        }
        getClusterExpansionZoom(ai, _i) {
          try {
            _i(null, this._geoJSONIndex.getClusterExpansionZoom(ai.clusterId));
          } catch (Pi) {
            _i(Pi);
          }
        }
        getClusterChildren(ai, _i) {
          try {
            _i(null, this._geoJSONIndex.getChildren(ai.clusterId));
          } catch (Pi) {
            _i(Pi);
          }
        }
        getClusterLeaves(ai, _i) {
          try {
            _i(null, this._geoJSONIndex.getLeaves(ai.clusterId, ai.limit, ai.offset));
          } catch (Pi) {
            _i(Pi);
          }
        }
      }
      class ma {
        constructor(ai, _i) {
          this.tileID = new ne.aG(ai.tileID.overscaledZ, ai.tileID.wrap, ai.tileID.canonical.z, ai.tileID.canonical.x, ai.tileID.canonical.y), this.tileZoom = ai.tileZoom, this.uid = ai.uid, this.zoom = ai.zoom, this.canonical = ai.tileID.canonical, this.pixelRatio = ai.pixelRatio, this.tileSize = ai.tileSize, this.source = ai.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = ai.projection, this.brightness = _i;
        }
        parse(ai, _i, Pi, Ai) {
          this.status = "parsing";
          const ki = new ne.aG(Pi.tileID.overscaledZ, Pi.tileID.wrap, Pi.tileID.canonical.z, Pi.tileID.canonical.x, Pi.tileID.canonical.y), an = [], Ui = _i.familiesBySource[Pi.source], Vi = new ne.dZ(ki, Pi.promoteId);
          return Vi.bucketLayerIDs = [], Vi.is3DTile = !0, ne.e9(ai).then((Sn) => {
            if (!Sn)
              return Ai(new Error("Could not parse tile"));
            const Hi = ne.ea(Sn, 1 / ne.cc(Pi.tileID.canonical)), en = Sn.json.extensionsUsed && Sn.json.extensionsUsed.includes("MAPBOX_mesh_features") || Sn.json.asset.extras && Sn.json.asset.extras.MAPBOX_mesh_features, qn = Sn.json.extensionsUsed && Sn.json.extensionsUsed.includes("EXT_meshopt_compression"), _n = new ne.a8(this.zoom, { brightness: this.brightness });
            for (const Tn in Ui)
              for (const xo of Ui[Tn]) {
                const Co = xo[0];
                Vi.bucketLayerIDs.push(xo.map((Bo) => ne.aC(Bo.id, Bo.scope))), Co.recalculate(_n, []);
                const $o = new ne.eb(xo, Hi, ki, en, qn, this.brightness, Vi);
                en || ($o.needsUpload = !0), an.push($o), $o.evaluate(Co);
              }
            this.status = "done", Ai(null, { buckets: an, featureIndex: Vi, collisionBoxArray: null, glyphAtlasImage: null, lineAtlas: null, imageAtlas: null, brightness: null });
          }).catch((Sn) => Ai(new Error(Sn.message)));
        }
      }
      class Qn {
        constructor(ai, _i, Pi, Ai, ki, an) {
          this.actor = ai, this.layerIndex = _i, this.availableImages = Pi, this.brightness = an, this.loading = {}, this.loaded = {};
        }
        loadTile(ai, _i) {
          const Pi = ai.uid, Ai = this.loading[Pi] = new ma(ai, this.brightness);
          ne.bi(ai.request, (ki, an) => {
            const Ui = !this.loading[Pi];
            return delete this.loading[Pi], Ui || ki ? (Ai.status = "done", Ui || (this.loaded[Pi] = Ai), _i(ki)) : an && an.byteLength !== 0 ? void Ai.parse(an, this.layerIndex, ai, (Vi, Sn) => {
              Ai.status = "done", this.loaded = this.loaded || {}, this.loaded[Pi] = Ai, Vi || !Sn ? _i(Vi) : _i(null, Sn);
            }) : (Ai.status = "done", this.loaded[Pi] = Ai, _i());
          });
        }
        reloadTile(ai, _i) {
          const Pi = this.loaded, Ai = ai.uid;
          if (Pi && Pi[Ai]) {
            const ki = Pi[Ai];
            ki.projection = ai.projection, ki.brightness = ai.brightness;
            const an = (Ui, Vi) => {
              ki.reloadCallback && (delete ki.reloadCallback, this.loadTile(ai, _i)), _i(Ui, Vi);
            };
            ki.status === "parsing" ? ki.reloadCallback = an : ki.status === "done" && this.loadTile(ai, _i);
          }
        }
        abortTile(ai, _i) {
          const Pi = ai.uid;
          this.loading[Pi] && delete this.loading[Pi], _i();
        }
        removeTile(ai, _i) {
          const Pi = this.loaded, Ai = ai.uid;
          Pi && Pi[Ai] && delete Pi[Ai], _i();
        }
      }
      class co {
        constructor(ai) {
          this.self = ai, this.actor = new ne.ec(ai, this), this.layerIndexes = {}, this.availableImages = {}, this.isSpriteLoaded = {}, this.imageRasterizer = new ne.I(), this.projections = {}, this.defaultProjection = ne.bP({ name: "mercator" }), this.workerSourceTypes = { vector: Nr, geojson: no, "batched-model": Qn }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (_i, Pi) => {
            if (this.workerSourceTypes[_i])
              throw new Error(`Worker source with name "${_i}" already registered.`);
            this.workerSourceTypes[_i] = Pi;
          }, this.self.registerRTLTextPlugin = (_i) => {
            if (ne.ed.isParsed())
              throw new Error("RTL text plugin already registered.");
            ne.ed.applyArabicShaping = _i.applyArabicShaping, ne.ed.processBidirectionalText = _i.processBidirectionalText, ne.ed.processStyledBidirectionalText = _i.processStyledBidirectionalText;
          };
        }
        clearCaches(ai, _i, Pi) {
          delete this.layerIndexes[ai], delete this.availableImages[ai], delete this.workerSources[ai], delete this.demWorkerSources[ai], delete this.rasterArrayWorkerSource, Pi();
        }
        checkIfReady(ai, _i, Pi) {
          Pi();
        }
        setReferrer(ai, _i) {
          this.referrer = _i;
        }
        spriteLoaded(ai, { scope: _i, isLoaded: Pi }) {
          if (this.isSpriteLoaded[ai] || (this.isSpriteLoaded[ai] = {}), this.isSpriteLoaded[ai][_i] = Pi, this.workerSources[ai] && this.workerSources[ai][_i])
            for (const Ai in this.workerSources[ai][_i]) {
              const ki = this.workerSources[ai][_i][Ai];
              for (const an in ki) {
                const Ui = ki[an];
                Ui instanceof Nr && (Ui.isSpriteLoaded = Pi, Ui.fire(new ne.z("isSpriteLoaded")));
              }
            }
        }
        setImages(ai, { scope: _i, images: Pi }, Ai) {
          if (this.availableImages[ai] || (this.availableImages[ai] = {}), this.availableImages[ai][_i] = Pi, this.workerSources[ai] && this.workerSources[ai][_i]) {
            for (const ki in this.workerSources[ai][_i]) {
              const an = this.workerSources[ai][_i][ki];
              for (const Ui in an)
                an[Ui].availableImages = Pi;
            }
            Ai();
          } else
            Ai();
        }
        setProjection(ai, _i) {
          this.projections[ai] = ne.bP(_i);
        }
        setBrightness(ai, _i, Pi) {
          this.brightness = _i, Pi();
        }
        setLayers(ai, _i, Pi) {
          this.getLayerIndex(ai, _i.scope).replace(_i.layers, _i.options), Pi();
        }
        updateLayers(ai, _i, Pi) {
          this.getLayerIndex(ai, _i.scope).update(_i.layers, _i.removedIds, _i.options), Pi();
        }
        loadTile(ai, _i, Pi) {
          _i.projection = this.projections[ai] || this.defaultProjection, this.getWorkerSource(ai, _i.type, _i.source, _i.scope).loadTile(_i, Pi);
        }
        loadDEMTile(ai, _i, Pi) {
          this.getDEMWorkerSource(ai, _i.source, _i.scope).loadTile(_i, Pi);
        }
        decodeRasterArray(ai, _i, Pi) {
          this.getRasterArrayWorkerSource().decodeRasterArray(_i, Pi);
        }
        reloadTile(ai, _i, Pi) {
          _i.projection = this.projections[ai] || this.defaultProjection, this.getWorkerSource(ai, _i.type, _i.source, _i.scope).reloadTile(_i, Pi);
        }
        abortTile(ai, _i, Pi) {
          this.getWorkerSource(ai, _i.type, _i.source, _i.scope).abortTile(_i, Pi);
        }
        removeTile(ai, _i, Pi) {
          this.getWorkerSource(ai, _i.type, _i.source, _i.scope).removeTile(_i, Pi);
        }
        removeSource(ai, _i, Pi) {
          if (!(this.workerSources[ai] && this.workerSources[ai][_i.scope] && this.workerSources[ai][_i.scope][_i.type] && this.workerSources[ai][_i.scope][_i.type][_i.source]))
            return;
          const Ai = this.workerSources[ai][_i.scope][_i.type][_i.source];
          delete this.workerSources[ai][_i.scope][_i.type][_i.source], Ai.removeSource !== void 0 ? Ai.removeSource(_i, Pi) : Pi();
        }
        loadWorkerSource(ai, _i, Pi) {
          try {
            this.self.importScripts(_i.url), Pi();
          } catch (Ai) {
            Pi(Ai.toString());
          }
        }
        syncRTLPluginState(ai, _i, Pi) {
          try {
            ne.ed.setState(_i);
            const Ai = ne.ed.getPluginURL();
            if (ne.ed.isLoaded() && !ne.ed.isParsed() && Ai != null) {
              this.self.importScripts(Ai);
              const ki = ne.ed.isParsed();
              Pi(ki ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${Ai}`), ki);
            }
          } catch (Ai) {
            Pi(Ai.toString());
          }
        }
        setDracoUrl(ai, _i) {
          this.dracoUrl = _i;
        }
        getAvailableImages(ai, _i) {
          this.availableImages[ai] || (this.availableImages[ai] = {});
          let Pi = this.availableImages[ai][_i];
          return Pi || (Pi = []), Pi;
        }
        getLayerIndex(ai, _i) {
          this.layerIndexes[ai] || (this.layerIndexes[ai] = {});
          let Pi = this.layerIndexes[ai][_i];
          return Pi || (Pi = this.layerIndexes[ai][_i] = new _r(), Pi.scope = _i), Pi;
        }
        getWorkerSource(ai, _i, Pi, Ai) {
          return this.workerSources[ai] || (this.workerSources[ai] = {}), this.workerSources[ai][Ai] || (this.workerSources[ai][Ai] = {}), this.workerSources[ai][Ai][_i] || (this.workerSources[ai][Ai][_i] = {}), this.isSpriteLoaded[ai] || (this.isSpriteLoaded[ai] = {}), this.workerSources[ai][Ai][_i][Pi] || (this.workerSources[ai][Ai][_i][Pi] = new this.workerSourceTypes[_i]({ send: (ki, an, Ui, Vi, Sn, Hi) => {
            this.actor.send(ki, an, Ui, ai, Sn, Hi);
          }, scheduler: this.actor.scheduler }, this.getLayerIndex(ai, Ai), this.getAvailableImages(ai, Ai), this.isSpriteLoaded[ai][Ai], void 0, this.brightness)), this.workerSources[ai][Ai][_i][Pi];
        }
        rasterizeImages(ai, _i, Pi) {
          const { imageTasks: Ai, scope: ki } = _i, an = {};
          for (const Ui in Ai) {
            const { image: Vi, imageIdWithOptions: Sn } = Ai[Ui];
            an[Ui] = this.imageRasterizer.rasterize(Sn, Vi, ki, ai);
          }
          Pi(void 0, an);
        }
        removeRasterizedImages(ai, _i, Pi) {
          const { imageIds: Ai, scope: ki } = _i;
          this.imageRasterizer.removeImagesFromCacheByIds(Ai, ki, ai), Pi();
        }
        getDEMWorkerSource(ai, _i, Pi) {
          return this.demWorkerSources[ai] || (this.demWorkerSources[ai] = {}), this.demWorkerSources[ai][Pi] || (this.demWorkerSources[ai][Pi] = {}), this.demWorkerSources[ai][Pi][_i] || (this.demWorkerSources[ai][Pi][_i] = new Yr()), this.demWorkerSources[ai][Pi][_i];
        }
        getRasterArrayWorkerSource() {
          return this.rasterArrayWorkerSource || (this.rasterArrayWorkerSource = new Vr()), this.rasterArrayWorkerSource;
        }
        enforceCacheSizeLimit(ai, _i) {
          ne.ee(_i);
        }
        getWorkerPerformanceMetrics(ai, _i, Pi) {
          Pi(void 0, void 0);
        }
      }
      return typeof WorkerGlobalScope < "u" && typeof self < "u" && self instanceof WorkerGlobalScope && (self.worker = new co(self)), co;
    }), Me(["./shared"], function(ne) {
      var rr = "3.9.3";
      const gr = { create: "create", load: "load", fullLoad: "fullLoad" }, or = { mark(qe) {
        performance.mark(qe);
      }, measure(qe, xe, ke) {
        performance.measure(qe, xe, ke);
      } };
      function _r(qe) {
        const xe = qe.name.split("?")[0];
        return ne.a(xe) && xe.includes("mapbox-gl.js") ? "javascript" : ne.a(xe) && xe.includes("mapbox-gl.css") ? "css" : ne.b(xe) ? "fontRange" : ne.c(xe) ? "sprite" : ne.i(xe) ? "style" : ne.d(xe) ? "tilejson" : "other";
      }
      var Lr, Ir = {}, Ar = function() {
        if (Lr)
          return Ir;
        function qe(He) {
          return !xe(He);
        }
        function xe(He) {
          return typeof window > "u" || typeof document > "u" ? "not a browser" : function() {
            if (!("Worker" in window && "Blob" in window && "URL" in window))
              return !1;
            var ar, yr, Tr = new Blob([""], { type: "text/javascript" }), $r = URL.createObjectURL(Tr);
            try {
              yr = new Worker($r), ar = !0;
            } catch {
              ar = !1;
            }
            return yr && yr.terminate(), URL.revokeObjectURL($r), ar;
          }() ? function() {
            var ar = document.createElement("canvas");
            ar.width = ar.height = 1;
            var yr = ar.getContext("2d");
            if (!yr)
              return !1;
            var Tr = yr.getImageData(0, 0, 1, 1);
            return Tr && Tr.width === ar.width;
          }() ? (ke[ir = He && He.failIfMajorPerformanceCaveat] === void 0 && (ke[ir] = function(ar) {
            var yr, Tr = function($r) {
              var Dr = document.createElement("canvas"), Or = Object.create(qe.webGLContextAttributes);
              return Or.failIfMajorPerformanceCaveat = $r, Dr.getContext("webgl2", Or);
            }(ar);
            if (!Tr)
              return !1;
            try {
              yr = Tr.createShader(Tr.VERTEX_SHADER);
            } catch {
              return !1;
            }
            return !(!yr || Tr.isContextLost()) && (Tr.shaderSource(yr, "void main() {}"), Tr.compileShader(yr), Tr.getShaderParameter(yr, Tr.COMPILE_STATUS) === !0);
          }(ir)), ke[ir] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL2 support") : "insufficient Canvas/getImageData support" : "insufficient worker support";
          var ir;
        }
        Lr = 1, Ir.supported = qe, Ir.notSupportedReason = xe;
        var ke = {};
        return qe.webGLContextAttributes = { antialias: !1, alpha: !0, stencil: !0, depth: !0 }, Ir;
      }();
      function Rr(qe, xe, ke) {
        const He = document.createElement(qe);
        return xe != null && (He.className = xe), ke && ke.appendChild(He), He;
      }
      function Nr(qe, xe, ke) {
        const He = document.createElementNS("http://www.w3.org/2000/svg", qe);
        for (const ir of Object.keys(xe))
          He.setAttributeNS(null, ir, String(xe[ir]));
        return ke && ke.appendChild(He), He;
      }
      const Yr = typeof document < "u" ? document.documentElement && document.documentElement.style : null, Vr = Yr && Yr.userSelect !== void 0 ? "userSelect" : "WebkitUserSelect";
      let Xr;
      function Wr() {
        Yr && Vr && (Xr = Yr[Vr], Yr[Vr] = "none");
      }
      function si() {
        Yr && Vr && (Yr[Vr] = Xr);
      }
      function li(qe) {
        qe.preventDefault(), qe.stopPropagation(), window.removeEventListener("click", li, !0);
      }
      function xi() {
        window.addEventListener("click", li, !0), window.setTimeout(() => {
          window.removeEventListener("click", li, !0);
        }, 0);
      }
      function di(qe, xe) {
        const ke = qe.getBoundingClientRect();
        return vr(qe, ke, xe);
      }
      function oi(qe, xe) {
        const ke = qe.getBoundingClientRect(), He = [];
        for (let ir = 0; ir < xe.length; ir++)
          He.push(vr(qe, ke, xe[ir]));
        return He;
      }
      function ci(qe) {
        return window.InstallTrigger !== void 0 && qe.button === 2 && qe.ctrlKey && window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : qe.button;
      }
      function vr(qe, xe, ke) {
        const He = qe.offsetWidth === xe.width ? 1 : qe.offsetWidth / xe.width;
        return new ne.P((ke.clientX - xe.left) * He, (ke.clientY - xe.top) * He);
      }
      const Ae = "01", ze = "NO_ACCESS_TOKEN";
      class Ue {
        constructor(xe, ke, He) {
          this._transformRequestFn = xe, this._customAccessToken = ke, this._silenceAuthErrors = !!He, this._createSkuToken();
        }
        _createSkuToken() {
          const xe = function() {
            let ke = "";
            for (let He = 0; He < 10; He++)
              ke += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
            return { token: ["1", Ae, ke].join(""), tokenExpiresAt: Date.now() + 432e5 };
          }();
          this._skuToken = xe.token, this._skuTokenExpiresAt = xe.tokenExpiresAt;
        }
        _isSkuTokenExpired() {
          return Date.now() > this._skuTokenExpiresAt;
        }
        transformRequest(xe, ke) {
          return this._transformRequestFn && this._transformRequestFn(xe, ke) || { url: xe };
        }
        normalizeStyleURL(xe, ke) {
          if (!ne.f(xe))
            return xe;
          const He = lr(xe);
          return He.params.push(`sdk=js-${rr}`), He.path = `/styles/v1${He.path}`, this._makeAPIURL(He, this._customAccessToken || ke);
        }
        normalizeGlyphsURL(xe, ke) {
          if (!ne.f(xe))
            return xe;
          const He = lr(xe);
          return He.path = `/fonts/v1${He.path}`, this._makeAPIURL(He, this._customAccessToken || ke);
        }
        normalizeModelURL(xe, ke) {
          if (!ne.f(xe))
            return xe;
          const He = lr(xe);
          return He.path = `/models/v1${He.path}`, this._makeAPIURL(He, this._customAccessToken || ke);
        }
        normalizeSourceURL(xe, ke, He, ir) {
          if (!ne.f(xe))
            return xe;
          const ar = lr(xe);
          return ar.path = `/v4/${ar.authority}.json`, ar.params.push("secure"), He && ar.params.push(`language=${He}`), ir && ar.params.push(`worldview=${ir}`), this._makeAPIURL(ar, this._customAccessToken || ke);
        }
        normalizeIconsetURL(xe, ke) {
          const He = lr(xe);
          return ne.f(xe) ? (He.path = `/styles/v1${He.path}/iconset.pbf`, this._makeAPIURL(He, this._customAccessToken || ke)) : pr(He);
        }
        normalizeSpriteURL(xe, ke, He, ir) {
          const ar = lr(xe);
          return ne.f(xe) ? (ar.path = `/styles/v1${ar.path}/sprite${ke}${He}`, this._makeAPIURL(ar, this._customAccessToken || ir)) : (ar.path += `${ke}${He}`, pr(ar));
        }
        normalizeTileURL(xe, ke, He) {
          if (this._isSkuTokenExpired() && this._createSkuToken(), xe && !ne.f(xe))
            return xe;
          const ir = lr(xe);
          ir.path = ir.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${ke || He && ir.authority !== "raster" && He === 512 ? "@2x" : ""}${ne.m.supported ? ".webp" : "$1"}`), ir.authority === "raster" ? ir.path = `/${ne.e.RASTER_URL_PREFIX}${ir.path}` : ir.authority === "rasterarrays" ? ir.path = `/${ne.e.RASTERARRAYS_URL_PREFIX}${ir.path}` : ir.authority === "3dtiles" ? ir.path = `/${ne.e.TILES3D_URL_PREFIX}${ir.path}` : (ir.path = ir.path.replace(/^.+\/v4\//, "/"), ir.path = `/${ne.e.TILE_URL_VERSION}${ir.path}`);
          const ar = this._customAccessToken || function(yr) {
            for (const Tr of yr) {
              const $r = Tr.match(/^access_token=(.*)$/);
              if ($r)
                return $r[1];
            }
            return null;
          }(ir.params) || ne.e.ACCESS_TOKEN;
          return ne.e.REQUIRE_ACCESS_TOKEN && ar && this._skuToken && ir.params.push(`sku=${this._skuToken}`), this._makeAPIURL(ir, ar);
        }
        canonicalizeTileURL(xe, ke) {
          const He = lr(xe);
          if (!He.path.match(/^(\/v4\/|\/(raster|rasterarrays)\/v1\/)/) || !He.path.match(/\.[\w]+$/))
            return xe;
          let ir = "mapbox://";
          He.path.match(/^\/raster\/v1\//) ? ir += `raster/${He.path.replace(`/${ne.e.RASTER_URL_PREFIX}/`, "")}` : He.path.match(/^\/rasterarrays\/v1\//) ? ir += `rasterarrays/${He.path.replace(`/${ne.e.RASTERARRAYS_URL_PREFIX}/`, "")}` : ir += `tiles/${He.path.replace(`/${ne.e.TILE_URL_VERSION}/`, "")}`;
          let ar = He.params;
          return ke && (ar = ar.filter((yr) => !yr.match(/^access_token=/))), ar.length && (ir += `?${ar.join("&")}`), ir;
        }
        canonicalizeTileset(xe, ke) {
          const He = !!ke && ne.f(ke), ir = [];
          for (const ar of xe.tiles || [])
            ne.h(ar) ? ir.push(this.canonicalizeTileURL(ar, He)) : ir.push(ar);
          return ir;
        }
        _makeAPIURL(xe, ke) {
          const He = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", ir = lr(ne.e.API_URL);
          if (xe.protocol = ir.protocol, xe.authority = ir.authority, xe.protocol === "http") {
            const ar = xe.params.indexOf("secure");
            ar >= 0 && xe.params.splice(ar, 1);
          }
          if (ir.path !== "/" && (xe.path = `${ir.path}${xe.path}`), !ne.e.REQUIRE_ACCESS_TOKEN)
            return pr(xe);
          if (ke = ke || ne.e.ACCESS_TOKEN, !this._silenceAuthErrors) {
            if (!ke)
              throw new Error(`An API access token is required to use Mapbox GL. ${He}`);
            if (ke[0] === "s")
              throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${He}`);
          }
          return xe.params = xe.params.filter((ar) => ar.indexOf("access_token") === -1), xe.params.push(`access_token=${ke || ""}`), pr(xe);
        }
      }
      const tr = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
      function lr(qe) {
        const xe = qe.match(tr);
        if (!xe)
          throw new Error("Unable to parse URL object");
        return { protocol: xe[1], authority: xe[2], path: xe[3] || "/", params: xe[4] ? xe[4].split("&") : [] };
      }
      function pr(qe) {
        const xe = qe.params.length ? `?${qe.params.join("&")}` : "";
        return `${qe.protocol}://${qe.authority}${qe.path}${xe}`;
      }
      const br = "mapbox.eventData";
      function nr(qe) {
        if (!qe)
          return null;
        const xe = qe.split(".");
        if (!xe || xe.length !== 3)
          return null;
        try {
          return JSON.parse(ne.j(xe[1]));
        } catch {
          return null;
        }
      }
      class Pe {
        constructor(xe) {
          this.type = xe, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
        }
        getStorageKey(xe) {
          const ke = nr(ne.e.ACCESS_TOKEN);
          let He = "";
          return He = ke && ke.u ? ne.k(ke.u) : ne.e.ACCESS_TOKEN || "", xe ? `${br}.${xe}:${He}` : `${br}:${He}`;
        }
        fetchEventData() {
          const xe = ne.s("localStorage"), ke = this.getStorageKey(), He = this.getStorageKey("uuid");
          if (xe)
            try {
              const ir = localStorage.getItem(ke);
              ir && (this.eventData = JSON.parse(ir));
              const ar = localStorage.getItem(He);
              ar && (this.anonId = ar);
            } catch {
              ne.w("Unable to read from LocalStorage");
            }
        }
        saveEventData() {
          const xe = ne.s("localStorage"), ke = this.getStorageKey(), He = this.getStorageKey("uuid"), ir = this.anonId;
          if (xe && ir)
            try {
              localStorage.setItem(He, ir), Object.keys(this.eventData).length >= 1 && localStorage.setItem(ke, JSON.stringify(this.eventData));
            } catch {
              ne.w("Unable to write to LocalStorage");
            }
        }
        processRequests(xe) {
        }
        postEvent(xe, ke, He, ir) {
          if (!ne.e.EVENTS_URL)
            return;
          const ar = lr(ne.e.EVENTS_URL);
          ar.params.push(`access_token=${ir || ne.e.ACCESS_TOKEN || ""}`);
          const yr = { event: this.type, created: new Date(xe).toISOString() }, Tr = ke ? ne.l(yr, ke) : yr, $r = { url: pr(ar), headers: { "Content-Type": "text/plain" }, body: JSON.stringify([Tr]) };
          this.pendingRequest = ne.p($r, (Dr) => {
            this.pendingRequest = null, He(Dr), this.saveEventData(), this.processRequests(ir);
          });
        }
        queueRequest(xe, ke) {
          this.queue.push(xe), this.processRequests(ke);
        }
      }
      const ur = new class extends Pe {
        constructor(qe) {
          super("appUserTurnstile"), this._customAccessToken = qe;
        }
        postTurnstileEvent(qe, xe) {
          ne.e.EVENTS_URL && ne.e.ACCESS_TOKEN && Array.isArray(qe) && qe.some((ke) => ne.f(ke) || ne.h(ke)) && this.queueRequest(Date.now(), xe);
        }
        processRequests(qe) {
          if (this.pendingRequest || this.queue.length === 0)
            return;
          this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
          const xe = nr(ne.e.ACCESS_TOKEN), ke = xe ? xe.u : ne.e.ACCESS_TOKEN;
          let He = ke !== this.eventData.tokenU;
          ne.v(this.anonId) || (this.anonId = ne.u(), He = !0);
          const ir = this.queue.shift();
          if (this.eventData.lastSuccess) {
            const ar = new Date(this.eventData.lastSuccess), yr = new Date(ir), Tr = (ir - this.eventData.lastSuccess) / 864e5;
            He = He || Tr >= 1 || Tr < -1 || ar.getDate() !== yr.getDate();
          } else
            He = !0;
          He ? this.postEvent(ir, { sdkIdentifier: "mapbox-gl-js", sdkVersion: rr, skuId: Ae, "enabled.telemetry": !1, userId: this.anonId }, (ar) => {
            ar || (this.eventData.lastSuccess = ir, this.eventData.tokenU = ke);
          }, qe) : this.processRequests();
        }
      }(), Pr = ur.postTurnstileEvent.bind(ur), Hr = new class extends Pe {
        constructor() {
          super("map.load"), this.success = {}, this.skuToken = "";
        }
        postMapLoadEvent(qe, xe, ke, He) {
          this.skuToken = xe, this.errorCb = He, ne.e.EVENTS_URL && (ke || ne.e.ACCESS_TOKEN ? this.queueRequest({ id: qe, timestamp: Date.now() }, ke) : this.errorCb(new Error(ze)));
        }
        processRequests(qe) {
          if (this.pendingRequest || this.queue.length === 0)
            return;
          const { id: xe, timestamp: ke } = this.queue.shift();
          xe && this.success[xe] || (this.anonId || this.fetchEventData(), ne.v(this.anonId) || (this.anonId = ne.u()), this.postEvent(ke, { sdkIdentifier: "mapbox-gl-js", sdkVersion: rr, skuId: Ae, skuToken: this.skuToken, userId: this.anonId }, (He) => {
            He ? this.errorCb(He) : xe && (this.success[xe] = !0);
          }, qe));
        }
        remove() {
          this.errorCb = null;
        }
      }(), vi = Hr.postMapLoadEvent.bind(Hr), Ti = new class extends Pe {
        constructor() {
          super("style.load"), this.eventIdPerMapInstanceMap = /* @__PURE__ */ new Map(), this.mapInstanceIdMap = /* @__PURE__ */ new WeakMap();
        }
        getMapInstanceId(qe) {
          let xe = this.mapInstanceIdMap.get(qe);
          return xe || (xe = ne.u(), this.mapInstanceIdMap.set(qe, xe)), xe;
        }
        getEventId(qe) {
          const xe = this.eventIdPerMapInstanceMap.get(qe) || 0;
          return this.eventIdPerMapInstanceMap.set(qe, xe + 1), xe;
        }
        postStyleLoadEvent(qe, xe) {
          const { map: ke, style: He, importedStyles: ir } = xe;
          if (!ne.e.EVENTS_URL || !qe && !ne.e.ACCESS_TOKEN)
            return;
          const ar = this.getMapInstanceId(ke), yr = { mapInstanceId: ar, eventId: this.getEventId(ar), style: He };
          ir.length && (yr.importedStyles = ir), this.queueRequest({ timestamp: Date.now(), payload: yr }, qe);
        }
        processRequests(qe) {
          if (this.pendingRequest || this.queue.length === 0)
            return;
          const { timestamp: xe, payload: ke } = this.queue.shift();
          this.postEvent(xe, ke, () => {
          }, qe);
        }
      }(), wi = Ti.postStyleLoadEvent.bind(Ti), ii = new class extends Pe {
        constructor() {
          super("gljs.performance");
        }
        postPerformanceEvent(qe, xe) {
          ne.e.EVENTS_URL && (qe || ne.e.ACCESS_TOKEN) && this.queueRequest({ timestamp: Date.now(), performanceData: xe }, qe);
        }
        processRequests(qe) {
          if (this.pendingRequest || this.queue.length === 0)
            return;
          const { timestamp: xe, performanceData: ke } = this.queue.shift(), He = function(ir) {
            const ar = performance.getEntriesByType("resource"), yr = performance.getEntriesByType("mark"), Tr = function(Jr) {
              const bi = {};
              if (Jr) {
                for (const fi in Jr)
                  if (fi !== "other")
                    for (const Mi of Jr[fi]) {
                      const Ei = `${fi}ResolveRangeMin`, Ii = `${fi}ResolveRangeMax`, Ni = `${fi}RequestCount`, zi = `${fi}RequestCachedCount`;
                      bi[Ei] = Math.min(bi[Ei] || 1 / 0, Mi.startTime), bi[Ii] = Math.max(bi[Ii] || -1 / 0, Mi.responseEnd);
                      const Ki = (Wi) => {
                        bi[Wi] === void 0 && (bi[Wi] = 0), ++bi[Wi];
                      };
                      Mi.transferSize !== void 0 && Mi.transferSize === 0 && Ki(zi), Ki(Ni);
                    }
              }
              return bi;
            }(function(Jr, bi) {
              const fi = {};
              if (Jr)
                for (const Mi of Jr) {
                  const Ei = bi(Mi);
                  fi[Ei] === void 0 && (fi[Ei] = []), fi[Ei].push(Mi);
                }
              return fi;
            }(ar, _r)), $r = window.devicePixelRatio, Dr = navigator.connection || navigator.mozConnection || navigator.webkitConnection, Or = Dr ? Dr.effectiveType : void 0, Gr = { counters: [], metadata: [], attributes: [] }, qr = (Jr, bi, fi) => {
              fi != null && Jr.push({ name: bi, value: fi.toString() });
            };
            for (const Jr in Tr)
              qr(Gr.counters, Jr, Tr[Jr]);
            if (ir.interactionRange[0] !== 1 / 0 && ir.interactionRange[1] !== -1 / 0 && (qr(Gr.counters, "interactionRangeMin", ir.interactionRange[0]), qr(Gr.counters, "interactionRangeMax", ir.interactionRange[1])), yr)
              for (const Jr of Object.keys(gr)) {
                const bi = gr[Jr], fi = yr.find((Mi) => Mi.name === bi);
                fi && qr(Gr.counters, bi, fi.startTime);
              }
            return qr(Gr.counters, "visibilityHidden", ir.visibilityHidden), qr(Gr.attributes, "style", function(Jr) {
              if (Jr)
                for (const bi of Jr) {
                  const fi = bi.name.split("?")[0];
                  if (ne.i(fi)) {
                    const Mi = fi.split("/").slice(-2);
                    if (Mi.length === 2)
                      return `mapbox://styles/${Mi[0]}/${Mi[1]}`;
                  }
                }
            }(ar)), qr(Gr.attributes, "terrainEnabled", ir.terrainEnabled ? "true" : "false"), qr(Gr.attributes, "fogEnabled", ir.fogEnabled ? "true" : "false"), qr(Gr.attributes, "projection", ir.projection), qr(Gr.attributes, "zoom", ir.zoom), qr(Gr.metadata, "devicePixelRatio", $r), qr(Gr.metadata, "connectionEffectiveType", Or), qr(Gr.metadata, "navigatorUserAgent", navigator.userAgent), qr(Gr.metadata, "screenWidth", window.screen.width), qr(Gr.metadata, "screenHeight", window.screen.height), qr(Gr.metadata, "windowWidth", window.innerWidth), qr(Gr.metadata, "windowHeight", window.innerHeight), qr(Gr.metadata, "mapWidth", ir.width / $r), qr(Gr.metadata, "mapHeight", ir.height / $r), qr(Gr.metadata, "webglRenderer", ir.renderer), qr(Gr.metadata, "webglVendor", ir.vendor), qr(Gr.metadata, "sdkVersion", rr), qr(Gr.metadata, "sdkIdentifier", "mapbox-gl-js"), Gr;
          }(ke);
          for (const ir of He.metadata)
            ;
          for (const ir of He.counters)
            ;
          for (const ir of He.attributes)
            ;
          this.postEvent(xe, He, () => {
          }, qe);
        }
      }(), mi = ii.postPerformanceEvent.bind(ii), ei = new class extends Pe {
        constructor() {
          super("map.auth"), this.success = {}, this.skuToken = "";
        }
        getSession(qe, xe, ke, He) {
          if (!ne.e.API_URL || !ne.e.SESSION_PATH)
            return;
          const ir = lr(ne.e.API_URL + ne.e.SESSION_PATH);
          ir.params.push(`sku=${xe || ""}`), ir.params.push(`access_token=${He || ne.e.ACCESS_TOKEN || ""}`);
          const ar = { url: pr(ir), headers: { "Content-Type": "text/plain" } };
          this.pendingRequest = ne.g(ar, (yr) => {
            this.pendingRequest = null, ke(yr), this.saveEventData(), this.processRequests(He);
          });
        }
        getSessionAPI(qe, xe, ke, He) {
          this.skuToken = xe, this.errorCb = He, ne.e.SESSION_PATH && ne.e.API_URL && (ke || ne.e.ACCESS_TOKEN ? this.queueRequest({ id: qe, timestamp: Date.now() }, ke) : this.errorCb(new Error(ze)));
        }
        processRequests(qe) {
          if (this.pendingRequest || this.queue.length === 0)
            return;
          const { id: xe, timestamp: ke } = this.queue.shift();
          xe && this.success[xe] || this.getSession(ke, this.skuToken, (He) => {
            He ? this.errorCb(He) : xe && (this.success[xe] = !0);
          }, qe);
        }
        remove() {
          this.errorCb = null;
        }
      }(), Zr = ei.getSessionAPI.bind(ei), pi = /* @__PURE__ */ new Set();
      function hi(qe, xe) {
        xe ? pi.add(qe) : pi.delete(qe);
      }
      class Oi {
        constructor() {
          this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps = /* @__PURE__ */ new Set(), this._updatedImages = /* @__PURE__ */ new Set();
        }
        isDirty() {
          return this._changed;
        }
        setDirty() {
          this._changed = !0;
        }
        getUpdatedSourceCaches() {
          return this._updatedSourceCaches;
        }
        updateSourceCache(xe, ke) {
          this._updatedSourceCaches[xe] = ke, this.setDirty();
        }
        discardSourceCacheUpdate(xe) {
          delete this._updatedSourceCaches[xe];
        }
        updateLayer(xe) {
          const ke = xe.scope;
          this._updatedLayers[ke] = this._updatedLayers[ke] || /* @__PURE__ */ new Set(), this._updatedLayers[ke].add(xe.id), this.setDirty();
        }
        removeLayer(xe) {
          const ke = xe.scope;
          this._removedLayers[ke] = this._removedLayers[ke] || {}, this._updatedLayers[ke] = this._updatedLayers[ke] || /* @__PURE__ */ new Set(), this._removedLayers[ke][xe.id] = xe, this._updatedLayers[ke].delete(xe.id), this._updatedPaintProps.delete(xe.fqid), this.setDirty();
        }
        getRemovedLayer(xe) {
          return this._removedLayers[xe.scope] ? this._removedLayers[xe.scope][xe.id] : null;
        }
        discardLayerRemoval(xe) {
          this._removedLayers[xe.scope] && delete this._removedLayers[xe.scope][xe.id];
        }
        getLayerUpdatesByScope() {
          const xe = {};
          for (const ke in this._updatedLayers)
            xe[ke] = xe[ke] || {}, xe[ke].updatedIds = Array.from(this._updatedLayers[ke].values());
          for (const ke in this._removedLayers)
            xe[ke] = xe[ke] || {}, xe[ke].removedIds = Object.keys(this._removedLayers[ke]);
          return xe;
        }
        getUpdatedPaintProperties() {
          return this._updatedPaintProps;
        }
        updatePaintProperties(xe) {
          this._updatedPaintProps.add(xe.fqid), this.setDirty();
        }
        getUpdatedImages() {
          return Array.from(this._updatedImages.values());
        }
        updateImage(xe) {
          this._updatedImages.add(xe), this.setDirty();
        }
        resetUpdatedImages() {
          this._updatedImages.clear();
        }
        reset() {
          this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps.clear(), this._updatedImages.clear();
        }
      }
      function qi(qe) {
        const { userImage: xe } = qe;
        return !!(xe && xe.render && xe.render()) && (qe.data.replace(new Uint8Array(xe.data.buffer)), !0);
      }
      class yn extends ne.E {
        constructor(xe) {
          super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = {}, this.requestors = [], this.patterns = {}, this.atlasImage = {}, this.atlasTexture = {}, this.dirty = !0, this.spriteFormat = xe, xe !== "raster" && ne.t() && (this.imageRasterizerDispatcher = new ne.D(ne.x(), this, "Image Rasterizer Worker", 1));
        }
        get imageRasterizer() {
          return this._imageRasterizer || (this._imageRasterizer = new ne.I()), this._imageRasterizer;
        }
        createScope(xe) {
          this.images[xe] = {}, this.loaded[xe] = !1, this.updatedImages[xe] = {}, this.patterns[xe] = {}, this.callbackDispatchedThisFrame[xe] = {}, this.atlasImage[xe] = new ne.r({ width: 1, height: 1 });
        }
        isLoaded() {
          for (const xe in this.loaded)
            if (!this.loaded[xe])
              return !1;
          return !0;
        }
        setLoaded(xe, ke) {
          if (this.loaded[ke] !== xe && (this.loaded[ke] = xe, xe)) {
            for (const { ids: He, callback: ir } of this.requestors)
              this._notify(He, ke, ir);
            this.requestors = [];
          }
        }
        hasImage(xe, ke) {
          return !!this.getImage(xe, ke);
        }
        getImage(xe, ke) {
          return this.images[ke][xe];
        }
        addImage(xe, ke, He) {
          this._validate(xe, He) && (this.images[ke][xe] = He);
        }
        _validate(xe, ke) {
          let He = !0;
          return this._validateStretch(ke.stretchX, ke.data && ke.data.width) || (this.fire(new ne.y(new Error(`Image "${xe}" has invalid "stretchX" value`))), He = !1), this._validateStretch(ke.stretchY, ke.data && ke.data.height) || (this.fire(new ne.y(new Error(`Image "${xe}" has invalid "stretchY" value`))), He = !1), this._validateContent(ke.content, ke) || (this.fire(new ne.y(new Error(`Image "${xe}" has invalid "content" value`))), He = !1), He;
        }
        _validateStretch(xe, ke) {
          if (!xe)
            return !0;
          let He = 0;
          for (const ir of xe) {
            if (ir[0] < He || ir[1] < ir[0] || ke < ir[1])
              return !1;
            He = ir[1];
          }
          return !0;
        }
        _validateContent(xe, ke) {
          return xe ? xe.length !== 4 || !ke.usvg && (xe[0] < 0 || ke.data.width < xe[0] || xe[1] < 0 || ke.data.height < xe[1] || xe[2] < 0 || ke.data.width < xe[2] || xe[3] < 0 || ke.data.height < xe[3]) ? !1 : !(xe[2] < xe[0] || xe[3] < xe[1]) : !0;
        }
        updateImage(xe, ke, He) {
          He.version = this.images[ke][xe].version + 1, this.images[ke][xe] = He, this.updatedImages[ke][xe] = !0, this.removeFromImageRasterizerCache(xe, ke);
        }
        removeFromImageRasterizerCache(xe, ke) {
          this.spriteFormat !== "raster" && (ne.t() ? this.imageRasterizerDispatcher.getActor().send("removeRasterizedImages", { imageIds: [xe], scope: ke }) : this.imageRasterizer.removeImagesFromCacheByIds([xe], ke));
        }
        removeImage(xe, ke) {
          const He = this.images[ke][xe];
          delete this.images[ke][xe], delete this.patterns[ke][xe], this.removeFromImageRasterizerCache(xe, ke), He.userImage && He.userImage.onRemove && He.userImage.onRemove();
        }
        listImages(xe) {
          return Object.keys(this.images[xe]);
        }
        getImages(xe, ke, He) {
          let ir = !0;
          const ar = !!this.loaded[ke];
          if (!ar)
            for (const yr of xe)
              this.images[ke][yr] || (ir = !1);
          ar || ir ? this._notify(xe, ke, He) : this.requestors.push({ ids: xe, scope: ke, callback: He });
        }
        rasterizeImages({ scope: xe, imageTasks: ke }, He) {
          const ir = {};
          for (const ar in ke) {
            const yr = ke[ar], Tr = this.getImage(yr.id, xe);
            Tr && (ir[ar] = { image: Tr, imageIdWithOptions: yr });
          }
          ne.t() ? this.imageRasterizerDispatcher.getActor().send("rasterizeImages", { imageTasks: ir, scope: xe }, He) : this.rasterizeImagesInMainThread({ imageTasks: ir, scope: xe }, He);
        }
        rasterizeImagesInMainThread(xe, ke) {
          const { imageTasks: He, scope: ir } = xe, ar = {};
          for (const yr in He) {
            const { image: Tr, imageIdWithOptions: $r } = He[yr];
            ar[yr] = this.imageRasterizer.rasterize($r, Tr, ir, "");
          }
          ke(void 0, ar);
        }
        getUpdatedImages(xe) {
          return this.updatedImages[xe];
        }
        _notify(xe, ke, He) {
          const ir = {};
          for (const ar of xe) {
            this.images[ke][ar] || this.fire(new ne.z("styleimagemissing", { id: ar }));
            const yr = this.images[ke][ar];
            yr ? ir[ar] = { data: yr.usvg ? null : yr.data.clone(), pixelRatio: yr.pixelRatio, sdf: yr.sdf, usvg: yr.usvg, version: yr.version, stretchX: yr.stretchX, stretchY: yr.stretchY, content: yr.content, hasRenderCallback: Boolean(yr.userImage && yr.userImage.render) } : ne.w(`Image "${ar}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
          }
          He(null, ir);
        }
        getPixelSize(xe) {
          const { width: ke, height: He } = this.atlasImage[xe];
          return { width: ke, height: He };
        }
        getPattern(xe, ke, He) {
          const ir = this.patterns[ke][xe], ar = this.getImage(xe, ke);
          if (!ar)
            return null;
          if (ir && ir.position.version === ar.version)
            return ir.position;
          if (ir)
            ir.position.version = ar.version;
          else {
            ar.usvg && !ar.data && (ar.data = this.imageRasterizer.rasterize(ne.A.from(xe).getPrimary(), ar, ke, ""));
            const yr = { w: ar.data.width + 2 * ne.B, h: ar.data.height + 2 * ne.B, x: 0, y: 0 }, Tr = new ne.F(yr, ar, ne.B);
            this.patterns[ke][xe] = { bin: yr, position: Tr };
          }
          return this._updatePatternAtlas(ke, He), this.patterns[ke][xe].position;
        }
        bind(xe, ke) {
          const He = xe.gl;
          let ir = this.atlasTexture[ke];
          ir ? this.dirty && (ir.update(this.atlasImage[ke]), this.dirty = !1) : (ir = new ne.T(xe, this.atlasImage[ke], He.RGBA8), this.atlasTexture[ke] = ir), ir.bind(He.LINEAR, He.CLAMP_TO_EDGE);
        }
        _updatePatternAtlas(xe, ke) {
          const He = [];
          for (const Tr in this.patterns[xe])
            He.push(this.patterns[xe][Tr].bin);
          const { w: ir, h: ar } = ne.C(He), yr = this.atlasImage[xe];
          yr.resize({ width: ir || 1, height: ar || 1 });
          for (const Tr in this.patterns[xe]) {
            const { bin: $r, position: Dr } = this.patterns[xe][Tr];
            let Or = Dr.padding;
            const Gr = $r.x + Or, qr = $r.y + Or, Jr = this.images[xe][Tr].data, bi = Jr.width, fi = Jr.height;
            Or = Or > 1 ? Or - 1 : Or, ne.r.copy(Jr, yr, { x: 0, y: 0 }, { x: Gr, y: qr }, { width: bi, height: fi }, ke), ne.r.copy(Jr, yr, { x: 0, y: fi - Or }, { x: Gr, y: qr - Or }, { width: bi, height: Or }, ke), ne.r.copy(Jr, yr, { x: 0, y: 0 }, { x: Gr, y: qr + fi }, { width: bi, height: Or }, ke), ne.r.copy(Jr, yr, { x: bi - Or, y: 0 }, { x: Gr - Or, y: qr }, { width: Or, height: fi }, ke), ne.r.copy(Jr, yr, { x: 0, y: 0 }, { x: Gr + bi, y: qr }, { width: Or, height: fi }, ke), ne.r.copy(Jr, yr, { x: bi - Or, y: fi - Or }, { x: Gr - Or, y: qr - Or }, { width: Or, height: Or }, ke), ne.r.copy(Jr, yr, { x: 0, y: fi - Or }, { x: Gr + bi, y: qr - Or }, { width: Or, height: Or }, ke), ne.r.copy(Jr, yr, { x: 0, y: 0 }, { x: Gr + bi, y: qr + fi }, { width: Or, height: Or }, ke), ne.r.copy(Jr, yr, { x: bi - Or, y: 0 }, { x: Gr - Or, y: qr + fi }, { width: Or, height: Or }, ke);
          }
          this.dirty = !0;
        }
        beginFrame() {
          for (const xe in this.images)
            this.callbackDispatchedThisFrame[xe] = {};
        }
        dispatchRenderCallbacks(xe, ke) {
          for (const He of xe) {
            if (this.callbackDispatchedThisFrame[ke][He])
              continue;
            this.callbackDispatchedThisFrame[ke][He] = !0;
            const ir = this.images[ke][He];
            qi(ir) && this.updateImage(He, ke, ir);
          }
        }
      }
      function sn(qe) {
        const xe = qe.key, ke = qe.value, He = qe.valueSpec || {}, ir = qe.objectElementValidators || {}, ar = qe.style, yr = qe.styleSpec;
        let Tr = [];
        const $r = ne.H(ke);
        if ($r !== "object")
          return [new ne.V(xe, ke, `object expected, ${$r} found`)];
        for (const Dr in ke) {
          const Or = Dr.split(".")[0];
          let Gr;
          ir[Or] ? Gr = ir[Or] : He[Or] ? Gr = Mn : ir["*"] ? Gr = ir["*"] : He["*"] && (Gr = Mn), Gr ? Tr = Tr.concat(Gr({ key: (xe && `${xe}.`) + Dr, value: ke[Dr], valueSpec: He[Or] || He["*"], style: ar, styleSpec: yr, object: ke, objectKey: Dr }, ke)) : Tr.push(new ne.G(xe, ke[Dr], `unknown property "${Dr}"`));
        }
        for (const Dr in He)
          ir[Dr] || He[Dr].required && He[Dr].default === void 0 && ke[Dr] === void 0 && Tr.push(new ne.V(xe, ke, `missing required property "${Dr}"`));
        return Tr;
      }
      function $n(qe) {
        const xe = qe.value, ke = qe.valueSpec, He = qe.style, ir = qe.styleSpec, ar = qe.key, yr = qe.arrayElementValidator || Mn;
        if (ne.H(xe) !== "array")
          return [new ne.V(ar, xe, `array expected, ${ne.H(xe)} found`)];
        if (ke.length && xe.length !== ke.length)
          return [new ne.V(ar, xe, `array length ${ke.length} expected, length ${xe.length} found`)];
        if (ke["min-length"] && xe.length < ke["min-length"])
          return [new ne.V(ar, xe, `array length at least ${ke["min-length"]} expected, length ${xe.length} found`)];
        let Tr = { type: ke.value, values: ke.values, minimum: ke.minimum, maximum: ke.maximum, function: void 0 };
        ir.$version < 7 && (Tr.function = ke.function), ne.H(ke.value) === "object" && (Tr = ke.value);
        let $r = [];
        for (let Dr = 0; Dr < xe.length; Dr++)
          $r = $r.concat(yr({ array: xe, arrayIndex: Dr, value: xe[Dr], valueSpec: Tr, style: He, styleSpec: ir, key: `${ar}[${Dr}]` }, !0));
        return $r;
      }
      function rn(qe) {
        const xe = qe.key, ke = qe.value, He = qe.valueSpec;
        let ir = ne.H(ke);
        if (ir === "number" && ke != ke && (ir = "NaN"), ir !== "number")
          return [new ne.V(xe, ke, `number expected, ${ir} found`)];
        if ("minimum" in He) {
          let ar = He.minimum;
          if (ne.H(He.minimum) === "array" && (ar = He.minimum[qe.arrayIndex]), ke < ar)
            return [new ne.V(xe, ke, `${ke} is less than the minimum value ${ar}`)];
        }
        if ("maximum" in He) {
          let ar = He.maximum;
          if (ne.H(He.maximum) === "array" && (ar = He.maximum[qe.arrayIndex]), ke > ar)
            return [new ne.V(xe, ke, `${ke} is greater than the maximum value ${ar}`)];
        }
        return [];
      }
      function ji(qe) {
        const xe = qe.valueSpec, ke = ne.K(qe.value.type);
        let He, ir, ar, yr = {};
        const Tr = ke !== "categorical" && qe.value.property === void 0, $r = !Tr, Dr = ne.H(qe.value.stops) === "array" && ne.H(qe.value.stops[0]) === "array" && ne.H(qe.value.stops[0][0]) === "object", Or = sn({ key: qe.key, value: qe.value, valueSpec: qe.styleSpec.function, style: qe.style, styleSpec: qe.styleSpec, objectElementValidators: { stops: function(Jr) {
          if (ke === "identity")
            return [new ne.V(Jr.key, Jr.value, 'identity function may not have a "stops" property')];
          let bi = [];
          const fi = Jr.value;
          return bi = bi.concat($n({ key: Jr.key, value: fi, valueSpec: Jr.valueSpec, style: Jr.style, styleSpec: Jr.styleSpec, arrayElementValidator: Gr })), ne.H(fi) === "array" && fi.length === 0 && bi.push(new ne.V(Jr.key, fi, "array must have at least one stop")), bi;
        }, default: function(Jr) {
          return Mn({ key: Jr.key, value: Jr.value, valueSpec: xe, style: Jr.style, styleSpec: Jr.styleSpec });
        } } });
        return ke === "identity" && Tr && Or.push(new ne.V(qe.key, qe.value, 'missing required property "property"')), ke === "identity" || qe.value.stops || Or.push(new ne.V(qe.key, qe.value, 'missing required property "stops"')), ke === "exponential" && qe.valueSpec.expression && !ne.L(qe.valueSpec) && Or.push(new ne.V(qe.key, qe.value, "exponential functions not supported")), qe.styleSpec.$version >= 8 && ($r && !ne.M(qe.valueSpec) ? Or.push(new ne.V(qe.key, qe.value, "property functions not supported")) : Tr && !ne.N(qe.valueSpec) && Or.push(new ne.V(qe.key, qe.value, "zoom functions not supported"))), ke !== "categorical" && !Dr || qe.value.property !== void 0 || Or.push(new ne.V(qe.key, qe.value, '"property" property is required')), Or;
        function Gr(Jr) {
          let bi = [];
          const fi = Jr.value, Mi = Jr.key;
          if (ne.H(fi) !== "array")
            return [new ne.V(Mi, fi, `array expected, ${ne.H(fi)} found`)];
          if (fi.length !== 2)
            return [new ne.V(Mi, fi, `array length 2 expected, length ${fi.length} found`)];
          if (Dr) {
            if (ne.H(fi[0]) !== "object")
              return [new ne.V(Mi, fi, `object expected, ${ne.H(fi[0])} found`)];
            if (fi[0].zoom === void 0)
              return [new ne.V(Mi, fi, "object stop key must have zoom")];
            if (fi[0].value === void 0)
              return [new ne.V(Mi, fi, "object stop key must have value")];
            const Ei = ne.K(fi[0].zoom);
            if (typeof Ei != "number")
              return [new ne.V(Mi, fi[0].zoom, "stop zoom values must be numbers")];
            if (ar && ar > Ei)
              return [new ne.V(Mi, fi[0].zoom, "stop zoom values must appear in ascending order")];
            Ei !== ar && (ar = Ei, ir = void 0, yr = {}), bi = bi.concat(sn({ key: `${Mi}[0]`, value: fi[0], valueSpec: { zoom: {} }, style: Jr.style, styleSpec: Jr.styleSpec, objectElementValidators: { zoom: rn, value: qr } }));
          } else
            bi = bi.concat(qr({ key: `${Mi}[0]`, value: fi[0], valueSpec: {}, style: Jr.style, styleSpec: Jr.styleSpec }, fi));
          return ne.O(ne.Q(fi[1])) ? bi.concat([new ne.V(`${Mi}[1]`, fi[1], "expressions are not allowed in function stops.")]) : bi.concat(Mn({ key: `${Mi}[1]`, value: fi[1], valueSpec: xe, style: Jr.style, styleSpec: Jr.styleSpec }));
        }
        function qr(Jr, bi) {
          const fi = ne.H(Jr.value), Mi = ne.K(Jr.value), Ei = Jr.value !== null ? Jr.value : bi;
          if (He) {
            if (fi !== He)
              return [new ne.V(Jr.key, Ei, `${fi} stop domain type must match previous stop domain type ${He}`)];
          } else
            He = fi;
          if (fi !== "number" && fi !== "string" && fi !== "boolean" && typeof Mi != "number" && typeof Mi != "string" && typeof Mi != "boolean")
            return [new ne.V(Jr.key, Ei, "stop domain value must be a number, string, or boolean")];
          if (fi !== "number" && ke !== "categorical") {
            let Ii = `number expected, ${fi} found`;
            return ne.M(xe) && ke === void 0 && (Ii += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [new ne.V(Jr.key, Ei, Ii)];
          }
          return ke !== "categorical" || fi !== "number" || typeof Mi == "number" && isFinite(Mi) && Math.floor(Mi) === Mi ? ke !== "categorical" && fi === "number" && typeof Mi == "number" && typeof ir == "number" && ir !== void 0 && Mi < ir ? [new ne.V(Jr.key, Ei, "stop domain values must appear in ascending order")] : (ir = Mi, ke === "categorical" && Mi in yr ? [new ne.V(Jr.key, Ei, "stop domain values must be unique")] : (yr[Mi] = !0, [])) : [new ne.V(Jr.key, Ei, `integer expected, found ${String(Mi)}`)];
        }
      }
      function Kn(qe) {
        const xe = (qe.expressionContext === "property" ? ne.S : ne.U)(ne.Q(qe.value), qe.valueSpec);
        if (xe.result === "error")
          return xe.value.map((He) => new ne.V(`${qe.key}${He.key}`, qe.value, He.message));
        const ke = xe.value.expression || xe.value._styleExpression.expression;
        if (qe.expressionContext === "property" && qe.propertyKey === "text-font" && !ke.outputDefined())
          return [new ne.V(qe.key, qe.value, `Invalid data expression for "${qe.propertyKey}". Output values must be contained as literals within the expression.`)];
        if (qe.expressionContext === "property" && qe.propertyType === "layout" && !ne.W(ke))
          return [new ne.V(qe.key, qe.value, '"feature-state" data expressions are not supported with layout properties.')];
        if (qe.expressionContext === "filter")
          return In(ke, qe);
        if (qe.expressionContext && qe.expressionContext.indexOf("cluster") === 0) {
          if (!ne.X(ke, ["zoom", "feature-state"]))
            return [new ne.V(qe.key, qe.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')];
          if (qe.expressionContext === "cluster-initial" && !ne.Y(ke))
            return [new ne.V(qe.key, qe.value, "Feature data expressions are not supported with initial expression part of cluster properties.")];
        }
        return [];
      }
      function In(qe, xe) {
        const ke = /* @__PURE__ */ new Set(["zoom", "feature-state", "pitch", "distance-from-center"]);
        if (xe.valueSpec && xe.valueSpec.expression)
          for (const ir of xe.valueSpec.expression.parameters)
            ke.delete(ir);
        if (ke.size === 0)
          return [];
        const He = [];
        return qe instanceof ne.Z && ke.has(qe.name) ? [new ne.V(xe.key, xe.value, `["${qe.name}"] expression is not supported in a filter for a ${xe.object.type} layer with id: ${xe.object.id}`)] : (qe.eachChild((ir) => {
          He.push(...In(ir, xe));
        }), He);
      }
      function Fn(qe) {
        const xe = qe.key, ke = qe.value, He = qe.valueSpec, ir = [];
        return Array.isArray(He.values) ? He.values.indexOf(ne.K(ke)) === -1 && ir.push(new ne.V(xe, ke, `expected one of [${He.values.join(", ")}], ${JSON.stringify(ke)} found`)) : Object.keys(He.values).indexOf(ne.K(ke)) === -1 && ir.push(new ne.V(xe, ke, `expected one of [${Object.keys(He.values).join(", ")}], ${JSON.stringify(ke)} found`)), ir;
      }
      function Po(qe) {
        return ne.$(ne.Q(qe.value)) ? Kn(ne.J({}, qe, { expressionContext: "filter", valueSpec: qe.styleSpec[`filter_${qe.layerType || "fill"}`] })) : vn(qe);
      }
      function vn(qe) {
        const xe = qe.value, ke = qe.key;
        if (ne.H(xe) !== "array")
          return [new ne.V(ke, xe, `array expected, ${ne.H(xe)} found`)];
        const He = qe.styleSpec;
        let ir, ar = [];
        if (xe.length < 1)
          return [new ne.V(ke, xe, "filter array must have at least 1 element")];
        switch (ar = ar.concat(Fn({ key: `${ke}[0]`, value: xe[0], valueSpec: He.filter_operator, style: qe.style, styleSpec: qe.styleSpec })), ne.K(xe[0])) {
          case "<":
          case "<=":
          case ">":
          case ">=":
            xe.length >= 2 && ne.K(xe[1]) === "$type" && ar.push(new ne.V(ke, xe, `"$type" cannot be use with operator "${xe[0]}"`));
          case "==":
          case "!=":
            xe.length !== 3 && ar.push(new ne.V(ke, xe, `filter array for operator "${xe[0]}" must have 3 elements`));
          case "in":
          case "!in":
            xe.length >= 2 && (ir = ne.H(xe[1]), ir !== "string" && ar.push(new ne.V(`${ke}[1]`, xe[1], `string expected, ${ir} found`)));
            for (let yr = 2; yr < xe.length; yr++)
              ir = ne.H(xe[yr]), ne.K(xe[1]) === "$type" ? ar = ar.concat(Fn({ key: `${ke}[${yr}]`, value: xe[yr], valueSpec: He.geometry_type, style: qe.style, styleSpec: qe.styleSpec })) : ir !== "string" && ir !== "number" && ir !== "boolean" && ar.push(new ne.V(`${ke}[${yr}]`, xe[yr], `string, number, or boolean expected, ${ir} found`));
            break;
          case "any":
          case "all":
          case "none":
            for (let yr = 1; yr < xe.length; yr++)
              ar = ar.concat(vn({ key: `${ke}[${yr}]`, value: xe[yr], style: qe.style, styleSpec: qe.styleSpec }));
            break;
          case "has":
          case "!has":
            ir = ne.H(xe[1]), xe.length !== 2 ? ar.push(new ne.V(ke, xe, `filter array for "${xe[0]}" operator must have 2 elements`)) : ir !== "string" && ar.push(new ne.V(`${ke}[1]`, xe[1], `string expected, ${ir} found`));
        }
        return ar;
      }
      function Vn(qe, xe) {
        const ke = qe.key, He = qe.style, ir = qe.layer, ar = qe.styleSpec, yr = qe.value, Tr = qe.objectKey, $r = ar[`${xe}_${qe.layerType}`];
        if (!$r)
          return [];
        const Dr = Tr.match(/^(.*)-use-theme$/);
        if (xe === "paint" && Dr && $r[Dr[1]])
          return Mn({ key: ke, value: yr, valueSpec: { type: "string" }, style: He, styleSpec: ar });
        const Or = Tr.match(/^(.*)-transition$/);
        if (xe === "paint" && Or && $r[Or[1]] && $r[Or[1]].transition)
          return Mn({ key: ke, value: yr, valueSpec: ar.transition, style: He, styleSpec: ar });
        const Gr = qe.valueSpec || $r[Tr];
        if (!Gr)
          return [new ne.G(ke, yr, `unknown property "${Tr}"`)];
        let qr;
        if (ne.H(yr) === "string" && ne.M(Gr) && !Gr.tokens && (qr = /^{([^}]+)}$/.exec(yr))) {
          const bi = `\`{ "type": "identity", "property": ${qr ? JSON.stringify(qr[1]) : '"_"'} }\``;
          return [new ne.V(ke, yr, `"${Tr}" does not support interpolation syntax
Use an identity property function instead: ${bi}.`)];
        }
        const Jr = [];
        if (qe.layerType === "symbol")
          Tr !== "text-field" || !He || He.glyphs || He.imports || Jr.push(new ne.V(ke, yr, 'use of "text-field" requires a style "glyphs" property')), Tr === "text-font" && ne.a0(ne.Q(yr)) && ne.K(yr.type) === "identity" && Jr.push(new ne.V(ke, yr, '"text-font" does not support identity functions'));
        else if (qe.layerType === "model" && xe === "paint" && ir && ir.layout && ir.layout.hasOwnProperty("model-id") && ne.M(Gr) && (ne.a1(Gr) || ne.N(Gr))) {
          const bi = ne.S(ne.Q(yr), Gr), fi = bi.value.expression || bi.value._styleExpression.expression;
          fi && !ne.X(fi, ["measure-light"]) && (Tr === "model-emissive-strength" && ne.Y(fi) && ne.W(fi) || Jr.push(new ne.V(ke, yr, `${Tr} does not support measure-light expressions when the model layer source is vector tile or GeoJSON.`)));
        }
        return Jr.concat(Mn({ key: qe.key, value: yr, valueSpec: Gr, style: He, styleSpec: ar, expressionContext: "property", propertyType: xe, propertyKey: Tr }));
      }
      function Xo(qe) {
        return Vn(qe, "paint");
      }
      function Xn(qe) {
        return Vn(qe, "layout");
      }
      function Yn(qe) {
        let xe = [];
        const ke = qe.value, He = qe.key, ir = qe.style, ar = qe.styleSpec;
        ke.type || ke.ref || xe.push(new ne.V(He, ke, 'either "type" or "ref" is required'));
        let yr = ne.K(ke.type);
        const Tr = ne.K(ke.ref);
        if (ke.id) {
          const $r = ne.K(ke.id);
          for (let Dr = 0; Dr < qe.arrayIndex; Dr++) {
            const Or = ir.layers[Dr];
            ne.K(Or.id) === $r && xe.push(new ne.V(He, ke.id, `duplicate layer id "${ke.id}", previously used at line ${Or.id.__line__}`));
          }
        }
        if ("ref" in ke) {
          let $r;
          ["type", "source", "source-layer", "filter", "layout"].forEach((Dr) => {
            Dr in ke && xe.push(new ne.V(He, ke[Dr], `"${Dr}" is prohibited for ref layers`));
          }), ir.layers.forEach((Dr) => {
            ne.K(Dr.id) === Tr && ($r = Dr);
          }), $r ? $r.ref ? xe.push(new ne.V(He, ke.ref, "ref cannot reference another ref layer")) : yr = ne.K($r.type) : typeof Tr == "string" && xe.push(new ne.V(He, ke.ref, `ref layer "${Tr}" not found`));
        } else if (yr !== "background" && yr !== "sky" && yr !== "slot")
          if (ke.source) {
            const $r = ir.sources && ir.sources[ke.source], Dr = $r && ne.K($r.type);
            $r ? Dr === "vector" && yr === "raster" ? xe.push(new ne.V(He, ke.source, `layer "${ke.id}" requires a raster source`)) : Dr === "raster" && yr !== "raster" ? xe.push(new ne.V(He, ke.source, `layer "${ke.id}" requires a vector source`)) : Dr !== "vector" || ke["source-layer"] ? Dr === "raster-dem" && yr !== "hillshade" ? xe.push(new ne.V(He, ke.source, "raster-dem source can only be used with layer type 'hillshade'.")) : Dr !== "raster-array" || ["raster", "raster-particle"].includes(yr) ? yr !== "line" || !ke.paint || !ke.paint["line-gradient"] && !ke.paint["line-trim-offset"] || Dr === "geojson" && $r.lineMetrics ? yr === "raster-particle" && Dr !== "raster-array" && xe.push(new ne.V(He, ke.source, `layer "${ke.id}" requires a 'raster-array' source.`)) : xe.push(new ne.V(He, ke, `layer "${ke.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : xe.push(new ne.V(He, ke.source, "raster-array source can only be used with layer type 'raster'.")) : xe.push(new ne.V(He, ke, `layer "${ke.id}" must specify a "source-layer"`)) : xe.push(new ne.V(He, ke.source, `source "${ke.source}" not found`));
          } else
            xe.push(new ne.V(He, ke, 'missing required property "source"'));
        return xe = xe.concat(sn({ key: He, value: ke, valueSpec: ar.layer, style: qe.style, styleSpec: qe.styleSpec, objectElementValidators: { "*": () => [], type: () => Mn({ key: `${He}.type`, value: ke.type, valueSpec: ar.layer.type, style: qe.style, styleSpec: qe.styleSpec, object: ke, objectKey: "type" }), filter: ($r) => Po(ne.J({ layerType: yr }, $r)), layout: ($r) => sn({ layer: ke, key: $r.key, value: $r.value, valueSpec: {}, style: $r.style, styleSpec: $r.styleSpec, objectElementValidators: { "*": (Dr) => Xn(ne.J({ layerType: yr }, Dr)) } }), paint: ($r) => sn({ layer: ke, key: $r.key, value: $r.value, valueSpec: {}, style: $r.style, styleSpec: $r.styleSpec, objectElementValidators: { "*": (Dr) => Xo(ne.J({ layerType: yr, layer: ke }, Dr)) } }) } })), xe;
      }
      function Wo(qe) {
        const xe = qe.value, ke = qe.key, He = ne.H(xe);
        return He !== "string" ? [new ne.V(ke, xe, `string expected, ${He} found`)] : [];
      }
      const Ci = { promoteId: function({ key: qe, value: xe }) {
        if (ne.H(xe) === "string")
          return Wo({ key: qe, value: xe });
        {
          const ke = [];
          for (const He in xe)
            ke.push(...Wo({ key: `${qe}.${He}`, value: xe[He] }));
          return ke;
        }
      } };
      function ri(qe) {
        const xe = qe.value, ke = qe.key, He = qe.styleSpec, ir = qe.style;
        if (!xe.type)
          return [new ne.V(ke, xe, '"type" is required')];
        const ar = ne.K(xe.type);
        let yr = [];
        switch (["vector", "raster", "raster-dem", "raster-array"].includes(ar) && (xe.url || xe.tiles || yr.push(new ne.G(ke, xe, 'Either "url" or "tiles" is required.'))), ar) {
          case "vector":
          case "raster":
          case "raster-dem":
          case "raster-array":
            return yr = yr.concat(sn({ key: ke, value: xe, valueSpec: He[`source_${ar.replace("-", "_")}`], style: qe.style, styleSpec: He, objectElementValidators: Ci })), yr;
          case "geojson":
            if (yr = sn({ key: ke, value: xe, valueSpec: He.source_geojson, style: ir, styleSpec: He, objectElementValidators: Ci }), xe.cluster)
              for (const Tr in xe.clusterProperties) {
                const [$r, Dr] = xe.clusterProperties[Tr], Or = typeof $r == "string" ? [$r, ["accumulated"], ["get", Tr]] : $r;
                yr.push(...Kn({ key: `${ke}.${Tr}.map`, value: Dr, expressionContext: "cluster-map" })), yr.push(...Kn({ key: `${ke}.${Tr}.reduce`, value: Or, expressionContext: "cluster-reduce" }));
              }
            return yr;
          case "video":
            return sn({ key: ke, value: xe, valueSpec: He.source_video, style: ir, styleSpec: He });
          case "image":
            return sn({ key: ke, value: xe, valueSpec: He.source_image, style: ir, styleSpec: He });
          case "canvas":
            return [new ne.V(ke, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")];
          default:
            return Fn({ key: `${ke}.type`, value: xe.type, valueSpec: { values: yi(He) }, style: ir, styleSpec: He });
        }
      }
      function yi(qe) {
        return qe.source.reduce((xe, ke) => {
          const He = qe[ke];
          return He.type.type === "enum" && (xe = xe.concat(Object.keys(He.type.values))), xe;
        }, []);
      }
      function Li(qe) {
        const xe = qe.value, ke = qe.styleSpec, He = ke.light, ir = qe.style;
        let ar = [];
        const yr = ne.H(xe);
        if (xe === void 0)
          return ar;
        if (yr !== "object")
          return ar = ar.concat([new ne.V("light", xe, `object expected, ${yr} found`)]), ar;
        for (const Tr in xe) {
          const $r = Tr.match(/^(.*)-transition$/), Dr = Tr.match(/^(.*)-use-theme$/);
          ar = ar.concat(Dr && He[Dr[1]] ? Mn({ key: Tr, value: xe[Tr], valueSpec: { type: "string" }, style: ir, styleSpec: ke }) : $r && He[$r[1]] && He[$r[1]].transition ? Mn({ key: Tr, value: xe[Tr], valueSpec: ke.transition, style: ir, styleSpec: ke }) : He[Tr] ? Mn({ key: Tr, value: xe[Tr], valueSpec: He[Tr], style: ir, styleSpec: ke }) : [new ne.V(Tr, xe[Tr], `unknown property "${Tr}"`)]);
        }
        return ar;
      }
      function Yi(qe) {
        const xe = qe.value;
        let ke = [];
        if (!xe)
          return ke;
        const He = ne.H(xe);
        if (He !== "object")
          return ke = ke.concat([new ne.V("light-3d", xe, `object expected, ${He} found`)]), ke;
        const ir = qe.styleSpec, ar = ir["light-3d"], yr = qe.key, Tr = qe.style, $r = qe.style.lights;
        for (const Gr of ["type", "id"])
          if (!(Gr in xe))
            return ke = ke.concat([new ne.V("light-3d", xe, `missing property ${Gr} on light`)]), ke;
        if (xe.type && $r)
          for (let Gr = 0; Gr < qe.arrayIndex; Gr++) {
            const qr = ne.K(xe.type), Jr = $r[Gr];
            ne.K(Jr.type) === qr && ke.push(new ne.V(yr, xe.id, `duplicate light type "${xe.type}", previously defined at line ${Jr.id.__line__}`));
          }
        const Dr = `properties_light_${xe.type}`;
        if (!(Dr in ir))
          return ke = ke.concat([new ne.V("light-3d", xe, `Invalid light type ${xe.type}`)]), ke;
        const Or = ir[Dr];
        for (const Gr in xe)
          if (Gr === "properties") {
            const qr = xe[Gr], Jr = ne.H(qr);
            if (Jr !== "object")
              return ke = ke.concat([new ne.V("properties", qr, `object expected, ${Jr} found`)]), ke;
            for (const bi in qr)
              ke = ke.concat(Or[bi] ? Mn({ key: bi, value: qr[bi], valueSpec: Or[bi], style: Tr, styleSpec: ir }) : [new ne.G(qe.key, qr[bi], `unknown property "${bi}"`)]);
          } else {
            const qr = Gr.match(/^(.*)-transition$/), Jr = Gr.match(/^(.*)-use-theme$/);
            ke = ke.concat(Jr && ar[Jr[1]] ? Mn({ key: Gr, value: xe[Gr], valueSpec: { type: "string" }, style: Tr, styleSpec: ir }) : qr && ar[qr[1]] && ar[qr[1]].transition ? Mn({ key: Gr, value: xe[Gr], valueSpec: ir.transition, style: Tr, styleSpec: ir }) : ar[Gr] ? Mn({ key: Gr, value: xe[Gr], valueSpec: ar[Gr], style: Tr, styleSpec: ir }) : [new ne.G(Gr, xe[Gr], `unknown property "${Gr}"`)]);
          }
        return ke;
      }
      function zn(qe) {
        const xe = qe.value, ke = qe.key, He = qe.style, ir = qe.styleSpec, ar = ir.terrain;
        let yr = [];
        const Tr = ne.H(xe);
        if (xe === void 0 || Tr === "null")
          return yr;
        if (Tr !== "object")
          return yr = yr.concat([new ne.V("terrain", xe, `object expected, ${Tr} found`)]), yr;
        for (const $r in xe) {
          const Dr = $r.match(/^(.*)-transition$/), Or = $r.match(/^(.*)-use-theme$/);
          yr = yr.concat(Or && ar[Or[1]] ? Mn({ key: $r, value: xe[$r], valueSpec: { type: "string" }, style: He, styleSpec: ir }) : Dr && ar[Dr[1]] && ar[Dr[1]].transition ? Mn({ key: $r, value: xe[$r], valueSpec: ir.transition, style: He, styleSpec: ir }) : ar[$r] ? Mn({ key: $r, value: xe[$r], valueSpec: ar[$r], style: He, styleSpec: ir }) : [new ne.G($r, xe[$r], `unknown property "${$r}"`)]);
        }
        if (xe.source) {
          const $r = He.sources && He.sources[xe.source], Dr = $r && ne.K($r.type);
          $r ? Dr !== "raster-dem" && yr.push(new ne.V(ke, xe.source, `terrain cannot be used with a source of type ${String(Dr)}, it only be used with a "raster-dem" source type`)) : yr.push(new ne.V(ke, xe.source, `source "${xe.source}" not found`));
        } else
          yr.push(new ne.V(ke, xe, 'terrain is missing required property "source"'));
        return yr;
      }
      function un(qe) {
        const xe = qe.value, ke = qe.style, He = qe.styleSpec, ir = He.fog;
        let ar = [];
        const yr = ne.H(xe);
        if (xe === void 0)
          return ar;
        if (yr !== "object")
          return ar = ar.concat([new ne.V("fog", xe, `object expected, ${yr} found`)]), ar;
        for (const Tr in xe) {
          const $r = Tr.match(/^(.*)-transition$/), Dr = Tr.match(/^(.*)-use-theme$/);
          ar = ar.concat(Dr && ir[Dr[1]] ? Mn({ key: Tr, value: xe[Tr], valueSpec: { type: "string" }, style: ke, styleSpec: He }) : $r && ir[$r[1]] && ir[$r[1]].transition ? Mn({ key: Tr, value: xe[Tr], valueSpec: He.transition, style: ke, styleSpec: He }) : ir[Tr] ? Mn({ key: Tr, value: xe[Tr], valueSpec: ir[Tr], style: ke, styleSpec: He }) : [new ne.G(Tr, xe[Tr], `unknown property "${Tr}"`)]);
        }
        return ar;
      }
      const Gn = { "*": () => [], array: $n, boolean: function(qe) {
        const xe = qe.value, ke = qe.key, He = ne.H(xe);
        return He !== "boolean" ? [new ne.V(ke, xe, `boolean expected, ${He} found`)] : [];
      }, number: rn, color: function(qe) {
        const xe = qe.key, ke = qe.value, He = ne.H(ke);
        return He !== "string" ? [new ne.V(xe, ke, `color expected, ${He} found`)] : ne._.parseCSSColor(ke) === null ? [new ne.V(xe, ke, `color expected, "${ke}" found`)] : [];
      }, enum: Fn, filter: Po, function: ji, layer: Yn, object: sn, source: ri, model: ne.a2, light: Li, "light-3d": Yi, terrain: zn, fog: un, string: Wo, formatted: function(qe) {
        return Wo(qe).length === 0 ? [] : Kn(qe);
      }, resolvedImage: function(qe) {
        return Wo(qe).length === 0 ? [] : Kn(qe);
      }, projection: function(qe) {
        const xe = qe.value, ke = qe.styleSpec, He = ke.projection, ir = qe.style;
        let ar = [];
        const yr = ne.H(xe);
        if (yr === "object")
          for (const Tr in xe)
            ar = ar.concat(Mn({ key: Tr, value: xe[Tr], valueSpec: He[Tr], style: ir, styleSpec: ke }));
        else
          yr !== "string" && (ar = ar.concat([new ne.V("projection", xe, `object or string expected, ${yr} found`)]));
        return ar;
      }, import: function(qe) {
        const { value: xe, styleSpec: ke } = qe, { data: He, ...ir } = xe;
        Object.defineProperty(ir, "__line__", { value: xe.__line__, enumerable: !1 });
        let ar = sn(ne.J({}, qe, { value: ir, valueSpec: ke.import }));
        return ne.K(ir.id) === "" && ar.push(new ne.V(`${qe.key}.id`, ir, "import id can't be an empty string")), He && (ar = ar.concat(Rn(He, ke, { key: `${qe.key}.data` }))), ar;
      } };
      function Mn(qe, xe = !1) {
        const ke = qe.value, He = qe.valueSpec, ir = qe.styleSpec;
        if (He.expression && ne.a0(ne.K(ke)))
          return ji(qe);
        if (He.expression && ne.O(ne.Q(ke)))
          return Kn(qe);
        if (He.type && Gn[He.type]) {
          const ar = Gn[He.type](qe);
          return xe === !0 && ar.length > 0 && ne.H(qe.value) === "array" ? Kn(qe) : ar;
        }
        return sn(ne.J({}, qe, { valueSpec: He.type ? ir[He.type] : He }));
      }
      function pn(qe) {
        const xe = qe.value, ke = qe.key, He = Wo(qe);
        return He.length || (xe.indexOf("{fontstack}") === -1 && He.push(new ne.V(ke, xe, '"glyphs" url must include a "{fontstack}" token')), xe.indexOf("{range}") === -1 && He.push(new ne.V(ke, xe, '"glyphs" url must include a "{range}" token'))), He;
      }
      function Rn(qe, xe = ne.a3, ke = {}) {
        return Mn({ key: ke.key || "", value: qe, valueSpec: xe.$root, styleSpec: xe, style: qe, objectElementValidators: { glyphs: pn, "*": () => [] } });
      }
      function Io(qe, xe = ne.a3) {
        return Ui(Rn(qe, xe));
      }
      const to = (qe) => Ui(ri(qe)), no = (qe) => Ui(Li(qe)), ma = (qe) => Ui(Yi(qe)), Qn = (qe) => Ui(zn(qe)), co = (qe) => Ui(un(qe)), kn = (qe) => Ui(function(xe) {
        const ke = xe.value, He = xe.style, ir = xe.styleSpec, ar = ir.snow;
        let yr = [];
        const Tr = ne.H(ke);
        if (ke === void 0)
          return yr;
        if (Tr !== "object")
          return yr = yr.concat([new ne.V("snow", ke, `object expected, ${Tr} found`)]), yr;
        for (const $r in ke) {
          const Dr = $r.match(/^(.*)-transition$/);
          yr = yr.concat(Dr && ar[Dr[1]] && ar[Dr[1]].transition ? Mn({ key: $r, value: ke[$r], valueSpec: ir.transition, style: He, styleSpec: ir }) : ar[$r] ? Mn({ key: $r, value: ke[$r], valueSpec: ar[$r], style: He, styleSpec: ir }) : [new ne.G($r, ke[$r], `unknown property "${$r}"`)]);
        }
        return yr;
      }(qe)), ai = (qe) => Ui(function(xe) {
        const ke = xe.value, He = xe.style, ir = xe.styleSpec, ar = ir.rain;
        let yr = [];
        const Tr = ne.H(ke);
        if (ke === void 0)
          return yr;
        if (Tr !== "object")
          return yr = yr.concat([new ne.V("rain", ke, `object expected, ${Tr} found`)]), yr;
        for (const $r in ke) {
          const Dr = $r.match(/^(.*)-transition$/);
          yr = yr.concat(Dr && ar[Dr[1]] && ar[Dr[1]].transition ? Mn({ key: $r, value: ke[$r], valueSpec: ir.transition, style: He, styleSpec: ir }) : ar[$r] ? Mn({ key: $r, value: ke[$r], valueSpec: ar[$r], style: He, styleSpec: ir }) : [new ne.G($r, ke[$r], `unknown property "${$r}"`)]);
        }
        return yr;
      }(qe)), _i = (qe) => Ui(Yn(qe)), Pi = (qe) => Ui(Po(qe)), Ai = (qe) => Ui(Xo(qe)), ki = (qe) => Ui(Xn(qe)), an = (qe) => Ui(ne.a2(qe));
      function Ui(qe) {
        return qe.slice().sort((xe, ke) => xe.line && ke.line ? xe.line - ke.line : 0);
      }
      function Vi(qe, xe) {
        let ke = !1;
        if (xe && xe.length)
          for (const He of xe)
            He instanceof ne.G ? ne.w(He.message) : (qe.fire(new ne.y(new Error(He.message))), ke = !0);
        return ke;
      }
      let Sn;
      class Hi extends ne.E {
        constructor(xe, ke = "flat") {
          super(), this._transitionable = new ne.a4(Sn || (Sn = new ne.a5({ anchor: new ne.a6(ne.a3.light.anchor), position: new ne.a7(ne.a3.light.position), color: new ne.a6(ne.a3.light.color), intensity: new ne.a6(ne.a3.light.intensity) }))), this.setLight(xe, ke), this._transitioning = this._transitionable.untransitioned();
        }
        getLight() {
          return this._transitionable.serialize();
        }
        setLight(xe, ke, He = {}) {
          this._validate(no, xe, He) || (this._transitionable.setTransitionOrValue(xe), this.id = ke);
        }
        updateTransitions(xe) {
          this._transitioning = this._transitionable.transitioned(xe, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(xe) {
          this.properties = this._transitioning.possiblyEvaluate(xe);
        }
        _validate(xe, ke, He) {
          return (!He || He.validate !== !1) && Vi(this, xe.call(Io, ne.l({ value: ke, style: { glyphs: !0, sprite: !0 }, styleSpec: ne.a3 })));
        }
      }
      let en = class extends ne.E {
        constructor(qe, xe, ke, He) {
          super(), this.scope = ke, this._transitionable = new ne.a4(new ne.a5({ source: new ne.a6(ne.a3.terrain.source), exaggeration: new ne.a6(ne.a3.terrain.exaggeration) }), ke, He), this._transitionable.setTransitionOrValue(qe, He), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = xe;
        }
        get() {
          return this._transitionable.serialize();
        }
        set(qe, xe) {
          this._transitionable.setTransitionOrValue(qe, xe);
        }
        updateTransitions(qe) {
          this._transitioning = this._transitionable.transitioned(qe, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(qe) {
          this.properties = this._transitioning.possiblyEvaluate(qe);
        }
        getExaggeration(qe) {
          return this._transitioning.possiblyEvaluate(new ne.a8(qe)).get("exaggeration");
        }
        getAttenuationRange() {
          if (!this.isZoomDependent())
            return null;
          const qe = this._transitionable._values.exaggeration;
          if (!qe)
            return null;
          const xe = qe.value.expression;
          if (!xe)
            return null;
          let ke = -1, He = -1, ir = 1;
          for (const ar of xe.zoomStops)
            ir = xe.evaluate(new ne.a8(ar)), ir > 0.01 ? (ke = ar, He = -1) : He = ar;
          return ir < 0.01 && ke > 0 && He > ke ? [ke, He] : null;
        }
        isZoomDependent() {
          const qe = this._transitionable._values.exaggeration;
          return qe != null && qe.value != null && qe.value.expression != null && qe.value.expression instanceof ne.a9;
        }
      };
      const qn = 45, _n = 65, Tn = 0.05;
      function xo(qe, xe, ke, He) {
        const ir = ne.ac(qn, _n, ke), [ar, yr] = Co(qe, He);
        let Tr = 1 - Math.min(1, Math.exp((xe - ar) / (yr - ar) * -6));
        return Tr *= Tr * Tr, Tr = Math.min(1, 1.00747 * Tr), Tr * ir * qe.alpha;
      }
      function Co(qe, xe) {
        const ke = 0.5 / Math.tan(0.5 * xe);
        return [qe.range[0] + ke, qe.range[1] + ke];
      }
      function $o(qe, xe, ke, He, ir) {
        const ar = ne.ab.vec3.transformMat4([], [xe, ke, He], ir.mercatorFogMatrix);
        return xo(qe, ne.ab.vec3.length(ar), ir.pitch, ir._fov);
      }
      function Bo(qe, xe, ke, He, ir, ar, yr) {
        const Tr = [[ke, He, 0], [ir, He, 0], [ir, ar, 0], [ke, ar, 0]];
        let $r = Number.MAX_VALUE, Dr = -Number.MAX_VALUE;
        for (const Or of Tr) {
          const Gr = ne.ab.vec3.transformMat4([], Or, xe), qr = ne.ab.vec3.length(Gr);
          $r = Math.min($r, qr), Dr = Math.max(Dr, qr);
        }
        return [xo(qe, $r, yr.pitch, yr._fov), xo(qe, Dr, yr.pitch, yr._fov)];
      }
      class Qo extends ne.E {
        constructor(xe, ke, He, ir) {
          super();
          const ar = new ne.a5({ range: new ne.a6(ne.a3.fog.range), color: new ne.a6(ne.a3.fog.color), "color-use-theme": new ne.a6({ type: "string", "property-type": "data-constant", default: "default" }), "high-color": new ne.a6(ne.a3.fog["high-color"]), "high-color-use-theme": new ne.a6({ type: "string", "property-type": "data-constant", default: "default" }), "space-color": new ne.a6(ne.a3.fog["space-color"]), "space-color-use-theme": new ne.a6({ type: "string", "property-type": "data-constant", default: "default" }), "horizon-blend": new ne.a6(ne.a3.fog["horizon-blend"]), "star-intensity": new ne.a6(ne.a3.fog["star-intensity"]), "vertical-range": new ne.a6(ne.a3.fog["vertical-range"]) });
          this._transitionable = new ne.a4(ar, He, new Map(ir)), this.set(xe, ir), this._transitioning = this._transitionable.untransitioned(), this._transform = ke, this.properties = new ne.ad(ar), this.scope = He;
        }
        get state() {
          const xe = this._transform, ke = xe.projection.name === "globe", He = ne.ae(xe.zoom), ir = this.properties.get("range"), ar = [0.5, 3];
          return { range: ke ? [ne.af(ar[0], ir[0], He), ne.af(ar[1], ir[1], He)] : ir, horizonBlend: this.properties.get("horizon-blend"), alpha: this.properties.get("color").a };
        }
        get() {
          return this._transitionable.serialize();
        }
        set(xe, ke, He = {}) {
          if (this._validate(co, xe, He))
            return;
          const ir = ne.l({}, xe);
          for (const ar of Object.keys(ne.a3.fog))
            ir[ar] === void 0 && (ir[ar] = ne.a3.fog[ar].default);
          this._options = ir, this._transitionable.setTransitionOrValue(this._options, ke);
        }
        getOpacity(xe) {
          if (!this._transform.projection.supportsFog)
            return 0;
          const ke = this.properties && this.properties.get("color") || 1;
          return (this._transform.projection.name === "globe" ? 1 : ne.ac(qn, _n, xe)) * ke.a;
        }
        getOpacityAtLatLng(xe, ke) {
          return this._transform.projection.supportsFog ? function(He, ir, ar) {
            const yr = ne.aa.fromLngLat(ir), Tr = ar.elevation ? ar.elevation.getAtPointOrZero(yr) : 0;
            return $o(He, yr.x, yr.y, Tr, ar);
          }(this.state, xe, ke) : 0;
        }
        getOpacityForTile(xe) {
          if (!this._transform.projection.supportsFog)
            return [1, 1];
          const ke = this._transform.calculateFogTileMatrix(xe.toUnwrapped());
          return Bo(this.state, ke, 0, 0, ne.ag, ne.ag, this._transform);
        }
        getOpacityForBounds(xe, ke, He, ir, ar) {
          return this._transform.projection.supportsFog ? Bo(this.state, xe, ke, He, ir, ar, this._transform) : [1, 1];
        }
        getFovAdjustedRange(xe) {
          return this._transform.projection.supportsFog ? Co(this.state, xe) : [0, 1];
        }
        isVisibleOnFrustum(xe) {
          if (!this._transform.projection.supportsFog)
            return !1;
          const ke = [4, 5, 6, 7];
          for (const He of ke) {
            const ir = xe.points[He];
            let ar;
            if (ir[2] >= 0)
              ar = ir;
            else {
              const yr = xe.points[He - 4];
              ar = ne.ah(yr, ir, yr[2] / (yr[2] - ir[2]));
            }
            if ($o(this.state, ar[0], ar[1], 0, this._transform) >= Tn)
              return !0;
          }
          return !1;
        }
        updateConfig(xe) {
          this._transitionable.setTransitionOrValue(this._options, new Map(xe));
        }
        updateTransitions(xe) {
          this._transitioning = this._transitionable.transitioned(xe, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(xe) {
          this.properties = this._transitioning.possiblyEvaluate(xe);
        }
        _validate(xe, ke, He) {
          return (!He || He.validate !== !1) && Vi(this, xe.call(Io, ne.l({ value: ke, style: { glyphs: !0, sprite: !0 }, styleSpec: ne.a3 })));
        }
      }
      let Go, No, Zo, ea, da = class extends ne.E {
        constructor(qe, xe, ke, He) {
          super();
          const ir = Go || (Go = new ne.a5({ density: new ne.a6(ne.a3.snow.density), intensity: new ne.a6(ne.a3.snow.intensity), color: new ne.a6(ne.a3.snow.color), opacity: new ne.a6(ne.a3.snow.opacity), vignette: new ne.a6(ne.a3.snow.vignette), "vignette-color": new ne.a6(ne.a3.snow["vignette-color"]), "center-thinning": new ne.a6(ne.a3.snow["center-thinning"]), direction: new ne.a6(ne.a3.snow.direction), "flake-size": new ne.a6(ne.a3.snow["flake-size"]) }));
          this._transitionable = new ne.a4(ir, ke, new Map(He)), this.set(qe, He), this._transitioning = this._transitionable.untransitioned(), this.properties = new ne.ad(ir), this.scope = ke;
        }
        get state() {
          const qe = this.properties.get("opacity"), xe = this.properties.get("color"), ke = this.properties.get("direction"), He = ne.ai(ke[0]), ir = -Math.max(ne.ai(ke[1]), 0.01), ar = [Math.cos(He) * Math.cos(ir), Math.sin(He) * Math.cos(ir), Math.sin(ir)], yr = this.properties.get("vignette"), Tr = this.properties.get("vignette-color");
          return Tr.a = yr, { density: this.properties.get("density"), intensity: this.properties.get("intensity"), color: new ne.aj(xe.r, xe.g, xe.b, xe.a * qe), direction: ar, centerThinning: this.properties.get("center-thinning"), flakeSize: this.properties.get("flake-size"), vignetteColor: Tr };
        }
        get() {
          return this._transitionable.serialize();
        }
        set(qe, xe, ke = {}) {
          if (this._validate(kn, qe, ke))
            return;
          const He = ne.l({}, qe);
          for (const ir of Object.keys(ne.a3.snow))
            He[ir] === void 0 && (He[ir] = ne.a3.snow[ir].default);
          this._options = He, this._transitionable.setTransitionOrValue(this._options, xe);
        }
        updateConfig(qe) {
          this._transitionable.setTransitionOrValue(this._options, new Map(qe));
        }
        updateTransitions(qe) {
          this._transitioning = this._transitionable.transitioned(qe, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(qe) {
          this.properties = this._transitioning.possiblyEvaluate(qe);
        }
        _validate(qe, xe, ke) {
          return (!ke || ke.validate !== !1) && Vi(this, qe.call(Io, ne.l({ value: xe, style: { glyphs: !0, sprite: !0 }, styleSpec: ne.a3 })));
        }
      }, Ra = class extends ne.E {
        constructor(qe, xe, ke, He) {
          super();
          const ir = No || (No = new ne.a5({ density: new ne.a6(ne.a3.rain.density), intensity: new ne.a6(ne.a3.rain.intensity), color: new ne.a6(ne.a3.rain.color), opacity: new ne.a6(ne.a3.rain.opacity), vignette: new ne.a6(ne.a3.rain.vignette), "vignette-color": new ne.a6(ne.a3.rain["vignette-color"]), "center-thinning": new ne.a6(ne.a3.rain["center-thinning"]), direction: new ne.a6(ne.a3.rain.direction), "droplet-size": new ne.a6(ne.a3.rain["droplet-size"]), "distortion-strength": new ne.a6(ne.a3.rain["distortion-strength"]) }));
          this._transitionable = new ne.a4(ir, ke, new Map(He)), this.set(qe, He), this._transitioning = this._transitionable.untransitioned(), this.properties = new ne.ad(ir), this.scope = ke;
        }
        get state() {
          const qe = this.properties.get("opacity"), xe = this.properties.get("color"), ke = this.properties.get("direction"), He = ne.ai(ke[0]), ir = -Math.max(ne.ai(ke[1]), 0.01), ar = [Math.cos(He) * Math.cos(ir), Math.sin(He) * Math.cos(ir), Math.sin(ir)], yr = this.properties.get("vignette-color");
          return yr.a = this.properties.get("vignette"), { density: this.properties.get("density"), intensity: this.properties.get("intensity"), color: new ne.aj(xe.r, xe.g, xe.b, xe.a * qe), direction: ar, centerThinning: this.properties.get("center-thinning"), dropletSize: this.properties.get("droplet-size"), distortionStrength: this.properties.get("distortion-strength"), vignetteColor: yr };
        }
        get() {
          return this._transitionable.serialize();
        }
        set(qe, xe, ke = {}) {
          if (this._validate(ai, qe, ke))
            return;
          const He = ne.l({}, qe);
          for (const ir of Object.keys(ne.a3.rain))
            He[ir] === void 0 && (He[ir] = ne.a3.rain[ir].default);
          this._options = He, this._transitionable.setTransitionOrValue(this._options, xe);
        }
        updateConfig(qe) {
          this._transitionable.setTransitionOrValue(this._options, new Map(qe));
        }
        updateTransitions(qe) {
          this._transitioning = this._transitionable.transitioned(qe, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(qe) {
          this.properties = this._transitioning.possiblyEvaluate(qe);
        }
        _validate(qe, xe, ke) {
          return (!ke || ke.validate !== !1) && Vi(this, qe.call(Io, ne.l({ value: xe, style: { glyphs: !0, sprite: !0 }, styleSpec: ne.a3 })));
        }
      };
      class ba extends ne.E {
        constructor(xe, ke, He, ir) {
          super(), this.scope = He, this._options = xe, this.properties = new ne.ad(ke), this._transitionable = new ne.a4(ke, He, new Map(ir)), this._transitionable.setTransitionOrValue(xe.properties), this._transitioning = this._transitionable.untransitioned();
        }
        updateConfig(xe) {
          this._transitionable.setTransitionOrValue(this._options.properties, new Map(xe));
        }
        updateTransitions(xe) {
          this._transitioning = this._transitionable.transitioned(xe, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(xe) {
          this.properties = this._transitioning.possiblyEvaluate(xe);
        }
        get() {
          return this._options.properties = this._transitionable.serialize(), this._options;
        }
        set(xe, ke) {
          this._options = xe, this._transitionable.setTransitionOrValue(xe.properties, ke);
        }
        shadowsEnabled() {
          return !!this.properties && this.properties.get("cast-shadows") === !0;
        }
      }
      class Ea {
        constructor(xe, ke, He, ir) {
          this.screenBounds = xe, this.cameraPoint = ke, this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = He, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, ir);
        }
        static createFromScreenPoints(xe, ke) {
          let He, ir;
          if (xe instanceof ne.P || typeof xe[0] == "number") {
            const ar = ne.P.convert(xe);
            He = [ar], ir = ke.isPointAboveHorizon(ar);
          } else {
            const ar = ne.P.convert(xe[0]), yr = ne.P.convert(xe[1]);
            He = [ar, yr], ir = ne.al(ar, yr).every((Tr) => ke.isPointAboveHorizon(Tr));
          }
          return new Ea(He, ke.getCameraPoint(), ir, ke);
        }
        isPointQuery() {
          return this.screenBounds.length === 1;
        }
        bufferedScreenGeometry(xe) {
          return ne.al(this.screenBounds[0], this.screenBounds.length === 1 ? this.screenBounds[0] : this.screenBounds[1], xe);
        }
        bufferedCameraGeometry(xe) {
          const ke = this.screenBounds[0], He = this.screenBounds.length === 1 ? this.screenBounds[0].add(new ne.P(1, 1)) : this.screenBounds[1], ir = ne.al(ke, He, 0, !1);
          return this.cameraPoint.y > He.y && (this.cameraPoint.x > ke.x && this.cameraPoint.x < He.x ? ir.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= He.x ? ir[2] = this.cameraPoint : this.cameraPoint.x <= ke.x && (ir[3] = this.cameraPoint)), ne.am(ir, xe);
        }
        bufferedCameraGeometryGlobe(xe) {
          const ke = this.screenBounds[0], He = this.screenBounds.length === 1 ? this.screenBounds[0].add(new ne.P(1, 1)) : this.screenBounds[1], ir = ne.al(ke, He, xe), ar = this.cameraPoint.clone();
          switch (3 * ((ar.y > ke.y) + (ar.y > He.y)) + ((ar.x > ke.x) + (ar.x > He.x))) {
            case 0:
              ir[0] = ar, ir[4] = ar.clone();
              break;
            case 1:
              ir.splice(1, 0, ar);
              break;
            case 2:
              ir[1] = ar;
              break;
            case 3:
              ir.splice(4, 0, ar);
              break;
            case 5:
              ir.splice(2, 0, ar);
              break;
            case 6:
              ir[3] = ar;
              break;
            case 7:
              ir.splice(3, 0, ar);
              break;
            case 8:
              ir[2] = ar;
          }
          return ir;
        }
        containsTile(xe, ke, He, ir = 0) {
          const ar = xe.queryPadding / ke._pixelsPerMercatorPixel + 1, yr = He ? this._bufferedCameraMercator(ar, ke) : this._bufferedScreenMercator(ar, ke);
          let Tr = xe.tileID.wrap + (yr.unwrapped ? ir : 0);
          const $r = yr.polygon.map((Mi) => ne.an(xe.tileTransform, Mi, Tr));
          if (!ne.ao($r, 0, 0, ne.ag, ne.ag))
            return;
          Tr = xe.tileID.wrap + (this.screenGeometryMercator.unwrapped ? ir : 0);
          const Dr = this.screenGeometryMercator.polygon.map((Mi) => ne.ap(xe.tileTransform, Mi, Tr)), Or = Dr.map((Mi) => new ne.P(Mi[0], Mi[1])), Gr = ke.getFreeCameraOptions().position || new ne.aa(0, 0, 0), qr = ne.ap(xe.tileTransform, Gr, Tr), Jr = Dr.map((Mi) => {
            const Ei = ne.ab.vec3.sub(Mi, Mi, qr);
            return ne.ab.vec3.normalize(Ei, Ei), new ne.aq(qr, Ei);
          }), bi = ne.ar(xe, 1, ke.zoom) * ke._pixelsPerMercatorPixel;
          return { queryGeometry: this, tilespaceGeometry: Or, tilespaceRays: Jr, bufferedTilespaceGeometry: $r, bufferedTilespaceBounds: (fi = ne.as($r), fi.min.x = ne.aw(fi.min.x, 0, ne.ag), fi.min.y = ne.aw(fi.min.y, 0, ne.ag), fi.max.x = ne.aw(fi.max.x, 0, ne.ag), fi.max.y = ne.aw(fi.max.y, 0, ne.ag), fi), tile: xe, tileID: xe.tileID, pixelToTileUnitsFactor: bi };
          var fi;
        }
        _bufferedScreenMercator(xe, ke) {
          const He = ls(xe);
          if (this._screenRaycastCache[He])
            return this._screenRaycastCache[He];
          {
            let ir;
            return ir = ke.projection.name === "globe" ? this._projectAndResample(this.bufferedScreenGeometry(xe), ke) : { polygon: this.bufferedScreenGeometry(xe).map((ar) => ke.pointCoordinate3D(ar)), unwrapped: !0 }, this._screenRaycastCache[He] = ir, ir;
          }
        }
        _bufferedCameraMercator(xe, ke) {
          const He = ls(xe);
          if (this._cameraRaycastCache[He])
            return this._cameraRaycastCache[He];
          {
            let ir;
            return ir = ke.projection.name === "globe" ? this._projectAndResample(this.bufferedCameraGeometryGlobe(xe), ke) : { polygon: this.bufferedCameraGeometry(xe).map((ar) => ke.pointCoordinate3D(ar)), unwrapped: !0 }, this._cameraRaycastCache[He] = ir, ir;
          }
        }
        _projectAndResample(xe, ke) {
          const He = function(ar, yr) {
            const Tr = ne.ab.mat4.multiply([], yr.pixelMatrix, yr.globeMatrix), $r = [0, -ne.ax, 0, 1], Dr = [0, ne.ax, 0, 1], Or = [0, 0, 0, 1];
            ne.ab.vec4.transformMat4($r, $r, Tr), ne.ab.vec4.transformMat4(Dr, Dr, Tr), ne.ab.vec4.transformMat4(Or, Or, Tr);
            const Gr = new ne.P($r[0] / $r[3], $r[1] / $r[3]), qr = new ne.P(Dr[0] / Dr[3], Dr[1] / Dr[3]), Jr = ne.au(ar, Gr) && $r[3] < Or[3], bi = ne.au(ar, qr) && Dr[3] < Or[3];
            if (!Jr && !bi)
              return null;
            const fi = function(Xi, Gi, nn) {
              for (let dn = 1; dn < Xi.length; dn++) {
                const Pn = Fa(Gi.pointCoordinate3D(Xi[dn - 1]).x), Ln = Fa(Gi.pointCoordinate3D(Xi[dn]).x);
                if (nn < 0) {
                  if (Pn < Ln)
                    return { idx: dn, t: -Pn / (Ln - 1 - Pn) };
                } else if (Ln < Pn)
                  return { idx: dn, t: (1 - Pn) / (Ln + 1 - Pn) };
              }
              return null;
            }(ar, yr, Jr ? -1 : 1);
            if (!fi)
              return null;
            const { idx: Mi, t: Ei } = fi;
            let Ii = Mi > 1 ? Ha(ar.slice(0, Mi), yr) : [], Ni = Mi < ar.length ? Ha(ar.slice(Mi), yr) : [];
            Ii = Ii.map((Xi) => new ne.P(Fa(Xi.x), Xi.y)), Ni = Ni.map((Xi) => new ne.P(Fa(Xi.x), Xi.y));
            const zi = [...Ii];
            zi.length === 0 && zi.push(Ni[Ni.length - 1]);
            const Ki = ne.af(zi[zi.length - 1].y, (Ni.length === 0 ? Ii[0] : Ni[0]).y, Ei);
            let Wi;
            return Wi = Jr ? [new ne.P(0, Ki), new ne.P(0, 0), new ne.P(1, 0), new ne.P(1, Ki)] : [new ne.P(1, Ki), new ne.P(1, 1), new ne.P(0, 1), new ne.P(0, Ki)], zi.push(...Wi), Ni.length === 0 ? zi.push(Ii[0]) : zi.push(...Ni), { polygon: zi.map((Xi) => new ne.aa(Xi.x, Xi.y)), unwrapped: !1 };
          }(xe, ke);
          if (He)
            return He;
          const ir = function(ar, yr) {
            let Tr = !1, $r = -1 / 0, Dr = 0;
            for (let Gr = 0; Gr < ar.length - 1; Gr++)
              ar[Gr].x > $r && ($r = ar[Gr].x, Dr = Gr);
            for (let Gr = 0; Gr < ar.length - 1; Gr++) {
              const qr = (Dr + Gr) % (ar.length - 1), Jr = ar[qr], bi = ar[qr + 1];
              Math.abs(Jr.x - bi.x) > 0.5 && (Jr.x < bi.x ? (Jr.x += 1, qr === 0 && (ar[ar.length - 1].x += 1)) : (bi.x += 1, qr + 1 === ar.length - 1 && (ar[0].x += 1)), Tr = !0);
            }
            const Or = ne.at(yr.center.lng);
            return Tr && Or < Math.abs(Or - 1) && ar.forEach((Gr) => {
              Gr.x -= 1;
            }), { polygon: ar, unwrapped: Tr };
          }(Ha(xe, ke).map((ar) => new ne.P(Fa(ar.x), ar.y)), ke);
          return { polygon: ir.polygon.map((ar) => new ne.aa(ar.x, ar.y)), unwrapped: ir.unwrapped };
        }
      }
      function Ha(qe, xe) {
        return ne.av(qe, (ke) => {
          const He = xe.pointCoordinate3D(ke);
          ke.x = He.x, ke.y = He.y;
        }, 1 / 256);
      }
      function Fa(qe) {
        return qe < 0 ? 1 + qe % 1 : qe % 1;
      }
      function ls(qe) {
        return 100 * qe | 0;
      }
      function us(qe, xe, ke, He, ir) {
        const ar = function(Tr, $r) {
          if (Tr)
            return ir(Tr);
          if ($r) {
            if (qe.url && $r.tiles && qe.tiles && delete qe.tiles, $r.variants) {
              if (!Array.isArray($r.variants))
                return ir(new Error("variants must be an array"));
              for (const Or of $r.variants) {
                if (Or == null || typeof Or != "object" || Or.constructor !== Object)
                  return ir(new Error("variant must be an object"));
                if (!Array.isArray(Or.capabilities))
                  return ir(new Error("capabilities must be an array"));
                if (Or.capabilities.length === 1 && Or.capabilities[0] === "meshopt") {
                  $r = ne.l($r, Or);
                  break;
                }
              }
            }
            const Dr = ne.ay(ne.l({}, $r, qe), ["tilejson", "tiles", "minzoom", "maxzoom", "attribution", "mapbox_logo", "bounds", "scheme", "tileSize", "encoding", "vector_layers", "raster_layers", "worldview_options", "worldview_default", "worldview"]);
            Dr.tiles = xe.canonicalizeTileset(Dr, qe.url), ir(null, Dr);
          }
        }, yr = function(Tr, $r, Dr) {
          if (!Tr)
            return null;
          if (!$r && !Dr)
            return Tr;
          Dr = Dr || Tr.worldview_default;
          const Or = Object.values(Tr.language || {});
          if (Or.length === 0)
            return null;
          const Gr = Object.values(Tr.worldview || {});
          if (Gr.length === 0)
            return null;
          const qr = Or.every((bi) => bi === $r), Jr = Gr.every((bi) => bi === Dr);
          return qr && Jr ? Tr : $r in (Tr.language_options || {}) || Dr in (Tr.worldview_options || {}) ? null : Tr.language_options && Tr.worldview_options ? Tr : null;
        }(qe.data, ke, He);
        return yr ? ne.q.frame(() => ar(null, yr)) : qe.url ? ne.n(xe.transformRequest(xe.normalizeSourceURL(qe.url, null, ke, He), ne.R.Source), ar) : ne.q.frame(() => {
          const { data: Tr, ...$r } = qe;
          ar(null, $r);
        });
      }
      class Xa {
        constructor(xe, ke, He) {
          this.bounds = ne.az.convert(this.validateBounds(xe)), this.minzoom = ke || 0, this.maxzoom = He || 24;
        }
        validateBounds(xe) {
          return Array.isArray(xe) && xe.length === 4 ? [Math.max(-180, xe[0]), Math.max(-90, xe[1]), Math.min(180, xe[2]), Math.min(90, xe[3])] : [-180, -90, 180, 90];
        }
        contains(xe) {
          const ke = Math.pow(2, xe.z), He = Math.floor(ne.at(this.bounds.getWest()) * ke), ir = Math.floor(ne.aA(this.bounds.getNorth()) * ke), ar = Math.ceil(ne.at(this.bounds.getEast()) * ke), yr = Math.ceil(ne.aA(this.bounds.getSouth()) * ke);
          return xe.x >= He && xe.x < ar && xe.y >= ir && xe.y < yr;
        }
      }
      class hs extends ne.E {
        constructor(xe, ke, He, ir) {
          if (super(), this.id = xe, this.dispatcher = He, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, ne.l(this, ne.ay(ke, ["url", "scheme", "tileSize", "promoteId"])), this._options = ne.l({ type: "vector" }, ke), this._collectResourceTiming = !!ke.collectResourceTiming, this.tileSize !== 512)
            throw new Error("vector tile sources must have a tileSize of 512");
          this.setEventedParent(ir), this._tileWorkers = {}, this._deduped = new ne.aB();
        }
        load(xe) {
          this._loaded = !1, this.fire(new ne.z("dataloading", { dataType: "source" }));
          const ke = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, He = this.map.getWorldview();
          this._tileJSONRequest = us(this._options, this.map._requestManager, ke, He, (ir, ar) => {
            if (this._tileJSONRequest = null, this._loaded = !0, ir)
              ke && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${ke}`), He && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${He}`), this.fire(new ne.y(ir));
            else if (ar) {
              if (ne.l(this, ar), this.hasWorldviews = !!ar.worldview_options, ar.worldview_default && (this.worldviewDefault = ar.worldview_default), ar.vector_layers) {
                this.vectorLayers = ar.vector_layers, this.vectorLayerIds = [], this.localizableLayerIds = /* @__PURE__ */ new Set();
                for (const yr of ar.vector_layers)
                  this.vectorLayerIds.push(yr.id), ar.worldview && ar.worldview[yr.source] && this.localizableLayerIds.add(yr.id);
              }
              ar.bounds && (this.tileBounds = new Xa(ar.bounds, this.minzoom, this.maxzoom)), Pr(ar.tiles, this.map._requestManager._customAccessToken), this.fire(new ne.z("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new ne.z("data", { dataType: "source", sourceDataType: "content" }));
            }
            xe && xe(ir);
          });
        }
        loaded() {
          return this._loaded;
        }
        hasTile(xe) {
          return !this.tileBounds || this.tileBounds.contains(xe.canonical);
        }
        onAdd(xe) {
          this.map = xe, this.load();
        }
        reload() {
          this.cancelTileJSONRequest();
          const xe = ne.aC(this.id, this.scope);
          this.load(() => this.map.style.clearSource(xe));
        }
        setTiles(xe) {
          return this._options.tiles = xe, this.reload(), this;
        }
        setUrl(xe) {
          return this.url = xe, this._options.url = xe, this.reload(), this;
        }
        onRemove(xe) {
          this.cancelTileJSONRequest();
        }
        serialize() {
          return ne.l({}, this._options);
        }
        loadTile(xe, ke) {
          const He = xe.tileID.canonical.url(this.tiles, this.scheme), ir = this.map._requestManager.normalizeTileURL(He), ar = this.map._requestManager.transformRequest(ir, ne.R.Tile), yr = this.map.style ? this.map.style.getLut(this.scope) : null, Tr = yr ? { image: yr.image.clone() } : null, $r = { request: ar, data: void 0, uid: xe.uid, tileID: xe.tileID, tileZoom: xe.tileZoom, zoom: xe.tileID.overscaledZ, maxZoom: this.maxzoom, lut: Tr, tileSize: this.tileSize * xe.tileID.overscaleFactor(), type: this.type, source: this.id, scope: this.scope, pixelRatio: ne.q.devicePixelRatio, showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId, isSymbolTile: xe.isSymbolTile, brightness: this.map.style && this.map.style.getBrightness() || 0, extraShadowCaster: xe.isExtraShadowCaster, tessellationStep: this.map._tessellationStep, scaleFactor: this.map.getScaleFactor() };
          if (this.hasWorldviews && ne.f(He) && ($r.worldview = this.map.getWorldview() || this.worldviewDefault, $r.localizableLayerIds = this.localizableLayerIds), $r.request.collectResourceTiming = this._collectResourceTiming, xe.actor && xe.state !== "expired")
            xe.state === "loading" ? xe.reloadCallback = ke : xe.request = xe.actor.send("reloadTile", $r, Dr.bind(this));
          else if (xe.actor = this._tileWorkers[ir] = this._tileWorkers[ir] || this.dispatcher.getActor(), this.dispatcher.ready)
            xe.request = xe.actor.send("loadTile", $r, Dr.bind(this), void 0, !0);
          else {
            const Or = ne.aD.call({ deduped: this._deduped }, $r, (Gr, qr) => {
              Gr || !qr ? Dr.call(this, Gr) : ($r.data = { cacheControl: qr.cacheControl, expires: qr.expires, rawData: qr.rawData.slice(0) }, xe.actor && xe.actor.send("loadTile", $r, Dr.bind(this), void 0, !0));
            }, !0);
            xe.request = { cancel: Or };
          }
          function Dr(Or, Gr) {
            return delete xe.request, xe.aborted ? ke(null) : Or && Or.status !== 404 ? ke(Or) : (Gr && Gr.resourceTiming && (xe.resourceTiming = Gr.resourceTiming), this.map._refreshExpiredTiles && Gr && xe.setExpiryData(Gr), xe.loadVectorData(Gr, this.map.painter), ne.aE(this.dispatcher), ke(null), void (xe.reloadCallback && (this.loadTile(xe, xe.reloadCallback), xe.reloadCallback = null)));
          }
        }
        abortTile(xe) {
          xe.request && (xe.request.cancel(), delete xe.request), xe.actor && xe.actor.send("abortTile", { uid: xe.uid, type: this.type, source: this.id, scope: this.scope });
        }
        unloadTile(xe, ke) {
          xe.actor && xe.actor.send("removeTile", { uid: xe.uid, type: this.type, source: this.id, scope: this.scope }), xe.destroy();
        }
        hasTransition() {
          return !1;
        }
        afterUpdate() {
          this._tileWorkers = {};
        }
        cancelTileJSONRequest() {
          this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
        }
      }
      class Fc extends ne.E {
        constructor(xe, ke, He, ir) {
          super(), this.id = xe, this.dispatcher = He, this.setEventedParent(ir), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = ne.l({ type: "raster" }, ke), ne.l(this, ne.ay(ke, ["url", "scheme", "tileSize"]));
        }
        load(xe) {
          this._loaded = !1, this.fire(new ne.z("dataloading", { dataType: "source" })), this._tileJSONRequest = us(this._options, this.map._requestManager, null, null, (ke, He) => {
            this._tileJSONRequest = null, this._loaded = !0, ke ? this.fire(new ne.y(ke)) : He && (ne.l(this, He), He.raster_layers && (this.rasterLayers = He.raster_layers, this.rasterLayerIds = this.rasterLayers.map((ir) => ir.id)), He.bounds && (this.tileBounds = new Xa(He.bounds, this.minzoom, this.maxzoom)), Pr(He.tiles), this.fire(new ne.z("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new ne.z("data", { dataType: "source", sourceDataType: "content" }))), xe && xe(ke);
          });
        }
        loaded() {
          return this._loaded;
        }
        onAdd(xe) {
          this.map = xe, this.load();
        }
        reload() {
          this.cancelTileJSONRequest();
          const xe = ne.aC(this.id, this.scope);
          this.load(() => this.map.style.clearSource(xe));
        }
        setTiles(xe) {
          return this._options.tiles = xe, this.reload(), this;
        }
        setUrl(xe) {
          return this.url = xe, this._options.url = xe, this.reload(), this;
        }
        onRemove(xe) {
          this.cancelTileJSONRequest();
        }
        serialize() {
          return ne.l({}, this._options);
        }
        hasTile(xe) {
          return !this.tileBounds || this.tileBounds.contains(xe.canonical);
        }
        loadTile(xe, ke) {
          const He = ne.q.devicePixelRatio >= 2, ir = this.map._requestManager.normalizeTileURL(xe.tileID.canonical.url(this.tiles, this.scheme), He, this.tileSize);
          xe.request = ne.o(this.map._requestManager.transformRequest(ir, ne.R.Tile), (ar, yr, Tr, $r) => (delete xe.request, xe.aborted ? (xe.state = "unloaded", ke(null)) : ar ? (xe.state = "errored", ke(ar)) : yr ? (this.map._refreshExpiredTiles && xe.setExpiryData({ cacheControl: Tr, expires: $r }), xe.setTexture(yr, this.map.painter), xe.state = "loaded", ne.aE(this.dispatcher), void ke(null)) : ke(null)));
        }
        abortTile(xe, ke) {
          xe.request && (xe.request.cancel(), delete xe.request), ke && ke();
        }
        unloadTile(xe, ke) {
          xe.texture && xe.texture instanceof ne.T ? (xe.destroy(!0), xe.texture && xe.texture instanceof ne.T && this.map.painter.saveTileTexture(xe.texture)) : xe.destroy(), ke && ke();
        }
        hasTransition() {
          return !1;
        }
        cancelTileJSONRequest() {
          this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
        }
      }
      class Pl extends Fc {
        constructor(xe, ke, He, ir) {
          super(xe, ke, He, ir), this.type = "raster-array", this.maxzoom = 22, this._options = ne.l({ type: "raster-array" }, ke);
        }
        triggerRepaint(xe) {
          const ke = this.map.painter._terrain, He = this.map.style.getSourceCache(this.id);
          ke && ke.enabled && He && ke._clearRenderCacheForTile(He.id, xe.tileID), this.map.triggerRepaint();
        }
        loadTile(xe, ke) {
          const He = this.map._requestManager.normalizeTileURL(xe.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize), ir = this.map._requestManager.transformRequest(He, ne.R.Tile);
          xe.requestParams = ir, xe.actor || (xe.actor = this.dispatcher.getActor()), xe.request = xe.fetchHeader(void 0, (ar, yr, Tr, $r) => {
            if (delete xe.request, xe.aborted)
              return xe.state = "unloaded", ke(null);
            if (ar)
              return ar.code === 20 ? void 0 : (xe.state = "errored", ke(ar));
            this.map._refreshExpiredTiles && xe.setExpiryData({ cacheControl: Tr, expires: $r }), xe.state = "empty", ke(null);
          });
        }
        unloadTile(xe, ke) {
          const He = xe.texture;
          He && He instanceof ne.T ? (xe.destroy(!0), this.map.painter.saveTileTexture(He)) : (xe.destroy(), xe.flushQueues(), xe._isHeaderLoaded = !1, delete xe._mrt, delete xe.textureDescriptor), xe.fbo && (xe.fbo.destroy(), delete xe.fbo), delete xe.request, delete xe.requestParams, delete xe.neighboringTiles, xe.state = "unloaded";
        }
        prepareTile(xe, ke, He) {
          xe._isHeaderLoaded && (xe.state !== "empty" && (xe.state = "reloading"), xe.fetchBand(ke, He, (ir, ar) => {
            if (ir)
              return xe.state = "errored", this.fire(new ne.y(ir)), void this.triggerRepaint(xe);
            ar && (xe.setTexture(ar, this.map.painter), xe.state = "loaded", this.triggerRepaint(xe));
          }));
        }
        getInitialBand(xe) {
          if (!this.rasterLayers)
            return 0;
          const ke = this.rasterLayers.find(({ id: ar }) => ar === xe), He = ke && ke.fields, ir = He && He.bands && He.bands;
          return ir ? ir[0] : 0;
        }
        getTextureDescriptor(xe, ke, He) {
          if (!xe)
            return;
          const ir = ke.sourceLayer || this.rasterLayerIds && this.rasterLayerIds[0];
          if (!ir)
            return;
          let ar = null;
          ke instanceof ne.aH ? ar = ke.paint.get("raster-array-band") : ke instanceof ne.aI && (ar = ke.paint.get("raster-particle-array-band"));
          const yr = ar || this.getInitialBand(ir);
          if (yr != null)
            if (xe.textureDescriptor) {
              if (!xe.updateNeeded(ir, yr) || He)
                return Object.assign({}, xe.textureDescriptor, { texture: xe.texture });
            } else
              this.prepareTile(xe, ir, yr);
        }
      }
      const wu = { vector: hs, raster: Fc, "raster-dem": class extends Fc {
        constructor(qe, xe, ke, He) {
          super(qe, xe, ke, He), this.type = "raster-dem", this.maxzoom = 22, this._options = ne.l({ type: "raster-dem" }, xe), this.encoding = xe.encoding || "mapbox";
        }
        loadTile(qe, xe) {
          const ke = this.map._requestManager.normalizeTileURL(qe.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
          function He(ir, ar) {
            ir && (qe.state = "errored", xe(ir)), ar && (qe.dem = ar, qe.dem.onDeserialize(), qe.needsHillshadePrepare = !0, qe.needsDEMTextureUpload = !0, qe.state = "loaded", xe(null));
          }
          qe.request = ne.o(this.map._requestManager.transformRequest(ke, ne.R.Tile), function(ir, ar, yr, Tr) {
            if (delete qe.request, qe.aborted)
              qe.state = "unloaded", xe(null);
            else if (ir)
              qe.state = "errored", xe(ir);
            else if (ar) {
              this.map._refreshExpiredTiles && qe.setExpiryData({ cacheControl: yr, expires: Tr });
              const $r = ImageBitmap && ar instanceof ImageBitmap && ne.t(), Dr = 1 - (ar.width - ne.aF(ar.width)) / 2;
              Dr < 1 || qe.neighboringTiles || (qe.neighboringTiles = this._getNeighboringTiles(qe.tileID));
              const Or = $r ? ar : ne.q.getImageData(ar, Dr), Gr = { uid: qe.uid, coord: qe.tileID, source: this.id, scope: this.scope, rawImageData: Or, encoding: this.encoding, padding: Dr };
              qe.actor && qe.state !== "expired" || (qe.actor = this.dispatcher.getActor(), qe.actor.send("loadDEMTile", Gr, He.bind(this), void 0, !0));
            }
          }.bind(this));
        }
        _getNeighboringTiles(qe) {
          const xe = qe.canonical, ke = Math.pow(2, xe.z), He = (xe.x - 1 + ke) % ke, ir = xe.x === 0 ? qe.wrap - 1 : qe.wrap, ar = (xe.x + 1 + ke) % ke, yr = xe.x + 1 === ke ? qe.wrap + 1 : qe.wrap, Tr = {};
          return Tr[new ne.aG(qe.overscaledZ, ir, xe.z, He, xe.y).key] = { backfilled: !1 }, Tr[new ne.aG(qe.overscaledZ, yr, xe.z, ar, xe.y).key] = { backfilled: !1 }, xe.y > 0 && (Tr[new ne.aG(qe.overscaledZ, ir, xe.z, He, xe.y - 1).key] = { backfilled: !1 }, Tr[new ne.aG(qe.overscaledZ, qe.wrap, xe.z, xe.x, xe.y - 1).key] = { backfilled: !1 }, Tr[new ne.aG(qe.overscaledZ, yr, xe.z, ar, xe.y - 1).key] = { backfilled: !1 }), xe.y + 1 < ke && (Tr[new ne.aG(qe.overscaledZ, ir, xe.z, He, xe.y + 1).key] = { backfilled: !1 }, Tr[new ne.aG(qe.overscaledZ, qe.wrap, xe.z, xe.x, xe.y + 1).key] = { backfilled: !1 }, Tr[new ne.aG(qe.overscaledZ, yr, xe.z, ar, xe.y + 1).key] = { backfilled: !1 }), Tr;
        }
      }, "raster-array": Pl, geojson: class extends ne.E {
        constructor(qe, xe, ke, He) {
          super(), this.id = qe, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._loaded = !1, this.actor = ke.getActor(), this.setEventedParent(He), this._data = xe.data, this._options = ne.l({}, xe), this._collectResourceTiming = xe.collectResourceTiming, xe.maxzoom !== void 0 && (this.maxzoom = xe.maxzoom), xe.minzoom !== void 0 && (this.minzoom = xe.minzoom), xe.type && (this.type = xe.type), xe.attribution && (this.attribution = xe.attribution), this.promoteId = xe.promoteId;
          const ir = ne.ag / this.tileSize;
          this.workerOptions = ne.l({ source: this.id, scope: this.scope, cluster: xe.cluster || !1, geojsonVtOptions: { buffer: (xe.buffer !== void 0 ? xe.buffer : 128) * ir, tolerance: (xe.tolerance !== void 0 ? xe.tolerance : 0.375) * ir, extent: ne.ag, maxZoom: this.maxzoom, lineMetrics: xe.lineMetrics || !1, generateId: xe.generateId || !1 }, superclusterOptions: { maxZoom: xe.clusterMaxZoom !== void 0 ? xe.clusterMaxZoom : this.maxzoom - 1, minPoints: Math.max(2, xe.clusterMinPoints || 2), extent: ne.ag, radius: (xe.clusterRadius !== void 0 ? xe.clusterRadius : 50) * ir, log: !1, generateId: xe.generateId || !1 }, clusterProperties: xe.clusterProperties, filter: xe.filter, dynamic: xe.dynamic }, xe.workerOptions);
        }
        onAdd(qe) {
          this.map = qe, this.setData(this._data);
        }
        setData(qe) {
          return this._data = qe, this._updateWorkerData(), this;
        }
        updateData(qe) {
          if (!this._options.dynamic)
            return this.fire(new ne.y(new Error("Can't call updateData on a GeoJSON source with dynamic set to false.")));
          if (typeof qe != "string" && (qe.type === "Feature" && (qe = { type: "FeatureCollection", features: [qe] }), qe.type !== "FeatureCollection"))
            return this.fire(new ne.y(new Error("Data to update should be a feature or a feature collection.")));
          if (this._coalesce && typeof qe != "string" && typeof this._data != "string" && this._data.type === "FeatureCollection") {
            const xe = /* @__PURE__ */ new Map();
            for (const ke of this._data.features)
              xe.set(ke.id, ke);
            for (const ke of qe.features)
              xe.set(ke.id, ke);
            this._data.features = [...xe.values()];
          } else
            this._data = qe;
          return this._updateWorkerData(!0), this;
        }
        getClusterExpansionZoom(qe, xe) {
          return this.actor.send("geojson.getClusterExpansionZoom", { clusterId: qe, source: this.id, scope: this.scope }, xe), this;
        }
        getClusterChildren(qe, xe) {
          return this.actor.send("geojson.getClusterChildren", { clusterId: qe, source: this.id, scope: this.scope }, xe), this;
        }
        getClusterLeaves(qe, xe, ke, He) {
          return this.actor.send("geojson.getClusterLeaves", { source: this.id, scope: this.scope, clusterId: qe, limit: xe, offset: ke }, He), this;
        }
        _updateWorkerData(qe = !1) {
          if (this._pendingLoad)
            return void (this._coalesce = !0);
          this.fire(new ne.z("dataloading", { dataType: "source" })), this._loaded = !1;
          const xe = ne.l({ append: qe }, this.workerOptions);
          xe.scope = this.scope;
          const ke = this._data;
          typeof ke == "string" ? (xe.request = this.map._requestManager.transformRequest(ne.q.resolveURL(ke), ne.R.Source), xe.request.collectResourceTiming = this._collectResourceTiming) : xe.data = JSON.stringify(ke), this._pendingLoad = this.actor.send(`${this.type}.loadData`, xe, (He, ir) => {
            if (this._loaded = !0, this._pendingLoad = null, He)
              this.fire(new ne.y(He));
            else {
              const ar = { dataType: "source", sourceDataType: this._metadataFired ? "content" : "metadata" };
              this._collectResourceTiming && ir && ir.resourceTiming && ir.resourceTiming[this.id] && (ar.resourceTiming = ir.resourceTiming[this.id]), qe && (this._partialReload = !0), this.fire(new ne.z("data", ar)), this._partialReload = !1, this._metadataFired = !0;
            }
            this._coalesce && (this._updateWorkerData(qe), this._coalesce = !1);
          });
        }
        loaded() {
          return this._loaded;
        }
        loadTile(qe, xe) {
          const ke = qe.actor ? "reloadTile" : "loadTile";
          qe.actor = this.actor;
          const He = this.map.style ? this.map.style.getLut(this.scope) : null, ir = He ? { image: He.image.clone() } : null, ar = this._partialReload, yr = { type: this.type, uid: qe.uid, tileID: qe.tileID, tileZoom: qe.tileZoom, zoom: qe.tileID.overscaledZ, maxZoom: this.maxzoom, tileSize: this.tileSize, source: this.id, lut: ir, scope: this.scope, pixelRatio: ne.q.devicePixelRatio, showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId, brightness: this.map.style && this.map.style.getBrightness() || 0, scaleFactor: this.map.getScaleFactor(), partial: ar };
          qe.request = this.actor.send(ke, yr, (Tr, $r) => ar && !$r ? (qe.state = "loaded", xe(null)) : (delete qe.request, qe.destroy(), qe.aborted ? xe(null) : Tr ? xe(Tr) : (qe.loadVectorData($r, this.map.painter, ke === "reloadTile"), xe(null))), void 0, ke === "loadTile");
        }
        abortTile(qe) {
          qe.request && (qe.request.cancel(), delete qe.request), qe.aborted = !0;
        }
        unloadTile(qe, xe) {
          this.actor.send("removeTile", { uid: qe.uid, type: this.type, source: this.id, scope: this.scope }), qe.destroy();
        }
        onRemove(qe) {
          this._pendingLoad && this._pendingLoad.cancel();
        }
        serialize() {
          return ne.l({}, this._options, { type: this.type, data: this._data });
        }
        hasTransition() {
          return !1;
        }
      }, video: class extends ne.aJ {
        constructor(qe, xe, ke, He) {
          super(qe, xe, ke, He), this.roundZoom = !0, this.type = "video", this.options = xe;
        }
        load() {
          this._loaded = !1;
          const qe = this.options;
          this.urls = [];
          for (const xe of qe.urls)
            this.urls.push(this.map._requestManager.transformRequest(xe, ne.R.Source).url);
          ne.aK(this.urls, (xe, ke) => {
            this._loaded = !0, xe ? this.fire(new ne.y(xe)) : ke && (this.video = ke, this.video.loop = !0, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", () => {
              this.map.triggerRepaint();
            }), this.map && this.video.play(), this._finishLoading());
          });
        }
        pause() {
          this.video && this.video.pause();
        }
        play() {
          this.video && this.video.play();
        }
        seek(qe) {
          if (this.video) {
            const xe = this.video.seekable;
            qe < xe.start(0) || qe > xe.end(0) ? this.fire(new ne.y(new ne.V(`sources.${this.id}`, null, `Playback for this video can be set only between the ${xe.start(0)} and ${xe.end(0)}-second mark.`))) : this.video.currentTime = qe;
          }
        }
        getVideo() {
          return this.video;
        }
        onAdd(qe) {
          this.map || (this.map = qe, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
        }
        prepare() {
          if (Object.keys(this.tiles).length === 0 || this.video.readyState < 2)
            return;
          const qe = this.map.painter.context, xe = qe.gl;
          this.texture ? this.video.paused || (this.texture.bind(xe.LINEAR, xe.CLAMP_TO_EDGE), xe.texSubImage2D(xe.TEXTURE_2D, 0, 0, 0, xe.RGBA, xe.UNSIGNED_BYTE, this.video)) : (this.texture = new ne.T(qe, this.video, xe.RGBA8), this.texture.bind(xe.LINEAR, xe.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(qe);
        }
        serialize() {
          return { type: "video", urls: this.urls, coordinates: this.coordinates };
        }
        hasTransition() {
          return this.video && !this.video.paused;
        }
      }, image: ne.aJ, model: class extends ne.E {
        constructor(qe, xe, ke, He) {
          super(), this.id = qe, this.type = "model", this.models = [], this._loaded = !1, this._options = xe;
        }
        load() {
          const qe = [];
          for (const xe in this._options.models) {
            const ke = this._options.models[xe], He = ne.aM(this.map._requestManager.transformRequest(ke.uri, ne.R.Model).url).then((ir) => {
              if (!ir)
                return;
              const ar = ne.aN(ir), yr = new ne.aO(xe, ke.position, ke.orientation, ar);
              yr.computeBoundsAndApplyParent(), this.models.push(yr);
            }).catch((ir) => {
              this.fire(new ne.y(new Error(`Could not load model ${xe} from ${ke.uri}: ${ir.message}`)));
            });
            qe.push(He);
          }
          return Promise.allSettled(qe).then(() => {
            this._loaded = !0, this.fire(new ne.z("data", { dataType: "source", sourceDataType: "metadata" }));
          }).catch((xe) => {
            this.fire(new ne.y(new Error(`Could not load models: ${xe.message}`)));
          });
        }
        onAdd(qe) {
          this.map = qe, this.load();
        }
        hasTransition() {
          return !1;
        }
        loaded() {
          return this._loaded;
        }
        getModels() {
          return this.models;
        }
        loadTile(qe, xe) {
        }
        serialize() {
          return { type: "model" };
        }
      }, "batched-model": class extends ne.E {
        constructor(qe, xe, ke, He) {
          super(), this.type = "batched-model", this.id = qe, this.tileSize = 512, this._options = xe, this.tiles = this._options.tiles, this.maxzoom = xe.maxzoom || 19, this.minzoom = xe.minzoom || 0, this.roundZoom = !0, this.usedInConflation = !0, this.dispatcher = ke, this.reparseOverscaled = !1, this.scheme = "xyz", this._loaded = !1, this.setEventedParent(He);
        }
        onAdd(qe) {
          this.map = qe, this.load();
        }
        load(qe) {
          this._loaded = !1, this.fire(new ne.z("dataloading", { dataType: "source" }));
          const xe = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, ke = this.map.getWorldview();
          this._tileJSONRequest = us(this._options, this.map._requestManager, xe, ke, (He, ir) => {
            this._tileJSONRequest = null, this._loaded = !0, He ? (xe && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${xe}`), ke && ke.length !== 2 && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${ke}`), this.fire(new ne.y(He))) : ir && (ne.l(this, ir), ir.bounds && (this.tileBounds = new Xa(ir.bounds, this.minzoom, this.maxzoom)), Pr(ir.tiles, this.map._requestManager._customAccessToken), this.fire(new ne.z("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new ne.z("data", { dataType: "source", sourceDataType: "content" }))), qe && qe(He);
          });
        }
        hasTransition() {
          return !1;
        }
        hasTile(qe) {
          return !this.tileBounds || this.tileBounds.contains(qe.canonical);
        }
        loaded() {
          return this._loaded;
        }
        loadTile(qe, xe) {
          const ke = this.map._requestManager.normalizeTileURL(qe.tileID.canonical.url(this.tiles, this.scheme)), He = { request: this.map._requestManager.transformRequest(ke, ne.R.Tile), data: void 0, uid: qe.uid, tileID: qe.tileID, tileZoom: qe.tileZoom, zoom: qe.tileID.overscaledZ, tileSize: this.tileSize * qe.tileID.overscaleFactor(), type: this.type, source: this.id, scope: this.scope, showCollisionBoxes: this.map.showCollisionBoxes, isSymbolTile: qe.isSymbolTile, brightness: this.map.style && this.map.style.getBrightness() || 0, lut: null, maxZoom: null, promoteId: null, pixelRatio: null, scaleFactor: null };
          if (qe.actor && qe.state !== "expired")
            if (qe.state === "loading")
              qe.reloadCallback = xe;
            else {
              if (qe.buckets) {
                const ar = Object.values(qe.buckets);
                for (const yr of ar)
                  yr.dirty = !0;
                return void (qe.state = "loaded");
              }
              qe.request = qe.actor.send("reloadTile", He, ir.bind(this));
            }
          else
            qe.actor = this.dispatcher.getActor(), qe.request = qe.actor.send("loadTile", He, ir.bind(this), void 0, !0);
          function ir(ar, yr) {
            return qe.aborted ? xe(null) : ar && ar.status !== 404 ? xe(ar) : (this.map._refreshExpiredTiles && yr && qe.setExpiryData(yr), qe.loadModelData(yr, this.map.painter), qe.state = "loaded", void xe(null));
          }
        }
        serialize() {
          return ne.l({}, this._options);
        }
      }, canvas: class extends ne.aJ {
        constructor(qe, xe, ke, He) {
          super(qe, xe, ke, He), xe.coordinates ? Array.isArray(xe.coordinates) && xe.coordinates.length === 4 && !xe.coordinates.some((ir) => !Array.isArray(ir) || ir.length !== 2 || ir.some((ar) => typeof ar != "number")) || this.fire(new ne.y(new ne.V(`sources.${qe}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new ne.y(new ne.V(`sources.${qe}`, null, 'missing required property "coordinates"'))), xe.animate && typeof xe.animate != "boolean" && this.fire(new ne.y(new ne.V(`sources.${qe}`, null, 'optional "animate" property must be a boolean value'))), xe.canvas ? typeof xe.canvas == "string" || xe.canvas instanceof HTMLCanvasElement || this.fire(new ne.y(new ne.V(`sources.${qe}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new ne.y(new ne.V(`sources.${qe}`, null, 'missing required property "canvas"'))), this.options = xe, this.animate = xe.animate === void 0 || xe.animate;
        }
        load() {
          this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new ne.y(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
            this._playing = !0, this.map.triggerRepaint();
          }, this.pause = function() {
            this._playing && (this.prepare(), this._playing = !1);
          }, this._finishLoading());
        }
        getCanvas() {
          return this.canvas;
        }
        onAdd(qe) {
          this.map = qe, this.load(), this.canvas && this.animate && this.play();
        }
        onRemove(qe) {
          this.pause();
        }
        prepare() {
          let qe = !1;
          if (this.canvas.width !== this.width && (this.width = this.canvas.width, qe = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, qe = !0), this._hasInvalidDimensions() || Object.keys(this.tiles).length === 0)
            return;
          const xe = this.map.painter.context;
          this.texture ? !qe && !this._playing || this.texture instanceof ne.aL || this.texture.update(this.canvas, { premultiply: !0 }) : this.texture = new ne.T(xe, this.canvas, xe.gl.RGBA8, { premultiply: !0 }), this._prepareData(xe);
        }
        serialize() {
          return { type: "canvas", coordinates: this.coordinates };
        }
        hasTransition() {
          return this._playing;
        }
        _hasInvalidDimensions() {
          for (const qe of [this.canvas.width, this.canvas.height])
            if (isNaN(qe) || qe <= 0)
              return !0;
          return !1;
        }
      }, custom: class extends ne.E {
        constructor(qe, xe, ke, He) {
          super(), this.id = qe, this.type = "custom", this._dataType = "raster", this._dispatcher = ke, this._implementation = xe, this.setEventedParent(He), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = !1, this.roundZoom = !0, this._implementation || this.fire(new ne.y(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new ne.y(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new Xa(this._implementation.bounds, this.minzoom, this.maxzoom)), xe.update = this._update.bind(this), xe.clearTiles = this._clearTiles.bind(this), xe.coveringTiles = this._coveringTiles.bind(this), ne.l(this, ne.ay(xe, ["dataType", "scheme", "minzoom", "maxzoom", "tileSize", "attribution", "minTileCacheSize", "maxTileCacheSize"]));
        }
        serialize() {
          return ne.ay(this, ["type", "scheme", "minzoom", "maxzoom", "tileSize", "attribution"]);
        }
        load() {
          this._loaded = !0, this.fire(new ne.z("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new ne.z("data", { dataType: "source", sourceDataType: "content" }));
        }
        loaded() {
          return this._loaded;
        }
        onAdd(qe) {
          this.map = qe, this._loaded = !1, this.fire(new ne.z("dataloading", { dataType: "source" })), this._implementation.onAdd && this._implementation.onAdd(qe), this.load();
        }
        onRemove(qe) {
          this._implementation.onRemove && this._implementation.onRemove(qe);
        }
        hasTile(qe) {
          if (this._implementation.hasTile) {
            const { x: xe, y: ke, z: He } = qe.canonical;
            return this._implementation.hasTile({ x: xe, y: ke, z: He });
          }
          return !this.tileBounds || this.tileBounds.contains(qe.canonical);
        }
        loadTile(qe, xe) {
          const { x: ke, y: He, z: ir } = qe.tileID.canonical, ar = new AbortController();
          qe.request = Promise.resolve(this._implementation.loadTile({ x: ke, y: He, z: ir }, { signal: ar.signal })).then(function(yr) {
            return delete qe.request, qe.aborted ? (qe.state = "unloaded", xe(null)) : yr === void 0 ? (qe.state = "errored", xe(null)) : yr === null ? (this.loadTileData(qe, { width: this.tileSize, height: this.tileSize, data: null }), qe.state = "loaded", xe(null)) : function(Tr) {
              return Tr instanceof ImageData || Tr instanceof HTMLCanvasElement || Tr instanceof ImageBitmap || Tr instanceof HTMLImageElement;
            }(yr) ? (this.loadTileData(qe, yr), qe.state = "loaded", void xe(null)) : (qe.state = "errored", xe(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`)));
          }.bind(this)).catch((yr) => {
            yr.code !== 20 && (qe.state = "errored", xe(yr));
          }), qe.request.cancel = () => ar.abort();
        }
        loadTileData(qe, xe) {
          qe.setTexture(xe, this.map.painter);
        }
        unloadTile(qe, xe) {
          if (qe.texture && qe.texture instanceof ne.T ? (qe.destroy(!0), qe.texture && qe.texture instanceof ne.T && this.map.painter.saveTileTexture(qe.texture)) : qe.destroy(), this._implementation.unloadTile) {
            const { x: ke, y: He, z: ir } = qe.tileID.canonical;
            this._implementation.unloadTile({ x: ke, y: He, z: ir });
          }
          xe && xe();
        }
        abortTile(qe, xe) {
          qe.request && qe.request.cancel && (qe.request.cancel(), delete qe.request), xe && xe();
        }
        hasTransition() {
          return !1;
        }
        _coveringTiles() {
          return this.map.transform.coveringTiles({ tileSize: this.tileSize, minzoom: this.minzoom, maxzoom: this.maxzoom, roundZoom: this.roundZoom }).map((qe) => ({ x: qe.canonical.x, y: qe.canonical.y, z: qe.canonical.z }));
        }
        _clearTiles() {
          const qe = ne.aC(this.id, this.scope);
          this.map.style.clearSource(qe);
        }
        _update() {
          this.fire(new ne.z("data", { dataType: "source", sourceDataType: "content" }));
        }
      } }, yf = function(qe, xe, ke, He) {
        const ir = new wu[xe.type](qe, xe, ke, He);
        if (ir.id !== qe)
          throw new Error(`Expected Source id to be ${qe} instead of ${ir.id}`);
        return ne.aP(["load", "abort", "unload", "serialize", "prepare"], ir), ir;
      };
      function bf(qe, xe, ke, He, ir = !1) {
        const ar = xe.sourceCache.transform, yr = xe.sourceCache.tilesIn(qe, xe.has3DLayers, ir);
        yr.sort(ju);
        const Tr = [];
        for (const $r of yr) {
          const Dr = $r.tile.queryRenderedFeatures(xe, $r, ke, He, ar, ir);
          Object.keys(Dr).length && Tr.push({ wrappedTileID: $r.tile.tileID.wrapped().key, queryResults: Dr });
        }
        return Tr.length === 0 ? {} : function($r) {
          const Dr = {}, Or = {};
          for (const Gr of $r) {
            const qr = Gr.queryResults, Jr = Gr.wrappedTileID, bi = Or[Jr] = Or[Jr] || {};
            for (const fi in qr) {
              const Mi = qr[fi], Ei = bi[fi] = bi[fi] || {}, Ii = Dr[fi] = Dr[fi] || [];
              for (const Ni of Mi)
                Ei[Ni.featureIndex] || (Ei[Ni.featureIndex] = !0, Ii.push(Ni));
            }
          }
          return Dr;
        }(Tr);
      }
      function xf(qe, xe, ke, He, ir) {
        const ar = {}, yr = He.queryRenderedSymbols(qe), Tr = [];
        for (const $r of Object.keys(yr).map(Number))
          Tr.push(ir[$r]);
        Tr.sort(ju);
        for (const $r of Tr) {
          const Dr = $r.featureIndex.lookupSymbolFeatures(yr[$r.bucketInstanceId], $r.bucketIndex, $r.sourceLayerIndex, xe, ke);
          for (const Or in Dr) {
            const Gr = ar[Or] = ar[Or] || [], qr = Dr[Or];
            qr.sort((Jr, bi) => {
              const fi = $r.featureSortOrder;
              if (fi) {
                const Mi = fi.indexOf(Jr.featureIndex);
                return fi.indexOf(bi.featureIndex) - Mi;
              }
              return bi.featureIndex - Jr.featureIndex;
            });
            for (const Jr of qr)
              Gr.push(Jr);
          }
        }
        return ar;
      }
      function Lh(qe, xe) {
        const ke = qe.getRenderableIds().map((ar) => qe.getTileByID(ar)), He = [], ir = {};
        for (let ar = 0; ar < ke.length; ar++) {
          const yr = ke[ar], Tr = yr.tileID.canonical.key;
          ir[Tr] || (ir[Tr] = !0, yr.querySourceFeatures(He, xe));
        }
        return He;
      }
      function ju(qe, xe) {
        const ke = qe.tileID, He = xe.tileID;
        return ke.overscaledZ - He.overscaledZ || ke.canonical.y - He.canonical.y || ke.wrap - He.wrap || ke.canonical.x - He.canonical.x;
      }
      function wf(qe, xe) {
        const ke = {};
        if (!xe)
          return ke;
        for (const He of qe) {
          const ir = He.layerIds.map((ar) => xe.getLayer(ar)).filter(Boolean);
          if (ir.length !== 0) {
            He.layers = ir, He.stateDependentLayerIds && (He.stateDependentLayers = He.stateDependentLayerIds.map((ar) => ir.filter((yr) => yr.id === ar)[0]));
            for (const ar of ir)
              ke[ar.fqid] = He;
          }
        }
        return ke;
      }
      const Hl = 32, uc = 33, Wl = new Uint16Array(8184);
      for (let qe = 0; qe < 2046; qe++) {
        let xe = qe + 2, ke = 0, He = 0, ir = 0, ar = 0, yr = 0, Tr = 0;
        for (1 & xe ? ir = ar = yr = Hl : ke = He = Tr = Hl; (xe >>= 1) > 1; ) {
          const Dr = ke + ir >> 1, Or = He + ar >> 1;
          1 & xe ? (ir = ke, ar = He, ke = yr, He = Tr) : (ke = ir, He = ar, ir = yr, ar = Tr), yr = Dr, Tr = Or;
        }
        const $r = 4 * qe;
        Wl[$r + 0] = ke, Wl[$r + 1] = He, Wl[$r + 2] = ir, Wl[$r + 3] = ar;
      }
      const Zl = new Uint16Array(2178), ru = new Uint8Array(1089), _d = new Uint16Array(1089);
      function qu(qe) {
        return qe === 0 ? -0.03125 : qe === 32 ? 0.03125 : 0;
      }
      const Nc = (() => ({ type: 2, extent: ne.ag, loadGeometry: () => [[new ne.P(0, 0), new ne.P(ne.ag + 1, 0), new ne.P(ne.ag + 1, ne.ag + 1), new ne.P(0, ne.ag + 1), new ne.P(0, 0)]] }))();
      class Xl {
        constructor(xe, ke, He, ir, ar) {
          this.tileID = xe, this.uid = ne.aV(), this.uses = 0, this.tileSize = ke, this.tileZoom = He, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.isRaster = ar, ir && ir.style && (this._lastUpdatedBrightness = ir.style.getBrightness()), this.expiredRequestCount = 0, this.state = "loading", ir && ir.transform && (this.projection = ir.transform.projection);
        }
        registerFadeDuration(xe) {
          const ke = xe + this.timeAdded;
          ke < ne.q.now() || this.fadeEndTime && ke < this.fadeEndTime || (this.fadeEndTime = ke);
        }
        wasRequested() {
          return this.state === "errored" || this.state === "loaded" || this.state === "reloading";
        }
        get tileTransform() {
          return this._tileTransform || (this._tileTransform = ne.aQ(this.tileID.canonical, this.projection)), this._tileTransform;
        }
        loadVectorData(xe, ke, He) {
          if (this.unloadVectorData(), this.state = "loaded", xe) {
            xe.featureIndex && (this.latestFeatureIndex = xe.featureIndex, xe.rawTileData ? (this.latestRawTileData = xe.rawTileData, this.latestFeatureIndex.rawTileData = xe.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = xe.collisionBoxArray, this.buckets = wf(xe.buckets, ke.style), this.hasSymbolBuckets = !1;
            for (const ir in this.buckets) {
              const ar = this.buckets[ir];
              if (ar instanceof ne.aX) {
                if (this.hasSymbolBuckets = !0, !He)
                  break;
                ar.justReloaded = !0;
              }
            }
            if (this.hasRTLText = !1, this.hasSymbolBuckets)
              for (const ir in this.buckets) {
                const ar = this.buckets[ir];
                if (ar instanceof ne.aX && ar.hasRTLText) {
                  this.hasRTLText = !0, ne.aY();
                  break;
                }
              }
            this.queryPadding = 0;
            for (const ir in this.buckets) {
              const ar = this.buckets[ir], yr = ke.style.getOwnLayer(ir);
              if (!yr)
                continue;
              const Tr = yr.queryRadius(ar);
              this.queryPadding = Math.max(this.queryPadding, Tr);
            }
            xe.imageAtlas && (this.imageAtlas = xe.imageAtlas), xe.glyphAtlasImage && (this.glyphAtlasImage = xe.glyphAtlasImage), xe.lineAtlas && (this.lineAtlas = xe.lineAtlas), this._lastUpdatedBrightness = xe.brightness;
          } else
            this.collisionBoxArray = new ne.aW();
        }
        unloadVectorData() {
          if (this.hasData()) {
            for (const xe in this.buckets)
              this.buckets[xe].destroy();
            this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
          }
        }
        loadModelData(xe, ke, He) {
          xe && (xe.resourceTiming && (this.resourceTiming = xe.resourceTiming), this.buckets = { ...this.buckets, ...wf(xe.buckets, ke.style) }, xe.featureIndex && (this.latestFeatureIndex = xe.featureIndex));
        }
        getBucket(xe) {
          return this.buckets[xe.fqid];
        }
        upload(xe) {
          for (const ir in this.buckets) {
            const ar = this.buckets[ir];
            ar.uploadPending() && ar.upload(xe);
          }
          const ke = xe.gl, He = this.imageAtlas;
          if (He && !He.uploaded) {
            const ir = !!Object.keys(He.patternPositions).length;
            this.imageAtlasTexture = new ne.T(xe, He.image, ke.RGBA8, { useMipmap: ir }), this.imageAtlas.uploaded = !0;
          }
          this.glyphAtlasImage && (this.glyphAtlasTexture = new ne.T(xe, this.glyphAtlasImage, ke.R8), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new ne.T(xe, this.lineAtlas.image, ke.R8), this.lineAtlas.uploaded = !0);
        }
        prepare(xe, ke, He) {
          if (this.imageAtlas && this.imageAtlasTexture && this.imageAtlas.patchUpdatedImages(xe, this.imageAtlasTexture, He), !ke || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData)
            return;
          const ir = ke.style.getBrightness();
          (this._lastUpdatedBrightness || ir) && (this._lastUpdatedBrightness && ir && Math.abs(this._lastUpdatedBrightness - ir) < 1e-3 || (this.updateBuckets(ke, this._lastUpdatedBrightness !== ir), this._lastUpdatedBrightness = ir));
        }
        queryRenderedFeatures(xe, ke, He, ir, ar, yr) {
          if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData && !this.latestFeatureIndex.is3DTile)
            return {};
          const Tr = function($r, Dr) {
            const Or = ne.ab.mat4.fromScaling([], [0.5 * $r.width, 0.5 * -$r.height, 1]);
            return ne.ab.mat4.translate(Or, Or, [1, -1, 0]), ne.ab.mat4.multiply(Or, Or, $r.calculateProjMatrix(Dr.toUnwrapped())), Float32Array.from(Or);
          }(ar, this.tileID);
          return this.latestFeatureIndex.query(xe, { tilespaceGeometry: ke, pixelPosMatrix: Tr, transform: ir, availableImages: He, tileTransform: this.tileTransform });
        }
        querySourceFeatures(xe, ke) {
          const He = this.latestFeatureIndex;
          if (!He || !He.rawTileData)
            return;
          const ir = He.loadVTLayers(), ar = ke ? ke.sourceLayer : "", yr = ir._geojsonTileLayer || ir[ar];
          if (!yr)
            return;
          const Tr = ne.aZ(ke && ke.filter), { z: $r, x: Dr, y: Or } = this.tileID.canonical, Gr = { z: $r, x: Dr, y: Or };
          for (let qr = 0; qr < yr.length; qr++) {
            const Jr = yr.feature(qr);
            if (Tr.needGeometry) {
              const Mi = ne.a_(Jr, !0);
              if (!Tr.filter(new ne.a8(this.tileID.overscaledZ), Mi, this.tileID.canonical))
                continue;
            } else if (!Tr.filter(new ne.a8(this.tileID.overscaledZ), Jr))
              continue;
            const bi = He.getId(Jr, ar), fi = new ne.a$(Jr, $r, Dr, Or, bi);
            fi.tile = Gr, xe.push(fi);
          }
        }
        hasData() {
          return this.state === "loaded" || this.state === "reloading" || this.state === "expired";
        }
        patternsLoaded() {
          return !!this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
        }
        setExpiryData(xe) {
          const ke = this.expirationTime;
          if (xe.cacheControl) {
            const He = ne.b0(xe.cacheControl);
            He["max-age"] && (this.expirationTime = Date.now() + 1e3 * He["max-age"]);
          } else
            xe.expires && (this.expirationTime = new Date(xe.expires).getTime());
          if (this.expirationTime) {
            const He = Date.now();
            let ir = !1;
            if (this.expirationTime > He)
              ir = !1;
            else if (ke)
              if (this.expirationTime < ke)
                ir = !0;
              else {
                const ar = this.expirationTime - ke;
                ar ? this.expirationTime = He + Math.max(ar, 3e4) : ir = !0;
              }
            else
              ir = !0;
            ir ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
          }
        }
        getExpiryTimeout() {
          if (this.expirationTime)
            return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - new Date().getTime(), Math.pow(2, 31) - 1);
        }
        refreshFeatureState(xe) {
          this.latestFeatureIndex && (this.latestFeatureIndex.rawTileData || this.latestFeatureIndex.is3DTile) && xe && this.updateBuckets(xe);
        }
        updateBuckets(xe, ke) {
          if (!this.latestFeatureIndex || !xe.style)
            return;
          const He = this.latestFeatureIndex.loadVTLayers(), ir = xe.style.listImages(), ar = xe.style.getBrightness();
          for (const yr in this.buckets) {
            if (!xe.style.hasLayer(yr))
              continue;
            const Tr = this.buckets[yr], $r = Tr.layers[0], Dr = $r.sourceLayer || "_geojsonTileLayer", Or = He[Dr], Gr = xe.style.getLayerSourceCache($r);
            let qr = {};
            Gr && (qr = Gr._state.getState(Dr, void 0));
            const Jr = this.imageAtlas && this.imageAtlas.patternPositions || {}, bi = Object.keys(qr).length > 0 && !ke;
            bi && !Tr.stateDependentLayers.length && !ke || Tr.update(qr, Or, ir, Jr, bi ? Tr.stateDependentLayers : Tr.layers, ke, ar), (Tr instanceof ne.b1 || Tr instanceof ne.b2) && xe._terrain && xe._terrain.enabled && Gr && Tr.programConfigurations.needsUpload && xe._terrain._clearRenderCacheForTile(Gr.id, this.tileID);
            const fi = xe && xe.style && xe.style.getOwnLayer(yr);
            fi && (this.queryPadding = Math.max(this.queryPadding, fi.queryRadius(Tr)));
          }
        }
        holdingForFade() {
          return this.symbolFadeHoldUntil !== void 0;
        }
        symbolFadeFinished() {
          return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < ne.q.now();
        }
        clearFadeHold() {
          this.symbolFadeHoldUntil = void 0;
        }
        setHoldDuration(xe) {
          this.symbolFadeHoldUntil = ne.q.now() + xe;
        }
        setTexture(xe, ke) {
          const He = ke.context, ir = He.gl;
          this.texture = this.texture || ke.getTileTexture(xe.width), this.texture && this.texture instanceof ne.T ? this.texture.update(xe) : (this.texture = new ne.T(He, xe, ir.RGBA8, { useMipmap: !0 }), this.texture.bind(ir.LINEAR, ir.CLAMP_TO_EDGE));
        }
        setDependencies(xe, ke) {
          const He = {};
          for (const ir of ke)
            He[ir] = !0;
          this.dependencies[xe] = He;
        }
        hasDependency(xe, ke) {
          for (const He of xe) {
            const ir = this.dependencies[He];
            if (ir) {
              for (const ar of ke)
                if (ir[ar])
                  return !0;
            }
          }
          return !1;
        }
        clearQueryDebugViz() {
        }
        _makeDebugTileBoundsBuffers(xe, ke) {
          if (!ke || ke.name === "mercator" || this._tileDebugBuffer)
            return;
          const He = ne.b3(Nc, this.tileID.canonical, this.tileTransform)[0], ir = new ne.b4(), ar = new ne.b5();
          for (let yr = 0; yr < He.length; yr++) {
            const { x: Tr, y: $r } = He[yr];
            ir.emplaceBack(Tr, $r), ar.emplaceBack(yr);
          }
          ar.emplaceBack(0), this._tileDebugIndexBuffer = xe.createIndexBuffer(ar), this._tileDebugBuffer = xe.createVertexBuffer(ir, ne.b6.members), this._tileDebugSegments = ne.b7.simpleSegment(0, 0, ir.length, ar.length);
        }
        _makeTileBoundsBuffers(xe, ke) {
          if (this._tileBoundsBuffer || !ke || ke.name === "mercator")
            return;
          const He = ne.b3(Nc, this.tileID.canonical, this.tileTransform)[0];
          let ir, ar;
          if (this.isRaster) {
            const yr = function(Tr, $r) {
              const Dr = ne.aQ(Tr, $r), Or = Math.pow(2, Tr.z);
              for (let Mi = 0; Mi < uc; Mi++)
                for (let Ei = 0; Ei < uc; Ei++) {
                  const Ii = ne.aR((Tr.x + (Ei + qu(Ei)) / Hl) / Or), Ni = ne.aS((Tr.y + (Mi + qu(Mi)) / Hl) / Or), zi = $r.project(Ii, Ni), Ki = Mi * uc + Ei;
                  Zl[2 * Ki + 0] = Math.round((zi.x * Dr.scale - Dr.x) * ne.ag), Zl[2 * Ki + 1] = Math.round((zi.y * Dr.scale - Dr.y) * ne.ag);
                }
              ru.fill(0), _d.fill(0);
              for (let Mi = 2045; Mi >= 0; Mi--) {
                const Ei = 4 * Mi, Ii = Wl[Ei + 0], Ni = Wl[Ei + 1], zi = Wl[Ei + 2], Ki = Wl[Ei + 3], Wi = Ii + zi >> 1, Xi = Ni + Ki >> 1, Gi = Wi + Xi - Ni, nn = Xi + Ii - Wi, dn = Ni * uc + Ii, Pn = Ki * uc + zi, Ln = Xi * uc + Wi, hn = Math.hypot((Zl[2 * dn + 0] + Zl[2 * Pn + 0]) / 2 - Zl[2 * Ln + 0], (Zl[2 * dn + 1] + Zl[2 * Pn + 1]) / 2 - Zl[2 * Ln + 1]) >= 16;
                ru[Ln] = ru[Ln] || (hn ? 1 : 0), Mi < 1022 && (ru[Ln] = ru[Ln] || ru[(Ni + nn >> 1) * uc + (Ii + Gi >> 1)] || ru[(Ki + nn >> 1) * uc + (zi + Gi >> 1)]);
              }
              const Gr = new ne.aT(), qr = new ne.aU();
              let Jr = 0;
              function bi(Mi, Ei) {
                const Ii = Ei * uc + Mi;
                return _d[Ii] === 0 && (Gr.emplaceBack(Zl[2 * Ii + 0], Zl[2 * Ii + 1], Mi * ne.ag / Hl, Ei * ne.ag / Hl), _d[Ii] = ++Jr), _d[Ii] - 1;
              }
              function fi(Mi, Ei, Ii, Ni, zi, Ki) {
                const Wi = Mi + Ii >> 1, Xi = Ei + Ni >> 1;
                if (Math.abs(Mi - zi) + Math.abs(Ei - Ki) > 1 && ru[Xi * uc + Wi])
                  fi(zi, Ki, Mi, Ei, Wi, Xi), fi(Ii, Ni, zi, Ki, Wi, Xi);
                else {
                  const Gi = bi(Mi, Ei), nn = bi(Ii, Ni), dn = bi(zi, Ki);
                  qr.emplaceBack(Gi, nn, dn);
                }
              }
              return fi(0, 0, Hl, Hl, Hl, 0), fi(Hl, Hl, 0, 0, 0, Hl), { vertices: Gr, indices: qr };
            }(this.tileID.canonical, ke);
            ir = yr.vertices, ar = yr.indices;
          } else {
            ir = new ne.aT(), ar = new ne.aU();
            for (const { x: Tr, y: $r } of He)
              ir.emplaceBack(Tr, $r, 0, 0);
            const yr = ne.b8(ir.int16, void 0, 4);
            for (let Tr = 0; Tr < yr.length; Tr += 3)
              ar.emplaceBack(yr[Tr], yr[Tr + 1], yr[Tr + 2]);
          }
          this._tileBoundsBuffer = xe.createVertexBuffer(ir, ne.b9.members), this._tileBoundsIndexBuffer = xe.createIndexBuffer(ar), this._tileBoundsSegments = ne.b7.simpleSegment(0, 0, ir.length, ar.length);
        }
        _makeGlobeTileDebugBuffers(xe, ke) {
          const He = ke.projection;
          if (!He || He.name !== "globe" || ke.freezeTileCoverage)
            return;
          const ir = this.tileID.canonical, ar = ne.ba(ir, ke), yr = ne.bb(ar), Tr = ne.ae(ke.zoom);
          let $r;
          Tr > 0 && ($r = ne.ab.mat4.invert(new Float64Array(16), ke.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(xe, ir, ke, yr, $r, Tr), this._makeGlobeTileDebugTextBuffer(xe, ir, ke, yr, $r, Tr);
        }
        _globePoint(xe, ke, He, ir, ar, yr, Tr) {
          let $r = ne.bc(xe, ke, He);
          if (yr) {
            const Dr = 1 << He.z, Or = ne.at(ir.center.lng), Gr = ne.aA(ir.center.lat), qr = (He.x + 0.5) / Dr - Or;
            let Jr = 0;
            qr > 0.5 ? Jr = -1 : qr < -0.5 && (Jr = 1);
            let bi = (xe / ne.ag + He.x) / Dr + Jr, fi = (ke / ne.ag + He.y) / Dr;
            bi = (bi - Or) * ir._pixelsPerMercatorPixel + Or, fi = (fi - Gr) * ir._pixelsPerMercatorPixel + Gr;
            const Mi = [bi * ir.worldSize, fi * ir.worldSize, 0];
            ne.ab.vec3.transformMat4(Mi, Mi, yr), $r = ne.bd($r, Mi, Tr);
          }
          return ne.ab.vec3.transformMat4($r, $r, ar);
        }
        _makeGlobeTileDebugBorderBuffer(xe, ke, He, ir, ar, yr) {
          const Tr = new ne.b4(), $r = new ne.b5(), Dr = new ne.be(), Or = (qr, Jr, bi, fi, Mi) => {
            const Ei = (bi - qr) / (Mi - 1), Ii = (fi - Jr) / (Mi - 1), Ni = Tr.length;
            for (let zi = 0; zi < Mi; zi++) {
              const Ki = qr + zi * Ei, Wi = Jr + zi * Ii;
              Tr.emplaceBack(Ki, Wi);
              const Xi = this._globePoint(Ki, Wi, ke, He, ir, ar, yr);
              Dr.emplaceBack(Xi[0], Xi[1], Xi[2]), $r.emplaceBack(Ni + zi);
            }
          }, Gr = ne.ag;
          Or(0, 0, Gr, 0, 16), Or(Gr, 0, Gr, Gr, 16), Or(Gr, Gr, 0, Gr, 16), Or(0, Gr, 0, 0, 16), this._tileDebugIndexBuffer = xe.createIndexBuffer($r), this._tileDebugBuffer = xe.createVertexBuffer(Tr, ne.b6.members), this._globeTileDebugBorderBuffer = xe.createVertexBuffer(Dr, ne.bf.members), this._tileDebugSegments = ne.b7.simpleSegment(0, 0, Tr.length, $r.length);
        }
        _makeGlobeTileDebugTextBuffer(xe, ke, He, ir, ar, yr) {
          const Tr = ne.ag / 4, $r = new ne.b4(), Dr = new ne.aU(), Or = new ne.be(), Gr = 25;
          Dr.reserve(32), $r.reserve(Gr), Or.reserve(Gr);
          const qr = (Jr, bi) => Gr * Jr + bi;
          for (let Jr = 0; Jr < Gr; Jr++) {
            const bi = Jr * Tr;
            for (let fi = 0; fi < Gr; fi++) {
              const Mi = fi * Tr;
              $r.emplaceBack(Mi, bi);
              const Ei = this._globePoint(Mi, bi, ke, He, ir, ar, yr);
              Or.emplaceBack(Ei[0], Ei[1], Ei[2]);
            }
          }
          for (let Jr = 0; Jr < 4; Jr++)
            for (let bi = 0; bi < 4; bi++) {
              const fi = qr(Jr, bi), Mi = qr(Jr, bi + 1), Ei = qr(Jr + 1, bi), Ii = qr(Jr + 1, bi + 1);
              Dr.emplaceBack(fi, Mi, Ei), Dr.emplaceBack(Ei, Mi, Ii);
            }
          this._tileDebugTextIndexBuffer = xe.createIndexBuffer(Dr), this._tileDebugTextBuffer = xe.createVertexBuffer($r, ne.b6.members), this._globeTileDebugTextBuffer = xe.createVertexBuffer(Or, ne.bf.members), this._tileDebugTextSegments = ne.b7.simpleSegment(0, 0, Gr, 32);
        }
        destroy(xe = !1) {
          for (const ke in this.buckets)
            this.buckets[ke].destroy();
          this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture.destroy(), delete this.imageAtlasTexture), this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), !xe && this.texture && this.texture instanceof ne.T && (this.texture.destroy(), delete this.texture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.rasterParticleState && (this.rasterParticleState.destroy(), delete this.rasterParticleState), this.latestFeatureIndex = null, this.state = "unloaded";
        }
      }
      ne.bg.setPbf(ne.bh);
      class yd extends Xl {
        constructor(xe, ke, He, ir, ar) {
          super(xe, ke, He, ir, ar), this._workQueue = [], this._fetchQueue = [], this._isHeaderLoaded = !1;
        }
        setTexture(xe, ke) {
          const He = ke.context, ir = He.gl;
          this.texture = this.texture || ke.getTileTexture(xe.width), this.texture && this.texture instanceof ne.T ? this.texture.update(xe, { premultiply: !1 }) : this.texture = new ne.T(He, xe, ir.RGBA8, { premultiply: !1 });
        }
        flushQueues() {
          for (; this._workQueue.length; )
            this._workQueue.pop()();
          for (; this._fetchQueue.length; )
            this._fetchQueue.pop()();
        }
        fetchHeader(xe = 16384, ke) {
          const He = this._mrt = new ne.bg(30), ir = Object.assign({}, this.requestParams, { headers: { Range: "bytes=0-" + (xe - 1) } });
          return this.entireBuffer = null, this.request = ne.bi(ir, (ar, yr, Tr, $r) => {
            if (ar)
              ke(ar);
            else
              try {
                const Dr = He.getHeaderLength(yr);
                if (Dr > xe)
                  return void (this.request = this.fetchHeader(Dr, ke));
                He.parseHeader(yr), this._isHeaderLoaded = !0;
                let Or = 0;
                for (const Gr of Object.values(He.layers))
                  Or = Math.max(Or, Gr.dataIndex[Gr.dataIndex.length - 1].last_byte);
                yr.byteLength >= Or && (this.entireBuffer = yr), ke(null, this.entireBuffer || yr, Tr, $r);
              } catch (Dr) {
                ke(Dr);
              }
          }), this.request;
        }
        fetchBand(xe, ke, He) {
          const ir = this._mrt;
          if (!this._isHeaderLoaded || !ir)
            return void He(new Error("Tile header is not ready"));
          const ar = this.actor;
          if (!ar)
            return void He(new Error("Can't fetch tile band without an actor"));
          let yr;
          const Tr = (Gr, qr) => {
            yr.complete(Gr, qr), Gr ? He(Gr) : (this.updateTextureDescriptor(xe, ke), He(null, this.textureDescriptor && this.textureDescriptor.img));
          }, $r = (Gr, qr) => {
            if (Gr)
              return He(Gr);
            const Jr = ar.send("decodeRasterArray", { buffer: qr, task: yr }, Tr, void 0, !0);
            this._workQueue.push(() => {
              Jr && Jr.cancel(), yr.cancel();
            });
          }, Dr = ir.getLayer(xe);
          if (!Dr)
            return void He(new Error(`Unknown sourceLayer "${xe}"`));
          if (Dr.hasDataForBand(ke))
            return this.updateTextureDescriptor(xe, ke), void He(null, this.textureDescriptor ? this.textureDescriptor.img : null);
          const Or = Dr.getDataRange([ke]);
          if (yr = ir.createDecodingTask(Or), !yr || yr.tasks.length)
            if (this.flushQueues(), this.entireBuffer)
              $r(null, this.entireBuffer.slice(Or.firstByte, Or.lastByte + 1));
            else {
              const Gr = Object.assign({}, this.requestParams, { headers: { Range: `bytes=${Or.firstByte}-${Or.lastByte}` } }), qr = ne.bi(Gr, $r);
              this._fetchQueue.push(() => {
                qr.cancel(), yr.cancel();
              });
            }
          else
            He(null);
        }
        updateNeeded(xe, ke) {
          return (!this.textureDescriptor || this.textureDescriptor.band !== ke || this.textureDescriptor.layer !== xe) && this.state !== "errored";
        }
        updateTextureDescriptor(xe, ke) {
          if (!this._mrt)
            return;
          const He = this._mrt.getLayer(xe);
          if (!He || !He.hasBand(ke) || !He.hasDataForBand(ke))
            return;
          const { bytes: ir, tileSize: ar, buffer: yr, offset: Tr, scale: $r } = He.getBandView(ke), Dr = ar + 2 * yr, Or = { data: ir, width: Dr, height: Dr }, Gr = this.texture;
          Gr && Gr instanceof ne.T && Gr.update(Or, { premultiply: !1 }), this.textureDescriptor = { layer: xe, band: ke, img: Or, buffer: yr, offset: Tr, tileSize: ar, format: He.pixelFormat, mix: [$r, 256 * $r, 65536 * $r, 16777216 * $r] };
        }
      }
      class Mf {
        constructor(xe, ke) {
          this.max = xe, this.onRemove = ke, this.reset();
        }
        reset() {
          for (const xe in this.data)
            for (const ke of this.data[xe])
              ke.timeout && clearTimeout(ke.timeout), this.onRemove(ke.value);
          return this.data = {}, this.order = [], this;
        }
        add(xe, ke, He) {
          const ir = xe.wrapped().key;
          this.data[ir] === void 0 && (this.data[ir] = []);
          const ar = { value: ke, timeout: void 0 };
          if (He !== void 0 && (ar.timeout = setTimeout(() => {
            this.remove(xe, ar);
          }, He)), this.data[ir].push(ar), this.order.push(ir), this.order.length > this.max) {
            const yr = this._getAndRemoveByKey(this.order[0]);
            yr && this.onRemove(yr);
          }
          return this;
        }
        has(xe) {
          return xe.wrapped().key in this.data;
        }
        getAndRemove(xe) {
          return this.has(xe) ? this._getAndRemoveByKey(xe.wrapped().key) : null;
        }
        _getAndRemoveByKey(xe) {
          const ke = this.data[xe].shift();
          return ke.timeout && clearTimeout(ke.timeout), this.data[xe].length === 0 && delete this.data[xe], this.order.splice(this.order.indexOf(xe), 1), ke.value;
        }
        getByKey(xe) {
          const ke = this.data[xe];
          return ke ? ke[0].value : null;
        }
        get(xe) {
          return this.has(xe) ? this.data[xe.wrapped().key][0].value : null;
        }
        remove(xe, ke) {
          if (!this.has(xe))
            return this;
          const He = xe.wrapped().key, ir = ke === void 0 ? 0 : this.data[He].indexOf(ke), ar = this.data[He][ir];
          return this.data[He].splice(ir, 1), ar.timeout && clearTimeout(ar.timeout), this.data[He].length === 0 && delete this.data[He], this.onRemove(ar.value), this.order.splice(this.order.indexOf(He), 1), this;
        }
        setMaxSize(xe) {
          for (this.max = xe; this.order.length > this.max; ) {
            const ke = this._getAndRemoveByKey(this.order[0]);
            ke && this.onRemove(ke);
          }
          return this;
        }
        filter(xe) {
          const ke = [];
          for (const He in this.data)
            for (const ir of this.data[He])
              xe(ir.value) || ke.push(ir);
          for (const He of ke)
            this.remove(He.value.tileID, He);
        }
      }
      class Ih {
        constructor() {
          this.state = {}, this.stateChanges = {}, this.deletedStates = {};
        }
        updateState(xe, ke, He) {
          const ir = String(ke);
          if (this.stateChanges[xe] = this.stateChanges[xe] || {}, this.stateChanges[xe][ir] = this.stateChanges[xe][ir] || {}, ne.l(this.stateChanges[xe][ir], He), this.deletedStates[xe] === null) {
            this.deletedStates[xe] = {};
            for (const ar in this.state[xe])
              ar !== ir && (this.deletedStates[xe][ar] = null);
          } else if (this.deletedStates[xe] && this.deletedStates[xe][ir] === null) {
            this.deletedStates[xe][ir] = {};
            for (const ar in this.state[xe][ir])
              He[ar] || (this.deletedStates[xe][ir][ar] = null);
          } else
            for (const ar in He)
              this.deletedStates[xe] && this.deletedStates[xe][ir] && this.deletedStates[xe][ir][ar] === null && delete this.deletedStates[xe][ir][ar];
        }
        removeFeatureState(xe, ke, He) {
          if (this.deletedStates[xe] === null)
            return;
          const ir = String(ke);
          if (this.deletedStates[xe] = this.deletedStates[xe] || {}, He && ke !== void 0)
            this.deletedStates[xe][ir] !== null && (this.deletedStates[xe][ir] = this.deletedStates[xe][ir] || {}, this.deletedStates[xe][ir][He] = null);
          else if (ke !== void 0)
            if (this.stateChanges[xe] && this.stateChanges[xe][ir])
              for (He in this.deletedStates[xe][ir] = {}, this.stateChanges[xe][ir])
                this.deletedStates[xe][ir][He] = null;
            else
              this.deletedStates[xe][ir] = null;
          else
            this.deletedStates[xe] = null;
        }
        getState(xe, ke) {
          const He = this.state[xe] || {}, ir = this.stateChanges[xe] || {}, ar = this.deletedStates[xe];
          if (ar === null)
            return {};
          if (ke !== void 0) {
            const Tr = String(ke), $r = ne.l({}, He[Tr], ir[Tr]);
            if (ar) {
              const Dr = ar[ke];
              if (Dr === null)
                return {};
              for (const Or in Dr)
                delete $r[Or];
            }
            return $r;
          }
          const yr = ne.l({}, He, ir);
          if (ar)
            for (const Tr in ar)
              delete yr[Tr];
          return yr;
        }
        initializeTileState(xe, ke) {
          xe.refreshFeatureState(ke);
        }
        coalesceChanges(xe, ke) {
          const He = {};
          for (const ir in this.stateChanges) {
            this.state[ir] = this.state[ir] || {};
            const ar = {};
            for (const yr in this.stateChanges[ir])
              this.state[ir][yr] || (this.state[ir][yr] = {}), ne.l(this.state[ir][yr], this.stateChanges[ir][yr]), ar[yr] = this.state[ir][yr];
            He[ir] = ar;
          }
          for (const ir in this.deletedStates) {
            this.state[ir] = this.state[ir] || {};
            const ar = {};
            if (this.deletedStates[ir] === null)
              for (const yr in this.state[ir])
                ar[yr] = {}, this.state[ir][yr] = {};
            else
              for (const yr in this.deletedStates[ir]) {
                if (this.deletedStates[ir][yr] === null)
                  this.state[ir][yr] = {};
                else if (this.state[ir][yr])
                  for (const Tr of Object.keys(this.deletedStates[ir][yr]))
                    delete this.state[ir][yr][Tr];
                ar[yr] = this.state[ir][yr];
              }
            He[ir] = He[ir] || {}, ne.l(He[ir], ar);
          }
          if (this.stateChanges = {}, this.deletedStates = {}, Object.keys(He).length !== 0)
            for (const ir in xe)
              xe[ir].refreshFeatureState(ke);
        }
      }
      class Kl extends ne.E {
        constructor(xe, ke, He) {
          super(), this.id = xe, this._onlySymbols = He, ke.on("data", (ir) => {
            ir.dataType === "source" && ir.sourceDataType === "metadata" && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && ir.dataType === "source" && ir.sourceDataType === "content" && (this.reload(), this.transform && this.update(this.transform));
          }), ke.on("error", () => {
            this._sourceErrored = !0;
          }), this._source = ke, this._tiles = {}, this._cache = new Mf(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = ke.minTileCacheSize, this._maxTileCacheSize = ke.maxTileCacheSize, this._loadedParentTiles = {}, this.castsShadows = !1, this.tileCoverLift = 0, this._coveredTiles = {}, this._shadowCasterTiles = {}, this._state = new Ih(), this._isRaster = this._source.type === "raster" || this._source.type === "raster-dem" || this._source.type === "raster-array" || this._source.type === "custom" && this._source._dataType === "raster";
        }
        onAdd(xe) {
          this.map = xe, this._minTileCacheSize = this._minTileCacheSize === void 0 && xe ? xe._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = this._maxTileCacheSize === void 0 && xe ? xe._maxTileCacheSize : this._maxTileCacheSize;
        }
        loaded() {
          if (this._sourceErrored)
            return !0;
          if (!this._sourceLoaded || !this._source.loaded())
            return !1;
          for (const xe in this._tiles) {
            const ke = this._tiles[xe];
            if (ke.state !== "loaded" && ke.state !== "errored")
              return !1;
          }
          return !0;
        }
        getSource() {
          return this._source;
        }
        pause() {
          this._paused = !0;
        }
        resume() {
          if (!this._paused)
            return;
          const xe = this._shouldReloadOnResume;
          this._paused = !1, this._shouldReloadOnResume = !1, xe && this.reload(), this.transform && this.update(this.transform);
        }
        _loadTile(xe, ke) {
          return xe.isSymbolTile = this._onlySymbols, xe.isExtraShadowCaster = this._shadowCasterTiles[xe.tileID.key], this._source.loadTile(xe, ke);
        }
        _unloadTile(xe) {
          if (this._source.unloadTile)
            return this._source.unloadTile(xe);
        }
        _abortTile(xe) {
          if (this._source.abortTile)
            return this._source.abortTile(xe);
        }
        serialize() {
          return this._source.serialize();
        }
        prepare(xe) {
          this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
          for (const ke in this._tiles) {
            const He = this._tiles[ke];
            He.upload(xe), He.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
          }
        }
        getIds() {
          return ne.bj(this._tiles).map((xe) => xe.tileID).sort(bd).map((xe) => xe.key);
        }
        getRenderableIds(xe, ke) {
          const He = [];
          for (const ir in this._tiles)
            this._isIdRenderable(+ir, xe, ke) && He.push(this._tiles[ir]);
          return xe ? He.sort((ir, ar) => {
            const yr = ir.tileID, Tr = ar.tileID, $r = new ne.P(yr.canonical.x, yr.canonical.y)._rotate(this.transform.angle), Dr = new ne.P(Tr.canonical.x, Tr.canonical.y)._rotate(this.transform.angle);
            return yr.overscaledZ - Tr.overscaledZ || Dr.y - $r.y || Dr.x - $r.x;
          }).map((ir) => ir.tileID.key) : He.map((ir) => ir.tileID).sort(bd).map((ir) => ir.key);
        }
        hasRenderableParent(xe) {
          const ke = this.findLoadedParent(xe, 0);
          return !!ke && this._isIdRenderable(ke.tileID.key);
        }
        _isIdRenderable(xe, ke, He) {
          return this._tiles[xe] && this._tiles[xe].hasData() && !this._coveredTiles[xe] && (ke || !this._tiles[xe].holdingForFade()) && (He || !this._shadowCasterTiles[xe]);
        }
        reload() {
          if (this._paused)
            this._shouldReloadOnResume = !0;
          else {
            this._cache.reset();
            for (const xe in this._tiles)
              this._tiles[xe].state !== "errored" && this._reloadTile(+xe, "reloading");
          }
        }
        _reloadTile(xe, ke) {
          const He = this._tiles[xe];
          He && (He.state !== "loading" && (He.state = ke), this._loadTile(He, this._tileLoaded.bind(this, He, xe, ke)));
        }
        _tileLoaded(xe, ke, He, ir) {
          if (ir)
            if (xe.state = "errored", ir.status !== 404)
              this._source.fire(new ne.y(ir, { tile: xe }));
            else {
              if (this._source.fire(new ne.z("data", { dataType: "source", sourceDataType: "error", sourceId: this._source.id, tile: xe })), !(xe.tileID.key in this._loadedParentTiles))
                return;
              if (this._source.type === "raster-dem" && this.usedForTerrain && this.map.painter.terrain) {
                const ar = this.map.painter.terrain;
                this.update(this.transform, ar.getScaledDemTileSize(), !0), ar.resetTileLookupCache(this.id);
              } else
                this.update(this.transform);
            }
          else
            xe.timeAdded = ne.q.now(), He === "expired" && (xe.refreshedUponExpiration = !0), this._setTileReloadTimer(ke, xe), this._source.type === "raster-dem" && xe.dem && this._backfillDEM(xe), this._state.initializeTileState(xe, this.map ? this.map.painter : null), this._source.fire(new ne.z("data", { dataType: "source", tile: xe, coord: xe.tileID, sourceCacheId: this.id }));
        }
        _backfillDEM(xe) {
          const ke = this.getRenderableIds();
          for (let ir = 0; ir < ke.length; ir++) {
            const ar = ke[ir];
            if (xe.neighboringTiles && xe.neighboringTiles[ar]) {
              const yr = this.getTileByID(ar);
              He(xe, yr), He(yr, xe);
            }
          }
          function He(ir, ar) {
            if (!ir.dem || ir.dem.borderReady)
              return;
            ir.needsHillshadePrepare = !0, ir.needsDEMTextureUpload = !0;
            let yr = ar.tileID.canonical.x - ir.tileID.canonical.x;
            const Tr = ar.tileID.canonical.y - ir.tileID.canonical.y, $r = Math.pow(2, ir.tileID.canonical.z), Dr = ar.tileID.key;
            yr === 0 && Tr === 0 || Math.abs(Tr) > 1 || (Math.abs(yr) > 1 && (Math.abs(yr + $r) === 1 ? yr += $r : Math.abs(yr - $r) === 1 && (yr -= $r)), ar.dem && ir.dem && (ir.dem.backfillBorder(ar.dem, yr, Tr), ir.neighboringTiles && ir.neighboringTiles[Dr] && (ir.neighboringTiles[Dr].backfilled = !0)));
          }
        }
        getTile(xe) {
          return this.getTileByID(xe.key);
        }
        getTileByID(xe) {
          return this._tiles[xe];
        }
        _retainLoadedChildren(xe, ke, He, ir) {
          for (const ar in this._tiles) {
            let yr = this._tiles[ar];
            if (ir[ar] || !yr.hasData() || yr.tileID.overscaledZ <= ke || yr.tileID.overscaledZ > He)
              continue;
            let Tr = yr.tileID;
            for (; yr && yr.tileID.overscaledZ > ke + 1; ) {
              const Dr = yr.tileID.scaledTo(yr.tileID.overscaledZ - 1);
              yr = this._tiles[Dr.key], yr && yr.hasData() && (Tr = Dr);
            }
            let $r = Tr;
            for (; $r.overscaledZ > ke; )
              if ($r = $r.scaledTo($r.overscaledZ - 1), xe[$r.key]) {
                ir[Tr.key] = Tr;
                break;
              }
          }
        }
        findLoadedParent(xe, ke) {
          if (xe.key in this._loadedParentTiles) {
            const He = this._loadedParentTiles[xe.key];
            return He && He.tileID.overscaledZ >= ke ? He : null;
          }
          for (let He = xe.overscaledZ - 1; He >= ke; He--) {
            const ir = xe.scaledTo(He), ar = this._getLoadedTile(ir);
            if (ar)
              return ar;
          }
        }
        _getLoadedTile(xe) {
          const ke = this._tiles[xe.key];
          return ke && ke.hasData() ? ke : this._cache.getByKey(this._source.reparseOverscaled ? xe.wrapped().key : xe.canonical.key);
        }
        updateCacheSize(xe, ke) {
          ke = ke || this._source.tileSize;
          const He = Math.ceil(xe.width / ke) + 1, ir = Math.ceil(xe.height / ke) + 1, ar = Math.floor(He * ir * 5), yr = typeof this._minTileCacheSize == "number" ? Math.max(this._minTileCacheSize, ar) : ar, Tr = typeof this._maxTileCacheSize == "number" ? Math.min(this._maxTileCacheSize, yr) : yr;
          this._cache.setMaxSize(Tr);
        }
        handleWrapJump(xe) {
          const ke = Math.round((xe - (this._prevLng === void 0 ? xe : this._prevLng)) / 360);
          if (this._prevLng = xe, ke) {
            const He = {};
            for (const ir in this._tiles) {
              const ar = this._tiles[ir];
              ar.tileID = ar.tileID.unwrapTo(ar.tileID.wrap + ke), He[ar.tileID.key] = ar;
            }
            this._tiles = He;
            for (const ir in this._timers)
              clearTimeout(this._timers[ir]), delete this._timers[ir];
            for (const ir in this._tiles)
              this._setTileReloadTimer(+ir, this._tiles[ir]);
          }
        }
        update(xe, ke, He, ir) {
          if (this.transform = xe, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage || this.usedForTerrain && !He)
            return;
          this.updateCacheSize(xe, ke), this.transform.projection.name !== "globe" && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = {}, this._coveredTiles = {};
          const ar = this._source.type === "batched-model";
          let yr, Tr = this._source.maxzoom;
          const $r = this.map && this.map.painter ? this.map.painter._terrain : null;
          if ($r && $r.sourceCache === this && $r.attenuationRange()) {
            const Gr = $r.attenuationRange()[0], qr = Math.floor(Gr) - Math.log2($r.getDemUpscale());
            Tr > qr && (Tr = qr);
          }
          if (this.used || this.usedForTerrain) {
            if (this._source.tileID)
              yr = xe.getVisibleUnwrappedCoordinates(this._source.tileID).map((Gr) => new ne.aG(Gr.canonical.z, Gr.wrap, Gr.canonical.z, Gr.canonical.x, Gr.canonical.y));
            else if (this.tileCoverLift !== 0) {
              const Gr = xe.clone();
              Gr.tileCoverLift = this.tileCoverLift, yr = Gr.coveringTiles({ tileSize: ke || this._source.tileSize, minzoom: this._source.minzoom, maxzoom: Tr, roundZoom: this._source.roundZoom && !He, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain, calculateQuadrantVisibility: ar }), this._source.minzoom <= 1 && xe.projection.name === "globe" && (yr.push(new ne.aG(1, 0, 1, 0, 0)), yr.push(new ne.aG(1, 0, 1, 1, 0)), yr.push(new ne.aG(1, 0, 1, 0, 1)), yr.push(new ne.aG(1, 0, 1, 1, 1)));
            } else if (yr = xe.coveringTiles({ tileSize: ke || this._source.tileSize, minzoom: this._source.minzoom, maxzoom: Tr, roundZoom: this._source.roundZoom && !He, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain, calculateQuadrantVisibility: ar }), this._source.hasTile) {
              const Gr = this._source.hasTile.bind(this._source);
              yr = yr.filter((qr) => Gr(qr));
            }
          } else
            yr = [];
          if (yr.length > 0 && this.castsShadows && ir && this.transform.projection.name !== "globe" && !this.usedForTerrain && !xd(this._source.type)) {
            const Gr = xe.coveringZoomLevel({ tileSize: ke || this._source.tileSize, roundZoom: this._source.roundZoom && !He }), qr = Math.min(Gr, this._source.maxzoom);
            if (ar) {
              const Jr = xe.extendTileCover(yr, qr);
              for (const bi of Jr)
                yr.push(bi);
            } else {
              const Jr = xe.extendTileCover(yr, qr, ir);
              for (const bi of Jr)
                this._shadowCasterTiles[bi.key] = !0, yr.push(bi);
            }
          }
          const Dr = this._updateRetainedTiles(yr);
          if (xd(this._source.type) && yr.length !== 0) {
            const Gr = {}, qr = {}, Jr = Object.keys(Dr);
            for (const fi of Jr) {
              const Mi = Dr[fi], Ei = this._tiles[fi];
              if (!Ei || Ei.fadeEndTime && Ei.fadeEndTime <= ne.q.now())
                continue;
              const Ii = this.findLoadedParent(Mi, Math.max(Mi.overscaledZ - Kl.maxOverzooming, this._source.minzoom));
              Ii && (this._addTile(Ii.tileID), Gr[Ii.tileID.key] = Ii.tileID), qr[fi] = Mi;
            }
            const bi = yr[yr.length - 1].overscaledZ;
            for (const fi in this._tiles) {
              const Mi = this._tiles[fi];
              if (Dr[fi] || !Mi.hasData())
                continue;
              let Ei = Mi.tileID;
              for (; Ei.overscaledZ > bi; ) {
                Ei = Ei.scaledTo(Ei.overscaledZ - 1);
                const Ii = this._tiles[Ei.key];
                if (Ii && Ii.hasData() && qr[Ei.key]) {
                  Dr[fi] = Mi.tileID;
                  break;
                }
              }
            }
            for (const fi in Gr)
              Dr[fi] || (this._coveredTiles[fi] = !0, Dr[fi] = Gr[fi]);
          }
          for (const Gr in Dr)
            this._tiles[Gr].clearFadeHold();
          const Or = ne.bk(this._tiles, Dr);
          for (const Gr of Or) {
            const qr = this._tiles[Gr];
            qr.hasSymbolBuckets && !qr.holdingForFade() ? qr.setHoldDuration(this.map._fadeDuration) : qr.hasSymbolBuckets && !qr.symbolFadeFinished() || this._removeTile(+Gr);
          }
          this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
        }
        releaseSymbolFadeTiles() {
          for (const xe in this._tiles)
            this._tiles[xe].holdingForFade() && this._removeTile(+xe);
        }
        _updateRetainedTiles(xe) {
          const ke = {};
          if (xe.length === 0)
            return ke;
          const He = {}, ir = xe.reduce((Dr, Or) => Math.min(Dr, Or.overscaledZ), 1 / 0), ar = xe[0].overscaledZ, yr = Math.max(ar - Kl.maxOverzooming, this._source.minzoom), Tr = Math.max(ar + Kl.maxUnderzooming, this._source.minzoom), $r = {};
          for (const Dr of xe) {
            const Or = this._addTile(Dr);
            ke[Dr.key] = Dr, Or.hasData() || ir < this._source.maxzoom && ($r[Dr.key] = Dr);
          }
          this._retainLoadedChildren($r, ir, Tr, ke);
          for (const Dr of xe) {
            let Or = this._tiles[Dr.key];
            if (Or.hasData())
              continue;
            if (Dr.canonical.z >= this._source.maxzoom) {
              const qr = Dr.children(this._source.maxzoom)[0], Jr = this.getTile(qr);
              if (Jr && Jr.hasData()) {
                ke[qr.key] = qr;
                continue;
              }
            } else {
              const qr = Dr.children(this._source.maxzoom);
              if (ke[qr[0].key] && ke[qr[1].key] && ke[qr[2].key] && ke[qr[3].key])
                continue;
            }
            let Gr = Or.wasRequested();
            for (let qr = Dr.overscaledZ - 1; qr >= yr; --qr) {
              const Jr = Dr.scaledTo(qr);
              if (He[Jr.key] || (He[Jr.key] = !0, Or = this.getTile(Jr), !Or && Gr && (Or = this._addTile(Jr)), Or && (ke[Jr.key] = Jr, Gr = Or.wasRequested(), Or.hasData())))
                break;
            }
          }
          return ke;
        }
        _updateLoadedParentTileCache() {
          this._loadedParentTiles = {};
          for (const xe in this._tiles) {
            const ke = [];
            let He, ir = this._tiles[xe].tileID;
            for (; ir.overscaledZ > 0; ) {
              if (ir.key in this._loadedParentTiles) {
                He = this._loadedParentTiles[ir.key];
                break;
              }
              ke.push(ir.key);
              const ar = ir.scaledTo(ir.overscaledZ - 1);
              if (He = this._getLoadedTile(ar), He)
                break;
              ir = ar;
            }
            for (const ar of ke)
              this._loadedParentTiles[ar] = He;
          }
        }
        _addTile(xe) {
          let ke = this._tiles[xe.key];
          if (ke)
            return ke.isExtraShadowCaster !== !0 || !!this._shadowCasterTiles[xe.key] || this._reloadTile(xe.key, "reloading"), ke;
          ke = this._cache.getAndRemove(xe), ke && (this._setTileReloadTimer(xe.key, ke), ke.tileID = xe, this._state.initializeTileState(ke, this.map ? this.map.painter : null), this._cacheTimers[xe.key] && (clearTimeout(this._cacheTimers[xe.key]), delete this._cacheTimers[xe.key], this._setTileReloadTimer(xe.key, ke)));
          const He = Boolean(ke);
          if (!He) {
            const ir = this.map ? this.map.painter : null, ar = this._source.tileSize * xe.overscaleFactor();
            ke = this._source.type === "raster-array" ? new yd(xe, ar, this.transform.tileZoom, ir, this._isRaster) : new Xl(xe, ar, this.transform.tileZoom, ir, this._isRaster), this._loadTile(ke, this._tileLoaded.bind(this, ke, xe.key, ke.state));
          }
          return ke ? (ke.uses++, this._tiles[xe.key] = ke, He || this._source.fire(new ne.z("dataloading", { tile: ke, coord: ke.tileID, dataType: "source" })), ke) : null;
        }
        _setTileReloadTimer(xe, ke) {
          xe in this._timers && (clearTimeout(this._timers[xe]), delete this._timers[xe]);
          const He = ke.getExpiryTimeout();
          He && (this._timers[xe] = setTimeout(() => {
            this._reloadTile(xe, "expired"), delete this._timers[xe];
          }, He));
        }
        _removeTile(xe) {
          const ke = this._tiles[xe];
          ke && (ke.uses--, delete this._tiles[xe], this._timers[xe] && (clearTimeout(this._timers[xe]), delete this._timers[xe]), ke.uses > 0 || (ke.hasData() && ke.state !== "reloading" || ke.state === "empty" ? this._cache.add(ke.tileID, ke, ke.getExpiryTimeout()) : (ke.aborted = !0, this._abortTile(ke), this._unloadTile(ke))));
        }
        clearTiles() {
          this._shouldReloadOnResume = !1, this._paused = !1;
          for (const xe in this._tiles)
            this._removeTile(+xe);
          this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
        }
        tilesIn(xe, ke, He) {
          const ir = [], ar = this.transform;
          if (!ar)
            return ir;
          const yr = ar.projection.name === "globe", Tr = ne.at(ar.center.lng);
          for (const $r in this._tiles) {
            const Dr = this._tiles[$r];
            if (He && Dr.clearQueryDebugViz(), Dr.holdingForFade())
              continue;
            let Or;
            if (yr) {
              const Gr = Dr.tileID.canonical;
              if (Gr.z === 0) {
                const qr = [Math.abs(ne.aw(Tr, ...Ca(Gr, -1)) - Tr), Math.abs(ne.aw(Tr, ...Ca(Gr, 1)) - Tr)];
                Or = [0, 2 * qr.indexOf(Math.min(...qr)) - 1];
              } else {
                const qr = [Math.abs(ne.aw(Tr, ...Ca(Gr, -1)) - Tr), Math.abs(ne.aw(Tr, ...Ca(Gr, 0)) - Tr), Math.abs(ne.aw(Tr, ...Ca(Gr, 1)) - Tr)];
                Or = [qr.indexOf(Math.min(...qr)) - 1];
              }
            } else
              Or = [0];
            for (const Gr of Or) {
              const qr = xe.containsTile(Dr, ar, ke, Gr);
              qr && ir.push(qr);
            }
          }
          return ir;
        }
        getShadowCasterCoordinates() {
          return this._getRenderableCoordinates(!1, !0);
        }
        getVisibleCoordinates(xe) {
          return this._getRenderableCoordinates(xe);
        }
        _getRenderableCoordinates(xe, ke) {
          const He = this.getRenderableIds(xe, ke).map((ar) => this._tiles[ar].tileID), ir = this.transform.projection.name === "globe";
          for (const ar of He)
            ar.projMatrix = this.transform.calculateProjMatrix(ar.toUnwrapped()), ar.expandedProjMatrix = ir ? this.transform.calculateProjMatrix(ar.toUnwrapped(), !1, !0) : ar.projMatrix;
          return He;
        }
        sortCoordinatesByDistance(xe) {
          const ke = xe.slice(), He = this.transform._camera.position, ir = this.transform._camera.forward(), ar = {};
          for (const yr of ke) {
            const Tr = 1 / (1 << yr.canonical.z);
            ar[yr.key] = ((yr.canonical.x + 0.5) * Tr + yr.wrap - He[0]) * ir[0] + ((yr.canonical.y + 0.5) * Tr - He[1]) * ir[1] - He[2] * ir[2];
          }
          return ke.sort((yr, Tr) => ar[yr.key] - ar[Tr.key]), ke;
        }
        hasTransition() {
          if (this._source.hasTransition())
            return !0;
          if (xd(this._source.type))
            for (const xe in this._tiles) {
              const ke = this._tiles[xe];
              if (ke.fadeEndTime !== void 0 && ke.fadeEndTime >= ne.q.now())
                return !0;
            }
          return !1;
        }
        setFeatureState(xe, ke, He) {
          this._state.updateState(xe = xe || "_geojsonTileLayer", ke, He);
        }
        removeFeatureState(xe, ke, He) {
          this._state.removeFeatureState(xe = xe || "_geojsonTileLayer", ke, He);
        }
        getFeatureState(xe, ke) {
          return this._state.getState(xe = xe || "_geojsonTileLayer", ke);
        }
        setDependencies(xe, ke, He) {
          const ir = this._tiles[xe];
          ir && ir.setDependencies(ke, He);
        }
        reloadTilesForDependencies(xe, ke) {
          for (const He in this._tiles)
            this._tiles[He].hasDependency(xe, ke) && this._reloadTile(+He, "reloading");
          this._cache.filter((He) => !He.hasDependency(xe, ke));
        }
        _preloadTiles(xe, ke) {
          if (!this._sourceLoaded) {
            const $r = () => {
              this._sourceLoaded && (this._source.off("data", $r), this._preloadTiles(xe, ke));
            };
            return void this._source.on("data", $r);
          }
          const He = /* @__PURE__ */ new Map(), ir = Array.isArray(xe) ? xe : [xe], ar = this.map.painter.terrain, yr = this.usedForTerrain && ar ? ar.getScaledDemTileSize() : this._source.tileSize;
          for (const $r of ir) {
            const Dr = $r.coveringTiles({ tileSize: yr, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: this._source.roundZoom && !this.usedForTerrain, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain });
            for (const Or of Dr)
              He.set(Or.key, Or);
            this.usedForTerrain && $r.updateElevation(!1);
          }
          const Tr = Array.from(He.values());
          ne.bl(Tr, ($r, Dr) => {
            const Or = new Xl($r, this._source.tileSize * $r.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster);
            this._loadTile(Or, (Gr) => {
              this._source.type === "raster-dem" && Or.dem && this._backfillDEM(Or), Dr(Gr, Or);
            });
          }, ke);
        }
      }
      function bd(qe, xe) {
        const ke = Math.abs(2 * qe.wrap) - +(qe.wrap < 0), He = Math.abs(2 * xe.wrap) - +(xe.wrap < 0);
        return qe.overscaledZ - xe.overscaledZ || He - ke || xe.canonical.y - qe.canonical.y || xe.canonical.x - qe.canonical.x;
      }
      function xd(qe) {
        return qe === "raster" || qe === "image" || qe === "video" || qe === "custom";
      }
      function Ca(qe, xe) {
        const ke = 1 << qe.z;
        return [qe.x / ke + xe, (qe.x + 1) / ke + xe];
      }
      Kl.maxOverzooming = 10, Kl.maxUnderzooming = 3;
      class O0 {
        constructor(xe) {
          this.style = xe, this.layersGotHidden = !1, this.layers = [];
        }
        processLayersChanged() {
          this.layers = [];
          const xe = !1, ke = !1;
          for (const He in this.style._mergedLayers) {
            const ir = this.style._mergedLayers[He];
            if (ir.type === "fill-extrusion")
              this.layers.push({ layer: ir, visible: xe, visibilityChanged: ke });
            else if (ir.type === "model") {
              const ar = this.style.getLayerSource(ir);
              ar && ar.type === "batched-model" && this.layers.push({ layer: ir, visible: xe, visibilityChanged: ke });
            }
          }
        }
        onNewFrame(xe) {
          this.layersGotHidden = !1;
          for (const ke of this.layers) {
            const He = ke.layer;
            let ir = !1;
            He.type === "fill-extrusion" ? ir = !He.isHidden(xe) && He.paint.get("fill-extrusion-opacity") > 0 : He.type === "model" && (ir = !He.isHidden(xe) && He.paint.get("model-opacity").constantOr(1) > 0), this.layersGotHidden = this.layersGotHidden || !ir && ke.visible, ke.visible = ir;
          }
        }
        updateZOffset(xe, ke) {
          this.currentBuildingBuckets = [];
          for (const ir of this.layers) {
            const ar = ir.layer, yr = this.style.getLayerSourceCache(ar);
            let Tr = 1;
            ar.type === "fill-extrusion" && (Tr = ir.visible ? ar.paint.get("fill-extrusion-vertical-scale") : 0);
            let $r = yr ? yr.getTile(ke) : null;
            if (!$r && yr && ke.canonical.z > yr.getSource().minzoom) {
              let Dr = ke.scaledTo(Math.min(yr.getSource().maxzoom, ke.overscaledZ - 1));
              for (; Dr.overscaledZ >= yr.getSource().minzoom && ($r = yr.getTile(Dr), !$r && Dr.overscaledZ !== 0); )
                Dr = Dr.scaledTo(Dr.overscaledZ - 1);
            }
            this.currentBuildingBuckets.push({ bucket: $r ? $r.getBucket(ar) : null, tileID: $r ? $r.tileID : ke, verticalScale: Tr });
          }
          xe.hasAnyZOffset = !1;
          let He = !1;
          for (let ir = 0; ir < xe.symbolInstances.length; ir++) {
            const ar = xe.symbolInstances.get(ir), yr = ar.zOffset, Tr = this._getHeightAtTileOffset(ke, ar.tileAnchorX, ar.tileAnchorY);
            ar.zOffset = Tr !== Number.NEGATIVE_INFINITY ? Tr : yr, He || yr === ar.zOffset || (He = !0), xe.hasAnyZOffset || ar.zOffset === 0 || (xe.hasAnyZOffset = !0);
          }
          He && (xe.zOffsetBuffersNeedUpload = !0, xe.zOffsetSortDirty = !0);
        }
        _mapCoordToOverlappingTile(xe, ke, He, ir) {
          let ar = ke, yr = He;
          if (xe.canonical.z !== ir.canonical.z) {
            const Tr = ir.canonical, $r = 1 / (1 << xe.canonical.z - Tr.z);
            ar = (ke + xe.canonical.x * ne.ag) * $r - Tr.x * ne.ag | 0, yr = (He + xe.canonical.y * ne.ag) * $r - Tr.y * ne.ag | 0;
          }
          return { tileX: ar, tileY: yr };
        }
        _getHeightAtTileOffset(xe, ke, He) {
          let ir, ar;
          for (let yr = 0; yr < this.layers.length; ++yr) {
            if (this.layers[yr].layer.type !== "fill-extrusion")
              continue;
            const { bucket: Tr, tileID: $r, verticalScale: Dr } = this.currentBuildingBuckets[yr];
            if (!Tr)
              continue;
            const { tileX: Or, tileY: Gr } = this._mapCoordToOverlappingTile(xe, ke, He, $r), qr = Tr.getHeightAtTileCoord(Or, Gr);
            qr && qr.height !== void 0 && (qr.hidden ? ir = qr.height : ar = Math.max(qr.height * Dr, ar || 0));
          }
          if (ar !== void 0)
            return ar;
          for (let yr = 0; yr < this.layers.length; ++yr) {
            const Tr = this.layers[yr];
            if (Tr.layer.type !== "model" || !Tr.visible)
              continue;
            const { bucket: $r, tileID: Dr } = this.currentBuildingBuckets[yr];
            if (!$r)
              continue;
            const { tileX: Or, tileY: Gr } = this._mapCoordToOverlappingTile(xe, ke, He, Dr), qr = $r.getHeightAtTileCoord(Or, Gr);
            if (qr && !qr.hidden)
              return qr.height === void 0 && ir !== void 0 ? Math.min(qr.maxHeight, ir) * qr.verticalScale : qr.height ? qr.height * qr.verticalScale : Number.NEGATIVE_INFINITY;
          }
          return this.layersGotHidden ? 0 : Number.NEGATIVE_INFINITY;
        }
      }
      function Ho(qe, xe) {
        const ke = {};
        for (const He in qe)
          He !== "ref" && (ke[He] = qe[He]);
        return ne.bm.forEach((He) => {
          He in xe && (ke[He] = xe[He]);
        }), ke;
      }
      function Sp(qe) {
        qe = qe.slice();
        const xe = /* @__PURE__ */ Object.create(null);
        for (let ke = 0; ke < qe.length; ke++)
          xe[qe[ke].id] = qe[ke];
        for (let ke = 0; ke < qe.length; ke++)
          "ref" in qe[ke] && (qe[ke] = Ho(qe[ke], xe[qe[ke].ref]));
        return qe;
      }
      const xa = { setStyle: "setStyle", addLayer: "addLayer", removeLayer: "removeLayer", setPaintProperty: "setPaintProperty", setLayoutProperty: "setLayoutProperty", setSlot: "setSlot", setFilter: "setFilter", addSource: "addSource", removeSource: "removeSource", setGeoJSONSourceData: "setGeoJSONSourceData", setLayerZoomRange: "setLayerZoomRange", setLayerProperty: "setLayerProperty", setCenter: "setCenter", setZoom: "setZoom", setBearing: "setBearing", setPitch: "setPitch", setSprite: "setSprite", setGlyphs: "setGlyphs", setTransition: "setTransition", setLight: "setLight", setTerrain: "setTerrain", setFog: "setFog", setSnow: "setSnow", setRain: "setRain", setCamera: "setCamera", setLights: "setLights", setProjection: "setProjection", addImport: "addImport", removeImport: "removeImport", updateImport: "updateImport" };
      function Sf(qe, xe, ke) {
        ke.push({ command: xa.addSource, args: [qe, xe[qe]] });
      }
      function hc(qe, xe, ke) {
        xe.push({ command: xa.removeSource, args: [qe] }), ke[qe] = !0;
      }
      function Ep(qe, xe, ke, He) {
        hc(qe, ke, He), Sf(qe, xe, ke);
      }
      function Bh(qe, xe, ke) {
        let He;
        for (He in qe[ke])
          if (qe[ke].hasOwnProperty(He) && He !== "data" && !ne.bn(qe[ke][He], xe[ke][He]))
            return !1;
        for (He in xe[ke])
          if (xe[ke].hasOwnProperty(He) && He !== "data" && !ne.bn(qe[ke][He], xe[ke][He]))
            return !1;
        return !0;
      }
      function To(qe, xe, ke, He, ir, ar) {
        let yr;
        for (yr in xe = xe || {}, qe = qe || {})
          qe.hasOwnProperty(yr) && (ne.bn(qe[yr], xe[yr]) || ke.push({ command: ar, args: [He, yr, xe[yr], ir] }));
        for (yr in xe)
          xe.hasOwnProperty(yr) && !qe.hasOwnProperty(yr) && (ne.bn(qe[yr], xe[yr]) || ke.push({ command: ar, args: [He, yr, xe[yr], ir] }));
      }
      function Pa(qe) {
        return qe.id;
      }
      function Ta(qe, xe) {
        return qe[xe.id] = xe, qe;
      }
      class Dl {
        constructor(xe, ke) {
          this.reset(xe, ke);
        }
        reset(xe, ke) {
          this.points = xe || [], this._distances = [0];
          for (let He = 1; He < this.points.length; He++)
            this._distances[He] = this._distances[He - 1] + this.points[He].dist(this.points[He - 1]);
          this.length = this._distances[this._distances.length - 1], this.padding = Math.min(ke || 0, 0.5 * this.length), this.paddedLength = this.length - 2 * this.padding;
        }
        lerp(xe) {
          if (this.points.length === 1)
            return this.points[0];
          xe = ne.aw(xe, 0, 1);
          let ke = 1, He = this._distances[ke];
          const ir = xe * this.paddedLength + this.padding;
          for (; He < ir && ke < this._distances.length; )
            He = this._distances[++ke];
          const ar = ke - 1, yr = this._distances[ar], Tr = He - yr, $r = Tr > 0 ? (ir - yr) / Tr : 0;
          return this.points[ar].mult(1 - $r).add(this.points[ke].mult($r));
        }
      }
      class Gu {
        constructor(xe, ke, He) {
          const ir = this.boxCells = [], ar = this.circleCells = [];
          this.xCellCount = Math.ceil(xe / He), this.yCellCount = Math.ceil(ke / He);
          for (let yr = 0; yr < this.xCellCount * this.yCellCount; yr++)
            ir.push([]), ar.push([]);
          this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = xe, this.height = ke, this.xScale = this.xCellCount / xe, this.yScale = this.yCellCount / ke, this.boxUid = 0, this.circleUid = 0;
        }
        keysLength() {
          return this.boxKeys.length + this.circleKeys.length;
        }
        insert(xe, ke, He, ir, ar) {
          this._forEachCell(ke, He, ir, ar, this._insertBoxCell, this.boxUid++), this.boxKeys.push(xe), this.bboxes.push(ke), this.bboxes.push(He), this.bboxes.push(ir), this.bboxes.push(ar);
        }
        insertCircle(xe, ke, He, ir) {
          this._forEachCell(ke - ir, He - ir, ke + ir, He + ir, this._insertCircleCell, this.circleUid++), this.circleKeys.push(xe), this.circles.push(ke), this.circles.push(He), this.circles.push(ir);
        }
        _insertBoxCell(xe, ke, He, ir, ar, yr) {
          this.boxCells[ar].push(yr);
        }
        _insertCircleCell(xe, ke, He, ir, ar, yr) {
          this.circleCells[ar].push(yr);
        }
        _query(xe, ke, He, ir, ar, yr) {
          if (He < 0 || xe > this.width || ir < 0 || ke > this.height)
            return !ar && [];
          const Tr = [];
          if (xe <= 0 && ke <= 0 && this.width <= He && this.height <= ir) {
            if (ar)
              return !0;
            for (let $r = 0; $r < this.boxKeys.length; $r++)
              Tr.push({ key: this.boxKeys[$r], x1: this.bboxes[4 * $r], y1: this.bboxes[4 * $r + 1], x2: this.bboxes[4 * $r + 2], y2: this.bboxes[4 * $r + 3] });
            for (let $r = 0; $r < this.circleKeys.length; $r++) {
              const Dr = this.circles[3 * $r], Or = this.circles[3 * $r + 1], Gr = this.circles[3 * $r + 2];
              Tr.push({ key: this.circleKeys[$r], x1: Dr - Gr, y1: Or - Gr, x2: Dr + Gr, y2: Or + Gr });
            }
            return yr ? Tr.filter(yr) : Tr;
          }
          return this._forEachCell(xe, ke, He, ir, this._queryCell, Tr, { hitTest: ar, seenUids: { box: {}, circle: {} } }, yr), ar ? Tr.length > 0 : Tr;
        }
        _queryCircle(xe, ke, He, ir, ar) {
          const yr = xe - He, Tr = xe + He, $r = ke - He, Dr = ke + He;
          if (Tr < 0 || yr > this.width || Dr < 0 || $r > this.height)
            return !ir && [];
          const Or = [];
          return this._forEachCell(yr, $r, Tr, Dr, this._queryCellCircle, Or, { hitTest: ir, circle: { x: xe, y: ke, radius: He }, seenUids: { box: {}, circle: {} } }, ar), ir ? Or.length > 0 : Or;
        }
        query(xe, ke, He, ir, ar) {
          return this._query(xe, ke, He, ir, !1, ar);
        }
        hitTest(xe, ke, He, ir, ar) {
          return this._query(xe, ke, He, ir, !0, ar);
        }
        hitTestCircle(xe, ke, He, ir) {
          return this._queryCircle(xe, ke, He, !0, ir);
        }
        _queryCell(xe, ke, He, ir, ar, yr, Tr, $r) {
          const Dr = Tr.seenUids, Or = this.boxCells[ar];
          if (Or !== null) {
            const qr = this.bboxes;
            for (const Jr of Or)
              if (!Dr.box[Jr]) {
                Dr.box[Jr] = !0;
                const bi = 4 * Jr;
                if (xe <= qr[bi + 2] && ke <= qr[bi + 3] && He >= qr[bi + 0] && ir >= qr[bi + 1] && (!$r || $r(this.boxKeys[Jr]))) {
                  if (Tr.hitTest)
                    return yr.push(!0), !0;
                  yr.push({ key: this.boxKeys[Jr], x1: qr[bi], y1: qr[bi + 1], x2: qr[bi + 2], y2: qr[bi + 3] });
                }
              }
          }
          const Gr = this.circleCells[ar];
          if (Gr !== null) {
            const qr = this.circles;
            for (const Jr of Gr)
              if (!Dr.circle[Jr]) {
                Dr.circle[Jr] = !0;
                const bi = 3 * Jr;
                if (this._circleAndRectCollide(qr[bi], qr[bi + 1], qr[bi + 2], xe, ke, He, ir) && (!$r || $r(this.circleKeys[Jr]))) {
                  if (Tr.hitTest)
                    return yr.push(!0), !0;
                  {
                    const fi = qr[bi], Mi = qr[bi + 1], Ei = qr[bi + 2];
                    yr.push({ key: this.circleKeys[Jr], x1: fi - Ei, y1: Mi - Ei, x2: fi + Ei, y2: Mi + Ei });
                  }
                }
              }
          }
        }
        _queryCellCircle(xe, ke, He, ir, ar, yr, Tr, $r) {
          const Dr = Tr.circle, Or = Tr.seenUids, Gr = this.boxCells[ar];
          if (Gr !== null) {
            const Jr = this.bboxes;
            for (const bi of Gr)
              if (!Or.box[bi]) {
                Or.box[bi] = !0;
                const fi = 4 * bi;
                if (this._circleAndRectCollide(Dr.x, Dr.y, Dr.radius, Jr[fi + 0], Jr[fi + 1], Jr[fi + 2], Jr[fi + 3]) && (!$r || $r(this.boxKeys[bi])))
                  return yr.push(!0), !0;
              }
          }
          const qr = this.circleCells[ar];
          if (qr !== null) {
            const Jr = this.circles;
            for (const bi of qr)
              if (!Or.circle[bi]) {
                Or.circle[bi] = !0;
                const fi = 3 * bi;
                if (this._circlesCollide(Jr[fi], Jr[fi + 1], Jr[fi + 2], Dr.x, Dr.y, Dr.radius) && (!$r || $r(this.circleKeys[bi])))
                  return yr.push(!0), !0;
              }
          }
        }
        _forEachCell(xe, ke, He, ir, ar, yr, Tr, $r) {
          const Dr = this._convertToXCellCoord(xe), Or = this._convertToYCellCoord(ke), Gr = this._convertToXCellCoord(He), qr = this._convertToYCellCoord(ir);
          for (let Jr = Dr; Jr <= Gr; Jr++)
            for (let bi = Or; bi <= qr; bi++)
              if (ar.call(this, xe, ke, He, ir, this.xCellCount * bi + Jr, yr, Tr, $r))
                return;
        }
        _convertToXCellCoord(xe) {
          return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(xe * this.xScale)));
        }
        _convertToYCellCoord(xe) {
          return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(xe * this.yScale)));
        }
        _circlesCollide(xe, ke, He, ir, ar, yr) {
          const Tr = ir - xe, $r = ar - ke, Dr = He + yr;
          return Dr * Dr > Tr * Tr + $r * $r;
        }
        _circleAndRectCollide(xe, ke, He, ir, ar, yr, Tr) {
          const $r = (yr - ir) / 2, Dr = Math.abs(xe - (ir + $r));
          if (Dr > $r + He)
            return !1;
          const Or = (Tr - ar) / 2, Gr = Math.abs(ke - (ar + Or));
          if (Gr > Or + He)
            return !1;
          if (Dr <= $r || Gr <= Or)
            return !0;
          const qr = Dr - $r, Jr = Gr - Or;
          return qr * qr + Jr * Jr <= He * He;
        }
      }
      const ga = { unknown: 0, flipRequired: 1, flipNotRequired: 2 }, vs = Math.tan(85 * Math.PI / 180);
      function es(qe, xe, ke, He, ir, ar, yr) {
        const Tr = ne.ab.mat4.create();
        if (ke)
          if (ar.name === "globe") {
            const $r = ne.bo(ir, xe);
            ne.ab.mat4.multiply(Tr, Tr, $r);
          } else {
            const $r = ne.ab.mat2.invert([], yr);
            Tr[0] = $r[0], Tr[1] = $r[1], Tr[4] = $r[2], Tr[5] = $r[3], He || ne.ab.mat4.rotateZ(Tr, Tr, ir.angle);
          }
        else
          ne.ab.mat4.multiply(Tr, ir.labelPlaneMatrix, qe);
        return Tr;
      }
      function Hu(qe, xe, ke, He, ir, ar, yr) {
        const Tr = es(qe, xe, ke, He, ir, ar, yr);
        return ar.name === "globe" && ke || (Tr[2] = Tr[6] = Tr[10] = Tr[14] = 0), Tr;
      }
      function dl(qe, xe, ke, He, ir, ar, yr) {
        if (ke) {
          if (ar.name === "globe") {
            const Tr = es(qe, xe, ke, He, ir, ar, yr);
            return ne.ab.mat4.invert(Tr, Tr), ne.ab.mat4.multiply(Tr, qe, Tr), Tr;
          }
          {
            const Tr = ne.ab.mat4.clone(qe), $r = ne.ab.mat4.identity([]);
            return $r[0] = yr[0], $r[1] = yr[1], $r[4] = yr[2], $r[5] = yr[3], ne.ab.mat4.multiply(Tr, Tr, $r), He || ne.ab.mat4.rotateZ(Tr, Tr, -ir.angle), Tr;
          }
        }
        return ir.glCoordMatrix;
      }
      function ts(qe, xe, ke, He) {
        const ir = [qe, xe, ke, 1];
        ke ? ne.ab.vec4.transformMat4(ir, ir, He) : ol(ir, ir, He);
        const ar = ir[3];
        return ir[0] /= ar, ir[1] /= ar, ir[2] /= ar, ir;
      }
      function Bm(qe, xe) {
        return Math.min(0.5 + qe / xe * 0.5, 1.5);
      }
      function wd(qe, xe) {
        const ke = qe[0] / qe[3], He = qe[1] / qe[3];
        return ke >= -xe[0] && ke <= xe[0] && He >= -xe[1] && He <= xe[1];
      }
      function Ef(qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr) {
        const Or = ke.transform, Gr = He ? qe.textSizeData : qe.iconSizeData, qr = ne.bp(Gr, ke.transform.zoom), Jr = Or.projection.name === "globe", bi = [256 / ke.width * 2 + 1, 256 / ke.height * 2 + 1], fi = He ? qe.text.dynamicLayoutVertexArray : qe.icon.dynamicLayoutVertexArray;
        fi.clear();
        let Mi = null;
        Jr && (Mi = He ? qe.text.globeExtVertexArray : qe.icon.globeExtVertexArray);
        const Ei = qe.lineVertexArray, Ii = He ? qe.text.placedSymbolArray : qe.icon.placedSymbolArray, Ni = ke.transform.width / ke.transform.height;
        let zi, Ki = !1;
        for (let Wi = 0; Wi < Ii.length; Wi++) {
          const Xi = Ii.get(Wi), { numGlyphs: Gi, writingMode: nn } = Xi;
          if (nn !== ne.bq.vertical || Ki || zi === ne.bq.horizontal || (Ki = !0), zi = nn, (Xi.hidden || nn === ne.bq.vertical) && !Ki) {
            iu(Gi, fi);
            continue;
          }
          Ki = !1;
          const dn = new ne.P(Xi.tileAnchorX, Xi.tileAnchorY);
          let { x: Pn, y: Ln, z: hn } = Or.projection.projectTilePoint(dn.x, dn.y, Dr.canonical);
          if ($r) {
            const [Wn, _o, yo] = $r(dn);
            Pn += Wn, Ln += _o, hn += yo;
          }
          const xn = [Pn, Ln, hn, 1];
          if (ne.ab.vec4.transformMat4(xn, xn, xe), !wd(xn, bi)) {
            iu(Gi, fi);
            continue;
          }
          const Hn = xn[3], io = Bm(ke.transform.getCameraToCenterDistance(Or.projection), Hn), uo = ne.br(Gr, qr, Xi), An = yr ? uo / io : uo * io, eo = ts(Pn, Ln, hn, ir);
          if (eo[3] <= 0) {
            iu(Gi, fi);
            continue;
          }
          let On = {};
          const ao = yr ? null : $r, ro = Rs(Xi, An, !1, Tr, xe, ir, ar, qe.glyphOffsetArray, Ei, fi, Mi, eo, dn, On, Ni, ao, Or.projection, Dr, yr);
          Ki = ro.useVertical, ao && ro.needsFlipping && (On = {}), (ro.notEnoughRoom || Ki || ro.needsFlipping && Rs(Xi, An, !0, Tr, xe, ir, ar, qe.glyphOffsetArray, Ei, fi, Mi, eo, dn, On, Ni, ao, Or.projection, Dr, yr).notEnoughRoom) && iu(Gi, fi);
        }
        He ? (qe.text.dynamicLayoutVertexBuffer.updateData(fi), Mi && qe.text.globeExtVertexBuffer && qe.text.globeExtVertexBuffer.updateData(Mi)) : (qe.icon.dynamicLayoutVertexBuffer.updateData(fi), Mi && qe.icon.globeExtVertexBuffer && qe.icon.globeExtVertexBuffer.updateData(Mi));
      }
      function Wu(qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr, qr, Jr, bi, fi) {
        const { lineStartIndex: Mi, glyphStartIndex: Ei, segment: Ii } = Tr, Ni = Ei + Tr.numGlyphs, zi = Mi + Tr.lineLength, Ki = xe.getoffsetX(Ei), Wi = xe.getoffsetX(Ni - 1), Xi = Ps(qe * Ki, ke, He, ir, ar, yr, Ii, Mi, zi, $r, Dr, Or, Gr, qr, !0, Jr, bi, fi);
        if (!Xi)
          return null;
        const Gi = Ps(qe * Wi, ke, He, ir, ar, yr, Ii, Mi, zi, $r, Dr, Or, Gr, qr, !0, Jr, bi, fi);
        return Gi ? { first: Xi, last: Gi } : null;
      }
      function Cf(qe, xe, ke, He) {
        return qe === ne.bq.horizontal && Math.abs(He) > Math.abs(ke) ? { useVertical: !0 } : qe === ne.bq.vertical ? He > 0 ? { needsFlipping: !0 } : null : xe !== ga.unknown && function(ir, ar) {
          return ir === 0 || Math.abs(ar / ir) > vs;
        }(ke, He) ? xe === ga.flipRequired ? { needsFlipping: !0 } : null : ke < 0 ? { needsFlipping: !0 } : null;
      }
      function Rs(qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr, qr, Jr, bi, fi, Mi, Ei, Ii) {
        const Ni = xe / 24, zi = qe.lineOffsetX * Ni, Ki = qe.lineOffsetY * Ni, { lineStartIndex: Wi, glyphStartIndex: Xi, numGlyphs: Gi, segment: nn, writingMode: dn, flipState: Pn } = qe, Ln = Wi + qe.lineLength, hn = (xn) => {
          if (Or) {
            const [An, eo, On] = xn.up, ao = Dr.length;
            ne.bs(Or, ao + 0, An, eo, On), ne.bs(Or, ao + 1, An, eo, On), ne.bs(Or, ao + 2, An, eo, On), ne.bs(Or, ao + 3, An, eo, On);
          }
          const [Hn, io, uo] = xn.point;
          ne.bt(Dr, Hn, io, uo, xn.angle);
        };
        if (Gi > 1) {
          const xn = Wu(Ni, Tr, zi, Ki, ke, Gr, qr, qe, $r, ar, Jr, fi, !1, Mi, Ei, Ii);
          if (!xn)
            return { notEnoughRoom: !0 };
          if (He && !ke) {
            let [Hn, io, uo] = xn.first.point, [An, eo, On] = xn.last.point;
            [Hn, io] = ts(Hn, io, uo, yr), [An, eo] = ts(An, eo, On, yr);
            const ao = Cf(dn, Pn, (An - Hn) * bi, eo - io);
            if (qe.flipState = ao && ao.needsFlipping ? ga.flipRequired : ga.flipNotRequired, ao)
              return ao;
          }
          hn(xn.first);
          for (let Hn = Xi + 1; Hn < Xi + Gi - 1; Hn++) {
            const io = Ps(Ni * Tr.getoffsetX(Hn), zi, Ki, ke, Gr, qr, nn, Wi, Ln, $r, ar, Jr, fi, !1, !1, Mi, Ei, Ii);
            if (!io)
              return Dr.length -= 4 * (Hn - Xi), { notEnoughRoom: !0 };
            hn(io);
          }
          hn(xn.last);
        } else {
          if (He && !ke) {
            const Hn = ts(qr.x, qr.y, 0, ir), io = Wi + nn + 1, uo = new ne.P($r.getx(io), $r.gety(io)), An = ts(uo.x, uo.y, 0, ir), eo = An[3] > 0 ? An : yl(qr, uo, Hn, 1, ir, void 0, Mi, Ei.canonical), On = Cf(dn, Pn, (eo[0] - Hn[0]) * bi, eo[1] - Hn[1]);
            if (qe.flipState = On && On.needsFlipping ? ga.flipRequired : ga.flipNotRequired, On)
              return On;
          }
          const xn = Ps(Ni * Tr.getoffsetX(Xi), zi, Ki, ke, Gr, qr, nn, Wi, Ln, $r, ar, Jr, fi, !1, !1, Mi, Ei, Ii);
          if (!xn)
            return { notEnoughRoom: !0 };
          hn(xn);
        }
        return {};
      }
      function Ys(qe, xe, ke, He, ir) {
        const { x: ar, y: yr, z: Tr } = He.projectTilePoint(qe.x, qe.y, xe);
        if (!ir)
          return ts(ar, yr, Tr, ke);
        const [$r, Dr, Or] = ir(qe);
        return ts(ar + $r, yr + Dr, Tr + Or, ke);
      }
      function yl(qe, xe, ke, He, ir, ar, yr, Tr) {
        const $r = Ys(qe.sub(xe)._unit()._add(qe), Tr, ir, yr, ar);
        return ne.ab.vec3.sub($r, ke, $r), ne.ab.vec3.normalize($r, $r), ne.ab.vec3.scaleAndAdd($r, ke, $r, He);
      }
      function Ps(qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr, qr, Jr, bi, fi, Mi, Ei) {
        const Ii = He ? qe - xe : qe + xe;
        let Ni = Ii > 0 ? 1 : -1, zi = 0;
        He && (Ni *= -1, zi = Math.PI), Ni < 0 && (zi += Math.PI);
        let Ki = Tr + yr + (Ni > 0 ? 0 : 1) | 0, Wi = ir, Xi = ir, Gi = 0, nn = 0;
        const dn = Math.abs(Ii), Pn = [], Ln = [];
        let hn = ar, xn = hn;
        const Hn = () => yl(xn, hn, Xi, dn - Gi + 1, Or, qr, fi, Mi.canonical);
        for (; Gi + nn <= dn; ) {
          if (Ki += Ni, Ki < Tr || Ki >= $r)
            return null;
          if (Xi = Wi, xn = hn, Pn.push(Xi), Jr && Ln.push(xn), hn = new ne.P(Dr.getx(Ki), Dr.gety(Ki)), Wi = Gr[Ki], !Wi) {
            const _o = Ys(hn, Mi.canonical, Or, fi, qr);
            Wi = _o[3] > 0 ? Gr[Ki] = _o : Hn();
          }
          Gi += nn, nn = ne.ab.vec3.distance(Xi, Wi);
        }
        bi && qr && (Gr[Ki] && (Wi = Hn(), nn = ne.ab.vec3.distance(Xi, Wi)), Gr[Ki] = Wi);
        const io = (dn - Gi) / nn, uo = hn.sub(xn)._mult(io)._add(xn), An = ne.ab.vec3.sub([], Wi, Xi), eo = ne.ab.vec3.scaleAndAdd([], Xi, An, io);
        let On = [0, 0, 1], ao = An[0], ro = An[1];
        if (Ei && (On = fi.upVector(Mi.canonical, uo.x, uo.y), On[0] !== 0 || On[1] !== 0 || On[2] !== 1)) {
          const _o = [On[2], 0, -On[0]], yo = ne.ab.vec3.cross([], On, _o);
          ne.ab.vec3.normalize(_o, _o), ne.ab.vec3.normalize(yo, yo), ao = ne.ab.vec3.dot(An, _o), ro = ne.ab.vec3.dot(An, yo);
        }
        if (ke) {
          const _o = ne.ab.vec3.cross([], On, An);
          ne.ab.vec3.normalize(_o, _o), ne.ab.vec3.scaleAndAdd(eo, eo, _o, ke * Ni);
        }
        const Wn = zi + Math.atan2(ro, ao);
        return Pn.push(eo), Jr && Ln.push(uo), { point: eo, angle: Wn, path: Pn, tilePath: Ln, up: On };
      }
      function iu(qe, xe) {
        const ke = xe.length, He = ke + 4 * qe;
        xe.resize(He), xe.float32.fill(-1 / 0, 4 * ke, 4 * He);
      }
      function ol(qe, xe, ke) {
        const He = xe[0], ir = xe[1];
        return qe[0] = ke[0] * He + ke[4] * ir + ke[12], qe[1] = ke[1] * He + ke[5] * ir + ke[13], qe[3] = ke[3] * He + ke[7] * ir + ke[15], qe;
      }
      const ds = 100;
      class dc {
        constructor(xe, ke, He = new Gu(xe.width + 200, xe.height + 200, 25), ir = new Gu(xe.width + 200, xe.height + 200, 25)) {
          this.transform = xe, this.grid = He, this.ignoredGrid = ir, this.pitchfactor = Math.cos(xe._pitch) * xe.cameraToCenterDistance, this.screenRightBoundary = xe.width + ds, this.screenBottomBoundary = xe.height + ds, this.gridRightBoundary = xe.width + 200, this.gridBottomBoundary = xe.height + 200, this.fogState = ke;
        }
        placeCollisionBox(xe, ke, He, ir, ar, yr, Tr, $r) {
          let Dr = He.projectedAnchorX, Or = He.projectedAnchorY, Gr = He.projectedAnchorZ;
          const qr = He.elevation, Jr = He.tileID, bi = xe.getProjection();
          if (qr && Jr) {
            const [Wi, Xi, Gi] = bi.upVector(Jr.canonical, He.tileAnchorX, He.tileAnchorY), nn = bi.upVectorScale(Jr.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
            Dr += Wi * qr * nn, Or += Xi * qr * nn, Gr += Gi * qr * nn;
          }
          const fi = this.projectAndGetPerspectiveRatio(Tr, Dr, Or, Gr, He.tileID, bi.name === "globe" || !!qr || this.transform.pitch > 0, bi), Mi = yr * fi.perspectiveRatio, Ei = (He.x1 * ke + ir.x - He.padding) * Mi + fi.point.x, Ii = (He.y1 * ke + ir.y - He.padding) * Mi + fi.point.y, Ni = (He.x2 * ke + ir.x + He.padding) * Mi + fi.point.x, zi = (He.y2 * ke + ir.y + He.padding) * Mi + fi.point.y, Ki = fi.perspectiveRatio <= 0.55 || fi.occluded;
          return !this.isInsideGrid(Ei, Ii, Ni, zi) || !ar && this.grid.hitTest(Ei, Ii, Ni, zi, $r) || Ki ? { box: [], offscreen: !1, occluded: fi.occluded } : { box: [Ei, Ii, Ni, zi], offscreen: this.isOffscreen(Ei, Ii, Ni, zi), occluded: !1 };
        }
        placeCollisionCircles(xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr, qr, Jr, bi, fi) {
          const Mi = [], Ei = this.transform.elevation, Ii = xe.getProjection(), Ni = Ei ? Ei.getAtTileOffsetFunc(fi, this.transform.center.lat, this.transform.worldSize, Ii) : null, zi = new ne.P(He.tileAnchorX, He.tileAnchorY);
          let { x: Ki, y: Wi, z: Xi } = Ii.projectTilePoint(zi.x, zi.y, fi.canonical);
          if (Ni) {
            const [uo, An, eo] = Ni(zi);
            Ki += uo, Wi += An, Xi += eo;
          }
          const Gi = Ii.name === "globe", nn = this.projectAndGetPerspectiveRatio(Tr, Ki, Wi, Xi, fi, Gi || !!Ei || this.transform.pitch > 0, Ii), { perspectiveRatio: dn } = nn, Pn = (Gr ? yr / dn : yr * dn) / ne.bw, Ln = ts(Ki, Wi, Xi, $r), hn = nn.signedDistanceFromCamera > 0 ? Wu(Pn, ar, He.lineOffsetX * Pn, He.lineOffsetY * Pn, !1, Ln, zi, He, ir, $r, {}, Ei && !Gr ? Ni : null, Gr && !!Ei, Ii, fi, Gr) : null;
          let xn = !1, Hn = !1, io = !0;
          if (hn && !nn.occluded) {
            const uo = 0.5 * Jr * dn + bi, An = new ne.P(-100, -100), eo = new ne.P(this.screenRightBoundary, this.screenBottomBoundary), On = new Dl(), { first: ao, last: ro } = hn, Wn = ao.path.length;
            let _o = [];
            for (let Eo = Wn - 1; Eo >= 1; Eo--)
              _o.push(ao.path[Eo]);
            for (let Eo = 1; Eo < ro.path.length; Eo++)
              _o.push(ro.path[Eo]);
            const yo = 2.5 * uo;
            Dr && (_o = _o.map(([Eo, Ko, Fo], zo) => (Ni && !Gi && (Fo = Ni(zo < Wn - 1 ? ao.tilePath[Wn - 1 - zo] : ro.tilePath[zo - Wn + 2])[2]), ts(Eo, Ko, Fo, Dr))), _o.some((Eo) => Eo[3] <= 0) && (_o = []));
            let mo = [];
            if (_o.length > 0) {
              let Eo = 1 / 0, Ko = -1 / 0, Fo = 1 / 0, zo = -1 / 0;
              for (const Jo of _o)
                Eo = Math.min(Eo, Jo[0]), Fo = Math.min(Fo, Jo[1]), Ko = Math.max(Ko, Jo[0]), zo = Math.max(zo, Jo[1]);
              Ko >= An.x && Eo <= eo.x && zo >= An.y && Fo <= eo.y && (mo = [_o.map((Jo) => new ne.P(Jo[0], Jo[1]))], (Eo < An.x || Ko > eo.x || Fo < An.y || zo > eo.y) && (mo = ne.bu(mo, An.x, An.y, eo.x, eo.y)));
            }
            for (const Eo of mo) {
              On.reset(Eo, 0.25 * uo);
              let Ko = 0;
              Ko = On.length <= 0.5 * uo ? 1 : Math.ceil(On.paddedLength / yo) + 1;
              for (let Fo = 0; Fo < Ko; Fo++) {
                const zo = Fo / Math.max(Ko - 1, 1), Jo = On.lerp(zo), ia = Jo.x + ds, sa = Jo.y + ds;
                Mi.push(ia, sa, uo, 0);
                const ss = ia - uo, Ya = sa - uo, Oa = ia + uo, Na = sa + uo;
                if (io = io && this.isOffscreen(ss, Ya, Oa, Na), Hn = Hn || this.isInsideGrid(ss, Ya, Oa, Na), !ke && this.grid.hitTestCircle(ia, sa, uo, qr) && (xn = !0, !Or))
                  return { circles: [], offscreen: !1, collisionDetected: xn, occluded: !1 };
              }
            }
          }
          return { circles: !Or && xn || !Hn ? [] : Mi, offscreen: io, collisionDetected: xn, occluded: nn.occluded };
        }
        queryRenderedSymbols(xe) {
          if (xe.length === 0 || this.grid.keysLength() === 0 && this.ignoredGrid.keysLength() === 0)
            return {};
          const ke = [];
          let He = 1 / 0, ir = 1 / 0, ar = -1 / 0, yr = -1 / 0;
          for (const Or of xe) {
            const Gr = new ne.P(Or.x + ds, Or.y + ds);
            He = Math.min(He, Gr.x), ir = Math.min(ir, Gr.y), ar = Math.max(ar, Gr.x), yr = Math.max(yr, Gr.y), ke.push(Gr);
          }
          const Tr = this.grid.query(He, ir, ar, yr).concat(this.ignoredGrid.query(He, ir, ar, yr)), $r = {}, Dr = {};
          for (const Or of Tr) {
            const Gr = Or.key;
            if ($r[Gr.bucketInstanceId] === void 0 && ($r[Gr.bucketInstanceId] = {}), $r[Gr.bucketInstanceId][Gr.featureIndex])
              continue;
            const qr = [new ne.P(Or.x1, Or.y1), new ne.P(Or.x2, Or.y1), new ne.P(Or.x2, Or.y2), new ne.P(Or.x1, Or.y2)];
            ne.bv(ke, qr) && ($r[Gr.bucketInstanceId][Gr.featureIndex] = !0, Dr[Gr.bucketInstanceId] === void 0 && (Dr[Gr.bucketInstanceId] = []), Dr[Gr.bucketInstanceId].push(Gr.featureIndex));
          }
          return Dr;
        }
        insertCollisionBox(xe, ke, He, ir, ar) {
          (ke ? this.ignoredGrid : this.grid).insert({ bucketInstanceId: He, featureIndex: ir, collisionGroupID: ar }, xe[0], xe[1], xe[2], xe[3]);
        }
        insertCollisionCircles(xe, ke, He, ir, ar) {
          const yr = ke ? this.ignoredGrid : this.grid, Tr = { bucketInstanceId: He, featureIndex: ir, collisionGroupID: ar };
          for (let $r = 0; $r < xe.length; $r += 4)
            yr.insertCircle(Tr, xe[$r], xe[$r + 1], xe[$r + 2]);
        }
        projectAndGetPerspectiveRatio(xe, ke, He, ir, ar, yr, Tr) {
          const $r = [ke, He, ir, 1];
          let Dr = !1;
          ir || this.transform.pitch > 0 ? (ne.ab.vec4.transformMat4($r, $r, xe), this.fogState && ar && Tr.name !== "globe" && (Dr = function(qr, Jr, bi, fi, Mi, Ei) {
            const Ii = Ei.calculateFogTileMatrix(Mi), Ni = [Jr, bi, fi];
            return ne.ab.vec3.transformMat4(Ni, Ni, Ii), xo(qr, ne.ab.vec3.length(Ni), Ei.pitch, Ei._fov);
          }(this.fogState, ke, He, ir, ar.toUnwrapped(), this.transform) > 0.9)) : ol($r, $r, xe);
          const Or = $r[3];
          return { point: new ne.P(($r[0] / Or + 1) / 2 * this.transform.width + ds, (-$r[1] / Or + 1) / 2 * this.transform.height + ds), perspectiveRatio: Math.min(0.5 + this.transform.getCameraToCenterDistance(Tr) / Or * 0.5, 1.5), signedDistanceFromCamera: Or, occluded: yr && $r[2] > Or || Dr };
        }
        isOffscreen(xe, ke, He, ir) {
          return He < ds || xe >= this.screenRightBoundary || ir < ds || ke > this.screenBottomBoundary;
        }
        isInsideGrid(xe, ke, He, ir) {
          return He >= 0 && xe < this.gridRightBoundary && ir >= 0 && ke < this.gridBottomBoundary;
        }
        getViewportMatrix() {
          const xe = ne.ab.mat4.identity([]);
          return ne.ab.mat4.translate(xe, xe, [-100, -100, 0]), xe;
        }
      }
      function Yl(qe, xe, ke) {
        const He = xe.createTileMatrix(qe, qe.worldSize, ke.toUnwrapped());
        return ne.ab.mat4.multiply(new Float32Array(16), qe.projMatrix, He);
      }
      function Ts(qe, xe, ke) {
        if (xe.projection.name === ke.projection.name)
          return qe.projMatrix;
        const He = ke.clone();
        return He.setProjection(xe.projection), Yl(He, xe.getProjection(), qe);
      }
      function $h(qe, xe, ke) {
        return xe.name === ke.projection.name ? qe.projMatrix : Yl(ke, xe, qe);
      }
      class Jl {
        constructor(xe, ke, He, ir) {
          this.opacity = xe ? Math.max(0, Math.min(1, xe.opacity + (xe.placed ? ke : -ke))) : ir && He ? 1 : 0, this.placed = He;
        }
        isHidden() {
          return this.opacity === 0 && !this.placed;
        }
      }
      class Ds {
        constructor(xe, ke, He, ir, ar, yr = !1) {
          this.text = new Jl(xe ? xe.text : null, ke, He, ar), this.icon = new Jl(xe ? xe.icon : null, ke, ir, ar), this.clipped = yr;
        }
        isHidden() {
          return this.text.isHidden() && this.icon.isHidden();
        }
      }
      class Rh {
        constructor(xe, ke, He, ir = !1) {
          this.text = xe, this.icon = ke, this.skipFade = He, this.clipped = ir;
        }
      }
      class al {
        constructor() {
          this.invProjMatrix = ne.ab.mat4.create(), this.viewportMatrix = ne.ab.mat4.create(), this.circles = [];
        }
      }
      class z0 {
        constructor(xe, ke, He, ir, ar) {
          this.bucketInstanceId = xe, this.featureIndex = ke, this.sourceLayerIndex = He, this.bucketIndex = ir, this.tileID = ar;
        }
      }
      class Vc {
        constructor(xe) {
          this.crossSourceCollisions = xe, this.maxGroupID = 0, this.collisionGroups = {};
        }
        get(xe) {
          if (this.crossSourceCollisions)
            return { ID: 0, predicate: null };
          if (!this.collisionGroups[xe]) {
            const ke = ++this.maxGroupID;
            this.collisionGroups[xe] = { ID: ke, predicate: (He) => He.collisionGroupID === ke };
          }
          return this.collisionGroups[xe];
        }
      }
      function nu(qe, xe, ke, He, ir) {
        const { horizontalAlign: ar, verticalAlign: yr } = ne.bD(qe), Tr = -(ar - 0.5) * xe, $r = -(yr - 0.5) * ke, Dr = ne.bC(qe, He);
        return new ne.P(Tr + Dr[0] * ir, $r + Dr[1] * ir);
      }
      function Zu(qe, xe, ke, He, ir) {
        const ar = new ne.P(qe, xe);
        return ke && ar._rotate(He ? ir : -ir), ar;
      }
      class bl {
        constructor(xe, ke, He, ir, ar, yr) {
          this.transform = xe.clone(), this.projection = xe.projection.name, this.collisionIndex = new dc(this.transform, ar), this.buildingIndex = yr, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = ke, this.retainedQueryData = {}, this.collisionGroups = new Vc(He), this.collisionCircleArrays = {}, this.prevPlacement = ir, ir && (ir.prevPlacement = void 0), this.placedOrientations = {};
        }
        getBucketParts(xe, ke, He, ir, ar = 1) {
          const yr = He.getBucket(ke), Tr = He.latestFeatureIndex;
          if (!yr || !Tr || ke.fqid !== yr.layerIds[0])
            return;
          const $r = yr.layers[0].layout, Dr = yr.layers[0].paint, Or = He.collisionBoxArray, Gr = Math.pow(2, this.transform.zoom - He.tileID.overscaledZ), qr = He.tileSize / ne.ag, Jr = He.tileID.toUnwrapped();
          this.transform.setProjection(yr.projection);
          const bi = (fi = He.tileID, Mi = yr.getProjection(), Ei = this.transform, Mi.name === this.projection ? Ei.calculateProjMatrix(fi.toUnwrapped()) : Yl(Ei, Mi, fi));
          var fi, Mi, Ei;
          const Ii = $r.get("text-pitch-alignment") === "map", Ni = $r.get("text-rotation-alignment") === "map";
          ke.compileFilter(ke.options);
          const zi = ke.dynamicFilter(), Ki = ke.dynamicFilterNeedsFeature(), Wi = this.transform.calculatePixelsToTileUnitsMatrix(He), Xi = Hu(bi, He.tileID.canonical, Ii, Ni, this.transform, yr.getProjection(), Wi);
          let Gi = null;
          if (Ii) {
            const uo = dl(bi, He.tileID.canonical, Ii, Ni, this.transform, yr.getProjection(), Wi);
            Gi = ne.ab.mat4.multiply([], this.transform.labelPlaneMatrix, uo);
          }
          let nn = null;
          zi && He.latestFeatureIndex && (nn = { unwrappedTileID: Jr, dynamicFilter: zi, dynamicFilterNeedsFeature: Ki }), this.retainedQueryData[yr.bucketInstanceId] = new z0(yr.bucketInstanceId, Tr, yr.sourceLayerIndex, yr.index, He.tileID);
          const [dn, Pn] = yr.layers[0].layout.get("text-size-scale-range"), Ln = ne.aw(ar, dn, Pn), [hn, xn] = $r.get("icon-size-scale-range"), Hn = ne.aw(ar, hn, xn), io = { bucket: yr, layout: $r, paint: Dr, posMatrix: bi, textLabelPlaneMatrix: Xi, labelToScreenMatrix: Gi, clippingData: nn, scale: Gr, textPixelRatio: qr, holdingForFade: He.holdingForFade(), collisionBoxArray: Or, partiallyEvaluatedTextSize: ne.bp(yr.textSizeData, this.transform.zoom, Ln), partiallyEvaluatedIconSize: ne.bp(yr.iconSizeData, this.transform.zoom, Hn), collisionGroup: this.collisionGroups.get(yr.sourceID), latestFeatureIndex: He.latestFeatureIndex };
          if (ir)
            for (const uo of yr.sortKeyRanges) {
              const { sortKey: An, symbolInstanceStart: eo, symbolInstanceEnd: On } = uo;
              xe.push({ sortKey: An, symbolInstanceStart: eo, symbolInstanceEnd: On, parameters: io });
            }
          else
            xe.push({ symbolInstanceStart: 0, symbolInstanceEnd: yr.symbolInstances.length, parameters: io });
        }
        attemptAnchorPlacement(xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr, qr, Jr, bi, fi, Mi, Ei, Ii) {
          const { textOffset0: Ni, textOffset1: zi, crossTileID: Ki } = qr, Wi = [Ni, zi], Xi = nu(xe, He, ir, Wi, ar), Gi = this.collisionIndex.placeCollisionBox(bi, ar, ke, Zu(Xi.x, Xi.y, yr, Tr, this.transform.angle), Gr, $r, Dr, Or.predicate);
          if (Mi) {
            const nn = bi.getSymbolInstanceIconSize(Ii, this.transform.zoom, qr.placedIconSymbolIndex);
            if (this.collisionIndex.placeCollisionBox(bi, nn, Mi, Zu(Xi.x, Xi.y, yr, Tr, this.transform.angle), Gr, $r, Dr, Or.predicate).box.length === 0)
              return;
          }
          if (Gi.box.length > 0) {
            let nn;
            return this.prevPlacement && this.prevPlacement.variableOffsets[Ki] && this.prevPlacement.placements[Ki] && this.prevPlacement.placements[Ki].text && (nn = this.prevPlacement.variableOffsets[Ki].anchor), this.variableOffsets[Ki] = { textOffset: Wi, width: He, height: ir, anchor: xe, textScale: ar, prevAnchor: nn }, this.markUsedJustification(bi, xe, qr, fi), bi.allowVerticalPlacement && (this.markUsedOrientation(bi, fi, qr), this.placedOrientations[Ki] = fi), { shift: Xi, placedGlyphBoxes: Gi };
          }
        }
        placeLayerBucketPart(xe, ke, He, ir, ar = 1) {
          const { bucket: yr, layout: Tr, paint: $r, posMatrix: Dr, textLabelPlaneMatrix: Or, labelToScreenMatrix: Gr, clippingData: qr, textPixelRatio: Jr, holdingForFade: bi, collisionBoxArray: fi, partiallyEvaluatedTextSize: Mi, partiallyEvaluatedIconSize: Ei, collisionGroup: Ii, latestFeatureIndex: Ni } = xe.parameters, zi = Tr.get("text-optional"), Ki = Tr.get("icon-optional"), Wi = Tr.get("text-allow-overlap"), Xi = Tr.get("icon-allow-overlap"), Gi = Tr.get("text-rotation-alignment") === "map", nn = Tr.get("text-pitch-alignment") === "map", dn = Tr.get("symbol-z-elevate"), Pn = $r.get("symbol-z-offset"), Ln = Tr.get("symbol-elevation-reference") === "sea", [hn, xn] = Tr.get("text-size-scale-range"), [Hn, io] = Tr.get("icon-size-scale-range"), uo = ne.aw(ar, hn, xn), An = ne.aw(ar, Hn, io);
          this.transform.setProjection(yr.projection);
          let eo = Wi && (Xi || !yr.hasIconData() || Ki), On = Xi && (Wi || !yr.hasTextData() || zi);
          const ao = !Pn.isConstant();
          !yr.collisionArrays && fi && yr.deserializeCollisionBoxes(fi), He && ir && yr.updateCollisionDebugBuffers(this.transform.zoom, fi, uo, An);
          const ro = (Wn, _o, yo) => {
            const { crossTileID: mo, numVerticalGlyphVertices: Eo } = Wn;
            let Ko = null;
            if (qr && qr.dynamicFilterNeedsFeature || ao) {
              const is = this.retainedQueryData[yr.bucketInstanceId];
              Ko = Ni.loadFeature({ featureIndex: Wn.featureIndex, bucketIndex: is.bucketIndex, sourceLayerIndex: is.sourceLayerIndex, layoutVertexArrayOffset: 0 });
            }
            if (qr && !(0, qr.dynamicFilter)({ zoom: this.transform.zoom, pitch: this.transform.pitch }, Ko, this.retainedQueryData[yr.bucketInstanceId].tileID.canonical, new ne.P(Wn.tileAnchorX, Wn.tileAnchorY), this.transform.calculateDistanceTileData(qr.unwrappedTileID)))
              return this.placements[mo] = new Rh(!1, !1, !1, !0), void ke.add(mo);
            const Fo = Pn.evaluate(Ko, {});
            if (ke.has(mo))
              return;
            if (bi)
              return void (this.placements[mo] = new Rh(!1, !1, !1));
            let zo = !1, Jo = !1, ia = !0, sa = !1, ss = !1, Ya = null, Oa = { box: null, offscreen: null, occluded: null }, Na = { box: null, offscreen: null, occluded: null }, la = null, _a = null, qo = null, Aa = 0, ps = 0, Xs = 0;
            yo.textFeatureIndex ? Aa = yo.textFeatureIndex : Wn.useRuntimeCollisionCircles && (Aa = Wn.featureIndex), yo.verticalTextFeatureIndex && (ps = yo.verticalTextFeatureIndex);
            const ql = (is) => {
              is.tileID = this.retainedQueryData[yr.bucketInstanceId].tileID;
              const Za = this.transform.elevation;
              is.elevation = Ln ? Fo : Fo + (Za ? Za.getAtTileOffset(is.tileID, is.tileAnchorX, is.tileAnchorY) : 0), is.elevation += Wn.zOffset;
            }, ml = yo.textBox;
            if (ml) {
              ql(ml);
              const is = (Ma) => {
                let xs = ne.bq.horizontal;
                if (yr.allowVerticalPlacement && !Ma && this.prevPlacement) {
                  const Vs = this.prevPlacement.placedOrientations[mo];
                  Vs && (this.placedOrientations[mo] = Vs, xs = Vs, this.markUsedOrientation(yr, xs, Wn));
                }
                return xs;
              }, Za = (Ma, xs) => {
                if (yr.allowVerticalPlacement && Eo > 0 && yo.verticalTextBox) {
                  for (const Vs of yr.writingModes)
                    if (Vs === ne.bq.vertical ? (Oa = xs(), Na = Oa) : Oa = Ma(), Oa && Oa.box && Oa.box.length)
                      break;
                } else
                  Oa = Ma();
              };
              if (Tr.get("text-variable-anchor")) {
                let Ma = Tr.get("text-variable-anchor");
                if (this.prevPlacement && this.prevPlacement.variableOffsets[mo]) {
                  const Ja = this.prevPlacement.variableOffsets[mo];
                  Ma.indexOf(Ja.anchor) > 0 && (Ma = Ma.filter((ul) => ul !== Ja.anchor), Ma.unshift(Ja.anchor));
                }
                const xs = (Ja, ul, nc) => {
                  const Rl = yr.getSymbolInstanceTextSize(Mi, Wn, this.transform.zoom, _o), vu = (Ja.x2 - Ja.x1) * Rl + 2 * Ja.padding, Jc = (Ja.y2 - Ja.y1) * Rl + 2 * Ja.padding, gl = Wn.hasIconTextFit && !Xi ? ul : null;
                  gl && ql(gl);
                  let oc = { box: [], offscreen: !1, occluded: !1 };
                  const Rc = Wi ? 2 * Ma.length : Ma.length;
                  for (let yc = 0; yc < Rc; ++yc) {
                    const xh = this.attemptAnchorPlacement(Ma[yc % Ma.length], Ja, vu, Jc, Rl, Gi, nn, Jr, Dr, Ii, yc >= Ma.length, Wn, _o, yr, nc, gl, Mi, Ei);
                    if (xh && (oc = xh.placedGlyphBoxes, oc && oc.box && oc.box.length)) {
                      zo = !0, Ya = xh.shift;
                      break;
                    }
                  }
                  return oc;
                };
                Za(() => xs(ml, yo.iconBox, ne.bq.horizontal), () => {
                  const Ja = yo.verticalTextBox;
                  return Ja && ql(Ja), yr.allowVerticalPlacement && !(Oa && Oa.box && Oa.box.length) && Eo > 0 && Ja ? xs(Ja, yo.verticalIconBox, ne.bq.vertical) : { box: null, offscreen: null, occluded: null };
                }), Oa && (zo = Oa.box, ia = Oa.offscreen, sa = Oa.occluded);
                const Vs = is(!(!Oa || !Oa.box));
                if (!zo && this.prevPlacement) {
                  const Ja = this.prevPlacement.variableOffsets[mo];
                  Ja && (this.variableOffsets[mo] = Ja, this.markUsedJustification(yr, Ja.anchor, Wn, Vs));
                }
              } else {
                const Ma = (xs, Vs) => {
                  const Ja = yr.getSymbolInstanceTextSize(Mi, Wn, this.transform.zoom, _o, ar), ul = this.collisionIndex.placeCollisionBox(yr, Ja, xs, new ne.P(0, 0), Wi, Jr, Dr, Ii.predicate);
                  return ul && ul.box && ul.box.length && (this.markUsedOrientation(yr, Vs, Wn), this.placedOrientations[mo] = Vs), ul;
                };
                Za(() => Ma(ml, ne.bq.horizontal), () => {
                  const xs = yo.verticalTextBox;
                  return yr.allowVerticalPlacement && Eo > 0 && xs ? (ql(xs), Ma(xs, ne.bq.vertical)) : { box: null, offscreen: null, occluded: null };
                }), is(!!(Oa && Oa.box && Oa.box.length));
              }
            }
            if (la = Oa, zo = la && la.box && la.box.length > 0, ia = la && la.offscreen, sa = la && la.occluded, Wn.useRuntimeCollisionCircles) {
              const is = yr.text.placedSymbolArray.get(Wn.centerJustifiedTextSymbolIndex >= 0 ? Wn.centerJustifiedTextSymbolIndex : Wn.verticalPlacedTextSymbolIndex), Za = ne.br(yr.textSizeData, Mi, is), Ma = Tr.get("text-padding");
              _a = this.collisionIndex.placeCollisionCircles(yr, Wi, is, yr.lineVertexArray, yr.glyphOffsetArray, Za, Dr, Or, Gr, He, nn, Ii.predicate, Wn.collisionCircleDiameter * Za / ne.bw, Ma, this.retainedQueryData[yr.bucketInstanceId].tileID), zo = Wi || _a.circles.length > 0 && !_a.collisionDetected, ia = ia && _a.offscreen, sa = _a.occluded;
            }
            if (yo.iconFeatureIndex && (Xs = yo.iconFeatureIndex), yo.iconBox) {
              const is = (Za) => {
                ql(Za);
                const Ma = Wn.hasIconTextFit && Ya ? Zu(Ya.x, Ya.y, Gi, nn, this.transform.angle) : new ne.P(0, 0), xs = yr.getSymbolInstanceIconSize(Ei, this.transform.zoom, Wn.placedIconSymbolIndex);
                return this.collisionIndex.placeCollisionBox(yr, xs, Za, Ma, Xi, Jr, Dr, Ii.predicate);
              };
              Na && Na.box && Na.box.length && yo.verticalIconBox ? (qo = is(yo.verticalIconBox), Jo = qo.box.length > 0) : (qo = is(yo.iconBox), Jo = qo.box.length > 0), ia = ia && qo.offscreen, ss = qo.occluded;
            }
            const Ns = zi || Wn.numHorizontalGlyphVertices === 0 && Eo === 0, ks = Ki || Wn.numIconVertices === 0;
            if (Ns || ks ? ks ? Ns || (Jo = Jo && zo) : zo = Jo && zo : Jo = zo = Jo && zo, zo && la && la.box && this.collisionIndex.insertCollisionBox(la.box, Tr.get("text-ignore-placement"), yr.bucketInstanceId, Na && Na.box && ps ? ps : Aa, Ii.ID), Jo && qo && this.collisionIndex.insertCollisionBox(qo.box, Tr.get("icon-ignore-placement"), yr.bucketInstanceId, Xs, Ii.ID), _a && (zo && this.collisionIndex.insertCollisionCircles(_a.circles, Tr.get("text-ignore-placement"), yr.bucketInstanceId, Aa, Ii.ID), He)) {
              const is = yr.bucketInstanceId;
              let Za = this.collisionCircleArrays[is];
              Za === void 0 && (Za = this.collisionCircleArrays[is] = new al());
              for (let Ma = 0; Ma < _a.circles.length; Ma += 4)
                Za.circles.push(_a.circles[Ma + 0]), Za.circles.push(_a.circles[Ma + 1]), Za.circles.push(_a.circles[Ma + 2]), Za.circles.push(_a.collisionDetected ? 1 : 0);
            }
            const Cs = yr.projection.name !== "globe";
            eo = eo && (Cs || !sa), On = On && (Cs || !ss), this.placements[mo] = new Rh(zo || eo, Jo || On, ia || yr.justReloaded), ke.add(mo);
          };
          if (dn && this.buildingIndex && (this.buildingIndex.updateZOffset(yr, this.retainedQueryData[yr.bucketInstanceId].tileID), yr.updateZOffset()), yr.sortFeaturesByY) {
            const Wn = yr.getSortedSymbolIndexes(this.transform.angle);
            for (let _o = Wn.length - 1; _o >= 0; --_o) {
              const yo = Wn[_o];
              ro(yr.symbolInstances.get(yo), yo, yr.collisionArrays[yo]);
            }
            yr.hasAnyZOffset && ne.w(`${yr.layerIds[0]} layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y`);
          } else if (yr.hasAnyZOffset) {
            const Wn = yr.getSortedIndexesByZOffset();
            for (let _o = 0; _o < Wn.length; ++_o) {
              const yo = Wn[_o];
              ro(yr.symbolInstances.get(yo), yo, yr.collisionArrays[yo]);
            }
          } else
            for (let Wn = xe.symbolInstanceStart; Wn < xe.symbolInstanceEnd; Wn++)
              ro(yr.symbolInstances.get(Wn), Wn, yr.collisionArrays[Wn]);
          if (He && yr.bucketInstanceId in this.collisionCircleArrays) {
            const Wn = this.collisionCircleArrays[yr.bucketInstanceId];
            ne.ab.mat4.invert(Wn.invProjMatrix, Dr), Wn.viewportMatrix = this.collisionIndex.getViewportMatrix();
          }
          yr.justReloaded = !1;
        }
        markUsedJustification(xe, ke, He, ir) {
          const { leftJustifiedTextSymbolIndex: ar, centerJustifiedTextSymbolIndex: yr, rightJustifiedTextSymbolIndex: Tr, verticalPlacedTextSymbolIndex: $r, crossTileID: Dr } = He, Or = ne.bB(ke), Gr = ir === ne.bq.vertical ? $r : Or === "left" ? ar : Or === "center" ? yr : Or === "right" ? Tr : -1;
          ar >= 0 && (xe.text.placedSymbolArray.get(ar).crossTileID = Gr >= 0 && ar !== Gr ? 0 : Dr), yr >= 0 && (xe.text.placedSymbolArray.get(yr).crossTileID = Gr >= 0 && yr !== Gr ? 0 : Dr), Tr >= 0 && (xe.text.placedSymbolArray.get(Tr).crossTileID = Gr >= 0 && Tr !== Gr ? 0 : Dr), $r >= 0 && (xe.text.placedSymbolArray.get($r).crossTileID = Gr >= 0 && $r !== Gr ? 0 : Dr);
        }
        markUsedOrientation(xe, ke, He) {
          const ir = ke === ne.bq.horizontal || ke === ne.bq.horizontalOnly ? ke : 0, ar = ke === ne.bq.vertical ? ke : 0, { leftJustifiedTextSymbolIndex: yr, centerJustifiedTextSymbolIndex: Tr, rightJustifiedTextSymbolIndex: $r, verticalPlacedTextSymbolIndex: Dr } = He, Or = xe.text.placedSymbolArray;
          yr >= 0 && (Or.get(yr).placedOrientation = ir), Tr >= 0 && (Or.get(Tr).placedOrientation = ir), $r >= 0 && (Or.get($r).placedOrientation = ir), Dr >= 0 && (Or.get(Dr).placedOrientation = ar);
        }
        commit(xe) {
          this.commitTime = xe, this.zoomAtLastRecencyCheck = this.transform.zoom;
          const ke = this.prevPlacement;
          let He = !1;
          this.prevZoomAdjustment = ke ? ke.zoomAdjustment(this.transform.zoom) : 0;
          const ir = ke ? ke.symbolFadeChange(xe) : 1, ar = ke ? ke.opacities : {}, yr = ke ? ke.variableOffsets : {}, Tr = ke ? ke.placedOrientations : {};
          for (const $r in this.placements) {
            const Dr = this.placements[$r], Or = ar[$r];
            Or ? (this.opacities[$r] = new Ds(Or, ir, Dr.text, Dr.icon, null, Dr.clipped), He = He || Dr.text !== Or.text.placed || Dr.icon !== Or.icon.placed) : (this.opacities[$r] = new Ds(null, ir, Dr.text, Dr.icon, Dr.skipFade, Dr.clipped), He = He || Dr.text || Dr.icon);
          }
          for (const $r in ar) {
            const Dr = ar[$r];
            if (!this.opacities[$r]) {
              const Or = new Ds(Dr, ir, !1, !1);
              Or.isHidden() || (this.opacities[$r] = Or, He = He || Dr.text.placed || Dr.icon.placed);
            }
          }
          for (const $r in yr)
            this.variableOffsets[$r] || !this.opacities[$r] || this.opacities[$r].isHidden() || (this.variableOffsets[$r] = yr[$r]);
          for (const $r in Tr)
            this.placedOrientations[$r] || !this.opacities[$r] || this.opacities[$r].isHidden() || (this.placedOrientations[$r] = Tr[$r]);
          He ? this.lastPlacementChangeTime = xe : typeof this.lastPlacementChangeTime != "number" && (this.lastPlacementChangeTime = ke ? ke.lastPlacementChangeTime : xe);
        }
        updateLayerOpacities(xe, ke, He, ir) {
          const ar = /* @__PURE__ */ new Set();
          for (const yr of ke) {
            const Tr = yr.getBucket(xe);
            Tr && yr.latestFeatureIndex && xe.fqid === Tr.layerIds[0] && (this.updateBucketOpacities(Tr, ar, yr, yr.collisionBoxArray, He, ir, yr.tileID, xe.scope), Tr.layers[0].layout.get("symbol-z-elevate") && this.buildingIndex && (this.buildingIndex.updateZOffset(Tr, yr.tileID), Tr.updateZOffset()));
          }
        }
        updateBucketOpacities(xe, ke, He, ir, ar, yr, Tr, $r) {
          xe.hasTextData() && xe.text.opacityVertexArray.clear(), xe.hasIconData() && xe.icon.opacityVertexArray.clear(), xe.hasIconCollisionBoxData() && xe.iconCollisionBox.collisionVertexArray.clear(), xe.hasTextCollisionBoxData() && xe.textCollisionBox.collisionVertexArray.clear();
          const Dr = xe.layers[0].layout, Or = xe.layers[0].paint, Gr = !!xe.layers[0].dynamicFilter(), qr = new Ds(null, 0, !1, !1, !0), Jr = Dr.get("text-allow-overlap"), bi = Dr.get("icon-allow-overlap"), fi = Dr.get("text-variable-anchor"), Mi = Dr.get("text-rotation-alignment") === "map", Ei = Dr.get("text-pitch-alignment") === "map", Ii = Or.get("symbol-z-offset"), Ni = Dr.get("symbol-elevation-reference") === "sea", zi = !Ii.isConstant(), Ki = new Ds(null, 0, Jr && (bi || !xe.hasIconData() || Dr.get("icon-optional")), bi && (Jr || !xe.hasTextData() || Dr.get("text-optional")), !0);
          !xe.collisionArrays && ir && (xe.hasIconCollisionBoxData() || xe.hasTextCollisionBoxData()) && xe.deserializeCollisionBoxes(ir);
          const Wi = (Gi, nn, dn) => {
            for (let Pn = 0; Pn < nn / 4; Pn++)
              Gi.opacityVertexArray.emplaceBack(dn);
          };
          let Xi = 0;
          yr && xe.updateReplacement(Tr, yr);
          for (let Gi = 0; Gi < xe.symbolInstances.length; Gi++) {
            const nn = xe.symbolInstances.get(Gi), { numHorizontalGlyphVertices: dn, numVerticalGlyphVertices: Pn, crossTileID: Ln, numIconVertices: hn, tileAnchorX: xn, tileAnchorY: Hn } = nn;
            let io = null;
            const uo = this.retainedQueryData[xe.bucketInstanceId];
            zi && nn && uo && (io = He.latestFeatureIndex.loadFeature({ featureIndex: nn.featureIndex, bucketIndex: uo.bucketIndex, sourceLayerIndex: uo.sourceLayerIndex, layoutVertexArrayOffset: 0 }));
            const An = Ii.evaluate(io, {}), eo = ke.has(Ln);
            let On = this.opacities[Ln];
            eo ? On = qr : On || (On = Ki, this.opacities[Ln] = On), ke.add(Ln);
            const ao = dn > 0 || Pn > 0, ro = hn > 0, Wn = this.placedOrientations[Ln], _o = Wn === ne.bq.vertical, yo = Wn === ne.bq.horizontal || Wn === ne.bq.horizontalOnly;
            !ao && !ro || On.isHidden() || Xi++;
            let mo = !1;
            if ((ao || ro) && yr)
              for (const Eo of xe.activeReplacements) {
                if (ne.bx(Eo, ar, ne.by.Symbol, $r) || Eo.min.x > xn || xn > Eo.max.x || Eo.min.y > Hn || Hn > Eo.max.y)
                  continue;
                const Ko = ne.bz(xn, Hn, Tr.canonical, Eo.footprintTileId.canonical);
                if (mo = ne.bA(Ko, Eo.footprint), mo)
                  break;
              }
            if (ao) {
              const Eo = mo ? Ol : Tp(On.text);
              Wi(xe.text, dn, _o ? Ol : Eo), Wi(xe.text, Pn, yo ? Ol : Eo);
              const Ko = On.text.isHidden(), { leftJustifiedTextSymbolIndex: Fo, centerJustifiedTextSymbolIndex: zo, rightJustifiedTextSymbolIndex: Jo, verticalPlacedTextSymbolIndex: ia } = nn, sa = xe.text.placedSymbolArray, ss = Ko || _o ? 1 : 0;
              Fo >= 0 && (sa.get(Fo).hidden = ss), zo >= 0 && (sa.get(zo).hidden = ss), Jo >= 0 && (sa.get(Jo).hidden = ss), ia >= 0 && (sa.get(ia).hidden = Ko || yo ? 1 : 0);
              const Ya = this.variableOffsets[Ln];
              Ya && this.markUsedJustification(xe, Ya.anchor, nn, Wn);
              const Oa = this.placedOrientations[Ln];
              Oa && (this.markUsedJustification(xe, "left", nn, Oa), this.markUsedOrientation(xe, Oa, nn));
            }
            if (ro) {
              const Eo = mo ? Ol : Tp(On.icon), { placedIconSymbolIndex: Ko, verticalPlacedIconSymbolIndex: Fo } = nn, zo = xe.icon.placedSymbolArray, Jo = On.icon.isHidden() ? 1 : 0;
              Ko >= 0 && (Wi(xe.icon, hn, _o ? Ol : Eo), zo.get(Ko).hidden = Jo), Fo >= 0 && (Wi(xe.icon, nn.numVerticalIconVertices, yo ? Ol : Eo), zo.get(Fo).hidden = Jo);
            }
            if (xe.hasIconCollisionBoxData() || xe.hasTextCollisionBoxData()) {
              const Eo = xe.collisionArrays[Gi];
              if (Eo) {
                let Ko = new ne.P(0, 0), Fo = !0;
                if (Eo.textBox || Eo.verticalTextBox) {
                  if (fi) {
                    const Jo = this.variableOffsets[Ln];
                    Jo ? (Ko = nu(Jo.anchor, Jo.width, Jo.height, Jo.textOffset, Jo.textScale), Mi && Ko._rotate(Ei ? this.transform.angle : -this.transform.angle)) : Fo = !1;
                  }
                  Gr && (Fo = !On.clipped), Eo.textBox && Ms(xe.textCollisionBox.collisionVertexArray, On.text.placed, !Fo || _o, An, Ni, Ko.x, Ko.y), Eo.verticalTextBox && Ms(xe.textCollisionBox.collisionVertexArray, On.text.placed, !Fo || yo, An, Ni, Ko.x, Ko.y);
                }
                const zo = Fo && Boolean(!yo && Eo.verticalIconBox);
                Eo.iconBox && Ms(xe.iconCollisionBox.collisionVertexArray, On.icon.placed, zo, An, Ni, nn.hasIconTextFit ? Ko.x : 0, nn.hasIconTextFit ? Ko.y : 0), Eo.verticalIconBox && Ms(xe.iconCollisionBox.collisionVertexArray, On.icon.placed, !zo, An, Ni, nn.hasIconTextFit ? Ko.x : 0, nn.hasIconTextFit ? Ko.y : 0);
              }
            }
          }
          if (xe.fullyClipped = Xi === 0, xe.sortFeatures(this.transform.angle), this.retainedQueryData[xe.bucketInstanceId] && (this.retainedQueryData[xe.bucketInstanceId].featureSortOrder = xe.featureSortOrder), xe.hasTextData() && xe.text.opacityVertexBuffer && xe.text.opacityVertexBuffer.updateData(xe.text.opacityVertexArray), xe.hasIconData() && xe.icon.opacityVertexBuffer && xe.icon.opacityVertexBuffer.updateData(xe.icon.opacityVertexArray), xe.hasIconCollisionBoxData() && xe.iconCollisionBox.collisionVertexBuffer && xe.iconCollisionBox.collisionVertexBuffer.updateData(xe.iconCollisionBox.collisionVertexArray), xe.hasTextCollisionBoxData() && xe.textCollisionBox.collisionVertexBuffer && xe.textCollisionBox.collisionVertexBuffer.updateData(xe.textCollisionBox.collisionVertexArray), xe.bucketInstanceId in this.collisionCircleArrays) {
            const Gi = this.collisionCircleArrays[xe.bucketInstanceId];
            xe.placementInvProjMatrix = Gi.invProjMatrix, xe.placementViewportMatrix = Gi.viewportMatrix, xe.collisionCircleArray = Gi.circles, delete this.collisionCircleArrays[xe.bucketInstanceId];
          }
        }
        symbolFadeChange(xe) {
          return this.fadeDuration === 0 ? 1 : (xe - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
        }
        zoomAdjustment(xe) {
          return Math.max(0, (this.transform.zoom - xe) / 1.5);
        }
        hasTransitions(xe) {
          return this.stale || xe - this.lastPlacementChangeTime < this.fadeDuration;
        }
        stillRecent(xe, ke) {
          const He = this.zoomAtLastRecencyCheck === ke ? 1 - this.zoomAdjustment(ke) : 1;
          return this.zoomAtLastRecencyCheck = ke, this.commitTime + this.fadeDuration * He > xe;
        }
        setStale() {
          this.stale = !0;
        }
      }
      function Ms(qe, xe, ke, He, ir, ar, yr) {
        qe.emplaceBack(xe ? 1 : 0, ke ? 1 : 0, ar || 0, yr || 0, He, ir ? 1 : 0), qe.emplaceBack(xe ? 1 : 0, ke ? 1 : 0, ar || 0, yr || 0, He, ir ? 1 : 0), qe.emplaceBack(xe ? 1 : 0, ke ? 1 : 0, ar || 0, yr || 0, He, ir ? 1 : 0), qe.emplaceBack(xe ? 1 : 0, ke ? 1 : 0, ar || 0, yr || 0, He, ir ? 1 : 0);
      }
      const Sc = Math.pow(2, 25), Tf = Math.pow(2, 24), Md = Math.pow(2, 17), Cp = Math.pow(2, 16), F0 = Math.pow(2, 9), Sd = Math.pow(2, 8), Ed = Math.pow(2, 1);
      function Tp(qe) {
        if (qe.opacity === 0 && !qe.placed)
          return 0;
        if (qe.opacity === 1 && qe.placed)
          return 4294967295;
        const xe = qe.placed ? 1 : 0, ke = Math.floor(127 * qe.opacity);
        return ke * Sc + xe * Tf + ke * Md + xe * Cp + ke * F0 + xe * Sd + ke * Ed + xe;
      }
      const Ol = 0;
      class Xu {
        constructor(xe) {
          this._sortAcrossTiles = xe.layout.get("symbol-z-order") !== "viewport-y" && xe.layout.get("symbol-sort-key").constantOr(1) !== void 0, this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = /* @__PURE__ */ new Set(), this._bucketParts = [];
        }
        continuePlacement(xe, ke, He, ir, ar, yr) {
          const Tr = this._bucketParts;
          for (; this._currentTileIndex < xe.length; )
            if (ke.getBucketParts(Tr, ir, xe[this._currentTileIndex], this._sortAcrossTiles, yr), this._currentTileIndex++, ar())
              return !0;
          for (this._sortAcrossTiles && (this._sortAcrossTiles = !1, Tr.sort(($r, Dr) => $r.sortKey - Dr.sortKey)); this._currentPartIndex < Tr.length; ) {
            const $r = Tr[this._currentPartIndex];
            if (ke.placeLayerBucketPart($r, this._seenCrossTileIDs, He, $r.symbolInstanceStart === 0, yr), this._currentPartIndex++, ar())
              return !0;
          }
          return !1;
        }
      }
      class Af {
        constructor(xe, ke, He, ir, ar, yr, Tr, $r, Dr) {
          this.placement = new bl(xe, ar, yr, Tr, $r, Dr), this._currentPlacementIndex = ke.length - 1, this._forceFullPlacement = He, this._showCollisionBoxes = ir, this._done = !1;
        }
        isDone() {
          return this._done;
        }
        continuePlacement(xe, ke, He, ir, ar) {
          const yr = ne.q.now(), Tr = () => {
            const $r = ne.q.now() - yr;
            return !this._forceFullPlacement && $r > 2;
          };
          for (; this._currentPlacementIndex >= 0; ) {
            const $r = ke[xe[this._currentPlacementIndex]], Dr = this.placement.collisionIndex.transform.zoom;
            if ($r.type === "symbol" && (!$r.minzoom || $r.minzoom <= Dr) && (!$r.maxzoom || $r.maxzoom > Dr)) {
              const Or = $r, Gr = Or.layout.get("symbol-z-elevate"), qr = Or.layout.get("symbol-sort-key").constantOr(1) !== void 0, Jr = Or.layout.get("symbol-z-order"), bi = Jr === "viewport-y" || Jr === "auto" && !(Jr !== "viewport-y" && qr), fi = Or.layout.get("text-allow-overlap") || Or.layout.get("icon-allow-overlap") || Or.layout.get("text-ignore-placement") || Or.layout.get("icon-ignore-placement"), Mi = bi && fi, Ei = this._inProgressLayer = this._inProgressLayer || new Xu(Or), Ii = ne.aC($r.source, $r.scope);
              if (Ei.continuePlacement(Gr || Mi ? ir[Ii] : He[Ii], this.placement, this._showCollisionBoxes, $r, Tr, ar))
                return;
              delete this._inProgressLayer;
            }
            this._currentPlacementIndex--;
          }
          this._done = !0;
        }
        commit(xe) {
          return this.placement.commit(xe), this.placement;
        }
      }
      const Ec = 512 / ne.ag / 2;
      class $m {
        constructor(xe, ke, He) {
          this.tileID = xe, this.bucketInstanceId = He, this.index = new ne.bE(ke.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
          const ir = xe.canonical.x * ne.ag, ar = xe.canonical.y * ne.ag;
          for (let yr = 0; yr < ke.length; yr++) {
            const { key: Tr, crossTileID: $r, tileAnchorX: Dr, tileAnchorY: Or } = ke.get(yr), Gr = Math.floor((ir + Dr) * Ec), qr = Math.floor((ar + Or) * Ec);
            this.index.add(Gr, qr), this.keys.push(Tr), this.crossTileIDs.push($r);
          }
          this.index.finish();
        }
        findMatches(xe, ke, He) {
          const ir = this.tileID.canonical.z < ke.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - ke.canonical.z), ar = Ec / Math.pow(2, ke.canonical.z - this.tileID.canonical.z), yr = ke.canonical.x * ne.ag, Tr = ke.canonical.y * ne.ag;
          for (let $r = 0; $r < xe.length; $r++) {
            const Dr = xe.get($r);
            if (Dr.crossTileID)
              continue;
            const { key: Or, tileAnchorX: Gr, tileAnchorY: qr } = Dr, Jr = Math.floor((yr + Gr) * ar), bi = Math.floor((Tr + qr) * ar), fi = this.index.range(Jr - ir, bi - ir, Jr + ir, bi + ir);
            for (const Mi of fi) {
              const Ei = this.crossTileIDs[Mi];
              if (this.keys[Mi] === Or && !He.has(Ei)) {
                He.add(Ei), Dr.crossTileID = Ei;
                break;
              }
            }
          }
        }
      }
      class Ap {
        constructor() {
          this.maxCrossTileID = 0;
        }
        generate() {
          return ++this.maxCrossTileID;
        }
      }
      class kp {
        constructor() {
          this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
        }
        handleWrapJump(xe) {
          const ke = Math.round((xe - this.lng) / 360);
          if (ke !== 0)
            for (const He in this.indexes) {
              const ir = this.indexes[He], ar = {};
              for (const yr in ir) {
                const Tr = ir[yr];
                Tr.tileID = Tr.tileID.unwrapTo(Tr.tileID.wrap + ke), ar[Tr.tileID.key] = Tr;
              }
              this.indexes[He] = ar;
            }
          this.lng = xe;
        }
        addBucket(xe, ke, He) {
          if (this.indexes[xe.overscaledZ] && this.indexes[xe.overscaledZ][xe.key]) {
            if (this.indexes[xe.overscaledZ][xe.key].bucketInstanceId === ke.bucketInstanceId)
              return !1;
            this.removeBucketCrossTileIDs(xe.overscaledZ, this.indexes[xe.overscaledZ][xe.key]);
          }
          for (let ar = 0; ar < ke.symbolInstances.length; ar++)
            ke.symbolInstances.get(ar).crossTileID = 0;
          this.usedCrossTileIDs[xe.overscaledZ] || (this.usedCrossTileIDs[xe.overscaledZ] = /* @__PURE__ */ new Set());
          const ir = this.usedCrossTileIDs[xe.overscaledZ];
          for (const ar in this.indexes) {
            const yr = this.indexes[ar];
            if (Number(ar) > xe.overscaledZ)
              for (const Tr in yr) {
                const $r = yr[Tr];
                $r.tileID.isChildOf(xe) && $r.findMatches(ke.symbolInstances, xe, ir);
              }
            else {
              const Tr = yr[xe.scaledTo(Number(ar)).key];
              Tr && Tr.findMatches(ke.symbolInstances, xe, ir);
            }
          }
          for (let ar = 0; ar < ke.symbolInstances.length; ar++) {
            const yr = ke.symbolInstances.get(ar);
            yr.crossTileID || (yr.crossTileID = He.generate(), ir.add(yr.crossTileID));
          }
          return this.indexes[xe.overscaledZ] === void 0 && (this.indexes[xe.overscaledZ] = {}), this.indexes[xe.overscaledZ][xe.key] = new $m(xe, ke.symbolInstances, ke.bucketInstanceId), !0;
        }
        removeBucketCrossTileIDs(xe, ke) {
          for (const He of ke.crossTileIDs)
            this.usedCrossTileIDs[xe].delete(He);
        }
        removeStaleBuckets(xe) {
          let ke = !1;
          for (const He in this.indexes) {
            const ir = this.indexes[He];
            for (const ar in ir)
              xe[ir[ar].bucketInstanceId] || (this.removeBucketCrossTileIDs(He, ir[ar]), delete ir[ar], ke = !0);
          }
          return ke;
        }
      }
      class Lp {
        constructor() {
          this.layerIndexes = {}, this.crossTileIDs = new Ap(), this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
        }
        addLayer(xe, ke, He, ir) {
          let ar = this.layerIndexes[xe.fqid];
          ar === void 0 && (ar = this.layerIndexes[xe.fqid] = new kp());
          let yr = !1;
          const Tr = {};
          ir.name !== "globe" && ar.handleWrapJump(He);
          for (const $r of ke) {
            const Dr = $r.getBucket(xe);
            Dr && xe.fqid === Dr.layerIds[0] && (Dr.bucketInstanceId || (Dr.bucketInstanceId = ++this.maxBucketInstanceId), ar.addBucket($r.tileID, Dr, this.crossTileIDs) && (yr = !0), Tr[Dr.bucketInstanceId] = !0);
          }
          return ar.removeStaleBuckets(Tr) && (yr = !0), yr;
        }
        pruneUnusedLayers(xe) {
          const ke = {};
          xe.forEach((He) => {
            ke[He] = !0;
          });
          for (const He in this.layerIndexes)
            ke[He] || delete this.layerIndexes[He];
        }
      }
      const Ph = 771;
      class aa {
        constructor(xe, ke, He, ir) {
          this.blendFunction = xe, this.blendColor = ke, this.mask = He, this.blendEquation = ir;
        }
      }
      aa.Replace = [1, 0, 1, 0], aa.disabled = new aa(aa.Replace, ne.aj.transparent, [!1, !1, !1, !1]), aa.unblended = new aa(aa.Replace, ne.aj.transparent, [!0, !0, !0, !0]), aa.alphaBlended = new aa([1, Ph, 1, Ph], ne.aj.transparent, [!0, !0, !0, !0]), aa.alphaBlendedNonPremultiplied = new aa([770, Ph, 770, Ph], ne.aj.transparent, [!0, !0, !0, !0]), aa.multiply = new aa([774, 0, 774, 0], ne.aj.transparent, [!0, !0, !0, !0]);
      class Oo {
        constructor(xe, ke, He) {
          this.func = xe, this.mask = ke, this.range = He;
        }
      }
      Oo.ReadOnly = !1, Oo.ReadWrite = !0, Oo.disabled = new Oo(519, Oo.ReadOnly, [0, 1]);
      const kf = 7680;
      class ta {
        constructor(xe, ke, He, ir, ar, yr) {
          this.test = xe, this.ref = ke, this.mask = He, this.fail = ir, this.depthFail = ar, this.pass = yr;
        }
      }
      ta.disabled = new ta({ func: 519, mask: 0 }, 0, 0, kf, kf, kf);
      const xl = 1029, Cc = 2305;
      class Uo {
        constructor(xe, ke, He) {
          this.enable = xe, this.mode = ke, this.frontFace = He;
        }
      }
      function Lf(qe, xe) {
        const ke = ne.bG(qe, 3);
        ne.ab.mat4.fromQuat(qe, xe), ne.bI(qe, 3, ke);
      }
      function Cd(qe, xe) {
        const ke = ne.ab.quat.identity([]);
        return ne.ab.quat.rotateZ(ke, ke, -xe), ne.ab.quat.rotateX(ke, ke, -qe), ke;
      }
      function Dh(qe, xe) {
        const ke = [qe[0], qe[1], 0], He = [xe[0], xe[1], 0];
        if (ne.ab.vec3.length(ke) >= 1e-15) {
          const yr = ne.ab.vec3.normalize([], ke);
          ne.ab.vec3.scale(He, yr, ne.ab.vec3.dot(He, yr)), xe[0] = He[0], xe[1] = He[1];
        }
        const ir = ne.ab.vec3.cross([], xe, qe);
        if (ne.ab.vec3.len(ir) < 1e-15)
          return null;
        const ar = Math.atan2(-ir[1], ir[0]);
        return Cd(Math.atan2(Math.sqrt(qe[0] * qe[0] + qe[1] * qe[1]), -qe[2]), ar);
      }
      Uo.disabled = new Uo(!1, xl, Cc), Uo.backCCW = new Uo(!0, xl, Cc), Uo.backCW = new Uo(!0, xl, 2304), Uo.frontCW = new Uo(!0, 1028, 2304), Uo.frontCCW = new Uo(!0, 1028, Cc);
      class Oh {
        constructor(xe, ke) {
          this.position = xe, this.orientation = ke;
        }
        get position() {
          return this._position;
        }
        set position(xe) {
          if (xe) {
            const ke = xe instanceof ne.aa ? xe : new ne.aa(xe[0], xe[1], xe[2]);
            this._renderWorldCopies && (ke.x = ne.bF(ke.x, 0, 1)), this._position = ke;
          } else
            this._position = null;
        }
        lookAtPoint(xe, ke) {
          if (this.orientation = null, !this.position)
            return;
          const He = this.position, ir = this._elevation ? this._elevation.getAtPointOrZero(ne.aa.fromLngLat(xe)) : 0, ar = ne.aa.fromLngLat(xe, ir), yr = [ar.x - He.x, ar.y - He.y, ar.z - He.z];
          ke || (ke = [0, 0, 1]), ke[2] = Math.abs(ke[2]), this.orientation = Dh(yr, ke);
        }
        setPitchBearing(xe, ke) {
          this.orientation = Cd(ne.ai(xe), ne.ai(-ke));
        }
      }
      class Td {
        constructor(xe, ke) {
          this._transform = ne.ab.mat4.identity([]), this.orientation = ke, this.position = xe;
        }
        get mercatorPosition() {
          const xe = this.position;
          return new ne.aa(xe[0], xe[1], xe[2]);
        }
        get position() {
          const xe = ne.bG(this._transform, 3);
          return [xe[0], xe[1], xe[2]];
        }
        set position(xe) {
          var ke;
          xe && ne.bI(this._transform, 3, [(ke = xe)[0], ke[1], ke[2], 1]);
        }
        get orientation() {
          return this._orientation;
        }
        set orientation(xe) {
          this._orientation = xe || ne.ab.quat.identity([]), xe && Lf(this._transform, this._orientation);
        }
        getPitchBearing() {
          const xe = this.forward(), ke = this.right();
          return { bearing: Math.atan2(-ke[1], ke[0]), pitch: Math.atan2(Math.sqrt(xe[0] * xe[0] + xe[1] * xe[1]), -xe[2]) };
        }
        setPitchBearing(xe, ke) {
          this._orientation = Cd(xe, ke), Lf(this._transform, this._orientation);
        }
        forward() {
          const xe = ne.bG(this._transform, 2);
          return [-xe[0], -xe[1], -xe[2]];
        }
        up() {
          const xe = ne.bG(this._transform, 1);
          return [-xe[0], -xe[1], -xe[2]];
        }
        right() {
          const xe = ne.bG(this._transform, 0);
          return [xe[0], xe[1], xe[2]];
        }
        getCameraToWorld(xe, ke) {
          const He = new Float64Array(16);
          return ne.ab.mat4.invert(He, this.getWorldToCamera(xe, ke)), He;
        }
        getCameraToWorldMercator() {
          return this._transform;
        }
        getWorldToCameraPosition(xe, ke, He) {
          const ir = this.position;
          ne.ab.vec3.scale(ir, ir, -xe);
          const ar = new Float64Array(16);
          return ne.ab.mat4.fromScaling(ar, [He, He, He]), ne.ab.mat4.translate(ar, ar, ir), ar[10] *= ke, ar;
        }
        getWorldToCamera(xe, ke) {
          const He = new Float64Array(16), ir = new Float64Array(4), ar = this.position;
          return ne.ab.quat.conjugate(ir, this._orientation), ne.ab.vec3.scale(ar, ar, -xe), ne.ab.mat4.fromQuat(He, ir), ne.ab.mat4.translate(He, He, ar), He[1] *= -1, He[5] *= -1, He[9] *= -1, He[13] *= -1, He[8] *= ke, He[9] *= ke, He[10] *= ke, He[11] *= ke, He;
        }
        getCameraToClipPerspective(xe, ke, He, ir) {
          const ar = new Float64Array(16);
          return ne.ab.mat4.perspective(ar, xe, ke, He, ir), ar;
        }
        getCameraToClipOrthographic(xe, ke, He, ir, ar, yr) {
          const Tr = new Float64Array(16);
          return ne.ab.mat4.ortho(Tr, xe, ke, He, ir, ar, yr), Tr;
        }
        getDistanceToElevation(xe, ke = !1) {
          const He = xe === 0 ? 0 : ne.bH(xe, ke ? ne.aS(this.position[1]) : this.position[1]), ir = this.forward();
          return (He - this.position[2]) / ir[2];
        }
        clone() {
          return new Td([...this.position], [...this.orientation]);
        }
      }
      const ll = { BaseColor: 5, MetallicRoughness: 6, Normal: 7, Occlusion: 8, Emission: 9, LUT: 10, ShadowMap0: 11 };
      class Fl {
        constructor(xe = 0, ke = 0, He = 0, ir = 0) {
          if (isNaN(xe) || xe < 0 || isNaN(ke) || ke < 0 || isNaN(He) || He < 0 || isNaN(ir) || ir < 0)
            throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
          this.top = xe, this.bottom = ke, this.left = He, this.right = ir;
        }
        interpolate(xe, ke, He) {
          return ke.top != null && xe.top != null && (this.top = ne.af(xe.top, ke.top, He)), ke.bottom != null && xe.bottom != null && (this.bottom = ne.af(xe.bottom, ke.bottom, He)), ke.left != null && xe.left != null && (this.left = ne.af(xe.left, ke.left, He)), ke.right != null && xe.right != null && (this.right = ne.af(xe.right, ke.right, He)), this;
        }
        getCenter(xe, ke) {
          const He = ne.aw((this.left + xe - this.right) / 2, 0, xe), ir = ne.aw((this.top + ke - this.bottom) / 2, 0, ke);
          return new ne.P(He, ir);
        }
        equals(xe) {
          return this.top === xe.top && this.bottom === xe.bottom && this.left === xe.left && this.right === xe.right;
        }
        clone() {
          return new Fl(this.top, this.bottom, this.left, this.right);
        }
        toJSON() {
          return { top: this.top, bottom: this.bottom, left: this.left, right: this.right };
        }
      }
      const ou = (qe, xe, ke) => (1 - ke) * qe + ke * xe, vo = (qe) => qe * qe * qe * qe * qe;
      class If {
        constructor(xe, ke, He, ir, ar, yr, Tr) {
          this.tileSize = 512, this._renderWorldCopies = ar === void 0 || ar, this._minZoom = xe || 0, this._maxZoom = ke || 22, this._minPitch = He ?? 0, this._maxPitch = ir ?? 60, this.setProjection(yr), this.setMaxBounds(Tr), this.width = 0, this.height = 0, this._center = new ne.bO(0, 0), this.zoom = 0, this.angle = 0, this._fov = 0.6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._unmodified = !0, this._edgeInsets = new Fl(), this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._expandedProjMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new Td(), this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [0, 0, 0], this._tileCoverLift = 0, this.freezeTileCoverage = !1, this._horizonShift = 0.1, this._orthographicProjectionAtLowPitch = !1;
        }
        clone() {
          const xe = new If(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection());
          return xe._elevation = this._elevation, xe._centerAltitude = this._centerAltitude, xe._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, xe.tileSize = this.tileSize, xe.mercatorFromTransition = this.mercatorFromTransition, xe.width = this.width, xe.height = this.height, xe.cameraElevationReference = this.cameraElevationReference, xe._center = this._center, xe._setZoom(this.zoom), xe._seaLevelZoom = this._seaLevelZoom, xe.angle = this.angle, xe._fov = this._fov, xe._pitch = this._pitch, xe._nearZ = this._nearZ, xe._farZ = this._farZ, xe._averageElevation = this._averageElevation, xe._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, xe._unmodified = this._unmodified, xe._edgeInsets = this._edgeInsets.clone(), xe._camera = this._camera.clone(), xe._calcMatrices(), xe.freezeTileCoverage = this.freezeTileCoverage, xe.frustumCorners = this.frustumCorners, xe;
        }
        get isOrthographic() {
          return this.projection.name !== "globe" && this._orthographicProjectionAtLowPitch && this.pitch < 15;
        }
        get elevation() {
          return this._elevation;
        }
        set elevation(xe) {
          this._elevation !== xe && (this._elevation = xe, this._updateCameraOnTerrain(), this._calcMatrices());
        }
        get depthOcclusionForSymbolsAndCircles() {
          return this.projection.name !== "globe" && !this.isOrthographic;
        }
        updateElevation(xe, ke = !1) {
          const He = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
          (this._seaLevelZoom == null || He) && this._updateCameraOnTerrain(), (xe || He) && this._constrainCamera(ke), this._calcMatrices();
        }
        getProjection() {
          return ne.ay(this.projection, ["name", "center", "parallels"]);
        }
        setProjection(xe) {
          this.projectionOptions = xe || { name: "mercator" };
          const ke = this.projection ? this.getProjection() : void 0;
          this.projection = ne.bP(this.projectionOptions);
          const He = this.getProjection(), ir = !ne.bn(ke, He);
          return ir && this._calcMatrices(), this.mercatorFromTransition = !1, ir;
        }
        setOrthographicProjectionAtLowPitch(xe) {
          return this._orthographicProjectionAtLowPitch !== xe && (this._orthographicProjectionAtLowPitch = xe, this._calcMatrices(), !0);
        }
        setMercatorFromTransition() {
          const xe = this.projection.name;
          this.mercatorFromTransition = !0, this.projectionOptions = { name: "mercator" }, this.projection = ne.bP({ name: "mercator" });
          const ke = xe !== this.projection.name;
          return ke && this._calcMatrices(), ke;
        }
        get minZoom() {
          return this._minZoom;
        }
        set minZoom(xe) {
          this._minZoom !== xe && (this._minZoom = xe, this.zoom = Math.max(this.zoom, xe));
        }
        get maxZoom() {
          return this._maxZoom;
        }
        set maxZoom(xe) {
          this._maxZoom !== xe && (this._maxZoom = xe, this.zoom = Math.min(this.zoom, xe));
        }
        get minPitch() {
          return this._minPitch;
        }
        set minPitch(xe) {
          this._minPitch !== xe && (this._minPitch = xe, this.pitch = Math.max(this.pitch, xe));
        }
        get maxPitch() {
          return this._maxPitch;
        }
        set maxPitch(xe) {
          this._maxPitch !== xe && (this._maxPitch = xe, this.pitch = Math.min(this.pitch, xe));
        }
        get renderWorldCopies() {
          return this._renderWorldCopies && this.projection.supportsWorldCopies === !0;
        }
        set renderWorldCopies(xe) {
          xe === void 0 ? xe = !0 : xe === null && (xe = !1), this._renderWorldCopies = xe;
        }
        get worldSize() {
          return this.tileSize * this.scale;
        }
        get cameraWorldSizeForFog() {
          const xe = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
          return this._worldSizeFromZoom(this._zoomFromMercatorZ(xe));
        }
        get cameraWorldSize() {
          const xe = Math.max(this._camera.getDistanceToElevation(this._averageElevation, !0), Number.EPSILON);
          return this._worldSizeFromZoom(this._zoomFromMercatorZ(xe));
        }
        get pixelsPerMeter() {
          return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
        }
        get cameraPixelsPerMeter() {
          return ne.bH(1, this.center.lat) * this.cameraWorldSizeForFog;
        }
        get centerOffset() {
          return this.centerPoint._sub(this.size._div(2));
        }
        get size() {
          return new ne.P(this.width, this.height);
        }
        get bearing() {
          return ne.bF(this.rotation, -180, 180);
        }
        set bearing(xe) {
          this.rotation = xe;
        }
        get rotation() {
          return -this.angle / Math.PI * 180;
        }
        set rotation(xe) {
          const ke = -xe * Math.PI / 180;
          this.angle !== ke && (this._unmodified = !1, this.angle = ke, this._calcMatrices(), this.rotationMatrix = ne.ab.mat2.create(), ne.ab.mat2.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
        }
        get pitch() {
          return this._pitch / Math.PI * 180;
        }
        set pitch(xe) {
          const ke = ne.aw(xe, this.minPitch, this.maxPitch) / 180 * Math.PI;
          this._pitch !== ke && (this._unmodified = !1, this._pitch = ke, this._calcMatrices());
        }
        get aspect() {
          return this.width / this.height;
        }
        get fov() {
          return this._fov / Math.PI * 180;
        }
        get fovX() {
          return this._fov;
        }
        get fovY() {
          const xe = 1 / Math.tan(0.5 * this.fovX);
          return 2 * Math.atan(1 / this.aspect / xe);
        }
        set fov(xe) {
          xe = Math.max(0.01, Math.min(60, xe)), this._fov !== xe && (this._unmodified = !1, this._fov = ne.ai(xe), this._calcMatrices());
        }
        get averageElevation() {
          return this._averageElevation;
        }
        set averageElevation(xe) {
          this._averageElevation = xe, this._calcFogMatrices(), this._distanceTileDataCache = {};
        }
        get zoom() {
          return this._zoom;
        }
        set zoom(xe) {
          const ke = Math.min(Math.max(xe, this.minZoom), this.maxZoom);
          this._zoom !== ke && (this._unmodified = !1, this._setZoom(ke), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
        }
        _setZoom(xe) {
          this._zoom = xe, this.scale = this.zoomScale(xe), this.tileZoom = Math.floor(xe), this.zoomFraction = xe - this.tileZoom;
        }
        get tileCoverLift() {
          return this._tileCoverLift;
        }
        set tileCoverLift(xe) {
          this._tileCoverLift !== xe && (this._tileCoverLift = xe);
        }
        _updateCameraOnTerrain() {
          const xe = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY, ke = this.elevation && xe === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
          if (!this._elevation || xe === Number.NEGATIVE_INFINITY && (!ke || !this._centerAltitude))
            return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
          const He = this._elevation;
          ke || this._centerAltitude && this._centerAltitudeValidForExaggeration && He.exaggeration() && this._centerAltitudeValidForExaggeration !== He.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * He.exaggeration(), this._centerAltitudeValidForExaggeration = He.exaggeration()) : (this._centerAltitude = xe || 0, this._centerAltitudeValidForExaggeration = He.exaggeration()), this._updateSeaLevelZoom();
        }
        _updateSeaLevelZoom() {
          this._centerAltitudeValidForExaggeration !== void 0 && (this._seaLevelZoom = this._zoomFromMercatorZ((this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize));
        }
        sampleAverageElevation() {
          if (!this._elevation)
            return 0;
          const xe = this._elevation, ke = [[0.5, 0.2], [0.3, 0.5], [0.5, 0.5], [0.7, 0.5], [0.5, 0.8]], He = this.horizonLineFromTop();
          let ir = 0, ar = 0;
          for (let yr = 0; yr < ke.length; yr++) {
            const Tr = new ne.P(ke[yr][0] * this.width, He + ke[yr][1] * (this.height - He)), $r = xe.pointCoordinate(Tr);
            if (!$r)
              continue;
            const Dr = 1 / Math.hypot($r[0] - this._camera.position[0], $r[1] - this._camera.position[1]);
            ir += $r[3] * Dr, ar += Dr;
          }
          return ar === 0 ? NaN : ir / ar;
        }
        get center() {
          return this._center;
        }
        set center(xe) {
          xe.lat === this._center.lat && xe.lng === this._center.lng || (this._unmodified = !1, this._center = xe, this._terrainEnabled() && (this.cameraElevationReference === "ground" ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
        }
        _updateZoomFromElevation() {
          if (this._seaLevelZoom == null || !this._elevation)
            return;
          const xe = this._seaLevelZoom, ke = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), He = this.pixelsPerMeter / this.worldSize * ke, ir = this._mercatorZfromZoom(xe), ar = this._mercatorZfromZoom(this._maxZoom), yr = Math.max(ir - He, ar);
          this._setZoom(this._zoomFromMercatorZ(yr));
        }
        get padding() {
          return this._edgeInsets.toJSON();
        }
        set padding(xe) {
          this._edgeInsets.equals(xe) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, xe, 1), this._calcMatrices());
        }
        computeZoomRelativeTo(xe) {
          const ke = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, xe.toAltitude()));
          let He;
          He = xe.z < this._camera.position[2] ? [ke.x, ke.y, ke.z] : [xe.x, xe.y, xe.z];
          const ir = ne.ab.vec3.length(ne.ab.vec3.sub([], this._camera.position, He));
          return ne.aw(this._zoomFromMercatorZ(ir), this._minZoom, this._maxZoom);
        }
        setFreeCameraOptions(xe) {
          if (!this.height || !xe.position && !xe.orientation)
            return;
          this._updateCameraState();
          let ke = !1;
          if (xe.orientation && !ne.ab.quat.exactEquals(xe.orientation, this._camera.orientation) && (ke = this._setCameraOrientation(xe.orientation)), xe.position) {
            const He = [xe.position.x, xe.position.y, xe.position.z];
            ne.ab.vec3.exactEquals(He, this._camera.position) || (this._setCameraPosition(He), ke = !0);
          }
          ke && (this._updateStateFromCamera(), this.recenterOnTerrain());
        }
        getFreeCameraOptions() {
          this._updateCameraState();
          const xe = this._camera.position, ke = new Oh();
          return ke.position = new ne.aa(xe[0], xe[1], xe[2]), ke.orientation = this._camera.orientation, ke._elevation = this.elevation, ke._renderWorldCopies = this.renderWorldCopies, ke;
        }
        _setCameraOrientation(xe) {
          if (!ne.ab.quat.length(xe))
            return !1;
          ne.ab.quat.normalize(xe, xe);
          const ke = ne.ab.vec3.transformQuat([], [0, 0, -1], xe), He = ne.ab.vec3.transformQuat([], [0, -1, 0], xe);
          if (He[2] < 0)
            return !1;
          const ir = Dh(ke, He);
          return !!ir && (this._camera.orientation = ir, !0);
        }
        _setCameraPosition(xe) {
          const ke = this.zoomScale(this.minZoom) * this.tileSize, He = this.zoomScale(this.maxZoom) * this.tileSize, ir = this.cameraToCenterDistance;
          xe[2] = ne.aw(xe[2], ir / He, ir / ke), this._camera.position = xe;
        }
        get centerPoint() {
          return this._edgeInsets.getCenter(this.width, this.height);
        }
        get fovAboveCenter() {
          return this._fov * (0.5 + this.centerOffset.y / this.height);
        }
        isPaddingEqual(xe) {
          return this._edgeInsets.equals(xe);
        }
        interpolatePadding(xe, ke, He) {
          this._unmodified = !1, this._edgeInsets.interpolate(xe, ke, He), this._constrain(), this._calcMatrices();
        }
        coveringZoomLevel(xe) {
          const ke = (xe.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / xe.tileSize));
          return Math.max(0, ke);
        }
        getVisibleUnwrappedCoordinates(xe) {
          const ke = [new ne.bQ(0, xe)];
          if (this.renderWorldCopies) {
            const He = this.pointCoordinate(new ne.P(0, 0)), ir = this.pointCoordinate(new ne.P(this.width, 0)), ar = this.pointCoordinate(new ne.P(this.width, this.height)), yr = this.pointCoordinate(new ne.P(0, this.height)), Tr = Math.floor(Math.min(He.x, ir.x, ar.x, yr.x)), $r = Math.floor(Math.max(He.x, ir.x, ar.x, yr.x)), Dr = 1;
            for (let Or = Tr - Dr; Or <= $r + Dr; Or++)
              Or !== 0 && ke.push(new ne.bQ(Or, xe));
          }
          return ke;
        }
        isLODDisabled(xe) {
          return (!xe || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
        }
        extendTileCover(xe, ke, He) {
          let ir = [];
          const ar = He !== void 0, yr = !ar;
          if (yr && this.zoom < ke || ar && He[0] === 0 && He[1] === 0)
            return ir;
          const Tr = /* @__PURE__ */ new Set(), $r = (Or, Gr, qr, Jr, bi) => {
            const fi = ne.c5(Gr, Or, qr, Jr, bi);
            Tr.has(fi) || (ir.push(new ne.aG(Or, Gr, qr, Jr, bi)), Tr.add(fi));
          };
          for (let Or = 0; Or < xe.length; Or++) {
            const Gr = xe[Or];
            if (yr && Gr.canonical.z !== ke)
              continue;
            const qr = Gr.canonical, Jr = Gr.overscaledZ, bi = Gr.wrap, fi = 1 << qr.z, Mi = qr.x + 1 < fi, Ei = qr.x > 0, Ii = qr.y + 1 < fi, Ni = qr.y > 0, zi = Gr.wrap - (Ei ? 0 : 1), Ki = Gr.wrap + (Mi ? 0 : 1), Wi = Ei ? qr.x - 1 : fi - 1, Xi = Mi ? qr.x + 1 : 0;
            if (ar)
              He[0] < 0 ? ($r(Jr, Ki, qr.z, Xi, qr.y), He[1] < 0 && Ii && ($r(Jr, bi, qr.z, qr.x, qr.y + 1), $r(Jr, Ki, qr.z, Xi, qr.y + 1)), He[1] > 0 && Ni && ($r(Jr, bi, qr.z, qr.x, qr.y - 1), $r(Jr, Ki, qr.z, Xi, qr.y - 1))) : He[0] > 0 ? ($r(Jr, zi, qr.z, Wi, qr.y), He[1] < 0 && Ii && ($r(Jr, bi, qr.z, qr.x, qr.y + 1), $r(Jr, zi, qr.z, Wi, qr.y + 1)), He[1] > 0 && Ni && ($r(Jr, bi, qr.z, qr.x, qr.y - 1), $r(Jr, zi, qr.z, Wi, qr.y - 1))) : He[1] < 0 && Ii ? $r(Jr, bi, qr.z, qr.x, qr.y + 1) : Ni && $r(Jr, bi, qr.z, qr.x, qr.y - 1);
            else {
              const Gi = Gr.visibleQuadrants;
              1 & Gi && ($r(Jr, zi, qr.z, Wi, qr.y), Ni && ($r(Jr, bi, qr.z, qr.x, qr.y - 1), $r(Jr, zi, qr.z, Wi, qr.y - 1))), 2 & Gi && ($r(Jr, Ki, qr.z, Xi, qr.y), Ni && ($r(Jr, bi, qr.z, qr.x, qr.y - 1), $r(Jr, Ki, qr.z, Xi, qr.y - 1))), 4 & Gi && ($r(Jr, zi, qr.z, Wi, qr.y), Ii && ($r(Jr, bi, qr.z, qr.x, qr.y + 1), $r(Jr, zi, qr.z, Wi, qr.y + 1))), 8 & Gi && ($r(Jr, Ki, qr.z, Xi, qr.y), Ii && ($r(Jr, bi, qr.z, qr.x, qr.y + 1), $r(Jr, Ki, qr.z, Xi, qr.y + 1)));
            }
          }
          const Dr = [];
          for (const Or of ir)
            ir.some((Gr) => Or.isChildOf(Gr)) || Dr.push(Or);
          if (ir = Dr.filter((Or) => !xe.some((Gr) => !!(Or.overscaledZ < ke && Gr.isChildOf(Or)) || Or.equals(Gr) || Or.isChildOf(Gr))), yr) {
            const Or = 1 << ke, Gr = this.projection.name === "globe" ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), qr = [Or * Gr.x, Or * Gr.y], Jr = 4, bi = Jr * Jr;
            ir = ir.filter((fi) => {
              const Mi = fi.canonical.x + 0.5 - qr[0], Ei = fi.canonical.y + 0.5 - qr[1];
              return Mi * Mi + Ei * Ei < bi;
            });
          }
          return ir;
        }
        coveringTiles(xe) {
          let ke = this.coveringZoomLevel(xe);
          const He = ke, ir = this.elevation && this.elevation.exaggeration(), ar = ir && !xe.isTerrainDEM, yr = this.projection.name === "mercator";
          if (xe.minzoom !== void 0 && ke < xe.minzoom)
            return [];
          xe.maxzoom !== void 0 && ke > xe.maxzoom && (ke = xe.maxzoom);
          const Tr = this.locationCoordinate(this.center), $r = this.center.lat, Dr = 1 << ke, Or = [Dr * Tr.x, Dr * Tr.y, 0], Gr = this.projection.name === "globe", qr = !Gr, Jr = ne.bR.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, ke, qr), bi = Gr ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), fi = Dr * ne.bH(1, this.center.lat), Mi = this._camera.position[2] / ne.bH(1, this.center.lat), Ei = [Dr * bi.x, Dr * bi.y, Mi * (qr ? 1 : fi)], Ii = Gr || ir, Ni = this.cameraToCenterDistance / xe.tileSize * (xe.roundZoom ? 1 : 0.502), zi = this.isLODDisabled(!0) ? ke : 0;
          let Ki;
          if (this._elevation && xe.isTerrainDEM)
            Ki = 1e4 * this._elevation.exaggeration();
          else if (this._elevation) {
            const An = this._elevation.getMinMaxForVisibleTiles();
            Ki = An ? An.max : this._centerAltitude;
          } else
            Ki = this._centerAltitude;
          const Wi = xe.isTerrainDEM ? -Ki : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, Xi = this.projection.isReprojectedInTileSpace ? ne.bS(this) : 1, Gi = (An) => {
            const On = new ne.aa(An.x + 25e-6, An.y, An.z), ao = new ne.aa(An.x, An.y + 25e-6, An.z), ro = An.toLngLat(), Wn = On.toLngLat(), _o = ao.toLngLat(), yo = this.locationCoordinate(ro), mo = this.locationCoordinate(Wn), Eo = this.locationCoordinate(_o), Ko = Math.hypot(mo.x - yo.x, mo.y - yo.y), Fo = Math.hypot(Eo.x - yo.x, Eo.y - yo.y);
            return Math.sqrt(Ko * Fo) * Xi / 25e-6;
          }, nn = (An) => {
            const eo = Ki, On = Wi;
            return { aabb: ne.bV(this, Dr, 0, 0, 0, An, On, eo, this.projection), zoom: 0, x: 0, y: 0, minZ: On, maxZ: eo, wrap: An, fullyVisible: !1 };
          }, dn = [];
          let Pn = [];
          const Ln = ke, hn = xe.reparseOverscaled ? He : ke, xn = (Mi - this._centerAltitude) * fi, Hn = (An) => {
            if (!this._elevation || !An.tileID || !yr)
              return;
            const eo = this._elevation.getMinMaxForTile(An.tileID), On = An.aabb;
            eo ? (On.min[2] = eo.min, On.max[2] = eo.max, On.center[2] = (On.min[2] + On.max[2]) / 2) : (An.shouldSplit = uo(An), An.shouldSplit || (On.min[2] = On.max[2] = On.center[2] = this._centerAltitude));
          }, io = (An, eo) => {
            if (0.707 * eo < An)
              return 1;
            const On = eo / An;
            return On / (1.4144271570014144 + (Math.pow(1.1, On - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
          }, uo = (An) => {
            if (An.zoom < zi)
              return !0;
            if (An.zoom === Ln)
              return !1;
            if (An.shouldSplit != null)
              return An.shouldSplit;
            const eo = An.aabb.distanceX(Ei), On = An.aabb.distanceY(Ei);
            let ao = xn, ro = 1;
            if (Gr) {
              ao = An.aabb.distanceZ(Ei);
              const Fo = Math.pow(2, An.zoom), zo = ne.aS((An.y + 1) / Fo), Jo = ne.aS(An.y / Fo), ia = Math.min(Math.max($r, zo), Jo), sa = ne.c9(ia) / ne.c9($r);
              if (ro = ia === $r ? 1 / Math.max(1, this._mercatorScaleRatio - 0.3) : Math.min(1, sa / this._mercatorScaleRatio), this.zoom <= ne.c6 && An.zoom === Ln - 1 && sa >= 0.9)
                return !0;
            } else if (ar && (ao = An.aabb.distanceZ(Ei) * fi), this.projection.isReprojectedInTileSpace && He <= 5) {
              const Fo = Math.pow(2, An.zoom), zo = Gi(new ne.aa((An.x + 0.5) / Fo, (An.y + 0.5) / Fo));
              ro = zo > 0.85 ? 1 : zo;
            }
            if (!yr) {
              const Fo = Math.sqrt(eo * eo + On * On + ao * ao);
              let zo = (1 << Ln - An.zoom) * Ni * ro;
              return zo *= io(Math.max(ao, xn), Fo), Fo < zo;
            }
            let Wn = Number.MAX_VALUE, _o = 0;
            const yo = An.aabb.getCorners(), mo = [];
            for (const Fo of yo) {
              ne.ab.vec3.sub(mo, Fo, Ei), Gr || (ar ? mo[2] *= fi : mo[2] = xn);
              const zo = ne.ab.vec3.dot(mo, this._camera.forward());
              zo < Wn && (Wn = zo, _o = Math.abs(mo[2]));
            }
            let Eo = (1 << Ln - An.zoom) * Ni * ro;
            if (Eo *= io(Math.max(_o, xn), Wn), Wn < Eo)
              return !0;
            const Ko = An.aabb.closestPoint(Or);
            return Ko[0] === Or[0] && Ko[1] === Or[1];
          };
          if (this.renderWorldCopies)
            for (let An = 1; An <= 3; An++)
              dn.push(nn(-An)), dn.push(nn(An));
          for (dn.push(nn(0)); dn.length > 0; ) {
            const An = dn.pop(), eo = An.x, On = An.y;
            let ao = An.fullyVisible;
            const ro = () => this.projection.name === "globe" && (An.y === 0 || An.y === (1 << An.zoom) - 1);
            if (!ao) {
              let Wn = Ii ? An.aabb.intersects(Jr) : An.aabb.intersectsFlat(Jr);
              if (Wn === 0 && ro()) {
                const _o = new ne.bT(An.zoom, eo, On);
                Wn = ne.bU(this, Dr, _o, !0).intersects(Jr);
              }
              if (Wn === 0)
                continue;
              ao = Wn === 2;
            }
            if (An.zoom !== Ln && uo(An))
              for (let Wn = 0; Wn < 4; Wn++) {
                const _o = (eo << 1) + Wn % 2, yo = (On << 1) + (Wn >> 1), mo = { aabb: yr ? An.aabb.quadrant(Wn) : ne.bV(this, Dr, An.zoom + 1, _o, yo, An.wrap, An.minZ, An.maxZ, this.projection), zoom: An.zoom + 1, x: _o, y: yo, wrap: An.wrap, fullyVisible: ao, tileID: void 0, shouldSplit: void 0, minZ: An.minZ, maxZ: An.maxZ };
                ar && !Gr && (mo.tileID = new ne.aG(An.zoom + 1 === Ln ? hn : An.zoom + 1, An.wrap, An.zoom + 1, _o, yo), Hn(mo)), dn.push(mo);
              }
            else {
              const Wn = An.zoom === Ln ? hn : An.zoom;
              if (xe.minzoom && xe.minzoom > Wn)
                continue;
              let _o = 0;
              if (!ao) {
                let Ko = Ii ? An.aabb.intersectsPrecise(Jr) : An.aabb.intersectsPreciseFlat(Jr);
                if (Ko === 0 && ro()) {
                  const Fo = new ne.bT(An.zoom, eo, On);
                  Ko = ne.bU(this, Dr, Fo, !0).intersectsPrecise(Jr);
                }
                if (Ko === 0)
                  continue;
                if (xe.calculateQuadrantVisibility)
                  if (Jr.containsPoint(An.aabb.center))
                    _o = 15;
                  else
                    for (let Fo = 0; Fo < 4; Fo++)
                      An.aabb.quadrant(Fo).intersects(Jr) !== 0 && (_o |= 1 << Fo);
              }
              const yo = Or[0] - (0.5 + eo + (An.wrap << An.zoom)) * (1 << ke - An.zoom), mo = Or[1] - 0.5 - On, Eo = An.tileID ? An.tileID : new ne.aG(Wn, An.wrap, An.zoom, eo, On);
              xe.calculateQuadrantVisibility && (Eo.visibleQuadrants = _o), Pn.push({ tileID: Eo, distanceSq: yo * yo + mo * mo });
            }
          }
          if (this.fogCullDistSq) {
            const An = this.fogCullDistSq, eo = this.horizonLineFromTop();
            Pn = Pn.filter((On) => {
              const ao = [0, 0, 0, 1], ro = [ne.ag, ne.ag, 0, 1], Wn = this.calculateFogTileMatrix(On.tileID.toUnwrapped());
              ne.ab.vec4.transformMat4(ao, ao, Wn), ne.ab.vec4.transformMat4(ro, ro, Wn);
              const _o = ne.ab.vec4.min([], ao, ro), yo = ne.ab.vec4.max([], ao, ro), mo = ne.bW(_o, yo);
              if (mo === 0)
                return !0;
              let Eo = !1;
              const Ko = this._elevation;
              if (Ko && mo > An && eo !== 0) {
                const Fo = this.calculateProjMatrix(On.tileID.toUnwrapped());
                let zo;
                xe.isTerrainDEM || (zo = Ko.getMinMaxForTile(On.tileID)), zo || (zo = { min: Wi, max: Ki });
                const Jo = ne.c7(this.rotation), ia = [Jo[0] * ne.ag, Jo[1] * ne.ag, zo.max];
                ne.ab.vec3.transformMat4(ia, ia, Fo), Eo = (1 - ia[1]) * this.height * 0.5 < eo;
              }
              return mo < An || Eo;
            });
          }
          return Pn.sort((An, eo) => An.distanceSq - eo.distanceSq).map((An) => An.tileID);
        }
        resize(xe, ke) {
          this.width = xe, this.height = ke, this.pixelsToGLUnits = [2 / xe, -2 / ke], this._constrain(), this._calcMatrices();
        }
        get unmodified() {
          return this._unmodified;
        }
        zoomScale(xe) {
          return Math.pow(2, xe);
        }
        scaleZoom(xe) {
          return Math.log(xe) / Math.LN2;
        }
        project(xe) {
          const ke = ne.aw(xe.lat, -ne.bX, ne.bX), He = this.projection.project(xe.lng, ke);
          return new ne.P(He.x * this.worldSize, He.y * this.worldSize);
        }
        unproject(xe) {
          return this.projection.unproject(xe.x / this.worldSize, xe.y / this.worldSize);
        }
        get point() {
          return this.project(this.center);
        }
        get pointMerc() {
          return this.point._div(this.worldSize);
        }
        get pixelsPerMeterRatio() {
          return this.pixelsPerMeter / ne.bH(1, this.center.lat) / this.worldSize;
        }
        setLocationAtPoint(xe, ke) {
          let He, ir;
          const ar = this.centerPoint;
          if (this.projection.name === "globe") {
            const Tr = this.worldSize;
            He = (ke.x - ar.x) / Tr, ir = (ke.y - ar.y) / Tr;
          } else {
            const Tr = this.pointCoordinate(ke), $r = this.pointCoordinate(ar);
            He = Tr.x - $r.x, ir = Tr.y - $r.y;
          }
          const yr = this.locationCoordinate(xe);
          this.setLocation(new ne.aa(yr.x - He, yr.y - ir));
        }
        setLocation(xe) {
          this.center = this.coordinateLocation(xe), this.projection.wrap && (this.center = this.center.wrap());
        }
        locationPoint(xe) {
          return this.projection.locationPoint(this, xe);
        }
        locationPoint3D(xe) {
          return this.projection.locationPoint(this, xe, !0);
        }
        pointLocation(xe) {
          return this.coordinateLocation(this.pointCoordinate(xe));
        }
        pointLocation3D(xe) {
          return this.coordinateLocation(this.pointCoordinate3D(xe));
        }
        locationCoordinate(xe, ke) {
          const He = ke ? ne.bH(ke, xe.lat) : void 0, ir = this.projection.project(xe.lng, xe.lat);
          return new ne.aa(ir.x, ir.y, He);
        }
        coordinateLocation(xe) {
          return this.projection.unproject(xe.x, xe.y);
        }
        pointRayIntersection(xe, ke) {
          const He = ke ?? this._centerAltitude, ir = [xe.x, xe.y, 0, 1], ar = [xe.x, xe.y, 1, 1];
          ne.ab.vec4.transformMat4(ir, ir, this.pixelMatrixInverse), ne.ab.vec4.transformMat4(ar, ar, this.pixelMatrixInverse);
          const yr = ar[3];
          ne.ab.vec4.scale(ir, ir, 1 / ir[3]), ne.ab.vec4.scale(ar, ar, 1 / yr);
          const Tr = ir[2], $r = ar[2];
          return { p0: ir, p1: ar, t: Tr === $r ? 0 : (He - Tr) / ($r - Tr) };
        }
        screenPointToMercatorRay(xe) {
          const ke = [xe.x, xe.y, 0, 1], He = [xe.x, xe.y, 1, 1];
          return ne.ab.vec4.transformMat4(ke, ke, this.pixelMatrixInverse), ne.ab.vec4.transformMat4(He, He, this.pixelMatrixInverse), ne.ab.vec4.scale(ke, ke, 1 / ke[3]), ne.ab.vec4.scale(He, He, 1 / He[3]), ke[2] = ne.bH(ke[2], this._center.lat) * this.worldSize, He[2] = ne.bH(He[2], this._center.lat) * this.worldSize, ne.ab.vec4.scale(ke, ke, 1 / this.worldSize), ne.ab.vec4.scale(He, He, 1 / this.worldSize), new ne.aq([ke[0], ke[1], ke[2]], ne.ab.vec3.normalize([], ne.ab.vec3.sub([], He, ke)));
        }
        rayIntersectionCoordinate(xe) {
          const { p0: ke, p1: He, t: ir } = xe, ar = ne.bH(ke[2], this._center.lat), yr = ne.bH(He[2], this._center.lat);
          return new ne.aa(ne.af(ke[0], He[0], ir) / this.worldSize, ne.af(ke[1], He[1], ir) / this.worldSize, ne.af(ar, yr, ir));
        }
        pointCoordinate(xe, ke = this._centerAltitude) {
          return this.projection.pointCoordinate(this, xe.x, xe.y, ke);
        }
        pointCoordinate3D(xe) {
          if (!this.elevation)
            return this.pointCoordinate(xe);
          let ke = this.projection.pointCoordinate3D(this, xe.x, xe.y);
          if (ke)
            return new ne.aa(ke[0], ke[1], ke[2]);
          let He = 0, ir = this.horizonLineFromTop();
          if (xe.y > ir)
            return this.pointCoordinate(xe);
          const ar = 0.02 * ir, yr = xe.clone();
          for (let Tr = 0; Tr < 10 && ir - He > ar; Tr++) {
            yr.y = ne.af(He, ir, 0.66);
            const $r = this.projection.pointCoordinate3D(this, yr.x, yr.y);
            $r ? (ir = yr.y, ke = $r) : He = yr.y;
          }
          return ke ? new ne.aa(ke[0], ke[1], ke[2]) : this.pointCoordinate(xe);
        }
        isPointAboveHorizon(xe) {
          return this.projection.isPointAboveHorizon(this, xe);
        }
        isPointOnSurface(xe) {
          if (xe.y < 0 || xe.y > this.height || xe.x < 0 || xe.x > this.width)
            return !1;
          if (this.elevation || this.zoom >= ne.bY)
            return !this.isPointAboveHorizon(xe);
          const ke = this.pointCoordinate(xe);
          return ke.y >= 0 && ke.y <= 1;
        }
        _coordinatePoint(xe, ke) {
          const He = ke && this.elevation ? this.elevation.getAtPointOrZero(xe, this._centerAltitude) : this._centerAltitude, ir = [xe.x * this.worldSize, xe.y * this.worldSize, He + xe.toAltitude(), 1];
          return ne.ab.vec4.transformMat4(ir, ir, this.pixelMatrix), ir[3] > 0 ? new ne.P(ir[0] / ir[3], ir[1] / ir[3]) : new ne.P(Number.MAX_VALUE, Number.MAX_VALUE);
        }
        _getBoundsNonRectangular() {
          const { top: xe, left: ke } = this._edgeInsets, He = this.height - this._edgeInsets.bottom, ir = this.width - this._edgeInsets.right, ar = this.pointLocation3D(new ne.P(ke, xe)), yr = this.pointLocation3D(new ne.P(ir, xe)), Tr = this.pointLocation3D(new ne.P(ir, He)), $r = this.pointLocation3D(new ne.P(ke, He));
          let Dr = Math.min(ar.lng, yr.lng, Tr.lng, $r.lng), Or = Math.max(ar.lng, yr.lng, Tr.lng, $r.lng), Gr = Math.min(ar.lat, yr.lat, Tr.lat, $r.lat), qr = Math.max(ar.lat, yr.lat, Tr.lat, $r.lat);
          const Jr = Math.pow(2, -this.zoom) / 16 * 270, bi = this.projection.name === "globe" ? 1 : 4, fi = (Mi, Ei, Ii, Ni, zi) => {
            const Ki = (Mi + Ii) / 2, Wi = (Ei + Ni) / 2, Xi = new ne.P(Ki, Wi), { lng: Gi, lat: nn } = this.pointLocation3D(Xi), dn = Math.max(0, Dr - Gi, Gr - nn, Gi - Or, nn - qr);
            Dr = Math.min(Dr, Gi), Or = Math.max(Or, Gi), Gr = Math.min(Gr, nn), qr = Math.max(qr, nn), (zi < bi || dn > Jr) && (fi(Mi, Ei, Ki, Wi, zi + 1), fi(Ki, Wi, Ii, Ni, zi + 1));
          };
          if (fi(ke, xe, ir, xe, 1), fi(ir, xe, ir, He, 1), fi(ir, He, ke, He, 1), fi(ke, He, ke, xe, 1), this.projection.name === "globe") {
            const [Mi, Ei] = ne.bZ(this);
            Mi ? (qr = 90, Or = 180, Dr = -180) : Ei && (Gr = -90, Or = 180, Dr = -180);
          }
          return new ne.az(new ne.bO(Dr, Gr), new ne.bO(Or, qr));
        }
        _getBoundsRectangular(xe, ke) {
          const { top: He, left: ir } = this._edgeInsets, ar = this.height - this._edgeInsets.bottom, yr = this.width - this._edgeInsets.right, Tr = new ne.P(ir, He), $r = new ne.P(yr, He), Dr = new ne.P(yr, ar), Or = new ne.P(ir, ar);
          let Gr = this.pointCoordinate(Tr, xe), qr = this.pointCoordinate($r, xe);
          const Jr = this.pointCoordinate(Dr, ke), bi = this.pointCoordinate(Or, ke), fi = (Mi, Ei) => (Ei.y - Mi.y) / (Ei.x - Mi.x);
          return Gr.y > 1 && qr.y >= 0 ? Gr = new ne.aa((1 - bi.y) / fi(bi, Gr) + bi.x, 1) : Gr.y < 0 && qr.y <= 1 && (Gr = new ne.aa(-bi.y / fi(bi, Gr) + bi.x, 0)), qr.y > 1 && Gr.y >= 0 ? qr = new ne.aa((1 - Jr.y) / fi(Jr, qr) + Jr.x, 1) : qr.y < 0 && Gr.y <= 1 && (qr = new ne.aa(-Jr.y / fi(Jr, qr) + Jr.x, 0)), new ne.az().extend(this.coordinateLocation(Gr)).extend(this.coordinateLocation(qr)).extend(this.coordinateLocation(bi)).extend(this.coordinateLocation(Jr));
        }
        _getBoundsRectangularTerrain() {
          const xe = this.elevation;
          if (!xe.visibleDemTiles.length || xe.isUsingMockSource())
            return this._getBoundsRectangular(0, 0);
          const ke = xe.visibleDemTiles.reduce((He, ir) => {
            if (ir.dem) {
              const ar = ir.dem.tree;
              He.min = Math.min(He.min, ar.minimums[0]), He.max = Math.max(He.max, ar.maximums[0]);
            }
            return He;
          }, { min: Number.MAX_VALUE, max: 0 });
          return this._getBoundsRectangular(ke.min * xe.exaggeration(), ke.max * xe.exaggeration());
        }
        getBounds() {
          return this.projection.name === "mercator" || this.projection.name === "equirectangular" ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
        }
        horizonLineFromTop(xe = !0) {
          const ke = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, 0.1)) - this.centerOffset.y, He = this.height / 2 - ke * (1 - this._horizonShift);
          return xe ? Math.max(0, He) : He;
        }
        getMaxBounds() {
          return this.maxBounds;
        }
        setMaxBounds(xe) {
          this.maxBounds = xe, this.minLat = -ne.bX, this.maxLat = ne.bX, this.minLng = -180, this.maxLng = 180, xe && (this.minLat = xe.getSouth(), this.maxLat = xe.getNorth(), this.minLng = xe.getWest(), this.maxLng = xe.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = ne.at(this.minLng) * this.tileSize, this.worldMaxX = ne.at(this.maxLng) * this.tileSize, this.worldMinY = ne.aA(this.maxLat) * this.tileSize, this.worldMaxY = ne.aA(this.minLat) * this.tileSize, this._constrain();
        }
        calculatePosMatrix(xe, ke) {
          return this.projection.createTileMatrix(this, ke, xe);
        }
        calculateDistanceTileData(xe) {
          const ke = xe.key, He = this._distanceTileDataCache;
          if (He[ke])
            return He[ke];
          const ir = xe.canonical, ar = 1 / this.height, yr = this.cameraWorldSize, Tr = yr / this.zoomScale(ir.z), $r = (ir.x + Math.pow(2, ir.z) * xe.wrap) * Tr, Dr = ir.y * Tr, Or = this.point;
          Or.x *= yr / this.worldSize, Or.y *= yr / this.worldSize;
          const Gr = this.angle, qr = Math.sin(-Gr), Jr = -Math.cos(-Gr);
          return He[ke] = { bearing: [qr, Jr], center: [(Or.x - $r) * ar, (Or.y - Dr) * ar], scale: Tr / ne.ag * ar }, He[ke];
        }
        calculateFogTileMatrix(xe) {
          const ke = xe.key, He = this._fogTileMatrixCache;
          if (He[ke])
            return He[ke];
          const ir = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, xe);
          return ne.ab.mat4.multiply(ir, this.worldToFogMatrix, ir), He[ke] = new Float32Array(ir), He[ke];
        }
        calculateProjMatrix(xe, ke = !1, He = !1) {
          const ir = xe.key;
          let ar;
          if (ar = He ? this._expandedProjMatrixCache : ke ? this._alignedProjMatrixCache : this._projMatrixCache, ar[ir])
            return ar[ir];
          const yr = this.calculatePosMatrix(xe, this.worldSize);
          let Tr;
          return Tr = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : He ? this.expandedFarZProjMatrix : ke ? this.alignedProjMatrix : this.projMatrix, ne.ab.mat4.multiply(yr, Tr, yr), ar[ir] = new Float32Array(yr), ar[ir];
        }
        calculatePixelsToTileUnitsMatrix(xe) {
          const ke = xe.tileID.key, He = this._pixelsToTileUnitsCache;
          if (He[ke])
            return He[ke];
          const ir = ne.b_(xe, this);
          return He[ke] = ir, He[ke];
        }
        customLayerMatrix() {
          return this.mercatorMatrix.slice();
        }
        globeToMercatorMatrix() {
          if (this.projection.name === "globe") {
            const xe = 1 / this.worldSize, ke = ne.ab.mat4.fromScaling([], [xe, xe, xe]);
            return ne.ab.mat4.multiply(ke, ke, this.globeMatrix), ke;
          }
        }
        recenterOnTerrain() {
          if (!this._elevation || this.projection.name === "globe")
            return;
          const xe = this._elevation;
          this._updateCameraState();
          const ke = ne.bH(1, this._center.lat) * this.worldSize, He = this._computeCameraPosition(ke), ir = this._camera.forward(), ar = ne.bH(1, this._center.lat);
          He[2] /= ar, ir[2] /= ar, ne.ab.vec3.normalize(ir, ir);
          const yr = xe.raycast(He, ir, xe.exaggeration());
          if (yr) {
            const Tr = ne.ab.vec3.scaleAndAdd([], He, ir, yr), $r = new ne.aa(Tr[0], Tr[1], ne.bH(Tr[2], ne.aS(Tr[1]))), Dr = ($r.z + ne.ab.vec3.length([$r.x - He[0], $r.y - He[1], $r.z - He[2] * ar])) * this._pixelsPerMercatorPixel;
            this._seaLevelZoom = this._zoomFromMercatorZ(Dr), this._centerAltitude = $r.toAltitude(), this._center = this.coordinateLocation($r), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
          }
        }
        _constrainCamera(xe = !1) {
          if (!this._elevation)
            return;
          const ke = this._elevation, He = ne.bH(1, this._center.lat) * this.worldSize, ir = this._computeCameraPosition(He), ar = ke.getAtPointOrZero(new ne.aa(...ir)), yr = this.pixelsPerMeter / this.worldSize * ar, Tr = this._minimumHeightOverTerrain(), $r = ir[2] - yr;
          if ($r <= Tr)
            if ($r < 0 || xe) {
              const Dr = this.locationCoordinate(this._center, this._centerAltitude), Or = [ir[0], ir[1], Dr.z - ir[2]], Gr = ne.ab.vec3.length(Or);
              Or[2] -= (Tr - $r) / this._pixelsPerMercatorPixel;
              const qr = ne.ab.vec3.length(Or);
              if (qr === 0)
                return;
              ne.ab.vec3.scale(Or, Or, Gr / qr * this._pixelsPerMercatorPixel), this._camera.position = [ir[0], ir[1], Dr.z * this._pixelsPerMercatorPixel - Or[2]], this._updateStateFromCamera();
            } else
              this._isCameraConstrained = !0;
        }
        _constrain() {
          if (!this.center || !this.width || !this.height || this._constraining)
            return;
          this._constraining = !0;
          const xe = this.projection.name === "globe" || this.mercatorFromTransition;
          if (this.projection.isReprojectedInTileSpace || xe) {
            const qr = this.center;
            return qr.lat = ne.aw(qr.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !xe) && (qr.lng = ne.aw(qr.lng, this.minLng, this.maxLng)), this.center = qr, void (this._constraining = !1);
          }
          const ke = this._unmodified, { x: He, y: ir } = this.point;
          let ar = 0, yr = He, Tr = ir;
          const $r = this.width / 2, Dr = this.height / 2, Or = this.worldMinY * this.scale, Gr = this.worldMaxY * this.scale;
          if (ir - Dr < Or && (Tr = Or + Dr), ir + Dr > Gr && (Tr = Gr - Dr), Gr - Or < this.height && (ar = Math.max(ar, this.height / (Gr - Or)), Tr = (Gr + Or) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
            const qr = this.worldMinX * this.scale, Jr = this.worldMaxX * this.scale, bi = this.worldSize / 2 - (qr + Jr) / 2;
            yr = (He + bi + this.worldSize) % this.worldSize - bi, yr - $r < qr && (yr = qr + $r), yr + $r > Jr && (yr = Jr - $r), Jr - qr < this.width && (ar = Math.max(ar, this.width / (Jr - qr)), yr = (Jr + qr) / 2);
          }
          yr === He && Tr === ir || (this.center = this.unproject(new ne.P(yr, Tr))), ar && (this.zoom += this.scaleZoom(ar)), this._constrainCamera(), this._unmodified = ke, this._constraining = !1;
        }
        _minZoomForBounds() {
          let xe = Math.max(0, this.scaleZoom(this.height / (this.worldMaxY - this.worldMinY)));
          return this.maxBounds && (xe = Math.max(xe, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), xe;
        }
        _maxCameraBoundsDistance() {
          return this._mercatorZfromZoom(this._minZoomForBounds());
        }
        _calcMatrices() {
          if (!this.height)
            return;
          const xe = this.centerOffset, ke = this.projection.name === "globe", He = this.pixelsPerMeter;
          this.projection.name === "globe" && (this._mercatorScaleRatio = ne.bH(1, this.center.lat) / ne.bH(1, ne.c8));
          const ir = ne.b$(this.projection, this.zoom, this.width, this.height, 1024);
          this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, ir), this.cameraToCenterDistance = 0.5 / Math.tan(0.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
          const ar = this.projection.zAxisUnit === "meters" ? He : 1, yr = this._camera.getWorldToCamera(this.worldSize, ar);
          let Tr;
          const $r = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
          if ($r[8] = 2 * -xe.x / this.width, $r[9] = 2 * xe.y / this.height, this.isOrthographic) {
            let nn = 0.5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(0.5 * this._fov), dn = nn * this.aspect, Pn = -dn, Ln = -nn;
            dn -= xe.x, Pn -= xe.x, nn += xe.y, Ln += xe.y, Tr = this._camera.getCameraToClipOrthographic(Pn, dn, Ln, nn, this._nearZ, this._farZ), ((hn, xn, Hn, io) => {
              for (let uo = 0; uo < 16; uo++)
                hn[uo] = ou(xn[uo], Hn[uo], io);
            })(Tr, Tr, $r, vo(this.pitch >= 15 ? 1 : this.pitch / 15));
          } else
            Tr = $r;
          const Dr = ne.ab.mat4.mul([], $r, yr);
          let Or = ne.ab.mat4.mul([], Tr, yr);
          if (this.projection.isReprojectedInTileSpace) {
            const nn = this.locationCoordinate(this.center), dn = ne.ab.mat4.identity([]);
            ne.ab.mat4.translate(dn, dn, [nn.x * this.worldSize, nn.y * this.worldSize, 0]), ne.ab.mat4.multiply(dn, dn, ne.c0(this)), ne.ab.mat4.translate(dn, dn, [-nn.x * this.worldSize, -nn.y * this.worldSize, 0]), ne.ab.mat4.multiply(Or, Or, dn), ne.ab.mat4.multiply(Dr, Dr, dn), this.inverseAdjustmentMatrix = ne.c1(this);
          } else
            this.inverseAdjustmentMatrix = [1, 0, 0, 1];
          if (this.mercatorMatrix = ne.ab.mat4.scale([], Or, [this.worldSize, this.worldSize, this.worldSize / ar, 1]), this.projMatrix = Or, this.invProjMatrix = ne.ab.mat4.invert(new Float64Array(16), this.projMatrix), ke) {
            const nn = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
            nn[8] = 2 * -xe.x / this.width, nn[9] = 2 * xe.y / this.height, this.expandedFarZProjMatrix = ne.ab.mat4.mul([], nn, yr);
          } else
            this.expandedFarZProjMatrix = this.projMatrix;
          const Gr = ne.ab.mat4.invert([], Tr);
          this.frustumCorners = ne.c2.fromInvProjectionMatrix(Gr, this.horizonLineFromTop(), this.height), this.cameraFrustum = ne.bR.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, 0, !ke);
          const qr = new Float32Array(16);
          ne.ab.mat4.identity(qr), ne.ab.mat4.scale(qr, qr, [1, -1, 1]), ne.ab.mat4.rotateX(qr, qr, this._pitch), ne.ab.mat4.rotateZ(qr, qr, this.angle);
          const Jr = ne.ab.mat4.perspective(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ);
          this.starsProjMatrix = ne.ab.mat4.clone(Jr);
          const bi = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
          Jr[8] = 2 * -xe.x / this.width, Jr[9] = 2 * (xe.y + bi) / this.height, this.skyboxMatrix = ne.ab.mat4.multiply(qr, Jr, qr);
          const fi = this.point, Mi = fi.x, Ei = fi.y, Ii = this.width % 2 / 2, Ni = this.height % 2 / 2, zi = Math.cos(this.angle), Ki = Math.sin(this.angle), Wi = Mi - Math.round(Mi) + zi * Ii + Ki * Ni, Xi = Ei - Math.round(Ei) + zi * Ni + Ki * Ii, Gi = new Float64Array(Or);
          if (ne.ab.mat4.translate(Gi, Gi, [Wi > 0.5 ? Wi - 1 : Wi, Xi > 0.5 ? Xi - 1 : Xi, 0]), this.alignedProjMatrix = Gi, Or = ne.ab.mat4.create(), ne.ab.mat4.scale(Or, Or, [this.width / 2, -this.height / 2, 1]), ne.ab.mat4.translate(Or, Or, [1, -1, 0]), this.labelPlaneMatrix = Or, Or = ne.ab.mat4.create(), ne.ab.mat4.scale(Or, Or, [1, -1, 1]), ne.ab.mat4.translate(Or, Or, [-1, -1, 0]), ne.ab.mat4.scale(Or, Or, [2 / this.width, 2 / this.height, 1]), this.glCoordMatrix = Or, this.pixelMatrix = ne.ab.mat4.multiply(new Float64Array(16), this.labelPlaneMatrix, Dr), this._calcFogMatrices(), this._distanceTileDataCache = {}, Or = ne.ab.mat4.invert(new Float64Array(16), this.pixelMatrix), !Or)
            throw new Error("failed to invert matrix");
          if (this.pixelMatrixInverse = Or, this.projection.name === "globe" || this.mercatorFromTransition) {
            this.globeMatrix = ne.c3(this);
            const nn = [this.globeMatrix[12], this.globeMatrix[13], this.globeMatrix[14]];
            this.globeCenterInViewSpace = ne.ab.vec3.transformMat4(nn, nn, yr), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
          } else
            this.globeMatrix = Or;
          this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {}, this._expandedProjMatrixCache = {};
        }
        _calcFogMatrices() {
          this._fogTileMatrixCache = {};
          const xe = this.cameraWorldSizeForFog, ke = this.cameraPixelsPerMeter, He = this._camera.position, ir = 1 / this.height / this._pixelsPerMercatorPixel, ar = [xe, xe, ke];
          ne.ab.vec3.scale(ar, ar, ir), ne.ab.vec3.scale(He, He, -1), ne.ab.vec3.multiply(He, He, ar);
          const yr = ne.ab.mat4.create();
          ne.ab.mat4.translate(yr, yr, He), ne.ab.mat4.scale(yr, yr, ar), this.mercatorFogMatrix = yr, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(xe, ke, ir);
        }
        _computeCameraPosition(xe) {
          const ke = (xe = xe || this.pixelsPerMeter) / this.pixelsPerMeter, He = this._camera.forward(), ir = this.point, ar = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * ke - xe / this.worldSize * this._centerAltitude;
          return [ir.x / this.worldSize - He[0] * ar, ir.y / this.worldSize - He[1] * ar, xe / this.worldSize * this._centerAltitude - He[2] * ar];
        }
        _updateCameraState() {
          this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
        }
        _translateCameraConstrained(xe) {
          const ke = this._maxCameraBoundsDistance() * Math.cos(this._pitch), He = this._camera.position[2], ir = xe[2];
          let ar = 1;
          this.projection.wrap && (this.center = this.center.wrap()), ir > 0 && (ar = Math.min((ke - He) / ir, 1)), this._camera.position = ne.ab.vec3.scaleAndAdd([], this._camera.position, xe, ar), this._updateStateFromCamera();
        }
        _updateStateFromCamera() {
          const xe = this._camera.position, ke = this._camera.forward(), { pitch: He, bearing: ir } = this._camera.getPitchBearing(), ar = ne.bH(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, yr = this._mercatorZfromZoom(this._maxZoom) * Math.cos(ne.ai(this._maxPitch)), Tr = Math.max((xe[2] - ar) / Math.cos(He), yr), $r = this._zoomFromMercatorZ(Tr);
          ne.ab.vec3.scaleAndAdd(xe, xe, ke, Tr), this._pitch = ne.aw(He, ne.ai(this.minPitch), ne.ai(this.maxPitch)), this.angle = ne.bF(ir, -Math.PI, Math.PI), this._setZoom(ne.aw($r, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new ne.aa(xe[0], xe[1], xe[2])), this._unmodified = !1, this._constrain(), this._calcMatrices();
        }
        _worldSizeFromZoom(xe) {
          return Math.pow(2, xe) * this.tileSize;
        }
        _mercatorZfromZoom(xe) {
          return this.cameraToCenterDistance / this._worldSizeFromZoom(xe);
        }
        _minimumHeightOverTerrain() {
          const xe = Math.min(this._seaLevelZoom != null ? this._seaLevelZoom : this._zoom, this._maxZoom) + 4;
          return this._mercatorZfromZoom(xe);
        }
        _zoomFromMercatorZ(xe) {
          return this.scaleZoom(this.cameraToCenterDistance / (xe * this.tileSize));
        }
        zoomFromMercatorZAdjusted(xe) {
          let ke = 0, He = ne.bY, ir = 0, ar = 1 / 0;
          for (; He - ke > 1e-6 && He > ke; ) {
            const yr = ke + 0.5 * (He - ke), Tr = this.tileSize * Math.pow(2, yr), $r = this.getCameraToCenterDistance(this.projection, yr, Tr), Dr = this.scaleZoom($r / (xe * this.tileSize)), Or = Math.abs(yr - Dr);
            Or < ar && (ar = Or, ir = yr), yr < Dr ? ke = yr : He = yr;
          }
          return ir;
        }
        _terrainEnabled() {
          return !(!this._elevation || !this.projection.supportsTerrain && (ne.w("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
        }
        anyCornerOffEdge(xe, ke) {
          const He = Math.min(xe.x, ke.x), ir = Math.max(xe.x, ke.x), ar = Math.min(xe.y, ke.y), yr = Math.max(xe.y, ke.y);
          if (ar < this.horizonLineFromTop(!1))
            return !0;
          if (this.projection.name !== "mercator")
            return !1;
          const Tr = [new ne.P(He, ar), new ne.P(ir, yr), new ne.P(He, yr), new ne.P(ir, ar)], $r = this.renderWorldCopies ? -3 : 0, Dr = this.renderWorldCopies ? 4 : 1;
          for (const Or of Tr) {
            const Gr = this.pointRayIntersection(Or);
            if (Gr.t < 0)
              return !0;
            const qr = this.rayIntersectionCoordinate(Gr);
            if (qr.x < $r || qr.y < 0 || qr.x > Dr || qr.y > 1)
              return !0;
          }
          return !1;
        }
        isHorizonVisible() {
          return this.pitch + ne.c4(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new ne.P(0, 0), new ne.P(this.width, this.height));
        }
        zoomDeltaToMovement(xe, ke) {
          const He = ne.ab.vec3.length(ne.ab.vec3.sub([], this._camera.position, xe)), ir = this._zoomFromMercatorZ(He) + ke;
          return He - this._mercatorZfromZoom(ir);
        }
        getCameraPoint() {
          if (this.projection.name === "globe") {
            const xe = function([ke, He, ir], ar) {
              const yr = [ke, He, ir, 1];
              ne.ab.vec4.transformMat4(yr, yr, ar);
              const Tr = yr[3] = Math.max(yr[3], 1e-6);
              return yr[0] /= Tr, yr[1] /= Tr, yr[2] /= Tr, yr;
            }([this.globeMatrix[12], this.globeMatrix[13], this.globeMatrix[14]], this.pixelMatrix);
            return new ne.P(xe[0], xe[1]);
          }
          {
            const xe = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
            return this.centerPoint.add(new ne.P(0, xe));
          }
        }
        getCameraToCenterDistance(xe, ke = this.zoom, He = this.worldSize) {
          const ir = ne.b$(xe, ke, this.width, this.height, 1024), ar = xe.pixelSpaceConversion(this.center.lat, He, ir);
          let yr = 0.5 / Math.tan(0.5 * this._fov) * this.height * ar;
          return this.isOrthographic && (yr = ou(1, yr, vo(this.pitch >= 15 ? 1 : this.pitch / 15))), yr;
        }
        getWorldToCameraMatrix() {
          const xe = this._camera.getWorldToCamera(this.worldSize, this.projection.zAxisUnit === "meters" ? this.pixelsPerMeter : 1);
          return this.projection.name === "globe" && ne.ab.mat4.multiply(xe, xe, this.globeMatrix), xe;
        }
        getFrustum(xe) {
          return ne.bR.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, xe, this.projection.zAxisUnit === "meters");
        }
      }
      const Tc = (qe, xe) => {
        if (xe > 0 && qe.terrain && ne.w("Cutoff is currently disabled on terrain"), xe <= 0 || qe.terrain)
          return { shouldRenderCutoff: !1, uniformValues: { u_cutoff_params: [0, 0, 0, 1] } };
        const ke = qe.transform, He = Math.max(Math.abs(ke._zoom - (qe.minCutoffZoom - 1)), 1), ir = ke.isLODDisabled(!1) ? ne.ac(60, 45, ke.pitch) : ne.ac(30, 15, ke.pitch), ar = ke._farZ - ke._nearZ, yr = xe * ke.height, Tr = ((1 - ($r = ir)) * ke.cameraToCenterDistance + $r * (ke._farZ + yr)) * He;
        var $r;
        return { shouldRenderCutoff: ir < 1, uniformValues: { u_cutoff_params: [ke._nearZ, ke._farZ, (Tr - ke._nearZ) / ar, (Tr - yr - ke._nearZ) / ar] } };
      }, Js = { cascadeCount: 2, normalOffset: 3, shadowMapResolution: 2048 };
      class au {
        constructor(xe, ke) {
          this.aabb = xe, this.lastCascade = ke;
        }
      }
      class Ku {
        add(xe, ke) {
          const He = this.receivers[xe.key];
          He !== void 0 ? (He.aabb.min[0] = Math.min(He.aabb.min[0], ke.min[0]), He.aabb.min[1] = Math.min(He.aabb.min[1], ke.min[1]), He.aabb.min[2] = Math.min(He.aabb.min[2], ke.min[2]), He.aabb.max[0] = Math.max(He.aabb.max[0], ke.max[0]), He.aabb.max[1] = Math.max(He.aabb.max[1], ke.max[1]), He.aabb.max[2] = Math.max(He.aabb.max[2], ke.max[2])) : this.receivers[xe.key] = new au(ke, null);
        }
        clear() {
          this.receivers = {};
        }
        get(xe) {
          return this.receivers[xe.key];
        }
        computeRequiredCascades(xe, ke, He) {
          const ir = ne.cd.fromPoints(xe.points);
          let ar = 0;
          for (const yr in this.receivers) {
            const Tr = this.receivers[yr];
            if (!Tr || !ir.intersectsAabb(Tr.aabb))
              continue;
            Tr.aabb.min = ir.closestPoint(Tr.aabb.min), Tr.aabb.max = ir.closestPoint(Tr.aabb.max);
            const $r = Tr.aabb.getCorners();
            for (let Dr = 0; Dr < He.length; Dr++) {
              let Or = !0;
              for (const Gr of $r) {
                const qr = [Gr[0] * ke, Gr[1] * ke, Gr[2]];
                if (ne.ab.vec3.transformMat4(qr, qr, He[Dr].matrix), qr[0] < -1 || qr[0] > 1 || qr[1] < -1 || qr[1] > 1) {
                  Or = !1;
                  break;
                }
              }
              if (Tr.lastCascade = Dr, ar = Math.max(ar, Dr), Or)
                break;
            }
          }
          return ar + 1;
        }
      }
      class su {
        constructor(xe) {
          this.painter = xe, this._enabled = !1, this._shadowLayerCount = 0, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new Ku(), this._depthMode = new Oo(xe.context.gl.LEQUAL, Oo.ReadWrite, [0, 1]), this._uniformValues = { u_light_matrix_0: new Float32Array(16), u_light_matrix_1: new Float32Array(16), u_shadow_intensity: 0, u_fade_range: [0, 0], u_shadow_normal_offset: [1, 1, 1], u_shadow_texel_size: 1, u_shadow_map_resolution: 1, u_shadow_direction: [0, 0, 1], u_shadow_bias: [36e-5, 12e-4, 0.012], u_shadowmap_0: 0, u_shadowmap_1: 0 }, this._forceDisable = !1, this.useNormalOffset = !1, xe.tp.registerParameter(this, ["Shadows"], "_forceDisable", { label: "forceDisable" }, () => {
            this.painter.style.map.triggerRepaint();
          }), xe.tp.registerParameter(Js, ["Shadows"], "cascadeCount", { min: 1, max: 2, step: 1 }), xe.tp.registerParameter(Js, ["Shadows"], "normalOffset", { min: 0, max: 10, step: 0.05 }), xe.tp.registerParameter(Js, ["Shadows"], "shadowMapResolution", { min: 32, max: 2048, step: 32 }), xe.tp.registerBinding(this, ["Shadows"], "_numCascadesToRender", { readonly: !0, label: "numCascadesToRender" });
        }
        destroy() {
          for (const xe of this._cascades)
            xe.texture.destroy(), xe.framebuffer.destroy();
          this._cascades = [];
        }
        updateShadowParameters(xe, ke) {
          const He = this.painter;
          if (this._enabled = !1, this._shadowLayerCount = 0, this._receivers.clear(), !ke || !ke.properties)
            return;
          const ir = ke.properties.get("shadow-intensity");
          if (!ke.shadowsEnabled() || ir <= 0 || (this._shadowLayerCount = He.style.order.reduce((bi, fi) => {
            const Mi = He.style._mergedLayers[fi];
            return bi + (Mi.hasShadowPass() && !Mi.isHidden(xe.zoom) ? 1 : 0);
          }, 0), this._enabled = this._shadowLayerCount > 0, !this.enabled))
            return;
          const ar = He.context, yr = Js.shadowMapResolution, Tr = Js.shadowMapResolution;
          if (this._cascades.length === 0 || Js.shadowMapResolution !== this._cascades[0].texture.size[0]) {
            this._cascades = [];
            for (let bi = 0; bi < Js.cascadeCount; ++bi) {
              const fi = He._shadowMapDebug, Mi = ar.gl, Ei = ar.createFramebuffer(yr, Tr, fi, "texture"), Ii = new ne.T(ar, { width: yr, height: Tr, data: null }, Mi.DEPTH_COMPONENT16);
              if (Ei.depthAttachment.set(Ii.texture), fi) {
                const Ni = new ne.T(ar, { width: yr, height: Tr, data: null }, Mi.RGBA8);
                Ei.colorAttachment.set(Ni.texture);
              }
              this._cascades.push({ framebuffer: Ei, texture: Ii, matrix: [], far: 0, boundingSphereRadius: 0, frustum: new ne.bR(), scale: 0 });
            }
          }
          this.shadowDirection = Mu(ke);
          let $r = 0;
          if (xe.elevation) {
            const bi = xe.elevation, fi = [1e4, -1e4];
            bi.visibleDemTiles.filter((Mi) => Mi.dem).forEach((Mi) => {
              const Ei = Mi.dem.tree;
              fi[0] = Math.min(fi[0], Ei.minimums[0]), fi[1] = Math.max(fi[1], Ei.maximums[0]);
            }), fi[0] !== 1e4 && ($r = (fi[1] - fi[0]) * bi.exaggeration());
          }
          const Dr = 1.5 * xe.cameraToCenterDistance, Or = 3 * Dr, Gr = new Float64Array(16);
          for (let bi = 0; bi < this._cascades.length; ++bi) {
            const fi = this._cascades[bi];
            let Mi = xe.height / 50, Ei = 1;
            Js.cascadeCount === 1 ? Ei = Or : bi === 0 ? Ei = Dr : (Mi = Dr, Ei = Or);
            const [Ii, Ni] = wl(xe, this.shadowDirection, Mi, Ei, Js.shadowMapResolution, $r);
            fi.scale = xe.scale, fi.matrix = Ii, fi.boundingSphereRadius = Ni, ne.ab.mat4.invert(Gr, fi.matrix), fi.frustum = ne.bR.fromInvProjectionMatrix(Gr, 1, 0, !0), fi.far = Ei;
          }
          const qr = this._cascades.length - 1;
          this._uniformValues.u_fade_range = [0.75 * this._cascades[qr].far, this._cascades[qr].far], this._uniformValues.u_shadow_intensity = ir, this._uniformValues.u_shadow_direction = [this.shadowDirection[0], this.shadowDirection[1], this.shadowDirection[2]], this._uniformValues.u_shadow_texel_size = 1 / Js.shadowMapResolution, this._uniformValues.u_shadow_map_resolution = Js.shadowMapResolution, this._uniformValues.u_shadowmap_0 = ll.ShadowMap0, this._uniformValues.u_shadowmap_1 = ll.ShadowMap0 + 1, this._groundShadowTiles = He.transform.coveringTiles({ tileSize: 512, renderWorldCopies: !0 });
          const Jr = He.transform.elevation;
          for (const bi of this._groundShadowTiles) {
            let fi = { min: 0, max: 0 };
            if (Jr) {
              const Mi = Jr.getMinMaxForTile(bi);
              Mi && (fi = Mi);
            }
            this.addShadowReceiver(bi.toUnwrapped(), fi.min, fi.max);
          }
        }
        get enabled() {
          return this._enabled && !this._forceDisable;
        }
        set enabled(xe) {
          this._enabled = xe;
        }
        drawShadowPass(xe, ke) {
          if (!this.enabled)
            return;
          const He = this.painter, ir = He.context;
          this._numCascadesToRender = this._receivers.computeRequiredCascades(He.transform.getFrustum(0), He.transform.worldSize, this._cascades), ir.viewport.set([0, 0, Js.shadowMapResolution, Js.shadowMapResolution]);
          for (let ar = 0; ar < this._numCascadesToRender; ++ar) {
            He.currentShadowCascade = ar, ir.bindFramebuffer.set(this._cascades[ar].framebuffer.framebuffer), ir.clear({ color: ne.aj.white, depth: 1 });
            for (const yr of xe.order) {
              const Tr = xe._mergedLayers[yr];
              if (!Tr.hasShadowPass() || Tr.isHidden(He.transform.zoom))
                continue;
              const $r = xe.getLayerSourceCache(Tr), Dr = $r ? ke[$r.id] : void 0;
              (Tr.type === "model" || Dr && Dr.length) && He.renderLayer(He, $r, Tr, Dr);
            }
          }
          He.currentShadowCascade = 0;
        }
        drawGroundShadows() {
          if (!this.enabled)
            return;
          const xe = this.painter, ke = xe.style, He = xe.context, ir = ke.directionalLight, ar = ke.ambientLight;
          if (!ir || !ar)
            return;
          const yr = [], Tr = Tc(xe, xe.longestCutoffRange);
          Tr.shouldRenderCutoff && yr.push("RENDER_CUTOFF"), yr.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), this.useNormalOffset && yr.push("NORMAL_OFFSET");
          const $r = Ac(ke, ir, ar), Dr = new Oo(He.gl.LEQUAL, Oo.ReadOnly, xe.depthRangeFor3D);
          for (const Or of this._groundShadowTiles) {
            const Gr = Or.toUnwrapped(), qr = xe.isTileAffectedByFog(Or), Jr = xe.getOrCreateProgram("groundShadow", { defines: yr, overrideFog: qr });
            this.setupShadows(Gr, Jr), xe.uploadCommonUniforms(He, Jr, Gr, null, Tr);
            const bi = { u_matrix: xe.transform.calculateProjMatrix(Gr), u_ground_shadow_factor: $r };
            Jr.draw(xe, He.gl.TRIANGLES, Dr, ta.disabled, aa.multiply, Uo.disabled, bi, "ground_shadow", xe.tileExtentBuffer, xe.quadTriangleIndexBuffer, xe.tileExtentSegments, {}, xe.transform.zoom, null, null);
          }
        }
        getShadowPassColorMode() {
          return this.painter._shadowMapDebug ? aa.unblended : aa.disabled;
        }
        getShadowPassDepthMode() {
          return this._depthMode;
        }
        getShadowCastingLayerCount() {
          return this._shadowLayerCount;
        }
        calculateShadowPassMatrixFromTile(xe) {
          const ke = this.painter.transform, He = ke.calculatePosMatrix(xe, ke.worldSize);
          return ne.ab.mat4.multiply(He, this._cascades[this.painter.currentShadowCascade].matrix, He), Float32Array.from(He);
        }
        calculateShadowPassMatrixFromMatrix(xe) {
          return ne.ab.mat4.multiply(xe, this._cascades[this.painter.currentShadowCascade].matrix, xe), Float32Array.from(xe);
        }
        setupShadows(xe, ke, He, ir = 0) {
          if (!this.enabled)
            return;
          const ar = this.painter.transform, yr = this.painter.context, Tr = yr.gl, $r = this._uniformValues, Dr = new Float64Array(16), Or = ar.calculatePosMatrix(xe, ar.worldSize);
          for (let Gr = 0; Gr < this._cascades.length; Gr++)
            ne.ab.mat4.multiply(Dr, this._cascades[Gr].matrix, Or), $r[Gr === 0 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(Dr), yr.activeTexture.set(Tr.TEXTURE0 + ll.ShadowMap0 + Gr), this._cascades[Gr].texture.bind(Tr.NEAREST, Tr.CLAMP_TO_EDGE);
          if (this.useNormalOffset = !!He, this.useNormalOffset) {
            const Gr = ne.cc(xe.canonical), qr = 2 / ar.tileSize * ne.ag / Js.shadowMapResolution, Jr = qr * this._cascades[0].boundingSphereRadius, bi = qr * this._cascades[this._cascades.length - 1].boundingSphereRadius, fi = (He === "vector-tile" ? 1 : 3) / Math.pow(2, ir - xe.canonical.z - (1 - ar.zoom + Math.floor(ar.zoom)));
            $r.u_shadow_normal_offset = [Gr, Jr * fi, bi * fi], $r.u_shadow_bias = [6e-5, 12e-4, 0.012];
          } else
            $r.u_shadow_bias = [36e-5, 12e-4, 0.012];
          ke.setShadowUniformValues(yr, $r);
        }
        setupShadowsFromMatrix(xe, ke, He = !1) {
          if (!this.enabled)
            return;
          const ir = this.painter.context, ar = ir.gl, yr = this._uniformValues, Tr = new Float64Array(16);
          for (let $r = 0; $r < Js.cascadeCount; $r++)
            ne.ab.mat4.multiply(Tr, this._cascades[$r].matrix, xe), yr[$r === 0 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(Tr), ir.activeTexture.set(ar.TEXTURE0 + ll.ShadowMap0 + $r), this._cascades[$r].texture.bind(ar.NEAREST, ar.CLAMP_TO_EDGE);
          if (this.useNormalOffset = He, He) {
            const $r = Js.normalOffset;
            yr.u_shadow_normal_offset = [1, $r, $r], yr.u_shadow_bias = [6e-5, 12e-4, 0.012];
          } else
            yr.u_shadow_bias = [36e-5, 12e-4, 0.012];
          ke.setShadowUniformValues(ir, yr);
        }
        getShadowUniformValues() {
          return this._uniformValues;
        }
        getCurrentCascadeFrustum() {
          return this._cascades[this.painter.currentShadowCascade].frustum;
        }
        computeSimplifiedTileShadowVolume(xe, ke, He, ir) {
          if (ir[2] >= 0)
            return {};
          const ar = function($r, Dr, Or) {
            const Gr = Or / (1 << $r.canonical.z);
            return new ne.cd([$r.canonical.x * Gr + $r.wrap * Or, $r.canonical.y * Gr + $r.wrap * Or, 0], [($r.canonical.x + 1) * Gr + $r.wrap * Or, ($r.canonical.y + 1) * Gr + $r.wrap * Or, Dr]);
          }(xe, ke, He).getCorners(), yr = ke / -ir[2];
          ir[0] < 0 ? (ne.ab.vec3.add(ar[0], ar[0], [ir[0] * yr, 0, 0]), ne.ab.vec3.add(ar[3], ar[3], [ir[0] * yr, 0, 0])) : ir[0] > 0 && (ne.ab.vec3.add(ar[1], ar[1], [ir[0] * yr, 0, 0]), ne.ab.vec3.add(ar[2], ar[2], [ir[0] * yr, 0, 0])), ir[1] < 0 ? (ne.ab.vec3.add(ar[0], ar[0], [0, ir[1] * yr, 0]), ne.ab.vec3.add(ar[1], ar[1], [0, ir[1] * yr, 0])) : ir[1] > 0 && (ne.ab.vec3.add(ar[2], ar[2], [0, ir[1] * yr, 0]), ne.ab.vec3.add(ar[3], ar[3], [0, ir[1] * yr, 0]));
          const Tr = {};
          return Tr.vertices = ar, Tr.planes = [zh(ar[1], ar[0], ar[4]), zh(ar[2], ar[1], ar[5]), zh(ar[3], ar[2], ar[6]), zh(ar[0], ar[3], ar[7])], Tr;
        }
        addShadowReceiver(xe, ke, He) {
          this._receivers.add(xe, ne.cd.fromTileIdAndHeight(xe, ke, He));
        }
        getMaxCascadeForTile(xe) {
          const ke = this._receivers.get(xe);
          return ke && ke.lastCascade ? ke.lastCascade : 0;
        }
      }
      function zh(qe, xe, ke) {
        const He = ne.ab.vec3.sub([], ke, xe), ir = ne.ab.vec3.sub([], qe, xe), ar = ne.ab.vec3.cross([], He, ir), yr = ne.ab.vec3.length(ar);
        return yr === 0 ? [0, 0, 1, 0] : (ne.ab.vec3.scale(ar, ar, 1 / yr), [ar[0], ar[1], ar[2], -ne.ab.vec3.dot(ar, xe)]);
      }
      function Mu(qe) {
        const xe = qe.properties.get("direction"), ke = ne.cb(xe.x, xe.y, xe.z);
        ke[2] = ne.aw(ke[2], 0, 75);
        const He = ne.ce([ke[0], ke[1], ke[2]]);
        return ne.ab.vec3.fromValues(He.x, He.y, He.z);
      }
      function Ac(qe, xe, ke) {
        const He = xe.properties.get("color-use-theme") === "none", ir = xe.properties.get("color"), ar = xe.properties.get("intensity"), yr = xe.properties.get("direction"), Tr = [yr.x, yr.y, yr.z], $r = ke.properties.get("color-use-theme") === "none", Dr = ke.properties.get("color"), Or = ke.properties.get("intensity"), Gr = Math.max(ne.ab.vec3.dot([0, 0, 1], Tr), 0), qr = [0, 0, 0];
        ne.ab.vec3.scale(qr, Dr.toRenderColor($r ? null : qe.getLut(xe.scope)).toArray01Linear().slice(0, 3), Or);
        const Jr = [0, 0, 0];
        return ne.ab.vec3.scale(Jr, ir.toRenderColor(He ? null : qe.getLut(ke.scope)).toArray01Linear().slice(0, 3), Gr * ar), ne.cf([qr[0] > 0 ? qr[0] / (qr[0] + Jr[0]) : 0, qr[1] > 0 ? qr[1] / (qr[1] + Jr[1]) : 0, qr[2] > 0 ? qr[2] / (qr[2] + Jr[2]) : 0]);
      }
      function wl(qe, xe, ke, He, ir, ar) {
        const yr = qe.zoom, Tr = qe.scale, $r = qe.worldSize, Dr = 1 / $r, Or = qe.aspect, Gr = Math.sqrt(1 + Or * Or) * Math.tan(0.5 * qe.fovX), qr = Gr * Gr, Jr = He - ke, bi = He + ke;
        let fi, Mi;
        qr > Jr / bi ? (fi = He, Mi = He * Gr) : (fi = 0.5 * bi * (1 + qr), Mi = 0.5 * Math.sqrt(Jr * Jr + 2 * (He * He + ke * ke) * qr + bi * bi * qr * qr));
        const Ei = qe.projection.pixelsPerMeter(qe.center.lat, $r), Ii = qe._camera.getCameraToWorldMercator(), Ni = [0, 0, -fi * Dr];
        ne.ab.vec3.transformMat4(Ni, Ni, Ii);
        let zi = Mi * Dr;
        const Ki = qe._edgeInsets;
        if (!(Ki.left === 0 && Ki.top === 0 && Ki.right === 0 && Ki.bottom === 0 || Ki.left === Ki.right && Ki.top === Ki.bottom)) {
          const ao = qe._camera.getWorldToCamera(qe.worldSize, qe.projection.zAxisUnit === "meters" ? Ei : 1), ro = qe._camera.getCameraToClipPerspective(qe._fov, qe.width / qe.height, ke, He);
          ro[8] = 2 * -qe.centerOffset.x / qe.width, ro[9] = 2 * qe.centerOffset.y / qe.height;
          const Wn = new Float64Array(16);
          ne.ab.mat4.mul(Wn, ro, ao);
          const _o = new Float64Array(16);
          ne.ab.mat4.invert(_o, Wn);
          const yo = ne.bR.fromInvProjectionMatrix(_o, $r, yr, !0);
          for (const mo of yo.points) {
            const Eo = ((Wi = mo)[0] /= Tr, Wi[1] /= Tr, Wi[2] = ne.bH(Wi[2], qe._center.lat), Wi);
            zi = Math.max(zi, ne.ab.vec3.len(ne.ab.vec3.subtract([], Ni, Eo)));
          }
        }
        var Wi;
        zi *= ir / (ir - 1);
        const Xi = Math.acos(xe[2]), Gi = Math.atan2(-xe[0], -xe[1]), nn = new Td();
        nn.position = Ni, nn.setPitchBearing(Xi, Gi);
        const dn = nn.getWorldToCamera($r, Ei), Pn = zi * $r, Ln = Math.min(qe._mercatorZfromZoom(17) * $r * -2, -2 * Pn), hn = nn.getCameraToClipOrthographic(-Pn, Pn, -Pn, Pn, Ln, (Pn + ar * Ei) / xe[2]), xn = new Float64Array(16);
        ne.ab.mat4.multiply(xn, hn, dn);
        const Hn = ne.ab.vec3.fromValues(Math.floor(1e6 * Ni[0]) / 1e6 * $r, Math.floor(1e6 * Ni[1]) / 1e6 * $r, 0), io = 0.5 * ir, uo = [0, 0, 0];
        ne.ab.vec3.transformMat4(uo, Hn, xn), ne.ab.vec3.scale(uo, uo, io);
        const An = [Math.floor(uo[0]), Math.floor(uo[1]), Math.floor(uo[2])], eo = [0, 0, 0];
        ne.ab.vec3.sub(eo, uo, An), ne.ab.vec3.scale(eo, eo, -1 / io);
        const On = new Float64Array(16);
        return ne.ab.mat4.identity(On), ne.ab.mat4.translate(On, On, eo), ne.ab.mat4.multiply(xn, On, xn), [xn, Pn];
      }
      class Rm extends ne.E {
        constructor(xe) {
          super(), this.requestManager = xe, this.models = { "": {} }, this.numModelsLoading = {};
        }
        loadModel(xe, ke) {
          return ne.aM(this.requestManager.transformRequest(ke, ne.R.Model).url).then((He) => {
            if (!He)
              return;
            const ir = ne.aN(He), ar = new ne.aO(xe, void 0, void 0, ir);
            return ar.computeBoundsAndApplyParent(), ar;
          }).catch((He) => {
            if (He && He.status === 404)
              return null;
            this.fire(new ne.y(new Error(`Could not load model ${xe} from ${ke}: ${He.message}`)));
          });
        }
        load(xe, ke) {
          this.models[ke] || (this.models[ke] = {});
          const He = Object.keys(xe);
          this.numModelsLoading[ke] = (this.numModelsLoading[ke] || 0) + He.length;
          const ir = [];
          for (const ar of He)
            ir.push(this.loadModel(ar, xe[ar]));
          Promise.allSettled(ir).then((ar) => {
            for (let yr = 0; yr < ar.length; yr++) {
              const { status: Tr, value: $r } = ar[yr];
              Tr === "fulfilled" && $r && (this.models[ke][He[yr]] = { model: $r, numReferences: 1 });
            }
            this.numModelsLoading[ke] -= He.length, this.fire(new ne.z("data", { dataType: "style" }));
          }).catch((ar) => {
            this.fire(new ne.y(new Error(`Could not load models: ${ar.message}`)));
          });
        }
        isLoaded() {
          for (const xe in this.numModelsLoading)
            if (this.numModelsLoading[xe] > 0)
              return !1;
          return !0;
        }
        hasModel(xe, ke) {
          return !!this.getModel(xe, ke);
        }
        getModel(xe, ke) {
          return this.models[ke] || (this.models[ke] = {}), this.models[ke][xe] ? this.models[ke][xe].model : void 0;
        }
        addModel(xe, ke, He) {
          this.models[He] || (this.models[He] = {}), this.hasModel(xe, He) && this.models[He][xe].numReferences++, this.load({ [xe]: this.requestManager.normalizeModelURL(ke) }, He);
        }
        addModels(xe, ke) {
          this.models[ke] || (this.models[ke] = {});
          const He = {};
          for (const ir in xe)
            this.models[ke][ir] = {}, He[ir] = this.requestManager.normalizeModelURL(xe[ir]);
          this.load(He, ke);
        }
        addModelsFromBucket(xe, ke) {
          this.models[ke] || (this.models[ke] = {});
          const He = {};
          for (const ir of xe)
            this.hasModel(ir, ke) ? this.models[ke][ir].numReferences++ : He[ir] = this.requestManager.normalizeModelURL(ir);
          this.load(He, ke);
        }
        removeModel(xe, ke) {
          if (this.models[ke] && this.models[ke][xe] && (this.models[ke][xe].numReferences--, this.models[ke][xe].numReferences === 0)) {
            const He = this.models[ke][xe].model;
            delete this.models[ke][xe], He.destroy();
          }
        }
        listModels(xe) {
          return this.models[xe] || (this.models[xe] = {}), Object.keys(this.models[xe]);
        }
        upload(xe, ke) {
          this.models[ke] || (this.models[ke] = {});
          for (const He in this.models[ke])
            this.models[ke][He].model && this.models[ke][He].model.upload(xe.context);
        }
      }
      const N0 = new ne.a5({ data: new ne.a6(ne.a3.colorTheme.data) }), Ip = { "mbx-indoor-active-floorplans": { default: ["literal", []] }, "mbx-indoor-underground": { default: ["literal", !1] }, "mbx-indoor-loaded-levels": { default: ["literal", []] }, "mbx-indoor-level-height": { default: ["literal", {}] }, "mbx-indoor-level-base": { default: ["literal", {}] }, "mbx-indoor-level-selected": { default: ["literal", {}] }, "mbx-indoor-level-overlapped": { default: ["literal", {}] } };
      function Pm(qe) {
        return qe = qe || {}, Object.assign(qe, Ip);
      }
      class Dm extends ne.E {
        constructor(xe) {
          super(), this.mergeFloors = !0, this._scope = void 0, this._queryFeatureSetId = void 0, this._buildingEntryFeatureSetId = void 0, this._selectedFloorplan = void 0, this._indoorData = void 0, this._selectedLevel = void 0, this._floorplanStates = {}, ne.aP(["_onLoad", "_onMove", "_checkFloorplanVisible"], this), this._map = xe, this._checkFloorplanVisible(!0), this._map.on("load", this._onLoad), this._map.on("move", this._onMove);
        }
        destroy() {
          this._map.indoor.off("load", this._onLoad), this._map.indoor.off("move", this._onMove), this._map = void 0;
        }
        _onLoad() {
          this._map.style.forEachFragmentStyle((xe) => {
            xe.stylesheet.indoor && (this._queryFeatureSetId ? this.fire(new ne.y(new Error("Multiple indoor map styles detected, simultaneous usage is not allowed currently."))) : (this._queryFeatureSetId = xe.stylesheet.indoor.floorplanFeaturesetId, this._buildingEntryFeatureSetId = xe.stylesheet.indoor.buildingFeaturesetId, this._scope = xe.scope));
          }), this._queryFeatureSetId && this._buildingEntryFeatureSetId && this._map.addInteraction("mbx-indoor-buildingclick", { type: "click", target: { featuresetId: this._buildingEntryFeatureSetId, importId: this._scope }, handler: (xe) => (xe.feature && xe.feature.properties.floorplan && this.selectFloorplan(xe.feature.properties.floorplan), !0) }), this._checkFloorplanVisible(!0);
        }
        _onMove() {
          this._checkFloorplanVisible(!1);
        }
        _checkFloorplanVisible(xe) {
          if (!this._queryFeatureSetId || !this._map.isStyleLoaded() || this._map.transform.zoom < 13)
            return;
          this._indoorData && !function(yr, Tr) {
            const [$r, Dr] = yr, { center: Or, radius: Gr } = Tr, [qr, Jr] = Or, bi = Math.abs($r - qr);
            return Math.sqrt((bi > 180 ? 360 - bi : bi) ** 2 + (Dr - Jr) ** 2) <= Gr;
          }([this._map.getCenter().lng, this._map.getCenter().lat], this._indoorData.circumCircle) && (this._indoorData = void 0, this._selectedFloorplan = void 0, this._map.setConfigProperty(this._scope, "mbx-indoor-underground", !1), this._map.setConfigProperty(this._scope, "mbx-indoor-active-floorplans", ["literal", []]), this.fire(new ne.z("floorplangone")));
          const ke = { target: { featuresetId: this._queryFeatureSetId, importId: this._scope } }, He = new ne.P(this._map.transform.width / 2, this._map.transform.height / 2), ir = [new ne.P(0, 0), new ne.P(this._map.transform.width, this._map.transform.height)], ar = this._map.queryRenderedFeatures(xe ? ir : He, ke);
          ar.length > 0 && (this._selectedFloorplan && ar[0].properties.id === this._selectedFloorplan.properties.id || (this._selectedFloorplan = ar[0], this._floorplanSelected(!1)));
        }
        _floorplanSelected(xe) {
          this._indoorData = JSON.parse(this._selectedFloorplan.properties["indoor-data"]), this._indoorData.id = this._selectedFloorplan.properties.id, this._indoorData.circumCircle = function(ar) {
            const [[yr, Tr], [$r, Dr]] = ar, Or = ($r - yr + 360) % 360, Gr = Or > 180 ? 360 - Or : Or;
            return { center: [(yr + Gr / 2 + 360) % 360, (Tr + Dr) / 2], radius: Math.sqrt(Gr ** 2 + (Dr - Tr) ** 2) / 2 };
          }(this._indoorData.extent), this._floorplanStates[this._indoorData.id] || (this._floorplanStates[this._indoorData.id] = {});
          const ke = this._floorplanStates[this._indoorData.id].selectedBuilding, He = this._floorplanStates[this._indoorData.id].selectedLevel;
          let ir;
          if (this._map.setConfigProperty(this._scope, "mbx-indoor-active-floorplans", this._indoorData.floorplanIDs), this._selectedLevel)
            for (const ar of this._indoorData.levels)
              ar.id === this._selectedLevel.id && (ir = ar.id);
          if (this.fire(new ne.z("floorplanselected", { buildings: this._indoorData.buildings, levels: this._indoorData.levels, selectedLevelId: ir })), ke) {
            const ar = this._indoorData.buildings.find((yr) => yr.id === ke);
            this._buildingSelected(ar, !1);
          } else
            this._indoorData.buildings.length > 0 && this._buildingSelected(this._indoorData.buildings[0], !1);
          if (He) {
            const ar = this._indoorData.levels.find((yr) => yr.id === He);
            this._updateLevels(ar, xe);
          } else
            xe && this._indoorData["default-levels"].length > 0 && this.selectLevel(this._indoorData["default-levels"][0]);
        }
        _buildingSelected(xe, ke) {
          ke && xe && xe.extent && this._map.fitBounds(xe.extent, { pitch: this._map.getPitch(), bearing: this._map.getBearing() }), this._floorplanStates[this._indoorData.id].selectedBuilding = xe ? xe.id : void 0;
          const He = this._indoorData.levels.filter((ir) => xe.levels.includes(ir.id));
          this.fire(new ne.z("buildingselected", { buildingId: xe.id, levels: He }));
        }
        _levelSelected(xe) {
          if (xe === "overview")
            this._updateLevels(void 0, !0);
          else {
            const ke = this._indoorData.levels.find((He) => He.id === xe);
            this._updateLevels(ke, !0);
          }
          this.fire(new ne.z("levelselected", { levelId: xe === "overview" ? void 0 : xe }));
        }
        _updateLevels(xe, ke) {
          if (!xe)
            return this._map.setConfigProperty(this._scope, "mbx-indoor-loaded-levels", ["literal", []]), this._map.setConfigProperty(this._scope, "mbx-indoor-underground", !1), this._floorplanStates[this._indoorData.id].selectedLevel = void 0, void (ke && this._indoorData.extent && this._map.fitBounds(this._indoorData.extent, { pitch: this._map.getPitch(), bearing: this._map.getBearing() }));
          function He(Dr) {
            const Or = Dr.indexOf("/floor/");
            if (Or === -1)
              return Dr;
            const Gr = Or + 7, qr = Dr.indexOf("/", Gr);
            return qr === -1 ? Dr.slice(Gr) : Dr.slice(Gr, qr);
          }
          this._selectedLevel = xe, this._floorplanStates[this._indoorData.id].selectedLevel = xe ? xe.id : void 0;
          const ir = [], ar = {}, yr = {}, Tr = {}, $r = {};
          for (const Dr of this._indoorData.levels)
            if (ir.push(Dr.id), ar[Dr.id] = Dr.height, yr[Dr.id] = Dr.base, xe) {
              if (this.mergeFloors) {
                const Or = He(xe.id), Gr = He(Dr.id);
                Tr[Dr.id] = Gr === Or ? "true" : "false";
              } else
                Tr[Dr.id] = Dr.id === xe.id ? "true" : "false";
              $r[Dr.id] = Dr.base < xe.base ? "true" : "false";
            } else
              $r[Dr.id] = !0;
          if (this._map.setConfigProperty(this._scope, "mbx-indoor-loaded-levels", ["literal", ir]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-height", ["literal", ar]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-base", ["literal", yr]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-selected", ["literal", Tr]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-overlapped", ["literal", $r]), xe && (this._map.setConfigProperty(this._scope, "mbx-indoor-underground", !!xe.isUnderground), ke && xe.extent)) {
            const Dr = this._map.cameraForBounds(xe.extent, { pitch: this._map.getPitch(), bearing: this._map.getBearing() }), Or = this._map.getZoom(), Gr = Dr.zoom ? Math.abs(Or - Dr.zoom) : 0;
            this._map.fitBounds(xe.extent, Gr >= 1 ? { pitch: this._map.getPitch(), bearing: this._map.getBearing() } : { pitch: this._map.getPitch(), bearing: this._map.getBearing(), zoom: Or });
          }
        }
        selectFloorplan(xe) {
          const ke = { target: { featuresetId: this._queryFeatureSetId, importId: this._scope } }, He = [new ne.P(0, 0), new ne.P(this._map.transform.width, this._map.transform.height)], ir = this._map.queryRenderedFeatures(He, ke);
          if (ir.length > 0) {
            for (const ar of ir)
              if (JSON.parse(ar.properties["indoor-data"]).floorplanIDs.includes(xe)) {
                this._selectedFloorplan = ar, this._floorplanSelected(!0);
                break;
              }
          }
        }
        selectBuilding(xe) {
          const ke = this._indoorData.buildings.find((He) => He.id === xe);
          this._buildingSelected(ke, !0);
        }
        selectLevel(xe) {
          this._levelSelected(xe);
        }
      }
      function Om(qe) {
        if (!qe.metadata || !qe.metadata.content_area)
          return;
        const { left: xe, top: ke, width: He, height: ir } = qe.metadata.content_area;
        return [xe, ke, xe + He, ke + ir];
      }
      const Nl = (qe, xe) => Vi(qe, xe && xe.filter((ke) => ke.identifier !== "source.canvas")), jn = ne.ay(xa, ["addLayer", "removeLayer", "setLights", "setPaintProperty", "setLayoutProperty", "setSlot", "setFilter", "addSource", "removeSource", "setLayerZoomRange", "setLight", "setTransition", "setGeoJSONSourceData", "setTerrain", "setFog", "setSnow", "setRain", "setProjection", "setCamera", "addImport", "removeImport", "updateImport"]), go = ne.ay(xa, ["setCenter", "setZoom", "setBearing", "setPitch"]), so = /* @__PURE__ */ new Set(["background", "sky", "slot", "custom"]), Yo = { version: 8, layers: [], sources: {} }, ka = { duration: 300, delay: 0 };
      class za extends ne.E {
        constructor(xe, ke = {}) {
          super(), this.map = xe, this.scope = ke.scope || "", this.globalId = null, this.fragments = [], this.importDepth = ke.importDepth || 0, this.importsCache = ke.importsCache || /* @__PURE__ */ new Map(), this.resolvedImports = ke.resolvedImports || /* @__PURE__ */ new Set(), this.transition = ne.l({}, ka), this._buildingIndex = new O0(this), this.crossTileSymbolIndex = new Lp(), this._mergedOrder = [], this._drapedFirstOrder = [], this._mergedLayers = {}, this._mergedSourceCaches = {}, this._mergedOtherSourceCaches = {}, this._mergedSymbolSourceCaches = {}, this._clipLayerPresent = !1, this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this._changes = ke.styleChanges || new Oi(), this.dispatcher = ke.dispatcher ? ke.dispatcher : new ne.D(ne.ci(), this), ke.imageManager ? this.imageManager = ke.imageManager : (this.imageManager = new yn(this.map._spriteFormat), this.imageManager.setEventedParent(this)), this.imageManager.createScope(this.scope), this.glyphManager = ke.glyphManager ? ke.glyphManager : new ne.cj(xe._requestManager, ke.localFontFamily ? ne.ck.all : ke.localIdeographFontFamily ? ne.ck.ideographs : ne.ck.none, ke.localFontFamily || ke.localIdeographFontFamily), ke.modelManager ? this.modelManager = ke.modelManager : (this.modelManager = new Rm(xe._requestManager), this.modelManager.setEventedParent(this)), this._layers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this._loaded = !1, this._precompileDone = !1, this._shouldPrecompile = !1, this._availableImages = [], this._order = [], this._markersNeedUpdate = !1, this.options = ke.configOptions ? ke.configOptions : /* @__PURE__ */ new Map(), this._configDependentLayers = ke.configDependentLayers ? ke.configDependentLayers : /* @__PURE__ */ new Set(), this._config = ke.config, this._styleColorTheme = { lut: null, lutLoading: !1, lutLoadingCorrelationID: 0, colorTheme: null, colorThemeOverride: ke.colorThemeOverride }, this._styleColorThemeForScope = {}, this._initialConfig = ke.initialConfig, this.dispatcher.broadcast("setReferrer", ne.cl());
          const He = this;
          this._rtlTextPluginCallback = za.registerForPluginStateChange((ir) => {
            He.dispatcher.broadcast("syncRTLPluginState", { pluginStatus: ir.pluginStatus, pluginURL: ir.pluginURL }, (ar, yr) => {
              if (ne.cm(ar), yr && yr.every((Tr) => Tr))
                for (const Tr in He._sourceCaches) {
                  const $r = He._sourceCaches[Tr], Dr = $r.getSource().type;
                  Dr !== "vector" && Dr !== "geojson" || $r.reload();
                }
            });
          }), this.on("data", (ir) => {
            if (ir.dataType !== "source" || ir.sourceDataType !== "metadata")
              return;
            const ar = this.getOwnSource(ir.sourceId);
            if (ar && ar.vectorLayerIds)
              for (const yr in this._layers) {
                const Tr = this._layers[yr];
                Tr.source === ar.id && this._validateLayer(Tr);
              }
          });
        }
        load(xe) {
          return xe ? (typeof xe == "string" ? this.loadURL(xe) : this.loadJSON(xe), this) : this;
        }
        _getGlobalId(xe) {
          if (!xe)
            return null;
          if (typeof xe == "string") {
            if (ne.f(xe))
              return xe;
            const ke = ne.cn(xe);
            if (!ke.startsWith("http"))
              try {
                return new URL(ke, location.href).toString();
              } catch {
                return ke;
              }
            return ke;
          }
          return `json://${ne.co(JSON.stringify(xe))}`;
        }
        _diffStyle(xe, ke, He) {
          this.globalId = this._getGlobalId(xe);
          const ir = (ar, yr) => {
            try {
              yr(null, this.setState(ar, He));
            } catch (Tr) {
              yr(Tr, !1);
            }
          };
          if (typeof xe == "string") {
            const ar = this.map._requestManager.normalizeStyleURL(xe), yr = this.map._requestManager.transformRequest(ar, ne.R.Style);
            ne.n(yr, (Tr, $r) => {
              Tr ? this.fire(new ne.y(Tr)) : $r && ir($r, ke);
            });
          } else
            typeof xe == "object" && ir(xe, ke);
        }
        loadURL(xe, ke = {}) {
          this.fire(new ne.z("dataloading", { dataType: "style" }));
          const He = typeof ke.validate == "boolean" ? ke.validate : !ne.f(xe);
          this.globalId = this._getGlobalId(xe), xe = this.map._requestManager.normalizeStyleURL(xe, ke.accessToken), this.resolvedImports.add(xe);
          const ir = this.importsCache.get(xe);
          if (ir)
            return this._load(ir, He);
          const ar = this.map._requestManager.transformRequest(xe, ne.R.Style);
          this._request = ne.n(ar, (yr, Tr) => {
            if (this._request = null, yr)
              this.fire(new ne.y(yr));
            else if (Tr)
              return this.importsCache.set(xe, Tr), this._load(Tr, He);
          });
        }
        loadJSON(xe, ke = {}) {
          this.fire(new ne.z("dataloading", { dataType: "style" })), this.globalId = this._getGlobalId(xe), this._request = ne.q.frame(() => {
            this._request = null, this._load(xe, ke.validate !== !1);
          });
        }
        loadEmpty() {
          this.fire(new ne.z("dataloading", { dataType: "style" })), this._load(Yo, !1);
        }
        _loadImports(xe, ke, He) {
          if (this.importDepth >= 4)
            return ne.w("Style doesn't support nesting deeper than 5"), Promise.resolve();
          const ir = [];
          for (const ar of xe) {
            const yr = this._createFragmentStyle(ar), Tr = new Promise((Or) => {
              yr.once("style.import.load", Or), yr.once("error", Or);
            }).then(() => this.mergeAll());
            if (ir.push(Tr), this.resolvedImports.has(ar.url)) {
              yr.loadEmpty();
              continue;
            }
            const $r = ar.data || this.importsCache.get(ar.url);
            $r ? (yr.loadJSON($r, { validate: ke }), this._isInternalStyle($r) && (yr.globalId = null)) : ar.url ? yr.loadURL(ar.url, { validate: ke }) : yr.loadEmpty();
            const Dr = { style: yr, id: ar.id, config: ar.config };
            if (He) {
              const Or = this.fragments.findIndex(({ id: Gr }) => Gr === He);
              this.fragments = this.fragments.slice(0, Or).concat(Dr).concat(this.fragments.slice(Or));
            } else
              this.fragments.push(Dr);
          }
          return Promise.allSettled(ir);
        }
        getImportGlobalIds(xe = this, ke = /* @__PURE__ */ new Set()) {
          for (const He of xe.fragments)
            He.style.globalId && ke.add(He.style.globalId), this.getImportGlobalIds(He.style, ke);
          return [...ke.values()];
        }
        _createFragmentStyle(xe) {
          const ke = this.scope ? ne.aC(xe.id, this.scope) : xe.id;
          let He;
          const ir = this._initialConfig && this._initialConfig[ke];
          (xe.config || ir) && (He = ne.l({}, xe.config, ir));
          const ar = new za(this.map, { scope: ke, styleChanges: this._changes, importDepth: this.importDepth + 1, importsCache: this.importsCache, resolvedImports: new Set(this.resolvedImports), dispatcher: this.dispatcher, imageManager: this.imageManager, glyphManager: this.glyphManager, modelManager: this.modelManager, config: He, configOptions: this.options, colorThemeOverride: xe["color-theme"], configDependentLayers: this._configDependentLayers });
          return ar.setEventedParent(this.map, { style: ar }), ar;
        }
        _reloadImports() {
          this.mergeAll(), this._updateMapProjection(), this.updateConfigDependencies(), this.map._triggerCameraUpdate(this.camera), this.dispatcher.broadcast("setLayers", { layers: this._serializeLayers(this._order), scope: this.scope, options: this.options }), this._shouldPrecompile = this.map._precompilePrograms && this.isRootStyle();
        }
        _isInternalStyle(xe) {
          return this.isRootStyle() && (xe.fragment || !!xe.schema && xe.fragment !== !1);
        }
        _load(xe, ke) {
          const He = xe.indoor ? Pm(xe.schema) : xe.schema;
          if (this._isInternalStyle(xe)) {
            const yr = ne.l({}, Yo, { imports: [{ id: "basemap", data: xe, url: "" }] });
            return void this._load(yr, ke);
          }
          if (this.updateConfig(this._config, He), ke && Nl(this, Io(xe)))
            return;
          this._loaded = !0, this.stylesheet = ne.cp(xe);
          const ir = () => {
            for (const Dr in xe.sources)
              this.addSource(Dr, xe.sources[Dr], { validate: !1, isInitialLoad: !0 });
            xe.sprite ? this._loadIconset(xe.sprite) : (this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", { scope: this.scope, isLoaded: !0 })), this.glyphManager.setURL(xe.glyphs, this.scope);
            const yr = Sp(this.stylesheet.layers);
            if (this._order = yr.map((Dr) => Dr.id), this.stylesheet.light && ne.w("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), this.stylesheet.lights)
              if (this.stylesheet.lights.length === 1 && this.stylesheet.lights[0].type === "flat") {
                const Dr = this.stylesheet.lights[0];
                this.light = new Hi(Dr.properties, Dr.id);
              } else
                this.setLights(this.stylesheet.lights);
            this.light || (this.light = new Hi(this.stylesheet.light)), this._layers = {};
            for (const Dr of yr) {
              const Or = ne.cu(Dr, this.scope, this._styleColorTheme.lut, this.options);
              Or.configDependencies.size !== 0 && this._configDependentLayers.add(Or.fqid), Or.setEventedParent(this, { layer: { id: Or.id } }), this._layers[Or.id] = Or;
              const Gr = this.getOwnLayerSourceCache(Or), qr = !!this.directionalLight && this.directionalLight.shadowsEnabled();
              Gr && Or.canCastShadows() && qr && (Gr.castsShadows = !0);
            }
            this.stylesheet.featuresets && this.setFeaturesetSelectors(this.stylesheet.featuresets), this.stylesheet.models && this.modelManager.addModels(this.stylesheet.models, this.scope);
            const Tr = this.stylesheet.terrain;
            Tr && (this.checkCanvasFingerprintNoise(), this.disableElevatedTerrain || this.terrainSetForDrapingOnly() || this._createTerrain(Tr, 1)), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this.stylesheet.snow && this._createSnow(this.stylesheet.snow), this.stylesheet.rain && this._createRain(this.stylesheet.rain), this.stylesheet.transition && this.setTransition(this.stylesheet.transition), this.fire(new ne.z("data", { dataType: "style" }));
            const $r = this.isRootStyle();
            xe.imports ? this._loadImports(xe.imports, ke).then(() => {
              this._reloadImports(), this.fire(new ne.z($r ? "style.load" : "style.import.load"));
            }) : (this._reloadImports(), this.fire(new ne.z($r ? "style.load" : "style.import.load")));
          };
          this._styleColorTheme.colorTheme = this.stylesheet["color-theme"];
          const ar = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
          if (ar) {
            const yr = this._evaluateColorThemeData(ar);
            this._loadColorTheme(yr).then(() => {
              ir();
            }).catch((Tr) => {
              ne.w(`Couldn't load color theme from the stylesheet: ${Tr}`), ir();
            });
          } else
            this._styleColorTheme.lut = null, ir();
        }
        isRootStyle() {
          return this.importDepth === 0;
        }
        mergeAll() {
          let xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or;
          const Gr = {};
          this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((qr) => {
            if (qr.stylesheet) {
              if (qr.light != null && (xe = qr.light), qr.stylesheet.lights)
                for (const Jr of qr.stylesheet.lights)
                  Jr.type === "ambient" && qr.ambientLight != null && (ke = qr.ambientLight), Jr.type === "directional" && qr.directionalLight != null && (He = qr.directionalLight);
              ir = this._prioritizeTerrain(ir, qr.terrain, qr.stylesheet.terrain), qr.stylesheet.fog && qr.fog != null && (ar = qr.fog), qr.stylesheet.snow && qr.snow != null && (yr = qr.snow), qr.stylesheet.rain && qr.rain != null && (Tr = qr.rain), qr.stylesheet.camera != null && (Or = qr.stylesheet.camera), qr.stylesheet.projection != null && ($r = qr.stylesheet.projection), qr.stylesheet.transition != null && (Dr = qr.stylesheet.transition), Gr[qr.scope] = qr._styleColorTheme;
            }
          }), this.light = xe, this.ambientLight = ke, this.directionalLight = He, this.fog = ar, this.snow = yr, this.rain = Tr, this._styleColorThemeForScope = Gr, ir === null ? delete this.terrain : this.terrain = ir, this.camera = Or || { "camera-projection": "perspective" }, this.projection = $r || { name: "mercator" }, this.transition = ne.l({}, ka, Dr), this.mergeSources(), this.mergeLayers();
        }
        forEachFragmentStyle(xe) {
          const ke = (He) => {
            for (const ir of He.fragments)
              ke(ir.style);
            xe(He);
          };
          ke(this);
        }
        _prioritizeTerrain(xe, ke, He) {
          const ir = xe && xe.drapeRenderMode === 0;
          return He === null ? ke && ke.drapeRenderMode === 0 ? ke : ir ? xe : null : ke != null && (!xe || ir || ke && ke.drapeRenderMode === 1) ? ke : xe;
        }
        mergeTerrain() {
          let xe;
          this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((ke) => {
            xe = this._prioritizeTerrain(xe, ke.terrain, ke.stylesheet.terrain);
          }), xe === null ? delete this.terrain : this.terrain = xe;
        }
        mergeProjection() {
          let xe;
          this.forEachFragmentStyle((ke) => {
            ke.stylesheet.projection != null && (xe = ke.stylesheet.projection);
          }), this.projection = xe || { name: "mercator" };
        }
        mergeSources() {
          const xe = {}, ke = {}, He = {};
          this.forEachFragmentStyle((ir) => {
            for (const ar in ir._sourceCaches) {
              const yr = ne.aC(ar, ir.scope);
              xe[yr] = ir._sourceCaches[ar];
            }
            for (const ar in ir._otherSourceCaches) {
              const yr = ne.aC(ar, ir.scope);
              ke[yr] = ir._otherSourceCaches[ar];
            }
            for (const ar in ir._symbolSourceCaches) {
              const yr = ne.aC(ar, ir.scope);
              He[yr] = ir._symbolSourceCaches[ar];
            }
          }), this._mergedSourceCaches = xe, this._mergedOtherSourceCaches = ke, this._mergedSymbolSourceCaches = He;
        }
        mergeLayers() {
          const xe = {}, ke = [], He = {};
          this._mergedSlots = [], this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this.forEachFragmentStyle((ar) => {
            for (const yr of ar._order) {
              const Tr = ar._layers[yr];
              if (Tr.type === "slot") {
                const $r = ne.cq(yr);
                if (xe[$r])
                  continue;
                xe[$r] = [];
              }
              Tr.slot && xe[Tr.slot] ? xe[Tr.slot].push(Tr) : ke.push(Tr);
            }
          }), this._mergedOrder = [];
          const ir = (ar = []) => {
            for (const yr of ar)
              if (yr.type === "slot") {
                const Tr = ne.cq(yr.id);
                xe[Tr] && ir(xe[Tr]), this._mergedSlots.push(Tr);
              } else {
                const Tr = ne.aC(yr.id, yr.scope);
                this._mergedOrder.push(Tr), He[Tr] = yr, yr.is3D() && (this._has3DLayers = !0), yr.type === "circle" && (this._hasCircleLayers = !0), yr.type === "symbol" && (this._hasSymbolLayers = !0), yr.type === "clip" && (this._clipLayerPresent = !0);
              }
          };
          ir(ke), this._mergedOrder.sort((ar, yr) => {
            const Tr = He[ar], $r = He[yr];
            return Tr.hasInitialOcclusionOpacityProperties ? $r.is3D() ? 1 : 0 : Tr.is3D() && $r.hasInitialOcclusionOpacityProperties ? -1 : 0;
          }), this._mergedLayers = He, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged();
        }
        terrainSetForDrapingOnly() {
          return !!this.terrain && this.terrain.drapeRenderMode === 0;
        }
        getCamera() {
          return this.stylesheet.camera;
        }
        setCamera(xe) {
          return this.stylesheet.camera = ne.l({}, this.stylesheet.camera, xe), this.camera = this.stylesheet.camera, this;
        }
        _evaluateColorThemeData(xe) {
          return xe.data ? function(ke, He, ir) {
            const ar = ne.l({}, He);
            for (const Tr of Object.keys(ne.a3.colorTheme))
              ar[Tr] === void 0 && (ar[Tr] = ne.a3.colorTheme[Tr].default);
            const yr = new ne.a4(N0, ke, new Map(ir));
            return yr.setTransitionOrValue(ar, ir), yr.untransitioned().possiblyEvaluate(new ne.a8(0));
          }(this.scope, xe, this.options).get("data") : null;
        }
        _loadColorTheme(xe) {
          this._styleColorTheme.lutLoading = !0, this._styleColorTheme.lutLoadingCorrelationID += 1;
          const ke = this._styleColorTheme.lutLoadingCorrelationID;
          return new Promise((He, ir) => {
            const ar = "data:image/png;base64,";
            if (!xe || xe.length === 0)
              return this._styleColorTheme.lut = null, this._styleColorTheme.lutLoading = !1, void He();
            let yr = xe;
            yr.startsWith(ar) || (yr = ar + yr);
            const Tr = "mapbox-reserved-lut", $r = new Image();
            $r.src = yr, $r.onerror = () => {
              this._styleColorTheme.lutLoading = !1, ir(new Error("Failed to load image data"));
            }, $r.onload = () => {
              if (this._styleColorTheme.lutLoadingCorrelationID !== ke)
                return void He();
              this._styleColorTheme.lutLoading = !1;
              const { width: Dr, height: Or, data: Gr } = ne.q.getImageData($r);
              if (Or > 32)
                return void ir(new Error("The height of the image must be less than or equal to 32 pixels."));
              if (Dr !== Or * Or)
                return void ir(new Error("The width of the image must be equal to the height squared."));
              this.getImage(Tr) && this.removeImage(Tr), this.addImage(Tr, { data: new ne.r({ width: Dr, height: Or }, Gr), pixelRatio: 1, sdf: !1, usvg: !1, version: 0 });
              const qr = this.imageManager.getImage(Tr, this.scope);
              qr ? (this._styleColorTheme.lut = { image: qr.data, data: xe }, He()) : ir(new Error("Missing LUT image."));
            };
          });
        }
        getLut(xe) {
          const ke = this._styleColorThemeForScope[xe];
          return ke ? ke.lut : null;
        }
        setProjection(xe) {
          xe ? this.stylesheet.projection = xe : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
        }
        applyProjectionUpdate() {
          this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? (this.getTerrain() || this.stylesheet.terrain) && !this.disableElevatedTerrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null, 0));
        }
        _updateMapProjection() {
          this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
        }
        _loadSprite(xe) {
          this._spriteRequest = function(ke, He, ir) {
            let ar, yr, Tr;
            const $r = ne.q.devicePixelRatio > 1 ? "@2x" : "";
            let Dr = ne.n(He.transformRequest(He.normalizeSpriteURL(ke, $r, ".json"), ne.R.SpriteJSON), (qr, Jr) => {
              Dr = null, Tr || (Tr = qr, ar = Jr, Gr());
            }), Or = ne.o(He.transformRequest(He.normalizeSpriteURL(ke, $r, ".png"), ne.R.SpriteImage), (qr, Jr) => {
              Or = null, Tr || (Tr = qr, yr = Jr, Gr());
            });
            function Gr() {
              if (Tr)
                ir(Tr);
              else if (ar && yr) {
                const qr = ne.q.getImageData(yr), Jr = {};
                for (const bi in ar) {
                  const { width: fi, height: Mi, x: Ei, y: Ii, sdf: Ni, pixelRatio: zi, stretchX: Ki, stretchY: Wi, content: Xi } = ar[bi], Gi = new ne.r({ width: fi, height: Mi });
                  ne.r.copy(qr, Gi, { x: Ei, y: Ii }, { x: 0, y: 0 }, { width: fi, height: Mi }, null), Jr[bi] = { data: Gi, pixelRatio: zi, sdf: Ni, stretchX: Ki, stretchY: Wi, content: Xi, usvg: !1 };
                }
                ir(null, Jr);
              }
            }
            return { cancel() {
              Dr && (Dr.cancel(), Dr = null), Or && (Or.cancel(), Or = null);
            } };
          }(xe, this.map._requestManager, (ke, He) => {
            if (this._spriteRequest = null, ke)
              this.fire(new ne.y(ke));
            else if (He)
              for (const ir in He)
                this.imageManager.addImage(ir, this.scope, He[ir]);
            this.imageManager.setLoaded(!0, this.scope), this._availableImages = this.imageManager.listImages(this.scope), this.dispatcher.broadcast("setImages", { scope: this.scope, images: this._availableImages }), this.dispatcher.broadcast("spriteLoaded", { scope: this.scope, isLoaded: !0 }), this.fire(new ne.z("data", { dataType: "style" }));
          });
        }
        _loadIconset(xe) {
          if (!ne.f(xe) && this.map._spriteFormat !== "icon_set" || this.map._spriteFormat === "raster")
            return void this._loadSprite(xe);
          const ke = this.map._spriteFormat === "auto";
          var He, ir;
          this._spriteRequest = (ir = (ar, yr) => {
            if (this._spriteRequest = null, ar)
              ke ? this._loadSprite(xe) : this.fire(new ne.y(ar));
            else if (yr)
              for (const Tr in yr)
                this.imageManager.addImage(Tr, this.scope, yr[Tr]);
            this.imageManager.setLoaded(!0, this.scope), this._availableImages = this.imageManager.listImages(this.scope), this.dispatcher.broadcast("setImages", { scope: this.scope, images: this._availableImages }), this.dispatcher.broadcast("spriteLoaded", { scope: this.scope, isLoaded: !0 }), this.fire(new ne.z("data", { dataType: "style" }));
          }, ne.bi((He = this.map._requestManager).transformRequest(He.normalizeIconsetURL(xe), ne.R.Iconset), (ar, yr) => {
            if (ar)
              return void ir(ar);
            const Tr = {}, $r = ne.cg(new ne.bh(yr));
            for (const Dr of $r.icons) {
              const Or = { version: 1, pixelRatio: ne.q.devicePixelRatio, content: Om(Dr), stretchX: Dr.metadata ? Dr.metadata.stretch_x_areas : void 0, stretchY: Dr.metadata ? Dr.metadata.stretch_y_areas : void 0, sdf: !1, usvg: !0, icon: Dr };
              Tr[Dr.name] = Or;
            }
            ir(null, Tr);
          }));
        }
        _validateLayer(xe) {
          const ke = this.getOwnSource(xe.source);
          if (!ke)
            return;
          const He = xe.sourceLayer;
          He && (ke.type === "geojson" || ke.vectorLayerIds && ke.vectorLayerIds.indexOf(He) === -1) && this.fire(new ne.y(new Error(`Source layer "${He}" does not exist on source "${ke.id}" as specified by style layer "${xe.id}"`)));
        }
        loaded() {
          if (!this._loaded || Object.keys(this._changes.getUpdatedSourceCaches()).length)
            return !1;
          for (const xe in this._sourceCaches)
            if (!this._sourceCaches[xe].loaded())
              return !1;
          if (!this.imageManager.isLoaded() || !this.modelManager.isLoaded() || this._styleColorTheme.lutLoading)
            return !1;
          for (const { style: xe } of this.fragments)
            if (!xe.loaded())
              return !1;
          return !0;
        }
        _serializeImports() {
          if (this.stylesheet.imports)
            return this.stylesheet.imports.map((xe, ke) => {
              const He = this.fragments[ke];
              return He && He.style && (xe.data = He.style.serialize()), xe;
            });
        }
        _serializeSources() {
          const xe = {};
          for (const ke in this._sourceCaches) {
            const He = this._sourceCaches[ke].getSource();
            xe[He.id] || (xe[He.id] = He.serialize());
          }
          return xe;
        }
        _serializeLayers(xe) {
          const ke = [];
          for (const He of xe) {
            const ir = this._layers[He];
            ir && ir.type !== "custom" && ke.push(ir.serialize());
          }
          return ke;
        }
        hasLightTransitions() {
          return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
        }
        hasFogTransition() {
          return !!this.fog && this.fog.hasTransition();
        }
        hasSnowTransition() {
          return !!this.snow && this.snow.hasTransition();
        }
        hasRainTransition() {
          return !!this.rain && this.rain.hasTransition();
        }
        hasTransitions() {
          if (this.hasLightTransitions() || this.hasFogTransition() || this.hasSnowTransition() || this.hasRainTransition())
            return !0;
          for (const xe in this._sourceCaches)
            if (this._sourceCaches[xe].hasTransition())
              return !0;
          for (const xe in this._layers)
            if (this._layers[xe].hasTransition())
              return !0;
          return !1;
        }
        get order() {
          return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
        }
        _getOrder(xe) {
          return xe ? this.order : this._mergedOrder;
        }
        isLayerDraped(xe) {
          return !!this.terrain && xe.isDraped(this.getLayerSourceCache(xe));
        }
        _checkLoaded() {
          if (!this._loaded)
            throw new Error("Style is not done loading");
        }
        _checkLayer(xe) {
          const ke = this.getOwnLayer(xe);
          if (ke)
            return ke;
          this.fire(new ne.y(new Error(`The layer '${xe}' does not exist in the map's style.`)));
        }
        _checkSource(xe) {
          const ke = this.getOwnSource(xe);
          if (ke)
            return ke;
          this.fire(new ne.y(new Error(`The source '${xe}' does not exist in the map's style.`)));
        }
        precompilePrograms(xe, ke) {
          const He = this.map.painter;
          if (He)
            for (let ir = xe.minzoom || 0; ir < (xe.maxzoom || 25.5); ir++) {
              const ar = xe.getProgramIds();
              if (ar)
                for (const yr of ar) {
                  const Tr = xe.getDefaultProgramParams(yr, ke.zoom, this._styleColorTheme.lut);
                  Tr && (He.style = this, this.fog && (He._fogVisible = !0, Tr.overrideFog = !0, He.getOrCreateProgram(yr, Tr)), He._fogVisible = !1, Tr.overrideFog = !1, He.getOrCreateProgram(yr, Tr), (this.stylesheet.terrain || this.stylesheet.projection && this.stylesheet.projection.name === "globe") && (Tr.overrideRtt = !0, He.getOrCreateProgram(yr, Tr)));
                }
            }
        }
        update(xe) {
          if (!this._loaded)
            return;
          this.ambientLight && this.ambientLight.recalculate(xe), this.directionalLight && this.directionalLight.recalculate(xe);
          const ke = this.calculateLightsBrightness();
          xe.brightness = ke || 0, ke !== this._brightness && (this._brightness = ke, this.dispatcher.broadcast("setBrightness", ke));
          const He = this._changes.isDirty();
          let ir = !1;
          if (this._changes.isDirty()) {
            const yr = this._changes.getLayerUpdatesByScope();
            for (const Tr in yr) {
              const { updatedIds: $r, removedIds: Dr } = yr[Tr];
              ($r || Dr) && (this._updateWorkerLayers(Tr, $r, Dr), ir = !0);
            }
            this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(xe), this.light && this.light.updateTransitions(xe), this.ambientLight && this.ambientLight.updateTransitions(xe), this.directionalLight && this.directionalLight.updateTransitions(xe), this.fog && this.fog.updateTransitions(xe), this.snow && this.snow.updateTransitions(xe), this.rain && this.rain.updateTransitions(xe), this._changes.reset();
          }
          const ar = {};
          for (const yr in this._mergedSourceCaches) {
            const Tr = this._mergedSourceCaches[yr];
            ar[yr] = Tr.used, Tr.used = !1, Tr.tileCoverLift = 0;
          }
          for (const yr of this._mergedOrder) {
            const Tr = this._mergedLayers[yr];
            if (Tr.recalculate(xe, this._availableImages), !Tr.isHidden(xe.zoom)) {
              const $r = this.getLayerSourceCache(Tr);
              $r && ($r.used = !0, $r.tileCoverLift = Math.max($r.tileCoverLift, Tr.tileCoverLift()));
            }
            !this._precompileDone && this._shouldPrecompile && ("requestIdleCallback" in window ? requestIdleCallback(() => {
              this.precompilePrograms(Tr, xe);
            }) : this.precompilePrograms(Tr, xe));
          }
          this._shouldPrecompile && (this._precompileDone = !0), this.terrain && ir && this.mergeLayers();
          for (const yr in ar) {
            const Tr = this._mergedSourceCaches[yr];
            ar[yr] !== Tr.used && Tr.getSource().fire(new ne.z("data", { sourceDataType: "visibility", dataType: "source", sourceId: Tr.getSource().id }));
          }
          this.light && this.light.recalculate(xe), this.terrain && this.terrain.recalculate(xe), this.fog && this.fog.recalculate(xe), this.snow && this.snow.recalculate(xe), this.rain && this.rain.recalculate(xe), this.z = xe.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = !1), He && this.fire(new ne.z("data", { dataType: "style" }));
        }
        _updateTilesForChangedImages() {
          const xe = this._changes.getUpdatedImages();
          if (xe.length) {
            for (const ke in this._sourceCaches)
              this._sourceCaches[ke].reloadTilesForDependencies(["icons", "patterns"], xe);
            this._changes.resetUpdatedImages();
          }
        }
        _updateWorkerLayers(xe, ke, He) {
          const ir = this.getFragmentStyle(xe);
          ir && this.dispatcher.broadcast("updateLayers", { layers: ke ? ir._serializeLayers(ke) : [], scope: xe, removedIds: He || [], options: ir.options });
        }
        setState(xe, ke) {
          if (this._checkLoaded(), Nl(this, Io(xe)))
            return !1;
          (xe = ne.cp(xe)).layers = Sp(xe.layers);
          const He = function(yr, Tr) {
            if (!yr)
              return [{ command: xa.setStyle, args: [Tr] }];
            let $r = [];
            try {
              if (!ne.bn(yr.version, Tr.version))
                return [{ command: xa.setStyle, args: [Tr] }];
              if (ne.bn(yr.center, Tr.center) || $r.push({ command: xa.setCenter, args: [Tr.center] }), ne.bn(yr.zoom, Tr.zoom) || $r.push({ command: xa.setZoom, args: [Tr.zoom] }), ne.bn(yr.bearing, Tr.bearing) || $r.push({ command: xa.setBearing, args: [Tr.bearing] }), ne.bn(yr.pitch, Tr.pitch) || $r.push({ command: xa.setPitch, args: [Tr.pitch] }), ne.bn(yr.sprite, Tr.sprite) || $r.push({ command: xa.setSprite, args: [Tr.sprite] }), ne.bn(yr.glyphs, Tr.glyphs) || $r.push({ command: xa.setGlyphs, args: [Tr.glyphs] }), ne.bn(yr.imports, Tr.imports) || function(Jr = [], bi = [], fi) {
                bi = bi || [];
                const Mi = (Jr = Jr || []).map(Pa), Ei = bi.map(Pa), Ii = Jr.reduce(Ta, {}), Ni = bi.reduce(Ta, {}), zi = Mi.slice();
                let Ki, Wi, Xi, Gi;
                for (Ki = 0, Wi = 0; Ki < Mi.length; Ki++)
                  Xi = Mi[Ki], Ni.hasOwnProperty(Xi) ? Wi++ : (fi.push({ command: xa.removeImport, args: [Xi] }), zi.splice(zi.indexOf(Xi, Wi), 1));
                for (Ki = 0, Wi = 0; Ki < Ei.length; Ki++)
                  Xi = Ei[Ei.length - 1 - Ki], zi[zi.length - 1 - Ki] !== Xi && (Ii.hasOwnProperty(Xi) ? (fi.push({ command: xa.removeImport, args: [Xi] }), zi.splice(zi.lastIndexOf(Xi, zi.length - Wi), 1)) : Wi++, Gi = zi[zi.length - Ki], fi.push({ command: xa.addImport, args: [Ni[Xi], Gi] }), zi.splice(zi.length - Ki, 0, Xi));
                for (const nn of bi) {
                  const dn = Ii[nn.id];
                  dn && !ne.bn(dn, nn) && fi.push({ command: xa.updateImport, args: [nn.id, nn] });
                }
              }(yr.imports, Tr.imports, $r), ne.bn(yr.transition, Tr.transition) || $r.push({ command: xa.setTransition, args: [Tr.transition] }), ne.bn(yr.light, Tr.light) || $r.push({ command: xa.setLight, args: [Tr.light] }), ne.bn(yr.fog, Tr.fog) || $r.push({ command: xa.setFog, args: [Tr.fog] }), ne.bn(yr.snow, Tr.snow) || $r.push({ command: xa.setSnow, args: [Tr.snow] }), ne.bn(yr.rain, Tr.rain) || $r.push({ command: xa.setRain, args: [Tr.rain] }), ne.bn(yr.projection, Tr.projection) || $r.push({ command: xa.setProjection, args: [Tr.projection] }), ne.bn(yr.lights, Tr.lights) || $r.push({ command: xa.setLights, args: [Tr.lights] }), ne.bn(yr.camera, Tr.camera) || $r.push({ command: xa.setCamera, args: [Tr.camera] }), !ne.bn(yr["color-theme"], Tr["color-theme"]))
                return [{ command: xa.setStyle, args: [Tr] }];
              const Dr = {}, Or = [];
              (function(Jr, bi, fi, Mi) {
                let Ei;
                for (Ei in bi = bi || {}, Jr = Jr || {})
                  Jr.hasOwnProperty(Ei) && (bi.hasOwnProperty(Ei) || hc(Ei, fi, Mi));
                for (Ei in bi) {
                  if (!bi.hasOwnProperty(Ei))
                    continue;
                  const Ii = bi[Ei];
                  Jr.hasOwnProperty(Ei) ? ne.bn(Jr[Ei], Ii) || (Jr[Ei].type === "geojson" && Ii.type === "geojson" && Bh(Jr, bi, Ei) ? fi.push({ command: xa.setGeoJSONSourceData, args: [Ei, Ii.data] }) : Ep(Ei, bi, fi, Mi)) : Sf(Ei, bi, fi);
                }
              })(yr.sources, Tr.sources, Or, Dr);
              const Gr = [];
              yr.layers && yr.layers.forEach((Jr) => {
                Jr.source && Dr[Jr.source] ? $r.push({ command: xa.removeLayer, args: [Jr.id] }) : Gr.push(Jr);
              });
              let qr = yr.terrain;
              qr && Dr[qr.source] && ($r.push({ command: xa.setTerrain, args: [void 0] }), qr = void 0), $r = $r.concat(Or), ne.bn(qr, Tr.terrain) || $r.push({ command: xa.setTerrain, args: [Tr.terrain] }), function(Jr, bi, fi) {
                bi = bi || [];
                const Mi = (Jr = Jr || []).map(Pa), Ei = bi.map(Pa), Ii = Jr.reduce(Ta, {}), Ni = bi.reduce(Ta, {}), zi = Mi.slice(), Ki = /* @__PURE__ */ Object.create(null);
                let Wi, Xi, Gi, nn, dn, Pn, Ln;
                for (Wi = 0, Xi = 0; Wi < Mi.length; Wi++)
                  Gi = Mi[Wi], Ni.hasOwnProperty(Gi) ? Xi++ : (fi.push({ command: xa.removeLayer, args: [Gi] }), zi.splice(zi.indexOf(Gi, Xi), 1));
                for (Wi = 0, Xi = 0; Wi < Ei.length; Wi++)
                  Gi = Ei[Ei.length - 1 - Wi], zi[zi.length - 1 - Wi] !== Gi && (Ii.hasOwnProperty(Gi) ? (fi.push({ command: xa.removeLayer, args: [Gi] }), zi.splice(zi.lastIndexOf(Gi, zi.length - Xi), 1)) : Xi++, Pn = zi[zi.length - Wi], fi.push({ command: xa.addLayer, args: [Ni[Gi], Pn] }), zi.splice(zi.length - Wi, 0, Gi), Ki[Gi] = !0);
                for (Wi = 0; Wi < Ei.length; Wi++)
                  if (Gi = Ei[Wi], nn = Ii[Gi], dn = Ni[Gi], !Ki[Gi] && !ne.bn(nn, dn))
                    if (ne.bn(nn.source, dn.source) && ne.bn(nn["source-layer"], dn["source-layer"]) && ne.bn(nn.type, dn.type)) {
                      for (Ln in To(nn.layout, dn.layout, fi, Gi, null, xa.setLayoutProperty), To(nn.paint, dn.paint, fi, Gi, null, xa.setPaintProperty), ne.bn(nn.slot, dn.slot) || fi.push({ command: xa.setSlot, args: [Gi, dn.slot] }), ne.bn(nn.filter, dn.filter) || fi.push({ command: xa.setFilter, args: [Gi, dn.filter] }), ne.bn(nn.minzoom, dn.minzoom) && ne.bn(nn.maxzoom, dn.maxzoom) || fi.push({ command: xa.setLayerZoomRange, args: [Gi, dn.minzoom, dn.maxzoom] }), nn)
                        nn.hasOwnProperty(Ln) && Ln !== "layout" && Ln !== "paint" && Ln !== "filter" && Ln !== "metadata" && Ln !== "minzoom" && Ln !== "maxzoom" && Ln !== "slot" && (Ln.indexOf("paint.") === 0 ? To(nn[Ln], dn[Ln], fi, Gi, Ln.slice(6), xa.setPaintProperty) : ne.bn(nn[Ln], dn[Ln]) || fi.push({ command: xa.setLayerProperty, args: [Gi, Ln, dn[Ln]] }));
                      for (Ln in dn)
                        dn.hasOwnProperty(Ln) && !nn.hasOwnProperty(Ln) && Ln !== "layout" && Ln !== "paint" && Ln !== "filter" && Ln !== "metadata" && Ln !== "minzoom" && Ln !== "maxzoom" && Ln !== "slot" && (Ln.indexOf("paint.") === 0 ? To(nn[Ln], dn[Ln], fi, Gi, Ln.slice(6), xa.setPaintProperty) : ne.bn(nn[Ln], dn[Ln]) || fi.push({ command: xa.setLayerProperty, args: [Gi, Ln, dn[Ln]] }));
                    } else
                      fi.push({ command: xa.removeLayer, args: [Gi] }), Pn = zi[zi.lastIndexOf(Gi) + 1], fi.push({ command: xa.addLayer, args: [dn, Pn] });
              }(Gr, Tr.layers, $r);
            } catch (Dr) {
              console.warn("Unable to compute style diff:", Dr), $r = [{ command: xa.setStyle, args: [Tr] }];
            }
            return $r;
          }(this.serialize(), xe).filter((yr) => !(yr.command in go));
          if (He.length === 0)
            return !1;
          const ir = He.filter((yr) => !(yr.command in jn));
          if (ir.length > 0)
            throw new Error(`Unimplemented: ${ir.map((yr) => yr.command).join(", ")}.`);
          const ar = [];
          return He.forEach((yr) => {
            ar.push(this[yr.command].apply(this, yr.args));
          }), ke && Promise.all(ar).then(ke), this.stylesheet = xe, this.mergeAll(), this.dispatcher.broadcast("setLayers", { layers: this._serializeLayers(this._order), scope: this.scope, options: this.options }), !0;
        }
        addImage(xe, ke) {
          return this.getImage(xe) ? this.fire(new ne.y(new Error("An image with this name already exists."))) : (this.imageManager.addImage(xe, this.scope, ke), this._afterImageUpdated(xe), this);
        }
        updateImage(xe, ke, He = !1) {
          this.imageManager.updateImage(xe, this.scope, ke), He && this._afterImageUpdated(xe);
        }
        getImage(xe) {
          return this.imageManager.getImage(xe, this.scope);
        }
        removeImage(xe) {
          return this.getImage(xe) ? (this.imageManager.removeImage(xe, this.scope), this._afterImageUpdated(xe), this) : this.fire(new ne.y(new Error("No image with this name exists.")));
        }
        _afterImageUpdated(xe) {
          this._availableImages = this.imageManager.listImages(this.scope), this._changes.updateImage(xe), this.dispatcher.broadcast("setImages", { scope: this.scope, images: this._availableImages }), this.fire(new ne.z("data", { dataType: "style" }));
        }
        listImages() {
          return this._checkLoaded(), this._availableImages.slice();
        }
        addModel(xe, ke, He = {}) {
          return this._checkLoaded(), this._validate(an, `models.${xe}`, ke, null, He) || (this.modelManager.addModel(xe, ke, this.scope), this._changes.setDirty()), this;
        }
        hasModel(xe) {
          return this.modelManager.hasModel(xe, this.scope);
        }
        removeModel(xe) {
          return this.hasModel(xe) ? (this.modelManager.removeModel(xe, this.scope), this) : this.fire(new ne.y(new Error("No model with this ID exists.")));
        }
        listModels() {
          return this._checkLoaded(), this.modelManager.listModels(this.scope);
        }
        addSource(xe, ke, He = {}) {
          if (this._checkLoaded(), this.getOwnSource(xe) !== void 0)
            throw new Error(`There is already a source with ID "${xe}".`);
          if (!ke.type)
            throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(ke).join(", ")}.`);
          if (["vector", "raster", "geojson", "video", "image"].indexOf(ke.type) >= 0 && this._validate(to, `sources.${xe}`, ke, null, He))
            return;
          this.map && this.map._collectResourceTiming && (ke.collectResourceTiming = !0);
          const ir = yf(xe, ke, this.dispatcher, this);
          ir.scope = this.scope, ir.setEventedParent(this, () => ({ isSourceLoaded: this._isSourceCacheLoaded(ir.id), source: ir.serialize(), sourceId: ir.id }));
          const ar = (yr) => {
            const Tr = (yr ? "symbol:" : "other:") + ir.id, $r = ne.aC(Tr, this.scope), Dr = this._sourceCaches[Tr] = new Kl($r, ir, yr);
            (yr ? this._symbolSourceCaches : this._otherSourceCaches)[ir.id] = Dr, Dr.onAdd(this.map);
          };
          ar(!1), ke.type !== "vector" && ke.type !== "geojson" || ar(!0), ir.onAdd && ir.onAdd(this.map), He.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
        }
        removeSource(xe) {
          this._checkLoaded();
          const ke = this.getOwnSource(xe);
          if (!ke)
            throw new Error("There is no source with this ID");
          for (const ir in this._layers)
            if (this._layers[ir].source === xe)
              return this.fire(new ne.y(new Error(`Source "${xe}" cannot be removed while layer "${ir}" is using it.`)));
          if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === xe)
            return this.fire(new ne.y(new Error(`Source "${xe}" cannot be removed while terrain is using it.`)));
          const He = this.getOwnSourceCaches(xe);
          for (const ir of He) {
            const ar = ne.cq(ir.id);
            delete this._sourceCaches[ar], this._changes.discardSourceCacheUpdate(ir.id), ir.fire(new ne.z("data", { sourceDataType: "metadata", dataType: "source", sourceId: ir.getSource().id })), ir.setEventedParent(null), ir.clearTiles();
          }
          return delete this._otherSourceCaches[xe], delete this._symbolSourceCaches[xe], this.mergeSources(), ke.setEventedParent(null), ke.onRemove && ke.onRemove(this.map), this._changes.setDirty(), this;
        }
        setGeoJSONSourceData(xe, ke) {
          this._checkLoaded(), this.getOwnSource(xe).setData(ke), this._changes.setDirty();
        }
        getOwnSource(xe) {
          const ke = this.getOwnSourceCache(xe);
          return ke && ke.getSource();
        }
        getOwnSources() {
          const xe = [];
          for (const ke in this._otherSourceCaches) {
            const He = this.getOwnSourceCache(ke);
            He && xe.push(He.getSource());
          }
          return xe;
        }
        areTilesLoaded() {
          const xe = this._mergedSourceCaches;
          for (const ke in xe) {
            const He = xe[ke]._tiles;
            for (const ir in He) {
              const ar = He[ir];
              if (ar.state !== "loaded" && ar.state !== "errored")
                return !1;
            }
          }
          return !0;
        }
        setLights(xe) {
          if (this._checkLoaded(), !xe)
            return delete this.ambientLight, void delete this.directionalLight;
          const ke = this._getTransitionParameters();
          for (const ir of xe) {
            if (this._validate(ma, "lights", ir))
              return;
            switch (ir.type) {
              case "ambient":
                if (this.ambientLight) {
                  const ar = this.ambientLight;
                  ar.set(ir), ar.updateTransitions(ke);
                } else
                  this.ambientLight = new ba(ir, Zo || (Zo = new ne.a5({ color: new ne.a6(ne.a3.properties_light_ambient.color), "color-use-theme": new ne.a6({ type: "string", default: "default", "property-type": "data-constant" }), intensity: new ne.a6(ne.a3.properties_light_ambient.intensity) })), this.scope, this.options);
                break;
              case "directional":
                if (this.directionalLight) {
                  const ar = this.directionalLight;
                  ar.set(ir), ar.updateTransitions(ke);
                } else
                  this.directionalLight = new ba(ir, ea || (ea = new ne.a5({ direction: new ne.ak(ne.a3.properties_light_directional.direction), color: new ne.a6(ne.a3.properties_light_directional.color), "color-use-theme": new ne.a6({ type: "string", default: "default", "property-type": "data-constant" }), intensity: new ne.a6(ne.a3.properties_light_directional.intensity), "cast-shadows": new ne.a6(ne.a3.properties_light_directional["cast-shadows"]), "shadow-quality": new ne.a6(ne.a3.properties_light_directional["shadow-quality"]), "shadow-intensity": new ne.a6(ne.a3.properties_light_directional["shadow-intensity"]) })), this.scope, this.options);
            }
          }
          const He = new ne.a8(this.z || 0, ke);
          this.ambientLight && this.ambientLight.recalculate(He), this.directionalLight && this.directionalLight.recalculate(He), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("setBrightness", this._brightness);
        }
        calculateLightsBrightness() {
          const xe = this.directionalLight, ke = this.ambientLight;
          if (!xe || !ke)
            return;
          const He = (qr) => 0.2126 * (qr[0] <= 0.03928 ? qr[0] / 12.92 : Math.pow((qr[0] + 0.055) / 1.055, 2.4)) + 0.7152 * (qr[1] <= 0.03928 ? qr[1] / 12.92 : Math.pow((qr[1] + 0.055) / 1.055, 2.4)) + 0.0722 * (qr[2] <= 0.03928 ? qr[2] / 12.92 : Math.pow((qr[2] + 0.055) / 1.055, 2.4)), ir = xe.properties.get("color").toRenderColor(null).toArray01(), ar = xe.properties.get("intensity"), yr = xe.properties.get("direction"), Tr = 1 - ne.cb(yr.x, yr.y, yr.z)[2] / 90, $r = He(ir) * ar * Tr, Dr = ke.properties.get("color").toRenderColor(null).toArray01(), Or = ke.properties.get("intensity"), Gr = He(Dr) * Or;
          return Number((($r + Gr) / 2).toFixed(6));
        }
        getBrightness() {
          return this._brightness;
        }
        getLights() {
          if (!this.enable3dLights())
            return null;
          const xe = [];
          return this.directionalLight && xe.push(this.directionalLight.get()), this.ambientLight && xe.push(this.ambientLight.get()), xe;
        }
        enable3dLights() {
          return !!this.ambientLight && !!this.directionalLight;
        }
        getFragmentStyle(xe) {
          if (!xe)
            return this;
          if (ne.cr(xe)) {
            const ke = ne.cs(xe), He = this.fragments.find(({ id: ar }) => ar === ke);
            if (!He)
              throw new Error(`Style import '${xe}' not found`);
            const ir = ne.cq(xe);
            return He.style.getFragmentStyle(ir);
          }
          {
            const ke = this.fragments.find(({ id: He }) => He === xe);
            if (!ke)
              throw new Error(`Style import '${xe}' not found`);
            return ke.style;
          }
        }
        setFeaturesetSelectors(xe) {
          if (!xe)
            return;
          const ke = {}, He = (ir, ar = "") => `${ir}::${ar}`;
          this.featuresetSelectors = {};
          for (const ir in xe) {
            const ar = this.featuresetSelectors[ir] = [];
            for (const yr of xe[ir].selectors) {
              if (yr.featureNamespace) {
                const $r = this.getOwnLayer(yr.layer);
                if (!$r) {
                  ne.w(`Layer is undefined for selector: ${yr.layer}`);
                  continue;
                }
                const Dr = He($r.source, $r.sourceLayer);
                if (Dr in ke && ke[Dr] !== yr.featureNamespace) {
                  ne.w(`"featureNamespace ${yr.featureNamespace} of featureset ${ir}'s selector is not associated to the same source, skip this selector`);
                  continue;
                }
                ke[Dr] = yr.featureNamespace;
              }
              let Tr;
              if (yr.properties)
                for (const $r in yr.properties) {
                  const Dr = ne.U(yr.properties[$r]);
                  Dr.result === "success" && (Tr = Tr || {}, Tr[$r] = Dr.value);
                }
              ar.push({ layerId: yr.layer, namespace: yr.featureNamespace, properties: Tr });
            }
          }
        }
        getFeaturesetDescriptors(xe) {
          const ke = this.getFragmentStyle(xe);
          if (!ke || !ke.stylesheet.featuresets)
            return [];
          const He = [];
          for (const ir in ke.stylesheet.featuresets)
            He.push({ featuresetId: ir, importId: ke.scope ? ke.scope : void 0 });
          return He;
        }
        getFeaturesetLayers(xe, ke) {
          const He = this.getFragmentStyle(ke), ir = He.stylesheet.featuresets;
          if (!ir || !ir[xe])
            return this.fire(new ne.y(new Error(`The featureset '${xe}' does not exist in the map's style and cannot be queried.`))), [];
          const ar = [];
          for (const yr of ir[xe].selectors) {
            const Tr = He.getOwnLayer(yr.layer);
            Tr && ar.push(Tr);
          }
          return ar;
        }
        getConfigProperty(xe, ke) {
          const He = this.getFragmentStyle(xe);
          if (!He)
            return null;
          const ir = ne.aC(ke, He.scope), ar = He.options.get(ir), yr = ar ? ar.value || ar.default : null;
          return yr ? yr.serialize() : null;
        }
        setConfigProperty(xe, ke, He) {
          const ir = this.getFragmentStyle(xe);
          if (!ir)
            return;
          const ar = ir.stylesheet.indoor ? Pm(ir.stylesheet.schema) : ir.stylesheet.schema;
          if (!ar || !ar[ke])
            return;
          const yr = ne.U(He);
          if (yr.result !== "success")
            return void Nl(this, yr.value);
          const Tr = yr.value.expression, $r = ne.aC(ke, ir.scope), Dr = ir.options.get($r);
          if (!Dr)
            return;
          let Or;
          const { minValue: Gr, maxValue: qr, stepValue: Jr, type: bi, values: fi } = ar[ke], Mi = ne.U(ar[ke].default);
          Mi.result === "success" && (Or = Mi.value.expression), Or ? (this.options.set($r, { ...Dr, value: Tr, default: Or, minValue: Gr, maxValue: qr, stepValue: Jr, type: bi, values: fi }), this.updateConfigDependencies(ke)) : this.fire(new ne.y(new Error(`No schema defined for the config option "${ke}" in the "${xe}" fragment.`)));
        }
        getConfig(xe) {
          const ke = this.getFragmentStyle(xe);
          if (!ke)
            return null;
          const He = ke.stylesheet.schema;
          if (!He)
            return null;
          const ir = {};
          for (const ar in He) {
            const yr = ne.aC(ar, ke.scope), Tr = ke.options.get(yr), $r = Tr ? Tr.value || Tr.default : null;
            ir[ar] = $r ? $r.serialize() : null;
          }
          return ir;
        }
        setConfig(xe, ke) {
          const He = this.getFragmentStyle(xe);
          He && (He.updateConfig(ke, He.stylesheet.schema), this.updateConfigDependencies());
        }
        getSchema(xe) {
          const ke = this.getFragmentStyle(xe);
          return ke ? ke.stylesheet.schema : null;
        }
        setSchema(xe, ke) {
          const He = this.getFragmentStyle(xe);
          He && (He.stylesheet.schema = ke, He.updateConfig(He._config, ke), this.updateConfigDependencies());
        }
        updateConfig(xe, ke) {
          if (this._config = xe, xe || ke)
            if (ke)
              for (const He in ke) {
                let ir, ar;
                const yr = ne.U(ke[He].default);
                if (yr.result === "success" && (ir = yr.value.expression), xe && xe[He] !== void 0) {
                  const qr = ne.U(xe[He]);
                  qr.result === "success" && (ar = qr.value.expression);
                }
                const { minValue: Tr, maxValue: $r, stepValue: Dr, type: Or, values: Gr } = ke[He];
                if (ir) {
                  const qr = ne.aC(He, this.scope);
                  this.options.set(qr, { default: ir, value: ar, minValue: Tr, maxValue: $r, stepValue: Dr, type: Or, values: Gr });
                } else
                  this.fire(new ne.y(new Error(`No schema defined for config option "${He}".`)));
              }
            else
              this.fire(new ne.y(new Error("Attempting to set config for a style without schema.")));
        }
        updateConfigDependencies(xe) {
          for (const ke of this._configDependentLayers) {
            const He = this.getLayer(ke);
            if (He) {
              if (xe && !He.configDependencies.has(xe))
                continue;
              He.possiblyEvaluateVisibility(), this._updateLayer(He);
            }
          }
          this.ambientLight && this.ambientLight.updateConfig(this.options), this.directionalLight && this.directionalLight.updateConfig(this.options), this.fog && this.fog.updateConfig(this.options), this.snow && this.snow.updateConfig(this.options), this.rain && this.rain.updateConfig(this.options), this.forEachFragmentStyle((ke) => {
            const He = ke._styleColorTheme.colorThemeOverride ? ke._styleColorTheme.colorThemeOverride : ke._styleColorTheme.colorTheme;
            if (He) {
              const ir = ke._evaluateColorThemeData(He);
              (!ke._styleColorTheme.lut && ir !== "" || ke._styleColorTheme.lut && ir !== ke._styleColorTheme.lut.data) && ke.setColorTheme(He);
            }
          }), this._changes.setDirty();
        }
        addLayer(xe, ke, He = {}) {
          this._checkLoaded();
          const ir = xe.id;
          if (this._layers[ir])
            return void this.fire(new ne.y(new Error(`Layer with id "${ir}" already exists on this map`)));
          let ar;
          if (xe.type === "custom") {
            if (Nl(this, ne.ct(xe)))
              return;
            ar = ne.cu(xe, this.scope, this._styleColorTheme.lut, this.options);
          } else {
            if (typeof xe.source == "object" && (this.addSource(ir, xe.source), xe = ne.cp(xe), xe = ne.l(xe, { source: ir })), this._validate(_i, `layers.${ir}`, xe, { arrayIndex: -1 }, He))
              return;
            ar = ne.cu(xe, this.scope, this._styleColorTheme.lut, this.options), this._validateLayer(ar), ar.setEventedParent(this, { layer: { id: ir } });
          }
          ar.configDependencies.size !== 0 && this._configDependentLayers.add(ar.fqid);
          let yr = this._order.length;
          if (ke) {
            const Or = this._order.indexOf(ke);
            if (Or === -1)
              return void this.fire(new ne.y(new Error(`Layer with id "${ke}" does not exist on this map.`)));
            ar.slot === this._layers[ke].slot ? yr = Or : ne.w(`Layer with id "${ke}" has a different slot. Layers can only be rearranged within the same slot.`);
          }
          this._order.splice(yr, 0, ir), this._layerOrderChanged = !0, this._layers[ir] = ar;
          const Tr = this.getOwnLayerSourceCache(ar), $r = !!this.directionalLight && this.directionalLight.shadowsEnabled();
          Tr && ar.canCastShadows() && $r && (Tr.castsShadows = !0);
          const Dr = this._changes.getRemovedLayer(ar);
          if (Dr && ar.source && Tr && ar.type !== "custom") {
            this._changes.discardLayerRemoval(ar);
            const Or = ne.aC(ar.source, ar.scope);
            Dr.type !== ar.type ? this._changes.updateSourceCache(Or, "clear") : (this._changes.updateSourceCache(Or, "reload"), Tr.pause());
          }
          this._updateLayer(ar), ar.onAdd && ar.onAdd(this.map), ar.scope = this.scope, this.mergeLayers();
        }
        moveLayer(xe, ke) {
          this._checkLoaded();
          const He = this._checkLayer(xe);
          if (!He || xe === ke)
            return;
          const ir = this._order.indexOf(xe);
          this._order.splice(ir, 1);
          let ar = this._order.length;
          if (ke) {
            const yr = this._order.indexOf(ke);
            if (yr === -1)
              return void this.fire(new ne.y(new Error(`Layer with id "${ke}" does not exist on this map.`)));
            He.slot === this._layers[ke].slot ? ar = yr : ne.w(`Layer with id "${ke}" has a different slot. Layers can only be rearranged within the same slot.`);
          }
          this._order.splice(ar, 0, xe), this._changes.setDirty(), this._layerOrderChanged = !0, this.mergeLayers();
        }
        removeLayer(xe) {
          this._checkLoaded();
          const ke = this._checkLayer(xe);
          if (!ke)
            return;
          ke.setEventedParent(null);
          const He = this._order.indexOf(xe);
          this._order.splice(He, 1), delete this._layers[xe], this._changes.setDirty(), this._layerOrderChanged = !0, this._configDependentLayers.delete(ke.fqid), this._changes.removeLayer(ke);
          const ir = this.getOwnLayerSourceCache(ke);
          if (ir && ir.castsShadows) {
            let ar = !1;
            for (const yr in this._layers)
              if (this._layers[yr].source === ke.source && this._layers[yr].canCastShadows()) {
                ar = !0;
                break;
              }
            ir.castsShadows = ar;
          }
          ke.onRemove && ke.onRemove(this.map), this.mergeLayers();
        }
        getOwnLayer(xe) {
          return this._layers[xe];
        }
        hasLayer(xe) {
          return xe in this._mergedLayers;
        }
        hasLayerType(xe) {
          for (const ke in this._layers)
            if (this._layers[ke].type === xe)
              return !0;
          return !1;
        }
        setLayerZoomRange(xe, ke, He) {
          this._checkLoaded();
          const ir = this._checkLayer(xe);
          ir && (ir.minzoom === ke && ir.maxzoom === He || (ke != null && (ir.minzoom = ke), He != null && (ir.maxzoom = He), this._updateLayer(ir)));
        }
        getSlots() {
          return this._checkLoaded(), this._mergedSlots;
        }
        setSlot(xe, ke) {
          this._checkLoaded();
          const He = this._checkLayer(xe);
          He && He.slot !== ke && (He.slot = ke, this._updateLayer(He));
        }
        setFilter(xe, ke, He = {}) {
          this._checkLoaded();
          const ir = this._checkLayer(xe);
          if (ir && !ne.bn(ir.filter, ke))
            return ke == null ? (ir.filter = void 0, void this._updateLayer(ir)) : void (this._validate(Pi, `layers.${ir.id}.filter`, ke, { layerType: ir.type }, He) || (ir.filter = ne.cp(ke), this._updateLayer(ir)));
        }
        getFilter(xe) {
          const ke = this._checkLayer(xe);
          if (ke)
            return ne.cp(ke.filter);
        }
        setLayoutProperty(xe, ke, He, ir = {}) {
          this._checkLoaded();
          const ar = this._checkLayer(xe);
          if (ar && !ne.bn(ar.getLayoutProperty(ke), He)) {
            if (He != null && (!ir || ir.validate !== !1) && Nl(ar, ki.call(Io, { key: `layers.${xe}.layout.${ke}`, layerType: ar.type, objectKey: ke, value: He, styleSpec: ne.a3, style: { glyphs: !0, sprite: !0 } })))
              return;
            ar.setLayoutProperty(ke, He), ar.configDependencies.size !== 0 && this._configDependentLayers.add(ar.fqid), this._updateLayer(ar);
          }
        }
        getLayoutProperty(xe, ke) {
          const He = this._checkLayer(xe);
          if (He)
            return He.getLayoutProperty(ke);
        }
        setPaintProperty(xe, ke, He, ir = {}) {
          this._checkLoaded();
          const ar = this._checkLayer(xe);
          if (!ar || ne.bn(ar.getPaintProperty(ke), He) || He != null && (!ir || ir.validate !== !1) && Nl(ar, Ai.call(Io, { key: `layers.${xe}.paint.${ke}`, layerType: ar.type, objectKey: ke, value: He, styleSpec: ne.a3 })))
            return;
          const yr = ar.setPaintProperty(ke, He);
          ar.configDependencies.size !== 0 && this._configDependentLayers.add(ar.fqid), yr && this._updateLayer(ar), this._changes.updatePaintProperties(ar);
        }
        getPaintProperty(xe, ke) {
          const He = this._checkLayer(xe);
          if (He)
            return He.getPaintProperty(ke);
        }
        setFeatureState(xe, ke) {
          if (this._checkLoaded(), "target" in xe) {
            if ("featuresetId" in xe.target) {
              const { featuresetId: $r, importId: Dr } = xe.target, Or = this.getFragmentStyle(Dr), Gr = Or.getFeaturesetLayers($r);
              for (const { source: qr, sourceLayer: Jr } of Gr)
                Or.setFeatureState({ id: xe.id, source: qr, sourceLayer: Jr }, ke);
            } else if ("layerId" in xe.target) {
              const { layerId: $r } = xe.target, Dr = this.getLayer($r);
              this.setFeatureState({ id: xe.id, source: Dr.source, sourceLayer: Dr.sourceLayer }, ke);
            }
            return;
          }
          const He = xe.source, ir = xe.sourceLayer, ar = this._checkSource(He);
          if (!ar)
            return;
          const yr = ar.type;
          if (yr === "geojson" && ir)
            return void this.fire(new ne.y(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
          if (yr === "vector" && !ir)
            return void this.fire(new ne.y(new Error("The sourceLayer parameter must be provided for vector source types.")));
          xe.id === void 0 && this.fire(new ne.y(new Error("The feature id parameter must be provided.")));
          const Tr = this.getOwnSourceCaches(He);
          for (const $r of Tr)
            $r.setFeatureState(ir, xe.id, ke);
        }
        removeFeatureState(xe, ke) {
          if (this._checkLoaded(), "target" in xe) {
            if ("featuresetId" in xe.target) {
              const { featuresetId: $r, importId: Dr } = xe.target, Or = this.getFragmentStyle(Dr), Gr = Or.getFeaturesetLayers($r);
              for (const { source: qr, sourceLayer: Jr } of Gr)
                Or.removeFeatureState({ id: xe.id, source: qr, sourceLayer: Jr }, ke);
            } else if ("layerId" in xe.target) {
              const { layerId: $r } = xe.target, Dr = this.getLayer($r);
              this.removeFeatureState({ id: xe.id, source: Dr.source, sourceLayer: Dr.sourceLayer }, ke);
            }
            return;
          }
          const He = xe.source, ir = this._checkSource(He);
          if (!ir)
            return;
          const ar = ir.type, yr = ar === "vector" ? xe.sourceLayer : void 0;
          if (ar === "vector" && !yr)
            return void this.fire(new ne.y(new Error("The sourceLayer parameter must be provided for vector source types.")));
          if (ke && typeof xe.id != "string" && typeof xe.id != "number")
            return void this.fire(new ne.y(new Error("A feature id is required to remove its specific state property.")));
          const Tr = this.getOwnSourceCaches(He);
          for (const $r of Tr)
            $r.removeFeatureState(yr, xe.id, ke);
        }
        getFeatureState(xe) {
          if (this._checkLoaded(), "target" in xe) {
            let ar;
            if ("featuresetId" in xe.target) {
              const { featuresetId: yr, importId: Tr } = xe.target, $r = this.getFragmentStyle(Tr), Dr = $r.getFeaturesetLayers(yr);
              for (const { source: Or, sourceLayer: Gr } of Dr) {
                const qr = $r.getFeatureState({ id: xe.id, source: Or, sourceLayer: Gr });
                if (qr && !ar)
                  ar = qr;
                else if (!ne.bn(ar, qr))
                  return void this.fire(new ne.y(new Error("The same feature id exists in multiple sources in the featureset, but their feature states are not consistent through the sources.")));
              }
            } else if ("layerId" in xe.target) {
              const { layerId: yr } = xe.target, Tr = this.getLayer(yr);
              ar = this.getFeatureState({ id: xe.id, source: Tr.source, sourceLayer: Tr.sourceLayer });
            }
            return ar;
          }
          const ke = xe.source, He = xe.sourceLayer, ir = this._checkSource(ke);
          if (ir) {
            if (ir.type !== "vector" || He)
              return xe.id === void 0 && this.fire(new ne.y(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(ke)[0].getFeatureState(He, xe.id);
            this.fire(new ne.y(new Error("The sourceLayer parameter must be provided for vector source types.")));
          }
        }
        setTransition(xe) {
          return this.stylesheet.transition = ne.l({}, this.stylesheet.transition, xe), this.transition = this.stylesheet.transition, this;
        }
        getTransition() {
          return ne.l({}, this.stylesheet.transition);
        }
        serialize() {
          this._checkLoaded();
          const xe = this.getTerrain(), ke = xe && this.terrain && this.terrain.scope === this.scope ? xe : this.stylesheet.terrain;
          return ne.cv({ version: this.stylesheet.version, name: this.stylesheet.name, metadata: this.stylesheet.metadata, fragment: this.stylesheet.fragment, imports: this._serializeImports(), schema: this.stylesheet.schema, camera: this.stylesheet.camera, light: this.stylesheet.light, lights: this.stylesheet.lights, terrain: ke, fog: this.stylesheet.fog, snow: this.stylesheet.snow, rain: this.stylesheet.rain, center: this.stylesheet.center, "color-theme": this.stylesheet["color-theme"], zoom: this.stylesheet.zoom, bearing: this.stylesheet.bearing, pitch: this.stylesheet.pitch, sprite: this.stylesheet.sprite, glyphs: this.stylesheet.glyphs, transition: this.stylesheet.transition, projection: this.stylesheet.projection, sources: this._serializeSources(), layers: this._serializeLayers(this._order) }, (He) => He !== void 0);
        }
        _updateFilteredLayers(xe) {
          for (const ke of Object.values(this._mergedLayers))
            xe(ke) && this._updateLayer(ke);
        }
        _updateLayer(xe) {
          this._changes.updateLayer(xe);
          const ke = this.getLayerSourceCache(xe), He = ne.aC(xe.source, xe.scope), ir = this._changes.getUpdatedSourceCaches();
          xe.source && !ir[He] && ke && ke.getSource().type !== "raster" && (this._changes.updateSourceCache(He, "reload"), ke.pause()), xe.invalidateCompiledFilter();
        }
        _flattenAndSortRenderedFeatures(xe) {
          const ke = (Tr) => this._mergedLayers[Tr].is3D(), He = this.order, ir = {}, ar = [];
          for (let Tr = He.length - 1; Tr >= 0; Tr--) {
            const $r = He[Tr];
            if (ke($r)) {
              ir[$r] = Tr;
              for (const Dr of xe) {
                const Or = Dr[$r];
                if (Or)
                  for (const Gr of Or)
                    ar.push(Gr);
              }
            }
          }
          ar.sort((Tr, $r) => $r.intersectionZ - Tr.intersectionZ);
          const yr = [];
          for (let Tr = He.length - 1; Tr >= 0; Tr--) {
            const $r = He[Tr];
            if (ke($r))
              for (let Dr = ar.length - 1; Dr >= 0; Dr--) {
                const Or = ar[Dr].feature;
                if (Or.layer && ir[Or.layer.id] < Tr)
                  break;
                yr.push(Or), ar.pop();
              }
            else
              for (const Dr of xe) {
                const Or = Dr[$r];
                if (Or)
                  for (const Gr of Or)
                    yr.push(Gr.feature);
              }
          }
          return yr;
        }
        queryRenderedFeatures(xe, ke, He) {
          let ir;
          ke && !Array.isArray(ke) && ke.filter && (this._validate(Pi, "queryRenderedFeatures.filter", ke.filter, null, ke), ir = ne.aZ(ke.filter));
          const ar = {}, yr = (Or) => {
            if (so.has(Or.type))
              return;
            const Gr = this.getOwnLayerSourceCache(Or), qr = ar[Gr.id] = ar[Gr.id] || { sourceCache: Gr, layers: {}, has3DLayers: !1 };
            Or.is3D() && (qr.has3DLayers = !0), qr.layers[Or.fqid] = qr.layers[Or.fqid] || { styleLayer: Or, targets: [] }, qr.layers[Or.fqid].targets.push({ filter: ir });
          };
          if (ke && ke.layers) {
            if (!Array.isArray(ke.layers))
              return this.fire(new ne.y(new Error("parameters.layers must be an Array."))), [];
            for (const Or of ke.layers) {
              const Gr = this._layers[Or];
              if (!Gr)
                return this.fire(new ne.y(new Error(`The layer '${Or}' does not exist in the map's style and cannot be queried for features.`))), [];
              yr(Gr);
            }
          } else
            for (const Or in this._layers)
              yr(this._layers[Or]);
          const Tr = this._queryRenderedFeatures(xe, ar, He), $r = this._flattenAndSortRenderedFeatures(Tr), Dr = [];
          for (const Or of $r)
            ne.cs(Or.layer.id) === this.scope && Dr.push(Or);
          return Dr;
        }
        queryRenderedFeatureset(xe, ke, He) {
          let ir;
          ke && !Array.isArray(ke) && ke.filter && (this._validate(Pi, "queryRenderedFeatures.filter", ke.filter, null, ke), ir = ne.aZ(ke.filter));
          const ar = "mock", yr = [];
          if (ke && ke.target)
            yr.push({ ...ke, targetId: ar, filter: ir });
          else {
            const Dr = this.getFeaturesetDescriptors();
            for (const Or of Dr)
              yr.push({ targetId: ar, filter: ir, target: Or });
            for (const { style: Or } of this.fragments) {
              const Gr = Or.getFeaturesetDescriptors();
              for (const qr of Gr)
                yr.push({ targetId: ar, filter: ir, target: qr });
            }
          }
          const Tr = this.queryRenderedTargets(xe, yr, He), $r = [];
          for (const Dr of Tr)
            for (const Or of Dr.variants[ar])
              $r.push(new ne.cw(Dr, Or));
          return $r;
        }
        queryRenderedTargets(xe, ke, He) {
          const ir = {}, ar = (Tr, $r, Dr, Or) => {
            const Gr = ir[$r.id] = ir[$r.id] || { sourceCache: $r, layers: {}, has3DLayers: !1 };
            Gr.layers[Tr.fqid] = Gr.layers[Tr.fqid] || { styleLayer: Tr, targets: [] }, Tr.is3D() && (Gr.has3DLayers = !0), Gr.layers[Tr.fqid].targets.push(Or ? { ...Dr, namespace: Or.namespace, properties: Or.properties } : Dr);
          };
          for (const Tr of ke)
            if ("featuresetId" in Tr.target) {
              const { featuresetId: $r, importId: Dr } = Tr.target, Or = this.getFragmentStyle(Dr), Gr = Or.featuresetSelectors[$r];
              if (!Gr) {
                this.fire(new ne.y(new Error(`The featureset '${$r}' does not exist in the map's style and cannot be queried for features.`)));
                continue;
              }
              for (const qr of Gr) {
                const Jr = Or.getOwnLayer(qr.layerId);
                Jr && !so.has(Jr.type) && ar(Jr, Or.getOwnLayerSourceCache(Jr), Tr, qr);
              }
            } else if ("layerId" in Tr.target) {
              const { layerId: $r } = Tr.target, Dr = this.getLayer($r);
              if (!Dr || so.has(Dr.type))
                continue;
              ar(Dr, this.getLayerSourceCache(Dr), Tr);
            }
          const yr = this._queryRenderedFeatures(xe, ir, He);
          return this._flattenAndSortRenderedFeatures(yr);
        }
        _queryRenderedFeatures(xe, ke, He) {
          const ir = [], ar = !!this.map._showQueryGeometry, yr = Ea.createFromScreenPoints(xe, He);
          for (const Tr in ke) {
            const $r = bf(yr, ke[Tr], this._availableImages, He, ar);
            Object.keys($r).length && ir.push($r);
          }
          if (this.placement)
            for (const Tr in ke) {
              if (!ke[Tr].sourceCache._onlySymbols)
                continue;
              const $r = xf(yr.screenGeometry, ke[Tr], this._availableImages, this.placement.collisionIndex, this.placement.retainedQueryData);
              Object.keys($r).length && ir.push($r);
            }
          return ir;
        }
        querySourceFeatures(xe, ke) {
          const He = ke && ke.filter;
          He && this._validate(Pi, "querySourceFeatures.filter", He, null, ke);
          let ir = [];
          const ar = this.getOwnSourceCaches(xe);
          for (const yr of ar)
            ir = ir.concat(Lh(yr, ke));
          return ir;
        }
        addSourceType(xe, ke, He) {
          return za.getSourceType(xe) ? He(new Error(`A source type called "${xe}" already exists.`)) : (za.setSourceType(xe, ke), ke.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", { name: xe, url: ke.workerSourceURL }, He) : He(null, null));
        }
        getFlatLight() {
          return this.light.getLight();
        }
        setFlatLight(xe, ke, He = {}) {
          this._checkLoaded();
          const ir = this.light.getLight();
          let ar = !1;
          for (const Tr in xe)
            if (!ne.bn(xe[Tr], ir[Tr])) {
              ar = !0;
              break;
            }
          if (!ar)
            return;
          const yr = this._getTransitionParameters();
          this.light.setLight(xe, ke, He), this.light.updateTransitions(yr);
        }
        getTerrain() {
          return this.terrain && this.terrain.drapeRenderMode === 1 ? this.terrain.get() : null;
        }
        setTerrainForDraping() {
          this.setTerrain({ source: "", exaggeration: 0 }, 0);
        }
        checkCanvasFingerprintNoise() {
          this.disableElevatedTerrain === void 0 && (this.disableElevatedTerrain = ne.q.hasCanvasFingerprintNoise(), this.disableElevatedTerrain && ne.w("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode)."));
        }
        setTerrain(xe, ke = 1) {
          if (this._checkLoaded(), !xe)
            return this.terrainSetForDrapingOnly() || (delete this.terrain, this.map.transform.projection.requiresDraping && this.setTerrainForDraping()), ke === 0 && delete this.terrain, xe === null ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = !0);
          this.checkCanvasFingerprintNoise();
          let He = xe;
          const ir = xe.source == null;
          if (ke === 1) {
            if (this.disableElevatedTerrain)
              return;
            if (typeof He.source == "object") {
              const Tr = "terrain-dem-src";
              this.addSource(Tr, He.source), He = ne.cp(He), He = ne.l(He, { source: Tr });
            }
            const ar = ne.l({}, He), yr = {};
            if (this.terrain && ir) {
              ar.source = this.terrain.get().source;
              const Tr = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
              Tr && (yr.style = Tr.serialize());
            }
            if (this._validate(Qn, "terrain", ar, yr))
              return;
          }
          if (!this.terrain || this.terrain.scope !== this.scope && !ir || this.terrain && ke !== this.terrain.drapeRenderMode) {
            if (!He)
              return;
            this._createTerrain(He, ke), this.fire(new ne.z("data", { dataType: "style" }));
          } else {
            const ar = this.terrain, yr = ar.get();
            for (const Tr of Object.keys(ne.a3.terrain))
              !He.hasOwnProperty(Tr) && ne.a3.terrain[Tr].default && (He[Tr] = ne.a3.terrain[Tr].default);
            for (const Tr in xe)
              if (!ne.bn(xe[Tr], yr[Tr])) {
                ar.set(xe, this.options), this.stylesheet.terrain = xe;
                const $r = this._getTransitionParameters({ duration: 0 });
                ar.updateTransitions($r), this.fire(new ne.z("data", { dataType: "style" }));
                break;
              }
          }
          this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = !0;
        }
        _createFog(xe) {
          const ke = this.fog = new Qo(xe, this.map.transform, this.scope, this.options);
          this.stylesheet.fog = ke.get();
          const He = this._getTransitionParameters({ duration: 0 });
          ke.updateTransitions(He);
        }
        _createSnow(xe) {
          const ke = this.snow = new da(xe, this.map.transform, this.scope, this.options);
          this.stylesheet.snow = ke.get();
          const He = this._getTransitionParameters({ duration: 0 });
          ke.updateTransitions(He);
        }
        _createRain(xe) {
          const ke = this.rain = new Ra(xe, this.map.transform, this.scope, this.options);
          this.stylesheet.rain = ke.get();
          const He = this._getTransitionParameters({ duration: 0 });
          ke.updateTransitions(He);
        }
        _updateMarkersOpacity() {
          this.map._markers.length !== 0 && this.map._requestDomTask(() => {
            for (const xe of this.map._markers)
              xe._evaluateOpacity();
          });
        }
        getFog() {
          return this.fog ? this.fog.get() : null;
        }
        setFog(xe) {
          if (this._checkLoaded(), !xe)
            return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = !0);
          if (this.fog) {
            const ke = this.fog;
            if (!ne.bn(ke.get(), xe)) {
              ke.set(xe, this.options), this.stylesheet.fog = ke.get();
              const He = this._getTransitionParameters({ duration: 0 });
              ke.updateTransitions(He);
            }
          } else
            this._createFog(xe);
          this._markersNeedUpdate = !0;
        }
        getSnow() {
          return this.snow ? this.snow.get() : null;
        }
        setSnow(xe) {
          if (this._checkLoaded(), !xe)
            return delete this.snow, void delete this.stylesheet.snow;
          if (this.snow) {
            const ke = this.snow;
            if (!ne.bn(ke.get(), xe)) {
              ke.set(xe, this.options), this.stylesheet.snow = ke.get();
              const He = this._getTransitionParameters({ duration: 0 });
              ke.updateTransitions(He);
            }
          } else
            this._createSnow(xe);
          this._markersNeedUpdate = !0;
        }
        getRain() {
          return this.rain ? this.rain.get() : null;
        }
        setRain(xe) {
          if (this._checkLoaded(), !xe)
            return delete this.rain, void delete this.stylesheet.rain;
          if (this.rain) {
            const ke = this.rain;
            if (!ne.bn(ke.get(), xe)) {
              ke.set(xe, this.options), this.stylesheet.rain = ke.get();
              const He = this._getTransitionParameters({ duration: 0 });
              ke.updateTransitions(He);
            }
          } else
            this._createRain(xe);
          this._markersNeedUpdate = !0;
        }
        _reloadColorTheme() {
          const xe = () => {
            for (const ir in this._layers)
              this._layers[ir].lut = this._styleColorTheme.lut;
            for (const ir in this._sourceCaches)
              this._sourceCaches[ir].clearTiles();
          }, ke = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
          if (!ke)
            return this._styleColorTheme.lut = null, void xe();
          const He = this._evaluateColorThemeData(ke);
          this._loadColorTheme(He).then(() => {
            this.fire(new ne.z("colorthemeset")), xe();
          }).catch((ir) => {
            ne.w(`Couldn't set color theme: ${ir}`);
          });
        }
        setColorTheme(xe) {
          this._checkLoaded(), this._styleColorTheme.colorThemeOverride && ne.w("Note: setColorTheme is called on a style with a color-theme override, the passed color-theme won't be visible."), this._styleColorTheme.colorTheme = xe, this._reloadColorTheme();
        }
        setImportColorTheme(xe, ke) {
          const He = this.getFragmentStyle(xe);
          He && (He._styleColorTheme.colorThemeOverride = ke, He._reloadColorTheme());
        }
        _getTransitionParameters(xe) {
          return { now: ne.q.now(), transition: ne.l(this.transition, xe) };
        }
        updateDrapeFirstLayers() {
          if (!this.terrain)
            return;
          const xe = [], ke = [];
          for (const He of this._mergedOrder)
            this.isLayerDraped(this._mergedLayers[He]) ? xe.push(He) : ke.push(He);
          this._drapedFirstOrder = [], this._drapedFirstOrder.push(...xe), this._drapedFirstOrder.push(...ke);
        }
        _createTerrain(xe, ke) {
          const He = this.terrain = new en(xe, ke, this.scope, this.options);
          ke === 1 && (this.stylesheet.terrain = xe), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
          const ir = this._getTransitionParameters({ duration: 0 });
          He.updateTransitions(ir);
        }
        _force3DLayerUpdate() {
          for (const xe in this._layers) {
            const ke = this._layers[xe];
            ke.type === "fill-extrusion" && this._updateLayer(ke);
          }
        }
        _forceSymbolLayerUpdate() {
          for (const xe in this._layers) {
            const ke = this._layers[xe];
            ke.type === "symbol" && this._updateLayer(ke);
          }
        }
        _validate(xe, ke, He, ir, ar = {}) {
          if (ar && ar.validate === !1)
            return !1;
          const yr = ne.l({}, this.serialize());
          return Nl(this, xe.call(Io, ne.l({ key: ke, style: yr, value: He, styleSpec: ne.a3 }, ir)));
        }
        _remove() {
          this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), ne.cx.off("pluginStateChange", this._rtlTextPluginCallback);
          for (const xe in this._mergedLayers)
            this._mergedLayers[xe].setEventedParent(null);
          for (const xe in this._mergedSourceCaches)
            this._mergedSourceCaches[xe].clearTiles(), this._mergedSourceCaches[xe].setEventedParent(null);
          this.setEventedParent(null), delete this.fog, delete this.snow, delete this.rain, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.isRootStyle() && (this.imageManager.setEventedParent(null), this.modelManager.setEventedParent(null), this.dispatcher.remove());
        }
        clearSource(xe) {
          const ke = this.getSourceCaches(xe);
          for (const He of ke)
            He.clearTiles();
        }
        clearSources() {
          for (const xe in this._mergedSourceCaches)
            this._mergedSourceCaches[xe].clearTiles();
        }
        reloadSource(xe) {
          const ke = this.getSourceCaches(xe);
          for (const He of ke)
            He.resume(), He.reload();
        }
        reloadSources() {
          for (const xe of this.getSources())
            xe.reload && xe.reload();
        }
        updateSources(xe) {
          let ke;
          this.directionalLight && (ke = Mu(this.directionalLight));
          for (const He in this._mergedSourceCaches)
            this._mergedSourceCaches[He].update(xe, void 0, void 0, ke);
        }
        _generateCollisionBoxes() {
          for (const xe in this._sourceCaches) {
            const ke = this._sourceCaches[xe];
            ke.resume(), ke.reload();
          }
        }
        _updatePlacement(xe, ke, He, ir, ar, yr, Tr = !1) {
          let $r = !1, Dr = !1;
          const Or = {}, Gr = {};
          for (const qr of this._mergedOrder) {
            const Jr = this._mergedLayers[qr];
            if (Jr.type !== "symbol")
              continue;
            const bi = ne.aC(Jr.source, Jr.scope);
            let fi = Or[bi];
            if (!fi) {
              const Ei = this.getLayerSourceCache(Jr);
              if (!Ei)
                continue;
              const Ii = Ei.getRenderableIds(!0).map((Ni) => Ei.getTileByID(Ni));
              Gr[bi] = Ii.slice(), fi = Or[bi] = Ii.sort((Ni, zi) => zi.tileID.overscaledZ - Ni.tileID.overscaledZ || (Ni.tileID.isLessThan(zi.tileID) ? -1 : 1));
            }
            const Mi = this.crossTileSymbolIndex.addLayer(Jr, fi, ke.center.lng, ke.projection);
            $r = $r || Mi;
          }
          if (this.crossTileSymbolIndex.pruneUnusedLayers(this._mergedOrder), Tr = Tr || this._layerOrderChanged || ir === 0, this._layerOrderChanged && this.fire(new ne.z("neworder")), (Tr || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(ne.q.now(), ke.zoom)) && (this.pauseablePlacement = new Af(ke, this._mergedOrder, Tr, He, ir, ar, this.placement, this.fog && ke.projection.supportsFog ? this.fog.state : null, this._buildingIndex), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._mergedOrder, this._mergedLayers, Or, Gr, this.map.painter.scaleFactor), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(ne.q.now()), Dr = !0), $r && this.pauseablePlacement.placement.setStale()), Dr || $r) {
            this._buildingIndex.onNewFrame(ke.zoom);
            for (let qr = 0; qr < this._mergedOrder.length; qr++) {
              const Jr = this._mergedLayers[this._mergedOrder[qr]];
              if (Jr.type !== "symbol")
                continue;
              const bi = this.isLayerClipped(Jr);
              this.placement.updateLayerOpacities(Jr, Or[ne.aC(Jr.source, Jr.scope)], qr, bi ? yr : null);
            }
          }
          return { needsRerender: !this.pauseablePlacement.isDone() || this.placement.hasTransitions(ne.q.now()) };
        }
        _releaseSymbolFadeTiles() {
          for (const xe in this._sourceCaches)
            this._sourceCaches[xe].releaseSymbolFadeTiles();
        }
        addImport(xe, ke) {
          this._checkLoaded();
          const He = this.stylesheet.imports = this.stylesheet.imports || [];
          if (He.findIndex(({ id: ar }) => ar === xe.id) !== -1)
            return void this.fire(new ne.y(new Error(`Import with id '${xe.id}' already exists in the map's style.`)));
          if (!ke)
            return He.push(xe), this._loadImports([xe], !0);
          const ir = He.findIndex(({ id: ar }) => ar === ke);
          return ir === -1 && this.fire(new ne.y(new Error(`Import with id "${ke}" does not exist on this map.`))), this.stylesheet.imports = He.slice(0, ir).concat(xe).concat(He.slice(ir)), this._loadImports([xe], !0, ke);
        }
        updateImport(xe, ke) {
          this._checkLoaded();
          const He = this.stylesheet.imports || [], ir = this.getImportIndex(xe);
          return ir === -1 ? this : typeof ke == "string" ? (this.setImportUrl(xe, ke), this) : (ke.url && ke.url !== He[ir].url && this.setImportUrl(xe, ke.url), ne.bn(ke.config, He[ir].config) || this.setImportConfig(xe, ke.config), ne.bn(ke.data, He[ir].data) || this.setImportData(xe, ke.data), this);
        }
        moveImport(xe, ke) {
          this._checkLoaded();
          let He = this.stylesheet.imports || [];
          const ir = this.getImportIndex(xe);
          if (ir === -1)
            return this;
          const ar = this.getImportIndex(ke);
          if (ar === -1)
            return this;
          const yr = He[ir], Tr = this.fragments[ir];
          return He = He.filter(({ id: $r }) => $r !== xe), this.fragments = this.fragments.filter(({ id: $r }) => $r !== xe), this.stylesheet.imports = He.slice(0, ar).concat(yr).concat(He.slice(ar)), this.fragments = this.fragments.slice(0, ar).concat(Tr).concat(this.fragments.slice(ar)), this.mergeLayers(), this;
        }
        setImportUrl(xe, ke) {
          this._checkLoaded();
          const He = this.stylesheet.imports || [], ir = this.getImportIndex(xe);
          if (ir === -1)
            return this;
          He[ir].url = ke;
          const ar = this.fragments[ir];
          return ar.style = this._createFragmentStyle(He[ir]), ar.style.on("style.import.load", () => this.mergeAll()), ar.style.loadURL(ke), this;
        }
        setImportData(xe, ke) {
          this._checkLoaded();
          const He = this.getImportIndex(xe), ir = this.stylesheet.imports || [];
          return He === -1 ? this : ke ? (this.fragments[He].style.setState(ke), this._reloadImports(), this) : (delete ir[He].data, this.setImportUrl(xe, ir[He].url));
        }
        setImportConfig(xe, ke) {
          this._checkLoaded();
          const He = this.getImportIndex(xe), ir = this.stylesheet.imports || [];
          if (He === -1)
            return this;
          ke ? ir[He].config = ke : delete ir[He].config;
          const ar = this.fragments[He], yr = ar.style.stylesheet && ar.style.stylesheet.schema;
          return ar.config = ke, ar.style.updateConfig(ke, yr), this.updateConfigDependencies(), this;
        }
        removeImport(xe) {
          this._checkLoaded();
          const ke = this.stylesheet.imports || [], He = this.getImportIndex(xe);
          He !== -1 && (ke.splice(He, 1), this.fragments[He].style._remove(), this.fragments.splice(He, 1), this._reloadImports());
        }
        getImportIndex(xe) {
          const ke = (this.stylesheet.imports || []).findIndex((He) => He.id === xe);
          return ke === -1 && this.fire(new ne.y(new Error(`Import '${xe}' does not exist in the map's style and cannot be updated.`))), ke;
        }
        getLayer(xe) {
          return this._mergedLayers[xe];
        }
        getSources() {
          const xe = [];
          for (const ke in this._mergedOtherSourceCaches) {
            const He = this._mergedOtherSourceCaches[ke];
            He && xe.push(He.getSource());
          }
          return xe;
        }
        getSource(xe, ke) {
          const He = this.getSourceCache(xe, ke);
          return He && He.getSource();
        }
        getLayerSource(xe) {
          const ke = this.getLayerSourceCache(xe);
          return ke && ke.getSource();
        }
        getSourceCache(xe, ke) {
          const He = ne.aC(xe, ke);
          return this._mergedOtherSourceCaches[He];
        }
        getLayerSourceCache(xe) {
          const ke = ne.aC(xe.source, xe.scope);
          return xe.type === "symbol" ? this._mergedSymbolSourceCaches[ke] : this._mergedOtherSourceCaches[ke];
        }
        getSourceCaches(xe) {
          if (xe == null)
            return Object.values(this._mergedSourceCaches);
          const ke = [];
          return this._mergedOtherSourceCaches[xe] && ke.push(this._mergedOtherSourceCaches[xe]), this._mergedSymbolSourceCaches[xe] && ke.push(this._mergedSymbolSourceCaches[xe]), ke;
        }
        updateSourceCaches() {
          const xe = this._changes.getUpdatedSourceCaches();
          for (const ke in xe) {
            const He = xe[ke];
            He === "reload" ? this.reloadSource(ke) : He === "clear" && this.clearSource(ke);
          }
        }
        updateLayers(xe) {
          const ke = this._changes.getUpdatedPaintProperties();
          for (const He of ke) {
            const ir = this.getLayer(He);
            ir && ir.updateTransitions(xe);
          }
        }
        getImages(xe, ke, He) {
          this.imageManager.getImages(ke.icons, ke.scope, He), this._updateTilesForChangedImages();
          const ir = (ar) => {
            ar && ar.setDependencies(ke.tileID.key, ke.type, ke.icons);
          };
          ir(this._otherSourceCaches[ke.source]), ir(this._symbolSourceCaches[ke.source]);
        }
        rasterizeImages(xe, ke, He) {
          this.imageManager.rasterizeImages(ke, He);
        }
        getGlyphs(xe, ke, He) {
          this.glyphManager.getGlyphs(ke.stacks, ke.scope, He);
        }
        getResource(xe, ke, He) {
          return ne.cy(ke, He);
        }
        getOwnSourceCache(xe) {
          return this._otherSourceCaches[xe];
        }
        getOwnLayerSourceCache(xe) {
          return xe.type === "symbol" ? this._symbolSourceCaches[xe.source] : this._otherSourceCaches[xe.source];
        }
        getOwnSourceCaches(xe) {
          const ke = [];
          return this._otherSourceCaches[xe] && ke.push(this._otherSourceCaches[xe]), this._symbolSourceCaches[xe] && ke.push(this._symbolSourceCaches[xe]), ke;
        }
        _isSourceCacheLoaded(xe) {
          const ke = this.getOwnSourceCaches(xe);
          return ke.length === 0 ? (this.fire(new ne.y(new Error(`There is no source with ID '${xe}'`))), !1) : ke.every((He) => He.loaded());
        }
        has3DLayers() {
          return this._has3DLayers;
        }
        hasSymbolLayers() {
          return this._hasSymbolLayers;
        }
        hasCircleLayers() {
          return this._hasCircleLayers;
        }
        isLayerClipped(xe, ke) {
          if (!this._clipLayerPresent && xe.type !== "fill-extrusion")
            return !1;
          const He = xe.type === "fill-extrusion" && xe.sourceLayer === "building";
          if (xe.is3D()) {
            if (He || ke && ke.type === "batched-model" || xe.type === "model")
              return !0;
          } else if (xe.type === "symbol")
            return !0;
          return !1;
        }
        _clearWorkerCaches() {
          this.dispatcher.broadcast("clearCaches");
        }
        destroy() {
          this._clearWorkerCaches(), this.fragments.forEach((xe) => {
            xe.style._remove();
          }), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
        }
      }
      za.getSourceType = function(qe) {
        return wu[qe];
      }, za.setSourceType = function(qe, xe) {
        wu[qe] = xe;
      }, za.registerForPluginStateChange = ne.ch;
      var Ls = `
#define EPSILON 0.0000001
#define PI 3.141592653589793
#ifdef RENDER_CUTOFF
float cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}
#endif`, _s = `
out vec4 glFragColor;highp float unpack_depth(highp vec4 rgba_depth)
{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}
#ifdef INDICATOR_CUTOUT
uniform vec3 u_indicator_cutout_centers;uniform vec4 u_indicator_cutout_params;
#endif
vec4 applyCutout(vec4 color,float height) {
#ifdef INDICATOR_CUTOUT
float verticalFadeRange=u_indicator_cutout_centers.z*0.25;float holeMinOpacity=mix(1.0,u_indicator_cutout_params.x,smoothstep(u_indicator_cutout_centers.z,u_indicator_cutout_centers.z+verticalFadeRange,height));float holeRadius=max(u_indicator_cutout_params.y,0.0);float holeAspectRatio=u_indicator_cutout_params.z;float fadeStart=u_indicator_cutout_params.w;float distA=distance(vec2(gl_FragCoord.x,gl_FragCoord.y*holeAspectRatio),vec2(u_indicator_cutout_centers[0],u_indicator_cutout_centers[1]*holeAspectRatio));return color*min(smoothstep(fadeStart,holeRadius,distA)+holeMinOpacity,1.0);
#else
return color;
#endif
}
#ifdef DEBUG_WIREFRAME
#define HANDLE_WIREFRAME_DEBUG \\
glFragColor=vec4(0.7,0.0,0.0,0.7); \\
gl_FragDepth=gl_FragCoord.z-0.0001;
#else
#define HANDLE_WIREFRAME_DEBUG
#endif
#ifdef RENDER_CUTOFF
uniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;
#endif
vec4 textureLodCustom(sampler2D image,highp vec2 pos,highp vec2 lod_coord) {highp vec2 size=vec2(textureSize(image,0));highp vec2 dx=dFdx(lod_coord.xy*size);highp vec2 dy=dFdy(lod_coord.xy*size);highp float delta_max_sqr=max(dot(dx,dx),dot(dy,dy));highp float lod=0.5*log2(delta_max_sqr);return textureLod(image,pos,lod);}vec4 applyLUT(highp sampler3D lut,vec4 col) {vec3 size=vec3(textureSize(lut,0));vec3 uvw=(col.rbg*float(size-1.0)+0.5)/size;return vec4(texture(lut,uvw).rgb,col.a);}vec3 applyLUT(highp sampler3D lut,vec3 col) {return applyLUT(lut,vec4(col,1.0)).rgb;}`, Ad = `
#define EXTENT 8192.0
#define RAD_TO_DEG 180.0/PI
#define DEG_TO_RAD PI/180.0
#define GLOBE_RADIUS EXTENT/PI/2.0
float wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}
#ifdef PROJECTION_GLOBE_VIEW
vec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {
#ifndef PROJECTED_POS_ON_VIEWPORT
float tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;
#else
return vec3(0.0);
#endif
}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}
#endif
vec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(
unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0
);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const vec2 units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (units_to_pixels*pos+offset)/pattern_size;}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {return get_pattern_pos(pixel_coord_upper,pixel_coord_lower,pattern_size,vec2(tile_units_to_pixels),pos);}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}
#ifdef RENDER_CUTOFF
uniform vec4 u_cutoff_params;out float v_cutoff_opacity;
#endif
const vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(vec2 posWithComposedSkirt)
{float skirt=float(posWithComposedSkirt.x >=skirtOffset);vec2 pos=posWithComposedSkirt-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}`, Bf = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", Ml = `
#define ELEVATION_SCALE 7.0
#define ELEVATION_OFFSET 450.0
#ifdef PROJECTION_GLOBE_VIEW
uniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(
mix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}
#else
vec3 elevationVector(vec2 pos) { return vec3(0,0,1); }
#endif
#ifdef TERRAIN
uniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {
#ifdef TERRAIN_DEM_FLOAT_FORMAT
vec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;
#else
float dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);
#endif
}float prevElevation(vec2 apos) {
#ifdef TERRAIN_DEM_FLOAT_FORMAT
vec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;
#else
float dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);
#endif
}
#ifdef TERRAIN_VERTEX_MORPHING
float elevation(vec2 apos) {
#ifdef ZERO_EXAGGERATION
return 0.0;
#endif
float nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}
#else
float elevation(vec2 apos) {
#ifdef ZERO_EXAGGERATION
return 0.0;
#endif
return currentElevation(apos);}
#endif
vec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}
#else
float elevation(vec2 pos) { return 0.0; }
#endif
#ifdef DEPTH_OCCLUSION
uniform highp sampler2D u_depth;uniform highp vec2 u_depth_size_inv;uniform highp vec2 u_depth_range_unpack;uniform highp float u_occluder_half_size;uniform highp float u_occlusion_depth_offset;
#ifdef DEPTH_D24
float unpack_depth(float depth) {return depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}vec4 unpack_depth4(vec4 depth) {return depth*u_depth_range_unpack.x+vec4(u_depth_range_unpack.y);}
#else
highp float unpack_depth_rgba(vec4 rgba_depth)
{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}
#endif
bool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;
#ifdef DEPTH_D24
float depth=unpack_depth(texture(u_depth,(coord.xy+1.0)*0.5).r);
#else
float depth=unpack_depth_rgba(texture(u_depth,(coord.xy+1.0)*0.5));
#endif
return coord.z+u_occlusion_depth_offset > depth;}highp vec4 getCornerDepths(vec2 coord) {highp vec3 df=vec3(u_occluder_half_size*u_depth_size_inv,0.0);highp vec2 uv=0.5*coord.xy+0.5;
#ifdef DEPTH_D24
highp vec4 depth=vec4(
texture(u_depth,uv-df.xz).r,texture(u_depth,uv+df.xz).r,texture(u_depth,uv-df.zy).r,texture(u_depth,uv+df.zy).r
);depth=unpack_depth4(depth);
#else
highp vec4 depth=vec4(
unpack_depth_rgba(texture(u_depth,uv-df.xz)),unpack_depth_rgba(texture(u_depth,uv+df.xz)),unpack_depth_rgba(texture(u_depth,uv-df.zy)),unpack_depth_rgba(texture(u_depth,uv+df.zy))
);
#endif
return depth;}highp float occlusionFadeMultiSample(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec2 uv=0.5*coord.xy+0.5;int NX=3;int NY=4;highp vec2 df=u_occluder_half_size*u_depth_size_inv;highp vec2 oneStep=2.0*u_occluder_half_size*u_depth_size_inv/vec2(NX-1,NY-1);highp float res=0.0;for (int y=0; y < NY;++y) {for (int x=0; x < NX;++x) {
#ifdef DEPTH_D24
highp float depth=unpack_depth(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)).r);
#else
highp float depth=unpack_depth_rgba(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)));
#endif
res+=1.0-clamp(300.0*(coord.z+u_occlusion_depth_offset-depth),0.0,1.0);}}res=clamp(2.0*res/float(NX*NY)-0.5,0.0,1.0);return res;}highp float occlusionFade(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec4 depth=getCornerDepths(coord.xy);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z+u_occlusion_depth_offset)-depth),0.0,1.0));}
#else
bool isOccluded(vec4 frag) { return false; }highp float occlusionFade(vec4 frag) { return 1.0; }highp float occlusionFadeMultiSample(vec4 frag) { return 1.0; }
#endif//DEPTH_OCCLUSION`, Yu = `#ifdef FOG
uniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}
#endif`, Su = `highp vec3 hash(highp vec2 p) {highp vec3 p3=fract(p.xyx*vec3(443.8975,397.2973,491.1871));p3+=dot(p3,p3.yxz+19.19);return fract((p3.xxy+p3.yzz)*p3.zyx);}vec3 dither(vec3 color,highp vec2 seed) {vec3 rnd=hash(seed)+hash(seed+0.59374)-0.5;return color+rnd/255.0;}
#ifdef FOG
uniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(
mix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {
#ifdef FOG_DITHERING
vec2 dither_seed=gl_FragCoord.xy+u_fog_temporal_offset;return dither(color,dither_seed);
#else
return color;
#endif
}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}
#endif`, lu = `#ifdef RASTER_ARRAY
uniform highp sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);ivec4 _raTexLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}vec2 _raTexLinearMix(highp vec2 fxy,highp vec4 colorMix,highp float colorOffset,highp vec4 t00,highp vec4 t10,highp vec4 t01,highp vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image0,c.yz,0),texelFetch(u_image0,c.xz,0),texelFetch(u_image0,c.yw,0),texelFetch(u_image0,c.xw,0)
);}vec2 raTexture2D_image1_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image1,c.yz,0),texelFetch(u_image1,c.xz,0),texelFetch(u_image1,c.yw,0),texelFetch(u_image1,c.xw,0)
);}vec2 raTexture2D_image0_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image0,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image1,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}
#endif`, Fh = `#ifdef RASTER_ARRAY
uniform sampler2D u_velocity;uniform mediump vec2 u_velocity_res;uniform mediump float u_max_speed;const vec4 NO_DATA=vec4(1);const vec2 INVALID_VELOCITY=vec2(-1);uniform highp vec2 u_uv_offset;uniform highp float u_data_offset;uniform highp vec2 u_data_scale;ivec4 rasterArrayLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}highp vec2 lookup_velocity(highp vec2 uv) {uv=u_uv_offset.x+u_uv_offset.y*uv;highp vec2 fxy;ivec4 c=rasterArrayLinearCoord(uv,u_velocity_res,fxy);highp vec4 tl=texelFetch(u_velocity,c.yz,0);highp vec4 tr=texelFetch(u_velocity,c.xz,0);highp vec4 bl=texelFetch(u_velocity,c.yw,0);highp vec4 br=texelFetch(u_velocity,c.xw,0);if (tl==NO_DATA) {return INVALID_VELOCITY;}if (tr==NO_DATA) {return INVALID_VELOCITY;}if (bl==NO_DATA) {return INVALID_VELOCITY;}if (br==NO_DATA) {return INVALID_VELOCITY;}highp vec4 t=mix(mix(bl,br,fxy.x),mix(tl,tr,fxy.x),fxy.y);highp vec2 velocity=u_data_offset+vec2(dot(t.rg,u_data_scale),dot(t.ba,u_data_scale));velocity.y=-velocity.y;velocity/=max(u_max_speed,length(velocity));return velocity;}
#endif
uniform highp float u_particle_pos_scale;uniform highp vec2 u_particle_pos_offset;highp vec4 pack_pos_to_rgba(highp vec2 p) {highp vec2 v=(p+u_particle_pos_offset)/u_particle_pos_scale;highp vec4 r=vec4(v.x,fract(v.x*255.0),v.y,fract(v.y*255.0));return vec4(r.x-r.y/255.0,r.y,r.z-r.w/255.0,r.w);}highp vec2 unpack_pos_from_rgba(highp vec4 v) {v=floor(v*255.0+0.5)/255.0;highp vec2 p=vec2(v.x+(v.y/255.0),v.z+(v.w/255.0));return u_particle_pos_scale*p-u_particle_pos_offset;}`, Uc = `#ifdef RENDER_SHADOWS
uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {vec3 transformed_normal=vec3(-normal.xy,normal.z);float NDotL=dot(normalize(transformed_normal),u_shadow_direction);float dotScale=min(1.0-NDotL,1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}
#endif//RENDER_SHADOWS`, rs = `#ifdef RENDER_SHADOWS
#ifdef DEPTH_TEXTURE
uniform highp sampler2D u_shadowmap_0;uniform highp sampler2D u_shadowmap_1;
#else
uniform sampler2D u_shadowmap_0;uniform sampler2D u_shadowmap_1;
#endif
uniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;highp float shadow_sample_1(highp vec2 uv,highp float compare) {highp float shadow_depth;
#ifdef DEPTH_TEXTURE
shadow_depth=texture(u_shadowmap_1,uv).r;
#else
shadow_depth=unpack_depth(texture(u_shadowmap_1,uv))*0.5+0.5;
#endif
return step(shadow_depth,compare);}highp float shadow_sample_0(highp vec2 uv,highp float compare) {highp float shadow_depth;
#ifdef DEPTH_TEXTURE
shadow_depth=texture(u_shadowmap_0,uv).r;
#else
shadow_depth=unpack_depth(texture(u_shadowmap_0,uv))*0.5+0.5;
#endif
return step(shadow_depth,compare);}float shadow_occlusion_1(highp vec4 pos,highp float bias) {highp vec2 uv=pos.xy;return shadow_sample_1(uv,pos.z-bias);}float shadow_occlusion_0(highp vec4 pos,highp float bias) {highp float compare0=pos.z-bias;
#ifdef TEXTURE_GATHER
highp vec2 uv=pos.xy;highp vec4 samples=textureGather(u_shadowmap_0,uv,0);lowp vec4 stepSamples=step(samples,vec4(compare0));
#else
highp vec2 uv00=pos.xy-vec2(0.5*u_shadow_texel_size);highp vec2 uv10=uv00+vec2(u_shadow_texel_size,0.0);highp vec2 uv01=uv00+vec2(0.0,u_shadow_texel_size);highp vec2 uv11=uv01+vec2(u_shadow_texel_size,0.0);lowp vec4 stepSamples=vec4(
shadow_sample_0(uv01,compare0),shadow_sample_0(uv11,compare0),shadow_sample_0(uv10,compare0),shadow_sample_0(uv00,compare0)
);
#endif
vec2 f=fract(pos.xy*u_shadow_map_resolution-vec2(0.5));lowp vec2 lerpx=mix(stepSamples.wx,stepSamples.zy,f.xx);return mix(lerpx.x,lerpx.y,f.y);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {
#ifdef SHADOWS_SINGLE_CASCADE
light_view_pos0.xyz/=light_view_pos0.w;vec2 abs_bounds=abs(light_view_pos0.xy);if (abs_bounds.x >=1.0 || abs_bounds.y >=1.0) {return 0.0;}light_view_pos0.xyz=light_view_pos0.xyz*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);
#else
light_view_pos0.xyz/=light_view_pos0.w;light_view_pos1.xyz/=light_view_pos1.w;vec4 uv=vec4(light_view_pos0.xy,light_view_pos1.xy);vec4 abs_bounds=abs(uv);if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {light_view_pos0.xyz=light_view_pos0.xyz*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}light_view_pos1.xyz=light_view_pos1.xyz*0.5+0.5;float occlusion1=shadow_occlusion_1(light_view_pos1,bias);return mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth));
#endif
}highp float calculate_shadow_bias(float NDotL) {
#ifdef NORMAL_OFFSET
return 0.5*u_shadow_bias.x;
#else
return 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));
#endif
}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_opacity(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,float shadow_opacity) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias)*shadow_opacity;return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}highp vec2 compute_receiver_plane_depth_bias(highp vec3 pos_dx,highp vec3 pos_dy)
{highp vec2 biasUV=vec2(
pos_dy.y*pos_dx.z-pos_dx.y*pos_dy.z,pos_dx.x*pos_dy.z-pos_dy.x*pos_dx.z);biasUV*=1.0/((pos_dx.x*pos_dy.y)-(pos_dx.y*pos_dy.x));return biasUV;}float shadowed_light_factor_plane_bias(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {highp vec3 light_view_pos0_xyz=light_view_pos0.xyz/light_view_pos0.w*0.5+0.5;highp vec3 light_view_pos0_ddx=dFdx(light_view_pos0_xyz);highp vec3 light_view_pos0_ddy=dFdy(light_view_pos0_xyz);highp vec2 plane_depth_bias=compute_receiver_plane_depth_bias(light_view_pos0_ddx,light_view_pos0_ddy);highp float bias=dot(vec2(u_shadow_texel_size,u_shadow_texel_size),plane_depth_bias)+0.0001;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}
#endif`;
      const Ju = [];
      kc(Ls, Ju), kc(Ad, Ju), kc(_s, Ju);
      const Eu = { "_prelude_fog.vertex.glsl": Yu, "_prelude_terrain.vertex.glsl": Ml, "_prelude_shadow.vertex.glsl": Uc, "_prelude_fog.fragment.glsl": Su, "_prelude_shadow.fragment.glsl": rs, "_prelude_lighting.glsl": `
#ifdef LIGHTING_3D_MODE
uniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}
#endif//LIGHTING_3D_MODE`, "_prelude_raster_array.glsl": lu, "_prelude_raster_particle.glsl": Fh }, fc = {};
      ca("", Ml), ca(Su, Yu), ca(rs, Uc), ca(lu, ""), ca(Fh, "");
      const kd = ca(_s, Ad), $f = Ls;
      var Bp = { background: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
uniform vec4 u_color;uniform float u_opacity;
#ifdef LIGHTING_3D_MODE
in vec4 v_color;
#endif
void main() {vec4 out_color;
#ifdef LIGHTING_3D_MODE
out_color=v_color;
#else
out_color=u_color;
#endif
#ifdef FOG
out_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));
#endif
glFragColor=out_color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
#include "_prelude_lighting.glsl"
in vec2 a_pos;uniform mat4 u_matrix;
#ifdef LIGHTING_3D_MODE
uniform mediump vec4 u_color;out vec4 v_color;uniform float u_emissive_strength;
#endif
void main() {gl_Position=u_matrix*vec4(a_pos,0,1);
#ifdef LIGHTING_3D_MODE
v_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);
#endif
#ifdef FOG
v_fog_pos=fog_position(a_pos);
#endif
}`), backgroundPattern: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
uniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in highp vec2 v_pos;void main() {highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=textureLodCustom(u_image,pos,v_pos);
#ifdef LIGHTING_3D_MODE
out_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);
#endif
#ifdef FOG
out_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));
#endif
glFragColor=out_color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
uniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec2 u_pattern_units_to_pixels;in vec2 a_pos;out highp vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_pattern_units_to_pixels,a_pos);
#ifdef FOG
v_fog_pos=fog_position(a_pos);
#endif
}`), circle: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
in vec3 v_data;in float v_visibility;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define mediump float radius
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define highp vec4 stroke_color
#pragma mapbox: define mediump float stroke_width
#pragma mapbox: define lowp float stroke_opacity
uniform float u_emissive_strength;void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize mediump float radius
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize highp vec4 stroke_color
#pragma mapbox: initialize mediump float stroke_width
#pragma mapbox: initialize lowp float stroke_opacity
vec2 extrude=v_data.xy;float blur_positive=blur < 0.0 ? 0.0 : 1.0;lowp float antialiasblur=v_data.z;float extrude_length=length(extrude)+antialiasblur*(1.0-blur_positive);float antialiased_blur=-max(abs(blur),antialiasblur);float opacity_t=smoothstep((1.0-blur_positive)*antialiased_blur,blur_positive*antialiased_blur,extrude_length-1.0)-smoothstep(0.0,antialiasblur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(
antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)
);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);
#ifdef LIGHTING_3D_MODE
out_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);
#endif
#ifdef FOG
out_color=fog_apply_premultiplied(out_color,v_fog_pos);
#endif
glFragColor=out_color*(v_visibility*opacity_t);
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
}`, `#include "_prelude_fog.vertex.glsl"
#include "_prelude_terrain.vertex.glsl"
#define NUM_VISIBILITY_RINGS 2
#define INV_SQRT2 0.70710678
#define ELEVATION_BIAS 0.0001
#define NUM_SAMPLES_PER_RING 16
uniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in vec2 a_pos;
#ifdef PROJECTION_GLOBE_VIEW
in vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;
#endif
out vec3 v_data;out float v_visibility;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define mediump float radius
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define highp vec4 stroke_color
#pragma mapbox: define mediump float stroke_width
#pragma mapbox: define lowp float stroke_opacity
vec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {
#if defined(TERRAIN)
return elevation(pos)+ELEVATION_BIAS;
#else
return 0.0;
#endif
}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);
#ifdef PITCH_WITH_MAP
#ifdef PROJECTION_GLOBE_VIEW
return u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );
#else
return u_matrix*( world_center+vec4(sample_offset,0,0) );
#endif
#else
return projected_center+vec4(sample_offset,0,0);
#endif
}float get_sample_step() {
#ifdef PITCH_WITH_MAP
return 2.0*PI/float(NUM_SAMPLES_PER_RING);
#else
return PI/float(NUM_SAMPLES_PER_RING);
#endif
}void main(void) {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize mediump float radius
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize highp vec4 stroke_color
#pragma mapbox: initialize mediump float stroke_width
#pragma mapbox: initialize lowp float stroke_opacity
vec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);vec4 world_center;mat3 surface_vectors;
#ifdef PROJECTION_GLOBE_VIEW
vec3 pos_normal_3=a_pos_normal_3/16384.0;surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);
#else 
surface_vectors=mat3(1.0);float height=circle_elevation(circle_center);world_center=vec4(circle_center,height,1);
#endif
vec4 projected_center=u_matrix*world_center;float view_scale=0.0;
#ifdef PITCH_WITH_MAP
#ifdef SCALE_WITH_MAP
view_scale=1.0;
#else
view_scale=projected_center.w/u_camera_to_center_distance;
#endif
#else
#ifdef SCALE_WITH_MAP
view_scale=u_camera_to_center_distance;
#else
view_scale=projected_center.w;
#endif
#endif
gl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;
#ifdef TERRAIN
float step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;
#ifdef PITCH_WITH_MAP
float cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;
#else
occlusion_world_center=world_center;occlusion_projected_center=projected_center;
#endif
for(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);
#else
visibility=1.0;
#endif
#ifdef PROJECTION_GLOBE_VIEW
visibility=1.0;
#endif
v_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);
#ifdef FOG
v_fog_pos=fog_position(world_center.xyz);
#endif
}`), clippingMask: ca("void main() {glFragColor=vec4(1.0);}", "in vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), heatmap: ca(`#include "_prelude_fog.fragment.glsl"
uniform highp float u_intensity;in vec2 v_extrude;
#pragma mapbox: define highp float weight
#define GAUSS_COEF 0.3989422804014327
void main() {
#pragma mapbox: initialize highp float weight
float d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);
#ifdef FOG
if (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}
#endif
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_terrain.vertex.glsl"
#include "_prelude_fog.vertex.glsl"
uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;in vec2 a_pos;
#ifdef PROJECTION_GLOBE_VIEW
in vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;
#endif
out vec2 v_extrude;
#pragma mapbox: define highp float weight
#pragma mapbox: define mediump float radius
const highp float ZERO=1.0/255.0/16.0;
#define GAUSS_COEF 0.3989422804014327
void main(void) {
#pragma mapbox: initialize highp float weight
#pragma mapbox: initialize mediump float radius
vec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);vec3 pos;
#ifdef PROJECTION_GLOBE_VIEW
vec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);
#else
pos=vec3(tilePos+extrude,elevation(tilePos));
#endif
gl_Position=u_matrix*vec4(pos,1);
#ifdef FOG
v_fog_pos=fog_position(pos);
#endif
}`), heatmapTexture: ca(`uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(0.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, "in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"), collisionBox: ca("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", `#include "_prelude_terrain.vertex.glsl"
in vec3 a_pos;in vec2 a_anchor_pos;in vec2 a_extrude;in vec2 a_placed;in vec2 a_shift;in vec2 a_elevation_from_sea;in float a_size_scale;in vec2 a_padding;in float a_auto_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;out float v_placed;out float v_notUsed;void main() {float feature_elevation=a_elevation_from_sea.x+a_auto_z_offset;float terrain_elevation=(a_elevation_from_sea.y==1.0 ? 0.0 : elevation(a_anchor_pos));vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*(feature_elevation+terrain_elevation),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(
0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}`), collisionCircle: ca("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", `in vec2 a_pos_2f;in float a_radius;in vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(
mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(
0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}`), debug: ca("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", `#include "_prelude_terrain.vertex.glsl"
in vec2 a_pos;
#ifdef PROJECTION_GLOBE_VIEW
in vec3 a_pos_3;
#endif
out vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;
#ifdef PROJECTION_GLOBE_VIEW
gl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);
#else
gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);
#endif
}`), fill: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
#include "_prelude_shadow.fragment.glsl"
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float opacity
uniform float u_emissive_strength;
#ifdef RENDER_SHADOWS
uniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;
#endif
#ifdef INDICATOR_CUTOUT
in highp float v_z_offset;
#endif
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float opacity
vec4 out_color=color;
#ifdef LIGHTING_3D_MODE
out_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);
#ifdef RENDER_SHADOWS
float light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);
#endif
#endif
#ifdef FOG
out_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));
#endif
out_color*=opacity;
#ifdef INDICATOR_CUTOUT
out_color=applyCutout(out_color,v_z_offset);
#endif
glFragColor=out_color;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
#include "_prelude_shadow.vertex.glsl"
in vec2 a_pos;
#ifdef ELEVATED_ROADS
in float a_road_z_offset;
#endif
#ifdef RENDER_SHADOWS
uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;
#endif
#ifdef INDICATOR_CUTOUT
out highp float v_z_offset;
#endif
uniform mat4 u_matrix;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define highp float z_offset
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize highp float z_offset
#ifdef ELEVATED_ROADS
z_offset+=a_road_z_offset;
#endif
float hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);
#ifdef RENDER_SHADOWS
vec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);
#ifdef NORMAL_OFFSET
vec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();
#endif
v_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;
#endif
#ifdef FOG
v_fog_pos=fog_position(a_pos);
#endif
#ifdef INDICATOR_CUTOUT
v_z_offset=z_offset;
#endif
}`), fillOutline: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
#include "_prelude_shadow.fragment.glsl"
in highp vec2 v_pos;uniform float u_emissive_strength;
#ifdef RENDER_SHADOWS
uniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;
#endif
#pragma mapbox: define highp vec4 outline_color
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 outline_color
#pragma mapbox: initialize lowp float opacity
float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;
#ifdef LIGHTING_3D_MODE
out_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);
#ifdef RENDER_SHADOWS
float light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);
#endif
#endif
#ifdef FOG
out_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));
#endif
glFragColor=out_color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
#include "_prelude_shadow.vertex.glsl"
in vec2 a_pos;
#ifdef ELEVATED_ROADS
in float a_road_z_offset;
#endif
#ifdef RENDER_SHADOWS
uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;
#endif
uniform mat4 u_matrix;uniform vec2 u_world;out highp vec2 v_pos;
#pragma mapbox: define highp vec4 outline_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define highp float z_offset
void main() {
#pragma mapbox: initialize highp vec4 outline_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize highp float z_offset
#ifdef ELEVATED_ROADS
z_offset+=a_road_z_offset;
#endif
float hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;
#ifdef RENDER_SHADOWS
vec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);
#ifdef NORMAL_OFFSET
vec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();
#endif
v_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;
#endif
#ifdef FOG
v_fog_pos=fog_position(a_pos);
#endif
}`), fillOutlinePattern: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
#include "_prelude_shadow.fragment.glsl"
uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_emissive_strength;
#ifdef RENDER_SHADOWS
uniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;
#endif
in highp vec2 v_pos;in highp vec2 v_pos_world;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern
vec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);
#ifdef LIGHTING_3D_MODE
out_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);
#ifdef RENDER_SHADOWS
float light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);
#endif
#endif
#ifdef FOG
out_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));
#endif
glFragColor=out_color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
#include "_prelude_shadow.vertex.glsl"
uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;
#ifdef ELEVATED_ROADS
in float a_road_z_offset;
#endif
#ifdef RENDER_SHADOWS
uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;
#endif
out highp vec2 v_pos;out highp vec2 v_pos_world;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern
#pragma mapbox: define lowp float pixel_ratio
#pragma mapbox: define highp float z_offset
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern
#pragma mapbox: initialize lowp float pixel_ratio
#pragma mapbox: initialize highp float z_offset
vec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;
#ifdef ELEVATED_ROADS
z_offset+=a_road_z_offset;
#endif
float hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);v_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;
#ifdef RENDER_SHADOWS
vec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);
#ifdef NORMAL_OFFSET
vec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();
#endif
v_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;
#endif
#ifdef FOG
v_fog_pos=fog_position(a_pos);
#endif
}`), fillPattern: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
#include "_prelude_shadow.fragment.glsl"
uniform vec2 u_texsize;uniform sampler2D u_image;in highp vec2 v_pos;uniform float u_emissive_strength;
#ifdef RENDER_SHADOWS
uniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;
#endif
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern
vec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);
#ifdef LIGHTING_3D_MODE
out_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);
#ifdef RENDER_SHADOWS
float light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);
#endif
#endif
#ifdef FOG
out_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));
#endif
glFragColor=out_color*opacity;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
#include "_prelude_shadow.vertex.glsl"
uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;
#ifdef ELEVATED_ROADS
in float a_road_z_offset;
#endif
#ifdef RENDER_SHADOWS
uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;
#endif
out highp vec2 v_pos;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern
#pragma mapbox: define lowp float pixel_ratio
#pragma mapbox: define highp float z_offset
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern
#pragma mapbox: initialize lowp float pixel_ratio
#pragma mapbox: initialize highp float z_offset
vec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;
#ifdef ELEVATED_ROADS
z_offset+=a_road_z_offset;
#endif
float hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);
#ifdef RENDER_SHADOWS
vec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);
#ifdef NORMAL_OFFSET
vec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();
#endif
v_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;
#endif
#ifdef FOG
v_fog_pos=fog_position(a_pos);
#endif
}`), fillExtrusion: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_shadow.fragment.glsl"
#include "_prelude_lighting.glsl"
in vec4 v_color;in vec4 v_flat;
#ifdef RENDER_SHADOWS
in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;
#endif
uniform lowp float u_opacity;
#ifdef FAUX_AO
uniform lowp vec2 u_ao;in vec2 v_ao;
#endif
#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)
in vec4 v_roof_color;
#endif
#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)
in highp vec3 v_normal;
#endif
uniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;
#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)
in float v_flood_radius;in float v_has_floodlight;
#endif
in float v_height;
#pragma mapbox: define highp float emissive_strength
void main() {
#pragma mapbox: initialize highp float emissive_strength
#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)
vec3 normal=normalize(v_normal);
#endif
float z;vec4 color=v_color;
#ifdef ZERO_ROOF_RADIUS
z=float(normal.z > 0.00001);
#ifdef LIGHTING_3D_MODE
normal=mix(normal,vec3(0.0,0.0,1.0),z);
#else
color=mix(v_color,v_roof_color,z);
#endif
#endif
float h=max(0.0,v_height);float ao_shade=1.0;
#ifdef FAUX_AO
float intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;
#ifdef ZERO_ROOF_RADIUS
concave*=(1.0-z);
#endif
float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);
#ifdef LIGHTING_3D_MODE
#ifdef FLOOD_LIGHT
color.rgb*=mix(ao_shade,1.0,v_has_floodlight);
#else
color.rgb*=ao_shade;
#endif
#else
color.rgb*=ao_shade;
#endif
#endif
#ifdef LIGHTING_3D_MODE
float flood_radiance=0.0;
#ifdef FLOOD_LIGHT
flood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;
#endif
#ifdef RENDER_SHADOWS
#ifdef FLOOD_LIGHT
float ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);
#else
float shadowed_lighting_factor;
#ifdef RENDER_CUTOFF
shadowed_lighting_factor=shadowed_light_factor_normal_opacity(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}
#else
shadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);
#endif
color.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);
#endif
#else
color.rgb=apply_lighting(color.rgb,normal);
#ifdef FLOOD_LIGHT
color.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);
#endif
#endif
color.rgb=mix(color.rgb,v_flat.rgb,emissive_strength);color*=u_opacity;
#endif
#ifdef FOG
color=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));
#endif
#ifdef INDICATOR_CUTOUT
color=applyCutout(color,h);
#endif
glFragColor=color;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
#include "_prelude_terrain.vertex.glsl"
#include "_prelude_shadow.vertex.glsl"
#include "_prelude_lighting.glsl"
uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;uniform float u_width_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;
#ifdef RENDER_WALL_MODE
in vec3 a_join_normal_inside;
#endif
#ifdef PROJECTION_GLOBE_VIEW
in vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;
#endif
#ifdef TERRAIN
uniform int u_height_type;uniform int u_base_type;
#endif
uniform highp float u_vertical_scale;out vec4 v_color;out vec4 v_flat;
#ifdef RENDER_SHADOWS
uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;
#endif
#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)
out vec4 v_roof_color;
#endif
#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)
out highp vec3 v_normal;
#endif
#ifdef FAUX_AO
uniform lowp vec2 u_ao;out vec2 v_ao;
#endif
#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)
out float v_flood_radius;out float v_has_floodlight;
#endif
out float v_height;vec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}
#pragma mapbox: define highp float base
#pragma mapbox: define highp float height
#pragma mapbox: define highp vec4 color
#pragma mapbox: define highp float flood_light_wall_radius
#pragma mapbox: define highp float line_width
#pragma mapbox: define highp float emissive_strength
void main() {
#pragma mapbox: initialize highp float base
#pragma mapbox: initialize highp float height
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize highp float flood_light_wall_radius
#pragma mapbox: initialize highp float line_width
#pragma mapbox: initialize highp float emissive_strength
base*=u_vertical_scale;height*=u_vertical_scale;vec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));
#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)
v_normal=normal;
#endif
base=max(0.0,base);float attr_height=height;height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);
#if defined(HAS_CENTROID) || defined(TERRAIN)
centroid_pos=a_centroid_pos;
#endif
float ele=0.0;float h=0.0;float c_ele=0.0;vec3 pos;
#ifdef TERRAIN
bool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);
#else
h=t > 0.0 ? height : base;pos=vec3(pos_nx.xy,h);
#endif
#ifdef PROJECTION_GLOBE_VIEW
float lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);
#endif
float cutoff=1.0;vec3 scaled_pos=pos;
#ifdef RENDER_CUTOFF
vec3 centroid_random=vec3(centroid_pos.xy,centroid_pos.x+centroid_pos.y+1.0);vec3 ground_pos=centroid_pos.x==0.0 ? pos.xyz : (centroid_random/8.0);vec4 ground=u_matrix*vec4(ground_pos.xy,ele,1.0);cutoff=cutoff_opacity(u_cutoff_params,ground.z);if (centroid_pos.y !=0.0 && centroid_pos.x !=0.0) {vec3 g=floor(ground_pos);vec3 mod_=centroid_random-g*8.0;float seed=min(1.0,0.1*(min(3.5,max(mod_.x+mod_.y,0.2*attr_height))*0.35+mod_.z));if (cutoff < 0.8-seed) {cutoff=0.0;}}float cutoff_scale=cutoff;v_cutoff_opacity=cutoff;scaled_pos.z=mix(c_ele,h,cutoff_scale);
#endif
float hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (cutoff==0.0 && centroid_pos.x !=0.0) || (color.a==0.0));
#ifdef RENDER_WALL_MODE
vec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);scaled_pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;scaled_pos.xy-=a_join_normal_inside.z*wall_offset*0.5;
#endif
gl_Position=mix(u_matrix*vec4(scaled_pos,1),AWAY,hidden);h=h-ele;v_height=h;
#ifdef RENDER_SHADOWS
vec3 shd_pos0=pos;vec3 shd_pos1=pos;
#ifdef NORMAL_OFFSET
vec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();
#endif
v_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);
#endif
float NdotL=0.0;float colorvalue=0.0;
#ifndef LIGHTING_3D_MODE
colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(
(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}
#endif
#ifdef FAUX_AO
float concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;
#ifdef TERRAIN
top_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);
#endif
v_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);
#ifdef PROJECTION_GLOBE_VIEW
top_height+=u_height_lift;
#endif
gl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;
#endif
#ifdef LIGHTING_3D_MODE
#ifdef FLOOD_LIGHT
float is_wall=1.0-float(t > 0.0 && top_up_ny.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;
#endif
v_color=vec4(color.rgb,1.0);float ndotl=calculate_NdotL(normal);v_flat.rgb=sRGBToLinear(color.rgb);v_flat.rgb=v_flat.rgb*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);v_flat=vec4(linearTosRGB(v_flat.rgb),1.0);
#else
v_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;
#endif
#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)
float roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;
#endif
#ifdef FOG
v_fog_pos=fog_position(pos);
#endif
}`), fillExtrusionDepth: ca(`in highp float v_depth;void main() {
#ifndef DEPTH_TEXTURE
glFragColor=pack_depth(v_depth);
#endif
}`, `#include "_prelude_terrain.vertex.glsl"
uniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_width_scale;uniform float u_vertical_scale;
#ifdef TERRAIN
uniform int u_height_type;uniform int u_base_type;
#endif
in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;
#ifdef RENDER_WALL_MODE
in vec3 a_join_normal_inside;
#endif
#pragma mapbox: define highp float base
#pragma mapbox: define highp float height
#pragma mapbox: define highp float line_width
#pragma mapbox: define highp vec4 color
out highp float v_depth;void main() {
#pragma mapbox: initialize highp float base
#pragma mapbox: initialize highp float height
#pragma mapbox: initialize highp float line_width
#pragma mapbox: initialize highp vec4 color
base*=u_vertical_scale;height*=u_vertical_scale;vec3 pos_nx=floor(a_pos_normal_ed.xyz*0.5);mediump vec3 top_up_ny=a_pos_normal_ed.xyz-2.0*pos_nx;base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);
#if defined(HAS_CENTROID) || defined(TERRAIN)
centroid_pos=a_centroid_pos;
#endif
vec3 pos;
#ifdef TERRAIN
bool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;float ele=elevation(pos_nx.xy);float c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);float h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);
#else
pos=vec3(pos_nx.xy,t > 0.0 ? height : base);
#endif
#ifdef RENDER_WALL_MODE
vec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;pos.xy-=a_join_normal_inside.z*wall_offset*0.5;
#endif
float hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);v_depth=gl_Position.z/gl_Position.w;}`), fillExtrusionPattern: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
uniform vec2 u_texsize;uniform sampler2D u_image;
#ifdef FAUX_AO
uniform lowp vec2 u_ao;in vec3 v_ao;
#endif
#ifdef LIGHTING_3D_MODE
in vec3 v_normal;
#endif
in highp vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;
#pragma mapbox: define highp float base
#pragma mapbox: define highp float height
#pragma mapbox: define mediump vec4 pattern
#pragma mapbox: define highp float pixel_ratio
void main() {
#pragma mapbox: initialize highp float base
#pragma mapbox: initialize highp float height
#pragma mapbox: initialize mediump vec4 pattern
#pragma mapbox: initialize highp float pixel_ratio
vec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);
#ifdef LIGHTING_3D_MODE
out_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;
#else
out_color=out_color*v_lighting;
#endif
#ifdef FAUX_AO
float intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;
#endif
#ifdef FOG
out_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));
#endif
#ifdef INDICATOR_CUTOUT
out_color=applyCutout(out_color,height);
#endif
glFragColor=out_color;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
#include "_prelude_terrain.vertex.glsl"
#include "_prelude_lighting.glsl"
uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_width_scale;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;
#ifdef RENDER_WALL_MODE
in vec3 a_join_normal_inside;
#endif
#ifdef PROJECTION_GLOBE_VIEW
in vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;
#endif
#ifdef TERRAIN
uniform int u_height_type;uniform int u_base_type;
#endif
out highp vec2 v_pos;out vec4 v_lighting;
#ifdef FAUX_AO
uniform lowp vec2 u_ao;out vec3 v_ao;
#endif
#ifdef LIGHTING_3D_MODE
out vec3 v_normal;
#endif
#pragma mapbox: define highp float base
#pragma mapbox: define highp float height
#pragma mapbox: define highp vec4 color
#pragma mapbox: define mediump vec4 pattern
#pragma mapbox: define highp float pixel_ratio
#pragma mapbox: define highp float line_width
void main() {
#pragma mapbox: initialize highp float base
#pragma mapbox: initialize highp float height
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize mediump vec4 pattern
#pragma mapbox: initialize highp float pixel_ratio
#pragma mapbox: initialize highp float line_width
vec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);
#if defined(HAS_CENTROID) || defined(TERRAIN)
centroid_pos=a_centroid_pos;
#endif
float ele=0.0;float h=z;vec3 p;float c_ele;
#ifdef TERRAIN
bool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;p=vec3(pos_nx.xy,h);
#else
p=vec3(pos_nx.xy,z);
#endif
#ifdef PROJECTION_GLOBE_VIEW
float lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);
#endif
#ifdef RENDER_WALL_MODE
vec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);p.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;p.xy-=a_join_normal_inside.z*wall_offset*0.5;
#endif
float hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0
? pos_nx.xy
: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;
#ifdef LIGHTING_3D_MODE
NdotL=calculate_NdotL(normal);
#else
NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);
#endif
if (normal.y !=0.0) {float r=0.84;
#ifndef LIGHTING_3D_MODE
r=mix(0.7,0.98,1.0-u_lightintensity);
#endif
NdotL*=(
(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}
#ifdef FAUX_AO
float concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;
#ifdef TERRAIN
top_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);
#endif
v_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);
#ifdef PROJECTION_GLOBE_VIEW
top_height+=u_height_lift;
#endif
gl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;
#endif
#ifdef LIGHTING_3D_MODE
v_normal=normal;
#else
v_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;
#endif 
#ifdef FOG
v_fog_pos=fog_position(p);
#endif
}`), groundShadow: ca(`#include "_prelude_shadow.fragment.glsl"
precision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;
#ifdef FOG
in float v_fog_opacity;
#endif
void main() {float light=shadowed_light_factor_plane_bias(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);
#ifdef RENDER_CUTOFF
shadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w));
#endif
#ifdef FOG
shadow=mix(shadow,vec3(1.0),v_fog_opacity);
#endif
#ifdef INDICATOR_CUTOUT
shadow=mix(shadow,vec3(1.0),1.0-applyCutout(vec4(1.0),0.0).r);
#endif
glFragColor=vec4(shadow,1.0);}`, `#include "_prelude_fog.vertex.glsl"
uniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in vec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;
#ifdef FOG
out float v_fog_opacity;
#endif
void main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);
#ifdef FOG
v_fog_pos=fog_position(a_pos);v_fog_opacity=fog(v_fog_pos);
#endif
}`), fillExtrusionGroundEffect: ca(`uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;
#ifdef SDF_SUBPASS
in highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}
#ifdef FOG
in highp float v_fog;
#endif
#endif
void main() {
#ifdef CLEAR_SUBPASS
vec4 color=vec4(1.0);
#ifdef CLEAR_FROM_TEXTURE
color=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));
#endif
glFragColor=color;
#else
#ifdef SDF_SUBPASS
highp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;
#ifdef FOG
fog=v_fog;
#endif
#ifdef RENDER_CUTOFF
fog*=v_cutoff_opacity;
#endif
glFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));
#else
vec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);
#ifdef OVERDRAW_INSPECTOR
color=vec4(1.0);
#endif
glFragColor=color;
#endif
HANDLE_WIREFRAME_DEBUG;
#endif
}`, `#include "_prelude_fog.vertex.glsl"
in highp vec4 a_pos_end;in highp float a_angular_offset_factor;in highp float a_hidden_by_landmark;
#ifdef SDF_SUBPASS
out highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;
#ifdef FOG
out highp float v_fog;
#endif
#endif
uniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp float u_dynamic_offset;uniform highp vec2 u_ao;
#pragma mapbox: define highp float flood_light_ground_radius
const float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {
#pragma mapbox: initialize highp float flood_light_ground_radius
vec2 p=a_pos_end.xy;vec2 q=floor(a_pos_end.zw*0.5);vec2 start_bottom=a_pos_end.zw-q*2.0;float fl_ground_radius=flood_light_ground_radius;fl_ground_radius=abs(flood_light_ground_radius);float direction=flood_light_ground_radius < 0.0 ?-1.0 : 1.0;float flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=a_angular_offset_factor/NORM*TANGENT_CUTOFF;float angular_offset=direction*angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(u_dynamic_offset,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=direction*perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;
#ifdef SDF_SUBPASS
v_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);
#ifdef FOG
v_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);
#endif
#endif
float hidden_by_landmark=0.0;
#ifdef HAS_CENTROID
hidden_by_landmark=a_hidden_by_landmark;
#endif
float isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));
#ifdef RENDER_CUTOFF
v_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);
#endif
}`), hillshadePrepare: ca(`precision highp float;uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(
(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)
)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(
deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}`, "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"), hillshade: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;
#ifdef LIGHTING_3D_MODE
glFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);
#endif
#ifdef FOG
glFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));
#endif
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
uniform mat4 u_matrix;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;
#ifdef FOG
v_fog_pos=fog_position(a_pos);
#endif
}`), line: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
#include "_prelude_shadow.fragment.glsl"
uniform lowp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_floor_width_scale;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec4 v_uv;
#ifdef ELEVATED_ROADS
in highp float v_road_z_offset;
#endif
#ifdef RENDER_LINE_DASH
uniform sampler2D u_dash_image;in vec2 v_tex;
#endif
#ifdef RENDER_LINE_GRADIENT
uniform sampler2D u_gradient_image;
#endif
#ifdef INDICATOR_CUTOUT
in highp float v_z_offset;
#endif
#ifdef RENDER_SHADOWS
uniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;
#endif
float luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}uniform float u_emissive_strength;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float floorwidth
#pragma mapbox: define lowp vec4 dash
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float border_width
#pragma mapbox: define lowp vec4 border_color
float linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float floorwidth
#pragma mapbox: initialize lowp vec4 dash
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float border_width
#pragma mapbox: initialize lowp vec4 border_color
float dist=length(v_normal)*v_width2.s;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);
#ifdef RENDER_LINE_DASH
float sdfdist=texture(u_dash_image,v_tex).r;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/dash.z;float scaled_floorwidth=(floorwidth*u_floor_width_scale);alpha*=linearstep(0.5-sdfgamma/scaled_floorwidth,0.5+sdfgamma/scaled_floorwidth,sdfdist);
#endif
highp vec4 out_color;
#ifdef RENDER_LINE_GRADIENT
out_color=texture(u_gradient_image,v_uv.xy);
#else
out_color=color;
#endif
float trim_alpha=1.0;
#ifdef RENDER_LINE_TRIM_OFFSET
highp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);out_color=mix(out_color,u_trim_color,transition_factor);trim_alpha=1.0-transition_factor;}
#endif
if (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}
#ifdef RENDER_LINE_BORDER
float edgeBlur=((border_width*u_width_scale)+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2.t-edgeBlur),v_width2.s-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);if (border_color.a==0.0) {float Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}} else {out_color=mix(border_color*trim_alpha,out_color,smoothAlpha);}}
#endif
#ifdef LIGHTING_3D_MODE
out_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);
#ifdef RENDER_SHADOWS
float light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);
#ifdef ELEVATED_ROADS
out_color.rgb*=mix(v_road_z_offset > 0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);
#else
out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);
#endif
#endif
#endif
#ifdef FOG
out_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));
#endif
out_color*=(alpha*opacity);
#ifdef INDICATOR_CUTOUT
out_color=applyCutout(out_color,v_z_offset);
#endif
glFragColor=out_color;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
#include "_prelude_shadow.vertex.glsl"
#include "_prelude_terrain.vertex.glsl"
#define EXTRUDE_SCALE 0.015873016
in vec2 a_pos_normal;in vec4 a_data;
#if defined(ELEVATED) || defined(ELEVATED_ROADS) || defined(VARIABLE_LINE_WIDTH)
in vec2 a_z_offset_width;
#endif
#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)
in highp vec4 a_packed;
#endif
#ifdef RENDER_LINE_DASH
in float a_linesofar;
#endif
uniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;uniform float u_width_scale;uniform highp float u_floor_width_scale;
#ifdef ELEVATED
uniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {
#ifdef ELEVATION_REFERENCE_SEA
return 0.0;
#else
return elevation(apos);
#endif
}
#endif
out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec4 v_uv;
#ifdef ELEVATED_ROADS
out highp float v_road_z_offset;
#endif
#ifdef RENDER_LINE_DASH
uniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out vec2 v_tex;
#endif
#ifdef RENDER_LINE_GRADIENT
uniform float u_image_height;
#endif
#ifdef INDICATOR_CUTOUT
out highp float v_z_offset;
#endif
#ifdef RENDER_SHADOWS
uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;
#endif
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float floorwidth
#pragma mapbox: define lowp vec4 dash
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define lowp float offset
#pragma mapbox: define mediump float width
#pragma mapbox: define lowp float border_width
#pragma mapbox: define lowp vec4 border_color
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float floorwidth
#pragma mapbox: initialize lowp vec4 dash
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize lowp float offset
#pragma mapbox: initialize mediump float width
#pragma mapbox: initialize lowp float border_width
#pragma mapbox: initialize lowp vec4 border_color
float a_z_offset;
#if defined(ELEVATED) || defined(ELEVATED_ROADS)
a_z_offset=a_z_offset_width.x;
#endif
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth;
#ifdef VARIABLE_LINE_WIDTH
halfwidth=(u_width_scale*a_z_offset_width.y)/2.0;
#else
halfwidth=(u_width_scale*width)/2.0;
#endif
offset=-1.0*offset*u_width_scale;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;
#ifdef ELEVATED_ROADS
v_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset+0.01*step(0.01,a_z_offset),1.0)+projected_extrude;
#else
#ifdef ELEVATED
vec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;
#ifdef CROSS_SLOPE_VERTICAL
float top=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+a_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);
#else
#ifdef CROSS_SLOPE_HORIZONTAL
float ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+a_z_offset;
#else
float ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+a_z_offset;
#endif
#endif
gl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);
#else
gl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);
#endif
#endif
#ifdef ELEVATED_ROADS
#ifdef RENDER_SHADOWS
vec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;
#ifdef NORMAL_OFFSET
vec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();
#endif
v_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;
#endif
#endif
#ifndef RENDER_TO_TEXTURE
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude_xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));
#else
v_gamma_scale=1.0;
#endif
#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)
float a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];
#ifdef RENDER_LINE_GRADIENT
highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec4(a_uv_x,a_split_index*texel_height-half_texel_height,a_clip_start,a_clip_end);
#else
v_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);
#endif
#endif
#ifdef RENDER_LINE_DASH
float scale=dash.z==0.0 ? 0.0 : u_tile_units_to_pixels/dash.z;float height=dash.y;v_tex=vec2(a_linesofar*scale/(floorwidth*u_floor_width_scale),(-normal.y*height+dash.x+0.5)/u_texsize.y);
#endif
v_width2=vec2(outset,inset);
#ifdef FOG
v_fog_pos=fog_position(pos);
#endif
#ifdef INDICATOR_CUTOUT
v_z_offset=a_z_offset;
#endif
}`), linePattern: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
#include "_prelude_shadow.fragment.glsl"
uniform highp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_alpha_discard_threshold;uniform highp vec2 u_texsize;uniform highp float u_tile_units_to_pixels;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in highp float v_linesofar;in float v_gamma_scale;in float v_width;
#ifdef RENDER_LINE_TRIM_OFFSET
in highp vec4 v_uv;
#endif
#ifdef ELEVATED_ROADS
in highp float v_road_z_offset;
#endif
#ifdef LINE_JOIN_NONE
in vec2 v_pattern_data;
#endif
#ifdef INDICATOR_CUTOUT
in highp float v_z_offset;
#endif
#ifdef RENDER_SHADOWS
uniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;
#endif
uniform float u_emissive_strength;
#pragma mapbox: define mediump vec4 pattern
#pragma mapbox: define mediump float pixel_ratio
#pragma mapbox: define mediump float blur
#pragma mapbox: define mediump float opacity
void main() {
#pragma mapbox: initialize mediump vec4 pattern
#pragma mapbox: initialize mediump float pixel_ratio
#pragma mapbox: initialize mediump float blur
#pragma mapbox: initialize mediump float opacity
vec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;highp float pattern_size=display_size.x/u_tile_units_to_pixels;float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);highp float pattern_x=v_linesofar/pattern_size*aspect;highp float x=mod(pattern_x,1.0);highp float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;highp vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));highp vec2 lod_pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(pattern_x,y));vec4 color=textureLodCustom(u_image,pos,lod_pos);
#ifdef RENDER_LINE_TRIM_OFFSET
highp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);color=mix(color,color.a*u_trim_color,transition_factor);}
#endif
#ifdef LINE_JOIN_NONE
highp float pattern_len=pattern_size/aspect;highp float segment_phase=pattern_len-mod(v_linesofar-v_pattern_data.x+pattern_len,pattern_len);highp float visible_start=segment_phase-step(pattern_len*0.5,segment_phase)*pattern_len;highp float visible_end=floor((v_pattern_data.y-segment_phase)/pattern_len)*pattern_len+segment_phase;visible_end+=step(pattern_len*0.5,v_pattern_data.y-visible_end)*pattern_len;if (v_pattern_data.x < visible_start || v_pattern_data.x >=visible_end) {color=vec4(0.0);}
#endif
#ifdef LIGHTING_3D_MODE
color=apply_lighting_with_emission_ground(color,u_emissive_strength);
#ifdef RENDER_SHADOWS
float light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);
#ifdef ELEVATED_ROADS
color.rgb*=mix(v_road_z_offset > 0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);
#else
color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);
#endif
#endif
#endif
#ifdef FOG
color=fog_dither(fog_apply_premultiplied(color,v_fog_pos));
#endif
color*=(alpha*opacity);if (u_alpha_discard_threshold !=0.0) {if (color.a < u_alpha_discard_threshold) {discard;}}
#ifdef INDICATOR_CUTOUT
color=applyCutout(color,v_z_offset);
#endif
glFragColor=color;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
#include "_prelude_shadow.vertex.glsl"
#include "_prelude_terrain.vertex.glsl"
#define scale 0.015873016
in vec2 a_pos_normal;in vec4 a_data;
#if defined(ELEVATED) || defined(ELEVATED_ROADS)
in vec2 a_z_offset_width;
#endif
#ifdef RENDER_LINE_TRIM_OFFSET
in highp vec4 a_packed;
#endif
in highp float a_linesofar;
#ifdef LINE_JOIN_NONE
in highp vec3 a_pattern_data;out vec2 v_pattern_data;
#endif
#ifdef INDICATOR_CUTOUT
out highp float v_z_offset;
#endif
uniform mat4 u_matrix;uniform float u_tile_units_to_pixels;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform float u_device_pixel_ratio;uniform float u_width_scale;uniform float u_floor_width_scale;
#ifdef ELEVATED
uniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {
#ifdef ELEVATION_REFERENCE_SEA
return 0.0;
#else
return elevation(apos);
#endif
}
#endif
out vec2 v_normal;out vec2 v_width2;out highp float v_linesofar;out float v_gamma_scale;out float v_width;
#ifdef RENDER_LINE_TRIM_OFFSET
out highp vec4 v_uv;
#endif
#ifdef ELEVATED_ROADS
out highp float v_road_z_offset;
#endif
#ifdef RENDER_SHADOWS
uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;
#endif
#pragma mapbox: define mediump float blur
#pragma mapbox: define mediump float opacity
#pragma mapbox: define mediump float offset
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define mediump float width
#pragma mapbox: define mediump float floorwidth
#pragma mapbox: define mediump vec4 pattern
#pragma mapbox: define mediump float pixel_ratio
void main() {
#pragma mapbox: initialize mediump float blur
#pragma mapbox: initialize mediump float opacity
#pragma mapbox: initialize mediump float offset
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize mediump float width
#pragma mapbox: initialize mediump float floorwidth
#pragma mapbox: initialize mediump vec4 pattern
#pragma mapbox: initialize mediump float pixel_ratio
float a_z_offset;
#if defined(ELEVATED) || defined(ELEVATED_ROADS)
a_z_offset=a_z_offset_width.x;
#endif
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=(u_width_scale*width)/2.0;offset=-1.0*offset*u_width_scale;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);vec2 dist=outset*a_extrude*scale;float u=0.5*a_direction;float t=1.0-abs(u);vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;
#ifdef ELEVATED_ROADS
v_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset+0.01*step(0.01,a_z_offset),1.0)+projected_extrude;
#else
#ifdef ELEVATED
vec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;
#ifdef CROSS_SLOPE_VERTICAL
float top=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+a_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);
#else
#ifdef CROSS_SLOPE_HORIZONTAL
float ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+a_z_offset;
#else
float ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+a_z_offset;
#endif
#endif
gl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);
#else
gl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);
#endif
#endif
#ifdef ELEVATED_ROADS
#ifdef RENDER_SHADOWS
vec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;
#ifdef NORMAL_OFFSET
vec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();
#endif
v_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;
#endif
#endif
#ifndef RENDER_TO_TEXTURE
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude_xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));
#else
v_gamma_scale=1.0;
#endif
#ifdef RENDER_LINE_TRIM_OFFSET
float a_uv_x=a_packed[0];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];v_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);
#endif
v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=(floorwidth*u_floor_width_scale);
#ifdef LINE_JOIN_NONE
v_width=(floorwidth*u_floor_width_scale)+ANTIALIASING;mediump float pixels_to_tile_units=1.0/u_tile_units_to_pixels;mediump float pixel_ratio_inverse=1.0/pixel_ratio;mediump float aspect=v_width/((pattern.w-pattern.y)*pixel_ratio_inverse);highp float subt_multiple=(pattern.z-pattern.x)*pixel_ratio_inverse*pixels_to_tile_units*aspect*32.0;highp float subt=floor(a_pattern_data.z/subt_multiple)*subt_multiple;float offset_sign=(fract(a_pattern_data.x)-0.5)*4.0;float line_progress_offset=offset_sign*v_width*0.5*pixels_to_tile_units;v_linesofar=(a_pattern_data.z-subt)+a_linesofar+line_progress_offset;v_pattern_data=vec2(a_pattern_data.x+line_progress_offset,a_pattern_data.y);
#endif
#ifdef FOG
v_fog_pos=fog_position(pos);
#endif
#ifdef INDICATOR_CUTOUT
v_z_offset=a_z_offset;
#endif
}`), raster: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
#include "_prelude_raster_array.glsl"
uniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;uniform highp float u_zoom_transition;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;
#ifdef PROJECTION_GLOBE_VIEW
in float v_split_fade;
#endif
uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;
#ifndef RASTER_ARRAY
uniform highp sampler2D u_image0;uniform sampler2D u_image1;
#endif
#ifdef RASTER_COLOR
uniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;
#endif
void main() {vec4 color0,color1,color;vec2 value;
#ifdef RASTER_COLOR
#ifdef RASTER_ARRAY
#ifdef RASTER_ARRAY_LINEAR
value=mix(
raTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t
);
#else
value=mix(
raTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t
);
#endif
if (value.y > 0.0) value.x/=value.y;
#else
color=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);
#endif
color=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;
#else
color0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);
#endif
color.a*=u_opacity;
#ifdef GLOBE_POLES
color.a*=1.0-smoothstep(0.0,0.05,u_zoom_transition);
#endif
vec3 rgb=color.rgb;rgb=vec3(
dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);
#ifdef LIGHTING_3D_MODE
out_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;
#endif
#ifdef FOG
highp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));
#endif
glFragColor=vec4(out_color*color.a,color.a);
#ifdef PROJECTION_GLOBE_VIEW
glFragColor*=mix(1.0,1.0-smoothstep(0.0,0.05,u_zoom_transition),smoothstep(0.8,0.9,v_split_fade));
#endif
#ifdef RENDER_CUTOFF
glFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);
#endif
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
uniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;
#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8
#ifdef GLOBE_POLES
in vec3 a_globe_pos;in vec2 a_uv;
#else
in vec2 a_pos;in vec2 a_texture_pos;
#endif
out vec2 v_pos0;out vec2 v_pos1;out float v_depth;
#ifdef PROJECTION_GLOBE_VIEW
out float v_split_fade;
#endif
void main() {vec2 uv;
#ifdef GLOBE_POLES
vec3 globe_pos=a_globe_pos;globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos   ,1.0);uv=a_uv;
#ifdef FOG
v_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);
#endif
#else
float w=1.0+dot(a_texture_pos,u_perspective_transform);uv=a_texture_pos/8192.0;
#ifdef PROJECTION_GLOBE_VIEW
vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);    
v_split_fade=0.0;if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;float opposite_merc_center=mod(u_merc_center.x+0.5,1.0);float dist_from_poles=(abs(mercatorY-0.5)*2.0);float range=0.1;v_split_fade=abs(opposite_merc_center-mercatorX);v_split_fade=clamp(1.0-v_split_fade,0.0,1.0);v_split_fade=max(smoothstep(1.0-range,1.0,dist_from_poles),max(smoothstep(1.0-range,1.0,v_split_fade),smoothstep(1.0-range,1.0,1.0-v_split_fade)));}float tiles=u_grid_matrix[0][2];if (tiles > 0.0) {float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvY=mercatorY*tiles-idy;float uvX=mercatorX*tiles-idx;uv=vec2(uvX,uvY);}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;
#ifdef FOG
v_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);
#endif
#else
gl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);
#ifdef FOG
v_fog_pos=fog_position(a_pos);
#endif
#endif
#endif
v_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;
#ifdef RENDER_CUTOFF
v_depth=gl_Position.z;
#endif
}`), rasterParticle: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
uniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;uniform sampler2D u_image0;uniform sampler2D u_image1;void main() {vec4 color0,color1,color;color0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 out_color=color.rgb;
#ifdef LIGHTING_3D_MODE
out_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),0.0).rgb;
#endif
#ifdef FOG
highp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));
#endif
glFragColor=vec4(out_color*color.a,color.a);
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
uniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;
#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8
in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {float w=1.0;vec2 uv;
#ifdef PROJECTION_GLOBE_VIEW
vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);float tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvX=mercatorX*tiles-idx;float uvY=mercatorY*tiles-idy;uv=vec2(uvX,uvY);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;
#ifdef FOG
v_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);
#endif
#else
uv=a_texture_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);
#ifdef FOG
v_fog_pos=fog_position(a_pos);
#endif
#endif
v_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}`), rasterParticleDraw: ca("uniform sampler2D u_color_ramp;in float v_particle_speed;void main() {glFragColor=texture(u_color_ramp,vec2(v_particle_speed,0.5));}", `#include "_prelude_raster_particle.glsl"
in float a_index;uniform sampler2D u_particle_texture;uniform float u_particle_texture_side_len;uniform vec2 u_tile_offset;out float v_particle_speed;void main() {ivec2 pixel_coord=ivec2(
mod(a_index,u_particle_texture_side_len),a_index/u_particle_texture_side_len);vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);vec2 pos=unpack_pos_from_rgba(pixel)+u_tile_offset;vec2 tex_coord=fract(pos);vec2 velocity=lookup_velocity(tex_coord);if (velocity==INVALID_VELOCITY) {gl_Position=AWAY;v_particle_speed=0.0;} else {gl_Position=vec4(2.0*pos-1.0,0,1);v_particle_speed=length(velocity);}gl_PointSize=1.0;}`), rasterParticleTexture: ca("uniform sampler2D u_texture;uniform float u_opacity;in vec2 v_tex_pos;void main() {vec4 color=texture(u_texture,v_tex_pos);glFragColor=vec4(floor(255.0*color*u_opacity)/255.0);}", "in vec2 a_pos;out vec2 v_tex_pos;void main() {vec2 uv=0.5*a_pos+vec2(0.5);v_tex_pos=uv;gl_Position=vec4(a_pos,0.0,1.0);}"), rasterParticleUpdate: ca(`#include "_prelude_raster_particle.glsl"
uniform sampler2D u_particle_texture;uniform mediump float u_particle_texture_side_len;uniform mediump float u_speed_factor;uniform highp float u_reset_rate;uniform highp float u_rand_seed;in highp vec2 v_tex_coord;vec2 linearstep(vec2 edge0,vec2 edge1,vec2 x) {return  clamp((x-edge0)/(edge1-edge0),vec2(0),vec2(1));}const highp vec3 rand_constants=vec3(12.9898,78.233,4375.85453);highp float rand(const highp vec2 co) {highp float t=dot(rand_constants.xy,co);return fract(sin(t)*(rand_constants.z+t));}void main() {ivec2 pixel_coord=ivec2(v_tex_coord*u_particle_texture_side_len);highp vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);highp vec2 pos=unpack_pos_from_rgba(pixel);highp vec2 velocity=lookup_velocity(clamp(pos,0.0,1.0));highp vec2 dp=velocity==INVALID_VELOCITY ? vec2(0) : velocity*u_speed_factor;pos=pos+dp;highp vec2 seed=(pos+v_tex_coord)*u_rand_seed;highp vec2 random_pos=vec2(rand(seed+1.3),rand(seed+2.1));highp vec2 persist_rate=pow(
linearstep(vec2(-u_particle_pos_offset),vec2(0),pos)*linearstep(vec2(1.0+u_particle_pos_offset),vec2(1),pos),vec2(4)
);highp vec2 per_frame_persist=pow(persist_rate,abs(dp)/u_particle_pos_offset);highp float drop_rate=1.0-per_frame_persist.x*per_frame_persist.y;drop_rate=any(greaterThanEqual(abs(pos-0.5),vec2(0.5+u_particle_pos_offset))) ? 1.0 : drop_rate;highp float drop=step(1.0-drop_rate-u_reset_rate,rand(seed));highp vec2 next_pos=mix(pos,random_pos,drop);glFragColor=pack_pos_to_rgba(next_pos);}`, "in vec2 a_pos;out vec2 v_tex_coord;void main() {v_tex_coord=0.5*(a_pos+vec2(1.0));gl_Position=vec4(a_pos,0.0,1.0);}"), symbol: ca(`#include "_prelude_lighting.glsl"
#define SDF_PX 8.0
#define SDF 1.0
#define ICON 0.0
uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_halo;uniform lowp float u_scale_factor;
#ifdef ICON_TRANSITION
uniform float u_icon_transition;
#endif
#ifdef COLOR_ADJUSTMENT
uniform mat4 u_color_adj_mat;
#endif
#ifdef INDICATOR_CUTOUT
in highp float v_z_offset;
#endif
in vec2 v_tex_a;
#ifdef ICON_TRANSITION
in vec2 v_tex_b;
#endif
in float v_draw_halo;in vec3 v_gamma_scale_size_fade_opacity;
#ifdef RENDER_TEXT_AND_SYMBOL
in float is_sdf;in vec2 v_tex_a_icon;
#endif
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
#pragma mapbox: define lowp float emissive_strength
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
#pragma mapbox: initialize lowp float emissive_strength
vec4 out_color;float fade_opacity=v_gamma_scale_size_fade_opacity[2];
#ifdef RENDER_TEXT_AND_SYMBOL
if (is_sdf==ICON) {vec2 tex_icon=v_tex_a_icon;lowp float alpha=opacity*fade_opacity;glFragColor=texture(u_texture_icon,tex_icon)*alpha;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
return;}
#endif
#ifdef RENDER_SDF
float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_gamma_scale_size_fade_opacity.x;float size=v_gamma_scale_size_fade_opacity.y;float fontScale=u_is_text ? size/24.0 : size;out_color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {out_color=halo_color;gamma=(halo_blur*u_scale_factor*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width*u_scale_factor/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,v_tex_a).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);out_color*=alpha;
#else
#ifdef ICON_TRANSITION
vec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b);
#else
out_color=texture(u_texture,v_tex_a);
#endif
#ifdef COLOR_ADJUSTMENT
out_color=u_color_adj_mat*out_color;
#endif
#endif
out_color*=opacity*fade_opacity;
#ifdef LIGHTING_3D_MODE
out_color=apply_lighting_with_emission_ground(out_color,emissive_strength);
#endif
#ifdef INDICATOR_CUTOUT
out_color=applyCutout(out_color,v_z_offset);
#endif
glFragColor=out_color;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_terrain.vertex.glsl"
in vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;
#ifdef Z_OFFSET
in float a_auto_z_offset;
#endif
#ifdef PROJECTION_GLOBE_VIEW
in vec3 a_globe_anchor;in vec3 a_globe_normal;
#endif
#ifdef ICON_TRANSITION
in vec2 a_texb;
#endif
#ifdef OCCLUSION_QUERIES
in float a_occlusion_query_opacity;
#endif
#ifdef INDICATOR_CUTOUT
out highp float v_z_offset;
#endif
uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_elevation_from_sea;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;uniform bool u_is_halo;
#ifdef PROJECTION_GLOBE_VIEW
uniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;
#endif
out vec2 v_tex_a;
#ifdef ICON_TRANSITION
out vec2 v_tex_b;
#endif
out float v_draw_halo;out vec3 v_gamma_scale_size_fade_opacity;
#ifdef RENDER_TEXT_AND_SYMBOL
out float is_sdf;out vec2 v_tex_a_icon;
#endif
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
#pragma mapbox: define lowp float emissive_strength
#pragma mapbox: define lowp float occlusion_opacity
#pragma mapbox: define lowp float z_offset
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
#pragma mapbox: initialize lowp float emissive_strength
#pragma mapbox: initialize lowp float occlusion_opacity
#pragma mapbox: initialize lowp float z_offset
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=u_elevation_from_sea ? z_offset : z_offset+elevation(tile_anchor);
#ifdef Z_OFFSET
e+=a_auto_z_offset;
#endif
vec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;
#ifdef PROJECTION_GLOBE_VIEW
mercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=a_globe_anchor+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;
#else
world_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;
#endif
vec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(
0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;vec2 a;
#ifdef PROJECTION_GLOBE_VIEW
vec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;
#else
offsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;
#endif
vec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;
#ifdef PROJECTION_GLOBE_VIEW
vec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);
#else
projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);
#endif
highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);
#ifdef TERRAIN
#ifdef PITCH_WITH_MAP_TERRAIN
vec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);
#endif
#endif
#ifdef Z_OFFSET
z+=u_pitch_with_map ? a_auto_z_offset+(u_elevation_from_sea ? z_offset : z_offset) : 0.0;
#else
z+=u_pitch_with_map ? (u_elevation_from_sea ? z_offset : z_offset) : 0.0;
#endif
float occlusion_fade=globe_occlusion_fade;float projection_transition_fade=1.0;
#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)
projection_transition_fade=1.0-step(EPSILON,u_zoom_transition);
#endif
vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float out_fade_opacity=interpolated_fade_opacity*projection_transition_fade;
#ifdef DEPTH_OCCLUSION
float depth_occlusion=occlusionFadeMultiSample(projected_point);float depth_occlusion_multplier=mix(occlusion_opacity,1.0,depth_occlusion);out_fade_opacity*=depth_occlusion_multplier;
#endif
#ifdef OCCLUSION_QUERIES
float occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);out_fade_opacity*=occludedFadeMultiplier;
#endif
float alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);
#ifdef PROJECTION_GLOBE_VIEW
vec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);
#else
gl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);
#endif
float gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_gamma_scale_size_fade_opacity=vec3(gamma_scale,size,out_fade_opacity);v_tex_a=a_tex/u_texsize;
#ifdef RENDER_TEXT_AND_SYMBOL
is_sdf=a_size[0]-2.0*a_size_min;v_tex_a_icon=a_tex/u_texsize_icon;
#endif
#ifdef ICON_TRANSITION
v_tex_b=a_texb/u_texsize;
#endif
#ifdef INDICATOR_CUTOUT
v_z_offset=e;
#endif
}`), terrainRaster: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_shadow.fragment.glsl"
#include "_prelude_lighting.glsl"
uniform sampler2D u_image0;in vec2 v_pos0;
#ifdef FOG
in float v_fog_opacity;
#endif
#ifdef RENDER_SHADOWS
in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;
#endif
uniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;
#ifdef LIGHTING_3D_MODE
const vec3 normal=vec3(0.0,0.0,1.0);
#ifdef RENDER_SHADOWS
float cutoffOpacity=1.0;
#ifdef RENDER_CUTOFF
cutoffOpacity=cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w);
#endif
#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS
vec3 unlit_base=image_color.rgb*(1.0-image_color.a);vec3 emissive_base=image_color.rgb*image_color.a;float ndotl=u_shadow_direction.z;float occlusion=ndotl < 0.0 ? 1.0 : shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,0.0);ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;
#else
float lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));
#endif
#else
float lighting_factor=u_lighting_directional_dir.z;color=apply_lighting(image_color,normal,lighting_factor);
#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS
color.rgb=mix(color.rgb,image_color.rgb,image_color.a);color.a=1.0;
#endif
#endif
#else
color=image_color;
#endif
#ifdef FOG
#ifdef ZERO_EXAGGERATION
color=fog_dither(fog_apply_premultiplied(color,v_fog_pos));
#else
color=fog_dither(fog_apply_from_vert(color,v_fog_opacity));
#endif
#endif
glFragColor=color;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
#include "_prelude_terrain.vertex.glsl"
uniform mat4 u_matrix;uniform float u_skirt_height;in vec2 a_pos;out vec2 v_pos0;
#ifdef FOG
out float v_fog_opacity;
#endif
#ifdef RENDER_SHADOWS
uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth;
#endif
void main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);
#ifdef FOG
#ifdef ZERO_EXAGGERATION
v_fog_pos=fog_position(decodedPos);
#else
v_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));
#endif
#endif
#ifdef RENDER_SHADOWS
vec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);
#endif
}`), terrainDepth: ca("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", `#include "_prelude_terrain.vertex.glsl"
uniform mat4 u_matrix;in vec2 a_pos;out float v_depth;void main() {float elevation=elevation(a_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}`), skybox: ca(`#include "_prelude_fog.fragment.glsl"
in lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(
cos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;
#ifdef FOG
sky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);
#endif
sky_color.rgb=dither(sky_color.rgb,gl_FragCoord.xy+u_temporal_offset);sky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
}`, Bf), skyboxGradient: ca(`#include "_prelude_fog.fragment.glsl"
in highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));
#ifdef FOG
color.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;
#endif
color*=u_opacity;color.rgb=dither(color.rgb,gl_FragCoord.xy+u_temporal_offset);glFragColor=color;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
}`, Bf), skyboxCapture: ca(`
in highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;
#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)
#define BETA_M                  vec3(21e-6,21e-6,21e-6)
#define MIE_G                   0.76
#define DENSITY_HEIGHT_SCALE_R  8000.0
#define DENSITY_HEIGHT_SCALE_M  1200.0
#define PLANET_RADIUS           6360e3
#define ATMOSPHERE_RADIUS       6420e3
#define SAMPLE_STEPS            10
#define DENSITY_STEPS           4
float ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}`, "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"), globeRaster: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_lighting.glsl"
uniform sampler2D u_image0;uniform float u_far_z_cutoff;in vec2 v_pos0;
#ifndef FOG
uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;
#endif
void main() {vec4 color;
#ifdef CUSTOM_ANTIALIASING
vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(
mix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);vec3 dir=normalize(ray_dir);vec3 closest_point=dot(u_globe_pos,dir)*dir;float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);
#ifdef LIGHTING_3D_MODE
#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS
raster=apply_lighting_with_emission_ground(raster,raster.a);color=vec4(raster.rgb*antialias,antialias);
#else
raster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);
#endif
#else
color=vec4(raster.rgb*antialias,raster.a*antialias);
#endif
#else
color=texture(u_image0,v_pos0);
#ifdef LIGHTING_3D_MODE
#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS
color=apply_lighting_with_emission_ground(color,color.a);color.a=1.0;
#else
color=apply_lighting_ground(color);
#endif
#endif
#endif
#ifdef FOG
color=fog_dither(fog_apply_premultiplied(color,v_fog_pos));
#endif
color*=1.0-step(u_far_z_cutoff,1.0/gl_FragCoord.w);glFragColor=color;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
#include "_prelude_terrain.vertex.glsl"
uniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;
#ifdef GLOBE_POLES
in vec3 a_globe_pos;in vec2 a_uv;
#else
in vec2 a_pos;
#endif
out vec2 v_pos0;void main() {
#ifdef GLOBE_POLES
vec3 globe_pos=a_globe_pos;vec2 uv=a_uv;
#else
float tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);
#endif
v_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;
#ifdef GLOBE_POLES
vec3 up_vector=globe_derived_up_vector;
#else
vec3 up_vector=elevationVector(tile_pos);
#endif
float height=elevation(tile_pos);globe_pos+=up_vector*height;
#ifndef GLOBE_POLES
globe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;
#endif
#ifdef GLOBE_POLES
vec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);
#else
vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);
#endif
gl_Position=u_proj_matrix*interpolated_pos;
#ifdef FOG
v_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);
#endif
}`), globeAtmosphere: ca(`#include "_prelude_fog.fragment.glsl"
uniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;
#ifdef PROJECTION_GLOBE_VIEW
globe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {
#ifdef ALPHA_PASS
glFragColor=vec4(0,0,0,0);return;
#else
#ifdef NATIVE
glFragColor=vec4(1,1,1,1);
#else
glFragColor=vec4(0,0,0,1);
#endif
return;
#endif
}
#endif
highp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?
0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;
#ifdef PROJECTION_GLOBE_VIEW
highp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?
PI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);
#else
horizon_angle=horizon_angle_mercator;
#endif
horizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;
#ifdef ALPHA_PASS
float a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);
#else
vec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;
#ifndef NATIVE
c=dither(c,gl_FragCoord.xy+u_temporal_offset);
#endif
glFragColor=vec4(c*t,t);
#endif
}`, `in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(
mix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(
mix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}`), model: ca(`#include "_prelude_fog.fragment.glsl"
#include "_prelude_shadow.fragment.glsl"
#include "_prelude_lighting.glsl"
uniform float u_opacity;uniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;uniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;
#ifdef RENDER_SHADOWS
in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;
#endif
#ifdef OCCLUSION_TEXTURE_TRANSFORM
uniform vec4 u_occlusionTextureTransform;
#endif
#pragma mapbox: define-attribute highp vec3 normal_3f
#pragma mapbox: define-attribute highp vec3 color_3f
#pragma mapbox: define-attribute highp vec4 color_4f
#pragma mapbox: define-attribute highp vec2 uv_2f
#pragma mapbox: initialize-attribute highp vec3 normal_3f
#pragma mapbox: initialize-attribute highp vec3 color_3f
#pragma mapbox: initialize-attribute highp vec4 color_4f
#pragma mapbox: initialize-attribute highp vec2 uv_2f
#ifdef HAS_ATTRIBUTE_a_pbr
in lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;
#endif
#ifdef HAS_TEXTURE_u_baseColorTexture
uniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;
#endif
#ifdef HAS_TEXTURE_u_metallicRoughnessTexture
uniform sampler2D u_metallicRoughnessTexture;
#endif
#ifdef HAS_TEXTURE_u_occlusionTexture
uniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;
#endif
#ifdef HAS_TEXTURE_u_normalTexture
uniform sampler2D u_normalTexture;
#endif
#ifdef HAS_TEXTURE_u_emissionTexture
uniform sampler2D u_emissionTexture;
#endif
#ifdef APPLY_LUT_ON_GPU
uniform highp sampler3D u_lutTexture;
#endif
#ifdef TERRAIN_FRAGMENT_OCCLUSION
in highp float v_depth;uniform highp sampler2D u_depthTexture;uniform highp vec2 u_inv_depth_size;uniform highp vec2 u_depth_range_unpack;
#ifdef DEPTH_D24
highp float unpack_depth(highp float depth) {return  depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}
#else
highp float unpack_depth_rgba(highp vec4 rgba_depth)
{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}
#endif
bool isOccluded() {highp vec2 coord=gl_FragCoord.xy*u_inv_depth_size;
#ifdef DEPTH_D24
highp float depth=unpack_depth(texture(u_depthTexture,coord).r);
#else
highp float depth=unpack_depth_rgba(texture(u_depthTexture,coord));
#endif
return v_depth > depth+0.0005;}
#endif
#define saturate(_x) clamp(_x,0.,1.)
vec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)
{
#ifdef LIGHTING_3D_MODE
vec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;
#ifdef RENDER_SHADOWS
lighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);
#else
lighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));
#endif
return apply_lighting(albedo,transformed_normal,lighting_factor);
#else
vec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;
#endif
}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;
#ifdef HAS_ATTRIBUTE_a_color_3f
albedo*=vec4(color_3f,1.0);
#endif
#ifdef HAS_ATTRIBUTE_a_pbr
#else
#ifdef HAS_ATTRIBUTE_a_color_4f
albedo*=color_4f;
#endif
#endif
#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)
vec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}
#ifdef UNPREMULT_TEXTURE_IN_SHADER
if(texColor.w > 0.0) {texColor.rgb/=texColor.w;}texColor.w=1.0;
#endif
if(u_baseTextureIsAlpha) {if (texColor.r < 0.5) {discard;}} else {texColor.rgb=sRGBToLinear(texColor.rgb);albedo*=texColor;}
#endif
vec4 color=vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);
#ifdef APPLY_LUT_ON_GPU
color=applyLUT(u_lutTexture,color);
#endif
return color;}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {
#ifdef HAS_TEXTURE_u_normalTexture
highp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=dp2perp*duv1.x+dp1perp*duv2.x;highp vec3 B=dp2perp*duv1.y+dp1perp*duv2.y;highp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;
#else
return mat3(1.0);
#endif
}highp vec3 getNormal(){highp vec3 n;
#ifdef HAS_ATTRIBUTE_a_normal_3f
n=normalize(normal_3f);
#else
highp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));n=normalize(cross(fdx,fdy))*-1.0;
#endif
#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)
vec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=normalize(-v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);
#endif
return n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;
#ifdef HAS_ATTRIBUTE_a_pbr
mat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;
#endif
#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f) 
vec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;
#endif
const float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)
{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)
{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)
{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)
{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)
{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)
{
#ifdef LIGHTING_3D_MODE
return mat.diffuseColor;
#else
return mat.diffuseColor/PI;
#endif
}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)
{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)
{vec3 env_light=vec3(0.65,0.65,0.65);
#ifdef LIGHTING_3D_MODE
float ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;
#endif
vec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)
{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;
#ifdef RENDER_SHADOWS
lighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);
#else
lighting_factor=NdotL;
#endif
vec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;
#if !defined(LIGHTING_3D_MODE)
const vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);
#endif
color*=intensityFactor;return color;}void main() {
#ifdef TERRAIN_FRAGMENT_OCCLUSION
if (isOccluded()) {discard;}
#endif
vec3 lightDir=u_lightpos;vec3 lightColor=u_lightcolor;
#ifdef LIGHTING_3D_MODE
lightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;
#endif
vec4 finalColor;
#ifdef DIFFUSE_SHADED
vec3 N=getNormal();vec3 baseColor=getBaseColor().rgb;vec3 diffuse=getDiffuseShadedColor(baseColor,N,lightDir,lightColor);
#ifdef HAS_TEXTURE_u_occlusionTexture
float ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;
#endif
finalColor=vec4(mix(diffuse,baseColor,u_emissive_strength),1.0)*u_opacity;
#else
Material mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;
#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)
#ifdef OCCLUSION_TEXTURE_TRANSFORM
vec2 uv=uv_2f.xy*u_occlusionTextureTransform.zw+u_occlusionTextureTransform.xy;
#else
vec2 uv=uv_2f;
#endif
ao=(texture(u_occlusionTexture,uv).x-1.0)*u_aoIntensity+1.0;color*=ao;
#endif
vec4 emissive=u_emissiveFactor;
#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)
emissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);
#endif
#ifdef APPLY_LUT_ON_GPU
float emissiveFactorLength=max(length(u_emissiveFactor.rgb),0.001);emissive.rgb=sRGBToLinear(applyLUT(u_lutTexture,linearTosRGB(emissive.rgb/emissiveFactorLength).rbg))*emissiveFactorLength;
#endif
color+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;
#ifdef HAS_ATTRIBUTE_a_pbr
float resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);vec3 color_mix=v_color_mix.rgb;
#ifdef APPLY_LUT_ON_GPU
color_mix=applyLUT(u_lutTexture,color_mix);
#endif
color=mix(color,color_mix,min(1.0,resEmission));
#ifdef HAS_ATTRIBUTE_a_color_4f
float distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);
#endif
#endif
vec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);
#endif
#ifdef FOG
finalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));
#endif
#ifdef RENDER_CUTOFF
finalColor*=v_cutoff_opacity;
#endif
#ifdef INDICATOR_CUTOUT
finalColor=applyCutout(finalColor,v_position_height.w);
#endif
glFragColor=finalColor;
#ifdef OVERDRAW_INSPECTOR
glFragColor=vec4(1.0);
#endif
HANDLE_WIREFRAME_DEBUG;}`, `#include "_prelude_fog.vertex.glsl"
#include "_prelude_shadow.vertex.glsl"
in vec3 a_pos_3f;
#pragma mapbox: define-attribute highp vec3 normal_3f
#pragma mapbox: define-attribute highp vec2 uv_2f
#pragma mapbox: define-attribute highp vec3 color_3f
#pragma mapbox: define-attribute highp vec4 color_4f
#pragma mapbox: define-attribute-vertex-shader-only highp vec4 pbr
#pragma mapbox: define-attribute-vertex-shader-only highp vec3 heightBasedEmissiveStrength
uniform mat4 u_matrix;uniform mat4 u_node_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;
#ifdef INSTANCED_ARRAYS
in vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;
#else
uniform highp mat4 u_normal_matrix;
#endif
#ifdef RENDER_SHADOWS
uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;
#endif
out vec4 v_position_height;out lowp vec4 v_color_mix;
#ifdef TERRAIN_FRAGMENT_OCCLUSION
out highp float v_depth;
#endif
#ifdef HAS_ATTRIBUTE_a_pbr
out lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;
#endif
vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {
#pragma mapbox: initialize-attribute highp vec3 normal_3f
#pragma mapbox: initialize-attribute highp vec2 uv_2f
#pragma mapbox: initialize-attribute highp vec3 color_3f
#pragma mapbox: initialize-attribute highp vec4 color_4f
#pragma mapbox: initialize-attribute-custom highp vec4 pbr
#pragma mapbox: initialize-attribute-custom highp vec3 heightBasedEmissiveStrength
highp mat4 normal_matrix;
#ifdef INSTANCED_ARRAYS
normal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);
#else
normal_matrix=u_normal_matrix;
#endif
vec3 local_pos;mat3 rs;
#ifdef MODEL_POSITION_ON_GPU
vec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float hidden=float(pos_a.x > EXTENT);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=mix(u_matrix*pos,AWAY,hidden);pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;
#else
local_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);
#endif
v_position_height.w=a_pos_3f.z;
#ifdef HAS_ATTRIBUTE_a_pbr
vec4 albedo_c=decode_color(pbr.xy);vec2 e_r_m=unpack_float(pbr.z);vec2 r_m= unpack_float(e_r_m.y*16.0);r_m.r=r_m.r*16.0;v_color_mix=vec4(albedo_c.rgb,1.0);v_roughness_metallic_emissive_alpha=vec4(vec3(r_m,e_r_m.x)/255.0,albedo_c.a);v_roughness_metallic_emissive_alpha.z*=2.0;float heightBasedRelativeIntepolation=a_pos_3f.z*heightBasedEmissiveStrength.x+heightBasedEmissiveStrength.y;v_height_based_emission_params.x=heightBasedRelativeIntepolation;v_height_based_emission_params.y=heightBasedEmissiveStrength.z;vec2 emissionMultiplierValues=unpack_float(pbr.w)/256.0;v_height_based_emission_params.z=emissionMultiplierValues.x;v_height_based_emission_params.w=emissionMultiplierValues.y-emissionMultiplierValues.x;
#endif
#ifdef FOG
v_fog_pos=fog_position(local_pos);
#endif
#ifdef RENDER_CUTOFF
v_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);
#endif
#ifdef TERRAIN_FRAGMENT_OCCLUSION
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef HAS_ATTRIBUTE_a_normal_3f
#ifdef MODEL_POSITION_ON_GPU
float x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_3f=rs*((u_lighting_matrix*vec4(normal_3f,0.0)).xyz/squared_scale);normal_3f=normalize(normal_3f);
#else
normal_3f=vec3(normal_matrix*vec4(normal_3f,0));
#endif
#endif
#ifdef HAS_ATTRIBUTE_a_pbr
#ifdef HAS_ATTRIBUTE_a_color_4f
v_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);
#endif
#endif
#ifdef RENDER_SHADOWS
vec4 shadow_pos=u_node_matrix*vec4(local_pos,1.0);
#ifdef NORMAL_OFFSET
#ifdef HAS_ATTRIBUTE_a_normal_3f
#ifdef MODEL_POSITION_ON_GPU
vec3 offset=shadow_normal_offset(vec3(-normal_3f.xy,normal_3f.z));shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();
#else
vec3 offset=shadow_normal_offset_model(normal_3f);shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();
#endif
#endif
#endif
v_pos_light_view_0=u_light_matrix_0*shadow_pos;v_pos_light_view_1=u_light_matrix_1*shadow_pos;v_depth_shadows=gl_Position.w;
#endif
}`), modelDepth: ca(`in highp float v_depth;void main() {
#ifndef DEPTH_TEXTURE
glFragColor=pack_depth(v_depth);
#endif
}`, `in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;
#ifdef MODEL_POSITION_ON_GPU
#ifdef INSTANCED_ARRAYS
in vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;
#else
uniform highp mat4 u_instance;
#endif
uniform highp mat4 u_node_matrix;
#endif
void main() {
#ifdef MODEL_POSITION_ON_GPU
highp mat4 instance;
#ifdef INSTANCED_ARRAYS
instance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);
#else
instance=u_instance;
#endif
vec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float hidden=float(pos_a.x > EXTENT);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=mix(u_matrix*pos,AWAY,hidden);
#else
gl_Position=u_matrix*vec4(a_pos_3f,1);
#endif
v_depth=gl_Position.z/gl_Position.w;}`), stars: ca(`in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)
{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}`, `
in vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_fade_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_fade_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}`), snowParticle: ca("in highp vec2 uv;in highp float alphaMultiplier;uniform vec4 u_particleColor;uniform vec2 u_simpleShapeParameters;void main() {float t=clamp((length(uv)-u_simpleShapeParameters.x)/(1.0-u_simpleShapeParameters.x),0.0,1.0);float alpha=1.0-pow(t,pow(10.0,u_simpleShapeParameters.y));alpha*=alphaMultiplier;alpha*=u_particleColor.a;vec3 color=u_particleColor.rgb*alpha;glFragColor=vec4(color,alpha) ;HANDLE_WIREFRAME_DEBUG;}", `
in highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_snowParticleData;in highp vec4 a_snowParticleDataHorizontalOscillation;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform vec2 u_screenSize;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; 
uniform float u_velocity;uniform vec3 u_direction;uniform float u_horizontalOscillationRadius; 
uniform float u_horizontalOscillationRate; 
uniform float u_billboardSize;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;out highp vec2 uv;out highp float alphaMultiplier;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos.xyz*=halfBoxSize;pos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_snowParticleData.z;float coneAngleHeadingRad=a_snowParticleData.w*radians(360.0);vec3 localZ=normalize(u_direction);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 direction;direction.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.z=cos(coneAnglePichRad);direction=normalize(direction);vec3 simPosLocal=vec3(0,0,0);float velocityScale=(1.0+3.0*a_snowParticleData.y)*u_velocity;simPosLocal+=direction*velocityScale*u_time;float horizontalOscillationRadius=u_horizontalOscillationRadius*a_snowParticleDataHorizontalOscillation.x;float horizontalOscillationAngle=u_horizontalOscillationRate*u_time*(-1.0+2.0*a_snowParticleDataHorizontalOscillation.y);simPosLocal.xy+=horizontalOscillationRadius*vec2(cos(horizontalOscillationAngle),sin(horizontalOscillationAngle));vec3 simPos=localX*simPosLocal.x+
localY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);float clipZ=-u_cam_pos.z+pos.z;vec4 posView=u_modelview*vec4(pos,1.0);float size=u_billboardSize;alphaMultiplier=1.0;vec4 posScreen=u_projection*posView;posScreen/=posScreen.w;posScreen.xy=vec2(0.5)+posScreen.xy*0.5;posScreen.xy*=u_screenSize;vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=u_screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-posScreen.xy)/(0.5*u_screenSize));screenDist+=a_snowParticleData.x*u_thinningParticleOffset;float scaleFactorMode=0.0;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);if (a_snowParticleData.x < u_thinningAffectedRatio) {scaleFactorMode=1.0-thinningFadeRatio;alphaMultiplier=thinningFadeRatio;}}vec4 posScreen1=u_projection*vec4(posView.x-size,posView.yzw);posScreen1/=posScreen1.w;vec4 posScreen2=u_projection*vec4(posView.x+size,posView.yzw);posScreen2/=posScreen2.w;posScreen1.xy=vec2(0.5)+posScreen1.xy*0.5;posScreen1.xy*=u_screenSize;posScreen2.xy=vec2(0.5)+posScreen2.xy*0.5;posScreen2.xy*=u_screenSize;float screenLength=length(posScreen1.xy-posScreen2.xy);float screenEpsilon=3.0;float scaleFactor=1.0;if (screenLength < screenEpsilon) {scaleFactor=screenEpsilon/max(screenLength,0.01);scaleFactor=mix(scaleFactor,1.0,scaleFactorMode);}float screenEpsilon2=15.0;if (screenLength > screenEpsilon2) {scaleFactor=screenEpsilon2/max(screenLength,0.01);}size*=scaleFactor;vec2 right=size*vec2(1,0);vec2 up=size*vec2(0,1);posView.xy+=right*a_uv.x;posView.xy+=up*a_uv.y;uv=a_uv;gl_Position=u_projection*posView;}`), rainParticle: ca("in highp vec2 uv;in highp float particleRandomValue;uniform sampler2D u_texScreen;uniform float u_distortionStrength;uniform vec4 u_color;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;uniform float u_shapeDirectionalPower;uniform float u_mode;void main() {vec2 st=uv*0.5+vec2(0.5);vec2 uvm=uv;uvm.y=-1.0+2.0*pow(st.y,u_shapeDirectionalPower);float shape=clamp(1.0-length(uvm),0.0,1.0);float alpha=abs(shape)*u_color.a;vec2 screenSize=vec2(textureSize(u_texScreen,0));vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-gl_FragCoord.xy)/(0.5*screenSize));screenDist+=(0.5+0.5*particleRandomValue)*u_thinningParticleOffset;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;float thinningAlpha=1.0;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);thinningAlpha*=thinningFadeRatio;}vec2 offsetXY=normalize(uvm)*abs(shape);vec2 stScreen=(gl_FragCoord.xy+offsetXY*u_distortionStrength*thinningAlpha)/screenSize;vec3 colorScreen=texture(u_texScreen,stScreen).rgb;alpha*=thinningAlpha;glFragColor=mix(vec4(colorScreen,1.0),vec4(u_color.rgb*alpha,alpha),u_mode);HANDLE_WIREFRAME_DEBUG;}", `
in highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_rainParticleData;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; 
uniform float u_velocity; 
uniform vec2 u_rainDropletSize;uniform vec3 u_rainDirection;out highp vec2 uv;out highp float particleRandomValue;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos*=halfBoxSize; 
pos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_rainParticleData.z;float coneAngleHeadingRad=a_rainParticleData.w*radians(360.0);vec3 localZ=normalize(u_rainDirection);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 directionLocal;directionLocal.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.z=cos(coneAnglePichRad);directionLocal=normalize(directionLocal);vec3 directionWorld=localX*directionLocal.x+localY*directionLocal.y+localZ*directionLocal.z;float velocityScale=(1.0+3.0*a_rainParticleData.y)*u_velocity;vec3 simPosLocal=vec3(0,0,0);simPosLocal+=directionLocal*velocityScale*u_time;vec3 simPos=localX*simPosLocal.x+
localY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);vec4 posView=u_modelview*vec4(pos,1.0);vec3 directionView=normalize((u_modelview*vec4(directionWorld,0.0)).xyz);vec3 side=cross(directionView,normalize(posView.xyz));posView.xyz+=side*a_uv.x*u_rainDropletSize.x;posView.xyz+=directionView*a_uv.y*u_rainDropletSize.y;uv=a_uv;particleRandomValue=a_rainParticleData.x;gl_Position=u_projection*posView;}`), vignette: ca("uniform vec3 u_vignetteShape;uniform vec4 u_vignetteColor;in vec2 st;void main() {float screenDist=length(st);float alpha=clamp((screenDist-u_vignetteShape.x)/u_vignetteShape.y,0.0,1.0);alpha=pow(alpha,u_vignetteShape.z)*u_vignetteColor.a;vec3 color=u_vignetteColor.rgb;glFragColor=vec4(color*alpha,alpha) ;}", "in vec2 a_pos_2f;out vec2 st;void main() {st=a_pos_2f;gl_Position=vec4(a_pos_2f,0,1);}"), occlusion: ca("uniform vec4 u_color;void main() {glFragColor=u_color;}", `#include "_prelude_terrain.vertex.glsl"
in highp vec2 a_offset_xy;uniform highp vec3 u_anchorPos;uniform mat4 u_matrix;uniform vec2 u_screenSizePx;uniform vec2 u_occluderSizePx;void main() {vec3 world_pos=u_anchorPos;
#ifdef TERRAIN
float e=elevation(world_pos.xy);world_pos.z+=e;
#endif
vec4 projected_point=u_matrix*vec4(world_pos,1.0);projected_point.xy+=projected_point.w*a_offset_xy*0.5*u_occluderSizePx/u_screenSizePx;gl_Position=projected_point;}`) };
      function kc(qe, xe) {
        const ke = qe.replace(/\s*\/\/[^\n]*\n/g, `
`).split(`
`);
        for (let He of ke)
          if (He = He.trim(), He[0] === "#" && He.includes("if") && !He.includes("endif")) {
            He = He.replace("#", "").replace(/ifdef|ifndef|elif|if/g, "").replace(/!|defined|\(|\)|\|\||&&/g, "").replace(/\s+/g, " ").trim();
            const ir = He.split(" ");
            for (const ar of ir)
              xe.includes(ar) || xe.push(ar);
          }
      }
      function ca(qe, xe) {
        const ke = /#include\s+"([^"]+)"/g, He = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g;
        let ir = xe.match(/(attribute(\S*)|(^\s*|;)in) (highp |mediump |lowp )?([\w]+) ([\w]+)/gm);
        ir && (ir = ir.map((Dr) => {
          const Or = Dr.split(" ");
          return Or[Or.length - 1];
        }), ir = [...new Set(ir)]);
        const ar = {}, yr = [], Tr = [];
        if (qe = qe.replace(ke, (Dr, Or) => (Tr.push(Or), "")), (xe = xe.replace(ke, (Dr, Or) => (yr.push(Or), ""))).includes("flat out"))
          return void console.error('The usage of "flat" qualifier is disallowed, see: https://bugs.webkit.org/show_bug.cgi?id=268071');
        let $r = [...Ju];
        kc(qe, $r), kc(xe, $r);
        for (const Dr of [...yr, ...Tr])
          Eu[Dr] || console.error(`Undefined include: ${Dr}`), fc[Dr] || (fc[Dr] = [], kc(Eu[Dr], fc[Dr])), $r = [...$r, ...fc[Dr]];
        return { fragmentSource: qe = qe.replace(He, (Dr, Or, Gr, qr, Jr) => (ar[Jr] = !0, Or === "define" ? `
#ifndef HAS_UNIFORM_u_${Jr}
in ${Gr} ${qr} ${Jr};
#else
uniform ${Gr} ${qr} u_${Jr};
#endif
` : Or === "initialize" ? `
#ifdef HAS_UNIFORM_u_${Jr}
    ${Gr} ${qr} ${Jr} = u_${Jr};
#endif
` : Or === "define-attribute" ? `
#ifdef HAS_ATTRIBUTE_a_${Jr}
    in ${Gr} ${qr} ${Jr};
#endif
` : Or === "initialize-attribute" ? "" : void 0)), vertexSource: xe = xe.replace(He, (Dr, Or, Gr, qr, Jr) => {
          const bi = qr === "float" ? "vec2" : qr, fi = Jr.match(/color/) ? "color" : bi;
          return Or === "define-attribute-vertex-shader-only" ? `
#ifdef HAS_ATTRIBUTE_a_${Jr}
in ${Gr} ${qr} a_${Jr};
#endif
` : ar[Jr] ? Or === "define" ? `
#ifndef HAS_UNIFORM_u_${Jr}
uniform lowp float u_${Jr}_t;
in ${Gr} ${bi} a_${Jr};
out ${Gr} ${qr} ${Jr};
#else
uniform ${Gr} ${qr} u_${Jr};
#endif
` : Or === "initialize" ? fi === "vec4" ? `
#ifndef HAS_UNIFORM_u_${Jr}
    ${Jr} = a_${Jr};
#else
    ${Gr} ${qr} ${Jr} = u_${Jr};
#endif
` : `
#ifndef HAS_UNIFORM_u_${Jr}
    ${Jr} = unpack_mix_${fi}(a_${Jr}, u_${Jr}_t);
#else
    ${Gr} ${qr} ${Jr} = u_${Jr};
#endif
` : Or === "define-attribute" ? `
#ifdef HAS_ATTRIBUTE_a_${Jr}
    in ${Gr} ${qr} a_${Jr};
    out ${Gr} ${qr} ${Jr};
#endif
` : Or === "initialize-attribute" ? `
#ifdef HAS_ATTRIBUTE_a_${Jr}
    ${Jr} = a_${Jr};
#endif
` : void 0 : Or === "define" ? `
#ifndef HAS_UNIFORM_u_${Jr}
uniform lowp float u_${Jr}_t;
in ${Gr} ${bi} a_${Jr};
#else
uniform ${Gr} ${qr} u_${Jr};
#endif
` : Or === "define-instanced" ? fi === "mat4" ? `
#ifdef INSTANCED_ARRAYS
in vec4 a_${Jr}0;
in vec4 a_${Jr}1;
in vec4 a_${Jr}2;
in vec4 a_${Jr}3;
#else
uniform ${Gr} ${qr} u_${Jr};
#endif
` : `
#ifdef INSTANCED_ARRAYS
in ${Gr} ${bi} a_${Jr};
#else
uniform ${Gr} ${qr} u_${Jr};
#endif
` : Or === "initialize-attribute-custom" ? `
#ifdef HAS_ATTRIBUTE_a_${Jr}
    ${Gr} ${qr} ${Jr} = a_${Jr};
#endif
` : fi === "vec4" ? `
#ifndef HAS_UNIFORM_u_${Jr}
    ${Gr} ${qr} ${Jr} = a_${Jr};
#else
    ${Gr} ${qr} ${Jr} = u_${Jr};
#endif
` : `
#ifndef HAS_UNIFORM_u_${Jr}
    ${Gr} ${qr} ${Jr} = unpack_mix_${fi}(a_${Jr}, u_${Jr}_t);
#else
    ${Gr} ${qr} ${Jr} = u_${Jr};
#endif
`;
        }), staticAttributes: ir, usedDefines: $r, vertexIncludes: yr, fragmentIncludes: Tr };
      }
      class Cu {
        constructor() {
          this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
        }
        bind(xe, ke, He, ir, ar, yr, Tr, $r) {
          this.context = xe;
          let Dr = this.boundPaintVertexBuffers.length !== ir.length;
          for (let Gr = 0; !Dr && Gr < ir.length; Gr++)
            this.boundPaintVertexBuffers[Gr] !== ir[Gr] && (Dr = !0);
          let Or = this.boundDynamicVertexBuffers.length !== Tr.length;
          for (let Gr = 0; !Or && Gr < Tr.length; Gr++)
            this.boundDynamicVertexBuffers[Gr] !== Tr[Gr] && (Or = !0);
          if (!this.vao || this.boundProgram !== ke || this.boundLayoutVertexBuffer !== He || Dr || Or || this.boundIndexBuffer !== ar || this.boundVertexOffset !== yr)
            this.freshBind(ke, He, ir, ar, yr, Tr, $r);
          else {
            xe.bindVertexArrayOES.set(this.vao);
            for (const Gr of Tr)
              Gr && (Gr.bind(), $r && Gr.instanceCount && Gr.setVertexAttribDivisor(xe.gl, ke, $r));
            ar && ar.dynamicDraw && ar.bind();
          }
        }
        freshBind(xe, ke, He, ir, ar, yr, Tr) {
          const $r = xe.numAttributes, Dr = this.context, Or = Dr.gl;
          this.vao && this.destroy(), this.vao = Dr.gl.createVertexArray(), Dr.bindVertexArrayOES.set(this.vao), this.boundProgram = xe, this.boundLayoutVertexBuffer = ke, this.boundPaintVertexBuffers = He, this.boundIndexBuffer = ir, this.boundVertexOffset = ar, this.boundDynamicVertexBuffers = yr, ke.enableAttributes(Or, xe), ke.bind(), ke.setVertexAttribPointers(Or, xe, ar);
          for (const Gr of He)
            Gr.enableAttributes(Or, xe), Gr.bind(), Gr.setVertexAttribPointers(Or, xe, ar);
          for (const Gr of yr)
            Gr && (Gr.enableAttributes(Or, xe), Gr.bind(), Gr.setVertexAttribPointers(Or, xe, ar), Tr && Gr.instanceCount && Gr.setVertexAttribDivisor(Or, xe, Tr));
          ir && ir.bind(), Dr.currentNumAttributes = $r;
        }
        destroy() {
          this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
        }
      }
      function $p(qe, xe) {
        const ke = Math.pow(2, xe.canonical.z), He = xe.canonical.y;
        return [new ne.aa(0, He / ke).toLngLat().lat, new ne.aa(0, (He + 1) / ke).toLngLat().lat];
      }
      function Ld(qe, xe, ke, He, ir, ar, yr) {
        const Tr = qe.context, $r = Tr.gl, Dr = ke.hillshadeFBO;
        if (!Dr)
          return;
        qe.prepareDrawTile();
        const Or = qe.isTileAffectedByFog(xe), Gr = qe.getOrCreateProgram("hillshade", { overrideFog: Or });
        Tr.activeTexture.set($r.TEXTURE0), $r.bindTexture($r.TEXTURE_2D, Dr.colorAttachment.get());
        const qr = ((Mi, Ei, Ii, Ni) => {
          const zi = Ii.paint.get("hillshade-shadow-color"), Ki = Ii.paint.get("hillshade-shadow-color-use-theme").constantOr("default") === "none", Wi = Ii.paint.get("hillshade-highlight-color"), Xi = Ii.paint.get("hillshade-highlight-color-use-theme").constantOr("default") === "none", Gi = Ii.paint.get("hillshade-accent-color"), nn = Ii.paint.get("hillshade-accent-color-use-theme").constantOr("default") === "none", dn = Ii.paint.get("hillshade-emissive-strength");
          let Pn = ne.ai(Ii.paint.get("hillshade-illumination-direction"));
          if (Ii.paint.get("hillshade-illumination-anchor") === "viewport")
            Pn -= Mi.transform.angle;
          else if (Mi.style && Mi.style.enable3dLights() && Mi.style.directionalLight) {
            const hn = Mi.style.directionalLight.properties.get("direction"), xn = ne.cb(hn.x, hn.y, hn.z);
            Pn = ne.ai(xn[1]);
          }
          const Ln = !Mi.options.moving;
          return { u_matrix: Ni || Mi.transform.calculateProjMatrix(Ei.tileID.toUnwrapped(), Ln), u_image: 0, u_latrange: $p(0, Ei.tileID), u_light: [Ii.paint.get("hillshade-exaggeration"), Pn], u_shadow: zi.toRenderColor(Ki ? null : Ii.lut), u_highlight: Wi.toRenderColor(Xi ? null : Ii.lut), u_emissive_strength: dn, u_accent: Gi.toRenderColor(nn ? null : Ii.lut) };
        })(qe, ke, He, qe.terrain ? xe.projMatrix : null);
        qe.uploadCommonUniforms(Tr, Gr, xe.toUnwrapped());
        const { tileBoundsBuffer: Jr, tileBoundsIndexBuffer: bi, tileBoundsSegments: fi } = qe.getTileBoundsBuffers(ke);
        Gr.draw(qe, $r.TRIANGLES, ir, ar, yr, Uo.disabled, qr, He.id, Jr, bi, fi);
      }
      function Rf(qe, xe, ke) {
        if (!xe.needsDEMTextureUpload)
          return;
        const He = qe.context, ir = He.gl;
        He.pixelStoreUnpackPremultiplyAlpha.set(!1), xe.demTexture = xe.demTexture || qe.getTileTexture(ke.stride);
        const ar = ke.getPixels();
        xe.demTexture ? xe.demTexture.update(ar, { premultiply: !1 }) : xe.demTexture = new ne.T(He, ar, ir.R32F, { premultiply: !1 }), xe.needsDEMTextureUpload = !1;
      }
      function Qu(qe, xe, ke) {
        const He = qe.context, ir = He.gl;
        if (!xe.dem)
          return;
        const ar = xe.dem;
        if (He.activeTexture.set(ir.TEXTURE1), Rf(qe, xe, ar), !xe.demTexture)
          return;
        xe.demTexture.bind(ir.NEAREST, ir.CLAMP_TO_EDGE);
        const yr = ar.dim;
        He.activeTexture.set(ir.TEXTURE0);
        let Tr = xe.hillshadeFBO;
        if (!Tr) {
          const qr = new ne.T(He, { width: yr, height: yr, data: null }, ir.RGBA8);
          qr.bind(ir.LINEAR, ir.CLAMP_TO_EDGE), Tr = xe.hillshadeFBO = He.createFramebuffer(yr, yr, !0, "renderbuffer"), Tr.colorAttachment.set(qr.texture);
        }
        He.bindFramebuffer.set(Tr.framebuffer), He.viewport.set([0, 0, yr, yr]);
        const { tileBoundsBuffer: $r, tileBoundsIndexBuffer: Dr, tileBoundsSegments: Or } = qe.getMercatorTileBoundsBuffers(), Gr = [];
        qe.linearFloatFilteringSupported() && Gr.push("TERRAIN_DEM_FLOAT_FORMAT"), qe.getOrCreateProgram("hillshadePrepare", { defines: Gr }).draw(qe, ir.TRIANGLES, Oo.disabled, ta.disabled, aa.unblended, Uo.disabled, ((qr, Jr) => {
          const bi = Jr.stride, fi = ne.ab.mat4.create();
          return ne.ab.mat4.ortho(fi, 0, ne.ag, -ne.ag, 0, 0, 1), ne.ab.mat4.translate(fi, fi, [0, -ne.ag, 0]), { u_matrix: fi, u_image: 1, u_dimension: [bi, bi], u_zoom: qr.overscaledZ };
        })(xe.tileID, ar), ke.id, $r, Dr, Or), xe.needsHillshadePrepare = !1;
      }
      class Wa {
        constructor(xe) {
          this.gl = xe.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
        }
        get() {
          return this.current;
        }
        set(xe) {
        }
        getDefault() {
          return this.default;
        }
        setDefault() {
          this.set(this.default);
        }
      }
      class zm extends Wa {
        getDefault() {
          return ne.aj.transparent;
        }
        set(xe) {
          const ke = this.current;
          (xe.r !== ke.r || xe.g !== ke.g || xe.b !== ke.b || xe.a !== ke.a || this.dirty) && (this.gl.clearColor(xe.r, xe.g, xe.b, xe.a), this.current = xe, this.dirty = !1);
        }
      }
      class Id extends Wa {
        getDefault() {
          return 1;
        }
        set(xe) {
          (xe !== this.current || this.dirty) && (this.gl.clearDepth(xe), this.current = xe, this.dirty = !1);
        }
      }
      class eh extends Wa {
        getDefault() {
          return 0;
        }
        set(xe) {
          (xe !== this.current || this.dirty) && (this.gl.clearStencil(xe), this.current = xe, this.dirty = !1);
        }
      }
      class Nh extends Wa {
        getDefault() {
          return [!0, !0, !0, !0];
        }
        set(xe) {
          const ke = this.current;
          (xe[0] !== ke[0] || xe[1] !== ke[1] || xe[2] !== ke[2] || xe[3] !== ke[3] || this.dirty) && (this.gl.colorMask(xe[0], xe[1], xe[2], xe[3]), this.current = xe, this.dirty = !1);
        }
      }
      class Rp extends Wa {
        getDefault() {
          return !0;
        }
        set(xe) {
          (xe !== this.current || this.dirty) && (this.gl.depthMask(xe), this.current = xe, this.dirty = !1);
        }
      }
      class Pp extends Wa {
        getDefault() {
          return 255;
        }
        set(xe) {
          (xe !== this.current || this.dirty) && (this.gl.stencilMask(xe), this.current = xe, this.dirty = !1);
        }
      }
      class Dp extends Wa {
        getDefault() {
          return { func: this.gl.ALWAYS, ref: 0, mask: 255 };
        }
        set(xe) {
          const ke = this.current;
          (xe.func !== ke.func || xe.ref !== ke.ref || xe.mask !== ke.mask || this.dirty) && (this.gl.stencilFunc(xe.func, xe.ref, xe.mask), this.current = xe, this.dirty = !1);
        }
      }
      class Bd extends Wa {
        getDefault() {
          const xe = this.gl;
          return [xe.KEEP, xe.KEEP, xe.KEEP];
        }
        set(xe) {
          const ke = this.current;
          (xe[0] !== ke[0] || xe[1] !== ke[1] || xe[2] !== ke[2] || this.dirty) && (this.gl.stencilOp(xe[0], xe[1], xe[2]), this.current = xe, this.dirty = !1);
        }
      }
      class $d extends Wa {
        getDefault() {
          return !1;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          const ke = this.gl;
          xe ? ke.enable(ke.STENCIL_TEST) : ke.disable(ke.STENCIL_TEST), this.current = xe, this.dirty = !1;
        }
      }
      class Op extends Wa {
        getDefault() {
          return [0, 1];
        }
        set(xe) {
          const ke = this.current;
          (xe[0] !== ke[0] || xe[1] !== ke[1] || this.dirty) && (this.gl.depthRange(xe[0], xe[1]), this.current = xe, this.dirty = !1);
        }
      }
      class Rd extends Wa {
        getDefault() {
          return !1;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          const ke = this.gl;
          xe ? ke.enable(ke.DEPTH_TEST) : ke.disable(ke.DEPTH_TEST), this.current = xe, this.dirty = !1;
        }
      }
      class Vh extends Wa {
        getDefault() {
          return this.gl.LESS;
        }
        set(xe) {
          (xe !== this.current || this.dirty) && (this.gl.depthFunc(xe), this.current = xe, this.dirty = !1);
        }
      }
      class Fm extends Wa {
        getDefault() {
          return !1;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          const ke = this.gl;
          xe ? ke.enable(ke.BLEND) : ke.disable(ke.BLEND), this.current = xe, this.dirty = !1;
        }
      }
      class Vl extends Wa {
        getDefault() {
          const xe = this.gl;
          return [xe.ONE, xe.ZERO, xe.ONE, xe.ZERO];
        }
        set(xe) {
          const ke = this.current;
          (xe[0] !== ke[0] || xe[1] !== ke[1] || xe[2] !== ke[2] || xe[3] !== ke[3] || this.dirty) && (this.gl.blendFuncSeparate(xe[0], xe[1], xe[2], xe[3]), this.current = xe, this.dirty = !1);
        }
      }
      class Os extends Wa {
        getDefault() {
          return ne.aj.transparent;
        }
        set(xe) {
          const ke = this.current;
          (xe.r !== ke.r || xe.g !== ke.g || xe.b !== ke.b || xe.a !== ke.a || this.dirty) && (this.gl.blendColor(xe.r, xe.g, xe.b, xe.a), this.current = xe, this.dirty = !1);
        }
      }
      class Qs extends Wa {
        getDefault() {
          return this.gl.FUNC_ADD;
        }
        set(xe) {
          (xe !== this.current || this.dirty) && (this.gl.blendEquationSeparate(xe, xe), this.current = xe, this.dirty = !1);
        }
      }
      class Pf extends Wa {
        getDefault() {
          return !1;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          const ke = this.gl;
          xe ? ke.enable(ke.CULL_FACE) : ke.disable(ke.CULL_FACE), this.current = xe, this.dirty = !1;
        }
      }
      class zp extends Wa {
        getDefault() {
          return this.gl.BACK;
        }
        set(xe) {
          (xe !== this.current || this.dirty) && (this.gl.cullFace(xe), this.current = xe, this.dirty = !1);
        }
      }
      class Df extends Wa {
        getDefault() {
          return this.gl.CCW;
        }
        set(xe) {
          (xe !== this.current || this.dirty) && (this.gl.frontFace(xe), this.current = xe, this.dirty = !1);
        }
      }
      let Of = class extends Wa {
        getDefault() {
          return null;
        }
        set(qe) {
          (qe !== this.current || this.dirty) && (this.gl.useProgram(qe), this.current = qe, this.dirty = !1);
        }
      };
      class Pd extends Wa {
        getDefault() {
          return this.gl.TEXTURE0;
        }
        set(xe) {
          (xe !== this.current || this.dirty) && (this.gl.activeTexture(xe), this.current = xe, this.dirty = !1);
        }
      }
      class th extends Wa {
        getDefault() {
          const xe = this.gl;
          return [0, 0, xe.drawingBufferWidth, xe.drawingBufferHeight];
        }
        set(xe) {
          const ke = this.current;
          (xe[0] !== ke[0] || xe[1] !== ke[1] || xe[2] !== ke[2] || xe[3] !== ke[3] || this.dirty) && (this.gl.viewport(xe[0], xe[1], xe[2], xe[3]), this.current = xe, this.dirty = !1);
        }
      }
      class Uh extends Wa {
        getDefault() {
          return null;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          const ke = this.gl;
          ke.bindFramebuffer(ke.FRAMEBUFFER, xe), this.current = xe, this.dirty = !1;
        }
      }
      class ih extends Wa {
        getDefault() {
          return null;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          const ke = this.gl;
          ke.bindRenderbuffer(ke.RENDERBUFFER, xe), this.current = xe, this.dirty = !1;
        }
      }
      class jh extends Wa {
        getDefault() {
          return null;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          const ke = this.gl;
          ke.bindTexture(ke.TEXTURE_2D, xe), this.current = xe, this.dirty = !1;
        }
      }
      class jc extends Wa {
        getDefault() {
          return null;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          const ke = this.gl;
          ke.bindBuffer(ke.ARRAY_BUFFER, xe), this.current = xe, this.dirty = !1;
        }
      }
      class zf extends Wa {
        getDefault() {
          return null;
        }
        set(xe) {
          const ke = this.gl;
          ke.bindBuffer(ke.ELEMENT_ARRAY_BUFFER, xe), this.current = xe, this.dirty = !1;
        }
      }
      class qh extends Wa {
        getDefault() {
          return null;
        }
        set(xe) {
          this.gl && (xe !== this.current || this.dirty) && (this.gl.bindVertexArray(xe), this.current = xe, this.dirty = !1);
        }
      }
      class V0 extends Wa {
        getDefault() {
          return 4;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          const ke = this.gl;
          ke.pixelStorei(ke.UNPACK_ALIGNMENT, xe), this.current = xe, this.dirty = !1;
        }
      }
      class U0 extends Wa {
        getDefault() {
          return !1;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          const ke = this.gl;
          ke.pixelStorei(ke.UNPACK_PREMULTIPLY_ALPHA_WEBGL, xe), this.current = xe, this.dirty = !1;
        }
      }
      class j0 extends Wa {
        getDefault() {
          return !1;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          const ke = this.gl;
          ke.pixelStorei(ke.UNPACK_FLIP_Y_WEBGL, xe), this.current = xe, this.dirty = !1;
        }
      }
      class Fp extends Wa {
        constructor(xe, ke) {
          super(xe), this.context = xe, this.parent = ke;
        }
        getDefault() {
          return null;
        }
      }
      class Np extends Fp {
        setDirty() {
          this.dirty = !0;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          this.context.bindFramebuffer.set(this.parent);
          const ke = this.gl;
          ke.framebufferTexture2D(ke.FRAMEBUFFER, ke.COLOR_ATTACHMENT0, ke.TEXTURE_2D, xe, 0), this.current = xe, this.dirty = !1;
        }
      }
      class nh extends Fp {
        attachment() {
          return this.gl.DEPTH_ATTACHMENT;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          this.context.bindFramebuffer.set(this.parent);
          const ke = this.gl;
          ke.framebufferRenderbuffer(ke.FRAMEBUFFER, this.attachment(), ke.RENDERBUFFER, xe), this.current = xe, this.dirty = !1;
        }
      }
      class Gh extends Fp {
        attachment() {
          return this.gl.DEPTH_ATTACHMENT;
        }
        set(xe) {
          if (xe === this.current && !this.dirty)
            return;
          this.context.bindFramebuffer.set(this.parent);
          const ke = this.gl;
          ke.framebufferTexture2D(ke.FRAMEBUFFER, this.attachment(), ke.TEXTURE_2D, xe, 0), this.current = xe, this.dirty = !1;
        }
      }
      class oh extends nh {
        attachment() {
          return this.gl.DEPTH_STENCIL_ATTACHMENT;
        }
      }
      const Zi = (qe, xe, ke) => ({ u_matrix: qe, u_image0: 0, u_skirt_height: xe, u_ground_shadow_factor: ke }), Tu = (qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr, qr, Jr, bi, fi) => ({ u_proj_matrix: Float32Array.from(qe), u_globe_matrix: xe, u_normalize_matrix: Float32Array.from(He), u_merc_matrix: ke, u_zoom_transition: ir, u_merc_center: ar, u_image0: 0, u_frustum_tl: yr, u_frustum_tr: Tr, u_frustum_br: $r, u_frustum_bl: Dr, u_globe_pos: Or, u_globe_radius: Gr, u_viewport: qr, u_grid_matrix: fi ? Float32Array.from(fi) : new Float32Array(9), u_skirt_height: Jr, u_far_z_cutoff: bi });
      function Hh(qe, xe) {
        return qe != null && xe != null && !(!qe.hasData() || !xe.hasData()) && qe.demTexture != null && xe.demTexture != null && qe.tileID.key !== xe.tileID.key;
      }
      const el = new class {
        constructor() {
          this.operations = {};
        }
        newMorphing(qe, xe, ke, He, ir) {
          if (qe in this.operations) {
            const ar = this.operations[qe];
            ar.to.tileID.key !== ke.tileID.key && (ar.queued = ke);
          } else
            this.operations[qe] = { startTime: He, phase: 0, duration: ir, from: xe, to: ke, queued: null };
        }
        getMorphValuesForProxy(qe) {
          if (!(qe in this.operations))
            return null;
          const xe = this.operations[qe];
          return { from: xe.from, to: xe.to, phase: xe.phase };
        }
        update(qe) {
          for (const xe in this.operations) {
            const ke = this.operations[xe];
            for (ke.phase = (qe - ke.startTime) / ke.duration; ke.phase >= 1 || !this._validOp(ke); )
              if (!this._nextOp(ke, qe)) {
                delete this.operations[xe];
                break;
              }
          }
        }
        _nextOp(qe, xe) {
          return !!qe.queued && (qe.from = qe.to, qe.to = qe.queued, qe.queued = null, qe.phase = 0, qe.startTime = xe, !0);
        }
        _validOp(qe) {
          return qe.from.hasData() && qe.to.hasData();
        }
      }(), Da = { 0: null, 1: "TERRAIN_VERTEX_MORPHING" };
      function Vp(qe, xe, ke) {
        if (xe === 0)
          return 0;
        const He = xe < 1 && ke === 514 ? 0.25 / xe : 1;
        return 6 * Math.pow(1.5, 22 - qe) * Math.max(xe, 1) * He;
      }
      function Au(qe, xe) {
        const ke = 1 << qe.z;
        return !xe && (qe.x === 0 || qe.x === ke - 1) || qe.y === 0 || qe.y === ke - 1;
      }
      const Dd = (qe) => ({ u_matrix: qe });
      function pc(qe, xe, ke, He, ir) {
        if (ir > 0) {
          const ar = ne.q.now(), yr = (ar - qe.timeAdded) / ir, Tr = xe ? (ar - xe.timeAdded) / ir : -1, $r = ke.getSource(), Dr = He.coveringZoomLevel({ tileSize: $r.tileSize, roundZoom: $r.roundZoom }), Or = !xe || Math.abs(xe.tileID.overscaledZ - Dr) > Math.abs(qe.tileID.overscaledZ - Dr), Gr = Or && qe.refreshedUponExpiration ? 1 : ne.aw(Or ? yr : 1 - Tr, 0, 1);
          return qe.refreshedUponExpiration && yr >= 1 && (qe.refreshedUponExpiration = !1), xe ? { opacity: 1, mix: 1 - Gr } : { opacity: Gr, mix: 0 };
        }
        return { opacity: 1, mix: 0 };
      }
      class Nm extends Kl {
        constructor(xe) {
          const ke = { type: "raster-dem", maxzoom: xe.transform.maxZoom }, He = new ne.D(ne.ci(), null), ir = yf("mock-dem", ke, He, xe.style);
          super("mock-dem", ir, !1), ir.setEventedParent(this), this._sourceLoaded = !0;
        }
        _loadTile(xe, ke) {
          xe.state = "loaded", ke(null);
        }
      }
      class Vm extends Kl {
        constructor(xe) {
          const ke = yf("proxy", { type: "geojson", maxzoom: xe.transform.maxZoom }, new ne.D(ne.ci(), null), xe.style);
          super("proxy", ke, !1), ke.setEventedParent(this), this.map = this.getSource().map = xe, this.used = this._sourceLoaded = !0, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
        }
        update(xe, ke, He) {
          if (xe.freezeTileCoverage)
            return;
          this.transform = xe;
          const ir = xe.coveringTiles({ tileSize: this._source.tileSize, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: this._source.roundZoom, reparseOverscaled: this._source.reparseOverscaled }).reduce((ar, yr) => {
            if (ar[yr.key] = "", !this._tiles[yr.key]) {
              const Tr = new Xl(yr, this._source.tileSize * yr.overscaleFactor(), xe.tileZoom);
              Tr.state = "loaded", this._tiles[yr.key] = Tr;
            }
            return ar;
          }, {});
          for (const ar in this._tiles)
            ar in ir || (this.freeFBO(ar), this._tiles[ar].unloadVectorData(), delete this._tiles[ar]);
        }
        freeFBO(xe) {
          const ke = this.proxyCachedFBO[xe];
          if (ke !== void 0) {
            const He = Object.values(ke);
            this.renderCachePool.push(...He), delete this.proxyCachedFBO[xe];
          }
        }
        deallocRenderCache() {
          this.renderCache.forEach((xe) => xe.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
        }
      }
      class Ff extends ne.aG {
        constructor(xe, ke, He) {
          super(xe.overscaledZ, xe.wrap, xe.canonical.z, xe.canonical.x, xe.canonical.y), this.proxyTileKey = ke, this.projMatrix = He;
        }
      }
      class Nf extends ne.cJ {
        constructor(xe, ke) {
          super(), this._debugParams = { sortTilesHiZFirst: !0, disableRenderCache: !1 }, xe.tp.registerParameter(this._debugParams, ["Terrain"], "sortTilesHiZFirst", {}, () => {
            this._style.map.triggerRepaint();
          }), xe.tp.registerParameter(this._debugParams, ["Terrain"], "disableRenderCache", {}, () => {
            this._style.map.triggerRepaint();
          }), xe.tp.registerButton(["Terrain"], "Invalidate Render Cache", () => {
            this.invalidateRenderCache = !0, this._style.map.triggerRepaint();
          }), this.painter = xe, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
          const [He, ir, ar] = function($r) {
            const Dr = new ne.b4(), Or = new ne.aU(), Gr = 131;
            Dr.reserve(17161), Or.reserve(33800);
            const qr = ne.ag / 128, Jr = ne.ag + qr / 2, bi = Jr + qr;
            for (let Mi = -qr; Mi < bi; Mi += qr)
              for (let Ei = -qr; Ei < bi; Ei += qr) {
                const Ii = Ei < 0 || Ei > Jr || Mi < 0 || Mi > Jr ? 24575 : 0, Ni = ne.aw(Math.round(Ei), 0, ne.ag), zi = ne.aw(Math.round(Mi), 0, ne.ag);
                Dr.emplaceBack(Ni + Ii, zi);
              }
            const fi = (Mi, Ei) => {
              const Ii = Ei * Gr + Mi;
              Or.emplaceBack(Ii + 1, Ii, Ii + Gr), Or.emplaceBack(Ii + Gr, Ii + Gr + 1, Ii + 1);
            };
            for (let Mi = 1; Mi < 129; Mi++)
              for (let Ei = 1; Ei < 129; Ei++)
                fi(Ei, Mi);
            return [0, 129].forEach((Mi) => {
              for (let Ei = 0; Ei < 130; Ei++)
                fi(Ei, Mi), fi(Mi, Ei);
            }), [Dr, Or, 32768];
          }(), yr = xe.context;
          this.gridBuffer = yr.createVertexBuffer(He, ne.b6.members), this.gridIndexBuffer = yr.createIndexBuffer(ir), this.gridSegments = ne.b7.simpleSegment(0, 0, He.length, ir.length), this.gridNoSkirtSegments = ne.b7.simpleSegment(0, 0, He.length, ar), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new Vm(ke.map), this.orthoMatrix = ne.ab.mat4.create(), ne.ab.mat4.ortho(this.orthoMatrix, this.painter.transform.projection.name === "globe" ? 0.015 : 0, ne.ag, 0, ne.ag, 0, 1);
          const Tr = yr.gl;
          this._overlapStencilMode = new ta({ func: Tr.GEQUAL, mask: 255 }, 0, 255, Tr.KEEP, Tr.KEEP, Tr.REPLACE), this._previousZoom = xe.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = ke, this._useVertexMorphing = !0, this._exaggeration = 1, this._mockSourceCache = new Nm(ke.map), this._pendingGroundEffectLayers = [];
        }
        set style(xe) {
          xe.on("data", this._onStyleDataEvent.bind(this)), this._style = xe, this._style.map.on("moveend", () => {
            this._clearLineLayersFromRenderCache();
          });
        }
        update(xe, ke, He) {
          if (xe && xe.terrain) {
            this._style !== xe && (this.style = xe, this._evaluationZoom = void 0);
            const ir = xe.terrain.properties, ar = xe.terrain.drapeRenderMode === 0, yr = xe.terrain.isZoomDependent();
            this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = ne.q.now();
            const Tr = xe.terrain && xe.terrain.scope, $r = ir.get("source"), Dr = ar ? this._mockSourceCache : xe.getSourceCache($r, Tr);
            if (!Dr)
              return void ne.w(`Couldn't find terrain source "${$r}".`);
            if (this.sourceCache = Dr, this._attenuationRange = xe.terrain.getAttenuationRange(), this._exaggeration = yr ? this.calculateExaggeration(ke) : ir.get("exaggeration"), !ke.projection.requiresDraping && yr && this._exaggeration === 0)
              return void this._disable();
            this.enabled = !0;
            const Or = () => {
              this.sourceCache.used && ne.w(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.
This leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
              const Gr = this.getScaledDemTileSize();
              this.sourceCache.update(ke, Gr, !0), this.resetTileLookupCache(this.sourceCache.id);
            };
            this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = !0, Or(), this._initializing = !0), Or(), ke.updateElevation(!0, He), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(ke), this._emptyDEMTextureDirty = !0, this._previousZoom = ke.zoom;
          } else
            this._disable();
        }
        calculateExaggeration(xe) {
          if (this._attenuationRange && xe.zoom >= Math.ceil(this._attenuationRange[1]))
            return this._style.terrain.getExaggeration(xe.zoom);
          const ke = this._previousCameraAltitude, He = xe.getFreeCameraOptions().position.z / xe.pixelsPerMeter * xe.worldSize;
          this._previousCameraAltitude = He;
          const ir = ke != null ? He - ke : Number.MAX_VALUE;
          if (Math.abs(ir) < 2)
            return this._exaggeration;
          const ar = xe.zoom, yr = this._style.terrain;
          if (!this._previousUpdateTimestamp)
            return yr.getExaggeration(ar);
          let Tr = ar - this._previousZoom;
          const $r = this._previousUpdateTimestamp;
          let Dr = ar;
          this._evaluationZoom != null && (Dr = this._evaluationZoom, Math.abs(ar - Dr) > 0.5 && (Tr = 0.5 * (ar - Dr + Tr)), Tr * ir < 0 && (Dr += Tr)), this._evaluationZoom = Dr;
          const Or = yr.getExaggeration(Dr), Gr = Or === yr.getExaggeration(Math.max(0, Dr - 0.1));
          if (Gr && Math.abs(Or - this._exaggeration) < 0.01)
            return Or;
          let qr = Math.min(0.1, 375e-5 * (this._updateTimestamp - $r));
          return (Gr || Or < 0.1 || Math.abs(Tr) < 1e-4) && (qr = Math.min(0.2, 4 * qr)), ne.af(this._exaggeration, Or, qr);
        }
        resetTileLookupCache(xe) {
          this._findCoveringTileCache[xe] = {};
        }
        attenuationRange() {
          return this._attenuationRange;
        }
        getDemUpscale() {
          return this.proxySourceCache.getSource().tileSize / 128;
        }
        getScaledDemTileSize() {
          return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
        }
        _onStyleDataEvent(xe) {
          xe.coord && xe.dataType === "source" ? this._clearRenderCacheForTile(xe.sourceCacheId, xe.coord) : xe.dataType === "style" && (this.invalidateRenderCache = !0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
        }
        _disable() {
          if (this.enabled && (this.enabled = !1, this._emptyDEMTextureDirty = !0, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style))
            for (const xe in this._style._mergedSourceCaches)
              this._style._mergedSourceCaches[xe].usedForTerrain = !1;
        }
        destroy() {
          this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this.pool.forEach((xe) => xe.fb.destroy()), this.pool = [], this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
        }
        _source() {
          return this.enabled ? this.sourceCache : null;
        }
        isUsingMockSource() {
          return this.sourceCache === this._mockSourceCache;
        }
        exaggeration() {
          return this.enabled ? this._exaggeration : 0;
        }
        get visibleDemTiles() {
          return this._visibleDemTiles;
        }
        get drapeBufferSize() {
          const xe = 2 * this.proxySourceCache.getSource().tileSize;
          return [xe, xe];
        }
        set useVertexMorphing(xe) {
          this._useVertexMorphing = xe;
        }
        updateTileBinding(xe) {
          if (!this.enabled)
            return;
          this.prevTerrainTileForTile = this.terrainTileForTile;
          const ke = this.proxySourceCache, He = this.painter.transform;
          this._initializing && (this._initializing = He._centerAltitude === 0 && this.getAtPointOrZero(ne.aa.fromLngLat(He.center), -1) === -1, this._emptyDEMTextureDirty = !this._initializing);
          const ir = this.proxyCoords = ke.getIds().map(($r) => {
            const Dr = ke.getTileByID($r).tileID;
            return Dr.projMatrix = He.calculateProjMatrix(Dr.toUnwrapped()), Dr;
          });
          (function($r, Dr) {
            const Or = Dr.transform.pointCoordinate(Dr.transform.getCameraPoint()), Gr = new ne.P(Or.x, Or.y);
            $r.sort((qr, Jr) => {
              if (Jr.overscaledZ - qr.overscaledZ)
                return Jr.overscaledZ - qr.overscaledZ;
              const bi = new ne.P(qr.canonical.x + (1 << qr.canonical.z) * qr.wrap, qr.canonical.y), fi = new ne.P(Jr.canonical.x + (1 << Jr.canonical.z) * Jr.wrap, Jr.canonical.y), Mi = Gr.mult(1 << qr.canonical.z);
              return Mi.x -= 0.5, Mi.y -= 0.5, Mi.distSqr(bi) - Mi.distSqr(fi);
            });
          })(ir, this.painter);
          const ar = this.proxyToSource || {};
          this.proxyToSource = {}, ir.forEach(($r) => {
            this.proxyToSource[$r.key] = {};
          }), this.terrainTileForTile = {};
          const yr = this._style._mergedSourceCaches;
          for (const $r in yr) {
            const Dr = yr[$r];
            if (!Dr.used || (Dr !== this.sourceCache && this.resetTileLookupCache(Dr.id), this._setupProxiedCoordsForOrtho(Dr, xe[$r], ar), Dr.usedForTerrain))
              continue;
            const Or = xe[$r];
            Dr.getSource().reparseOverscaled && this._assignTerrainTiles(Or);
          }
          this.proxiedCoords[ke.id] = ir.map(($r) => new Ff($r, $r.key, this.orthoMatrix)), this._assignTerrainTiles(ir), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(ar), this.renderingToTexture = !1;
          const Tr = {};
          this._visibleDemTiles = [];
          for (const $r of this.proxyCoords) {
            const Dr = this.terrainTileForTile[$r.key];
            if (!Dr)
              continue;
            const Or = Dr.tileID.key;
            Or in Tr || (this._visibleDemTiles.push(Dr), Tr[Or] = Or);
          }
        }
        _assignTerrainTiles(xe) {
          this._initializing || xe.forEach((ke) => {
            if (this.terrainTileForTile[ke.key])
              return;
            const He = this._findTileCoveringTileID(ke, this.sourceCache);
            He && (this.terrainTileForTile[ke.key] = He);
          });
        }
        _prepareDEMTextures() {
          const xe = this.painter.context, ke = xe.gl;
          for (const He in this.terrainTileForTile) {
            const ir = this.terrainTileForTile[He], ar = ir.dem;
            !ar || ir.demTexture && !ir.needsDEMTextureUpload || (xe.activeTexture.set(ke.TEXTURE1), Rf(this.painter, ir, ar));
          }
        }
        _prepareDemTileUniforms(xe, ke, He, ir) {
          if (!ke || ke.demTexture == null)
            return !1;
          const ar = xe.tileID.canonical, yr = Math.pow(2, ke.tileID.canonical.z - ar.z), Tr = ir || "";
          return He[`u_dem_tl${Tr}`] = [ar.x * yr % 1, ar.y * yr % 1], He[`u_dem_scale${Tr}`] = yr, !0;
        }
        get emptyDEMTexture() {
          return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
        }
        _getLoadedAreaMinimum() {
          if (!this.enabled)
            return 0;
          let xe = 0;
          const ke = this._visibleDemTiles.reduce((He, ir) => {
            if (!ir.dem)
              return He;
            const ar = ir.dem.tree.minimums[0];
            return ar > 0 && xe++, He + ar;
          }, 0);
          return xe ? ke / xe : 0;
        }
        _updateEmptyDEMTexture() {
          const xe = this.painter.context, ke = xe.gl;
          xe.activeTexture.set(ke.TEXTURE2);
          const He = this._getLoadedAreaMinimum(), ir = new ne.cK({ width: 1, height: 1 }, new Float32Array([He]));
          this._emptyDEMTextureDirty = !1;
          let ar = this._emptyDEMTexture;
          return ar ? ar.update(ir, { premultiply: !1 }) : ar = this._emptyDEMTexture = new ne.T(xe, ir, ke.R32F, { premultiply: !1 }), ar;
        }
        setupElevationDraw(xe, ke, He) {
          const ir = this.painter.context, ar = ir.gl, yr = { u_dem: 2, u_dem_prev: 4, u_dem_tl: [0, 0], u_dem_tl_prev: [0, 0], u_dem_scale: 0, u_dem_scale_prev: 0, u_dem_size: 0, u_dem_lerp: 1, u_depth: 3, u_depth_size_inv: [0, 0], u_depth_range_unpack: [0, 1], u_occluder_half_size: 16, u_occlusion_depth_offset: -1e-4, u_exaggeration: 0 };
          yr.u_exaggeration = this.exaggeration();
          let Tr = null, $r = null, Dr = 1;
          if (He && He.morphing && this._useVertexMorphing) {
            const Jr = He.morphing.srcDemTile, bi = He.morphing.dstDemTile;
            Dr = He.morphing.phase, Jr && bi && (this._prepareDemTileUniforms(xe, Jr, yr, "_prev") && ($r = Jr), this._prepareDemTileUniforms(xe, bi, yr) && (Tr = bi));
          }
          const Or = (Jr) => Jr && Jr.demTexture && this.painter.linearFloatFilteringSupported() ? ar.LINEAR : ar.NEAREST;
          let Gr = null;
          var qr;
          if (this.enabled ? $r && Tr ? (Gr = Tr.demTexture, ir.activeTexture.set(ar.TEXTURE4), $r.demTexture.bind(Or($r), ar.CLAMP_TO_EDGE), yr.u_dem_lerp = Dr) : (Tr = this.terrainTileForTile[xe.tileID.key], Gr = this._prepareDemTileUniforms(xe, Tr, yr) ? Tr.demTexture : this.emptyDEMTexture) : Gr = this.emptyDEMTexture, ir.activeTexture.set(ar.TEXTURE2), Gr && (yr.u_dem_size = (qr = Gr).size[0] === 1 ? 1 : qr.size[0] - 2, Gr.bind(Or(Tr), ar.CLAMP_TO_EDGE)), this.painter.setupDepthForOcclusion(He && He.useDepthForOcclusion, ke, yr), He && He.useMeterToDem && Tr) {
            const Jr = (1 << Tr.tileID.canonical.z) * ne.bH(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
            yr.u_meter_to_dem = Jr;
          }
          if (He && He.labelPlaneMatrixInv && (yr.u_label_plane_matrix_inv = He.labelPlaneMatrixInv), ke.setTerrainUniformValues(ir, yr), this.painter.transform.projection.name === "globe") {
            const Jr = this.globeUniformValues(this.painter.transform, xe.tileID.canonical, He && He.useDenormalizedUpVectorScale);
            ke.setGlobeUniformValues(ir, Jr);
          }
        }
        globeUniformValues(xe, ke, He) {
          const ir = xe.projection;
          return { u_tile_tl_up: ir.upVector(ke, 0, 0), u_tile_tr_up: ir.upVector(ke, ne.ag, 0), u_tile_br_up: ir.upVector(ke, ne.ag, ne.ag), u_tile_bl_up: ir.upVector(ke, 0, ne.ag), u_tile_up_scale: He ? ne.cL(1) : ir.upVectorScale(ke, xe.center.lat, xe.worldSize).metersToTile };
        }
        renderToBackBuffer(xe) {
          const ke = this.painter, He = this.painter.context;
          xe.length !== 0 && (He.bindFramebuffer.set(null), He.viewport.set([0, 0, ke.width, ke.height]), ke.gpuTimingDeferredRenderStart(), this.renderingToTexture = !1, function(ir, ar, yr, Tr, $r) {
            if (ir.transform.projection.name === "globe")
              (function(Dr, Or, Gr, qr, Jr) {
                const bi = Dr.context, fi = bi.gl;
                let Mi, Ei;
                const Ii = Dr.transform, Ni = ne.cC(Dr, bi, Ii), zi = (hn, xn) => {
                  if (Ei === xn)
                    return;
                  const Hn = [Da[xn], "PROJECTION_GLOBE_VIEW"];
                  Ni && Hn.push("CUSTOM_ANTIALIASING");
                  const io = Dr.isTileAffectedByFog(hn);
                  Mi = Dr.getOrCreateProgram("globeRaster", { defines: Hn, overrideFog: io }), Ei = xn;
                }, Ki = Dr.colorModeForRenderPass(), Wi = new Oo(fi.LEQUAL, Oo.ReadWrite, Dr.depthRangeFor3D);
                el.update(Jr);
                const Xi = ne.cD(Ii), Gi = [ne.at(Ii.center.lng), ne.aA(Ii.center.lat)], nn = Dr.globeSharedBuffers, dn = [Ii.width * ne.q.devicePixelRatio, Ii.height * ne.q.devicePixelRatio], Pn = Float32Array.from(Ii.globeMatrix), Ln = { useDenormalizedUpVectorScale: !0 };
                {
                  const hn = Dr.transform, xn = Vp(hn.zoom, Or.exaggeration(), Or.sourceCache._source.tileSize);
                  Ei = -1;
                  const Hn = fi.TRIANGLES;
                  for (const io of qr) {
                    const uo = Gr.getTile(io), An = ta.disabled, eo = Or.prevTerrainTileForTile[io.key], On = Or.terrainTileForTile[io.key];
                    Hh(eo, On) && el.newMorphing(io.key, eo, On, Jr, 250), bi.activeTexture.set(fi.TEXTURE0), uo.texture && uo.texture.bind(fi.LINEAR, fi.CLAMP_TO_EDGE);
                    const ao = el.getMorphValuesForProxy(io.key), ro = ao ? 1 : 0;
                    ao && ne.J(Ln, { morphing: { srcDemTile: ao.from, dstDemTile: ao.to, phase: ne.cB(ao.phase) } });
                    const Wn = ne.cE(io.canonical), _o = ne.cF(Wn.getCenter().lat), yo = ne.cG(io.canonical, Wn, _o, hn.worldSize / hn._pixelsPerMercatorPixel), mo = ne.bb(ne.cH(io.canonical)), Eo = Tu(hn.expandedFarZProjMatrix, Pn, Xi, mo, ne.ae(hn.zoom), Gi, hn.frustumCorners.TL, hn.frustumCorners.TR, hn.frustumCorners.BR, hn.frustumCorners.BL, hn.globeCenterInViewSpace, hn.globeRadius, dn, xn, hn._farZ, yo);
                    if (zi(io, ro), Mi && (Or.setupElevationDraw(uo, Mi, Ln), Dr.uploadCommonUniforms(bi, Mi, io.toUnwrapped()), nn)) {
                      const [Ko, Fo, zo] = nn.getGridBuffers(_o, xn !== 0);
                      Mi.draw(Dr, Hn, Wi, An, Ki, Uo.backCCW, Eo, "globe_raster", Ko, Fo, zo);
                    }
                  }
                }
                if (nn && (Dr.renderDefaultNorthPole || Dr.renderDefaultSouthPole)) {
                  const hn = ["GLOBE_POLES", "PROJECTION_GLOBE_VIEW"];
                  Ni && hn.push("CUSTOM_ANTIALIASING"), Mi = Dr.getOrCreateProgram("globeRaster", { defines: hn });
                  for (const xn of qr) {
                    const { x: Hn, y: io, z: uo } = xn.canonical, An = io === 0, eo = io === (1 << uo) - 1, [On, ao, ro, Wn] = nn.getPoleBuffers(uo, !1);
                    if (Wn && (An || eo)) {
                      const _o = Gr.getTile(xn);
                      bi.activeTexture.set(fi.TEXTURE0), _o.texture && _o.texture.bind(fi.LINEAR, fi.CLAMP_TO_EDGE);
                      let yo = ne.cI(uo, Hn, Ii);
                      const mo = ne.bb(ne.cH(xn.canonical)), Eo = (Ko, Fo) => Ko.draw(Dr, fi.TRIANGLES, Wi, ta.disabled, Ki, Uo.disabled, Tu(Ii.expandedFarZProjMatrix, yo, yo, mo, 0, Gi, Ii.frustumCorners.TL, Ii.frustumCorners.TR, Ii.frustumCorners.BR, Ii.frustumCorners.BL, Ii.globeCenterInViewSpace, Ii.globeRadius, dn, 0, Ii._farZ), "globe_pole_raster", Fo, ro, Wn);
                      Or.setupElevationDraw(_o, Mi, Ln), Dr.uploadCommonUniforms(bi, Mi, xn.toUnwrapped()), An && Dr.renderDefaultNorthPole && Eo(Mi, On), eo && Dr.renderDefaultSouthPole && (yo = ne.ab.mat4.scale(ne.ab.mat4.create(), yo, [1, -1, 1]), Eo(Mi, ao));
                    }
                  }
                }
              })(ir, ar, yr, Tr, $r);
            else {
              const Dr = ir.context, Or = Dr.gl;
              let Gr, qr;
              const Jr = ir.shadowRenderer, bi = Tc(ir, ir.longestCutoffRange), fi = (Ki) => {
                if (qr === Ki)
                  return;
                const Wi = [];
                Wi.push(Da[Ki]), bi.shouldRenderCutoff && Wi.push("RENDER_CUTOFF"), Jr && (Wi.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), Jr.useNormalOffset && Wi.push("NORMAL_OFFSET")), Gr = ir.getOrCreateProgram("terrainRaster", { defines: Wi }), qr = Ki;
              }, Mi = ir.colorModeForRenderPass(), Ei = new Oo(Or.LEQUAL, Oo.ReadWrite, ir.depthRangeFor3D);
              el.update($r);
              const Ii = ir.transform, Ni = Vp(Ii.zoom, ar.exaggeration(), ar.sourceCache._source.tileSize);
              let zi = [0, 0, 0];
              if (Jr) {
                const Ki = ir.style.directionalLight, Wi = ir.style.ambientLight;
                Ki && Wi && (zi = Ac(ir.style, Ki, Wi));
              }
              {
                qr = -1;
                const Ki = Or.TRIANGLES, [Wi, Xi] = [ar.gridIndexBuffer, ar.gridSegments];
                for (const Gi of Tr) {
                  const nn = yr.getTile(Gi), dn = ta.disabled, Pn = ar.prevTerrainTileForTile[Gi.key], Ln = ar.terrainTileForTile[Gi.key];
                  Hh(Pn, Ln) && el.newMorphing(Gi.key, Pn, Ln, $r, 250), Dr.activeTexture.set(Or.TEXTURE0), nn.texture && nn.texture.bind(Or.LINEAR, Or.CLAMP_TO_EDGE);
                  const hn = el.getMorphValuesForProxy(Gi.key), xn = hn ? 1 : 0;
                  let Hn;
                  hn && (Hn = { morphing: { srcDemTile: hn.from, dstDemTile: hn.to, phase: ne.cB(hn.phase) } });
                  const io = Zi(Gi.projMatrix, Au(Gi.canonical, Ii.renderWorldCopies) ? Ni / 10 : Ni, zi);
                  if (fi(xn), !Gr)
                    continue;
                  ar.setupElevationDraw(nn, Gr, Hn);
                  const uo = Gi.toUnwrapped();
                  Jr && Jr.setupShadows(uo, Gr), ir.uploadCommonUniforms(Dr, Gr, uo, null, bi), Gr.draw(ir, Ki, Ei, dn, Mi, Uo.backCCW, io, "terrain_raster", ar.gridBuffer, Wi, Xi);
                }
              }
            }
          }(ke, this, this.proxySourceCache, xe, this._updateTimestamp), this.renderingToTexture = !0, ke.gpuTimingDeferredRenderEnd(), xe.splice(0, xe.length));
        }
        renderBatch(xe) {
          if (this._drapedRenderBatches.length === 0)
            return xe + 1;
          this.renderingToTexture = !0;
          const ke = this.painter, He = this.painter.context, ir = this.proxySourceCache, ar = this.proxiedCoords[ir.id], yr = this._drapedRenderBatches.shift(), Tr = ke.style.order, $r = [];
          let Dr = 0;
          for (const Or of ar) {
            const Gr = ir.getTileByID(Or.proxyTileKey), qr = ir.proxyCachedFBO[Or.key] ? ir.proxyCachedFBO[Or.key][xe] : void 0, Jr = qr !== void 0 ? ir.renderCache[qr] : this.pool[Dr++], bi = qr !== void 0;
            if (Gr.texture = Jr.tex, bi && !Jr.dirty) {
              $r.push(Gr.tileID);
              continue;
            }
            let fi;
            He.bindFramebuffer.set(Jr.fb.framebuffer), this.renderedToTile = !1, Jr.dirty && (He.clear({ color: ne.aj.transparent, stencil: 0 }), Jr.dirty = !1);
            for (let Mi = yr.start; Mi <= yr.end; ++Mi) {
              const Ei = ke.style._mergedLayers[Tr[Mi]];
              if (Ei.isHidden(ke.transform.zoom))
                continue;
              const Ii = ke.style.getLayerSourceCache(Ei), Ni = Ii ? this.proxyToSource[Or.key][Ii.id] : [Or];
              if (!Ni)
                continue;
              const zi = Ni;
              He.viewport.set([0, 0, Jr.fb.width, Jr.fb.height]), fi !== (Ii ? Ii.id : null) && (this._setupStencil(Jr, Ni, Ei, Ii), fi = Ii ? Ii.id : null), ke.renderLayer(ke, Ii, Ei, zi);
            }
            if (this._drapedRenderBatches.length === 0)
              for (const Mi of this._pendingGroundEffectLayers) {
                const Ei = ke.style._mergedLayers[Tr[Mi]];
                if (Ei.isHidden(ke.transform.zoom))
                  continue;
                const Ii = ke.style.getLayerSourceCache(Ei), Ni = Ii ? this.proxyToSource[Or.key][Ii.id] : [Or];
                if (!Ni)
                  continue;
                const zi = Ni;
                He.viewport.set([0, 0, Jr.fb.width, Jr.fb.height]), fi !== (Ii ? Ii.id : null) && (this._setupStencil(Jr, Ni, Ei, Ii), fi = Ii ? Ii.id : null), ke.renderLayer(ke, Ii, Ei, zi);
              }
            this.renderedToTile ? (Jr.dirty = !0, $r.push(Gr.tileID)) : bi || --Dr, Dr === 5 && (Dr = 0, this.renderToBackBuffer($r));
          }
          return this.renderToBackBuffer($r), this.renderingToTexture = !1, He.bindFramebuffer.set(null), He.viewport.set([0, 0, ke.width, ke.height]), yr.end + 1;
        }
        postRender() {
        }
        isLayerOrderingCorrect(xe) {
          const ke = xe.order.length;
          let He = -1, ir = ke;
          for (let ar = 0; ar < ke; ++ar)
            this._style.isLayerDraped(xe._mergedLayers[xe.order[ar]]) ? He = Math.max(He, ar) : ir = Math.min(ir, ar);
          return ir > He;
        }
        getMinElevationBelowMSL() {
          let xe = 0;
          return this._visibleDemTiles.filter((ke) => ke.dem).forEach((ke) => {
            xe = Math.min(xe, ke.dem.tree.minimums[0]);
          }), xe === 0 ? xe : (xe - 30) * this._exaggeration;
        }
        raycast(xe, ke, He) {
          if (!this._visibleDemTiles)
            return null;
          const ir = this._visibleDemTiles.filter((ar) => ar.dem).map((ar) => {
            const yr = ar.tileID, Tr = 1 << yr.overscaledZ, { x: $r, y: Dr } = yr.canonical, Or = $r / Tr, Gr = ($r + 1) / Tr, qr = Dr / Tr, Jr = (Dr + 1) / Tr;
            return { minx: Or, miny: qr, maxx: Gr, maxy: Jr, t: ar.dem.tree.raycastRoot(Or, qr, Gr, Jr, xe, ke, He), tile: ar };
          });
          ir.sort((ar, yr) => (ar.t !== null ? ar.t : Number.MAX_VALUE) - (yr.t !== null ? yr.t : Number.MAX_VALUE));
          for (const ar of ir) {
            if (ar.t == null)
              return null;
            const yr = ar.tile.dem.tree.raycast(ar.minx, ar.miny, ar.maxx, ar.maxy, xe, ke, He);
            if (yr != null)
              return yr;
          }
          return null;
        }
        _createFBO() {
          const xe = this.painter.context, ke = xe.gl, He = this.drapeBufferSize;
          xe.activeTexture.set(ke.TEXTURE0);
          const ir = new ne.T(xe, { width: He[0], height: He[1], data: null }, ke.RGBA8);
          ir.bind(ke.LINEAR, ke.CLAMP_TO_EDGE);
          const ar = xe.createFramebuffer(He[0], He[1], !0, null);
          return ar.colorAttachment.set(ir.texture), ar.depthAttachment = new oh(xe, ar.framebuffer), this._sharedDepthStencil === void 0 ? (this._sharedDepthStencil = xe.createRenderbuffer(xe.gl.DEPTH_STENCIL, He[0], He[1]), this._stencilRef = 0, ar.depthAttachment.set(this._sharedDepthStencil), xe.clear({ stencil: 0 })) : ar.depthAttachment.set(this._sharedDepthStencil), xe.extTextureFilterAnisotropic && ke.texParameterf(ke.TEXTURE_2D, xe.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, xe.extTextureFilterAnisotropicMax), { fb: ar, tex: ir, dirty: !1 };
        }
        _initFBOPool() {
          for (; this.pool.length < Math.min(5, this.proxyCoords.length); )
            this.pool.push(this._createFBO());
        }
        _shouldDisableRenderCache() {
          if (this._debugParams.disableRenderCache || this._style.hasLightTransitions())
            return !0;
          for (const xe in this._style._mergedSourceCaches)
            if (this._style._mergedSourceCaches[xe].hasTransition())
              return !0;
          return this._style.order.some((xe) => {
            const ke = this._style._mergedLayers[xe], He = ke.isHidden(this.painter.transform.zoom);
            return ke.type === "hillshade" || ke.type === "custom" ? !He && ke.shouldRedrape() : !He && ke.hasTransition();
          });
        }
        _clearLineLayersFromRenderCache() {
          let xe = !1;
          for (const He of this._style.getSources())
            if (He instanceof hs) {
              xe = !0;
              break;
            }
          if (!xe)
            return;
          const ke = {};
          for (let He = 0; He < this._style.order.length; ++He) {
            const ir = this._style._mergedLayers[this._style.order[He]], ar = this._style.getLayerSourceCache(ir);
            if (ar && !ke[ar.id] && !ir.isHidden(this.painter.transform.zoom) && ir.type === "line" && ir.widthExpression() instanceof ne.a9) {
              ke[ar.id] = !0;
              for (const yr of this.proxyCoords) {
                const Tr = this.proxyToSource[yr.key][ar.id];
                if (Tr)
                  for (const $r of Tr)
                    this._clearRenderCacheForTile(ar.id, $r);
              }
            }
          }
        }
        _clearRasterLayersFromRenderCache() {
          let xe = !1;
          for (const He in this._style._mergedSourceCaches)
            if (this._style._mergedSourceCaches[He]._source instanceof Fc) {
              xe = !0;
              break;
            }
          if (!xe)
            return;
          const ke = {};
          for (let He = 0; He < this._style.order.length; ++He) {
            const ir = this._style._mergedLayers[this._style.order[He]], ar = this._style.getLayerSourceCache(ir);
            if (!ar || ke[ar.id] || ir.isHidden(this.painter.transform.zoom) || ir.type !== "raster")
              continue;
            const yr = ir.paint.get("raster-fade-duration");
            for (const Tr of this.proxyCoords) {
              const $r = this.proxyToSource[Tr.key][ar.id];
              if ($r)
                for (const Dr of $r) {
                  const Or = pc(ar.getTile(Dr), ar.findLoadedParent(Dr, 0), ar, this.painter.transform, yr);
                  (Or.opacity !== 1 || Or.mix !== 0) && this._clearRenderCacheForTile(ar.id, Dr);
                }
            }
          }
        }
        _setupDrapedRenderBatches() {
          this._style.updateDrapeFirstLayers();
          const xe = this._style.order, ke = xe.length;
          if (ke === 0)
            return;
          const He = [];
          this._pendingGroundEffectLayers = [];
          let ir, ar = 0, yr = this._style._mergedLayers[xe[ar]];
          for (; !this._style.isLayerDraped(yr) && yr.isHidden(this.painter.transform.zoom) && ++ar < ke; )
            yr = this._style._mergedLayers[xe[ar]];
          for (; ar < ke; ++ar) {
            const Tr = this._style._mergedLayers[xe[ar]];
            Tr.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(Tr) ? ir === void 0 && (ir = ar) : (Tr.type === "fill-extrusion" && this._pendingGroundEffectLayers.push(ar), ir !== void 0 && (He.push({ start: ir, end: ar - 1 }), ir = void 0)));
          }
          if (ir !== void 0 && He.push({ start: ir, end: ar - 1 }), He.length !== 0) {
            const Tr = He[He.length - 1];
            this._pendingGroundEffectLayers.every(($r) => $r > Tr.end) || ne.w("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
          }
          this._drapedRenderBatches = He;
        }
        _setupRenderCache(xe) {
          const ke = this.proxySourceCache;
          if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
            if (this.invalidateRenderCache = !1, ke.renderCache.length > ke.renderCachePool.length) {
              const yr = Object.values(ke.proxyCachedFBO);
              ke.proxyCachedFBO = {};
              for (let Tr = 0; Tr < yr.length; ++Tr) {
                const $r = Object.values(yr[Tr]);
                ke.renderCachePool.push(...$r);
              }
            }
            return;
          }
          this._clearRasterLayersFromRenderCache();
          const He = this.proxyCoords, ir = this._tilesDirty;
          for (let yr = He.length - 1; yr >= 0; yr--) {
            const Tr = He[yr];
            if (ke.getTileByID(Tr.key), ke.proxyCachedFBO[Tr.key] !== void 0) {
              const $r = xe[Tr.key], Dr = this.proxyToSource[Tr.key];
              let Or = 0;
              for (const Gr in Dr) {
                const qr = Dr[Gr], Jr = $r[Gr];
                if (!Jr || Jr.length !== qr.length || qr.some((bi, fi) => bi !== Jr[fi] || ir[Gr] && ir[Gr].hasOwnProperty(bi.key))) {
                  Or = -1;
                  break;
                }
                ++Or;
              }
              for (const Gr in ke.proxyCachedFBO[Tr.key])
                ke.renderCache[ke.proxyCachedFBO[Tr.key][Gr]].dirty = Or < 0 || Or !== Object.values($r).length;
            }
          }
          const ar = [...this._drapedRenderBatches];
          ar.sort((yr, Tr) => Tr.end - Tr.start - (yr.end - yr.start));
          for (const yr of ar)
            for (const Tr of He) {
              if (ke.proxyCachedFBO[Tr.key])
                continue;
              let $r = ke.renderCachePool.pop();
              $r === void 0 && ke.renderCache.length < 50 && ($r = ke.renderCache.length, ke.renderCache.push(this._createFBO())), $r !== void 0 && (ke.proxyCachedFBO[Tr.key] = {}, ke.proxyCachedFBO[Tr.key][yr.start] = $r, ke.renderCache[$r].dirty = !0);
            }
          this._tilesDirty = {};
        }
        _setupStencil(xe, ke, He, ir) {
          if (!ir || !this._sourceTilesOverlap[ir.id])
            return void (this._overlapStencilType && (this._overlapStencilType = !1));
          const ar = this.painter.context, yr = ar.gl;
          if (ke.length <= 1)
            return void (this._overlapStencilType = !1);
          let Tr;
          if (He.isTileClipped())
            Tr = ke.length, this._overlapStencilMode.test = { func: yr.EQUAL, mask: 255 }, this._overlapStencilType = "Clip";
          else {
            if (!(ke[0].overscaledZ > ke[ke.length - 1].overscaledZ))
              return void (this._overlapStencilType = !1);
            Tr = 1, this._overlapStencilMode.test = { func: yr.GREATER, mask: 255 }, this._overlapStencilType = "Mask";
          }
          this._stencilRef + Tr > 255 && (ar.clear({ stencil: 0 }), this._stencilRef = 0), this._stencilRef += Tr, this._overlapStencilMode.ref = this._stencilRef, He.isTileClipped() && this._renderTileClippingMasks(ke, this._overlapStencilMode.ref);
        }
        clipOrMaskOverlapStencilType() {
          return this._overlapStencilType === "Clip" || this._overlapStencilType === "Mask";
        }
        stencilModeForRTTOverlap(xe) {
          return this.renderingToTexture && this._overlapStencilType ? (this._overlapStencilType === "Clip" && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[xe.key]), this._overlapStencilMode) : ta.disabled;
        }
        _renderTileClippingMasks(xe, ke) {
          const He = this.painter, ir = this.painter.context, ar = ir.gl;
          He._tileClippingMaskIDs = {}, ir.setColorMode(aa.disabled), ir.setDepthMode(Oo.disabled);
          const yr = He.getOrCreateProgram("clippingMask");
          for (const Tr of xe) {
            const $r = He._tileClippingMaskIDs[Tr.key] = --ke;
            yr.draw(He, ar.TRIANGLES, Oo.disabled, new ta({ func: ar.ALWAYS, mask: 0 }, $r, 255, ar.KEEP, ar.KEEP, ar.REPLACE), aa.disabled, Uo.disabled, Dd(Tr.projMatrix), "$clipping", He.tileExtentBuffer, He.quadTriangleIndexBuffer, He.tileExtentSegments);
          }
        }
        pointCoordinate(xe) {
          const ke = this.painter.transform;
          if (xe.x < 0 || xe.x > ke.width || xe.y < 0 || xe.y > ke.height)
            return null;
          const He = [xe.x, xe.y, 1, 1];
          ne.ab.vec4.transformMat4(He, He, ke.pixelMatrixInverse), ne.ab.vec4.scale(He, He, 1 / He[3]), He[0] /= ke.worldSize, He[1] /= ke.worldSize;
          const ir = ke._camera.position, ar = ne.bH(1, ke.center.lat), yr = [ir[0], ir[1], ir[2] / ar, 0], Tr = ne.ab.vec3.subtract([], He.slice(0, 3), yr);
          ne.ab.vec3.normalize(Tr, Tr);
          const $r = this.raycast(yr, Tr, this._exaggeration);
          return $r !== null && $r ? (ne.ab.vec3.scaleAndAdd(yr, yr, Tr, $r), yr[3] = yr[2], yr[2] *= ar, yr) : null;
        }
        _setupProxiedCoordsForOrtho(xe, ke, He) {
          if (xe.getSource() instanceof ne.aJ)
            return this._setupProxiedCoordsForImageSource(xe, ke, He);
          this._findCoveringTileCache[xe.id] = this._findCoveringTileCache[xe.id] || {};
          const ir = this.proxiedCoords[xe.id] = [], ar = this.proxyCoords;
          for (let $r = 0; $r < ar.length; $r++) {
            const Dr = ar[$r], Or = this._findTileCoveringTileID(Dr, xe);
            if (Or) {
              const Gr = this._createProxiedId(Dr, Or, He[Dr.key] && He[Dr.key][xe.id]);
              ir.push(Gr), this.proxyToSource[Dr.key][xe.id] = [Gr];
            }
          }
          let yr = !1;
          const Tr = /* @__PURE__ */ new Set();
          for (let $r = 0; $r < ke.length; $r++) {
            const Dr = xe.getTile(ke[$r]);
            if (!Dr || !Dr.hasData())
              continue;
            const Or = this._findTileCoveringTileID(Dr.tileID, this.proxySourceCache);
            if (Or && Or.tileID.canonical.z !== Dr.tileID.canonical.z) {
              const Gr = this.proxyToSource[Or.tileID.key][xe.id], qr = this._createProxiedId(Or.tileID, Dr, He[Or.tileID.key] && He[Or.tileID.key][xe.id]);
              Gr ? Gr.splice(Gr.length - 1, 0, qr) : this.proxyToSource[Or.tileID.key][xe.id] = [qr];
              const Jr = this.proxyToSource[Or.tileID.key][xe.id];
              Tr.has(Jr) || Tr.add(Jr), ir.push(qr), yr = !0;
            }
          }
          if (this._sourceTilesOverlap[xe.id] = yr, yr && this._debugParams.sortTilesHiZFirst)
            for (const $r of Tr)
              $r.sort((Dr, Or) => Or.overscaledZ - Dr.overscaledZ);
        }
        _setupProxiedCoordsForImageSource(xe, ke, He) {
          if (!xe.getSource().loaded())
            return;
          const ir = this.proxiedCoords[xe.id] = [], ar = this.proxyCoords, yr = xe.getSource(), Tr = yr.tileID;
          if (!Tr)
            return;
          const $r = new ne.P(Tr.x, Tr.y)._div(1 << Tr.z), Dr = yr.coordinates.map(ne.aa.fromLngLat).reduce((Gr, qr) => (Gr.min.x = Math.min(Gr.min.x, qr.x - $r.x), Gr.min.y = Math.min(Gr.min.y, qr.y - $r.y), Gr.max.x = Math.max(Gr.max.x, qr.x - $r.x), Gr.max.y = Math.max(Gr.max.y, qr.y - $r.y), Gr), { min: new ne.P(Number.MAX_VALUE, Number.MAX_VALUE), max: new ne.P(-Number.MAX_VALUE, -Number.MAX_VALUE) }), Or = (Gr, qr) => {
            const Jr = Gr.wrap + Gr.canonical.x / (1 << Gr.canonical.z), bi = Gr.canonical.y / (1 << Gr.canonical.z), fi = ne.ag / (1 << Gr.canonical.z), Mi = qr.wrap + qr.canonical.x / (1 << qr.canonical.z), Ei = qr.canonical.y / (1 << qr.canonical.z);
            return Jr + fi < Mi + Dr.min.x || Jr > Mi + Dr.max.x || bi + fi < Ei + Dr.min.y || bi > Ei + Dr.max.y;
          };
          for (let Gr = 0; Gr < ar.length; Gr++) {
            const qr = ar[Gr];
            for (let Jr = 0; Jr < ke.length; Jr++) {
              const bi = xe.getTile(ke[Jr]);
              if (!bi || !bi.hasData() || Or(qr, bi.tileID))
                continue;
              const fi = this._createProxiedId(qr, bi, He[qr.key] && He[qr.key][xe.id]), Mi = this.proxyToSource[qr.key][xe.id];
              Mi ? Mi.push(fi) : this.proxyToSource[qr.key][xe.id] = [fi], ir.push(fi);
            }
          }
        }
        _createProxiedId(xe, ke, He) {
          let ir = this.orthoMatrix;
          if (He) {
            const ar = He.find((yr) => yr.key === ke.tileID.key);
            if (ar)
              return ar;
          }
          if (ke.tileID.key !== xe.key) {
            const ar = xe.canonical.z - ke.tileID.canonical.z;
            let yr, Tr, $r;
            ir = ne.ab.mat4.create();
            const Dr = ke.tileID.wrap - xe.wrap << xe.overscaledZ;
            ar > 0 ? (yr = ne.ag >> ar, Tr = yr * ((ke.tileID.canonical.x << ar) - xe.canonical.x + Dr), $r = yr * ((ke.tileID.canonical.y << ar) - xe.canonical.y)) : (yr = ne.ag << -ar, Tr = ne.ag * (ke.tileID.canonical.x - (xe.canonical.x + Dr << -ar)), $r = ne.ag * (ke.tileID.canonical.y - (xe.canonical.y << -ar))), ne.ab.mat4.ortho(ir, 0, yr, 0, yr, 0, 1), ne.ab.mat4.translate(ir, ir, [Tr, $r, 0]);
          }
          return new Ff(ke.tileID, xe.key, ir);
        }
        _findTileCoveringTileID(xe, ke) {
          let He = ke.getTile(xe);
          if (He && He.hasData())
            return He;
          const ir = this._findCoveringTileCache[ke.id], ar = ir[xe.key];
          if (He = ar ? ke.getTileByID(ar) : null, He && He.hasData() || ar === null)
            return He;
          let yr = He ? He.tileID : xe, Tr = yr.overscaledZ;
          const $r = ke.getSource().minzoom, Dr = [];
          if (!ar) {
            const Gr = ke.getSource().maxzoom;
            if (xe.canonical.z >= Gr) {
              const qr = xe.canonical.z - Gr;
              ke.getSource().reparseOverscaled ? (Tr = Math.max(xe.canonical.z + 2, ke.transform.tileZoom), yr = new ne.aG(Tr, xe.wrap, Gr, xe.canonical.x >> qr, xe.canonical.y >> qr)) : qr !== 0 && (Tr = Gr, yr = new ne.aG(Tr, xe.wrap, Gr, xe.canonical.x >> qr, xe.canonical.y >> qr));
            }
            yr.key !== xe.key && (Dr.push(yr.key), He = ke.getTile(yr));
          }
          const Or = (Gr) => {
            Dr.forEach((qr) => {
              ir[qr] = Gr;
            }), Dr.length = 0;
          };
          for (Tr -= 1; Tr >= $r && (!He || !He.hasData()); Tr--) {
            He && Or(He.tileID.key);
            const Gr = yr.calculateScaledKey(Tr);
            if (He = ke.getTileByID(Gr), He && He.hasData())
              break;
            const qr = ir[Gr];
            if (qr === null)
              break;
            qr === void 0 ? Dr.push(Gr) : He = ke.getTileByID(qr);
          }
          return Or(He ? He.tileID.key : null), He && He.hasData() ? He : null;
        }
        findDEMTileFor(xe) {
          return this.enabled ? this._findTileCoveringTileID(xe, this.sourceCache) : null;
        }
        prepareDrawTile() {
          this.renderedToTile = !0;
        }
        _clearRenderCacheForTile(xe, ke) {
          let He = this._tilesDirty[xe];
          He || (He = this._tilesDirty[xe] = {}), He[ke.key] = !0;
        }
      }
      function q0(qe, xe, ke) {
        const He = function(Tr, $r, Dr) {
          const Or = ne.ab.vec3.dot($r, Tr), Gr = ne.ab.vec3.dot(Dr, [0.2126, 0.7152, 0.0722]), qr = (bi, fi, Mi) => (1 - Mi) * bi + Mi * fi, Jr = qr(1 - 0.3 * Math.min(Gr, 1), 1, Math.min(Or + 1, 1));
          return qr(0.92, 1, Math.asin(ne.aw($r[2], -1, 1)) / Math.PI + 0.5) * Jr;
        }(qe, [0, 0, 1], xe), ir = [0, 0, 0];
        ne.ab.vec3.scale(ir, ke.slice(0, 3), He);
        const ar = [0, 0, 0];
        ne.ab.vec3.scale(ar, xe.slice(0, 3), qe[2]);
        const yr = [0, 0, 0];
        return ne.ab.vec3.add(yr, ir, ar), ne.cf(yr);
      }
      const qc = ["fill", "fillOutline", "fillPattern", "line", "linePattern", "background", "backgroundPattern", "hillshade", "raster"], Od = ["stars", "rainParticle", "snowParticle", "fillExtrusion", "fillExtrusionGroundEffect", "model", "symbol"];
      class Um {
        static cacheKey(xe, ke, He, ir) {
          let ar = `${ke}${ir ? ir.cacheKey : ""}`;
          for (const yr of He)
            xe.usedDefines.includes(yr) && (ar += `/${yr}`);
          return ar;
        }
        constructor(xe, ke, He, ir, ar, yr) {
          const Tr = xe.gl;
          this.program = Tr.createProgram(), this.configuration = ir, this.name = ke, this.fixedDefines = [...yr];
          const $r = ir ? ir.getBinderAttributes() : [], Dr = (He.staticAttributes || []).concat($r);
          let Or = ir ? ir.defines() : [];
          Or = Or.concat(yr.map((Mi) => `#define ${Mi}`));
          const Gr = `#version 300 es
`;
          let qr = Gr + Or.concat("precision mediump float;", $f, kd.fragmentSource).join(`
`);
          for (const Mi of He.fragmentIncludes)
            qr += `
${Eu[Mi]}`;
          qr += `
${He.fragmentSource}`;
          let Jr = Gr + Or.concat("precision highp float;", $f, kd.vertexSource).join(`
`);
          for (const Mi of He.vertexIncludes)
            Jr += `
${Eu[Mi]}`;
          this.forceManualRenderingForInstanceIDShaders = xe.forceManualRenderingForInstanceIDShaders && He.vertexSource.indexOf("gl_InstanceID") !== -1, this.forceManualRenderingForInstanceIDShaders && (Jr += `
uniform int u_instanceID;
`), Jr += `
${He.vertexSource}`, this.forceManualRenderingForInstanceIDShaders && (Jr = Jr.replaceAll("gl_InstanceID", "u_instanceID"));
          const bi = Tr.createShader(Tr.FRAGMENT_SHADER);
          if (Tr.isContextLost())
            return void (this.failedToCreate = !0);
          Tr.shaderSource(bi, qr), Tr.compileShader(bi), Tr.attachShader(this.program, bi);
          const fi = Tr.createShader(Tr.VERTEX_SHADER);
          if (Tr.isContextLost())
            this.failedToCreate = !0;
          else {
            Tr.shaderSource(fi, Jr), Tr.compileShader(fi), Tr.attachShader(this.program, fi), this.attributes = {}, this.numAttributes = Dr.length;
            for (let Mi = 0; Mi < this.numAttributes; Mi++)
              if (Dr[Mi]) {
                const Ei = Dr[Mi].startsWith("a_") ? Dr[Mi] : `a_${Dr[Mi]}`;
                Tr.bindAttribLocation(this.program, Mi, Ei), this.attributes[Ei] = Mi;
              }
            Tr.linkProgram(this.program), Tr.deleteShader(fi), Tr.deleteShader(bi), this.fixedUniforms = ar(xe), this.binderUniforms = ir ? ir.getUniforms(xe) : [], this.forceManualRenderingForInstanceIDShaders && (this.instancingUniforms = ((Mi) => ({ u_instanceID: new ne.bN(Mi) }))(xe)), (yr.includes("TERRAIN") || ke.indexOf("symbol") !== -1 || ke.indexOf("circle") !== -1) && (this.terrainUniforms = ((Mi) => ({ u_dem: new ne.bN(Mi), u_dem_prev: new ne.bN(Mi), u_dem_tl: new ne.bK(Mi), u_dem_scale: new ne.bM(Mi), u_dem_tl_prev: new ne.bK(Mi), u_dem_scale_prev: new ne.bM(Mi), u_dem_size: new ne.bM(Mi), u_dem_lerp: new ne.bM(Mi), u_exaggeration: new ne.bM(Mi), u_depth: new ne.bN(Mi), u_depth_size_inv: new ne.bK(Mi), u_depth_range_unpack: new ne.bK(Mi), u_occluder_half_size: new ne.bM(Mi), u_occlusion_depth_offset: new ne.bM(Mi), u_meter_to_dem: new ne.bM(Mi), u_label_plane_matrix_inv: new ne.bJ(Mi) }))(xe)), yr.includes("GLOBE") && (this.globeUniforms = ((Mi) => ({ u_tile_tl_up: new ne.bL(Mi), u_tile_tr_up: new ne.bL(Mi), u_tile_br_up: new ne.bL(Mi), u_tile_bl_up: new ne.bL(Mi), u_tile_up_scale: new ne.bM(Mi) }))(xe)), yr.includes("FOG") && (this.fogUniforms = ((Mi) => ({ u_fog_matrix: new ne.bJ(Mi), u_fog_range: new ne.bK(Mi), u_fog_color: new ne.ca(Mi), u_fog_horizon_blend: new ne.bM(Mi), u_fog_vertical_limit: new ne.bK(Mi), u_fog_temporal_offset: new ne.bM(Mi), u_frustum_tl: new ne.bL(Mi), u_frustum_tr: new ne.bL(Mi), u_frustum_br: new ne.bL(Mi), u_frustum_bl: new ne.bL(Mi), u_globe_pos: new ne.bL(Mi), u_globe_radius: new ne.bM(Mi), u_globe_transition: new ne.bM(Mi), u_is_globe: new ne.bN(Mi), u_viewport: new ne.bK(Mi) }))(xe)), yr.includes("RENDER_CUTOFF") && (this.cutoffUniforms = ((Mi) => ({ u_cutoff_params: new ne.ca(Mi) }))(xe)), yr.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = ((Mi) => ({ u_lighting_ambient_color: new ne.bL(Mi), u_lighting_directional_dir: new ne.bL(Mi), u_lighting_directional_color: new ne.bL(Mi), u_ground_radiance: new ne.bL(Mi) }))(xe)), yr.includes("RENDER_SHADOWS") && (this.shadowUniforms = ((Mi) => ({ u_light_matrix_0: new ne.bJ(Mi), u_light_matrix_1: new ne.bJ(Mi), u_fade_range: new ne.bK(Mi), u_shadow_normal_offset: new ne.bL(Mi), u_shadow_intensity: new ne.bM(Mi), u_shadow_texel_size: new ne.bM(Mi), u_shadow_map_resolution: new ne.bM(Mi), u_shadow_direction: new ne.bL(Mi), u_shadow_bias: new ne.bL(Mi), u_shadowmap_0: new ne.bN(Mi), u_shadowmap_1: new ne.bN(Mi) }))(xe));
          }
        }
        setTerrainUniformValues(xe, ke) {
          if (!this.terrainUniforms)
            return;
          const He = this.terrainUniforms;
          if (!this.failedToCreate) {
            xe.program.set(this.program);
            for (const ir in ke)
              He[ir] && He[ir].set(this.program, ir, ke[ir]);
          }
        }
        setGlobeUniformValues(xe, ke) {
          if (!this.globeUniforms)
            return;
          const He = this.globeUniforms;
          if (!this.failedToCreate) {
            xe.program.set(this.program);
            for (const ir in ke)
              He[ir] && He[ir].set(this.program, ir, ke[ir]);
          }
        }
        setFogUniformValues(xe, ke) {
          if (!this.fogUniforms)
            return;
          const He = this.fogUniforms;
          if (!this.failedToCreate) {
            xe.program.set(this.program);
            for (const ir in ke)
              He[ir].set(this.program, ir, ke[ir]);
          }
        }
        setCutoffUniformValues(xe, ke) {
          if (!this.cutoffUniforms)
            return;
          const He = this.cutoffUniforms;
          if (!this.failedToCreate) {
            xe.program.set(this.program);
            for (const ir in ke)
              He[ir].set(this.program, ir, ke[ir]);
          }
        }
        setLightsUniformValues(xe, ke) {
          if (!this.lightsUniforms)
            return;
          const He = this.lightsUniforms;
          if (!this.failedToCreate) {
            xe.program.set(this.program);
            for (const ir in ke)
              He[ir].set(this.program, ir, ke[ir]);
          }
        }
        setShadowUniformValues(xe, ke) {
          if (this.failedToCreate || !this.shadowUniforms)
            return;
          const He = this.shadowUniforms;
          xe.program.set(this.program);
          for (const ir in ke)
            He[ir].set(this.program, ir, ke[ir]);
        }
        _drawDebugWireframe(xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or) {
          const Gr = xe.options.wireframe;
          if (Gr.terrain === !1 && Gr.layers2D === !1 && Gr.layers3D === !1)
            return;
          const qr = xe.context;
          if (!(() => !(!Gr.terrain || this.name !== "terrainRaster" && this.name !== "globeRaster") || !(!Gr.layers2D || xe._terrain && xe._terrain.renderingToTexture || !qc.includes(this.name)) || !(!Gr.layers3D || !Od.includes(this.name)))())
            return;
          const Jr = qr.gl, bi = xe.wireframeDebugCache.getLinesFromTrianglesBuffer(xe.frameCounter, ar, qr);
          if (!bi)
            return;
          const fi = [...this.fixedDefines];
          fi.push("DEBUG_WIREFRAME");
          const Mi = xe.getOrCreateProgram(this.name, { config: this.configuration, defines: fi });
          qr.program.set(Mi.program);
          const Ei = (zi, Ki, Wi) => {
            if (Ki[zi] && Wi[zi])
              for (const Xi in Ki[zi])
                Wi[zi][Xi] && Wi[zi][Xi].set(Wi.program, Xi, Ki[zi][Xi].current);
          };
          Dr && Dr.setUniforms(Mi.program, qr, Mi.binderUniforms, Tr, { zoom: $r }), Ei("fixedUniforms", this, Mi), Ei("terrainUniforms", this, Mi), Ei("globeUniforms", this, Mi), Ei("fogUniforms", this, Mi), Ei("lightsUniforms", this, Mi), Ei("shadowUniforms", this, Mi), bi.bind(), qr.setColorMode(new aa([Jr.ONE, Jr.ONE_MINUS_SRC_ALPHA, Jr.ZERO, Jr.ONE], ne.aj.transparent, [!0, !0, !0, !1])), qr.setDepthMode(new Oo(ke.func === Jr.LESS ? Jr.LEQUAL : ke.func, Oo.ReadOnly, ke.range)), qr.setStencilMode(ta.disabled);
          const Ii = 3 * yr.primitiveLength * 2, Ni = 3 * yr.primitiveOffset * 2 * 2;
          if (this.forceManualRenderingForInstanceIDShaders) {
            const zi = Or || 1;
            for (let Ki = 0; Ki < zi; ++Ki)
              Mi.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", Ki), Jr.drawElements(Jr.LINES, Ii, Jr.UNSIGNED_SHORT, Ni);
          } else
            Or && Or > 1 ? Jr.drawElementsInstanced(Jr.LINES, Ii, Jr.UNSIGNED_SHORT, Ni, Or) : Jr.drawElements(Jr.LINES, Ii, Jr.UNSIGNED_SHORT, Ni);
          ar.bind(), qr.program.set(this.program), qr.setDepthMode(ke), qr.setStencilMode(He), qr.setColorMode(ir);
        }
        checkUniforms(xe, ke, He) {
          if (this.fixedDefines.includes(ke)) {
            for (const ir of Object.keys(He))
              if (!He[ir].initialized)
                throw new Error(`Program '${this.name}', from draw '${xe}': uniform ${ir} not set but required by ${ke} being defined`);
          }
        }
        draw(xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr, qr, Jr, bi, fi, Mi) {
          const Ei = xe.context, Ii = Ei.gl;
          if (this.failedToCreate)
            return;
          Ei.program.set(this.program), Ei.setDepthMode(He), Ei.setStencilMode(ir), Ei.setColorMode(ar), Ei.setCullFace(yr);
          for (const Ki of Object.keys(this.fixedUniforms))
            this.fixedUniforms[Ki].set(this.program, Ki, Tr[Ki]);
          bi && bi.setUniforms(this.program, Ei, this.binderUniforms, qr, { zoom: Jr });
          const Ni = { [Ii.POINTS]: 1, [Ii.LINES]: 2, [Ii.TRIANGLES]: 3, [Ii.LINE_STRIP]: 1 }[ke];
          this.checkUniforms($r, "RENDER_SHADOWS", this.shadowUniforms);
          const zi = Mi && Mi > 0 ? 1 : void 0;
          for (const Ki of Gr.get()) {
            const Wi = Ki.vaos || (Ki.vaos = {});
            if ((Wi[$r] || (Wi[$r] = new Cu())).bind(Ei, this, Dr, bi ? bi.getPaintVertexBuffers() : [], Or, Ki.vertexOffset, fi || [], zi), this.forceManualRenderingForInstanceIDShaders) {
              const Xi = Mi || 1;
              for (let Gi = 0; Gi < Xi; ++Gi)
                this.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", Gi), Or ? Ii.drawElements(ke, Ki.primitiveLength * Ni, Ii.UNSIGNED_SHORT, Ki.primitiveOffset * Ni * 2) : Ii.drawArrays(ke, Ki.vertexOffset, Ki.vertexLength);
            } else
              Mi && Mi > 1 ? Ii.drawElementsInstanced(ke, Ki.primitiveLength * Ni, Ii.UNSIGNED_SHORT, Ki.primitiveOffset * Ni * 2, Mi) : Or ? Ii.drawElements(ke, Ki.primitiveLength * Ni, Ii.UNSIGNED_SHORT, Ki.primitiveOffset * Ni * 2) : Ii.drawArrays(ke, Ki.vertexOffset, Ki.vertexLength);
            ke === Ii.TRIANGLES && Or && this._drawDebugWireframe(xe, He, ir, ar, Or, Ki, qr, Jr, bi, Mi);
          }
        }
      }
      function jm(qe, xe) {
        const ke = Math.pow(2, xe.tileID.overscaledZ), He = xe.tileSize * Math.pow(2, qe.transform.tileZoom) / ke, ir = He * (xe.tileID.canonical.x + xe.tileID.wrap * ke), ar = He * xe.tileID.canonical.y;
        return { u_image: 0, u_texsize: xe.imageAtlasTexture ? xe.imageAtlasTexture.size : [0, 0], u_tile_units_to_pixels: 1 / ne.ar(xe, 1, qe.transform.tileZoom), u_pixel_coord_upper: [ir >> 16, ar >> 16], u_pixel_coord_lower: [65535 & ir, 65535 & ar] };
      }
      const zd = { terrain: 0, flat: 1 }, G0 = ne.ab.mat4.create(), mc = (qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr, qr, Jr, bi, fi, Mi, Ei) => {
        const Ii = xe.style.light, Ni = Ii.properties.get("position"), zi = [Ni.x, Ni.y, Ni.z], Ki = ne.ab.mat3.create();
        Ii.properties.get("anchor") === "viewport" && (ne.ab.mat3.fromRotation(Ki, -xe.transform.angle), ne.ab.vec3.transformMat3(zi, zi, Ki));
        const Wi = Ii.properties.get("color"), Xi = xe.transform, Gi = { u_matrix: qe, u_lightpos: zi, u_lightintensity: Ii.properties.get("intensity"), u_lightcolor: [Wi.r, Wi.g, Wi.b], u_vertical_gradient: +ke, u_opacity: He, u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_inv_rot_matrix: G0, u_merc_center: [0, 0], u_up_dir: [0, 0, 0], u_height_lift: 0, u_height_type: zd[Dr], u_base_type: zd[Or], u_ao: ir, u_edge_radius: ar, u_width_scale: yr, u_flood_light_color: bi, u_vertical_scale: fi, u_flood_light_intensity: Mi, u_ground_shadow_factor: Ei };
        return Xi.projection.name === "globe" && (Gi.u_tile_id = [Tr.canonical.x, Tr.canonical.y, 1 << Tr.canonical.z], Gi.u_zoom_transition = Gr, Gi.u_inv_rot_matrix = Jr, Gi.u_merc_center = qr, Gi.u_up_dir = Xi.projection.upVector(new ne.bT(0, 0, 0), qr[0] * ne.ag, qr[1] * ne.ag), Gi.u_height_lift = $r), Gi;
      }, Up = (qe, xe, ke, He, ir, ar) => ({ u_matrix: qe, u_edge_radius: xe, u_width_scale: ke, u_vertical_scale: He, u_height_type: zd[ir], u_base_type: zd[ar] }), Fd = (qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr, qr, Jr, bi, fi, Mi) => {
        const Ei = mc(qe, xe, ke, He, ir, ar, yr, Tr, Dr, Or, Gr, qr, Jr, bi, fi, Mi, 1, [0, 0, 0]), Ii = { u_height_factor: -Math.pow(2, Tr.overscaledZ) / $r.tileSize / 8 };
        return ne.l(Ei, jm(xe, $r), Ii);
      }, Vf = (qe, xe) => ({ u_matrix: qe, u_emissive_strength: xe }), Wh = (qe, xe, ke, He) => ne.l(Vf(qe, xe), jm(ke, He)), qm = (qe, xe, ke) => ({ u_matrix: qe, u_world: ke, u_emissive_strength: xe }), Gc = (qe, xe, ke, He, ir) => ne.l(Wh(qe, xe, ke, He), { u_world: ir }), Uf = (qe, xe, ke, He) => {
        const ir = ne.ag / ke.tileSize;
        return { u_matrix: qe, u_camera_to_center_distance: xe.getCameraToCenterDistance(He), u_extrude_scale: [xe.pixelsToGLUnits[0] / ir, xe.pixelsToGLUnits[1] / ir] };
      }, jf = (qe, xe, ke = 1) => ({ u_matrix: qe, u_color: xe.toRenderColor(null), u_overlay: 0, u_overlay_scale: ke }), gc = ne.ab.mat4.create(), H0 = (qe, xe, ke, He, ir, ar, yr) => {
        const Tr = qe.transform, $r = Tr.projection.name === "globe", Dr = $r ? ne.cN(Tr.zoom, xe.canonical) * Tr._pixelsPerMercatorPixel : ne.ar(ke, 1, ar), Or = { u_matrix: xe.projMatrix, u_extrude_scale: Dr, u_intensity: yr, u_inv_rot_matrix: gc, u_merc_center: [0, 0], u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_up_dir: [0, 0, 0] };
        if ($r) {
          Or.u_inv_rot_matrix = He, Or.u_merc_center = ir, Or.u_tile_id = [xe.canonical.x, xe.canonical.y, 1 << xe.canonical.z], Or.u_zoom_transition = ne.ae(Tr.zoom);
          const Gr = ir[0] * ne.ag, qr = ir[1] * ne.ag;
          Or.u_up_dir = Tr.projection.upVector(new ne.bT(0, 0, 0), Gr, qr);
        }
        return Or;
      };
      function ah(qe, [xe, ke, He, ir], [ar, yr]) {
        if (ar === yr)
          return [0, 0, 0, 0];
        const Tr = 255 * (qe - 1) / (qe * (yr - ar));
        return [xe * Tr, ke * Tr, He * Tr, ir * Tr];
      }
      function Nd(qe, xe, [ke, He]) {
        return ke === He ? 0 : 0.5 / qe + (xe - ke) * (qe - 1) / (qe * (He - ke));
      }
      const Ao = (qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr, qr, Jr, bi, fi, Mi, Ei, Ii, Ni, zi) => ({ u_matrix: qe, u_normalize_matrix: xe, u_globe_matrix: ke, u_merc_matrix: He, u_grid_matrix: ir, u_tl_parent: ar, u_scale_parent: Dr, u_fade_t: Or.mix, u_opacity: Or.opacity * Gr.paint.get("raster-opacity"), u_image0: 0, u_image1: 1, u_brightness_low: Gr.paint.get("raster-brightness-min"), u_brightness_high: Gr.paint.get("raster-brightness-max"), u_saturation_factor: ne.cO(Gr.paint.get("raster-saturation")), u_contrast_factor: ne.cP(Gr.paint.get("raster-contrast")), u_spin_weights: Gm(Gr.paint.get("raster-hue-rotate")), u_perspective_transform: qr, u_raster_elevation: Jr, u_zoom_transition: yr, u_merc_center: Tr, u_cutoff_params: $r, u_colorization_mix: ah(ne.cQ, fi, Ei), u_colorization_offset: Nd(ne.cQ, Mi, Ei), u_color_ramp: bi, u_texture_offset: [Ni / (Ii + 2 * Ni), Ii / (Ii + 2 * Ni)], u_texture_res: [Ii + 2 * Ni, Ii + 2 * Ni], u_emissive_strength: zi });
      function Gm(qe) {
        qe *= Math.PI / 180;
        const xe = Math.sin(qe), ke = Math.cos(qe);
        return [(2 * ke + 1) / 3, (-Math.sqrt(3) * xe - ke + 1) / 3, (Math.sqrt(3) * xe - ke + 1) / 3];
      }
      const ku = 0.05, Lu = (qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr) => ({ u_matrix: qe, u_normalize_matrix: xe, u_globe_matrix: ke, u_merc_matrix: He, u_grid_matrix: ir, u_tl_parent: ar, u_scale_parent: Dr, u_fade_t: Or.mix, u_opacity: Or.opacity, u_image0: 0, u_image1: 1, u_raster_elevation: Gr, u_zoom_transition: yr, u_merc_center: Tr, u_cutoff_params: $r }), lh = (qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr) => ({ u_particle_texture: qe, u_particle_texture_side_len: xe, u_tile_offset: ke, u_velocity: He, u_color_ramp: ar, u_velocity_res: ir, u_max_speed: yr, u_uv_offset: Tr, u_data_scale: [255 * $r[0], 255 * $r[1]], u_data_offset: Dr, u_particle_pos_scale: 1.1, u_particle_pos_offset: [ku, ku] }), Do = (qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr) => ({ u_particle_texture: qe, u_particle_texture_side_len: xe, u_velocity: ke, u_velocity_res: He, u_max_speed: ir, u_speed_factor: ar, u_reset_rate: yr, u_rand_seed: Math.random(), u_uv_offset: Tr, u_data_scale: [255 * $r[0], 255 * $r[1]], u_data_offset: Dr, u_particle_pos_scale: 1.1, u_particle_pos_offset: [ku, ku] }), Zh = ne.ab.mat4.create(), Xh = (qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr, qr, Jr, bi, fi, Mi, Ei, Ii, Ni, zi, Ki) => {
        const Wi = ir.transform, Xi = { u_is_size_zoom_constant: +(qe === "constant" || qe === "source"), u_is_size_feature_constant: +(qe === "constant" || qe === "camera"), u_size_t: xe ? xe.uSizeT : 0, u_size: xe ? xe.uSize : 0, u_camera_to_center_distance: Wi.getCameraToCenterDistance(Ii), u_rotate_symbol: +ke, u_aspect_ratio: Wi.width / Wi.height, u_fade_change: ir.options.fadeDuration ? ir.symbolFadeChange : 1, u_matrix: ar, u_label_plane_matrix: yr, u_coord_matrix: Tr, u_is_text: +Dr, u_elevation_from_sea: $r ? 1 : 0, u_pitch_with_map: +He, u_texsize: Or, u_texsize_icon: Gr, u_texture: 0, u_texture_icon: 1, u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_inv_rot_matrix: Zh, u_merc_center: [0, 0], u_camera_forward: [0, 0, 0], u_ecef_origin: [0, 0, 0], u_tile_matrix: Zh, u_up_vector: [0, -1, 0], u_color_adj_mat: Ni, u_icon_transition: zi || 0, u_gamma_scale: He ? ir.transform.getCameraToCenterDistance(Ii) * Math.cos(ir.terrain ? 0 : ir.transform._pitch) : 1, u_device_pixel_ratio: ne.q.devicePixelRatio, u_is_halo: +qr, u_scale_factor: Ki || 1 };
        return Ii.name === "globe" && (Xi.u_tile_id = [Jr.canonical.x, Jr.canonical.y, 1 << Jr.canonical.z], Xi.u_zoom_transition = bi, Xi.u_inv_rot_matrix = Mi, Xi.u_merc_center = fi, Xi.u_camera_forward = Wi._camera.forward(), Xi.u_ecef_origin = ne.cR(Wi.globeMatrix, Jr.toUnwrapped()), Xi.u_tile_matrix = Float32Array.from(Wi.globeMatrix), Xi.u_up_vector = Ei), Xi;
      }, Vd = (qe, xe, ke, He) => ({ u_matrix: qe, u_emissive_strength: xe, u_opacity: ke, u_color: He }), qf = (qe, xe, ke, He, ir, ar, yr, Tr, $r) => ne.l(function(Dr, Or, Gr, qr, Jr, bi) {
        const { width: fi, height: Mi } = qr.imageManager.getPixelSize(Or), Ei = Math.pow(2, bi.tileID.overscaledZ), Ii = bi.tileSize * Math.pow(2, qr.transform.tileZoom) / Ei, Ni = Ii * (bi.tileID.canonical.x + bi.tileID.wrap * Ei), zi = Ii * bi.tileID.canonical.y;
        return { u_image: 0, u_pattern_tl: Gr.tl, u_pattern_br: Gr.br, u_texsize: [fi, Mi], u_pattern_size: Gr.displaySize, u_pattern_units_to_pixels: Jr ? [qr.transform.width, -1 * qr.transform.height] : [1 / ne.ar(bi, 1, qr.transform.tileZoom), 1 / ne.ar(bi, 1, qr.transform.tileZoom)], u_pixel_coord_upper: [Ni >> 16, zi >> 16], u_pixel_coord_lower: [65535 & Ni, 65535 & zi] };
      }(0, ar, yr, He, Tr, $r), { u_matrix: qe, u_emissive_strength: xe, u_opacity: ke }), Ud = new Float32Array(ne.ab.mat4.identity([])), Gf = (qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr, qr, Jr = [0, 0, 0], bi) => {
        const fi = ir.style.light, Mi = fi.properties.get("position"), Ei = [-Mi.x, -Mi.y, Mi.z], Ii = ne.ab.mat3.create();
        fi.properties.get("anchor") === "viewport" && (ne.ab.mat3.fromRotation(Ii, -ir.transform.angle), ne.ab.vec3.transformMat3(Ei, Ei, Ii));
        const Ni = Or.alphaMode === "MASK", zi = fi.properties.get("color").toRenderColor(null), Ki = qr.paint.get("model-ambient-occlusion-intensity"), Wi = qr.paint.get("model-color").constantOr(ne.aj.white).toRenderColor(null), Xi = qr.paint.get("model-color-mix-intensity").constantOr(0);
        return { u_matrix: qe, u_lighting_matrix: xe, u_normal_matrix: ke, u_node_matrix: He || Ud, u_lightpos: Ei, u_lightintensity: fi.properties.get("intensity"), u_lightcolor: [zi.r, zi.g, zi.b], u_camera_pos: Jr, u_opacity: ar, u_baseTextureIsAlpha: 0, u_alphaMask: +Ni, u_alphaCutoff: Or.alphaCutoff, u_baseColorFactor: [yr.r, yr.g, yr.b, yr.a], u_emissiveFactor: [Tr[0], Tr[1], Tr[2], 1], u_metallicFactor: $r, u_roughnessFactor: Dr, u_baseColorTexture: ll.BaseColor, u_metallicRoughnessTexture: ll.MetallicRoughness, u_normalTexture: ll.Normal, u_occlusionTexture: ll.Occlusion, u_emissionTexture: ll.Emission, u_lutTexture: ll.LUT, u_color_mix: [Wi.r, Wi.g, Wi.b, Xi], u_aoIntensity: Ki, u_emissive_strength: Gr, u_occlusionTextureTransform: bi || [0, 0, 0, 0] };
      }, Hc = (qe, xe = Ud, ke = Ud) => ({ u_matrix: qe, u_instance: xe, u_node_matrix: ke }), jp = { fillExtrusion: (qe) => ({ u_matrix: new ne.bJ(qe), u_lightpos: new ne.bL(qe), u_lightintensity: new ne.bM(qe), u_lightcolor: new ne.bL(qe), u_vertical_gradient: new ne.bM(qe), u_opacity: new ne.bM(qe), u_edge_radius: new ne.bM(qe), u_width_scale: new ne.bM(qe), u_ao: new ne.bK(qe), u_height_type: new ne.bN(qe), u_base_type: new ne.bN(qe), u_tile_id: new ne.bL(qe), u_zoom_transition: new ne.bM(qe), u_inv_rot_matrix: new ne.bJ(qe), u_merc_center: new ne.bK(qe), u_up_dir: new ne.bL(qe), u_height_lift: new ne.bM(qe), u_flood_light_color: new ne.bL(qe), u_vertical_scale: new ne.bM(qe), u_flood_light_intensity: new ne.bM(qe), u_ground_shadow_factor: new ne.bL(qe) }), fillExtrusionDepth: (qe) => ({ u_matrix: new ne.bJ(qe), u_edge_radius: new ne.bM(qe), u_width_scale: new ne.bM(qe), u_vertical_scale: new ne.bM(qe), u_height_type: new ne.bN(qe), u_base_type: new ne.bN(qe) }), fillExtrusionPattern: (qe) => ({ u_matrix: new ne.bJ(qe), u_lightpos: new ne.bL(qe), u_lightintensity: new ne.bM(qe), u_lightcolor: new ne.bL(qe), u_vertical_gradient: new ne.bM(qe), u_height_factor: new ne.bM(qe), u_edge_radius: new ne.bM(qe), u_width_scale: new ne.bM(qe), u_ao: new ne.bK(qe), u_height_type: new ne.bN(qe), u_base_type: new ne.bN(qe), u_tile_id: new ne.bL(qe), u_zoom_transition: new ne.bM(qe), u_inv_rot_matrix: new ne.bJ(qe), u_merc_center: new ne.bK(qe), u_up_dir: new ne.bL(qe), u_height_lift: new ne.bM(qe), u_image: new ne.bN(qe), u_texsize: new ne.bK(qe), u_pixel_coord_upper: new ne.bK(qe), u_pixel_coord_lower: new ne.bK(qe), u_tile_units_to_pixels: new ne.bM(qe), u_opacity: new ne.bM(qe) }), fillExtrusionGroundEffect: (qe) => ({ u_matrix: new ne.bJ(qe), u_opacity: new ne.bM(qe), u_ao_pass: new ne.bM(qe), u_meter_to_tile: new ne.bM(qe), u_ao: new ne.bK(qe), u_flood_light_intensity: new ne.bM(qe), u_flood_light_color: new ne.bL(qe), u_attenuation: new ne.bM(qe), u_edge_radius: new ne.bM(qe), u_fb: new ne.bN(qe), u_fb_size: new ne.bM(qe), u_dynamic_offset: new ne.bM(qe) }), fill: (qe) => ({ u_matrix: new ne.bJ(qe), u_emissive_strength: new ne.bM(qe) }), fillPattern: (qe) => ({ u_matrix: new ne.bJ(qe), u_emissive_strength: new ne.bM(qe), u_image: new ne.bN(qe), u_texsize: new ne.bK(qe), u_pixel_coord_upper: new ne.bK(qe), u_pixel_coord_lower: new ne.bK(qe), u_tile_units_to_pixels: new ne.bM(qe) }), fillOutline: (qe) => ({ u_matrix: new ne.bJ(qe), u_emissive_strength: new ne.bM(qe), u_world: new ne.bK(qe) }), fillOutlinePattern: (qe) => ({ u_matrix: new ne.bJ(qe), u_emissive_strength: new ne.bM(qe), u_world: new ne.bK(qe), u_image: new ne.bN(qe), u_texsize: new ne.bK(qe), u_pixel_coord_upper: new ne.bK(qe), u_pixel_coord_lower: new ne.bK(qe), u_tile_units_to_pixels: new ne.bM(qe) }), circle: ne.cS, collisionBox: (qe) => ({ u_matrix: new ne.bJ(qe), u_camera_to_center_distance: new ne.bM(qe), u_extrude_scale: new ne.bK(qe) }), collisionCircle: (qe) => ({ u_matrix: new ne.bJ(qe), u_inv_matrix: new ne.bJ(qe), u_camera_to_center_distance: new ne.bM(qe), u_viewport_size: new ne.bK(qe) }), debug: (qe) => ({ u_color: new ne.cz(qe), u_matrix: new ne.bJ(qe), u_overlay: new ne.bN(qe), u_overlay_scale: new ne.bM(qe) }), clippingMask: (qe) => ({ u_matrix: new ne.bJ(qe) }), heatmap: (qe) => ({ u_extrude_scale: new ne.bM(qe), u_intensity: new ne.bM(qe), u_matrix: new ne.bJ(qe), u_inv_rot_matrix: new ne.bJ(qe), u_merc_center: new ne.bK(qe), u_tile_id: new ne.bL(qe), u_zoom_transition: new ne.bM(qe), u_up_dir: new ne.bL(qe) }), heatmapTexture: (qe) => ({ u_image: new ne.bN(qe), u_color_ramp: new ne.bN(qe), u_opacity: new ne.bM(qe) }), hillshade: (qe) => ({ u_matrix: new ne.bJ(qe), u_image: new ne.bN(qe), u_latrange: new ne.bK(qe), u_light: new ne.bK(qe), u_shadow: new ne.cz(qe), u_highlight: new ne.cz(qe), u_emissive_strength: new ne.bM(qe), u_accent: new ne.cz(qe) }), hillshadePrepare: (qe) => ({ u_matrix: new ne.bJ(qe), u_image: new ne.bN(qe), u_dimension: new ne.bK(qe), u_zoom: new ne.bM(qe) }), line: ne.cT, linePattern: ne.cU, raster: (qe) => ({ u_matrix: new ne.bJ(qe), u_normalize_matrix: new ne.bJ(qe), u_globe_matrix: new ne.bJ(qe), u_merc_matrix: new ne.bJ(qe), u_grid_matrix: new ne.cA(qe), u_tl_parent: new ne.bK(qe), u_scale_parent: new ne.bM(qe), u_fade_t: new ne.bM(qe), u_opacity: new ne.bM(qe), u_image0: new ne.bN(qe), u_image1: new ne.bN(qe), u_brightness_low: new ne.bM(qe), u_brightness_high: new ne.bM(qe), u_saturation_factor: new ne.bM(qe), u_contrast_factor: new ne.bM(qe), u_spin_weights: new ne.bL(qe), u_perspective_transform: new ne.bK(qe), u_raster_elevation: new ne.bM(qe), u_zoom_transition: new ne.bM(qe), u_merc_center: new ne.bK(qe), u_cutoff_params: new ne.ca(qe), u_colorization_mix: new ne.ca(qe), u_colorization_offset: new ne.bM(qe), u_color_ramp: new ne.bN(qe), u_texture_offset: new ne.bK(qe), u_texture_res: new ne.bK(qe), u_emissive_strength: new ne.bM(qe) }), rasterParticle: (qe) => ({ u_matrix: new ne.bJ(qe), u_normalize_matrix: new ne.bJ(qe), u_globe_matrix: new ne.bJ(qe), u_merc_matrix: new ne.bJ(qe), u_grid_matrix: new ne.cA(qe), u_tl_parent: new ne.bK(qe), u_scale_parent: new ne.bM(qe), u_fade_t: new ne.bM(qe), u_opacity: new ne.bM(qe), u_image0: new ne.bN(qe), u_image1: new ne.bN(qe), u_raster_elevation: new ne.bM(qe), u_zoom_transition: new ne.bM(qe), u_merc_center: new ne.bK(qe), u_cutoff_params: new ne.ca(qe) }), rasterParticleTexture: (qe) => ({ u_texture: new ne.bN(qe), u_opacity: new ne.bM(qe) }), rasterParticleDraw: (qe) => ({ u_particle_texture: new ne.bN(qe), u_particle_texture_side_len: new ne.bM(qe), u_tile_offset: new ne.bK(qe), u_velocity: new ne.bN(qe), u_color_ramp: new ne.bN(qe), u_velocity_res: new ne.bK(qe), u_max_speed: new ne.bM(qe), u_uv_offset: new ne.bK(qe), u_data_scale: new ne.bK(qe), u_data_offset: new ne.bM(qe), u_particle_pos_scale: new ne.bM(qe), u_particle_pos_offset: new ne.bK(qe) }), rasterParticleUpdate: (qe) => ({ u_particle_texture: new ne.bN(qe), u_particle_texture_side_len: new ne.bM(qe), u_velocity: new ne.bN(qe), u_velocity_res: new ne.bK(qe), u_max_speed: new ne.bM(qe), u_speed_factor: new ne.bM(qe), u_reset_rate: new ne.bM(qe), u_rand_seed: new ne.bM(qe), u_uv_offset: new ne.bK(qe), u_data_scale: new ne.bK(qe), u_data_offset: new ne.bM(qe), u_particle_pos_scale: new ne.bM(qe), u_particle_pos_offset: new ne.bK(qe) }), symbol: (qe) => ({ u_is_size_zoom_constant: new ne.bN(qe), u_is_size_feature_constant: new ne.bN(qe), u_size_t: new ne.bM(qe), u_size: new ne.bM(qe), u_camera_to_center_distance: new ne.bM(qe), u_rotate_symbol: new ne.bN(qe), u_aspect_ratio: new ne.bM(qe), u_fade_change: new ne.bM(qe), u_matrix: new ne.bJ(qe), u_label_plane_matrix: new ne.bJ(qe), u_coord_matrix: new ne.bJ(qe), u_is_text: new ne.bN(qe), u_elevation_from_sea: new ne.bN(qe), u_pitch_with_map: new ne.bN(qe), u_texsize: new ne.bK(qe), u_texsize_icon: new ne.bK(qe), u_texture: new ne.bN(qe), u_texture_icon: new ne.bN(qe), u_gamma_scale: new ne.bM(qe), u_device_pixel_ratio: new ne.bM(qe), u_tile_id: new ne.bL(qe), u_zoom_transition: new ne.bM(qe), u_inv_rot_matrix: new ne.bJ(qe), u_merc_center: new ne.bK(qe), u_camera_forward: new ne.bL(qe), u_tile_matrix: new ne.bJ(qe), u_up_vector: new ne.bL(qe), u_ecef_origin: new ne.bL(qe), u_is_halo: new ne.bN(qe), u_icon_transition: new ne.bM(qe), u_color_adj_mat: new ne.bJ(qe), u_scale_factor: new ne.bM(qe) }), background: (qe) => ({ u_matrix: new ne.bJ(qe), u_emissive_strength: new ne.bM(qe), u_opacity: new ne.bM(qe), u_color: new ne.cz(qe) }), backgroundPattern: (qe) => ({ u_matrix: new ne.bJ(qe), u_emissive_strength: new ne.bM(qe), u_opacity: new ne.bM(qe), u_image: new ne.bN(qe), u_pattern_tl: new ne.bK(qe), u_pattern_br: new ne.bK(qe), u_texsize: new ne.bK(qe), u_pattern_size: new ne.bK(qe), u_pixel_coord_upper: new ne.bK(qe), u_pixel_coord_lower: new ne.bK(qe), u_pattern_units_to_pixels: new ne.bK(qe) }), terrainRaster: (qe) => ({ u_matrix: new ne.bJ(qe), u_image0: new ne.bN(qe), u_skirt_height: new ne.bM(qe), u_ground_shadow_factor: new ne.bL(qe) }), skybox: (qe) => ({ u_matrix: new ne.bJ(qe), u_sun_direction: new ne.bL(qe), u_cubemap: new ne.bN(qe), u_opacity: new ne.bM(qe), u_temporal_offset: new ne.bM(qe) }), skyboxGradient: (qe) => ({ u_matrix: new ne.bJ(qe), u_color_ramp: new ne.bN(qe), u_center_direction: new ne.bL(qe), u_radius: new ne.bM(qe), u_opacity: new ne.bM(qe), u_temporal_offset: new ne.bM(qe) }), skyboxCapture: (qe) => ({ u_matrix_3f: new ne.cA(qe), u_sun_direction: new ne.bL(qe), u_sun_intensity: new ne.bM(qe), u_color_tint_r: new ne.ca(qe), u_color_tint_m: new ne.ca(qe), u_luminance: new ne.bM(qe) }), globeRaster: (qe) => ({ u_proj_matrix: new ne.bJ(qe), u_globe_matrix: new ne.bJ(qe), u_normalize_matrix: new ne.bJ(qe), u_merc_matrix: new ne.bJ(qe), u_zoom_transition: new ne.bM(qe), u_merc_center: new ne.bK(qe), u_image0: new ne.bN(qe), u_grid_matrix: new ne.cA(qe), u_skirt_height: new ne.bM(qe), u_far_z_cutoff: new ne.bM(qe), u_frustum_tl: new ne.bL(qe), u_frustum_tr: new ne.bL(qe), u_frustum_br: new ne.bL(qe), u_frustum_bl: new ne.bL(qe), u_globe_pos: new ne.bL(qe), u_globe_radius: new ne.bM(qe), u_viewport: new ne.bK(qe) }), globeAtmosphere: (qe) => ({ u_frustum_tl: new ne.bL(qe), u_frustum_tr: new ne.bL(qe), u_frustum_br: new ne.bL(qe), u_frustum_bl: new ne.bL(qe), u_horizon: new ne.bM(qe), u_transition: new ne.bM(qe), u_fadeout_range: new ne.bM(qe), u_color: new ne.ca(qe), u_high_color: new ne.ca(qe), u_space_color: new ne.ca(qe), u_temporal_offset: new ne.bM(qe), u_horizon_angle: new ne.bM(qe) }), model: (qe) => ({ u_matrix: new ne.bJ(qe), u_lighting_matrix: new ne.bJ(qe), u_normal_matrix: new ne.bJ(qe), u_node_matrix: new ne.bJ(qe), u_lightpos: new ne.bL(qe), u_lightintensity: new ne.bM(qe), u_lightcolor: new ne.bL(qe), u_camera_pos: new ne.bL(qe), u_opacity: new ne.bM(qe), u_baseColorFactor: new ne.ca(qe), u_emissiveFactor: new ne.ca(qe), u_metallicFactor: new ne.bM(qe), u_roughnessFactor: new ne.bM(qe), u_baseTextureIsAlpha: new ne.bN(qe), u_alphaMask: new ne.bN(qe), u_alphaCutoff: new ne.bM(qe), u_baseColorTexture: new ne.bN(qe), u_metallicRoughnessTexture: new ne.bN(qe), u_normalTexture: new ne.bN(qe), u_occlusionTexture: new ne.bN(qe), u_emissionTexture: new ne.bN(qe), u_lutTexture: new ne.bN(qe), u_color_mix: new ne.ca(qe), u_aoIntensity: new ne.bM(qe), u_emissive_strength: new ne.bM(qe), u_occlusionTextureTransform: new ne.ca(qe) }), modelDepth: (qe) => ({ u_matrix: new ne.bJ(qe), u_instance: new ne.bJ(qe), u_node_matrix: new ne.bJ(qe) }), groundShadow: (qe) => ({ u_matrix: new ne.bJ(qe), u_ground_shadow_factor: new ne.bL(qe) }), stars: (qe) => ({ u_matrix: new ne.bJ(qe), u_up: new ne.bL(qe), u_right: new ne.bL(qe), u_intensity_multiplier: new ne.bM(qe) }), snowParticle: (qe) => ({ u_modelview: new ne.bJ(qe), u_projection: new ne.bJ(qe), u_time: new ne.bM(qe), u_cam_pos: new ne.bL(qe), u_velocityConeAperture: new ne.bM(qe), u_velocity: new ne.bM(qe), u_horizontalOscillationRadius: new ne.bM(qe), u_horizontalOscillationRate: new ne.bM(qe), u_boxSize: new ne.bM(qe), u_billboardSize: new ne.bM(qe), u_simpleShapeParameters: new ne.bK(qe), u_screenSize: new ne.bK(qe), u_thinningCenterPos: new ne.bK(qe), u_thinningShape: new ne.bL(qe), u_thinningAffectedRatio: new ne.bM(qe), u_thinningParticleOffset: new ne.bM(qe), u_particleColor: new ne.ca(qe), u_direction: new ne.bL(qe) }), rainParticle: (qe) => ({ u_modelview: new ne.bJ(qe), u_projection: new ne.bJ(qe), u_time: new ne.bM(qe), u_cam_pos: new ne.bL(qe), u_texScreen: new ne.bN(qe), u_velocityConeAperture: new ne.bM(qe), u_velocity: new ne.bM(qe), u_boxSize: new ne.bM(qe), u_rainDropletSize: new ne.bK(qe), u_distortionStrength: new ne.bM(qe), u_rainDirection: new ne.bL(qe), u_color: new ne.ca(qe), u_screenSize: new ne.bK(qe), u_thinningCenterPos: new ne.bK(qe), u_thinningShape: new ne.bL(qe), u_thinningAffectedRatio: new ne.bM(qe), u_thinningParticleOffset: new ne.bM(qe), u_shapeDirectionalPower: new ne.bM(qe), u_shapeNormalPower: new ne.bM(qe), u_mode: new ne.bM(qe) }), vignette: (qe) => ({ u_vignetteShape: new ne.bL(qe), u_vignetteColor: new ne.ca(qe) }), occlusion: (qe) => ({ u_matrix: new ne.bJ(qe), u_anchorPos: new ne.bL(qe), u_screenSizePx: new ne.bK(qe), u_occluderSizePx: new ne.bK(qe), u_color: new ne.ca(qe) }) };
      class Sl {
        constructor(xe, ke, He, ir) {
          this.id = Sl.uniqueIdxCounter, Sl.uniqueIdxCounter++, this.context = xe;
          const ar = xe.gl;
          this.buffer = ar.createBuffer(), this.dynamicDraw = Boolean(He), this.context.unbindVAO(), xe.bindElementBuffer.set(this.buffer), ar.bufferData(ar.ELEMENT_ARRAY_BUFFER, ke.arrayBuffer, this.dynamicDraw ? ar.DYNAMIC_DRAW : ar.STATIC_DRAW), this.dynamicDraw || ir || ke.destroy();
        }
        bind() {
          this.context.bindElementBuffer.set(this.buffer);
        }
        updateData(xe) {
          this.id = Sl.uniqueIdxCounter, Sl.uniqueIdxCounter++;
          const ke = this.context.gl;
          this.context.unbindVAO(), this.bind(), ke.bufferSubData(ke.ELEMENT_ARRAY_BUFFER, 0, xe.arrayBuffer);
        }
        destroy() {
          this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        }
      }
      Sl.uniqueIdxCounter = 0;
      const Ul = { Int8: "BYTE", Uint8: "UNSIGNED_BYTE", Int16: "SHORT", Uint16: "UNSIGNED_SHORT", Int32: "INT", Uint32: "UNSIGNED_INT", Float32: "FLOAT" };
      class qp {
        constructor(xe, ke, He, ir, ar, yr) {
          this.length = ke.length, this.attributes = He, this.itemSize = ke.bytesPerElement, this.dynamicDraw = ir, this.instanceCount = yr, this.context = xe;
          const Tr = xe.gl;
          this.buffer = Tr.createBuffer(), xe.bindVertexBuffer.set(this.buffer), Tr.bufferData(Tr.ARRAY_BUFFER, ke.arrayBuffer, this.dynamicDraw ? Tr.DYNAMIC_DRAW : Tr.STATIC_DRAW), this.dynamicDraw || ar || ke.destroy();
        }
        bind() {
          this.context.bindVertexBuffer.set(this.buffer);
        }
        updateData(xe) {
          const ke = this.context.gl;
          this.bind(), ke.bufferSubData(ke.ARRAY_BUFFER, 0, xe.arrayBuffer);
        }
        enableAttributes(xe, ke) {
          for (let He = 0; He < this.attributes.length; He++) {
            const ir = ke.attributes[this.attributes[He].name];
            ir !== void 0 && xe.enableVertexAttribArray(ir);
          }
        }
        setVertexAttribPointers(xe, ke, He) {
          for (let ir = 0; ir < this.attributes.length; ir++) {
            const ar = this.attributes[ir], yr = ke.attributes[ar.name];
            yr !== void 0 && xe.vertexAttribPointer(yr, ar.components, xe[Ul[ar.type]], !1, this.itemSize, ar.offset + this.itemSize * (He || 0));
          }
        }
        setVertexAttribDivisor(xe, ke, He) {
          for (let ir = 0; ir < this.attributes.length; ir++) {
            const ar = ke.attributes[this.attributes[ir].name];
            ar !== void 0 && this.instanceCount && this.instanceCount > 0 && xe.vertexAttribDivisor(ar, He);
          }
        }
        destroy() {
          this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        }
      }
      class jd {
        constructor(xe, ke, He, ir, ar) {
          this.context = xe, this.width = ke, this.height = He;
          const yr = this.framebuffer = xe.gl.createFramebuffer();
          ir && (this.colorAttachment = new Np(xe, yr)), ar && (this.depthAttachmentType = ar, this.depthAttachment = ar === "renderbuffer" ? new nh(xe, yr) : new Gh(xe, yr));
        }
        destroy() {
          const xe = this.context.gl;
          if (this.colorAttachment) {
            const ke = this.colorAttachment.get();
            ke && xe.deleteTexture(ke);
          }
          if (this.depthAttachment && this.depthAttachmentType)
            if (this.depthAttachmentType === "renderbuffer") {
              const ke = this.depthAttachment.get();
              ke && xe.deleteRenderbuffer(ke);
            } else {
              const ke = this.depthAttachment.get();
              ke && xe.deleteTexture(ke);
            }
          xe.deleteFramebuffer(this.framebuffer);
        }
      }
      class kl {
        constructor(xe, ke) {
          this.gl = xe, this.clearColor = new zm(this), this.clearDepth = new Id(this), this.clearStencil = new eh(this), this.colorMask = new Nh(this), this.depthMask = new Rp(this), this.stencilMask = new Pp(this), this.stencilFunc = new Dp(this), this.stencilOp = new Bd(this), this.stencilTest = new $d(this), this.depthRange = new Op(this), this.depthTest = new Rd(this), this.depthFunc = new Vh(this), this.blend = new Fm(this), this.blendFunc = new Vl(this), this.blendColor = new Os(this), this.blendEquation = new Qs(this), this.cullFace = new Pf(this), this.cullFaceSide = new zp(this), this.frontFace = new Df(this), this.program = new Of(this), this.activeTexture = new Pd(this), this.viewport = new th(this), this.bindFramebuffer = new Uh(this), this.bindRenderbuffer = new ih(this), this.bindTexture = new jh(this), this.bindVertexBuffer = new jc(this), this.bindElementBuffer = new zf(this), this.bindVertexArrayOES = new qh(this), this.pixelStoreUnpack = new V0(this), this.pixelStoreUnpackPremultiplyAlpha = new U0(this), this.pixelStoreUnpackFlipY = new j0(this), this.options = ke ? { ...ke } : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = xe.getExtension("EXT_texture_filter_anisotropic") || xe.getExtension("MOZ_EXT_texture_filter_anisotropic") || xe.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = xe.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = xe.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = xe.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = xe.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.forceManualRenderingForInstanceIDShaders = ke && !!ke.forceManualRenderingForInstanceIDShaders || this.renderer && this.renderer.indexOf("PowerVR") !== -1, this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = xe.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = xe.getExtension("EXT_color_buffer_half_float"), this.extTimerQuery = xe.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = xe.getParameter(xe.MAX_TEXTURE_SIZE), this.maxPointSize = xe.getParameter(xe.ALIASED_POINT_SIZE_RANGE)[1];
        }
        setDefault() {
          this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
        }
        setDirty() {
          this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArrayOES.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
        }
        createIndexBuffer(xe, ke, He) {
          return new Sl(this, xe, ke, He);
        }
        createVertexBuffer(xe, ke, He, ir, ar) {
          return new qp(this, xe, ke, He, ir, ar);
        }
        createRenderbuffer(xe, ke, He) {
          const ir = this.gl, ar = ir.createRenderbuffer();
          return this.bindRenderbuffer.set(ar), ir.renderbufferStorage(ir.RENDERBUFFER, xe, ke, He), this.bindRenderbuffer.set(null), ar;
        }
        createFramebuffer(xe, ke, He, ir) {
          return new jd(this, xe, ke, He, ir);
        }
        clear({ color: xe, depth: ke, stencil: He, colorMask: ir }) {
          const ar = this.gl;
          let yr = 0;
          xe && (yr |= ar.COLOR_BUFFER_BIT, this.clearColor.set(xe), this.colorMask.set(ir || [!0, !0, !0, !0])), ke !== void 0 && (yr |= ar.DEPTH_BUFFER_BIT, this.depthRange.set([0, 1]), this.clearDepth.set(ke), this.depthMask.set(!0)), He !== void 0 && (yr |= ar.STENCIL_BUFFER_BIT, this.clearStencil.set(He), this.stencilMask.set(255)), ar.clear(yr);
        }
        setCullFace(xe) {
          xe.enable === !1 ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(xe.mode), this.frontFace.set(xe.frontFace));
        }
        setDepthMode(xe) {
          xe.func !== this.gl.ALWAYS || xe.mask ? (this.depthTest.set(!0), this.depthFunc.set(xe.func), this.depthMask.set(xe.mask), this.depthRange.set(xe.range)) : this.depthTest.set(!1);
        }
        setStencilMode(xe) {
          xe.test.func !== this.gl.ALWAYS || xe.mask ? (this.stencilTest.set(!0), this.stencilMask.set(xe.mask), this.stencilOp.set([xe.fail, xe.depthFail, xe.pass]), this.stencilFunc.set({ func: xe.test.func, ref: xe.ref, mask: xe.test.mask })) : this.stencilTest.set(!1);
        }
        setColorMode(xe) {
          ne.bn(xe.blendFunction, aa.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(xe.blendFunction), this.blendColor.set(xe.blendColor), xe.blendEquation ? this.blendEquation.set(xe.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(xe.mask);
        }
        unbindVAO() {
          this.bindVertexArrayOES.set(null);
        }
      }
      let Ll;
      function Wc(qe, xe, ke, He, ir, ar, yr) {
        const Tr = qe.context, $r = Tr.gl, Dr = qe.transform, Or = qe.getOrCreateProgram("collisionBox"), Gr = [];
        let qr = 0, Jr = 0;
        for (let zi = 0; zi < He.length; zi++) {
          const Ki = He[zi], Wi = xe.getTile(Ki), Xi = Wi.getBucket(ke);
          if (!Xi)
            continue;
          const Gi = Ts(Ki, Xi, Dr);
          let nn = Gi;
          ir[0] === 0 && ir[1] === 0 || (nn = qe.translatePosMatrix(Gi, Wi, ir, ar));
          const dn = yr ? Xi.textCollisionBox : Xi.iconCollisionBox, Pn = Xi.collisionCircleArray;
          if (Pn.length > 0) {
            const Ln = ne.ab.mat4.create(), hn = nn;
            ne.ab.mat4.mul(Ln, Xi.placementInvProjMatrix, Dr.glCoordMatrix), ne.ab.mat4.mul(Ln, Ln, Xi.placementViewportMatrix), Gr.push({ circleArray: Pn, circleOffset: Jr, transform: hn, invTransform: Ln, projection: Xi.getProjection() }), qr += Pn.length / 4, Jr = qr;
          }
          dn && (qe.terrain && qe.terrain.setupElevationDraw(Wi, Or), Or.draw(qe, $r.LINES, Oo.disabled, ta.disabled, qe.colorModeForRenderPass(), Uo.disabled, Uf(nn, Dr, Wi, Xi.getProjection()), ke.id, dn.layoutVertexBuffer, dn.indexBuffer, dn.segments, null, Dr.zoom, null, [dn.collisionVertexBuffer, dn.collisionVertexBufferExt]));
        }
        if (!yr || !Gr.length)
          return;
        const bi = qe.getOrCreateProgram("collisionCircle"), fi = new ne.cV();
        fi.resize(4 * qr), fi._trim();
        let Mi = 0;
        for (const zi of Gr)
          for (let Ki = 0; Ki < zi.circleArray.length / 4; Ki++) {
            const Wi = 4 * Ki, Xi = zi.circleArray[Wi + 0], Gi = zi.circleArray[Wi + 1], nn = zi.circleArray[Wi + 2], dn = zi.circleArray[Wi + 3];
            fi.emplace(Mi++, Xi, Gi, nn, dn, 0), fi.emplace(Mi++, Xi, Gi, nn, dn, 1), fi.emplace(Mi++, Xi, Gi, nn, dn, 2), fi.emplace(Mi++, Xi, Gi, nn, dn, 3);
          }
        (!Ll || Ll.length < 2 * qr) && (Ll = function(zi) {
          const Ki = 2 * zi, Wi = new ne.aU();
          Wi.resize(Ki), Wi._trim();
          for (let Xi = 0; Xi < Ki; Xi++) {
            const Gi = 6 * Xi;
            Wi.uint16[Gi + 0] = 4 * Xi + 0, Wi.uint16[Gi + 1] = 4 * Xi + 1, Wi.uint16[Gi + 2] = 4 * Xi + 2, Wi.uint16[Gi + 3] = 4 * Xi + 2, Wi.uint16[Gi + 4] = 4 * Xi + 3, Wi.uint16[Gi + 5] = 4 * Xi + 0;
          }
          return Wi;
        }(qr));
        const Ei = Tr.createIndexBuffer(Ll, !0), Ii = Tr.createVertexBuffer(fi, ne.cW.members, !0);
        for (const zi of Gr) {
          const Ki = { u_matrix: zi.transform, u_inv_matrix: zi.invTransform, u_camera_to_center_distance: (Ni = Dr).getCameraToCenterDistance(zi.projection), u_viewport_size: [Ni.width, Ni.height] };
          bi.draw(qe, $r.TRIANGLES, Oo.disabled, ta.disabled, qe.colorModeForRenderPass(), Uo.disabled, Ki, ke.id, Ii, Ei, ne.b7.simpleSegment(0, 2 * zi.circleOffset, zi.circleArray.length, zi.circleArray.length / 2), null, Dr.zoom);
        }
        var Ni;
        Ii.destroy(), Ei.destroy();
      }
      const uh = ne.ab.mat4.create();
      function Hf(qe) {
        const xe = qe._camera.getWorldToCamera(qe.worldSize, 1), ke = ne.ab.mat4.multiply([], xe, qe.globeMatrix);
        ne.ab.mat4.invert(ke, ke);
        const He = [0, 0, 0], ir = [0, 1, 0, 0];
        return ne.ab.vec4.transformMat4(ir, ir, ke), He[0] = ir[0], He[1] = ir[1], He[2] = ir[2], ne.ab.vec3.normalize(He, He), He;
      }
      function Yh({ width: qe, height: xe, anchor: ke, textOffset: He, textScale: ir }, ar) {
        const { horizontalAlign: yr, verticalAlign: Tr } = ne.bD(ke), $r = -(yr - 0.5) * qe, Dr = -(Tr - 0.5) * xe, Or = ne.bC(ke, He);
        return new ne.P(($r / ir + Or[0]) * ar, (Dr / ir + Or[1]) * ar);
      }
      function Hm(qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or) {
        const Gr = qe.text.placedSymbolArray, qr = qe.text.dynamicLayoutVertexArray, Jr = qe.icon.dynamicLayoutVertexArray, bi = {}, fi = qe.getProjection(), Mi = $h(Tr, fi, ar), Ei = ar.elevation, Ii = fi.upVectorScale(Tr.canonical, ar.center.lat, ar.worldSize).metersToTile;
        qr.clear();
        for (let Ni = 0; Ni < Gr.length; Ni++) {
          const zi = Gr.get(Ni), { tileAnchorX: Ki, tileAnchorY: Wi, numGlyphs: Xi } = zi, Gi = zi.hidden || !zi.crossTileID || qe.allowVerticalPlacement && !zi.placedOrientation ? null : He[zi.crossTileID];
          if (Gi) {
            let nn = 0, dn = 0, Pn = 0;
            if (Ei) {
              const On = Ei ? Ei.getAtTileOffset(Tr, Ki, Wi) : 0, [ao, ro, Wn] = fi.upVector(Tr.canonical, Ki, Wi);
              nn = On * ao * Ii, dn = On * ro * Ii, Pn = On * Wn * Ii;
            }
            let [Ln, hn, xn, Hn] = ts(zi.projectedAnchorX + nn, zi.projectedAnchorY + dn, zi.projectedAnchorZ + Pn, ke ? Mi : yr);
            const io = Bm(ar.getCameraToCenterDistance(fi), Hn);
            let uo = ir.evaluateSizeForFeature(qe.textSizeData, Dr, zi) * io / ne.bw;
            ke && (uo *= qe.tilePixelRatio / $r);
            const An = Yh(Gi, uo);
            ke ? ({ x: Ln, y: hn, z: xn } = fi.projectTilePoint(Ki + An.x, Wi + An.y, Tr.canonical), [Ln, hn, xn] = ts(Ln + nn, hn + dn, xn + Pn, yr)) : (xe && An._rotate(-ar.angle), Ln += An.x, hn += An.y, xn = 0);
            const eo = qe.allowVerticalPlacement && zi.placedOrientation === ne.bq.vertical ? Math.PI / 2 : 0;
            for (let On = 0; On < Xi; On++)
              ne.bt(qr, Ln, hn, xn, eo);
            Or && zi.associatedIconIndex >= 0 && (bi[zi.associatedIconIndex] = { x: Ln, y: hn, z: xn, angle: eo });
          } else
            iu(Xi, qr);
        }
        if (Or) {
          Jr.clear();
          const Ni = qe.icon.placedSymbolArray;
          for (let zi = 0; zi < Ni.length; zi++) {
            const Ki = Ni.get(zi), { numGlyphs: Wi } = Ki, Xi = bi[zi];
            if (Ki.hidden || !Xi)
              iu(Wi, Jr);
            else {
              const { x: Gi, y: nn, z: dn, angle: Pn } = Xi;
              for (let Ln = 0; Ln < Wi; Ln++)
                ne.bt(Jr, Gi, nn, dn, Pn);
            }
          }
          qe.icon.dynamicLayoutVertexBuffer.updateData(Jr);
        }
        qe.text.dynamicLayoutVertexBuffer.updateData(qr);
      }
      function Il(qe, xe, ke, He, ir, ar, yr = {}) {
        const Tr = ke.paint.get("icon-translate"), $r = ke.paint.get("text-translate"), Dr = ke.paint.get("icon-translate-anchor"), Or = ke.paint.get("text-translate-anchor"), Gr = ke.layout.get("icon-rotation-alignment"), qr = ke.layout.get("text-rotation-alignment"), Jr = ke.layout.get("icon-pitch-alignment"), bi = ke.layout.get("text-pitch-alignment"), fi = ke.layout.get("icon-keep-upright"), Mi = ke.layout.get("text-keep-upright"), Ei = ke.paint.get("icon-color-saturation"), Ii = ke.paint.get("icon-color-contrast"), Ni = ke.paint.get("icon-color-brightness-min"), zi = ke.paint.get("icon-color-brightness-max"), Ki = ke.layout.get("symbol-elevation-reference") === "sea", Wi = qe.context, Xi = Wi.gl, Gi = qe.transform, nn = Gr === "map", dn = qr === "map", Pn = Jr === "map", Ln = bi === "map", hn = ke.layout.get("symbol-sort-key").constantOr(1) !== void 0;
        let xn = !1;
        const Hn = qe.depthModeForSublayer(0, Oo.ReadOnly), io = [ne.at(Gi.center.lng), ne.aA(Gi.center.lat)], uo = ke.layout.get("text-variable-anchor"), An = Gi.projection.name === "globe", eo = [], On = [0, -1, 0];
        for (const ao of He) {
          const ro = xe.getTile(ao), Wn = ro.getBucket(ke);
          if (!Wn || Wn.projection.name === "mercator" && An || Wn.fullyClipped)
            continue;
          const _o = Wn.projection.name === "globe", yo = _o ? ne.ae(Gi.zoom) : 0, mo = $h(ao, Wn.getProjection(), Gi), Eo = Gi.calculatePixelsToTileUnitsMatrix(ro), Ko = uo && Wn.hasTextData(), Fo = Wn.hasIconTextFit() && Ko && Wn.hasIconData(), zo = Wn.getProjection().createInversionMatrix(Gi, ao.canonical), Jo = (qo) => {
            Gi.depthOcclusionForSymbolsAndCircles && (ke.hasInitialOcclusionOpacityProperties || qe.terrain) && (qo.push("DEPTH_D24"), qo.push("DEPTH_OCCLUSION"));
          }, ia = () => {
            const qo = nn && ke.layout.get("symbol-placement") !== "point", Aa = [];
            Jo(Aa);
            const ps = qo || Fo, Xs = ke.paint.get("icon-image-cross-fade").constantOr(0);
            qe.terrainRenderModeElevated() && Pn && Aa.push("PITCH_WITH_MAP_TERRAIN"), _o && (Aa.push("PROJECTION_GLOBE_VIEW"), ps && Aa.push("PROJECTED_POS_ON_VIEWPORT")), Xs > 0 && Aa.push("ICON_TRANSITION"), Wn.icon.zOffsetVertexBuffer && Aa.push("Z_OFFSET"), Ei === 0 && Ii === 0 && Ni === 0 && zi === 1 || Aa.push("COLOR_ADJUSTMENT"), Wn.sdfIcons && Aa.push("RENDER_SDF");
            const ql = Wn.icon.programConfigurations.get(ke.id), ml = qe.getOrCreateProgram("symbol", { config: ql, defines: Aa }), Ns = ro.imageAtlasTexture ? ro.imageAtlasTexture.size : [0, 0], ks = Wn.iconSizeData, Cs = ne.bp(ks, Gi.zoom), is = Pn || Gi.pitch !== 0, Za = es(mo, ro.tileID.canonical, Pn, nn, Gi, Wn.getProjection(), Eo), Ma = dl(mo, ro.tileID.canonical, Pn, nn, Gi, Wn.getProjection(), Eo), xs = qe.translatePosMatrix(Ma, ro, Tr, Dr, !0), Vs = qe.translatePosMatrix(mo, ro, Tr, Dr), Ja = ps ? uh : Za, ul = nn && !Pn && !qo;
            let nc = On;
            !An && !Gi.mercatorFromTransition || nn || (nc = Hf(Gi));
            const Rl = _o ? nc : On, vu = ke.getColorAdjustmentMatrix(Ei, Ii, Ni, zi), Jc = Xh(ks.kind, Cs, ul, Pn, qe, Vs, Ja, xs, Ki, !1, Ns, [0, 0], !0, ao, yo, io, zo, Rl, Wn.getProjection(), vu, Xs), gl = ro.imageAtlasTexture ? ro.imageAtlasTexture : null, oc = ke.layout.get("icon-size").constantOr(0) !== 1 || Wn.iconsNeedLinear, Rc = Wn.sdfIcons || qe.options.rotating || qe.options.zooming || oc || is ? Xi.LINEAR : Xi.NEAREST, yc = Wn.sdfIcons && ke.paint.get("icon-halo-width").constantOr(1) !== 0, xh = qe.terrain && Pn && qo ? ne.ab.mat4.invert(ne.ab.mat4.create(), Za) : uh;
            if (qo && Wn.icon) {
              const hf = Gi.elevation, tm = hf ? hf.getAtTileOffsetFunc(ao, Gi.center.lat, Gi.worldSize, Wn.getProjection()) : null, hp = Hu(mo, ro.tileID.canonical, Pn, nn, Gi, Wn.getProjection(), Eo);
              Ef(Wn, mo, qe, !1, hp, Ma, Pn, fi, tm, ao);
            }
            return { program: ml, buffers: Wn.icon, uniformValues: Jc, atlasTexture: gl, atlasTextureIcon: null, atlasInterpolation: Rc, atlasInterpolationIcon: null, isSDF: Wn.sdfIcons, hasHalo: yc, tile: ro, labelPlaneMatrixInv: xh };
          }, sa = () => {
            const qo = dn && ke.layout.get("symbol-placement") !== "point", Aa = [], ps = qo || uo || Fo;
            qe.terrainRenderModeElevated() && Ln && Aa.push("PITCH_WITH_MAP_TERRAIN"), _o && (Aa.push("PROJECTION_GLOBE_VIEW"), ps && Aa.push("PROJECTED_POS_ON_VIEWPORT")), Wn.text.zOffsetVertexBuffer && Aa.push("Z_OFFSET"), Wn.iconsInText && Aa.push("RENDER_TEXT_AND_SYMBOL"), Aa.push("RENDER_SDF"), Jo(Aa);
            const Xs = Wn.text.programConfigurations.get(ke.id), ql = qe.getOrCreateProgram("symbol", { config: Xs, defines: Aa });
            let ml, Ns = [0, 0], ks = null;
            const Cs = Wn.textSizeData;
            Wn.iconsInText && (Ns = ro.imageAtlasTexture ? ro.imageAtlasTexture.size : [0, 0], ks = ro.imageAtlasTexture ? ro.imageAtlasTexture : null, ml = Ln || Gi.pitch !== 0 || qe.options.rotating || qe.options.zooming || Cs.kind === "composite" || Cs.kind === "camera" ? Xi.LINEAR : Xi.NEAREST);
            const is = ro.glyphAtlasTexture ? ro.glyphAtlasTexture.size : [0, 0], Za = ke.layout.get("text-size-scale-range"), Ma = ne.aw(qe.scaleFactor, Za[0], Za[1]), xs = ne.bp(Cs, Gi.zoom, Ma), Vs = es(mo, ro.tileID.canonical, Ln, dn, Gi, Wn.getProjection(), Eo), Ja = dl(mo, ro.tileID.canonical, Ln, dn, Gi, Wn.getProjection(), Eo), ul = qe.translatePosMatrix(Ja, ro, $r, Or, !0), nc = qe.translatePosMatrix(mo, ro, $r, Or), Rl = ps ? uh : Vs, vu = dn && !Ln && !qo;
            let Jc = On;
            !An && !Gi.mercatorFromTransition || dn || (Jc = Hf(Gi));
            const gl = Xh(Cs.kind, xs, vu, Ln, qe, nc, Rl, ul, Ki, !0, is, Ns, !0, ao, yo, io, zo, _o ? Jc : On, Wn.getProjection(), null, null, Ma), oc = ro.glyphAtlasTexture ? ro.glyphAtlasTexture : null, Rc = Xi.LINEAR, yc = ke.paint.get("text-halo-width").constantOr(1) !== 0, xh = qe.terrain && Ln && qo ? ne.ab.mat4.invert(ne.ab.mat4.create(), Vs) : uh;
            if (qo && Wn.text) {
              const hf = Gi.elevation, tm = hf ? hf.getAtTileOffsetFunc(ao, Gi.center.lat, Gi.worldSize, Wn.getProjection()) : null, hp = Hu(mo, ro.tileID.canonical, Ln, dn, Gi, Wn.getProjection(), Eo);
              Ef(Wn, mo, qe, !0, hp, Ja, Ln, Mi, tm, ao);
            }
            return { program: ql, buffers: Wn.text, uniformValues: gl, atlasTexture: oc, atlasTextureIcon: ks, atlasInterpolation: Rc, atlasInterpolationIcon: ml, isSDF: !0, hasHalo: yc, tile: ro, labelPlaneMatrixInv: xh };
          }, ss = Wn.icon.segments.get().length, Ya = Wn.text.segments.get().length, Oa = ss && !yr.onlyText ? ia() : null, Na = Ya && !yr.onlyIcons ? sa() : null, la = ke.paint.get("icon-opacity").constantOr(1), _a = ke.paint.get("text-opacity").constantOr(1);
          if (hn && Wn.canOverlap) {
            xn = !0;
            const qo = la && !yr.onlyText ? Wn.icon.segments.get() : [], Aa = _a && !yr.onlyIcons ? Wn.text.segments.get() : [];
            for (const ps of qo)
              eo.push({ segments: new ne.b7([ps]), sortKey: ps.sortKey, state: Oa });
            for (const ps of Aa)
              eo.push({ segments: new ne.b7([ps]), sortKey: ps.sortKey, state: Na });
          } else
            yr.onlyText || eo.push({ segments: la ? Wn.icon.segments : new ne.b7([]), sortKey: 0, state: Oa }), yr.onlyIcons || eo.push({ segments: _a ? Wn.text.segments : new ne.b7([]), sortKey: 0, state: Na });
        }
        xn && eo.sort((ao, ro) => ao.sortKey - ro.sortKey);
        for (const ao of eo) {
          const ro = ao.state;
          if (ro)
            if (qe.terrain ? qe.terrain.setupElevationDraw(ro.tile, ro.program, { useDepthForOcclusion: Gi.depthOcclusionForSymbolsAndCircles, labelPlaneMatrixInv: ro.labelPlaneMatrixInv }) : qe.setupDepthForOcclusion(Gi.depthOcclusionForSymbolsAndCircles, ro.program), Wi.activeTexture.set(Xi.TEXTURE0), ro.atlasTexture && ro.atlasTexture.bind(ro.atlasInterpolation, Xi.CLAMP_TO_EDGE, !0), ro.atlasTextureIcon && (Wi.activeTexture.set(Xi.TEXTURE1), ro.atlasTextureIcon && ro.atlasTextureIcon.bind(ro.atlasInterpolationIcon, Xi.CLAMP_TO_EDGE, !0)), qe.uploadCommonLightUniforms(qe.context, ro.program), ro.hasHalo) {
              const Wn = ro.uniformValues;
              Wn.u_is_halo = 1, wa(ro.buffers, ao.segments, ke, qe, ro.program, Hn, ir, ar, Wn, 2), Wn.u_is_halo = 0;
            } else {
              if (ro.isSDF) {
                const Wn = ro.uniformValues;
                ro.hasHalo && (Wn.u_is_halo = 1, wa(ro.buffers, ao.segments, ke, qe, ro.program, Hn, ir, ar, Wn, 1)), Wn.u_is_halo = 0;
              }
              wa(ro.buffers, ao.segments, ke, qe, ro.program, Hn, ir, ar, ro.uniformValues, 1);
            }
        }
      }
      function wa(qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr) {
        const Or = [qe.dynamicLayoutVertexBuffer, qe.opacityVertexBuffer, qe.iconTransitioningVertexBuffer, qe.globeExtVertexBuffer, qe.zOffsetVertexBuffer];
        ir.draw(He, He.context.gl.TRIANGLES, ar, yr, Tr, Uo.disabled, $r, ke.id, qe.layoutVertexBuffer, qe.indexBuffer, xe, ke.paint, He.transform.zoom, qe.programConfigurations.get(ke.id), Or, Dr);
      }
      function hh(qe, xe, ke, He, ir, ar, yr) {
        const Tr = qe.context.gl, $r = ke.paint.get("fill-pattern"), Dr = ke.is3D(), Or = Dr ? qe.stencilModeFor3D() : ta.disabled, Gr = $r && $r.constantOr(1);
        let qr, Jr, bi, fi, Mi;
        yr ? (Jr = Gr && !ke.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", qr = Tr.LINES) : (Jr = Gr ? "fillPattern" : "fill", qr = Tr.TRIANGLES);
        for (const Ei of He) {
          const Ii = xe.getTile(Ei);
          if (Gr && !Ii.patternsLoaded())
            continue;
          const Ni = Ii.getBucket(ke);
          if (!Ni)
            continue;
          qe.prepareDrawTile();
          const zi = Ni.programConfigurations.get(ke.id), Ki = qe.isTileAffectedByFog(Ei), Wi = qe.getOrCreateProgram(Jr, { config: zi, overrideFog: Ki });
          Gr && (qe.context.activeTexture.set(Tr.TEXTURE0), Ii.imageAtlasTexture && Ii.imageAtlasTexture.bind(Tr.LINEAR, Tr.CLAMP_TO_EDGE), zi.updatePaintBuffers());
          const Xi = $r.constantOr(null);
          if (Xi && Ii.imageAtlas) {
            const dn = Ii.imageAtlas, Pn = ne.A.from(Xi), Ln = dn.patternPositions[Pn.getSerializedPrimary()];
            Ln && zi.setConstantPatternPositions(Ln);
          }
          const Gi = qe.translatePosMatrix(Ei.projMatrix, Ii, ke.paint.get("fill-translate"), ke.paint.get("fill-translate-anchor")), nn = ke.paint.get("fill-emissive-strength");
          if (yr) {
            fi = Ni.indexBuffer2, Mi = Ni.segments2;
            const dn = qe.terrain && qe.terrain.renderingToTexture ? qe.terrain.drapeBufferSize : [Tr.drawingBufferWidth, Tr.drawingBufferHeight];
            bi = Jr === "fillOutlinePattern" && Gr ? Gc(Gi, nn, qe, Ii, dn) : qm(Gi, nn, dn);
          } else
            fi = Ni.indexBuffer, Mi = Ni.segments, bi = Gr ? Wh(Gi, nn, qe, Ii) : Vf(Gi, nn);
          qe.uploadCommonUniforms(qe.context, Wi, Ei.toUnwrapped()), Wi.draw(qe, qr, ir, Dr ? Or : qe.stencilModeForClipping(Ei), ar, Uo.disabled, bi, ke.id, Ni.layoutVertexBuffer, fi, Mi, ke.paint, qe.transform.zoom, zi, void 0);
        }
      }
      function fh(qe, xe, ke, He, ir, ar, yr, Tr) {
        ke.resetLayerRenderingStats(qe);
        const $r = qe.context, Dr = $r.gl, Or = qe.transform, Gr = ke.paint.get("fill-extrusion-pattern"), qr = Gr.constantOr(1), Jr = ke.paint.get("fill-extrusion-opacity"), bi = qe.style.enable3dLights(), fi = ke.paint.get(bi && !qr ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"), Mi = [ke.paint.get("fill-extrusion-ambient-occlusion-intensity"), fi], Ei = ke.layout.get("fill-extrusion-edge-radius"), Ii = Ei > 0 && !ke.paint.get("fill-extrusion-rounded-roof"), Ni = Ii ? 0 : Ei, zi = Or.projection.name === "globe" ? ne.d3() : 0, Ki = Or.projection.name === "globe", Wi = Ki ? ne.ae(Or.zoom) : 0, Xi = [ne.at(Or.center.lng), ne.aA(Or.center.lat)], Gi = ke.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default") === "none", nn = ke.paint.get("fill-extrusion-flood-light-color").toRenderColor(Gi ? null : ke.lut).toArray01().slice(0, 3), dn = ke.paint.get("fill-extrusion-flood-light-intensity"), Pn = ke.paint.get("fill-extrusion-vertical-scale"), Ln = ke.paint.get("fill-extrusion-line-width").constantOr(1) !== 0, hn = ke.paint.get("fill-extrusion-height-alignment"), xn = ke.paint.get("fill-extrusion-base-alignment"), Hn = Tc(qe, ke.paint.get("fill-extrusion-cutoff-fade-range")), io = [];
        let uo;
        Ki && io.push("PROJECTION_GLOBE_VIEW"), Mi[0] > 0 && io.push("FAUX_AO"), Ii && io.push("ZERO_ROOF_RADIUS"), Tr && io.push("HAS_CENTROID"), dn > 0 && io.push("FLOOD_LIGHT"), Hn.shouldRenderCutoff && io.push("RENDER_CUTOFF"), Ln && io.push("RENDER_WALL_MODE");
        const An = qe.renderPass === "shadow", eo = qe.shadowRenderer, On = An && !!eo;
        qe.shadowRenderer && (qe.shadowRenderer.useNormalOffset = !0);
        let ao = [0, 0, 0];
        if (eo) {
          const _o = qe.style.directionalLight, yo = qe.style.ambientLight;
          _o && yo && (ao = Ac(qe.style, _o, yo)), An || (io.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), eo.useNormalOffset && io.push("NORMAL_OFFSET")), uo = io.concat(["SHADOWS_SINGLE_CASCADE"]);
        }
        const ro = On ? "fillExtrusionDepth" : qr ? "fillExtrusionPattern" : "fillExtrusion", Wn = ke.getLayerRenderingStats();
        for (const _o of He) {
          const yo = xe.getTile(_o), mo = yo.getBucket(ke);
          if (!mo || mo.projection.name !== Or.projection.name)
            continue;
          let Eo = !1;
          eo && (Eo = eo.getMaxCascadeForTile(_o.toUnwrapped()) === 0);
          const Ko = qe.isTileAffectedByFog(_o), Fo = mo.programConfigurations.get(ke.id), zo = qe.getOrCreateProgram(ro, { config: Fo, defines: Eo ? uo : io, overrideFog: Ko });
          if (qe.terrain && qe.terrain.setupElevationDraw(yo, zo, { useMeterToDem: !0 }), !mo.centroidVertexBuffer) {
            const Na = zo.attributes.a_centroid_pos;
            Na !== void 0 && Dr.vertexAttrib2f(Na, 0, 0);
          }
          !An && eo && eo.setupShadows(yo.tileID.toUnwrapped(), zo, "vector-tile", yo.tileID.overscaledZ), qr && (qe.context.activeTexture.set(Dr.TEXTURE0), yo.imageAtlasTexture && yo.imageAtlasTexture.bind(Dr.LINEAR, Dr.CLAMP_TO_EDGE), Fo.updatePaintBuffers());
          const Jo = Gr.constantOr(null);
          if (Jo && yo.imageAtlas) {
            const Na = yo.imageAtlas, la = ne.A.from(Jo), _a = Na.patternPositions[la.getSerializedPrimary()];
            _a && Fo.setConstantPatternPositions(_a);
          }
          const ia = ke.paint.get("fill-extrusion-vertical-gradient"), sa = 1 / mo.tileToMeter;
          let ss;
          if (An && eo) {
            if (Zs(yo.tileID, mo, qe))
              continue;
            const Na = eo.calculateShadowPassMatrixFromTile(yo.tileID.toUnwrapped());
            ss = Up(Na, Ni, sa, Pn, hn, xn);
          } else {
            const Na = qe.translatePosMatrix(_o.expandedProjMatrix, yo, ke.paint.get("fill-extrusion-translate"), ke.paint.get("fill-extrusion-translate-anchor")), la = Or.projection.createInversionMatrix(Or, _o.canonical);
            ss = qr ? Fd(Na, qe, ia, Jr, Mi, Ni, sa, _o, yo, zi, hn, xn, Wi, Xi, la, nn, Pn) : mc(Na, qe, ia, Jr, Mi, Ni, sa, _o, zi, hn, xn, Wi, Xi, la, nn, Pn, dn, ao);
          }
          qe.uploadCommonUniforms($r, zo, _o.toUnwrapped(), null, Hn);
          let Ya = mo.segments;
          if (Or.projection.name === "mercator" && !An && (Ya = mo.getVisibleSegments(yo.tileID, qe.terrain, qe.transform.getFrustum(0)), !Ya.get().length))
            continue;
          if (Wn)
            if (An)
              for (const Na of Ya.get())
                Wn.numRenderedVerticesInShadowPass += Na.primitiveLength;
            else
              for (const Na of Ya.get())
                Wn.numRenderedVerticesInTransparentPass += Na.primitiveLength;
          const Oa = [];
          (qe.terrain || Tr) && Oa.push(mo.centroidVertexBuffer), Ki && Oa.push(mo.layoutVertexExtBuffer), Ln && Oa.push(mo.wallVertexBuffer), zo.draw(qe, $r.gl.TRIANGLES, ir, ar, yr, Uo.backCCW, ss, ke.id, mo.layoutVertexBuffer, mo.indexBuffer, Ya, ke.paint, qe.transform.zoom, Fo, Oa);
        }
        qe.shadowRenderer && (qe.shadowRenderer.useNormalOffset = !1);
      }
      function El(qe, xe, ke, He, ir, ar, yr, Tr, $r, Dr, Or, Gr, qr, Jr, bi, fi, Mi, Ei, Ii) {
        const Ni = qe.context, zi = Ni.gl, Ki = qe.transform, Wi = qe.transform.zoom, Xi = [], Gi = Tc(qe, ke.paint.get("fill-extrusion-cutoff-fade-range"));
        Dr === "clear" ? (Xi.push("CLEAR_SUBPASS"), Ii && (Xi.push("CLEAR_FROM_TEXTURE"), Ni.activeTexture.set(zi.TEXTURE0), Ii.bind(zi.LINEAR, zi.CLAMP_TO_EDGE))) : Dr === "sdf" && Xi.push("SDF_SUBPASS"), Mi && Xi.push("HAS_CENTROID"), Gi.shouldRenderCutoff && Xi.push("RENDER_CUTOFF");
        const nn = ke.layout.get("fill-extrusion-edge-radius"), dn = (Pn, Ln, hn, xn, Hn) => {
          const io = Ln.programConfigurations.get(ke.id), uo = qe.isTileAffectedByFog(Pn), An = qe.getOrCreateProgram("fillExtrusionGroundEffect", { config: io, defines: Xi, overrideFog: uo }), eo = ((ao, ro, Wn, _o, yo, mo, Eo, Ko, Fo, zo, Jo) => ({ u_matrix: ro, u_opacity: Wn, u_ao_pass: _o ? 1 : 0, u_meter_to_tile: yo, u_ao: mo, u_flood_light_intensity: Eo, u_flood_light_color: Ko, u_attenuation: Fo, u_edge_radius: zo, u_fb: 0, u_fb_size: Jo, u_dynamic_offset: 1 }))(0, xn, Or, $r, Hn, [Gr, qr * Hn], Jr, bi, fi, Wi >= 17 ? 0 : nn * Hn, Ii ? Ii.size[0] : 0), On = [];
          Mi && On.push(Ln.hiddenByLandmarkVertexBuffer), qe.uploadCommonUniforms(Ni, An, Pn.toUnwrapped(), null, Gi), An.draw(qe, Ni.gl.TRIANGLES, ir, ar, yr, Tr, eo, ke.id, Ln.vertexBuffer, Ln.indexBuffer, hn, ke.paint, Wi, io, On);
        };
        for (const Pn of He) {
          const Ln = xe.getTile(Pn), hn = Ln.getBucket(ke);
          if (!hn || hn.projection.name !== Ki.projection.name || !hn.groundEffect || hn.groundEffect && !hn.groundEffect.hasData())
            continue;
          const xn = hn.groundEffect, Hn = 1 / hn.tileToMeter;
          {
            const io = qe.translatePosMatrix(Pn.projMatrix, Ln, ke.paint.get("fill-extrusion-translate"), ke.paint.get("fill-extrusion-translate-anchor")), uo = xn.getDefaultSegment();
            dn(Pn, xn, uo, io, Hn);
          }
          if (Ei)
            for (let io = 0; io < 4; io++) {
              const uo = ne.d4[io](Pn), An = xe.getTile(uo);
              if (!An)
                continue;
              const eo = An.getBucket(ke);
              if (!eo || eo.projection.name !== Ki.projection.name || !eo.groundEffect || eo.groundEffect && !eo.groundEffect.hasData())
                continue;
              const On = eo.groundEffect;
              let ao, ro;
              io === 0 ? (ao = [-ne.ag, 0, 0], ro = 1) : io === 1 ? (ao = [ne.ag, 0, 0], ro = 0) : io === 2 ? (ao = [0, -ne.ag, 0], ro = 3) : (ao = [0, ne.ag, 0], ro = 2);
              const Wn = On.regionSegments[ro];
              if (!Wn)
                continue;
              const _o = new Float32Array(16);
              ne.ab.mat4.translate(_o, Pn.projMatrix, ao), dn(Pn, On, Wn, qe.translatePosMatrix(_o, Ln, ke.paint.get("fill-extrusion-translate"), ke.paint.get("fill-extrusion-translate-anchor")), Hn);
            }
        }
      }
      function Wf(qe, xe, ke, He, ir, ar, yr) {
        He.centroidVertexArray.length === 0 && He.createCentroidsBuffer();
        const Tr = ar ? ar.findDEMTileFor(ke) : null;
        if (!(Tr && Tr.dem || yr))
          return;
        ar && Tr && Tr.dem && He.selfDEMTileTimestamp !== Tr.dem._timestamp && (He.borderDoneWithNeighborZ = [-1, -1, -1, -1], He.selfDEMTileTimestamp = Tr.dem._timestamp);
        const $r = (Ei) => new ne.P(Math.ceil((Ei + ne.d7) * ne.d8), 0), Dr = (Ei) => {
          const Ii = xe.getSource().minzoom, Ni = (Ki) => {
            const Wi = xe.getTileByID(Ki);
            if (Wi && Wi.hasData())
              return Wi.getBucket(ir);
          }, zi = [0, -1, 1];
          for (const Ki of zi) {
            if (Ei.overscaledZ + Ki < Ii)
              continue;
            const Wi = Ni(Ei.calculateScaledKey(Ei.overscaledZ + Ki));
            if (Wi)
              return Wi;
          }
        }, Or = [0, 0, 0], Gr = (Ei, Ii) => (Or[0] = Math.min(Ei.min.y, Ii.min.y), Or[1] = Math.max(Ei.max.y, Ii.max.y), Or[2] = ne.ag - Ii.min.x > Ei.max.x ? Ii.min.x - ne.ag : Ei.max.x, Or), qr = (Ei, Ii) => (Or[0] = Math.min(Ei.min.x, Ii.min.x), Or[1] = Math.max(Ei.max.x, Ii.max.x), Or[2] = ne.ag - Ii.min.y > Ei.max.y ? Ii.min.y - ne.ag : Ei.max.y, Or), Jr = [(Ei, Ii) => Gr(Ei, Ii), (Ei, Ii) => Gr(Ii, Ei), (Ei, Ii) => qr(Ei, Ii), (Ei, Ii) => qr(Ii, Ei)], bi = (Ei, Ii, Ni, zi, Ki, Wi, Xi) => {
          if (!ar)
            return 0;
          const Gi = [[Wi ? Ni : Ei, Wi ? Ei : Ni, 0], [Wi ? Ni : Ii, Wi ? Ii : Ni, 0]], nn = Xi < 0 ? ne.ag + Xi : Xi, dn = [Wi ? nn : (Ei + Ii) / 2, Wi ? (Ei + Ii) / 2 : nn, 0];
          return Ni === 0 && Xi < 0 || Ni !== 0 && Xi > 0 ? ar.getForTilePoints(Ki, [dn], !0, zi) : Gi.push(dn), ar.getForTilePoints(ke, Gi, !0, Tr), Math.max(Gi[0][2], Gi[1][2], dn[2]) / ar.exaggeration();
        };
        for (let Ei = 0; Ei < 4; Ei++) {
          const Ii = He.borderFeatureIndices[Ei];
          if (Ii.length === 0)
            continue;
          const Ni = ne.d4[Ei](ke), zi = Dr(Ni);
          if (!(zi && zi instanceof ne.d5))
            continue;
          const Ki = ar ? ar.findDEMTileFor(Ni) : null;
          if (!(Ki && Ki.dem || yr) || (ar && Ki && Ki.dem && He.borderDEMTileTimestamp[Ei] !== Ki.dem._timestamp && (He.borderDoneWithNeighborZ[Ei] = -1, He.borderDEMTileTimestamp[Ei] = Ki.dem._timestamp), He.borderDoneWithNeighborZ[Ei] === zi.canonical.z))
            continue;
          zi.centroidVertexArray.length === 0 && zi.createCentroidsBuffer();
          const Wi = (Ei < 2 ? 1 : 5) - Ei, Xi = zi.borderDoneWithNeighborZ[Wi] !== He.canonical.z, Gi = zi.borderFeatureIndices[Wi];
          let nn = 0;
          if (He.canonical.z !== zi.canonical.z) {
            for (const dn of Ii)
              He.showCentroid(He.featuresOnBorder[dn]);
            if (Xi)
              for (const dn of Gi)
                zi.showCentroid(zi.featuresOnBorder[dn]);
            He.borderDoneWithNeighborZ[Ei] = zi.canonical.z, zi.borderDoneWithNeighborZ[Wi] = He.canonical.z;
          }
          for (const dn of Ii) {
            const Pn = He.featuresOnBorder[dn], Ln = He.centroidData[Pn.centroidDataIndex], hn = Pn.borders[Ei];
            let xn;
            for (; nn < Gi.length; ) {
              xn = zi.featuresOnBorder[Gi[nn]];
              const Hn = xn.borders[Wi];
              if (Hn[1] > hn[0] + 3 || Hn[0] > hn[0] - 3)
                break;
              zi.showCentroid(xn), nn++;
            }
            if (xn && nn < Gi.length) {
              const Hn = nn;
              let io = 0;
              for (; !(xn.borders[Wi][0] > hn[1] - 3) && (io++, ++nn !== Gi.length); )
                xn = zi.featuresOnBorder[Gi[nn]];
              xn = zi.featuresOnBorder[Gi[Hn]];
              let uo = !1;
              if (io >= 1) {
                const On = xn.borders[Wi];
                Math.abs(hn[0] - On[0]) < 3 && Math.abs(hn[1] - On[1]) < 3 && (io = 1, uo = !0, nn = Hn + 1);
              } else if (io === 0) {
                He.showCentroid(Pn);
                continue;
              }
              const An = zi.centroidData[xn.centroidDataIndex];
              yr && uo && (((fi = Ln).flags | (Mi = An).flags) & ne.d6 ? (fi.flags |= ne.d6, Mi.flags |= ne.d6) : (fi.flags &= ~ne.d6, Mi.flags &= ~ne.d6));
              const eo = Pn.intersectsCount() > 1 || xn.intersectsCount() > 1;
              if (io > 1)
                nn = Hn, Ln.centroidXY = An.centroidXY = new ne.P(0, 0);
              else if (Ki && Ki.dem && !eo) {
                const On = Jr[Ei](Ln, An), ao = Ei % 2 ? ne.ag - 1 : 0, ro = bi(On[0], Math.min(ne.ag - 1, On[1]), ao, Ki, Ni, Ei < 2, On[2]);
                Ln.centroidXY = An.centroidXY = $r(ro);
              } else
                eo ? Ln.centroidXY = An.centroidXY = new ne.P(0, 0) : (Ln.centroidXY = He.encodeBorderCentroid(Pn), An.centroidXY = zi.encodeBorderCentroid(xn));
              He.writeCentroidToBuffer(Ln), zi.writeCentroidToBuffer(An);
            } else
              He.showCentroid(Pn);
          }
          He.borderDoneWithNeighborZ[Ei] = zi.canonical.z, zi.borderDoneWithNeighborZ[Wi] = He.canonical.z;
        }
        var fi, Mi;
        (He.needsCentroidUpdate || !He.centroidVertexBuffer && He.centroidVertexArray.length !== 0) && He.uploadCentroid(qe);
      }
      const qd = [1, 0, 0], ph = [0, 1, 0], mh = [0, 0, 1];
      function Zs(qe, xe, ke) {
        const He = ke.transform, ir = ke.shadowRenderer;
        if (!ir)
          return !0;
        const ar = qe.toUnwrapped(), yr = He.tileSize * ir._cascades[ke.currentShadowCascade].scale;
        let Tr = xe.maxHeight;
        if (He.elevation) {
          const fi = He.elevation.getMinMaxForTile(qe);
          fi && (Tr += fi.max);
        }
        const $r = [...ir.shadowDirection];
        $r[2] = -$r[2];
        const Dr = ir.computeSimplifiedTileShadowVolume(ar, Tr, yr, $r);
        if (!Dr)
          return !1;
        const Or = [qd, ph, mh, $r, [$r[0], 0, $r[2]], [0, $r[1], $r[2]]], Gr = He.projection.name === "globe", qr = He.scaleZoom(yr), Jr = ne.bR.fromInvProjectionMatrix(He.invProjMatrix, He.worldSize, qr, !Gr), bi = ir.getCurrentCascadeFrustum();
        return Jr.intersectsPrecise(Dr.vertices, Dr.planes, Or) === 0 || bi.intersectsPrecise(Dr.vertices, Dr.planes, Or) === 0;
      }
      function lo(qe) {
        return [qe[0] * ne.d9, qe[1] * ne.d9, qe[2] * ne.d9, 0];
      }
      function Mo(qe, xe, ke, He, ir, ar, yr, Tr, $r) {
        const Dr = He.getSource(), Or = ke.globeSharedBuffers;
        if (!Or)
          return;
        let Gr, qr, Jr;
        if (xe && (Gr = He.getTile(xe)), Dr instanceof ne.aJ ? (qr = Dr.texture, Jr = ne.cI(0, 0, ke.transform)) : Gr && xe && (qr = Gr.texture, Jr = ne.cI(xe.canonical.z, xe.canonical.x, ke.transform)), !qr || !Jr)
          return;
        qe || (Jr = ne.ab.mat4.scale(ne.ab.mat4.create(), Jr, [1, -1, 1]));
        const bi = ke.context, fi = bi.gl, Mi = ir.paint.get("raster-resampling") === "nearest" ? fi.NEAREST : fi.LINEAR, Ei = ke.colorModeForDrapableLayerRenderPass(ar), Ii = yr.defines;
        Ii.push("GLOBE_POLES");
        const Ni = new Oo(fi.LEQUAL, Oo.ReadWrite, ke.depthRangeFor3D), zi = Float32Array.from(ke.transform.expandedFarZProjMatrix), Ki = Float32Array.from(ne.bb(ne.cH(new ne.bT(0, 0, 0))));
        ke.terrain && ke.terrain.prepareDrawTile(), bi.activeTexture.set(fi.TEXTURE0), qr.bind(Mi, fi.CLAMP_TO_EDGE), bi.activeTexture.set(fi.TEXTURE1), qr.bind(Mi, fi.CLAMP_TO_EDGE), qr.useMipmap && bi.extTextureFilterAnisotropic && ke.transform.pitch > 20 && fi.texParameterf(fi.TEXTURE_2D, bi.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, bi.extTextureFilterAnisotropicMax);
        const [Wi, Xi, Gi, nn] = xe ? Or.getPoleBuffers(xe.canonical.z, !1) : Or.getPoleBuffers(0, !0), dn = ir.paint.get("raster-elevation");
        let Pn;
        qe ? (Pn = Wi, ke.renderDefaultNorthPole = dn !== 0) : (Pn = Xi, ke.renderDefaultSouthPole = dn !== 0);
        const Ln = lo(yr.mix), hn = ((Hn, io, uo, An, eo, On, ao, ro, Wn, _o, yo, mo, Eo) => Ao(Hn, io, uo, new Float32Array(16), new Float32Array(9), [0, 0], An, [0, 0], [0, 0, 0, 0], 1, { opacity: 1, mix: 0 }, On, [0, 0], ro, 2, _o, yo, mo, 1, 0, Eo))(zi, Ki, Jr, ne.ae(ke.transform.zoom), 0, ir, 0, dn, 0, Ln, yr.offset, yr.range, ar), xn = ke.getOrCreateProgram("raster", { defines: Ii });
        ke.uploadCommonUniforms(bi, xn, null), xn.draw(ke, fi.TRIANGLES, Ni, $r, Ei, Tr, hn, ir.id, Pn, Gi, nn);
      }
      function Jh(qe) {
        const xe = qe._nearZ, ke = qe.projection.farthestPixelDistance(qe), He = ke - xe, ir = 0.2 * qe.height, ar = xe + ir;
        return [xe, ke, (ar - ir - xe) / He, (ar - xe) / He];
      }
      function ys(qe, xe, ke, He) {
        if (qe)
          return xe instanceof Pl && qe instanceof yd ? xe.getTextureDescriptor(qe, ke, !0) : { texture: qe.texture, mix: lo(He.mix), offset: He.offset, buffer: 0, tileSize: 1 };
      }
      var Bn = ne.da([{ name: "a_index", type: "Int16", components: 1 }]);
      class Wm {
        constructor(xe, ke, He, ir) {
          const ar = { width: He[0], height: He[1], data: null }, yr = xe.gl;
          this.targetColorTexture = new ne.T(xe, ar, yr.RGBA8, { useMipmap: !1 }), this.backgroundColorTexture = new ne.T(xe, ar, yr.RGBA8, { useMipmap: !1 }), this.context = xe, this.updateParticleTexture(ke, ir), this.lastInvalidatedAt = 0;
        }
        updateParticleTexture(xe, ke) {
          if (this.particleTextureDimension === ke.width)
            return;
          (this.particleTexture0 || this.particleTexture1 || this.particleIndexBuffer || this.particleSegment) && (this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleIndexBuffer.destroy(), this.particleSegment.destroy());
          const He = this.context.gl, ir = ke.width * ke.height;
          this.particleTexture0 = new ne.T(this.context, ke, He.RGBA8, { premultiply: !1, useMipmap: !1 }), this.particleTexture1 = new ne.T(this.context, ke, He.RGBA8, { premultiply: !1, useMipmap: !1 });
          const ar = new ne.db();
          ar.reserve(ir);
          for (let yr = 0; yr < ir; yr++)
            ar.emplaceBack(yr);
          this.particleIndexBuffer = this.context.createVertexBuffer(ar, Bn.members, !0), this.particleSegment = ne.b7.simpleSegment(0, 0, this.particleIndexBuffer.length, 0), this.particleTextureDimension = ke.width;
        }
        update(xe) {
          return !(this.lastInvalidatedAt < xe && (this.lastInvalidatedAt = ne.q.now(), 1));
        }
        destroy() {
          this.targetColorTexture.destroy(), this.backgroundColorTexture.destroy(), this.particleIndexBuffer.destroy(), this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleSegment.destroy();
        }
      }
      function Iu(qe, xe, ke) {
        if (!qe)
          return null;
        const He = xe.getTextureDescriptor(qe, ke, !0);
        if (!He)
          return null;
        let { texture: ir, mix: ar, offset: yr, tileSize: Tr, buffer: $r, format: Dr } = He;
        if (!ir || !Dr)
          return null;
        let Or = !1;
        return Dr === "uint32" && (Or = !0, ar[3] = 0, ar = ah(ne.dc, ar, [0, ke.paint.get("raster-particle-max-speed")]), yr = Nd(ne.dc, yr, [0, ke.paint.get("raster-particle-max-speed")])), { texture: ir, textureOffset: [$r / (Tr + 2 * $r), Tr / (Tr + 2 * $r)], tileSize: Tr, scalarData: Or, scale: ar, offset: yr, defines: ["RASTER_ARRAY", { uint8: "DATA_FORMAT_UINT8", uint16: "DATA_FORMAT_UINT16", uint32: "DATA_FORMAT_UINT32" }[Dr]] };
      }
      function Zf(qe) {
        const xe = qe._nearZ, ke = qe.projection.farthestPixelDistance(qe), He = ke - xe, ir = 0.2 * qe.height, ar = xe + ir;
        return [xe, ke, (ar - ir - xe) / He, (ar - xe) / He];
      }
      const Zm = new ne.aj(1, 0, 0, 1), Xm = new ne.aj(0, 1, 0, 1), Qh = new ne.aj(0, 0, 1, 1), ed = new ne.aj(1, 0, 1, 1), W0 = new ne.aj(0, 1, 1, 1);
      function Bu(qe, xe, ke, He, ir, ar, yr) {
        const Tr = qe.context, $r = qe.transform, Dr = Tr.gl, Or = $r.projection.name === "globe", Gr = Or ? ["PROJECTION_GLOBE_VIEW"] : [];
        let qr = ne.ab.mat4.clone(ke.projMatrix);
        if (Or && ne.ae($r.zoom) > 0) {
          const Ln = ne.ba(ke.canonical, $r), hn = ne.dd(Ln);
          qr = ne.ab.mat4.multiply(new Float32Array(16), $r.globeMatrix, hn), ne.ab.mat4.multiply(qr, $r.projMatrix, qr);
        }
        const Jr = ne.ab.mat4.create();
        Jr[12] += 2 * ir / (ne.q.devicePixelRatio * $r.width), Jr[13] += 2 * ar / (ne.q.devicePixelRatio * $r.height), ne.ab.mat4.multiply(qr, Jr, qr);
        const bi = qe.getOrCreateProgram("debug", { defines: Gr }), fi = xe.getTileByID(ke.key);
        qe.terrain && qe.terrain.setupElevationDraw(fi, bi);
        const Mi = Oo.disabled, Ei = ta.disabled, Ii = qe.colorModeForRenderPass(), Ni = "$debug";
        Tr.activeTexture.set(Dr.TEXTURE0), qe.emptyTexture.bind(Dr.LINEAR, Dr.CLAMP_TO_EDGE), Or ? fi._makeGlobeTileDebugBuffers(qe.context, $r) : fi._makeDebugTileBoundsBuffers(qe.context, $r.projection);
        const zi = fi._tileDebugBuffer || qe.debugBuffer, Ki = fi._tileDebugIndexBuffer || qe.debugIndexBuffer, Wi = fi._tileDebugSegments || qe.debugSegments;
        if (bi.draw(qe, Dr.LINE_STRIP, Mi, Ei, Ii, Uo.disabled, jf(qr, He), Ni, zi, Ki, Wi, null, null, null, [fi._globeTileDebugBorderBuffer]), yr) {
          const Ln = fi.latestRawTileData, hn = Math.floor((Ln && Ln.byteLength || 0) / 1024);
          let xn = ke.canonical.toString();
          ke.overscaledZ !== ke.canonical.z && (xn += ` => ${ke.overscaledZ}`), xn += ` ${fi.state}`, xn += ` ${hn}kb`, function(Hn, io) {
            Hn.initDebugOverlayCanvas();
            const uo = Hn.debugOverlayCanvas, An = Hn.context.gl, eo = Hn.debugOverlayCanvas.getContext("2d");
            eo.clearRect(0, 0, uo.width, uo.height), eo.shadowColor = "white", eo.shadowBlur = 2, eo.lineWidth = 1.5, eo.strokeStyle = "white", eo.textBaseline = "top", eo.font = "bold 36px Open Sans, sans-serif", eo.fillText(io, 5, 5), eo.strokeText(io, 5, 5), Hn.debugOverlayTexture.update(uo), Hn.debugOverlayTexture.bind(An.LINEAR, An.CLAMP_TO_EDGE);
          }(qe, xn);
        }
        const Xi = xe.getTile(ke).tileSize, Gi = 512 / Math.min(Xi, 512) * (ke.overscaledZ / $r.zoom) * 0.5, nn = fi._tileDebugTextBuffer || qe.debugBuffer, dn = fi._tileDebugTextIndexBuffer || qe.quadTriangleIndexBuffer, Pn = fi._tileDebugTextSegments || qe.debugSegments;
        bi.draw(qe, Dr.TRIANGLES, Mi, Ei, aa.alphaBlended, Uo.disabled, jf(qr, ne.aj.transparent, Gi), Ni, nn, dn, Pn, null, null, null, [fi._globeTileDebugTextBuffer]);
      }
      function Xf(qe, xe, ke, He) {
        td(qe, 0, xe + ke / 2, qe.transform.width, ke, He);
      }
      function Gd(qe, xe, ke, He) {
        td(qe, xe - ke / 2, 0, ke, qe.transform.height, He);
      }
      function td(qe, xe, ke, He, ir, ar) {
        const yr = qe.context, Tr = yr.gl;
        Tr.enable(Tr.SCISSOR_TEST), Tr.scissor(xe * ne.q.devicePixelRatio, ke * ne.q.devicePixelRatio, He * ne.q.devicePixelRatio, ir * ne.q.devicePixelRatio), yr.clear({ color: ar }), Tr.disable(Tr.SCISSOR_TEST);
      }
      const Km = ne.da([{ name: "a_pos_3f", components: 3, type: "Float32" }]), { members: Gp } = Km;
      function Ql(qe, xe, ke, He) {
        qe.emplaceBack(xe, ke, He);
      }
      class Hd {
        constructor(xe) {
          this.vertexArray = new ne.de(), this.indices = new ne.aU(), Ql(this.vertexArray, -1, -1, 1), Ql(this.vertexArray, 1, -1, 1), Ql(this.vertexArray, -1, 1, 1), Ql(this.vertexArray, 1, 1, 1), Ql(this.vertexArray, -1, -1, -1), Ql(this.vertexArray, 1, -1, -1), Ql(this.vertexArray, -1, 1, -1), Ql(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = xe.createVertexBuffer(this.vertexArray, Gp), this.indexBuffer = xe.createIndexBuffer(this.indices), this.segment = ne.b7.simpleSegment(0, 0, 36, 12);
        }
      }
      function fl(qe, xe, ke, He, ir, ar) {
        const yr = qe.context.gl, Tr = xe.paint.get("sky-atmosphere-color"), $r = xe.paint.get("sky-atmosphere-halo-color"), Dr = xe.paint.get("sky-atmosphere-sun-intensity"), Or = ((Gr, qr, Jr, bi, fi) => ({ u_matrix_3f: Gr, u_sun_direction: qr, u_sun_intensity: Jr, u_color_tint_r: [bi.r, bi.g, bi.b, bi.a], u_color_tint_m: [fi.r, fi.g, fi.b, fi.a], u_luminance: 5e-5 }))(ne.ab.mat3.fromMat4(ne.ab.mat3.create(), He), ir, Dr, Tr, $r);
        yr.framebufferTexture2D(yr.FRAMEBUFFER, yr.COLOR_ATTACHMENT0, yr.TEXTURE_CUBE_MAP_POSITIVE_X + ar, xe.skyboxTexture, 0), ke.draw(qe, yr.TRIANGLES, Oo.disabled, ta.disabled, aa.unblended, Uo.frontCW, Or, "skyboxCapture", xe.skyboxGeometry.vertexBuffer, xe.skyboxGeometry.indexBuffer, xe.skyboxGeometry.segment);
      }
      const Hp = ne.da([{ type: "Float32", name: "a_pos", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }]);
      class Ym {
        constructor(xe) {
          const ke = new ne.df();
          ke.emplaceBack(-1, 1, 1, 0, 0), ke.emplaceBack(1, 1, 1, 1, 0), ke.emplaceBack(1, -1, 1, 1, 1), ke.emplaceBack(-1, -1, 1, 0, 1);
          const He = new ne.aU();
          He.emplaceBack(0, 1, 2), He.emplaceBack(2, 3, 0), this.vertexBuffer = xe.createVertexBuffer(ke, Hp.members), this.indexBuffer = xe.createIndexBuffer(He), this.segments = ne.b7.simpleSegment(0, 0, 4, 2);
        }
        destroy() {
          this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
        }
      }
      const Cl = ne.da([{ type: "Float32", name: "a_pos_3f", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }, { type: "Float32", name: "a_size_scale", components: 1 }, { type: "Float32", name: "a_fade_opacity", components: 1 }]);
      class Kf {
        constructor() {
          this.starsCount = 16e3, this.sizeMultiplier = 0.15, this.sizeRange = 100, this.intensityRange = 200;
        }
      }
      class Wd {
        constructor(xe) {
          this.colorModeAlphaBlendedWriteRGB = new aa([1, Ph, 1, Ph], ne.aj.transparent, [!0, !0, !0, !1]), this.colorModeWriteAlpha = new aa([1, 0, 1, 0], ne.aj.transparent, [!1, !1, !1, !0]), this.params = new Kf(), this.updateNeeded = !0, xe.tp.registerParameter(this.params, ["Stars"], "starsCount", { min: 100, max: 16e3, step: 1 }, () => {
            this.updateNeeded = !0;
          }), xe.tp.registerParameter(this.params, ["Stars"], "sizeMultiplier", { min: 0.01, max: 2, step: 0.01 }), xe.tp.registerParameter(this.params, ["Stars"], "sizeRange", { min: 0, max: 200, step: 1 }, () => {
            this.updateNeeded = !0;
          }), xe.tp.registerParameter(this.params, ["Stars"], "intensityRange", { min: 0, max: 200, step: 1 }, () => {
            this.updateNeeded = !0;
          });
        }
        update(xe) {
          const ke = xe.context;
          if (!this.atmosphereBuffer || this.updateNeeded) {
            this.updateNeeded = !1, this.atmosphereBuffer = new Ym(ke);
            const He = this.params.sizeRange, ir = this.params.intensityRange, ar = function(Or) {
              const Gr = ne.di(30), qr = [];
              for (let Jr = 0; Jr < Or; ++Jr) {
                const bi = 2 * Math.PI * Gr(), fi = Math.acos(1 - 2 * Gr()) - 0.5 * Math.PI;
                qr.push(ne.ab.vec3.fromValues(Math.cos(fi) * Math.cos(bi), Math.cos(fi) * Math.sin(bi), Math.sin(fi)));
              }
              return qr;
            }(this.params.starsCount), yr = ne.di(300), Tr = new ne.dg(), $r = new ne.aU();
            let Dr = 0;
            for (let Or = 0; Or < ar.length; ++Or) {
              const Gr = ne.ab.vec3.scale([], ar[Or], 200), qr = Math.max(0, 1 + 0.01 * He * (1 * yr() - 0.5)), Jr = Math.max(0, 1 + 0.01 * ir * (1 * yr() - 0.5));
              Tr.emplaceBack(Gr[0], Gr[1], Gr[2], -1, -1, qr, Jr), Tr.emplaceBack(Gr[0], Gr[1], Gr[2], 1, -1, qr, Jr), Tr.emplaceBack(Gr[0], Gr[1], Gr[2], 1, 1, qr, Jr), Tr.emplaceBack(Gr[0], Gr[1], Gr[2], -1, 1, qr, Jr), $r.emplaceBack(Dr + 0, Dr + 1, Dr + 2), $r.emplaceBack(Dr + 0, Dr + 2, Dr + 3), Dr += 4;
            }
            this.starsVx = ke.createVertexBuffer(Tr, Cl.members), this.starsIdx = ke.createIndexBuffer($r), this.starsSegments = ne.b7.simpleSegment(0, 0, Tr.length, $r.length);
          }
        }
        destroy() {
          this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy();
        }
        drawAtmosphereGlow(xe, ke) {
          const He = xe.context, ir = He.gl, ar = xe.transform, yr = new Oo(ir.LEQUAL, Oo.ReadOnly, [0, 1]), Tr = ne.ae(ar.zoom), $r = xe.style.getLut(ke.scope), Dr = ke.properties.get("color-use-theme") === "none", Or = ke.properties.get("color").toRenderColor(Dr ? null : $r).toArray01(), Gr = ke.properties.get("high-color-use-theme") === "none", qr = ke.properties.get("high-color").toRenderColor(Gr ? null : $r).toArray01(), Jr = ke.properties.get("space-color-use-theme") === "none", bi = ke.properties.get("space-color").toRenderColor(Jr ? null : $r).toArray01PremultipliedAlpha(), fi = 5e-4, Mi = ne.dh(ke.properties.get("horizon-blend"), 0, 1, fi, 0.25), Ei = ne.cC(xe, He, ar) && Mi === fi ? ar.worldSize / (2 * Math.PI * 1.025) - 1 : ar.globeRadius, Ii = xe.frameCounter / 1e3 % 1, Ni = ne.ab.vec3.length(ar.globeCenterInViewSpace), zi = Math.sqrt(Math.pow(Ni, 2) - Math.pow(Ei, 2)), Ki = Math.acos(zi / Ni), Wi = (Xi) => {
            const Gi = ar.projection.name === "globe" ? ["PROJECTION_GLOBE_VIEW", "FOG"] : ["FOG"];
            Xi && Gi.push("ALPHA_PASS");
            const nn = xe.getOrCreateProgram("globeAtmosphere", { defines: Gi }), dn = ((Ln, hn, xn, Hn, io, uo, An, eo, On, ao, ro, Wn) => ({ u_frustum_tl: Ln, u_frustum_tr: hn, u_frustum_br: xn, u_frustum_bl: Hn, u_horizon: io, u_transition: uo, u_fadeout_range: An, u_color: eo, u_high_color: On, u_space_color: ao, u_temporal_offset: ro, u_horizon_angle: Wn }))(ar.frustumCorners.TL, ar.frustumCorners.TR, ar.frustumCorners.BR, ar.frustumCorners.BL, ar.frustumCorners.horizon, Tr, Mi, Or, qr, bi, Ii, Ki);
            xe.uploadCommonUniforms(He, nn);
            const Pn = this.atmosphereBuffer;
            Pn && nn.draw(xe, ir.TRIANGLES, yr, ta.disabled, Xi ? this.colorModeWriteAlpha : this.colorModeAlphaBlendedWriteRGB, Uo.backCW, dn, Xi ? "atmosphere_glow_alpha" : "atmosphere_glow", Pn.vertexBuffer, Pn.indexBuffer, Pn.segments);
          };
          Wi(!1), Wi(!0);
        }
        drawStars(xe, ke) {
          const He = ne.aw(ke.properties.get("star-intensity"), 0, 1);
          if (He === 0)
            return;
          const ir = xe.context, ar = ir.gl, yr = xe.transform, Tr = xe.getOrCreateProgram("stars"), $r = ne.ab.quat.identity([]);
          ne.ab.quat.rotateX($r, $r, -yr._pitch), ne.ab.quat.rotateZ($r, $r, -yr.angle), ne.ab.quat.rotateX($r, $r, ne.ai(yr._center.lat)), ne.ab.quat.rotateY($r, $r, -ne.ai(yr._center.lng));
          const Dr = ne.ab.mat4.fromQuat(new Float32Array(16), $r), Or = ne.ab.mat4.multiply([], yr.starsProjMatrix, Dr), Gr = ne.ab.mat3.fromMat4([], Dr), qr = ne.ab.mat3.invert([], Gr), Jr = [0, 1, 0];
          ne.ab.vec3.transformMat3(Jr, Jr, qr), ne.ab.vec3.scale(Jr, Jr, this.params.sizeMultiplier);
          const bi = [1, 0, 0];
          ne.ab.vec3.transformMat3(bi, bi, qr), ne.ab.vec3.scale(bi, bi, this.params.sizeMultiplier);
          const fi = (Mi = Jr, Ei = bi, Ii = He, { u_matrix: Float32Array.from(Or), u_up: Mi, u_right: Ei, u_intensity_multiplier: Ii });
          var Mi, Ei, Ii;
          xe.uploadCommonUniforms(ir, Tr), this.starsVx && this.starsIdx && Tr.draw(xe, ar.TRIANGLES, Oo.disabled, ta.disabled, this.colorModeAlphaBlendedWriteRGB, Uo.disabled, fi, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
        }
      }
      function Ka(qe, xe) {
        const ke = [...qe], He = xe.cameraWorldSizeForFog / xe.worldSize, ir = ne.ab.mat4.identity([]);
        return ne.ab.mat4.scale(ir, ir, [He, He, 1]), ne.ab.mat4.multiply(ke, ir, ke), ne.ab.mat4.multiply(ke, xe.worldToFogMatrix, ke), ke;
      }
      function La(qe, xe, ke, He, ir) {
        const ar = ke.material, yr = He.context, { baseColorTexture: Tr, metallicRoughnessTexture: $r } = ar.pbrMetallicRoughness, { normalTexture: Dr, occlusionTexture: Or, emissionTexture: Gr } = ar;
        function qr(bi, fi, Mi) {
          if (bi && (qe.push(fi), yr.activeTexture.set(yr.gl.TEXTURE0 + Mi), bi.gfxTexture)) {
            const { minFilter: Ei, magFilter: Ii, wrapS: Ni, wrapT: zi } = bi.sampler;
            bi.gfxTexture.bindExtraParam(Ei, Ii, Ni, zi);
          }
        }
        qr(Tr, "HAS_TEXTURE_u_baseColorTexture", ll.BaseColor), qr($r, "HAS_TEXTURE_u_metallicRoughnessTexture", ll.MetallicRoughness), qr(Dr, "HAS_TEXTURE_u_normalTexture", ll.Normal), qr(Or, "HAS_TEXTURE_u_occlusionTexture", ll.Occlusion), qr(Gr, "HAS_TEXTURE_u_emissionTexture", ll.Emission), ir && (ir.texture || (ir.texture = new ne.dk(He.context, ir.image, [ir.image.height, ir.image.height, ir.image.height], yr.gl.RGBA8)), yr.activeTexture.set(yr.gl.TEXTURE0 + ll.LUT), ir.texture && ir.texture.bind(yr.gl.LINEAR, yr.gl.CLAMP_TO_EDGE), qe.push("APPLY_LUT_ON_GPU")), ke.texcoordBuffer && (qe.push("HAS_ATTRIBUTE_a_uv_2f"), xe.push(ke.texcoordBuffer)), ke.colorBuffer && (qe.push(ke.colorBuffer.itemSize === 12 ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), xe.push(ke.colorBuffer)), ke.normalBuffer && (qe.push("HAS_ATTRIBUTE_a_normal_3f"), xe.push(ke.normalBuffer)), ke.pbrBuffer && (qe.push("HAS_ATTRIBUTE_a_pbr"), qe.push("HAS_ATTRIBUTE_a_heightBasedEmissiveStrength"), xe.push(ke.pbrBuffer)), ar.alphaMode !== "OPAQUE" && ar.alphaMode !== "MASK" || qe.push("UNPREMULT_TEXTURE_IN_SHADER"), ar.defined || qe.push("DIFFUSE_SHADED"), qe.push("USE_STANDARD_DERIVATIVES");
        const Jr = He.shadowRenderer;
        Jr && (qe.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), Jr.useNormalOffset && qe.push("NORMAL_OFFSET"));
      }
      function Zd(qe, xe, ke, He, ir, ar) {
        const yr = ke.paint.get("model-opacity").constantOr(1), Tr = xe.context, $r = new Oo(xe.context.gl.LEQUAL, Oo.ReadWrite, xe.depthRangeFor3D), Dr = xe.transform, Or = qe.mesh, Gr = Or.material, qr = Gr.pbrMetallicRoughness, Jr = xe.style.fog;
        let bi;
        bi = xe.transform.projection.zAxisUnit === "pixels" ? [...qe.nodeModelMatrix] : ne.ab.mat4.multiply([], He.zScaleMatrix, qe.nodeModelMatrix), ne.ab.mat4.multiply(bi, He.negCameraPosMatrix, bi);
        const fi = ne.ab.mat4.invert([], bi);
        ne.ab.mat4.transpose(fi, fi);
        const Mi = ke.paint.get("model-color-use-theme").constantOr("default") === "none", Ei = ke.paint.get("model-emissive-strength").constantOr(0), Ii = Gf(new Float32Array(qe.worldViewProjection), new Float32Array(bi), new Float32Array(fi), null, xe, yr, qr.baseColorFactor.toRenderColor(null), Gr.emissiveFactor, qr.metallicFactor, qr.roughnessFactor, Gr, Ei, ke), Ni = { defines: [] }, zi = [], Ki = xe.shadowRenderer;
        Ki && (Ki.useNormalOffset = !1), La(Ni.defines, zi, Or, xe, Mi ? null : ke.lut);
        let Wi = null;
        if (Jr) {
          const nn = Ka(qe.nodeModelMatrix, xe.transform);
          if (Wi = new Float32Array(nn), Dr.projection.name !== "globe") {
            const dn = Or.aabb.min, Pn = Or.aabb.max, [Ln, hn] = Jr.getOpacityForBounds(nn, dn[0], dn[1], Pn[0], Pn[1]);
            Ni.overrideFog = Ln >= Tn || hn >= Tn;
          }
        }
        const Xi = Tc(xe, ke.paint.get("model-cutoff-fade-range"));
        Xi.shouldRenderCutoff && Ni.defines.push("RENDER_CUTOFF");
        const Gi = xe.getOrCreateProgram("model", Ni);
        xe.uploadCommonUniforms(Tr, Gi, null, Wi, Xi), xe.renderPass !== "shadow" && Ki && Ki.setupShadowsFromMatrix(qe.nodeModelMatrix, Gi), Gi.draw(xe, Tr.gl.TRIANGLES, $r, ir, ar, Or.material.doubleSided ? Uo.disabled : Uo.backCCW, Ii, ke.id, Or.vertexBuffer, Or.indexBuffer, Or.segments, ke.paint, xe.transform.zoom, void 0, zi);
      }
      function Zc(qe, xe, ke, He, ir, ar, yr) {
        let Tr;
        Tr = qe.projection.name === "globe" ? ne.dl(ke, qe) : [...ke], ne.ab.mat4.multiply(Tr, Tr, xe.matrix);
        const $r = ne.ab.mat4.multiply([], He, Tr);
        if (xe.meshes)
          for (const Dr of xe.meshes) {
            if (Dr.material.alphaMode !== "BLEND") {
              yr.push({ mesh: Dr, depth: 0, modelIndex: ir, worldViewProjection: $r, nodeModelMatrix: Tr });
              continue;
            }
            const Or = ne.ab.vec3.transformMat4([], Dr.centroid, $r);
            Or[2] > 0 && ar.push({ mesh: Dr, depth: Or[2], modelIndex: ir, worldViewProjection: $r, nodeModelMatrix: Tr });
          }
        if (xe.children)
          for (const Dr of xe.children)
            Zc(qe, Dr, ke, He, ir, ar, yr);
      }
      function rd(qe, xe, ke, He) {
        const ir = ke.shadowRenderer;
        if (!ir)
          return;
        const ar = ir.getShadowPassDepthMode(), yr = ir.getShadowPassColorMode(), Tr = ir.calculateShadowPassMatrixFromMatrix(xe), $r = Hc(Tr);
        ke.getOrCreateProgram("modelDepth", { defines: ke._shadowMapDebug ? [] : ["DEPTH_TEXTURE"] }).draw(ke, ke.context.gl.TRIANGLES, ar, ta.disabled, yr, Uo.backCCW, $r, He.id, qe.vertexBuffer, qe.indexBuffer, qe.segments, He.paint, ke.transform.zoom, void 0, void 0);
      }
      function $u(qe, xe, ke) {
        const He = xe.updateZoomBasedPaintProperties(), ir = function(ar, yr, Tr) {
          let $r, Dr, Or, Gr = ar.terrain ? ar.terrain.exaggeration() : 0;
          if (ar.terrain && Gr > 0) {
            const qr = ar.terrain, Jr = qr.findDEMTileFor(Tr);
            Jr && Jr.dem ? $r = ne.dn.create(qr, Tr, Jr) : Gr = 0;
          }
          if (Gr === 0 && (yr.terrainElevationMin = 0, yr.terrainElevationMax = 0), Gr === yr.validForExaggeration && (Gr === 0 || $r && $r._demTile && $r._demTile.tileID === yr.validForDEMTile.id && $r._dem._timestamp === yr.validForDEMTile.timestamp))
            return !1;
          for (const qr in yr.instancesPerModel) {
            const Jr = yr.instancesPerModel[qr];
            for (let bi = 0; bi < Jr.instancedDataArray.length; ++bi) {
              const fi = ($r ? Gr * $r.getElevationAt(0 | Jr.instancedDataArray.float32[16 * bi], 0 | Jr.instancedDataArray.float32[16 * bi + 1], !0, !0) : 0) + Jr.instancesEvaluatedElevation[bi];
              Jr.instancedDataArray.float32[16 * bi + 6] = fi, Dr = Dr ? Math.min(yr.terrainElevationMin, fi) : fi, Or = Or ? Math.max(yr.terrainElevationMax, fi) : fi;
            }
          }
          return yr.terrainElevationMin = Dr || 0, yr.terrainElevationMax = Or || 0, yr.validForExaggeration = Gr, yr.validForDEMTile = $r && $r._demTile ? { id: $r._demTile.tileID, timestamp: $r._dem._timestamp } : { id: void 0, timestamp: 0 }, !0;
        }(qe, xe, ke);
        (He || ir) && (xe.uploaded = !1, xe.upload(qe.context));
      }
      const tc = { shadowUniformsInitialized: !1, useSingleShadowCascade: !1, tileMatrix: new Float64Array(16), shadowTileMatrix: new Float32Array(16), aabb: new ne.cd([0, 0, 0], [ne.ag, ne.ag, 0]) };
      function Xd(qe, xe) {
        const ke = 1 << qe.canonical.z, He = xe.getFreeCameraOptions().position, ir = xe.elevation, ar = qe.canonical.x / ke, yr = (qe.canonical.x + 1) / ke, Tr = qe.canonical.y / ke, $r = (qe.canonical.y + 1) / ke;
        let Dr = xe._centerAltitude;
        if (ir) {
          const Jr = ir.getMinMaxForTile(qe);
          Jr && Jr.max > Dr && (Dr = Jr.max);
        }
        const Or = ne.aw(He.x, ar, yr) - He.x, Gr = ne.aw(He.y, Tr, $r) - He.y, qr = ne.bH(Dr, xe.center.lat) - He.z;
        return xe._zoomFromMercatorZ(Math.sqrt(Or * Or + Gr * Gr + qr * qr));
      }
      function cu(qe, xe, ke, He, ir, ar, yr) {
        const Tr = qe.context, $r = qe.renderPass === "shadow", Dr = qe.shadowRenderer, Or = $r && Dr ? Dr.getShadowPassDepthMode() : new Oo(Tr.gl.LEQUAL, Oo.ReadWrite, qe.depthRangeFor3D), Gr = qe.isTileAffectedByFog(ar);
        if (ke.meshes)
          for (const qr of ke.meshes) {
            const Jr = ["MODEL_POSITION_ON_GPU"], bi = [];
            let fi, Mi, Ei;
            He.instancedDataArray.length > 20 && Jr.push("INSTANCED_ARRAYS");
            const Ii = Tc(qe, xe.paint.get("model-cutoff-fade-range"));
            if (Ii.shouldRenderCutoff && Jr.push("RENDER_CUTOFF"), $r && Dr)
              fi = qe.getOrCreateProgram("modelDepth", { defines: Jr }), Mi = Hc(yr.shadowTileMatrix, yr.shadowTileMatrix, Float32Array.from(ke.matrix)), Ei = Dr.getShadowPassColorMode();
            else {
              La(Jr, bi, qr, qe, xe.paint.get("model-color-use-theme").constantOr("default") === "none" ? null : xe.lut), fi = qe.getOrCreateProgram("model", { defines: Jr, overrideFog: Gr });
              const zi = qr.material, Ki = zi.pbrMetallicRoughness, Wi = xe.paint.get("model-opacity").constantOr(1), Xi = xe.paint.get("model-emissive-strength").constantOr(0);
              Mi = Gf(ar.expandedProjMatrix, Float32Array.from(ke.matrix), new Float32Array(16), null, qe, Wi, Ki.baseColorFactor.toRenderColor(null), zi.emissiveFactor, Ki.metallicFactor, Ki.roughnessFactor, zi, Xi, xe, ir), Dr && (yr.shadowUniformsInitialized ? fi.setShadowUniformValues(Tr, Dr.getShadowUniformValues()) : (Dr.setupShadows(ar.toUnwrapped(), fi, "model-tile", ar.overscaledZ), yr.shadowUniformsInitialized = !0)), Ei = Ii.shouldRenderCutoff || Wi < 1 || zi.alphaMode !== "OPAQUE" ? aa.alphaBlended : aa.unblended;
            }
            qe.uploadCommonUniforms(Tr, fi, ar.toUnwrapped(), null, Ii);
            const Ni = qr.material.doubleSided ? Uo.disabled : Uo.backCCW;
            if (He.instancedDataArray.length > 20)
              bi.push(He.instancedDataBuffer), fi.draw(qe, Tr.gl.TRIANGLES, Or, ta.disabled, Ei, Ni, Mi, xe.id, qr.vertexBuffer, qr.indexBuffer, qr.segments, xe.paint, qe.transform.zoom, void 0, bi, He.instancedDataArray.length);
            else {
              const zi = $r ? "u_instance" : "u_normal_matrix";
              for (let Ki = 0; Ki < He.instancedDataArray.length; ++Ki)
                Mi[zi] = new Float32Array(He.instancedDataArray.arrayBuffer, 64 * Ki, 16), fi.draw(qe, Tr.gl.TRIANGLES, Or, ta.disabled, Ei, Ni, Mi, xe.id, qr.vertexBuffer, qr.indexBuffer, qr.segments, xe.paint, qe.transform.zoom, void 0, bi);
            }
          }
        if (ke.children)
          for (const qr of ke.children)
            cu(qe, xe, qr, He, ir, ar, yr);
      }
      const Xc = [1, -1, 1];
      function Ia(qe, xe, ke, He) {
        if (!ke.modelManager)
          return !0;
        const ir = ke.modelManager;
        if (!ke.shadowRenderer)
          return !0;
        const ar = ke.shadowRenderer, yr = xe.aabb;
        let Tr = !0, $r = qe.maxHeight;
        if ($r === 0) {
          let Or = 0;
          for (const Gr in qe.instancesPerModel) {
            const qr = ir.getModel(Gr, He);
            qr ? Or = Math.max(Or, Math.max(Math.max(qr.aabb.max[0], qr.aabb.max[1]), qr.aabb.max[2])) : Tr = !1;
          }
          $r = qe.maxScale * Or * 1.41 + qe.maxVerticalOffset, Tr && (qe.maxHeight = $r);
        }
        yr.max[2] = $r, yr.min[2] += qe.terrainElevationMin, yr.max[2] += qe.terrainElevationMax, ne.ab.vec3.transformMat4(yr.min, yr.min, xe.tileMatrix), ne.ab.vec3.transformMat4(yr.max, yr.max, xe.tileMatrix);
        const Dr = yr.intersects(ar.getCurrentCascadeFrustum());
        return ke.currentShadowCascade === 0 && (qe.isInsideFirstShadowMapFrustum = Dr === 2), Dr === 0;
      }
      function Yf(qe, xe) {
        const ke = qe.uniformValues.u_cutoff_params[0], He = qe.uniformValues.u_cutoff_params[1], ir = qe.uniformValues.u_cutoff_params[2], ar = qe.uniformValues.u_cutoff_params[3];
        return He === ke || ar === ir ? 1 : ne.aw(((xe - ke) / (He - ke) - ir) / (ar - ir), 0, 1);
      }
      function Jf(qe, xe, ke, He) {
        if (xe.pitch < 20)
          return 1;
        const ir = xe.getWorldToCameraMatrix();
        ne.ab.mat4.multiply(ir, ir, qe);
        const ar = ne.ab.vec4.fromValues(ke.min[0], ke.min[1], ke.min[2], 1);
        let yr = ne.ab.vec4.transformMat4(ne.ab.vec4.create(), ar, ir), Tr = yr, $r = yr;
        ar[1] = ke.max[1], yr = ne.ab.vec4.transformMat4(ne.ab.vec4.create(), ar, ir), Tr = yr[1] < Tr[1] ? yr : Tr, $r = yr[1] > $r[1] ? yr : $r, ar[0] = ke.max[0], yr = ne.ab.vec4.transformMat4(ne.ab.vec4.create(), ar, ir), Tr = yr[1] < Tr[1] ? yr : Tr, $r = yr[1] > $r[1] ? yr : $r, ar[1] = ke.min[1], yr = ne.ab.vec4.transformMat4(ne.ab.vec4.create(), ar, ir), Tr = yr[1] < Tr[1] ? yr : Tr, $r = yr[1] > $r[1] ? yr : $r;
        const Dr = ne.aw(He[0], 0, 1), Or = 100 * xe.pixelsPerMeter * ne.aw(He[1], 0, 1), Gr = ne.aw(He[2], 0, 1), qr = ne.ab.vec4.lerp(ne.ab.vec4.create(), Tr, $r, Dr), Jr = Math.tan(0.5 * xe.fovX), bi = -qr[2] * Jr;
        if (Or === 0)
          return qr[1] < -Math.abs(bi) ? Gr : 1;
        const fi = (-Math.abs(bi) - qr[1]) / Or, Mi = (Ii, Ni, zi) => (1 - zi) * Ii + zi * Ni, Ei = ne.aw(Mi(1, Gr, fi), Gr, 1);
        return Mi(1, Ei, ne.aw((xe.pitch - 20) / 20, 0, 1));
      }
      class gh {
      }
      class Qf {
        constructor() {
          this._storage = /* @__PURE__ */ new Map();
        }
        getLinesFromTrianglesBuffer(xe, ke, He) {
          {
            const Gr = this._storage.get(ke.id);
            if (Gr)
              return Gr.lastUsedFrameIdx = xe, Gr.buf;
          }
          const ir = He.gl, ar = ir.getBufferParameter(ir.ELEMENT_ARRAY_BUFFER, ir.BUFFER_SIZE), yr = new ArrayBuffer(ar), Tr = new Int16Array(yr);
          ir.getBufferSubData(ir.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(yr));
          const $r = new ne.dq();
          for (let Gr = 0; Gr < ar / 2; Gr += 3) {
            const qr = Tr[Gr], Jr = Tr[Gr + 1], bi = Tr[Gr + 2];
            $r.emplaceBack(qr, Jr), $r.emplaceBack(Jr, bi), $r.emplaceBack(bi, qr);
          }
          const Dr = He.bindVertexArrayOES.current, Or = new gh();
          return Or.buf = new Sl(He, $r), Or.lastUsedFrameIdx = xe, this._storage.set(ke.id, Or), He.bindVertexArrayOES.set(Dr), Or.buf;
        }
        update(xe) {
          for (const [ke, He] of this._storage)
            xe - He.lastUsedFrameIdx > 30 && (He.buf.destroy(), this._storage.delete(ke));
        }
        destroy() {
          for (const [xe, ke] of this._storage)
            ke.buf.destroy(), this._storage.delete(xe);
        }
      }
      class Wp {
        constructor(xe) {
          this.occluderSize = 30, this.depthOffset = -1e-4, xe.registerParameter(this, ["Occlusion"], "occluderSize", { min: 1, max: 100, step: 1 }), xe.registerParameter(this, ["Occlusion"], "depthOffset", { min: -0.05, max: 0, step: 1e-5 });
        }
      }
      const Ru = ne.da([{ type: "Float32", name: "a_pos_3f", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }, { type: "Float32", name: "a_rainParticleData", components: 4 }]);
      class jl {
        registerParameter() {
        }
        registerButton() {
        }
        registerBinding() {
        }
        refreshUI() {
        }
      }
      class Kd {
        constructor(xe, ke) {
          this.revealStart = 11, this.revealRange = 2, xe.registerParameter(this, [...ke, "Reveal"], "revealStart", { min: 0, max: 17, step: 0.05 }), xe.registerParameter(this, [...ke, "Reveal"], "revealRange", { min: 0.1, max: 5.1, step: 0.05 });
        }
      }
      const id = ne.da([{ type: "Float32", name: "a_pos_2f", components: 2 }]);
      class Yd {
        destroy() {
          this.vignetteVx && this.vignetteVx.destroy(), this.vignetteIdx && this.vignetteIdx.destroy();
        }
        draw(xe, ke) {
          const He = xe.getOrCreateProgram("vignette");
          if (!this.vignetteVx || !this.vignetteIdx) {
            const yr = new ne.dr(), Tr = new ne.aU();
            yr.emplaceBack(-1, -1), yr.emplaceBack(1, -1), yr.emplaceBack(1, 1), yr.emplaceBack(-1, 1), Tr.emplaceBack(0, 1, 2), Tr.emplaceBack(0, 2, 3), this.vignetteVx = xe.context.createVertexBuffer(yr, id.members), this.vignetteIdx = xe.context.createIndexBuffer(Tr);
          }
          const ir = ne.b7.simpleSegment(0, 0, 4, 6);
          if (this.vignetteVx && this.vignetteIdx) {
            xe.uploadCommonUniforms(xe.context, He);
            const yr = { u_vignetteShape: (ar = { vignetteShape: [ke.start, ke.range, Math.pow(10, ke.fadePower)], vignetteColor: [ke.color.r, ke.color.g, ke.color.b, ke.color.a * ke.strength] }).vignetteShape, u_vignetteColor: ar.vignetteColor };
            He.draw(xe, xe.context.gl.TRIANGLES, Oo.disabled, ta.disabled, aa.alphaBlended, Uo.disabled, yr, "vignette", this.vignetteVx, this.vignetteIdx, ir, {});
          }
          var ar;
        }
      }
      class tl {
        constructor() {
          this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
        }
        update(xe, ke) {
          const He = xe.getFreeCameraOptions().position, ir = He.toAltitude(), ar = He.toLngLat(), yr = ne.ai(ar.lng), Tr = ne.ai(ar.lat), $r = xe.pixelsPerMeter / ke, Dr = yr * ne.ds, Or = ne.ds * Math.log(Math.tan(Math.PI / 4 + Tr / 2));
          if (this._offsetXPrev === void 0)
            this._offsetXPrev = 0, this._offsetYPrev = 0, this._elevationPrev = 0, this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
          else {
            const Gr = -this._offsetYPrev + Or, qr = -this._elevationPrev + ir;
            this._accumulatedOffsetX += (-this._offsetXPrev + Dr) * $r, this._accumulatedOffsetY += Gr * $r, this._accumulatedElevation += qr * $r, this._offsetXPrev = Dr, this._offsetYPrev = Or, this._elevationPrev = ir;
          }
        }
        getPosition() {
          return [this._accumulatedOffsetX, this._accumulatedOffsetY, this._accumulatedElevation];
        }
      }
      function Jd(qe, xe) {
        return [-(qe[0] - Math.floor(qe[0] / xe) * xe), -(qe[1] - Math.floor(qe[1] / xe) * xe), -(qe[2] - Math.floor(qe[2] / xe) * xe)];
      }
      function Tl(qe) {
        const xe = ne.di(1323123451230), ke = [];
        for (let He = 0; He < qe; ++He) {
          const ir = 2 * xe() - 1, ar = 2 * xe() - 1, yr = 2 * xe() - 1;
          ke.push(ne.ab.vec3.fromValues(ir, ar, yr));
        }
        return ke;
      }
      function rl(qe, xe, ke, He, ir) {
        const ar = ne.aw((ir - ke) / (He - ke), 0, 1);
        return (1 - ar) * qe + ar * xe;
      }
      class Kc {
        constructor(xe) {
          this._movement = new tl(), this._accumulatedTimeFromStart = 0, this._prevTime = Date.now() / 1e3, this._vignette = new Yd(), this._ppmScaleFactor = xe;
        }
        destroy() {
          this.particlesVx && this.particlesVx.destroy(), this.particlesIdx && this.particlesIdx.destroy(), this._vignette && this._vignette.destroy();
        }
        updateOnRender(xe, ke) {
          const He = xe.transform;
          this._movement.update(He, this._ppmScaleFactor);
          const ir = He.starsProjMatrix, ar = ne.ab.quat.identity([]);
          ne.ab.quat.rotateX(ar, ar, ne.ai(90) - He._pitch), ne.ab.quat.rotateZ(ar, ar, -He.angle);
          const yr = ne.ab.mat4.fromQuat(new Float32Array(16), ar), Tr = ne.ab.mat4.fromValues(1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1), $r = ne.ab.mat4.transpose([], Tr), Dr = ne.ab.mat4.multiply([], $r, yr), Or = Date.now() / 1e3;
          return this._accumulatedTimeFromStart += (Or - this._prevTime) * ke, this._prevTime = Or, { projectionMatrix: ir, modelviewMatrix: Dr };
        }
      }
      class ep extends Kc {
        constructor(xe) {
          super(4.25), this._params = { overrideStyleParameters: !1, intensity: 0.5, timeFactor: 1, velocityConeAperture: 0, velocity: 300, boxSize: 2500, dropletSizeX: 1, dropletSizeYScale: 10, distortionStrength: 70, screenThinning: { intensity: 0.57, start: 0.46, range: 1.17, fadePower: 0.17, affectedRatio: 1, particleOffset: -0.2 }, color: { r: 0.66, g: 0.68, b: 0.74, a: 0.7 }, direction: { x: -50, y: -35 }, shapeDirPower: 2, shapeNormalPower: 1 }, this._revealParams = new Kd(xe.tp, ["Precipitation", "Rain"]), this._vignetteParams = { strength: 1, start: 0.7, range: 1, fadePower: 0.4, color: { r: 0.27, g: 0.27, b: 0.27, a: 1 } }, this.particlesCount = 16e3;
        }
        update(xe) {
          const ke = xe.context;
          if (!this.particlesVx) {
            const He = Tl(this.particlesCount), ir = new ne.dt(), ar = new ne.aU();
            let yr = 0;
            const Tr = ne.di(1323123451230);
            for (let $r = 0; $r < He.length; ++$r) {
              const Dr = He[$r], Or = [2 * Tr() - 1, Tr(), Tr(), Tr()];
              ir.emplaceBack(Dr[0], Dr[1], Dr[2], -1, -1, ...Or), ir.emplaceBack(Dr[0], Dr[1], Dr[2], 1, -1, ...Or), ir.emplaceBack(Dr[0], Dr[1], Dr[2], 1, 1, ...Or), ir.emplaceBack(Dr[0], Dr[1], Dr[2], -1, 1, ...Or), ar.emplaceBack(yr + 0, yr + 1, yr + 2), ar.emplaceBack(yr + 0, yr + 2, yr + 3), yr += 4;
            }
            this.particlesVx = ke.createVertexBuffer(ir, Ru.members), this.particlesIdx = ke.createIndexBuffer(ar);
          }
        }
        draw(xe) {
          if (!this._params.overrideStyleParameters && !xe.style.rain)
            return;
          const ke = this._params.overrideStyleParameters ? this._revealParams : { revealStart: 0, revealRange: 0.01 }, He = xe.transform.zoom;
          if (ke.revealStart > He)
            return;
          const ir = rl(0, 1, ke.revealStart, ke.revealStart + ke.revealRange, He);
          if (!this.particlesVx || !this.particlesIdx)
            return;
          const ar = structuredClone(this._params);
          let yr = [-ar.direction.x, ar.direction.y, -100];
          ne.ab.vec3.normalize(yr, yr);
          const Tr = structuredClone(this._vignetteParams);
          Tr.strength *= ir, ar.overrideStyleParameters || (ar.intensity = xe.style.rain.state.density, ar.timeFactor = xe.style.rain.state.intensity, ar.color = structuredClone(xe.style.rain.state.color), yr = structuredClone(xe.style.rain.state.direction), ar.screenThinning.intensity = xe.style.rain.state.centerThinning, ar.dropletSizeX = xe.style.rain.state.dropletSize[0], ar.dropletSizeYScale = xe.style.rain.state.dropletSize[1] / xe.style.rain.state.dropletSize[0], ar.distortionStrength = 100 * xe.style.rain.state.distortionStrength, Tr.strength = 1, Tr.color = structuredClone(xe.style.rain.state.vignetteColor));
          const $r = this.updateOnRender(xe, ar.timeFactor), Dr = xe.context, Or = Dr.gl, Gr = xe.transform;
          this.screenTexture && this.screenTexture.size[0] === xe.width && this.screenTexture.size[1] === xe.height || (this.screenTexture = new ne.T(Dr, { width: xe.width, height: xe.height, data: null }, Or.RGBA8)), ar.distortionStrength > 0 && (Dr.activeTexture.set(Or.TEXTURE0), this.screenTexture.bind(Or.LINEAR, Or.CLAMP_TO_EDGE), Or.copyTexSubImage2D(Or.TEXTURE_2D, 0, 0, 0, 0, 0, xe.width, xe.height));
          const qr = xe.getOrCreateProgram("rainParticle");
          xe.uploadCommonUniforms(Dr, qr), Dr.activeTexture.set(Or.TEXTURE0), this.screenTexture.bind(Or.LINEAR, Or.CLAMP_TO_EDGE);
          const Jr = [ar.color.r, ar.color.g, ar.color.b, ar.color.a], bi = (fi, Mi) => {
            const Ei = Jd(this._movement.getPosition(), fi), Ii = ar.dropletSizeX, Ni = ar.dropletSizeX * ar.dropletSizeYScale, zi = xe.width / 2, Ki = xe.height / 2, Wi = rl(0, ar.screenThinning.start, 0, 1, ar.screenThinning.intensity), Xi = rl(1e-3, ar.screenThinning.range, 0, 1, ar.screenThinning.intensity), Gi = rl(0, ar.screenThinning.particleOffset, 0, 1, ar.screenThinning.intensity), nn = (dn = { modelview: $r.modelviewMatrix, projection: $r.projectionMatrix, time: this._accumulatedTimeFromStart, camPos: Ei, velocityConeAperture: ar.velocityConeAperture, velocity: ar.velocity, boxSize: fi, rainDropletSize: [Ii, Ni], distortionStrength: ar.distortionStrength, rainDirection: yr, color: Jr, screenSize: [Gr.width, Gr.height], thinningCenterPos: [zi, Ki], thinningShape: [Wi, Xi, Math.pow(10, ar.screenThinning.fadePower)], thinningAffectedRatio: ar.screenThinning.affectedRatio, thinningParticleOffset: Gi, shapeDirectionalPower: ar.shapeDirPower, shapeNormalPower: ar.shapeNormalPower, mode: Mi ? 0 : 1 }, { u_modelview: Float32Array.from(dn.modelview), u_projection: Float32Array.from(dn.projection), u_time: dn.time, u_cam_pos: dn.camPos, u_texScreen: 0, u_velocityConeAperture: dn.velocityConeAperture, u_velocity: dn.velocity, u_boxSize: dn.boxSize, u_rainDropletSize: dn.rainDropletSize, u_distortionStrength: dn.distortionStrength, u_rainDirection: dn.rainDirection, u_color: dn.color, u_screenSize: dn.screenSize, u_thinningCenterPos: dn.thinningCenterPos, u_thinningShape: dn.thinningShape, u_thinningAffectedRatio: dn.thinningAffectedRatio, u_thinningParticleOffset: dn.thinningParticleOffset, u_shapeDirectionalPower: dn.shapeDirectionalPower, u_shapeNormalPower: dn.shapeNormalPower, u_mode: dn.mode });
            var dn;
            const Pn = Math.round(ir * ar.intensity * this.particlesCount), Ln = ne.b7.simpleSegment(0, 0, 4 * Pn, 2 * Pn);
            qr.draw(xe, Or.TRIANGLES, Oo.disabled, ta.disabled, aa.alphaBlended, Uo.disabled, nn, "rain_particles", this.particlesVx, this.particlesIdx, Ln, {});
          };
          ar.distortionStrength > 0 && bi(ar.boxSize, !0), bi(ar.boxSize, !1), this._vignette.draw(xe, Tr);
        }
      }
      const nd = ne.da([{ type: "Float32", name: "a_pos_3f", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }, { type: "Float32", name: "a_snowParticleData", components: 4 }, { type: "Float32", name: "a_snowParticleDataHorizontalOscillation", components: 2 }]);
      class tp extends Kc {
        constructor(xe) {
          super(2.25), this._params = { overrideStyleParameters: !1, intensity: 0.85, timeFactor: 0.75, velocityConeAperture: 70, velocity: 40, horizontalOscillationRadius: 4, horizontalOscillationRate: 1.5, boxSize: 2e3, billboardSize: 2, shapeFadeStart: 0.27, shapeFadePower: 0.21, screenThinning: { intensity: 0.4, start: 0.15, range: 1.4, fadePower: 0.24, affectedRatio: 1, particleOffset: -0.2 }, color: { r: 1, g: 1, b: 1, a: 1 }, direction: { x: -50, y: -35 } }, this._revealParams = new Kd(xe.tp, ["Precipitation", "Snow"]), this._vignetteParams = { strength: 0.3, start: 0.78, range: 0.46, fadePower: 0.2, color: { r: 1, g: 1, b: 1, a: 1 } }, this.particlesCount = 16e3;
        }
        update(xe) {
          const ke = xe.context;
          if (!this.particlesVx) {
            const He = Tl(this.particlesCount), ir = new ne.du(), ar = new ne.aU();
            let yr = 0;
            const Tr = ne.di(1323123451230);
            for (let $r = 0; $r < He.length; ++$r) {
              const Dr = He[$r], Or = Tr(), Gr = Tr(), qr = Tr(), Jr = [$r / He.length, Or, Gr, qr], bi = [Tr(), Tr()];
              ir.emplaceBack(Dr[0], Dr[1], Dr[2], -1, -1, ...Jr, ...bi), ir.emplaceBack(Dr[0], Dr[1], Dr[2], 1, -1, ...Jr, ...bi), ir.emplaceBack(Dr[0], Dr[1], Dr[2], 1, 1, ...Jr, ...bi), ir.emplaceBack(Dr[0], Dr[1], Dr[2], -1, 1, ...Jr, ...bi), ar.emplaceBack(yr + 0, yr + 1, yr + 2), ar.emplaceBack(yr + 0, yr + 2, yr + 3), yr += 4;
            }
            this.particlesVx = ke.createVertexBuffer(ir, nd.members), this.particlesIdx = ke.createIndexBuffer(ar);
          }
        }
        draw(xe) {
          if (!this._params.overrideStyleParameters && !xe.style.snow)
            return;
          const ke = structuredClone(this._params);
          let He = [-ke.direction.x, ke.direction.y, -100];
          ne.ab.vec3.normalize(He, He);
          const ir = structuredClone(this._vignetteParams), ar = ke.overrideStyleParameters ? this._revealParams : { revealStart: 0, revealRange: 0.01 }, yr = xe.transform.zoom;
          if (ar.revealStart > yr)
            return;
          const Tr = rl(0, 1, ar.revealStart, ar.revealStart + ar.revealRange, yr);
          ir.strength *= Tr, ke.overrideStyleParameters || (ke.intensity = xe.style.snow.state.density, ke.timeFactor = xe.style.snow.state.intensity, ke.color = structuredClone(xe.style.snow.state.color), He = structuredClone(xe.style.snow.state.direction), ke.screenThinning.intensity = xe.style.snow.state.centerThinning, ke.billboardSize = 2.79 * xe.style.snow.state.flakeSize, ir.strength = 1, ir.color = structuredClone(xe.style.snow.state.vignetteColor));
          const $r = this.updateOnRender(xe, ke.timeFactor);
          if (!this.particlesVx || !this.particlesIdx)
            return;
          const Dr = xe.context, Or = Dr.gl, Gr = xe.transform, qr = xe.getOrCreateProgram("snowParticle");
          xe.uploadCommonUniforms(Dr, qr), ((Jr, bi, fi) => {
            const Mi = Jd(this._movement.getPosition(), Jr), Ei = Gr.width / 2, Ii = Gr.height / 2, Ni = rl(0, fi.screenThinning.start, 0, 1, fi.screenThinning.intensity), zi = rl(1e-3, fi.screenThinning.range, 0, 1, fi.screenThinning.intensity), Ki = rl(0, fi.screenThinning.particleOffset, 0, 1, fi.screenThinning.intensity), Wi = (Xi = { modelview: $r.modelviewMatrix, projection: $r.projectionMatrix, time: this._accumulatedTimeFromStart, camPos: Mi, velocityConeAperture: fi.velocityConeAperture, velocity: fi.velocity, horizontalOscillationRadius: fi.horizontalOscillationRadius, horizontalOscillationRate: fi.horizontalOscillationRate, boxSize: Jr, billboardSize: 1 * fi.billboardSize, simpleShapeParameters: [fi.shapeFadeStart, fi.shapeFadePower], screenSize: [Gr.width, Gr.height], thinningCenterPos: [Ei, Ii], thinningShape: [Ni, zi, Math.pow(10, fi.screenThinning.fadePower)], thinningAffectedRatio: fi.screenThinning.affectedRatio, thinningParticleOffset: Ki, color: [fi.color.r, fi.color.g, fi.color.b, fi.color.a], direction: He }, { u_modelview: Float32Array.from(Xi.modelview), u_projection: Float32Array.from(Xi.projection), u_time: Xi.time, u_cam_pos: Xi.camPos, u_velocityConeAperture: Xi.velocityConeAperture, u_velocity: Xi.velocity, u_horizontalOscillationRadius: Xi.horizontalOscillationRadius, u_horizontalOscillationRate: Xi.horizontalOscillationRate, u_boxSize: Xi.boxSize, u_billboardSize: Xi.billboardSize, u_simpleShapeParameters: Xi.simpleShapeParameters, u_screenSize: Xi.screenSize, u_thinningCenterPos: Xi.thinningCenterPos, u_thinningShape: Xi.thinningShape, u_thinningAffectedRatio: Xi.thinningAffectedRatio, u_thinningParticleOffset: Xi.thinningParticleOffset, u_particleColor: Xi.color, u_direction: Xi.direction });
            var Xi;
            const Gi = Math.round(Tr * fi.intensity * this.particlesCount), nn = ne.b7.simpleSegment(0, 0, 4 * Gi, 2 * Gi);
            this.particlesVx && this.particlesIdx && qr.draw(xe, Or.TRIANGLES, Oo.disabled, ta.disabled, aa.alphaBlended, Uo.disabled, Wi, "snow_particles", this.particlesVx, this.particlesIdx, nn, {});
          })(ke.boxSize, 0, ke), this._vignette.draw(xe, ir);
        }
      }
      const Lc = { symbol: function(qe, xe, ke, He, ir) {
        if (qe.renderPass !== "translucent")
          return;
        const ar = ta.disabled, yr = qe.colorModeForRenderPass(), Tr = ke.layout.get("text-variable-anchor"), $r = ke.layout.get("text-size-scale-range"), Dr = ne.aw(qe.scaleFactor, $r[0], $r[1]);
        Tr && function(qr, Jr, bi, fi, Mi, Ei, Ii, Ni) {
          const zi = Jr.transform, Ki = Mi === "map", Wi = Ei === "map";
          for (const Xi of qr) {
            const Gi = fi.getTile(Xi), nn = Gi.getBucket(bi);
            if (!nn || !nn.text || !nn.text.segments.get().length)
              continue;
            const dn = ne.bp(nn.textSizeData, zi.zoom, Ni), Pn = $h(Xi, nn.getProjection(), zi), Ln = zi.calculatePixelsToTileUnitsMatrix(Gi), hn = es(Pn, Gi.tileID.canonical, Wi, Ki, zi, nn.getProjection(), Ln), xn = nn.hasIconTextFit() && nn.hasIconData();
            if (dn) {
              const Hn = Math.pow(2, zi.zoom - Gi.tileID.overscaledZ);
              Hm(nn, Ki, Wi, Ii, ne.cX, zi, hn, Xi, Hn, dn, xn);
            }
          }
        }(He, qe, ke, xe, ke.layout.get("text-rotation-alignment"), ke.layout.get("text-pitch-alignment"), ir, Dr);
        const Or = ke.paint.get("icon-opacity").constantOr(1) !== 0, Gr = ke.paint.get("text-opacity").constantOr(1) !== 0;
        ke.layout.get("symbol-sort-key").constantOr(1) !== void 0 && (Or || Gr) ? Il(qe, xe, ke, He, ar, yr) : (Or && Il(qe, xe, ke, He, ar, yr, { onlyIcons: !0 }), Gr && Il(qe, xe, ke, He, ar, yr, { onlyText: !0 })), xe.map.showCollisionBoxes && (Wc(qe, xe, ke, He, ke.paint.get("text-translate"), ke.paint.get("text-translate-anchor"), !0), Wc(qe, xe, ke, He, ke.paint.get("icon-translate"), ke.paint.get("icon-translate-anchor"), !1));
      }, circle: function(qe, xe, ke, He) {
        if (qe.renderPass !== "translucent")
          return;
        const ir = ke.paint.get("circle-opacity"), ar = ke.paint.get("circle-stroke-width"), yr = ke.paint.get("circle-stroke-opacity"), Tr = ke.layout.get("circle-sort-key").constantOr(1) !== void 0, $r = ke.paint.get("circle-emissive-strength");
        if (ir.constantOr(1) === 0 && (ar.constantOr(1) === 0 || yr.constantOr(1) === 0))
          return;
        const Dr = qe.context, Or = Dr.gl, Gr = qe.transform, qr = qe.depthModeForSublayer(0, Oo.ReadOnly), Jr = ta.disabled, bi = qe.colorModeForDrapableLayerRenderPass($r), fi = Gr.projection.name === "globe", Mi = [ne.at(Gr.center.lng), ne.aA(Gr.center.lat)], Ei = [];
        for (let Ni = 0; Ni < He.length; Ni++) {
          const zi = He[Ni], Ki = xe.getTile(zi), Wi = Ki.getBucket(ke);
          if (!Wi || Wi.projection.name !== Gr.projection.name)
            continue;
          const Xi = Wi.programConfigurations.get(ke.id), Gi = ne.cY(ke), nn = qe.isTileAffectedByFog(zi);
          fi && Gi.push("PROJECTION_GLOBE_VIEW"), Gi.push("DEPTH_D24"), qe.terrain && Gr.depthOcclusionForSymbolsAndCircles && Gi.push("DEPTH_OCCLUSION");
          const dn = qe.getOrCreateProgram("circle", { config: Xi, defines: Gi, overrideFog: nn }), Pn = Wi.layoutVertexBuffer, Ln = Wi.globeExtVertexBuffer, hn = Wi.indexBuffer, xn = Gr.projection.createInversionMatrix(Gr, zi.canonical), Hn = { programConfiguration: Xi, program: dn, layoutVertexBuffer: Pn, globeExtVertexBuffer: Ln, indexBuffer: hn, uniformValues: ne.cZ(qe, zi, Ki, xn, Mi, ke), tile: Ki };
          if (Tr) {
            const io = Wi.segments.get();
            for (const uo of io)
              Ei.push({ segments: new ne.b7([uo]), sortKey: uo.sortKey, state: Hn });
          } else
            Ei.push({ segments: Wi.segments, sortKey: 0, state: Hn });
        }
        Tr && Ei.sort((Ni, zi) => Ni.sortKey - zi.sortKey);
        const Ii = { useDepthForOcclusion: Gr.depthOcclusionForSymbolsAndCircles };
        for (const Ni of Ei) {
          const { programConfiguration: zi, program: Ki, layoutVertexBuffer: Wi, globeExtVertexBuffer: Xi, indexBuffer: Gi, uniformValues: nn, tile: dn } = Ni.state, Pn = Ni.segments;
          qe.terrain && qe.terrain.setupElevationDraw(dn, Ki, Ii), qe.uploadCommonUniforms(Dr, Ki, dn.tileID.toUnwrapped()), Ki.draw(qe, Or.TRIANGLES, qr, Jr, bi, Uo.disabled, nn, ke.id, Wi, Gi, Pn, ke.paint, Gr.zoom, zi, [Xi]);
        }
      }, heatmap: function(qe, xe, ke, He) {
        if (ke.paint.get("heatmap-opacity") !== 0)
          if (qe.renderPass === "offscreen") {
            const ir = qe.context, ar = ir.gl, yr = ta.disabled, Tr = new aa([ar.ONE, ar.ONE, ar.ONE, ar.ONE], ne.aj.transparent, [!0, !0, !0, !0]);
            (function(Jr, bi, fi, Mi) {
              const Ei = Jr.gl, Ii = bi.width * Mi, Ni = bi.height * Mi;
              Jr.activeTexture.set(Ei.TEXTURE1), Jr.viewport.set([0, 0, Ii, Ni]);
              let zi = fi.heatmapFbo;
              if (!zi || zi && (zi.width !== Ii || zi.height !== Ni)) {
                zi && zi.destroy();
                const Ki = Ei.createTexture();
                Ei.bindTexture(Ei.TEXTURE_2D, Ki), Ei.texParameteri(Ei.TEXTURE_2D, Ei.TEXTURE_WRAP_S, Ei.CLAMP_TO_EDGE), Ei.texParameteri(Ei.TEXTURE_2D, Ei.TEXTURE_WRAP_T, Ei.CLAMP_TO_EDGE), Ei.texParameteri(Ei.TEXTURE_2D, Ei.TEXTURE_MIN_FILTER, Ei.LINEAR), Ei.texParameteri(Ei.TEXTURE_2D, Ei.TEXTURE_MAG_FILTER, Ei.LINEAR), zi = fi.heatmapFbo = Jr.createFramebuffer(Ii, Ni, !0, null), function(Wi, Xi, Gi, nn, dn, Pn) {
                  const Ln = Wi.gl;
                  Ln.texImage2D(Ln.TEXTURE_2D, 0, Wi.extRenderToTextureHalfFloat ? Ln.RGBA16F : Ln.RGBA, dn, Pn, 0, Ln.RGBA, Wi.extRenderToTextureHalfFloat ? Ln.HALF_FLOAT : Ln.UNSIGNED_BYTE, null), nn.colorAttachment.set(Gi);
                }(Jr, 0, Ki, zi, Ii, Ni);
              } else
                Ei.bindTexture(Ei.TEXTURE_2D, zi.colorAttachment.get()), Jr.bindFramebuffer.set(zi.framebuffer);
            })(ir, qe, ke, qe.transform.projection.name === "globe" ? 0.5 : 0.25), ir.clear({ color: ne.aj.transparent });
            const $r = qe.transform, Dr = $r.projection.name === "globe", Or = Dr ? ["PROJECTION_GLOBE_VIEW"] : [], Gr = Dr ? Uo.frontCCW : Uo.disabled, qr = [ne.at($r.center.lng), ne.aA($r.center.lat)];
            for (let Jr = 0; Jr < He.length; Jr++) {
              const bi = He[Jr];
              if (xe.hasRenderableParent(bi))
                continue;
              const fi = xe.getTile(bi), Mi = fi.getBucket(ke);
              if (!Mi || Mi.projection.name !== $r.projection.name)
                continue;
              const Ei = qe.isTileAffectedByFog(bi), Ii = Mi.programConfigurations.get(ke.id), Ni = qe.getOrCreateProgram("heatmap", { config: Ii, defines: Or, overrideFog: Ei }), { zoom: zi } = qe.transform;
              qe.terrain && qe.terrain.setupElevationDraw(fi, Ni), qe.uploadCommonUniforms(ir, Ni, bi.toUnwrapped());
              const Ki = $r.projection.createInversionMatrix($r, bi.canonical);
              Ni.draw(qe, ar.TRIANGLES, Oo.disabled, yr, Tr, Gr, H0(qe, bi, fi, Ki, qr, zi, ke.paint.get("heatmap-intensity")), ke.id, Mi.layoutVertexBuffer, Mi.indexBuffer, Mi.segments, ke.paint, qe.transform.zoom, Ii, Dr ? [Mi.globeExtVertexBuffer] : null);
            }
            ir.viewport.set([0, 0, qe.width, qe.height]);
          } else
            qe.renderPass === "translucent" && (qe.context.setColorMode(qe.colorModeForRenderPass()), function(ir, ar) {
              const yr = ir.context, Tr = yr.gl, $r = ar.heatmapFbo;
              if (!$r)
                return;
              yr.activeTexture.set(Tr.TEXTURE0), Tr.bindTexture(Tr.TEXTURE_2D, $r.colorAttachment.get()), yr.activeTexture.set(Tr.TEXTURE1);
              let Dr = ar.colorRampTexture;
              Dr || (Dr = ar.colorRampTexture = new ne.T(yr, ar.colorRamp, Tr.RGBA8)), Dr.bind(Tr.LINEAR, Tr.CLAMP_TO_EDGE), ir.getOrCreateProgram("heatmapTexture").draw(ir, Tr.TRIANGLES, Oo.disabled, ta.disabled, ir.colorModeForRenderPass(), Uo.disabled, ((Or, Gr, qr, Jr) => ({ u_image: 0, u_color_ramp: 1, u_opacity: Gr.paint.get("heatmap-opacity") }))(0, ar), ar.id, ir.viewportBuffer, ir.quadTriangleIndexBuffer, ir.viewportSegments, ar.paint, ir.transform.zoom);
            }(qe, ke));
      }, line: function(qe, xe, ke, He) {
        if (qe.renderPass !== "translucent")
          return;
        const ir = ke.paint.get("line-opacity"), ar = ke.paint.get("line-width");
        if (ir.constantOr(1) === 0 || ar.constantOr(1) === 0)
          return;
        const yr = ke.paint.get("line-emissive-strength"), Tr = ke.paint.get("line-occlusion-opacity"), $r = ke.layout.get("line-elevation-reference"), Dr = ke.layout.get("line-width-unit") === "meters", Or = $r === "sea", Gr = qe.context, qr = Gr.gl, Jr = !ke.isDraped();
        if (Jr && qe.transform.projection.name === "globe")
          return;
        const bi = ke.layout.get("line-cross-slope"), fi = bi !== void 0, Mi = bi < 1, Ei = Jr ? new Oo(qe.depthOcclusion ? qr.GREATER : qr.LEQUAL, Oo.ReadOnly, qe.depthRangeFor3D) : qe.depthModeForSublayer(0, Oo.ReadOnly), Ii = qe.colorModeForDrapableLayerRenderPass(yr), Ni = qe.terrain && qe.terrain.renderingToTexture, zi = Ni ? 1 : ne.q.devicePixelRatio, Ki = ke.paint.get("line-dasharray"), Wi = Ki.constantOr(1), Xi = ke.layout.get("line-cap"), Gi = Ki.constantOr(null), nn = Xi.constantOr(null), dn = ke.paint.get("line-pattern"), Pn = dn.constantOr(1), Ln = dn.constantOr(null), hn = ke.paint.get("line-opacity").constantOr(1);
        let xn = !Pn && hn !== 1 || qe.depthOcclusion && Tr > 0 && Tr < 1;
        const Hn = ke.paint.get("line-gradient"), io = Pn ? "linePattern" : "line", uo = ne.c_(ke);
        let An;
        if (Ni && qe.terrain && qe.terrain.clipOrMaskOverlapStencilType() && (xn = !1), Tr !== 0 && qe.depthOcclusion) {
          const On = ke.paint._values["line-opacity"];
          On && On.value && On.value.kind === "constant" ? An = On.value : ne.w(`Occlusion opacity for layer ${ke.id} is supported only when line-opacity isn't data-driven.`);
        }
        if (Jr && (qe.forceTerrainMode = !0), !Jr && Tr !== 0 && qe.terrain && !Ni)
          return void ne.w(`Occlusion opacity for layer ${ke.id} is supported on terrain only if the layer has line-z-offset enabled.`);
        const eo = xn && Jr ? qe.stencilModeFor3D() : ta.disabled;
        Jr && (uo.push("ELEVATED"), fi && uo.push(Mi ? "CROSS_SLOPE_HORIZONTAL" : "CROSS_SLOPE_VERTICAL"), Or && uo.push("ELEVATION_REFERENCE_SEA")), ar.value.kind !== "constant" && ar.value.isLineProgressConstant === !1 && uo.push("VARIABLE_LINE_WIDTH");
        for (const On of He) {
          const ao = xe.getTile(On);
          if (Pn && !ao.patternsLoaded())
            continue;
          const ro = ao.getBucket(ke);
          if (!ro)
            continue;
          qe.prepareDrawTile();
          const Wn = ro.programConfigurations.get(ke.id), _o = qe.isTileAffectedByFog(On), yo = qe.getOrCreateProgram(io, { config: Wn, defines: uo, overrideFog: _o, overrideRtt: !Jr && void 0 });
          if (Ln && ao.imageAtlas) {
            const sa = ne.A.from(Ln), ss = ao.imageAtlas.patternPositions[sa.getSerializedPrimary()];
            ss && Wn.setConstantPatternPositions(ss);
          }
          if (!Pn && Gi && nn && ao.lineAtlas) {
            const sa = ao.lineAtlas.getDash(Gi, nn);
            sa && Wn.setConstantPatternPositions(sa);
          }
          let [mo, Eo] = ke.paint.get("line-trim-offset");
          (nn === "round" || nn === "square") && mo !== Eo && (mo === 0 && (mo -= 1), Eo === 1 && (Eo += 1));
          const Ko = Ni ? On.projMatrix : null, Fo = Dr ? 1 / ro.tileToMeter / ne.ar(ao, 1, qe.transform.zoom) : 1, zo = Dr ? 1 / ro.tileToMeter / ne.ar(ao, 1, Math.floor(qe.transform.zoom)) : 1, Jo = Pn ? ne.c$(qe, ao, ke, Ko, zi, Fo, zo, [mo, Eo]) : ne.d0(qe, ao, ke, Ko, ro.lineClipsArray.length, zi, Fo, zo, [mo, Eo]);
          if (Hn) {
            const sa = ro.gradients[ke.id];
            let ss = sa.texture;
            if (ke.gradientVersion !== sa.version) {
              let Ya = 256;
              if (ke.stepInterpolant) {
                const Oa = xe.getSource().maxzoom, Na = On.canonical.z === Oa ? Math.ceil(1 << qe.transform.maxZoom - On.canonical.z) : 1;
                Ya = ne.aw(ne.d1(ro.maxLineLength / ne.ag * 1024 * Na), 256, Gr.maxTextureSize);
              }
              sa.gradient = ne.d2({ expression: ke.gradientExpression(), evaluationKey: "lineProgress", resolution: Ya, image: sa.gradient || void 0, clips: ro.lineClipsArray }), sa.texture ? sa.texture.update(sa.gradient) : sa.texture = new ne.T(Gr, sa.gradient, qr.RGBA8), sa.version = ke.gradientVersion, ss = sa.texture;
            }
            Gr.activeTexture.set(qr.TEXTURE1), ss.bind(ke.stepInterpolant ? qr.NEAREST : qr.LINEAR, qr.CLAMP_TO_EDGE);
          }
          Wi && (Gr.activeTexture.set(qr.TEXTURE0), ao.lineAtlasTexture && ao.lineAtlasTexture.bind(qr.LINEAR, qr.REPEAT), Wn.updatePaintBuffers()), Pn && (Gr.activeTexture.set(qr.TEXTURE0), ao.imageAtlasTexture && ao.imageAtlasTexture.bind(qr.LINEAR, qr.CLAMP_TO_EDGE), Wn.updatePaintBuffers()), Jr && !Or && qe.terrain.setupElevationDraw(ao, yo), qe.uploadCommonUniforms(Gr, yo, On.toUnwrapped());
          const ia = (sa) => {
            An != null && (An.value = hn * Tr), yo.draw(qe, qr.TRIANGLES, Ei, sa, Ii, Uo.disabled, Jo, ke.id, ro.layoutVertexBuffer, ro.indexBuffer, ro.segments, ke.paint, qe.transform.zoom, Wn, [ro.layoutVertexBuffer2, ro.patternVertexBuffer, ro.zOffsetVertexBuffer]), An != null && (An.value = hn);
          };
          if (xn && !Jr) {
            const sa = qe.stencilModeForClipping(On).ref;
            sa === 0 && Ni && Gr.clear({ stencil: 0 });
            const ss = { func: qr.EQUAL, mask: 255 };
            Jo.u_alpha_discard_threshold = 0.8, ia(new ta(ss, sa, 255, qr.KEEP, qr.KEEP, qr.INVERT)), Jo.u_alpha_discard_threshold = 0, ia(new ta(ss, sa, 255, qr.KEEP, qr.KEEP, qr.KEEP));
          } else
            xn && Jr && (Jo.u_alpha_discard_threshold = 1e-3), ia(Jr ? eo : qe.stencilModeForClipping(On));
        }
        Jr && (qe.forceTerrainMode = !1), xn && (qe.resetStencilClippingMasks(), Ni && Gr.clear({ stencil: 0 })), Tr === 0 || qe.depthOcclusion || Ni || qe.layersWithOcclusionOpacity.push(qe.currentLayer);
      }, fill: function(qe, xe, ke, He) {
        const ir = ke.paint.get("fill-color"), ar = ke.paint.get("fill-opacity"), yr = ke.is3D(), Tr = new Oo(qe.context.gl.LEQUAL, Oo.ReadWrite, qe.depthRangeFor3D);
        if (ar.constantOr(1) === 0)
          return;
        const $r = ke.paint.get("fill-emissive-strength"), Dr = qe.colorModeForDrapableLayerRenderPass($r), Or = ke.paint.get("fill-pattern"), Gr = qe.opaquePassEnabledForLayer() && !Or.constantOr(1) && ir.constantOr(ne.aj.transparent).a === 1 && ar.constantOr(0) === 1 ? "opaque" : "translucent";
        if (qe.renderPass === Gr) {
          const qr = yr ? Tr : qe.depthModeForSublayer(1, qe.renderPass === "opaque" ? Oo.ReadWrite : Oo.ReadOnly);
          hh(qe, xe, ke, He, qr, Dr, !1);
        }
        if (!yr && qe.renderPass === "translucent" && ke.paint.get("fill-antialias")) {
          const qr = yr ? Tr : qe.depthModeForSublayer(ke.getPaintProperty("fill-outline-color") ? 2 : 0, Oo.ReadOnly);
          hh(qe, xe, ke, He, qr, Dr, !0);
        }
      }, "fill-extrusion": function(qe, xe, ke, He) {
        const ir = ke.paint.get("fill-extrusion-opacity"), ar = qe.context, yr = ar.gl, Tr = qe.terrain, $r = Tr && Tr.renderingToTexture;
        if (ir === 0)
          return;
        const Dr = qe.conflationActive && qe.style.isLayerClipped(ke, xe.getSource()), Or = qe.style.order.indexOf(ke.fqid);
        if (Dr && function(Gr, qr, Jr, bi, fi) {
          for (const Mi of bi) {
            const Ei = qr.getTile(Mi).getBucket(Jr);
            Ei && (Ei.updateReplacement(Mi, Gr.replacementSource, fi), Ei.uploadCentroid(Gr.context));
          }
        }(qe, xe, ke, He, Or), Tr || Dr)
          for (const Gr of He) {
            const qr = xe.getTile(Gr).getBucket(ke);
            qr && Wf(qe.context, xe, Gr, qr, ke, Tr, Dr);
          }
        if (qe.renderPass === "shadow" && qe.shadowRenderer) {
          const Gr = qe.shadowRenderer;
          if (Tr && ir < 0.65 && ke._transitionablePaint._values["fill-extrusion-opacity"].value.expression instanceof ne.a9)
            return;
          const qr = Gr.getShadowPassDepthMode(), Jr = Gr.getShadowPassColorMode();
          fh(qe, xe, ke, He, qr, ta.disabled, Jr, Dr);
        } else if (qe.renderPass === "translucent") {
          const Gr = !ke.paint.get("fill-extrusion-pattern").constantOr(1), qr = ke.paint.get("fill-extrusion-color").constantOr(ne.aj.white);
          if (!$r && qr.a !== 0) {
            const Jr = new Oo(qe.context.gl.LEQUAL, Oo.ReadWrite, qe.depthRangeFor3D);
            ir === 1 && Gr ? fh(qe, xe, ke, He, Jr, ta.disabled, aa.unblended, Dr) : (fh(qe, xe, ke, He, Jr, ta.disabled, aa.disabled, Dr), fh(qe, xe, ke, He, Jr, qe.stencilModeFor3D(), qe.colorModeForRenderPass(), Dr), qe.resetStencilClippingMasks());
          }
          if (qe.style.enable3dLights() && Gr && (!Tr && qe.transform.projection.name !== "globe" || $r)) {
            const Jr = ke.paint.get("fill-extrusion-opacity"), bi = ke.paint.get("fill-extrusion-ambient-occlusion-intensity"), fi = ke.paint.get("fill-extrusion-ambient-occlusion-ground-radius"), Mi = ke.paint.get("fill-extrusion-flood-light-intensity"), Ei = ke.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default") === "none", Ii = ke.paint.get("fill-extrusion-flood-light-color").toRenderColor(Ei ? null : ke.lut).toArray01().slice(0, 3), Ni = bi > 0 && fi > 0, zi = Mi > 0, Ki = (Xi, Gi, nn) => (1 - nn) * Xi + nn * Gi, Wi = (Xi) => {
              const Gi = qe.depthModeForSublayer(1, Oo.ReadOnly, yr.LEQUAL, !0), nn = ke.paint.get(Xi ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), dn = Ki(0.1, 3, nn), Pn = qe._showOverdrawInspector;
              if (!Pn) {
                const Ln = new ta({ func: yr.ALWAYS, mask: 255 }, 255, 255, yr.KEEP, yr.KEEP, yr.REPLACE), hn = new aa([yr.ONE, yr.ONE, yr.ONE, yr.ONE], ne.aj.transparent, [!1, !1, !1, !0], yr.MIN);
                El(qe, xe, ke, He, Gi, Ln, hn, Uo.disabled, Xi, "sdf", Jr, bi, fi, Mi, Ii, dn, Dr, !1);
              }
              {
                const Ln = Pn ? ta.disabled : new ta({ func: yr.EQUAL, mask: 255 }, 255, 255, yr.KEEP, yr.DECR, yr.DECR), hn = Pn ? qe.colorModeForRenderPass() : new aa([yr.ONE_MINUS_DST_ALPHA, yr.DST_ALPHA, yr.ONE, yr.ONE], ne.aj.transparent, [!0, !0, !0, !0]);
                El(qe, xe, ke, He, Gi, Ln, hn, Uo.disabled, Xi, "color", Jr, bi, fi, Mi, Ii, dn, Dr, !1);
              }
            };
            if ($r) {
              const Xi = (Gi, nn, dn) => {
                const Pn = qe.depthModeForSublayer(1, Oo.ReadOnly, yr.LEQUAL, !1), Ln = ke.paint.get(Gi ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), hn = Ki(0.1, 3, Ln);
                {
                  const xn = new aa([yr.ONE, yr.ONE, yr.ONE, yr.ONE], ne.aj.transparent, [!1, !1, !1, !0]);
                  El(qe, xe, ke, He, Pn, ta.disabled, xn, Uo.disabled, Gi, "clear", Jr, bi, fi, Mi, Ii, hn, Dr, nn);
                }
                {
                  const xn = new ta({ func: yr.ALWAYS, mask: 255 }, 255, 255, yr.KEEP, yr.KEEP, yr.REPLACE), Hn = new aa([yr.ONE, yr.ONE, yr.ONE, yr.ONE], ne.aj.transparent, [!1, !1, !1, !0], yr.MIN);
                  El(qe, xe, ke, He, Pn, xn, Hn, Uo.disabled, Gi, "sdf", Jr, bi, fi, Mi, Ii, hn, Dr, nn);
                }
                {
                  const xn = Gi ? yr.ZERO : yr.ONE_MINUS_DST_ALPHA, Hn = new ta({ func: yr.EQUAL, mask: 255 }, 255, 255, yr.KEEP, yr.DECR, yr.DECR), io = new aa([xn, yr.DST_ALPHA, yr.ONE_MINUS_DST_ALPHA, yr.ZERO], ne.aj.transparent, [!0, !0, !0, !0]);
                  El(qe, xe, ke, He, Pn, Hn, io, Uo.disabled, Gi, "color", Jr, bi, fi, Mi, Ii, hn, Dr, nn);
                }
                {
                  const xn = new aa([yr.ONE, yr.ONE, yr.ONE, Gi ? yr.ZERO : yr.ONE], ne.aj.transparent, [!1, !1, !1, !0], Gi ? yr.FUNC_ADD : yr.MAX);
                  El(qe, xe, ke, He, Pn, ta.disabled, xn, Uo.disabled, Gi, "clear", Jr, bi, fi, Mi, Ii, hn, Dr, nn, dn);
                }
              };
              if (Ni || zi) {
                let Gi;
                if (qe.prepareDrawTile(), Tr) {
                  const nn = Tr.drapeBufferSize[0], dn = Tr.drapeBufferSize[1];
                  Gi = Tr.framebufferCopyTexture, Gi && (!Gi || Gi.size[0] === nn && Gi.size[1] === dn) || (Gi && Gi.destroy(), Gi = Tr.framebufferCopyTexture = new ne.T(ar, new ne.r({ width: nn, height: dn }), yr.RGBA8)), Gi.bind(yr.LINEAR, yr.CLAMP_TO_EDGE), yr.copyTexSubImage2D(yr.TEXTURE_2D, 0, 0, 0, 0, 0, nn, dn);
                }
                Ni && Xi(!0, !1, Gi), zi && Xi(!1, !0, Gi);
              }
            } else
              Ni && Wi(!0), zi && Wi(!1), (Ni || zi) && qe.resetStencilClippingMasks();
          }
        }
      }, hillshade: function(qe, xe, ke, He) {
        if (qe.renderPass !== "offscreen" && qe.renderPass !== "translucent" || qe.style.disableElevatedTerrain)
          return;
        const ir = qe.context, ar = qe.terrain && qe.terrain.renderingToTexture, [yr, Tr] = qe.renderPass !== "translucent" || ar ? [{}, He] : qe.stencilConfigForOverlap(He);
        for (const $r of Tr) {
          const Dr = xe.getTile($r);
          if (Dr.needsHillshadePrepare && qe.renderPass === "offscreen")
            Qu(qe, Dr, ke);
          else if (qe.renderPass === "translucent") {
            const Or = qe.depthModeForSublayer(0, Oo.ReadOnly), Gr = ke.paint.get("hillshade-emissive-strength"), qr = qe.colorModeForDrapableLayerRenderPass(Gr), Jr = ar && qe.terrain ? qe.terrain.stencilModeForRTTOverlap($r) : yr[$r.overscaledZ];
            Ld(qe, $r, Dr, ke, Or, Jr, qr);
          }
        }
        ir.viewport.set([0, 0, qe.width, qe.height]), qe.resetStencilClippingMasks();
      }, raster: function(qe, xe, ke, He, ir, ar) {
        if (qe.renderPass !== "translucent" || ke.paint.get("raster-opacity") === 0)
          return;
        const yr = qe.transform.projection.name === "globe", Tr = ke.paint.get("raster-elevation") !== 0, $r = Tr && yr;
        if (qe.renderElevatedRasterBackface && !$r)
          return;
        const Dr = qe.context, Or = Dr.gl, Gr = xe.getSource(), qr = function(Wi, Xi, Gi, nn) {
          const dn = Xi.paint.get("raster-color"), Pn = Wi.type === "raster-array", Ln = [], hn = Xi.paint.get("raster-resampling"), xn = Xi.paint.get("raster-color-mix");
          let Hn = Xi.paint.get("raster-color-range");
          const io = [xn[0], xn[1], xn[2], 0], uo = xn[3];
          let An = hn === "nearest" ? nn.NEAREST : nn.LINEAR;
          if (Pn && (Ln.push("RASTER_ARRAY"), dn || Ln.push("RASTER_COLOR"), hn === "linear" && Ln.push("RASTER_ARRAY_LINEAR"), An = nn.NEAREST, !Hn && Wi.rasterLayers)) {
            const eo = Wi.rasterLayers.find(({ id: On }) => On === Xi.sourceLayer);
            eo && eo.fields && eo.fields.range && (Hn = eo.fields.range);
          }
          if (Hn = Hn || [0, 1], dn) {
            Ln.push("RASTER_COLOR"), Gi.activeTexture.set(nn.TEXTURE2), Xi.updateColorRamp(Hn);
            let eo = Xi.colorRampTexture;
            eo || (eo = Xi.colorRampTexture = new ne.T(Gi, Xi.colorRamp, nn.RGBA8)), eo.bind(nn.LINEAR, nn.CLAMP_TO_EDGE);
          }
          return { mix: io, range: Hn, offset: uo, defines: Ln, resampling: An };
        }(Gr, ke, Dr, Or);
        if (Gr instanceof ne.aJ && !He.length && !yr)
          return;
        const Jr = ke.paint.get("raster-emissive-strength"), bi = qe.colorModeForDrapableLayerRenderPass(Jr), fi = qe.terrain && qe.terrain.renderingToTexture, Mi = !qe.options.moving, Ei = ke.paint.get("raster-resampling") === "nearest" ? Or.NEAREST : Or.LINEAR;
        if (Gr instanceof ne.aJ && !He.length && (Gr.onNorthPole || Gr.onSouthPole)) {
          const Wi = Tr ? qe.stencilModeFor3D() : ta.disabled;
          return void Mo(!!Gr.onNorthPole, null, qe, xe, ke, Jr, qr, Uo.disabled, Wi);
        }
        if (!He.length)
          return;
        const [Ii, Ni] = Gr instanceof ne.aJ || fi ? [{}, He] : qe.stencilConfigForOverlap(He), zi = Ni[Ni.length - 1].overscaledZ;
        $r && qr.defines.push("PROJECTION_GLOBE_VIEW"), Tr && qr.defines.push("RENDER_CUTOFF");
        const Ki = (Wi, Xi, Gi) => {
          for (const nn of Wi) {
            const dn = nn.toUnwrapped(), Pn = xe.getTile(nn);
            if (fi && (!Pn || !Pn.hasData()))
              continue;
            Dr.activeTexture.set(Or.TEXTURE0);
            const Ln = ys(Pn, Gr, ke, qr);
            if (!Ln || !Ln.texture)
              continue;
            const { texture: hn, mix: xn, offset: Hn, tileSize: io, buffer: uo } = Ln;
            let An, eo;
            fi ? (An = Oo.disabled, eo = nn.projMatrix) : Tr ? (An = new Oo(Or.LEQUAL, Oo.ReadWrite, qe.depthRangeFor3D), eo = yr ? Float32Array.from(qe.transform.expandedFarZProjMatrix) : qe.transform.calculateProjMatrix(dn, Mi)) : (An = qe.depthModeForSublayer(nn.overscaledZ - zi, ke.paint.get("raster-opacity") === 1 ? Oo.ReadWrite : Oo.ReadOnly, Or.LESS), eo = qe.transform.calculateProjMatrix(dn, Mi));
            const On = qe.terrain && fi ? qe.terrain.stencilModeForRTTOverlap(nn) : Ii[nn.overscaledZ], ao = ar ? 0 : ke.paint.get("raster-fade-duration");
            Pn.registerFadeDuration(ao);
            const ro = xe.findLoadedParent(nn, 0), Wn = pc(Pn, ro, xe, qe.transform, ao);
            let _o, yo;
            qe.terrain && qe.terrain.prepareDrawTile(), Dr.activeTexture.set(Or.TEXTURE0), hn.bind(Ei, Or.CLAMP_TO_EDGE), Dr.activeTexture.set(Or.TEXTURE1), ro ? (ro.texture && ro.texture.bind(Ei, Or.CLAMP_TO_EDGE), _o = Math.pow(2, ro.tileID.overscaledZ - Pn.tileID.overscaledZ), yo = [Pn.tileID.canonical.x * _o % 1, Pn.tileID.canonical.y * _o % 1]) : hn.bind(Ei, Or.CLAMP_TO_EDGE), hn.useMipmap && Dr.extTextureFilterAnisotropic && qe.transform.pitch > 20 && Or.texParameterf(Or.TEXTURE_2D, Dr.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, Dr.extTextureFilterAnisotropicMax);
            const mo = qe.transform;
            let Eo;
            const Ko = Tr ? Jh(mo) : [0, 0, 0, 0];
            let Fo, zo, Jo, ia, sa, ss = 0;
            if ($r && Gr instanceof ne.aJ && Gr.coordinates.length > 3)
              Fo = Float32Array.from(ne.bb(ne.cH(new ne.bT(0, 0, 0)))), zo = Float32Array.from(mo.globeMatrix), Jo = Float32Array.from(ne.cD(mo)), ia = [ne.at(mo.center.lng), ne.aA(mo.center.lat)], Eo = Gr.elevatedGlobePerspectiveTransform, sa = Gr.elevatedGlobeGridMatrix || new Float32Array(9);
            else if ($r) {
              const la = ne.cE(nn.canonical);
              ss = ne.cF(la.getCenter().lat), Fo = Float32Array.from(ne.bb(ne.cH(nn.canonical))), zo = Float32Array.from(mo.globeMatrix), Jo = Float32Array.from(ne.cD(mo)), ia = [ne.at(mo.center.lng), ne.aA(mo.center.lat)], Eo = [0, 0], sa = Float32Array.from(ne.cG(nn.canonical, la, ss, mo.worldSize / mo._pixelsPerMercatorPixel));
            } else
              Eo = Gr instanceof ne.aJ ? Gr.perspectiveTransform : [0, 0], Fo = new Float32Array(16), zo = new Float32Array(9), Jo = new Float32Array(16), ia = [0, 0], sa = new Float32Array(9);
            const Ya = Ao(eo, Fo, zo, Jo, sa, yo || [0, 0], ne.ae(qe.transform.zoom), ia, Ko, _o || 1, Wn, ke, Eo, Tr ? ke.paint.get("raster-elevation") : 0, 2, xn, Hn, qr.range, io, uo, Jr), Oa = qe.isTileAffectedByFog(nn), Na = qe.getOrCreateProgram("raster", { defines: qr.defines, overrideFog: Oa });
            if (qe.uploadCommonUniforms(Dr, Na, dn), Gr instanceof ne.aJ) {
              const la = Gr.elevatedGlobeVertexBuffer, _a = Gr.elevatedGlobeIndexBuffer;
              if (fi || !yr)
                Gr.boundsBuffer && Gr.boundsSegments && Na.draw(qe, Or.TRIANGLES, An, ta.disabled, bi, Uo.disabled, Ya, ke.id, Gr.boundsBuffer, qe.quadTriangleIndexBuffer, Gr.boundsSegments);
              else if (la && _a) {
                const qo = mo.zoom <= ne.c6 ? Gr.elevatedGlobeSegments : Gr.getSegmentsForLongitude(mo.center.lng);
                qo && Na.draw(qe, Or.TRIANGLES, An, ta.disabled, bi, Xi, Ya, ke.id, la, _a, qo);
              }
            } else if ($r) {
              An = new Oo(Or.LEQUAL, Oo.ReadOnly, qe.depthRangeFor3D);
              const la = qe.globeSharedBuffers;
              if (la) {
                const [_a, qo, Aa] = la.getGridBuffers(ss, !1);
                Na.draw(qe, Or.TRIANGLES, An, Gi || On, qe.colorModeForRenderPass(), Xi, Ya, ke.id, _a, qo, Aa);
              }
            } else {
              const { tileBoundsBuffer: la, tileBoundsIndexBuffer: _a, tileBoundsSegments: qo } = qe.getTileBoundsBuffers(Pn);
              Na.draw(qe, Or.TRIANGLES, An, On, bi, Uo.disabled, Ya, ke.id, la, _a, qo);
            }
          }
          if (!(Gr instanceof ne.aJ) && $r)
            for (const nn of Wi) {
              const dn = nn.canonical.y === (1 << nn.canonical.z) - 1;
              nn.canonical.y === 0 && Mo(!0, nn, qe, xe, ke, Jr, qr, Xi, Gi || ta.disabled), dn && Mo(!1, nn, qe, xe, ke, Jr, qr, Xi === Uo.frontCW ? Uo.backCW : Uo.frontCW, Gi || ta.disabled);
            }
        };
        $r ? Ki(Ni, qe.renderElevatedRasterBackface ? Uo.backCW : Uo.frontCW, qe.stencilModeFor3D()) : Ki(Ni, Uo.disabled, void 0), qe.resetStencilClippingMasks();
      }, "raster-particle": function(qe, xe, ke, He, ir, ar) {
        qe.renderPass === "offscreen" && function(yr, Tr, $r, Dr) {
          if (!Dr.length)
            return;
          const Or = yr.context, Gr = Or.gl, qr = Tr.getSource();
          if (!(qr instanceof Pl))
            return;
          const Jr = Math.ceil(Math.sqrt($r.paint.get("raster-particle-count")));
          let bi = $r.particlePositionRGBAImage;
          if (!bi || bi.width !== Jr) {
            const Ni = function(zi) {
              const Ki = zi * zi, Wi = new Uint8Array(4 * Ki), Xi = function(nn) {
                return nn |= 0, nn = Math.imul(2747636419 ^ nn, 2654435769), nn = Math.imul(nn ^ nn >>> 16, 2654435769), ((nn = Math.imul(nn ^ nn >>> 16, 2654435769)) >>> 0) / 4294967296;
              }, Gi = 1 / 1.1;
              for (let nn = 0; nn < Ki; nn++) {
                const dn = Gi * (Xi(2 * nn + 0) + ku), Pn = Gi * (Xi(2 * nn + 1) + ku), Ln = 255 * dn % 1, hn = 255 * Pn % 1, xn = Ln, Hn = Pn - hn / 255, io = hn;
                Wi[4 * nn + 0] = 255 * (dn - Ln / 255), Wi[4 * nn + 1] = 255 * xn, Wi[4 * nn + 2] = 255 * Hn, Wi[4 * nn + 3] = 255 * io;
              }
              return Wi;
            }(Jr);
            bi = $r.particlePositionRGBAImage = new ne.r({ width: Jr, height: Jr }, Ni);
          }
          let fi = $r.particleFramebuffer;
          fi ? fi.width !== Jr && (fi.destroy(), fi = $r.particleFramebuffer = Or.createFramebuffer(Jr, Jr, !0, null)) : fi = $r.particleFramebuffer = Or.createFramebuffer(Jr, Jr, !0, null);
          const Mi = [];
          for (const Ni of Dr) {
            const zi = Tr.getTile(Ni);
            if (!(zi instanceof yd))
              continue;
            const Ki = Iu(zi, qr, $r);
            if (!Ki)
              continue;
            const Wi = [zi.tileSize, zi.tileSize];
            let Xi = $r.tileFramebuffer;
            Xi || (Xi = $r.tileFramebuffer = Or.createFramebuffer(Wi[0], Wi[1], !0, null));
            let Gi = zi.rasterParticleState;
            Gi || (Gi = zi.rasterParticleState = new Wm(Or, Ni, Wi, bi));
            const nn = Gi.update($r.lastInvalidatedAt);
            Gi.particleTextureDimension !== Jr && Gi.updateParticleTexture(Ni, bi);
            const dn = Gi.targetColorTexture;
            Gi.targetColorTexture = Gi.backgroundColorTexture, Gi.backgroundColorTexture = dn;
            const Pn = Gi.particleTexture0;
            Gi.particleTexture0 = Gi.particleTexture1, Gi.particleTexture1 = Pn, Mi.push([Ni, Ki, Gi, nn]);
          }
          if (Mi.length === 0)
            return;
          const Ei = ne.q.now(), Ii = $r.previousDrawTimestamp ? 1e-3 * (Ei - $r.previousDrawTimestamp) : 0.0167;
          if ($r.previousDrawTimestamp = Ei, $r.hasColorMap()) {
            Or.activeTexture.set(Gr.TEXTURE0 + 2);
            let Ni = $r.colorRampTexture;
            Ni || (Ni = $r.colorRampTexture = new ne.T(Or, $r.colorRamp, Gr.RGBA8)), Ni.bind(Gr.LINEAR, Gr.CLAMP_TO_EDGE);
          }
          Or.bindFramebuffer.set($r.tileFramebuffer.framebuffer), function(Ni, zi, Ki) {
            const Wi = Ni.context, Xi = Wi.gl, Gi = zi.tileFramebuffer;
            Wi.activeTexture.set(Xi.TEXTURE0);
            const nn = { u_texture: 0, u_opacity: 1.05 * (Pn = zi.paint.get("raster-particle-fade-opacity-factor")) / (Pn + 0.05) }, dn = Ni.getOrCreateProgram("rasterParticleTexture", { defines: [], overrideFog: !1 });
            var Pn;
            for (const Ln of Ki) {
              const [, , hn, xn] = Ln;
              Gi.colorAttachment.set(hn.targetColorTexture.texture), Wi.viewport.set([0, 0, Gi.width, Gi.height]), Wi.clear({ color: ne.aj.transparent }), xn && (hn.backgroundColorTexture.bind(Xi.NEAREST, Xi.CLAMP_TO_EDGE), dn.draw(Ni, Xi.TRIANGLES, Oo.disabled, ta.disabled, aa.alphaBlended, Uo.disabled, nn, zi.id, Ni.viewportBuffer, Ni.quadTriangleIndexBuffer, Ni.viewportSegments));
            }
          }(yr, $r, Mi), function(Ni, zi, Ki, Wi) {
            const Xi = Ni.context, Gi = Xi.gl, nn = Ki.tileFramebuffer, dn = Ni.transform.projection.name === "globe", Pn = Ki.paint.get("raster-particle-max-speed");
            for (const Ln of Wi) {
              const [hn, xn, Hn] = Ln;
              Xi.activeTexture.set(Gi.TEXTURE0 + 0), xn.texture.bind(Gi.LINEAR, Gi.CLAMP_TO_EDGE), nn.colorAttachment.set(Hn.targetColorTexture.texture);
              const io = Ni.getOrCreateProgram("rasterParticleDraw", { defines: xn.defines, overrideFog: !1 });
              Xi.activeTexture.set(Gi.TEXTURE0 + 1);
              const uo = xn.scalarData ? [] : [0, 1, 2, 3].map((On) => ne.d4[On](hn));
              uo.push(hn);
              const An = hn.canonical.x, eo = hn.canonical.y;
              for (const On of uo) {
                const ao = zi.getTile(dn ? On.wrapped() : On);
                if (!ao)
                  continue;
                const ro = ao.rasterParticleState;
                if (!ro)
                  continue;
                const Wn = On.canonical.x + (1 << On.canonical.z) * (On.wrap - hn.wrap), _o = On.canonical.y;
                ro.particleTexture0.bind(Gi.NEAREST, Gi.CLAMP_TO_EDGE);
                const yo = lh(1, ro.particleTexture0.size[0], [Wn - An, _o - eo], 0, xn.texture.size, 2, Pn, xn.textureOffset, xn.scale, xn.offset);
                io.draw(Ni, Gi.POINTS, Oo.disabled, ta.disabled, aa.alphaBlended, Uo.disabled, yo, Ki.id, ro.particleIndexBuffer, void 0, ro.particleSegment);
              }
            }
          }(yr, Tr, $r, Mi), Or.bindFramebuffer.set($r.particleFramebuffer.framebuffer), function(Ni, zi, Ki, Wi) {
            const Xi = Ni.context, Gi = Xi.gl, nn = zi.paint.get("raster-particle-max-speed"), dn = Wi * zi.paint.get("raster-particle-speed-factor") * 0.15, Pn = function(hn) {
              return Math.pow(hn, 6);
            }(0.01 + 1 * zi.paint.get("raster-particle-reset-rate-factor")), Ln = zi.particleFramebuffer;
            Xi.viewport.set([0, 0, Ln.width, Ln.height]);
            for (const hn of Ki) {
              const [, xn, Hn] = hn;
              Xi.activeTexture.set(Gi.TEXTURE0 + 0), xn.texture.bind(Gi.LINEAR, Gi.CLAMP_TO_EDGE), Xi.activeTexture.set(Gi.TEXTURE0 + 1);
              const io = Hn.particleTexture0;
              io.bind(Gi.NEAREST, Gi.CLAMP_TO_EDGE);
              const uo = Do(1, io.size[0], 0, xn.texture.size, nn, dn, Pn, xn.textureOffset, xn.scale, xn.offset);
              Ln.colorAttachment.set(Hn.particleTexture1.texture), Xi.clear({ color: ne.aj.transparent }), Ni.getOrCreateProgram("rasterParticleUpdate", { defines: xn.defines }).draw(Ni, Gi.TRIANGLES, Oo.disabled, ta.disabled, aa.unblended, Uo.disabled, uo, zi.id, Ni.viewportBuffer, Ni.quadTriangleIndexBuffer, Ni.viewportSegments);
            }
          }(yr, $r, Mi, Ii);
        }(qe, xe, ke, He), qe.renderPass === "translucent" && (function(yr, Tr, $r, Dr, Or) {
          const Gr = yr.context, qr = Gr.gl, Jr = Tr.getSource().tileSize, bi = 5 * (1 - ne.ac(ne.bY, ne.bY + 1, yr.transform.zoom)) * Jr + $r.paint.get("raster-particle-elevation"), fi = !yr.options.moving, Mi = yr.transform.projection.name === "globe";
          if (!Dr.length)
            return;
          const [Ei, Ii] = yr.stencilConfigForOverlap(Dr), Ni = [];
          Mi && Ni.push("PROJECTION_GLOBE_VIEW");
          const zi = yr.stencilModeFor3D();
          for (const Ki of Ii) {
            const Wi = Ki.toUnwrapped(), Xi = Tr.getTile(Ki);
            if (!Xi.rasterParticleState)
              continue;
            const Gi = Xi.rasterParticleState, nn = 100;
            Xi.registerFadeDuration(nn);
            const dn = Tr.findLoadedParent(Ki, 0), Pn = pc(Xi, dn, Tr, yr.transform, nn);
            let Ln, hn;
            yr.terrain && yr.terrain.prepareDrawTile(), Gr.activeTexture.set(qr.TEXTURE0), Gi.targetColorTexture.bind(qr.LINEAR, qr.CLAMP_TO_EDGE), Gr.activeTexture.set(qr.TEXTURE1), dn && dn.rasterParticleState ? (dn.rasterParticleState.targetColorTexture.bind(qr.LINEAR, qr.CLAMP_TO_EDGE), Ln = Math.pow(2, dn.tileID.overscaledZ - Xi.tileID.overscaledZ), hn = [Xi.tileID.canonical.x * Ln % 1, Xi.tileID.canonical.y * Ln % 1]) : Gi.targetColorTexture.bind(qr.LINEAR, qr.CLAMP_TO_EDGE);
            const xn = Mi ? Float32Array.from(yr.transform.expandedFarZProjMatrix) : yr.transform.calculateProjMatrix(Wi, fi), Hn = yr.transform, io = Zf(Hn), uo = ne.cE(Ki.canonical), An = ne.cF(uo.getCenter().lat);
            let eo, On, ao, ro, Wn;
            Mi ? (eo = Float32Array.from(ne.bb(ne.cH(Ki.canonical))), On = Float32Array.from(Hn.globeMatrix), ao = Float32Array.from(ne.cD(Hn)), ro = [ne.at(Hn.center.lng), ne.aA(Hn.center.lat)], Wn = Float32Array.from(ne.cG(Ki.canonical, uo, An, Hn.worldSize / Hn._pixelsPerMercatorPixel))) : (eo = new Float32Array(16), On = new Float32Array(9), ao = new Float32Array(16), ro = [0, 0], Wn = new Float32Array(9));
            const _o = Lu(xn, eo, On, ao, Wn, hn || [0, 0], ne.ae(yr.transform.zoom), ro, io, Ln || 1, Pn, bi), yo = yr.isTileAffectedByFog(Ki), mo = yr.getOrCreateProgram("rasterParticle", { defines: Ni, overrideFog: yo });
            if (yr.uploadCommonUniforms(Gr, mo, Wi), Mi) {
              const Eo = new Oo(qr.LEQUAL, Oo.ReadOnly, yr.depthRangeFor3D), Ko = 0, Fo = yr.globeSharedBuffers;
              if (Fo) {
                const [zo, Jo, ia] = Fo.getGridBuffers(An, Ko !== 0);
                mo.draw(yr, qr.TRIANGLES, Eo, zi, aa.alphaBlended, yr.renderElevatedRasterBackface ? Uo.frontCCW : Uo.backCCW, _o, $r.id, zo, Jo, ia);
              }
            } else {
              const Eo = yr.depthModeForSublayer(0, Oo.ReadOnly), Ko = Ei[Ki.overscaledZ], { tileBoundsBuffer: Fo, tileBoundsIndexBuffer: zo, tileBoundsSegments: Jo } = yr.getTileBoundsBuffers(Xi);
              mo.draw(yr, qr.TRIANGLES, Eo, Ko, aa.alphaBlended, Uo.disabled, _o, $r.id, Fo, zo, Jo);
            }
          }
          yr.resetStencilClippingMasks();
        }(qe, xe, ke, He), qe.style.map.triggerRepaint());
      }, background: function(qe, xe, ke, He) {
        const ir = ke.paint.get("background-color"), ar = ke.paint.get("background-color-use-theme").constantOr("default") === "none", yr = ke.paint.get("background-opacity"), Tr = ke.paint.get("background-emissive-strength"), $r = ke.paint.get("background-pitch-alignment") === "viewport";
        if (yr === 0)
          return;
        const Dr = qe.context, Or = Dr.gl, Gr = qe.transform, qr = Gr.tileSize, Jr = ke.paint.get("background-pattern");
        let bi;
        if (Jr !== void 0 && (Jr === null || (bi = qe.imageManager.getPattern(Jr.toString(), ke.scope, qe.style.getLut(ke.scope)), !bi)))
          return;
        const fi = !Jr && ir.a === 1 && yr === 1 && qe.opaquePassEnabledForLayer() ? "opaque" : "translucent";
        if (qe.renderPass !== fi)
          return;
        const Mi = ta.disabled, Ei = qe.depthModeForSublayer(0, fi === "opaque" ? Oo.ReadWrite : Oo.ReadOnly), Ii = qe.colorModeForDrapableLayerRenderPass(Tr), Ni = Jr ? "backgroundPattern" : "background";
        let zi, Ki = He;
        if (Ki || (zi = qe.getBackgroundTiles(), Ki = Object.values(zi).map((Wi) => Wi.tileID)), Jr && (Dr.activeTexture.set(Or.TEXTURE0), qe.imageManager.bind(qe.context, ke.scope)), $r) {
          const Wi = qe.getOrCreateProgram(Ni, { overrideFog: !1, overrideRtt: !0 }), Xi = new Float32Array(ne.ab.mat4.identity([])), Gi = new ne.aG(0, 0, 0, 0, 0), nn = Jr ? qf(Xi, Tr, yr, qe, 0, ke.scope, bi, $r, { tileID: Gi, tileSize: qr }) : Vd(Xi, Tr, yr, ir.toRenderColor(ar ? null : ke.lut));
          Wi.draw(qe, Or.TRIANGLES, Ei, Mi, Ii, Uo.disabled, nn, ke.id, qe.viewportBuffer, qe.quadTriangleIndexBuffer, qe.viewportSegments);
        } else
          for (const Wi of Ki) {
            const Xi = qe.isTileAffectedByFog(Wi), Gi = qe.getOrCreateProgram(Ni, { overrideFog: Xi }), nn = Wi.toUnwrapped(), dn = He ? Wi.projMatrix : qe.transform.calculateProjMatrix(nn);
            qe.prepareDrawTile();
            const Pn = xe ? xe.getTile(Wi) : zi ? zi[Wi.key] : new Xl(Wi, qr, Gr.zoom, qe), Ln = Jr ? qf(dn, Tr, yr, qe, 0, ke.scope, bi, $r, { tileID: Wi, tileSize: qr }) : Vd(dn, Tr, yr, ir.toRenderColor(ar ? null : ke.lut));
            qe.uploadCommonUniforms(Dr, Gi, nn);
            const { tileBoundsBuffer: hn, tileBoundsIndexBuffer: xn, tileBoundsSegments: Hn } = qe.getTileBoundsBuffers(Pn);
            Gi.draw(qe, Or.TRIANGLES, Ei, Mi, Ii, Uo.disabled, Ln, ke.id, hn, xn, Hn);
          }
      }, sky: function(qe, xe, ke) {
        const He = qe._atmosphere ? ne.ae(qe.transform.zoom) : 1, ir = ke.paint.get("sky-opacity") * He;
        if (ir === 0)
          return;
        const ar = qe.context, yr = ke.paint.get("sky-type"), Tr = new Oo(ar.gl.LEQUAL, Oo.ReadOnly, [0, 1]), $r = qe.frameCounter / 1e3 % 1;
        yr === "atmosphere" ? qe.renderPass === "offscreen" ? ke.needsSkyboxCapture(qe) && (function(Dr, Or, Gr, qr) {
          const Jr = Dr.context, bi = Jr.gl;
          let fi = Or.skyboxFbo;
          if (!fi) {
            fi = Or.skyboxFbo = Jr.createFramebuffer(32, 32, !0, null), Or.skyboxGeometry = new Hd(Jr), Or.skyboxTexture = Jr.gl.createTexture(), bi.bindTexture(bi.TEXTURE_CUBE_MAP, Or.skyboxTexture), bi.texParameteri(bi.TEXTURE_CUBE_MAP, bi.TEXTURE_WRAP_S, bi.CLAMP_TO_EDGE), bi.texParameteri(bi.TEXTURE_CUBE_MAP, bi.TEXTURE_WRAP_T, bi.CLAMP_TO_EDGE), bi.texParameteri(bi.TEXTURE_CUBE_MAP, bi.TEXTURE_MIN_FILTER, bi.LINEAR), bi.texParameteri(bi.TEXTURE_CUBE_MAP, bi.TEXTURE_MAG_FILTER, bi.LINEAR);
            for (let Ni = 0; Ni < 6; ++Ni)
              bi.texImage2D(bi.TEXTURE_CUBE_MAP_POSITIVE_X + Ni, 0, bi.RGBA, 32, 32, 0, bi.RGBA, bi.UNSIGNED_BYTE, null);
          }
          Jr.bindFramebuffer.set(fi.framebuffer), Jr.viewport.set([0, 0, 32, 32]);
          const Mi = Or.getCenter(Dr, !0), Ei = Dr.getOrCreateProgram("skyboxCapture"), Ii = new Float64Array(16);
          ne.ab.mat4.identity(Ii), ne.ab.mat4.rotateY(Ii, Ii, 0.5 * -Math.PI), fl(Dr, Or, Ei, Ii, Mi, 0), ne.ab.mat4.identity(Ii), ne.ab.mat4.rotateY(Ii, Ii, 0.5 * Math.PI), fl(Dr, Or, Ei, Ii, Mi, 1), ne.ab.mat4.identity(Ii), ne.ab.mat4.rotateX(Ii, Ii, 0.5 * -Math.PI), fl(Dr, Or, Ei, Ii, Mi, 2), ne.ab.mat4.identity(Ii), ne.ab.mat4.rotateX(Ii, Ii, 0.5 * Math.PI), fl(Dr, Or, Ei, Ii, Mi, 3), ne.ab.mat4.identity(Ii), fl(Dr, Or, Ei, Ii, Mi, 4), ne.ab.mat4.identity(Ii), ne.ab.mat4.rotateY(Ii, Ii, Math.PI), fl(Dr, Or, Ei, Ii, Mi, 5), Jr.viewport.set([0, 0, Dr.width, Dr.height]);
        }(qe, ke), ke.markSkyboxValid(qe)) : qe.renderPass === "sky" && function(Dr, Or, Gr, qr, Jr) {
          const bi = Dr.context, fi = bi.gl, Mi = Dr.transform, Ei = Dr.getOrCreateProgram("skybox");
          bi.activeTexture.set(fi.TEXTURE0), fi.bindTexture(fi.TEXTURE_CUBE_MAP, Or.skyboxTexture);
          const Ii = ((Ni, zi, Ki, Wi, Xi) => ({ u_matrix: Ni, u_sun_direction: zi, u_cubemap: 0, u_opacity: Wi, u_temporal_offset: Xi }))(Mi.skyboxMatrix, Or.getCenter(Dr, !1), 0, qr, Jr);
          Dr.uploadCommonUniforms(bi, Ei), Ei.draw(Dr, fi.TRIANGLES, Gr, ta.disabled, Dr.colorModeForRenderPass(), Uo.backCW, Ii, "skybox", Or.skyboxGeometry.vertexBuffer, Or.skyboxGeometry.indexBuffer, Or.skyboxGeometry.segment);
        }(qe, ke, Tr, ir, $r) : yr === "gradient" && qe.renderPass === "sky" && function(Dr, Or, Gr, qr, Jr) {
          const bi = Dr.context, fi = bi.gl, Mi = Dr.transform, Ei = Dr.getOrCreateProgram("skyboxGradient");
          Or.skyboxGeometry || (Or.skyboxGeometry = new Hd(bi)), bi.activeTexture.set(fi.TEXTURE0);
          let Ii = Or.colorRampTexture;
          Ii || (Ii = Or.colorRampTexture = new ne.T(bi, Or.colorRamp, fi.RGBA8)), Ii.bind(fi.LINEAR, fi.CLAMP_TO_EDGE);
          const Ni = ((zi, Ki, Wi, Xi, Gi) => ({ u_matrix: zi, u_color_ramp: 0, u_center_direction: Ki, u_radius: ne.ai(Wi), u_opacity: Xi, u_temporal_offset: Gi }))(Mi.skyboxMatrix, Or.getCenter(Dr, !1), Or.paint.get("sky-gradient-radius"), qr, Jr);
          Dr.uploadCommonUniforms(bi, Ei), Ei.draw(Dr, fi.TRIANGLES, Gr, ta.disabled, Dr.colorModeForRenderPass(), Uo.backCW, Ni, "skyboxGradient", Or.skyboxGeometry.vertexBuffer, Or.skyboxGeometry.indexBuffer, Or.skyboxGeometry.segment);
        }(qe, ke, Tr, ir, $r);
      }, debug: function(qe, xe, ke, He, ir, ar) {
        for (let yr = 0; yr < ke.length; yr++)
          if (ir) {
            const Dr = new ne.aj(He.r * 0.8, He.g * 0.8, He.b * 0.8, 1);
            Bu(qe, xe, ke[yr], He, -1, -1, ar), Bu(qe, xe, ke[yr], He, -1, 1, ar), Bu(qe, xe, ke[yr], He, 1, 1, ar), Bu(qe, xe, ke[yr], He, 1, -1, ar), Bu(qe, xe, ke[yr], Dr, 0, 0, ar);
          } else
            Bu(qe, xe, ke[yr], He, 0, 0, ar);
      }, custom: function(qe, xe, ke, He) {
        const ir = qe.context, ar = ke.implementation;
        if (!qe.transform.projection.unsupportedLayers || !qe.transform.projection.unsupportedLayers.includes("custom") || qe.terrain && (qe.terrain.renderingToTexture || qe.renderPass === "offscreen") && ke.isDraped(xe)) {
          if (qe.renderPass === "offscreen") {
            const yr = ar.prerender;
            if (yr) {
              if (qe.setCustomLayerDefaults(), ir.setColorMode(qe.colorModeForRenderPass()), qe.transform.projection.name === "globe") {
                const Tr = qe.transform.pointMerc;
                yr.call(ar, ir.gl, qe.transform.customLayerMatrix(), qe.transform.getProjection(), qe.transform.globeToMercatorMatrix(), ne.ae(qe.transform.zoom), [Tr.x, Tr.y], qe.transform.pixelsPerMeterRatio);
              } else
                yr.call(ar, ir.gl, qe.transform.customLayerMatrix());
              ir.setDirty(), qe.setBaseState();
            }
          } else if (qe.renderPass === "translucent") {
            if (qe.terrain && qe.terrain.renderingToTexture) {
              const Tr = ar.renderToTile;
              if (Tr) {
                const $r = He[0].canonical, Dr = new ne.aa($r.x + He[0].wrap * (1 << $r.z), $r.y, $r.z);
                ir.setDepthMode(Oo.disabled), ir.setStencilMode(ta.disabled), ir.setColorMode(qe.colorModeForRenderPass()), qe.setCustomLayerDefaults(), Tr.call(ar, ir.gl, Dr), ir.setDirty(), qe.setBaseState();
              }
              return;
            }
            qe.setCustomLayerDefaults(), ir.setColorMode(qe.colorModeForRenderPass()), ir.setStencilMode(ta.disabled);
            const yr = ar.renderingMode === "3d" ? new Oo(qe.context.gl.LEQUAL, Oo.ReadWrite, qe.depthRangeFor3D) : qe.depthModeForSublayer(0, Oo.ReadOnly);
            if (ir.setDepthMode(yr), qe.transform.projection.name === "globe") {
              const Tr = qe.transform.pointMerc;
              ar.render(ir.gl, qe.transform.customLayerMatrix(), qe.transform.getProjection(), qe.transform.globeToMercatorMatrix(), ne.ae(qe.transform.zoom), [Tr.x, Tr.y], qe.transform.pixelsPerMeterRatio);
            } else
              ar.render(ir.gl, qe.transform.customLayerMatrix());
            ir.setDirty(), qe.setBaseState(), ir.bindFramebuffer.set(null);
          }
        } else
          ne.w("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
      }, model: function(qe, xe, ke, He) {
        if (qe.renderPass === "opaque")
          return;
        const ir = ke.paint.get("model-opacity").constantOr(1);
        if (ir === 0)
          return;
        const ar = ke.paint.get("model-cast-shadows");
        if (qe.renderPass === "shadow" && (!ar || qe.terrain && ir < 0.65 && ke._transitionablePaint._values["model-opacity"].value.expression instanceof ne.a9))
          return;
        const yr = qe.shadowRenderer, Tr = ke.paint.get("model-receive-shadows");
        yr && (yr.useNormalOffset = !0, Tr || (yr.enabled = !1));
        const $r = () => {
          yr && (yr.useNormalOffset = !0, Tr || (yr.enabled = !0));
        }, Dr = xe.getSource();
        if (qe.renderPass === "light-beam" && Dr.type !== "batched-model")
          return;
        if (Dr.type === "vector" || Dr.type === "geojson")
          return function(Ei, Ii, Ni, zi, Ki) {
            const Wi = Ei.transform;
            if (Wi.projection.name !== "mercator")
              return void ne.w(`Drawing 3D models for ${Wi.projection.name} projection is not yet implemented`);
            const Xi = Wi.getFreeCameraOptions().position;
            if (!Ei.modelManager)
              return;
            const Gi = Ei.modelManager;
            Ni.modelManager = Gi;
            const nn = Ei.shadowRenderer;
            if (!Ni._unevaluatedLayout._values.hasOwnProperty("model-id"))
              return;
            const dn = Ni._unevaluatedLayout._values["model-id"], Pn = { ...Ni.layout.get("model-id").parameters }, Ln = Ei.style.order.indexOf(Ni.fqid);
            for (const hn of zi) {
              const xn = Ii.getTile(hn).getBucket(Ni);
              if (!xn || xn.projection.name !== Wi.projection.name)
                continue;
              const Hn = xn.getModelUris();
              Hn && !xn.modelsRequested && (Gi.addModelsFromBucket(Hn, Ki), xn.modelsRequested = !0);
              const io = Xd(hn, Wi);
              Pn.zoom = io;
              const uo = dn.possiblyEvaluate(Pn);
              if ($u(Ei, xn, hn), tc.shadowUniformsInitialized = !1, tc.useSingleShadowCascade = !!nn && nn.getMaxCascadeForTile(hn.toUnwrapped()) === 0, Ei.renderPass === "shadow" && nn) {
                if (Ei.currentShadowCascade === 1 && xn.isInsideFirstShadowMapFrustum)
                  continue;
                const On = Wi.calculatePosMatrix(hn.toUnwrapped(), Wi.worldSize);
                if (tc.tileMatrix.set(On), tc.shadowTileMatrix = Float32Array.from(nn.calculateShadowPassMatrixFromMatrix(On)), tc.aabb.min.fill(0), tc.aabb.max[0] = tc.aabb.max[1] = ne.ag, tc.aabb.max[2] = 0, Ia(xn, tc, Ei, Ni.scope))
                  continue;
              }
              const An = 1 << hn.canonical.z, eo = [((Xi.x - hn.wrap) * An - hn.canonical.x) * ne.ag, (Xi.y * An - hn.canonical.y) * ne.ag, Xi.z * An * ne.ag];
              Ei.conflationActive && Object.keys(xn.instancesPerModel).length > 0 && Ei.style.isLayerClipped(Ni, Ii.getSource()) && xn.updateReplacement(hn, Ei.replacementSource, Ln, Ki) && (xn.uploaded = !1, xn.upload(Ei.context));
              for (let On in xn.instancesPerModel) {
                const ao = xn.instancesPerModel[On];
                ao.features.length > 0 && (On = uo.evaluate(ao.features[0].feature, {}));
                const ro = Gi.getModel(On, Ki);
                if (ro && ro.uploaded)
                  for (const Wn of ro.nodes)
                    cu(Ei, Ni, Wn, ao, eo, hn, tc);
              }
            }
          }(qe, xe, ke, He, Dr.type === "vector" ? ke.scope : ""), void $r();
        if (!Dr.loaded())
          return;
        if (Dr.type === "batched-model")
          return function(Ei, Ii, Ni, zi) {
            Ni.resetLayerRenderingStats(Ei);
            const Ki = Ei.context, Wi = Ei.transform, Xi = Ei.style.fog, Gi = Ei.shadowRenderer;
            if (Wi.projection.name !== "mercator")
              return void ne.w(`Drawing 3D landmark models for ${Wi.projection.name} projection is not yet implemented`);
            const nn = Ei.transform.getFreeCameraOptions().position, dn = ne.ab.vec3.scale([], [nn.x, nn.y, nn.z], Ei.transform.worldSize), Pn = ne.ab.vec3.negate([], dn), Ln = ne.ab.mat4.identity([]), hn = ne.dj(Wi.center.lat, Wi.zoom), xn = ne.ab.mat4.fromScaling([], [1, 1, 1 / hn]);
            ne.ab.mat4.translate(Ln, Ln, Pn);
            const Hn = Ni.paint.get("model-opacity").constantOr(1), io = new Oo(Ki.gl.LEQUAL, Oo.ReadWrite, Ei.depthRangeFor3D), uo = new Oo(Ki.gl.LEQUAL, Oo.ReadOnly, Ei.depthRangeFor3D), An = new ne.cd([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), eo = Ei.renderPass === "shadow", On = eo && Gi ? Gi.getCurrentCascadeFrustum() : Wi.getFrustum(Wi.scaleZoom(Wi.worldSize)), ao = Ni.paint.get("model-front-cutoff"), ro = ao[2] < 1, Wn = Tc(Ei, Ni.paint.get("model-cutoff-fade-range")), _o = Ni.getLayerRenderingStats();
            (function(yo, mo, Eo, Ko) {
              const Fo = yo.terrain ? yo.terrain.exaggeration() : 0, zo = yo.transform.zoom;
              for (const Jo of Ko) {
                const ia = mo.getTile(Jo).getBucket(Eo);
                ia && (yo.conflationActive && ia.updateReplacement(Jo, yo.replacementSource), ia.evaluateScale(yo, Eo), yo.terrain && Fo > 0 && ia.elevationUpdate(yo.terrain, Fo, Jo, Eo.source), ia.needsReEvaluation(yo, zo, Eo) && ia.evaluate(Eo));
              }
            })(Ei, Ii, Ni, zi), function() {
              let yo, mo, Eo;
              ro ? (yo = zi.length - 1, mo = -1, Eo = -1) : (yo = 0, mo = zi.length, Eo = 1);
              const Ko = new Float64Array(16), Fo = ne.ab.vec3.create(), zo = new ne.P(0, 0);
              for (let Jo = yo; Jo !== mo; Jo += Eo) {
                const ia = zi[Jo], sa = Ii.getTile(ia).getBucket(Ni);
                if (!sa || !sa.uploaded)
                  continue;
                let ss = !1;
                Gi && (ss = Gi.getMaxCascadeForTile(ia.toUnwrapped()) === 0);
                const Ya = Wi.calculatePosMatrix(ia.toUnwrapped(), Wi.worldSize), Oa = sa.modelTraits;
                !eo && ro && (ne.ab.mat4.invert(Ko, Ya), ne.ab.vec3.transformMat4(Fo, dn, Ko), zo.x = Fo[0], zo.y = Fo[1]);
                const Na = [];
                for (const la of sa.getNodesInfo()) {
                  if (la.hiddenByReplacement || !la.node.meshes)
                    continue;
                  const _a = la.node;
                  let qo = 0;
                  Ei.terrain && _a.elevation && (qo = _a.elevation * Ei.terrain.exaggeration());
                  const Aa = (() => {
                    const Ma = la.aabb;
                    return An.min = [...Ma.min], An.max = [...Ma.max], An.min[2] += qo, An.max[2] += qo, ne.ab.vec3.transformMat4(An.min, An.min, Ya), ne.ab.vec3.transformMat4(An.max, An.max, Ya), An;
                  })(), ps = la.evaluatedScale;
                  if (ps[0] <= 1 && ps[1] <= 1 && ps[2] <= 1 && Aa.intersects(On) === 0)
                    continue;
                  if (!eo && ro) {
                    const Ma = 0.16666666666666666;
                    la.cameraCollisionOpacity = dn[0] > Aa.min[0] && dn[0] < Aa.max[0] && dn[1] > Aa.min[1] && dn[1] < Aa.max[1] && dn[2] * hn < Aa.max[2] && _a.footprint && ne.bA(zo, _a.footprint) ? Math.max(la.cameraCollisionOpacity - Ma, 0) : Math.min(1, la.cameraCollisionOpacity + Ma);
                  }
                  const Xs = [...Ya], ql = _a.anchor ? _a.anchor[0] : 0, ml = _a.anchor ? _a.anchor[1] : 0;
                  ne.ab.mat4.translate(Xs, Xs, [ql * (ps[0] - 1), ml * (ps[1] - 1), qo]), ne.ab.vec3.exactEquals(ps, ne.dm) || ne.ab.mat4.scale(Xs, Xs, ps);
                  const Ns = ne.ab.mat4.multiply([], Xs, _a.matrix), ks = ne.ab.mat4.multiply([], Wi.expandedFarZProjMatrix, Ns), Cs = ne.ab.mat4.multiply([], Wi.expandedFarZProjMatrix, Xs), is = ne.ab.vec4.transformMat4([], [ql, ml, qo, 1], ks)[2];
                  _a.hidden = !1;
                  let Za = Hn;
                  eo || (ro && (Za *= la.cameraCollisionOpacity, Za *= Jf(Xs, Wi, la.aabb, ao)), Za *= Yf(Wn, is)), Za !== 0 ? Na.push({ nodeInfo: la, depth: is, opacity: Za, wvpForNode: ks, wvpForTile: Cs, nodeModelMatrix: Ns, tileModelMatrix: Xs }) : _a.hidden = !0;
                }
                eo || Na.sort((la, _a) => !ro || la.opacity === 1 && _a.opacity === 1 ? la.depth < _a.depth ? -1 : 1 : la.opacity === 1 ? -1 : _a.opacity === 1 ? 1 : la.depth > _a.depth ? -1 : 1);
                for (const la of Na) {
                  const _a = la.nodeInfo, qo = _a.node;
                  let Aa = ne.ab.mat4.multiply([], xn, la.tileModelMatrix);
                  ne.ab.mat4.multiply(Aa, Ln, Aa);
                  const ps = ne.ab.mat4.invert([], Aa);
                  ne.ab.mat4.transpose(ps, ps), ne.ab.mat4.scale(ps, ps, Xc), Aa = ne.ab.mat4.multiply(Aa, Aa, qo.matrix);
                  const Xs = Ei.renderPass === "light-beam", ql = Ni.paint.get("model-color-use-theme").constantOr("default") === "none", ml = Oa & ne.dp.HasMapboxMeshFeatures, Ns = ml ? 0 : _a.evaluatedRMEA[0][2];
                  for (let ks = 0; ks < qo.meshes.length; ++ks) {
                    const Cs = qo.meshes[ks], is = ks === qo.lightMeshIndex;
                    let Za = la.wvpForNode;
                    if (is) {
                      if (!Xs && !Ei.terrain && Ei.shadowRenderer) {
                        Ei.currentLayer < Ei.firstLightBeamLayer && (Ei.firstLightBeamLayer = Ei.currentLayer);
                        continue;
                      }
                      Za = la.wvpForTile;
                    } else if (Xs)
                      continue;
                    const Ma = { defines: [] }, xs = [];
                    if (!eo && Gi && (Gi.useNormalOffset = !!Cs.normalBuffer), La(Ma.defines, xs, Cs, Ei, ql ? null : Ni.lut), ml || Ma.defines.push("DIFFUSE_SHADED"), ss && Ma.defines.push("SHADOWS_SINGLE_CASCADE"), _o && (eo ? _o.numRenderedVerticesInShadowPass += Cs.vertexArray.length : _o.numRenderedVerticesInTransparentPass += Cs.vertexArray.length), eo) {
                      rd(Cs, la.nodeModelMatrix, Ei, Ni);
                      continue;
                    }
                    let Vs = null;
                    if (Xi) {
                      const Jc = Ka(la.nodeModelMatrix, Ei.transform);
                      if (Vs = new Float32Array(Jc), Wi.projection.name !== "globe") {
                        const gl = Cs.aabb.min, oc = Cs.aabb.max, [Rc, yc] = Xi.getOpacityForBounds(Jc, gl[0], gl[1], oc[0], oc[1]);
                        Ma.overrideFog = Rc >= Tn || yc >= Tn;
                      }
                    }
                    const Ja = Cs.material;
                    let ul;
                    Ja.occlusionTexture && Ja.occlusionTexture.offsetScale && (ul = Ja.occlusionTexture.offsetScale, Ma.defines.push("OCCLUSION_TEXTURE_TRANSFORM"));
                    const nc = Ei.getOrCreateProgram("model", Ma);
                    !eo && Gi && Gi.setupShadowsFromMatrix(la.tileModelMatrix, nc, Gi.useNormalOffset), Ei.uploadCommonUniforms(Ki, nc, null, Vs);
                    const Rl = Ja.pbrMetallicRoughness;
                    Rl.metallicFactor = 0.9, Rl.roughnessFactor = 0.5;
                    const vu = Gf(new Float32Array(Za), new Float32Array(Aa), new Float32Array(ps), new Float32Array(qo.matrix), Ei, la.opacity, Rl.baseColorFactor.toRenderColor(null), Ja.emissiveFactor, Rl.metallicFactor, Rl.roughnessFactor, Ja, Ns, Ni, [0, 0, 0], ul);
                    !is && (_a.hasTranslucentParts || la.opacity < 1) && nc.draw(Ei, Ki.gl.TRIANGLES, io, ta.disabled, aa.disabled, Uo.backCCW, vu, Ni.id, Cs.vertexBuffer, Cs.indexBuffer, Cs.segments, Ni.paint, Ei.transform.zoom, void 0, xs), nc.draw(Ei, Ki.gl.TRIANGLES, is ? uo : io, ta.disabled, is || la.opacity < 1 || _a.hasTranslucentParts ? aa.alphaBlended : aa.unblended, Uo.backCCW, vu, Ni.id, Cs.vertexBuffer, Cs.indexBuffer, Cs.segments, Ni.paint, Ei.transform.zoom, void 0, xs);
                  }
                }
              }
            }();
          }(qe, xe, ke, He), void $r();
        if (Dr.type !== "model")
          return;
        const Or = Dr.getModels(), Gr = [], qr = qe.transform.getFreeCameraOptions().position, Jr = ne.ab.vec3.scale([], [qr.x, qr.y, qr.z], qe.transform.worldSize);
        ne.ab.vec3.negate(Jr, Jr);
        const bi = [], fi = [];
        let Mi = 0;
        for (const Ei of Or) {
          const Ii = ke.paint.get("model-rotation").constantOr(null), Ni = ke.paint.get("model-scale").constantOr(null), zi = ke.paint.get("model-translation").constantOr(null);
          Ei.computeModelMatrix(qe, Ii, Ni, zi, !0, !0, !1);
          const Ki = ne.ab.mat4.identity([]), Wi = ne.dj(Ei.position.lat, qe.transform.zoom), Xi = ne.ab.mat4.fromScaling([], [1, 1, 1 / Wi]);
          ne.ab.mat4.translate(Ki, Ki, Jr), Gr.push({ zScaleMatrix: Xi, negCameraPosMatrix: Ki });
          for (const Gi of Ei.nodes)
            Zc(qe.transform, Gi, Ei.matrix, qe.transform.expandedFarZProjMatrix, Mi, bi, fi);
          Mi++;
        }
        if (bi.sort((Ei, Ii) => Ii.depth - Ei.depth), qe.renderPass !== "shadow") {
          if (ir === 1)
            for (const Ei of fi)
              Zd(Ei, qe, ke, Gr[Ei.modelIndex], ta.disabled, qe.colorModeForRenderPass());
          else {
            for (const Ei of fi)
              Zd(Ei, qe, ke, Gr[Ei.modelIndex], ta.disabled, aa.disabled);
            for (const Ei of fi)
              Zd(Ei, qe, ke, Gr[Ei.modelIndex], qe.stencilModeFor3D(), qe.colorModeForRenderPass());
            qe.resetStencilClippingMasks();
          }
          for (const Ei of bi)
            Zd(Ei, qe, ke, Gr[Ei.modelIndex], ta.disabled, qe.colorModeForRenderPass());
          $r();
        } else {
          for (const Ei of fi)
            rd(Ei.mesh, Ei.nodeModelMatrix, qe, ke);
          for (const Ei of bi)
            rd(Ei.mesh, Ei.nodeModelMatrix, qe, ke);
          $r();
        }
      } }, Qd = { model: function(qe, xe, ke) {
        const He = xe.getSource();
        if (!He.loaded())
          return;
        if (He.type === "vector" || He.type === "geojson")
          return void (ke.modelManager && ke.modelManager.upload(ke, He.type === "vector" ? qe.scope : ""));
        if (He.type === "batched-model" || He.type !== "model")
          return;
        const ir = He.getModels();
        for (const ar of ir)
          ar.upload(ke.context);
      }, raster: function(qe, xe, ke) {
        const He = xe.getSource();
        if (!(He instanceof Pl && He.loaded()))
          return;
        const ir = qe.sourceLayer || He.rasterLayerIds && He.rasterLayerIds[0];
        if (!ir)
          return;
        const ar = qe.paint.get("raster-array-band") || He.getInitialBand(ir);
        if (ar == null)
          return;
        const yr = xe.getIds().map((Tr) => xe.getTileByID(Tr));
        for (const Tr of yr)
          Tr.updateNeeded(ir, ar) && He.prepareTile(Tr, ir, ar);
      }, "raster-particle": function(qe, xe, ke) {
        const He = xe.getSource();
        if (!(He instanceof Pl && He.loaded()))
          return;
        const ir = qe.sourceLayer || He.rasterLayerIds && He.rasterLayerIds[0];
        if (!ir)
          return;
        const ar = qe.paint.get("raster-particle-array-band") || He.getInitialBand(ir);
        if (ar == null)
          return;
        const yr = xe.getIds().map((Tr) => xe.getTileByID(Tr));
        for (const Tr of yr)
          Tr.updateNeeded(ir, ar) && He.prepareTile(Tr, ir, ar);
      } };
      class ef {
        constructor(xe, ke, He, ir, ar) {
          this.context = new kl(xe, ke), this.transform = He, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.tp = ar, this._timeStamp = ne.q.now(), this._averageFPS = 0, this._fpsHistory = [], this._dt = 0, this._debugParams = { forceEnablePrecipitation: !1, showTerrainProxyTiles: !1, fpsWindow: 30, continousRedraw: !1, enabledLayers: {} };
          const yr = ["fill", "line", "symbol", "circle", "heatmap", "fill-extrusion", "raster", "raster-particle", "hillshade", "model", "background", "sky"];
          for (const $r of yr)
            this._debugParams.enabledLayers[$r] = !0;
          ar.registerParameter(this._debugParams, ["Terrain"], "showTerrainProxyTiles", {}, () => {
            this.style.map.triggerRepaint();
          }), ar.registerParameter(this._debugParams, ["Precipitation"], "forceEnablePrecipitation"), ar.registerParameter(this._debugParams, ["FPS"], "fpsWindow", { min: 1, max: 100, step: 1 }), ar.registerBinding(this._debugParams, ["FPS"], "continousRedraw", { readonly: !0, label: "continuous redraw" }), ar.registerBinding(this, ["FPS"], "_averageFPS", { readonly: !0, label: "value" }), ar.registerBinding(this, ["FPS"], "_averageFPS", { readonly: !0, label: "graph", view: "graph", min: 0, max: 200 });
          for (const $r of yr)
            ar.registerParameter(this._debugParams.enabledLayers, ["Debug", "Layers"], $r);
          this.occlusionParams = new Wp(ar), this.setup(), this.numSublayers = Kl.maxUnderzooming + Kl.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {}, this.conflationActive = !1, this.replacementSource = new ne.dv(), this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = !1, this._cachedTileFogOpacities = {}, this._shadowRenderer = new su(this), this._wireframeDebugCache = new Qf(), this.renderDefaultNorthPole = !0, this.renderDefaultSouthPole = !0, this.layersWithOcclusionOpacity = [];
          const Tr = new ne.r({ width: 1, height: 1 }, Uint8Array.of(0, 0, 0, 0));
          this.emptyDepthTexture = new ne.T(this.context, Tr, xe.RGBA8), this._clippingActiveLastFrame = !1, this.scaleFactor = ir;
        }
        updateTerrain(xe, ke) {
          const He = !!xe && !!xe.terrain && this.transform.projection.supportsTerrain;
          if (!(He || this._terrain && this._terrain.enabled))
            return;
          this._terrain || (this._terrain = new Nf(this, xe));
          const ir = this._terrain;
          this.transform.elevation = He ? ir : null, ir.update(xe, this.transform, ke), this.transform.elevation && !ir.enabled && (this.transform.elevation = null);
        }
        _updateFog(xe) {
          const ke = xe.fog;
          if (!ke || this.transform.projection.name === "globe" || ke.getOpacity(this.transform.pitch) < 1 || ke.properties.get("horizon-blend") < 0.03)
            return void (this.transform.fogCullDistSq = null);
          const [He, ir] = ke.getFovAdjustedRange(this.transform._fov);
          if (He > ir)
            return void (this.transform.fogCullDistSq = null);
          const ar = He + 0.78 * (ir - He);
          this.transform.fogCullDistSq = ar * ar;
        }
        get terrain() {
          return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled || this._forceTerrainMode ? this._terrain : null;
        }
        get forceTerrainMode() {
          return this._forceTerrainMode;
        }
        set forceTerrainMode(xe) {
          xe && !this._terrain && (this._terrain = new Nf(this, this.style)), this._forceTerrainMode = xe;
        }
        get shadowRenderer() {
          return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
        }
        get wireframeDebugCache() {
          return this._wireframeDebugCache;
        }
        resize(xe, ke) {
          if (this.width = xe * ne.q.devicePixelRatio, this.height = ke * ne.q.devicePixelRatio, this.context.viewport.set([0, 0, this.width, this.height]), this.style)
            for (const He of this.style.order)
              this.style._mergedLayers[He].resize();
        }
        setup() {
          const xe = this.context, ke = new ne.b4();
          ke.emplaceBack(0, 0), ke.emplaceBack(ne.ag, 0), ke.emplaceBack(0, ne.ag), ke.emplaceBack(ne.ag, ne.ag), this.tileExtentBuffer = xe.createVertexBuffer(ke, ne.b6.members), this.tileExtentSegments = ne.b7.simpleSegment(0, 0, 4, 2);
          const He = new ne.b4();
          He.emplaceBack(0, 0), He.emplaceBack(ne.ag, 0), He.emplaceBack(0, ne.ag), He.emplaceBack(ne.ag, ne.ag), this.debugBuffer = xe.createVertexBuffer(He, ne.b6.members), this.debugSegments = ne.b7.simpleSegment(0, 0, 4, 5);
          const ir = new ne.b4();
          ir.emplaceBack(-1, -1), ir.emplaceBack(1, -1), ir.emplaceBack(-1, 1), ir.emplaceBack(1, 1), this.viewportBuffer = xe.createVertexBuffer(ir, ne.b6.members), this.viewportSegments = ne.b7.simpleSegment(0, 0, 4, 2);
          const ar = new ne.aT();
          ar.emplaceBack(0, 0, 0, 0), ar.emplaceBack(ne.ag, 0, ne.ag, 0), ar.emplaceBack(0, ne.ag, 0, ne.ag), ar.emplaceBack(ne.ag, ne.ag, ne.ag, ne.ag), this.mercatorBoundsBuffer = xe.createVertexBuffer(ar, ne.b9.members), this.mercatorBoundsSegments = ne.b7.simpleSegment(0, 0, 4, 2);
          const yr = new ne.aU();
          yr.emplaceBack(0, 1, 2), yr.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = xe.createIndexBuffer(yr);
          const Tr = new ne.b5();
          for (const Dr of [0, 1, 3, 2, 0])
            Tr.emplaceBack(Dr);
          this.debugIndexBuffer = xe.createIndexBuffer(Tr), this.emptyTexture = new ne.T(xe, new ne.r({ width: 1, height: 1 }, Uint8Array.of(0, 0, 0, 0)), xe.gl.RGBA8), this.identityMat = ne.ab.mat4.create();
          const $r = this.context.gl;
          this.stencilClearMode = new ta({ func: $r.ALWAYS, mask: 0 }, 0, 255, $r.ZERO, $r.ZERO, $r.ZERO), this.loadTimeStamps.push(performance.now());
        }
        getMercatorTileBoundsBuffers() {
          return { tileBoundsBuffer: this.mercatorBoundsBuffer, tileBoundsIndexBuffer: this.quadTriangleIndexBuffer, tileBoundsSegments: this.mercatorBoundsSegments };
        }
        getTileBoundsBuffers(xe) {
          return xe._makeTileBoundsBuffers(this.context, this.transform.projection), xe._tileBoundsBuffer ? { tileBoundsBuffer: xe._tileBoundsBuffer, tileBoundsIndexBuffer: xe._tileBoundsIndexBuffer, tileBoundsSegments: xe._tileBoundsSegments } : this.getMercatorTileBoundsBuffers();
        }
        clearStencil() {
          const xe = this.context.gl;
          this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.getOrCreateProgram("clippingMask").draw(this, xe.TRIANGLES, Oo.disabled, this.stencilClearMode, aa.disabled, Uo.disabled, Dd(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
        }
        resetStencilClippingMasks() {
          this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
        }
        _renderTileClippingMasks(xe, ke, He) {
          if (!ke || this.currentStencilSource === ke.id || !xe.isTileClipped() || !He || He.length === 0)
            return;
          if (this._tileClippingMaskIDs && !this.terrain) {
            let Tr = !1;
            for (const $r of He)
              if (this._tileClippingMaskIDs[$r.key] === void 0) {
                Tr = !0;
                break;
              }
            if (!Tr)
              return;
          }
          this.currentStencilSource = ke.id;
          const ir = this.context, ar = ir.gl;
          this.nextStencilID + He.length > 256 && this.clearStencil(), ir.setColorMode(aa.disabled), ir.setDepthMode(Oo.disabled);
          const yr = this.getOrCreateProgram("clippingMask");
          this._tileClippingMaskIDs = {};
          for (const Tr of He) {
            const $r = ke.getTile(Tr), Dr = this._tileClippingMaskIDs[Tr.key] = this.nextStencilID++, { tileBoundsBuffer: Or, tileBoundsIndexBuffer: Gr, tileBoundsSegments: qr } = this.getTileBoundsBuffers($r);
            yr.draw(this, ar.TRIANGLES, Oo.disabled, new ta({ func: ar.ALWAYS, mask: 0 }, Dr, 255, ar.KEEP, ar.KEEP, ar.REPLACE), aa.disabled, Uo.disabled, Dd(Tr.projMatrix), "$clipping", Or, Gr, qr);
          }
        }
        stencilModeFor3D() {
          this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
          const xe = this.nextStencilID++, ke = this.context.gl;
          return new ta({ func: ke.NOTEQUAL, mask: 255 }, xe, 255, ke.KEEP, ke.KEEP, ke.REPLACE);
        }
        stencilModeForClipping(xe) {
          if (this.terrain)
            return this.terrain.stencilModeForRTTOverlap(xe);
          const ke = this.context.gl;
          return new ta({ func: ke.EQUAL, mask: 255 }, this._tileClippingMaskIDs[xe.key], 0, ke.KEEP, ke.KEEP, ke.REPLACE);
        }
        stencilConfigForOverlap(xe) {
          const ke = this.context.gl, He = xe.sort((yr, Tr) => Tr.overscaledZ - yr.overscaledZ), ir = He[He.length - 1].overscaledZ, ar = He[0].overscaledZ - ir + 1;
          if (ar > 1) {
            this.currentStencilSource = void 0, this.nextStencilID + ar > 256 && this.clearStencil();
            const yr = {};
            for (let Tr = 0; Tr < ar; Tr++)
              yr[Tr + ir] = new ta({ func: ke.GEQUAL, mask: 255 }, Tr + this.nextStencilID, 255, ke.KEEP, ke.KEEP, ke.REPLACE);
            return this.nextStencilID += ar, [yr, He];
          }
          return [{ [ir]: ta.disabled }, He];
        }
        colorModeForRenderPass() {
          const xe = this.context.gl;
          return this._showOverdrawInspector ? new aa([xe.CONSTANT_COLOR, xe.ONE, xe.CONSTANT_COLOR, xe.ONE], new ne.aj(0.125, 0.125, 0.125, 0), [!0, !0, !0, !0]) : this.renderPass === "opaque" ? aa.unblended : aa.alphaBlended;
        }
        colorModeForDrapableLayerRenderPass(xe) {
          const ke = this.context.gl;
          return (() => this.style && this.style.enable3dLights() && this.terrain && this.terrain.renderingToTexture)() && this.renderPass === "translucent" ? new aa([ke.ONE, ke.ONE_MINUS_SRC_ALPHA, ke.CONSTANT_ALPHA, ke.ONE_MINUS_SRC_ALPHA], new ne.aj(0, 0, 0, xe === void 0 ? 0 : xe), [!0, !0, !0, !0]) : this.colorModeForRenderPass();
        }
        depthModeForSublayer(xe, ke, He, ir = !1) {
          if (this.depthOcclusion)
            return new Oo(this.context.gl.GREATER, Oo.ReadOnly, this.depthRangeFor3D);
          if (!this.opaquePassEnabledForLayer() && !ir)
            return Oo.disabled;
          const ar = 1 - ((1 + this.currentLayer) * this.numSublayers + xe) * this.depthEpsilon;
          return new Oo(He || this.context.gl.LEQUAL, ke, [ar, ar]);
        }
        opaquePassEnabledForLayer() {
          return this.currentLayer < this.opaquePassCutoff;
        }
        blitDepth() {
          const xe = this.context.gl, ke = Math.ceil(this.width), He = Math.ceil(this.height), ir = this.context.bindFramebuffer.get(), ar = xe.getParameter(xe.TEXTURE_BINDING_2D);
          this.depthFBO && this.depthFBO.width === ke && this.depthFBO.height === He || (this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), ke !== 0 && He !== 0 && (this.depthFBO = new jd(this.context, ke, He, !1, "texture"), this.depthTexture = new ne.T(this.context, { width: ke, height: He, data: null }, xe.DEPTH24_STENCIL8), this.depthFBO.depthAttachment.set(this.depthTexture.texture))), this.context.bindFramebuffer.set(ir), xe.bindTexture(xe.TEXTURE_2D, ar), this.depthFBO && (xe.bindFramebuffer(xe.READ_FRAMEBUFFER, null), xe.bindFramebuffer(xe.DRAW_FRAMEBUFFER, this.depthFBO.framebuffer), xe.blitFramebuffer(0, 0, ke, He, 0, 0, ke, He, xe.DEPTH_BUFFER_BIT, xe.NEAREST), xe.bindFramebuffer(xe.FRAMEBUFFER, this.context.bindFramebuffer.current));
        }
        updateAverageFPS() {
          this._fpsHistory.push(this._dt === 0 ? 0 : 1e3 / this._dt), this._fpsHistory.length > this._debugParams.fpsWindow && this._fpsHistory.splice(0, this._fpsHistory.length - this._debugParams.fpsWindow), this._averageFPS = Math.round(this._fpsHistory.reduce((xe, ke) => xe + ke / this._fpsHistory.length, 0));
        }
        render(xe, ke) {
          const He = ne.q.now();
          this._dt = He - this._timeStamp, this._timeStamp = He, this._wireframeDebugCache.update(this.frameCounter), this._debugParams.continousRedraw = xe.map.repaint, this.style = xe, this.options = ke;
          const ir = this.style._mergedLayers, ar = this.style._getOrder(!(!this.terrain || !this.terrain.enabled)).filter((hn) => {
            const xn = ir[hn];
            return !(xn.type in this._debugParams.enabledLayers) || this._debugParams.enabledLayers[xn.type];
          });
          let yr = !1, Tr = !1;
          for (const hn of ar) {
            const xn = ir[hn];
            xn.type === "circle" && (yr = !0), xn.type === "symbol" && (xn.hasInitialOcclusionOpacityProperties ? Tr = !0 : yr = !0);
          }
          const $r = ar.map((hn) => ir[hn]), Dr = this.style._mergedSourceCaches;
          this.imageManager = xe.imageManager, this.modelManager = xe.modelManager, this.symbolFadeChange = xe.placement.symbolFadeChange(ne.q.now()), this.imageManager.beginFrame();
          let Or = 0, Gr = !1;
          for (const hn in Dr) {
            const xn = Dr[hn];
            xn.used && (xn.prepare(this.context), xn.getSource().usedInConflation && ++Or);
          }
          let qr = !1;
          for (const hn of $r)
            hn.isHidden(this.transform.zoom) || (hn.type === "clip" && (qr = !0), this.prepareLayer(hn));
          const Jr = {}, bi = {}, fi = {}, Mi = {}, Ei = {};
          for (const hn in Dr) {
            const xn = Dr[hn];
            Jr[hn] = xn.getVisibleCoordinates(), bi[hn] = Jr[hn].slice().reverse(), fi[hn] = xn.getVisibleCoordinates(!0).reverse(), Mi[hn] = xn.getShadowCasterCoordinates(), Ei[hn] = xn.sortCoordinatesByDistance(Jr[hn]);
          }
          const Ii = (hn) => {
            const xn = this.style.getLayerSourceCache(hn);
            return xn && xn.used ? xn.getSource() : null;
          };
          if (Or || qr || this._clippingActiveLastFrame) {
            const hn = [], xn = [];
            let Hn = 0;
            for (const io of $r)
              this.isSourceForClippingOrConflation(io, Ii(io)) && (hn.push(io), xn.push(Hn)), Hn++;
            if (hn && (qr || hn.length > 1) || this._clippingActiveLastFrame) {
              qr = !1;
              const io = [];
              for (let uo = 0; uo < hn.length; uo++) {
                const An = hn[uo], eo = xn[uo], On = this.style.getLayerSourceCache(An);
                if (!On || !On.used || !On.getSource().usedInConflation && An.type !== "clip")
                  continue;
                let ao = ne.dx, ro = ne.by.None;
                const Wn = [];
                let _o = !0;
                if (An.type === "clip") {
                  ao = eo;
                  for (const yo of An.layout.get("clip-layer-types"))
                    ro |= yo === "model" ? ne.by.Model : yo === "symbol" ? ne.by.Symbol : ne.by.FillExtrusion;
                  for (const yo of An.layout.get("clip-layer-scope"))
                    Wn.push(yo);
                  An.isHidden(this.transform.zoom) ? _o = !1 : qr = !0;
                }
                _o && io.push({ layer: An.fqid, cache: On, order: ao, clipMask: ro, clipScope: Wn });
              }
              this.replacementSource.setSources(io), Gr = !0;
            }
          }
          this._clippingActiveLastFrame = qr, Gr || this.replacementSource.clear(), this.conflationActive = Gr, this.minCutoffZoom = 0, this.longestCutoffRange = 0, this.opaquePassCutoff = 1 / 0, this._lastOcclusionLayer = -1, this.layersWithOcclusionOpacity = [];
          for (let hn = 0; hn < $r.length; hn++) {
            const xn = $r[hn], Hn = xn.cutoffRange();
            if (this.longestCutoffRange = Math.max(Hn, this.longestCutoffRange), Hn > 0) {
              const io = Ii(xn);
              io && (this.minCutoffZoom = Math.max(io.minzoom, this.minCutoffZoom)), xn.minzoom && (this.minCutoffZoom = Math.max(xn.minzoom, this.minCutoffZoom));
            }
            xn.is3D() && (this.opaquePassCutoff === 1 / 0 && (this.opaquePassCutoff = hn), this._lastOcclusionLayer = hn);
          }
          const Ni = this.style && this.style.fog;
          Ni ? (this._fogVisible = Ni.getOpacity(this.transform.pitch) !== 0, this._fogVisible && this.transform.projection.name !== "globe" && (this._fogVisible = Ni.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = !1, this._cachedTileFogOpacities = {}, this.terrain && (this.terrain.updateTileBinding(fi), this.opaquePassCutoff = 0);
          const zi = this._shadowRenderer;
          if (zi) {
            zi.updateShadowParameters(this.transform, this.style.directionalLight);
            for (const hn in Dr)
              for (const xn of Jr[hn]) {
                let Hn = { min: 0, max: 0 };
                this.terrain && (Hn = this.terrain.getMinMaxForTile(xn) || Hn), zi.addShadowReceiver(xn.toUnwrapped(), Hn.min, Hn.max);
              }
          }
          this.transform.projection.name !== "globe" || this.globeSharedBuffers || (this.globeSharedBuffers = new ne.dw(this.context)), this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new Wd(this)), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0);
          const Ki = this._debugParams.forceEnablePrecipitation || !(!this.style || !this.style.snow), Wi = this._debugParams.forceEnablePrecipitation || !(!this.style || !this.style.rain);
          if (Ki && !this._snow && (this._snow = new tp(this)), !Ki && this._snow && (this._snow.destroy(), delete this._snow), Wi && !this._rain && (this._rain = new ep(this)), !Wi && this._rain && (this._rain.destroy(), delete this._rain), this._snow && this._snow.update(this), this._rain && this._rain.update(this), !pi.has(this.context.gl))
            return;
          this.renderPass = "offscreen";
          for (const hn of $r) {
            const xn = xe.getLayerSourceCache(hn);
            if (!hn.hasOffscreenPass() || hn.isHidden(this.transform.zoom))
              continue;
            const Hn = xn ? bi[xn.id] : void 0;
            (hn.type === "custom" || hn.type === "raster" || hn.type === "raster-particle" || hn.isSky() || Hn && Hn.length) && this.renderLayer(this, xn, hn, Hn);
          }
          this.depthRangeFor3D = [0, 1 - ($r.length + 2) * this.numSublayers * this.depthEpsilon], this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, Mi)), this.context.bindFramebuffer.set(null), this.context.viewport.set([0, 0, this.width, this.height]);
          const Xi = this.transform.projection.name === "globe" || this.transform.isHorizonVisible(), Gi = (() => {
            if (ke.showOverdrawInspector)
              return ne.aj.black;
            const hn = this.style.fog;
            if (hn && this.transform.projection.supportsFog) {
              const xn = this.style.getLut(hn.scope);
              if (!Xi) {
                const Hn = hn.properties.get("color-use-theme") === "none", io = hn.properties.get("color").toRenderColor(Hn ? null : xn).toArray01();
                return new ne.aj(...io);
              }
              if (Xi) {
                const Hn = hn.properties.get("space-color-use-theme") === "none", io = hn.properties.get("space-color").toRenderColor(Hn ? null : xn).toArray01();
                return new ne.aj(...io);
              }
            }
            return ne.aj.transparent;
          })();
          if (this.context.clear({ color: Gi, depth: 1 }), this.clearStencil(), this._showOverdrawInspector = ke.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && Xi && this._atmosphere.drawStars(this, this.style.fog), !this.terrain)
            for (this.currentLayer = ar.length - 1; this.currentLayer >= 0; this.currentLayer--) {
              const hn = $r[this.currentLayer], xn = xe.getLayerSourceCache(hn);
              if (hn.isSky())
                continue;
              const Hn = xn ? (hn.is3D() ? Ei : bi)[xn.id] : void 0;
              this._renderTileClippingMasks(hn, xn, Hn), this.renderLayer(this, xn, hn, Hn);
            }
          if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && Xi && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || ne.ae(this.transform.zoom) > 0) && (this.transform.projection.name === "globe" || this.transform.isHorizonVisible()))
            for (this.currentLayer = 0; this.currentLayer < ar.length; this.currentLayer++) {
              const hn = $r[this.currentLayer], xn = xe.getLayerSourceCache(hn);
              hn.isSky() && this.renderLayer(this, xn, hn, xn ? bi[xn.id] : void 0);
            }
          function nn(hn, xn) {
            let Hn;
            return xn && (Hn = (hn.type === "symbol" ? fi : hn.is3D() ? Ei : bi)[xn.id]), Hn;
          }
          if (this.renderPass = "translucent", this.transform.projection.name === "globe") {
            for (this.renderElevatedRasterBackface = !0, this.currentLayer = 0; this.currentLayer < ar.length; ) {
              const hn = $r[this.currentLayer];
              if (hn.type === "raster" || hn.type === "raster-particle") {
                const xn = xe.getLayerSourceCache(hn);
                this.renderLayer(this, xn, hn, nn(hn, xn));
              }
              ++this.currentLayer;
            }
            this.renderElevatedRasterBackface = !1;
          }
          this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER;
          let dn = 0;
          zi && (dn = zi.getShadowCastingLayerCount());
          let Pn = !1, Ln = -1;
          for (let hn = 0; hn < ar.length; ++hn) {
            const xn = $r[hn];
            xn.isHidden(this.transform.zoom) || xn.is3D() && (Ln = hn);
          }
          for (Tr && Ln === -1 && (yr = !0); this.currentLayer < ar.length; ) {
            const hn = $r[this.currentLayer], xn = xe.getLayerSourceCache(hn);
            if (hn.isSky())
              ++this.currentLayer;
            else if (this.terrain && this.style.isLayerDraped(hn)) {
              if (hn.isHidden(this.transform.zoom)) {
                ++this.currentLayer;
                continue;
              }
              this.currentLayer = this.terrain.renderBatch(this.currentLayer), this._lastOcclusionLayer = Math.max(this.currentLayer, this._lastOcclusionLayer);
            } else {
              if (yr && !Pn && this.terrain && !this.transform.isOrthographic && (Pn = !0, this.blitDepth()), Tr && Ln !== -1 && this.currentLayer === Ln + 1 && !this.transform.isOrthographic && this.blitDepth(), hn.is3D() || this.terrain || this._renderTileClippingMasks(hn, xn, xn ? Jr[xn.id] : void 0), this.renderLayer(this, xn, hn, nn(hn, xn)), !this.terrain && zi && dn > 0 && hn.hasShadowPass() && --dn == 0 && (zi.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer)) {
                const Hn = this.currentLayer;
                for (this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= Hn; this.currentLayer++) {
                  const io = $r[this.currentLayer];
                  if (!io.hasLightBeamPass())
                    continue;
                  const uo = xe.getLayerSourceCache(io);
                  this.renderLayer(this, uo, io, uo ? bi[uo.id] : void 0);
                }
                this.currentLayer = Hn, this.renderPass = "translucent";
              }
              if (this.currentLayer >= this._lastOcclusionLayer && this.layersWithOcclusionOpacity.length > 0) {
                const Hn = this.currentLayer;
                this.depthOcclusion = !0;
                for (const io of this.layersWithOcclusionOpacity) {
                  this.currentLayer = io;
                  const uo = $r[this.currentLayer], An = xe.getLayerSourceCache(uo), eo = An ? bi[An.id] : void 0;
                  uo.is3D() || this.terrain || this._renderTileClippingMasks(uo, An, An ? Jr[An.id] : void 0), this.renderLayer(this, An, uo, eo);
                }
                this.depthOcclusion = !1, this.currentLayer = Hn, this.renderPass = "translucent", this.layersWithOcclusionOpacity = [];
              }
              ++this.currentLayer;
            }
          }
          if (this.terrain && this.terrain.postRender(), this._snow && this._snow.draw(this), this._rain && this._rain.draw(this), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
            let hn = null;
            $r.forEach((xn) => {
              const Hn = xe.getLayerSourceCache(xn);
              Hn && !xn.isHidden(this.transform.zoom) && Hn.getVisibleCoordinates().length && (!hn || hn.getSource().maxzoom < Hn.getSource().maxzoom) && (hn = Hn);
            }), hn && this.options.showTileBoundaries && Lc.debug(this, hn, hn.getVisibleCoordinates(), ne.aj.red, !1, this.options.showParseStatus);
          }
          this.terrain && this._debugParams.showTerrainProxyTiles && Lc.debug(this, this.terrain.proxySourceCache, this.terrain.proxyCoords, new ne.aj(1, 0.8, 0.1, 1), !0, this.options.showParseStatus), this.options.showPadding && function(hn) {
            const xn = hn.transform.padding;
            Xf(hn, hn.transform.height - (xn.top || 0), 3, Zm), Xf(hn, xn.bottom || 0, 3, Xm), Gd(hn, xn.left || 0, 3, Qh), Gd(hn, hn.transform.width - (xn.right || 0), 3, ed);
            const Hn = hn.transform.centerPoint;
            (function(io, uo, An, eo) {
              td(io, uo - 1, An - 10, 2, 20, eo), td(io, uo - 10, An - 1, 20, 2, eo);
            })(hn, Hn.x, hn.transform.height - Hn.y, W0);
          }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(performance.now()), this.saveCanvasCopy()), Gr || (this.conflationActive = !1);
        }
        prepareLayer(xe) {
          this.gpuTimingStart(xe);
          const { unsupportedLayers: ke } = this.transform.projection, He = !ke || !ke.includes(xe.type);
          if (Qd[xe.type] && (He || this.terrain && xe.type === "custom")) {
            const ir = this.style.getLayerSourceCache(xe);
            Qd[xe.type](xe, ir, this);
          }
          this.gpuTimingEnd();
        }
        renderLayer(xe, ke, He, ir) {
          He.isHidden(this.transform.zoom) || (He.type === "background" || He.type === "sky" || He.type === "custom" || He.type === "model" || He.type === "raster" || He.type === "raster-particle" || ir && ir.length) && (this.id = He.id, this.gpuTimingStart(He), xe.transform.projection.unsupportedLayers && xe.transform.projection.unsupportedLayers.includes(He.type) && (!xe.terrain || He.type !== "custom") || He.type === "clip" || Lc[He.type](xe, ke, He, ir, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
        }
        gpuTimingStart(xe) {
          if (!this.options.gpuTiming)
            return;
          const ke = this.context.extTimerQuery, He = this.context.gl;
          let ir = this.gpuTimers[xe.id];
          ir || (ir = this.gpuTimers[xe.id] = { calls: 0, cpuTime: 0, query: He.createQuery() }), ir.calls++, He.beginQuery(ke.TIME_ELAPSED_EXT, ir.query);
        }
        gpuTimingDeferredRenderStart() {
          if (this.options.gpuTimingDeferredRender) {
            const xe = this.context.extTimerQuery, ke = this.context.gl, He = ke.createQuery();
            this.deferredRenderGpuTimeQueries.push(He), ke.beginQuery(xe.TIME_ELAPSED_EXT, He);
          }
        }
        gpuTimingDeferredRenderEnd() {
          this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
        }
        gpuTimingEnd() {
          this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
        }
        collectGpuTimers() {
          const xe = this.gpuTimers;
          return this.gpuTimers = {}, xe;
        }
        collectDeferredRenderGpuQueries() {
          const xe = this.deferredRenderGpuTimeQueries;
          return this.deferredRenderGpuTimeQueries = [], xe;
        }
        queryGpuTimers(xe) {
          const ke = {};
          for (const He in xe) {
            const ir = xe[He], ar = this.context.extTimerQuery, yr = ar.getQueryParameter(ir.query, this.context.gl.QUERY_RESULT) / 1e6;
            ar.deleteQueryEXT(ir.query), ke[He] = yr;
          }
          return ke;
        }
        queryGpuTimeDeferredRender(xe) {
          if (!this.options.gpuTimingDeferredRender)
            return 0;
          const ke = this.context.gl;
          let He = 0;
          for (const ir of xe)
            He += ke.getQueryParameter(ir, ke.QUERY_RESULT) / 1e6, ke.deleteQuery(ir);
          return He;
        }
        translatePosMatrix(xe, ke, He, ir, ar) {
          if (!He[0] && !He[1])
            return xe;
          const yr = ar ? ir === "map" ? this.transform.angle : 0 : ir === "viewport" ? -this.transform.angle : 0;
          if (yr) {
            const Dr = Math.sin(yr), Or = Math.cos(yr);
            He = [He[0] * Or - He[1] * Dr, He[0] * Dr + He[1] * Or];
          }
          const Tr = [ar ? He[0] : ne.ar(ke, He[0], this.transform.zoom), ar ? He[1] : ne.ar(ke, He[1], this.transform.zoom), 0], $r = new Float32Array(16);
          return ne.ab.mat4.translate($r, xe, Tr), $r;
        }
        saveTileTexture(xe) {
          const ke = xe.size[0], He = this._tileTextures[ke];
          He ? He.push(xe) : this._tileTextures[ke] = [xe];
        }
        getTileTexture(xe) {
          const ke = this._tileTextures[xe];
          return ke && ke.length > 0 ? ke.pop() : null;
        }
        terrainRenderModeElevated() {
          return this.style && !!this.style.getTerrain() && !!this.terrain && !this.terrain.renderingToTexture || this.forceTerrainMode;
        }
        linearFloatFilteringSupported() {
          return this.context.extTextureFloatLinear != null;
        }
        currentGlobalDefines(xe, ke, He) {
          const ir = He === void 0 ? this.terrain && this.terrain.renderingToTexture : He, ar = [];
          return this.style && this.style.enable3dLights() && (xe === "globeRaster" || xe === "terrainRaster" ? (ar.push("LIGHTING_3D_MODE"), ar.push("LIGHTING_3D_ALPHA_EMISSIVENESS")) : ir || ar.push("LIGHTING_3D_MODE")), this.renderPass === "shadow" && (this._shadowMapDebug || ar.push("DEPTH_TEXTURE")), this.terrainRenderModeElevated() && (ar.push("TERRAIN"), this.linearFloatFilteringSupported() && ar.push("TERRAIN_DEM_FLOAT_FORMAT")), this.transform.projection.name === "globe" && ar.push("GLOBE"), !this._fogVisible || ir || ke !== void 0 && !ke || ar.push("FOG", "FOG_DITHERING"), ir && ar.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && ar.push("OVERDRAW_INSPECTOR"), ar;
        }
        getOrCreateProgram(xe, ke) {
          this.cache = this.cache || {};
          const He = ke && ke.defines || [], ir = ke && ke.config, ar = this.currentGlobalDefines(xe, ke && ke.overrideFog, ke && ke.overrideRtt).concat(He), yr = Um.cacheKey(Bp[xe], xe, ar, ir);
          return this.cache[yr] || (this.cache[yr] = new Um(this.context, xe, Bp[xe], ir, jp[xe], ar)), this.cache[yr];
        }
        setCustomLayerDefaults() {
          this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
        }
        setBaseState() {
          const xe = this.context.gl;
          this.context.cullFace.set(!1), this.context.viewport.set([0, 0, this.width, this.height]), this.context.blendEquation.set(xe.FUNC_ADD);
        }
        initDebugOverlayCanvas() {
          this.debugOverlayCanvas == null && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new ne.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA8));
        }
        destroy() {
          this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy(), this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), this.emptyDepthTexture && this.emptyDepthTexture.destroy();
        }
        prepareDrawTile() {
          this.terrain && this.terrain.prepareDrawTile();
        }
        uploadCommonLightUniforms(xe, ke) {
          if (this.style.enable3dLights()) {
            const He = this.style.directionalLight, ir = this.style.ambientLight;
            if (He && ir) {
              const ar = ((yr, Tr, $r) => {
                const Dr = yr.properties.get("direction"), Or = yr.properties.get("color-use-theme") === "none", Gr = yr.properties.get("color").toRenderColor(Or ? null : $r.getLut(yr.scope)).toArray01(), qr = yr.properties.get("intensity"), Jr = Tr.properties.get("color-use-theme") === "none", bi = Tr.properties.get("color").toRenderColor(Jr ? null : $r.getLut(Tr.scope)).toArray01(), fi = Tr.properties.get("intensity"), Mi = [Dr.x, Dr.y, Dr.z], Ei = ne.cM(bi, fi), Ii = ne.cM(Gr, qr);
                return { u_lighting_ambient_color: Ei, u_lighting_directional_dir: Mi, u_lighting_directional_color: Ii, u_ground_radiance: q0(Mi, Ii, Ei) };
              })(He, ir, this.style);
              ke.setLightsUniformValues(xe, ar);
            }
          }
        }
        uploadCommonUniforms(xe, ke, He, ir, ar) {
          if (this.uploadCommonLightUniforms(xe, ke), this.terrain && this.terrain.renderingToTexture)
            return;
          const yr = this.style.fog;
          if (yr) {
            const Tr = yr.getOpacity(this.transform.pitch), $r = ((Dr, Or, Gr, qr, Jr, bi, fi, Mi, Ei, Ii, Ni, zi) => {
              const Ki = Dr.transform, Wi = Or.properties.get("color-use-theme") === "none", Xi = Or.properties.get("color").toRenderColor(Wi ? null : Dr.style.getLut(Or.scope)).toArray01();
              Xi[3] = qr;
              const Gi = Dr.frameCounter / 1e3 % 1, [nn, dn] = Or.properties.get("vertical-range");
              return { u_fog_matrix: Gr ? Ki.calculateFogTileMatrix(Gr) : zi || Dr.identityMat, u_fog_range: Or.getFovAdjustedRange(Ki._fov), u_fog_color: Xi, u_fog_horizon_blend: Or.properties.get("horizon-blend"), u_fog_vertical_limit: [Math.min(nn, dn), dn], u_fog_temporal_offset: Gi, u_frustum_tl: Jr, u_frustum_tr: bi, u_frustum_br: fi, u_frustum_bl: Mi, u_globe_pos: Ei, u_globe_radius: Ii, u_viewport: Ni, u_globe_transition: ne.ae(Ki.zoom), u_is_globe: +(Ki.projection.name === "globe") };
            })(this, yr, He, Tr, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [this.transform.width * ne.q.devicePixelRatio, this.transform.height * ne.q.devicePixelRatio], ir);
            ke.setFogUniformValues(xe, $r);
          }
          ar && ke.setCutoffUniformValues(xe, ar.uniformValues);
        }
        setTileLoadedFlag(xe) {
          this.tileLoaded = xe;
        }
        saveCanvasCopy() {
          const xe = this.canvasCopy();
          xe && (this.frameCopies.push(xe), this.tileLoaded = !1);
        }
        canvasCopy() {
          const xe = this.context.gl, ke = xe.createTexture();
          return xe.bindTexture(xe.TEXTURE_2D, ke), xe.copyTexImage2D(xe.TEXTURE_2D, 0, xe.RGBA, 0, 0, xe.drawingBufferWidth, xe.drawingBufferHeight, 0), ke;
        }
        getCanvasCopiesAndTimestamps() {
          return { canvasCopies: this.frameCopies, timeStamps: this.loadTimeStamps };
        }
        averageElevationNeedsEasing() {
          if (!this.transform._elevation)
            return !1;
          const xe = this.style && this.style.fog;
          return !!xe && xe.getOpacity(this.transform.pitch) !== 0;
        }
        getBackgroundTiles() {
          const xe = this._backgroundTiles, ke = this._backgroundTiles = {}, He = this.transform.coveringTiles({ tileSize: 512 });
          for (const ir of He)
            ke[ir.key] = xe[ir.key] || new Xl(ir, 512, this.transform.tileZoom, this);
          return ke;
        }
        clearBackgroundTiles() {
          this._backgroundTiles = {};
        }
        isSourceForClippingOrConflation(xe, ke) {
          return !(!xe.is3D() || xe.type !== "clip" && (xe.minzoom && xe.minzoom > this.transform.zoom || (this.style._clipLayerPresent || xe.sourceLayer !== "building") && (!ke || ke.type !== "batched-model")));
        }
        isTileAffectedByFog(xe) {
          if (!this.style || !this.style.fog)
            return !1;
          if (this.transform.projection.name === "globe")
            return !0;
          let ke = this._cachedTileFogOpacities[xe.key];
          return ke || (this._cachedTileFogOpacities[xe.key] = ke = this.style.fog.getOpacityForTile(xe)), ke[0] >= Tn || ke[1] >= Tn;
        }
        setupDepthForOcclusion(xe, ke, He) {
          const ir = this.context, ar = ir.gl, yr = !!He;
          var Tr;
          He || (He = { u_dem: 2, u_dem_prev: 4, u_dem_tl: [0, 0], u_dem_tl_prev: [0, 0], u_dem_scale: 0, u_dem_scale_prev: 0, u_dem_size: 0, u_dem_lerp: 1, u_depth: 3, u_depth_size_inv: [0, 0], u_depth_range_unpack: [0, 1], u_occluder_half_size: 16, u_occlusion_depth_offset: -1e-4, u_exaggeration: 0 }), ir.activeTexture.set(ar.TEXTURE3), xe && this.depthFBO && this.depthTexture ? (this.depthTexture.bind(ar.NEAREST, ar.CLAMP_TO_EDGE), He.u_depth_size_inv = [1 / this.depthFBO.width, 1 / this.depthFBO.height], He.u_depth_range_unpack = [2 / ((Tr = this.depthRangeFor3D)[1] - Tr[0]), -1 - 2 * Tr[0] / (Tr[1] - Tr[0])], He.u_occluder_half_size = 0.5 * this.occlusionParams.occluderSize, He.u_occlusion_depth_offset = this.occlusionParams.depthOffset) : this.emptyDepthTexture.bind(ar.NEAREST, ar.CLAMP_TO_EDGE), ir.activeTexture.set(ar.TEXTURE0), yr || ke.setTerrainUniformValues(ir, He);
        }
      }
      function od(qe, xe) {
        let ke = !1, He = null;
        const ir = () => {
          He = null, ke && (qe(), He = setTimeout(ir, xe), ke = !1);
        };
        return () => (ke = !0, He || ir(), He);
      }
      class Ic {
        constructor(xe) {
          this._hashName = xe && encodeURIComponent(xe), ne.aP(["_getCurrentHash", "_onHashChange", "_updateHash"], this), this._updateHash = od(this._updateHashUnthrottled.bind(this), 300);
        }
        addTo(xe) {
          return this._map = xe, window.addEventListener("hashchange", this._onHashChange, !1), xe.on("moveend", this._updateHash), this;
        }
        remove() {
          return this._map ? (this._map.off("moveend", this._updateHash), window.removeEventListener("hashchange", this._onHashChange, !1), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
        }
        getHashString() {
          const xe = this._map;
          if (!xe)
            return "";
          const ke = rp(xe);
          if (this._hashName) {
            const He = this._hashName;
            let ir = !1;
            const ar = location.hash.slice(1).split("&").map((yr) => {
              const Tr = yr.split("=")[0];
              return Tr === He ? (ir = !0, `${Tr}=${ke}`) : yr;
            }).filter((yr) => yr);
            return ir || ar.push(`${He}=${ke}`), `#${ar.join("&")}`;
          }
          return `#${ke}`;
        }
        _getCurrentHash() {
          const xe = location.hash.replace("#", "");
          if (this._hashName) {
            let ke;
            return xe.split("&").map((He) => He.split("=")).forEach((He) => {
              He[0] === this._hashName && (ke = He);
            }), (ke && ke[1] || "").split("/");
          }
          return xe.split("/");
        }
        _onHashChange() {
          const xe = this._map;
          if (!xe)
            return !1;
          const ke = this._getCurrentHash();
          if (ke.length >= 3 && !ke.some((He) => isNaN(He))) {
            const He = xe.dragRotate.isEnabled() && xe.touchZoomRotate.isEnabled() ? +(ke[3] || 0) : xe.getBearing();
            return xe.jumpTo({ center: [+ke[2], +ke[1]], zoom: +ke[0], bearing: He, pitch: +(ke[4] || 0) }), !0;
          }
          return !1;
        }
        _updateHashUnthrottled() {
          history.replaceState(history.state, "", location.href.replace(/(#.+)?$/, this.getHashString()));
        }
      }
      function rp(qe, xe) {
        const ke = qe.getCenter(), He = Math.round(100 * qe.getZoom()) / 100, ir = Math.ceil((He * Math.LN2 + Math.log(512 / 360 / 0.5)) / Math.LN10), ar = Math.pow(10, ir), yr = Math.round(ke.lng * ar) / ar, Tr = Math.round(ke.lat * ar) / ar, $r = qe.getBearing(), Dr = qe.getPitch();
        let Or = xe ? `/${yr}/${Tr}/${He}` : `${He}/${Tr}/${yr}`;
        return ($r || Dr) && (Or += "/" + Math.round(10 * $r) / 10), Dr && (Or += `/${Math.round(Dr)}`), Or;
      }
      const rc = { linearity: 0.3, easing: ne.dy(0, 0, 0.3, 1) }, Zp = ne.l({ deceleration: 2500, maxSpeed: 1400 }, rc), Xp = ne.l({ deceleration: 20, maxSpeed: 1400 }, rc), ip = ne.l({ deceleration: 1e3, maxSpeed: 360 }, rc), Jm = ne.l({ deceleration: 1e3, maxSpeed: 90 }, rc);
      class Qm {
        constructor(xe) {
          this._map = xe, this.clear();
        }
        clear() {
          this._inertiaBuffer = [];
        }
        record(xe) {
          this._drainInertiaBuffer(), this._inertiaBuffer.push({ time: ne.q.now(), settings: xe });
        }
        _drainInertiaBuffer() {
          const xe = this._inertiaBuffer, ke = ne.q.now();
          for (; xe.length > 0 && ke - xe[0].time > 160; )
            xe.shift();
        }
        _onMoveEnd(xe) {
          if (this._map._prefersReducedMotion() || (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2))
            return;
          const ke = { zoom: 0, bearing: 0, pitch: 0, pan: new ne.P(0, 0), pinchAround: void 0, around: void 0 };
          for (const { settings: ar } of this._inertiaBuffer)
            ke.zoom += ar.zoomDelta || 0, ke.bearing += ar.bearingDelta || 0, ke.pitch += ar.pitchDelta || 0, ar.panDelta && ke.pan._add(ar.panDelta), ar.around && (ke.around = ar.around), ar.pinchAround && (ke.pinchAround = ar.pinchAround);
          const He = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, ir = {};
          if (ke.pan.mag()) {
            const ar = ad(ke.pan.mag(), He, ne.l({}, Zp, xe || {}));
            ir.offset = ke.pan.mult(ar.amount / ke.pan.mag()), ir.center = this._map.transform.center, tf(ir, ar);
          }
          if (ke.zoom) {
            const ar = ad(ke.zoom, He, Xp);
            ir.zoom = this._map.transform.zoom + ar.amount, tf(ir, ar);
          }
          if (ke.bearing) {
            const ar = ad(ke.bearing, He, ip);
            ir.bearing = this._map.transform.bearing + ne.aw(ar.amount, -179, 179), tf(ir, ar);
          }
          if (ke.pitch) {
            const ar = ad(ke.pitch, He, Jm);
            ir.pitch = this._map.transform.pitch + ar.amount, tf(ir, ar);
          }
          if (ir.zoom || ir.bearing) {
            const ar = ke.pinchAround === void 0 ? ke.around : ke.pinchAround;
            ir.around = ar ? this._map.unproject(ar) : this._map.getCenter();
          }
          return this.clear(), ir.noMoveStart = !0, ir;
        }
      }
      function tf(qe, xe) {
        (!qe.duration || qe.duration < xe.duration) && (qe.duration = xe.duration, qe.easing = xe.easing);
      }
      function ad(qe, xe, ke) {
        const { maxSpeed: He, linearity: ir, deceleration: ar } = ke, yr = ne.aw(qe * ir / (xe / 1e3), -He, He), Tr = Math.abs(yr) / (ar * ir);
        return { easing: ke.easing, duration: 1e3 * Tr, amount: yr * (Tr / 2) };
      }
      class Bl extends ne.z {
        preventDefault() {
          this._defaultPrevented = !0;
        }
        get defaultPrevented() {
          return this._defaultPrevented;
        }
        constructor(xe, ke, He, ir = {}) {
          const ar = di(ke.getCanvasContainer(), He), yr = ke.unproject(ar);
          super(xe, ne.l({ point: ar, lngLat: yr, originalEvent: He }, ir)), this._defaultPrevented = !1, this.target = ke;
        }
      }
      class rf extends ne.z {
        preventDefault() {
          this._defaultPrevented = !0;
        }
        get defaultPrevented() {
          return this._defaultPrevented;
        }
        constructor(xe, ke, He) {
          const ir = xe === "touchend" ? He.changedTouches : He.touches, ar = oi(ke.getCanvasContainer(), ir), yr = ar.map(($r) => ke.unproject($r)), Tr = ar.reduce(($r, Dr, Or, Gr) => $r.add(Dr.div(Gr.length)), new ne.P(0, 0));
          super(xe, { points: ar, point: Tr, lngLats: yr, lngLat: ke.unproject(Tr), originalEvent: He }), this._defaultPrevented = !1;
        }
      }
      class Kp extends ne.z {
        preventDefault() {
          this._defaultPrevented = !0;
        }
        get defaultPrevented() {
          return this._defaultPrevented;
        }
        constructor(xe, ke) {
          super("wheel", { originalEvent: ke }), this._defaultPrevented = !1;
        }
      }
      class Yp {
        constructor(xe, ke) {
          this._map = xe, this._clickTolerance = ke.clickTolerance;
        }
        reset() {
          this._mousedownPos = void 0;
        }
        wheel(xe) {
          return this._firePreventable(new Kp(this._map, xe));
        }
        mousedown(xe, ke) {
          return this._mousedownPos = ke, this._firePreventable(new Bl(xe.type, this._map, xe));
        }
        mouseup(xe) {
          this._map.fire(new Bl(xe.type, this._map, xe));
        }
        preclick(xe) {
          const ke = ne.l({}, xe);
          ke.type = "preclick", this._map.fire(new Bl(ke.type, this._map, ke));
        }
        click(xe, ke) {
          this._mousedownPos && this._mousedownPos.dist(ke) >= this._clickTolerance || (this.preclick(xe), this._map.fire(new Bl(xe.type, this._map, xe)));
        }
        dblclick(xe) {
          return this._firePreventable(new Bl(xe.type, this._map, xe));
        }
        mouseover(xe) {
          this._map.fire(new Bl(xe.type, this._map, xe));
        }
        mouseout(xe) {
          this._map.fire(new Bl(xe.type, this._map, xe));
        }
        touchstart(xe) {
          return this._firePreventable(new rf(xe.type, this._map, xe));
        }
        touchmove(xe) {
          this._map.fire(new rf(xe.type, this._map, xe));
        }
        touchend(xe) {
          this._map.fire(new rf(xe.type, this._map, xe));
        }
        touchcancel(xe) {
          this._map.fire(new rf(xe.type, this._map, xe));
        }
        _firePreventable(xe) {
          if (this._map.fire(xe), xe.defaultPrevented)
            return {};
        }
        isEnabled() {
          return !0;
        }
        isActive() {
          return !1;
        }
        enable() {
        }
        disable() {
        }
      }
      class $l {
        constructor(xe) {
          this._map = xe;
        }
        reset() {
          this._delayContextMenu = !1, this._contextMenuEvent = void 0;
        }
        mousemove(xe) {
          this._map.fire(new Bl(xe.type, this._map, xe));
        }
        mousedown() {
          this._delayContextMenu = !0;
        }
        mouseup() {
          this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new Bl("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
        }
        contextmenu(xe) {
          this._delayContextMenu ? this._contextMenuEvent = xe : this._map.fire(new Bl(xe.type, this._map, xe)), this._map.listens("contextmenu") && xe.preventDefault();
        }
        isEnabled() {
          return !0;
        }
        isActive() {
          return !1;
        }
        enable() {
        }
        disable() {
        }
      }
      class Bc {
        constructor(xe, ke) {
          this._map = xe, this._el = xe.getCanvasContainer(), this._container = xe.getContainer(), this._clickTolerance = ke.clickTolerance || 1;
        }
        isEnabled() {
          return !!this._enabled;
        }
        isActive() {
          return !!this._active;
        }
        enable() {
          this.isEnabled() || (this._enabled = !0);
        }
        disable() {
          this.isEnabled() && (this._enabled = !1);
        }
        mousedown(xe, ke) {
          this.isEnabled() && xe.shiftKey && xe.button === 0 && (Wr(), this._startPos = this._lastPos = ke, this._active = !0);
        }
        mousemoveWindow(xe, ke) {
          if (!this._active)
            return;
          const He = ke, ir = this._startPos, ar = this._lastPos;
          if (!ir || !ar || ar.equals(He) || !this._box && He.dist(ir) < this._clickTolerance)
            return;
          this._lastPos = He, this._box || (this._box = Rr("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", xe));
          const yr = Math.min(ir.x, He.x), Tr = Math.max(ir.x, He.x), $r = Math.min(ir.y, He.y), Dr = Math.max(ir.y, He.y);
          this._map._requestDomTask(() => {
            this._box && (this._box.style.transform = `translate(${yr}px,${$r}px)`, this._box.style.width = Tr - yr + "px", this._box.style.height = Dr - $r + "px");
          });
        }
        mouseupWindow(xe, ke) {
          if (!this._active)
            return;
          const He = this._startPos, ir = ke;
          if (He && xe.button === 0) {
            if (this.reset(), xi(), He.x !== ir.x || He.y !== ir.y)
              return this._map.fire(new ne.z("boxzoomend", { originalEvent: xe })), { cameraAnimation: (ar) => ar.fitScreenCoordinates(He, ir, this._map.getBearing(), { linear: !1 }) };
            this._fireEvent("boxzoomcancel", xe);
          }
        }
        keydown(xe) {
          this._active && xe.keyCode === 27 && (this.reset(), this._fireEvent("boxzoomcancel", xe));
        }
        blur() {
          this.reset();
        }
        reset() {
          this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), si(), delete this._startPos, delete this._lastPos;
        }
        _fireEvent(xe, ke) {
          return this._map.fire(new ne.z(xe, { originalEvent: ke }));
        }
      }
      function Jp(qe, xe) {
        const ke = {};
        for (let He = 0; He < qe.length; He++)
          ke[qe[He].identifier] = xe[He];
        return ke;
      }
      class Z0 {
        constructor(xe) {
          this.reset(), this.numTouches = xe.numTouches;
        }
        reset() {
          this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = !1;
        }
        touchstart(xe, ke, He) {
          (this.centroid || He.length > this.numTouches) && (this.aborted = !0), this.aborted || (this.startTime === 0 && (this.startTime = xe.timeStamp), He.length === this.numTouches && (this.centroid = function(ir) {
            const ar = new ne.P(0, 0);
            for (const yr of ir)
              ar._add(yr);
            return ar.div(ir.length);
          }(ke), this.touches = Jp(He, ke)));
        }
        touchmove(xe, ke, He) {
          if (this.aborted || !this.centroid)
            return;
          const ir = Jp(He, ke);
          for (const ar in this.touches) {
            const yr = ir[ar];
            (!yr || yr.dist(this.touches[ar]) > 30) && (this.aborted = !0);
          }
        }
        touchend(xe, ke, He) {
          if ((!this.centroid || xe.timeStamp - this.startTime > 500) && (this.aborted = !0), He.length === 0) {
            const ir = !this.aborted && this.centroid;
            if (this.reset(), ir)
              return ir;
          }
        }
      }
      class fs {
        constructor(xe) {
          this.singleTap = new Z0(xe), this.numTaps = xe.numTaps, this.reset();
        }
        reset() {
          this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
        }
        touchstart(xe, ke, He) {
          this.singleTap.touchstart(xe, ke, He);
        }
        touchmove(xe, ke, He) {
          this.singleTap.touchmove(xe, ke, He);
        }
        touchend(xe, ke, He) {
          const ir = this.singleTap.touchend(xe, ke, He);
          if (ir) {
            const ar = xe.timeStamp - this.lastTime < 500, yr = !this.lastTap || this.lastTap.dist(ir) < 30;
            if (ar && yr || this.reset(), this.count++, this.lastTime = xe.timeStamp, this.lastTap = ir, this.count === this.numTaps)
              return this.reset(), ir;
          }
        }
      }
      class vh {
        constructor() {
          this._zoomIn = new fs({ numTouches: 1, numTaps: 2 }), this._zoomOut = new fs({ numTouches: 2, numTaps: 1 }), this.reset();
        }
        reset() {
          this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
        }
        touchstart(xe, ke, He) {
          this._zoomIn.touchstart(xe, ke, He), this._zoomOut.touchstart(xe, ke, He);
        }
        touchmove(xe, ke, He) {
          this._zoomIn.touchmove(xe, ke, He), this._zoomOut.touchmove(xe, ke, He);
        }
        touchend(xe, ke, He) {
          const ir = this._zoomIn.touchend(xe, ke, He), ar = this._zoomOut.touchend(xe, ke, He);
          return ir ? (this._active = !0, xe.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (yr) => yr.easeTo({ duration: 300, zoom: yr.getZoom() + 1, around: yr.unproject(ir) }, { originalEvent: xe }) }) : ar ? (this._active = !0, xe.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (yr) => yr.easeTo({ duration: 300, zoom: yr.getZoom() - 1, around: yr.unproject(ar) }, { originalEvent: xe }) }) : void 0;
        }
        touchcancel() {
          this.reset();
        }
        enable() {
          this._enabled = !0;
        }
        disable() {
          this._enabled = !1, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      const e0 = { 0: 1, 2: 2 };
      class np {
        constructor(xe) {
          this.reset(), this._clickTolerance = xe.clickTolerance || 1;
        }
        blur() {
          this.reset();
        }
        reset() {
          this._active = !1, this._moved = !1, this._lastPoint = void 0, this._eventButton = void 0;
        }
        _correctButton(xe, ke) {
          return !1;
        }
        _move(xe, ke) {
          return {};
        }
        mousedown(xe, ke) {
          if (this._lastPoint)
            return;
          const He = ci(xe);
          this._correctButton(xe, He) && (this._lastPoint = ke, this._eventButton = He);
        }
        mousemoveWindow(xe, ke) {
          const He = this._lastPoint;
          if (He) {
            if (xe.preventDefault(), this._eventButton != null && function(ir, ar) {
              const yr = e0[ar];
              return ir.buttons === void 0 || (ir.buttons & yr) !== yr;
            }(xe, this._eventButton))
              this.reset();
            else if (this._moved || !(ke.dist(He) < this._clickTolerance))
              return this._moved = !0, this._lastPoint = ke, this._move(He, ke);
          }
        }
        mouseupWindow(xe) {
          this._lastPoint && ci(xe) === this._eventButton && (this._moved && xi(), this.reset());
        }
        enable() {
          this._enabled = !0;
        }
        disable() {
          this._enabled = !1, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      class nf extends np {
        mousedown(xe, ke) {
          super.mousedown(xe, ke), this._lastPoint && (this._active = !0);
        }
        _correctButton(xe, ke) {
          return ke === 0 && !xe.ctrlKey;
        }
        _move(xe, ke) {
          return { around: ke, panDelta: ke.sub(xe) };
        }
      }
      class op extends np {
        _correctButton(xe, ke) {
          return ke === 0 && xe.ctrlKey || ke === 2;
        }
        _move(xe, ke) {
          const He = 0.8 * (ke.x - xe.x);
          if (He)
            return this._active = !0, { bearingDelta: He };
        }
        contextmenu(xe) {
          xe.preventDefault();
        }
      }
      class uu extends np {
        _correctButton(xe, ke) {
          return ke === 0 && xe.ctrlKey || ke === 2;
        }
        _move(xe, ke) {
          const He = -0.5 * (ke.y - xe.y);
          if (He)
            return this._active = !0, { pitchDelta: He };
        }
        contextmenu(xe) {
          xe.preventDefault();
        }
      }
      class Pu {
        constructor(xe, ke) {
          this._map = xe, this._el = xe.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = ke.clickTolerance || 1, this.reset(), ne.aP(["_addTouchPanBlocker", "_showTouchPanBlockerAlert"], this);
        }
        reset() {
          this._active = !1, this._touches = {}, this._sum = new ne.P(0, 0);
        }
        touchstart(xe, ke, He) {
          return this._calculateTransform(xe, ke, He);
        }
        touchmove(xe, ke, He) {
          if (this._active && !(He.length < this._minTouches)) {
            if (this._map._cooperativeGestures && !this._map.isMoving()) {
              if (He.length === 1 && !ne.dz())
                return void this._showTouchPanBlockerAlert();
              this._alertContainer.style.visibility !== "hidden" && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
            }
            return xe.cancelable && xe.preventDefault(), this._calculateTransform(xe, ke, He);
          }
        }
        touchend(xe, ke, He) {
          this._calculateTransform(xe, ke, He), this._active && He.length < this._minTouches && this.reset();
        }
        touchcancel() {
          this.reset();
        }
        _calculateTransform(xe, ke, He) {
          He.length > 0 && (this._active = !0);
          const ir = Jp(He, ke), ar = new ne.P(0, 0), yr = new ne.P(0, 0);
          let Tr = 0;
          for (const Dr in ir) {
            const Or = ir[Dr], Gr = this._touches[Dr];
            Gr && (ar._add(Or), yr._add(Or.sub(Gr)), Tr++, ir[Dr] = Or);
          }
          if (this._touches = ir, Tr < this._minTouches || !yr.mag())
            return;
          const $r = yr.div(Tr);
          return this._sum._add($r), this._sum.mag() < this._clickTolerance ? void 0 : { around: ar.div(Tr), panDelta: $r };
        }
        enable() {
          this._enabled = !0, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
        }
        disable() {
          this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
        }
        isEnabled() {
          return !!this._enabled;
        }
        isActive() {
          return !!this._active;
        }
        _addTouchPanBlocker() {
          this._map && !this._alertContainer && (this._alertContainer = Rr("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(0.05 * this._el.clientWidth)))}px`);
        }
        _showTouchPanBlockerAlert() {
          this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(() => {
            this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.removeAttribute("role");
          }, 500);
        }
      }
      class $c {
        constructor() {
          this.reset();
        }
        reset() {
          this._active = !1, this._firstTwoTouches = void 0;
        }
        _start(xe) {
        }
        _move(xe, ke, He) {
          return {};
        }
        touchstart(xe, ke, He) {
          this._firstTwoTouches || He.length < 2 || (this._firstTwoTouches = [He[0].identifier, He[1].identifier], this._start([ke[0], ke[1]]));
        }
        touchmove(xe, ke, He) {
          const ir = this._firstTwoTouches;
          if (!ir)
            return;
          xe.preventDefault();
          const [ar, yr] = ir, Tr = Du(He, ke, ar), $r = Du(He, ke, yr);
          if (!Tr || !$r)
            return;
          const Dr = this._aroundCenter ? null : Tr.add($r).div(2);
          return this._move([Tr, $r], Dr, xe);
        }
        touchend(xe, ke, He) {
          if (!this._firstTwoTouches)
            return;
          const [ir, ar] = this._firstTwoTouches, yr = Du(He, ke, ir), Tr = Du(He, ke, ar);
          yr && Tr || (this._active && xi(), this.reset());
        }
        touchcancel() {
          this.reset();
        }
        enable(xe) {
          this._enabled = !0, this._aroundCenter = !!xe && xe.around === "center";
        }
        disable() {
          this._enabled = !1, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      function Du(qe, xe, ke) {
        for (let He = 0; He < qe.length; He++)
          if (qe[He].identifier === ke)
            return xe[He];
      }
      function Ss(qe, xe) {
        return Math.log(qe / xe) / Math.LN2;
      }
      class ic extends $c {
        reset() {
          super.reset(), this._distance = 0, this._startDistance = 0;
        }
        _start(xe) {
          this._startDistance = this._distance = xe[0].dist(xe[1]);
        }
        _move(xe, ke) {
          const He = this._distance;
          if (this._distance = xe[0].dist(xe[1]), this._active || !(Math.abs(Ss(this._distance, this._startDistance)) < 0.1))
            return this._active = !0, { zoomDelta: Ss(this._distance, He), pinchAround: ke };
        }
      }
      function of(qe, xe) {
        return 180 * qe.angleWith(xe) / Math.PI;
      }
      class _h extends $c {
        reset() {
          super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
        }
        _start(xe) {
          this._startVector = this._vector = xe[0].sub(xe[1]), this._minDiameter = xe[0].dist(xe[1]);
        }
        _move(xe, ke) {
          const He = this._vector;
          if (this._vector = xe[0].sub(xe[1]), He && (this._active || !this._isBelowThreshold(this._vector)))
            return this._active = !0, { bearingDelta: of(this._vector, He), pinchAround: ke };
        }
        _isBelowThreshold(xe) {
          this._minDiameter = Math.min(this._minDiameter, xe.mag());
          const ke = 25 / (Math.PI * this._minDiameter) * 360, He = this._startVector;
          if (!He)
            return !1;
          const ir = of(xe, He);
          return Math.abs(ir) < ke;
        }
      }
      function sd(qe) {
        return Math.abs(qe.y) > Math.abs(qe.x);
      }
      class ap extends $c {
        constructor(xe) {
          super(), this._map = xe;
        }
        reset() {
          super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
        }
        _start(xe) {
          this._lastPoints = xe, sd(xe[0].sub(xe[1])) && (this._valid = !1);
        }
        _move(xe, ke, He) {
          const ir = this._lastPoints;
          if (!ir)
            return;
          const ar = xe[0].sub(ir[0]), yr = xe[1].sub(ir[1]);
          return this._map._cooperativeGestures && !ne.dz() && He.touches.length < 3 || (this._valid = this.gestureBeginsVertically(ar, yr, He.timeStamp), !this._valid) ? void 0 : (this._lastPoints = xe, this._active = !0, { pitchDelta: (ar.y + yr.y) / 2 * -0.5 });
        }
        gestureBeginsVertically(xe, ke, He) {
          if (this._valid !== void 0)
            return this._valid;
          const ir = xe.mag() >= 2, ar = ke.mag() >= 2;
          if (!ir && !ar)
            return;
          if (!ir || !ar)
            return this._firstMove == null && (this._firstMove = He), He - this._firstMove < 100 && void 0;
          const yr = xe.y > 0 == ke.y > 0;
          return sd(xe) && sd(ke) && yr;
        }
      }
      const af = { panStep: 100, bearingStep: 15, pitchStep: 10 };
      class t0 {
        constructor() {
          const xe = af;
          this._panStep = xe.panStep, this._bearingStep = xe.bearingStep, this._pitchStep = xe.pitchStep, this._rotationDisabled = !1;
        }
        blur() {
          this.reset();
        }
        reset() {
          this._active = !1;
        }
        keydown(xe) {
          if (xe.altKey || xe.ctrlKey || xe.metaKey)
            return;
          let ke = 0, He = 0, ir = 0, ar = 0, yr = 0;
          switch (xe.keyCode) {
            case 61:
            case 107:
            case 171:
            case 187:
              ke = 1;
              break;
            case 189:
            case 109:
            case 173:
              ke = -1;
              break;
            case 37:
              xe.shiftKey ? He = -1 : (xe.preventDefault(), ar = -1);
              break;
            case 39:
              xe.shiftKey ? He = 1 : (xe.preventDefault(), ar = 1);
              break;
            case 38:
              xe.shiftKey ? ir = 1 : (xe.preventDefault(), yr = -1);
              break;
            case 40:
              xe.shiftKey ? ir = -1 : (xe.preventDefault(), yr = 1);
              break;
            default:
              return;
          }
          return this._rotationDisabled && (He = 0, ir = 0), { cameraAnimation: (Tr) => {
            const $r = Tr.getZoom();
            Tr.easeTo({ duration: 300, easeId: "keyboardHandler", easing: sp, zoom: ke ? Math.round($r) + ke * (xe.shiftKey ? 2 : 1) : $r, bearing: Tr.getBearing() + He * this._bearingStep, pitch: Tr.getPitch() + ir * this._pitchStep, offset: [-ar * this._panStep, -yr * this._panStep], center: Tr.getCenter() }, { originalEvent: xe });
          } };
        }
        enable() {
          this._enabled = !0;
        }
        disable() {
          this._enabled = !1, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
        disableRotation() {
          this._rotationDisabled = !0;
        }
        enableRotation() {
          this._rotationDisabled = !1;
        }
      }
      function sp(qe) {
        return qe * (2 - qe);
      }
      const sf = 4.000244140625, lf = 1 / 450;
      class ld {
        constructor(xe, ke) {
          this._map = xe, this._el = xe.getCanvasContainer(), this._handler = ke, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = 0.01, this._wheelZoomRate = lf, ne.aP(["_onTimeout", "_addScrollZoomBlocker", "_showBlockerAlert"], this);
        }
        setZoomRate(xe) {
          this._defaultZoomRate = xe;
        }
        setWheelZoomRate(xe) {
          this._wheelZoomRate = xe;
        }
        isEnabled() {
          return !!this._enabled;
        }
        isActive() {
          return this._active || this._finishTimeout !== void 0;
        }
        isZooming() {
          return !!this._zooming;
        }
        enable(xe) {
          this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!xe && xe.around === "center", this._map._cooperativeGestures && this._addScrollZoomBlocker());
        }
        disable() {
          this.isEnabled() && (this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
        }
        wheel(xe) {
          if (!this.isEnabled())
            return;
          if (this._map._cooperativeGestures) {
            if (!(xe.ctrlKey || xe.metaKey || this.isZooming() || ne.dz()))
              return void this._showBlockerAlert();
            this._alertContainer.style.visibility !== "hidden" && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
          }
          let ke = xe.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * xe.deltaY : xe.deltaY;
          const He = ne.q.now(), ir = He - (this._lastWheelEventTime || 0);
          this._lastWheelEventTime = He, ke !== 0 && ke % sf == 0 ? this._type = "wheel" : ke !== 0 && Math.abs(ke) < 4 ? this._type = "trackpad" : ir > 400 ? (this._type = null, this._lastValue = ke, this._timeout = window.setTimeout(this._onTimeout, 40, xe)) : this._type || (this._type = Math.abs(ir * ke) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, ke += this._lastValue)), xe.shiftKey && ke && (ke /= 4), this._type && (this._lastWheelEvent = xe, this._delta -= ke, this._active || this._start(xe)), xe.preventDefault();
        }
        _onTimeout(xe) {
          this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(xe);
        }
        _start(xe) {
          if (!this._delta)
            return;
          this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
          const ke = di(this._el, xe);
          this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : ke, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
        }
        renderFrame() {
          if (!this._frameId || (this._frameId = null, !this.isActive()))
            return;
          const xe = this._map.transform;
          this._type === "wheel" && xe.projection.wrap && (xe._center.lng >= 180 || xe._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
          const ke = () => xe._terrainEnabled() && this._aroundCoord ? xe.computeZoomRelativeTo(this._aroundCoord) : xe.zoom;
          if (this._delta !== 0) {
            const Dr = this._type === "wheel" && Math.abs(this._delta) > sf ? this._wheelZoomRate : this._defaultZoomRate;
            let Or = 2 / (1 + Math.exp(-Math.abs(this._delta * Dr)));
            this._delta < 0 && Or !== 0 && (Or = 1 / Or);
            const Gr = ke(), qr = Math.pow(2, Gr), Jr = typeof this._targetZoom == "number" ? xe.zoomScale(this._targetZoom) : qr;
            this._targetZoom = Math.min(xe.maxZoom, Math.max(xe.minZoom, xe.scaleZoom(Jr * Or))), this._type === "wheel" && (this._startZoom = Gr, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
          }
          const He = typeof this._targetZoom == "number" ? this._targetZoom : ke(), ir = this._startZoom, ar = this._easing;
          let yr, Tr = !1;
          if (this._type === "wheel" && ir && ar) {
            const Dr = Math.min((ne.q.now() - this._lastWheelEventTime) / 200, 1), Or = ar(Dr);
            yr = ne.af(ir, He, Or), Dr < 1 ? this._frameId || (this._frameId = !0) : Tr = !0;
          } else
            yr = He, Tr = !0;
          this._active = !0, Tr && (this._active = !1, this._finishTimeout = window.setTimeout(() => {
            this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
          }, 200));
          let $r = yr - ke();
          return $r * this._lastDelta < 0 && ($r = 0), { noInertia: !0, needsRenderFrame: !Tr, zoomDelta: $r, around: this._aroundPoint, aroundCoord: this._aroundCoord, originalEvent: this._lastWheelEvent };
        }
        _smoothOutEasing(xe) {
          let ke = ne.dA;
          if (this._prevEase) {
            const He = this._prevEase, ir = (ne.q.now() - He.start) / He.duration, ar = He.easing(ir + 0.01) - He.easing(ir), yr = 0.27 / Math.sqrt(ar * ar + 1e-4) * 0.01, Tr = Math.sqrt(0.0729 - yr * yr);
            ke = ne.dy(yr, Tr, 0.25, 1);
          }
          return this._prevEase = { start: ne.q.now(), duration: xe, easing: ke }, ke;
        }
        blur() {
          this.reset();
        }
        reset() {
          this._active = !1;
        }
        _addScrollZoomBlocker() {
          this._map && !this._alertContainer && (this._alertContainer = Rr("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(0.05 * this._el.clientWidth)))}px`);
        }
        _showBlockerAlert() {
          this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(() => {
            this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.removeAttribute("role");
          }, 200);
        }
      }
      class yh {
        constructor(xe, ke) {
          this._clickZoom = xe, this._tapZoom = ke;
        }
        enable() {
          this._clickZoom.enable(), this._tapZoom.enable();
        }
        disable() {
          this._clickZoom.disable(), this._tapZoom.disable();
        }
        isEnabled() {
          return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
        }
        isActive() {
          return this._clickZoom.isActive() || this._tapZoom.isActive();
        }
      }
      class pl {
        constructor() {
          this.reset();
        }
        reset() {
          this._active = !1;
        }
        blur() {
          this.reset();
        }
        dblclick(xe, ke) {
          return xe.preventDefault(), { cameraAnimation: (He) => {
            He.easeTo({ duration: 300, zoom: He.getZoom() + (xe.shiftKey ? -1 : 1), around: He.unproject(ke) }, { originalEvent: xe });
          } };
        }
        enable() {
          this._enabled = !0;
        }
        disable() {
          this._enabled = !1, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      class vc {
        constructor() {
          this._tap = new fs({ numTouches: 1, numTaps: 1 }), this.reset();
        }
        reset() {
          this._active = !1, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
        }
        touchstart(xe, ke, He) {
          this._swipePoint || (this._tapTime && xe.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? He.length > 0 && (this._swipePoint = ke[0], this._swipeTouch = He[0].identifier) : this._tap.touchstart(xe, ke, He));
        }
        touchmove(xe, ke, He) {
          if (this._tapTime) {
            if (this._swipePoint) {
              if (He[0].identifier !== this._swipeTouch)
                return;
              const ir = ke[0], ar = ir.y - this._swipePoint.y;
              return this._swipePoint = ir, xe.preventDefault(), this._active = !0, { zoomDelta: ar / 128 };
            }
          } else
            this._tap.touchmove(xe, ke, He);
        }
        touchend(xe, ke, He) {
          this._tapTime ? this._swipePoint && He.length === 0 && this.reset() : this._tap.touchend(xe, ke, He) && (this._tapTime = xe.timeStamp);
        }
        touchcancel() {
          this.reset();
        }
        enable() {
          this._enabled = !0;
        }
        disable() {
          this._enabled = !1, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      class hu {
        constructor(xe, ke, He) {
          this._el = xe, this._mousePan = ke, this._touchPan = He;
        }
        enable(xe) {
          this._inertiaOptions = xe || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
        }
        disable() {
          this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
        }
        isEnabled() {
          return this._mousePan.isEnabled() && this._touchPan.isEnabled();
        }
        isActive() {
          return this._mousePan.isActive() || this._touchPan.isActive();
        }
      }
      class bh {
        constructor(xe, ke, He) {
          this._pitchWithRotate = xe.pitchWithRotate, this._mouseRotate = ke, this._mousePitch = He;
        }
        enable() {
          this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
        }
        disable() {
          this._mouseRotate.disable(), this._mousePitch.disable();
        }
        isEnabled() {
          return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
        }
        isActive() {
          return this._mouseRotate.isActive() || this._mousePitch.isActive();
        }
      }
      class du {
        constructor(xe, ke, He, ir) {
          this._el = xe, this._touchZoom = ke, this._touchRotate = He, this._tapDragZoom = ir, this._rotationDisabled = !1, this._enabled = !0;
        }
        enable(xe) {
          this._touchZoom.enable(xe), this._rotationDisabled || this._touchRotate.enable(xe), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
        }
        disable() {
          this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
        }
        isEnabled() {
          return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
        }
        isActive() {
          return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
        }
        disableRotation() {
          this._rotationDisabled = !0, this._touchRotate.disable();
        }
        enableRotation() {
          this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
        }
      }
      const lp = (qe) => qe.zoom || qe.drag || qe.pitch || qe.rotate;
      class X0 extends ne.z {
      }
      class fu {
        constructor() {
          this.constants = [1, 1, 0.01], this.radius = 0;
        }
        setup(xe, ke) {
          const He = ne.ab.vec3.sub([], ke, xe);
          this.radius = ne.ab.vec3.length(He[2] < 0 ? ne.ab.vec3.div([], He, this.constants) : [He[0], He[1], 0]);
        }
        projectRay(xe) {
          ne.ab.vec3.div(xe, xe, this.constants), ne.ab.vec3.normalize(xe, xe), ne.ab.vec3.mul(xe, xe, this.constants);
          const ke = ne.ab.vec3.scale([], xe, this.radius);
          if (ke[2] > 0) {
            const He = ne.ab.vec3.scale([], [0, 0, 1], ne.ab.vec3.dot(ke, [0, 0, 1])), ir = ne.ab.vec3.scale([], ne.ab.vec3.normalize([], [ke[0], ke[1], 0]), this.radius), ar = ne.ab.vec3.add([], ke, ne.ab.vec3.scale([], ne.ab.vec3.sub([], ne.ab.vec3.add([], ir, He), ke), 2));
            ke[0] = ar[0], ke[1] = ar[1];
          }
          return ke;
        }
      }
      function cd(qe) {
        return qe.panDelta && qe.panDelta.mag() || qe.zoomDelta || qe.bearingDelta || qe.pitchDelta;
      }
      class cp {
        constructor(xe, ke) {
          this._map = xe, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Qm(xe), this._bearingSnap = ke.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new fu(), this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(ke), ne.aP(["handleEvent", "handleWindowEvent"], this);
          const He = this._el;
          this._listeners = [[He, "touchstart", { passive: !0 }], [He, "touchmove", { passive: !1 }], [He, "touchend", void 0], [He, "touchcancel", void 0], [He, "mousedown", void 0], [He, "mousemove", void 0], [He, "mouseup", void 0], [document, "mousemove", { capture: !0 }], [document, "mouseup", void 0], [He, "mouseover", void 0], [He, "mouseout", void 0], [He, "dblclick", void 0], [He, "click", void 0], [He, "keydown", { capture: !1 }], [He, "keyup", void 0], [He, "wheel", { passive: !1 }], [He, "contextmenu", void 0], [window, "blur", void 0]];
          for (const [ir, ar, yr] of this._listeners) {
            const Tr = ir === document ? this.handleWindowEvent : this.handleEvent;
            ir.addEventListener(ar, Tr, yr);
          }
        }
        destroy() {
          for (const [xe, ke, He] of this._listeners) {
            const ir = xe === document ? this.handleWindowEvent : this.handleEvent;
            xe.removeEventListener(ke, ir, He);
          }
        }
        _addDefaultHandlers(xe) {
          const ke = this._map, He = ke.getCanvasContainer();
          this._add("mapEvent", new Yp(ke, xe));
          const ir = ke.boxZoom = new Bc(ke, xe);
          this._add("boxZoom", ir);
          const ar = new vh(), yr = new pl();
          ke.doubleClickZoom = new yh(yr, ar), this._add("tapZoom", ar), this._add("clickZoom", yr);
          const Tr = new vc();
          this._add("tapDragZoom", Tr);
          const $r = ke.touchPitch = new ap(ke);
          this._add("touchPitch", $r);
          const Dr = new op(xe), Or = new uu(xe);
          ke.dragRotate = new bh(xe, Dr, Or), this._add("mouseRotate", Dr, ["mousePitch"]), this._add("mousePitch", Or, ["mouseRotate"]);
          const Gr = new nf(xe), qr = new Pu(ke, xe);
          ke.dragPan = new hu(He, Gr, qr), this._add("mousePan", Gr), this._add("touchPan", qr, ["touchZoom", "touchRotate"]);
          const Jr = new _h(), bi = new ic();
          ke.touchZoomRotate = new du(He, bi, Jr, Tr), this._add("touchRotate", Jr, ["touchPan", "touchZoom"]), this._add("touchZoom", bi, ["touchPan", "touchRotate"]), this._add("blockableMapEvent", new $l(ke));
          const fi = ke.scrollZoom = new ld(ke, this);
          this._add("scrollZoom", fi, ["mousePan"]);
          const Mi = ke.keyboard = new t0();
          this._add("keyboard", Mi);
          for (const Ei of ["boxZoom", "doubleClickZoom", "tapDragZoom", "touchPitch", "dragRotate", "dragPan", "touchZoomRotate", "scrollZoom", "keyboard"])
            xe.interactive && xe[Ei] && ke[Ei].enable(xe[Ei]);
        }
        _add(xe, ke, He) {
          this._handlers.push({ handlerName: xe, handler: ke, allowed: He }), this._handlersById[xe] = ke;
        }
        stop(xe) {
          if (!this._updatingCamera) {
            for (const { handler: ke } of this._handlers)
              ke.reset();
            this._inertia.clear(), this._fireEvents({}, {}, xe), this._changes = [], this._originalZoom = void 0;
          }
        }
        isActive() {
          for (const { handler: xe } of this._handlers)
            if (xe.isActive())
              return !0;
          return !1;
        }
        isZooming() {
          return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
        }
        isRotating() {
          return !!this._eventsInProgress.rotate;
        }
        isMoving() {
          return !!lp(this._eventsInProgress) || this.isZooming();
        }
        _isDragging() {
          return !!this._eventsInProgress.drag;
        }
        _blockedByActive(xe, ke, He) {
          for (const ir in xe)
            if (ir !== He && (!ke || ke.indexOf(ir) < 0))
              return !0;
          return !1;
        }
        handleWindowEvent(xe) {
          this.handleEvent(xe, `${xe.type}Window`);
        }
        _getMapTouches(xe) {
          const ke = [];
          for (const He of xe)
            this._el.contains(He.target) && ke.push(He);
          return ke;
        }
        handleEvent(xe, ke) {
          this._updatingCamera = !0;
          const He = xe.type === "renderFrame", ir = He ? void 0 : xe, ar = { needsRenderFrame: !1 }, yr = {}, Tr = {}, $r = xe.touches ? this._getMapTouches(xe.touches) : void 0, Dr = $r ? oi(this._el, $r) : He ? void 0 : di(this._el, xe);
          for (const { handlerName: qr, handler: Jr, allowed: bi } of this._handlers) {
            if (!Jr.isEnabled())
              continue;
            let fi;
            this._blockedByActive(Tr, bi, qr) ? Jr.reset() : Jr[ke || xe.type] && (fi = Jr[ke || xe.type](xe, Dr, $r), this.mergeHandlerResult(ar, yr, fi, qr, ir), fi && fi.needsRenderFrame && this._triggerRenderFrame()), (fi || Jr.isActive()) && (Tr[qr] = Jr);
          }
          const Or = {};
          for (const qr in this._previousActiveHandlers)
            Tr[qr] || (Or[qr] = ir);
          this._previousActiveHandlers = Tr, (Object.keys(Or).length || cd(ar)) && (this._changes.push([ar, yr, Or]), this._triggerRenderFrame()), (Object.keys(Tr).length || cd(ar)) && this._map._stop(!0), this._updatingCamera = !1;
          const { cameraAnimation: Gr } = ar;
          Gr && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], Gr(this._map));
        }
        mergeHandlerResult(xe, ke, He, ir, ar) {
          if (!He)
            return;
          ne.l(xe, He);
          const yr = { handlerName: ir, originalEvent: He.originalEvent || ar };
          He.zoomDelta !== void 0 && (ke.zoom = yr), He.panDelta !== void 0 && (ke.drag = yr), He.pitchDelta !== void 0 && (ke.pitch = yr), He.bearingDelta !== void 0 && (ke.rotate = yr);
        }
        _applyChanges() {
          const xe = {}, ke = {}, He = {};
          for (const [ir, ar, yr] of this._changes)
            ir.panDelta && (xe.panDelta = (xe.panDelta || new ne.P(0, 0))._add(ir.panDelta)), ir.zoomDelta && (xe.zoomDelta = (xe.zoomDelta || 0) + ir.zoomDelta), ir.bearingDelta && (xe.bearingDelta = (xe.bearingDelta || 0) + ir.bearingDelta), ir.pitchDelta && (xe.pitchDelta = (xe.pitchDelta || 0) + ir.pitchDelta), ir.around !== void 0 && (xe.around = ir.around), ir.aroundCoord !== void 0 && (xe.aroundCoord = ir.aroundCoord), ir.pinchAround !== void 0 && (xe.pinchAround = ir.pinchAround), ir.noInertia && (xe.noInertia = ir.noInertia), ne.l(ke, ar), ne.l(He, yr);
          this._updateMapTransform(xe, ke, He), this._changes = [];
        }
        _updateMapTransform(xe, ke, He) {
          const ir = this._map, ar = ir.transform, yr = (Ii) => [Ii.x, Ii.y, Ii.z];
          if (((Ii) => {
            const Ni = this._eventsInProgress.drag;
            return Ni && !this._handlersById[Ni.handlerName].isActive();
          })() && !cd(xe)) {
            const Ii = ar.zoom;
            ar.cameraElevationReference = "sea", this._originalZoom != null && ar._orthographicProjectionAtLowPitch && ar.projection.name !== "globe" && ar.pitch === 0 ? (ar.cameraElevationReference = "ground", ar.zoom = this._originalZoom) : (ar.recenterOnTerrain(), ar.cameraElevationReference = "ground"), Ii !== ar.zoom && this._map._update(!0);
          }
          if (ar._isCameraConstrained && ir._stop(!0), !cd(xe))
            return void this._fireEvents(ke, He, !0);
          let { panDelta: Tr, zoomDelta: $r, bearingDelta: Dr, pitchDelta: Or, around: Gr, aroundCoord: qr, pinchAround: Jr } = xe;
          ar._isCameraConstrained && ($r > 0 && ($r = 0), ar._isCameraConstrained = !1), Jr !== void 0 && (Gr = Jr), ($r || ((Ii) => ke[Ii] && !this._eventsInProgress[Ii])("drag")) && Gr && (this._dragOrigin = yr(ar.pointCoordinate3D(Gr)), this._originalZoom = ar.zoom, this._trackingEllipsoid.setup(ar._camera.position, this._dragOrigin)), ar.cameraElevationReference = "sea", ir._stop(!0), Gr = Gr || ir.transform.centerPoint, Dr && (ar.bearing += Dr), Or && (ar.pitch += Or), ar._updateCameraState();
          const bi = [0, 0, 0];
          if (Tr)
            if (ar.projection.name === "mercator") {
              const Ii = this._trackingEllipsoid.projectRay(ar.screenPointToMercatorRay(Gr).dir), Ni = this._trackingEllipsoid.projectRay(ar.screenPointToMercatorRay(Gr.sub(Tr)).dir);
              bi[0] = Ni[0] - Ii[0], bi[1] = Ni[1] - Ii[1];
            } else {
              const Ii = ar.pointCoordinate(Gr);
              if (ar.projection.name === "globe") {
                Tr = Tr.rotate(-ar.angle);
                const Ni = ar._pixelsPerMercatorPixel / ar.worldSize;
                bi[0] = -Tr.x * ne.dB(ne.aS(Ii.y)) * Ni, bi[1] = -Tr.y * ne.dB(ar.center.lat) * Ni;
              } else {
                const Ni = ar.pointCoordinate(Gr.sub(Tr));
                Ii && Ni && (bi[0] = Ni.x - Ii.x, bi[1] = Ni.y - Ii.y);
              }
            }
          const fi = ar.zoom, Mi = [0, 0, 0];
          if ($r) {
            const Ii = yr(qr || ar.pointCoordinate3D(Gr)), Ni = { dir: ne.ab.vec3.normalize([], ne.ab.vec3.sub([], Ii, ar._camera.position)) };
            if (Ni.dir[2] < 0) {
              const zi = ar.zoomDeltaToMovement(Ii, $r);
              ne.ab.vec3.scale(Mi, Ni.dir, zi);
            }
          }
          const Ei = ne.ab.vec3.add(bi, bi, Mi);
          ar._translateCameraConstrained(Ei), $r && Math.abs(ar.zoom - fi) > 1e-4 && ar.recenterOnTerrain(), ar.cameraElevationReference = "ground", this._map._update(), xe.noInertia || this._inertia.record(xe), this._fireEvents(ke, He, !0);
        }
        _fireEvents(xe, ke, He) {
          const ir = lp(this._eventsInProgress), ar = lp(xe), yr = {};
          for (const Or in xe) {
            const { originalEvent: Gr } = xe[Or];
            this._eventsInProgress[Or] || (yr[`${Or}start`] = Gr), this._eventsInProgress[Or] = xe[Or];
          }
          !ir && ar && this._fireEvent("movestart", ar.originalEvent);
          for (const Or in yr)
            this._fireEvent(Or, yr[Or]);
          ar && this._fireEvent("move", ar.originalEvent);
          for (const Or in xe) {
            const { originalEvent: Gr } = xe[Or];
            this._fireEvent(Or, Gr);
          }
          const Tr = {};
          let $r;
          for (const Or in this._eventsInProgress) {
            const { handlerName: Gr, originalEvent: qr } = this._eventsInProgress[Or];
            this._handlersById[Gr].isActive() || (delete this._eventsInProgress[Or], $r = ke[Gr] || qr, Tr[`${Or}end`] = $r);
          }
          for (const Or in Tr)
            this._fireEvent(Or, Tr[Or]);
          const Dr = lp(this._eventsInProgress);
          if (He && (ir || ar) && !Dr) {
            this._updatingCamera = !0;
            const Or = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), Gr = (qr) => qr !== 0 && -this._bearingSnap < qr && qr < this._bearingSnap;
            Or ? (Gr(Or.bearing || this._map.getBearing()) && (Or.bearing = 0), this._map.easeTo(Or, { originalEvent: $r })) : (this._map.fire(new ne.z("moveend", { originalEvent: $r })), Gr(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
          }
        }
        _fireEvent(xe, ke) {
          this._map.fire(new ne.z(xe, ke ? { originalEvent: ke } : {}));
        }
        _requestFrame() {
          return this._map.triggerRepaint(), this._map._renderTaskQueue.add((xe) => {
            this._frameId = void 0, this.handleEvent(new X0("renderFrame", { timeStamp: xe })), this._applyChanges();
          });
        }
        _triggerRenderFrame() {
          this._frameId === void 0 && (this._frameId = this._requestFrame());
        }
      }
      const il = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
      class ud extends ne.E {
        constructor(xe, ke) {
          super(), this._moving = !1, this._zooming = !1, this.transform = xe, this._bearingSnap = ke.bearingSnap, this._respectPrefersReducedMotion = ke.respectPrefersReducedMotion !== !1, ne.aP(["_renderFrameCallback"], this);
        }
        getCenter() {
          return new ne.bO(this.transform.center.lng, this.transform.center.lat);
        }
        setCenter(xe, ke) {
          return this.jumpTo({ center: xe }, ke);
        }
        panBy(xe, ke, He) {
          return xe = ne.P.convert(xe).mult(-1), this.panTo(this.transform.center, ne.l({ offset: xe }, ke), He);
        }
        panTo(xe, ke, He) {
          return this.easeTo(ne.l({ center: xe }, ke), He);
        }
        getZoom() {
          return this.transform.zoom;
        }
        setZoom(xe, ke) {
          return this.jumpTo({ zoom: xe }, ke), this;
        }
        zoomTo(xe, ke, He) {
          return this.easeTo(ne.l({ zoom: xe }, ke), He);
        }
        zoomIn(xe, ke) {
          return this.zoomTo(this.getZoom() + 1, xe, ke), this;
        }
        zoomOut(xe, ke) {
          return this.zoomTo(this.getZoom() - 1, xe, ke), this;
        }
        getBearing() {
          return this.transform.bearing;
        }
        setBearing(xe, ke) {
          return this.jumpTo({ bearing: xe }, ke), this;
        }
        getPadding() {
          return this.transform.padding;
        }
        setPadding(xe, ke) {
          return this.jumpTo({ padding: xe }, ke), this;
        }
        rotateTo(xe, ke, He) {
          return this.easeTo(ne.l({ bearing: xe }, ke), He);
        }
        resetNorth(xe, ke) {
          return this.rotateTo(0, ne.l({ duration: 1e3 }, xe), ke), this;
        }
        resetNorthPitch(xe, ke) {
          return this.easeTo(ne.l({ bearing: 0, pitch: 0, duration: 1e3 }, xe), ke), this;
        }
        snapToNorth(xe, ke) {
          return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(xe, ke) : this;
        }
        getPitch() {
          return this.transform.pitch;
        }
        setPitch(xe, ke) {
          return this.jumpTo({ pitch: xe }, ke), this;
        }
        cameraForBounds(xe, ke) {
          xe = ne.az.convert(xe);
          const He = ke && ke.bearing || 0, ir = ke && ke.pitch || 0, ar = xe.getNorthWest(), yr = xe.getSouthEast();
          return this._cameraForBounds(this.transform, ar, yr, He, ir, ke);
        }
        _extendPadding(xe) {
          const ke = { top: 0, right: 0, bottom: 0, left: 0 };
          return xe == null ? ne.l({}, ke, this.transform.padding) : typeof xe == "number" ? { top: xe, bottom: xe, right: xe, left: xe } : ne.l({}, ke, xe);
        }
        _extendCameraOptions(xe) {
          return (xe = ne.l({ offset: [0, 0], maxZoom: this.transform.maxZoom }, xe)).padding = this._extendPadding(xe.padding), xe;
        }
        _minimumAABBFrustumDistance(xe, ke) {
          const He = ke.max[0] - ke.min[0], ir = ke.max[1] - ke.min[1];
          return He / ir > xe.aspect ? He / (2 * Math.tan(0.5 * xe.fovX) * xe.aspect) : ir / (2 * Math.tan(0.5 * xe.fovY) * xe.aspect);
        }
        _cameraForBoundsOnGlobe(xe, ke, He, ir, ar, yr) {
          const Tr = xe.clone(), $r = this._extendCameraOptions(yr);
          Tr.bearing = ir, Tr.pitch = ar;
          const Dr = ne.bO.convert(ke), Or = ne.bO.convert(He), Gr = 0.5 * (Dr.lat + Or.lat), qr = 0.5 * (Dr.lng + Or.lng), Jr = ne.dC(Gr, qr), bi = ne.ab.vec3.normalize([], Jr), fi = ne.ab.vec3.normalize([], ne.ab.vec3.cross([], bi, [0, 1, 0])), Mi = ne.ab.vec3.cross([], fi, bi), Ei = [fi[0], fi[1], fi[2], 0, Mi[0], Mi[1], Mi[2], 0, bi[0], bi[1], bi[2], 0, 0, 0, 0, 1], Ii = [Jr, ne.dC(Dr.lat, Dr.lng), ne.dC(Or.lat, Dr.lng), ne.dC(Or.lat, Or.lng), ne.dC(Dr.lat, Or.lng), ne.dC(Gr, Dr.lng), ne.dC(Gr, Or.lng), ne.dC(Dr.lat, qr), ne.dC(Or.lat, qr)];
          let Ni = ne.cd.fromPoints(Ii.map((On) => [ne.ab.vec3.dot(fi, On), ne.ab.vec3.dot(Mi, On), ne.ab.vec3.dot(bi, On)]));
          const zi = ne.ab.vec3.transformMat4([], Ni.center, Ei);
          ne.ab.vec3.squaredLength(zi) === 0 && ne.ab.vec3.set(zi, 0, 0, 1), ne.ab.vec3.normalize(zi, zi), ne.ab.vec3.scale(zi, zi, ne.ax), Tr.center = ne.dD(zi);
          const Ki = Tr.getWorldToCameraMatrix(), Wi = ne.ab.mat4.invert(new Float64Array(16), Ki);
          Ni = ne.cd.applyTransform(Ni, ne.ab.mat4.multiply([], Ki, Ei));
          const Xi = this._extendAABB(Ni, Tr, $r, ir);
          if (!Xi)
            return void ne.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
          Ni = Xi, ne.ab.vec3.transformMat4(zi, zi, Ki);
          const Gi = 0.5 * (Ni.max[2] - Ni.min[2]), nn = this._minimumAABBFrustumDistance(Tr, Ni), dn = ne.ab.vec3.scale([], [0, 0, 1], Gi), Pn = ne.ab.vec3.add(dn, zi, dn), Ln = nn + (Tr.pitch === 0 ? 0 : ne.ab.vec3.distance(zi, Pn)), hn = Tr.globeCenterInViewSpace, xn = ne.ab.vec3.sub([], zi, [hn[0], hn[1], hn[2]]);
          ne.ab.vec3.normalize(xn, xn), ne.ab.vec3.scale(xn, xn, Ln);
          const Hn = ne.ab.vec3.add([], zi, xn);
          ne.ab.vec3.transformMat4(Hn, Hn, Wi);
          const io = ne.ds / ne.ax, uo = ne.ab.vec3.length(Hn), An = ne.bH(Math.max(uo * io - ne.ds, Number.EPSILON), 0), eo = Math.min(Tr.zoomFromMercatorZAdjusted(An), $r.maxZoom);
          return eo > 0.5 * (ne.c6 + ne.bY) ? (Tr.setProjection({ name: "mercator" }), Tr.zoom = eo, this._cameraForBounds(Tr, ke, He, ir, ar, yr)) : { center: Tr.center, zoom: eo, bearing: ir, pitch: ar };
        }
        _extendAABB(xe, ke, He, ir) {
          const ar = 0.5 * ((He.padding.left || 0) + (He.padding.right || 0)), yr = 0.5 * ((He.padding.top || 0) + (He.padding.bottom || 0)), Tr = yr, $r = ar, Dr = ar, Or = yr, Gr = ke.width - ($r + Dr), qr = ke.height - (Tr + Or), Jr = ne.ab.vec3.sub([], xe.max, xe.min), bi = Math.min(Gr / Jr[0], qr / Jr[1]), fi = Math.min(ke.scaleZoom(ke.scale * bi), He.maxZoom);
          if (isNaN(fi))
            return null;
          const Mi = ke.scale / ke.zoomScale(fi), Ei = new ne.cd([xe.min[0] - $r * Mi, xe.min[1] - Or * Mi, xe.min[2]], [xe.max[0] + Dr * Mi, xe.max[1] + Tr * Mi, xe.max[2]]), Ii = (typeof He.offset.x == "number" && typeof He.offset.y == "number" ? new ne.P(He.offset.x, He.offset.y) : ne.P.convert(He.offset)).rotate(-ne.ai(ir));
          return Ei.center[0] -= Ii.x * Mi, Ei.center[1] += Ii.y * Mi, Ei;
        }
        queryTerrainElevation(xe, ke) {
          const He = this.transform.elevation;
          return He ? (ke = ne.l({}, { exaggerated: !0 }, ke), He.getAtPoint(ne.aa.fromLngLat(xe), null, ke.exaggerated)) : null;
        }
        _cameraForBounds(xe, ke, He, ir, ar, yr) {
          if (xe.projection.name === "globe")
            return this._cameraForBoundsOnGlobe(xe, ke, He, ir, ar, yr);
          const Tr = xe.clone(), $r = this._extendCameraOptions(yr);
          Tr.bearing = ir, Tr.pitch = ar;
          const Dr = ne.bO.convert(ke), Or = ne.bO.convert(He), Gr = new ne.bO(Dr.lng, Or.lat), qr = new ne.bO(Or.lng, Dr.lat), Jr = Tr.project(Dr), bi = Tr.project(Or), fi = this.queryTerrainElevation(Dr), Mi = this.queryTerrainElevation(Or), Ei = this.queryTerrainElevation(Gr), Ii = this.queryTerrainElevation(qr), Ni = [[Jr.x, Jr.y, Math.min(fi || 0, Mi || 0, Ei || 0, Ii || 0)], [bi.x, bi.y, Math.max(fi || 0, Mi || 0, Ei || 0, Ii || 0)]];
          let zi = ne.cd.fromPoints(Ni);
          const Ki = Tr.getWorldToCameraMatrix(), Wi = ne.ab.mat4.invert(new Float64Array(16), Ki);
          zi = ne.cd.applyTransform(zi, Ki);
          const Xi = this._extendAABB(zi, Tr, $r, ir);
          if (!Xi)
            return void ne.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
          zi = Xi;
          const Gi = 0.5 * ne.ab.vec3.sub([], zi.max, zi.min)[2], nn = this._minimumAABBFrustumDistance(Tr, zi), dn = [0, 0, 1, 0];
          ne.ab.vec4.transformMat4(dn, dn, Ki), ne.ab.vec4.normalize(dn, dn);
          const Pn = ne.ab.vec3.scale([], dn, nn + Gi), Ln = ne.ab.vec3.add([], zi.center, Pn);
          ne.ab.vec3.transformMat4(zi.center, zi.center, Wi), ne.ab.vec3.transformMat4(Ln, Ln, Wi);
          const hn = Tr.unproject(new ne.P(zi.center[0], zi.center[1])), xn = ne.dE(Tr.projection, hn), Hn = Math.pow(2, xn), io = Math.min(Tr._zoomFromMercatorZ(Ln[2] * Tr.pixelsPerMeter * Hn / Tr.worldSize), $r.maxZoom);
          return Tr.mercatorFromTransition && io < 0.5 * (ne.c6 + ne.bY) ? (Tr.setProjection({ name: "globe" }), Tr.zoom = io, this._cameraForBounds(Tr, ke, He, ir, ar, yr)) : { center: hn, zoom: io, bearing: ir, pitch: ar };
        }
        fitBounds(xe, ke, He) {
          const ir = this.cameraForBounds(xe, ke);
          return this._fitInternal(ir, ke, He);
        }
        fitScreenCoordinates(xe, ke, He, ir, ar) {
          const yr = ne.P.convert(xe), Tr = ne.P.convert(ke), $r = new ne.P(Math.min(yr.x, Tr.x), Math.min(yr.y, Tr.y)), Dr = new ne.P(Math.max(yr.x, Tr.x), Math.max(yr.y, Tr.y));
          if (this.transform.projection.name === "mercator" && this.transform.anyCornerOffEdge(yr, Tr))
            return this;
          const Or = this.transform.pointLocation3D($r), Gr = this.transform.pointLocation3D(Dr), qr = this.transform.pointLocation3D(new ne.P($r.x, Dr.y)), Jr = this.transform.pointLocation3D(new ne.P(Dr.x, $r.y)), bi = [Math.min(Or.lng, Gr.lng, qr.lng, Jr.lng), Math.min(Or.lat, Gr.lat, qr.lat, Jr.lat)], fi = [Math.max(Or.lng, Gr.lng, qr.lng, Jr.lng), Math.max(Or.lat, Gr.lat, qr.lat, Jr.lat)], Mi = ir && ir.pitch ? ir.pitch : this.getPitch(), Ei = this._cameraForBounds(this.transform, bi, fi, He, Mi, ir);
          return this._fitInternal(Ei, ir, ar);
        }
        _fitInternal(xe, ke, He) {
          return xe ? (ke = ne.l(xe, ke)).linear ? this.easeTo(ke, He) : this.flyTo(ke, He) : this;
        }
        jumpTo(xe, ke) {
          this.stop();
          const He = xe.preloadOnly ? this.transform.clone() : this.transform;
          let ir = !1, ar = !1, yr = !1;
          "zoom" in xe && He.zoom !== +xe.zoom && (ir = !0, He.zoom = +xe.zoom), xe.center !== void 0 && (He.center = ne.bO.convert(xe.center)), "bearing" in xe && He.bearing !== +xe.bearing && (ar = !0, He.bearing = +xe.bearing), "pitch" in xe && He.pitch !== +xe.pitch && (yr = !0, He.pitch = +xe.pitch);
          const Tr = typeof xe.padding == "number" ? this._extendPadding(xe.padding) : xe.padding;
          if (xe.padding != null && !He.isPaddingEqual(Tr))
            if (xe.retainPadding === !1) {
              const $r = He.clone();
              $r.padding = Tr, He.setLocationAtPoint(He.center, $r.centerPoint);
            } else
              He.padding = Tr;
          return xe.preloadOnly ? (this._preloadTiles(He), this) : (this.fire(new ne.z("movestart", ke)).fire(new ne.z("move", ke)), ir && this.fire(new ne.z("zoomstart", ke)).fire(new ne.z("zoom", ke)).fire(new ne.z("zoomend", ke)), ar && this.fire(new ne.z("rotatestart", ke)).fire(new ne.z("rotate", ke)).fire(new ne.z("rotateend", ke)), yr && this.fire(new ne.z("pitchstart", ke)).fire(new ne.z("pitch", ke)).fire(new ne.z("pitchend", ke)), this.fire(new ne.z("moveend", ke)));
        }
        getFreeCameraOptions() {
          return this.transform.projection.supportsFreeCamera || ne.w(il), this.transform.getFreeCameraOptions();
        }
        setFreeCameraOptions(xe, ke) {
          const He = this.transform;
          if (!He.projection.supportsFreeCamera)
            return ne.w(il), this;
          this.stop();
          const ir = He.zoom, ar = He.pitch, yr = He.bearing;
          He.setFreeCameraOptions(xe);
          const Tr = ir !== He.zoom, $r = ar !== He.pitch, Dr = yr !== He.bearing;
          return this.fire(new ne.z("movestart", ke)).fire(new ne.z("move", ke)), Tr && this.fire(new ne.z("zoomstart", ke)).fire(new ne.z("zoom", ke)).fire(new ne.z("zoomend", ke)), Dr && this.fire(new ne.z("rotatestart", ke)).fire(new ne.z("rotate", ke)).fire(new ne.z("rotateend", ke)), $r && this.fire(new ne.z("pitchstart", ke)).fire(new ne.z("pitch", ke)).fire(new ne.z("pitchend", ke)), this.fire(new ne.z("moveend", ke)), this;
        }
        easeTo(xe, ke) {
          this._stop(!1, xe.easeId), ((xe = ne.l({ offset: [0, 0], duration: 500, easing: ne.dA }, xe)).animate === !1 || this._prefersReducedMotion(xe)) && (xe.duration = 0);
          const He = this.transform, ir = this.getZoom(), ar = this.getBearing(), yr = this.getPitch(), Tr = this.getPadding(), $r = "zoom" in xe ? +xe.zoom : ir, Dr = "bearing" in xe ? this._normalizeBearing(xe.bearing, ar) : ar, Or = "pitch" in xe ? +xe.pitch : yr, Gr = this._extendPadding(xe.padding), qr = ne.P.convert(xe.offset);
          let Jr, bi, fi;
          if (He.projection.name === "globe") {
            const dn = ne.aa.fromLngLat(He.center), Pn = qr.rotate(-He.angle);
            dn.x += Pn.x / He.worldSize, dn.y += Pn.y / He.worldSize;
            const Ln = dn.toLngLat(), hn = ne.bO.convert(xe.center || Ln);
            this._normalizeCenter(hn), Jr = He.centerPoint.add(Pn), bi = new ne.P(dn.x, dn.y).mult(He.worldSize), fi = new ne.P(ne.at(hn.lng), ne.aA(hn.lat)).mult(He.worldSize).sub(bi);
          } else {
            Jr = He.centerPoint.add(qr);
            const dn = He.pointLocation(Jr), Pn = ne.bO.convert(xe.center || dn);
            this._normalizeCenter(Pn), bi = He.project(dn), fi = He.project(Pn).sub(bi);
          }
          const Mi = He.zoomScale($r - ir);
          let Ei, Ii;
          xe.around && (Ei = ne.bO.convert(xe.around), Ii = He.locationPoint(Ei));
          const Ni = this._zooming || $r !== ir, zi = this._rotating || ar !== Dr, Ki = this._pitching || Or !== yr, Wi = !He.isPaddingEqual(Gr), Xi = xe.retainPadding === !1 ? He.clone() : He, Gi = (dn) => (Pn) => {
            if (Ni && (dn.zoom = ne.af(ir, $r, Pn)), zi && (dn.bearing = ne.af(ar, Dr, Pn)), Ki && (dn.pitch = ne.af(yr, Or, Pn)), Wi && (Xi.interpolatePadding(Tr, Gr, Pn), Jr = Xi.centerPoint.add(qr)), Ei)
              dn.setLocationAtPoint(Ei, Ii);
            else {
              const Ln = dn.zoomScale(dn.zoom - ir), hn = $r > ir ? Math.min(2, Mi) : Math.max(0.5, Mi), xn = Math.pow(hn, 1 - Pn), Hn = dn.unproject(bi.add(fi.mult(Pn * xn)).mult(Ln));
              dn.setLocationAtPoint(dn.renderWorldCopies ? Hn.wrap() : Hn, Jr);
            }
            return xe.preloadOnly || this._fireMoveEvents(ke), dn;
          };
          if (xe.preloadOnly) {
            const dn = this._emulate(Gi, xe.duration, He);
            return this._preloadTiles(dn), this;
          }
          const nn = { moving: this._moving, zooming: this._zooming, rotating: this._rotating, pitching: this._pitching };
          return this._zooming = Ni, this._rotating = zi, this._pitching = Ki, this._padding = Wi, this._easeId = xe.easeId, this._prepareEase(ke, xe.noMoveStart, nn), this._ease(Gi(He), (dn) => {
            He.cameraElevationReference === "sea" && He.recenterOnTerrain(), this._afterEase(ke, dn);
          }, xe), this;
        }
        _prepareEase(xe, ke, He = {}) {
          this._moving = !0, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && this.transform.pitch === 0 && this.transform.projection.name !== "globe" && (this.transform.cameraElevationReference = "ground"), ke || He.moving || this.fire(new ne.z("movestart", xe)), this._zooming && !He.zooming && this.fire(new ne.z("zoomstart", xe)), this._rotating && !He.rotating && this.fire(new ne.z("rotatestart", xe)), this._pitching && !He.pitching && this.fire(new ne.z("pitchstart", xe));
        }
        _fireMoveEvents(xe) {
          this.fire(new ne.z("move", xe)), this._zooming && this.fire(new ne.z("zoom", xe)), this._rotating && this.fire(new ne.z("rotate", xe)), this._pitching && this.fire(new ne.z("pitch", xe));
        }
        _afterEase(xe, ke) {
          if (this._easeId && ke && this._easeId === ke)
            return;
          this._easeId = void 0, this.transform.cameraElevationReference = "ground";
          const He = this._zooming, ir = this._rotating, ar = this._pitching;
          this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, He && this.fire(new ne.z("zoomend", xe)), ir && this.fire(new ne.z("rotateend", xe)), ar && this.fire(new ne.z("pitchend", xe)), this.fire(new ne.z("moveend", xe));
        }
        flyTo(xe, ke) {
          if (this._prefersReducedMotion(xe)) {
            const On = ne.ay(xe, ["center", "zoom", "bearing", "pitch", "around", "padding", "retainPadding"]);
            return this.jumpTo(On, ke);
          }
          this.stop(), xe = ne.l({ offset: [0, 0], speed: 1.2, curve: 1.42, easing: ne.dA }, xe);
          const He = this.transform, ir = this.getZoom(), ar = this.getBearing(), yr = this.getPitch(), Tr = this.getPadding(), $r = "zoom" in xe ? ne.aw(+xe.zoom, He.minZoom, He.maxZoom) : ir, Dr = "bearing" in xe ? this._normalizeBearing(xe.bearing, ar) : ar, Or = "pitch" in xe ? +xe.pitch : yr, Gr = this._extendPadding(xe.padding), qr = He.zoomScale($r - ir), Jr = ne.P.convert(xe.offset);
          let bi = He.centerPoint.add(Jr);
          const fi = He.pointLocation(bi), Mi = ne.bO.convert(xe.center || fi);
          this._normalizeCenter(Mi);
          const Ei = He.project(fi), Ii = He.project(Mi).sub(Ei);
          let Ni = xe.curve;
          const zi = Math.max(He.width, He.height), Ki = zi / qr, Wi = Ii.mag();
          if ("minZoom" in xe) {
            const On = ne.aw(Math.min(xe.minZoom, ir, $r), He.minZoom, He.maxZoom), ao = zi / He.zoomScale(On - ir);
            Ni = Math.sqrt(ao / Wi * 2);
          }
          const Xi = Ni * Ni;
          function Gi(On) {
            const ao = (Ki * Ki - zi * zi + (On ? -1 : 1) * Xi * Xi * Wi * Wi) / (2 * (On ? Ki : zi) * Xi * Wi);
            return Math.log(Math.sqrt(ao * ao + 1) - ao);
          }
          function nn(On) {
            return (Math.exp(On) - Math.exp(-On)) / 2;
          }
          function dn(On) {
            return (Math.exp(On) + Math.exp(-On)) / 2;
          }
          const Pn = Gi(0);
          let Ln = function(On) {
            return dn(Pn) / dn(Pn + Ni * On);
          }, hn = function(On) {
            return zi * ((dn(Pn) * (nn(ao = Pn + Ni * On) / dn(ao)) - nn(Pn)) / Xi) / Wi;
            var ao;
          }, xn = (Gi(1) - Pn) / Ni;
          if (Math.abs(Wi) < 1e-6 || !isFinite(xn)) {
            if (Math.abs(zi - Ki) < 1e-6)
              return this.easeTo(xe, ke);
            const On = Ki < zi ? -1 : 1;
            xn = Math.abs(Math.log(Ki / zi)) / Ni, hn = function() {
              return 0;
            }, Ln = function(ao) {
              return Math.exp(On * Ni * ao);
            };
          }
          xe.duration = "duration" in xe ? +xe.duration : 1e3 * xn / ("screenSpeed" in xe ? +xe.screenSpeed / Ni : +xe.speed), xe.maxDuration && xe.duration > xe.maxDuration && (xe.duration = 0);
          const Hn = ar !== Dr, io = Or !== yr, uo = !He.isPaddingEqual(Gr), An = xe.retainPadding === !1 ? He.clone() : He, eo = (On) => (ao) => {
            const ro = ao * xn, Wn = 1 / Ln(ro);
            On.zoom = ao === 1 ? $r : ir + On.scaleZoom(Wn), Hn && (On.bearing = ne.af(ar, Dr, ao)), io && (On.pitch = ne.af(yr, Or, ao)), uo && (An.interpolatePadding(Tr, Gr, ao), bi = An.centerPoint.add(Jr));
            const _o = ao === 1 ? Mi : On.unproject(Ei.add(Ii.mult(hn(ro))).mult(Wn));
            return On.setLocationAtPoint(On.renderWorldCopies ? _o.wrap() : _o, bi), On._updateCameraOnTerrain(), xe.preloadOnly || this._fireMoveEvents(ke), On;
          };
          if (xe.preloadOnly) {
            const On = this._emulate(eo, xe.duration, He);
            return this._preloadTiles(On), this;
          }
          return this._zooming = !0, this._rotating = Hn, this._pitching = io, this._padding = uo, this._prepareEase(ke, !1), this._ease(eo(He), () => this._afterEase(ke), xe), this;
        }
        isEasing() {
          return !!this._easeFrameId;
        }
        stop() {
          return this._stop();
        }
        _requestRenderFrame(xe) {
        }
        _cancelRenderFrame(xe) {
        }
        _stop(xe, ke) {
          if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
            const He = this._onEaseEnd;
            this._onEaseEnd = void 0, He.call(this, ke);
          }
          if (!xe) {
            const He = this.handlers;
            He && He.stop(!1);
          }
          return this;
        }
        _ease(xe, ke, He) {
          He.animate === !1 || He.duration === 0 ? (xe(1), ke()) : (this._easeStart = ne.q.now(), this._easeOptions = He, this._onEaseFrame = xe, this._onEaseEnd = ke, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
        }
        _renderFrameCallback() {
          const xe = Math.min((ne.q.now() - this._easeStart) / this._easeOptions.duration, 1), ke = this._onEaseFrame;
          ke && ke(this._easeOptions.easing(xe)), xe < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
        }
        _normalizeBearing(xe, ke) {
          xe = ne.bF(xe, -180, 180);
          const He = Math.abs(xe - ke);
          return Math.abs(xe - 360 - ke) < He && (xe -= 360), Math.abs(xe + 360 - ke) < He && (xe += 360), xe;
        }
        _normalizeCenter(xe) {
          const ke = this.transform;
          if (ke.maxBounds || ke.projection.name !== "globe" && !ke.renderWorldCopies)
            return;
          const He = xe.lng - ke.center.lng;
          xe.lng += He > 180 ? -360 : He < -180 ? 360 : 0;
        }
        _prefersReducedMotion(xe) {
          return this._respectPrefersReducedMotion && ne.q.prefersReducedMotion && !(xe && xe.essential);
        }
        _emulate(xe, ke, He) {
          const ir = Math.ceil(15 * ke / 1e3), ar = [], yr = xe(He.clone());
          for (let Tr = 0; Tr <= ir; Tr++) {
            const $r = yr(Tr / ir);
            ar.push($r.clone());
          }
          return ar;
        }
        _preloadTiles(xe, ke) {
        }
      }
      class Ou {
        constructor(xe = {}) {
          this.options = xe, ne.aP(["_toggleAttribution", "_updateEditLink", "_updateData", "_updateCompact"], this);
        }
        getDefaultPosition() {
          return "bottom-right";
        }
        onAdd(xe) {
          const ke = this.options && this.options.compact, He = xe._getUIString("AttributionControl.ToggleAttribution");
          this._map = xe, this._container = Rr("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = Rr("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._compactButton.setAttribute("aria-label", He);
          const ir = Rr("span", "mapboxgl-ctrl-icon", this._compactButton);
          return ir.setAttribute("aria-hidden", "true"), ir.setAttribute("title", He), this._innerContainer = Rr("div", "mapboxgl-ctrl-attrib-inner", this._container), ke && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), ke === void 0 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
        }
        onRemove() {
          this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
        }
        _toggleAttribution() {
          this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
        }
        _updateEditLink() {
          let xe = this._editLink;
          xe || (xe = this._editLink = this._container.querySelector(".mapbox-improve-map"));
          const ke = [{ key: "owner", value: this.styleOwner }, { key: "id", value: this.styleId }, { key: "access_token", value: this._map._requestManager._customAccessToken || ne.e.ACCESS_TOKEN }];
          if (xe) {
            const He = ke.reduce((ir, ar, yr) => (ar.value && (ir += `${ar.key}=${ar.value}${yr < ke.length - 1 ? "&" : ""}`), ir), "?");
            xe.href = `${ne.e.FEEDBACK_URL}/${He}#${rp(this._map, !0)}`, xe.rel = "noopener nofollow";
          }
        }
        _updateData(xe) {
          !xe || xe.sourceDataType !== "metadata" && xe.sourceDataType !== "visibility" && xe.dataType !== "style" || (this._updateAttributions(), this._updateEditLink());
        }
        _updateAttributions() {
          if (!this._map.style)
            return;
          let xe = [];
          if (this._map.style.stylesheet) {
            const ir = this._map.style.stylesheet;
            this.styleOwner = ir.owner, this.styleId = ir.id;
          }
          const ke = this._map.style._mergedSourceCaches;
          for (const ir in ke) {
            const ar = ke[ir];
            if (ar.used) {
              const yr = ar.getSource();
              yr.attribution && xe.indexOf(yr.attribution) < 0 && xe.push(yr.attribution);
            }
          }
          xe.sort((ir, ar) => ir.length - ar.length), xe = xe.filter((ir, ar) => {
            for (let yr = ar + 1; yr < xe.length; yr++)
              if (xe[yr].indexOf(ir) >= 0)
                return !1;
            return !0;
          }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? xe = [...this.options.customAttribution, ...xe] : xe.unshift(this.options.customAttribution));
          const He = xe.join(" | ");
          He !== this._attribHTML && (this._attribHTML = He, xe.length ? (this._innerContainer.innerHTML = He, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
        }
        _updateCompact() {
          this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
        }
      }
      class pa {
        constructor() {
          ne.aP(["_updateLogo", "_updateCompact"], this);
        }
        onAdd(xe) {
          this._map = xe, this._container = Rr("div", "mapboxgl-ctrl");
          const ke = Rr("a", "mapboxgl-ctrl-logo");
          return ke.target = "_blank", ke.rel = "noopener nofollow", ke.href = "https://www.mapbox.com/", ke.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), ke.setAttribute("rel", "noopener nofollow"), this._container.appendChild(ke), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
        }
        onRemove() {
          this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
        }
        getDefaultPosition() {
          return "bottom-left";
        }
        _updateLogo(xe) {
          xe && xe.sourceDataType !== "metadata" || (this._container.style.display = this._logoRequired() ? "block" : "none");
        }
        _logoRequired() {
          if (!this._map.style)
            return !0;
          const xe = this._map.style._sourceCaches;
          if (Object.entries(xe).length === 0)
            return !0;
          for (const ke in xe) {
            const He = xe[ke].getSource();
            if (He.hasOwnProperty("mapbox_logo") && !He.mapbox_logo)
              return !1;
          }
          return !0;
        }
        _updateCompact() {
          const xe = this._container.children;
          if (xe.length) {
            const ke = xe[0];
            this._map.getCanvasContainer().offsetWidth < 250 ? ke.classList.add("mapboxgl-compact") : ke.classList.remove("mapboxgl-compact");
          }
        }
      }
      class Yc {
        constructor() {
          this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
        }
        add(xe) {
          const ke = ++this._id;
          return this._queue.push({ callback: xe, id: ke, cancelled: !1 }), ke;
        }
        remove(xe) {
          const ke = this._currentlyRunning, He = ke ? this._queue.concat(ke) : this._queue;
          for (const ir of He)
            if (ir.id === xe)
              return void (ir.cancelled = !0);
        }
        run(xe = 0) {
          const ke = this._currentlyRunning = this._queue;
          this._queue = [];
          for (const He of ke)
            if (!He.cancelled && (He.callback(xe), this._cleared))
              break;
          this._cleared = !1, this._currentlyRunning = !1;
        }
        clear() {
          this._currentlyRunning && (this._cleared = !0), this._queue = [];
        }
      }
      class cf {
        constructor(xe) {
          this.jumpTo(xe);
        }
        getValue(xe) {
          if (xe <= this._startTime)
            return this._start;
          if (xe >= this._endTime)
            return this._end;
          const ke = ne.cB((xe - this._startTime) / (this._endTime - this._startTime));
          return this._start * (1 - ke) + this._end * ke;
        }
        isEasing(xe) {
          return xe >= this._startTime && xe <= this._endTime;
        }
        jumpTo(xe) {
          this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = xe, this._end = xe;
        }
        easeTo(xe, ke, He) {
          this._start = this.getValue(ke), this._end = xe, this._startTime = ke, this._endTime = ke + He;
        }
      }
      const cl = { "AttributionControl.ToggleAttribution": "Toggle attribution", "FullscreenControl.Enter": "Enter fullscreen", "FullscreenControl.Exit": "Exit fullscreen", "GeolocateControl.FindMyLocation": "Find my location", "GeolocateControl.LocationNotAvailable": "Location not available", "LogoControl.Title": "Mapbox homepage", "Map.Title": "Map", "NavigationControl.ResetBearing": "Reset bearing to north", "NavigationControl.ZoomIn": "Zoom in", "NavigationControl.ZoomOut": "Zoom out", "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map", "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map", "TouchPanBlocker.Message": "Use two fingers to move the map" }, _c = ["mouseenter", "mouseover", "mouseleave", "mouseout"];
      class pu extends ne.z {
        constructor(xe, ke, He, ir) {
          const { point: ar, lngLat: yr, originalEvent: Tr, target: $r } = xe;
          super(xe.type, { point: ar, lngLat: yr, originalEvent: Tr, target: $r }), this.preventDefault = () => {
            xe.preventDefault();
          }, this.id = ke, this.interaction = He, this.feature = ir;
        }
      }
      class zu {
        constructor(xe) {
          this.map = xe, this.interactionsByType = /* @__PURE__ */ new Map(), this.typeById = /* @__PURE__ */ new Map(), this.filters = /* @__PURE__ */ new Map(), this.delegatedHandlers = /* @__PURE__ */ new Map(), this.handleType = this.handleType.bind(this);
        }
        add(xe, ke) {
          if (this.typeById.has(xe))
            throw new Error(`Interaction id "${xe}" already exists.`);
          const { type: He, filter: ir } = ke;
          ir && this.filters.set(xe, ne.aZ(ir));
          const ar = this.interactionsByType.get(He) || /* @__PURE__ */ new Map();
          if (ar.size === 0) {
            if (_c.includes(He)) {
              const { mousemove: yr, mouseout: Tr } = this._createDelegatedHandlers(xe, ke);
              this.map.on("mousemove", yr), this.map.on("mouseout", Tr), this.delegatedHandlers.set(xe, { mousemove: yr, mouseout: Tr });
            } else
              this.map.on(He, this.handleType);
            this.interactionsByType.set(He, ar);
          }
          ar.set(xe, ke), this.typeById.set(xe, He);
        }
        get(xe) {
          const ke = this.typeById.get(xe);
          if (!ke)
            return;
          const He = this.interactionsByType.get(ke);
          return He ? He.get(xe) : void 0;
        }
        remove(xe) {
          const ke = this.typeById.get(xe);
          if (!ke)
            return;
          this.typeById.delete(xe), this.filters.delete(xe);
          const He = this.interactionsByType.get(ke);
          if (He) {
            if (He.delete(xe), this.delegatedHandlers.has(xe)) {
              const { mousemove: ir, mouseout: ar } = this.delegatedHandlers.get(xe);
              this.map.off("mousemove", ir), this.map.off("mouseout", ar), this.delegatedHandlers.delete(xe);
            }
            He.size === 0 && this.map.off(ke, this.handleType);
          }
        }
        queryTargets(xe, ke) {
          const He = [];
          for (const [ir, ar] of ke)
            ar.target && He.push({ targetId: ir, target: ar.target, filter: this.filters.get(ir) });
          return this.map.style.queryRenderedTargets(xe, He, this.map.transform);
        }
        handleType(xe, ke) {
          const He = this.interactionsByType.get(xe.type), ir = Array.from(He).reverse();
          ke = ke || this.queryTargets(xe.point, ir);
          let ar = !1;
          for (const yr of ke) {
            for (const [Tr, $r] of ir) {
              if (!$r.target)
                continue;
              const Dr = yr.variants ? yr.variants[Tr] : null;
              if (Dr) {
                for (const Or of Dr) {
                  const Gr = new ne.cw(yr, Or);
                  if ($r.handler(new pu(xe, Tr, $r, Gr)) !== !1) {
                    ar = !0;
                    break;
                  }
                }
                if (ar)
                  break;
              }
            }
            if (ar)
              break;
          }
          if (!ar)
            for (const [yr, Tr] of ir) {
              const { handler: $r, target: Dr } = Tr;
              if (!Dr && $r(new pu(xe, yr, Tr, null)) !== !1)
                break;
            }
        }
        _createDelegatedHandlers(xe, ke) {
          switch (ke.type) {
            case "mouseenter":
            case "mouseover": {
              let He = !1, ir = /* @__PURE__ */ new Set();
              return { mousemove: (ar) => {
                const yr = this.queryTargets(ar.point, [[xe, ke]]), Tr = /* @__PURE__ */ new Set();
                if (!yr.length)
                  return He = !1, void ir.clear();
                const $r = [];
                for (const Dr of yr)
                  ir.has(Dr.id) || (Tr.add(Dr.id), $r.push(Dr));
                He && !$r.length || (He = !0, ir = Tr, ar.type = ke.type, this.handleType(ar, $r));
              }, mouseout: () => {
                He = !1, ir.clear();
              } };
            }
            case "mouseleave":
            case "mouseout": {
              let He = [];
              return { mousemove: (ir) => {
                const ar = this.queryTargets(ir.point, [[xe, ke]]);
                if (!ar.length)
                  return ir.type = ke.type, this.handleType(ir, He), void (He = ar);
                const yr = [], Tr = new Set(ar.map(($r) => $r.id));
                for (const $r of He)
                  Tr.has($r.id) || yr.push($r);
                yr.length && (ir.type = ke.type, this.handleType(ir, yr)), He = ar;
              }, mouseout: (ir) => {
                He.length && (ir.type = ke.type, this.handleType(ir, He), He = []);
              } };
            }
          }
        }
      }
      function zs(qe, xe) {
        if (Array.isArray(qe) && Array.isArray(xe)) {
          const ke = new Set(qe), He = new Set(xe);
          return ke.size === He.size && qe.every((ir) => He.has(ir));
        }
        return ne.bn(qe, xe);
      }
      const Qp = { center: [0, 0], zoom: 0, bearing: 0, pitch: 0, minZoom: -2, maxZoom: 22, minPitch: 0, maxPitch: 85, interactive: !0, scrollZoom: !0, boxZoom: !0, dragRotate: !0, dragPan: !0, keyboard: !0, doubleClickZoom: !0, touchZoomRotate: !0, touchPitch: !0, cooperativeGestures: !1, performanceMetricsCollection: !0, bearingSnap: 7, clickTolerance: 3, pitchWithRotate: !0, hash: !1, attributionControl: !0, antialias: !1, failIfMajorPerformanceCaveat: !1, preserveDrawingBuffer: !1, trackResize: !0, renderWorldCopies: !0, refreshExpiredTiles: !0, minTileCacheSize: null, maxTileCacheSize: null, localIdeographFontFamily: "sans-serif", localFontFamily: null, transformRequest: null, accessToken: null, fadeDuration: 300, respectPrefersReducedMotion: !0, crossSourceCollisions: !0, collectResourceTiming: !1, testMode: !1, precompilePrograms: !0, scaleFactor: 1, spriteFormat: "auto" }, Ba = { showCompass: !0, showZoom: !0, visualizePitch: !1 };
      class mu {
        constructor(xe, ke, He = !1) {
          this._clickTolerance = 10, this.element = ke, this.mouseRotate = new op({ clickTolerance: xe.dragRotate._mouseRotate._clickTolerance }), this.map = xe, He && (this.mousePitch = new uu({ clickTolerance: xe.dragRotate._mousePitch._clickTolerance })), ne.aP(["mousedown", "mousemove", "mouseup", "touchstart", "touchmove", "touchend", "reset"], this), ke.addEventListener("mousedown", this.mousedown), ke.addEventListener("touchstart", this.touchstart, { passive: !1 }), ke.addEventListener("touchmove", this.touchmove), ke.addEventListener("touchend", this.touchend), ke.addEventListener("touchcancel", this.reset);
        }
        down(xe, ke) {
          this.mouseRotate.mousedown(xe, ke), this.mousePitch && this.mousePitch.mousedown(xe, ke), Wr();
        }
        move(xe, ke) {
          const He = this.map, ir = this.mouseRotate.mousemoveWindow(xe, ke), ar = ir && ir.bearingDelta;
          if (ar && He.setBearing(He.getBearing() + ar), this.mousePitch) {
            const yr = this.mousePitch.mousemoveWindow(xe, ke), Tr = yr && yr.pitchDelta;
            Tr && He.setPitch(He.getPitch() + Tr);
          }
        }
        off() {
          const xe = this.element;
          xe.removeEventListener("mousedown", this.mousedown), xe.removeEventListener("touchstart", this.touchstart, { passive: !1 }), xe.removeEventListener("touchmove", this.touchmove), xe.removeEventListener("touchend", this.touchend), xe.removeEventListener("touchcancel", this.reset), this.offTemp();
        }
        offTemp() {
          si(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup);
        }
        mousedown(xe) {
          this.down(ne.l({}, xe, { ctrlKey: !0, preventDefault: () => xe.preventDefault() }), di(this.element, xe)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
        }
        mousemove(xe) {
          this.move(xe, di(this.element, xe));
        }
        mouseup(xe) {
          this.mouseRotate.mouseupWindow(xe), this.mousePitch && this.mousePitch.mouseupWindow(xe), this.offTemp();
        }
        touchstart(xe) {
          xe.targetTouches.length !== 1 ? this.reset() : (this._startPos = this._lastPos = oi(this.element, xe.targetTouches)[0], this.down({ type: "mousedown", button: 0, ctrlKey: !0, preventDefault: () => xe.preventDefault() }, this._startPos));
        }
        touchmove(xe) {
          xe.targetTouches.length !== 1 ? this.reset() : (this._lastPos = oi(this.element, xe.targetTouches)[0], this.move({ preventDefault: () => xe.preventDefault() }, this._lastPos));
        }
        touchend(xe) {
          xe.targetTouches.length === 0 && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
        }
        reset() {
          this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
        }
      }
      function r0(qe, xe, ke) {
        if (qe = new ne.bO(qe.lng, qe.lat), xe) {
          const He = new ne.bO(qe.lng - 360, qe.lat), ir = new ne.bO(qe.lng + 360, qe.lat), ar = 360 * Math.ceil(Math.abs(qe.lng - ke.center.lng) / 360), yr = ke.locationPoint(qe).distSqr(xe), Tr = xe.x < 0 || xe.y < 0 || xe.x > ke.width || xe.y > ke.height;
          ke.locationPoint(He).distSqr(xe) < yr && (Tr || Math.abs(He.lng - ke.center.lng) < ar) ? qe = He : ke.locationPoint(ir).distSqr(xe) < yr && (Tr || Math.abs(ir.lng - ke.center.lng) < ar) && (qe = ir);
        }
        for (; Math.abs(qe.lng - ke.center.lng) > 180; ) {
          const He = ke.locationPoint(qe);
          if (He.x >= 0 && He.y >= 0 && He.x <= ke.width && He.y <= ke.height)
            break;
          qe.lng > ke.center.lng ? qe.lng -= 360 : qe.lng += 360;
        }
        return qe;
      }
      const up = { center: "translate(-50%,-50%)", top: "translate(-50%,0)", "top-left": "translate(0,0)", "top-right": "translate(-100%,0)", bottom: "translate(-50%,-100%)", "bottom-left": "translate(0,-100%)", "bottom-right": "translate(-100%,-100%)", left: "translate(0,-50%)", right: "translate(-100%,-50%)" };
      class uf extends ne.E {
        constructor(xe, ke) {
          if (super(), (xe instanceof HTMLElement || ke) && (xe = ne.l({ element: xe }, ke)), ne.aP(["_update", "_onMove", "_onUp", "_addDragHandler", "_onMapClick", "_onKeyPress", "_clearFadeTimer"], this), this._anchor = xe && xe.anchor || "center", this._color = xe && xe.color || "#3FB1CE", this._scale = xe && xe.scale || 1, this._draggable = xe && xe.draggable || !1, this._clickTolerance = xe && xe.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = xe && xe.rotation || 0, this._rotationAlignment = xe && xe.rotationAlignment || "auto", this._pitchAlignment = xe && xe.pitchAlignment && xe.pitchAlignment || "auto", this._updateMoving = () => this._update(!0), this._occludedOpacity = xe && xe.occludedOpacity || 0.2, xe && xe.element)
            this._element = xe.element, this._offset = ne.P.convert(xe && xe.offset || [0, 0]);
          else {
            this._defaultMarker = !0, this._element = Rr("div");
            const ar = 41, yr = 27, Tr = Nr("svg", { display: "block", height: ar * this._scale + "px", width: yr * this._scale + "px", viewBox: `0 0 ${yr} ${ar}` }, this._element), $r = Nr("radialGradient", { id: "shadowGradient" }, Nr("defs", {}, Tr));
            Nr("stop", { offset: "10%", "stop-opacity": 0.4 }, $r), Nr("stop", { offset: "100%", "stop-opacity": 0.05 }, $r), Nr("ellipse", { cx: 13.5, cy: 34.8, rx: 10.5, ry: 5.25, fill: "url(#shadowGradient)" }, Tr), Nr("path", { fill: this._color, d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z" }, Tr), Nr("path", { opacity: 0.25, d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z" }, Tr), Nr("circle", { fill: "white", cx: 13.5, cy: 13.5, r: 5.5 }, Tr), this._offset = ne.P.convert(xe && xe.offset || [0, -14]);
          }
          this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.hasAttribute("role") || this._element.setAttribute("role", "img"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (ar) => {
            ar.preventDefault();
          }), this._element.addEventListener("mousedown", (ar) => {
            ar.preventDefault();
          });
          const He = this._element.classList;
          for (const ar in up)
            He.remove(`mapboxgl-marker-anchor-${ar}`);
          He.add(`mapboxgl-marker-anchor-${this._anchor}`);
          const ir = xe && xe.className ? xe.className.trim().split(/\s+/) : [];
          He.add(...ir), this._popup = null;
        }
        addTo(xe) {
          return xe === this._map || (this.remove(), this._map = xe, xe.getCanvasContainer().appendChild(this._element), xe.on("move", this._updateMoving), xe.on("moveend", this._update), xe.on("remove", this._clearFadeTimer), xe._addMarker(this), this.setDraggable(this._draggable), this._update(), xe.on("click", this._onMapClick)), this;
        }
        remove() {
          const xe = this._map;
          return xe && (xe.off("click", this._onMapClick), xe.off("move", this._updateMoving), xe.off("moveend", this._update), xe.off("mousedown", this._addDragHandler), xe.off("touchstart", this._addDragHandler), xe.off("mouseup", this._onUp), xe.off("touchend", this._onUp), xe.off("mousemove", this._onMove), xe.off("touchmove", this._onMove), xe.off("remove", this._clearFadeTimer), xe._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
        }
        getLngLat() {
          return this._lngLat;
        }
        setLngLat(xe) {
          return this._lngLat = ne.bO.convert(xe), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(!0), this;
        }
        getElement() {
          return this._element;
        }
        setPopup(xe) {
          if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), xe) {
            if (!("offset" in xe.options)) {
              const ir = Math.sqrt(Math.pow(13.5, 2) / 2);
              xe.options.offset = this._defaultMarker ? { top: [0, 0], "top-left": [0, 0], "top-right": [0, 0], bottom: [0, -38.1], "bottom-left": [ir, -1 * (38.1 - 13.5 + ir)], "bottom-right": [-ir, -1 * (38.1 - 13.5 + ir)], left: [13.5, -1 * (38.1 - 13.5)], right: [-13.5, -1 * (38.1 - 13.5)] } : this._offset;
            }
            this._popup = xe, xe._marker = this, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
          }
          return this;
        }
        _onKeyPress(xe) {
          const ke = xe.code, He = xe.charCode || xe.keyCode;
          ke !== "Space" && ke !== "Enter" && He !== 32 && He !== 13 || this.togglePopup();
        }
        _onMapClick(xe) {
          const ke = xe.originalEvent.target, He = this._element;
          this._popup && (ke === He || He.contains(ke)) && this.togglePopup();
        }
        getPopup() {
          return this._popup;
        }
        togglePopup() {
          const xe = this._popup;
          return xe ? (xe.isOpen() ? (xe.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (xe.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
        }
        _behindTerrain() {
          const xe = this._map, ke = this._pos;
          if (!xe || !ke)
            return !1;
          const He = xe.unproject(ke), ir = xe.getFreeCameraOptions();
          if (!ir.position)
            return !1;
          const ar = ir.position.toLngLat();
          return ar.distanceTo(He) < 0.9 * ar.distanceTo(this._lngLat);
        }
        _evaluateOpacity() {
          const xe = this._map;
          if (!xe)
            return;
          const ke = this._pos;
          if (!ke || ke.x < 0 || ke.x > xe.transform.width || ke.y < 0 || ke.y > xe.transform.height)
            return void this._clearFadeTimer();
          const He = xe.unproject(ke);
          let ir;
          xe._showingGlobe() && ne.dH(xe.transform, this._lngLat) ? ir = 0 : (ir = 1 - xe._queryFogOpacity(He), xe.transform._terrainEnabled() && xe.getTerrain() && this._behindTerrain() && (ir *= this._occludedOpacity)), this._element.style.opacity = `${ir}`, this._element.style.pointerEvents = ir > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(ir), this._fadeTimer = null;
        }
        _clearFadeTimer() {
          this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
        }
        _updateDOM() {
          const xe = this._pos;
          if (!xe || !this._map)
            return;
          const ke = this._offset.mult(this._scale);
          this._element.style.transform = `
            translate(${xe.x}px,${xe.y}px)
            ${up[this._anchor]}
            ${this._calculateXYTransform()} ${this._calculateZTransform()}
            translate(${ke.x}px,${ke.y}px)
        `;
        }
        _calculateXYTransform() {
          const xe = this._pos, ke = this._map, He = this.getPitchAlignment();
          if (!ke || !xe || He !== "map")
            return "";
          if (!ke._showingGlobe()) {
            const $r = ke.getPitch();
            return $r ? `rotateX(${$r}deg)` : "";
          }
          const ir = ne.c4(ne.dI(ke.transform, this._lngLat)), ar = xe.sub(ne.dJ(ke.transform)), yr = Math.abs(ar.x) + Math.abs(ar.y);
          if (yr === 0)
            return "";
          const Tr = ir / yr;
          return `rotateX(${-ar.y * Tr}deg) rotateY(${ar.x * Tr}deg)`;
        }
        _calculateZTransform() {
          const xe = this._pos, ke = this._map;
          if (!ke || !xe)
            return "";
          let He = 0;
          const ir = this.getRotationAlignment();
          if (ir === "map")
            if (ke._showingGlobe()) {
              const ar = ke.project(new ne.bO(this._lngLat.lng, this._lngLat.lat + 1e-3)), yr = ke.project(new ne.bO(this._lngLat.lng, this._lngLat.lat - 1e-3)).sub(ar);
              He = ne.c4(Math.atan2(yr.y, yr.x)) - 90;
            } else
              He = -ke.getBearing();
          else if (ir === "horizon") {
            const ar = ne.ac(4, 6, ke.getZoom()), yr = ne.dJ(ke.transform);
            yr.y += ar * ke.transform.height;
            const Tr = xe.sub(yr), $r = ne.c4(Math.atan2(Tr.y, Tr.x));
            He = ($r > 90 ? $r - 270 : $r + 90) * (1 - ar);
          }
          return He += this._rotation, He ? `rotateZ(${He}deg)` : "";
        }
        _update(xe) {
          cancelAnimationFrame(this._updateFrameId);
          const ke = this._map;
          ke && (ke.transform.renderWorldCopies && (this._lngLat = r0(this._lngLat, this._pos, ke.transform)), this._pos = ke.project(this._lngLat), xe === !0 ? this._updateFrameId = requestAnimationFrame(() => {
            this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
          }) : this._pos = this._pos.round(), ke._requestDomTask(() => {
            this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (ke._showingGlobe() || ke.getTerrain() || ke.getFog()) && !this._fadeTimer && (this._fadeTimer = window.setTimeout(this._evaluateOpacity.bind(this), 60)));
          }));
        }
        getOffset() {
          return this._offset;
        }
        setOffset(xe) {
          return this._offset = ne.P.convert(xe), this._update(), this;
        }
        addClassName(xe) {
          return this._element.classList.add(xe), this;
        }
        removeClassName(xe) {
          return this._element.classList.remove(xe), this;
        }
        toggleClassName(xe) {
          return this._element.classList.toggle(xe);
        }
        _onMove(xe) {
          const ke = this._map;
          if (!ke)
            return;
          const He = this._pointerdownPos, ir = this._positionDelta;
          if (He && ir) {
            if (!this._isDragging) {
              const ar = this._clickTolerance || ke._clickTolerance;
              if (xe.point.dist(He) < ar)
                return;
              this._isDragging = !0;
            }
            this._pos = xe.point.sub(ir), this._lngLat = ke.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", this._state === "pending" && (this._state = "active", this.fire(new ne.z("dragstart"))), this.fire(new ne.z("drag"));
          }
        }
        _onUp() {
          this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1;
          const xe = this._map;
          xe && (xe.off("mousemove", this._onMove), xe.off("touchmove", this._onMove)), this._state === "active" && this.fire(new ne.z("dragend")), this._state = "inactive";
        }
        _addDragHandler(xe) {
          const ke = this._map, He = this._pos;
          ke && He && this._element.contains(xe.originalEvent.target) && (xe.preventDefault(), this._positionDelta = xe.point.sub(He), this._pointerdownPos = xe.point, this._state = "pending", ke.on("mousemove", this._onMove), ke.on("touchmove", this._onMove), ke.once("mouseup", this._onUp), ke.once("touchend", this._onUp));
        }
        setDraggable(xe) {
          this._draggable = !!xe;
          const ke = this._map;
          return ke && (xe ? (ke.on("mousedown", this._addDragHandler), ke.on("touchstart", this._addDragHandler)) : (ke.off("mousedown", this._addDragHandler), ke.off("touchstart", this._addDragHandler))), this;
        }
        isDraggable() {
          return this._draggable;
        }
        setRotation(xe) {
          return this._rotation = xe || 0, this._update(), this;
        }
        getRotation() {
          return this._rotation;
        }
        setRotationAlignment(xe) {
          return this._rotationAlignment = xe || "auto", this._update(), this;
        }
        getRotationAlignment() {
          return this._rotationAlignment === "auto" || this._rotationAlignment === "horizon" && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
        }
        setPitchAlignment(xe) {
          return this._pitchAlignment = xe || "auto", this._update(), this;
        }
        getPitchAlignment() {
          return this._pitchAlignment === "auto" ? this.getRotationAlignment() : this._pitchAlignment;
        }
        setOccludedOpacity(xe) {
          return this._occludedOpacity = xe || 0.2, this._update(), this;
        }
        getOccludedOpacity() {
          return this._occludedOpacity;
        }
      }
      const Fu = { positionOptions: { enableHighAccuracy: !1, maximumAge: 0, timeout: 6e3 }, fitBoundsOptions: { maxZoom: 15 }, trackUserLocation: !1, showAccuracyCircle: !0, showUserLocation: !0, showUserHeading: !1 }, gu = { maxWidth: 100, unit: "metric" }, As = { kilometer: "km", meter: "m", mile: "mi", foot: "ft", "nautical-mile": "nm" }, bs = { closeButton: !0, closeOnClick: !0, focusAfterOpen: !0, className: "", maxWidth: "240px" }, Fs = ["a[href]", "[tabindex]:not([tabindex='-1'])", "[contenteditable]:not([contenteditable='false'])", "button:not([disabled])", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].join(", ");
      function em(qe = new ne.P(0, 0), xe = "bottom") {
        if (typeof qe == "number") {
          const ke = Math.round(Math.sqrt(0.5 * Math.pow(qe, 2)));
          switch (xe) {
            case "top":
              return new ne.P(0, qe);
            case "top-left":
              return new ne.P(ke, ke);
            case "top-right":
              return new ne.P(-ke, ke);
            case "bottom":
              return new ne.P(0, -qe);
            case "bottom-left":
              return new ne.P(ke, -ke);
            case "bottom-right":
              return new ne.P(-ke, -ke);
            case "left":
              return new ne.P(qe, 0);
            case "right":
              return new ne.P(-qe, 0);
          }
          return new ne.P(0, 0);
        }
        return qe instanceof ne.P || Array.isArray(qe) ? ne.P.convert(qe) : ne.P.convert(qe[xe] || [0, 0]);
      }
      return { version: rr, supported: Ar.supported, setRTLTextPlugin: ne.dK, getRTLTextPluginStatus: ne.dL, Map: class extends ud {
        constructor(qe) {
          or.mark(gr.create);
          const xe = qe;
          if ((qe = ne.l({}, Qp, qe)).minZoom != null && qe.maxZoom != null && qe.minZoom > qe.maxZoom)
            throw new Error("maxZoom must be greater than or equal to minZoom");
          if (qe.minPitch != null && qe.maxPitch != null && qe.minPitch > qe.maxPitch)
            throw new Error("maxPitch must be greater than or equal to minPitch");
          if (qe.minPitch != null && qe.minPitch < 0)
            throw new Error("minPitch must be greater than or equal to 0");
          if (qe.maxPitch != null && qe.maxPitch > 85)
            throw new Error("maxPitch must be less than or equal to 85");
          if (qe.antialias && ne.dF(window) && (qe.antialias = !1, ne.w("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), super(new If(qe.minZoom, qe.maxZoom, qe.minPitch, qe.maxPitch, qe.renderWorldCopies), qe), this._repaint = !!qe.repaint, this._interactive = qe.interactive, this._minTileCacheSize = qe.minTileCacheSize, this._maxTileCacheSize = qe.maxTileCacheSize, this._failIfMajorPerformanceCaveat = qe.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = qe.preserveDrawingBuffer, this._antialias = qe.antialias, this._trackResize = qe.trackResize, this._bearingSnap = qe.bearingSnap, this._refreshExpiredTiles = qe.refreshExpiredTiles, this._fadeDuration = qe.fadeDuration, this._isInitialLoad = !0, this._crossSourceCollisions = qe.crossSourceCollisions, this._collectResourceTiming = qe.collectResourceTiming, this._language = this._parseLanguage(qe.language), this._worldview = qe.worldview, this._renderTaskQueue = new Yc(), this._domRenderTaskQueue = new Yc(), this._controls = [], this._markers = [], this._popups = [], this._mapId = ne.aV(), this._locale = ne.l({}, cl, qe.locale), this._clickTolerance = qe.clickTolerance, this._cooperativeGestures = qe.cooperativeGestures, this._performanceMetricsCollection = qe.performanceMetricsCollection, this._tessellationStep = qe.tessellationStep, this._containerWidth = 0, this._containerHeight = 0, this._showParseStatus = !0, this._precompilePrograms = qe.precompilePrograms, this._scaleFactorChanged = !1, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new cf(0), this._interactionRange = [1 / 0, -1 / 0], this._visibilityHidden = 0, this._useExplicitProjection = !1, this._frameId = 0, this._scaleFactor = qe.scaleFactor, this._requestManager = new Ue(qe.transformRequest, qe.accessToken, qe.testMode), this._silenceAuthErrors = !!qe.testMode, this._contextCreateOptions = qe.contextCreateOptions ? { ...qe.contextCreateOptions } : {}, typeof qe.container == "string") {
            const ke = document.getElementById(qe.container);
            if (!ke)
              throw new Error(`Container '${qe.container.toString()}' not found.`);
            this._container = ke;
          } else {
            if (!(qe.container instanceof HTMLElement))
              throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
            this._container = qe.container;
          }
          if (this._container.childNodes.length > 0 && ne.w("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), qe.maxBounds && this.setMaxBounds(qe.maxBounds), this._spriteFormat = qe.spriteFormat, ne.aP(["_onWindowOnline", "_onWindowResize", "_onVisibilityChange", "_onMapScroll", "_contextLost", "_contextRestored"], this), this._setupContainer(), this._tp || (this._tp = new jl()), this._tp.registerParameter(this, ["Debug"], "showOverdrawInspector"), this._tp.registerParameter(this, ["Debug"], "showTileBoundaries"), this._tp.registerParameter(this, ["Debug"], "showParseStatus"), this._tp.registerParameter(this, ["Debug"], "repaint"), this._tp.registerParameter(this, ["Debug"], "showTileAABBs"), this._tp.registerParameter(this, ["Debug"], "showPadding"), this._tp.registerParameter(this, ["Debug"], "showCollisionBoxes", { noSave: !0 }), this._tp.registerParameter(this.transform, ["Debug"], "freezeTileCoverage", { noSave: !0 }, () => {
            this._update();
          }), this._tp.registerParameter(this, ["Debug", "Wireframe"], "showTerrainWireframe"), this._tp.registerParameter(this, ["Debug", "Wireframe"], "showLayers2DWireframe"), this._tp.registerParameter(this, ["Debug", "Wireframe"], "showLayers3DWireframe"), this._tp.registerParameter(this, ["Scaling"], "_scaleFactor", { min: 0.1, max: 10, step: 0.1 }, () => {
            this.setScaleFactor(this._scaleFactor);
          }), this._setupPainter(), this.painter === void 0)
            throw new Error("Failed to initialize WebGL.");
          if (this.on("move", () => this._update(!1)), this.on("moveend", () => this._update(!1)), this.on("zoom", () => this._update(!0)), this._fullscreenchangeEvent = "onfullscreenchange" in document ? "fullscreenchange" : "webkitfullscreenchange", window.addEventListener("online", this._onWindowOnline, !1), window.addEventListener("resize", this._onWindowResize, !1), window.addEventListener("orientationchange", this._onWindowResize, !1), window.addEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.addEventListener("visibilitychange", this._onVisibilityChange, !1), this.handlers = new cp(this, qe), this._localFontFamily = qe.localFontFamily, this._localIdeographFontFamily = qe.localIdeographFontFamily, (qe.style || !qe.testMode) && this.setStyle(qe.style || ne.e.DEFAULT_STYLE, { config: qe.config, localFontFamily: this._localFontFamily, localIdeographFontFamily: this._localIdeographFontFamily }), qe.projection && this.setProjection(qe.projection), this.indoor = new Dm(this), qe.hash && (this._hash = new Ic(typeof qe.hash == "string" && qe.hash || void 0).addTo(this)), !this._hash || !this._hash._onHashChange()) {
            xe.center == null && xe.zoom == null || (this.transform._unmodified = !1), this.jumpTo({ center: qe.center, zoom: qe.zoom, bearing: qe.bearing, pitch: qe.pitch });
            const ke = qe.bounds;
            ke && (this.resize(), this.fitBounds(ke, ne.l({}, qe.fitBoundsOptions, { duration: 0 })));
          }
          this.resize(), qe.attributionControl && this.addControl(new Ou({ customAttribution: qe.customAttribution })), this._logoControl = new pa(), this.addControl(this._logoControl, qe.logoPosition), this.on("style.load", () => {
            this.transform.unmodified && this.jumpTo(this.style.stylesheet), this._postStyleLoadEvent();
          }), this.on("data", (ke) => {
            this._update(ke.dataType === "style"), this.fire(new ne.z(`${ke.dataType}data`, ke));
          }), this.on("dataloading", (ke) => {
            this.fire(new ne.z(`${ke.dataType}dataloading`, ke));
          }), this._interactions = new zu(this);
        }
        _getMapId() {
          return this._mapId;
        }
        addControl(qe, xe) {
          if (xe === void 0 && (xe = qe.getDefaultPosition ? qe.getDefaultPosition() : "top-right"), !qe || !qe.onAdd)
            return this.fire(new ne.y(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
          const ke = qe.onAdd(this);
          this._controls.push(qe);
          const He = this._controlPositions[xe];
          return xe.indexOf("bottom") !== -1 ? He.insertBefore(ke, He.firstChild) : He.appendChild(ke), this;
        }
        removeControl(qe) {
          if (!qe || !qe.onRemove)
            return this.fire(new ne.y(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
          const xe = this._controls.indexOf(qe);
          return xe > -1 && this._controls.splice(xe, 1), qe.onRemove(this), this;
        }
        hasControl(qe) {
          return this._controls.indexOf(qe) > -1;
        }
        getContainer() {
          return this._container;
        }
        getCanvasContainer() {
          return this._canvasContainer;
        }
        getCanvas() {
          return this._canvas;
        }
        resize(qe) {
          if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height)
            return this;
          this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
          const xe = !this._moving;
          return xe && this.fire(new ne.z("movestart", qe)).fire(new ne.z("move", qe)), this.fire(new ne.z("resize", qe)), xe && this.fire(new ne.z("moveend", qe)), this;
        }
        getBounds() {
          return this.transform.getBounds();
        }
        getMaxBounds() {
          return this.transform.getMaxBounds() || null;
        }
        setMaxBounds(qe) {
          return this.transform.setMaxBounds(ne.az.convert(qe)), this._update();
        }
        setMinZoom(qe) {
          if ((qe = qe ?? -2) >= -2 && qe <= this.transform.maxZoom)
            return this.transform.minZoom = qe, this._update(), this.getZoom() < qe ? this.setZoom(qe) : this.fire(new ne.z("zoomstart")).fire(new ne.z("zoom")).fire(new ne.z("zoomend")), this;
          throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
        }
        getMinZoom() {
          return this.transform.minZoom;
        }
        setMaxZoom(qe) {
          if ((qe = qe ?? 22) >= this.transform.minZoom)
            return this.transform.maxZoom = qe, this._update(), this.getZoom() > qe ? this.setZoom(qe) : this.fire(new ne.z("zoomstart")).fire(new ne.z("zoom")).fire(new ne.z("zoomend")), this;
          throw new Error("maxZoom must be greater than the current minZoom");
        }
        getMaxZoom() {
          return this.transform.maxZoom;
        }
        setMinPitch(qe) {
          if ((qe = qe ?? 0) < 0)
            throw new Error("minPitch must be greater than or equal to 0");
          if (qe >= 0 && qe <= this.transform.maxPitch)
            return this.transform.minPitch = qe, this._update(), this.getPitch() < qe ? this.setPitch(qe) : this.fire(new ne.z("pitchstart")).fire(new ne.z("pitch")).fire(new ne.z("pitchend")), this;
          throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
        }
        getMinPitch() {
          return this.transform.minPitch;
        }
        setMaxPitch(qe) {
          if ((qe = qe ?? 85) > 85)
            throw new Error("maxPitch must be less than or equal to 85");
          if (qe >= this.transform.minPitch)
            return this.transform.maxPitch = qe, this._update(), this.getPitch() > qe ? this.setPitch(qe) : this.fire(new ne.z("pitchstart")).fire(new ne.z("pitch")).fire(new ne.z("pitchend")), this;
          throw new Error("maxPitch must be greater than or equal to minPitch");
        }
        getMaxPitch() {
          return this.transform.maxPitch;
        }
        getScaleFactor() {
          return this._scaleFactor;
        }
        setScaleFactor(qe) {
          return this._scaleFactor = qe, this.painter.scaleFactor = qe, this._tp.refreshUI(), this._scaleFactorChanged = !0, this.style._updateFilteredLayers((xe) => xe.type === "symbol"), this._update(!0), this;
        }
        getRenderWorldCopies() {
          return this.transform.renderWorldCopies;
        }
        setRenderWorldCopies(qe) {
          return this.transform.renderWorldCopies = qe, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(!0), this._update();
        }
        getLanguage() {
          return this._language;
        }
        _parseLanguage(qe) {
          return qe === "auto" ? navigator.language : Array.isArray(qe) ? qe.length === 0 ? void 0 : qe.map((xe) => xe === "auto" ? navigator.language : xe) : qe;
        }
        setLanguage(qe) {
          const xe = this._parseLanguage(qe);
          if (!this.style || xe === this._language)
            return this;
          this._language = xe, this.style.reloadSources();
          for (const ke of this._controls)
            ke._setLanguage && ke._setLanguage(this._language);
          return this;
        }
        getWorldview() {
          return this._worldview;
        }
        setWorldview(qe) {
          return this.style && qe !== this._worldview ? (this._worldview = qe, this.style.reloadSources(), this) : this;
        }
        getProjection() {
          return this.transform.mercatorFromTransition ? { name: "globe", center: [0, 0] } : this.transform.getProjection();
        }
        _showingGlobe() {
          return this.transform.projection.name === "globe";
        }
        setProjection(qe) {
          return this._lazyInitEmptyStyle(), qe ? typeof qe == "string" && (qe = { name: qe }) : qe = null, this._useExplicitProjection = !!qe, this._prioritizeAndUpdateProjection(qe, this.style.projection);
        }
        _updateProjectionTransition() {
          if (this.getProjection().name !== "globe")
            return;
          const qe = this.transform, xe = qe.projection.name;
          let ke;
          xe === "globe" && qe.zoom >= ne.bY ? (qe.setMercatorFromTransition(), ke = !0) : xe === "mercator" && qe.zoom < ne.bY && (qe.setProjection({ name: "globe" }), ke = !0), ke && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate());
        }
        _prioritizeAndUpdateProjection(qe, xe) {
          return this._updateProjection(qe || xe || { name: "mercator" });
        }
        _updateProjection(qe) {
          let xe;
          return xe = qe.name === "globe" && this.transform.zoom >= ne.bY ? this.transform.setMercatorFromTransition() : this.transform.setProjection(qe), this.style.applyProjectionUpdate(), xe && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(!0), this._forceMarkerAndPopupUpdate(!0)), this;
        }
        project(qe) {
          return this.transform.locationPoint3D(ne.bO.convert(qe));
        }
        unproject(qe) {
          return this.transform.pointLocation3D(ne.P.convert(qe));
        }
        isMoving() {
          return this._moving || this.handlers && this.handlers.isMoving() || !1;
        }
        isZooming() {
          return this._zooming || this.handlers && this.handlers.isZooming() || !1;
        }
        isRotating() {
          return this._rotating || this.handlers && this.handlers.isRotating() || !1;
        }
        _isDragging() {
          return this.handlers && this.handlers._isDragging() || !1;
        }
        _createDelegatedListener(qe, xe, ke) {
          const He = (ir) => {
            let ar = [];
            if (Array.isArray(xe)) {
              const yr = xe.filter((Tr) => this.getLayer(Tr));
              ar = yr.length ? this.queryRenderedFeatures(ir, { layers: yr }) : [];
            } else
              ar = this.queryRenderedFeatures(ir, { target: xe });
            return ar;
          };
          if (qe === "mouseenter" || qe === "mouseover") {
            let ir = !1;
            return { listener: ke, targets: xe, delegates: { mousemove: (yr) => {
              const Tr = He(yr.point);
              Tr.length ? ir || (ir = !0, ke.call(this, new Bl(qe, this, yr.originalEvent, { features: Tr }))) : ir = !1;
            }, mouseout: () => {
              ir = !1;
            } } };
          }
          if (qe === "mouseleave" || qe === "mouseout") {
            let ir = !1;
            return { listener: ke, targets: xe, delegates: { mousemove: (Tr) => {
              He(Tr.point).length ? ir = !0 : ir && (ir = !1, ke.call(this, new Bl(qe, this, Tr.originalEvent)));
            }, mouseout: (Tr) => {
              ir && (ir = !1, ke.call(this, new Bl(qe, this, Tr.originalEvent)));
            } } };
          }
          {
            const ir = (ar) => {
              const yr = He(ar.point);
              yr.length && (ar.features = yr, ke.call(this, ar), delete ar.features);
            };
            return { listener: ke, targets: xe, delegates: { [qe]: ir } };
          }
        }
        on(qe, xe, ke) {
          if (typeof xe == "function" || ke === void 0)
            return super.on(qe, xe);
          if (typeof xe == "string" && (xe = [xe]), !this._areTargetsValid(xe))
            return this;
          const He = this._createDelegatedListener(qe, xe, ke);
          this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[qe] = this._delegatedListeners[qe] || [], this._delegatedListeners[qe].push(He);
          for (const ir in He.delegates)
            this.on(ir, He.delegates[ir]);
          return this;
        }
        once(qe, xe, ke) {
          if (typeof xe == "function" || ke === void 0)
            return super.once(qe, xe);
          if (typeof xe == "string" && (xe = [xe]), !this._areTargetsValid(xe))
            return this;
          const He = this._createDelegatedListener(qe, xe, ke);
          for (const ir in He.delegates)
            this.once(ir, He.delegates[ir]);
          return this;
        }
        off(qe, xe, ke) {
          if (typeof xe == "function" || ke === void 0)
            return super.off(qe, xe);
          if (typeof xe == "string" && (xe = [xe]), !this._areTargetsValid(xe))
            return this;
          const He = this._delegatedListeners ? this._delegatedListeners[qe] : void 0;
          return He && ((ir) => {
            for (let ar = 0; ar < ir.length; ar++) {
              const yr = ir[ar];
              if (yr.listener === ke && zs(yr.targets, xe)) {
                for (const Tr in yr.delegates)
                  this.off(Tr, yr.delegates[Tr]);
                return ir.splice(ar, 1), this;
              }
            }
          })(He), this;
        }
        queryRenderedFeatures(qe, xe) {
          if (!this.style)
            return [];
          if (qe === void 0 || qe instanceof ne.P || Array.isArray(qe) || xe !== void 0 || (xe = qe, qe = void 0), qe = qe || [[0, 0], [this.transform.width, this.transform.height]], !xe) {
            const ar = this.style.queryRenderedFeatures(qe, void 0, this.transform), yr = this.style.queryRenderedFeatureset(qe, void 0, this.transform);
            return ar.concat(yr);
          }
          let ke = !0;
          if (xe.target && (ke = this._isTargetValid(xe.target), ke && !xe.layers))
            return this.style.queryRenderedFeatureset(qe, xe, this.transform);
          let He = !0;
          if (xe.layers && Array.isArray(xe.layers)) {
            for (const ar of xe.layers)
              if (!this._isValidId(ar)) {
                He = !1;
                break;
              }
            if (He && !xe.target)
              return this.style.queryRenderedFeatures(qe, xe, this.transform);
          }
          let ir = [];
          return He && (ir = ir.concat(this.style.queryRenderedFeatures(qe, xe, this.transform))), ke && (ir = ir.concat(this.style.queryRenderedFeatureset(qe, xe, this.transform))), ir;
        }
        querySourceFeatures(qe, xe) {
          return !qe || typeof qe == "string" && !this._isValidId(qe) ? [] : this.style.querySourceFeatures(qe, xe);
        }
        isPointOnSurface(qe) {
          const { name: xe } = this.transform.projection;
          return xe !== "globe" && xe !== "mercator" && ne.w(`${xe} projection does not support isPointOnSurface, this API may behave unexpectedly.`), this.transform.isPointOnSurface(ne.P.convert(qe));
        }
        addInteraction(qe, xe) {
          return this._interactions.add(qe, xe), this;
        }
        removeInteraction(qe) {
          return this._interactions.remove(qe), this;
        }
        setStyle(qe, xe) {
          return xe = ne.l({}, { localIdeographFontFamily: this._localIdeographFontFamily, localFontFamily: this._localFontFamily }, xe), this.style && qe && xe.diff !== !1 && xe.localFontFamily === this._localFontFamily && xe.localIdeographFontFamily === this._localIdeographFontFamily && !xe.config ? (this.style._diffStyle(qe, (ke, He) => {
            ke ? (ne.w(`Unable to perform style diff: ${String(ke.message || ke.error || ke)}. Rebuilding the style from scratch.`), this._updateStyle(qe, xe)) : He && this._update(!0);
          }, () => {
            this._postStyleLoadEvent();
          }), this) : (this._localIdeographFontFamily = xe.localIdeographFontFamily, this._localFontFamily = xe.localFontFamily, this._updateStyle(qe, xe));
        }
        _getUIString(qe) {
          const xe = this._locale[qe];
          if (xe == null)
            throw new Error(`Missing UI string '${qe}'`);
          return xe;
        }
        _updateStyle(qe, xe) {
          if (this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), qe) {
            const ke = ne.l({}, xe);
            xe && xe.config && (ke.initialConfig = xe.config, delete ke.config), this.style = new za(this, ke).load(qe), this.style.setEventedParent(this, { style: this.style });
          }
          return this._updateTerrain(), this;
        }
        _lazyInitEmptyStyle() {
          this.style || (this.style = new za(this, {}), this.style.setEventedParent(this, { style: this.style }), this.style.loadEmpty());
        }
        getStyle() {
          if (this.style)
            return this.style.serialize();
        }
        isStyleLoaded() {
          return this.style ? this.style.loaded() : (ne.w("There is no style added to the map."), !1);
        }
        _isValidId(qe) {
          return qe == null ? (this.fire(new ne.y(new Error("IDs can't be empty."))), !1) : !ne.cr(qe) || (this.fire(new ne.y(new Error(`IDs can't contain special symbols: "${qe}".`))), !1);
        }
        _isTargetValid(qe) {
          return "featuresetId" in qe ? this._isValidId("importId" in qe ? qe.importId : qe.featuresetId) : "layerId" in qe && this._isValidId(qe.layerId);
        }
        _areTargetsValid(qe) {
          if (Array.isArray(qe)) {
            for (const xe of qe)
              if (!this._isValidId(xe))
                return !1;
            return !0;
          }
          return this._isTargetValid(qe);
        }
        addSource(qe, xe) {
          return this._isValidId(qe) ? (this._lazyInitEmptyStyle(), this.style.addSource(qe, xe), this._update(!0)) : this;
        }
        isSourceLoaded(qe) {
          return !!this._isValidId(qe) && !!this.style && this.style._isSourceCacheLoaded(qe);
        }
        areTilesLoaded() {
          return this.style.areTilesLoaded();
        }
        addSourceType(qe, xe, ke) {
          this._lazyInitEmptyStyle(), this.style.addSourceType(qe, xe, ke);
        }
        removeSource(qe) {
          return this._isValidId(qe) ? (this.style.removeSource(qe), this._updateTerrain(), this._update(!0)) : this;
        }
        getSource(qe) {
          return this._isValidId(qe) ? this.style.getOwnSource(qe) : null;
        }
        addImage(qe, xe, { pixelRatio: ke = 1, sdf: He = !1, stretchX: ir, stretchY: ar, content: yr } = {}) {
          if (this._lazyInitEmptyStyle(), xe instanceof HTMLImageElement || ImageBitmap && xe instanceof ImageBitmap) {
            const { width: Tr, height: $r, data: Dr } = ne.q.getImageData(xe);
            this.style.addImage(qe, { data: new ne.r({ width: Tr, height: $r }, Dr), pixelRatio: ke, stretchX: ir, stretchY: ar, content: yr, sdf: He, version: 0, usvg: !1 });
          } else if (xe.width === void 0 || xe.height === void 0)
            this.fire(new ne.y(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
          else {
            const { width: Tr, height: $r } = xe, Dr = xe;
            this.style.addImage(qe, { data: new ne.r({ width: Tr, height: $r }, new Uint8Array(Dr.data)), pixelRatio: ke, stretchX: ir, stretchY: ar, content: yr, sdf: He, usvg: !1, version: 0, userImage: Dr }), Dr.onAdd && Dr.onAdd(this, qe);
          }
        }
        updateImage(qe, xe) {
          this._lazyInitEmptyStyle();
          const ke = this.style.getImage(qe);
          if (!ke)
            return void this.fire(new ne.y(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
          const He = xe instanceof HTMLImageElement || ImageBitmap && xe instanceof ImageBitmap ? ne.q.getImageData(xe) : xe, { width: ir, height: ar, data: yr } = He;
          if (ir === void 0 || ar === void 0)
            return void this.fire(new ne.y(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
          if (ir !== (ke.usvg ? ke.icon.usvg_tree.width : ke.data.width) || ar !== (ke.usvg ? ke.icon.usvg_tree.height : ke.data.height))
            return void this.fire(new ne.y(new Error(`The width and height of the updated image (${ir}, ${ar})
                must be that same as the previous version of the image
                (${ke.data.width}, ${ke.data.height})`)));
          const Tr = !(xe instanceof HTMLImageElement || ImageBitmap && xe instanceof ImageBitmap);
          let $r = !1;
          ke.usvg ? (ke.data = new ne.r({ width: ir, height: ar }, new Uint8Array(yr)), ke.usvg = !1, ke.icon = void 0, $r = !0) : ke.data.replace(yr, Tr), this.style.updateImage(qe, ke, $r);
        }
        hasImage(qe) {
          return qe ? !!this.style && !!this.style.getImage(qe) : (this.fire(new ne.y(new Error("Missing required image id"))), !1);
        }
        removeImage(qe) {
          this.style.removeImage(qe);
        }
        loadImage(qe, xe) {
          ne.o(this._requestManager.transformRequest(qe, ne.R.Image), (ke, He) => {
            xe(ke, He instanceof HTMLImageElement ? ne.q.getImageData(He) : He);
          });
        }
        listImages() {
          return this.style.listImages();
        }
        addModel(qe, xe) {
          this._lazyInitEmptyStyle(), this.style.addModel(qe, xe);
        }
        hasModel(qe) {
          return qe ? this.style.hasModel(qe) : (this.fire(new ne.y(new Error("Missing required model id"))), !1);
        }
        removeModel(qe) {
          this.style.removeModel(qe);
        }
        listModels() {
          return this.style.listModels();
        }
        addLayer(qe, xe) {
          return this._isValidId(qe.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(qe, xe), this._update(!0)) : this;
        }
        getSlot(qe) {
          const xe = this.getLayer(qe);
          return xe && xe.slot || null;
        }
        setSlot(qe, xe) {
          return this.style.setSlot(qe, xe), this.style.mergeLayers(), this._update(!0);
        }
        addImport(qe, xe) {
          return this.style.addImport(qe, xe), this;
        }
        updateImport(qe, xe) {
          return typeof xe != "string" && xe.id !== qe ? (this.removeImport(qe), this.addImport(xe)) : (this.style.updateImport(qe, xe), this._update(!0));
        }
        removeImport(qe) {
          return this.style.removeImport(qe), this;
        }
        moveImport(qe, xe) {
          return this.style.moveImport(qe, xe), this._update(!0);
        }
        moveLayer(qe, xe) {
          return this._isValidId(qe) ? (this.style.moveLayer(qe, xe), this._update(!0)) : this;
        }
        removeLayer(qe) {
          return this._isValidId(qe) ? (this.style.removeLayer(qe), this._update(!0)) : this;
        }
        getLayer(qe) {
          if (!this._isValidId(qe))
            return null;
          const xe = this.style.getOwnLayer(qe);
          return xe ? xe.type === "custom" ? xe.implementation : xe.serialize() : void 0;
        }
        getSlots() {
          return this.style.getSlots();
        }
        setLayerZoomRange(qe, xe, ke) {
          return this._isValidId(qe) ? (this.style.setLayerZoomRange(qe, xe, ke), this._update(!0)) : this;
        }
        setFilter(qe, xe, ke = {}) {
          return this._isValidId(qe) ? (this.style.setFilter(qe, xe, ke), this._update(!0)) : this;
        }
        getFilter(qe) {
          return this._isValidId(qe) ? this.style.getFilter(qe) : null;
        }
        setPaintProperty(qe, xe, ke, He = {}) {
          return this._isValidId(qe) ? (this.style.setPaintProperty(qe, xe, ke, He), this._update(!0)) : this;
        }
        getPaintProperty(qe, xe) {
          return this._isValidId(qe) ? this.style.getPaintProperty(qe, xe) : null;
        }
        setLayoutProperty(qe, xe, ke, He = {}) {
          return this._isValidId(qe) ? (this.style.setLayoutProperty(qe, xe, ke, He), this._update(!0)) : this;
        }
        getLayoutProperty(qe, xe) {
          return this._isValidId(qe) ? this.style.getLayoutProperty(qe, xe) : null;
        }
        getSchema(qe) {
          return this.style.getSchema(qe);
        }
        setSchema(qe, xe) {
          return this.style.setSchema(qe, xe), this._update(!0);
        }
        getConfig(qe) {
          return this.style.getConfig(qe);
        }
        setConfig(qe, xe) {
          return this.style.setConfig(qe, xe), this._update(!0);
        }
        getConfigProperty(qe, xe) {
          return this.style.getConfigProperty(qe, xe);
        }
        setConfigProperty(qe, xe, ke) {
          return this.style.setConfigProperty(qe, xe, ke), this._update(!0);
        }
        getFeaturesetDescriptors(qe) {
          return this.style.getFeaturesetDescriptors(qe);
        }
        setLights(qe) {
          if (this._lazyInitEmptyStyle(), qe && qe.length === 1 && qe[0].type === "flat") {
            const xe = qe[0];
            xe.properties ? this.style.setFlatLight(xe.properties, xe.id, {}) : this.style.setFlatLight({}, "flat");
          } else
            this.style.setLights(qe), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = !0);
          return this._update(!0);
        }
        getLights() {
          const qe = this.style.getLights() || [];
          return qe.length === 0 && qe.push({ id: this.style.light.id, type: "flat", properties: this.style.getFlatLight() }), qe;
        }
        setLight(qe, xe = {}) {
          return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([{ id: "flat", type: "flat", properties: qe }]);
        }
        getLight() {
          return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
        }
        setTerrain(qe) {
          return this._lazyInitEmptyStyle(), !qe && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(qe), this._averageElevationLastSampledAt = -1 / 0, this._update(!0);
        }
        getTerrain() {
          return this.style ? this.style.getTerrain() : null;
        }
        setFog(qe) {
          return this._lazyInitEmptyStyle(), this.style.setFog(qe), this._update(!0);
        }
        getFog() {
          return this.style ? this.style.getFog() : null;
        }
        setSnow(qe) {
          return this._lazyInitEmptyStyle(), this.style.setSnow(qe), this._update(!0);
        }
        getSnow() {
          return this.style ? this.style.getSnow() : null;
        }
        setRain(qe) {
          return this._lazyInitEmptyStyle(), this.style.setRain(qe), this._update(!0);
        }
        getRain() {
          return this.style ? this.style.getRain() : null;
        }
        setColorTheme(qe) {
          return this._lazyInitEmptyStyle(), this.style.setColorTheme(qe), this._update(!0);
        }
        setImportColorTheme(qe, xe) {
          return this._lazyInitEmptyStyle(), this.style.setImportColorTheme(qe, xe), this._update(!0);
        }
        setCamera(qe) {
          return this.style.setCamera(qe), this._triggerCameraUpdate(qe);
        }
        _triggerCameraUpdate(qe) {
          return this._update(this.transform.setOrthographicProjectionAtLowPitch(qe["camera-projection"] === "orthographic"));
        }
        getCamera() {
          return this.style.camera;
        }
        _queryFogOpacity(qe) {
          return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(ne.bO.convert(qe), this.transform) : 0;
        }
        setFeatureState(qe, xe) {
          return qe.source && !this._isValidId(qe.source) ? this : (this.style.setFeatureState(qe, xe), this._update());
        }
        removeFeatureState(qe, xe) {
          return qe.source && !this._isValidId(qe.source) ? this : (this.style.removeFeatureState(qe, xe), this._update());
        }
        getFeatureState(qe) {
          return qe.source && !this._isValidId(qe.source) ? null : this.style.getFeatureState(qe);
        }
        _updateContainerDimensions() {
          if (!this._container)
            return;
          const qe = this._container.getBoundingClientRect().width || 400, xe = this._container.getBoundingClientRect().height || 300;
          let ke, He, ir, ar = this._container;
          for (; ar && (!He || !ir); ) {
            const yr = window.getComputedStyle(ar).transform;
            yr && yr !== "none" && (ke = yr.match(/matrix.*\((.+)\)/)[1].split(", "), ke[0] && ke[0] !== "0" && ke[0] !== "1" && (He = ke[0]), ke[3] && ke[3] !== "0" && ke[3] !== "1" && (ir = ke[3])), ar = ar.parentElement;
          }
          this._containerWidth = He ? Math.abs(qe / He) : qe, this._containerHeight = ir ? Math.abs(xe / ir) : xe;
        }
        _detectMissingCSS() {
          window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") !== "rgb(250, 128, 114)" && ne.w("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
        }
        _setupContainer() {
          const qe = this._container;
          qe.classList.add("mapboxgl-map"), (this._missingCSSCanary = Rr("div", "mapboxgl-canary", qe)).style.visibility = "hidden", this._detectMissingCSS();
          const xe = this._canvasContainer = Rr("div", "mapboxgl-canvas-container", qe);
          this._canvas = Rr("canvas", "mapboxgl-canvas", xe), this._interactive && (xe.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
          const ke = this._controlContainer = Rr("div", "mapboxgl-control-container", qe), He = this._controlPositions = {};
          ["top-left", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left"].forEach((ir) => {
            He[ir] = Rr("div", `mapboxgl-ctrl-${ir}`, ke);
          }), this._container.addEventListener("scroll", this._onMapScroll, !1);
        }
        _resizeCanvas(qe, xe) {
          const ke = ne.q.devicePixelRatio || 1;
          this._canvas.width = ke * Math.ceil(qe), this._canvas.height = ke * Math.ceil(xe), this._canvas.style.width = `${qe}px`, this._canvas.style.height = `${xe}px`;
        }
        _addMarker(qe) {
          this._markers.push(qe);
        }
        _removeMarker(qe) {
          const xe = this._markers.indexOf(qe);
          xe !== -1 && this._markers.splice(xe, 1);
        }
        _addPopup(qe) {
          this._popups.push(qe);
        }
        _removePopup(qe) {
          const xe = this._popups.indexOf(qe);
          xe !== -1 && this._popups.splice(xe, 1);
        }
        _setupPainter() {
          const qe = ne.l({}, Ar.supported.webGLContextAttributes, { failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat, preserveDrawingBuffer: this._preserveDrawingBuffer, antialias: this._antialias || !1 }), xe = this._canvas.getContext("webgl2", qe);
          xe ? (hi(xe, !0), this.painter = new ef(xe, this._contextCreateOptions, this.transform, this._scaleFactor, this._tp), this.on("data", (ke) => {
            ke.dataType === "source" && this.painter.setTileLoadedFlag(!0);
          }), ne.m.testSupport(xe)) : this.fire(new ne.y(new Error("Failed to initialize WebGL")));
        }
        _contextLost(qe) {
          qe.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new ne.z("webglcontextlost", { originalEvent: qe }));
        }
        _contextRestored(qe) {
          this._setupPainter(), this.resize(), this._update(), this.fire(new ne.z("webglcontextrestored", { originalEvent: qe }));
        }
        _onMapScroll(qe) {
          if (qe.target === this._container)
            return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
        }
        idle() {
          return !this.isMoving() && this.loaded();
        }
        loaded() {
          return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
        }
        frameReady() {
          return this.loaded() && !this._placementDirty;
        }
        _update(qe) {
          return this.style ? (this._styleDirty = this._styleDirty || qe, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
        }
        _requestRenderFrame(qe) {
          return this._update(), this._renderTaskQueue.add(qe);
        }
        _cancelRenderFrame(qe) {
          this._renderTaskQueue.remove(qe);
        }
        _requestDomTask(qe) {
          !this.loaded() || this.loaded() && !this.isMoving() ? qe() : this._domRenderTaskQueue.add(qe);
        }
        _render(qe) {
          let xe;
          this.fire(new ne.z("renderstart")), ++this._frameId;
          const ke = this.painter.context.extTimerQuery, He = ne.q.now(), ir = this.painter.context.gl;
          if (this.listens("gpu-timing-frame") && (xe = ir.createQuery(), ir.beginQuery(ke.TIME_ELAPSED_EXT, xe)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], performance.now())), this._renderTaskQueue.run(qe), this._domRenderTaskQueue.run(qe), this._removed)
            return;
          this._updateProjectionTransition();
          const ar = this._isInitialLoad ? 0 : this._fadeDuration;
          if (this.style && this._styleDirty) {
            this._styleDirty = !1;
            const Dr = this.transform.zoom, Or = this.transform.pitch, Gr = ne.q.now(), qr = new ne.a8(Dr, { now: Gr, fadeDuration: ar, pitch: Or, transition: this.style.transition });
            this.style.update(qr);
          }
          this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = !0, this._sourcesDirty = !0);
          let yr = !1;
          this.style && this._sourcesDirty ? (this._sourcesDirty = !1, this.painter._updateFog(this.style), this._updateTerrain(), yr = this._updateAverageElevation(He), this.style.updateSources(this.transform), this._forceMarkerAndPopupUpdate()) : yr = this._updateAverageElevation(He);
          const Tr = this.style && this.style._updatePlacement(this.painter, this.painter.transform, this.showCollisionBoxes, ar, this._crossSourceCollisions, this.painter.replacementSource, this._scaleFactorChanged);
          if (this._scaleFactorChanged && (this._scaleFactorChanged = !1), Tr && (this._placementDirty = Tr.needsRerender), this.style && this.painter.render(this.style, { showTileBoundaries: this.showTileBoundaries, showParseStatus: this.showParseStatus, wireframe: { terrain: this.showTerrainWireframe, layers2D: this.showLayers2DWireframe, layers3D: this.showLayers3DWireframe }, showOverdrawInspector: this._showOverdrawInspector, showQueryGeometry: !!this._showQueryGeometry, showTileAABBs: this.showTileAABBs, rotating: this.isRotating(), zooming: this.isZooming(), moving: this.isMoving(), fadeDuration: ar, isInitialLoad: this._isInitialLoad, showPadding: this.showPadding, gpuTiming: !!this.listens("gpu-timing-layer"), gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"), speedIndexTiming: this.speedIndexTiming }), this.fire(new ne.z("render")), this.loaded() && !this._loaded && (this._loaded = !0, or.mark(gr.load), this.fire(new ne.z("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = !0), this.style && (this.style.snow || this.style.rain) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), xe) {
            const Dr = ne.q.now() - He;
            ir.endQuery(ke.TIME_ELAPSED_EXT), setTimeout(() => {
              const Or = ir.getQueryParameter(xe, ir.QUERY_RESULT) / 1e6;
              ir.deleteQuery(xe), this.fire(new ne.z("gpu-timing-frame", { cpuTime: Dr, gpuTime: Or }));
            }, 50);
          }
          if (this.listens("gpu-timing-layer")) {
            const Dr = this.painter.collectGpuTimers();
            setTimeout(() => {
              const Or = this.painter.queryGpuTimers(Dr);
              this.fire(new ne.z("gpu-timing-layer", { layerTimes: Or }));
            }, 50);
          }
          if (this.listens("gpu-timing-deferred-render")) {
            const Dr = this.painter.collectDeferredRenderGpuQueries();
            setTimeout(() => {
              const Or = this.painter.queryGpuTimeDeferredRender(Dr);
              this.fire(new ne.z("gpu-timing-deferred-render", { gpuTime: Or }));
            }, 50);
          }
          const $r = this._sourcesDirty || this._styleDirty || this._placementDirty || yr;
          if ($r || this._repaint)
            this.triggerRepaint();
          else {
            const Dr = this.idle();
            if (Dr && (yr = this._updateAverageElevation(He, !0)), yr)
              this.triggerRepaint();
            else if (this._triggerFrame(!1), Dr && (this.fire(new ne.z("idle")), this._isInitialLoad = !1, this.speedIndexTiming)) {
              const Or = this._calculateSpeedIndex();
              this.fire(new ne.z("speedindexcompleted", { speedIndex: Or })), this.speedIndexTiming = !1;
            }
          }
          !this._loaded || this._fullyLoaded || $r || (this._fullyLoaded = !0, or.mark(gr.fullLoad), this._performanceMetricsCollection && mi(this._requestManager._customAccessToken, { width: this.painter.width, height: this.painter.height, interactionRange: this._interactionRange, visibilityHidden: this._visibilityHidden, terrainEnabled: !!this.painter.style.getTerrain(), fogEnabled: !!this.painter.style.getFog(), projection: this.getProjection().name, zoom: this.transform.zoom, renderer: this.painter.context.renderer, vendor: this.painter.context.vendor }), this._authenticate());
        }
        _forceMarkerAndPopupUpdate(qe) {
          for (const xe of this._markers)
            qe && !this.getRenderWorldCopies() && (xe._lngLat = xe._lngLat.wrap()), xe._update();
          for (const xe of this._popups)
            !qe || this.getRenderWorldCopies() || xe._trackPointer || (xe._lngLat = xe._lngLat.wrap()), xe._update();
        }
        _updateAverageElevation(qe, xe = !1) {
          const ke = (ir) => (this.transform.averageElevation = ir, this._update(!1), !0);
          if (!this.painter.averageElevationNeedsEasing())
            return this.transform.averageElevation !== 0 && ke(0);
          const He = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
          if (He || (xe || qe - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(qe)) {
            const ir = this.transform.averageElevation;
            let ar = this.transform.sampleAverageElevation();
            this.transform.elevation != null && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(ar) ? ar = 0 : this._averageElevationLastSampledAt = qe;
            const yr = Math.abs(ir - ar);
            if (yr > 1) {
              if (this._isInitialLoad || He)
                return this._averageElevation.jumpTo(ar), ke(ar);
              this._averageElevation.easeTo(ar, qe, 300);
            } else if (yr > 1e-4)
              return this._averageElevation.jumpTo(ar), ke(ar);
          }
          return !!this._averageElevation.isEasing(qe) && ke(this._averageElevation.getValue(qe));
        }
        _authenticate() {
          Zr(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (qe) => {
            if (qe && (qe.message === ze || qe.status === 401)) {
              const xe = this.painter.context.gl;
              hi(xe, !1), this._logoControl instanceof pa && this._logoControl._updateLogo(), xe && xe.clear(xe.DEPTH_BUFFER_BIT | xe.COLOR_BUFFER_BIT | xe.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new ne.y(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
            }
          }), vi(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, () => {
          });
        }
        _postStyleLoadEvent() {
          this.style.globalId && wi(this._requestManager._customAccessToken, { map: this, skuToken: this._requestManager._skuToken, style: this.style.globalId, importedStyles: this.style.getImportGlobalIds() });
        }
        _updateTerrain() {
          const qe = this._isDragging();
          this.painter.updateTerrain(this.style, qe);
        }
        _calculateSpeedIndex() {
          const qe = this.painter.canvasCopy(), xe = this.painter.getCanvasCopiesAndTimestamps();
          xe.timeStamps.push(performance.now());
          const ke = this.painter.context.gl, He = ke.createFramebuffer();
          function ir(ar) {
            ke.framebufferTexture2D(ke.FRAMEBUFFER, ke.COLOR_ATTACHMENT0, ke.TEXTURE_2D, ar, 0);
            const yr = new Uint8Array(ke.drawingBufferWidth * ke.drawingBufferHeight * 4);
            return ke.readPixels(0, 0, ke.drawingBufferWidth, ke.drawingBufferHeight, ke.RGBA, ke.UNSIGNED_BYTE, yr), yr;
          }
          return ke.bindFramebuffer(ke.FRAMEBUFFER, He), this._canvasPixelComparison(ir(qe), xe.canvasCopies.map(ir), xe.timeStamps);
        }
        _canvasPixelComparison(qe, xe, ke) {
          let He = ke[1] - ke[0];
          const ir = qe.length / 4;
          for (let ar = 0; ar < xe.length; ar++) {
            const yr = xe[ar];
            let Tr = 0;
            for (let $r = 0; $r < yr.length; $r += 4)
              yr[$r] === qe[$r] && yr[$r + 1] === qe[$r + 1] && yr[$r + 2] === qe[$r + 2] && yr[$r + 3] === qe[$r + 3] && (Tr += 1);
            He += (ke[ar + 2] - ke[ar + 1]) * (1 - Tr / ir);
          }
          return He;
        }
        remove() {
          this._hash && this._hash.remove();
          for (const xe of this._controls)
            xe.onRemove(this);
          this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.indoor.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), window.removeEventListener("resize", this._onWindowResize, !1), window.removeEventListener("orientationchange", this._onWindowResize, !1), window.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.removeEventListener("online", this._onWindowOnline, !1), window.removeEventListener("visibilitychange", this._onVisibilityChange, !1);
          const qe = this.painter.context.gl.getExtension("WEBGL_lose_context");
          qe && qe.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, !1), pi.delete(this.painter.context.gl), ei.remove(), Hr.remove(), this._removed = !0, this.fire(new ne.z("remove"));
        }
        triggerRepaint() {
          this._triggerFrame(!0);
        }
        _triggerFrame(qe) {
          this._renderNextFrame = this._renderNextFrame || qe, this.style && !this._frame && (this._frame = ne.q.frame((xe) => {
            const ke = !!this._renderNextFrame;
            this._frame = null, this._renderNextFrame = null, ke && this._render(xe);
          }));
        }
        _preloadTiles(qe) {
          const xe = this.style ? this.style.getSourceCaches() : [];
          return ne.bl(xe, (ke, He) => ke._preloadTiles(qe, He), () => {
            this.triggerRepaint();
          }), this;
        }
        _onWindowOnline() {
          this._update();
        }
        _onWindowResize(qe) {
          this._trackResize && this.resize({ originalEvent: qe })._update();
        }
        _onVisibilityChange() {
          document.visibilityState === "hidden" && this._visibilityHidden++;
        }
        get showTileBoundaries() {
          return !!this._showTileBoundaries;
        }
        set showTileBoundaries(qe) {
          this._showTileBoundaries !== qe && (this._showTileBoundaries = qe, this._tp.refreshUI(), this._update());
        }
        get showParseStatus() {
          return !!this._showParseStatus;
        }
        set showParseStatus(qe) {
          this._showParseStatus !== qe && (this._showParseStatus = qe, this._tp.refreshUI(), this._update());
        }
        get showTerrainWireframe() {
          return !!this._showTerrainWireframe;
        }
        set showTerrainWireframe(qe) {
          this._showTerrainWireframe !== qe && (this._showTerrainWireframe = qe, this._tp.refreshUI(), this._update());
        }
        get showLayers2DWireframe() {
          return !!this._showLayers2DWireframe;
        }
        set showLayers2DWireframe(qe) {
          this._showLayers2DWireframe !== qe && (this._showLayers2DWireframe = qe, this._tp.refreshUI(), this._update());
        }
        get showLayers3DWireframe() {
          return !!this._showLayers3DWireframe;
        }
        set showLayers3DWireframe(qe) {
          this._showLayers3DWireframe !== qe && (this._showLayers3DWireframe = qe, this._tp.refreshUI(), this._update());
        }
        get speedIndexTiming() {
          return !!this._speedIndexTiming;
        }
        set speedIndexTiming(qe) {
          this._speedIndexTiming !== qe && (this._speedIndexTiming = qe, this._update());
        }
        get showPadding() {
          return !!this._showPadding;
        }
        set showPadding(qe) {
          this._showPadding !== qe && (this._showPadding = qe, this._tp.refreshUI(), this._update());
        }
        get showCollisionBoxes() {
          return !!this._showCollisionBoxes;
        }
        set showCollisionBoxes(qe) {
          this._showCollisionBoxes !== qe && (this._showCollisionBoxes = qe, this._tp.refreshUI(), qe ? this.style._generateCollisionBoxes() : this._update());
        }
        get showOverdrawInspector() {
          return !!this._showOverdrawInspector;
        }
        set showOverdrawInspector(qe) {
          this._showOverdrawInspector !== qe && (this._showOverdrawInspector = qe, this._tp.refreshUI(), this._update());
        }
        get repaint() {
          return !!this._repaint;
        }
        set repaint(qe) {
          this._repaint !== qe && (this._repaint = qe, this._tp.refreshUI(), this.triggerRepaint());
        }
        get vertices() {
          return !!this._vertices;
        }
        set vertices(qe) {
          this._vertices = qe, this._update();
        }
        get showTileAABBs() {
          return !!this._showTileAABBs;
        }
        set showTileAABBs(qe) {
          this._showTileAABBs !== qe && (this._showTileAABBs = qe, this._tp.refreshUI(), qe && this._update());
        }
        _setCacheLimits(qe, xe) {
          ne.dG(qe, xe);
        }
        get version() {
          return rr;
        }
      }, NavigationControl: class {
        constructor(qe = {}) {
          this.options = ne.l({}, Ba, qe), this._container = Rr("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (xe) => xe.preventDefault()), this.options.showZoom && (ne.aP(["_setButtonTitle", "_updateZoomButtons"], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (xe) => {
            this._map && this._map.zoomIn({}, { originalEvent: xe });
          }), Rr("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (xe) => {
            this._map && this._map.zoomOut({}, { originalEvent: xe });
          }), Rr("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (ne.aP(["_rotateCompassArrow"], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (xe) => {
            const ke = this._map;
            ke && (this.options.visualizePitch ? ke.resetNorthPitch({}, { originalEvent: xe }) : ke.resetNorth({}, { originalEvent: xe }));
          }), this._compassIcon = Rr("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
        }
        _updateZoomButtons() {
          const qe = this._map;
          if (!qe)
            return;
          const xe = qe.getZoom(), ke = xe === qe.getMaxZoom(), He = xe === qe.getMinZoom();
          this._zoomInButton.disabled = ke, this._zoomOutButton.disabled = He, this._zoomInButton.setAttribute("aria-disabled", ke.toString()), this._zoomOutButton.setAttribute("aria-disabled", He.toString());
        }
        _rotateCompassArrow() {
          const qe = this._map;
          if (!qe)
            return;
          const xe = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(qe.transform.pitch * (Math.PI / 180)), 0.5)}) rotateX(${qe.transform.pitch}deg) rotateZ(${qe.transform.angle * (180 / Math.PI)}deg)` : `rotate(${qe.transform.angle * (180 / Math.PI)}deg)`;
          qe._requestDomTask(() => {
            this._compassIcon && (this._compassIcon.style.transform = xe);
          });
        }
        onAdd(qe) {
          return this._map = qe, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), qe.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && qe.on("pitch", this._rotateCompassArrow), qe.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new mu(qe, this._compass, this.options.visualizePitch)), this._container;
        }
        onRemove() {
          const qe = this._map;
          qe && (this._container.remove(), this.options.showZoom && qe.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && qe.off("pitch", this._rotateCompassArrow), qe.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
        }
        _createButton(qe, xe) {
          const ke = Rr("button", qe, this._container);
          return ke.type = "button", ke.addEventListener("click", xe), ke;
        }
        _setButtonTitle(qe, xe) {
          if (!this._map)
            return;
          const ke = this._map._getUIString(`NavigationControl.${xe}`);
          qe.setAttribute("aria-label", ke), qe.firstElementChild && qe.firstElementChild.setAttribute("title", ke);
        }
      }, GeolocateControl: class extends ne.E {
        constructor(qe = {}) {
          super();
          const xe = navigator.geolocation;
          this.options = ne.l({ geolocation: xe }, Fu, qe), ne.aP(["_onSuccess", "_onError", "_onZoom", "_finish", "_setupUI", "_updateCamera", "_updateMarker", "_updateMarkerRotation", "_onDeviceOrientation"], this), this._updateMarkerRotationThrottled = od(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
        }
        onAdd(qe) {
          return this._map = qe, this._container = Rr("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
        }
        onRemove() {
          this._geolocationWatchID !== void 0 && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = !1;
        }
        _checkGeolocationSupport(qe) {
          const xe = (ke = !!this.options.geolocation) => {
            this._supportsGeolocation = ke, qe(ke);
          };
          this._supportsGeolocation !== void 0 ? qe(this._supportsGeolocation) : navigator.permissions !== void 0 ? navigator.permissions.query({ name: "geolocation" }).then((ke) => xe(ke.state !== "denied")).catch(() => xe()) : xe();
        }
        _isOutOfMapMaxBounds(qe) {
          const xe = this._map.getMaxBounds(), ke = qe.coords;
          return !!xe && (ke.longitude < xe.getWest() || ke.longitude > xe.getEast() || ke.latitude < xe.getSouth() || ke.latitude > xe.getNorth());
        }
        _setErrorState() {
          switch (this._watchState) {
            case "WAITING_ACTIVE":
              this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
              break;
            case "ACTIVE_LOCK":
              this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
              break;
            case "BACKGROUND":
              this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
          }
        }
        _onSuccess(qe) {
          if (this._map) {
            if (this._isOutOfMapMaxBounds(qe))
              return this._setErrorState(), this.fire(new ne.z("outofmaxbounds", qe)), this._updateMarker(), void this._finish();
            if (this.options.trackUserLocation)
              switch (this._lastKnownPosition = qe, this._watchState) {
                case "WAITING_ACTIVE":
                case "ACTIVE_LOCK":
                case "ACTIVE_ERROR":
                  this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                  break;
                case "BACKGROUND":
                case "BACKGROUND_ERROR":
                  this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
              }
            this.options.showUserLocation && this._watchState !== "OFF" && this._updateMarker(qe), this.options.trackUserLocation && this._watchState !== "ACTIVE_LOCK" || this._updateCamera(qe), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new ne.z("geolocate", qe)), this._finish();
          }
        }
        _updateCamera(qe) {
          const xe = new ne.bO(qe.coords.longitude, qe.coords.latitude), ke = qe.coords.accuracy, He = this._map.getBearing(), ir = ne.l({ bearing: He }, this.options.fitBoundsOptions);
          this._map.fitBounds(xe.toBounds(ke), ir, { geolocateSource: !0 });
        }
        _updateMarker(qe) {
          if (qe) {
            const xe = new ne.bO(qe.coords.longitude, qe.coords.latitude);
            this._accuracyCircleMarker.setLngLat(xe).addTo(this._map), this._userLocationDotMarker.setLngLat(xe).addTo(this._map), this._accuracy = qe.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
          } else
            this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
        }
        _updateCircleRadius() {
          const qe = this._map.transform, xe = ne.bH(1, qe._center.lat) * qe.worldSize, ke = Math.ceil(2 * this._accuracy * xe);
          this._circleElement.style.width = `${ke}px`, this._circleElement.style.height = `${ke}px`;
        }
        _onZoom() {
          this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
        }
        _updateMarkerRotation() {
          this._userLocationDotMarker && typeof this._heading == "number" ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
        }
        _onError(qe) {
          if (this._map) {
            if (this.options.trackUserLocation)
              if (qe.code === 1) {
                this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                const xe = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                this._geolocateButton.setAttribute("aria-label", xe), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", xe), this._geolocationWatchID !== void 0 && this._clearWatch();
              } else {
                if (qe.code === 3 && this._noTimeout)
                  return;
                this._setErrorState();
              }
            this._watchState !== "OFF" && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new ne.z("error", qe)), this._finish();
          }
        }
        _finish() {
          this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
        }
        _setupUI(qe) {
          if (this._map !== void 0) {
            if (this._container.addEventListener("contextmenu", (xe) => xe.preventDefault()), this._geolocateButton = Rr("button", "mapboxgl-ctrl-geolocate", this._container), Rr("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", qe === !1) {
              ne.w("Geolocation support is not available so the GeolocateControl will be disabled.");
              const xe = this._map._getUIString("GeolocateControl.LocationNotAvailable");
              this._geolocateButton.disabled = !0, this._geolocateButton.setAttribute("aria-label", xe), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", xe);
            } else {
              const xe = this._map._getUIString("GeolocateControl.FindMyLocation");
              this._geolocateButton.setAttribute("aria-label", xe), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", xe);
            }
            this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = Rr("div", "mapboxgl-user-location"), this._dotElement.appendChild(Rr("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(Rr("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new uf({ element: this._dotElement, rotationAlignment: "map", pitchAlignment: "map" }), this._circleElement = Rr("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new uf({ element: this._circleElement, pitchAlignment: "map" }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (xe) => {
              xe.geolocateSource || this._watchState !== "ACTIVE_LOCK" || xe.originalEvent && xe.originalEvent.type === "resize" || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new ne.z("trackuserlocationend")));
            });
          }
        }
        _onDeviceOrientation(qe) {
          this._userLocationDotMarker && (qe.webkitCompassHeading ? this._heading = qe.webkitCompassHeading : qe.absolute === !0 && (this._heading = -1 * qe.alpha), this._updateMarkerRotationThrottled());
        }
        trigger() {
          if (!this._setup)
            return ne.w("Geolocate control triggered before added to a map"), !1;
          if (this.options.trackUserLocation) {
            switch (this._watchState) {
              case "OFF":
                this._watchState = "WAITING_ACTIVE", this.fire(new ne.z("trackuserlocationstart"));
                break;
              case "WAITING_ACTIVE":
              case "ACTIVE_LOCK":
              case "ACTIVE_ERROR":
              case "BACKGROUND_ERROR":
                this._numberOfWatches--, this._noTimeout = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new ne.z("trackuserlocationend"));
                break;
              case "BACKGROUND":
                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new ne.z("trackuserlocationstart"));
            }
            switch (this._watchState) {
              case "WAITING_ACTIVE":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                break;
              case "ACTIVE_LOCK":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                break;
              case "ACTIVE_ERROR":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                break;
              case "BACKGROUND":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                break;
              case "BACKGROUND_ERROR":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
            }
            if (this._watchState === "OFF" && this._geolocationWatchID !== void 0)
              this._clearWatch();
            else if (this._geolocationWatchID === void 0) {
              let qe;
              this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (qe = { maximumAge: 6e5, timeout: 0 }, this._noTimeout = !0) : (qe = this.options.positionOptions, this._noTimeout = !1), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, qe), this.options.showUserHeading && this._addDeviceOrientationListener();
            }
          } else
            this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = window.setTimeout(this._finish, 1e4);
          return !0;
        }
        _addDeviceOrientationListener() {
          const qe = () => {
            "ondeviceorientationabsolute" in window ? window.addEventListener("deviceorientationabsolute", this._onDeviceOrientation) : window.addEventListener("deviceorientation", this._onDeviceOrientation);
          };
          typeof DeviceMotionEvent < "u" && typeof DeviceMotionEvent.requestPermission == "function" ? DeviceOrientationEvent.requestPermission().then((xe) => {
            xe === "granted" && qe();
          }).catch(console.error) : qe();
        }
        _clearWatch() {
          this.options.geolocation.clearWatch(this._geolocationWatchID), window.removeEventListener("deviceorientation", this._onDeviceOrientation), window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
        }
      }, AttributionControl: Ou, ScaleControl: class {
        constructor(qe = {}) {
          this.options = ne.l({}, gu, qe), this._isNumberFormatSupported = function() {
            try {
              return new Intl.NumberFormat("en", { style: "unit", unitDisplay: "short", unit: "meter" }), !0;
            } catch {
              return !1;
            }
          }(), ne.aP(["_update", "_setScale", "setUnit"], this);
        }
        getDefaultPosition() {
          return "bottom-left";
        }
        _update() {
          const qe = this.options.maxWidth || 100, xe = this._map, ke = xe._containerHeight / 2, He = xe._containerWidth / 2 - qe / 2, ir = xe.unproject([He, ke]), ar = xe.unproject([He + qe, ke]), yr = ir.distanceTo(ar);
          if (this.options.unit === "imperial") {
            const Tr = 3.2808 * yr;
            Tr > 5280 ? this._setScale(qe, Tr / 5280, "mile") : this._setScale(qe, Tr, "foot");
          } else
            this.options.unit === "nautical" ? this._setScale(qe, yr / 1852, "nautical-mile") : yr >= 1e3 ? this._setScale(qe, yr / 1e3, "kilometer") : this._setScale(qe, yr, "meter");
        }
        _setScale(qe, xe, ke) {
          this._map._requestDomTask(() => {
            const He = function(ar) {
              const yr = Math.pow(10, `${Math.floor(ar)}`.length - 1);
              let Tr = ar / yr;
              return Tr = Tr >= 10 ? 10 : Tr >= 5 ? 5 : Tr >= 3 ? 3 : Tr >= 2 ? 2 : Tr >= 1 ? 1 : function($r) {
                const Dr = Math.pow(10, Math.ceil(-Math.log($r) / Math.LN10));
                return Math.round($r * Dr) / Dr;
              }(Tr), yr * Tr;
            }(xe), ir = He / xe;
            this._container.innerHTML = this._isNumberFormatSupported && ke !== "nautical-mile" ? new Intl.NumberFormat(this._language, { style: "unit", unitDisplay: "short", unit: ke }).format(He) : `${He}&nbsp;${As[ke]}`, this._container.style.width = qe * ir + "px";
          });
        }
        onAdd(qe) {
          return this._map = qe, this._language = qe.getLanguage(), this._container = Rr("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", qe.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
        }
        onRemove() {
          this._container.remove(), this._map.off("move", this._update), this._map = void 0;
        }
        _setLanguage(qe) {
          this._language = qe, this._update();
        }
        setUnit(qe) {
          this.options.unit = qe, this._update();
        }
      }, FullscreenControl: class {
        constructor(qe = {}) {
          this._fullscreen = !1, qe && qe.container && (qe.container instanceof HTMLElement ? this._container = qe.container : ne.w("Full screen control 'container' must be a DOM element.")), ne.aP(["_onClickFullscreen", "_changeIcon"], this), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in document && (this._fullscreenchange = "webkitfullscreenchange");
        }
        onAdd(qe) {
          return this._map = qe, this._container || (this._container = this._map.getContainer()), this._controlContainer = Rr("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", ne.w("This device does not support fullscreen mode.")), this._controlContainer;
        }
        onRemove() {
          this._controlContainer.remove(), this._map = null, document.removeEventListener(this._fullscreenchange, this._changeIcon);
        }
        _checkFullscreenSupport() {
          return !(!document.fullscreenEnabled && !document.webkitFullscreenEnabled);
        }
        _setupUI() {
          const qe = this._fullscreenButton = Rr("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
          Rr("span", "mapboxgl-ctrl-icon", qe).setAttribute("aria-hidden", "true"), qe.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), document.addEventListener(this._fullscreenchange, this._changeIcon);
        }
        _updateTitle() {
          const qe = this._getTitle();
          this._fullscreenButton.setAttribute("aria-label", qe), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", qe);
        }
        _getTitle() {
          return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
        }
        _isFullscreen() {
          return this._fullscreen;
        }
        _changeIcon() {
          (document.fullscreenElement || document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
        }
        _onClickFullscreen() {
          this._isFullscreen() ? document.exitFullscreen ? document.exitFullscreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
        }
      }, Popup: class extends ne.E {
        constructor(qe) {
          super(), this.options = ne.l(Object.create(bs), qe), ne.aP(["_update", "_onClose", "remove", "_onMouseEvent"], this), this._classList = new Set(qe && qe.className ? qe.className.trim().split(/\s+/) : []);
        }
        addTo(qe) {
          return this._map && this.remove(), this._map = qe, this.options.closeOnClick && qe.on("preclick", this._onClose), this.options.closeOnMove && qe.on("move", this._onClose), qe.on("remove", this.remove), this._update(), qe._addPopup(this), this._focusFirstElement(), this._trackPointer ? (qe.on("mousemove", this._onMouseEvent), qe.on("mouseup", this._onMouseEvent), qe._canvasContainer.classList.add("mapboxgl-track-pointer")) : qe.on("move", this._update), this.fire(new ne.z("open")), this;
        }
        isOpen() {
          return !!this._map;
        }
        remove() {
          this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
          const qe = this._map;
          return qe && (qe.off("move", this._update), qe.off("move", this._onClose), qe.off("preclick", this._onClose), qe.off("click", this._onClose), qe.off("remove", this.remove), qe.off("mousemove", this._onMouseEvent), qe.off("mouseup", this._onMouseEvent), qe.off("drag", this._onMouseEvent), qe._canvasContainer && qe._canvasContainer.classList.remove("mapboxgl-track-pointer"), qe._removePopup(this), this._map = void 0), this.fire(new ne.z("close")), this;
        }
        getLngLat() {
          return this._lngLat;
        }
        setLngLat(qe) {
          this._lngLat = ne.bO.convert(qe), this._pos = null, this._trackPointer = !1, this._update();
          const xe = this._map;
          return xe && (xe.on("move", this._update), xe.off("mousemove", this._onMouseEvent), xe._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
        }
        trackPointer() {
          this._trackPointer = !0, this._pos = null, this._update();
          const qe = this._map;
          return qe && (qe.off("move", this._update), qe.on("mousemove", this._onMouseEvent), qe.on("drag", this._onMouseEvent), qe._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
        }
        getElement() {
          return this._container;
        }
        setText(qe) {
          return this.setDOMContent(document.createTextNode(qe));
        }
        setHTML(qe) {
          const xe = document.createDocumentFragment(), ke = document.createElement("body");
          let He;
          for (ke.innerHTML = qe; He = ke.firstChild, He; )
            xe.appendChild(He);
          return this.setDOMContent(xe);
        }
        getMaxWidth() {
          return this._container && this._container.style.maxWidth;
        }
        setMaxWidth(qe) {
          return this.options.maxWidth = qe, this._update(), this;
        }
        setDOMContent(qe) {
          let xe = this._content;
          if (xe)
            for (; xe.hasChildNodes(); )
              xe.firstChild && xe.removeChild(xe.firstChild);
          else
            xe = this._content = Rr("div", "mapboxgl-popup-content", this._container || void 0);
          if (xe.appendChild(qe), this.options.closeButton) {
            const ke = this._closeButton = Rr("button", "mapboxgl-popup-close-button", xe);
            ke.type = "button", ke.setAttribute("aria-label", "Close popup"), ke.setAttribute("aria-hidden", "true"), ke.innerHTML = "&#215;", ke.addEventListener("click", this._onClose);
          }
          return this._update(), this._focusFirstElement(), this;
        }
        addClassName(qe) {
          return this._classList.add(qe), this._updateClassList(), this;
        }
        removeClassName(qe) {
          return this._classList.delete(qe), this._updateClassList(), this;
        }
        setOffset(qe) {
          return this.options.offset = qe, this._update(), this;
        }
        toggleClassName(qe) {
          let xe;
          return this._classList.delete(qe) ? xe = !1 : (this._classList.add(qe), xe = !0), this._updateClassList(), xe;
        }
        _onMouseEvent(qe) {
          this._update(qe.point);
        }
        _getAnchor(qe) {
          if (this.options.anchor)
            return this.options.anchor;
          const xe = this._map, ke = this._container, He = this._pos;
          if (!xe || !ke || !He)
            return "bottom";
          const ir = ke.offsetWidth, ar = ke.offsetHeight, yr = He.x < ir / 2, Tr = He.x > xe.transform.width - ir / 2;
          if (He.y + qe < ar)
            return yr ? "top-left" : Tr ? "top-right" : "top";
          if (He.y > xe.transform.height - ar) {
            if (yr)
              return "bottom-left";
            if (Tr)
              return "bottom-right";
          }
          return yr ? "left" : Tr ? "right" : "bottom";
        }
        _updateClassList() {
          const qe = this._container;
          if (!qe)
            return;
          const xe = [...this._classList];
          xe.push("mapboxgl-popup"), this._anchor && xe.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && xe.push("mapboxgl-popup-track-pointer"), qe.className = xe.join(" ");
        }
        _update(qe) {
          const xe = this._map, ke = this._content;
          if (!xe || !this._lngLat && !this._trackPointer || !ke)
            return;
          let He = this._container;
          if (He || (He = this._container = Rr("div", "mapboxgl-popup", xe.getContainer()), this._tip = Rr("div", "mapboxgl-popup-tip", He), He.appendChild(ke)), this.options.maxWidth && He.style.maxWidth !== this.options.maxWidth && (He.style.maxWidth = this.options.maxWidth), xe.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = r0(this._lngLat, this._pos, xe.transform)), !this._trackPointer || qe) {
            const ir = this._pos = this._trackPointer && qe instanceof ne.P ? qe : xe.project(this._lngLat), ar = em(this.options.offset), yr = this._anchor = this._getAnchor(ar.y), Tr = em(this.options.offset, yr), $r = ir.add(Tr).round();
            xe._requestDomTask(() => {
              this._container && yr && (this._container.style.transform = `${up[yr]} translate(${$r.x}px,${$r.y}px)`);
            });
          }
          if (!this._marker && xe._showingGlobe()) {
            const ir = ne.dH(xe.transform, this._lngLat) ? 0 : 1;
            this._setOpacity(ir);
          }
          this._updateClassList();
        }
        _focusFirstElement() {
          if (!this.options.focusAfterOpen || !this._container)
            return;
          const qe = this._container.querySelector(Fs);
          qe && qe.focus();
        }
        _onClose() {
          this.remove();
        }
        _setOpacity(qe) {
          this._container && (this._container.style.opacity = `${qe}`), this._content && (this._content.style.pointerEvents = qe ? "auto" : "none");
        }
      }, Marker: uf, Style: za, LngLat: ne.bO, LngLatBounds: ne.az, Point: ne.P, MercatorCoordinate: ne.aa, FreeCameraOptions: Oh, Evented: ne.E, config: ne.e, prewarm: ne.dM, clearPrewarmedResources: ne.dN, get accessToken() {
        return ne.e.ACCESS_TOKEN;
      }, set accessToken(qe) {
        ne.e.ACCESS_TOKEN = qe;
      }, get baseApiUrl() {
        return ne.e.API_URL;
      }, set baseApiUrl(qe) {
        ne.e.API_URL = qe;
      }, get workerCount() {
        return ne.dO.workerCount;
      }, set workerCount(qe) {
        ne.dO.workerCount = qe;
      }, get maxParallelImageRequests() {
        return ne.e.MAX_PARALLEL_IMAGE_REQUESTS;
      }, set maxParallelImageRequests(qe) {
        ne.e.MAX_PARALLEL_IMAGE_REQUESTS = qe;
      }, clearStorage(qe) {
        ne.dP(qe);
      }, get workerUrl() {
        return ne.dQ.workerUrl;
      }, set workerUrl(qe) {
        ne.dQ.workerUrl = qe;
      }, get workerClass() {
        return ne.dQ.workerClass;
      }, set workerClass(qe) {
        ne.dQ.workerClass = qe;
      }, get workerParams() {
        return ne.dQ.workerParams;
      }, set workerParams(qe) {
        ne.dQ.workerParams = qe;
      }, get dracoUrl() {
        return ne.dR();
      }, set dracoUrl(qe) {
        ne.dS(qe);
      }, get meshoptUrl() {
        return ne.dT();
      }, set meshoptUrl(qe) {
        ne.dU(qe);
      }, setNow: ne.q.setNow, restoreNow: ne.q.restoreNow };
    });
    var Ze = $e;
    return Ze;
  });
})(mapboxGl);
const mapboxgl = /* @__PURE__ */ getDefaultExportFromCjs$1(mapboxGl.exports);
function debounce(m, c) {
  let ie = null;
  const we = this;
  return () => {
    clearTimeout(ie);
    var $e = arguments;
    ie = setTimeout(() => {
      m.apply(we, $e);
    }, c);
  };
}
const _hoisted_1$s = { class: "map" }, _sfc_main$B = /* @__PURE__ */ defineComponent({
  __name: "MapboxMap",
  props: {
    bounds: {},
    padding: {},
    mapboxAccessToken: {},
    mapboxStyle: {},
    projection: {},
    bearing: {},
    pitch: {},
    synchronousPrecision: {},
    ratio: {}
  },
  emits: ["update:bounds"],
  setup(m, { emit: c }) {
    const ie = m, we = c;
    function $e(Ar) {
      return { left: Ar[0], top: Ar[1], right: Ar[2], bottom: Ar[3] };
    }
    const Me = ref$1(), { width: Ze, height: ne } = useElementBounding(Me);
    let rr;
    const gr = () => {
      rr?.fitBounds(ie.bounds, { padding: $e(ie.padding), pitch: ie.pitch, bearing: ie.bearing });
    }, or = () => {
      if (Lr.value && rr) {
        const { x: Ar, y: Rr, width: Nr, height: Yr } = Lr.value, Vr = rr.unproject([Ar + Nr, Rr]), Xr = rr.unproject([Ar, Rr + Yr]);
        Ir.value = [Xr.lng, Xr.lat, Vr.lng, Vr.lat].map((Wr) => Number(Wr.toFixed(ie.synchronousPrecision)));
      }
    };
    onMounted(() => {
      rr = new mapboxgl.Map({
        container: Me.value,
        style: ie.mapboxStyle,
        bounds: ie.bounds,
        accessToken: ie.mapboxAccessToken,
        projection: ie.projection,
        bearing: ie.bearing,
        pitch: ie.pitch
      }), rr.on("render", or), rr.on("load", () => {
        gr();
      });
    }), watch(
      () => ie.mapboxStyle,
      () => {
        rr?.setStyle(ie.mapboxStyle);
      }
    ), watch(
      () => ie.projection,
      () => {
        rr?.setProjection(ie.projection);
      }
    ), watch(
      () => ie.bearing,
      () => {
        rr?.setBearing(ie.bearing);
      }
    ), watch(
      () => ie.pitch,
      () => {
        rr?.setPitch(ie.pitch);
      }
    ), watch([() => ie.bounds, () => ie.padding], gr);
    const _r = computed(() => Ze.value && ne.value ? Ze.value / ne.value : 1), Lr = computed(() => {
      const Ar = Ze.value - ie.padding[0] - ie.padding[2], Rr = ne.value - ie.padding[1] - ie.padding[3];
      if (_r.value >= ie.ratio) {
        const Nr = Rr * ie.ratio;
        return {
          x: ie.padding[0] + (Ar - Nr) / 2,
          y: ie.padding[1] + 0,
          width: Nr,
          height: Rr
        };
      } else {
        const Nr = Ar / ie.ratio;
        return {
          x: ie.padding[0] + 0,
          y: ie.padding[1] + (Rr - Nr) / 2,
          width: Ar,
          height: Nr
        };
      }
    }), Ir = ref$1();
    return watch(
      Ir,
      debounce(() => {
        !isEqual(Ir.value, ie.bounds) && Ir.value && we("update:bounds", Ir.value);
      }, 100)
    ), (Ar, Rr) => (openBlock(), createElementBlock("div", _hoisted_1$s, [
      createElementVNode("div", {
        ref_key: "mapboxMapRef",
        ref: Me,
        class: "mapbox-map"
      }, null, 512),
      Lr.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "layer",
        style: normalizeStyle({
          "--x": `${Lr.value.x}px`,
          "--y": `${Lr.value.y}px`,
          "--width": `${Lr.value.width}px`,
          "--height": `${Lr.value.height}px`
        })
      }, [
        renderSlot(Ar.$slots, "layer", {
          bounds: Ir.value,
          bbox: Lr.value,
          map: unref(rr)
        }, void 0, !0)
      ], 4)) : createCommentVNode("", !0)
    ]));
  }
}), MapboxMap_vue_vue_type_style_index_0_scoped_8f6ef37a_lang = "", MapboxMap = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["__scopeId", "data-v-8f6ef37a"]]), _hoisted_1$r = { class: "preview-image" }, _hoisted_2$j = ["src"], _hoisted_3$b = { class: "map-wrapper" }, _sfc_main$A = /* @__PURE__ */ defineComponent({
  __name: "Map",
  props: {
    modelValue: {},
    padding: { default: 0 },
    mapStyle: { default: "mapbox://styles/mapbox/streets-v11" },
    mapboxAccessToken: {},
    type: { default: "popup" },
    aspectRatio: {}
  },
  emits: ["update:model-value"],
  setup(m, { emit: c }) {
    const ie = m, we = c, $e = ref$1(), { width: Me } = useElementBounding($e), Ze = ref$1(!1);
    watch(Ze, () => {
      Ze.value || (ne.value = rr.value, we("update:model-value", ne.value));
    });
    const ne = ref$1(ie.modelValue), rr = ref$1(ie.modelValue), gr = debounce((Lr) => {
      rr.value = Lr, ie.type === "inline" && we("update:model-value", rr.value);
    }, 500);
    function or() {
      const Lr = ie.mapStyle?.replace("mapbox://styles/", ""), Ir = Math.round(Me.value ?? 200);
      return `https://api.mapbox.com/styles/v1/${Lr}/static/[${ne.value.join(",")}]/${Ir}x${Math.round(
        Ir / ie.aspectRatio
      )}@2x?access_token=${ie.mapboxAccessToken}`;
    }
    const _r = ref$1(or());
    return watch(
      ne,
      debounce(() => {
        _r.value = or();
      }, 500)
    ), (Lr, Ir) => (openBlock(), createElementBlock("div", {
      ref_key: "mapFieldRef",
      ref: $e,
      class: normalizeClass(["field-map", { ["type-" + Lr.type]: !0 }]),
      style: normalizeStyle({ "--aspect-ratio": Lr.aspectRatio })
    }, [
      Lr.type === "inline" ? (openBlock(), createBlock(MapboxMap, {
        key: 0,
        bounds: Lr.modelValue,
        "onUpdate:bounds": unref(gr),
        bearing: 0,
        pitch: 0,
        "mapbox-access-token": Lr.mapboxAccessToken,
        "mapbox-style": Lr.mapStyle,
        padding: [Lr.padding, Lr.padding, Lr.padding, Lr.padding],
        projection: { name: "globe" },
        ratio: Lr.aspectRatio,
        "synchronous-precision": 8
      }, {
        layer: withCtx(({ bounds: Ar, map: Rr, bbox: Nr }) => [
          Ar && Rr ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "layer-wrapper",
            style: normalizeStyle({
              "--x": `${Rr.project([Ar[0], Ar[1]]).x}px`,
              "--y": `${Rr.project([Ar[2], Ar[3]]).y}px`,
              "--width": `${Rr.project([Ar[2], Ar[3]]).x - Rr.project([Ar[0], Ar[1]]).x}px`,
              "--height": `${Rr.project([Ar[0], Ar[1]]).y - Rr.project([Ar[2], Ar[3]]).y}px`
            })
          }, Ir[1] || (Ir[1] = [
            createElementVNode("div", { class: "overlay" }, null, -1),
            createElementVNode("div", { class: "viewport-border" }, null, -1)
          ]), 4)) : createCommentVNode("", !0)
        ]),
        _: 1
      }, 8, ["bounds", "onUpdate:bounds", "mapbox-access-token", "mapbox-style", "padding", "ratio"])) : (openBlock(), createBlock(_sfc_main$18, {
        key: 1,
        type: "layer",
        transculent: "",
        show: Ze.value,
        "onUpdate:show": Ir[0] || (Ir[0] = (Ar) => Ze.value = Ar)
      }, {
        trigger: withCtx(() => [
          createElementVNode("div", _hoisted_1$r, [
            createElementVNode("img", { src: _r.value }, null, 8, _hoisted_2$j)
          ])
        ]),
        "close-btn": withCtx(() => [
          createVNode(BxButton, {
            round: "",
            tertiary: "",
            class: "close-btn"
          }, {
            default: withCtx(() => Ir[2] || (Ir[2] = [
              createTextVNode(" Done ")
            ])),
            _: 1
          })
        ]),
        default: withCtx(() => [
          createElementVNode("div", _hoisted_3$b, [
            createVNode(MapboxMap, {
              bounds: Lr.modelValue,
              "onUpdate:bounds": unref(gr),
              bearing: 0,
              pitch: 0,
              "mapbox-access-token": Lr.mapboxAccessToken,
              "mapbox-style": Lr.mapStyle,
              padding: [Lr.padding, Lr.padding, Lr.padding, Lr.padding],
              projection: { name: "globe" },
              ratio: Lr.aspectRatio,
              "synchronous-precision": 8
            }, {
              layer: withCtx(({ bounds: Ar, map: Rr, bbox: Nr }) => [
                Ar && Rr ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: "layer-wrapper",
                  style: normalizeStyle({
                    "--x": `${Rr.project([Ar[0], Ar[1]]).x}px`,
                    "--y": `${Rr.project([Ar[2], Ar[3]]).y}px`,
                    "--width": `${Rr.project([Ar[2], Ar[3]]).x - Rr.project([Ar[0], Ar[1]]).x}px`,
                    "--height": `${Rr.project([Ar[0], Ar[1]]).y - Rr.project([Ar[2], Ar[3]]).y}px`
                  })
                }, Ir[3] || (Ir[3] = [
                  createElementVNode("div", { class: "overlay" }, null, -1),
                  createElementVNode("div", { class: "viewport-border" }, null, -1),
                  createElementVNode("div", { class: "marker" }, [
                    createElementVNode("svg", {
                      version: "1.0",
                      id: "Layer_1",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      viewBox: "0 0 64 64",
                      "enable-background": "new 0 0 64 64",
                      "xml:space": "preserve"
                    }, [
                      createElementVNode("path", { d: "M32,0C18.746,0,8,10.746,8,24c0,5.219,1.711,10.008,4.555,13.93c0.051,0.094,0.059,0.199,0.117,0.289l16,24 C29.414,63.332,30.664,64,32,64s2.586-0.668,3.328-1.781l16-24c0.059-0.09,0.066-0.195,0.117-0.289C54.289,34.008,56,29.219,56,24 C56,10.746,45.254,0,32,0z M32,32c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S36.418,32,32,32z" })
                    ])
                  ], -1)
                ]), 4)) : createCommentVNode("", !0)
              ]),
              _: 1
            }, 8, ["bounds", "onUpdate:bounds", "mapbox-access-token", "mapbox-style", "padding", "ratio"])
          ])
        ]),
        _: 1
      }, 8, ["show"]))
    ], 6));
  }
}), Map_vue_vue_type_style_index_0_scoped_2e4a6276_lamng_scss_lang = "", Map_vue_vue_type_style_index_1_lang = "", Map$1 = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["__scopeId", "data-v-2e4a6276"]]), _hoisted_1$q = { class: "field-color" }, _sfc_main$z = /* @__PURE__ */ defineComponent({
  __name: "Color",
  props: /* @__PURE__ */ mergeModels({
    alpha: { type: Boolean }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue");
    return (ie, we) => (openBlock(), createElementBlock("div", _hoisted_1$q, [
      withDirectives(createElementVNode("input", {
        type: "color",
        "onUpdate:modelValue": we[0] || (we[0] = ($e) => c.value = $e)
      }, null, 512), [
        [vModelText, c.value]
      ])
    ]));
  }
}), Color_vue_vue_type_style_index_0_scoped_14e2dc54_lang = "", Color = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["__scopeId", "data-v-14e2dc54"]]);
function e$1(m, c, ie = 1e3, we) {
  let $e, Me = 0;
  const Ze = () => {
    $e && clearTimeout($e);
  };
  return watch(m, async (ne, rr) => {
    we && we(ne, rr);
    const gr = () => (Ze(), Me = Date.now(), c(ne, rr)), or = Date.now() - Me;
    or >= ie ? gr() : (Ze(), $e = setTimeout(gr, ie - or));
  });
}
const _sfc_main$y = /* @__PURE__ */ defineComponent({
  __name: "BxSlider",
  props: /* @__PURE__ */ mergeModels({
    min: {},
    max: {},
    step: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue"), ie = m, we = ref$1(), { left: $e, width: Me } = useElementBounding(we), Ze = computed(() => isNaN(c.value) ? ie.min : Math.min(ie.max, Math.max(ie.min, c.value))), ne = computed(() => ie.max - ie.min), rr = computed(() => (Ze.value - ie.min) / ne.value), gr = ref$1();
    function or(Ar) {
      if (Ar.preventDefault(), Ar.target?.closest(".slider-thumb"))
        Ar.type === "mousedown" ? gr.value = { x: Ar.clientX, value: Ze.value } : gr.value = { x: Ar.touches[0].clientX, value: Ze.value };
      else {
        const Rr = Ar.type === "mousedown" ? Ar.clientX : Ar.touches[0].clientX, Vr = (Rr - $e.value) / Me.value * ne.value, Xr = ie.min + Vr;
        c.value = Math.min(ie.max, Math.max(ie.min, Xr - Xr % ie.step)), gr.value = { x: Rr, value: Xr };
      }
    }
    const _r = ref$1({ x: 0, y: 0 });
    e$1(
      () => _r.value,
      () => {
        if (!gr.value)
          return;
        const Nr = (gr.value.x - _r.value.x) / Me.value * ne.value, Yr = gr.value.value - Nr;
        c.value = Math.min(ie.max, Math.max(ie.min, Yr - Yr % ie.step));
      },
      16,
      () => {
      }
    );
    function Lr(Ar) {
      !gr.value || (Ar.preventDefault(), Ar.type === "mousemove" ? _r.value = { x: Ar.clientX, y: Ar.clientY } : _r.value = { x: Ar.touches[0].clientX, y: Ar.touches[0].clientY });
    }
    function Ir(Ar) {
      gr.value && Ar.preventDefault(), gr.value = void 0;
    }
    return window.addEventListener("mousemove", Lr), window.addEventListener("mouseup", Ir), window.addEventListener("touchmove", Lr), window.addEventListener("touchend", Ir), onUnmounted(() => {
      window.removeEventListener("mousemove", Lr), window.removeEventListener("mouseup", Ir), window.removeEventListener("touchmove", Lr), window.removeEventListener("touchend", Ir);
    }), (Ar, Rr) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-slider swiper-no-swiping", {}]),
      style: normalizeStyle({ "--value-relative": rr.value }),
      onMousedown: or,
      onTouchstart: or
    }, [
      createElementVNode("div", {
        class: "slider-body",
        ref_key: "sliderBodyRef",
        ref: we
      }, Rr[0] || (Rr[0] = [
        createElementVNode("div", { class: "slider-value" }, null, -1)
      ]), 512),
      Rr[1] || (Rr[1] = createElementVNode("div", { class: "slider-thumb" }, null, -1))
    ], 36));
  }
}), BxSlider_vue_vue_type_style_index_0_scoped_b702c467_lang = "", BxSlider = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["__scopeId", "data-v-b702c467"]]), _hoisted_1$p = { class: "field-number" }, _hoisted_2$i = ["min", "max", "step"], _sfc_main$x = /* @__PURE__ */ defineComponent({
  __name: "Number",
  props: /* @__PURE__ */ mergeModels({
    min: {},
    max: {},
    step: {},
    type: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue"), ie = computed({
      get() {
        return Number(c.value);
      },
      set(we) {
        c.value = Number(we);
      }
    });
    return (we, $e) => (openBlock(), createElementBlock("div", _hoisted_1$p, [
      we.type === "slider" ? (openBlock(), createBlock(BxSlider, {
        key: 0,
        type: "range",
        modelValue: ie.value,
        "onUpdate:modelValue": $e[0] || ($e[0] = (Me) => ie.value = Me),
        min: we.min,
        max: we.max,
        step: we.step
      }, null, 8, ["modelValue", "min", "max", "step"])) : withDirectives((openBlock(), createElementBlock("input", {
        key: 1,
        type: "number",
        "onUpdate:modelValue": $e[1] || ($e[1] = (Me) => ie.value = Me),
        min: we.min,
        max: we.max,
        step: we.step
      }, null, 8, _hoisted_2$i)), [
        [vModelText, ie.value]
      ])
    ]));
  }
}), Number_vue_vue_type_style_index_0_scoped_7b17f563_lang = "", Number$1 = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["__scopeId", "data-v-7b17f563"]]), _hoisted_1$o = {
  key: 0,
  class: "select-dropdown-wrapper"
}, _hoisted_2$h = ["onClick"], _hoisted_3$a = { class: "preview-wrapper" }, _hoisted_4$6 = {
  key: 0,
  class: "label-wrapper"
}, _sfc_main$w = /* @__PURE__ */ defineComponent({
  __name: "SelectItem",
  props: /* @__PURE__ */ mergeModels({
    options: {},
    layout: {},
    size: {},
    showLabels: { type: Boolean },
    mobile: { type: Boolean }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue"), ie = m;
    useSlots();
    const we = computed(() => ie.options.map(($e) => ({
      label: $e.label,
      value: $e.value,
      icon: $e.image ? () => h$1("img", { src: $e.image, style: { "object-fit": "cover", width: "19px", height: "19px" } }) : void 0
    })));
    return ($e, Me) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["select-item-wrapper", { [`size-${$e.size}`]: !0, ["swiper-no-swiping"]: $e.mobile && $e.layout === "carroussel" }])
    }, [
      $e.layout === "dropdown" ? (openBlock(), createElementBlock("div", _hoisted_1$o, [
        createVNode(BxSelect, {
          modelValue: c.value,
          "onUpdate:modelValue": Me[0] || (Me[0] = (Ze) => c.value = Ze),
          options: we.value,
          "placeholder-active-label": "Select option"
        }, null, 8, ["modelValue", "options"])
      ])) : (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass(["select-buttons-wrapper", { carroussel: $e.layout === "carroussel" }])
      }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList($e.options, (Ze) => (openBlock(), createElementBlock("div", {
          class: normalizeClass(["select-option-button", { selected: Ze.value === c.value }]),
          onClick: (ne) => c.value = Ze.value
        }, [
          createElementVNode("div", _hoisted_3$a, [
            renderSlot($e.$slots, "preview", {
              option: Ze,
              selected: c.value === Ze.value
            }, void 0, !0)
          ]),
          Ze.label ? (openBlock(), createElementBlock("div", _hoisted_4$6, toDisplayString(Ze.label), 1)) : createCommentVNode("", !0)
        ], 10, _hoisted_2$h))), 256))
      ], 2))
    ], 2));
  }
}), SelectItem_vue_vue_type_style_index_0_scoped_0afa82f9_lang = "", SelectItem = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["__scopeId", "data-v-0afa82f9"]]), _hoisted_1$n = { class: "select-text-field" }, _sfc_main$v = /* @__PURE__ */ defineComponent({
  __name: "SelectText",
  props: /* @__PURE__ */ mergeModels({
    options: {},
    layout: {},
    imageDisplay: {},
    showLabels: { type: Boolean },
    size: {},
    mobile: { type: Boolean, default: !1 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue"), ie = m, we = computed(() => ie.layout === "button" && ie.mobile ? "carroussel" : ie.layout);
    return ($e, Me) => (openBlock(), createElementBlock("div", _hoisted_1$n, [
      createVNode(SelectItem, {
        modelValue: c.value,
        "onUpdate:modelValue": Me[0] || (Me[0] = (Ze) => c.value = Ze),
        options: $e.options,
        layout: we.value,
        "image-display": $e.imageDisplay,
        "show-labels": $e.showLabels,
        size: $e.size,
        mobile: $e.mobile
      }, null, 8, ["modelValue", "options", "layout", "image-display", "show-labels", "size", "mobile"])
    ]));
  }
}), SelectText_vue_vue_type_style_index_0_scoped_cb108a08_lang = "", SelectText = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["__scopeId", "data-v-cb108a08"]]), _sfc_main$u = /* @__PURE__ */ defineComponent({
  __name: "SelectColor",
  props: /* @__PURE__ */ mergeModels({
    options: {},
    layout: {},
    imageDisplay: {},
    showLabels: { type: Boolean },
    size: {},
    mobile: { type: Boolean, default: !1 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue"), ie = m, we = computed(() => ie.layout === "button" && ie.mobile ? "carroussel" : ie.layout), $e = computed(() => ie.layout === "dropdown" ? ie.options.map((Me) => ({
      label: Me.label || Me.value,
      value: Me.value,
      image: `data:image/svg+xml;base64,${window.btoa(
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50%" cy="50%" r="50%" style="fill: ${Me.image};" /></svg>`
      )}`
    })) : ie.options);
    return (Me, Ze) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["select-color-field", {}])
    }, [
      createVNode(SelectItem, {
        modelValue: c.value,
        "onUpdate:modelValue": Ze[0] || (Ze[0] = (ne) => c.value = ne),
        options: $e.value,
        layout: we.value,
        "image-display": Me.imageDisplay,
        "show-labels": Me.showLabels,
        size: Me.size,
        mobile: Me.mobile
      }, {
        preview: withCtx(({ option: ne, selected: rr }) => [
          createElementVNode("div", {
            class: normalizeClass(["preview-color", { selected: rr }]),
            style: normalizeStyle({ "--color": ne.image || ne.value })
          }, null, 6)
        ]),
        _: 1
      }, 8, ["modelValue", "options", "layout", "image-display", "show-labels", "size", "mobile"])
    ]));
  }
}), SelectColor_vue_vue_type_style_index_0_scoped_fd1b97d0_lang = "", SelectColor = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["__scopeId", "data-v-fd1b97d0"]]), _hoisted_1$m = ["src"], _sfc_main$t = /* @__PURE__ */ defineComponent({
  __name: "SelectImage",
  props: /* @__PURE__ */ mergeModels({
    options: {},
    layout: {},
    imageDisplay: {},
    showLabels: { type: Boolean },
    size: {},
    mobile: { type: Boolean, default: !1 }
  }, {
    modelValue: {
      required: !0,
      default: () => ({
        src: "https://picsum.photos/536/354",
        scale: 1,
        innerPos: [0, 0],
        innerRotate: 0
      })
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue"), ie = m, we = computed(() => ie.layout === "button" && ie.mobile ? "carroussel" : ie.layout), $e = computed({
      get() {
        return typeof c.value == "string" ? c.value : c.value.src;
      },
      set(Me) {
        typeof c.value == "string" ? c.value = Me : c.value = {
          ...c.value,
          src: Me
        };
      }
    });
    return (Me, Ze) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["select-image-field", { mobile: Me.mobile }])
    }, [
      createVNode(SelectItem, {
        modelValue: $e.value,
        "onUpdate:modelValue": Ze[0] || (Ze[0] = (ne) => $e.value = ne),
        options: Me.options,
        layout: we.value,
        "image-display": Me.imageDisplay,
        "show-labels": Me.showLabels,
        size: Me.size,
        mobile: Me.mobile
      }, {
        preview: withCtx(({ option: ne, selected: rr }) => [
          createElementVNode("img", {
            class: normalizeClass(["preview-image", { [`image-display-${Me.imageDisplay}`]: !0, selected: rr }]),
            src: ne.image
          }, null, 10, _hoisted_1$m)
        ]),
        _: 1
      }, 8, ["modelValue", "options", "layout", "image-display", "show-labels", "size", "mobile"])
    ], 2));
  }
}), SelectImage_vue_vue_type_style_index_0_scoped_e9a9bcd1_lang = "", SelectImage = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["__scopeId", "data-v-e9a9bcd1"]]), _hoisted_1$l = {
  key: 0,
  class: "info-symbol-wrapper"
}, _hoisted_2$g = { class: "instruction-text" }, _hoisted_3$9 = { class: "detailed-description-text" }, _sfc_main$s = /* @__PURE__ */ defineComponent({
  __name: "Instruction",
  props: {
    instruction: {},
    description: {},
    detailedDescription: {}
  },
  setup(m) {
    return (c, ie) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["instruction-field", {}])
    }, [
      c.description === void 0 ? (openBlock(), createElementBlock("div", _hoisted_1$l, [
        createVNode(BxIcon, null, {
          default: withCtx(() => [
            createVNode(unref(InformationCircleOutline))
          ]),
          _: 1
        })
      ])) : createCommentVNode("", !0),
      createElementVNode("main", null, [
        createElementVNode("div", _hoisted_2$g, toDisplayString(c.instruction), 1),
        createElementVNode("div", _hoisted_3$9, toDisplayString(c.detailedDescription), 1)
      ])
    ]));
  }
}), Instruction_vue_vue_type_style_index_0_scoped_19f1c8ca_lang = "", Instruction = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["__scopeId", "data-v-19f1c8ca"]]), _hoisted_1$k = { class: "highlighted-field" }, _hoisted_2$f = { class: "actions" }, _sfc_main$r = /* @__PURE__ */ defineComponent({
  __name: "HighlightedText",
  props: /* @__PURE__ */ mergeModels({
    options: {},
    userAgentRichText: { type: Boolean },
    noStyleLabel: {},
    mixedStyleLabel: {},
    showWordCount: { type: Boolean },
    clearable: { type: Boolean },
    maxLength: {},
    maxLineLength: {},
    maxLines: {},
    placeholder: {},
    maxHeight: {}
  }, {
    modelValue: { type: [String, Number, Boolean, Array], required: !1, default: "Hello world" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue"), ie = ref$1();
    function we(Ir) {
      return typeof Ir == "object" && Ir instanceof Array ? _$1.cloneDeep(Ir) : typeof Ir == "string" || typeof Ir == "number" || typeof Ir == "boolean" ? [
        {
          text: String(Ir),
          format: {}
        }
      ] : [{ text: "foobar", format: {} }];
    }
    function $e(Ir, Ar) {
      return _$1.isEqual(Ir, Ar);
    }
    const Me = ref$1(we(c.value));
    watch(Me, (Ir, Ar) => {
      c.value = Ir;
    }), watch(c, () => {
      $e(we(c.value), Me.value) || (Me.value = we(c.value));
    });
    const Ze = ref$1(), ne = ref$1({ start: 0, length: 0 });
    watch(Ze, () => {
      !Ze.value || (ne.value = Ze.value);
    });
    const rr = ref$1(!1);
    function gr(Ir) {
      let Ar = !1, Rr;
      for (const Nr of Ir)
        if (!Rr)
          Rr = Nr.format;
        else if (!_$1.isEqual(Rr, Nr.format)) {
          Ar = !0;
          break;
        }
      return Ar ? null : Rr ?? null;
    }
    const or = computed(() => {
      const Ir = ie.value?.richTextInstance;
      if (!Ir)
        return null;
      const Rr = Ir.resolveFeatures(ne.value.start, ne.value.length).flat();
      return gr(Rr);
    });
    watchEffect(() => {
      console.log("commonStyleFormat", or.value);
    });
    function _r(Ir) {
      return or.value ? Ir.style === null ? gr(Me.value) !== null : _$1.isEqual(or.value, Ir.style) : !1;
    }
    function Lr(Ir) {
      const Ar = ie.value?.richTextInstance;
      !Ar || !Ze.value || Ze.value.length === 0 || (_r(Ir) ? Ar.applyFormat(ne.value.start, ne.value.length, {}) : Ar.applyFormat(ne.value.start, ne.value.length, Ir.style));
    }
    return watchEffect(() => {
      console.log("selection", Ze.value);
    }), (Ir, Ar) => (openBlock(), createElementBlock("div", _hoisted_1$k, [
      createElementVNode("div", _hoisted_2$f, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(Ir.options, (Rr) => (openBlock(), createBlock(BxButton, {
          secondary: _r(Rr),
          onClick: (Nr) => Lr(Rr),
          disabled: !Ze.value || Ze.value.length === 0
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(Rr.label), 1)
          ]),
          _: 2
        }, 1032, ["secondary", "onClick", "disabled"]))), 256))
      ]),
      createElementVNode("div", {
        class: normalizeClass(["text-input", { focused: rr.value }]),
        style: normalizeStyle({ "--max-height": Ir.maxHeight ?? void 0 })
      }, [
        createVNode(BxRichtextInput, {
          ref_key: "bxRichTextInstance",
          ref: ie,
          modelValue: Me.value,
          "onUpdate:modelValue": Ar[0] || (Ar[0] = (Rr) => Me.value = Rr),
          selection: Ze.value,
          "onUpdate:selection": Ar[1] || (Ar[1] = (Rr) => Ze.value = Rr),
          focus: rr.value,
          "onUpdate:focus": Ar[2] || (Ar[2] = (Rr) => rr.value = Rr)
        }, null, 8, ["modelValue", "selection", "focus"])
      ], 6)
    ]));
  }
}), HighlightedText_vue_vue_type_style_index_0_scoped_8fbdfe62_lang = "", HighlightedText = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["__scopeId", "data-v-8fbdfe62"]]), BluepciFieldComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ImageEdit,
  Image: Image$1,
  Group,
  Text,
  ImageAdjust,
  Select,
  Checkbox,
  Collection,
  Map: Map$1,
  Color,
  Number: Number$1,
  SelectText,
  SelectColor,
  SelectImage,
  Instruction,
  HighlightedText
}, Symbol.toStringTag, { value: "Module" })), _hoisted_1$j = { class: "inner" }, _hoisted_2$e = { key: 1 }, _sfc_main$q = /* @__PURE__ */ defineComponent({
  __name: "FieldsList",
  props: {
    layout: { default: "list" },
    fields: {},
    isRoot: { type: Boolean }
  },
  setup(m) {
    const c = m, ie = inject("bridge"), we = inject("data"), $e = inject("computedPropEvaluator");
    $e || console.error("computedPropEvaluator is not provided");
    const Me = (rr) => {
      if ("pos" in rr && "scale" in rr) {
        const or = rr.image, _r = rr.pos, Lr = rr.scale;
        return {
          image: we.value[or],
          "onUpdate:image": (Ar) => {
            we.value[or] = Ar;
          },
          adjust: {
            scale: we.value[Lr],
            innerPos: we.value[_r]
          },
          "onUpdate:adjust": (Ar) => {
            we.value[Lr] = Ar.scale, we.value[_r] = Ar.innerPos;
          }
        };
      }
      return {
        ...Object.fromEntries(Object.entries(rr).map(([or, _r]) => [or, we.value[_r]])),
        ...Object.fromEntries(
          Object.entries(rr).map(([or]) => [
            `onUpdate:${or}`,
            (_r) => {
              we.value[rr[or]] = _r;
            }
          ])
        )
      };
    };
    function Ze(rr) {
      return Object.fromEntries(
        Object.entries(rr).map(([gr, or]) => typeof or == "function" ? [gr, $e(or)] : [gr, or])
      );
    }
    const ne = (rr) => {
      const gr = c.fields.indexOf(rr), or = c.fields.slice(0, gr).filter((_r) => _r.type === "Instruction");
      return gr - or.length + 1;
    };
    return (rr, gr) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bluepic-fields", { ["layout-" + rr.layout]: !0 }])
    }, [
      (openBlock(!0), createElementBlock(Fragment, null, renderList(rr.fields, (or, _r) => (openBlock(), createElementBlock("div", {
        class: normalizeClass(["field", {
          "is-root": rr.isRoot,
          ["field-type-" + or.type.toLowerCase()]: !0,
          "field-has-card": or.type === "Group" && or.props.card
        }]),
        style: normalizeStyle({ "--min-width": or.layout?.minWidth, "--max-width": or.layout?.maxWidth })
      }, [
        or.type !== "Group" && or.description ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["description", {
            "no-detailed-description": !or.detailedDescription,
            "text-overlaying-description": !rr.isRoot && or.type === "Text"
          }])
        }, [
          createElementVNode("div", _hoisted_1$j, [
            rr.isRoot ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["root-index", {}])
            }, [
              or.type === "Instruction" ? (openBlock(), createBlock(BxIcon, { key: 0 }, {
                default: withCtx(() => [
                  createVNode(unref(InformationOutline))
                ]),
                _: 1
              })) : (openBlock(), createElementBlock("span", _hoisted_2$e, toDisplayString(ne(or)), 1))
            ])) : createCommentVNode("", !0),
            createElementVNode("span", null, toDisplayString(or.description), 1),
            or.detailedDescription && or.type !== "Instruction" ? (openBlock(), createBlock(BxTooltip, {
              key: 1,
              trigger: "hover"
            }, {
              trigger: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(HelpOutline))
                  ]),
                  _: 1
                })
              ]),
              content: withCtx(() => [
                createTextVNode(toDisplayString(or.detailedDescription), 1)
              ]),
              _: 2
            }, 1024)) : createCommentVNode("", !0)
          ])
        ], 2)) : createCommentVNode("", !0),
        (openBlock(), createBlock(resolveDynamicComponent(BluepciFieldComponents[or.type]), mergeProps({
          bridge: unref(ie),
          index: ne(or),
          "is-root": rr.isRoot,
          ref_for: !0
        }, {
          ...Ze(or.props),
          ...Me(or.model),
          field: or,
          description: or.description,
          detailedDescription: or.detailedDescription,
          ...(() => {
            if (or.type === "Text")
              return {
                ...or.layout
              };
          })()
        }), null, 16, ["bridge", "index", "is-root"]))
      ], 6))), 256))
    ], 2));
  }
}), FieldsList_vue_vue_type_style_index_0_scoped_7538310d_lang = "", FieldsList = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["__scopeId", "data-v-7538310d"]]), _hoisted_1$i = { class: "bx-fields" }, _sfc_main$p = /* @__PURE__ */ defineComponent({
  __name: "Fields",
  props: {
    fields: {}
  },
  setup(m) {
    return (c, ie) => (openBlock(), createElementBlock("div", _hoisted_1$i, [
      createVNode(FieldsList, {
        fields: c.fields,
        "is-root": ""
      }, null, 8, ["fields"])
    ]));
  }
}), _sfc_main$o = /* @__PURE__ */ defineComponent({
  __name: "PopupProvider",
  setup(m, { expose: c }) {
    const ie = ref$1([]);
    function we(or, _r, Lr) {
      ie.value.push({
        id: or,
        render: _r,
        type: Lr.type,
        close: Lr.close,
        handleClickOutside: Lr.handleClickOutside,
        disableBackgroundEffect: Lr.disableBackgroundEffect,
        wrapperCustomClasses: Lr.wrapperCustomClasses
      });
    }
    function $e(or) {
      const _r = ie.value.findIndex((Lr) => Lr.id === or);
      _r !== -1 && ie.value.splice(_r, 1);
    }
    function Me(or) {
      return ie.value.some((_r) => _r.id === or);
    }
    const Ze = computed(() => ie.value.length > 0), ne = ref$1(["a", "b", "c"]);
    window.tPush = () => ne.value.push("d"), window.tPull = () => ne.value = ne.value.slice(0, -1);
    const rr = computed(() => ie.value.filter((or) => !or.disableBackgroundEffect));
    watch([Ze, rr], () => {
      const or = document.querySelector(GLOBAL_APP_WRAPPER_SELECTOR);
      !or || (Ze.value && rr.value.length > 0 && or.classList.add("bluepic-popup-app-wrapper-in-background"), Ze.value || or.classList.remove("bluepic-popup-app-wrapper-in-background"));
    });
    function gr(or) {
      or.close();
    }
    return c({
      isVisible: Me,
      push: we,
      pull: $e
    }), (or, _r) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bluepic-popup-provider", { visible: Ze.value }])
    }, [
      createVNode(TransitionGroup, { name: "slide-popup-element" }, {
        default: withCtx(() => [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(ie.value, (Lr, Ir) => (openBlock(), createElementBlock("div", {
            key: Lr.id,
            class: normalizeClass(["popup-wrapper", {
              ["type-" + Lr.type]: !0,
              ...Object.fromEntries(Lr.wrapperCustomClasses.map((Ar) => [Ar, !0]))
            }])
          }, [
            (openBlock(), createBlock(resolveDynamicComponent(Lr.render), {
              onClickOutside: (Ar) => gr(Lr),
              onClose: Lr.close,
              style: normalizeStyle({ "--level": -(Ir - (ie.value.length - 1)) })
            }, null, 40, ["onClickOutside", "onClose", "style"]))
          ], 2))), 128))
        ]),
        _: 1
      })
    ], 2));
  }
}), PopupProvider_vue_vue_type_style_index_0_scoped_088eba49_lang = "", PopupProvider = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["__scopeId", "data-v-088eba49"]]), _sfc_main$n = /* @__PURE__ */ defineComponent({
  __name: "PopoverProvider",
  setup(m, { expose: c }) {
    const ie = ref$1([]), we = computed(() => ie.value.length > 0);
    function $e(rr, gr, or) {
      ie.value.push({
        id: rr,
        render: gr,
        darkenBackground: or.darkenBackground,
        handleClickOutside: or.handleClickOutside
      });
    }
    function Me(rr) {
      console.log("pull", rr);
      const gr = ie.value.findIndex((or) => or.id === rr);
      gr !== -1 && ie.value.splice(gr, 1);
    }
    function Ze(rr) {
      return ie.value.some((gr) => gr.id === rr);
    }
    watch(we, () => {
    });
    function ne(rr) {
      rr.handleClickOutside();
    }
    return c({
      isVisible: Ze,
      push: $e,
      pull: Me
    }), (rr, gr) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bluepic-popover-provider", {
        visible: we.value,
        "darken-background": ie.value.filter((or) => or.darkenBackground).length > 0
      }])
    }, [
      createVNode(TransitionGroup, { name: "show-popover-element" }, {
        default: withCtx(() => [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(ie.value, (or, _r) => (openBlock(), createBlock(resolveDynamicComponent(or.render), {
            key: or.id,
            onClickOutside: (Lr) => ne(or)
          }, null, 40, ["onClickOutside"]))), 128))
        ]),
        _: 1
      })
    ], 2));
  }
}), PopoverProvider_vue_vue_type_style_index_0_scoped_acb5ec3e_lang = "", PopoverProvider = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["__scopeId", "data-v-acb5ec3e"]]);
class BluepicPopupProvider {
  popupProviderRef;
  popoverProviderRef;
  constructor() {
    const c = document.createElement("div");
    c.classList.add("bluepic-popup-provider__wrapper");
    const ie = document.createElement("style");
    ie.setAttribute("type", "text/css"), ie.setAttribute("data-bluepic-popup-app-wrapper", "true"), ie.innerHTML = `
      .bluepic-popup-body {
        
      }
      .bluepic-app-wrapper {
        transform: none;
      }
      .bluepic-popup-app-wrapper {
        /*background-color: rgba(255, 255, 255, 1);*/
        background-color: inherit;
        transform-origin: center center;
        /*transform-origin: center max(10px, -49vh);*/
        
        --transition-duration: 0.3s;
        transition: transform calc(1.2 * var(--transition-duration)), filter var(--transition-duration), background-color var(--transition-duration);
      }
      .bluepic-popup-app-wrapper-in-background {
        transform: scale(0.9);

        --offset-top-safe-area: env(safe-area-inset-top);
        clip-path: inset(0 0 0 0 round 10px);
        -webkit-clip-path: inset(0 0 0 0 round 10px);
        filter: brightness(0.8);

        
      }
    `, document.head.appendChild(ie);
    const we = createApp({
      setup() {
        const $e = ref$1(), Me = ref$1();
        return {
          popupProviderRef: $e,
          popoverProviderRef: Me
        };
      },
      render() {
        return [h$1(PopupProvider, { ref: "popupProviderRef" }), h$1(PopoverProvider, { ref: "popoverProviderRef" })];
      }
    }).mount(c);
    this.popupProviderRef = we.popupProviderRef, this.popoverProviderRef = we.popoverProviderRef;
    try {
      document.body.appendChild(c);
    } catch ($e) {
      console.error("Error adding wrapper to body:", $e);
    }
  }
}
function convertDeprecatedField(m) {
  return m.datatype === "Collection" ? {
    type: "Collection",
    model: {
      modelValue: m.model.modelValue
    },
    description: m.description,
    detailedDescription: void 0,
    props: {
      fields: m.props.fields.map(convertDeprecatedField).filter((c) => c !== void 0),
      min: m.props.min,
      max: m.props.max,
      layout: "list"
    },
    hitbox: void 0,
    layout: {
      maxWidth: "100%",
      minWidth: "100%"
    }
  } : m.datatype === "Dropdown" ? {
    type: "Select",
    model: { modelValue: m.model.modelValue },
    description: m.description,
    detailedDescription: void 0,
    props: {
      size: "medium",
      layout: "dropdown",
      showLabels: !0,
      imageDisplay: "cover",
      options: m.props.options.map((c) => ({
        label: c.label,
        value: c.value,
        image: c.preview
      }))
    },
    layout: {
      minWidth: "100%",
      maxWidth: "100%"
    },
    hitbox: void 0
  } : m.datatype === "Select" ? {
    type: "Select",
    model: { modelValue: m.model.modelValue },
    description: m.description,
    detailedDescription: void 0,
    props: {
      size: "medium",
      layout: "button",
      showLabels: !0,
      imageDisplay: m.props.imageDisplay,
      options: m.props.options.map((c, ie) => ({
        label: `Option ${ie + 1}`,
        value: c.value,
        image: c.preview
      }))
    },
    layout: {
      minWidth: "100%",
      maxWidth: "100%"
    },
    hitbox: void 0
  } : m.datatype === "Text" ? {
    type: "Text",
    model: { modelValue: m.model.modelValue },
    description: m.description,
    detailedDescription: void 0,
    props: {
      clearable: m.props.clearable,
      maxHeight: "150px",
      maxLength: m.props.maxLength,
      maxLineLength: m.props.maxLineLength,
      maxLines: m.props.maxLines,
      multiline: m.props.multiline,
      placeholder: m.description ?? "Text...",
      showWordCount: m.props.showWordCount,
      uppercase: !1,
      richtext: {
        enabled: m.props.richtext,
        mixedStyleLabel: {
          en: m.props.mixedStyleLabel
        },
        noStyleLabel: {
          en: m.props.noStyleLabel
        },
        userAgentRichText: m.props.userAgentRichText,
        options: m.props.richTextOptions
      }
    },
    layout: {
      minWidth: "120px",
      maxWidth: "auto"
    },
    hitbox: void 0
  } : m.datatype === "Image" ? {
    type: "Image",
    model: { modelValue: m.model.modelValue },
    description: m.description,
    detailedDescription: void 0,
    props: {
      allowUploadFromDevice: m.props.allowUpload ?? !0,
      allowedTypes: ["image/png", "image/jpeg", "image/gif", "image/webp", "image/svg+xml"],
      convertTo: void 0,
      width: m.props.width,
      height: m.props.height,
      imageLibraries: m.props.imageLibraries.map((c) => c.props?.sharingUrl ? c.props.sharingUrl.indexOf("googledrive") > -1 ? {
        type: "sharedDrive",
        service: "googledrive",
        label: c.label,
        sharedUrl: c.props.sharingUrl
      } : {
        type: "sharedDrive",
        service: "onedrive",
        label: c.label,
        sharedUrl: c.props.sharingUrl
      } : {
        type: "custom",
        name: c.name,
        label: c.label,
        controller: c.controller,
        props: c.props
      }),
      layout: "normal",
      quality: m.props.quality,
      removeBackground: !1,
      uploadLabel: "Upload Image"
    },
    layout: {
      minWidth: "100%",
      maxWidth: "100%"
    },
    hitbox: void 0
  } : m.datatype === "ImageAdjust" ? {
    type: "ImageAdjust",
    model: { ...m.model, image: m.model.image, adjust: m.model.adjust },
    description: m.description,
    detailedDescription: void 0,
    props: {
      aspectRatio: m.props.aspectRatio,
      maxScale: m.props.maxScale,
      minScale: m.props.minScale,
      maxX: m.props.maxX,
      maxY: m.props.maxY,
      minX: m.props.minX,
      minY: m.props.minY,
      type: "popup"
    },
    layout: {
      minWidth: "100%",
      maxWidth: "100%"
    },
    hitbox: void 0
  } : m.datatype === "Switch" ? {
    type: "Checkbox",
    model: { modelValue: m.model.modelValue },
    description: m.description,
    detailedDescription: void 0,
    props: {
      label: "",
      size: "medium"
    },
    layout: {
      minWidth: "100%",
      maxWidth: "100%"
    },
    hitbox: void 0
  } : m.datatype === "Number" ? {
    type: "Number",
    model: { modelValue: m.model.modelValue },
    description: m.description,
    detailedDescription: void 0,
    props: {
      min: m.props.min,
      max: m.props.max,
      step: m.props.step,
      type: "slider"
    },
    layout: {
      minWidth: "100%",
      maxWidth: "100%"
    },
    hitbox: void 0
  } : m.datatype === "Color" ? {
    type: "Color",
    model: { modelValue: m.model.modelValue },
    description: m.description,
    detailedDescription: void 0,
    props: {
      alpha: !0
    },
    layout: {
      minWidth: "100%",
      maxWidth: "100%"
    },
    hitbox: void 0
  } : m.datatype === "Map" ? {
    type: "Map",
    model: { modelValue: m.model.modelValue },
    description: m.description,
    detailedDescription: void 0,
    props: {
      aspectRatio: m.props.aspectRatio,
      mapStyle: m.props.mapStyle,
      mapboxAccessToken: m.props.mapboxAccessToken,
      padding: m.props.padding,
      type: m.props.type
    },
    layout: {
      minWidth: "100%",
      maxWidth: "100%"
    },
    hitbox: void 0
  } : void 0;
}
function getCloudflareLiveUrl(m, c) {
  return `https://${m !== "auto" ? `${m.replaceAll(/\./g, "-")}.` : ""}${c.cloudflarePagesHostname}`;
}
function getTemplateSerialUrl(m, c) {
  return `${c.studioResourcesBaseUrl}${c.authorization ? `/auth.proxy/${c.authorization}` : ""}/api/files/${m}/default`;
}
function getTemplateLiveUrl(m, c, ie) {
  return `${getCloudflareLiveUrl(c, ie)}?` + new URLSearchParams(
    Object.fromEntries(
      Object.entries({
        fonts: JSON.stringify(ie.config.fonts ?? []),
        webgl: ie.config.webgl,
        resolution: ie.config.resolution,
        autoDetectBxCoreVersion: String(c === "auto"),
        resolveSerial: ie.useBoilerplate ? void 0 : getTemplateSerialUrl(m, ie)
      }).filter(([, $e]) => $e && $e !== "null")
    )
  ).toString();
}
function getTemplatePreviewUrl(m, c) {
  return `${c.studioResourcesBaseUrl}${c.authorization ? `/auth.proxy/${c.authorization}` : ""}/api/files/${m}/preview`;
}
function optimizePreviewUrl(m, c, ie) {
  try {
    const we = new URL(m);
    if (we.hostname === "imagedelivery.net") {
      const [, $e, Me, Ze] = we.pathname.split("/");
      return `https://imagedelivery.net/${$e}/${Me}/${c || ie ? new URLSearchParams(Object.fromEntries(Object.entries({ w: c, h: ie }).filter(([ne, rr]) => rr !== void 0).map(([ne, rr]) => [ne, String(rr)]))).toString() : Ze}`;
    }
  } catch (we) {
    return console.error(we), m;
  }
}
class EmbeddedController extends EventTarget {
  iframe;
  alive;
  ready;
  sessionId;
  $data;
  constructor(c, ie, we = 5) {
    super(), this.iframe = c, this.alive = !0, this.ready = !1, this.sessionId = null, this.initListener();
    let $e = !1, Me = !1;
    this.addEventListener("mounted", async () => {
      if (ie !== void 0 && !Me) {
        const rr = await ie;
        Me = !0, rr ? await this.evaluate((gr) => {
          const or = JSON.parse(gr);
          window.bx_serial.value = or;
        }, JSON.stringify(rr)) : this.dispatchEvent(new CustomEvent("error", { detail: { code: 2 } }));
      } else
        $e || ($e = !0, this.dispatchEvent(new CustomEvent("ready")));
    }), this.addEventListener("setGlobalScope", (rr) => {
      const gr = Object.fromEntries(
        Object.entries(rr.detail).map(([_r, Lr]) => Lr?.__type__ === "function" ? [_r, new Function(`return (${Lr.__value__})()`)] : [_r, Lr])
      ), or = new CustomEvent("globalScope", { detail: gr });
      this.dispatchEvent(or);
    });
    const Ze = setInterval(async () => {
      if (!this.alive)
        return clearInterval(Ze);
      try {
        await this.ping() && clearInterval(Ze);
      } catch {
      }
    }, 5);
    this.$data = new Proxy(this, {
      get(rr, gr) {
        return rr.get(gr);
      },
      set(rr, gr, or) {
        return rr.set(gr, or);
      }
    });
    let ne = 0;
    this.addEventListener("http:error", (rr) => {
      const gr = rr.detail?.code;
      if (gr >= 400 && (console.error("ERROR DURING LIVE REQUEST", gr), gr === 412))
        if (ne < we) {
          const or = new URL(c.src);
          or.searchParams.set("force", Date.now().toString()), c.src = or.toString(), ne++;
        } else
          this.dispatchEvent(new CustomEvent("error", { detail: { code: 412 } }));
    });
  }
  destroy() {
    this.alive = !1;
  }
  ping(c = 100) {
    return new Promise((ie, we) => {
      const $e = Date.now(), Me = $e, Ze = setTimeout(we, c), ne = ({ data: rr }) => {
        this.alive && rr.type == "pong" && rr.id == Me && (ie(Date.now() - $e), clearTimeout(Ze), window.removeEventListener("message", ne));
      };
      window.addEventListener("message", ne);
      try {
        this.iframe.contentWindow?.postMessage({ type: "ping", id: Me }, "*");
      } catch {
      }
    });
  }
  getSessionId() {
    return new Promise((c) => {
      const ie = nanoid();
      this.apply("getSessionId", ie), window.addEventListener("message", ({ data: we }) => {
        we.scope === "bx" && we.taskId === ie && c(we.sessionId);
      });
    });
  }
  messageIsSession(c) {
    return c.sessionId == this.sessionId;
  }
  messageIsEvent(c) {
    return c.type == "event";
  }
  initListener() {
    window.addEventListener(
      "message",
      async ({ data: c }) => {
        if (c.error && (console.error("ERROR FROM LIVE SANDBOX", c), c?.response?.error === "File ist not embedded" ? this.dispatchEvent(new CustomEvent("error", { detail: { code: 2 } })) : this.dispatchEvent(new CustomEvent("error", { detail: { code: 1 } }))), this.messageIsSession(c) && (c.taskId && this.dispatchEvent(new CustomEvent("rerender")), this.messageIsEvent(c))) {
          const ie = new CustomEvent(c.message, { detail: c.payload });
          this.dispatchEvent(ie);
        }
        if (c.type === "bx:init") {
          const ie = await this.getSessionId();
          ie != this.sessionId && (this.sessionId = ie, this.dispatchEvent(new CustomEvent("init"))), this.dispatchEvent(new CustomEvent("roll"));
        }
        c.type === "event" && c.message === "mounted" && this.dispatchEvent(new CustomEvent("mounted"));
      },
      !1
    );
  }
  apply(c, ...ie) {
    try {
      this.iframe.contentWindow?.postMessage(
        {
          type: "action",
          name: c,
          args: ie
        },
        "*"
      );
    } catch (we) {
      console.error(we);
    }
  }
  get(c) {
    return this.evaluate((ie) => this.$data[ie], c);
  }
  set(c, ie) {
    return this.apply("set", c, ie), !0;
  }
  evaluate(c, ...ie) {
    return new Promise((we, $e) => {
      const Me = nanoid();
      this.apply("evaluate", c.toString(), Me, ie);
      const Ze = ({ detail: rr }) => {
        if (rr.processId == Me) {
          try {
            we(JSON.parse(rr.result));
          } catch {
            we(rr.result);
          }
          this.removeEventListener("return", Ze), this.removeEventListener("error", ne);
        }
      }, ne = ({ detail: rr }) => {
        rr.processId == Me && ($e(rr.error), this.removeEventListener("return", Ze), this.removeEventListener("error", ne));
      };
      this.addEventListener("return", Ze), this.addEventListener("error", ne);
    });
  }
  setData(c) {
    return new Promise((ie, we) => {
      this.evaluate(($e) => {
        const Me = JSON.parse($e);
        for (const Ze in Me)
          window.bx_data[Ze] = Me[Ze];
      }, JSON.stringify(c)).then(($e) => {
        ie($e);
      }).catch(($e) => {
        we($e);
      });
    });
  }
  transform(c, ie, we, $e) {
    this.apply("transform", c, ie, we, $e);
  }
}
function dataUrlToBlob(m) {
  const c = window.atob(m.split(",")[1]), ie = m.split(",")[0].split(":")[1].split(";")[0], we = new ArrayBuffer(c.length), $e = new Uint8Array(we);
  for (var Me = 0; Me < c.length; Me++)
    $e[Me] = c.charCodeAt(Me);
  return new Blob([we], { type: ie });
}
var css = {}, commentre = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, parse$b = function(m, c) {
  c = c || {};
  var ie = 1, we = 1;
  function $e(nr) {
    var Pe = nr.match(/\n/g);
    Pe && (ie += Pe.length);
    var ur = nr.lastIndexOf(`
`);
    we = ~ur ? nr.length - ur : we + nr.length;
  }
  function Me() {
    var nr = { line: ie, column: we };
    return function(Pe) {
      return Pe.position = new Ze(nr), Ar(), Pe;
    };
  }
  function Ze(nr) {
    this.start = nr, this.end = { line: ie, column: we }, this.source = c.source;
  }
  Ze.prototype.content = m;
  var ne = [];
  function rr(nr) {
    var Pe = new Error(c.source + ":" + ie + ":" + we + ": " + nr);
    if (Pe.reason = nr, Pe.filename = c.source, Pe.line = ie, Pe.column = we, Pe.source = m, c.silent)
      ne.push(Pe);
    else
      throw Pe;
  }
  function gr() {
    var nr = Lr();
    return {
      type: "stylesheet",
      stylesheet: {
        source: c.source,
        rules: nr,
        parsingErrors: ne
      }
    };
  }
  function or() {
    return Ir(/^{\s*/);
  }
  function _r() {
    return Ir(/^}/);
  }
  function Lr() {
    var nr, Pe = [];
    for (Ar(), Rr(Pe); m.length && m.charAt(0) != "}" && (nr = pr() || br()); )
      nr !== !1 && (Pe.push(nr), Rr(Pe));
    return Pe;
  }
  function Ir(nr) {
    var Pe = nr.exec(m);
    if (!!Pe) {
      var ur = Pe[0];
      return $e(ur), m = m.slice(ur.length), Pe;
    }
  }
  function Ar() {
    Ir(/^\s*/);
  }
  function Rr(nr) {
    var Pe;
    for (nr = nr || []; Pe = Nr(); )
      Pe !== !1 && nr.push(Pe);
    return nr;
  }
  function Nr() {
    var nr = Me();
    if (!(m.charAt(0) != "/" || m.charAt(1) != "*")) {
      for (var Pe = 2; m.charAt(Pe) != "" && (m.charAt(Pe) != "*" || m.charAt(Pe + 1) != "/"); )
        ++Pe;
      if (Pe += 2, m.charAt(Pe - 1) === "")
        return rr("End of comment missing");
      var ur = m.slice(2, Pe - 2);
      return we += 2, $e(ur), m = m.slice(Pe), we += 2, nr({
        type: "comment",
        comment: ur
      });
    }
  }
  function Yr() {
    var nr = Ir(/^([^{]+)/);
    if (!!nr)
      return trim(nr[0]).replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, "").replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function(Pe) {
        return Pe.replace(/,/g, "\u200C");
      }).split(/\s*(?![^(]*\)),\s*/).map(function(Pe) {
        return Pe.replace(/\u200C/g, ",");
      });
  }
  function Vr() {
    var nr = Me(), Pe = Ir(/^(\*?[-#\/\*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
    if (!!Pe) {
      if (Pe = trim(Pe[0]), !Ir(/^:\s*/))
        return rr("property missing ':'");
      var ur = Ir(/^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^\)]*?\)|[^};])+)/), Pr = nr({
        type: "declaration",
        property: Pe.replace(commentre, ""),
        value: ur ? trim(ur[0]).replace(commentre, "") : ""
      });
      return Ir(/^[;\s]*/), Pr;
    }
  }
  function Xr() {
    var nr = [];
    if (!or())
      return rr("missing '{'");
    Rr(nr);
    for (var Pe; Pe = Vr(); )
      Pe !== !1 && (nr.push(Pe), Rr(nr));
    return _r() ? nr : rr("missing '}'");
  }
  function Wr() {
    for (var nr, Pe = [], ur = Me(); nr = Ir(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/); )
      Pe.push(nr[1]), Ir(/^,\s*/);
    if (!!Pe.length)
      return ur({
        type: "keyframe",
        values: Pe,
        declarations: Xr()
      });
  }
  function si() {
    var nr = Me(), ur = Ir(/^@([-\w]+)?keyframes\s*/);
    if (!!ur) {
      var Pe = ur[1], ur = Ir(/^([-\w]+)\s*/);
      if (!ur)
        return rr("@keyframes missing name");
      var Pr = ur[1];
      if (!or())
        return rr("@keyframes missing '{'");
      for (var Hr, vi = Rr(); Hr = Wr(); )
        vi.push(Hr), vi = vi.concat(Rr());
      return _r() ? nr({
        type: "keyframes",
        name: Pr,
        vendor: Pe,
        keyframes: vi
      }) : rr("@keyframes missing '}'");
    }
  }
  function li() {
    var nr = Me(), Pe = Ir(/^@supports *([^{]+)/);
    if (!!Pe) {
      var ur = trim(Pe[1]);
      if (!or())
        return rr("@supports missing '{'");
      var Pr = Rr().concat(Lr());
      return _r() ? nr({
        type: "supports",
        supports: ur,
        rules: Pr
      }) : rr("@supports missing '}'");
    }
  }
  function xi() {
    var nr = Me(), Pe = Ir(/^@host\s*/);
    if (!!Pe) {
      if (!or())
        return rr("@host missing '{'");
      var ur = Rr().concat(Lr());
      return _r() ? nr({
        type: "host",
        rules: ur
      }) : rr("@host missing '}'");
    }
  }
  function di() {
    var nr = Me(), Pe = Ir(/^@media *([^{]+)/);
    if (!!Pe) {
      var ur = trim(Pe[1]);
      if (!or())
        return rr("@media missing '{'");
      var Pr = Rr().concat(Lr());
      return _r() ? nr({
        type: "media",
        media: ur,
        rules: Pr
      }) : rr("@media missing '}'");
    }
  }
  function oi() {
    var nr = Me(), Pe = Ir(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
    if (!!Pe)
      return nr({
        type: "custom-media",
        name: trim(Pe[1]),
        media: trim(Pe[2])
      });
  }
  function ci() {
    var nr = Me(), Pe = Ir(/^@page */);
    if (!!Pe) {
      var ur = Yr() || [];
      if (!or())
        return rr("@page missing '{'");
      for (var Pr = Rr(), Hr; Hr = Vr(); )
        Pr.push(Hr), Pr = Pr.concat(Rr());
      return _r() ? nr({
        type: "page",
        selectors: ur,
        declarations: Pr
      }) : rr("@page missing '}'");
    }
  }
  function vr() {
    var nr = Me(), Pe = Ir(/^@([-\w]+)?document *([^{]+)/);
    if (!!Pe) {
      var ur = trim(Pe[1]), Pr = trim(Pe[2]);
      if (!or())
        return rr("@document missing '{'");
      var Hr = Rr().concat(Lr());
      return _r() ? nr({
        type: "document",
        document: Pr,
        vendor: ur,
        rules: Hr
      }) : rr("@document missing '}'");
    }
  }
  function Ae() {
    var nr = Me(), Pe = Ir(/^@font-face\s*/);
    if (!!Pe) {
      if (!or())
        return rr("@font-face missing '{'");
      for (var ur = Rr(), Pr; Pr = Vr(); )
        ur.push(Pr), ur = ur.concat(Rr());
      return _r() ? nr({
        type: "font-face",
        declarations: ur
      }) : rr("@font-face missing '}'");
    }
  }
  var ze = lr("import"), Ue = lr("charset"), tr = lr("namespace");
  function lr(nr) {
    var Pe = new RegExp("^@" + nr + "\\s*([^;]+);");
    return function() {
      var ur = Me(), Pr = Ir(Pe);
      if (!!Pr) {
        var Hr = { type: nr };
        return Hr[nr] = Pr[1].trim(), ur(Hr);
      }
    };
  }
  function pr() {
    if (m[0] == "@")
      return si() || di() || oi() || li() || ze() || Ue() || tr() || vr() || ci() || xi() || Ae();
  }
  function br() {
    var nr = Me(), Pe = Yr();
    return Pe ? (Rr(), nr({
      type: "rule",
      selectors: Pe,
      declarations: Xr()
    })) : rr("selector missing");
  }
  return addParent(gr());
};
function trim(m) {
  return m ? m.replace(/^\s+|\s+$/g, "") : "";
}
function addParent(m, c) {
  var ie = m && typeof m.type == "string", we = ie ? m : c;
  for (var $e in m) {
    var Me = m[$e];
    Array.isArray(Me) ? Me.forEach(function(Ze) {
      addParent(Ze, we);
    }) : Me && typeof Me == "object" && addParent(Me, we);
  }
  return ie && Object.defineProperty(m, "parent", {
    configurable: !0,
    writable: !0,
    enumerable: !1,
    value: c || null
  }), m;
}
var compiler = Compiler$2;
function Compiler$2(m) {
  this.options = m || {};
}
Compiler$2.prototype.emit = function(m) {
  return m;
};
Compiler$2.prototype.visit = function(m) {
  return this[m.type](m);
};
Compiler$2.prototype.mapVisit = function(m, c) {
  var ie = "";
  c = c || "";
  for (var we = 0, $e = m.length; we < $e; we++)
    ie += this.visit(m[we]), c && we < $e - 1 && (ie += this.emit(c));
  return ie;
};
var Base$1 = compiler, inherits$1 = inherits_browser.exports, compress = Compiler$1;
function Compiler$1(m) {
  Base$1.call(this, m);
}
inherits$1(Compiler$1, Base$1);
Compiler$1.prototype.compile = function(m) {
  return m.stylesheet.rules.map(this.visit, this).join("");
};
Compiler$1.prototype.comment = function(m) {
  return this.emit("", m.position);
};
Compiler$1.prototype.import = function(m) {
  return this.emit("@import " + m.import + ";", m.position);
};
Compiler$1.prototype.media = function(m) {
  return this.emit("@media " + m.media, m.position) + this.emit("{") + this.mapVisit(m.rules) + this.emit("}");
};
Compiler$1.prototype.document = function(m) {
  var c = "@" + (m.vendor || "") + "document " + m.document;
  return this.emit(c, m.position) + this.emit("{") + this.mapVisit(m.rules) + this.emit("}");
};
Compiler$1.prototype.charset = function(m) {
  return this.emit("@charset " + m.charset + ";", m.position);
};
Compiler$1.prototype.namespace = function(m) {
  return this.emit("@namespace " + m.namespace + ";", m.position);
};
Compiler$1.prototype.supports = function(m) {
  return this.emit("@supports " + m.supports, m.position) + this.emit("{") + this.mapVisit(m.rules) + this.emit("}");
};
Compiler$1.prototype.keyframes = function(m) {
  return this.emit("@" + (m.vendor || "") + "keyframes " + m.name, m.position) + this.emit("{") + this.mapVisit(m.keyframes) + this.emit("}");
};
Compiler$1.prototype.keyframe = function(m) {
  var c = m.declarations;
  return this.emit(m.values.join(","), m.position) + this.emit("{") + this.mapVisit(c) + this.emit("}");
};
Compiler$1.prototype.page = function(m) {
  var c = m.selectors.length ? m.selectors.join(", ") : "";
  return this.emit("@page " + c, m.position) + this.emit("{") + this.mapVisit(m.declarations) + this.emit("}");
};
Compiler$1.prototype["font-face"] = function(m) {
  return this.emit("@font-face", m.position) + this.emit("{") + this.mapVisit(m.declarations) + this.emit("}");
};
Compiler$1.prototype.host = function(m) {
  return this.emit("@host", m.position) + this.emit("{") + this.mapVisit(m.rules) + this.emit("}");
};
Compiler$1.prototype["custom-media"] = function(m) {
  return this.emit("@custom-media " + m.name + " " + m.media + ";", m.position);
};
Compiler$1.prototype.rule = function(m) {
  var c = m.declarations;
  return c.length ? this.emit(m.selectors.join(","), m.position) + this.emit("{") + this.mapVisit(c) + this.emit("}") : "";
};
Compiler$1.prototype.declaration = function(m) {
  return this.emit(m.property + ":" + m.value, m.position) + this.emit(";");
};
var Base = compiler, inherits = inherits_browser.exports, identity = Compiler;
function Compiler(m) {
  m = m || {}, Base.call(this, m), this.indentation = m.indent;
}
inherits(Compiler, Base);
Compiler.prototype.compile = function(m) {
  return this.stylesheet(m);
};
Compiler.prototype.stylesheet = function(m) {
  return this.mapVisit(m.stylesheet.rules, `

`);
};
Compiler.prototype.comment = function(m) {
  return this.emit(this.indent() + "/*" + m.comment + "*/", m.position);
};
Compiler.prototype.import = function(m) {
  return this.emit("@import " + m.import + ";", m.position);
};
Compiler.prototype.media = function(m) {
  return this.emit("@media " + m.media, m.position) + this.emit(
    ` {
` + this.indent(1)
  ) + this.mapVisit(m.rules, `

`) + this.emit(
    this.indent(-1) + `
}`
  );
};
Compiler.prototype.document = function(m) {
  var c = "@" + (m.vendor || "") + "document " + m.document;
  return this.emit(c, m.position) + this.emit(
    `  {
` + this.indent(1)
  ) + this.mapVisit(m.rules, `

`) + this.emit(
    this.indent(-1) + `
}`
  );
};
Compiler.prototype.charset = function(m) {
  return this.emit("@charset " + m.charset + ";", m.position);
};
Compiler.prototype.namespace = function(m) {
  return this.emit("@namespace " + m.namespace + ";", m.position);
};
Compiler.prototype.supports = function(m) {
  return this.emit("@supports " + m.supports, m.position) + this.emit(
    ` {
` + this.indent(1)
  ) + this.mapVisit(m.rules, `

`) + this.emit(
    this.indent(-1) + `
}`
  );
};
Compiler.prototype.keyframes = function(m) {
  return this.emit("@" + (m.vendor || "") + "keyframes " + m.name, m.position) + this.emit(
    ` {
` + this.indent(1)
  ) + this.mapVisit(m.keyframes, `
`) + this.emit(
    this.indent(-1) + "}"
  );
};
Compiler.prototype.keyframe = function(m) {
  var c = m.declarations;
  return this.emit(this.indent()) + this.emit(m.values.join(", "), m.position) + this.emit(
    ` {
` + this.indent(1)
  ) + this.mapVisit(c, `
`) + this.emit(
    this.indent(-1) + `
` + this.indent() + `}
`
  );
};
Compiler.prototype.page = function(m) {
  var c = m.selectors.length ? m.selectors.join(", ") + " " : "";
  return this.emit("@page " + c, m.position) + this.emit(`{
`) + this.emit(this.indent(1)) + this.mapVisit(m.declarations, `
`) + this.emit(this.indent(-1)) + this.emit(`
}`);
};
Compiler.prototype["font-face"] = function(m) {
  return this.emit("@font-face ", m.position) + this.emit(`{
`) + this.emit(this.indent(1)) + this.mapVisit(m.declarations, `
`) + this.emit(this.indent(-1)) + this.emit(`
}`);
};
Compiler.prototype.host = function(m) {
  return this.emit("@host", m.position) + this.emit(
    ` {
` + this.indent(1)
  ) + this.mapVisit(m.rules, `

`) + this.emit(
    this.indent(-1) + `
}`
  );
};
Compiler.prototype["custom-media"] = function(m) {
  return this.emit("@custom-media " + m.name + " " + m.media + ";", m.position);
};
Compiler.prototype.rule = function(m) {
  var c = this.indent(), ie = m.declarations;
  return ie.length ? this.emit(m.selectors.map(function(we) {
    return c + we;
  }).join(`,
`), m.position) + this.emit(` {
`) + this.emit(this.indent(1)) + this.mapVisit(ie, `
`) + this.emit(this.indent(-1)) + this.emit(`
` + this.indent() + "}") : "";
};
Compiler.prototype.declaration = function(m) {
  return this.emit(this.indent()) + this.emit(m.property + ": " + m.value, m.position) + this.emit(";");
};
Compiler.prototype.indent = function(m) {
  return this.level = this.level || 1, m != null ? (this.level += m, "") : Array(this.level).join(this.indentation || "  ");
};
var sourceMapSupport = { exports: {} }, sourceMap = {}, sourceMapGenerator = {}, base64Vlq = {}, base64 = {}, hasRequiredBase64;
function requireBase64() {
  if (hasRequiredBase64)
    return base64;
  hasRequiredBase64 = 1;
  var m = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
  return base64.encode = function(c) {
    if (0 <= c && c < m.length)
      return m[c];
    throw new TypeError("Must be between 0 and 63: " + c);
  }, base64.decode = function(c) {
    var ie = 65, we = 90, $e = 97, Me = 122, Ze = 48, ne = 57, rr = 43, gr = 47, or = 26, _r = 52;
    return ie <= c && c <= we ? c - ie : $e <= c && c <= Me ? c - $e + or : Ze <= c && c <= ne ? c - Ze + _r : c == rr ? 62 : c == gr ? 63 : -1;
  }, base64;
}
var hasRequiredBase64Vlq;
function requireBase64Vlq() {
  if (hasRequiredBase64Vlq)
    return base64Vlq;
  hasRequiredBase64Vlq = 1;
  var m = requireBase64(), c = 5, ie = 1 << c, we = ie - 1, $e = ie;
  function Me(ne) {
    return ne < 0 ? (-ne << 1) + 1 : (ne << 1) + 0;
  }
  function Ze(ne) {
    var rr = (ne & 1) === 1, gr = ne >> 1;
    return rr ? -gr : gr;
  }
  return base64Vlq.encode = function(rr) {
    var gr = "", or, _r = Me(rr);
    do
      or = _r & we, _r >>>= c, _r > 0 && (or |= $e), gr += m.encode(or);
    while (_r > 0);
    return gr;
  }, base64Vlq.decode = function(rr, gr, or) {
    var _r = rr.length, Lr = 0, Ir = 0, Ar, Rr;
    do {
      if (gr >= _r)
        throw new Error("Expected more digits in base 64 VLQ value.");
      if (Rr = m.decode(rr.charCodeAt(gr++)), Rr === -1)
        throw new Error("Invalid base64 digit: " + rr.charAt(gr - 1));
      Ar = !!(Rr & $e), Rr &= we, Lr = Lr + (Rr << Ir), Ir += c;
    } while (Ar);
    or.value = Ze(Lr), or.rest = gr;
  }, base64Vlq;
}
var util = {}, hasRequiredUtil;
function requireUtil() {
  return hasRequiredUtil || (hasRequiredUtil = 1, function(m) {
    function c(Wr, si, li) {
      if (si in Wr)
        return Wr[si];
      if (arguments.length === 3)
        return li;
      throw new Error('"' + si + '" is a required argument.');
    }
    m.getArg = c;
    var ie = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/, we = /^data:.+\,.+$/;
    function $e(Wr) {
      var si = Wr.match(ie);
      return si ? {
        scheme: si[1],
        auth: si[2],
        host: si[3],
        port: si[4],
        path: si[5]
      } : null;
    }
    m.urlParse = $e;
    function Me(Wr) {
      var si = "";
      return Wr.scheme && (si += Wr.scheme + ":"), si += "//", Wr.auth && (si += Wr.auth + "@"), Wr.host && (si += Wr.host), Wr.port && (si += ":" + Wr.port), Wr.path && (si += Wr.path), si;
    }
    m.urlGenerate = Me;
    function Ze(Wr) {
      var si = Wr, li = $e(Wr);
      if (li) {
        if (!li.path)
          return Wr;
        si = li.path;
      }
      for (var xi = m.isAbsolute(si), di = si.split(/\/+/), oi, ci = 0, vr = di.length - 1; vr >= 0; vr--)
        oi = di[vr], oi === "." ? di.splice(vr, 1) : oi === ".." ? ci++ : ci > 0 && (oi === "" ? (di.splice(vr + 1, ci), ci = 0) : (di.splice(vr, 2), ci--));
      return si = di.join("/"), si === "" && (si = xi ? "/" : "."), li ? (li.path = si, Me(li)) : si;
    }
    m.normalize = Ze;
    function ne(Wr, si) {
      Wr === "" && (Wr = "."), si === "" && (si = ".");
      var li = $e(si), xi = $e(Wr);
      if (xi && (Wr = xi.path || "/"), li && !li.scheme)
        return xi && (li.scheme = xi.scheme), Me(li);
      if (li || si.match(we))
        return si;
      if (xi && !xi.host && !xi.path)
        return xi.host = si, Me(xi);
      var di = si.charAt(0) === "/" ? si : Ze(Wr.replace(/\/+$/, "") + "/" + si);
      return xi ? (xi.path = di, Me(xi)) : di;
    }
    m.join = ne, m.isAbsolute = function(Wr) {
      return Wr.charAt(0) === "/" || ie.test(Wr);
    };
    function rr(Wr, si) {
      Wr === "" && (Wr = "."), Wr = Wr.replace(/\/$/, "");
      for (var li = 0; si.indexOf(Wr + "/") !== 0; ) {
        var xi = Wr.lastIndexOf("/");
        if (xi < 0 || (Wr = Wr.slice(0, xi), Wr.match(/^([^\/]+:\/)?\/*$/)))
          return si;
        ++li;
      }
      return Array(li + 1).join("../") + si.substr(Wr.length + 1);
    }
    m.relative = rr;
    var gr = function() {
      var Wr = /* @__PURE__ */ Object.create(null);
      return !("__proto__" in Wr);
    }();
    function or(Wr) {
      return Wr;
    }
    function _r(Wr) {
      return Ir(Wr) ? "$" + Wr : Wr;
    }
    m.toSetString = gr ? or : _r;
    function Lr(Wr) {
      return Ir(Wr) ? Wr.slice(1) : Wr;
    }
    m.fromSetString = gr ? or : Lr;
    function Ir(Wr) {
      if (!Wr)
        return !1;
      var si = Wr.length;
      if (si < 9 || Wr.charCodeAt(si - 1) !== 95 || Wr.charCodeAt(si - 2) !== 95 || Wr.charCodeAt(si - 3) !== 111 || Wr.charCodeAt(si - 4) !== 116 || Wr.charCodeAt(si - 5) !== 111 || Wr.charCodeAt(si - 6) !== 114 || Wr.charCodeAt(si - 7) !== 112 || Wr.charCodeAt(si - 8) !== 95 || Wr.charCodeAt(si - 9) !== 95)
        return !1;
      for (var li = si - 10; li >= 0; li--)
        if (Wr.charCodeAt(li) !== 36)
          return !1;
      return !0;
    }
    function Ar(Wr, si, li) {
      var xi = Nr(Wr.source, si.source);
      return xi !== 0 || (xi = Wr.originalLine - si.originalLine, xi !== 0) || (xi = Wr.originalColumn - si.originalColumn, xi !== 0 || li) || (xi = Wr.generatedColumn - si.generatedColumn, xi !== 0) || (xi = Wr.generatedLine - si.generatedLine, xi !== 0) ? xi : Nr(Wr.name, si.name);
    }
    m.compareByOriginalPositions = Ar;
    function Rr(Wr, si, li) {
      var xi = Wr.generatedLine - si.generatedLine;
      return xi !== 0 || (xi = Wr.generatedColumn - si.generatedColumn, xi !== 0 || li) || (xi = Nr(Wr.source, si.source), xi !== 0) || (xi = Wr.originalLine - si.originalLine, xi !== 0) || (xi = Wr.originalColumn - si.originalColumn, xi !== 0) ? xi : Nr(Wr.name, si.name);
    }
    m.compareByGeneratedPositionsDeflated = Rr;
    function Nr(Wr, si) {
      return Wr === si ? 0 : Wr === null ? 1 : si === null ? -1 : Wr > si ? 1 : -1;
    }
    function Yr(Wr, si) {
      var li = Wr.generatedLine - si.generatedLine;
      return li !== 0 || (li = Wr.generatedColumn - si.generatedColumn, li !== 0) || (li = Nr(Wr.source, si.source), li !== 0) || (li = Wr.originalLine - si.originalLine, li !== 0) || (li = Wr.originalColumn - si.originalColumn, li !== 0) ? li : Nr(Wr.name, si.name);
    }
    m.compareByGeneratedPositionsInflated = Yr;
    function Vr(Wr) {
      return JSON.parse(Wr.replace(/^\)]}'[^\n]*\n/, ""));
    }
    m.parseSourceMapInput = Vr;
    function Xr(Wr, si, li) {
      if (si = si || "", Wr && (Wr[Wr.length - 1] !== "/" && si[0] !== "/" && (Wr += "/"), si = Wr + si), li) {
        var xi = $e(li);
        if (!xi)
          throw new Error("sourceMapURL could not be parsed");
        if (xi.path) {
          var di = xi.path.lastIndexOf("/");
          di >= 0 && (xi.path = xi.path.substring(0, di + 1));
        }
        si = ne(Me(xi), si);
      }
      return Ze(si);
    }
    m.computeSourceURL = Xr;
  }(util)), util;
}
var arraySet = {}, hasRequiredArraySet;
function requireArraySet() {
  if (hasRequiredArraySet)
    return arraySet;
  hasRequiredArraySet = 1;
  var m = requireUtil(), c = Object.prototype.hasOwnProperty, ie = typeof Map < "u";
  function we() {
    this._array = [], this._set = ie ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
  }
  return we.fromArray = function(Me, Ze) {
    for (var ne = new we(), rr = 0, gr = Me.length; rr < gr; rr++)
      ne.add(Me[rr], Ze);
    return ne;
  }, we.prototype.size = function() {
    return ie ? this._set.size : Object.getOwnPropertyNames(this._set).length;
  }, we.prototype.add = function(Me, Ze) {
    var ne = ie ? Me : m.toSetString(Me), rr = ie ? this.has(Me) : c.call(this._set, ne), gr = this._array.length;
    (!rr || Ze) && this._array.push(Me), rr || (ie ? this._set.set(Me, gr) : this._set[ne] = gr);
  }, we.prototype.has = function(Me) {
    if (ie)
      return this._set.has(Me);
    var Ze = m.toSetString(Me);
    return c.call(this._set, Ze);
  }, we.prototype.indexOf = function(Me) {
    if (ie) {
      var Ze = this._set.get(Me);
      if (Ze >= 0)
        return Ze;
    } else {
      var ne = m.toSetString(Me);
      if (c.call(this._set, ne))
        return this._set[ne];
    }
    throw new Error('"' + Me + '" is not in the set.');
  }, we.prototype.at = function(Me) {
    if (Me >= 0 && Me < this._array.length)
      return this._array[Me];
    throw new Error("No element indexed by " + Me);
  }, we.prototype.toArray = function() {
    return this._array.slice();
  }, arraySet.ArraySet = we, arraySet;
}
var mappingList = {}, hasRequiredMappingList;
function requireMappingList() {
  if (hasRequiredMappingList)
    return mappingList;
  hasRequiredMappingList = 1;
  var m = requireUtil();
  function c(we, $e) {
    var Me = we.generatedLine, Ze = $e.generatedLine, ne = we.generatedColumn, rr = $e.generatedColumn;
    return Ze > Me || Ze == Me && rr >= ne || m.compareByGeneratedPositionsInflated(we, $e) <= 0;
  }
  function ie() {
    this._array = [], this._sorted = !0, this._last = { generatedLine: -1, generatedColumn: 0 };
  }
  return ie.prototype.unsortedForEach = function($e, Me) {
    this._array.forEach($e, Me);
  }, ie.prototype.add = function($e) {
    c(this._last, $e) ? (this._last = $e, this._array.push($e)) : (this._sorted = !1, this._array.push($e));
  }, ie.prototype.toArray = function() {
    return this._sorted || (this._array.sort(m.compareByGeneratedPositionsInflated), this._sorted = !0), this._array;
  }, mappingList.MappingList = ie, mappingList;
}
var hasRequiredSourceMapGenerator;
function requireSourceMapGenerator() {
  if (hasRequiredSourceMapGenerator)
    return sourceMapGenerator;
  hasRequiredSourceMapGenerator = 1;
  var m = requireBase64Vlq(), c = requireUtil(), ie = requireArraySet().ArraySet, we = requireMappingList().MappingList;
  function $e(Me) {
    Me || (Me = {}), this._file = c.getArg(Me, "file", null), this._sourceRoot = c.getArg(Me, "sourceRoot", null), this._skipValidation = c.getArg(Me, "skipValidation", !1), this._sources = new ie(), this._names = new ie(), this._mappings = new we(), this._sourcesContents = null;
  }
  return $e.prototype._version = 3, $e.fromSourceMap = function(Ze) {
    var ne = Ze.sourceRoot, rr = new $e({
      file: Ze.file,
      sourceRoot: ne
    });
    return Ze.eachMapping(function(gr) {
      var or = {
        generated: {
          line: gr.generatedLine,
          column: gr.generatedColumn
        }
      };
      gr.source != null && (or.source = gr.source, ne != null && (or.source = c.relative(ne, or.source)), or.original = {
        line: gr.originalLine,
        column: gr.originalColumn
      }, gr.name != null && (or.name = gr.name)), rr.addMapping(or);
    }), Ze.sources.forEach(function(gr) {
      var or = gr;
      ne !== null && (or = c.relative(ne, gr)), rr._sources.has(or) || rr._sources.add(or);
      var _r = Ze.sourceContentFor(gr);
      _r != null && rr.setSourceContent(gr, _r);
    }), rr;
  }, $e.prototype.addMapping = function(Ze) {
    var ne = c.getArg(Ze, "generated"), rr = c.getArg(Ze, "original", null), gr = c.getArg(Ze, "source", null), or = c.getArg(Ze, "name", null);
    this._skipValidation || this._validateMapping(ne, rr, gr, or), gr != null && (gr = String(gr), this._sources.has(gr) || this._sources.add(gr)), or != null && (or = String(or), this._names.has(or) || this._names.add(or)), this._mappings.add({
      generatedLine: ne.line,
      generatedColumn: ne.column,
      originalLine: rr != null && rr.line,
      originalColumn: rr != null && rr.column,
      source: gr,
      name: or
    });
  }, $e.prototype.setSourceContent = function(Ze, ne) {
    var rr = Ze;
    this._sourceRoot != null && (rr = c.relative(this._sourceRoot, rr)), ne != null ? (this._sourcesContents || (this._sourcesContents = /* @__PURE__ */ Object.create(null)), this._sourcesContents[c.toSetString(rr)] = ne) : this._sourcesContents && (delete this._sourcesContents[c.toSetString(rr)], Object.keys(this._sourcesContents).length === 0 && (this._sourcesContents = null));
  }, $e.prototype.applySourceMap = function(Ze, ne, rr) {
    var gr = ne;
    if (ne == null) {
      if (Ze.file == null)
        throw new Error(
          `SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map's "file" property. Both were omitted.`
        );
      gr = Ze.file;
    }
    var or = this._sourceRoot;
    or != null && (gr = c.relative(or, gr));
    var _r = new ie(), Lr = new ie();
    this._mappings.unsortedForEach(function(Ir) {
      if (Ir.source === gr && Ir.originalLine != null) {
        var Ar = Ze.originalPositionFor({
          line: Ir.originalLine,
          column: Ir.originalColumn
        });
        Ar.source != null && (Ir.source = Ar.source, rr != null && (Ir.source = c.join(rr, Ir.source)), or != null && (Ir.source = c.relative(or, Ir.source)), Ir.originalLine = Ar.line, Ir.originalColumn = Ar.column, Ar.name != null && (Ir.name = Ar.name));
      }
      var Rr = Ir.source;
      Rr != null && !_r.has(Rr) && _r.add(Rr);
      var Nr = Ir.name;
      Nr != null && !Lr.has(Nr) && Lr.add(Nr);
    }, this), this._sources = _r, this._names = Lr, Ze.sources.forEach(function(Ir) {
      var Ar = Ze.sourceContentFor(Ir);
      Ar != null && (rr != null && (Ir = c.join(rr, Ir)), or != null && (Ir = c.relative(or, Ir)), this.setSourceContent(Ir, Ar));
    }, this);
  }, $e.prototype._validateMapping = function(Ze, ne, rr, gr) {
    if (ne && typeof ne.line != "number" && typeof ne.column != "number")
      throw new Error(
        "original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values."
      );
    if (!(Ze && "line" in Ze && "column" in Ze && Ze.line > 0 && Ze.column >= 0 && !ne && !rr && !gr)) {
      if (Ze && "line" in Ze && "column" in Ze && ne && "line" in ne && "column" in ne && Ze.line > 0 && Ze.column >= 0 && ne.line > 0 && ne.column >= 0 && rr)
        return;
      throw new Error("Invalid mapping: " + JSON.stringify({
        generated: Ze,
        source: rr,
        original: ne,
        name: gr
      }));
    }
  }, $e.prototype._serializeMappings = function() {
    for (var Ze = 0, ne = 1, rr = 0, gr = 0, or = 0, _r = 0, Lr = "", Ir, Ar, Rr, Nr, Yr = this._mappings.toArray(), Vr = 0, Xr = Yr.length; Vr < Xr; Vr++) {
      if (Ar = Yr[Vr], Ir = "", Ar.generatedLine !== ne)
        for (Ze = 0; Ar.generatedLine !== ne; )
          Ir += ";", ne++;
      else if (Vr > 0) {
        if (!c.compareByGeneratedPositionsInflated(Ar, Yr[Vr - 1]))
          continue;
        Ir += ",";
      }
      Ir += m.encode(Ar.generatedColumn - Ze), Ze = Ar.generatedColumn, Ar.source != null && (Nr = this._sources.indexOf(Ar.source), Ir += m.encode(Nr - _r), _r = Nr, Ir += m.encode(Ar.originalLine - 1 - gr), gr = Ar.originalLine - 1, Ir += m.encode(Ar.originalColumn - rr), rr = Ar.originalColumn, Ar.name != null && (Rr = this._names.indexOf(Ar.name), Ir += m.encode(Rr - or), or = Rr)), Lr += Ir;
    }
    return Lr;
  }, $e.prototype._generateSourcesContent = function(Ze, ne) {
    return Ze.map(function(rr) {
      if (!this._sourcesContents)
        return null;
      ne != null && (rr = c.relative(ne, rr));
      var gr = c.toSetString(rr);
      return Object.prototype.hasOwnProperty.call(this._sourcesContents, gr) ? this._sourcesContents[gr] : null;
    }, this);
  }, $e.prototype.toJSON = function() {
    var Ze = {
      version: this._version,
      sources: this._sources.toArray(),
      names: this._names.toArray(),
      mappings: this._serializeMappings()
    };
    return this._file != null && (Ze.file = this._file), this._sourceRoot != null && (Ze.sourceRoot = this._sourceRoot), this._sourcesContents && (Ze.sourcesContent = this._generateSourcesContent(Ze.sources, Ze.sourceRoot)), Ze;
  }, $e.prototype.toString = function() {
    return JSON.stringify(this.toJSON());
  }, sourceMapGenerator.SourceMapGenerator = $e, sourceMapGenerator;
}
var sourceMapConsumer = {}, binarySearch = {}, hasRequiredBinarySearch;
function requireBinarySearch() {
  return hasRequiredBinarySearch || (hasRequiredBinarySearch = 1, function(m) {
    m.GREATEST_LOWER_BOUND = 1, m.LEAST_UPPER_BOUND = 2;
    function c(ie, we, $e, Me, Ze, ne) {
      var rr = Math.floor((we - ie) / 2) + ie, gr = Ze($e, Me[rr], !0);
      return gr === 0 ? rr : gr > 0 ? we - rr > 1 ? c(rr, we, $e, Me, Ze, ne) : ne == m.LEAST_UPPER_BOUND ? we < Me.length ? we : -1 : rr : rr - ie > 1 ? c(ie, rr, $e, Me, Ze, ne) : ne == m.LEAST_UPPER_BOUND ? rr : ie < 0 ? -1 : ie;
    }
    m.search = function(we, $e, Me, Ze) {
      if ($e.length === 0)
        return -1;
      var ne = c(
        -1,
        $e.length,
        we,
        $e,
        Me,
        Ze || m.GREATEST_LOWER_BOUND
      );
      if (ne < 0)
        return -1;
      for (; ne - 1 >= 0 && Me($e[ne], $e[ne - 1], !0) === 0; )
        --ne;
      return ne;
    };
  }(binarySearch)), binarySearch;
}
var quickSort = {}, hasRequiredQuickSort;
function requireQuickSort() {
  if (hasRequiredQuickSort)
    return quickSort;
  hasRequiredQuickSort = 1;
  function m(we, $e, Me) {
    var Ze = we[$e];
    we[$e] = we[Me], we[Me] = Ze;
  }
  function c(we, $e) {
    return Math.round(we + Math.random() * ($e - we));
  }
  function ie(we, $e, Me, Ze) {
    if (Me < Ze) {
      var ne = c(Me, Ze), rr = Me - 1;
      m(we, ne, Ze);
      for (var gr = we[Ze], or = Me; or < Ze; or++)
        $e(we[or], gr) <= 0 && (rr += 1, m(we, rr, or));
      m(we, rr + 1, or);
      var _r = rr + 1;
      ie(we, $e, Me, _r - 1), ie(we, $e, _r + 1, Ze);
    }
  }
  return quickSort.quickSort = function(we, $e) {
    ie(we, $e, 0, we.length - 1);
  }, quickSort;
}
var hasRequiredSourceMapConsumer;
function requireSourceMapConsumer() {
  if (hasRequiredSourceMapConsumer)
    return sourceMapConsumer;
  hasRequiredSourceMapConsumer = 1;
  var m = requireUtil(), c = requireBinarySearch(), ie = requireArraySet().ArraySet, we = requireBase64Vlq(), $e = requireQuickSort().quickSort;
  function Me(gr, or) {
    var _r = gr;
    return typeof gr == "string" && (_r = m.parseSourceMapInput(gr)), _r.sections != null ? new rr(_r, or) : new Ze(_r, or);
  }
  Me.fromSourceMap = function(gr, or) {
    return Ze.fromSourceMap(gr, or);
  }, Me.prototype._version = 3, Me.prototype.__generatedMappings = null, Object.defineProperty(Me.prototype, "_generatedMappings", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.__generatedMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__generatedMappings;
    }
  }), Me.prototype.__originalMappings = null, Object.defineProperty(Me.prototype, "_originalMappings", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.__originalMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__originalMappings;
    }
  }), Me.prototype._charIsMappingSeparator = function(or, _r) {
    var Lr = or.charAt(_r);
    return Lr === ";" || Lr === ",";
  }, Me.prototype._parseMappings = function(or, _r) {
    throw new Error("Subclasses must implement _parseMappings");
  }, Me.GENERATED_ORDER = 1, Me.ORIGINAL_ORDER = 2, Me.GREATEST_LOWER_BOUND = 1, Me.LEAST_UPPER_BOUND = 2, Me.prototype.eachMapping = function(or, _r, Lr) {
    var Ir = _r || null, Ar = Lr || Me.GENERATED_ORDER, Rr;
    switch (Ar) {
      case Me.GENERATED_ORDER:
        Rr = this._generatedMappings;
        break;
      case Me.ORIGINAL_ORDER:
        Rr = this._originalMappings;
        break;
      default:
        throw new Error("Unknown order of iteration.");
    }
    var Nr = this.sourceRoot;
    Rr.map(function(Yr) {
      var Vr = Yr.source === null ? null : this._sources.at(Yr.source);
      return Vr = m.computeSourceURL(Nr, Vr, this._sourceMapURL), {
        source: Vr,
        generatedLine: Yr.generatedLine,
        generatedColumn: Yr.generatedColumn,
        originalLine: Yr.originalLine,
        originalColumn: Yr.originalColumn,
        name: Yr.name === null ? null : this._names.at(Yr.name)
      };
    }, this).forEach(or, Ir);
  }, Me.prototype.allGeneratedPositionsFor = function(or) {
    var _r = m.getArg(or, "line"), Lr = {
      source: m.getArg(or, "source"),
      originalLine: _r,
      originalColumn: m.getArg(or, "column", 0)
    };
    if (Lr.source = this._findSourceIndex(Lr.source), Lr.source < 0)
      return [];
    var Ir = [], Ar = this._findMapping(
      Lr,
      this._originalMappings,
      "originalLine",
      "originalColumn",
      m.compareByOriginalPositions,
      c.LEAST_UPPER_BOUND
    );
    if (Ar >= 0) {
      var Rr = this._originalMappings[Ar];
      if (or.column === void 0)
        for (var Nr = Rr.originalLine; Rr && Rr.originalLine === Nr; )
          Ir.push({
            line: m.getArg(Rr, "generatedLine", null),
            column: m.getArg(Rr, "generatedColumn", null),
            lastColumn: m.getArg(Rr, "lastGeneratedColumn", null)
          }), Rr = this._originalMappings[++Ar];
      else
        for (var Yr = Rr.originalColumn; Rr && Rr.originalLine === _r && Rr.originalColumn == Yr; )
          Ir.push({
            line: m.getArg(Rr, "generatedLine", null),
            column: m.getArg(Rr, "generatedColumn", null),
            lastColumn: m.getArg(Rr, "lastGeneratedColumn", null)
          }), Rr = this._originalMappings[++Ar];
    }
    return Ir;
  }, sourceMapConsumer.SourceMapConsumer = Me;
  function Ze(gr, or) {
    var _r = gr;
    typeof gr == "string" && (_r = m.parseSourceMapInput(gr));
    var Lr = m.getArg(_r, "version"), Ir = m.getArg(_r, "sources"), Ar = m.getArg(_r, "names", []), Rr = m.getArg(_r, "sourceRoot", null), Nr = m.getArg(_r, "sourcesContent", null), Yr = m.getArg(_r, "mappings"), Vr = m.getArg(_r, "file", null);
    if (Lr != this._version)
      throw new Error("Unsupported version: " + Lr);
    Rr && (Rr = m.normalize(Rr)), Ir = Ir.map(String).map(m.normalize).map(function(Xr) {
      return Rr && m.isAbsolute(Rr) && m.isAbsolute(Xr) ? m.relative(Rr, Xr) : Xr;
    }), this._names = ie.fromArray(Ar.map(String), !0), this._sources = ie.fromArray(Ir, !0), this._absoluteSources = this._sources.toArray().map(function(Xr) {
      return m.computeSourceURL(Rr, Xr, or);
    }), this.sourceRoot = Rr, this.sourcesContent = Nr, this._mappings = Yr, this._sourceMapURL = or, this.file = Vr;
  }
  Ze.prototype = Object.create(Me.prototype), Ze.prototype.consumer = Me, Ze.prototype._findSourceIndex = function(gr) {
    var or = gr;
    if (this.sourceRoot != null && (or = m.relative(this.sourceRoot, or)), this._sources.has(or))
      return this._sources.indexOf(or);
    var _r;
    for (_r = 0; _r < this._absoluteSources.length; ++_r)
      if (this._absoluteSources[_r] == gr)
        return _r;
    return -1;
  }, Ze.fromSourceMap = function(or, _r) {
    var Lr = Object.create(Ze.prototype), Ir = Lr._names = ie.fromArray(or._names.toArray(), !0), Ar = Lr._sources = ie.fromArray(or._sources.toArray(), !0);
    Lr.sourceRoot = or._sourceRoot, Lr.sourcesContent = or._generateSourcesContent(
      Lr._sources.toArray(),
      Lr.sourceRoot
    ), Lr.file = or._file, Lr._sourceMapURL = _r, Lr._absoluteSources = Lr._sources.toArray().map(function(li) {
      return m.computeSourceURL(Lr.sourceRoot, li, _r);
    });
    for (var Rr = or._mappings.toArray().slice(), Nr = Lr.__generatedMappings = [], Yr = Lr.__originalMappings = [], Vr = 0, Xr = Rr.length; Vr < Xr; Vr++) {
      var Wr = Rr[Vr], si = new ne();
      si.generatedLine = Wr.generatedLine, si.generatedColumn = Wr.generatedColumn, Wr.source && (si.source = Ar.indexOf(Wr.source), si.originalLine = Wr.originalLine, si.originalColumn = Wr.originalColumn, Wr.name && (si.name = Ir.indexOf(Wr.name)), Yr.push(si)), Nr.push(si);
    }
    return $e(Lr.__originalMappings, m.compareByOriginalPositions), Lr;
  }, Ze.prototype._version = 3, Object.defineProperty(Ze.prototype, "sources", {
    get: function() {
      return this._absoluteSources.slice();
    }
  });
  function ne() {
    this.generatedLine = 0, this.generatedColumn = 0, this.source = null, this.originalLine = null, this.originalColumn = null, this.name = null;
  }
  Ze.prototype._parseMappings = function(or, _r) {
    for (var Lr = 1, Ir = 0, Ar = 0, Rr = 0, Nr = 0, Yr = 0, Vr = or.length, Xr = 0, Wr = {}, si = {}, li = [], xi = [], di, oi, ci, vr, Ae; Xr < Vr; )
      if (or.charAt(Xr) === ";")
        Lr++, Xr++, Ir = 0;
      else if (or.charAt(Xr) === ",")
        Xr++;
      else {
        for (di = new ne(), di.generatedLine = Lr, vr = Xr; vr < Vr && !this._charIsMappingSeparator(or, vr); vr++)
          ;
        if (oi = or.slice(Xr, vr), ci = Wr[oi], ci)
          Xr += oi.length;
        else {
          for (ci = []; Xr < vr; )
            we.decode(or, Xr, si), Ae = si.value, Xr = si.rest, ci.push(Ae);
          if (ci.length === 2)
            throw new Error("Found a source, but no line and column");
          if (ci.length === 3)
            throw new Error("Found a source and line, but no column");
          Wr[oi] = ci;
        }
        di.generatedColumn = Ir + ci[0], Ir = di.generatedColumn, ci.length > 1 && (di.source = Nr + ci[1], Nr += ci[1], di.originalLine = Ar + ci[2], Ar = di.originalLine, di.originalLine += 1, di.originalColumn = Rr + ci[3], Rr = di.originalColumn, ci.length > 4 && (di.name = Yr + ci[4], Yr += ci[4])), xi.push(di), typeof di.originalLine == "number" && li.push(di);
      }
    $e(xi, m.compareByGeneratedPositionsDeflated), this.__generatedMappings = xi, $e(li, m.compareByOriginalPositions), this.__originalMappings = li;
  }, Ze.prototype._findMapping = function(or, _r, Lr, Ir, Ar, Rr) {
    if (or[Lr] <= 0)
      throw new TypeError("Line must be greater than or equal to 1, got " + or[Lr]);
    if (or[Ir] < 0)
      throw new TypeError("Column must be greater than or equal to 0, got " + or[Ir]);
    return c.search(or, _r, Ar, Rr);
  }, Ze.prototype.computeColumnSpans = function() {
    for (var or = 0; or < this._generatedMappings.length; ++or) {
      var _r = this._generatedMappings[or];
      if (or + 1 < this._generatedMappings.length) {
        var Lr = this._generatedMappings[or + 1];
        if (_r.generatedLine === Lr.generatedLine) {
          _r.lastGeneratedColumn = Lr.generatedColumn - 1;
          continue;
        }
      }
      _r.lastGeneratedColumn = 1 / 0;
    }
  }, Ze.prototype.originalPositionFor = function(or) {
    var _r = {
      generatedLine: m.getArg(or, "line"),
      generatedColumn: m.getArg(or, "column")
    }, Lr = this._findMapping(
      _r,
      this._generatedMappings,
      "generatedLine",
      "generatedColumn",
      m.compareByGeneratedPositionsDeflated,
      m.getArg(or, "bias", Me.GREATEST_LOWER_BOUND)
    );
    if (Lr >= 0) {
      var Ir = this._generatedMappings[Lr];
      if (Ir.generatedLine === _r.generatedLine) {
        var Ar = m.getArg(Ir, "source", null);
        Ar !== null && (Ar = this._sources.at(Ar), Ar = m.computeSourceURL(this.sourceRoot, Ar, this._sourceMapURL));
        var Rr = m.getArg(Ir, "name", null);
        return Rr !== null && (Rr = this._names.at(Rr)), {
          source: Ar,
          line: m.getArg(Ir, "originalLine", null),
          column: m.getArg(Ir, "originalColumn", null),
          name: Rr
        };
      }
    }
    return {
      source: null,
      line: null,
      column: null,
      name: null
    };
  }, Ze.prototype.hasContentsOfAllSources = function() {
    return this.sourcesContent ? this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(or) {
      return or == null;
    }) : !1;
  }, Ze.prototype.sourceContentFor = function(or, _r) {
    if (!this.sourcesContent)
      return null;
    var Lr = this._findSourceIndex(or);
    if (Lr >= 0)
      return this.sourcesContent[Lr];
    var Ir = or;
    this.sourceRoot != null && (Ir = m.relative(this.sourceRoot, Ir));
    var Ar;
    if (this.sourceRoot != null && (Ar = m.urlParse(this.sourceRoot))) {
      var Rr = Ir.replace(/^file:\/\//, "");
      if (Ar.scheme == "file" && this._sources.has(Rr))
        return this.sourcesContent[this._sources.indexOf(Rr)];
      if ((!Ar.path || Ar.path == "/") && this._sources.has("/" + Ir))
        return this.sourcesContent[this._sources.indexOf("/" + Ir)];
    }
    if (_r)
      return null;
    throw new Error('"' + Ir + '" is not in the SourceMap.');
  }, Ze.prototype.generatedPositionFor = function(or) {
    var _r = m.getArg(or, "source");
    if (_r = this._findSourceIndex(_r), _r < 0)
      return {
        line: null,
        column: null,
        lastColumn: null
      };
    var Lr = {
      source: _r,
      originalLine: m.getArg(or, "line"),
      originalColumn: m.getArg(or, "column")
    }, Ir = this._findMapping(
      Lr,
      this._originalMappings,
      "originalLine",
      "originalColumn",
      m.compareByOriginalPositions,
      m.getArg(or, "bias", Me.GREATEST_LOWER_BOUND)
    );
    if (Ir >= 0) {
      var Ar = this._originalMappings[Ir];
      if (Ar.source === Lr.source)
        return {
          line: m.getArg(Ar, "generatedLine", null),
          column: m.getArg(Ar, "generatedColumn", null),
          lastColumn: m.getArg(Ar, "lastGeneratedColumn", null)
        };
    }
    return {
      line: null,
      column: null,
      lastColumn: null
    };
  }, sourceMapConsumer.BasicSourceMapConsumer = Ze;
  function rr(gr, or) {
    var _r = gr;
    typeof gr == "string" && (_r = m.parseSourceMapInput(gr));
    var Lr = m.getArg(_r, "version"), Ir = m.getArg(_r, "sections");
    if (Lr != this._version)
      throw new Error("Unsupported version: " + Lr);
    this._sources = new ie(), this._names = new ie();
    var Ar = {
      line: -1,
      column: 0
    };
    this._sections = Ir.map(function(Rr) {
      if (Rr.url)
        throw new Error("Support for url field in sections not implemented.");
      var Nr = m.getArg(Rr, "offset"), Yr = m.getArg(Nr, "line"), Vr = m.getArg(Nr, "column");
      if (Yr < Ar.line || Yr === Ar.line && Vr < Ar.column)
        throw new Error("Section offsets must be ordered and non-overlapping.");
      return Ar = Nr, {
        generatedOffset: {
          generatedLine: Yr + 1,
          generatedColumn: Vr + 1
        },
        consumer: new Me(m.getArg(Rr, "map"), or)
      };
    });
  }
  return rr.prototype = Object.create(Me.prototype), rr.prototype.constructor = Me, rr.prototype._version = 3, Object.defineProperty(rr.prototype, "sources", {
    get: function() {
      for (var gr = [], or = 0; or < this._sections.length; or++)
        for (var _r = 0; _r < this._sections[or].consumer.sources.length; _r++)
          gr.push(this._sections[or].consumer.sources[_r]);
      return gr;
    }
  }), rr.prototype.originalPositionFor = function(or) {
    var _r = {
      generatedLine: m.getArg(or, "line"),
      generatedColumn: m.getArg(or, "column")
    }, Lr = c.search(
      _r,
      this._sections,
      function(Ar, Rr) {
        var Nr = Ar.generatedLine - Rr.generatedOffset.generatedLine;
        return Nr || Ar.generatedColumn - Rr.generatedOffset.generatedColumn;
      }
    ), Ir = this._sections[Lr];
    return Ir ? Ir.consumer.originalPositionFor({
      line: _r.generatedLine - (Ir.generatedOffset.generatedLine - 1),
      column: _r.generatedColumn - (Ir.generatedOffset.generatedLine === _r.generatedLine ? Ir.generatedOffset.generatedColumn - 1 : 0),
      bias: or.bias
    }) : {
      source: null,
      line: null,
      column: null,
      name: null
    };
  }, rr.prototype.hasContentsOfAllSources = function() {
    return this._sections.every(function(or) {
      return or.consumer.hasContentsOfAllSources();
    });
  }, rr.prototype.sourceContentFor = function(or, _r) {
    for (var Lr = 0; Lr < this._sections.length; Lr++) {
      var Ir = this._sections[Lr], Ar = Ir.consumer.sourceContentFor(or, !0);
      if (Ar)
        return Ar;
    }
    if (_r)
      return null;
    throw new Error('"' + or + '" is not in the SourceMap.');
  }, rr.prototype.generatedPositionFor = function(or) {
    for (var _r = 0; _r < this._sections.length; _r++) {
      var Lr = this._sections[_r];
      if (Lr.consumer._findSourceIndex(m.getArg(or, "source")) !== -1) {
        var Ir = Lr.consumer.generatedPositionFor(or);
        if (Ir) {
          var Ar = {
            line: Ir.line + (Lr.generatedOffset.generatedLine - 1),
            column: Ir.column + (Lr.generatedOffset.generatedLine === Ir.line ? Lr.generatedOffset.generatedColumn - 1 : 0)
          };
          return Ar;
        }
      }
    }
    return {
      line: null,
      column: null
    };
  }, rr.prototype._parseMappings = function(or, _r) {
    this.__generatedMappings = [], this.__originalMappings = [];
    for (var Lr = 0; Lr < this._sections.length; Lr++)
      for (var Ir = this._sections[Lr], Ar = Ir.consumer._generatedMappings, Rr = 0; Rr < Ar.length; Rr++) {
        var Nr = Ar[Rr], Yr = Ir.consumer._sources.at(Nr.source);
        Yr = m.computeSourceURL(Ir.consumer.sourceRoot, Yr, this._sourceMapURL), this._sources.add(Yr), Yr = this._sources.indexOf(Yr);
        var Vr = null;
        Nr.name && (Vr = Ir.consumer._names.at(Nr.name), this._names.add(Vr), Vr = this._names.indexOf(Vr));
        var Xr = {
          source: Yr,
          generatedLine: Nr.generatedLine + (Ir.generatedOffset.generatedLine - 1),
          generatedColumn: Nr.generatedColumn + (Ir.generatedOffset.generatedLine === Nr.generatedLine ? Ir.generatedOffset.generatedColumn - 1 : 0),
          originalLine: Nr.originalLine,
          originalColumn: Nr.originalColumn,
          name: Vr
        };
        this.__generatedMappings.push(Xr), typeof Xr.originalLine == "number" && this.__originalMappings.push(Xr);
      }
    $e(this.__generatedMappings, m.compareByGeneratedPositionsDeflated), $e(this.__originalMappings, m.compareByOriginalPositions);
  }, sourceMapConsumer.IndexedSourceMapConsumer = rr, sourceMapConsumer;
}
var sourceNode = {}, hasRequiredSourceNode;
function requireSourceNode() {
  if (hasRequiredSourceNode)
    return sourceNode;
  hasRequiredSourceNode = 1;
  var m = requireSourceMapGenerator().SourceMapGenerator, c = requireUtil(), ie = /(\r?\n)/, we = 10, $e = "$$$isSourceNode$$$";
  function Me(Ze, ne, rr, gr, or) {
    this.children = [], this.sourceContents = {}, this.line = Ze ?? null, this.column = ne ?? null, this.source = rr ?? null, this.name = or ?? null, this[$e] = !0, gr != null && this.add(gr);
  }
  return Me.fromStringWithSourceMap = function(ne, rr, gr) {
    var or = new Me(), _r = ne.split(ie), Lr = 0, Ir = function() {
      var Vr = Wr(), Xr = Wr() || "";
      return Vr + Xr;
      function Wr() {
        return Lr < _r.length ? _r[Lr++] : void 0;
      }
    }, Ar = 1, Rr = 0, Nr = null;
    return rr.eachMapping(function(Vr) {
      if (Nr !== null)
        if (Ar < Vr.generatedLine)
          Yr(Nr, Ir()), Ar++, Rr = 0;
        else {
          var Xr = _r[Lr] || "", Wr = Xr.substr(0, Vr.generatedColumn - Rr);
          _r[Lr] = Xr.substr(Vr.generatedColumn - Rr), Rr = Vr.generatedColumn, Yr(Nr, Wr), Nr = Vr;
          return;
        }
      for (; Ar < Vr.generatedLine; )
        or.add(Ir()), Ar++;
      if (Rr < Vr.generatedColumn) {
        var Xr = _r[Lr] || "";
        or.add(Xr.substr(0, Vr.generatedColumn)), _r[Lr] = Xr.substr(Vr.generatedColumn), Rr = Vr.generatedColumn;
      }
      Nr = Vr;
    }, this), Lr < _r.length && (Nr && Yr(Nr, Ir()), or.add(_r.splice(Lr).join(""))), rr.sources.forEach(function(Vr) {
      var Xr = rr.sourceContentFor(Vr);
      Xr != null && (gr != null && (Vr = c.join(gr, Vr)), or.setSourceContent(Vr, Xr));
    }), or;
    function Yr(Vr, Xr) {
      if (Vr === null || Vr.source === void 0)
        or.add(Xr);
      else {
        var Wr = gr ? c.join(gr, Vr.source) : Vr.source;
        or.add(new Me(
          Vr.originalLine,
          Vr.originalColumn,
          Wr,
          Xr,
          Vr.name
        ));
      }
    }
  }, Me.prototype.add = function(ne) {
    if (Array.isArray(ne))
      ne.forEach(function(rr) {
        this.add(rr);
      }, this);
    else if (ne[$e] || typeof ne == "string")
      ne && this.children.push(ne);
    else
      throw new TypeError(
        "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + ne
      );
    return this;
  }, Me.prototype.prepend = function(ne) {
    if (Array.isArray(ne))
      for (var rr = ne.length - 1; rr >= 0; rr--)
        this.prepend(ne[rr]);
    else if (ne[$e] || typeof ne == "string")
      this.children.unshift(ne);
    else
      throw new TypeError(
        "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + ne
      );
    return this;
  }, Me.prototype.walk = function(ne) {
    for (var rr, gr = 0, or = this.children.length; gr < or; gr++)
      rr = this.children[gr], rr[$e] ? rr.walk(ne) : rr !== "" && ne(rr, {
        source: this.source,
        line: this.line,
        column: this.column,
        name: this.name
      });
  }, Me.prototype.join = function(ne) {
    var rr, gr, or = this.children.length;
    if (or > 0) {
      for (rr = [], gr = 0; gr < or - 1; gr++)
        rr.push(this.children[gr]), rr.push(ne);
      rr.push(this.children[gr]), this.children = rr;
    }
    return this;
  }, Me.prototype.replaceRight = function(ne, rr) {
    var gr = this.children[this.children.length - 1];
    return gr[$e] ? gr.replaceRight(ne, rr) : typeof gr == "string" ? this.children[this.children.length - 1] = gr.replace(ne, rr) : this.children.push("".replace(ne, rr)), this;
  }, Me.prototype.setSourceContent = function(ne, rr) {
    this.sourceContents[c.toSetString(ne)] = rr;
  }, Me.prototype.walkSourceContents = function(ne) {
    for (var rr = 0, gr = this.children.length; rr < gr; rr++)
      this.children[rr][$e] && this.children[rr].walkSourceContents(ne);
    for (var or = Object.keys(this.sourceContents), rr = 0, gr = or.length; rr < gr; rr++)
      ne(c.fromSetString(or[rr]), this.sourceContents[or[rr]]);
  }, Me.prototype.toString = function() {
    var ne = "";
    return this.walk(function(rr) {
      ne += rr;
    }), ne;
  }, Me.prototype.toStringWithSourceMap = function(ne) {
    var rr = {
      code: "",
      line: 1,
      column: 0
    }, gr = new m(ne), or = !1, _r = null, Lr = null, Ir = null, Ar = null;
    return this.walk(function(Rr, Nr) {
      rr.code += Rr, Nr.source !== null && Nr.line !== null && Nr.column !== null ? ((_r !== Nr.source || Lr !== Nr.line || Ir !== Nr.column || Ar !== Nr.name) && gr.addMapping({
        source: Nr.source,
        original: {
          line: Nr.line,
          column: Nr.column
        },
        generated: {
          line: rr.line,
          column: rr.column
        },
        name: Nr.name
      }), _r = Nr.source, Lr = Nr.line, Ir = Nr.column, Ar = Nr.name, or = !0) : or && (gr.addMapping({
        generated: {
          line: rr.line,
          column: rr.column
        }
      }), _r = null, or = !1);
      for (var Yr = 0, Vr = Rr.length; Yr < Vr; Yr++)
        Rr.charCodeAt(Yr) === we ? (rr.line++, rr.column = 0, Yr + 1 === Vr ? (_r = null, or = !1) : or && gr.addMapping({
          source: Nr.source,
          original: {
            line: Nr.line,
            column: Nr.column
          },
          generated: {
            line: rr.line,
            column: rr.column
          },
          name: Nr.name
        })) : rr.column++;
    }), this.walkSourceContents(function(Rr, Nr) {
      gr.setSourceContent(Rr, Nr);
    }), { code: rr.code, map: gr };
  }, sourceNode.SourceNode = Me, sourceNode;
}
var hasRequiredSourceMap;
function requireSourceMap() {
  return hasRequiredSourceMap || (hasRequiredSourceMap = 1, sourceMap.SourceMapGenerator = requireSourceMapGenerator().SourceMapGenerator, sourceMap.SourceMapConsumer = requireSourceMapConsumer().SourceMapConsumer, sourceMap.SourceNode = requireSourceNode().SourceNode), sourceMap;
}
var browserAtob = { exports: {} }, hasRequiredBrowserAtob;
function requireBrowserAtob() {
  return hasRequiredBrowserAtob || (hasRequiredBrowserAtob = 1, function(m) {
    (function(c) {
      function ie($e) {
        return typeof $e == "function" ? $e : typeof Buffer$C == "function" ? function(Ze) {
          //!! Deliberately using an API that's deprecated in node.js because
          //!! this file is for browsers and we expect them to cope with it.
          //!! Discussion: github.com/node-browser-compat/atob/pull/9
          return new Buffer$C(Ze, "base64").toString("binary");
        } : typeof c.base64js == "object" ? function(Ze) {
          var ne = c.base64js.b64ToByteArray(Ze);
          return Array.prototype.map.call(ne, function(rr) {
            return String.fromCharCode(rr);
          }).join("");
        } : function() {
          throw new Error("You're probably in an old browser or an iOS webworker. It might help to include beatgammit's base64-js.");
        };
      }
      var we = ie(c.atob);
      c.atob = we, m && m.exports && (m.exports = we);
    })(window);
  }(browserAtob)), browserAtob.exports;
}
var punycode$1 = { exports: {} };
/*! https://mths.be/punycode v1.4.1 by @mathias */
(function(m, c) {
  (function(ie) {
    var we = c && !c.nodeType && c, $e = m && !m.nodeType && m, Me = typeof commonjsGlobal == "object" && commonjsGlobal;
    (Me.global === Me || Me.window === Me || Me.self === Me) && (ie = Me);
    var Ze, ne = 2147483647, rr = 36, gr = 1, or = 26, _r = 38, Lr = 700, Ir = 72, Ar = 128, Rr = "-", Nr = /^xn--/, Yr = /[^\x20-\x7E]/, Vr = /[\x2E\u3002\uFF0E\uFF61]/g, Xr = {
      overflow: "Overflow: input needs wider integers to process",
      "not-basic": "Illegal input >= 0x80 (not a basic code point)",
      "invalid-input": "Invalid input"
    }, Wr = rr - gr, si = Math.floor, li = String.fromCharCode, xi;
    function di(Pe) {
      throw new RangeError(Xr[Pe]);
    }
    function oi(Pe, ur) {
      for (var Pr = Pe.length, Hr = []; Pr--; )
        Hr[Pr] = ur(Pe[Pr]);
      return Hr;
    }
    function ci(Pe, ur) {
      var Pr = Pe.split("@"), Hr = "";
      Pr.length > 1 && (Hr = Pr[0] + "@", Pe = Pr[1]), Pe = Pe.replace(Vr, ".");
      var vi = Pe.split("."), Ti = oi(vi, ur).join(".");
      return Hr + Ti;
    }
    function vr(Pe) {
      for (var ur = [], Pr = 0, Hr = Pe.length, vi, Ti; Pr < Hr; )
        vi = Pe.charCodeAt(Pr++), vi >= 55296 && vi <= 56319 && Pr < Hr ? (Ti = Pe.charCodeAt(Pr++), (Ti & 64512) == 56320 ? ur.push(((vi & 1023) << 10) + (Ti & 1023) + 65536) : (ur.push(vi), Pr--)) : ur.push(vi);
      return ur;
    }
    function Ae(Pe) {
      return oi(Pe, function(ur) {
        var Pr = "";
        return ur > 65535 && (ur -= 65536, Pr += li(ur >>> 10 & 1023 | 55296), ur = 56320 | ur & 1023), Pr += li(ur), Pr;
      }).join("");
    }
    function ze(Pe) {
      return Pe - 48 < 10 ? Pe - 22 : Pe - 65 < 26 ? Pe - 65 : Pe - 97 < 26 ? Pe - 97 : rr;
    }
    function Ue(Pe, ur) {
      return Pe + 22 + 75 * (Pe < 26) - ((ur != 0) << 5);
    }
    function tr(Pe, ur, Pr) {
      var Hr = 0;
      for (Pe = Pr ? si(Pe / Lr) : Pe >> 1, Pe += si(Pe / ur); Pe > Wr * or >> 1; Hr += rr)
        Pe = si(Pe / Wr);
      return si(Hr + (Wr + 1) * Pe / (Pe + _r));
    }
    function lr(Pe) {
      var ur = [], Pr = Pe.length, Hr, vi = 0, Ti = Ar, wi = Ir, ii, mi, ei, Zr, pi, hi, Oi, qi, yn;
      for (ii = Pe.lastIndexOf(Rr), ii < 0 && (ii = 0), mi = 0; mi < ii; ++mi)
        Pe.charCodeAt(mi) >= 128 && di("not-basic"), ur.push(Pe.charCodeAt(mi));
      for (ei = ii > 0 ? ii + 1 : 0; ei < Pr; ) {
        for (Zr = vi, pi = 1, hi = rr; ei >= Pr && di("invalid-input"), Oi = ze(Pe.charCodeAt(ei++)), (Oi >= rr || Oi > si((ne - vi) / pi)) && di("overflow"), vi += Oi * pi, qi = hi <= wi ? gr : hi >= wi + or ? or : hi - wi, !(Oi < qi); hi += rr)
          yn = rr - qi, pi > si(ne / yn) && di("overflow"), pi *= yn;
        Hr = ur.length + 1, wi = tr(vi - Zr, Hr, Zr == 0), si(vi / Hr) > ne - Ti && di("overflow"), Ti += si(vi / Hr), vi %= Hr, ur.splice(vi++, 0, Ti);
      }
      return Ae(ur);
    }
    function pr(Pe) {
      var ur, Pr, Hr, vi, Ti, wi, ii, mi, ei, Zr, pi, hi = [], Oi, qi, yn, sn;
      for (Pe = vr(Pe), Oi = Pe.length, ur = Ar, Pr = 0, Ti = Ir, wi = 0; wi < Oi; ++wi)
        pi = Pe[wi], pi < 128 && hi.push(li(pi));
      for (Hr = vi = hi.length, vi && hi.push(Rr); Hr < Oi; ) {
        for (ii = ne, wi = 0; wi < Oi; ++wi)
          pi = Pe[wi], pi >= ur && pi < ii && (ii = pi);
        for (qi = Hr + 1, ii - ur > si((ne - Pr) / qi) && di("overflow"), Pr += (ii - ur) * qi, ur = ii, wi = 0; wi < Oi; ++wi)
          if (pi = Pe[wi], pi < ur && ++Pr > ne && di("overflow"), pi == ur) {
            for (mi = Pr, ei = rr; Zr = ei <= Ti ? gr : ei >= Ti + or ? or : ei - Ti, !(mi < Zr); ei += rr)
              sn = mi - Zr, yn = rr - Zr, hi.push(
                li(Ue(Zr + sn % yn, 0))
              ), mi = si(sn / yn);
            hi.push(li(Ue(mi, 0))), Ti = tr(Pr, qi, Hr == vi), Pr = 0, ++Hr;
          }
        ++Pr, ++ur;
      }
      return hi.join("");
    }
    function br(Pe) {
      return ci(Pe, function(ur) {
        return Nr.test(ur) ? lr(ur.slice(4).toLowerCase()) : ur;
      });
    }
    function nr(Pe) {
      return ci(Pe, function(ur) {
        return Yr.test(ur) ? "xn--" + pr(ur) : ur;
      });
    }
    if (Ze = {
      version: "1.4.1",
      ucs2: {
        decode: vr,
        encode: Ae
      },
      decode: lr,
      encode: pr,
      toASCII: nr,
      toUnicode: br
    }, we && $e)
      if (m.exports == we)
        $e.exports = Ze;
      else
        for (xi in Ze)
          Ze.hasOwnProperty(xi) && (we[xi] = Ze[xi]);
    else
      ie.punycode = Ze;
  })(commonjsGlobal);
})(punycode$1, punycode$1.exports);
const require$$0$2 = punycode$1.exports, __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasMap = typeof Map == "function" && Map.prototype, mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get == "function" ? mapSizeDescriptor.get : null, mapForEach = hasMap && Map.prototype.forEach, hasSet = typeof Set == "function" && Set.prototype, setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get == "function" ? setSizeDescriptor.get : null, setForEach = hasSet && Set.prototype.forEach, hasWeakMap = typeof WeakMap == "function" && WeakMap.prototype, weakMapHas = hasWeakMap ? WeakMap.prototype.has : null, hasWeakSet = typeof WeakSet == "function" && WeakSet.prototype, weakSetHas = hasWeakSet ? WeakSet.prototype.has : null, hasWeakRef = typeof WeakRef == "function" && WeakRef.prototype, weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null, booleanValueOf = Boolean.prototype.valueOf, objectToString = Object.prototype.toString, functionToString = Function.prototype.toString, $match = String.prototype.match, $slice = String.prototype.slice, $replace = String.prototype.replace, $toUpperCase = String.prototype.toUpperCase, $toLowerCase = String.prototype.toLowerCase, $test = RegExp.prototype.test, $concat = Array.prototype.concat, $join = Array.prototype.join, $arrSlice = Array.prototype.slice, $floor = Math.floor, bigIntValueOf = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, gOPS = Object.getOwnPropertySymbols, symToString = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, hasShammedSymbols = typeof Symbol == "function" && typeof Symbol.iterator == "object", toStringTag = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null, isEnumerable = Object.prototype.propertyIsEnumerable, gPO = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(m) {
  return m.__proto__;
} : null);
function addNumericSeparator(m, c) {
  if (m === 1 / 0 || m === -1 / 0 || m !== m || m && m > -1e3 && m < 1e3 || $test.call(/e/, c))
    return c;
  var ie = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof m == "number") {
    var we = m < 0 ? -$floor(-m) : $floor(m);
    if (we !== m) {
      var $e = String(we), Me = $slice.call(c, $e.length + 1);
      return $replace.call($e, ie, "$&_") + "." + $replace.call($replace.call(Me, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return $replace.call(c, ie, "$&_");
}
var utilInspect = require$$0$1, inspectCustom = utilInspect.custom, inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null, quotes = {
  __proto__: null,
  double: '"',
  single: "'"
}, quoteREs = {
  __proto__: null,
  double: /(["\\])/g,
  single: /(['\\])/g
}, objectInspect = function m(c, ie, we, $e) {
  var Me = ie || {};
  if (has$3(Me, "quoteStyle") && !has$3(quotes, Me.quoteStyle))
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (has$3(Me, "maxStringLength") && (typeof Me.maxStringLength == "number" ? Me.maxStringLength < 0 && Me.maxStringLength !== 1 / 0 : Me.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var Ze = has$3(Me, "customInspect") ? Me.customInspect : !0;
  if (typeof Ze != "boolean" && Ze !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (has$3(Me, "indent") && Me.indent !== null && Me.indent !== "	" && !(parseInt(Me.indent, 10) === Me.indent && Me.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (has$3(Me, "numericSeparator") && typeof Me.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var ne = Me.numericSeparator;
  if (typeof c > "u")
    return "undefined";
  if (c === null)
    return "null";
  if (typeof c == "boolean")
    return c ? "true" : "false";
  if (typeof c == "string")
    return inspectString(c, Me);
  if (typeof c == "number") {
    if (c === 0)
      return 1 / 0 / c > 0 ? "0" : "-0";
    var rr = String(c);
    return ne ? addNumericSeparator(c, rr) : rr;
  }
  if (typeof c == "bigint") {
    var gr = String(c) + "n";
    return ne ? addNumericSeparator(c, gr) : gr;
  }
  var or = typeof Me.depth > "u" ? 5 : Me.depth;
  if (typeof we > "u" && (we = 0), we >= or && or > 0 && typeof c == "object")
    return isArray$3(c) ? "[Array]" : "[Object]";
  var _r = getIndent(Me, we);
  if (typeof $e > "u")
    $e = [];
  else if (indexOf$1($e, c) >= 0)
    return "[Circular]";
  function Lr(ze, Ue, tr) {
    if (Ue && ($e = $arrSlice.call($e), $e.push(Ue)), tr) {
      var lr = {
        depth: Me.depth
      };
      return has$3(Me, "quoteStyle") && (lr.quoteStyle = Me.quoteStyle), m(ze, lr, we + 1, $e);
    }
    return m(ze, Me, we + 1, $e);
  }
  if (typeof c == "function" && !isRegExp$1(c)) {
    var Ir = nameOf(c), Ar = arrObjKeys(c, Lr);
    return "[Function" + (Ir ? ": " + Ir : " (anonymous)") + "]" + (Ar.length > 0 ? " { " + $join.call(Ar, ", ") + " }" : "");
  }
  if (isSymbol(c)) {
    var Rr = hasShammedSymbols ? $replace.call(String(c), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(c);
    return typeof c == "object" && !hasShammedSymbols ? markBoxed(Rr) : Rr;
  }
  if (isElement(c)) {
    for (var Nr = "<" + $toLowerCase.call(String(c.nodeName)), Yr = c.attributes || [], Vr = 0; Vr < Yr.length; Vr++)
      Nr += " " + Yr[Vr].name + "=" + wrapQuotes(quote(Yr[Vr].value), "double", Me);
    return Nr += ">", c.childNodes && c.childNodes.length && (Nr += "..."), Nr += "</" + $toLowerCase.call(String(c.nodeName)) + ">", Nr;
  }
  if (isArray$3(c)) {
    if (c.length === 0)
      return "[]";
    var Xr = arrObjKeys(c, Lr);
    return _r && !singleLineValues(Xr) ? "[" + indentedJoin(Xr, _r) + "]" : "[ " + $join.call(Xr, ", ") + " ]";
  }
  if (isError(c)) {
    var Wr = arrObjKeys(c, Lr);
    return !("cause" in Error.prototype) && "cause" in c && !isEnumerable.call(c, "cause") ? "{ [" + String(c) + "] " + $join.call($concat.call("[cause]: " + Lr(c.cause), Wr), ", ") + " }" : Wr.length === 0 ? "[" + String(c) + "]" : "{ [" + String(c) + "] " + $join.call(Wr, ", ") + " }";
  }
  if (typeof c == "object" && Ze) {
    if (inspectSymbol && typeof c[inspectSymbol] == "function" && utilInspect)
      return utilInspect(c, { depth: or - we });
    if (Ze !== "symbol" && typeof c.inspect == "function")
      return c.inspect();
  }
  if (isMap(c)) {
    var si = [];
    return mapForEach && mapForEach.call(c, function(ze, Ue) {
      si.push(Lr(Ue, c, !0) + " => " + Lr(ze, c));
    }), collectionOf("Map", mapSize.call(c), si, _r);
  }
  if (isSet(c)) {
    var li = [];
    return setForEach && setForEach.call(c, function(ze) {
      li.push(Lr(ze, c));
    }), collectionOf("Set", setSize.call(c), li, _r);
  }
  if (isWeakMap(c))
    return weakCollectionOf("WeakMap");
  if (isWeakSet(c))
    return weakCollectionOf("WeakSet");
  if (isWeakRef(c))
    return weakCollectionOf("WeakRef");
  if (isNumber(c))
    return markBoxed(Lr(Number(c)));
  if (isBigInt(c))
    return markBoxed(Lr(bigIntValueOf.call(c)));
  if (isBoolean(c))
    return markBoxed(booleanValueOf.call(c));
  if (isString(c))
    return markBoxed(Lr(String(c)));
  if (typeof window < "u" && c === window)
    return "{ [object Window] }";
  if (typeof globalThis < "u" && c === globalThis || typeof commonjsGlobal < "u" && c === commonjsGlobal)
    return "{ [object globalThis] }";
  if (!isDate(c) && !isRegExp$1(c)) {
    var xi = arrObjKeys(c, Lr), di = gPO ? gPO(c) === Object.prototype : c instanceof Object || c.constructor === Object, oi = c instanceof Object ? "" : "null prototype", ci = !di && toStringTag && Object(c) === c && toStringTag in c ? $slice.call(toStr(c), 8, -1) : oi ? "Object" : "", vr = di || typeof c.constructor != "function" ? "" : c.constructor.name ? c.constructor.name + " " : "", Ae = vr + (ci || oi ? "[" + $join.call($concat.call([], ci || [], oi || []), ": ") + "] " : "");
    return xi.length === 0 ? Ae + "{}" : _r ? Ae + "{" + indentedJoin(xi, _r) + "}" : Ae + "{ " + $join.call(xi, ", ") + " }";
  }
  return String(c);
};
function wrapQuotes(m, c, ie) {
  var we = ie.quoteStyle || c, $e = quotes[we];
  return $e + m + $e;
}
function quote(m) {
  return $replace.call(String(m), /"/g, "&quot;");
}
function isArray$3(m) {
  return toStr(m) === "[object Array]" && (!toStringTag || !(typeof m == "object" && toStringTag in m));
}
function isDate(m) {
  return toStr(m) === "[object Date]" && (!toStringTag || !(typeof m == "object" && toStringTag in m));
}
function isRegExp$1(m) {
  return toStr(m) === "[object RegExp]" && (!toStringTag || !(typeof m == "object" && toStringTag in m));
}
function isError(m) {
  return toStr(m) === "[object Error]" && (!toStringTag || !(typeof m == "object" && toStringTag in m));
}
function isString(m) {
  return toStr(m) === "[object String]" && (!toStringTag || !(typeof m == "object" && toStringTag in m));
}
function isNumber(m) {
  return toStr(m) === "[object Number]" && (!toStringTag || !(typeof m == "object" && toStringTag in m));
}
function isBoolean(m) {
  return toStr(m) === "[object Boolean]" && (!toStringTag || !(typeof m == "object" && toStringTag in m));
}
function isSymbol(m) {
  if (hasShammedSymbols)
    return m && typeof m == "object" && m instanceof Symbol;
  if (typeof m == "symbol")
    return !0;
  if (!m || typeof m != "object" || !symToString)
    return !1;
  try {
    return symToString.call(m), !0;
  } catch {
  }
  return !1;
}
function isBigInt(m) {
  if (!m || typeof m != "object" || !bigIntValueOf)
    return !1;
  try {
    return bigIntValueOf.call(m), !0;
  } catch {
  }
  return !1;
}
var hasOwn = Object.prototype.hasOwnProperty || function(m) {
  return m in this;
};
function has$3(m, c) {
  return hasOwn.call(m, c);
}
function toStr(m) {
  return objectToString.call(m);
}
function nameOf(m) {
  if (m.name)
    return m.name;
  var c = $match.call(functionToString.call(m), /^function\s*([\w$]+)/);
  return c ? c[1] : null;
}
function indexOf$1(m, c) {
  if (m.indexOf)
    return m.indexOf(c);
  for (var ie = 0, we = m.length; ie < we; ie++)
    if (m[ie] === c)
      return ie;
  return -1;
}
function isMap(m) {
  if (!mapSize || !m || typeof m != "object")
    return !1;
  try {
    mapSize.call(m);
    try {
      setSize.call(m);
    } catch {
      return !0;
    }
    return m instanceof Map;
  } catch {
  }
  return !1;
}
function isWeakMap(m) {
  if (!weakMapHas || !m || typeof m != "object")
    return !1;
  try {
    weakMapHas.call(m, weakMapHas);
    try {
      weakSetHas.call(m, weakSetHas);
    } catch {
      return !0;
    }
    return m instanceof WeakMap;
  } catch {
  }
  return !1;
}
function isWeakRef(m) {
  if (!weakRefDeref || !m || typeof m != "object")
    return !1;
  try {
    return weakRefDeref.call(m), !0;
  } catch {
  }
  return !1;
}
function isSet(m) {
  if (!setSize || !m || typeof m != "object")
    return !1;
  try {
    setSize.call(m);
    try {
      mapSize.call(m);
    } catch {
      return !0;
    }
    return m instanceof Set;
  } catch {
  }
  return !1;
}
function isWeakSet(m) {
  if (!weakSetHas || !m || typeof m != "object")
    return !1;
  try {
    weakSetHas.call(m, weakSetHas);
    try {
      weakMapHas.call(m, weakMapHas);
    } catch {
      return !0;
    }
    return m instanceof WeakSet;
  } catch {
  }
  return !1;
}
function isElement(m) {
  return !m || typeof m != "object" ? !1 : typeof HTMLElement < "u" && m instanceof HTMLElement ? !0 : typeof m.nodeName == "string" && typeof m.getAttribute == "function";
}
function inspectString(m, c) {
  if (m.length > c.maxStringLength) {
    var ie = m.length - c.maxStringLength, we = "... " + ie + " more character" + (ie > 1 ? "s" : "");
    return inspectString($slice.call(m, 0, c.maxStringLength), c) + we;
  }
  var $e = quoteREs[c.quoteStyle || "single"];
  $e.lastIndex = 0;
  var Me = $replace.call($replace.call(m, $e, "\\$1"), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(Me, "single", c);
}
function lowbyte(m) {
  var c = m.charCodeAt(0), ie = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[c];
  return ie ? "\\" + ie : "\\x" + (c < 16 ? "0" : "") + $toUpperCase.call(c.toString(16));
}
function markBoxed(m) {
  return "Object(" + m + ")";
}
function weakCollectionOf(m) {
  return m + " { ? }";
}
function collectionOf(m, c, ie, we) {
  var $e = we ? indentedJoin(ie, we) : $join.call(ie, ", ");
  return m + " (" + c + ") {" + $e + "}";
}
function singleLineValues(m) {
  for (var c = 0; c < m.length; c++)
    if (indexOf$1(m[c], `
`) >= 0)
      return !1;
  return !0;
}
function getIndent(m, c) {
  var ie;
  if (m.indent === "	")
    ie = "	";
  else if (typeof m.indent == "number" && m.indent > 0)
    ie = $join.call(Array(m.indent + 1), " ");
  else
    return null;
  return {
    base: ie,
    prev: $join.call(Array(c + 1), ie)
  };
}
function indentedJoin(m, c) {
  if (m.length === 0)
    return "";
  var ie = `
` + c.prev + c.base;
  return ie + $join.call(m, "," + ie) + `
` + c.prev;
}
function arrObjKeys(m, c) {
  var ie = isArray$3(m), we = [];
  if (ie) {
    we.length = m.length;
    for (var $e = 0; $e < m.length; $e++)
      we[$e] = has$3(m, $e) ? c(m[$e], m) : "";
  }
  var Me = typeof gOPS == "function" ? gOPS(m) : [], Ze;
  if (hasShammedSymbols) {
    Ze = {};
    for (var ne = 0; ne < Me.length; ne++)
      Ze["$" + Me[ne]] = Me[ne];
  }
  for (var rr in m)
    !has$3(m, rr) || ie && String(Number(rr)) === rr && rr < m.length || hasShammedSymbols && Ze["$" + rr] instanceof Symbol || ($test.call(/[^\w$]/, rr) ? we.push(c(rr, m) + ": " + c(m[rr], m)) : we.push(rr + ": " + c(m[rr], m)));
  if (typeof gOPS == "function")
    for (var gr = 0; gr < Me.length; gr++)
      isEnumerable.call(m, Me[gr]) && we.push("[" + c(Me[gr]) + "]: " + c(m[Me[gr]], m));
  return we;
}
var inspect$3 = objectInspect, $TypeError$3 = type, listGetNode = function(m, c, ie) {
  for (var we = m, $e; ($e = we.next) != null; we = $e)
    if ($e.key === c)
      return we.next = $e.next, ie || ($e.next = m.next, m.next = $e), $e;
}, listGet = function(m, c) {
  if (!!m) {
    var ie = listGetNode(m, c);
    return ie && ie.value;
  }
}, listSet = function(m, c, ie) {
  var we = listGetNode(m, c);
  we ? we.value = ie : m.next = {
    key: c,
    next: m.next,
    value: ie
  };
}, listHas = function(m, c) {
  return m ? !!listGetNode(m, c) : !1;
}, listDelete = function(m, c) {
  if (m)
    return listGetNode(m, c, !0);
}, sideChannelList = function m() {
  var c, ie = {
    assert: function(we) {
      if (!ie.has(we))
        throw new $TypeError$3("Side channel does not contain " + inspect$3(we));
    },
    delete: function(we) {
      var $e = c && c.next, Me = listDelete(c, we);
      return Me && $e && $e === Me && (c = void 0), !!Me;
    },
    get: function(we) {
      return listGet(c, we);
    },
    has: function(we) {
      return listHas(c, we);
    },
    set: function(we, $e) {
      c || (c = {
        next: void 0
      }), listSet(c, we, $e);
    }
  };
  return ie;
}, GetIntrinsic$1 = getIntrinsic, callBound$1 = callBound$7, inspect$2 = objectInspect, $TypeError$2 = type, $Map = GetIntrinsic$1("%Map%", !0), $mapGet = callBound$1("Map.prototype.get", !0), $mapSet = callBound$1("Map.prototype.set", !0), $mapHas = callBound$1("Map.prototype.has", !0), $mapDelete = callBound$1("Map.prototype.delete", !0), $mapSize = callBound$1("Map.prototype.size", !0), sideChannelMap = !!$Map && function m() {
  var c, ie = {
    assert: function(we) {
      if (!ie.has(we))
        throw new $TypeError$2("Side channel does not contain " + inspect$2(we));
    },
    delete: function(we) {
      if (c) {
        var $e = $mapDelete(c, we);
        return $mapSize(c) === 0 && (c = void 0), $e;
      }
      return !1;
    },
    get: function(we) {
      if (c)
        return $mapGet(c, we);
    },
    has: function(we) {
      return c ? $mapHas(c, we) : !1;
    },
    set: function(we, $e) {
      c || (c = new $Map()), $mapSet(c, we, $e);
    }
  };
  return ie;
}, GetIntrinsic = getIntrinsic, callBound = callBound$7, inspect$1 = objectInspect, getSideChannelMap$1 = sideChannelMap, $TypeError$1 = type, $WeakMap = GetIntrinsic("%WeakMap%", !0), $weakMapGet = callBound("WeakMap.prototype.get", !0), $weakMapSet = callBound("WeakMap.prototype.set", !0), $weakMapHas = callBound("WeakMap.prototype.has", !0), $weakMapDelete = callBound("WeakMap.prototype.delete", !0), sideChannelWeakmap = $WeakMap ? function m() {
  var c, ie, we = {
    assert: function($e) {
      if (!we.has($e))
        throw new $TypeError$1("Side channel does not contain " + inspect$1($e));
    },
    delete: function($e) {
      if ($WeakMap && $e && (typeof $e == "object" || typeof $e == "function")) {
        if (c)
          return $weakMapDelete(c, $e);
      } else if (getSideChannelMap$1 && ie)
        return ie.delete($e);
      return !1;
    },
    get: function($e) {
      return $WeakMap && $e && (typeof $e == "object" || typeof $e == "function") && c ? $weakMapGet(c, $e) : ie && ie.get($e);
    },
    has: function($e) {
      return $WeakMap && $e && (typeof $e == "object" || typeof $e == "function") && c ? $weakMapHas(c, $e) : !!ie && ie.has($e);
    },
    set: function($e, Me) {
      $WeakMap && $e && (typeof $e == "object" || typeof $e == "function") ? (c || (c = new $WeakMap()), $weakMapSet(c, $e, Me)) : getSideChannelMap$1 && (ie || (ie = getSideChannelMap$1()), ie.set($e, Me));
    }
  };
  return we;
} : getSideChannelMap$1, $TypeError = type, inspect = objectInspect, getSideChannelList = sideChannelList, getSideChannelMap = sideChannelMap, getSideChannelWeakMap = sideChannelWeakmap, makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList, sideChannel = function m() {
  var c, ie = {
    assert: function(we) {
      if (!ie.has(we))
        throw new $TypeError("Side channel does not contain " + inspect(we));
    },
    delete: function(we) {
      return !!c && c.delete(we);
    },
    get: function(we) {
      return c && c.get(we);
    },
    has: function(we) {
      return !!c && c.has(we);
    },
    set: function(we, $e) {
      c || (c = makeChannel()), c.set(we, $e);
    }
  };
  return ie;
}, replace = String.prototype.replace, percentTwenties = /%20/g, Format = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, formats$3 = {
  default: Format.RFC3986,
  formatters: {
    RFC1738: function(m) {
      return replace.call(m, percentTwenties, "+");
    },
    RFC3986: function(m) {
      return String(m);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
}, formats$2 = formats$3, has$2 = Object.prototype.hasOwnProperty, isArray$2 = Array.isArray, hexTable = function() {
  for (var m = [], c = 0; c < 256; ++c)
    m.push("%" + ((c < 16 ? "0" : "") + c.toString(16)).toUpperCase());
  return m;
}(), compactQueue = function m(c) {
  for (; c.length > 1; ) {
    var ie = c.pop(), we = ie.obj[ie.prop];
    if (isArray$2(we)) {
      for (var $e = [], Me = 0; Me < we.length; ++Me)
        typeof we[Me] < "u" && $e.push(we[Me]);
      ie.obj[ie.prop] = $e;
    }
  }
}, arrayToObject = function m(c, ie) {
  for (var we = ie && ie.plainObjects ? { __proto__: null } : {}, $e = 0; $e < c.length; ++$e)
    typeof c[$e] < "u" && (we[$e] = c[$e]);
  return we;
}, merge = function m(c, ie, we) {
  if (!ie)
    return c;
  if (typeof ie != "object" && typeof ie != "function") {
    if (isArray$2(c))
      c.push(ie);
    else if (c && typeof c == "object")
      (we && (we.plainObjects || we.allowPrototypes) || !has$2.call(Object.prototype, ie)) && (c[ie] = !0);
    else
      return [c, ie];
    return c;
  }
  if (!c || typeof c != "object")
    return [c].concat(ie);
  var $e = c;
  return isArray$2(c) && !isArray$2(ie) && ($e = arrayToObject(c, we)), isArray$2(c) && isArray$2(ie) ? (ie.forEach(function(Me, Ze) {
    if (has$2.call(c, Ze)) {
      var ne = c[Ze];
      ne && typeof ne == "object" && Me && typeof Me == "object" ? c[Ze] = m(ne, Me, we) : c.push(Me);
    } else
      c[Ze] = Me;
  }), c) : Object.keys(ie).reduce(function(Me, Ze) {
    var ne = ie[Ze];
    return has$2.call(Me, Ze) ? Me[Ze] = m(Me[Ze], ne, we) : Me[Ze] = ne, Me;
  }, $e);
}, assign = function m(c, ie) {
  return Object.keys(ie).reduce(function(we, $e) {
    return we[$e] = ie[$e], we;
  }, c);
}, decode = function(m, c, ie) {
  var we = m.replace(/\+/g, " ");
  if (ie === "iso-8859-1")
    return we.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(we);
  } catch {
    return we;
  }
}, limit = 1024, encode = function m(c, ie, we, $e, Me) {
  if (c.length === 0)
    return c;
  var Ze = c;
  if (typeof c == "symbol" ? Ze = Symbol.prototype.toString.call(c) : typeof c != "string" && (Ze = String(c)), we === "iso-8859-1")
    return escape(Ze).replace(/%u[0-9a-f]{4}/gi, function(Ir) {
      return "%26%23" + parseInt(Ir.slice(2), 16) + "%3B";
    });
  for (var ne = "", rr = 0; rr < Ze.length; rr += limit) {
    for (var gr = Ze.length >= limit ? Ze.slice(rr, rr + limit) : Ze, or = [], _r = 0; _r < gr.length; ++_r) {
      var Lr = gr.charCodeAt(_r);
      if (Lr === 45 || Lr === 46 || Lr === 95 || Lr === 126 || Lr >= 48 && Lr <= 57 || Lr >= 65 && Lr <= 90 || Lr >= 97 && Lr <= 122 || Me === formats$2.RFC1738 && (Lr === 40 || Lr === 41)) {
        or[or.length] = gr.charAt(_r);
        continue;
      }
      if (Lr < 128) {
        or[or.length] = hexTable[Lr];
        continue;
      }
      if (Lr < 2048) {
        or[or.length] = hexTable[192 | Lr >> 6] + hexTable[128 | Lr & 63];
        continue;
      }
      if (Lr < 55296 || Lr >= 57344) {
        or[or.length] = hexTable[224 | Lr >> 12] + hexTable[128 | Lr >> 6 & 63] + hexTable[128 | Lr & 63];
        continue;
      }
      _r += 1, Lr = 65536 + ((Lr & 1023) << 10 | gr.charCodeAt(_r) & 1023), or[or.length] = hexTable[240 | Lr >> 18] + hexTable[128 | Lr >> 12 & 63] + hexTable[128 | Lr >> 6 & 63] + hexTable[128 | Lr & 63];
    }
    ne += or.join("");
  }
  return ne;
}, compact = function m(c) {
  for (var ie = [{ obj: { o: c }, prop: "o" }], we = [], $e = 0; $e < ie.length; ++$e)
    for (var Me = ie[$e], Ze = Me.obj[Me.prop], ne = Object.keys(Ze), rr = 0; rr < ne.length; ++rr) {
      var gr = ne[rr], or = Ze[gr];
      typeof or == "object" && or !== null && we.indexOf(or) === -1 && (ie.push({ obj: Ze, prop: gr }), we.push(or));
    }
  return compactQueue(ie), c;
}, isRegExp = function m(c) {
  return Object.prototype.toString.call(c) === "[object RegExp]";
}, isBuffer = function m(c) {
  return !c || typeof c != "object" ? !1 : !!(c.constructor && c.constructor.isBuffer && c.constructor.isBuffer(c));
}, combine = function m(c, ie) {
  return [].concat(c, ie);
}, maybeMap = function m(c, ie) {
  if (isArray$2(c)) {
    for (var we = [], $e = 0; $e < c.length; $e += 1)
      we.push(ie(c[$e]));
    return we;
  }
  return ie(c);
}, utils$2 = {
  arrayToObject,
  assign,
  combine,
  compact,
  decode,
  encode,
  isBuffer,
  isRegExp,
  maybeMap,
  merge
}, getSideChannel = sideChannel, utils$1 = utils$2, formats$1 = formats$3, has$1 = Object.prototype.hasOwnProperty, arrayPrefixGenerators = {
  brackets: function m(c) {
    return c + "[]";
  },
  comma: "comma",
  indices: function m(c, ie) {
    return c + "[" + ie + "]";
  },
  repeat: function m(c) {
    return c;
  }
}, isArray$1 = Array.isArray, push = Array.prototype.push, pushToArray = function(m, c) {
  push.apply(m, isArray$1(c) ? c : [c]);
}, toISO = Date.prototype.toISOString, defaultFormat = formats$1.default, defaults$2 = {
  addQueryPrefix: !1,
  allowDots: !1,
  allowEmptyArrays: !1,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: !1,
  commaRoundTrip: !1,
  delimiter: "&",
  encode: !0,
  encodeDotInKeys: !1,
  encoder: utils$1.encode,
  encodeValuesOnly: !1,
  filter: void 0,
  format: defaultFormat,
  formatter: formats$1.formatters[defaultFormat],
  indices: !1,
  serializeDate: function m(c) {
    return toISO.call(c);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, isNonNullishPrimitive = function m(c) {
  return typeof c == "string" || typeof c == "number" || typeof c == "boolean" || typeof c == "symbol" || typeof c == "bigint";
}, sentinel = {}, stringify$2 = function m(c, ie, we, $e, Me, Ze, ne, rr, gr, or, _r, Lr, Ir, Ar, Rr, Nr, Yr, Vr) {
  for (var Xr = c, Wr = Vr, si = 0, li = !1; (Wr = Wr.get(sentinel)) !== void 0 && !li; ) {
    var xi = Wr.get(c);
    if (si += 1, typeof xi < "u") {
      if (xi === si)
        throw new RangeError("Cyclic object value");
      li = !0;
    }
    typeof Wr.get(sentinel) > "u" && (si = 0);
  }
  if (typeof or == "function" ? Xr = or(ie, Xr) : Xr instanceof Date ? Xr = Ir(Xr) : we === "comma" && isArray$1(Xr) && (Xr = utils$1.maybeMap(Xr, function(Pe) {
    return Pe instanceof Date ? Ir(Pe) : Pe;
  })), Xr === null) {
    if (Ze)
      return gr && !Nr ? gr(ie, defaults$2.encoder, Yr, "key", Ar) : ie;
    Xr = "";
  }
  if (isNonNullishPrimitive(Xr) || utils$1.isBuffer(Xr)) {
    if (gr) {
      var di = Nr ? ie : gr(ie, defaults$2.encoder, Yr, "key", Ar);
      return [Rr(di) + "=" + Rr(gr(Xr, defaults$2.encoder, Yr, "value", Ar))];
    }
    return [Rr(ie) + "=" + Rr(String(Xr))];
  }
  var oi = [];
  if (typeof Xr > "u")
    return oi;
  var ci;
  if (we === "comma" && isArray$1(Xr))
    Nr && gr && (Xr = utils$1.maybeMap(Xr, gr)), ci = [{ value: Xr.length > 0 ? Xr.join(",") || null : void 0 }];
  else if (isArray$1(or))
    ci = or;
  else {
    var vr = Object.keys(Xr);
    ci = _r ? vr.sort(_r) : vr;
  }
  var Ae = rr ? String(ie).replace(/\./g, "%2E") : String(ie), ze = $e && isArray$1(Xr) && Xr.length === 1 ? Ae + "[]" : Ae;
  if (Me && isArray$1(Xr) && Xr.length === 0)
    return ze + "[]";
  for (var Ue = 0; Ue < ci.length; ++Ue) {
    var tr = ci[Ue], lr = typeof tr == "object" && tr && typeof tr.value < "u" ? tr.value : Xr[tr];
    if (!(ne && lr === null)) {
      var pr = Lr && rr ? String(tr).replace(/\./g, "%2E") : String(tr), br = isArray$1(Xr) ? typeof we == "function" ? we(ze, pr) : ze : ze + (Lr ? "." + pr : "[" + pr + "]");
      Vr.set(c, si);
      var nr = getSideChannel();
      nr.set(sentinel, Vr), pushToArray(oi, m(
        lr,
        br,
        we,
        $e,
        Me,
        Ze,
        ne,
        rr,
        we === "comma" && Nr && isArray$1(Xr) ? null : gr,
        or,
        _r,
        Lr,
        Ir,
        Ar,
        Rr,
        Nr,
        Yr,
        nr
      ));
    }
  }
  return oi;
}, normalizeStringifyOptions = function m(c) {
  if (!c)
    return defaults$2;
  if (typeof c.allowEmptyArrays < "u" && typeof c.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof c.encodeDotInKeys < "u" && typeof c.encodeDotInKeys != "boolean")
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  if (c.encoder !== null && typeof c.encoder < "u" && typeof c.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var ie = c.charset || defaults$2.charset;
  if (typeof c.charset < "u" && c.charset !== "utf-8" && c.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var we = formats$1.default;
  if (typeof c.format < "u") {
    if (!has$1.call(formats$1.formatters, c.format))
      throw new TypeError("Unknown format option provided.");
    we = c.format;
  }
  var $e = formats$1.formatters[we], Me = defaults$2.filter;
  (typeof c.filter == "function" || isArray$1(c.filter)) && (Me = c.filter);
  var Ze;
  if (c.arrayFormat in arrayPrefixGenerators ? Ze = c.arrayFormat : "indices" in c ? Ze = c.indices ? "indices" : "repeat" : Ze = defaults$2.arrayFormat, "commaRoundTrip" in c && typeof c.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var ne = typeof c.allowDots > "u" ? c.encodeDotInKeys === !0 ? !0 : defaults$2.allowDots : !!c.allowDots;
  return {
    addQueryPrefix: typeof c.addQueryPrefix == "boolean" ? c.addQueryPrefix : defaults$2.addQueryPrefix,
    allowDots: ne,
    allowEmptyArrays: typeof c.allowEmptyArrays == "boolean" ? !!c.allowEmptyArrays : defaults$2.allowEmptyArrays,
    arrayFormat: Ze,
    charset: ie,
    charsetSentinel: typeof c.charsetSentinel == "boolean" ? c.charsetSentinel : defaults$2.charsetSentinel,
    commaRoundTrip: !!c.commaRoundTrip,
    delimiter: typeof c.delimiter > "u" ? defaults$2.delimiter : c.delimiter,
    encode: typeof c.encode == "boolean" ? c.encode : defaults$2.encode,
    encodeDotInKeys: typeof c.encodeDotInKeys == "boolean" ? c.encodeDotInKeys : defaults$2.encodeDotInKeys,
    encoder: typeof c.encoder == "function" ? c.encoder : defaults$2.encoder,
    encodeValuesOnly: typeof c.encodeValuesOnly == "boolean" ? c.encodeValuesOnly : defaults$2.encodeValuesOnly,
    filter: Me,
    format: we,
    formatter: $e,
    serializeDate: typeof c.serializeDate == "function" ? c.serializeDate : defaults$2.serializeDate,
    skipNulls: typeof c.skipNulls == "boolean" ? c.skipNulls : defaults$2.skipNulls,
    sort: typeof c.sort == "function" ? c.sort : null,
    strictNullHandling: typeof c.strictNullHandling == "boolean" ? c.strictNullHandling : defaults$2.strictNullHandling
  };
}, stringify_1 = function(m, c) {
  var ie = m, we = normalizeStringifyOptions(c), $e, Me;
  typeof we.filter == "function" ? (Me = we.filter, ie = Me("", ie)) : isArray$1(we.filter) && (Me = we.filter, $e = Me);
  var Ze = [];
  if (typeof ie != "object" || ie === null)
    return "";
  var ne = arrayPrefixGenerators[we.arrayFormat], rr = ne === "comma" && we.commaRoundTrip;
  $e || ($e = Object.keys(ie)), we.sort && $e.sort(we.sort);
  for (var gr = getSideChannel(), or = 0; or < $e.length; ++or) {
    var _r = $e[or], Lr = ie[_r];
    we.skipNulls && Lr === null || pushToArray(Ze, stringify$2(
      Lr,
      _r,
      ne,
      rr,
      we.allowEmptyArrays,
      we.strictNullHandling,
      we.skipNulls,
      we.encodeDotInKeys,
      we.encode ? we.encoder : null,
      we.filter,
      we.sort,
      we.allowDots,
      we.serializeDate,
      we.format,
      we.formatter,
      we.encodeValuesOnly,
      we.charset,
      gr
    ));
  }
  var Ir = Ze.join(we.delimiter), Ar = we.addQueryPrefix === !0 ? "?" : "";
  return we.charsetSentinel && (we.charset === "iso-8859-1" ? Ar += "utf8=%26%2310003%3B&" : Ar += "utf8=%E2%9C%93&"), Ir.length > 0 ? Ar + Ir : "";
}, utils = utils$2, has = Object.prototype.hasOwnProperty, isArray = Array.isArray, defaults$1 = {
  allowDots: !1,
  allowEmptyArrays: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decodeDotInKeys: !1,
  decoder: utils.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictDepth: !1,
  strictNullHandling: !1,
  throwOnLimitExceeded: !1
}, interpretNumericEntities = function(m) {
  return m.replace(/&#(\d+);/g, function(c, ie) {
    return String.fromCharCode(parseInt(ie, 10));
  });
}, parseArrayValue = function(m, c, ie) {
  if (m && typeof m == "string" && c.comma && m.indexOf(",") > -1)
    return m.split(",");
  if (c.throwOnLimitExceeded && ie >= c.arrayLimit)
    throw new RangeError("Array limit exceeded. Only " + c.arrayLimit + " element" + (c.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
  return m;
}, isoSentinel = "utf8=%26%2310003%3B", charsetSentinel = "utf8=%E2%9C%93", parseValues = function m(c, ie) {
  var we = { __proto__: null }, $e = ie.ignoreQueryPrefix ? c.replace(/^\?/, "") : c;
  $e = $e.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  var Me = ie.parameterLimit === 1 / 0 ? void 0 : ie.parameterLimit, Ze = $e.split(
    ie.delimiter,
    ie.throwOnLimitExceeded ? Me + 1 : Me
  );
  if (ie.throwOnLimitExceeded && Ze.length > Me)
    throw new RangeError("Parameter limit exceeded. Only " + Me + " parameter" + (Me === 1 ? "" : "s") + " allowed.");
  var ne = -1, rr, gr = ie.charset;
  if (ie.charsetSentinel)
    for (rr = 0; rr < Ze.length; ++rr)
      Ze[rr].indexOf("utf8=") === 0 && (Ze[rr] === charsetSentinel ? gr = "utf-8" : Ze[rr] === isoSentinel && (gr = "iso-8859-1"), ne = rr, rr = Ze.length);
  for (rr = 0; rr < Ze.length; ++rr)
    if (rr !== ne) {
      var or = Ze[rr], _r = or.indexOf("]="), Lr = _r === -1 ? or.indexOf("=") : _r + 1, Ir, Ar;
      Lr === -1 ? (Ir = ie.decoder(or, defaults$1.decoder, gr, "key"), Ar = ie.strictNullHandling ? null : "") : (Ir = ie.decoder(or.slice(0, Lr), defaults$1.decoder, gr, "key"), Ar = utils.maybeMap(
        parseArrayValue(
          or.slice(Lr + 1),
          ie,
          isArray(we[Ir]) ? we[Ir].length : 0
        ),
        function(Nr) {
          return ie.decoder(Nr, defaults$1.decoder, gr, "value");
        }
      )), Ar && ie.interpretNumericEntities && gr === "iso-8859-1" && (Ar = interpretNumericEntities(String(Ar))), or.indexOf("[]=") > -1 && (Ar = isArray(Ar) ? [Ar] : Ar);
      var Rr = has.call(we, Ir);
      Rr && ie.duplicates === "combine" ? we[Ir] = utils.combine(we[Ir], Ar) : (!Rr || ie.duplicates === "last") && (we[Ir] = Ar);
    }
  return we;
}, parseObject = function(m, c, ie, we) {
  var $e = 0;
  if (m.length > 0 && m[m.length - 1] === "[]") {
    var Me = m.slice(0, -1).join("");
    $e = Array.isArray(c) && c[Me] ? c[Me].length : 0;
  }
  for (var Ze = we ? c : parseArrayValue(c, ie, $e), ne = m.length - 1; ne >= 0; --ne) {
    var rr, gr = m[ne];
    if (gr === "[]" && ie.parseArrays)
      rr = ie.allowEmptyArrays && (Ze === "" || ie.strictNullHandling && Ze === null) ? [] : utils.combine([], Ze);
    else {
      rr = ie.plainObjects ? { __proto__: null } : {};
      var or = gr.charAt(0) === "[" && gr.charAt(gr.length - 1) === "]" ? gr.slice(1, -1) : gr, _r = ie.decodeDotInKeys ? or.replace(/%2E/g, ".") : or, Lr = parseInt(_r, 10);
      !ie.parseArrays && _r === "" ? rr = { 0: Ze } : !isNaN(Lr) && gr !== _r && String(Lr) === _r && Lr >= 0 && ie.parseArrays && Lr <= ie.arrayLimit ? (rr = [], rr[Lr] = Ze) : _r !== "__proto__" && (rr[_r] = Ze);
    }
    Ze = rr;
  }
  return Ze;
}, parseKeys = function m(c, ie, we, $e) {
  if (!!c) {
    var Me = we.allowDots ? c.replace(/\.([^.[]+)/g, "[$1]") : c, Ze = /(\[[^[\]]*])/, ne = /(\[[^[\]]*])/g, rr = we.depth > 0 && Ze.exec(Me), gr = rr ? Me.slice(0, rr.index) : Me, or = [];
    if (gr) {
      if (!we.plainObjects && has.call(Object.prototype, gr) && !we.allowPrototypes)
        return;
      or.push(gr);
    }
    for (var _r = 0; we.depth > 0 && (rr = ne.exec(Me)) !== null && _r < we.depth; ) {
      if (_r += 1, !we.plainObjects && has.call(Object.prototype, rr[1].slice(1, -1)) && !we.allowPrototypes)
        return;
      or.push(rr[1]);
    }
    if (rr) {
      if (we.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + we.depth + " and strictDepth is true");
      or.push("[" + Me.slice(rr.index) + "]");
    }
    return parseObject(or, ie, we, $e);
  }
}, normalizeParseOptions = function m(c) {
  if (!c)
    return defaults$1;
  if (typeof c.allowEmptyArrays < "u" && typeof c.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof c.decodeDotInKeys < "u" && typeof c.decodeDotInKeys != "boolean")
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  if (c.decoder !== null && typeof c.decoder < "u" && typeof c.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof c.charset < "u" && c.charset !== "utf-8" && c.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  if (typeof c.throwOnLimitExceeded < "u" && typeof c.throwOnLimitExceeded != "boolean")
    throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
  var ie = typeof c.charset > "u" ? defaults$1.charset : c.charset, we = typeof c.duplicates > "u" ? defaults$1.duplicates : c.duplicates;
  if (we !== "combine" && we !== "first" && we !== "last")
    throw new TypeError("The duplicates option must be either combine, first, or last");
  var $e = typeof c.allowDots > "u" ? c.decodeDotInKeys === !0 ? !0 : defaults$1.allowDots : !!c.allowDots;
  return {
    allowDots: $e,
    allowEmptyArrays: typeof c.allowEmptyArrays == "boolean" ? !!c.allowEmptyArrays : defaults$1.allowEmptyArrays,
    allowPrototypes: typeof c.allowPrototypes == "boolean" ? c.allowPrototypes : defaults$1.allowPrototypes,
    allowSparse: typeof c.allowSparse == "boolean" ? c.allowSparse : defaults$1.allowSparse,
    arrayLimit: typeof c.arrayLimit == "number" ? c.arrayLimit : defaults$1.arrayLimit,
    charset: ie,
    charsetSentinel: typeof c.charsetSentinel == "boolean" ? c.charsetSentinel : defaults$1.charsetSentinel,
    comma: typeof c.comma == "boolean" ? c.comma : defaults$1.comma,
    decodeDotInKeys: typeof c.decodeDotInKeys == "boolean" ? c.decodeDotInKeys : defaults$1.decodeDotInKeys,
    decoder: typeof c.decoder == "function" ? c.decoder : defaults$1.decoder,
    delimiter: typeof c.delimiter == "string" || utils.isRegExp(c.delimiter) ? c.delimiter : defaults$1.delimiter,
    depth: typeof c.depth == "number" || c.depth === !1 ? +c.depth : defaults$1.depth,
    duplicates: we,
    ignoreQueryPrefix: c.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof c.interpretNumericEntities == "boolean" ? c.interpretNumericEntities : defaults$1.interpretNumericEntities,
    parameterLimit: typeof c.parameterLimit == "number" ? c.parameterLimit : defaults$1.parameterLimit,
    parseArrays: c.parseArrays !== !1,
    plainObjects: typeof c.plainObjects == "boolean" ? c.plainObjects : defaults$1.plainObjects,
    strictDepth: typeof c.strictDepth == "boolean" ? !!c.strictDepth : defaults$1.strictDepth,
    strictNullHandling: typeof c.strictNullHandling == "boolean" ? c.strictNullHandling : defaults$1.strictNullHandling,
    throwOnLimitExceeded: typeof c.throwOnLimitExceeded == "boolean" ? c.throwOnLimitExceeded : !1
  };
}, parse$a = function(m, c) {
  var ie = normalizeParseOptions(c);
  if (m === "" || m === null || typeof m > "u")
    return ie.plainObjects ? { __proto__: null } : {};
  for (var we = typeof m == "string" ? parseValues(m, ie) : m, $e = ie.plainObjects ? { __proto__: null } : {}, Me = Object.keys(we), Ze = 0; Ze < Me.length; ++Ze) {
    var ne = Me[Ze], rr = parseKeys(ne, we[ne], ie, typeof m == "string");
    $e = utils.merge($e, rr, ie);
  }
  return ie.allowSparse === !0 ? $e : utils.compact($e);
}, stringify$1 = stringify_1, parse$9 = parse$a, formats = formats$3, lib = {
  formats,
  parse: parse$9,
  stringify: stringify$1
};
const require$$1$1 = lib;
var punycode = require$$0$2;
function Url() {
  this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
}
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, delims = [
  "<",
  ">",
  '"',
  "`",
  " ",
  "\r",
  `
`,
  "	"
], unwise = [
  "{",
  "}",
  "|",
  "\\",
  "^",
  "`"
].concat(delims), autoEscape = ["'"].concat(unwise), nonHostChars = [
  "%",
  "/",
  "?",
  ";",
  "#"
].concat(autoEscape), hostEndingChars = [
  "/",
  "?",
  "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, unsafeProtocol = {
  javascript: !0,
  "javascript:": !0
}, hostlessProtocol = {
  javascript: !0,
  "javascript:": !0
}, slashedProtocol = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
}, querystring = require$$1$1;
function urlParse(m, c, ie) {
  if (m && typeof m == "object" && m instanceof Url)
    return m;
  var we = new Url();
  return we.parse(m, c, ie), we;
}
Url.prototype.parse = function(m, c, ie) {
  if (typeof m != "string")
    throw new TypeError("Parameter 'url' must be a string, not " + typeof m);
  var we = m.indexOf("?"), $e = we !== -1 && we < m.indexOf("#") ? "?" : "#", Me = m.split($e), Ze = /\\/g;
  Me[0] = Me[0].replace(Ze, "/"), m = Me.join($e);
  var ne = m;
  if (ne = ne.trim(), !ie && m.split("#").length === 1) {
    var rr = simplePathPattern.exec(ne);
    if (rr)
      return this.path = ne, this.href = ne, this.pathname = rr[1], rr[2] ? (this.search = rr[2], c ? this.query = querystring.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : c && (this.search = "", this.query = {}), this;
  }
  var gr = protocolPattern.exec(ne);
  if (gr) {
    gr = gr[0];
    var or = gr.toLowerCase();
    this.protocol = or, ne = ne.substr(gr.length);
  }
  if (ie || gr || ne.match(/^\/\/[^@/]+@[^@/]+/)) {
    var _r = ne.substr(0, 2) === "//";
    _r && !(gr && hostlessProtocol[gr]) && (ne = ne.substr(2), this.slashes = !0);
  }
  if (!hostlessProtocol[gr] && (_r || gr && !slashedProtocol[gr])) {
    for (var Lr = -1, Ir = 0; Ir < hostEndingChars.length; Ir++) {
      var Ar = ne.indexOf(hostEndingChars[Ir]);
      Ar !== -1 && (Lr === -1 || Ar < Lr) && (Lr = Ar);
    }
    var Rr, Nr;
    Lr === -1 ? Nr = ne.lastIndexOf("@") : Nr = ne.lastIndexOf("@", Lr), Nr !== -1 && (Rr = ne.slice(0, Nr), ne = ne.slice(Nr + 1), this.auth = decodeURIComponent(Rr)), Lr = -1;
    for (var Ir = 0; Ir < nonHostChars.length; Ir++) {
      var Ar = ne.indexOf(nonHostChars[Ir]);
      Ar !== -1 && (Lr === -1 || Ar < Lr) && (Lr = Ar);
    }
    Lr === -1 && (Lr = ne.length), this.host = ne.slice(0, Lr), ne = ne.slice(Lr), this.parseHost(), this.hostname = this.hostname || "";
    var Yr = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!Yr)
      for (var Vr = this.hostname.split(/\./), Ir = 0, Xr = Vr.length; Ir < Xr; Ir++) {
        var Wr = Vr[Ir];
        if (!!Wr && !Wr.match(hostnamePartPattern)) {
          for (var si = "", li = 0, xi = Wr.length; li < xi; li++)
            Wr.charCodeAt(li) > 127 ? si += "x" : si += Wr[li];
          if (!si.match(hostnamePartPattern)) {
            var di = Vr.slice(0, Ir), oi = Vr.slice(Ir + 1), ci = Wr.match(hostnamePartStart);
            ci && (di.push(ci[1]), oi.unshift(ci[2])), oi.length && (ne = "/" + oi.join(".") + ne), this.hostname = di.join(".");
            break;
          }
        }
      }
    this.hostname.length > hostnameMaxLen ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), Yr || (this.hostname = punycode.toASCII(this.hostname));
    var vr = this.port ? ":" + this.port : "", Ae = this.hostname || "";
    this.host = Ae + vr, this.href += this.host, Yr && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), ne[0] !== "/" && (ne = "/" + ne));
  }
  if (!unsafeProtocol[or])
    for (var Ir = 0, Xr = autoEscape.length; Ir < Xr; Ir++) {
      var ze = autoEscape[Ir];
      if (ne.indexOf(ze) !== -1) {
        var Ue = encodeURIComponent(ze);
        Ue === ze && (Ue = escape(ze)), ne = ne.split(ze).join(Ue);
      }
    }
  var tr = ne.indexOf("#");
  tr !== -1 && (this.hash = ne.substr(tr), ne = ne.slice(0, tr));
  var lr = ne.indexOf("?");
  if (lr !== -1 ? (this.search = ne.substr(lr), this.query = ne.substr(lr + 1), c && (this.query = querystring.parse(this.query)), ne = ne.slice(0, lr)) : c && (this.search = "", this.query = {}), ne && (this.pathname = ne), slashedProtocol[or] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
    var vr = this.pathname || "", pr = this.search || "";
    this.path = vr + pr;
  }
  return this.href = this.format(), this;
};
function urlFormat(m) {
  return typeof m == "string" && (m = urlParse(m)), m instanceof Url ? m.format() : Url.prototype.format.call(m);
}
Url.prototype.format = function() {
  var m = this.auth || "";
  m && (m = encodeURIComponent(m), m = m.replace(/%3A/i, ":"), m += "@");
  var c = this.protocol || "", ie = this.pathname || "", we = this.hash || "", $e = !1, Me = "";
  this.host ? $e = m + this.host : this.hostname && ($e = m + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && ($e += ":" + this.port)), this.query && typeof this.query == "object" && Object.keys(this.query).length && (Me = querystring.stringify(this.query, {
    arrayFormat: "repeat",
    addQueryPrefix: !1
  }));
  var Ze = this.search || Me && "?" + Me || "";
  return c && c.substr(-1) !== ":" && (c += ":"), this.slashes || (!c || slashedProtocol[c]) && $e !== !1 ? ($e = "//" + ($e || ""), ie && ie.charAt(0) !== "/" && (ie = "/" + ie)) : $e || ($e = ""), we && we.charAt(0) !== "#" && (we = "#" + we), Ze && Ze.charAt(0) !== "?" && (Ze = "?" + Ze), ie = ie.replace(/[?#]/g, function(ne) {
    return encodeURIComponent(ne);
  }), Ze = Ze.replace("#", "%23"), c + $e + ie + Ze + we;
};
function urlResolve(m, c) {
  return urlParse(m, !1, !0).resolve(c);
}
Url.prototype.resolve = function(m) {
  return this.resolveObject(urlParse(m, !1, !0)).format();
};
function urlResolveObject(m, c) {
  return m ? urlParse(m, !1, !0).resolveObject(c) : c;
}
Url.prototype.resolveObject = function(m) {
  if (typeof m == "string") {
    var c = new Url();
    c.parse(m, !1, !0), m = c;
  }
  for (var ie = new Url(), we = Object.keys(this), $e = 0; $e < we.length; $e++) {
    var Me = we[$e];
    ie[Me] = this[Me];
  }
  if (ie.hash = m.hash, m.href === "")
    return ie.href = ie.format(), ie;
  if (m.slashes && !m.protocol) {
    for (var Ze = Object.keys(m), ne = 0; ne < Ze.length; ne++) {
      var rr = Ze[ne];
      rr !== "protocol" && (ie[rr] = m[rr]);
    }
    return slashedProtocol[ie.protocol] && ie.hostname && !ie.pathname && (ie.pathname = "/", ie.path = ie.pathname), ie.href = ie.format(), ie;
  }
  if (m.protocol && m.protocol !== ie.protocol) {
    if (!slashedProtocol[m.protocol]) {
      for (var gr = Object.keys(m), or = 0; or < gr.length; or++) {
        var _r = gr[or];
        ie[_r] = m[_r];
      }
      return ie.href = ie.format(), ie;
    }
    if (ie.protocol = m.protocol, !m.host && !hostlessProtocol[m.protocol]) {
      for (var Xr = (m.pathname || "").split("/"); Xr.length && !(m.host = Xr.shift()); )
        ;
      m.host || (m.host = ""), m.hostname || (m.hostname = ""), Xr[0] !== "" && Xr.unshift(""), Xr.length < 2 && Xr.unshift(""), ie.pathname = Xr.join("/");
    } else
      ie.pathname = m.pathname;
    if (ie.search = m.search, ie.query = m.query, ie.host = m.host || "", ie.auth = m.auth, ie.hostname = m.hostname || m.host, ie.port = m.port, ie.pathname || ie.search) {
      var Lr = ie.pathname || "", Ir = ie.search || "";
      ie.path = Lr + Ir;
    }
    return ie.slashes = ie.slashes || m.slashes, ie.href = ie.format(), ie;
  }
  var Ar = ie.pathname && ie.pathname.charAt(0) === "/", Rr = m.host || m.pathname && m.pathname.charAt(0) === "/", Nr = Rr || Ar || ie.host && m.pathname, Yr = Nr, Vr = ie.pathname && ie.pathname.split("/") || [], Xr = m.pathname && m.pathname.split("/") || [], Wr = ie.protocol && !slashedProtocol[ie.protocol];
  if (Wr && (ie.hostname = "", ie.port = null, ie.host && (Vr[0] === "" ? Vr[0] = ie.host : Vr.unshift(ie.host)), ie.host = "", m.protocol && (m.hostname = null, m.port = null, m.host && (Xr[0] === "" ? Xr[0] = m.host : Xr.unshift(m.host)), m.host = null), Nr = Nr && (Xr[0] === "" || Vr[0] === "")), Rr)
    ie.host = m.host || m.host === "" ? m.host : ie.host, ie.hostname = m.hostname || m.hostname === "" ? m.hostname : ie.hostname, ie.search = m.search, ie.query = m.query, Vr = Xr;
  else if (Xr.length)
    Vr || (Vr = []), Vr.pop(), Vr = Vr.concat(Xr), ie.search = m.search, ie.query = m.query;
  else if (m.search != null) {
    if (Wr) {
      ie.host = Vr.shift(), ie.hostname = ie.host;
      var si = ie.host && ie.host.indexOf("@") > 0 ? ie.host.split("@") : !1;
      si && (ie.auth = si.shift(), ie.hostname = si.shift(), ie.host = ie.hostname);
    }
    return ie.search = m.search, ie.query = m.query, (ie.pathname !== null || ie.search !== null) && (ie.path = (ie.pathname ? ie.pathname : "") + (ie.search ? ie.search : "")), ie.href = ie.format(), ie;
  }
  if (!Vr.length)
    return ie.pathname = null, ie.search ? ie.path = "/" + ie.search : ie.path = null, ie.href = ie.format(), ie;
  for (var li = Vr.slice(-1)[0], xi = (ie.host || m.host || Vr.length > 1) && (li === "." || li === "..") || li === "", di = 0, oi = Vr.length; oi >= 0; oi--)
    li = Vr[oi], li === "." ? Vr.splice(oi, 1) : li === ".." ? (Vr.splice(oi, 1), di++) : di && (Vr.splice(oi, 1), di--);
  if (!Nr && !Yr)
    for (; di--; di)
      Vr.unshift("..");
  Nr && Vr[0] !== "" && (!Vr[0] || Vr[0].charAt(0) !== "/") && Vr.unshift(""), xi && Vr.join("/").substr(-1) !== "/" && Vr.push("");
  var ci = Vr[0] === "" || Vr[0] && Vr[0].charAt(0) === "/";
  if (Wr) {
    ie.hostname = ci ? "" : Vr.length ? Vr.shift() : "", ie.host = ie.hostname;
    var si = ie.host && ie.host.indexOf("@") > 0 ? ie.host.split("@") : !1;
    si && (ie.auth = si.shift(), ie.hostname = si.shift(), ie.host = ie.hostname);
  }
  return Nr = Nr || ie.host && Vr.length, Nr && !ci && Vr.unshift(""), Vr.length > 0 ? ie.pathname = Vr.join("/") : (ie.pathname = null, ie.path = null), (ie.pathname !== null || ie.search !== null) && (ie.path = (ie.pathname ? ie.pathname : "") + (ie.search ? ie.search : "")), ie.auth = m.auth || ie.auth, ie.slashes = ie.slashes || m.slashes, ie.href = ie.format(), ie;
};
Url.prototype.parseHost = function() {
  var m = this.host, c = portPattern.exec(m);
  c && (c = c[0], c !== ":" && (this.port = c.substr(1)), m = m.substr(0, m.length - c.length)), m && (this.hostname = m);
};
var parse$8 = urlParse, resolve$1 = urlResolve, resolveObject = urlResolveObject, format = urlFormat, Url_1 = Url;
function normalizeArray(m, c) {
  for (var ie = 0, we = m.length - 1; we >= 0; we--) {
    var $e = m[we];
    $e === "." ? m.splice(we, 1) : $e === ".." ? (m.splice(we, 1), ie++) : ie && (m.splice(we, 1), ie--);
  }
  if (c)
    for (; ie--; ie)
      m.unshift("..");
  return m;
}
function resolve() {
  for (var m = "", c = !1, ie = arguments.length - 1; ie >= -1 && !c; ie--) {
    var we = ie >= 0 ? arguments[ie] : "/";
    if (typeof we != "string")
      throw new TypeError("Arguments to path.resolve must be strings");
    if (!we)
      continue;
    m = we + "/" + m, c = we.charAt(0) === "/";
  }
  return m = normalizeArray(filter(m.split("/"), function($e) {
    return !!$e;
  }), !c).join("/"), (c ? "/" : "") + m || ".";
}
function filter(m, c) {
  if (m.filter)
    return m.filter(c);
  for (var ie = [], we = 0; we < m.length; we++)
    c(m[we], we, m) && ie.push(m[we]);
  return ie;
}
var _globalThis = function(m) {
  function c() {
    var we = this || self;
    return delete m.prototype.__magic__, we;
  }
  if (typeof globalThis == "object")
    return globalThis;
  if (this)
    return c();
  m.defineProperty(m.prototype, "__magic__", {
    configurable: !0,
    get: c
  });
  var ie = __magic__;
  return ie;
}(Object), formatImport = format, parseImport = parse$8, resolveImport = resolve$1, UrlImport = Url_1, URL$1 = _globalThis.URL, URLSearchParams$1 = _globalThis.URLSearchParams, percentRegEx = /%/g, backslashRegEx = /\\/g, newlineRegEx = /\n/g, carriageReturnRegEx = /\r/g, tabRegEx = /\t/g, CHAR_FORWARD_SLASH = 47;
function isURLInstance(m) {
  var c = m ?? null;
  return Boolean(c !== null && c?.href && c?.origin);
}
function getPathFromURLPosix(m) {
  if (m.hostname !== "")
    throw new TypeError('File URL host must be "localhost" or empty on browser');
  for (var c = m.pathname, ie = 0; ie < c.length; ie++)
    if (c[ie] === "%") {
      var we = c.codePointAt(ie + 2) | 32;
      if (c[ie + 1] === "2" && we === 102)
        throw new TypeError("File URL path must not include encoded / characters");
    }
  return decodeURIComponent(c);
}
function encodePathChars(m) {
  return m.includes("%") && (m = m.replace(percentRegEx, "%25")), m.includes("\\") && (m = m.replace(backslashRegEx, "%5C")), m.includes(`
`) && (m = m.replace(newlineRegEx, "%0A")), m.includes("\r") && (m = m.replace(carriageReturnRegEx, "%0D")), m.includes("	") && (m = m.replace(tabRegEx, "%09")), m;
}
var domainToASCII = function m(c) {
  if (typeof c > "u")
    throw new TypeError('The "domain" argument must be specified');
  return new URL$1("http://" + c).hostname;
}, domainToUnicode = function m(c) {
  if (typeof c > "u")
    throw new TypeError('The "domain" argument must be specified');
  return new URL$1("http://" + c).hostname;
}, pathToFileURL = function m(c) {
  var ie = new URL$1("file://"), we = resolve(c), $e = c.charCodeAt(c.length - 1);
  return $e === CHAR_FORWARD_SLASH && we[we.length - 1] !== "/" && (we += "/"), ie.pathname = encodePathChars(we), ie;
}, fileURLToPath = function m(c) {
  if (!isURLInstance(c) && typeof c != "string")
    throw new TypeError('The "path" argument must be of type string or an instance of URL. Received type ' + typeof c + " (" + c + ")");
  var ie = new URL$1(c);
  if (ie.protocol !== "file:")
    throw new TypeError("The URL must be of scheme file");
  return getPathFromURLPosix(ie);
}, formatImportWithOverloads = function m(c, ie) {
  var we, $e, Me, Ze;
  if (ie === void 0 && (ie = {}), !(c instanceof URL$1))
    return formatImport(c);
  if (typeof ie != "object" || ie === null)
    throw new TypeError('The "options" argument must be of type object.');
  var ne = (we = ie.auth) != null ? we : !0, rr = ($e = ie.fragment) != null ? $e : !0, gr = (Me = ie.search) != null ? Me : !0;
  (Ze = ie.unicode) != null;
  var or = new URL$1(c.toString());
  return ne || (or.username = "", or.password = ""), rr || (or.hash = ""), gr || (or.search = ""), or.toString();
}, api = {
  format: formatImportWithOverloads,
  parse: parseImport,
  resolve: resolveImport,
  resolveObject,
  Url: UrlImport,
  URL: URL$1,
  URLSearchParams: URLSearchParams$1,
  domainToASCII,
  domainToUnicode,
  pathToFileURL,
  fileURLToPath
};
const url = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  URL: URL$1,
  URLSearchParams: URLSearchParams$1,
  Url: UrlImport,
  default: api,
  domainToASCII,
  domainToUnicode,
  fileURLToPath,
  format: formatImportWithOverloads,
  parse: parseImport,
  pathToFileURL,
  resolve: resolveImport,
  resolveObject
}, Symbol.toStringTag, { value: "Module" })), require$$1 = /* @__PURE__ */ getAugmentedNamespace(url);
function assertPath(m) {
  if (typeof m != "string")
    throw new TypeError("Path must be a string. Received " + JSON.stringify(m));
}
function normalizeStringPosix(m, c) {
  for (var ie = "", we = 0, $e = -1, Me = 0, Ze, ne = 0; ne <= m.length; ++ne) {
    if (ne < m.length)
      Ze = m.charCodeAt(ne);
    else {
      if (Ze === 47)
        break;
      Ze = 47;
    }
    if (Ze === 47) {
      if (!($e === ne - 1 || Me === 1))
        if ($e !== ne - 1 && Me === 2) {
          if (ie.length < 2 || we !== 2 || ie.charCodeAt(ie.length - 1) !== 46 || ie.charCodeAt(ie.length - 2) !== 46) {
            if (ie.length > 2) {
              var rr = ie.lastIndexOf("/");
              if (rr !== ie.length - 1) {
                rr === -1 ? (ie = "", we = 0) : (ie = ie.slice(0, rr), we = ie.length - 1 - ie.lastIndexOf("/")), $e = ne, Me = 0;
                continue;
              }
            } else if (ie.length === 2 || ie.length === 1) {
              ie = "", we = 0, $e = ne, Me = 0;
              continue;
            }
          }
          c && (ie.length > 0 ? ie += "/.." : ie = "..", we = 2);
        } else
          ie.length > 0 ? ie += "/" + m.slice($e + 1, ne) : ie = m.slice($e + 1, ne), we = ne - $e - 1;
      $e = ne, Me = 0;
    } else
      Ze === 46 && Me !== -1 ? ++Me : Me = -1;
  }
  return ie;
}
function _format(m, c) {
  var ie = c.dir || c.root, we = c.base || (c.name || "") + (c.ext || "");
  return ie ? ie === c.root ? ie + we : ie + m + we : we;
}
var posix = {
  resolve: function m() {
    for (var c = "", ie = !1, we, $e = arguments.length - 1; $e >= -1 && !ie; $e--) {
      var Me;
      $e >= 0 ? Me = arguments[$e] : (we === void 0 && (we = process$1.cwd()), Me = we), assertPath(Me), Me.length !== 0 && (c = Me + "/" + c, ie = Me.charCodeAt(0) === 47);
    }
    return c = normalizeStringPosix(c, !ie), ie ? c.length > 0 ? "/" + c : "/" : c.length > 0 ? c : ".";
  },
  normalize: function m(c) {
    if (assertPath(c), c.length === 0)
      return ".";
    var ie = c.charCodeAt(0) === 47, we = c.charCodeAt(c.length - 1) === 47;
    return c = normalizeStringPosix(c, !ie), c.length === 0 && !ie && (c = "."), c.length > 0 && we && (c += "/"), ie ? "/" + c : c;
  },
  isAbsolute: function m(c) {
    return assertPath(c), c.length > 0 && c.charCodeAt(0) === 47;
  },
  join: function m() {
    if (arguments.length === 0)
      return ".";
    for (var c, ie = 0; ie < arguments.length; ++ie) {
      var we = arguments[ie];
      assertPath(we), we.length > 0 && (c === void 0 ? c = we : c += "/" + we);
    }
    return c === void 0 ? "." : posix.normalize(c);
  },
  relative: function m(c, ie) {
    if (assertPath(c), assertPath(ie), c === ie || (c = posix.resolve(c), ie = posix.resolve(ie), c === ie))
      return "";
    for (var we = 1; we < c.length && c.charCodeAt(we) === 47; ++we)
      ;
    for (var $e = c.length, Me = $e - we, Ze = 1; Ze < ie.length && ie.charCodeAt(Ze) === 47; ++Ze)
      ;
    for (var ne = ie.length, rr = ne - Ze, gr = Me < rr ? Me : rr, or = -1, _r = 0; _r <= gr; ++_r) {
      if (_r === gr) {
        if (rr > gr) {
          if (ie.charCodeAt(Ze + _r) === 47)
            return ie.slice(Ze + _r + 1);
          if (_r === 0)
            return ie.slice(Ze + _r);
        } else
          Me > gr && (c.charCodeAt(we + _r) === 47 ? or = _r : _r === 0 && (or = 0));
        break;
      }
      var Lr = c.charCodeAt(we + _r), Ir = ie.charCodeAt(Ze + _r);
      if (Lr !== Ir)
        break;
      Lr === 47 && (or = _r);
    }
    var Ar = "";
    for (_r = we + or + 1; _r <= $e; ++_r)
      (_r === $e || c.charCodeAt(_r) === 47) && (Ar.length === 0 ? Ar += ".." : Ar += "/..");
    return Ar.length > 0 ? Ar + ie.slice(Ze + or) : (Ze += or, ie.charCodeAt(Ze) === 47 && ++Ze, ie.slice(Ze));
  },
  _makeLong: function m(c) {
    return c;
  },
  dirname: function m(c) {
    if (assertPath(c), c.length === 0)
      return ".";
    for (var ie = c.charCodeAt(0), we = ie === 47, $e = -1, Me = !0, Ze = c.length - 1; Ze >= 1; --Ze)
      if (ie = c.charCodeAt(Ze), ie === 47) {
        if (!Me) {
          $e = Ze;
          break;
        }
      } else
        Me = !1;
    return $e === -1 ? we ? "/" : "." : we && $e === 1 ? "//" : c.slice(0, $e);
  },
  basename: function m(c, ie) {
    if (ie !== void 0 && typeof ie != "string")
      throw new TypeError('"ext" argument must be a string');
    assertPath(c);
    var we = 0, $e = -1, Me = !0, Ze;
    if (ie !== void 0 && ie.length > 0 && ie.length <= c.length) {
      if (ie.length === c.length && ie === c)
        return "";
      var ne = ie.length - 1, rr = -1;
      for (Ze = c.length - 1; Ze >= 0; --Ze) {
        var gr = c.charCodeAt(Ze);
        if (gr === 47) {
          if (!Me) {
            we = Ze + 1;
            break;
          }
        } else
          rr === -1 && (Me = !1, rr = Ze + 1), ne >= 0 && (gr === ie.charCodeAt(ne) ? --ne === -1 && ($e = Ze) : (ne = -1, $e = rr));
      }
      return we === $e ? $e = rr : $e === -1 && ($e = c.length), c.slice(we, $e);
    } else {
      for (Ze = c.length - 1; Ze >= 0; --Ze)
        if (c.charCodeAt(Ze) === 47) {
          if (!Me) {
            we = Ze + 1;
            break;
          }
        } else
          $e === -1 && (Me = !1, $e = Ze + 1);
      return $e === -1 ? "" : c.slice(we, $e);
    }
  },
  extname: function m(c) {
    assertPath(c);
    for (var ie = -1, we = 0, $e = -1, Me = !0, Ze = 0, ne = c.length - 1; ne >= 0; --ne) {
      var rr = c.charCodeAt(ne);
      if (rr === 47) {
        if (!Me) {
          we = ne + 1;
          break;
        }
        continue;
      }
      $e === -1 && (Me = !1, $e = ne + 1), rr === 46 ? ie === -1 ? ie = ne : Ze !== 1 && (Ze = 1) : ie !== -1 && (Ze = -1);
    }
    return ie === -1 || $e === -1 || Ze === 0 || Ze === 1 && ie === $e - 1 && ie === we + 1 ? "" : c.slice(ie, $e);
  },
  format: function m(c) {
    if (c === null || typeof c != "object")
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof c);
    return _format("/", c);
  },
  parse: function m(c) {
    assertPath(c);
    var ie = { root: "", dir: "", base: "", ext: "", name: "" };
    if (c.length === 0)
      return ie;
    var we = c.charCodeAt(0), $e = we === 47, Me;
    $e ? (ie.root = "/", Me = 1) : Me = 0;
    for (var Ze = -1, ne = 0, rr = -1, gr = !0, or = c.length - 1, _r = 0; or >= Me; --or) {
      if (we = c.charCodeAt(or), we === 47) {
        if (!gr) {
          ne = or + 1;
          break;
        }
        continue;
      }
      rr === -1 && (gr = !1, rr = or + 1), we === 46 ? Ze === -1 ? Ze = or : _r !== 1 && (_r = 1) : Ze !== -1 && (_r = -1);
    }
    return Ze === -1 || rr === -1 || _r === 0 || _r === 1 && Ze === rr - 1 && Ze === ne + 1 ? rr !== -1 && (ne === 0 && $e ? ie.base = ie.name = c.slice(1, rr) : ie.base = ie.name = c.slice(ne, rr)) : (ne === 0 && $e ? (ie.name = c.slice(1, Ze), ie.base = c.slice(1, rr)) : (ie.name = c.slice(ne, Ze), ie.base = c.slice(ne, rr)), ie.ext = c.slice(Ze, rr)), ne > 0 ? ie.dir = c.slice(0, ne - 1) : $e && (ie.dir = "/"), ie;
  },
  sep: "/",
  delimiter: ":",
  win32: null,
  posix: null
};
posix.posix = posix;
var pathBrowserify = posix, decodeUriComponent, hasRequiredDecodeUriComponent;
function requireDecodeUriComponent() {
  if (hasRequiredDecodeUriComponent)
    return decodeUriComponent;
  hasRequiredDecodeUriComponent = 1;
  var m = "%[a-f0-9]{2}", c = new RegExp("(" + m + ")|([^%]+?)", "gi"), ie = new RegExp("(" + m + ")+", "gi");
  function we(Ze, ne) {
    try {
      return [decodeURIComponent(Ze.join(""))];
    } catch {
    }
    if (Ze.length === 1)
      return Ze;
    ne = ne || 1;
    var rr = Ze.slice(0, ne), gr = Ze.slice(ne);
    return Array.prototype.concat.call([], we(rr), we(gr));
  }
  function $e(Ze) {
    try {
      return decodeURIComponent(Ze);
    } catch {
      for (var ne = Ze.match(c) || [], rr = 1; rr < ne.length; rr++)
        Ze = we(ne, rr).join(""), ne = Ze.match(c) || [];
      return Ze;
    }
  }
  function Me(Ze) {
    for (var ne = {
      "%FE%FF": "\uFFFD\uFFFD",
      "%FF%FE": "\uFFFD\uFFFD"
    }, rr = ie.exec(Ze); rr; ) {
      try {
        ne[rr[0]] = decodeURIComponent(rr[0]);
      } catch {
        var gr = $e(rr[0]);
        gr !== rr[0] && (ne[rr[0]] = gr);
      }
      rr = ie.exec(Ze);
    }
    ne["%C2"] = "\uFFFD";
    for (var or = Object.keys(ne), _r = 0; _r < or.length; _r++) {
      var Lr = or[_r];
      Ze = Ze.replace(new RegExp(Lr, "g"), ne[Lr]);
    }
    return Ze;
  }
  return decodeUriComponent = function(Ze) {
    if (typeof Ze != "string")
      throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof Ze + "`");
    try {
      return Ze = Ze.replace(/\+/g, " "), decodeURIComponent(Ze);
    } catch {
      return Me(Ze);
    }
  }, decodeUriComponent;
}
var sourceMapResolve, hasRequiredSourceMapResolve;
function requireSourceMapResolve() {
  if (hasRequiredSourceMapResolve)
    return sourceMapResolve;
  hasRequiredSourceMapResolve = 1;
  var m = requireBrowserAtob(), c = require$$1, ie = pathBrowserify, we = requireDecodeUriComponent();
  function $e() {
    return Array.prototype.reduce.call(arguments, function(vr, Ae) {
      return c.resolve(vr, Ae);
    });
  }
  function Me(vr) {
    return ie.sep === "\\" ? vr.replace(/\\/g, "/").replace(/^[a-z]:\/?/i, "/") : vr;
  }
  function Ze(vr) {
    return we(vr.replace(/\+/g, "%2B"));
  }
  function ne(vr, Ae, ze) {
    setImmediate(function() {
      vr(Ae, ze);
    });
  }
  function rr(vr, Ae) {
    try {
      return JSON.parse(vr.replace(/^\)\]\}'/, ""));
    } catch (ze) {
      throw ze.sourceMapData = Ae, ze;
    }
  }
  function gr(vr, Ae, ze) {
    var Ue = Ze(Ae);
    try {
      return String(vr(Ue));
    } catch (tr) {
      throw tr.sourceMapData = ze, tr;
    }
  }
  var or = /[#@] sourceMappingURL=([^\s'"]*)/, _r = RegExp(
    `(?:/\\*(?:\\s*\r?
(?://)?)?(?:` + or.source + ")\\s*\\*/|//(?:" + or.source + "))\\s*"
  );
  function Lr(vr) {
    var Ae = vr.match(_r);
    return Ae ? Ae[1] || Ae[2] || "" : null;
  }
  function Ir(vr, Ae, ze, Ue) {
    var tr;
    try {
      tr = Wr(vr, Ae);
    } catch (pr) {
      return ne(Ue, pr);
    }
    if (!tr || tr.map)
      return ne(Ue, null, tr);
    var lr = Ze(tr.url);
    ze(lr, function(pr, br) {
      if (pr)
        return pr.sourceMapData = tr, Ue(pr);
      tr.map = String(br);
      try {
        tr.map = rr(tr.map, tr);
      } catch (nr) {
        return Ue(nr);
      }
      Ue(null, tr);
    });
  }
  function Ar(vr, Ae, ze) {
    var Ue = Wr(vr, Ae);
    return !Ue || Ue.map || (Ue.map = gr(ze, Ue.url, Ue), Ue.map = rr(Ue.map, Ue)), Ue;
  }
  var Rr = /^data:([^,;]*)(;[^,;]*)*(?:,(.*))?$/, Nr = /^(?:application|text)\/json$/, Yr = "utf-8";
  function Vr(vr) {
    for (var Ae = m(vr), ze = Ae.length, Ue = new Uint8Array(ze), tr = 0; tr < ze; tr++)
      Ue[tr] = Ae.charCodeAt(tr);
    return Ue;
  }
  function Xr(vr) {
    if (typeof TextDecoder > "u" || typeof Uint8Array > "u")
      return m(vr);
    var Ae = Vr(vr), ze = new TextDecoder(Yr, { fatal: !0 });
    return ze.decode(Ae);
  }
  function Wr(vr, Ae) {
    Ae = Me(Ae);
    var ze = Lr(vr);
    if (!ze)
      return null;
    var Ue = ze.match(Rr);
    if (Ue) {
      var tr = Ue[1] || "text/plain", lr = Ue[2] || "", pr = Ue[3] || "", br = {
        sourceMappingURL: ze,
        url: null,
        sourcesRelativeTo: Ae,
        map: pr
      };
      if (!Nr.test(tr)) {
        var nr = new Error("Unuseful data uri mime type: " + tr);
        throw nr.sourceMapData = br, nr;
      }
      try {
        br.map = rr(
          lr === ";base64" ? Xr(pr) : decodeURIComponent(pr),
          br
        );
      } catch (ur) {
        throw ur.sourceMapData = br, ur;
      }
      return br;
    }
    var Pe = $e(Ae, ze);
    return {
      sourceMappingURL: ze,
      url: Pe,
      sourcesRelativeTo: Pe,
      map: null
    };
  }
  function si(vr, Ae, ze, Ue, tr) {
    typeof Ue == "function" && (tr = Ue, Ue = {});
    var lr = vr.sources ? vr.sources.length : 0, pr = {
      sourcesResolved: [],
      sourcesContent: []
    };
    if (lr === 0) {
      ne(tr, null, pr);
      return;
    }
    var br = function() {
      lr--, lr === 0 && tr(null, pr);
    };
    di(vr, Ae, Ue, function(nr, Pe, ur) {
      if (pr.sourcesResolved[ur] = nr, typeof Pe == "string")
        pr.sourcesContent[ur] = Pe, ne(br, null);
      else {
        var Pr = Ze(nr);
        ze(Pr, function(Hr, vi) {
          pr.sourcesContent[ur] = Hr || String(vi), br();
        });
      }
    });
  }
  function li(vr, Ae, ze, Ue) {
    var tr = {
      sourcesResolved: [],
      sourcesContent: []
    };
    return !vr.sources || vr.sources.length === 0 || di(vr, Ae, Ue, function(lr, pr, br) {
      if (tr.sourcesResolved[br] = lr, ze !== null)
        if (typeof pr == "string")
          tr.sourcesContent[br] = pr;
        else {
          var nr = Ze(lr);
          try {
            tr.sourcesContent[br] = String(ze(nr));
          } catch (Pe) {
            tr.sourcesContent[br] = Pe;
          }
        }
    }), tr;
  }
  var xi = /\/?$/;
  function di(vr, Ae, ze, Ue) {
    ze = ze || {}, Ae = Me(Ae);
    for (var tr, lr, pr, br = 0, nr = vr.sources.length; br < nr; br++)
      pr = null, typeof ze.sourceRoot == "string" ? pr = ze.sourceRoot : typeof vr.sourceRoot == "string" && ze.sourceRoot !== !1 && (pr = vr.sourceRoot), pr === null || pr === "" ? tr = $e(Ae, vr.sources[br]) : tr = $e(Ae, pr.replace(xi, "/"), vr.sources[br]), lr = (vr.sourcesContent || [])[br], Ue(tr, lr, br);
  }
  function oi(vr, Ae, ze, Ue, tr) {
    if (typeof Ue == "function" && (tr = Ue, Ue = {}), vr === null) {
      var lr = Ae, pr = {
        sourceMappingURL: null,
        url: lr,
        sourcesRelativeTo: lr,
        map: null
      }, br = Ze(lr);
      ze(br, function(Pe, ur) {
        if (Pe)
          return Pe.sourceMapData = pr, tr(Pe);
        pr.map = String(ur);
        try {
          pr.map = rr(pr.map, pr);
        } catch (Pr) {
          return tr(Pr);
        }
        nr(pr);
      });
    } else
      Ir(vr, Ae, ze, function(Pe, ur) {
        if (Pe)
          return tr(Pe);
        if (!ur)
          return tr(null, null);
        nr(ur);
      });
    function nr(Pe) {
      si(Pe.map, Pe.sourcesRelativeTo, ze, Ue, function(ur, Pr) {
        if (ur)
          return tr(ur);
        Pe.sourcesResolved = Pr.sourcesResolved, Pe.sourcesContent = Pr.sourcesContent, tr(null, Pe);
      });
    }
  }
  function ci(vr, Ae, ze, Ue) {
    var tr;
    if (vr === null) {
      var lr = Ae;
      tr = {
        sourceMappingURL: null,
        url: lr,
        sourcesRelativeTo: lr,
        map: null
      }, tr.map = gr(ze, lr, tr), tr.map = rr(tr.map, tr);
    } else if (tr = Ar(vr, Ae, ze), !tr)
      return null;
    var pr = li(tr.map, tr.sourcesRelativeTo, ze, Ue);
    return tr.sourcesResolved = pr.sourcesResolved, tr.sourcesContent = pr.sourcesContent, tr;
  }
  return sourceMapResolve = {
    resolveSourceMap: Ir,
    resolveSourceMapSync: Ar,
    resolveSources: si,
    resolveSourcesSync: li,
    resolve: oi,
    resolveSync: ci,
    parseMapToJSON: rr
  }, sourceMapResolve;
}
var empty = null;
const empty$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: empty
}, Symbol.toStringTag, { value: "Module" })), require$$2 = /* @__PURE__ */ getAugmentedNamespace(empty$1);
var hasRequiredSourceMapSupport;
function requireSourceMapSupport() {
  return hasRequiredSourceMapSupport || (hasRequiredSourceMapSupport = 1, function(m, c) {
    var ie = requireSourceMap().SourceMapGenerator, we = requireSourceMap().SourceMapConsumer, $e = requireSourceMapResolve(), Me = require$$2, Ze = pathBrowserify;
    m.exports = rr;
    const ne = function(gr) {
      return Ze.sep === "\\" ? gr.replace(/\\/g, "/").replace(/^[a-z]:\/?/i, "/") : gr;
    };
    function rr(gr) {
      gr._comment = gr.comment, gr.map = new ie(), gr.position = { line: 1, column: 1 }, gr.files = {};
      for (var or in c)
        gr[or] = c[or];
    }
    c.updatePosition = function(gr) {
      var or = gr.match(/\n/g);
      or && (this.position.line += or.length);
      var _r = gr.lastIndexOf(`
`);
      this.position.column = ~_r ? gr.length - _r : this.position.column + gr.length;
    }, c.emit = function(gr, or) {
      if (or) {
        var _r = ne(or.source || "source.css");
        this.map.addMapping({
          source: _r,
          generated: {
            line: this.position.line,
            column: Math.max(this.position.column - 1, 0)
          },
          original: {
            line: or.start.line,
            column: or.start.column - 1
          }
        }), this.addFile(_r, or);
      }
      return this.updatePosition(gr), gr;
    }, c.addFile = function(gr, or) {
      typeof or.content == "string" && (Object.prototype.hasOwnProperty.call(this.files, gr) || (this.files[gr] = or.content));
    }, c.applySourceMaps = function() {
      Object.keys(this.files).forEach(function(gr) {
        var or = this.files[gr];
        if (this.map.setSourceContent(gr, or), this.options.inputSourcemaps !== !1) {
          var _r = $e.resolveSync(
            or,
            gr,
            Me.readFileSync
          );
          if (_r) {
            var Lr = new we(_r.map), Ir = _r.sourcesRelativeTo;
            this.map.applySourceMap(Lr, gr, ne(Ze.dirname(Ir)));
          }
        }
      }, this);
    }, c.comment = function(gr) {
      return /^# sourceMappingURL=/.test(gr.comment) ? this.emit("", gr.position) : this._comment(gr);
    };
  }(sourceMapSupport, sourceMapSupport.exports)), sourceMapSupport.exports;
}
var Compressed = compress, Identity = identity, stringify = function(m, c) {
  c = c || {};
  var ie = c.compress ? new Compressed(c) : new Identity(c);
  if (c.sourcemap) {
    var we = requireSourceMapSupport();
    we(ie);
    var Me = ie.compile(m);
    ie.applySourceMaps();
    var $e = c.sourcemap === "generator" ? ie.map : ie.map.toJSON();
    return { code: Me, map: $e };
  }
  var Me = ie.compile(m);
  return Me;
};
css.parse = parse$b;
css.stringify = stringify;
function blobToDataURL(m) {
  return new Promise(function(c) {
    const ie = new FileReader();
    ie.addEventListener("load", (we) => {
      typeof we?.target?.result == "string" && c(we.target.result);
    }), ie.readAsDataURL(m);
  });
}
function indexOf(m, c, ie = 0) {
  const we = m.substring(ie).search(c);
  return we > -1 ? ie + we : we;
}
function indexOfAll(m, c, ie = 0) {
  const we = [];
  for (; indexOf(m, c, ie) > -1; )
    we.push(indexOf(m, c, ie)), ie = we[we.length - 1] + 1;
  return we;
}
function findExprEnd(m, c, ie, we = [/\(/, /\)/]) {
  let $e = c;
  for (; $e < m.length; ) {
    const Me = indexOf(m, ie, $e) > -1 ? indexOf(m, ie, $e) : 1 / 0, Ze = m.slice(0, Me + 1), ne = indexOfAll(Ze, we[0], c), rr = indexOfAll(Ze, we[1], c);
    if (ne.length - rr.length <= 0)
      return Me;
    $e = Me + 1;
  }
  return -1;
}
function parseArgumentsIndex(m, c, ie, we = [/\(/, /\)/]) {
  let $e = 0;
  const Me = [];
  for (; indexOf(m, ie, $e) > -1; ) {
    const Ze = indexOf(m, ie, $e), ne = findExprEnd(m, Ze, c, we);
    if (Me.push({ start: Ze, end: ne }), $e = ne + 1, ne == -1)
      break;
  }
  return Me;
}
function parseArguments(m, c = /,\s*/, ie = /[^\s]/, we) {
  return parseArgumentsIndex(m, c, ie, we).map(({ start: $e, end: Me }) => m.substring($e, Me));
}
function parseExpression(m) {
  const c = [];
  let ie = 0;
  for (; ; ) {
    const we = findExprEnd(m, ie, /\s{1,}/);
    if (we >= 0) {
      const $e = m.substring(ie, we);
      c.push($e);
      const Me = indexOf(m, /[^\s]/, we);
      if (Me >= 0)
        ie = Me;
      else
        break;
    } else {
      const $e = m.substring(ie);
      c.push($e);
      break;
    }
  }
  return c;
}
function parsePrimitive(m) {
  const c = m.search(/[^\.0-9\-]/);
  if (c > 0) {
    const ie = Number(m.slice(0, c)), we = m.slice(c);
    if (!isNaN(ie))
      return { value: ie, unit: we };
  }
  return { value: isNaN(Number(m)) ? m : Number(m), unit: null };
}
const funcRegex = /^([^()\s]{1,})\((.*)\)$/;
function isFunctionLiteral(m) {
  return funcRegex.test(m);
}
function __parse(m) {
  const c = m;
  if (isFunctionLiteral(m)) {
    const [, ie, we] = m.match(funcRegex);
    return {
      raw: c,
      type: "function",
      name: ie,
      args: parseArguments(we, /,\s*/, /[^\s]/).map(parse$7)
    };
  } else {
    const ie = m.replace(/^\((.*)\)$/, "$1"), we = parseExpression(ie);
    if (we.length === 1 && we[0] === m) {
      const { value: $e, unit: Me } = parsePrimitive(we[0]);
      return {
        raw: c,
        type: "primitive",
        value: $e,
        unit: Me
      };
    } else
      return {
        raw: c,
        type: "expression",
        literals: we.map(__parse)
      };
  }
}
function parse$7(m) {
  var c;
  const ie = __parse(`(${m})`);
  return Object.assign(Object.assign({}, ie), { raw: (c = ie.raw) === null || c === void 0 ? void 0 : c.slice(1, -1) });
}
async function fetchWithProgress(m, c, ie = "unit8Array", we) {
  const $e = await fetch(m, c);
  if (!$e.body)
    throw new Error("Response body is undefined");
  const Me = Number($e.headers.get("Content-Length")), Ze = isNaN(Me) ? null : Me, ne = $e.body.getReader();
  let rr = 0;
  const gr = [];
  for (; ; ) {
    const { done: Ir, value: Ar } = await ne.read();
    if (Ir)
      break;
    rr += Ar.length, gr.push(Ar), we && we(Ze, rr);
  }
  const or = new Uint8Array(rr);
  let _r = 0;
  for (const Ir of gr)
    or.set(Ir, _r), _r += Ir.length;
  const Lr = $e.headers.get("Content-Type");
  return {
    data: or,
    contentType: Lr
  };
}
function fetchWithProgressV1({
  url: m,
  method: c = "GET",
  data: ie = null,
  headers: we = {},
  onUploadProgress: $e,
  onDownloadProgress: Me
}) {
  return new Promise((Ze, ne) => {
    const rr = new XMLHttpRequest();
    rr.responseType = "blob", rr.open(c, m);
    for (const [gr, or] of Object.entries(we))
      rr.setRequestHeader(gr, or);
    $e && rr.upload && (rr.upload.onprogress = (gr) => {
      $e(gr.loaded, gr.total);
    }), Me && (rr.onprogress = (gr) => {
      gr.lengthComputable && Me(gr.loaded, gr.total);
    }), rr.onload = async () => {
      if (rr.status >= 200 && rr.status < 300)
        Ze(rr.response);
      else
        try {
          ne(new Error(await rr.response.text()));
        } catch {
          ne(new Error(`HTTP error: ${rr.statusText}`));
        }
    }, rr.onerror = (gr) => {
      ne(new Error("Network error"));
    }, rr.send(ie);
  });
}
const cssFontsCache = /* @__PURE__ */ new Map();
function isCharInRange(m, c) {
  const ie = c.split(",").map((we) => we.trim());
  for (const we of ie)
    if (we.startsWith("U+")) {
      const [$e, Me] = we.substring(2).split("-").map((Ze) => parseInt(Ze, 16));
      if (Me ? m >= $e && m <= Me : m === $e)
        return !0;
    }
  return !1;
}
function textIsInUnicodeRange(m, c) {
  for (const ie of m) {
    const we = ie.codePointAt(0);
    if (we !== void 0 && isCharInRange(we, c))
      return !0;
  }
  return !1;
}
async function resolveCSSFontFile(m, c, ie, we, $e = !0) {
  if ($e && cssFontsCache.has(m))
    return c(1, 1), cssFontsCache.get(m);
  const Me = await fetch(`https://fontdelivery.fellowblue.dev/proxy?url=${encodeURIComponent(m)}`).then(
    (Ar) => Ar.text()
  ), Ze = pLimit(1), ne = css.parse(Me), { stylesheet: rr } = ne;
  if (!rr)
    throw new Error("Invalid CSS file");
  const { rules: gr } = rr, or = gr.map((Ar) => {
    if (!we && Ar.type === "font-face") {
      const Rr = Ar;
      if (Rr.declarations === void 0)
        throw new Error("no declarations in font-face rule");
      const Nr = Rr.declarations.find((Xr) => Xr.type === "declaration" ? Xr.property === "src" : !1), Vr = Rr.declarations.find((Xr) => Xr.type === "declaration" ? Xr.property === "unicode-range" : null)?.value;
      if (Vr && !textIsInUnicodeRange(ie, Vr))
        return;
      if (!Nr)
        throw new Error("no src declaration in font-face rule");
      return Nr;
    }
  }).filter((Ar) => Ar !== void 0), _r = or.length + 1;
  let Lr = 1;
  c(Lr, _r);
  for (const Ar of or) {
    const Rr = Ar.value;
    if (Rr === void 0)
      throw new Error("no value in src declaration");
    const Yr = parse$7(Rr).literals.find(
      (li) => li.type === "function" && li.name === "url"
    );
    if (Yr === void 0)
      throw new Error("no url function in src declaration");
    const Vr = Yr.args[0].raw;
    if (Vr === void 0)
      throw new Error("no url in url function");
    const Xr = await Ze(() => fetch(Vr).then((li) => li.blob())), Wr = Xr.type.split("/")[1], si = await blobToDataURL(Xr);
    Ar.value = `url('${si}') format('${Wr}')`, Lr++, c(Lr, _r);
  }
  const Ir = css.stringify(ne);
  return $e && cssFontsCache.set(m, Ir), Ir;
}
function uint8ArrayToBase64(m, c = 8192) {
  let ie = "";
  for (let we = 0; we < m.length; we += c) {
    const $e = m.subarray(we, we + c);
    ie += String.fromCharCode(...$e);
  }
  return window.btoa(ie);
}
async function resolveImage(m, c) {
  const ie = m.getAttribute("href");
  if (ie) {
    const { data: we, contentType: $e } = await fetchWithProgress(ie, {}, "unit8Array", (Ze, ne) => {
      Ze !== null && c(ne / Ze);
    }), Me = `data:${$e};base64,${uint8ArrayToBase64(we)}`;
    c(1), m.setAttribute("href", Me);
  }
}
function getTextToCoverByFont(m, c) {
  const ie = Array.from(m.querySelectorAll("text")), we = ie.map((Me) => Array.from(Me.querySelectorAll("tspan"))).flat();
  return [
    ...ie.map((Me) => Me.textContent ?? ""),
    ...we.map((Me) => Me.textContent ?? "")
  ].join("");
}
async function exportSVGDocument(m, c, ie, we) {
  const Me = new DOMParser().parseFromString(m, "image/svg+xml"), Ze = Array.from(Me.querySelectorAll("image")), ne = Ze.map(() => 0), rr = c.map(() => 0), gr = () => {
    const Ar = [...rr, ...ne], Rr = Ar.reduce((Nr, Yr) => Nr + Yr, 0) / Ar.length;
    ie(Rr);
  }, or = await Promise.all(
    c.map(async ({ src: Ar, name: Rr }, Nr) => {
      const Yr = getTextToCoverByFont(Me);
      return {
        name: Rr,
        css: await resolveCSSFontFile(
          Ar,
          (Vr, Xr) => {
            rr[Nr] = Vr / Xr, gr();
          },
          Yr,
          we
        )
      };
    })
  ), _r = Me.createElementNS("http://www.w3.org/2000/svg", "defs");
  for (const { name: Ar, css: Rr } of or) {
    const Nr = document.createElement("style");
    Nr.setAttribute("type", "text/css"), Nr.setAttribute("data-bx-live-font", "true"), Nr.setAttribute("data-bx-font-name", Ar), Nr.innerHTML = Rr, _r.appendChild(Nr);
  }
  const Lr = Me.documentElement;
  Lr.insertBefore(_r, Lr.firstChild);
  const Ir = pLimit(1);
  return await Promise.all(
    Ze.map(
      (Ar, Rr) => Ir(
        () => resolveImage(Ar, (Nr) => {
          ne[Rr] = Nr, gr();
        })
      )
    )
  ), new XMLSerializer().serializeToString(Me);
}
var re$3 = { exports: {} };
const SEMVER_SPEC_VERSION = "2.0.0", MAX_LENGTH$1 = 256, MAX_SAFE_INTEGER$1 = Number.MAX_SAFE_INTEGER || 9007199254740991, MAX_SAFE_COMPONENT_LENGTH = 16, MAX_SAFE_BUILD_LENGTH = MAX_LENGTH$1 - 6, RELEASE_TYPES = [
  "major",
  "premajor",
  "minor",
  "preminor",
  "patch",
  "prepatch",
  "prerelease"
];
var constants$1 = {
  MAX_LENGTH: MAX_LENGTH$1,
  MAX_SAFE_COMPONENT_LENGTH,
  MAX_SAFE_BUILD_LENGTH,
  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$1,
  RELEASE_TYPES,
  SEMVER_SPEC_VERSION,
  FLAG_INCLUDE_PRERELEASE: 1,
  FLAG_LOOSE: 2
};
const debug$1 = typeof process$1 == "object" && process$1.env && process$1.env.NODE_DEBUG && /\bsemver\b/i.test(process$1.env.NODE_DEBUG) ? (...m) => console.error("SEMVER", ...m) : () => {
};
var debug_1 = debug$1;
(function(m, c) {
  const {
    MAX_SAFE_COMPONENT_LENGTH: ie,
    MAX_SAFE_BUILD_LENGTH: we,
    MAX_LENGTH: $e
  } = constants$1, Me = debug_1;
  c = m.exports = {};
  const Ze = c.re = [], ne = c.safeRe = [], rr = c.src = [], gr = c.t = {};
  let or = 0;
  const _r = "[a-zA-Z0-9-]", Lr = [
    ["\\s", 1],
    ["\\d", $e],
    [_r, we]
  ], Ir = (Rr) => {
    for (const [Nr, Yr] of Lr)
      Rr = Rr.split(`${Nr}*`).join(`${Nr}{0,${Yr}}`).split(`${Nr}+`).join(`${Nr}{1,${Yr}}`);
    return Rr;
  }, Ar = (Rr, Nr, Yr) => {
    const Vr = Ir(Nr), Xr = or++;
    Me(Rr, Xr, Nr), gr[Rr] = Xr, rr[Xr] = Nr, Ze[Xr] = new RegExp(Nr, Yr ? "g" : void 0), ne[Xr] = new RegExp(Vr, Yr ? "g" : void 0);
  };
  Ar("NUMERICIDENTIFIER", "0|[1-9]\\d*"), Ar("NUMERICIDENTIFIERLOOSE", "\\d+"), Ar("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${_r}*`), Ar("MAINVERSION", `(${rr[gr.NUMERICIDENTIFIER]})\\.(${rr[gr.NUMERICIDENTIFIER]})\\.(${rr[gr.NUMERICIDENTIFIER]})`), Ar("MAINVERSIONLOOSE", `(${rr[gr.NUMERICIDENTIFIERLOOSE]})\\.(${rr[gr.NUMERICIDENTIFIERLOOSE]})\\.(${rr[gr.NUMERICIDENTIFIERLOOSE]})`), Ar("PRERELEASEIDENTIFIER", `(?:${rr[gr.NUMERICIDENTIFIER]}|${rr[gr.NONNUMERICIDENTIFIER]})`), Ar("PRERELEASEIDENTIFIERLOOSE", `(?:${rr[gr.NUMERICIDENTIFIERLOOSE]}|${rr[gr.NONNUMERICIDENTIFIER]})`), Ar("PRERELEASE", `(?:-(${rr[gr.PRERELEASEIDENTIFIER]}(?:\\.${rr[gr.PRERELEASEIDENTIFIER]})*))`), Ar("PRERELEASELOOSE", `(?:-?(${rr[gr.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${rr[gr.PRERELEASEIDENTIFIERLOOSE]})*))`), Ar("BUILDIDENTIFIER", `${_r}+`), Ar("BUILD", `(?:\\+(${rr[gr.BUILDIDENTIFIER]}(?:\\.${rr[gr.BUILDIDENTIFIER]})*))`), Ar("FULLPLAIN", `v?${rr[gr.MAINVERSION]}${rr[gr.PRERELEASE]}?${rr[gr.BUILD]}?`), Ar("FULL", `^${rr[gr.FULLPLAIN]}$`), Ar("LOOSEPLAIN", `[v=\\s]*${rr[gr.MAINVERSIONLOOSE]}${rr[gr.PRERELEASELOOSE]}?${rr[gr.BUILD]}?`), Ar("LOOSE", `^${rr[gr.LOOSEPLAIN]}$`), Ar("GTLT", "((?:<|>)?=?)"), Ar("XRANGEIDENTIFIERLOOSE", `${rr[gr.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), Ar("XRANGEIDENTIFIER", `${rr[gr.NUMERICIDENTIFIER]}|x|X|\\*`), Ar("XRANGEPLAIN", `[v=\\s]*(${rr[gr.XRANGEIDENTIFIER]})(?:\\.(${rr[gr.XRANGEIDENTIFIER]})(?:\\.(${rr[gr.XRANGEIDENTIFIER]})(?:${rr[gr.PRERELEASE]})?${rr[gr.BUILD]}?)?)?`), Ar("XRANGEPLAINLOOSE", `[v=\\s]*(${rr[gr.XRANGEIDENTIFIERLOOSE]})(?:\\.(${rr[gr.XRANGEIDENTIFIERLOOSE]})(?:\\.(${rr[gr.XRANGEIDENTIFIERLOOSE]})(?:${rr[gr.PRERELEASELOOSE]})?${rr[gr.BUILD]}?)?)?`), Ar("XRANGE", `^${rr[gr.GTLT]}\\s*${rr[gr.XRANGEPLAIN]}$`), Ar("XRANGELOOSE", `^${rr[gr.GTLT]}\\s*${rr[gr.XRANGEPLAINLOOSE]}$`), Ar("COERCEPLAIN", `(^|[^\\d])(\\d{1,${ie}})(?:\\.(\\d{1,${ie}}))?(?:\\.(\\d{1,${ie}}))?`), Ar("COERCE", `${rr[gr.COERCEPLAIN]}(?:$|[^\\d])`), Ar("COERCEFULL", rr[gr.COERCEPLAIN] + `(?:${rr[gr.PRERELEASE]})?(?:${rr[gr.BUILD]})?(?:$|[^\\d])`), Ar("COERCERTL", rr[gr.COERCE], !0), Ar("COERCERTLFULL", rr[gr.COERCEFULL], !0), Ar("LONETILDE", "(?:~>?)"), Ar("TILDETRIM", `(\\s*)${rr[gr.LONETILDE]}\\s+`, !0), c.tildeTrimReplace = "$1~", Ar("TILDE", `^${rr[gr.LONETILDE]}${rr[gr.XRANGEPLAIN]}$`), Ar("TILDELOOSE", `^${rr[gr.LONETILDE]}${rr[gr.XRANGEPLAINLOOSE]}$`), Ar("LONECARET", "(?:\\^)"), Ar("CARETTRIM", `(\\s*)${rr[gr.LONECARET]}\\s+`, !0), c.caretTrimReplace = "$1^", Ar("CARET", `^${rr[gr.LONECARET]}${rr[gr.XRANGEPLAIN]}$`), Ar("CARETLOOSE", `^${rr[gr.LONECARET]}${rr[gr.XRANGEPLAINLOOSE]}$`), Ar("COMPARATORLOOSE", `^${rr[gr.GTLT]}\\s*(${rr[gr.LOOSEPLAIN]})$|^$`), Ar("COMPARATOR", `^${rr[gr.GTLT]}\\s*(${rr[gr.FULLPLAIN]})$|^$`), Ar("COMPARATORTRIM", `(\\s*)${rr[gr.GTLT]}\\s*(${rr[gr.LOOSEPLAIN]}|${rr[gr.XRANGEPLAIN]})`, !0), c.comparatorTrimReplace = "$1$2$3", Ar("HYPHENRANGE", `^\\s*(${rr[gr.XRANGEPLAIN]})\\s+-\\s+(${rr[gr.XRANGEPLAIN]})\\s*$`), Ar("HYPHENRANGELOOSE", `^\\s*(${rr[gr.XRANGEPLAINLOOSE]})\\s+-\\s+(${rr[gr.XRANGEPLAINLOOSE]})\\s*$`), Ar("STAR", "(<|>)?=?\\s*\\*"), Ar("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), Ar("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(re$3, re$3.exports);
const looseOption = Object.freeze({ loose: !0 }), emptyOpts = Object.freeze({}), parseOptions$1 = (m) => m ? typeof m != "object" ? looseOption : m : emptyOpts;
var parseOptions_1 = parseOptions$1;
const numeric = /^[0-9]+$/, compareIdentifiers$1 = (m, c) => {
  const ie = numeric.test(m), we = numeric.test(c);
  return ie && we && (m = +m, c = +c), m === c ? 0 : ie && !we ? -1 : we && !ie ? 1 : m < c ? -1 : 1;
}, rcompareIdentifiers = (m, c) => compareIdentifiers$1(c, m);
var identifiers$1 = {
  compareIdentifiers: compareIdentifiers$1,
  rcompareIdentifiers
};
const debug = debug_1, { MAX_LENGTH, MAX_SAFE_INTEGER } = constants$1, { safeRe: re$2, t: t$2 } = re$3.exports, parseOptions = parseOptions_1, { compareIdentifiers } = identifiers$1;
class SemVer$d {
  constructor(c, ie) {
    if (ie = parseOptions(ie), c instanceof SemVer$d) {
      if (c.loose === !!ie.loose && c.includePrerelease === !!ie.includePrerelease)
        return c;
      c = c.version;
    } else if (typeof c != "string")
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof c}".`);
    if (c.length > MAX_LENGTH)
      throw new TypeError(
        `version is longer than ${MAX_LENGTH} characters`
      );
    debug("SemVer", c, ie), this.options = ie, this.loose = !!ie.loose, this.includePrerelease = !!ie.includePrerelease;
    const we = c.trim().match(ie.loose ? re$2[t$2.LOOSE] : re$2[t$2.FULL]);
    if (!we)
      throw new TypeError(`Invalid Version: ${c}`);
    if (this.raw = c, this.major = +we[1], this.minor = +we[2], this.patch = +we[3], this.major > MAX_SAFE_INTEGER || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
      throw new TypeError("Invalid patch version");
    we[4] ? this.prerelease = we[4].split(".").map(($e) => {
      if (/^[0-9]+$/.test($e)) {
        const Me = +$e;
        if (Me >= 0 && Me < MAX_SAFE_INTEGER)
          return Me;
      }
      return $e;
    }) : this.prerelease = [], this.build = we[5] ? we[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(c) {
    if (debug("SemVer.compare", this.version, this.options, c), !(c instanceof SemVer$d)) {
      if (typeof c == "string" && c === this.version)
        return 0;
      c = new SemVer$d(c, this.options);
    }
    return c.version === this.version ? 0 : this.compareMain(c) || this.comparePre(c);
  }
  compareMain(c) {
    return c instanceof SemVer$d || (c = new SemVer$d(c, this.options)), compareIdentifiers(this.major, c.major) || compareIdentifiers(this.minor, c.minor) || compareIdentifiers(this.patch, c.patch);
  }
  comparePre(c) {
    if (c instanceof SemVer$d || (c = new SemVer$d(c, this.options)), this.prerelease.length && !c.prerelease.length)
      return -1;
    if (!this.prerelease.length && c.prerelease.length)
      return 1;
    if (!this.prerelease.length && !c.prerelease.length)
      return 0;
    let ie = 0;
    do {
      const we = this.prerelease[ie], $e = c.prerelease[ie];
      if (debug("prerelease compare", ie, we, $e), we === void 0 && $e === void 0)
        return 0;
      if ($e === void 0)
        return 1;
      if (we === void 0)
        return -1;
      if (we === $e)
        continue;
      return compareIdentifiers(we, $e);
    } while (++ie);
  }
  compareBuild(c) {
    c instanceof SemVer$d || (c = new SemVer$d(c, this.options));
    let ie = 0;
    do {
      const we = this.build[ie], $e = c.build[ie];
      if (debug("build compare", ie, we, $e), we === void 0 && $e === void 0)
        return 0;
      if ($e === void 0)
        return 1;
      if (we === void 0)
        return -1;
      if (we === $e)
        continue;
      return compareIdentifiers(we, $e);
    } while (++ie);
  }
  inc(c, ie, we) {
    switch (c) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", ie, we);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", ie, we);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", ie, we), this.inc("pre", ie, we);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", ie, we), this.inc("pre", ie, we);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre": {
        const $e = Number(we) ? 1 : 0;
        if (!ie && we === !1)
          throw new Error("invalid increment argument: identifier is empty");
        if (this.prerelease.length === 0)
          this.prerelease = [$e];
        else {
          let Me = this.prerelease.length;
          for (; --Me >= 0; )
            typeof this.prerelease[Me] == "number" && (this.prerelease[Me]++, Me = -2);
          if (Me === -1) {
            if (ie === this.prerelease.join(".") && we === !1)
              throw new Error("invalid increment argument: identifier already exists");
            this.prerelease.push($e);
          }
        }
        if (ie) {
          let Me = [ie, $e];
          we === !1 && (Me = [ie]), compareIdentifiers(this.prerelease[0], ie) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = Me) : this.prerelease = Me;
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${c}`);
    }
    return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
  }
}
var semver$1 = SemVer$d;
const SemVer$c = semver$1, parse$6 = (m, c, ie = !1) => {
  if (m instanceof SemVer$c)
    return m;
  try {
    return new SemVer$c(m, c);
  } catch (we) {
    if (!ie)
      return null;
    throw we;
  }
};
var parse_1 = parse$6;
const parse$5 = parse_1, valid$2 = (m, c) => {
  const ie = parse$5(m, c);
  return ie ? ie.version : null;
};
var valid_1 = valid$2;
const parse$4 = parse_1, clean$1 = (m, c) => {
  const ie = parse$4(m.trim().replace(/^[=v]+/, ""), c);
  return ie ? ie.version : null;
};
var clean_1 = clean$1;
const SemVer$b = semver$1, inc$1 = (m, c, ie, we, $e) => {
  typeof ie == "string" && ($e = we, we = ie, ie = void 0);
  try {
    return new SemVer$b(
      m instanceof SemVer$b ? m.version : m,
      ie
    ).inc(c, we, $e).version;
  } catch {
    return null;
  }
};
var inc_1 = inc$1;
const parse$3 = parse_1, diff$1 = (m, c) => {
  const ie = parse$3(m, null, !0), we = parse$3(c, null, !0), $e = ie.compare(we);
  if ($e === 0)
    return null;
  const Me = $e > 0, Ze = Me ? ie : we, ne = Me ? we : ie, rr = !!Ze.prerelease.length;
  if (!!ne.prerelease.length && !rr)
    return !ne.patch && !ne.minor ? "major" : Ze.patch ? "patch" : Ze.minor ? "minor" : "major";
  const or = rr ? "pre" : "";
  return ie.major !== we.major ? or + "major" : ie.minor !== we.minor ? or + "minor" : ie.patch !== we.patch ? or + "patch" : "prerelease";
};
var diff_1 = diff$1;
const SemVer$a = semver$1, major$1 = (m, c) => new SemVer$a(m, c).major;
var major_1 = major$1;
const SemVer$9 = semver$1, minor$1 = (m, c) => new SemVer$9(m, c).minor;
var minor_1 = minor$1;
const SemVer$8 = semver$1, patch$1 = (m, c) => new SemVer$8(m, c).patch;
var patch_1 = patch$1;
const parse$2 = parse_1, prerelease$1 = (m, c) => {
  const ie = parse$2(m, c);
  return ie && ie.prerelease.length ? ie.prerelease : null;
};
var prerelease_1 = prerelease$1;
const SemVer$7 = semver$1, compare$b = (m, c, ie) => new SemVer$7(m, ie).compare(new SemVer$7(c, ie));
var compare_1 = compare$b;
const compare$a = compare_1, rcompare$1 = (m, c, ie) => compare$a(c, m, ie);
var rcompare_1 = rcompare$1;
const compare$9 = compare_1, compareLoose$1 = (m, c) => compare$9(m, c, !0);
var compareLoose_1 = compareLoose$1;
const SemVer$6 = semver$1, compareBuild$3 = (m, c, ie) => {
  const we = new SemVer$6(m, ie), $e = new SemVer$6(c, ie);
  return we.compare($e) || we.compareBuild($e);
};
var compareBuild_1 = compareBuild$3;
const compareBuild$2 = compareBuild_1, sort$1 = (m, c) => m.sort((ie, we) => compareBuild$2(ie, we, c));
var sort_1 = sort$1;
const compareBuild$1 = compareBuild_1, rsort$1 = (m, c) => m.sort((ie, we) => compareBuild$1(we, ie, c));
var rsort_1 = rsort$1;
const compare$8 = compare_1, gt$5 = (m, c, ie) => compare$8(m, c, ie) > 0;
var gt_1 = gt$5;
const compare$7 = compare_1, lt$4 = (m, c, ie) => compare$7(m, c, ie) < 0;
var lt_1 = lt$4;
const compare$6 = compare_1, eq$2 = (m, c, ie) => compare$6(m, c, ie) === 0;
var eq_1 = eq$2;
const compare$5 = compare_1, neq$2 = (m, c, ie) => compare$5(m, c, ie) !== 0;
var neq_1 = neq$2;
const compare$4 = compare_1, gte$3 = (m, c, ie) => compare$4(m, c, ie) >= 0;
var gte_1 = gte$3;
const compare$3 = compare_1, lte$3 = (m, c, ie) => compare$3(m, c, ie) <= 0;
var lte_1 = lte$3;
const eq$1 = eq_1, neq$1 = neq_1, gt$4 = gt_1, gte$2 = gte_1, lt$3 = lt_1, lte$2 = lte_1, cmp$1 = (m, c, ie, we) => {
  switch (c) {
    case "===":
      return typeof m == "object" && (m = m.version), typeof ie == "object" && (ie = ie.version), m === ie;
    case "!==":
      return typeof m == "object" && (m = m.version), typeof ie == "object" && (ie = ie.version), m !== ie;
    case "":
    case "=":
    case "==":
      return eq$1(m, ie, we);
    case "!=":
      return neq$1(m, ie, we);
    case ">":
      return gt$4(m, ie, we);
    case ">=":
      return gte$2(m, ie, we);
    case "<":
      return lt$3(m, ie, we);
    case "<=":
      return lte$2(m, ie, we);
    default:
      throw new TypeError(`Invalid operator: ${c}`);
  }
};
var cmp_1 = cmp$1;
const SemVer$5 = semver$1, parse$1 = parse_1, { safeRe: re$1, t: t$1 } = re$3.exports, coerce$1 = (m, c) => {
  if (m instanceof SemVer$5)
    return m;
  if (typeof m == "number" && (m = String(m)), typeof m != "string")
    return null;
  c = c || {};
  let ie = null;
  if (!c.rtl)
    ie = m.match(c.includePrerelease ? re$1[t$1.COERCEFULL] : re$1[t$1.COERCE]);
  else {
    const rr = c.includePrerelease ? re$1[t$1.COERCERTLFULL] : re$1[t$1.COERCERTL];
    let gr;
    for (; (gr = rr.exec(m)) && (!ie || ie.index + ie[0].length !== m.length); )
      (!ie || gr.index + gr[0].length !== ie.index + ie[0].length) && (ie = gr), rr.lastIndex = gr.index + gr[1].length + gr[2].length;
    rr.lastIndex = -1;
  }
  if (ie === null)
    return null;
  const we = ie[2], $e = ie[3] || "0", Me = ie[4] || "0", Ze = c.includePrerelease && ie[5] ? `-${ie[5]}` : "", ne = c.includePrerelease && ie[6] ? `+${ie[6]}` : "";
  return parse$1(`${we}.${$e}.${Me}${Ze}${ne}`, c);
};
var coerce_1 = coerce$1;
class LRUCache {
  constructor() {
    this.max = 1e3, this.map = /* @__PURE__ */ new Map();
  }
  get(c) {
    const ie = this.map.get(c);
    if (ie !== void 0)
      return this.map.delete(c), this.map.set(c, ie), ie;
  }
  delete(c) {
    return this.map.delete(c);
  }
  set(c, ie) {
    if (!this.delete(c) && ie !== void 0) {
      if (this.map.size >= this.max) {
        const $e = this.map.keys().next().value;
        this.delete($e);
      }
      this.map.set(c, ie);
    }
    return this;
  }
}
var lrucache = LRUCache, range, hasRequiredRange;
function requireRange() {
  if (hasRequiredRange)
    return range;
  hasRequiredRange = 1;
  const m = /\s+/g;
  class c {
    constructor(tr, lr) {
      if (lr = $e(lr), tr instanceof c)
        return tr.loose === !!lr.loose && tr.includePrerelease === !!lr.includePrerelease ? tr : new c(tr.raw, lr);
      if (tr instanceof Me)
        return this.raw = tr.value, this.set = [[tr]], this.formatted = void 0, this;
      if (this.options = lr, this.loose = !!lr.loose, this.includePrerelease = !!lr.includePrerelease, this.raw = tr.trim().replace(m, " "), this.set = this.raw.split("||").map((pr) => this.parseRange(pr.trim())).filter((pr) => pr.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const pr = this.set[0];
        if (this.set = this.set.filter((br) => !Rr(br[0])), this.set.length === 0)
          this.set = [pr];
        else if (this.set.length > 1) {
          for (const br of this.set)
            if (br.length === 1 && Nr(br[0])) {
              this.set = [br];
              break;
            }
        }
      }
      this.formatted = void 0;
    }
    get range() {
      if (this.formatted === void 0) {
        this.formatted = "";
        for (let tr = 0; tr < this.set.length; tr++) {
          tr > 0 && (this.formatted += "||");
          const lr = this.set[tr];
          for (let pr = 0; pr < lr.length; pr++)
            pr > 0 && (this.formatted += " "), this.formatted += lr[pr].toString().trim();
        }
      }
      return this.formatted;
    }
    format() {
      return this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(tr) {
      const pr = ((this.options.includePrerelease && Ir) | (this.options.loose && Ar)) + ":" + tr, br = we.get(pr);
      if (br)
        return br;
      const nr = this.options.loose, Pe = nr ? rr[gr.HYPHENRANGELOOSE] : rr[gr.HYPHENRANGE];
      tr = tr.replace(Pe, Ae(this.options.includePrerelease)), Ze("hyphen replace", tr), tr = tr.replace(rr[gr.COMPARATORTRIM], or), Ze("comparator trim", tr), tr = tr.replace(rr[gr.TILDETRIM], _r), Ze("tilde trim", tr), tr = tr.replace(rr[gr.CARETTRIM], Lr), Ze("caret trim", tr);
      let ur = tr.split(" ").map((Ti) => Vr(Ti, this.options)).join(" ").split(/\s+/).map((Ti) => vr(Ti, this.options));
      nr && (ur = ur.filter((Ti) => (Ze("loose invalid filter", Ti, this.options), !!Ti.match(rr[gr.COMPARATORLOOSE])))), Ze("range list", ur);
      const Pr = /* @__PURE__ */ new Map(), Hr = ur.map((Ti) => new Me(Ti, this.options));
      for (const Ti of Hr) {
        if (Rr(Ti))
          return [Ti];
        Pr.set(Ti.value, Ti);
      }
      Pr.size > 1 && Pr.has("") && Pr.delete("");
      const vi = [...Pr.values()];
      return we.set(pr, vi), vi;
    }
    intersects(tr, lr) {
      if (!(tr instanceof c))
        throw new TypeError("a Range is required");
      return this.set.some((pr) => Yr(pr, lr) && tr.set.some((br) => Yr(br, lr) && pr.every((nr) => br.every((Pe) => nr.intersects(Pe, lr)))));
    }
    test(tr) {
      if (!tr)
        return !1;
      if (typeof tr == "string")
        try {
          tr = new ne(tr, this.options);
        } catch {
          return !1;
        }
      for (let lr = 0; lr < this.set.length; lr++)
        if (ze(this.set[lr], tr, this.options))
          return !0;
      return !1;
    }
  }
  range = c;
  const ie = lrucache, we = new ie(), $e = parseOptions_1, Me = requireComparator(), Ze = debug_1, ne = semver$1, {
    safeRe: rr,
    t: gr,
    comparatorTrimReplace: or,
    tildeTrimReplace: _r,
    caretTrimReplace: Lr
  } = re$3.exports, { FLAG_INCLUDE_PRERELEASE: Ir, FLAG_LOOSE: Ar } = constants$1, Rr = (Ue) => Ue.value === "<0.0.0-0", Nr = (Ue) => Ue.value === "", Yr = (Ue, tr) => {
    let lr = !0;
    const pr = Ue.slice();
    let br = pr.pop();
    for (; lr && pr.length; )
      lr = pr.every((nr) => br.intersects(nr, tr)), br = pr.pop();
    return lr;
  }, Vr = (Ue, tr) => (Ze("comp", Ue, tr), Ue = li(Ue, tr), Ze("caret", Ue), Ue = Wr(Ue, tr), Ze("tildes", Ue), Ue = di(Ue, tr), Ze("xrange", Ue), Ue = ci(Ue, tr), Ze("stars", Ue), Ue), Xr = (Ue) => !Ue || Ue.toLowerCase() === "x" || Ue === "*", Wr = (Ue, tr) => Ue.trim().split(/\s+/).map((lr) => si(lr, tr)).join(" "), si = (Ue, tr) => {
    const lr = tr.loose ? rr[gr.TILDELOOSE] : rr[gr.TILDE];
    return Ue.replace(lr, (pr, br, nr, Pe, ur) => {
      Ze("tilde", Ue, pr, br, nr, Pe, ur);
      let Pr;
      return Xr(br) ? Pr = "" : Xr(nr) ? Pr = `>=${br}.0.0 <${+br + 1}.0.0-0` : Xr(Pe) ? Pr = `>=${br}.${nr}.0 <${br}.${+nr + 1}.0-0` : ur ? (Ze("replaceTilde pr", ur), Pr = `>=${br}.${nr}.${Pe}-${ur} <${br}.${+nr + 1}.0-0`) : Pr = `>=${br}.${nr}.${Pe} <${br}.${+nr + 1}.0-0`, Ze("tilde return", Pr), Pr;
    });
  }, li = (Ue, tr) => Ue.trim().split(/\s+/).map((lr) => xi(lr, tr)).join(" "), xi = (Ue, tr) => {
    Ze("caret", Ue, tr);
    const lr = tr.loose ? rr[gr.CARETLOOSE] : rr[gr.CARET], pr = tr.includePrerelease ? "-0" : "";
    return Ue.replace(lr, (br, nr, Pe, ur, Pr) => {
      Ze("caret", Ue, br, nr, Pe, ur, Pr);
      let Hr;
      return Xr(nr) ? Hr = "" : Xr(Pe) ? Hr = `>=${nr}.0.0${pr} <${+nr + 1}.0.0-0` : Xr(ur) ? nr === "0" ? Hr = `>=${nr}.${Pe}.0${pr} <${nr}.${+Pe + 1}.0-0` : Hr = `>=${nr}.${Pe}.0${pr} <${+nr + 1}.0.0-0` : Pr ? (Ze("replaceCaret pr", Pr), nr === "0" ? Pe === "0" ? Hr = `>=${nr}.${Pe}.${ur}-${Pr} <${nr}.${Pe}.${+ur + 1}-0` : Hr = `>=${nr}.${Pe}.${ur}-${Pr} <${nr}.${+Pe + 1}.0-0` : Hr = `>=${nr}.${Pe}.${ur}-${Pr} <${+nr + 1}.0.0-0`) : (Ze("no pr"), nr === "0" ? Pe === "0" ? Hr = `>=${nr}.${Pe}.${ur}${pr} <${nr}.${Pe}.${+ur + 1}-0` : Hr = `>=${nr}.${Pe}.${ur}${pr} <${nr}.${+Pe + 1}.0-0` : Hr = `>=${nr}.${Pe}.${ur} <${+nr + 1}.0.0-0`), Ze("caret return", Hr), Hr;
    });
  }, di = (Ue, tr) => (Ze("replaceXRanges", Ue, tr), Ue.split(/\s+/).map((lr) => oi(lr, tr)).join(" ")), oi = (Ue, tr) => {
    Ue = Ue.trim();
    const lr = tr.loose ? rr[gr.XRANGELOOSE] : rr[gr.XRANGE];
    return Ue.replace(lr, (pr, br, nr, Pe, ur, Pr) => {
      Ze("xRange", Ue, pr, br, nr, Pe, ur, Pr);
      const Hr = Xr(nr), vi = Hr || Xr(Pe), Ti = vi || Xr(ur), wi = Ti;
      return br === "=" && wi && (br = ""), Pr = tr.includePrerelease ? "-0" : "", Hr ? br === ">" || br === "<" ? pr = "<0.0.0-0" : pr = "*" : br && wi ? (vi && (Pe = 0), ur = 0, br === ">" ? (br = ">=", vi ? (nr = +nr + 1, Pe = 0, ur = 0) : (Pe = +Pe + 1, ur = 0)) : br === "<=" && (br = "<", vi ? nr = +nr + 1 : Pe = +Pe + 1), br === "<" && (Pr = "-0"), pr = `${br + nr}.${Pe}.${ur}${Pr}`) : vi ? pr = `>=${nr}.0.0${Pr} <${+nr + 1}.0.0-0` : Ti && (pr = `>=${nr}.${Pe}.0${Pr} <${nr}.${+Pe + 1}.0-0`), Ze("xRange return", pr), pr;
    });
  }, ci = (Ue, tr) => (Ze("replaceStars", Ue, tr), Ue.trim().replace(rr[gr.STAR], "")), vr = (Ue, tr) => (Ze("replaceGTE0", Ue, tr), Ue.trim().replace(rr[tr.includePrerelease ? gr.GTE0PRE : gr.GTE0], "")), Ae = (Ue) => (tr, lr, pr, br, nr, Pe, ur, Pr, Hr, vi, Ti, wi) => (Xr(pr) ? lr = "" : Xr(br) ? lr = `>=${pr}.0.0${Ue ? "-0" : ""}` : Xr(nr) ? lr = `>=${pr}.${br}.0${Ue ? "-0" : ""}` : Pe ? lr = `>=${lr}` : lr = `>=${lr}${Ue ? "-0" : ""}`, Xr(Hr) ? Pr = "" : Xr(vi) ? Pr = `<${+Hr + 1}.0.0-0` : Xr(Ti) ? Pr = `<${Hr}.${+vi + 1}.0-0` : wi ? Pr = `<=${Hr}.${vi}.${Ti}-${wi}` : Ue ? Pr = `<${Hr}.${vi}.${+Ti + 1}-0` : Pr = `<=${Pr}`, `${lr} ${Pr}`.trim()), ze = (Ue, tr, lr) => {
    for (let pr = 0; pr < Ue.length; pr++)
      if (!Ue[pr].test(tr))
        return !1;
    if (tr.prerelease.length && !lr.includePrerelease) {
      for (let pr = 0; pr < Ue.length; pr++)
        if (Ze(Ue[pr].semver), Ue[pr].semver !== Me.ANY && Ue[pr].semver.prerelease.length > 0) {
          const br = Ue[pr].semver;
          if (br.major === tr.major && br.minor === tr.minor && br.patch === tr.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return range;
}
var comparator, hasRequiredComparator;
function requireComparator() {
  if (hasRequiredComparator)
    return comparator;
  hasRequiredComparator = 1;
  const m = Symbol("SemVer ANY");
  class c {
    static get ANY() {
      return m;
    }
    constructor(or, _r) {
      if (_r = ie(_r), or instanceof c) {
        if (or.loose === !!_r.loose)
          return or;
        or = or.value;
      }
      or = or.trim().split(/\s+/).join(" "), Ze("comparator", or, _r), this.options = _r, this.loose = !!_r.loose, this.parse(or), this.semver === m ? this.value = "" : this.value = this.operator + this.semver.version, Ze("comp", this);
    }
    parse(or) {
      const _r = this.options.loose ? we[$e.COMPARATORLOOSE] : we[$e.COMPARATOR], Lr = or.match(_r);
      if (!Lr)
        throw new TypeError(`Invalid comparator: ${or}`);
      this.operator = Lr[1] !== void 0 ? Lr[1] : "", this.operator === "=" && (this.operator = ""), Lr[2] ? this.semver = new ne(Lr[2], this.options.loose) : this.semver = m;
    }
    toString() {
      return this.value;
    }
    test(or) {
      if (Ze("Comparator.test", or, this.options.loose), this.semver === m || or === m)
        return !0;
      if (typeof or == "string")
        try {
          or = new ne(or, this.options);
        } catch {
          return !1;
        }
      return Me(or, this.operator, this.semver, this.options);
    }
    intersects(or, _r) {
      if (!(or instanceof c))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new rr(or.value, _r).test(this.value) : or.operator === "" ? or.value === "" ? !0 : new rr(this.value, _r).test(or.semver) : (_r = ie(_r), _r.includePrerelease && (this.value === "<0.0.0-0" || or.value === "<0.0.0-0") || !_r.includePrerelease && (this.value.startsWith("<0.0.0") || or.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && or.operator.startsWith(">") || this.operator.startsWith("<") && or.operator.startsWith("<") || this.semver.version === or.semver.version && this.operator.includes("=") && or.operator.includes("=") || Me(this.semver, "<", or.semver, _r) && this.operator.startsWith(">") && or.operator.startsWith("<") || Me(this.semver, ">", or.semver, _r) && this.operator.startsWith("<") && or.operator.startsWith(">")));
    }
  }
  comparator = c;
  const ie = parseOptions_1, { safeRe: we, t: $e } = re$3.exports, Me = cmp_1, Ze = debug_1, ne = semver$1, rr = requireRange();
  return comparator;
}
const Range$9 = requireRange(), satisfies$4 = (m, c, ie) => {
  try {
    c = new Range$9(c, ie);
  } catch {
    return !1;
  }
  return c.test(m);
};
var satisfies_1 = satisfies$4;
const Range$8 = requireRange(), toComparators$1 = (m, c) => new Range$8(m, c).set.map((ie) => ie.map((we) => we.value).join(" ").trim().split(" "));
var toComparators_1 = toComparators$1;
const SemVer$4 = semver$1, Range$7 = requireRange(), maxSatisfying$1 = (m, c, ie) => {
  let we = null, $e = null, Me = null;
  try {
    Me = new Range$7(c, ie);
  } catch {
    return null;
  }
  return m.forEach((Ze) => {
    Me.test(Ze) && (!we || $e.compare(Ze) === -1) && (we = Ze, $e = new SemVer$4(we, ie));
  }), we;
};
var maxSatisfying_1 = maxSatisfying$1;
const SemVer$3 = semver$1, Range$6 = requireRange(), minSatisfying$1 = (m, c, ie) => {
  let we = null, $e = null, Me = null;
  try {
    Me = new Range$6(c, ie);
  } catch {
    return null;
  }
  return m.forEach((Ze) => {
    Me.test(Ze) && (!we || $e.compare(Ze) === 1) && (we = Ze, $e = new SemVer$3(we, ie));
  }), we;
};
var minSatisfying_1 = minSatisfying$1;
const SemVer$2 = semver$1, Range$5 = requireRange(), gt$3 = gt_1, minVersion$1 = (m, c) => {
  m = new Range$5(m, c);
  let ie = new SemVer$2("0.0.0");
  if (m.test(ie) || (ie = new SemVer$2("0.0.0-0"), m.test(ie)))
    return ie;
  ie = null;
  for (let we = 0; we < m.set.length; ++we) {
    const $e = m.set[we];
    let Me = null;
    $e.forEach((Ze) => {
      const ne = new SemVer$2(Ze.semver.version);
      switch (Ze.operator) {
        case ">":
          ne.prerelease.length === 0 ? ne.patch++ : ne.prerelease.push(0), ne.raw = ne.format();
        case "":
        case ">=":
          (!Me || gt$3(ne, Me)) && (Me = ne);
          break;
        case "<":
        case "<=":
          break;
        default:
          throw new Error(`Unexpected operation: ${Ze.operator}`);
      }
    }), Me && (!ie || gt$3(ie, Me)) && (ie = Me);
  }
  return ie && m.test(ie) ? ie : null;
};
var minVersion_1 = minVersion$1;
const Range$4 = requireRange(), validRange$1 = (m, c) => {
  try {
    return new Range$4(m, c).range || "*";
  } catch {
    return null;
  }
};
var valid$1 = validRange$1;
const SemVer$1 = semver$1, Comparator$2 = requireComparator(), { ANY: ANY$1 } = Comparator$2, Range$3 = requireRange(), satisfies$3 = satisfies_1, gt$2 = gt_1, lt$2 = lt_1, lte$1 = lte_1, gte$1 = gte_1, outside$3 = (m, c, ie, we) => {
  m = new SemVer$1(m, we), c = new Range$3(c, we);
  let $e, Me, Ze, ne, rr;
  switch (ie) {
    case ">":
      $e = gt$2, Me = lte$1, Ze = lt$2, ne = ">", rr = ">=";
      break;
    case "<":
      $e = lt$2, Me = gte$1, Ze = gt$2, ne = "<", rr = "<=";
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }
  if (satisfies$3(m, c, we))
    return !1;
  for (let gr = 0; gr < c.set.length; ++gr) {
    const or = c.set[gr];
    let _r = null, Lr = null;
    if (or.forEach((Ir) => {
      Ir.semver === ANY$1 && (Ir = new Comparator$2(">=0.0.0")), _r = _r || Ir, Lr = Lr || Ir, $e(Ir.semver, _r.semver, we) ? _r = Ir : Ze(Ir.semver, Lr.semver, we) && (Lr = Ir);
    }), _r.operator === ne || _r.operator === rr || (!Lr.operator || Lr.operator === ne) && Me(m, Lr.semver))
      return !1;
    if (Lr.operator === rr && Ze(m, Lr.semver))
      return !1;
  }
  return !0;
};
var outside_1 = outside$3;
const outside$2 = outside_1, gtr$1 = (m, c, ie) => outside$2(m, c, ">", ie);
var gtr_1 = gtr$1;
const outside$1 = outside_1, ltr$1 = (m, c, ie) => outside$1(m, c, "<", ie);
var ltr_1 = ltr$1;
const Range$2 = requireRange(), intersects$1 = (m, c, ie) => (m = new Range$2(m, ie), c = new Range$2(c, ie), m.intersects(c, ie));
var intersects_1 = intersects$1;
const satisfies$2 = satisfies_1, compare$2 = compare_1;
var simplify = (m, c, ie) => {
  const we = [];
  let $e = null, Me = null;
  const Ze = m.sort((or, _r) => compare$2(or, _r, ie));
  for (const or of Ze)
    satisfies$2(or, c, ie) ? (Me = or, $e || ($e = or)) : (Me && we.push([$e, Me]), Me = null, $e = null);
  $e && we.push([$e, null]);
  const ne = [];
  for (const [or, _r] of we)
    or === _r ? ne.push(or) : !_r && or === Ze[0] ? ne.push("*") : _r ? or === Ze[0] ? ne.push(`<=${_r}`) : ne.push(`${or} - ${_r}`) : ne.push(`>=${or}`);
  const rr = ne.join(" || "), gr = typeof c.raw == "string" ? c.raw : String(c);
  return rr.length < gr.length ? rr : c;
};
const Range$1 = requireRange(), Comparator$1 = requireComparator(), { ANY } = Comparator$1, satisfies$1 = satisfies_1, compare$1 = compare_1, subset$1 = (m, c, ie = {}) => {
  if (m === c)
    return !0;
  m = new Range$1(m, ie), c = new Range$1(c, ie);
  let we = !1;
  e:
    for (const $e of m.set) {
      for (const Me of c.set) {
        const Ze = simpleSubset($e, Me, ie);
        if (we = we || Ze !== null, Ze)
          continue e;
      }
      if (we)
        return !1;
    }
  return !0;
}, minimumVersionWithPreRelease = [new Comparator$1(">=0.0.0-0")], minimumVersion = [new Comparator$1(">=0.0.0")], simpleSubset = (m, c, ie) => {
  if (m === c)
    return !0;
  if (m.length === 1 && m[0].semver === ANY) {
    if (c.length === 1 && c[0].semver === ANY)
      return !0;
    ie.includePrerelease ? m = minimumVersionWithPreRelease : m = minimumVersion;
  }
  if (c.length === 1 && c[0].semver === ANY) {
    if (ie.includePrerelease)
      return !0;
    c = minimumVersion;
  }
  const we = /* @__PURE__ */ new Set();
  let $e, Me;
  for (const Ir of m)
    Ir.operator === ">" || Ir.operator === ">=" ? $e = higherGT($e, Ir, ie) : Ir.operator === "<" || Ir.operator === "<=" ? Me = lowerLT(Me, Ir, ie) : we.add(Ir.semver);
  if (we.size > 1)
    return null;
  let Ze;
  if ($e && Me) {
    if (Ze = compare$1($e.semver, Me.semver, ie), Ze > 0)
      return null;
    if (Ze === 0 && ($e.operator !== ">=" || Me.operator !== "<="))
      return null;
  }
  for (const Ir of we) {
    if ($e && !satisfies$1(Ir, String($e), ie) || Me && !satisfies$1(Ir, String(Me), ie))
      return null;
    for (const Ar of c)
      if (!satisfies$1(Ir, String(Ar), ie))
        return !1;
    return !0;
  }
  let ne, rr, gr, or, _r = Me && !ie.includePrerelease && Me.semver.prerelease.length ? Me.semver : !1, Lr = $e && !ie.includePrerelease && $e.semver.prerelease.length ? $e.semver : !1;
  _r && _r.prerelease.length === 1 && Me.operator === "<" && _r.prerelease[0] === 0 && (_r = !1);
  for (const Ir of c) {
    if (or = or || Ir.operator === ">" || Ir.operator === ">=", gr = gr || Ir.operator === "<" || Ir.operator === "<=", $e) {
      if (Lr && Ir.semver.prerelease && Ir.semver.prerelease.length && Ir.semver.major === Lr.major && Ir.semver.minor === Lr.minor && Ir.semver.patch === Lr.patch && (Lr = !1), Ir.operator === ">" || Ir.operator === ">=") {
        if (ne = higherGT($e, Ir, ie), ne === Ir && ne !== $e)
          return !1;
      } else if ($e.operator === ">=" && !satisfies$1($e.semver, String(Ir), ie))
        return !1;
    }
    if (Me) {
      if (_r && Ir.semver.prerelease && Ir.semver.prerelease.length && Ir.semver.major === _r.major && Ir.semver.minor === _r.minor && Ir.semver.patch === _r.patch && (_r = !1), Ir.operator === "<" || Ir.operator === "<=") {
        if (rr = lowerLT(Me, Ir, ie), rr === Ir && rr !== Me)
          return !1;
      } else if (Me.operator === "<=" && !satisfies$1(Me.semver, String(Ir), ie))
        return !1;
    }
    if (!Ir.operator && (Me || $e) && Ze !== 0)
      return !1;
  }
  return !($e && gr && !Me && Ze !== 0 || Me && or && !$e && Ze !== 0 || Lr || _r);
}, higherGT = (m, c, ie) => {
  if (!m)
    return c;
  const we = compare$1(m.semver, c.semver, ie);
  return we > 0 ? m : we < 0 || c.operator === ">" && m.operator === ">=" ? c : m;
}, lowerLT = (m, c, ie) => {
  if (!m)
    return c;
  const we = compare$1(m.semver, c.semver, ie);
  return we < 0 ? m : we > 0 || c.operator === "<" && m.operator === "<=" ? c : m;
};
var subset_1 = subset$1;
const internalRe = re$3.exports, constants = constants$1, SemVer = semver$1, identifiers = identifiers$1, parse = parse_1, valid = valid_1, clean = clean_1, inc = inc_1, diff = diff_1, major = major_1, minor = minor_1, patch = patch_1, prerelease = prerelease_1, compare = compare_1, rcompare = rcompare_1, compareLoose = compareLoose_1, compareBuild = compareBuild_1, sort = sort_1, rsort = rsort_1, gt$1 = gt_1, lt$1 = lt_1, eq = eq_1, neq = neq_1, gte = gte_1, lte = lte_1, cmp = cmp_1, coerce = coerce_1, Comparator = requireComparator(), Range = requireRange(), satisfies = satisfies_1, toComparators = toComparators_1, maxSatisfying = maxSatisfying_1, minSatisfying = minSatisfying_1, minVersion = minVersion_1, validRange = valid$1, outside = outside_1, gtr = gtr_1, ltr = ltr_1, intersects = intersects_1, simplifyRange = simplify, subset = subset_1;
var semver = {
  parse,
  valid,
  clean,
  inc,
  diff,
  major,
  minor,
  patch,
  prerelease,
  compare,
  rcompare,
  compareLoose,
  compareBuild,
  sort,
  rsort,
  gt: gt$1,
  lt: lt$1,
  eq,
  neq,
  gte,
  lte,
  cmp,
  coerce,
  Comparator,
  Range,
  satisfies,
  toComparators,
  maxSatisfying,
  minSatisfying,
  minVersion,
  validRange,
  outside,
  gtr,
  ltr,
  intersects,
  simplifyRange,
  subset,
  SemVer,
  re: internalRe.re,
  src: internalRe.src,
  tokens: internalRe.t,
  SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
  RELEASE_TYPES: constants.RELEASE_TYPES,
  compareIdentifiers: identifiers.compareIdentifiers,
  rcompareIdentifiers: identifiers.rcompareIdentifiers
};
const _hoisted_1$h = { class: "bluepic-embedded-wrapper" }, _hoisted_2$d = ["src"], maxTries = 3, _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "BluepicEmbedded",
  props: {
    templateId: {},
    studioResourcesBaseUrl: {},
    cloudflarePagesHostname: {},
    bxCoreVersion: { default: "auto" },
    authorization: { default: void 0 },
    data: { default: () => ({}) },
    fonts: { default: () => [] },
    webgl: { type: Boolean, default: !1 },
    resolution: { default: 1 },
    asyncSerial: { type: Boolean, default: !1 },
    baseSerial: {}
  },
  emits: ["update:data", "update:ready", "update:serial", "error", "update:globalScope"],
  setup(m, { expose: c, emit: ie }) {
    const we = m, $e = ie, Ze = computed(
      () => we.bxCoreVersion !== "auto" && semver.gte(we.bxCoreVersion, "0.1.200") && we.asyncSerial
    ).value ? new Promise(async (Xr, Wr) => {
      if (we.baseSerial)
        return Xr(we.baseSerial);
      const si = getTemplateSerialUrl(we.templateId, {
        studioResourcesBaseUrl: we.studioResourcesBaseUrl,
        authorization: we.authorization,
        cloudflarePagesHostname: we.cloudflarePagesHostname,
        config: {
          fonts: we.fonts,
          webgl: we.webgl,
          resolution: we.resolution
        }
      });
      let li = !1, xi = 0;
      for (; !li && xi < maxTries; ) {
        const di = await fetch(si);
        if (di.ok) {
          const oi = await di.json();
          Xr(oi), li = !0;
        } else
          xi++;
      }
      li || Wr(new Error("Failed to fetch serial"));
    }) : void 0, ne = computed(() => getTemplateLiveUrl(we.templateId, we.bxCoreVersion, {
      studioResourcesBaseUrl: we.studioResourcesBaseUrl,
      authorization: we.authorization,
      cloudflarePagesHostname: we.cloudflarePagesHostname,
      useBoilerplate: Ze !== void 0,
      config: {
        fonts: we.fonts,
        webgl: we.webgl,
        resolution: we.resolution
      }
    })), rr = ref$1(!1);
    watchEffect(() => {
      $e("update:ready", rr.value);
    });
    const gr = ref$1();
    watch(gr, () => {
      $e("update:serial", gr.value);
    });
    const or = ref$1(), _r = ref$1();
    watch(or, () => {
      const Xr = or.value;
      if (Xr) {
        _r.value = new EmbeddedController(Xr, Ze);
        const Wr = async () => {
          rr.value = !0;
          let si, li;
          for (; !si; )
            si = await Rr(), si || await new Promise((di) => setTimeout(di, 50));
          for (; !li; )
            _r.value && (li = await _r.value.evaluate(() => window.bx_serial?.value)), li || await new Promise((di) => setTimeout(di, 50));
          const xi = {
            ...si,
            ...we.data
          };
          gr.value = li, await _r.value?.setData(xi), $e("update:data", xi), _r.value?.removeEventListener("ready", Wr);
        };
        _r.value.addEventListener("ready", Wr), _r.value.addEventListener("error", (si) => {
          $e("error", si.detail.code);
        }), _r.value.addEventListener("globalScope", (si) => {
          $e("update:globalScope", si.detail);
        });
      }
    });
    let Lr = !1, Ir = !1;
    const Ar = () => {
      _r.value && (Lr ? Ir = !0 : (Ir = !1, Lr = !0, _r.value.setData(we.data).then(async () => {
        if (Lr = !1, Ir && _r.value)
          return Ar();
      }).catch((Xr) => {
        console.error("ERROR!", Xr);
      })));
    };
    watch(
      () => we.data,
      async (Xr) => {
        const Wr = await Rr();
        isEqual(Wr, Xr) || Ar();
      },
      { deep: !0 }
    );
    const Rr = () => _r.value?.evaluate(() => {
      if (window.bx_data)
        return window.bx_data;
    });
    async function Nr() {
      if (_r?.value)
        try {
          return !!await _r.value.evaluate(() => !!window.__serialWrapperWebGL?.value);
        } catch {
          return !1;
        }
      else
        return !1;
    }
    async function Yr(Xr) {
      if (!_r.value)
        throw new Error("Controller is not available");
      if (!we.webgl)
        throw new Error("WebGL is not enabled");
      const Wr = await _r.value.evaluate(
        (si, li, xi) => {
          const di = JSON.parse(si);
          JSON.parse(li);
          const oi = xi ? JSON.parse(xi) : void 0;
          return window.__serialWrapperWebGL.value.bluepic.renderImage({ ...di, resultType: "dataUrl", area: oi });
        },
        JSON.stringify(Xr),
        JSON.stringify(gr.value),
        JSON.stringify(Xr.area)
      );
      return dataUrlToBlob(Wr);
    }
    async function Vr() {
      if (!_r.value)
        throw new Error("Controller is not available");
      if (!gr.value)
        throw new Error("Serial is not available");
      const Xr = await _r.value.evaluate(() => window.document.querySelector(".serial-wrapper > svg").outerHTML), Wr = gr.value.fonts;
      console.log("fontsInUse", Wr);
      const si = await exportSVGDocument(
        Xr,
        Wr,
        (xi) => {
          console.log(xi);
        },
        !0
      );
      return new DOMParser().parseFromString(si, "image/svg+xml");
    }
    return c({
      renderWebGL: Yr,
      renderSVG: Vr,
      webglSupported: Nr,
      resolveData: Rr,
      controller: _r
    }), (Xr, Wr) => (openBlock(), createElementBlock("div", _hoisted_1$h, [
      createElementVNode("iframe", {
        ref_key: "frameRef",
        ref: or,
        src: ne.value,
        scrolling: "no"
      }, null, 8, _hoisted_2$d)
    ]));
  }
}), BluepicEmbedded_vue_vue_type_style_index_0_scoped_b2100af7_lang = "", BluepicEmbedded = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["__scopeId", "data-v-b2100af7"]]);
function Ee(m) {
  return getCurrentScope() ? (onScopeDispose(m), !0) : !1;
}
function Te(m) {
  return typeof m == "function" ? m() : unref(m);
}
const me = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Je = (m) => m != null, Qe = Object.prototype.toString, Ne = (m) => Qe.call(m) === "[object Object]", et = () => {
};
function tt(m) {
  return m || getCurrentInstance();
}
function nt(m, c = !0, ie) {
  tt() ? onMounted(m, ie) : c ? m() : nextTick$3(m);
}
function ae(m) {
  var c;
  const ie = Te(m);
  return (c = ie?.$el) != null ? c : ie;
}
const Se = me ? window : void 0;
function _e(...m) {
  let c, ie, we, $e;
  if (typeof m[0] == "string" || Array.isArray(m[0]) ? ([ie, we, $e] = m, c = Se) : [c, ie, we, $e] = m, !c)
    return et;
  Array.isArray(ie) || (ie = [ie]), Array.isArray(we) || (we = [we]);
  const Me = [], Ze = () => {
    Me.forEach((or) => or()), Me.length = 0;
  }, ne = (or, _r, Lr, Ir) => (or.addEventListener(_r, Lr, Ir), () => or.removeEventListener(_r, Lr, Ir)), rr = watch(
    () => [ae(c), Te($e)],
    ([or, _r]) => {
      if (Ze(), !or)
        return;
      const Lr = Ne(_r) ? { ..._r } : _r;
      Me.push(
        ...ie.flatMap((Ir) => we.map((Ar) => ne(or, Ir, Ar, Lr)))
      );
    },
    { immediate: !0, flush: "post" }
  ), gr = () => {
    rr(), Ze();
  };
  return Ee(gr), gr;
}
function ot() {
  const m = ref$1(!1), c = getCurrentInstance();
  return c && onMounted(() => {
    m.value = !0;
  }, c), m;
}
function je(m) {
  const c = ot();
  return computed(() => (c.value, Boolean(m())));
}
function st(m, c, ie = {}) {
  const { window: we = Se, ...$e } = ie;
  let Me;
  const Ze = je(() => we && "MutationObserver" in we), ne = () => {
    Me && (Me.disconnect(), Me = void 0);
  }, rr = computed(() => {
    const Lr = Te(m), Ir = (Array.isArray(Lr) ? Lr : [Lr]).map(ae).filter(Je);
    return new Set(Ir);
  }), gr = watch(
    () => rr.value,
    (Lr) => {
      ne(), Ze.value && we && Lr.size && (Me = new MutationObserver(c), Lr.forEach((Ir) => Me.observe(Ir, $e)));
    },
    { immediate: !0, flush: "post" }
  ), or = () => Me?.takeRecords(), _r = () => {
    ne(), gr();
  };
  return Ee(_r), {
    isSupported: Ze,
    stop: _r,
    takeRecords: or
  };
}
function at(m, c, ie = {}) {
  const { window: we = Se, ...$e } = ie;
  let Me;
  const Ze = je(() => we && "ResizeObserver" in we), ne = () => {
    Me && (Me.disconnect(), Me = void 0);
  }, rr = computed(() => Array.isArray(m) ? m.map((_r) => ae(_r)) : [ae(m)]), gr = watch(
    rr,
    (_r) => {
      if (ne(), Ze.value && we) {
        Me = new ResizeObserver(c);
        for (const Lr of _r)
          Lr && Me.observe(Lr, $e);
      }
    },
    { immediate: !0, flush: "post" }
  ), or = () => {
    ne(), gr();
  };
  return Ee(or), {
    isSupported: Ze,
    stop: or
  };
}
function rt(m, c = {}) {
  const {
    reset: ie = !0,
    windowResize: we = !0,
    windowScroll: $e = !0,
    immediate: Me = !0
  } = c, Ze = ref$1(0), ne = ref$1(0), rr = ref$1(0), gr = ref$1(0), or = ref$1(0), _r = ref$1(0), Lr = ref$1(0), Ir = ref$1(0);
  function Ar() {
    const Rr = ae(m);
    if (!Rr) {
      ie && (Ze.value = 0, ne.value = 0, rr.value = 0, gr.value = 0, or.value = 0, _r.value = 0, Lr.value = 0, Ir.value = 0);
      return;
    }
    const Nr = Rr.getBoundingClientRect();
    Ze.value = Nr.height, ne.value = Nr.bottom, rr.value = Nr.left, gr.value = Nr.right, or.value = Nr.top, _r.value = Nr.width, Lr.value = Nr.x, Ir.value = Nr.y;
  }
  return at(m, Ar), watch(() => ae(m), (Rr) => !Rr && Ar()), st(m, Ar, {
    attributeFilter: ["style", "class"]
  }), $e && _e("scroll", Ar, { capture: !0, passive: !0 }), we && _e("resize", Ar, { passive: !0 }), nt(() => {
    Me && Ar();
  }), {
    height: Ze,
    bottom: ne,
    left: rr,
    right: gr,
    top: or,
    width: _r,
    x: Lr,
    y: Ir,
    update: Ar
  };
}
function Be(m) {
  return m * 180 / Math.PI;
}
function Fe(m) {
  return m * Math.PI / 180;
}
function ce(m, c, ie) {
  return Math.min(Math.max(m, c), ie);
}
function Re(m, c) {
  return Math.atan2(c[1] - m[1], c[0] - m[0]);
}
function pe(m, c, ie) {
  const [we, $e] = m, [Me, Ze] = c, ne = Math.cos(ie) * (we - Me) - Math.sin(ie) * ($e - Ze) + Me, rr = Math.sin(ie) * (we - Me) + Math.cos(ie) * ($e - Ze) + Ze;
  return [ne, rr];
}
function he(m, c) {
  const ie = Math.pow(10, c);
  return Math.round(m * ie) / ie;
}
function lt({
  wrapperInnerWidth: m,
  wrapperInnerHeight: c,
  canvasNaturalWidth: ie,
  canvasNaturalHeight: we,
  translate: $e,
  rotate: Me,
  scale: Ze,
  offset: ne,
  rotationEnabled: rr,
  minScale: gr,
  maxScale: or,
  naturalScale: _r,
  clientCoordsToWrapperCoords: Lr,
  getCanvasCoords: Ir,
  calcProjectionTranslate: Ar
}) {
  let Rr = null, Nr = [0, 0];
  const Yr = (Vr) => Array.from(Vr).map((Xr) => {
    const Wr = Lr(Xr.clientX, Xr.clientY);
    return {
      client: [Xr.clientX, Xr.clientY],
      canvasRel: Ir(Wr[0], Wr[1])
    };
  });
  return {
    handleTouchstart: (Vr) => {
      Vr.target.closest(".matrix") === null && (Vr.preventDefault(), Rr = Yr(Vr.touches), Ze.value, Nr = [$e.value[0], $e.value[1]], Me.value);
    },
    handleTouchmove: (Vr) => {
      if (Vr.target.closest(".matrix") !== null)
        return;
      Vr.preventDefault();
      const Xr = Array.from(Vr.touches).map((Wr) => Lr(Wr.clientX, Wr.clientY));
      if (Rr)
        if (Xr.length >= 2 && Rr.length >= 2) {
          const Wr = [
            Rr[0].canvasRel[0] * ie.value,
            Rr[0].canvasRel[1] * we.value
          ], si = [
            Rr[1].canvasRel[0] * ie.value,
            Rr[1].canvasRel[1] * we.value
          ], li = Math.sqrt(
            Math.pow(Wr[0] - si[0], 2) + Math.pow(Wr[1] - si[1], 2)
          ), xi = Math.sqrt(
            Math.pow(Xr[0][0] - Xr[1][0], 2) + Math.pow(Xr[0][1] - Xr[1][1], 2)
          ) / _r.value, di = ce(xi / li, gr.value, or.value), oi = [
            Xr[0][0] / m.value,
            Xr[0][1] / c.value
          ], ci = Rr[0].canvasRel, [vr, Ae] = Ar(di, oi, ci, 0);
          let ze = 0, Ue = 0, tr = 0;
          if (rr.value) {
            let lr = function(ur, Pr) {
              return [
                ne.value.left + ie.value * ur * _r.value * di + vr,
                ne.value.top + we.value * Pr * _r.value * di + Ae
              ];
            };
            const pr = Re(Wr, si);
            tr = Re(
              Xr[0],
              Xr[1]
            ) - pr, console.log("startAngle", pr);
            const br = lr(0, 0), nr = lr(
              Rr[0].canvasRel[0],
              Rr[0].canvasRel[1]
            ), Pe = pe(
              br,
              nr,
              tr
            );
            ze = Pe[0] - br[0], Ue = Pe[1] - br[1];
          }
          Ze.value = di, Me.value = tr, $e.value = [vr + ze, Ae + Ue], console.log("scale", Ze.value), console.log("rotate", Me.value), console.log("translate", $e.value[0], $e.value[1]);
        } else {
          const Wr = Vr.touches[0].clientX - Rr[0].client[0], si = Vr.touches[0].clientY - Rr[0].client[1], li = [Nr[0] + Wr, Nr[1] + si];
          $e.value = li;
        }
    },
    handleTouchend: (Vr) => {
      Vr.target.closest(".matrix") === null && (Vr.touches.length === 0 ? Rr = null : (Rr = Yr(Vr.touches), Ze.value, Nr = [$e.value[0], $e.value[1]], Me.value));
    }
  };
}
function ut(m) {
  var c = !1;
  return m.wheelDeltaY ? m.wheelDeltaY === m.deltaY * -3 && (c = !0) : m.deltaMode === 0 && (c = !0), c;
}
function Ye(m, c) {
  const ie = c.find((we) => m % we === 0);
  return ie ? m / ie : 1;
}
function it({
  scale: m,
  translate: c,
  minScale: ie,
  maxScale: we,
  relativeWrapperCoordinatesFromClientCoords: $e,
  normalizeMatrixCoordinates: Me,
  calcProjectionTranslate: Ze
}) {
  function ne(rr) {
    let { deltaX: gr, deltaY: or, ctrlKey: _r } = rr;
    const Lr = [120, 100], Ir = 2;
    ut(rr) || ((Math.abs(gr) === 120 || Math.abs(gr) === 200) && (gr = gr / (100 / Ir * Ye(gr, Lr)) * Math.sign(gr)), (Math.abs(or) === 120 || Math.abs(or) === 200) && (or = or / (100 / Ir * Ye(or, Lr)) * Math.sign(or)));
    const Ar = m.value;
    if (_r) {
      const Rr = -or / 100 * Ar, Nr = ce(Ar + Rr, ie.value, we.value), [Yr, Vr] = Ze(
        Nr,
        $e(rr.clientX, rr.clientY),
        Me(rr.clientX, rr.clientY)
      );
      c.value = [Yr, Vr], m.value = Nr;
    } else
      c.value = [c.value[0] - gr, c.value[1] - or];
    rr.preventDefault(), rr.stopPropagation();
  }
  return {
    handleWheel: ne
  };
}
function ct(m) {
  let c = null, ie = null, we = null;
  return {
    handleMousedown: ($e) => {
      $e.preventDefault(), c = [$e.clientX, $e.clientY], ie = m.value[0], we = m.value[1];
    },
    handleMouseup: ($e) => {
      $e.preventDefault(), c = null, ie = null, we = null;
    },
    handleMousemove: ($e) => {
      if ($e.preventDefault(), c && ie !== null && we !== null) {
        const Me = $e.clientX - c[0], Ze = $e.clientY - c[1], ne = ie - -Me, rr = we - -Ze;
        m.value = [ne, rr];
      }
    }
  };
}
function dt(m, c, ie, we) {
  let $e = 0;
  return {
    handleGesturestart: (Me) => {
      $e = m.value;
    },
    handleGesturechange: (Me) => {
      if (c.value === !1)
        return;
      const Ze = Me.rotation;
      if (Ze === 0)
        return;
      const ne = we(Me.clientX, Me.clientY);
      ie(ne[0], ne[1], $e + Fe(Ze));
    },
    handleGestureend: (Me) => {
    }
  };
}
function ft({
  wrapperElementRef: m,
  canvasNaturalWidth: c,
  canvasNaturalHeight: ie,
  offset: we,
  bounds: $e,
  rotationEnabled: Me,
  minScale: Ze,
  maxScale: ne
}) {
  const { x: rr, y: gr, width: or, height: _r } = rt(m), Lr = computed(() => ({
    x: rr.value,
    y: gr.value,
    width: or.value,
    height: _r.value
  })), Ir = computed(() => rr.value + we.value.left), Ar = computed(() => gr.value + we.value.top), Rr = computed(() => or.value - we.value.left - we.value.right), Nr = computed(() => _r.value - we.value.top - we.value.bottom), Yr = computed(() => Rr.value / Nr.value), Vr = computed(() => c.value / ie.value), Xr = computed(() => Vr.value >= Yr.value ? Rr.value / c.value : Nr.value / ie.value), Wr = (() => {
    const sn = ref$1(0), $n = ref$1(0);
    return computed({
      get() {
        return [sn.value, $n.value];
      },
      set([rn, ji]) {
        const Kn = c.value * xi.value - Rr.value, In = ie.value * xi.value - Nr.value;
        if (Me.value || !$e.value)
          sn.value = rn, $n.value = ji;
        else {
          const Fn = -Kn, Po = Math.max(0, -Kn / 2), vn = -In, Vn = Math.max(0, -In / 2);
          sn.value = ce(rn, Fn, Po), $n.value = ce(ji, vn, Vn);
        }
      }
    });
  })(), si = (() => {
    const sn = ref$1(1);
    return computed({
      get() {
        return sn.value;
      },
      set($n) {
        sn.value = ce($n, Ze.value, ne.value);
      }
    });
  })(), li = (() => {
    const sn = ref$1(0);
    return computed({
      get() {
        return sn.value;
      },
      set($n) {
        sn.value = $n;
      }
    });
  })(), xi = computed(() => si.value * Xr.value), di = computed(() => [we.value.left + Wr.value[0], we.value.top + Wr.value[1]]), oi = computed(() => li.value), ci = ref$1(!1), vr = ref$1(0.3);
  let Ae = !1;
  function ze(sn, $n, rn, ji = !1) {
    const Kn = vi(sn, $n, rn, 0);
    si.value = sn, Wr.value = Kn, ci.value = ji, Ae = !0, nextTick$3(() => {
      Ae = !1;
    }), setTimeout(() => {
      ci.value = !1;
    }, vr.value * 1e3);
  }
  watch([oi, xi, di], () => {
    Ae || (ci.value = !1);
  });
  function Ue(sn, $n, rn) {
    const ji = vi(sn, [0.5, 0.5], [0.5, 0.5], 0), Kn = [
      we.value.left + ji[0] + c.value * (sn * Xr.value) * 0.5,
      we.value.top + ji[1] + ie.value * (sn * Xr.value) * 0.5
    ], In = Pr(0.5, 0.5, sn, $n, rn), Fn = In[0] - Kn[0], Po = In[1] - Kn[1];
    return [Fn, Po];
  }
  function tr() {
    const sn = Ue(si.value, [0, 0], li.value);
    return {
      x: he(Wr.value[0] + sn[0], 6),
      y: he(Wr.value[1] + sn[1], 6),
      scale: he(si.value, 6),
      rotate: he(Be(li.value), 6)
    };
  }
  const lr = computed({
    get() {
      return tr();
    },
    set(sn) {
      const $n = tr();
      if (sn.x === $n.x && sn.y === $n.y && sn.scale === $n.scale && sn.rotate === $n.rotate)
        return;
      const rn = Fe(sn.rotate), ji = Ue(sn.scale, [0, 0], rn);
      Wr.value = [sn.x - ji[0], sn.y - ji[1]], si.value = sn.scale, li.value = rn;
    }
  });
  function pr(sn, $n) {
    return [sn - Ir.value, $n - Ar.value];
  }
  function br(sn, $n) {
    const [rn, ji] = pr(sn, $n);
    return [rn / Rr.value, ji / Nr.value];
  }
  function nr(sn, $n) {
    const rn = [0, 0], ji = [sn - Wr.value[0], $n - Wr.value[1]], Kn = pe(ji, rn, -li.value), In = [Kn[0] / xi.value, Kn[1] / xi.value];
    return [In[0] / c.value, In[1] / ie.value];
  }
  function Pe(sn, $n) {
    const rn = pr(sn, $n);
    return nr(rn[0], rn[1]);
  }
  function ur(sn, $n) {
    const [rn, ji] = Pe(sn, $n);
    return [rn * c.value, ji * ie.value];
  }
  function Pr(sn, $n, rn, ji, Kn) {
    rn = rn ?? si.value, ji = ji ?? Wr.value, Kn = Kn ?? li.value;
    const In = [we.value.left, we.value.top], Fn = [
      we.value.left + c.value * (rn * Xr.value) * sn,
      we.value.top + ie.value * (rn * Xr.value) * $n
    ], Po = pe(Fn, In, Kn);
    return [Po[0] + ji[0], Po[1] + ji[1]];
  }
  function Hr(sn, $n) {
    const rn = sn / c.value, ji = $n / ie.value;
    return Pr(rn, ji);
  }
  function vi(sn, $n, rn, ji) {
    const Kn = c.value * Xr.value, In = ie.value * Xr.value, Fn = rn[0] * Kn * sn, Po = rn[1] * In * sn, vn = pe([Fn, Po], [0, 0], ji ?? li.value), Vn = $n[0] * Rr.value, Xo = $n[1] * Nr.value, Xn = Vn - vn[0], Yn = Xo - vn[1];
    return [Xn, Yn];
  }
  function Ti(sn, $n, rn) {
    const ji = rn, Kn = Ue(si.value, [0, 0], ji), In = [0 - Kn[0], 0 - Kn[1]], Fn = si.value, Po = Pr(sn, $n, Fn, In, ji), vn = Pr(sn, $n), Vn = vn[0] - Po[0], Xo = vn[1] - Po[1];
    Wr.value = [In[0] + Vn, In[1] + Xo], li.value = ji;
  }
  const { handleTouchend: wi, handleTouchmove: ii, handleTouchstart: mi } = lt({
    wrapperInnerWidth: Rr,
    wrapperInnerHeight: Nr,
    canvasNaturalWidth: c,
    canvasNaturalHeight: ie,
    translate: Wr,
    rotate: li,
    scale: si,
    offset: we,
    rotationEnabled: Me,
    minScale: Ze,
    maxScale: ne,
    naturalScale: Xr,
    clientCoordsToWrapperCoords: pr,
    getCanvasCoords: nr,
    calcProjectionTranslate: vi
  }), { handleWheel: ei } = it({
    scale: si,
    translate: Wr,
    minScale: Ze,
    maxScale: ne,
    relativeWrapperCoordinatesFromClientCoords: br,
    normalizeMatrixCoordinates: Pe,
    calcProjectionTranslate: vi
  }), { handleMousedown: Zr, handleMouseup: pi, handleMousemove: hi } = ct(Wr), { handleGesturestart: Oi, handleGesturechange: qi, handleGestureend: yn } = dt(
    li,
    Me,
    Ti,
    Pe
  );
  return {
    handleTouchend: wi,
    handleTouchmove: ii,
    handleTouchstart: mi,
    handleGesturestart: Oi,
    handleGesturechange: qi,
    handleGestureend: yn,
    translate: Wr,
    scale: si,
    rotate: li,
    renderingScale: xi,
    renderingTranslate: di,
    renderingRotate: oi,
    exposedTransform: lr,
    rotateCanvas: Ti,
    calcProjectionTranslate: vi,
    clientCoordsToWrapperCoords: pr,
    getCanvasCoords: nr,
    normalizeMatrixCoordinates: Pe,
    clientCoordinatesToCanvasCoordinates: ur,
    composePoint: Pr,
    compose: Hr,
    handleWheel: ei,
    applyTransform: ze,
    handleMousedown: Zr,
    handleMouseup: pi,
    handleMousemove: hi,
    wrapperBounds: Lr,
    transitionEnabled: ci,
    transitionDuration: vr,
    wrapperX: rr,
    wrapperY: gr,
    wrapperWidth: or,
    wrapperHeight: _r
  };
}
const vt = 0.996, ht = (m, c = vt) => m * c / (1 - c);
function pt(m) {
  return m[m.length - 1];
}
function mt(m) {
  return m.reduce((c, ie) => c + ie) / m.length;
}
const gt = (m, c, ie) => Math.min(Math.max(c, m), ie);
function ye(m, c) {
  if (m.length !== c.length)
    throw new Error("vectors must be same length");
  return m.map((ie, we) => ie + c[we]);
}
function Xe(m) {
  return Math.max(...m.map(Math.abs));
}
function re(m) {
  return Object.freeze(m), Object.values(m).forEach((c) => {
    c !== null && typeof c == "object" && !Object.isFrozen(c) && re(c);
  }), m;
}
function Mt() {
  const m = {};
  function c($e, Me) {
    return m[$e] = (m[$e] || []).concat(Me), () => ie($e, Me);
  }
  function ie($e, Me) {
    m[$e] = (m[$e] || []).filter((Ze) => Ze !== Me);
  }
  function we($e, Me) {
    $e in m && m[$e].forEach((Ze) => Ze(Me));
  }
  return re({
    on: c,
    off: ie,
    dispatch: we
  });
}
function wt(m) {
  let c = [];
  const ie = ($e) => ($e.addEventListener("wheel", m, { passive: !1 }), c.push($e), () => we($e)), we = ($e) => {
    $e.removeEventListener("wheel", m), c = c.filter((Me) => Me !== $e);
  };
  return re({
    observe: ie,
    unobserve: we,
    disconnect: () => {
      c.forEach(we);
    }
  });
}
const xt = 16 * 1.125, yt = typeof window < "u" && window.innerHeight || 800, be = [1, xt, yt];
function bt(m) {
  const c = m.deltaX * be[m.deltaMode], ie = m.deltaY * be[m.deltaMode], we = (m.deltaZ || 0) * be[m.deltaMode];
  return {
    timeStamp: m.timeStamp,
    axisDelta: [c, ie, we]
  };
}
const Pt = [-1, -1, -1];
function Et(m, c) {
  if (!c)
    return m;
  const ie = c === !0 ? Pt : c.map((we) => we ? -1 : 1);
  return {
    ...m,
    axisDelta: m.axisDelta.map((we, $e) => we * ie[$e])
  };
}
const Oe = 700, Tt = (m) => ({
  ...m,
  axisDelta: m.axisDelta.map((c) => gt(c, -Oe, Oe))
}), St = 0.6, Dt = 0.96, Ct = 2, Ge = 5, We = re({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), At = 400;
function Le() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: At
  };
}
function _t(m = {}) {
  const { on: c, off: ie, dispatch: we } = Mt();
  let $e = We, Me = Le(), Ze, ne = !1, rr;
  const gr = (vr) => {
    Array.isArray(vr) ? vr.forEach((Ae) => Ir(Ae)) : Ir(vr);
  }, or = (vr = {}) => Object.values(vr).some((Ae) => Ae == null) ? $e : $e = re({ ...We, ...$e, ...vr }), _r = (vr) => {
    const Ae = {
      event: Ze,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: Me.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: Me.axisVelocity,
      axisMovement: Me.axisMovement,
      get axisMovementProjection() {
        return ye(
          Ae.axisMovement,
          Ae.axisVelocity.map((ze) => ht(ze))
        );
      },
      ...vr
    };
    we("wheel", {
      ...Ae,
      previous: rr
    }), rr = Ae;
  }, Lr = (vr, Ae) => {
    const { preventWheelAction: ze } = $e, [Ue, tr, lr] = Ae;
    if (typeof ze == "boolean")
      return ze;
    switch (ze) {
      case "x":
        return Math.abs(Ue) >= vr;
      case "y":
        return Math.abs(tr) >= vr;
      case "z":
        return Math.abs(lr) >= vr;
      default:
        return !1;
    }
  }, Ir = (vr) => {
    const { axisDelta: Ae, timeStamp: ze } = Tt(
      Et(bt(vr), $e.reverseSign)
    ), Ue = Xe(Ae);
    if (vr.preventDefault && Lr(Ue, Ae) && vr.preventDefault(), Me.isStarted ? Me.isMomentum && Ue > Math.max(2, Me.lastAbsDelta * 2) && (xi(!0), si()) : si(), Ue === 0 && Object.is && Object.is(vr.deltaX, -0)) {
      ne = !0;
      return;
    }
    Ze = vr, Me.axisMovement = ye(Me.axisMovement, Ae), Me.lastAbsDelta = Ue, Me.scrollPointsToMerge.push({
      axisDelta: Ae,
      timeStamp: ze
    }), Ar(), _r({ axisDelta: Ae, isStart: !Me.isStartPublished }), Me.isStartPublished = !0, li();
  }, Ar = () => {
    Me.scrollPointsToMerge.length === Ct ? (Me.scrollPoints.unshift({
      axisDeltaSum: Me.scrollPointsToMerge.map((vr) => vr.axisDelta).reduce(ye),
      timeStamp: mt(Me.scrollPointsToMerge.map((vr) => vr.timeStamp))
    }), Nr(), Me.scrollPointsToMerge.length = 0, Me.scrollPoints.length = 1, Me.isMomentum || Xr()) : Me.isStartPublished || Rr();
  }, Rr = () => {
    Me.axisVelocity = pt(Me.scrollPointsToMerge).axisDelta.map((vr) => vr / Me.willEndTimeout);
  }, Nr = () => {
    const [vr, Ae] = Me.scrollPoints;
    if (!Ae || !vr)
      return;
    const ze = vr.timeStamp - Ae.timeStamp;
    if (ze <= 0)
      return;
    const Ue = vr.axisDeltaSum.map((lr) => lr / ze), tr = Ue.map((lr, pr) => lr / (Me.axisVelocity[pr] || 1));
    Me.axisVelocity = Ue, Me.accelerationFactors.push(tr), Yr(ze);
  }, Yr = (vr) => {
    let Ae = Math.ceil(vr / 10) * 10 * 1.2;
    Me.isMomentum || (Ae = Math.max(100, Ae * 2)), Me.willEndTimeout = Math.min(1e3, Math.round(Ae));
  }, Vr = (vr) => vr === 0 ? !0 : vr <= Dt && vr >= St, Xr = () => {
    if (Me.accelerationFactors.length >= Ge) {
      if (ne && (ne = !1, Xe(Me.axisVelocity) >= 0.2)) {
        Wr();
        return;
      }
      const vr = Me.accelerationFactors.slice(Ge * -1);
      vr.every((Ae) => {
        const ze = !!Ae.reduce((tr, lr) => tr && tr < 1 && tr === lr ? 1 : 0), Ue = Ae.filter(Vr).length === Ae.length;
        return ze || Ue;
      }) && Wr(), Me.accelerationFactors = vr;
    }
  }, Wr = () => {
    Me.isMomentum = !0;
  }, si = () => {
    Me = Le(), Me.isStarted = !0, Me.startTime = Date.now(), rr = void 0, ne = !1;
  }, li = (() => {
    let vr;
    return () => {
      clearTimeout(vr), vr = setTimeout(xi, Me.willEndTimeout);
    };
  })(), xi = (vr = !1) => {
    !Me.isStarted || (Me.isMomentum && vr ? _r({ isEnding: !0, isMomentumCancel: !0 }) : _r({ isEnding: !0 }), Me.isMomentum = !1, Me.isStarted = !1);
  }, { observe: di, unobserve: oi, disconnect: ci } = wt(gr);
  return or(m), re({
    on: c,
    off: ie,
    observe: di,
    unobserve: oi,
    disconnect: ci,
    feedWheel: gr,
    updateOptions: or
  });
}
const Rt = 10, Yt = 10, Xt = /* @__PURE__ */ defineComponent({
  __name: "Zoompinch",
  props: {
    transform: { default: () => ({ x: 0, y: 0, scale: 1, rotate: 0 }) },
    width: {},
    height: {},
    offset: { default: () => ({ left: 0, top: 0, right: 0, bottom: 0 }) },
    maxScale: { default: 10 },
    minScale: { default: 0.5 },
    bounds: { type: Boolean, default: !1 },
    rotation: { type: Boolean, default: !0 },
    mouse: { type: Boolean, default: !0 },
    wheel: { type: Boolean, default: !0 },
    touch: { type: Boolean, default: !0 },
    gesture: { type: Boolean, default: !0 }
  },
  emits: ["update:transform", "dragGestureStart", "dragGestureEnd"],
  setup(m, { expose: c, emit: ie }) {
    const we = m, $e = ie;
    console.log("!!!!!! ZOOMPINCH !!!!!!!", we);
    const Me = ref$1(), Ze = ref$1(), ne = ref$1(), rr = toRef(we, "width"), gr = toRef(we, "height"), or = toRef(we, "offset"), _r = computed(() => !we.bounds && we.rotation), {
      renderingTranslate: Lr,
      renderingRotate: Ir,
      renderingScale: Ar,
      composePoint: Rr,
      handleWheel: Nr,
      handleMousedown: Yr,
      handleMousemove: Vr,
      handleMouseup: Xr,
      handleTouchstart: Wr,
      handleTouchmove: si,
      handleTouchend: li,
      handleGesturestart: xi,
      handleGesturechange: di,
      handleGestureend: oi,
      applyTransform: ci,
      rotateCanvas: vr,
      compose: Ae,
      exposedTransform: ze,
      calcProjectionTranslate: Ue,
      clientCoordinatesToCanvasCoordinates: tr,
      normalizeMatrixCoordinates: lr,
      transitionEnabled: pr,
      transitionDuration: br,
      wrapperX: nr,
      wrapperY: Pe,
      wrapperWidth: ur,
      wrapperHeight: Pr
    } = ft({
      wrapperElementRef: Me,
      canvasNaturalWidth: rr,
      canvasNaturalHeight: gr,
      offset: or,
      bounds: toRef(we, "bounds"),
      rotationEnabled: _r,
      minScale: toRef(we, "minScale"),
      maxScale: toRef(we, "maxScale")
    });
    watch(ze, () => {
      (we.transform.rotate !== ze.value.rotate || we.transform.scale !== ze.value.scale || we.transform.x !== ze.value.x || we.transform.y !== ze.value.y) && $e("update:transform", ze.value);
    }), watch(
      () => we.transform,
      () => {
        ze.value = {
          x: we.transform.x,
          y: we.transform.y,
          scale: we.transform.scale,
          rotate: we.transform.rotate
        };
      },
      { deep: !0 }
    ), onMounted(() => {
    });
    const Hr = _t();
    Hr.on("wheel", (Kn) => {
      Kn.isStart && $e("dragGestureStart", Kn.event), Nr(Kn.event), Kn.isEnding && $e("dragGestureEnd", Kn.event);
    }), watch([Me, () => we.wheel], () => {
      Me.value && (we.wheel ? Hr.observe(Me.value) : Hr.disconnect());
    }), onUnmounted(() => {
      Hr.disconnect();
    });
    let vi = !1, Ti = null;
    const wi = (Kn) => {
      vi = !1, Ti = { x: Kn.touches[0].clientX, y: Kn.touches[0].clientY }, we.touch && ($e("dragGestureStart", Kn), Wr(Kn));
    }, ii = (Kn) => {
      Ti && Math.sqrt(
        Math.pow(Kn.touches[0].clientX - Ti.x, 2) + Math.pow(Kn.touches[0].clientY - Ti.y, 2)
      ) > Rt && (vi = !0), we.touch && si(Kn);
    }, mi = (Kn) => {
      we.touch && (li(Kn), Kn.composedPath().includes(Me.value) && vi && $e("dragGestureEnd", Kn));
    };
    let ei = !1, Zr = null;
    const pi = (Kn) => {
      ei = !1, Zr = { x: Kn.clientX, y: Kn.clientY }, we.mouse && ($e("dragGestureStart", Kn), Yr(Kn));
    }, hi = (Kn) => {
      Zr && Math.sqrt(Math.pow(Kn.clientX - Zr.x, 2) + Math.pow(Kn.clientY - Zr.y, 2)) > Yt && (ei = !0), we.mouse && Vr(Kn);
    }, Oi = (Kn) => {
      we.mouse && (Xr(Kn), Kn.composedPath().includes(Me.value) && ei && $e("dragGestureEnd", Kn));
    };
    function qi() {
      return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    }
    const yn = computed(() => !qi() && we.gesture), sn = (Kn) => {
      yn.value && xi(Kn);
    }, $n = (Kn) => {
      yn.value && di(Kn);
    }, rn = (Kn) => {
      yn.value && oi(Kn);
    };
    window.addEventListener("touchmove", ii), window.addEventListener("touchend", mi), window.addEventListener("mouseup", Oi), window.addEventListener("mousemove", hi), window.addEventListener("gesturechange", $n), window.addEventListener("gestureend", rn), onUnmounted(() => {
      window.removeEventListener("touchmove", ii), window.removeEventListener("touchend", mi), window.removeEventListener("mouseup", Oi), window.removeEventListener("mousemove", hi), window.removeEventListener("gesturechange", $n), window.removeEventListener("gestureend", rn);
    });
    const ji = computed(() => ({
      x: nr.value,
      y: Pe.value,
      width: ur.value,
      height: Pr.value
    }));
    return c({
      compose: Ae,
      composePoint: Rr,
      clientCoordinatesToCanvasCoordinates: tr,
      normalizeMatrixCoordinates: lr,
      applyTransform: ci,
      calcProjectionTranslate: Ue,
      rotateCanvas: vr,
      wrapperBounds: ji,
      canvas: Ze,
      matrix: ne
    }), (Kn, In) => (openBlock(), createElementBlock("div", {
      ref_key: "zoompinchRef",
      ref: Me,
      class: normalizeClass(["zoompinch", {
        "transition-enabled": unref(pr)
      }]),
      style: normalizeStyle({
        "--canvas-width": `${Kn.width}px`,
        "--canvas-height": `${Kn.height}px`,
        "--canvas-ratio": Kn.width / Kn.height,
        "--rendering-scale": unref(Ar),
        "--translate-x": `${unref(Lr)[0]}px`,
        "--translate-y": `${unref(Lr)[1]}px`,
        "--rotate": `${unref(Be)(unref(Ir))}deg`,
        "--offset-top": `${we.offset.top}px`,
        "--offset-right": `${we.offset.right}px`,
        "--offset-bottom": `${we.offset.bottom}px`,
        "--offset-left": `${we.offset.left}px`,
        "--transition-duration": `${unref(br)}s`
      }),
      onTouchstart: wi,
      onMousedown: pi,
      onGesturestart: sn
    }, [
      createElementVNode("div", {
        ref_key: "canvasRef",
        ref: Ze,
        class: "canvas"
      }, [
        renderSlot(Kn.$slots, "canvas", {}, void 0, !0)
      ], 512),
      createElementVNode("div", {
        ref_key: "matrixRef",
        ref: ne,
        class: "matrix"
      }, [
        renderSlot(Kn.$slots, "matrix", {
          composePoint: unref(Rr),
          compose: unref(Ae),
          clientCoordinatesToCanvasCoordinates: unref(tr),
          normalizeMatrixCoordinates: unref(lr)
        }, void 0, !0)
      ], 512)
    ], 38));
  }
}), Ot = (m, c) => {
  const ie = m.__vccOpts || m;
  for (const [we, $e] of c)
    ie[we] = $e;
  return ie;
}, Wt = /* @__PURE__ */ Ot(Xt, [["__scopeId", "data-v-55dbc0c0"]]), style = "", _hoisted_1$g = {
  key: 0,
  class: "error-wrapper"
}, _hoisted_2$c = { class: "error-symbol" }, _hoisted_3$8 = { class: "error-message" }, _hoisted_4$5 = { key: 0 }, _hoisted_5$4 = { key: 1 }, _hoisted_6$3 = { class: "error-actions" }, _hoisted_7$3 = { xmlns: "http://www.w3.org/2000/svg" }, _hoisted_8$3 = {
  key: 0,
  class: "scrollbar scrollbar-x"
}, _hoisted_9$3 = {
  key: 1,
  class: "scrollbar scrollbar-y"
}, _hoisted_10$3 = {
  key: 2,
  class: "segment-navigation-wrapper-x"
}, _hoisted_11$3 = { class: "frame-dots" }, _hoisted_12$2 = ["onClick"], _hoisted_13$2 = {
  key: 3,
  class: "segment-navigation-wrapper-y"
}, _hoisted_14$2 = { class: "frame-dots" }, _hoisted_15$2 = ["onClick"], _hoisted_16$2 = {
  key: 4,
  class: "fit-btn-wrapper"
}, _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "BluepicLiveTemplate",
  props: /* @__PURE__ */ mergeModels({
    templateId: {},
    studioResourcesBaseUrl: {},
    cloudflarePagesHostname: {},
    bxCoreVersion: {},
    authorization: {},
    asyncSerial: { type: Boolean },
    resolution: {},
    webgl: { type: Boolean },
    fonts: {},
    zoomAndPan: { type: Boolean, default: !0 },
    baseSerial: {},
    watermark: {},
    scrollbars: { type: Boolean, default: !0 },
    offset: {}
  }, {
    data: {
      required: !0
    },
    dataModifiers: {},
    serial: {
      required: !1
    },
    serialModifiers: {},
    ready: { type: Boolean, required: !1 },
    readyModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["matrix-click"], ["update:data", "update:serial", "update:ready"]),
  setup(m, { expose: c, emit: ie }) {
    const we = ie, $e = useModel(m, "data"), Me = useModel(m, "serial"), Ze = useModel(m, "ready"), ne = ref$1(), rr = ref$1(), gr = ref$1(), or = ref$1(), { width: _r, height: Lr } = useElementBounding(or), Ir = computed(() => _r.value / Lr.value), Ar = computed(() => {
      if (!!Me.value)
        return Me.value.width / Me.value.height;
    }), Rr = computed(() => {
      if (!!Ar.value)
        return Ar.value > Ir.value ? "width" : "height";
    }), Nr = ref$1({
      x: 0,
      y: 0,
      scale: 1,
      rotate: 0
    });
    window.transform = Nr;
    function Yr($n) {
      const rn = gr.value?.normalizeMatrixCoordinates($n.clientX, $n.clientY);
      if (!rn || !Me.value)
        return;
      const ji = rn[0] * Me.value.width, Kn = rn[1] * Me.value.height;
      we("matrix-click", { x: ji, y: Kn });
    }
    const Vr = computed(() => Me.value?.frames ?? { x: 1, y: 1 }), Xr = ref$1([0, 0]);
    window.focusedFrame = Xr, window.zoompinchRef = gr;
    const Wr = computed(() => gr.value?.wrapperBounds), si = computed(() => {
      if (Me.value)
        return Me.value.width / Me.value.height;
    }), li = computed(() => {
      if (Wr.value)
        return Wr.value.width / Wr.value.height;
    }), xi = computed(() => {
      if (si.value && li.value)
        return si.value > li.value ? "width" : "height";
    }), di = computed(() => {
      if (si.value && li.value)
        return li.value < si.value ? si.value / li.value : li.value / si.value;
    }), oi = computed(() => {
      if (si.value)
        return si.value / (Vr.value.x / Vr.value.y);
    }), ci = computed(() => {
      if (oi.value && li.value)
        return oi.value > li.value ? "width" : "height";
    }), vr = computed(() => {
      if (!!di.value)
        if (ci.value === xi.value) {
          if (ci.value === "height")
            return Vr.value.y;
          if (ci.value === "width")
            return Vr.value.x;
        } else {
          if (ci.value === "height")
            return di.value * Vr.value.y;
          if (ci.value === "width")
            return di.value * Vr.value.x;
        }
    });
    function Ae($n, rn) {
      const ji = vr.value;
      if (!Wr.value || !si.value || !ji)
        return;
      const Kn = xi.value === "width" ? Wr.value?.width : Wr.value?.height / si.value, In = xi.value === "height" ? Wr.value?.height : Wr.value?.width * si.value, Fn = Kn * ji, Po = In * ji, vn = Fn / 2, Vn = Po / 2, Xo = Fn / Vr.value.x, Xn = Po / Vr.value.y, Yn = vn - Xo * 0.5 - Xo * $n, Wo = Vn - Xn * 0.5 - Xn * rn;
      return {
        rotate: 0,
        scale: ji,
        x: Yn,
        y: Wo
      };
    }
    const ze = computed(() => Object.values(Me.value?.frames ?? { x: 1, y: 1 }).reduce(($n, rn) => rn * $n, 1) > 1);
    function Ue() {
      if (!Wr.value || !Nr.value || !si.value) {
        console.error("We can't calculate the focused frame if we don't have the necessary data");
        return;
      }
      const $n = Ae(0, 0);
      if (!$n) {
        console.error("no target transform");
        return;
      }
      if (round$3($n.scale, 6) !== Nr.value.scale) {
        console.error("The scale is not adjusted, we can't calculate the focused frame in a way that makes sense");
        return;
      }
      const rn = ($n.x - $n.scale * Wr.value.width / 2) / ($n.scale * Wr.value.width / Vr.value.x), ji = ($n.y - $n.scale * Wr.value.height / 2) / ($n.scale * Wr.value.height / Vr.value.y);
      return [rn, ji];
    }
    const tr = computed(() => {
      if (!Wr.value || !Nr.value || !si.value)
        return;
      const $n = xi.value === "width" ? Wr.value.width : Wr.value.height * si.value, ji = (xi.value === "height" ? Wr.value.height : Wr.value.width / si.value) / 2 * Nr.value.scale - Wr.value.height / 2, Kn = $n / 2 * Nr.value.scale - Wr.value.width / 2, In = -Kn, Fn = -ji;
      return {
        top: ji,
        right: In,
        bottom: Fn,
        left: Kn
      };
    }), lr = computed(() => {
      if (!!tr.value)
        return [
          (Nr.value.x - tr.value.left) / (tr.value.right - tr.value.left),
          (Nr.value.y - tr.value.top) / (tr.value.bottom - tr.value.top)
        ];
    }), pr = computed(() => {
      if (!!vr.value)
        return Math.abs(1 - Nr.value.scale / vr.value);
    }), br = computed(() => {
      if (pr.value === void 0 || pr.value > 0.25 || !lr.value)
        return;
      const $n = Array.from({ length: Vr.value.x * Vr.value.y }, (vn, Vn) => {
        const Xo = Vn % Vr.value.x, Xn = Math.floor(Vn / Vr.value.x);
        return {
          x: Xo,
          y: Xn,
          transform: Ae(Xo, Xn)
        };
      }).filter(({ transform: vn }) => vn), rn = Nr.value.x, ji = Nr.value.y, Kn = $n.map(({ x: vn, transform: Vn }) => ({
        index: vn,
        distance: Math.abs(Vn.x - rn)
      })), In = $n.map(({ y: vn, transform: Vn }) => ({
        index: vn,
        distance: Math.abs(Vn.y - ji)
      })), Fn = Kn.reduce((vn, Vn) => vn.distance < Vn.distance ? vn : Vn), Po = In.reduce((vn, Vn) => vn.distance < Vn.distance ? vn : Vn);
      return {
        x: Fn,
        y: Po
      };
    }), nr = computed(() => {
      if (!!br.value)
        return {
          x: br.value.x.index + 1,
          y: br.value.y.index + 1
        };
    }), Pe = computed(() => {
      if (Wr.value)
        return xi.value === "height" ? 1 : Wr.value.height / Wr.value.width;
    }), ur = computed(() => {
      if (Wr.value)
        return xi.value === "width" ? 1 : Wr.value.width / Wr.value.height;
    });
    window.getTransformToFocusFrame = Ae, window.calcCurrFocusedFrame = Ue, window.bluepicEmbeddedRef = rr;
    const Pr = computed(() => {
      if (!!Nr.value)
        return Nr.value.scale !== 1 || Nr.value.x !== 0 || Nr.value.y !== 0 || Nr.value.rotate !== 0;
    }), Hr = () => {
      gr.value?.applyTransform(1, [0.5, 0.5], [0.5, 0.5], !0);
    };
    function vi($n, rn) {
      if (!vr.value)
        return;
      const ji = 1 / Vr.value.x, Kn = 1 / Vr.value.y, In = ($n - 1) * ji + ji / 2, Fn = (rn - 1) * Kn + Kn / 2;
      gr.value?.applyTransform(vr.value, [0.5, 0.5], [In, Fn], !0);
    }
    function Ti($n, rn) {
      const ji = nr.value?.y ?? 1;
      vi($n, ji), rn.stopPropagation();
    }
    function wi($n, rn) {
      const ji = nr.value?.x ?? 1;
      vi(ji, $n), rn.stopPropagation();
    }
    function ii({ clientX: $n, clientY: rn }) {
      const ji = gr.value?.normalizeMatrixCoordinates($n, rn);
      if (!ji)
        return console.error("no matrix coords. This should not happen");
      const Kn = Math.min(
        Vr.value.x,
        Math.max(0, Math.trunc(ji[0] / (1 / Vr.value.x)) + 1)
      ), In = Math.min(
        Vr.value.y,
        Math.max(0, Math.trunc(ji[1] / (1 / Vr.value.y)) + 1)
      );
      if (nr.value) {
        const Fn = Ae(nr.value.x, nr.value.y);
        if (!Fn)
          return console.error("no perfect frame fitting transform. This should not happen");
        if (!br.value)
          return console.error("no closest frame descriptor. This should not happen");
        const Po = round$3(Fn?.scale, 6) === round$3(Nr.value.scale, 6), vn = round$3(Fn?.rotate, 6) === round$3(Nr.value.rotate, 6), Vn = Math.abs(br.value.x.distance) + Math.abs(br.value.y.distance);
        if (Po && vn && Vn !== void 0 && Vn < 5 && Kn === nr.value.x && In === nr.value.y)
          return Hr();
      }
      vi(Kn, In);
    }
    const mi = ref$1();
    function ei($n) {
      mi.value = $n;
    }
    function Zr() {
      mi.value = void 0;
    }
    const pi = ref$1(), hi = ($n) => {
      const rn = Date.now();
      pi.value && rn - pi.value < 300 && ii({ clientX: $n.changedTouches[0].clientX, clientY: $n.changedTouches[0].clientY }), pi.value = rn;
    };
    watch([Ze, vr], () => {
      Ze.value && vr.value && gr.value?.applyTransform(1, [0.5, 0.5], [0.5, 0.5], !0);
    });
    let Oi, qi;
    function yn() {
      Oi = nr.value?.x ?? 1, qi = nr.value?.y ?? 1;
    }
    function sn($n) {
      if (ze.value) {
        const rn = nr.value?.x, ji = nr.value?.y;
        vi(rn ?? Oi, ji ?? qi);
      }
    }
    return watch(Me, () => {
      setTimeout(() => {
        Nr.value = { x: 0, y: 0, scale: 1, rotate: 0 };
      });
    }), c({
      aspectRatio: Ar,
      aspectRatioSizingSide: Rr,
      bluepicLiveTemplateRootWidth: _r,
      bluepicLiveTemplateRootHeight: Lr,
      bluepicEmbeddedRef: rr,
      zoompinchRef: gr,
      isMultiFrame: ze,
      ready: Ze,
      transform: Nr,
      innerScroll: lr,
      focusedFrame: Xr,
      calcCurrFocusedFrame: Ue,
      getTransformToFocusFrame: Ae,
      applyTranformBasedOnFrame: vi,
      closestFrame: nr,
      globalScope: ne
    }), ($n, rn) => (openBlock(), createElementBlock("div", {
      ref_key: "bluepicLiveTemplateRootRef",
      ref: or,
      class: normalizeClass(["bluepic-live-template", {
        [`aspect-ratio-sizing-side-${Rr.value}`]: !0,
        "zoom-and-pan": $n.zoomAndPan,
        "is-ready": Ze.value || !0
      }]),
      style: normalizeStyle({ "--aspect-ratio": Ar.value }),
      onClick: Yr,
      onDblclick: ii,
      onTouchend: hi
    }, [
      mi.value !== void 0 ? (openBlock(), createElementBlock("div", _hoisted_1$g, [
        createVNode(BxCard, null, {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_2$c, [
              createVNode(unref(BxIcon), null, {
                default: withCtx(() => [
                  createVNode(unref(BandageOutline))
                ]),
                _: 1
              })
            ]),
            createElementVNode("div", _hoisted_3$8, [
              mi.value === 2 ? (openBlock(), createElementBlock("span", _hoisted_4$5, " You're not allowed to view this template. ")) : (openBlock(), createElementBlock("span", _hoisted_5$4, " Embed Template is still processing. Please retry in 3 minutes. "))
            ]),
            createElementVNode("div", _hoisted_6$3, [
              createVNode(unref(BxButton), {
                round: "",
                onClick: Zr
              }, {
                icon: withCtx(() => [
                  createVNode(unref(BxIcon), null, {
                    default: withCtx(() => [
                      createVNode(unref(RefreshOutline))
                    ]),
                    _: 1
                  })
                ]),
                default: withCtx(() => [
                  rn[5] || (rn[5] = createTextVNode(" Retry "))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])) : (openBlock(), createBlock(unref(Wt), {
        key: 1,
        ref_key: "zoompinchRef",
        ref: gr,
        transform: Nr.value,
        "onUpdate:transform": rn[4] || (rn[4] = (ji) => Nr.value = ji),
        width: Me.value ? Me.value.width : 1080,
        height: Me.value ? Me.value.height : 1080,
        offset: $n.offset,
        "min-scale": 0.1,
        "max-scale": 10,
        rotation: !1,
        bounds: !1,
        mouse: $n.zoomAndPan,
        touch: $n.zoomAndPan,
        wheel: $n.zoomAndPan,
        gesture: "",
        onDragGestureStart: yn,
        onDragGestureEnd: sn
      }, {
        canvas: withCtx(() => [
          createVNode(BluepicEmbedded, {
            ref_key: "bluepicEmbeddedRef",
            ref: rr,
            "template-id": $n.templateId,
            "studio-resources-base-url": $n.studioResourcesBaseUrl,
            "cloudflare-pages-hostname": $n.cloudflarePagesHostname,
            "bx-core-version": $n.bxCoreVersion,
            authorization: $n.authorization,
            "async-serial": $n.asyncSerial,
            resolution: $n.resolution,
            webgl: $n.webgl,
            fonts: $n.fonts,
            "base-serial": $n.baseSerial,
            data: $e.value,
            "onUpdate:data": rn[0] || (rn[0] = (ji) => $e.value = ji),
            serial: Me.value,
            "onUpdate:serial": rn[1] || (rn[1] = (ji) => Me.value = ji),
            ready: Ze.value,
            "onUpdate:ready": rn[2] || (rn[2] = (ji) => Ze.value = ji),
            "global-scope": ne.value,
            "onUpdate:globalScope": rn[3] || (rn[3] = (ji) => ne.value = ji),
            onError: ei
          }, null, 8, ["template-id", "studio-resources-base-url", "cloudflare-pages-hostname", "bx-core-version", "authorization", "async-serial", "resolution", "webgl", "fonts", "base-serial", "data", "serial", "ready", "global-scope"])
        ]),
        matrix: withCtx(({ composePoint: ji }) => [
          $n.watermark ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["watermark", {}])
          }, [
            (openBlock(), createElementBlock(Fragment, null, renderList(32, (Kn) => createElementVNode("div", null, [
              (openBlock(), createElementBlock(Fragment, null, renderList(32, (In) => createElementVNode("span", null, toDisplayString($n.watermark), 1)), 64))
            ])), 64))
          ])) : createCommentVNode("", !0),
          (openBlock(), createElementBlock("svg", _hoisted_7$3, [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(Array.from({ length: Vr.value.y }, (Kn, In) => In), (Kn) => (openBlock(), createElementBlock(Fragment, null, [], 64))), 256)),
            renderSlot($n.$slots, "matrix", { composePoint: ji }, void 0, !0)
          ])),
          renderSlot($n.$slots, "matrix", { composePoint: ji }, void 0, !0),
          $n.scrollbars && lr.value && ur.value && Pe.value ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: "controls-layer",
            style: normalizeStyle({
              "--scale": Nr.value.scale,
              "--cover-scale-x": ur.value,
              "--cover-scale-y": Pe.value,
              "--inner-scroll-x": lr.value[0],
              "--inner-scroll-y": lr.value[1]
            })
          }, [
            Nr.value.scale > ur.value ? (openBlock(), createElementBlock("div", _hoisted_8$3)) : createCommentVNode("", !0),
            Nr.value.scale > Pe.value ? (openBlock(), createElementBlock("div", _hoisted_9$3)) : createCommentVNode("", !0),
            Vr.value.x > 1 ? (openBlock(), createElementBlock("div", _hoisted_10$3, [
              createElementVNode("div", _hoisted_11$3, [
                (openBlock(!0), createElementBlock(Fragment, null, renderList(Vr.value.x, (Kn) => (openBlock(), createElementBlock("div", {
                  class: normalizeClass(["frame-dot", { active: nr.value?.x === Kn, disabled: !nr.value }]),
                  onClick: (In) => Ti(Kn, In)
                }, null, 10, _hoisted_12$2))), 256))
              ])
            ])) : createCommentVNode("", !0),
            Vr.value.y > 1 ? (openBlock(), createElementBlock("div", _hoisted_13$2, [
              createElementVNode("div", _hoisted_14$2, [
                (openBlock(!0), createElementBlock(Fragment, null, renderList(Vr.value.y, (Kn) => (openBlock(), createElementBlock("div", {
                  class: normalizeClass(["frame-dot", { active: nr.value?.y === Kn, disabled: !nr.value }]),
                  onClick: (In) => wi(Kn, In)
                }, null, 10, _hoisted_15$2))), 256))
              ])
            ])) : createCommentVNode("", !0),
            Pr.value ? (openBlock(), createElementBlock("div", _hoisted_16$2, [
              createVNode(unref(BxButton), {
                circle: "",
                tertiary: "",
                onClick: Hr
              }, {
                icon: withCtx(() => [
                  createVNode(unref(BxIcon), null, {
                    default: withCtx(() => [
                      createVNode(unref(ExpandOutline))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])) : createCommentVNode("", !0)
          ], 4)) : createCommentVNode("", !0)
        ]),
        _: 3
      }, 8, ["transform", "width", "height", "offset", "mouse", "touch", "wheel"]))
    ], 38));
  }
}), BluepicLiveTemplate_vue_vue_type_style_index_0_scoped_9c93c6d4_lang = "", BluepicLiveTemplate_vue_vue_type_style_index_1_scoped_9c93c6d4_lang = "", BluepicLiveTemplate = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["__scopeId", "data-v-9c93c6d4"]]), _hoisted_1$f = { class: "label" }, _hoisted_2$b = { class: "field-wrapper" }, _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "KioskField",
  props: {
    serial: {},
    field: {},
    composePoint: { type: Function }
  },
  setup(m) {
    const c = m, ie = ref$1(), we = ref$1(), $e = reactive({ x: 0, y: 0 });
    function Me() {
      !ie.value || !we.value || computePosition(ie.value, ie.value, {
        middleware: [autoPlacement(), offset(10)]
      }).then((Ar) => {
        $e.x = Ar.x, $e.y = Ar.y;
      });
    }
    const Ze = computed(() => {
      if (c.field.hitbox) {
        const [Ar, Rr] = c.composePoint(c.field.hitbox.x / c.serial.width, c.field.hitbox.y / c.serial.height), [Nr, Yr] = c.composePoint(
          (c.field.hitbox.x + c.field.hitbox.width) / c.serial.width,
          (c.field.hitbox.y + c.field.hitbox.height) / c.serial.height
        );
        return {
          x: Ar,
          y: Rr,
          width: Nr - Ar,
          height: Yr - Rr
        };
      }
    }), ne = computed(() => getFieldDescription(c.field)), rr = computed(() => {
      if (c.field.hitbox) {
        const [Ar, Rr] = c.composePoint(
          c.field.hitbox.x / c.serial.width,
          c.field.hitbox.y / c.serial.height
        ), [Nr, Yr] = c.composePoint(
          (c.field.hitbox.x + c.field.hitbox.width) / c.serial.width,
          (c.field.hitbox.y + c.field.hitbox.height) / c.serial.height
        );
        return `${Nr - Ar}px`;
      }
      return "100%";
    });
    watch(
      () => c.field,
      () => {
        nextTick$3(() => {
          Me();
        });
      },
      { immediate: !0 }
    );
    const { fields: gr, data: or, bridge: _r, modelField: Lr, wrapFieldProps: Ir } = useFields(computed(() => [c.field]));
    return (Ar, Rr) => (openBlock(), createElementBlock(Fragment, null, [
      Ze.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        ref_key: "hitboxAnchorRef",
        ref: ie,
        class: "hitbox-anchor",
        style: normalizeStyle({
          "--x": `${Ze.value.x}px`,
          "--y": `${Ze.value.y}px`,
          "--width": `${Ze.value.width}px`,
          "--height": `${Ze.value.height}px`
        })
      }, null, 4)) : createCommentVNode("", !0),
      createElementVNode("div", {
        ref_key: "kioskFieldWindowRef",
        ref: we,
        class: normalizeClass(["kiosk-field", { "no-hitbox-pos": !Ar.field.hitbox }]),
        style: normalizeStyle({ "--max-width": rr.value, "--x": `${$e.x}px`, "--y": `${$e.y}px` })
      }, [
        createElementVNode("header", null, [
          createVNode(BxIcon, null, {
            default: withCtx(() => [
              (openBlock(), createBlock(resolveDynamicComponent(unref(renderFieldIcon)(c.field.type, !1))))
            ]),
            _: 1
          }),
          createElementVNode("div", _hoisted_1$f, toDisplayString(ne.value), 1)
        ]),
        createElementVNode("main", null, [
          createElementVNode("div", _hoisted_2$b, [
            Ar.field.type in BluepciFieldComponents ? (openBlock(), createBlock(resolveDynamicComponent(BluepciFieldComponents[Ar.field.type]), normalizeProps(mergeProps({ key: 0 }, {
              ...unref(Ir)(Ar.field.props),
              ...unref(Lr)(Ar.field.model),
              description: ne.value,
              detailedDescription: Ar.field.detailedDescription,
              field: Ar.field,
              mobile: !1
            })), null, 16)) : createCommentVNode("", !0)
          ])
        ])
      ], 6)
    ], 64));
  }
}), KioskField_vue_vue_type_style_index_0_scoped_f468be80_lang = "", KioskField = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["__scopeId", "data-v-f468be80"]]), _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "SlidesNavigation",
  props: /* @__PURE__ */ mergeModels({
    length: {}
  }, {
    index: {
      required: !0
    },
    indexModifiers: {}
  }),
  emits: ["update:index"],
  setup(m) {
    const c = useModel(m, "index"), ie = m, we = ref$1(), { width: $e } = useElementBounding(we);
    function Me(_r) {
      c.value = _r;
    }
    function Ze() {
      c.value = Math.max(1, c.value - 1);
    }
    function ne() {
      c.value = Math.min(ie.length, c.value + 1);
    }
    const rr = computed(() => Math.max(0, Math.trunc($e.value / (26 + 5)) - 2)), gr = computed(() => Math.max(0, ie.length > rr.value ? rr.value - 1 : ie.length)), or = computed(() => {
      if (gr.value < ie.length)
        return Array(ie.length - rr.value).fill(0).map((_r, Lr) => ({
          label: `${Lr + rr.value}`,
          value: Lr + rr.value
        }));
    });
    return (_r, Lr) => (openBlock(), createElementBlock("div", {
      ref_key: "slidesNavigationWrapperRef",
      ref: we,
      class: "slides-navigation"
    }, [
      createVNode(BxButton, {
        circle: "",
        onClick: Ze,
        size: "small",
        disabled: c.value <= 1
      }, {
        icon: withCtx(() => [
          createVNode(BxIcon, null, {
            default: withCtx(() => [
              createVNode(unref(ChevronBackOutline))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["disabled"]),
      (openBlock(!0), createElementBlock(Fragment, null, renderList(gr.value, (Ir) => (openBlock(), createBlock(BxButton, {
        key: Ir,
        secondary: c.value === Ir,
        circle: "",
        onClick: (Ar) => Me(Ir),
        size: "small"
      }, {
        icon: withCtx(() => [
          createVNode(BxIcon, null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(Ir), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["secondary", "onClick"]))), 128)),
      or.value ? (openBlock(), createBlock(BxSelect, {
        key: 0,
        options: or.value,
        modelValue: c.value,
        "onUpdate:modelValue": Lr[0] || (Lr[0] = (Ir) => c.value = Ir)
      }, {
        trigger: withCtx(() => [
          createVNode(BxButton, {
            circle: "",
            size: "small",
            secondary: c.value > gr.value
          }, {
            icon: withCtx(() => [
              createVNode(BxIcon, null, {
                default: withCtx(() => Lr[1] || (Lr[1] = [
                  createTextVNode(" ... ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["secondary"])
        ]),
        _: 1
      }, 8, ["options", "modelValue"])) : createCommentVNode("", !0),
      createVNode(BxButton, {
        circle: "",
        onClick: ne,
        size: "small",
        disabled: c.value >= _r.length
      }, {
        icon: withCtx(() => [
          createVNode(BxIcon, null, {
            default: withCtx(() => [
              createVNode(unref(ChevronForwardOutline))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 512));
  }
}), SlidesNavigation_vue_vue_type_style_index_0_scoped_afb2cc1e_lang = "", SlidesNavigation = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["__scopeId", "data-v-afb2cc1e"]]);
function isObject$2(m) {
  return m !== null && typeof m == "object" && "constructor" in m && m.constructor === Object;
}
function extend$2(m, c) {
  m === void 0 && (m = {}), c === void 0 && (c = {}), Object.keys(c).forEach((ie) => {
    typeof m[ie] > "u" ? m[ie] = c[ie] : isObject$2(c[ie]) && isObject$2(m[ie]) && Object.keys(c[ie]).length > 0 && extend$2(m[ie], c[ie]);
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  const m = typeof document < "u" ? document : {};
  return extend$2(m, ssrDocument), m;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function m() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(m) {
    return typeof setTimeout > "u" ? (m(), null) : setTimeout(m, 0);
  },
  cancelAnimationFrame(m) {
    typeof setTimeout > "u" || clearTimeout(m);
  }
};
function getWindow() {
  const m = typeof window < "u" ? window : {};
  return extend$2(m, ssrWindow), m;
}
function classesToTokens(m) {
  return m === void 0 && (m = ""), m.trim().split(" ").filter((c) => !!c.trim());
}
function deleteProps(m) {
  const c = m;
  Object.keys(c).forEach((ie) => {
    try {
      c[ie] = null;
    } catch {
    }
    try {
      delete c[ie];
    } catch {
    }
  });
}
function nextTick(m, c) {
  return c === void 0 && (c = 0), setTimeout(m, c);
}
function now() {
  return Date.now();
}
function getComputedStyle$1(m) {
  const c = getWindow();
  let ie;
  return c.getComputedStyle && (ie = c.getComputedStyle(m, null)), !ie && m.currentStyle && (ie = m.currentStyle), ie || (ie = m.style), ie;
}
function getTranslate(m, c) {
  c === void 0 && (c = "x");
  const ie = getWindow();
  let we, $e, Me;
  const Ze = getComputedStyle$1(m);
  return ie.WebKitCSSMatrix ? ($e = Ze.transform || Ze.webkitTransform, $e.split(",").length > 6 && ($e = $e.split(", ").map((ne) => ne.replace(",", ".")).join(", ")), Me = new ie.WebKitCSSMatrix($e === "none" ? "" : $e)) : (Me = Ze.MozTransform || Ze.OTransform || Ze.MsTransform || Ze.msTransform || Ze.transform || Ze.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), we = Me.toString().split(",")), c === "x" && (ie.WebKitCSSMatrix ? $e = Me.m41 : we.length === 16 ? $e = parseFloat(we[12]) : $e = parseFloat(we[4])), c === "y" && (ie.WebKitCSSMatrix ? $e = Me.m42 : we.length === 16 ? $e = parseFloat(we[13]) : $e = parseFloat(we[5])), $e || 0;
}
function isObject$1(m) {
  return typeof m == "object" && m !== null && m.constructor && Object.prototype.toString.call(m).slice(8, -1) === "Object";
}
function isNode(m) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? m instanceof HTMLElement : m && (m.nodeType === 1 || m.nodeType === 11);
}
function extend$1() {
  const m = Object(arguments.length <= 0 ? void 0 : arguments[0]), c = ["__proto__", "constructor", "prototype"];
  for (let ie = 1; ie < arguments.length; ie += 1) {
    const we = ie < 0 || arguments.length <= ie ? void 0 : arguments[ie];
    if (we != null && !isNode(we)) {
      const $e = Object.keys(Object(we)).filter((Me) => c.indexOf(Me) < 0);
      for (let Me = 0, Ze = $e.length; Me < Ze; Me += 1) {
        const ne = $e[Me], rr = Object.getOwnPropertyDescriptor(we, ne);
        rr !== void 0 && rr.enumerable && (isObject$1(m[ne]) && isObject$1(we[ne]) ? we[ne].__swiper__ ? m[ne] = we[ne] : extend$1(m[ne], we[ne]) : !isObject$1(m[ne]) && isObject$1(we[ne]) ? (m[ne] = {}, we[ne].__swiper__ ? m[ne] = we[ne] : extend$1(m[ne], we[ne])) : m[ne] = we[ne]);
      }
    }
  }
  return m;
}
function setCSSProperty(m, c, ie) {
  m.style.setProperty(c, ie);
}
function animateCSSModeScroll(m) {
  let {
    swiper: c,
    targetPosition: ie,
    side: we
  } = m;
  const $e = getWindow(), Me = -c.translate;
  let Ze = null, ne;
  const rr = c.params.speed;
  c.wrapperEl.style.scrollSnapType = "none", $e.cancelAnimationFrame(c.cssModeFrameID);
  const gr = ie > Me ? "next" : "prev", or = (Lr, Ir) => gr === "next" && Lr >= Ir || gr === "prev" && Lr <= Ir, _r = () => {
    ne = new Date().getTime(), Ze === null && (Ze = ne);
    const Lr = Math.max(Math.min((ne - Ze) / rr, 1), 0), Ir = 0.5 - Math.cos(Lr * Math.PI) / 2;
    let Ar = Me + Ir * (ie - Me);
    if (or(Ar, ie) && (Ar = ie), c.wrapperEl.scrollTo({
      [we]: Ar
    }), or(Ar, ie)) {
      c.wrapperEl.style.overflow = "hidden", c.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        c.wrapperEl.style.overflow = "", c.wrapperEl.scrollTo({
          [we]: Ar
        });
      }), $e.cancelAnimationFrame(c.cssModeFrameID);
      return;
    }
    c.cssModeFrameID = $e.requestAnimationFrame(_r);
  };
  _r();
}
function elementChildren(m, c) {
  c === void 0 && (c = "");
  const ie = getWindow(), we = [...m.children];
  return ie.HTMLSlotElement && m instanceof HTMLSlotElement && we.push(...m.assignedElements()), c ? we.filter(($e) => $e.matches(c)) : we;
}
function elementIsChildOfSlot(m, c) {
  const ie = [c];
  for (; ie.length > 0; ) {
    const we = ie.shift();
    if (m === we)
      return !0;
    ie.push(...we.children, ...we.shadowRoot?.children || [], ...we.assignedElements?.() || []);
  }
}
function elementIsChildOf(m, c) {
  const ie = getWindow();
  let we = c.contains(m);
  return !we && ie.HTMLSlotElement && c instanceof HTMLSlotElement && (we = [...c.assignedElements()].includes(m), we || (we = elementIsChildOfSlot(m, c))), we;
}
function showWarning(m) {
  try {
    console.warn(m);
    return;
  } catch {
  }
}
function createElement(m, c) {
  c === void 0 && (c = []);
  const ie = document.createElement(m);
  return ie.classList.add(...Array.isArray(c) ? c : classesToTokens(c)), ie;
}
function elementOffset(m) {
  const c = getWindow(), ie = getDocument(), we = m.getBoundingClientRect(), $e = ie.body, Me = m.clientTop || $e.clientTop || 0, Ze = m.clientLeft || $e.clientLeft || 0, ne = m === c ? c.scrollY : m.scrollTop, rr = m === c ? c.scrollX : m.scrollLeft;
  return {
    top: we.top + ne - Me,
    left: we.left + rr - Ze
  };
}
function elementPrevAll(m, c) {
  const ie = [];
  for (; m.previousElementSibling; ) {
    const we = m.previousElementSibling;
    c ? we.matches(c) && ie.push(we) : ie.push(we), m = we;
  }
  return ie;
}
function elementNextAll(m, c) {
  const ie = [];
  for (; m.nextElementSibling; ) {
    const we = m.nextElementSibling;
    c ? we.matches(c) && ie.push(we) : ie.push(we), m = we;
  }
  return ie;
}
function elementStyle(m, c) {
  return getWindow().getComputedStyle(m, null).getPropertyValue(c);
}
function elementIndex(m) {
  let c = m, ie;
  if (c) {
    for (ie = 0; (c = c.previousSibling) !== null; )
      c.nodeType === 1 && (ie += 1);
    return ie;
  }
}
function elementParents(m, c) {
  const ie = [];
  let we = m.parentElement;
  for (; we; )
    c ? we.matches(c) && ie.push(we) : ie.push(we), we = we.parentElement;
  return ie;
}
function elementOuterSize(m, c, ie) {
  const we = getWindow();
  return ie ? m[c === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(we.getComputedStyle(m, null).getPropertyValue(c === "width" ? "margin-right" : "margin-top")) + parseFloat(we.getComputedStyle(m, null).getPropertyValue(c === "width" ? "margin-left" : "margin-bottom")) : m.offsetWidth;
}
function makeElementsArray(m) {
  return (Array.isArray(m) ? m : [m]).filter((c) => !!c);
}
function createElementIfNotDefined(m, c, ie, we) {
  return m.params.createElements && Object.keys(we).forEach(($e) => {
    if (!ie[$e] && ie.auto === !0) {
      let Me = elementChildren(m.el, `.${we[$e]}`)[0];
      Me || (Me = createElement("div", we[$e]), Me.className = we[$e], m.el.append(Me)), ie[$e] = Me, c[$e] = Me;
    }
  }), ie;
}
function Navigation(m) {
  let {
    swiper: c,
    extendParams: ie,
    on: we,
    emit: $e
  } = m;
  ie({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), c.navigation = {
    nextEl: null,
    prevEl: null
  };
  function Me(Ar) {
    let Rr;
    return Ar && typeof Ar == "string" && c.isElement && (Rr = c.el.querySelector(Ar) || c.hostEl.querySelector(Ar), Rr) ? Rr : (Ar && (typeof Ar == "string" && (Rr = [...document.querySelectorAll(Ar)]), c.params.uniqueNavElements && typeof Ar == "string" && Rr && Rr.length > 1 && c.el.querySelectorAll(Ar).length === 1 ? Rr = c.el.querySelector(Ar) : Rr && Rr.length === 1 && (Rr = Rr[0])), Ar && !Rr ? Ar : Rr);
  }
  function Ze(Ar, Rr) {
    const Nr = c.params.navigation;
    Ar = makeElementsArray(Ar), Ar.forEach((Yr) => {
      Yr && (Yr.classList[Rr ? "add" : "remove"](...Nr.disabledClass.split(" ")), Yr.tagName === "BUTTON" && (Yr.disabled = Rr), c.params.watchOverflow && c.enabled && Yr.classList[c.isLocked ? "add" : "remove"](Nr.lockClass));
    });
  }
  function ne() {
    const {
      nextEl: Ar,
      prevEl: Rr
    } = c.navigation;
    if (c.params.loop) {
      Ze(Rr, !1), Ze(Ar, !1);
      return;
    }
    Ze(Rr, c.isBeginning && !c.params.rewind), Ze(Ar, c.isEnd && !c.params.rewind);
  }
  function rr(Ar) {
    Ar.preventDefault(), !(c.isBeginning && !c.params.loop && !c.params.rewind) && (c.slidePrev(), $e("navigationPrev"));
  }
  function gr(Ar) {
    Ar.preventDefault(), !(c.isEnd && !c.params.loop && !c.params.rewind) && (c.slideNext(), $e("navigationNext"));
  }
  function or() {
    const Ar = c.params.navigation;
    if (c.params.navigation = createElementIfNotDefined(c, c.originalParams.navigation, c.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(Ar.nextEl || Ar.prevEl))
      return;
    let Rr = Me(Ar.nextEl), Nr = Me(Ar.prevEl);
    Object.assign(c.navigation, {
      nextEl: Rr,
      prevEl: Nr
    }), Rr = makeElementsArray(Rr), Nr = makeElementsArray(Nr);
    const Yr = (Vr, Xr) => {
      Vr && Vr.addEventListener("click", Xr === "next" ? gr : rr), !c.enabled && Vr && Vr.classList.add(...Ar.lockClass.split(" "));
    };
    Rr.forEach((Vr) => Yr(Vr, "next")), Nr.forEach((Vr) => Yr(Vr, "prev"));
  }
  function _r() {
    let {
      nextEl: Ar,
      prevEl: Rr
    } = c.navigation;
    Ar = makeElementsArray(Ar), Rr = makeElementsArray(Rr);
    const Nr = (Yr, Vr) => {
      Yr.removeEventListener("click", Vr === "next" ? gr : rr), Yr.classList.remove(...c.params.navigation.disabledClass.split(" "));
    };
    Ar.forEach((Yr) => Nr(Yr, "next")), Rr.forEach((Yr) => Nr(Yr, "prev"));
  }
  we("init", () => {
    c.params.navigation.enabled === !1 ? Ir() : (or(), ne());
  }), we("toEdge fromEdge lock unlock", () => {
    ne();
  }), we("destroy", () => {
    _r();
  }), we("enable disable", () => {
    let {
      nextEl: Ar,
      prevEl: Rr
    } = c.navigation;
    if (Ar = makeElementsArray(Ar), Rr = makeElementsArray(Rr), c.enabled) {
      ne();
      return;
    }
    [...Ar, ...Rr].filter((Nr) => !!Nr).forEach((Nr) => Nr.classList.add(c.params.navigation.lockClass));
  }), we("click", (Ar, Rr) => {
    let {
      nextEl: Nr,
      prevEl: Yr
    } = c.navigation;
    Nr = makeElementsArray(Nr), Yr = makeElementsArray(Yr);
    const Vr = Rr.target;
    let Xr = Yr.includes(Vr) || Nr.includes(Vr);
    if (c.isElement && !Xr) {
      const Wr = Rr.path || Rr.composedPath && Rr.composedPath();
      Wr && (Xr = Wr.find((si) => Nr.includes(si) || Yr.includes(si)));
    }
    if (c.params.navigation.hideOnClick && !Xr) {
      if (c.pagination && c.params.pagination && c.params.pagination.clickable && (c.pagination.el === Vr || c.pagination.el.contains(Vr)))
        return;
      let Wr;
      Nr.length ? Wr = Nr[0].classList.contains(c.params.navigation.hiddenClass) : Yr.length && (Wr = Yr[0].classList.contains(c.params.navigation.hiddenClass)), $e(Wr === !0 ? "navigationShow" : "navigationHide"), [...Nr, ...Yr].filter((si) => !!si).forEach((si) => si.classList.toggle(c.params.navigation.hiddenClass));
    }
  });
  const Lr = () => {
    c.el.classList.remove(...c.params.navigation.navigationDisabledClass.split(" ")), or(), ne();
  }, Ir = () => {
    c.el.classList.add(...c.params.navigation.navigationDisabledClass.split(" ")), _r();
  };
  Object.assign(c.navigation, {
    enable: Lr,
    disable: Ir,
    update: ne,
    init: or,
    destroy: _r
  });
}
function classesToSelector(m) {
  return m === void 0 && (m = ""), `.${m.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function Pagination(m) {
  let {
    swiper: c,
    extendParams: ie,
    on: we,
    emit: $e
  } = m;
  const Me = "swiper-pagination";
  ie({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (Vr) => Vr,
      formatFractionTotal: (Vr) => Vr,
      bulletClass: `${Me}-bullet`,
      bulletActiveClass: `${Me}-bullet-active`,
      modifierClass: `${Me}-`,
      currentClass: `${Me}-current`,
      totalClass: `${Me}-total`,
      hiddenClass: `${Me}-hidden`,
      progressbarFillClass: `${Me}-progressbar-fill`,
      progressbarOppositeClass: `${Me}-progressbar-opposite`,
      clickableClass: `${Me}-clickable`,
      lockClass: `${Me}-lock`,
      horizontalClass: `${Me}-horizontal`,
      verticalClass: `${Me}-vertical`,
      paginationDisabledClass: `${Me}-disabled`
    }
  }), c.pagination = {
    el: null,
    bullets: []
  };
  let Ze, ne = 0;
  function rr() {
    return !c.params.pagination.el || !c.pagination.el || Array.isArray(c.pagination.el) && c.pagination.el.length === 0;
  }
  function gr(Vr, Xr) {
    const {
      bulletActiveClass: Wr
    } = c.params.pagination;
    !Vr || (Vr = Vr[`${Xr === "prev" ? "previous" : "next"}ElementSibling`], Vr && (Vr.classList.add(`${Wr}-${Xr}`), Vr = Vr[`${Xr === "prev" ? "previous" : "next"}ElementSibling`], Vr && Vr.classList.add(`${Wr}-${Xr}-${Xr}`)));
  }
  function or(Vr, Xr, Wr) {
    if (Vr = Vr % Wr, Xr = Xr % Wr, Xr === Vr + 1)
      return "next";
    if (Xr === Vr - 1)
      return "previous";
  }
  function _r(Vr) {
    const Xr = Vr.target.closest(classesToSelector(c.params.pagination.bulletClass));
    if (!Xr)
      return;
    Vr.preventDefault();
    const Wr = elementIndex(Xr) * c.params.slidesPerGroup;
    if (c.params.loop) {
      if (c.realIndex === Wr)
        return;
      const si = or(c.realIndex, Wr, c.slides.length);
      si === "next" ? c.slideNext() : si === "previous" ? c.slidePrev() : c.slideToLoop(Wr);
    } else
      c.slideTo(Wr);
  }
  function Lr() {
    const Vr = c.rtl, Xr = c.params.pagination;
    if (rr())
      return;
    let Wr = c.pagination.el;
    Wr = makeElementsArray(Wr);
    let si, li;
    const xi = c.virtual && c.params.virtual.enabled ? c.virtual.slides.length : c.slides.length, di = c.params.loop ? Math.ceil(xi / c.params.slidesPerGroup) : c.snapGrid.length;
    if (c.params.loop ? (li = c.previousRealIndex || 0, si = c.params.slidesPerGroup > 1 ? Math.floor(c.realIndex / c.params.slidesPerGroup) : c.realIndex) : typeof c.snapIndex < "u" ? (si = c.snapIndex, li = c.previousSnapIndex) : (li = c.previousIndex || 0, si = c.activeIndex || 0), Xr.type === "bullets" && c.pagination.bullets && c.pagination.bullets.length > 0) {
      const oi = c.pagination.bullets;
      let ci, vr, Ae;
      if (Xr.dynamicBullets && (Ze = elementOuterSize(oi[0], c.isHorizontal() ? "width" : "height", !0), Wr.forEach((ze) => {
        ze.style[c.isHorizontal() ? "width" : "height"] = `${Ze * (Xr.dynamicMainBullets + 4)}px`;
      }), Xr.dynamicMainBullets > 1 && li !== void 0 && (ne += si - (li || 0), ne > Xr.dynamicMainBullets - 1 ? ne = Xr.dynamicMainBullets - 1 : ne < 0 && (ne = 0)), ci = Math.max(si - ne, 0), vr = ci + (Math.min(oi.length, Xr.dynamicMainBullets) - 1), Ae = (vr + ci) / 2), oi.forEach((ze) => {
        const Ue = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((tr) => `${Xr.bulletActiveClass}${tr}`)].map((tr) => typeof tr == "string" && tr.includes(" ") ? tr.split(" ") : tr).flat();
        ze.classList.remove(...Ue);
      }), Wr.length > 1)
        oi.forEach((ze) => {
          const Ue = elementIndex(ze);
          Ue === si ? ze.classList.add(...Xr.bulletActiveClass.split(" ")) : c.isElement && ze.setAttribute("part", "bullet"), Xr.dynamicBullets && (Ue >= ci && Ue <= vr && ze.classList.add(...`${Xr.bulletActiveClass}-main`.split(" ")), Ue === ci && gr(ze, "prev"), Ue === vr && gr(ze, "next"));
        });
      else {
        const ze = oi[si];
        if (ze && ze.classList.add(...Xr.bulletActiveClass.split(" ")), c.isElement && oi.forEach((Ue, tr) => {
          Ue.setAttribute("part", tr === si ? "bullet-active" : "bullet");
        }), Xr.dynamicBullets) {
          const Ue = oi[ci], tr = oi[vr];
          for (let lr = ci; lr <= vr; lr += 1)
            oi[lr] && oi[lr].classList.add(...`${Xr.bulletActiveClass}-main`.split(" "));
          gr(Ue, "prev"), gr(tr, "next");
        }
      }
      if (Xr.dynamicBullets) {
        const ze = Math.min(oi.length, Xr.dynamicMainBullets + 4), Ue = (Ze * ze - Ze) / 2 - Ae * Ze, tr = Vr ? "right" : "left";
        oi.forEach((lr) => {
          lr.style[c.isHorizontal() ? tr : "top"] = `${Ue}px`;
        });
      }
    }
    Wr.forEach((oi, ci) => {
      if (Xr.type === "fraction" && (oi.querySelectorAll(classesToSelector(Xr.currentClass)).forEach((vr) => {
        vr.textContent = Xr.formatFractionCurrent(si + 1);
      }), oi.querySelectorAll(classesToSelector(Xr.totalClass)).forEach((vr) => {
        vr.textContent = Xr.formatFractionTotal(di);
      })), Xr.type === "progressbar") {
        let vr;
        Xr.progressbarOpposite ? vr = c.isHorizontal() ? "vertical" : "horizontal" : vr = c.isHorizontal() ? "horizontal" : "vertical";
        const Ae = (si + 1) / di;
        let ze = 1, Ue = 1;
        vr === "horizontal" ? ze = Ae : Ue = Ae, oi.querySelectorAll(classesToSelector(Xr.progressbarFillClass)).forEach((tr) => {
          tr.style.transform = `translate3d(0,0,0) scaleX(${ze}) scaleY(${Ue})`, tr.style.transitionDuration = `${c.params.speed}ms`;
        });
      }
      Xr.type === "custom" && Xr.renderCustom ? (oi.innerHTML = Xr.renderCustom(c, si + 1, di), ci === 0 && $e("paginationRender", oi)) : (ci === 0 && $e("paginationRender", oi), $e("paginationUpdate", oi)), c.params.watchOverflow && c.enabled && oi.classList[c.isLocked ? "add" : "remove"](Xr.lockClass);
    });
  }
  function Ir() {
    const Vr = c.params.pagination;
    if (rr())
      return;
    const Xr = c.virtual && c.params.virtual.enabled ? c.virtual.slides.length : c.grid && c.params.grid.rows > 1 ? c.slides.length / Math.ceil(c.params.grid.rows) : c.slides.length;
    let Wr = c.pagination.el;
    Wr = makeElementsArray(Wr);
    let si = "";
    if (Vr.type === "bullets") {
      let li = c.params.loop ? Math.ceil(Xr / c.params.slidesPerGroup) : c.snapGrid.length;
      c.params.freeMode && c.params.freeMode.enabled && li > Xr && (li = Xr);
      for (let xi = 0; xi < li; xi += 1)
        Vr.renderBullet ? si += Vr.renderBullet.call(c, xi, Vr.bulletClass) : si += `<${Vr.bulletElement} ${c.isElement ? 'part="bullet"' : ""} class="${Vr.bulletClass}"></${Vr.bulletElement}>`;
    }
    Vr.type === "fraction" && (Vr.renderFraction ? si = Vr.renderFraction.call(c, Vr.currentClass, Vr.totalClass) : si = `<span class="${Vr.currentClass}"></span> / <span class="${Vr.totalClass}"></span>`), Vr.type === "progressbar" && (Vr.renderProgressbar ? si = Vr.renderProgressbar.call(c, Vr.progressbarFillClass) : si = `<span class="${Vr.progressbarFillClass}"></span>`), c.pagination.bullets = [], Wr.forEach((li) => {
      Vr.type !== "custom" && (li.innerHTML = si || ""), Vr.type === "bullets" && c.pagination.bullets.push(...li.querySelectorAll(classesToSelector(Vr.bulletClass)));
    }), Vr.type !== "custom" && $e("paginationRender", Wr[0]);
  }
  function Ar() {
    c.params.pagination = createElementIfNotDefined(c, c.originalParams.pagination, c.params.pagination, {
      el: "swiper-pagination"
    });
    const Vr = c.params.pagination;
    if (!Vr.el)
      return;
    let Xr;
    typeof Vr.el == "string" && c.isElement && (Xr = c.el.querySelector(Vr.el)), !Xr && typeof Vr.el == "string" && (Xr = [...document.querySelectorAll(Vr.el)]), Xr || (Xr = Vr.el), !(!Xr || Xr.length === 0) && (c.params.uniqueNavElements && typeof Vr.el == "string" && Array.isArray(Xr) && Xr.length > 1 && (Xr = [...c.el.querySelectorAll(Vr.el)], Xr.length > 1 && (Xr = Xr.find((Wr) => elementParents(Wr, ".swiper")[0] === c.el))), Array.isArray(Xr) && Xr.length === 1 && (Xr = Xr[0]), Object.assign(c.pagination, {
      el: Xr
    }), Xr = makeElementsArray(Xr), Xr.forEach((Wr) => {
      Vr.type === "bullets" && Vr.clickable && Wr.classList.add(...(Vr.clickableClass || "").split(" ")), Wr.classList.add(Vr.modifierClass + Vr.type), Wr.classList.add(c.isHorizontal() ? Vr.horizontalClass : Vr.verticalClass), Vr.type === "bullets" && Vr.dynamicBullets && (Wr.classList.add(`${Vr.modifierClass}${Vr.type}-dynamic`), ne = 0, Vr.dynamicMainBullets < 1 && (Vr.dynamicMainBullets = 1)), Vr.type === "progressbar" && Vr.progressbarOpposite && Wr.classList.add(Vr.progressbarOppositeClass), Vr.clickable && Wr.addEventListener("click", _r), c.enabled || Wr.classList.add(Vr.lockClass);
    }));
  }
  function Rr() {
    const Vr = c.params.pagination;
    if (rr())
      return;
    let Xr = c.pagination.el;
    Xr && (Xr = makeElementsArray(Xr), Xr.forEach((Wr) => {
      Wr.classList.remove(Vr.hiddenClass), Wr.classList.remove(Vr.modifierClass + Vr.type), Wr.classList.remove(c.isHorizontal() ? Vr.horizontalClass : Vr.verticalClass), Vr.clickable && (Wr.classList.remove(...(Vr.clickableClass || "").split(" ")), Wr.removeEventListener("click", _r));
    })), c.pagination.bullets && c.pagination.bullets.forEach((Wr) => Wr.classList.remove(...Vr.bulletActiveClass.split(" ")));
  }
  we("changeDirection", () => {
    if (!c.pagination || !c.pagination.el)
      return;
    const Vr = c.params.pagination;
    let {
      el: Xr
    } = c.pagination;
    Xr = makeElementsArray(Xr), Xr.forEach((Wr) => {
      Wr.classList.remove(Vr.horizontalClass, Vr.verticalClass), Wr.classList.add(c.isHorizontal() ? Vr.horizontalClass : Vr.verticalClass);
    });
  }), we("init", () => {
    c.params.pagination.enabled === !1 ? Yr() : (Ar(), Ir(), Lr());
  }), we("activeIndexChange", () => {
    typeof c.snapIndex > "u" && Lr();
  }), we("snapIndexChange", () => {
    Lr();
  }), we("snapGridLengthChange", () => {
    Ir(), Lr();
  }), we("destroy", () => {
    Rr();
  }), we("enable disable", () => {
    let {
      el: Vr
    } = c.pagination;
    Vr && (Vr = makeElementsArray(Vr), Vr.forEach((Xr) => Xr.classList[c.enabled ? "remove" : "add"](c.params.pagination.lockClass)));
  }), we("lock unlock", () => {
    Lr();
  }), we("click", (Vr, Xr) => {
    const Wr = Xr.target, si = makeElementsArray(c.pagination.el);
    if (c.params.pagination.el && c.params.pagination.hideOnClick && si && si.length > 0 && !Wr.classList.contains(c.params.pagination.bulletClass)) {
      if (c.navigation && (c.navigation.nextEl && Wr === c.navigation.nextEl || c.navigation.prevEl && Wr === c.navigation.prevEl))
        return;
      const li = si[0].classList.contains(c.params.pagination.hiddenClass);
      $e(li === !0 ? "paginationShow" : "paginationHide"), si.forEach((xi) => xi.classList.toggle(c.params.pagination.hiddenClass));
    }
  });
  const Nr = () => {
    c.el.classList.remove(c.params.pagination.paginationDisabledClass);
    let {
      el: Vr
    } = c.pagination;
    Vr && (Vr = makeElementsArray(Vr), Vr.forEach((Xr) => Xr.classList.remove(c.params.pagination.paginationDisabledClass))), Ar(), Ir(), Lr();
  }, Yr = () => {
    c.el.classList.add(c.params.pagination.paginationDisabledClass);
    let {
      el: Vr
    } = c.pagination;
    Vr && (Vr = makeElementsArray(Vr), Vr.forEach((Xr) => Xr.classList.add(c.params.pagination.paginationDisabledClass))), Rr();
  };
  Object.assign(c.pagination, {
    enable: Nr,
    disable: Yr,
    render: Ir,
    update: Lr,
    init: Ar,
    destroy: Rr
  });
}
function Scrollbar(m) {
  let {
    swiper: c,
    extendParams: ie,
    on: we,
    emit: $e
  } = m;
  const Me = getDocument();
  let Ze = !1, ne = null, rr = null, gr, or, _r, Lr;
  ie({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), c.scrollbar = {
    el: null,
    dragEl: null
  };
  function Ir() {
    if (!c.params.scrollbar.el || !c.scrollbar.el)
      return;
    const {
      scrollbar: Ae,
      rtlTranslate: ze
    } = c, {
      dragEl: Ue,
      el: tr
    } = Ae, lr = c.params.scrollbar, pr = c.params.loop ? c.progressLoop : c.progress;
    let br = or, nr = (_r - or) * pr;
    ze ? (nr = -nr, nr > 0 ? (br = or - nr, nr = 0) : -nr + or > _r && (br = _r + nr)) : nr < 0 ? (br = or + nr, nr = 0) : nr + or > _r && (br = _r - nr), c.isHorizontal() ? (Ue.style.transform = `translate3d(${nr}px, 0, 0)`, Ue.style.width = `${br}px`) : (Ue.style.transform = `translate3d(0px, ${nr}px, 0)`, Ue.style.height = `${br}px`), lr.hide && (clearTimeout(ne), tr.style.opacity = 1, ne = setTimeout(() => {
      tr.style.opacity = 0, tr.style.transitionDuration = "400ms";
    }, 1e3));
  }
  function Ar(Ae) {
    !c.params.scrollbar.el || !c.scrollbar.el || (c.scrollbar.dragEl.style.transitionDuration = `${Ae}ms`);
  }
  function Rr() {
    if (!c.params.scrollbar.el || !c.scrollbar.el)
      return;
    const {
      scrollbar: Ae
    } = c, {
      dragEl: ze,
      el: Ue
    } = Ae;
    ze.style.width = "", ze.style.height = "", _r = c.isHorizontal() ? Ue.offsetWidth : Ue.offsetHeight, Lr = c.size / (c.virtualSize + c.params.slidesOffsetBefore - (c.params.centeredSlides ? c.snapGrid[0] : 0)), c.params.scrollbar.dragSize === "auto" ? or = _r * Lr : or = parseInt(c.params.scrollbar.dragSize, 10), c.isHorizontal() ? ze.style.width = `${or}px` : ze.style.height = `${or}px`, Lr >= 1 ? Ue.style.display = "none" : Ue.style.display = "", c.params.scrollbar.hide && (Ue.style.opacity = 0), c.params.watchOverflow && c.enabled && Ae.el.classList[c.isLocked ? "add" : "remove"](c.params.scrollbar.lockClass);
  }
  function Nr(Ae) {
    return c.isHorizontal() ? Ae.clientX : Ae.clientY;
  }
  function Yr(Ae) {
    const {
      scrollbar: ze,
      rtlTranslate: Ue
    } = c, {
      el: tr
    } = ze;
    let lr;
    lr = (Nr(Ae) - elementOffset(tr)[c.isHorizontal() ? "left" : "top"] - (gr !== null ? gr : or / 2)) / (_r - or), lr = Math.max(Math.min(lr, 1), 0), Ue && (lr = 1 - lr);
    const pr = c.minTranslate() + (c.maxTranslate() - c.minTranslate()) * lr;
    c.updateProgress(pr), c.setTranslate(pr), c.updateActiveIndex(), c.updateSlidesClasses();
  }
  function Vr(Ae) {
    const ze = c.params.scrollbar, {
      scrollbar: Ue,
      wrapperEl: tr
    } = c, {
      el: lr,
      dragEl: pr
    } = Ue;
    Ze = !0, gr = Ae.target === pr ? Nr(Ae) - Ae.target.getBoundingClientRect()[c.isHorizontal() ? "left" : "top"] : null, Ae.preventDefault(), Ae.stopPropagation(), tr.style.transitionDuration = "100ms", pr.style.transitionDuration = "100ms", Yr(Ae), clearTimeout(rr), lr.style.transitionDuration = "0ms", ze.hide && (lr.style.opacity = 1), c.params.cssMode && (c.wrapperEl.style["scroll-snap-type"] = "none"), $e("scrollbarDragStart", Ae);
  }
  function Xr(Ae) {
    const {
      scrollbar: ze,
      wrapperEl: Ue
    } = c, {
      el: tr,
      dragEl: lr
    } = ze;
    !Ze || (Ae.preventDefault && Ae.cancelable ? Ae.preventDefault() : Ae.returnValue = !1, Yr(Ae), Ue.style.transitionDuration = "0ms", tr.style.transitionDuration = "0ms", lr.style.transitionDuration = "0ms", $e("scrollbarDragMove", Ae));
  }
  function Wr(Ae) {
    const ze = c.params.scrollbar, {
      scrollbar: Ue,
      wrapperEl: tr
    } = c, {
      el: lr
    } = Ue;
    !Ze || (Ze = !1, c.params.cssMode && (c.wrapperEl.style["scroll-snap-type"] = "", tr.style.transitionDuration = ""), ze.hide && (clearTimeout(rr), rr = nextTick(() => {
      lr.style.opacity = 0, lr.style.transitionDuration = "400ms";
    }, 1e3)), $e("scrollbarDragEnd", Ae), ze.snapOnRelease && c.slideToClosest());
  }
  function si(Ae) {
    const {
      scrollbar: ze,
      params: Ue
    } = c, tr = ze.el;
    if (!tr)
      return;
    const lr = tr, pr = Ue.passiveListeners ? {
      passive: !1,
      capture: !1
    } : !1, br = Ue.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    if (!lr)
      return;
    const nr = Ae === "on" ? "addEventListener" : "removeEventListener";
    lr[nr]("pointerdown", Vr, pr), Me[nr]("pointermove", Xr, pr), Me[nr]("pointerup", Wr, br);
  }
  function li() {
    !c.params.scrollbar.el || !c.scrollbar.el || si("on");
  }
  function xi() {
    !c.params.scrollbar.el || !c.scrollbar.el || si("off");
  }
  function di() {
    const {
      scrollbar: Ae,
      el: ze
    } = c;
    c.params.scrollbar = createElementIfNotDefined(c, c.originalParams.scrollbar, c.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const Ue = c.params.scrollbar;
    if (!Ue.el)
      return;
    let tr;
    if (typeof Ue.el == "string" && c.isElement && (tr = c.el.querySelector(Ue.el)), !tr && typeof Ue.el == "string") {
      if (tr = Me.querySelectorAll(Ue.el), !tr.length)
        return;
    } else
      tr || (tr = Ue.el);
    c.params.uniqueNavElements && typeof Ue.el == "string" && tr.length > 1 && ze.querySelectorAll(Ue.el).length === 1 && (tr = ze.querySelector(Ue.el)), tr.length > 0 && (tr = tr[0]), tr.classList.add(c.isHorizontal() ? Ue.horizontalClass : Ue.verticalClass);
    let lr;
    tr && (lr = tr.querySelector(classesToSelector(c.params.scrollbar.dragClass)), lr || (lr = createElement("div", c.params.scrollbar.dragClass), tr.append(lr))), Object.assign(Ae, {
      el: tr,
      dragEl: lr
    }), Ue.draggable && li(), tr && tr.classList[c.enabled ? "remove" : "add"](...classesToTokens(c.params.scrollbar.lockClass));
  }
  function oi() {
    const Ae = c.params.scrollbar, ze = c.scrollbar.el;
    ze && ze.classList.remove(...classesToTokens(c.isHorizontal() ? Ae.horizontalClass : Ae.verticalClass)), xi();
  }
  we("changeDirection", () => {
    if (!c.scrollbar || !c.scrollbar.el)
      return;
    const Ae = c.params.scrollbar;
    let {
      el: ze
    } = c.scrollbar;
    ze = makeElementsArray(ze), ze.forEach((Ue) => {
      Ue.classList.remove(Ae.horizontalClass, Ae.verticalClass), Ue.classList.add(c.isHorizontal() ? Ae.horizontalClass : Ae.verticalClass);
    });
  }), we("init", () => {
    c.params.scrollbar.enabled === !1 ? vr() : (di(), Rr(), Ir());
  }), we("update resize observerUpdate lock unlock changeDirection", () => {
    Rr();
  }), we("setTranslate", () => {
    Ir();
  }), we("setTransition", (Ae, ze) => {
    Ar(ze);
  }), we("enable disable", () => {
    const {
      el: Ae
    } = c.scrollbar;
    Ae && Ae.classList[c.enabled ? "remove" : "add"](...classesToTokens(c.params.scrollbar.lockClass));
  }), we("destroy", () => {
    oi();
  });
  const ci = () => {
    c.el.classList.remove(...classesToTokens(c.params.scrollbar.scrollbarDisabledClass)), c.scrollbar.el && c.scrollbar.el.classList.remove(...classesToTokens(c.params.scrollbar.scrollbarDisabledClass)), di(), Rr(), Ir();
  }, vr = () => {
    c.el.classList.add(...classesToTokens(c.params.scrollbar.scrollbarDisabledClass)), c.scrollbar.el && c.scrollbar.el.classList.add(...classesToTokens(c.params.scrollbar.scrollbarDisabledClass)), oi();
  };
  Object.assign(c.scrollbar, {
    enable: ci,
    disable: vr,
    updateSize: Rr,
    setTranslate: Ir,
    init: di,
    destroy: oi
  });
}
function A11y(m) {
  let {
    swiper: c,
    extendParams: ie,
    on: we
  } = m;
  ie({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), c.a11y = {
    clicked: !1
  };
  let $e = null, Me, Ze, ne = new Date().getTime();
  function rr(pr) {
    const br = $e;
    br.length !== 0 && (br.innerHTML = "", br.innerHTML = pr);
  }
  function gr(pr) {
    pr === void 0 && (pr = 16);
    const br = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(pr).replace(/x/g, br);
  }
  function or(pr) {
    pr = makeElementsArray(pr), pr.forEach((br) => {
      br.setAttribute("tabIndex", "0");
    });
  }
  function _r(pr) {
    pr = makeElementsArray(pr), pr.forEach((br) => {
      br.setAttribute("tabIndex", "-1");
    });
  }
  function Lr(pr, br) {
    pr = makeElementsArray(pr), pr.forEach((nr) => {
      nr.setAttribute("role", br);
    });
  }
  function Ir(pr, br) {
    pr = makeElementsArray(pr), pr.forEach((nr) => {
      nr.setAttribute("aria-roledescription", br);
    });
  }
  function Ar(pr, br) {
    pr = makeElementsArray(pr), pr.forEach((nr) => {
      nr.setAttribute("aria-controls", br);
    });
  }
  function Rr(pr, br) {
    pr = makeElementsArray(pr), pr.forEach((nr) => {
      nr.setAttribute("aria-label", br);
    });
  }
  function Nr(pr, br) {
    pr = makeElementsArray(pr), pr.forEach((nr) => {
      nr.setAttribute("id", br);
    });
  }
  function Yr(pr, br) {
    pr = makeElementsArray(pr), pr.forEach((nr) => {
      nr.setAttribute("aria-live", br);
    });
  }
  function Vr(pr) {
    pr = makeElementsArray(pr), pr.forEach((br) => {
      br.setAttribute("aria-disabled", !0);
    });
  }
  function Xr(pr) {
    pr = makeElementsArray(pr), pr.forEach((br) => {
      br.setAttribute("aria-disabled", !1);
    });
  }
  function Wr(pr) {
    if (pr.keyCode !== 13 && pr.keyCode !== 32)
      return;
    const br = c.params.a11y, nr = pr.target;
    if (!(c.pagination && c.pagination.el && (nr === c.pagination.el || c.pagination.el.contains(pr.target)) && !pr.target.matches(classesToSelector(c.params.pagination.bulletClass)))) {
      if (c.navigation && c.navigation.prevEl && c.navigation.nextEl) {
        const Pe = makeElementsArray(c.navigation.prevEl);
        makeElementsArray(c.navigation.nextEl).includes(nr) && (c.isEnd && !c.params.loop || c.slideNext(), c.isEnd ? rr(br.lastSlideMessage) : rr(br.nextSlideMessage)), Pe.includes(nr) && (c.isBeginning && !c.params.loop || c.slidePrev(), c.isBeginning ? rr(br.firstSlideMessage) : rr(br.prevSlideMessage));
      }
      c.pagination && nr.matches(classesToSelector(c.params.pagination.bulletClass)) && nr.click();
    }
  }
  function si() {
    if (c.params.loop || c.params.rewind || !c.navigation)
      return;
    const {
      nextEl: pr,
      prevEl: br
    } = c.navigation;
    br && (c.isBeginning ? (Vr(br), _r(br)) : (Xr(br), or(br))), pr && (c.isEnd ? (Vr(pr), _r(pr)) : (Xr(pr), or(pr)));
  }
  function li() {
    return c.pagination && c.pagination.bullets && c.pagination.bullets.length;
  }
  function xi() {
    return li() && c.params.pagination.clickable;
  }
  function di() {
    const pr = c.params.a11y;
    !li() || c.pagination.bullets.forEach((br) => {
      c.params.pagination.clickable && (or(br), c.params.pagination.renderBullet || (Lr(br, "button"), Rr(br, pr.paginationBulletMessage.replace(/\{\{index\}\}/, elementIndex(br) + 1)))), br.matches(classesToSelector(c.params.pagination.bulletActiveClass)) ? br.setAttribute("aria-current", "true") : br.removeAttribute("aria-current");
    });
  }
  const oi = (pr, br, nr) => {
    or(pr), pr.tagName !== "BUTTON" && (Lr(pr, "button"), pr.addEventListener("keydown", Wr)), Rr(pr, nr), Ar(pr, br);
  }, ci = (pr) => {
    Ze && Ze !== pr.target && !Ze.contains(pr.target) && (Me = !0), c.a11y.clicked = !0;
  }, vr = () => {
    Me = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        c.destroyed || (c.a11y.clicked = !1);
      });
    });
  }, Ae = (pr) => {
    ne = new Date().getTime();
  }, ze = (pr) => {
    if (c.a11y.clicked || !c.params.a11y.scrollOnFocus || new Date().getTime() - ne < 100)
      return;
    const br = pr.target.closest(`.${c.params.slideClass}, swiper-slide`);
    if (!br || !c.slides.includes(br))
      return;
    Ze = br;
    const nr = c.slides.indexOf(br) === c.activeIndex, Pe = c.params.watchSlidesProgress && c.visibleSlides && c.visibleSlides.includes(br);
    nr || Pe || pr.sourceCapabilities && pr.sourceCapabilities.firesTouchEvents || (c.isHorizontal() ? c.el.scrollLeft = 0 : c.el.scrollTop = 0, requestAnimationFrame(() => {
      Me || (c.params.loop ? c.slideToLoop(parseInt(br.getAttribute("data-swiper-slide-index")), 0) : c.slideTo(c.slides.indexOf(br), 0), Me = !1);
    }));
  }, Ue = () => {
    const pr = c.params.a11y;
    pr.itemRoleDescriptionMessage && Ir(c.slides, pr.itemRoleDescriptionMessage), pr.slideRole && Lr(c.slides, pr.slideRole);
    const br = c.slides.length;
    pr.slideLabelMessage && c.slides.forEach((nr, Pe) => {
      const ur = c.params.loop ? parseInt(nr.getAttribute("data-swiper-slide-index"), 10) : Pe, Pr = pr.slideLabelMessage.replace(/\{\{index\}\}/, ur + 1).replace(/\{\{slidesLength\}\}/, br);
      Rr(nr, Pr);
    });
  }, tr = () => {
    const pr = c.params.a11y;
    c.el.append($e);
    const br = c.el;
    pr.containerRoleDescriptionMessage && Ir(br, pr.containerRoleDescriptionMessage), pr.containerMessage && Rr(br, pr.containerMessage), pr.containerRole && Lr(br, pr.containerRole);
    const nr = c.wrapperEl, Pe = pr.id || nr.getAttribute("id") || `swiper-wrapper-${gr(16)}`, ur = c.params.autoplay && c.params.autoplay.enabled ? "off" : "polite";
    Nr(nr, Pe), Yr(nr, ur), Ue();
    let {
      nextEl: Pr,
      prevEl: Hr
    } = c.navigation ? c.navigation : {};
    Pr = makeElementsArray(Pr), Hr = makeElementsArray(Hr), Pr && Pr.forEach((Ti) => oi(Ti, Pe, pr.nextSlideMessage)), Hr && Hr.forEach((Ti) => oi(Ti, Pe, pr.prevSlideMessage)), xi() && makeElementsArray(c.pagination.el).forEach((wi) => {
      wi.addEventListener("keydown", Wr);
    }), getDocument().addEventListener("visibilitychange", Ae), c.el.addEventListener("focus", ze, !0), c.el.addEventListener("focus", ze, !0), c.el.addEventListener("pointerdown", ci, !0), c.el.addEventListener("pointerup", vr, !0);
  };
  function lr() {
    $e && $e.remove();
    let {
      nextEl: pr,
      prevEl: br
    } = c.navigation ? c.navigation : {};
    pr = makeElementsArray(pr), br = makeElementsArray(br), pr && pr.forEach((Pe) => Pe.removeEventListener("keydown", Wr)), br && br.forEach((Pe) => Pe.removeEventListener("keydown", Wr)), xi() && makeElementsArray(c.pagination.el).forEach((ur) => {
      ur.removeEventListener("keydown", Wr);
    }), getDocument().removeEventListener("visibilitychange", Ae), c.el && typeof c.el != "string" && (c.el.removeEventListener("focus", ze, !0), c.el.removeEventListener("pointerdown", ci, !0), c.el.removeEventListener("pointerup", vr, !0));
  }
  we("beforeInit", () => {
    $e = createElement("span", c.params.a11y.notificationClass), $e.setAttribute("aria-live", "assertive"), $e.setAttribute("aria-atomic", "true");
  }), we("afterInit", () => {
    !c.params.a11y.enabled || tr();
  }), we("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    !c.params.a11y.enabled || Ue();
  }), we("fromEdge toEdge afterInit lock unlock", () => {
    !c.params.a11y.enabled || si();
  }), we("paginationUpdate", () => {
    !c.params.a11y.enabled || di();
  }), we("destroy", () => {
    !c.params.a11y.enabled || lr();
  });
}
let support;
function calcSupport() {
  const m = getWindow(), c = getDocument();
  return {
    smoothScroll: c.documentElement && c.documentElement.style && "scrollBehavior" in c.documentElement.style,
    touch: !!("ontouchstart" in m || m.DocumentTouch && c instanceof m.DocumentTouch)
  };
}
function getSupport() {
  return support || (support = calcSupport()), support;
}
let deviceCached;
function calcDevice(m) {
  let {
    userAgent: c
  } = m === void 0 ? {} : m;
  const ie = getSupport(), we = getWindow(), $e = we.navigator.platform, Me = c || we.navigator.userAgent, Ze = {
    ios: !1,
    android: !1
  }, ne = we.screen.width, rr = we.screen.height, gr = Me.match(/(Android);?[\s\/]+([\d.]+)?/);
  let or = Me.match(/(iPad).*OS\s([\d_]+)/);
  const _r = Me.match(/(iPod)(.*OS\s([\d_]+))?/), Lr = !or && Me.match(/(iPhone\sOS|iOS)\s([\d_]+)/), Ir = $e === "Win32";
  let Ar = $e === "MacIntel";
  const Rr = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !or && Ar && ie.touch && Rr.indexOf(`${ne}x${rr}`) >= 0 && (or = Me.match(/(Version)\/([\d.]+)/), or || (or = [0, 1, "13_0_0"]), Ar = !1), gr && !Ir && (Ze.os = "android", Ze.android = !0), (or || Lr || _r) && (Ze.os = "ios", Ze.ios = !0), Ze;
}
function getDevice(m) {
  return m === void 0 && (m = {}), deviceCached || (deviceCached = calcDevice(m)), deviceCached;
}
let browser;
function calcBrowser() {
  const m = getWindow(), c = getDevice();
  let ie = !1;
  function we() {
    const ne = m.navigator.userAgent.toLowerCase();
    return ne.indexOf("safari") >= 0 && ne.indexOf("chrome") < 0 && ne.indexOf("android") < 0;
  }
  if (we()) {
    const ne = String(m.navigator.userAgent);
    if (ne.includes("Version/")) {
      const [rr, gr] = ne.split("Version/")[1].split(" ")[0].split(".").map((or) => Number(or));
      ie = rr < 16 || rr === 16 && gr < 2;
    }
  }
  const $e = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(m.navigator.userAgent), Me = we(), Ze = Me || $e && c.ios;
  return {
    isSafari: ie || Me,
    needPerspectiveFix: ie,
    need3dFix: Ze,
    isWebView: $e
  };
}
function getBrowser() {
  return browser || (browser = calcBrowser()), browser;
}
function Resize(m) {
  let {
    swiper: c,
    on: ie,
    emit: we
  } = m;
  const $e = getWindow();
  let Me = null, Ze = null;
  const ne = () => {
    !c || c.destroyed || !c.initialized || (we("beforeResize"), we("resize"));
  }, rr = () => {
    !c || c.destroyed || !c.initialized || (Me = new ResizeObserver((_r) => {
      Ze = $e.requestAnimationFrame(() => {
        const {
          width: Lr,
          height: Ir
        } = c;
        let Ar = Lr, Rr = Ir;
        _r.forEach((Nr) => {
          let {
            contentBoxSize: Yr,
            contentRect: Vr,
            target: Xr
          } = Nr;
          Xr && Xr !== c.el || (Ar = Vr ? Vr.width : (Yr[0] || Yr).inlineSize, Rr = Vr ? Vr.height : (Yr[0] || Yr).blockSize);
        }), (Ar !== Lr || Rr !== Ir) && ne();
      });
    }), Me.observe(c.el));
  }, gr = () => {
    Ze && $e.cancelAnimationFrame(Ze), Me && Me.unobserve && c.el && (Me.unobserve(c.el), Me = null);
  }, or = () => {
    !c || c.destroyed || !c.initialized || we("orientationchange");
  };
  ie("init", () => {
    if (c.params.resizeObserver && typeof $e.ResizeObserver < "u") {
      rr();
      return;
    }
    $e.addEventListener("resize", ne), $e.addEventListener("orientationchange", or);
  }), ie("destroy", () => {
    gr(), $e.removeEventListener("resize", ne), $e.removeEventListener("orientationchange", or);
  });
}
function Observer(m) {
  let {
    swiper: c,
    extendParams: ie,
    on: we,
    emit: $e
  } = m;
  const Me = [], Ze = getWindow(), ne = function(or, _r) {
    _r === void 0 && (_r = {});
    const Lr = Ze.MutationObserver || Ze.WebkitMutationObserver, Ir = new Lr((Ar) => {
      if (c.__preventObserver__)
        return;
      if (Ar.length === 1) {
        $e("observerUpdate", Ar[0]);
        return;
      }
      const Rr = function() {
        $e("observerUpdate", Ar[0]);
      };
      Ze.requestAnimationFrame ? Ze.requestAnimationFrame(Rr) : Ze.setTimeout(Rr, 0);
    });
    Ir.observe(or, {
      attributes: typeof _r.attributes > "u" ? !0 : _r.attributes,
      childList: c.isElement || (typeof _r.childList > "u" ? !0 : _r).childList,
      characterData: typeof _r.characterData > "u" ? !0 : _r.characterData
    }), Me.push(Ir);
  }, rr = () => {
    if (!!c.params.observer) {
      if (c.params.observeParents) {
        const or = elementParents(c.hostEl);
        for (let _r = 0; _r < or.length; _r += 1)
          ne(or[_r]);
      }
      ne(c.hostEl, {
        childList: c.params.observeSlideChildren
      }), ne(c.wrapperEl, {
        attributes: !1
      });
    }
  }, gr = () => {
    Me.forEach((or) => {
      or.disconnect();
    }), Me.splice(0, Me.length);
  };
  ie({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), we("init", rr), we("destroy", gr);
}
var eventsEmitter = {
  on(m, c, ie) {
    const we = this;
    if (!we.eventsListeners || we.destroyed || typeof c != "function")
      return we;
    const $e = ie ? "unshift" : "push";
    return m.split(" ").forEach((Me) => {
      we.eventsListeners[Me] || (we.eventsListeners[Me] = []), we.eventsListeners[Me][$e](c);
    }), we;
  },
  once(m, c, ie) {
    const we = this;
    if (!we.eventsListeners || we.destroyed || typeof c != "function")
      return we;
    function $e() {
      we.off(m, $e), $e.__emitterProxy && delete $e.__emitterProxy;
      for (var Me = arguments.length, Ze = new Array(Me), ne = 0; ne < Me; ne++)
        Ze[ne] = arguments[ne];
      c.apply(we, Ze);
    }
    return $e.__emitterProxy = c, we.on(m, $e, ie);
  },
  onAny(m, c) {
    const ie = this;
    if (!ie.eventsListeners || ie.destroyed || typeof m != "function")
      return ie;
    const we = c ? "unshift" : "push";
    return ie.eventsAnyListeners.indexOf(m) < 0 && ie.eventsAnyListeners[we](m), ie;
  },
  offAny(m) {
    const c = this;
    if (!c.eventsListeners || c.destroyed || !c.eventsAnyListeners)
      return c;
    const ie = c.eventsAnyListeners.indexOf(m);
    return ie >= 0 && c.eventsAnyListeners.splice(ie, 1), c;
  },
  off(m, c) {
    const ie = this;
    return !ie.eventsListeners || ie.destroyed || !ie.eventsListeners || m.split(" ").forEach((we) => {
      typeof c > "u" ? ie.eventsListeners[we] = [] : ie.eventsListeners[we] && ie.eventsListeners[we].forEach(($e, Me) => {
        ($e === c || $e.__emitterProxy && $e.__emitterProxy === c) && ie.eventsListeners[we].splice(Me, 1);
      });
    }), ie;
  },
  emit() {
    const m = this;
    if (!m.eventsListeners || m.destroyed || !m.eventsListeners)
      return m;
    let c, ie, we;
    for (var $e = arguments.length, Me = new Array($e), Ze = 0; Ze < $e; Ze++)
      Me[Ze] = arguments[Ze];
    return typeof Me[0] == "string" || Array.isArray(Me[0]) ? (c = Me[0], ie = Me.slice(1, Me.length), we = m) : (c = Me[0].events, ie = Me[0].data, we = Me[0].context || m), ie.unshift(we), (Array.isArray(c) ? c : c.split(" ")).forEach((rr) => {
      m.eventsAnyListeners && m.eventsAnyListeners.length && m.eventsAnyListeners.forEach((gr) => {
        gr.apply(we, [rr, ...ie]);
      }), m.eventsListeners && m.eventsListeners[rr] && m.eventsListeners[rr].forEach((gr) => {
        gr.apply(we, ie);
      });
    }), m;
  }
};
function updateSize() {
  const m = this;
  let c, ie;
  const we = m.el;
  typeof m.params.width < "u" && m.params.width !== null ? c = m.params.width : c = we.clientWidth, typeof m.params.height < "u" && m.params.height !== null ? ie = m.params.height : ie = we.clientHeight, !(c === 0 && m.isHorizontal() || ie === 0 && m.isVertical()) && (c = c - parseInt(elementStyle(we, "padding-left") || 0, 10) - parseInt(elementStyle(we, "padding-right") || 0, 10), ie = ie - parseInt(elementStyle(we, "padding-top") || 0, 10) - parseInt(elementStyle(we, "padding-bottom") || 0, 10), Number.isNaN(c) && (c = 0), Number.isNaN(ie) && (ie = 0), Object.assign(m, {
    width: c,
    height: ie,
    size: m.isHorizontal() ? c : ie
  }));
}
function updateSlides() {
  const m = this;
  function c(ci, vr) {
    return parseFloat(ci.getPropertyValue(m.getDirectionLabel(vr)) || 0);
  }
  const ie = m.params, {
    wrapperEl: we,
    slidesEl: $e,
    size: Me,
    rtlTranslate: Ze,
    wrongRTL: ne
  } = m, rr = m.virtual && ie.virtual.enabled, gr = rr ? m.virtual.slides.length : m.slides.length, or = elementChildren($e, `.${m.params.slideClass}, swiper-slide`), _r = rr ? m.virtual.slides.length : or.length;
  let Lr = [];
  const Ir = [], Ar = [];
  let Rr = ie.slidesOffsetBefore;
  typeof Rr == "function" && (Rr = ie.slidesOffsetBefore.call(m));
  let Nr = ie.slidesOffsetAfter;
  typeof Nr == "function" && (Nr = ie.slidesOffsetAfter.call(m));
  const Yr = m.snapGrid.length, Vr = m.slidesGrid.length;
  let Xr = ie.spaceBetween, Wr = -Rr, si = 0, li = 0;
  if (typeof Me > "u")
    return;
  typeof Xr == "string" && Xr.indexOf("%") >= 0 ? Xr = parseFloat(Xr.replace("%", "")) / 100 * Me : typeof Xr == "string" && (Xr = parseFloat(Xr)), m.virtualSize = -Xr, or.forEach((ci) => {
    Ze ? ci.style.marginLeft = "" : ci.style.marginRight = "", ci.style.marginBottom = "", ci.style.marginTop = "";
  }), ie.centeredSlides && ie.cssMode && (setCSSProperty(we, "--swiper-centered-offset-before", ""), setCSSProperty(we, "--swiper-centered-offset-after", ""));
  const xi = ie.grid && ie.grid.rows > 1 && m.grid;
  xi ? m.grid.initSlides(or) : m.grid && m.grid.unsetSlides();
  let di;
  const oi = ie.slidesPerView === "auto" && ie.breakpoints && Object.keys(ie.breakpoints).filter((ci) => typeof ie.breakpoints[ci].slidesPerView < "u").length > 0;
  for (let ci = 0; ci < _r; ci += 1) {
    di = 0;
    let vr;
    if (or[ci] && (vr = or[ci]), xi && m.grid.updateSlide(ci, vr, or), !(or[ci] && elementStyle(vr, "display") === "none")) {
      if (ie.slidesPerView === "auto") {
        oi && (or[ci].style[m.getDirectionLabel("width")] = "");
        const Ae = getComputedStyle(vr), ze = vr.style.transform, Ue = vr.style.webkitTransform;
        if (ze && (vr.style.transform = "none"), Ue && (vr.style.webkitTransform = "none"), ie.roundLengths)
          di = m.isHorizontal() ? elementOuterSize(vr, "width", !0) : elementOuterSize(vr, "height", !0);
        else {
          const tr = c(Ae, "width"), lr = c(Ae, "padding-left"), pr = c(Ae, "padding-right"), br = c(Ae, "margin-left"), nr = c(Ae, "margin-right"), Pe = Ae.getPropertyValue("box-sizing");
          if (Pe && Pe === "border-box")
            di = tr + br + nr;
          else {
            const {
              clientWidth: ur,
              offsetWidth: Pr
            } = vr;
            di = tr + lr + pr + br + nr + (Pr - ur);
          }
        }
        ze && (vr.style.transform = ze), Ue && (vr.style.webkitTransform = Ue), ie.roundLengths && (di = Math.floor(di));
      } else
        di = (Me - (ie.slidesPerView - 1) * Xr) / ie.slidesPerView, ie.roundLengths && (di = Math.floor(di)), or[ci] && (or[ci].style[m.getDirectionLabel("width")] = `${di}px`);
      or[ci] && (or[ci].swiperSlideSize = di), Ar.push(di), ie.centeredSlides ? (Wr = Wr + di / 2 + si / 2 + Xr, si === 0 && ci !== 0 && (Wr = Wr - Me / 2 - Xr), ci === 0 && (Wr = Wr - Me / 2 - Xr), Math.abs(Wr) < 1 / 1e3 && (Wr = 0), ie.roundLengths && (Wr = Math.floor(Wr)), li % ie.slidesPerGroup === 0 && Lr.push(Wr), Ir.push(Wr)) : (ie.roundLengths && (Wr = Math.floor(Wr)), (li - Math.min(m.params.slidesPerGroupSkip, li)) % m.params.slidesPerGroup === 0 && Lr.push(Wr), Ir.push(Wr), Wr = Wr + di + Xr), m.virtualSize += di + Xr, si = di, li += 1;
    }
  }
  if (m.virtualSize = Math.max(m.virtualSize, Me) + Nr, Ze && ne && (ie.effect === "slide" || ie.effect === "coverflow") && (we.style.width = `${m.virtualSize + Xr}px`), ie.setWrapperSize && (we.style[m.getDirectionLabel("width")] = `${m.virtualSize + Xr}px`), xi && m.grid.updateWrapperSize(di, Lr), !ie.centeredSlides) {
    const ci = [];
    for (let vr = 0; vr < Lr.length; vr += 1) {
      let Ae = Lr[vr];
      ie.roundLengths && (Ae = Math.floor(Ae)), Lr[vr] <= m.virtualSize - Me && ci.push(Ae);
    }
    Lr = ci, Math.floor(m.virtualSize - Me) - Math.floor(Lr[Lr.length - 1]) > 1 && Lr.push(m.virtualSize - Me);
  }
  if (rr && ie.loop) {
    const ci = Ar[0] + Xr;
    if (ie.slidesPerGroup > 1) {
      const vr = Math.ceil((m.virtual.slidesBefore + m.virtual.slidesAfter) / ie.slidesPerGroup), Ae = ci * ie.slidesPerGroup;
      for (let ze = 0; ze < vr; ze += 1)
        Lr.push(Lr[Lr.length - 1] + Ae);
    }
    for (let vr = 0; vr < m.virtual.slidesBefore + m.virtual.slidesAfter; vr += 1)
      ie.slidesPerGroup === 1 && Lr.push(Lr[Lr.length - 1] + ci), Ir.push(Ir[Ir.length - 1] + ci), m.virtualSize += ci;
  }
  if (Lr.length === 0 && (Lr = [0]), Xr !== 0) {
    const ci = m.isHorizontal() && Ze ? "marginLeft" : m.getDirectionLabel("marginRight");
    or.filter((vr, Ae) => !ie.cssMode || ie.loop ? !0 : Ae !== or.length - 1).forEach((vr) => {
      vr.style[ci] = `${Xr}px`;
    });
  }
  if (ie.centeredSlides && ie.centeredSlidesBounds) {
    let ci = 0;
    Ar.forEach((Ae) => {
      ci += Ae + (Xr || 0);
    }), ci -= Xr;
    const vr = ci > Me ? ci - Me : 0;
    Lr = Lr.map((Ae) => Ae <= 0 ? -Rr : Ae > vr ? vr + Nr : Ae);
  }
  if (ie.centerInsufficientSlides) {
    let ci = 0;
    Ar.forEach((Ae) => {
      ci += Ae + (Xr || 0);
    }), ci -= Xr;
    const vr = (ie.slidesOffsetBefore || 0) + (ie.slidesOffsetAfter || 0);
    if (ci + vr < Me) {
      const Ae = (Me - ci - vr) / 2;
      Lr.forEach((ze, Ue) => {
        Lr[Ue] = ze - Ae;
      }), Ir.forEach((ze, Ue) => {
        Ir[Ue] = ze + Ae;
      });
    }
  }
  if (Object.assign(m, {
    slides: or,
    snapGrid: Lr,
    slidesGrid: Ir,
    slidesSizesGrid: Ar
  }), ie.centeredSlides && ie.cssMode && !ie.centeredSlidesBounds) {
    setCSSProperty(we, "--swiper-centered-offset-before", `${-Lr[0]}px`), setCSSProperty(we, "--swiper-centered-offset-after", `${m.size / 2 - Ar[Ar.length - 1] / 2}px`);
    const ci = -m.snapGrid[0], vr = -m.slidesGrid[0];
    m.snapGrid = m.snapGrid.map((Ae) => Ae + ci), m.slidesGrid = m.slidesGrid.map((Ae) => Ae + vr);
  }
  if (_r !== gr && m.emit("slidesLengthChange"), Lr.length !== Yr && (m.params.watchOverflow && m.checkOverflow(), m.emit("snapGridLengthChange")), Ir.length !== Vr && m.emit("slidesGridLengthChange"), ie.watchSlidesProgress && m.updateSlidesOffset(), m.emit("slidesUpdated"), !rr && !ie.cssMode && (ie.effect === "slide" || ie.effect === "fade")) {
    const ci = `${ie.containerModifierClass}backface-hidden`, vr = m.el.classList.contains(ci);
    _r <= ie.maxBackfaceHiddenSlides ? vr || m.el.classList.add(ci) : vr && m.el.classList.remove(ci);
  }
}
function updateAutoHeight(m) {
  const c = this, ie = [], we = c.virtual && c.params.virtual.enabled;
  let $e = 0, Me;
  typeof m == "number" ? c.setTransition(m) : m === !0 && c.setTransition(c.params.speed);
  const Ze = (ne) => we ? c.slides[c.getSlideIndexByData(ne)] : c.slides[ne];
  if (c.params.slidesPerView !== "auto" && c.params.slidesPerView > 1)
    if (c.params.centeredSlides)
      (c.visibleSlides || []).forEach((ne) => {
        ie.push(ne);
      });
    else
      for (Me = 0; Me < Math.ceil(c.params.slidesPerView); Me += 1) {
        const ne = c.activeIndex + Me;
        if (ne > c.slides.length && !we)
          break;
        ie.push(Ze(ne));
      }
  else
    ie.push(Ze(c.activeIndex));
  for (Me = 0; Me < ie.length; Me += 1)
    if (typeof ie[Me] < "u") {
      const ne = ie[Me].offsetHeight;
      $e = ne > $e ? ne : $e;
    }
  ($e || $e === 0) && (c.wrapperEl.style.height = `${$e}px`);
}
function updateSlidesOffset() {
  const m = this, c = m.slides, ie = m.isElement ? m.isHorizontal() ? m.wrapperEl.offsetLeft : m.wrapperEl.offsetTop : 0;
  for (let we = 0; we < c.length; we += 1)
    c[we].swiperSlideOffset = (m.isHorizontal() ? c[we].offsetLeft : c[we].offsetTop) - ie - m.cssOverflowAdjustment();
}
const toggleSlideClasses$1 = (m, c, ie) => {
  c && !m.classList.contains(ie) ? m.classList.add(ie) : !c && m.classList.contains(ie) && m.classList.remove(ie);
};
function updateSlidesProgress(m) {
  m === void 0 && (m = this && this.translate || 0);
  const c = this, ie = c.params, {
    slides: we,
    rtlTranslate: $e,
    snapGrid: Me
  } = c;
  if (we.length === 0)
    return;
  typeof we[0].swiperSlideOffset > "u" && c.updateSlidesOffset();
  let Ze = -m;
  $e && (Ze = m), c.visibleSlidesIndexes = [], c.visibleSlides = [];
  let ne = ie.spaceBetween;
  typeof ne == "string" && ne.indexOf("%") >= 0 ? ne = parseFloat(ne.replace("%", "")) / 100 * c.size : typeof ne == "string" && (ne = parseFloat(ne));
  for (let rr = 0; rr < we.length; rr += 1) {
    const gr = we[rr];
    let or = gr.swiperSlideOffset;
    ie.cssMode && ie.centeredSlides && (or -= we[0].swiperSlideOffset);
    const _r = (Ze + (ie.centeredSlides ? c.minTranslate() : 0) - or) / (gr.swiperSlideSize + ne), Lr = (Ze - Me[0] + (ie.centeredSlides ? c.minTranslate() : 0) - or) / (gr.swiperSlideSize + ne), Ir = -(Ze - or), Ar = Ir + c.slidesSizesGrid[rr], Rr = Ir >= 0 && Ir <= c.size - c.slidesSizesGrid[rr], Nr = Ir >= 0 && Ir < c.size - 1 || Ar > 1 && Ar <= c.size || Ir <= 0 && Ar >= c.size;
    Nr && (c.visibleSlides.push(gr), c.visibleSlidesIndexes.push(rr)), toggleSlideClasses$1(gr, Nr, ie.slideVisibleClass), toggleSlideClasses$1(gr, Rr, ie.slideFullyVisibleClass), gr.progress = $e ? -_r : _r, gr.originalProgress = $e ? -Lr : Lr;
  }
}
function updateProgress(m) {
  const c = this;
  if (typeof m > "u") {
    const or = c.rtlTranslate ? -1 : 1;
    m = c && c.translate && c.translate * or || 0;
  }
  const ie = c.params, we = c.maxTranslate() - c.minTranslate();
  let {
    progress: $e,
    isBeginning: Me,
    isEnd: Ze,
    progressLoop: ne
  } = c;
  const rr = Me, gr = Ze;
  if (we === 0)
    $e = 0, Me = !0, Ze = !0;
  else {
    $e = (m - c.minTranslate()) / we;
    const or = Math.abs(m - c.minTranslate()) < 1, _r = Math.abs(m - c.maxTranslate()) < 1;
    Me = or || $e <= 0, Ze = _r || $e >= 1, or && ($e = 0), _r && ($e = 1);
  }
  if (ie.loop) {
    const or = c.getSlideIndexByData(0), _r = c.getSlideIndexByData(c.slides.length - 1), Lr = c.slidesGrid[or], Ir = c.slidesGrid[_r], Ar = c.slidesGrid[c.slidesGrid.length - 1], Rr = Math.abs(m);
    Rr >= Lr ? ne = (Rr - Lr) / Ar : ne = (Rr + Ar - Ir) / Ar, ne > 1 && (ne -= 1);
  }
  Object.assign(c, {
    progress: $e,
    progressLoop: ne,
    isBeginning: Me,
    isEnd: Ze
  }), (ie.watchSlidesProgress || ie.centeredSlides && ie.autoHeight) && c.updateSlidesProgress(m), Me && !rr && c.emit("reachBeginning toEdge"), Ze && !gr && c.emit("reachEnd toEdge"), (rr && !Me || gr && !Ze) && c.emit("fromEdge"), c.emit("progress", $e);
}
const toggleSlideClasses = (m, c, ie) => {
  c && !m.classList.contains(ie) ? m.classList.add(ie) : !c && m.classList.contains(ie) && m.classList.remove(ie);
};
function updateSlidesClasses() {
  const m = this, {
    slides: c,
    params: ie,
    slidesEl: we,
    activeIndex: $e
  } = m, Me = m.virtual && ie.virtual.enabled, Ze = m.grid && ie.grid && ie.grid.rows > 1, ne = (_r) => elementChildren(we, `.${ie.slideClass}${_r}, swiper-slide${_r}`)[0];
  let rr, gr, or;
  if (Me)
    if (ie.loop) {
      let _r = $e - m.virtual.slidesBefore;
      _r < 0 && (_r = m.virtual.slides.length + _r), _r >= m.virtual.slides.length && (_r -= m.virtual.slides.length), rr = ne(`[data-swiper-slide-index="${_r}"]`);
    } else
      rr = ne(`[data-swiper-slide-index="${$e}"]`);
  else
    Ze ? (rr = c.find((_r) => _r.column === $e), or = c.find((_r) => _r.column === $e + 1), gr = c.find((_r) => _r.column === $e - 1)) : rr = c[$e];
  rr && (Ze || (or = elementNextAll(rr, `.${ie.slideClass}, swiper-slide`)[0], ie.loop && !or && (or = c[0]), gr = elementPrevAll(rr, `.${ie.slideClass}, swiper-slide`)[0], ie.loop && !gr === 0 && (gr = c[c.length - 1]))), c.forEach((_r) => {
    toggleSlideClasses(_r, _r === rr, ie.slideActiveClass), toggleSlideClasses(_r, _r === or, ie.slideNextClass), toggleSlideClasses(_r, _r === gr, ie.slidePrevClass);
  }), m.emitSlidesClasses();
}
const processLazyPreloader = (m, c) => {
  if (!m || m.destroyed || !m.params)
    return;
  const ie = () => m.isElement ? "swiper-slide" : `.${m.params.slideClass}`, we = c.closest(ie());
  if (we) {
    let $e = we.querySelector(`.${m.params.lazyPreloaderClass}`);
    !$e && m.isElement && (we.shadowRoot ? $e = we.shadowRoot.querySelector(`.${m.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      we.shadowRoot && ($e = we.shadowRoot.querySelector(`.${m.params.lazyPreloaderClass}`), $e && $e.remove());
    })), $e && $e.remove();
  }
}, unlazy = (m, c) => {
  if (!m.slides[c])
    return;
  const ie = m.slides[c].querySelector('[loading="lazy"]');
  ie && ie.removeAttribute("loading");
}, preload = (m) => {
  if (!m || m.destroyed || !m.params)
    return;
  let c = m.params.lazyPreloadPrevNext;
  const ie = m.slides.length;
  if (!ie || !c || c < 0)
    return;
  c = Math.min(c, ie);
  const we = m.params.slidesPerView === "auto" ? m.slidesPerViewDynamic() : Math.ceil(m.params.slidesPerView), $e = m.activeIndex;
  if (m.params.grid && m.params.grid.rows > 1) {
    const Ze = $e, ne = [Ze - c];
    ne.push(...Array.from({
      length: c
    }).map((rr, gr) => Ze + we + gr)), m.slides.forEach((rr, gr) => {
      ne.includes(rr.column) && unlazy(m, gr);
    });
    return;
  }
  const Me = $e + we - 1;
  if (m.params.rewind || m.params.loop)
    for (let Ze = $e - c; Ze <= Me + c; Ze += 1) {
      const ne = (Ze % ie + ie) % ie;
      (ne < $e || ne > Me) && unlazy(m, ne);
    }
  else
    for (let Ze = Math.max($e - c, 0); Ze <= Math.min(Me + c, ie - 1); Ze += 1)
      Ze !== $e && (Ze > Me || Ze < $e) && unlazy(m, Ze);
};
function getActiveIndexByTranslate(m) {
  const {
    slidesGrid: c,
    params: ie
  } = m, we = m.rtlTranslate ? m.translate : -m.translate;
  let $e;
  for (let Me = 0; Me < c.length; Me += 1)
    typeof c[Me + 1] < "u" ? we >= c[Me] && we < c[Me + 1] - (c[Me + 1] - c[Me]) / 2 ? $e = Me : we >= c[Me] && we < c[Me + 1] && ($e = Me + 1) : we >= c[Me] && ($e = Me);
  return ie.normalizeSlideIndex && ($e < 0 || typeof $e > "u") && ($e = 0), $e;
}
function updateActiveIndex(m) {
  const c = this, ie = c.rtlTranslate ? c.translate : -c.translate, {
    snapGrid: we,
    params: $e,
    activeIndex: Me,
    realIndex: Ze,
    snapIndex: ne
  } = c;
  let rr = m, gr;
  const or = (Ir) => {
    let Ar = Ir - c.virtual.slidesBefore;
    return Ar < 0 && (Ar = c.virtual.slides.length + Ar), Ar >= c.virtual.slides.length && (Ar -= c.virtual.slides.length), Ar;
  };
  if (typeof rr > "u" && (rr = getActiveIndexByTranslate(c)), we.indexOf(ie) >= 0)
    gr = we.indexOf(ie);
  else {
    const Ir = Math.min($e.slidesPerGroupSkip, rr);
    gr = Ir + Math.floor((rr - Ir) / $e.slidesPerGroup);
  }
  if (gr >= we.length && (gr = we.length - 1), rr === Me && !c.params.loop) {
    gr !== ne && (c.snapIndex = gr, c.emit("snapIndexChange"));
    return;
  }
  if (rr === Me && c.params.loop && c.virtual && c.params.virtual.enabled) {
    c.realIndex = or(rr);
    return;
  }
  const _r = c.grid && $e.grid && $e.grid.rows > 1;
  let Lr;
  if (c.virtual && $e.virtual.enabled && $e.loop)
    Lr = or(rr);
  else if (_r) {
    const Ir = c.slides.find((Rr) => Rr.column === rr);
    let Ar = parseInt(Ir.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(Ar) && (Ar = Math.max(c.slides.indexOf(Ir), 0)), Lr = Math.floor(Ar / $e.grid.rows);
  } else if (c.slides[rr]) {
    const Ir = c.slides[rr].getAttribute("data-swiper-slide-index");
    Ir ? Lr = parseInt(Ir, 10) : Lr = rr;
  } else
    Lr = rr;
  Object.assign(c, {
    previousSnapIndex: ne,
    snapIndex: gr,
    previousRealIndex: Ze,
    realIndex: Lr,
    previousIndex: Me,
    activeIndex: rr
  }), c.initialized && preload(c), c.emit("activeIndexChange"), c.emit("snapIndexChange"), (c.initialized || c.params.runCallbacksOnInit) && (Ze !== Lr && c.emit("realIndexChange"), c.emit("slideChange"));
}
function updateClickedSlide(m, c) {
  const ie = this, we = ie.params;
  let $e = m.closest(`.${we.slideClass}, swiper-slide`);
  !$e && ie.isElement && c && c.length > 1 && c.includes(m) && [...c.slice(c.indexOf(m) + 1, c.length)].forEach((ne) => {
    !$e && ne.matches && ne.matches(`.${we.slideClass}, swiper-slide`) && ($e = ne);
  });
  let Me = !1, Ze;
  if ($e) {
    for (let ne = 0; ne < ie.slides.length; ne += 1)
      if (ie.slides[ne] === $e) {
        Me = !0, Ze = ne;
        break;
      }
  }
  if ($e && Me)
    ie.clickedSlide = $e, ie.virtual && ie.params.virtual.enabled ? ie.clickedIndex = parseInt($e.getAttribute("data-swiper-slide-index"), 10) : ie.clickedIndex = Ze;
  else {
    ie.clickedSlide = void 0, ie.clickedIndex = void 0;
    return;
  }
  we.slideToClickedSlide && ie.clickedIndex !== void 0 && ie.clickedIndex !== ie.activeIndex && ie.slideToClickedSlide();
}
var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};
function getSwiperTranslate(m) {
  m === void 0 && (m = this.isHorizontal() ? "x" : "y");
  const c = this, {
    params: ie,
    rtlTranslate: we,
    translate: $e,
    wrapperEl: Me
  } = c;
  if (ie.virtualTranslate)
    return we ? -$e : $e;
  if (ie.cssMode)
    return $e;
  let Ze = getTranslate(Me, m);
  return Ze += c.cssOverflowAdjustment(), we && (Ze = -Ze), Ze || 0;
}
function setTranslate(m, c) {
  const ie = this, {
    rtlTranslate: we,
    params: $e,
    wrapperEl: Me,
    progress: Ze
  } = ie;
  let ne = 0, rr = 0;
  const gr = 0;
  ie.isHorizontal() ? ne = we ? -m : m : rr = m, $e.roundLengths && (ne = Math.floor(ne), rr = Math.floor(rr)), ie.previousTranslate = ie.translate, ie.translate = ie.isHorizontal() ? ne : rr, $e.cssMode ? Me[ie.isHorizontal() ? "scrollLeft" : "scrollTop"] = ie.isHorizontal() ? -ne : -rr : $e.virtualTranslate || (ie.isHorizontal() ? ne -= ie.cssOverflowAdjustment() : rr -= ie.cssOverflowAdjustment(), Me.style.transform = `translate3d(${ne}px, ${rr}px, ${gr}px)`);
  let or;
  const _r = ie.maxTranslate() - ie.minTranslate();
  _r === 0 ? or = 0 : or = (m - ie.minTranslate()) / _r, or !== Ze && ie.updateProgress(m), ie.emit("setTranslate", ie.translate, c);
}
function minTranslate() {
  return -this.snapGrid[0];
}
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(m, c, ie, we, $e) {
  m === void 0 && (m = 0), c === void 0 && (c = this.params.speed), ie === void 0 && (ie = !0), we === void 0 && (we = !0);
  const Me = this, {
    params: Ze,
    wrapperEl: ne
  } = Me;
  if (Me.animating && Ze.preventInteractionOnTransition)
    return !1;
  const rr = Me.minTranslate(), gr = Me.maxTranslate();
  let or;
  if (we && m > rr ? or = rr : we && m < gr ? or = gr : or = m, Me.updateProgress(or), Ze.cssMode) {
    const _r = Me.isHorizontal();
    if (c === 0)
      ne[_r ? "scrollLeft" : "scrollTop"] = -or;
    else {
      if (!Me.support.smoothScroll)
        return animateCSSModeScroll({
          swiper: Me,
          targetPosition: -or,
          side: _r ? "left" : "top"
        }), !0;
      ne.scrollTo({
        [_r ? "left" : "top"]: -or,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return c === 0 ? (Me.setTransition(0), Me.setTranslate(or), ie && (Me.emit("beforeTransitionStart", c, $e), Me.emit("transitionEnd"))) : (Me.setTransition(c), Me.setTranslate(or), ie && (Me.emit("beforeTransitionStart", c, $e), Me.emit("transitionStart")), Me.animating || (Me.animating = !0, Me.onTranslateToWrapperTransitionEnd || (Me.onTranslateToWrapperTransitionEnd = function(Lr) {
    !Me || Me.destroyed || Lr.target === this && (Me.wrapperEl.removeEventListener("transitionend", Me.onTranslateToWrapperTransitionEnd), Me.onTranslateToWrapperTransitionEnd = null, delete Me.onTranslateToWrapperTransitionEnd, Me.animating = !1, ie && Me.emit("transitionEnd"));
  }), Me.wrapperEl.addEventListener("transitionend", Me.onTranslateToWrapperTransitionEnd))), !0;
}
var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};
function setTransition(m, c) {
  const ie = this;
  ie.params.cssMode || (ie.wrapperEl.style.transitionDuration = `${m}ms`, ie.wrapperEl.style.transitionDelay = m === 0 ? "0ms" : ""), ie.emit("setTransition", m, c);
}
function transitionEmit(m) {
  let {
    swiper: c,
    runCallbacks: ie,
    direction: we,
    step: $e
  } = m;
  const {
    activeIndex: Me,
    previousIndex: Ze
  } = c;
  let ne = we;
  if (ne || (Me > Ze ? ne = "next" : Me < Ze ? ne = "prev" : ne = "reset"), c.emit(`transition${$e}`), ie && Me !== Ze) {
    if (ne === "reset") {
      c.emit(`slideResetTransition${$e}`);
      return;
    }
    c.emit(`slideChangeTransition${$e}`), ne === "next" ? c.emit(`slideNextTransition${$e}`) : c.emit(`slidePrevTransition${$e}`);
  }
}
function transitionStart(m, c) {
  m === void 0 && (m = !0);
  const ie = this, {
    params: we
  } = ie;
  we.cssMode || (we.autoHeight && ie.updateAutoHeight(), transitionEmit({
    swiper: ie,
    runCallbacks: m,
    direction: c,
    step: "Start"
  }));
}
function transitionEnd(m, c) {
  m === void 0 && (m = !0);
  const ie = this, {
    params: we
  } = ie;
  ie.animating = !1, !we.cssMode && (ie.setTransition(0), transitionEmit({
    swiper: ie,
    runCallbacks: m,
    direction: c,
    step: "End"
  }));
}
var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};
function slideTo(m, c, ie, we, $e) {
  m === void 0 && (m = 0), ie === void 0 && (ie = !0), typeof m == "string" && (m = parseInt(m, 10));
  const Me = this;
  let Ze = m;
  Ze < 0 && (Ze = 0);
  const {
    params: ne,
    snapGrid: rr,
    slidesGrid: gr,
    previousIndex: or,
    activeIndex: _r,
    rtlTranslate: Lr,
    wrapperEl: Ir,
    enabled: Ar
  } = Me;
  if (!Ar && !we && !$e || Me.destroyed || Me.animating && ne.preventInteractionOnTransition)
    return !1;
  typeof c > "u" && (c = Me.params.speed);
  const Rr = Math.min(Me.params.slidesPerGroupSkip, Ze);
  let Nr = Rr + Math.floor((Ze - Rr) / Me.params.slidesPerGroup);
  Nr >= rr.length && (Nr = rr.length - 1);
  const Yr = -rr[Nr];
  if (ne.normalizeSlideIndex)
    for (let si = 0; si < gr.length; si += 1) {
      const li = -Math.floor(Yr * 100), xi = Math.floor(gr[si] * 100), di = Math.floor(gr[si + 1] * 100);
      typeof gr[si + 1] < "u" ? li >= xi && li < di - (di - xi) / 2 ? Ze = si : li >= xi && li < di && (Ze = si + 1) : li >= xi && (Ze = si);
    }
  if (Me.initialized && Ze !== _r && (!Me.allowSlideNext && (Lr ? Yr > Me.translate && Yr > Me.minTranslate() : Yr < Me.translate && Yr < Me.minTranslate()) || !Me.allowSlidePrev && Yr > Me.translate && Yr > Me.maxTranslate() && (_r || 0) !== Ze))
    return !1;
  Ze !== (or || 0) && ie && Me.emit("beforeSlideChangeStart"), Me.updateProgress(Yr);
  let Vr;
  Ze > _r ? Vr = "next" : Ze < _r ? Vr = "prev" : Vr = "reset";
  const Xr = Me.virtual && Me.params.virtual.enabled;
  if (!(Xr && $e) && (Lr && -Yr === Me.translate || !Lr && Yr === Me.translate))
    return Me.updateActiveIndex(Ze), ne.autoHeight && Me.updateAutoHeight(), Me.updateSlidesClasses(), ne.effect !== "slide" && Me.setTranslate(Yr), Vr !== "reset" && (Me.transitionStart(ie, Vr), Me.transitionEnd(ie, Vr)), !1;
  if (ne.cssMode) {
    const si = Me.isHorizontal(), li = Lr ? Yr : -Yr;
    if (c === 0)
      Xr && (Me.wrapperEl.style.scrollSnapType = "none", Me._immediateVirtual = !0), Xr && !Me._cssModeVirtualInitialSet && Me.params.initialSlide > 0 ? (Me._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        Ir[si ? "scrollLeft" : "scrollTop"] = li;
      })) : Ir[si ? "scrollLeft" : "scrollTop"] = li, Xr && requestAnimationFrame(() => {
        Me.wrapperEl.style.scrollSnapType = "", Me._immediateVirtual = !1;
      });
    else {
      if (!Me.support.smoothScroll)
        return animateCSSModeScroll({
          swiper: Me,
          targetPosition: li,
          side: si ? "left" : "top"
        }), !0;
      Ir.scrollTo({
        [si ? "left" : "top"]: li,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return Me.setTransition(c), Me.setTranslate(Yr), Me.updateActiveIndex(Ze), Me.updateSlidesClasses(), Me.emit("beforeTransitionStart", c, we), Me.transitionStart(ie, Vr), c === 0 ? Me.transitionEnd(ie, Vr) : Me.animating || (Me.animating = !0, Me.onSlideToWrapperTransitionEnd || (Me.onSlideToWrapperTransitionEnd = function(li) {
    !Me || Me.destroyed || li.target === this && (Me.wrapperEl.removeEventListener("transitionend", Me.onSlideToWrapperTransitionEnd), Me.onSlideToWrapperTransitionEnd = null, delete Me.onSlideToWrapperTransitionEnd, Me.transitionEnd(ie, Vr));
  }), Me.wrapperEl.addEventListener("transitionend", Me.onSlideToWrapperTransitionEnd)), !0;
}
function slideToLoop(m, c, ie, we) {
  m === void 0 && (m = 0), ie === void 0 && (ie = !0), typeof m == "string" && (m = parseInt(m, 10));
  const $e = this;
  if ($e.destroyed)
    return;
  typeof c > "u" && (c = $e.params.speed);
  const Me = $e.grid && $e.params.grid && $e.params.grid.rows > 1;
  let Ze = m;
  if ($e.params.loop)
    if ($e.virtual && $e.params.virtual.enabled)
      Ze = Ze + $e.virtual.slidesBefore;
    else {
      let ne;
      if (Me) {
        const Lr = Ze * $e.params.grid.rows;
        ne = $e.slides.find((Ir) => Ir.getAttribute("data-swiper-slide-index") * 1 === Lr).column;
      } else
        ne = $e.getSlideIndexByData(Ze);
      const rr = Me ? Math.ceil($e.slides.length / $e.params.grid.rows) : $e.slides.length, {
        centeredSlides: gr
      } = $e.params;
      let or = $e.params.slidesPerView;
      or === "auto" ? or = $e.slidesPerViewDynamic() : (or = Math.ceil(parseFloat($e.params.slidesPerView, 10)), gr && or % 2 === 0 && (or = or + 1));
      let _r = rr - ne < or;
      if (gr && (_r = _r || ne < Math.ceil(or / 2)), we && gr && $e.params.slidesPerView !== "auto" && !Me && (_r = !1), _r) {
        const Lr = gr ? ne < $e.activeIndex ? "prev" : "next" : ne - $e.activeIndex - 1 < $e.params.slidesPerView ? "next" : "prev";
        $e.loopFix({
          direction: Lr,
          slideTo: !0,
          activeSlideIndex: Lr === "next" ? ne + 1 : ne - rr + 1,
          slideRealIndex: Lr === "next" ? $e.realIndex : void 0
        });
      }
      if (Me) {
        const Lr = Ze * $e.params.grid.rows;
        Ze = $e.slides.find((Ir) => Ir.getAttribute("data-swiper-slide-index") * 1 === Lr).column;
      } else
        Ze = $e.getSlideIndexByData(Ze);
    }
  return requestAnimationFrame(() => {
    $e.slideTo(Ze, c, ie, we);
  }), $e;
}
function slideNext(m, c, ie) {
  c === void 0 && (c = !0);
  const we = this, {
    enabled: $e,
    params: Me,
    animating: Ze
  } = we;
  if (!$e || we.destroyed)
    return we;
  typeof m > "u" && (m = we.params.speed);
  let ne = Me.slidesPerGroup;
  Me.slidesPerView === "auto" && Me.slidesPerGroup === 1 && Me.slidesPerGroupAuto && (ne = Math.max(we.slidesPerViewDynamic("current", !0), 1));
  const rr = we.activeIndex < Me.slidesPerGroupSkip ? 1 : ne, gr = we.virtual && Me.virtual.enabled;
  if (Me.loop) {
    if (Ze && !gr && Me.loopPreventsSliding)
      return !1;
    if (we.loopFix({
      direction: "next"
    }), we._clientLeft = we.wrapperEl.clientLeft, we.activeIndex === we.slides.length - 1 && Me.cssMode)
      return requestAnimationFrame(() => {
        we.slideTo(we.activeIndex + rr, m, c, ie);
      }), !0;
  }
  return Me.rewind && we.isEnd ? we.slideTo(0, m, c, ie) : we.slideTo(we.activeIndex + rr, m, c, ie);
}
function slidePrev(m, c, ie) {
  c === void 0 && (c = !0);
  const we = this, {
    params: $e,
    snapGrid: Me,
    slidesGrid: Ze,
    rtlTranslate: ne,
    enabled: rr,
    animating: gr
  } = we;
  if (!rr || we.destroyed)
    return we;
  typeof m > "u" && (m = we.params.speed);
  const or = we.virtual && $e.virtual.enabled;
  if ($e.loop) {
    if (gr && !or && $e.loopPreventsSliding)
      return !1;
    we.loopFix({
      direction: "prev"
    }), we._clientLeft = we.wrapperEl.clientLeft;
  }
  const _r = ne ? we.translate : -we.translate;
  function Lr(Yr) {
    return Yr < 0 ? -Math.floor(Math.abs(Yr)) : Math.floor(Yr);
  }
  const Ir = Lr(_r), Ar = Me.map((Yr) => Lr(Yr));
  let Rr = Me[Ar.indexOf(Ir) - 1];
  if (typeof Rr > "u" && $e.cssMode) {
    let Yr;
    Me.forEach((Vr, Xr) => {
      Ir >= Vr && (Yr = Xr);
    }), typeof Yr < "u" && (Rr = Me[Yr > 0 ? Yr - 1 : Yr]);
  }
  let Nr = 0;
  if (typeof Rr < "u" && (Nr = Ze.indexOf(Rr), Nr < 0 && (Nr = we.activeIndex - 1), $e.slidesPerView === "auto" && $e.slidesPerGroup === 1 && $e.slidesPerGroupAuto && (Nr = Nr - we.slidesPerViewDynamic("previous", !0) + 1, Nr = Math.max(Nr, 0))), $e.rewind && we.isBeginning) {
    const Yr = we.params.virtual && we.params.virtual.enabled && we.virtual ? we.virtual.slides.length - 1 : we.slides.length - 1;
    return we.slideTo(Yr, m, c, ie);
  } else if ($e.loop && we.activeIndex === 0 && $e.cssMode)
    return requestAnimationFrame(() => {
      we.slideTo(Nr, m, c, ie);
    }), !0;
  return we.slideTo(Nr, m, c, ie);
}
function slideReset(m, c, ie) {
  c === void 0 && (c = !0);
  const we = this;
  if (!we.destroyed)
    return typeof m > "u" && (m = we.params.speed), we.slideTo(we.activeIndex, m, c, ie);
}
function slideToClosest(m, c, ie, we) {
  c === void 0 && (c = !0), we === void 0 && (we = 0.5);
  const $e = this;
  if ($e.destroyed)
    return;
  typeof m > "u" && (m = $e.params.speed);
  let Me = $e.activeIndex;
  const Ze = Math.min($e.params.slidesPerGroupSkip, Me), ne = Ze + Math.floor((Me - Ze) / $e.params.slidesPerGroup), rr = $e.rtlTranslate ? $e.translate : -$e.translate;
  if (rr >= $e.snapGrid[ne]) {
    const gr = $e.snapGrid[ne], or = $e.snapGrid[ne + 1];
    rr - gr > (or - gr) * we && (Me += $e.params.slidesPerGroup);
  } else {
    const gr = $e.snapGrid[ne - 1], or = $e.snapGrid[ne];
    rr - gr <= (or - gr) * we && (Me -= $e.params.slidesPerGroup);
  }
  return Me = Math.max(Me, 0), Me = Math.min(Me, $e.slidesGrid.length - 1), $e.slideTo(Me, m, c, ie);
}
function slideToClickedSlide() {
  const m = this;
  if (m.destroyed)
    return;
  const {
    params: c,
    slidesEl: ie
  } = m, we = c.slidesPerView === "auto" ? m.slidesPerViewDynamic() : c.slidesPerView;
  let $e = m.clickedIndex, Me;
  const Ze = m.isElement ? "swiper-slide" : `.${c.slideClass}`;
  if (c.loop) {
    if (m.animating)
      return;
    Me = parseInt(m.clickedSlide.getAttribute("data-swiper-slide-index"), 10), c.centeredSlides ? $e < m.loopedSlides - we / 2 || $e > m.slides.length - m.loopedSlides + we / 2 ? (m.loopFix(), $e = m.getSlideIndex(elementChildren(ie, `${Ze}[data-swiper-slide-index="${Me}"]`)[0]), nextTick(() => {
      m.slideTo($e);
    })) : m.slideTo($e) : $e > m.slides.length - we ? (m.loopFix(), $e = m.getSlideIndex(elementChildren(ie, `${Ze}[data-swiper-slide-index="${Me}"]`)[0]), nextTick(() => {
      m.slideTo($e);
    })) : m.slideTo($e);
  } else
    m.slideTo($e);
}
var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};
function loopCreate(m) {
  const c = this, {
    params: ie,
    slidesEl: we
  } = c;
  if (!ie.loop || c.virtual && c.params.virtual.enabled)
    return;
  const $e = () => {
    elementChildren(we, `.${ie.slideClass}, swiper-slide`).forEach((_r, Lr) => {
      _r.setAttribute("data-swiper-slide-index", Lr);
    });
  }, Me = c.grid && ie.grid && ie.grid.rows > 1, Ze = ie.slidesPerGroup * (Me ? ie.grid.rows : 1), ne = c.slides.length % Ze !== 0, rr = Me && c.slides.length % ie.grid.rows !== 0, gr = (or) => {
    for (let _r = 0; _r < or; _r += 1) {
      const Lr = c.isElement ? createElement("swiper-slide", [ie.slideBlankClass]) : createElement("div", [ie.slideClass, ie.slideBlankClass]);
      c.slidesEl.append(Lr);
    }
  };
  if (ne) {
    if (ie.loopAddBlankSlides) {
      const or = Ze - c.slides.length % Ze;
      gr(or), c.recalcSlides(), c.updateSlides();
    } else
      showWarning("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    $e();
  } else if (rr) {
    if (ie.loopAddBlankSlides) {
      const or = ie.grid.rows - c.slides.length % ie.grid.rows;
      gr(or), c.recalcSlides(), c.updateSlides();
    } else
      showWarning("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    $e();
  } else
    $e();
  c.loopFix({
    slideRealIndex: m,
    direction: ie.centeredSlides ? void 0 : "next"
  });
}
function loopFix(m) {
  let {
    slideRealIndex: c,
    slideTo: ie = !0,
    direction: we,
    setTranslate: $e,
    activeSlideIndex: Me,
    byController: Ze,
    byMousewheel: ne
  } = m === void 0 ? {} : m;
  const rr = this;
  if (!rr.params.loop)
    return;
  rr.emit("beforeLoopFix");
  const {
    slides: gr,
    allowSlidePrev: or,
    allowSlideNext: _r,
    slidesEl: Lr,
    params: Ir
  } = rr, {
    centeredSlides: Ar
  } = Ir;
  if (rr.allowSlidePrev = !0, rr.allowSlideNext = !0, rr.virtual && Ir.virtual.enabled) {
    ie && (!Ir.centeredSlides && rr.snapIndex === 0 ? rr.slideTo(rr.virtual.slides.length, 0, !1, !0) : Ir.centeredSlides && rr.snapIndex < Ir.slidesPerView ? rr.slideTo(rr.virtual.slides.length + rr.snapIndex, 0, !1, !0) : rr.snapIndex === rr.snapGrid.length - 1 && rr.slideTo(rr.virtual.slidesBefore, 0, !1, !0)), rr.allowSlidePrev = or, rr.allowSlideNext = _r, rr.emit("loopFix");
    return;
  }
  let Rr = Ir.slidesPerView;
  Rr === "auto" ? Rr = rr.slidesPerViewDynamic() : (Rr = Math.ceil(parseFloat(Ir.slidesPerView, 10)), Ar && Rr % 2 === 0 && (Rr = Rr + 1));
  const Nr = Ir.slidesPerGroupAuto ? Rr : Ir.slidesPerGroup;
  let Yr = Nr;
  Yr % Nr !== 0 && (Yr += Nr - Yr % Nr), Yr += Ir.loopAdditionalSlides, rr.loopedSlides = Yr;
  const Vr = rr.grid && Ir.grid && Ir.grid.rows > 1;
  gr.length < Rr + Yr ? showWarning("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : Vr && Ir.grid.fill === "row" && showWarning("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const Xr = [], Wr = [];
  let si = rr.activeIndex;
  typeof Me > "u" ? Me = rr.getSlideIndex(gr.find((ze) => ze.classList.contains(Ir.slideActiveClass))) : si = Me;
  const li = we === "next" || !we, xi = we === "prev" || !we;
  let di = 0, oi = 0;
  const ci = Vr ? Math.ceil(gr.length / Ir.grid.rows) : gr.length, Ae = (Vr ? gr[Me].column : Me) + (Ar && typeof $e > "u" ? -Rr / 2 + 0.5 : 0);
  if (Ae < Yr) {
    di = Math.max(Yr - Ae, Nr);
    for (let ze = 0; ze < Yr - Ae; ze += 1) {
      const Ue = ze - Math.floor(ze / ci) * ci;
      if (Vr) {
        const tr = ci - Ue - 1;
        for (let lr = gr.length - 1; lr >= 0; lr -= 1)
          gr[lr].column === tr && Xr.push(lr);
      } else
        Xr.push(ci - Ue - 1);
    }
  } else if (Ae + Rr > ci - Yr) {
    oi = Math.max(Ae - (ci - Yr * 2), Nr);
    for (let ze = 0; ze < oi; ze += 1) {
      const Ue = ze - Math.floor(ze / ci) * ci;
      Vr ? gr.forEach((tr, lr) => {
        tr.column === Ue && Wr.push(lr);
      }) : Wr.push(Ue);
    }
  }
  if (rr.__preventObserver__ = !0, requestAnimationFrame(() => {
    rr.__preventObserver__ = !1;
  }), xi && Xr.forEach((ze) => {
    gr[ze].swiperLoopMoveDOM = !0, Lr.prepend(gr[ze]), gr[ze].swiperLoopMoveDOM = !1;
  }), li && Wr.forEach((ze) => {
    gr[ze].swiperLoopMoveDOM = !0, Lr.append(gr[ze]), gr[ze].swiperLoopMoveDOM = !1;
  }), rr.recalcSlides(), Ir.slidesPerView === "auto" ? rr.updateSlides() : Vr && (Xr.length > 0 && xi || Wr.length > 0 && li) && rr.slides.forEach((ze, Ue) => {
    rr.grid.updateSlide(Ue, ze, rr.slides);
  }), Ir.watchSlidesProgress && rr.updateSlidesOffset(), ie) {
    if (Xr.length > 0 && xi) {
      if (typeof c > "u") {
        const ze = rr.slidesGrid[si], tr = rr.slidesGrid[si + di] - ze;
        ne ? rr.setTranslate(rr.translate - tr) : (rr.slideTo(si + Math.ceil(di), 0, !1, !0), $e && (rr.touchEventsData.startTranslate = rr.touchEventsData.startTranslate - tr, rr.touchEventsData.currentTranslate = rr.touchEventsData.currentTranslate - tr));
      } else if ($e) {
        const ze = Vr ? Xr.length / Ir.grid.rows : Xr.length;
        rr.slideTo(rr.activeIndex + ze, 0, !1, !0), rr.touchEventsData.currentTranslate = rr.translate;
      }
    } else if (Wr.length > 0 && li)
      if (typeof c > "u") {
        const ze = rr.slidesGrid[si], tr = rr.slidesGrid[si - oi] - ze;
        ne ? rr.setTranslate(rr.translate - tr) : (rr.slideTo(si - oi, 0, !1, !0), $e && (rr.touchEventsData.startTranslate = rr.touchEventsData.startTranslate - tr, rr.touchEventsData.currentTranslate = rr.touchEventsData.currentTranslate - tr));
      } else {
        const ze = Vr ? Wr.length / Ir.grid.rows : Wr.length;
        rr.slideTo(rr.activeIndex - ze, 0, !1, !0);
      }
  }
  if (rr.allowSlidePrev = or, rr.allowSlideNext = _r, rr.controller && rr.controller.control && !Ze) {
    const ze = {
      slideRealIndex: c,
      direction: we,
      setTranslate: $e,
      activeSlideIndex: Me,
      byController: !0
    };
    Array.isArray(rr.controller.control) ? rr.controller.control.forEach((Ue) => {
      !Ue.destroyed && Ue.params.loop && Ue.loopFix({
        ...ze,
        slideTo: Ue.params.slidesPerView === Ir.slidesPerView ? ie : !1
      });
    }) : rr.controller.control instanceof rr.constructor && rr.controller.control.params.loop && rr.controller.control.loopFix({
      ...ze,
      slideTo: rr.controller.control.params.slidesPerView === Ir.slidesPerView ? ie : !1
    });
  }
  rr.emit("loopFix");
}
function loopDestroy() {
  const m = this, {
    params: c,
    slidesEl: ie
  } = m;
  if (!c.loop || m.virtual && m.params.virtual.enabled)
    return;
  m.recalcSlides();
  const we = [];
  m.slides.forEach(($e) => {
    const Me = typeof $e.swiperSlideIndex > "u" ? $e.getAttribute("data-swiper-slide-index") * 1 : $e.swiperSlideIndex;
    we[Me] = $e;
  }), m.slides.forEach(($e) => {
    $e.removeAttribute("data-swiper-slide-index");
  }), we.forEach(($e) => {
    ie.append($e);
  }), m.recalcSlides(), m.slideTo(m.realIndex, 0);
}
var loop = {
  loopCreate,
  loopFix,
  loopDestroy
};
function setGrabCursor(m) {
  const c = this;
  if (!c.params.simulateTouch || c.params.watchOverflow && c.isLocked || c.params.cssMode)
    return;
  const ie = c.params.touchEventsTarget === "container" ? c.el : c.wrapperEl;
  c.isElement && (c.__preventObserver__ = !0), ie.style.cursor = "move", ie.style.cursor = m ? "grabbing" : "grab", c.isElement && requestAnimationFrame(() => {
    c.__preventObserver__ = !1;
  });
}
function unsetGrabCursor() {
  const m = this;
  m.params.watchOverflow && m.isLocked || m.params.cssMode || (m.isElement && (m.__preventObserver__ = !0), m[m.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", m.isElement && requestAnimationFrame(() => {
    m.__preventObserver__ = !1;
  }));
}
var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};
function closestElement(m, c) {
  c === void 0 && (c = this);
  function ie(we) {
    if (!we || we === getDocument() || we === getWindow())
      return null;
    we.assignedSlot && (we = we.assignedSlot);
    const $e = we.closest(m);
    return !$e && !we.getRootNode ? null : $e || ie(we.getRootNode().host);
  }
  return ie(c);
}
function preventEdgeSwipe(m, c, ie) {
  const we = getWindow(), {
    params: $e
  } = m, Me = $e.edgeSwipeDetection, Ze = $e.edgeSwipeThreshold;
  return Me && (ie <= Ze || ie >= we.innerWidth - Ze) ? Me === "prevent" ? (c.preventDefault(), !0) : !1 : !0;
}
function onTouchStart(m) {
  const c = this, ie = getDocument();
  let we = m;
  we.originalEvent && (we = we.originalEvent);
  const $e = c.touchEventsData;
  if (we.type === "pointerdown") {
    if ($e.pointerId !== null && $e.pointerId !== we.pointerId)
      return;
    $e.pointerId = we.pointerId;
  } else
    we.type === "touchstart" && we.targetTouches.length === 1 && ($e.touchId = we.targetTouches[0].identifier);
  if (we.type === "touchstart") {
    preventEdgeSwipe(c, we, we.targetTouches[0].pageX);
    return;
  }
  const {
    params: Me,
    touches: Ze,
    enabled: ne
  } = c;
  if (!ne || !Me.simulateTouch && we.pointerType === "mouse" || c.animating && Me.preventInteractionOnTransition)
    return;
  !c.animating && Me.cssMode && Me.loop && c.loopFix();
  let rr = we.target;
  if (Me.touchEventsTarget === "wrapper" && !elementIsChildOf(rr, c.wrapperEl) || "which" in we && we.which === 3 || "button" in we && we.button > 0 || $e.isTouched && $e.isMoved)
    return;
  const gr = !!Me.noSwipingClass && Me.noSwipingClass !== "", or = we.composedPath ? we.composedPath() : we.path;
  gr && we.target && we.target.shadowRoot && or && (rr = or[0]);
  const _r = Me.noSwipingSelector ? Me.noSwipingSelector : `.${Me.noSwipingClass}`, Lr = !!(we.target && we.target.shadowRoot);
  if (Me.noSwiping && (Lr ? closestElement(_r, rr) : rr.closest(_r))) {
    c.allowClick = !0;
    return;
  }
  if (Me.swipeHandler && !rr.closest(Me.swipeHandler))
    return;
  Ze.currentX = we.pageX, Ze.currentY = we.pageY;
  const Ir = Ze.currentX, Ar = Ze.currentY;
  if (!preventEdgeSwipe(c, we, Ir))
    return;
  Object.assign($e, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), Ze.startX = Ir, Ze.startY = Ar, $e.touchStartTime = now(), c.allowClick = !0, c.updateSize(), c.swipeDirection = void 0, Me.threshold > 0 && ($e.allowThresholdMove = !1);
  let Rr = !0;
  rr.matches($e.focusableElements) && (Rr = !1, rr.nodeName === "SELECT" && ($e.isTouched = !1)), ie.activeElement && ie.activeElement.matches($e.focusableElements) && ie.activeElement !== rr && (we.pointerType === "mouse" || we.pointerType !== "mouse" && !rr.matches($e.focusableElements)) && ie.activeElement.blur();
  const Nr = Rr && c.allowTouchMove && Me.touchStartPreventDefault;
  (Me.touchStartForcePreventDefault || Nr) && !rr.isContentEditable && we.preventDefault(), Me.freeMode && Me.freeMode.enabled && c.freeMode && c.animating && !Me.cssMode && c.freeMode.onTouchStart(), c.emit("touchStart", we);
}
function onTouchMove(m) {
  const c = getDocument(), ie = this, we = ie.touchEventsData, {
    params: $e,
    touches: Me,
    rtlTranslate: Ze,
    enabled: ne
  } = ie;
  if (!ne || !$e.simulateTouch && m.pointerType === "mouse")
    return;
  let rr = m;
  if (rr.originalEvent && (rr = rr.originalEvent), rr.type === "pointermove" && (we.touchId !== null || rr.pointerId !== we.pointerId))
    return;
  let gr;
  if (rr.type === "touchmove") {
    if (gr = [...rr.changedTouches].find((li) => li.identifier === we.touchId), !gr || gr.identifier !== we.touchId)
      return;
  } else
    gr = rr;
  if (!we.isTouched) {
    we.startMoving && we.isScrolling && ie.emit("touchMoveOpposite", rr);
    return;
  }
  const or = gr.pageX, _r = gr.pageY;
  if (rr.preventedByNestedSwiper) {
    Me.startX = or, Me.startY = _r;
    return;
  }
  if (!ie.allowTouchMove) {
    rr.target.matches(we.focusableElements) || (ie.allowClick = !1), we.isTouched && (Object.assign(Me, {
      startX: or,
      startY: _r,
      currentX: or,
      currentY: _r
    }), we.touchStartTime = now());
    return;
  }
  if ($e.touchReleaseOnEdges && !$e.loop) {
    if (ie.isVertical()) {
      if (_r < Me.startY && ie.translate <= ie.maxTranslate() || _r > Me.startY && ie.translate >= ie.minTranslate()) {
        we.isTouched = !1, we.isMoved = !1;
        return;
      }
    } else if (or < Me.startX && ie.translate <= ie.maxTranslate() || or > Me.startX && ie.translate >= ie.minTranslate())
      return;
  }
  if (c.activeElement && c.activeElement.matches(we.focusableElements) && c.activeElement !== rr.target && rr.pointerType !== "mouse" && c.activeElement.blur(), c.activeElement && rr.target === c.activeElement && rr.target.matches(we.focusableElements)) {
    we.isMoved = !0, ie.allowClick = !1;
    return;
  }
  we.allowTouchCallbacks && ie.emit("touchMove", rr), Me.previousX = Me.currentX, Me.previousY = Me.currentY, Me.currentX = or, Me.currentY = _r;
  const Lr = Me.currentX - Me.startX, Ir = Me.currentY - Me.startY;
  if (ie.params.threshold && Math.sqrt(Lr ** 2 + Ir ** 2) < ie.params.threshold)
    return;
  if (typeof we.isScrolling > "u") {
    let li;
    ie.isHorizontal() && Me.currentY === Me.startY || ie.isVertical() && Me.currentX === Me.startX ? we.isScrolling = !1 : Lr * Lr + Ir * Ir >= 25 && (li = Math.atan2(Math.abs(Ir), Math.abs(Lr)) * 180 / Math.PI, we.isScrolling = ie.isHorizontal() ? li > $e.touchAngle : 90 - li > $e.touchAngle);
  }
  if (we.isScrolling && ie.emit("touchMoveOpposite", rr), typeof we.startMoving > "u" && (Me.currentX !== Me.startX || Me.currentY !== Me.startY) && (we.startMoving = !0), we.isScrolling || rr.type === "touchmove" && we.preventTouchMoveFromPointerMove) {
    we.isTouched = !1;
    return;
  }
  if (!we.startMoving)
    return;
  ie.allowClick = !1, !$e.cssMode && rr.cancelable && rr.preventDefault(), $e.touchMoveStopPropagation && !$e.nested && rr.stopPropagation();
  let Ar = ie.isHorizontal() ? Lr : Ir, Rr = ie.isHorizontal() ? Me.currentX - Me.previousX : Me.currentY - Me.previousY;
  $e.oneWayMovement && (Ar = Math.abs(Ar) * (Ze ? 1 : -1), Rr = Math.abs(Rr) * (Ze ? 1 : -1)), Me.diff = Ar, Ar *= $e.touchRatio, Ze && (Ar = -Ar, Rr = -Rr);
  const Nr = ie.touchesDirection;
  ie.swipeDirection = Ar > 0 ? "prev" : "next", ie.touchesDirection = Rr > 0 ? "prev" : "next";
  const Yr = ie.params.loop && !$e.cssMode, Vr = ie.touchesDirection === "next" && ie.allowSlideNext || ie.touchesDirection === "prev" && ie.allowSlidePrev;
  if (!we.isMoved) {
    if (Yr && Vr && ie.loopFix({
      direction: ie.swipeDirection
    }), we.startTranslate = ie.getTranslate(), ie.setTransition(0), ie.animating) {
      const li = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      ie.wrapperEl.dispatchEvent(li);
    }
    we.allowMomentumBounce = !1, $e.grabCursor && (ie.allowSlideNext === !0 || ie.allowSlidePrev === !0) && ie.setGrabCursor(!0), ie.emit("sliderFirstMove", rr);
  }
  let Xr;
  if (new Date().getTime(), we.isMoved && we.allowThresholdMove && Nr !== ie.touchesDirection && Yr && Vr && Math.abs(Ar) >= 1) {
    Object.assign(Me, {
      startX: or,
      startY: _r,
      currentX: or,
      currentY: _r,
      startTranslate: we.currentTranslate
    }), we.loopSwapReset = !0, we.startTranslate = we.currentTranslate;
    return;
  }
  ie.emit("sliderMove", rr), we.isMoved = !0, we.currentTranslate = Ar + we.startTranslate;
  let Wr = !0, si = $e.resistanceRatio;
  if ($e.touchReleaseOnEdges && (si = 0), Ar > 0 ? (Yr && Vr && !Xr && we.allowThresholdMove && we.currentTranslate > ($e.centeredSlides ? ie.minTranslate() - ie.slidesSizesGrid[ie.activeIndex + 1] - ($e.slidesPerView !== "auto" && ie.slides.length - $e.slidesPerView >= 2 ? ie.slidesSizesGrid[ie.activeIndex + 1] + ie.params.spaceBetween : 0) - ie.params.spaceBetween : ie.minTranslate()) && ie.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), we.currentTranslate > ie.minTranslate() && (Wr = !1, $e.resistance && (we.currentTranslate = ie.minTranslate() - 1 + (-ie.minTranslate() + we.startTranslate + Ar) ** si))) : Ar < 0 && (Yr && Vr && !Xr && we.allowThresholdMove && we.currentTranslate < ($e.centeredSlides ? ie.maxTranslate() + ie.slidesSizesGrid[ie.slidesSizesGrid.length - 1] + ie.params.spaceBetween + ($e.slidesPerView !== "auto" && ie.slides.length - $e.slidesPerView >= 2 ? ie.slidesSizesGrid[ie.slidesSizesGrid.length - 1] + ie.params.spaceBetween : 0) : ie.maxTranslate()) && ie.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: ie.slides.length - ($e.slidesPerView === "auto" ? ie.slidesPerViewDynamic() : Math.ceil(parseFloat($e.slidesPerView, 10)))
  }), we.currentTranslate < ie.maxTranslate() && (Wr = !1, $e.resistance && (we.currentTranslate = ie.maxTranslate() + 1 - (ie.maxTranslate() - we.startTranslate - Ar) ** si))), Wr && (rr.preventedByNestedSwiper = !0), !ie.allowSlideNext && ie.swipeDirection === "next" && we.currentTranslate < we.startTranslate && (we.currentTranslate = we.startTranslate), !ie.allowSlidePrev && ie.swipeDirection === "prev" && we.currentTranslate > we.startTranslate && (we.currentTranslate = we.startTranslate), !ie.allowSlidePrev && !ie.allowSlideNext && (we.currentTranslate = we.startTranslate), $e.threshold > 0)
    if (Math.abs(Ar) > $e.threshold || we.allowThresholdMove) {
      if (!we.allowThresholdMove) {
        we.allowThresholdMove = !0, Me.startX = Me.currentX, Me.startY = Me.currentY, we.currentTranslate = we.startTranslate, Me.diff = ie.isHorizontal() ? Me.currentX - Me.startX : Me.currentY - Me.startY;
        return;
      }
    } else {
      we.currentTranslate = we.startTranslate;
      return;
    }
  !$e.followFinger || $e.cssMode || (($e.freeMode && $e.freeMode.enabled && ie.freeMode || $e.watchSlidesProgress) && (ie.updateActiveIndex(), ie.updateSlidesClasses()), $e.freeMode && $e.freeMode.enabled && ie.freeMode && ie.freeMode.onTouchMove(), ie.updateProgress(we.currentTranslate), ie.setTranslate(we.currentTranslate));
}
function onTouchEnd(m) {
  const c = this, ie = c.touchEventsData;
  let we = m;
  we.originalEvent && (we = we.originalEvent);
  let $e;
  if (we.type === "touchend" || we.type === "touchcancel") {
    if ($e = [...we.changedTouches].find((si) => si.identifier === ie.touchId), !$e || $e.identifier !== ie.touchId)
      return;
  } else {
    if (ie.touchId !== null || we.pointerId !== ie.pointerId)
      return;
    $e = we;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(we.type) && !(["pointercancel", "contextmenu"].includes(we.type) && (c.browser.isSafari || c.browser.isWebView)))
    return;
  ie.pointerId = null, ie.touchId = null;
  const {
    params: Ze,
    touches: ne,
    rtlTranslate: rr,
    slidesGrid: gr,
    enabled: or
  } = c;
  if (!or || !Ze.simulateTouch && we.pointerType === "mouse")
    return;
  if (ie.allowTouchCallbacks && c.emit("touchEnd", we), ie.allowTouchCallbacks = !1, !ie.isTouched) {
    ie.isMoved && Ze.grabCursor && c.setGrabCursor(!1), ie.isMoved = !1, ie.startMoving = !1;
    return;
  }
  Ze.grabCursor && ie.isMoved && ie.isTouched && (c.allowSlideNext === !0 || c.allowSlidePrev === !0) && c.setGrabCursor(!1);
  const _r = now(), Lr = _r - ie.touchStartTime;
  if (c.allowClick) {
    const si = we.path || we.composedPath && we.composedPath();
    c.updateClickedSlide(si && si[0] || we.target, si), c.emit("tap click", we), Lr < 300 && _r - ie.lastClickTime < 300 && c.emit("doubleTap doubleClick", we);
  }
  if (ie.lastClickTime = now(), nextTick(() => {
    c.destroyed || (c.allowClick = !0);
  }), !ie.isTouched || !ie.isMoved || !c.swipeDirection || ne.diff === 0 && !ie.loopSwapReset || ie.currentTranslate === ie.startTranslate && !ie.loopSwapReset) {
    ie.isTouched = !1, ie.isMoved = !1, ie.startMoving = !1;
    return;
  }
  ie.isTouched = !1, ie.isMoved = !1, ie.startMoving = !1;
  let Ir;
  if (Ze.followFinger ? Ir = rr ? c.translate : -c.translate : Ir = -ie.currentTranslate, Ze.cssMode)
    return;
  if (Ze.freeMode && Ze.freeMode.enabled) {
    c.freeMode.onTouchEnd({
      currentPos: Ir
    });
    return;
  }
  const Ar = Ir >= -c.maxTranslate() && !c.params.loop;
  let Rr = 0, Nr = c.slidesSizesGrid[0];
  for (let si = 0; si < gr.length; si += si < Ze.slidesPerGroupSkip ? 1 : Ze.slidesPerGroup) {
    const li = si < Ze.slidesPerGroupSkip - 1 ? 1 : Ze.slidesPerGroup;
    typeof gr[si + li] < "u" ? (Ar || Ir >= gr[si] && Ir < gr[si + li]) && (Rr = si, Nr = gr[si + li] - gr[si]) : (Ar || Ir >= gr[si]) && (Rr = si, Nr = gr[gr.length - 1] - gr[gr.length - 2]);
  }
  let Yr = null, Vr = null;
  Ze.rewind && (c.isBeginning ? Vr = Ze.virtual && Ze.virtual.enabled && c.virtual ? c.virtual.slides.length - 1 : c.slides.length - 1 : c.isEnd && (Yr = 0));
  const Xr = (Ir - gr[Rr]) / Nr, Wr = Rr < Ze.slidesPerGroupSkip - 1 ? 1 : Ze.slidesPerGroup;
  if (Lr > Ze.longSwipesMs) {
    if (!Ze.longSwipes) {
      c.slideTo(c.activeIndex);
      return;
    }
    c.swipeDirection === "next" && (Xr >= Ze.longSwipesRatio ? c.slideTo(Ze.rewind && c.isEnd ? Yr : Rr + Wr) : c.slideTo(Rr)), c.swipeDirection === "prev" && (Xr > 1 - Ze.longSwipesRatio ? c.slideTo(Rr + Wr) : Vr !== null && Xr < 0 && Math.abs(Xr) > Ze.longSwipesRatio ? c.slideTo(Vr) : c.slideTo(Rr));
  } else {
    if (!Ze.shortSwipes) {
      c.slideTo(c.activeIndex);
      return;
    }
    c.navigation && (we.target === c.navigation.nextEl || we.target === c.navigation.prevEl) ? we.target === c.navigation.nextEl ? c.slideTo(Rr + Wr) : c.slideTo(Rr) : (c.swipeDirection === "next" && c.slideTo(Yr !== null ? Yr : Rr + Wr), c.swipeDirection === "prev" && c.slideTo(Vr !== null ? Vr : Rr));
  }
}
function onResize() {
  const m = this, {
    params: c,
    el: ie
  } = m;
  if (ie && ie.offsetWidth === 0)
    return;
  c.breakpoints && m.setBreakpoint();
  const {
    allowSlideNext: we,
    allowSlidePrev: $e,
    snapGrid: Me
  } = m, Ze = m.virtual && m.params.virtual.enabled;
  m.allowSlideNext = !0, m.allowSlidePrev = !0, m.updateSize(), m.updateSlides(), m.updateSlidesClasses();
  const ne = Ze && c.loop;
  (c.slidesPerView === "auto" || c.slidesPerView > 1) && m.isEnd && !m.isBeginning && !m.params.centeredSlides && !ne ? m.slideTo(m.slides.length - 1, 0, !1, !0) : m.params.loop && !Ze ? m.slideToLoop(m.realIndex, 0, !1, !0) : m.slideTo(m.activeIndex, 0, !1, !0), m.autoplay && m.autoplay.running && m.autoplay.paused && (clearTimeout(m.autoplay.resizeTimeout), m.autoplay.resizeTimeout = setTimeout(() => {
    m.autoplay && m.autoplay.running && m.autoplay.paused && m.autoplay.resume();
  }, 500)), m.allowSlidePrev = $e, m.allowSlideNext = we, m.params.watchOverflow && Me !== m.snapGrid && m.checkOverflow();
}
function onClick(m) {
  const c = this;
  !c.enabled || c.allowClick || (c.params.preventClicks && m.preventDefault(), c.params.preventClicksPropagation && c.animating && (m.stopPropagation(), m.stopImmediatePropagation()));
}
function onScroll() {
  const m = this, {
    wrapperEl: c,
    rtlTranslate: ie,
    enabled: we
  } = m;
  if (!we)
    return;
  m.previousTranslate = m.translate, m.isHorizontal() ? m.translate = -c.scrollLeft : m.translate = -c.scrollTop, m.translate === 0 && (m.translate = 0), m.updateActiveIndex(), m.updateSlidesClasses();
  let $e;
  const Me = m.maxTranslate() - m.minTranslate();
  Me === 0 ? $e = 0 : $e = (m.translate - m.minTranslate()) / Me, $e !== m.progress && m.updateProgress(ie ? -m.translate : m.translate), m.emit("setTranslate", m.translate, !1);
}
function onLoad(m) {
  const c = this;
  processLazyPreloader(c, m.target), !(c.params.cssMode || c.params.slidesPerView !== "auto" && !c.params.autoHeight) && c.update();
}
function onDocumentTouchStart() {
  const m = this;
  m.documentTouchHandlerProceeded || (m.documentTouchHandlerProceeded = !0, m.params.touchReleaseOnEdges && (m.el.style.touchAction = "auto"));
}
const events = (m, c) => {
  const ie = getDocument(), {
    params: we,
    el: $e,
    wrapperEl: Me,
    device: Ze
  } = m, ne = !!we.nested, rr = c === "on" ? "addEventListener" : "removeEventListener", gr = c;
  !$e || typeof $e == "string" || (ie[rr]("touchstart", m.onDocumentTouchStart, {
    passive: !1,
    capture: ne
  }), $e[rr]("touchstart", m.onTouchStart, {
    passive: !1
  }), $e[rr]("pointerdown", m.onTouchStart, {
    passive: !1
  }), ie[rr]("touchmove", m.onTouchMove, {
    passive: !1,
    capture: ne
  }), ie[rr]("pointermove", m.onTouchMove, {
    passive: !1,
    capture: ne
  }), ie[rr]("touchend", m.onTouchEnd, {
    passive: !0
  }), ie[rr]("pointerup", m.onTouchEnd, {
    passive: !0
  }), ie[rr]("pointercancel", m.onTouchEnd, {
    passive: !0
  }), ie[rr]("touchcancel", m.onTouchEnd, {
    passive: !0
  }), ie[rr]("pointerout", m.onTouchEnd, {
    passive: !0
  }), ie[rr]("pointerleave", m.onTouchEnd, {
    passive: !0
  }), ie[rr]("contextmenu", m.onTouchEnd, {
    passive: !0
  }), (we.preventClicks || we.preventClicksPropagation) && $e[rr]("click", m.onClick, !0), we.cssMode && Me[rr]("scroll", m.onScroll), we.updateOnWindowResize ? m[gr](Ze.ios || Ze.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, !0) : m[gr]("observerUpdate", onResize, !0), $e[rr]("load", m.onLoad, {
    capture: !0
  }));
};
function attachEvents() {
  const m = this, {
    params: c
  } = m;
  m.onTouchStart = onTouchStart.bind(m), m.onTouchMove = onTouchMove.bind(m), m.onTouchEnd = onTouchEnd.bind(m), m.onDocumentTouchStart = onDocumentTouchStart.bind(m), c.cssMode && (m.onScroll = onScroll.bind(m)), m.onClick = onClick.bind(m), m.onLoad = onLoad.bind(m), events(m, "on");
}
function detachEvents() {
  events(this, "off");
}
var events$1 = {
  attachEvents,
  detachEvents
};
const isGridEnabled = (m, c) => m.grid && c.grid && c.grid.rows > 1;
function setBreakpoint() {
  const m = this, {
    realIndex: c,
    initialized: ie,
    params: we,
    el: $e
  } = m, Me = we.breakpoints;
  if (!Me || Me && Object.keys(Me).length === 0)
    return;
  const Ze = getDocument(), ne = we.breakpointsBase === "window" || !we.breakpointsBase ? we.breakpointsBase : "container", rr = ["window", "container"].includes(we.breakpointsBase) || !we.breakpointsBase ? m.el : Ze.querySelector(we.breakpointsBase), gr = m.getBreakpoint(Me, ne, rr);
  if (!gr || m.currentBreakpoint === gr)
    return;
  const _r = (gr in Me ? Me[gr] : void 0) || m.originalParams, Lr = isGridEnabled(m, we), Ir = isGridEnabled(m, _r), Ar = m.params.grabCursor, Rr = _r.grabCursor, Nr = we.enabled;
  Lr && !Ir ? ($e.classList.remove(`${we.containerModifierClass}grid`, `${we.containerModifierClass}grid-column`), m.emitContainerClasses()) : !Lr && Ir && ($e.classList.add(`${we.containerModifierClass}grid`), (_r.grid.fill && _r.grid.fill === "column" || !_r.grid.fill && we.grid.fill === "column") && $e.classList.add(`${we.containerModifierClass}grid-column`), m.emitContainerClasses()), Ar && !Rr ? m.unsetGrabCursor() : !Ar && Rr && m.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((li) => {
    if (typeof _r[li] > "u")
      return;
    const xi = we[li] && we[li].enabled, di = _r[li] && _r[li].enabled;
    xi && !di && m[li].disable(), !xi && di && m[li].enable();
  });
  const Yr = _r.direction && _r.direction !== we.direction, Vr = we.loop && (_r.slidesPerView !== we.slidesPerView || Yr), Xr = we.loop;
  Yr && ie && m.changeDirection(), extend$1(m.params, _r);
  const Wr = m.params.enabled, si = m.params.loop;
  Object.assign(m, {
    allowTouchMove: m.params.allowTouchMove,
    allowSlideNext: m.params.allowSlideNext,
    allowSlidePrev: m.params.allowSlidePrev
  }), Nr && !Wr ? m.disable() : !Nr && Wr && m.enable(), m.currentBreakpoint = gr, m.emit("_beforeBreakpoint", _r), ie && (Vr ? (m.loopDestroy(), m.loopCreate(c), m.updateSlides()) : !Xr && si ? (m.loopCreate(c), m.updateSlides()) : Xr && !si && m.loopDestroy()), m.emit("breakpoint", _r);
}
function getBreakpoint(m, c, ie) {
  if (c === void 0 && (c = "window"), !m || c === "container" && !ie)
    return;
  let we = !1;
  const $e = getWindow(), Me = c === "window" ? $e.innerHeight : ie.clientHeight, Ze = Object.keys(m).map((ne) => {
    if (typeof ne == "string" && ne.indexOf("@") === 0) {
      const rr = parseFloat(ne.substr(1));
      return {
        value: Me * rr,
        point: ne
      };
    }
    return {
      value: ne,
      point: ne
    };
  });
  Ze.sort((ne, rr) => parseInt(ne.value, 10) - parseInt(rr.value, 10));
  for (let ne = 0; ne < Ze.length; ne += 1) {
    const {
      point: rr,
      value: gr
    } = Ze[ne];
    c === "window" ? $e.matchMedia(`(min-width: ${gr}px)`).matches && (we = rr) : gr <= ie.clientWidth && (we = rr);
  }
  return we || "max";
}
var breakpoints = {
  setBreakpoint,
  getBreakpoint
};
function prepareClasses(m, c) {
  const ie = [];
  return m.forEach((we) => {
    typeof we == "object" ? Object.keys(we).forEach(($e) => {
      we[$e] && ie.push(c + $e);
    }) : typeof we == "string" && ie.push(c + we);
  }), ie;
}
function addClasses() {
  const m = this, {
    classNames: c,
    params: ie,
    rtl: we,
    el: $e,
    device: Me
  } = m, Ze = prepareClasses(["initialized", ie.direction, {
    "free-mode": m.params.freeMode && ie.freeMode.enabled
  }, {
    autoheight: ie.autoHeight
  }, {
    rtl: we
  }, {
    grid: ie.grid && ie.grid.rows > 1
  }, {
    "grid-column": ie.grid && ie.grid.rows > 1 && ie.grid.fill === "column"
  }, {
    android: Me.android
  }, {
    ios: Me.ios
  }, {
    "css-mode": ie.cssMode
  }, {
    centered: ie.cssMode && ie.centeredSlides
  }, {
    "watch-progress": ie.watchSlidesProgress
  }], ie.containerModifierClass);
  c.push(...Ze), $e.classList.add(...c), m.emitContainerClasses();
}
function removeClasses() {
  const m = this, {
    el: c,
    classNames: ie
  } = m;
  !c || typeof c == "string" || (c.classList.remove(...ie), m.emitContainerClasses());
}
var classes = {
  addClasses,
  removeClasses
};
function checkOverflow() {
  const m = this, {
    isLocked: c,
    params: ie
  } = m, {
    slidesOffsetBefore: we
  } = ie;
  if (we) {
    const $e = m.slides.length - 1, Me = m.slidesGrid[$e] + m.slidesSizesGrid[$e] + we * 2;
    m.isLocked = m.size > Me;
  } else
    m.isLocked = m.snapGrid.length === 1;
  ie.allowSlideNext === !0 && (m.allowSlideNext = !m.isLocked), ie.allowSlidePrev === !0 && (m.allowSlidePrev = !m.isLocked), c && c !== m.isLocked && (m.isEnd = !1), c !== m.isLocked && m.emit(m.isLocked ? "lock" : "unlock");
}
var checkOverflow$1 = {
  checkOverflow
}, defaults = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  width: null,
  height: null,
  preventInteractionOnTransition: !1,
  userAgent: null,
  url: null,
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  autoHeight: !1,
  setWrapperSize: !1,
  virtualTranslate: !1,
  effect: "slide",
  breakpoints: void 0,
  breakpointsBase: "window",
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  watchOverflow: !0,
  roundLengths: !1,
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  uniqueNavElements: !0,
  resistance: !0,
  resistanceRatio: 0.85,
  watchSlidesProgress: !1,
  grabCursor: !1,
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  rewind: !1,
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  containerModifierClass: "swiper-",
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  runCallbacksOnInit: !0,
  _emitClasses: !1
};
function moduleExtendParams(m, c) {
  return function(we) {
    we === void 0 && (we = {});
    const $e = Object.keys(we)[0], Me = we[$e];
    if (typeof Me != "object" || Me === null) {
      extend$1(c, we);
      return;
    }
    if (m[$e] === !0 && (m[$e] = {
      enabled: !0
    }), $e === "navigation" && m[$e] && m[$e].enabled && !m[$e].prevEl && !m[$e].nextEl && (m[$e].auto = !0), ["pagination", "scrollbar"].indexOf($e) >= 0 && m[$e] && m[$e].enabled && !m[$e].el && (m[$e].auto = !0), !($e in m && "enabled" in Me)) {
      extend$1(c, we);
      return;
    }
    typeof m[$e] == "object" && !("enabled" in m[$e]) && (m[$e].enabled = !0), m[$e] || (m[$e] = {
      enabled: !1
    }), extend$1(c, we);
  };
}
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes
}, extendedDefaults = {};
class Swiper$1 {
  constructor() {
    let c, ie;
    for (var we = arguments.length, $e = new Array(we), Me = 0; Me < we; Me++)
      $e[Me] = arguments[Me];
    $e.length === 1 && $e[0].constructor && Object.prototype.toString.call($e[0]).slice(8, -1) === "Object" ? ie = $e[0] : [c, ie] = $e, ie || (ie = {}), ie = extend$1({}, ie), c && !ie.el && (ie.el = c);
    const Ze = getDocument();
    if (ie.el && typeof ie.el == "string" && Ze.querySelectorAll(ie.el).length > 1) {
      const or = [];
      return Ze.querySelectorAll(ie.el).forEach((_r) => {
        const Lr = extend$1({}, ie, {
          el: _r
        });
        or.push(new Swiper$1(Lr));
      }), or;
    }
    const ne = this;
    ne.__swiper__ = !0, ne.support = getSupport(), ne.device = getDevice({
      userAgent: ie.userAgent
    }), ne.browser = getBrowser(), ne.eventsListeners = {}, ne.eventsAnyListeners = [], ne.modules = [...ne.__modules__], ie.modules && Array.isArray(ie.modules) && ne.modules.push(...ie.modules);
    const rr = {};
    ne.modules.forEach((or) => {
      or({
        params: ie,
        swiper: ne,
        extendParams: moduleExtendParams(ie, rr),
        on: ne.on.bind(ne),
        once: ne.once.bind(ne),
        off: ne.off.bind(ne),
        emit: ne.emit.bind(ne)
      });
    });
    const gr = extend$1({}, defaults, rr);
    return ne.params = extend$1({}, gr, extendedDefaults, ie), ne.originalParams = extend$1({}, ne.params), ne.passedParams = extend$1({}, ie), ne.params && ne.params.on && Object.keys(ne.params.on).forEach((or) => {
      ne.on(or, ne.params.on[or]);
    }), ne.params && ne.params.onAny && ne.onAny(ne.params.onAny), Object.assign(ne, {
      enabled: ne.params.enabled,
      el: c,
      classNames: [],
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      isHorizontal() {
        return ne.params.direction === "horizontal";
      },
      isVertical() {
        return ne.params.direction === "vertical";
      },
      activeIndex: 0,
      realIndex: 0,
      isBeginning: !0,
      isEnd: !1,
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      allowSlideNext: ne.params.allowSlideNext,
      allowSlidePrev: ne.params.allowSlidePrev,
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        focusableElements: ne.params.focusableElements,
        lastClickTime: 0,
        clickTimeout: void 0,
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      allowClick: !0,
      allowTouchMove: ne.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      imagesToLoad: [],
      imagesLoaded: 0
    }), ne.emit("_swiper"), ne.params.init && ne.init(), ne;
  }
  getDirectionLabel(c) {
    return this.isHorizontal() ? c : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[c];
  }
  getSlideIndex(c) {
    const {
      slidesEl: ie,
      params: we
    } = this, $e = elementChildren(ie, `.${we.slideClass}, swiper-slide`), Me = elementIndex($e[0]);
    return elementIndex(c) - Me;
  }
  getSlideIndexByData(c) {
    return this.getSlideIndex(this.slides.find((ie) => ie.getAttribute("data-swiper-slide-index") * 1 === c));
  }
  recalcSlides() {
    const c = this, {
      slidesEl: ie,
      params: we
    } = c;
    c.slides = elementChildren(ie, `.${we.slideClass}, swiper-slide`);
  }
  enable() {
    const c = this;
    c.enabled || (c.enabled = !0, c.params.grabCursor && c.setGrabCursor(), c.emit("enable"));
  }
  disable() {
    const c = this;
    !c.enabled || (c.enabled = !1, c.params.grabCursor && c.unsetGrabCursor(), c.emit("disable"));
  }
  setProgress(c, ie) {
    const we = this;
    c = Math.min(Math.max(c, 0), 1);
    const $e = we.minTranslate(), Ze = (we.maxTranslate() - $e) * c + $e;
    we.translateTo(Ze, typeof ie > "u" ? 0 : ie), we.updateActiveIndex(), we.updateSlidesClasses();
  }
  emitContainerClasses() {
    const c = this;
    if (!c.params._emitClasses || !c.el)
      return;
    const ie = c.el.className.split(" ").filter((we) => we.indexOf("swiper") === 0 || we.indexOf(c.params.containerModifierClass) === 0);
    c.emit("_containerClasses", ie.join(" "));
  }
  getSlideClasses(c) {
    const ie = this;
    return ie.destroyed ? "" : c.className.split(" ").filter((we) => we.indexOf("swiper-slide") === 0 || we.indexOf(ie.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const c = this;
    if (!c.params._emitClasses || !c.el)
      return;
    const ie = [];
    c.slides.forEach((we) => {
      const $e = c.getSlideClasses(we);
      ie.push({
        slideEl: we,
        classNames: $e
      }), c.emit("_slideClass", we, $e);
    }), c.emit("_slideClasses", ie);
  }
  slidesPerViewDynamic(c, ie) {
    c === void 0 && (c = "current"), ie === void 0 && (ie = !1);
    const we = this, {
      params: $e,
      slides: Me,
      slidesGrid: Ze,
      slidesSizesGrid: ne,
      size: rr,
      activeIndex: gr
    } = we;
    let or = 1;
    if (typeof $e.slidesPerView == "number")
      return $e.slidesPerView;
    if ($e.centeredSlides) {
      let _r = Me[gr] ? Math.ceil(Me[gr].swiperSlideSize) : 0, Lr;
      for (let Ir = gr + 1; Ir < Me.length; Ir += 1)
        Me[Ir] && !Lr && (_r += Math.ceil(Me[Ir].swiperSlideSize), or += 1, _r > rr && (Lr = !0));
      for (let Ir = gr - 1; Ir >= 0; Ir -= 1)
        Me[Ir] && !Lr && (_r += Me[Ir].swiperSlideSize, or += 1, _r > rr && (Lr = !0));
    } else if (c === "current")
      for (let _r = gr + 1; _r < Me.length; _r += 1)
        (ie ? Ze[_r] + ne[_r] - Ze[gr] < rr : Ze[_r] - Ze[gr] < rr) && (or += 1);
    else
      for (let _r = gr - 1; _r >= 0; _r -= 1)
        Ze[gr] - Ze[_r] < rr && (or += 1);
    return or;
  }
  update() {
    const c = this;
    if (!c || c.destroyed)
      return;
    const {
      snapGrid: ie,
      params: we
    } = c;
    we.breakpoints && c.setBreakpoint(), [...c.el.querySelectorAll('[loading="lazy"]')].forEach((Ze) => {
      Ze.complete && processLazyPreloader(c, Ze);
    }), c.updateSize(), c.updateSlides(), c.updateProgress(), c.updateSlidesClasses();
    function $e() {
      const Ze = c.rtlTranslate ? c.translate * -1 : c.translate, ne = Math.min(Math.max(Ze, c.maxTranslate()), c.minTranslate());
      c.setTranslate(ne), c.updateActiveIndex(), c.updateSlidesClasses();
    }
    let Me;
    if (we.freeMode && we.freeMode.enabled && !we.cssMode)
      $e(), we.autoHeight && c.updateAutoHeight();
    else {
      if ((we.slidesPerView === "auto" || we.slidesPerView > 1) && c.isEnd && !we.centeredSlides) {
        const Ze = c.virtual && we.virtual.enabled ? c.virtual.slides : c.slides;
        Me = c.slideTo(Ze.length - 1, 0, !1, !0);
      } else
        Me = c.slideTo(c.activeIndex, 0, !1, !0);
      Me || $e();
    }
    we.watchOverflow && ie !== c.snapGrid && c.checkOverflow(), c.emit("update");
  }
  changeDirection(c, ie) {
    ie === void 0 && (ie = !0);
    const we = this, $e = we.params.direction;
    return c || (c = $e === "horizontal" ? "vertical" : "horizontal"), c === $e || c !== "horizontal" && c !== "vertical" || (we.el.classList.remove(`${we.params.containerModifierClass}${$e}`), we.el.classList.add(`${we.params.containerModifierClass}${c}`), we.emitContainerClasses(), we.params.direction = c, we.slides.forEach((Me) => {
      c === "vertical" ? Me.style.width = "" : Me.style.height = "";
    }), we.emit("changeDirection"), ie && we.update()), we;
  }
  changeLanguageDirection(c) {
    const ie = this;
    ie.rtl && c === "rtl" || !ie.rtl && c === "ltr" || (ie.rtl = c === "rtl", ie.rtlTranslate = ie.params.direction === "horizontal" && ie.rtl, ie.rtl ? (ie.el.classList.add(`${ie.params.containerModifierClass}rtl`), ie.el.dir = "rtl") : (ie.el.classList.remove(`${ie.params.containerModifierClass}rtl`), ie.el.dir = "ltr"), ie.update());
  }
  mount(c) {
    const ie = this;
    if (ie.mounted)
      return !0;
    let we = c || ie.params.el;
    if (typeof we == "string" && (we = document.querySelector(we)), !we)
      return !1;
    we.swiper = ie, we.parentNode && we.parentNode.host && we.parentNode.host.nodeName === ie.params.swiperElementNodeName.toUpperCase() && (ie.isElement = !0);
    const $e = () => `.${(ie.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let Ze = (() => we && we.shadowRoot && we.shadowRoot.querySelector ? we.shadowRoot.querySelector($e()) : elementChildren(we, $e())[0])();
    return !Ze && ie.params.createElements && (Ze = createElement("div", ie.params.wrapperClass), we.append(Ze), elementChildren(we, `.${ie.params.slideClass}`).forEach((ne) => {
      Ze.append(ne);
    })), Object.assign(ie, {
      el: we,
      wrapperEl: Ze,
      slidesEl: ie.isElement && !we.parentNode.host.slideSlots ? we.parentNode.host : Ze,
      hostEl: ie.isElement ? we.parentNode.host : we,
      mounted: !0,
      rtl: we.dir.toLowerCase() === "rtl" || elementStyle(we, "direction") === "rtl",
      rtlTranslate: ie.params.direction === "horizontal" && (we.dir.toLowerCase() === "rtl" || elementStyle(we, "direction") === "rtl"),
      wrongRTL: elementStyle(Ze, "display") === "-webkit-box"
    }), !0;
  }
  init(c) {
    const ie = this;
    if (ie.initialized || ie.mount(c) === !1)
      return ie;
    ie.emit("beforeInit"), ie.params.breakpoints && ie.setBreakpoint(), ie.addClasses(), ie.updateSize(), ie.updateSlides(), ie.params.watchOverflow && ie.checkOverflow(), ie.params.grabCursor && ie.enabled && ie.setGrabCursor(), ie.params.loop && ie.virtual && ie.params.virtual.enabled ? ie.slideTo(ie.params.initialSlide + ie.virtual.slidesBefore, 0, ie.params.runCallbacksOnInit, !1, !0) : ie.slideTo(ie.params.initialSlide, 0, ie.params.runCallbacksOnInit, !1, !0), ie.params.loop && ie.loopCreate(), ie.attachEvents();
    const $e = [...ie.el.querySelectorAll('[loading="lazy"]')];
    return ie.isElement && $e.push(...ie.hostEl.querySelectorAll('[loading="lazy"]')), $e.forEach((Me) => {
      Me.complete ? processLazyPreloader(ie, Me) : Me.addEventListener("load", (Ze) => {
        processLazyPreloader(ie, Ze.target);
      });
    }), preload(ie), ie.initialized = !0, preload(ie), ie.emit("init"), ie.emit("afterInit"), ie;
  }
  destroy(c, ie) {
    c === void 0 && (c = !0), ie === void 0 && (ie = !0);
    const we = this, {
      params: $e,
      el: Me,
      wrapperEl: Ze,
      slides: ne
    } = we;
    return typeof we.params > "u" || we.destroyed || (we.emit("beforeDestroy"), we.initialized = !1, we.detachEvents(), $e.loop && we.loopDestroy(), ie && (we.removeClasses(), Me && typeof Me != "string" && Me.removeAttribute("style"), Ze && Ze.removeAttribute("style"), ne && ne.length && ne.forEach((rr) => {
      rr.classList.remove($e.slideVisibleClass, $e.slideFullyVisibleClass, $e.slideActiveClass, $e.slideNextClass, $e.slidePrevClass), rr.removeAttribute("style"), rr.removeAttribute("data-swiper-slide-index");
    })), we.emit("destroy"), Object.keys(we.eventsListeners).forEach((rr) => {
      we.off(rr);
    }), c !== !1 && (we.el && typeof we.el != "string" && (we.el.swiper = null), deleteProps(we)), we.destroyed = !0), null;
  }
  static extendDefaults(c) {
    extend$1(extendedDefaults, c);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults;
  }
  static installModule(c) {
    Swiper$1.prototype.__modules__ || (Swiper$1.prototype.__modules__ = []);
    const ie = Swiper$1.prototype.__modules__;
    typeof c == "function" && ie.indexOf(c) < 0 && ie.push(c);
  }
  static use(c) {
    return Array.isArray(c) ? (c.forEach((ie) => Swiper$1.installModule(ie)), Swiper$1) : (Swiper$1.installModule(c), Swiper$1);
  }
}
Object.keys(prototypes).forEach((m) => {
  Object.keys(prototypes[m]).forEach((c) => {
    Swiper$1.prototype[c] = prototypes[m][c];
  });
});
Swiper$1.use([Resize, Observer]);
const paramsList = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function isObject(m) {
  return typeof m == "object" && m !== null && m.constructor && Object.prototype.toString.call(m).slice(8, -1) === "Object" && !m.__swiper__;
}
function extend(m, c) {
  const ie = ["__proto__", "constructor", "prototype"];
  Object.keys(c).filter((we) => ie.indexOf(we) < 0).forEach((we) => {
    typeof m[we] > "u" ? m[we] = c[we] : isObject(c[we]) && isObject(m[we]) && Object.keys(c[we]).length > 0 ? c[we].__swiper__ ? m[we] = c[we] : extend(m[we], c[we]) : m[we] = c[we];
  });
}
function needsNavigation(m) {
  return m === void 0 && (m = {}), m.navigation && typeof m.navigation.nextEl > "u" && typeof m.navigation.prevEl > "u";
}
function needsPagination(m) {
  return m === void 0 && (m = {}), m.pagination && typeof m.pagination.el > "u";
}
function needsScrollbar(m) {
  return m === void 0 && (m = {}), m.scrollbar && typeof m.scrollbar.el > "u";
}
function uniqueClasses(m) {
  m === void 0 && (m = "");
  const c = m.split(" ").map((we) => we.trim()).filter((we) => !!we), ie = [];
  return c.forEach((we) => {
    ie.indexOf(we) < 0 && ie.push(we);
  }), ie.join(" ");
}
function wrapperClass(m) {
  return m === void 0 && (m = ""), m ? m.includes("swiper-wrapper") ? m : `swiper-wrapper ${m}` : "swiper-wrapper";
}
function updateSwiper(m) {
  let {
    swiper: c,
    slides: ie,
    passedParams: we,
    changedParams: $e,
    nextEl: Me,
    prevEl: Ze,
    scrollbarEl: ne,
    paginationEl: rr
  } = m;
  const gr = $e.filter((oi) => oi !== "children" && oi !== "direction" && oi !== "wrapperClass"), {
    params: or,
    pagination: _r,
    navigation: Lr,
    scrollbar: Ir,
    virtual: Ar,
    thumbs: Rr
  } = c;
  let Nr, Yr, Vr, Xr, Wr, si, li, xi;
  $e.includes("thumbs") && we.thumbs && we.thumbs.swiper && !we.thumbs.swiper.destroyed && or.thumbs && (!or.thumbs.swiper || or.thumbs.swiper.destroyed) && (Nr = !0), $e.includes("controller") && we.controller && we.controller.control && or.controller && !or.controller.control && (Yr = !0), $e.includes("pagination") && we.pagination && (we.pagination.el || rr) && (or.pagination || or.pagination === !1) && _r && !_r.el && (Vr = !0), $e.includes("scrollbar") && we.scrollbar && (we.scrollbar.el || ne) && (or.scrollbar || or.scrollbar === !1) && Ir && !Ir.el && (Xr = !0), $e.includes("navigation") && we.navigation && (we.navigation.prevEl || Ze) && (we.navigation.nextEl || Me) && (or.navigation || or.navigation === !1) && Lr && !Lr.prevEl && !Lr.nextEl && (Wr = !0);
  const di = (oi) => {
    !c[oi] || (c[oi].destroy(), oi === "navigation" ? (c.isElement && (c[oi].prevEl.remove(), c[oi].nextEl.remove()), or[oi].prevEl = void 0, or[oi].nextEl = void 0, c[oi].prevEl = void 0, c[oi].nextEl = void 0) : (c.isElement && c[oi].el.remove(), or[oi].el = void 0, c[oi].el = void 0));
  };
  $e.includes("loop") && c.isElement && (or.loop && !we.loop ? si = !0 : !or.loop && we.loop ? li = !0 : xi = !0), gr.forEach((oi) => {
    if (isObject(or[oi]) && isObject(we[oi]))
      Object.assign(or[oi], we[oi]), (oi === "navigation" || oi === "pagination" || oi === "scrollbar") && "enabled" in we[oi] && !we[oi].enabled && di(oi);
    else {
      const ci = we[oi];
      (ci === !0 || ci === !1) && (oi === "navigation" || oi === "pagination" || oi === "scrollbar") ? ci === !1 && di(oi) : or[oi] = we[oi];
    }
  }), gr.includes("controller") && !Yr && c.controller && c.controller.control && or.controller && or.controller.control && (c.controller.control = or.controller.control), $e.includes("children") && ie && Ar && or.virtual.enabled ? (Ar.slides = ie, Ar.update(!0)) : $e.includes("virtual") && Ar && or.virtual.enabled && (ie && (Ar.slides = ie), Ar.update(!0)), $e.includes("children") && ie && or.loop && (xi = !0), Nr && Rr.init() && Rr.update(!0), Yr && (c.controller.control = or.controller.control), Vr && (c.isElement && (!rr || typeof rr == "string") && (rr = document.createElement("div"), rr.classList.add("swiper-pagination"), rr.part.add("pagination"), c.el.appendChild(rr)), rr && (or.pagination.el = rr), _r.init(), _r.render(), _r.update()), Xr && (c.isElement && (!ne || typeof ne == "string") && (ne = document.createElement("div"), ne.classList.add("swiper-scrollbar"), ne.part.add("scrollbar"), c.el.appendChild(ne)), ne && (or.scrollbar.el = ne), Ir.init(), Ir.updateSize(), Ir.setTranslate()), Wr && (c.isElement && ((!Me || typeof Me == "string") && (Me = document.createElement("div"), Me.classList.add("swiper-button-next"), Me.innerHTML = c.hostEl.constructor.nextButtonSvg, Me.part.add("button-next"), c.el.appendChild(Me)), (!Ze || typeof Ze == "string") && (Ze = document.createElement("div"), Ze.classList.add("swiper-button-prev"), Ze.innerHTML = c.hostEl.constructor.prevButtonSvg, Ze.part.add("button-prev"), c.el.appendChild(Ze))), Me && (or.navigation.nextEl = Me), Ze && (or.navigation.prevEl = Ze), Lr.init(), Lr.update()), $e.includes("allowSlideNext") && (c.allowSlideNext = we.allowSlideNext), $e.includes("allowSlidePrev") && (c.allowSlidePrev = we.allowSlidePrev), $e.includes("direction") && c.changeDirection(we.direction, !1), (si || xi) && c.loopDestroy(), (li || xi) && c.loopCreate(), c.update();
}
function getParams(m, c) {
  m === void 0 && (m = {}), c === void 0 && (c = !0);
  const ie = {
    on: {}
  }, we = {}, $e = {};
  extend(ie, defaults), ie._emitClasses = !0, ie.init = !1;
  const Me = {}, Ze = paramsList.map((rr) => rr.replace(/_/, "")), ne = Object.assign({}, m);
  return Object.keys(ne).forEach((rr) => {
    typeof m[rr] > "u" || (Ze.indexOf(rr) >= 0 ? isObject(m[rr]) ? (ie[rr] = {}, $e[rr] = {}, extend(ie[rr], m[rr]), extend($e[rr], m[rr])) : (ie[rr] = m[rr], $e[rr] = m[rr]) : rr.search(/on[A-Z]/) === 0 && typeof m[rr] == "function" ? c ? we[`${rr[2].toLowerCase()}${rr.substr(3)}`] = m[rr] : ie.on[`${rr[2].toLowerCase()}${rr.substr(3)}`] = m[rr] : Me[rr] = m[rr]);
  }), ["navigation", "pagination", "scrollbar"].forEach((rr) => {
    ie[rr] === !0 && (ie[rr] = {}), ie[rr] === !1 && delete ie[rr];
  }), {
    params: ie,
    passedParams: $e,
    rest: Me,
    events: we
  };
}
function mountSwiper(m, c) {
  let {
    el: ie,
    nextEl: we,
    prevEl: $e,
    paginationEl: Me,
    scrollbarEl: Ze,
    swiper: ne
  } = m;
  needsNavigation(c) && we && $e && (ne.params.navigation.nextEl = we, ne.originalParams.navigation.nextEl = we, ne.params.navigation.prevEl = $e, ne.originalParams.navigation.prevEl = $e), needsPagination(c) && Me && (ne.params.pagination.el = Me, ne.originalParams.pagination.el = Me), needsScrollbar(c) && Ze && (ne.params.scrollbar.el = Ze, ne.originalParams.scrollbar.el = Ze), ne.init(ie);
}
function getChangedParams(m, c, ie, we, $e) {
  const Me = [];
  if (!c)
    return Me;
  const Ze = (rr) => {
    Me.indexOf(rr) < 0 && Me.push(rr);
  };
  if (ie && we) {
    const rr = we.map($e), gr = ie.map($e);
    rr.join("") !== gr.join("") && Ze("children"), we.length !== ie.length && Ze("children");
  }
  return paramsList.filter((rr) => rr[0] === "_").map((rr) => rr.replace(/_/, "")).forEach((rr) => {
    if (rr in m && rr in c)
      if (isObject(m[rr]) && isObject(c[rr])) {
        const gr = Object.keys(m[rr]), or = Object.keys(c[rr]);
        gr.length !== or.length ? Ze(rr) : (gr.forEach((_r) => {
          m[rr][_r] !== c[rr][_r] && Ze(rr);
        }), or.forEach((_r) => {
          m[rr][_r] !== c[rr][_r] && Ze(rr);
        }));
      } else
        m[rr] !== c[rr] && Ze(rr);
  }), Me;
}
const updateOnVirtualData = (m) => {
  !m || m.destroyed || !m.params.virtual || m.params.virtual && !m.params.virtual.enabled || (m.updateSlides(), m.updateProgress(), m.updateSlidesClasses(), m.parallax && m.params.parallax && m.params.parallax.enabled && m.parallax.setTranslate());
};
function getChildren(m, c, ie) {
  m === void 0 && (m = {});
  const we = [], $e = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  }, Me = (Ze, ne) => {
    !Array.isArray(Ze) || Ze.forEach((rr) => {
      const gr = typeof rr.type == "symbol";
      ne === "default" && (ne = "container-end"), gr && rr.children ? Me(rr.children, ne) : rr.type && (rr.type.name === "SwiperSlide" || rr.type.name === "AsyncComponentWrapper") || rr.componentOptions && rr.componentOptions.tag === "SwiperSlide" ? we.push(rr) : $e[ne] && $e[ne].push(rr);
    });
  };
  return Object.keys(m).forEach((Ze) => {
    if (typeof m[Ze] != "function")
      return;
    const ne = m[Ze]();
    Me(ne, Ze);
  }), ie.value = c.value, c.value = we, {
    slides: we,
    slots: $e
  };
}
function renderVirtual(m, c, ie) {
  if (!ie)
    return null;
  const we = (or) => {
    let _r = or;
    return or < 0 ? _r = c.length + or : _r >= c.length && (_r = _r - c.length), _r;
  }, $e = m.value.isHorizontal() ? {
    [m.value.rtlTranslate ? "right" : "left"]: `${ie.offset}px`
  } : {
    top: `${ie.offset}px`
  }, {
    from: Me,
    to: Ze
  } = ie, ne = m.value.params.loop ? -c.length : 0, rr = m.value.params.loop ? c.length * 2 : c.length, gr = [];
  for (let or = ne; or < rr; or += 1)
    or >= Me && or <= Ze && gr.length < c.length && gr.push(c[we(or)]);
  return gr.map((or) => {
    if (or.props || (or.props = {}), or.props.style || (or.props.style = {}), or.props.swiperRef = m, or.props.style = $e, or.type)
      return h$1(or.type, {
        ...or.props
      }, or.children);
    if (or.componentOptions)
      return h$1(or.componentOptions.Ctor, {
        ...or.props
      }, or.componentOptions.children);
  });
}
const Swiper = {
  name: "Swiper",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    wrapperTag: {
      type: String,
      default: "div"
    },
    modules: {
      type: Array,
      default: void 0
    },
    init: {
      type: Boolean,
      default: void 0
    },
    direction: {
      type: String,
      default: void 0
    },
    oneWayMovement: {
      type: Boolean,
      default: void 0
    },
    swiperElementNodeName: {
      type: String,
      default: "SWIPER-CONTAINER"
    },
    touchEventsTarget: {
      type: String,
      default: void 0
    },
    initialSlide: {
      type: Number,
      default: void 0
    },
    speed: {
      type: Number,
      default: void 0
    },
    cssMode: {
      type: Boolean,
      default: void 0
    },
    updateOnWindowResize: {
      type: Boolean,
      default: void 0
    },
    resizeObserver: {
      type: Boolean,
      default: void 0
    },
    nested: {
      type: Boolean,
      default: void 0
    },
    focusableElements: {
      type: String,
      default: void 0
    },
    width: {
      type: Number,
      default: void 0
    },
    height: {
      type: Number,
      default: void 0
    },
    preventInteractionOnTransition: {
      type: Boolean,
      default: void 0
    },
    userAgent: {
      type: String,
      default: void 0
    },
    url: {
      type: String,
      default: void 0
    },
    edgeSwipeDetection: {
      type: [Boolean, String],
      default: void 0
    },
    edgeSwipeThreshold: {
      type: Number,
      default: void 0
    },
    autoHeight: {
      type: Boolean,
      default: void 0
    },
    setWrapperSize: {
      type: Boolean,
      default: void 0
    },
    virtualTranslate: {
      type: Boolean,
      default: void 0
    },
    effect: {
      type: String,
      default: void 0
    },
    breakpoints: {
      type: Object,
      default: void 0
    },
    breakpointsBase: {
      type: String,
      default: void 0
    },
    spaceBetween: {
      type: [Number, String],
      default: void 0
    },
    slidesPerView: {
      type: [Number, String],
      default: void 0
    },
    maxBackfaceHiddenSlides: {
      type: Number,
      default: void 0
    },
    slidesPerGroup: {
      type: Number,
      default: void 0
    },
    slidesPerGroupSkip: {
      type: Number,
      default: void 0
    },
    slidesPerGroupAuto: {
      type: Boolean,
      default: void 0
    },
    centeredSlides: {
      type: Boolean,
      default: void 0
    },
    centeredSlidesBounds: {
      type: Boolean,
      default: void 0
    },
    slidesOffsetBefore: {
      type: Number,
      default: void 0
    },
    slidesOffsetAfter: {
      type: Number,
      default: void 0
    },
    normalizeSlideIndex: {
      type: Boolean,
      default: void 0
    },
    centerInsufficientSlides: {
      type: Boolean,
      default: void 0
    },
    watchOverflow: {
      type: Boolean,
      default: void 0
    },
    roundLengths: {
      type: Boolean,
      default: void 0
    },
    touchRatio: {
      type: Number,
      default: void 0
    },
    touchAngle: {
      type: Number,
      default: void 0
    },
    simulateTouch: {
      type: Boolean,
      default: void 0
    },
    shortSwipes: {
      type: Boolean,
      default: void 0
    },
    longSwipes: {
      type: Boolean,
      default: void 0
    },
    longSwipesRatio: {
      type: Number,
      default: void 0
    },
    longSwipesMs: {
      type: Number,
      default: void 0
    },
    followFinger: {
      type: Boolean,
      default: void 0
    },
    allowTouchMove: {
      type: Boolean,
      default: void 0
    },
    threshold: {
      type: Number,
      default: void 0
    },
    touchMoveStopPropagation: {
      type: Boolean,
      default: void 0
    },
    touchStartPreventDefault: {
      type: Boolean,
      default: void 0
    },
    touchStartForcePreventDefault: {
      type: Boolean,
      default: void 0
    },
    touchReleaseOnEdges: {
      type: Boolean,
      default: void 0
    },
    uniqueNavElements: {
      type: Boolean,
      default: void 0
    },
    resistance: {
      type: Boolean,
      default: void 0
    },
    resistanceRatio: {
      type: Number,
      default: void 0
    },
    watchSlidesProgress: {
      type: Boolean,
      default: void 0
    },
    grabCursor: {
      type: Boolean,
      default: void 0
    },
    preventClicks: {
      type: Boolean,
      default: void 0
    },
    preventClicksPropagation: {
      type: Boolean,
      default: void 0
    },
    slideToClickedSlide: {
      type: Boolean,
      default: void 0
    },
    loop: {
      type: Boolean,
      default: void 0
    },
    loopedSlides: {
      type: Number,
      default: void 0
    },
    loopPreventsSliding: {
      type: Boolean,
      default: void 0
    },
    rewind: {
      type: Boolean,
      default: void 0
    },
    allowSlidePrev: {
      type: Boolean,
      default: void 0
    },
    allowSlideNext: {
      type: Boolean,
      default: void 0
    },
    swipeHandler: {
      type: Boolean,
      default: void 0
    },
    noSwiping: {
      type: Boolean,
      default: void 0
    },
    noSwipingClass: {
      type: String,
      default: void 0
    },
    noSwipingSelector: {
      type: String,
      default: void 0
    },
    passiveListeners: {
      type: Boolean,
      default: void 0
    },
    containerModifierClass: {
      type: String,
      default: void 0
    },
    slideClass: {
      type: String,
      default: void 0
    },
    slideActiveClass: {
      type: String,
      default: void 0
    },
    slideVisibleClass: {
      type: String,
      default: void 0
    },
    slideFullyVisibleClass: {
      type: String,
      default: void 0
    },
    slideBlankClass: {
      type: String,
      default: void 0
    },
    slideNextClass: {
      type: String,
      default: void 0
    },
    slidePrevClass: {
      type: String,
      default: void 0
    },
    wrapperClass: {
      type: String,
      default: void 0
    },
    lazyPreloaderClass: {
      type: String,
      default: void 0
    },
    lazyPreloadPrevNext: {
      type: Number,
      default: void 0
    },
    runCallbacksOnInit: {
      type: Boolean,
      default: void 0
    },
    observer: {
      type: Boolean,
      default: void 0
    },
    observeParents: {
      type: Boolean,
      default: void 0
    },
    observeSlideChildren: {
      type: Boolean,
      default: void 0
    },
    a11y: {
      type: [Boolean, Object],
      default: void 0
    },
    autoplay: {
      type: [Boolean, Object],
      default: void 0
    },
    controller: {
      type: Object,
      default: void 0
    },
    coverflowEffect: {
      type: Object,
      default: void 0
    },
    cubeEffect: {
      type: Object,
      default: void 0
    },
    fadeEffect: {
      type: Object,
      default: void 0
    },
    flipEffect: {
      type: Object,
      default: void 0
    },
    creativeEffect: {
      type: Object,
      default: void 0
    },
    cardsEffect: {
      type: Object,
      default: void 0
    },
    hashNavigation: {
      type: [Boolean, Object],
      default: void 0
    },
    history: {
      type: [Boolean, Object],
      default: void 0
    },
    keyboard: {
      type: [Boolean, Object],
      default: void 0
    },
    mousewheel: {
      type: [Boolean, Object],
      default: void 0
    },
    navigation: {
      type: [Boolean, Object],
      default: void 0
    },
    pagination: {
      type: [Boolean, Object],
      default: void 0
    },
    parallax: {
      type: [Boolean, Object],
      default: void 0
    },
    scrollbar: {
      type: [Boolean, Object],
      default: void 0
    },
    thumbs: {
      type: Object,
      default: void 0
    },
    virtual: {
      type: [Boolean, Object],
      default: void 0
    },
    zoom: {
      type: [Boolean, Object],
      default: void 0
    },
    grid: {
      type: [Object],
      default: void 0
    },
    freeMode: {
      type: [Boolean, Object],
      default: void 0
    },
    enabled: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["_beforeBreakpoint", "_containerClasses", "_slideClass", "_slideClasses", "_swiper", "_freeModeNoMomentumRelease", "activeIndexChange", "afterInit", "autoplay", "autoplayStart", "autoplayStop", "autoplayPause", "autoplayResume", "autoplayTimeLeft", "beforeDestroy", "beforeInit", "beforeLoopFix", "beforeResize", "beforeSlideChangeStart", "beforeTransitionStart", "breakpoint", "changeDirection", "click", "disable", "doubleTap", "doubleClick", "destroy", "enable", "fromEdge", "hashChange", "hashSet", "init", "keyPress", "lock", "loopFix", "momentumBounce", "navigationHide", "navigationShow", "navigationPrev", "navigationNext", "observerUpdate", "orientationchange", "paginationHide", "paginationRender", "paginationShow", "paginationUpdate", "progress", "reachBeginning", "reachEnd", "realIndexChange", "resize", "scroll", "scrollbarDragEnd", "scrollbarDragMove", "scrollbarDragStart", "setTransition", "setTranslate", "slidesUpdated", "slideChange", "slideChangeTransitionEnd", "slideChangeTransitionStart", "slideNextTransitionEnd", "slideNextTransitionStart", "slidePrevTransitionEnd", "slidePrevTransitionStart", "slideResetTransitionStart", "slideResetTransitionEnd", "sliderMove", "sliderFirstMove", "slidesLengthChange", "slidesGridLengthChange", "snapGridLengthChange", "snapIndexChange", "swiper", "tap", "toEdge", "touchEnd", "touchMove", "touchMoveOpposite", "touchStart", "transitionEnd", "transitionStart", "unlock", "update", "virtualUpdate", "zoomChange"],
  setup(m, c) {
    let {
      slots: ie,
      emit: we
    } = c;
    const {
      tag: $e,
      wrapperTag: Me
    } = m, Ze = ref$1("swiper"), ne = ref$1(null), rr = ref$1(!1), gr = ref$1(!1), or = ref$1(null), _r = ref$1(null), Lr = ref$1(null), Ir = {
      value: []
    }, Ar = {
      value: []
    }, Rr = ref$1(null), Nr = ref$1(null), Yr = ref$1(null), Vr = ref$1(null), {
      params: Xr,
      passedParams: Wr
    } = getParams(m, !1);
    getChildren(ie, Ir, Ar), Lr.value = Wr, Ar.value = Ir.value;
    const si = () => {
      getChildren(ie, Ir, Ar), rr.value = !0;
    };
    Xr.onAny = function(di) {
      for (var oi = arguments.length, ci = new Array(oi > 1 ? oi - 1 : 0), vr = 1; vr < oi; vr++)
        ci[vr - 1] = arguments[vr];
      we(di, ...ci);
    }, Object.assign(Xr.on, {
      _beforeBreakpoint: si,
      _containerClasses(di, oi) {
        Ze.value = oi;
      }
    });
    const li = {
      ...Xr
    };
    if (delete li.wrapperClass, _r.value = new Swiper$1(li), _r.value.virtual && _r.value.params.virtual.enabled) {
      _r.value.virtual.slides = Ir.value;
      const di = {
        cache: !1,
        slides: Ir.value,
        renderExternal: (oi) => {
          ne.value = oi;
        },
        renderExternalUpdate: !1
      };
      extend(_r.value.params.virtual, di), extend(_r.value.originalParams.virtual, di);
    }
    onUpdated(() => {
      !gr.value && _r.value && (_r.value.emitSlidesClasses(), gr.value = !0);
      const {
        passedParams: di
      } = getParams(m, !1), oi = getChangedParams(di, Lr.value, Ir.value, Ar.value, (ci) => ci.props && ci.props.key);
      Lr.value = di, (oi.length || rr.value) && _r.value && !_r.value.destroyed && updateSwiper({
        swiper: _r.value,
        slides: Ir.value,
        passedParams: di,
        changedParams: oi,
        nextEl: Rr.value,
        prevEl: Nr.value,
        scrollbarEl: Vr.value,
        paginationEl: Yr.value
      }), rr.value = !1;
    }), provide("swiper", _r), watch(ne, () => {
      nextTick$3(() => {
        updateOnVirtualData(_r.value);
      });
    }), onMounted(() => {
      !or.value || (mountSwiper({
        el: or.value,
        nextEl: Rr.value,
        prevEl: Nr.value,
        paginationEl: Yr.value,
        scrollbarEl: Vr.value,
        swiper: _r.value
      }, Xr), we("swiper", _r.value));
    }), onBeforeUnmount(() => {
      _r.value && !_r.value.destroyed && _r.value.destroy(!0, !1);
    });
    function xi(di) {
      return Xr.virtual ? renderVirtual(_r, di, ne.value) : (di.forEach((oi, ci) => {
        oi.props || (oi.props = {}), oi.props.swiperRef = _r, oi.props.swiperSlideIndex = ci;
      }), di);
    }
    return () => {
      const {
        slides: di,
        slots: oi
      } = getChildren(ie, Ir, Ar);
      return h$1($e, {
        ref: or,
        class: uniqueClasses(Ze.value)
      }, [oi["container-start"], h$1(Me, {
        class: wrapperClass(Xr.wrapperClass)
      }, [oi["wrapper-start"], xi(di), oi["wrapper-end"]]), needsNavigation(m) && [h$1("div", {
        ref: Nr,
        class: "swiper-button-prev"
      }), h$1("div", {
        ref: Rr,
        class: "swiper-button-next"
      })], needsScrollbar(m) && h$1("div", {
        ref: Vr,
        class: "swiper-scrollbar"
      }), needsPagination(m) && h$1("div", {
        ref: Yr,
        class: "swiper-pagination"
      }), oi["container-end"]]);
    };
  }
}, SwiperSlide = {
  name: "SwiperSlide",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    swiperRef: {
      type: Object,
      required: !1
    },
    swiperSlideIndex: {
      type: Number,
      default: void 0,
      required: !1
    },
    zoom: {
      type: Boolean,
      default: void 0,
      required: !1
    },
    lazy: {
      type: Boolean,
      default: !1,
      required: !1
    },
    virtualIndex: {
      type: [String, Number],
      default: void 0
    }
  },
  setup(m, c) {
    let {
      slots: ie
    } = c, we = !1;
    const {
      swiperRef: $e
    } = m, Me = ref$1(null), Ze = ref$1("swiper-slide"), ne = ref$1(!1);
    function rr(_r, Lr, Ir) {
      Lr === Me.value && (Ze.value = Ir);
    }
    onMounted(() => {
      !$e || !$e.value || ($e.value.on("_slideClass", rr), we = !0);
    }), onBeforeUpdate(() => {
      we || !$e || !$e.value || ($e.value.on("_slideClass", rr), we = !0);
    }), onUpdated(() => {
      !Me.value || !$e || !$e.value || (typeof m.swiperSlideIndex < "u" && (Me.value.swiperSlideIndex = m.swiperSlideIndex), $e.value.destroyed && Ze.value !== "swiper-slide" && (Ze.value = "swiper-slide"));
    }), onBeforeUnmount(() => {
      !$e || !$e.value || $e.value.off("_slideClass", rr);
    });
    const gr = computed(() => ({
      isActive: Ze.value.indexOf("swiper-slide-active") >= 0,
      isVisible: Ze.value.indexOf("swiper-slide-visible") >= 0,
      isPrev: Ze.value.indexOf("swiper-slide-prev") >= 0,
      isNext: Ze.value.indexOf("swiper-slide-next") >= 0
    }));
    provide("swiperSlide", gr);
    const or = () => {
      ne.value = !0;
    };
    return () => h$1(m.tag, {
      class: uniqueClasses(`${Ze.value}`),
      ref: Me,
      "data-swiper-slide-index": typeof m.virtualIndex > "u" && $e && $e.value && $e.value.params.loop ? m.swiperSlideIndex : m.virtualIndex,
      onLoadCapture: or
    }, m.zoom ? h$1("div", {
      class: "swiper-zoom-container",
      "data-swiper-zoom": typeof m.zoom == "number" ? m.zoom : void 0
    }, [ie.default && ie.default(gr.value), m.lazy && !ne.value && h$1("div", {
      class: "swiper-lazy-preloader"
    })]) : [ie.default && ie.default(gr.value), m.lazy && !ne.value && h$1("div", {
      class: "swiper-lazy-preloader"
    })]);
  }
};
async function cropImage({ imageSource: m, cropX: c, cropY: ie, cropWidth: we, cropHeight: $e, type: Me, quality: Ze }, ne) {
  function rr(_r) {
    return new Promise((Lr, Ir) => {
      const Ar = new Image();
      Ar.crossOrigin = "anonymous", Ar.onload = () => Lr(Ar), Ar.onerror = (Rr) => Ir(new Error("Failed to load image: " + Rr)), Ar.src = _r;
    });
  }
  const gr = document.createElement("canvas"), or = gr.getContext("2d");
  if (!or)
    throw new Error("Failed to create 2D context");
  return gr.width = we, gr.height = $e, or.drawImage(
    typeof m == "string" ? await rr(m) : m,
    c,
    ie,
    we,
    $e,
    0,
    0,
    we,
    $e
  ), ne === "canvas" ? gr : ne === "blob" ? await new Promise((_r, Lr) => {
    gr.toBlob(
      (Ir) => {
        Ir ? _r(Ir) : Lr(new Error("Failed to create Blob from canvas"));
      },
      Me,
      Ze
    );
  }) : ne === "dataUrl" ? gr.toDataURL(Me, Ze) : await new Promise((_r, Lr) => {
    gr.toBlob(
      (Ir) => {
        Ir ? Ir.arrayBuffer().then((Ar) => {
          _r(Ar);
        }).catch(Lr) : Lr(new Error("Failed to create Blob from canvas"));
      },
      Me,
      Ze
    );
  });
}
var mimeTypes = {}, mimeDb = { exports: {} };
const require$$0 = {
  "application/1d-interleaved-parityfec": {
    source: "iana"
  },
  "application/3gpdash-qoe-report+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/3gpp-ims+xml": {
    source: "iana",
    compressible: !0
  },
  "application/3gpphal+json": {
    source: "iana",
    compressible: !0
  },
  "application/3gpphalforms+json": {
    source: "iana",
    compressible: !0
  },
  "application/a2l": {
    source: "iana"
  },
  "application/ace+cbor": {
    source: "iana"
  },
  "application/activemessage": {
    source: "iana"
  },
  "application/activity+json": {
    source: "iana",
    compressible: !0
  },
  "application/alto-costmap+json": {
    source: "iana",
    compressible: !0
  },
  "application/alto-costmapfilter+json": {
    source: "iana",
    compressible: !0
  },
  "application/alto-directory+json": {
    source: "iana",
    compressible: !0
  },
  "application/alto-endpointcost+json": {
    source: "iana",
    compressible: !0
  },
  "application/alto-endpointcostparams+json": {
    source: "iana",
    compressible: !0
  },
  "application/alto-endpointprop+json": {
    source: "iana",
    compressible: !0
  },
  "application/alto-endpointpropparams+json": {
    source: "iana",
    compressible: !0
  },
  "application/alto-error+json": {
    source: "iana",
    compressible: !0
  },
  "application/alto-networkmap+json": {
    source: "iana",
    compressible: !0
  },
  "application/alto-networkmapfilter+json": {
    source: "iana",
    compressible: !0
  },
  "application/alto-updatestreamcontrol+json": {
    source: "iana",
    compressible: !0
  },
  "application/alto-updatestreamparams+json": {
    source: "iana",
    compressible: !0
  },
  "application/aml": {
    source: "iana"
  },
  "application/andrew-inset": {
    source: "iana",
    extensions: [
      "ez"
    ]
  },
  "application/applefile": {
    source: "iana"
  },
  "application/applixware": {
    source: "apache",
    extensions: [
      "aw"
    ]
  },
  "application/at+jwt": {
    source: "iana"
  },
  "application/atf": {
    source: "iana"
  },
  "application/atfx": {
    source: "iana"
  },
  "application/atom+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "atom"
    ]
  },
  "application/atomcat+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "atomcat"
    ]
  },
  "application/atomdeleted+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "atomdeleted"
    ]
  },
  "application/atomicmail": {
    source: "iana"
  },
  "application/atomsvc+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "atomsvc"
    ]
  },
  "application/atsc-dwd+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "dwd"
    ]
  },
  "application/atsc-dynamic-event-message": {
    source: "iana"
  },
  "application/atsc-held+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "held"
    ]
  },
  "application/atsc-rdt+json": {
    source: "iana",
    compressible: !0
  },
  "application/atsc-rsat+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "rsat"
    ]
  },
  "application/atxml": {
    source: "iana"
  },
  "application/auth-policy+xml": {
    source: "iana",
    compressible: !0
  },
  "application/bacnet-xdd+zip": {
    source: "iana",
    compressible: !1
  },
  "application/batch-smtp": {
    source: "iana"
  },
  "application/bdoc": {
    compressible: !1,
    extensions: [
      "bdoc"
    ]
  },
  "application/beep+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/calendar+json": {
    source: "iana",
    compressible: !0
  },
  "application/calendar+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xcs"
    ]
  },
  "application/call-completion": {
    source: "iana"
  },
  "application/cals-1840": {
    source: "iana"
  },
  "application/captive+json": {
    source: "iana",
    compressible: !0
  },
  "application/cbor": {
    source: "iana"
  },
  "application/cbor-seq": {
    source: "iana"
  },
  "application/cccex": {
    source: "iana"
  },
  "application/ccmp+xml": {
    source: "iana",
    compressible: !0
  },
  "application/ccxml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "ccxml"
    ]
  },
  "application/cdfx+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "cdfx"
    ]
  },
  "application/cdmi-capability": {
    source: "iana",
    extensions: [
      "cdmia"
    ]
  },
  "application/cdmi-container": {
    source: "iana",
    extensions: [
      "cdmic"
    ]
  },
  "application/cdmi-domain": {
    source: "iana",
    extensions: [
      "cdmid"
    ]
  },
  "application/cdmi-object": {
    source: "iana",
    extensions: [
      "cdmio"
    ]
  },
  "application/cdmi-queue": {
    source: "iana",
    extensions: [
      "cdmiq"
    ]
  },
  "application/cdni": {
    source: "iana"
  },
  "application/cea": {
    source: "iana"
  },
  "application/cea-2018+xml": {
    source: "iana",
    compressible: !0
  },
  "application/cellml+xml": {
    source: "iana",
    compressible: !0
  },
  "application/cfw": {
    source: "iana"
  },
  "application/city+json": {
    source: "iana",
    compressible: !0
  },
  "application/clr": {
    source: "iana"
  },
  "application/clue+xml": {
    source: "iana",
    compressible: !0
  },
  "application/clue_info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/cms": {
    source: "iana"
  },
  "application/cnrp+xml": {
    source: "iana",
    compressible: !0
  },
  "application/coap-group+json": {
    source: "iana",
    compressible: !0
  },
  "application/coap-payload": {
    source: "iana"
  },
  "application/commonground": {
    source: "iana"
  },
  "application/conference-info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/cose": {
    source: "iana"
  },
  "application/cose-key": {
    source: "iana"
  },
  "application/cose-key-set": {
    source: "iana"
  },
  "application/cpl+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "cpl"
    ]
  },
  "application/csrattrs": {
    source: "iana"
  },
  "application/csta+xml": {
    source: "iana",
    compressible: !0
  },
  "application/cstadata+xml": {
    source: "iana",
    compressible: !0
  },
  "application/csvm+json": {
    source: "iana",
    compressible: !0
  },
  "application/cu-seeme": {
    source: "apache",
    extensions: [
      "cu"
    ]
  },
  "application/cwt": {
    source: "iana"
  },
  "application/cybercash": {
    source: "iana"
  },
  "application/dart": {
    compressible: !0
  },
  "application/dash+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "mpd"
    ]
  },
  "application/dash-patch+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "mpp"
    ]
  },
  "application/dashdelta": {
    source: "iana"
  },
  "application/davmount+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "davmount"
    ]
  },
  "application/dca-rft": {
    source: "iana"
  },
  "application/dcd": {
    source: "iana"
  },
  "application/dec-dx": {
    source: "iana"
  },
  "application/dialog-info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/dicom": {
    source: "iana"
  },
  "application/dicom+json": {
    source: "iana",
    compressible: !0
  },
  "application/dicom+xml": {
    source: "iana",
    compressible: !0
  },
  "application/dii": {
    source: "iana"
  },
  "application/dit": {
    source: "iana"
  },
  "application/dns": {
    source: "iana"
  },
  "application/dns+json": {
    source: "iana",
    compressible: !0
  },
  "application/dns-message": {
    source: "iana"
  },
  "application/docbook+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "dbk"
    ]
  },
  "application/dots+cbor": {
    source: "iana"
  },
  "application/dskpp+xml": {
    source: "iana",
    compressible: !0
  },
  "application/dssc+der": {
    source: "iana",
    extensions: [
      "dssc"
    ]
  },
  "application/dssc+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xdssc"
    ]
  },
  "application/dvcs": {
    source: "iana"
  },
  "application/ecmascript": {
    source: "iana",
    compressible: !0,
    extensions: [
      "es",
      "ecma"
    ]
  },
  "application/edi-consent": {
    source: "iana"
  },
  "application/edi-x12": {
    source: "iana",
    compressible: !1
  },
  "application/edifact": {
    source: "iana",
    compressible: !1
  },
  "application/efi": {
    source: "iana"
  },
  "application/elm+json": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/elm+xml": {
    source: "iana",
    compressible: !0
  },
  "application/emergencycalldata.cap+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/emergencycalldata.comment+xml": {
    source: "iana",
    compressible: !0
  },
  "application/emergencycalldata.control+xml": {
    source: "iana",
    compressible: !0
  },
  "application/emergencycalldata.deviceinfo+xml": {
    source: "iana",
    compressible: !0
  },
  "application/emergencycalldata.ecall.msd": {
    source: "iana"
  },
  "application/emergencycalldata.providerinfo+xml": {
    source: "iana",
    compressible: !0
  },
  "application/emergencycalldata.serviceinfo+xml": {
    source: "iana",
    compressible: !0
  },
  "application/emergencycalldata.subscriberinfo+xml": {
    source: "iana",
    compressible: !0
  },
  "application/emergencycalldata.veds+xml": {
    source: "iana",
    compressible: !0
  },
  "application/emma+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "emma"
    ]
  },
  "application/emotionml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "emotionml"
    ]
  },
  "application/encaprtp": {
    source: "iana"
  },
  "application/epp+xml": {
    source: "iana",
    compressible: !0
  },
  "application/epub+zip": {
    source: "iana",
    compressible: !1,
    extensions: [
      "epub"
    ]
  },
  "application/eshop": {
    source: "iana"
  },
  "application/exi": {
    source: "iana",
    extensions: [
      "exi"
    ]
  },
  "application/expect-ct-report+json": {
    source: "iana",
    compressible: !0
  },
  "application/express": {
    source: "iana",
    extensions: [
      "exp"
    ]
  },
  "application/fastinfoset": {
    source: "iana"
  },
  "application/fastsoap": {
    source: "iana"
  },
  "application/fdt+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "fdt"
    ]
  },
  "application/fhir+json": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/fhir+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/fido.trusted-apps+json": {
    compressible: !0
  },
  "application/fits": {
    source: "iana"
  },
  "application/flexfec": {
    source: "iana"
  },
  "application/font-sfnt": {
    source: "iana"
  },
  "application/font-tdpfr": {
    source: "iana",
    extensions: [
      "pfr"
    ]
  },
  "application/font-woff": {
    source: "iana",
    compressible: !1
  },
  "application/framework-attributes+xml": {
    source: "iana",
    compressible: !0
  },
  "application/geo+json": {
    source: "iana",
    compressible: !0,
    extensions: [
      "geojson"
    ]
  },
  "application/geo+json-seq": {
    source: "iana"
  },
  "application/geopackage+sqlite3": {
    source: "iana"
  },
  "application/geoxacml+xml": {
    source: "iana",
    compressible: !0
  },
  "application/gltf-buffer": {
    source: "iana"
  },
  "application/gml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "gml"
    ]
  },
  "application/gpx+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "gpx"
    ]
  },
  "application/gxf": {
    source: "apache",
    extensions: [
      "gxf"
    ]
  },
  "application/gzip": {
    source: "iana",
    compressible: !1,
    extensions: [
      "gz"
    ]
  },
  "application/h224": {
    source: "iana"
  },
  "application/held+xml": {
    source: "iana",
    compressible: !0
  },
  "application/hjson": {
    extensions: [
      "hjson"
    ]
  },
  "application/http": {
    source: "iana"
  },
  "application/hyperstudio": {
    source: "iana",
    extensions: [
      "stk"
    ]
  },
  "application/ibe-key-request+xml": {
    source: "iana",
    compressible: !0
  },
  "application/ibe-pkg-reply+xml": {
    source: "iana",
    compressible: !0
  },
  "application/ibe-pp-data": {
    source: "iana"
  },
  "application/iges": {
    source: "iana"
  },
  "application/im-iscomposing+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/index": {
    source: "iana"
  },
  "application/index.cmd": {
    source: "iana"
  },
  "application/index.obj": {
    source: "iana"
  },
  "application/index.response": {
    source: "iana"
  },
  "application/index.vnd": {
    source: "iana"
  },
  "application/inkml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "ink",
      "inkml"
    ]
  },
  "application/iotp": {
    source: "iana"
  },
  "application/ipfix": {
    source: "iana",
    extensions: [
      "ipfix"
    ]
  },
  "application/ipp": {
    source: "iana"
  },
  "application/isup": {
    source: "iana"
  },
  "application/its+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "its"
    ]
  },
  "application/java-archive": {
    source: "apache",
    compressible: !1,
    extensions: [
      "jar",
      "war",
      "ear"
    ]
  },
  "application/java-serialized-object": {
    source: "apache",
    compressible: !1,
    extensions: [
      "ser"
    ]
  },
  "application/java-vm": {
    source: "apache",
    compressible: !1,
    extensions: [
      "class"
    ]
  },
  "application/javascript": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0,
    extensions: [
      "js",
      "mjs"
    ]
  },
  "application/jf2feed+json": {
    source: "iana",
    compressible: !0
  },
  "application/jose": {
    source: "iana"
  },
  "application/jose+json": {
    source: "iana",
    compressible: !0
  },
  "application/jrd+json": {
    source: "iana",
    compressible: !0
  },
  "application/jscalendar+json": {
    source: "iana",
    compressible: !0
  },
  "application/json": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0,
    extensions: [
      "json",
      "map"
    ]
  },
  "application/json-patch+json": {
    source: "iana",
    compressible: !0
  },
  "application/json-seq": {
    source: "iana"
  },
  "application/json5": {
    extensions: [
      "json5"
    ]
  },
  "application/jsonml+json": {
    source: "apache",
    compressible: !0,
    extensions: [
      "jsonml"
    ]
  },
  "application/jwk+json": {
    source: "iana",
    compressible: !0
  },
  "application/jwk-set+json": {
    source: "iana",
    compressible: !0
  },
  "application/jwt": {
    source: "iana"
  },
  "application/kpml-request+xml": {
    source: "iana",
    compressible: !0
  },
  "application/kpml-response+xml": {
    source: "iana",
    compressible: !0
  },
  "application/ld+json": {
    source: "iana",
    compressible: !0,
    extensions: [
      "jsonld"
    ]
  },
  "application/lgr+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "lgr"
    ]
  },
  "application/link-format": {
    source: "iana"
  },
  "application/load-control+xml": {
    source: "iana",
    compressible: !0
  },
  "application/lost+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "lostxml"
    ]
  },
  "application/lostsync+xml": {
    source: "iana",
    compressible: !0
  },
  "application/lpf+zip": {
    source: "iana",
    compressible: !1
  },
  "application/lxf": {
    source: "iana"
  },
  "application/mac-binhex40": {
    source: "iana",
    extensions: [
      "hqx"
    ]
  },
  "application/mac-compactpro": {
    source: "apache",
    extensions: [
      "cpt"
    ]
  },
  "application/macwriteii": {
    source: "iana"
  },
  "application/mads+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "mads"
    ]
  },
  "application/manifest+json": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0,
    extensions: [
      "webmanifest"
    ]
  },
  "application/marc": {
    source: "iana",
    extensions: [
      "mrc"
    ]
  },
  "application/marcxml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "mrcx"
    ]
  },
  "application/mathematica": {
    source: "iana",
    extensions: [
      "ma",
      "nb",
      "mb"
    ]
  },
  "application/mathml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "mathml"
    ]
  },
  "application/mathml-content+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mathml-presentation+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mbms-associated-procedure-description+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mbms-deregister+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mbms-envelope+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mbms-msk+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mbms-msk-response+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mbms-protection-description+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mbms-reception-report+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mbms-register+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mbms-register-response+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mbms-schedule+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mbms-user-service-description+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mbox": {
    source: "iana",
    extensions: [
      "mbox"
    ]
  },
  "application/media-policy-dataset+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "mpf"
    ]
  },
  "application/media_control+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mediaservercontrol+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "mscml"
    ]
  },
  "application/merge-patch+json": {
    source: "iana",
    compressible: !0
  },
  "application/metalink+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "metalink"
    ]
  },
  "application/metalink4+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "meta4"
    ]
  },
  "application/mets+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "mets"
    ]
  },
  "application/mf4": {
    source: "iana"
  },
  "application/mikey": {
    source: "iana"
  },
  "application/mipc": {
    source: "iana"
  },
  "application/missing-blocks+cbor-seq": {
    source: "iana"
  },
  "application/mmt-aei+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "maei"
    ]
  },
  "application/mmt-usd+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "musd"
    ]
  },
  "application/mods+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "mods"
    ]
  },
  "application/moss-keys": {
    source: "iana"
  },
  "application/moss-signature": {
    source: "iana"
  },
  "application/mosskey-data": {
    source: "iana"
  },
  "application/mosskey-request": {
    source: "iana"
  },
  "application/mp21": {
    source: "iana",
    extensions: [
      "m21",
      "mp21"
    ]
  },
  "application/mp4": {
    source: "iana",
    extensions: [
      "mp4s",
      "m4p"
    ]
  },
  "application/mpeg4-generic": {
    source: "iana"
  },
  "application/mpeg4-iod": {
    source: "iana"
  },
  "application/mpeg4-iod-xmt": {
    source: "iana"
  },
  "application/mrb-consumer+xml": {
    source: "iana",
    compressible: !0
  },
  "application/mrb-publish+xml": {
    source: "iana",
    compressible: !0
  },
  "application/msc-ivr+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/msc-mixer+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/msword": {
    source: "iana",
    compressible: !1,
    extensions: [
      "doc",
      "dot"
    ]
  },
  "application/mud+json": {
    source: "iana",
    compressible: !0
  },
  "application/multipart-core": {
    source: "iana"
  },
  "application/mxf": {
    source: "iana",
    extensions: [
      "mxf"
    ]
  },
  "application/n-quads": {
    source: "iana",
    extensions: [
      "nq"
    ]
  },
  "application/n-triples": {
    source: "iana",
    extensions: [
      "nt"
    ]
  },
  "application/nasdata": {
    source: "iana"
  },
  "application/news-checkgroups": {
    source: "iana",
    charset: "US-ASCII"
  },
  "application/news-groupinfo": {
    source: "iana",
    charset: "US-ASCII"
  },
  "application/news-transmission": {
    source: "iana"
  },
  "application/nlsml+xml": {
    source: "iana",
    compressible: !0
  },
  "application/node": {
    source: "iana",
    extensions: [
      "cjs"
    ]
  },
  "application/nss": {
    source: "iana"
  },
  "application/oauth-authz-req+jwt": {
    source: "iana"
  },
  "application/oblivious-dns-message": {
    source: "iana"
  },
  "application/ocsp-request": {
    source: "iana"
  },
  "application/ocsp-response": {
    source: "iana"
  },
  "application/octet-stream": {
    source: "iana",
    compressible: !1,
    extensions: [
      "bin",
      "dms",
      "lrf",
      "mar",
      "so",
      "dist",
      "distz",
      "pkg",
      "bpk",
      "dump",
      "elc",
      "deploy",
      "exe",
      "dll",
      "deb",
      "dmg",
      "iso",
      "img",
      "msi",
      "msp",
      "msm",
      "buffer"
    ]
  },
  "application/oda": {
    source: "iana",
    extensions: [
      "oda"
    ]
  },
  "application/odm+xml": {
    source: "iana",
    compressible: !0
  },
  "application/odx": {
    source: "iana"
  },
  "application/oebps-package+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "opf"
    ]
  },
  "application/ogg": {
    source: "iana",
    compressible: !1,
    extensions: [
      "ogx"
    ]
  },
  "application/omdoc+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "omdoc"
    ]
  },
  "application/onenote": {
    source: "apache",
    extensions: [
      "onetoc",
      "onetoc2",
      "onetmp",
      "onepkg"
    ]
  },
  "application/opc-nodeset+xml": {
    source: "iana",
    compressible: !0
  },
  "application/oscore": {
    source: "iana"
  },
  "application/oxps": {
    source: "iana",
    extensions: [
      "oxps"
    ]
  },
  "application/p21": {
    source: "iana"
  },
  "application/p21+zip": {
    source: "iana",
    compressible: !1
  },
  "application/p2p-overlay+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "relo"
    ]
  },
  "application/parityfec": {
    source: "iana"
  },
  "application/passport": {
    source: "iana"
  },
  "application/patch-ops-error+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xer"
    ]
  },
  "application/pdf": {
    source: "iana",
    compressible: !1,
    extensions: [
      "pdf"
    ]
  },
  "application/pdx": {
    source: "iana"
  },
  "application/pem-certificate-chain": {
    source: "iana"
  },
  "application/pgp-encrypted": {
    source: "iana",
    compressible: !1,
    extensions: [
      "pgp"
    ]
  },
  "application/pgp-keys": {
    source: "iana",
    extensions: [
      "asc"
    ]
  },
  "application/pgp-signature": {
    source: "iana",
    extensions: [
      "asc",
      "sig"
    ]
  },
  "application/pics-rules": {
    source: "apache",
    extensions: [
      "prf"
    ]
  },
  "application/pidf+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/pidf-diff+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/pkcs10": {
    source: "iana",
    extensions: [
      "p10"
    ]
  },
  "application/pkcs12": {
    source: "iana"
  },
  "application/pkcs7-mime": {
    source: "iana",
    extensions: [
      "p7m",
      "p7c"
    ]
  },
  "application/pkcs7-signature": {
    source: "iana",
    extensions: [
      "p7s"
    ]
  },
  "application/pkcs8": {
    source: "iana",
    extensions: [
      "p8"
    ]
  },
  "application/pkcs8-encrypted": {
    source: "iana"
  },
  "application/pkix-attr-cert": {
    source: "iana",
    extensions: [
      "ac"
    ]
  },
  "application/pkix-cert": {
    source: "iana",
    extensions: [
      "cer"
    ]
  },
  "application/pkix-crl": {
    source: "iana",
    extensions: [
      "crl"
    ]
  },
  "application/pkix-pkipath": {
    source: "iana",
    extensions: [
      "pkipath"
    ]
  },
  "application/pkixcmp": {
    source: "iana",
    extensions: [
      "pki"
    ]
  },
  "application/pls+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "pls"
    ]
  },
  "application/poc-settings+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/postscript": {
    source: "iana",
    compressible: !0,
    extensions: [
      "ai",
      "eps",
      "ps"
    ]
  },
  "application/ppsp-tracker+json": {
    source: "iana",
    compressible: !0
  },
  "application/problem+json": {
    source: "iana",
    compressible: !0
  },
  "application/problem+xml": {
    source: "iana",
    compressible: !0
  },
  "application/provenance+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "provx"
    ]
  },
  "application/prs.alvestrand.titrax-sheet": {
    source: "iana"
  },
  "application/prs.cww": {
    source: "iana",
    extensions: [
      "cww"
    ]
  },
  "application/prs.cyn": {
    source: "iana",
    charset: "7-BIT"
  },
  "application/prs.hpub+zip": {
    source: "iana",
    compressible: !1
  },
  "application/prs.nprend": {
    source: "iana"
  },
  "application/prs.plucker": {
    source: "iana"
  },
  "application/prs.rdf-xml-crypt": {
    source: "iana"
  },
  "application/prs.xsf+xml": {
    source: "iana",
    compressible: !0
  },
  "application/pskc+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "pskcxml"
    ]
  },
  "application/pvd+json": {
    source: "iana",
    compressible: !0
  },
  "application/qsig": {
    source: "iana"
  },
  "application/raml+yaml": {
    compressible: !0,
    extensions: [
      "raml"
    ]
  },
  "application/raptorfec": {
    source: "iana"
  },
  "application/rdap+json": {
    source: "iana",
    compressible: !0
  },
  "application/rdf+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "rdf",
      "owl"
    ]
  },
  "application/reginfo+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "rif"
    ]
  },
  "application/relax-ng-compact-syntax": {
    source: "iana",
    extensions: [
      "rnc"
    ]
  },
  "application/remote-printing": {
    source: "iana"
  },
  "application/reputon+json": {
    source: "iana",
    compressible: !0
  },
  "application/resource-lists+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "rl"
    ]
  },
  "application/resource-lists-diff+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "rld"
    ]
  },
  "application/rfc+xml": {
    source: "iana",
    compressible: !0
  },
  "application/riscos": {
    source: "iana"
  },
  "application/rlmi+xml": {
    source: "iana",
    compressible: !0
  },
  "application/rls-services+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "rs"
    ]
  },
  "application/route-apd+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "rapd"
    ]
  },
  "application/route-s-tsid+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "sls"
    ]
  },
  "application/route-usd+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "rusd"
    ]
  },
  "application/rpki-ghostbusters": {
    source: "iana",
    extensions: [
      "gbr"
    ]
  },
  "application/rpki-manifest": {
    source: "iana",
    extensions: [
      "mft"
    ]
  },
  "application/rpki-publication": {
    source: "iana"
  },
  "application/rpki-roa": {
    source: "iana",
    extensions: [
      "roa"
    ]
  },
  "application/rpki-updown": {
    source: "iana"
  },
  "application/rsd+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "rsd"
    ]
  },
  "application/rss+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "rss"
    ]
  },
  "application/rtf": {
    source: "iana",
    compressible: !0,
    extensions: [
      "rtf"
    ]
  },
  "application/rtploopback": {
    source: "iana"
  },
  "application/rtx": {
    source: "iana"
  },
  "application/samlassertion+xml": {
    source: "iana",
    compressible: !0
  },
  "application/samlmetadata+xml": {
    source: "iana",
    compressible: !0
  },
  "application/sarif+json": {
    source: "iana",
    compressible: !0
  },
  "application/sarif-external-properties+json": {
    source: "iana",
    compressible: !0
  },
  "application/sbe": {
    source: "iana"
  },
  "application/sbml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "sbml"
    ]
  },
  "application/scaip+xml": {
    source: "iana",
    compressible: !0
  },
  "application/scim+json": {
    source: "iana",
    compressible: !0
  },
  "application/scvp-cv-request": {
    source: "iana",
    extensions: [
      "scq"
    ]
  },
  "application/scvp-cv-response": {
    source: "iana",
    extensions: [
      "scs"
    ]
  },
  "application/scvp-vp-request": {
    source: "iana",
    extensions: [
      "spq"
    ]
  },
  "application/scvp-vp-response": {
    source: "iana",
    extensions: [
      "spp"
    ]
  },
  "application/sdp": {
    source: "iana",
    extensions: [
      "sdp"
    ]
  },
  "application/secevent+jwt": {
    source: "iana"
  },
  "application/senml+cbor": {
    source: "iana"
  },
  "application/senml+json": {
    source: "iana",
    compressible: !0
  },
  "application/senml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "senmlx"
    ]
  },
  "application/senml-etch+cbor": {
    source: "iana"
  },
  "application/senml-etch+json": {
    source: "iana",
    compressible: !0
  },
  "application/senml-exi": {
    source: "iana"
  },
  "application/sensml+cbor": {
    source: "iana"
  },
  "application/sensml+json": {
    source: "iana",
    compressible: !0
  },
  "application/sensml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "sensmlx"
    ]
  },
  "application/sensml-exi": {
    source: "iana"
  },
  "application/sep+xml": {
    source: "iana",
    compressible: !0
  },
  "application/sep-exi": {
    source: "iana"
  },
  "application/session-info": {
    source: "iana"
  },
  "application/set-payment": {
    source: "iana"
  },
  "application/set-payment-initiation": {
    source: "iana",
    extensions: [
      "setpay"
    ]
  },
  "application/set-registration": {
    source: "iana"
  },
  "application/set-registration-initiation": {
    source: "iana",
    extensions: [
      "setreg"
    ]
  },
  "application/sgml": {
    source: "iana"
  },
  "application/sgml-open-catalog": {
    source: "iana"
  },
  "application/shf+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "shf"
    ]
  },
  "application/sieve": {
    source: "iana",
    extensions: [
      "siv",
      "sieve"
    ]
  },
  "application/simple-filter+xml": {
    source: "iana",
    compressible: !0
  },
  "application/simple-message-summary": {
    source: "iana"
  },
  "application/simplesymbolcontainer": {
    source: "iana"
  },
  "application/sipc": {
    source: "iana"
  },
  "application/slate": {
    source: "iana"
  },
  "application/smil": {
    source: "iana"
  },
  "application/smil+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "smi",
      "smil"
    ]
  },
  "application/smpte336m": {
    source: "iana"
  },
  "application/soap+fastinfoset": {
    source: "iana"
  },
  "application/soap+xml": {
    source: "iana",
    compressible: !0
  },
  "application/sparql-query": {
    source: "iana",
    extensions: [
      "rq"
    ]
  },
  "application/sparql-results+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "srx"
    ]
  },
  "application/spdx+json": {
    source: "iana",
    compressible: !0
  },
  "application/spirits-event+xml": {
    source: "iana",
    compressible: !0
  },
  "application/sql": {
    source: "iana"
  },
  "application/srgs": {
    source: "iana",
    extensions: [
      "gram"
    ]
  },
  "application/srgs+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "grxml"
    ]
  },
  "application/sru+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "sru"
    ]
  },
  "application/ssdl+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "ssdl"
    ]
  },
  "application/ssml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "ssml"
    ]
  },
  "application/stix+json": {
    source: "iana",
    compressible: !0
  },
  "application/swid+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "swidtag"
    ]
  },
  "application/tamp-apex-update": {
    source: "iana"
  },
  "application/tamp-apex-update-confirm": {
    source: "iana"
  },
  "application/tamp-community-update": {
    source: "iana"
  },
  "application/tamp-community-update-confirm": {
    source: "iana"
  },
  "application/tamp-error": {
    source: "iana"
  },
  "application/tamp-sequence-adjust": {
    source: "iana"
  },
  "application/tamp-sequence-adjust-confirm": {
    source: "iana"
  },
  "application/tamp-status-query": {
    source: "iana"
  },
  "application/tamp-status-response": {
    source: "iana"
  },
  "application/tamp-update": {
    source: "iana"
  },
  "application/tamp-update-confirm": {
    source: "iana"
  },
  "application/tar": {
    compressible: !0
  },
  "application/taxii+json": {
    source: "iana",
    compressible: !0
  },
  "application/td+json": {
    source: "iana",
    compressible: !0
  },
  "application/tei+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "tei",
      "teicorpus"
    ]
  },
  "application/tetra_isi": {
    source: "iana"
  },
  "application/thraud+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "tfi"
    ]
  },
  "application/timestamp-query": {
    source: "iana"
  },
  "application/timestamp-reply": {
    source: "iana"
  },
  "application/timestamped-data": {
    source: "iana",
    extensions: [
      "tsd"
    ]
  },
  "application/tlsrpt+gzip": {
    source: "iana"
  },
  "application/tlsrpt+json": {
    source: "iana",
    compressible: !0
  },
  "application/tnauthlist": {
    source: "iana"
  },
  "application/token-introspection+jwt": {
    source: "iana"
  },
  "application/toml": {
    compressible: !0,
    extensions: [
      "toml"
    ]
  },
  "application/trickle-ice-sdpfrag": {
    source: "iana"
  },
  "application/trig": {
    source: "iana",
    extensions: [
      "trig"
    ]
  },
  "application/ttml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "ttml"
    ]
  },
  "application/tve-trigger": {
    source: "iana"
  },
  "application/tzif": {
    source: "iana"
  },
  "application/tzif-leap": {
    source: "iana"
  },
  "application/ubjson": {
    compressible: !1,
    extensions: [
      "ubj"
    ]
  },
  "application/ulpfec": {
    source: "iana"
  },
  "application/urc-grpsheet+xml": {
    source: "iana",
    compressible: !0
  },
  "application/urc-ressheet+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "rsheet"
    ]
  },
  "application/urc-targetdesc+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "td"
    ]
  },
  "application/urc-uisocketdesc+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vcard+json": {
    source: "iana",
    compressible: !0
  },
  "application/vcard+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vemmi": {
    source: "iana"
  },
  "application/vividence.scriptfile": {
    source: "apache"
  },
  "application/vnd.1000minds.decision-model+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "1km"
    ]
  },
  "application/vnd.3gpp-prose+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp-prose-pc3ch+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp-v2x-local-service-information": {
    source: "iana"
  },
  "application/vnd.3gpp.5gnas": {
    source: "iana"
  },
  "application/vnd.3gpp.access-transfer-events+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.bsf+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.gmop+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.gtpc": {
    source: "iana"
  },
  "application/vnd.3gpp.interworking-data": {
    source: "iana"
  },
  "application/vnd.3gpp.lpp": {
    source: "iana"
  },
  "application/vnd.3gpp.mc-signalling-ear": {
    source: "iana"
  },
  "application/vnd.3gpp.mcdata-affiliation-command+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcdata-info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcdata-payload": {
    source: "iana"
  },
  "application/vnd.3gpp.mcdata-service-config+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcdata-signalling": {
    source: "iana"
  },
  "application/vnd.3gpp.mcdata-ue-config+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcdata-user-profile+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcptt-affiliation-command+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcptt-floor-request+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcptt-info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcptt-location-info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcptt-mbms-usage-info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcptt-service-config+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcptt-signed+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcptt-ue-config+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcptt-ue-init-config+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcptt-user-profile+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcvideo-affiliation-command+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcvideo-affiliation-info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcvideo-info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcvideo-location-info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcvideo-mbms-usage-info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcvideo-service-config+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcvideo-transmission-request+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcvideo-ue-config+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mcvideo-user-profile+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.mid-call+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.ngap": {
    source: "iana"
  },
  "application/vnd.3gpp.pfcp": {
    source: "iana"
  },
  "application/vnd.3gpp.pic-bw-large": {
    source: "iana",
    extensions: [
      "plb"
    ]
  },
  "application/vnd.3gpp.pic-bw-small": {
    source: "iana",
    extensions: [
      "psb"
    ]
  },
  "application/vnd.3gpp.pic-bw-var": {
    source: "iana",
    extensions: [
      "pvb"
    ]
  },
  "application/vnd.3gpp.s1ap": {
    source: "iana"
  },
  "application/vnd.3gpp.sms": {
    source: "iana"
  },
  "application/vnd.3gpp.sms+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.srvcc-ext+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.srvcc-info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.state-and-event-info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp.ussd+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp2.bcmcsinfo+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.3gpp2.sms": {
    source: "iana"
  },
  "application/vnd.3gpp2.tcap": {
    source: "iana",
    extensions: [
      "tcap"
    ]
  },
  "application/vnd.3lightssoftware.imagescal": {
    source: "iana"
  },
  "application/vnd.3m.post-it-notes": {
    source: "iana",
    extensions: [
      "pwn"
    ]
  },
  "application/vnd.accpac.simply.aso": {
    source: "iana",
    extensions: [
      "aso"
    ]
  },
  "application/vnd.accpac.simply.imp": {
    source: "iana",
    extensions: [
      "imp"
    ]
  },
  "application/vnd.acucobol": {
    source: "iana",
    extensions: [
      "acu"
    ]
  },
  "application/vnd.acucorp": {
    source: "iana",
    extensions: [
      "atc",
      "acutc"
    ]
  },
  "application/vnd.adobe.air-application-installer-package+zip": {
    source: "apache",
    compressible: !1,
    extensions: [
      "air"
    ]
  },
  "application/vnd.adobe.flash.movie": {
    source: "iana"
  },
  "application/vnd.adobe.formscentral.fcdt": {
    source: "iana",
    extensions: [
      "fcdt"
    ]
  },
  "application/vnd.adobe.fxp": {
    source: "iana",
    extensions: [
      "fxp",
      "fxpl"
    ]
  },
  "application/vnd.adobe.partial-upload": {
    source: "iana"
  },
  "application/vnd.adobe.xdp+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xdp"
    ]
  },
  "application/vnd.adobe.xfdf": {
    source: "iana",
    extensions: [
      "xfdf"
    ]
  },
  "application/vnd.aether.imp": {
    source: "iana"
  },
  "application/vnd.afpc.afplinedata": {
    source: "iana"
  },
  "application/vnd.afpc.afplinedata-pagedef": {
    source: "iana"
  },
  "application/vnd.afpc.cmoca-cmresource": {
    source: "iana"
  },
  "application/vnd.afpc.foca-charset": {
    source: "iana"
  },
  "application/vnd.afpc.foca-codedfont": {
    source: "iana"
  },
  "application/vnd.afpc.foca-codepage": {
    source: "iana"
  },
  "application/vnd.afpc.modca": {
    source: "iana"
  },
  "application/vnd.afpc.modca-cmtable": {
    source: "iana"
  },
  "application/vnd.afpc.modca-formdef": {
    source: "iana"
  },
  "application/vnd.afpc.modca-mediummap": {
    source: "iana"
  },
  "application/vnd.afpc.modca-objectcontainer": {
    source: "iana"
  },
  "application/vnd.afpc.modca-overlay": {
    source: "iana"
  },
  "application/vnd.afpc.modca-pagesegment": {
    source: "iana"
  },
  "application/vnd.age": {
    source: "iana",
    extensions: [
      "age"
    ]
  },
  "application/vnd.ah-barcode": {
    source: "iana"
  },
  "application/vnd.ahead.space": {
    source: "iana",
    extensions: [
      "ahead"
    ]
  },
  "application/vnd.airzip.filesecure.azf": {
    source: "iana",
    extensions: [
      "azf"
    ]
  },
  "application/vnd.airzip.filesecure.azs": {
    source: "iana",
    extensions: [
      "azs"
    ]
  },
  "application/vnd.amadeus+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.amazon.ebook": {
    source: "apache",
    extensions: [
      "azw"
    ]
  },
  "application/vnd.amazon.mobi8-ebook": {
    source: "iana"
  },
  "application/vnd.americandynamics.acc": {
    source: "iana",
    extensions: [
      "acc"
    ]
  },
  "application/vnd.amiga.ami": {
    source: "iana",
    extensions: [
      "ami"
    ]
  },
  "application/vnd.amundsen.maze+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.android.ota": {
    source: "iana"
  },
  "application/vnd.android.package-archive": {
    source: "apache",
    compressible: !1,
    extensions: [
      "apk"
    ]
  },
  "application/vnd.anki": {
    source: "iana"
  },
  "application/vnd.anser-web-certificate-issue-initiation": {
    source: "iana",
    extensions: [
      "cii"
    ]
  },
  "application/vnd.anser-web-funds-transfer-initiation": {
    source: "apache",
    extensions: [
      "fti"
    ]
  },
  "application/vnd.antix.game-component": {
    source: "iana",
    extensions: [
      "atx"
    ]
  },
  "application/vnd.apache.arrow.file": {
    source: "iana"
  },
  "application/vnd.apache.arrow.stream": {
    source: "iana"
  },
  "application/vnd.apache.thrift.binary": {
    source: "iana"
  },
  "application/vnd.apache.thrift.compact": {
    source: "iana"
  },
  "application/vnd.apache.thrift.json": {
    source: "iana"
  },
  "application/vnd.api+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.aplextor.warrp+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.apothekende.reservation+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.apple.installer+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "mpkg"
    ]
  },
  "application/vnd.apple.keynote": {
    source: "iana",
    extensions: [
      "key"
    ]
  },
  "application/vnd.apple.mpegurl": {
    source: "iana",
    extensions: [
      "m3u8"
    ]
  },
  "application/vnd.apple.numbers": {
    source: "iana",
    extensions: [
      "numbers"
    ]
  },
  "application/vnd.apple.pages": {
    source: "iana",
    extensions: [
      "pages"
    ]
  },
  "application/vnd.apple.pkpass": {
    compressible: !1,
    extensions: [
      "pkpass"
    ]
  },
  "application/vnd.arastra.swi": {
    source: "iana"
  },
  "application/vnd.aristanetworks.swi": {
    source: "iana",
    extensions: [
      "swi"
    ]
  },
  "application/vnd.artisan+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.artsquare": {
    source: "iana"
  },
  "application/vnd.astraea-software.iota": {
    source: "iana",
    extensions: [
      "iota"
    ]
  },
  "application/vnd.audiograph": {
    source: "iana",
    extensions: [
      "aep"
    ]
  },
  "application/vnd.autopackage": {
    source: "iana"
  },
  "application/vnd.avalon+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.avistar+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.balsamiq.bmml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "bmml"
    ]
  },
  "application/vnd.balsamiq.bmpr": {
    source: "iana"
  },
  "application/vnd.banana-accounting": {
    source: "iana"
  },
  "application/vnd.bbf.usp.error": {
    source: "iana"
  },
  "application/vnd.bbf.usp.msg": {
    source: "iana"
  },
  "application/vnd.bbf.usp.msg+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.bekitzur-stech+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.bint.med-content": {
    source: "iana"
  },
  "application/vnd.biopax.rdf+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.blink-idb-value-wrapper": {
    source: "iana"
  },
  "application/vnd.blueice.multipass": {
    source: "iana",
    extensions: [
      "mpm"
    ]
  },
  "application/vnd.bluetooth.ep.oob": {
    source: "iana"
  },
  "application/vnd.bluetooth.le.oob": {
    source: "iana"
  },
  "application/vnd.bmi": {
    source: "iana",
    extensions: [
      "bmi"
    ]
  },
  "application/vnd.bpf": {
    source: "iana"
  },
  "application/vnd.bpf3": {
    source: "iana"
  },
  "application/vnd.businessobjects": {
    source: "iana",
    extensions: [
      "rep"
    ]
  },
  "application/vnd.byu.uapi+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.cab-jscript": {
    source: "iana"
  },
  "application/vnd.canon-cpdl": {
    source: "iana"
  },
  "application/vnd.canon-lips": {
    source: "iana"
  },
  "application/vnd.capasystems-pg+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.cendio.thinlinc.clientconf": {
    source: "iana"
  },
  "application/vnd.century-systems.tcp_stream": {
    source: "iana"
  },
  "application/vnd.chemdraw+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "cdxml"
    ]
  },
  "application/vnd.chess-pgn": {
    source: "iana"
  },
  "application/vnd.chipnuts.karaoke-mmd": {
    source: "iana",
    extensions: [
      "mmd"
    ]
  },
  "application/vnd.ciedi": {
    source: "iana"
  },
  "application/vnd.cinderella": {
    source: "iana",
    extensions: [
      "cdy"
    ]
  },
  "application/vnd.cirpack.isdn-ext": {
    source: "iana"
  },
  "application/vnd.citationstyles.style+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "csl"
    ]
  },
  "application/vnd.claymore": {
    source: "iana",
    extensions: [
      "cla"
    ]
  },
  "application/vnd.cloanto.rp9": {
    source: "iana",
    extensions: [
      "rp9"
    ]
  },
  "application/vnd.clonk.c4group": {
    source: "iana",
    extensions: [
      "c4g",
      "c4d",
      "c4f",
      "c4p",
      "c4u"
    ]
  },
  "application/vnd.cluetrust.cartomobile-config": {
    source: "iana",
    extensions: [
      "c11amc"
    ]
  },
  "application/vnd.cluetrust.cartomobile-config-pkg": {
    source: "iana",
    extensions: [
      "c11amz"
    ]
  },
  "application/vnd.coffeescript": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.document": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.document-template": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.presentation": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.presentation-template": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.spreadsheet": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.spreadsheet-template": {
    source: "iana"
  },
  "application/vnd.collection+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.collection.doc+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.collection.next+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.comicbook+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.comicbook-rar": {
    source: "iana"
  },
  "application/vnd.commerce-battelle": {
    source: "iana"
  },
  "application/vnd.commonspace": {
    source: "iana",
    extensions: [
      "csp"
    ]
  },
  "application/vnd.contact.cmsg": {
    source: "iana",
    extensions: [
      "cdbcmsg"
    ]
  },
  "application/vnd.coreos.ignition+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.cosmocaller": {
    source: "iana",
    extensions: [
      "cmc"
    ]
  },
  "application/vnd.crick.clicker": {
    source: "iana",
    extensions: [
      "clkx"
    ]
  },
  "application/vnd.crick.clicker.keyboard": {
    source: "iana",
    extensions: [
      "clkk"
    ]
  },
  "application/vnd.crick.clicker.palette": {
    source: "iana",
    extensions: [
      "clkp"
    ]
  },
  "application/vnd.crick.clicker.template": {
    source: "iana",
    extensions: [
      "clkt"
    ]
  },
  "application/vnd.crick.clicker.wordbank": {
    source: "iana",
    extensions: [
      "clkw"
    ]
  },
  "application/vnd.criticaltools.wbs+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "wbs"
    ]
  },
  "application/vnd.cryptii.pipe+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.crypto-shade-file": {
    source: "iana"
  },
  "application/vnd.cryptomator.encrypted": {
    source: "iana"
  },
  "application/vnd.cryptomator.vault": {
    source: "iana"
  },
  "application/vnd.ctc-posml": {
    source: "iana",
    extensions: [
      "pml"
    ]
  },
  "application/vnd.ctct.ws+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.cups-pdf": {
    source: "iana"
  },
  "application/vnd.cups-postscript": {
    source: "iana"
  },
  "application/vnd.cups-ppd": {
    source: "iana",
    extensions: [
      "ppd"
    ]
  },
  "application/vnd.cups-raster": {
    source: "iana"
  },
  "application/vnd.cups-raw": {
    source: "iana"
  },
  "application/vnd.curl": {
    source: "iana"
  },
  "application/vnd.curl.car": {
    source: "apache",
    extensions: [
      "car"
    ]
  },
  "application/vnd.curl.pcurl": {
    source: "apache",
    extensions: [
      "pcurl"
    ]
  },
  "application/vnd.cyan.dean.root+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.cybank": {
    source: "iana"
  },
  "application/vnd.cyclonedx+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.cyclonedx+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.d2l.coursepackage1p0+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.d3m-dataset": {
    source: "iana"
  },
  "application/vnd.d3m-problem": {
    source: "iana"
  },
  "application/vnd.dart": {
    source: "iana",
    compressible: !0,
    extensions: [
      "dart"
    ]
  },
  "application/vnd.data-vision.rdz": {
    source: "iana",
    extensions: [
      "rdz"
    ]
  },
  "application/vnd.datapackage+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.dataresource+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.dbf": {
    source: "iana",
    extensions: [
      "dbf"
    ]
  },
  "application/vnd.debian.binary-package": {
    source: "iana"
  },
  "application/vnd.dece.data": {
    source: "iana",
    extensions: [
      "uvf",
      "uvvf",
      "uvd",
      "uvvd"
    ]
  },
  "application/vnd.dece.ttml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "uvt",
      "uvvt"
    ]
  },
  "application/vnd.dece.unspecified": {
    source: "iana",
    extensions: [
      "uvx",
      "uvvx"
    ]
  },
  "application/vnd.dece.zip": {
    source: "iana",
    extensions: [
      "uvz",
      "uvvz"
    ]
  },
  "application/vnd.denovo.fcselayout-link": {
    source: "iana",
    extensions: [
      "fe_launch"
    ]
  },
  "application/vnd.desmume.movie": {
    source: "iana"
  },
  "application/vnd.dir-bi.plate-dl-nosuffix": {
    source: "iana"
  },
  "application/vnd.dm.delegation+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.dna": {
    source: "iana",
    extensions: [
      "dna"
    ]
  },
  "application/vnd.document+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.dolby.mlp": {
    source: "apache",
    extensions: [
      "mlp"
    ]
  },
  "application/vnd.dolby.mobile.1": {
    source: "iana"
  },
  "application/vnd.dolby.mobile.2": {
    source: "iana"
  },
  "application/vnd.doremir.scorecloud-binary-document": {
    source: "iana"
  },
  "application/vnd.dpgraph": {
    source: "iana",
    extensions: [
      "dpg"
    ]
  },
  "application/vnd.dreamfactory": {
    source: "iana",
    extensions: [
      "dfac"
    ]
  },
  "application/vnd.drive+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.ds-keypoint": {
    source: "apache",
    extensions: [
      "kpxx"
    ]
  },
  "application/vnd.dtg.local": {
    source: "iana"
  },
  "application/vnd.dtg.local.flash": {
    source: "iana"
  },
  "application/vnd.dtg.local.html": {
    source: "iana"
  },
  "application/vnd.dvb.ait": {
    source: "iana",
    extensions: [
      "ait"
    ]
  },
  "application/vnd.dvb.dvbisl+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.dvb.dvbj": {
    source: "iana"
  },
  "application/vnd.dvb.esgcontainer": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcdftnotifaccess": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcesgaccess": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcesgaccess2": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcesgpdd": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcroaming": {
    source: "iana"
  },
  "application/vnd.dvb.iptv.alfec-base": {
    source: "iana"
  },
  "application/vnd.dvb.iptv.alfec-enhancement": {
    source: "iana"
  },
  "application/vnd.dvb.notif-aggregate-root+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.dvb.notif-container+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.dvb.notif-generic+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.dvb.notif-ia-msglist+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.dvb.notif-ia-registration-request+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.dvb.notif-ia-registration-response+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.dvb.notif-init+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.dvb.pfr": {
    source: "iana"
  },
  "application/vnd.dvb.service": {
    source: "iana",
    extensions: [
      "svc"
    ]
  },
  "application/vnd.dxr": {
    source: "iana"
  },
  "application/vnd.dynageo": {
    source: "iana",
    extensions: [
      "geo"
    ]
  },
  "application/vnd.dzr": {
    source: "iana"
  },
  "application/vnd.easykaraoke.cdgdownload": {
    source: "iana"
  },
  "application/vnd.ecdis-update": {
    source: "iana"
  },
  "application/vnd.ecip.rlp": {
    source: "iana"
  },
  "application/vnd.eclipse.ditto+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.ecowin.chart": {
    source: "iana",
    extensions: [
      "mag"
    ]
  },
  "application/vnd.ecowin.filerequest": {
    source: "iana"
  },
  "application/vnd.ecowin.fileupdate": {
    source: "iana"
  },
  "application/vnd.ecowin.series": {
    source: "iana"
  },
  "application/vnd.ecowin.seriesrequest": {
    source: "iana"
  },
  "application/vnd.ecowin.seriesupdate": {
    source: "iana"
  },
  "application/vnd.efi.img": {
    source: "iana"
  },
  "application/vnd.efi.iso": {
    source: "iana"
  },
  "application/vnd.emclient.accessrequest+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.enliven": {
    source: "iana",
    extensions: [
      "nml"
    ]
  },
  "application/vnd.enphase.envoy": {
    source: "iana"
  },
  "application/vnd.eprints.data+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.epson.esf": {
    source: "iana",
    extensions: [
      "esf"
    ]
  },
  "application/vnd.epson.msf": {
    source: "iana",
    extensions: [
      "msf"
    ]
  },
  "application/vnd.epson.quickanime": {
    source: "iana",
    extensions: [
      "qam"
    ]
  },
  "application/vnd.epson.salt": {
    source: "iana",
    extensions: [
      "slt"
    ]
  },
  "application/vnd.epson.ssf": {
    source: "iana",
    extensions: [
      "ssf"
    ]
  },
  "application/vnd.ericsson.quickcall": {
    source: "iana"
  },
  "application/vnd.espass-espass+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.eszigno3+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "es3",
      "et3"
    ]
  },
  "application/vnd.etsi.aoc+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.asic-e+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.etsi.asic-s+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.etsi.cug+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.iptvcommand+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.iptvdiscovery+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.iptvprofile+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.iptvsad-bc+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.iptvsad-cod+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.iptvsad-npvr+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.iptvservice+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.iptvsync+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.iptvueprofile+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.mcid+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.mheg5": {
    source: "iana"
  },
  "application/vnd.etsi.overload-control-policy-dataset+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.pstn+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.sci+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.simservs+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.timestamp-token": {
    source: "iana"
  },
  "application/vnd.etsi.tsl+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.etsi.tsl.der": {
    source: "iana"
  },
  "application/vnd.eu.kasparian.car+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.eudora.data": {
    source: "iana"
  },
  "application/vnd.evolv.ecig.profile": {
    source: "iana"
  },
  "application/vnd.evolv.ecig.settings": {
    source: "iana"
  },
  "application/vnd.evolv.ecig.theme": {
    source: "iana"
  },
  "application/vnd.exstream-empower+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.exstream-package": {
    source: "iana"
  },
  "application/vnd.ezpix-album": {
    source: "iana",
    extensions: [
      "ez2"
    ]
  },
  "application/vnd.ezpix-package": {
    source: "iana",
    extensions: [
      "ez3"
    ]
  },
  "application/vnd.f-secure.mobile": {
    source: "iana"
  },
  "application/vnd.familysearch.gedcom+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.fastcopy-disk-image": {
    source: "iana"
  },
  "application/vnd.fdf": {
    source: "iana",
    extensions: [
      "fdf"
    ]
  },
  "application/vnd.fdsn.mseed": {
    source: "iana",
    extensions: [
      "mseed"
    ]
  },
  "application/vnd.fdsn.seed": {
    source: "iana",
    extensions: [
      "seed",
      "dataless"
    ]
  },
  "application/vnd.ffsns": {
    source: "iana"
  },
  "application/vnd.ficlab.flb+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.filmit.zfc": {
    source: "iana"
  },
  "application/vnd.fints": {
    source: "iana"
  },
  "application/vnd.firemonkeys.cloudcell": {
    source: "iana"
  },
  "application/vnd.flographit": {
    source: "iana",
    extensions: [
      "gph"
    ]
  },
  "application/vnd.fluxtime.clip": {
    source: "iana",
    extensions: [
      "ftc"
    ]
  },
  "application/vnd.font-fontforge-sfd": {
    source: "iana"
  },
  "application/vnd.framemaker": {
    source: "iana",
    extensions: [
      "fm",
      "frame",
      "maker",
      "book"
    ]
  },
  "application/vnd.frogans.fnc": {
    source: "iana",
    extensions: [
      "fnc"
    ]
  },
  "application/vnd.frogans.ltf": {
    source: "iana",
    extensions: [
      "ltf"
    ]
  },
  "application/vnd.fsc.weblaunch": {
    source: "iana",
    extensions: [
      "fsc"
    ]
  },
  "application/vnd.fujifilm.fb.docuworks": {
    source: "iana"
  },
  "application/vnd.fujifilm.fb.docuworks.binder": {
    source: "iana"
  },
  "application/vnd.fujifilm.fb.docuworks.container": {
    source: "iana"
  },
  "application/vnd.fujifilm.fb.jfi+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.fujitsu.oasys": {
    source: "iana",
    extensions: [
      "oas"
    ]
  },
  "application/vnd.fujitsu.oasys2": {
    source: "iana",
    extensions: [
      "oa2"
    ]
  },
  "application/vnd.fujitsu.oasys3": {
    source: "iana",
    extensions: [
      "oa3"
    ]
  },
  "application/vnd.fujitsu.oasysgp": {
    source: "iana",
    extensions: [
      "fg5"
    ]
  },
  "application/vnd.fujitsu.oasysprs": {
    source: "iana",
    extensions: [
      "bh2"
    ]
  },
  "application/vnd.fujixerox.art-ex": {
    source: "iana"
  },
  "application/vnd.fujixerox.art4": {
    source: "iana"
  },
  "application/vnd.fujixerox.ddd": {
    source: "iana",
    extensions: [
      "ddd"
    ]
  },
  "application/vnd.fujixerox.docuworks": {
    source: "iana",
    extensions: [
      "xdw"
    ]
  },
  "application/vnd.fujixerox.docuworks.binder": {
    source: "iana",
    extensions: [
      "xbd"
    ]
  },
  "application/vnd.fujixerox.docuworks.container": {
    source: "iana"
  },
  "application/vnd.fujixerox.hbpl": {
    source: "iana"
  },
  "application/vnd.fut-misnet": {
    source: "iana"
  },
  "application/vnd.futoin+cbor": {
    source: "iana"
  },
  "application/vnd.futoin+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.fuzzysheet": {
    source: "iana",
    extensions: [
      "fzs"
    ]
  },
  "application/vnd.genomatix.tuxedo": {
    source: "iana",
    extensions: [
      "txd"
    ]
  },
  "application/vnd.gentics.grd+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.geo+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.geocube+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.geogebra.file": {
    source: "iana",
    extensions: [
      "ggb"
    ]
  },
  "application/vnd.geogebra.slides": {
    source: "iana"
  },
  "application/vnd.geogebra.tool": {
    source: "iana",
    extensions: [
      "ggt"
    ]
  },
  "application/vnd.geometry-explorer": {
    source: "iana",
    extensions: [
      "gex",
      "gre"
    ]
  },
  "application/vnd.geonext": {
    source: "iana",
    extensions: [
      "gxt"
    ]
  },
  "application/vnd.geoplan": {
    source: "iana",
    extensions: [
      "g2w"
    ]
  },
  "application/vnd.geospace": {
    source: "iana",
    extensions: [
      "g3w"
    ]
  },
  "application/vnd.gerber": {
    source: "iana"
  },
  "application/vnd.globalplatform.card-content-mgt": {
    source: "iana"
  },
  "application/vnd.globalplatform.card-content-mgt-response": {
    source: "iana"
  },
  "application/vnd.gmx": {
    source: "iana",
    extensions: [
      "gmx"
    ]
  },
  "application/vnd.google-apps.document": {
    compressible: !1,
    extensions: [
      "gdoc"
    ]
  },
  "application/vnd.google-apps.presentation": {
    compressible: !1,
    extensions: [
      "gslides"
    ]
  },
  "application/vnd.google-apps.spreadsheet": {
    compressible: !1,
    extensions: [
      "gsheet"
    ]
  },
  "application/vnd.google-earth.kml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "kml"
    ]
  },
  "application/vnd.google-earth.kmz": {
    source: "iana",
    compressible: !1,
    extensions: [
      "kmz"
    ]
  },
  "application/vnd.gov.sk.e-form+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.gov.sk.e-form+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.gov.sk.xmldatacontainer+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.grafeq": {
    source: "iana",
    extensions: [
      "gqf",
      "gqs"
    ]
  },
  "application/vnd.gridmp": {
    source: "iana"
  },
  "application/vnd.groove-account": {
    source: "iana",
    extensions: [
      "gac"
    ]
  },
  "application/vnd.groove-help": {
    source: "iana",
    extensions: [
      "ghf"
    ]
  },
  "application/vnd.groove-identity-message": {
    source: "iana",
    extensions: [
      "gim"
    ]
  },
  "application/vnd.groove-injector": {
    source: "iana",
    extensions: [
      "grv"
    ]
  },
  "application/vnd.groove-tool-message": {
    source: "iana",
    extensions: [
      "gtm"
    ]
  },
  "application/vnd.groove-tool-template": {
    source: "iana",
    extensions: [
      "tpl"
    ]
  },
  "application/vnd.groove-vcard": {
    source: "iana",
    extensions: [
      "vcg"
    ]
  },
  "application/vnd.hal+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.hal+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "hal"
    ]
  },
  "application/vnd.handheld-entertainment+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "zmm"
    ]
  },
  "application/vnd.hbci": {
    source: "iana",
    extensions: [
      "hbci"
    ]
  },
  "application/vnd.hc+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.hcl-bireports": {
    source: "iana"
  },
  "application/vnd.hdt": {
    source: "iana"
  },
  "application/vnd.heroku+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.hhe.lesson-player": {
    source: "iana",
    extensions: [
      "les"
    ]
  },
  "application/vnd.hl7cda+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/vnd.hl7v2+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/vnd.hp-hpgl": {
    source: "iana",
    extensions: [
      "hpgl"
    ]
  },
  "application/vnd.hp-hpid": {
    source: "iana",
    extensions: [
      "hpid"
    ]
  },
  "application/vnd.hp-hps": {
    source: "iana",
    extensions: [
      "hps"
    ]
  },
  "application/vnd.hp-jlyt": {
    source: "iana",
    extensions: [
      "jlt"
    ]
  },
  "application/vnd.hp-pcl": {
    source: "iana",
    extensions: [
      "pcl"
    ]
  },
  "application/vnd.hp-pclxl": {
    source: "iana",
    extensions: [
      "pclxl"
    ]
  },
  "application/vnd.httphone": {
    source: "iana"
  },
  "application/vnd.hydrostatix.sof-data": {
    source: "iana",
    extensions: [
      "sfd-hdstx"
    ]
  },
  "application/vnd.hyper+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.hyper-item+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.hyperdrive+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.hzn-3d-crossword": {
    source: "iana"
  },
  "application/vnd.ibm.afplinedata": {
    source: "iana"
  },
  "application/vnd.ibm.electronic-media": {
    source: "iana"
  },
  "application/vnd.ibm.minipay": {
    source: "iana",
    extensions: [
      "mpy"
    ]
  },
  "application/vnd.ibm.modcap": {
    source: "iana",
    extensions: [
      "afp",
      "listafp",
      "list3820"
    ]
  },
  "application/vnd.ibm.rights-management": {
    source: "iana",
    extensions: [
      "irm"
    ]
  },
  "application/vnd.ibm.secure-container": {
    source: "iana",
    extensions: [
      "sc"
    ]
  },
  "application/vnd.iccprofile": {
    source: "iana",
    extensions: [
      "icc",
      "icm"
    ]
  },
  "application/vnd.ieee.1905": {
    source: "iana"
  },
  "application/vnd.igloader": {
    source: "iana",
    extensions: [
      "igl"
    ]
  },
  "application/vnd.imagemeter.folder+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.imagemeter.image+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.immervision-ivp": {
    source: "iana",
    extensions: [
      "ivp"
    ]
  },
  "application/vnd.immervision-ivu": {
    source: "iana",
    extensions: [
      "ivu"
    ]
  },
  "application/vnd.ims.imsccv1p1": {
    source: "iana"
  },
  "application/vnd.ims.imsccv1p2": {
    source: "iana"
  },
  "application/vnd.ims.imsccv1p3": {
    source: "iana"
  },
  "application/vnd.ims.lis.v2.result+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.ims.lti.v2.toolconsumerprofile+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.ims.lti.v2.toolproxy+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.ims.lti.v2.toolproxy.id+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.ims.lti.v2.toolsettings+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.ims.lti.v2.toolsettings.simple+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.informedcontrol.rms+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.informix-visionary": {
    source: "iana"
  },
  "application/vnd.infotech.project": {
    source: "iana"
  },
  "application/vnd.infotech.project+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.innopath.wamp.notification": {
    source: "iana"
  },
  "application/vnd.insors.igm": {
    source: "iana",
    extensions: [
      "igm"
    ]
  },
  "application/vnd.intercon.formnet": {
    source: "iana",
    extensions: [
      "xpw",
      "xpx"
    ]
  },
  "application/vnd.intergeo": {
    source: "iana",
    extensions: [
      "i2g"
    ]
  },
  "application/vnd.intertrust.digibox": {
    source: "iana"
  },
  "application/vnd.intertrust.nncp": {
    source: "iana"
  },
  "application/vnd.intu.qbo": {
    source: "iana",
    extensions: [
      "qbo"
    ]
  },
  "application/vnd.intu.qfx": {
    source: "iana",
    extensions: [
      "qfx"
    ]
  },
  "application/vnd.iptc.g2.catalogitem+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.iptc.g2.conceptitem+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.iptc.g2.knowledgeitem+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.iptc.g2.newsitem+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.iptc.g2.newsmessage+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.iptc.g2.packageitem+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.iptc.g2.planningitem+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.ipunplugged.rcprofile": {
    source: "iana",
    extensions: [
      "rcprofile"
    ]
  },
  "application/vnd.irepository.package+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "irp"
    ]
  },
  "application/vnd.is-xpr": {
    source: "iana",
    extensions: [
      "xpr"
    ]
  },
  "application/vnd.isac.fcs": {
    source: "iana",
    extensions: [
      "fcs"
    ]
  },
  "application/vnd.iso11783-10+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.jam": {
    source: "iana",
    extensions: [
      "jam"
    ]
  },
  "application/vnd.japannet-directory-service": {
    source: "iana"
  },
  "application/vnd.japannet-jpnstore-wakeup": {
    source: "iana"
  },
  "application/vnd.japannet-payment-wakeup": {
    source: "iana"
  },
  "application/vnd.japannet-registration": {
    source: "iana"
  },
  "application/vnd.japannet-registration-wakeup": {
    source: "iana"
  },
  "application/vnd.japannet-setstore-wakeup": {
    source: "iana"
  },
  "application/vnd.japannet-verification": {
    source: "iana"
  },
  "application/vnd.japannet-verification-wakeup": {
    source: "iana"
  },
  "application/vnd.jcp.javame.midlet-rms": {
    source: "iana",
    extensions: [
      "rms"
    ]
  },
  "application/vnd.jisp": {
    source: "iana",
    extensions: [
      "jisp"
    ]
  },
  "application/vnd.joost.joda-archive": {
    source: "iana",
    extensions: [
      "joda"
    ]
  },
  "application/vnd.jsk.isdn-ngn": {
    source: "iana"
  },
  "application/vnd.kahootz": {
    source: "iana",
    extensions: [
      "ktz",
      "ktr"
    ]
  },
  "application/vnd.kde.karbon": {
    source: "iana",
    extensions: [
      "karbon"
    ]
  },
  "application/vnd.kde.kchart": {
    source: "iana",
    extensions: [
      "chrt"
    ]
  },
  "application/vnd.kde.kformula": {
    source: "iana",
    extensions: [
      "kfo"
    ]
  },
  "application/vnd.kde.kivio": {
    source: "iana",
    extensions: [
      "flw"
    ]
  },
  "application/vnd.kde.kontour": {
    source: "iana",
    extensions: [
      "kon"
    ]
  },
  "application/vnd.kde.kpresenter": {
    source: "iana",
    extensions: [
      "kpr",
      "kpt"
    ]
  },
  "application/vnd.kde.kspread": {
    source: "iana",
    extensions: [
      "ksp"
    ]
  },
  "application/vnd.kde.kword": {
    source: "iana",
    extensions: [
      "kwd",
      "kwt"
    ]
  },
  "application/vnd.kenameaapp": {
    source: "iana",
    extensions: [
      "htke"
    ]
  },
  "application/vnd.kidspiration": {
    source: "iana",
    extensions: [
      "kia"
    ]
  },
  "application/vnd.kinar": {
    source: "iana",
    extensions: [
      "kne",
      "knp"
    ]
  },
  "application/vnd.koan": {
    source: "iana",
    extensions: [
      "skp",
      "skd",
      "skt",
      "skm"
    ]
  },
  "application/vnd.kodak-descriptor": {
    source: "iana",
    extensions: [
      "sse"
    ]
  },
  "application/vnd.las": {
    source: "iana"
  },
  "application/vnd.las.las+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.las.las+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "lasxml"
    ]
  },
  "application/vnd.laszip": {
    source: "iana"
  },
  "application/vnd.leap+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.liberty-request+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.llamagraphics.life-balance.desktop": {
    source: "iana",
    extensions: [
      "lbd"
    ]
  },
  "application/vnd.llamagraphics.life-balance.exchange+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "lbe"
    ]
  },
  "application/vnd.logipipe.circuit+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.loom": {
    source: "iana"
  },
  "application/vnd.lotus-1-2-3": {
    source: "iana",
    extensions: [
      "123"
    ]
  },
  "application/vnd.lotus-approach": {
    source: "iana",
    extensions: [
      "apr"
    ]
  },
  "application/vnd.lotus-freelance": {
    source: "iana",
    extensions: [
      "pre"
    ]
  },
  "application/vnd.lotus-notes": {
    source: "iana",
    extensions: [
      "nsf"
    ]
  },
  "application/vnd.lotus-organizer": {
    source: "iana",
    extensions: [
      "org"
    ]
  },
  "application/vnd.lotus-screencam": {
    source: "iana",
    extensions: [
      "scm"
    ]
  },
  "application/vnd.lotus-wordpro": {
    source: "iana",
    extensions: [
      "lwp"
    ]
  },
  "application/vnd.macports.portpkg": {
    source: "iana",
    extensions: [
      "portpkg"
    ]
  },
  "application/vnd.mapbox-vector-tile": {
    source: "iana",
    extensions: [
      "mvt"
    ]
  },
  "application/vnd.marlin.drm.actiontoken+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.marlin.drm.conftoken+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.marlin.drm.license+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.marlin.drm.mdcf": {
    source: "iana"
  },
  "application/vnd.mason+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.maxar.archive.3tz+zip": {
    source: "iana",
    compressible: !1
  },
  "application/vnd.maxmind.maxmind-db": {
    source: "iana"
  },
  "application/vnd.mcd": {
    source: "iana",
    extensions: [
      "mcd"
    ]
  },
  "application/vnd.medcalcdata": {
    source: "iana",
    extensions: [
      "mc1"
    ]
  },
  "application/vnd.mediastation.cdkey": {
    source: "iana",
    extensions: [
      "cdkey"
    ]
  },
  "application/vnd.meridian-slingshot": {
    source: "iana"
  },
  "application/vnd.mfer": {
    source: "iana",
    extensions: [
      "mwf"
    ]
  },
  "application/vnd.mfmp": {
    source: "iana",
    extensions: [
      "mfm"
    ]
  },
  "application/vnd.micro+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.micrografx.flo": {
    source: "iana",
    extensions: [
      "flo"
    ]
  },
  "application/vnd.micrografx.igx": {
    source: "iana",
    extensions: [
      "igx"
    ]
  },
  "application/vnd.microsoft.portable-executable": {
    source: "iana"
  },
  "application/vnd.microsoft.windows.thumbnail-cache": {
    source: "iana"
  },
  "application/vnd.miele+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.mif": {
    source: "iana",
    extensions: [
      "mif"
    ]
  },
  "application/vnd.minisoft-hp3000-save": {
    source: "iana"
  },
  "application/vnd.mitsubishi.misty-guard.trustweb": {
    source: "iana"
  },
  "application/vnd.mobius.daf": {
    source: "iana",
    extensions: [
      "daf"
    ]
  },
  "application/vnd.mobius.dis": {
    source: "iana",
    extensions: [
      "dis"
    ]
  },
  "application/vnd.mobius.mbk": {
    source: "iana",
    extensions: [
      "mbk"
    ]
  },
  "application/vnd.mobius.mqy": {
    source: "iana",
    extensions: [
      "mqy"
    ]
  },
  "application/vnd.mobius.msl": {
    source: "iana",
    extensions: [
      "msl"
    ]
  },
  "application/vnd.mobius.plc": {
    source: "iana",
    extensions: [
      "plc"
    ]
  },
  "application/vnd.mobius.txf": {
    source: "iana",
    extensions: [
      "txf"
    ]
  },
  "application/vnd.mophun.application": {
    source: "iana",
    extensions: [
      "mpn"
    ]
  },
  "application/vnd.mophun.certificate": {
    source: "iana",
    extensions: [
      "mpc"
    ]
  },
  "application/vnd.motorola.flexsuite": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.adsi": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.fis": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.gotap": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.kmr": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.ttc": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.wem": {
    source: "iana"
  },
  "application/vnd.motorola.iprm": {
    source: "iana"
  },
  "application/vnd.mozilla.xul+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xul"
    ]
  },
  "application/vnd.ms-3mfdocument": {
    source: "iana"
  },
  "application/vnd.ms-artgalry": {
    source: "iana",
    extensions: [
      "cil"
    ]
  },
  "application/vnd.ms-asf": {
    source: "iana"
  },
  "application/vnd.ms-cab-compressed": {
    source: "iana",
    extensions: [
      "cab"
    ]
  },
  "application/vnd.ms-color.iccprofile": {
    source: "apache"
  },
  "application/vnd.ms-excel": {
    source: "iana",
    compressible: !1,
    extensions: [
      "xls",
      "xlm",
      "xla",
      "xlc",
      "xlt",
      "xlw"
    ]
  },
  "application/vnd.ms-excel.addin.macroenabled.12": {
    source: "iana",
    extensions: [
      "xlam"
    ]
  },
  "application/vnd.ms-excel.sheet.binary.macroenabled.12": {
    source: "iana",
    extensions: [
      "xlsb"
    ]
  },
  "application/vnd.ms-excel.sheet.macroenabled.12": {
    source: "iana",
    extensions: [
      "xlsm"
    ]
  },
  "application/vnd.ms-excel.template.macroenabled.12": {
    source: "iana",
    extensions: [
      "xltm"
    ]
  },
  "application/vnd.ms-fontobject": {
    source: "iana",
    compressible: !0,
    extensions: [
      "eot"
    ]
  },
  "application/vnd.ms-htmlhelp": {
    source: "iana",
    extensions: [
      "chm"
    ]
  },
  "application/vnd.ms-ims": {
    source: "iana",
    extensions: [
      "ims"
    ]
  },
  "application/vnd.ms-lrm": {
    source: "iana",
    extensions: [
      "lrm"
    ]
  },
  "application/vnd.ms-office.activex+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.ms-officetheme": {
    source: "iana",
    extensions: [
      "thmx"
    ]
  },
  "application/vnd.ms-opentype": {
    source: "apache",
    compressible: !0
  },
  "application/vnd.ms-outlook": {
    compressible: !1,
    extensions: [
      "msg"
    ]
  },
  "application/vnd.ms-package.obfuscated-opentype": {
    source: "apache"
  },
  "application/vnd.ms-pki.seccat": {
    source: "apache",
    extensions: [
      "cat"
    ]
  },
  "application/vnd.ms-pki.stl": {
    source: "apache",
    extensions: [
      "stl"
    ]
  },
  "application/vnd.ms-playready.initiator+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.ms-powerpoint": {
    source: "iana",
    compressible: !1,
    extensions: [
      "ppt",
      "pps",
      "pot"
    ]
  },
  "application/vnd.ms-powerpoint.addin.macroenabled.12": {
    source: "iana",
    extensions: [
      "ppam"
    ]
  },
  "application/vnd.ms-powerpoint.presentation.macroenabled.12": {
    source: "iana",
    extensions: [
      "pptm"
    ]
  },
  "application/vnd.ms-powerpoint.slide.macroenabled.12": {
    source: "iana",
    extensions: [
      "sldm"
    ]
  },
  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": {
    source: "iana",
    extensions: [
      "ppsm"
    ]
  },
  "application/vnd.ms-powerpoint.template.macroenabled.12": {
    source: "iana",
    extensions: [
      "potm"
    ]
  },
  "application/vnd.ms-printdevicecapabilities+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.ms-printing.printticket+xml": {
    source: "apache",
    compressible: !0
  },
  "application/vnd.ms-printschematicket+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.ms-project": {
    source: "iana",
    extensions: [
      "mpp",
      "mpt"
    ]
  },
  "application/vnd.ms-tnef": {
    source: "iana"
  },
  "application/vnd.ms-windows.devicepairing": {
    source: "iana"
  },
  "application/vnd.ms-windows.nwprinting.oob": {
    source: "iana"
  },
  "application/vnd.ms-windows.printerpairing": {
    source: "iana"
  },
  "application/vnd.ms-windows.wsd.oob": {
    source: "iana"
  },
  "application/vnd.ms-wmdrm.lic-chlg-req": {
    source: "iana"
  },
  "application/vnd.ms-wmdrm.lic-resp": {
    source: "iana"
  },
  "application/vnd.ms-wmdrm.meter-chlg-req": {
    source: "iana"
  },
  "application/vnd.ms-wmdrm.meter-resp": {
    source: "iana"
  },
  "application/vnd.ms-word.document.macroenabled.12": {
    source: "iana",
    extensions: [
      "docm"
    ]
  },
  "application/vnd.ms-word.template.macroenabled.12": {
    source: "iana",
    extensions: [
      "dotm"
    ]
  },
  "application/vnd.ms-works": {
    source: "iana",
    extensions: [
      "wps",
      "wks",
      "wcm",
      "wdb"
    ]
  },
  "application/vnd.ms-wpl": {
    source: "iana",
    extensions: [
      "wpl"
    ]
  },
  "application/vnd.ms-xpsdocument": {
    source: "iana",
    compressible: !1,
    extensions: [
      "xps"
    ]
  },
  "application/vnd.msa-disk-image": {
    source: "iana"
  },
  "application/vnd.mseq": {
    source: "iana",
    extensions: [
      "mseq"
    ]
  },
  "application/vnd.msign": {
    source: "iana"
  },
  "application/vnd.multiad.creator": {
    source: "iana"
  },
  "application/vnd.multiad.creator.cif": {
    source: "iana"
  },
  "application/vnd.music-niff": {
    source: "iana"
  },
  "application/vnd.musician": {
    source: "iana",
    extensions: [
      "mus"
    ]
  },
  "application/vnd.muvee.style": {
    source: "iana",
    extensions: [
      "msty"
    ]
  },
  "application/vnd.mynfc": {
    source: "iana",
    extensions: [
      "taglet"
    ]
  },
  "application/vnd.nacamar.ybrid+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.ncd.control": {
    source: "iana"
  },
  "application/vnd.ncd.reference": {
    source: "iana"
  },
  "application/vnd.nearst.inv+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.nebumind.line": {
    source: "iana"
  },
  "application/vnd.nervana": {
    source: "iana"
  },
  "application/vnd.netfpx": {
    source: "iana"
  },
  "application/vnd.neurolanguage.nlu": {
    source: "iana",
    extensions: [
      "nlu"
    ]
  },
  "application/vnd.nimn": {
    source: "iana"
  },
  "application/vnd.nintendo.nitro.rom": {
    source: "iana"
  },
  "application/vnd.nintendo.snes.rom": {
    source: "iana"
  },
  "application/vnd.nitf": {
    source: "iana",
    extensions: [
      "ntf",
      "nitf"
    ]
  },
  "application/vnd.noblenet-directory": {
    source: "iana",
    extensions: [
      "nnd"
    ]
  },
  "application/vnd.noblenet-sealer": {
    source: "iana",
    extensions: [
      "nns"
    ]
  },
  "application/vnd.noblenet-web": {
    source: "iana",
    extensions: [
      "nnw"
    ]
  },
  "application/vnd.nokia.catalogs": {
    source: "iana"
  },
  "application/vnd.nokia.conml+wbxml": {
    source: "iana"
  },
  "application/vnd.nokia.conml+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.nokia.iptv.config+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.nokia.isds-radio-presets": {
    source: "iana"
  },
  "application/vnd.nokia.landmark+wbxml": {
    source: "iana"
  },
  "application/vnd.nokia.landmark+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.nokia.landmarkcollection+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.nokia.n-gage.ac+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "ac"
    ]
  },
  "application/vnd.nokia.n-gage.data": {
    source: "iana",
    extensions: [
      "ngdat"
    ]
  },
  "application/vnd.nokia.n-gage.symbian.install": {
    source: "iana",
    extensions: [
      "n-gage"
    ]
  },
  "application/vnd.nokia.ncd": {
    source: "iana"
  },
  "application/vnd.nokia.pcd+wbxml": {
    source: "iana"
  },
  "application/vnd.nokia.pcd+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.nokia.radio-preset": {
    source: "iana",
    extensions: [
      "rpst"
    ]
  },
  "application/vnd.nokia.radio-presets": {
    source: "iana",
    extensions: [
      "rpss"
    ]
  },
  "application/vnd.novadigm.edm": {
    source: "iana",
    extensions: [
      "edm"
    ]
  },
  "application/vnd.novadigm.edx": {
    source: "iana",
    extensions: [
      "edx"
    ]
  },
  "application/vnd.novadigm.ext": {
    source: "iana",
    extensions: [
      "ext"
    ]
  },
  "application/vnd.ntt-local.content-share": {
    source: "iana"
  },
  "application/vnd.ntt-local.file-transfer": {
    source: "iana"
  },
  "application/vnd.ntt-local.ogw_remote-access": {
    source: "iana"
  },
  "application/vnd.ntt-local.sip-ta_remote": {
    source: "iana"
  },
  "application/vnd.ntt-local.sip-ta_tcp_stream": {
    source: "iana"
  },
  "application/vnd.oasis.opendocument.chart": {
    source: "iana",
    extensions: [
      "odc"
    ]
  },
  "application/vnd.oasis.opendocument.chart-template": {
    source: "iana",
    extensions: [
      "otc"
    ]
  },
  "application/vnd.oasis.opendocument.database": {
    source: "iana",
    extensions: [
      "odb"
    ]
  },
  "application/vnd.oasis.opendocument.formula": {
    source: "iana",
    extensions: [
      "odf"
    ]
  },
  "application/vnd.oasis.opendocument.formula-template": {
    source: "iana",
    extensions: [
      "odft"
    ]
  },
  "application/vnd.oasis.opendocument.graphics": {
    source: "iana",
    compressible: !1,
    extensions: [
      "odg"
    ]
  },
  "application/vnd.oasis.opendocument.graphics-template": {
    source: "iana",
    extensions: [
      "otg"
    ]
  },
  "application/vnd.oasis.opendocument.image": {
    source: "iana",
    extensions: [
      "odi"
    ]
  },
  "application/vnd.oasis.opendocument.image-template": {
    source: "iana",
    extensions: [
      "oti"
    ]
  },
  "application/vnd.oasis.opendocument.presentation": {
    source: "iana",
    compressible: !1,
    extensions: [
      "odp"
    ]
  },
  "application/vnd.oasis.opendocument.presentation-template": {
    source: "iana",
    extensions: [
      "otp"
    ]
  },
  "application/vnd.oasis.opendocument.spreadsheet": {
    source: "iana",
    compressible: !1,
    extensions: [
      "ods"
    ]
  },
  "application/vnd.oasis.opendocument.spreadsheet-template": {
    source: "iana",
    extensions: [
      "ots"
    ]
  },
  "application/vnd.oasis.opendocument.text": {
    source: "iana",
    compressible: !1,
    extensions: [
      "odt"
    ]
  },
  "application/vnd.oasis.opendocument.text-master": {
    source: "iana",
    extensions: [
      "odm"
    ]
  },
  "application/vnd.oasis.opendocument.text-template": {
    source: "iana",
    extensions: [
      "ott"
    ]
  },
  "application/vnd.oasis.opendocument.text-web": {
    source: "iana",
    extensions: [
      "oth"
    ]
  },
  "application/vnd.obn": {
    source: "iana"
  },
  "application/vnd.ocf+cbor": {
    source: "iana"
  },
  "application/vnd.oci.image.manifest.v1+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oftn.l10n+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oipf.contentaccessdownload+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oipf.contentaccessstreaming+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oipf.cspg-hexbinary": {
    source: "iana"
  },
  "application/vnd.oipf.dae.svg+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oipf.dae.xhtml+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oipf.mippvcontrolmessage+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oipf.pae.gem": {
    source: "iana"
  },
  "application/vnd.oipf.spdiscovery+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oipf.spdlist+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oipf.ueprofile+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oipf.userprofile+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.olpc-sugar": {
    source: "iana",
    extensions: [
      "xo"
    ]
  },
  "application/vnd.oma-scws-config": {
    source: "iana"
  },
  "application/vnd.oma-scws-http-request": {
    source: "iana"
  },
  "application/vnd.oma-scws-http-response": {
    source: "iana"
  },
  "application/vnd.oma.bcast.associated-procedure-parameter+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.bcast.drm-trigger+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.bcast.imd+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.bcast.ltkm": {
    source: "iana"
  },
  "application/vnd.oma.bcast.notification+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.bcast.provisioningtrigger": {
    source: "iana"
  },
  "application/vnd.oma.bcast.sgboot": {
    source: "iana"
  },
  "application/vnd.oma.bcast.sgdd+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.bcast.sgdu": {
    source: "iana"
  },
  "application/vnd.oma.bcast.simple-symbol-container": {
    source: "iana"
  },
  "application/vnd.oma.bcast.smartcard-trigger+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.bcast.sprov+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.bcast.stkm": {
    source: "iana"
  },
  "application/vnd.oma.cab-address-book+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.cab-feature-handler+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.cab-pcc+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.cab-subs-invite+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.cab-user-prefs+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.dcd": {
    source: "iana"
  },
  "application/vnd.oma.dcdc": {
    source: "iana"
  },
  "application/vnd.oma.dd2+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "dd2"
    ]
  },
  "application/vnd.oma.drm.risd+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.group-usage-list+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.lwm2m+cbor": {
    source: "iana"
  },
  "application/vnd.oma.lwm2m+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.lwm2m+tlv": {
    source: "iana"
  },
  "application/vnd.oma.pal+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.poc.detailed-progress-report+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.poc.final-report+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.poc.groups+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.poc.invocation-descriptor+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.poc.optimized-progress-report+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.push": {
    source: "iana"
  },
  "application/vnd.oma.scidm.messages+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oma.xcap-directory+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.omads-email+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/vnd.omads-file+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/vnd.omads-folder+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/vnd.omaloc-supl-init": {
    source: "iana"
  },
  "application/vnd.onepager": {
    source: "iana"
  },
  "application/vnd.onepagertamp": {
    source: "iana"
  },
  "application/vnd.onepagertamx": {
    source: "iana"
  },
  "application/vnd.onepagertat": {
    source: "iana"
  },
  "application/vnd.onepagertatp": {
    source: "iana"
  },
  "application/vnd.onepagertatx": {
    source: "iana"
  },
  "application/vnd.openblox.game+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "obgx"
    ]
  },
  "application/vnd.openblox.game-binary": {
    source: "iana"
  },
  "application/vnd.openeye.oeb": {
    source: "iana"
  },
  "application/vnd.openofficeorg.extension": {
    source: "apache",
    extensions: [
      "oxt"
    ]
  },
  "application/vnd.openstreetmap.data+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "osm"
    ]
  },
  "application/vnd.opentimestamps.ots": {
    source: "iana"
  },
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.customxmlproperties+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.drawing+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.comments+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
    source: "iana",
    compressible: !1,
    extensions: [
      "pptx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.presprops+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slide": {
    source: "iana",
    extensions: [
      "sldx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slide+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": {
    source: "iana",
    extensions: [
      "ppsx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.tags+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.template": {
    source: "iana",
    extensions: [
      "potx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.presentationml.template.main+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
    source: "iana",
    compressible: !1,
    extensions: [
      "xlsx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": {
    source: "iana",
    extensions: [
      "xltx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.theme+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.themeoverride+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.vmldrawing": {
    source: "iana"
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
    source: "iana",
    compressible: !1,
    extensions: [
      "docx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": {
    source: "iana",
    extensions: [
      "dotx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-package.core-properties+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.openxmlformats-package.relationships+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oracle.resource+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.orange.indata": {
    source: "iana"
  },
  "application/vnd.osa.netdeploy": {
    source: "iana"
  },
  "application/vnd.osgeo.mapguide.package": {
    source: "iana",
    extensions: [
      "mgp"
    ]
  },
  "application/vnd.osgi.bundle": {
    source: "iana"
  },
  "application/vnd.osgi.dp": {
    source: "iana",
    extensions: [
      "dp"
    ]
  },
  "application/vnd.osgi.subsystem": {
    source: "iana",
    extensions: [
      "esa"
    ]
  },
  "application/vnd.otps.ct-kip+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.oxli.countgraph": {
    source: "iana"
  },
  "application/vnd.pagerduty+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.palm": {
    source: "iana",
    extensions: [
      "pdb",
      "pqa",
      "oprc"
    ]
  },
  "application/vnd.panoply": {
    source: "iana"
  },
  "application/vnd.paos.xml": {
    source: "iana"
  },
  "application/vnd.patentdive": {
    source: "iana"
  },
  "application/vnd.patientecommsdoc": {
    source: "iana"
  },
  "application/vnd.pawaafile": {
    source: "iana",
    extensions: [
      "paw"
    ]
  },
  "application/vnd.pcos": {
    source: "iana"
  },
  "application/vnd.pg.format": {
    source: "iana",
    extensions: [
      "str"
    ]
  },
  "application/vnd.pg.osasli": {
    source: "iana",
    extensions: [
      "ei6"
    ]
  },
  "application/vnd.piaccess.application-licence": {
    source: "iana"
  },
  "application/vnd.picsel": {
    source: "iana",
    extensions: [
      "efif"
    ]
  },
  "application/vnd.pmi.widget": {
    source: "iana",
    extensions: [
      "wg"
    ]
  },
  "application/vnd.poc.group-advertisement+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.pocketlearn": {
    source: "iana",
    extensions: [
      "plf"
    ]
  },
  "application/vnd.powerbuilder6": {
    source: "iana",
    extensions: [
      "pbd"
    ]
  },
  "application/vnd.powerbuilder6-s": {
    source: "iana"
  },
  "application/vnd.powerbuilder7": {
    source: "iana"
  },
  "application/vnd.powerbuilder7-s": {
    source: "iana"
  },
  "application/vnd.powerbuilder75": {
    source: "iana"
  },
  "application/vnd.powerbuilder75-s": {
    source: "iana"
  },
  "application/vnd.preminet": {
    source: "iana"
  },
  "application/vnd.previewsystems.box": {
    source: "iana",
    extensions: [
      "box"
    ]
  },
  "application/vnd.proteus.magazine": {
    source: "iana",
    extensions: [
      "mgz"
    ]
  },
  "application/vnd.psfs": {
    source: "iana"
  },
  "application/vnd.publishare-delta-tree": {
    source: "iana",
    extensions: [
      "qps"
    ]
  },
  "application/vnd.pvi.ptid1": {
    source: "iana",
    extensions: [
      "ptid"
    ]
  },
  "application/vnd.pwg-multiplexed": {
    source: "iana"
  },
  "application/vnd.pwg-xhtml-print+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.qualcomm.brew-app-res": {
    source: "iana"
  },
  "application/vnd.quarantainenet": {
    source: "iana"
  },
  "application/vnd.quark.quarkxpress": {
    source: "iana",
    extensions: [
      "qxd",
      "qxt",
      "qwd",
      "qwt",
      "qxl",
      "qxb"
    ]
  },
  "application/vnd.quobject-quoxdocument": {
    source: "iana"
  },
  "application/vnd.radisys.moml+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml-audit+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml-audit-conf+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml-audit-conn+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml-audit-dialog+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml-audit-stream+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml-conf+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml-dialog+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml-dialog-base+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml-dialog-fax-detect+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml-dialog-fax-sendrecv+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml-dialog-group+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml-dialog-speech+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.radisys.msml-dialog-transform+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.rainstor.data": {
    source: "iana"
  },
  "application/vnd.rapid": {
    source: "iana"
  },
  "application/vnd.rar": {
    source: "iana",
    extensions: [
      "rar"
    ]
  },
  "application/vnd.realvnc.bed": {
    source: "iana",
    extensions: [
      "bed"
    ]
  },
  "application/vnd.recordare.musicxml": {
    source: "iana",
    extensions: [
      "mxl"
    ]
  },
  "application/vnd.recordare.musicxml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "musicxml"
    ]
  },
  "application/vnd.renlearn.rlprint": {
    source: "iana"
  },
  "application/vnd.resilient.logic": {
    source: "iana"
  },
  "application/vnd.restful+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.rig.cryptonote": {
    source: "iana",
    extensions: [
      "cryptonote"
    ]
  },
  "application/vnd.rim.cod": {
    source: "apache",
    extensions: [
      "cod"
    ]
  },
  "application/vnd.rn-realmedia": {
    source: "apache",
    extensions: [
      "rm"
    ]
  },
  "application/vnd.rn-realmedia-vbr": {
    source: "apache",
    extensions: [
      "rmvb"
    ]
  },
  "application/vnd.route66.link66+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "link66"
    ]
  },
  "application/vnd.rs-274x": {
    source: "iana"
  },
  "application/vnd.ruckus.download": {
    source: "iana"
  },
  "application/vnd.s3sms": {
    source: "iana"
  },
  "application/vnd.sailingtracker.track": {
    source: "iana",
    extensions: [
      "st"
    ]
  },
  "application/vnd.sar": {
    source: "iana"
  },
  "application/vnd.sbm.cid": {
    source: "iana"
  },
  "application/vnd.sbm.mid2": {
    source: "iana"
  },
  "application/vnd.scribus": {
    source: "iana"
  },
  "application/vnd.sealed.3df": {
    source: "iana"
  },
  "application/vnd.sealed.csf": {
    source: "iana"
  },
  "application/vnd.sealed.doc": {
    source: "iana"
  },
  "application/vnd.sealed.eml": {
    source: "iana"
  },
  "application/vnd.sealed.mht": {
    source: "iana"
  },
  "application/vnd.sealed.net": {
    source: "iana"
  },
  "application/vnd.sealed.ppt": {
    source: "iana"
  },
  "application/vnd.sealed.tiff": {
    source: "iana"
  },
  "application/vnd.sealed.xls": {
    source: "iana"
  },
  "application/vnd.sealedmedia.softseal.html": {
    source: "iana"
  },
  "application/vnd.sealedmedia.softseal.pdf": {
    source: "iana"
  },
  "application/vnd.seemail": {
    source: "iana",
    extensions: [
      "see"
    ]
  },
  "application/vnd.seis+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.sema": {
    source: "iana",
    extensions: [
      "sema"
    ]
  },
  "application/vnd.semd": {
    source: "iana",
    extensions: [
      "semd"
    ]
  },
  "application/vnd.semf": {
    source: "iana",
    extensions: [
      "semf"
    ]
  },
  "application/vnd.shade-save-file": {
    source: "iana"
  },
  "application/vnd.shana.informed.formdata": {
    source: "iana",
    extensions: [
      "ifm"
    ]
  },
  "application/vnd.shana.informed.formtemplate": {
    source: "iana",
    extensions: [
      "itp"
    ]
  },
  "application/vnd.shana.informed.interchange": {
    source: "iana",
    extensions: [
      "iif"
    ]
  },
  "application/vnd.shana.informed.package": {
    source: "iana",
    extensions: [
      "ipk"
    ]
  },
  "application/vnd.shootproof+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.shopkick+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.shp": {
    source: "iana"
  },
  "application/vnd.shx": {
    source: "iana"
  },
  "application/vnd.sigrok.session": {
    source: "iana"
  },
  "application/vnd.simtech-mindmapper": {
    source: "iana",
    extensions: [
      "twd",
      "twds"
    ]
  },
  "application/vnd.siren+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.smaf": {
    source: "iana",
    extensions: [
      "mmf"
    ]
  },
  "application/vnd.smart.notebook": {
    source: "iana"
  },
  "application/vnd.smart.teacher": {
    source: "iana",
    extensions: [
      "teacher"
    ]
  },
  "application/vnd.snesdev-page-table": {
    source: "iana"
  },
  "application/vnd.software602.filler.form+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "fo"
    ]
  },
  "application/vnd.software602.filler.form-xml-zip": {
    source: "iana"
  },
  "application/vnd.solent.sdkm+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "sdkm",
      "sdkd"
    ]
  },
  "application/vnd.spotfire.dxp": {
    source: "iana",
    extensions: [
      "dxp"
    ]
  },
  "application/vnd.spotfire.sfs": {
    source: "iana",
    extensions: [
      "sfs"
    ]
  },
  "application/vnd.sqlite3": {
    source: "iana"
  },
  "application/vnd.sss-cod": {
    source: "iana"
  },
  "application/vnd.sss-dtf": {
    source: "iana"
  },
  "application/vnd.sss-ntf": {
    source: "iana"
  },
  "application/vnd.stardivision.calc": {
    source: "apache",
    extensions: [
      "sdc"
    ]
  },
  "application/vnd.stardivision.draw": {
    source: "apache",
    extensions: [
      "sda"
    ]
  },
  "application/vnd.stardivision.impress": {
    source: "apache",
    extensions: [
      "sdd"
    ]
  },
  "application/vnd.stardivision.math": {
    source: "apache",
    extensions: [
      "smf"
    ]
  },
  "application/vnd.stardivision.writer": {
    source: "apache",
    extensions: [
      "sdw",
      "vor"
    ]
  },
  "application/vnd.stardivision.writer-global": {
    source: "apache",
    extensions: [
      "sgl"
    ]
  },
  "application/vnd.stepmania.package": {
    source: "iana",
    extensions: [
      "smzip"
    ]
  },
  "application/vnd.stepmania.stepchart": {
    source: "iana",
    extensions: [
      "sm"
    ]
  },
  "application/vnd.street-stream": {
    source: "iana"
  },
  "application/vnd.sun.wadl+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "wadl"
    ]
  },
  "application/vnd.sun.xml.calc": {
    source: "apache",
    extensions: [
      "sxc"
    ]
  },
  "application/vnd.sun.xml.calc.template": {
    source: "apache",
    extensions: [
      "stc"
    ]
  },
  "application/vnd.sun.xml.draw": {
    source: "apache",
    extensions: [
      "sxd"
    ]
  },
  "application/vnd.sun.xml.draw.template": {
    source: "apache",
    extensions: [
      "std"
    ]
  },
  "application/vnd.sun.xml.impress": {
    source: "apache",
    extensions: [
      "sxi"
    ]
  },
  "application/vnd.sun.xml.impress.template": {
    source: "apache",
    extensions: [
      "sti"
    ]
  },
  "application/vnd.sun.xml.math": {
    source: "apache",
    extensions: [
      "sxm"
    ]
  },
  "application/vnd.sun.xml.writer": {
    source: "apache",
    extensions: [
      "sxw"
    ]
  },
  "application/vnd.sun.xml.writer.global": {
    source: "apache",
    extensions: [
      "sxg"
    ]
  },
  "application/vnd.sun.xml.writer.template": {
    source: "apache",
    extensions: [
      "stw"
    ]
  },
  "application/vnd.sus-calendar": {
    source: "iana",
    extensions: [
      "sus",
      "susp"
    ]
  },
  "application/vnd.svd": {
    source: "iana",
    extensions: [
      "svd"
    ]
  },
  "application/vnd.swiftview-ics": {
    source: "iana"
  },
  "application/vnd.sycle+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.syft+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.symbian.install": {
    source: "apache",
    extensions: [
      "sis",
      "sisx"
    ]
  },
  "application/vnd.syncml+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0,
    extensions: [
      "xsm"
    ]
  },
  "application/vnd.syncml.dm+wbxml": {
    source: "iana",
    charset: "UTF-8",
    extensions: [
      "bdm"
    ]
  },
  "application/vnd.syncml.dm+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0,
    extensions: [
      "xdm"
    ]
  },
  "application/vnd.syncml.dm.notification": {
    source: "iana"
  },
  "application/vnd.syncml.dmddf+wbxml": {
    source: "iana"
  },
  "application/vnd.syncml.dmddf+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0,
    extensions: [
      "ddf"
    ]
  },
  "application/vnd.syncml.dmtnds+wbxml": {
    source: "iana"
  },
  "application/vnd.syncml.dmtnds+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0
  },
  "application/vnd.syncml.ds.notification": {
    source: "iana"
  },
  "application/vnd.tableschema+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.tao.intent-module-archive": {
    source: "iana",
    extensions: [
      "tao"
    ]
  },
  "application/vnd.tcpdump.pcap": {
    source: "iana",
    extensions: [
      "pcap",
      "cap",
      "dmp"
    ]
  },
  "application/vnd.think-cell.ppttc+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.tmd.mediaflex.api+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.tml": {
    source: "iana"
  },
  "application/vnd.tmobile-livetv": {
    source: "iana",
    extensions: [
      "tmo"
    ]
  },
  "application/vnd.tri.onesource": {
    source: "iana"
  },
  "application/vnd.trid.tpt": {
    source: "iana",
    extensions: [
      "tpt"
    ]
  },
  "application/vnd.triscape.mxs": {
    source: "iana",
    extensions: [
      "mxs"
    ]
  },
  "application/vnd.trueapp": {
    source: "iana",
    extensions: [
      "tra"
    ]
  },
  "application/vnd.truedoc": {
    source: "iana"
  },
  "application/vnd.ubisoft.webplayer": {
    source: "iana"
  },
  "application/vnd.ufdl": {
    source: "iana",
    extensions: [
      "ufd",
      "ufdl"
    ]
  },
  "application/vnd.uiq.theme": {
    source: "iana",
    extensions: [
      "utz"
    ]
  },
  "application/vnd.umajin": {
    source: "iana",
    extensions: [
      "umj"
    ]
  },
  "application/vnd.unity": {
    source: "iana",
    extensions: [
      "unityweb"
    ]
  },
  "application/vnd.uoml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "uoml"
    ]
  },
  "application/vnd.uplanet.alert": {
    source: "iana"
  },
  "application/vnd.uplanet.alert-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.bearer-choice": {
    source: "iana"
  },
  "application/vnd.uplanet.bearer-choice-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.cacheop": {
    source: "iana"
  },
  "application/vnd.uplanet.cacheop-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.channel": {
    source: "iana"
  },
  "application/vnd.uplanet.channel-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.list": {
    source: "iana"
  },
  "application/vnd.uplanet.list-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.listcmd": {
    source: "iana"
  },
  "application/vnd.uplanet.listcmd-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.signal": {
    source: "iana"
  },
  "application/vnd.uri-map": {
    source: "iana"
  },
  "application/vnd.valve.source.material": {
    source: "iana"
  },
  "application/vnd.vcx": {
    source: "iana",
    extensions: [
      "vcx"
    ]
  },
  "application/vnd.vd-study": {
    source: "iana"
  },
  "application/vnd.vectorworks": {
    source: "iana"
  },
  "application/vnd.vel+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.verimatrix.vcas": {
    source: "iana"
  },
  "application/vnd.veritone.aion+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.veryant.thin": {
    source: "iana"
  },
  "application/vnd.ves.encrypted": {
    source: "iana"
  },
  "application/vnd.vidsoft.vidconference": {
    source: "iana"
  },
  "application/vnd.visio": {
    source: "iana",
    extensions: [
      "vsd",
      "vst",
      "vss",
      "vsw"
    ]
  },
  "application/vnd.visionary": {
    source: "iana",
    extensions: [
      "vis"
    ]
  },
  "application/vnd.vividence.scriptfile": {
    source: "iana"
  },
  "application/vnd.vsf": {
    source: "iana",
    extensions: [
      "vsf"
    ]
  },
  "application/vnd.wap.sic": {
    source: "iana"
  },
  "application/vnd.wap.slc": {
    source: "iana"
  },
  "application/vnd.wap.wbxml": {
    source: "iana",
    charset: "UTF-8",
    extensions: [
      "wbxml"
    ]
  },
  "application/vnd.wap.wmlc": {
    source: "iana",
    extensions: [
      "wmlc"
    ]
  },
  "application/vnd.wap.wmlscriptc": {
    source: "iana",
    extensions: [
      "wmlsc"
    ]
  },
  "application/vnd.webturbo": {
    source: "iana",
    extensions: [
      "wtb"
    ]
  },
  "application/vnd.wfa.dpp": {
    source: "iana"
  },
  "application/vnd.wfa.p2p": {
    source: "iana"
  },
  "application/vnd.wfa.wsc": {
    source: "iana"
  },
  "application/vnd.windows.devicepairing": {
    source: "iana"
  },
  "application/vnd.wmc": {
    source: "iana"
  },
  "application/vnd.wmf.bootstrap": {
    source: "iana"
  },
  "application/vnd.wolfram.mathematica": {
    source: "iana"
  },
  "application/vnd.wolfram.mathematica.package": {
    source: "iana"
  },
  "application/vnd.wolfram.player": {
    source: "iana",
    extensions: [
      "nbp"
    ]
  },
  "application/vnd.wordperfect": {
    source: "iana",
    extensions: [
      "wpd"
    ]
  },
  "application/vnd.wqd": {
    source: "iana",
    extensions: [
      "wqd"
    ]
  },
  "application/vnd.wrq-hp3000-labelled": {
    source: "iana"
  },
  "application/vnd.wt.stf": {
    source: "iana",
    extensions: [
      "stf"
    ]
  },
  "application/vnd.wv.csp+wbxml": {
    source: "iana"
  },
  "application/vnd.wv.csp+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.wv.ssp+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.xacml+json": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.xara": {
    source: "iana",
    extensions: [
      "xar"
    ]
  },
  "application/vnd.xfdl": {
    source: "iana",
    extensions: [
      "xfdl"
    ]
  },
  "application/vnd.xfdl.webform": {
    source: "iana"
  },
  "application/vnd.xmi+xml": {
    source: "iana",
    compressible: !0
  },
  "application/vnd.xmpie.cpkg": {
    source: "iana"
  },
  "application/vnd.xmpie.dpkg": {
    source: "iana"
  },
  "application/vnd.xmpie.plan": {
    source: "iana"
  },
  "application/vnd.xmpie.ppkg": {
    source: "iana"
  },
  "application/vnd.xmpie.xlim": {
    source: "iana"
  },
  "application/vnd.yamaha.hv-dic": {
    source: "iana",
    extensions: [
      "hvd"
    ]
  },
  "application/vnd.yamaha.hv-script": {
    source: "iana",
    extensions: [
      "hvs"
    ]
  },
  "application/vnd.yamaha.hv-voice": {
    source: "iana",
    extensions: [
      "hvp"
    ]
  },
  "application/vnd.yamaha.openscoreformat": {
    source: "iana",
    extensions: [
      "osf"
    ]
  },
  "application/vnd.yamaha.openscoreformat.osfpvg+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "osfpvg"
    ]
  },
  "application/vnd.yamaha.remote-setup": {
    source: "iana"
  },
  "application/vnd.yamaha.smaf-audio": {
    source: "iana",
    extensions: [
      "saf"
    ]
  },
  "application/vnd.yamaha.smaf-phrase": {
    source: "iana",
    extensions: [
      "spf"
    ]
  },
  "application/vnd.yamaha.through-ngn": {
    source: "iana"
  },
  "application/vnd.yamaha.tunnel-udpencap": {
    source: "iana"
  },
  "application/vnd.yaoweme": {
    source: "iana"
  },
  "application/vnd.yellowriver-custom-menu": {
    source: "iana",
    extensions: [
      "cmp"
    ]
  },
  "application/vnd.youtube.yt": {
    source: "iana"
  },
  "application/vnd.zul": {
    source: "iana",
    extensions: [
      "zir",
      "zirz"
    ]
  },
  "application/vnd.zzazz.deck+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "zaz"
    ]
  },
  "application/voicexml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "vxml"
    ]
  },
  "application/voucher-cms+json": {
    source: "iana",
    compressible: !0
  },
  "application/vq-rtcpxr": {
    source: "iana"
  },
  "application/wasm": {
    source: "iana",
    compressible: !0,
    extensions: [
      "wasm"
    ]
  },
  "application/watcherinfo+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "wif"
    ]
  },
  "application/webpush-options+json": {
    source: "iana",
    compressible: !0
  },
  "application/whoispp-query": {
    source: "iana"
  },
  "application/whoispp-response": {
    source: "iana"
  },
  "application/widget": {
    source: "iana",
    extensions: [
      "wgt"
    ]
  },
  "application/winhlp": {
    source: "apache",
    extensions: [
      "hlp"
    ]
  },
  "application/wita": {
    source: "iana"
  },
  "application/wordperfect5.1": {
    source: "iana"
  },
  "application/wsdl+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "wsdl"
    ]
  },
  "application/wspolicy+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "wspolicy"
    ]
  },
  "application/x-7z-compressed": {
    source: "apache",
    compressible: !1,
    extensions: [
      "7z"
    ]
  },
  "application/x-abiword": {
    source: "apache",
    extensions: [
      "abw"
    ]
  },
  "application/x-ace-compressed": {
    source: "apache",
    extensions: [
      "ace"
    ]
  },
  "application/x-amf": {
    source: "apache"
  },
  "application/x-apple-diskimage": {
    source: "apache",
    extensions: [
      "dmg"
    ]
  },
  "application/x-arj": {
    compressible: !1,
    extensions: [
      "arj"
    ]
  },
  "application/x-authorware-bin": {
    source: "apache",
    extensions: [
      "aab",
      "x32",
      "u32",
      "vox"
    ]
  },
  "application/x-authorware-map": {
    source: "apache",
    extensions: [
      "aam"
    ]
  },
  "application/x-authorware-seg": {
    source: "apache",
    extensions: [
      "aas"
    ]
  },
  "application/x-bcpio": {
    source: "apache",
    extensions: [
      "bcpio"
    ]
  },
  "application/x-bdoc": {
    compressible: !1,
    extensions: [
      "bdoc"
    ]
  },
  "application/x-bittorrent": {
    source: "apache",
    extensions: [
      "torrent"
    ]
  },
  "application/x-blorb": {
    source: "apache",
    extensions: [
      "blb",
      "blorb"
    ]
  },
  "application/x-bzip": {
    source: "apache",
    compressible: !1,
    extensions: [
      "bz"
    ]
  },
  "application/x-bzip2": {
    source: "apache",
    compressible: !1,
    extensions: [
      "bz2",
      "boz"
    ]
  },
  "application/x-cbr": {
    source: "apache",
    extensions: [
      "cbr",
      "cba",
      "cbt",
      "cbz",
      "cb7"
    ]
  },
  "application/x-cdlink": {
    source: "apache",
    extensions: [
      "vcd"
    ]
  },
  "application/x-cfs-compressed": {
    source: "apache",
    extensions: [
      "cfs"
    ]
  },
  "application/x-chat": {
    source: "apache",
    extensions: [
      "chat"
    ]
  },
  "application/x-chess-pgn": {
    source: "apache",
    extensions: [
      "pgn"
    ]
  },
  "application/x-chrome-extension": {
    extensions: [
      "crx"
    ]
  },
  "application/x-cocoa": {
    source: "nginx",
    extensions: [
      "cco"
    ]
  },
  "application/x-compress": {
    source: "apache"
  },
  "application/x-conference": {
    source: "apache",
    extensions: [
      "nsc"
    ]
  },
  "application/x-cpio": {
    source: "apache",
    extensions: [
      "cpio"
    ]
  },
  "application/x-csh": {
    source: "apache",
    extensions: [
      "csh"
    ]
  },
  "application/x-deb": {
    compressible: !1
  },
  "application/x-debian-package": {
    source: "apache",
    extensions: [
      "deb",
      "udeb"
    ]
  },
  "application/x-dgc-compressed": {
    source: "apache",
    extensions: [
      "dgc"
    ]
  },
  "application/x-director": {
    source: "apache",
    extensions: [
      "dir",
      "dcr",
      "dxr",
      "cst",
      "cct",
      "cxt",
      "w3d",
      "fgd",
      "swa"
    ]
  },
  "application/x-doom": {
    source: "apache",
    extensions: [
      "wad"
    ]
  },
  "application/x-dtbncx+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "ncx"
    ]
  },
  "application/x-dtbook+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "dtb"
    ]
  },
  "application/x-dtbresource+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "res"
    ]
  },
  "application/x-dvi": {
    source: "apache",
    compressible: !1,
    extensions: [
      "dvi"
    ]
  },
  "application/x-envoy": {
    source: "apache",
    extensions: [
      "evy"
    ]
  },
  "application/x-eva": {
    source: "apache",
    extensions: [
      "eva"
    ]
  },
  "application/x-font-bdf": {
    source: "apache",
    extensions: [
      "bdf"
    ]
  },
  "application/x-font-dos": {
    source: "apache"
  },
  "application/x-font-framemaker": {
    source: "apache"
  },
  "application/x-font-ghostscript": {
    source: "apache",
    extensions: [
      "gsf"
    ]
  },
  "application/x-font-libgrx": {
    source: "apache"
  },
  "application/x-font-linux-psf": {
    source: "apache",
    extensions: [
      "psf"
    ]
  },
  "application/x-font-pcf": {
    source: "apache",
    extensions: [
      "pcf"
    ]
  },
  "application/x-font-snf": {
    source: "apache",
    extensions: [
      "snf"
    ]
  },
  "application/x-font-speedo": {
    source: "apache"
  },
  "application/x-font-sunos-news": {
    source: "apache"
  },
  "application/x-font-type1": {
    source: "apache",
    extensions: [
      "pfa",
      "pfb",
      "pfm",
      "afm"
    ]
  },
  "application/x-font-vfont": {
    source: "apache"
  },
  "application/x-freearc": {
    source: "apache",
    extensions: [
      "arc"
    ]
  },
  "application/x-futuresplash": {
    source: "apache",
    extensions: [
      "spl"
    ]
  },
  "application/x-gca-compressed": {
    source: "apache",
    extensions: [
      "gca"
    ]
  },
  "application/x-glulx": {
    source: "apache",
    extensions: [
      "ulx"
    ]
  },
  "application/x-gnumeric": {
    source: "apache",
    extensions: [
      "gnumeric"
    ]
  },
  "application/x-gramps-xml": {
    source: "apache",
    extensions: [
      "gramps"
    ]
  },
  "application/x-gtar": {
    source: "apache",
    extensions: [
      "gtar"
    ]
  },
  "application/x-gzip": {
    source: "apache"
  },
  "application/x-hdf": {
    source: "apache",
    extensions: [
      "hdf"
    ]
  },
  "application/x-httpd-php": {
    compressible: !0,
    extensions: [
      "php"
    ]
  },
  "application/x-install-instructions": {
    source: "apache",
    extensions: [
      "install"
    ]
  },
  "application/x-iso9660-image": {
    source: "apache",
    extensions: [
      "iso"
    ]
  },
  "application/x-iwork-keynote-sffkey": {
    extensions: [
      "key"
    ]
  },
  "application/x-iwork-numbers-sffnumbers": {
    extensions: [
      "numbers"
    ]
  },
  "application/x-iwork-pages-sffpages": {
    extensions: [
      "pages"
    ]
  },
  "application/x-java-archive-diff": {
    source: "nginx",
    extensions: [
      "jardiff"
    ]
  },
  "application/x-java-jnlp-file": {
    source: "apache",
    compressible: !1,
    extensions: [
      "jnlp"
    ]
  },
  "application/x-javascript": {
    compressible: !0
  },
  "application/x-keepass2": {
    extensions: [
      "kdbx"
    ]
  },
  "application/x-latex": {
    source: "apache",
    compressible: !1,
    extensions: [
      "latex"
    ]
  },
  "application/x-lua-bytecode": {
    extensions: [
      "luac"
    ]
  },
  "application/x-lzh-compressed": {
    source: "apache",
    extensions: [
      "lzh",
      "lha"
    ]
  },
  "application/x-makeself": {
    source: "nginx",
    extensions: [
      "run"
    ]
  },
  "application/x-mie": {
    source: "apache",
    extensions: [
      "mie"
    ]
  },
  "application/x-mobipocket-ebook": {
    source: "apache",
    extensions: [
      "prc",
      "mobi"
    ]
  },
  "application/x-mpegurl": {
    compressible: !1
  },
  "application/x-ms-application": {
    source: "apache",
    extensions: [
      "application"
    ]
  },
  "application/x-ms-shortcut": {
    source: "apache",
    extensions: [
      "lnk"
    ]
  },
  "application/x-ms-wmd": {
    source: "apache",
    extensions: [
      "wmd"
    ]
  },
  "application/x-ms-wmz": {
    source: "apache",
    extensions: [
      "wmz"
    ]
  },
  "application/x-ms-xbap": {
    source: "apache",
    extensions: [
      "xbap"
    ]
  },
  "application/x-msaccess": {
    source: "apache",
    extensions: [
      "mdb"
    ]
  },
  "application/x-msbinder": {
    source: "apache",
    extensions: [
      "obd"
    ]
  },
  "application/x-mscardfile": {
    source: "apache",
    extensions: [
      "crd"
    ]
  },
  "application/x-msclip": {
    source: "apache",
    extensions: [
      "clp"
    ]
  },
  "application/x-msdos-program": {
    extensions: [
      "exe"
    ]
  },
  "application/x-msdownload": {
    source: "apache",
    extensions: [
      "exe",
      "dll",
      "com",
      "bat",
      "msi"
    ]
  },
  "application/x-msmediaview": {
    source: "apache",
    extensions: [
      "mvb",
      "m13",
      "m14"
    ]
  },
  "application/x-msmetafile": {
    source: "apache",
    extensions: [
      "wmf",
      "wmz",
      "emf",
      "emz"
    ]
  },
  "application/x-msmoney": {
    source: "apache",
    extensions: [
      "mny"
    ]
  },
  "application/x-mspublisher": {
    source: "apache",
    extensions: [
      "pub"
    ]
  },
  "application/x-msschedule": {
    source: "apache",
    extensions: [
      "scd"
    ]
  },
  "application/x-msterminal": {
    source: "apache",
    extensions: [
      "trm"
    ]
  },
  "application/x-mswrite": {
    source: "apache",
    extensions: [
      "wri"
    ]
  },
  "application/x-netcdf": {
    source: "apache",
    extensions: [
      "nc",
      "cdf"
    ]
  },
  "application/x-ns-proxy-autoconfig": {
    compressible: !0,
    extensions: [
      "pac"
    ]
  },
  "application/x-nzb": {
    source: "apache",
    extensions: [
      "nzb"
    ]
  },
  "application/x-perl": {
    source: "nginx",
    extensions: [
      "pl",
      "pm"
    ]
  },
  "application/x-pilot": {
    source: "nginx",
    extensions: [
      "prc",
      "pdb"
    ]
  },
  "application/x-pkcs12": {
    source: "apache",
    compressible: !1,
    extensions: [
      "p12",
      "pfx"
    ]
  },
  "application/x-pkcs7-certificates": {
    source: "apache",
    extensions: [
      "p7b",
      "spc"
    ]
  },
  "application/x-pkcs7-certreqresp": {
    source: "apache",
    extensions: [
      "p7r"
    ]
  },
  "application/x-pki-message": {
    source: "iana"
  },
  "application/x-rar-compressed": {
    source: "apache",
    compressible: !1,
    extensions: [
      "rar"
    ]
  },
  "application/x-redhat-package-manager": {
    source: "nginx",
    extensions: [
      "rpm"
    ]
  },
  "application/x-research-info-systems": {
    source: "apache",
    extensions: [
      "ris"
    ]
  },
  "application/x-sea": {
    source: "nginx",
    extensions: [
      "sea"
    ]
  },
  "application/x-sh": {
    source: "apache",
    compressible: !0,
    extensions: [
      "sh"
    ]
  },
  "application/x-shar": {
    source: "apache",
    extensions: [
      "shar"
    ]
  },
  "application/x-shockwave-flash": {
    source: "apache",
    compressible: !1,
    extensions: [
      "swf"
    ]
  },
  "application/x-silverlight-app": {
    source: "apache",
    extensions: [
      "xap"
    ]
  },
  "application/x-sql": {
    source: "apache",
    extensions: [
      "sql"
    ]
  },
  "application/x-stuffit": {
    source: "apache",
    compressible: !1,
    extensions: [
      "sit"
    ]
  },
  "application/x-stuffitx": {
    source: "apache",
    extensions: [
      "sitx"
    ]
  },
  "application/x-subrip": {
    source: "apache",
    extensions: [
      "srt"
    ]
  },
  "application/x-sv4cpio": {
    source: "apache",
    extensions: [
      "sv4cpio"
    ]
  },
  "application/x-sv4crc": {
    source: "apache",
    extensions: [
      "sv4crc"
    ]
  },
  "application/x-t3vm-image": {
    source: "apache",
    extensions: [
      "t3"
    ]
  },
  "application/x-tads": {
    source: "apache",
    extensions: [
      "gam"
    ]
  },
  "application/x-tar": {
    source: "apache",
    compressible: !0,
    extensions: [
      "tar"
    ]
  },
  "application/x-tcl": {
    source: "apache",
    extensions: [
      "tcl",
      "tk"
    ]
  },
  "application/x-tex": {
    source: "apache",
    extensions: [
      "tex"
    ]
  },
  "application/x-tex-tfm": {
    source: "apache",
    extensions: [
      "tfm"
    ]
  },
  "application/x-texinfo": {
    source: "apache",
    extensions: [
      "texinfo",
      "texi"
    ]
  },
  "application/x-tgif": {
    source: "apache",
    extensions: [
      "obj"
    ]
  },
  "application/x-ustar": {
    source: "apache",
    extensions: [
      "ustar"
    ]
  },
  "application/x-virtualbox-hdd": {
    compressible: !0,
    extensions: [
      "hdd"
    ]
  },
  "application/x-virtualbox-ova": {
    compressible: !0,
    extensions: [
      "ova"
    ]
  },
  "application/x-virtualbox-ovf": {
    compressible: !0,
    extensions: [
      "ovf"
    ]
  },
  "application/x-virtualbox-vbox": {
    compressible: !0,
    extensions: [
      "vbox"
    ]
  },
  "application/x-virtualbox-vbox-extpack": {
    compressible: !1,
    extensions: [
      "vbox-extpack"
    ]
  },
  "application/x-virtualbox-vdi": {
    compressible: !0,
    extensions: [
      "vdi"
    ]
  },
  "application/x-virtualbox-vhd": {
    compressible: !0,
    extensions: [
      "vhd"
    ]
  },
  "application/x-virtualbox-vmdk": {
    compressible: !0,
    extensions: [
      "vmdk"
    ]
  },
  "application/x-wais-source": {
    source: "apache",
    extensions: [
      "src"
    ]
  },
  "application/x-web-app-manifest+json": {
    compressible: !0,
    extensions: [
      "webapp"
    ]
  },
  "application/x-www-form-urlencoded": {
    source: "iana",
    compressible: !0
  },
  "application/x-x509-ca-cert": {
    source: "iana",
    extensions: [
      "der",
      "crt",
      "pem"
    ]
  },
  "application/x-x509-ca-ra-cert": {
    source: "iana"
  },
  "application/x-x509-next-ca-cert": {
    source: "iana"
  },
  "application/x-xfig": {
    source: "apache",
    extensions: [
      "fig"
    ]
  },
  "application/x-xliff+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "xlf"
    ]
  },
  "application/x-xpinstall": {
    source: "apache",
    compressible: !1,
    extensions: [
      "xpi"
    ]
  },
  "application/x-xz": {
    source: "apache",
    extensions: [
      "xz"
    ]
  },
  "application/x-zmachine": {
    source: "apache",
    extensions: [
      "z1",
      "z2",
      "z3",
      "z4",
      "z5",
      "z6",
      "z7",
      "z8"
    ]
  },
  "application/x400-bp": {
    source: "iana"
  },
  "application/xacml+xml": {
    source: "iana",
    compressible: !0
  },
  "application/xaml+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "xaml"
    ]
  },
  "application/xcap-att+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xav"
    ]
  },
  "application/xcap-caps+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xca"
    ]
  },
  "application/xcap-diff+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xdf"
    ]
  },
  "application/xcap-el+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xel"
    ]
  },
  "application/xcap-error+xml": {
    source: "iana",
    compressible: !0
  },
  "application/xcap-ns+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xns"
    ]
  },
  "application/xcon-conference-info+xml": {
    source: "iana",
    compressible: !0
  },
  "application/xcon-conference-info-diff+xml": {
    source: "iana",
    compressible: !0
  },
  "application/xenc+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xenc"
    ]
  },
  "application/xhtml+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xhtml",
      "xht"
    ]
  },
  "application/xhtml-voice+xml": {
    source: "apache",
    compressible: !0
  },
  "application/xliff+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xlf"
    ]
  },
  "application/xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xml",
      "xsl",
      "xsd",
      "rng"
    ]
  },
  "application/xml-dtd": {
    source: "iana",
    compressible: !0,
    extensions: [
      "dtd"
    ]
  },
  "application/xml-external-parsed-entity": {
    source: "iana"
  },
  "application/xml-patch+xml": {
    source: "iana",
    compressible: !0
  },
  "application/xmpp+xml": {
    source: "iana",
    compressible: !0
  },
  "application/xop+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xop"
    ]
  },
  "application/xproc+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "xpl"
    ]
  },
  "application/xslt+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xsl",
      "xslt"
    ]
  },
  "application/xspf+xml": {
    source: "apache",
    compressible: !0,
    extensions: [
      "xspf"
    ]
  },
  "application/xv+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "mxml",
      "xhvml",
      "xvml",
      "xvm"
    ]
  },
  "application/yang": {
    source: "iana",
    extensions: [
      "yang"
    ]
  },
  "application/yang-data+json": {
    source: "iana",
    compressible: !0
  },
  "application/yang-data+xml": {
    source: "iana",
    compressible: !0
  },
  "application/yang-patch+json": {
    source: "iana",
    compressible: !0
  },
  "application/yang-patch+xml": {
    source: "iana",
    compressible: !0
  },
  "application/yin+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "yin"
    ]
  },
  "application/zip": {
    source: "iana",
    compressible: !1,
    extensions: [
      "zip"
    ]
  },
  "application/zlib": {
    source: "iana"
  },
  "application/zstd": {
    source: "iana"
  },
  "audio/1d-interleaved-parityfec": {
    source: "iana"
  },
  "audio/32kadpcm": {
    source: "iana"
  },
  "audio/3gpp": {
    source: "iana",
    compressible: !1,
    extensions: [
      "3gpp"
    ]
  },
  "audio/3gpp2": {
    source: "iana"
  },
  "audio/aac": {
    source: "iana"
  },
  "audio/ac3": {
    source: "iana"
  },
  "audio/adpcm": {
    source: "apache",
    extensions: [
      "adp"
    ]
  },
  "audio/amr": {
    source: "iana",
    extensions: [
      "amr"
    ]
  },
  "audio/amr-wb": {
    source: "iana"
  },
  "audio/amr-wb+": {
    source: "iana"
  },
  "audio/aptx": {
    source: "iana"
  },
  "audio/asc": {
    source: "iana"
  },
  "audio/atrac-advanced-lossless": {
    source: "iana"
  },
  "audio/atrac-x": {
    source: "iana"
  },
  "audio/atrac3": {
    source: "iana"
  },
  "audio/basic": {
    source: "iana",
    compressible: !1,
    extensions: [
      "au",
      "snd"
    ]
  },
  "audio/bv16": {
    source: "iana"
  },
  "audio/bv32": {
    source: "iana"
  },
  "audio/clearmode": {
    source: "iana"
  },
  "audio/cn": {
    source: "iana"
  },
  "audio/dat12": {
    source: "iana"
  },
  "audio/dls": {
    source: "iana"
  },
  "audio/dsr-es201108": {
    source: "iana"
  },
  "audio/dsr-es202050": {
    source: "iana"
  },
  "audio/dsr-es202211": {
    source: "iana"
  },
  "audio/dsr-es202212": {
    source: "iana"
  },
  "audio/dv": {
    source: "iana"
  },
  "audio/dvi4": {
    source: "iana"
  },
  "audio/eac3": {
    source: "iana"
  },
  "audio/encaprtp": {
    source: "iana"
  },
  "audio/evrc": {
    source: "iana"
  },
  "audio/evrc-qcp": {
    source: "iana"
  },
  "audio/evrc0": {
    source: "iana"
  },
  "audio/evrc1": {
    source: "iana"
  },
  "audio/evrcb": {
    source: "iana"
  },
  "audio/evrcb0": {
    source: "iana"
  },
  "audio/evrcb1": {
    source: "iana"
  },
  "audio/evrcnw": {
    source: "iana"
  },
  "audio/evrcnw0": {
    source: "iana"
  },
  "audio/evrcnw1": {
    source: "iana"
  },
  "audio/evrcwb": {
    source: "iana"
  },
  "audio/evrcwb0": {
    source: "iana"
  },
  "audio/evrcwb1": {
    source: "iana"
  },
  "audio/evs": {
    source: "iana"
  },
  "audio/flexfec": {
    source: "iana"
  },
  "audio/fwdred": {
    source: "iana"
  },
  "audio/g711-0": {
    source: "iana"
  },
  "audio/g719": {
    source: "iana"
  },
  "audio/g722": {
    source: "iana"
  },
  "audio/g7221": {
    source: "iana"
  },
  "audio/g723": {
    source: "iana"
  },
  "audio/g726-16": {
    source: "iana"
  },
  "audio/g726-24": {
    source: "iana"
  },
  "audio/g726-32": {
    source: "iana"
  },
  "audio/g726-40": {
    source: "iana"
  },
  "audio/g728": {
    source: "iana"
  },
  "audio/g729": {
    source: "iana"
  },
  "audio/g7291": {
    source: "iana"
  },
  "audio/g729d": {
    source: "iana"
  },
  "audio/g729e": {
    source: "iana"
  },
  "audio/gsm": {
    source: "iana"
  },
  "audio/gsm-efr": {
    source: "iana"
  },
  "audio/gsm-hr-08": {
    source: "iana"
  },
  "audio/ilbc": {
    source: "iana"
  },
  "audio/ip-mr_v2.5": {
    source: "iana"
  },
  "audio/isac": {
    source: "apache"
  },
  "audio/l16": {
    source: "iana"
  },
  "audio/l20": {
    source: "iana"
  },
  "audio/l24": {
    source: "iana",
    compressible: !1
  },
  "audio/l8": {
    source: "iana"
  },
  "audio/lpc": {
    source: "iana"
  },
  "audio/melp": {
    source: "iana"
  },
  "audio/melp1200": {
    source: "iana"
  },
  "audio/melp2400": {
    source: "iana"
  },
  "audio/melp600": {
    source: "iana"
  },
  "audio/mhas": {
    source: "iana"
  },
  "audio/midi": {
    source: "apache",
    extensions: [
      "mid",
      "midi",
      "kar",
      "rmi"
    ]
  },
  "audio/mobile-xmf": {
    source: "iana",
    extensions: [
      "mxmf"
    ]
  },
  "audio/mp3": {
    compressible: !1,
    extensions: [
      "mp3"
    ]
  },
  "audio/mp4": {
    source: "iana",
    compressible: !1,
    extensions: [
      "m4a",
      "mp4a"
    ]
  },
  "audio/mp4a-latm": {
    source: "iana"
  },
  "audio/mpa": {
    source: "iana"
  },
  "audio/mpa-robust": {
    source: "iana"
  },
  "audio/mpeg": {
    source: "iana",
    compressible: !1,
    extensions: [
      "mpga",
      "mp2",
      "mp2a",
      "mp3",
      "m2a",
      "m3a"
    ]
  },
  "audio/mpeg4-generic": {
    source: "iana"
  },
  "audio/musepack": {
    source: "apache"
  },
  "audio/ogg": {
    source: "iana",
    compressible: !1,
    extensions: [
      "oga",
      "ogg",
      "spx",
      "opus"
    ]
  },
  "audio/opus": {
    source: "iana"
  },
  "audio/parityfec": {
    source: "iana"
  },
  "audio/pcma": {
    source: "iana"
  },
  "audio/pcma-wb": {
    source: "iana"
  },
  "audio/pcmu": {
    source: "iana"
  },
  "audio/pcmu-wb": {
    source: "iana"
  },
  "audio/prs.sid": {
    source: "iana"
  },
  "audio/qcelp": {
    source: "iana"
  },
  "audio/raptorfec": {
    source: "iana"
  },
  "audio/red": {
    source: "iana"
  },
  "audio/rtp-enc-aescm128": {
    source: "iana"
  },
  "audio/rtp-midi": {
    source: "iana"
  },
  "audio/rtploopback": {
    source: "iana"
  },
  "audio/rtx": {
    source: "iana"
  },
  "audio/s3m": {
    source: "apache",
    extensions: [
      "s3m"
    ]
  },
  "audio/scip": {
    source: "iana"
  },
  "audio/silk": {
    source: "apache",
    extensions: [
      "sil"
    ]
  },
  "audio/smv": {
    source: "iana"
  },
  "audio/smv-qcp": {
    source: "iana"
  },
  "audio/smv0": {
    source: "iana"
  },
  "audio/sofa": {
    source: "iana"
  },
  "audio/sp-midi": {
    source: "iana"
  },
  "audio/speex": {
    source: "iana"
  },
  "audio/t140c": {
    source: "iana"
  },
  "audio/t38": {
    source: "iana"
  },
  "audio/telephone-event": {
    source: "iana"
  },
  "audio/tetra_acelp": {
    source: "iana"
  },
  "audio/tetra_acelp_bb": {
    source: "iana"
  },
  "audio/tone": {
    source: "iana"
  },
  "audio/tsvcis": {
    source: "iana"
  },
  "audio/uemclip": {
    source: "iana"
  },
  "audio/ulpfec": {
    source: "iana"
  },
  "audio/usac": {
    source: "iana"
  },
  "audio/vdvi": {
    source: "iana"
  },
  "audio/vmr-wb": {
    source: "iana"
  },
  "audio/vnd.3gpp.iufp": {
    source: "iana"
  },
  "audio/vnd.4sb": {
    source: "iana"
  },
  "audio/vnd.audiokoz": {
    source: "iana"
  },
  "audio/vnd.celp": {
    source: "iana"
  },
  "audio/vnd.cisco.nse": {
    source: "iana"
  },
  "audio/vnd.cmles.radio-events": {
    source: "iana"
  },
  "audio/vnd.cns.anp1": {
    source: "iana"
  },
  "audio/vnd.cns.inf1": {
    source: "iana"
  },
  "audio/vnd.dece.audio": {
    source: "iana",
    extensions: [
      "uva",
      "uvva"
    ]
  },
  "audio/vnd.digital-winds": {
    source: "iana",
    extensions: [
      "eol"
    ]
  },
  "audio/vnd.dlna.adts": {
    source: "iana"
  },
  "audio/vnd.dolby.heaac.1": {
    source: "iana"
  },
  "audio/vnd.dolby.heaac.2": {
    source: "iana"
  },
  "audio/vnd.dolby.mlp": {
    source: "iana"
  },
  "audio/vnd.dolby.mps": {
    source: "iana"
  },
  "audio/vnd.dolby.pl2": {
    source: "iana"
  },
  "audio/vnd.dolby.pl2x": {
    source: "iana"
  },
  "audio/vnd.dolby.pl2z": {
    source: "iana"
  },
  "audio/vnd.dolby.pulse.1": {
    source: "iana"
  },
  "audio/vnd.dra": {
    source: "iana",
    extensions: [
      "dra"
    ]
  },
  "audio/vnd.dts": {
    source: "iana",
    extensions: [
      "dts"
    ]
  },
  "audio/vnd.dts.hd": {
    source: "iana",
    extensions: [
      "dtshd"
    ]
  },
  "audio/vnd.dts.uhd": {
    source: "iana"
  },
  "audio/vnd.dvb.file": {
    source: "iana"
  },
  "audio/vnd.everad.plj": {
    source: "iana"
  },
  "audio/vnd.hns.audio": {
    source: "iana"
  },
  "audio/vnd.lucent.voice": {
    source: "iana",
    extensions: [
      "lvp"
    ]
  },
  "audio/vnd.ms-playready.media.pya": {
    source: "iana",
    extensions: [
      "pya"
    ]
  },
  "audio/vnd.nokia.mobile-xmf": {
    source: "iana"
  },
  "audio/vnd.nortel.vbk": {
    source: "iana"
  },
  "audio/vnd.nuera.ecelp4800": {
    source: "iana",
    extensions: [
      "ecelp4800"
    ]
  },
  "audio/vnd.nuera.ecelp7470": {
    source: "iana",
    extensions: [
      "ecelp7470"
    ]
  },
  "audio/vnd.nuera.ecelp9600": {
    source: "iana",
    extensions: [
      "ecelp9600"
    ]
  },
  "audio/vnd.octel.sbc": {
    source: "iana"
  },
  "audio/vnd.presonus.multitrack": {
    source: "iana"
  },
  "audio/vnd.qcelp": {
    source: "iana"
  },
  "audio/vnd.rhetorex.32kadpcm": {
    source: "iana"
  },
  "audio/vnd.rip": {
    source: "iana",
    extensions: [
      "rip"
    ]
  },
  "audio/vnd.rn-realaudio": {
    compressible: !1
  },
  "audio/vnd.sealedmedia.softseal.mpeg": {
    source: "iana"
  },
  "audio/vnd.vmx.cvsd": {
    source: "iana"
  },
  "audio/vnd.wave": {
    compressible: !1
  },
  "audio/vorbis": {
    source: "iana",
    compressible: !1
  },
  "audio/vorbis-config": {
    source: "iana"
  },
  "audio/wav": {
    compressible: !1,
    extensions: [
      "wav"
    ]
  },
  "audio/wave": {
    compressible: !1,
    extensions: [
      "wav"
    ]
  },
  "audio/webm": {
    source: "apache",
    compressible: !1,
    extensions: [
      "weba"
    ]
  },
  "audio/x-aac": {
    source: "apache",
    compressible: !1,
    extensions: [
      "aac"
    ]
  },
  "audio/x-aiff": {
    source: "apache",
    extensions: [
      "aif",
      "aiff",
      "aifc"
    ]
  },
  "audio/x-caf": {
    source: "apache",
    compressible: !1,
    extensions: [
      "caf"
    ]
  },
  "audio/x-flac": {
    source: "apache",
    extensions: [
      "flac"
    ]
  },
  "audio/x-m4a": {
    source: "nginx",
    extensions: [
      "m4a"
    ]
  },
  "audio/x-matroska": {
    source: "apache",
    extensions: [
      "mka"
    ]
  },
  "audio/x-mpegurl": {
    source: "apache",
    extensions: [
      "m3u"
    ]
  },
  "audio/x-ms-wax": {
    source: "apache",
    extensions: [
      "wax"
    ]
  },
  "audio/x-ms-wma": {
    source: "apache",
    extensions: [
      "wma"
    ]
  },
  "audio/x-pn-realaudio": {
    source: "apache",
    extensions: [
      "ram",
      "ra"
    ]
  },
  "audio/x-pn-realaudio-plugin": {
    source: "apache",
    extensions: [
      "rmp"
    ]
  },
  "audio/x-realaudio": {
    source: "nginx",
    extensions: [
      "ra"
    ]
  },
  "audio/x-tta": {
    source: "apache"
  },
  "audio/x-wav": {
    source: "apache",
    extensions: [
      "wav"
    ]
  },
  "audio/xm": {
    source: "apache",
    extensions: [
      "xm"
    ]
  },
  "chemical/x-cdx": {
    source: "apache",
    extensions: [
      "cdx"
    ]
  },
  "chemical/x-cif": {
    source: "apache",
    extensions: [
      "cif"
    ]
  },
  "chemical/x-cmdf": {
    source: "apache",
    extensions: [
      "cmdf"
    ]
  },
  "chemical/x-cml": {
    source: "apache",
    extensions: [
      "cml"
    ]
  },
  "chemical/x-csml": {
    source: "apache",
    extensions: [
      "csml"
    ]
  },
  "chemical/x-pdb": {
    source: "apache"
  },
  "chemical/x-xyz": {
    source: "apache",
    extensions: [
      "xyz"
    ]
  },
  "font/collection": {
    source: "iana",
    extensions: [
      "ttc"
    ]
  },
  "font/otf": {
    source: "iana",
    compressible: !0,
    extensions: [
      "otf"
    ]
  },
  "font/sfnt": {
    source: "iana"
  },
  "font/ttf": {
    source: "iana",
    compressible: !0,
    extensions: [
      "ttf"
    ]
  },
  "font/woff": {
    source: "iana",
    extensions: [
      "woff"
    ]
  },
  "font/woff2": {
    source: "iana",
    extensions: [
      "woff2"
    ]
  },
  "image/aces": {
    source: "iana",
    extensions: [
      "exr"
    ]
  },
  "image/apng": {
    compressible: !1,
    extensions: [
      "apng"
    ]
  },
  "image/avci": {
    source: "iana",
    extensions: [
      "avci"
    ]
  },
  "image/avcs": {
    source: "iana",
    extensions: [
      "avcs"
    ]
  },
  "image/avif": {
    source: "iana",
    compressible: !1,
    extensions: [
      "avif"
    ]
  },
  "image/bmp": {
    source: "iana",
    compressible: !0,
    extensions: [
      "bmp"
    ]
  },
  "image/cgm": {
    source: "iana",
    extensions: [
      "cgm"
    ]
  },
  "image/dicom-rle": {
    source: "iana",
    extensions: [
      "drle"
    ]
  },
  "image/emf": {
    source: "iana",
    extensions: [
      "emf"
    ]
  },
  "image/fits": {
    source: "iana",
    extensions: [
      "fits"
    ]
  },
  "image/g3fax": {
    source: "iana",
    extensions: [
      "g3"
    ]
  },
  "image/gif": {
    source: "iana",
    compressible: !1,
    extensions: [
      "gif"
    ]
  },
  "image/heic": {
    source: "iana",
    extensions: [
      "heic"
    ]
  },
  "image/heic-sequence": {
    source: "iana",
    extensions: [
      "heics"
    ]
  },
  "image/heif": {
    source: "iana",
    extensions: [
      "heif"
    ]
  },
  "image/heif-sequence": {
    source: "iana",
    extensions: [
      "heifs"
    ]
  },
  "image/hej2k": {
    source: "iana",
    extensions: [
      "hej2"
    ]
  },
  "image/hsj2": {
    source: "iana",
    extensions: [
      "hsj2"
    ]
  },
  "image/ief": {
    source: "iana",
    extensions: [
      "ief"
    ]
  },
  "image/jls": {
    source: "iana",
    extensions: [
      "jls"
    ]
  },
  "image/jp2": {
    source: "iana",
    compressible: !1,
    extensions: [
      "jp2",
      "jpg2"
    ]
  },
  "image/jpeg": {
    source: "iana",
    compressible: !1,
    extensions: [
      "jpeg",
      "jpg",
      "jpe"
    ]
  },
  "image/jph": {
    source: "iana",
    extensions: [
      "jph"
    ]
  },
  "image/jphc": {
    source: "iana",
    extensions: [
      "jhc"
    ]
  },
  "image/jpm": {
    source: "iana",
    compressible: !1,
    extensions: [
      "jpm"
    ]
  },
  "image/jpx": {
    source: "iana",
    compressible: !1,
    extensions: [
      "jpx",
      "jpf"
    ]
  },
  "image/jxr": {
    source: "iana",
    extensions: [
      "jxr"
    ]
  },
  "image/jxra": {
    source: "iana",
    extensions: [
      "jxra"
    ]
  },
  "image/jxrs": {
    source: "iana",
    extensions: [
      "jxrs"
    ]
  },
  "image/jxs": {
    source: "iana",
    extensions: [
      "jxs"
    ]
  },
  "image/jxsc": {
    source: "iana",
    extensions: [
      "jxsc"
    ]
  },
  "image/jxsi": {
    source: "iana",
    extensions: [
      "jxsi"
    ]
  },
  "image/jxss": {
    source: "iana",
    extensions: [
      "jxss"
    ]
  },
  "image/ktx": {
    source: "iana",
    extensions: [
      "ktx"
    ]
  },
  "image/ktx2": {
    source: "iana",
    extensions: [
      "ktx2"
    ]
  },
  "image/naplps": {
    source: "iana"
  },
  "image/pjpeg": {
    compressible: !1
  },
  "image/png": {
    source: "iana",
    compressible: !1,
    extensions: [
      "png"
    ]
  },
  "image/prs.btif": {
    source: "iana",
    extensions: [
      "btif"
    ]
  },
  "image/prs.pti": {
    source: "iana",
    extensions: [
      "pti"
    ]
  },
  "image/pwg-raster": {
    source: "iana"
  },
  "image/sgi": {
    source: "apache",
    extensions: [
      "sgi"
    ]
  },
  "image/svg+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "svg",
      "svgz"
    ]
  },
  "image/t38": {
    source: "iana",
    extensions: [
      "t38"
    ]
  },
  "image/tiff": {
    source: "iana",
    compressible: !1,
    extensions: [
      "tif",
      "tiff"
    ]
  },
  "image/tiff-fx": {
    source: "iana",
    extensions: [
      "tfx"
    ]
  },
  "image/vnd.adobe.photoshop": {
    source: "iana",
    compressible: !0,
    extensions: [
      "psd"
    ]
  },
  "image/vnd.airzip.accelerator.azv": {
    source: "iana",
    extensions: [
      "azv"
    ]
  },
  "image/vnd.cns.inf2": {
    source: "iana"
  },
  "image/vnd.dece.graphic": {
    source: "iana",
    extensions: [
      "uvi",
      "uvvi",
      "uvg",
      "uvvg"
    ]
  },
  "image/vnd.djvu": {
    source: "iana",
    extensions: [
      "djvu",
      "djv"
    ]
  },
  "image/vnd.dvb.subtitle": {
    source: "iana",
    extensions: [
      "sub"
    ]
  },
  "image/vnd.dwg": {
    source: "iana",
    extensions: [
      "dwg"
    ]
  },
  "image/vnd.dxf": {
    source: "iana",
    extensions: [
      "dxf"
    ]
  },
  "image/vnd.fastbidsheet": {
    source: "iana",
    extensions: [
      "fbs"
    ]
  },
  "image/vnd.fpx": {
    source: "iana",
    extensions: [
      "fpx"
    ]
  },
  "image/vnd.fst": {
    source: "iana",
    extensions: [
      "fst"
    ]
  },
  "image/vnd.fujixerox.edmics-mmr": {
    source: "iana",
    extensions: [
      "mmr"
    ]
  },
  "image/vnd.fujixerox.edmics-rlc": {
    source: "iana",
    extensions: [
      "rlc"
    ]
  },
  "image/vnd.globalgraphics.pgb": {
    source: "iana"
  },
  "image/vnd.microsoft.icon": {
    source: "iana",
    compressible: !0,
    extensions: [
      "ico"
    ]
  },
  "image/vnd.mix": {
    source: "iana"
  },
  "image/vnd.mozilla.apng": {
    source: "iana"
  },
  "image/vnd.ms-dds": {
    compressible: !0,
    extensions: [
      "dds"
    ]
  },
  "image/vnd.ms-modi": {
    source: "iana",
    extensions: [
      "mdi"
    ]
  },
  "image/vnd.ms-photo": {
    source: "apache",
    extensions: [
      "wdp"
    ]
  },
  "image/vnd.net-fpx": {
    source: "iana",
    extensions: [
      "npx"
    ]
  },
  "image/vnd.pco.b16": {
    source: "iana",
    extensions: [
      "b16"
    ]
  },
  "image/vnd.radiance": {
    source: "iana"
  },
  "image/vnd.sealed.png": {
    source: "iana"
  },
  "image/vnd.sealedmedia.softseal.gif": {
    source: "iana"
  },
  "image/vnd.sealedmedia.softseal.jpg": {
    source: "iana"
  },
  "image/vnd.svf": {
    source: "iana"
  },
  "image/vnd.tencent.tap": {
    source: "iana",
    extensions: [
      "tap"
    ]
  },
  "image/vnd.valve.source.texture": {
    source: "iana",
    extensions: [
      "vtf"
    ]
  },
  "image/vnd.wap.wbmp": {
    source: "iana",
    extensions: [
      "wbmp"
    ]
  },
  "image/vnd.xiff": {
    source: "iana",
    extensions: [
      "xif"
    ]
  },
  "image/vnd.zbrush.pcx": {
    source: "iana",
    extensions: [
      "pcx"
    ]
  },
  "image/webp": {
    source: "apache",
    extensions: [
      "webp"
    ]
  },
  "image/wmf": {
    source: "iana",
    extensions: [
      "wmf"
    ]
  },
  "image/x-3ds": {
    source: "apache",
    extensions: [
      "3ds"
    ]
  },
  "image/x-cmu-raster": {
    source: "apache",
    extensions: [
      "ras"
    ]
  },
  "image/x-cmx": {
    source: "apache",
    extensions: [
      "cmx"
    ]
  },
  "image/x-freehand": {
    source: "apache",
    extensions: [
      "fh",
      "fhc",
      "fh4",
      "fh5",
      "fh7"
    ]
  },
  "image/x-icon": {
    source: "apache",
    compressible: !0,
    extensions: [
      "ico"
    ]
  },
  "image/x-jng": {
    source: "nginx",
    extensions: [
      "jng"
    ]
  },
  "image/x-mrsid-image": {
    source: "apache",
    extensions: [
      "sid"
    ]
  },
  "image/x-ms-bmp": {
    source: "nginx",
    compressible: !0,
    extensions: [
      "bmp"
    ]
  },
  "image/x-pcx": {
    source: "apache",
    extensions: [
      "pcx"
    ]
  },
  "image/x-pict": {
    source: "apache",
    extensions: [
      "pic",
      "pct"
    ]
  },
  "image/x-portable-anymap": {
    source: "apache",
    extensions: [
      "pnm"
    ]
  },
  "image/x-portable-bitmap": {
    source: "apache",
    extensions: [
      "pbm"
    ]
  },
  "image/x-portable-graymap": {
    source: "apache",
    extensions: [
      "pgm"
    ]
  },
  "image/x-portable-pixmap": {
    source: "apache",
    extensions: [
      "ppm"
    ]
  },
  "image/x-rgb": {
    source: "apache",
    extensions: [
      "rgb"
    ]
  },
  "image/x-tga": {
    source: "apache",
    extensions: [
      "tga"
    ]
  },
  "image/x-xbitmap": {
    source: "apache",
    extensions: [
      "xbm"
    ]
  },
  "image/x-xcf": {
    compressible: !1
  },
  "image/x-xpixmap": {
    source: "apache",
    extensions: [
      "xpm"
    ]
  },
  "image/x-xwindowdump": {
    source: "apache",
    extensions: [
      "xwd"
    ]
  },
  "message/cpim": {
    source: "iana"
  },
  "message/delivery-status": {
    source: "iana"
  },
  "message/disposition-notification": {
    source: "iana",
    extensions: [
      "disposition-notification"
    ]
  },
  "message/external-body": {
    source: "iana"
  },
  "message/feedback-report": {
    source: "iana"
  },
  "message/global": {
    source: "iana",
    extensions: [
      "u8msg"
    ]
  },
  "message/global-delivery-status": {
    source: "iana",
    extensions: [
      "u8dsn"
    ]
  },
  "message/global-disposition-notification": {
    source: "iana",
    extensions: [
      "u8mdn"
    ]
  },
  "message/global-headers": {
    source: "iana",
    extensions: [
      "u8hdr"
    ]
  },
  "message/http": {
    source: "iana",
    compressible: !1
  },
  "message/imdn+xml": {
    source: "iana",
    compressible: !0
  },
  "message/news": {
    source: "iana"
  },
  "message/partial": {
    source: "iana",
    compressible: !1
  },
  "message/rfc822": {
    source: "iana",
    compressible: !0,
    extensions: [
      "eml",
      "mime"
    ]
  },
  "message/s-http": {
    source: "iana"
  },
  "message/sip": {
    source: "iana"
  },
  "message/sipfrag": {
    source: "iana"
  },
  "message/tracking-status": {
    source: "iana"
  },
  "message/vnd.si.simp": {
    source: "iana"
  },
  "message/vnd.wfa.wsc": {
    source: "iana",
    extensions: [
      "wsc"
    ]
  },
  "model/3mf": {
    source: "iana",
    extensions: [
      "3mf"
    ]
  },
  "model/e57": {
    source: "iana"
  },
  "model/gltf+json": {
    source: "iana",
    compressible: !0,
    extensions: [
      "gltf"
    ]
  },
  "model/gltf-binary": {
    source: "iana",
    compressible: !0,
    extensions: [
      "glb"
    ]
  },
  "model/iges": {
    source: "iana",
    compressible: !1,
    extensions: [
      "igs",
      "iges"
    ]
  },
  "model/mesh": {
    source: "iana",
    compressible: !1,
    extensions: [
      "msh",
      "mesh",
      "silo"
    ]
  },
  "model/mtl": {
    source: "iana",
    extensions: [
      "mtl"
    ]
  },
  "model/obj": {
    source: "iana",
    extensions: [
      "obj"
    ]
  },
  "model/step": {
    source: "iana"
  },
  "model/step+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "stpx"
    ]
  },
  "model/step+zip": {
    source: "iana",
    compressible: !1,
    extensions: [
      "stpz"
    ]
  },
  "model/step-xml+zip": {
    source: "iana",
    compressible: !1,
    extensions: [
      "stpxz"
    ]
  },
  "model/stl": {
    source: "iana",
    extensions: [
      "stl"
    ]
  },
  "model/vnd.collada+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "dae"
    ]
  },
  "model/vnd.dwf": {
    source: "iana",
    extensions: [
      "dwf"
    ]
  },
  "model/vnd.flatland.3dml": {
    source: "iana"
  },
  "model/vnd.gdl": {
    source: "iana",
    extensions: [
      "gdl"
    ]
  },
  "model/vnd.gs-gdl": {
    source: "apache"
  },
  "model/vnd.gs.gdl": {
    source: "iana"
  },
  "model/vnd.gtw": {
    source: "iana",
    extensions: [
      "gtw"
    ]
  },
  "model/vnd.moml+xml": {
    source: "iana",
    compressible: !0
  },
  "model/vnd.mts": {
    source: "iana",
    extensions: [
      "mts"
    ]
  },
  "model/vnd.opengex": {
    source: "iana",
    extensions: [
      "ogex"
    ]
  },
  "model/vnd.parasolid.transmit.binary": {
    source: "iana",
    extensions: [
      "x_b"
    ]
  },
  "model/vnd.parasolid.transmit.text": {
    source: "iana",
    extensions: [
      "x_t"
    ]
  },
  "model/vnd.pytha.pyox": {
    source: "iana"
  },
  "model/vnd.rosette.annotated-data-model": {
    source: "iana"
  },
  "model/vnd.sap.vds": {
    source: "iana",
    extensions: [
      "vds"
    ]
  },
  "model/vnd.usdz+zip": {
    source: "iana",
    compressible: !1,
    extensions: [
      "usdz"
    ]
  },
  "model/vnd.valve.source.compiled-map": {
    source: "iana",
    extensions: [
      "bsp"
    ]
  },
  "model/vnd.vtu": {
    source: "iana",
    extensions: [
      "vtu"
    ]
  },
  "model/vrml": {
    source: "iana",
    compressible: !1,
    extensions: [
      "wrl",
      "vrml"
    ]
  },
  "model/x3d+binary": {
    source: "apache",
    compressible: !1,
    extensions: [
      "x3db",
      "x3dbz"
    ]
  },
  "model/x3d+fastinfoset": {
    source: "iana",
    extensions: [
      "x3db"
    ]
  },
  "model/x3d+vrml": {
    source: "apache",
    compressible: !1,
    extensions: [
      "x3dv",
      "x3dvz"
    ]
  },
  "model/x3d+xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "x3d",
      "x3dz"
    ]
  },
  "model/x3d-vrml": {
    source: "iana",
    extensions: [
      "x3dv"
    ]
  },
  "multipart/alternative": {
    source: "iana",
    compressible: !1
  },
  "multipart/appledouble": {
    source: "iana"
  },
  "multipart/byteranges": {
    source: "iana"
  },
  "multipart/digest": {
    source: "iana"
  },
  "multipart/encrypted": {
    source: "iana",
    compressible: !1
  },
  "multipart/form-data": {
    source: "iana",
    compressible: !1
  },
  "multipart/header-set": {
    source: "iana"
  },
  "multipart/mixed": {
    source: "iana"
  },
  "multipart/multilingual": {
    source: "iana"
  },
  "multipart/parallel": {
    source: "iana"
  },
  "multipart/related": {
    source: "iana",
    compressible: !1
  },
  "multipart/report": {
    source: "iana"
  },
  "multipart/signed": {
    source: "iana",
    compressible: !1
  },
  "multipart/vnd.bint.med-plus": {
    source: "iana"
  },
  "multipart/voice-message": {
    source: "iana"
  },
  "multipart/x-mixed-replace": {
    source: "iana"
  },
  "text/1d-interleaved-parityfec": {
    source: "iana"
  },
  "text/cache-manifest": {
    source: "iana",
    compressible: !0,
    extensions: [
      "appcache",
      "manifest"
    ]
  },
  "text/calendar": {
    source: "iana",
    extensions: [
      "ics",
      "ifb"
    ]
  },
  "text/calender": {
    compressible: !0
  },
  "text/cmd": {
    compressible: !0
  },
  "text/coffeescript": {
    extensions: [
      "coffee",
      "litcoffee"
    ]
  },
  "text/cql": {
    source: "iana"
  },
  "text/cql-expression": {
    source: "iana"
  },
  "text/cql-identifier": {
    source: "iana"
  },
  "text/css": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0,
    extensions: [
      "css"
    ]
  },
  "text/csv": {
    source: "iana",
    compressible: !0,
    extensions: [
      "csv"
    ]
  },
  "text/csv-schema": {
    source: "iana"
  },
  "text/directory": {
    source: "iana"
  },
  "text/dns": {
    source: "iana"
  },
  "text/ecmascript": {
    source: "iana"
  },
  "text/encaprtp": {
    source: "iana"
  },
  "text/enriched": {
    source: "iana"
  },
  "text/fhirpath": {
    source: "iana"
  },
  "text/flexfec": {
    source: "iana"
  },
  "text/fwdred": {
    source: "iana"
  },
  "text/gff3": {
    source: "iana"
  },
  "text/grammar-ref-list": {
    source: "iana"
  },
  "text/html": {
    source: "iana",
    compressible: !0,
    extensions: [
      "html",
      "htm",
      "shtml"
    ]
  },
  "text/jade": {
    extensions: [
      "jade"
    ]
  },
  "text/javascript": {
    source: "iana",
    compressible: !0
  },
  "text/jcr-cnd": {
    source: "iana"
  },
  "text/jsx": {
    compressible: !0,
    extensions: [
      "jsx"
    ]
  },
  "text/less": {
    compressible: !0,
    extensions: [
      "less"
    ]
  },
  "text/markdown": {
    source: "iana",
    compressible: !0,
    extensions: [
      "markdown",
      "md"
    ]
  },
  "text/mathml": {
    source: "nginx",
    extensions: [
      "mml"
    ]
  },
  "text/mdx": {
    compressible: !0,
    extensions: [
      "mdx"
    ]
  },
  "text/mizar": {
    source: "iana"
  },
  "text/n3": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0,
    extensions: [
      "n3"
    ]
  },
  "text/parameters": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/parityfec": {
    source: "iana"
  },
  "text/plain": {
    source: "iana",
    compressible: !0,
    extensions: [
      "txt",
      "text",
      "conf",
      "def",
      "list",
      "log",
      "in",
      "ini"
    ]
  },
  "text/provenance-notation": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/prs.fallenstein.rst": {
    source: "iana"
  },
  "text/prs.lines.tag": {
    source: "iana",
    extensions: [
      "dsc"
    ]
  },
  "text/prs.prop.logic": {
    source: "iana"
  },
  "text/raptorfec": {
    source: "iana"
  },
  "text/red": {
    source: "iana"
  },
  "text/rfc822-headers": {
    source: "iana"
  },
  "text/richtext": {
    source: "iana",
    compressible: !0,
    extensions: [
      "rtx"
    ]
  },
  "text/rtf": {
    source: "iana",
    compressible: !0,
    extensions: [
      "rtf"
    ]
  },
  "text/rtp-enc-aescm128": {
    source: "iana"
  },
  "text/rtploopback": {
    source: "iana"
  },
  "text/rtx": {
    source: "iana"
  },
  "text/sgml": {
    source: "iana",
    extensions: [
      "sgml",
      "sgm"
    ]
  },
  "text/shaclc": {
    source: "iana"
  },
  "text/shex": {
    source: "iana",
    extensions: [
      "shex"
    ]
  },
  "text/slim": {
    extensions: [
      "slim",
      "slm"
    ]
  },
  "text/spdx": {
    source: "iana",
    extensions: [
      "spdx"
    ]
  },
  "text/strings": {
    source: "iana"
  },
  "text/stylus": {
    extensions: [
      "stylus",
      "styl"
    ]
  },
  "text/t140": {
    source: "iana"
  },
  "text/tab-separated-values": {
    source: "iana",
    compressible: !0,
    extensions: [
      "tsv"
    ]
  },
  "text/troff": {
    source: "iana",
    extensions: [
      "t",
      "tr",
      "roff",
      "man",
      "me",
      "ms"
    ]
  },
  "text/turtle": {
    source: "iana",
    charset: "UTF-8",
    extensions: [
      "ttl"
    ]
  },
  "text/ulpfec": {
    source: "iana"
  },
  "text/uri-list": {
    source: "iana",
    compressible: !0,
    extensions: [
      "uri",
      "uris",
      "urls"
    ]
  },
  "text/vcard": {
    source: "iana",
    compressible: !0,
    extensions: [
      "vcard"
    ]
  },
  "text/vnd.a": {
    source: "iana"
  },
  "text/vnd.abc": {
    source: "iana"
  },
  "text/vnd.ascii-art": {
    source: "iana"
  },
  "text/vnd.curl": {
    source: "iana",
    extensions: [
      "curl"
    ]
  },
  "text/vnd.curl.dcurl": {
    source: "apache",
    extensions: [
      "dcurl"
    ]
  },
  "text/vnd.curl.mcurl": {
    source: "apache",
    extensions: [
      "mcurl"
    ]
  },
  "text/vnd.curl.scurl": {
    source: "apache",
    extensions: [
      "scurl"
    ]
  },
  "text/vnd.debian.copyright": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/vnd.dmclientscript": {
    source: "iana"
  },
  "text/vnd.dvb.subtitle": {
    source: "iana",
    extensions: [
      "sub"
    ]
  },
  "text/vnd.esmertec.theme-descriptor": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/vnd.familysearch.gedcom": {
    source: "iana",
    extensions: [
      "ged"
    ]
  },
  "text/vnd.ficlab.flt": {
    source: "iana"
  },
  "text/vnd.fly": {
    source: "iana",
    extensions: [
      "fly"
    ]
  },
  "text/vnd.fmi.flexstor": {
    source: "iana",
    extensions: [
      "flx"
    ]
  },
  "text/vnd.gml": {
    source: "iana"
  },
  "text/vnd.graphviz": {
    source: "iana",
    extensions: [
      "gv"
    ]
  },
  "text/vnd.hans": {
    source: "iana"
  },
  "text/vnd.hgl": {
    source: "iana"
  },
  "text/vnd.in3d.3dml": {
    source: "iana",
    extensions: [
      "3dml"
    ]
  },
  "text/vnd.in3d.spot": {
    source: "iana",
    extensions: [
      "spot"
    ]
  },
  "text/vnd.iptc.newsml": {
    source: "iana"
  },
  "text/vnd.iptc.nitf": {
    source: "iana"
  },
  "text/vnd.latex-z": {
    source: "iana"
  },
  "text/vnd.motorola.reflex": {
    source: "iana"
  },
  "text/vnd.ms-mediapackage": {
    source: "iana"
  },
  "text/vnd.net2phone.commcenter.command": {
    source: "iana"
  },
  "text/vnd.radisys.msml-basic-layout": {
    source: "iana"
  },
  "text/vnd.senx.warpscript": {
    source: "iana"
  },
  "text/vnd.si.uricatalogue": {
    source: "iana"
  },
  "text/vnd.sosi": {
    source: "iana"
  },
  "text/vnd.sun.j2me.app-descriptor": {
    source: "iana",
    charset: "UTF-8",
    extensions: [
      "jad"
    ]
  },
  "text/vnd.trolltech.linguist": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/vnd.wap.si": {
    source: "iana"
  },
  "text/vnd.wap.sl": {
    source: "iana"
  },
  "text/vnd.wap.wml": {
    source: "iana",
    extensions: [
      "wml"
    ]
  },
  "text/vnd.wap.wmlscript": {
    source: "iana",
    extensions: [
      "wmls"
    ]
  },
  "text/vtt": {
    source: "iana",
    charset: "UTF-8",
    compressible: !0,
    extensions: [
      "vtt"
    ]
  },
  "text/x-asm": {
    source: "apache",
    extensions: [
      "s",
      "asm"
    ]
  },
  "text/x-c": {
    source: "apache",
    extensions: [
      "c",
      "cc",
      "cxx",
      "cpp",
      "h",
      "hh",
      "dic"
    ]
  },
  "text/x-component": {
    source: "nginx",
    extensions: [
      "htc"
    ]
  },
  "text/x-fortran": {
    source: "apache",
    extensions: [
      "f",
      "for",
      "f77",
      "f90"
    ]
  },
  "text/x-gwt-rpc": {
    compressible: !0
  },
  "text/x-handlebars-template": {
    extensions: [
      "hbs"
    ]
  },
  "text/x-java-source": {
    source: "apache",
    extensions: [
      "java"
    ]
  },
  "text/x-jquery-tmpl": {
    compressible: !0
  },
  "text/x-lua": {
    extensions: [
      "lua"
    ]
  },
  "text/x-markdown": {
    compressible: !0,
    extensions: [
      "mkd"
    ]
  },
  "text/x-nfo": {
    source: "apache",
    extensions: [
      "nfo"
    ]
  },
  "text/x-opml": {
    source: "apache",
    extensions: [
      "opml"
    ]
  },
  "text/x-org": {
    compressible: !0,
    extensions: [
      "org"
    ]
  },
  "text/x-pascal": {
    source: "apache",
    extensions: [
      "p",
      "pas"
    ]
  },
  "text/x-processing": {
    compressible: !0,
    extensions: [
      "pde"
    ]
  },
  "text/x-sass": {
    extensions: [
      "sass"
    ]
  },
  "text/x-scss": {
    extensions: [
      "scss"
    ]
  },
  "text/x-setext": {
    source: "apache",
    extensions: [
      "etx"
    ]
  },
  "text/x-sfv": {
    source: "apache",
    extensions: [
      "sfv"
    ]
  },
  "text/x-suse-ymp": {
    compressible: !0,
    extensions: [
      "ymp"
    ]
  },
  "text/x-uuencode": {
    source: "apache",
    extensions: [
      "uu"
    ]
  },
  "text/x-vcalendar": {
    source: "apache",
    extensions: [
      "vcs"
    ]
  },
  "text/x-vcard": {
    source: "apache",
    extensions: [
      "vcf"
    ]
  },
  "text/xml": {
    source: "iana",
    compressible: !0,
    extensions: [
      "xml"
    ]
  },
  "text/xml-external-parsed-entity": {
    source: "iana"
  },
  "text/yaml": {
    compressible: !0,
    extensions: [
      "yaml",
      "yml"
    ]
  },
  "video/1d-interleaved-parityfec": {
    source: "iana"
  },
  "video/3gpp": {
    source: "iana",
    extensions: [
      "3gp",
      "3gpp"
    ]
  },
  "video/3gpp-tt": {
    source: "iana"
  },
  "video/3gpp2": {
    source: "iana",
    extensions: [
      "3g2"
    ]
  },
  "video/av1": {
    source: "iana"
  },
  "video/bmpeg": {
    source: "iana"
  },
  "video/bt656": {
    source: "iana"
  },
  "video/celb": {
    source: "iana"
  },
  "video/dv": {
    source: "iana"
  },
  "video/encaprtp": {
    source: "iana"
  },
  "video/ffv1": {
    source: "iana"
  },
  "video/flexfec": {
    source: "iana"
  },
  "video/h261": {
    source: "iana",
    extensions: [
      "h261"
    ]
  },
  "video/h263": {
    source: "iana",
    extensions: [
      "h263"
    ]
  },
  "video/h263-1998": {
    source: "iana"
  },
  "video/h263-2000": {
    source: "iana"
  },
  "video/h264": {
    source: "iana",
    extensions: [
      "h264"
    ]
  },
  "video/h264-rcdo": {
    source: "iana"
  },
  "video/h264-svc": {
    source: "iana"
  },
  "video/h265": {
    source: "iana"
  },
  "video/iso.segment": {
    source: "iana",
    extensions: [
      "m4s"
    ]
  },
  "video/jpeg": {
    source: "iana",
    extensions: [
      "jpgv"
    ]
  },
  "video/jpeg2000": {
    source: "iana"
  },
  "video/jpm": {
    source: "apache",
    extensions: [
      "jpm",
      "jpgm"
    ]
  },
  "video/jxsv": {
    source: "iana"
  },
  "video/mj2": {
    source: "iana",
    extensions: [
      "mj2",
      "mjp2"
    ]
  },
  "video/mp1s": {
    source: "iana"
  },
  "video/mp2p": {
    source: "iana"
  },
  "video/mp2t": {
    source: "iana",
    extensions: [
      "ts"
    ]
  },
  "video/mp4": {
    source: "iana",
    compressible: !1,
    extensions: [
      "mp4",
      "mp4v",
      "mpg4"
    ]
  },
  "video/mp4v-es": {
    source: "iana"
  },
  "video/mpeg": {
    source: "iana",
    compressible: !1,
    extensions: [
      "mpeg",
      "mpg",
      "mpe",
      "m1v",
      "m2v"
    ]
  },
  "video/mpeg4-generic": {
    source: "iana"
  },
  "video/mpv": {
    source: "iana"
  },
  "video/nv": {
    source: "iana"
  },
  "video/ogg": {
    source: "iana",
    compressible: !1,
    extensions: [
      "ogv"
    ]
  },
  "video/parityfec": {
    source: "iana"
  },
  "video/pointer": {
    source: "iana"
  },
  "video/quicktime": {
    source: "iana",
    compressible: !1,
    extensions: [
      "qt",
      "mov"
    ]
  },
  "video/raptorfec": {
    source: "iana"
  },
  "video/raw": {
    source: "iana"
  },
  "video/rtp-enc-aescm128": {
    source: "iana"
  },
  "video/rtploopback": {
    source: "iana"
  },
  "video/rtx": {
    source: "iana"
  },
  "video/scip": {
    source: "iana"
  },
  "video/smpte291": {
    source: "iana"
  },
  "video/smpte292m": {
    source: "iana"
  },
  "video/ulpfec": {
    source: "iana"
  },
  "video/vc1": {
    source: "iana"
  },
  "video/vc2": {
    source: "iana"
  },
  "video/vnd.cctv": {
    source: "iana"
  },
  "video/vnd.dece.hd": {
    source: "iana",
    extensions: [
      "uvh",
      "uvvh"
    ]
  },
  "video/vnd.dece.mobile": {
    source: "iana",
    extensions: [
      "uvm",
      "uvvm"
    ]
  },
  "video/vnd.dece.mp4": {
    source: "iana"
  },
  "video/vnd.dece.pd": {
    source: "iana",
    extensions: [
      "uvp",
      "uvvp"
    ]
  },
  "video/vnd.dece.sd": {
    source: "iana",
    extensions: [
      "uvs",
      "uvvs"
    ]
  },
  "video/vnd.dece.video": {
    source: "iana",
    extensions: [
      "uvv",
      "uvvv"
    ]
  },
  "video/vnd.directv.mpeg": {
    source: "iana"
  },
  "video/vnd.directv.mpeg-tts": {
    source: "iana"
  },
  "video/vnd.dlna.mpeg-tts": {
    source: "iana"
  },
  "video/vnd.dvb.file": {
    source: "iana",
    extensions: [
      "dvb"
    ]
  },
  "video/vnd.fvt": {
    source: "iana",
    extensions: [
      "fvt"
    ]
  },
  "video/vnd.hns.video": {
    source: "iana"
  },
  "video/vnd.iptvforum.1dparityfec-1010": {
    source: "iana"
  },
  "video/vnd.iptvforum.1dparityfec-2005": {
    source: "iana"
  },
  "video/vnd.iptvforum.2dparityfec-1010": {
    source: "iana"
  },
  "video/vnd.iptvforum.2dparityfec-2005": {
    source: "iana"
  },
  "video/vnd.iptvforum.ttsavc": {
    source: "iana"
  },
  "video/vnd.iptvforum.ttsmpeg2": {
    source: "iana"
  },
  "video/vnd.motorola.video": {
    source: "iana"
  },
  "video/vnd.motorola.videop": {
    source: "iana"
  },
  "video/vnd.mpegurl": {
    source: "iana",
    extensions: [
      "mxu",
      "m4u"
    ]
  },
  "video/vnd.ms-playready.media.pyv": {
    source: "iana",
    extensions: [
      "pyv"
    ]
  },
  "video/vnd.nokia.interleaved-multimedia": {
    source: "iana"
  },
  "video/vnd.nokia.mp4vr": {
    source: "iana"
  },
  "video/vnd.nokia.videovoip": {
    source: "iana"
  },
  "video/vnd.objectvideo": {
    source: "iana"
  },
  "video/vnd.radgamettools.bink": {
    source: "iana"
  },
  "video/vnd.radgamettools.smacker": {
    source: "iana"
  },
  "video/vnd.sealed.mpeg1": {
    source: "iana"
  },
  "video/vnd.sealed.mpeg4": {
    source: "iana"
  },
  "video/vnd.sealed.swf": {
    source: "iana"
  },
  "video/vnd.sealedmedia.softseal.mov": {
    source: "iana"
  },
  "video/vnd.uvvu.mp4": {
    source: "iana",
    extensions: [
      "uvu",
      "uvvu"
    ]
  },
  "video/vnd.vivo": {
    source: "iana",
    extensions: [
      "viv"
    ]
  },
  "video/vnd.youtube.yt": {
    source: "iana"
  },
  "video/vp8": {
    source: "iana"
  },
  "video/vp9": {
    source: "iana"
  },
  "video/webm": {
    source: "apache",
    compressible: !1,
    extensions: [
      "webm"
    ]
  },
  "video/x-f4v": {
    source: "apache",
    extensions: [
      "f4v"
    ]
  },
  "video/x-fli": {
    source: "apache",
    extensions: [
      "fli"
    ]
  },
  "video/x-flv": {
    source: "apache",
    compressible: !1,
    extensions: [
      "flv"
    ]
  },
  "video/x-m4v": {
    source: "apache",
    extensions: [
      "m4v"
    ]
  },
  "video/x-matroska": {
    source: "apache",
    compressible: !1,
    extensions: [
      "mkv",
      "mk3d",
      "mks"
    ]
  },
  "video/x-mng": {
    source: "apache",
    extensions: [
      "mng"
    ]
  },
  "video/x-ms-asf": {
    source: "apache",
    extensions: [
      "asf",
      "asx"
    ]
  },
  "video/x-ms-vob": {
    source: "apache",
    extensions: [
      "vob"
    ]
  },
  "video/x-ms-wm": {
    source: "apache",
    extensions: [
      "wm"
    ]
  },
  "video/x-ms-wmv": {
    source: "apache",
    compressible: !1,
    extensions: [
      "wmv"
    ]
  },
  "video/x-ms-wmx": {
    source: "apache",
    extensions: [
      "wmx"
    ]
  },
  "video/x-ms-wvx": {
    source: "apache",
    extensions: [
      "wvx"
    ]
  },
  "video/x-msvideo": {
    source: "apache",
    extensions: [
      "avi"
    ]
  },
  "video/x-sgi-movie": {
    source: "apache",
    extensions: [
      "movie"
    ]
  },
  "video/x-smv": {
    source: "apache",
    extensions: [
      "smv"
    ]
  },
  "x-conference/x-cooltalk": {
    source: "apache",
    extensions: [
      "ice"
    ]
  },
  "x-shader/x-fragment": {
    compressible: !0
  },
  "x-shader/x-vertex": {
    compressible: !0
  }
};
/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */
(function(m) {
  m.exports = require$$0;
})(mimeDb);
/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
(function(m) {
  var c = mimeDb.exports, ie = pathBrowserify.extname, we = /^\s*([^;\s]*)(?:;|\s|$)/, $e = /^text\//i;
  m.charset = Me, m.charsets = { lookup: Me }, m.contentType = Ze, m.extension = ne, m.extensions = /* @__PURE__ */ Object.create(null), m.lookup = rr, m.types = /* @__PURE__ */ Object.create(null), gr(m.extensions, m.types);
  function Me(or) {
    if (!or || typeof or != "string")
      return !1;
    var _r = we.exec(or), Lr = _r && c[_r[1].toLowerCase()];
    return Lr && Lr.charset ? Lr.charset : _r && $e.test(_r[1]) ? "UTF-8" : !1;
  }
  function Ze(or) {
    if (!or || typeof or != "string")
      return !1;
    var _r = or.indexOf("/") === -1 ? m.lookup(or) : or;
    if (!_r)
      return !1;
    if (_r.indexOf("charset") === -1) {
      var Lr = m.charset(_r);
      Lr && (_r += "; charset=" + Lr.toLowerCase());
    }
    return _r;
  }
  function ne(or) {
    if (!or || typeof or != "string")
      return !1;
    var _r = we.exec(or), Lr = _r && m.extensions[_r[1].toLowerCase()];
    return !Lr || !Lr.length ? !1 : Lr[0];
  }
  function rr(or) {
    if (!or || typeof or != "string")
      return !1;
    var _r = ie("x." + or).toLowerCase().substr(1);
    return _r && m.types[_r] || !1;
  }
  function gr(or, _r) {
    var Lr = ["nginx", "apache", void 0, "iana"];
    Object.keys(c).forEach(function(Ar) {
      var Rr = c[Ar], Nr = Rr.extensions;
      if (!(!Nr || !Nr.length)) {
        or[Ar] = Nr;
        for (var Yr = 0; Yr < Nr.length; Yr++) {
          var Vr = Nr[Yr];
          if (_r[Vr]) {
            var Xr = Lr.indexOf(c[_r[Vr]].source), Wr = Lr.indexOf(Rr.source);
            if (_r[Vr] !== "application/octet-stream" && (Xr > Wr || Xr === Wr && _r[Vr].substr(0, 12) === "application/"))
              continue;
          }
          _r[Vr] = Ar;
        }
      }
    });
  }
})(mimeTypes);
"stream" in Blob.prototype || Object.defineProperty(Blob.prototype, "stream", { value() {
  return new Response(this).body;
} }), "setBigUint64" in DataView.prototype || Object.defineProperty(DataView.prototype, "setBigUint64", { value(m, c, ie) {
  const we = Number(0xffffffffn & c), $e = Number(c >> 32n);
  this.setUint32(m + (ie ? 0 : 4), we, ie), this.setUint32(m + (ie ? 4 : 0), $e, ie);
} });
var e = (m) => new DataView(new ArrayBuffer(m)), n = (m) => new Uint8Array(m.buffer || m), t = (m) => new TextEncoder().encode(String(m)), i = (m) => Math.min(4294967295, Number(m)), r = (m) => Math.min(65535, Number(m));
function o(m, c, ie) {
  c === void 0 || c instanceof Date || (c = new Date(c));
  const we = m !== void 0;
  if (ie || (ie = we ? 436 : 509), m instanceof File)
    return { isFile: we, t: c || new Date(m.lastModified), bytes: m.stream(), mode: ie };
  if (m instanceof Response)
    return { isFile: we, t: c || new Date(m.headers.get("Last-Modified") || Date.now()), bytes: m.body, mode: ie };
  if (c === void 0)
    c = new Date();
  else if (isNaN(c))
    throw new Error("Invalid modification date.");
  if (!we)
    return { isFile: we, t: c, mode: ie };
  if (typeof m == "string")
    return { isFile: we, t: c, bytes: t(m), mode: ie };
  if (m instanceof Blob)
    return { isFile: we, t: c, bytes: m.stream(), mode: ie };
  if (m instanceof Uint8Array || m instanceof ReadableStream)
    return { isFile: we, t: c, bytes: m, mode: ie };
  if (m instanceof ArrayBuffer || ArrayBuffer.isView(m))
    return { isFile: we, t: c, bytes: n(m), mode: ie };
  if (Symbol.asyncIterator in m)
    return { isFile: we, t: c, bytes: f(m[Symbol.asyncIterator]()), mode: ie };
  throw new TypeError("Unsupported input format.");
}
function f(m, c = m) {
  return new ReadableStream({ async pull(ie) {
    let we = 0;
    for (; ie.desiredSize > we; ) {
      const $e = await m.next();
      if (!$e.value) {
        ie.close();
        break;
      }
      {
        const Me = a($e.value);
        ie.enqueue(Me), we += Me.byteLength;
      }
    }
  }, cancel(ie) {
    c.throw?.(ie);
  } });
}
function a(m) {
  return typeof m == "string" ? t(m) : m instanceof Uint8Array ? m : n(m);
}
function s(m, c, ie) {
  let [we, $e] = function(Me) {
    return Me ? Me instanceof Uint8Array ? [Me, 1] : ArrayBuffer.isView(Me) || Me instanceof ArrayBuffer ? [n(Me), 1] : [t(Me), 0] : [void 0, 0];
  }(c);
  if (m instanceof File)
    return { i: d(we || t(m.name)), o: BigInt(m.size), u: $e };
  if (m instanceof Response) {
    const Me = m.headers.get("content-disposition"), Ze = Me && Me.match(/;\s*filename\*?\s*=\s*(?:UTF-\d+''|)["']?([^;"'\r\n]*)["']?(?:;|$)/i), ne = Ze && Ze[1] || m.url && new URL(m.url).pathname.split("/").findLast(Boolean), rr = ne && decodeURIComponent(ne), gr = ie || +m.headers.get("content-length");
    return { i: d(we || t(rr)), o: BigInt(gr), u: $e };
  }
  return we = d(we, m !== void 0 || ie !== void 0), typeof m == "string" ? { i: we, o: BigInt(t(m).length), u: $e } : m instanceof Blob ? { i: we, o: BigInt(m.size), u: $e } : m instanceof ArrayBuffer || ArrayBuffer.isView(m) ? { i: we, o: BigInt(m.byteLength), u: $e } : { i: we, o: u(m, ie), u: $e };
}
function u(m, c) {
  return c > -1 ? BigInt(c) : m ? void 0 : 0n;
}
function d(m, c = 1) {
  if (!m || m.every((ie) => ie === 47))
    throw new Error("The file must have a name.");
  if (c)
    for (; m[m.length - 1] === 47; )
      m = m.subarray(0, -1);
  else
    m[m.length - 1] !== 47 && (m = new Uint8Array([...m, 47]));
  return m;
}
var l = new Uint32Array(256);
for (let m = 0; m < 256; ++m) {
  let c = m;
  for (let ie = 0; ie < 8; ++ie)
    c = c >>> 1 ^ (1 & c && 3988292384);
  l[m] = c;
}
function y(m, c = 0) {
  c = ~c;
  for (var ie = 0, we = m.length; ie < we; ie++)
    c = c >>> 8 ^ l[255 & c ^ m[ie]];
  return ~c >>> 0;
}
function w(m, c, ie = 0) {
  const we = m.getSeconds() >> 1 | m.getMinutes() << 5 | m.getHours() << 11, $e = m.getDate() | m.getMonth() + 1 << 5 | m.getFullYear() - 1980 << 9;
  c.setUint16(ie, we, 1), c.setUint16(ie + 2, $e, 1);
}
function B({ i: m, u: c }, ie) {
  return 8 * (!c || (ie ?? function(we) {
    try {
      b.decode(we);
    } catch {
      return 0;
    }
    return 1;
  }(m)));
}
var b = new TextDecoder("utf8", { fatal: 1 });
function p(m, c = 0) {
  const ie = e(30);
  return ie.setUint32(0, 1347093252), ie.setUint32(4, 754976768 | c), w(m.t, ie, 10), ie.setUint16(26, m.i.length, 1), n(ie);
}
async function* g(m) {
  let { bytes: c } = m;
  if ("then" in c && (c = await c), c instanceof Uint8Array)
    yield c, m.l = y(c, 0), m.o = BigInt(c.length);
  else {
    m.o = 0n;
    const ie = c.getReader();
    for (; ; ) {
      const { value: we, done: $e } = await ie.read();
      if ($e)
        break;
      m.l = y(we, m.l), m.o += BigInt(we.length), yield we;
    }
  }
}
function I(m, c) {
  const ie = e(16 + (c ? 8 : 0));
  return ie.setUint32(0, 1347094280), ie.setUint32(4, m.isFile ? m.l : 0, 1), c ? (ie.setBigUint64(8, m.o, 1), ie.setBigUint64(16, m.o, 1)) : (ie.setUint32(8, i(m.o), 1), ie.setUint32(12, i(m.o), 1)), n(ie);
}
function v(m, c, ie = 0, we = 0) {
  const $e = e(46);
  return $e.setUint32(0, 1347092738), $e.setUint32(4, 755182848), $e.setUint16(8, 2048 | ie), w(m.t, $e, 12), $e.setUint32(16, m.isFile ? m.l : 0, 1), $e.setUint32(20, i(m.o), 1), $e.setUint32(24, i(m.o), 1), $e.setUint16(28, m.i.length, 1), $e.setUint16(30, we, 1), $e.setUint16(40, m.mode | (m.isFile ? 32768 : 16384), 1), $e.setUint32(42, i(c), 1), n($e);
}
function h(m, c, ie) {
  const we = e(ie);
  return we.setUint16(0, 1, 1), we.setUint16(2, ie - 4, 1), 16 & ie && (we.setBigUint64(4, m.o, 1), we.setBigUint64(12, m.o, 1)), we.setBigUint64(ie - 8, c, 1), n(we);
}
function D(m) {
  return m instanceof File || m instanceof Response ? [[m], [m]] : [[m.input, m.name, m.size], [m.input, m.lastModified, m.mode]];
}
var S = (m) => function(c) {
  let ie = BigInt(22), we = 0n, $e = 0;
  for (const Me of c) {
    if (!Me.i)
      throw new Error("Every file must have a non-empty name.");
    if (Me.o === void 0)
      throw new Error(`Missing size for file "${new TextDecoder().decode(Me.i)}".`);
    const Ze = Me.o >= 0xffffffffn, ne = we >= 0xffffffffn;
    we += BigInt(46 + Me.i.length + (Ze && 8)) + Me.o, ie += BigInt(Me.i.length + 46 + (12 * ne | 28 * Ze)), $e || ($e = Ze);
  }
  return ($e || we >= 0xffffffffn) && (ie += BigInt(76)), ie + we;
}(function* (c) {
  for (const ie of c)
    yield s(...D(ie)[0]);
}(m));
function A(m, c = {}) {
  const ie = { "Content-Type": "application/zip", "Content-Disposition": "attachment" };
  return (typeof c.length == "bigint" || Number.isInteger(c.length)) && c.length > 0 && (ie["Content-Length"] = String(c.length)), c.metadata && (ie["Content-Length"] = String(S(c.metadata))), new Response(N(m, c), { headers: ie });
}
function N(m, c = {}) {
  const ie = function(we) {
    const $e = we[Symbol.iterator in we ? Symbol.iterator : Symbol.asyncIterator]();
    return { async next() {
      const Me = await $e.next();
      if (Me.done)
        return Me;
      const [Ze, ne] = D(Me.value);
      return { done: 0, value: Object.assign(o(...ne), s(...Ze)) };
    }, throw: $e.throw?.bind($e), [Symbol.asyncIterator]() {
      return this;
    } };
  }(m);
  return f(async function* (we, $e) {
    const Me = [];
    let Ze = 0n, ne = 0n, rr = 0;
    for await (const _r of we) {
      const Lr = B(_r, $e.buffersAreUTF8);
      yield p(_r, Lr), yield new Uint8Array(_r.i), _r.isFile && (yield* g(_r));
      const Ir = _r.o >= 0xffffffffn, Ar = 12 * (Ze >= 0xffffffffn) | 28 * Ir;
      yield I(_r, Ir), Me.push(v(_r, Ze, Lr, Ar)), Me.push(_r.i), Ar && Me.push(h(_r, Ze, Ar)), Ir && (Ze += 8n), ne++, Ze += BigInt(46 + _r.i.length) + _r.o, rr || (rr = Ir);
    }
    let gr = 0n;
    for (const _r of Me)
      yield _r, gr += BigInt(_r.length);
    if (rr || Ze >= 0xffffffffn) {
      const _r = e(76);
      _r.setUint32(0, 1347094022), _r.setBigUint64(4, BigInt(44), 1), _r.setUint32(12, 755182848), _r.setBigUint64(24, ne, 1), _r.setBigUint64(32, ne, 1), _r.setBigUint64(40, gr, 1), _r.setBigUint64(48, Ze, 1), _r.setUint32(56, 1347094023), _r.setBigUint64(64, Ze + gr, 1), _r.setUint32(72, 1, 1), yield n(_r);
    }
    const or = e(22);
    or.setUint32(0, 1347093766), or.setUint16(8, r(ne), 1), or.setUint16(10, r(ne), 1), or.setUint32(12, i(gr), 1), or.setUint32(16, i(Ze), 1), yield n(or);
  }(ie, c), ie);
}
var download$1 = { exports: {} };
(function(m, c) {
  (function(ie, we) {
    m.exports = we();
  })(commonjsGlobal, function() {
    return function ie(we, $e, Me) {
      var Ze = window, ne = "application/octet-stream", rr = Me || ne, gr = we, or = !$e && !Me && gr, _r = document.createElement("a"), Lr = function(xi) {
        return String(xi);
      }, Ir = Ze.Blob || Ze.MozBlob || Ze.WebKitBlob || Lr, Ar = $e || "download", Rr, Nr;
      if (Ir = Ir.call ? Ir.bind(Ze) : Blob, String(this) === "true" && (gr = [gr, rr], rr = gr[0], gr = gr[1]), or && or.length < 2048 && (Ar = or.split("/").pop().split("?")[0], _r.href = or, _r.href.indexOf(or) !== -1)) {
        var Yr = new XMLHttpRequest();
        return Yr.open("GET", or, !0), Yr.responseType = "blob", Yr.onload = function(xi) {
          ie(xi.target.response, Ar, ne);
        }, setTimeout(function() {
          Yr.send();
        }, 0), Yr;
      }
      if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(gr))
        if (gr.length > 1024 * 1024 * 1.999 && Ir !== Lr)
          gr = si(gr), rr = gr.type || ne;
        else
          return navigator.msSaveBlob ? navigator.msSaveBlob(si(gr), Ar) : li(gr);
      else if (/([\x80-\xff])/.test(gr)) {
        var Vr = 0, Xr = new Uint8Array(gr.length), Wr = Xr.length;
        for (Vr; Vr < Wr; ++Vr)
          Xr[Vr] = gr.charCodeAt(Vr);
        gr = new Ir([Xr], { type: rr });
      }
      Rr = gr instanceof Ir ? gr : new Ir([gr], { type: rr });
      function si(xi) {
        var di = xi.split(/[:;,]/), oi = di[1], ci = di[2] == "base64" ? atob : decodeURIComponent, vr = ci(di.pop()), Ae = vr.length, ze = 0, Ue = new Uint8Array(Ae);
        for (ze; ze < Ae; ++ze)
          Ue[ze] = vr.charCodeAt(ze);
        return new Ir([Ue], { type: oi });
      }
      function li(xi, di) {
        if ("download" in _r)
          return _r.href = xi, _r.setAttribute("download", Ar), _r.className = "download-js-link", _r.innerHTML = "downloading...", _r.style.display = "none", document.body.appendChild(_r), setTimeout(function() {
            _r.click(), document.body.removeChild(_r), di === !0 && setTimeout(function() {
              Ze.URL.revokeObjectURL(_r.href);
            }, 250);
          }, 66), !0;
        if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent))
          return /^data:/.test(xi) && (xi = "data:" + xi.replace(/^data:([\w\/\-\+]+)/, ne)), window.open(xi) || confirm(`Displaying New Document

Use Save As... to download, then click back to return to this page.`) && (location.href = xi), !0;
        var oi = document.createElement("iframe");
        document.body.appendChild(oi), !di && /^data:/.test(xi) && (xi = "data:" + xi.replace(/^data:([\w\/\-\+]+)/, ne)), oi.src = xi, setTimeout(function() {
          document.body.removeChild(oi);
        }, 333);
      }
      if (navigator.msSaveBlob)
        return navigator.msSaveBlob(Rr, Ar);
      if (Ze.URL)
        li(Ze.URL.createObjectURL(Rr), !0);
      else {
        if (typeof Rr == "string" || Rr.constructor === Lr)
          try {
            return li("data:" + rr + ";base64," + Ze.btoa(Rr));
          } catch {
            return li("data:" + rr + "," + encodeURIComponent(Rr));
          }
        Nr = new FileReader(), Nr.onload = function(xi) {
          li(this.result);
        }, Nr.readAsDataURL(Rr);
      }
      return !0;
    };
  });
})(download$1);
const download = download$1.exports, types$1 = {
  "application/prs.cww": ["cww"],
  "application/prs.xsf+xml": ["xsf"],
  "application/vnd.1000minds.decision-model+xml": ["1km"],
  "application/vnd.3gpp.pic-bw-large": ["plb"],
  "application/vnd.3gpp.pic-bw-small": ["psb"],
  "application/vnd.3gpp.pic-bw-var": ["pvb"],
  "application/vnd.3gpp2.tcap": ["tcap"],
  "application/vnd.3m.post-it-notes": ["pwn"],
  "application/vnd.accpac.simply.aso": ["aso"],
  "application/vnd.accpac.simply.imp": ["imp"],
  "application/vnd.acucobol": ["acu"],
  "application/vnd.acucorp": ["atc", "acutc"],
  "application/vnd.adobe.air-application-installer-package+zip": ["air"],
  "application/vnd.adobe.formscentral.fcdt": ["fcdt"],
  "application/vnd.adobe.fxp": ["fxp", "fxpl"],
  "application/vnd.adobe.xdp+xml": ["xdp"],
  "application/vnd.adobe.xfdf": ["*xfdf"],
  "application/vnd.age": ["age"],
  "application/vnd.ahead.space": ["ahead"],
  "application/vnd.airzip.filesecure.azf": ["azf"],
  "application/vnd.airzip.filesecure.azs": ["azs"],
  "application/vnd.amazon.ebook": ["azw"],
  "application/vnd.americandynamics.acc": ["acc"],
  "application/vnd.amiga.ami": ["ami"],
  "application/vnd.android.package-archive": ["apk"],
  "application/vnd.anser-web-certificate-issue-initiation": ["cii"],
  "application/vnd.anser-web-funds-transfer-initiation": ["fti"],
  "application/vnd.antix.game-component": ["atx"],
  "application/vnd.apple.installer+xml": ["mpkg"],
  "application/vnd.apple.keynote": ["key"],
  "application/vnd.apple.mpegurl": ["m3u8"],
  "application/vnd.apple.numbers": ["numbers"],
  "application/vnd.apple.pages": ["pages"],
  "application/vnd.apple.pkpass": ["pkpass"],
  "application/vnd.aristanetworks.swi": ["swi"],
  "application/vnd.astraea-software.iota": ["iota"],
  "application/vnd.audiograph": ["aep"],
  "application/vnd.autodesk.fbx": ["fbx"],
  "application/vnd.balsamiq.bmml+xml": ["bmml"],
  "application/vnd.blueice.multipass": ["mpm"],
  "application/vnd.bmi": ["bmi"],
  "application/vnd.businessobjects": ["rep"],
  "application/vnd.chemdraw+xml": ["cdxml"],
  "application/vnd.chipnuts.karaoke-mmd": ["mmd"],
  "application/vnd.cinderella": ["cdy"],
  "application/vnd.citationstyles.style+xml": ["csl"],
  "application/vnd.claymore": ["cla"],
  "application/vnd.cloanto.rp9": ["rp9"],
  "application/vnd.clonk.c4group": ["c4g", "c4d", "c4f", "c4p", "c4u"],
  "application/vnd.cluetrust.cartomobile-config": ["c11amc"],
  "application/vnd.cluetrust.cartomobile-config-pkg": ["c11amz"],
  "application/vnd.commonspace": ["csp"],
  "application/vnd.contact.cmsg": ["cdbcmsg"],
  "application/vnd.cosmocaller": ["cmc"],
  "application/vnd.crick.clicker": ["clkx"],
  "application/vnd.crick.clicker.keyboard": ["clkk"],
  "application/vnd.crick.clicker.palette": ["clkp"],
  "application/vnd.crick.clicker.template": ["clkt"],
  "application/vnd.crick.clicker.wordbank": ["clkw"],
  "application/vnd.criticaltools.wbs+xml": ["wbs"],
  "application/vnd.ctc-posml": ["pml"],
  "application/vnd.cups-ppd": ["ppd"],
  "application/vnd.curl.car": ["car"],
  "application/vnd.curl.pcurl": ["pcurl"],
  "application/vnd.dart": ["dart"],
  "application/vnd.data-vision.rdz": ["rdz"],
  "application/vnd.dbf": ["dbf"],
  "application/vnd.dcmp+xml": ["dcmp"],
  "application/vnd.dece.data": ["uvf", "uvvf", "uvd", "uvvd"],
  "application/vnd.dece.ttml+xml": ["uvt", "uvvt"],
  "application/vnd.dece.unspecified": ["uvx", "uvvx"],
  "application/vnd.dece.zip": ["uvz", "uvvz"],
  "application/vnd.denovo.fcselayout-link": ["fe_launch"],
  "application/vnd.dna": ["dna"],
  "application/vnd.dolby.mlp": ["mlp"],
  "application/vnd.dpgraph": ["dpg"],
  "application/vnd.dreamfactory": ["dfac"],
  "application/vnd.ds-keypoint": ["kpxx"],
  "application/vnd.dvb.ait": ["ait"],
  "application/vnd.dvb.service": ["svc"],
  "application/vnd.dynageo": ["geo"],
  "application/vnd.ecowin.chart": ["mag"],
  "application/vnd.enliven": ["nml"],
  "application/vnd.epson.esf": ["esf"],
  "application/vnd.epson.msf": ["msf"],
  "application/vnd.epson.quickanime": ["qam"],
  "application/vnd.epson.salt": ["slt"],
  "application/vnd.epson.ssf": ["ssf"],
  "application/vnd.eszigno3+xml": ["es3", "et3"],
  "application/vnd.ezpix-album": ["ez2"],
  "application/vnd.ezpix-package": ["ez3"],
  "application/vnd.fdf": ["*fdf"],
  "application/vnd.fdsn.mseed": ["mseed"],
  "application/vnd.fdsn.seed": ["seed", "dataless"],
  "application/vnd.flographit": ["gph"],
  "application/vnd.fluxtime.clip": ["ftc"],
  "application/vnd.framemaker": ["fm", "frame", "maker", "book"],
  "application/vnd.frogans.fnc": ["fnc"],
  "application/vnd.frogans.ltf": ["ltf"],
  "application/vnd.fsc.weblaunch": ["fsc"],
  "application/vnd.fujitsu.oasys": ["oas"],
  "application/vnd.fujitsu.oasys2": ["oa2"],
  "application/vnd.fujitsu.oasys3": ["oa3"],
  "application/vnd.fujitsu.oasysgp": ["fg5"],
  "application/vnd.fujitsu.oasysprs": ["bh2"],
  "application/vnd.fujixerox.ddd": ["ddd"],
  "application/vnd.fujixerox.docuworks": ["xdw"],
  "application/vnd.fujixerox.docuworks.binder": ["xbd"],
  "application/vnd.fuzzysheet": ["fzs"],
  "application/vnd.genomatix.tuxedo": ["txd"],
  "application/vnd.geogebra.file": ["ggb"],
  "application/vnd.geogebra.slides": ["ggs"],
  "application/vnd.geogebra.tool": ["ggt"],
  "application/vnd.geometry-explorer": ["gex", "gre"],
  "application/vnd.geonext": ["gxt"],
  "application/vnd.geoplan": ["g2w"],
  "application/vnd.geospace": ["g3w"],
  "application/vnd.gmx": ["gmx"],
  "application/vnd.google-apps.document": ["gdoc"],
  "application/vnd.google-apps.drawing": ["gdraw"],
  "application/vnd.google-apps.form": ["gform"],
  "application/vnd.google-apps.jam": ["gjam"],
  "application/vnd.google-apps.map": ["gmap"],
  "application/vnd.google-apps.presentation": ["gslides"],
  "application/vnd.google-apps.script": ["gscript"],
  "application/vnd.google-apps.site": ["gsite"],
  "application/vnd.google-apps.spreadsheet": ["gsheet"],
  "application/vnd.google-earth.kml+xml": ["kml"],
  "application/vnd.google-earth.kmz": ["kmz"],
  "application/vnd.gov.sk.xmldatacontainer+xml": ["xdcf"],
  "application/vnd.grafeq": ["gqf", "gqs"],
  "application/vnd.groove-account": ["gac"],
  "application/vnd.groove-help": ["ghf"],
  "application/vnd.groove-identity-message": ["gim"],
  "application/vnd.groove-injector": ["grv"],
  "application/vnd.groove-tool-message": ["gtm"],
  "application/vnd.groove-tool-template": ["tpl"],
  "application/vnd.groove-vcard": ["vcg"],
  "application/vnd.hal+xml": ["hal"],
  "application/vnd.handheld-entertainment+xml": ["zmm"],
  "application/vnd.hbci": ["hbci"],
  "application/vnd.hhe.lesson-player": ["les"],
  "application/vnd.hp-hpgl": ["hpgl"],
  "application/vnd.hp-hpid": ["hpid"],
  "application/vnd.hp-hps": ["hps"],
  "application/vnd.hp-jlyt": ["jlt"],
  "application/vnd.hp-pcl": ["pcl"],
  "application/vnd.hp-pclxl": ["pclxl"],
  "application/vnd.hydrostatix.sof-data": ["sfd-hdstx"],
  "application/vnd.ibm.minipay": ["mpy"],
  "application/vnd.ibm.modcap": ["afp", "listafp", "list3820"],
  "application/vnd.ibm.rights-management": ["irm"],
  "application/vnd.ibm.secure-container": ["sc"],
  "application/vnd.iccprofile": ["icc", "icm"],
  "application/vnd.igloader": ["igl"],
  "application/vnd.immervision-ivp": ["ivp"],
  "application/vnd.immervision-ivu": ["ivu"],
  "application/vnd.insors.igm": ["igm"],
  "application/vnd.intercon.formnet": ["xpw", "xpx"],
  "application/vnd.intergeo": ["i2g"],
  "application/vnd.intu.qbo": ["qbo"],
  "application/vnd.intu.qfx": ["qfx"],
  "application/vnd.ipunplugged.rcprofile": ["rcprofile"],
  "application/vnd.irepository.package+xml": ["irp"],
  "application/vnd.is-xpr": ["xpr"],
  "application/vnd.isac.fcs": ["fcs"],
  "application/vnd.jam": ["jam"],
  "application/vnd.jcp.javame.midlet-rms": ["rms"],
  "application/vnd.jisp": ["jisp"],
  "application/vnd.joost.joda-archive": ["joda"],
  "application/vnd.kahootz": ["ktz", "ktr"],
  "application/vnd.kde.karbon": ["karbon"],
  "application/vnd.kde.kchart": ["chrt"],
  "application/vnd.kde.kformula": ["kfo"],
  "application/vnd.kde.kivio": ["flw"],
  "application/vnd.kde.kontour": ["kon"],
  "application/vnd.kde.kpresenter": ["kpr", "kpt"],
  "application/vnd.kde.kspread": ["ksp"],
  "application/vnd.kde.kword": ["kwd", "kwt"],
  "application/vnd.kenameaapp": ["htke"],
  "application/vnd.kidspiration": ["kia"],
  "application/vnd.kinar": ["kne", "knp"],
  "application/vnd.koan": ["skp", "skd", "skt", "skm"],
  "application/vnd.kodak-descriptor": ["sse"],
  "application/vnd.las.las+xml": ["lasxml"],
  "application/vnd.llamagraphics.life-balance.desktop": ["lbd"],
  "application/vnd.llamagraphics.life-balance.exchange+xml": ["lbe"],
  "application/vnd.lotus-1-2-3": ["123"],
  "application/vnd.lotus-approach": ["apr"],
  "application/vnd.lotus-freelance": ["pre"],
  "application/vnd.lotus-notes": ["nsf"],
  "application/vnd.lotus-organizer": ["org"],
  "application/vnd.lotus-screencam": ["scm"],
  "application/vnd.lotus-wordpro": ["lwp"],
  "application/vnd.macports.portpkg": ["portpkg"],
  "application/vnd.mapbox-vector-tile": ["mvt"],
  "application/vnd.mcd": ["mcd"],
  "application/vnd.medcalcdata": ["mc1"],
  "application/vnd.mediastation.cdkey": ["cdkey"],
  "application/vnd.mfer": ["mwf"],
  "application/vnd.mfmp": ["mfm"],
  "application/vnd.micrografx.flo": ["flo"],
  "application/vnd.micrografx.igx": ["igx"],
  "application/vnd.mif": ["mif"],
  "application/vnd.mobius.daf": ["daf"],
  "application/vnd.mobius.dis": ["dis"],
  "application/vnd.mobius.mbk": ["mbk"],
  "application/vnd.mobius.mqy": ["mqy"],
  "application/vnd.mobius.msl": ["msl"],
  "application/vnd.mobius.plc": ["plc"],
  "application/vnd.mobius.txf": ["txf"],
  "application/vnd.mophun.application": ["mpn"],
  "application/vnd.mophun.certificate": ["mpc"],
  "application/vnd.mozilla.xul+xml": ["xul"],
  "application/vnd.ms-artgalry": ["cil"],
  "application/vnd.ms-cab-compressed": ["cab"],
  "application/vnd.ms-excel": ["xls", "xlm", "xla", "xlc", "xlt", "xlw"],
  "application/vnd.ms-excel.addin.macroenabled.12": ["xlam"],
  "application/vnd.ms-excel.sheet.binary.macroenabled.12": ["xlsb"],
  "application/vnd.ms-excel.sheet.macroenabled.12": ["xlsm"],
  "application/vnd.ms-excel.template.macroenabled.12": ["xltm"],
  "application/vnd.ms-fontobject": ["eot"],
  "application/vnd.ms-htmlhelp": ["chm"],
  "application/vnd.ms-ims": ["ims"],
  "application/vnd.ms-lrm": ["lrm"],
  "application/vnd.ms-officetheme": ["thmx"],
  "application/vnd.ms-outlook": ["msg"],
  "application/vnd.ms-pki.seccat": ["cat"],
  "application/vnd.ms-pki.stl": ["*stl"],
  "application/vnd.ms-powerpoint": ["ppt", "pps", "pot"],
  "application/vnd.ms-powerpoint.addin.macroenabled.12": ["ppam"],
  "application/vnd.ms-powerpoint.presentation.macroenabled.12": ["pptm"],
  "application/vnd.ms-powerpoint.slide.macroenabled.12": ["sldm"],
  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": ["ppsm"],
  "application/vnd.ms-powerpoint.template.macroenabled.12": ["potm"],
  "application/vnd.ms-project": ["*mpp", "mpt"],
  "application/vnd.ms-visio.viewer": ["vdx"],
  "application/vnd.ms-word.document.macroenabled.12": ["docm"],
  "application/vnd.ms-word.template.macroenabled.12": ["dotm"],
  "application/vnd.ms-works": ["wps", "wks", "wcm", "wdb"],
  "application/vnd.ms-wpl": ["wpl"],
  "application/vnd.ms-xpsdocument": ["xps"],
  "application/vnd.mseq": ["mseq"],
  "application/vnd.musician": ["mus"],
  "application/vnd.muvee.style": ["msty"],
  "application/vnd.mynfc": ["taglet"],
  "application/vnd.nato.bindingdataobject+xml": ["bdo"],
  "application/vnd.neurolanguage.nlu": ["nlu"],
  "application/vnd.nitf": ["ntf", "nitf"],
  "application/vnd.noblenet-directory": ["nnd"],
  "application/vnd.noblenet-sealer": ["nns"],
  "application/vnd.noblenet-web": ["nnw"],
  "application/vnd.nokia.n-gage.ac+xml": ["*ac"],
  "application/vnd.nokia.n-gage.data": ["ngdat"],
  "application/vnd.nokia.n-gage.symbian.install": ["n-gage"],
  "application/vnd.nokia.radio-preset": ["rpst"],
  "application/vnd.nokia.radio-presets": ["rpss"],
  "application/vnd.novadigm.edm": ["edm"],
  "application/vnd.novadigm.edx": ["edx"],
  "application/vnd.novadigm.ext": ["ext"],
  "application/vnd.oasis.opendocument.chart": ["odc"],
  "application/vnd.oasis.opendocument.chart-template": ["otc"],
  "application/vnd.oasis.opendocument.database": ["odb"],
  "application/vnd.oasis.opendocument.formula": ["odf"],
  "application/vnd.oasis.opendocument.formula-template": ["odft"],
  "application/vnd.oasis.opendocument.graphics": ["odg"],
  "application/vnd.oasis.opendocument.graphics-template": ["otg"],
  "application/vnd.oasis.opendocument.image": ["odi"],
  "application/vnd.oasis.opendocument.image-template": ["oti"],
  "application/vnd.oasis.opendocument.presentation": ["odp"],
  "application/vnd.oasis.opendocument.presentation-template": ["otp"],
  "application/vnd.oasis.opendocument.spreadsheet": ["ods"],
  "application/vnd.oasis.opendocument.spreadsheet-template": ["ots"],
  "application/vnd.oasis.opendocument.text": ["odt"],
  "application/vnd.oasis.opendocument.text-master": ["odm"],
  "application/vnd.oasis.opendocument.text-template": ["ott"],
  "application/vnd.oasis.opendocument.text-web": ["oth"],
  "application/vnd.olpc-sugar": ["xo"],
  "application/vnd.oma.dd2+xml": ["dd2"],
  "application/vnd.openblox.game+xml": ["obgx"],
  "application/vnd.openofficeorg.extension": ["oxt"],
  "application/vnd.openstreetmap.data+xml": ["osm"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    "pptx"
  ],
  "application/vnd.openxmlformats-officedocument.presentationml.slide": [
    "sldx"
  ],
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": [
    "ppsx"
  ],
  "application/vnd.openxmlformats-officedocument.presentationml.template": [
    "potx"
  ],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ["xlsx"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
    "xltx"
  ],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    "docx"
  ],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [
    "dotx"
  ],
  "application/vnd.osgeo.mapguide.package": ["mgp"],
  "application/vnd.osgi.dp": ["dp"],
  "application/vnd.osgi.subsystem": ["esa"],
  "application/vnd.palm": ["pdb", "pqa", "oprc"],
  "application/vnd.pawaafile": ["paw"],
  "application/vnd.pg.format": ["str"],
  "application/vnd.pg.osasli": ["ei6"],
  "application/vnd.picsel": ["efif"],
  "application/vnd.pmi.widget": ["wg"],
  "application/vnd.pocketlearn": ["plf"],
  "application/vnd.powerbuilder6": ["pbd"],
  "application/vnd.previewsystems.box": ["box"],
  "application/vnd.procrate.brushset": ["brushset"],
  "application/vnd.procreate.brush": ["brush"],
  "application/vnd.procreate.dream": ["drm"],
  "application/vnd.proteus.magazine": ["mgz"],
  "application/vnd.publishare-delta-tree": ["qps"],
  "application/vnd.pvi.ptid1": ["ptid"],
  "application/vnd.pwg-xhtml-print+xml": ["xhtm"],
  "application/vnd.quark.quarkxpress": [
    "qxd",
    "qxt",
    "qwd",
    "qwt",
    "qxl",
    "qxb"
  ],
  "application/vnd.rar": ["rar"],
  "application/vnd.realvnc.bed": ["bed"],
  "application/vnd.recordare.musicxml": ["mxl"],
  "application/vnd.recordare.musicxml+xml": ["musicxml"],
  "application/vnd.rig.cryptonote": ["cryptonote"],
  "application/vnd.rim.cod": ["cod"],
  "application/vnd.rn-realmedia": ["rm"],
  "application/vnd.rn-realmedia-vbr": ["rmvb"],
  "application/vnd.route66.link66+xml": ["link66"],
  "application/vnd.sailingtracker.track": ["st"],
  "application/vnd.seemail": ["see"],
  "application/vnd.sema": ["sema"],
  "application/vnd.semd": ["semd"],
  "application/vnd.semf": ["semf"],
  "application/vnd.shana.informed.formdata": ["ifm"],
  "application/vnd.shana.informed.formtemplate": ["itp"],
  "application/vnd.shana.informed.interchange": ["iif"],
  "application/vnd.shana.informed.package": ["ipk"],
  "application/vnd.simtech-mindmapper": ["twd", "twds"],
  "application/vnd.smaf": ["mmf"],
  "application/vnd.smart.teacher": ["teacher"],
  "application/vnd.software602.filler.form+xml": ["fo"],
  "application/vnd.solent.sdkm+xml": ["sdkm", "sdkd"],
  "application/vnd.spotfire.dxp": ["dxp"],
  "application/vnd.spotfire.sfs": ["sfs"],
  "application/vnd.stardivision.calc": ["sdc"],
  "application/vnd.stardivision.draw": ["sda"],
  "application/vnd.stardivision.impress": ["sdd"],
  "application/vnd.stardivision.math": ["smf"],
  "application/vnd.stardivision.writer": ["sdw", "vor"],
  "application/vnd.stardivision.writer-global": ["sgl"],
  "application/vnd.stepmania.package": ["smzip"],
  "application/vnd.stepmania.stepchart": ["sm"],
  "application/vnd.sun.wadl+xml": ["wadl"],
  "application/vnd.sun.xml.calc": ["sxc"],
  "application/vnd.sun.xml.calc.template": ["stc"],
  "application/vnd.sun.xml.draw": ["sxd"],
  "application/vnd.sun.xml.draw.template": ["std"],
  "application/vnd.sun.xml.impress": ["sxi"],
  "application/vnd.sun.xml.impress.template": ["sti"],
  "application/vnd.sun.xml.math": ["sxm"],
  "application/vnd.sun.xml.writer": ["sxw"],
  "application/vnd.sun.xml.writer.global": ["sxg"],
  "application/vnd.sun.xml.writer.template": ["stw"],
  "application/vnd.sus-calendar": ["sus", "susp"],
  "application/vnd.svd": ["svd"],
  "application/vnd.symbian.install": ["sis", "sisx"],
  "application/vnd.syncml+xml": ["xsm"],
  "application/vnd.syncml.dm+wbxml": ["bdm"],
  "application/vnd.syncml.dm+xml": ["xdm"],
  "application/vnd.syncml.dmddf+xml": ["ddf"],
  "application/vnd.tao.intent-module-archive": ["tao"],
  "application/vnd.tcpdump.pcap": ["pcap", "cap", "dmp"],
  "application/vnd.tmobile-livetv": ["tmo"],
  "application/vnd.trid.tpt": ["tpt"],
  "application/vnd.triscape.mxs": ["mxs"],
  "application/vnd.trueapp": ["tra"],
  "application/vnd.ufdl": ["ufd", "ufdl"],
  "application/vnd.uiq.theme": ["utz"],
  "application/vnd.umajin": ["umj"],
  "application/vnd.unity": ["unityweb"],
  "application/vnd.uoml+xml": ["uoml", "uo"],
  "application/vnd.vcx": ["vcx"],
  "application/vnd.visio": ["vsd", "vst", "vss", "vsw", "vsdx", "vtx"],
  "application/vnd.visionary": ["vis"],
  "application/vnd.vsf": ["vsf"],
  "application/vnd.wap.wbxml": ["wbxml"],
  "application/vnd.wap.wmlc": ["wmlc"],
  "application/vnd.wap.wmlscriptc": ["wmlsc"],
  "application/vnd.webturbo": ["wtb"],
  "application/vnd.wolfram.player": ["nbp"],
  "application/vnd.wordperfect": ["wpd"],
  "application/vnd.wqd": ["wqd"],
  "application/vnd.wt.stf": ["stf"],
  "application/vnd.xara": ["xar"],
  "application/vnd.xfdl": ["xfdl"],
  "application/vnd.yamaha.hv-dic": ["hvd"],
  "application/vnd.yamaha.hv-script": ["hvs"],
  "application/vnd.yamaha.hv-voice": ["hvp"],
  "application/vnd.yamaha.openscoreformat": ["osf"],
  "application/vnd.yamaha.openscoreformat.osfpvg+xml": ["osfpvg"],
  "application/vnd.yamaha.smaf-audio": ["saf"],
  "application/vnd.yamaha.smaf-phrase": ["spf"],
  "application/vnd.yellowriver-custom-menu": ["cmp"],
  "application/vnd.zul": ["zir", "zirz"],
  "application/vnd.zzazz.deck+xml": ["zaz"],
  "application/x-7z-compressed": ["7z"],
  "application/x-abiword": ["abw"],
  "application/x-ace-compressed": ["ace"],
  "application/x-apple-diskimage": ["*dmg"],
  "application/x-arj": ["arj"],
  "application/x-authorware-bin": ["aab", "x32", "u32", "vox"],
  "application/x-authorware-map": ["aam"],
  "application/x-authorware-seg": ["aas"],
  "application/x-bcpio": ["bcpio"],
  "application/x-bdoc": ["*bdoc"],
  "application/x-bittorrent": ["torrent"],
  "application/x-blender": ["blend"],
  "application/x-blorb": ["blb", "blorb"],
  "application/x-bzip": ["bz"],
  "application/x-bzip2": ["bz2", "boz"],
  "application/x-cbr": ["cbr", "cba", "cbt", "cbz", "cb7"],
  "application/x-cdlink": ["vcd"],
  "application/x-cfs-compressed": ["cfs"],
  "application/x-chat": ["chat"],
  "application/x-chess-pgn": ["pgn"],
  "application/x-chrome-extension": ["crx"],
  "application/x-cocoa": ["cco"],
  "application/x-compressed": ["*rar"],
  "application/x-conference": ["nsc"],
  "application/x-cpio": ["cpio"],
  "application/x-csh": ["csh"],
  "application/x-debian-package": ["*deb", "udeb"],
  "application/x-dgc-compressed": ["dgc"],
  "application/x-director": [
    "dir",
    "dcr",
    "dxr",
    "cst",
    "cct",
    "cxt",
    "w3d",
    "fgd",
    "swa"
  ],
  "application/x-doom": ["wad"],
  "application/x-dtbncx+xml": ["ncx"],
  "application/x-dtbook+xml": ["dtb"],
  "application/x-dtbresource+xml": ["res"],
  "application/x-dvi": ["dvi"],
  "application/x-envoy": ["evy"],
  "application/x-eva": ["eva"],
  "application/x-font-bdf": ["bdf"],
  "application/x-font-ghostscript": ["gsf"],
  "application/x-font-linux-psf": ["psf"],
  "application/x-font-pcf": ["pcf"],
  "application/x-font-snf": ["snf"],
  "application/x-font-type1": ["pfa", "pfb", "pfm", "afm"],
  "application/x-freearc": ["arc"],
  "application/x-futuresplash": ["spl"],
  "application/x-gca-compressed": ["gca"],
  "application/x-glulx": ["ulx"],
  "application/x-gnumeric": ["gnumeric"],
  "application/x-gramps-xml": ["gramps"],
  "application/x-gtar": ["gtar"],
  "application/x-hdf": ["hdf"],
  "application/x-httpd-php": ["php"],
  "application/x-install-instructions": ["install"],
  "application/x-ipynb+json": ["ipynb"],
  "application/x-iso9660-image": ["*iso"],
  "application/x-iwork-keynote-sffkey": ["*key"],
  "application/x-iwork-numbers-sffnumbers": ["*numbers"],
  "application/x-iwork-pages-sffpages": ["*pages"],
  "application/x-java-archive-diff": ["jardiff"],
  "application/x-java-jnlp-file": ["jnlp"],
  "application/x-keepass2": ["kdbx"],
  "application/x-latex": ["latex"],
  "application/x-lua-bytecode": ["luac"],
  "application/x-lzh-compressed": ["lzh", "lha"],
  "application/x-makeself": ["run"],
  "application/x-mie": ["mie"],
  "application/x-mobipocket-ebook": ["*prc", "mobi"],
  "application/x-ms-application": ["application"],
  "application/x-ms-shortcut": ["lnk"],
  "application/x-ms-wmd": ["wmd"],
  "application/x-ms-wmz": ["wmz"],
  "application/x-ms-xbap": ["xbap"],
  "application/x-msaccess": ["mdb"],
  "application/x-msbinder": ["obd"],
  "application/x-mscardfile": ["crd"],
  "application/x-msclip": ["clp"],
  "application/x-msdos-program": ["*exe"],
  "application/x-msdownload": ["*exe", "*dll", "com", "bat", "*msi"],
  "application/x-msmediaview": ["mvb", "m13", "m14"],
  "application/x-msmetafile": ["*wmf", "*wmz", "*emf", "emz"],
  "application/x-msmoney": ["mny"],
  "application/x-mspublisher": ["pub"],
  "application/x-msschedule": ["scd"],
  "application/x-msterminal": ["trm"],
  "application/x-mswrite": ["wri"],
  "application/x-netcdf": ["nc", "cdf"],
  "application/x-ns-proxy-autoconfig": ["pac"],
  "application/x-nzb": ["nzb"],
  "application/x-perl": ["pl", "pm"],
  "application/x-pilot": ["*prc", "*pdb"],
  "application/x-pkcs12": ["p12", "pfx"],
  "application/x-pkcs7-certificates": ["p7b", "spc"],
  "application/x-pkcs7-certreqresp": ["p7r"],
  "application/x-rar-compressed": ["*rar"],
  "application/x-redhat-package-manager": ["rpm"],
  "application/x-research-info-systems": ["ris"],
  "application/x-sea": ["sea"],
  "application/x-sh": ["sh"],
  "application/x-shar": ["shar"],
  "application/x-shockwave-flash": ["swf"],
  "application/x-silverlight-app": ["xap"],
  "application/x-sql": ["*sql"],
  "application/x-stuffit": ["sit"],
  "application/x-stuffitx": ["sitx"],
  "application/x-subrip": ["srt"],
  "application/x-sv4cpio": ["sv4cpio"],
  "application/x-sv4crc": ["sv4crc"],
  "application/x-t3vm-image": ["t3"],
  "application/x-tads": ["gam"],
  "application/x-tar": ["tar"],
  "application/x-tcl": ["tcl", "tk"],
  "application/x-tex": ["tex"],
  "application/x-tex-tfm": ["tfm"],
  "application/x-texinfo": ["texinfo", "texi"],
  "application/x-tgif": ["*obj"],
  "application/x-ustar": ["ustar"],
  "application/x-virtualbox-hdd": ["hdd"],
  "application/x-virtualbox-ova": ["ova"],
  "application/x-virtualbox-ovf": ["ovf"],
  "application/x-virtualbox-vbox": ["vbox"],
  "application/x-virtualbox-vbox-extpack": ["vbox-extpack"],
  "application/x-virtualbox-vdi": ["vdi"],
  "application/x-virtualbox-vhd": ["vhd"],
  "application/x-virtualbox-vmdk": ["vmdk"],
  "application/x-wais-source": ["src"],
  "application/x-web-app-manifest+json": ["webapp"],
  "application/x-x509-ca-cert": ["der", "crt", "pem"],
  "application/x-xfig": ["fig"],
  "application/x-xliff+xml": ["*xlf"],
  "application/x-xpinstall": ["xpi"],
  "application/x-xz": ["xz"],
  "application/x-zip-compressed": ["*zip"],
  "application/x-zmachine": ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"],
  "audio/vnd.dece.audio": ["uva", "uvva"],
  "audio/vnd.digital-winds": ["eol"],
  "audio/vnd.dra": ["dra"],
  "audio/vnd.dts": ["dts"],
  "audio/vnd.dts.hd": ["dtshd"],
  "audio/vnd.lucent.voice": ["lvp"],
  "audio/vnd.ms-playready.media.pya": ["pya"],
  "audio/vnd.nuera.ecelp4800": ["ecelp4800"],
  "audio/vnd.nuera.ecelp7470": ["ecelp7470"],
  "audio/vnd.nuera.ecelp9600": ["ecelp9600"],
  "audio/vnd.rip": ["rip"],
  "audio/x-aac": ["*aac"],
  "audio/x-aiff": ["aif", "aiff", "aifc"],
  "audio/x-caf": ["caf"],
  "audio/x-flac": ["flac"],
  "audio/x-m4a": ["*m4a"],
  "audio/x-matroska": ["mka"],
  "audio/x-mpegurl": ["m3u"],
  "audio/x-ms-wax": ["wax"],
  "audio/x-ms-wma": ["wma"],
  "audio/x-pn-realaudio": ["ram", "ra"],
  "audio/x-pn-realaudio-plugin": ["rmp"],
  "audio/x-realaudio": ["*ra"],
  "audio/x-wav": ["*wav"],
  "chemical/x-cdx": ["cdx"],
  "chemical/x-cif": ["cif"],
  "chemical/x-cmdf": ["cmdf"],
  "chemical/x-cml": ["cml"],
  "chemical/x-csml": ["csml"],
  "chemical/x-xyz": ["xyz"],
  "image/prs.btif": ["btif", "btf"],
  "image/prs.pti": ["pti"],
  "image/vnd.adobe.photoshop": ["psd"],
  "image/vnd.airzip.accelerator.azv": ["azv"],
  "image/vnd.dece.graphic": ["uvi", "uvvi", "uvg", "uvvg"],
  "image/vnd.djvu": ["djvu", "djv"],
  "image/vnd.dvb.subtitle": ["*sub"],
  "image/vnd.dwg": ["dwg"],
  "image/vnd.dxf": ["dxf"],
  "image/vnd.fastbidsheet": ["fbs"],
  "image/vnd.fpx": ["fpx"],
  "image/vnd.fst": ["fst"],
  "image/vnd.fujixerox.edmics-mmr": ["mmr"],
  "image/vnd.fujixerox.edmics-rlc": ["rlc"],
  "image/vnd.microsoft.icon": ["ico"],
  "image/vnd.ms-dds": ["dds"],
  "image/vnd.ms-modi": ["mdi"],
  "image/vnd.ms-photo": ["wdp"],
  "image/vnd.net-fpx": ["npx"],
  "image/vnd.pco.b16": ["b16"],
  "image/vnd.tencent.tap": ["tap"],
  "image/vnd.valve.source.texture": ["vtf"],
  "image/vnd.wap.wbmp": ["wbmp"],
  "image/vnd.xiff": ["xif"],
  "image/vnd.zbrush.pcx": ["pcx"],
  "image/x-3ds": ["3ds"],
  "image/x-adobe-dng": ["dng"],
  "image/x-cmu-raster": ["ras"],
  "image/x-cmx": ["cmx"],
  "image/x-freehand": ["fh", "fhc", "fh4", "fh5", "fh7"],
  "image/x-icon": ["*ico"],
  "image/x-jng": ["jng"],
  "image/x-mrsid-image": ["sid"],
  "image/x-ms-bmp": ["*bmp"],
  "image/x-pcx": ["*pcx"],
  "image/x-pict": ["pic", "pct"],
  "image/x-portable-anymap": ["pnm"],
  "image/x-portable-bitmap": ["pbm"],
  "image/x-portable-graymap": ["pgm"],
  "image/x-portable-pixmap": ["ppm"],
  "image/x-rgb": ["rgb"],
  "image/x-tga": ["tga"],
  "image/x-xbitmap": ["xbm"],
  "image/x-xpixmap": ["xpm"],
  "image/x-xwindowdump": ["xwd"],
  "message/vnd.wfa.wsc": ["wsc"],
  "model/vnd.bary": ["bary"],
  "model/vnd.cld": ["cld"],
  "model/vnd.collada+xml": ["dae"],
  "model/vnd.dwf": ["dwf"],
  "model/vnd.gdl": ["gdl"],
  "model/vnd.gtw": ["gtw"],
  "model/vnd.mts": ["*mts"],
  "model/vnd.opengex": ["ogex"],
  "model/vnd.parasolid.transmit.binary": ["x_b"],
  "model/vnd.parasolid.transmit.text": ["x_t"],
  "model/vnd.pytha.pyox": ["pyo", "pyox"],
  "model/vnd.sap.vds": ["vds"],
  "model/vnd.usda": ["usda"],
  "model/vnd.usdz+zip": ["usdz"],
  "model/vnd.valve.source.compiled-map": ["bsp"],
  "model/vnd.vtu": ["vtu"],
  "text/prs.lines.tag": ["dsc"],
  "text/vnd.curl": ["curl"],
  "text/vnd.curl.dcurl": ["dcurl"],
  "text/vnd.curl.mcurl": ["mcurl"],
  "text/vnd.curl.scurl": ["scurl"],
  "text/vnd.dvb.subtitle": ["sub"],
  "text/vnd.familysearch.gedcom": ["ged"],
  "text/vnd.fly": ["fly"],
  "text/vnd.fmi.flexstor": ["flx"],
  "text/vnd.graphviz": ["gv"],
  "text/vnd.in3d.3dml": ["3dml"],
  "text/vnd.in3d.spot": ["spot"],
  "text/vnd.sun.j2me.app-descriptor": ["jad"],
  "text/vnd.wap.wml": ["wml"],
  "text/vnd.wap.wmlscript": ["wmls"],
  "text/x-asm": ["s", "asm"],
  "text/x-c": ["c", "cc", "cxx", "cpp", "h", "hh", "dic"],
  "text/x-component": ["htc"],
  "text/x-fortran": ["f", "for", "f77", "f90"],
  "text/x-handlebars-template": ["hbs"],
  "text/x-java-source": ["java"],
  "text/x-lua": ["lua"],
  "text/x-markdown": ["mkd"],
  "text/x-nfo": ["nfo"],
  "text/x-opml": ["opml"],
  "text/x-org": ["*org"],
  "text/x-pascal": ["p", "pas"],
  "text/x-processing": ["pde"],
  "text/x-sass": ["sass"],
  "text/x-scss": ["scss"],
  "text/x-setext": ["etx"],
  "text/x-sfv": ["sfv"],
  "text/x-suse-ymp": ["ymp"],
  "text/x-uuencode": ["uu"],
  "text/x-vcalendar": ["vcs"],
  "text/x-vcard": ["vcf"],
  "video/vnd.dece.hd": ["uvh", "uvvh"],
  "video/vnd.dece.mobile": ["uvm", "uvvm"],
  "video/vnd.dece.pd": ["uvp", "uvvp"],
  "video/vnd.dece.sd": ["uvs", "uvvs"],
  "video/vnd.dece.video": ["uvv", "uvvv"],
  "video/vnd.dvb.file": ["dvb"],
  "video/vnd.fvt": ["fvt"],
  "video/vnd.mpegurl": ["mxu", "m4u"],
  "video/vnd.ms-playready.media.pyv": ["pyv"],
  "video/vnd.uvvu.mp4": ["uvu", "uvvu"],
  "video/vnd.vivo": ["viv"],
  "video/x-f4v": ["f4v"],
  "video/x-fli": ["fli"],
  "video/x-flv": ["flv"],
  "video/x-m4v": ["m4v"],
  "video/x-matroska": ["mkv", "mk3d", "mks"],
  "video/x-mng": ["mng"],
  "video/x-ms-asf": ["asf", "asx"],
  "video/x-ms-vob": ["vob"],
  "video/x-ms-wm": ["wm"],
  "video/x-ms-wmv": ["wmv"],
  "video/x-ms-wmx": ["wmx"],
  "video/x-ms-wvx": ["wvx"],
  "video/x-msvideo": ["avi"],
  "video/x-sgi-movie": ["movie"],
  "video/x-smv": ["smv"],
  "x-conference/x-cooltalk": ["ice"]
};
Object.freeze(types$1);
const types = {
  "application/andrew-inset": ["ez"],
  "application/appinstaller": ["appinstaller"],
  "application/applixware": ["aw"],
  "application/appx": ["appx"],
  "application/appxbundle": ["appxbundle"],
  "application/atom+xml": ["atom"],
  "application/atomcat+xml": ["atomcat"],
  "application/atomdeleted+xml": ["atomdeleted"],
  "application/atomsvc+xml": ["atomsvc"],
  "application/atsc-dwd+xml": ["dwd"],
  "application/atsc-held+xml": ["held"],
  "application/atsc-rsat+xml": ["rsat"],
  "application/automationml-aml+xml": ["aml"],
  "application/automationml-amlx+zip": ["amlx"],
  "application/bdoc": ["bdoc"],
  "application/calendar+xml": ["xcs"],
  "application/ccxml+xml": ["ccxml"],
  "application/cdfx+xml": ["cdfx"],
  "application/cdmi-capability": ["cdmia"],
  "application/cdmi-container": ["cdmic"],
  "application/cdmi-domain": ["cdmid"],
  "application/cdmi-object": ["cdmio"],
  "application/cdmi-queue": ["cdmiq"],
  "application/cpl+xml": ["cpl"],
  "application/cu-seeme": ["cu"],
  "application/cwl": ["cwl"],
  "application/dash+xml": ["mpd"],
  "application/dash-patch+xml": ["mpp"],
  "application/davmount+xml": ["davmount"],
  "application/dicom": ["dcm"],
  "application/docbook+xml": ["dbk"],
  "application/dssc+der": ["dssc"],
  "application/dssc+xml": ["xdssc"],
  "application/ecmascript": ["ecma"],
  "application/emma+xml": ["emma"],
  "application/emotionml+xml": ["emotionml"],
  "application/epub+zip": ["epub"],
  "application/exi": ["exi"],
  "application/express": ["exp"],
  "application/fdf": ["fdf"],
  "application/fdt+xml": ["fdt"],
  "application/font-tdpfr": ["pfr"],
  "application/geo+json": ["geojson"],
  "application/gml+xml": ["gml"],
  "application/gpx+xml": ["gpx"],
  "application/gxf": ["gxf"],
  "application/gzip": ["gz"],
  "application/hjson": ["hjson"],
  "application/hyperstudio": ["stk"],
  "application/inkml+xml": ["ink", "inkml"],
  "application/ipfix": ["ipfix"],
  "application/its+xml": ["its"],
  "application/java-archive": ["jar", "war", "ear"],
  "application/java-serialized-object": ["ser"],
  "application/java-vm": ["class"],
  "application/javascript": ["*js"],
  "application/json": ["json", "map"],
  "application/json5": ["json5"],
  "application/jsonml+json": ["jsonml"],
  "application/ld+json": ["jsonld"],
  "application/lgr+xml": ["lgr"],
  "application/lost+xml": ["lostxml"],
  "application/mac-binhex40": ["hqx"],
  "application/mac-compactpro": ["cpt"],
  "application/mads+xml": ["mads"],
  "application/manifest+json": ["webmanifest"],
  "application/marc": ["mrc"],
  "application/marcxml+xml": ["mrcx"],
  "application/mathematica": ["ma", "nb", "mb"],
  "application/mathml+xml": ["mathml"],
  "application/mbox": ["mbox"],
  "application/media-policy-dataset+xml": ["mpf"],
  "application/mediaservercontrol+xml": ["mscml"],
  "application/metalink+xml": ["metalink"],
  "application/metalink4+xml": ["meta4"],
  "application/mets+xml": ["mets"],
  "application/mmt-aei+xml": ["maei"],
  "application/mmt-usd+xml": ["musd"],
  "application/mods+xml": ["mods"],
  "application/mp21": ["m21", "mp21"],
  "application/mp4": ["*mp4", "*mpg4", "mp4s", "m4p"],
  "application/msix": ["msix"],
  "application/msixbundle": ["msixbundle"],
  "application/msword": ["doc", "dot"],
  "application/mxf": ["mxf"],
  "application/n-quads": ["nq"],
  "application/n-triples": ["nt"],
  "application/node": ["cjs"],
  "application/octet-stream": [
    "bin",
    "dms",
    "lrf",
    "mar",
    "so",
    "dist",
    "distz",
    "pkg",
    "bpk",
    "dump",
    "elc",
    "deploy",
    "exe",
    "dll",
    "deb",
    "dmg",
    "iso",
    "img",
    "msi",
    "msp",
    "msm",
    "buffer"
  ],
  "application/oda": ["oda"],
  "application/oebps-package+xml": ["opf"],
  "application/ogg": ["ogx"],
  "application/omdoc+xml": ["omdoc"],
  "application/onenote": [
    "onetoc",
    "onetoc2",
    "onetmp",
    "onepkg",
    "one",
    "onea"
  ],
  "application/oxps": ["oxps"],
  "application/p2p-overlay+xml": ["relo"],
  "application/patch-ops-error+xml": ["xer"],
  "application/pdf": ["pdf"],
  "application/pgp-encrypted": ["pgp"],
  "application/pgp-keys": ["asc"],
  "application/pgp-signature": ["sig", "*asc"],
  "application/pics-rules": ["prf"],
  "application/pkcs10": ["p10"],
  "application/pkcs7-mime": ["p7m", "p7c"],
  "application/pkcs7-signature": ["p7s"],
  "application/pkcs8": ["p8"],
  "application/pkix-attr-cert": ["ac"],
  "application/pkix-cert": ["cer"],
  "application/pkix-crl": ["crl"],
  "application/pkix-pkipath": ["pkipath"],
  "application/pkixcmp": ["pki"],
  "application/pls+xml": ["pls"],
  "application/postscript": ["ai", "eps", "ps"],
  "application/provenance+xml": ["provx"],
  "application/pskc+xml": ["pskcxml"],
  "application/raml+yaml": ["raml"],
  "application/rdf+xml": ["rdf", "owl"],
  "application/reginfo+xml": ["rif"],
  "application/relax-ng-compact-syntax": ["rnc"],
  "application/resource-lists+xml": ["rl"],
  "application/resource-lists-diff+xml": ["rld"],
  "application/rls-services+xml": ["rs"],
  "application/route-apd+xml": ["rapd"],
  "application/route-s-tsid+xml": ["sls"],
  "application/route-usd+xml": ["rusd"],
  "application/rpki-ghostbusters": ["gbr"],
  "application/rpki-manifest": ["mft"],
  "application/rpki-roa": ["roa"],
  "application/rsd+xml": ["rsd"],
  "application/rss+xml": ["rss"],
  "application/rtf": ["rtf"],
  "application/sbml+xml": ["sbml"],
  "application/scvp-cv-request": ["scq"],
  "application/scvp-cv-response": ["scs"],
  "application/scvp-vp-request": ["spq"],
  "application/scvp-vp-response": ["spp"],
  "application/sdp": ["sdp"],
  "application/senml+xml": ["senmlx"],
  "application/sensml+xml": ["sensmlx"],
  "application/set-payment-initiation": ["setpay"],
  "application/set-registration-initiation": ["setreg"],
  "application/shf+xml": ["shf"],
  "application/sieve": ["siv", "sieve"],
  "application/smil+xml": ["smi", "smil"],
  "application/sparql-query": ["rq"],
  "application/sparql-results+xml": ["srx"],
  "application/sql": ["sql"],
  "application/srgs": ["gram"],
  "application/srgs+xml": ["grxml"],
  "application/sru+xml": ["sru"],
  "application/ssdl+xml": ["ssdl"],
  "application/ssml+xml": ["ssml"],
  "application/swid+xml": ["swidtag"],
  "application/tei+xml": ["tei", "teicorpus"],
  "application/thraud+xml": ["tfi"],
  "application/timestamped-data": ["tsd"],
  "application/toml": ["toml"],
  "application/trig": ["trig"],
  "application/ttml+xml": ["ttml"],
  "application/ubjson": ["ubj"],
  "application/urc-ressheet+xml": ["rsheet"],
  "application/urc-targetdesc+xml": ["td"],
  "application/voicexml+xml": ["vxml"],
  "application/wasm": ["wasm"],
  "application/watcherinfo+xml": ["wif"],
  "application/widget": ["wgt"],
  "application/winhlp": ["hlp"],
  "application/wsdl+xml": ["wsdl"],
  "application/wspolicy+xml": ["wspolicy"],
  "application/xaml+xml": ["xaml"],
  "application/xcap-att+xml": ["xav"],
  "application/xcap-caps+xml": ["xca"],
  "application/xcap-diff+xml": ["xdf"],
  "application/xcap-el+xml": ["xel"],
  "application/xcap-ns+xml": ["xns"],
  "application/xenc+xml": ["xenc"],
  "application/xfdf": ["xfdf"],
  "application/xhtml+xml": ["xhtml", "xht"],
  "application/xliff+xml": ["xlf"],
  "application/xml": ["xml", "xsl", "xsd", "rng"],
  "application/xml-dtd": ["dtd"],
  "application/xop+xml": ["xop"],
  "application/xproc+xml": ["xpl"],
  "application/xslt+xml": ["*xsl", "xslt"],
  "application/xspf+xml": ["xspf"],
  "application/xv+xml": ["mxml", "xhvml", "xvml", "xvm"],
  "application/yang": ["yang"],
  "application/yin+xml": ["yin"],
  "application/zip": ["zip"],
  "application/zip+dotlottie": ["lottie"],
  "audio/3gpp": ["*3gpp"],
  "audio/aac": ["adts", "aac"],
  "audio/adpcm": ["adp"],
  "audio/amr": ["amr"],
  "audio/basic": ["au", "snd"],
  "audio/midi": ["mid", "midi", "kar", "rmi"],
  "audio/mobile-xmf": ["mxmf"],
  "audio/mp3": ["*mp3"],
  "audio/mp4": ["m4a", "mp4a", "m4b"],
  "audio/mpeg": ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"],
  "audio/ogg": ["oga", "ogg", "spx", "opus"],
  "audio/s3m": ["s3m"],
  "audio/silk": ["sil"],
  "audio/wav": ["wav"],
  "audio/wave": ["*wav"],
  "audio/webm": ["weba"],
  "audio/xm": ["xm"],
  "font/collection": ["ttc"],
  "font/otf": ["otf"],
  "font/ttf": ["ttf"],
  "font/woff": ["woff"],
  "font/woff2": ["woff2"],
  "image/aces": ["exr"],
  "image/apng": ["apng"],
  "image/avci": ["avci"],
  "image/avcs": ["avcs"],
  "image/avif": ["avif"],
  "image/bmp": ["bmp", "dib"],
  "image/cgm": ["cgm"],
  "image/dicom-rle": ["drle"],
  "image/dpx": ["dpx"],
  "image/emf": ["emf"],
  "image/fits": ["fits"],
  "image/g3fax": ["g3"],
  "image/gif": ["gif"],
  "image/heic": ["heic"],
  "image/heic-sequence": ["heics"],
  "image/heif": ["heif"],
  "image/heif-sequence": ["heifs"],
  "image/hej2k": ["hej2"],
  "image/ief": ["ief"],
  "image/jaii": ["jaii"],
  "image/jais": ["jais"],
  "image/jls": ["jls"],
  "image/jp2": ["jp2", "jpg2"],
  "image/jpeg": ["jpg", "jpeg", "jpe"],
  "image/jph": ["jph"],
  "image/jphc": ["jhc"],
  "image/jpm": ["jpm", "jpgm"],
  "image/jpx": ["jpx", "jpf"],
  "image/jxl": ["jxl"],
  "image/jxr": ["jxr"],
  "image/jxra": ["jxra"],
  "image/jxrs": ["jxrs"],
  "image/jxs": ["jxs"],
  "image/jxsc": ["jxsc"],
  "image/jxsi": ["jxsi"],
  "image/jxss": ["jxss"],
  "image/ktx": ["ktx"],
  "image/ktx2": ["ktx2"],
  "image/pjpeg": ["jfif"],
  "image/png": ["png"],
  "image/sgi": ["sgi"],
  "image/svg+xml": ["svg", "svgz"],
  "image/t38": ["t38"],
  "image/tiff": ["tif", "tiff"],
  "image/tiff-fx": ["tfx"],
  "image/webp": ["webp"],
  "image/wmf": ["wmf"],
  "message/disposition-notification": ["disposition-notification"],
  "message/global": ["u8msg"],
  "message/global-delivery-status": ["u8dsn"],
  "message/global-disposition-notification": ["u8mdn"],
  "message/global-headers": ["u8hdr"],
  "message/rfc822": ["eml", "mime", "mht", "mhtml"],
  "model/3mf": ["3mf"],
  "model/gltf+json": ["gltf"],
  "model/gltf-binary": ["glb"],
  "model/iges": ["igs", "iges"],
  "model/jt": ["jt"],
  "model/mesh": ["msh", "mesh", "silo"],
  "model/mtl": ["mtl"],
  "model/obj": ["obj"],
  "model/prc": ["prc"],
  "model/step": ["step", "stp", "stpnc", "p21", "210"],
  "model/step+xml": ["stpx"],
  "model/step+zip": ["stpz"],
  "model/step-xml+zip": ["stpxz"],
  "model/stl": ["stl"],
  "model/u3d": ["u3d"],
  "model/vrml": ["wrl", "vrml"],
  "model/x3d+binary": ["*x3db", "x3dbz"],
  "model/x3d+fastinfoset": ["x3db"],
  "model/x3d+vrml": ["*x3dv", "x3dvz"],
  "model/x3d+xml": ["x3d", "x3dz"],
  "model/x3d-vrml": ["x3dv"],
  "text/cache-manifest": ["appcache", "manifest"],
  "text/calendar": ["ics", "ifb"],
  "text/coffeescript": ["coffee", "litcoffee"],
  "text/css": ["css"],
  "text/csv": ["csv"],
  "text/html": ["html", "htm", "shtml"],
  "text/jade": ["jade"],
  "text/javascript": ["js", "mjs"],
  "text/jsx": ["jsx"],
  "text/less": ["less"],
  "text/markdown": ["md", "markdown"],
  "text/mathml": ["mml"],
  "text/mdx": ["mdx"],
  "text/n3": ["n3"],
  "text/plain": ["txt", "text", "conf", "def", "list", "log", "in", "ini"],
  "text/richtext": ["rtx"],
  "text/rtf": ["*rtf"],
  "text/sgml": ["sgml", "sgm"],
  "text/shex": ["shex"],
  "text/slim": ["slim", "slm"],
  "text/spdx": ["spdx"],
  "text/stylus": ["stylus", "styl"],
  "text/tab-separated-values": ["tsv"],
  "text/troff": ["t", "tr", "roff", "man", "me", "ms"],
  "text/turtle": ["ttl"],
  "text/uri-list": ["uri", "uris", "urls"],
  "text/vcard": ["vcard"],
  "text/vtt": ["vtt"],
  "text/wgsl": ["wgsl"],
  "text/xml": ["*xml"],
  "text/yaml": ["yaml", "yml"],
  "video/3gpp": ["3gp", "3gpp"],
  "video/3gpp2": ["3g2"],
  "video/h261": ["h261"],
  "video/h263": ["h263"],
  "video/h264": ["h264"],
  "video/iso.segment": ["m4s"],
  "video/jpeg": ["jpgv"],
  "video/jpm": ["*jpm", "*jpgm"],
  "video/mj2": ["mj2", "mjp2"],
  "video/mp2t": ["ts", "m2t", "m2ts", "mts"],
  "video/mp4": ["mp4", "mp4v", "mpg4"],
  "video/mpeg": ["mpeg", "mpg", "mpe", "m1v", "m2v"],
  "video/ogg": ["ogv"],
  "video/quicktime": ["qt", "mov"],
  "video/webm": ["webm"]
};
Object.freeze(types);
var __classPrivateFieldGet = globalThis && globalThis.__classPrivateFieldGet || function(m, c, ie, we) {
  if (ie === "a" && !we)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof c == "function" ? m !== c || !we : !c.has(m))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return ie === "m" ? we : ie === "a" ? we.call(m) : we ? we.value : c.get(m);
}, _Mime_extensionToType, _Mime_typeToExtension, _Mime_typeToExtensions;
class Mime {
  constructor(...c) {
    _Mime_extensionToType.set(this, /* @__PURE__ */ new Map()), _Mime_typeToExtension.set(this, /* @__PURE__ */ new Map()), _Mime_typeToExtensions.set(this, /* @__PURE__ */ new Map());
    for (const ie of c)
      this.define(ie);
  }
  define(c, ie = !1) {
    for (let [we, $e] of Object.entries(c)) {
      we = we.toLowerCase(), $e = $e.map((ne) => ne.toLowerCase()), __classPrivateFieldGet(this, _Mime_typeToExtensions, "f").has(we) || __classPrivateFieldGet(this, _Mime_typeToExtensions, "f").set(we, /* @__PURE__ */ new Set());
      const Me = __classPrivateFieldGet(this, _Mime_typeToExtensions, "f").get(we);
      let Ze = !0;
      for (let ne of $e) {
        const rr = ne.startsWith("*");
        if (ne = rr ? ne.slice(1) : ne, Me?.add(ne), Ze && __classPrivateFieldGet(this, _Mime_typeToExtension, "f").set(we, ne), Ze = !1, rr)
          continue;
        const gr = __classPrivateFieldGet(this, _Mime_extensionToType, "f").get(ne);
        if (gr && gr != we && !ie)
          throw new Error(`"${we} -> ${ne}" conflicts with "${gr} -> ${ne}". Pass \`force=true\` to override this definition.`);
        __classPrivateFieldGet(this, _Mime_extensionToType, "f").set(ne, we);
      }
    }
    return this;
  }
  getType(c) {
    if (typeof c != "string")
      return null;
    const ie = c.replace(/^.*[/\\]/s, "").toLowerCase(), we = ie.replace(/^.*\./s, "").toLowerCase(), $e = ie.length < c.length;
    return !(we.length < ie.length - 1) && $e ? null : __classPrivateFieldGet(this, _Mime_extensionToType, "f").get(we) ?? null;
  }
  getExtension(c) {
    return typeof c != "string" ? null : (c = c?.split?.(";")[0], (c && __classPrivateFieldGet(this, _Mime_typeToExtension, "f").get(c.trim().toLowerCase())) ?? null);
  }
  getAllExtensions(c) {
    return typeof c != "string" ? null : __classPrivateFieldGet(this, _Mime_typeToExtensions, "f").get(c.toLowerCase()) ?? null;
  }
  _freeze() {
    this.define = () => {
      throw new Error("define() not allowed for built-in Mime objects. See https://github.com/broofa/mime/blob/main/README.md#custom-mime-instances");
    }, Object.freeze(this);
    for (const c of __classPrivateFieldGet(this, _Mime_typeToExtensions, "f").values())
      Object.freeze(c);
    return this;
  }
  _getTestState() {
    return {
      types: __classPrivateFieldGet(this, _Mime_extensionToType, "f"),
      extensions: __classPrivateFieldGet(this, _Mime_typeToExtension, "f")
    };
  }
}
_Mime_extensionToType = /* @__PURE__ */ new WeakMap(), _Mime_typeToExtension = /* @__PURE__ */ new WeakMap(), _Mime_typeToExtensions = /* @__PURE__ */ new WeakMap();
const mime = new Mime(types, types$1)._freeze();
function dataUrlToArrayBuffer(m) {
  const [c, ie] = m.split(",");
  if (!c || !ie)
    throw new Error("invalid data url");
  const we = atob(ie), $e = new ArrayBuffer(we.length), Me = new Uint8Array($e);
  for (let Ze = 0; Ze < we.length; Ze++)
    Me[Ze] = we.charCodeAt(Ze);
  return $e;
}
async function ensureAllImagesLoaded(m) {
  const ie = Array.from(m.querySelectorAll("image")).map((we) => {
    const $e = we.getAttributeNS("http://www.w3.org/1999/xlink", "href") || we.getAttribute("href");
    return $e?.startsWith("data:") ? new Promise((Me, Ze) => {
      const ne = new Image();
      ne.src = $e, ne.onload = () => Me(), ne.onerror = () => Ze(new Error(`Fehler beim Laden des Bildes: ${$e}`));
    }) : Promise.resolve();
  });
  await Promise.all(ie);
}
function renderSVG(m, c = "image/png", ie = "arrayBuffer", we = 150) {
  return ensureAllImagesLoaded(m).then(() => new Promise(($e, Me) => {
    const Ze = m.getAttribute("viewBox")?.split(" ").map((_r) => parseFloat(_r)) ?? [0, 0, 100, 100], ne = document.createElement("canvas");
    ne.style.position = "absolute", ne.style.top = "-1000%", ne.style.left = "-1000%", document.body.appendChild(ne), ne.width = Ze[2], ne.height = Ze[3];
    const rr = ne.getContext("2d");
    if (!rr)
      return Me(new Error("Failed to get 2d context"));
    const gr = new XMLSerializer().serializeToString(m), or = new Image();
    or.src = `data:image/svg+xml;base64,${btoa(gr)}`, or.addEventListener("load", async () => {
      if (await new Promise((_r) => setTimeout(_r, we)), rr.drawImage(or, 0, 0), ie === "arrayBuffer") {
        const _r = dataUrlToArrayBuffer(ne.toDataURL(c));
        $e(_r), document.body.removeChild(ne);
      } else
        ne.toBlob((_r) => {
          _r ? $e(_r) : Me(new Error("Failed to convert canvas to blob")), document.body.removeChild(ne);
        }, c);
    });
  }));
}
function applyColorMatrixToColor({ r: m, g: c, b: ie, a: we }, $e) {
  const Me = $e[0] * m + $e[1] * c + $e[2] * ie + $e[3] * we + $e[4] * 255, Ze = $e[5] * m + $e[6] * c + $e[7] * ie + $e[8] * we + $e[9] * 255, ne = $e[10] * m + $e[11] * c + $e[12] * ie + $e[13] * we + $e[14] * 255, rr = $e[15] * m + $e[16] * c + $e[17] * ie + $e[18] * we + $e[19] * 255;
  return {
    r: Math.min(255, Math.max(0, Math.round(Me))),
    g: Math.min(255, Math.max(0, Math.round(Ze))),
    b: Math.min(255, Math.max(0, Math.round(ne))),
    a: Math.min(255, Math.max(0, Math.round(rr)))
  };
}
async function applyColorMatricesToImage(m, c) {
  return new Promise((ie, we) => {
    const $e = new Blob([m], { type: "image/png" }), Me = new Image();
    Me.src = URL.createObjectURL($e), Me.addEventListener("load", () => {
      const Ze = document.createElement("canvas");
      Ze.width = Me.width, Ze.height = Me.height;
      const ne = Ze.getContext("2d");
      if (!ne) {
        we("Canvas-Kontext konnte nicht erstellt werden.");
        return;
      }
      ne.drawImage(Me, 0, 0);
      const rr = ne.getImageData(0, 0, Me.width, Me.height), { data: gr, width: or, height: _r } = rr;
      for (let Lr = 0; Lr < _r; Lr++)
        for (let Ir = 0; Ir < or; Ir++) {
          const Ar = (Lr * or + Ir) * 4;
          for (const Rr of c) {
            const [Nr, Yr, Vr, Xr] = [gr[Ar], gr[Ar + 1], gr[Ar + 2], gr[Ar + 3]], { r: Wr, g: si, b: li, a: xi } = applyColorMatrixToColor({ r: Nr, g: Yr, b: Vr, a: Xr }, Rr);
            gr[Ar] = Wr, gr[Ar + 1] = si, gr[Ar + 2] = li, gr[Ar + 3] = xi;
          }
        }
      ne.putImageData(rr, 0, 0), Ze.toBlob((Lr) => {
        if (Lr) {
          const Ir = new FileReader();
          Ir.onloadend = () => {
            Ir.result ? ie(Ir.result) : we("Fehler beim Lesen des Blob-Inhalts.");
          }, Ir.onerror = we, Ir.readAsArrayBuffer(Lr);
        } else
          we("Canvas konnte nicht in Blob konvertiert werden.");
      }, "image/png");
    }), Me.onerror = () => {
      we("Bild konnte nicht geladen werden.");
    };
  });
}
async function getVisibleBBox(m) {
  return new Promise((c, ie) => {
    const we = new Blob([m], { type: "image/png" }), $e = new Image();
    $e.src = URL.createObjectURL(we), $e.onload = () => {
      const Me = document.createElement("canvas");
      Me.width = $e.width, Me.height = $e.height;
      const Ze = Me.getContext("2d");
      if (!Ze) {
        ie("Canvas-Kontext konnte nicht erstellt werden.");
        return;
      }
      Ze.drawImage($e, 0, 0);
      const ne = Ze.getImageData(0, 0, $e.width, $e.height), { data: rr, width: gr, height: or } = ne;
      let _r = gr, Lr = or, Ir = 0, Ar = 0, Rr = !1;
      for (let Yr = 0; Yr < or; Yr++)
        for (let Vr = 0; Vr < gr; Vr++) {
          const Xr = (Yr * gr + Vr) * 4;
          rr[Xr + 3] > 0 && (Rr = !0, _r = Math.min(_r, Vr), Lr = Math.min(Lr, Yr), Ir = Math.max(Ir, Vr), Ar = Math.max(Ar, Yr));
        }
      if (!Rr) {
        c(void 0);
        return;
      }
      const Nr = {
        left: _r,
        top: Lr,
        width: Ir - _r + 1,
        height: Ar - Lr + 1
      };
      c(Nr);
    }, $e.onerror = () => {
      ie("Bild konnte nicht geladen werden.");
    };
  });
}
async function cropToVisibleBBox(m, c) {
  return new Promise((ie, we) => {
    const $e = new Blob([m], { type: "image/png" }), Me = new Image();
    Me.src = URL.createObjectURL($e), Me.onload = () => {
      const Ze = document.createElement("canvas");
      Ze.width = c.width, Ze.height = c.height;
      const ne = Ze.getContext("2d");
      if (!ne) {
        we("Canvas-Kontext konnte nicht erstellt werden.");
        return;
      }
      ne.drawImage(
        Me,
        c.left,
        c.top,
        c.width,
        c.height,
        0,
        0,
        c.width,
        c.height
      ), Ze.toBlob((rr) => {
        if (rr) {
          const gr = new FileReader();
          gr.onloadend = () => {
            gr.result ? ie(gr.result) : we("Fehler beim Lesen des Blob-Inhalts.");
          }, gr.onerror = we, gr.readAsArrayBuffer(rr);
        } else
          we("Canvas konnte nicht in Blob konvertiert werden.");
      }, "image/png");
    }, Me.onerror = () => {
      we("Bild konnte nicht geladen werden.");
    };
  });
}
async function rasterize(m) {
  const c = await renderSVG(m, "image/png", "arrayBuffer"), ie = await getVisibleBBox(c);
  if (!ie) {
    console.error("Failed to get visible bbox");
    return;
  }
  return {
    left: ie?.left,
    top: ie?.top,
    width: ie?.width,
    height: ie?.height,
    buffer: await cropToVisibleBBox(c, ie)
  };
}
async function applyColorMatrix(m, c) {
  return m;
}
async function renderRemote(m, c, ie, we, $e, Me, Ze, ne, rr, gr, or) {
  const _r = `https://embed-api-v2.bluepic.workers.dev/api/export/${c}?${new URLSearchParams({
    env: "prod",
    embedV2Server: m
  })}`, Lr = {
    templateId: ie,
    data: we,
    width: $e,
    height: Me,
    format: Ze,
    frames: gr
  }, Ir = await fetch(_r, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(Lr)
  });
  if (!Ir.ok)
    throw new Error(`Failed to start rendering: ${Ir.status}`);
  return await Ir.json();
}
function getSessionState(m, c, ie, we, $e, Me, Ze) {
  return hash$1({ templateId: m, data: c, format: ie, width: we, height: $e, quality: Me });
}
const renderCache = /* @__PURE__ */ new Map();
async function renderRemoteWithRetry(m, c, ie, we, $e, Me, Ze, ne, rr, gr, or = 3) {
  const _r = getSessionState(ie, we, $e, Me, Ze, ne);
  if (renderCache.has(_r)) {
    const Ir = renderCache.get(_r);
    if (Ir)
      return await Ir;
  }
  const Lr = new Promise(async (Ir, Ar) => {
    let Rr = 0;
    for (; ; )
      try {
        Rr > 0 && console.info(`Retrying ${Rr}/${or}`);
        const Nr = await renderRemote(
          m,
          c,
          ie,
          we,
          Me,
          Ze,
          $e,
          ne,
          gr,
          rr
        );
        return Ir(Nr);
      } catch (Nr) {
        if (Rr++, console.error(`Rendering failed (${ie})`, Nr), Rr > or)
          return Ar(Nr);
      }
  });
  renderCache.set(_r, Lr);
  try {
    return await Lr;
  } catch (Ir) {
    throw renderCache.delete(_r), Ir;
  }
}
async function renderLocal(m, c) {
  const ie = await import("flat-svg");
  c.watermark;
  const we = await ie.simplifySVG(m, {
    rasterizeAllMasks: !1,
    vectorizeAllTexts: c.format !== "image/svg+xml",
    rasterize,
    applyColorMatrix,
    keepGroupTransforms: !1
  }), $e = new XMLSerializer().serializeToString(we);
  if (c.format === "image/svg+xml") {
    const Me = new Blob([$e], { type: "image/svg+xml" });
    return [
      {
        name: `render.${mimeTypes.extension(Me.type)}`,
        blob: Me
      }
    ];
  } else if (c.format === "application/vnd.adobe.indesign-idml-package") {
    const Me = await import("idml"), { idml: Ze, collectedFonts: ne } = await Me.svg2idml(m, rasterize, applyColorMatrix, {
      keepGroupTransforms: c.idmlOptions.keepGroupTransforms ?? !1,
      vectorizeAllTexts: c.idmlOptions.vectorizeAllTexts ?? !1
    }), rr = await Ze.export();
    return [
      {
        name: `${c.fileBasename}.idml`,
        blob: new Blob([rr], { type: "application/vnd.adobe.indesign-idml-package" })
      },
      ...ne.map((gr) => {
        const or = (() => {
          if (gr.src.startsWith("data:")) {
            const Lr = gr.src.split(";")[0].split(":")[1];
            return mimeTypes.extension(Lr) || "otf";
          } else
            return new URL(gr.src).pathname.split(".").pop();
        })(), _r = or ? {
          ttf: "font/ttf",
          otf: "font/otf",
          woff2: "font/woff2",
          woff: "font/woff"
        }[or] : void 0;
        return {
          name: `${gr.fullName}.${or}`,
          blob: new Blob([gr.data], { type: _r })
        };
      })
    ];
  } else {
    const Me = c.frames?.x ?? 1, Ze = c.frames?.y ?? 1, ne = Me * Ze, rr = Array(ne).fill(0).map((Ir, Ar) => {
      const Rr = Ar % Me, Nr = Math.floor(Ar / Me), Yr = c.width / Me, Vr = c.height / Ze;
      return {
        x: Rr * Yr,
        y: Nr * Vr,
        width: Yr,
        height: Vr
      };
    }), or = await (await import("flat-svg")).simplifySVG(m, {
      rasterizeAllMasks: !1,
      vectorizeAllTexts: !0,
      rasterize,
      applyColorMatrix,
      keepGroupTransforms: !1
    }), _r = c.format, Lr = await renderSVG(or.querySelector("svg"), mime.getType(_r), "blob");
    if (rr.length > 1) {
      const Ir = URL.createObjectURL(Lr);
      return (await Promise.all(
        rr.map(({ x: Ar, y: Rr, width: Nr, height: Yr }) => cropImage(
          {
            imageSource: Ir,
            cropX: Ar,
            cropY: Rr,
            cropWidth: Nr,
            cropHeight: Yr,
            type: mime.getType(_r),
            quality: 1
          },
          "blob"
        ))
      ).then((Ar) => (URL.revokeObjectURL(Ir), Ar))).map((Ar, Rr) => ({
        name: `${c.fileBasename}_${Rr + 1}.${mimeTypes.extension(Ar.type)}`,
        blob: Ar
      }));
    } else
      return [
        {
          name: `${c.fileBasename}.${mimeTypes.extension(Lr.type)}`,
          blob: Lr
        }
      ];
  }
}
function renderVideoRemote(m, c, ie, we, $e, Me, Ze, ne, rr) {
  return new Promise(async (gr, or) => {
    let _r, Lr, Ir;
    function Ar(si) {
      try {
        const li = JSON.parse(si);
        if (li.type === "end" && (_r = li.sessionId, Lr = li.creditsConsumed, Ir = li.files), li.type === "error")
          throw console.error("Error in video rendering", li), new Error(li.message);
        li.type !== "end" && rr(li);
      } catch {
      }
    }
    const Rr = `https://api.bluepic.io/api/export/${m}?${new URLSearchParams({
      env: "prod"
    })}`, Nr = {
      templateId: c,
      data: ie,
      width: we,
      height: $e,
      format: "mp4",
      quality: 0.85,
      fps: 30,
      duration: Ze,
      vcodec: "libx264",
      pixFmt: "yuv420p",
      audio: [],
      minParallel: 16,
      maxParallel: 16
    }, Yr = await fetch(Rr, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(Nr)
    });
    if (!Yr.body)
      throw new Error(`Failed to start video rendering: ${Yr.status}`);
    const Vr = Yr.body.getReader();
    let Xr = "";
    const Wr = new TextDecoder();
    for (; ; ) {
      const { value: si, done: li } = await Vr.read();
      if (li)
        break;
      Xr += Wr.decode(si, { stream: !0 });
      let xi = Xr.indexOf(`

`);
      for (; xi !== -1; ) {
        const di = Xr.slice(0, xi).trim();
        Xr = Xr.slice(xi + 2), xi = Xr.indexOf(`

`);
        const oi = di.split(/\r?\n/);
        let ci = "";
        for (const vr of oi)
          vr.startsWith("data:") && (ci += vr.slice(5).trim());
        Ar(ci);
      }
    }
    if (!Ir || Ir.length === 0) {
      or(new Error("No files found"));
      return;
    } else if (Lr === void 0) {
      or(new Error("No credits consumed"));
      return;
    }
    gr({
      files: Ir,
      creditsConsumed: Lr
    });
  });
}
function useRenderer(m, c, ie, we, $e, Me) {
  const Ze = ref$1();
  nanoid();
  async function ne(Lr, Ir, Ar) {
    const Rr = ie.value;
    if (!Rr)
      throw console.error("Serial not available"), new Error("Serial not available");
    let Nr = 0;
    const Yr = !0;
    if (Ze.value = [], Lr === "pdf" || Yr) {
      if (Lr === "idml")
        throw new Error("IDML rendering is not supported");
      const Vr = await renderRemoteWithRetry(
        m,
        we.value,
        $e.value,
        Me.value,
        Lr,
        Rr.width,
        Rr.height,
        0.95,
        Rr.frames,
        void 0,
        5
      );
      Ze.value = Vr.files, Nr = Vr.creditsConsumed;
    } else {
      const Vr = c.value?.bluepicEmbeddedRef?.renderSVG(), Xr = ie.value;
      if (!Vr)
        throw console.error("SVG document not available"), new Error("SVG document not available");
      if (!Xr)
        throw console.error("Serial not available"), new Error("Serial not available");
      Ze.value = (await renderLocal(await Vr, {
        width: Xr.width,
        height: Xr.height,
        format: mime.getType(Lr),
        quality: 0.95,
        frames: Xr.frames,
        idmlOptions: {
          keepGroupTransforms: !1,
          rasterizeAllMasks: !1,
          vectorizeAllTexts: !1,
          keepFontRemoteUrls: !1
        },
        svgOptions: {
          vectorizeAllTexts: !1
        },
        fileBasename: Ir ?? `${Xr.name}_export`,
        watermark: Ar
      })).map((Wr) => URL.createObjectURL(Wr.blob));
    }
    return {
      files: Ze.value,
      creditsConsumed: Nr
    };
  }
  const rr = ref$1(!1), gr = ref$1(), or = ref$1();
  async function _r(Lr, Ir, Ar) {
    rr.value = !0, gr.value = void 0;
    const Rr = await renderVideoRemote(
      we.value,
      $e.value,
      Me.value,
      ie.value?.width ?? 0,
      ie.value?.height ?? 0,
      Lr,
      Ir,
      {
        fps: 30,
        vcodec: "libx264",
        pixFmt: "yuv420p",
        audio: []
      },
      (Nr) => {
        or.value = Nr;
      }
    );
    return rr.value = !1, gr.value = [
      {
        name: `${Ar ?? "video"}.mp4`,
        url: Rr.files[0]
      }
    ], or.value = void 0, {
      files: gr.value.map((Nr) => Nr.url),
      creditsConsumed: Rr.creditsConsumed
    };
  }
  return {
    renderFiles: Ze,
    render: ne,
    renderVideo: _r,
    videoFiles: gr,
    videoRendering: rr,
    videoProgress: or
  };
}
async function downloadFiles(m, c) {
  const ie = await Promise.all(
    m.map(async (we) => {
      const $e = we.split("/").pop(), Me = $e.split(".").pop(), Ze = await fetch(we);
      if (!Ze.ok)
        throw new Error(`Failed to download file: ${Ze.status}`);
      const ne = await Ze.blob();
      return {
        name: m.length > 1 ? $e : `${c}.${Me}`,
        blob: ne
      };
    })
  );
  if (ie.length > 1) {
    const we = await A(ie.map(({ name: $e, blob: Me }) => ({ name: $e, input: Me }))).blob();
    download(we, `${c}.zip`);
  } else
    download(ie[0].blob, ie[0].name);
}
const swiper = "", navigation = "", pagination = "", scrollbar = "", _hoisted_1$e = { class: "fields-wrapper" }, _hoisted_2$a = { class: "nav-wrapper" }, _hoisted_3$7 = { class: "nav-button" }, _sfc_main$i = /* @__PURE__ */ defineComponent({
  __name: "MobileFieldsSlide",
  props: {
    fields: {},
    originalField: {},
    active: { type: Boolean },
    mobileFieldsSlides: {},
    naturalFieldsViewMaxHeight: {},
    slideIndex: {}
  },
  emits: ["select-nav"],
  setup(m, { emit: c }) {
    const ie = m, we = c, { fields: $e, data: Me, bridge: Ze, modelField: ne, wrapFieldProps: rr } = useFields(toRef(ie, "fields")), gr = computed(() => ie.originalField && ie.fields.length >= 2 ? getFieldDescription(ie.originalField) : getFieldsDescription(ie.fields)), or = computed(() => ie.mobileFieldsSlides.map(({ fields: Lr, originalField: Ir }, Ar) => ({
      label: (Lr.length === 1 ? Lr[0] : Ir)?.description ?? getFieldsDescription(Lr),
      value: Ar,
      icon: () => renderFieldIcon(Lr[0].type, Ar === ie.slideIndex)
    })));
    function _r(Lr) {
      we("select-nav", Lr);
    }
    return (Lr, Ir) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["mobile-fields-slide", { active: Lr.active }])
    }, [
      createElementVNode("div", _hoisted_1$e, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(unref($e), ({ type: Ar, model: Rr, props: Nr, description: Yr, detailedDescription: Vr, layout: Xr }) => (openBlock(), createElementBlock("div", {
          class: normalizeClass(["field-wrapper", { ["field-wrapper-" + Ar]: !0 }])
        }, [
          Ar in BluepciFieldComponents ? (openBlock(), createBlock(resolveDynamicComponent(BluepciFieldComponents[Ar]), mergeProps({
            key: 0,
            ref_for: !0
          }, {
            ...unref(rr)(Nr),
            ...unref(ne)(Rr),
            maxHeight: `${Lr.naturalFieldsViewMaxHeight - 37 - 20 - 5}px`,
            description: Yr,
            detailedDescription: Vr,
            bridge: unref(Ze),
            ...(() => {
              if (Ar === "Text")
                return {
                  ...Xr
                };
            })(),
            mobile: !0
          }), null, 16)) : (openBlock(), createBlock(BxEmpty, {
            key: 1,
            title: "Field not supported"
          }, {
            icon: withCtx(() => [
              createVNode(BxIcon, null, {
                default: withCtx(() => [
                  createVNode(unref(AlertOutline))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        ], 2))), 256))
      ]),
      createElementVNode("div", _hoisted_2$a, [
        createVNode(BxDropdown, {
          "allowed-placements": ["top"],
          trigger: "click",
          options: or.value,
          onSelect: _r,
          "mobile-layout": ""
        }, {
          trigger: withCtx(() => [
            createElementVNode("div", _hoisted_3$7, [
              createElementVNode("span", null, toDisplayString(gr.value), 1)
            ])
          ]),
          optionLabel: withCtx(({ option: Ar }) => [
            createElementVNode("span", {
              style: normalizeStyle({ color: Ar.value === Lr.slideIndex ? "rgba(var(--primary-color-base), 1)" : "inherit" })
            }, toDisplayString(Ar.label), 5)
          ]),
          _: 1
        }, 8, ["options"])
      ])
    ], 2));
  }
}), MobileFieldsSlide_vue_vue_type_style_index_0_scoped_88d3f1fe_lang = "", MobileFieldsSlide = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["__scopeId", "data-v-88d3f1fe"]]);
function splitTimestamp(m) {
  const c = Math.floor(m / 36e5), ie = m % (1e3 * 60 * 60), we = Math.floor(ie / (1e3 * 60)), $e = ie % (1e3 * 60), Me = Math.floor($e / 1e3), Ze = Math.round($e % 1e3);
  return { hours: c, minutes: we, seconds: Me, milliseconds: Ze };
}
function timestampToTimecode(m, c) {
  const { hours: ie, minutes: we, seconds: $e, milliseconds: Me } = splitTimestamp(m);
  return `${ie.toString().padStart(2, "0")}:${we.toString().padStart(2, "0")}:${$e.toString().padStart(2, "0")}${c}${Me.toString().padEnd(3, "0")}`;
}
const _hoisted_1$d = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  class: "arctic-progress"
}, _hoisted_2$9 = ["d", "fill"], _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "CircularProgress",
  props: {
    progress: {},
    strokeWidth: { default: 10 },
    color: { default: "#00f" },
    backgroundColor: { default: "#e0e0e0" }
  },
  setup(m) {
    function c(we, $e, Me, Ze) {
      const ne = (Ze - 90) * Math.PI / 180;
      return {
        x: we + Me * Math.cos(ne),
        y: $e + Me * Math.sin(ne)
      };
    }
    function ie(we, $e, Me, Ze) {
      const rr = Math.max(0, Math.min(100, Ze)) / 100 * 360, gr = c(we, $e, Me, 0), or = c(we, $e, Me, rr), _r = rr > 180 ? 1 : 0;
      return [
        `M ${we} ${$e}`,
        `L ${gr.x} ${gr.y}`,
        `A ${Me} ${Me} 0 ${_r} 1 ${or.x} ${or.y}`,
        "Z"
      ].join(" ");
    }
    return (we, $e) => (openBlock(), createElementBlock("svg", _hoisted_1$d, [
      createElementVNode("path", {
        d: ie(50, 50, 50, we.progress),
        fill: we.color,
        class: "progress-sector"
      }, null, 8, _hoisted_2$9)
    ]));
  }
}), CircularProgress_vue_vue_type_style_index_0_scoped_7f4cd3b8_lang = "", CircularProgress = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["__scopeId", "data-v-7f4cd3b8"]]), _sfc_main$g = {}, _hoisted_1$c = {
  viewBox: "0 0 344 350",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$2(m, c) {
  return openBlock(), createElementBlock("svg", _hoisted_1$c, c[0] || (c[0] = [
    createStaticVNode('<ellipse cx="220.755" cy="202.159" rx="49.9896" ry="39.3918" fill="white"></ellipse><circle cx="172.765" cy="177.564" r="137.571" fill="#09275E"></circle><path d="M289.161 117.691L290.189 119.025L290.264 118.986C290.267 118.995 290.269 119.005 290.271 119.014C290.292 119.111 290.315 119.215 290.34 119.326L290.342 119.337C290.487 119.99 290.731 121.089 291.275 121.912C291.58 122.375 292.096 122.935 292.913 123.191C293.415 123.348 293.903 123.35 294.35 123.263L295.779 123.684C301.037 125.446 304.551 126.122 307.811 126.749C308.154 126.815 308.493 126.88 308.832 126.946C312.104 127.583 315.343 128.293 320.317 130.209C320.307 130.996 320.033 131.826 319.597 132.943C319.558 133.042 319.517 133.144 319.475 133.25C318.931 134.621 318.158 136.569 318.569 138.743L319.03 141.184L321.316 140.213C322.688 139.63 326.238 138.076 329.797 136.444C333.29 134.843 336.992 133.075 338.526 132.093L339.723 131.327L339.394 129.946C338.672 126.916 337.967 123.872 337.258 120.815C335.248 112.147 333.214 103.376 330.737 94.5409L330.308 93.0091L328.719 93.0832C321.431 93.4233 314.301 94.1966 307.29 94.9568C303.561 95.3612 299.866 95.7619 296.2 96.0918L295.311 96.1717L294.777 96.886C294.246 97.5964 293.707 98.3078 293.165 99.0223C290.635 102.358 288.052 105.763 286.025 109.468L285.631 110.188L285.857 110.977C286.583 113.52 287.614 115.684 289.161 117.691ZM289.933 117.746C289.934 117.745 289.938 117.753 289.947 117.771C289.937 117.756 289.933 117.747 289.933 117.746Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M93.1862 189.025L93.1862 189.025C92.3418 188.723 91.58 188.994 91.2708 189.119C90.8714 189.28 90.4932 189.512 90.169 189.738C89.5089 190.198 88.7881 190.834 88.1038 191.51C86.7464 192.85 85.2731 194.605 84.4485 196.015L84.4467 196.018C76.1322 210.301 75.0953 225.446 78.6265 241.168C81.8267 255.475 89.6272 267.326 97.2042 278.836L97.5148 279.308L97.5213 279.318C99.8514 282.814 102.915 285.581 106.291 287.871L106.293 287.872C107.63 288.777 109.408 289.807 111.751 289.538C115.478 289.131 119.188 287.275 122.147 284.723C125.106 282.171 127.493 278.77 128.373 275.08C129.463 270.553 128.601 266.205 127.362 262.489L127.241 262.126L126.995 261.833C125.807 260.423 124.367 259.601 123.334 259.011C123.1 258.878 122.887 258.756 122.702 258.642C115.356 254.059 109.017 248.779 104.649 241.416L104.646 241.412C96.802 228.252 93.2533 214.222 94.7986 198.973C94.8225 198.747 94.8517 198.49 94.8837 198.208C95.0138 197.06 95.1886 195.518 95.2329 194.155C95.2603 193.311 95.2447 192.396 95.0956 191.61C95.0214 191.219 94.8947 190.75 94.6514 190.309C94.4038 189.861 93.9521 189.299 93.1862 189.025Z" fill="#FFBB34" stroke="#09275E" stroke-width="3.99916"></path><path d="M290.005 121.129L289.656 121.988L290.085 122.809C292.75 127.905 294.192 132.59 293.907 136.956C293.627 141.238 291.665 145.483 286.961 149.719L284.446 151.984L287.643 153.094C293.842 155.247 299.66 157.273 305.479 159.3C307.974 160.168 310.469 161.037 312.995 161.916L314.796 162.543L315.508 160.774C317.768 155.15 319.921 149.776 322.065 144.425C324.217 139.052 326.36 133.704 328.592 128.152L329.356 126.251L327.438 125.533C322.371 123.638 317.397 121.775 312.491 119.939C307.134 117.933 301.858 115.958 296.635 114.004L295.405 113.544L294.494 114.49C292.435 116.629 291.012 118.653 290.005 121.129Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M162.722 197.574H162.695L162.668 197.575C158.965 197.676 156.646 200.15 155.153 202.449C151.761 207.638 150.294 213.427 150.531 219.592C150.634 222.464 152.176 224.391 153.955 225.873L153.963 225.88L153.972 225.887C158.318 229.429 163.337 231.194 168.536 232.158C169.167 232.282 169.957 232.298 170.744 231.972C171.586 231.623 172.225 230.962 172.6 230.102L172.707 229.854L172.745 229.587C172.745 229.587 172.747 229.579 172.75 229.557C172.754 229.538 172.757 229.52 172.762 229.495C172.764 229.485 172.766 229.474 172.768 229.462C172.782 229.388 172.806 229.258 172.824 229.117C172.841 228.98 172.861 228.764 172.844 228.515C172.827 228.277 172.766 227.874 172.518 227.46L172.518 227.46L172.513 227.453C168.063 220.106 166.241 212.24 167.157 203.718C167.321 202.2 166.665 200.739 166.017 199.78C165.672 199.268 165.252 198.783 164.786 198.401C164.396 198.082 163.661 197.574 162.722 197.574Z" fill="#FFBB34" stroke="#09275E" stroke-width="3.99916"></path><path d="M180.399 40.1741C181.974 40.3116 183.454 40.4408 184.909 40.6792C184.228 45.2675 183.241 49.756 182.237 54.3138L182.214 54.4178C181.085 59.5414 179.935 64.7558 179.241 70.1416L179.016 71.8853L180.717 72.3314C185.308 73.5358 189.672 74.411 193.947 74.8692C196.831 75.1782 199.928 75.7588 202.811 76.2992C203.941 76.511 205.038 76.7166 206.076 76.8973C207.852 77.2063 209.528 77.4544 210.793 77.4711C211.397 77.4791 212.131 77.4419 212.783 77.2014C213.128 77.0746 213.569 76.8483 213.937 76.4293C214.337 75.9731 214.545 75.407 214.556 74.8219L214.556 74.8168C214.6 72.0297 213.488 69.3888 212.568 67.2043C212.54 67.1397 212.513 67.0755 212.486 67.0117C211.477 64.6117 210.713 62.7036 210.757 60.8354C210.764 60.5351 210.756 60.1602 210.749 59.8186C210.746 59.6678 210.743 59.5234 210.741 59.3948C210.736 58.9128 210.744 58.4628 210.791 58.0449C210.847 57.5513 210.945 57.2092 211.066 56.9696C212.585 56.8593 213.855 56.3467 214.708 55.2183C215.492 54.1819 215.665 52.8597 215.762 52.1245C215.771 52.0554 215.779 51.9915 215.787 51.9335C215.918 51.001 216.027 50.6767 216.19 50.4815C216.269 50.3865 216.628 49.9996 218.159 49.93L220.201 49.8372L220.063 47.7982C219.845 44.5492 220.16 41.3975 220.492 38.0783C220.533 37.6678 220.574 37.2547 220.614 36.8385C220.977 33.124 221.274 29.2037 220.597 25.1391L220.347 23.6407L218.836 23.4795C209.196 22.4508 199.693 21.4527 190.202 20.4559C184.985 19.908 179.771 19.3604 174.54 18.8083L172.779 18.6226L172.381 20.3473C171.008 26.298 170.555 31.6249 170.367 36.7755L170.311 38.3068L171.775 38.7589C174.514 39.6048 177.162 39.8863 179.615 40.1051C179.879 40.1287 180.14 40.1515 180.399 40.1741Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M134.234 79.9717L134.458 81.5862L136.085 81.6917C139.271 81.8981 142.447 82.132 145.618 82.3656C155.449 83.0898 165.234 83.8105 175.12 83.6975L176.711 83.6793L177.051 82.1246C178.105 77.2955 179.195 72.5212 180.279 67.7721C182.531 57.9086 184.758 48.154 186.59 38.244L186.918 36.4649L185.181 35.9604C179.24 34.2354 171.076 33.8622 165.486 33.6068L165.258 33.5963L163.101 33.4976L163.168 35.6559C163.268 38.8806 163.968 41.9624 164.79 44.889C165.136 46.118 165.488 47.2779 165.834 48.413C166.158 49.4805 166.476 50.5261 166.775 51.5867C159.115 53.946 151.592 56.2745 144.101 58.5932C140.914 59.5797 137.733 60.5644 134.549 61.549L133.317 61.9301L133.156 63.2098C132.517 68.2858 133.206 72.9608 133.893 77.6183C134.009 78.4026 134.125 79.1865 134.234 79.9717Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M235.987 77.2978L237.597 75.9449L236.164 74.4049C234.927 73.0743 233.511 72.8335 232.527 72.7119C232.424 72.6991 232.327 72.6874 232.236 72.6764C231.957 72.6427 231.729 72.6152 231.533 72.5831C231.441 69.4098 231.536 66.2292 231.633 62.9588C231.654 62.2493 231.676 61.5355 231.695 60.8167C231.816 56.3655 231.867 51.7646 231.35 47.0422L231.155 45.2528L229.355 45.2599C225.882 45.2737 222.492 44.9896 219.022 44.6988C217.931 44.6073 216.832 44.5152 215.719 44.4315C211.131 44.086 206.409 43.8946 201.565 44.6144L199.731 44.887L199.865 46.7367C200.233 51.8147 200.432 56.8294 200.631 61.8463C200.691 63.3646 200.751 64.8832 200.816 66.4037C201.095 72.9254 201.459 79.4532 202.285 85.9895L202.486 87.5836L204.087 87.73C206.257 87.9285 208.273 88.3083 210.351 88.6997C211.078 88.8366 211.812 88.9749 212.562 89.1073C215.396 89.6071 218.362 89.9982 221.547 89.694L222.312 89.6208L222.831 89.0534C226.01 85.5803 229.634 82.5749 233.426 79.4307C234.272 78.7289 235.127 78.0202 235.987 77.2978Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M238.43 76.8741L238.524 76.883H238.619H238.656H239.416L239.984 76.3784C240.606 75.8255 241.206 75.2772 241.793 74.7413C244.015 72.7114 246.04 70.8607 248.334 69.623C251.027 68.1703 253.99 67.6423 257.9 69.2771L259.41 69.9081L260.327 68.5536C263.376 64.052 266.319 59.7631 268.842 56.1056C269.214 55.8165 269.59 55.7012 270.152 55.5731C270.2 55.5622 270.256 55.5505 270.318 55.5375C270.918 55.4115 272.136 55.156 273.036 54.187L273.432 53.7603L273.537 53.1876C274.04 50.4526 273.895 47.6874 273.127 44.9153L272.797 43.7231L271.582 43.4867C263.347 41.8831 255 40.2479 246.437 38.5701C241.936 37.6882 237.375 36.7945 232.738 35.8876L230.648 35.4788L230.372 37.5901C229.226 46.3333 229.305 54.9129 229.382 63.2284C229.413 66.6176 229.444 69.9628 229.391 73.2575L229.369 74.6691L230.692 75.1628C233.369 76.1618 235.547 76.6013 238.43 76.8741Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M113.263 17.2528L111.592 17.7788L111.894 19.5045C112.563 23.3331 113.21 27.1511 113.856 30.9674C115.742 42.1 117.626 53.2183 120.063 64.5472L120.527 66.7031L122.627 66.0311C137.343 61.3231 151.356 56.837 165.739 52.2025L167.448 51.652L167.084 49.8942C166.341 46.3024 165.618 42.7407 164.899 39.1967C162.612 27.9303 160.361 16.8421 157.618 5.52881L157.112 3.44522L155.069 4.09424C145.819 7.03208 136.764 9.87348 127.677 12.7249C122.892 14.2262 118.098 15.7303 113.263 17.2528Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M262.342 65.8041L260.526 68.8324H263.185C272.563 79.6925 278.667 92.1168 284.494 105.834L285.903 109.152L287.972 106.2C289.795 103.598 291.611 101.061 293.405 98.5547C297.793 92.425 302.05 86.4771 305.97 80.1993L306.956 78.6203L305.452 77.5241C301.19 74.4193 296.984 71.3585 292.795 68.3103C285.976 63.3488 279.204 58.421 272.316 53.3923L270.548 52.1018L269.422 53.9786C268.143 56.1116 266.956 58.096 265.797 60.0328L265.719 60.1647C264.588 62.0558 263.483 63.9035 262.342 65.8041Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M328.052 237.274L328.894 236.501L328.655 235.383C328.524 234.766 328.393 234.15 328.261 233.533C326.622 225.832 324.984 218.135 322.767 210.307L322.338 208.792L320.764 208.854C316.093 209.038 311.535 209.802 307.19 210.53C307.035 210.556 306.879 210.582 306.724 210.608C302.583 211.301 298.643 211.941 294.779 212.087C294.32 211.174 294.184 210.152 294.067 208.823C294.058 208.717 294.048 208.609 294.039 208.498C293.905 206.915 293.726 204.792 292.391 202.858L291.489 201.552L290.012 202.133C289.048 202.513 288.07 202.885 287.083 203.26C283.205 204.735 279.196 206.259 275.417 208.502L274.451 209.076L274.438 210.199C274.402 213.408 274.138 216.128 272.948 218.512C271.647 221.054 271.503 223.443 272.081 225.711C272.635 227.88 273.834 229.865 275.028 231.674L276.226 233.49L277.934 232.144C280.24 230.329 282.202 228.249 284.059 226.282C284.211 226.121 284.361 225.962 284.511 225.803C286.164 224.056 287.767 222.4 289.577 220.93C293.737 224.62 297.869 228.288 302.002 231.957C306.542 235.989 311.083 240.021 315.662 244.08L316.757 245.052L318.014 244.3C318.127 244.233 318.239 244.166 318.351 244.099C321.621 242.146 324.837 240.224 328.052 237.274Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><mask id="path-14-outside-1_503_366" maskUnits="userSpaceOnUse" x="25" y="63" width="271" height="287" fill="black"><rect fill="white" x="25" y="63" width="271" height="287"></rect><path fill-rule="evenodd" clip-rule="evenodd" d="M177.294 229.437C176.864 227.937 176.002 226.893 175.17 225.884C175.007 225.686 174.844 225.489 174.686 225.29C170.498 220.137 169.015 213.946 167.977 207.644C166.827 200.707 169.684 194.677 172.528 188.674C172.617 188.485 172.707 188.297 172.796 188.108C178.096 176.839 186.066 167.46 194.368 158.377L194.69 158.028C197.991 154.438 201.278 150.864 205.155 147.812C206.415 146.811 207.601 145.662 208.343 143.809C207.687 142.861 207.043 141.883 206.392 140.896C204.982 138.756 203.542 136.57 201.893 134.541C196.333 127.646 196.481 120.899 201.596 113.893C202.11 113.19 202.619 112.484 203.128 111.779C205.999 107.799 208.862 103.832 212.42 100.399L213.332 99.5236C222.33 90.882 231.31 82.2574 240.776 74.1532C243.852 71.5211 247.225 69.4823 250.932 67.8882C254.602 66.2942 257.789 66.8503 260.755 69.5193C266.352 74.5609 270.169 80.9 273.765 87.3873C280.066 98.6939 284.848 110.631 288.999 122.827C290.519 127.312 291.853 131.835 291.705 136.691C291.557 141.473 289.778 145.18 285.923 148.109C282.216 150.926 278.213 153.039 274.061 155.041C273.717 155.209 273.366 155.366 273.017 155.523C271.903 156.022 270.812 156.512 270.021 157.302C269.227 158.529 269.382 159.721 269.527 160.844L269.539 160.935C269.88 163.671 270.21 166.41 270.54 169.149C271.431 176.544 272.322 183.949 273.431 191.333C275.396 204.456 273.95 217.097 268.168 228.997C265.054 235.41 260.384 240.896 253.712 244.159C252.251 244.879 250.808 245.627 249.37 246.372C245.849 248.198 242.359 250.008 238.7 251.35C238.632 253.023 239.281 254.296 239.965 255.639C240.404 256.499 240.857 257.389 241.146 258.431C238.441 262.782 235.715 267.171 232.964 271.601C227.534 280.342 222.007 289.24 216.349 298.319C224.689 304.176 232.658 309.773 240.553 315.334C242.149 319.235 240.081 322.186 238.179 324.9C238.093 325.024 238.007 325.147 237.922 325.269C230.063 336.576 218.758 342.062 205.377 343.73C205.133 343.755 204.888 343.771 204.645 343.787C204.151 343.82 203.662 343.853 203.19 343.953C184.954 348.104 171.313 340.32 159.637 327.271C158.981 326.533 158.365 325.774 157.745 325.01C157.524 324.739 157.303 324.466 157.08 324.194C156.756 323.763 156.453 323.312 156.097 322.785C155.964 322.587 155.823 322.378 155.671 322.155C151.683 322.98 147.796 323.152 143.951 323.323C142.615 323.382 141.284 323.441 139.955 323.527C137.362 323.702 134.772 323.941 132.183 324.18C125.481 324.799 118.781 325.417 112.044 324.935C105.817 324.49 99.6635 323.378 93.844 321.154C86.2454 318.263 78.9062 314.667 71.8636 310.515C63.746 305.733 57.0741 299.208 51.1434 291.943C39.6157 277.893 32.499 261.804 29.6448 243.899C28.5671 237.073 29.0562 230.211 29.5598 223.147C29.5758 222.922 29.5918 222.697 29.6078 222.472C34.1855 219.729 38.7261 217.014 43.2667 214.298C47.8074 211.583 52.3481 208.867 56.9258 206.124C55.058 200.68 53.2461 195.375 51.4645 190.159C50.3469 186.887 49.2412 183.65 48.141 180.434C57.1111 168.349 69.0095 160.861 82.5388 155.745C87.8022 153.744 93.1398 152.001 98.5144 150.333C108.263 147.256 115.528 140.991 121.31 132.799C123.201 130.13 124.342 128.784 126.092 129.092C128.761 129.561 129.205 133.837 128.761 136.914C127.945 142.734 124.72 147.367 120.903 151.556C117.789 154.967 114.156 157.784 110.153 160.12C108.715 160.961 107.281 161.806 105.847 162.652C100.516 165.795 95.1918 168.934 89.7297 171.797C70.6033 181.769 61.5591 198.451 57.8525 218.802C54.9613 234.78 58.6679 249.608 66.8226 263.102C76.7193 279.45 91.9166 288.087 110.969 289.978C122.274 291.127 132.616 277.114 131.244 267.661C130.503 262.434 128.724 257.652 126.129 253.093C124.043 249.467 121.708 246.025 119.369 242.576C118.216 240.876 117.061 239.174 115.936 237.449C110.265 228.774 106.15 219.433 105.742 208.942C104.964 188.256 112.674 171.834 130.132 160.157C133.247 158.075 136.493 156.205 139.741 154.334C144.185 151.774 148.631 149.213 152.743 146.107C156.301 143.438 159.637 140.509 162.936 137.507C172.981 128.387 168.644 106.701 152.446 102.067C147.183 100.547 142.179 102.216 137.508 104.81C135.655 105.848 132.341 106.989 131.763 105.774C131.141 103.989 132.467 101.771 134.098 100.51C142.068 94.4307 151.149 92.4289 160.934 93.9859C164.135 94.4929 167.254 95.7044 170.338 96.9022C170.862 97.1056 171.384 97.3085 171.906 97.5076C174.871 98.6197 177.207 100.696 179.171 103.179C179.486 103.578 179.764 104 180.041 104.418C180.254 104.74 180.465 105.06 180.691 105.367C192.775 120.64 189.661 137.247 180.728 150.741C175.205 159.082 167.903 165.866 160.082 172.019C154.374 176.505 148.814 181.176 144.662 187.255C140.437 193.446 137.879 200.045 139.176 207.718C140.511 215.54 145.07 221.36 151.371 225.549C156.82 229.182 163.047 231.258 169.793 231.184C172.331 231.184 174.723 230.819 177.294 229.437ZM175.835 317.966C172.277 318.856 168.681 319.597 164.011 319.338C165.729 318.563 167.323 317.826 168.846 317.123C171.331 315.974 173.625 314.914 175.946 313.925C177.726 313.147 179.764 313.184 181.618 313.629C186.214 314.704 190.588 316.409 195.555 318.819C193.071 319.894 191.329 319.634 189.661 318.782C185.139 316.446 180.506 316.78 175.835 317.966Z"></path></mask><path fill-rule="evenodd" clip-rule="evenodd" d="M177.294 229.437C176.864 227.937 176.002 226.893 175.17 225.884C175.007 225.686 174.844 225.489 174.686 225.29C170.498 220.137 169.015 213.946 167.977 207.644C166.827 200.707 169.684 194.677 172.528 188.674C172.617 188.485 172.707 188.297 172.796 188.108C178.096 176.839 186.066 167.46 194.368 158.377L194.69 158.028C197.991 154.438 201.278 150.864 205.155 147.812C206.415 146.811 207.601 145.662 208.343 143.809C207.687 142.861 207.043 141.883 206.392 140.896C204.982 138.756 203.542 136.57 201.893 134.541C196.333 127.646 196.481 120.899 201.596 113.893C202.11 113.19 202.619 112.484 203.128 111.779C205.999 107.799 208.862 103.832 212.42 100.399L213.332 99.5236C222.33 90.882 231.31 82.2574 240.776 74.1532C243.852 71.5211 247.225 69.4823 250.932 67.8882C254.602 66.2942 257.789 66.8503 260.755 69.5193C266.352 74.5609 270.169 80.9 273.765 87.3873C280.066 98.6939 284.848 110.631 288.999 122.827C290.519 127.312 291.853 131.835 291.705 136.691C291.557 141.473 289.778 145.18 285.923 148.109C282.216 150.926 278.213 153.039 274.061 155.041C273.717 155.209 273.366 155.366 273.017 155.523C271.903 156.022 270.812 156.512 270.021 157.302C269.227 158.529 269.382 159.721 269.527 160.844L269.539 160.935C269.88 163.671 270.21 166.41 270.54 169.149C271.431 176.544 272.322 183.949 273.431 191.333C275.396 204.456 273.95 217.097 268.168 228.997C265.054 235.41 260.384 240.896 253.712 244.159C252.251 244.879 250.808 245.627 249.37 246.372C245.849 248.198 242.359 250.008 238.7 251.35C238.632 253.023 239.281 254.296 239.965 255.639C240.404 256.499 240.857 257.389 241.146 258.431C238.441 262.782 235.715 267.171 232.964 271.601C227.534 280.342 222.007 289.24 216.349 298.319C224.689 304.176 232.658 309.773 240.553 315.334C242.149 319.235 240.081 322.186 238.179 324.9C238.093 325.024 238.007 325.147 237.922 325.269C230.063 336.576 218.758 342.062 205.377 343.73C205.133 343.755 204.888 343.771 204.645 343.787C204.151 343.82 203.662 343.853 203.19 343.953C184.954 348.104 171.313 340.32 159.637 327.271C158.981 326.533 158.365 325.774 157.745 325.01C157.524 324.739 157.303 324.466 157.08 324.194C156.756 323.763 156.453 323.312 156.097 322.785C155.964 322.587 155.823 322.378 155.671 322.155C151.683 322.98 147.796 323.152 143.951 323.323C142.615 323.382 141.284 323.441 139.955 323.527C137.362 323.702 134.772 323.941 132.183 324.18C125.481 324.799 118.781 325.417 112.044 324.935C105.817 324.49 99.6635 323.378 93.844 321.154C86.2454 318.263 78.9062 314.667 71.8636 310.515C63.746 305.733 57.0741 299.208 51.1434 291.943C39.6157 277.893 32.499 261.804 29.6448 243.899C28.5671 237.073 29.0562 230.211 29.5598 223.147C29.5758 222.922 29.5918 222.697 29.6078 222.472C34.1855 219.729 38.7261 217.014 43.2667 214.298C47.8074 211.583 52.3481 208.867 56.9258 206.124C55.058 200.68 53.2461 195.375 51.4645 190.159C50.3469 186.887 49.2412 183.65 48.141 180.434C57.1111 168.349 69.0095 160.861 82.5388 155.745C87.8022 153.744 93.1398 152.001 98.5144 150.333C108.263 147.256 115.528 140.991 121.31 132.799C123.201 130.13 124.342 128.784 126.092 129.092C128.761 129.561 129.205 133.837 128.761 136.914C127.945 142.734 124.72 147.367 120.903 151.556C117.789 154.967 114.156 157.784 110.153 160.12C108.715 160.961 107.281 161.806 105.847 162.652C100.516 165.795 95.1918 168.934 89.7297 171.797C70.6033 181.769 61.5591 198.451 57.8525 218.802C54.9613 234.78 58.6679 249.608 66.8226 263.102C76.7193 279.45 91.9166 288.087 110.969 289.978C122.274 291.127 132.616 277.114 131.244 267.661C130.503 262.434 128.724 257.652 126.129 253.093C124.043 249.467 121.708 246.025 119.369 242.576C118.216 240.876 117.061 239.174 115.936 237.449C110.265 228.774 106.15 219.433 105.742 208.942C104.964 188.256 112.674 171.834 130.132 160.157C133.247 158.075 136.493 156.205 139.741 154.334C144.185 151.774 148.631 149.213 152.743 146.107C156.301 143.438 159.637 140.509 162.936 137.507C172.981 128.387 168.644 106.701 152.446 102.067C147.183 100.547 142.179 102.216 137.508 104.81C135.655 105.848 132.341 106.989 131.763 105.774C131.141 103.989 132.467 101.771 134.098 100.51C142.068 94.4307 151.149 92.4289 160.934 93.9859C164.135 94.4929 167.254 95.7044 170.338 96.9022C170.862 97.1056 171.384 97.3085 171.906 97.5076C174.871 98.6197 177.207 100.696 179.171 103.179C179.486 103.578 179.764 104 180.041 104.418C180.254 104.74 180.465 105.06 180.691 105.367C192.775 120.64 189.661 137.247 180.728 150.741C175.205 159.082 167.903 165.866 160.082 172.019C154.374 176.505 148.814 181.176 144.662 187.255C140.437 193.446 137.879 200.045 139.176 207.718C140.511 215.54 145.07 221.36 151.371 225.549C156.82 229.182 163.047 231.258 169.793 231.184C172.331 231.184 174.723 230.819 177.294 229.437ZM175.835 317.966C172.277 318.856 168.681 319.597 164.011 319.338C165.729 318.563 167.323 317.826 168.846 317.123C171.331 315.974 173.625 314.914 175.946 313.925C177.726 313.147 179.764 313.184 181.618 313.629C186.214 314.704 190.588 316.409 195.555 318.819C193.071 319.894 191.329 319.634 189.661 318.782C185.139 316.446 180.506 316.78 175.835 317.966Z" fill="#FFBB34"></path><path d="M214.718 207.496L212.718 207.489V207.496H214.718ZM234.511 227.106H236.511V225.093L234.498 225.107L234.511 227.106ZM174.167 194.521L176.167 194.549L176.167 194.544L174.167 194.521ZM192.182 212.871L192.174 210.872L192.167 210.872L192.182 212.871ZM234.599 185.923C222.452 185.842 212.759 195.441 212.718 207.489L216.718 207.503C216.751 197.679 224.628 189.855 234.572 189.922L234.599 185.923ZM212.718 207.496C212.718 219.58 222.371 229.187 234.525 229.106L234.498 225.107C224.56 225.173 216.718 217.357 216.718 207.496H212.718ZM232.512 227.106V227.143H236.511V227.106H232.512ZM192.123 174.913C181.272 174.831 172.291 183.648 172.168 194.498L176.167 194.544C176.265 185.895 183.446 178.846 192.092 178.912L192.123 174.913ZM172.168 194.493C172.004 206.083 180.674 214.953 192.196 214.871L192.167 210.872C182.932 210.938 176.034 203.942 176.167 194.549L172.168 194.493ZM192.189 214.871C203.259 214.83 211.858 206.229 211.899 195.159L207.9 195.144C207.867 204.018 201.046 210.839 192.174 210.872L192.189 214.871ZM177.294 229.437L179.187 232.96L182.028 231.434L181.138 228.334L177.294 229.437ZM175.17 225.884L178.255 223.339L178.255 223.339L175.17 225.884ZM174.686 225.29L177.818 222.803L177.804 222.785L177.789 222.767L174.686 225.29ZM167.977 207.644L171.923 206.994L171.922 206.99L167.977 207.644ZM172.528 188.674L176.142 190.386L176.142 190.386L172.528 188.674ZM172.796 188.108L176.411 189.818L176.415 189.81L172.796 188.108ZM194.368 158.377L191.425 155.67L191.417 155.679L194.368 158.377ZM194.69 158.028L197.634 160.735L197.634 160.735L194.69 158.028ZM205.155 147.812L207.628 150.955L207.635 150.949L207.642 150.944L205.155 147.812ZM208.343 143.809L212.056 145.294L212.853 143.301L211.632 141.535L208.343 143.809ZM206.392 140.896L203.053 143.097L203.053 143.097L206.392 140.896ZM201.893 134.541L198.78 137.051L198.784 137.057L198.789 137.063L201.893 134.541ZM201.596 113.893L198.366 111.535L198.366 111.535L201.596 113.893ZM203.128 111.779L199.884 109.439V109.439L203.128 111.779ZM212.42 100.399L209.65 97.5147L209.643 97.5209L212.42 100.399ZM213.332 99.5236L216.102 102.408L216.102 102.408L213.332 99.5236ZM240.776 74.1532L238.176 71.1143L238.175 71.1153L240.776 74.1532ZM250.932 67.8882L252.512 71.5621L252.519 71.5592L252.525 71.5563L250.932 67.8882ZM260.755 69.5193L263.431 66.5479L263.43 66.5469L260.755 69.5193ZM273.765 87.3873L270.267 89.326L270.272 89.3342L273.765 87.3873ZM288.999 122.827L292.787 121.543L292.785 121.538L288.999 122.827ZM291.705 136.691L295.702 136.815L295.702 136.813L291.705 136.691ZM285.923 148.109L283.503 144.924L283.503 144.925L285.923 148.109ZM274.061 155.041L272.324 151.439L272.317 151.442L272.31 151.446L274.061 155.041ZM273.017 155.523L271.381 151.874L271.381 151.874L273.017 155.523ZM270.021 157.302L267.193 154.475L266.894 154.774L266.663 155.13L270.021 157.302ZM269.527 160.844L273.494 160.33L273.493 160.329L269.527 160.844ZM269.539 160.935L273.508 160.441L273.507 160.432L273.505 160.422L269.539 160.935ZM270.54 169.149L274.51 168.671V168.671L270.54 169.149ZM273.431 191.333L277.386 190.741L277.386 190.739L273.431 191.333ZM268.168 228.997L264.571 227.249L264.57 227.25L268.168 228.997ZM253.712 244.159L251.955 240.566L251.944 240.571L253.712 244.159ZM249.37 246.372L251.211 249.922L251.211 249.922L249.37 246.372ZM238.7 251.35L237.322 247.596L234.812 248.517L234.704 251.188L238.7 251.35ZM239.965 255.639L236.402 257.455L236.402 257.455L239.965 255.639ZM241.146 258.431L244.543 260.542L245.469 259.052L245 257.361L241.146 258.431ZM232.964 271.601L236.361 273.711V273.711L232.964 271.601ZM216.349 298.319L212.955 296.203L210.953 299.416L214.05 301.591L216.349 298.319ZM240.553 315.334L244.255 313.82L243.812 312.738L242.856 312.064L240.553 315.334ZM238.179 324.9L241.454 327.195L241.455 327.195L238.179 324.9ZM237.922 325.269L234.641 322.982L234.638 322.987L237.922 325.269ZM205.377 343.73L205.775 347.709L205.824 347.705L205.872 347.699L205.377 343.73ZM204.645 343.787L204.913 347.777L204.913 347.777L204.645 343.787ZM203.19 343.953L202.366 340.039L202.334 340.046L202.303 340.053L203.19 343.953ZM159.637 327.271L156.648 329.928L156.657 329.938L159.637 327.271ZM157.745 325.01L160.85 322.49L160.85 322.489L157.745 325.01ZM157.08 324.194L153.88 326.593L153.933 326.664L153.989 326.732L157.08 324.194ZM156.097 322.785L152.781 325.02L152.781 325.02L156.097 322.785ZM155.671 322.155L158.975 319.902L157.473 317.698L154.861 318.239L155.671 322.155ZM143.951 323.323L143.774 319.327L143.951 323.323ZM139.955 323.527L139.696 319.536L139.685 319.537L139.955 323.527ZM132.183 324.18L132.55 328.162H132.55L132.183 324.18ZM112.044 324.935L111.759 328.924L112.044 324.935ZM93.844 321.154L95.2718 317.419L95.2663 317.416L93.844 321.154ZM71.8636 310.515L73.8946 307.07L73.8935 307.069L71.8636 310.515ZM51.1434 291.943L54.2416 289.414L54.2351 289.406L51.1434 291.943ZM29.6448 243.899L25.6946 244.523L25.6955 244.529L29.6448 243.899ZM29.5598 223.147L25.5707 222.862H25.5707L29.5598 223.147ZM29.6078 222.472L27.5521 219.042L25.7662 220.112L25.6187 222.189L29.6078 222.472ZM43.2667 214.298L41.2141 210.866H41.2141L43.2667 214.298ZM56.9258 206.124L58.9815 209.555L61.7595 207.89L60.7086 204.827L56.9258 206.124ZM51.4645 190.159L47.68 191.451V191.451L51.4645 190.159ZM48.141 180.434L44.9298 178.051L43.6764 179.739L44.3573 181.729L48.141 180.434ZM82.5388 155.745L83.9532 159.486L83.9604 159.483L82.5388 155.745ZM98.5144 150.333L99.6999 154.153L99.709 154.15L99.7181 154.147L98.5144 150.333ZM121.31 132.799L118.047 130.487L118.043 130.493L121.31 132.799ZM126.092 129.092L126.785 125.153H126.785L126.092 129.092ZM128.761 136.914L124.803 136.341L124.801 136.35L124.8 136.359L128.761 136.914ZM120.903 151.556L123.856 154.253L123.858 154.25L120.903 151.556ZM110.153 160.12L108.138 156.665L108.135 156.667L110.153 160.12ZM105.847 162.652L103.816 159.207H103.816L105.847 162.652ZM89.7297 171.797L91.5785 175.343L91.5862 175.339L89.7297 171.797ZM57.8525 218.802L53.918 218.086L53.9172 218.09L57.8525 218.802ZM66.8226 263.102L63.3999 265.17L63.4014 265.173L66.8226 263.102ZM110.969 289.978L111.373 285.999L111.364 285.998L110.969 289.978ZM131.244 267.661L127.285 268.223L127.286 268.236L131.244 267.661ZM126.129 253.093L129.605 251.115L129.6 251.107L129.595 251.098L126.129 253.093ZM119.369 242.576L116.059 244.821L119.369 242.576ZM115.936 237.449L119.285 235.264L119.283 235.26L115.936 237.449ZM105.742 208.942L101.746 209.092L101.746 209.097L105.742 208.942ZM130.132 160.157L127.91 156.832L127.909 156.833L130.132 160.157ZM139.741 154.334L137.745 150.869V150.869L139.741 154.334ZM152.743 146.107L150.343 142.908L150.332 142.916L152.743 146.107ZM162.936 137.507L160.248 134.546L160.244 134.549L162.936 137.507ZM152.446 102.067L151.337 105.909L151.346 105.912L152.446 102.067ZM137.508 104.81L135.566 101.315L135.554 101.321L137.508 104.81ZM131.763 105.774L127.987 107.09L128.058 107.296L128.152 107.492L131.763 105.774ZM134.098 100.51L131.673 97.3307L131.663 97.3383L131.653 97.346L134.098 100.51ZM160.934 93.9859L160.306 97.9354L160.309 97.9358L160.934 93.9859ZM170.338 96.9022L171.786 93.1743L171.786 93.1743L170.338 96.9022ZM171.906 97.5076L170.481 101.244L170.491 101.248L170.502 101.252L171.906 97.5076ZM179.171 103.179L182.31 100.701L182.308 100.698L179.171 103.179ZM180.041 104.418L176.705 106.623V106.623L180.041 104.418ZM180.691 105.367L177.471 107.739L177.512 107.794L177.555 107.848L180.691 105.367ZM180.728 150.741L184.062 152.949L184.063 152.948L180.728 150.741ZM160.082 172.019L162.553 175.164L162.555 175.162L160.082 172.019ZM144.662 187.255L141.36 185L141.359 185.001L144.662 187.255ZM139.176 207.718L135.233 208.385L135.234 208.391L139.176 207.718ZM151.371 225.549L153.59 222.222L153.585 222.219L151.371 225.549ZM169.793 231.184V227.185H169.771L169.749 227.185L169.793 231.184ZM164.011 319.338L162.367 315.692L163.789 323.331L164.011 319.338ZM175.835 317.966L176.805 321.846L176.812 321.844L176.82 321.842L175.835 317.966ZM168.846 317.123L170.524 320.753L170.524 320.753L168.846 317.123ZM175.946 313.925L177.513 317.605L177.531 317.597L177.549 317.589L175.946 313.925ZM181.618 313.629L180.684 317.518L180.695 317.52L180.707 317.523L181.618 313.629ZM195.555 318.819L197.143 322.489L205.143 319.026L197.3 315.221L195.555 318.819ZM189.661 318.782L187.826 322.335L187.833 322.339L187.841 322.343L189.661 318.782ZM181.138 228.334C180.449 225.934 179.051 224.304 178.255 223.339L172.085 228.429C172.953 229.481 173.278 229.94 173.45 230.54L181.138 228.334ZM178.255 223.339C178.087 223.136 177.949 222.968 177.818 222.803L171.554 227.777C171.739 228.01 171.926 228.235 172.085 228.429L178.255 223.339ZM177.789 222.767C174.304 218.479 172.944 213.195 171.923 206.994L164.031 208.294C165.086 214.697 166.691 221.794 171.583 227.812L177.789 222.767ZM171.922 206.99C171.009 201.481 173.207 196.581 176.142 190.386L168.914 186.962C166.161 192.773 162.645 199.934 164.032 208.298L171.922 206.99ZM176.142 190.386C176.231 190.198 176.321 190.008 176.411 189.818L169.181 186.398C169.092 186.585 169.003 186.773 168.914 186.962L176.142 190.386ZM176.415 189.81C181.438 179.13 189.043 170.13 197.32 161.076L191.417 155.679C183.088 164.79 174.754 174.548 169.177 186.406L176.415 189.81ZM197.312 161.085L197.634 160.735L191.747 155.321L191.425 155.67L197.312 161.085ZM197.634 160.735C200.97 157.107 204.045 153.775 207.628 150.955L202.681 144.67C198.51 147.953 195.013 151.768 191.746 155.321L197.634 160.735ZM207.642 150.944C209.139 149.755 210.941 148.081 212.056 145.294L204.629 142.324C204.261 143.244 203.691 143.868 202.668 144.681L207.642 150.944ZM211.632 141.535C211.006 140.629 210.387 139.689 209.732 138.695L203.053 143.097C203.699 144.077 204.368 145.092 205.053 146.083L211.632 141.535ZM209.732 138.695C208.339 136.583 206.792 134.229 204.997 132.019L198.789 137.063C200.291 138.912 201.625 140.93 203.053 143.097L209.732 138.695ZM205.006 132.031C202.644 129.102 201.753 126.541 201.741 124.237C201.728 121.907 202.611 119.285 204.826 116.251L198.366 111.535C195.467 115.506 193.718 119.762 193.742 124.28C193.767 128.825 195.582 133.085 198.78 137.051L205.006 132.031ZM204.826 116.251C205.347 115.537 205.863 114.823 206.371 114.119L199.884 109.439C199.375 110.146 198.872 110.842 198.366 111.535L204.826 116.251ZM206.371 114.119C209.276 110.092 211.938 106.421 215.196 103.277L209.643 97.5209C205.786 101.243 202.722 105.506 199.884 109.439L206.371 114.119ZM215.19 103.284L216.102 102.408L210.561 96.6391L209.65 97.5147L215.19 103.284ZM216.102 102.408C225.113 93.7532 234.012 85.2086 243.377 77.191L238.175 71.1153C228.608 79.3063 219.546 88.0108 210.561 96.6392L216.102 102.408ZM243.376 77.192C246.12 74.8439 249.143 73.011 252.512 71.5621L249.352 64.2144C245.308 65.9535 241.584 68.1984 238.176 71.1143L243.376 77.192ZM252.525 71.5563C253.803 71.0012 254.73 70.9289 255.444 71.0489C256.164 71.1699 257.03 71.5471 258.079 72.4918L263.43 66.5469C261.514 64.8225 259.304 63.5871 256.77 63.1613C254.232 62.7346 251.73 63.1813 249.339 64.2202L252.525 71.5563ZM258.078 72.4908C263.137 77.0481 266.685 82.8635 270.267 89.3259L277.263 85.4487C273.654 78.9365 269.566 72.0738 263.431 66.5479L258.078 72.4908ZM270.272 89.3342C276.412 100.353 281.104 112.043 285.213 124.115L292.785 121.538C288.591 109.218 283.72 97.0349 277.258 85.4405L270.272 89.3342ZM285.212 124.11C286.719 128.559 287.832 132.489 287.708 136.569L295.702 136.813C295.874 131.18 294.319 126.065 292.787 121.543L285.212 124.11ZM287.708 136.567C287.595 140.218 286.34 142.77 283.503 144.924L288.342 151.293C293.215 147.591 295.519 142.729 295.702 136.815L287.708 136.567ZM283.503 144.925C280.122 147.494 276.41 149.469 272.324 151.439L275.798 158.643C280.016 156.61 284.31 154.358 288.343 151.293L283.503 144.925ZM272.31 151.446C272.032 151.581 271.739 151.713 271.381 151.874L274.654 159.172C274.993 159.02 275.402 158.837 275.813 158.636L272.31 151.446ZM271.381 151.874C270.427 152.302 268.6 153.067 267.193 154.475L272.849 160.13C273.023 159.956 273.38 159.743 274.654 159.172L271.381 151.874ZM266.663 155.13C264.987 157.722 265.427 160.319 265.561 161.358L273.493 160.329C273.455 160.033 273.432 159.848 273.419 159.678C273.406 159.519 273.408 159.437 273.411 159.398C273.413 159.366 273.415 159.378 273.404 159.415C273.391 159.454 273.377 159.477 273.379 159.475L266.663 155.13ZM265.561 161.357L265.573 161.448L273.505 160.422L273.494 160.33L265.561 161.357ZM265.571 161.429C265.91 164.156 266.239 166.886 266.569 169.628L274.51 168.671C274.18 165.933 273.85 163.186 273.508 160.441L265.571 161.429ZM266.569 169.628C267.459 177.013 268.357 184.475 269.477 191.927L277.386 190.739C276.287 183.422 275.402 176.076 274.51 168.671L266.569 169.628ZM269.476 191.925C271.338 204.36 269.955 216.169 264.571 227.249L271.765 230.745C277.946 218.025 279.454 204.553 277.386 190.741L269.476 191.925ZM264.57 227.25C261.751 233.057 257.648 237.783 251.955 240.566L255.469 247.751C263.12 244.01 268.357 237.763 271.765 230.743L264.57 227.25ZM251.944 240.571C250.44 241.312 248.961 242.08 247.53 242.822L251.211 249.922C252.655 249.174 254.061 248.445 255.479 247.746L251.944 240.571ZM247.53 242.822C243.968 244.668 240.703 246.356 237.322 247.596L240.078 255.105C244.015 253.66 247.73 251.727 251.211 249.922L247.53 242.822ZM234.704 251.188C234.588 254.042 235.76 256.195 236.402 257.455L243.529 253.823C242.801 252.396 242.676 252.003 242.696 251.512L234.704 251.188ZM236.402 257.455C236.859 258.352 237.127 258.902 237.293 259.501L245 257.361C244.587 255.876 243.948 254.647 243.529 253.823L236.402 257.455ZM237.75 256.319C235.044 260.671 232.318 265.061 229.566 269.491L236.361 273.711C239.112 269.281 241.838 264.893 244.543 260.542L237.75 256.319ZM229.566 269.491C224.137 278.232 218.611 287.128 212.955 296.203L219.743 300.434C225.403 291.353 230.932 282.451 236.361 273.711L229.566 269.491ZM214.05 301.591C222.391 307.449 230.358 313.045 238.251 318.604L242.856 312.064C234.958 306.502 226.987 300.903 218.647 295.046L214.05 301.591ZM236.852 316.848C237.23 317.772 237.18 318.461 236.909 319.225C236.567 320.188 235.916 321.161 234.904 322.606L241.455 327.195C243.177 324.737 246.778 319.989 244.255 313.82L236.852 316.848ZM234.904 322.605C234.818 322.729 234.729 322.855 234.641 322.982L241.202 327.556C241.284 327.438 241.368 327.319 241.454 327.195L234.904 322.605ZM234.638 322.987C227.567 333.161 217.403 338.201 204.882 339.762L205.872 347.699C220.113 345.923 232.56 339.99 241.206 327.551L234.638 322.987ZM204.979 339.751C204.811 339.768 204.632 339.78 204.378 339.797L204.913 347.777C205.145 347.762 205.455 347.741 205.775 347.709L204.979 339.751ZM204.378 339.797C203.935 339.827 203.161 339.872 202.366 340.039L204.014 347.866C204.163 347.834 204.367 347.814 204.913 347.777L204.378 339.797ZM202.303 340.053C186.013 343.762 173.75 337.046 162.617 324.604L156.657 329.938C168.876 343.593 183.894 352.447 204.078 347.852L202.303 340.053ZM162.626 324.614C162.039 323.953 161.479 323.264 160.85 322.49L154.64 327.531C155.251 328.284 155.923 329.112 156.648 329.928L162.626 324.614ZM160.85 322.489C160.63 322.219 160.402 321.938 160.17 321.656L153.989 326.732C154.205 326.994 154.419 327.258 154.64 327.531L160.85 322.489ZM160.279 321.795C160.027 321.459 159.781 321.095 159.414 320.55L152.781 325.02C153.124 325.529 153.485 326.067 153.88 326.593L160.279 321.795ZM159.414 320.55C159.281 320.353 159.134 320.135 158.975 319.902L152.367 324.408C152.512 324.62 152.647 324.821 152.781 325.02L159.414 320.55ZM154.861 318.239C151.234 318.989 147.662 319.155 143.774 319.327L144.128 327.318C147.931 327.149 152.131 326.971 156.481 326.071L154.861 318.239ZM143.774 319.327C142.445 319.386 141.073 319.447 139.696 319.536L140.213 327.517C141.495 327.434 142.785 327.377 144.128 327.318L143.774 319.327ZM139.685 319.537C137.035 319.716 134.397 319.96 131.815 320.198L132.55 328.162C135.148 327.923 137.689 327.688 140.225 327.517L139.685 319.537ZM131.815 320.198C125.059 320.821 118.686 321.4 112.329 320.946L111.759 328.924C118.877 329.433 125.902 328.776 132.55 328.162L131.815 320.198ZM112.329 320.946C106.379 320.521 100.631 319.467 95.2718 317.419L92.4163 324.89C98.6956 327.29 105.254 328.46 111.759 328.924L112.329 320.946ZM95.2663 317.416C87.8973 314.612 80.7611 311.118 73.8946 307.07L69.8326 313.96C77.0514 318.216 84.5935 321.913 92.4218 324.892L95.2663 317.416ZM73.8935 307.069C66.3209 302.608 59.9941 296.461 54.2416 289.414L48.0453 294.471C54.154 301.955 61.1712 308.857 69.8337 313.961L73.8935 307.069ZM54.2351 289.406C43.1675 275.917 36.3391 260.49 33.5941 243.27L25.6955 244.529C28.6588 263.118 36.064 279.869 48.0517 294.479L54.2351 289.406ZM33.5951 243.275C32.6007 236.977 33.0395 230.576 33.5488 223.431L25.5707 222.862C25.0729 229.846 24.5335 237.168 25.6946 244.523L33.5951 243.275ZM33.5488 223.431C33.5648 223.206 33.5809 222.981 33.5969 222.756L25.6187 222.189C25.6027 222.413 25.5867 222.638 25.5707 222.862L33.5488 223.431ZM31.6634 225.903C36.2393 223.161 40.7784 220.446 45.3193 217.731L41.2141 210.866C36.6738 213.581 32.1316 216.298 27.5521 219.042L31.6634 225.903ZM45.3193 217.731C49.8597 215.015 54.4019 212.299 58.9815 209.555L54.8701 202.694C50.2942 205.436 45.7551 208.151 41.2141 210.866L45.3193 217.731ZM60.7086 204.827C58.8417 199.385 57.0308 194.083 55.249 188.866L47.68 191.451C49.4615 196.667 51.2742 201.974 53.143 207.422L60.7086 204.827ZM55.249 188.866C54.1315 185.594 53.0254 182.356 51.9248 179.14L44.3573 181.729C45.457 184.943 46.5624 188.179 47.68 191.451L55.249 188.866ZM51.3523 182.818C59.7438 171.512 70.9214 164.414 83.9532 159.486L81.1243 152.005C67.0976 157.309 54.4785 165.186 44.9298 178.051L51.3523 182.818ZM83.9604 159.483C89.11 157.525 94.3568 155.811 99.6999 154.153L97.329 146.514C91.9228 148.192 86.4944 149.962 81.1171 152.007L83.9604 159.483ZM99.7181 154.147C110.497 150.745 118.424 143.824 124.578 135.105L118.043 130.493C112.632 138.159 106.029 143.768 97.3107 146.519L99.7181 154.147ZM124.574 135.11C125.038 134.455 125.404 133.955 125.723 133.559C126.046 133.159 126.244 132.961 126.349 132.871C126.443 132.791 126.359 132.888 126.111 132.968C125.828 133.061 125.561 133.059 125.399 133.03L126.785 125.153C124.467 124.745 122.577 125.577 121.159 126.786C119.975 127.796 118.943 129.223 118.047 130.487L124.574 135.11ZM125.399 133.03C124.967 132.954 124.673 132.702 124.569 132.57C124.515 132.503 124.613 132.602 124.721 133.022C124.941 133.878 124.974 135.157 124.803 136.341L132.719 137.486C132.992 135.594 133.025 133.196 132.467 131.028C131.954 129.035 130.498 125.806 126.785 125.153L125.399 133.03ZM124.8 136.359C124.152 140.986 121.574 144.883 117.947 148.863L123.858 154.25C127.867 149.852 131.739 144.482 132.721 137.468L124.8 136.359ZM117.949 148.86C115.144 151.933 111.84 154.505 108.138 156.665L112.169 163.574C116.473 161.063 120.434 158.001 123.856 154.253L117.949 148.86ZM108.135 156.667C106.689 157.513 105.249 158.362 103.816 159.207L107.878 166.097C109.313 165.251 110.741 164.409 112.172 163.572L108.135 156.667ZM103.816 159.207C98.4701 162.359 93.2319 165.446 87.8732 168.255L91.5862 175.339C97.1517 172.422 102.562 169.231 107.878 166.097L103.816 159.207ZM87.8808 168.251C67.3449 178.958 57.7733 196.918 53.918 218.086L61.7869 219.519C65.3449 199.983 73.8618 184.58 91.5785 175.343L87.8808 168.251ZM53.9172 218.09C50.8244 235.182 54.83 250.989 63.3999 265.17L70.2453 261.033C62.5059 248.227 59.0982 234.378 61.7877 219.514L53.9172 218.09ZM63.4014 265.173C74.0208 282.714 90.4108 291.957 110.574 293.957L111.364 285.998C93.4224 284.218 79.4178 276.185 70.2437 261.031L63.4014 265.173ZM110.564 293.956C118.019 294.714 124.613 290.481 128.918 285.373C133.197 280.296 136.106 273.319 135.202 267.087L127.286 268.236C127.754 271.457 126.178 276.213 122.802 280.218C119.454 284.192 115.224 286.391 111.373 285.999L110.564 293.956ZM135.204 267.1C134.382 261.306 132.412 256.048 129.605 251.115L122.653 255.071C125.035 259.257 126.624 263.563 127.285 268.223L135.204 267.1ZM129.595 251.098C127.424 247.323 125.004 243.76 122.678 240.331L116.059 244.821C118.412 248.29 120.663 251.611 122.663 255.087L129.595 251.098ZM122.678 240.331C121.522 238.626 120.388 236.954 119.285 235.264L112.586 239.634C113.735 241.395 114.909 243.126 116.059 244.821L122.678 240.331ZM119.283 235.26C113.834 226.926 110.108 218.291 109.739 208.786L101.746 209.097C102.192 220.574 106.695 230.622 112.588 239.637L119.283 235.26ZM109.739 208.791C109.009 189.404 116.123 174.338 132.356 163.481L127.909 156.833C109.224 169.33 100.919 187.108 101.746 209.092L109.739 208.791ZM132.355 163.482C135.34 161.486 138.47 159.681 141.737 157.799L137.745 150.869C134.516 152.728 131.153 154.664 127.91 156.832L132.355 163.482ZM141.737 157.799C146.146 155.26 150.81 152.579 155.153 149.298L150.332 142.916C146.452 145.847 142.224 148.288 137.745 150.869L141.737 157.799ZM155.142 149.306C158.855 146.521 162.303 143.491 165.628 140.464L160.244 134.549C156.971 137.528 153.747 140.355 150.343 142.908L155.142 149.306ZM165.624 140.468C172.056 134.628 173.512 125.226 171.403 117.1C169.264 108.858 163.254 100.999 153.546 98.2223L151.346 105.912C157.837 107.769 162.094 113.071 163.661 119.11C165.259 125.266 163.861 131.266 160.248 134.546L165.624 140.468ZM153.556 98.2251C146.763 96.2635 140.573 98.5327 135.566 101.315L139.451 108.306C143.785 105.898 147.603 104.831 151.337 105.909L153.556 98.2251ZM135.554 101.321C134.889 101.694 133.949 102.08 133.253 102.241C132.876 102.329 132.86 102.282 133.094 102.308C133.23 102.324 133.596 102.381 134.041 102.627C134.534 102.901 135.049 103.372 135.374 104.056L128.152 107.492C129.155 109.601 131.153 110.138 132.194 110.256C133.27 110.377 134.307 110.208 135.062 110.032C136.63 109.668 138.274 108.965 139.463 108.3L135.554 101.321ZM135.54 104.458C135.701 104.922 135.498 105.071 135.678 104.703C135.752 104.553 135.869 104.368 136.031 104.172C136.193 103.978 136.372 103.807 136.544 103.675L131.653 97.346C130.398 98.3155 129.245 99.6521 128.494 101.188C127.758 102.691 127.203 104.842 127.987 107.09L135.54 104.458ZM136.524 103.69C143.56 98.3219 151.52 96.5375 160.306 97.9354L161.563 90.0364C150.778 88.3204 140.575 90.5395 131.673 97.3307L136.524 103.69ZM160.309 97.9358C163.013 98.3642 165.729 99.4023 168.89 100.63L171.786 93.1743C168.779 92.0064 165.257 90.6217 161.56 90.036L160.309 97.9358ZM168.89 100.63C169.412 100.833 169.946 101.04 170.481 101.244L173.332 93.7711C172.823 93.577 172.311 93.3784 171.786 93.1743L168.89 100.63ZM170.502 101.252C172.555 102.022 174.339 103.517 176.035 105.66L182.308 100.698C180.074 97.8741 177.188 95.2174 173.31 93.7631L170.502 101.252ZM176.032 105.657C176.225 105.901 176.413 106.181 176.705 106.623L183.378 102.214C183.116 101.818 182.746 101.254 182.31 100.701L176.032 105.657ZM176.705 106.623C176.908 106.93 177.175 107.336 177.471 107.739L183.911 102.994C183.756 102.784 183.6 102.55 183.378 102.214L176.705 106.623ZM177.555 107.848C183.007 114.739 184.932 121.761 184.596 128.523C184.257 135.37 181.579 142.211 177.393 148.533L184.063 152.948C188.81 145.777 192.156 137.567 192.585 128.919C193.018 120.185 190.459 111.267 183.827 102.885L177.555 107.848ZM177.394 148.533C172.208 156.364 165.28 162.841 157.609 168.876L162.555 175.162C170.526 168.89 178.202 161.799 184.062 152.949L177.394 148.533ZM157.611 168.875C151.884 173.375 145.888 178.369 141.36 185L147.965 189.511C151.74 183.982 156.864 179.635 162.553 175.164L157.611 168.875ZM141.359 185.001C136.809 191.667 133.7 199.315 135.233 208.385L143.12 207.052C142.058 200.775 144.064 195.225 147.965 189.51L141.359 185.001ZM135.234 208.391C136.791 217.516 142.14 224.214 149.157 228.88L153.585 222.219C148 218.506 144.231 213.564 143.119 207.046L135.234 208.391ZM149.153 228.877C155.201 232.91 162.207 235.267 169.837 235.183L169.749 227.185C163.888 227.249 158.439 225.455 153.59 222.222L149.153 228.877ZM169.793 235.183C172.778 235.183 175.871 234.742 179.187 232.96L175.401 225.915C173.574 226.896 171.884 227.185 169.793 227.185V235.183ZM163.789 323.331C169.053 323.623 173.104 322.771 176.805 321.846L174.865 314.086C171.45 314.94 168.31 315.571 164.233 315.345L163.789 323.331ZM167.168 313.492C165.644 314.197 164.065 314.926 162.367 315.692L165.655 322.983C167.392 322.2 169.003 321.456 170.524 320.753L167.168 313.492ZM174.38 310.246C171.992 311.262 169.643 312.348 167.168 313.492L170.524 320.753C173.02 319.599 175.257 318.565 177.513 317.605L174.38 310.246ZM182.551 309.74C180.174 309.17 177.18 309.02 174.343 310.262L177.549 317.589C178.271 317.273 179.354 317.198 180.684 317.518L182.551 309.74ZM197.3 315.221C192.169 312.731 187.506 310.899 182.528 309.735L180.707 317.523C184.922 318.509 189.007 320.087 193.809 322.417L197.3 315.221ZM187.841 322.343C189.046 322.958 190.468 323.454 192.147 323.519C193.818 323.584 195.473 323.212 197.143 322.489L193.966 315.149C193.153 315.5 192.695 315.536 192.457 315.527C192.227 315.518 191.944 315.458 191.481 315.221L187.841 322.343ZM176.82 321.842C181.084 320.759 184.566 320.651 187.826 322.335L191.496 315.228C185.712 312.241 179.927 312.801 174.851 314.09L176.82 321.842Z" fill="#09275E" mask="url(#path-14-outside-1_503_366)"></path><path d="M89.8915 57.0404L88.8306 56.4518L87.8186 57.121C83.1444 60.2119 78.8785 63.8126 74.7973 67.2575C72.8793 68.8764 71.0021 70.4608 69.1426 71.9418L68.5392 72.4223L68.4148 73.1836C67.5559 78.4416 67.2125 83.6401 66.8775 88.7105C66.7295 90.952 66.583 93.1685 66.3945 95.3539L66.2979 96.4726L67.2029 97.1374C73.7731 101.964 80.2245 106.589 87.0594 110.997L88.5282 111.944L89.6634 110.615C99.2102 99.4404 108.42 88.6371 117.806 77.6265L119.17 76.0265L120.755 74.1671L118.619 72.9811C109.997 68.1945 101.84 63.6689 93.2746 58.9173C92.1545 58.2959 91.0275 57.6706 89.8915 57.0404Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M234.144 227.534C245.264 227.497 253.864 218.785 253.752 207.738C253.641 196.876 245.116 188.387 234.218 188.313C223.173 188.239 214.388 196.95 214.351 207.886C214.351 218.859 223.098 227.571 234.144 227.497V227.534ZM209.495 195.542C209.569 185.421 201.711 177.377 191.74 177.303C181.992 177.229 173.911 185.162 173.8 194.912C173.652 205.402 181.436 213.336 191.814 213.261C201.785 213.224 209.495 205.514 209.532 195.542H209.495Z" fill="white"></path><path d="M326.03 255.941L327.06 254.494L325.746 253.3C314.068 242.697 302.688 232.39 290.938 221.751L289.436 220.391L288.096 221.911C283.602 227.006 279.159 232.049 274.717 237.092C269.007 243.574 263.297 250.056 257.48 256.645L256.053 258.262L257.773 259.563C263.62 263.986 269.634 267.923 275.55 271.755C276.01 272.053 276.47 272.351 276.929 272.648C281.952 275.898 286.886 279.092 291.64 282.498C291.145 283.634 290.505 284.695 289.809 285.85C289.759 285.934 289.708 286.018 289.657 286.103C288.682 287.723 287.577 289.599 287.15 291.848L286.96 292.846L287.654 293.588C289.462 295.519 291.386 296.901 293.747 298.2L295.305 299.056L296.338 297.61C303.314 287.843 310.216 278.15 317.28 268.227C320.164 264.177 323.075 260.088 326.03 255.941Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M338.304 204.327L340.616 203.887L339.809 201.677C337.196 194.522 334.629 187.488 332.062 180.454L332.06 180.448C329.493 173.416 326.927 166.384 324.315 159.231L323.572 157.196L321.603 158.099C312.602 162.228 303.999 166.201 295.438 170.155C292.927 171.315 290.419 172.474 287.905 173.634L286.432 174.314L286.794 175.895C287.483 178.907 288.165 181.885 288.842 184.842C290.824 193.497 292.764 201.972 294.726 210.591L295.153 212.471L297.048 212.112C303.286 210.93 309.385 209.783 315.447 208.643C323.058 207.212 330.611 205.792 338.304 204.327Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M37.3088 70.9943L35.2298 70.8135L35.1379 72.8983C34.8368 79.7309 35.1199 86.2832 35.4538 92.655C35.4925 93.3945 35.5319 94.1312 35.5712 94.8654C35.8716 100.484 36.1646 105.96 36.0998 111.479L36.0783 113.317L37.9082 113.493C49.9545 114.649 61.3173 115.099 73.3255 114.575L74.9709 114.504L75.2157 112.875C76.5829 103.776 77.4526 94.7227 78.3254 85.6351C78.6885 81.8548 79.0522 78.0687 79.4525 74.271L79.676 72.1506L77.5456 72.0635C72.0999 71.8409 66.7299 71.813 61.4159 71.7853C60.05 71.7782 58.6877 71.7711 57.3289 71.7607C50.6626 71.7098 44.0466 71.5803 37.3088 70.9943Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M293.135 284.096L294.283 282.389L292.544 281.29C285.636 276.922 278.849 272.64 272.089 268.375C264.438 263.547 256.821 258.742 249.103 253.858L247.365 252.759L246.315 254.526C242.757 260.514 239.237 266.431 235.729 272.329C230.832 280.561 225.958 288.754 221.035 297.047L220.055 298.697L221.664 299.744C226.371 302.807 231.013 305.901 235.644 308.988C244.5 314.891 253.318 320.77 262.487 326.355L264.121 327.35L265.187 325.762C269.467 319.393 273.673 313.115 277.875 306.842C282.927 299.301 287.973 291.769 293.135 284.096Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M4.6069 136.87L3.32656 138.114L4.41714 139.527C5.45766 140.875 6.49509 142.219 7.53067 143.56C13.6143 151.443 19.6343 159.242 25.8437 167.258L26.9528 168.69L28.4871 167.727C34.6363 163.87 40.6597 160.096 46.7543 156.277C50.6154 153.858 54.505 151.421 58.4733 148.933L60.4036 147.723L58.9534 145.966C49.8109 134.89 40.7098 124.525 31.3269 113.991L29.9405 112.435L28.4429 113.884C24.7686 117.442 21.1619 120.91 17.5712 124.363C13.2568 128.511 8.96536 132.638 4.6069 136.87Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M24.1438 220.764L24.7235 223.219L26.9813 222.095C35.2305 217.986 42.7267 213.623 50.2998 209.214C51.4696 208.534 52.6413 207.852 53.8179 207.169L55.3098 206.304L54.6731 204.701C53.3352 201.333 52.2061 197.943 51.0558 194.489C50.8421 193.847 50.6276 193.203 50.411 192.557C49.0368 188.457 47.5826 184.287 45.7024 180.146L44.9085 178.398L43.1293 179.12C41.6769 179.71 40.2302 180.291 38.7892 180.87C31.8672 183.65 25.0751 186.377 18.3958 189.795L17.0028 190.508L17.3598 192.031C18.8458 198.372 20.3156 204.583 21.8347 211.001C22.5895 214.19 23.3566 217.431 24.1438 220.764Z" fill="#58C2DB" stroke="#09275E" stroke-width="3.99916"></path><path d="M223.136 212.372C225.063 210.629 227.658 211.037 228.733 208.553C228.918 204.179 224.841 205.959 222.765 204.921C221.876 199.99 224.1 195.468 228.066 193.985C231.735 192.576 236.369 194.244 238.741 198.211C241.669 203.141 241.558 208.405 239.297 213.521C238.111 216.227 235.664 217.895 232.551 217.747C228.659 217.525 224.952 216.82 223.136 212.409V212.372Z" fill="#09275E"></path><path d="M190.814 197.247C188.923 196.024 186.996 196.802 185.365 196.098C183.919 191.538 186.625 185.57 190.999 183.716C194.891 182.085 199.784 184.198 201.971 188.721C204.046 193.021 204.195 197.655 202.638 202.066C200.303 208.739 193.445 209.406 187.811 203.512C188.404 201.992 190.517 202.363 190.851 201.362C191.926 199.62 191.815 198.433 190.851 197.21L190.814 197.247Z" fill="#09275E"></path><path d="M258.547 165.167C259.667 168.526 263.813 172.965 265.746 174.765C266.945 172.765 265.182 164.595 264.946 163.767C264.346 159.768 264.546 158.768 264.946 155.369C265.346 151.97 273.544 151.17 281.342 146.771C289.141 142.372 287.541 134.373 286.341 130.374C285.307 126.927 283.142 122.976 281.742 119.776C280.342 116.577 271.944 101.98 269.945 98.3807C267.945 94.7815 266.145 93.5817 265.746 93.5817C265.346 93.5817 264.346 93.5817 265.346 98.3807C265.876 100.926 267.345 108.779 267.745 110.378C268.145 111.978 268.945 124.175 268.345 129.174C267.865 133.173 266.145 137.639 265.346 139.372C265.012 137.906 264.106 134.533 263.146 132.774C261.946 130.574 260.147 126.775 258.547 125.175C256.948 123.575 255.748 122.176 253.748 121.776C251.748 121.376 255.548 127.775 257.147 132.774C258.747 137.773 256.948 142.372 257.147 147.97C257.347 153.569 257.147 160.968 258.547 165.167Z" fill="#FFA220"></path><path d="M232.123 270.553C232.123 267.25 229.599 264.176 227.693 261.583C226.593 260.086 225.628 258.278 224.349 256.998" stroke="#FFBB34" stroke-width="1.19975" stroke-linecap="round"></path><path d="M232.521 269.158C232.057 267.59 231.444 266.408 230.373 265.104C228.229 262.495 226.282 259.735 224.216 257.065C222.613 254.994 220.993 252.315 220.163 249.822" stroke="#FFBB34" stroke-width="1.19975" stroke-linecap="round"></path><path d="M229.953 263.546C231.553 266.266 232.753 269.611 233.153 270.945L238.352 262.746L234.752 255.348C233.553 253.548 233.553 251.349 233.553 249.549C233.553 247.749 237.552 247.35 238.752 246.55C239.951 245.75 240.751 245.75 242.751 244.15C244.75 242.551 247.95 240.351 248.349 238.751C248.749 237.152 241.151 240.151 239.151 240.751C237.152 241.351 233.953 242.55 232.353 243.35C230.753 244.15 226.354 245.35 223.155 246.55C219.955 247.749 220.155 250.549 220.355 251.949C220.555 253.348 223.955 255.948 224.554 256.348C225.154 256.748 227.954 260.147 229.953 263.546Z" fill="#FFA220"></path>', 30)
  ]));
}
const BluepicLogo = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$2]]), _hoisted_1$b = {
  key: 0,
  class: "nav-wrapper"
}, _hoisted_2$8 = {
  key: 0,
  class: "branding"
}, _hoisted_3$6 = { class: "logo" }, _hoisted_4$4 = { class: "actions" }, _hoisted_5$3 = { class: "editor-inner" }, _hoisted_6$2 = {
  key: 0,
  class: "view-desktop"
}, _hoisted_7$2 = { class: "fields-view" }, _hoisted_8$2 = {
  key: 0,
  class: "slides-nav-wrapper"
}, _hoisted_9$2 = {
  key: 1,
  class: "form-extra-wrapper"
}, _hoisted_10$2 = { class: "time-meta-wrapper" }, _hoisted_11$2 = { class: "play-controls" }, _hoisted_12$1 = { class: "live-view-inner" }, _hoisted_13$1 = ["src"], _hoisted_14$1 = ["src"], _hoisted_15$1 = {
  key: 0,
  class: "timeline-wrapper"
}, _hoisted_16$1 = { class: "time-meta-wrapper" }, _hoisted_17 = { class: "play-controls" }, _hoisted_18 = { class: "form-extra-wrapper" }, _hoisted_19 = ["src"], _hoisted_20 = {
  key: 0,
  class: "timeline-wrapper"
}, _hoisted_21 = { class: "time-meta-wrapper" }, _hoisted_22 = { class: "play-controls" }, _hoisted_23 = { class: "fields-view" }, _hoisted_24 = {
  key: 0,
  class: "slides-nav-wrapper"
}, _hoisted_25 = {
  key: 1,
  class: "form-extra-wrapper"
}, _hoisted_26 = { class: "stack-nav-wrapper" }, _hoisted_27 = {
  key: 0,
  class: "branding"
}, _hoisted_28 = { class: "logo" }, _hoisted_29 = { class: "actions" }, _hoisted_30 = {
  key: 3,
  class: "view-kiosk"
}, _hoisted_31 = { class: "kiosk-field-wrapper" }, _hoisted_32 = {
  key: 0,
  class: "navigation-view"
}, _hoisted_33 = { class: "toolbar" }, _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "BluepicEmbeddedEditor",
  props: /* @__PURE__ */ mergeModels({
    data: {},
    displayMode: {},
    templateId: {},
    studioResourcesBaseUrl: {},
    cloudflarePagesHostname: {},
    bxCoreVersion: {},
    authorization: {},
    asyncSerial: { type: Boolean },
    baseSerial: {},
    preview: {},
    resolution: {},
    webgl: { type: Boolean },
    fonts: {},
    bridge: {},
    watermark: {},
    zoomAndPan: { type: Boolean },
    exportActions: {},
    embedProjectId: {},
    embedV2Server: {},
    branding: { type: Boolean },
    showNavBar: { type: Boolean, default: !0 }
  }, {
    serial: {
      required: !1
    },
    serialModifiers: {},
    ready: { type: Boolean, required: !1 },
    readyModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["update:data", "update:globalScope", "handle-export-action"], ["update:serial", "update:ready"]),
  setup(m, { expose: c, emit: ie }) {
    const we = m, $e = ie, Me = ref$1(we.data ?? {}), Ze = useModel(m, "serial"), ne = useModel(m, "ready"), rr = ref$1(), { width: gr, height: or } = useElementBounding(rr);
    watchEffect(() => {
      $e("update:data", Me.value);
    }), onMounted(() => {
      console.log("!!!!!!!!!!!", we);
    });
    const _r = computed(() => we.embedProjectId), Lr = computed(() => we.templateId);
    provide("data", Me), provide("bridge", we.bridge);
    const Ir = ref$1(), { width: Ar, height: Rr } = useElementBounding(Ir), Nr = ref$1(), { width: Yr } = useWindowSize(), Vr = ref$1([]), Xr = computed(() => {
      if (!Nr.value?.aspectRatio)
        return;
      const Mn = Nr.value.bluepicLiveTemplateRootWidth * Nr.value.aspectRatio;
      return Rr.value - Mn;
    }), Wr = computed(() => we.displayMode === "auto" ? Yr.value > 768 ? "desktop" : "mobile" : we.displayMode);
    function si() {
      !Nr.value || (Nr.value.transform = { x: 0, y: 0, scale: 1, rotate: 0 });
    }
    const li = computed(() => Nr.value?.bluepicLiveTemplateRootWidth), xi = computed(() => Nr.value?.bluepicLiveTemplateRootHeight);
    watch([li, xi], si);
    const di = ref$1(!1), oi = () => di.value = !0, ci = ref$1();
    function vr(Mn) {
      ci.value = Mn;
    }
    function Ae() {
      if (!(!Ze.value?.frames || !ci.value) && Wr.value === "mobile") {
        const Mn = ze.value[ci.value.activeIndex], pn = [Mn.originalField, ...Mn.fields].find(
          (Rn) => Rn?.frameIndex !== void 0
        )?.frameIndex;
        if (pn !== void 0 && Ze.value.frames && Ze.value.frames.x > 0 && Ze.value.frames.y > 0) {
          const Rn = (pn - 1) % Ze.value.frames.x, Io = Math.floor((pn - 1) / Ze.value.frames.x);
          Nr.value?.applyTranformBasedOnFrame(Rn + 1, Io + 1);
        }
      }
    }
    const { mobileFields: ze } = useMobileFields(Vr), Ue = [Navigation, Pagination, Scrollbar, A11y];
    computed(() => Vr.value.map((Mn) => Mn.hitbox).filter((Mn) => Mn));
    function tr({ x: Mn, y: pn }) {
      console.log("Matrix click", Mn, pn);
    }
    const lr = computed(() => ze.value.reduce((Mn, pn) => [...Mn, ...pn.fields], [])), pr = ref$1(0), br = ref$1(!1), nr = computed(() => lr.value.map((Mn, pn) => ({
      label: getFieldDescription(Mn),
      value: pn,
      icon: () => renderFieldIcon(Mn.type, pn === pr.value)
    }))), Pe = computed(() => nr.value.find(({ value: Mn }) => Mn === pr.value)?.label), ur = computed(() => Yr.value <= 768);
    function Pr(Mn) {
      pr.value = Mn, br.value = !0, lr.value[Mn];
    }
    const Hr = computed(() => pr.value < lr.value.length - 1), vi = computed(() => pr.value > 0);
    function Ti() {
      Hr.value && Pr(pr.value + 1);
    }
    function wi() {
      vi.value && Pr(pr.value - 1);
    }
    const ii = computed(() => lr.value[pr.value]), mi = computed(() => Object.values(Ze.value?.frames ?? { x: 1, y: 1 }).reduce((Mn, pn) => pn * Mn, 1)), ei = computed(() => mi.value > 1), Zr = computed({
      get() {
        if (!Ze.value?.frames || !ei.value)
          return;
        const { x: Mn, y: pn } = Nr.value?.closestFrame ?? { x: 1, y: 1 }, Rn = Mn - 1;
        return (pn - 1) * Ze.value.frames.x + Rn + 1;
      },
      set(Mn) {
        if (Mn === void 0 || !ei.value || !Ze.value?.frames)
          return;
        const pn = Mn - 1, Rn = pn % Ze.value.frames.x, Io = Math.floor(pn / Ze.value.frames.x);
        Nr.value?.applyTranformBasedOnFrame(Rn + 1, Io + 1);
      }
    }), pi = computed(() => Nr.value?.globalScope ?? {});
    watchEffect(() => {
      $e("update:globalScope", pi.value);
    }), provide("computedPropEvaluator", (Mn) => new Function(...Object.keys(pi.value), `return (${Mn.toString()})()`)(
      ...Object.values(pi.value)
    ));
    const Oi = useSlots(), qi = (Mn) => {
      !Mn || (Vr.value = (Mn.fields ?? Mn?.meta.fields.map(convertDeprecatedField).filter((pn) => pn !== void 0)).map(realizeField).filter((pn) => ei.value && Wr.value !== "mobile" ? (pn.frameIndex ?? 1) === Zr.value : !0), Me.value = {
        ...Me.value,
        ...Mn.bindings
      }, console.log("INITIALIZED FIELDS", Vr.value, Me.value));
    };
    we.baseSerial && qi(we.baseSerial);
    const yn = computed(() => (Ze.value ?? we.baseSerial)?.animation);
    watch(Ze, () => {
      qi(Ze.value);
    }), watch(Zr, () => {
      Wr.value !== "mobile" && qi(Ze.value);
    }), watch(Wr, () => {
      qi(Ze.value);
    });
    const sn = ref$1(0);
    watchEffect(() => {
      Ze.value?.animation && (Me.value.TIME = sn.value);
    });
    const $n = computed(() => 1 / (Ze.value?.animation?.fps ?? 30)), rn = ref$1($n.value), ji = ref$1(!1), Kn = ref$1(!0);
    let In = 0, Fn = 0;
    function Po() {
      ji.value = !ji.value, ji.value && (In = Date.now(), Fn = sn.value);
      function Mn() {
        const pn = Ze.value?.animation.duration ?? 120;
        if (ji.value) {
          const Rn = (Date.now() - In) / 1e3 % pn, to = Fn - Fn % rn.value + Rn, no = to - to % rn.value;
          no > pn ? Kn.value ? sn.value = 0 : (ji.value = !1, sn.value = pn) : sn.value = no, requestAnimationFrame(Mn);
        }
      }
      Mn();
    }
    const vn = computed(() => {
      const Mn = we.exportActions ?? [];
      return Mn.length === 0 ? [
        {
          renderFormat: "png",
          trigger: "user-gesture",
          label: "Download",
          download: !0,
          successMessage: "Image downloaded",
          webhook: void 0,
          redirect: void 0
        }
      ] : Mn;
    }), Vn = computed(() => vn.value.filter((Mn) => Mn.trigger === "user-gesture" || !Mn.trigger).map((Mn, pn) => ({
      label: Mn.label,
      value: pn
    }))), Xo = computed(() => vn.value.filter((Mn) => Mn.trigger === "onupdate"));
    watch(
      Me,
      useDebounceFn(() => {
        for (const Mn of Xo.value)
          Ci(vn.value.indexOf(Mn));
      }, 1e3),
      {
        deep: !0
      }
    );
    const Xn = import("https://openfpcdn.io/fingerprintjs/v4").then((Mn) => Mn.load()).then((Mn) => Mn.get()), Yn = nanoid(), Wo = ref$1(!1);
    async function Ci(Mn) {
      const pn = vn.value[Mn];
      if (!pn)
        return;
      $e("handle-export-action", pn), Wo.value = !0;
      let Rn = null, Io = null;
      if (console.log("exportAction", pn), pn.renderFormat !== "none")
        if (Ze.value?.animation?.enabled) {
          if (pn.trigger === "onupdate")
            return Wo.value = !1, console.error("onupdate is not supported for video export");
          const Qn = await yi("mp4", Ze.value.animation.duration * 1e3, `${Ze.value?.name}`);
          Rn = Qn.files, Io = Qn.creditsConsumed;
        } else {
          if (pn.trigger === "onupdate")
            return Wo.value = !1, console.error("onupdate is not supported for image export");
          const Qn = await ri(pn.renderFormat, `${Ze.value?.name}`, void 0);
          Rn = Qn.files, Io = Qn.creditsConsumed;
        }
      Rn !== null && pn.download && pn.trigger === "user-gesture" && await downloadFiles(Rn, `${Ze.value?.name}`);
      const to = {
        PRIMARY_COLOR: "#47AFD5FF",
        SECONDARY_COLOR: "#474FB1FF",
        TERTIARY_COLOR: "#D6AFC7FF",
        LOGO_IMAGE_LIGHT: "https://imagedelivery.net/mudX-CmAqIANL8bxoNCToA/94fda3e8-3770-4052-21df-a669c761c600/public",
        LOGO_IMAGE_DARK: "https://imagedelivery.net/mudX-CmAqIANL8bxoNCToA/894acbb8-37a0-452a-5c10-2ca63b487800/public",
        DISPLAY_FONT: "Unbounded",
        BODY_FONT: "Inter",
        FOO: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIC8+Cjwvc3ZnPg==",
        MAPBOX_ACCESS_TOKEN: "pk.eyJ1IjoibWF1cmljZS1jb25yYWQiLCJhIjoiY2w5eTllbnNwMDMycTNubG5mYmd5bDl1MCJ9.VjV0KzTnJ6nbK2kZejkHaQ"
      }, no = await Xn, ma = {
        templateId: Lr.value,
        data: Object.fromEntries(
          Object.entries(Me.value).filter(([Qn, co]) => !(Qn === "TIME" && !Ze.value?.animation?.enabled || Qn in to && co === to[Qn]))
        ),
        embedProjectId: _r.value,
        files: Rn,
        creditsConsumed: Io,
        sessionId: Yn,
        userAgent: navigator.userAgent,
        visitorId: no.visitorId,
        visitorConfidence: no.confidence.score
      };
      if (pn.webhook)
        try {
          const Qn = await fetch(pn.webhook, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(ma)
          }), co = await Qn.text();
          Qn.ok || console.error("Webhook failed", co), console.log("Webhook result", co), pn.successMessage && createMessage({
            type: "success",
            message: pn.successMessage,
            closeAfter: 5e3
          });
        } catch (Qn) {
          console.error("Webhook error", Qn);
        }
      if ((Rn !== null || pn.webhook) && pn.successMessage && pn.successMessage, Wo.value = !1, pn.redirect && pn.trigger === "user-gesture") {
        const Qn = new URL(pn.redirect);
        Qn.searchParams.set("context", JSON.stringify(ma)), window.location = Qn.toString();
      }
    }
    const { render: ri, renderVideo: yi, videoFiles: Li, videoProgress: Yi, videoRendering: zn } = useRenderer(
      we.embedV2Server,
      Nr,
      Ze,
      _r,
      Lr,
      Me
    ), un = computed(() => {
      if (!Yi.value || !(Yi.value.type === "keyframe" || Yi.value.type === "encode_video" || Yi.value.type === "encode_audio"))
        return;
      const Mn = {
        keyframe: 0.8,
        encode_video: 0.1,
        encode_audio: 0.1
      }, pn = Object.values(Mn).reduce((no, ma) => no + ma, 0), Rn = Object.keys(Mn).findIndex((no) => no === Yi.value?.type), Io = Object.values(Mn).slice(0, Rn).reduce((no, ma) => no + ma, 0), to = Mn[Yi.value.type] * (Yi.value.frame / Yi.value.totalFrames);
      return (Io + to) / pn * 100;
    });
    c({
      bluepicLiveTemplateRef: Nr,
      slidesNavIndex: Zr,
      serial: Ze
    });
    function Gn() {
      window.open("https://bluepic.io", "_blank");
    }
    return (Mn, pn) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bluepic-embedded-editor", { "display-mode-stack": Wr.value === "stack" }])
    }, [
      Wr.value !== "stack" && Mn.showNavBar ? (openBlock(), createElementBlock("div", _hoisted_1$b, [
        Mn.branding ? (openBlock(), createElementBlock("div", _hoisted_2$8, [
          createElementVNode("div", {
            class: "branding-wrapper",
            onClick: Gn
          }, [
            createElementVNode("div", _hoisted_3$6, [
              createVNode(BluepicLogo)
            ]),
            pn[22] || (pn[22] = createElementVNode("div", { class: "content" }, [
              createElementVNode("span", { class: "main" }, " Design Template "),
              createElementVNode("span", { class: "sub" }, " shared with Bluepic ")
            ], -1))
          ])
        ])) : createCommentVNode("", !0),
        createElementVNode("div", _hoisted_4$4, [
          Vn.value.length >= 2 ? (openBlock(), createBlock(BxDropdown, {
            key: 0,
            options: Vn.value,
            onSelect: Ci
          }, {
            trigger: withCtx(() => [
              createVNode(BxButton, {
                secondary: "",
                loading: (Wo.value || unref(zn)) && un.value === void 0,
                disabled: Wo.value || unref(zn)
              }, {
                icon: withCtx(() => [
                  un.value !== void 0 ? (openBlock(), createBlock(CircularProgress, {
                    key: 0,
                    color: "#ff0000",
                    class: "export-button-circular-progress",
                    progress: un.value
                  }, null, 8, ["progress"])) : (openBlock(), createBlock(BxIcon, { key: 1 }, {
                    default: withCtx(() => [
                      createVNode(unref(ArrowRedoOutline))
                    ]),
                    _: 1
                  }))
                ]),
                default: withCtx(() => [
                  pn[23] || (pn[23] = createTextVNode(" Export "))
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          }, 8, ["options"])) : Vn.value.length === 1 ? (openBlock(), createBlock(BxButton, {
            key: 1,
            secondary: "",
            onClick: pn[0] || (pn[0] = (Rn) => Ci(0)),
            loading: (Wo.value || unref(zn)) && un.value === void 0,
            disabled: Wo.value || unref(zn)
          }, {
            icon: withCtx(() => [
              un.value !== void 0 ? (openBlock(), createBlock(CircularProgress, {
                key: 0,
                color: "#ff0000",
                class: "export-button-circular-progress",
                progress: un.value
              }, null, 8, ["progress"])) : (openBlock(), createBlock(BxIcon, { key: 1 }, {
                default: withCtx(() => [
                  createVNode(unref(ArrowRedoOutline))
                ]),
                _: 1
              }))
            ]),
            default: withCtx(() => [
              createTextVNode(" " + toDisplayString(vn.value[0].label), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"])) : createCommentVNode("", !0)
        ])
      ])) : createCommentVNode("", !0),
      createElementVNode("div", _hoisted_5$3, [
        Wr.value === "desktop" ? (openBlock(), createElementBlock("div", _hoisted_6$2, [
          createElementVNode("div", _hoisted_7$2, [
            ei.value && Zr.value ? (openBlock(), createElementBlock("div", _hoisted_8$2, [
              createVNode(SlidesNavigation, {
                length: mi.value,
                index: Zr.value,
                "onUpdate:index": pn[1] || (pn[1] = (Rn) => Zr.value = Rn)
              }, null, 8, ["length", "index"])
            ])) : createCommentVNode("", !0),
            createVNode(_sfc_main$p, { fields: Vr.value }, null, 8, ["fields"]),
            Oi["form-extra"] ? (openBlock(), createElementBlock("div", _hoisted_9$2, [
              renderSlot(Mn.$slots, "form-extra", {}, void 0, !0)
            ])) : createCommentVNode("", !0)
          ]),
          createElementVNode("div", {
            class: normalizeClass(["live-view", { ready: ne.value }])
          }, [
            yn.value?.enabled ? (openBlock(), createElementBlock("div", {
              key: 0,
              ref_key: "timelineWrapperRef",
              ref: rr,
              class: "timeline-wrapper"
            }, [
              createElementVNode("div", _hoisted_10$2, toDisplayString(unref(timestampToTimecode)(sn.value * 1e3, ",")) + " / " + toDisplayString(unref(timestampToTimecode)((yn.value.duration ?? 120) * 1e3, ",")), 1),
              createVNode(BxSlider, {
                modelValue: sn.value,
                "onUpdate:modelValue": pn[2] || (pn[2] = (Rn) => sn.value = Rn),
                min: 0,
                step: rn.value,
                max: yn.value.duration ?? 120
              }, null, 8, ["modelValue", "step", "max"]),
              createElementVNode("div", _hoisted_11$2, [
                createElementVNode("button", null, [
                  createVNode(BxIcon, null, {
                    default: withCtx(() => [
                      createVNode(unref(PlayBack))
                    ]),
                    _: 1
                  })
                ]),
                createElementVNode("button", { onClick: Po }, [
                  createVNode(BxIcon, null, {
                    default: withCtx(() => [
                      ji.value ? (openBlock(), createBlock(unref(Pause), { key: 0 })) : (openBlock(), createBlock(unref(Play), { key: 1 }))
                    ]),
                    _: 1
                  })
                ]),
                createElementVNode("button", null, [
                  createVNode(BxIcon, null, {
                    default: withCtx(() => [
                      createVNode(unref(PlayForward))
                    ]),
                    _: 1
                  })
                ])
              ])
            ], 512)) : createCommentVNode("", !0),
            createElementVNode("div", _hoisted_12$1, [
              createVNode(Transition, { name: "ghost-loading-preview-image-fade" }, {
                default: withCtx(() => [
                  Mn.baseSerial && !ne.value ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: "ghost-loading-preview-image-wrapper",
                    style: normalizeStyle({
                      "--aspect-ratio": Mn.baseSerial.width / Mn.baseSerial.height,
                      "--timeline-height": `${unref(or)}px`,
                      "--offset-top": "0px",
                      "--offset-right": "20px",
                      "--offset-bottom": "0px",
                      "--offset-left": "0px"
                    })
                  }, [
                    createElementVNode("img", {
                      src: Mn.preview ? unref(optimizePreviewUrl)(Mn.preview, 200) : unref(getTemplatePreviewUrl)(Lr.value, { studioResourcesBaseUrl: Mn.studioResourcesBaseUrl }),
                      onLoad: oi
                    }, null, 40, _hoisted_13$1),
                    createElementVNode("div", {
                      class: normalizeClass(["skeleton", { "overlays-image": di.value }])
                    }, null, 2)
                  ], 4)) : createCommentVNode("", !0)
                ]),
                _: 1
              }),
              createVNode(BluepicLiveTemplate, {
                ref_key: "bluepicLiveTemplateRef",
                ref: Nr,
                "template-id": Lr.value,
                "studio-resources-base-url": Mn.studioResourcesBaseUrl,
                "cloudflare-pages-hostname": Mn.cloudflarePagesHostname,
                "bx-core-version": Mn.bxCoreVersion,
                authorization: Mn.authorization,
                "async-serial": Mn.asyncSerial,
                resolution: Mn.resolution,
                webgl: Mn.webgl,
                fonts: Mn.fonts,
                "base-serial": Mn.baseSerial,
                data: Me.value,
                "onUpdate:data": pn[3] || (pn[3] = (Rn) => Me.value = Rn),
                serial: Ze.value,
                "onUpdate:serial": pn[4] || (pn[4] = (Rn) => Ze.value = Rn),
                ready: ne.value,
                "onUpdate:ready": pn[5] || (pn[5] = (Rn) => ne.value = Rn),
                onMatrixClick: tr,
                watermark: Mn.watermark,
                "zoom-and-pan": Mn.zoomAndPan,
                scrollbars: Mn.zoomAndPan,
                offset: { top: 0, right: 20, bottom: 0, left: 0 }
              }, null, 8, ["template-id", "studio-resources-base-url", "cloudflare-pages-hostname", "bx-core-version", "authorization", "async-serial", "resolution", "webgl", "fonts", "base-serial", "data", "serial", "ready", "watermark", "zoom-and-pan", "scrollbars"])
            ])
          ], 2)
        ])) : Wr.value === "mobile" ? (openBlock(), createElementBlock("div", {
          key: 1,
          ref_key: "viewMobileRef",
          ref: Ir,
          class: "view-mobile"
        }, [
          createElementVNode("div", {
            class: normalizeClass(["live-view", { ready: ne.value }])
          }, [
            createVNode(Transition, { name: "ghost-loading-preview-image-fade" }, {
              default: withCtx(() => [
                Mn.baseSerial && !ne.value ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: "ghost-loading-preview-image-wrapper",
                  style: normalizeStyle({ "--aspect-ratio": Mn.baseSerial.width / Mn.baseSerial.height })
                }, [
                  createElementVNode("img", {
                    src: Mn.preview ? unref(optimizePreviewUrl)(Mn.preview, 200) : unref(getTemplatePreviewUrl)(Lr.value, { studioResourcesBaseUrl: Mn.studioResourcesBaseUrl }),
                    onLoad: oi
                  }, null, 40, _hoisted_14$1),
                  createElementVNode("div", {
                    class: normalizeClass(["skeleton", { "overlays-image": di.value }])
                  }, null, 2)
                ], 4)) : createCommentVNode("", !0)
              ]),
              _: 1
            }),
            createVNode(BluepicLiveTemplate, {
              ref_key: "bluepicLiveTemplateRef",
              ref: Nr,
              "template-id": Lr.value,
              "studio-resources-base-url": Mn.studioResourcesBaseUrl,
              "cloudflare-pages-hostname": Mn.cloudflarePagesHostname,
              "bx-core-version": Mn.bxCoreVersion,
              authorization: Mn.authorization,
              "async-serial": Mn.asyncSerial,
              resolution: Mn.resolution,
              webgl: Mn.webgl,
              fonts: Mn.fonts,
              "base-serial": Mn.baseSerial,
              data: Me.value,
              "onUpdate:data": pn[6] || (pn[6] = (Rn) => Me.value = Rn),
              serial: Ze.value,
              "onUpdate:serial": pn[7] || (pn[7] = (Rn) => Ze.value = Rn),
              ready: ne.value,
              "onUpdate:ready": pn[8] || (pn[8] = (Rn) => ne.value = Rn),
              onMatrixClick: tr,
              watermark: Mn.watermark,
              "zoom-and-pan": Mn.zoomAndPan,
              scrollbars: Mn.zoomAndPan,
              offset: { top: 0, right: 0, bottom: 0, left: 0 }
            }, null, 8, ["template-id", "studio-resources-base-url", "cloudflare-pages-hostname", "bx-core-version", "authorization", "async-serial", "resolution", "webgl", "fonts", "base-serial", "data", "serial", "ready", "watermark", "zoom-and-pan", "scrollbars"])
          ], 2),
          yn.value?.enabled ? (openBlock(), createElementBlock("div", _hoisted_15$1, [
            createElementVNode("div", _hoisted_16$1, toDisplayString(unref(timestampToTimecode)(sn.value * 1e3, ",")) + " / " + toDisplayString(unref(timestampToTimecode)((yn.value.duration ?? 120) * 1e3, ",")), 1),
            createVNode(BxSlider, {
              modelValue: sn.value,
              "onUpdate:modelValue": pn[9] || (pn[9] = (Rn) => sn.value = Rn),
              min: 0,
              step: rn.value,
              max: yn.value.duration ?? 120
            }, null, 8, ["modelValue", "step", "max"]),
            createElementVNode("div", _hoisted_17, [
              createElementVNode("button", null, [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(PlayBack))
                  ]),
                  _: 1
                })
              ]),
              createElementVNode("button", { onClick: Po }, [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    ji.value ? (openBlock(), createBlock(unref(Pause), { key: 0 })) : (openBlock(), createBlock(unref(Play), { key: 1 }))
                  ]),
                  _: 1
                })
              ]),
              createElementVNode("button", null, [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(PlayForward))
                  ]),
                  _: 1
                })
              ])
            ])
          ])) : createCommentVNode("", !0),
          Me.value ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: "fields-view",
            style: normalizeStyle({ "--view-mobile-height": `${unref(Rr)}px` })
          }, [
            createVNode(unref(Swiper), {
              modules: Ue,
              "slides-per-view": 1,
              "space-between": 0,
              onSwiper: vr,
              onSlideChange: Ae
            }, {
              default: withCtx(() => [
                (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(ze), ({ fields: Rn, originalField: Io }, to) => (openBlock(), createBlock(unref(SwiperSlide), null, {
                  default: withCtx(() => [
                    createVNode(MobileFieldsSlide, {
                      fields: Rn,
                      "original-field": Io,
                      active: ci.value?.activeIndex === to,
                      "mobile-fields-slides": unref(ze),
                      "natural-fields-view-max-height": Math.max(180, Xr.value ?? 180),
                      onSelectNav: pn[10] || (pn[10] = (no) => ci.value?.slideTo(no)),
                      "slide-index": to
                    }, null, 8, ["fields", "original-field", "active", "mobile-fields-slides", "natural-fields-view-max-height", "slide-index"])
                  ]),
                  _: 2
                }, 1024))), 256)),
                Oi["form-extra"] ? (openBlock(), createBlock(unref(SwiperSlide), { key: 0 }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_18, [
                      renderSlot(Mn.$slots, "form-extra", {}, void 0, !0)
                    ])
                  ]),
                  _: 3
                })) : createCommentVNode("", !0)
              ]),
              _: 3
            }),
            createElementVNode("div", {
              class: normalizeClass(["swiper-nav-prev", { disabled: ci.value?.activeIndex === 0 }]),
              onClick: pn[11] || (pn[11] = (Rn) => ci.value?.slidePrev())
            }, [
              createVNode(BxIcon, null, {
                default: withCtx(() => [
                  createVNode(unref(ChevronBackOutline))
                ]),
                _: 1
              })
            ], 2),
            createElementVNode("div", {
              class: normalizeClass(["swiper-nav-next", { disabled: ci.value?.activeIndex === unref(ze).length - 1 }]),
              onClick: pn[12] || (pn[12] = (Rn) => ci.value?.slideNext())
            }, [
              createVNode(BxIcon, null, {
                default: withCtx(() => [
                  createVNode(unref(ChevronForwardOutline))
                ]),
                _: 1
              })
            ], 2)
          ], 4)) : createCommentVNode("", !0)
        ], 512)) : Wr.value === "stack" ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass(["view-stack", {}])
        }, [
          createElementVNode("div", {
            class: normalizeClass(["live-view", { ready: ne.value }])
          }, [
            createVNode(Transition, { name: "ghost-loading-preview-image-fade" }, {
              default: withCtx(() => [
                Mn.baseSerial && !ne.value ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: "ghost-loading-preview-image-wrapper",
                  style: normalizeStyle({ "--aspect-ratio": Mn.baseSerial.width / Mn.baseSerial.height })
                }, [
                  createElementVNode("img", {
                    src: Mn.preview ? unref(optimizePreviewUrl)(Mn.preview, 200) : unref(getTemplatePreviewUrl)(Lr.value, { studioResourcesBaseUrl: Mn.studioResourcesBaseUrl }),
                    onLoad: oi
                  }, null, 40, _hoisted_19),
                  createElementVNode("div", {
                    class: normalizeClass(["skeleton", { "overlays-image": di.value }])
                  }, null, 2)
                ], 4)) : createCommentVNode("", !0)
              ]),
              _: 1
            }),
            createVNode(BluepicLiveTemplate, {
              ref_key: "bluepicLiveTemplateRef",
              ref: Nr,
              "template-id": Lr.value,
              "studio-resources-base-url": Mn.studioResourcesBaseUrl,
              "cloudflare-pages-hostname": Mn.cloudflarePagesHostname,
              "bx-core-version": Mn.bxCoreVersion,
              authorization: Mn.authorization,
              "async-serial": Mn.asyncSerial,
              resolution: Mn.resolution,
              webgl: Mn.webgl,
              fonts: Mn.fonts,
              "base-serial": Mn.baseSerial,
              data: Me.value,
              "onUpdate:data": pn[13] || (pn[13] = (Rn) => Me.value = Rn),
              serial: Ze.value,
              "onUpdate:serial": pn[14] || (pn[14] = (Rn) => Ze.value = Rn),
              ready: ne.value,
              "onUpdate:ready": pn[15] || (pn[15] = (Rn) => ne.value = Rn),
              onMatrixClick: tr,
              watermark: Mn.watermark,
              "zoom-and-pan": Mn.zoomAndPan,
              scrollbars: Mn.zoomAndPan,
              offset: { top: 0, right: 0, bottom: 0, left: 0 }
            }, null, 8, ["template-id", "studio-resources-base-url", "cloudflare-pages-hostname", "bx-core-version", "authorization", "async-serial", "resolution", "webgl", "fonts", "base-serial", "data", "serial", "ready", "watermark", "zoom-and-pan", "scrollbars"])
          ], 2),
          yn.value?.enabled ? (openBlock(), createElementBlock("div", _hoisted_20, [
            createElementVNode("div", _hoisted_21, toDisplayString(unref(timestampToTimecode)(sn.value * 1e3, ",")) + " / " + toDisplayString(unref(timestampToTimecode)((yn.value.duration ?? 120) * 1e3, ",")), 1),
            createVNode(BxSlider, {
              modelValue: sn.value,
              "onUpdate:modelValue": pn[16] || (pn[16] = (Rn) => sn.value = Rn),
              min: 0,
              step: rn.value,
              max: yn.value.duration ?? 120
            }, null, 8, ["modelValue", "step", "max"]),
            createElementVNode("div", _hoisted_22, [
              createElementVNode("button", null, [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(PlayBack))
                  ]),
                  _: 1
                })
              ]),
              createElementVNode("button", { onClick: Po }, [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    ji.value ? (openBlock(), createBlock(unref(Pause), { key: 0 })) : (openBlock(), createBlock(unref(Play), { key: 1 }))
                  ]),
                  _: 1
                })
              ]),
              createElementVNode("button", null, [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(PlayForward))
                  ]),
                  _: 1
                })
              ])
            ])
          ])) : createCommentVNode("", !0),
          createElementVNode("div", _hoisted_23, [
            ei.value && Zr.value ? (openBlock(), createElementBlock("div", _hoisted_24, [
              createVNode(SlidesNavigation, {
                length: mi.value,
                index: Zr.value,
                "onUpdate:index": pn[17] || (pn[17] = (Rn) => Zr.value = Rn)
              }, null, 8, ["length", "index"])
            ])) : createCommentVNode("", !0),
            createVNode(_sfc_main$p, { fields: Vr.value }, null, 8, ["fields"]),
            Oi["form-extra"] ? (openBlock(), createElementBlock("div", _hoisted_25, [
              renderSlot(Mn.$slots, "form-extra", {}, void 0, !0)
            ])) : createCommentVNode("", !0)
          ]),
          createElementVNode("div", _hoisted_26, [
            Mn.branding ? (openBlock(), createElementBlock("div", _hoisted_27, [
              createElementVNode("div", {
                class: "branding-wrapper",
                onClick: Gn
              }, [
                createElementVNode("div", _hoisted_28, [
                  createVNode(BluepicLogo)
                ]),
                pn[24] || (pn[24] = createElementVNode("div", { class: "content" }, [
                  createElementVNode("span", { class: "main" }, " Design Template "),
                  createElementVNode("span", { class: "sub" }, " shared with Bluepic ")
                ], -1))
              ])
            ])) : createCommentVNode("", !0),
            createElementVNode("div", _hoisted_29, [
              Vn.value.length >= 2 ? (openBlock(), createBlock(BxDropdown, {
                key: 0,
                options: Vn.value,
                onSelect: Ci
              }, {
                trigger: withCtx(() => [
                  createVNode(BxButton, {
                    secondary: "",
                    loading: (Wo.value || unref(zn)) && un.value === void 0,
                    disabled: Wo.value || unref(zn)
                  }, {
                    icon: withCtx(() => [
                      un.value !== void 0 ? (openBlock(), createBlock(CircularProgress, {
                        key: 0,
                        color: "#000000",
                        class: "export-button-circular-progress",
                        progress: un.value
                      }, null, 8, ["progress"])) : (openBlock(), createBlock(BxIcon, { key: 1 }, {
                        default: withCtx(() => [
                          createVNode(unref(ArrowRedoOutline))
                        ]),
                        _: 1
                      }))
                    ]),
                    default: withCtx(() => [
                      pn[25] || (pn[25] = createTextVNode(" Export "))
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ]),
                _: 1
              }, 8, ["options"])) : Vn.value.length === 1 ? (openBlock(), createBlock(BxButton, {
                key: 1,
                secondary: "",
                onClick: pn[18] || (pn[18] = (Rn) => Ci(0)),
                loading: (Wo.value || unref(zn)) && un.value === void 0,
                disabled: Wo.value || unref(zn)
              }, {
                icon: withCtx(() => [
                  un.value !== void 0 ? (openBlock(), createBlock(CircularProgress, {
                    key: 0,
                    color: "#ff0000",
                    class: "export-button-circular-progress",
                    progress: un.value
                  }, null, 8, ["progress"])) : (openBlock(), createBlock(BxIcon, { key: 1 }, {
                    default: withCtx(() => [
                      createVNode(unref(ArrowRedoOutline))
                    ]),
                    _: 1
                  }))
                ]),
                default: withCtx(() => [
                  createTextVNode(" " + toDisplayString(vn.value[0].label), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"])) : createCommentVNode("", !0)
            ])
          ])
        ])) : (openBlock(), createElementBlock("div", _hoisted_30, [
          createElementVNode("div", {
            class: normalizeClass(["live-view", { ready: ne.value }])
          }, [
            createVNode(BluepicLiveTemplate, {
              ref_key: "bluepicLiveTemplateRef",
              ref: Nr,
              "template-id": Lr.value,
              "studio-resources-base-url": Mn.studioResourcesBaseUrl,
              "cloudflare-pages-hostname": Mn.cloudflarePagesHostname,
              "bx-core-version": Mn.bxCoreVersion,
              authorization: Mn.authorization,
              "async-serial": Mn.asyncSerial,
              resolution: Mn.resolution,
              webgl: Mn.webgl,
              fonts: Mn.fonts,
              data: Me.value,
              "onUpdate:data": pn[19] || (pn[19] = (Rn) => Me.value = Rn),
              serial: Ze.value,
              "onUpdate:serial": pn[20] || (pn[20] = (Rn) => Ze.value = Rn),
              ready: ne.value,
              "onUpdate:ready": pn[21] || (pn[21] = (Rn) => ne.value = Rn),
              onMatrixClick: tr,
              watermark: Mn.watermark,
              "zoom-and-pan": Mn.zoomAndPan,
              scrollbars: Mn.zoomAndPan,
              offset: { top: 0, right: 0, bottom: 0, left: 0 }
            }, {
              matrix: withCtx(({ composePoint: Rn }) => [
                createElementVNode("div", _hoisted_31, [
                  Ze.value && ii.value && br.value ? (openBlock(), createBlock(KioskField, {
                    key: 0,
                    field: ii.value,
                    "compose-point": Rn,
                    serial: Ze.value
                  }, null, 8, ["field", "compose-point", "serial"])) : createCommentVNode("", !0)
                ])
              ]),
              _: 1
            }, 8, ["template-id", "studio-resources-base-url", "cloudflare-pages-hostname", "bx-core-version", "authorization", "async-serial", "resolution", "webgl", "fonts", "data", "serial", "ready", "watermark", "zoom-and-pan", "scrollbars"])
          ], 2),
          ne.value ? (openBlock(), createElementBlock("div", _hoisted_32, [
            createElementVNode("div", _hoisted_33, [
              createElementVNode("button", {
                class: normalizeClass(["icon-only", { disabled: !vi.value }]),
                onClick: wi
              }, [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(ChevronBackOutline))
                  ]),
                  _: 1
                })
              ], 2),
              createVNode(BxDropdown, {
                options: nr.value,
                "mobile-layout": ur.value,
                onSelect: Pr
              }, {
                trigger: withCtx(() => [
                  createElementVNode("button", null, toDisplayString(Pe.value), 1)
                ]),
                _: 1
              }, 8, ["options", "mobile-layout"]),
              createElementVNode("button", {
                class: normalizeClass(["icon-only", { disabled: !Hr.value }]),
                onClick: Ti
              }, [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(ChevronForwardOutline))
                  ]),
                  _: 1
                })
              ], 2)
            ])
          ])) : createCommentVNode("", !0)
        ]))
      ])
    ], 2));
  }
}), BluepicEmbeddedEditor_vue_vue_type_style_index_0_scoped_c0da4e7f_lang = "", BluepicEmbeddedEditor = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["__scopeId", "data-v-c0da4e7f"]]), _hoisted_1$a = { class: "collection-field-popup" }, _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "CollectionFieldPopup",
  props: /* @__PURE__ */ mergeModels({
    layout: {},
    fields: {},
    description: {},
    detailedDescription: {},
    bridge: {},
    defaultValue: {},
    mobile: { type: Boolean }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = m, ie = useModel(m, "modelValue");
    return inject("computedPropEvaluator"), inject("bridge"), (we, $e) => (openBlock(), createElementBlock("div", _hoisted_1$a, [
      createVNode(_sfc_main$18, {
        trigger: "click",
        type: "layer",
        "pass-injections": ["computedPropEvaluator", "bridge"]
      }, {
        trigger: withCtx(() => [
          createVNode(BxButton, null, {
            default: withCtx(() => $e[1] || ($e[1] = [
              createTextVNode(" Edit collection ")
            ])),
            _: 1
          })
        ]),
        content: withCtx(() => [
          createVNode(Collection, mergeProps(c, {
            modelValue: ie.value,
            "onUpdate:modelValue": $e[0] || ($e[0] = (Me) => ie.value = Me)
          }), null, 16, ["modelValue"])
        ]),
        _: 1
      })
    ]));
  }
}), CollectionFieldPopup_vue_vue_type_style_index_0_scoped_a0928c6b_lang = "", CollectionFieldPopup = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["__scopeId", "data-v-a0928c6b"]]), _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "TableFieldsList",
  props: /* @__PURE__ */ mergeModels({
    fields: {}
  }, {
    data: {
      required: !0
    },
    dataModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["change"], ["update:data"]),
  setup(m, { emit: c }) {
    const ie = {
      Text,
      Image: Image$1,
      Select,
      Collection: CollectionFieldPopup,
      Checkbox,
      Color,
      ImageAdjust,
      Map: Map$1,
      Number: Number$1,
      ImageEdit,
      SelectText,
      SelectImage,
      SelectColor
    }, we = useModel(m, "data"), $e = c, Me = inject("bridge"), Ze = inject("computedPropEvaluator");
    Ze || console.error("computedPropEvaluator is not provided");
    const ne = (gr) => {
      if ("pos" in gr && "scale" in gr) {
        const _r = gr.image, Lr = gr.pos, Ir = gr.scale;
        return {
          image: we.value[_r],
          "onUpdate:image": (Rr) => {
            we.value[_r] = Rr;
          },
          adjust: {
            scale: we.value[Ir],
            innerPos: we.value[Lr]
          },
          "onUpdate:adjust": (Rr) => {
            we.value[Ir] = Rr.scale, we.value[Lr] = Rr.innerPos;
          }
        };
      }
      return {
        ...Object.fromEntries(Object.entries(gr).map(([_r, Lr]) => [_r, we.value[Lr]])),
        ...Object.fromEntries(
          Object.entries(gr).map(([_r]) => [
            `onUpdate:${_r}`,
            (Lr) => {
              we.value[gr[_r]] = Lr, $e("change");
            }
          ])
        )
      };
    };
    function rr(gr) {
      return Object.fromEntries(
        Object.entries(gr).map(([or, _r]) => typeof _r == "function" ? [or, Ze(_r)] : [or, _r])
      );
    }
    return (gr, or) => (openBlock(!0), createElementBlock(Fragment, null, renderList(gr.fields, (_r) => (openBlock(), createElementBlock("td", {
      style: normalizeStyle({ "--min-width": _r.layout?.minWidth, "--max-width": _r.layout?.maxWidth })
    }, [
      createElementVNode("div", {
        class: "table-cell-wrapper-field-wrapper",
        style: normalizeStyle({ "--min-width": _r.layout?.minWidth, "--max-width": _r.layout?.maxWidth })
      }, [
        _r.type in ie ? (openBlock(), createBlock(resolveDynamicComponent(ie[_r.type]), mergeProps({
          key: 0,
          bridge: unref(Me),
          ref_for: !0
        }, {
          ...rr(_r.props),
          ...ne(_r.model),
          description: _r.description,
          detailedDescription: _r.detailedDescription,
          field: _r,
          ...(() => {
            if (_r.type === "Text")
              return {
                ..._r.layout,
                minWidth: "120px"
              };
            if (_r.type === "Select")
              return {
                ..._r.layout,
                cardSize: "small"
              };
          })()
        }), null, 16, ["bridge"])) : createCommentVNode("", !0)
      ], 4)
    ], 4))), 256));
  }
}), TableFieldsList_vue_vue_type_style_index_0_scoped_b7b49ece_lang = "", TableFieldsList = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["__scopeId", "data-v-b7b49ece"]]), _hoisted_1$9 = ["onClick"], _hoisted_2$7 = { class: "label" }, _hoisted_3$5 = { class: "indicator-wrapper" }, _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "BxTabs",
  props: /* @__PURE__ */ mergeModels({
    tabs: {},
    type: { default: "inline" },
    fullWidth: { type: Boolean, default: !1 },
    fitWidth: { type: Boolean, default: !1 }
  }, {
    modelValue: {
      required: !1
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = m, ie = ref$1(), we = useModel(m, "modelValue");
    we.value || (we.value = c.tabs[0].name);
    const $e = ref$1();
    function Me() {
      if (!ie.value)
        return;
      const Ze = ie.value.getBoundingClientRect().left, ne = c.tabs.findIndex((gr) => gr.name === we.value);
      ie.value.children.item(ne);
      const rr = ie.value.children.item(ne)?.getBoundingClientRect();
      !rr || ($e.value = {
        x: rr?.left - Ze,
        width: rr?.width
      });
    }
    return onMounted(() => {
      nextTick$3(() => {
        Me();
      });
    }), watch(we, Me), (Ze, ne) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-tabs-wrapper", { "full-width": Ze.fullWidth, "fit-width": Ze.fitWidth }])
    }, [
      createElementVNode("div", {
        class: normalizeClass(["bx-tabs", { [`type-${Ze.type}`]: !0 }])
      }, [
        createElementVNode("div", {
          class: "tabs",
          ref_key: "tabsRef",
          ref: ie
        }, [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(c.tabs, (rr, gr) => (openBlock(), createElementBlock("div", {
            key: gr,
            class: normalizeClass(["tab", { active: we.value === rr.name }]),
            onClick: (or) => we.value = rr.name
          }, [
            createElementVNode("span", _hoisted_2$7, toDisplayString(rr.label), 1)
          ], 10, _hoisted_1$9))), 128))
        ], 512),
        createElementVNode("div", _hoisted_3$5, [
          createElementVNode("div", {
            class: "indicator",
            style: normalizeStyle({ "--width": `${$e.value?.width}px`, "--x": `${$e.value?.x}px` })
          }, null, 4)
        ])
      ], 2)
    ], 2));
  }
}), BxTabs_vue_vue_type_style_index_0_scoped_56b2b10c_lang = "", BxTabs = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["__scopeId", "data-v-56b2b10c"]]), _hoisted_1$8 = { class: "table-data-matcher" }, _hoisted_2$6 = { class: "table-wrapper" }, _hoisted_3$4 = { class: "value" }, _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "TableDataMatcher",
  props: {
    data: {},
    fields: {}
  },
  emits: ["update:partial-data"],
  setup(m, { emit: c }) {
    const ie = m, we = c, $e = ref$1(ie.data[0].map(() => {
    })), Me = ref$1(ie.data), Ze = computed(() => Object.fromEntries(
      $e.value.map((or, _r) => or ? [Object.values(or.model)[0], Me.value.map((Ir) => Ir[_r])] : void 0).filter((or) => or !== void 0)
    ));
    function ne(or) {
      Me.value = Me.value.filter((_r, Lr) => Lr !== or);
    }
    function rr(or) {
      return ie.fields.filter((_r) => {
        const Lr = $e.value.indexOf(_r);
        return Lr === or || Lr === -1;
      }).map((_r) => ({
        label: getFieldDescription(_r),
        value: _r,
        icon: () => renderFieldIcon(_r.type, !1)
      }));
    }
    function gr(or, _r) {
      $e.value[_r] = or;
    }
    return watch(
      Ze,
      () => {
        we("update:partial-data", Ze.value);
      },
      { immediate: !0 }
    ), (or, _r) => (openBlock(), createElementBlock("div", _hoisted_1$8, [
      createElementVNode("div", _hoisted_2$6, [
        createElementVNode("table", null, [
          createElementVNode("thead", null, [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(Me.value[0].length, (Lr) => (openBlock(), createElementBlock("th", null, [
              createVNode(BxSelect, {
                options: rr(Lr - 1),
                value: $e.value[Lr - 1],
                "onUpdate:modelValue": (Ir) => gr(Ir, Lr - 1),
                "placeholder-active-label": "Select field"
              }, null, 8, ["options", "value", "onUpdate:modelValue"])
            ]))), 256))
          ]),
          createElementVNode("tbody", null, [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(Me.value, (Lr, Ir) => (openBlock(), createElementBlock("tr", null, [
              (openBlock(!0), createElementBlock(Fragment, null, renderList(Lr, (Ar) => (openBlock(), createElementBlock("td", null, [
                createElementVNode("span", _hoisted_3$4, toDisplayString(Ar), 1)
              ]))), 256)),
              createElementVNode("td", null, [
                createVNode(BxButton, {
                  circle: "",
                  state: "error",
                  quarternary: "",
                  onClick: (Ar) => ne(Ir)
                }, {
                  icon: withCtx(() => [
                    createVNode(BxIcon, null, {
                      default: withCtx(() => [
                        createVNode(unref(CloseOutline))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))), 256))
          ])
        ])
      ])
    ]));
  }
}), TableDataMatcher_vue_vue_type_style_index_0_scoped_54220f31_lang = "", TableDataMatcher = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["__scopeId", "data-v-54220f31"]]);
function parseCSV(m, c) {
  return m.split(`
`).map(
    (ie) => ie.split(",").map((we) => {
      const $e = Number(we);
      return isNaN($e) ? we === "true" || we === "false" ? we === "true" : we : $e;
    })
  );
}
const _hoisted_1$7 = { class: "import-data" }, _hoisted_2$5 = { class: "source-selector" }, _hoisted_3$3 = { class: "source-view" }, _hoisted_4$3 = { class: "gsheets-inputs" }, _hoisted_5$2 = {
  key: 0,
  class: "spinner-wrapper"
}, _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "ImportData",
  props: {
    fields: {}
  },
  setup(m, { expose: c }) {
    const ie = [
      {
        name: "upload",
        label: "Upload file"
      },
      {
        name: "clipboard",
        label: "Clipboard"
      },
      {
        name: "googlesheets",
        label: "Google Sheets"
      }
    ], we = ref$1("upload"), $e = ref$1(), Me = ref$1(), Ze = ref$1(), ne = ref$1(), rr = ref$1(""), gr = computed(() => {
      if (rr.value.startsWith("http"))
        try {
          const Ir = new URL(rr.value), [, , , Ar] = Ir.pathname.split("/");
          return Ar;
        } catch {
          return;
        }
      else
        return rr.value;
    }), or = ref$1(!1);
    async function _r() {
      or.value = !0;
      const Ir = `https://google-sheets-api-bridge.bluepic.workers.dev/sheet/${gr.value}/A:Z`, Ar = await fetch(Ir);
      Ar.ok && (Ze.value = await Ar.json()), or.value = !1;
    }
    watch(we, async () => {
      if (we.value === "clipboard") {
        const Ir = await navigator.clipboard.readText();
        Me.value = parseCSV(Ir);
      }
    });
    async function Lr(Ir) {
      const [Ar] = Ir, Rr = await new Promise((Nr) => {
        const Yr = new FileReader();
        Yr.addEventListener("load", () => {
          Nr(Yr.result);
        }), Yr.readAsText(Ar);
      });
      $e.value = parseCSV(Rr);
    }
    return c({
      partialData: ne
    }), (Ir, Ar) => (openBlock(), createElementBlock("div", _hoisted_1$7, [
      createElementVNode("div", _hoisted_2$5, [
        createVNode(BxTabs, {
          tabs: ie,
          modelValue: we.value,
          "onUpdate:modelValue": Ar[0] || (Ar[0] = (Rr) => we.value = Rr)
        }, null, 8, ["modelValue"])
      ]),
      createElementVNode("div", _hoisted_3$3, [
        we.value === "upload" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createVNode(BxUpload, {
            accept: ["text/csv"],
            type: "area",
            title: "Upload CSV file",
            description: "Drag any CSV file",
            onSelect: Lr
          }),
          $e.value ? (openBlock(), createBlock(TableDataMatcher, {
            key: 0,
            data: $e.value,
            fields: Ir.fields,
            "onUpdate:partialData": Ar[1] || (Ar[1] = (Rr) => ne.value = Rr)
          }, null, 8, ["data", "fields"])) : createCommentVNode("", !0)
        ], 64)) : createCommentVNode("", !0),
        we.value === "clipboard" ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          Me.value ? (openBlock(), createBlock(TableDataMatcher, {
            key: 0,
            data: Me.value,
            fields: Ir.fields,
            "onUpdate:partialData": Ar[2] || (Ar[2] = (Rr) => ne.value = Rr)
          }, null, 8, ["data", "fields"])) : createCommentVNode("", !0)
        ], 64)) : createCommentVNode("", !0),
        we.value === "googlesheets" ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
          createElementVNode("div", _hoisted_4$3, [
            createVNode(BxInput, {
              modelValue: rr.value,
              "onUpdate:modelValue": Ar[3] || (Ar[3] = (Rr) => rr.value = Rr),
              placeholder: "Google Spreadhseets URL or ID",
              disabled: or.value
            }, null, 8, ["modelValue", "disabled"]),
            createVNode(BxButton, {
              size: "medium",
              onClick: _r,
              disabled: or.value
            }, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(SyncOutline))
                  ]),
                  _: 1
                })
              ]),
              default: withCtx(() => [
                Ar[5] || (Ar[5] = createTextVNode(" Sync "))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          or.value ? (openBlock(), createElementBlock("div", _hoisted_5$2, [
            createVNode(BluepicSpinner)
          ])) : Ze.value ? (openBlock(), createBlock(TableDataMatcher, {
            key: 1,
            data: Ze.value,
            fields: Ir.fields,
            "onUpdate:partialData": Ar[4] || (Ar[4] = (Rr) => ne.value = Rr)
          }, null, 8, ["data", "fields"])) : createCommentVNode("", !0)
        ], 64)) : createCommentVNode("", !0)
      ])
    ]));
  }
}), ImportData_vue_vue_type_style_index_0_scoped_bcbee4aa_lang = "", ImportData = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["__scopeId", "data-v-bcbee4aa"]]), _hoisted_1$6 = { class: "preview-view" }, _hoisted_2$4 = { class: "preview-view-tools" }, _hoisted_3$2 = { class: "popup-actions" }, _hoisted_4$2 = { class: "preview-view-live" }, _hoisted_5$1 = {
  key: 0,
  class: "actions-layer"
}, _hoisted_6$1 = {
  key: 0,
  class: "table-view"
}, _hoisted_7$1 = {
  key: 0,
  class: "selected-actions-wrapper"
}, _hoisted_8$1 = { class: "label" }, _hoisted_9$1 = { class: "actions" }, _hoisted_10$1 = { class: "inner" }, _hoisted_11$1 = { class: "data-table" }, _hoisted_12 = { class: "select-cell-wrapper" }, _hoisted_13 = { class: "inner" }, _hoisted_14 = {
  key: 0,
  class: "column-field-wrapper"
}, _hoisted_15 = { class: "select-cell-wrapper" }, _hoisted_16 = { style: { padding: "0 10px" } }, _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "BluepicBatchEditor",
  props: /* @__PURE__ */ mergeModels({
    data: { default: () => [] },
    templateId: {},
    studioResourcesBaseUrl: {},
    cloudflarePagesHostname: {},
    bxCoreVersion: {},
    authorization: {},
    asyncSerial: { type: Boolean },
    resolution: {},
    webgl: { type: Boolean },
    fonts: {},
    bridge: {}
  }, {
    serial: {
      required: !1
    },
    serialModifiers: {},
    ready: { type: Boolean, required: !1 },
    readyModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["download", "update:data"], ["update:serial", "update:ready"]),
  setup(m, { expose: c, emit: ie }) {
    const we = {
      ...BluepciFieldComponents,
      Collection: CollectionFieldPopup
    }, $e = m, Me = ie, Ze = ref$1(), ne = useModel(m, "serial"), rr = useModel(m, "ready");
    function gr({ x: wi, y: ii }) {
      console.log("Matrix clicked at", wi, ii);
    }
    provide("bridge", $e.bridge);
    const or = ref$1(), _r = computed(() => or.value?.globalScope ?? {}), Lr = (wi) => new Function(...Object.keys(_r.value), `return (${wi.toString()})()`)(
      ...Object.values(_r.value)
    );
    provide("computedPropEvaluator", Lr);
    const Ir = ref$1(!1);
    watch(Ir, () => {
      setTimeout(() => {
        !or.value || (or.value.transform = { scale: 1, x: 0, y: 0, rotate: 0 });
      }, 30);
    });
    const Ar = computed(() => ne.value ? flattenFieldTable(ne.value.fields ?? ne.value.meta.fields.map(convertDeprecatedField)).map(realizeField) : []), Rr = ref$1($e.data);
    Rr.value.length === 0 && (Rr.value = [{}]), watch(
      Rr,
      (wi) => {
        Me("update:data", wi);
      },
      { deep: !0, immediate: !0 }
    );
    const Nr = ref$1(0);
    function Yr() {
      !Rr.value || (Nr.value = Math.min(Nr.value + 1, Rr.value.length - 1));
    }
    function Vr() {
      Nr.value = Math.max(Nr.value - 1, 0);
    }
    const Xr = ref$1([]);
    function Wr(wi) {
      Xr.value.includes(wi) ? Xr.value = Xr.value.filter((ii) => ii !== wi) : Xr.value = [...Xr.value, wi];
    }
    function si() {
      Rr.value = [...Rr.value, structuredClone(toRaw(Rr.value[Rr.value.length - 1]))], Nr.value = Rr.value.length - 1;
    }
    function li(wi) {
      Nr.value = wi;
    }
    function xi() {
      Me("download", Xr.value);
    }
    function di() {
      Xr.value.length >= Rr.value.length || (Rr.value = Rr.value.filter((wi, ii) => !Xr.value.includes(ii)), Xr.value = []);
    }
    const oi = ref$1({}), ci = (wi) => {
      if ("pos" in wi && "scale" in wi) {
        const mi = wi.image, ei = wi.pos, Zr = wi.scale;
        return {
          image: oi.value[mi] ?? Rr.value[0][mi],
          "onUpdate:image": (hi) => {
            for (let Oi = 0; Oi < Rr.value.length; Oi++)
              Rr.value[Oi][mi] = hi, oi.value[mi] = hi;
          },
          adjust: {
            scale: oi.value[Zr] ?? Rr.value[0][Zr],
            innerPos: oi.value[ei] ?? Rr.value[0][ei]
          },
          "onUpdate:adjust": (hi) => {
            for (let Oi = 0; Oi < Rr.value.length; Oi++)
              Rr.value[Oi][Zr] = hi.scale, Rr.value[Oi][ei] = hi.innerPos, oi.value[Zr] = hi.scale, oi.value[ei] = hi.innerPos;
          }
        };
      }
      return {
        ...Object.fromEntries(
          Object.entries(wi).map(([mi, ei]) => [mi, oi.value[ei] ?? Rr.value[0][ei]])
        ),
        ...Object.fromEntries(
          Object.entries(wi).map(([mi]) => [
            `onUpdate:${mi}`,
            (ei) => {
              for (let Zr = 0; Zr < Rr.value.length; Zr++)
                Rr.value[Zr][wi[mi]] = ei, oi.value[wi[mi]] = ei;
            }
          ])
        )
      };
    };
    function vr(wi) {
      return Object.fromEntries(
        Object.entries(wi).map(([ii, mi]) => typeof mi == "function" ? [ii, Lr(mi)] : [ii, mi])
      );
    }
    const Ae = ref$1();
    function ze(wi) {
      Ae.value = wi;
    }
    const Ue = computed(() => {
      if (Ae.value !== void 0)
        return Ar.value[Ae.value];
    }), { uploadFiles: tr, uploadProgresses: lr, uploading: pr } = useUpload(
      computed(() => Ue.value?.props?.width),
      computed(() => Ue.value?.props?.height),
      computed(() => Ue.value?.props?.convertTo),
      computed(() => Ue.value?.props?.quality),
      $e.bridge.handleUpload,
      Ue
    ), br = [
      {
        label: "Upload from device",
        value: "upload",
        icon: () => h$1(CloudUploadOutline)
      },
      {
        label: "Upload from URL",
        value: "upload_from_url",
        icon: () => h$1(GlobeOutline)
      }
    ];
    function nr(wi, ii) {
      ii === "upload" ? Pe(wi) : ii === "upload_from_url" ? ur(wi) : console.warn("Unknown upload option selected:", ii);
    }
    async function Pe(wi) {
      const ii = Ar.value[wi], mi = await openFiles({
        maxSize: 1024 * 1024 * 10,
        multiple: !0,
        types: ["image/*"]
      }), ei = createPopup({
        title: "Uploading images",
        content: () => [
          h$1(BxProgress, { value: lr.value.reduce((pi, hi) => pi + hi, 0) / lr.value.length })
        ],
        closeable: !1,
        icon: () => h$1(CloudUploadOutline),
        disableBackgroundEffect: !0
      }), Zr = await tr(mi);
      Rr.value = [
        ...Rr.value,
        ...Array(Math.max(0, Zr.length - Rr.value.length)).fill({}).map(() => lodash.exports.cloneDeep(Rr.value[Rr.value.length - 1]))
      ], ei.close();
      for (let pi = 0; pi < Zr.length; pi++) {
        const { src: hi } = Zr[pi];
        typeof Rr.value[pi][ii.model.modelValue] == "string" ? Rr.value[pi][ii.model.modelValue] = hi : Rr.value[pi][ii.model.modelValue] = {
          innerPos: [0, 0],
          innerRotate: 0,
          scale: 1,
          ...Rr.value[pi][ii.model.modelValue] ?? {},
          src: hi
        };
      }
    }
    async function ur(wi) {
      const ii = Ar.value[wi], mi = ref$1(""), ei = createPopup({
        title: "Insert image urls",
        content: () => [
          h$1(
            "div",
            {
              style: {
                padding: "5px 0"
              }
            },
            [
              h$1(BxInput, {
                type: "textarea",
                modelValue: mi.value,
                "onUpdate:modelValue": (Zr) => {
                  mi.value = Zr;
                }
              })
            ]
          )
        ],
        actions: () => [
          h$1(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "flex-end",
                padding: "10px 0",
                gap: "10px"
              }
            },
            [
              h$1(
                BxButton,
                {
                  secondary: !1,
                  onClick: () => {
                    ei.close();
                  }
                },
                () => "Cancel"
              ),
              h$1(
                BxButton,
                {
                  secondary: !0,
                  onClick: () => {
                    ei.close();
                    const Zr = mi.value.split(`
`).map((pi) => pi.trim()).filter((pi) => pi.length > 0);
                    Rr.value = [
                      ...Rr.value,
                      ...Array(Math.max(0, Zr.length - Rr.value.length)).fill({}).map(() => lodash.exports.cloneDeep(Rr.value[Rr.value.length - 1]))
                    ];
                    for (let pi = 0; pi < Zr.length; pi++) {
                      const hi = Zr[pi];
                      typeof Rr.value[pi][ii.model.modelValue] == "string" ? Rr.value[pi][ii.model.modelValue] = hi : Rr.value[pi][ii.model.modelValue] = {
                        innerPos: [0, 0],
                        innerRotate: 0,
                        scale: 1,
                        ...Rr.value[pi][ii.model.modelValue] ?? {},
                        src: hi
                      };
                    }
                  }
                },
                () => "Confirm"
              )
            ]
          )
        ],
        disableBackgroundEffect: !0,
        customClasses: ["bluepic-batch-editor-insert-image-urls-popup"]
      });
    }
    function Pr() {
      console.log("Trigger import");
    }
    const Hr = ref$1(!1);
    function vi() {
      Hr.value = !1;
    }
    function Ti() {
      if (!Ze.value)
        return;
      const wi = Ze.value.partialData;
      if (Object.keys(wi).length === 0)
        return;
      const ii = wi[Object.keys(wi)[0]].length;
      Rr.value = Array(ii).fill(0).map((mi, ei) => ({
        ...Rr.value[Nr.value],
        ...Object.fromEntries(Object.entries(wi).map(([Zr, pi]) => [Zr, pi[ei]]))
      })), Hr.value = !1;
    }
    return c({
      serial: ne,
      ready: rr,
      bluepicLiveTemplateRef: or
    }), (wi, ii) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bluepic-bathc-editor", { ready: rr.value, collapsed: Ir.value }])
    }, [
      createElementVNode("div", _hoisted_1$6, [
        createElementVNode("div", _hoisted_2$4, [
          createVNode(BxButton, {
            tertiary: "",
            size: "small",
            class: normalizeClass(["btn-collapse", { collapsed: Ir.value }]),
            onClick: ii[0] || (ii[0] = (mi) => Ir.value = !Ir.value)
          }, {
            icon: withCtx(() => [
              createVNode(BxIcon, null, {
                default: withCtx(() => [
                  createVNode(unref(ChevronForwardOutline))
                ]),
                _: 1
              })
            ]),
            default: withCtx(() => [
              ii[6] || (ii[6] = createElementVNode("span", null, "Preview", -1))
            ]),
            _: 1
          }, 8, ["class"]),
          createVNode(_sfc_main$18, {
            show: Hr.value,
            "onUpdate:show": ii[1] || (ii[1] = (mi) => Hr.value = mi),
            type: "layer"
          }, {
            trigger: withCtx(() => [
              createVNode(BxButton, {
                tertiary: "",
                size: "small",
                class: "btn-import",
                onClick: Pr
              }, {
                icon: withCtx(() => [
                  createVNode(BxIcon, null, {
                    default: withCtx(() => [
                      createVNode(unref(ClipboardOutline))
                    ]),
                    _: 1
                  })
                ]),
                default: withCtx(() => [
                  ii[7] || (ii[7] = createElementVNode("span", null, "Import Data", -1))
                ]),
                _: 1
              })
            ]),
            content: withCtx(() => [
              createVNode(ImportData, {
                ref_key: "importDataRef",
                ref: Ze,
                fields: Ar.value
              }, null, 8, ["fields"])
            ]),
            "close-btn": withCtx(() => [
              createElementVNode("div", _hoisted_3$2, [
                createVNode(BxButton, { onClick: vi }, {
                  icon: withCtx(() => [
                    createVNode(BxIcon, null, {
                      default: withCtx(() => [
                        createVNode(unref(CloseOutline))
                      ]),
                      _: 1
                    })
                  ]),
                  default: withCtx(() => [
                    ii[8] || (ii[8] = createTextVNode(" Cancel "))
                  ]),
                  _: 1
                }),
                createVNode(BxButton, { onClick: Ti }, {
                  icon: withCtx(() => [
                    createVNode(BxIcon, null, {
                      default: withCtx(() => [
                        createVNode(unref(CheckmarkOutline))
                      ]),
                      _: 1
                    })
                  ]),
                  default: withCtx(() => [
                    ii[9] || (ii[9] = createTextVNode(" Import "))
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        createElementVNode("div", _hoisted_4$2, [
          createVNode(BluepicLiveTemplate, {
            ref_key: "bluepicLiveTemplateRef",
            ref: or,
            "template-id": wi.templateId,
            "studio-resources-base-url": wi.studioResourcesBaseUrl,
            "cloudflare-pages-hostname": wi.cloudflarePagesHostname,
            "bx-core-version": wi.bxCoreVersion,
            authorization: wi.authorization,
            "async-serial": wi.asyncSerial,
            resolution: wi.resolution,
            webgl: wi.webgl,
            fonts: wi.fonts,
            data: Rr.value[Nr.value],
            "onUpdate:data": ii[2] || (ii[2] = (mi) => Rr.value[Nr.value] = mi),
            serial: ne.value,
            "onUpdate:serial": ii[3] || (ii[3] = (mi) => ne.value = mi),
            ready: rr.value,
            "onUpdate:ready": ii[4] || (ii[4] = (mi) => rr.value = mi),
            onMatrixClick: gr,
            offset: { top: 0, right: 0, bottom: 0, left: 0 }
          }, null, 8, ["template-id", "studio-resources-base-url", "cloudflare-pages-hostname", "bx-core-version", "authorization", "async-serial", "resolution", "webgl", "fonts", "data", "serial", "ready"]),
          Rr.value ? (openBlock(), createElementBlock("div", _hoisted_5$1, [
            createVNode(BxButton, {
              class: "btn-prev",
              tertiary: "",
              circle: "",
              disabled: Nr.value <= 0,
              onClick: Vr
            }, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(ArrowBackOutline))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            createVNode(BxButton, {
              class: "btn-next",
              tertiary: "",
              circle: "",
              disabled: Nr.value >= Rr.value.length - 1,
              onClick: Yr
            }, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(ArrowForwardOutline))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ])) : createCommentVNode("", !0)
        ])
      ]),
      rr.value && Rr.value ? (openBlock(), createElementBlock("div", _hoisted_6$1, [
        createElementVNode("header", null, [
          Xr.value.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_7$1, [
            createElementVNode("span", _hoisted_8$1, " Selected " + toDisplayString(Xr.value.length) + " of " + toDisplayString(Rr.value.length) + " rows ", 1),
            createElementVNode("div", _hoisted_9$1, [
              createVNode(BxButton, {
                round: "",
                onClick: xi
              }, {
                icon: withCtx(() => [
                  createVNode(BxIcon, null, {
                    default: withCtx(() => [
                      createVNode(unref(CloudDownloadOutline))
                    ]),
                    _: 1
                  })
                ]),
                default: withCtx(() => [
                  ii[10] || (ii[10] = createTextVNode(" Download "))
                ]),
                _: 1
              }),
              createVNode(BxButton, {
                round: "",
                state: "error",
                disabled: Xr.value.length >= Rr.value.length,
                onClick: di
              }, {
                icon: withCtx(() => [
                  createVNode(BxIcon, null, {
                    default: withCtx(() => [
                      createVNode(unref(CloseOutline))
                    ]),
                    _: 1
                  })
                ]),
                default: withCtx(() => [
                  ii[11] || (ii[11] = createTextVNode(" Delete "))
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])) : createCommentVNode("", !0)
        ]),
        createElementVNode("div", _hoisted_10$1, [
          createElementVNode("table", _hoisted_11$1, [
            createElementVNode("thead", null, [
              createElementVNode("th", null, [
                createElementVNode("div", _hoisted_12, [
                  createVNode(BxCheckbox, {
                    "model-value": Xr.value.length === Rr.value.length,
                    "onUpdate:modelValue": ii[5] || (ii[5] = (mi) => Xr.value = Xr.value.length === Rr.value.length ? [] : Rr.value.map((ei, Zr) => Zr)),
                    size: "medium"
                  }, null, 8, ["model-value"]),
                  ii[12] || (ii[12] = createElementVNode("span", null, "#", -1))
                ])
              ]),
              (openBlock(!0), createElementBlock(Fragment, null, renderList(Ar.value, (mi, ei) => (openBlock(), createElementBlock("th", null, [
                createElementVNode("div", _hoisted_13, [
                  createElementVNode("header", null, [
                    createElementVNode("span", null, toDisplayString(unref(getFieldDescription)(mi)), 1),
                    createVNode(BxButton, {
                      circle: "",
                      size: "medium",
                      onClick: (Zr) => ze(ei)
                    }, {
                      icon: withCtx(() => [
                        createVNode(BxIcon, null, {
                          default: withCtx(() => [
                            createVNode(unref(CreateOutline))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    (mi.type === "ImageEdit" || mi.type === "Image") && mi.props.allowUploadFromDevice ? (openBlock(), createBlock(BxDropdown, {
                      key: 0,
                      trigger: "hover",
                      options: br,
                      onSelect: (Zr) => nr(ei, Zr)
                    }, {
                      trigger: withCtx(() => [
                        createVNode(BxButton, {
                          circle: "",
                          size: "medium",
                          onClick: (Zr) => Pe(ei)
                        }, {
                          icon: withCtx(() => [
                            createVNode(BxIcon, null, {
                              default: withCtx(() => [
                                createVNode(unref(CloudUploadOutline))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["onSelect"])) : createCommentVNode("", !0)
                  ]),
                  ei === Ae.value ? (openBlock(), createElementBlock("div", _hoisted_14, [
                    (openBlock(), createBlock(resolveDynamicComponent(we[mi.type]), mergeProps({
                      bridge: wi.bridge,
                      ref_for: !0
                    }, {
                      ...vr(mi.props),
                      ...ci(mi.model),
                      description: mi.description,
                      detailedDescription: mi.detailedDescription,
                      field: mi,
                      ...(() => {
                        if (mi.type === "Text")
                          return {
                            ...mi.layout,
                            minWidth: "120px"
                          };
                        if (mi.type === "Select")
                          return {
                            ...mi.layout,
                            cardSize: "small"
                          };
                      })()
                    }), null, 16, ["bridge"]))
                  ])) : createCommentVNode("", !0)
                ])
              ]))), 256)),
              ii[13] || (ii[13] = createElementVNode("th", null, null, -1))
            ]),
            createElementVNode("tbody", null, [
              (openBlock(!0), createElementBlock(Fragment, null, renderList(Rr.value, (mi, ei) => (openBlock(), createElementBlock("tr", null, [
                createElementVNode("td", null, [
                  createElementVNode("div", _hoisted_15, [
                    createVNode(BxCheckbox, {
                      "model-value": Xr.value.includes(ei),
                      "onUpdate:modelValue": (Zr) => Wr(ei),
                      size: "medium"
                    }, null, 8, ["model-value", "onUpdate:modelValue"]),
                    createElementVNode("span", null, toDisplayString(ei + 1), 1)
                  ])
                ]),
                createVNode(TableFieldsList, {
                  data: Rr.value[ei],
                  "onUpdate:data": (Zr) => Rr.value[ei] = Zr,
                  onChange: (Zr) => li(ei),
                  fields: Ar.value
                }, null, 8, ["data", "onUpdate:data", "onChange", "fields"]),
                createElementVNode("td", _hoisted_16, [
                  createVNode(BxButton, {
                    circle: "",
                    secondary: Nr.value === ei,
                    size: "medium",
                    onClick: (Zr) => Nr.value = ei
                  }, {
                    icon: withCtx(() => [
                      createVNode(BxIcon, null, {
                        default: withCtx(() => [
                          createVNode(unref(EyeOutline))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["secondary", "onClick"])
                ])
              ]))), 256))
            ])
          ])
        ]),
        createElementVNode("footer", null, [
          createVNode(BxButton, { onClick: si }, {
            icon: withCtx(() => [
              createVNode(BxIcon, null, {
                default: withCtx(() => [
                  createVNode(unref(AddOutline))
                ]),
                _: 1
              })
            ]),
            default: withCtx(() => [
              ii[14] || (ii[14] = createTextVNode(" Add "))
            ]),
            _: 1
          })
        ])
      ])) : createCommentVNode("", !0)
    ], 2));
  }
}), BluepicBatchEditor_vue_vue_type_style_index_0_scoped_f37bb672_lang = "", BluepicBatchEditor_vue_vue_type_style_index_1_lang = "", BluepicBatchEditor = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["__scopeId", "data-v-f37bb672"]]), _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "BxSwitch",
  props: /* @__PURE__ */ mergeModels({
    disabled: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean, required: !1, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue"), ie = m;
    function we($e) {
      ie.disabled || (c.value = !c.value);
    }
    return ($e, Me) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-switch", { active: c.value, disabled: $e.disabled }]),
      onClick: we
    }, Me[0] || (Me[0] = [
      createElementVNode("div", { class: "switch-inner" }, [
        createElementVNode("div", { class: "switch-thumb" })
      ], -1)
    ]), 2));
  }
}), BxSwitch_vue_vue_type_style_index_0_scoped_f719ddd9_lang = "", BxSwitch = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["__scopeId", "data-v-f719ddd9"]]), BxSkeleton_vue_vue_type_style_index_0_scoped_1589b32d_lang = "", _sfc_main$7 = {}, _hoisted_1$5 = { class: "bx-skeleton" };
function _sfc_render$1(m, c) {
  return openBlock(), createElementBlock("div", _hoisted_1$5);
}
const BxSkeleton = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$1], ["__scopeId", "data-v-1589b32d"]]), CSS_COLOR_NAMES = {
  aliceblue: "#F0F8FF",
  antiquewhite: "#FAEBD7",
  aqua: "#00FFFF",
  aquamarine: "#7FFFD4",
  azure: "#F0FFFF",
  beige: "#F5F5DC",
  bisque: "#FFE4C4",
  black: "#000000",
  blanchedalmond: "#FFEBCD",
  blue: "#0000FF",
  blueviolet: "#8A2BE2",
  brown: "#A52A2A",
  burlywood: "#DEB887",
  cadetblue: "#5F9EA0",
  chartreuse: "#7FFF00",
  chocolate: "#D2691E",
  coral: "#FF7F50",
  cornflowerblue: "#6495ED",
  cornsilk: "#FFF8DC",
  crimson: "#DC143C",
  cyan: "#00FFFF",
  darkblue: "#00008B",
  darkcyan: "#008B8B",
  darkgoldenrod: "#B8860B",
  darkgray: "#A9A9A9",
  darkgrey: "#A9A9A9",
  darkgreen: "#006400",
  darkkhaki: "#BDB76B",
  darkmagenta: "#8B008B",
  darkolivegreen: "#556B2F",
  darkorange: "#FF8C00",
  darkorchid: "#9932CC",
  darkred: "#8B0000",
  darksalmon: "#E9967A",
  darkseagreen: "#8FBC8F",
  darkslateblue: "#483D8B",
  darkslategray: "#2F4F4F",
  darkslategrey: "#2F4F4F",
  darkturquoise: "#00CED1",
  darkviolet: "#9400D3",
  deeppink: "#FF1493",
  deepskyblue: "#00BFFF",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1E90FF",
  firebrick: "#B22222",
  floralwhite: "#FFFAF0",
  forestgreen: "#228B22",
  fuchsia: "#FF00FF",
  gainsboro: "#DCDCDC",
  ghostwhite: "#F8F8FF",
  gold: "#FFD700",
  goldenrod: "#DAA520",
  gray: "#808080",
  grey: "#808080",
  green: "#008000",
  greenyellow: "#ADFF2F",
  honeydew: "#F0FFF0",
  hotpink: "#FF69B4",
  indianred: "#CD5C5C",
  indigo: "#4B0082",
  ivory: "#FFFFF0",
  khaki: "#F0E68C",
  lavender: "#E6E6FA",
  lavenderblush: "#FFF0F5",
  lawngreen: "#7CFC00",
  lemonchiffon: "#FFFACD",
  lightblue: "#ADD8E6",
  lightcoral: "#F08080",
  lightcyan: "#E0FFFF",
  lightgoldenrodyellow: "#FAFAD2",
  lightgray: "#D3D3D3",
  lightgrey: "#D3D3D3",
  lightgreen: "#90EE90",
  lightpink: "#FFB6C1",
  lightsalmon: "#FFA07A",
  lightseagreen: "#20B2AA",
  lightskyblue: "#87CEFA",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#B0C4DE",
  lightyellow: "#FFFFE0",
  lime: "#00FF00",
  limegreen: "#32CD32",
  linen: "#FAF0E6",
  magenta: "#FF00FF",
  maroon: "#800000",
  mediumaquamarine: "#66CDAA",
  mediumblue: "#0000CD",
  mediumorchid: "#BA55D3",
  mediumpurple: "#9370DB",
  mediumseagreen: "#3CB371",
  mediumslateblue: "#7B68EE",
  mediumspringgreen: "#00FA9A",
  mediumturquoise: "#48D1CC",
  mediumvioletred: "#C71585",
  midnightblue: "#191970",
  mintcream: "#F5FFFA",
  mistyrose: "#FFE4E1",
  moccasin: "#FFE4B5",
  navajowhite: "#FFDEAD",
  navy: "#000080",
  oldlace: "#FDF5E6",
  olive: "#808000",
  olivedrab: "#6B8E23",
  orange: "#FFA500",
  orangered: "#FF4500",
  orchid: "#DA70D6",
  palegoldenrod: "#EEE8AA",
  palegreen: "#98FB98",
  paleturquoise: "#AFEEEE",
  palevioletred: "#DB7093",
  papayawhip: "#FFEFD5",
  peachpuff: "#FFDAB9",
  peru: "#CD853F",
  pink: "#FFC0CB",
  plum: "#DDA0DD",
  powderblue: "#B0E0E6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#FF0000",
  rosybrown: "#BC8F8F",
  royalblue: "#4169E1",
  saddlebrown: "#8B4513",
  salmon: "#FA8072",
  sandybrown: "#F4A460",
  seagreen: "#2E8B57",
  seashell: "#FFF5EE",
  sienna: "#A0522D",
  silver: "#C0C0C0",
  skyblue: "#87CEEB",
  slateblue: "#6A5ACD",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#FFFAFA",
  springgreen: "#00FF7F",
  steelblue: "#4682B4",
  tan: "#D2B48C",
  teal: "#008080",
  thistle: "#D8BFD8",
  tomato: "#FF6347",
  turquoise: "#40E0D0",
  violet: "#EE82EE",
  wheat: "#F5DEB3",
  white: "#FFFFFF",
  whitesmoke: "#F5F5F5",
  yellow: "#FFFF00",
  yellowgreen: "#9ACD32"
};
function hslToRgb(m, c, ie) {
  let we, $e, Me;
  if (c === 0)
    we = $e = Me = ie;
  else {
    const Ze = (gr, or, _r) => (_r < 0 && (_r += 1), _r > 1 && (_r -= 1), _r < 0.16666666666666666 ? gr + (or - gr) * 6 * _r : _r < 0.5 ? or : _r < 0.6666666666666666 ? gr + (or - gr) * (0.6666666666666666 - _r) * 6 : gr), ne = ie < 0.5 ? ie * (1 + c) : ie + c - ie * c, rr = 2 * ie - ne;
    we = Ze(rr, ne, m + 1 / 3), $e = Ze(rr, ne, m), Me = Ze(rr, ne, m - 1 / 3);
  }
  return [we * 255, $e * 255, Me * 255];
}
function rgba(m) {
  if (m.startsWith("rgb")) {
    const [c, ie, we] = m.slice(4, -1).split(",").map(($e) => Number($e.trim()));
    return [c, ie, we, 1];
  } else if (m.startsWith("rgba")) {
    const [c, ie, we, $e] = m.slice(5, -1).split(",").map((Me) => Number(Me.trim()));
    return [c, ie, we, $e];
  } else if (m.startsWith("#")) {
    const c = m.slice(1), ie = parseInt(c.slice(0, 2), 16), we = parseInt(c.slice(2, 4), 16), $e = parseInt(c.slice(4, 6), 16);
    return [ie, we, $e, 1];
  } else if (m.startsWith("hsl")) {
    const [c, ie, we] = m.slice(4, -1).split(",").map(($e) => Number($e.trim()));
    return [...hslToRgb(c, ie, we), 1];
  } else if (m.startsWith("hsla")) {
    const [c, ie, we, $e] = m.slice(5, -1).split(",").map((Me) => Number(Me.trim()));
    return [...hslToRgb(c, ie, we), $e];
  } else {
    if (m.startsWith("transparent"))
      return [0, 0, 0, 0];
    {
      const c = m.toLowerCase();
      if (c in CSS_COLOR_NAMES)
        return rgba(CSS_COLOR_NAMES[c]);
      throw new Error(`Unknown color: ${m}`);
    }
  }
}
function isDark(m) {
  const [c, ie, we] = rgba(m);
  return (c * 2126 + ie * 7152 + we * 722) / 1e4 < 128;
}
const _hoisted_1$4 = ["src", "alt"], _hoisted_2$3 = ["src", "alt"], _hoisted_3$1 = { viewBox: "0 0 35 35" }, _hoisted_4$1 = {
  x: "50%",
  y: "55%",
  "dominant-baseline": "middle",
  "text-anchor": "middle"
}, _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "BxAvatar",
  props: {
    user: {},
    team: {},
    square: { type: Boolean },
    thumbnail: { type: Boolean },
    src: {},
    name: {},
    colorSeed: {},
    backgroundColor: {},
    textColor: {},
    size: { default: "medium" }
  },
  setup(m) {
    const c = m, ie = computed(() => c.user ?? c.team), we = computed(() => c.name ? Ze(c.name) : ie.value ? Ze(ie.value.name) : ""), $e = computed(() => c.backgroundColor ? c.backgroundColor : c.colorSeed ? rr(c.colorSeed) : ie.value ? rr(ie.value.id) : "transparent"), Me = computed(() => c.textColor ? c.textColor : isDark($e.value) ? "white" : "black");
    function Ze(gr) {
      return gr.split(" ").map((or) => or[0]).join("");
    }
    function ne(gr) {
      for (var or = 5381, _r = 0; _r < gr.length; _r++)
        or = (or << 5) + or + gr.charCodeAt(_r);
      return or;
    }
    function rr(gr) {
      var or = ne(gr), _r = (or & 16711680) >> 16, Lr = (or & 65280) >> 8, Ir = or & 255;
      return "#" + ("0" + _r.toString(16)).substr(-2) + ("0" + Lr.toString(16)).substr(-2) + ("0" + Ir.toString(16)).substr(-2);
    }
    return (gr, or) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-avatar", {
        square: gr.square,
        [`size-${gr.size}`]: !0
      }])
    }, [
      gr.src ? (openBlock(), createElementBlock("img", {
        key: 0,
        src: gr.src,
        alt: `Avatar of ${gr.name}`
      }, null, 8, _hoisted_1$4)) : ie.value?.pictureFull && ie.value?.pictureThumb ? (openBlock(), createElementBlock("img", {
        key: 1,
        src: gr.thumbnail ? ie.value.pictureThumb : ie.value.pictureFull,
        alt: `Avatar of ${ie.value?.name}`
      }, null, 8, _hoisted_2$3)) : ie.value?.name || gr.name ? (openBlock(), createElementBlock("div", {
        key: 2,
        style: normalizeStyle({
          backgroundColor: $e.value,
          fill: Me.value,
          fontSize: "100%",
          display: "grid",
          placeItems: "center"
        })
      }, [
        (openBlock(), createElementBlock("svg", _hoisted_3$1, [
          createElementVNode("text", _hoisted_4$1, toDisplayString(we.value), 1)
        ]))
      ], 4)) : (openBlock(), createBlock(BxSkeleton, { key: 3 }))
    ], 2));
  }
}), BxAvatar_vue_vue_type_style_index_0_scoped_d12499eb_lang = "", BxAvatar = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["__scopeId", "data-v-d12499eb"]]), _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "BxTag",
  props: {
    size: { default: "medium" },
    round: { type: Boolean, default: !1 },
    status: { default: "default" }
  },
  setup(m) {
    return (c, ie) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-tag", { [`size-${c.size}`]: !0, [`status-${c.status}`]: !0, round: c.round }])
    }, [
      renderSlot(c.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), BxTag_vue_vue_type_style_index_0_scoped_fb8c8804_lang = "", BxTag = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["__scopeId", "data-v-fb8c8804"]]), _hoisted_1$3 = {
  key: 0,
  class: "info"
}, _hoisted_2$2 = { class: "name" }, _hoisted_3 = { class: "email" }, _hoisted_4 = { class: "menu" }, _hoisted_5 = { class: "bx-user-menu compact" }, _hoisted_6 = { class: "info" }, _hoisted_7 = { class: "name" }, _hoisted_8 = { class: "email" }, _hoisted_9 = {
  key: 0,
  class: "tags"
}, _hoisted_10 = { class: "menu__items" }, _hoisted_11 = {
  key: 1,
  class: "menu__extra"
}, _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "BxUserMenu",
  props: /* @__PURE__ */ mergeModels({
    user: {},
    jwt: {},
    availableLocales: {},
    compact: { type: Boolean },
    allowedPlacements: {},
    avatarSize: {},
    avatarBackgroundColor: {},
    avatarTextColor: {},
    env: { default: "prod" },
    bordered: { type: Boolean, default: !0 },
    show: { type: Boolean },
    socialLink: { type: Boolean, default: !1 },
    studioLink: { type: Boolean, default: !1 }
  }, {
    locale: {
      required: !1,
      default: "en-US"
    },
    localeModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels({
    logout: () => !0
  }, ["update:locale"]),
  setup(m, { emit: c }) {
    const ie = useModel(m, "locale"), we = m, $e = c, Me = useSlots();
    function Ze() {
      $e("logout");
    }
    const ne = computed(() => {
      const Xr = [];
      return we.user.permissions?.includes("bluepic.admin") && Xr.push("Bluepic Admin"), we.user.permissions?.includes("bluepic.affiliate") && Xr.push("Affiliate"), Xr;
    }), rr = computed(() => {
      const Xr = we.env === "prod" ? "" : ".staging";
      return {
        studio: `https://studio${Xr}.bluepic.io/?token=${we.jwt}`,
        embed: `https://embed${Xr}.bluepic.io/?token=${we.jwt}`,
        social: `https://social${Xr}.bluepic.io/?token=${we.jwt}`,
        dash: `https://dash.bluepic.io/?token=${we.jwt}`,
        account: `https://id${Xr}.bluepic.io/pages/me`,
        billing: `https://id${Xr}.bluepic.io/pages/billing`
      };
    }), gr = {
      studio: "https://imagedelivery.net/mudX-CmAqIANL8bxoNCToA/eed26102-f789-425d-833e-d7c934c88d00/public",
      embed: "https://imagedelivery.net/mudX-CmAqIANL8bxoNCToA/e558c90c-14b0-4acc-7632-7021cbb10200/public",
      social: "https://imagedelivery.net/mudX-CmAqIANL8bxoNCToA/1a50716a-bf1c-4bc4-c047-dd239cd58900/public",
      dash: "https://imagedelivery.net/mudX-CmAqIANL8bxoNCToA/619dea6d-ad96-43db-05c2-7957f4532300/public"
    };
    computed(() => ["studio", "embed", "social"].map((Wr) => ({
      label: Wr.toUpperCase(),
      avatar: gr[Wr],
      url: rr.value[Wr]
    })));
    function or(Xr) {
      const Wr = Xr.toUpperCase().split("").map((si) => 127397 + si.charCodeAt(0));
      return String.fromCodePoint(...Wr).slice(-4);
    }
    const _r = {
      "de-DE": "Deutsch (Deutschland)",
      "en-US": "English (United States)"
    };
    function Lr(Xr) {
      return _r[Xr] ?? new Intl.DisplayNames([Xr], {
        type: "language"
      }).of(Xr);
    }
    const Ir = computed(() => we.availableLocales?.map((Xr) => {
      const [, Wr] = Xr.split("-");
      return {
        label: or(Wr) + " " + Lr(Xr),
        value: Xr
      };
    })), Ar = {
      de: {
        account: "Konto",
        language: "Sprache",
        billing: "Abrechnung",
        "sign-out": "Abmelden",
        "sign-out-message": "M\xF6chtest du dich wirklich abmelden?",
        "stay-signed-in": "Angemeldet bleiben"
      },
      en: {
        account: "Account",
        language: "Language",
        billing: "Billing",
        "sign-out": "Sign out",
        "sign-out-message": "Do you really want to sign out?",
        "stay-signed-in": "Stay signed in"
      }
    };
    function Rr(Xr) {
      return Ar[(ie.value ?? "en-US").slice(0, 2)][Xr];
    }
    function Nr() {
      window.open(rr.value.social, "_blank");
    }
    function Yr() {
      window.open(rr.value.studio, "_blank");
    }
    function Vr() {
      window.open("https://learn.bluepic.io", "_blank");
    }
    return (Xr, Wr) => (openBlock(), createBlock(BxPopover, {
      show: Xr.show || void 0,
      "allowed-placements": Xr.allowedPlacements,
      trigger: "hover"
    }, {
      trigger: withCtx(() => [
        createElementVNode("div", {
          class: normalizeClass(["bx-user-menu trigger", { compact: Xr.compact, bordered: Xr.bordered }])
        }, [
          createVNode(BxAvatar, {
            size: "medium",
            user: Xr.user,
            "background-color": Xr.avatarBackgroundColor ?? "var(--primary-lighter, #C3D5F9FF)",
            "text-color": Xr.avatarTextColor ?? "var(--primary, #457DED)"
          }, null, 8, ["user", "background-color", "text-color"]),
          Xr.compact ? createCommentVNode("", !0) : (openBlock(), createElementBlock("div", _hoisted_1$3, [
            createElementVNode("span", _hoisted_2$2, toDisplayString(Xr.user.name), 1),
            createElementVNode("span", _hoisted_3, toDisplayString(Xr.user.email ?? Xr.user.newEmail), 1)
          ]))
        ], 2)
      ]),
      content: withCtx(() => [
        createElementVNode("div", _hoisted_4, [
          createElementVNode("div", _hoisted_5, [
            createVNode(BxAvatar, {
              size: "large",
              user: Xr.user,
              "background-color": Xr.avatarBackgroundColor ?? "var(--primary-lighter, #C3D5F9FF)",
              "text-color": Xr.avatarTextColor ?? "var(--primary, #457DED)"
            }, null, 8, ["user", "background-color", "text-color"]),
            createElementVNode("div", _hoisted_6, [
              createElementVNode("span", _hoisted_7, toDisplayString(Xr.user.name), 1),
              createElementVNode("span", _hoisted_8, toDisplayString(Xr.user.email ?? Xr.user.newEmail), 1)
            ])
          ]),
          ne.value.length ? (openBlock(), createElementBlock("div", _hoisted_9, [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(ne.value, (si) => (openBlock(), createBlock(BxTag, {
              round: "",
              type: "primary"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(si), 1)
              ]),
              _: 2
            }, 1024))), 256))
          ])) : createCommentVNode("", !0),
          createElementVNode("div", _hoisted_10, [
            createVNode(BxButton, {
              quaternary: "",
              tag: "a",
              href: rr.value.account,
              target: "_blank"
            }, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(ArrowRedoOutline))
                  ]),
                  _: 1
                })
              ]),
              default: withCtx(() => [
                createElementVNode("span", null, toDisplayString(Rr("account")), 1)
              ]),
              _: 1
            }, 8, ["href"]),
            Ir.value ? (openBlock(), createBlock(BxSelect, {
              key: 0,
              options: Ir.value,
              modelValue: ie.value,
              "onUpdate:modelValue": Wr[0] || (Wr[0] = (si) => ie.value = si)
            }, null, 8, ["options", "modelValue"])) : createCommentVNode("", !0),
            createVNode(BxButton, {
              quaternary: "",
              tag: "a",
              href: rr.value.billing,
              target: "_blank"
            }, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(CardOutline))
                  ]),
                  _: 1
                })
              ]),
              default: withCtx(() => [
                createElementVNode("span", null, toDisplayString(Rr("billing")), 1)
              ]),
              _: 1
            }, 8, ["href"]),
            Xr.socialLink ? (openBlock(), createBlock(BxButton, {
              key: 1,
              quaternary: "",
              type: "error",
              onClick: Vr
            }, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(BulbOutline))
                  ]),
                  _: 1
                })
              ]),
              default: withCtx(() => [
                Wr[1] || (Wr[1] = createElementVNode("span", null, "Learn Bluepic", -1))
              ]),
              _: 1
            })) : createCommentVNode("", !0),
            Xr.socialLink ? (openBlock(), createBlock(BxButton, {
              key: 2,
              quaternary: "",
              type: "error",
              onClick: Nr
            }, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(ArrowRedoOutline))
                  ]),
                  _: 1
                })
              ]),
              default: withCtx(() => [
                Wr[2] || (Wr[2] = createElementVNode("span", null, "Bluepic SOCIAL", -1))
              ]),
              _: 1
            })) : createCommentVNode("", !0),
            Xr.studioLink ? (openBlock(), createBlock(BxButton, {
              key: 3,
              quaternary: "",
              type: "error",
              onClick: Yr
            }, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(ArrowRedoOutline))
                  ]),
                  _: 1
                })
              ]),
              default: withCtx(() => [
                Wr[3] || (Wr[3] = createElementVNode("span", null, "Bluepic STUDIO", -1))
              ]),
              _: 1
            })) : createCommentVNode("", !0),
            createVNode(BxButton, {
              quaternary: "",
              type: "error",
              onClick: Ze
            }, {
              icon: withCtx(() => [
                createVNode(BxIcon, null, {
                  default: withCtx(() => [
                    createVNode(unref(ExitOutline))
                  ]),
                  _: 1
                })
              ]),
              default: withCtx(() => [
                createElementVNode("span", null, toDisplayString(Rr("sign-out")), 1)
              ]),
              _: 1
            })
          ]),
          Me["menu-extra"] ? (openBlock(), createElementBlock("div", _hoisted_11, [
            renderSlot(Xr.$slots, "menu-extra", {}, void 0, !0)
          ])) : createCommentVNode("", !0)
        ])
      ]),
      _: 3
    }, 8, ["show", "allowed-placements"]));
  }
}), BxUserMenu_vue_vue_type_style_index_0_scoped_de4d86fe_lang = "", BxUserMenu = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["__scopeId", "data-v-de4d86fe"]]), _hoisted_1$2 = { class: "bx-color-picker" }, _hoisted_2$1 = {
  key: 0,
  class: "color-label"
}, _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "BxColorPicker",
  props: /* @__PURE__ */ mergeModels({
    showLabel: { type: Boolean, default: !1 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue"), ie = ref$1();
    onMounted(() => {
      !ie.value || ie.value.addEventListener("input", ($e) => {
        c.value = $e.target.value;
      });
    });
    function we() {
      ie.value?.click();
    }
    return ($e, Me) => (openBlock(), createElementBlock("div", _hoisted_1$2, [
      createElementVNode("div", {
        class: "color-value",
        style: normalizeStyle({ "--color-value": c.value }),
        onClick: we
      }, [
        $e.showLabel ? (openBlock(), createElementBlock("span", _hoisted_2$1, toDisplayString(c.value), 1)) : createCommentVNode("", !0)
      ], 4),
      withDirectives(createElementVNode("input", {
        ref_key: "hiddenColorInputRef",
        ref: ie,
        class: "hidden-color-input",
        type: "color",
        "onUpdate:modelValue": Me[0] || (Me[0] = (Ze) => c.value = Ze)
      }, null, 512), [
        [vModelText, c.value]
      ])
    ]));
  }
}), BxColorPicker_vue_vue_type_style_index_0_scoped_3ba46b8b_lang = "", BxColorPicker = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["__scopeId", "data-v-3ba46b8b"]]), _sfc_main$2 = {}, _hoisted_1$1 = { class: "bx-tab" };
function _sfc_render(m, c) {
  return openBlock(), createElementBlock("div", _hoisted_1$1, "BXTAB");
}
const BxTab = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render]]), _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "BxRadioGroup",
  props: /* @__PURE__ */ mergeModels({
    vertical: { type: Boolean, default: !1 },
    size: { default: "medium" },
    disabled: { type: Boolean, default: !1 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const c = useModel(m, "modelValue");
    provide("bxPopoverValue", c);
    const ie = useSlots(), { setSlotRef: we, slotElements: $e, vNodes: Me } = useSlotVNodes(ie.default);
    return provide("selectRadio", (ne) => {
      c.value = ne;
    }), (ne, rr) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-radio-group", {
        vertical: ne.vertical,
        [`size-${ne.size}`]: !0,
        disabled: ne.disabled
      }])
    }, [
      (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(Me), (gr, or) => (openBlock(), createBlock(resolveDynamicComponent(gr), {
        ref_for: !0,
        ref: unref(we)(or)
      }, null, 512))), 256))
    ], 2));
  }
}), BxRadioGroup_vue_vue_type_style_index_0_scoped_606fd804_lang = "", BxRadioGroup = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-606fd804"]]), _hoisted_1 = ["data-bx-radio-name"], _hoisted_2 = { class: "bx-radio__label" }, _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BxRadio",
  props: {
    name: {},
    size: { default: "medium" }
  },
  setup(m) {
    const c = m, ie = inject("selectRadio");
    function we() {
      ie?.(c.name);
    }
    const $e = inject("bxPopoverValue");
    return (Me, Ze) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["bx-radio", {
        [`size-${Me.size}`]: !0,
        active: unref($e) === Me.name
      }]),
      "data-bx-radio-name": Me.name,
      onClick: we
    }, [
      Ze[0] || (Ze[0] = createElementVNode("div", { class: "bx-radio__toggle" }, null, -1)),
      createElementVNode("div", _hoisted_2, [
        renderSlot(Me.$slots, "label", {}, void 0, !0)
      ])
    ], 10, _hoisted_1));
  }
}), BxRadio_vue_vue_type_style_index_0_scoped_680cd620_lang = "", BxRadio = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-680cd620"]]);
function getThemeStyle(m) {
  const c = css.parse(m).stylesheet?.rules.find((ie) => ie.type === "rule" && ie.selectors?.includes(":root"));
  if (!c)
    throw new Error("No :root rule found in the CSS");
  return c.declarations?.reduce((ie, we) => (we.type === "declaration" && we.property && we.value && (ie[we.property.replace(/^--(.*)$/, "$1")] = we.value), ie), {}) ?? {};
}
const preferedColorScheme = ref$1(window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (m) => {
  preferedColorScheme.value = m.matches ? "dark" : "light";
});
function useTheme(m = GLOBAL_APP_WRAPPER_SELECTOR, c = "auto") {
  const ie = nanoid(), we = ref$1(getThemeStyle((c === "auto" ? preferedColorScheme.value === "dark" : c) ? BxEmbedThemeDarkmode : BxEmbedThemeLightmode)), $e = computed(() => {
    if (!!we.value)
      return Object.fromEntries(Object.entries(we.value).map(([ne, rr]) => [`--${ne}`, rr]));
  }), Me = document.querySelector(m);
  if (!Me)
    throw new Error(`Element with selector ${m} not found`);
  const Ze = Me.parentElement;
  if (!Ze)
    throw new Error(`Parent element of ${m} not found`);
  return Ze.setAttribute("data-bx-style-target", ie), watch($e, () => {
    if ($e.value) {
      let ne = document.querySelector(`style[data-bx-style='${ie}']`);
      ne || (ne = document.createElement("style"), ne.setAttribute("data-bx-style", ie), document.head.appendChild(ne)), ne.innerHTML = `[data-bx-style-target='${ie}'], .bluepic-popup-provider__wrapper { ${Object.entries($e.value).map(([rr, gr]) => `${rr}: ${gr};`).join(" ")} }`;
    }
  }, { immediate: !0, deep: !0 }), we;
}
const BxEmbedThemeDarkmode = `:root {
  --primary-color-base: 0, 105, 255; /* #0069ff */
  --primary-color-dark: 4, 84, 195; /* #0454c3 */
  --primary-color-light: 135, 180, 244; /* #B9E1F5 */
  --primary-color-bright: 135, 180, 244; /* #B9E1F5 */

  --success-color-base: 40, 165, 82; /* #28A552 */
  --success-color-light: 93, 203, 126; /* #5DCB7E */
  --success-color-dark: 33, 131, 66; /* #218342 */
  --success-color-darker: 25, 97, 49; /* #196131 */

  --error-color-base: 220, 47, 47; /* #DC2F2F */
  --error-color-light: 242, 90, 90; /* #F25A5A */
  --error-color-dark: 172, 38, 38; /* #AC2626 */
  --error-color-darker: 142, 53, 53; /* #8E3535 */

  --warning-color-base: 204, 198, 58; /* #CCC63A */
  --warning-color-light: 245, 243, 165; /* #F5F3A5 */
  --warning-color-dark: 161, 157, 46; /* #A19D2E */
  --warning-color-darker: 106, 103, 30; /* #6A671E */

  --text-color-base: 255, 255, 255;
  --text-color-alt: 17, 17, 17;
  

  --border-color-base: 255, 255, 255; /* #888888 */

  --input-border-color: rgba(255, 255, 255, 0.3);
  --input-border-color-hover: rgba(255, 255, 255, 0.3);
  --input-border-color-focus: rgba(var(--primary-color-bright), 0.65);
  --input-shadow-focus-color: rgba(var(--primary-color-bright), 0.65);
  --input-background-color: rgba(255, 255, 255, 0.07);
  --input-outline-color-focus: rgba(var(--primary-color-light), 0.5);
  --input-border-color-disabled: rgba(255, 255, 255, 0.25);
  --input-opacity-disabled: 0.55;

  --card-background-color: rgba(255, 255, 255, 0.07);
  --card-border-color: rgba(255, 255, 255, 0.06);
  --card-header-divider-color: rgba(255, 255, 255, 0.15);
  --card-footer-divider-color: rgba(255, 255, 255, 0.15);
  --card-footer-background-color: rgba(0, 0, 0, 0.05);

  --select-background-color: #444954b8;
  --select-background-color-hover: #444954b8;
  --select-background-color-focus: #444954b8;
  --select-border: 1px solid rgba(var(--border-color-base), 0);
  --select-border-hover: 1px solid rgba(var(--primary-color-bright), 1);
  --select-border-focus: 1px solid rgba(var(--primary-color-bright), 1);
  --select-color: rgba(var(--text-color-base), 1);
  --select-color-hover: rgba(var(--text-color-base), 1);
  --select-color-focus: rgba(var(--text-color-base), 1);

  --checkbox-border-color: rgba(var(--border-color-base), 0.6);
  --checkbox-outline-color-focus: rgba(var(--primary-color-bright), 0.5);
  --checkbox-border-color-focus: rgba(var(--primary-color-light), 0);
  --checkbox-border-color-checked: rgba(var(--primary-color-base), 0);
  --checkbox-background-color-checked: rgba(var(--primary-color-base), 1);

  --popover-background-color: rgb(41, 41, 49);
  --popover-border: 1px solid rgba(255, 255, 255, 0.1);
  --popover-arrow-border-color: #3f3f45;
  --popup-background-color: rgb(41, 41, 49);

  --tooltip-background-color: rgba(255, 255, 255);
  --tooltip-text-color: rgba(var(--text-color-alt), 1);

  --menu-item-color: rgba(var(--text-color-base), 1);
  --menu-item-color-active: rgba(var(--primary-color-bright), 1);
  --menu-item-background-color: transparent;
  --menu-item-background-color-active: rgba(var(--primary-color-bright), 0.2);
  --menu-item-background-color-hover: rgba(255, 255, 255, 0.1);

  --labeled-text-color: rgba(var(--text-color-base), 0.7);
  --label-background-color: rgba(30, 30, 30, 0.7);

  --list-divider: 1px solid rgba(255, 255, 255, 0.1);
  --list-item-background-color-hover: rgba(0, 0, 0, 0.2);

  --empty-text-color: rgba(var(--text-color-base), 0.5);

  --select-button-background-color: rgba(39, 39, 39, 0.65);
  --select-button-background-color-hover: rgb(0, 0, 0, 0.1);

  --tag-background-color: rgba(255, 255, 255, 0.1);
  --tag-color: rgba(var(--text-color-base), 1);
  --tag-border-color: rgba(255, 255, 255, 0.2);

  --tag-error-background-color: rgba(var(--error-color-base), 0.5);
  --tag-error-color: rgba(255, 255, 255, 1);
  --tag-error-border-color: rgba(var(--error-color-base), 0.7);

  --slider-body-background-color: #6a74898b;
  --slider-body-background-color-hover: #6a74898b;
  --slider-body-background-color-focus: #6a74898b;

  --slider-thumb-background-color: #fff;
  --slider-thumb-background-color-hover: #fff;
  --slider-thumb-background-color-focus: #fff;
  --slider-thumb-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);

  --slider-value-background-color: rgba(var(--primary-color-light), 1);
  --slider-value-background-color-hover: rgba(var(--primary-color-light), 1);
  --slider-value-background-color-focus: rgba(var(--primary-color-light), 1);

  --progress-background-color: rgba(255, 255, 255, 0.142);
  --progress-value-color: rgba(var(--primary-color-light), 1);

  --tab-color: #fff;
  --tab-color-active: rgba(var(--primary-color-light), 1);
  --tab-segment-background-color: rgba(255, 255, 255, 0.1);
  --tab-segment-background-color-active: rgba(255, 255, 255, 0.15);
  --tab-segment-color: rgba(var(--text-color-base), 1);
  --tab-segment-color-active: rgba(var(--text-color-base), 1);

  /* Radio */

  --radio-background-color: transparent;
  --radio-background-color-active: rgba(var(--primary-color-base), 1);
  --radio-background-color-hover: transparent;
  --radio-border: 1px solid rgba(var(--border-color-base), 0.5);
  --radio-border-active: 1px solid rgba(var(--primary-color-base), 1);
  --radio-border-color-hover: rgba(var(--primary-color-base), 1);
  --radio-symbol-color: rgba(var(--text-color-base), 1);
  --radio-label-color: rgba(var(--text-color-base), 1);
  --radio-label-color-active: rgba(var(--text-color-base), 1);

  /* Button */

  --button-border: 1px solid rgba(var(--border-color-base), 0.5);
  --button-border-hover: 1px solid rgba(var(--border-color-base), 0.5);
  --button-border-focus: 1px solid rgba(var(--border-color-base), 0.5);
  --button-background-color: transparent;
  --button-background-color-hover: rgba(255, 255, 255, 0.1);
  --button-background-color-focus: rgba(255, 255, 255, 0.1);
  --button-text-color: rgba(var(--text-color-base), 1);
  --button-text-color-hover: rgba(var(--text-color-base), 1);
  --button-text-color-focus: rgba(var(--text-color-base), 1);
  --button-box-shadow: none;
  --button-box-shadow-hover: none;

  --button-secondary-border: 1px solid transparent;
  --button-secondary-border-hover: 1px solid transparent;
  --button-secondary-border-focus: 1px solid transparent;
  --button-secondary-background-color: #fff;
  --button-secondary-background-color-hover: #fff;
  --button-secondary-background-color-focus: #fff;
  --button-secondary-text-color: rgba(var(--text-color-alt), 1);
  --button-secondary-text-color-hover: rgba(var(--text-color-alt), 1);
  --button-secondary-text-color-focus: rgba(var(--text-color-alt), 1);
  --button-secondary-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  --button-secondary-box-shadow-hover: 0px 1px 6px 5px rgba(0, 0, 0, 0.2);

  --message-body-background-color: rgb(57, 57, 68);
  --message-body-text-color: rgba(var(--text-color-base), 1);
  --message-body-border: 1px solid rgba(var(--border-color-base), 0.2);

  --canvas-background-color: rgba(0, 0, 0, 0.25);
  --canvas-background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxyZWN0IHg9IjAlIiB5PSIwJSIgd2lkdGg9IjUwJSIgaGVpZ2h0PSI1MCUiIHN0eWxlPSJmaWxsOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMDUpOyIgLz4KICA8cmVjdCB4PSI1MCUiIHk9IjUwJSIgd2lkdGg9IjUwJSIgaGVpZ2h0PSI1MCUiIHN0eWxlPSJmaWxsOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMDUpOyIgLz4KPC9zdmc+');
  --canvas-btn-background-color: rgba(255, 255, 255, 0.35);
  --canvas-btn-background-color-hover: rgba(255, 255, 255, 0.3);
  --canvas-btn-color: #fff;

  --select-item-border: 2px solid rgba(var(--primary-color-light), 1);

  --editor-view-background-color: #26262B;
  --fields-view-background-color: transparent;
  --live-view-background-color: transparent;
}
.bluepic-app-wrapper {
  background-color: #303039;
  color: #fff;
}
`, BxEmbedThemeLightmode = `:root {
  --primary-color-base: 18, 75, 186; /* #124BBA */
  --primary-color-light: 80, 133, 209;

  --primary-color-dark: 4, 84, 195; /* #0454c3 */
  --primary-color-bright: 135, 180, 244; /* #B9E1F5 */

  --success-color-base: 40, 165, 82; /* #28A552 */
  --success-color-light: 93, 203, 126; /* #5DCB7E */
  --success-color-dark: 33, 131, 66; /* #218342 */
  --success-color-darker: 25, 97, 49; /* #196131 */

  --error-color-base: 220, 47, 47; /* #DC2F2F */
  --error-color-light: 242, 90, 90; /* #F25A5A */
  --error-color-dark: 172, 38, 38; /* #AC2626 */
  --error-color-darker: 142, 53, 53; /* #8E3535 */

  --warning-color-base: 204, 198, 58; /* #CCC63A */
  --warning-color-light: 245, 243, 165; /* #F5F3A5 */
  --warning-color-dark: 161, 157, 46; /* #A19D2E */
  --warning-color-darker: 106, 103, 30; /* #6A671E */

  --border-color-base: 0, 0, 0; /* #888888 */
  --text-color-base: 17, 17, 17; /* #111111 */
  --text-color-alt: 255, 255, 255; /* #ffffff */

  --card-border-color: rgba(0, 0, 0, 0.075); /* #eeeeee */
  --card-background-color: rgb(255, 255, 255); /* #ffffff */
  --card-background-color-hover: rgb(0, 0, 0); /* #f5f5f5 */
  --card-header-divider-color: rgba(0, 0, 0, 0.074);
  --card-footer-divider-color: gba(0, 0, 0, 0.074);
  --card-footer-background-color: rgba(245, 245, 245, 0); /* #f5f5f5 */

  --popover-without-darkened-bg-background-color: 255, 255, 255; /* #ffffff */
  --popover-without-darkened-bg-box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);

  --input-border-color: rgba(var(--border-color-base), 0.25);
  --input-border-color-hover: rgba(var(--border-color-base), 0.25);
  --input-border-color-focus: rgba(var(--primary-color-bright), 0.65);
  --input-shadow-focus-color: rgba(var(--primary-color-bright), 0.65);
  --input-background-color: rgba(0, 0, 0, 0.015);
  --input-outline-color-focus: rgba(var(--primary-color-light), 0.5);
  --input-border-color-disabled: rgba(var(--border-color-base), 0.05);
  --input-opacity-disabled: 0.5;

  --checkbox-border-color: rgba(var(--border-color-base), 0.5);
  --checkbox-outline-color-focus: rgba(var(--primary-color-base), 0.5);
  --checkbox-border-color-focus: rgba(var(--primary-color-base), 0);
  --checkbox-border-color-checked: rgba(var(--primary-color-base), 0);
  --checkbox-background-color-checked: rgba(var(--primary-color-base), 1);

  --labeled-text-color: rgba(var(--text-color-base), 0.7);
  --label-background-color: rgba(210, 210, 210, 0.7);

  --select-background-color: rgba(0, 0, 0, 0.015);
  --select-background-color-hover: rgba(0, 0, 0, 0.015);
  --select-background-color-focus: rgba(0, 0, 0, 0.015);
  --select-border: 2px solid rgba(var(--border-color-base), 0.1);
  --select-border-hover: 2px solid rgba(var(--primary-color-bright), 0.75);
  --select-border-focus: 2px solid rgba(var(--primary-color-bright), 0.75);
  --select-color: rgba(var(--text-color-base), 1);
  --select-color-hover: rgba(var(--text-color-base), 1);
  --select-color-focus: rgba(var(--text-color-base), 1);

  --popover-background-color: rgba(255, 255, 255, 1);
  --popover-border: 1px solid rgba(9, 9, 9, 0.1);
  --popover-arrow-border-color: rgba(9, 9, 9, 0.1);
  --popup-background-color: rgba(255, 255, 255, 1);

  --tooltip-background-color: rgb(33, 33, 33);
  --tooltip-text-color: rgba(var(--text-color-alt), 1);

  --menu-item-color: rgba(var(--text-color-base), 1);
  --menu-item-color-active: rgba(var(--primary-color-base), 1);
  --menu-item-background-color: transparent;
  --menu-item-background-color-active: rgba(var(--primary-color-light), 0.2);
  --menu-item-background-color-hover: rgba(0, 0, 0, 0.075);

  --list-divider: 1px solid #fefefe;
  --list-item-background-color-hover: rgba(0, 0, 0, 0.05);

  --empty-text-color: rgba(var(--text-color-base), 0.5);

  --select-button-background-color: rgba(255, 255, 255, 0.65);
  --select-button-background-color-hover: rgba(0, 0, 0, 0.1);

  --tag-background-color: rgba(0, 0, 0, 0.1);
  --tag-color: rgba(var(--text-color-base), 1);
  --tag-border-color: rgba(0, 0, 0, 0.2);

  --tag-error-background-color: rgba(var(--error-color-base), 0.3);
  --tag-error-color: rgba(255, 255, 255, 1);
  --tag-error-border-color: rgba(var(--error-color-base), 0.5);

  --slider-body-background-color: #e5e5e5;
  --slider-body-background-color-hover: #e5e5e5;
  --slider-body-background-color-focus: #e5e5e5;

  --slider-thumb-background-color: #fff;
  --slider-thumb-background-color-hover: #fff;
  --slider-thumb-background-color-focus: #fff;
  --slider-thumb-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);

  --slider-value-background-color: rgba(var(--primary-color-base), 1);
  --slider-value-background-color-hover: rgba(var(--primary-color-base), 1);
  --slider-value-background-color-focus: rgba(var(--primary-color-base), 1);

  --progress-background-color: rgba(0, 0, 0, 0.142);
  --progress-value-color: rgba(var(--primary-color-base), 1);

  --tab-color: rgba(var(--text-color-base), 1);
  --tab-color-active: rgba(var(--primary-color-base), 1);
  --tab-segment-background-color: rgba(255, 255, 255, 0.1);
  --tab-segment-background-color-active: rgba(255, 255, 255, 0.15);
  --tab-segment-color: rgba(var(--text-color-base), 1);
  --tab-segment-color-active: rgba(var(--text-color-base), 1);

  /* Button */

  --button-border: 1px solid rgba(var(--border-color-base), 0.2);
  --button-border-hover: 1px solid rgba(var(--border-color-base), 0.2);
  --button-border-focus: 1px solid rgba(var(--border-color-base), 0.2);
  --button-background-color: transparent;
  --button-background-color-hover: rgba(0, 0, 0, 0.05);
  --button-background-color-focus: rgba(0, 0, 0, 0.05);
  --button-text-color: rgba(var(--text-color-base), 1);
  --button-text-color-hover: rgba(var(--text-color-base), 1);
  --button-text-color-focus: rgba(var(--text-color-base), 1);
  --button-box-shadow: none;
  --button-box-shadow-hover: none;

  --button-secondary-border: 1px solid transparent;
  --button-secondary-border-hover: 1px solid transparent;
  --button-secondary-border-focus: 1px solid transparent;
  --button-secondary-background-color: rgb(18, 75, 186);
  --button-secondary-background-color-hover: rgb(18, 75, 186);
  --button-secondary-background-color-focus: rgb(18, 75, 186);
  --button-secondary-text-color: rgba(var(--text-color-alt), 1);
  --button-secondary-text-color-hover: rgba(var(--text-color-alt), 1);
  --button-secondary-text-color-focus: rgba(var(--text-color-alt), 1);
  --button-secondary-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.025);
  --button-secondary-box-shadow-hover: 0px 1px 6px 5px rgba(0, 0, 0, 0.05);

  --message-body-background-color: rgba(255, 255, 255, 1);
  --message-body-text-color: rgba(var(--text-color-base), 1);
  --message-body-border: 1px solid rgba(var(--border-color-base), 0.2);

  --canvas-background-color: rgba(255, 255, 255, 0.25);
  --canvas-background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxyZWN0IHg9IjAlIiB5PSIwJSIgd2lkdGg9IjUwJSIgaGVpZ2h0PSI1MCUiIHN0eWxlPSJmaWxsOiByZ2JhKDAsIDAsIDAsIDAuMSk7IiAvPgogIDxyZWN0IHg9IjUwJSIgeT0iNTAlIiB3aWR0aD0iNTAlIiBoZWlnaHQ9IjUwJSIgc3R5bGU9ImZpbGw6IHJnYmEoMCwgMCwgMCwgMC4xKTsiIC8+Cjwvc3ZnPg==');
  --canvas-btn-background-color: rgba(0, 0, 0, 0.3);
  --canvas-btn-background-color-hover: rgba(0, 0, 0, 0.35);
  --canvas-btn-color: #fff;

  --select-item-border: 2px solid rgba(var(--primary-color-light), 1);

  --editor-view-background-color: #fff;
  --fields-view-background-color: rgba(0, 0, 0, 0.05);
  --live-view-background-color: transparent;
}

.bluepic-app-wrapper {
  background-color: #fff;
  color: #000;
}
`;
function commonjsRequire(m) {
  throw new Error('Could not dynamically require "' + m + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var object_hash = { exports: {} };
(function(m, c) {
  (function(ie) {
    m.exports = ie();
  })(function() {
    return function ie(we, $e, Me) {
      function Ze(gr, or) {
        if (!$e[gr]) {
          if (!we[gr]) {
            var _r = typeof commonjsRequire == "function" && commonjsRequire;
            if (!or && _r)
              return _r(gr, !0);
            if (ne)
              return ne(gr, !0);
            throw new Error("Cannot find module '" + gr + "'");
          }
          or = $e[gr] = { exports: {} }, we[gr][0].call(or.exports, function(Lr) {
            var Ir = we[gr][1][Lr];
            return Ze(Ir || Lr);
          }, or, or.exports, ie, we, $e, Me);
        }
        return $e[gr].exports;
      }
      for (var ne = typeof commonjsRequire == "function" && commonjsRequire, rr = 0; rr < Me.length; rr++)
        Ze(Me[rr]);
      return Ze;
    }({ 1: [function(ie, we, $e) {
      (function(Me, Ze, ne, rr, gr, or, _r, Lr, Ir) {
        var Ar = ie("crypto");
        function Rr(li, xi) {
          xi = Vr(li, xi);
          var di;
          return (di = xi.algorithm !== "passthrough" ? Ar.createHash(xi.algorithm) : new si()).write === void 0 && (di.write = di.update, di.end = di.update), Wr(xi, di).dispatch(li), di.update || di.end(""), di.digest ? di.digest(xi.encoding === "buffer" ? void 0 : xi.encoding) : (li = di.read(), xi.encoding !== "buffer" ? li.toString(xi.encoding) : li);
        }
        ($e = we.exports = Rr).sha1 = function(li) {
          return Rr(li);
        }, $e.keys = function(li) {
          return Rr(li, { excludeValues: !0, algorithm: "sha1", encoding: "hex" });
        }, $e.MD5 = function(li) {
          return Rr(li, { algorithm: "md5", encoding: "hex" });
        }, $e.keysMD5 = function(li) {
          return Rr(li, { algorithm: "md5", encoding: "hex", excludeValues: !0 });
        };
        var Nr = Ar.getHashes ? Ar.getHashes().slice() : ["sha1", "md5"], Yr = (Nr.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
        function Vr(li, xi) {
          var di = {};
          if (di.algorithm = (xi = xi || {}).algorithm || "sha1", di.encoding = xi.encoding || "hex", di.excludeValues = !!xi.excludeValues, di.algorithm = di.algorithm.toLowerCase(), di.encoding = di.encoding.toLowerCase(), di.ignoreUnknown = xi.ignoreUnknown === !0, di.respectType = xi.respectType !== !1, di.respectFunctionNames = xi.respectFunctionNames !== !1, di.respectFunctionProperties = xi.respectFunctionProperties !== !1, di.unorderedArrays = xi.unorderedArrays === !0, di.unorderedSets = xi.unorderedSets !== !1, di.unorderedObjects = xi.unorderedObjects !== !1, di.replacer = xi.replacer || void 0, di.excludeKeys = xi.excludeKeys || void 0, li === void 0)
            throw new Error("Object argument required.");
          for (var oi = 0; oi < Nr.length; ++oi)
            Nr[oi].toLowerCase() === di.algorithm.toLowerCase() && (di.algorithm = Nr[oi]);
          if (Nr.indexOf(di.algorithm) === -1)
            throw new Error('Algorithm "' + di.algorithm + '"  not supported. supported values: ' + Nr.join(", "));
          if (Yr.indexOf(di.encoding) === -1 && di.algorithm !== "passthrough")
            throw new Error('Encoding "' + di.encoding + '"  not supported. supported values: ' + Yr.join(", "));
          return di;
        }
        function Xr(li) {
          if (typeof li == "function")
            return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(li)) != null;
        }
        function Wr(li, xi, di) {
          di = di || [];
          function oi(ci) {
            return xi.update ? xi.update(ci, "utf8") : xi.write(ci, "utf8");
          }
          return { dispatch: function(ci) {
            return this["_" + ((ci = li.replacer ? li.replacer(ci) : ci) === null ? "null" : typeof ci)](ci);
          }, _object: function(ci) {
            var vr, Ae = Object.prototype.toString.call(ci), ze = /\[object (.*)\]/i.exec(Ae);
            if (ze = (ze = ze ? ze[1] : "unknown:[" + Ae + "]").toLowerCase(), 0 <= (Ae = di.indexOf(ci)))
              return this.dispatch("[CIRCULAR:" + Ae + "]");
            if (di.push(ci), ne !== void 0 && ne.isBuffer && ne.isBuffer(ci))
              return oi("buffer:"), oi(ci);
            if (ze === "object" || ze === "function" || ze === "asyncfunction")
              return Ae = Object.keys(ci), li.unorderedObjects && (Ae = Ae.sort()), li.respectType === !1 || Xr(ci) || Ae.splice(0, 0, "prototype", "__proto__", "constructor"), li.excludeKeys && (Ae = Ae.filter(function(Ue) {
                return !li.excludeKeys(Ue);
              })), oi("object:" + Ae.length + ":"), vr = this, Ae.forEach(function(Ue) {
                vr.dispatch(Ue), oi(":"), li.excludeValues || vr.dispatch(ci[Ue]), oi(",");
              });
            if (!this["_" + ze]) {
              if (li.ignoreUnknown)
                return oi("[" + ze + "]");
              throw new Error('Unknown object type "' + ze + '"');
            }
            this["_" + ze](ci);
          }, _array: function(ci, Ue) {
            Ue = Ue !== void 0 ? Ue : li.unorderedArrays !== !1;
            var Ae = this;
            if (oi("array:" + ci.length + ":"), !Ue || ci.length <= 1)
              return ci.forEach(function(tr) {
                return Ae.dispatch(tr);
              });
            var ze = [], Ue = ci.map(function(tr) {
              var lr = new si(), pr = di.slice();
              return Wr(li, lr, pr).dispatch(tr), ze = ze.concat(pr.slice(di.length)), lr.read().toString();
            });
            return di = di.concat(ze), Ue.sort(), this._array(Ue, !1);
          }, _date: function(ci) {
            return oi("date:" + ci.toJSON());
          }, _symbol: function(ci) {
            return oi("symbol:" + ci.toString());
          }, _error: function(ci) {
            return oi("error:" + ci.toString());
          }, _boolean: function(ci) {
            return oi("bool:" + ci.toString());
          }, _string: function(ci) {
            oi("string:" + ci.length + ":"), oi(ci.toString());
          }, _function: function(ci) {
            oi("fn:"), Xr(ci) ? this.dispatch("[native]") : this.dispatch(ci.toString()), li.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(ci.name)), li.respectFunctionProperties && this._object(ci);
          }, _number: function(ci) {
            return oi("number:" + ci.toString());
          }, _xml: function(ci) {
            return oi("xml:" + ci.toString());
          }, _null: function() {
            return oi("Null");
          }, _undefined: function() {
            return oi("Undefined");
          }, _regexp: function(ci) {
            return oi("regex:" + ci.toString());
          }, _uint8array: function(ci) {
            return oi("uint8array:"), this.dispatch(Array.prototype.slice.call(ci));
          }, _uint8clampedarray: function(ci) {
            return oi("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(ci));
          }, _int8array: function(ci) {
            return oi("int8array:"), this.dispatch(Array.prototype.slice.call(ci));
          }, _uint16array: function(ci) {
            return oi("uint16array:"), this.dispatch(Array.prototype.slice.call(ci));
          }, _int16array: function(ci) {
            return oi("int16array:"), this.dispatch(Array.prototype.slice.call(ci));
          }, _uint32array: function(ci) {
            return oi("uint32array:"), this.dispatch(Array.prototype.slice.call(ci));
          }, _int32array: function(ci) {
            return oi("int32array:"), this.dispatch(Array.prototype.slice.call(ci));
          }, _float32array: function(ci) {
            return oi("float32array:"), this.dispatch(Array.prototype.slice.call(ci));
          }, _float64array: function(ci) {
            return oi("float64array:"), this.dispatch(Array.prototype.slice.call(ci));
          }, _arraybuffer: function(ci) {
            return oi("arraybuffer:"), this.dispatch(new Uint8Array(ci));
          }, _url: function(ci) {
            return oi("url:" + ci.toString());
          }, _map: function(ci) {
            return oi("map:"), ci = Array.from(ci), this._array(ci, li.unorderedSets !== !1);
          }, _set: function(ci) {
            return oi("set:"), ci = Array.from(ci), this._array(ci, li.unorderedSets !== !1);
          }, _file: function(ci) {
            return oi("file:"), this.dispatch([ci.name, ci.size, ci.type, ci.lastModfied]);
          }, _blob: function() {
            if (li.ignoreUnknown)
              return oi("[blob]");
            throw Error(`Hashing Blob objects is currently not supported
(see https://github.com/puleos/object-hash/issues/26)
Use "options.replacer" or "options.ignoreUnknown"
`);
          }, _domwindow: function() {
            return oi("domwindow");
          }, _bigint: function(ci) {
            return oi("bigint:" + ci.toString());
          }, _process: function() {
            return oi("process");
          }, _timer: function() {
            return oi("timer");
          }, _pipe: function() {
            return oi("pipe");
          }, _tcp: function() {
            return oi("tcp");
          }, _udp: function() {
            return oi("udp");
          }, _tty: function() {
            return oi("tty");
          }, _statwatcher: function() {
            return oi("statwatcher");
          }, _securecontext: function() {
            return oi("securecontext");
          }, _connection: function() {
            return oi("connection");
          }, _zlib: function() {
            return oi("zlib");
          }, _context: function() {
            return oi("context");
          }, _nodescript: function() {
            return oi("nodescript");
          }, _httpparser: function() {
            return oi("httpparser");
          }, _dataview: function() {
            return oi("dataview");
          }, _signal: function() {
            return oi("signal");
          }, _fsevent: function() {
            return oi("fsevent");
          }, _tlswrap: function() {
            return oi("tlswrap");
          } };
        }
        function si() {
          return { buf: "", write: function(li) {
            this.buf += li;
          }, end: function(li) {
            this.buf += li;
          }, read: function() {
            return this.buf;
          } };
        }
        $e.writeToStream = function(li, xi, di) {
          return di === void 0 && (di = xi, xi = {}), Wr(xi = Vr(li, xi), di).dispatch(li);
        };
      }).call(this, ie("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, ie("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
    }, { buffer: 3, crypto: 5, lYpoI2: 11 }], 2: [function(ie, we, $e) {
      (function(Me, Ze, ne, rr, gr, or, _r, Lr, Ir) {
        (function(Ar) {
          var Rr = typeof Uint8Array < "u" ? Uint8Array : Array, Nr = "+".charCodeAt(0), Yr = "/".charCodeAt(0), Vr = "0".charCodeAt(0), Xr = "a".charCodeAt(0), Wr = "A".charCodeAt(0), si = "-".charCodeAt(0), li = "_".charCodeAt(0);
          function xi(di) {
            return di = di.charCodeAt(0), di === Nr || di === si ? 62 : di === Yr || di === li ? 63 : di < Vr ? -1 : di < Vr + 10 ? di - Vr + 26 + 26 : di < Wr + 26 ? di - Wr : di < Xr + 26 ? di - Xr + 26 : void 0;
          }
          Ar.toByteArray = function(di) {
            var oi, ci;
            if (0 < di.length % 4)
              throw new Error("Invalid string. Length must be a multiple of 4");
            var vr = di.length, vr = di.charAt(vr - 2) === "=" ? 2 : di.charAt(vr - 1) === "=" ? 1 : 0, Ae = new Rr(3 * di.length / 4 - vr), ze = 0 < vr ? di.length - 4 : di.length, Ue = 0;
            function tr(lr) {
              Ae[Ue++] = lr;
            }
            for (oi = 0; oi < ze; oi += 4, 0)
              tr((16711680 & (ci = xi(di.charAt(oi)) << 18 | xi(di.charAt(oi + 1)) << 12 | xi(di.charAt(oi + 2)) << 6 | xi(di.charAt(oi + 3)))) >> 16), tr((65280 & ci) >> 8), tr(255 & ci);
            return vr == 2 ? tr(255 & (ci = xi(di.charAt(oi)) << 2 | xi(di.charAt(oi + 1)) >> 4)) : vr == 1 && (tr((ci = xi(di.charAt(oi)) << 10 | xi(di.charAt(oi + 1)) << 4 | xi(di.charAt(oi + 2)) >> 2) >> 8 & 255), tr(255 & ci)), Ae;
          }, Ar.fromByteArray = function(di) {
            var oi, ci, vr, Ae, ze = di.length % 3, Ue = "";
            function tr(lr) {
              return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(lr);
            }
            for (oi = 0, vr = di.length - ze; oi < vr; oi += 3)
              ci = (di[oi] << 16) + (di[oi + 1] << 8) + di[oi + 2], Ue += tr((Ae = ci) >> 18 & 63) + tr(Ae >> 12 & 63) + tr(Ae >> 6 & 63) + tr(63 & Ae);
            switch (ze) {
              case 1:
                Ue = (Ue += tr((ci = di[di.length - 1]) >> 2)) + tr(ci << 4 & 63) + "==";
                break;
              case 2:
                Ue = (Ue = (Ue += tr((ci = (di[di.length - 2] << 8) + di[di.length - 1]) >> 10)) + tr(ci >> 4 & 63)) + tr(ci << 2 & 63) + "=";
            }
            return Ue;
          };
        })($e === void 0 ? this.base64js = {} : $e);
      }).call(this, ie("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, ie("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
    }, { buffer: 3, lYpoI2: 11 }], 3: [function(ie, we, $e) {
      (function(Me, Ze, Nr, rr, gr, or, _r, Lr, Ir) {
        var Ar = ie("base64-js"), Rr = ie("ieee754");
        function Nr(ei, Zr, pi) {
          if (!(this instanceof Nr))
            return new Nr(ei, Zr, pi);
          var hi, Oi, qi, yn, sn = typeof ei;
          if (Zr === "base64" && sn == "string")
            for (ei = (yn = ei).trim ? yn.trim() : yn.replace(/^\s+|\s+$/g, ""); ei.length % 4 != 0; )
              ei += "=";
          if (sn == "number")
            hi = br(ei);
          else if (sn == "string")
            hi = Nr.byteLength(ei, Zr);
          else {
            if (sn != "object")
              throw new Error("First argument needs to be a number, array or string.");
            hi = br(ei.length);
          }
          if (Nr._useTypedArrays ? Oi = Nr._augment(new Uint8Array(hi)) : ((Oi = this).length = hi, Oi._isBuffer = !0), Nr._useTypedArrays && typeof ei.byteLength == "number")
            Oi._set(ei);
          else if (nr(yn = ei) || Nr.isBuffer(yn) || yn && typeof yn == "object" && typeof yn.length == "number")
            for (qi = 0; qi < hi; qi++)
              Nr.isBuffer(ei) ? Oi[qi] = ei.readUInt8(qi) : Oi[qi] = ei[qi];
          else if (sn == "string")
            Oi.write(ei, 0, Zr);
          else if (sn == "number" && !Nr._useTypedArrays && !pi)
            for (qi = 0; qi < hi; qi++)
              Oi[qi] = 0;
          return Oi;
        }
        function Yr(ei, Zr, pi, hi) {
          return Nr._charsWritten = Hr(function(Oi) {
            for (var qi = [], yn = 0; yn < Oi.length; yn++)
              qi.push(255 & Oi.charCodeAt(yn));
            return qi;
          }(Zr), ei, pi, hi);
        }
        function Vr(ei, Zr, pi, hi) {
          return Nr._charsWritten = Hr(function(Oi) {
            for (var qi, yn, sn = [], $n = 0; $n < Oi.length; $n++)
              yn = Oi.charCodeAt($n), qi = yn >> 8, yn = yn % 256, sn.push(yn), sn.push(qi);
            return sn;
          }(Zr), ei, pi, hi);
        }
        function Xr(ei, Zr, pi) {
          var hi = "";
          pi = Math.min(ei.length, pi);
          for (var Oi = Zr; Oi < pi; Oi++)
            hi += String.fromCharCode(ei[Oi]);
          return hi;
        }
        function Wr(ei, Zr, pi, qi) {
          qi || (mi(typeof pi == "boolean", "missing or invalid endian"), mi(Zr != null, "missing offset"), mi(Zr + 1 < ei.length, "Trying to read beyond buffer length"));
          var Oi, qi = ei.length;
          if (!(qi <= Zr))
            return pi ? (Oi = ei[Zr], Zr + 1 < qi && (Oi |= ei[Zr + 1] << 8)) : (Oi = ei[Zr] << 8, Zr + 1 < qi && (Oi |= ei[Zr + 1])), Oi;
        }
        function si(ei, Zr, pi, qi) {
          qi || (mi(typeof pi == "boolean", "missing or invalid endian"), mi(Zr != null, "missing offset"), mi(Zr + 3 < ei.length, "Trying to read beyond buffer length"));
          var Oi, qi = ei.length;
          if (!(qi <= Zr))
            return pi ? (Zr + 2 < qi && (Oi = ei[Zr + 2] << 16), Zr + 1 < qi && (Oi |= ei[Zr + 1] << 8), Oi |= ei[Zr], Zr + 3 < qi && (Oi += ei[Zr + 3] << 24 >>> 0)) : (Zr + 1 < qi && (Oi = ei[Zr + 1] << 16), Zr + 2 < qi && (Oi |= ei[Zr + 2] << 8), Zr + 3 < qi && (Oi |= ei[Zr + 3]), Oi += ei[Zr] << 24 >>> 0), Oi;
        }
        function li(ei, Zr, pi, hi) {
          if (hi || (mi(typeof pi == "boolean", "missing or invalid endian"), mi(Zr != null, "missing offset"), mi(Zr + 1 < ei.length, "Trying to read beyond buffer length")), !(ei.length <= Zr))
            return hi = Wr(ei, Zr, pi, !0), 32768 & hi ? -1 * (65535 - hi + 1) : hi;
        }
        function xi(ei, Zr, pi, hi) {
          if (hi || (mi(typeof pi == "boolean", "missing or invalid endian"), mi(Zr != null, "missing offset"), mi(Zr + 3 < ei.length, "Trying to read beyond buffer length")), !(ei.length <= Zr))
            return hi = si(ei, Zr, pi, !0), 2147483648 & hi ? -1 * (4294967295 - hi + 1) : hi;
        }
        function di(ei, Zr, pi, hi) {
          return hi || (mi(typeof pi == "boolean", "missing or invalid endian"), mi(Zr + 3 < ei.length, "Trying to read beyond buffer length")), Rr.read(ei, Zr, pi, 23, 4);
        }
        function oi(ei, Zr, pi, hi) {
          return hi || (mi(typeof pi == "boolean", "missing or invalid endian"), mi(Zr + 7 < ei.length, "Trying to read beyond buffer length")), Rr.read(ei, Zr, pi, 52, 8);
        }
        function ci(ei, Zr, pi, hi, Oi) {
          if (Oi || (mi(Zr != null, "missing value"), mi(typeof hi == "boolean", "missing or invalid endian"), mi(pi != null, "missing offset"), mi(pi + 1 < ei.length, "trying to write beyond buffer length"), Ti(Zr, 65535)), Oi = ei.length, !(Oi <= pi))
            for (var qi = 0, yn = Math.min(Oi - pi, 2); qi < yn; qi++)
              ei[pi + qi] = (Zr & 255 << 8 * (hi ? qi : 1 - qi)) >>> 8 * (hi ? qi : 1 - qi);
        }
        function vr(ei, Zr, pi, hi, Oi) {
          if (Oi || (mi(Zr != null, "missing value"), mi(typeof hi == "boolean", "missing or invalid endian"), mi(pi != null, "missing offset"), mi(pi + 3 < ei.length, "trying to write beyond buffer length"), Ti(Zr, 4294967295)), Oi = ei.length, !(Oi <= pi))
            for (var qi = 0, yn = Math.min(Oi - pi, 4); qi < yn; qi++)
              ei[pi + qi] = Zr >>> 8 * (hi ? qi : 3 - qi) & 255;
        }
        function Ae(ei, Zr, pi, hi, Oi) {
          Oi || (mi(Zr != null, "missing value"), mi(typeof hi == "boolean", "missing or invalid endian"), mi(pi != null, "missing offset"), mi(pi + 1 < ei.length, "Trying to write beyond buffer length"), wi(Zr, 32767, -32768)), ei.length <= pi || ci(ei, 0 <= Zr ? Zr : 65535 + Zr + 1, pi, hi, Oi);
        }
        function ze(ei, Zr, pi, hi, Oi) {
          Oi || (mi(Zr != null, "missing value"), mi(typeof hi == "boolean", "missing or invalid endian"), mi(pi != null, "missing offset"), mi(pi + 3 < ei.length, "Trying to write beyond buffer length"), wi(Zr, 2147483647, -2147483648)), ei.length <= pi || vr(ei, 0 <= Zr ? Zr : 4294967295 + Zr + 1, pi, hi, Oi);
        }
        function Ue(ei, Zr, pi, hi, Oi) {
          Oi || (mi(Zr != null, "missing value"), mi(typeof hi == "boolean", "missing or invalid endian"), mi(pi != null, "missing offset"), mi(pi + 3 < ei.length, "Trying to write beyond buffer length"), ii(Zr, 34028234663852886e22, -34028234663852886e22)), ei.length <= pi || Rr.write(ei, Zr, pi, hi, 23, 4);
        }
        function tr(ei, Zr, pi, hi, Oi) {
          Oi || (mi(Zr != null, "missing value"), mi(typeof hi == "boolean", "missing or invalid endian"), mi(pi != null, "missing offset"), mi(pi + 7 < ei.length, "Trying to write beyond buffer length"), ii(Zr, 17976931348623157e292, -17976931348623157e292)), ei.length <= pi || Rr.write(ei, Zr, pi, hi, 52, 8);
        }
        $e.Buffer = Nr, $e.SlowBuffer = Nr, $e.INSPECT_MAX_BYTES = 50, Nr.poolSize = 8192, Nr._useTypedArrays = function() {
          try {
            var ei = new ArrayBuffer(0), Zr = new Uint8Array(ei);
            return Zr.foo = function() {
              return 42;
            }, Zr.foo() === 42 && typeof Zr.subarray == "function";
          } catch {
            return !1;
          }
        }(), Nr.isEncoding = function(ei) {
          switch (String(ei).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "raw":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;
            default:
              return !1;
          }
        }, Nr.isBuffer = function(ei) {
          return !(ei == null || !ei._isBuffer);
        }, Nr.byteLength = function(ei, Zr) {
          var pi;
          switch (ei += "", Zr || "utf8") {
            case "hex":
              pi = ei.length / 2;
              break;
            case "utf8":
            case "utf-8":
              pi = ur(ei).length;
              break;
            case "ascii":
            case "binary":
            case "raw":
              pi = ei.length;
              break;
            case "base64":
              pi = Pr(ei).length;
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              pi = 2 * ei.length;
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return pi;
        }, Nr.concat = function(ei, Zr) {
          if (mi(nr(ei), `Usage: Buffer.concat(list, [totalLength])
list should be an Array.`), ei.length === 0)
            return new Nr(0);
          if (ei.length === 1)
            return ei[0];
          if (typeof Zr != "number")
            for (Oi = Zr = 0; Oi < ei.length; Oi++)
              Zr += ei[Oi].length;
          for (var pi = new Nr(Zr), hi = 0, Oi = 0; Oi < ei.length; Oi++) {
            var qi = ei[Oi];
            qi.copy(pi, hi), hi += qi.length;
          }
          return pi;
        }, Nr.prototype.write = function(ei, Zr, pi, hi) {
          isFinite(Zr) ? isFinite(pi) || (hi = pi, pi = void 0) : ($n = hi, hi = Zr, Zr = pi, pi = $n), Zr = Number(Zr) || 0;
          var Oi, qi, yn, sn, $n = this.length - Zr;
          switch ((!pi || $n < (pi = Number(pi))) && (pi = $n), hi = String(hi || "utf8").toLowerCase()) {
            case "hex":
              Oi = function(rn, ji, Kn, In) {
                Kn = Number(Kn) || 0;
                var Fn = rn.length - Kn;
                (!In || Fn < (In = Number(In))) && (In = Fn), mi((Fn = ji.length) % 2 == 0, "Invalid hex string"), Fn / 2 < In && (In = Fn / 2);
                for (var Po = 0; Po < In; Po++) {
                  var vn = parseInt(ji.substr(2 * Po, 2), 16);
                  mi(!isNaN(vn), "Invalid hex string"), rn[Kn + Po] = vn;
                }
                return Nr._charsWritten = 2 * Po, Po;
              }(this, ei, Zr, pi);
              break;
            case "utf8":
            case "utf-8":
              qi = this, yn = Zr, sn = pi, Oi = Nr._charsWritten = Hr(ur(ei), qi, yn, sn);
              break;
            case "ascii":
            case "binary":
              Oi = Yr(this, ei, Zr, pi);
              break;
            case "base64":
              qi = this, yn = Zr, sn = pi, Oi = Nr._charsWritten = Hr(Pr(ei), qi, yn, sn);
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              Oi = Vr(this, ei, Zr, pi);
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return Oi;
        }, Nr.prototype.toString = function(ei, Zr, pi) {
          var hi, Oi, qi, yn, sn = this;
          if (ei = String(ei || "utf8").toLowerCase(), Zr = Number(Zr) || 0, (pi = pi !== void 0 ? Number(pi) : sn.length) === Zr)
            return "";
          switch (ei) {
            case "hex":
              hi = function($n, rn, ji) {
                var Kn = $n.length;
                (!rn || rn < 0) && (rn = 0), (!ji || ji < 0 || Kn < ji) && (ji = Kn);
                for (var In = "", Fn = rn; Fn < ji; Fn++)
                  In += Pe($n[Fn]);
                return In;
              }(sn, Zr, pi);
              break;
            case "utf8":
            case "utf-8":
              hi = function($n, rn, ji) {
                var Kn = "", In = "";
                ji = Math.min($n.length, ji);
                for (var Fn = rn; Fn < ji; Fn++)
                  $n[Fn] <= 127 ? (Kn += vi(In) + String.fromCharCode($n[Fn]), In = "") : In += "%" + $n[Fn].toString(16);
                return Kn + vi(In);
              }(sn, Zr, pi);
              break;
            case "ascii":
            case "binary":
              hi = Xr(sn, Zr, pi);
              break;
            case "base64":
              Oi = sn, yn = pi, hi = (qi = Zr) === 0 && yn === Oi.length ? Ar.fromByteArray(Oi) : Ar.fromByteArray(Oi.slice(qi, yn));
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              hi = function($n, rn, ji) {
                for (var Kn = $n.slice(rn, ji), In = "", Fn = 0; Fn < Kn.length; Fn += 2)
                  In += String.fromCharCode(Kn[Fn] + 256 * Kn[Fn + 1]);
                return In;
              }(sn, Zr, pi);
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return hi;
        }, Nr.prototype.toJSON = function() {
          return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
        }, Nr.prototype.copy = function(ei, Zr, pi, hi) {
          if (Zr = Zr || 0, (hi = hi || hi === 0 ? hi : this.length) !== (pi = pi || 0) && ei.length !== 0 && this.length !== 0) {
            mi(pi <= hi, "sourceEnd < sourceStart"), mi(0 <= Zr && Zr < ei.length, "targetStart out of bounds"), mi(0 <= pi && pi < this.length, "sourceStart out of bounds"), mi(0 <= hi && hi <= this.length, "sourceEnd out of bounds"), hi > this.length && (hi = this.length);
            var Oi = (hi = ei.length - Zr < hi - pi ? ei.length - Zr + pi : hi) - pi;
            if (Oi < 100 || !Nr._useTypedArrays)
              for (var qi = 0; qi < Oi; qi++)
                ei[qi + Zr] = this[qi + pi];
            else
              ei._set(this.subarray(pi, pi + Oi), Zr);
          }
        }, Nr.prototype.slice = function(ei, Zr) {
          var pi = this.length;
          if (ei = pr(ei, pi, 0), Zr = pr(Zr, pi, pi), Nr._useTypedArrays)
            return Nr._augment(this.subarray(ei, Zr));
          for (var hi = Zr - ei, Oi = new Nr(hi, void 0, !0), qi = 0; qi < hi; qi++)
            Oi[qi] = this[qi + ei];
          return Oi;
        }, Nr.prototype.get = function(ei) {
          return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(ei);
        }, Nr.prototype.set = function(ei, Zr) {
          return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(ei, Zr);
        }, Nr.prototype.readUInt8 = function(ei, Zr) {
          if (Zr || (mi(ei != null, "missing offset"), mi(ei < this.length, "Trying to read beyond buffer length")), !(ei >= this.length))
            return this[ei];
        }, Nr.prototype.readUInt16LE = function(ei, Zr) {
          return Wr(this, ei, !0, Zr);
        }, Nr.prototype.readUInt16BE = function(ei, Zr) {
          return Wr(this, ei, !1, Zr);
        }, Nr.prototype.readUInt32LE = function(ei, Zr) {
          return si(this, ei, !0, Zr);
        }, Nr.prototype.readUInt32BE = function(ei, Zr) {
          return si(this, ei, !1, Zr);
        }, Nr.prototype.readInt8 = function(ei, Zr) {
          if (Zr || (mi(ei != null, "missing offset"), mi(ei < this.length, "Trying to read beyond buffer length")), !(ei >= this.length))
            return 128 & this[ei] ? -1 * (255 - this[ei] + 1) : this[ei];
        }, Nr.prototype.readInt16LE = function(ei, Zr) {
          return li(this, ei, !0, Zr);
        }, Nr.prototype.readInt16BE = function(ei, Zr) {
          return li(this, ei, !1, Zr);
        }, Nr.prototype.readInt32LE = function(ei, Zr) {
          return xi(this, ei, !0, Zr);
        }, Nr.prototype.readInt32BE = function(ei, Zr) {
          return xi(this, ei, !1, Zr);
        }, Nr.prototype.readFloatLE = function(ei, Zr) {
          return di(this, ei, !0, Zr);
        }, Nr.prototype.readFloatBE = function(ei, Zr) {
          return di(this, ei, !1, Zr);
        }, Nr.prototype.readDoubleLE = function(ei, Zr) {
          return oi(this, ei, !0, Zr);
        }, Nr.prototype.readDoubleBE = function(ei, Zr) {
          return oi(this, ei, !1, Zr);
        }, Nr.prototype.writeUInt8 = function(ei, Zr, pi) {
          pi || (mi(ei != null, "missing value"), mi(Zr != null, "missing offset"), mi(Zr < this.length, "trying to write beyond buffer length"), Ti(ei, 255)), Zr >= this.length || (this[Zr] = ei);
        }, Nr.prototype.writeUInt16LE = function(ei, Zr, pi) {
          ci(this, ei, Zr, !0, pi);
        }, Nr.prototype.writeUInt16BE = function(ei, Zr, pi) {
          ci(this, ei, Zr, !1, pi);
        }, Nr.prototype.writeUInt32LE = function(ei, Zr, pi) {
          vr(this, ei, Zr, !0, pi);
        }, Nr.prototype.writeUInt32BE = function(ei, Zr, pi) {
          vr(this, ei, Zr, !1, pi);
        }, Nr.prototype.writeInt8 = function(ei, Zr, pi) {
          pi || (mi(ei != null, "missing value"), mi(Zr != null, "missing offset"), mi(Zr < this.length, "Trying to write beyond buffer length"), wi(ei, 127, -128)), Zr >= this.length || (0 <= ei ? this.writeUInt8(ei, Zr, pi) : this.writeUInt8(255 + ei + 1, Zr, pi));
        }, Nr.prototype.writeInt16LE = function(ei, Zr, pi) {
          Ae(this, ei, Zr, !0, pi);
        }, Nr.prototype.writeInt16BE = function(ei, Zr, pi) {
          Ae(this, ei, Zr, !1, pi);
        }, Nr.prototype.writeInt32LE = function(ei, Zr, pi) {
          ze(this, ei, Zr, !0, pi);
        }, Nr.prototype.writeInt32BE = function(ei, Zr, pi) {
          ze(this, ei, Zr, !1, pi);
        }, Nr.prototype.writeFloatLE = function(ei, Zr, pi) {
          Ue(this, ei, Zr, !0, pi);
        }, Nr.prototype.writeFloatBE = function(ei, Zr, pi) {
          Ue(this, ei, Zr, !1, pi);
        }, Nr.prototype.writeDoubleLE = function(ei, Zr, pi) {
          tr(this, ei, Zr, !0, pi);
        }, Nr.prototype.writeDoubleBE = function(ei, Zr, pi) {
          tr(this, ei, Zr, !1, pi);
        }, Nr.prototype.fill = function(ei, Zr, pi) {
          if (Zr = Zr || 0, pi = pi || this.length, mi(typeof (ei = typeof (ei = ei || 0) == "string" ? ei.charCodeAt(0) : ei) == "number" && !isNaN(ei), "value is not a number"), mi(Zr <= pi, "end < start"), pi !== Zr && this.length !== 0) {
            mi(0 <= Zr && Zr < this.length, "start out of bounds"), mi(0 <= pi && pi <= this.length, "end out of bounds");
            for (var hi = Zr; hi < pi; hi++)
              this[hi] = ei;
          }
        }, Nr.prototype.inspect = function() {
          for (var ei = [], Zr = this.length, pi = 0; pi < Zr; pi++)
            if (ei[pi] = Pe(this[pi]), pi === $e.INSPECT_MAX_BYTES) {
              ei[pi + 1] = "...";
              break;
            }
          return "<Buffer " + ei.join(" ") + ">";
        }, Nr.prototype.toArrayBuffer = function() {
          if (typeof Uint8Array > "u")
            throw new Error("Buffer.toArrayBuffer not supported in this browser");
          if (Nr._useTypedArrays)
            return new Nr(this).buffer;
          for (var ei = new Uint8Array(this.length), Zr = 0, pi = ei.length; Zr < pi; Zr += 1)
            ei[Zr] = this[Zr];
          return ei.buffer;
        };
        var lr = Nr.prototype;
        function pr(ei, Zr, pi) {
          return typeof ei != "number" ? pi : Zr <= (ei = ~~ei) ? Zr : 0 <= ei || 0 <= (ei += Zr) ? ei : 0;
        }
        function br(ei) {
          return (ei = ~~Math.ceil(+ei)) < 0 ? 0 : ei;
        }
        function nr(ei) {
          return (Array.isArray || function(Zr) {
            return Object.prototype.toString.call(Zr) === "[object Array]";
          })(ei);
        }
        function Pe(ei) {
          return ei < 16 ? "0" + ei.toString(16) : ei.toString(16);
        }
        function ur(ei) {
          for (var Zr = [], pi = 0; pi < ei.length; pi++) {
            var hi = ei.charCodeAt(pi);
            if (hi <= 127)
              Zr.push(ei.charCodeAt(pi));
            else
              for (var Oi = pi, qi = (55296 <= hi && hi <= 57343 && pi++, encodeURIComponent(ei.slice(Oi, pi + 1)).substr(1).split("%")), yn = 0; yn < qi.length; yn++)
                Zr.push(parseInt(qi[yn], 16));
          }
          return Zr;
        }
        function Pr(ei) {
          return Ar.toByteArray(ei);
        }
        function Hr(ei, Zr, pi, hi) {
          for (var Oi = 0; Oi < hi && !(Oi + pi >= Zr.length || Oi >= ei.length); Oi++)
            Zr[Oi + pi] = ei[Oi];
          return Oi;
        }
        function vi(ei) {
          try {
            return decodeURIComponent(ei);
          } catch {
            return String.fromCharCode(65533);
          }
        }
        function Ti(ei, Zr) {
          mi(typeof ei == "number", "cannot write a non-number as a number"), mi(0 <= ei, "specified a negative value for writing an unsigned value"), mi(ei <= Zr, "value is larger than maximum value for type"), mi(Math.floor(ei) === ei, "value has a fractional component");
        }
        function wi(ei, Zr, pi) {
          mi(typeof ei == "number", "cannot write a non-number as a number"), mi(ei <= Zr, "value larger than maximum allowed value"), mi(pi <= ei, "value smaller than minimum allowed value"), mi(Math.floor(ei) === ei, "value has a fractional component");
        }
        function ii(ei, Zr, pi) {
          mi(typeof ei == "number", "cannot write a non-number as a number"), mi(ei <= Zr, "value larger than maximum allowed value"), mi(pi <= ei, "value smaller than minimum allowed value");
        }
        function mi(ei, Zr) {
          if (!ei)
            throw new Error(Zr || "Failed assertion");
        }
        Nr._augment = function(ei) {
          return ei._isBuffer = !0, ei._get = ei.get, ei._set = ei.set, ei.get = lr.get, ei.set = lr.set, ei.write = lr.write, ei.toString = lr.toString, ei.toLocaleString = lr.toString, ei.toJSON = lr.toJSON, ei.copy = lr.copy, ei.slice = lr.slice, ei.readUInt8 = lr.readUInt8, ei.readUInt16LE = lr.readUInt16LE, ei.readUInt16BE = lr.readUInt16BE, ei.readUInt32LE = lr.readUInt32LE, ei.readUInt32BE = lr.readUInt32BE, ei.readInt8 = lr.readInt8, ei.readInt16LE = lr.readInt16LE, ei.readInt16BE = lr.readInt16BE, ei.readInt32LE = lr.readInt32LE, ei.readInt32BE = lr.readInt32BE, ei.readFloatLE = lr.readFloatLE, ei.readFloatBE = lr.readFloatBE, ei.readDoubleLE = lr.readDoubleLE, ei.readDoubleBE = lr.readDoubleBE, ei.writeUInt8 = lr.writeUInt8, ei.writeUInt16LE = lr.writeUInt16LE, ei.writeUInt16BE = lr.writeUInt16BE, ei.writeUInt32LE = lr.writeUInt32LE, ei.writeUInt32BE = lr.writeUInt32BE, ei.writeInt8 = lr.writeInt8, ei.writeInt16LE = lr.writeInt16LE, ei.writeInt16BE = lr.writeInt16BE, ei.writeInt32LE = lr.writeInt32LE, ei.writeInt32BE = lr.writeInt32BE, ei.writeFloatLE = lr.writeFloatLE, ei.writeFloatBE = lr.writeFloatBE, ei.writeDoubleLE = lr.writeDoubleLE, ei.writeDoubleBE = lr.writeDoubleBE, ei.fill = lr.fill, ei.inspect = lr.inspect, ei.toArrayBuffer = lr.toArrayBuffer, ei;
        };
      }).call(this, ie("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, ie("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
    }, { "base64-js": 2, buffer: 3, ieee754: 10, lYpoI2: 11 }], 4: [function(ie, we, $e) {
      (function(Me, Ze, Ar, rr, gr, or, _r, Lr, Ir) {
        var Ar = ie("buffer").Buffer, Rr = 4, Nr = new Ar(Rr);
        Nr.fill(0), we.exports = { hash: function(Yr, Vr, Xr, Wr) {
          for (var si = Vr(function(ci, vr) {
            ci.length % Rr != 0 && (Ae = ci.length + (Rr - ci.length % Rr), ci = Ar.concat([ci, Nr], Ae));
            for (var Ae, ze = [], Ue = vr ? ci.readInt32BE : ci.readInt32LE, tr = 0; tr < ci.length; tr += Rr)
              ze.push(Ue.call(ci, tr));
            return ze;
          }(Yr = Ar.isBuffer(Yr) ? Yr : new Ar(Yr), Wr), 8 * Yr.length), Vr = Wr, li = new Ar(Xr), xi = Vr ? li.writeInt32BE : li.writeInt32LE, di = 0; di < si.length; di++)
            xi.call(li, si[di], 4 * di, !0);
          return li;
        } };
      }).call(this, ie("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, ie("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { buffer: 3, lYpoI2: 11 }], 5: [function(ie, we, $e) {
      (function(Me, Ze, Ar, rr, gr, or, _r, Lr, Ir) {
        var Ar = ie("buffer").Buffer, Rr = ie("./sha"), Nr = ie("./sha256"), Yr = ie("./rng"), Vr = { sha1: Rr, sha256: Nr, md5: ie("./md5") }, Xr = 64, Wr = new Ar(Xr);
        function si(ci, vr) {
          var Ae = Vr[ci = ci || "sha1"], ze = [];
          return Ae || li("algorithm:", ci, "is not yet supported"), { update: function(Ue) {
            return Ar.isBuffer(Ue) || (Ue = new Ar(Ue)), ze.push(Ue), Ue.length, this;
          }, digest: function(Ue) {
            var tr = Ar.concat(ze), tr = vr ? function(lr, pr, br) {
              Ar.isBuffer(pr) || (pr = new Ar(pr)), Ar.isBuffer(br) || (br = new Ar(br)), pr.length > Xr ? pr = lr(pr) : pr.length < Xr && (pr = Ar.concat([pr, Wr], Xr));
              for (var nr = new Ar(Xr), Pe = new Ar(Xr), ur = 0; ur < Xr; ur++)
                nr[ur] = 54 ^ pr[ur], Pe[ur] = 92 ^ pr[ur];
              return br = lr(Ar.concat([nr, br])), lr(Ar.concat([Pe, br]));
            }(Ae, vr, tr) : Ae(tr);
            return ze = null, Ue ? tr.toString(Ue) : tr;
          } };
        }
        function li() {
          var ci = [].slice.call(arguments).join(" ");
          throw new Error([ci, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join(`
`));
        }
        Wr.fill(0), $e.createHash = function(ci) {
          return si(ci);
        }, $e.createHmac = si, $e.randomBytes = function(ci, vr) {
          if (!vr || !vr.call)
            return new Ar(Yr(ci));
          try {
            vr.call(this, void 0, new Ar(Yr(ci)));
          } catch (Ae) {
            vr(Ae);
          }
        };
        var xi, di = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], oi = function(ci) {
          $e[ci] = function() {
            li("sorry,", ci, "is not implemented yet");
          };
        };
        for (xi in di)
          oi(di[xi]);
      }).call(this, ie("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, ie("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./md5": 6, "./rng": 7, "./sha": 8, "./sha256": 9, buffer: 3, lYpoI2: 11 }], 6: [function(ie, we, $e) {
      (function(Me, Ze, ne, rr, gr, or, _r, Lr, Ir) {
        var Ar = ie("./helpers");
        function Rr(li, xi) {
          li[xi >> 5] |= 128 << xi % 32, li[14 + (xi + 64 >>> 9 << 4)] = xi;
          for (var di = 1732584193, oi = -271733879, ci = -1732584194, vr = 271733878, Ae = 0; Ae < li.length; Ae += 16) {
            var ze = di, Ue = oi, tr = ci, lr = vr, di = Yr(di, oi, ci, vr, li[Ae + 0], 7, -680876936), vr = Yr(vr, di, oi, ci, li[Ae + 1], 12, -389564586), ci = Yr(ci, vr, di, oi, li[Ae + 2], 17, 606105819), oi = Yr(oi, ci, vr, di, li[Ae + 3], 22, -1044525330);
            di = Yr(di, oi, ci, vr, li[Ae + 4], 7, -176418897), vr = Yr(vr, di, oi, ci, li[Ae + 5], 12, 1200080426), ci = Yr(ci, vr, di, oi, li[Ae + 6], 17, -1473231341), oi = Yr(oi, ci, vr, di, li[Ae + 7], 22, -45705983), di = Yr(di, oi, ci, vr, li[Ae + 8], 7, 1770035416), vr = Yr(vr, di, oi, ci, li[Ae + 9], 12, -1958414417), ci = Yr(ci, vr, di, oi, li[Ae + 10], 17, -42063), oi = Yr(oi, ci, vr, di, li[Ae + 11], 22, -1990404162), di = Yr(di, oi, ci, vr, li[Ae + 12], 7, 1804603682), vr = Yr(vr, di, oi, ci, li[Ae + 13], 12, -40341101), ci = Yr(ci, vr, di, oi, li[Ae + 14], 17, -1502002290), di = Vr(di, oi = Yr(oi, ci, vr, di, li[Ae + 15], 22, 1236535329), ci, vr, li[Ae + 1], 5, -165796510), vr = Vr(vr, di, oi, ci, li[Ae + 6], 9, -1069501632), ci = Vr(ci, vr, di, oi, li[Ae + 11], 14, 643717713), oi = Vr(oi, ci, vr, di, li[Ae + 0], 20, -373897302), di = Vr(di, oi, ci, vr, li[Ae + 5], 5, -701558691), vr = Vr(vr, di, oi, ci, li[Ae + 10], 9, 38016083), ci = Vr(ci, vr, di, oi, li[Ae + 15], 14, -660478335), oi = Vr(oi, ci, vr, di, li[Ae + 4], 20, -405537848), di = Vr(di, oi, ci, vr, li[Ae + 9], 5, 568446438), vr = Vr(vr, di, oi, ci, li[Ae + 14], 9, -1019803690), ci = Vr(ci, vr, di, oi, li[Ae + 3], 14, -187363961), oi = Vr(oi, ci, vr, di, li[Ae + 8], 20, 1163531501), di = Vr(di, oi, ci, vr, li[Ae + 13], 5, -1444681467), vr = Vr(vr, di, oi, ci, li[Ae + 2], 9, -51403784), ci = Vr(ci, vr, di, oi, li[Ae + 7], 14, 1735328473), di = Xr(di, oi = Vr(oi, ci, vr, di, li[Ae + 12], 20, -1926607734), ci, vr, li[Ae + 5], 4, -378558), vr = Xr(vr, di, oi, ci, li[Ae + 8], 11, -2022574463), ci = Xr(ci, vr, di, oi, li[Ae + 11], 16, 1839030562), oi = Xr(oi, ci, vr, di, li[Ae + 14], 23, -35309556), di = Xr(di, oi, ci, vr, li[Ae + 1], 4, -1530992060), vr = Xr(vr, di, oi, ci, li[Ae + 4], 11, 1272893353), ci = Xr(ci, vr, di, oi, li[Ae + 7], 16, -155497632), oi = Xr(oi, ci, vr, di, li[Ae + 10], 23, -1094730640), di = Xr(di, oi, ci, vr, li[Ae + 13], 4, 681279174), vr = Xr(vr, di, oi, ci, li[Ae + 0], 11, -358537222), ci = Xr(ci, vr, di, oi, li[Ae + 3], 16, -722521979), oi = Xr(oi, ci, vr, di, li[Ae + 6], 23, 76029189), di = Xr(di, oi, ci, vr, li[Ae + 9], 4, -640364487), vr = Xr(vr, di, oi, ci, li[Ae + 12], 11, -421815835), ci = Xr(ci, vr, di, oi, li[Ae + 15], 16, 530742520), di = Wr(di, oi = Xr(oi, ci, vr, di, li[Ae + 2], 23, -995338651), ci, vr, li[Ae + 0], 6, -198630844), vr = Wr(vr, di, oi, ci, li[Ae + 7], 10, 1126891415), ci = Wr(ci, vr, di, oi, li[Ae + 14], 15, -1416354905), oi = Wr(oi, ci, vr, di, li[Ae + 5], 21, -57434055), di = Wr(di, oi, ci, vr, li[Ae + 12], 6, 1700485571), vr = Wr(vr, di, oi, ci, li[Ae + 3], 10, -1894986606), ci = Wr(ci, vr, di, oi, li[Ae + 10], 15, -1051523), oi = Wr(oi, ci, vr, di, li[Ae + 1], 21, -2054922799), di = Wr(di, oi, ci, vr, li[Ae + 8], 6, 1873313359), vr = Wr(vr, di, oi, ci, li[Ae + 15], 10, -30611744), ci = Wr(ci, vr, di, oi, li[Ae + 6], 15, -1560198380), oi = Wr(oi, ci, vr, di, li[Ae + 13], 21, 1309151649), di = Wr(di, oi, ci, vr, li[Ae + 4], 6, -145523070), vr = Wr(vr, di, oi, ci, li[Ae + 11], 10, -1120210379), ci = Wr(ci, vr, di, oi, li[Ae + 2], 15, 718787259), oi = Wr(oi, ci, vr, di, li[Ae + 9], 21, -343485551), di = si(di, ze), oi = si(oi, Ue), ci = si(ci, tr), vr = si(vr, lr);
          }
          return Array(di, oi, ci, vr);
        }
        function Nr(li, xi, di, oi, ci, vr) {
          return si((xi = si(si(xi, li), si(oi, vr))) << ci | xi >>> 32 - ci, di);
        }
        function Yr(li, xi, di, oi, ci, vr, Ae) {
          return Nr(xi & di | ~xi & oi, li, xi, ci, vr, Ae);
        }
        function Vr(li, xi, di, oi, ci, vr, Ae) {
          return Nr(xi & oi | di & ~oi, li, xi, ci, vr, Ae);
        }
        function Xr(li, xi, di, oi, ci, vr, Ae) {
          return Nr(xi ^ di ^ oi, li, xi, ci, vr, Ae);
        }
        function Wr(li, xi, di, oi, ci, vr, Ae) {
          return Nr(di ^ (xi | ~oi), li, xi, ci, vr, Ae);
        }
        function si(li, xi) {
          var di = (65535 & li) + (65535 & xi);
          return (li >> 16) + (xi >> 16) + (di >> 16) << 16 | 65535 & di;
        }
        we.exports = function(li) {
          return Ar.hash(li, Rr, 16);
        };
      }).call(this, ie("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, ie("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 7: [function(ie, we, $e) {
      (function(Me, Ze, ne, rr, gr, or, _r, Lr, Ir) {
        we.exports = function(Ar) {
          for (var Rr, Nr = new Array(Ar), Yr = 0; Yr < Ar; Yr++)
            (3 & Yr) == 0 && (Rr = 4294967296 * Math.random()), Nr[Yr] = Rr >>> ((3 & Yr) << 3) & 255;
          return Nr;
        };
      }).call(this, ie("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, ie("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { buffer: 3, lYpoI2: 11 }], 8: [function(ie, we, $e) {
      (function(Me, Ze, ne, rr, gr, or, _r, Lr, Ir) {
        var Ar = ie("./helpers");
        function Rr(Vr, Xr) {
          Vr[Xr >> 5] |= 128 << 24 - Xr % 32, Vr[15 + (Xr + 64 >> 9 << 4)] = Xr;
          for (var Wr, si, li, xi = Array(80), di = 1732584193, oi = -271733879, ci = -1732584194, vr = 271733878, Ae = -1009589776, ze = 0; ze < Vr.length; ze += 16) {
            for (var Ue = di, tr = oi, lr = ci, pr = vr, br = Ae, nr = 0; nr < 80; nr++) {
              xi[nr] = nr < 16 ? Vr[ze + nr] : Yr(xi[nr - 3] ^ xi[nr - 8] ^ xi[nr - 14] ^ xi[nr - 16], 1);
              var Pe = Nr(Nr(Yr(di, 5), (Pe = oi, si = ci, li = vr, (Wr = nr) < 20 ? Pe & si | ~Pe & li : !(Wr < 40) && Wr < 60 ? Pe & si | Pe & li | si & li : Pe ^ si ^ li)), Nr(Nr(Ae, xi[nr]), (Wr = nr) < 20 ? 1518500249 : Wr < 40 ? 1859775393 : Wr < 60 ? -1894007588 : -899497514)), Ae = vr, vr = ci, ci = Yr(oi, 30), oi = di, di = Pe;
            }
            di = Nr(di, Ue), oi = Nr(oi, tr), ci = Nr(ci, lr), vr = Nr(vr, pr), Ae = Nr(Ae, br);
          }
          return Array(di, oi, ci, vr, Ae);
        }
        function Nr(Vr, Xr) {
          var Wr = (65535 & Vr) + (65535 & Xr);
          return (Vr >> 16) + (Xr >> 16) + (Wr >> 16) << 16 | 65535 & Wr;
        }
        function Yr(Vr, Xr) {
          return Vr << Xr | Vr >>> 32 - Xr;
        }
        we.exports = function(Vr) {
          return Ar.hash(Vr, Rr, 20, !0);
        };
      }).call(this, ie("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, ie("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 9: [function(ie, we, $e) {
      (function(Me, Ze, ne, rr, gr, or, _r, Lr, Ir) {
        function Ar(Xr, Wr) {
          var si = (65535 & Xr) + (65535 & Wr);
          return (Xr >> 16) + (Wr >> 16) + (si >> 16) << 16 | 65535 & si;
        }
        function Rr(Xr, Wr) {
          var si, li = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), xi = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), di = new Array(64);
          Xr[Wr >> 5] |= 128 << 24 - Wr % 32, Xr[15 + (Wr + 64 >> 9 << 4)] = Wr;
          for (var oi, ci, vr = 0; vr < Xr.length; vr += 16) {
            for (var Ae = xi[0], ze = xi[1], Ue = xi[2], tr = xi[3], lr = xi[4], pr = xi[5], br = xi[6], nr = xi[7], Pe = 0; Pe < 64; Pe++)
              di[Pe] = Pe < 16 ? Xr[Pe + vr] : Ar(Ar(Ar((ci = di[Pe - 2], Yr(ci, 17) ^ Yr(ci, 19) ^ Vr(ci, 10)), di[Pe - 7]), (ci = di[Pe - 15], Yr(ci, 7) ^ Yr(ci, 18) ^ Vr(ci, 3))), di[Pe - 16]), si = Ar(Ar(Ar(Ar(nr, Yr(ci = lr, 6) ^ Yr(ci, 11) ^ Yr(ci, 25)), lr & pr ^ ~lr & br), li[Pe]), di[Pe]), oi = Ar(Yr(oi = Ae, 2) ^ Yr(oi, 13) ^ Yr(oi, 22), Ae & ze ^ Ae & Ue ^ ze & Ue), nr = br, br = pr, pr = lr, lr = Ar(tr, si), tr = Ue, Ue = ze, ze = Ae, Ae = Ar(si, oi);
            xi[0] = Ar(Ae, xi[0]), xi[1] = Ar(ze, xi[1]), xi[2] = Ar(Ue, xi[2]), xi[3] = Ar(tr, xi[3]), xi[4] = Ar(lr, xi[4]), xi[5] = Ar(pr, xi[5]), xi[6] = Ar(br, xi[6]), xi[7] = Ar(nr, xi[7]);
          }
          return xi;
        }
        var Nr = ie("./helpers"), Yr = function(Xr, Wr) {
          return Xr >>> Wr | Xr << 32 - Wr;
        }, Vr = function(Xr, Wr) {
          return Xr >>> Wr;
        };
        we.exports = function(Xr) {
          return Nr.hash(Xr, Rr, 32, !0);
        };
      }).call(this, ie("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, ie("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 10: [function(ie, we, $e) {
      (function(Me, Ze, ne, rr, gr, or, _r, Lr, Ir) {
        $e.read = function(Ar, Rr, Nr, Yr, vr) {
          var Xr, Wr, si = 8 * vr - Yr - 1, li = (1 << si) - 1, xi = li >> 1, di = -7, oi = Nr ? vr - 1 : 0, ci = Nr ? -1 : 1, vr = Ar[Rr + oi];
          for (oi += ci, Xr = vr & (1 << -di) - 1, vr >>= -di, di += si; 0 < di; Xr = 256 * Xr + Ar[Rr + oi], oi += ci, di -= 8)
            ;
          for (Wr = Xr & (1 << -di) - 1, Xr >>= -di, di += Yr; 0 < di; Wr = 256 * Wr + Ar[Rr + oi], oi += ci, di -= 8)
            ;
          if (Xr === 0)
            Xr = 1 - xi;
          else {
            if (Xr === li)
              return Wr ? NaN : 1 / 0 * (vr ? -1 : 1);
            Wr += Math.pow(2, Yr), Xr -= xi;
          }
          return (vr ? -1 : 1) * Wr * Math.pow(2, Xr - Yr);
        }, $e.write = function(Ar, Rr, Nr, Yr, Vr, Ae) {
          var Wr, si, li = 8 * Ae - Vr - 1, xi = (1 << li) - 1, di = xi >> 1, oi = Vr === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, ci = Yr ? 0 : Ae - 1, vr = Yr ? 1 : -1, Ae = Rr < 0 || Rr === 0 && 1 / Rr < 0 ? 1 : 0;
          for (Rr = Math.abs(Rr), isNaN(Rr) || Rr === 1 / 0 ? (si = isNaN(Rr) ? 1 : 0, Wr = xi) : (Wr = Math.floor(Math.log(Rr) / Math.LN2), Rr * (Yr = Math.pow(2, -Wr)) < 1 && (Wr--, Yr *= 2), 2 <= (Rr += 1 <= Wr + di ? oi / Yr : oi * Math.pow(2, 1 - di)) * Yr && (Wr++, Yr /= 2), xi <= Wr + di ? (si = 0, Wr = xi) : 1 <= Wr + di ? (si = (Rr * Yr - 1) * Math.pow(2, Vr), Wr += di) : (si = Rr * Math.pow(2, di - 1) * Math.pow(2, Vr), Wr = 0)); 8 <= Vr; Ar[Nr + ci] = 255 & si, ci += vr, si /= 256, Vr -= 8)
            ;
          for (Wr = Wr << Vr | si, li += Vr; 0 < li; Ar[Nr + ci] = 255 & Wr, ci += vr, Wr /= 256, li -= 8)
            ;
          Ar[Nr + ci - vr] |= 128 * Ae;
        };
      }).call(this, ie("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, ie("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
    }, { buffer: 3, lYpoI2: 11 }], 11: [function(ie, we, $e) {
      (function(Me, Ze, ne, rr, gr, or, _r, Lr, Ir) {
        var Ar, Rr, Nr;
        function Yr() {
        }
        (Me = we.exports = {}).nextTick = (Rr = typeof window < "u" && window.setImmediate, Nr = typeof window < "u" && window.postMessage && window.addEventListener, Rr ? function(Vr) {
          return window.setImmediate(Vr);
        } : Nr ? (Ar = [], window.addEventListener("message", function(Vr) {
          var Xr = Vr.source;
          Xr !== window && Xr !== null || Vr.data !== "process-tick" || (Vr.stopPropagation(), 0 < Ar.length && Ar.shift()());
        }, !0), function(Vr) {
          Ar.push(Vr), window.postMessage("process-tick", "*");
        }) : function(Vr) {
          setTimeout(Vr, 0);
        }), Me.title = "browser", Me.browser = !0, Me.env = {}, Me.argv = [], Me.on = Yr, Me.addListener = Yr, Me.once = Yr, Me.off = Yr, Me.removeListener = Yr, Me.removeAllListeners = Yr, Me.emit = Yr, Me.binding = function(Vr) {
          throw new Error("process.binding is not supported");
        }, Me.cwd = function() {
          return "/";
        }, Me.chdir = function(Vr) {
          throw new Error("process.chdir is not supported");
        };
      }).call(this, ie("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, ie("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
    }, { buffer: 3, lYpoI2: 11 }] }, {}, [1])(1);
  });
})(object_hash);
const hash = object_hash.exports, IMAGE_TTL_IN_SECONDS = 60 * 60 * 24 * 1;
function parseCloudflareImagesDeliveryUrl(m) {
  try {
    const c = new URL(m);
    if (c.hostname === "imagedelivery.net") {
      const [, ie, we, $e] = c.pathname.split("/") || [];
      if (ie && we && $e)
        return {
          scopeId: ie,
          imageId: we,
          variant: $e
        };
      throw new Error("Invalid Cloudflare Images URL");
    }
    throw new Error("Invalid Cloudflare Images URL");
  } catch {
    throw new Error("Invalid URL");
  }
}
async function uploadImage(m, c, ie, we, $e, Me) {
  const Ze = `${m}/api/image/session?${new URLSearchParams({
    key: hash({ field: ie.field, templateId: c }),
    ttl: String(IMAGE_TTL_IN_SECONDS)
  })}`, ne = new FormData();
  ne.append("file", we, $e);
  const rr = await fetchWithProgressV1({
    url: Ze,
    method: "POST",
    data: ne,
    onUploadProgress: Me
  });
  if (rr.type === "application/json")
    return JSON.parse(await rr.text());
  throw new Error("Invalid response from Cloudflare Images");
}
class BluepicEmbed extends EventTarget {
  constructor(c, ie, we, $e) {
    if (super(), this.embedProjectSlugOrId = we, console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!", $e?.branding, "embedProjectSlugOrId", this.embedProjectSlugOrId), !ie && !this.embedProjectSlugOrId)
      throw new Error("Either templateId or embedProjectId must be provided");
    if (typeof c == "string") {
      const Me = document.querySelector(c);
      if (!Me || !(Me instanceof HTMLElement))
        throw new Error(`Element with selector "${c}" not found or not an HTMLElement`);
      this.element = Me;
    } else if (c instanceof HTMLElement)
      this.element = c;
    else
      throw new Error("Invalid element or selector provided");
    this.init(), this.displayMode.value = $e?.displayMode ?? this.displayMode.value, this.allowPanAndZoom.value = $e?.allowPanAndZoom ?? this.allowPanAndZoom.value, this.studioResourcesBaseUrl.value = $e?.studioResourcesBaseUrl ?? this.studioResourcesBaseUrl.value, this.cloudflarePagesHostname.value = $e?.cloudflarePagesHostname ?? this.cloudflarePagesHostname.value, this.bxCoreVersion.value = $e?.bxCoreVersion ?? this.bxCoreVersion.value, this.branding.value = $e?.branding ?? this.branding.value, this.stripeEnv.value = $e?.stripeEnv ?? this.stripeEnv.value, this.data.value = $e?.initData ?? this.data.value, watch(this.ready, (Me, Ze) => {
      if (Me && !Ze) {
        const ne = new CustomEvent("ready", {
          detail: { templateId: this.templateId.value, data: unref(this.data.value) }
        });
        this.dispatchEvent(ne);
      }
    }), watch(
      this.data,
      () => {
        const Me = new CustomEvent("data", {
          detail: {
            data: unref(this.data.value)
          }
        });
        this.dispatchEvent(Me);
      },
      {
        deep: !0
      }
    );
  }
  element;
  studioResourcesBaseUrl = ref$1("https://studio-resources.c2.bluepic.io");
  cloudflarePagesHostname = ref$1("bluepic-core-sandbox.pages.dev");
  editorRef = ref$1();
  templateId = ref$1();
  data = ref$1();
  serial = ref$1();
  allowPanAndZoom = ref$1(!1);
  ready = ref$1(!1);
  displayMode = ref$1("auto");
  bxCoreVersion = ref$1("auto");
  branding = ref$1(!0);
  stripeEnv = ref$1("prod");
  bxThemeStyleVars;
  embedProject = ref$1();
  baseSerial = ref$1();
  basePreview = ref$1();
  init() {
    const c = `bluepic-app-${nanoid()}`;
    this.embedProjectSlugOrId && getProjectWithRetries("template.bluepic.io", this.embedProjectSlugOrId, 3, 2e3, this.stripeEnv.value).then(({ embedProject: $e, isAllowedToDisableBranding: Me, templates: Ze }) => {
      this.embedProject.value = $e, this.displayMode.value = $e.config.layout, this.allowPanAndZoom.value = $e.config.allowPanAndZoom, this.branding.value = Me ? $e.config.bluepicBranding : !0, Ze && (this.baseSerial.value = Ze[$e.templates[0]].serial, this.basePreview.value = Ze[$e.templates[0]].preview), console.log("BRANDING", this.branding.value), this.templateId.value = $e.templates[0];
    });
    const ie = document.createElement("style");
    ie.textContent = `
      #${c} .fade-spinner-enter-active,
      #${c} .fade-spinner-leave-active {
        transition: opacity .3s ease;
      }
      #${c} .fade-spinner-enter-from,
      #${c} .fade-spinner-leave-to {
        opacity: 0;
      }
      #${c} {
        > div {
          border: 1px solid var(--bluepic-app-border-color);
          overflow: hidden;
          border-radius: var(--bluepic-app-border-radius);
          margin: 30px auto;
          box-sizing: border-box;
          max-width: calc(100vw - 40px);
          max-height: calc(100vh - 40px);
        }
      }
    `, document.head.appendChild(ie), this.element.innerHTML = `
        <div id="${c}" class="bluepic-app-wrapper" style="position: relative;" :style="">
            <div v-if="templateId" style="display: flex; flex-direction: column;" :style="{ height: embedProject?.config.layout === 'stack' ? 'auto' : 'calc(100% - 40px)', '--bluepic-app-border-color': borderColor, '--bluepic-app-border-radius': borderRadius }">
              <bluepic-embedded-editor
                v-if="templateId"
                ref="editorRef"
                :template-id="templateId"
                :studio-resources-base-url="studioResourcesBaseUrl"
                :cloudflare-pages-hostname="cloudflarePagesHostname"
                :authorization="undefined"
                :async-serial="true"
                :bx-core-version="bxCoreVersion"
                :bridge="bridge"
                :display-mode="displayMode"
                v-model:data="data"
                v-model:serial="serial"
                :zoom-and-pan="allowPanAndZoom"
                v-model:ready="ready"
                :branding="branding"
                embedV2Server="https://embed-api-v2.bluepic.workers.dev"
                :embed-project-id="embedProject?.id"
                :base-serial="baseSerial"
                :preview="basePreview"
              />
            </div>
            <transition name="fade-spinner">
              <div v-if="!ready" style="display: flex; justify-content: center; align-items: center; height: 100%; width: 100%; position: absolute; left: 0; top: 0;">
                <bluepic-spinner />
              </div>
            </transition>

        </div>
    `;
    const we = this;
    nextTick$3(() => {
      createApp({
        components: {
          BluepicEmbeddedEditor,
          BluepicSpinner
        },
        setup() {
          const $e = {
            async handleUpload({ blob: Me, context: Ze, width: ne, height: rr, name: gr, onProgress: or }) {
              const { variants: _r, filename: Lr, id: Ir } = await uploadImage(
                "https://embed-api-v2.bluepic.workers.dev",
                we.templateId.value,
                Ze,
                Me,
                gr,
                (Rr, Nr) => {
                  or(Rr / Nr);
                }
              ), Ar = _r.find((Rr) => parseCloudflareImagesDeliveryUrl(Rr).variant === "public");
              if (!Ar)
                throw new Error("No public variant");
              return {
                width: ne,
                height: rr,
                key: Ir,
                name: Lr,
                src: Ar
              };
            }
          };
          return watch(we.embedProject, (Me) => {
            if (Me?.config.customStyle)
              we.bxThemeStyleVars = useTheme(`#${c}`), we.bxThemeStyleVars.value = Me?.config.customStyle;
            else {
              const Ze = Color$1(Me?.config.backgroundColor).isDark();
              we.bxThemeStyleVars = useTheme(`#${c}`, Ze), we.bxThemeStyleVars.value["editor-view-background-color"] = Me?.config.backgroundColor;
            }
          }), console.log(we.embedProject.value?.config.layout === "stack"), {
            bridge: $e,
            editorRef: we.editorRef,
            embedProject: we.embedProject,
            allowPanAndZoom: we.allowPanAndZoom,
            templateId: we.templateId,
            baseSerial: we.baseSerial,
            basePreview: we.basePreview,
            studioResourcesBaseUrl: we.studioResourcesBaseUrl,
            cloudflarePagesHostname: we.cloudflarePagesHostname,
            data: we.data,
            serial: we.serial,
            ready: we.ready,
            displayMode: we.displayMode,
            bxCoreVersion: we.bxCoreVersion,
            bxThemeStyleVars: we.bxThemeStyleVars,
            darkmode: computed(() => Color$1(we.bxThemeStyleVars.value["editor-view-background-color"]).isDark()),
            borderRadius: computed(() => (we.embedProject.value?.config.layout === "stack", "10px")),
            borderColor: computed(() => {
              const Me = Color$1(we.bxThemeStyleVars.value["editor-view-background-color"]);
              return Me.isDark() ? Me.lighten(0.8).hex() : Me.darken(0.1).hex();
            })
          };
        }
      }).mount(`#${c}`);
    });
  }
  setVariable(c, ie) {
    this.data.value || (this.data.value = {}), this.data.value[c] = ie;
  }
  setData(c, ie = !1) {
    if (ie)
      this.data.value = c;
    else {
      this.data.value || (this.data.value = {});
      for (const we in c)
        this.setVariable(we, c[we]);
    }
  }
}
async function getProjectWithRetries(m, c, ie, we, $e) {
  let Me = 0;
  for (; Me < ie; ) {
    try {
      console.log(`\u{1F504} Versuch ${Me + 1}/${ie}: Hole Public Config...`);
      const Ze = await fetch(
        `https://embed-api-v2.bluepic.workers.dev/api/public/project?${new URLSearchParams({
          hostname: m,
          slug: c,
          env: $e
        })}`,
        {
          method: "GET"
        }
      );
      return console.log(`\u2705 Erfolgreich nach ${Me + 1} Versuchen`), await Ze.json();
    } catch (Ze) {
      if (console.error(`\u274C Fehler bei Versuch ${Me + 1}:`, Ze), Me < ie - 1)
        console.log(`\u23F3 Warte ${we}ms vor erneutem Versuch...`), await new Promise((ne) => setTimeout(ne, we));
      else
        throw console.error(`\u{1F6A8} Maximalanzahl von ${ie} Versuchen erreicht. Abbruch.`), Ze;
    }
    Me++;
  }
  throw new Error("Unbekannter Fehler in getPublicConfigWithRetries");
}
const initEmbeds = async () => {
  const m = document.querySelectorAll(".bluepic-embed");
  console.log("Auto-BluepicEmbed elements", m);
  for (const c of m) {
    const ie = c.getAttribute("data-embed-project-id"), we = c.getAttribute("data-template-id");
    c.getAttribute("data-stripe-env");
    const $e = c.getAttribute("data-init-data"), Me = c.getAttribute("data-studio-resources-base-url") ?? void 0, Ze = c.getAttribute("data-cloudflare-pages-hostname") ?? void 0, ne = c.getAttribute("data-display-mode"), rr = c.getAttribute("data-allow-pan-and-zoom"), gr = c.getAttribute("data-bx-core-version") ?? void 0, or = $e ? JSON.parse($e) : void 0, _r = rr === "true", Lr = ne === "mobile" ? "mobile" : ne === "stack" ? "stack" : "auto", Ir = c.getAttribute("data-branding") === "false", Ar = new BluepicEmbed(c, we, ie, {
      initData: or,
      displayMode: Lr,
      allowPanAndZoom: _r,
      studioResourcesBaseUrl: Me,
      cloudflarePagesHostname: Ze,
      bxCoreVersion: gr,
      branding: Ir
    });
    console.log("!", c, Ar);
  }
};
window.addEventListener("load", initEmbeds);
const GLOBAL_APP_WRAPPER_CLASS = "bluepic-app-wrapper", GLOBAL_APP_WRAPPER_SELECTOR = `.${GLOBAL_APP_WRAPPER_CLASS}`;
window.bluepicPopupProvider = new BluepicPopupProvider();
export {
  AdjustImage,
  BluepicBatchEditor,
  BluepicEmbed,
  BluepicEmbedded,
  BluepicEmbeddedEditor,
  BluepciFieldComponents as BluepicFieldComponents,
  BluepicLogo,
  BluepicSpinner,
  BxAvatar,
  BxButton,
  BxCard,
  BxCheckbox,
  BxColorPicker,
  BxDropdown,
  BxEmbedThemeDarkmode,
  BxEmbedThemeLightmode,
  _sfc_main$p as BxFields,
  BxIcon,
  BxInput,
  BxList,
  BxListItem,
  BxMenu,
  BxPopover,
  _sfc_main$18 as BxPopup,
  BxRadio,
  BxRadioGroup,
  BxSelect,
  BxSlider,
  BxSpin,
  BxSwitch,
  BxTab,
  BxTabs,
  BxTag,
  BxTooltip,
  BxUserMenu,
  GLOBAL_APP_WRAPPER_CLASS,
  GLOBAL_APP_WRAPPER_SELECTOR,
  MapboxMap,
  SlidesNavigation,
  applyColorMatricesToImage,
  applyColorMatrix,
  applyColorMatrixToColor,
  convertDeprecatedField,
  createMessage,
  createPopup,
  cropImage,
  cropToVisibleBBox,
  getDefaultValueForFieldModel,
  getTemplateLiveUrl,
  getTemplatePreviewUrl,
  getTemplateSerialUrl,
  getThemeStyle,
  getVisibleBBox,
  groupFeatureByLinebreaks$1 as groupFeatureByLinebreaks,
  initEmbeds,
  normalizeAdjust,
  normalizeCrop,
  optimizePreviewUrl,
  rasterize,
  realizeField,
  renderFieldIcon,
  renderSVG,
  stringifyField,
  ungroupFeaturesDividedByLinebreaks,
  useTheme,
  waitUntil
};
